
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("fFa3V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $lRkRh = parcelRequire("lRkRh");

Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $lRkRh.bind;
    }
});

var $8jRth = parcelRequire("8jRth");

Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $8jRth.bindAll;
    }
});

});

parcelRegister("lRkRh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $fe9eba42b47b0c73$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $fe9eba42b47b0c73$var$bind;

});

parcelRegister("8jRth", function(module, exports) {
"use strict";
var $60e99357810b400b$var$__assign = module.exports && module.exports.__assign || function() {
    $60e99357810b400b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $60e99357810b400b$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $lRkRh = parcelRequire("lRkRh");

function $60e99357810b400b$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $60e99357810b400b$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $60e99357810b400b$var$__assign($60e99357810b400b$var$__assign({}, original), {
        options: $60e99357810b400b$var$__assign($60e99357810b400b$var$__assign({}, $60e99357810b400b$var$toOptions(sharedOptions)), $60e99357810b400b$var$toOptions(original.options))
    });
    return binding;
}
function $60e99357810b400b$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $60e99357810b400b$var$getBinding(original, sharedOptions);
        return (0, $lRkRh.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $60e99357810b400b$var$bindAll;

});

parcelRegister("hZpML", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGrzq = parcelRequire("kGrzq");

var $37b533d524acf2b8$export$5cd865dcdb41adf = /*#__PURE__*/ function(WATERFALL_INITIAL_MEASURES) {
    WATERFALL_INITIAL_MEASURES["REDIRECTION"] = "wf/navigation/redirection";
    WATERFALL_INITIAL_MEASURES["DNS"] = "wf/navigation/dns";
    WATERFALL_INITIAL_MEASURES["TCP"] = "wf/navigation/tcp";
    WATERFALL_INITIAL_MEASURES["TLS"] = "wf/navigation/tls";
    WATERFALL_INITIAL_MEASURES["RESPONSE"] = "wf/navigation/response";
    WATERFALL_INITIAL_MEASURES["TTFB"] = "wf/navigation/ttfb";
    WATERFALL_INITIAL_MEASURES["FULL_HTML"] = "wf/navigation/fullHtml";
    WATERFALL_INITIAL_MEASURES["SERVER_TIMING"] = "wf/navigation/serverTiming";
    WATERFALL_INITIAL_MEASURES["CSS_MAIN"] = "wf/css/main";
    WATERFALL_INITIAL_MEASURES["CSS_SUPERBATCH"] = "wf/css/superbatch";
    WATERFALL_INITIAL_MEASURES["CSS_CONNECT_WEB_RESOURCES"] = "wf/css/connectWebResources";
    WATERFALL_INITIAL_MEASURES["CSS_COMPILED"] = "wf/css/compiled";
    WATERFALL_INITIAL_MEASURES["JS_SUPERBATCH"] = "wf/js/superbatch";
    WATERFALL_INITIAL_MEASURES["JS_CONNECT_WEB_RESOURCES"] = "wf/js/connectWebResources";
    WATERFALL_INITIAL_MEASURES["HTML_THEME_INIT"] = "wf/html/themeInit";
    WATERFALL_INITIAL_MEASURES["HTML_REACT_ROOT"] = "wf/html/reactRoot";
    WATERFALL_INITIAL_MEASURES["HTML_SSR_SCRIPTS"] = "wf/html/ssrScripts";
    WATERFALL_INITIAL_MEASURES["HTML_TOP_NAV"] = "wf/html/topNav";
    WATERFALL_INITIAL_MEASURES["HTML_SIDE_NAV"] = "wf/html/sideNav";
    WATERFALL_INITIAL_MEASURES["HTML_MAIN"] = "wf/html/main";
    WATERFALL_INITIAL_MEASURES["HTML_FORCE_LAYOUT"] = "wf/html/forceLayout";
    WATERFALL_INITIAL_MEASURES["SSR_GLOBALS"] = "wf/html/ssrGlobals";
    WATERFALL_INITIAL_MEASURES["COLLECT_PLACEHOLDER_DIMENSIONS"] = "wf/bootstrap/collectPlaceholderDimensions";
    WATERFALL_INITIAL_MEASURES["SSR_BEFORE_SCRIPTS"] = "wf/bootstrap/ssrBeforeScripts";
    WATERFALL_INITIAL_MEASURES["SSR_AFTER_SCRIPTS"] = "wf/bootstrap/ssrAfterScripts";
    WATERFALL_INITIAL_MEASURES["CREATE_APOLLO_CLIENTS"] = "wf/bootstrap/createApolloClients";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_SESSION_DATA"] = "wf/bootstrap/getSessionData";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_TRANSLATION"] = "wf/bootstrap/loadTranslation";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_LOADABLE"] = "wf/bootstrap/preloadLoadable";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_INITIALIZE_STORAGE_MANAGER"] = "wf/bootstrap/initializeStorageManager";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_INITIALIZE_COOKIES"] = "wf/bootstrap/initializeCookies";
    return WATERFALL_INITIAL_MEASURES;
}({});
const $37b533d524acf2b8$export$deb9bd49feb08fb5 = [
    'atl-edge-internal',
    'atl-edge-upstream',
    'cdn-upstream-fbl',
    'cdn-upstream-dns',
    'cdn-upstream-connect',
    'cdn-downstream-fbl'
];
function $37b533d524acf2b8$export$61a691dabeb80f51(name) {
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window["__SSR_RENDERED__"]&&window.performance.mark("${name}");`
        }
    });
}
class $37b533d524acf2b8$var$WaterfallMeasure extends (0, $kGrzq.BaseMeasures) {
    markMeasureStart(name, timestamp) {
        this.markedKeys.add(name);
        window.performance.clearMarks(`${name}.start`);
        window.performance.mark(`${name}.start`, {
            startTime: Math.floor(timestamp ?? performance.now())
        });
    }
    markMeasureEnd(name, timestamp) {
        window.performance.clearMarks(`${name}.end`);
        window.performance.mark(`${name}.end`, {
            startTime: Math.floor(timestamp ?? performance.now())
        });
    }
    getMeasureKeys(after) {
        return Array.from(this.markedKeys).filter((key)=>{
            const mark = performance.getEntriesByName(`${key}.start`, 'mark');
            return mark.length && mark[0].startTime >= after;
        });
    }
    clearMeasures() {
        super.clearMeasures();
        this.markedKeys.clear();
    }
    constructor(...args){
        super(...args);
        this.markedKeys = new Set();
    }
}
const $37b533d524acf2b8$export$d7d6a49c52882aad = new $37b533d524acf2b8$var$WaterfallMeasure();
module.exports["WATERFALL_INITIAL_MEASURES"] = $37b533d524acf2b8$export$5cd865dcdb41adf;
module.exports["SERVER_TIMING_MEASURES"] = $37b533d524acf2b8$export$deb9bd49feb08fb5;
module.exports["perfMark"] = $37b533d524acf2b8$export$61a691dabeb80f51;
module.exports["WaterfallMeasures"] = $37b533d524acf2b8$export$d7d6a49c52882aad;

});

parcelRegister("42omo", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6pzYC"));

});

parcelRegister("6pzYC", function(module, exports) {
$parcel$export(module.exports, "Children", () => $4ab0fc1563709023$export$dca3b0875bd9a954, (v) => $4ab0fc1563709023$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $4ab0fc1563709023$export$16fa2f45be04daa8, (v) => $4ab0fc1563709023$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $4ab0fc1563709023$export$ffb0004e005737fa, (v) => $4ab0fc1563709023$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $4ab0fc1563709023$export$e2c29f18771995cb, (v) => $4ab0fc1563709023$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $4ab0fc1563709023$export$221d75b3f55bb0bd, (v) => $4ab0fc1563709023$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $4ab0fc1563709023$export$5f8d39834fd61797, (v) => $4ab0fc1563709023$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $4ab0fc1563709023$export$74bf444e3cd11ea5, (v) => $4ab0fc1563709023$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $4ab0fc1563709023$export$ae55be85d98224ed, (v) => $4ab0fc1563709023$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $4ab0fc1563709023$export$e530037191fcd5d7, (v) => $4ab0fc1563709023$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $4ab0fc1563709023$export$fd42f52fd3ae1109, (v) => $4ab0fc1563709023$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $4ab0fc1563709023$export$c8a8987d4410bf2d, (v) => $4ab0fc1563709023$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $4ab0fc1563709023$export$d38cd72104c1f0e9, (v) => $4ab0fc1563709023$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $4ab0fc1563709023$export$7d1e3a5e95ceca43, (v) => $4ab0fc1563709023$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $4ab0fc1563709023$export$257a8862b851cb5b, (v) => $4ab0fc1563709023$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $4ab0fc1563709023$export$a8257692ac88316c, (v) => $4ab0fc1563709023$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $4ab0fc1563709023$export$488013bae63b21da, (v) => $4ab0fc1563709023$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $4ab0fc1563709023$export$7c73462e0d25e514, (v) => $4ab0fc1563709023$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $4ab0fc1563709023$export$7568632d0d33d16d, (v) => $4ab0fc1563709023$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $4ab0fc1563709023$export$88948ce120ea2619, (v) => $4ab0fc1563709023$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $4ab0fc1563709023$export$35808ee640e87ca7, (v) => $4ab0fc1563709023$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $4ab0fc1563709023$export$fae74005e78b1a27, (v) => $4ab0fc1563709023$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $4ab0fc1563709023$export$dc8fbce3eb94dc1e, (v) => $4ab0fc1563709023$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $4ab0fc1563709023$export$6a7bc4e911dc01cf, (v) => $4ab0fc1563709023$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $4ab0fc1563709023$export$6d9c69b0de29b591, (v) => $4ab0fc1563709023$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $4ab0fc1563709023$export$f680877a34711e37, (v) => $4ab0fc1563709023$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $4ab0fc1563709023$export$d5a552a76deda3c2, (v) => $4ab0fc1563709023$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $4ab0fc1563709023$export$aaabe4eda9ed9969, (v) => $4ab0fc1563709023$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $4ab0fc1563709023$export$e5c5a5f917a5871c, (v) => $4ab0fc1563709023$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $4ab0fc1563709023$export$1538c33de8887b59, (v) => $4ab0fc1563709023$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $4ab0fc1563709023$export$13e3392192263954, (v) => $4ab0fc1563709023$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $4ab0fc1563709023$export$b8f5890fc79d6aca, (v) => $4ab0fc1563709023$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $4ab0fc1563709023$export$60241385465d0a34, (v) => $4ab0fc1563709023$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $4ab0fc1563709023$export$306c0aa65ff9ec16, (v) => $4ab0fc1563709023$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $4ab0fc1563709023$export$7b286972b8d8ccbf, (v) => $4ab0fc1563709023$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $4ab0fc1563709023$export$83d89fbfd8236492, (v) => $4ab0fc1563709023$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4ab0fc1563709023$export$dca3b0875bd9a954;
var $4ab0fc1563709023$export$16fa2f45be04daa8;
var $4ab0fc1563709023$export$ffb0004e005737fa;
var $4ab0fc1563709023$export$e2c29f18771995cb;
var $4ab0fc1563709023$export$221d75b3f55bb0bd;
var $4ab0fc1563709023$export$5f8d39834fd61797;
var $4ab0fc1563709023$export$74bf444e3cd11ea5;
var $4ab0fc1563709023$export$ae55be85d98224ed;
var $4ab0fc1563709023$export$e530037191fcd5d7;
var $4ab0fc1563709023$export$fd42f52fd3ae1109;
var $4ab0fc1563709023$export$c8a8987d4410bf2d;
var $4ab0fc1563709023$export$d38cd72104c1f0e9;
var $4ab0fc1563709023$export$7d1e3a5e95ceca43;
var $4ab0fc1563709023$export$257a8862b851cb5b;
var $4ab0fc1563709023$export$a8257692ac88316c;
var $4ab0fc1563709023$export$488013bae63b21da;
var $4ab0fc1563709023$export$7c73462e0d25e514;
var $4ab0fc1563709023$export$7568632d0d33d16d;
var $4ab0fc1563709023$export$88948ce120ea2619;
var $4ab0fc1563709023$export$35808ee640e87ca7;
var $4ab0fc1563709023$export$fae74005e78b1a27;
var $4ab0fc1563709023$export$dc8fbce3eb94dc1e;
var $4ab0fc1563709023$export$6a7bc4e911dc01cf;
var $4ab0fc1563709023$export$6d9c69b0de29b591;
var $4ab0fc1563709023$export$f680877a34711e37;
var $4ab0fc1563709023$export$d5a552a76deda3c2;
var $4ab0fc1563709023$export$aaabe4eda9ed9969;
var $4ab0fc1563709023$export$e5c5a5f917a5871c;
var $4ab0fc1563709023$export$1538c33de8887b59;
var $4ab0fc1563709023$export$13e3392192263954;
var $4ab0fc1563709023$export$b8f5890fc79d6aca;
var $4ab0fc1563709023$export$60241385465d0a34;
var $4ab0fc1563709023$export$306c0aa65ff9ec16;
var $4ab0fc1563709023$export$7b286972b8d8ccbf;
var $4ab0fc1563709023$export$83d89fbfd8236492;
'use strict';
var $4ab0fc1563709023$var$l = Symbol.for("react.element"), $4ab0fc1563709023$var$n = Symbol.for("react.portal"), $4ab0fc1563709023$var$p = Symbol.for("react.fragment"), $4ab0fc1563709023$var$q = Symbol.for("react.strict_mode"), $4ab0fc1563709023$var$r = Symbol.for("react.profiler"), $4ab0fc1563709023$var$t = Symbol.for("react.provider"), $4ab0fc1563709023$var$u = Symbol.for("react.context"), $4ab0fc1563709023$var$v = Symbol.for("react.forward_ref"), $4ab0fc1563709023$var$w = Symbol.for("react.suspense"), $4ab0fc1563709023$var$x = Symbol.for("react.memo"), $4ab0fc1563709023$var$y = Symbol.for("react.lazy"), $4ab0fc1563709023$var$z = Symbol.iterator;
function $4ab0fc1563709023$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4ab0fc1563709023$var$z && a[$4ab0fc1563709023$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4ab0fc1563709023$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $4ab0fc1563709023$var$C = Object.assign, $4ab0fc1563709023$var$D = {};
function $4ab0fc1563709023$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $4ab0fc1563709023$var$D;
    this.updater = e || $4ab0fc1563709023$var$B;
}
$4ab0fc1563709023$var$E.prototype.isReactComponent = {};
$4ab0fc1563709023$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$4ab0fc1563709023$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $4ab0fc1563709023$var$F() {}
$4ab0fc1563709023$var$F.prototype = $4ab0fc1563709023$var$E.prototype;
function $4ab0fc1563709023$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $4ab0fc1563709023$var$D;
    this.updater = e || $4ab0fc1563709023$var$B;
}
var $4ab0fc1563709023$var$H = $4ab0fc1563709023$var$G.prototype = new $4ab0fc1563709023$var$F;
$4ab0fc1563709023$var$H.constructor = $4ab0fc1563709023$var$G;
$4ab0fc1563709023$var$C($4ab0fc1563709023$var$H, $4ab0fc1563709023$var$E.prototype);
$4ab0fc1563709023$var$H.isPureReactComponent = !0;
var $4ab0fc1563709023$var$I = Array.isArray, $4ab0fc1563709023$var$J = Object.prototype.hasOwnProperty, $4ab0fc1563709023$var$K = {
    current: null
}, $4ab0fc1563709023$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4ab0fc1563709023$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$4ab0fc1563709023$var$J.call(b, d) && !$4ab0fc1563709023$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $4ab0fc1563709023$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $4ab0fc1563709023$var$K.current
    };
}
function $4ab0fc1563709023$var$N(a, b) {
    return {
        $$typeof: $4ab0fc1563709023$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $4ab0fc1563709023$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4ab0fc1563709023$var$l;
}
function $4ab0fc1563709023$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $4ab0fc1563709023$var$P = /\/+/g;
function $4ab0fc1563709023$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $4ab0fc1563709023$var$escape("" + a.key) : b.toString(36);
}
function $4ab0fc1563709023$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $4ab0fc1563709023$var$l:
                case $4ab0fc1563709023$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $4ab0fc1563709023$var$Q(h, 0) : d, $4ab0fc1563709023$var$I(c) ? (e = "", null != a && (e = a.replace($4ab0fc1563709023$var$P, "$&/") + "/"), $4ab0fc1563709023$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($4ab0fc1563709023$var$O(c) && (c = $4ab0fc1563709023$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($4ab0fc1563709023$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($4ab0fc1563709023$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $4ab0fc1563709023$var$Q(k, g);
        h += $4ab0fc1563709023$var$R(k, b, e, f, c);
    }
    else if (f = $4ab0fc1563709023$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $4ab0fc1563709023$var$Q(k, g++), h += $4ab0fc1563709023$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $4ab0fc1563709023$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $4ab0fc1563709023$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $4ab0fc1563709023$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $4ab0fc1563709023$var$U = {
    current: null
}, $4ab0fc1563709023$var$V = {
    transition: null
}, $4ab0fc1563709023$var$W = {
    ReactCurrentDispatcher: $4ab0fc1563709023$var$U,
    ReactCurrentBatchConfig: $4ab0fc1563709023$var$V,
    ReactCurrentOwner: $4ab0fc1563709023$var$K
};
$4ab0fc1563709023$export$dca3b0875bd9a954 = {
    map: $4ab0fc1563709023$var$S,
    forEach: function(a, b, e) {
        $4ab0fc1563709023$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $4ab0fc1563709023$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $4ab0fc1563709023$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$4ab0fc1563709023$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$4ab0fc1563709023$export$16fa2f45be04daa8 = $4ab0fc1563709023$var$E;
$4ab0fc1563709023$export$ffb0004e005737fa = $4ab0fc1563709023$var$p;
$4ab0fc1563709023$export$e2c29f18771995cb = $4ab0fc1563709023$var$r;
$4ab0fc1563709023$export$221d75b3f55bb0bd = $4ab0fc1563709023$var$G;
$4ab0fc1563709023$export$5f8d39834fd61797 = $4ab0fc1563709023$var$q;
$4ab0fc1563709023$export$74bf444e3cd11ea5 = $4ab0fc1563709023$var$w;
$4ab0fc1563709023$export$ae55be85d98224ed = $4ab0fc1563709023$var$W;
$4ab0fc1563709023$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $4ab0fc1563709023$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $4ab0fc1563709023$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$4ab0fc1563709023$var$J.call(b, f) && !$4ab0fc1563709023$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $4ab0fc1563709023$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$4ab0fc1563709023$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $4ab0fc1563709023$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $4ab0fc1563709023$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$4ab0fc1563709023$export$c8a8987d4410bf2d = $4ab0fc1563709023$var$M;
$4ab0fc1563709023$export$d38cd72104c1f0e9 = function(a) {
    var b = $4ab0fc1563709023$var$M.bind(null, a);
    b.type = a;
    return b;
};
$4ab0fc1563709023$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$4ab0fc1563709023$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $4ab0fc1563709023$var$v,
        render: a
    };
};
$4ab0fc1563709023$export$a8257692ac88316c = $4ab0fc1563709023$var$O;
$4ab0fc1563709023$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $4ab0fc1563709023$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $4ab0fc1563709023$var$T
    };
};
$4ab0fc1563709023$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $4ab0fc1563709023$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$4ab0fc1563709023$export$7568632d0d33d16d = function(a) {
    var b = $4ab0fc1563709023$var$V.transition;
    $4ab0fc1563709023$var$V.transition = {};
    try {
        a();
    } finally{
        $4ab0fc1563709023$var$V.transition = b;
    }
};
$4ab0fc1563709023$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$4ab0fc1563709023$export$35808ee640e87ca7 = function(a, b) {
    return $4ab0fc1563709023$var$U.current.useCallback(a, b);
};
$4ab0fc1563709023$export$fae74005e78b1a27 = function(a) {
    return $4ab0fc1563709023$var$U.current.useContext(a);
};
$4ab0fc1563709023$export$dc8fbce3eb94dc1e = function() {};
$4ab0fc1563709023$export$6a7bc4e911dc01cf = function(a) {
    return $4ab0fc1563709023$var$U.current.useDeferredValue(a);
};
$4ab0fc1563709023$export$6d9c69b0de29b591 = function(a, b) {
    return $4ab0fc1563709023$var$U.current.useEffect(a, b);
};
$4ab0fc1563709023$export$f680877a34711e37 = function() {
    return $4ab0fc1563709023$var$U.current.useId();
};
$4ab0fc1563709023$export$d5a552a76deda3c2 = function(a, b, e) {
    return $4ab0fc1563709023$var$U.current.useImperativeHandle(a, b, e);
};
$4ab0fc1563709023$export$aaabe4eda9ed9969 = function(a, b) {
    return $4ab0fc1563709023$var$U.current.useInsertionEffect(a, b);
};
$4ab0fc1563709023$export$e5c5a5f917a5871c = function(a, b) {
    return $4ab0fc1563709023$var$U.current.useLayoutEffect(a, b);
};
$4ab0fc1563709023$export$1538c33de8887b59 = function(a, b) {
    return $4ab0fc1563709023$var$U.current.useMemo(a, b);
};
$4ab0fc1563709023$export$13e3392192263954 = function(a, b, e) {
    return $4ab0fc1563709023$var$U.current.useReducer(a, b, e);
};
$4ab0fc1563709023$export$b8f5890fc79d6aca = function(a) {
    return $4ab0fc1563709023$var$U.current.useRef(a);
};
$4ab0fc1563709023$export$60241385465d0a34 = function(a) {
    return $4ab0fc1563709023$var$U.current.useState(a);
};
$4ab0fc1563709023$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $4ab0fc1563709023$var$U.current.useSyncExternalStore(a, b, e);
};
$4ab0fc1563709023$export$7b286972b8d8ccbf = function() {
    return $4ab0fc1563709023$var$U.current.useTransition();
};
$4ab0fc1563709023$export$83d89fbfd8236492 = "18.2.0";

});

parcelRegister("kGrzq", function(module, exports) {
/* eslint-disable no-dupe-class-members */ class $533cd45aab169de9$export$31c6869b8bca23f6 {
    run(name, fn) {
        const names = Array.isArray(name) ? name : [
            name
        ];
        names.forEach((name)=>this.markMeasureStart(name));
        const result = fn();
        if (typeof result?.then === 'function') // eslint-disable-next-line @typescript-eslint/no-floating-promises
        result.finally(()=>{
            names.forEach((name)=>this.markMeasureEnd(name));
        });
        else names.forEach((name)=>this.markMeasureEnd(name));
        return result;
    }
    markMeasureStart(name, timestamp) {
        //if startTime already marked, don't mark again.
        if (this.measures[name]?.startTime) return;
        this.measures[name] = {
            startTime: Math.floor(timestamp ?? performance.now()),
            duration: 0
        };
    }
    markMeasureEnd(name, timestamp, allowEndOnly = false) {
        const entry = this.measures[name];
        if (!entry?.duration && entry?.startTime) entry.duration = Math.floor((timestamp ?? performance.now()) - entry.startTime);
        else if (!entry && allowEndOnly) // In allowEndOnly mode we take FIRST end time as duration
        this.measures[name] = {
            startTime: 0,
            duration: timestamp ?? performance.now()
        };
    }
    getMeasures() {
        return this.measures;
    }
    clearMeasures() {
        this.measures = {};
    }
    constructor(){
        this.measures = {};
    }
}
module.exports["BaseMeasures"] = $533cd45aab169de9$export$31c6869b8bca23f6;

});

parcelRegister("2FNjD", function(module, exports) {
$parcel$export(module.exports, "createRoot", () => $1f25aa2fa9b8cc50$export$882461b6382ed46c, (v) => $1f25aa2fa9b8cc50$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $1f25aa2fa9b8cc50$export$757ceba2d55c277e, (v) => $1f25aa2fa9b8cc50$export$757ceba2d55c277e = v);
var $1f25aa2fa9b8cc50$export$882461b6382ed46c;
var $1f25aa2fa9b8cc50$export$757ceba2d55c277e;
'use strict';

var $jTxSS = parcelRequire("jTxSS");

var $1f25aa2fa9b8cc50$var$i;
$1f25aa2fa9b8cc50$export$882461b6382ed46c = $jTxSS.createRoot;
$1f25aa2fa9b8cc50$export$757ceba2d55c277e = $jTxSS.hydrateRoot;

});

parcelRegister("jTxSS", function(module, exports) {
'use strict';
function $e7bd700cb66ebab0$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e7bd700cb66ebab0$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e7bd700cb66ebab0$var$checkDCE();

module.exports = (parcelRequire("i7l6a"));

});

parcelRegister("i7l6a", function(module, exports) {
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $d3093f2493aa17fd$export$ae55be85d98224ed, (v) => $d3093f2493aa17fd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $d3093f2493aa17fd$export$d39a5bbd09211389, (v) => $d3093f2493aa17fd$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $d3093f2493aa17fd$export$882461b6382ed46c, (v) => $d3093f2493aa17fd$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $d3093f2493aa17fd$export$466bfc07425424d5, (v) => $d3093f2493aa17fd$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $d3093f2493aa17fd$export$cd75ccfd720a3cd4, (v) => $d3093f2493aa17fd$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $d3093f2493aa17fd$export$fa8d919ba61d84db, (v) => $d3093f2493aa17fd$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $d3093f2493aa17fd$export$757ceba2d55c277e, (v) => $d3093f2493aa17fd$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $d3093f2493aa17fd$export$b3890eb0ae9dca99, (v) => $d3093f2493aa17fd$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $d3093f2493aa17fd$export$502457920280e6be, (v) => $d3093f2493aa17fd$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $d3093f2493aa17fd$export$c78a37762a8d58e1, (v) => $d3093f2493aa17fd$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $d3093f2493aa17fd$export$dc54d992c10e8a18, (v) => $d3093f2493aa17fd$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $d3093f2493aa17fd$export$83d89fbfd8236492, (v) => $d3093f2493aa17fd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d3093f2493aa17fd$export$ae55be85d98224ed;
var $d3093f2493aa17fd$export$d39a5bbd09211389;
var $d3093f2493aa17fd$export$882461b6382ed46c;
var $d3093f2493aa17fd$export$466bfc07425424d5;
var $d3093f2493aa17fd$export$cd75ccfd720a3cd4;
var $d3093f2493aa17fd$export$fa8d919ba61d84db;
var $d3093f2493aa17fd$export$757ceba2d55c277e;
var $d3093f2493aa17fd$export$b3890eb0ae9dca99;
var $d3093f2493aa17fd$export$502457920280e6be;
var $d3093f2493aa17fd$export$c78a37762a8d58e1;
var $d3093f2493aa17fd$export$dc54d992c10e8a18;
var $d3093f2493aa17fd$export$83d89fbfd8236492;
'use strict';
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $42omo = parcelRequire("42omo");


var $eggFB = parcelRequire("eggFB");

function $d3093f2493aa17fd$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $d3093f2493aa17fd$var$ca = new Set, $d3093f2493aa17fd$var$ea = {};
function $d3093f2493aa17fd$var$fa(a, b) {
    $d3093f2493aa17fd$var$ha(a, b);
    $d3093f2493aa17fd$var$ha(a + "Capture", b);
}
function $d3093f2493aa17fd$var$ha(a, b) {
    $d3093f2493aa17fd$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$d3093f2493aa17fd$var$ca.add(b[a]);
}
var $d3093f2493aa17fd$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $d3093f2493aa17fd$var$ja = Object.prototype.hasOwnProperty, $d3093f2493aa17fd$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $d3093f2493aa17fd$var$la = {}, $d3093f2493aa17fd$var$ma = {};
function $d3093f2493aa17fd$var$na(a) {
    if ($d3093f2493aa17fd$var$ja.call($d3093f2493aa17fd$var$ma, a)) return !0;
    if ($d3093f2493aa17fd$var$ja.call($d3093f2493aa17fd$var$la, a)) return !1;
    if ($d3093f2493aa17fd$var$ka.test(a)) return $d3093f2493aa17fd$var$ma[a] = !0;
    $d3093f2493aa17fd$var$la[a] = !0;
    return !1;
}
function $d3093f2493aa17fd$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $d3093f2493aa17fd$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $d3093f2493aa17fd$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $d3093f2493aa17fd$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $d3093f2493aa17fd$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $d3093f2493aa17fd$var$t[a] = new $d3093f2493aa17fd$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $d3093f2493aa17fd$var$t[b] = new $d3093f2493aa17fd$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $d3093f2493aa17fd$var$t[a] = new $d3093f2493aa17fd$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $d3093f2493aa17fd$var$t[a] = new $d3093f2493aa17fd$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $d3093f2493aa17fd$var$t[a] = new $d3093f2493aa17fd$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $d3093f2493aa17fd$var$t[a] = new $d3093f2493aa17fd$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $d3093f2493aa17fd$var$t[a] = new $d3093f2493aa17fd$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $d3093f2493aa17fd$var$t[a] = new $d3093f2493aa17fd$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $d3093f2493aa17fd$var$t[a] = new $d3093f2493aa17fd$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $d3093f2493aa17fd$var$ra = /[\-:]([a-z])/g;
function $d3093f2493aa17fd$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($d3093f2493aa17fd$var$ra, $d3093f2493aa17fd$var$ta);
    $d3093f2493aa17fd$var$t[b] = new $d3093f2493aa17fd$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($d3093f2493aa17fd$var$ra, $d3093f2493aa17fd$var$ta);
    $d3093f2493aa17fd$var$t[b] = new $d3093f2493aa17fd$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($d3093f2493aa17fd$var$ra, $d3093f2493aa17fd$var$ta);
    $d3093f2493aa17fd$var$t[b] = new $d3093f2493aa17fd$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $d3093f2493aa17fd$var$t[a] = new $d3093f2493aa17fd$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$d3093f2493aa17fd$var$t.xlinkHref = new $d3093f2493aa17fd$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $d3093f2493aa17fd$var$t[a] = new $d3093f2493aa17fd$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $d3093f2493aa17fd$var$ua(a, b, c, d) {
    var e = $d3093f2493aa17fd$var$t.hasOwnProperty(b) ? $d3093f2493aa17fd$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $d3093f2493aa17fd$var$pa(b, c, e, d) && (c = null), d || null === e ? $d3093f2493aa17fd$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $d3093f2493aa17fd$var$va = $42omo.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $d3093f2493aa17fd$var$wa = Symbol.for("react.element"), $d3093f2493aa17fd$var$xa = Symbol.for("react.portal"), $d3093f2493aa17fd$var$ya = Symbol.for("react.fragment"), $d3093f2493aa17fd$var$za = Symbol.for("react.strict_mode"), $d3093f2493aa17fd$var$Aa = Symbol.for("react.profiler"), $d3093f2493aa17fd$var$Ba = Symbol.for("react.provider"), $d3093f2493aa17fd$var$Ca = Symbol.for("react.context"), $d3093f2493aa17fd$var$Da = Symbol.for("react.forward_ref"), $d3093f2493aa17fd$var$Ea = Symbol.for("react.suspense"), $d3093f2493aa17fd$var$Fa = Symbol.for("react.suspense_list"), $d3093f2493aa17fd$var$Ga = Symbol.for("react.memo"), $d3093f2493aa17fd$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $d3093f2493aa17fd$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $d3093f2493aa17fd$var$Ja = Symbol.iterator;
function $d3093f2493aa17fd$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $d3093f2493aa17fd$var$Ja && a[$d3093f2493aa17fd$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $d3093f2493aa17fd$var$u = Object.assign, $d3093f2493aa17fd$var$La;
function $d3093f2493aa17fd$var$Ma(a) {
    if (void 0 === $d3093f2493aa17fd$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $d3093f2493aa17fd$var$La = b && b[1] || "";
    }
    return "\n" + $d3093f2493aa17fd$var$La + a;
}
var $d3093f2493aa17fd$var$Na = !1;
function $d3093f2493aa17fd$var$Oa(a, b) {
    if (!a || $d3093f2493aa17fd$var$Na) return "";
    $d3093f2493aa17fd$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $d3093f2493aa17fd$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $d3093f2493aa17fd$var$Ma(a) : "";
}
function $d3093f2493aa17fd$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $d3093f2493aa17fd$var$Ma(a.type);
        case 16:
            return $d3093f2493aa17fd$var$Ma("Lazy");
        case 13:
            return $d3093f2493aa17fd$var$Ma("Suspense");
        case 19:
            return $d3093f2493aa17fd$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $d3093f2493aa17fd$var$Oa(a.type, !1), a;
        case 11:
            return a = $d3093f2493aa17fd$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $d3093f2493aa17fd$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $d3093f2493aa17fd$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $d3093f2493aa17fd$var$ya:
            return "Fragment";
        case $d3093f2493aa17fd$var$xa:
            return "Portal";
        case $d3093f2493aa17fd$var$Aa:
            return "Profiler";
        case $d3093f2493aa17fd$var$za:
            return "StrictMode";
        case $d3093f2493aa17fd$var$Ea:
            return "Suspense";
        case $d3093f2493aa17fd$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $d3093f2493aa17fd$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $d3093f2493aa17fd$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $d3093f2493aa17fd$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $d3093f2493aa17fd$var$Ga:
            return b = a.displayName || null, null !== b ? b : $d3093f2493aa17fd$var$Qa(a.type) || "Memo";
        case $d3093f2493aa17fd$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $d3093f2493aa17fd$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $d3093f2493aa17fd$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $d3093f2493aa17fd$var$Qa(b);
        case 8:
            return b === $d3093f2493aa17fd$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $d3093f2493aa17fd$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $d3093f2493aa17fd$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $d3093f2493aa17fd$var$Ua(a) {
    var b = $d3093f2493aa17fd$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $d3093f2493aa17fd$var$Va(a) {
    a._valueTracker || (a._valueTracker = $d3093f2493aa17fd$var$Ua(a));
}
function $d3093f2493aa17fd$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $d3093f2493aa17fd$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $d3093f2493aa17fd$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $d3093f2493aa17fd$var$Ya(a, b) {
    var c = b.checked;
    return $d3093f2493aa17fd$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $d3093f2493aa17fd$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $d3093f2493aa17fd$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $d3093f2493aa17fd$var$$a(a, b) {
    b = b.checked;
    null != b && $d3093f2493aa17fd$var$ua(a, "checked", b, !1);
}
function $d3093f2493aa17fd$var$ab(a, b) {
    $d3093f2493aa17fd$var$$a(a, b);
    var c = $d3093f2493aa17fd$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $d3093f2493aa17fd$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $d3093f2493aa17fd$var$bb(a, b.type, $d3093f2493aa17fd$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $d3093f2493aa17fd$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $d3093f2493aa17fd$var$bb(a, b, c) {
    if ("number" !== b || $d3093f2493aa17fd$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $d3093f2493aa17fd$var$db = Array.isArray;
function $d3093f2493aa17fd$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $d3093f2493aa17fd$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $d3093f2493aa17fd$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($d3093f2493aa17fd$var$p(91));
    return $d3093f2493aa17fd$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $d3093f2493aa17fd$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($d3093f2493aa17fd$var$p(92));
            if ($d3093f2493aa17fd$var$db(c)) {
                if (1 < c.length) throw Error($d3093f2493aa17fd$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $d3093f2493aa17fd$var$Sa(c)
    };
}
function $d3093f2493aa17fd$var$hb(a, b) {
    var c = $d3093f2493aa17fd$var$Sa(b.value), d = $d3093f2493aa17fd$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $d3093f2493aa17fd$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $d3093f2493aa17fd$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $d3093f2493aa17fd$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $d3093f2493aa17fd$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $d3093f2493aa17fd$var$lb, $d3093f2493aa17fd$var$mb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $d3093f2493aa17fd$var$lb = $d3093f2493aa17fd$var$lb || document.createElement("div");
        $d3093f2493aa17fd$var$lb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $d3093f2493aa17fd$var$lb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $d3093f2493aa17fd$var$nb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $d3093f2493aa17fd$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $d3093f2493aa17fd$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($d3093f2493aa17fd$var$pb).forEach(function(a) {
    $d3093f2493aa17fd$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $d3093f2493aa17fd$var$pb[b] = $d3093f2493aa17fd$var$pb[a];
    });
});
function $d3093f2493aa17fd$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $d3093f2493aa17fd$var$pb.hasOwnProperty(a) && $d3093f2493aa17fd$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $d3093f2493aa17fd$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $d3093f2493aa17fd$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $d3093f2493aa17fd$var$tb = $d3093f2493aa17fd$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $d3093f2493aa17fd$var$ub(a, b) {
    if (b) {
        if ($d3093f2493aa17fd$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($d3093f2493aa17fd$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($d3093f2493aa17fd$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($d3093f2493aa17fd$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($d3093f2493aa17fd$var$p(62));
    }
}
function $d3093f2493aa17fd$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $d3093f2493aa17fd$var$wb = null;
function $d3093f2493aa17fd$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $d3093f2493aa17fd$var$yb = null, $d3093f2493aa17fd$var$zb = null, $d3093f2493aa17fd$var$Ab = null;
function $d3093f2493aa17fd$var$Bb(a) {
    if (a = $d3093f2493aa17fd$var$Cb(a)) {
        if ("function" !== typeof $d3093f2493aa17fd$var$yb) throw Error($d3093f2493aa17fd$var$p(280));
        var b = a.stateNode;
        b && (b = $d3093f2493aa17fd$var$Db(b), $d3093f2493aa17fd$var$yb(a.stateNode, a.type, b));
    }
}
function $d3093f2493aa17fd$var$Eb(a) {
    $d3093f2493aa17fd$var$zb ? $d3093f2493aa17fd$var$Ab ? $d3093f2493aa17fd$var$Ab.push(a) : $d3093f2493aa17fd$var$Ab = [
        a
    ] : $d3093f2493aa17fd$var$zb = a;
}
function $d3093f2493aa17fd$var$Fb() {
    if ($d3093f2493aa17fd$var$zb) {
        var a = $d3093f2493aa17fd$var$zb, b = $d3093f2493aa17fd$var$Ab;
        $d3093f2493aa17fd$var$Ab = $d3093f2493aa17fd$var$zb = null;
        $d3093f2493aa17fd$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$d3093f2493aa17fd$var$Bb(b[a]);
    }
}
function $d3093f2493aa17fd$var$Gb(a, b) {
    return a(b);
}
function $d3093f2493aa17fd$var$Hb() {}
var $d3093f2493aa17fd$var$Ib = !1;
function $d3093f2493aa17fd$var$Jb(a, b, c) {
    if ($d3093f2493aa17fd$var$Ib) return a(b, c);
    $d3093f2493aa17fd$var$Ib = !0;
    try {
        return $d3093f2493aa17fd$var$Gb(a, b, c);
    } finally{
        if ($d3093f2493aa17fd$var$Ib = !1, null !== $d3093f2493aa17fd$var$zb || null !== $d3093f2493aa17fd$var$Ab) $d3093f2493aa17fd$var$Hb(), $d3093f2493aa17fd$var$Fb();
    }
}
function $d3093f2493aa17fd$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $d3093f2493aa17fd$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($d3093f2493aa17fd$var$p(231, b, typeof c));
    return c;
}
var $d3093f2493aa17fd$var$Lb = !1;
if ($d3093f2493aa17fd$var$ia) try {
    var $d3093f2493aa17fd$var$Mb = {};
    Object.defineProperty($d3093f2493aa17fd$var$Mb, "passive", {
        get: function() {
            $d3093f2493aa17fd$var$Lb = !0;
        }
    });
    window.addEventListener("test", $d3093f2493aa17fd$var$Mb, $d3093f2493aa17fd$var$Mb);
    window.removeEventListener("test", $d3093f2493aa17fd$var$Mb, $d3093f2493aa17fd$var$Mb);
} catch (a) {
    $d3093f2493aa17fd$var$Lb = !1;
}
function $d3093f2493aa17fd$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $d3093f2493aa17fd$var$Ob = !1, $d3093f2493aa17fd$var$Pb = null, $d3093f2493aa17fd$var$Qb = !1, $d3093f2493aa17fd$var$Rb = null, $d3093f2493aa17fd$var$Sb = {
    onError: function(a) {
        $d3093f2493aa17fd$var$Ob = !0;
        $d3093f2493aa17fd$var$Pb = a;
    }
};
function $d3093f2493aa17fd$var$Tb(a, b, c, d, e, f, g, h, k) {
    $d3093f2493aa17fd$var$Ob = !1;
    $d3093f2493aa17fd$var$Pb = null;
    $d3093f2493aa17fd$var$Nb.apply($d3093f2493aa17fd$var$Sb, arguments);
}
function $d3093f2493aa17fd$var$Ub(a, b, c, d, e, f, g, h, k) {
    $d3093f2493aa17fd$var$Tb.apply(this, arguments);
    if ($d3093f2493aa17fd$var$Ob) {
        if ($d3093f2493aa17fd$var$Ob) {
            var l = $d3093f2493aa17fd$var$Pb;
            $d3093f2493aa17fd$var$Ob = !1;
            $d3093f2493aa17fd$var$Pb = null;
        } else throw Error($d3093f2493aa17fd$var$p(198));
        $d3093f2493aa17fd$var$Qb || ($d3093f2493aa17fd$var$Qb = !0, $d3093f2493aa17fd$var$Rb = l);
    }
}
function $d3093f2493aa17fd$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $d3093f2493aa17fd$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $d3093f2493aa17fd$var$Xb(a) {
    if ($d3093f2493aa17fd$var$Vb(a) !== a) throw Error($d3093f2493aa17fd$var$p(188));
}
function $d3093f2493aa17fd$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $d3093f2493aa17fd$var$Vb(a);
        if (null === b) throw Error($d3093f2493aa17fd$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $d3093f2493aa17fd$var$Xb(e), a;
                if (f === d) return $d3093f2493aa17fd$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($d3093f2493aa17fd$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($d3093f2493aa17fd$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($d3093f2493aa17fd$var$p(190));
    }
    if (3 !== c.tag) throw Error($d3093f2493aa17fd$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $d3093f2493aa17fd$var$Zb(a) {
    a = $d3093f2493aa17fd$var$Yb(a);
    return null !== a ? $d3093f2493aa17fd$var$$b(a) : null;
}
function $d3093f2493aa17fd$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $d3093f2493aa17fd$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $d3093f2493aa17fd$var$ac = $eggFB.unstable_scheduleCallback, $d3093f2493aa17fd$var$bc = $eggFB.unstable_cancelCallback, $d3093f2493aa17fd$var$cc = $eggFB.unstable_shouldYield, $d3093f2493aa17fd$var$dc = $eggFB.unstable_requestPaint, $d3093f2493aa17fd$var$A = $eggFB.unstable_now, $d3093f2493aa17fd$var$ec = $eggFB.unstable_getCurrentPriorityLevel, $d3093f2493aa17fd$var$fc = $eggFB.unstable_ImmediatePriority, $d3093f2493aa17fd$var$gc = $eggFB.unstable_UserBlockingPriority, $d3093f2493aa17fd$var$hc = $eggFB.unstable_NormalPriority, $d3093f2493aa17fd$var$ic = $eggFB.unstable_LowPriority, $d3093f2493aa17fd$var$jc = $eggFB.unstable_IdlePriority, $d3093f2493aa17fd$var$kc = null, $d3093f2493aa17fd$var$lc = null, $d3093f2493aa17fd$var$B = null, $d3093f2493aa17fd$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $d3093f2493aa17fd$var$nc(a, b) {
    if ($d3093f2493aa17fd$var$lc && "function" === typeof $d3093f2493aa17fd$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $d3093f2493aa17fd$var$fc;
                break;
            case 4:
                d = $d3093f2493aa17fd$var$gc;
                break;
            case 16:
                d = $d3093f2493aa17fd$var$hc;
                break;
            case 536870912:
                d = $d3093f2493aa17fd$var$jc;
                break;
            default:
                d = $d3093f2493aa17fd$var$hc;
        }
        $d3093f2493aa17fd$var$lc.onCommitFiberRoot($d3093f2493aa17fd$var$kc, a, d, c);
    } catch (e) {}
}
function $d3093f2493aa17fd$var$oc(a) {
    $d3093f2493aa17fd$var$B = a;
}
function $d3093f2493aa17fd$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $d3093f2493aa17fd$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $d3093f2493aa17fd$var$rc() {
    null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markCommitStopped && $d3093f2493aa17fd$var$B.markCommitStopped();
}
function $d3093f2493aa17fd$var$sc(a) {
    null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markComponentRenderStarted && $d3093f2493aa17fd$var$B.markComponentRenderStarted(a);
}
function $d3093f2493aa17fd$var$tc() {
    null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markComponentRenderStopped && $d3093f2493aa17fd$var$B.markComponentRenderStopped();
}
function $d3093f2493aa17fd$var$uc(a) {
    null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markComponentLayoutEffectUnmountStarted && $d3093f2493aa17fd$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $d3093f2493aa17fd$var$vc() {
    null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markComponentLayoutEffectUnmountStopped && $d3093f2493aa17fd$var$B.markComponentLayoutEffectUnmountStopped();
}
function $d3093f2493aa17fd$var$wc(a) {
    null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markRenderStarted && $d3093f2493aa17fd$var$B.markRenderStarted(a);
}
function $d3093f2493aa17fd$var$xc() {
    null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markRenderStopped && $d3093f2493aa17fd$var$B.markRenderStopped();
}
function $d3093f2493aa17fd$var$yc(a, b) {
    null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markStateUpdateScheduled && $d3093f2493aa17fd$var$B.markStateUpdateScheduled(a, b);
}
var $d3093f2493aa17fd$var$Ac = Math.clz32 ? Math.clz32 : $d3093f2493aa17fd$var$zc, $d3093f2493aa17fd$var$Bc = Math.log, $d3093f2493aa17fd$var$Cc = Math.LN2;
function $d3093f2493aa17fd$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($d3093f2493aa17fd$var$Bc(a) / $d3093f2493aa17fd$var$Cc | 0) | 0;
}
function $d3093f2493aa17fd$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $d3093f2493aa17fd$var$Dc = 64, $d3093f2493aa17fd$var$Ec = 4194304;
function $d3093f2493aa17fd$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $d3093f2493aa17fd$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $d3093f2493aa17fd$var$Fc(h) : (f &= g, 0 !== f && (d = $d3093f2493aa17fd$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $d3093f2493aa17fd$var$Fc(g) : 0 !== f && (d = $d3093f2493aa17fd$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $d3093f2493aa17fd$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $d3093f2493aa17fd$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $d3093f2493aa17fd$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $d3093f2493aa17fd$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $d3093f2493aa17fd$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $d3093f2493aa17fd$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $d3093f2493aa17fd$var$Kc() {
    var a = $d3093f2493aa17fd$var$Dc;
    $d3093f2493aa17fd$var$Dc <<= 1;
    0 === ($d3093f2493aa17fd$var$Dc & 4194240) && ($d3093f2493aa17fd$var$Dc = 64);
    return a;
}
function $d3093f2493aa17fd$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $d3093f2493aa17fd$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $d3093f2493aa17fd$var$Ac(b);
    a[b] = c;
}
function $d3093f2493aa17fd$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $d3093f2493aa17fd$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $d3093f2493aa17fd$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $d3093f2493aa17fd$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $d3093f2493aa17fd$var$Pc(a, b, c) {
    if ($d3093f2493aa17fd$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $d3093f2493aa17fd$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $d3093f2493aa17fd$var$Qc(a, b) {
    if ($d3093f2493aa17fd$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $d3093f2493aa17fd$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $d3093f2493aa17fd$var$E = 0;
function $d3093f2493aa17fd$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $d3093f2493aa17fd$var$Sc, $d3093f2493aa17fd$var$Tc, $d3093f2493aa17fd$var$Uc, $d3093f2493aa17fd$var$Vc, $d3093f2493aa17fd$var$Wc, $d3093f2493aa17fd$var$Xc = !1, $d3093f2493aa17fd$var$Yc = [], $d3093f2493aa17fd$var$Zc = null, $d3093f2493aa17fd$var$$c = null, $d3093f2493aa17fd$var$ad = null, $d3093f2493aa17fd$var$bd = new Map, $d3093f2493aa17fd$var$cd = new Map, $d3093f2493aa17fd$var$dd = [], $d3093f2493aa17fd$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $d3093f2493aa17fd$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $d3093f2493aa17fd$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $d3093f2493aa17fd$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $d3093f2493aa17fd$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $d3093f2493aa17fd$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $d3093f2493aa17fd$var$cd.delete(b.pointerId);
    }
}
function $d3093f2493aa17fd$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $d3093f2493aa17fd$var$Cb(b), null !== b && $d3093f2493aa17fd$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $d3093f2493aa17fd$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $d3093f2493aa17fd$var$Zc = $d3093f2493aa17fd$var$gd($d3093f2493aa17fd$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $d3093f2493aa17fd$var$$c = $d3093f2493aa17fd$var$gd($d3093f2493aa17fd$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $d3093f2493aa17fd$var$ad = $d3093f2493aa17fd$var$gd($d3093f2493aa17fd$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $d3093f2493aa17fd$var$bd.set(f, $d3093f2493aa17fd$var$gd($d3093f2493aa17fd$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $d3093f2493aa17fd$var$cd.set(f, $d3093f2493aa17fd$var$gd($d3093f2493aa17fd$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $d3093f2493aa17fd$var$id(a) {
    var b = $d3093f2493aa17fd$var$jd(a.target);
    if (null !== b) {
        var c = $d3093f2493aa17fd$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $d3093f2493aa17fd$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $d3093f2493aa17fd$var$Wc(a.priority, function() {
                        $d3093f2493aa17fd$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $d3093f2493aa17fd$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $d3093f2493aa17fd$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $d3093f2493aa17fd$var$wb = d;
            c.target.dispatchEvent(d);
            $d3093f2493aa17fd$var$wb = null;
        } else return b = $d3093f2493aa17fd$var$Cb(c), null !== b && $d3093f2493aa17fd$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $d3093f2493aa17fd$var$md(a, b, c) {
    $d3093f2493aa17fd$var$kd(a) && c.delete(b);
}
function $d3093f2493aa17fd$var$nd() {
    $d3093f2493aa17fd$var$Xc = !1;
    null !== $d3093f2493aa17fd$var$Zc && $d3093f2493aa17fd$var$kd($d3093f2493aa17fd$var$Zc) && ($d3093f2493aa17fd$var$Zc = null);
    null !== $d3093f2493aa17fd$var$$c && $d3093f2493aa17fd$var$kd($d3093f2493aa17fd$var$$c) && ($d3093f2493aa17fd$var$$c = null);
    null !== $d3093f2493aa17fd$var$ad && $d3093f2493aa17fd$var$kd($d3093f2493aa17fd$var$ad) && ($d3093f2493aa17fd$var$ad = null);
    $d3093f2493aa17fd$var$bd.forEach($d3093f2493aa17fd$var$md);
    $d3093f2493aa17fd$var$cd.forEach($d3093f2493aa17fd$var$md);
}
function $d3093f2493aa17fd$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $d3093f2493aa17fd$var$Xc || ($d3093f2493aa17fd$var$Xc = !0, $eggFB.unstable_scheduleCallback($eggFB.unstable_NormalPriority, $d3093f2493aa17fd$var$nd)));
}
function $d3093f2493aa17fd$var$pd(a) {
    function b(b) {
        return $d3093f2493aa17fd$var$od(b, a);
    }
    if (0 < $d3093f2493aa17fd$var$Yc.length) {
        $d3093f2493aa17fd$var$od($d3093f2493aa17fd$var$Yc[0], a);
        for(var c = 1; c < $d3093f2493aa17fd$var$Yc.length; c++){
            var d = $d3093f2493aa17fd$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $d3093f2493aa17fd$var$Zc && $d3093f2493aa17fd$var$od($d3093f2493aa17fd$var$Zc, a);
    null !== $d3093f2493aa17fd$var$$c && $d3093f2493aa17fd$var$od($d3093f2493aa17fd$var$$c, a);
    null !== $d3093f2493aa17fd$var$ad && $d3093f2493aa17fd$var$od($d3093f2493aa17fd$var$ad, a);
    $d3093f2493aa17fd$var$bd.forEach(b);
    $d3093f2493aa17fd$var$cd.forEach(b);
    for(c = 0; c < $d3093f2493aa17fd$var$dd.length; c++)d = $d3093f2493aa17fd$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $d3093f2493aa17fd$var$dd.length && (c = $d3093f2493aa17fd$var$dd[0], null === c.blockedOn);)$d3093f2493aa17fd$var$id(c), null === c.blockedOn && $d3093f2493aa17fd$var$dd.shift();
}
var $d3093f2493aa17fd$var$qd = $d3093f2493aa17fd$var$va.ReactCurrentBatchConfig, $d3093f2493aa17fd$var$rd = !0;
function $d3093f2493aa17fd$var$sd(a, b, c, d) {
    var e = $d3093f2493aa17fd$var$E, f = $d3093f2493aa17fd$var$qd.transition;
    $d3093f2493aa17fd$var$qd.transition = null;
    try {
        $d3093f2493aa17fd$var$E = 1, $d3093f2493aa17fd$var$td(a, b, c, d);
    } finally{
        $d3093f2493aa17fd$var$E = e, $d3093f2493aa17fd$var$qd.transition = f;
    }
}
function $d3093f2493aa17fd$var$ud(a, b, c, d) {
    var e = $d3093f2493aa17fd$var$E, f = $d3093f2493aa17fd$var$qd.transition;
    $d3093f2493aa17fd$var$qd.transition = null;
    try {
        $d3093f2493aa17fd$var$E = 4, $d3093f2493aa17fd$var$td(a, b, c, d);
    } finally{
        $d3093f2493aa17fd$var$E = e, $d3093f2493aa17fd$var$qd.transition = f;
    }
}
function $d3093f2493aa17fd$var$td(a, b, c, d) {
    if ($d3093f2493aa17fd$var$rd) {
        var e = $d3093f2493aa17fd$var$ld(a, b, c, d);
        if (null === e) $d3093f2493aa17fd$var$vd(a, b, d, $d3093f2493aa17fd$var$wd, c), $d3093f2493aa17fd$var$fd(a, d);
        else if ($d3093f2493aa17fd$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($d3093f2493aa17fd$var$fd(a, d), b & 4 && -1 < $d3093f2493aa17fd$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $d3093f2493aa17fd$var$Cb(e);
                null !== f && $d3093f2493aa17fd$var$Sc(f);
                f = $d3093f2493aa17fd$var$ld(a, b, c, d);
                null === f && $d3093f2493aa17fd$var$vd(a, b, d, $d3093f2493aa17fd$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $d3093f2493aa17fd$var$vd(a, b, d, null, c);
    }
}
var $d3093f2493aa17fd$var$wd = null;
function $d3093f2493aa17fd$var$ld(a, b, c, d) {
    $d3093f2493aa17fd$var$wd = null;
    a = $d3093f2493aa17fd$var$xb(d);
    a = $d3093f2493aa17fd$var$jd(a);
    if (null !== a) {
        if (b = $d3093f2493aa17fd$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $d3093f2493aa17fd$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $d3093f2493aa17fd$var$wd = a;
    return null;
}
function $d3093f2493aa17fd$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($d3093f2493aa17fd$var$ec()){
                case $d3093f2493aa17fd$var$fc:
                    return 1;
                case $d3093f2493aa17fd$var$gc:
                    return 4;
                case $d3093f2493aa17fd$var$hc:
                case $d3093f2493aa17fd$var$ic:
                    return 16;
                case $d3093f2493aa17fd$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $d3093f2493aa17fd$var$yd = null, $d3093f2493aa17fd$var$zd = null, $d3093f2493aa17fd$var$Ad = null;
function $d3093f2493aa17fd$var$Bd() {
    if ($d3093f2493aa17fd$var$Ad) return $d3093f2493aa17fd$var$Ad;
    var a, b = $d3093f2493aa17fd$var$zd, c = b.length, d, e = "value" in $d3093f2493aa17fd$var$yd ? $d3093f2493aa17fd$var$yd.value : $d3093f2493aa17fd$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d3093f2493aa17fd$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $d3093f2493aa17fd$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $d3093f2493aa17fd$var$Dd() {
    return !0;
}
function $d3093f2493aa17fd$var$Ed() {
    return !1;
}
function $d3093f2493aa17fd$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $d3093f2493aa17fd$var$Dd : $d3093f2493aa17fd$var$Ed;
        this.isPropagationStopped = $d3093f2493aa17fd$var$Ed;
        return this;
    }
    $d3093f2493aa17fd$var$u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $d3093f2493aa17fd$var$Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $d3093f2493aa17fd$var$Dd);
        },
        persist: function() {},
        isPersistent: $d3093f2493aa17fd$var$Dd
    });
    return b;
}
var $d3093f2493aa17fd$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $d3093f2493aa17fd$var$Hd = $d3093f2493aa17fd$var$Fd($d3093f2493aa17fd$var$Gd), $d3093f2493aa17fd$var$Id = $d3093f2493aa17fd$var$u({}, $d3093f2493aa17fd$var$Gd, {
    view: 0,
    detail: 0
}), $d3093f2493aa17fd$var$Jd = $d3093f2493aa17fd$var$Fd($d3093f2493aa17fd$var$Id), $d3093f2493aa17fd$var$Kd, $d3093f2493aa17fd$var$Ld, $d3093f2493aa17fd$var$Md, $d3093f2493aa17fd$var$Od = $d3093f2493aa17fd$var$u({}, $d3093f2493aa17fd$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $d3093f2493aa17fd$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $d3093f2493aa17fd$var$Md && ($d3093f2493aa17fd$var$Md && "mousemove" === a.type ? ($d3093f2493aa17fd$var$Kd = a.screenX - $d3093f2493aa17fd$var$Md.screenX, $d3093f2493aa17fd$var$Ld = a.screenY - $d3093f2493aa17fd$var$Md.screenY) : $d3093f2493aa17fd$var$Ld = $d3093f2493aa17fd$var$Kd = 0, $d3093f2493aa17fd$var$Md = a);
        return $d3093f2493aa17fd$var$Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $d3093f2493aa17fd$var$Ld;
    }
}), $d3093f2493aa17fd$var$Pd = $d3093f2493aa17fd$var$Fd($d3093f2493aa17fd$var$Od), $d3093f2493aa17fd$var$Qd = $d3093f2493aa17fd$var$u({}, $d3093f2493aa17fd$var$Od, {
    dataTransfer: 0
}), $d3093f2493aa17fd$var$Rd = $d3093f2493aa17fd$var$Fd($d3093f2493aa17fd$var$Qd), $d3093f2493aa17fd$var$Sd = $d3093f2493aa17fd$var$u({}, $d3093f2493aa17fd$var$Id, {
    relatedTarget: 0
}), $d3093f2493aa17fd$var$Td = $d3093f2493aa17fd$var$Fd($d3093f2493aa17fd$var$Sd), $d3093f2493aa17fd$var$Ud = $d3093f2493aa17fd$var$u({}, $d3093f2493aa17fd$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $d3093f2493aa17fd$var$Vd = $d3093f2493aa17fd$var$Fd($d3093f2493aa17fd$var$Ud), $d3093f2493aa17fd$var$Wd = $d3093f2493aa17fd$var$u({}, $d3093f2493aa17fd$var$Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $d3093f2493aa17fd$var$Xd = $d3093f2493aa17fd$var$Fd($d3093f2493aa17fd$var$Wd), $d3093f2493aa17fd$var$Yd = $d3093f2493aa17fd$var$u({}, $d3093f2493aa17fd$var$Gd, {
    data: 0
}), $d3093f2493aa17fd$var$Zd = $d3093f2493aa17fd$var$Fd($d3093f2493aa17fd$var$Yd), $d3093f2493aa17fd$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $d3093f2493aa17fd$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $d3093f2493aa17fd$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $d3093f2493aa17fd$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $d3093f2493aa17fd$var$be[a]) ? !!b[a] : !1;
}
function $d3093f2493aa17fd$var$Nd() {
    return $d3093f2493aa17fd$var$ce;
}
var $d3093f2493aa17fd$var$de = $d3093f2493aa17fd$var$u({}, $d3093f2493aa17fd$var$Id, {
    key: function(a) {
        if (a.key) {
            var b = $d3093f2493aa17fd$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $d3093f2493aa17fd$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $d3093f2493aa17fd$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $d3093f2493aa17fd$var$Nd,
    charCode: function(a) {
        return "keypress" === a.type ? $d3093f2493aa17fd$var$Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $d3093f2493aa17fd$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $d3093f2493aa17fd$var$ee = $d3093f2493aa17fd$var$Fd($d3093f2493aa17fd$var$de), $d3093f2493aa17fd$var$fe = $d3093f2493aa17fd$var$u({}, $d3093f2493aa17fd$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $d3093f2493aa17fd$var$ge = $d3093f2493aa17fd$var$Fd($d3093f2493aa17fd$var$fe), $d3093f2493aa17fd$var$he = $d3093f2493aa17fd$var$u({}, $d3093f2493aa17fd$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $d3093f2493aa17fd$var$Nd
}), $d3093f2493aa17fd$var$ie = $d3093f2493aa17fd$var$Fd($d3093f2493aa17fd$var$he), $d3093f2493aa17fd$var$je = $d3093f2493aa17fd$var$u({}, $d3093f2493aa17fd$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $d3093f2493aa17fd$var$ke = $d3093f2493aa17fd$var$Fd($d3093f2493aa17fd$var$je), $d3093f2493aa17fd$var$le = $d3093f2493aa17fd$var$u({}, $d3093f2493aa17fd$var$Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $d3093f2493aa17fd$var$me = $d3093f2493aa17fd$var$Fd($d3093f2493aa17fd$var$le), $d3093f2493aa17fd$var$ne = [
    9,
    13,
    27,
    32
], $d3093f2493aa17fd$var$oe = $d3093f2493aa17fd$var$ia && "CompositionEvent" in window, $d3093f2493aa17fd$var$pe = null;
$d3093f2493aa17fd$var$ia && "documentMode" in document && ($d3093f2493aa17fd$var$pe = document.documentMode);
var $d3093f2493aa17fd$var$qe = $d3093f2493aa17fd$var$ia && "TextEvent" in window && !$d3093f2493aa17fd$var$pe, $d3093f2493aa17fd$var$re = $d3093f2493aa17fd$var$ia && (!$d3093f2493aa17fd$var$oe || $d3093f2493aa17fd$var$pe && 8 < $d3093f2493aa17fd$var$pe && 11 >= $d3093f2493aa17fd$var$pe), $d3093f2493aa17fd$var$se = String.fromCharCode(32), $d3093f2493aa17fd$var$te = !1;
function $d3093f2493aa17fd$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d3093f2493aa17fd$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $d3093f2493aa17fd$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $d3093f2493aa17fd$var$we = !1;
function $d3093f2493aa17fd$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $d3093f2493aa17fd$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $d3093f2493aa17fd$var$te = !0;
            return $d3093f2493aa17fd$var$se;
        case "textInput":
            return a = b.data, a === $d3093f2493aa17fd$var$se && $d3093f2493aa17fd$var$te ? null : a;
        default:
            return null;
    }
}
function $d3093f2493aa17fd$var$ye(a, b) {
    if ($d3093f2493aa17fd$var$we) return "compositionend" === a || !$d3093f2493aa17fd$var$oe && $d3093f2493aa17fd$var$ue(a, b) ? (a = $d3093f2493aa17fd$var$Bd(), $d3093f2493aa17fd$var$Ad = $d3093f2493aa17fd$var$zd = $d3093f2493aa17fd$var$yd = null, $d3093f2493aa17fd$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $d3093f2493aa17fd$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $d3093f2493aa17fd$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $d3093f2493aa17fd$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$d3093f2493aa17fd$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $d3093f2493aa17fd$var$Be(a, b, c, d) {
    $d3093f2493aa17fd$var$Eb(d);
    b = $d3093f2493aa17fd$var$Ce(b, "onChange");
    0 < b.length && (c = new $d3093f2493aa17fd$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $d3093f2493aa17fd$var$De = null, $d3093f2493aa17fd$var$Ee = null;
function $d3093f2493aa17fd$var$Fe(a) {
    $d3093f2493aa17fd$var$Ge(a, 0);
}
function $d3093f2493aa17fd$var$He(a) {
    var b = $d3093f2493aa17fd$var$Ie(a);
    if ($d3093f2493aa17fd$var$Wa(b)) return a;
}
function $d3093f2493aa17fd$var$Je(a, b) {
    if ("change" === a) return b;
}
var $d3093f2493aa17fd$var$Ke = !1;
if ($d3093f2493aa17fd$var$ia) {
    var $d3093f2493aa17fd$var$Le;
    if ($d3093f2493aa17fd$var$ia) {
        var $d3093f2493aa17fd$var$Me = "oninput" in document;
        if (!$d3093f2493aa17fd$var$Me) {
            var $d3093f2493aa17fd$var$Ne = document.createElement("div");
            $d3093f2493aa17fd$var$Ne.setAttribute("oninput", "return;");
            $d3093f2493aa17fd$var$Me = "function" === typeof $d3093f2493aa17fd$var$Ne.oninput;
        }
        $d3093f2493aa17fd$var$Le = $d3093f2493aa17fd$var$Me;
    } else $d3093f2493aa17fd$var$Le = !1;
    $d3093f2493aa17fd$var$Ke = $d3093f2493aa17fd$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $d3093f2493aa17fd$var$Oe() {
    $d3093f2493aa17fd$var$De && ($d3093f2493aa17fd$var$De.detachEvent("onpropertychange", $d3093f2493aa17fd$var$Pe), $d3093f2493aa17fd$var$Ee = $d3093f2493aa17fd$var$De = null);
}
function $d3093f2493aa17fd$var$Pe(a) {
    if ("value" === a.propertyName && $d3093f2493aa17fd$var$He($d3093f2493aa17fd$var$Ee)) {
        var b = [];
        $d3093f2493aa17fd$var$Be(b, $d3093f2493aa17fd$var$Ee, a, $d3093f2493aa17fd$var$xb(a));
        $d3093f2493aa17fd$var$Jb($d3093f2493aa17fd$var$Fe, b);
    }
}
function $d3093f2493aa17fd$var$Qe(a, b, c) {
    "focusin" === a ? ($d3093f2493aa17fd$var$Oe(), $d3093f2493aa17fd$var$De = b, $d3093f2493aa17fd$var$Ee = c, $d3093f2493aa17fd$var$De.attachEvent("onpropertychange", $d3093f2493aa17fd$var$Pe)) : "focusout" === a && $d3093f2493aa17fd$var$Oe();
}
function $d3093f2493aa17fd$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $d3093f2493aa17fd$var$He($d3093f2493aa17fd$var$Ee);
}
function $d3093f2493aa17fd$var$Se(a, b) {
    if ("click" === a) return $d3093f2493aa17fd$var$He(b);
}
function $d3093f2493aa17fd$var$Te(a, b) {
    if ("input" === a || "change" === a) return $d3093f2493aa17fd$var$He(b);
}
function $d3093f2493aa17fd$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d3093f2493aa17fd$var$Ve = "function" === typeof Object.is ? Object.is : $d3093f2493aa17fd$var$Ue;
function $d3093f2493aa17fd$var$We(a, b) {
    if ($d3093f2493aa17fd$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$d3093f2493aa17fd$var$ja.call(b, e) || !$d3093f2493aa17fd$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $d3093f2493aa17fd$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $d3093f2493aa17fd$var$Ye(a, b) {
    var c = $d3093f2493aa17fd$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $d3093f2493aa17fd$var$Xe(c);
    }
}
function $d3093f2493aa17fd$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $d3093f2493aa17fd$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $d3093f2493aa17fd$var$$e() {
    for(var a = window, b = $d3093f2493aa17fd$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $d3093f2493aa17fd$var$Xa(a.document);
    }
    return b;
}
function $d3093f2493aa17fd$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $d3093f2493aa17fd$var$bf(a) {
    var b = $d3093f2493aa17fd$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $d3093f2493aa17fd$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $d3093f2493aa17fd$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $d3093f2493aa17fd$var$Ye(c, f);
                var g = $d3093f2493aa17fd$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $d3093f2493aa17fd$var$cf = $d3093f2493aa17fd$var$ia && "documentMode" in document && 11 >= document.documentMode, $d3093f2493aa17fd$var$df = null, $d3093f2493aa17fd$var$ef = null, $d3093f2493aa17fd$var$ff = null, $d3093f2493aa17fd$var$gf = !1;
function $d3093f2493aa17fd$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $d3093f2493aa17fd$var$gf || null == $d3093f2493aa17fd$var$df || $d3093f2493aa17fd$var$df !== $d3093f2493aa17fd$var$Xa(d) || (d = $d3093f2493aa17fd$var$df, "selectionStart" in d && $d3093f2493aa17fd$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $d3093f2493aa17fd$var$ff && $d3093f2493aa17fd$var$We($d3093f2493aa17fd$var$ff, d) || ($d3093f2493aa17fd$var$ff = d, d = $d3093f2493aa17fd$var$Ce($d3093f2493aa17fd$var$ef, "onSelect"), 0 < d.length && (b = new $d3093f2493aa17fd$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $d3093f2493aa17fd$var$df)));
}
function $d3093f2493aa17fd$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $d3093f2493aa17fd$var$kf = {
    animationend: $d3093f2493aa17fd$var$jf("Animation", "AnimationEnd"),
    animationiteration: $d3093f2493aa17fd$var$jf("Animation", "AnimationIteration"),
    animationstart: $d3093f2493aa17fd$var$jf("Animation", "AnimationStart"),
    transitionend: $d3093f2493aa17fd$var$jf("Transition", "TransitionEnd")
}, $d3093f2493aa17fd$var$lf = {}, $d3093f2493aa17fd$var$mf = {};
$d3093f2493aa17fd$var$ia && ($d3093f2493aa17fd$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $d3093f2493aa17fd$var$kf.animationend.animation, delete $d3093f2493aa17fd$var$kf.animationiteration.animation, delete $d3093f2493aa17fd$var$kf.animationstart.animation), "TransitionEvent" in window || delete $d3093f2493aa17fd$var$kf.transitionend.transition);
function $d3093f2493aa17fd$var$nf(a) {
    if ($d3093f2493aa17fd$var$lf[a]) return $d3093f2493aa17fd$var$lf[a];
    if (!$d3093f2493aa17fd$var$kf[a]) return a;
    var b = $d3093f2493aa17fd$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $d3093f2493aa17fd$var$mf) return $d3093f2493aa17fd$var$lf[a] = b[c];
    return a;
}
var $d3093f2493aa17fd$var$of = $d3093f2493aa17fd$var$nf("animationend"), $d3093f2493aa17fd$var$pf = $d3093f2493aa17fd$var$nf("animationiteration"), $d3093f2493aa17fd$var$qf = $d3093f2493aa17fd$var$nf("animationstart"), $d3093f2493aa17fd$var$rf = $d3093f2493aa17fd$var$nf("transitionend"), $d3093f2493aa17fd$var$sf = new Map, $d3093f2493aa17fd$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $d3093f2493aa17fd$var$uf(a, b) {
    $d3093f2493aa17fd$var$sf.set(a, b);
    $d3093f2493aa17fd$var$fa(b, [
        a
    ]);
}
for(var $d3093f2493aa17fd$var$vf = 0; $d3093f2493aa17fd$var$vf < $d3093f2493aa17fd$var$tf.length; $d3093f2493aa17fd$var$vf++){
    var $d3093f2493aa17fd$var$wf = $d3093f2493aa17fd$var$tf[$d3093f2493aa17fd$var$vf], $d3093f2493aa17fd$var$xf = $d3093f2493aa17fd$var$wf.toLowerCase(), $d3093f2493aa17fd$var$yf = $d3093f2493aa17fd$var$wf[0].toUpperCase() + $d3093f2493aa17fd$var$wf.slice(1);
    $d3093f2493aa17fd$var$uf($d3093f2493aa17fd$var$xf, "on" + $d3093f2493aa17fd$var$yf);
}
$d3093f2493aa17fd$var$uf($d3093f2493aa17fd$var$of, "onAnimationEnd");
$d3093f2493aa17fd$var$uf($d3093f2493aa17fd$var$pf, "onAnimationIteration");
$d3093f2493aa17fd$var$uf($d3093f2493aa17fd$var$qf, "onAnimationStart");
$d3093f2493aa17fd$var$uf("dblclick", "onDoubleClick");
$d3093f2493aa17fd$var$uf("focusin", "onFocus");
$d3093f2493aa17fd$var$uf("focusout", "onBlur");
$d3093f2493aa17fd$var$uf($d3093f2493aa17fd$var$rf, "onTransitionEnd");
$d3093f2493aa17fd$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$d3093f2493aa17fd$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$d3093f2493aa17fd$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$d3093f2493aa17fd$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$d3093f2493aa17fd$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$d3093f2493aa17fd$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$d3093f2493aa17fd$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$d3093f2493aa17fd$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$d3093f2493aa17fd$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$d3093f2493aa17fd$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $d3093f2493aa17fd$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $d3093f2493aa17fd$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($d3093f2493aa17fd$var$zf));
function $d3093f2493aa17fd$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $d3093f2493aa17fd$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $d3093f2493aa17fd$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $d3093f2493aa17fd$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $d3093f2493aa17fd$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($d3093f2493aa17fd$var$Qb) throw a = $d3093f2493aa17fd$var$Rb, $d3093f2493aa17fd$var$Qb = !1, $d3093f2493aa17fd$var$Rb = null, a;
}
function $d3093f2493aa17fd$var$F(a, b) {
    var c = b[$d3093f2493aa17fd$var$Cf];
    void 0 === c && (c = b[$d3093f2493aa17fd$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($d3093f2493aa17fd$var$Df(b, a, 2, !1), c.add(d));
}
function $d3093f2493aa17fd$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $d3093f2493aa17fd$var$Df(c, a, d, b);
}
var $d3093f2493aa17fd$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $d3093f2493aa17fd$var$Gf(a) {
    if (!a[$d3093f2493aa17fd$var$Ff]) {
        a[$d3093f2493aa17fd$var$Ff] = !0;
        $d3093f2493aa17fd$var$ca.forEach(function(b) {
            "selectionchange" !== b && ($d3093f2493aa17fd$var$Af.has(b) || $d3093f2493aa17fd$var$Ef(b, !1, a), $d3093f2493aa17fd$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$d3093f2493aa17fd$var$Ff] || (b[$d3093f2493aa17fd$var$Ff] = !0, $d3093f2493aa17fd$var$Ef("selectionchange", !1, b));
    }
}
function $d3093f2493aa17fd$var$Df(a, b, c, d) {
    switch($d3093f2493aa17fd$var$xd(b)){
        case 1:
            var e = $d3093f2493aa17fd$var$sd;
            break;
        case 4:
            e = $d3093f2493aa17fd$var$ud;
            break;
        default:
            e = $d3093f2493aa17fd$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$d3093f2493aa17fd$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $d3093f2493aa17fd$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $d3093f2493aa17fd$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $d3093f2493aa17fd$var$Jb(function() {
        var d = f, e = $d3093f2493aa17fd$var$xb(c), g = [];
        a: {
            var h = $d3093f2493aa17fd$var$sf.get(a);
            if (void 0 !== h) {
                var k = $d3093f2493aa17fd$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $d3093f2493aa17fd$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $d3093f2493aa17fd$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $d3093f2493aa17fd$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $d3093f2493aa17fd$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $d3093f2493aa17fd$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $d3093f2493aa17fd$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $d3093f2493aa17fd$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $d3093f2493aa17fd$var$ie;
                        break;
                    case $d3093f2493aa17fd$var$of:
                    case $d3093f2493aa17fd$var$pf:
                    case $d3093f2493aa17fd$var$qf:
                        k = $d3093f2493aa17fd$var$Vd;
                        break;
                    case $d3093f2493aa17fd$var$rf:
                        k = $d3093f2493aa17fd$var$ke;
                        break;
                    case "scroll":
                        k = $d3093f2493aa17fd$var$Jd;
                        break;
                    case "wheel":
                        k = $d3093f2493aa17fd$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $d3093f2493aa17fd$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $d3093f2493aa17fd$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $d3093f2493aa17fd$var$Kb(y, x), null != D && w.push($d3093f2493aa17fd$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $d3093f2493aa17fd$var$wb && (m = c.relatedTarget || c.fromElement) && ($d3093f2493aa17fd$var$jd(m) || m[$d3093f2493aa17fd$var$If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $d3093f2493aa17fd$var$jd(m) : null, null !== m && (C = $d3093f2493aa17fd$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $d3093f2493aa17fd$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $d3093f2493aa17fd$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $d3093f2493aa17fd$var$Ie(k);
                        v = null == m ? h : $d3093f2493aa17fd$var$Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $d3093f2493aa17fd$var$jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $d3093f2493aa17fd$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $d3093f2493aa17fd$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $d3093f2493aa17fd$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $d3093f2493aa17fd$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $d3093f2493aa17fd$var$Jf(w);
                                x = $d3093f2493aa17fd$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $d3093f2493aa17fd$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $d3093f2493aa17fd$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $d3093f2493aa17fd$var$Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var da = $d3093f2493aa17fd$var$Je;
                else if ($d3093f2493aa17fd$var$Ae(h)) {
                    if ($d3093f2493aa17fd$var$Ke) da = $d3093f2493aa17fd$var$Te;
                    else {
                        da = $d3093f2493aa17fd$var$Re;
                        var R = $d3093f2493aa17fd$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (da = $d3093f2493aa17fd$var$Se);
                if (da && (da = da(a, d))) {
                    $d3093f2493aa17fd$var$Be(g, da, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $d3093f2493aa17fd$var$bb(h, "number", h.value);
            }
            R = d ? $d3093f2493aa17fd$var$Ie(d) : window;
            switch(a){
                case "focusin":
                    if ($d3093f2493aa17fd$var$Ae(R) || "true" === R.contentEditable) $d3093f2493aa17fd$var$df = R, $d3093f2493aa17fd$var$ef = d, $d3093f2493aa17fd$var$ff = null;
                    break;
                case "focusout":
                    $d3093f2493aa17fd$var$ff = $d3093f2493aa17fd$var$ef = $d3093f2493aa17fd$var$df = null;
                    break;
                case "mousedown":
                    $d3093f2493aa17fd$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $d3093f2493aa17fd$var$gf = !1;
                    $d3093f2493aa17fd$var$hf(g, c, e);
                    break;
                case "selectionchange":
                    if ($d3093f2493aa17fd$var$cf) break;
                case "keydown":
                case "keyup":
                    $d3093f2493aa17fd$var$hf(g, c, e);
            }
            var sa;
            if ($d3093f2493aa17fd$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $d3093f2493aa17fd$var$we ? $d3093f2493aa17fd$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($d3093f2493aa17fd$var$re && "ko" !== c.locale && ($d3093f2493aa17fd$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $d3093f2493aa17fd$var$we && (sa = $d3093f2493aa17fd$var$Bd()) : ($d3093f2493aa17fd$var$yd = e, $d3093f2493aa17fd$var$zd = "value" in $d3093f2493aa17fd$var$yd ? $d3093f2493aa17fd$var$yd.value : $d3093f2493aa17fd$var$yd.textContent, $d3093f2493aa17fd$var$we = !0)), R = $d3093f2493aa17fd$var$Ce(d, V), 0 < R.length && (V = new $d3093f2493aa17fd$var$Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $d3093f2493aa17fd$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $d3093f2493aa17fd$var$qe ? $d3093f2493aa17fd$var$xe(a, c) : $d3093f2493aa17fd$var$ye(a, c)) d = $d3093f2493aa17fd$var$Ce(d, "onBeforeInput"), 0 < d.length && (e = new $d3093f2493aa17fd$var$Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        $d3093f2493aa17fd$var$Ge(g, b);
    });
}
function $d3093f2493aa17fd$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $d3093f2493aa17fd$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $d3093f2493aa17fd$var$Kb(a, c), null != f && d.unshift($d3093f2493aa17fd$var$Hf(a, f, e)), f = $d3093f2493aa17fd$var$Kb(a, b), null != f && d.push($d3093f2493aa17fd$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $d3093f2493aa17fd$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $d3093f2493aa17fd$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $d3093f2493aa17fd$var$Kb(c, f), null != k && g.unshift($d3093f2493aa17fd$var$Hf(c, k, h))) : e || (k = $d3093f2493aa17fd$var$Kb(c, f), null != k && g.push($d3093f2493aa17fd$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $d3093f2493aa17fd$var$Lf = !1, $d3093f2493aa17fd$var$Mf = /\r\n?/g, $d3093f2493aa17fd$var$Nf = /\u0000|\uFFFD/g;
function $d3093f2493aa17fd$var$Of(a) {
    return ("string" === typeof a ? a : "" + a).replace($d3093f2493aa17fd$var$Mf, "\n").replace($d3093f2493aa17fd$var$Nf, "");
}
function $d3093f2493aa17fd$var$Pf(a, b, c) {
    b = $d3093f2493aa17fd$var$Of(b);
    a = $d3093f2493aa17fd$var$Of(a);
    if (a !== b && (console.log('Text content did not match. Server: "' + a + '" Client: " ' + b + '"'), window && window.__HYDRATION_ERRORS__ && window.__HYDRATION_ERRORS__.push({
        type: "TEXT_MISMATCH",
        msg: 'Text content did not match. Server: "' + a + '" Client: " ' + b + '"'
    }), c)) throw Error($d3093f2493aa17fd$var$p(425));
}
function $d3093f2493aa17fd$var$Qf() {}
function $d3093f2493aa17fd$var$Rf(a, b) {
    console.log("Did not expect server HTML to contain a " + b.nodeName.toLowerCase() + " in " + a.nodeName.toLowerCase() + ".", b, a);
    window && window.__HYDRATION_ERRORS__ && window.__HYDRATION_ERRORS__.push({
        type: "CLIENT_MISMATCH",
        msg: "Did not expect server HTML to contain a " + b.nodeName.toLowerCase() + " in " + a.nodeName.toLowerCase() + ".",
        parent: a,
        child: b
    });
}
function $d3093f2493aa17fd$var$Sf(a, b) {
    console.log('Did not expect server HTML to contain the text node "' + b.nodeValue + '" in ' + a.nodeName.toLowerCase() + ".", b, a);
    window && window.__HYDRATION_ERRORS__ && window.__HYDRATION_ERRORS__.push({
        type: "CLIENT_MISMATCH",
        msg: 'Did not expect server HTML to contain the text node "' + b.nodeValue + '" in ' + a.nodeName.toLowerCase() + ".",
        parent: a,
        child: b
    });
}
function $d3093f2493aa17fd$var$Tf(a, b) {
    console.log("Expected server HTML to contain a matching " + b + " in " + a.nodeName.toLowerCase() + ".", a);
    window && window.__HYDRATION_ERRORS__ && window.__HYDRATION_ERRORS__.push({
        type: "SERVER_MISMATCH",
        msg: "Expected server HTML to contain a matching " + b + " in " + a.nodeName.toLowerCase() + ".",
        parentNode: a
    });
}
function $d3093f2493aa17fd$var$Uf(a, b) {
    "" !== b && (console.log("Expected server HTML to contain matching text in " + a.nodeName.toLowerCase() + ".", a), window && window.__HYDRATION_ERRORS__ && window.__HYDRATION_ERRORS__.push({
        type: "SERVER_MISMATCH",
        msg: 'Expected server HTML to contain a matching text node for "' + b + '" in ' + a.nodeName.toLowerCase() + ".",
        parent: a
    }), $d3093f2493aa17fd$var$Lf || ($d3093f2493aa17fd$var$Lf = !0, console.error('Expected server HTML to contain a matching text node for "%s" in <%s>.', b, a.nodeName.toLowerCase())));
}
var $d3093f2493aa17fd$var$Vf = null, $d3093f2493aa17fd$var$Wf = null;
function $d3093f2493aa17fd$var$Xf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $d3093f2493aa17fd$var$Yf = function() {
    return setTimeout.apply(void 0, arguments);
}, $d3093f2493aa17fd$var$Zf = function() {
    return clearTimeout.apply(void 0, arguments);
}, $d3093f2493aa17fd$var$$f = "function" === typeof Promise ? Promise : void 0, $d3093f2493aa17fd$var$bg = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $d3093f2493aa17fd$var$$f ? function(a) {
    return $d3093f2493aa17fd$var$$f.resolve(null).then(a).catch($d3093f2493aa17fd$var$ag);
} : $d3093f2493aa17fd$var$Yf;
function $d3093f2493aa17fd$var$ag(a) {
    setTimeout(function() {
        throw a;
    });
}
function $d3093f2493aa17fd$var$cg(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $d3093f2493aa17fd$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $d3093f2493aa17fd$var$pd(b);
}
function $d3093f2493aa17fd$var$dg(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $d3093f2493aa17fd$var$eg(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $d3093f2493aa17fd$var$fg = Math.random().toString(36).slice(2), $d3093f2493aa17fd$var$gg = "__reactFiber$" + $d3093f2493aa17fd$var$fg, $d3093f2493aa17fd$var$hg = "__reactProps$" + $d3093f2493aa17fd$var$fg, $d3093f2493aa17fd$var$If = "__reactContainer$" + $d3093f2493aa17fd$var$fg, $d3093f2493aa17fd$var$Cf = "__reactEvents$" + $d3093f2493aa17fd$var$fg, $d3093f2493aa17fd$var$ig = "__reactListeners$" + $d3093f2493aa17fd$var$fg, $d3093f2493aa17fd$var$jg = "__reactHandles$" + $d3093f2493aa17fd$var$fg;
function $d3093f2493aa17fd$var$jd(a) {
    var b = a[$d3093f2493aa17fd$var$gg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$d3093f2493aa17fd$var$If] || c[$d3093f2493aa17fd$var$gg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $d3093f2493aa17fd$var$eg(a); null !== a;){
                if (c = a[$d3093f2493aa17fd$var$gg]) return c;
                a = $d3093f2493aa17fd$var$eg(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $d3093f2493aa17fd$var$Cb(a) {
    a = a[$d3093f2493aa17fd$var$gg] || a[$d3093f2493aa17fd$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $d3093f2493aa17fd$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($d3093f2493aa17fd$var$p(33));
}
function $d3093f2493aa17fd$var$Db(a) {
    return a[$d3093f2493aa17fd$var$hg] || null;
}
var $d3093f2493aa17fd$var$kg = [], $d3093f2493aa17fd$var$lg = -1;
function $d3093f2493aa17fd$var$mg(a) {
    return {
        current: a
    };
}
function $d3093f2493aa17fd$var$G(a) {
    0 > $d3093f2493aa17fd$var$lg || (a.current = $d3093f2493aa17fd$var$kg[$d3093f2493aa17fd$var$lg], $d3093f2493aa17fd$var$kg[$d3093f2493aa17fd$var$lg] = null, $d3093f2493aa17fd$var$lg--);
}
function $d3093f2493aa17fd$var$H(a, b) {
    $d3093f2493aa17fd$var$lg++;
    $d3093f2493aa17fd$var$kg[$d3093f2493aa17fd$var$lg] = a.current;
    a.current = b;
}
var $d3093f2493aa17fd$var$ng = {}, $d3093f2493aa17fd$var$I = $d3093f2493aa17fd$var$mg($d3093f2493aa17fd$var$ng), $d3093f2493aa17fd$var$og = $d3093f2493aa17fd$var$mg(!1), $d3093f2493aa17fd$var$pg = $d3093f2493aa17fd$var$ng;
function $d3093f2493aa17fd$var$qg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $d3093f2493aa17fd$var$ng;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $d3093f2493aa17fd$var$rg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $d3093f2493aa17fd$var$sg() {
    $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$og);
    $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$I);
}
function $d3093f2493aa17fd$var$tg(a, b, c) {
    if ($d3093f2493aa17fd$var$I.current !== $d3093f2493aa17fd$var$ng) throw Error($d3093f2493aa17fd$var$p(168));
    $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$I, b);
    $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$og, c);
}
function $d3093f2493aa17fd$var$ug(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($d3093f2493aa17fd$var$p(108, $d3093f2493aa17fd$var$Ra(a) || "Unknown", e));
    return $d3093f2493aa17fd$var$u({}, c, d);
}
function $d3093f2493aa17fd$var$vg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $d3093f2493aa17fd$var$ng;
    $d3093f2493aa17fd$var$pg = $d3093f2493aa17fd$var$I.current;
    $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$I, a);
    $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$og, $d3093f2493aa17fd$var$og.current);
    return !0;
}
function $d3093f2493aa17fd$var$wg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($d3093f2493aa17fd$var$p(169));
    c ? (a = $d3093f2493aa17fd$var$ug(a, b, $d3093f2493aa17fd$var$pg), d.__reactInternalMemoizedMergedChildContext = a, $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$og), $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$I), $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$I, a)) : $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$og);
    $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$og, c);
}
var $d3093f2493aa17fd$var$xg = null, $d3093f2493aa17fd$var$yg = !1, $d3093f2493aa17fd$var$zg = !1;
function $d3093f2493aa17fd$var$Ag(a) {
    null === $d3093f2493aa17fd$var$xg ? $d3093f2493aa17fd$var$xg = [
        a
    ] : $d3093f2493aa17fd$var$xg.push(a);
}
function $d3093f2493aa17fd$var$Bg(a) {
    $d3093f2493aa17fd$var$yg = !0;
    $d3093f2493aa17fd$var$Ag(a);
}
function $d3093f2493aa17fd$var$Cg() {
    if (!$d3093f2493aa17fd$var$zg && null !== $d3093f2493aa17fd$var$xg) {
        $d3093f2493aa17fd$var$zg = !0;
        var a = 0, b = $d3093f2493aa17fd$var$E;
        try {
            var c = $d3093f2493aa17fd$var$xg;
            for($d3093f2493aa17fd$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $d3093f2493aa17fd$var$xg = null;
            $d3093f2493aa17fd$var$yg = !1;
        } catch (e) {
            throw null !== $d3093f2493aa17fd$var$xg && ($d3093f2493aa17fd$var$xg = $d3093f2493aa17fd$var$xg.slice(a + 1)), $d3093f2493aa17fd$var$ac($d3093f2493aa17fd$var$fc, $d3093f2493aa17fd$var$Cg), e;
        } finally{
            $d3093f2493aa17fd$var$E = b, $d3093f2493aa17fd$var$zg = !1;
        }
    }
    return null;
}
var $d3093f2493aa17fd$var$Dg = [], $d3093f2493aa17fd$var$Eg = 0, $d3093f2493aa17fd$var$Fg = null, $d3093f2493aa17fd$var$Gg = 0, $d3093f2493aa17fd$var$Hg = [], $d3093f2493aa17fd$var$Ig = 0, $d3093f2493aa17fd$var$Jg = null, $d3093f2493aa17fd$var$Kg = 1, $d3093f2493aa17fd$var$Lg = "";
function $d3093f2493aa17fd$var$Mg(a, b) {
    $d3093f2493aa17fd$var$Dg[$d3093f2493aa17fd$var$Eg++] = $d3093f2493aa17fd$var$Gg;
    $d3093f2493aa17fd$var$Dg[$d3093f2493aa17fd$var$Eg++] = $d3093f2493aa17fd$var$Fg;
    $d3093f2493aa17fd$var$Fg = a;
    $d3093f2493aa17fd$var$Gg = b;
}
function $d3093f2493aa17fd$var$Ng(a, b, c) {
    $d3093f2493aa17fd$var$Hg[$d3093f2493aa17fd$var$Ig++] = $d3093f2493aa17fd$var$Kg;
    $d3093f2493aa17fd$var$Hg[$d3093f2493aa17fd$var$Ig++] = $d3093f2493aa17fd$var$Lg;
    $d3093f2493aa17fd$var$Hg[$d3093f2493aa17fd$var$Ig++] = $d3093f2493aa17fd$var$Jg;
    $d3093f2493aa17fd$var$Jg = a;
    var d = $d3093f2493aa17fd$var$Kg;
    a = $d3093f2493aa17fd$var$Lg;
    var e = 32 - $d3093f2493aa17fd$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $d3093f2493aa17fd$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $d3093f2493aa17fd$var$Kg = 1 << 32 - $d3093f2493aa17fd$var$Ac(b) + e | c << e | d;
        $d3093f2493aa17fd$var$Lg = f + a;
    } else $d3093f2493aa17fd$var$Kg = 1 << f | c << e | d, $d3093f2493aa17fd$var$Lg = a;
}
function $d3093f2493aa17fd$var$Og(a) {
    null !== a.return && ($d3093f2493aa17fd$var$Mg(a, 1), $d3093f2493aa17fd$var$Ng(a, 1, 0));
}
function $d3093f2493aa17fd$var$Pg(a) {
    for(; a === $d3093f2493aa17fd$var$Fg;)$d3093f2493aa17fd$var$Fg = $d3093f2493aa17fd$var$Dg[--$d3093f2493aa17fd$var$Eg], $d3093f2493aa17fd$var$Dg[$d3093f2493aa17fd$var$Eg] = null, $d3093f2493aa17fd$var$Gg = $d3093f2493aa17fd$var$Dg[--$d3093f2493aa17fd$var$Eg], $d3093f2493aa17fd$var$Dg[$d3093f2493aa17fd$var$Eg] = null;
    for(; a === $d3093f2493aa17fd$var$Jg;)$d3093f2493aa17fd$var$Jg = $d3093f2493aa17fd$var$Hg[--$d3093f2493aa17fd$var$Ig], $d3093f2493aa17fd$var$Hg[$d3093f2493aa17fd$var$Ig] = null, $d3093f2493aa17fd$var$Lg = $d3093f2493aa17fd$var$Hg[--$d3093f2493aa17fd$var$Ig], $d3093f2493aa17fd$var$Hg[$d3093f2493aa17fd$var$Ig] = null, $d3093f2493aa17fd$var$Kg = $d3093f2493aa17fd$var$Hg[--$d3093f2493aa17fd$var$Ig], $d3093f2493aa17fd$var$Hg[$d3093f2493aa17fd$var$Ig] = null;
}
var $d3093f2493aa17fd$var$J = null, $d3093f2493aa17fd$var$Qg = null, $d3093f2493aa17fd$var$K = !1, $d3093f2493aa17fd$var$Rg = !1, $d3093f2493aa17fd$var$Sg = null;
function $d3093f2493aa17fd$var$Tg(a, b) {
    switch(a.tag){
        case 3:
            a = a.stateNode.containerInfo;
            1 === b.nodeType ? $d3093f2493aa17fd$var$Rf(a, b) : 8 !== b.nodeType && $d3093f2493aa17fd$var$Sf(a, b);
            break;
        case 13:
            a = a.memoizedState, null !== a.dehydrated && (a = a.dehydrated.parentNode, null !== a && (1 === b.nodeType ? $d3093f2493aa17fd$var$Rf(a, b) : 8 !== b.nodeType && $d3093f2493aa17fd$var$Sf(a, b)));
    }
}
function $d3093f2493aa17fd$var$Ug(a, b) {
    $d3093f2493aa17fd$var$Tg(a, b);
    var c = $d3093f2493aa17fd$var$Vg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $d3093f2493aa17fd$var$Wg(a, b) {
    if (!$d3093f2493aa17fd$var$Rg) switch(a.tag){
        case 3:
            a = a.stateNode.containerInfo;
            switch(b.tag){
                case 5:
                    $d3093f2493aa17fd$var$Tf(a, b.type);
                    break;
                case 6:
                    $d3093f2493aa17fd$var$Uf(a, b.pendingProps);
            }
            break;
        case 5:
            var c = a.memoizedProps, d = a.stateNode;
            switch(b.tag){
                case 5:
                    b = b.type;
                    0 === (a.mode & 1) && !0 === c.suppressHydrationWarning || $d3093f2493aa17fd$var$Tf(d, b);
                    break;
                case 6:
                    b = b.pendingProps, 0 === (a.mode & 1) && !0 === c.suppressHydrationWarning || $d3093f2493aa17fd$var$Uf(d, b);
            }
            break;
        case 13:
            if (a = a.memoizedState.dehydrated, null !== a) switch(b.tag){
                case 5:
                    b = b.type;
                    a = a.parentNode;
                    null !== a && $d3093f2493aa17fd$var$Tf(a, b);
                    break;
                case 6:
                    b = b.pendingProps, a = a.parentNode, null !== a && $d3093f2493aa17fd$var$Uf(a, b);
            }
    }
}
function $d3093f2493aa17fd$var$Xg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $d3093f2493aa17fd$var$J = a, $d3093f2493aa17fd$var$Qg = $d3093f2493aa17fd$var$dg(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $d3093f2493aa17fd$var$J = a, $d3093f2493aa17fd$var$Qg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $d3093f2493aa17fd$var$Jg ? {
                id: $d3093f2493aa17fd$var$Kg,
                overflow: $d3093f2493aa17fd$var$Lg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $d3093f2493aa17fd$var$Vg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $d3093f2493aa17fd$var$J = a, $d3093f2493aa17fd$var$Qg = null, !0) : !1;
        default:
            return !1;
    }
}
function $d3093f2493aa17fd$var$Yg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $d3093f2493aa17fd$var$Zg(a) {
    if ($d3093f2493aa17fd$var$K) {
        var b = $d3093f2493aa17fd$var$Qg;
        if (b) {
            var c = b;
            if (!$d3093f2493aa17fd$var$Xg(a, b)) {
                if ($d3093f2493aa17fd$var$Yg(a)) throw $d3093f2493aa17fd$var$Wg($d3093f2493aa17fd$var$J, a), Error($d3093f2493aa17fd$var$p(418));
                b = $d3093f2493aa17fd$var$dg(c.nextSibling);
                var d = $d3093f2493aa17fd$var$J;
                b && $d3093f2493aa17fd$var$Xg(a, b) ? $d3093f2493aa17fd$var$Ug(d, c) : (b = $d3093f2493aa17fd$var$J, a.flags = a.flags & -4097 | 2, $d3093f2493aa17fd$var$Wg(b, a), $d3093f2493aa17fd$var$K = !1, $d3093f2493aa17fd$var$J = a);
            }
        } else {
            if ($d3093f2493aa17fd$var$Yg(a)) throw $d3093f2493aa17fd$var$Wg($d3093f2493aa17fd$var$J, a), Error($d3093f2493aa17fd$var$p(418));
            b = $d3093f2493aa17fd$var$J;
            a.flags = a.flags & -4097 | 2;
            $d3093f2493aa17fd$var$Wg(b, a);
            $d3093f2493aa17fd$var$K = !1;
            $d3093f2493aa17fd$var$J = a;
        }
    }
}
function $d3093f2493aa17fd$var$$g(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $d3093f2493aa17fd$var$J = a;
}
function $d3093f2493aa17fd$var$ah(a) {
    if (a !== $d3093f2493aa17fd$var$J) return !1;
    if (!$d3093f2493aa17fd$var$K) return $d3093f2493aa17fd$var$$g(a), $d3093f2493aa17fd$var$K = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$d3093f2493aa17fd$var$Xf(a.type, a.memoizedProps));
    if (b && (b = $d3093f2493aa17fd$var$Qg)) {
        if ($d3093f2493aa17fd$var$Yg(a)) throw $d3093f2493aa17fd$var$bh(a), Error($d3093f2493aa17fd$var$p(418));
        for(; b;)$d3093f2493aa17fd$var$Ug(a, b), b = $d3093f2493aa17fd$var$dg(b.nextSibling);
    }
    $d3093f2493aa17fd$var$$g(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($d3093f2493aa17fd$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $d3093f2493aa17fd$var$Qg = $d3093f2493aa17fd$var$dg(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $d3093f2493aa17fd$var$Qg = null;
        }
    } else $d3093f2493aa17fd$var$Qg = $d3093f2493aa17fd$var$J ? $d3093f2493aa17fd$var$dg(a.stateNode.nextSibling) : null;
    return !0;
}
function $d3093f2493aa17fd$var$bh(a) {
    for(var b = $d3093f2493aa17fd$var$Qg; b;)$d3093f2493aa17fd$var$Tg(a, b), b = $d3093f2493aa17fd$var$dg(b.nextSibling);
}
function $d3093f2493aa17fd$var$ch() {
    $d3093f2493aa17fd$var$Qg = $d3093f2493aa17fd$var$J = null;
    $d3093f2493aa17fd$var$Rg = $d3093f2493aa17fd$var$K = !1;
}
function $d3093f2493aa17fd$var$dh(a) {
    null === $d3093f2493aa17fd$var$Sg ? $d3093f2493aa17fd$var$Sg = [
        a
    ] : $d3093f2493aa17fd$var$Sg.push(a);
}
var $d3093f2493aa17fd$var$eh = $d3093f2493aa17fd$var$va.ReactCurrentBatchConfig;
function $d3093f2493aa17fd$var$fh(a, b) {
    if (a && a.defaultProps) {
        b = $d3093f2493aa17fd$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $d3093f2493aa17fd$var$gh = $d3093f2493aa17fd$var$mg(null), $d3093f2493aa17fd$var$hh = null, $d3093f2493aa17fd$var$ih = null, $d3093f2493aa17fd$var$jh = null;
function $d3093f2493aa17fd$var$kh() {
    $d3093f2493aa17fd$var$jh = $d3093f2493aa17fd$var$ih = $d3093f2493aa17fd$var$hh = null;
}
function $d3093f2493aa17fd$var$lh(a) {
    var b = $d3093f2493aa17fd$var$gh.current;
    $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$gh);
    a._currentValue = b;
}
function $d3093f2493aa17fd$var$mh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $d3093f2493aa17fd$var$nh(a, b) {
    $d3093f2493aa17fd$var$hh = a;
    $d3093f2493aa17fd$var$jh = $d3093f2493aa17fd$var$ih = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($d3093f2493aa17fd$var$oh = !0), a.firstContext = null);
}
function $d3093f2493aa17fd$var$ph(a) {
    var b = a._currentValue;
    if ($d3093f2493aa17fd$var$jh !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $d3093f2493aa17fd$var$ih) {
            if (null === $d3093f2493aa17fd$var$hh) throw Error($d3093f2493aa17fd$var$p(308));
            $d3093f2493aa17fd$var$ih = a;
            $d3093f2493aa17fd$var$hh.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $d3093f2493aa17fd$var$ih = $d3093f2493aa17fd$var$ih.next = a;
    }
    return b;
}
var $d3093f2493aa17fd$var$qh = null;
function $d3093f2493aa17fd$var$rh(a) {
    null === $d3093f2493aa17fd$var$qh ? $d3093f2493aa17fd$var$qh = [
        a
    ] : $d3093f2493aa17fd$var$qh.push(a);
}
function $d3093f2493aa17fd$var$sh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $d3093f2493aa17fd$var$rh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $d3093f2493aa17fd$var$th(a, d);
}
function $d3093f2493aa17fd$var$th(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $d3093f2493aa17fd$var$uh = !1;
function $d3093f2493aa17fd$var$vh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $d3093f2493aa17fd$var$wh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $d3093f2493aa17fd$var$xh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $d3093f2493aa17fd$var$yh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($d3093f2493aa17fd$var$L & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $d3093f2493aa17fd$var$th(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $d3093f2493aa17fd$var$rh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $d3093f2493aa17fd$var$th(a, c);
}
function $d3093f2493aa17fd$var$zh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $d3093f2493aa17fd$var$Oc(a, c);
    }
}
function $d3093f2493aa17fd$var$Ah(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $d3093f2493aa17fd$var$Bh(a, b, c, d) {
    var e = a.updateQueue;
    $d3093f2493aa17fd$var$uh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $d3093f2493aa17fd$var$u({}, q, r);
                            break a;
                        case 2:
                            $d3093f2493aa17fd$var$uh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $d3093f2493aa17fd$var$Ch |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $d3093f2493aa17fd$var$Dh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($d3093f2493aa17fd$var$p(191, e));
            e.call(d);
        }
    }
}
var $d3093f2493aa17fd$var$Eh = (new $42omo.Component).refs;
function $d3093f2493aa17fd$var$Fh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $d3093f2493aa17fd$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $d3093f2493aa17fd$var$Jh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $d3093f2493aa17fd$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $d3093f2493aa17fd$var$Gh(), e = $d3093f2493aa17fd$var$Hh(a), f = $d3093f2493aa17fd$var$xh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $d3093f2493aa17fd$var$yh(a, f, e);
        null !== b && ($d3093f2493aa17fd$var$Ih(b, a, e, d), $d3093f2493aa17fd$var$zh(b, a, e));
        $d3093f2493aa17fd$var$yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $d3093f2493aa17fd$var$Gh(), e = $d3093f2493aa17fd$var$Hh(a), f = $d3093f2493aa17fd$var$xh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $d3093f2493aa17fd$var$yh(a, f, e);
        null !== b && ($d3093f2493aa17fd$var$Ih(b, a, e, d), $d3093f2493aa17fd$var$zh(b, a, e));
        $d3093f2493aa17fd$var$yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $d3093f2493aa17fd$var$Gh(), d = $d3093f2493aa17fd$var$Hh(a), e = $d3093f2493aa17fd$var$xh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $d3093f2493aa17fd$var$yh(a, e, d);
        null !== b && ($d3093f2493aa17fd$var$Ih(b, a, d, c), $d3093f2493aa17fd$var$zh(b, a, d));
        null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markForceUpdateScheduled && $d3093f2493aa17fd$var$B.markForceUpdateScheduled(a, d);
    }
};
function $d3093f2493aa17fd$var$Kh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$d3093f2493aa17fd$var$We(c, d) || !$d3093f2493aa17fd$var$We(e, f) : !0;
}
function $d3093f2493aa17fd$var$Lh(a, b, c) {
    var d = !1, e = $d3093f2493aa17fd$var$ng;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $d3093f2493aa17fd$var$ph(f) : (e = $d3093f2493aa17fd$var$rg(b) ? $d3093f2493aa17fd$var$pg : $d3093f2493aa17fd$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $d3093f2493aa17fd$var$qg(a, e) : $d3093f2493aa17fd$var$ng);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $d3093f2493aa17fd$var$Jh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $d3093f2493aa17fd$var$Mh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $d3093f2493aa17fd$var$Jh.enqueueReplaceState(b, b.state, null);
}
function $d3093f2493aa17fd$var$Nh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $d3093f2493aa17fd$var$Eh;
    $d3093f2493aa17fd$var$vh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $d3093f2493aa17fd$var$ph(f) : (f = $d3093f2493aa17fd$var$rg(b) ? $d3093f2493aa17fd$var$pg : $d3093f2493aa17fd$var$I.current, e.context = $d3093f2493aa17fd$var$qg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($d3093f2493aa17fd$var$Fh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $d3093f2493aa17fd$var$Jh.enqueueReplaceState(e, e.state, null), $d3093f2493aa17fd$var$Bh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $d3093f2493aa17fd$var$Oh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($d3093f2493aa17fd$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($d3093f2493aa17fd$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $d3093f2493aa17fd$var$Eh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($d3093f2493aa17fd$var$p(284));
        if (!c._owner) throw Error($d3093f2493aa17fd$var$p(290, a));
    }
    return a;
}
function $d3093f2493aa17fd$var$Ph(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($d3093f2493aa17fd$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $d3093f2493aa17fd$var$Qh(a) {
    var b = a._init;
    return b(a._payload);
}
function $d3093f2493aa17fd$var$Rh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $d3093f2493aa17fd$var$Sh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $d3093f2493aa17fd$var$Th(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $d3093f2493aa17fd$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $d3093f2493aa17fd$var$Ha && $d3093f2493aa17fd$var$Qh(f) === b.type)) return d = e(b, c.props), d.ref = $d3093f2493aa17fd$var$Oh(a, b, c), d.return = a, d;
        d = $d3093f2493aa17fd$var$Uh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $d3093f2493aa17fd$var$Oh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $d3093f2493aa17fd$var$Vh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $d3093f2493aa17fd$var$Wh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $d3093f2493aa17fd$var$Th("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $d3093f2493aa17fd$var$wa:
                    return c = $d3093f2493aa17fd$var$Uh(b.type, b.key, b.props, null, a.mode, c), c.ref = $d3093f2493aa17fd$var$Oh(a, null, b), c.return = a, c;
                case $d3093f2493aa17fd$var$xa:
                    return b = $d3093f2493aa17fd$var$Vh(b, a.mode, c), b.return = a, b;
                case $d3093f2493aa17fd$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($d3093f2493aa17fd$var$db(b) || $d3093f2493aa17fd$var$Ka(b)) return b = $d3093f2493aa17fd$var$Wh(b, a.mode, c, null), b.return = a, b;
            $d3093f2493aa17fd$var$Ph(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $d3093f2493aa17fd$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $d3093f2493aa17fd$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $d3093f2493aa17fd$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($d3093f2493aa17fd$var$db(c) || $d3093f2493aa17fd$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $d3093f2493aa17fd$var$Ph(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $d3093f2493aa17fd$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $d3093f2493aa17fd$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $d3093f2493aa17fd$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($d3093f2493aa17fd$var$db(d) || $d3093f2493aa17fd$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $d3093f2493aa17fd$var$Ph(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $d3093f2493aa17fd$var$K && $d3093f2493aa17fd$var$Mg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $d3093f2493aa17fd$var$K && $d3093f2493aa17fd$var$Mg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $d3093f2493aa17fd$var$K && $d3093f2493aa17fd$var$Mg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $d3093f2493aa17fd$var$Ka(h);
        if ("function" !== typeof l) throw Error($d3093f2493aa17fd$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($d3093f2493aa17fd$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $d3093f2493aa17fd$var$K && $d3093f2493aa17fd$var$Mg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $d3093f2493aa17fd$var$K && $d3093f2493aa17fd$var$Mg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $d3093f2493aa17fd$var$K && $d3093f2493aa17fd$var$Mg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $d3093f2493aa17fd$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $d3093f2493aa17fd$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $d3093f2493aa17fd$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $d3093f2493aa17fd$var$Ha && $d3093f2493aa17fd$var$Qh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $d3093f2493aa17fd$var$Oh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $d3093f2493aa17fd$var$ya ? (d = $d3093f2493aa17fd$var$Wh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $d3093f2493aa17fd$var$Uh(f.type, f.key, f.props, null, a.mode, h), h.ref = $d3093f2493aa17fd$var$Oh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $d3093f2493aa17fd$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $d3093f2493aa17fd$var$Vh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $d3093f2493aa17fd$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($d3093f2493aa17fd$var$db(f)) return m(a, d, f, h);
            if ($d3093f2493aa17fd$var$Ka(f)) return w(a, d, f, h);
            $d3093f2493aa17fd$var$Ph(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $d3093f2493aa17fd$var$Th(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $d3093f2493aa17fd$var$Xh = $d3093f2493aa17fd$var$Rh(!0), $d3093f2493aa17fd$var$Yh = $d3093f2493aa17fd$var$Rh(!1), $d3093f2493aa17fd$var$Zh = {}, $d3093f2493aa17fd$var$$h = $d3093f2493aa17fd$var$mg($d3093f2493aa17fd$var$Zh), $d3093f2493aa17fd$var$ai = $d3093f2493aa17fd$var$mg($d3093f2493aa17fd$var$Zh), $d3093f2493aa17fd$var$bi = $d3093f2493aa17fd$var$mg($d3093f2493aa17fd$var$Zh);
function $d3093f2493aa17fd$var$ci(a) {
    if (a === $d3093f2493aa17fd$var$Zh) throw Error($d3093f2493aa17fd$var$p(174));
    return a;
}
function $d3093f2493aa17fd$var$di(a, b) {
    $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$bi, b);
    $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$ai, a);
    $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$$h, $d3093f2493aa17fd$var$Zh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $d3093f2493aa17fd$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $d3093f2493aa17fd$var$kb(b, a);
    }
    $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$$h);
    $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$$h, b);
}
function $d3093f2493aa17fd$var$ei() {
    $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$$h);
    $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$ai);
    $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$bi);
}
function $d3093f2493aa17fd$var$fi(a) {
    $d3093f2493aa17fd$var$ci($d3093f2493aa17fd$var$bi.current);
    var b = $d3093f2493aa17fd$var$ci($d3093f2493aa17fd$var$$h.current);
    var c = $d3093f2493aa17fd$var$kb(b, a.type);
    b !== c && ($d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$ai, a), $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$$h, c));
}
function $d3093f2493aa17fd$var$gi(a) {
    $d3093f2493aa17fd$var$ai.current === a && ($d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$$h), $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$ai));
}
var $d3093f2493aa17fd$var$M = $d3093f2493aa17fd$var$mg(0);
function $d3093f2493aa17fd$var$hi(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $d3093f2493aa17fd$var$ii = [];
function $d3093f2493aa17fd$var$ji() {
    for(var a = 0; a < $d3093f2493aa17fd$var$ii.length; a++)$d3093f2493aa17fd$var$ii[a]._workInProgressVersionPrimary = null;
    $d3093f2493aa17fd$var$ii.length = 0;
}
var $d3093f2493aa17fd$var$ki = $d3093f2493aa17fd$var$va.ReactCurrentDispatcher, $d3093f2493aa17fd$var$li = $d3093f2493aa17fd$var$va.ReactCurrentBatchConfig, $d3093f2493aa17fd$var$mi = 0, $d3093f2493aa17fd$var$N = null, $d3093f2493aa17fd$var$O = null, $d3093f2493aa17fd$var$P = null, $d3093f2493aa17fd$var$ni = !1, $d3093f2493aa17fd$var$oi = !1, $d3093f2493aa17fd$var$pi = 0, $d3093f2493aa17fd$var$qi = 0;
function $d3093f2493aa17fd$var$ri() {
    throw Error($d3093f2493aa17fd$var$p(321));
}
function $d3093f2493aa17fd$var$si(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$d3093f2493aa17fd$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $d3093f2493aa17fd$var$ti(a, b, c, d, e, f) {
    $d3093f2493aa17fd$var$mi = f;
    $d3093f2493aa17fd$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $d3093f2493aa17fd$var$ki.current = null === a || null === a.memoizedState ? $d3093f2493aa17fd$var$ui : $d3093f2493aa17fd$var$vi;
    a = c(d, e);
    if ($d3093f2493aa17fd$var$oi) {
        f = 0;
        do {
            $d3093f2493aa17fd$var$oi = !1;
            $d3093f2493aa17fd$var$pi = 0;
            if (25 <= f) throw Error($d3093f2493aa17fd$var$p(301));
            f += 1;
            $d3093f2493aa17fd$var$P = $d3093f2493aa17fd$var$O = null;
            b.updateQueue = null;
            $d3093f2493aa17fd$var$ki.current = $d3093f2493aa17fd$var$wi;
            a = c(d, e);
        }while ($d3093f2493aa17fd$var$oi);
    }
    $d3093f2493aa17fd$var$ki.current = $d3093f2493aa17fd$var$xi;
    b = null !== $d3093f2493aa17fd$var$O && null !== $d3093f2493aa17fd$var$O.next;
    $d3093f2493aa17fd$var$mi = 0;
    $d3093f2493aa17fd$var$P = $d3093f2493aa17fd$var$O = $d3093f2493aa17fd$var$N = null;
    $d3093f2493aa17fd$var$ni = !1;
    if (b) throw Error($d3093f2493aa17fd$var$p(300));
    return a;
}
function $d3093f2493aa17fd$var$yi() {
    var a = 0 !== $d3093f2493aa17fd$var$pi;
    $d3093f2493aa17fd$var$pi = 0;
    return a;
}
function $d3093f2493aa17fd$var$zi() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $d3093f2493aa17fd$var$P ? $d3093f2493aa17fd$var$N.memoizedState = $d3093f2493aa17fd$var$P = a : $d3093f2493aa17fd$var$P = $d3093f2493aa17fd$var$P.next = a;
    return $d3093f2493aa17fd$var$P;
}
function $d3093f2493aa17fd$var$Ai() {
    if (null === $d3093f2493aa17fd$var$O) {
        var a = $d3093f2493aa17fd$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $d3093f2493aa17fd$var$O.next;
    var b = null === $d3093f2493aa17fd$var$P ? $d3093f2493aa17fd$var$N.memoizedState : $d3093f2493aa17fd$var$P.next;
    if (null !== b) $d3093f2493aa17fd$var$P = b, $d3093f2493aa17fd$var$O = a;
    else {
        if (null === a) throw Error($d3093f2493aa17fd$var$p(310));
        $d3093f2493aa17fd$var$O = a;
        a = {
            memoizedState: $d3093f2493aa17fd$var$O.memoizedState,
            baseState: $d3093f2493aa17fd$var$O.baseState,
            baseQueue: $d3093f2493aa17fd$var$O.baseQueue,
            queue: $d3093f2493aa17fd$var$O.queue,
            next: null
        };
        null === $d3093f2493aa17fd$var$P ? $d3093f2493aa17fd$var$N.memoizedState = $d3093f2493aa17fd$var$P = a : $d3093f2493aa17fd$var$P = $d3093f2493aa17fd$var$P.next = a;
    }
    return $d3093f2493aa17fd$var$P;
}
function $d3093f2493aa17fd$var$Bi(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $d3093f2493aa17fd$var$Ci(a) {
    var b = $d3093f2493aa17fd$var$Ai(), c = b.queue;
    if (null === c) throw Error($d3093f2493aa17fd$var$p(311));
    c.lastRenderedReducer = a;
    var d = $d3093f2493aa17fd$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($d3093f2493aa17fd$var$mi & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $d3093f2493aa17fd$var$N.lanes |= n;
                $d3093f2493aa17fd$var$Ch |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $d3093f2493aa17fd$var$Ve(d, b.memoizedState) || ($d3093f2493aa17fd$var$oh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $d3093f2493aa17fd$var$N.lanes |= f, $d3093f2493aa17fd$var$Ch |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $d3093f2493aa17fd$var$Di(a) {
    var b = $d3093f2493aa17fd$var$Ai(), c = b.queue;
    if (null === c) throw Error($d3093f2493aa17fd$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $d3093f2493aa17fd$var$Ve(f, b.memoizedState) || ($d3093f2493aa17fd$var$oh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $d3093f2493aa17fd$var$Ei() {}
function $d3093f2493aa17fd$var$Fi(a, b) {
    var c = $d3093f2493aa17fd$var$N, d = $d3093f2493aa17fd$var$Ai(), e = b(), f = !$d3093f2493aa17fd$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $d3093f2493aa17fd$var$oh = !0);
    d = d.queue;
    $d3093f2493aa17fd$var$Gi($d3093f2493aa17fd$var$Hi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $d3093f2493aa17fd$var$P && $d3093f2493aa17fd$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $d3093f2493aa17fd$var$Ii(9, $d3093f2493aa17fd$var$Ji.bind(null, c, d, e, b), void 0, null);
        if (null === $d3093f2493aa17fd$var$Q) throw Error($d3093f2493aa17fd$var$p(349));
        0 !== ($d3093f2493aa17fd$var$mi & 30) || $d3093f2493aa17fd$var$Ki(c, b, e);
    }
    return e;
}
function $d3093f2493aa17fd$var$Ki(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $d3093f2493aa17fd$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $d3093f2493aa17fd$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $d3093f2493aa17fd$var$Ji(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $d3093f2493aa17fd$var$Li(b) && $d3093f2493aa17fd$var$Mi(a);
}
function $d3093f2493aa17fd$var$Hi(a, b, c) {
    return c(function() {
        $d3093f2493aa17fd$var$Li(b) && $d3093f2493aa17fd$var$Mi(a);
    });
}
function $d3093f2493aa17fd$var$Li(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$d3093f2493aa17fd$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $d3093f2493aa17fd$var$Mi(a) {
    var b = $d3093f2493aa17fd$var$th(a, 1);
    null !== b && $d3093f2493aa17fd$var$Ih(b, a, 1, -1);
}
function $d3093f2493aa17fd$var$Ni(a) {
    var b = $d3093f2493aa17fd$var$zi();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $d3093f2493aa17fd$var$Bi,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $d3093f2493aa17fd$var$Oi.bind(null, $d3093f2493aa17fd$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $d3093f2493aa17fd$var$Ii(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $d3093f2493aa17fd$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $d3093f2493aa17fd$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $d3093f2493aa17fd$var$Ri() {
    return $d3093f2493aa17fd$var$Ai().memoizedState;
}
function $d3093f2493aa17fd$var$Si(a, b, c, d) {
    var e = $d3093f2493aa17fd$var$zi();
    $d3093f2493aa17fd$var$N.flags |= a;
    e.memoizedState = $d3093f2493aa17fd$var$Ii(1 | b, c, void 0, void 0 === d ? null : d);
}
function $d3093f2493aa17fd$var$Ti(a, b, c, d) {
    var e = $d3093f2493aa17fd$var$Ai();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $d3093f2493aa17fd$var$O) {
        var g = $d3093f2493aa17fd$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $d3093f2493aa17fd$var$si(d, g.deps)) {
            e.memoizedState = $d3093f2493aa17fd$var$Ii(b, c, f, d);
            return;
        }
    }
    $d3093f2493aa17fd$var$N.flags |= a;
    e.memoizedState = $d3093f2493aa17fd$var$Ii(1 | b, c, f, d);
}
function $d3093f2493aa17fd$var$Ui(a, b) {
    return $d3093f2493aa17fd$var$Si(8390656, 8, a, b);
}
function $d3093f2493aa17fd$var$Gi(a, b) {
    return $d3093f2493aa17fd$var$Ti(2048, 8, a, b);
}
function $d3093f2493aa17fd$var$Vi(a, b) {
    return $d3093f2493aa17fd$var$Ti(4, 2, a, b);
}
function $d3093f2493aa17fd$var$Wi(a, b) {
    return $d3093f2493aa17fd$var$Ti(4, 4, a, b);
}
function $d3093f2493aa17fd$var$Xi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $d3093f2493aa17fd$var$Yi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $d3093f2493aa17fd$var$Ti(4, 4, $d3093f2493aa17fd$var$Xi.bind(null, b, a), c);
}
function $d3093f2493aa17fd$var$Zi() {}
function $d3093f2493aa17fd$var$$i(a, b) {
    var c = $d3093f2493aa17fd$var$Ai();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $d3093f2493aa17fd$var$si(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $d3093f2493aa17fd$var$aj(a, b) {
    var c = $d3093f2493aa17fd$var$Ai();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $d3093f2493aa17fd$var$si(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $d3093f2493aa17fd$var$bj(a, b, c) {
    if (0 === ($d3093f2493aa17fd$var$mi & 21)) return a.baseState && (a.baseState = !1, $d3093f2493aa17fd$var$oh = !0), a.memoizedState = c;
    $d3093f2493aa17fd$var$Ve(c, b) || (c = $d3093f2493aa17fd$var$Kc(), $d3093f2493aa17fd$var$N.lanes |= c, $d3093f2493aa17fd$var$Ch |= c, a.baseState = !0);
    return b;
}
function $d3093f2493aa17fd$var$cj(a, b) {
    var c = $d3093f2493aa17fd$var$E;
    $d3093f2493aa17fd$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $d3093f2493aa17fd$var$li.transition;
    $d3093f2493aa17fd$var$li.transition = {};
    try {
        a(!1), b();
    } finally{
        $d3093f2493aa17fd$var$E = c, $d3093f2493aa17fd$var$li.transition = d;
    }
}
function $d3093f2493aa17fd$var$dj() {
    return $d3093f2493aa17fd$var$Ai().memoizedState;
}
function $d3093f2493aa17fd$var$ej(a, b, c) {
    var d = $d3093f2493aa17fd$var$Hh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($d3093f2493aa17fd$var$fj(a)) $d3093f2493aa17fd$var$gj(b, c);
    else if (c = $d3093f2493aa17fd$var$sh(a, b, c, d), null !== c) {
        var e = $d3093f2493aa17fd$var$Gh();
        $d3093f2493aa17fd$var$Ih(c, a, d, e);
        $d3093f2493aa17fd$var$hj(c, b, d);
    }
    $d3093f2493aa17fd$var$yc(a, d);
}
function $d3093f2493aa17fd$var$Oi(a, b, c) {
    var d = $d3093f2493aa17fd$var$Hh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($d3093f2493aa17fd$var$fj(a)) $d3093f2493aa17fd$var$gj(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($d3093f2493aa17fd$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $d3093f2493aa17fd$var$rh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $d3093f2493aa17fd$var$sh(a, b, e, d);
        null !== c && (e = $d3093f2493aa17fd$var$Gh(), $d3093f2493aa17fd$var$Ih(c, a, d, e), $d3093f2493aa17fd$var$hj(c, b, d));
    }
    $d3093f2493aa17fd$var$yc(a, d);
}
function $d3093f2493aa17fd$var$fj(a) {
    var b = a.alternate;
    return a === $d3093f2493aa17fd$var$N || null !== b && b === $d3093f2493aa17fd$var$N;
}
function $d3093f2493aa17fd$var$gj(a, b) {
    $d3093f2493aa17fd$var$oi = $d3093f2493aa17fd$var$ni = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $d3093f2493aa17fd$var$hj(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $d3093f2493aa17fd$var$Oc(a, c);
    }
}
var $d3093f2493aa17fd$var$xi = {
    readContext: $d3093f2493aa17fd$var$ph,
    useCallback: $d3093f2493aa17fd$var$ri,
    useContext: $d3093f2493aa17fd$var$ri,
    useEffect: $d3093f2493aa17fd$var$ri,
    useImperativeHandle: $d3093f2493aa17fd$var$ri,
    useInsertionEffect: $d3093f2493aa17fd$var$ri,
    useLayoutEffect: $d3093f2493aa17fd$var$ri,
    useMemo: $d3093f2493aa17fd$var$ri,
    useReducer: $d3093f2493aa17fd$var$ri,
    useRef: $d3093f2493aa17fd$var$ri,
    useState: $d3093f2493aa17fd$var$ri,
    useDebugValue: $d3093f2493aa17fd$var$ri,
    useDeferredValue: $d3093f2493aa17fd$var$ri,
    useTransition: $d3093f2493aa17fd$var$ri,
    useMutableSource: $d3093f2493aa17fd$var$ri,
    useSyncExternalStore: $d3093f2493aa17fd$var$ri,
    useId: $d3093f2493aa17fd$var$ri,
    unstable_isNewReconciler: !1
}, $d3093f2493aa17fd$var$ui = {
    readContext: $d3093f2493aa17fd$var$ph,
    useCallback: function(a, b) {
        $d3093f2493aa17fd$var$zi().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $d3093f2493aa17fd$var$ph,
    useEffect: $d3093f2493aa17fd$var$Ui,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $d3093f2493aa17fd$var$Si(4194308, 4, $d3093f2493aa17fd$var$Xi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $d3093f2493aa17fd$var$Si(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $d3093f2493aa17fd$var$Si(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $d3093f2493aa17fd$var$zi();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $d3093f2493aa17fd$var$zi();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $d3093f2493aa17fd$var$ej.bind(null, $d3093f2493aa17fd$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $d3093f2493aa17fd$var$zi();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $d3093f2493aa17fd$var$Ni,
    useDebugValue: $d3093f2493aa17fd$var$Zi,
    useDeferredValue: function(a) {
        return $d3093f2493aa17fd$var$zi().memoizedState = a;
    },
    useTransition: function() {
        var a = $d3093f2493aa17fd$var$Ni(!1), b = a[0];
        a = $d3093f2493aa17fd$var$cj.bind(null, a[1]);
        $d3093f2493aa17fd$var$zi().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $d3093f2493aa17fd$var$N, e = $d3093f2493aa17fd$var$zi();
        if ($d3093f2493aa17fd$var$K) {
            if (void 0 === c) throw Error($d3093f2493aa17fd$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $d3093f2493aa17fd$var$Q) throw Error($d3093f2493aa17fd$var$p(349));
            0 !== ($d3093f2493aa17fd$var$mi & 30) || $d3093f2493aa17fd$var$Ki(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $d3093f2493aa17fd$var$Ui($d3093f2493aa17fd$var$Hi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $d3093f2493aa17fd$var$Ii(9, $d3093f2493aa17fd$var$Ji.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $d3093f2493aa17fd$var$zi(), b = $d3093f2493aa17fd$var$Q.identifierPrefix;
        if ($d3093f2493aa17fd$var$K) {
            var c = $d3093f2493aa17fd$var$Lg;
            var d = $d3093f2493aa17fd$var$Kg;
            c = (d & ~(1 << 32 - $d3093f2493aa17fd$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $d3093f2493aa17fd$var$pi++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $d3093f2493aa17fd$var$qi++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $d3093f2493aa17fd$var$vi = {
    readContext: $d3093f2493aa17fd$var$ph,
    useCallback: $d3093f2493aa17fd$var$$i,
    useContext: $d3093f2493aa17fd$var$ph,
    useEffect: $d3093f2493aa17fd$var$Gi,
    useImperativeHandle: $d3093f2493aa17fd$var$Yi,
    useInsertionEffect: $d3093f2493aa17fd$var$Vi,
    useLayoutEffect: $d3093f2493aa17fd$var$Wi,
    useMemo: $d3093f2493aa17fd$var$aj,
    useReducer: $d3093f2493aa17fd$var$Ci,
    useRef: $d3093f2493aa17fd$var$Ri,
    useState: function() {
        return $d3093f2493aa17fd$var$Ci($d3093f2493aa17fd$var$Bi);
    },
    useDebugValue: $d3093f2493aa17fd$var$Zi,
    useDeferredValue: function(a) {
        var b = $d3093f2493aa17fd$var$Ai();
        return $d3093f2493aa17fd$var$bj(b, $d3093f2493aa17fd$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $d3093f2493aa17fd$var$Ci($d3093f2493aa17fd$var$Bi)[0], b = $d3093f2493aa17fd$var$Ai().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $d3093f2493aa17fd$var$Ei,
    useSyncExternalStore: $d3093f2493aa17fd$var$Fi,
    useId: $d3093f2493aa17fd$var$dj,
    unstable_isNewReconciler: !1
}, $d3093f2493aa17fd$var$wi = {
    readContext: $d3093f2493aa17fd$var$ph,
    useCallback: $d3093f2493aa17fd$var$$i,
    useContext: $d3093f2493aa17fd$var$ph,
    useEffect: $d3093f2493aa17fd$var$Gi,
    useImperativeHandle: $d3093f2493aa17fd$var$Yi,
    useInsertionEffect: $d3093f2493aa17fd$var$Vi,
    useLayoutEffect: $d3093f2493aa17fd$var$Wi,
    useMemo: $d3093f2493aa17fd$var$aj,
    useReducer: $d3093f2493aa17fd$var$Di,
    useRef: $d3093f2493aa17fd$var$Ri,
    useState: function() {
        return $d3093f2493aa17fd$var$Di($d3093f2493aa17fd$var$Bi);
    },
    useDebugValue: $d3093f2493aa17fd$var$Zi,
    useDeferredValue: function(a) {
        var b = $d3093f2493aa17fd$var$Ai();
        return null === $d3093f2493aa17fd$var$O ? b.memoizedState = a : $d3093f2493aa17fd$var$bj(b, $d3093f2493aa17fd$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $d3093f2493aa17fd$var$Di($d3093f2493aa17fd$var$Bi)[0], b = $d3093f2493aa17fd$var$Ai().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $d3093f2493aa17fd$var$Ei,
    useSyncExternalStore: $d3093f2493aa17fd$var$Fi,
    useId: $d3093f2493aa17fd$var$dj,
    unstable_isNewReconciler: !1
}, $d3093f2493aa17fd$var$ij = $eggFB.unstable_now, $d3093f2493aa17fd$var$jj = 0, $d3093f2493aa17fd$var$kj = -1, $d3093f2493aa17fd$var$lj = -1, $d3093f2493aa17fd$var$mj = -1, $d3093f2493aa17fd$var$nj = !1, $d3093f2493aa17fd$var$oj = !1;
function $d3093f2493aa17fd$var$pj(a, b) {
    if (0 <= $d3093f2493aa17fd$var$lj) {
        var c = $d3093f2493aa17fd$var$ij() - $d3093f2493aa17fd$var$lj;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $d3093f2493aa17fd$var$lj = -1;
    }
}
function $d3093f2493aa17fd$var$qj(a) {
    if (0 <= $d3093f2493aa17fd$var$kj) {
        var b = $d3093f2493aa17fd$var$ij() - $d3093f2493aa17fd$var$kj;
        $d3093f2493aa17fd$var$kj = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $d3093f2493aa17fd$var$rj(a) {
    if (0 <= $d3093f2493aa17fd$var$mj) {
        var b = $d3093f2493aa17fd$var$ij() - $d3093f2493aa17fd$var$mj;
        $d3093f2493aa17fd$var$mj = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $d3093f2493aa17fd$var$sj() {
    $d3093f2493aa17fd$var$kj = $d3093f2493aa17fd$var$ij();
}
function $d3093f2493aa17fd$var$tj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $d3093f2493aa17fd$var$uj(a, b) {
    try {
        var c = "", d = b;
        do c += $d3093f2493aa17fd$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $d3093f2493aa17fd$var$vj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $d3093f2493aa17fd$var$wj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $d3093f2493aa17fd$var$xj = "function" === typeof WeakMap ? WeakMap : Map;
function $d3093f2493aa17fd$var$yj(a, b, c) {
    c = $d3093f2493aa17fd$var$xh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $d3093f2493aa17fd$var$zj || ($d3093f2493aa17fd$var$zj = !0, $d3093f2493aa17fd$var$Aj = d);
        $d3093f2493aa17fd$var$wj(a, b);
    };
    return c;
}
function $d3093f2493aa17fd$var$Bj(a, b, c) {
    c = $d3093f2493aa17fd$var$xh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $d3093f2493aa17fd$var$wj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $d3093f2493aa17fd$var$wj(a, b);
        "function" !== typeof d && (null === $d3093f2493aa17fd$var$Cj ? $d3093f2493aa17fd$var$Cj = new Set([
            this
        ]) : $d3093f2493aa17fd$var$Cj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $d3093f2493aa17fd$var$Dj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $d3093f2493aa17fd$var$xj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $d3093f2493aa17fd$var$Ej.bind(null, a, b, c), $d3093f2493aa17fd$var$mc && $d3093f2493aa17fd$var$Fj(a, c), b.then(d, d));
}
function $d3093f2493aa17fd$var$Gj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $d3093f2493aa17fd$var$Hj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $d3093f2493aa17fd$var$xh(-1, 1), b.tag = 2, $d3093f2493aa17fd$var$yh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $d3093f2493aa17fd$var$Ij = $d3093f2493aa17fd$var$va.ReactCurrentOwner, $d3093f2493aa17fd$var$oh = !1;
function $d3093f2493aa17fd$var$Jj(a, b, c, d) {
    b.child = null === a ? $d3093f2493aa17fd$var$Yh(b, null, c, d) : $d3093f2493aa17fd$var$Xh(b, a.child, c, d);
}
function $d3093f2493aa17fd$var$Kj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $d3093f2493aa17fd$var$nh(b, e);
    $d3093f2493aa17fd$var$sc(b);
    d = $d3093f2493aa17fd$var$ti(a, b, c, d, f, e);
    c = $d3093f2493aa17fd$var$yi();
    $d3093f2493aa17fd$var$tc();
    if (null !== a && !$d3093f2493aa17fd$var$oh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $d3093f2493aa17fd$var$Lj(a, b, e);
    $d3093f2493aa17fd$var$K && c && $d3093f2493aa17fd$var$Og(b);
    b.flags |= 1;
    $d3093f2493aa17fd$var$Jj(a, b, d, e);
    return b.child;
}
function $d3093f2493aa17fd$var$Mj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$d3093f2493aa17fd$var$Nj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $d3093f2493aa17fd$var$Oj(a, b, f, d, e);
        a = $d3093f2493aa17fd$var$Uh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $d3093f2493aa17fd$var$We;
        if (c(g, d) && a.ref === b.ref) return $d3093f2493aa17fd$var$Lj(a, b, e);
    }
    b.flags |= 1;
    a = $d3093f2493aa17fd$var$Sh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $d3093f2493aa17fd$var$Oj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($d3093f2493aa17fd$var$We(f, d) && a.ref === b.ref) {
            if ($d3093f2493aa17fd$var$oh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($d3093f2493aa17fd$var$oh = !0);
            else return b.lanes = a.lanes, $d3093f2493aa17fd$var$Lj(a, b, e);
        }
    }
    return $d3093f2493aa17fd$var$Pj(a, b, c, d, e);
}
function $d3093f2493aa17fd$var$Qj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$Rj, $d3093f2493aa17fd$var$Sj), $d3093f2493aa17fd$var$Sj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$Rj, $d3093f2493aa17fd$var$Sj), $d3093f2493aa17fd$var$Sj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$Rj, $d3093f2493aa17fd$var$Sj);
            $d3093f2493aa17fd$var$Sj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$Rj, $d3093f2493aa17fd$var$Sj), $d3093f2493aa17fd$var$Sj |= d;
    $d3093f2493aa17fd$var$Jj(a, b, e, c);
    return b.child;
}
function $d3093f2493aa17fd$var$Tj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $d3093f2493aa17fd$var$Pj(a, b, c, d, e) {
    var f = $d3093f2493aa17fd$var$rg(c) ? $d3093f2493aa17fd$var$pg : $d3093f2493aa17fd$var$I.current;
    f = $d3093f2493aa17fd$var$qg(b, f);
    $d3093f2493aa17fd$var$nh(b, e);
    $d3093f2493aa17fd$var$sc(b);
    c = $d3093f2493aa17fd$var$ti(a, b, c, d, f, e);
    d = $d3093f2493aa17fd$var$yi();
    $d3093f2493aa17fd$var$tc();
    if (null !== a && !$d3093f2493aa17fd$var$oh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $d3093f2493aa17fd$var$Lj(a, b, e);
    $d3093f2493aa17fd$var$K && d && $d3093f2493aa17fd$var$Og(b);
    b.flags |= 1;
    $d3093f2493aa17fd$var$Jj(a, b, c, e);
    return b.child;
}
function $d3093f2493aa17fd$var$Uj(a, b, c, d, e) {
    if ($d3093f2493aa17fd$var$rg(c)) {
        var f = !0;
        $d3093f2493aa17fd$var$vg(b);
    } else f = !1;
    $d3093f2493aa17fd$var$nh(b, e);
    if (null === b.stateNode) $d3093f2493aa17fd$var$Vj(a, b), $d3093f2493aa17fd$var$Lh(b, c, d), $d3093f2493aa17fd$var$Nh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $d3093f2493aa17fd$var$ph(l) : (l = $d3093f2493aa17fd$var$rg(c) ? $d3093f2493aa17fd$var$pg : $d3093f2493aa17fd$var$I.current, l = $d3093f2493aa17fd$var$qg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $d3093f2493aa17fd$var$Mh(b, g, d, l);
        $d3093f2493aa17fd$var$uh = !1;
        var r = b.memoizedState;
        g.state = r;
        $d3093f2493aa17fd$var$Bh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $d3093f2493aa17fd$var$og.current || $d3093f2493aa17fd$var$uh ? ("function" === typeof n && ($d3093f2493aa17fd$var$Fh(b, c, n, d), k = b.memoizedState), (h = $d3093f2493aa17fd$var$uh || $d3093f2493aa17fd$var$Kh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $d3093f2493aa17fd$var$wh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $d3093f2493aa17fd$var$fh(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $d3093f2493aa17fd$var$ph(k) : (k = $d3093f2493aa17fd$var$rg(c) ? $d3093f2493aa17fd$var$pg : $d3093f2493aa17fd$var$I.current, k = $d3093f2493aa17fd$var$qg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $d3093f2493aa17fd$var$Mh(b, g, d, k);
        $d3093f2493aa17fd$var$uh = !1;
        r = b.memoizedState;
        g.state = r;
        $d3093f2493aa17fd$var$Bh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $d3093f2493aa17fd$var$og.current || $d3093f2493aa17fd$var$uh ? ("function" === typeof z && ($d3093f2493aa17fd$var$Fh(b, c, z, d), m = b.memoizedState), (l = $d3093f2493aa17fd$var$uh || $d3093f2493aa17fd$var$Kh(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $d3093f2493aa17fd$var$Wj(a, b, c, d, f, e);
}
function $d3093f2493aa17fd$var$Wj(a, b, c, d, e, f) {
    $d3093f2493aa17fd$var$Tj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $d3093f2493aa17fd$var$wg(b, c, !1), $d3093f2493aa17fd$var$Lj(a, b, f);
    d = b.stateNode;
    $d3093f2493aa17fd$var$Ij.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $d3093f2493aa17fd$var$lj = -1;
    } else $d3093f2493aa17fd$var$sc(b), h = d.render(), $d3093f2493aa17fd$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $d3093f2493aa17fd$var$Xh(b, a.child, null, f), b.child = $d3093f2493aa17fd$var$Xh(b, null, g, f)) : $d3093f2493aa17fd$var$Jj(a, b, h, f);
    b.memoizedState = d.state;
    e && $d3093f2493aa17fd$var$wg(b, c, !0);
    return b.child;
}
function $d3093f2493aa17fd$var$Xj(a) {
    var b = a.stateNode;
    b.pendingContext ? $d3093f2493aa17fd$var$tg(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $d3093f2493aa17fd$var$tg(a, b.context, !1);
    $d3093f2493aa17fd$var$di(a, b.containerInfo);
}
function $d3093f2493aa17fd$var$Yj(a, b, c, d, e) {
    $d3093f2493aa17fd$var$ch();
    $d3093f2493aa17fd$var$dh(e);
    b.flags |= 256;
    $d3093f2493aa17fd$var$Jj(a, b, c, d);
    return b.child;
}
var $d3093f2493aa17fd$var$bk = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $d3093f2493aa17fd$var$ck(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $d3093f2493aa17fd$var$dk(a, b, c) {
    var d = b.pendingProps, e = $d3093f2493aa17fd$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$M, e & 1);
    if (null === a) {
        $d3093f2493aa17fd$var$Zg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $d3093f2493aa17fd$var$ek(g, d, 0, null), a = $d3093f2493aa17fd$var$Wh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $d3093f2493aa17fd$var$ck(c), b.memoizedState = $d3093f2493aa17fd$var$bk, a) : $d3093f2493aa17fd$var$fk(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $d3093f2493aa17fd$var$gk(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $d3093f2493aa17fd$var$Sh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $d3093f2493aa17fd$var$Sh(h, f) : (f = $d3093f2493aa17fd$var$Wh(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $d3093f2493aa17fd$var$ck(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $d3093f2493aa17fd$var$bk;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $d3093f2493aa17fd$var$Sh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $d3093f2493aa17fd$var$fk(a, b) {
    b = $d3093f2493aa17fd$var$ek({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $d3093f2493aa17fd$var$hk(a, b, c, d) {
    null !== d && $d3093f2493aa17fd$var$dh(d);
    $d3093f2493aa17fd$var$Xh(b, a.child, null, c);
    a = $d3093f2493aa17fd$var$fk(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $d3093f2493aa17fd$var$gk(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $d3093f2493aa17fd$var$vj(Error($d3093f2493aa17fd$var$p(422))), $d3093f2493aa17fd$var$hk(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $d3093f2493aa17fd$var$ek({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $d3093f2493aa17fd$var$Wh(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $d3093f2493aa17fd$var$Xh(b, a.child, null, g);
        b.child.memoizedState = $d3093f2493aa17fd$var$ck(g);
        b.memoizedState = $d3093f2493aa17fd$var$bk;
        return f;
    }
    if (0 === (b.mode & 1)) return $d3093f2493aa17fd$var$hk(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($d3093f2493aa17fd$var$p(419));
        d = $d3093f2493aa17fd$var$vj(f, d, void 0);
        return $d3093f2493aa17fd$var$hk(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($d3093f2493aa17fd$var$oh || (typeof window !== 'undefined' && window.__CC_REACT_DOM_CONTEXT_PATCH__ ? 0 : h)) {
        d = $d3093f2493aa17fd$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $d3093f2493aa17fd$var$th(a, e), $d3093f2493aa17fd$var$Ih(d, a, e, -1));
        }
        $d3093f2493aa17fd$var$ik();
        d = $d3093f2493aa17fd$var$vj(Error($d3093f2493aa17fd$var$p(421)));
        return $d3093f2493aa17fd$var$hk(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $d3093f2493aa17fd$var$jk.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $d3093f2493aa17fd$var$Qg = $d3093f2493aa17fd$var$dg(e.nextSibling);
    $d3093f2493aa17fd$var$J = b;
    $d3093f2493aa17fd$var$K = !0;
    $d3093f2493aa17fd$var$Sg = null;
    $d3093f2493aa17fd$var$Rg = !1;
    null !== a && ($d3093f2493aa17fd$var$Hg[$d3093f2493aa17fd$var$Ig++] = $d3093f2493aa17fd$var$Kg, $d3093f2493aa17fd$var$Hg[$d3093f2493aa17fd$var$Ig++] = $d3093f2493aa17fd$var$Lg, $d3093f2493aa17fd$var$Hg[$d3093f2493aa17fd$var$Ig++] = $d3093f2493aa17fd$var$Jg, $d3093f2493aa17fd$var$Kg = a.id, $d3093f2493aa17fd$var$Lg = a.overflow, $d3093f2493aa17fd$var$Jg = b);
    b = $d3093f2493aa17fd$var$fk(b, d.children);
    b.flags |= 4096;
    return b;
}
function $d3093f2493aa17fd$var$kk(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $d3093f2493aa17fd$var$mh(a.return, b, c);
}
function $d3093f2493aa17fd$var$lk(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $d3093f2493aa17fd$var$mk(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $d3093f2493aa17fd$var$Jj(a, b, d.children, c);
    d = $d3093f2493aa17fd$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $d3093f2493aa17fd$var$kk(a, c, b);
            else if (19 === a.tag) $d3093f2493aa17fd$var$kk(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $d3093f2493aa17fd$var$hi(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $d3093f2493aa17fd$var$lk(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $d3093f2493aa17fd$var$hi(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $d3093f2493aa17fd$var$lk(b, !0, c, null, f);
            break;
        case "together":
            $d3093f2493aa17fd$var$lk(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $d3093f2493aa17fd$var$Vj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $d3093f2493aa17fd$var$Lj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $d3093f2493aa17fd$var$lj = -1;
    $d3093f2493aa17fd$var$Ch |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($d3093f2493aa17fd$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $d3093f2493aa17fd$var$Sh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $d3093f2493aa17fd$var$Sh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $d3093f2493aa17fd$var$nk(a, b, c) {
    switch(b.tag){
        case 3:
            $d3093f2493aa17fd$var$Xj(b);
            $d3093f2493aa17fd$var$ch();
            break;
        case 5:
            $d3093f2493aa17fd$var$fi(b);
            break;
        case 1:
            $d3093f2493aa17fd$var$rg(b.type) && $d3093f2493aa17fd$var$vg(b);
            break;
        case 4:
            $d3093f2493aa17fd$var$di(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$gh, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$M, $d3093f2493aa17fd$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $d3093f2493aa17fd$var$dk(a, b, c);
                $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$M, $d3093f2493aa17fd$var$M.current & 1);
                a = $d3093f2493aa17fd$var$Lj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$M, $d3093f2493aa17fd$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $d3093f2493aa17fd$var$mk(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$M, $d3093f2493aa17fd$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $d3093f2493aa17fd$var$Qj(a, b, c);
    }
    return $d3093f2493aa17fd$var$Lj(a, b, c);
}
var $d3093f2493aa17fd$var$ok, $d3093f2493aa17fd$var$pk, $d3093f2493aa17fd$var$qk, $d3093f2493aa17fd$var$rk;
$d3093f2493aa17fd$var$ok = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$d3093f2493aa17fd$var$pk = function() {};
$d3093f2493aa17fd$var$qk = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $d3093f2493aa17fd$var$ci($d3093f2493aa17fd$var$$h.current);
        var f = null;
        switch(c){
            case "input":
                e = $d3093f2493aa17fd$var$Ya(a, e);
                d = $d3093f2493aa17fd$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $d3093f2493aa17fd$var$u({}, e, {
                    value: void 0
                });
                d = $d3093f2493aa17fd$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $d3093f2493aa17fd$var$fb(a, e);
                d = $d3093f2493aa17fd$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $d3093f2493aa17fd$var$Qf);
        }
        $d3093f2493aa17fd$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($d3093f2493aa17fd$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($d3093f2493aa17fd$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $d3093f2493aa17fd$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$d3093f2493aa17fd$var$rk = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $d3093f2493aa17fd$var$sk(a, b) {
    if (!$d3093f2493aa17fd$var$K) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $d3093f2493aa17fd$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $d3093f2493aa17fd$var$tk(a, b, c) {
    var d = b.pendingProps;
    $d3093f2493aa17fd$var$Pg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $d3093f2493aa17fd$var$S(b), null;
        case 1:
            return $d3093f2493aa17fd$var$rg(b.type) && $d3093f2493aa17fd$var$sg(), $d3093f2493aa17fd$var$S(b), null;
        case 3:
            d = b.stateNode;
            $d3093f2493aa17fd$var$ei();
            $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$og);
            $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$I);
            $d3093f2493aa17fd$var$ji();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $d3093f2493aa17fd$var$ah(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $d3093f2493aa17fd$var$Sg && ($d3093f2493aa17fd$var$uk($d3093f2493aa17fd$var$Sg), $d3093f2493aa17fd$var$Sg = null));
            $d3093f2493aa17fd$var$pk(a, b);
            $d3093f2493aa17fd$var$S(b);
            return null;
        case 5:
            $d3093f2493aa17fd$var$gi(b);
            var e = $d3093f2493aa17fd$var$ci($d3093f2493aa17fd$var$bi.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $d3093f2493aa17fd$var$qk(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($d3093f2493aa17fd$var$p(166));
                    $d3093f2493aa17fd$var$S(b);
                    return null;
                }
                a = $d3093f2493aa17fd$var$ci($d3093f2493aa17fd$var$$h.current);
                if ($d3093f2493aa17fd$var$ah(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$d3093f2493aa17fd$var$gg] = b;
                    d[$d3093f2493aa17fd$var$hg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $d3093f2493aa17fd$var$F("cancel", d);
                            $d3093f2493aa17fd$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $d3093f2493aa17fd$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $d3093f2493aa17fd$var$zf.length; e++)$d3093f2493aa17fd$var$F($d3093f2493aa17fd$var$zf[e], d);
                            break;
                        case "source":
                            $d3093f2493aa17fd$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $d3093f2493aa17fd$var$F("error", d);
                            $d3093f2493aa17fd$var$F("load", d);
                            break;
                        case "details":
                            $d3093f2493aa17fd$var$F("toggle", d);
                            break;
                        case "input":
                            $d3093f2493aa17fd$var$Za(d, c);
                            $d3093f2493aa17fd$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $d3093f2493aa17fd$var$F("invalid", d);
                            break;
                        case "textarea":
                            $d3093f2493aa17fd$var$gb(d, c), $d3093f2493aa17fd$var$F("invalid", d);
                    }
                    $d3093f2493aa17fd$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $d3093f2493aa17fd$var$Pf(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $d3093f2493aa17fd$var$Pf(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $d3093f2493aa17fd$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $d3093f2493aa17fd$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $d3093f2493aa17fd$var$Va(d);
                            $d3093f2493aa17fd$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $d3093f2493aa17fd$var$Va(d);
                            $d3093f2493aa17fd$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $d3093f2493aa17fd$var$Qf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $d3093f2493aa17fd$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$d3093f2493aa17fd$var$gg] = b;
                    a[$d3093f2493aa17fd$var$hg] = d;
                    $d3093f2493aa17fd$var$ok(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $d3093f2493aa17fd$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $d3093f2493aa17fd$var$F("cancel", a);
                                $d3093f2493aa17fd$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $d3093f2493aa17fd$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $d3093f2493aa17fd$var$zf.length; e++)$d3093f2493aa17fd$var$F($d3093f2493aa17fd$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $d3093f2493aa17fd$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $d3093f2493aa17fd$var$F("error", a);
                                $d3093f2493aa17fd$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $d3093f2493aa17fd$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $d3093f2493aa17fd$var$Za(a, d);
                                e = $d3093f2493aa17fd$var$Ya(a, d);
                                $d3093f2493aa17fd$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $d3093f2493aa17fd$var$u({}, d, {
                                    value: void 0
                                });
                                $d3093f2493aa17fd$var$F("invalid", a);
                                break;
                            case "textarea":
                                $d3093f2493aa17fd$var$gb(a, d);
                                e = $d3093f2493aa17fd$var$fb(a, d);
                                $d3093f2493aa17fd$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $d3093f2493aa17fd$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $d3093f2493aa17fd$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $d3093f2493aa17fd$var$mb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $d3093f2493aa17fd$var$nb(a, k) : "number" === typeof k && $d3093f2493aa17fd$var$nb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($d3093f2493aa17fd$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $d3093f2493aa17fd$var$F("scroll", a) : null != k && $d3093f2493aa17fd$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $d3093f2493aa17fd$var$Va(a);
                                $d3093f2493aa17fd$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $d3093f2493aa17fd$var$Va(a);
                                $d3093f2493aa17fd$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $d3093f2493aa17fd$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $d3093f2493aa17fd$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $d3093f2493aa17fd$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $d3093f2493aa17fd$var$Qf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $d3093f2493aa17fd$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $d3093f2493aa17fd$var$rk(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($d3093f2493aa17fd$var$p(166));
                a = $d3093f2493aa17fd$var$ci($d3093f2493aa17fd$var$bi.current);
                $d3093f2493aa17fd$var$ci($d3093f2493aa17fd$var$$h.current);
                if ($d3093f2493aa17fd$var$ah(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$d3093f2493aa17fd$var$gg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $d3093f2493aa17fd$var$J, null !== f) switch(f.tag){
                            case 3:
                                $d3093f2493aa17fd$var$Pf(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $d3093f2493aa17fd$var$Pf(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$d3093f2493aa17fd$var$gg] = b, b.stateNode = d;
            }
            $d3093f2493aa17fd$var$S(b);
            return null;
        case 13:
            $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($d3093f2493aa17fd$var$K && null !== $d3093f2493aa17fd$var$Qg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $d3093f2493aa17fd$var$bh(b), $d3093f2493aa17fd$var$ch(), b.flags |= 98560, f = !1;
                else if (f = $d3093f2493aa17fd$var$ah(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($d3093f2493aa17fd$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($d3093f2493aa17fd$var$p(317));
                        f[$d3093f2493aa17fd$var$gg] = b;
                        $d3093f2493aa17fd$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $d3093f2493aa17fd$var$ch(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $d3093f2493aa17fd$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $d3093f2493aa17fd$var$Sg && ($d3093f2493aa17fd$var$uk($d3093f2493aa17fd$var$Sg), $d3093f2493aa17fd$var$Sg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $d3093f2493aa17fd$var$tj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($d3093f2493aa17fd$var$M.current & 1) ? 0 === $d3093f2493aa17fd$var$T && ($d3093f2493aa17fd$var$T = 3) : $d3093f2493aa17fd$var$ik()));
            null !== b.updateQueue && (b.flags |= 4);
            $d3093f2493aa17fd$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $d3093f2493aa17fd$var$ei(), $d3093f2493aa17fd$var$pk(a, b), null === a && $d3093f2493aa17fd$var$Gf(b.stateNode.containerInfo), $d3093f2493aa17fd$var$S(b), null;
        case 10:
            return $d3093f2493aa17fd$var$lh(b.type._context), $d3093f2493aa17fd$var$S(b), null;
        case 17:
            return $d3093f2493aa17fd$var$rg(b.type) && $d3093f2493aa17fd$var$sg(), $d3093f2493aa17fd$var$S(b), null;
        case 19:
            $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$M);
            f = b.memoizedState;
            if (null === f) return $d3093f2493aa17fd$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $d3093f2493aa17fd$var$sk(f, !1);
                else {
                    if (0 !== $d3093f2493aa17fd$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $d3093f2493aa17fd$var$hi(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $d3093f2493aa17fd$var$sk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$M, $d3093f2493aa17fd$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $d3093f2493aa17fd$var$A() > $d3093f2493aa17fd$var$vk && (b.flags |= 128, d = !0, $d3093f2493aa17fd$var$sk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $d3093f2493aa17fd$var$hi(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $d3093f2493aa17fd$var$sk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$d3093f2493aa17fd$var$K) return $d3093f2493aa17fd$var$S(b), null;
                    } else 2 * $d3093f2493aa17fd$var$A() - f.renderingStartTime > $d3093f2493aa17fd$var$vk && 1073741824 !== c && (b.flags |= 128, d = !0, $d3093f2493aa17fd$var$sk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $d3093f2493aa17fd$var$A(), b.sibling = null, a = $d3093f2493aa17fd$var$M.current, $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$M, d ? a & 1 | 2 : a & 1), b;
            $d3093f2493aa17fd$var$S(b);
            return null;
        case 22:
        case 23:
            return $d3093f2493aa17fd$var$wk(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($d3093f2493aa17fd$var$Sj & 1073741824) && ($d3093f2493aa17fd$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $d3093f2493aa17fd$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($d3093f2493aa17fd$var$p(156, b.tag));
}
function $d3093f2493aa17fd$var$xk(a, b) {
    $d3093f2493aa17fd$var$Pg(b);
    switch(b.tag){
        case 1:
            return $d3093f2493aa17fd$var$rg(b.type) && $d3093f2493aa17fd$var$sg(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $d3093f2493aa17fd$var$tj(b), b) : null;
        case 3:
            return $d3093f2493aa17fd$var$ei(), $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$og), $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$I), $d3093f2493aa17fd$var$ji(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $d3093f2493aa17fd$var$gi(b), null;
        case 13:
            $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($d3093f2493aa17fd$var$p(340));
                $d3093f2493aa17fd$var$ch();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $d3093f2493aa17fd$var$tj(b), b) : null;
        case 19:
            return $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$M), null;
        case 4:
            return $d3093f2493aa17fd$var$ei(), null;
        case 10:
            return $d3093f2493aa17fd$var$lh(b.type._context), null;
        case 22:
        case 23:
            return $d3093f2493aa17fd$var$wk(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $d3093f2493aa17fd$var$yk = !1, $d3093f2493aa17fd$var$zk = !1, $d3093f2493aa17fd$var$Ak = "function" === typeof WeakSet ? WeakSet : Set, $d3093f2493aa17fd$var$U = null, $d3093f2493aa17fd$var$Bk = null, $d3093f2493aa17fd$var$Ck = null;
function $d3093f2493aa17fd$var$Dk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $d3093f2493aa17fd$var$sj(), b.componentWillUnmount();
    } finally{
        $d3093f2493aa17fd$var$qj(a);
    }
    else b.componentWillUnmount();
}
function $d3093f2493aa17fd$var$Ek(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $d3093f2493aa17fd$var$sj(), c(null);
            } finally{
                $d3093f2493aa17fd$var$qj(a);
            }
            else c(null);
        } catch (d) {
            $d3093f2493aa17fd$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $d3093f2493aa17fd$var$Fk(a, b, c) {
    try {
        c();
    } catch (d) {
        $d3093f2493aa17fd$var$W(a, b, d);
    }
}
var $d3093f2493aa17fd$var$Gk = !1;
function $d3093f2493aa17fd$var$Hk(a, b) {
    $d3093f2493aa17fd$var$Vf = $d3093f2493aa17fd$var$rd;
    a = $d3093f2493aa17fd$var$$e();
    if ($d3093f2493aa17fd$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $d3093f2493aa17fd$var$Wf = {
        focusedElem: a,
        selectionRange: c
    };
    $d3093f2493aa17fd$var$rd = !1;
    for($d3093f2493aa17fd$var$U = b; null !== $d3093f2493aa17fd$var$U;)if (b = $d3093f2493aa17fd$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $d3093f2493aa17fd$var$U = a;
    else for(; null !== $d3093f2493aa17fd$var$U;){
        b = $d3093f2493aa17fd$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $d3093f2493aa17fd$var$fh(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($d3093f2493aa17fd$var$p(163));
            }
        } catch (D) {
            $d3093f2493aa17fd$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $d3093f2493aa17fd$var$U = a;
            break;
        }
        $d3093f2493aa17fd$var$U = b.return;
    }
    m = $d3093f2493aa17fd$var$Gk;
    $d3093f2493aa17fd$var$Gk = !1;
    return m;
}
function $d3093f2493aa17fd$var$Ik(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markComponentPassiveEffectUnmountStarted && $d3093f2493aa17fd$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $d3093f2493aa17fd$var$uc(b), $d3093f2493aa17fd$var$Fk(b, c, f), 0 !== (a & 8) ? null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markComponentPassiveEffectUnmountStopped && $d3093f2493aa17fd$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $d3093f2493aa17fd$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $d3093f2493aa17fd$var$Jk(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markComponentPassiveEffectMountStarted && $d3093f2493aa17fd$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markComponentLayoutEffectMountStarted && $d3093f2493aa17fd$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markComponentPassiveEffectMountStopped && $d3093f2493aa17fd$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markComponentLayoutEffectMountStopped && $d3093f2493aa17fd$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $d3093f2493aa17fd$var$Kk(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $d3093f2493aa17fd$var$sj(), b(c);
            } finally{
                $d3093f2493aa17fd$var$qj(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $d3093f2493aa17fd$var$Lk(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $d3093f2493aa17fd$var$Lk(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$d3093f2493aa17fd$var$gg], delete b[$d3093f2493aa17fd$var$hg], delete b[$d3093f2493aa17fd$var$Cf], delete b[$d3093f2493aa17fd$var$ig], delete b[$d3093f2493aa17fd$var$jg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $d3093f2493aa17fd$var$Mk(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $d3093f2493aa17fd$var$Nk(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $d3093f2493aa17fd$var$Mk(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $d3093f2493aa17fd$var$Ok(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $d3093f2493aa17fd$var$Qf));
    else if (4 !== d && (a = a.child, null !== a)) for($d3093f2493aa17fd$var$Ok(a, b, c), a = a.sibling; null !== a;)$d3093f2493aa17fd$var$Ok(a, b, c), a = a.sibling;
}
function $d3093f2493aa17fd$var$Pk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($d3093f2493aa17fd$var$Pk(a, b, c), a = a.sibling; null !== a;)$d3093f2493aa17fd$var$Pk(a, b, c), a = a.sibling;
}
var $d3093f2493aa17fd$var$X = null, $d3093f2493aa17fd$var$Qk = !1;
function $d3093f2493aa17fd$var$Rk(a, b, c) {
    for(c = c.child; null !== c;)$d3093f2493aa17fd$var$Sk(a, b, c), c = c.sibling;
}
function $d3093f2493aa17fd$var$Sk(a, b, c) {
    if ($d3093f2493aa17fd$var$lc && "function" === typeof $d3093f2493aa17fd$var$lc.onCommitFiberUnmount) try {
        $d3093f2493aa17fd$var$lc.onCommitFiberUnmount($d3093f2493aa17fd$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $d3093f2493aa17fd$var$zk || $d3093f2493aa17fd$var$Ek(c, b);
        case 6:
            var d = $d3093f2493aa17fd$var$X, e = $d3093f2493aa17fd$var$Qk;
            $d3093f2493aa17fd$var$X = null;
            $d3093f2493aa17fd$var$Rk(a, b, c);
            $d3093f2493aa17fd$var$X = d;
            $d3093f2493aa17fd$var$Qk = e;
            null !== $d3093f2493aa17fd$var$X && ($d3093f2493aa17fd$var$Qk ? (a = $d3093f2493aa17fd$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $d3093f2493aa17fd$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $d3093f2493aa17fd$var$X && ($d3093f2493aa17fd$var$Qk ? (a = $d3093f2493aa17fd$var$X, c = c.stateNode, 8 === a.nodeType ? $d3093f2493aa17fd$var$cg(a.parentNode, c) : 1 === a.nodeType && $d3093f2493aa17fd$var$cg(a, c), $d3093f2493aa17fd$var$pd(a)) : $d3093f2493aa17fd$var$cg($d3093f2493aa17fd$var$X, c.stateNode));
            break;
        case 4:
            d = $d3093f2493aa17fd$var$X;
            e = $d3093f2493aa17fd$var$Qk;
            $d3093f2493aa17fd$var$X = c.stateNode.containerInfo;
            $d3093f2493aa17fd$var$Qk = !0;
            $d3093f2493aa17fd$var$Rk(a, b, c);
            $d3093f2493aa17fd$var$X = d;
            $d3093f2493aa17fd$var$Qk = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$d3093f2493aa17fd$var$zk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $d3093f2493aa17fd$var$Fk(c, b, g) : 0 !== (f & 4) && ($d3093f2493aa17fd$var$uc(c), c.mode & 2 ? ($d3093f2493aa17fd$var$sj(), $d3093f2493aa17fd$var$Fk(c, b, g), $d3093f2493aa17fd$var$qj(c)) : $d3093f2493aa17fd$var$Fk(c, b, g), $d3093f2493aa17fd$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $d3093f2493aa17fd$var$Rk(a, b, c);
            break;
        case 1:
            if (!$d3093f2493aa17fd$var$zk && ($d3093f2493aa17fd$var$Ek(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $d3093f2493aa17fd$var$Dk(c, d);
            } catch (h) {
                $d3093f2493aa17fd$var$W(c, b, h);
            }
            $d3093f2493aa17fd$var$Rk(a, b, c);
            break;
        case 21:
            $d3093f2493aa17fd$var$Rk(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($d3093f2493aa17fd$var$zk = (d = $d3093f2493aa17fd$var$zk) || null !== c.memoizedState, $d3093f2493aa17fd$var$Rk(a, b, c), $d3093f2493aa17fd$var$zk = d) : $d3093f2493aa17fd$var$Rk(a, b, c);
            break;
        default:
            $d3093f2493aa17fd$var$Rk(a, b, c);
    }
}
function $d3093f2493aa17fd$var$Tk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $d3093f2493aa17fd$var$Ak);
        b.forEach(function(b) {
            var d = $d3093f2493aa17fd$var$Uk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($d3093f2493aa17fd$var$mc) {
                    if (null !== $d3093f2493aa17fd$var$Bk && null !== $d3093f2493aa17fd$var$Ck) $d3093f2493aa17fd$var$Fj($d3093f2493aa17fd$var$Ck, $d3093f2493aa17fd$var$Bk);
                    else throw Error($d3093f2493aa17fd$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $d3093f2493aa17fd$var$Vk(a, b, c) {
    $d3093f2493aa17fd$var$Bk = c;
    $d3093f2493aa17fd$var$Ck = a;
    $d3093f2493aa17fd$var$Wk(b, a);
    $d3093f2493aa17fd$var$Ck = $d3093f2493aa17fd$var$Bk = null;
}
function $d3093f2493aa17fd$var$Xk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $d3093f2493aa17fd$var$X = h.stateNode;
                        $d3093f2493aa17fd$var$Qk = !1;
                        break a;
                    case 3:
                        $d3093f2493aa17fd$var$X = h.stateNode.containerInfo;
                        $d3093f2493aa17fd$var$Qk = !0;
                        break a;
                    case 4:
                        $d3093f2493aa17fd$var$X = h.stateNode.containerInfo;
                        $d3093f2493aa17fd$var$Qk = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $d3093f2493aa17fd$var$X) throw Error($d3093f2493aa17fd$var$p(160));
            $d3093f2493aa17fd$var$Sk(f, g, e);
            $d3093f2493aa17fd$var$X = null;
            $d3093f2493aa17fd$var$Qk = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $d3093f2493aa17fd$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$d3093f2493aa17fd$var$Wk(b, a), b = b.sibling;
}
function $d3093f2493aa17fd$var$Wk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $d3093f2493aa17fd$var$Xk(b, a);
            $d3093f2493aa17fd$var$Yk(a);
            if (d & 4) {
                try {
                    $d3093f2493aa17fd$var$Ik(3, a, a.return), $d3093f2493aa17fd$var$Jk(3, a);
                } catch (m) {
                    $d3093f2493aa17fd$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $d3093f2493aa17fd$var$sj(), $d3093f2493aa17fd$var$Ik(5, a, a.return);
                    } catch (m) {
                        $d3093f2493aa17fd$var$W(a, a.return, m);
                    }
                    $d3093f2493aa17fd$var$qj(a);
                } else try {
                    $d3093f2493aa17fd$var$Ik(5, a, a.return);
                } catch (m) {
                    $d3093f2493aa17fd$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $d3093f2493aa17fd$var$Xk(b, a);
            $d3093f2493aa17fd$var$Yk(a);
            d & 512 && null !== c && $d3093f2493aa17fd$var$Ek(c, c.return);
            break;
        case 5:
            $d3093f2493aa17fd$var$Xk(b, a);
            $d3093f2493aa17fd$var$Yk(a);
            d & 512 && null !== c && $d3093f2493aa17fd$var$Ek(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $d3093f2493aa17fd$var$nb(e, "");
                } catch (m) {
                    $d3093f2493aa17fd$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $d3093f2493aa17fd$var$$a(e, f);
                    $d3093f2493aa17fd$var$vb(h, g);
                    var l = $d3093f2493aa17fd$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $d3093f2493aa17fd$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $d3093f2493aa17fd$var$mb(e, q) : "children" === n ? $d3093f2493aa17fd$var$nb(e, q) : $d3093f2493aa17fd$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $d3093f2493aa17fd$var$ab(e, f);
                            break;
                        case "textarea":
                            $d3093f2493aa17fd$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $d3093f2493aa17fd$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $d3093f2493aa17fd$var$eb(e, !!f.multiple, f.defaultValue, !0) : $d3093f2493aa17fd$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$d3093f2493aa17fd$var$hg] = f;
                } catch (m) {
                    $d3093f2493aa17fd$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $d3093f2493aa17fd$var$Xk(b, a);
            $d3093f2493aa17fd$var$Yk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($d3093f2493aa17fd$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $d3093f2493aa17fd$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $d3093f2493aa17fd$var$Xk(b, a);
            $d3093f2493aa17fd$var$Yk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $d3093f2493aa17fd$var$pd(b.containerInfo);
            } catch (m) {
                $d3093f2493aa17fd$var$W(a, a.return, m);
            }
            break;
        case 4:
            $d3093f2493aa17fd$var$Xk(b, a);
            $d3093f2493aa17fd$var$Yk(a);
            break;
        case 13:
            $d3093f2493aa17fd$var$Xk(b, a);
            $d3093f2493aa17fd$var$Yk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($d3093f2493aa17fd$var$Zk = $d3093f2493aa17fd$var$A()));
            d & 4 && $d3093f2493aa17fd$var$Tk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($d3093f2493aa17fd$var$zk = (l = $d3093f2493aa17fd$var$zk) || n, $d3093f2493aa17fd$var$Xk(b, a), $d3093f2493aa17fd$var$zk = l) : $d3093f2493aa17fd$var$Xk(b, a);
            $d3093f2493aa17fd$var$Yk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($d3093f2493aa17fd$var$U = a, n = a.child; null !== n;){
                    for(q = $d3093f2493aa17fd$var$U = n; null !== $d3093f2493aa17fd$var$U;){
                        r = $d3093f2493aa17fd$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $d3093f2493aa17fd$var$sj(), $d3093f2493aa17fd$var$Ik(4, r, r.return);
                                } finally{
                                    $d3093f2493aa17fd$var$qj(r);
                                }
                                else $d3093f2493aa17fd$var$Ik(4, r, r.return);
                                break;
                            case 1:
                                $d3093f2493aa17fd$var$Ek(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $d3093f2493aa17fd$var$Dk(c, d);
                                    } catch (m) {
                                        $d3093f2493aa17fd$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $d3093f2493aa17fd$var$Ek(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $d3093f2493aa17fd$var$$k(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $d3093f2493aa17fd$var$U = z) : $d3093f2493aa17fd$var$$k(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $d3093f2493aa17fd$var$rb("display", g));
                            } catch (m) {
                                $d3093f2493aa17fd$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $d3093f2493aa17fd$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $d3093f2493aa17fd$var$Xk(b, a);
            $d3093f2493aa17fd$var$Yk(a);
            d & 4 && $d3093f2493aa17fd$var$Tk(a);
            break;
        case 21:
            break;
        default:
            $d3093f2493aa17fd$var$Xk(b, a), $d3093f2493aa17fd$var$Yk(a);
    }
}
function $d3093f2493aa17fd$var$Yk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($d3093f2493aa17fd$var$Mk(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($d3093f2493aa17fd$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($d3093f2493aa17fd$var$nb(e, ""), d.flags &= -33);
                    var f = $d3093f2493aa17fd$var$Nk(a);
                    $d3093f2493aa17fd$var$Pk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $d3093f2493aa17fd$var$Nk(a);
                    $d3093f2493aa17fd$var$Ok(a, h, g);
                    break;
                default:
                    throw Error($d3093f2493aa17fd$var$p(161));
            }
        } catch (k) {
            $d3093f2493aa17fd$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $d3093f2493aa17fd$var$al(a, b, c) {
    $d3093f2493aa17fd$var$Bk = c;
    $d3093f2493aa17fd$var$Ck = b;
    $d3093f2493aa17fd$var$U = a;
    $d3093f2493aa17fd$var$bl(a, b, c);
    $d3093f2493aa17fd$var$Ck = $d3093f2493aa17fd$var$Bk = null;
}
function $d3093f2493aa17fd$var$bl(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $d3093f2493aa17fd$var$U;){
        var e = $d3093f2493aa17fd$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $d3093f2493aa17fd$var$yk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $d3093f2493aa17fd$var$zk;
                h = $d3093f2493aa17fd$var$yk;
                var l = $d3093f2493aa17fd$var$zk;
                $d3093f2493aa17fd$var$yk = g;
                if (($d3093f2493aa17fd$var$zk = k) && !l) for($d3093f2493aa17fd$var$U = e; null !== $d3093f2493aa17fd$var$U;)g = $d3093f2493aa17fd$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $d3093f2493aa17fd$var$cl(e) : null !== k ? (k.return = g, $d3093f2493aa17fd$var$U = k) : $d3093f2493aa17fd$var$cl(e);
                for(; null !== f;)$d3093f2493aa17fd$var$U = f, $d3093f2493aa17fd$var$bl(f, b, c), f = f.sibling;
                $d3093f2493aa17fd$var$U = e;
                $d3093f2493aa17fd$var$yk = h;
                $d3093f2493aa17fd$var$zk = l;
            }
            $d3093f2493aa17fd$var$dl(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $d3093f2493aa17fd$var$U = f) : $d3093f2493aa17fd$var$dl(a, b, c);
    }
}
function $d3093f2493aa17fd$var$dl(a) {
    for(; null !== $d3093f2493aa17fd$var$U;){
        var b = $d3093f2493aa17fd$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$d3093f2493aa17fd$var$zk) {
                            if (b.mode & 2) try {
                                $d3093f2493aa17fd$var$sj(), $d3093f2493aa17fd$var$Jk(5, b);
                            } finally{
                                $d3093f2493aa17fd$var$qj(b);
                            }
                            else $d3093f2493aa17fd$var$Jk(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$d3093f2493aa17fd$var$zk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $d3093f2493aa17fd$var$sj(), d.componentDidMount();
                                } finally{
                                    $d3093f2493aa17fd$var$qj(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $d3093f2493aa17fd$var$fh(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $d3093f2493aa17fd$var$sj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $d3093f2493aa17fd$var$qj(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $d3093f2493aa17fd$var$Dh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $d3093f2493aa17fd$var$Dh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $d3093f2493aa17fd$var$jj;
                        c = null === c ? "mount" : "update";
                        $d3093f2493aa17fd$var$nj && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $d3093f2493aa17fd$var$el(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $d3093f2493aa17fd$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($d3093f2493aa17fd$var$p(163));
                }
                $d3093f2493aa17fd$var$zk || b.flags & 512 && $d3093f2493aa17fd$var$Kk(b);
            } catch (v) {
                $d3093f2493aa17fd$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $d3093f2493aa17fd$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $d3093f2493aa17fd$var$U = k;
            break;
        }
        $d3093f2493aa17fd$var$U = b.return;
    }
}
function $d3093f2493aa17fd$var$$k(a) {
    for(; null !== $d3093f2493aa17fd$var$U;){
        var b = $d3093f2493aa17fd$var$U;
        if (b === a) {
            $d3093f2493aa17fd$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $d3093f2493aa17fd$var$U = c;
            break;
        }
        $d3093f2493aa17fd$var$U = b.return;
    }
}
function $d3093f2493aa17fd$var$cl(a) {
    for(; null !== $d3093f2493aa17fd$var$U;){
        var b = $d3093f2493aa17fd$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $d3093f2493aa17fd$var$sj();
                        var c = b.return;
                        try {
                            $d3093f2493aa17fd$var$Jk(4, b);
                        } catch (l) {
                            $d3093f2493aa17fd$var$W(b, c, l);
                        }
                    } finally{
                        $d3093f2493aa17fd$var$qj(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $d3093f2493aa17fd$var$Jk(4, b);
                        } catch (l) {
                            $d3093f2493aa17fd$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $d3093f2493aa17fd$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $d3093f2493aa17fd$var$Kk(b);
                    } catch (l) {
                        $d3093f2493aa17fd$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $d3093f2493aa17fd$var$Kk(b);
                    } catch (l) {
                        $d3093f2493aa17fd$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $d3093f2493aa17fd$var$W(b, b.return, l);
        }
        if (b === a) {
            $d3093f2493aa17fd$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $d3093f2493aa17fd$var$U = k;
            break;
        }
        $d3093f2493aa17fd$var$U = b.return;
    }
}
var $d3093f2493aa17fd$var$fl = Math.ceil, $d3093f2493aa17fd$var$gl = $d3093f2493aa17fd$var$va.ReactCurrentDispatcher, $d3093f2493aa17fd$var$hl = $d3093f2493aa17fd$var$va.ReactCurrentOwner, $d3093f2493aa17fd$var$il = $d3093f2493aa17fd$var$va.ReactCurrentBatchConfig, $d3093f2493aa17fd$var$L = 0, $d3093f2493aa17fd$var$Q = null, $d3093f2493aa17fd$var$Y = null, $d3093f2493aa17fd$var$Z = 0, $d3093f2493aa17fd$var$Sj = 0, $d3093f2493aa17fd$var$Rj = $d3093f2493aa17fd$var$mg(0), $d3093f2493aa17fd$var$T = 0, $d3093f2493aa17fd$var$jl = null, $d3093f2493aa17fd$var$Ch = 0, $d3093f2493aa17fd$var$kl = 0, $d3093f2493aa17fd$var$ll = 0, $d3093f2493aa17fd$var$ml = null, $d3093f2493aa17fd$var$nl = null, $d3093f2493aa17fd$var$Zk = 0, $d3093f2493aa17fd$var$vk = Infinity, $d3093f2493aa17fd$var$ol = null, $d3093f2493aa17fd$var$zj = !1, $d3093f2493aa17fd$var$Aj = null, $d3093f2493aa17fd$var$Cj = null, $d3093f2493aa17fd$var$pl = !1, $d3093f2493aa17fd$var$ql = null, $d3093f2493aa17fd$var$rl = 0, $d3093f2493aa17fd$var$sl = [], $d3093f2493aa17fd$var$tl = 0, $d3093f2493aa17fd$var$ul = null, $d3093f2493aa17fd$var$vl = -1, $d3093f2493aa17fd$var$wl = 0;
function $d3093f2493aa17fd$var$Gh() {
    return 0 !== ($d3093f2493aa17fd$var$L & 6) ? $d3093f2493aa17fd$var$A() : -1 !== $d3093f2493aa17fd$var$vl ? $d3093f2493aa17fd$var$vl : $d3093f2493aa17fd$var$vl = $d3093f2493aa17fd$var$A();
}
function $d3093f2493aa17fd$var$Hh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($d3093f2493aa17fd$var$L & 2) && 0 !== $d3093f2493aa17fd$var$Z) return $d3093f2493aa17fd$var$Z & -$d3093f2493aa17fd$var$Z;
    if (null !== $d3093f2493aa17fd$var$eh.transition) return 0 === $d3093f2493aa17fd$var$wl && ($d3093f2493aa17fd$var$wl = $d3093f2493aa17fd$var$Kc()), $d3093f2493aa17fd$var$wl;
    a = $d3093f2493aa17fd$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $d3093f2493aa17fd$var$xd(a.type);
    return a;
}
function $d3093f2493aa17fd$var$Ih(a, b, c, d) {
    if (50 < $d3093f2493aa17fd$var$tl) throw $d3093f2493aa17fd$var$tl = 0, $d3093f2493aa17fd$var$ul = null, Error($d3093f2493aa17fd$var$p(185));
    $d3093f2493aa17fd$var$Mc(a, c, d);
    if (0 === ($d3093f2493aa17fd$var$L & 2) || a !== $d3093f2493aa17fd$var$Q) $d3093f2493aa17fd$var$mc && $d3093f2493aa17fd$var$Pc(a, b, c), a === $d3093f2493aa17fd$var$Q && (0 === ($d3093f2493aa17fd$var$L & 2) && ($d3093f2493aa17fd$var$kl |= c), 4 === $d3093f2493aa17fd$var$T && $d3093f2493aa17fd$var$xl(a, $d3093f2493aa17fd$var$Z)), $d3093f2493aa17fd$var$yl(a, d), 1 === c && 0 === $d3093f2493aa17fd$var$L && 0 === (b.mode & 1) && ($d3093f2493aa17fd$var$vk = $d3093f2493aa17fd$var$A() + 500, $d3093f2493aa17fd$var$yg && $d3093f2493aa17fd$var$Cg());
}
function $d3093f2493aa17fd$var$yl(a, b) {
    var c = a.callbackNode;
    $d3093f2493aa17fd$var$Ic(a, b);
    var d = $d3093f2493aa17fd$var$Gc(a, a === $d3093f2493aa17fd$var$Q ? $d3093f2493aa17fd$var$Z : 0);
    if (0 === d) null !== c && $d3093f2493aa17fd$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $d3093f2493aa17fd$var$bc(c);
        if (1 === b) 0 === a.tag ? $d3093f2493aa17fd$var$Bg($d3093f2493aa17fd$var$zl.bind(null, a)) : $d3093f2493aa17fd$var$Ag($d3093f2493aa17fd$var$zl.bind(null, a)), $d3093f2493aa17fd$var$bg(function() {
            0 === ($d3093f2493aa17fd$var$L & 6) && $d3093f2493aa17fd$var$Cg();
        }), c = null;
        else {
            switch($d3093f2493aa17fd$var$Rc(d)){
                case 1:
                    c = $d3093f2493aa17fd$var$fc;
                    break;
                case 4:
                    c = $d3093f2493aa17fd$var$gc;
                    break;
                case 16:
                    c = $d3093f2493aa17fd$var$hc;
                    break;
                case 536870912:
                    c = $d3093f2493aa17fd$var$jc;
                    break;
                default:
                    c = $d3093f2493aa17fd$var$hc;
            }
            c = $d3093f2493aa17fd$var$Al(c, $d3093f2493aa17fd$var$Bl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $d3093f2493aa17fd$var$Bl(a, b) {
    $d3093f2493aa17fd$var$oj = $d3093f2493aa17fd$var$nj = !1;
    $d3093f2493aa17fd$var$vl = -1;
    $d3093f2493aa17fd$var$wl = 0;
    if (0 !== ($d3093f2493aa17fd$var$L & 6)) throw Error($d3093f2493aa17fd$var$p(327));
    var c = a.callbackNode;
    if ($d3093f2493aa17fd$var$Cl() && a.callbackNode !== c) return null;
    var d = $d3093f2493aa17fd$var$Gc(a, a === $d3093f2493aa17fd$var$Q ? $d3093f2493aa17fd$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $d3093f2493aa17fd$var$Dl(a, d);
    else {
        b = d;
        var e = $d3093f2493aa17fd$var$L;
        $d3093f2493aa17fd$var$L |= 2;
        var f = $d3093f2493aa17fd$var$El();
        if ($d3093f2493aa17fd$var$Q !== a || $d3093f2493aa17fd$var$Z !== b) {
            if ($d3093f2493aa17fd$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($d3093f2493aa17fd$var$Fj(a, $d3093f2493aa17fd$var$Z), g.clear());
                $d3093f2493aa17fd$var$Qc(a, b);
            }
            $d3093f2493aa17fd$var$ol = null;
            $d3093f2493aa17fd$var$vk = $d3093f2493aa17fd$var$A() + 500;
            $d3093f2493aa17fd$var$Fl(a, b);
        }
        $d3093f2493aa17fd$var$wc(b);
        for(;;)try {
            $d3093f2493aa17fd$var$Gl();
            break;
        } catch (h) {
            $d3093f2493aa17fd$var$Hl(a, h);
        }
        $d3093f2493aa17fd$var$kh();
        $d3093f2493aa17fd$var$gl.current = f;
        $d3093f2493aa17fd$var$L = e;
        null !== $d3093f2493aa17fd$var$Y ? (null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markRenderYielded && $d3093f2493aa17fd$var$B.markRenderYielded(), b = 0) : ($d3093f2493aa17fd$var$xc(), $d3093f2493aa17fd$var$Q = null, $d3093f2493aa17fd$var$Z = 0, b = $d3093f2493aa17fd$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $d3093f2493aa17fd$var$Jc(a), 0 !== e && (d = e, b = $d3093f2493aa17fd$var$Il(a, e)));
        if (1 === b) throw c = $d3093f2493aa17fd$var$jl, $d3093f2493aa17fd$var$Fl(a, 0), $d3093f2493aa17fd$var$xl(a, d), $d3093f2493aa17fd$var$yl(a, $d3093f2493aa17fd$var$A()), c;
        if (6 === b) $d3093f2493aa17fd$var$xl(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$d3093f2493aa17fd$var$Jl(e) && (b = $d3093f2493aa17fd$var$Dl(a, d), 2 === b && (f = $d3093f2493aa17fd$var$Jc(a), 0 !== f && (d = f, b = $d3093f2493aa17fd$var$Il(a, f))), 1 === b)) throw c = $d3093f2493aa17fd$var$jl, $d3093f2493aa17fd$var$Fl(a, 0), $d3093f2493aa17fd$var$xl(a, d), $d3093f2493aa17fd$var$yl(a, $d3093f2493aa17fd$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($d3093f2493aa17fd$var$p(345));
                case 2:
                    $d3093f2493aa17fd$var$Ll(a, $d3093f2493aa17fd$var$nl, $d3093f2493aa17fd$var$ol);
                    break;
                case 3:
                    $d3093f2493aa17fd$var$xl(a, d);
                    if ((d & 130023424) === d && (b = $d3093f2493aa17fd$var$Zk + 500 - $d3093f2493aa17fd$var$A(), 10 < b)) {
                        if (0 !== $d3093f2493aa17fd$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $d3093f2493aa17fd$var$Gh();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $d3093f2493aa17fd$var$Yf($d3093f2493aa17fd$var$Ll.bind(null, a, $d3093f2493aa17fd$var$nl, $d3093f2493aa17fd$var$ol), b);
                        break;
                    }
                    $d3093f2493aa17fd$var$Ll(a, $d3093f2493aa17fd$var$nl, $d3093f2493aa17fd$var$ol);
                    break;
                case 4:
                    $d3093f2493aa17fd$var$xl(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $d3093f2493aa17fd$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $d3093f2493aa17fd$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $d3093f2493aa17fd$var$fl(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $d3093f2493aa17fd$var$Yf($d3093f2493aa17fd$var$Ll.bind(null, a, $d3093f2493aa17fd$var$nl, $d3093f2493aa17fd$var$ol), d);
                        break;
                    }
                    $d3093f2493aa17fd$var$Ll(a, $d3093f2493aa17fd$var$nl, $d3093f2493aa17fd$var$ol);
                    break;
                case 5:
                    $d3093f2493aa17fd$var$Ll(a, $d3093f2493aa17fd$var$nl, $d3093f2493aa17fd$var$ol);
                    break;
                default:
                    throw Error($d3093f2493aa17fd$var$p(329));
            }
        }
    }
    $d3093f2493aa17fd$var$yl(a, $d3093f2493aa17fd$var$A());
    return a.callbackNode === c ? $d3093f2493aa17fd$var$Bl.bind(null, a) : null;
}
function $d3093f2493aa17fd$var$Il(a, b) {
    var c = $d3093f2493aa17fd$var$ml;
    a.current.memoizedState.isDehydrated && ($d3093f2493aa17fd$var$Fl(a, b).flags |= 256);
    a = $d3093f2493aa17fd$var$Dl(a, b);
    2 !== a && (b = $d3093f2493aa17fd$var$nl, $d3093f2493aa17fd$var$nl = c, null !== b && $d3093f2493aa17fd$var$uk(b));
    return a;
}
function $d3093f2493aa17fd$var$uk(a) {
    null === $d3093f2493aa17fd$var$nl ? $d3093f2493aa17fd$var$nl = a : $d3093f2493aa17fd$var$nl.push.apply($d3093f2493aa17fd$var$nl, a);
}
function $d3093f2493aa17fd$var$Jl(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$d3093f2493aa17fd$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $d3093f2493aa17fd$var$xl(a, b) {
    b &= ~$d3093f2493aa17fd$var$ll;
    b &= ~$d3093f2493aa17fd$var$kl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $d3093f2493aa17fd$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $d3093f2493aa17fd$var$zl(a) {
    $d3093f2493aa17fd$var$nj = $d3093f2493aa17fd$var$oj;
    $d3093f2493aa17fd$var$oj = !1;
    if (0 !== ($d3093f2493aa17fd$var$L & 6)) throw Error($d3093f2493aa17fd$var$p(327));
    $d3093f2493aa17fd$var$Cl();
    var b = $d3093f2493aa17fd$var$Gc(a, 0);
    if (0 === (b & 1)) return $d3093f2493aa17fd$var$yl(a, $d3093f2493aa17fd$var$A()), null;
    var c = $d3093f2493aa17fd$var$Dl(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $d3093f2493aa17fd$var$Jc(a);
        0 !== d && (b = d, c = $d3093f2493aa17fd$var$Il(a, d));
    }
    if (1 === c) throw c = $d3093f2493aa17fd$var$jl, $d3093f2493aa17fd$var$Fl(a, 0), $d3093f2493aa17fd$var$xl(a, b), $d3093f2493aa17fd$var$yl(a, $d3093f2493aa17fd$var$A()), c;
    if (6 === c) throw Error($d3093f2493aa17fd$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $d3093f2493aa17fd$var$Ll(a, $d3093f2493aa17fd$var$nl, $d3093f2493aa17fd$var$ol);
    $d3093f2493aa17fd$var$yl(a, $d3093f2493aa17fd$var$A());
    return null;
}
function $d3093f2493aa17fd$var$Ml(a, b) {
    var c = $d3093f2493aa17fd$var$L;
    $d3093f2493aa17fd$var$L |= 1;
    try {
        return a(b);
    } finally{
        $d3093f2493aa17fd$var$L = c, 0 === $d3093f2493aa17fd$var$L && ($d3093f2493aa17fd$var$vk = $d3093f2493aa17fd$var$A() + 500, $d3093f2493aa17fd$var$yg && $d3093f2493aa17fd$var$Cg());
    }
}
function $d3093f2493aa17fd$var$Nl(a) {
    null !== $d3093f2493aa17fd$var$ql && 0 === $d3093f2493aa17fd$var$ql.tag && 0 === ($d3093f2493aa17fd$var$L & 6) && $d3093f2493aa17fd$var$Cl();
    var b = $d3093f2493aa17fd$var$L;
    $d3093f2493aa17fd$var$L |= 1;
    var c = $d3093f2493aa17fd$var$il.transition, d = $d3093f2493aa17fd$var$E;
    try {
        if ($d3093f2493aa17fd$var$il.transition = null, $d3093f2493aa17fd$var$E = 1, a) return a();
    } finally{
        $d3093f2493aa17fd$var$E = d, $d3093f2493aa17fd$var$il.transition = c, $d3093f2493aa17fd$var$L = b, 0 === ($d3093f2493aa17fd$var$L & 6) && $d3093f2493aa17fd$var$Cg();
    }
}
function $d3093f2493aa17fd$var$wk() {
    $d3093f2493aa17fd$var$Sj = $d3093f2493aa17fd$var$Rj.current;
    $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$Rj);
}
function $d3093f2493aa17fd$var$Fl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $d3093f2493aa17fd$var$Zf(c));
    if (null !== $d3093f2493aa17fd$var$Y) for(c = $d3093f2493aa17fd$var$Y.return; null !== c;){
        var d = c;
        $d3093f2493aa17fd$var$Pg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $d3093f2493aa17fd$var$sg();
                break;
            case 3:
                $d3093f2493aa17fd$var$ei();
                $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$og);
                $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$I);
                $d3093f2493aa17fd$var$ji();
                break;
            case 5:
                $d3093f2493aa17fd$var$gi(d);
                break;
            case 4:
                $d3093f2493aa17fd$var$ei();
                break;
            case 13:
                $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$M);
                break;
            case 19:
                $d3093f2493aa17fd$var$G($d3093f2493aa17fd$var$M);
                break;
            case 10:
                $d3093f2493aa17fd$var$lh(d.type._context);
                break;
            case 22:
            case 23:
                $d3093f2493aa17fd$var$wk();
        }
        c = c.return;
    }
    $d3093f2493aa17fd$var$Q = a;
    $d3093f2493aa17fd$var$Y = a = $d3093f2493aa17fd$var$Sh(a.current, null);
    $d3093f2493aa17fd$var$Z = $d3093f2493aa17fd$var$Sj = b;
    $d3093f2493aa17fd$var$T = 0;
    $d3093f2493aa17fd$var$jl = null;
    $d3093f2493aa17fd$var$ll = $d3093f2493aa17fd$var$kl = $d3093f2493aa17fd$var$Ch = 0;
    $d3093f2493aa17fd$var$nl = $d3093f2493aa17fd$var$ml = null;
    if (null !== $d3093f2493aa17fd$var$qh) {
        for(b = 0; b < $d3093f2493aa17fd$var$qh.length; b++)if (c = $d3093f2493aa17fd$var$qh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $d3093f2493aa17fd$var$qh = null;
    }
    return a;
}
function $d3093f2493aa17fd$var$Hl(a, b) {
    do {
        var c = $d3093f2493aa17fd$var$Y;
        try {
            $d3093f2493aa17fd$var$kh();
            $d3093f2493aa17fd$var$ki.current = $d3093f2493aa17fd$var$xi;
            if ($d3093f2493aa17fd$var$ni) {
                for(var d = $d3093f2493aa17fd$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $d3093f2493aa17fd$var$ni = !1;
            }
            $d3093f2493aa17fd$var$mi = 0;
            $d3093f2493aa17fd$var$P = $d3093f2493aa17fd$var$O = $d3093f2493aa17fd$var$N = null;
            $d3093f2493aa17fd$var$oi = !1;
            $d3093f2493aa17fd$var$pi = 0;
            $d3093f2493aa17fd$var$hl.current = null;
            if (null === c || null === c.return) {
                $d3093f2493aa17fd$var$T = 1;
                $d3093f2493aa17fd$var$jl = b;
                $d3093f2493aa17fd$var$Y = null;
                break;
            }
            c.mode & 2 && $d3093f2493aa17fd$var$pj(c, !0);
            $d3093f2493aa17fd$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markComponentSuspended && $d3093f2493aa17fd$var$B.markComponentSuspended(c, f, $d3093f2493aa17fd$var$Z);
            } else null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markComponentErrored && $d3093f2493aa17fd$var$B.markComponentErrored(c, b, $d3093f2493aa17fd$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $d3093f2493aa17fd$var$Z;
                k.flags |= 32768;
                $d3093f2493aa17fd$var$mc && $d3093f2493aa17fd$var$Fj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $d3093f2493aa17fd$var$Gj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $d3093f2493aa17fd$var$Hj(z, h, k, g, b);
                        z.mode & 1 && $d3093f2493aa17fd$var$Dj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $d3093f2493aa17fd$var$Dj(g, l, b);
                            $d3093f2493aa17fd$var$ik();
                            break a;
                        }
                        f = Error($d3093f2493aa17fd$var$p(426));
                    }
                } else if ($d3093f2493aa17fd$var$K && k.mode & 1) {
                    var C = $d3093f2493aa17fd$var$Gj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $d3093f2493aa17fd$var$Hj(C, h, k, g, b);
                        $d3093f2493aa17fd$var$dh($d3093f2493aa17fd$var$uj(f, k));
                        break a;
                    }
                }
                g = f = $d3093f2493aa17fd$var$uj(f, k);
                4 !== $d3093f2493aa17fd$var$T && ($d3093f2493aa17fd$var$T = 2);
                null === $d3093f2493aa17fd$var$ml ? $d3093f2493aa17fd$var$ml = [
                    g
                ] : $d3093f2493aa17fd$var$ml.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $d3093f2493aa17fd$var$yj(g, f, b);
                            $d3093f2493aa17fd$var$Ah(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $d3093f2493aa17fd$var$Cj || !$d3093f2493aa17fd$var$Cj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $d3093f2493aa17fd$var$Bj(g, k, b);
                                $d3093f2493aa17fd$var$Ah(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $d3093f2493aa17fd$var$Ol(c);
        } catch (da) {
            b = da;
            $d3093f2493aa17fd$var$Y === c && null !== c && ($d3093f2493aa17fd$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $d3093f2493aa17fd$var$El() {
    var a = $d3093f2493aa17fd$var$gl.current;
    $d3093f2493aa17fd$var$gl.current = $d3093f2493aa17fd$var$xi;
    return null === a ? $d3093f2493aa17fd$var$xi : a;
}
function $d3093f2493aa17fd$var$ik() {
    if (0 === $d3093f2493aa17fd$var$T || 3 === $d3093f2493aa17fd$var$T || 2 === $d3093f2493aa17fd$var$T) $d3093f2493aa17fd$var$T = 4;
    null === $d3093f2493aa17fd$var$Q || 0 === ($d3093f2493aa17fd$var$Ch & 268435455) && 0 === ($d3093f2493aa17fd$var$kl & 268435455) || $d3093f2493aa17fd$var$xl($d3093f2493aa17fd$var$Q, $d3093f2493aa17fd$var$Z);
}
function $d3093f2493aa17fd$var$Dl(a, b) {
    var c = $d3093f2493aa17fd$var$L;
    $d3093f2493aa17fd$var$L |= 2;
    var d = $d3093f2493aa17fd$var$El();
    if ($d3093f2493aa17fd$var$Q !== a || $d3093f2493aa17fd$var$Z !== b) {
        if ($d3093f2493aa17fd$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($d3093f2493aa17fd$var$Fj(a, $d3093f2493aa17fd$var$Z), e.clear());
            $d3093f2493aa17fd$var$Qc(a, b);
        }
        $d3093f2493aa17fd$var$ol = null;
        $d3093f2493aa17fd$var$Fl(a, b);
    }
    $d3093f2493aa17fd$var$wc(b);
    for(;;)try {
        $d3093f2493aa17fd$var$Pl();
        break;
    } catch (f) {
        $d3093f2493aa17fd$var$Hl(a, f);
    }
    $d3093f2493aa17fd$var$kh();
    $d3093f2493aa17fd$var$L = c;
    $d3093f2493aa17fd$var$gl.current = d;
    if (null !== $d3093f2493aa17fd$var$Y) throw Error($d3093f2493aa17fd$var$p(261));
    $d3093f2493aa17fd$var$xc();
    $d3093f2493aa17fd$var$Q = null;
    $d3093f2493aa17fd$var$Z = 0;
    return $d3093f2493aa17fd$var$T;
}
function $d3093f2493aa17fd$var$Pl() {
    for(; null !== $d3093f2493aa17fd$var$Y;)$d3093f2493aa17fd$var$Ql($d3093f2493aa17fd$var$Y);
}
function $d3093f2493aa17fd$var$Gl() {
    for(; null !== $d3093f2493aa17fd$var$Y && !$d3093f2493aa17fd$var$cc();)$d3093f2493aa17fd$var$Ql($d3093f2493aa17fd$var$Y);
}
function $d3093f2493aa17fd$var$Ql(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($d3093f2493aa17fd$var$lj = $d3093f2493aa17fd$var$ij(), 0 > a.actualStartTime && (a.actualStartTime = $d3093f2493aa17fd$var$ij()), b = $d3093f2493aa17fd$var$Rl(b, a, $d3093f2493aa17fd$var$Sj), $d3093f2493aa17fd$var$pj(a, !0)) : b = $d3093f2493aa17fd$var$Rl(b, a, $d3093f2493aa17fd$var$Sj);
    a.memoizedProps = a.pendingProps;
    null === b ? $d3093f2493aa17fd$var$Ol(a) : $d3093f2493aa17fd$var$Y = b;
    $d3093f2493aa17fd$var$hl.current = null;
}
function $d3093f2493aa17fd$var$Ol(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $d3093f2493aa17fd$var$tk(c, b, $d3093f2493aa17fd$var$Sj);
            else {
                var d = b;
                $d3093f2493aa17fd$var$lj = $d3093f2493aa17fd$var$ij();
                0 > d.actualStartTime && (d.actualStartTime = $d3093f2493aa17fd$var$ij());
                c = $d3093f2493aa17fd$var$tk(c, b, $d3093f2493aa17fd$var$Sj);
                $d3093f2493aa17fd$var$pj(b, !1);
            }
            if (null !== c) {
                $d3093f2493aa17fd$var$Y = c;
                return;
            }
        } else {
            c = $d3093f2493aa17fd$var$xk(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $d3093f2493aa17fd$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $d3093f2493aa17fd$var$pj(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $d3093f2493aa17fd$var$T = 6;
                $d3093f2493aa17fd$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $d3093f2493aa17fd$var$Y = b;
            return;
        }
        $d3093f2493aa17fd$var$Y = b = a;
    }while (null !== b);
    0 === $d3093f2493aa17fd$var$T && ($d3093f2493aa17fd$var$T = 5);
}
function $d3093f2493aa17fd$var$Ll(a, b, c) {
    var d = $d3093f2493aa17fd$var$E, e = $d3093f2493aa17fd$var$il.transition;
    try {
        $d3093f2493aa17fd$var$il.transition = null, $d3093f2493aa17fd$var$E = 1, $d3093f2493aa17fd$var$Sl(a, b, c, d);
    } finally{
        $d3093f2493aa17fd$var$il.transition = e, $d3093f2493aa17fd$var$E = d;
    }
    return null;
}
function $d3093f2493aa17fd$var$Sl(a, b, c, d) {
    do $d3093f2493aa17fd$var$Cl();
    while (null !== $d3093f2493aa17fd$var$ql);
    if (0 !== ($d3093f2493aa17fd$var$L & 6)) throw Error($d3093f2493aa17fd$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markCommitStarted && $d3093f2493aa17fd$var$B.markCommitStarted(e);
    if (null === c) return $d3093f2493aa17fd$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($d3093f2493aa17fd$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $d3093f2493aa17fd$var$Nc(a, f);
    a === $d3093f2493aa17fd$var$Q && ($d3093f2493aa17fd$var$Y = $d3093f2493aa17fd$var$Q = null, $d3093f2493aa17fd$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $d3093f2493aa17fd$var$pl || ($d3093f2493aa17fd$var$pl = !0, $d3093f2493aa17fd$var$Al($d3093f2493aa17fd$var$hc, function() {
        $d3093f2493aa17fd$var$Cl();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $d3093f2493aa17fd$var$il.transition;
        $d3093f2493aa17fd$var$il.transition = null;
        var g = $d3093f2493aa17fd$var$E;
        $d3093f2493aa17fd$var$E = 1;
        var h = $d3093f2493aa17fd$var$L;
        $d3093f2493aa17fd$var$L |= 4;
        $d3093f2493aa17fd$var$hl.current = null;
        $d3093f2493aa17fd$var$Hk(a, c);
        $d3093f2493aa17fd$var$jj = $d3093f2493aa17fd$var$ij();
        $d3093f2493aa17fd$var$Vk(a, c, e);
        $d3093f2493aa17fd$var$bf($d3093f2493aa17fd$var$Wf);
        $d3093f2493aa17fd$var$rd = !!$d3093f2493aa17fd$var$Vf;
        $d3093f2493aa17fd$var$Wf = $d3093f2493aa17fd$var$Vf = null;
        a.current = c;
        null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markLayoutEffectsStarted && $d3093f2493aa17fd$var$B.markLayoutEffectsStarted(e);
        $d3093f2493aa17fd$var$al(c, a, e);
        null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markLayoutEffectsStopped && $d3093f2493aa17fd$var$B.markLayoutEffectsStopped();
        $d3093f2493aa17fd$var$dc();
        $d3093f2493aa17fd$var$L = h;
        $d3093f2493aa17fd$var$E = g;
        $d3093f2493aa17fd$var$il.transition = f;
    } else a.current = c, $d3093f2493aa17fd$var$jj = $d3093f2493aa17fd$var$ij();
    $d3093f2493aa17fd$var$pl && ($d3093f2493aa17fd$var$pl = !1, $d3093f2493aa17fd$var$ql = a, $d3093f2493aa17fd$var$rl = e);
    f = a.pendingLanes;
    0 === f && ($d3093f2493aa17fd$var$Cj = null);
    $d3093f2493aa17fd$var$nc(c.stateNode, d);
    $d3093f2493aa17fd$var$mc && a.memoizedUpdaters.clear();
    $d3093f2493aa17fd$var$yl(a, $d3093f2493aa17fd$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($d3093f2493aa17fd$var$zj) throw $d3093f2493aa17fd$var$zj = !1, a = $d3093f2493aa17fd$var$Aj, $d3093f2493aa17fd$var$Aj = null, a;
    0 !== ($d3093f2493aa17fd$var$rl & 1) && 0 !== a.tag && $d3093f2493aa17fd$var$Cl();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($d3093f2493aa17fd$var$oj = !0, a === $d3093f2493aa17fd$var$ul ? $d3093f2493aa17fd$var$tl++ : ($d3093f2493aa17fd$var$tl = 0, $d3093f2493aa17fd$var$ul = a)) : $d3093f2493aa17fd$var$tl = 0;
    $d3093f2493aa17fd$var$Cg();
    $d3093f2493aa17fd$var$rc();
    return null;
}
function $d3093f2493aa17fd$var$Cl() {
    if (null !== $d3093f2493aa17fd$var$ql) {
        var a = $d3093f2493aa17fd$var$Rc($d3093f2493aa17fd$var$rl), b = $d3093f2493aa17fd$var$il.transition, c = $d3093f2493aa17fd$var$E;
        try {
            $d3093f2493aa17fd$var$il.transition = null;
            $d3093f2493aa17fd$var$E = 16 > a ? 16 : a;
            if (null === $d3093f2493aa17fd$var$ql) var d = !1;
            else {
                a = $d3093f2493aa17fd$var$ql;
                var e = $d3093f2493aa17fd$var$rl;
                $d3093f2493aa17fd$var$ql = null;
                $d3093f2493aa17fd$var$rl = 0;
                if (0 !== ($d3093f2493aa17fd$var$L & 6)) throw Error($d3093f2493aa17fd$var$p(331));
                null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markPassiveEffectsStarted && $d3093f2493aa17fd$var$B.markPassiveEffectsStarted(e);
                e = $d3093f2493aa17fd$var$L;
                $d3093f2493aa17fd$var$L |= 4;
                for($d3093f2493aa17fd$var$U = a.current; null !== $d3093f2493aa17fd$var$U;){
                    var f = $d3093f2493aa17fd$var$U, g = f.child;
                    if (0 !== ($d3093f2493aa17fd$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($d3093f2493aa17fd$var$U = l; null !== $d3093f2493aa17fd$var$U;){
                                    var n = $d3093f2493aa17fd$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($d3093f2493aa17fd$var$mj = $d3093f2493aa17fd$var$ij(), $d3093f2493aa17fd$var$Ik(8, q, f), $d3093f2493aa17fd$var$rj(q)) : $d3093f2493aa17fd$var$Ik(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $d3093f2493aa17fd$var$U = r;
                                    else for(; null !== $d3093f2493aa17fd$var$U;){
                                        n = $d3093f2493aa17fd$var$U;
                                        var z = n.sibling, m = n.return;
                                        $d3093f2493aa17fd$var$Lk(n);
                                        if (n === l) {
                                            $d3093f2493aa17fd$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $d3093f2493aa17fd$var$U = z;
                                            break;
                                        }
                                        $d3093f2493aa17fd$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $d3093f2493aa17fd$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $d3093f2493aa17fd$var$U = g;
                    else b: for(; null !== $d3093f2493aa17fd$var$U;){
                        f = $d3093f2493aa17fd$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($d3093f2493aa17fd$var$mj = $d3093f2493aa17fd$var$ij(), $d3093f2493aa17fd$var$Ik(9, k, k.return), $d3093f2493aa17fd$var$rj(k)) : $d3093f2493aa17fd$var$Ik(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $d3093f2493aa17fd$var$U = y;
                            break b;
                        }
                        $d3093f2493aa17fd$var$U = f.return;
                    }
                }
                var v = a.current;
                for($d3093f2493aa17fd$var$U = v; null !== $d3093f2493aa17fd$var$U;){
                    g = $d3093f2493aa17fd$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $d3093f2493aa17fd$var$U = D;
                    else b: for(g = v; null !== $d3093f2493aa17fd$var$U;){
                        h = $d3093f2493aa17fd$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $d3093f2493aa17fd$var$mj = $d3093f2493aa17fd$var$ij();
                                        try {
                                            $d3093f2493aa17fd$var$Jk(9, l);
                                        } finally{
                                            $d3093f2493aa17fd$var$rj(l);
                                        }
                                    } else $d3093f2493aa17fd$var$Jk(9, l);
                            }
                        } catch (Zj) {
                            $d3093f2493aa17fd$var$W(h, h.return, Zj);
                        }
                        if (h === g) {
                            $d3093f2493aa17fd$var$U = null;
                            break b;
                        }
                        var da = h.sibling;
                        if (null !== da) {
                            da.return = h.return;
                            $d3093f2493aa17fd$var$U = da;
                            break b;
                        }
                        $d3093f2493aa17fd$var$U = h.return;
                    }
                }
                v = $d3093f2493aa17fd$var$sl;
                $d3093f2493aa17fd$var$sl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Kl = V.id, Pi = V.onPostCommit;
                            da = $d3093f2493aa17fd$var$jj;
                            var Qi = null === R.alternate ? "mount" : "update";
                            $d3093f2493aa17fd$var$nj && (Qi = "nested-update");
                            "function" === typeof Pi && Pi(Kl, Qi, sa, da);
                            var ob = R.return;
                            b: for(; null !== ob;){
                                switch(ob.tag){
                                    case 3:
                                        ob.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        ob.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                ob = ob.return;
                            }
                    }
                }
                null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markPassiveEffectsStopped && $d3093f2493aa17fd$var$B.markPassiveEffectsStopped();
                $d3093f2493aa17fd$var$L = e;
                $d3093f2493aa17fd$var$Cg();
                if ($d3093f2493aa17fd$var$lc && "function" === typeof $d3093f2493aa17fd$var$lc.onPostCommitFiberRoot) try {
                    $d3093f2493aa17fd$var$lc.onPostCommitFiberRoot($d3093f2493aa17fd$var$kc, a);
                } catch (Zj) {}
                var ak = a.current.stateNode;
                ak.effectDuration = 0;
                ak.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $d3093f2493aa17fd$var$E = c, $d3093f2493aa17fd$var$il.transition = b;
        }
    }
    return !1;
}
function $d3093f2493aa17fd$var$el(a) {
    $d3093f2493aa17fd$var$sl.push(a);
    $d3093f2493aa17fd$var$pl || ($d3093f2493aa17fd$var$pl = !0, $d3093f2493aa17fd$var$Al($d3093f2493aa17fd$var$hc, function() {
        $d3093f2493aa17fd$var$Cl();
        return null;
    }));
}
function $d3093f2493aa17fd$var$Tl(a, b, c) {
    b = $d3093f2493aa17fd$var$uj(c, b);
    b = $d3093f2493aa17fd$var$yj(a, b, 1);
    a = $d3093f2493aa17fd$var$yh(a, b, 1);
    b = $d3093f2493aa17fd$var$Gh();
    null !== a && ($d3093f2493aa17fd$var$Mc(a, 1, b), $d3093f2493aa17fd$var$yl(a, b));
}
function $d3093f2493aa17fd$var$W(a, b, c) {
    if (3 === a.tag) $d3093f2493aa17fd$var$Tl(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $d3093f2493aa17fd$var$Tl(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $d3093f2493aa17fd$var$Cj || !$d3093f2493aa17fd$var$Cj.has(d))) {
                a = $d3093f2493aa17fd$var$uj(c, a);
                a = $d3093f2493aa17fd$var$Bj(b, a, 1);
                b = $d3093f2493aa17fd$var$yh(b, a, 1);
                a = $d3093f2493aa17fd$var$Gh();
                null !== b && ($d3093f2493aa17fd$var$Mc(b, 1, a), $d3093f2493aa17fd$var$yl(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $d3093f2493aa17fd$var$Ej(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $d3093f2493aa17fd$var$Gh();
    a.pingedLanes |= a.suspendedLanes & c;
    $d3093f2493aa17fd$var$Q === a && ($d3093f2493aa17fd$var$Z & c) === c && (4 === $d3093f2493aa17fd$var$T || 3 === $d3093f2493aa17fd$var$T && ($d3093f2493aa17fd$var$Z & 130023424) === $d3093f2493aa17fd$var$Z && 500 > $d3093f2493aa17fd$var$A() - $d3093f2493aa17fd$var$Zk ? $d3093f2493aa17fd$var$Fl(a, 0) : $d3093f2493aa17fd$var$ll |= c);
    $d3093f2493aa17fd$var$yl(a, b);
}
function $d3093f2493aa17fd$var$Ul(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $d3093f2493aa17fd$var$Ec, $d3093f2493aa17fd$var$Ec <<= 1, 0 === ($d3093f2493aa17fd$var$Ec & 130023424) && ($d3093f2493aa17fd$var$Ec = 4194304)));
    var c = $d3093f2493aa17fd$var$Gh();
    a = $d3093f2493aa17fd$var$th(a, b);
    null !== a && ($d3093f2493aa17fd$var$Mc(a, b, c), $d3093f2493aa17fd$var$yl(a, c));
}
function $d3093f2493aa17fd$var$jk(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $d3093f2493aa17fd$var$Ul(a, c);
}
function $d3093f2493aa17fd$var$Uk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($d3093f2493aa17fd$var$p(314));
    }
    null !== d && d.delete(b);
    $d3093f2493aa17fd$var$Ul(a, c);
}
var $d3093f2493aa17fd$var$Rl;
$d3093f2493aa17fd$var$Rl = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $d3093f2493aa17fd$var$og.current) $d3093f2493aa17fd$var$oh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $d3093f2493aa17fd$var$oh = !1, $d3093f2493aa17fd$var$nk(a, b, c);
            $d3093f2493aa17fd$var$oh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $d3093f2493aa17fd$var$oh = !1, $d3093f2493aa17fd$var$K && 0 !== (b.flags & 1048576) && $d3093f2493aa17fd$var$Ng(b, $d3093f2493aa17fd$var$Gg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $d3093f2493aa17fd$var$Vj(a, b);
            a = b.pendingProps;
            var e = $d3093f2493aa17fd$var$qg(b, $d3093f2493aa17fd$var$I.current);
            $d3093f2493aa17fd$var$nh(b, c);
            $d3093f2493aa17fd$var$sc(b);
            e = $d3093f2493aa17fd$var$ti(null, b, d, a, e, c);
            var f = $d3093f2493aa17fd$var$yi();
            $d3093f2493aa17fd$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $d3093f2493aa17fd$var$rg(d) ? (f = !0, $d3093f2493aa17fd$var$vg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $d3093f2493aa17fd$var$vh(b), e.updater = $d3093f2493aa17fd$var$Jh, b.stateNode = e, e._reactInternals = b, $d3093f2493aa17fd$var$Nh(b, d, a, c), b = $d3093f2493aa17fd$var$Wj(null, b, d, !0, f, c)) : (b.tag = 0, $d3093f2493aa17fd$var$K && f && $d3093f2493aa17fd$var$Og(b), $d3093f2493aa17fd$var$Jj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $d3093f2493aa17fd$var$Vj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $d3093f2493aa17fd$var$Vl(d);
                a = $d3093f2493aa17fd$var$fh(d, a);
                switch(e){
                    case 0:
                        b = $d3093f2493aa17fd$var$Pj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $d3093f2493aa17fd$var$Uj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $d3093f2493aa17fd$var$Kj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $d3093f2493aa17fd$var$Mj(null, b, d, $d3093f2493aa17fd$var$fh(d.type, a), c);
                        break a;
                }
                throw Error($d3093f2493aa17fd$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $d3093f2493aa17fd$var$fh(d, e), $d3093f2493aa17fd$var$Pj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $d3093f2493aa17fd$var$fh(d, e), $d3093f2493aa17fd$var$Uj(a, b, d, e, c);
        case 3:
            a: {
                $d3093f2493aa17fd$var$Xj(b);
                if (null === a) throw Error($d3093f2493aa17fd$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $d3093f2493aa17fd$var$wh(a, b);
                $d3093f2493aa17fd$var$Bh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $d3093f2493aa17fd$var$uj(Error($d3093f2493aa17fd$var$p(423)), b);
                        b = $d3093f2493aa17fd$var$Yj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $d3093f2493aa17fd$var$uj(Error($d3093f2493aa17fd$var$p(424)), b);
                        b = $d3093f2493aa17fd$var$Yj(a, b, d, c, e);
                        break a;
                    } else for($d3093f2493aa17fd$var$Qg = $d3093f2493aa17fd$var$dg(b.stateNode.containerInfo.firstChild), $d3093f2493aa17fd$var$J = b, $d3093f2493aa17fd$var$K = !0, $d3093f2493aa17fd$var$Sg = null, $d3093f2493aa17fd$var$Rg = !1, c = $d3093f2493aa17fd$var$Yh(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $d3093f2493aa17fd$var$ch();
                    if (d === e) {
                        b = $d3093f2493aa17fd$var$Lj(a, b, c);
                        break a;
                    }
                    $d3093f2493aa17fd$var$Jj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $d3093f2493aa17fd$var$fi(b), null === a && $d3093f2493aa17fd$var$Zg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $d3093f2493aa17fd$var$Xf(d, e) ? g = null : null !== f && $d3093f2493aa17fd$var$Xf(d, f) && (b.flags |= 32), $d3093f2493aa17fd$var$Tj(a, b), $d3093f2493aa17fd$var$Jj(a, b, g, c), b.child;
        case 6:
            return null === a && $d3093f2493aa17fd$var$Zg(b), null;
        case 13:
            return $d3093f2493aa17fd$var$dk(a, b, c);
        case 4:
            return $d3093f2493aa17fd$var$di(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $d3093f2493aa17fd$var$Xh(b, null, d, c) : $d3093f2493aa17fd$var$Jj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $d3093f2493aa17fd$var$fh(d, e), $d3093f2493aa17fd$var$Kj(a, b, d, e, c);
        case 7:
            return $d3093f2493aa17fd$var$Jj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $d3093f2493aa17fd$var$Jj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $d3093f2493aa17fd$var$Jj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $d3093f2493aa17fd$var$H($d3093f2493aa17fd$var$gh, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($d3093f2493aa17fd$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$d3093f2493aa17fd$var$og.current) {
                            b = $d3093f2493aa17fd$var$Lj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $d3093f2493aa17fd$var$xh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $d3093f2493aa17fd$var$mh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($d3093f2493aa17fd$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $d3093f2493aa17fd$var$mh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $d3093f2493aa17fd$var$Jj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $d3093f2493aa17fd$var$nh(b, c), e = $d3093f2493aa17fd$var$ph(e), $d3093f2493aa17fd$var$sc(b), d = d(e), $d3093f2493aa17fd$var$tc(), b.flags |= 1, $d3093f2493aa17fd$var$Jj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $d3093f2493aa17fd$var$fh(d, b.pendingProps), e = $d3093f2493aa17fd$var$fh(d.type, e), $d3093f2493aa17fd$var$Mj(a, b, d, e, c);
        case 15:
            return $d3093f2493aa17fd$var$Oj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $d3093f2493aa17fd$var$fh(d, e), $d3093f2493aa17fd$var$Vj(a, b), b.tag = 1, $d3093f2493aa17fd$var$rg(d) ? (a = !0, $d3093f2493aa17fd$var$vg(b)) : a = !1, $d3093f2493aa17fd$var$nh(b, c), $d3093f2493aa17fd$var$Lh(b, d, e), $d3093f2493aa17fd$var$Nh(b, d, e, c), $d3093f2493aa17fd$var$Wj(null, b, d, !0, a, c);
        case 19:
            return $d3093f2493aa17fd$var$mk(a, b, c);
        case 22:
            return $d3093f2493aa17fd$var$Qj(a, b, c);
    }
    throw Error($d3093f2493aa17fd$var$p(156, b.tag));
};
function $d3093f2493aa17fd$var$Fj(a, b) {
    $d3093f2493aa17fd$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $d3093f2493aa17fd$var$Pc(a, c, b);
    });
}
function $d3093f2493aa17fd$var$Al(a, b) {
    return $d3093f2493aa17fd$var$ac(a, b);
}
function $d3093f2493aa17fd$var$Wl(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $d3093f2493aa17fd$var$Vg(a, b, c, d) {
    return new $d3093f2493aa17fd$var$Wl(a, b, c, d);
}
function $d3093f2493aa17fd$var$Nj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $d3093f2493aa17fd$var$Vl(a) {
    if ("function" === typeof a) return $d3093f2493aa17fd$var$Nj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $d3093f2493aa17fd$var$Da) return 11;
        if (a === $d3093f2493aa17fd$var$Ga) return 14;
    }
    return 2;
}
function $d3093f2493aa17fd$var$Sh(a, b) {
    var c = a.alternate;
    null === c ? (c = $d3093f2493aa17fd$var$Vg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $d3093f2493aa17fd$var$Uh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $d3093f2493aa17fd$var$Nj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $d3093f2493aa17fd$var$ya:
            return $d3093f2493aa17fd$var$Wh(c.children, e, f, b);
        case $d3093f2493aa17fd$var$za:
            g = 8;
            e |= 8;
            break;
        case $d3093f2493aa17fd$var$Aa:
            return a = $d3093f2493aa17fd$var$Vg(12, c, b, e | 2), a.elementType = $d3093f2493aa17fd$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $d3093f2493aa17fd$var$Ea:
            return a = $d3093f2493aa17fd$var$Vg(13, c, b, e), a.elementType = $d3093f2493aa17fd$var$Ea, a.lanes = f, a;
        case $d3093f2493aa17fd$var$Fa:
            return a = $d3093f2493aa17fd$var$Vg(19, c, b, e), a.elementType = $d3093f2493aa17fd$var$Fa, a.lanes = f, a;
        case $d3093f2493aa17fd$var$Ia:
            return $d3093f2493aa17fd$var$ek(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $d3093f2493aa17fd$var$Ba:
                    g = 10;
                    break a;
                case $d3093f2493aa17fd$var$Ca:
                    g = 9;
                    break a;
                case $d3093f2493aa17fd$var$Da:
                    g = 11;
                    break a;
                case $d3093f2493aa17fd$var$Ga:
                    g = 14;
                    break a;
                case $d3093f2493aa17fd$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($d3093f2493aa17fd$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $d3093f2493aa17fd$var$Vg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $d3093f2493aa17fd$var$Wh(a, b, c, d) {
    a = $d3093f2493aa17fd$var$Vg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $d3093f2493aa17fd$var$ek(a, b, c, d) {
    a = $d3093f2493aa17fd$var$Vg(22, a, d, b);
    a.elementType = $d3093f2493aa17fd$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $d3093f2493aa17fd$var$Th(a, b, c) {
    a = $d3093f2493aa17fd$var$Vg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $d3093f2493aa17fd$var$Vh(a, b, c) {
    b = $d3093f2493aa17fd$var$Vg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $d3093f2493aa17fd$var$Xl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $d3093f2493aa17fd$var$Lc(0);
    this.expirationTimes = $d3093f2493aa17fd$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $d3093f2493aa17fd$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $d3093f2493aa17fd$var$Yl(a, b, c, d, e, f, g, h, k) {
    a = new $d3093f2493aa17fd$var$Xl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $d3093f2493aa17fd$var$mc && (b |= 2);
    f = $d3093f2493aa17fd$var$Vg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $d3093f2493aa17fd$var$vh(f);
    return a;
}
function $d3093f2493aa17fd$var$Zl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $d3093f2493aa17fd$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $d3093f2493aa17fd$var$$l(a) {
    if (!a) return $d3093f2493aa17fd$var$ng;
    a = a._reactInternals;
    a: {
        if ($d3093f2493aa17fd$var$Vb(a) !== a || 1 !== a.tag) throw Error($d3093f2493aa17fd$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($d3093f2493aa17fd$var$rg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($d3093f2493aa17fd$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($d3093f2493aa17fd$var$rg(c)) return $d3093f2493aa17fd$var$ug(a, c, b);
    }
    return b;
}
function $d3093f2493aa17fd$var$am(a, b, c, d, e, f, g, h, k) {
    a = $d3093f2493aa17fd$var$Yl(c, d, !0, a, e, f, g, h, k);
    a.context = $d3093f2493aa17fd$var$$l(null);
    c = a.current;
    d = $d3093f2493aa17fd$var$Gh();
    e = $d3093f2493aa17fd$var$Hh(c);
    f = $d3093f2493aa17fd$var$xh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $d3093f2493aa17fd$var$yh(c, f, e);
    a.current.lanes = e;
    $d3093f2493aa17fd$var$Mc(a, e, d);
    $d3093f2493aa17fd$var$yl(a, d);
    return a;
}
function $d3093f2493aa17fd$var$bm(a, b, c, d) {
    var e = b.current, f = $d3093f2493aa17fd$var$Gh(), g = $d3093f2493aa17fd$var$Hh(e);
    null !== $d3093f2493aa17fd$var$B && "function" === typeof $d3093f2493aa17fd$var$B.markRenderScheduled && $d3093f2493aa17fd$var$B.markRenderScheduled(g);
    c = $d3093f2493aa17fd$var$$l(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $d3093f2493aa17fd$var$xh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $d3093f2493aa17fd$var$yh(e, b, g);
    null !== a && ($d3093f2493aa17fd$var$Ih(a, e, g, f), $d3093f2493aa17fd$var$zh(a, e, g));
    return g;
}
function $d3093f2493aa17fd$var$cm(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $d3093f2493aa17fd$var$dm(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $d3093f2493aa17fd$var$em(a, b) {
    $d3093f2493aa17fd$var$dm(a, b);
    (a = a.alternate) && $d3093f2493aa17fd$var$dm(a, b);
}
function $d3093f2493aa17fd$var$fm() {
    return null;
}
var $d3093f2493aa17fd$var$gm = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $d3093f2493aa17fd$var$hm(a) {
    this._internalRoot = a;
}
$d3093f2493aa17fd$var$im.prototype.render = $d3093f2493aa17fd$var$hm.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($d3093f2493aa17fd$var$p(409));
    $d3093f2493aa17fd$var$bm(a, b, null, null);
};
$d3093f2493aa17fd$var$im.prototype.unmount = $d3093f2493aa17fd$var$hm.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $d3093f2493aa17fd$var$Nl(function() {
            $d3093f2493aa17fd$var$bm(null, a, null, null);
        });
        b[$d3093f2493aa17fd$var$If] = null;
    }
};
function $d3093f2493aa17fd$var$im(a) {
    this._internalRoot = a;
}
$d3093f2493aa17fd$var$im.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $d3093f2493aa17fd$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $d3093f2493aa17fd$var$dd.length && 0 !== b && b < $d3093f2493aa17fd$var$dd[c].priority; c++);
        $d3093f2493aa17fd$var$dd.splice(c, 0, a);
        0 === c && $d3093f2493aa17fd$var$id(a);
    }
};
function $d3093f2493aa17fd$var$jm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $d3093f2493aa17fd$var$km(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $d3093f2493aa17fd$var$lm() {}
function $d3093f2493aa17fd$var$mm(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $d3093f2493aa17fd$var$cm(g);
                f.call(a);
            };
        }
        var g = $d3093f2493aa17fd$var$am(b, d, a, 0, null, !1, !1, "", $d3093f2493aa17fd$var$lm);
        a._reactRootContainer = g;
        a[$d3093f2493aa17fd$var$If] = g.current;
        $d3093f2493aa17fd$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $d3093f2493aa17fd$var$Nl();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $d3093f2493aa17fd$var$cm(k);
            h.call(a);
        };
    }
    var k = $d3093f2493aa17fd$var$Yl(a, 0, !1, null, null, !1, !1, "", $d3093f2493aa17fd$var$lm);
    a._reactRootContainer = k;
    a[$d3093f2493aa17fd$var$If] = k.current;
    $d3093f2493aa17fd$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $d3093f2493aa17fd$var$Nl(function() {
        $d3093f2493aa17fd$var$bm(b, k, c, d);
    });
    return k;
}
function $d3093f2493aa17fd$var$nm(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $d3093f2493aa17fd$var$cm(g);
                h.call(a);
            };
        }
        $d3093f2493aa17fd$var$bm(b, g, a, e);
    } else g = $d3093f2493aa17fd$var$mm(c, b, a, e, d);
    return $d3093f2493aa17fd$var$cm(g);
}
$d3093f2493aa17fd$var$Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $d3093f2493aa17fd$var$Fc(b.pendingLanes);
                0 !== c && ($d3093f2493aa17fd$var$Oc(b, c | 1), $d3093f2493aa17fd$var$yl(b, $d3093f2493aa17fd$var$A()), 0 === ($d3093f2493aa17fd$var$L & 6) && ($d3093f2493aa17fd$var$vk = $d3093f2493aa17fd$var$A() + 500, $d3093f2493aa17fd$var$Cg()));
            }
            break;
        case 13:
            $d3093f2493aa17fd$var$Nl(function() {
                var b = $d3093f2493aa17fd$var$th(a, 1);
                if (null !== b) {
                    var c = $d3093f2493aa17fd$var$Gh();
                    $d3093f2493aa17fd$var$Ih(b, a, 1, c);
                }
            }), $d3093f2493aa17fd$var$em(a, 1);
    }
};
$d3093f2493aa17fd$var$Tc = function(a) {
    if (13 === a.tag) {
        var b = $d3093f2493aa17fd$var$th(a, 134217728);
        if (null !== b) {
            var c = $d3093f2493aa17fd$var$Gh();
            $d3093f2493aa17fd$var$Ih(b, a, 134217728, c);
        }
        $d3093f2493aa17fd$var$em(a, 134217728);
    }
};
$d3093f2493aa17fd$var$Uc = function(a) {
    if (13 === a.tag) {
        var b = $d3093f2493aa17fd$var$Hh(a), c = $d3093f2493aa17fd$var$th(a, b);
        if (null !== c) {
            var d = $d3093f2493aa17fd$var$Gh();
            $d3093f2493aa17fd$var$Ih(c, a, b, d);
        }
        $d3093f2493aa17fd$var$em(a, b);
    }
};
$d3093f2493aa17fd$var$Vc = function() {
    return $d3093f2493aa17fd$var$E;
};
$d3093f2493aa17fd$var$Wc = function(a, b) {
    var c = $d3093f2493aa17fd$var$E;
    try {
        return $d3093f2493aa17fd$var$E = a, b();
    } finally{
        $d3093f2493aa17fd$var$E = c;
    }
};
$d3093f2493aa17fd$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $d3093f2493aa17fd$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $d3093f2493aa17fd$var$Db(d);
                        if (!e) throw Error($d3093f2493aa17fd$var$p(90));
                        $d3093f2493aa17fd$var$Wa(d);
                        $d3093f2493aa17fd$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $d3093f2493aa17fd$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $d3093f2493aa17fd$var$eb(a, !!c.multiple, b, !1);
    }
};
$d3093f2493aa17fd$var$Gb = $d3093f2493aa17fd$var$Ml;
$d3093f2493aa17fd$var$Hb = $d3093f2493aa17fd$var$Nl;
var $d3093f2493aa17fd$var$om = {
    usingClientEntryPoint: !1,
    Events: [
        $d3093f2493aa17fd$var$Cb,
        $d3093f2493aa17fd$var$Ie,
        $d3093f2493aa17fd$var$Db,
        $d3093f2493aa17fd$var$Eb,
        $d3093f2493aa17fd$var$Fb,
        $d3093f2493aa17fd$var$Ml
    ]
}, $d3093f2493aa17fd$var$pm = {
    findFiberByHostInstance: $d3093f2493aa17fd$var$jd,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $d3093f2493aa17fd$var$u({}, a, {
            getLaneLabelMap: $d3093f2493aa17fd$var$pc,
            injectProfilingHooks: $d3093f2493aa17fd$var$oc
        }), $d3093f2493aa17fd$var$kc = b.inject(a), $d3093f2493aa17fd$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $d3093f2493aa17fd$var$pm.bundleType,
    version: $d3093f2493aa17fd$var$pm.version,
    rendererPackageName: $d3093f2493aa17fd$var$pm.rendererPackageName,
    rendererConfig: $d3093f2493aa17fd$var$pm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $d3093f2493aa17fd$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $d3093f2493aa17fd$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $d3093f2493aa17fd$var$pm.findFiberByHostInstance || $d3093f2493aa17fd$var$fm,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0"
});
$d3093f2493aa17fd$export$ae55be85d98224ed = $d3093f2493aa17fd$var$om;
$d3093f2493aa17fd$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$d3093f2493aa17fd$var$jm(b)) throw Error($d3093f2493aa17fd$var$p(200));
    return $d3093f2493aa17fd$var$Zl(a, b, null, c);
};
$d3093f2493aa17fd$export$882461b6382ed46c = function(a, b) {
    if (!$d3093f2493aa17fd$var$jm(a)) throw Error($d3093f2493aa17fd$var$p(299));
    var c = !1, d = "", e = $d3093f2493aa17fd$var$gm;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $d3093f2493aa17fd$var$Yl(a, 1, !1, null, null, c, !1, d, e);
    a[$d3093f2493aa17fd$var$If] = b.current;
    $d3093f2493aa17fd$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $d3093f2493aa17fd$var$hm(b);
};
$d3093f2493aa17fd$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($d3093f2493aa17fd$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($d3093f2493aa17fd$var$p(268, a));
    }
    a = $d3093f2493aa17fd$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$d3093f2493aa17fd$export$cd75ccfd720a3cd4 = function(a) {
    return $d3093f2493aa17fd$var$Nl(a);
};
$d3093f2493aa17fd$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$d3093f2493aa17fd$var$km(b)) throw Error($d3093f2493aa17fd$var$p(200));
    return $d3093f2493aa17fd$var$nm(null, a, b, !0, c);
};
$d3093f2493aa17fd$export$757ceba2d55c277e = function(a, b, c) {
    if (!$d3093f2493aa17fd$var$jm(a)) throw Error($d3093f2493aa17fd$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $d3093f2493aa17fd$var$gm;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $d3093f2493aa17fd$var$am(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$d3093f2493aa17fd$var$If] = b.current;
    $d3093f2493aa17fd$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $d3093f2493aa17fd$var$im(b);
};
$d3093f2493aa17fd$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$d3093f2493aa17fd$var$km(b)) throw Error($d3093f2493aa17fd$var$p(200));
    return $d3093f2493aa17fd$var$nm(null, a, b, !1, c);
};
$d3093f2493aa17fd$export$502457920280e6be = function(a) {
    if (!$d3093f2493aa17fd$var$km(a)) throw Error($d3093f2493aa17fd$var$p(40));
    return a._reactRootContainer ? ($d3093f2493aa17fd$var$Nl(function() {
        $d3093f2493aa17fd$var$nm(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$d3093f2493aa17fd$var$If] = null;
        });
    }), !0) : !1;
};
$d3093f2493aa17fd$export$c78a37762a8d58e1 = $d3093f2493aa17fd$var$Ml;
$d3093f2493aa17fd$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$d3093f2493aa17fd$var$km(c)) throw Error($d3093f2493aa17fd$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($d3093f2493aa17fd$var$p(38));
    return $d3093f2493aa17fd$var$nm(a, b, c, !1, d);
};
$d3093f2493aa17fd$export$83d89fbfd8236492 = "18.2.0";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});

parcelRegister("eggFB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2dETi"));

});

parcelRegister("2dETi", function(module, exports) {
$parcel$export(module.exports, "unstable_now", () => $19dc83c41971ef93$export$c4744153514ff05d, (v) => $19dc83c41971ef93$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $19dc83c41971ef93$export$3e506c1ccc9cc1a7, (v) => $19dc83c41971ef93$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $19dc83c41971ef93$export$e26fe2ed2fa76875, (v) => $19dc83c41971ef93$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $19dc83c41971ef93$export$502329bbf4b505b1, (v) => $19dc83c41971ef93$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $19dc83c41971ef93$export$6e3807111c4874c4, (v) => $19dc83c41971ef93$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $19dc83c41971ef93$export$c27134553091fb3a, (v) => $19dc83c41971ef93$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $19dc83c41971ef93$export$33ee1acdc04fd2a2, (v) => $19dc83c41971ef93$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $19dc83c41971ef93$export$b00a404bbd5edef2, (v) => $19dc83c41971ef93$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $19dc83c41971ef93$export$8352ce38b91d0c62, (v) => $19dc83c41971ef93$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $19dc83c41971ef93$export$d66a1c1c77bd778b, (v) => $19dc83c41971ef93$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $19dc83c41971ef93$export$d3dfb8e4810cb555, (v) => $19dc83c41971ef93$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $19dc83c41971ef93$export$839f9183b0465a69, (v) => $19dc83c41971ef93$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $19dc83c41971ef93$export$72fdf0e06517287b, (v) => $19dc83c41971ef93$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $19dc83c41971ef93$export$4b844e58a3e414b4, (v) => $19dc83c41971ef93$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $19dc83c41971ef93$export$816d2913ae6b83b1, (v) => $19dc83c41971ef93$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $19dc83c41971ef93$export$61bcfe829111a1d0, (v) => $19dc83c41971ef93$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $19dc83c41971ef93$export$7ee8c9beb337bc3f, (v) => $19dc83c41971ef93$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $19dc83c41971ef93$export$b5836b71941fa3ed, (v) => $19dc83c41971ef93$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $19dc83c41971ef93$export$cf845f2c119da08a, (v) => $19dc83c41971ef93$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $19dc83c41971ef93$export$c4744153514ff05d;
var $19dc83c41971ef93$export$3e506c1ccc9cc1a7;
var $19dc83c41971ef93$export$e26fe2ed2fa76875;
var $19dc83c41971ef93$export$502329bbf4b505b1;
var $19dc83c41971ef93$export$6e3807111c4874c4;
var $19dc83c41971ef93$export$c27134553091fb3a;
var $19dc83c41971ef93$export$33ee1acdc04fd2a2;
var $19dc83c41971ef93$export$b00a404bbd5edef2;
var $19dc83c41971ef93$export$8352ce38b91d0c62;
var $19dc83c41971ef93$export$d66a1c1c77bd778b;
var $19dc83c41971ef93$export$d3dfb8e4810cb555;
var $19dc83c41971ef93$export$839f9183b0465a69;
var $19dc83c41971ef93$export$72fdf0e06517287b;
var $19dc83c41971ef93$export$4b844e58a3e414b4;
var $19dc83c41971ef93$export$816d2913ae6b83b1;
var $19dc83c41971ef93$export$61bcfe829111a1d0;
var $19dc83c41971ef93$export$7ee8c9beb337bc3f;
var $19dc83c41971ef93$export$b5836b71941fa3ed;
var $19dc83c41971ef93$export$cf845f2c119da08a;
'use strict';
function $19dc83c41971ef93$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $19dc83c41971ef93$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $19dc83c41971ef93$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $19dc83c41971ef93$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $19dc83c41971ef93$var$g(C, c)) n < e && 0 > $19dc83c41971ef93$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $19dc83c41971ef93$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $19dc83c41971ef93$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $19dc83c41971ef93$var$l = performance;
    $19dc83c41971ef93$export$c4744153514ff05d = function() {
        return $19dc83c41971ef93$var$l.now();
    };
} else {
    var $19dc83c41971ef93$var$p = Date, $19dc83c41971ef93$var$q = $19dc83c41971ef93$var$p.now();
    $19dc83c41971ef93$export$c4744153514ff05d = function() {
        return $19dc83c41971ef93$var$p.now() - $19dc83c41971ef93$var$q;
    };
}
var $19dc83c41971ef93$var$r = [], $19dc83c41971ef93$var$t = [], $19dc83c41971ef93$var$u = 1, $19dc83c41971ef93$var$v = null, $19dc83c41971ef93$var$y = 3, $19dc83c41971ef93$var$z = !1, $19dc83c41971ef93$var$A = !1, $19dc83c41971ef93$var$B = !1, $19dc83c41971ef93$var$D = "function" === typeof setTimeout ? setTimeout : null, $19dc83c41971ef93$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $19dc83c41971ef93$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $19dc83c41971ef93$var$G(a) {
    for(var b = $19dc83c41971ef93$var$h($19dc83c41971ef93$var$t); null !== b;){
        if (null === b.callback) $19dc83c41971ef93$var$k($19dc83c41971ef93$var$t);
        else if (b.startTime <= a) $19dc83c41971ef93$var$k($19dc83c41971ef93$var$t), b.sortIndex = b.expirationTime, $19dc83c41971ef93$var$f($19dc83c41971ef93$var$r, b);
        else break;
        b = $19dc83c41971ef93$var$h($19dc83c41971ef93$var$t);
    }
}
function $19dc83c41971ef93$var$H(a) {
    $19dc83c41971ef93$var$B = !1;
    $19dc83c41971ef93$var$G(a);
    if (!$19dc83c41971ef93$var$A) {
        if (null !== $19dc83c41971ef93$var$h($19dc83c41971ef93$var$r)) $19dc83c41971ef93$var$A = !0, $19dc83c41971ef93$var$I($19dc83c41971ef93$var$J);
        else {
            var b = $19dc83c41971ef93$var$h($19dc83c41971ef93$var$t);
            null !== b && $19dc83c41971ef93$var$K($19dc83c41971ef93$var$H, b.startTime - a);
        }
    }
}
function $19dc83c41971ef93$var$J(a, b) {
    $19dc83c41971ef93$var$A = !1;
    $19dc83c41971ef93$var$B && ($19dc83c41971ef93$var$B = !1, $19dc83c41971ef93$var$E($19dc83c41971ef93$var$L), $19dc83c41971ef93$var$L = -1);
    $19dc83c41971ef93$var$z = !0;
    var c = $19dc83c41971ef93$var$y;
    try {
        $19dc83c41971ef93$var$G(b);
        for($19dc83c41971ef93$var$v = $19dc83c41971ef93$var$h($19dc83c41971ef93$var$r); null !== $19dc83c41971ef93$var$v && (!($19dc83c41971ef93$var$v.expirationTime > b) || a && !$19dc83c41971ef93$var$M());){
            var d = $19dc83c41971ef93$var$v.callback;
            if ("function" === typeof d) {
                $19dc83c41971ef93$var$v.callback = null;
                $19dc83c41971ef93$var$y = $19dc83c41971ef93$var$v.priorityLevel;
                var e = d($19dc83c41971ef93$var$v.expirationTime <= b);
                b = $19dc83c41971ef93$export$c4744153514ff05d();
                "function" === typeof e ? $19dc83c41971ef93$var$v.callback = e : $19dc83c41971ef93$var$v === $19dc83c41971ef93$var$h($19dc83c41971ef93$var$r) && $19dc83c41971ef93$var$k($19dc83c41971ef93$var$r);
                $19dc83c41971ef93$var$G(b);
            } else $19dc83c41971ef93$var$k($19dc83c41971ef93$var$r);
            $19dc83c41971ef93$var$v = $19dc83c41971ef93$var$h($19dc83c41971ef93$var$r);
        }
        if (null !== $19dc83c41971ef93$var$v) var w = !0;
        else {
            var m = $19dc83c41971ef93$var$h($19dc83c41971ef93$var$t);
            null !== m && $19dc83c41971ef93$var$K($19dc83c41971ef93$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $19dc83c41971ef93$var$v = null, $19dc83c41971ef93$var$y = c, $19dc83c41971ef93$var$z = !1;
    }
}
var $19dc83c41971ef93$var$N = !1, $19dc83c41971ef93$var$O = null, $19dc83c41971ef93$var$L = -1, $19dc83c41971ef93$var$P = 5, $19dc83c41971ef93$var$Q = -1;
function $19dc83c41971ef93$var$M() {
    return $19dc83c41971ef93$export$c4744153514ff05d() - $19dc83c41971ef93$var$Q < $19dc83c41971ef93$var$P ? !1 : !0;
}
function $19dc83c41971ef93$var$R() {
    if (null !== $19dc83c41971ef93$var$O) {
        var a = $19dc83c41971ef93$export$c4744153514ff05d();
        $19dc83c41971ef93$var$Q = a;
        var b = !0;
        try {
            b = $19dc83c41971ef93$var$O(!0, a);
        } finally{
            b ? $19dc83c41971ef93$var$S() : ($19dc83c41971ef93$var$N = !1, $19dc83c41971ef93$var$O = null);
        }
    } else $19dc83c41971ef93$var$N = !1;
}
var $19dc83c41971ef93$var$S;
if ("function" === typeof $19dc83c41971ef93$var$F) $19dc83c41971ef93$var$S = function() {
    $19dc83c41971ef93$var$F($19dc83c41971ef93$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $19dc83c41971ef93$var$T = new MessageChannel, $19dc83c41971ef93$var$U = $19dc83c41971ef93$var$T.port2;
    $19dc83c41971ef93$var$T.port1.onmessage = $19dc83c41971ef93$var$R;
    $19dc83c41971ef93$var$S = function() {
        $19dc83c41971ef93$var$U.postMessage(null);
    };
} else $19dc83c41971ef93$var$S = function() {
    $19dc83c41971ef93$var$D($19dc83c41971ef93$var$R, 0);
};
function $19dc83c41971ef93$var$I(a) {
    $19dc83c41971ef93$var$O = a;
    $19dc83c41971ef93$var$N || ($19dc83c41971ef93$var$N = !0, $19dc83c41971ef93$var$S());
}
function $19dc83c41971ef93$var$K(a, b) {
    $19dc83c41971ef93$var$L = $19dc83c41971ef93$var$D(function() {
        a($19dc83c41971ef93$export$c4744153514ff05d());
    }, b);
}
$19dc83c41971ef93$export$3e506c1ccc9cc1a7 = 5;
$19dc83c41971ef93$export$e26fe2ed2fa76875 = 1;
$19dc83c41971ef93$export$502329bbf4b505b1 = 4;
$19dc83c41971ef93$export$6e3807111c4874c4 = 3;
$19dc83c41971ef93$export$c27134553091fb3a = null;
$19dc83c41971ef93$export$33ee1acdc04fd2a2 = 2;
$19dc83c41971ef93$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$19dc83c41971ef93$export$8352ce38b91d0c62 = function() {
    $19dc83c41971ef93$var$A || $19dc83c41971ef93$var$z || ($19dc83c41971ef93$var$A = !0, $19dc83c41971ef93$var$I($19dc83c41971ef93$var$J));
};
$19dc83c41971ef93$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $19dc83c41971ef93$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$19dc83c41971ef93$export$d3dfb8e4810cb555 = function() {
    return $19dc83c41971ef93$var$y;
};
$19dc83c41971ef93$export$839f9183b0465a69 = function() {
    return $19dc83c41971ef93$var$h($19dc83c41971ef93$var$r);
};
$19dc83c41971ef93$export$72fdf0e06517287b = function(a) {
    switch($19dc83c41971ef93$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $19dc83c41971ef93$var$y;
    }
    var c = $19dc83c41971ef93$var$y;
    $19dc83c41971ef93$var$y = b;
    try {
        return a();
    } finally{
        $19dc83c41971ef93$var$y = c;
    }
};
$19dc83c41971ef93$export$4b844e58a3e414b4 = function() {};
$19dc83c41971ef93$export$816d2913ae6b83b1 = function() {};
$19dc83c41971ef93$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $19dc83c41971ef93$var$y;
    $19dc83c41971ef93$var$y = a;
    try {
        return b();
    } finally{
        $19dc83c41971ef93$var$y = c;
    }
};
$19dc83c41971ef93$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $19dc83c41971ef93$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $19dc83c41971ef93$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $19dc83c41971ef93$var$f($19dc83c41971ef93$var$t, a), null === $19dc83c41971ef93$var$h($19dc83c41971ef93$var$r) && a === $19dc83c41971ef93$var$h($19dc83c41971ef93$var$t) && ($19dc83c41971ef93$var$B ? ($19dc83c41971ef93$var$E($19dc83c41971ef93$var$L), $19dc83c41971ef93$var$L = -1) : $19dc83c41971ef93$var$B = !0, $19dc83c41971ef93$var$K($19dc83c41971ef93$var$H, c - d))) : (a.sortIndex = e, $19dc83c41971ef93$var$f($19dc83c41971ef93$var$r, a), $19dc83c41971ef93$var$A || $19dc83c41971ef93$var$z || ($19dc83c41971ef93$var$A = !0, $19dc83c41971ef93$var$I($19dc83c41971ef93$var$J)));
    return a;
};
$19dc83c41971ef93$export$b5836b71941fa3ed = $19dc83c41971ef93$var$M;
$19dc83c41971ef93$export$cf845f2c119da08a = function(a) {
    var b = $19dc83c41971ef93$var$y;
    return function() {
        var c = $19dc83c41971ef93$var$y;
        $19dc83c41971ef93$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $19dc83c41971ef93$var$y = c;
        }
    };
};

});

parcelRegister("egy7N", function(module, exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $aa0c3aea4a52e28d$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $aa0c3aea4a52e28d$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $aa0c3aea4a52e28d$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($aa0c3aea4a52e28d$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $aa0c3aea4a52e28d$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


/**
 * @param {number}
 * @return {number}
 */ var $8d6ec0e25b95c4c2$export$2335f513bbd82c6d = Math.abs;
var $8d6ec0e25b95c4c2$export$6788812c4e6611e6 = String.fromCharCode;
var $8d6ec0e25b95c4c2$export$e6e34fd1f2686227 = Object.assign;
function $8d6ec0e25b95c4c2$export$d6af199866bfb566(value, length) {
    return $8d6ec0e25b95c4c2$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $8d6ec0e25b95c4c2$export$a9db5e087081082d(value, 0)) << 2 ^ $8d6ec0e25b95c4c2$export$a9db5e087081082d(value, 1)) << 2 ^ $8d6ec0e25b95c4c2$export$a9db5e087081082d(value, 2)) << 2 ^ $8d6ec0e25b95c4c2$export$a9db5e087081082d(value, 3) : 0;
}
function $8d6ec0e25b95c4c2$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $8d6ec0e25b95c4c2$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $8d6ec0e25b95c4c2$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $8d6ec0e25b95c4c2$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $8d6ec0e25b95c4c2$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $8d6ec0e25b95c4c2$export$36776f635604f274(value) {
    return value.length;
}
function $8d6ec0e25b95c4c2$export$f9084667e487ed46(value) {
    return value.length;
}
function $8d6ec0e25b95c4c2$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $8d6ec0e25b95c4c2$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}


var $41cf24261f4c36e3$export$53f1d5ea8de3d7c = 1;
var $41cf24261f4c36e3$export$4e0c71f277ca26b3 = 1;
var $41cf24261f4c36e3$export$f24224f1c91d8156 = 0;
var $41cf24261f4c36e3$export$5880b8b5730aff45 = 0;
var $41cf24261f4c36e3$export$c0306caf338ac095 = 0;
var $41cf24261f4c36e3$export$30a86d91af8ff6e6 = '';
function $41cf24261f4c36e3$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $41cf24261f4c36e3$export$53f1d5ea8de3d7c,
        column: $41cf24261f4c36e3$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $41cf24261f4c36e3$export$784d13d8ee351f07(root, props) {
    return (0, $8d6ec0e25b95c4c2$export$e6e34fd1f2686227)($41cf24261f4c36e3$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $41cf24261f4c36e3$export$eba6f6f03b0a92e7() {
    return $41cf24261f4c36e3$export$c0306caf338ac095;
}
function $41cf24261f4c36e3$export$232faf9add678146() {
    $41cf24261f4c36e3$export$c0306caf338ac095 = $41cf24261f4c36e3$export$5880b8b5730aff45 > 0 ? (0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)($41cf24261f4c36e3$export$30a86d91af8ff6e6, --$41cf24261f4c36e3$export$5880b8b5730aff45) : 0;
    if ($41cf24261f4c36e3$export$4e0c71f277ca26b3--, $41cf24261f4c36e3$export$c0306caf338ac095 === 10) $41cf24261f4c36e3$export$4e0c71f277ca26b3 = 1, $41cf24261f4c36e3$export$53f1d5ea8de3d7c--;
    return $41cf24261f4c36e3$export$c0306caf338ac095;
}
function $41cf24261f4c36e3$export$48cfd1e771a65c4f() {
    $41cf24261f4c36e3$export$c0306caf338ac095 = $41cf24261f4c36e3$export$5880b8b5730aff45 < $41cf24261f4c36e3$export$f24224f1c91d8156 ? (0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)($41cf24261f4c36e3$export$30a86d91af8ff6e6, $41cf24261f4c36e3$export$5880b8b5730aff45++) : 0;
    if ($41cf24261f4c36e3$export$4e0c71f277ca26b3++, $41cf24261f4c36e3$export$c0306caf338ac095 === 10) $41cf24261f4c36e3$export$4e0c71f277ca26b3 = 1, $41cf24261f4c36e3$export$53f1d5ea8de3d7c++;
    return $41cf24261f4c36e3$export$c0306caf338ac095;
}
function $41cf24261f4c36e3$export$4d3fb11e950abb9e() {
    return (0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)($41cf24261f4c36e3$export$30a86d91af8ff6e6, $41cf24261f4c36e3$export$5880b8b5730aff45);
}
function $41cf24261f4c36e3$export$e88cb2efb12ae807() {
    return $41cf24261f4c36e3$export$5880b8b5730aff45;
}
function $41cf24261f4c36e3$export$58adb3bec8346d0f(begin, end) {
    return (0, $8d6ec0e25b95c4c2$export$2f35ab04d2335697)($41cf24261f4c36e3$export$30a86d91af8ff6e6, begin, end);
}
function $41cf24261f4c36e3$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $41cf24261f4c36e3$export$2de70f21292aac9e(value) {
    return $41cf24261f4c36e3$export$53f1d5ea8de3d7c = $41cf24261f4c36e3$export$4e0c71f277ca26b3 = 1, $41cf24261f4c36e3$export$f24224f1c91d8156 = (0, $8d6ec0e25b95c4c2$export$36776f635604f274)($41cf24261f4c36e3$export$30a86d91af8ff6e6 = value), $41cf24261f4c36e3$export$5880b8b5730aff45 = 0, [];
}
function $41cf24261f4c36e3$export$45918ac1574455b1(value) {
    return $41cf24261f4c36e3$export$30a86d91af8ff6e6 = '', value;
}
function $41cf24261f4c36e3$export$410ac95b9ec204b8(type) {
    return (0, $8d6ec0e25b95c4c2$export$87c2784dc9fc4ab)($41cf24261f4c36e3$export$58adb3bec8346d0f($41cf24261f4c36e3$export$5880b8b5730aff45 - 1, $41cf24261f4c36e3$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $41cf24261f4c36e3$export$660b2ee2d4fb4eff(value) {
    return $41cf24261f4c36e3$export$45918ac1574455b1($41cf24261f4c36e3$export$5f8c09e3ae6f64e1($41cf24261f4c36e3$export$2de70f21292aac9e(value)));
}
function $41cf24261f4c36e3$export$7af1228ff777d175(type) {
    while($41cf24261f4c36e3$export$c0306caf338ac095 = $41cf24261f4c36e3$export$4d3fb11e950abb9e())if ($41cf24261f4c36e3$export$c0306caf338ac095 < 33) $41cf24261f4c36e3$export$48cfd1e771a65c4f();
    else break;
    return $41cf24261f4c36e3$export$9e1725a4cfeada27(type) > 2 || $41cf24261f4c36e3$export$9e1725a4cfeada27($41cf24261f4c36e3$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $41cf24261f4c36e3$export$5f8c09e3ae6f64e1(children) {
    while($41cf24261f4c36e3$export$48cfd1e771a65c4f())switch($41cf24261f4c36e3$export$9e1725a4cfeada27($41cf24261f4c36e3$export$c0306caf338ac095)){
        case 0:
            (0, $8d6ec0e25b95c4c2$export$10d8903dec122b9d)($41cf24261f4c36e3$export$c2ab62c7bf24634($41cf24261f4c36e3$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $8d6ec0e25b95c4c2$export$10d8903dec122b9d)($41cf24261f4c36e3$export$410ac95b9ec204b8($41cf24261f4c36e3$export$c0306caf338ac095), children);
            break;
        default:
            (0, $8d6ec0e25b95c4c2$export$10d8903dec122b9d)((0, $8d6ec0e25b95c4c2$export$6788812c4e6611e6)($41cf24261f4c36e3$export$c0306caf338ac095), children);
    }
    return children;
}
function $41cf24261f4c36e3$export$955ba06d119e085e(index, count) {
    while(--count && $41cf24261f4c36e3$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($41cf24261f4c36e3$export$c0306caf338ac095 < 48 || $41cf24261f4c36e3$export$c0306caf338ac095 > 102 || $41cf24261f4c36e3$export$c0306caf338ac095 > 57 && $41cf24261f4c36e3$export$c0306caf338ac095 < 65 || $41cf24261f4c36e3$export$c0306caf338ac095 > 70 && $41cf24261f4c36e3$export$c0306caf338ac095 < 97) break;
    return $41cf24261f4c36e3$export$58adb3bec8346d0f(index, $41cf24261f4c36e3$export$e88cb2efb12ae807() + (count < 6 && $41cf24261f4c36e3$export$4d3fb11e950abb9e() == 32 && $41cf24261f4c36e3$export$48cfd1e771a65c4f() == 32));
}
function $41cf24261f4c36e3$export$c889f2fcc19dbf12(type) {
    while($41cf24261f4c36e3$export$48cfd1e771a65c4f())switch($41cf24261f4c36e3$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $41cf24261f4c36e3$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $41cf24261f4c36e3$export$c889f2fcc19dbf12($41cf24261f4c36e3$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $41cf24261f4c36e3$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $41cf24261f4c36e3$export$48cfd1e771a65c4f();
            break;
    }
    return $41cf24261f4c36e3$export$5880b8b5730aff45;
}
function $41cf24261f4c36e3$export$4254d4e2b3745c4c(type, index) {
    while($41cf24261f4c36e3$export$48cfd1e771a65c4f())// //
    if (type + $41cf24261f4c36e3$export$c0306caf338ac095 === 57) break;
    else if (type + $41cf24261f4c36e3$export$c0306caf338ac095 === 84 && $41cf24261f4c36e3$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $41cf24261f4c36e3$export$58adb3bec8346d0f(index, $41cf24261f4c36e3$export$5880b8b5730aff45 - 1) + '*' + (0, $8d6ec0e25b95c4c2$export$6788812c4e6611e6)(type === 47 ? type : $41cf24261f4c36e3$export$48cfd1e771a65c4f());
}
function $41cf24261f4c36e3$export$c2ab62c7bf24634(index) {
    while(!$41cf24261f4c36e3$export$9e1725a4cfeada27($41cf24261f4c36e3$export$4d3fb11e950abb9e()))$41cf24261f4c36e3$export$48cfd1e771a65c4f();
    return $41cf24261f4c36e3$export$58adb3bec8346d0f(index, $41cf24261f4c36e3$export$5880b8b5730aff45);
}

var $f7cca8c9202aa514$export$71ad59f2e432cfe8 = '-ms-';
var $f7cca8c9202aa514$export$2c0f367103c8d01c = '-moz-';
var $f7cca8c9202aa514$export$39dfd62a25e0fe93 = '-webkit-';
var $f7cca8c9202aa514$export$a29989082612d0d9 = 'comm';
var $f7cca8c9202aa514$export$aa3a2e812ca8570d = 'rule';
var $f7cca8c9202aa514$export$527d108ccf083c2b = 'decl';
var $f7cca8c9202aa514$export$d3d35020fa5b54f0 = '@page';
var $f7cca8c9202aa514$export$500415a86c544f73 = '@media';
var $f7cca8c9202aa514$export$a763edbf796b780a = '@import';
var $f7cca8c9202aa514$export$2790aeb8b4e5c826 = '@charset';
var $f7cca8c9202aa514$export$1cc683e23b84b133 = '@viewport';
var $f7cca8c9202aa514$export$9447a5efea57e862 = '@supports';
var $f7cca8c9202aa514$export$ef011b4e114b1fba = '@document';
var $f7cca8c9202aa514$export$6aad947bda0f3f46 = '@namespace';
var $f7cca8c9202aa514$export$b44a8529a35fcb60 = '@keyframes';
var $f7cca8c9202aa514$export$2c16de31893252e6 = '@font-face';
var $f7cca8c9202aa514$export$3d846dd52e150c6f = '@counter-style';
var $f7cca8c9202aa514$export$22314bfbb57653fe = '@font-feature-values';
var $f7cca8c9202aa514$export$d773506282b3cfe6 = '@layer';




function $ca8387d01b3ff8a8$export$ef7acd7185315e22(value) {
    return (0, $41cf24261f4c36e3$export$45918ac1574455b1)($ca8387d01b3ff8a8$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $41cf24261f4c36e3$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $ca8387d01b3ff8a8$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $41cf24261f4c36e3$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $8d6ec0e25b95c4c2$export$f8e21b1e77979a08)(characters += (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)((0, $41cf24261f4c36e3$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $41cf24261f4c36e3$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $41cf24261f4c36e3$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $41cf24261f4c36e3$export$955ba06d119e085e)((0, $41cf24261f4c36e3$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $41cf24261f4c36e3$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $8d6ec0e25b95c4c2$export$10d8903dec122b9d)($ca8387d01b3ff8a8$export$4a34f930e789283c((0, $41cf24261f4c36e3$export$4254d4e2b3745c4c)((0, $41cf24261f4c36e3$export$48cfd1e771a65c4f)(), (0, $41cf24261f4c36e3$export$e88cb2efb12ae807)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $8d6ec0e25b95c4c2$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && (0, $8d6ec0e25b95c4c2$export$36776f635604f274)(characters) - length) (0, $8d6ec0e25b95c4c2$export$10d8903dec122b9d)(property > 32 ? $ca8387d01b3ff8a8$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $ca8387d01b3ff8a8$export$f8483753829ec8f3((0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $8d6ec0e25b95c4c2$export$10d8903dec122b9d)(reference = $ca8387d01b3ff8a8$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $ca8387d01b3ff8a8$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $ca8387d01b3ff8a8$export$98e6a39c04603d36(value, reference, reference, rule && (0, $8d6ec0e25b95c4c2$export$10d8903dec122b9d)($ca8387d01b3ff8a8$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $ca8387d01b3ff8a8$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $8d6ec0e25b95c4c2$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $41cf24261f4c36e3$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $8d6ec0e25b95c4c2$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $8d6ec0e25b95c4c2$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $41cf24261f4c36e3$export$4d3fb11e950abb9e)() === 45) characters += (0, $41cf24261f4c36e3$export$410ac95b9ec204b8)((0, $41cf24261f4c36e3$export$48cfd1e771a65c4f)());
                    atrule = (0, $41cf24261f4c36e3$export$4d3fb11e950abb9e)(), offset = length = (0, $8d6ec0e25b95c4c2$export$36776f635604f274)(type = characters += (0, $41cf24261f4c36e3$export$c2ab62c7bf24634)((0, $41cf24261f4c36e3$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $8d6ec0e25b95c4c2$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $ca8387d01b3ff8a8$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $8d6ec0e25b95c4c2$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $8d6ec0e25b95c4c2$export$2f35ab04d2335697)(value, post + 1, post = (0, $8d6ec0e25b95c4c2$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $8d6ec0e25b95c4c2$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $41cf24261f4c36e3$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $f7cca8c9202aa514$export$aa3a2e812ca8570d) : type, props, children, length);
}
function $ca8387d01b3ff8a8$export$4a34f930e789283c(value, root, parent) {
    return (0, $41cf24261f4c36e3$export$35059013cd4a06db)(value, root, parent, (0, $f7cca8c9202aa514$export$a29989082612d0d9), (0, $8d6ec0e25b95c4c2$export$6788812c4e6611e6)((0, $41cf24261f4c36e3$export$eba6f6f03b0a92e7)()), (0, $8d6ec0e25b95c4c2$export$2f35ab04d2335697)(value, 2, -2), 0);
}
function $ca8387d01b3ff8a8$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $41cf24261f4c36e3$export$35059013cd4a06db)(value, root, parent, (0, $f7cca8c9202aa514$export$527d108ccf083c2b), (0, $8d6ec0e25b95c4c2$export$2f35ab04d2335697)(value, 0, length), (0, $8d6ec0e25b95c4c2$export$2f35ab04d2335697)(value, length + 1, -1), length);
}






function $258a89ae7b032a40$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $8d6ec0e25b95c4c2$export$f9084667e487ed46)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $258a89ae7b032a40$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $f7cca8c9202aa514$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $f7cca8c9202aa514$export$a763edbf796b780a:
        case 0, $f7cca8c9202aa514$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $f7cca8c9202aa514$export$a29989082612d0d9:
            return '';
        case 0, $f7cca8c9202aa514$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $258a89ae7b032a40$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $f7cca8c9202aa514$export$aa3a2e812ca8570d:
            element.value = element.props.join(',');
    }
    return (0, $8d6ec0e25b95c4c2$export$36776f635604f274)(children = $258a89ae7b032a40$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $6490cfa69877f232$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $8d6ec0e25b95c4c2$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + value;
        // tab-size
        case 4789:
            return (0, $f7cca8c9202aa514$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$2c0f367103c8d01c) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $8d6ec0e25b95c4c2$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + 'box-' + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)((0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)((0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)((0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $8d6ec0e25b95c4c2$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $8d6ec0e25b95c4c2$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $8d6ec0e25b95c4c2$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $8d6ec0e25b95c4c2$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span') ? value : (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $8d6ec0e25b95c4c2$export$f8e21b1e77979a08)(children, 'span') ? (0, $8d6ec0e25b95c4c2$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $8d6ec0e25b95c4c2$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $8d6ec0e25b95c4c2$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $8d6ec0e25b95c4c2$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)((0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $8d6ec0e25b95c4c2$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $f7cca8c9202aa514$export$2c0f367103c8d01c) + ((0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $8d6ec0e25b95c4c2$export$f8e21b1e77979a08)(value, 'stretch') ? $6490cfa69877f232$export$82e9f45cca5ba907((0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(value, (0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + ((0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $42e7c989d27ab7fb$export$5a7767152ae0305f(collection) {
    var length = (0, $8d6ec0e25b95c4c2$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $42e7c989d27ab7fb$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $42e7c989d27ab7fb$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $f7cca8c9202aa514$export$527d108ccf083c2b:
                element.return = (0, $6490cfa69877f232$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $f7cca8c9202aa514$export$b44a8529a35fcb60:
                return (0, $258a89ae7b032a40$export$dfdc1655ccc5b9cb)([
                    (0, $41cf24261f4c36e3$export$784d13d8ee351f07)(element, {
                        value: (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $f7cca8c9202aa514$export$aa3a2e812ca8570d:
                if (element.length) return (0, $8d6ec0e25b95c4c2$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $8d6ec0e25b95c4c2$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $258a89ae7b032a40$export$dfdc1655ccc5b9cb)([
                                (0, $41cf24261f4c36e3$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $f7cca8c9202aa514$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $258a89ae7b032a40$export$dfdc1655ccc5b9cb)([
                                (0, $41cf24261f4c36e3$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $41cf24261f4c36e3$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $f7cca8c9202aa514$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $41cf24261f4c36e3$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $42e7c989d27ab7fb$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $f7cca8c9202aa514$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $8d6ec0e25b95c4c2$export$1be1fc439b849fdf)((0, $41cf24261f4c36e3$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $8d6ec0e25b95c4c2$export$2f35ab04d2335697)(value, 1, (0, $8d6ec0e25b95c4c2$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $8d6ec0e25b95c4c2$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $8d6ec0e25b95c4c2$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $8d6ec0e25b95c4c2$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}


parcelRequire("jZwD7");

function $c2b9fc5ab06d88a2$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $a62d07c2ecbe428b$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $41cf24261f4c36e3$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $41cf24261f4c36e3$export$9e1725a4cfeada27)(character)) break;
        (0, $41cf24261f4c36e3$export$48cfd1e771a65c4f)();
    }
    return (0, $41cf24261f4c36e3$export$58adb3bec8346d0f)(begin, (0, $41cf24261f4c36e3$export$5880b8b5730aff45));
};
var $a62d07c2ecbe428b$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $41cf24261f4c36e3$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $41cf24261f4c36e3$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $a62d07c2ecbe428b$var$identifierWithPointTracking((0, $41cf24261f4c36e3$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $41cf24261f4c36e3$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $41cf24261f4c36e3$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $8d6ec0e25b95c4c2$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $41cf24261f4c36e3$export$48cfd1e771a65c4f)());
    return parsed;
};
var $a62d07c2ecbe428b$var$getRules = function getRules(value, points) {
    return (0, $41cf24261f4c36e3$export$45918ac1574455b1)($a62d07c2ecbe428b$var$toRules((0, $41cf24261f4c36e3$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $a62d07c2ecbe428b$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $a62d07c2ecbe428b$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$a62d07c2ecbe428b$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $a62d07c2ecbe428b$var$fixedElements.set(element, true);
    var points = [];
    var rules = $a62d07c2ecbe428b$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $a62d07c2ecbe428b$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var $a62d07c2ecbe428b$var$ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var $a62d07c2ecbe428b$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === 'comm' && element.children.indexOf($a62d07c2ecbe428b$var$ignoreFlag) > -1;
};
var $a62d07c2ecbe428b$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule' || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($a62d07c2ecbe428b$var$isIgnoringComment(node)) return;
                    break;
                }
            }
        }
    };
};
var $a62d07c2ecbe428b$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $a62d07c2ecbe428b$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$a62d07c2ecbe428b$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $a62d07c2ecbe428b$var$nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var $a62d07c2ecbe428b$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$a62d07c2ecbe428b$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $a62d07c2ecbe428b$var$nullifyElement(element);
    } else if ($a62d07c2ecbe428b$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $a62d07c2ecbe428b$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $a62d07c2ecbe428b$var$prefix(value, length) {
    switch((0, $8d6ec0e25b95c4c2$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$2c0f367103c8d01c) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + 'box-' + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)((0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)((0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)((0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $8d6ec0e25b95c4c2$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $f7cca8c9202aa514$export$2c0f367103c8d01c) + ((0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $8d6ec0e25b95c4c2$export$f8e21b1e77979a08)(value, 'stretch') ? $a62d07c2ecbe428b$var$prefix((0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(value, (0, $8d6ec0e25b95c4c2$export$36776f635604f274)(value) - 3 - (~(0, $8d6ec0e25b95c4c2$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + ((0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $8d6ec0e25b95c4c2$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + value + (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $a62d07c2ecbe428b$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $f7cca8c9202aa514$export$527d108ccf083c2b:
                element["return"] = $a62d07c2ecbe428b$var$prefix(element.value, element.length);
                break;
            case 0, $f7cca8c9202aa514$export$b44a8529a35fcb60:
                return (0, $258a89ae7b032a40$export$dfdc1655ccc5b9cb)([
                    (0, $41cf24261f4c36e3$export$784d13d8ee351f07)(element, {
                        value: (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $f7cca8c9202aa514$export$aa3a2e812ca8570d:
                if (element.length) return (0, $8d6ec0e25b95c4c2$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $8d6ec0e25b95c4c2$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $258a89ae7b032a40$export$dfdc1655ccc5b9cb)([
                                (0, $41cf24261f4c36e3$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $f7cca8c9202aa514$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $258a89ae7b032a40$export$dfdc1655ccc5b9cb)([
                                (0, $41cf24261f4c36e3$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $f7cca8c9202aa514$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $41cf24261f4c36e3$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $f7cca8c9202aa514$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $41cf24261f4c36e3$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $8d6ec0e25b95c4c2$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $f7cca8c9202aa514$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $a62d07c2ecbe428b$var$defaultStylisPlugins = [
    $a62d07c2ecbe428b$var$prefixer
];
var $a62d07c2ecbe428b$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $a62d07c2ecbe428b$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $a62d07c2ecbe428b$var$compat,
        $a62d07c2ecbe428b$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $258a89ae7b032a40$export$fac44ee5b035f737),
        (0, $42e7c989d27ab7fb$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $42e7c989d27ab7fb$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $258a89ae7b032a40$export$dfdc1655ccc5b9cb)((0, $ca8387d01b3ff8a8$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $aa0c3aea4a52e28d$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};
module.exports["default"] = $a62d07c2ecbe428b$export$2e2bcd8739ae039;

});

parcelRegister("6dGgK", function(module, exports) {
$parcel$export(module.exports, "w", () => $4874beb97538da8e$export$efccba1c4a2ef57b);

var $42omo = parcelRequire("42omo");


var $egy7N = parcelRequire("egy7N");


var $7Q5yr = parcelRequire("7Q5yr");


var $jZwD7 = parcelRequire("jZwD7");


var $lk6Q6 = parcelRequire("lk6Q6");


var $dmgN7 = parcelRequire("dmgN7");


var $g2YHK = parcelRequire("g2YHK");


var $jjudR = parcelRequire("jjudR");

var $4874beb97538da8e$export$23f2a1d2818174ef = true;
var $4874beb97538da8e$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4874beb97538da8e$var$EmotionCacheContext = /* #__PURE__ */ $42omo.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $egy7N.default)({
    key: 'css'
}) : null);
var $4874beb97538da8e$export$e7094788287c5e9b = $4874beb97538da8e$var$EmotionCacheContext.Provider;
var $4874beb97538da8e$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $42omo.useContext)($4874beb97538da8e$var$EmotionCacheContext);
};
var $4874beb97538da8e$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $42omo.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $42omo.useContext)($4874beb97538da8e$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$4874beb97538da8e$export$23f2a1d2818174ef) $4874beb97538da8e$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $42omo.useContext)($4874beb97538da8e$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $egy7N.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $42omo.createElement($4874beb97538da8e$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $4874beb97538da8e$export$971d5caa766a69d7 = /* #__PURE__ */ $42omo.createContext({});
var $4874beb97538da8e$export$3b14a55fb2447963 = function useTheme() {
    return $42omo.useContext($4874beb97538da8e$export$971d5caa766a69d7);
};
var $4874beb97538da8e$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $7Q5yr.default)({}, outerTheme, theme);
};
var $4874beb97538da8e$var$createCacheWithTheme = /* #__PURE__ */ (0, $jZwD7.default)(function(outerTheme) {
    return (0, $jZwD7.default)(function(theme) {
        return $4874beb97538da8e$var$getTheme(outerTheme, theme);
    });
});
var $4874beb97538da8e$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $42omo.useContext($4874beb97538da8e$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4874beb97538da8e$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $42omo.createElement($4874beb97538da8e$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4874beb97538da8e$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $42omo.useContext($4874beb97538da8e$export$971d5caa766a69d7);
        return /*#__PURE__*/ $42omo.createElement(Component, (0, $7Q5yr.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $42omo.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $lk6Q6.default)(WithTheme, Component);
}
var $4874beb97538da8e$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $4874beb97538da8e$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $4874beb97538da8e$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $4874beb97538da8e$var$getLastPart(match[1]);
    return undefined;
};
var $4874beb97538da8e$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $4874beb97538da8e$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $4874beb97538da8e$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $4874beb97538da8e$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($4874beb97538da8e$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $4874beb97538da8e$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $4874beb97538da8e$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $4874beb97538da8e$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $4874beb97538da8e$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($4874beb97538da8e$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$4874beb97538da8e$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $4874beb97538da8e$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $dmgN7.registerStyles)(cache, serialized, isStringTag);
    (0, $jjudR.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $dmgN7.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $4874beb97538da8e$var$Emotion = /* #__PURE__ */ $4874beb97538da8e$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$4874beb97538da8e$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $dmgN7.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $g2YHK.serializeStyles)(registeredStyles, undefined, $42omo.useContext($4874beb97538da8e$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($4874beb97538da8e$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $4874beb97538da8e$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement($4874beb97538da8e$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $42omo.createElement(WrappedComponent, newProps));
});
var $4874beb97538da8e$export$a9c23c6ac3fc3eca = $4874beb97538da8e$var$Emotion;
module.exports["i"] = $4874beb97538da8e$export$23f2a1d2818174ef;
module.exports["h"] = $4874beb97538da8e$export$dda1d9f60106f0e9;
module.exports["C"] = $4874beb97538da8e$export$e7094788287c5e9b;
module.exports["T"] = $4874beb97538da8e$export$971d5caa766a69d7;
module.exports["u"] = $4874beb97538da8e$export$3b14a55fb2447963;
module.exports["a"] = $4874beb97538da8e$export$407448d2b89b1813;
module.exports["b"] = $4874beb97538da8e$export$8b22cf2602fb60ce;
module.exports["c"] = $4874beb97538da8e$export$db3b6bfb95261072;
module.exports["E"] = $4874beb97538da8e$export$a9c23c6ac3fc3eca;

});

parcelRegister("7Q5yr", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b51b2bd56316a23$export$2e2bcd8739ae039);
function $5b51b2bd56316a23$export$2e2bcd8739ae039() {
    return $5b51b2bd56316a23$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5b51b2bd56316a23$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("56GFp", function(module, exports) {
'use strict';
var $16cd21e599eebd08$exports = {};
'use strict';

$16cd21e599eebd08$exports = (parcelRequire("hzNyi"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $3b7e9c0dc9de6571$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $3b7e9c0dc9de6571$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $3b7e9c0dc9de6571$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $3b7e9c0dc9de6571$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $3b7e9c0dc9de6571$var$TYPE_STATICS = {};
$3b7e9c0dc9de6571$var$TYPE_STATICS[$16cd21e599eebd08$exports.ForwardRef] = $3b7e9c0dc9de6571$var$FORWARD_REF_STATICS;
$3b7e9c0dc9de6571$var$TYPE_STATICS[$16cd21e599eebd08$exports.Memo] = $3b7e9c0dc9de6571$var$MEMO_STATICS;
function $3b7e9c0dc9de6571$var$getStatics(component) {
    // React v16.11 and below
    if ($16cd21e599eebd08$exports.isMemo(component)) return $3b7e9c0dc9de6571$var$MEMO_STATICS;
     // React v16.12 and above
    return $3b7e9c0dc9de6571$var$TYPE_STATICS[component['$$typeof']] || $3b7e9c0dc9de6571$var$REACT_STATICS;
}
var $3b7e9c0dc9de6571$var$defineProperty = Object.defineProperty;
var $3b7e9c0dc9de6571$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $3b7e9c0dc9de6571$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3b7e9c0dc9de6571$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3b7e9c0dc9de6571$var$getPrototypeOf = Object.getPrototypeOf;
var $3b7e9c0dc9de6571$var$objectPrototype = Object.prototype;
function $3b7e9c0dc9de6571$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($3b7e9c0dc9de6571$var$objectPrototype) {
            var inheritedComponent = $3b7e9c0dc9de6571$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $3b7e9c0dc9de6571$var$objectPrototype) $3b7e9c0dc9de6571$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $3b7e9c0dc9de6571$var$getOwnPropertyNames(sourceComponent);
        if ($3b7e9c0dc9de6571$var$getOwnPropertySymbols) keys = keys.concat($3b7e9c0dc9de6571$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $3b7e9c0dc9de6571$var$getStatics(targetComponent);
        var sourceStatics = $3b7e9c0dc9de6571$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$3b7e9c0dc9de6571$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $3b7e9c0dc9de6571$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $3b7e9c0dc9de6571$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $3b7e9c0dc9de6571$var$hoistNonReactStatics;

});

parcelRegister("hzNyi", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $ccbc24991aa3a263$export$2b8d127b894957b9, (v) => $ccbc24991aa3a263$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $ccbc24991aa3a263$export$cea3a54a6425200c, (v) => $ccbc24991aa3a263$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $ccbc24991aa3a263$export$a7c73072b1a182ae, (v) => $ccbc24991aa3a263$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $ccbc24991aa3a263$export$9f27bc3417b4524d, (v) => $ccbc24991aa3a263$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $ccbc24991aa3a263$export$db77ccec0bb4ccac, (v) => $ccbc24991aa3a263$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $ccbc24991aa3a263$export$8392c0c9d3dcbd35, (v) => $ccbc24991aa3a263$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $ccbc24991aa3a263$export$ffb0004e005737fa, (v) => $ccbc24991aa3a263$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $ccbc24991aa3a263$export$b624eff549462981, (v) => $ccbc24991aa3a263$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $ccbc24991aa3a263$export$7897aa7841a5380c, (v) => $ccbc24991aa3a263$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $ccbc24991aa3a263$export$602eac185826482c, (v) => $ccbc24991aa3a263$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $ccbc24991aa3a263$export$e2c29f18771995cb, (v) => $ccbc24991aa3a263$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $ccbc24991aa3a263$export$5f8d39834fd61797, (v) => $ccbc24991aa3a263$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $ccbc24991aa3a263$export$74bf444e3cd11ea5, (v) => $ccbc24991aa3a263$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $ccbc24991aa3a263$export$92387174baf9b227, (v) => $ccbc24991aa3a263$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $ccbc24991aa3a263$export$ec112efeb987d9c6, (v) => $ccbc24991aa3a263$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $ccbc24991aa3a263$export$b706b080d889d2c9, (v) => $ccbc24991aa3a263$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $ccbc24991aa3a263$export$5be5a87408f70ddc, (v) => $ccbc24991aa3a263$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $ccbc24991aa3a263$export$45a5e7f76e0caa8d, (v) => $ccbc24991aa3a263$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $ccbc24991aa3a263$export$455c2e768291efa6, (v) => $ccbc24991aa3a263$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $ccbc24991aa3a263$export$9522e17588c12572, (v) => $ccbc24991aa3a263$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $ccbc24991aa3a263$export$2110ac352bb060b9, (v) => $ccbc24991aa3a263$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $ccbc24991aa3a263$export$56885ab8b9c456ab, (v) => $ccbc24991aa3a263$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $ccbc24991aa3a263$export$d927fcb6adf8f9de, (v) => $ccbc24991aa3a263$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $ccbc24991aa3a263$export$b82d16f27459e05a, (v) => $ccbc24991aa3a263$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $ccbc24991aa3a263$export$522c17b4f5e123e8, (v) => $ccbc24991aa3a263$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $ccbc24991aa3a263$export$1aabd8a0274ecfd6, (v) => $ccbc24991aa3a263$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $ccbc24991aa3a263$export$9b621391a187a31a, (v) => $ccbc24991aa3a263$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $ccbc24991aa3a263$export$f5bbd400c2f4426f, (v) => $ccbc24991aa3a263$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ccbc24991aa3a263$export$2b8d127b894957b9;
var $ccbc24991aa3a263$export$cea3a54a6425200c;
var $ccbc24991aa3a263$export$a7c73072b1a182ae;
var $ccbc24991aa3a263$export$9f27bc3417b4524d;
var $ccbc24991aa3a263$export$db77ccec0bb4ccac;
var $ccbc24991aa3a263$export$8392c0c9d3dcbd35;
var $ccbc24991aa3a263$export$ffb0004e005737fa;
var $ccbc24991aa3a263$export$b624eff549462981;
var $ccbc24991aa3a263$export$7897aa7841a5380c;
var $ccbc24991aa3a263$export$602eac185826482c;
var $ccbc24991aa3a263$export$e2c29f18771995cb;
var $ccbc24991aa3a263$export$5f8d39834fd61797;
var $ccbc24991aa3a263$export$74bf444e3cd11ea5;
var $ccbc24991aa3a263$export$92387174baf9b227;
var $ccbc24991aa3a263$export$ec112efeb987d9c6;
var $ccbc24991aa3a263$export$b706b080d889d2c9;
var $ccbc24991aa3a263$export$5be5a87408f70ddc;
var $ccbc24991aa3a263$export$45a5e7f76e0caa8d;
var $ccbc24991aa3a263$export$455c2e768291efa6;
var $ccbc24991aa3a263$export$9522e17588c12572;
var $ccbc24991aa3a263$export$2110ac352bb060b9;
var $ccbc24991aa3a263$export$56885ab8b9c456ab;
var $ccbc24991aa3a263$export$d927fcb6adf8f9de;
var $ccbc24991aa3a263$export$b82d16f27459e05a;
var $ccbc24991aa3a263$export$522c17b4f5e123e8;
var $ccbc24991aa3a263$export$1aabd8a0274ecfd6;
var $ccbc24991aa3a263$export$9b621391a187a31a;
var $ccbc24991aa3a263$export$f5bbd400c2f4426f;
'use strict';
var $ccbc24991aa3a263$var$b = "function" === typeof Symbol && Symbol.for, $ccbc24991aa3a263$var$c = $ccbc24991aa3a263$var$b ? Symbol.for("react.element") : 60103, $ccbc24991aa3a263$var$d = $ccbc24991aa3a263$var$b ? Symbol.for("react.portal") : 60106, $ccbc24991aa3a263$var$e = $ccbc24991aa3a263$var$b ? Symbol.for("react.fragment") : 60107, $ccbc24991aa3a263$var$f = $ccbc24991aa3a263$var$b ? Symbol.for("react.strict_mode") : 60108, $ccbc24991aa3a263$var$g = $ccbc24991aa3a263$var$b ? Symbol.for("react.profiler") : 60114, $ccbc24991aa3a263$var$h = $ccbc24991aa3a263$var$b ? Symbol.for("react.provider") : 60109, $ccbc24991aa3a263$var$k = $ccbc24991aa3a263$var$b ? Symbol.for("react.context") : 60110, $ccbc24991aa3a263$var$l = $ccbc24991aa3a263$var$b ? Symbol.for("react.async_mode") : 60111, $ccbc24991aa3a263$var$m = $ccbc24991aa3a263$var$b ? Symbol.for("react.concurrent_mode") : 60111, $ccbc24991aa3a263$var$n = $ccbc24991aa3a263$var$b ? Symbol.for("react.forward_ref") : 60112, $ccbc24991aa3a263$var$p = $ccbc24991aa3a263$var$b ? Symbol.for("react.suspense") : 60113, $ccbc24991aa3a263$var$q = $ccbc24991aa3a263$var$b ? Symbol.for("react.suspense_list") : 60120, $ccbc24991aa3a263$var$r = $ccbc24991aa3a263$var$b ? Symbol.for("react.memo") : 60115, $ccbc24991aa3a263$var$t = $ccbc24991aa3a263$var$b ? Symbol.for("react.lazy") : 60116, $ccbc24991aa3a263$var$v = $ccbc24991aa3a263$var$b ? Symbol.for("react.block") : 60121, $ccbc24991aa3a263$var$w = $ccbc24991aa3a263$var$b ? Symbol.for("react.fundamental") : 60117, $ccbc24991aa3a263$var$x = $ccbc24991aa3a263$var$b ? Symbol.for("react.responder") : 60118, $ccbc24991aa3a263$var$y = $ccbc24991aa3a263$var$b ? Symbol.for("react.scope") : 60119;
function $ccbc24991aa3a263$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $ccbc24991aa3a263$var$c:
                switch(a = a.type, a){
                    case $ccbc24991aa3a263$var$l:
                    case $ccbc24991aa3a263$var$m:
                    case $ccbc24991aa3a263$var$e:
                    case $ccbc24991aa3a263$var$g:
                    case $ccbc24991aa3a263$var$f:
                    case $ccbc24991aa3a263$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ccbc24991aa3a263$var$k:
                            case $ccbc24991aa3a263$var$n:
                            case $ccbc24991aa3a263$var$t:
                            case $ccbc24991aa3a263$var$r:
                            case $ccbc24991aa3a263$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $ccbc24991aa3a263$var$d:
                return u;
        }
    }
}
function $ccbc24991aa3a263$var$A(a) {
    return $ccbc24991aa3a263$var$z(a) === $ccbc24991aa3a263$var$m;
}
$ccbc24991aa3a263$export$2b8d127b894957b9 = $ccbc24991aa3a263$var$l;
$ccbc24991aa3a263$export$cea3a54a6425200c = $ccbc24991aa3a263$var$m;
$ccbc24991aa3a263$export$a7c73072b1a182ae = $ccbc24991aa3a263$var$k;
$ccbc24991aa3a263$export$9f27bc3417b4524d = $ccbc24991aa3a263$var$h;
$ccbc24991aa3a263$export$db77ccec0bb4ccac = $ccbc24991aa3a263$var$c;
$ccbc24991aa3a263$export$8392c0c9d3dcbd35 = $ccbc24991aa3a263$var$n;
$ccbc24991aa3a263$export$ffb0004e005737fa = $ccbc24991aa3a263$var$e;
$ccbc24991aa3a263$export$b624eff549462981 = $ccbc24991aa3a263$var$t;
$ccbc24991aa3a263$export$7897aa7841a5380c = $ccbc24991aa3a263$var$r;
$ccbc24991aa3a263$export$602eac185826482c = $ccbc24991aa3a263$var$d;
$ccbc24991aa3a263$export$e2c29f18771995cb = $ccbc24991aa3a263$var$g;
$ccbc24991aa3a263$export$5f8d39834fd61797 = $ccbc24991aa3a263$var$f;
$ccbc24991aa3a263$export$74bf444e3cd11ea5 = $ccbc24991aa3a263$var$p;
$ccbc24991aa3a263$export$92387174baf9b227 = function(a) {
    return $ccbc24991aa3a263$var$A(a) || $ccbc24991aa3a263$var$z(a) === $ccbc24991aa3a263$var$l;
};
$ccbc24991aa3a263$export$ec112efeb987d9c6 = $ccbc24991aa3a263$var$A;
$ccbc24991aa3a263$export$b706b080d889d2c9 = function(a) {
    return $ccbc24991aa3a263$var$z(a) === $ccbc24991aa3a263$var$k;
};
$ccbc24991aa3a263$export$5be5a87408f70ddc = function(a) {
    return $ccbc24991aa3a263$var$z(a) === $ccbc24991aa3a263$var$h;
};
$ccbc24991aa3a263$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ccbc24991aa3a263$var$c;
};
$ccbc24991aa3a263$export$455c2e768291efa6 = function(a) {
    return $ccbc24991aa3a263$var$z(a) === $ccbc24991aa3a263$var$n;
};
$ccbc24991aa3a263$export$9522e17588c12572 = function(a) {
    return $ccbc24991aa3a263$var$z(a) === $ccbc24991aa3a263$var$e;
};
$ccbc24991aa3a263$export$2110ac352bb060b9 = function(a) {
    return $ccbc24991aa3a263$var$z(a) === $ccbc24991aa3a263$var$t;
};
$ccbc24991aa3a263$export$56885ab8b9c456ab = function(a) {
    return $ccbc24991aa3a263$var$z(a) === $ccbc24991aa3a263$var$r;
};
$ccbc24991aa3a263$export$d927fcb6adf8f9de = function(a) {
    return $ccbc24991aa3a263$var$z(a) === $ccbc24991aa3a263$var$d;
};
$ccbc24991aa3a263$export$b82d16f27459e05a = function(a) {
    return $ccbc24991aa3a263$var$z(a) === $ccbc24991aa3a263$var$g;
};
$ccbc24991aa3a263$export$522c17b4f5e123e8 = function(a) {
    return $ccbc24991aa3a263$var$z(a) === $ccbc24991aa3a263$var$f;
};
$ccbc24991aa3a263$export$1aabd8a0274ecfd6 = function(a) {
    return $ccbc24991aa3a263$var$z(a) === $ccbc24991aa3a263$var$p;
};
$ccbc24991aa3a263$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ccbc24991aa3a263$var$e || a === $ccbc24991aa3a263$var$m || a === $ccbc24991aa3a263$var$g || a === $ccbc24991aa3a263$var$f || a === $ccbc24991aa3a263$var$p || a === $ccbc24991aa3a263$var$q || "object" === typeof a && null !== a && (a.$$typeof === $ccbc24991aa3a263$var$t || a.$$typeof === $ccbc24991aa3a263$var$r || a.$$typeof === $ccbc24991aa3a263$var$h || a.$$typeof === $ccbc24991aa3a263$var$k || a.$$typeof === $ccbc24991aa3a263$var$n || a.$$typeof === $ccbc24991aa3a263$var$w || a.$$typeof === $ccbc24991aa3a263$var$x || a.$$typeof === $ccbc24991aa3a263$var$y || a.$$typeof === $ccbc24991aa3a263$var$v);
};
$ccbc24991aa3a263$export$f5bbd400c2f4426f = $ccbc24991aa3a263$var$z;

});

parcelRegister("dmgN7", function(module, exports) {
var $9b9a5ad4b13d3277$var$isBrowser = true;
function $9b9a5ad4b13d3277$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $9b9a5ad4b13d3277$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $9b9a5ad4b13d3277$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $9b9a5ad4b13d3277$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $9b9a5ad4b13d3277$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};
module.exports["getRegisteredStyles"] = $9b9a5ad4b13d3277$export$95d99596f328fd52;
module.exports["registerStyles"] = $9b9a5ad4b13d3277$export$580009a5da2a8b4b;
module.exports["insertStyles"] = $9b9a5ad4b13d3277$export$6f077d94b33a01aa;

});

parcelRegister("g2YHK", function(module, exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $fba96806c3dc605d$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $4ba7091f7cebc1a8$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $9bLS2 = parcelRequire("9bLS2");

var $baebebed4af6c10e$var$isDevelopment = false;
var $baebebed4af6c10e$var$hyphenateRegex = /[A-Z]|^ms/g;
var $baebebed4af6c10e$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $baebebed4af6c10e$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $baebebed4af6c10e$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $baebebed4af6c10e$var$processStyleName = /* #__PURE__ */ (0, $9bLS2.default)(function(styleName) {
    return $baebebed4af6c10e$var$isCustomProperty(styleName) ? styleName : styleName.replace($baebebed4af6c10e$var$hyphenateRegex, '-$&').toLowerCase();
});
var $baebebed4af6c10e$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($baebebed4af6c10e$var$animationRegex, function(match, p1, p2) {
                $baebebed4af6c10e$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $baebebed4af6c10e$var$cursor
                };
                return p1;
            });
    }
    if ((0, $4ba7091f7cebc1a8$export$2e2bcd8739ae039)[key] !== 1 && !$baebebed4af6c10e$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $baebebed4af6c10e$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $baebebed4af6c10e$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $baebebed4af6c10e$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $baebebed4af6c10e$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $baebebed4af6c10e$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $baebebed4af6c10e$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $baebebed4af6c10e$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $baebebed4af6c10e$var$cursor;
                var result = interpolation(mergedProps);
                $baebebed4af6c10e$var$cursor = previousCursor;
                return $baebebed4af6c10e$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $baebebed4af6c10e$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $baebebed4af6c10e$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($baebebed4af6c10e$var$isProcessableValue(asString)) string += $baebebed4af6c10e$var$processStyleName(key) + ":" + $baebebed4af6c10e$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $baebebed4af6c10e$var$isDevelopment) throw new Error($baebebed4af6c10e$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($baebebed4af6c10e$var$isProcessableValue(value[_i])) string += $baebebed4af6c10e$var$processStyleName(key) + ":" + $baebebed4af6c10e$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $baebebed4af6c10e$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $baebebed4af6c10e$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $baebebed4af6c10e$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $baebebed4af6c10e$var$cursor;
function $baebebed4af6c10e$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $baebebed4af6c10e$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $baebebed4af6c10e$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $baebebed4af6c10e$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $baebebed4af6c10e$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $baebebed4af6c10e$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $fba96806c3dc605d$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $baebebed4af6c10e$var$cursor
    };
}
module.exports["serializeStyles"] = $baebebed4af6c10e$export$6321afa313b251b5;

});

parcelRegister("9bLS2", function(module, exports) {
function $01b9f8dfddf04b4a$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
module.exports["default"] = $01b9f8dfddf04b4a$export$2e2bcd8739ae039;

});

parcelRegister("l998X", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jyf2o"));

});

parcelRegister("jyf2o", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $e3bcdb79329ef2ff$export$ffb0004e005737fa, (v) => $e3bcdb79329ef2ff$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $e3bcdb79329ef2ff$export$34b9dba7ce09269b, (v) => $e3bcdb79329ef2ff$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $e3bcdb79329ef2ff$export$25062201e9e25d76, (v) => $e3bcdb79329ef2ff$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e3bcdb79329ef2ff$export$ffb0004e005737fa;
var $e3bcdb79329ef2ff$export$34b9dba7ce09269b;
var $e3bcdb79329ef2ff$export$25062201e9e25d76;
'use strict';

var $42omo = parcelRequire("42omo");

var $e3bcdb79329ef2ff$var$k = Symbol.for("react.element"), $e3bcdb79329ef2ff$var$l = Symbol.for("react.fragment"), $e3bcdb79329ef2ff$var$m = Object.prototype.hasOwnProperty, $e3bcdb79329ef2ff$var$n = $42omo.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $e3bcdb79329ef2ff$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e3bcdb79329ef2ff$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$e3bcdb79329ef2ff$var$m.call(a, b) && !$e3bcdb79329ef2ff$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $e3bcdb79329ef2ff$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $e3bcdb79329ef2ff$var$n.current
    };
}
$e3bcdb79329ef2ff$export$ffb0004e005737fa = $e3bcdb79329ef2ff$var$l;
$e3bcdb79329ef2ff$export$34b9dba7ce09269b = $e3bcdb79329ef2ff$var$q;
$e3bcdb79329ef2ff$export$25062201e9e25d76 = $e3bcdb79329ef2ff$var$q;

});

parcelRegister("dQl1W", function(module, exports) {
var $00e0b335b8c83c8f$exports = {};

var $aOdGZ = parcelRequire("aOdGZ");


var $gOV62 = parcelRequire("gOV62");

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $00e0b335b8c83c8f$var$_nodeId;
var $00e0b335b8c83c8f$var$_clockseq;
// Previous uuid creation time
var $00e0b335b8c83c8f$var$_lastMSecs = 0;
var $00e0b335b8c83c8f$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $00e0b335b8c83c8f$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $00e0b335b8c83c8f$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $00e0b335b8c83c8f$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $aOdGZ();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $00e0b335b8c83c8f$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $00e0b335b8c83c8f$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $00e0b335b8c83c8f$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $00e0b335b8c83c8f$var$_lastMSecs + (nsecs - $00e0b335b8c83c8f$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $00e0b335b8c83c8f$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $00e0b335b8c83c8f$var$_lastMSecs = msecs;
    $00e0b335b8c83c8f$var$_lastNSecs = nsecs;
    $00e0b335b8c83c8f$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $gOV62(b);
}
$00e0b335b8c83c8f$exports = $00e0b335b8c83c8f$var$v1;



var $cUcZ5 = parcelRequire("cUcZ5");

var $a14071e1528cb536$var$uuid = $cUcZ5;
$a14071e1528cb536$var$uuid.v1 = $00e0b335b8c83c8f$exports;
$a14071e1528cb536$var$uuid.v4 = $cUcZ5;
module.exports = $a14071e1528cb536$var$uuid;

});

parcelRegister("gOV62", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $c3ed9b030c0a1146$var$byteToHex = [];
for(var $c3ed9b030c0a1146$var$i = 0; $c3ed9b030c0a1146$var$i < 256; ++$c3ed9b030c0a1146$var$i)$c3ed9b030c0a1146$var$byteToHex[$c3ed9b030c0a1146$var$i] = ($c3ed9b030c0a1146$var$i + 0x100).toString(16).substr(1);
function $c3ed9b030c0a1146$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $c3ed9b030c0a1146$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $c3ed9b030c0a1146$var$bytesToUuid;

});

parcelRegister("cUcZ5", function(module, exports) {

var $aOdGZ = parcelRequire("aOdGZ");


var $gOV62 = parcelRequire("gOV62");

function $9654c968d6abfc18$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $aOdGZ)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $gOV62(rnds);
}
module.exports = $9654c968d6abfc18$var$v4;

});

parcelRegister("dh538", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");

// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $bf2538ea95b40513$var$TESTS_MODE = globalThis?.process?.env?.JEST_WORKER_ID !== undefined;
const $bf2538ea95b40513$var$DEBUG_MODE = !$bf2538ea95b40513$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
const $bf2538ea95b40513$export$1c9f709888824e05 = (...args)=>{
    if (!$bf2538ea95b40513$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};



var $kyRHQ = parcelRequire("kyRHQ");

const $11c935177cdc07c6$var$pkgName = '@atlaskit/platform-feature-flags';
const $11c935177cdc07c6$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $11c935177cdc07c6$var$hasProcessEnv = typeof $kyRHQ !== 'undefined' && typeof $kyRHQ.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
const $11c935177cdc07c6$var$ENV_ENABLE_PLATFORM_FF = $11c935177cdc07c6$var$hasProcessEnv ? false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
const $11c935177cdc07c6$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $11c935177cdc07c6$var$hasProcessEnv ? false : false;
const $11c935177cdc07c6$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $11c935177cdc07c6$var$ENV_ENABLE_PLATFORM_FF || $11c935177cdc07c6$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
const $11c935177cdc07c6$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $11c935177cdc07c6$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$11c935177cdc07c6$var$globalVar[$11c935177cdc07c6$export$7e41b1b2bdee3f98] = $11c935177cdc07c6$var$globalVar[$11c935177cdc07c6$export$7e41b1b2bdee3f98] || $11c935177cdc07c6$var$DEFAULT_PFF_GLOBAL;
function $11c935177cdc07c6$export$f2b591175b3e424c(resolver) {
    $11c935177cdc07c6$var$globalVar[$11c935177cdc07c6$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $11c935177cdc07c6$export$6333b6aff9fc6275(flagKey) {
    if ($11c935177cdc07c6$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $bf2538ea95b40513$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $11c935177cdc07c6$var$pkgName, flagKey);
        return true;
    }
    try {
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if ($11c935177cdc07c6$var$globalVar[$11c935177cdc07c6$export$7e41b1b2bdee3f98]?.booleanResolver === undefined || $11c935177cdc07c6$var$globalVar[$11c935177cdc07c6$export$7e41b1b2bdee3f98]?.booleanResolver === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $c6GJD.default).checkGate(flagKey);
        const result = $11c935177cdc07c6$var$globalVar[$11c935177cdc07c6$export$7e41b1b2bdee3f98]?.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $525cfba0b60a0f0c$export$ba05d765b8392e5e(flagResolver) {
    (0, $11c935177cdc07c6$export$f2b591175b3e424c)(flagResolver);
}
function $525cfba0b60a0f0c$export$470e5c2be1411c89(name) {
    return (0, $11c935177cdc07c6$export$6333b6aff9fc6275)(name);
}
function $525cfba0b60a0f0c$export$b40ec24ac8275656(name) {
    return (0, $11c935177cdc07c6$export$6333b6aff9fc6275)(name);
}
module.exports["setBooleanFeatureFlagResolver"] = $525cfba0b60a0f0c$export$ba05d765b8392e5e;
module.exports["getBooleanFF"] = $525cfba0b60a0f0c$export$470e5c2be1411c89;
module.exports["fg"] = $525cfba0b60a0f0c$export$b40ec24ac8275656;

});

parcelRegister("kyRHQ", function(module, exports) {
// shim for using process in browser
var $ef80a4899ff13f54$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $ef80a4899ff13f54$var$cachedSetTimeout;
var $ef80a4899ff13f54$var$cachedClearTimeout;
function $ef80a4899ff13f54$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $ef80a4899ff13f54$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $ef80a4899ff13f54$var$cachedSetTimeout = setTimeout;
        else $ef80a4899ff13f54$var$cachedSetTimeout = $ef80a4899ff13f54$var$defaultSetTimout;
    } catch (e) {
        $ef80a4899ff13f54$var$cachedSetTimeout = $ef80a4899ff13f54$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $ef80a4899ff13f54$var$cachedClearTimeout = clearTimeout;
        else $ef80a4899ff13f54$var$cachedClearTimeout = $ef80a4899ff13f54$var$defaultClearTimeout;
    } catch (e) {
        $ef80a4899ff13f54$var$cachedClearTimeout = $ef80a4899ff13f54$var$defaultClearTimeout;
    }
})();
function $ef80a4899ff13f54$var$runTimeout(fun) {
    if ($ef80a4899ff13f54$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($ef80a4899ff13f54$var$cachedSetTimeout === $ef80a4899ff13f54$var$defaultSetTimout || !$ef80a4899ff13f54$var$cachedSetTimeout) && setTimeout) {
        $ef80a4899ff13f54$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ef80a4899ff13f54$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $ef80a4899ff13f54$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $ef80a4899ff13f54$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $ef80a4899ff13f54$var$runClearTimeout(marker) {
    if ($ef80a4899ff13f54$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($ef80a4899ff13f54$var$cachedClearTimeout === $ef80a4899ff13f54$var$defaultClearTimeout || !$ef80a4899ff13f54$var$cachedClearTimeout) && clearTimeout) {
        $ef80a4899ff13f54$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ef80a4899ff13f54$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $ef80a4899ff13f54$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $ef80a4899ff13f54$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $ef80a4899ff13f54$var$queue = [];
var $ef80a4899ff13f54$var$draining = false;
var $ef80a4899ff13f54$var$currentQueue;
var $ef80a4899ff13f54$var$queueIndex = -1;
function $ef80a4899ff13f54$var$cleanUpNextTick() {
    if (!$ef80a4899ff13f54$var$draining || !$ef80a4899ff13f54$var$currentQueue) return;
    $ef80a4899ff13f54$var$draining = false;
    if ($ef80a4899ff13f54$var$currentQueue.length) $ef80a4899ff13f54$var$queue = $ef80a4899ff13f54$var$currentQueue.concat($ef80a4899ff13f54$var$queue);
    else $ef80a4899ff13f54$var$queueIndex = -1;
    if ($ef80a4899ff13f54$var$queue.length) $ef80a4899ff13f54$var$drainQueue();
}
function $ef80a4899ff13f54$var$drainQueue() {
    if ($ef80a4899ff13f54$var$draining) return;
    var timeout = $ef80a4899ff13f54$var$runTimeout($ef80a4899ff13f54$var$cleanUpNextTick);
    $ef80a4899ff13f54$var$draining = true;
    var len = $ef80a4899ff13f54$var$queue.length;
    while(len){
        $ef80a4899ff13f54$var$currentQueue = $ef80a4899ff13f54$var$queue;
        $ef80a4899ff13f54$var$queue = [];
        while(++$ef80a4899ff13f54$var$queueIndex < len)if ($ef80a4899ff13f54$var$currentQueue) $ef80a4899ff13f54$var$currentQueue[$ef80a4899ff13f54$var$queueIndex].run();
        $ef80a4899ff13f54$var$queueIndex = -1;
        len = $ef80a4899ff13f54$var$queue.length;
    }
    $ef80a4899ff13f54$var$currentQueue = null;
    $ef80a4899ff13f54$var$draining = false;
    $ef80a4899ff13f54$var$runClearTimeout(timeout);
}
$ef80a4899ff13f54$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $ef80a4899ff13f54$var$queue.push(new $ef80a4899ff13f54$var$Item(fun, args));
    if ($ef80a4899ff13f54$var$queue.length === 1 && !$ef80a4899ff13f54$var$draining) $ef80a4899ff13f54$var$runTimeout($ef80a4899ff13f54$var$drainQueue);
};
// v8 likes predictible objects
function $ef80a4899ff13f54$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$ef80a4899ff13f54$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$ef80a4899ff13f54$var$process.title = 'browser';
$ef80a4899ff13f54$var$process.browser = true;
$ef80a4899ff13f54$var$process.env = {};
$ef80a4899ff13f54$var$process.argv = [];
$ef80a4899ff13f54$var$process.version = ''; // empty string to avoid regexp issues
$ef80a4899ff13f54$var$process.versions = {};
function $ef80a4899ff13f54$var$noop() {}
$ef80a4899ff13f54$var$process.on = $ef80a4899ff13f54$var$noop;
$ef80a4899ff13f54$var$process.addListener = $ef80a4899ff13f54$var$noop;
$ef80a4899ff13f54$var$process.once = $ef80a4899ff13f54$var$noop;
$ef80a4899ff13f54$var$process.off = $ef80a4899ff13f54$var$noop;
$ef80a4899ff13f54$var$process.removeListener = $ef80a4899ff13f54$var$noop;
$ef80a4899ff13f54$var$process.removeAllListeners = $ef80a4899ff13f54$var$noop;
$ef80a4899ff13f54$var$process.emit = $ef80a4899ff13f54$var$noop;
$ef80a4899ff13f54$var$process.prependListener = $ef80a4899ff13f54$var$noop;
$ef80a4899ff13f54$var$process.prependOnceListener = $ef80a4899ff13f54$var$noop;
$ef80a4899ff13f54$var$process.listeners = function(name) {
    return [];
};
$ef80a4899ff13f54$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$ef80a4899ff13f54$var$process.cwd = function() {
    return '/';
};
$ef80a4899ff13f54$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$ef80a4899ff13f54$var$process.umask = function() {
    return 0;
};

});

parcelRegister("c6GJD", function(module, exports) {
$parcel$export(module.exports, "default", () => $e97dbefc75c56cbc$export$2e2bcd8739ae039);

var $96xxk = parcelRequire("96xxk");


var $hEUUD = parcelRequire("hEUUD");




var $7OROP = parcelRequire("7OROP");

var $e97dbefc75c56cbc$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $e97dbefc75c56cbc$var$FeatureGates {
    static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
}
$e97dbefc75c56cbc$var$_FeatureGates = $e97dbefc75c56cbc$var$FeatureGates;
$e97dbefc75c56cbc$var$FeatureGates.client = new (0, $96xxk.Client)();
$e97dbefc75c56cbc$var$FeatureGates.hasCheckGateErrorOccurred = false;
$e97dbefc75c56cbc$var$FeatureGates.hasGetExperimentValueErrorOccurred = false;
$e97dbefc75c56cbc$var$FeatureGates.checkGate = (gateName, options)=>{
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e97dbefc75c56cbc$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $e97dbefc75c56cbc$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $e97dbefc75c56cbc$var$_FeatureGates.client.checkGate(gateName, options);
};
$e97dbefc75c56cbc$var$FeatureGates.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e97dbefc75c56cbc$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $e97dbefc75c56cbc$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $e97dbefc75c56cbc$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
};
$e97dbefc75c56cbc$var$FeatureGates.initializeCalled = $e97dbefc75c56cbc$var$_FeatureGates.client.initializeCalled.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.initializeCompleted = $e97dbefc75c56cbc$var$_FeatureGates.client.initializeCompleted.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.waitUntilInitializeCompleted = $e97dbefc75c56cbc$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.initialize = $e97dbefc75c56cbc$var$_FeatureGates.client.initialize.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.initializeWithProvider = $e97dbefc75c56cbc$var$_FeatureGates.client.initializeWithProvider.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.initializeFromValues = $e97dbefc75c56cbc$var$_FeatureGates.client.initializeFromValues.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.manuallyLogGateExposure = $e97dbefc75c56cbc$var$_FeatureGates.client.manuallyLogGateExposure.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.getExperiment = $e97dbefc75c56cbc$var$_FeatureGates.client.getExperiment.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.manuallyLogExperimentExposure = $e97dbefc75c56cbc$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.manuallyLogLayerExposure = $e97dbefc75c56cbc$var$_FeatureGates.client.manuallyLogLayerExposure.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.shutdownStatsig = $e97dbefc75c56cbc$var$_FeatureGates.client.shutdownStatsig.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.overrideGate = $e97dbefc75c56cbc$var$_FeatureGates.client.overrideGate.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.clearGateOverride = $e97dbefc75c56cbc$var$_FeatureGates.client.clearGateOverride.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.overrideConfig = $e97dbefc75c56cbc$var$_FeatureGates.client.overrideConfig.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.clearConfigOverride = $e97dbefc75c56cbc$var$_FeatureGates.client.clearConfigOverride.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.setOverrides = $e97dbefc75c56cbc$var$_FeatureGates.client.setOverrides.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.getOverrides = $e97dbefc75c56cbc$var$_FeatureGates.client.getOverrides.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.clearAllOverrides = $e97dbefc75c56cbc$var$_FeatureGates.client.clearAllOverrides.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.isCurrentUser = $e97dbefc75c56cbc$var$_FeatureGates.client.isCurrentUser.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.onGateUpdated = $e97dbefc75c56cbc$var$_FeatureGates.client.onGateUpdated.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.onExperimentValueUpdated = $e97dbefc75c56cbc$var$_FeatureGates.client.onExperimentValueUpdated.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.onAnyUpdated = $e97dbefc75c56cbc$var$_FeatureGates.client.onAnyUpdated.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.updateUser = $e97dbefc75c56cbc$var$_FeatureGates.client.updateUser.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.updateUserWithProvider = $e97dbefc75c56cbc$var$_FeatureGates.client.updateUserWithProvider.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.updateUserWithValues = $e97dbefc75c56cbc$var$_FeatureGates.client.updateUserWithValues.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.getPackageVersion = $e97dbefc75c56cbc$var$_FeatureGates.client.getPackageVersion.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.getLayer = $e97dbefc75c56cbc$var$_FeatureGates.client.getLayer.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
$e97dbefc75c56cbc$var$FeatureGates.getLayerValue = $e97dbefc75c56cbc$var$_FeatureGates.client.getLayerValue.bind($e97dbefc75c56cbc$var$_FeatureGates.client);
let $e97dbefc75c56cbc$var$boundFGJS = $e97dbefc75c56cbc$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $e97dbefc75c56cbc$var$FeatureGates;
    else {
        $e97dbefc75c56cbc$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = $e97dbefc75c56cbc$var$boundFGJS?.getPackageVersion?.() || '4.10.0 or earlier';
        if (boundVersion !== (0, $hEUUD.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $hEUUD.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $e97dbefc75c56cbc$export$2e2bcd8739ae039 = $e97dbefc75c56cbc$var$boundFGJS;

});

parcelRegister("96xxk", function(module, exports) {

var $g84RO = parcelRequire("g84RO");


var $5OAab = parcelRequire("5OAab");

const $06378c6481821a0e$export$a66cbd9b2289cd78 = '@all-features';
class $06378c6481821a0e$export$2e2bcd8739ae039 {
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($06378c6481821a0e$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($06378c6481821a0e$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($06378c6481821a0e$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $06378c6481821a0e$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
    constructor(){
        this.emitter = void 0;
        this.eventToValue = new Map();
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($5OAab)))();
    }
}



var $kWb5j = parcelRequire("kWb5j");


var $dYDWA = parcelRequire("dYDWA");

class $4d5e0688f3ef3f8c$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        const value = new $4d5e0688f3ef3f8c$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $dYDWA.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), (0, $dYDWA.migrateSecondaryExposures)(layer.__evaluation?.secondary_exposures ?? []), (0, $dYDWA.migrateSecondaryExposures)(layer.__evaluation?.undelegated_secondary_exposures ?? []), layer.__evaluation?.allocated_experiment_name, layer.__evaluation?.explicit_parameters);
        return value;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        this._logParameterFunction?.(this, parameterName);
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._name = void 0;
        this._value = void 0;
        this._ruleID = void 0;
        /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ this._secondaryExposures = void 0;
        /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ this._undelegatedSecondaryExposures = void 0;
        this._allocatedExperimentName = void 0;
        this._explicitParameters = void 0;
        this._evaluationDetails = void 0;
        this._logParameterFunction = void 0;
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
}



var $3Fnbb = parcelRequire("3Fnbb");


var $7OROP = parcelRequire("7OROP");


var $hEUUD = parcelRequire("hEUUD");

class $1189bd9dc67f1683$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}


const $7919757618009ac3$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $7919757618009ac3$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $7919757618009ac3$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $7919757618009ac3$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $7919757618009ac3$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $7919757618009ac3$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $7919757618009ac3$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
const $7919757618009ac3$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
const $7919757618009ac3$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
const $7919757618009ac3$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $7919757618009ac3$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $1189bd9dc67f1683$export$286baf652d0b1206)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $1189bd9dc67f1683$export$286baf652d0b1206)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter, isolationContextId = null) {
        if (useGatewayUrl) return $7919757618009ac3$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $7OROP.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $7OROP.FeatureGateEnvironment).Production:
                return $7919757618009ac3$export$18c93900db9358a4;
            case (0, $7OROP.FeatureGateEnvironment).Staging:
                return $7919757618009ac3$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $7OROP.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $7OROP.FeatureGateEnvironment).Development:
                return $7919757618009ac3$export$f058dbf75c3bc647;
            case (0, $7OROP.FeatureGateEnvironment).Staging:
                const apiUrl = this.getApiUrl(isolationContextId);
                if (apiUrl !== null) return apiUrl;
                return $7919757618009ac3$export$942ba04389b0d5a2;
            default:
                const prodApiUrl = this.getApiUrl(isolationContextId);
                if (prodApiUrl !== null) return prodApiUrl;
                return $7919757618009ac3$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $7919757618009ac3$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $7919757618009ac3$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $hEUUD.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
    static getApiUrl(isolationContextId) {
        const window1 = this.getWindowLocation();
        if (window1 === undefined) {
            //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
            if (!isolationContextId) return null;
            return $7919757618009ac3$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
        }
        const { protocol: protocol, hostname: hostname } = window1;
        // Match last subdomain fragment before oasis-stg.com
        const oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
        if (oasisMatch) return `${protocol}//api.${oasisMatch[1]}.${$7919757618009ac3$export$cb3cd156f70d7e94}`;
        // Match last subdomain fragment before atlassian-isolated.net
        const isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
        if (isolatedMatch) return `${protocol}//api.${isolatedMatch[1]}.${$7919757618009ac3$export$921fbc6cdfd4eee0}`;
        return null;
    }
    static getWindowLocation() {
        if (typeof window !== 'undefined' && window.location) return window.location;
        return undefined;
    }
}





class $437a381907a752dd$export$55fffef3474104af extends (0, $g84RO.DataAdapterCore) {
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $g84RO.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $g84RO._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $g84RO._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $g84RO._getStorageKey)(this._getSdkKey(), user);
        return `${0, $g84RO.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
    constructor(){
        super('NoFetchDataAdapter', 'nofetch');
        this.bootstrapResult = null;
    }
}



var $1CKxc = parcelRequire("1CKxc");

const $944e02537a6d683d$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $944e02537a6d683d$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $944e02537a6d683d$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $944e02537a6d683d$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $944e02537a6d683d$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $944e02537a6d683d$export$bcb28fbac1def494 {
    parseStoredOverrides(localStorageKey) {
        try {
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $944e02537a6d683d$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $944e02537a6d683d$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $944e02537a6d683d$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($944e02537a6d683d$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            window.localStorage.removeItem($944e02537a6d683d$var$LEGACY_LOCAL_STORAGE_KEY);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $1CKxc._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$944e02537a6d683d$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($944e02537a6d683d$var$djb2MapKey((0, $1CKxc._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($944e02537a6d683d$var$djb2MapKey((0, $1CKxc._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($944e02537a6d683d$var$djb2MapKey((0, $1CKxc._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($944e02537a6d683d$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $944e02537a6d683d$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($944e02537a6d683d$var$djb2MapKey((0, $1CKxc._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($944e02537a6d683d$var$djb2MapKey((0, $1CKxc._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($944e02537a6d683d$var$djb2MapKey((0, $1CKxc._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($944e02537a6d683d$var$djb2MapKey((0, $1CKxc._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($944e02537a6d683d$var$djb2MapKey((0, $1CKxc._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($944e02537a6d683d$var$djb2MapKey((0, $1CKxc._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $944e02537a6d683d$var$makeEmptyStore();
        try {
            window.localStorage.removeItem(this._localStorageKey);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($944e02537a6d683d$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $1CKxc._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $944e02537a6d683d$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($944e02537a6d683d$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $1CKxc._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $944e02537a6d683d$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    constructor(localStorageKey){
        this._overrides = void 0;
        this._localStorageKey = void 0;
        this._djb2Map = void 0;
        this._overrides = $944e02537a6d683d$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
}











const $a8f72bf32701f8a4$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $a8f72bf32701f8a4$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
class $a8f72bf32701f8a4$export$1f2bb630327ac4b6 {
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $dYDWA.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $dYDWA.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
   * @description
   * This method initializes the client using the provider given to call to fetch the bootstrap values.
   * If the client is initialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param provider {Provider}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $dYDWA.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $dYDWA.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $hEUUD.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if (this.initCompleted || this.initWithDefaults) {
                this.assertInitialized(this.statsigClient);
                this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                this.statsigValuesUpdated();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        this.initOptions.analyticsWebClient?.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: this.initOptions.targetApp,
                clientVersion: (0, $hEUUD.CLIENT_VERSION),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if (this.initOptions.environment !== (0, $7OROP.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const clientOptionsWithDefaults = (0, $dYDWA.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $dYDWA.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
   * This method updates the user using a network call to fetch the new set of values.
   * @param fetchOptions {FetcherOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        const fetchOptionsWithDefaults = (0, $dYDWA.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $7919757618009ac3$export$2e2bcd8739ae039).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
   * This method updates the user using the provider given on initialisation to get the new set of
   * values.
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
   * This method updates the user given a new set of bootstrap values obtained from one of the
   * server-side SDKs.
   *
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @param initializeValues {Record<string,unknown>}
   */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        this.assertInitialized(this.statsigClient);
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    async waitUntilInitializeCompleted() {
        if (!this.initPromise) throw new Error('The client must be initialized before you can wait until initialized.');
        if (this.initCompleted) return;
        await this.initPromise;
    }
    /**
   * Returns the value for a feature gate. Returns false if there are errors.
   * @param {string} gateName - The name of the feature gate.
   * @param {Object} options
   * @param {boolean} options.fireGateExposure
   *        Whether or not to fire the exposure event for the gate. Defaults to true.
   *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
   *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   */ checkGate(gateName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireGateExposure: fireGateExposure = true } = options;
            return this.statsigClient.checkGate(gateName, {
                disableExposureLog: !fireGateExposure
            });
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    isGateExist(gateName) {
        try {
            this.assertInitialized(this.statsigClient);
            const gate = this.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    isExperimentExist(experimentName) {
        try {
            this.assertInitialized(this.statsigClient);
            const config = this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
   * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
   * <code>options.fireGateExposure</code> is false.
   * @param gateName
   */ manuallyLogGateExposure(gateName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.checkGate(gateName);
    }
    /**
   * Returns the entire config for a given experiment.
   *
   * @param {string} experimentName - The name of the experiment
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns The config for an experiment
   * @example
   * ```ts
   * const experimentConfig = client.getExperiment('example-experiment-name');
   * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
   * ```
   */ getExperiment(experimentName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            return (0, $kWb5j.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: !fireExperimentExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $kWb5j.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $3Fnbb.EvaluationReason).Error
            });
        }
    }
    /**
   * Returns the value of a given parameter in an experiment config.
   *
   * @template T
   * @param {string} experimentName - The name of the experiment
   * @param {string} parameterName - The name of the parameter to fetch from the experiment config
   * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
   * if the returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the
   * expected type. If this function returns false, then the default value will be returned
   * instead. This can be set to protect your code from unexpected values being set remotely. By
   * default, this will be done by asserting that the default value and value are the same primitive
   * type.
   * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
   * default value.
   * @example
   ``` ts
   type ValidColor = 'blue' | 'red' | 'yellow';
   type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
  	 const isValidColor: ValidColorTypeCheck =
  		(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
  	 const buttonColor: ValidColor = client.getExperimentValue(
  		'example-experiment-name',
  		'backgroundColor',
  		'yellow',
  		{
  				typeGuard: isValidColor
  		}
   );
   ```
  */ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
   * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
   * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
   * @param experimentName
   */ manuallyLogExperimentExposure(experimentName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getExperiment(experimentName);
    }
    /**
   * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
   * @param layerName
   * @param parameterName
   */ manuallyLogLayerExposure(layerName, parameterName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getLayer(layerName)?.get(parameterName);
    }
    shutdownStatsig() {
        this.assertInitialized(this.statsigClient);
        this.statsigClient.shutdown();
    }
    /**
   * Adds a new override for the given gate.
   *
   * This method is additive, meaning you can call it multiple times with different gate names to
   * build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearGateOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} gateName
   * @param {boolean} value
   */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) this.statsigClient?.updateUserSync(this.user, {
            disableBackgroundCacheRefresh: true
        });
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given gate.
   */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
   * Adds a new override for the given config (or experiment).
   *
   * This method is additive, meaning you can call it multiple times with different experiment
   * names to build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearConfigOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} experimentName
   * @param {object} values
   */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given experiment.
   * @param {string} experimentName
   */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
   * Set overrides for gates, experiments and layers in batch.
   *
   * Note that these overrides are **not** additive and will completely replace any that have been
   * added via prior calls to {@link Client.overrideConfig} or
   * {@link Client.overrideGate}.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearAllOverrides} after your tests are completed to remove this
   * localStorage entry.
   */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
   * @returns The current overrides for gates, configs (including experiments) and layers.
   */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
   * Clears overrides for all gates, configs (including experiments) and layers.
   */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
   * Returns whether the given identifiers and customAttributes align with the current
   * set that is being used by the client.
   *
   * If this method returns false, then the {@link Client.updateUser},
   * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
   * methods can be used to re-align these values.
   *
   * @param identifiers
   * @param customAttributes
   * @returns a flag indicating whether the clients current configuration aligns with the given values
   */ isCurrentUser(identifiers, customAttributes) {
        return (0, $dYDWA.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $dYDWA.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current checkGate value
   * @param gateName
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current experiment value
   * @param experimentName
   * @param parameterName
   * @param defaultValue
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
   * Subscribe so on any update the callback will be called.
   * NOTE: The callback will be called whenever the values are updated even if the values have not
   * changed.
   * @param callback
   * @returns off function to unsubscribe from updates
   */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
   * This method initializes the client using a network call to fetch the bootstrap values for the
   * given user.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @private
   */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $7919757618009ac3$export$2e2bcd8739ae039).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $7919757618009ac3$export$2e2bcd8739ae039).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            await provider.setProfile(baseClientOptions, identifiers, customAttributes);
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
            const experimentValuesPromise = provider.getExperimentValues();
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
   * This method initializes the client using a set of boostrap values obtained from one of the
   * server-side SDKs.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @param initializeValues
   * @private
   */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        const newClientOptions = (0, $dYDWA.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $a8f72bf32701f8a4$var$DEFAULT_CLIENT_KEY;
        if (!newClientOptions.networkConfig?.logEventUrl) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $a8f72bf32701f8a4$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $7OROP.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        this.user = (0, $dYDWA.toStatsigUser)(identifiers, customAttributes);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter,
            logEventCompressionMode: (0, $g84RO.LogEventCompressionMode).Forced
        };
        // Statsig validates the provided stableId against their own cookie, so we either need
        // to update the cookie to match, or disable the validation completely.
        if (identifiers.stableId) (0, $g84RO.StableID).setOverride(identifiers.stableId, sdkKey);
        else statsigOptions.disableStableID = true;
        try {
            this.statsigClient = new (0, $g84RO.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $g84RO.StatsigClient)($a8f72bf32701f8a4$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
   * This method updates the user for this client with the bootstrap values returned from a given
   * Promise.
   * It uses the customAttributes from fetching experiment values to update the Statsig user but
   * uses the customAttributes from given input to check if the user has changed.
   *
   * @param {Identifiers} identifiers
   * @param {CustomAttributes} customAttributes
   * @param {Promise<InitializeValues>} getInitializeValues
   * @private
   */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            this.initPromise = originalInitPromise;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
   * This method updates the user on the nested Statsig client
   *
   * @param identifiers
   * @param customAttributes
   * @param initializeValuesPromise
   * @private
   */ async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            user = (0, $dYDWA.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
        } catch (err) {
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            this.initOptions.updateUserCompletionCallback?.(false, errMsg);
            throw err;
        }
        let success = true;
        let errorMessage = null;
        try {
            this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
            this.user = user;
            if (this.user) await this.statsigClient.updateUserAsync(this.user);
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        this.initOptions?.updateUserCompletionCallback?.(success, errorMessage);
        if (success) {
            this.currentIdentifiers = identifiers;
            this.currentAttributes = customAttributes;
            this.subscriptions.anyUpdated();
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
   * @returns string version of the current package in semver style.
   */ getPackageVersion() {
        return 0, $hEUUD.CLIENT_VERSION;
    }
    /**
   * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
   *
   * @param {string} layerName - The name of the layer
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns A layer
   * @example
   * ```ts
   * const layer = client.getLayer('example-layer-name');
   * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
   * ```
   */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireLayerExposure: fireLayerExposure = true } = options;
            return (0, $4d5e0688f3ef3f8c$export$936d0764594b6eb3).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $4d5e0688f3ef3f8c$export$936d0764594b6eb3).fromLayer((0, $g84RO._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
   * Returns the value of a given parameter in a layer config.
   *
   * @template T
   * @param {string} layerName - The name of the layer
   * @param {string} parameterName - The name of the parameter to fetch from the layer config
   * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
   * returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
   * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
   * @example
   * ``` ts
   * type ValidColor = 'blue' | 'red' | 'yellow';
   * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
   *
   * const isValidColor: ValidColorTypeCheck =
   *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
   *
   * const buttonColor: ValidColor = client.getLayerValue(
   *    'example-layer-name',
   *    'backgroundColor',
   *    'yellow',
   *    {
   *        typeGuard: isValidColor
   *    }
   * );
   * ```
   */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    constructor({ localStorageKey: localStorageKey = (0, $944e02537a6d683d$export$d8474cff104280f3), overrideAdapter: overrideAdapter } = {}){
        this.statsigClient = void 0;
        this.user = void 0;
        this.initOptions = void 0;
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ this.initWithDefaults = false;
        this.currentIdentifiers = void 0;
        this.currentAttributes = void 0;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.provider = void 0;
        this.subscriptions = new (0, $06378c6481821a0e$export$2e2bcd8739ae039)();
        this.dataAdapter = new (0, $437a381907a752dd$export$55fffef3474104af)();
        this.overrideAdapter = void 0;
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ this.statsigValuesUpdated = ()=>{
            if (this.user) // Trigger a reset of the memoize cache
            this.statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, $944e02537a6d683d$export$bcb28fbac1def494)(localStorageKey);
    }
}
module.exports["Client"] = $a8f72bf32701f8a4$export$1f2bb630327ac4b6;

});

parcelRegister("4XvZj", function(module, exports) {
"use strict";
var $39c57c403dc6ef6c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $39c57c403dc6ef6c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $39c57c403dc6ef6c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("7LDyB")).Diagnostics;
    }
});

var $DCfK4 = parcelRequire("DCfK4");

Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $DCfK4.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("druB2")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("dR8ux")).Storage;
    }
});

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("eA9uL")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("8PnCm")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("3Mh7C")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("3PhuH")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("7LDyB")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("3a6uX")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("29SLx")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("bLz2T")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("5Okig")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("ecDPx")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("i8dnb")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("druB2")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("SRHpG")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("dc8O0")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("gujdA")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("5fu0F")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("eUKsP")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("7IzEC")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("2zuAI")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("5H8yY")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("4OWQJ")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("h8v16")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("021f6")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("c4JqD")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("hQdCo")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("99fLW")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("dpikB")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("62rFB")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("2QISn")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("2JGsX")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("adidj")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("q0i7Z")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("dR8ux")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("75yk2")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("dvnOP")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("d9YAx")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("bJA4G")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("7bskI")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("iNoAI")), module.exports);

$39c57c403dc6ef6c$var$__exportStar((parcelRequire("l2CLC")), module.exports);
Object.assign((0, (parcelRequire("eA9uL"))._getStatsigGlobal)(), {
    Log: (parcelRequire("druB2")).Log,
    SDK_VERSION: (parcelRequire("dpikB")).SDK_VERSION
});

});

parcelRegister("eA9uL", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $a9dbcb0ba2ffd91d$var$_a, $a9dbcb0ba2ffd91d$var$_b, $a9dbcb0ba2ffd91d$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $druB2 = parcelRequire("druB2");

const $a9dbcb0ba2ffd91d$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $a9dbcb0ba2ffd91d$var$statsigGlobal;
    } catch (e) {
        return $a9dbcb0ba2ffd91d$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $a9dbcb0ba2ffd91d$var$_getStatsigGlobal;
const $a9dbcb0ba2ffd91d$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $a9dbcb0ba2ffd91d$var$_getStatsigGlobalFlag;
const $a9dbcb0ba2ffd91d$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $druB2.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $a9dbcb0ba2ffd91d$var$_getInstance;
const $a9dbcb0ba2ffd91d$var$GLOBAL_KEY = '__STATSIG__';
const $a9dbcb0ba2ffd91d$var$_window = typeof window !== 'undefined' ? window : {};
const $a9dbcb0ba2ffd91d$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $a9dbcb0ba2ffd91d$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $a9dbcb0ba2ffd91d$var$statsigGlobal = ($a9dbcb0ba2ffd91d$var$_c = ($a9dbcb0ba2ffd91d$var$_b = ($a9dbcb0ba2ffd91d$var$_a = $a9dbcb0ba2ffd91d$var$_window[$a9dbcb0ba2ffd91d$var$GLOBAL_KEY]) !== null && $a9dbcb0ba2ffd91d$var$_a !== void 0 ? $a9dbcb0ba2ffd91d$var$_a : $a9dbcb0ba2ffd91d$var$_global[$a9dbcb0ba2ffd91d$var$GLOBAL_KEY]) !== null && $a9dbcb0ba2ffd91d$var$_b !== void 0 ? $a9dbcb0ba2ffd91d$var$_b : $a9dbcb0ba2ffd91d$var$_globalThis[$a9dbcb0ba2ffd91d$var$GLOBAL_KEY]) !== null && $a9dbcb0ba2ffd91d$var$_c !== void 0 ? $a9dbcb0ba2ffd91d$var$_c : {
    instance: module.exports._getInstance
};
$a9dbcb0ba2ffd91d$var$_window[$a9dbcb0ba2ffd91d$var$GLOBAL_KEY] = $a9dbcb0ba2ffd91d$var$statsigGlobal;
$a9dbcb0ba2ffd91d$var$_global[$a9dbcb0ba2ffd91d$var$GLOBAL_KEY] = $a9dbcb0ba2ffd91d$var$statsigGlobal;
$a9dbcb0ba2ffd91d$var$_globalThis[$a9dbcb0ba2ffd91d$var$GLOBAL_KEY] = $a9dbcb0ba2ffd91d$var$statsigGlobal;

});

parcelRegister("druB2", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $9c9587cec7d7fc21$var$DEBUG = ' DEBUG ';
const $9c9587cec7d7fc21$var$_INFO = '  INFO ';
const $9c9587cec7d7fc21$var$_WARN = '  WARN ';
const $9c9587cec7d7fc21$var$ERROR = ' ERROR ';
function $9c9587cec7d7fc21$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $9c9587cec7d7fc21$var$Log {
    static info(...args) {
        if ($9c9587cec7d7fc21$var$Log.level >= module.exports.LogLevel.Info) console.info($9c9587cec7d7fc21$var$_INFO, ...$9c9587cec7d7fc21$var$addTag(args));
    }
    static debug(...args) {
        if ($9c9587cec7d7fc21$var$Log.level >= module.exports.LogLevel.Debug) console.debug($9c9587cec7d7fc21$var$DEBUG, ...$9c9587cec7d7fc21$var$addTag(args));
    }
    static warn(...args) {
        if ($9c9587cec7d7fc21$var$Log.level >= module.exports.LogLevel.Warn) console.warn($9c9587cec7d7fc21$var$_WARN, ...$9c9587cec7d7fc21$var$addTag(args));
    }
    static error(...args) {
        if ($9c9587cec7d7fc21$var$Log.level >= module.exports.LogLevel.Error) console.error($9c9587cec7d7fc21$var$ERROR, ...$9c9587cec7d7fc21$var$addTag(args));
    }
}
module.exports.Log = $9c9587cec7d7fc21$var$Log;
$9c9587cec7d7fc21$var$Log.level = module.exports.LogLevel.Warn;

});

parcelRegister("7LDyB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $5a7b9b63d71edca3$var$MARKER_MAP = new Map();
const $5a7b9b63d71edca3$var$ACT_START = 'start';
const $5a7b9b63d71edca3$var$ACT_END = 'end';
const $5a7b9b63d71edca3$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $5a7b9b63d71edca3$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $5a7b9b63d71edca3$var$_addMarker(sdkKey, $5a7b9b63d71edca3$var$_createMarker({}, $5a7b9b63d71edca3$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $5a7b9b63d71edca3$var$_addMarker(sdkKey, $5a7b9b63d71edca3$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $5a7b9b63d71edca3$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $5a7b9b63d71edca3$var$_addMarker(sdkKey, $5a7b9b63d71edca3$var$_createMarker(data, $5a7b9b63d71edca3$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $5a7b9b63d71edca3$var$_addMarker(sdkKey, $5a7b9b63d71edca3$var$_createMarker(data, $5a7b9b63d71edca3$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $5a7b9b63d71edca3$var$_addMarker(sdkKey, $5a7b9b63d71edca3$var$_createMarker({}, $5a7b9b63d71edca3$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $5a7b9b63d71edca3$var$_addMarker(sdkKey, $5a7b9b63d71edca3$var$_createMarker(data, $5a7b9b63d71edca3$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $5a7b9b63d71edca3$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $5a7b9b63d71edca3$var$_safeGetField(e, 'code'),
            name: $5a7b9b63d71edca3$var$_safeGetField(e, 'name'),
            message: $5a7b9b63d71edca3$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $5a7b9b63d71edca3$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $5a7b9b63d71edca3$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $5a7b9b63d71edca3$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $5a7b9b63d71edca3$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $5a7b9b63d71edca3$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $5a7b9b63d71edca3$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $5a7b9b63d71edca3$var$MARKER_MAP.set(sdkKey, markers);
}
function $5a7b9b63d71edca3$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("8PnCm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $ecDPx = parcelRequire("ecDPx");

function $66d5682759f0aa60$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $ecDPx._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $66d5682759f0aa60$var$_getUserStorageKey;
function $66d5682759f0aa60$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $66d5682759f0aa60$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $ecDPx._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $66d5682759f0aa60$var$_getStorageKey;

});

parcelRegister("ecDPx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $dvnOP = parcelRequire("dvnOP");

const $a571151fa658925b$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $a571151fa658925b$var$_DJB2;
const $a571151fa658925b$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $a571151fa658925b$var$_DJB2Object;
const $a571151fa658925b$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $dvnOP._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $a571151fa658925b$var$_getSortedObject;

});

parcelRegister("dvnOP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $9d50a5860d9fd0b0$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $9d50a5860d9fd0b0$var$_typeOf;
function $9d50a5860d9fd0b0$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $9d50a5860d9fd0b0$var$_isTypeMatch;

});

parcelRegister("dc8O0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("7IzEC", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $59e84c9e9967fe6f$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $59e84c9e9967fe6f$var$_getWindowSafe;
const $59e84c9e9967fe6f$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $59e84c9e9967fe6f$var$_getDocumentSafe;
const $59e84c9e9967fe6f$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $kyRHQ !== 'undefined' && $kyRHQ.versions != null && $kyRHQ.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $59e84c9e9967fe6f$var$_isServerEnv;
const $59e84c9e9967fe6f$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $59e84c9e9967fe6f$var$_addWindowEventListenerSafe;
const $59e84c9e9967fe6f$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $59e84c9e9967fe6f$var$_addDocumentEventListenerSafe;
const $59e84c9e9967fe6f$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $59e84c9e9967fe6f$var$_getCurrentPageUrlSafe;
const $59e84c9e9967fe6f$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $59e84c9e9967fe6f$var$_getUnloadEvent;

});

parcelRegister("99fLW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $6a91305da738c726$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $6a91305da738c726$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $6a91305da738c726$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $6a91305da738c726$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $6a91305da738c726$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $6a91305da738c726$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $6a91305da738c726$var$GATE_EXPOSURE_NAME || eventName === $6a91305da738c726$var$CONFIG_EXPOSURE_NAME || eventName === $6a91305da738c726$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $6a91305da738c726$var$_isExposureEvent;
const $6a91305da738c726$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $6a91305da738c726$var$_createExposure($6a91305da738c726$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $6a91305da738c726$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $6a91305da738c726$var$_createGateExposure;
function $6a91305da738c726$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $6a91305da738c726$var$_mapExposures;
const $6a91305da738c726$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $6a91305da738c726$var$_createExposure($6a91305da738c726$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $6a91305da738c726$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $6a91305da738c726$var$_createConfigExposure;
const $6a91305da738c726$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $6a91305da738c726$var$_createExposure($6a91305da738c726$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $6a91305da738c726$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $6a91305da738c726$var$_createLayerParameterExposure;
const $6a91305da738c726$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("62rFB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("dR8ux", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $druB2 = parcelRequire("druB2");


var $7IzEC = parcelRequire("7IzEC");

const $a166cfd913694157$var$inMemoryStore = {};
const $a166cfd913694157$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$a166cfd913694157$var$inMemoryStore[key] ? $a166cfd913694157$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $a166cfd913694157$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $a166cfd913694157$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($a166cfd913694157$var$inMemoryStore)
};
let $a166cfd913694157$var$_localStorageProvider = null;
try {
    const win = (0, $7IzEC._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $a166cfd913694157$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $druB2.Log.warn('Failed to setup localStorageProvider.');
}
let $a166cfd913694157$var$_main = $a166cfd913694157$var$_localStorageProvider !== null && $a166cfd913694157$var$_localStorageProvider !== void 0 ? $a166cfd913694157$var$_localStorageProvider : $a166cfd913694157$var$_inMemoryProvider;
let $a166cfd913694157$var$_current = $a166cfd913694157$var$_main;
function $a166cfd913694157$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($a166cfd913694157$var$_inMemoryProvider);
            return null;
        }
        if (error instanceof Error && error.name === 'QuotaExceededError') {
            const allKeys = module.exports.Storage.getAllKeys();
            const statsigKeys = allKeys.filter((key)=>key.startsWith('statsig.'));
            error.message = `${error.message}. Statsig Keys: ${statsigKeys.length}`;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$a166cfd913694157$var$_current.isReady(),
    isReadyResolver: ()=>$a166cfd913694157$var$_current.isReadyResolver(),
    getProviderName: ()=>$a166cfd913694157$var$_current.getProviderName(),
    getItem: (key)=>$a166cfd913694157$var$_inMemoryBreaker(()=>$a166cfd913694157$var$_current.getItem(key)),
    setItem: (key, value)=>$a166cfd913694157$var$_inMemoryBreaker(()=>$a166cfd913694157$var$_current.setItem(key, value)),
    removeItem: (key)=>$a166cfd913694157$var$_current.removeItem(key),
    getAllKeys: ()=>$a166cfd913694157$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $a166cfd913694157$var$_main = newProvider;
        $a166cfd913694157$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $a166cfd913694157$var$_current = $a166cfd913694157$var$_inMemoryProvider;
        else $a166cfd913694157$var$_current = $a166cfd913694157$var$_main;
    }
};
function $a166cfd913694157$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : 'null');
}
module.exports._getObjectFromStorage = $a166cfd913694157$var$_getObjectFromStorage;
function $a166cfd913694157$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $a166cfd913694157$var$_setObjectInStorage;

});

parcelRegister("d9YAx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $ecDPx = parcelRequire("ecDPx");


var $dc8O0 = parcelRequire("dc8O0");

const $994b1d340ce33977$var$ENDPOINT_DNS_KEY_MAP = {
    [$dc8O0.Endpoint._initialize]: 'i',
    [$dc8O0.Endpoint._rgstr]: 'e',
    [$dc8O0.Endpoint._download_config_specs]: 'd'
};
class $994b1d340ce33977$var$UrlConfiguration {
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $ecDPx._DJB2)(this.customUrl + fallbacks);
    }
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $994b1d340ce33977$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $dc8O0.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
}
module.exports.UrlConfiguration = $994b1d340ce33977$var$UrlConfiguration;

});

parcelRegister("7bskI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $7IzEC = parcelRequire("7IzEC");

const $53af89df5eae016c$var$FOREGROUND = 'foreground';
const $53af89df5eae016c$var$BACKGROUND = 'background';
const $53af89df5eae016c$var$LISTENERS = [];
let $53af89df5eae016c$var$current = $53af89df5eae016c$var$FOREGROUND;
let $53af89df5eae016c$var$isUnloading = false;
const $53af89df5eae016c$var$_isCurrentlyVisible = ()=>{
    return $53af89df5eae016c$var$current === $53af89df5eae016c$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $53af89df5eae016c$var$_isCurrentlyVisible;
const $53af89df5eae016c$var$_isUnloading = ()=>$53af89df5eae016c$var$isUnloading;
module.exports._isUnloading = $53af89df5eae016c$var$_isUnloading;
const $53af89df5eae016c$var$_subscribeToVisiblityChanged = (listener)=>{
    $53af89df5eae016c$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $53af89df5eae016c$var$_subscribeToVisiblityChanged;
const $53af89df5eae016c$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $53af89df5eae016c$var$current) return;
    $53af89df5eae016c$var$current = visibility;
    $53af89df5eae016c$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $53af89df5eae016c$var$_notifyVisibilityChanged;
(0, $7IzEC._addWindowEventListenerSafe)('focus', ()=>{
    $53af89df5eae016c$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($53af89df5eae016c$var$FOREGROUND);
});
(0, $7IzEC._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($53af89df5eae016c$var$BACKGROUND));
(0, $7IzEC._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $53af89df5eae016c$var$FOREGROUND : $53af89df5eae016c$var$BACKGROUND);
});
(0, $7IzEC._addWindowEventListenerSafe)((0, $7IzEC._getUnloadEvent)(), ()=>{
    $53af89df5eae016c$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($53af89df5eae016c$var$BACKGROUND);
});

});

parcelRegister("dpikB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.21.1';
let $9c2bd45a40aafbd8$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$9c2bd45a40aafbd8$var$metadata,
    add: (additions)=>{
        $9c2bd45a40aafbd8$var$metadata = Object.assign(Object.assign({}, $9c2bd45a40aafbd8$var$metadata), additions);
    }
};

});

parcelRegister("3Mh7C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3PhuH", function(module, exports) {
"use strict";
var $2c93b47d6849e3b5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $druB2 = parcelRequire("druB2");


var $h8v16 = parcelRequire("h8v16");


var $q0i7Z = parcelRequire("q0i7Z");


var $dR8ux = parcelRequire("dR8ux");


var $75yk2 = parcelRequire("75yk2");

const $2c93b47d6849e3b5$var$CACHE_LIMIT = 10;
class $2c93b47d6849e3b5$var$DataAdapterCore {
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $q0i7Z._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $q0i7Z._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $2c93b47d6849e3b5$var$_makeDataAdapterResult('Bootstrap', data, null, normalized));
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $h8v16.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $2c93b47d6849e3b5$var$__awaiter(this, void 0, void 0, function*() {
            if (!$dR8ux.Storage.isReady()) yield $dR8ux.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $druB2.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $2c93b47d6849e3b5$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $q0i7Z._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $2c93b47d6849e3b5$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $druB2.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $75yk2._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $h8v16.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $2c93b47d6849e3b5$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $2c93b47d6849e3b5$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $druB2.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $dR8ux.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($dR8ux.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $75yk2._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $dR8ux.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $dR8ux._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $2c93b47d6849e3b5$var$_getEvictableKey(lastModifiedTimeMap, $2c93b47d6849e3b5$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $dR8ux.Storage.removeItem(evictable);
        }
        (0, $dR8ux._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $2c93b47d6849e3b5$var$InMemoryCache();
    }
}
module.exports.DataAdapterCore = $2c93b47d6849e3b5$var$DataAdapterCore;
function $2c93b47d6849e3b5$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $q0i7Z._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $2c93b47d6849e3b5$var$_makeDataAdapterResult;
class $2c93b47d6849e3b5$var$InMemoryCache {
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $druB2.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $2c93b47d6849e3b5$var$_getEvictableKey(this._data, $2c93b47d6849e3b5$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
    constructor(){
        this._data = {};
    }
}
function $2c93b47d6849e3b5$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === 'object' && typeof current === 'object') return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});

parcelRegister("h8v16", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $8PnCm = parcelRequire("8PnCm");


var $druB2 = parcelRequire("druB2");


var $7IzEC = parcelRequire("7IzEC");


var $dR8ux = parcelRequire("dR8ux");


var $bJA4G = parcelRequire("bJA4G");

const $c79b3e5087a6913c$var$PROMISE_MAP = {};
const $c79b3e5087a6913c$var$COOKIE_ENABLED_MAP = {};
const $c79b3e5087a6913c$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($c79b3e5087a6913c$var$DISABLED_MAP[sdkKey]) return null;
        if ($c79b3e5087a6913c$var$PROMISE_MAP[sdkKey] != null) return $c79b3e5087a6913c$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $c79b3e5087a6913c$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $c79b3e5087a6913c$var$PROMISE_MAP[sdkKey] = stableID;
            $c79b3e5087a6913c$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $c79b3e5087a6913c$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $bJA4G.getUUID)();
        $c79b3e5087a6913c$var$_persistToStorage(stableID, sdkKey);
        $c79b3e5087a6913c$var$_persistToCookie(stableID, sdkKey);
        $c79b3e5087a6913c$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $c79b3e5087a6913c$var$PROMISE_MAP[sdkKey] = override;
        $c79b3e5087a6913c$var$_persistToStorage(override, sdkKey);
        $c79b3e5087a6913c$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $c79b3e5087a6913c$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $c79b3e5087a6913c$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $c79b3e5087a6913c$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $8PnCm._getStorageKey)(sdkKey)}`;
}
function $c79b3e5087a6913c$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $c79b3e5087a6913c$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $dR8ux._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $druB2.Log.warn('Failed to save StableID to storage');
    }
}
function $c79b3e5087a6913c$var$_loadFromStorage(sdkKey) {
    const storageKey = $c79b3e5087a6913c$var$_getStableIDStorageKey(sdkKey);
    return (0, $dR8ux._getObjectFromStorage)(storageKey);
}
function $c79b3e5087a6913c$var$_loadFromCookie(sdkKey) {
    if (!$c79b3e5087a6913c$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $7IzEC._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $c79b3e5087a6913c$var$_getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $c79b3e5087a6913c$var$_persistToCookie(stableID, sdkKey) {
    if (!$c79b3e5087a6913c$var$COOKIE_ENABLED_MAP[sdkKey] || !document) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$c79b3e5087a6913c$var$_getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $c79b3e5087a6913c$var$_getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $8PnCm._getStorageKey)(sdkKey)}`;
}

});

parcelRegister("bJA4G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $88afe158e84709bd$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $88afe158e84709bd$var$getUUID;

});

parcelRegister("q0i7Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $ecDPx = parcelRequire("ecDPx");


var $druB2 = parcelRequire("druB2");

function $04e2a7af92e7274e$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $druB2.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $04e2a7af92e7274e$var$_normalizeUser;
function $04e2a7af92e7274e$var$_getFullUserHash(user) {
    return user ? (0, $ecDPx._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $04e2a7af92e7274e$var$_getFullUserHash;

});

parcelRegister("75yk2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $druB2 = parcelRequire("druB2");

/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $52939faf2bd9d1ff$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $druB2.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $52939faf2bd9d1ff$var$_typedJsonParse;

});

parcelRegister("3a6uX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("29SLx", function(module, exports) {
"use strict";
var $1926e75f45aed117$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $druB2 = parcelRequire("druB2");


var $2zuAI = parcelRequire("2zuAI");


var $dpikB = parcelRequire("dpikB");

module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $1926e75f45aed117$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $1926e75f45aed117$var$ErrorBoundary {
    wrap(instance) {
        try {
            const obj = instance;
            $1926e75f45aed117$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $1926e75f45aed117$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $druB2.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$1926e75f45aed117$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($1926e75f45aed117$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $1926e75f45aed117$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $2zuAI.SDKType._get(this._sdkKey);
                    const statsigMetadata = $dpikB.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $1926e75f45aed117$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $1926e75f45aed117$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
}
module.exports.ErrorBoundary = $1926e75f45aed117$var$ErrorBoundary;
function $1926e75f45aed117$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $1926e75f45aed117$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $1926e75f45aed117$var$UNKNOWN_ERROR;
    }
}
function $1926e75f45aed117$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $1926e75f45aed117$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.entries(options).forEach(([option, value])=>{
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});

parcelRegister("2zuAI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $1df6947365cb78ea$var$SDK_CLIENT = {};
let $1df6947365cb78ea$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $1df6947365cb78ea$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($1df6947365cb78ea$var$suffix !== null && $1df6947365cb78ea$var$suffix !== void 0 ? $1df6947365cb78ea$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $1df6947365cb78ea$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$1df6947365cb78ea$var$suffix || $1df6947365cb78ea$var$suffix === '-react') $1df6947365cb78ea$var$suffix = '-' + binding;
    }
};

});

parcelRegister("bLz2T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5Okig", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("i8dnb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("SRHpG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $0a4eb2ce37a3c67a$var$EXIST_KEYS = new Set([]);
const $0a4eb2ce37a3c67a$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $0a4eb2ce37a3c67a$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($0a4eb2ce37a3c67a$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($0a4eb2ce37a3c67a$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $0a4eb2ce37a3c67a$var$createMemoKey;

});

parcelRegister("gujdA", function(module, exports) {
"use strict";
var $c00e5b05eb65c5ba$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $eA9uL = parcelRequire("eA9uL");





var $7LDyB = parcelRequire("7LDyB");


var $druB2 = parcelRequire("druB2");


var $dc8O0 = parcelRequire("dc8O0");


var $2MfSb = parcelRequire("2MfSb");


var $l2CLC = parcelRequire("l2CLC");


var $2zuAI = parcelRequire("2zuAI");


var $7IzEC = parcelRequire("7IzEC");


var $5H8yY = parcelRequire("5H8yY");


var $h8v16 = parcelRequire("h8v16");


var $c4JqD = parcelRequire("c4JqD");


var $dpikB = parcelRequire("dpikB");


var $62rFB = parcelRequire("62rFB");


var $7bskI = parcelRequire("7bskI");

const $c00e5b05eb65c5ba$var$DEFAULT_TIMEOUT_MS = 10000;
const $c00e5b05eb65c5ba$var$BACKOFF_BASE_MS = 500;
const $c00e5b05eb65c5ba$var$BACKOFF_MAX_MS = 30000;
const $c00e5b05eb65c5ba$var$RATE_LIMIT_WINDOW_MS = 1000;
const $c00e5b05eb65c5ba$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $c00e5b05eb65c5ba$var$LEAK_RATE = $c00e5b05eb65c5ba$var$RATE_LIMIT_MAX_REQ_COUNT / $c00e5b05eb65c5ba$var$RATE_LIMIT_WINDOW_MS;
const $c00e5b05eb65c5ba$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $c00e5b05eb65c5ba$var$NetworkCore {
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$c00e5b05eb65c5ba$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $c00e5b05eb65c5ba$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $c00e5b05eb65c5ba$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$c00e5b05eb65c5ba$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $druB2.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $7bskI._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $c00e5b05eb65c5ba$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $c00e5b05eb65c5ba$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $c00e5b05eb65c5ba$var$_getErrorMessage(abortController, error);
                const timedOut = $c00e5b05eb65c5ba$var$_didTimeout(abortController);
                $c00e5b05eb65c5ba$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$c00e5b05eb65c5ba$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $c4JqD.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $druB2.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $c00e5b05eb65c5ba$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $62rFB.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $62rFB.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $c00e5b05eb65c5ba$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $c00e5b05eb65c5ba$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $dc8O0.Endpoint._initialize || args.urlConfig.endpoint === $dc8O0.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$dc8O0.NetworkParam.SdkKey]: args.sdkKey,
            [$dc8O0.NetworkParam.SdkType]: $2zuAI.SDKType._get(args.sdkKey),
            [$dc8O0.NetworkParam.SdkVersion]: $dpikB.SDK_VERSION,
            [$dc8O0.NetworkParam.Time]: String(Date.now()),
            [$dc8O0.NetworkParam.SessionID]: $5H8yY.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $7IzEC._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $eA9uL._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$dc8O0.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $druB2.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $c00e5b05eb65c5ba$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$c00e5b05eb65c5ba$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($druB2.Log.error);
                writer.close().catch($druB2.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$dc8O0.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $druB2.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $c00e5b05eb65c5ba$var$_populateRequestBody(result, args.data);
        return result;
    }
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $c00e5b05eb65c5ba$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $2MfSb.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
}
module.exports.NetworkCore = $c00e5b05eb65c5ba$var$NetworkCore;
const $c00e5b05eb65c5ba$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $druB2.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $c00e5b05eb65c5ba$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $h8v16.StableID.get(sdkKey);
    const sessionID = $5H8yY.SessionID.get(sdkKey);
    const sdkType = $2zuAI.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $dpikB.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $c00e5b05eb65c5ba$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $eA9uL._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $l2CLC.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $62rFB.LogEventCompressionMode.Disabled:
            return false;
        case $62rFB.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $62rFB.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $c00e5b05eb65c5ba$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string') return controller.signal.reason;
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $c00e5b05eb65c5ba$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string' && controller.signal.reason.includes('Timeout');
    return timeout || false;
}
function $c00e5b05eb65c5ba$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $dc8O0.Endpoint._initialize) return;
    $7LDyB.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $c00e5b05eb65c5ba$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $dc8O0.Endpoint._initialize) return;
    $7LDyB.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $7LDyB.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $c00e5b05eb65c5ba$var$_exponentialBackoff(attempt) {
    return $c00e5b05eb65c5ba$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($c00e5b05eb65c5ba$var$BACKOFF_BASE_MS * (attempt * attempt), $c00e5b05eb65c5ba$var$BACKOFF_MAX_MS)));
    });
}

});

parcelRegister("l2CLC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $f517db367cf927bb$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $f517db367cf927bb$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $f517db367cf927bb$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("5H8yY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $eA9uL = parcelRequire("eA9uL");


var $8PnCm = parcelRequire("8PnCm");


var $druB2 = parcelRequire("druB2");


var $dR8ux = parcelRequire("dR8ux");


var $bJA4G = parcelRequire("bJA4G");

const $42579c5c0a8803fd$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $42579c5c0a8803fd$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $42579c5c0a8803fd$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($42579c5c0a8803fd$var$PROMISE_MAP[sdkKey] == null) $42579c5c0a8803fd$var$PROMISE_MAP[sdkKey] = $42579c5c0a8803fd$var$_loadSession(sdkKey);
        const session = $42579c5c0a8803fd$var$PROMISE_MAP[sdkKey];
        return $42579c5c0a8803fd$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $42579c5c0a8803fd$var$PROMISE_MAP[sdkKey] = $42579c5c0a8803fd$var$_overrideSessionId(override, sdkKey);
    }
};
function $42579c5c0a8803fd$var$_loadSession(sdkKey) {
    let data = $42579c5c0a8803fd$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $bJA4G.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $42579c5c0a8803fd$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $42579c5c0a8803fd$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($42579c5c0a8803fd$var$_isIdle(data) || $42579c5c0a8803fd$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $bJA4G.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $42579c5c0a8803fd$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $42579c5c0a8803fd$var$_createSessionTimeout(sdkKey, $42579c5c0a8803fd$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $42579c5c0a8803fd$var$_createSessionTimeout(sdkKey, $42579c5c0a8803fd$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $42579c5c0a8803fd$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $eA9uL._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $42579c5c0a8803fd$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $42579c5c0a8803fd$var$MAX_SESSION_IDLE_TIME;
}
function $42579c5c0a8803fd$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $42579c5c0a8803fd$var$MAX_SESSION_AGE;
}
function $42579c5c0a8803fd$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $8PnCm._getStorageKey)(sdkKey)}`;
}
function $42579c5c0a8803fd$var$_persistToStorage(session, sdkKey) {
    const storageKey = $42579c5c0a8803fd$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $dR8ux._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $druB2.Log.warn('Failed to save SessionID');
    }
}
function $42579c5c0a8803fd$var$_loadFromStorage(sdkKey) {
    const storageKey = $42579c5c0a8803fd$var$_getSessionIDStorageKey(sdkKey);
    return (0, $dR8ux._getObjectFromStorage)(storageKey);
}

});

parcelRegister("c4JqD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});

parcelRegister("5fu0F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eUKsP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4OWQJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $38297b3ce932c013$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $38297b3ce932c013$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $38297b3ce932c013$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $38297b3ce932c013$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $38297b3ce932c013$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $38297b3ce932c013$var$_fastApproxSizeOf;

});

parcelRegister("021f6", function(module, exports) {
"use strict";
var $006126c6f91a3354$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $eA9uL = parcelRequire("eA9uL");





var $29SLx = parcelRequire("29SLx");


var $DCfK4 = parcelRequire("DCfK4");


var $druB2 = parcelRequire("druB2");


var $SRHpG = parcelRequire("SRHpG");


var $7IzEC = parcelRequire("7IzEC");


var $5H8yY = parcelRequire("5H8yY");


var $h8v16 = parcelRequire("h8v16");


var $62rFB = parcelRequire("62rFB");


var $dR8ux = parcelRequire("dR8ux");

const $006126c6f91a3354$var$MAX_MEMO_CACHE_SIZE = 3000;
class $006126c6f91a3354$var$StatsigClientBase {
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $dR8ux.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $h8v16.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($62rFB.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $006126c6f91a3354$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $druB2.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $SRHpG.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $006126c6f91a3354$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($druB2.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $dR8ux.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $5H8yY.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $dR8ux.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $h8v16.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $h8v16.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $DCfK4.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $29SLx.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $dR8ux.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $006126c6f91a3354$var$_assignGlobalInstance(sdkKey, this);
    }
}
module.exports.StatsigClientBase = $006126c6f91a3354$var$StatsigClientBase;
function $006126c6f91a3354$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $7IzEC._isServerEnv)()) return;
    const statsigGlobal = (0, $eA9uL._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $druB2.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("hQdCo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("2QISn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2JGsX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $druB2 = parcelRequire("druB2");


var $dvnOP = parcelRequire("dvnOP");

function $1fe0b99f8551e89d$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $1fe0b99f8551e89d$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $1fe0b99f8551e89d$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $1fe0b99f8551e89d$var$_makeFeatureGate;
function $1fe0b99f8551e89d$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $1fe0b99f8551e89d$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $1fe0b99f8551e89d$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $1fe0b99f8551e89d$var$_makeDynamicConfig;
function $1fe0b99f8551e89d$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $1fe0b99f8551e89d$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $1fe0b99f8551e89d$var$_makeExperiment;
function $1fe0b99f8551e89d$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $1fe0b99f8551e89d$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $1fe0b99f8551e89d$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $1fe0b99f8551e89d$var$_makeLayer;
function $1fe0b99f8551e89d$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $1fe0b99f8551e89d$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $1fe0b99f8551e89d$var$_mergeOverride;
function $1fe0b99f8551e89d$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $dvnOP._isTypeMatch)(found, fallback)) {
            $druB2.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $1fe0b99f8551e89d$var$_makeTypedGet;

});

parcelRegister("adidj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iNoAI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $daefe0e825a3d6e7$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $daefe0e825a3d6e7$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});

parcelRegister("5OAab", function(module, exports) {
'use strict';
var $43bdac8472d9da0f$var$has = Object.prototype.hasOwnProperty, $43bdac8472d9da0f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $43bdac8472d9da0f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $43bdac8472d9da0f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $43bdac8472d9da0f$var$Events().__proto__) $43bdac8472d9da0f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $43bdac8472d9da0f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $43bdac8472d9da0f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $43bdac8472d9da0f$var$EE(fn, context || emitter, once), evt = $43bdac8472d9da0f$var$prefix ? $43bdac8472d9da0f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $43bdac8472d9da0f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $43bdac8472d9da0f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $43bdac8472d9da0f$var$EventEmitter() {
    this._events = new $43bdac8472d9da0f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $43bdac8472d9da0f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($43bdac8472d9da0f$var$has.call(events, name)) names.push($43bdac8472d9da0f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $43bdac8472d9da0f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $43bdac8472d9da0f$var$prefix ? $43bdac8472d9da0f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $43bdac8472d9da0f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $43bdac8472d9da0f$var$prefix ? $43bdac8472d9da0f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $43bdac8472d9da0f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $43bdac8472d9da0f$var$prefix ? $43bdac8472d9da0f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $43bdac8472d9da0f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $43bdac8472d9da0f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $43bdac8472d9da0f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $43bdac8472d9da0f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $43bdac8472d9da0f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $43bdac8472d9da0f$var$prefix ? $43bdac8472d9da0f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $43bdac8472d9da0f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $43bdac8472d9da0f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $43bdac8472d9da0f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $43bdac8472d9da0f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $43bdac8472d9da0f$var$prefix ? $43bdac8472d9da0f$var$prefix + event : event;
        if (this._events[evt]) $43bdac8472d9da0f$var$clearEvent(this, evt);
    } else {
        this._events = new $43bdac8472d9da0f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$43bdac8472d9da0f$var$EventEmitter.prototype.off = $43bdac8472d9da0f$var$EventEmitter.prototype.removeListener;
$43bdac8472d9da0f$var$EventEmitter.prototype.addListener = $43bdac8472d9da0f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$43bdac8472d9da0f$var$EventEmitter.prefixed = $43bdac8472d9da0f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$43bdac8472d9da0f$var$EventEmitter.EventEmitter = $43bdac8472d9da0f$var$EventEmitter;
module.exports = $43bdac8472d9da0f$var$EventEmitter;

});

parcelRegister("lzcvT", function(module, exports) {

var $g46Dm = parcelRequire("g46Dm");

function $72d6d9b79d5ad30d$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $g46Dm.FEDRAMP_MODERATE);
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}
module.exports["isFedRamp"] = $72d6d9b79d5ad30d$export$64d6499adf9b2e51;

});

parcelRegister("g46Dm", function(module, exports) {
const $70009cc17afae0c4$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $70009cc17afae0c4$export$f005e2e9f707cb5f = 'commercial';
const $70009cc17afae0c4$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $70009cc17afae0c4$export$a739cd5aac835909 = 'stg';
const $70009cc17afae0c4$export$42dd0cdd351a4a9 = 'prod';
const $70009cc17afae0c4$export$404582bc18fe4d9e = 'dev';
module.exports["FEDRAMP_MODERATE"] = $70009cc17afae0c4$export$ce553301d55c2fd8;
module.exports["COMMERCIAL"] = $70009cc17afae0c4$export$f005e2e9f707cb5f;
module.exports["FEDRAMP_FEDEX"] = $70009cc17afae0c4$export$bd6b5a7802d76127;
module.exports["STAGING"] = $70009cc17afae0c4$export$a739cd5aac835909;
module.exports["PRODUCTION"] = $70009cc17afae0c4$export$42dd0cdd351a4a9;
module.exports["DEV"] = $70009cc17afae0c4$export$404582bc18fe4d9e;

});

parcelRegister("7OROP", function(module, exports) {
var $c6e78d3b2e417294$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $c6e78d3b2e417294$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
const $c6e78d3b2e417294$export$42f4885608027d0c = 'non_boolean';
module.exports["FeatureGateEnvironment"] = $c6e78d3b2e417294$export$479e7351a733299;
module.exports["PerimeterType"] = $c6e78d3b2e417294$export$c42b7bbc5e7ba555;

});

parcelRegister("jThPW", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $e7b0fd5ff224cd02$var$_a, $e7b0fd5ff224cd02$var$_b, $e7b0fd5ff224cd02$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $gEGY8 = parcelRequire("gEGY8");

const $e7b0fd5ff224cd02$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $e7b0fd5ff224cd02$var$statsigGlobal;
    } catch (e) {
        return $e7b0fd5ff224cd02$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $e7b0fd5ff224cd02$var$_getStatsigGlobal;
const $e7b0fd5ff224cd02$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $e7b0fd5ff224cd02$var$_getStatsigGlobalFlag;
const $e7b0fd5ff224cd02$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $gEGY8.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $e7b0fd5ff224cd02$var$_getInstance;
const $e7b0fd5ff224cd02$var$GLOBAL_KEY = '__STATSIG__';
const $e7b0fd5ff224cd02$var$_window = typeof window !== 'undefined' ? window : {};
const $e7b0fd5ff224cd02$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $e7b0fd5ff224cd02$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $e7b0fd5ff224cd02$var$statsigGlobal = ($e7b0fd5ff224cd02$var$_c = ($e7b0fd5ff224cd02$var$_b = ($e7b0fd5ff224cd02$var$_a = $e7b0fd5ff224cd02$var$_window[$e7b0fd5ff224cd02$var$GLOBAL_KEY]) !== null && $e7b0fd5ff224cd02$var$_a !== void 0 ? $e7b0fd5ff224cd02$var$_a : $e7b0fd5ff224cd02$var$_global[$e7b0fd5ff224cd02$var$GLOBAL_KEY]) !== null && $e7b0fd5ff224cd02$var$_b !== void 0 ? $e7b0fd5ff224cd02$var$_b : $e7b0fd5ff224cd02$var$_globalThis[$e7b0fd5ff224cd02$var$GLOBAL_KEY]) !== null && $e7b0fd5ff224cd02$var$_c !== void 0 ? $e7b0fd5ff224cd02$var$_c : {
    instance: module.exports._getInstance
};
$e7b0fd5ff224cd02$var$_window[$e7b0fd5ff224cd02$var$GLOBAL_KEY] = $e7b0fd5ff224cd02$var$statsigGlobal;
$e7b0fd5ff224cd02$var$_global[$e7b0fd5ff224cd02$var$GLOBAL_KEY] = $e7b0fd5ff224cd02$var$statsigGlobal;
$e7b0fd5ff224cd02$var$_globalThis[$e7b0fd5ff224cd02$var$GLOBAL_KEY] = $e7b0fd5ff224cd02$var$statsigGlobal;

});

parcelRegister("gEGY8", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $c201b67a1e1c1ffc$var$DEBUG = ' DEBUG ';
const $c201b67a1e1c1ffc$var$_INFO = '  INFO ';
const $c201b67a1e1c1ffc$var$_WARN = '  WARN ';
const $c201b67a1e1c1ffc$var$ERROR = ' ERROR ';
function $c201b67a1e1c1ffc$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $c201b67a1e1c1ffc$var$Log {
    static info(...args) {
        if ($c201b67a1e1c1ffc$var$Log.level >= module.exports.LogLevel.Info) console.info($c201b67a1e1c1ffc$var$_INFO, ...$c201b67a1e1c1ffc$var$addTag(args));
    }
    static debug(...args) {
        if ($c201b67a1e1c1ffc$var$Log.level >= module.exports.LogLevel.Debug) console.debug($c201b67a1e1c1ffc$var$DEBUG, ...$c201b67a1e1c1ffc$var$addTag(args));
    }
    static warn(...args) {
        if ($c201b67a1e1c1ffc$var$Log.level >= module.exports.LogLevel.Warn) console.warn($c201b67a1e1c1ffc$var$_WARN, ...$c201b67a1e1c1ffc$var$addTag(args));
    }
    static error(...args) {
        if ($c201b67a1e1c1ffc$var$Log.level >= module.exports.LogLevel.Error) console.error($c201b67a1e1c1ffc$var$ERROR, ...$c201b67a1e1c1ffc$var$addTag(args));
    }
}
module.exports.Log = $c201b67a1e1c1ffc$var$Log;
$c201b67a1e1c1ffc$var$Log.level = module.exports.LogLevel.Warn;

});

parcelRegister("g7kXt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $bbbd8ea2c42f9712$var$MARKER_MAP = new Map();
const $bbbd8ea2c42f9712$var$ACT_START = 'start';
const $bbbd8ea2c42f9712$var$ACT_END = 'end';
const $bbbd8ea2c42f9712$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $bbbd8ea2c42f9712$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $bbbd8ea2c42f9712$var$_addMarker(sdkKey, $bbbd8ea2c42f9712$var$_createMarker({}, $bbbd8ea2c42f9712$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $bbbd8ea2c42f9712$var$_addMarker(sdkKey, $bbbd8ea2c42f9712$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $bbbd8ea2c42f9712$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $bbbd8ea2c42f9712$var$_addMarker(sdkKey, $bbbd8ea2c42f9712$var$_createMarker(data, $bbbd8ea2c42f9712$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $bbbd8ea2c42f9712$var$_addMarker(sdkKey, $bbbd8ea2c42f9712$var$_createMarker(data, $bbbd8ea2c42f9712$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $bbbd8ea2c42f9712$var$_addMarker(sdkKey, $bbbd8ea2c42f9712$var$_createMarker({}, $bbbd8ea2c42f9712$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $bbbd8ea2c42f9712$var$_addMarker(sdkKey, $bbbd8ea2c42f9712$var$_createMarker(data, $bbbd8ea2c42f9712$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $bbbd8ea2c42f9712$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $bbbd8ea2c42f9712$var$_safeGetField(e, 'code'),
            name: $bbbd8ea2c42f9712$var$_safeGetField(e, 'name'),
            message: $bbbd8ea2c42f9712$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $bbbd8ea2c42f9712$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $bbbd8ea2c42f9712$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $bbbd8ea2c42f9712$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $bbbd8ea2c42f9712$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $bbbd8ea2c42f9712$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $bbbd8ea2c42f9712$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $bbbd8ea2c42f9712$var$MARKER_MAP.set(sdkKey, markers);
}
function $bbbd8ea2c42f9712$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("bCidb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $hfOjO = parcelRequire("hfOjO");

function $022ebb55b5dbf9ad$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $hfOjO._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $022ebb55b5dbf9ad$var$_getUserStorageKey;
function $022ebb55b5dbf9ad$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $022ebb55b5dbf9ad$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $hfOjO._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $022ebb55b5dbf9ad$var$_getStorageKey;

});

parcelRegister("hfOjO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $l5YTH = parcelRequire("l5YTH");

const $c8fade9fcab013a5$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $c8fade9fcab013a5$var$_DJB2;
const $c8fade9fcab013a5$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $c8fade9fcab013a5$var$_DJB2Object;
const $c8fade9fcab013a5$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $l5YTH._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $c8fade9fcab013a5$var$_getSortedObject;

});

parcelRegister("l5YTH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $f5b94d8d0713055a$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $f5b94d8d0713055a$var$_typeOf;
function $f5b94d8d0713055a$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $f5b94d8d0713055a$var$_isTypeMatch;

});

parcelRegister("9SMpY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("c03HY", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $8bc85c84249ae175$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $8bc85c84249ae175$var$_getWindowSafe;
const $8bc85c84249ae175$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $8bc85c84249ae175$var$_getDocumentSafe;
const $8bc85c84249ae175$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $kyRHQ !== 'undefined' && $kyRHQ.versions != null && $kyRHQ.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $8bc85c84249ae175$var$_isServerEnv;
const $8bc85c84249ae175$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $8bc85c84249ae175$var$_addWindowEventListenerSafe;
const $8bc85c84249ae175$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $8bc85c84249ae175$var$_addDocumentEventListenerSafe;
const $8bc85c84249ae175$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $8bc85c84249ae175$var$_getCurrentPageUrlSafe;
const $8bc85c84249ae175$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $8bc85c84249ae175$var$_getUnloadEvent;

});

parcelRegister("e68I2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $a43861b7fba04440$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $a43861b7fba04440$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $a43861b7fba04440$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $a43861b7fba04440$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $a43861b7fba04440$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $a43861b7fba04440$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $a43861b7fba04440$var$GATE_EXPOSURE_NAME || eventName === $a43861b7fba04440$var$CONFIG_EXPOSURE_NAME || eventName === $a43861b7fba04440$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $a43861b7fba04440$var$_isExposureEvent;
const $a43861b7fba04440$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $a43861b7fba04440$var$_createExposure($a43861b7fba04440$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $a43861b7fba04440$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $a43861b7fba04440$var$_createGateExposure;
function $a43861b7fba04440$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $a43861b7fba04440$var$_mapExposures;
const $a43861b7fba04440$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $a43861b7fba04440$var$_createExposure($a43861b7fba04440$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $a43861b7fba04440$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $a43861b7fba04440$var$_createConfigExposure;
const $a43861b7fba04440$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $a43861b7fba04440$var$_createExposure($a43861b7fba04440$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $a43861b7fba04440$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $a43861b7fba04440$var$_createLayerParameterExposure;
const $a43861b7fba04440$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("l7BAr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("4DTY3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $gEGY8 = parcelRequire("gEGY8");


var $c03HY = parcelRequire("c03HY");

const $361637f336a1f1ea$var$inMemoryStore = {};
const $361637f336a1f1ea$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$361637f336a1f1ea$var$inMemoryStore[key] ? $361637f336a1f1ea$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $361637f336a1f1ea$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $361637f336a1f1ea$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($361637f336a1f1ea$var$inMemoryStore)
};
let $361637f336a1f1ea$var$_localStorageProvider = null;
try {
    const win = (0, $c03HY._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $361637f336a1f1ea$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $gEGY8.Log.warn('Failed to setup localStorageProvider.');
}
let $361637f336a1f1ea$var$_main = $361637f336a1f1ea$var$_localStorageProvider !== null && $361637f336a1f1ea$var$_localStorageProvider !== void 0 ? $361637f336a1f1ea$var$_localStorageProvider : $361637f336a1f1ea$var$_inMemoryProvider;
let $361637f336a1f1ea$var$_current = $361637f336a1f1ea$var$_main;
function $361637f336a1f1ea$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($361637f336a1f1ea$var$_inMemoryProvider);
            return null;
        }
        if (error instanceof Error && error.name === 'QuotaExceededError') {
            const allKeys = module.exports.Storage.getAllKeys();
            const statsigKeys = allKeys.filter((key)=>key.startsWith('statsig.'));
            error.message = `${error.message}. Statsig Keys: ${statsigKeys.length}`;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$361637f336a1f1ea$var$_current.isReady(),
    isReadyResolver: ()=>$361637f336a1f1ea$var$_current.isReadyResolver(),
    getProviderName: ()=>$361637f336a1f1ea$var$_current.getProviderName(),
    getItem: (key)=>$361637f336a1f1ea$var$_inMemoryBreaker(()=>$361637f336a1f1ea$var$_current.getItem(key)),
    setItem: (key, value)=>$361637f336a1f1ea$var$_inMemoryBreaker(()=>$361637f336a1f1ea$var$_current.setItem(key, value)),
    removeItem: (key)=>$361637f336a1f1ea$var$_current.removeItem(key),
    getAllKeys: ()=>$361637f336a1f1ea$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $361637f336a1f1ea$var$_main = newProvider;
        $361637f336a1f1ea$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $361637f336a1f1ea$var$_current = $361637f336a1f1ea$var$_inMemoryProvider;
        else $361637f336a1f1ea$var$_current = $361637f336a1f1ea$var$_main;
    }
};
function $361637f336a1f1ea$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : 'null');
}
module.exports._getObjectFromStorage = $361637f336a1f1ea$var$_getObjectFromStorage;
function $361637f336a1f1ea$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $361637f336a1f1ea$var$_setObjectInStorage;

});

parcelRegister("cRnPo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $hfOjO = parcelRequire("hfOjO");


var $9SMpY = parcelRequire("9SMpY");

const $95cceb030317cec1$var$ENDPOINT_DNS_KEY_MAP = {
    [$9SMpY.Endpoint._initialize]: 'i',
    [$9SMpY.Endpoint._rgstr]: 'e',
    [$9SMpY.Endpoint._download_config_specs]: 'd'
};
class $95cceb030317cec1$var$UrlConfiguration {
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $hfOjO._DJB2)(this.customUrl + fallbacks);
    }
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $95cceb030317cec1$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $9SMpY.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
}
module.exports.UrlConfiguration = $95cceb030317cec1$var$UrlConfiguration;

});

parcelRegister("kOIO0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $c03HY = parcelRequire("c03HY");

const $f27b3b9933d6408e$var$FOREGROUND = 'foreground';
const $f27b3b9933d6408e$var$BACKGROUND = 'background';
const $f27b3b9933d6408e$var$LISTENERS = [];
let $f27b3b9933d6408e$var$current = $f27b3b9933d6408e$var$FOREGROUND;
let $f27b3b9933d6408e$var$isUnloading = false;
const $f27b3b9933d6408e$var$_isCurrentlyVisible = ()=>{
    return $f27b3b9933d6408e$var$current === $f27b3b9933d6408e$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $f27b3b9933d6408e$var$_isCurrentlyVisible;
const $f27b3b9933d6408e$var$_isUnloading = ()=>$f27b3b9933d6408e$var$isUnloading;
module.exports._isUnloading = $f27b3b9933d6408e$var$_isUnloading;
const $f27b3b9933d6408e$var$_subscribeToVisiblityChanged = (listener)=>{
    $f27b3b9933d6408e$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $f27b3b9933d6408e$var$_subscribeToVisiblityChanged;
const $f27b3b9933d6408e$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $f27b3b9933d6408e$var$current) return;
    $f27b3b9933d6408e$var$current = visibility;
    $f27b3b9933d6408e$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $f27b3b9933d6408e$var$_notifyVisibilityChanged;
(0, $c03HY._addWindowEventListenerSafe)('focus', ()=>{
    $f27b3b9933d6408e$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($f27b3b9933d6408e$var$FOREGROUND);
});
(0, $c03HY._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($f27b3b9933d6408e$var$BACKGROUND));
(0, $c03HY._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $f27b3b9933d6408e$var$FOREGROUND : $f27b3b9933d6408e$var$BACKGROUND);
});
(0, $c03HY._addWindowEventListenerSafe)((0, $c03HY._getUnloadEvent)(), ()=>{
    $f27b3b9933d6408e$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($f27b3b9933d6408e$var$BACKGROUND);
});

});

parcelRegister("kqAyV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.22.0';
let $edf298e3699fef2c$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$edf298e3699fef2c$var$metadata,
    add: (additions)=>{
        $edf298e3699fef2c$var$metadata = Object.assign(Object.assign({}, $edf298e3699fef2c$var$metadata), additions);
    }
};

});

parcelRegister("2TU3n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("yyBtO", function(module, exports) {
"use strict";
var $067e04a0b95d7aec$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $gEGY8 = parcelRequire("gEGY8");


var $efYQm = parcelRequire("efYQm");


var $dYbRq = parcelRequire("dYbRq");


var $4DTY3 = parcelRequire("4DTY3");


var $fpY7K = parcelRequire("fpY7K");

const $067e04a0b95d7aec$var$CACHE_LIMIT = 10;
class $067e04a0b95d7aec$var$DataAdapterCore {
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $dYbRq._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $dYbRq._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $067e04a0b95d7aec$var$_makeDataAdapterResult('Bootstrap', data, null, normalized));
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $efYQm.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $067e04a0b95d7aec$var$__awaiter(this, void 0, void 0, function*() {
            if (!$4DTY3.Storage.isReady()) yield $4DTY3.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $gEGY8.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $067e04a0b95d7aec$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $dYbRq._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $067e04a0b95d7aec$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $gEGY8.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $fpY7K._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $efYQm.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $067e04a0b95d7aec$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $067e04a0b95d7aec$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $gEGY8.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $4DTY3.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($4DTY3.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $fpY7K._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $4DTY3.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $4DTY3._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $067e04a0b95d7aec$var$_getEvictableKey(lastModifiedTimeMap, $067e04a0b95d7aec$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $4DTY3.Storage.removeItem(evictable);
        }
        (0, $4DTY3._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $067e04a0b95d7aec$var$InMemoryCache();
    }
}
module.exports.DataAdapterCore = $067e04a0b95d7aec$var$DataAdapterCore;
function $067e04a0b95d7aec$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $dYbRq._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $067e04a0b95d7aec$var$_makeDataAdapterResult;
class $067e04a0b95d7aec$var$InMemoryCache {
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $gEGY8.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $067e04a0b95d7aec$var$_getEvictableKey(this._data, $067e04a0b95d7aec$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
    constructor(){
        this._data = {};
    }
}
function $067e04a0b95d7aec$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === 'object' && typeof current === 'object') return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});

parcelRegister("efYQm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $bCidb = parcelRequire("bCidb");


var $gEGY8 = parcelRequire("gEGY8");


var $c03HY = parcelRequire("c03HY");


var $4DTY3 = parcelRequire("4DTY3");


var $jWTBq = parcelRequire("jWTBq");

const $a611a9ac97ca6246$var$PROMISE_MAP = {};
const $a611a9ac97ca6246$var$COOKIE_ENABLED_MAP = {};
const $a611a9ac97ca6246$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($a611a9ac97ca6246$var$DISABLED_MAP[sdkKey]) return null;
        if ($a611a9ac97ca6246$var$PROMISE_MAP[sdkKey] != null) return $a611a9ac97ca6246$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $a611a9ac97ca6246$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $a611a9ac97ca6246$var$PROMISE_MAP[sdkKey] = stableID;
            $a611a9ac97ca6246$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $a611a9ac97ca6246$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $jWTBq.getUUID)();
        $a611a9ac97ca6246$var$_persistToStorage(stableID, sdkKey);
        $a611a9ac97ca6246$var$_persistToCookie(stableID, sdkKey);
        $a611a9ac97ca6246$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $a611a9ac97ca6246$var$PROMISE_MAP[sdkKey] = override;
        $a611a9ac97ca6246$var$_persistToStorage(override, sdkKey);
        $a611a9ac97ca6246$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $a611a9ac97ca6246$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $a611a9ac97ca6246$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $a611a9ac97ca6246$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $bCidb._getStorageKey)(sdkKey)}`;
}
function $a611a9ac97ca6246$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $a611a9ac97ca6246$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $4DTY3._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $gEGY8.Log.warn('Failed to save StableID to storage');
    }
}
function $a611a9ac97ca6246$var$_loadFromStorage(sdkKey) {
    const storageKey = $a611a9ac97ca6246$var$_getStableIDStorageKey(sdkKey);
    return (0, $4DTY3._getObjectFromStorage)(storageKey);
}
function $a611a9ac97ca6246$var$_loadFromCookie(sdkKey) {
    if (!$a611a9ac97ca6246$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $c03HY._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $a611a9ac97ca6246$var$_getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $a611a9ac97ca6246$var$_persistToCookie(stableID, sdkKey) {
    if (!$a611a9ac97ca6246$var$COOKIE_ENABLED_MAP[sdkKey] || !document) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$a611a9ac97ca6246$var$_getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $a611a9ac97ca6246$var$_getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $bCidb._getStorageKey)(sdkKey)}`;
}

});

parcelRegister("jWTBq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $e85e90a67feaf7cf$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $e85e90a67feaf7cf$var$getUUID;

});

parcelRegister("dYbRq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $hfOjO = parcelRequire("hfOjO");


var $gEGY8 = parcelRequire("gEGY8");

function $a2ba143ca3c3a221$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $gEGY8.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $a2ba143ca3c3a221$var$_normalizeUser;
function $a2ba143ca3c3a221$var$_getFullUserHash(user) {
    return user ? (0, $hfOjO._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $a2ba143ca3c3a221$var$_getFullUserHash;

});

parcelRegister("fpY7K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $gEGY8 = parcelRequire("gEGY8");

/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $b397d433f21d34e6$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $gEGY8.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $b397d433f21d34e6$var$_typedJsonParse;

});

parcelRegister("fZ2rG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gTaww", function(module, exports) {
"use strict";
var $c4b9f226b555a4ab$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $gEGY8 = parcelRequire("gEGY8");


var $csFe1 = parcelRequire("csFe1");


var $kqAyV = parcelRequire("kqAyV");

module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $c4b9f226b555a4ab$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $c4b9f226b555a4ab$var$ErrorBoundary {
    wrap(instance) {
        try {
            const obj = instance;
            $c4b9f226b555a4ab$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $c4b9f226b555a4ab$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $gEGY8.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$c4b9f226b555a4ab$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($c4b9f226b555a4ab$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $c4b9f226b555a4ab$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $csFe1.SDKType._get(this._sdkKey);
                    const statsigMetadata = $kqAyV.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $c4b9f226b555a4ab$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $c4b9f226b555a4ab$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
}
module.exports.ErrorBoundary = $c4b9f226b555a4ab$var$ErrorBoundary;
function $c4b9f226b555a4ab$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $c4b9f226b555a4ab$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $c4b9f226b555a4ab$var$UNKNOWN_ERROR;
    }
}
function $c4b9f226b555a4ab$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $c4b9f226b555a4ab$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.entries(options).forEach(([option, value])=>{
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});

parcelRegister("csFe1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $9128140903f63dc4$var$SDK_CLIENT = {};
let $9128140903f63dc4$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $9128140903f63dc4$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($9128140903f63dc4$var$suffix !== null && $9128140903f63dc4$var$suffix !== void 0 ? $9128140903f63dc4$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $9128140903f63dc4$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$9128140903f63dc4$var$suffix || $9128140903f63dc4$var$suffix === '-react') $9128140903f63dc4$var$suffix = '-' + binding;
    }
};

});

parcelRegister("8tHvG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aVYNV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9oX2t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fwPWd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $b4e221f9aeb62af0$var$EXIST_KEYS = new Set([]);
const $b4e221f9aeb62af0$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $b4e221f9aeb62af0$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($b4e221f9aeb62af0$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($b4e221f9aeb62af0$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $b4e221f9aeb62af0$var$createMemoKey;

});

parcelRegister("g2HdN", function(module, exports) {
"use strict";
var $bade5c295cda34ca$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $jThPW = parcelRequire("jThPW");





var $g7kXt = parcelRequire("g7kXt");


var $gEGY8 = parcelRequire("gEGY8");


var $9SMpY = parcelRequire("9SMpY");


var $5QGKZ = parcelRequire("5QGKZ");


var $bXP0P = parcelRequire("bXP0P");


var $csFe1 = parcelRequire("csFe1");


var $c03HY = parcelRequire("c03HY");


var $humPl = parcelRequire("humPl");


var $efYQm = parcelRequire("efYQm");


var $4GR4m = parcelRequire("4GR4m");


var $kqAyV = parcelRequire("kqAyV");


var $l7BAr = parcelRequire("l7BAr");


var $kOIO0 = parcelRequire("kOIO0");

const $bade5c295cda34ca$var$DEFAULT_TIMEOUT_MS = 10000;
const $bade5c295cda34ca$var$BACKOFF_BASE_MS = 500;
const $bade5c295cda34ca$var$BACKOFF_MAX_MS = 30000;
const $bade5c295cda34ca$var$RATE_LIMIT_WINDOW_MS = 1000;
const $bade5c295cda34ca$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $bade5c295cda34ca$var$LEAK_RATE = $bade5c295cda34ca$var$RATE_LIMIT_MAX_REQ_COUNT / $bade5c295cda34ca$var$RATE_LIMIT_WINDOW_MS;
const $bade5c295cda34ca$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $bade5c295cda34ca$var$NetworkCore {
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$bade5c295cda34ca$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $bade5c295cda34ca$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $bade5c295cda34ca$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$bade5c295cda34ca$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $gEGY8.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $kOIO0._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $bade5c295cda34ca$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $bade5c295cda34ca$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $bade5c295cda34ca$var$_getErrorMessage(abortController, error);
                const timedOut = $bade5c295cda34ca$var$_didTimeout(abortController);
                $bade5c295cda34ca$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$bade5c295cda34ca$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $4GR4m.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $gEGY8.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $bade5c295cda34ca$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $l7BAr.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $l7BAr.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $bade5c295cda34ca$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $bade5c295cda34ca$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $9SMpY.Endpoint._initialize || args.urlConfig.endpoint === $9SMpY.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$9SMpY.NetworkParam.SdkKey]: args.sdkKey,
            [$9SMpY.NetworkParam.SdkType]: $csFe1.SDKType._get(args.sdkKey),
            [$9SMpY.NetworkParam.SdkVersion]: $kqAyV.SDK_VERSION,
            [$9SMpY.NetworkParam.Time]: String(Date.now()),
            [$9SMpY.NetworkParam.SessionID]: $humPl.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $c03HY._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $jThPW._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$9SMpY.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $gEGY8.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $bade5c295cda34ca$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$bade5c295cda34ca$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($gEGY8.Log.error);
                writer.close().catch($gEGY8.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$9SMpY.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $gEGY8.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $bade5c295cda34ca$var$_populateRequestBody(result, args.data);
        return result;
    }
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $bade5c295cda34ca$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $5QGKZ.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
}
module.exports.NetworkCore = $bade5c295cda34ca$var$NetworkCore;
const $bade5c295cda34ca$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $gEGY8.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $bade5c295cda34ca$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $efYQm.StableID.get(sdkKey);
    const sessionID = $humPl.SessionID.get(sdkKey);
    const sdkType = $csFe1.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $kqAyV.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $bade5c295cda34ca$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $jThPW._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $bXP0P.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $l7BAr.LogEventCompressionMode.Disabled:
            return false;
        case $l7BAr.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $l7BAr.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $bade5c295cda34ca$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string') return controller.signal.reason;
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $bade5c295cda34ca$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string' && controller.signal.reason.includes('Timeout');
    return timeout || false;
}
function $bade5c295cda34ca$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $9SMpY.Endpoint._initialize) return;
    $g7kXt.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $bade5c295cda34ca$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $9SMpY.Endpoint._initialize) return;
    $g7kXt.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $g7kXt.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $bade5c295cda34ca$var$_exponentialBackoff(attempt) {
    return $bade5c295cda34ca$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($bade5c295cda34ca$var$BACKOFF_BASE_MS * (attempt * attempt), $bade5c295cda34ca$var$BACKOFF_MAX_MS)));
    });
}

});

parcelRegister("bXP0P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $8b5cc6665df27db6$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $8b5cc6665df27db6$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $8b5cc6665df27db6$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("humPl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $jThPW = parcelRequire("jThPW");


var $bCidb = parcelRequire("bCidb");


var $gEGY8 = parcelRequire("gEGY8");


var $4DTY3 = parcelRequire("4DTY3");


var $jWTBq = parcelRequire("jWTBq");

const $cbb6f20774bde4c8$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $cbb6f20774bde4c8$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $cbb6f20774bde4c8$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($cbb6f20774bde4c8$var$PROMISE_MAP[sdkKey] == null) $cbb6f20774bde4c8$var$PROMISE_MAP[sdkKey] = $cbb6f20774bde4c8$var$_loadSession(sdkKey);
        const session = $cbb6f20774bde4c8$var$PROMISE_MAP[sdkKey];
        return $cbb6f20774bde4c8$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $cbb6f20774bde4c8$var$PROMISE_MAP[sdkKey] = $cbb6f20774bde4c8$var$_overrideSessionId(override, sdkKey);
    }
};
function $cbb6f20774bde4c8$var$_loadSession(sdkKey) {
    let data = $cbb6f20774bde4c8$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $jWTBq.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $cbb6f20774bde4c8$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $cbb6f20774bde4c8$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($cbb6f20774bde4c8$var$_isIdle(data) || $cbb6f20774bde4c8$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $jWTBq.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $cbb6f20774bde4c8$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $cbb6f20774bde4c8$var$_createSessionTimeout(sdkKey, $cbb6f20774bde4c8$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $cbb6f20774bde4c8$var$_createSessionTimeout(sdkKey, $cbb6f20774bde4c8$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $cbb6f20774bde4c8$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $jThPW._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $cbb6f20774bde4c8$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $cbb6f20774bde4c8$var$MAX_SESSION_IDLE_TIME;
}
function $cbb6f20774bde4c8$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $cbb6f20774bde4c8$var$MAX_SESSION_AGE;
}
function $cbb6f20774bde4c8$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $bCidb._getStorageKey)(sdkKey)}`;
}
function $cbb6f20774bde4c8$var$_persistToStorage(session, sdkKey) {
    const storageKey = $cbb6f20774bde4c8$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $4DTY3._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $gEGY8.Log.warn('Failed to save SessionID');
    }
}
function $cbb6f20774bde4c8$var$_loadFromStorage(sdkKey) {
    const storageKey = $cbb6f20774bde4c8$var$_getSessionIDStorageKey(sdkKey);
    return (0, $4DTY3._getObjectFromStorage)(storageKey);
}

});

parcelRegister("4GR4m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});

parcelRegister("lhJ27", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("mHIrT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hNnlB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $cf491f965920c218$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $cf491f965920c218$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $cf491f965920c218$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $cf491f965920c218$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $cf491f965920c218$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $cf491f965920c218$var$_fastApproxSizeOf;

});

parcelRegister("dlQeO", function(module, exports) {
"use strict";
var $9b85c1e5fa2cf312$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $jThPW = parcelRequire("jThPW");





var $gTaww = parcelRequire("gTaww");


var $2y1fg = parcelRequire("2y1fg");


var $gEGY8 = parcelRequire("gEGY8");


var $fwPWd = parcelRequire("fwPWd");


var $c03HY = parcelRequire("c03HY");


var $humPl = parcelRequire("humPl");


var $efYQm = parcelRequire("efYQm");


var $l7BAr = parcelRequire("l7BAr");


var $4DTY3 = parcelRequire("4DTY3");

const $9b85c1e5fa2cf312$var$MAX_MEMO_CACHE_SIZE = 3000;
class $9b85c1e5fa2cf312$var$StatsigClientBase {
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $4DTY3.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $efYQm.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($l7BAr.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $9b85c1e5fa2cf312$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $gEGY8.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $fwPWd.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $9b85c1e5fa2cf312$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($gEGY8.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $4DTY3.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $humPl.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $4DTY3.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $efYQm.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $efYQm.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $2y1fg.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $gTaww.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $4DTY3.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $9b85c1e5fa2cf312$var$_assignGlobalInstance(sdkKey, this);
    }
}
module.exports.StatsigClientBase = $9b85c1e5fa2cf312$var$StatsigClientBase;
function $9b85c1e5fa2cf312$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $c03HY._isServerEnv)()) return;
    const statsigGlobal = (0, $jThPW._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $gEGY8.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("7ndJy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("j4WXX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3WRYT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $gEGY8 = parcelRequire("gEGY8");


var $l5YTH = parcelRequire("l5YTH");

function $2e00a966e411cc8f$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $2e00a966e411cc8f$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $2e00a966e411cc8f$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $2e00a966e411cc8f$var$_makeFeatureGate;
function $2e00a966e411cc8f$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $2e00a966e411cc8f$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $2e00a966e411cc8f$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $2e00a966e411cc8f$var$_makeDynamicConfig;
function $2e00a966e411cc8f$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $2e00a966e411cc8f$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $2e00a966e411cc8f$var$_makeExperiment;
function $2e00a966e411cc8f$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $2e00a966e411cc8f$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $2e00a966e411cc8f$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $2e00a966e411cc8f$var$_makeLayer;
function $2e00a966e411cc8f$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $2e00a966e411cc8f$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $2e00a966e411cc8f$var$_mergeOverride;
function $2e00a966e411cc8f$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $l5YTH._isTypeMatch)(found, fallback)) {
            $gEGY8.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $2e00a966e411cc8f$var$_makeTypedGet;

});

parcelRegister("8qVRj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("knKVb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $ed6a5a39d09bc8bf$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $ed6a5a39d09bc8bf$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});

parcelRegister("90YwQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ca7c9a0a318ac25$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var $2ca7c9a0a318ac25$export$2e2bcd8739ae039 = (0, $42omo.createContext)(null);

});

parcelRegister("hTKp4", function(module, exports) {
const $9389511d27301d89$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};
module.exports["getDocument"] = $9389511d27301d89$export$f65ca476c09acec0;

});

parcelRegister("5QpZa", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");

let $74a91b492495e33b$var$shouldInitilizeGlobalErrorHandler = true;
let $74a91b492495e33b$var$globalCount = 0;
const $74a91b492495e33b$var$errors = [];
let $74a91b492495e33b$var$push = (name, labelStack, errorType, errorMessage, errorStack)=>{
    $74a91b492495e33b$var$errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack
    });
};
function $74a91b492495e33b$export$ebe081a8c9bf8176(sinkFunc) {
    $74a91b492495e33b$var$push = sinkFunc;
    $74a91b492495e33b$var$errors.forEach((e)=>{
        sinkFunc(e.name, e.labelStack, e.errorType, e.errorMessage, e.errorStack);
    });
    $74a91b492495e33b$var$errors.length = 0;
}
function $74a91b492495e33b$export$d06c0426664e7c08() {
    return $74a91b492495e33b$var$globalCount;
}
function $74a91b492495e33b$var$handleError(e) {
    $74a91b492495e33b$var$globalCount++;
    if (e.error?.UFOhasCaught === undefined) try {
        if (e.error instanceof Error) $74a91b492495e33b$var$push('GlobalErrorHandler', null, e.error.name, e.error.message, e.error.stack);
        else if (e.error) {
            const hint = JSON.stringify(e.error).slice(0, 50);
            $74a91b492495e33b$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        } else if (e.message !== undefined) {
            const hint = e.message.slice(0, 50);
            $74a91b492495e33b$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        }
        if (e.error && typeof e.error === 'object') e.error.UFOhasCaught = true;
    // eslint-disable-next-line no-empty
    } catch (e) {}
}
function $74a91b492495e33b$var$handlePromiseRejection(e) {
    $74a91b492495e33b$var$globalCount++;
    if (e.reason instanceof Error) $74a91b492495e33b$var$push('GlobalErrorHandler', null, e.reason.name, e.reason.message, e.reason.stack);
    else if (e.reason) try {
        const hint = JSON.stringify(e.reason).slice(0, 50);
        $74a91b492495e33b$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
    // eslint-disable-next-line no-empty
    } catch (e) {}
}
function $74a91b492495e33b$var$setupUFOGlobalErrorHandler() {
    if ($74a91b492495e33b$var$shouldInitilizeGlobalErrorHandler) {
        (0, $fFa3V.bind)(window, {
            type: 'error',
            listener: (e)=>$74a91b492495e33b$var$handleError(e)
        });
        (0, $fFa3V.bind)(window, {
            type: 'unhandledrejection',
            listener: $74a91b492495e33b$var$handlePromiseRejection
        });
        $74a91b492495e33b$var$shouldInitilizeGlobalErrorHandler = false;
    }
}
var $74a91b492495e33b$export$2e2bcd8739ae039 = $74a91b492495e33b$var$setupUFOGlobalErrorHandler;
module.exports["getGlobalErrorCount"] = $74a91b492495e33b$export$d06c0426664e7c08;
module.exports["default"] = $74a91b492495e33b$export$2e2bcd8739ae039;

});

parcelRegister("1iSzD", function(module, exports) {

var $6CWAz = parcelRequire("6CWAz");


var $3XKuW = parcelRequire("3XKuW");


var $diaaX = parcelRequire("diaaX");

const $6897d68cb85ce934$export$8195e508b27d5978 = ()=>Boolean(window?.frameElement?.[0, $3XKuW.EP_REACT_PROPS_OBSERVABLE_OBJECT]) || window?.name.includes((0, $diaaX.CHANNEL_NAME));


const $f673983857dd97cf$export$9c21f25960873ecb = (location)=>{
    if (!location) location = window.location;
    const { query: query } = (0, (/*@__PURE__*/$parcel$interopDefault($6CWAz))).parse(location.search, true);
    return query.embedded === 'true' || Boolean(query.parentProduct) || (0, $6897d68cb85ce934$export$8195e508b27d5978)();
};
module.exports["isEmbeddedConfluence_DO_NOT_USE"] = $f673983857dd97cf$export$9c21f25960873ecb;

});

parcelRegister("6CWAz", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $htTYG = parcelRequire("htTYG");

function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
var $95ff1ffdf00be801$exports = {};
'use strict';
var $dbc61fd5134a1e4f$exports = {};
'use strict';
var $fd99ee91f5a6fc1f$exports = {};
'use strict';

var $bLmKG = parcelRequire("bLmKG");

var $123d0c2eaecc9456$exports = {};
var $123d0c2eaecc9456$var$hasMap = typeof Map === 'function' && Map.prototype;
var $123d0c2eaecc9456$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $123d0c2eaecc9456$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $123d0c2eaecc9456$var$mapSize = $123d0c2eaecc9456$var$hasMap && $123d0c2eaecc9456$var$mapSizeDescriptor && typeof $123d0c2eaecc9456$var$mapSizeDescriptor.get === 'function' ? $123d0c2eaecc9456$var$mapSizeDescriptor.get : null;
var $123d0c2eaecc9456$var$mapForEach = $123d0c2eaecc9456$var$hasMap && Map.prototype.forEach;
var $123d0c2eaecc9456$var$hasSet = typeof Set === 'function' && Set.prototype;
var $123d0c2eaecc9456$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $123d0c2eaecc9456$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $123d0c2eaecc9456$var$setSize = $123d0c2eaecc9456$var$hasSet && $123d0c2eaecc9456$var$setSizeDescriptor && typeof $123d0c2eaecc9456$var$setSizeDescriptor.get === 'function' ? $123d0c2eaecc9456$var$setSizeDescriptor.get : null;
var $123d0c2eaecc9456$var$setForEach = $123d0c2eaecc9456$var$hasSet && Set.prototype.forEach;
var $123d0c2eaecc9456$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $123d0c2eaecc9456$var$weakMapHas = $123d0c2eaecc9456$var$hasWeakMap ? WeakMap.prototype.has : null;
var $123d0c2eaecc9456$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $123d0c2eaecc9456$var$weakSetHas = $123d0c2eaecc9456$var$hasWeakSet ? WeakSet.prototype.has : null;
var $123d0c2eaecc9456$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $123d0c2eaecc9456$var$weakRefDeref = $123d0c2eaecc9456$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $123d0c2eaecc9456$var$booleanValueOf = Boolean.prototype.valueOf;
var $123d0c2eaecc9456$var$objectToString = Object.prototype.toString;
var $123d0c2eaecc9456$var$functionToString = Function.prototype.toString;
var $123d0c2eaecc9456$var$$match = String.prototype.match;
var $123d0c2eaecc9456$var$$slice = String.prototype.slice;
var $123d0c2eaecc9456$var$$replace = String.prototype.replace;
var $123d0c2eaecc9456$var$$toUpperCase = String.prototype.toUpperCase;
var $123d0c2eaecc9456$var$$toLowerCase = String.prototype.toLowerCase;
var $123d0c2eaecc9456$var$$test = RegExp.prototype.test;
var $123d0c2eaecc9456$var$$concat = Array.prototype.concat;
var $123d0c2eaecc9456$var$$join = Array.prototype.join;
var $123d0c2eaecc9456$var$$arrSlice = Array.prototype.slice;
var $123d0c2eaecc9456$var$$floor = Math.floor;
var $123d0c2eaecc9456$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $123d0c2eaecc9456$var$gOPS = Object.getOwnPropertySymbols;
var $123d0c2eaecc9456$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $123d0c2eaecc9456$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $123d0c2eaecc9456$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $123d0c2eaecc9456$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $123d0c2eaecc9456$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $123d0c2eaecc9456$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $123d0c2eaecc9456$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $123d0c2eaecc9456$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$123d0c2eaecc9456$var$$floor(-num) : $123d0c2eaecc9456$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $123d0c2eaecc9456$var$$slice.call(str, intStr.length + 1);
            return $123d0c2eaecc9456$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $123d0c2eaecc9456$var$$replace.call($123d0c2eaecc9456$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $123d0c2eaecc9456$var$$replace.call(str, sepRegex, '$&_');
}

var $h1hUh = parcelRequire("h1hUh");

var $123d0c2eaecc9456$var$inspectCustom = $h1hUh.custom;
var $123d0c2eaecc9456$var$inspectSymbol = $123d0c2eaecc9456$var$isSymbol($123d0c2eaecc9456$var$inspectCustom) ? $123d0c2eaecc9456$var$inspectCustom : null;
var $123d0c2eaecc9456$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $123d0c2eaecc9456$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
$123d0c2eaecc9456$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($123d0c2eaecc9456$var$has(opts, 'quoteStyle') && !$123d0c2eaecc9456$var$has($123d0c2eaecc9456$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($123d0c2eaecc9456$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $123d0c2eaecc9456$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($123d0c2eaecc9456$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($123d0c2eaecc9456$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $123d0c2eaecc9456$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $123d0c2eaecc9456$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $123d0c2eaecc9456$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $123d0c2eaecc9456$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $123d0c2eaecc9456$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($123d0c2eaecc9456$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $123d0c2eaecc9456$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($123d0c2eaecc9456$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$123d0c2eaecc9456$var$isRegExp(obj)) {
        var name = $123d0c2eaecc9456$var$nameOf(obj);
        var keys = $123d0c2eaecc9456$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $123d0c2eaecc9456$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($123d0c2eaecc9456$var$isSymbol(obj)) {
        var symString = $123d0c2eaecc9456$var$hasShammedSymbols ? $123d0c2eaecc9456$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $123d0c2eaecc9456$var$symToString.call(obj);
        return typeof obj === 'object' && !$123d0c2eaecc9456$var$hasShammedSymbols ? $123d0c2eaecc9456$var$markBoxed(symString) : symString;
    }
    if ($123d0c2eaecc9456$var$isElement(obj)) {
        var s = '<' + $123d0c2eaecc9456$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $123d0c2eaecc9456$var$wrapQuotes($123d0c2eaecc9456$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $123d0c2eaecc9456$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($123d0c2eaecc9456$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $123d0c2eaecc9456$var$arrObjKeys(obj, inspect);
        if (indent && !$123d0c2eaecc9456$var$singleLineValues(xs)) return '[' + $123d0c2eaecc9456$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $123d0c2eaecc9456$var$$join.call(xs, ', ') + ' ]';
    }
    if ($123d0c2eaecc9456$var$isError(obj)) {
        var parts = $123d0c2eaecc9456$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$123d0c2eaecc9456$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $123d0c2eaecc9456$var$$join.call($123d0c2eaecc9456$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $123d0c2eaecc9456$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($123d0c2eaecc9456$var$inspectSymbol && typeof obj[$123d0c2eaecc9456$var$inspectSymbol] === 'function' && $h1hUh) return $h1hUh(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($123d0c2eaecc9456$var$isMap(obj)) {
        var mapParts = [];
        if ($123d0c2eaecc9456$var$mapForEach) $123d0c2eaecc9456$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $123d0c2eaecc9456$var$collectionOf('Map', $123d0c2eaecc9456$var$mapSize.call(obj), mapParts, indent);
    }
    if ($123d0c2eaecc9456$var$isSet(obj)) {
        var setParts = [];
        if ($123d0c2eaecc9456$var$setForEach) $123d0c2eaecc9456$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $123d0c2eaecc9456$var$collectionOf('Set', $123d0c2eaecc9456$var$setSize.call(obj), setParts, indent);
    }
    if ($123d0c2eaecc9456$var$isWeakMap(obj)) return $123d0c2eaecc9456$var$weakCollectionOf('WeakMap');
    if ($123d0c2eaecc9456$var$isWeakSet(obj)) return $123d0c2eaecc9456$var$weakCollectionOf('WeakSet');
    if ($123d0c2eaecc9456$var$isWeakRef(obj)) return $123d0c2eaecc9456$var$weakCollectionOf('WeakRef');
    if ($123d0c2eaecc9456$var$isNumber(obj)) return $123d0c2eaecc9456$var$markBoxed(inspect(Number(obj)));
    if ($123d0c2eaecc9456$var$isBigInt(obj)) return $123d0c2eaecc9456$var$markBoxed(inspect($123d0c2eaecc9456$var$bigIntValueOf.call(obj)));
    if ($123d0c2eaecc9456$var$isBoolean(obj)) return $123d0c2eaecc9456$var$markBoxed($123d0c2eaecc9456$var$booleanValueOf.call(obj));
    if ($123d0c2eaecc9456$var$isString(obj)) return $123d0c2eaecc9456$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$123d0c2eaecc9456$var$isDate(obj) && !$123d0c2eaecc9456$var$isRegExp(obj)) {
        var ys = $123d0c2eaecc9456$var$arrObjKeys(obj, inspect);
        var isPlainObject = $123d0c2eaecc9456$var$gPO ? $123d0c2eaecc9456$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $123d0c2eaecc9456$var$toStringTag && Object(obj) === obj && $123d0c2eaecc9456$var$toStringTag in obj ? $123d0c2eaecc9456$var$$slice.call($123d0c2eaecc9456$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $123d0c2eaecc9456$var$$join.call($123d0c2eaecc9456$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $123d0c2eaecc9456$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $123d0c2eaecc9456$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $123d0c2eaecc9456$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $123d0c2eaecc9456$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $123d0c2eaecc9456$var$quote(s) {
    return $123d0c2eaecc9456$var$$replace.call(String(s), /"/g, '&quot;');
}
function $123d0c2eaecc9456$var$canTrustToString(obj) {
    return !$123d0c2eaecc9456$var$toStringTag || !(typeof obj === 'object' && ($123d0c2eaecc9456$var$toStringTag in obj || typeof obj[$123d0c2eaecc9456$var$toStringTag] !== 'undefined'));
}
function $123d0c2eaecc9456$var$isArray(obj) {
    return $123d0c2eaecc9456$var$toStr(obj) === '[object Array]' && $123d0c2eaecc9456$var$canTrustToString(obj);
}
function $123d0c2eaecc9456$var$isDate(obj) {
    return $123d0c2eaecc9456$var$toStr(obj) === '[object Date]' && $123d0c2eaecc9456$var$canTrustToString(obj);
}
function $123d0c2eaecc9456$var$isRegExp(obj) {
    return $123d0c2eaecc9456$var$toStr(obj) === '[object RegExp]' && $123d0c2eaecc9456$var$canTrustToString(obj);
}
function $123d0c2eaecc9456$var$isError(obj) {
    return $123d0c2eaecc9456$var$toStr(obj) === '[object Error]' && $123d0c2eaecc9456$var$canTrustToString(obj);
}
function $123d0c2eaecc9456$var$isString(obj) {
    return $123d0c2eaecc9456$var$toStr(obj) === '[object String]' && $123d0c2eaecc9456$var$canTrustToString(obj);
}
function $123d0c2eaecc9456$var$isNumber(obj) {
    return $123d0c2eaecc9456$var$toStr(obj) === '[object Number]' && $123d0c2eaecc9456$var$canTrustToString(obj);
}
function $123d0c2eaecc9456$var$isBoolean(obj) {
    return $123d0c2eaecc9456$var$toStr(obj) === '[object Boolean]' && $123d0c2eaecc9456$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $123d0c2eaecc9456$var$isSymbol(obj) {
    if ($123d0c2eaecc9456$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$123d0c2eaecc9456$var$symToString) return false;
    try {
        $123d0c2eaecc9456$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $123d0c2eaecc9456$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$123d0c2eaecc9456$var$bigIntValueOf) return false;
    try {
        $123d0c2eaecc9456$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $123d0c2eaecc9456$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $123d0c2eaecc9456$var$has(obj, key) {
    return $123d0c2eaecc9456$var$hasOwn.call(obj, key);
}
function $123d0c2eaecc9456$var$toStr(obj) {
    return $123d0c2eaecc9456$var$objectToString.call(obj);
}
function $123d0c2eaecc9456$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $123d0c2eaecc9456$var$$match.call($123d0c2eaecc9456$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $123d0c2eaecc9456$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $123d0c2eaecc9456$var$isMap(x) {
    if (!$123d0c2eaecc9456$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $123d0c2eaecc9456$var$mapSize.call(x);
        try {
            $123d0c2eaecc9456$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $123d0c2eaecc9456$var$isWeakMap(x) {
    if (!$123d0c2eaecc9456$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $123d0c2eaecc9456$var$weakMapHas.call(x, $123d0c2eaecc9456$var$weakMapHas);
        try {
            $123d0c2eaecc9456$var$weakSetHas.call(x, $123d0c2eaecc9456$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $123d0c2eaecc9456$var$isWeakRef(x) {
    if (!$123d0c2eaecc9456$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $123d0c2eaecc9456$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $123d0c2eaecc9456$var$isSet(x) {
    if (!$123d0c2eaecc9456$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $123d0c2eaecc9456$var$setSize.call(x);
        try {
            $123d0c2eaecc9456$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $123d0c2eaecc9456$var$isWeakSet(x) {
    if (!$123d0c2eaecc9456$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $123d0c2eaecc9456$var$weakSetHas.call(x, $123d0c2eaecc9456$var$weakSetHas);
        try {
            $123d0c2eaecc9456$var$weakMapHas.call(x, $123d0c2eaecc9456$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $123d0c2eaecc9456$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $123d0c2eaecc9456$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $123d0c2eaecc9456$var$inspectString($123d0c2eaecc9456$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $123d0c2eaecc9456$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $123d0c2eaecc9456$var$$replace.call($123d0c2eaecc9456$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $123d0c2eaecc9456$var$lowbyte);
    return $123d0c2eaecc9456$var$wrapQuotes(s, 'single', opts);
}
function $123d0c2eaecc9456$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $123d0c2eaecc9456$var$$toUpperCase.call(n.toString(16));
}
function $123d0c2eaecc9456$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $123d0c2eaecc9456$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $123d0c2eaecc9456$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $123d0c2eaecc9456$var$indentedJoin(entries, indent) : $123d0c2eaecc9456$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $123d0c2eaecc9456$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($123d0c2eaecc9456$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $123d0c2eaecc9456$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $123d0c2eaecc9456$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $123d0c2eaecc9456$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $123d0c2eaecc9456$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $123d0c2eaecc9456$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $123d0c2eaecc9456$var$arrObjKeys(obj, inspect) {
    var isArr = $123d0c2eaecc9456$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $123d0c2eaecc9456$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $123d0c2eaecc9456$var$gOPS === 'function' ? $123d0c2eaecc9456$var$gOPS(obj) : [];
    var symMap;
    if ($123d0c2eaecc9456$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$123d0c2eaecc9456$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($123d0c2eaecc9456$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($123d0c2eaecc9456$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $123d0c2eaecc9456$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($123d0c2eaecc9456$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}


var $b951fceb01bd8c07$exports = {};
'use strict';




/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $b951fceb01bd8c07$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $b951fceb01bd8c07$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $b951fceb01bd8c07$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $b951fceb01bd8c07$var$listSet = function(objects, key, value) {
    var node = $b951fceb01bd8c07$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $b951fceb01bd8c07$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$b951fceb01bd8c07$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $b951fceb01bd8c07$var$listDelete = function(objects, key) {
    if (objects) return $b951fceb01bd8c07$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ $b951fceb01bd8c07$exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $bLmKG('Side channel does not contain ' + $123d0c2eaecc9456$exports(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $b951fceb01bd8c07$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $b951fceb01bd8c07$var$listGet($o, key);
        },
        has: function(key) {
            return $b951fceb01bd8c07$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $b951fceb01bd8c07$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $f5e662bee64eac0b$exports = {};
'use strict';

var $92atP = parcelRequire("92atP");


var $aahHV = parcelRequire("aahHV");





var $f5e662bee64eac0b$var$$Map = $92atP('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $f5e662bee64eac0b$var$$mapGet = $aahHV('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $f5e662bee64eac0b$var$$mapSet = $aahHV('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $f5e662bee64eac0b$var$$mapHas = $aahHV('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $f5e662bee64eac0b$var$$mapDelete = $aahHV('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $f5e662bee64eac0b$var$$mapSize = $aahHV('Map.prototype.size', true);
/** @type {import('.')} */ $f5e662bee64eac0b$exports = !!$f5e662bee64eac0b$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $bLmKG('Side channel does not contain ' + $123d0c2eaecc9456$exports(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $f5e662bee64eac0b$var$$mapDelete($m, key);
                if ($f5e662bee64eac0b$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $f5e662bee64eac0b$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $f5e662bee64eac0b$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $f5e662bee64eac0b$var$$Map();
            $f5e662bee64eac0b$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};


var $793c124acd8ca4c1$exports = {};
'use strict';











var $793c124acd8ca4c1$var$$WeakMap = $92atP('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $793c124acd8ca4c1$var$$weakMapGet = $aahHV('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $793c124acd8ca4c1$var$$weakMapSet = $aahHV('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $793c124acd8ca4c1$var$$weakMapHas = $aahHV('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $793c124acd8ca4c1$var$$weakMapDelete = $aahHV('WeakMap.prototype.delete', true);
/** @type {import('.')} */ $793c124acd8ca4c1$exports = $793c124acd8ca4c1$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $bLmKG('Side channel does not contain ' + $123d0c2eaecc9456$exports(key));
        },
        'delete': function(key) {
            if ($793c124acd8ca4c1$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $793c124acd8ca4c1$var$$weakMapDelete($wm, key);
            } else if ($f5e662bee64eac0b$exports) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($793c124acd8ca4c1$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $793c124acd8ca4c1$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($793c124acd8ca4c1$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $793c124acd8ca4c1$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($793c124acd8ca4c1$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $793c124acd8ca4c1$var$$WeakMap();
                $793c124acd8ca4c1$var$$weakMapSet($wm, key, value);
            } else if ($f5e662bee64eac0b$exports) {
                if (!$m) $m = $f5e662bee64eac0b$exports();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $f5e662bee64eac0b$exports;


var $fd99ee91f5a6fc1f$var$makeChannel = $793c124acd8ca4c1$exports || $f5e662bee64eac0b$exports || $b951fceb01bd8c07$exports;
/** @type {import('.')} */ $fd99ee91f5a6fc1f$exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $bLmKG('Side channel does not contain ' + $123d0c2eaecc9456$exports(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $fd99ee91f5a6fc1f$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $70844ce8823e885e$exports = {};
'use strict';
var $d29398e4df45acfb$exports = {};
'use strict';
var $d29398e4df45acfb$var$replace = String.prototype.replace;
var $d29398e4df45acfb$var$percentTwenties = /%20/g;
var $d29398e4df45acfb$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
$d29398e4df45acfb$exports = {
    'default': $d29398e4df45acfb$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d29398e4df45acfb$var$replace.call(value, $d29398e4df45acfb$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d29398e4df45acfb$var$Format.RFC1738,
    RFC3986: $d29398e4df45acfb$var$Format.RFC3986
};


var $70844ce8823e885e$var$has = Object.prototype.hasOwnProperty;
var $70844ce8823e885e$var$isArray = Array.isArray;
var $70844ce8823e885e$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $70844ce8823e885e$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($70844ce8823e885e$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $70844ce8823e885e$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $70844ce8823e885e$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($70844ce8823e885e$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$70844ce8823e885e$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($70844ce8823e885e$var$isArray(target) && !$70844ce8823e885e$var$isArray(source)) mergeTarget = $70844ce8823e885e$var$arrayToObject(target, options);
    if ($70844ce8823e885e$var$isArray(target) && $70844ce8823e885e$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($70844ce8823e885e$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($70844ce8823e885e$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $70844ce8823e885e$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $70844ce8823e885e$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $70844ce8823e885e$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $70844ce8823e885e$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $70844ce8823e885e$var$limit){
        var segment = string.length >= $70844ce8823e885e$var$limit ? string.slice(j, j + $70844ce8823e885e$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $d29398e4df45acfb$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $70844ce8823e885e$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $70844ce8823e885e$var$hexTable[0xC0 | c >> 6] + $70844ce8823e885e$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $70844ce8823e885e$var$hexTable[0xE0 | c >> 12] + $70844ce8823e885e$var$hexTable[0x80 | c >> 6 & 0x3F] + $70844ce8823e885e$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $70844ce8823e885e$var$hexTable[0xF0 | c >> 18] + $70844ce8823e885e$var$hexTable[0x80 | c >> 12 & 0x3F] + $70844ce8823e885e$var$hexTable[0x80 | c >> 6 & 0x3F] + $70844ce8823e885e$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $70844ce8823e885e$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $70844ce8823e885e$var$compactQueue(queue);
    return value;
};
var $70844ce8823e885e$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $70844ce8823e885e$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $70844ce8823e885e$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $70844ce8823e885e$var$maybeMap = function maybeMap(val, fn) {
    if ($70844ce8823e885e$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$70844ce8823e885e$exports = {
    arrayToObject: $70844ce8823e885e$var$arrayToObject,
    assign: $70844ce8823e885e$var$assign,
    combine: $70844ce8823e885e$var$combine,
    compact: $70844ce8823e885e$var$compact,
    decode: $70844ce8823e885e$var$decode,
    encode: $70844ce8823e885e$var$encode,
    isBuffer: $70844ce8823e885e$var$isBuffer,
    isRegExp: $70844ce8823e885e$var$isRegExp,
    maybeMap: $70844ce8823e885e$var$maybeMap,
    merge: $70844ce8823e885e$var$merge
};



var $dbc61fd5134a1e4f$var$has = Object.prototype.hasOwnProperty;
var $dbc61fd5134a1e4f$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $dbc61fd5134a1e4f$var$isArray = Array.isArray;
var $dbc61fd5134a1e4f$var$push = Array.prototype.push;
var $dbc61fd5134a1e4f$var$pushToArray = function(arr, valueOrArray) {
    $dbc61fd5134a1e4f$var$push.apply(arr, $dbc61fd5134a1e4f$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $dbc61fd5134a1e4f$var$toISO = Date.prototype.toISOString;
var $dbc61fd5134a1e4f$var$defaultFormat = $d29398e4df45acfb$exports.default;
var $dbc61fd5134a1e4f$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $70844ce8823e885e$exports.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $dbc61fd5134a1e4f$var$defaultFormat,
    formatter: $d29398e4df45acfb$exports.formatters[$dbc61fd5134a1e4f$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $dbc61fd5134a1e4f$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $dbc61fd5134a1e4f$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $dbc61fd5134a1e4f$var$sentinel = {};
var $dbc61fd5134a1e4f$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($dbc61fd5134a1e4f$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($dbc61fd5134a1e4f$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $dbc61fd5134a1e4f$var$isArray(obj)) obj = $70844ce8823e885e$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $dbc61fd5134a1e4f$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($dbc61fd5134a1e4f$var$isNonNullishPrimitive(obj) || $70844ce8823e885e$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $dbc61fd5134a1e4f$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $dbc61fd5134a1e4f$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $dbc61fd5134a1e4f$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $70844ce8823e885e$exports.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($dbc61fd5134a1e4f$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $dbc61fd5134a1e4f$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $dbc61fd5134a1e4f$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $dbc61fd5134a1e4f$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $fd99ee91f5a6fc1f$exports();
        valueSideChannel.set($dbc61fd5134a1e4f$var$sentinel, sideChannel);
        $dbc61fd5134a1e4f$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $dbc61fd5134a1e4f$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $dbc61fd5134a1e4f$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $dbc61fd5134a1e4f$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $dbc61fd5134a1e4f$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $d29398e4df45acfb$exports.default;
    if (typeof opts.format !== 'undefined') {
        if (!$dbc61fd5134a1e4f$var$has.call($d29398e4df45acfb$exports.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $d29398e4df45acfb$exports.formatters[format];
    var filter = $dbc61fd5134a1e4f$var$defaults.filter;
    if (typeof opts.filter === 'function' || $dbc61fd5134a1e4f$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $dbc61fd5134a1e4f$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $dbc61fd5134a1e4f$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $dbc61fd5134a1e4f$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $dbc61fd5134a1e4f$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $dbc61fd5134a1e4f$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $dbc61fd5134a1e4f$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $dbc61fd5134a1e4f$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $dbc61fd5134a1e4f$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $dbc61fd5134a1e4f$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $dbc61fd5134a1e4f$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $dbc61fd5134a1e4f$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $dbc61fd5134a1e4f$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $dbc61fd5134a1e4f$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $dbc61fd5134a1e4f$var$defaults.strictNullHandling
    };
};
$dbc61fd5134a1e4f$exports = function(object, opts) {
    var obj = object;
    var options = $dbc61fd5134a1e4f$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($dbc61fd5134a1e4f$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $dbc61fd5134a1e4f$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $fd99ee91f5a6fc1f$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $dbc61fd5134a1e4f$var$pushToArray(keys, $dbc61fd5134a1e4f$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};


var $d57608c6af9419ff$exports = {};
'use strict';

var $d57608c6af9419ff$var$has = Object.prototype.hasOwnProperty;
var $d57608c6af9419ff$var$isArray = Array.isArray;
var $d57608c6af9419ff$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $70844ce8823e885e$exports.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $d57608c6af9419ff$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $d57608c6af9419ff$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $d57608c6af9419ff$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $d57608c6af9419ff$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $d57608c6af9419ff$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $d57608c6af9419ff$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $d57608c6af9419ff$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $d57608c6af9419ff$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $d57608c6af9419ff$var$defaults.decoder, charset, 'key');
            val = $70844ce8823e885e$exports.maybeMap($d57608c6af9419ff$var$parseArrayValue(part.slice(pos + 1), options, $d57608c6af9419ff$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $d57608c6af9419ff$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $d57608c6af9419ff$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $d57608c6af9419ff$var$isArray(val) ? [
            val
        ] : val;
        var existing = $d57608c6af9419ff$var$has.call(obj, key);
        if (existing && options.duplicates === 'combine') obj[key] = $70844ce8823e885e$exports.combine(obj[key], val);
        else if (!existing || options.duplicates === 'last') obj[key] = val;
    }
    return obj;
};
var $d57608c6af9419ff$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $d57608c6af9419ff$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $70844ce8823e885e$exports.combine([], leaf);
        else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $d57608c6af9419ff$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $d57608c6af9419ff$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $d57608c6af9419ff$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return $d57608c6af9419ff$var$parseObject(keys, val, options, valuesParsed);
};
var $d57608c6af9419ff$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $d57608c6af9419ff$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $d57608c6af9419ff$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $d57608c6af9419ff$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $d57608c6af9419ff$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $d57608c6af9419ff$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $d57608c6af9419ff$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $d57608c6af9419ff$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $d57608c6af9419ff$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $d57608c6af9419ff$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $d57608c6af9419ff$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $d57608c6af9419ff$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $d57608c6af9419ff$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $70844ce8823e885e$exports.isRegExp(opts.delimiter) ? opts.delimiter : $d57608c6af9419ff$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $d57608c6af9419ff$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $d57608c6af9419ff$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $d57608c6af9419ff$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $d57608c6af9419ff$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $d57608c6af9419ff$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $d57608c6af9419ff$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
$d57608c6af9419ff$exports = function(str, opts) {
    var options = $d57608c6af9419ff$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $d57608c6af9419ff$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $d57608c6af9419ff$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $70844ce8823e885e$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $70844ce8823e885e$exports.compact(obj);
};



$95ff1ffdf00be801$exports = {
    formats: $d29398e4df45acfb$exports,
    parse: $d57608c6af9419ff$exports,
    stringify: $dbc61fd5134a1e4f$exports
};


function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $95ff1ffdf00be801$exports.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $htTYG.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $95ff1ffdf00be801$exports.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $95ff1ffdf00be801$exports.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});

parcelRegister("htTYG", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("h1hUh", function(module, exports) {
"use strict";

});

parcelRegister("92atP", function(module, exports) {
'use strict';
var $693c6e131964618e$var$undefined1;
var $9441c5597f75fc7c$exports = {};
'use strict';
/** @type {import('.')} */ $9441c5597f75fc7c$exports = Error;


var $80e24f7b6f5b0579$exports = {};
'use strict';
/** @type {import('./eval')} */ $80e24f7b6f5b0579$exports = EvalError;


var $93d7eb58b6897ba8$exports = {};
'use strict';
/** @type {import('./range')} */ $93d7eb58b6897ba8$exports = RangeError;


var $64f7f2d32c938e9b$exports = {};
'use strict';
/** @type {import('./ref')} */ $64f7f2d32c938e9b$exports = ReferenceError;



var $f0OSc = parcelRequire("f0OSc");


var $bLmKG = parcelRequire("bLmKG");

var $d9cd2905ba41e81a$exports = {};
'use strict';
/** @type {import('./uri')} */ $d9cd2905ba41e81a$exports = URIError;


var $693c6e131964618e$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $693c6e131964618e$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $693c6e131964618e$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $693c6e131964618e$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($693c6e131964618e$var$$gOPD) try {
    $693c6e131964618e$var$$gOPD({}, '');
} catch (e) {
    $693c6e131964618e$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $693c6e131964618e$var$throwTypeError = function() {
    throw new $bLmKG();
};
var $693c6e131964618e$var$ThrowTypeError = $693c6e131964618e$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $693c6e131964618e$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $693c6e131964618e$var$$gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $693c6e131964618e$var$throwTypeError;
        }
    }
}() : $693c6e131964618e$var$throwTypeError;

var $693c6e131964618e$var$hasSymbols = (parcelRequire("hSWFN"))();

var $693c6e131964618e$var$hasProto = (parcelRequire("hN7qD"))();
var $693c6e131964618e$var$getProto = Object.getPrototypeOf || ($693c6e131964618e$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $693c6e131964618e$var$needsEval = {};
var $693c6e131964618e$var$TypedArray = typeof Uint8Array === 'undefined' || !$693c6e131964618e$var$getProto ? undefined : $693c6e131964618e$var$getProto(Uint8Array);
var $693c6e131964618e$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $693c6e131964618e$var$hasSymbols && $693c6e131964618e$var$getProto ? $693c6e131964618e$var$getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $693c6e131964618e$var$needsEval,
    '%AsyncGenerator%': $693c6e131964618e$var$needsEval,
    '%AsyncGeneratorFunction%': $693c6e131964618e$var$needsEval,
    '%AsyncIteratorPrototype%': $693c6e131964618e$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $9441c5597f75fc7c$exports,
    '%eval%': eval,
    '%EvalError%': $80e24f7b6f5b0579$exports,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $693c6e131964618e$var$$Function,
    '%GeneratorFunction%': $693c6e131964618e$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $693c6e131964618e$var$hasSymbols && $693c6e131964618e$var$getProto ? $693c6e131964618e$var$getProto($693c6e131964618e$var$getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$693c6e131964618e$var$hasSymbols || !$693c6e131964618e$var$getProto ? undefined : $693c6e131964618e$var$getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $93d7eb58b6897ba8$exports,
    '%ReferenceError%': $64f7f2d32c938e9b$exports,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$693c6e131964618e$var$hasSymbols || !$693c6e131964618e$var$getProto ? undefined : $693c6e131964618e$var$getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $693c6e131964618e$var$hasSymbols && $693c6e131964618e$var$getProto ? $693c6e131964618e$var$getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $693c6e131964618e$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $f0OSc,
    '%ThrowTypeError%': $693c6e131964618e$var$ThrowTypeError,
    '%TypedArray%': $693c6e131964618e$var$TypedArray,
    '%TypeError%': $bLmKG,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $d9cd2905ba41e81a$exports,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
if ($693c6e131964618e$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $693c6e131964618e$var$errorProto = $693c6e131964618e$var$getProto($693c6e131964618e$var$getProto(e));
    $693c6e131964618e$var$INTRINSICS['%Error.prototype%'] = $693c6e131964618e$var$errorProto;
}
var $693c6e131964618e$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $693c6e131964618e$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $693c6e131964618e$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $693c6e131964618e$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $693c6e131964618e$var$getProto) value = $693c6e131964618e$var$getProto(gen.prototype);
    }
    $693c6e131964618e$var$INTRINSICS[name] = value;
    return value;
};
var $693c6e131964618e$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $7WErB = parcelRequire("7WErB");

var $d2c29f460f4c2c1e$exports = {};
'use strict';
var $d2c29f460f4c2c1e$var$call = Function.prototype.call;
var $d2c29f460f4c2c1e$var$$hasOwn = Object.prototype.hasOwnProperty;



/** @type {import('.')} */ $d2c29f460f4c2c1e$exports = $7WErB.call($d2c29f460f4c2c1e$var$call, $d2c29f460f4c2c1e$var$$hasOwn);


var $693c6e131964618e$var$$concat = $7WErB.call(Function.call, Array.prototype.concat);
var $693c6e131964618e$var$$spliceApply = $7WErB.call(Function.apply, Array.prototype.splice);
var $693c6e131964618e$var$$replace = $7WErB.call(Function.call, String.prototype.replace);
var $693c6e131964618e$var$$strSlice = $7WErB.call(Function.call, String.prototype.slice);
var $693c6e131964618e$var$$exec = $7WErB.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $693c6e131964618e$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $693c6e131964618e$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $693c6e131964618e$var$stringToPath = function stringToPath(string) {
    var first = $693c6e131964618e$var$$strSlice(string, 0, 1);
    var last = $693c6e131964618e$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $f0OSc('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $f0OSc('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $693c6e131964618e$var$$replace(string, $693c6e131964618e$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $693c6e131964618e$var$$replace(subString, $693c6e131964618e$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $693c6e131964618e$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($d2c29f460f4c2c1e$exports($693c6e131964618e$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $693c6e131964618e$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($d2c29f460f4c2c1e$exports($693c6e131964618e$var$INTRINSICS, intrinsicName)) {
        var value = $693c6e131964618e$var$INTRINSICS[intrinsicName];
        if (value === $693c6e131964618e$var$needsEval) value = $693c6e131964618e$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $bLmKG('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $f0OSc('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $bLmKG('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $bLmKG('"allowMissing" argument must be a boolean');
    if ($693c6e131964618e$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $f0OSc('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $693c6e131964618e$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $693c6e131964618e$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $693c6e131964618e$var$$spliceApply(parts, $693c6e131964618e$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $693c6e131964618e$var$$strSlice(part, 0, 1);
        var last = $693c6e131964618e$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $f0OSc('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($d2c29f460f4c2c1e$exports($693c6e131964618e$var$INTRINSICS, intrinsicRealName)) value = $693c6e131964618e$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $bLmKG('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($693c6e131964618e$var$$gOPD && i + 1 >= parts.length) {
                var desc = $693c6e131964618e$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $d2c29f460f4c2c1e$exports(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $693c6e131964618e$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});

parcelRegister("hSWFN", function(module, exports) {
'use strict';
var $d054fe13a8ed72ef$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $23Da1 = parcelRequire("23Da1");

/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $d054fe13a8ed72ef$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $d054fe13a8ed72ef$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $23Da1();
};

});

parcelRegister("23Da1", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});

parcelRegister("hN7qD", function(module, exports) {
'use strict';
var $cf3cc66b711ee338$var$test = {
    __proto__: null,
    foo: {}
};
// @ts-expect-error: TS errors on an inherited property for some reason
var $cf3cc66b711ee338$var$result = {
    __proto__: $cf3cc66b711ee338$var$test
}.foo === $cf3cc66b711ee338$var$test.foo && !($cf3cc66b711ee338$var$test instanceof Object);
/** @type {import('.')} */ module.exports = function hasProto() {
    return $cf3cc66b711ee338$var$result;
};

});

parcelRegister("aahHV", function(module, exports) {
'use strict';

var $92atP = parcelRequire("92atP");


var $bVf2p = parcelRequire("bVf2p");

/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $766892e1d74d2707$var$$indexOf = $bVf2p([
    $92atP('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $92atP(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $766892e1d74d2707$var$$indexOf(name, '.prototype.') > -1) return $bVf2p(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});

parcelRegister("3XKuW", function(module, exports) {

var $eFNS0 = parcelRequire("eFNS0");

const $4186db0e7e18f734$export$cdb0163d35da79f3 = '__EP_REACT_PROPS_OBSERVABLE_OBJECT__';
module.exports["EP_REACT_PROPS_OBSERVABLE_OBJECT"] = $4186db0e7e18f734$export$cdb0163d35da79f3;

});

parcelRegister("eFNS0", function(module, exports) {
class $6be6b2d330604e6b$export$b176171395436676 {
    subscribe(fn) {
        this._observers.push(fn);
        return ()=>this.unsubscribe(fn);
    }
    unsubscribe(fn) {
        this._observers = this._observers.filter((observerFn)=>fn !== observerFn);
    }
    notify() {
        this._observers.forEach((observerFn)=>observerFn.call(this));
    }
    get object() {
        return this._object;
    }
    set object(value) {
        this._object = value;
        this.notify();
    }
    constructor(){
        this._observers = void 0;
        this._object = void 0;
        this._observers = [];
        this._object = null;
    }
}
module.exports["ObservableObject"] = $6be6b2d330604e6b$export$b176171395436676;

});

parcelRegister("diaaX", function(module, exports) {

var $dQl1W = parcelRequire("dQl1W");

const $53fc47f1270327a6$export$ab9998995666ebe3 = 'embedded-confluence-iframe';
const $53fc47f1270327a6$export$f2fe03976fe13de = ()=>{
    return `${$53fc47f1270327a6$export$ab9998995666ebe3}-${(0, $dQl1W.v4)()}`;
};
const $53fc47f1270327a6$export$45b0adb7f9689286 = 'passThroughProps';
const $53fc47f1270327a6$export$78cada8c8749e264 = 'propsUpdated';
const $53fc47f1270327a6$export$b75934a6b56fd9ba = 'experienceForwarding';
module.exports["CHANNEL_NAME"] = $53fc47f1270327a6$export$ab9998995666ebe3;
module.exports["createUniqueKey"] = $53fc47f1270327a6$export$f2fe03976fe13de;
module.exports["PASSTHROUGH_PROPS_MODULE_NAME"] = $53fc47f1270327a6$export$45b0adb7f9689286;
module.exports["PROPS_UPDATED"] = $53fc47f1270327a6$export$78cada8c8749e264;
module.exports["EXPERIENCE_FORWARDING_MODULE_NAME"] = $53fc47f1270327a6$export$b75934a6b56fd9ba;

});

parcelRegister("lJlG6", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $jiJCD = parcelRequire("jiJCD");

const $af6c27b029be1f92$export$acd98617fc81054b = [
    'mobileAppWithEditing'
];
const $af6c27b029be1f92$export$ac1a20a3ede9f67e = [
    ...$af6c27b029be1f92$export$acd98617fc81054b,
    'mobileAppWithCommenting'
];
const $af6c27b029be1f92$export$d79cba85ed29c923 = [
    ...$af6c27b029be1f92$export$ac1a20a3ede9f67e,
    'mobileApp'
];
const $af6c27b029be1f92$export$89472efb549ed81c = (param, validParams)=>{
    if (!param || !validParams) return false;
    if (Array.isArray(param)) return param.some((p)=>validParams.includes(p));
    return validParams.includes(param);
};
const $af6c27b029be1f92$export$b3e06e857f50f3ca = (location)=>{
    if (!(0, $6mKj3.expVal)('cc_mobile_query_param', 'isEnabled', false)) return false;
    if (!location) location = window.location;
    const { query: query } = (0, $jiJCD.parse)(location.search, true);
    return $af6c27b029be1f92$export$89472efb549ed81c(query.presentationMode, $af6c27b029be1f92$export$d79cba85ed29c923) || $af6c27b029be1f92$export$89472efb549ed81c(query.parentProduct, $af6c27b029be1f92$export$d79cba85ed29c923);
};
const $af6c27b029be1f92$export$e3b2195d2067d8c0 = (location)=>{
    if (!window.__CC_MOBILE_QUERY_PARAM_EXP__) return false;
    if (!location) location = window.location;
    const { query: query } = (0, $jiJCD.parse)(location.search, true);
    return $af6c27b029be1f92$export$89472efb549ed81c(query.presentationMode, $af6c27b029be1f92$export$d79cba85ed29c923) || $af6c27b029be1f92$export$89472efb549ed81c(query.parentProduct, $af6c27b029be1f92$export$d79cba85ed29c923);
};
module.exports["MOBILE_APP_WITH_EDITING_QUERY_PARAM_VALUES"] = $af6c27b029be1f92$export$acd98617fc81054b;
module.exports["MOBILE_APP_WITH_COMMENTING_QUERY_PARAM_VALUES"] = $af6c27b029be1f92$export$ac1a20a3ede9f67e;
module.exports["MOBILE_APP_QUERY_PARAM_VALUES"] = $af6c27b029be1f92$export$d79cba85ed29c923;
module.exports["checkForValidParam"] = $af6c27b029be1f92$export$89472efb549ed81c;
module.exports["isMobileApp_DO_NOT_USE"] = $af6c27b029be1f92$export$b3e06e857f50f3ca;
module.exports["isMobileApp_checkGateViaSSR_DO_NOT_USE"] = $af6c27b029be1f92$export$e3b2195d2067d8c0;

});

parcelRegister("6mKj3", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $g68Gk = parcelRequire("g68Gk");

const $86d6de4c9065cd14$var$DEFAULT_ENABLED_PARAM = 'isEnabled';
function $86d6de4c9065cd14$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
    const value = (0, $c6GJD.default).getExperimentValue(experimentName, param, defaultValue);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $g68Gk.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $86d6de4c9065cd14$export$da472ee01c19d92e(experimentName, param, defaultValue) {
    // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
    const value = (0, $c6GJD.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: false
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $g68Gk.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
const $86d6de4c9065cd14$export$94f132839aec533f = $86d6de4c9065cd14$export$da472ee01c19d92e;
function $86d6de4c9065cd14$export$45abdb3f977b5b14(experimentName, param, comparatorValue) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $86d6de4c9065cd14$export$9db1624a8af791a4(experimentName, param, null) === comparatorValue;
}
function $86d6de4c9065cd14$export$d9ae946a42fe8ba9(experimentName, param, comparatorValue) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $86d6de4c9065cd14$export$da472ee01c19d92e(experimentName, param, null) === comparatorValue;
}
const $86d6de4c9065cd14$export$63eebf86443a0a61 = $86d6de4c9065cd14$export$d9ae946a42fe8ba9;
function $86d6de4c9065cd14$export$d14de861476c5d7c(experimentName) {
    (0, $c6GJD.default).manuallyLogExperimentExposure(experimentName);
}
function $86d6de4c9065cd14$export$336b018592dc9972(experimentName) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $86d6de4c9065cd14$export$45abdb3f977b5b14(experimentName, $86d6de4c9065cd14$var$DEFAULT_ENABLED_PARAM, true);
}
function $86d6de4c9065cd14$export$9a4bf900b9ee892d(experimentName) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $86d6de4c9065cd14$export$d9ae946a42fe8ba9(experimentName, $86d6de4c9065cd14$var$DEFAULT_ENABLED_PARAM, true);
}
class $86d6de4c9065cd14$var$ExperimentConfig {
    get(key, defaultValue, typeGuard) {
        // Check if the CRITERION override mechanism is available
        if (window && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            const overrideValue = window.__CRITERION__.getExperimentValueOverride(this._experimentName, key);
            if (overrideValue !== undefined && overrideValue !== null) {
                (0, $g68Gk.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, overrideValue);
                return overrideValue;
            }
        }
        const value = this._config.get(key, defaultValue, typeGuard);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $g68Gk.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return value;
    }
    constructor(experimentName, config){
        this._experimentName = void 0;
        this._config = void 0;
        this._experimentName = experimentName;
        this._config = config;
    }
}
const $86d6de4c9065cd14$var$cache = new Map();
function $86d6de4c9065cd14$export$677f9fa2e1ae6fec(experimentName) {
    let instance = $86d6de4c9065cd14$var$cache.get(experimentName);
    if (instance == null) {
        const config = (0, $c6GJD.default).getExperiment(experimentName, {
            fireExperimentExposure: false
        });
        const fireExposure = ()=>(0, $c6GJD.default).manuallyLogExperimentExposure(experimentName);
        instance = [
            new $86d6de4c9065cd14$var$ExperimentConfig(experimentName, config),
            fireExposure
        ];
        $86d6de4c9065cd14$var$cache.set(experimentName, instance);
    }
    return instance;
}
module.exports["expVal"] = $86d6de4c9065cd14$export$9db1624a8af791a4;
module.exports["UNSAFE_expValNoExposure"] = $86d6de4c9065cd14$export$da472ee01c19d92e;
module.exports["expValEquals"] = $86d6de4c9065cd14$export$45abdb3f977b5b14;
module.exports["UNSAFE_expValEqualsNoExposure"] = $86d6de4c9065cd14$export$d9ae946a42fe8ba9;
module.exports["manuallyLogExpExposure"] = $86d6de4c9065cd14$export$d14de861476c5d7c;
module.exports["isExperimentEnabled"] = $86d6de4c9065cd14$export$336b018592dc9972;
module.exports["UNSAFE_noExposureExp"] = $86d6de4c9065cd14$export$677f9fa2e1ae6fec;

});

parcelRegister("58Z9z", function(module, exports) {
$parcel$export(module.exports, "parse", () => $3bed22dd94743c59$export$98e6a39c04603d36, (v) => $3bed22dd94743c59$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "encode", () => $3bed22dd94743c59$export$c564cdbbe6da493, (v) => $3bed22dd94743c59$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "stringify", () => $3bed22dd94743c59$export$fac44ee5b035f737, (v) => $3bed22dd94743c59$export$fac44ee5b035f737 = v);
var $3bed22dd94743c59$export$2f872c0f2117be69;
var $3bed22dd94743c59$export$98e6a39c04603d36;
var $3bed22dd94743c59$export$c564cdbbe6da493;
var $3bed22dd94743c59$export$fac44ee5b035f737;
'use strict';

$3bed22dd94743c59$export$2f872c0f2117be69 = $3bed22dd94743c59$export$98e6a39c04603d36 = (parcelRequire("dbCAo"));

$3bed22dd94743c59$export$c564cdbbe6da493 = $3bed22dd94743c59$export$fac44ee5b035f737 = (parcelRequire("hpqIY"));

});

parcelRegister("dbCAo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $999a3bd3fee24a2e$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$999a3bd3fee24a2e$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($999a3bd3fee24a2e$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $999a3bd3fee24a2e$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("hpqIY", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $cac980648615414d$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $cac980648615414d$var$map($cac980648615414d$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($cac980648615414d$var$stringifyPrimitive(k)) + eq;
        if ($cac980648615414d$var$isArray(obj[k])) return $cac980648615414d$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($cac980648615414d$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($cac980648615414d$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($cac980648615414d$var$stringifyPrimitive(name)) + eq + encodeURIComponent($cac980648615414d$var$stringifyPrimitive(obj));
};
var $cac980648615414d$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $cac980648615414d$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $cac980648615414d$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});

parcelRegister("9wGTI", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $g68Gk = parcelRequire("g68Gk");

const $1519d2098734f64b$export$b40ec24ac8275656 = (gateName)=>{
    // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
    const value = (0, $c6GJD.default).checkGate(gateName);
    (0, $g68Gk.addFeatureFlagAccessed)(gateName, value);
    return value;
};
module.exports["fg"] = $1519d2098734f64b$export$b40ec24ac8275656;

});

parcelRegister("uxMYQ", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});

parcelRegister("04e9M", function(module, exports) {
/**
 *  Data Services - Analytics Web Client for E-MAU
 *  url to the JIRA ticket (https://product-fabric.atlassian.net/browse/CFEA-16)
 *  source code (https://bitbucket.org/atlassian/analytics-web-client)
 */ 
var $6Co6F = parcelRequire("6Co6F");


var $T9xHm = parcelRequire("T9xHm");


var $cMvQV = parcelRequire("cMvQV");


var $hmRc4 = parcelRequire("hmRc4");


var $eSuZj = parcelRequire("eSuZj");


var $6X8o4 = parcelRequire("6X8o4");


var $8dwdz = parcelRequire("8dwdz");


var $9wGTI = parcelRequire("9wGTI");


var $f7B1p = parcelRequire("f7B1p");




const $fc053589e4468ba9$export$54fe7bbc3a8667b6 = `
  query isNewUserQuery {
    isNewUser
  }
`;


const $58c1a29bfb57901c$export$53cb6decc268273b = (attributes)=>{
    const URI = (0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint') ? '/gateway/api/graphql/slow' : window['GLOBAL_APOLLO_CLIENT_URI'] || '/cgraphql';
    (0, $f7B1p.cfetch)(`${URI}?q=isNewUserQuery`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'X-APOLLO-OPERATION-NAME': 'isNewUserQuery',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            operationName: 'isNewUserQuery',
            query: (0, $fc053589e4468ba9$export$54fe7bbc3a8667b6)
        })
    }).then(async (res)=>{
        if (res.ok) {
            const data = await res.json();
            const isNewUser = data?.data?.isNewUser || false;
            if (!!isNewUser) {
                (0, $f7B1p.cfetch)('/wiki/rest/onboarding/1/store', {
                    method: 'PUT',
                    body: JSON.stringify({
                        key: 'onboarding-origin-state:attributes',
                        value: JSON.stringify(attributes)
                    }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                window.dispatchEvent(new Event('onboardingAttributesUpdated'));
            }
        }
    });
};


// Must call this before any browser-helper functions, to ensure user agent has been set first
(0, $cMvQV.setUserAgent)();
let $395aeb7a9cfb70e5$var$provideClient;
const $395aeb7a9cfb70e5$var$analyticsWebClientPromise = (0, $6X8o4.liftPromiseState)(new Promise((resolve)=>{
    $395aeb7a9cfb70e5$var$provideClient = resolve;
}));
let $395aeb7a9cfb70e5$var$provideDwellTimeHelper;
const $395aeb7a9cfb70e5$var$dwellTimeHelperPromise = (0, $6X8o4.liftPromiseState)(new Promise((resolve)=>{
    $395aeb7a9cfb70e5$var$provideDwellTimeHelper = resolve;
}));
const $395aeb7a9cfb70e5$var$GAS_V3_ROUTE = 'gateway/api/gasv3/api/v1';
const $395aeb7a9cfb70e5$export$45a69314cf48a3eb = ({ envType: envType, originType: originType, environment: environment, platformType: platformType, locale: locale, product: product, subproduct: subproduct })=>{
    const env = // In dev, proxying to a site will give that site's environment,
    // which is not what we want
    window.location.hostname === 'localhost' ? envType.DEV : environment === 'STAGING' ? envType.STAGING : environment === 'PRODUCTION' ? envType.PROD : envType.DEV;
    return {
        env: env,
        product: product || 'confluence',
        ...subproduct ? {
            subproduct: subproduct
        } : undefined,
        version: (0, $eSuZj.getBuildInfo)().FRONTEND_VERSION,
        origin: originType.WEB,
        platform: (0, $8dwdz.shouldShowMobileWeb)() ? platformType.MOBILE_WEB : platformType.WEB,
        locale: locale,
        ...(0, $T9xHm.isIsolatedCloud)() && {
            ic: (0, $T9xHm.isolationContextId)()
        }
    };
};
const $395aeb7a9cfb70e5$export$cac1fa7ce63519ac = (cloudId, activationId)=>`ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
let $395aeb7a9cfb70e5$var$updateAmplitudeSRSession;
let $395aeb7a9cfb70e5$var$amplitudeAttributesInjector;
const $395aeb7a9cfb70e5$var$wrapSendMethod = (originalMethod)=>{
    return function(payload, ...args) {
        // Inject amplitude attributes if injector exists
        if ($395aeb7a9cfb70e5$var$amplitudeAttributesInjector && payload) $395aeb7a9cfb70e5$var$amplitudeAttributesInjector(payload);
        // Call original method
        return originalMethod.call(this, payload, ...args);
    };
};




const $395aeb7a9cfb70e5$export$7d842b959fcdcd03 = ({ cloudId: cloudId, userId: userId, environment: environment, product: product, subproduct: subproduct, locale: locale, activationId: activationId, eventFilterOptions: eventFilterOptions = {
    shouldFilterEvents: false,
    eventMatchers: []
}, callback: callback })=>{
    let config;
    Promise.all([
        (parcelRequire("kl90G")),
        (parcelRequire("gAHXO")),
        // This is needed for @atlassiansox/origin-tracing to work in old versions of Edge (<=16).
        // Origin Tracing needs URLSearchParams, but the API is missing from old Edge,
        // and old Edge is not served the ES5/polyfills bundle.
        typeof URLSearchParams === 'undefined' ? (parcelRequire("d8fmB")) : Promise.resolve()
    ]).then(async ([analyticsWebClientModule, { buildCompressionFunction: buildCompressionFunction, canCompress: canCompress }])=>{
        const { default: AnalyticsWebClient, originType: originType, tenantType: tenantType, userType: userType, envType: envType, platformType: platformType, DwellTimeHelper: DwellTimeHelper, CompressionRule: CompressionRule } = analyticsWebClientModule;
        config = $395aeb7a9cfb70e5$export$45a69314cf48a3eb({
            envType: envType,
            originType: originType,
            environment: environment,
            platformType: platformType,
            locale: locale,
            product: product,
            subproduct: subproduct
        });
        let analyticsWebClient;
        // COMMENTS-195 - Send an operational event when a session starts
        const handleSessionStarted = ()=>{
            analyticsWebClient && analyticsWebClient.sendOperationalEvent({
                action: 'started',
                actionSubject: 'session',
                source: 'webClient'
            });
            if ((0, $9wGTI.fg)('cc_engagement_amplitude_session_replay')) $395aeb7a9cfb70e5$var$updateAmplitudeSRSession && $395aeb7a9cfb70e5$var$updateAmplitudeSRSession(analyticsWebClient);
        };
        $395aeb7a9cfb70e5$var$provideDwellTimeHelper(DwellTimeHelper);
        const browserHistory = (0, $hmRc4.getBrowserHistory)();
        const settings = {
            historyReplaceFn: (url)=>{
                const { pathname: pathname, search: search, hash: hash } = new URL(url);
                // Warning: can't pass an instance of URL here as it will erase query params and hash
                // Caused: https://product-fabric.atlassian.net/browse/WS-2317
                browserHistory.replace({
                    pathname: pathname,
                    search: search,
                    hash: hash
                });
            },
            delayQueueCompressors: [
                new CompressionRule(canCompress, buildCompressionFunction())
            ],
            onNewSessionStarted: handleSessionStarted,
            apiHostProtocol: window.location.hostname === 'localhost' ? 'http' : 'https',
            ...(0, $T9xHm.isIsolatedCloud)() && {
                apiHost: `${window.location.hostname}/${$395aeb7a9cfb70e5$var$GAS_V3_ROUTE}`
            },
            disableCookiePersistence: true
        };
        const { shouldFilterEvents: shouldFilterEvents, eventMatchers: eventMatchers } = eventFilterOptions;
        // We suppress analytics events if we're within the mobile app so that we don't
        // end up firing overlapping events from the native and web code
        if (shouldFilterEvents || (0, $cMvQV.isNativeMobile)()) {
            /**
       * Don't use Stargate if we're filtering events.
       * According to the analytics-web-client package source code at https://bitbucket.org/atlassian/analytics-web-client/src/bf3bd861ee8d08759e0e79830fcb1d69156db1a5/src/analyticsWebClient.js?at=master#lines-208
       * By default, useStargate is true. On a production instance, even if we set the env to "staging" or "dev", this event will land to the huge production Redash Socrates table, such as cloud.event_operational.
       * For the purpose of preproduction performance detection, we need the analytics event to send to staging table, such as raw_dlf_stg.event_operational.
       * The staging table has much less data, so we can run data transformation job hourly, and query more real-time data. Production table is huge, so we can only run data transformation job daily.
       */ const useStargate = !shouldFilterEvents;
            const { createFilteredAWC: createFilteredAWC } = await (parcelRequire("5cVJq"));
            analyticsWebClient = createFilteredAWC(analyticsWebClientModule, config, {
                ...settings,
                useStargate: useStargate
            }, eventMatchers);
        } else analyticsWebClient = new AnalyticsWebClient(config, settings);
        analyticsWebClient.setTenantInfo(tenantType.CLOUD_ID, cloudId);
        if ((0, $9wGTI.fg)('cc_engagement_amplitude_session_replay')) {
            analyticsWebClient.setUpdateAmplitudeSRSession = (callback)=>{
                $395aeb7a9cfb70e5$var$updateAmplitudeSRSession = callback || undefined;
            };
            analyticsWebClient.setAmplitudeAttributesInjector = (injector)=>{
                $395aeb7a9cfb70e5$var$amplitudeAttributesInjector = injector || undefined;
            };
            analyticsWebClient.sendScreenEvent = $395aeb7a9cfb70e5$var$wrapSendMethod(analyticsWebClient.sendScreenEvent);
            analyticsWebClient.sendUIEvent = $395aeb7a9cfb70e5$var$wrapSendMethod(analyticsWebClient.sendUIEvent);
        }
        if (activationId) {
            const workspaceId = $395aeb7a9cfb70e5$export$cac1fa7ce63519ac(cloudId, activationId);
            analyticsWebClient.setWorkspaceInfo(workspaceId);
        }
        // userId is null when the user is anonymous. In that scenario we don't
        // want to set any account ID on the analytics client.
        if (userId) analyticsWebClient.setUserInfo(userType.ATLASSIAN_ACCOUNT, userId);
        analyticsWebClient.setOriginTracingHandlers({
            atlOrigin: (encodedOrigin)=>{
                const origin = (0, $6Co6F.default).fromEncoded(encodedOrigin);
                const attributes = origin.toAnalyticsAttributes();
                if (userId) (0, $58c1a29bfb57901c$export$53cb6decc268273b)(attributes);
                return {
                    originTracingAttributes: {
                        id: attributes.originId,
                        product: attributes.originProduct,
                        library: attributes.originLibrary
                    },
                    taskSessionId: origin.id
                };
            }
        });
        if (product === 'embeddedConfluence') {
            const href = window?.location?.href;
            if (href) {
                const url = new URL(href);
                const embeddedConfluenceSource = url.searchParams.get('embeddedConfluenceSource');
                analyticsWebClient.setUIViewedAttributes({
                    embeddedConfluenceSource: embeddedConfluenceSource || 'unknown'
                });
            }
        }
        analyticsWebClient.startUIViewedEvent();
        $395aeb7a9cfb70e5$var$provideClient(analyticsWebClient);
        callback && callback();
    }).catch((error)=>{
        throw new Error(`Analytics Web Client ${error}, ${JSON.stringify({
            ...config
        })}`);
    });
};
const $395aeb7a9cfb70e5$export$e9ba7ef9458d1a4a = ()=>$395aeb7a9cfb70e5$var$analyticsWebClientPromise;
const $395aeb7a9cfb70e5$export$68106415736c5577 = ()=>$395aeb7a9cfb70e5$var$dwellTimeHelperPromise;
module.exports["getWorkspaceId"] = $395aeb7a9cfb70e5$export$cac1fa7ce63519ac;
module.exports["initializeAnalyticsClient"] = $395aeb7a9cfb70e5$export$7d842b959fcdcd03;
module.exports["getAnalyticsWebClient"] = $395aeb7a9cfb70e5$export$e9ba7ef9458d1a4a;
module.exports["getDwellTimeHelper"] = $395aeb7a9cfb70e5$export$68106415736c5577;

});

parcelRegister("6Co6F", function(module, exports) {
// import uuid from 'uuid/v4';

var $dQl1W = parcelRequire("dQl1W");

/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ function $13a72d3092eaa770$export$3b91e21dac1023c6(base64) {
    if (base64 == null) return '';
    return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function $13a72d3092eaa770$export$47c5265a25535d02(base64url) {
    if (base64url == null) return '';
    const base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - base64url.length % 4) % 4;
    const pad = '==='.slice(0, padLength);
    return base64 + pad;
}



var $iA9co = parcelRequire("iA9co");


const $3ca81fa3e85f1ccb$export$d3cd91e0fdbfdbc0 = ()=>({
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === 'function' && atob.bind(undefined) || typeof (0, $iA9co.Buffer) !== 'undefined' && ((encoded)=>(0, $iA9co.Buffer).from(encoded, 'base64').toString()),
        btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, $iA9co.Buffer) !== 'undefined' && ((str)=>(0, $iA9co.Buffer).from(str).toString('base64')),
        URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || (0, (parcelRequire("6CWAz")).URLSearchParams)
    });
let $3ca81fa3e85f1ccb$var$env;
const $3ca81fa3e85f1ccb$export$4bd44a2aa29d3d6e = ()=>$3ca81fa3e85f1ccb$var$env || ($3ca81fa3e85f1ccb$var$env = $3ca81fa3e85f1ccb$var$validateEnv($3ca81fa3e85f1ccb$export$d3cd91e0fdbfdbc0()));
const $3ca81fa3e85f1ccb$var$validateEnv = (env)=>{
    if (!(env.atob && env.btoa && env.URLSearchParams)) throw new TypeError(`Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).`);
    return env;
};


const $60c4e943508abf9b$var$productShorthands = {
    confluence: 'c',
    jira: 'j',
    stride: 's',
    bitbucket: 'b',
    trello: 't'
};
function $60c4e943508abf9b$export$c564cdbbe6da493(originData) {
    const json = JSON.stringify($60c4e943508abf9b$export$4bc4b533a565aabe(originData));
    const base64 = (0, $3ca81fa3e85f1ccb$export$4bd44a2aa29d3d6e)().btoa(json);
    return (0, $13a72d3092eaa770$export$3b91e21dac1023c6)(base64);
}
function $60c4e943508abf9b$export$2f872c0f2117be69(encodedOriginString) {
    const base64 = (0, $13a72d3092eaa770$export$47c5265a25535d02)(encodedOriginString);
    const json = (0, $3ca81fa3e85f1ccb$export$4bd44a2aa29d3d6e)().atob(base64);
    return $60c4e943508abf9b$export$46d5cda6b884b7ab(JSON.parse(json));
}
function $60c4e943508abf9b$export$4bc4b533a565aabe({ id: id, product: product }) {
    return {
        i: id,
        p: product && product in $60c4e943508abf9b$var$productShorthands ? $60c4e943508abf9b$var$productShorthands[product] : product
    };
}
function $60c4e943508abf9b$export$46d5cda6b884b7ab(originJSONObject) {
    const originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = $60c4e943508abf9b$var$expandProductShorthand(originJSONObject.p);
    return originData;
}
function $60c4e943508abf9b$var$expandProductShorthand(maybeShorthand) {
    const products = Object.keys($60c4e943508abf9b$var$productShorthands);
    for(let i = 0; i < products.length; i++){
        const product = products[i];
        const shorthand = $60c4e943508abf9b$var$productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}



const $29c1a49acaf4d5a1$var$packageVersion = "0.0.0-use.local";
const $29c1a49acaf4d5a1$var$originParamName = 'atlOrigin';
const $29c1a49acaf4d5a1$var$originVersioningAttributes = {
    originLibrary: `origin-tracing.js@${$29c1a49acaf4d5a1$var$packageVersion}`
};
class $29c1a49acaf4d5a1$export$2e2bcd8739ae039 {
    static isValidId(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
    }
    static isValidProduct(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
    }
    static generateId() {
        const id = (0, $dQl1W.v4)();
        // Dash positions are fixed so they don't add to uniqueness.
        // Remove them to save space in the encoded form.
        return id.replace(/-/g, '');
    }
    static createEmpty() {
        return new $29c1a49acaf4d5a1$var$EmptyOriginTracer();
    }
    static createMalformed() {
        return new $29c1a49acaf4d5a1$var$MalformedOriginTracer();
    }
    static fromUrl(url) {
        let params = new ((0, $3ca81fa3e85f1ccb$export$4bd44a2aa29d3d6e)()).URLSearchParams();
        $29c1a49acaf4d5a1$var$replaceQuery(url, (queryString)=>{
            params = new ((0, $3ca81fa3e85f1ccb$export$4bd44a2aa29d3d6e)()).URLSearchParams(queryString);
        });
        return $29c1a49acaf4d5a1$export$2e2bcd8739ae039.fromEncoded(params.get($29c1a49acaf4d5a1$var$originParamName));
    }
    static fromEncoded(encoded) {
        if (!encoded) return $29c1a49acaf4d5a1$export$2e2bcd8739ae039.createEmpty();
        try {
            return $29c1a49acaf4d5a1$export$2e2bcd8739ae039.decode(encoded);
        } catch (e) {
            return $29c1a49acaf4d5a1$export$2e2bcd8739ae039.createMalformed();
        }
    }
    static removeFromUrl(url) {
        return $29c1a49acaf4d5a1$var$replaceQuery(url, (queryString)=>{
            const params = new ((0, $3ca81fa3e85f1ccb$export$4bd44a2aa29d3d6e)()).URLSearchParams(queryString);
            params.delete($29c1a49acaf4d5a1$var$originParamName);
            return params.toString();
        });
    }
    static decode(encodedOrigin) {
        const originData = (0, $60c4e943508abf9b$export$2f872c0f2117be69)(encodedOrigin);
        return new $29c1a49acaf4d5a1$export$2e2bcd8739ae039(originData);
    }
    encode() {
        return (0, $60c4e943508abf9b$export$c564cdbbe6da493)({
            id: this.id,
            product: this.product
        });
    }
    addToUrl(url) {
        return $29c1a49acaf4d5a1$var$replaceQuery(url, (originalQueryString)=>{
            const params = new ((0, $3ca81fa3e85f1ccb$export$4bd44a2aa29d3d6e)()).URLSearchParams(originalQueryString);
            params.set($29c1a49acaf4d5a1$var$originParamName, this.encode());
            return params.toString();
        });
    }
    isEmpty() {
        return false;
    }
    isMalformed() {
        return !this.isEmpty() && !this.isValid();
    }
    isValid() {
        return true;
    }
    toAnalyticsAttributes({ transformValue: transformValue = (v)=>v === null ? undefined : v, hasGeneratedId: hasGeneratedId = false } = {}) {
        // `originIdGenerated` should be used in analytic events that generated this originId.
        // Subsequent events should use `originId`.
        // No two events should have the same value of originIdGenerated.
        const originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
        return {
            [originIdProp]: transformValue(this.id),
            originProduct: transformValue(this.product),
            ...$29c1a49acaf4d5a1$var$originVersioningAttributes
        };
    }
    validate() {
        if (!$29c1a49acaf4d5a1$export$2e2bcd8739ae039.isValidId(this.id)) throw new TypeError('Invalid Origin id');
        if (!$29c1a49acaf4d5a1$export$2e2bcd8739ae039.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
    }
    constructor({ id: id = $29c1a49acaf4d5a1$export$2e2bcd8739ae039.generateId(), product: product, dangerouslySkipValidation: dangerouslySkipValidation = false }){
        this.id = void 0;
        this.product = void 0;
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
}
class $29c1a49acaf4d5a1$var$EmptyOriginTracer extends $29c1a49acaf4d5a1$export$2e2bcd8739ae039 {
    isValid() {
        return false;
    }
    isEmpty() {
        return true;
    }
    toAnalyticsAttributes() {
        return {
            ...$29c1a49acaf4d5a1$var$originVersioningAttributes
        };
    }
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
}
class $29c1a49acaf4d5a1$var$MalformedOriginTracer extends $29c1a49acaf4d5a1$export$2e2bcd8739ae039 {
    isValid() {
        return false;
    }
    isEmpty() {
        return false;
    }
    toAnalyticsAttributes() {
        return {
            originMalformed: true,
            ...$29c1a49acaf4d5a1$var$originVersioningAttributes
        };
    }
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
}
function $29c1a49acaf4d5a1$var$replaceQuery(url, replacer) {
    const urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    const urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, (_wholeMatch, beforeQuery, queryString, afterQuery)=>{
        let newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = `?${newQueryString}`;
        return `${beforeQuery}${newQueryString}${afterQuery}`;
    });
}
module.exports["default"] = $29c1a49acaf4d5a1$export$2e2bcd8739ae039;

});

parcelRegister("iA9co", function(module, exports) {
$parcel$export(module.exports, "Buffer", () => $d872b97f91b2bb97$export$a143d493d941bafc, (v) => $d872b97f91b2bb97$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $d872b97f91b2bb97$export$e4cf37d7f6fb9e0a, (v) => $d872b97f91b2bb97$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $d872b97f91b2bb97$export$f99ded8fe4b79145, (v) => $d872b97f91b2bb97$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $d872b97f91b2bb97$export$599f31c3813fae4d, (v) => $d872b97f91b2bb97$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d872b97f91b2bb97$export$a143d493d941bafc;
var $d872b97f91b2bb97$export$e4cf37d7f6fb9e0a;
var $d872b97f91b2bb97$export$f99ded8fe4b79145;
var $d872b97f91b2bb97$export$599f31c3813fae4d;
'use strict';
var $ac5287e820454e69$export$a48f0734ac7c2329;
var $ac5287e820454e69$export$d622b2ad8d90c771;
var $ac5287e820454e69$export$6100ba28696e12de;
'use strict';
$ac5287e820454e69$export$a48f0734ac7c2329 = $ac5287e820454e69$var$byteLength;
$ac5287e820454e69$export$d622b2ad8d90c771 = $ac5287e820454e69$var$toByteArray;
$ac5287e820454e69$export$6100ba28696e12de = $ac5287e820454e69$var$fromByteArray;
var $ac5287e820454e69$var$lookup = [];
var $ac5287e820454e69$var$revLookup = [];
var $ac5287e820454e69$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $ac5287e820454e69$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $ac5287e820454e69$var$i = 0, $ac5287e820454e69$var$len = $ac5287e820454e69$var$code.length; $ac5287e820454e69$var$i < $ac5287e820454e69$var$len; ++$ac5287e820454e69$var$i){
    $ac5287e820454e69$var$lookup[$ac5287e820454e69$var$i] = $ac5287e820454e69$var$code[$ac5287e820454e69$var$i];
    $ac5287e820454e69$var$revLookup[$ac5287e820454e69$var$code.charCodeAt($ac5287e820454e69$var$i)] = $ac5287e820454e69$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$ac5287e820454e69$var$revLookup['-'.charCodeAt(0)] = 62;
$ac5287e820454e69$var$revLookup['_'.charCodeAt(0)] = 63;
function $ac5287e820454e69$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $ac5287e820454e69$var$byteLength(b64) {
    var lens = $ac5287e820454e69$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ac5287e820454e69$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ac5287e820454e69$var$toByteArray(b64) {
    var tmp;
    var lens = $ac5287e820454e69$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $ac5287e820454e69$var$Arr($ac5287e820454e69$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $ac5287e820454e69$var$revLookup[b64.charCodeAt(i)] << 18 | $ac5287e820454e69$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $ac5287e820454e69$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $ac5287e820454e69$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $ac5287e820454e69$var$revLookup[b64.charCodeAt(i)] << 2 | $ac5287e820454e69$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $ac5287e820454e69$var$revLookup[b64.charCodeAt(i)] << 10 | $ac5287e820454e69$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $ac5287e820454e69$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $ac5287e820454e69$var$tripletToBase64(num) {
    return $ac5287e820454e69$var$lookup[num >> 18 & 0x3F] + $ac5287e820454e69$var$lookup[num >> 12 & 0x3F] + $ac5287e820454e69$var$lookup[num >> 6 & 0x3F] + $ac5287e820454e69$var$lookup[num & 0x3F];
}
function $ac5287e820454e69$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($ac5287e820454e69$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $ac5287e820454e69$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($ac5287e820454e69$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($ac5287e820454e69$var$lookup[tmp >> 2] + $ac5287e820454e69$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($ac5287e820454e69$var$lookup[tmp >> 10] + $ac5287e820454e69$var$lookup[tmp >> 4 & 0x3F] + $ac5287e820454e69$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $dc954e3b093cc48d$export$aafa59e2e03f2942;
var $dc954e3b093cc48d$export$68d8715fc104d294;
$dc954e3b093cc48d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$dc954e3b093cc48d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $d872b97f91b2bb97$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d872b97f91b2bb97$export$a143d493d941bafc = $d872b97f91b2bb97$var$Buffer;
$d872b97f91b2bb97$export$e4cf37d7f6fb9e0a = $d872b97f91b2bb97$var$SlowBuffer;
$d872b97f91b2bb97$export$f99ded8fe4b79145 = 50;
const $d872b97f91b2bb97$var$K_MAX_LENGTH = 0x7fffffff;
$d872b97f91b2bb97$export$599f31c3813fae4d = $d872b97f91b2bb97$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d872b97f91b2bb97$var$Buffer.TYPED_ARRAY_SUPPORT = $d872b97f91b2bb97$var$typedArraySupport();
if (!$d872b97f91b2bb97$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d872b97f91b2bb97$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d872b97f91b2bb97$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$d872b97f91b2bb97$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d872b97f91b2bb97$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$d872b97f91b2bb97$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d872b97f91b2bb97$var$createBuffer(length) {
    if (length > $d872b97f91b2bb97$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d872b97f91b2bb97$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d872b97f91b2bb97$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d872b97f91b2bb97$var$allocUnsafe(arg);
    }
    return $d872b97f91b2bb97$var$from(arg, encodingOrOffset, length);
}
$d872b97f91b2bb97$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d872b97f91b2bb97$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d872b97f91b2bb97$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d872b97f91b2bb97$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d872b97f91b2bb97$var$isInstance(value, ArrayBuffer) || value && $d872b97f91b2bb97$var$isInstance(value.buffer, ArrayBuffer)) return $d872b97f91b2bb97$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d872b97f91b2bb97$var$isInstance(value, SharedArrayBuffer) || value && $d872b97f91b2bb97$var$isInstance(value.buffer, SharedArrayBuffer))) return $d872b97f91b2bb97$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d872b97f91b2bb97$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $d872b97f91b2bb97$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d872b97f91b2bb97$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d872b97f91b2bb97$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d872b97f91b2bb97$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d872b97f91b2bb97$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d872b97f91b2bb97$var$Buffer, Uint8Array);
function $d872b97f91b2bb97$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d872b97f91b2bb97$var$alloc(size, fill, encoding) {
    $d872b97f91b2bb97$var$assertSize(size);
    if (size <= 0) return $d872b97f91b2bb97$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d872b97f91b2bb97$var$createBuffer(size).fill(fill, encoding) : $d872b97f91b2bb97$var$createBuffer(size).fill(fill);
    return $d872b97f91b2bb97$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d872b97f91b2bb97$var$Buffer.alloc = function(size, fill, encoding) {
    return $d872b97f91b2bb97$var$alloc(size, fill, encoding);
};
function $d872b97f91b2bb97$var$allocUnsafe(size) {
    $d872b97f91b2bb97$var$assertSize(size);
    return $d872b97f91b2bb97$var$createBuffer(size < 0 ? 0 : $d872b97f91b2bb97$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d872b97f91b2bb97$var$Buffer.allocUnsafe = function(size) {
    return $d872b97f91b2bb97$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d872b97f91b2bb97$var$Buffer.allocUnsafeSlow = function(size) {
    return $d872b97f91b2bb97$var$allocUnsafe(size);
};
function $d872b97f91b2bb97$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d872b97f91b2bb97$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $d872b97f91b2bb97$var$byteLength(string, encoding) | 0;
    let buf = $d872b97f91b2bb97$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d872b97f91b2bb97$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $d872b97f91b2bb97$var$checked(array.length) | 0;
    const buf = $d872b97f91b2bb97$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d872b97f91b2bb97$var$fromArrayView(arrayView) {
    if ($d872b97f91b2bb97$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $d872b97f91b2bb97$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d872b97f91b2bb97$var$fromArrayLike(arrayView);
}
function $d872b97f91b2bb97$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d872b97f91b2bb97$var$Buffer.prototype);
    return buf;
}
function $d872b97f91b2bb97$var$fromObject(obj) {
    if ($d872b97f91b2bb97$var$Buffer.isBuffer(obj)) {
        const len = $d872b97f91b2bb97$var$checked(obj.length) | 0;
        const buf = $d872b97f91b2bb97$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d872b97f91b2bb97$var$numberIsNaN(obj.length)) return $d872b97f91b2bb97$var$createBuffer(0);
        return $d872b97f91b2bb97$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d872b97f91b2bb97$var$fromArrayLike(obj.data);
}
function $d872b97f91b2bb97$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d872b97f91b2bb97$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d872b97f91b2bb97$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d872b97f91b2bb97$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d872b97f91b2bb97$var$Buffer.alloc(+length);
}
$d872b97f91b2bb97$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d872b97f91b2bb97$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d872b97f91b2bb97$var$Buffer.compare = function compare(a, b) {
    if ($d872b97f91b2bb97$var$isInstance(a, Uint8Array)) a = $d872b97f91b2bb97$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d872b97f91b2bb97$var$isInstance(b, Uint8Array)) b = $d872b97f91b2bb97$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d872b97f91b2bb97$var$Buffer.isBuffer(a) || !$d872b97f91b2bb97$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d872b97f91b2bb97$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d872b97f91b2bb97$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d872b97f91b2bb97$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $d872b97f91b2bb97$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($d872b97f91b2bb97$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d872b97f91b2bb97$var$Buffer.isBuffer(buf)) buf = $d872b97f91b2bb97$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d872b97f91b2bb97$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d872b97f91b2bb97$var$byteLength(string, encoding) {
    if ($d872b97f91b2bb97$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d872b97f91b2bb97$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d872b97f91b2bb97$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d872b97f91b2bb97$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d872b97f91b2bb97$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d872b97f91b2bb97$var$Buffer.byteLength = $d872b97f91b2bb97$var$byteLength;
function $d872b97f91b2bb97$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d872b97f91b2bb97$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d872b97f91b2bb97$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d872b97f91b2bb97$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d872b97f91b2bb97$var$latin1Slice(this, start, end);
        case 'base64':
            return $d872b97f91b2bb97$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d872b97f91b2bb97$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d872b97f91b2bb97$var$Buffer.prototype._isBuffer = true;
function $d872b97f91b2bb97$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d872b97f91b2bb97$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$d872b97f91b2bb97$var$swap(this, i, i + 1);
    return this;
};
$d872b97f91b2bb97$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $d872b97f91b2bb97$var$swap(this, i, i + 3);
        $d872b97f91b2bb97$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d872b97f91b2bb97$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $d872b97f91b2bb97$var$swap(this, i, i + 7);
        $d872b97f91b2bb97$var$swap(this, i + 1, i + 6);
        $d872b97f91b2bb97$var$swap(this, i + 2, i + 5);
        $d872b97f91b2bb97$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d872b97f91b2bb97$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d872b97f91b2bb97$var$utf8Slice(this, 0, length);
    return $d872b97f91b2bb97$var$slowToString.apply(this, arguments);
};
$d872b97f91b2bb97$var$Buffer.prototype.toLocaleString = $d872b97f91b2bb97$var$Buffer.prototype.toString;
$d872b97f91b2bb97$var$Buffer.prototype.equals = function equals(b) {
    if (!$d872b97f91b2bb97$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d872b97f91b2bb97$var$Buffer.compare(this, b) === 0;
};
$d872b97f91b2bb97$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $d872b97f91b2bb97$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d872b97f91b2bb97$var$customInspectSymbol) $d872b97f91b2bb97$var$Buffer.prototype[$d872b97f91b2bb97$var$customInspectSymbol] = $d872b97f91b2bb97$var$Buffer.prototype.inspect;
$d872b97f91b2bb97$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d872b97f91b2bb97$var$isInstance(target, Uint8Array)) target = $d872b97f91b2bb97$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d872b97f91b2bb97$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d872b97f91b2bb97$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d872b97f91b2bb97$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d872b97f91b2bb97$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d872b97f91b2bb97$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d872b97f91b2bb97$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d872b97f91b2bb97$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d872b97f91b2bb97$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d872b97f91b2bb97$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d872b97f91b2bb97$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d872b97f91b2bb97$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d872b97f91b2bb97$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d872b97f91b2bb97$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d872b97f91b2bb97$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d872b97f91b2bb97$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d872b97f91b2bb97$var$utf8Write(buf, string, offset, length) {
    return $d872b97f91b2bb97$var$blitBuffer($d872b97f91b2bb97$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d872b97f91b2bb97$var$asciiWrite(buf, string, offset, length) {
    return $d872b97f91b2bb97$var$blitBuffer($d872b97f91b2bb97$var$asciiToBytes(string), buf, offset, length);
}
function $d872b97f91b2bb97$var$base64Write(buf, string, offset, length) {
    return $d872b97f91b2bb97$var$blitBuffer($d872b97f91b2bb97$var$base64ToBytes(string), buf, offset, length);
}
function $d872b97f91b2bb97$var$ucs2Write(buf, string, offset, length) {
    return $d872b97f91b2bb97$var$blitBuffer($d872b97f91b2bb97$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d872b97f91b2bb97$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d872b97f91b2bb97$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d872b97f91b2bb97$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d872b97f91b2bb97$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d872b97f91b2bb97$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d872b97f91b2bb97$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d872b97f91b2bb97$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d872b97f91b2bb97$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $ac5287e820454e69$export$6100ba28696e12de(buf);
    else return $ac5287e820454e69$export$6100ba28696e12de(buf.slice(start, end));
}
function $d872b97f91b2bb97$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d872b97f91b2bb97$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $d872b97f91b2bb97$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d872b97f91b2bb97$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $d872b97f91b2bb97$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d872b97f91b2bb97$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d872b97f91b2bb97$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d872b97f91b2bb97$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d872b97f91b2bb97$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $d872b97f91b2bb97$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d872b97f91b2bb97$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d872b97f91b2bb97$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d872b97f91b2bb97$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d872b97f91b2bb97$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d872b97f91b2bb97$var$Buffer.prototype.readUintLE = $d872b97f91b2bb97$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d872b97f91b2bb97$var$Buffer.prototype.readUintBE = $d872b97f91b2bb97$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d872b97f91b2bb97$var$Buffer.prototype.readUint8 = $d872b97f91b2bb97$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d872b97f91b2bb97$var$Buffer.prototype.readUint16LE = $d872b97f91b2bb97$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d872b97f91b2bb97$var$Buffer.prototype.readUint16BE = $d872b97f91b2bb97$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d872b97f91b2bb97$var$Buffer.prototype.readUint32LE = $d872b97f91b2bb97$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d872b97f91b2bb97$var$Buffer.prototype.readUint32BE = $d872b97f91b2bb97$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d872b97f91b2bb97$var$Buffer.prototype.readBigUInt64LE = $d872b97f91b2bb97$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d872b97f91b2bb97$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d872b97f91b2bb97$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d872b97f91b2bb97$var$Buffer.prototype.readBigUInt64BE = $d872b97f91b2bb97$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d872b97f91b2bb97$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d872b97f91b2bb97$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d872b97f91b2bb97$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d872b97f91b2bb97$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d872b97f91b2bb97$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d872b97f91b2bb97$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d872b97f91b2bb97$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d872b97f91b2bb97$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d872b97f91b2bb97$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d872b97f91b2bb97$var$Buffer.prototype.readBigInt64LE = $d872b97f91b2bb97$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d872b97f91b2bb97$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d872b97f91b2bb97$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$d872b97f91b2bb97$var$Buffer.prototype.readBigInt64BE = $d872b97f91b2bb97$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d872b97f91b2bb97$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d872b97f91b2bb97$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$d872b97f91b2bb97$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, 4, this.length);
    return $dc954e3b093cc48d$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$d872b97f91b2bb97$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, 4, this.length);
    return $dc954e3b093cc48d$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$d872b97f91b2bb97$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, 8, this.length);
    return $dc954e3b093cc48d$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$d872b97f91b2bb97$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkOffset(offset, 8, this.length);
    return $dc954e3b093cc48d$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $d872b97f91b2bb97$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d872b97f91b2bb97$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d872b97f91b2bb97$var$Buffer.prototype.writeUintLE = $d872b97f91b2bb97$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d872b97f91b2bb97$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d872b97f91b2bb97$var$Buffer.prototype.writeUintBE = $d872b97f91b2bb97$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d872b97f91b2bb97$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d872b97f91b2bb97$var$Buffer.prototype.writeUint8 = $d872b97f91b2bb97$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d872b97f91b2bb97$var$Buffer.prototype.writeUint16LE = $d872b97f91b2bb97$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d872b97f91b2bb97$var$Buffer.prototype.writeUint16BE = $d872b97f91b2bb97$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d872b97f91b2bb97$var$Buffer.prototype.writeUint32LE = $d872b97f91b2bb97$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d872b97f91b2bb97$var$Buffer.prototype.writeUint32BE = $d872b97f91b2bb97$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d872b97f91b2bb97$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d872b97f91b2bb97$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d872b97f91b2bb97$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d872b97f91b2bb97$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d872b97f91b2bb97$var$Buffer.prototype.writeBigUInt64LE = $d872b97f91b2bb97$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $d872b97f91b2bb97$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d872b97f91b2bb97$var$Buffer.prototype.writeBigUInt64BE = $d872b97f91b2bb97$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $d872b97f91b2bb97$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d872b97f91b2bb97$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d872b97f91b2bb97$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d872b97f91b2bb97$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d872b97f91b2bb97$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d872b97f91b2bb97$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d872b97f91b2bb97$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d872b97f91b2bb97$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d872b97f91b2bb97$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d872b97f91b2bb97$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d872b97f91b2bb97$var$Buffer.prototype.writeBigInt64LE = $d872b97f91b2bb97$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $d872b97f91b2bb97$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$d872b97f91b2bb97$var$Buffer.prototype.writeBigInt64BE = $d872b97f91b2bb97$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $d872b97f91b2bb97$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $d872b97f91b2bb97$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d872b97f91b2bb97$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dc954e3b093cc48d$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d872b97f91b2bb97$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d872b97f91b2bb97$var$writeFloat(this, value, offset, true, noAssert);
};
$d872b97f91b2bb97$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d872b97f91b2bb97$var$writeFloat(this, value, offset, false, noAssert);
};
function $d872b97f91b2bb97$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d872b97f91b2bb97$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dc954e3b093cc48d$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d872b97f91b2bb97$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d872b97f91b2bb97$var$writeDouble(this, value, offset, true, noAssert);
};
$d872b97f91b2bb97$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d872b97f91b2bb97$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d872b97f91b2bb97$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d872b97f91b2bb97$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d872b97f91b2bb97$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d872b97f91b2bb97$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $d872b97f91b2bb97$var$Buffer.isBuffer(val) ? val : $d872b97f91b2bb97$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $d872b97f91b2bb97$var$errors = {};
function $d872b97f91b2bb97$var$E(sym, getMessage, Base) {
    $d872b97f91b2bb97$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$d872b97f91b2bb97$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$d872b97f91b2bb97$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$d872b97f91b2bb97$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $d872b97f91b2bb97$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $d872b97f91b2bb97$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $d872b97f91b2bb97$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $d872b97f91b2bb97$var$checkBounds(buf, offset, byteLength) {
    $d872b97f91b2bb97$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d872b97f91b2bb97$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d872b97f91b2bb97$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $d872b97f91b2bb97$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $d872b97f91b2bb97$var$checkBounds(buf, offset, byteLength);
}
function $d872b97f91b2bb97$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $d872b97f91b2bb97$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $d872b97f91b2bb97$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d872b97f91b2bb97$var$validateNumber(value, type);
        throw new $d872b97f91b2bb97$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $d872b97f91b2bb97$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d872b97f91b2bb97$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $d872b97f91b2bb97$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d872b97f91b2bb97$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d872b97f91b2bb97$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d872b97f91b2bb97$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d872b97f91b2bb97$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d872b97f91b2bb97$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d872b97f91b2bb97$var$base64ToBytes(str) {
    return $ac5287e820454e69$export$d622b2ad8d90c771($d872b97f91b2bb97$var$base64clean(str));
}
function $d872b97f91b2bb97$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d872b97f91b2bb97$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d872b97f91b2bb97$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $d872b97f91b2bb97$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d872b97f91b2bb97$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $d872b97f91b2bb97$var$BufferBigIntNotDefined : fn;
}
function $d872b97f91b2bb97$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("T9xHm", function(module, exports) {

var $aK8Ra = parcelRequire("aK8Ra");




/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $de133686e3836166$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}
function $de133686e3836166$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = $de133686e3836166$var$getRawCookieValue((0, $aK8Ra.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = $de133686e3836166$var$getRawCookieValue((0, $aK8Ra.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = $de133686e3836166$var$getRawCookieValue((0, $aK8Ra.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}


function $0d80b51a2573beb2$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext.isInIC;
    const atlCtxCookieValues = (0, $de133686e3836166$export$3fa7b7af96286cc9)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $aK8Ra.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $0d80b51a2573beb2$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext.isInFedramp;
    const atlCtxCookieValues = (0, $de133686e3836166$export$3fa7b7af96286cc9)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $aK8Ra.FEDRAMP_MODERATE);
}
function $0d80b51a2573beb2$export$80638ee198476daf() {
    if (typeof document === 'undefined') return globalThis.location.hostname;
    const atlCtxCookieValues = (0, $de133686e3836166$export$3fa7b7af96286cc9)();
    return atlCtxCookieValues?.icDomain;
}
function $0d80b51a2573beb2$export$839b022803d38d4d() {
    if (typeof document === 'undefined') // @ts-ignore
    return $0d80b51a2573beb2$export$9186ccba8effc5de() ? globalThis.ssrContext.icName : undefined;
    const atlCtxCookieValues = (0, $de133686e3836166$export$3fa7b7af96286cc9)();
    return atlCtxCookieValues?.icId;
}
function $0d80b51a2573beb2$export$9e04105551ffc5c4() {
    if (typeof document === 'undefined') return $0d80b51a2573beb2$var$cloudEnvironmentSsrLookup();
    return $0d80b51a2573beb2$var$cloudEnvironmentCookieLookup();
}
function $0d80b51a2573beb2$var$cloudEnvironmentSsrLookup() {
    // @ts-ignore
    if (globalThis.ssrContext.isInIC === true) return {
        type: 'isolated-cloud',
        perimeter: (0, $aK8Ra.COMMERCIAL)
    };
    // @ts-ignore
    if (globalThis.ssrContext.isInFedramp === true) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $aK8Ra.FEDRAMP_MODERATE)
    };
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $aK8Ra.COMMERCIAL)
    };
}
function $0d80b51a2573beb2$var$cloudEnvironmentCookieLookup() {
    // Avoid calling isFedrampModerate() and isIsolatedCloud() here to avoid repeated cookie parsing
    const atlCtxCookieValues = (0, $de133686e3836166$export$3fa7b7af96286cc9)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $aK8Ra.COMMERCIAL)
    };
    const isIc = (0, $aK8Ra.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
    if (isIc) return {
        type: 'isolated-cloud',
        perimeter: (0, $aK8Ra.COMMERCIAL)
    };
    if (atlCtxCookieValues.perimeter === (0, $aK8Ra.FEDRAMP_MODERATE)) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $aK8Ra.FEDRAMP_MODERATE)
    };
    // If a new cloud environment has been created but not added to this library, return undefined
    return undefined;
}
module.exports["isIsolatedCloud"] = $0d80b51a2573beb2$export$9186ccba8effc5de;
module.exports["isFedrampModerate"] = $0d80b51a2573beb2$export$104cb891a6e90b3a;
module.exports["isolatedCloudDomain"] = $0d80b51a2573beb2$export$80638ee198476daf;
module.exports["isolationContextId"] = $0d80b51a2573beb2$export$839b022803d38d4d;
module.exports["cloudEnvironment"] = $0d80b51a2573beb2$export$9e04105551ffc5c4;

});

parcelRegister("aK8Ra", function(module, exports) {
const $e51c98f01c91eb22$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $e51c98f01c91eb22$export$f005e2e9f707cb5f = 'commercial';
const $e51c98f01c91eb22$export$a739cd5aac835909 = 'staging';
const $e51c98f01c91eb22$export$42dd0cdd351a4a9 = 'prod';
const $e51c98f01c91eb22$export$404582bc18fe4d9e = 'dev';
const $e51c98f01c91eb22$export$d8347b4aae768c2d = [
    $e51c98f01c91eb22$export$f005e2e9f707cb5f
];
const $e51c98f01c91eb22$export$b1b1ccc8f3e7f954 = [
    $e51c98f01c91eb22$export$f005e2e9f707cb5f,
    $e51c98f01c91eb22$export$ce553301d55c2fd8
];
const $e51c98f01c91eb22$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $e51c98f01c91eb22$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $e51c98f01c91eb22$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
module.exports["FEDRAMP_MODERATE"] = $e51c98f01c91eb22$export$ce553301d55c2fd8;
module.exports["COMMERCIAL"] = $e51c98f01c91eb22$export$f005e2e9f707cb5f;
module.exports["STAGING"] = $e51c98f01c91eb22$export$a739cd5aac835909;
module.exports["PRODUCTION"] = $e51c98f01c91eb22$export$42dd0cdd351a4a9;
module.exports["DEV"] = $e51c98f01c91eb22$export$404582bc18fe4d9e;
module.exports["ISOLATED_CLOUD_PERIMETERS"] = $e51c98f01c91eb22$export$d8347b4aae768c2d;
module.exports["ATL_CTX_PERIMETER"] = $e51c98f01c91eb22$export$87285944378c596;
module.exports["ATL_CTX_ISOLATION_CONTEXT_DOMAIN"] = $e51c98f01c91eb22$export$715603e81922c3ec;
module.exports["ATL_CTX_ISOLATION_CONTEXT_ID"] = $e51c98f01c91eb22$export$a0ffa0598c95dfb7;

});

parcelRegister("cMvQV", function(module, exports) {
let $f7403687c64b23d9$export$3dcce53a3755dc8c;
const $f7403687c64b23d9$export$57d3cdb500cb5402 = (agent)=>{
    if (agent) $f7403687c64b23d9$export$3dcce53a3755dc8c = agent;
    else if (typeof window !== 'undefined' && window.navigator) $f7403687c64b23d9$export$3dcce53a3755dc8c = window.navigator.userAgent;
};
const $f7403687c64b23d9$export$aad8462122ac592b = ()=>{
    $f7403687c64b23d9$export$3dcce53a3755dc8c = undefined;
};
const $f7403687c64b23d9$export$b7d78993b74f766d = ()=>{
    return $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('Firefox/') !== -1;
};
const $f7403687c64b23d9$export$c87f7e935aea4901 = ()=>{
    return !$f7403687c64b23d9$export$b7d78993b74f766d();
};
const $f7403687c64b23d9$export$552b0ed0b7a8f620 = ()=>{
    return $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('Edge/') !== -1;
};
const $f7403687c64b23d9$export$bf319670985f797f = ()=>{
    return !$f7403687c64b23d9$export$552b0ed0b7a8f620();
};
const $f7403687c64b23d9$export$7e7b1a9668aaed8 = ()=>{
    return $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('MSIE') !== -1 || $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('Trident/') !== -1 || $f7403687c64b23d9$export$552b0ed0b7a8f620();
};
const $f7403687c64b23d9$export$a9ab798d36ba46c = ()=>{
    return !$f7403687c64b23d9$export$7e7b1a9668aaed8();
};
const $f7403687c64b23d9$export$6446a186d09e379e = ()=>{
    return $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('Chrome/') !== -1;
};
const $f7403687c64b23d9$export$23ee57a84a15eab5 = ()=>{
    return !$f7403687c64b23d9$export$6446a186d09e379e();
};
const $f7403687c64b23d9$export$95df08bae54cb4df = ()=>{
    return $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('Safari/') !== -1 && $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('Chrome/') === -1;
};
const $f7403687c64b23d9$export$bc187e33086c8385 = ()=>{
    return !$f7403687c64b23d9$export$95df08bae54cb4df();
};
const $f7403687c64b23d9$export$7b405d3c2ef63516 = ()=>{
    return $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('PhantomJS') !== -1;
};
const $f7403687c64b23d9$export$f11fe2ca946efdb2 = ()=>{
    return !$f7403687c64b23d9$export$7b405d3c2ef63516();
};
const $f7403687c64b23d9$export$6d5620528cf86fa2 = ()=>{
    return !!$f7403687c64b23d9$export$3dcce53a3755dc8c && ($f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('Confluence iOS/') !== -1 || $f7403687c64b23d9$export$3dcce53a3755dc8c?.indexOf('Confluence Android/') !== -1);
};
const $f7403687c64b23d9$export$83d89fbfd8236492 = ()=>{
    let versionMatch;
    if ($f7403687c64b23d9$export$7e7b1a9668aaed8()) versionMatch = $f7403687c64b23d9$export$3dcce53a3755dc8c?.match(/MSIE\s([\d.]+)/) || $f7403687c64b23d9$export$3dcce53a3755dc8c?.match(/rv:([\d.]+)/) || $f7403687c64b23d9$export$3dcce53a3755dc8c?.match(/Edge\/([\d.]+)/);
    else if ($f7403687c64b23d9$export$6446a186d09e379e()) versionMatch = $f7403687c64b23d9$export$3dcce53a3755dc8c?.match(/Chrome\/([\d.]+)/);
    else if ($f7403687c64b23d9$export$95df08bae54cb4df()) versionMatch = $f7403687c64b23d9$export$3dcce53a3755dc8c?.match(/Version\/([\d.]+)/);
    else if ($f7403687c64b23d9$export$b7d78993b74f766d()) versionMatch = $f7403687c64b23d9$export$3dcce53a3755dc8c?.match(/Firefox\/([\d.]+)/);
    return versionMatch && parseInt(versionMatch[1]);
};
const $f7403687c64b23d9$export$f52e1a142ed579d = ()=>{
    if ($f7403687c64b23d9$export$552b0ed0b7a8f620()) return 'MSEdge';
    if ($f7403687c64b23d9$export$7e7b1a9668aaed8()) return 'IE';
    if ($f7403687c64b23d9$export$6446a186d09e379e()) return 'Chrome';
    if ($f7403687c64b23d9$export$95df08bae54cb4df()) return 'Safari';
    if ($f7403687c64b23d9$export$b7d78993b74f766d()) return 'Firefox';
};
module.exports["setUserAgent"] = $f7403687c64b23d9$export$57d3cdb500cb5402;
module.exports["isFirefox"] = $f7403687c64b23d9$export$b7d78993b74f766d;
module.exports["isMSEdge"] = $f7403687c64b23d9$export$552b0ed0b7a8f620;
module.exports["isIE"] = $f7403687c64b23d9$export$7e7b1a9668aaed8;
module.exports["isChrome"] = $f7403687c64b23d9$export$6446a186d09e379e;
module.exports["isSafari"] = $f7403687c64b23d9$export$95df08bae54cb4df;
module.exports["isNativeMobile"] = $f7403687c64b23d9$export$6d5620528cf86fa2;
module.exports["version"] = $f7403687c64b23d9$export$83d89fbfd8236492;
module.exports["friendlyName"] = $f7403687c64b23d9$export$f52e1a142ed579d;

});

parcelRegister("hmRc4", function(module, exports) {

var $7PY4o = parcelRequire("7PY4o");


var $2XqLN = parcelRequire("2XqLN");

let $f54fcd98c424e4b2$var$browserHistoryListener = null;
const $f54fcd98c424e4b2$export$39f750fd76b05ae3 = (newBrowserHistoryListener)=>{
    $f54fcd98c424e4b2$var$browserHistoryListener = newBrowserHistoryListener;
    return ()=>{
        $f54fcd98c424e4b2$var$browserHistoryListener = null;
    };
};
const $f54fcd98c424e4b2$export$1ddb08151d15bc78 = (0, $2XqLN.default)(()=>{
    const browserHistory = (0, $7PY4o.default)();
    browserHistory.listen((location, action)=>{
        $f54fcd98c424e4b2$var$browserHistoryListener?.(location, action);
    });
    return browserHistory;
});
module.exports["setBrowserHistoryListener"] = $f54fcd98c424e4b2$export$39f750fd76b05ae3;
module.exports["getBrowserHistory"] = $f54fcd98c424e4b2$export$1ddb08151d15bc78;

});

parcelRegister("2XqLN", function(module, exports) {
var $2275db661fc067ee$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $2275db661fc067ee$var$isEqual(first, second) {
    if (first === second) return true;
    if ($2275db661fc067ee$var$safeIsNaN(first) && $2275db661fc067ee$var$safeIsNaN(second)) return true;
    return false;
}
function $2275db661fc067ee$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$2275db661fc067ee$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $2275db661fc067ee$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $2275db661fc067ee$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}
module.exports["default"] = $2275db661fc067ee$export$2e2bcd8739ae039;

});

parcelRegister("eSuZj", function(module, exports) {
// The build information here are populated by the code inlined in the bootstrapping HTML
// They can be found in:
// - packages/confluence-frontend-server/templates/*
function $fb0776fab4601f82$var$getReleaseTrack() {
    try {
        // This value overrides the track as "dev". Helpful for when
        // end-to-end tests are run from dev machine against a production instance.
        // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
        if (sessionStorage.getItem('confluence.telemetry-dev-track-override')) return 'dev';
    } catch  {
    // no-op
    }
    return 'prod';
}
function $fb0776fab4601f82$export$4ea39b9726d98a51() {
    const injectedBuildInfo = window.__buildInfo || {};
    let { FRONTEND_VERSION: FRONTEND_VERSION } = injectedBuildInfo;
    if (!FRONTEND_VERSION) FRONTEND_VERSION = '';
    const FRONTEND_VERSION_PATTERN = /^([^-]+)-(.+)-(\d+)$/;
    const match = FRONTEND_VERSION_PATTERN.exec(FRONTEND_VERSION);
    return {
        FRONTEND_VERSION: match ? FRONTEND_VERSION : 'UNKNOWN-unknown-0',
        BRANCH_NAME: match ? match[2] : 'unknown',
        BUILD_NUMBER: match ? parseInt(match[3], 10) : 0,
        BUILD_DATE: injectedBuildInfo.BUILD_DATE || 0,
        PUBLIC_PATH: injectedBuildInfo.PUBLIC_PATH || 'unknown',
        RELEASE_TRACK: $fb0776fab4601f82$var$getReleaseTrack(),
        IS_BIFROST: window.__IS_BIFROST__ || false
    };
}
module.exports["getBuildInfo"] = $fb0776fab4601f82$export$4ea39b9726d98a51;

});

parcelRegister("6X8o4", function(module, exports) {
const $bcb98143ff5ee717$var$PromiseStatus = Symbol.for('PromiseStatus');
const $bcb98143ff5ee717$var$PromiseValue = Symbol.for('PromiseValue');
const $bcb98143ff5ee717$export$cc373701aed148fc = (promise)=>{
    const newPromise = promise.then((value)=>{
        newPromise[$bcb98143ff5ee717$var$PromiseStatus] = 'resolved';
        newPromise[$bcb98143ff5ee717$var$PromiseValue] = value;
        return value;
    }, (error)=>{
        newPromise[$bcb98143ff5ee717$var$PromiseStatus] = 'rejected';
        newPromise[$bcb98143ff5ee717$var$PromiseValue] = error;
        throw error;
    });
    newPromise[$bcb98143ff5ee717$var$PromiseStatus] = 'pending';
    return newPromise;
};
const $bcb98143ff5ee717$export$b1a2a6bd0c6f9666 = (liftedPromise)=>liftedPromise[$bcb98143ff5ee717$var$PromiseStatus] === 'resolved';
const $bcb98143ff5ee717$export$bf7199a9ebcb84a9 = (liftedPromise)=>liftedPromise[$bcb98143ff5ee717$var$PromiseValue];
module.exports["liftPromiseState"] = $bcb98143ff5ee717$export$cc373701aed148fc;
module.exports["isResolved"] = $bcb98143ff5ee717$export$b1a2a6bd0c6f9666;
module.exports["getValue"] = $bcb98143ff5ee717$export$bf7199a9ebcb84a9;

});

parcelRegister("8dwdz", function(module, exports) {

var $cMvQV = parcelRequire("cMvQV");


var $7W8i8 = parcelRequire("7W8i8");

// Must call this before any browser-helper functions, to ensure user agent has been set first
(0, $cMvQV.setUserAgent)();
const $a209961579457491$var$logger = (0, $7W8i8.getLogger)('mobile-detection');
// Copied from com.atlassian.confluence.mobile.MobileUtils
const $a209961579457491$var$NATIVE_IOS_REGEX_STRING = 'iPhone;|iPad;|iPhone Simulator;|iPod;|iPod touch;';
const $a209961579457491$var$NATIVE_ANDROID_REGEX_STRING = 'Linux; U; Android|Android';
const $a209961579457491$var$MOBILE_USER_AGENT_REGEX = new RegExp(`(${$a209961579457491$var$NATIVE_IOS_REGEX_STRING}|${$a209961579457491$var$NATIVE_ANDROID_REGEX_STRING})`, 'i');
const $a209961579457491$var$ANDROID_CHROME = /Chrome\/[.\d]* Mobile/i;
const $a209961579457491$var$OLD_ANDROID = /Linux; U; Android (?:[23]\.\d|4\.0\.[12])/i;
const $a209961579457491$var$NATIVE_IOS = new RegExp(`(${$a209961579457491$var$NATIVE_IOS_REGEX_STRING})`, 'i');
const $a209961579457491$var$NATIVE_ANDROID = new RegExp(`(${$a209961579457491$var$NATIVE_ANDROID_REGEX_STRING})`, 'i');
const $a209961579457491$export$bb3c728251279d4a = 'mobileWebTestingMode=testing';
const $a209961579457491$export$2275282fb5681637 = 'mobile.web.desktop.override.active';
const $a209961579457491$export$abee7d877fc322c9 = ()=>{
    // Port from com.atlassian.confluence.mobile.MobileUtils#isMobileViewRequest
    const ua = window.navigator.userAgent;
    return !!ua && !$a209961579457491$var$OLD_ANDROID.test(ua) && ($a209961579457491$var$MOBILE_USER_AGENT_REGEX.test(ua) || $a209961579457491$var$ANDROID_CHROME.test(ua) || (0, $cMvQV.isNativeMobile)());
};
const $a209961579457491$export$cc63546398e0df2 = ()=>window.localStorage.getItem($a209961579457491$export$2275282fb5681637) === 'true';
const $a209961579457491$export$47a2095e97aaa3d3 = ()=>{
    try {
        // TODO: Remove lint rule once storage is updated to use atlassian/browser-storage-controls or confluence/storage-manager
        // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
        window.localStorage.setItem($a209961579457491$export$2275282fb5681637, 'true');
    } catch (err) {
        $a209961579457491$var$logger.error`Unable to set local storage. key = "${$a209961579457491$export$2275282fb5681637}", value = "true"`;
    }
};
const $a209961579457491$export$77ee453f21ed22ca = ()=>window.localStorage.removeItem($a209961579457491$export$2275282fb5681637);
function $a209961579457491$export$1adf40e7373cdd98() {
    // for testing purposes, query param forces mobile web
    if (window.location.search.includes($a209961579457491$export$bb3c728251279d4a)) return true;
    return $a209961579457491$export$abee7d877fc322c9() && !$a209961579457491$export$cc63546398e0df2();
}
const $a209961579457491$export$4483f9f8ce987764 = ()=>{
    const ua = window.navigator.userAgent;
    return !!ua && $a209961579457491$var$NATIVE_ANDROID.test(ua);
};
const $a209961579457491$export$63c82ea425a2bb3d = ()=>{
    const ua = window.navigator.userAgent;
    return !!ua && $a209961579457491$var$NATIVE_IOS.test(ua);
};
module.exports["isMobileUserAgent"] = $a209961579457491$export$abee7d877fc322c9;
module.exports["isDesktopOverrideActive"] = $a209961579457491$export$cc63546398e0df2;
module.exports["activateDesktopOverride"] = $a209961579457491$export$47a2095e97aaa3d3;
module.exports["deactivateDesktopOverride"] = $a209961579457491$export$77ee453f21ed22ca;
module.exports["shouldShowMobileWeb"] = $a209961579457491$export$1adf40e7373cdd98;
module.exports["isNativeAndroid"] = $a209961579457491$export$4483f9f8ce987764;
module.exports["isNativeIOS"] = $a209961579457491$export$63c82ea425a2bb3d;

});

parcelRegister("7W8i8", function(module, exports) {
/* eslint-disable no-console */ function $adab7063d3512c85$var$getLoggerName(logSource) {
    return typeof logSource === 'string' ? logSource : logSource.displayName || logSource.name || 'Unknown';
}
class $adab7063d3512c85$var$Logger {
    log(strings, ...values) {
        this.logAnyLevel(1, console.log, strings, values);
    }
    debug(strings, ...values) {
        this.logAnyLevel(2, console.debug, strings, values);
    }
    info(strings, ...values) {
        this.logAnyLevel(3, console.info, strings, values);
    }
    warn(strings, ...values) {
        this.logAnyLevel(4, console.warn, strings, values);
    }
    error(strings, ...values) {
        this.logAnyLevel(5, console.error, strings, values);
    }
    logAnyLevel(logLevel, consoleFunction, strings, values) {
        try {
            if (// There's no sessionStorage in service workers.
            // We'll just enable logging from service workers for simplicity.
            typeof sessionStorage === 'undefined' || sessionStorage.getItem('confluence.enable-logging') === 'true') {
                const logLevelSetting = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('confluence.log-level');
                const configuredLogLevel = parseInt(logLevelSetting || '', 10) || 1;
                if (configuredLogLevel > logLevel) return;
                const prefix = [
                    `[@${Math.round(performance.now())} ${this.name}]`
                ];
                const messages = strings.reduce((processed, str, index)=>{
                    const value = values[index];
                    const trimmedStr = str.trim()// Allow multiline strings to be indented in code but printed without indenting
                    .replace(/\n\s+/g, '\n');
                    if (trimmedStr) processed.push(trimmedStr);
                    if (index !== strings.length - 1) processed.push(typeof value === 'string' ? JSON.stringify(value) : value);
                    return processed;
                }, prefix);
                consoleFunction(...messages);
            }
        } catch (e) {
            // Catch and log.
            // We don't want to stop execution due to a logging error.
            console.error(e);
        }
    }
    constructor(logSource){
        this.name = void 0;
        this.name = $adab7063d3512c85$var$getLoggerName(logSource);
    }
}
const $adab7063d3512c85$export$2b1d391cd05230fd = (logSource)=>new $adab7063d3512c85$var$Logger(logSource);
module.exports["getLogger"] = $adab7063d3512c85$export$2b1d391cd05230fd;

});

parcelRegister("f7B1p", function(module, exports) {


var $7W8i8 = parcelRequire("7W8i8");



var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");



var $cgNzK = parcelRequire("cgNzK");


var $hBkCm = parcelRequire("hBkCm");


var $flE5X = parcelRequire("flE5X");


var $8pZFw = parcelRequire("8pZFw");


var $14DR2 = parcelRequire("14DR2");


var $3P4tJ = parcelRequire("3P4tJ");


var $c0BL4 = parcelRequire("c0BL4");


var $lqJ5I = parcelRequire("lqJ5I");

const $9d631243cbb35282$export$7fd82c6bb3f5e7d5 = async (resource, init = {})=>{
    const urlPrefix = (0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint') ? '/gateway/api/graphql/slow' : '/cgraphql';
    if (typeof window !== 'undefined' && window['GLOBAL_FALLBACK_ATL_EXP']) {
        if (resource instanceof Request && resource.url.startsWith(urlPrefix)) resource.headers.append((0, $c0BL4.X_ATL_EXPERIENCE), resource.headers.get((0, $c0BL4.X_ATL_EXPERIENCE)) || window['GLOBAL_FALLBACK_ATL_EXP']);
        else if (String(resource).startsWith(urlPrefix)) {
            init.headers = init?.headers || {};
            // For requests sending outside of exp tracker scope fallback to URL based exp name
            (0, $14DR2.appendHeader)(init.headers, (0, $c0BL4.X_ATL_EXPERIENCE), (0, $3P4tJ.getHeaderValue)(init.headers, (0, $c0BL4.X_ATL_EXPERIENCE)) || window['GLOBAL_FALLBACK_ATL_EXP']);
        }
    }
    // eslint-disable-next-line prefer-const
    let { ignoreNoNetworkError: ignoreNoNetworkError, requestInit: requestInit } = $9d631243cbb35282$var$decomposeInit(init);
    // XXX Default RequestInit's credentials to "include" but not always: if the
    // caller provided a Request as resource and no init, then us adding a
    // RequestInit can break the caller.
    if (!resource || typeof resource === 'string' || !resource.credentials) requestInit = {
        credentials: 'include',
        ...requestInit
    };
    let response;
    const { url: url } = $9d631243cbb35282$var$getRequestInfo(resource);
    let finalUrl = url;
    let authHeaders = {};
    try {
        // Track REST calls for frontend (GraphQL is tracked separately)
        // Only track in browser environment
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (typeof window !== 'undefined') (0, $lqJ5I.networkTracker).trackRestCall(url);
        var value, name;
        // eslint-disable-next-line check-credentials-option/has-credentials-option, no-restricted-syntax
        response = await fetch(resource, requestInit);
    } catch (e) {
        // According to the fetch spec, a network failure results in a Promise
        // rejected with a TypeError. Any Response at all will resolve the Promise,
        // with the status property revealing the HTTP status code.
        const cause = (0, $6mKj3.expVal)('confluence_use_fetch_base', 'isEnabled', false) ? e.cause : e;
        const error = new (0, $flE5X.NoNetworkError)(`Network failure: ${cause}`, {
            cause: cause
        });
        error.ignore = ignoreNoNetworkError;
        error.ignore || $9d631243cbb35282$var$emit(/* response */ undefined, error);
        throw error;
    }
    // If we don't get a 2xx Response, we'll consider that an error, and we'll
    // throw an exception. If we don't, we risk developers not checking the
    // Response status, running parsing logic such as parsing JSON, and failing
    // on non-2xx HTTP status code with weird errors like:
    // * Unexpected end of JSON input
    // * Unexpected token < in JSON at position 0
    // * JSON.parse: unexpected end of data at line 1 column 1 of the JSON data
    // * etc.
    //
    // By using our own Error subclass, we can prevent such unintended running of
    // parsing logic and we allow the product easily recognize the error and apply
    // product-wide processing.
    if (!response.ok) {
        let error;
        if (response.status === 429) error = new (0, $8pZFw.RateLimitedError)(resource.toString(), response);
        else error = new (0, $hBkCm.BadStatusError)(`Received status ${response.status}`, response);
        $9d631243cbb35282$var$emit(response, error);
        throw error;
    }
    $9d631243cbb35282$var$emit(response, /* error */ undefined);
    return response;
};
function $9d631243cbb35282$var$decomposeInit(init = {}) {
    const { ignoreNoNetworkError: ignoreNoNetworkError, ...requestInit } = init;
    return {
        ignoreNoNetworkError: ignoreNoNetworkError,
        requestInit: Object.getOwnPropertyNames(requestInit).length ? (0, $cgNzK.constructCompatibleRequestInit)(requestInit) : undefined
    };
}
const $9d631243cbb35282$var$logger = (0, $7W8i8.getLogger)($9d631243cbb35282$export$7fd82c6bb3f5e7d5);
let $9d631243cbb35282$var$subscribers = [];
/**
 * Adds a specific `subscriber` to be notified whenever any `cfetch` call
 * resolves with a `Response` and/or an `Error`. If you're calling `cfetch` and
 * are interested in the outcome of that particular call only, please await the
 * resolution of the `Promise` returned by `cfetch`.
 */ $9d631243cbb35282$export$7fd82c6bb3f5e7d5.subscribe = (subscriber)=>{
    if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
    $9d631243cbb35282$var$subscribers.push(subscriber);
    return ()=>{
        $9d631243cbb35282$var$subscribers = $9d631243cbb35282$var$subscribers.filter((x)=>x !== subscriber);
    };
};
function $9d631243cbb35282$var$emit(response, error) {
    $9d631243cbb35282$var$subscribers.forEach((subscriber)=>{
        try {
            subscriber(response, error);
        } catch (e) {
            $9d631243cbb35282$var$logger.error`Error occurred in a cfetch subscriber: ${e}`;
        }
    });
}
/**
 * Helper function to extract URL and determine if request is GraphQL
 */ function $9d631243cbb35282$var$getRequestInfo(resource) {
    const url = typeof resource === 'string' ? resource : resource instanceof Request ? resource.url : resource.toString();
    const isGraphQL = url.includes('/gateway/api/graphql/slow') || url.includes('?q=') || url.includes('&q=');
    return {
        url: url,
        isGraphQL: isGraphQL
    };
}
module.exports["cfetch"] = $9d631243cbb35282$export$7fd82c6bb3f5e7d5;

});

parcelRegister("cgNzK", function(module, exports) {
function $e9eb431104406f8e$export$eca64eb737a4c2bc(requestInit) {
    // referrerPolicy is not supported by Edge pre Chromium:
    if (requestInit && 'referrerPolicy' in requestInit) {
        const { referrerPolicy: referrerPolicy, ...requestInitWithoutReferrerPolicy } = requestInit;
        try {
            new Request('/', {
                referrerPolicy: referrerPolicy
            });
        // The referrerPolicy seems to be supported. Leave it in requestInit.
        } catch (_) {
            // The referrerPolicy does not seem to be supported. Drop it from
            // requestInit; otherwise, the Request constructor and fetch will throw:
            requestInit = requestInitWithoutReferrerPolicy;
        }
    }
    return requestInit;
}
module.exports["constructCompatibleRequestInit"] = $e9eb431104406f8e$export$eca64eb737a4c2bc;

});

parcelRegister("hBkCm", function(module, exports) {

var $9kGfD = parcelRequire("9kGfD");


var $6fil2 = parcelRequire("6fil2");

class $725b5147ae15e4c9$export$12c8b3d0a1a46f87 extends (0, $6fil2.NetworkError) {
    get traceId() {
        return (0, $9kGfD.getTraceIdFromResponse)(this.response);
    }
    static isBadStatusError(value) {
        return value instanceof $725b5147ae15e4c9$export$12c8b3d0a1a46f87;
    }
    constructor(message, response){
        super(message);
        this.response = void 0;
        this.name = 'BadStatusError';
        this.response = response;
    }
}
module.exports["BadStatusError"] = $725b5147ae15e4c9$export$12c8b3d0a1a46f87;

});

parcelRegister("9kGfD", function(module, exports) {
const $2ab84c9d21556fcf$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-b3-traceid') || response?.headers?.get('atl-traceid') || null;
module.exports["getTraceIdFromResponse"] = $2ab84c9d21556fcf$export$9f229e40eb65abfc;

});

parcelRegister("6fil2", function(module, exports) {

var $9wEpK = parcelRequire("9wEpK");


var $8H5XZ = parcelRequire("8H5XZ");

class $28de7f8962acb00f$export$bae979e68e4dc802 extends Error {
}
function $28de7f8962acb00f$export$bda33884db3cf75b(error) {
    if (error instanceof $28de7f8962acb00f$export$bae979e68e4dc802) return true;
    if ((0, $9wEpK.isApolloError)(error)) {
        const { graphQLErrors: graphQLErrors, networkError: networkError } = error;
        if (networkError) // ApolloError describes a network-related error if its networkError
        // property value is truthy. These are errors that have occurred within a
        // NetworkLink of ApolloClient. Think non-experimental queries (and
        // mutations).
        return true;
        return graphQLErrors.some($28de7f8962acb00f$export$bda33884db3cf75b);
    }
    if ((0, $8H5XZ.isGraphQLError)(error)) {
        const { originalError: originalError } = error;
        if (originalError) return $28de7f8962acb00f$export$bda33884db3cf75b(originalError);
    }
    return false;
}
function $28de7f8962acb00f$export$762bd3eeab681428(error) {
    return error.cause instanceof Error && error.cause?.name === 'AbortError';
}
module.exports["NetworkError"] = $28de7f8962acb00f$export$bae979e68e4dc802;
module.exports["containsNetworkError"] = $28de7f8962acb00f$export$bda33884db3cf75b;
module.exports["causedByAbortError"] = $28de7f8962acb00f$export$762bd3eeab681428;

});

parcelRegister("9wEpK", function(module, exports) {
$parcel$export(module.exports, "NetworkStatus", () => $6ef673a53f74c0bb$export$bd096ddbd246c79c);

var $hXuPC = parcelRequire("hXuPC");


var $guZe9 = parcelRequire("guZe9");

var $b3YTN = parcelRequire("b3YTN");


var $5v4fk = parcelRequire("5v4fk");
var $jLTuK = parcelRequire("jLTuK");


var $1hmzn = parcelRequire("1hmzn");


var $7RTAm = parcelRequire("7RTAm");


var $19Cca = parcelRequire("19Cca");

var $6ef673a53f74c0bb$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($6ef673a53f74c0bb$export$bd096ddbd246c79c || ($6ef673a53f74c0bb$export$bd096ddbd246c79c = {}));
function $6ef673a53f74c0bb$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $6ef673a53f74c0bb$var$Observable = function(_super) {
    (0, $hXuPC.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $1hmzn.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $jLTuK.default));
function $6ef673a53f74c0bb$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $6ef673a53f74c0bb$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $6ef673a53f74c0bb$var$generateErrorMessage = function(err) {
    var message = '';
    if ($6ef673a53f74c0bb$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $6ef673a53f74c0bb$export$26a337512320b8c6 = function(_super) {
    (0, $hXuPC.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $6ef673a53f74c0bb$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $6ef673a53f74c0bb$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($6ef673a53f74c0bb$export$160bafb6ac1e0641 || ($6ef673a53f74c0bb$export$160bafb6ac1e0641 = {}));
var $6ef673a53f74c0bb$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $6ef673a53f74c0bb$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $6ef673a53f74c0bb$export$6c1b56eac59c9584 = function(_super) {
    (0, $hXuPC.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $guZe9.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $6ef673a53f74c0bb$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($6ef673a53f74c0bb$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $6ef673a53f74c0bb$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $6ef673a53f74c0bb$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $6ef673a53f74c0bb$export$bd096ddbd246c79c.loading : $6ef673a53f74c0bb$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, result), {
            stale: false
        }));
        return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $b3YTN.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $7RTAm.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $b3YTN.equal)(this.variables, variables)) this.variables = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this.variables), variables);
        if (!(0, $b3YTN.equal)(this.options.variables, this.variables)) this.options.variables = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $6ef673a53f74c0bb$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $7RTAm.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $6ef673a53f74c0bb$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $b3YTN.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $guZe9.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $6ef673a53f74c0bb$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $guZe9.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $6ef673a53f74c0bb$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $6ef673a53f74c0bb$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $6ef673a53f74c0bb$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $6ef673a53f74c0bb$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $b3YTN.equal)(previousVariables, variables)) _this.refetch();
                        else $6ef673a53f74c0bb$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $6ef673a53f74c0bb$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($6ef673a53f74c0bb$var$Observable);
function $6ef673a53f74c0bb$var$defaultSubscriptionObserverErrorCallback(error) {}
function $6ef673a53f74c0bb$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $6ef673a53f74c0bb$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $7RTAm.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $6ef673a53f74c0bb$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $6ef673a53f74c0bb$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $7RTAm.invariant)(!previousQuery || previousQuery.document === query.document || (0, $b3YTN.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $6ef673a53f74c0bb$export$bd096ddbd246c79c.loading) {
            if (!(0, $b3YTN.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $6ef673a53f74c0bb$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $6ef673a53f74c0bb$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $6ef673a53f74c0bb$export$bd096ddbd246c79c.refetch;
        else networkStatus = $6ef673a53f74c0bb$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $6ef673a53f74c0bb$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $6ef673a53f74c0bb$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $6ef673a53f74c0bb$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $6ef673a53f74c0bb$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $6ef673a53f74c0bb$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $6ef673a53f74c0bb$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $6ef673a53f74c0bb$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $6ef673a53f74c0bb$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $6ef673a53f74c0bb$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $guZe9.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $guZe9.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $hXuPC.__awaiter)(this, void 0, void 0, function() {
            return (0, $hXuPC.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $guZe9.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $guZe9.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $7RTAm.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $hXuPC.__awaiter)(this, void 0, void 0, function() {
            return (0, $hXuPC.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $hXuPC.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $19Cca.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $19Cca.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $guZe9.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $hXuPC.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $hXuPC.__generator)(this, function(_b) {
                mainDefinition = (0, $guZe9.getMainDefinition)(document);
                fragments = (0, $guZe9.getFragmentDefinitions)(document);
                fragmentMap = (0, $guZe9.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $6ef673a53f74c0bb$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $hXuPC.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $hXuPC.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $hXuPC.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $hXuPC.__generator)(this, function(_a) {
                            if (!(0, $guZe9.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $guZe9.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $guZe9.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $guZe9.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $7RTAm.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $guZe9.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $hXuPC.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $hXuPC.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $guZe9.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $guZe9.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $6ef673a53f74c0bb$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $6ef673a53f74c0bb$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $6ef673a53f74c0bb$var$asyncMap(observable, mapFn) {
    return new $6ef673a53f74c0bb$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $6ef673a53f74c0bb$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $6ef673a53f74c0bb$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $6ef673a53f74c0bb$var$MutationStore();
        this.queryStore = new $6ef673a53f74c0bb$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $guZe9.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $6ef673a53f74c0bb$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $7RTAm.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $hXuPC.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $hXuPC.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $7RTAm.invariant)(mutation, 9);
                        (0, $7RTAm.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $6ef673a53f74c0bb$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $guZe9.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $6ef673a53f74c0bb$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $6ef673a53f74c0bb$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($6ef673a53f74c0bb$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $guZe9.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $hXuPC.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $hXuPC.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $guZe9.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $6ef673a53f74c0bb$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $6ef673a53f74c0bb$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($6ef673a53f74c0bb$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $6ef673a53f74c0bb$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $6ef673a53f74c0bb$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $6ef673a53f74c0bb$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $6ef673a53f74c0bb$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $6ef673a53f74c0bb$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $guZe9.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $guZe9.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $guZe9.getDefaultValues)((0, $guZe9.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $7RTAm.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $hXuPC.__assign)({}, options);
        return new $6ef673a53f74c0bb$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $7RTAm.invariant)(options.query, 12);
        (0, $7RTAm.invariant)(options.query.kind === 'Document', 13);
        (0, $7RTAm.invariant)(!options.returnPartialData, 14);
        (0, $7RTAm.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                if (!$6ef673a53f74c0bb$export$13f5a5f0f1dbab88.__watchPerformanceImprovementsEnabled || newData.result !== previousResult()) _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $7RTAm.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $guZe9.graphQLResultHasError)(result)) throw new $6ef673a53f74c0bb$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $6ef673a53f74c0bb$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $7RTAm.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) {
                const name = info && info.document && info.document.definitions && info.document.definitions[0] && info.document.definitions[0].name && info.document.definitions[0].name.value;
                const stats = typeof window !== 'undefined' && window && window.__APOLLO_STATS__ && window.__APOLLO_STATS__.broadcast;
                let start;
                if (name && stats) {
                    start = performance.now();
                    if (!(name in stats)) stats[name] = {
                        count: 0,
                        duration: 0
                    };
                    stats[name].count++;
                }
                info.listeners.forEach(function(listener) {
                    if (listener) listener(_this.queryStore.get(id), info.newData);
                });
                if (name && stats) stats[name].duration += performance.now() - start; // how long it took to broadcast
            }
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $guZe9.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $6ef673a53f74c0bb$var$multiplex((0, $5v4fk.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $6ef673a53f74c0bb$var$multiplex((0, $5v4fk.execute)(link, operation));
        } else {
            observable = $6ef673a53f74c0bb$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $6ef673a53f74c0bb$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $6ef673a53f74c0bb$var$isNonEmptyArray(result.errors)) return reject(new $6ef673a53f74c0bb$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $6ef673a53f74c0bb$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $6ef673a53f74c0bb$export$bd096ddbd246c79c.ready && query.networkStatus !== $6ef673a53f74c0bb$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $7RTAm.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $6ef673a53f74c0bb$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $6ef673a53f74c0bb$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $guZe9.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $guZe9.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $guZe9.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $guZe9.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $guZe9.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $guZe9.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $guZe9.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $6ef673a53f74c0bb$var$version = "2.6.10";
var $6ef673a53f74c0bb$var$hasSuggestedDevtools = false;
var $6ef673a53f74c0bb$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $5v4fk.ApolloLink).empty();
        if (!link || !cache) throw new (0, $7RTAm.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $6ef673a53f74c0bb$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $6ef673a53f74c0bb$var$version;
        this.localState = new $6ef673a53f74c0bb$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $6ef673a53f74c0bb$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this.defaultOptions.query), options);
        (0, $7RTAm.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $5v4fk.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $6ef673a53f74c0bb$export$2e2bcd8739ae039 = $6ef673a53f74c0bb$export$13f5a5f0f1dbab88;
module.exports["isApolloError"] = $6ef673a53f74c0bb$export$17f5e6bd290bb15d;
module.exports["ApolloError"] = $6ef673a53f74c0bb$export$26a337512320b8c6;
module.exports["ApolloClient"] = $6ef673a53f74c0bb$export$13f5a5f0f1dbab88;

});

parcelRegister("hXuPC", function(module, exports) {
$parcel$export(module.exports, "__assign", () => $d12fdcdf5ecb4065$export$18ce0697a983be9b);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $d12fdcdf5ecb4065$var$extendStatics = function(d, b) {
    $d12fdcdf5ecb4065$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $d12fdcdf5ecb4065$var$extendStatics(d, b);
};
function $d12fdcdf5ecb4065$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $d12fdcdf5ecb4065$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d12fdcdf5ecb4065$export$18ce0697a983be9b = function() {
    $d12fdcdf5ecb4065$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d12fdcdf5ecb4065$export$18ce0697a983be9b.apply(this, arguments);
};
function $d12fdcdf5ecb4065$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d12fdcdf5ecb4065$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d12fdcdf5ecb4065$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d12fdcdf5ecb4065$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $d12fdcdf5ecb4065$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $d12fdcdf5ecb4065$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $d12fdcdf5ecb4065$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $d12fdcdf5ecb4065$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d12fdcdf5ecb4065$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d12fdcdf5ecb4065$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $d12fdcdf5ecb4065$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $d12fdcdf5ecb4065$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $d12fdcdf5ecb4065$export$45d3717a4c69092e(o, m, p);
}
function $d12fdcdf5ecb4065$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d12fdcdf5ecb4065$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d12fdcdf5ecb4065$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d12fdcdf5ecb4065$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d12fdcdf5ecb4065$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d12fdcdf5ecb4065$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $d12fdcdf5ecb4065$export$10c90e4f7922046c(v) {
    return this instanceof $d12fdcdf5ecb4065$export$10c90e4f7922046c ? (this.v = v, this) : new $d12fdcdf5ecb4065$export$10c90e4f7922046c(v);
}
function $d12fdcdf5ecb4065$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d12fdcdf5ecb4065$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d12fdcdf5ecb4065$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d12fdcdf5ecb4065$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $d12fdcdf5ecb4065$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d12fdcdf5ecb4065$export$19a8beecd37a4c45 === "function" ? $d12fdcdf5ecb4065$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d12fdcdf5ecb4065$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $d12fdcdf5ecb4065$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $d12fdcdf5ecb4065$var$ownKeys = function(o) {
    $d12fdcdf5ecb4065$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $d12fdcdf5ecb4065$var$ownKeys(o);
};
function $d12fdcdf5ecb4065$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $d12fdcdf5ecb4065$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $d12fdcdf5ecb4065$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $d12fdcdf5ecb4065$var$__setModuleDefault(result, mod);
    return result;
}
function $d12fdcdf5ecb4065$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d12fdcdf5ecb4065$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $d12fdcdf5ecb4065$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $d12fdcdf5ecb4065$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $d12fdcdf5ecb4065$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $d12fdcdf5ecb4065$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $d12fdcdf5ecb4065$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $d12fdcdf5ecb4065$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $d12fdcdf5ecb4065$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $d12fdcdf5ecb4065$export$2e2bcd8739ae039 = {
    __extends: $d12fdcdf5ecb4065$export$a8ba968b8961cb8a,
    __assign: $d12fdcdf5ecb4065$export$18ce0697a983be9b,
    __rest: $d12fdcdf5ecb4065$export$3c9a16f847548506,
    __decorate: $d12fdcdf5ecb4065$export$29e00dfd3077644b,
    __param: $d12fdcdf5ecb4065$export$d5ad3fd78186038f,
    __esDecorate: $d12fdcdf5ecb4065$export$3a84e1ae4e97e9b0,
    __runInitializers: $d12fdcdf5ecb4065$export$d831c04e792af3d,
    __propKey: $d12fdcdf5ecb4065$export$6a2a36740a146cb8,
    __setFunctionName: $d12fdcdf5ecb4065$export$d1a06452d3489bc7,
    __metadata: $d12fdcdf5ecb4065$export$f1db080c865becb9,
    __awaiter: $d12fdcdf5ecb4065$export$1050f835b63b671e,
    __generator: $d12fdcdf5ecb4065$export$67ebef60e6f28a6,
    __createBinding: $d12fdcdf5ecb4065$export$45d3717a4c69092e,
    __exportStar: $d12fdcdf5ecb4065$export$f33643c0debef087,
    __values: $d12fdcdf5ecb4065$export$19a8beecd37a4c45,
    __read: $d12fdcdf5ecb4065$export$8d051b38c9118094,
    __spread: $d12fdcdf5ecb4065$export$afc72e2116322959,
    __spreadArrays: $d12fdcdf5ecb4065$export$6388937ca91ccae8,
    __spreadArray: $d12fdcdf5ecb4065$export$1216008129fb82ed,
    __await: $d12fdcdf5ecb4065$export$10c90e4f7922046c,
    __asyncGenerator: $d12fdcdf5ecb4065$export$e427f37a30a4de9b,
    __asyncDelegator: $d12fdcdf5ecb4065$export$bbd80228419bb833,
    __asyncValues: $d12fdcdf5ecb4065$export$e3b29a3d6162315f,
    __makeTemplateObject: $d12fdcdf5ecb4065$export$4fb47efe1390b86f,
    __importStar: $d12fdcdf5ecb4065$export$c21735bcef00d192,
    __importDefault: $d12fdcdf5ecb4065$export$da59b14a69baef04,
    __classPrivateFieldGet: $d12fdcdf5ecb4065$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $d12fdcdf5ecb4065$export$d40a35129aaff81f,
    __classPrivateFieldIn: $d12fdcdf5ecb4065$export$81fdc39f203e4e04,
    __addDisposableResource: $d12fdcdf5ecb4065$export$88ac25d8e944e405,
    __disposeResources: $d12fdcdf5ecb4065$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $d12fdcdf5ecb4065$export$889dfb5d17574b0b
};
module.exports["__extends"] = $d12fdcdf5ecb4065$export$a8ba968b8961cb8a;
module.exports["__rest"] = $d12fdcdf5ecb4065$export$3c9a16f847548506;
module.exports["__awaiter"] = $d12fdcdf5ecb4065$export$1050f835b63b671e;
module.exports["__generator"] = $d12fdcdf5ecb4065$export$67ebef60e6f28a6;
module.exports["__exportStar"] = $d12fdcdf5ecb4065$export$f33643c0debef087;
module.exports["__values"] = $d12fdcdf5ecb4065$export$19a8beecd37a4c45;
module.exports["__read"] = $d12fdcdf5ecb4065$export$8d051b38c9118094;
module.exports["__spread"] = $d12fdcdf5ecb4065$export$afc72e2116322959;
module.exports["__spreadArrays"] = $d12fdcdf5ecb4065$export$6388937ca91ccae8;
module.exports["__spreadArray"] = $d12fdcdf5ecb4065$export$1216008129fb82ed;
module.exports["__importStar"] = $d12fdcdf5ecb4065$export$c21735bcef00d192;
module.exports["__importDefault"] = $d12fdcdf5ecb4065$export$da59b14a69baef04;

});

parcelRegister("19Cca", function(module, exports) {

var $3F3t4 = parcelRequire("3F3t4");


var $t4pTu = parcelRequire("t4pTu");

var $0d744280208d3025$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $0d744280208d3025$export$a89c95c098ac2a58 = Object.freeze({});
function $0d744280208d3025$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $0d744280208d3025$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $t4pTu.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $3F3t4.default)(node), "."));
            var visitFn = $0d744280208d3025$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $0d744280208d3025$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $t4pTu.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $0d744280208d3025$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $0d744280208d3025$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $0d744280208d3025$export$a89c95c098ac2a58) skipping[i] = $0d744280208d3025$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $0d744280208d3025$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $0d744280208d3025$export$a89c95c098ac2a58) skipping[i] = $0d744280208d3025$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $0d744280208d3025$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}
module.exports["BREAK"] = $0d744280208d3025$export$a89c95c098ac2a58;
module.exports["visit"] = $0d744280208d3025$export$bf638b60ea8b89b7;
module.exports["getVisitFn"] = $0d744280208d3025$export$c9c25cca74db6e70;
module.exports["visitInParallel"] = $0d744280208d3025$export$728beebeea393478;

});

parcelRegister("3F3t4", function(module, exports) {
$parcel$export(module.exports, "default", () => $2aa7e4185078af7e$export$2e2bcd8739ae039);

var $9Z0h9 = parcelRequire("9Z0h9");

function $2aa7e4185078af7e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2aa7e4185078af7e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2aa7e4185078af7e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2aa7e4185078af7e$var$_typeof(obj);
}
var $2aa7e4185078af7e$var$MAX_ARRAY_LENGTH = 10;
var $2aa7e4185078af7e$var$MAX_RECURSIVE_DEPTH = 2;
function $2aa7e4185078af7e$export$2e2bcd8739ae039(value) {
    return $2aa7e4185078af7e$var$formatValue(value, []);
}
function $2aa7e4185078af7e$var$formatValue(value, seenValues) {
    switch($2aa7e4185078af7e$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $2aa7e4185078af7e$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $2aa7e4185078af7e$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $2aa7e4185078af7e$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $2aa7e4185078af7e$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $2aa7e4185078af7e$var$formatArray(value, seenValues);
    return $2aa7e4185078af7e$var$formatObject(value, seenValues);
}
function $2aa7e4185078af7e$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $2aa7e4185078af7e$var$MAX_RECURSIVE_DEPTH) return '[' + $2aa7e4185078af7e$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $2aa7e4185078af7e$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $2aa7e4185078af7e$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $2aa7e4185078af7e$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($2aa7e4185078af7e$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($2aa7e4185078af7e$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $2aa7e4185078af7e$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $9Z0h9.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $2aa7e4185078af7e$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});

parcelRegister("t4pTu", function(module, exports) {

var $dVgLJ = parcelRequire("dVgLJ");

var $05762299fb1dd79e$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $dVgLJ.default)($05762299fb1dd79e$export$18a2be9195644f38);
var $05762299fb1dd79e$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $dVgLJ.default)($05762299fb1dd79e$export$50792b0e93539fde);
function $05762299fb1dd79e$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 
module.exports["Location"] = $05762299fb1dd79e$export$18a2be9195644f38;
module.exports["Token"] = $05762299fb1dd79e$export$50792b0e93539fde;
module.exports["isNode"] = $05762299fb1dd79e$export$8ee0fc9ee280b4ee;

});

parcelRegister("dVgLJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a22d9b330c2c0f63$export$2e2bcd8739ae039);

var $fzOZq = parcelRequire("fzOZq");


var $9Z0h9 = parcelRequire("9Z0h9");

function $a22d9b330c2c0f63$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $fzOZq.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $9Z0h9.default) classObject.prototype[0, $9Z0h9.default] = fn;
}

});

parcelRegister("fzOZq", function(module, exports) {
$parcel$export(module.exports, "default", () => $b571ad69acac34ba$export$2e2bcd8739ae039);
function $b571ad69acac34ba$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});

parcelRegister("2uzbP", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("5v4fk", function(module, exports) {
$parcel$export(module.exports, "Observable", () => (parcelRequire("jLTuK")).default);

var $jLTuK = parcelRequire("jLTuK");


var $7RTAm = parcelRequire("7RTAm");


var $hXuPC = parcelRequire("hXuPC");


var $guZe9 = parcelRequire("guZe9");

function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $7RTAm.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $hXuPC.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $jLTuK.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $jLTuK.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $guZe9.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $hXuPC.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $hXuPC.__assign)({}, context, next(context));
        else context = (0, $hXuPC.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $hXuPC.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $jLTuK.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $jLTuK.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $jLTuK.default).of() : rightLink.request(operation) || (0, $jLTuK.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $jLTuK.default).of() : rightLink.request(operation, forward) || (0, $jLTuK.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $jLTuK.default).of();
        }) || (0, $jLTuK.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $jLTuK.default).of();
        }) || (0, $jLTuK.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $7RTAm.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $jLTuK.default).of();
}
module.exports["fromError"] = fromError;
module.exports["ApolloLink"] = ApolloLink;
module.exports["from"] = from;
module.exports["split"] = split;
module.exports["execute"] = execute;

});

parcelRegister("lqRg6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $f9a556c702a5bce6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f9a556c702a5bce6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f9a556c702a5bce6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f9a556c702a5bce6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f9a556c702a5bce6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $f9a556c702a5bce6$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $f9a556c702a5bce6$var$hasSymbol = function(name) {
    return $f9a556c702a5bce6$var$hasSymbols() && Boolean(Symbol[name]);
};
var $f9a556c702a5bce6$var$getSymbol = function(name) {
    return $f9a556c702a5bce6$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($f9a556c702a5bce6$var$hasSymbols() && !$f9a556c702a5bce6$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $f9a556c702a5bce6$var$SymbolIterator = $f9a556c702a5bce6$var$getSymbol('iterator');
var $f9a556c702a5bce6$var$SymbolObservable = $f9a556c702a5bce6$var$getSymbol('observable');
var $f9a556c702a5bce6$var$SymbolSpecies = $f9a556c702a5bce6$var$getSymbol('species'); // === Abstract Operations ===
function $f9a556c702a5bce6$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $f9a556c702a5bce6$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$f9a556c702a5bce6$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $f9a556c702a5bce6$var$Observable;
}
function $f9a556c702a5bce6$var$isObservable(x) {
    return x instanceof $f9a556c702a5bce6$var$Observable; // SPEC: Brand check
}
function $f9a556c702a5bce6$var$hostReportError(e) {
    if ($f9a556c702a5bce6$var$hostReportError.log) $f9a556c702a5bce6$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $f9a556c702a5bce6$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $f9a556c702a5bce6$var$hostReportError(e);
        }
    });
}
function $f9a556c702a5bce6$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $f9a556c702a5bce6$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $f9a556c702a5bce6$var$hostReportError(e);
    }
}
function $f9a556c702a5bce6$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $f9a556c702a5bce6$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $f9a556c702a5bce6$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $f9a556c702a5bce6$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $f9a556c702a5bce6$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $f9a556c702a5bce6$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $f9a556c702a5bce6$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $f9a556c702a5bce6$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $f9a556c702a5bce6$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $f9a556c702a5bce6$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $f9a556c702a5bce6$var$enqueue(function() {
            return $f9a556c702a5bce6$var$flushSubscription(subscription);
        });
        return;
    }
    $f9a556c702a5bce6$var$notifySubscription(subscription, type, value);
}
var $f9a556c702a5bce6$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $f9a556c702a5bce6$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $f9a556c702a5bce6$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $f9a556c702a5bce6$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $f9a556c702a5bce6$var$closeSubscription(this);
                    $f9a556c702a5bce6$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $f9a556c702a5bce6$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $f9a556c702a5bce6$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $f9a556c702a5bce6$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $f9a556c702a5bce6$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $f9a556c702a5bce6$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $f9a556c702a5bce6$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $f9a556c702a5bce6$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $f9a556c702a5bce6$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $f9a556c702a5bce6$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $f9a556c702a5bce6$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f9a556c702a5bce6$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f9a556c702a5bce6$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f9a556c702a5bce6$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $f9a556c702a5bce6$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f9a556c702a5bce6$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $f9a556c702a5bce6$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $f9a556c702a5bce6$var$getMethod(x, $f9a556c702a5bce6$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($f9a556c702a5bce6$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($f9a556c702a5bce6$var$hasSymbol('iterator')) {
                    method = $f9a556c702a5bce6$var$getMethod(x, $f9a556c702a5bce6$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $f9a556c702a5bce6$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $f9a556c702a5bce6$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $f9a556c702a5bce6$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $f9a556c702a5bce6$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $f9a556c702a5bce6$var$Observable;
if ($f9a556c702a5bce6$var$hasSymbols()) Object.defineProperty($f9a556c702a5bce6$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $f9a556c702a5bce6$var$SymbolObservable,
        hostReportError: $f9a556c702a5bce6$var$hostReportError
    },
    configurable: true
});

});

parcelRegister("1hmzn", function(module, exports) {
/* global window */ function $7b5eaa28af0b0243$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}


var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $7b5eaa28af0b0243$export$2e2bcd8739ae039)(root);
var $0ee8e2d22601f000$export$2e2bcd8739ae039 = result;
module.exports["default"] = $0ee8e2d22601f000$export$2e2bcd8739ae039;

});

parcelRegister("8H5XZ", function(module, exports) {

var $aAxiE = parcelRequire("aAxiE");

function $82406df716527994$export$d54488e5d0ecaef7(value) {
    return value instanceof (0, $aAxiE.GraphQLError);
}
module.exports["isGraphQLError"] = $82406df716527994$export$d54488e5d0ecaef7;

});

parcelRegister("aAxiE", function(module, exports) {

var $6mpIf = parcelRequire("6mpIf");


var $2l5ss = parcelRequire("2l5ss");


var $kdJ3v = parcelRequire("kdJ3v");

/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $966d2f93d01e827d$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}



function $e5264c88a63c9f37$export$96a9681e539deed(location) {
    return $e5264c88a63c9f37$export$867940333fd9f869(location.source, (0, $966d2f93d01e827d$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $e5264c88a63c9f37$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $e5264c88a63c9f37$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $e5264c88a63c9f37$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $e5264c88a63c9f37$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $e5264c88a63c9f37$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $e5264c88a63c9f37$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $e5264c88a63c9f37$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $e5264c88a63c9f37$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $e5264c88a63c9f37$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $e5264c88a63c9f37$var$leftPad(len, str) {
    return $e5264c88a63c9f37$var$whitespace(len - str.length) + str;
}


function $7b5718d74178270e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7b5718d74178270e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7b5718d74178270e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7b5718d74178270e$var$_typeof(obj);
}
function $7b5718d74178270e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7b5718d74178270e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7b5718d74178270e$var$ownKeys(Object(source), true).forEach(function(key) {
            $7b5718d74178270e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7b5718d74178270e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7b5718d74178270e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7b5718d74178270e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7b5718d74178270e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7b5718d74178270e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7b5718d74178270e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7b5718d74178270e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $7b5718d74178270e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $7b5718d74178270e$var$_setPrototypeOf(subClass, superClass);
}
function $7b5718d74178270e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7b5718d74178270e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7b5718d74178270e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7b5718d74178270e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7b5718d74178270e$var$_possibleConstructorReturn(this, result);
    };
}
function $7b5718d74178270e$var$_possibleConstructorReturn(self, call) {
    if (call && ($7b5718d74178270e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $7b5718d74178270e$var$_assertThisInitialized(self);
}
function $7b5718d74178270e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7b5718d74178270e$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $7b5718d74178270e$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$7b5718d74178270e$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $7b5718d74178270e$var$_construct(Class, arguments, $7b5718d74178270e$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $7b5718d74178270e$var$_setPrototypeOf(Wrapper, Class);
    };
    return $7b5718d74178270e$var$_wrapNativeSuper(Class);
}
function $7b5718d74178270e$var$_construct(Parent, args, Class) {
    if ($7b5718d74178270e$var$_isNativeReflectConstruct()) $7b5718d74178270e$var$_construct = Reflect.construct;
    else $7b5718d74178270e$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $7b5718d74178270e$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $7b5718d74178270e$var$_construct.apply(null, arguments);
}
function $7b5718d74178270e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7b5718d74178270e$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $7b5718d74178270e$var$_setPrototypeOf(o, p) {
    $7b5718d74178270e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7b5718d74178270e$var$_setPrototypeOf(o, p);
}
function $7b5718d74178270e$var$_getPrototypeOf(o) {
    $7b5718d74178270e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7b5718d74178270e$var$_getPrototypeOf(o);
}
var $7b5718d74178270e$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $7b5718d74178270e$var$_inherits(GraphQLError, _Error);
    var _super = $7b5718d74178270e$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $7b5718d74178270e$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $7b5718d74178270e$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $7b5718d74178270e$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $966d2f93d01e827d$export$e7fd20fad3cf4b5f)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $966d2f93d01e827d$export$e7fd20fad3cf4b5f)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $2l5ss.default)(originalExtensions)) _this.extensions = $7b5718d74178270e$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($7b5718d74178270e$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($7b5718d74178270e$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $7b5718d74178270e$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($7b5718d74178270e$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($7b5718d74178270e$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $7b5718d74178270e$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $7b5718d74178270e$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $7b5718d74178270e$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $kdJ3v.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $7b5718d74178270e$var$_wrapNativeSuper(Error));
function $7b5718d74178270e$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $7b5718d74178270e$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $e5264c88a63c9f37$export$96a9681e539deed)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $e5264c88a63c9f37$export$867940333fd9f869)(error.source, location);
    }
    return output;
}
function $7b5718d74178270e$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $6mpIf.default)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 
module.exports["GraphQLError"] = $7b5718d74178270e$export$92d6ed0888e7cb7f;

});

parcelRegister("6mpIf", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a18be2174f7e2de$export$2e2bcd8739ae039);
function $4a18be2174f7e2de$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("2l5ss", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b41c6ca9814f962$export$2e2bcd8739ae039);
function $1b41c6ca9814f962$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1b41c6ca9814f962$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1b41c6ca9814f962$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1b41c6ca9814f962$var$_typeof(obj);
}
function $1b41c6ca9814f962$export$2e2bcd8739ae039(value) {
    return $1b41c6ca9814f962$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("kdJ3v", function(module, exports) {
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $eb87f8a2225ce74c$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $eb87f8a2225ce74c$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $eb87f8a2225ce74c$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';
module.exports["SYMBOL_ITERATOR"] = $eb87f8a2225ce74c$export$f6cdee3c26d6da57;
module.exports["SYMBOL_TO_STRING_TAG"] = $eb87f8a2225ce74c$export$5deadc579ccc7c9c;

});

parcelRegister("flE5X", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");

class $97ab40fc05a809aa$export$79f50640f30c1c0e extends (0, $6fil2.NetworkError) {
    constructor(...args){
        super(...args);
        /**
     * If the call site of `cfetch` has indicated that `NoNetworkError`s are to be
     * ignored by handlers, then `true`; otherwise, `false` or `undefined`.
     */ this.ignore = void 0;
        /**
     * Indicates whether the error was exposed to the feature gate `platform_editor_bubble_cfe_gql_network_errors`
     * and subsequently bubbled up to the client. This property is used to track errors originating from this
     * feature gate in analytics events.
     *
     * Note: This property is temporary and may be removed during the cleanup of the feature gate.
     */ this.wasBubbledUp = void 0;
    }
}
module.exports["NoNetworkError"] = $97ab40fc05a809aa$export$79f50640f30c1c0e;

});

parcelRegister("8pZFw", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");

const $7671de4d2b536449$var$RATE_LIMIT_TEXT_MARK = 'rate limit exceeded';
class $7671de4d2b536449$export$b5f929f4d77c16a9 extends (0, $hBkCm.BadStatusError) {
    constructor(message, response){
        super(`${message} ${$7671de4d2b536449$var$RATE_LIMIT_TEXT_MARK}`, response);
    }
}
module.exports["RateLimitedError"] = $7671de4d2b536449$export$b5f929f4d77c16a9;

});

parcelRegister("14DR2", function(module, exports) {
function $92ce0641c5e05da2$export$bee20cbc27fea50(headers, headerName, headerValue) {
    if (Array.isArray(headers)) {
        headers.push([
            headerName,
            headerValue
        ]);
        return;
    }
    if (headers instanceof Headers) {
        headers.append(headerName, headerValue);
        return;
    }
    headers[headerName] = headerValue;
}
module.exports["appendHeader"] = $92ce0641c5e05da2$export$bee20cbc27fea50;

});

parcelRegister("3P4tJ", function(module, exports) {
function $82686a09d9ecb1b0$export$149b1181d497cd(headers, headerName) {
    if (Array.isArray(headers)) {
        const header = headers.find(([name])=>name === headerName);
        return header ? header[1] : null;
    }
    if (headers instanceof Headers) return headers.get(headerName);
    return headers[headerName] ?? null;
}
module.exports["getHeaderValue"] = $82686a09d9ecb1b0$export$149b1181d497cd;

});

parcelRegister("c0BL4", function(module, exports) {
const $ef04b7af4a33fe58$export$1fccf6c6ebec28fe = 'X-Atl-Experience';
const $ef04b7af4a33fe58$export$ecc9e1785213e182 = 'X-Atl-Experience-Id';
module.exports["X_ATL_EXPERIENCE"] = $ef04b7af4a33fe58$export$1fccf6c6ebec28fe;
module.exports["X_ATL_EXPERIENCE_ID"] = $ef04b7af4a33fe58$export$ecc9e1785213e182;

});

parcelRegister("lqJ5I", function(module, exports) {
class $59e0c8d2e847e31f$var$FrontendNetworkTracker {
    // Called from createWrappedFetch for each individual operation
    trackGraphQLOperations(operationNames) {
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (typeof window === 'undefined') return;
        operationNames.forEach(()=>{
            this.stats.totalOperations++;
        });
    }
    // Called from cfetch for REST calls
    trackRestCall(_url) {
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (typeof window === 'undefined') return;
        this.stats.totalOperations++;
    }
    getStats() {
        return {
            ...this.stats
        };
    }
    reset() {
        this.stats = {
            totalOperations: 0
        };
    }
    constructor(){
        this.stats = {
            totalOperations: 0
        };
    }
}
const $59e0c8d2e847e31f$export$9a57a9973e788640 = new $59e0c8d2e847e31f$var$FrontendNetworkTracker();
module.exports["networkTracker"] = $59e0c8d2e847e31f$export$9a57a9973e788640;

});

parcelRegister("kl90G", function(module, exports) {

let $ececc203a288be66$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ececc203a288be66$var$load("8eYa0"),
    $ececc203a288be66$var$load("ladkM"),
    $ececc203a288be66$var$load("e1Z8a")
]).then(()=>parcelRequire('dQOC0'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("gAHXO", function(module, exports) {

let $c1421c6840721a39$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c1421c6840721a39$var$load("iEydq").then(()=>parcelRequire('cOKrX'));

});

parcelRegister("d8fmB", function(module, exports) {

let $98f7f09de5bda26c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $98f7f09de5bda26c$var$load("axJvf").then(()=>parcelRequire('fjRfo'));

});

parcelRegister("5cVJq", function(module, exports) {

let $3caadb0ae57bdaa3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3caadb0ae57bdaa3$var$load("82zLI").then(()=>parcelRequire('hwSGt'));

});

parcelRegister("q03Nf", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $04e279c5ff710cda$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $04e279c5ff710cda$var$invariant;

});

parcelRegister("a9sR2", function(module, exports) {

var $5DUgU = parcelRequire("5DUgU");




class $5401be2930f14104$export$2e2bcd8739ae039 {
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
    constructor(){
        this._callbacks = void 0;
        this._hidden = void 0;
        this._isHidden = void 0;
        this._visibilityChange = void 0;
        this._bindEventListeners = ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
}


class $e78379f44c50158e$export$2e2bcd8739ae039 {
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
    constructor(){
        this._performance = void 0;
        this._performance = window.performance;
    }
}


class $a4b812cbc3a59940$export$2e2bcd8739ae039 {
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent({
            ...event,
            ...apdexFields,
            ...visibilityFields
        }, callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
    constructor(onEvent, pageVisibility){
        this._isActiveEvents = void 0;
        this._onEvent = void 0;
        this._pageVisibility = void 0;
        this._performance = void 0;
        this._startedEvents = void 0;
        this._threshold = void 0;
        this._wasPreviouslyHidden = void 0;
        this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
        this._getEventTimingByName = (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return {
                ...apdexTimings,
                apdex: apdexScore
            };
        };
        this._getApdexTimings = (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $5DUgU.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
        this._cleanApdexState = (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $5DUgU.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $5DUgU.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        };
        this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $5DUgU.isType)((0, $5DUgU.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $5DUgU.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: {
                    ...event.additionalAttributes,
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                }
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $5401be2930f14104$export$2e2bcd8739ae039))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $e78379f44c50158e$export$2e2bcd8739ae039)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
}


/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $29a361f5f1eed66e$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $29a361f5f1eed66e$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($29a361f5f1eed66e$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};



var $a4UIB = parcelRequire("a4UIB");

var $26AWB = parcelRequire("26AWB");
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
const $9545d40999c42e94$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom'
];



var $dh538 = parcelRequire("dh538");





var $6Pcds = parcelRequire("6Pcds");


var $ewjj9 = parcelRequire("ewjj9");

const $945a6126a5ece0de$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $945a6126a5ece0de$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $945a6126a5ece0de$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $6Pcds.parseUrl)(removedFragmentURL);
    const captureParams = (0, $ewjj9.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $ewjj9.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $6Pcds.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $945a6126a5ece0de$export$2e2bcd8739ae039 = $945a6126a5ece0de$var$urlParamExtractor;


const $8862ca24f3715e5d$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $26AWB.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class $8862ca24f3715e5d$export$2e2bcd8739ae039 {
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
   * Validates the cross product interaction session parameters parsed from the URL (if present)
   * If the Base64-encoded URL does not decode into a valid JSON object
   *
   * This method must be called out of the constructor, as the sendEventCallback we expect here
   * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
   */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
    constructor(options){
        this.analyticsCrossProductInteractionClient = void 0;
        this.isEnabled = void 0;
        this.urlValidation = void 0;
        this.sendEventCallback = void 0;
        this.validProduct = false;
        this.isEnabled = (0, $dh538.fg)('analytics_cross_product_interaction_tracking') && options.perimeter !== (0, $5DUgU.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $9545d40999c42e94$export$b1e8b4360a046e61).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $945a6126a5ece0de$export$2e2bcd8739ae039)($8862ca24f3715e5d$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $26AWB.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $26AWB.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch  {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $a4UIB.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
}





const $a12ec36efbd18e1b$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $5DUgU.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};
const $a12ec36efbd18e1b$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $5DUgU.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};









var $bKFjF = parcelRequire("bKFjF");

const $7599af0b503dbd64$var$libraryVersion = "0.0.0-use.local";
function $7599af0b503dbd64$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $7599af0b503dbd64$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $7599af0b503dbd64$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $7599af0b503dbd64$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $7599af0b503dbd64$var$buildAliases(aliases) {
    if ($7599af0b503dbd64$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $7599af0b503dbd64$var$buildGroups(groups) {
    if ($7599af0b503dbd64$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $7599af0b503dbd64$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $7599af0b503dbd64$var$buildInteractionSession(properties) {
    // TODO: Once feature flag is removed this function can be removed and the property
    // directly added at the top level in the buildActionEvent and buildScreenEvent functions
    if ((0, $dh538.fg)('analytics_cross_product_interaction_tracking')) return {
        interactionSession: properties
    };
    return undefined;
}
function $7599af0b503dbd64$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $7599af0b503dbd64$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $7599af0b503dbd64$var$getProductField(productInfo.env, overrides.env);
    const product = $7599af0b503dbd64$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $7599af0b503dbd64$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $7599af0b503dbd64$var$getProductField(productInfo.version, overrides.version);
    const origin = $7599af0b503dbd64$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $7599af0b503dbd64$var$getProductField(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic
    };
}
function $7599af0b503dbd64$var$isNotEmptyObject(obj) {
    return (0, $bKFjF.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $7599af0b503dbd64$var$buildAttributesWithName(name, attrObject) {
    return $7599af0b503dbd64$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $7599af0b503dbd64$var$buildAttributes(attributes) {
    return $7599af0b503dbd64$var$buildAttributesWithName('attributes', attributes);
}
function $7599af0b503dbd64$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $7599af0b503dbd64$export$f045f238d77c002a(containers) {
    if ($7599af0b503dbd64$var$isNotEmptyObject(containers)) {
        const validContainers = $7599af0b503dbd64$export$3f5115a568819c1a(containers);
        return $7599af0b503dbd64$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $7599af0b503dbd64$export$655ecf7241feac42(event, actionEventType) {
    return {
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType,
        ...$7599af0b503dbd64$export$f045f238d77c002a(event.containers)
    };
}
function $7599af0b503dbd64$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $7599af0b503dbd64$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $7599af0b503dbd64$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $7599af0b503dbd64$var$buildProductFields(productInfo);
    const tenantFields = $7599af0b503dbd64$var$buildTenantFields(tenantInfo);
    const userFields = $7599af0b503dbd64$var$buildUserFields(userInfo);
    const orgFields = $7599af0b503dbd64$var$buildOrgFields(orgInfo);
    const workspaceFields = $7599af0b503dbd64$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $5DUgU.eventType).SCREEN
    };
    return {
        ...productFields,
        ...tenantFields,
        ...userFields,
        ...orgFields,
        ...overrides,
        ...$7599af0b503dbd64$var$buildAttributes(attributes),
        ...$7599af0b503dbd64$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
        ...$7599af0b503dbd64$export$f045f238d77c002a(containers),
        ...$7599af0b503dbd64$var$buildEventOverrides(event),
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        ...$7599af0b503dbd64$var$buildInteractionSession(interactionSession),
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...$7599af0b503dbd64$var$buildAliases(aliases),
        ...$7599af0b503dbd64$var$buildGroups(groups)
    };
}
function $7599af0b503dbd64$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
var $7599af0b503dbd64$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $7599af0b503dbd64$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return "quiet";
    if (environment.includes('prod')) return "quiet";
    return "complete";
}
function $7599af0b503dbd64$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $7599af0b503dbd64$var$libraryVersion
            },
            validationMode: $7599af0b503dbd64$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $7599af0b503dbd64$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $7599af0b503dbd64$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $7599af0b503dbd64$var$buildProductFields(productInfo, $7599af0b503dbd64$export$e3d99b4bfec06f6e(event));
    const tenantFields = $7599af0b503dbd64$var$buildTenantFields(tenantInfo);
    const orgFields = $7599af0b503dbd64$var$buildOrgFields(orgInfo);
    const workspaceFields = $7599af0b503dbd64$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $7599af0b503dbd64$var$buildUserFields(userInfo);
    const actionFields = $7599af0b503dbd64$export$655ecf7241feac42(event, actionEventType);
    return {
        ...productFields,
        ...tenantFields,
        ...orgFields,
        ...userFields,
        ...actionFields,
        ...$7599af0b503dbd64$var$buildEventOverrides(event),
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        ...$7599af0b503dbd64$var$buildInteractionSession(interactionSession),
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...$7599af0b503dbd64$var$buildAliases(aliases),
        ...$7599af0b503dbd64$var$buildGroups(groups)
    };
}


const $1de1af54ad722408$export$cf090d5281b5ae06 = 10000;
const $1de1af54ad722408$export$8575e30be0feb909 = 30000;






/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ 




var $iSMQS = parcelRequire("iSMQS");

class $1bea471a7c54f53e$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        this.compressionRules = void 0;
        this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
        this.compress = (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        };
        this.createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $7599af0b503dbd64$export$655ecf7241feac42)(event, event.eventType);
                    contextFields = (0, $ewjj9.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $ewjj9.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []);
        this.compressGroup = (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>({
                        ...actionFields,
                        ...group.contextFields
                    }));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        };
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $iSMQS.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}


// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $447d46b89aa14820$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $447d46b89aa14820$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $447d46b89aa14820$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        this.compressor = void 0;
        this.eventArgs = void 0;
        this.flushBatchTimeout = void 0;
        this.processFn = void 0;
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        };
        this.size = ()=>this.eventArgs.length;
        this.startFlush = ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        };
        this.cancelFlush = ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        };
        this.flushNextBatch = ()=>{
            const batch = this.eventArgs.splice(0, $447d46b89aa14820$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $447d46b89aa14820$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        };
        this.compressEventArgs = (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $ewjj9.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $ewjj9.equals)(group.userInfo, args.userInfo) && (0, $ewjj9.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $7599af0b503dbd64$export$9c5623a792efc9b0)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        };
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $1bea471a7c54f53e$export$2e2bcd8739ae039)(compressionRules);
    }
}



var $jFax1 = parcelRequire("jFax1");

class $fa4b133ceb32e864$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        this.delayQueue = void 0;
        this.delayTimeout = void 0;
        this.delayCallback = void 0;
        this.isDelaying = void 0;
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        };
        this.startLowPriorityEventDelay = (timeout = (0, $1de1af54ad722408$export$cf090d5281b5ae06), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $1de1af54ad722408$export$8575e30be0feb909)) : (0, $1de1af54ad722408$export$8575e30be0feb909);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $jFax1.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        };
        this.stopLowPriorityEventDelay = (reason = (0, $jFax1.StopLowPriorityEventDelayReason).MANUAL)=>{
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            this.delayCallback?.(reason);
            this.delayCallback = undefined;
        };
        this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
        this.isDelaying = false;
        this.delayQueue = new (0, $447d46b89aa14820$export$2e2bcd8739ae039)(fireDelayedEvent, compressors);
    }
}



var $epqyT = parcelRequire("epqyT");

var $810aef977e468468$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $810aef977e468468$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});



const $31e8ba78da167a43$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $810aef977e468468$export$ecfa71cbc9b28241).ACK]: `${queuePrefix}.${queueId}.${(0, $810aef977e468468$export$ecfa71cbc9b28241).ACK}`,
        [(0, $810aef977e468468$export$ecfa71cbc9b28241).QUEUE]: `${queuePrefix}.${queueId}.${(0, $810aef977e468468$export$ecfa71cbc9b28241).QUEUE}`,
        [(0, $810aef977e468468$export$ecfa71cbc9b28241).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $810aef977e468468$export$ecfa71cbc9b28241).IN_PROGRESS}`,
        [(0, $810aef977e468468$export$ecfa71cbc9b28241).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $810aef977e468468$export$ecfa71cbc9b28241).RECLAIM_START}`,
        [(0, $810aef977e468468$export$ecfa71cbc9b28241).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $810aef977e468468$export$ecfa71cbc9b28241).RECLAIM_END}`
    });


// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $1de69a39d0b1f5d2$var$validSuffixs = Object.values((0, $810aef977e468468$export$ecfa71cbc9b28241));
var $1de69a39d0b1f5d2$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $1de69a39d0b1f5d2$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $810aef977e468468$export$ecfa71cbc9b28241).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $31e8ba78da167a43$export$8433d54f767cbec5)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};



const $a21ab0356ac08551$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $a21ab0356ac08551$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $810aef977e468468$export$ecfa71cbc9b28241).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $810aef977e468468$export$8bb2c1fb2b1765a9).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $a21ab0356ac08551$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $a21ab0356ac08551$var$promisedSetTimeout((0, $810aef977e468468$export$8bb2c1fb2b1765a9).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $810aef977e468468$export$8bb2c1fb2b1765a9).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $a21ab0356ac08551$var$promisedSetTimeout((0, $810aef977e468468$export$8bb2c1fb2b1765a9).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $810aef977e468468$export$8bb2c1fb2b1765a9).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $a21ab0356ac08551$var$reclaim(options, callback);
};
const $a21ab0356ac08551$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = {
            ...item,
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        };
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $a21ab0356ac08551$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $a21ab0356ac08551$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $a21ab0356ac08551$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $a21ab0356ac08551$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = crypto.randomUUID();
    const queuesToReclaim = $a21ab0356ac08551$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$a21ab0356ac08551$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $31e8ba78da167a43$export$8433d54f767cbec5)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};



var $a2LhX = parcelRequire("a2LhX");

var $abcF7 = parcelRequire("abcF7");

const $ca7ec8e55be33d55$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $ca7ec8e55be33d55$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $ca7ec8e55be33d55$export$2e2bcd8739ae039.prototype);
        this.name = $ca7ec8e55be33d55$export$fc14cf6dcea0f8ed;
    }
}

const $d395f595a54ad6ce$export$ba95206613c96b28 = 'AbandonWriteError';
class $d395f595a54ad6ce$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $d395f595a54ad6ce$export$2e2bcd8739ae039.prototype);
        this.name = $d395f595a54ad6ce$export$ba95206613c96b28;
    }
}





const $6052bdbaad264038$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $6052bdbaad264038$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $6052bdbaad264038$export$7e7aee9a953465ec;
    }
}


const $8f3ccf74a1ef98ac$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $d395f595a54ad6ce$export$ba95206613c96b28) || errorWithName.name === (0, $a2LhX.CallbackProcessingErrorName) || errorWithName.name === (0, $6052bdbaad264038$export$7e7aee9a953465ec));
    }
    return false;
};





const $ac25b5ff880ec5b8$export$b6df3d334cec060f = 7;
const $ac25b5ff880ec5b8$export$14ef152a03a4b6ee = 60000;
const $ac25b5ff880ec5b8$export$da9ab7b2fd5998e8 = 10;
const $ac25b5ff880ec5b8$export$1188664dfff364c8 = 5000;










const $b64847155b9e134b$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || crypto.randomUUID(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $b64847155b9e134b$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $ac25b5ff880ec5b8$export$da9ab7b2fd5998e8),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $ac25b5ff880ec5b8$export$1188664dfff364c8)
    });
const $b64847155b9e134b$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $b64847155b9e134b$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $b64847155b9e134b$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $b64847155b9e134b$export$2a5213bce1720b42(transaction);
};
const $b64847155b9e134b$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};


class $bc5734d26b96ca81$export$2e2bcd8739ae039 {
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $abcF7.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $abcF7.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $abcF7.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $abcF7.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $b64847155b9e134b$export$85ceed0783e42041)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $b64847155b9e134b$export$feab8418f018df89)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $d395f595a54ad6ce$export$2e2bcd8739ae039)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $abcF7.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $b64847155b9e134b$export$85ceed0783e42041)(request);
        return event.target.result;
    }
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        this.eventLimit = void 0;
        this.namespace = void 0;
        this.logger = void 0;
        this.deleteItemHandler = void 0;
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ this.deleteOldestNEvents = async (objectStore, count)=>{
            const productTimeAddedIndex = objectStore.index((0, $abcF7.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $b64847155b9e134b$export$85ceed0783e42041)(getAllRequest);
            const result = event?.target?.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
}



class $c9c6c49af4b53e48$export$2e2bcd8739ae039 {
    storeType() {
        return (0, $abcF7.StoreType).INDEXEDDB;
    }
    constructor(_namespace, _options = {}){
        this.db = void 0;
        this.logger = void 0;
        this.globalEventLimitGuard = void 0;
        this.options = void 0;
        this.namespace = void 0;
        this.startDB = async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $ca7ec8e55be33d55$export$2e2bcd8739ae039)());
                    }, (0, $abcF7.INDEXEDDB_TIMEOUT));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $abcF7.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $abcF7.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $abcF7.TIME_TO_PROCESS_AFTER_INDEX), (0, $abcF7.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $abcF7.RETRY_INDEX), (0, $abcF7.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $abcF7.TIME_ADDED_INDEX), (0, $abcF7.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $abcF7.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $ca7ec8e55be33d55$export$2e2bcd8739ae039)());
                    };
                    try {
                        await (0, $b64847155b9e134b$export$85ceed0783e42041)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $ca7ec8e55be33d55$export$2e2bcd8739ae039)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $ca7ec8e55be33d55$export$2e2bcd8739ae039)());
                }
            });
        };
        this.addItem = async (item, options = {}, policy = (0, $abcF7.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $b64847155b9e134b$export$aec476f33d77be11)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $abcF7.GuardPolicy).IGNORE) throw new (0, $6052bdbaad264038$export$2e2bcd8739ae039)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $8f3ccf74a1ef98ac$export$74101021e0969375)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.bulkAddItem = async (itemOptions, policy = (0, $abcF7.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map(({ item: item, ...options })=>(0, $b64847155b9e134b$export$aec476f33d77be11)(item, namespace, options));
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $8f3ccf74a1ef98ac$export$74101021e0969375)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.getItems = async (count = (0, $ac25b5ff880ec5b8$export$b6df3d334cec060f))=>{
            const fixedCount = count > 0 ? count : (0, $ac25b5ff880ec5b8$export$b6df3d334cec060f);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $abcF7.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = {
                            ...cursor.value
                        };
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $ac25b5ff880ec5b8$export$14ef152a03a4b6ee);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $b64847155b9e134b$export$342d941b6f724995)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $b64847155b9e134b$export$342d941b6f724995)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $b64847155b9e134b$export$feab8418f018df89)(transaction, this.logger);
            return getResult;
        };
        this.deleteItems = async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $b64847155b9e134b$export$feab8418f018df89)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        this.getItemCount = async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $abcF7.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $b64847155b9e134b$export$85ceed0783e42041)(request);
            await (0, $b64847155b9e134b$export$feab8418f018df89)(transaction, this.logger);
            return event.target.result;
        };
        this.processItems = async (processFn, count = (0, $ac25b5ff880ec5b8$export$b6df3d334cec060f))=>{
            const { items: items, ...partialResult } = await this.getItems(count);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $a2LhX.default)(error);
            }
        };
        this.deleteItem = async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $b64847155b9e134b$export$85ceed0783e42041)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        };
        this.getObjectStoreAndTransaction = async (mode)=>{
            const transaction = (await this.db).transaction((0, $abcF7.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $abcF7.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        };
        this.options = (0, $b64847155b9e134b$export$ddc6718318090f71)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $ca7ec8e55be33d55$export$2e2bcd8739ae039)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $bc5734d26b96ca81$export$2e2bcd8739ae039)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
}













class $cbf01c485b1751ff$export$2e2bcd8739ae039 {
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $d395f595a54ad6ce$export$2e2bcd8739ae039)((0, $abcF7.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
    constructor(eventLimit, memoryItemHandlers){
        this.eventLimit = void 0;
        this.memoryItemHandlers = void 0;
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $abcF7.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $abcF7.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $abcF7.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
}



class $702d2cb9e96a32fb$export$2e2bcd8739ae039 {
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $abcF7.GuardPolicy).ABANDON) {
        if (policy === (0, $abcF7.GuardPolicy).IGNORE) throw new (0, $6052bdbaad264038$export$2e2bcd8739ae039)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $b64847155b9e134b$export$aec476f33d77be11)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $abcF7.GuardPolicy).ABANDON) {
        const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $b64847155b9e134b$export$aec476f33d77be11)(item, this.namespace, addOptions));
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $abcF7.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $ac25b5ff880ec5b8$export$b6df3d334cec060f)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $ac25b5ff880ec5b8$export$b6df3d334cec060f)) {
        const fixedCount = count > 0 ? count : (0, $ac25b5ff880ec5b8$export$b6df3d334cec060f);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push({
                    ...wrappedItem
                });
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $ac25b5ff880ec5b8$export$14ef152a03a4b6ee);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $a2LhX.default)(error);
        }
    }
    storeType() {
        return (0, $abcF7.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
    constructor(namespace, options = {}){
        this.memoryStore = void 0;
        this.options = void 0;
        this.globalEventLimitGuard = void 0;
        this.namespace = void 0;
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $b64847155b9e134b$export$ddc6718318090f71)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $cbf01c485b1751ff$export$2e2bcd8739ae039)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
}



class $0bee71b2ddcd8462$export$2e2bcd8739ae039 {
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $c9c6c49af4b53e48$export$2e2bcd8739ae039)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $ca7ec8e55be33d55$export$2e2bcd8739ae039))) options.logger?.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
        }
        return new (0, $702d2cb9e96a32fb$export$2e2bcd8739ae039)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $abcF7.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $abcF7.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $8f3ccf74a1ef98ac$export$74101021e0969375)(error)) throw error;
            else if (this.resilience.storeType() === (0, $abcF7.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $702d2cb9e96a32fb$export$2e2bcd8739ae039)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $abcF7.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
    constructor(namespace, options = {}){
        this.resilience = void 0;
        this.options = void 0;
        this.namespace = void 0;
        this.namespace = namespace;
        this.options = (0, $b64847155b9e134b$export$ddc6718318090f71)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
}








var $19ba44361c624334$export$2e2bcd8739ae039 = (0, $0bee71b2ddcd8462$export$2e2bcd8739ae039);





var $hVXIk = parcelRequire("hVXIk");

class $36fd87bc225a2648$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, $hVXIk.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
}
let $36fd87bc225a2648$var$cachedMetricsClient = null;
var $36fd87bc225a2648$export$2e2bcd8739ae039 = ()=>{
    if (!$36fd87bc225a2648$var$cachedMetricsClient) $36fd87bc225a2648$var$cachedMetricsClient = new $36fd87bc225a2648$export$4b62ee5120ab50a8();
    return $36fd87bc225a2648$var$cachedMetricsClient;
};





class $7583c71c35f1b55e$export$2e2bcd8739ae039 {
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $hVXIk.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $hVXIk.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $hVXIk.NetworkStatusEnum).ONLINE;
        return (0, $hVXIk.NetworkStatusEnum).OFFLINE;
    }
    constructor(networkChangeCallback){
        this._networkChangeCallback = void 0;
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $hVXIk.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $hVXIk.NetworkStatusEnum).ONLINE));
        }
    }
}


var $633697aac9c9f6a8$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $633697aac9c9f6a8$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $633697aac9c9f6a8$export$590a718599f8f8b3 {
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
    constructor(timeoutPeriod){
        // Milliseconds to wait
        this.timeoutPeriod = void 0;
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
}


// Clients can optionally provide the callbackTimeoutPeriod parameter
var $22268497503b9859$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});


const $075a1d94af401b85$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $075a1d94af401b85$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $075a1d94af401b85$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        this.callback = void 0;
        this.failureCount = void 0;
        this.operationInFlight = void 0;
        this.options = void 0;
        this.queuedSchedule = void 0;
        this.scheduledTimeout = void 0;
        this.callbackTimer = void 0;
        this.schedule = ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = 1;
                else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        };
        this.stop = ()=>{
            this.clearTimeout();
            this.queuedSchedule = 0;
        };
        this.getFailureCount = ()=>this.failureCount;
        this.getCallbackStatus = ()=>{
            return this.callbackTimer.getCallbackStatus();
        };
        this.clearTimeout = ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        };
        this.run = ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $22268497503b9859$export$f93c40fda808dd0c).ERROR));
            } catch (err) {
                this.done(err);
            }
        };
        this.done = (state)=>{
            this.operationInFlight = false;
            if (state === (0, $22268497503b9859$export$f93c40fda808dd0c).ERROR || this.callbackTimer.getCallbackStatus() === (0, $633697aac9c9f6a8$export$ef3353088fca369c).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $22268497503b9859$export$f93c40fda808dd0c).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        };
        this.processQueuedSchedule = ()=>{
            if (this.queuedSchedule !== 0) {
                const immediate = this.queuedSchedule === 1;
                this.queuedSchedule = 0;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        };
        this.calculateBackoff = ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        };
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $075a1d94af401b85$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $075a1d94af401b85$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $075a1d94af401b85$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $075a1d94af401b85$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $075a1d94af401b85$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $075a1d94af401b85$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, $633697aac9c9f6a8$export$590a718599f8f8b3)(this.options.callbackTimeoutPeriod);
    }
}





const $fce38ef6e3eb1741$var$ONE_MINUTE = 60000;
const $fce38ef6e3eb1741$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $fce38ef6e3eb1741$var$ONE_MINUTE,
    minRetryDelay: $fce38ef6e3eb1741$var$ONE_MINUTE,
    maxRetryDelay: $fce38ef6e3eb1741$var$ONE_MINUTE
};
const $fce38ef6e3eb1741$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $fce38ef6e3eb1741$export$2e2bcd8739ae039 {
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $abcF7.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $hVXIk.NetworkStatusEnum).OFFLINE) {
            done((0, $22268497503b9859$export$f93c40fda808dd0c).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $a2LhX.CallbackProcessingErrorName)) {
                done((0, $22268497503b9859$export$f93c40fda808dd0c).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $1de69a39d0b1f5d2$export$2e2bcd8739ae039)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $a21ab0356ac08551$export$2e2bcd8739ae039)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $abcF7.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $22268497503b9859$export$f93c40fda808dd0c).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $22268497503b9859$export$f93c40fda808dd0c).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $22268497503b9859$export$f93c40fda808dd0c).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || $fce38ef6e3eb1741$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : $fce38ef6e3eb1741$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || $fce38ef6e3eb1741$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || $fce38ef6e3eb1741$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || $fce38ef6e3eb1741$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: options?.maxItems || $fce38ef6e3eb1741$export$d219df4fe04c04a7.maxItems,
            maxAttempts: options?.maxAttempts || $fce38ef6e3eb1741$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || $fce38ef6e3eb1741$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || $fce38ef6e3eb1741$export$d219df4fe04c04a7.minRetryDelay
        };
    }
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = void 0;
        this.resilience = void 0;
        this.batchFlushCallback = void 0;
        this.options = void 0;
        this.scheduler = void 0;
        this.longPollingScheduler = void 0;
        this.metricsCollector = void 0;
        this.networkStatus = void 0;
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $19ba44361c624334$export$2e2bcd8739ae039)(product, {
            logger: logger,
            maxAttempts: options?.maxAttempts,
            maxEventLimit: options?.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $075a1d94af401b85$export$2e2bcd8739ae039)({
            ...this.options,
            waitInterval: options?.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }, this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $075a1d94af401b85$export$2e2bcd8739ae039)({
            ...$fce38ef6e3eb1741$var$LONG_POLLING_OPTIONS,
            waitInterval: $fce38ef6e3eb1741$var$LONG_POLLING_OPTIONS.flushWaitMs
        }, this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $36fd87bc225a2648$export$2e2bcd8739ae039)();
        this.networkStatus = new (0, $7583c71c35f1b55e$export$2e2bcd8739ae039)((status)=>{
            if (status === (0, $hVXIk.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
}





var $2b5e3d6df16f2e76$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $fce38ef6e3eb1741$export$2e2bcd8739ae039)(retryQueuePrefix, product, options || {}, logger);
};



class $d3448b122cc731d9$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = void 0;
        this.message = void 0;
        this.statusCode = void 0;
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof $d3448b122cc731d9$export$26e841bcf1aeb894 ? error.statusCode : null;
    }
}
var $d3448b122cc731d9$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $d3448b122cc731d9$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $d3448b122cc731d9$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
class $d3448b122cc731d9$export$4b1a5e5486cc0d80 {
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json?.url) ? json.url.trim() : '';
        return new $d3448b122cc731d9$export$4b1a5e5486cc0d80(json?.props || null, url.startsWith('http') ? url : null);
    }
    constructor(props, url){
        this.props = void 0;
        this.url = void 0;
        this.props = props;
        this.url = url;
    }
}
class $d3448b122cc731d9$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = void 0;
        this.statusText = void 0;
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}
const $d3448b122cc731d9$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];


function $2e21bfed4d180604$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $d3448b122cc731d9$export$ddf929981dc6feb3).PAGE || item.msg.type === (0, $d3448b122cc731d9$export$ddf929981dc6feb3).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = {
            ...item.msg.properties,
            xid: xid
        };
    } else if (item.msg.traits && item.msg.type === (0, $d3448b122cc731d9$export$ddf929981dc6feb3).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = {
            ...item.msg.traits,
            xid: xid
        };
    }
    return item;
}
async function $2e21bfed4d180604$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$2e21bfed4d180604$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}


const $9164eeffd0539b5d$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $9164eeffd0539b5d$export$8fddcd1eff390364 = 60000; // 60 seconds
const $9164eeffd0539b5d$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $9164eeffd0539b5d$export$6649d5c857717efe = 5000; // 5 seconds
const $9164eeffd0539b5d$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $9164eeffd0539b5d$export$6f1c008dd0c3b67e = 10; // 10 milliseconds


const $7165fde85bff9235$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);



var $2XqLN = parcelRequire("2XqLN");


const $972d61447de85e3a$export$8e8f0180c1b41fad = async (options)=>{
    const signal = $972d61447de85e3a$var$createOrGetAbortController(options)?.signal;
    const corsOptions = $972d61447de85e3a$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, {
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal,
        ...corsOptions
    });
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new (0, $d3448b122cc731d9$export$26e841bcf1aeb894)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $972d61447de85e3a$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $972d61447de85e3a$var$getCorsForUrl = (0, $2XqLN.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});




var $917iu = parcelRequire("917iu");

var $ed50499514b90321$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $ed50499514b90321$var$CookieSchema {
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
    constructor(key, options){
        this.key = void 0;
        this.options = void 0;
        this.key = key;
        this.options = options;
    }
}
const $ed50499514b90321$var$isSecure = ()=>{
    try {
        return window && window.location && window.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $ed50499514b90321$export$d4cb17942ea57c95 = {
    ["AWC_TLD_TEST"]: new $ed50499514b90321$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $ed50499514b90321$var$isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new $ed50499514b90321$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $ed50499514b90321$var$isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new $ed50499514b90321$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $ed50499514b90321$var$isSecure(),
        path: '/'
    })
};


var $5k5F7 = parcelRequire("5k5F7");


class $ca64da15c4c0a7aa$export$90e3e001bcac59c7 {
    constructor(){
        this._data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        };
        this.clear = ()=>{
            this._data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this._data)[index];
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $ca64da15c4c0a7aa$var$inmemorystorage = new $ca64da15c4c0a7aa$export$90e3e001bcac59c7();
var $ca64da15c4c0a7aa$export$2e2bcd8739ae039 = $ca64da15c4c0a7aa$var$inmemorystorage;


/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 



const $8db0efe23d1f1048$export$41c06fdd37b7e9a5 = 'awc';
const $8db0efe23d1f1048$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $8db0efe23d1f1048$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $8db0efe23d1f1048$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $8db0efe23d1f1048$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this._prefix = void 0;
        this._store = void 0;
        this.options = void 0;
        this.getStore = ()=>this._store;
        this.getItem = (key)=>this._store.getItem(this.createKey(key));
        this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($8db0efe23d1f1048$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        };
        this.swapToInMemory = ()=>{
            if (this._store === (0, $ca64da15c4c0a7aa$export$2e2bcd8739ae039) || typeof window === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($8db0efe23d1f1048$export$48c17662a6902497(window[$8db0efe23d1f1048$export$770aa8bc07b3de03])) inMemoryStorage = window[$8db0efe23d1f1048$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $ca64da15c4c0a7aa$export$2e2bcd8739ae039);
                if (!window[$8db0efe23d1f1048$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$8db0efe23d1f1048$export$770aa8bc07b3de03] = (0, $ca64da15c4c0a7aa$export$2e2bcd8739ae039);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        };
        this.clear = ()=>this._store.clear();
        this.key = (index)=>this._store.key(index);
        this.getPrefix = ()=>this._prefix;
        this.createKey = (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($8db0efe23d1f1048$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $5DUgU.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($8db0efe23d1f1048$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}


class $00656ffbea15235e$export$2e2bcd8739ae039 extends (0, $8db0efe23d1f1048$export$2e2bcd8739ae039) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $ca64da15c4c0a7aa$export$2e2bcd8739ae039);
        } catch (err) {
            storageToUse = (0, $ca64da15c4c0a7aa$export$2e2bcd8739ae039);
        }
        super(storageToUse, options);
    }
}


class $8b1a4e934d8db12a$export$2e2bcd8739ae039 {
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
    constructor(){
        this.safeStorage = void 0;
        this.safeStorage = new (0, $00656ffbea15235e$export$2e2bcd8739ae039)({
            useStoragePrefix: false
        });
    }
}









const $4f9007717dfe8915$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $4f9007717dfe8915$export$eb80e1beaa8dacf8 = (0, $ed50499514b90321$export$d4cb17942ea57c95).AWC_TLD_TEST.getKey();
const $4f9007717dfe8915$export$19164982d36535d8 = 'tld_test';
const $4f9007717dfe8915$export$de6821eed3d5f32d = (0, $2XqLN.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).set($4f9007717dfe8915$export$eb80e1beaa8dacf8, $4f9007717dfe8915$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).get($4f9007717dfe8915$export$eb80e1beaa8dacf8) === $4f9007717dfe8915$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).remove($4f9007717dfe8915$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});


class $76142d2a9a314c64$export$2e2bcd8739ae039 {
    set(name, value, options) {
        // no-op
        if (!(0, $ed50499514b90321$export$d4cb17942ea57c95)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $ed50499514b90321$export$d4cb17942ea57c95)[name].getKey(), value, {
            ...(0, $ed50499514b90321$export$d4cb17942ea57c95)[name].getAttributes(),
            // Function is memoized so we only calculate this once per page load
            domain: (0, $4f9007717dfe8915$export$de6821eed3d5f32d)(),
            ...options
        });
    }
    get(name) {
        if (!(0, $ed50499514b90321$export$d4cb17942ea57c95)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $ed50499514b90321$export$d4cb17942ea57c95)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $ed50499514b90321$export$d4cb17942ea57c95)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $ed50499514b90321$export$d4cb17942ea57c95)[name].getKey(), {
            ...options
        });
    }
    constructor(disableCookiePersistence){
        this.cookieLike = void 0;
        this.cookieLike = (0, $4f9007717dfe8915$export$a9330601ee8f4d95)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))) : new (0, $8b1a4e934d8db12a$export$2e2bcd8739ae039)();
    }
}



// Cookie is stale, if anonymousId was generated 7 days ago.
const $9d730249ef708149$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $9d730249ef708149$var$SAFE = 'SAFE';
const $9d730249ef708149$var$UNSAFE = 'UNSAFE';
const $9d730249ef708149$var$NOT_FOUND = 'NOT_FOUND';
const $9d730249ef708149$var$COOKIE = 'COOKIE';
const $9d730249ef708149$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $9d730249ef708149$export$2e2bcd8739ae039 {
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $ed50499514b90321$export$202d555a5dbfd90c).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $ed50499514b90321$export$d4cb17942ea57c95).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $9d730249ef708149$var$LOCAL_STORAGE ? this.store.getItem((0, $ed50499514b90321$export$d4cb17942ea57c95).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $ed50499514b90321$export$202d555a5dbfd90c).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $9d730249ef708149$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $9d730249ef708149$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $9d730249ef708149$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($9d730249ef708149$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $917iu.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $9d730249ef708149$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $9d730249ef708149$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $9d730249ef708149$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $9d730249ef708149$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($9d730249ef708149$var$COOKIE);
        switch(cookieValue.type){
            case $9d730249ef708149$var$SAFE:
            case $9d730249ef708149$var$UNSAFE:
                this.store.setItem((0, $ed50499514b90321$export$d4cb17942ea57c95).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $9d730249ef708149$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return crypto.randomUUID();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
    constructor(disableCookiePersistence){
        this.store = void 0;
        this.cookie = void 0;
        this.userId = void 0;
        this.lastAnonymousIdCookieUpdate = void 0;
        this.store = new (0, $00656ffbea15235e$export$2e2bcd8739ae039)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $76142d2a9a314c64$export$2e2bcd8739ae039)(disableCookiePersistence);
    }
}


// @ts-ignore

var $kNag8 = parcelRequire("kNag8");

const $88ca4b3f953c89b1$export$3a7fe28f9bf4f3d9 = (context)=>{
    return {
        ...context.context,
        userAgent: navigator.userAgent
    };
};
const $88ca4b3f953c89b1$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $88ca4b3f953c89b1$var$nestedRemoveUndefinedValues(properties, '$.properties');
    return (0, (/*@__PURE__*/$parcel$interopDefault($kNag8)))(propertiesWithoutUndefined);
};
// This function will essentially deepClone as well
const $88ca4b3f953c89b1$var$nestedRemoveUndefinedValues = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};


class $d320daaca5f992f9$var$AnalyticsAPIResponse {
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
    constructor(success, validationErrors, message, code, validationReports){
        this.success = void 0;
        this.validationErrors = void 0;
        this.message = void 0;
        this.code = void 0;
        this.validationReports = void 0;
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
}
class $d320daaca5f992f9$var$Message {
    constructor(error){
        this.error = void 0;
        this.error = error;
    }
}
class $d320daaca5f992f9$var$EventValidationReport {
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    constructor(messageId, results){
        this.messageId = void 0;
        this.results = void 0;
        this.messageId = messageId;
        this.results = results;
    }
}
class $d320daaca5f992f9$export$133650fcdde1b226 {
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
    constructor(success, statusCode, message, eventResponseList){
        this.success = void 0;
        this.statusCode = void 0;
        this.message = void 0;
        this.eventResponseList = void 0;
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
}
class $d320daaca5f992f9$var$EventResponse {
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
    constructor(messageId, results, segmentEvent){
        this.messageId = void 0;
        this.results = void 0;
        this.segmentEvent = void 0;
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
}
class $d320daaca5f992f9$var$EventValidationResult {
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
    constructor(type, severity, propertyPath, message){
        this.type = void 0;
        this.severity = void 0;
        this.propertyPath = void 0;
        this.message = void 0;
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
}
class $d320daaca5f992f9$export$2e2bcd8739ae039 {
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $d3448b122cc731d9$export$ddf929981dc6feb3).TRACK, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $d3448b122cc731d9$export$ddf929981dc6feb3).TRACK,
            properties: (0, $88ca4b3f953c89b1$export$44d22e5fb02cc68e)(builtEvent),
            event: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $d3448b122cc731d9$export$ddf929981dc6feb3).PAGE, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $d3448b122cc731d9$export$ddf929981dc6feb3).PAGE,
            properties: (0, $88ca4b3f953c89b1$export$44d22e5fb02cc68e)(builtEvent),
            name: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $d3448b122cc731d9$export$ddf929981dc6feb3).IDENTIFY, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $d3448b122cc731d9$export$ddf929981dc6feb3).IDENTIFY,
            traits: (0, $88ca4b3f953c89b1$export$44d22e5fb02cc68e)(builtEvent)
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $88ca4b3f953c89b1$export$44d22e5fb02cc68e)(context);
        const segmentContext = (0, $88ca4b3f953c89b1$export$3a7fe28f9bf4f3d9)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${crypto.randomUUID()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo?.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch (error) {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $d320daaca5f992f9$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $d320daaca5f992f9$var$Message(responseObject.message?.error || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $d320daaca5f992f9$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
            analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $2e21bfed4d180604$export$c21270cab66ab290)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
    constructor(options){
        this.user = void 0;
        this.options = void 0;
        this.resilienceQueue = void 0;
        this.gasv3BatchUrl = void 0;
        this.metrics = void 0;
        this.xidPromiseCallback = void 0;
        this.responseCallback = void 0;
        this.metadataClient = void 0;
        this.useUrlFromMetadata = void 0;
        this.lastSendEventsError = void 0;
        this.lastUrlFallbackError = void 0;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = async (items, callback)=>{
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = {
                ...metricsPayload,
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: this.lastSendEventsError?.message || null,
                // Temporary back-compat
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: metadataInfo?.props || null,
                metadataClientMetrics: this.metadataClient?.metrics || null
            };
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $972d61447de85e3a$export$8e8f0180c1b41fad)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $d3448b122cc731d9$export$26e841bcf1aeb894) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $d3448b122cc731d9$export$a63e16b3351b8c36)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $d3448b122cc731d9$export$96f086dcf574a9e2).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $d3448b122cc731d9$export$a63e16b3351b8c36)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        };
        this.options = {
            ...options,
            requestTimeout: options.requestTimeout || (0, $9164eeffd0539b5d$export$9175ce0e1c95daf2),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        };
        this.user = new (0, $9d730249ef708149$export$2e2bcd8739ae039)(this.options?.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $36fd87bc225a2648$export$2e2bcd8739ae039)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $2b5e3d6df16f2e76$export$2e2bcd8739ae039)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
}
class $d320daaca5f992f9$var$BatchInterceptor {
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                analyticsAPIResponse.validationReports?.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $d320daaca5f992f9$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $d320daaca5f992f9$export$133650fcdde1b226(success, statusCode, (0, $7165fde85bff9235$export$ba118f9de1e5ac63).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = analyticsAPIResponse.message?.error !== null ? analyticsAPIResponse.message.error : (0, $7165fde85bff9235$export$ba118f9de1e5ac63).has(statusCode) ? (0, $7165fde85bff9235$export$ba118f9de1e5ac63).get(statusCode) : (0, $7165fde85bff9235$export$ba118f9de1e5ac63).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $d320daaca5f992f9$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $d320daaca5f992f9$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error?.message) {
            const match = error.message.match($d320daaca5f992f9$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $d320daaca5f992f9$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $d320daaca5f992f9$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $d320daaca5f992f9$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $d320daaca5f992f9$export$133650fcdde1b226(false, -1, (0, $7165fde85bff9235$export$ba118f9de1e5ac63).get(-1), eventResponseList);
    }
}
$d320daaca5f992f9$var$BatchInterceptor.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;











const $ec9186f5a2212b6f$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $ec9186f5a2212b6f$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $ec9186f5a2212b6f$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $ec9186f5a2212b6f$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $ec9186f5a2212b6f$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $ec9186f5a2212b6f$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $ec9186f5a2212b6f$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $ec9186f5a2212b6f$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $ec9186f5a2212b6f$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
const $ec9186f5a2212b6f$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $5DUgU.envType).LOCAL || env === (0, $5DUgU.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $5DUgU.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $5DUgU.envType).PROD ? $ec9186f5a2212b6f$var$FEDRAMP_PROD_HOST : $ec9186f5a2212b6f$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $5DUgU.envType).PROD ? $ec9186f5a2212b6f$var$STARGATE_FEDRAMP_PROD_HOST : $ec9186f5a2212b6f$var$STARGATE_FEDRAMP_STAGING_HOST;
    /**
	 * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
	 * For more details, see:
	 *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
	 *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
	 */ return window.location.host + $ec9186f5a2212b6f$var$STARGATE_PROXY_PATH;
};
const $ec9186f5a2212b6f$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $5DUgU.envType).PROD ? $ec9186f5a2212b6f$var$PROD_HOST : $ec9186f5a2212b6f$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $5DUgU.envType).PROD ? $ec9186f5a2212b6f$var$STARGATE_PROD_HOST : $ec9186f5a2212b6f$var$STARGATE_STAGING_HOST;
    /**
	 * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
	 * For more details, see:
	 *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
	 *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
	 */ return window.location.host + $ec9186f5a2212b6f$var$STARGATE_PROXY_PATH;
};
function $ec9186f5a2212b6f$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride }) {
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true.');
        throw Error('IC is set but no apiHost provided.');
    }
    if (perimeter === (0, $5DUgU.perimeterType).FEDRAMP_MODERATE) return $ec9186f5a2212b6f$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $ec9186f5a2212b6f$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}
function $ec9186f5a2212b6f$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === window.location.host + $ec9186f5a2212b6f$var$STARGATE_PROXY_PATH;
}


class $39be788a663b8d7e$export$44b578549c42d779 {
    static isGeminiVREnvironment() {
        try {
            for(const k in $parcel$global){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($39be788a663b8d7e$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($39be788a663b8d7e$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($39be788a663b8d7e$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($39be788a663b8d7e$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if ($parcel$global && $parcel$global.hasOwnProperty(propertyName)) return $parcel$global[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if ($parcel$global && $parcel$global.hasOwnProperty(propertyName)) {
            const value = $parcel$global[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}
$39be788a663b8d7e$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
$39be788a663b8d7e$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
$39be788a663b8d7e$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
$39be788a663b8d7e$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY = '__awc_synthetic_flag_override__';







const $b479b6178b262e9f$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    const requestAbortController = $b479b6178b262e9f$var$createRequestAbortController(timeout, signal);
    const corsOptions = $b479b6178b262e9f$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${params.userInfo?.userId || ''}`,
        userIdType: `${params.userInfo?.userIdType || ''}`,
        tenantId: `${params.tenantInfo?.tenantId || ''}`,
        tenantIdType: `${params.tenantInfo?.tenantIdType || ''}`
    }).toString();
    const response = await fetch(metadataUrl, {
        method: 'GET',
        signal: requestAbortController.signal,
        ...corsOptions
    });
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $d3448b122cc731d9$export$26e841bcf1aeb894)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $b479b6178b262e9f$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal?.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $b479b6178b262e9f$var$getCorsForUrl = (0, $2XqLN.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});



var $70ceb115a3b23ecd$var$_MetadataClient;
class $70ceb115a3b23ecd$export$1ac223ae496131c9 {
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $70ceb115a3b23ecd$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        this._fetchAbortController?.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $7583c71c35f1b55e$export$2e2bcd8739ae039)((status)=>{
            if (status === (0, $hVXIk.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        if ((0, $39be788a663b8d7e$export$44b578549c42d779).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        this._fetchAbortController?.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $b479b6178b262e9f$export$55b0d0261469055)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $9164eeffd0539b5d$export$8fddcd1eff390364), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $d3448b122cc731d9$export$4b1a5e5486cc0d80).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $d3448b122cc731d9$export$26e841bcf1aeb894) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $d3448b122cc731d9$export$96f086dcf574a9e2).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        if (this._userInfo?.userId === userInfo?.userId && this._userInfo?.userIdType === userInfo?.userIdType) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        if (this._tenantInfo?.tenantId === tenantInfo?.tenantId && this._tenantInfo?.tenantIdType === tenantInfo?.tenantIdType) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        if (this._networkStatus?.getNetworkStatus() === (0, $hVXIk.NetworkStatusEnum).OFFLINE) {
            done((0, $22268497503b9859$export$f93c40fda808dd0c).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $22268497503b9859$export$f93c40fda808dd0c).SUCCESS);
            this._scheduler.schedule();
        } catch (error) {
            done((0, $22268497503b9859$export$f93c40fda808dd0c).ERROR);
        }
    }
    /**
   * Schedules a refresh of the metadata when the user or tenant info changes. There is
   * a short delay to allow for multiple changes to be batched together, such as when the
   * callers sets the user info and tenant info in quick succession.
   */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $9164eeffd0539b5d$export$6f1c008dd0c3b67e));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || (0, $fce38ef6e3eb1741$export$d219df4fe04c04a7).backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : (0, $fce38ef6e3eb1741$export$d219df4fe04c04a7).backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || (0, $fce38ef6e3eb1741$export$d219df4fe04c04a7).batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || (0, $fce38ef6e3eb1741$export$d219df4fe04c04a7).flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || (0, $fce38ef6e3eb1741$export$d219df4fe04c04a7).flushWaitMs,
            maxItems: options?.maxItems || (0, $fce38ef6e3eb1741$export$d219df4fe04c04a7).maxItems,
            maxAttempts: options?.maxAttempts || (0, $fce38ef6e3eb1741$export$d219df4fe04c04a7).maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || (0, $fce38ef6e3eb1741$export$d219df4fe04c04a7).maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || (0, $fce38ef6e3eb1741$export$d219df4fe04c04a7).minRetryDelay
        };
    }
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = void 0;
        this._tenantInfo = void 0;
        this._url = void 0;
        this._metadataHost = void 0;
        this._product = void 0;
        this._metadataInfo = void 0;
        this._requestStatus = void 0;
        this._lastFetchRequestCount = void 0;
        this._options = void 0;
        this._scheduler = void 0;
        this._networkStatus = void 0;
        this._lastErrorReason = void 0;
        this._fetchAbortController = void 0;
        this._hasBeenStopped = void 0;
        this._isEnabled = void 0;
        this._propertyChangeRefreshTimeout = void 0;
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $ec9186f5a2212b6f$export$83a9dd8d74be72c)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            batchFlushSize: 7,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            maxItems: 1000,
            minRetryDelay: (0, $9164eeffd0539b5d$export$6649d5c857717efe),
            maxRetryDelay: (0, $9164eeffd0539b5d$export$33e7628d3b2c0e2)
        });
        this._scheduler = new (0, $075a1d94af401b85$export$2e2bcd8739ae039)({
            ...this._options,
            waitInterval: (0, $9164eeffd0539b5d$export$92ed669a3d41dad3)
        }, this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
}
$70ceb115a3b23ecd$var$_MetadataClient = $70ceb115a3b23ecd$export$1ac223ae496131c9;
$70ceb115a3b23ecd$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY = 1;
$70ceb115a3b23ecd$export$1ac223ae496131c9.Factory = (apiHostProtocol, apiHost, product)=>{
    return new $70ceb115a3b23ecd$var$_MetadataClient(apiHostProtocol, apiHost, product);
};






class $c6dd695367b163ca$export$2e2bcd8739ae039 {
    constructor(){
        this._originStore = void 0;
        this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $5DUgU.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $945a6126a5ece0de$export$2e2bcd8739ae039)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        };
        this._originStore = {};
    }
}





// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $1d8eeb7f4033b441$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $1d8eeb7f4033b441$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $1d8eeb7f4033b441$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $1d8eeb7f4033b441$export$285f6bddd927a06d = 1800000; // 30 minutes
const $1d8eeb7f4033b441$export$a92e915d70316eb2 = 5000; // 5 seconds
const $1d8eeb7f4033b441$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $1d8eeb7f4033b441$export$5702a91a6f42969f = ()=>{};
class $1d8eeb7f4033b441$export$2e2bcd8739ae039 {
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($1d8eeb7f4033b441$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($1d8eeb7f4033b441$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$1d8eeb7f4033b441$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
    constructor(options = {}){
        this._safeLocalStorage = void 0;
        this._sessionExpiryTime = void 0;
        this._sessionExpiryDebounce = void 0;
        this._sessionExpiryDebounceThresholdPercentage = void 0;
        this._sessionExpiryDebounceTimer = void 0;
        this._onNewSessionStarted = void 0;
        this._generateNewSessionId = ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($1d8eeb7f4033b441$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($1d8eeb7f4033b441$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || $1d8eeb7f4033b441$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $1d8eeb7f4033b441$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $1d8eeb7f4033b441$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $1d8eeb7f4033b441$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $00656ffbea15235e$export$2e2bcd8739ae039)();
    }
}




class $6b131b21fd6988d6$export$2e2bcd8739ae039 extends (0, $8db0efe23d1f1048$export$2e2bcd8739ae039) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $ca64da15c4c0a7aa$export$2e2bcd8739ae039);
        } catch (err) {
            storageToUse = (0, $ca64da15c4c0a7aa$export$2e2bcd8739ae039);
        }
        super(storageToUse, options);
    }
}



const $665df044bb2c8b06$var$STORAGE_KEY = 'tab.id';
class $665df044bb2c8b06$export$2e2bcd8739ae039 {
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($665df044bb2c8b06$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
    constructor(){
        this._safeSessionStorage = void 0;
        this._generateNewTabId = ()=>{
            const newTabId = crypto.randomUUID();
            this._safeSessionStorage.setItem($665df044bb2c8b06$var$STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, $6b131b21fd6988d6$export$2e2bcd8739ae039)();
    }
}













const $e12a166f16cadc43$var$STORAGE_KEY = 'taskSessions';
const $e12a166f16cadc43$var$INIT_KEY = 'taskSessionsInit';
const $e12a166f16cadc43$var$AWC_PARAM_PREFIX = 'awc.';
const $e12a166f16cadc43$var$TASK_SESSION_RELOAD_TIME = 3000;
class $e12a166f16cadc43$export$2e2bcd8739ae039 {
    constructor(){
        this._safeSessionStorage = void 0;
        this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($e12a166f16cadc43$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($e12a166f16cadc43$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($e12a166f16cadc43$var$INIT_KEY) || '0', 10) < currentTimestamp - $e12a166f16cadc43$var$TASK_SESSION_RELOAD_TIME;
        this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($e12a166f16cadc43$var$AWC_PARAM_PREFIX)[1];
        this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($e12a166f16cadc43$var$AWC_PARAM_PREFIX);
        this.getAllTaskSessions = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($e12a166f16cadc43$var$STORAGE_KEY) || '');
            } catch (e) {
                return {};
            }
        };
        this._writeToSessionStorage = (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($e12a166f16cadc43$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        };
        this._appendTaskSessions = (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        };
        this._safelyRemoveKey = (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        };
        this.createTaskSession = (taskSessionName)=>{
            const taskSessionId = crypto.randomUUID();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        };
        this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        };
        this.completeTaskSession = (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        };
        this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $6Pcds.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $ewjj9.pick)(currentState, includedTaskSessions) : (0, $ewjj9.omit)(currentState, Object.values((0, $5DUgU.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = {
                ...(0, $ewjj9.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$e12a166f16cadc43$var$AWC_PARAM_PREFIX + taskSessionName),
                ...query
            };
            return `${url}?${(0, $6Pcds.stringify)(queryWithTaskSessions)}`;
        };
        this.stripQueryParameters = ()=>{
            const extractedTaskSessions = (0, $ewjj9.mapKeys)((0, $945a6126a5ece0de$export$2e2bcd8739ae039)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        };
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $6b131b21fd6988d6$export$2e2bcd8739ae039)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($e12a166f16cadc43$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}







const $201c469b9a404af6$var$MAX_CACHE_SIZE = 100;
const $201c469b9a404af6$var$COOKIE_NAME = (0, $ed50499514b90321$export$d4cb17942ea57c95).AWC_ANALYTICS_DEBUG.getKey();
const $201c469b9a404af6$var$DEBUG_TAG = 'synthetic';
class $201c469b9a404af6$var$TestingCache {
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch  {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch  {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $201c469b9a404af6$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($201c469b9a404af6$var$DEBUG_TAG)) event.tags.push($201c469b9a404af6$var$DEBUG_TAG);
        } else event.tags = [
            $201c469b9a404af6$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $39be788a663b8d7e$export$44b578549c42d779).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).get($201c469b9a404af6$var$COOKIE_NAME) || 'false') === true;
        } catch  {
            (0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).remove($201c469b9a404af6$var$COOKIE_NAME);
        }
        return false;
    }
    constructor(syntheticFlagOverride, enableTestingCache){
        this._isDebugCookieEnabled = void 0;
        this._syntheticFlagOverride = void 0;
        this._enableTestingCache = void 0;
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $201c469b9a404af6$var$TestingCache.getDebugCookie();
        this.bind();
    }
}
var $201c469b9a404af6$export$2e2bcd8739ae039 = $201c469b9a404af6$var$TestingCache;





const $c298aef6a0d197ce$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};



const $ffc19307df5cc51a$var$DEFAULT_DELAY = 2000; // 2 seconds
const $ffc19307df5cc51a$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $ffc19307df5cc51a$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $ffc19307df5cc51a$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
class $ffc19307df5cc51a$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        this._blurListener = void 0;
        this._delay = void 0;
        this._focusListener = void 0;
        this._getContext = void 0;
        this._intervalId = void 0;
        this._onEvent = void 0;
        this._product = void 0;
        this._productInfo = void 0;
        this._safeLocalStorage = void 0;
        this._storageKey = void 0;
        this._malformedEventStorageKey = void 0;
        this._throttle = void 0;
        this.start = ()=>{
            this._startInterval();
            this._bindEventListeners();
        };
        this.stop = ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        };
        this.resetTimers = ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        };
        this._bindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        };
        this._unbindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        };
        this._startInterval = ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        };
        this._stopInterval = ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        };
        this._getProductKey = (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        };
        this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._parseLocalStorageData = (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch (error) {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        };
        this._getMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        };
        this._setMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        };
        this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
            const document = (0, $c298aef6a0d197ce$export$f65ca476c09acec0)();
            if (document && !document.hasFocus()) return 'FocusLost';
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $5DUgU.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return 'UserOrTenantIncomplete';
                return 'MalformedUiViewedRateLimited';
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 'EligibleToSend';
            return 'UiViewedRateLimited';
        };
        this._handleInterval = ()=>{
            const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        };
        this._sendEvent = (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const shouldSendEventTriggerStatus = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(shouldSendEventTriggerStatus){
                case 'EligibleToSend':
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case 'UserOrTenantIncomplete':
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        };
        this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = {
                    ...event.attributes,
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                };
            }
            if (lastScreenEvent) event.attributes = {
                ...event.attributes,
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            };
            return event;
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $ffc19307df5cc51a$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $ffc19307df5cc51a$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $ffc19307df5cc51a$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $ffc19307df5cc51a$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $00656ffbea15235e$export$2e2bcd8739ae039)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}




function $ec692407b558bb24$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}


var $5c7af631796b958c$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $5c7af631796b958c$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});


const $8ec072c6b5f8105f$export$545bcbd53afabfa3 = 5000;
const $8ec072c6b5f8105f$export$af4087e36d63846 = ()=>[
        {
            type: (0, $5c7af631796b958c$export$92ca0438bcb0d396).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $5c7af631796b958c$export$92ca0438bcb0d396).UID,
            state: 'TIMEOUT'
        }
    ];
const $8ec072c6b5f8105f$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $5c7af631796b958c$export$92ca0438bcb0d396).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $5c7af631796b958c$export$92ca0438bcb0d396).UID,
            state: 'UNKNOWN'
        }
    ];


const $37dac68d15a97eff$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $8ec072c6b5f8105f$export$af4087e36d63846)()), (0, $8ec072c6b5f8105f$export$545bcbd53afabfa3));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $8ec072c6b5f8105f$export$fa341d0c750d705b)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};


const $bc3bdafb6daaa863$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
const $bc3bdafb6daaa863$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $bc3bdafb6daaa863$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $bc3bdafb6daaa863$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $bc3bdafb6daaa863$export$2e2bcd8739ae039 {
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $39be788a663b8d7e$export$44b578549c42d779).isGeminiVREnvironment() && !(0, $39be788a663b8d7e$export$44b578549c42d779).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $39be788a663b8d7e$export$44b578549c42d779).isGeminiVREnvironment() && !(0, $39be788a663b8d7e$export$44b578549c42d779).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties. They are not part of the public
   * API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get task() {
        return this._task;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties.
   * They are not part of the public API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get _productInfo() {
        return this._internalProductInfo;
    }
    constructor(productInfo, settings = {}){
        this._apdexEvent = void 0;
        this._context = void 0;
        this._eventDelayQueue = void 0;
        this._historyReplaceFn = void 0;
        this._orgInfo = void 0;
        this._pageVisibility = void 0;
        this._internalProductInfo = void 0;
        this._safeSessionStorage = void 0;
        this._sessionTracking = void 0;
        this._tabTracking = void 0;
        this._tenantInfo = void 0;
        this._testingCache = void 0;
        this._uiViewedAttributes = void 0;
        this._uiViewedEvent = void 0;
        this._userInfo = void 0;
        this._originTracing = void 0;
        this._task = void 0;
        this._pageLoadId = void 0;
        this._workspaceInfo = void 0;
        this._aliases = void 0;
        this._groups = void 0;
        this._eventProcessor = void 0;
        this._logger = void 0;
        this._embeddedContext = void 0;
        this._crossProductInteractionTracking = void 0;
        this._useStargate = (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        };
        this._changeInternalUserId = (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = (subproduct)=>(0, $29a361f5f1eed66e$export$2e2bcd8739ae039)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        this._createEmbeddedProductGetter = (embeddedProduct)=>(0, $29a361f5f1eed66e$export$2e2bcd8739ae039)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        this._getLastScreenEvent = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($bc3bdafb6daaa863$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (err) {
                this._safeSessionStorage.removeItem($bc3bdafb6daaa863$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = (event)=>{
            this._safeSessionStorage.setItem($bc3bdafb6daaa863$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $5DUgU.eventType).UI:
                case (0, $5DUgU.eventType).OPERATIONAL:
                case (0, $5DUgU.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $5DUgU.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $5DUgU.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        };
        this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        };
        this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        };
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        };
        this.setTenantInfo = (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $5DUgU.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $5DUgU.isType)((0, $5DUgU.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $5DUgU.objectValues)((0, $5DUgU.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearTenantInfo = ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setOrgInfo = (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        };
        this.clearOrgInfo = ()=>{
            this._orgInfo = {};
        };
        this.setWorkspaceInfo = (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        };
        this.clearWorkspaceInfo = ()=>{
            this._workspaceInfo = {};
        };
        this.setUserInfo = (userIdType, userId)=>{
            (0, $epqyT.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearUserInfo = ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setAlias = (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $5DUgU.isType)((0, $5DUgU.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $5DUgU.objectValues)((0, $5DUgU.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = ()=>{
            this._aliases = {};
        };
        this.setGroup = (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $5DUgU.isType)((0, $5DUgU.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $5DUgU.objectValues)((0, $5DUgU.groupType))}]`);
            this._groups[groupsKeyType] = group;
        };
        this.clearGroup = ()=>{
            this._groups = {};
        };
        this.getAnonymousId = ()=>this._userInfo.anonymousId;
        this.getCurrentSessionId = ()=>this._sessionTracking.getCurrentSessionId();
        this.setUIViewedAttributes = (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = {
                ...uiViewedAttributes
            };
        };
        this.getUIViewedAttributes = ()=>{
            return this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = ()=>{
            this._uiViewedAttributes = {};
        };
        this.appendUIViewedAttributes = (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = {
                ...this._uiViewedAttributes,
                ...attributes
            };
        };
        this.sendIdentifyEvent = (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $5DUgU.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        };
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ this.sendPageEvent = (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        };
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ this.sendScreenEvent = (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $epqyT.validateScreenEvent)(screenName);
            (0, $epqyT.validateContainers)(screenContainers);
            const builtEvent = (0, $7599af0b503dbd64$export$c7d9a5f56acc4b19)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = {
                name: screenName,
                ...builtEvent
            };
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $ec692407b558bb24$export$2e2bcd8739ae039)(callback, builtEventWithName));
        };
        this.sendTrackEvent = (event, callback)=>{
            (0, $epqyT.validateTrackEvent)(event);
            const builtEvent = (0, $7599af0b503dbd64$export$7bf451af4a8e3dd9)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $5DUgU.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $7599af0b503dbd64$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $ec692407b558bb24$export$2e2bcd8739ae039)(callback, builtEvent));
        };
        this.sendUIEvent = (event, callback)=>{
            (0, $epqyT.validateUIEvent)(event);
            const builtEvent = (0, $7599af0b503dbd64$export$7bf451af4a8e3dd9)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $5DUgU.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $7599af0b503dbd64$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $ec692407b558bb24$export$2e2bcd8739ae039)(callback, builtEvent));
        };
        this.sendOperationalEvent = (event, callback)=>{
            (0, $epqyT.validateOperationalEvent)(event);
            const builtEvent = (0, $7599af0b503dbd64$export$7bf451af4a8e3dd9)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $5DUgU.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $7599af0b503dbd64$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $ec692407b558bb24$export$2e2bcd8739ae039)(callback, builtEvent));
        };
        this.startUIViewedEvent = (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $ffc19307df5cc51a$export$2e2bcd8739ae039)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        };
        this.startApdexEvent = (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
        this.stopApdexEvent = (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $5DUgU.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $5DUgU.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $5DUgU.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $5DUgU.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $5DUgU.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $5DUgU.objectValues)((0, $5DUgU.eventType))}]`);
        };
        this.setResponseCallback = (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $5DUgU.isType)((0, $5DUgU.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $5DUgU.objectValues)((0, $5DUgU.envType))}]`);
        if (productInfo.perimeter && !(0, $5DUgU.isType)((0, $5DUgU.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $5DUgU.objectValues)((0, $5DUgU.perimeterType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $5DUgU.originType).WEB;
        else if (!(0, $5DUgU.isType)((0, $5DUgU.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $5DUgU.objectValues)((0, $5DUgU.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $5DUgU.originType).WEB ? (0, $5DUgU.platformType).WEB : (0, $5DUgU.platformType).DESKTOP;
        else (0, $epqyT.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        this._internalProductInfo = {
            ...productInfo,
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        };
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo?.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $a12ec36efbd18e1b$export$f56713ced121eb91)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $a12ec36efbd18e1b$export$ab34f90cc32c8960)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $7599af0b503dbd64$export$3a7fe28f9bf4f3d9)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $6b131b21fd6988d6$export$2e2bcd8739ae039)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $ec9186f5a2212b6f$export$18c0b81944902eae)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $37dac68d15a97eff$export$fbe53bbbe682bcdd)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $70ceb115a3b23ecd$export$1ac223ae496131c9).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $d320daaca5f992f9$export$2e2bcd8739ae039)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $bc3bdafb6daaa863$export$48361b6ed38f1b0.getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings?.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $5401be2930f14104$export$2e2bcd8739ae039)();
        this._tabTracking = new (0, $665df044bb2c8b06$export$2e2bcd8739ae039)();
        this._sessionTracking = new (0, $1d8eeb7f4033b441$export$2e2bcd8739ae039)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $e12a166f16cadc43$export$2e2bcd8739ae039)();
        this._originTracing = new (0, $c6dd695367b163ca$export$2e2bcd8739ae039)();
        // Init Apdex
        this._apdexEvent = new (0, $a4b812cbc3a59940$export$2e2bcd8739ae039)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $945a6126a5ece0de$export$600dd5bf1b049f11);
        this._eventDelayQueue = new (0, $fa4b133ceb32e864$export$2e2bcd8739ae039)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $201c469b9a404af6$export$2e2bcd8739ae039)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = crypto.randomUUID();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $8862ca24f3715e5d$export$2e2bcd8739ae039)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
}
module.exports["STARGATE_PROXY_PATH"] = $bc3bdafb6daaa863$export$5df9262e102d0c32;
module.exports["default"] = $bc3bdafb6daaa863$export$2e2bcd8739ae039;

});

parcelRegister("5DUgU", function(module, exports) {
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $70ec6637eda69bb4$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $70ec6637eda69bb4$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $70ec6637eda69bb4$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
	 *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
	 */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $70ec6637eda69bb4$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $70ec6637eda69bb4$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $70ec6637eda69bb4$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var $70ec6637eda69bb4$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $70ec6637eda69bb4$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $70ec6637eda69bb4$export$809831be6c4c6227 = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const $70ec6637eda69bb4$export$19c579398ad213e7 = Object.freeze([
    "web",
    "mobileWeb"
]);
var $70ec6637eda69bb4$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $70ec6637eda69bb4$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $70ec6637eda69bb4$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
var $70ec6637eda69bb4$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $70ec6637eda69bb4$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $70ec6637eda69bb4$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $70ec6637eda69bb4$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});
module.exports["envType"] = $70ec6637eda69bb4$export$56ac8ebc9870b1b9;
module.exports["eventType"] = $70ec6637eda69bb4$export$4c045e605d532c98;
module.exports["platformType"] = $70ec6637eda69bb4$export$6b4f396210e539f3;
module.exports["originType"] = $70ec6637eda69bb4$export$f73e9fcd368bb695;
module.exports["tenantType"] = $70ec6637eda69bb4$export$496f06ac2a964da2;
module.exports["productEmbedType"] = $70ec6637eda69bb4$export$f49776dca27a2e7c;
module.exports["userType"] = $70ec6637eda69bb4$export$1827adfd178b4870;
module.exports["apdexType"] = $70ec6637eda69bb4$export$99b37380a464d794;
module.exports["desktopPlatforms"] = $70ec6637eda69bb4$export$809831be6c4c6227;
module.exports["webPlatforms"] = $70ec6637eda69bb4$export$19c579398ad213e7;
module.exports["originTracingType"] = $70ec6637eda69bb4$export$62a500c02dc63ee;
module.exports["objectValues"] = $70ec6637eda69bb4$export$ad1854f4a08c15f8;
module.exports["isType"] = $70ec6637eda69bb4$export$26b9f946b448f23e;
module.exports["perimeterType"] = $70ec6637eda69bb4$export$bdd41749d2096e4b;
module.exports["aliasType"] = $70ec6637eda69bb4$export$a8c99e46b781d936;
module.exports["groupType"] = $70ec6637eda69bb4$export$e73680b18d9b7c6e;

});

parcelRegister("a4UIB", function(module, exports) {

var $T9xHm = parcelRequire("T9xHm");


var $dh538 = parcelRequire("dh538");


var $5O1V9 = parcelRequire("5O1V9");

const $ced354b675004b13$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $ced354b675004b13$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($ced354b675004b13$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$ced354b675004b13$export$7bc189309d2ad463];
            else {
                // Initialise InteractionSessionTracking on global window object
                window[$ced354b675004b13$export$7bc189309d2ad463] = new (0, $5O1V9.default)();
                interactionSessionTracking = window[$ced354b675004b13$export$7bc189309d2ad463];
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error initialising InteractionSessionTracking - ${error instanceof Error ? error.message : String(error)}`);
        }
        return interactionSessionTracking;
    }
}



var $iGeiI = parcelRequire("iGeiI");

const $78ff55797ebb645d$export$b9dd752fb13352ce = 'interactionSession.source';
const $78ff55797ebb645d$export$e04e3c50573f9af7 = 'interactionSession.bridge';
class $78ff55797ebb645d$export$2e2bcd8739ae039 {
    constructor(interactionSessionOptions, bridge, interactionSource){
        // TODO: Make these fields non-nullable once feature flag removed
        this.safeSessionStorage = void 0;
        this.interactionSessionTracking = void 0;
        this.isEnabled = void 0;
        this.getCurrentInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
        this.getPreviousInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
        this.getBridge = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($78ff55797ebb645d$export$e04e3c50573f9af7) : null;
        this.getInteractionSource = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($78ff55797ebb645d$export$b9dd752fb13352ce) : null;
        this.isEnabled = (0, $dh538.fg)('analytics_cross_product_interaction_tracking') && !(0, $T9xHm.isFedrampModerate)();
        if (this.isEnabled) {
            // Get singleton interaction session tracking instance
            this.interactionSessionTracking = (0, $ced354b675004b13$export$2e2bcd8739ae039).getInstance();
            let isValidPersistedId = false;
            if (this.interactionSessionTracking) {
                if (interactionSessionOptions) {
                    this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                    isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
                }
            }
            this.safeSessionStorage = new (0, $iGeiI.default)();
            // Store other interaction session parameters directly in session storage if ID has been validated
            if (isValidPersistedId) {
                bridge && this.safeSessionStorage.setItem($78ff55797ebb645d$export$e04e3c50573f9af7, bridge);
                interactionSource && this.safeSessionStorage.setItem($78ff55797ebb645d$export$b9dd752fb13352ce, interactionSource);
            }
        }
    }
}
module.exports["default"] = $78ff55797ebb645d$export$2e2bcd8739ae039;

});

parcelRegister("5O1V9", function(module, exports) {

var $iGeiI = parcelRequire("iGeiI");

// WARNING: The value of INTERACTION_SESSION_ID_STORAGE_KEY will be used by Analytics Web Client to attach the session ID to events.
// If you change this, you will need to update the Analytics Web Client code as well.
const $bc957b7e3473605a$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
const $bc957b7e3473605a$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
const $bc957b7e3473605a$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
const $bc957b7e3473605a$export$285f6bddd927a06d = 1800000; // 30 minutes
const $bc957b7e3473605a$export$d050a4cab1b9f734 = 86400000; // 24 hours
const $bc957b7e3473605a$export$a92e915d70316eb2 = 5000; // 5 seconds
const $bc957b7e3473605a$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $bc957b7e3473605a$var$INTEGER_REGEX = /^\d+$/;
const $bc957b7e3473605a$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
class $bc957b7e3473605a$export$2e2bcd8739ae039 {
    getCurrentInteractionSessionId() {
        const sessionId = this.safeSessionStorage.getItem($bc957b7e3473605a$var$INTERACTION_SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this.safeSessionStorage.getItem($bc957b7e3473605a$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        // If we have an existing valid session ID within expiry, we can return it straight away
        if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) {
            this.debouncedUpdateSessionExpiry(sessionExpiry);
            return sessionId;
        }
        // To generate a new session ID we must ensure analytics is ready
        if (this.analyticsReady) {
            // Session expiry update must occur before generateNewSessionId. Otherwise we were running
            // into issues of calls attempting to read the session ID before a valid expiry had been set
            this.debouncedUpdateSessionExpiry(sessionExpiry);
            return this.generateNewSessionId();
        }
        return null;
    }
    getPreviousInteractionSessionId() {
        return this.safeSessionStorage.getItem($bc957b7e3473605a$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
    }
    setInteractionSessionId(persistedSessionId) {
        if (this.validateSessionId(persistedSessionId)) {
            const currentSessionId = this.safeSessionStorage.getItem($bc957b7e3473605a$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            // If we are already on the required session ID, just return true and make no changes
            // This can happen if the persisted session ID in options is the same as the current session ID
            // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
            // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
            if (currentSessionId === persistedSessionId) return false;
            // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
            // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
            this.debouncedUpdateSessionExpiry(0);
            this.safeSessionStorage.setItem($bc957b7e3473605a$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
            this.safeSessionStorage.removeItem($bc957b7e3473605a$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            document.dispatchEvent(new Event($bc957b7e3473605a$export$5d4c4eab0863aae3));
            return true;
        }
        return false;
    }
    // Must be called with a valid sendEvent function for other methods to work
    setAnalyticsCallback(sendEventCallback) {
        if (this.analyticsReady) // If we already have a valid callback, don't over-write it
        return;
        if (sendEventCallback && typeof sendEventCallback === 'function') {
            this.sendEventCallback = sendEventCallback;
            this.analyticsReady = true;
        } else this.analyticsReady = false;
    }
    validateSessionId(sessionId) {
        // Check if persisted session ID can parse as valid Unix timestamp
        if (sessionId && $bc957b7e3473605a$var$INTEGER_REGEX.test(sessionId)) {
            const sessionAge = Date.now() - parseInt(sessionId, 10);
            // Validate that timestamp is not a future time, and is also within the TTL
            if (sessionAge >= 0 && sessionAge <= $bc957b7e3473605a$export$d050a4cab1b9f734) return true;
        }
        return false;
    }
    sendInteractionSessionEvent(action) {
        this.sendEventCallback && this.sendEventCallback({
            action: action,
            actionSubject: 'interactionSession',
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
    constructor(){
        this.safeSessionStorage = void 0;
        this.sessionExpiryTime = void 0;
        this.sessionExpiryDebounce = void 0;
        this.sessionExpiryDebounceThresholdPercentage = void 0;
        this.sessionExpiryDebounceTimer = void 0;
        this.analyticsReady = false;
        // This callback function will be called whenever a new session ID is generated
        // It expects a function that sends an operational analytics event, with
        // the first parameter being set to the action ('started' or 'renewed'), and the second parameter being
        // an InteractionSession object containing the new session ID and previous session ID.
        this.sendEventCallback = void 0;
        this.generateNewSessionId = ()=>{
            if (!this.analyticsReady) return null;
            const currentSessionId = this.safeSessionStorage.getItem($bc957b7e3473605a$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            const newSessionId = Date.now().toString();
            this.safeSessionStorage.setItem($bc957b7e3473605a$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                this.safeSessionStorage.setItem($bc957b7e3473605a$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                this.sendInteractionSessionEvent('renewed');
            } else this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($bc957b7e3473605a$export$5d4c4eab0863aae3));
            return newSessionId;
        };
        this.updateSessionExpiry = ()=>{
            const expiry = Date.now() + this.sessionExpiryTime;
            this.safeSessionStorage.setItem($bc957b7e3473605a$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this.debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { updateSessionExpiry: updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this.sessionExpiryDebounceThresholdPercentage * this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (this.sessionExpiryDebounceTimer) clearTimeout(this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this.sessionExpiryDebounceTimer = setTimeout(()=>{
                    updateSessionExpiry();
                }, this.sessionExpiryDebounce);
            }
        };
        this.sessionExpiryTime = $bc957b7e3473605a$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $bc957b7e3473605a$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $bc957b7e3473605a$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $iGeiI.default)();
    }
}
module.exports["INTERACTION_SESSION_ID_UPDATED_EVENT"] = $bc957b7e3473605a$export$5d4c4eab0863aae3;
module.exports["default"] = $bc957b7e3473605a$export$2e2bcd8739ae039;

});

parcelRegister("26AWB", function(module, exports) {
const $98232efc2ad06442$export$81d16f1428ce0486 = 'xpis';
const $98232efc2ad06442$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    const urlObj = new URL(url);
    urlObj.searchParams.set($98232efc2ad06442$export$81d16f1428ce0486, paramValueEncoded);
    return urlObj.toString();
};
module.exports["URL_QUERY_PARAM_INTERACTION_SESSION"] = $98232efc2ad06442$export$81d16f1428ce0486;
module.exports["generateUrlWithParams"] = $98232efc2ad06442$export$2e3999ec51334ffe;

});

parcelRegister("6Pcds", function(module, exports) {
$parcel$export(module.exports, "extract", () => $4f80fb5a9ae18be7$export$f9380c9a627682d3, (v) => $4f80fb5a9ae18be7$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $4f80fb5a9ae18be7$export$98e6a39c04603d36, (v) => $4f80fb5a9ae18be7$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $4f80fb5a9ae18be7$export$fac44ee5b035f737, (v) => $4f80fb5a9ae18be7$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $4f80fb5a9ae18be7$export$7a5253c0f62e0150, (v) => $4f80fb5a9ae18be7$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $4f80fb5a9ae18be7$export$a8c1621ea79325d3, (v) => $4f80fb5a9ae18be7$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $4f80fb5a9ae18be7$export$357523c63a2253b9, (v) => $4f80fb5a9ae18be7$export$357523c63a2253b9 = v);
$parcel$export(module.exports, "exclude", () => $4f80fb5a9ae18be7$export$44c361b8ec72ef7f, (v) => $4f80fb5a9ae18be7$export$44c361b8ec72ef7f = v);
var $4f80fb5a9ae18be7$export$f9380c9a627682d3;
var $4f80fb5a9ae18be7$export$98e6a39c04603d36;
var $4f80fb5a9ae18be7$export$fac44ee5b035f737;
var $4f80fb5a9ae18be7$export$7a5253c0f62e0150;
var $4f80fb5a9ae18be7$export$a8c1621ea79325d3;
var $4f80fb5a9ae18be7$export$357523c63a2253b9;
var $4f80fb5a9ae18be7$export$44c361b8ec72ef7f;
'use strict';

var $7Zf89 = parcelRequire("7Zf89");


var $7vZEy = parcelRequire("7vZEy");


var $8GHHs = parcelRequire("8GHHs");


var $310XO = parcelRequire("310XO");

const $4f80fb5a9ae18be7$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $4f80fb5a9ae18be7$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $4f80fb5a9ae18be7$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $4f80fb5a9ae18be7$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $4f80fb5a9ae18be7$var$encode(key, options),
                            '[',
                            $4f80fb5a9ae18be7$var$encode(index, options),
                            ']=',
                            $4f80fb5a9ae18be7$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $4f80fb5a9ae18be7$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $4f80fb5a9ae18be7$var$encode(key, options),
                            '[]=',
                            $4f80fb5a9ae18be7$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $4f80fb5a9ae18be7$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $4f80fb5a9ae18be7$var$encode(key, options),
                            ':list=',
                            $4f80fb5a9ae18be7$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $4f80fb5a9ae18be7$var$encode(key, options),
                                keyValueSep,
                                $4f80fb5a9ae18be7$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $4f80fb5a9ae18be7$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $4f80fb5a9ae18be7$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $4f80fb5a9ae18be7$var$encode(key, options),
                            '=',
                            $4f80fb5a9ae18be7$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $4f80fb5a9ae18be7$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $4f80fb5a9ae18be7$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $4f80fb5a9ae18be7$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$4f80fb5a9ae18be7$var$decode(item, options)) : value === null ? value : $4f80fb5a9ae18be7$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $4f80fb5a9ae18be7$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$4f80fb5a9ae18be7$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $4f80fb5a9ae18be7$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $4f80fb5a9ae18be7$var$encode(value, options) {
    if (options.encode) return options.strict ? $7Zf89(value) : encodeURIComponent(value);
    return value;
}
function $4f80fb5a9ae18be7$var$decode(value, options) {
    if (options.decode) return $7vZEy(value);
    return value;
}
function $4f80fb5a9ae18be7$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $4f80fb5a9ae18be7$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $4f80fb5a9ae18be7$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $4f80fb5a9ae18be7$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $4f80fb5a9ae18be7$var$extract(input) {
    input = $4f80fb5a9ae18be7$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $4f80fb5a9ae18be7$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $4f80fb5a9ae18be7$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $4f80fb5a9ae18be7$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $4f80fb5a9ae18be7$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $8GHHs(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $4f80fb5a9ae18be7$var$decode(value, options);
        formatter($4f80fb5a9ae18be7$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $4f80fb5a9ae18be7$var$parseValue(value[k], options);
        else ret[key] = $4f80fb5a9ae18be7$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $4f80fb5a9ae18be7$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$4f80fb5a9ae18be7$export$f9380c9a627682d3 = $4f80fb5a9ae18be7$var$extract;
$4f80fb5a9ae18be7$export$98e6a39c04603d36 = $4f80fb5a9ae18be7$var$parse;
$4f80fb5a9ae18be7$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $4f80fb5a9ae18be7$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $4f80fb5a9ae18be7$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $4f80fb5a9ae18be7$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $4f80fb5a9ae18be7$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $4f80fb5a9ae18be7$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $4f80fb5a9ae18be7$var$encode(key, options) + '=' + $4f80fb5a9ae18be7$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$4f80fb5a9ae18be7$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $8GHHs(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $4f80fb5a9ae18be7$var$parse($4f80fb5a9ae18be7$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $4f80fb5a9ae18be7$var$decode(hash, options)
    } : {});
};
$4f80fb5a9ae18be7$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$4f80fb5a9ae18be7$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $4f80fb5a9ae18be7$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $4f80fb5a9ae18be7$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $4f80fb5a9ae18be7$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $4f80fb5a9ae18be7$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $4f80fb5a9ae18be7$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$4f80fb5a9ae18be7$var$encodeFragmentIdentifier] ? $4f80fb5a9ae18be7$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$4f80fb5a9ae18be7$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$4f80fb5a9ae18be7$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $4f80fb5a9ae18be7$export$7a5253c0f62e0150(input, options);
    return $4f80fb5a9ae18be7$export$a8c1621ea79325d3({
        url: url,
        query: $310XO(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$4f80fb5a9ae18be7$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $4f80fb5a9ae18be7$export$357523c63a2253b9(input, exclusionFilter, options);
};

});

parcelRegister("7Zf89", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("7vZEy", function(module, exports) {
'use strict';
var $578b40b28a33e064$var$token = '%[a-f0-9]{2}';
var $578b40b28a33e064$var$singleMatcher = new RegExp('(' + $578b40b28a33e064$var$token + ')|([^%]+?)', 'gi');
var $578b40b28a33e064$var$multiMatcher = new RegExp('(' + $578b40b28a33e064$var$token + ')+', 'gi');
function $578b40b28a33e064$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $578b40b28a33e064$var$decodeComponents(left), $578b40b28a33e064$var$decodeComponents(right));
}
function $578b40b28a33e064$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($578b40b28a33e064$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $578b40b28a33e064$var$decodeComponents(tokens, i).join('');
            tokens = input.match($578b40b28a33e064$var$singleMatcher) || [];
        }
        return input;
    }
}
function $578b40b28a33e064$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $578b40b28a33e064$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $578b40b28a33e064$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $578b40b28a33e064$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $578b40b28a33e064$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("8GHHs", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("310XO", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});

parcelRegister("iSMQS", function(module, exports) {

var $epqyT = parcelRequire("epqyT");


var $ewjj9 = parcelRequire("ewjj9");

class $a4fe5d5c8f4d3ad2$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        this.compressFn = void 0;
        this.predicate = void 0;
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ this.canCompress = (event)=>{
            try {
                return event && (0, $epqyT.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        };
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ this.compress = (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $ewjj9.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $epqyT.validateActionEventType)(event.eventType);
                (0, $epqyT.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        };
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}
module.exports["CompressionRule"] = $a4fe5d5c8f4d3ad2$export$89b3253ddfd2e6e8;

});

parcelRegister("epqyT", function(module, exports) {

var $5DUgU = parcelRequire("5DUgU");


var $bKFjF = parcelRequire("bKFjF");

const $de815167dc148761$var$actionEventTypes = Object.freeze([
    (0, $5DUgU.eventType).OPERATIONAL,
    (0, $5DUgU.eventType).TRACK,
    (0, $5DUgU.eventType).UI
]);
function $de815167dc148761$export$df8ff30e3c960006(container) {
    if (!(0, $bKFjF.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $de815167dc148761$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$de815167dc148761$export$df8ff30e3c960006(container));
}
function $de815167dc148761$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $5DUgU.eventType).OPERATIONAL:
        case (0, $5DUgU.eventType).TRACK:
        case (0, $5DUgU.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $de815167dc148761$export$4a8d7476662aebcc(type) {
    if (!$de815167dc148761$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$de815167dc148761$var$actionEventTypes}]`);
    return true;
}
function $de815167dc148761$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $de815167dc148761$export$e63ea5d8477971d3(event.containers);
}
function $de815167dc148761$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $de815167dc148761$export$8c014fd74b0c8b99(event) {
    $de815167dc148761$export$e0c121325c66ed4c(event);
}
function $de815167dc148761$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $de815167dc148761$export$e5bac0930c812e90(event) {
    $de815167dc148761$export$e0c121325c66ed4c(event);
}
function $de815167dc148761$export$1e561554275607ef(event) {
    $de815167dc148761$export$e0c121325c66ed4c(event);
}
function $de815167dc148761$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $5DUgU.isType)((0, $5DUgU.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $5DUgU.objectValues)((0, $5DUgU.userType))}]`);
}
function $de815167dc148761$export$801b46c35394d316(productInfo) {
    if (!(0, $5DUgU.isType)((0, $5DUgU.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $5DUgU.objectValues)((0, $5DUgU.platformType))}]`);
    if (productInfo.origin === (0, $5DUgU.originType).DESKTOP && !(0, $5DUgU.isType)((0, $5DUgU.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $5DUgU.originType).WEB && !(0, $5DUgU.isType)((0, $5DUgU.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}
module.exports["validateContainers"] = $de815167dc148761$export$e63ea5d8477971d3;
module.exports["isActionEventType"] = $de815167dc148761$export$d19cebda16f7579a;
module.exports["validateActionEventType"] = $de815167dc148761$export$4a8d7476662aebcc;
module.exports["validateActionEvent"] = $de815167dc148761$export$e0c121325c66ed4c;
module.exports["validateScreenEvent"] = $de815167dc148761$export$dc993432a592dc27;
module.exports["validateTrackEvent"] = $de815167dc148761$export$8c014fd74b0c8b99;
module.exports["validateDwellBaseEvent"] = $de815167dc148761$export$39d6334da9a44984;
module.exports["validateUIEvent"] = $de815167dc148761$export$e5bac0930c812e90;
module.exports["validateOperationalEvent"] = $de815167dc148761$export$1e561554275607ef;
module.exports["validateIdentifyEvent"] = $de815167dc148761$export$c16a4e16aa4026c0;
module.exports["validatePlatform"] = $de815167dc148761$export$801b46c35394d316;

});

parcelRegister("jFax1", function(module, exports) {
var $23e03d9a7e96f25d$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});
module.exports["StopLowPriorityEventDelayReason"] = $23e03d9a7e96f25d$export$fa6e3729c21cb8f;

});

parcelRegister("hVXIk", function(module, exports) {
var $633a56c35f8a61f6$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $633a56c35f8a61f6$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});
module.exports["ResilienceMechanism"] = $633a56c35f8a61f6$export$c75161629e3ec34e;
module.exports["NetworkStatusEnum"] = $633a56c35f8a61f6$export$ee138fa712d11b84;

});

parcelRegister("917iu", function(module, exports) {
$parcel$export(module.exports, "default", () => $6909de25ff64fab5$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $2Hy4R = parcelRequire("2Hy4R");


var $b5utg = parcelRequire("b5utg");

// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $6909de25ff64fab5$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $6909de25ff64fab5$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeft = (0, $egXhZ.default)(dirtyDateLeft);
    var dateRight = (0, $egXhZ.default)(dirtyDateRight);
    var sign = $6909de25ff64fab5$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $2Hy4R.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($6909de25ff64fab5$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("egXhZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6408ceb2925c7b5$export$2e2bcd8739ae039);

var $da6O1 = parcelRequire("da6O1");


var $b5utg = parcelRequire("b5utg");

function $a6408ceb2925c7b5$export$2e2bcd8739ae039(argument) {
    (0, $b5utg.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $da6O1.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});

parcelRegister("da6O1", function(module, exports) {
$parcel$export(module.exports, "default", () => $99517d09459ad8b9$export$2e2bcd8739ae039);
function $99517d09459ad8b9$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $99517d09459ad8b9$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $99517d09459ad8b9$export$2e2bcd8739ae039(o);
}

});

parcelRegister("b5utg", function(module, exports) {
$parcel$export(module.exports, "default", () => $8127cc3fb530f734$export$2e2bcd8739ae039);
function $8127cc3fb530f734$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});

parcelRegister("2Hy4R", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f7a07f5d911bb21$export$2e2bcd8739ae039);

var $qc9ak = parcelRequire("qc9ak");


var $dhNqt = parcelRequire("dhNqt");


var $b5utg = parcelRequire("b5utg");

var $1f7a07f5d911bb21$var$MILLISECONDS_IN_DAY = 86400000;
function $1f7a07f5d911bb21$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var startOfDayLeft = (0, $dhNqt.default)(dirtyDateLeft);
    var startOfDayRight = (0, $dhNqt.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $qc9ak.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $qc9ak.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $1f7a07f5d911bb21$var$MILLISECONDS_IN_DAY);
}

});

parcelRegister("qc9ak", function(module, exports) {
$parcel$export(module.exports, "default", () => $04ebd9ee2f961c19$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $04ebd9ee2f961c19$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("dhNqt", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ac333dad7296427$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9ac333dad7296427$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("5k5F7", function(module, exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("kNag8", function(module, exports) {
'use strict';
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $8508f86d37feb6a5$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $8508f86d37feb6a5$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $8508f86d37feb6a5$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$8508f86d37feb6a5$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $8508f86d37feb6a5$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$8508f86d37feb6a5$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $8508f86d37feb6a5$var$matcher.test(string);
};


/**
 * Expose `traverse`.
 */ module.exports = $f230577fedc3b30e$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $f230577fedc3b30e$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $f230577fedc3b30e$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $f230577fedc3b30e$var$traverseArray(input, strict);
    else if ($8508f86d37feb6a5$export$226b3eccf92c9ed9(input, strict)) return $8508f86d37feb6a5$export$98e6a39c04603d36(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $f230577fedc3b30e$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $f230577fedc3b30e$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $f230577fedc3b30e$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $f230577fedc3b30e$var$traverse(value, strict);
    });
    return arr;
}

});

parcelRegister("27y2X", function(module, exports) {

var $hs90m = parcelRequire("hs90m");

const $6bca2d59b6606ecd$export$322c2f7d58c321eb = [
    {
        action: 'measured',
        actionSubject: 'performance',
        source: 'performance',
        attributes: {
            properties: {
                'event:type': 'page-load'
            }
        }
    },
    {
        action: 'measured',
        actionSubject: 'performance',
        source: 'performance',
        attributes: {
            properties: {
                'event:key': 'confluence.fe.page-segment-load.content-renderer'
            }
        }
    }
];
const $6bca2d59b6606ecd$export$a4c2a3f0b2be7eb = (event, matchers)=>{
    if (typeof event !== 'object' || !event) return false;
    return matchers.some((matcher)=>(0, (/*@__PURE__*/$parcel$interopDefault($hs90m)))(event, matcher));
};
module.exports["defaultEventMatchers"] = $6bca2d59b6606ecd$export$322c2f7d58c321eb;
module.exports["isAllowedEvent"] = $6bca2d59b6606ecd$export$a4c2a3f0b2be7eb;

});

parcelRegister("hs90m", function(module, exports) {

var $6Ovzg = parcelRequire("6Ovzg");


var $bJedp = parcelRequire("bJedp");

/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */ function $cb4c095e866cbf5f$var$isMatch(object, source) {
    return object === source || $6Ovzg(object, source, $bJedp(source));
}
module.exports = $cb4c095e866cbf5f$var$isMatch;

});

parcelRegister("6Ovzg", function(module, exports) {

var $en5bh = parcelRequire("en5bh");


var $cndcq = parcelRequire("cndcq");

/** Used to compose bitmasks for value comparisons. */ var $4f5fe64f3aee6b87$var$COMPARE_PARTIAL_FLAG = 1, $4f5fe64f3aee6b87$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $4f5fe64f3aee6b87$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $en5bh;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $cndcq(srcValue, objValue, $4f5fe64f3aee6b87$var$COMPARE_PARTIAL_FLAG | $4f5fe64f3aee6b87$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $4f5fe64f3aee6b87$var$baseIsMatch;

});

parcelRegister("en5bh", function(module, exports) {

var $2JXSR = parcelRequire("2JXSR");

var $006ed61947f398be$exports = {};



/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $006ed61947f398be$var$stackClear() {
    this.__data__ = new $2JXSR;
    this.size = 0;
}
$006ed61947f398be$exports = $006ed61947f398be$var$stackClear;


var $83f90e7e70a1064b$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $83f90e7e70a1064b$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$83f90e7e70a1064b$exports = $83f90e7e70a1064b$var$stackDelete;


var $41440166ac69447d$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $41440166ac69447d$var$stackGet(key) {
    return this.__data__.get(key);
}
$41440166ac69447d$exports = $41440166ac69447d$var$stackGet;


var $f97b81949248123f$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f97b81949248123f$var$stackHas(key) {
    return this.__data__.has(key);
}
$f97b81949248123f$exports = $f97b81949248123f$var$stackHas;


var $8950b6a7efdabf5f$exports = {};




var $iiQrz = parcelRequire("iiQrz");


var $aSUgi = parcelRequire("aSUgi");

/** Used as the size to enable large array optimizations. */ var $8950b6a7efdabf5f$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $8950b6a7efdabf5f$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $2JXSR) {
        var pairs = data.__data__;
        if (!$iiQrz || pairs.length < $8950b6a7efdabf5f$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $aSUgi(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$8950b6a7efdabf5f$exports = $8950b6a7efdabf5f$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a7673b82a1b9f916$var$Stack(entries) {
    var data = this.__data__ = new $2JXSR(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$a7673b82a1b9f916$var$Stack.prototype.clear = $006ed61947f398be$exports;
$a7673b82a1b9f916$var$Stack.prototype['delete'] = $83f90e7e70a1064b$exports;
$a7673b82a1b9f916$var$Stack.prototype.get = $41440166ac69447d$exports;
$a7673b82a1b9f916$var$Stack.prototype.has = $f97b81949248123f$exports;
$a7673b82a1b9f916$var$Stack.prototype.set = $8950b6a7efdabf5f$exports;
module.exports = $a7673b82a1b9f916$var$Stack;

});

parcelRegister("bsrY7", function(module, exports) {

var $9vwa5 = parcelRequire("9vwa5");


var $lc9ud = parcelRequire("lc9ud");

/** `Object#toString` result references. */ var $85780136ccfd005a$var$asyncTag = '[object AsyncFunction]', $85780136ccfd005a$var$funcTag = '[object Function]', $85780136ccfd005a$var$genTag = '[object GeneratorFunction]', $85780136ccfd005a$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $85780136ccfd005a$var$isFunction(value) {
    if (!$lc9ud(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $9vwa5(value);
    return tag == $85780136ccfd005a$var$funcTag || tag == $85780136ccfd005a$var$genTag || tag == $85780136ccfd005a$var$asyncTag || tag == $85780136ccfd005a$var$proxyTag;
}
module.exports = $85780136ccfd005a$var$isFunction;

});

parcelRegister("9vwa5", function(module, exports) {

var $agzqu = parcelRequire("agzqu");

var $eba340894e364f73$exports = {};



/** Used for built-in method references. */ var $eba340894e364f73$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $eba340894e364f73$var$hasOwnProperty = $eba340894e364f73$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $eba340894e364f73$var$nativeObjectToString = $eba340894e364f73$var$objectProto.toString;
/** Built-in value references. */ var $eba340894e364f73$var$symToStringTag = $agzqu ? $agzqu.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $eba340894e364f73$var$getRawTag(value) {
    var isOwn = $eba340894e364f73$var$hasOwnProperty.call(value, $eba340894e364f73$var$symToStringTag), tag = value[$eba340894e364f73$var$symToStringTag];
    try {
        value[$eba340894e364f73$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $eba340894e364f73$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$eba340894e364f73$var$symToStringTag] = tag;
        else delete value[$eba340894e364f73$var$symToStringTag];
    }
    return result;
}
$eba340894e364f73$exports = $eba340894e364f73$var$getRawTag;


var $22100740005a4055$exports = {};
/** Used for built-in method references. */ var $22100740005a4055$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $22100740005a4055$var$nativeObjectToString = $22100740005a4055$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $22100740005a4055$var$objectToString(value) {
    return $22100740005a4055$var$nativeObjectToString.call(value);
}
$22100740005a4055$exports = $22100740005a4055$var$objectToString;


/** `Object#toString` result references. */ var $6ebff4ef8160a58c$var$nullTag = '[object Null]', $6ebff4ef8160a58c$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $6ebff4ef8160a58c$var$symToStringTag = $agzqu ? $agzqu.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $6ebff4ef8160a58c$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $6ebff4ef8160a58c$var$undefinedTag : $6ebff4ef8160a58c$var$nullTag;
    return $6ebff4ef8160a58c$var$symToStringTag && $6ebff4ef8160a58c$var$symToStringTag in Object(value) ? $eba340894e364f73$exports(value) : $22100740005a4055$exports(value);
}
module.exports = $6ebff4ef8160a58c$var$baseGetTag;

});

parcelRegister("agzqu", function(module, exports) {

var $c2Pwh = parcelRequire("c2Pwh");

/** Built-in value references. */ var $7796e0e5b05fdeee$var$Symbol = $c2Pwh.Symbol;
module.exports = $7796e0e5b05fdeee$var$Symbol;

});

parcelRegister("c2Pwh", function(module, exports) {

var $2ivnr = parcelRequire("2ivnr");

/** Detect free variable `self`. */ var $8c4da2a989229806$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $8c4da2a989229806$var$root = $2ivnr || $8c4da2a989229806$var$freeSelf || Function('return this')();
module.exports = $8c4da2a989229806$var$root;

});

parcelRegister("lc9ud", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f6e213bafe8227ef$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $f6e213bafe8227ef$var$isObject;

});

parcelRegister("cndcq", function(module, exports) {
var $d505519d8eb5f980$exports = {};

var $en5bh = parcelRequire("en5bh");

var $e27a8e86b9c81b54$exports = {};

var $jcOUW = parcelRequire("jcOUW");


var $eZD4P = parcelRequire("eZD4P");


var $bcPN2 = parcelRequire("bcPN2");

/** Used to compose bitmasks for value comparisons. */ var $e27a8e86b9c81b54$var$COMPARE_PARTIAL_FLAG = 1, $e27a8e86b9c81b54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $e27a8e86b9c81b54$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $e27a8e86b9c81b54$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $e27a8e86b9c81b54$var$COMPARE_UNORDERED_FLAG ? new $jcOUW : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$eZD4P(other, function(othValue, othIndex) {
                if (!$bcPN2(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$e27a8e86b9c81b54$exports = $e27a8e86b9c81b54$var$equalArrays;


var $065d77c28f320003$exports = {};

var $agzqu = parcelRequire("agzqu");


var $egtNM = parcelRequire("egtNM");


var $ERH8u = parcelRequire("ERH8u");


var $28f653747fef453c$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $28f653747fef453c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$28f653747fef453c$exports = $28f653747fef453c$var$mapToArray;



var $fTWVK = parcelRequire("fTWVK");

/** Used to compose bitmasks for value comparisons. */ var $065d77c28f320003$var$COMPARE_PARTIAL_FLAG = 1, $065d77c28f320003$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $065d77c28f320003$var$boolTag = '[object Boolean]', $065d77c28f320003$var$dateTag = '[object Date]', $065d77c28f320003$var$errorTag = '[object Error]', $065d77c28f320003$var$mapTag = '[object Map]', $065d77c28f320003$var$numberTag = '[object Number]', $065d77c28f320003$var$regexpTag = '[object RegExp]', $065d77c28f320003$var$setTag = '[object Set]', $065d77c28f320003$var$stringTag = '[object String]', $065d77c28f320003$var$symbolTag = '[object Symbol]';
var $065d77c28f320003$var$arrayBufferTag = '[object ArrayBuffer]', $065d77c28f320003$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $065d77c28f320003$var$symbolProto = $agzqu ? $agzqu.prototype : undefined, $065d77c28f320003$var$symbolValueOf = $065d77c28f320003$var$symbolProto ? $065d77c28f320003$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $065d77c28f320003$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $065d77c28f320003$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $065d77c28f320003$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $egtNM(object), new $egtNM(other))) return false;
            return true;
        case $065d77c28f320003$var$boolTag:
        case $065d77c28f320003$var$dateTag:
        case $065d77c28f320003$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $ERH8u(+object, +other);
        case $065d77c28f320003$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $065d77c28f320003$var$regexpTag:
        case $065d77c28f320003$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $065d77c28f320003$var$mapTag:
            var convert = $28f653747fef453c$exports;
        case $065d77c28f320003$var$setTag:
            var isPartial = bitmask & $065d77c28f320003$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $fTWVK);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $065d77c28f320003$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $e27a8e86b9c81b54$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $065d77c28f320003$var$symbolTag:
            if ($065d77c28f320003$var$symbolValueOf) return $065d77c28f320003$var$symbolValueOf.call(object) == $065d77c28f320003$var$symbolValueOf.call(other);
    }
    return false;
}
$065d77c28f320003$exports = $065d77c28f320003$var$equalByTag;


var $818178fab546b5ba$exports = {};

var $d5B92 = parcelRequire("d5B92");

/** Used to compose bitmasks for value comparisons. */ var $818178fab546b5ba$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $818178fab546b5ba$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $818178fab546b5ba$var$hasOwnProperty = $818178fab546b5ba$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $818178fab546b5ba$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $818178fab546b5ba$var$COMPARE_PARTIAL_FLAG, objProps = $d5B92(object), objLength = objProps.length, othProps = $d5B92(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $818178fab546b5ba$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$818178fab546b5ba$exports = $818178fab546b5ba$var$equalObjects;



var $1WABR = parcelRequire("1WABR");


var $fZxmY = parcelRequire("fZxmY");


var $cSA01 = parcelRequire("cSA01");


var $gQUlr = parcelRequire("gQUlr");

/** Used to compose bitmasks for value comparisons. */ var $d505519d8eb5f980$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $d505519d8eb5f980$var$argsTag = '[object Arguments]', $d505519d8eb5f980$var$arrayTag = '[object Array]', $d505519d8eb5f980$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $d505519d8eb5f980$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d505519d8eb5f980$var$hasOwnProperty = $d505519d8eb5f980$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $d505519d8eb5f980$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $fZxmY(object), othIsArr = $fZxmY(other), objTag = objIsArr ? $d505519d8eb5f980$var$arrayTag : $1WABR(object), othTag = othIsArr ? $d505519d8eb5f980$var$arrayTag : $1WABR(other);
    objTag = objTag == $d505519d8eb5f980$var$argsTag ? $d505519d8eb5f980$var$objectTag : objTag;
    othTag = othTag == $d505519d8eb5f980$var$argsTag ? $d505519d8eb5f980$var$objectTag : othTag;
    var objIsObj = objTag == $d505519d8eb5f980$var$objectTag, othIsObj = othTag == $d505519d8eb5f980$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $cSA01(object)) {
        if (!$cSA01(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $en5bh);
        return objIsArr || $gQUlr(object) ? $e27a8e86b9c81b54$exports(object, other, bitmask, customizer, equalFunc, stack) : $065d77c28f320003$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $d505519d8eb5f980$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $d505519d8eb5f980$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $d505519d8eb5f980$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $en5bh);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $en5bh);
    return $818178fab546b5ba$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$d505519d8eb5f980$exports = $d505519d8eb5f980$var$baseIsEqualDeep;



var $6eZU2 = parcelRequire("6eZU2");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $9021df226c69b911$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$6eZU2(value) && !$6eZU2(other)) return value !== value && other !== other;
    return $d505519d8eb5f980$exports(value, other, bitmask, customizer, $9021df226c69b911$var$baseIsEqual, stack);
}
module.exports = $9021df226c69b911$var$baseIsEqual;

});

parcelRegister("jcOUW", function(module, exports) {

var $aSUgi = parcelRequire("aSUgi");

var $d7d3087611c3f5b8$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $d7d3087611c3f5b8$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $d7d3087611c3f5b8$var$setCacheAdd(value) {
    this.__data__.set(value, $d7d3087611c3f5b8$var$HASH_UNDEFINED);
    return this;
}
$d7d3087611c3f5b8$exports = $d7d3087611c3f5b8$var$setCacheAdd;


var $3452311faf5060f7$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $3452311faf5060f7$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$3452311faf5060f7$exports = $3452311faf5060f7$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $dfb6a2719f7e6d5e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $aSUgi;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$dfb6a2719f7e6d5e$var$SetCache.prototype.add = $dfb6a2719f7e6d5e$var$SetCache.prototype.push = $d7d3087611c3f5b8$exports;
$dfb6a2719f7e6d5e$var$SetCache.prototype.has = $3452311faf5060f7$exports;
module.exports = $dfb6a2719f7e6d5e$var$SetCache;

});

parcelRegister("eZD4P", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aea5131110d8b0d2$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $aea5131110d8b0d2$var$arraySome;

});

parcelRegister("bcPN2", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8288fd1d15597d3e$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $8288fd1d15597d3e$var$cacheHas;

});

parcelRegister("fTWVK", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $b939b46c5461ae3f$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $b939b46c5461ae3f$var$setToArray;

});

parcelRegister("d5B92", function(module, exports) {

var $dJQeL = parcelRequire("dJQeL");


var $jcne3 = parcelRequire("jcne3");


var $d6TaN = parcelRequire("d6TaN");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $98788e2f4d5d731a$var$getAllKeys(object) {
    return $dJQeL(object, $d6TaN, $jcne3);
}
module.exports = $98788e2f4d5d731a$var$getAllKeys;

});

parcelRegister("hwwIB", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc1ece06d981ba55$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $cc1ece06d981ba55$var$arrayPush;

});

parcelRegister("fZxmY", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $ba46700396bf6179$var$isArray = Array.isArray;
module.exports = $ba46700396bf6179$var$isArray;

});

parcelRegister("jcne3", function(module, exports) {

var $2z7Y0 = parcelRequire("2z7Y0");


var $2l40N = parcelRequire("2l40N");

/** Used for built-in method references. */ var $dfa1277269eccb68$var$objectProto = Object.prototype;
/** Built-in value references. */ var $dfa1277269eccb68$var$propertyIsEnumerable = $dfa1277269eccb68$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $dfa1277269eccb68$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $dfa1277269eccb68$var$getSymbols = !$dfa1277269eccb68$var$nativeGetSymbols ? $2l40N : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $2z7Y0($dfa1277269eccb68$var$nativeGetSymbols(object), function(symbol) {
        return $dfa1277269eccb68$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $dfa1277269eccb68$var$getSymbols;

});

parcelRegister("2z7Y0", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $1de507b617789b23$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $1de507b617789b23$var$arrayFilter;

});

parcelRegister("d6TaN", function(module, exports) {

var $dP6hW = parcelRequire("dP6hW");


var $eHPLt = parcelRequire("eHPLt");


var $bRRFB = parcelRequire("bRRFB");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $98b6a2243c7233d6$var$keys(object) {
    return $bRRFB(object) ? $dP6hW(object) : $eHPLt(object);
}
module.exports = $98b6a2243c7233d6$var$keys;

});

parcelRegister("jr8iR", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $e266fac6f0619428$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $e266fac6f0619428$var$baseTimes;

});

parcelRegister("dI6Ko", function(module, exports) {
var $ad10a14e42f9734e$exports = {};

var $9vwa5 = parcelRequire("9vwa5");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $ad10a14e42f9734e$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ad10a14e42f9734e$var$baseIsArguments(value) {
    return $6eZU2(value) && $9vwa5(value) == $ad10a14e42f9734e$var$argsTag;
}
$ad10a14e42f9734e$exports = $ad10a14e42f9734e$var$baseIsArguments;





/** Used for built-in method references. */ var $9fb49e4f974d6254$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9fb49e4f974d6254$var$hasOwnProperty = $9fb49e4f974d6254$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $9fb49e4f974d6254$var$propertyIsEnumerable = $9fb49e4f974d6254$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $9fb49e4f974d6254$var$isArguments = $ad10a14e42f9734e$exports(function() {
    return arguments;
}()) ? $ad10a14e42f9734e$exports : function(value) {
    return $6eZU2(value) && $9fb49e4f974d6254$var$hasOwnProperty.call(value, 'callee') && !$9fb49e4f974d6254$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $9fb49e4f974d6254$var$isArguments;

});

parcelRegister("6eZU2", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $48b4117a40f78db6$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $48b4117a40f78db6$var$isObjectLike;

});

parcelRegister("cSA01", function(module, exports) {

var $c2Pwh = parcelRequire("c2Pwh");

var $624b4e7b059b4781$exports = {};
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $624b4e7b059b4781$var$stubFalse() {
    return false;
}
$624b4e7b059b4781$exports = $624b4e7b059b4781$var$stubFalse;


/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $c2Pwh.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $624b4e7b059b4781$exports;
module.exports = isBuffer;

});

parcelRegister("1UktQ", function(module, exports) {
/** Used as references for various `Number` constants. */ var $163ae85e60d52b17$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $163ae85e60d52b17$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $163ae85e60d52b17$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $163ae85e60d52b17$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $163ae85e60d52b17$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $163ae85e60d52b17$var$isIndex;

});

parcelRegister("gQUlr", function(module, exports) {
var $d4d0cd89c74ec9ba$exports = {};

var $9vwa5 = parcelRequire("9vwa5");


var $4CWcc = parcelRequire("4CWcc");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $d4d0cd89c74ec9ba$var$argsTag = '[object Arguments]', $d4d0cd89c74ec9ba$var$arrayTag = '[object Array]', $d4d0cd89c74ec9ba$var$boolTag = '[object Boolean]', $d4d0cd89c74ec9ba$var$dateTag = '[object Date]', $d4d0cd89c74ec9ba$var$errorTag = '[object Error]', $d4d0cd89c74ec9ba$var$funcTag = '[object Function]', $d4d0cd89c74ec9ba$var$mapTag = '[object Map]', $d4d0cd89c74ec9ba$var$numberTag = '[object Number]', $d4d0cd89c74ec9ba$var$objectTag = '[object Object]', $d4d0cd89c74ec9ba$var$regexpTag = '[object RegExp]', $d4d0cd89c74ec9ba$var$setTag = '[object Set]', $d4d0cd89c74ec9ba$var$stringTag = '[object String]', $d4d0cd89c74ec9ba$var$weakMapTag = '[object WeakMap]';
var $d4d0cd89c74ec9ba$var$arrayBufferTag = '[object ArrayBuffer]', $d4d0cd89c74ec9ba$var$dataViewTag = '[object DataView]', $d4d0cd89c74ec9ba$var$float32Tag = '[object Float32Array]', $d4d0cd89c74ec9ba$var$float64Tag = '[object Float64Array]', $d4d0cd89c74ec9ba$var$int8Tag = '[object Int8Array]', $d4d0cd89c74ec9ba$var$int16Tag = '[object Int16Array]', $d4d0cd89c74ec9ba$var$int32Tag = '[object Int32Array]', $d4d0cd89c74ec9ba$var$uint8Tag = '[object Uint8Array]', $d4d0cd89c74ec9ba$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d4d0cd89c74ec9ba$var$uint16Tag = '[object Uint16Array]', $d4d0cd89c74ec9ba$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $d4d0cd89c74ec9ba$var$typedArrayTags = {};
$d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$float32Tag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$float64Tag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$int8Tag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$int16Tag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$int32Tag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$uint8Tag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$uint8ClampedTag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$uint16Tag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$uint32Tag] = true;
$d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$argsTag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$arrayTag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$arrayBufferTag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$boolTag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$dataViewTag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$dateTag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$errorTag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$funcTag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$mapTag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$numberTag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$objectTag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$regexpTag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$setTag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$stringTag] = $d4d0cd89c74ec9ba$var$typedArrayTags[$d4d0cd89c74ec9ba$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $d4d0cd89c74ec9ba$var$baseIsTypedArray(value) {
    return $6eZU2(value) && $4CWcc(value.length) && !!$d4d0cd89c74ec9ba$var$typedArrayTags[$9vwa5(value)];
}
$d4d0cd89c74ec9ba$exports = $d4d0cd89c74ec9ba$var$baseIsTypedArray;



var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $c44d359597573088$var$nodeIsTypedArray = $cl53l && $cl53l.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $c44d359597573088$var$isTypedArray = $c44d359597573088$var$nodeIsTypedArray ? $dFnBO($c44d359597573088$var$nodeIsTypedArray) : $d4d0cd89c74ec9ba$exports;
module.exports = $c44d359597573088$var$isTypedArray;

});

parcelRegister("dFnBO", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $9f316aecacb93882$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $9f316aecacb93882$var$baseUnary;

});

parcelRegister("cl53l", function(module, exports) {

var $2ivnr = parcelRequire("2ivnr");

/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $2ivnr.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("eHPLt", function(module, exports) {

var $erbrP = parcelRequire("erbrP");

var $0272c30edae1319c$exports = {};

var $bmalB = parcelRequire("bmalB");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $0272c30edae1319c$var$nativeKeys = $bmalB(Object.keys, Object);
$0272c30edae1319c$exports = $0272c30edae1319c$var$nativeKeys;


/** Used for built-in method references. */ var $ab4d3c3f2bf76f0b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ab4d3c3f2bf76f0b$var$hasOwnProperty = $ab4d3c3f2bf76f0b$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ab4d3c3f2bf76f0b$var$baseKeys(object) {
    if (!$erbrP(object)) return $0272c30edae1319c$exports(object);
    var result = [];
    for(var key in Object(object))if ($ab4d3c3f2bf76f0b$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $ab4d3c3f2bf76f0b$var$baseKeys;

});

parcelRegister("erbrP", function(module, exports) {
/** Used for built-in method references. */ var $a82c779c6457cc62$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $a82c779c6457cc62$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $a82c779c6457cc62$var$objectProto;
    return value === proto;
}
module.exports = $a82c779c6457cc62$var$isPrototype;

});

parcelRegister("bRRFB", function(module, exports) {

var $bsrY7 = parcelRequire("bsrY7");


var $4CWcc = parcelRequire("4CWcc");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $8a3e46b3b617983f$var$isArrayLike(value) {
    return value != null && $4CWcc(value.length) && !$bsrY7(value);
}
module.exports = $8a3e46b3b617983f$var$isArrayLike;

});

parcelRegister("1WABR", function(module, exports) {
var $13f26db8b3b3d40d$exports = {};

var $k1Lsb = parcelRequire("k1Lsb");


var $c2Pwh = parcelRequire("c2Pwh");

/* Built-in method references that are verified to be native. */ var $13f26db8b3b3d40d$var$DataView = $k1Lsb($c2Pwh, 'DataView');
$13f26db8b3b3d40d$exports = $13f26db8b3b3d40d$var$DataView;



var $iiQrz = parcelRequire("iiQrz");

var $2759c2c950b528de$exports = {};






/* Built-in method references that are verified to be native. */ var $2759c2c950b528de$var$Promise = $k1Lsb($c2Pwh, 'Promise');
$2759c2c950b528de$exports = $2759c2c950b528de$var$Promise;



var $l57m2 = parcelRequire("l57m2");


var $2623w = parcelRequire("2623w");


var $9vwa5 = parcelRequire("9vwa5");


var $gnC5r = parcelRequire("gnC5r");

/** `Object#toString` result references. */ var $16a79b29c75e63e2$var$mapTag = '[object Map]', $16a79b29c75e63e2$var$objectTag = '[object Object]', $16a79b29c75e63e2$var$promiseTag = '[object Promise]', $16a79b29c75e63e2$var$setTag = '[object Set]', $16a79b29c75e63e2$var$weakMapTag = '[object WeakMap]';
var $16a79b29c75e63e2$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $16a79b29c75e63e2$var$dataViewCtorString = $gnC5r($13f26db8b3b3d40d$exports), $16a79b29c75e63e2$var$mapCtorString = $gnC5r($iiQrz), $16a79b29c75e63e2$var$promiseCtorString = $gnC5r($2759c2c950b528de$exports), $16a79b29c75e63e2$var$setCtorString = $gnC5r($l57m2), $16a79b29c75e63e2$var$weakMapCtorString = $gnC5r($2623w);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $16a79b29c75e63e2$var$getTag = $9vwa5;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($13f26db8b3b3d40d$exports && $16a79b29c75e63e2$var$getTag(new $13f26db8b3b3d40d$exports(new ArrayBuffer(1))) != $16a79b29c75e63e2$var$dataViewTag || $iiQrz && $16a79b29c75e63e2$var$getTag(new $iiQrz) != $16a79b29c75e63e2$var$mapTag || $2759c2c950b528de$exports && $16a79b29c75e63e2$var$getTag($2759c2c950b528de$exports.resolve()) != $16a79b29c75e63e2$var$promiseTag || $l57m2 && $16a79b29c75e63e2$var$getTag(new $l57m2) != $16a79b29c75e63e2$var$setTag || $2623w && $16a79b29c75e63e2$var$getTag(new $2623w) != $16a79b29c75e63e2$var$weakMapTag) $16a79b29c75e63e2$var$getTag = function(value) {
    var result = $9vwa5(value), Ctor = result == $16a79b29c75e63e2$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $gnC5r(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $16a79b29c75e63e2$var$dataViewCtorString:
            return $16a79b29c75e63e2$var$dataViewTag;
        case $16a79b29c75e63e2$var$mapCtorString:
            return $16a79b29c75e63e2$var$mapTag;
        case $16a79b29c75e63e2$var$promiseCtorString:
            return $16a79b29c75e63e2$var$promiseTag;
        case $16a79b29c75e63e2$var$setCtorString:
            return $16a79b29c75e63e2$var$setTag;
        case $16a79b29c75e63e2$var$weakMapCtorString:
            return $16a79b29c75e63e2$var$weakMapTag;
    }
    return result;
};
module.exports = $16a79b29c75e63e2$var$getTag;

});

parcelRegister("l57m2", function(module, exports) {

var $k1Lsb = parcelRequire("k1Lsb");


var $c2Pwh = parcelRequire("c2Pwh");

/* Built-in method references that are verified to be native. */ var $f58fc510e733475a$var$Set = $k1Lsb($c2Pwh, 'Set');
module.exports = $f58fc510e733475a$var$Set;

});

parcelRegister("2623w", function(module, exports) {

var $k1Lsb = parcelRequire("k1Lsb");


var $c2Pwh = parcelRequire("c2Pwh");

/* Built-in method references that are verified to be native. */ var $186dbc8bc46f73a8$var$WeakMap = $k1Lsb($c2Pwh, 'WeakMap');
module.exports = $186dbc8bc46f73a8$var$WeakMap;

});

parcelRegister("bJedp", function(module, exports) {

var $45dI4 = parcelRequire("45dI4");


var $d6TaN = parcelRequire("d6TaN");

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $02341c96cefc58a4$var$getMatchData(object) {
    var result = $d6TaN(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $45dI4(value)
        ];
    }
    return result;
}
module.exports = $02341c96cefc58a4$var$getMatchData;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("ge2sX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6X8o4 = parcelRequire("6X8o4");


var $iC5L0 = parcelRequire("iC5L0");


var $9WAeG = parcelRequire("9WAeG");


var $5ZqQS = parcelRequire("5ZqQS");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $gFHOP = parcelRequire("gFHOP");

function $65cf320a85975377$var$apolloQuery({ query: query, queryName: queryName, client: client = window.GLOBAL_APOLLO_CLIENT }) {
    if (!client) return Promise.reject(new Error(`ApolloClient not available, cannot load query ${queryName}`));
    return (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/fetch:${queryName}`, async ()=>client.query({
            query: query,
            errorPolicy: 'all',
            fetchPolicy: 'cache-first',
            context: {
                single: false,
                allowOnExternalPage: true
            }
        }));
}
async function $65cf320a85975377$export$5ae208508f6870b() {
    // __SITEINFORMATION__ is either actual session data
    // or the promise that is resolving the session data
    // In the case when page is rendered by SSR, the __SITEINFORMATION__ will be populated with JSON data.
    if (window['__SITEINFORMATION__']) return window['__SITEINFORMATION__'];
    window['__SITEINFORMATION__'] = $65cf320a85975377$var$apolloQuery({
        query: (0, $gFHOP.SiteInformationQuery),
        queryName: 'SiteInformationQuery'
    }).then((result)=>{
        const errors = result.errors ?? [];
        if (errors.length > 0) errors.forEach((e)=>{
            if ((0, $1uFM6.isUnauthorizedError)(e) && !!result?.data?.tenant?.cloudId) (0, $7Sm4c.markErrorAsHandled)(e);
            else (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                isSiteInformationError: true,
                partialFailure: true,
                attribution: 'FATAL'
            });
        });
        return result.data;
    }).catch((error)=>{
        if (Array.isArray(error)) error.forEach((e)=>(0, $5ZqQS.getMonitoringClient)().submitError(e, {
                isSiteInformationError: true,
                partialFailure: false,
                attribution: 'FATAL'
            }));
        else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            isSiteInformationError: true,
            partialFailure: false,
            attribution: 'FATAL'
        });
        return null;
    });
    return window['__SITEINFORMATION__'];
}


const $49211747c0c1fb72$export$4163744babc94103 = ()=>{
    // Not using memorize here because we want to reset promise in test
    if (window['__SITEINFORMATION_PROMISE__']) return window['__SITEINFORMATION_PROMISE__'];
    return window['__SITEINFORMATION_PROMISE__'] = (0, $6X8o4.liftPromiseState)((0, $65cf320a85975377$export$5ae208508f6870b)().then((0, $iC5L0.processSessionData)));
};
const $49211747c0c1fb72$export$fdd2c0ba94025c3c = ()=>{
    const sessionDataPromise = $49211747c0c1fb72$export$4163744babc94103();
    if ((0, $6X8o4.isResolved)(sessionDataPromise)) return (0, $6X8o4.getValue)(sessionDataPromise)?.cloudId;
    else // Session data is not loaded yet, return null
    return null;
};
class $49211747c0c1fb72$export$14dde3d2ec7dfd8f extends (0, $42omo.Component) {
    componentWillUnmount() {
        this._mount = false;
    }
    render() {
        const { sessionData: sessionData } = this.state;
        if (sessionData) return this.props.children(sessionData);
        if (this.props.renderChildrenWhenLoading === true) return this.props.children({
            loading: true
        });
        return null;
    }
    constructor(props){
        super(props);
        this._mount = void 0;
        this.state = {};
        const promise = $49211747c0c1fb72$export$4163744babc94103();
        this._mount = true;
        if ((0, $6X8o4.isResolved)(promise)) this.state = {
            sessionData: (0, $6X8o4.getValue)(promise)
        };
        else promise.then((sessionData)=>{
            if (this._mount) this.setState({
                sessionData: sessionData
            });
        });
    }
}
module.exports["getSessionData"] = $49211747c0c1fb72$export$4163744babc94103;
module.exports["getCloudId"] = $49211747c0c1fb72$export$fdd2c0ba94025c3c;
module.exports["SessionData"] = $49211747c0c1fb72$export$14dde3d2ec7dfd8f;

});

parcelRegister("iC5L0", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $dh538 = parcelRequire("dh538");


var $8ihu7 = parcelRequire("8ihu7");




var $ECRpY = parcelRequire("ECRpY");


var $iGqJ7 = parcelRequire("iGqJ7");




var $9wGTI = parcelRequire("9wGTI");

function $575a5c9b172039f7$export$30a0bf30ea993fb(value) {
    if (value === 'true') return true;
    else if (value === 'false') return false;
    else if (typeof value === 'object') return JSON.stringify(value);
    return value;
}
function $575a5c9b172039f7$export$254798ec7ef71406(objectList, valueGetter) {
    return objectList.reduce((keyedObject, item)=>{
        keyedObject[item.id] = valueGetter(item);
        return keyedObject;
    }, {});
}
const $575a5c9b172039f7$export$b474714fac955e7c = (flags)=>{
    return $575a5c9b172039f7$export$254798ec7ef71406(flags, (item)=>$575a5c9b172039f7$export$30a0bf30ea993fb(item.value));
};


function $11652f2649e2c81d$var$normalizeValue(rawValue) {
    if (typeof rawValue === 'object' && 'value' in rawValue) return {
        ...rawValue.explanation ? {
            explanation: {
                ...rawValue.explanation
            }
        } : {},
        value: (0, $575a5c9b172039f7$export$30a0bf30ea993fb)(rawValue.value)
    };
    else return {
        value: (0, $575a5c9b172039f7$export$30a0bf30ea993fb)(rawValue),
        explanation: undefined
    };
}
const $11652f2649e2c81d$var$noopAnalyticsHandler = {
    sendOperationalEvent: (_event)=>Promise.resolve()
};
const $11652f2649e2c81d$export$8c9b5e98a87ea54c = (0, $2XqLN.default)((flags, platformFlags)=>{
    const normalizedFeatureFlags = flags ? (0, $575a5c9b172039f7$export$254798ec7ef71406)(flags, $11652f2649e2c81d$var$normalizeValue) : {};
    const normalizedPlatformFeatureFlags = platformFlags != null ? (0, $575a5c9b172039f7$export$254798ec7ef71406)(platformFlags, $11652f2649e2c81d$var$normalizeValue) : {};
    Object.assign(normalizedFeatureFlags, normalizedPlatformFeatureFlags);
    const featureFlagClient = new (0, $ECRpY.default)({
        flags: normalizedFeatureFlags,
        analyticsHandler: $11652f2649e2c81d$var$noopAnalyticsHandler
    });
    // This sets up tooling for the editor experiments
    (0, $8ihu7.setupEditorExperiments)('confluence');
    // This sets up the platform feature flags
    (0, $dh538.setBooleanFeatureFlagResolver)((flagKey)=>{
        // eslint-disable-next-line confluence-feature-gating/static-feature-gates
        if ((0, $9wGTI.fg)(flagKey)) return true;
        return false;
    });
    const allFlags = flags.concat(platformFlags);
    const original = (0, $575a5c9b172039f7$export$b474714fac955e7c)(allFlags);
    return {
        originalFeatureFlags: original,
        featureFlagsWithOverrides: original,
        featureFlagClient: featureFlagClient
    };
});


const $f22ae18572ac4cf5$export$3aa1d70b86d65666 = ()=>$f22ae18572ac4cf5$export$48ea97dcec207a60(null);
function $f22ae18572ac4cf5$export$48ea97dcec207a60(data) {
    const { originalFeatureFlags: originalFeatureFlags, featureFlagsWithOverrides: featureFlagsWithOverrides, featureFlagClient: featureFlagClient } = (0, $11652f2649e2c81d$export$8c9b5e98a87ea54c)([], []);
    // nullability of `tenant` is probably a schema issue
    // `userForAnalytics.id` would probably never be null, follow up with Xiao
    const confluenceLocale = data?.user?.confluence?.locale?.replace('_', '-');
    return {
        shard: data?.tenant?.shard || '',
        cloudId: data?.tenant?.cloudId || '',
        activationId: data?.tenant?.activationId || '',
        orgId: data?.organization?.orgId || undefined,
        environment: data?.tenant?.environment || 'PRODUCTION',
        edition: data?.confluence_tenantContext?.editions?.confluence || null,
        userId: data?.user?.id || null,
        displayName: data?.user?.displayName || null,
        isLoggedIn: Boolean(data?.user?.id),
        // CCP-472: This is for JSD users who are unlicensed for
        // Confluence usage. In that case, we need to skip
        // `WatchDialogQuery` as they are causing NullPointerExceptions
        // in the BE.
        isLicensed: Boolean(data?.user?.confluence?.accountId && data?.user?.confluence?.userKey),
        accessStatus: data?.user?.confluence?.accessStatus || null,
        userIdForAnalytics: data?.userForAnalytics?.id || null,
        featureFlags: featureFlagsWithOverrides,
        featureFlagClient: featureFlagClient,
        _originalFeatureFlags: originalFeatureFlags,
        locale: confluenceLocale || 'en-US',
        timeZone: data?.user?.timeZone || null,
        tenantTimeZone: data?.confluence_tenantContext?.timeZone || null,
        isAdminHubAIEnabled: Boolean(data?.getAIConfig?.isEnabled),
        isRovoEnabled: Boolean(data?.getAIConfig?.isRovoEnabled),
        isRovoLLMEnabled: Boolean(data?.getAIConfig?.isRovoLLMEnabled),
        monolithRegion: data?.confluence_tenantContext?.monolithRegion || null
    };
}
module.exports["getEmptySessionData"] = $f22ae18572ac4cf5$export$3aa1d70b86d65666;
module.exports["processSessionData"] = $f22ae18572ac4cf5$export$48ea97dcec207a60;

});

parcelRegister("8ihu7", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $47435f399fa7774f$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $47435f399fa7774f$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $47435f399fa7774f$export$cf7305fc65acbf0d);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $7Rqpr = parcelRequire("7Rqpr");

const $7251ede4f7239ece$export$7e849a84a00ffd1c = {
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_ai_proactive_ai_nudge_parameters: 'control',
    platform_editor_controls: 'control',
    confluence_whiteboards_quick_insert_aa: 'control',
    confluence_whiteboards_quick_insert: 'control',
    confluence_whiteboards_quick_insert_localised: 'control',
    confluence_whiteboards_quick_insert_localised_aa: 'control',
    platform_editor_insertion: 'control',
    editor_ai_inline_suggestion_date_v2: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_editor_add_orange_highlight_color: 'control',
    platform_editor_ai_iw_adf_streaming: 'control',
    platform_editor_ai_non_iw_adf_streaming: 'control',
    platform_hover_card_preview_panel: 'control',
    platform_hover_card_preview_panel_modal: 'control',
    platform_inline_smartcard_connect_button_exp: 'control',
    confluence_content_mode_replace_dense_with_compact: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_disable_table_overflow_shadows: 'control',
    platform_editor_hoverlink_ui_fixes_exp: 'control',
    platform_editor_table_sticky_header_improvements: 'control'
};
const $7251ede4f7239ece$export$54960937bb713f97 = {
    platform_editor_feedback_mandatory_rating: false,
    platform_editor_preview_panel_responsiveness: false,
    platform_editor_renderer_breakout_fix: false,
    platform_editor_toolbar_aifc: false,
    platform_editor_block_control_optimise_render: false,
    'test-new-experiments-package': false,
    support_table_in_comment: false,
    platform_editor_exp_lazy_node_views: false,
    platform_renderer_table_sticky_scrollbar: false,
    platform_editor_prevent_toolbar_layout_shifts: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    support_table_in_comment_jira: false,
    'nested-tables-in-tables': false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_blockquote_in_text_formatting_menu: false,
    platform_editor_element_drag_and_drop_multiselect: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_offline_editing_web: false,
    platform_editor_tables_drag_and_drop: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_stop_width_reflows: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_ai_quickstart_command: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_ai_remove_trivial_prompts_cc: false,
    platform_editor_find_and_replace_improvements: false,
    platform_editor_toggle_expand_on_match_found: false,
    platform_editor_reduce_noisy_steps_ncs: false,
    cc_improve_writing_on_paste_v2: false,
    platform_editor_text_highlight_padding: false
};


let $47435f399fa7774f$export$e5d73bf4f8e2ae96 = {};
let $47435f399fa7774f$export$4e849416bb5c5b52 = {};
let $47435f399fa7774f$export$cf7305fc65acbf0d;
function $47435f399fa7774f$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $7Rqpr.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $47435f399fa7774f$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !options?.disableTestOverrides) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        const testOverrides = Object.fromEntries(Object.entries((0, $7Rqpr.editorExperimentsConfig)).map(([key, value])=>{
            const defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                groupOverrides?.[key] ?? (0, $7251ede4f7239ece$export$7e849a84a00ffd1c)[key] ?? (0, $7251ede4f7239ece$export$54960937bb713f97)[key] ?? defaultValue
            ];
        }));
        $47435f399fa7774f$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $47435f399fa7774f$export$cf7305fc65acbf0d = product;
    $47435f399fa7774f$export$4e849416bb5c5b52 = paramOverrides || {};
}
module.exports["setupEditorExperiments"] = $47435f399fa7774f$export$1c2b6dbf79eb3560;

});

parcelRegister("7Rqpr", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
function $d057f5e142af87dd$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $d057f5e142af87dd$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($d057f5e142af87dd$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $d057f5e142af87dd$var$IS_TESTING_ENV = false;


function $856a57b67e416c72$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $d057f5e142af87dd$export$f9ce7b637dfbe238),
        defaultValue: config.defaultValue
    };
}
function $856a57b67e416c72$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        typeGuard: (0, $d057f5e142af87dd$export$a9a18ae5ba42aeab)(config.values),
        defaultValue: config.defaultValue
    };
}


const $2b0767b4f0dbf85f$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Editor Platform experiments
    // lwoollard experiments
    // Added 03-09-2025
    cc_editor_limited_mode_include_lcm: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_limited_mode_include_lcm'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 03-09-2025
    cc_editor_interactivity_monitoring: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_interactivity_monitoring'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-30
    // variant 1: remove table overflow shadows completely, no table border shown when scrolling.
    // variant 2: remove table overflow shadows, show table border when scrolling.
    // variant 3: replace table overflow shadows with CSS-only solution.
    platform_editor_disable_table_overflow_shadows: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_disable_table_overflow_shadows'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2',
            'variant3'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_prevent_numbered_column_too_big_jira_1: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            jira: 'editor_prevent_numbered_column_too_big_jira_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_block_control_optimise_render: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_control_optimise_render'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_drag_handle_hover: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_table_drag_handle_hover',
            jira: 'platform_editor_table_drag_handle_hover'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_experience_tracking: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_experience_tracking'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-01
    platform_editor_controls_block_controls_state_fix: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_controls_block_controls_state_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 28-02-2025
    platform_editor_insertion: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_insertion'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-03
    platform_editor_hydratable_ui: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_hydratable_ui'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-14
    platform_editor_resizer_cls_fix: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_resizer_cls_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    editor_ai_inline_suggestion_date_v2: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'editor_ai_inline_suggestion_date_v2'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-31
    platform_editor_lovability_suppress_toolbar_event: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_suppress_toolbar_event',
            jira: 'platform_editor_lovability_suppress_toolbar_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_stop_width_reflows: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_stop_width_reflows'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-15
    platform_editor_no_ssr: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_no_ssr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-14
    platform_editor_jira_advanced_code_blocks: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_jira_advanced_code_blocks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-02
    platform_editor_code_block_fold_gutter: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_code_block_fold_gutter'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-18
    platform_editor_ai_iw_adf_streaming: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf_gemini25flash',
            'adf_gpt41mini'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-18
    platform_editor_ai_ct_sg_adf_streaming: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_ct_sg_adf_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-20
    platform_editor_ai_non_iw_adf_streaming: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai_non_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf_gemini25flash',
            'adf_gpt41mini'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-07-07
    platform_editor_ai_remove_trivial_prompts_cc: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_remove_trivial_prompts_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-25
    platform_editor_extension_styles: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_extension_styles'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-20
    confluence_whiteboards_quick_insert_aa: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_find_and_replace_improvements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    confluence_whiteboards_quick_insert: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-26
    platform_editor_feedback_mandatory_rating: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_feedback_mandatory_rating'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_drag_handle_aria_label: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_drag_handle_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_toggle_expand_on_match_found: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toggle_expand_on_match_found'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_smart_card_otp: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_smart_card_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_preview_panels_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_preview_panel_linking_exp: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_linking_exp_conf',
            jira: 'platform_editor_preview_panel_linking_exp_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_hoverlink_ui_fixes_exp: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_hoverlink_ui_fixes_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'css_changes_only',
            'css_js_changes'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-17
    platform_hover_card_preview_panel_modal: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel_modal',
            jira: 'platform_hover_card_preview_panel_modal'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025--9-17
    platform_editor_block_menu_empty_line: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_menu_empty_line'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_emoji_otp: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_emoji_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    platform_editor_renderer_breakout_fix: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_renderer_breakout_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_enghealth_hyperlink_toolbar_aria_values: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_enghealth_hyperlink_toolbar_aria_values'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_add_orange_highlight_color: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_add_orange_highlight_color'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_jira',
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-04
    editor_refactor_backspace_task_and_decisions: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_refactor_backspace_task_and_decisions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc_patch_3: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_patch_3',
            confluence: 'platform_editor_toolbar_aifc_patch_3'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-09-09
    platform_editor_toolbar_aifc_patch_4: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_patch_4',
            confluence: 'platform_editor_toolbar_aifc_patch_4'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-29
    platform_editor_toolbar_aifc_selection_extension: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_selection_extension',
            jira: 'platform_editor_toolbar_aifc_selection_extension'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-04
    platform_editor_floating_toolbar_button_aria_label: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_floating_toolbar_button_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    platform_editor_enghealth_table_plugin_lable_rule: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_enghealth_table_plugin_lable_rule'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_aifc_responsive: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_responsive',
            jira: 'platform_editor_toolbar_aifc_responsive'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_pasting_nested_table_fix: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_pasting_nested_table_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 20205-07-28
    platform_editor_fix_quick_insert_consistency_exp: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_quick_insert_consistency_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_fix_a11y_aria_posinset_0: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_a11y_aria_posinset_0'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-08
    platform_editor_blocktaskitem_patch_1: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_patch_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-06
    cc_editor_limited_mode: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_limited_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_support: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-10
    platform_synced_block: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_synced_block'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    cc_improve_writing_on_paste_v2: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_improve_writing_on_paste_v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_find_replace_a11y_fixes: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_find_replace_a11y_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-19
    platform_editor_breakout_resizing_vc90_fix: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing_vc90_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_support_custom_components: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_support_custom_components'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-21
    platform_editor_paste_rich_text_bugfix: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_paste_rich_text_bugfix',
            jira: 'platform_editor_paste_rich_text_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-25
    platform_editor_toolbar_aifc_template_editor: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_template_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-26
    platform_editor_toolbar_migrate_loom: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_migrate_loom',
            jira: 'platform_editor_toolbar_migrate_loom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_prevent_taskitem_remount: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_prevent_taskitem_remount'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-08
    platform_editor_editor_width_analytics: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_editor_width_analytics',
            jira: 'platform_editor_editor_width_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-10
    platform_editor_fix_button_name_violation_in_table: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_button_name_violation_in_table'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_quick_insert_image_wrap_right_fix: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_quick_insert_image_wrap_right_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_block_menu_layout_format: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_menu_layout_format'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_block_menu_expand_format: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_menu_expand_format'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-17
    platform_editor_block_menu_keyboard_navigation: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_menu_keyboard_navigation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_add_aria_checked_to_inline_img_btn: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_add_aria_checked_to_inline_image_btn'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_nested_table_refresh_width_fix: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_nested_table_refresh_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_toolbar_aifc_patch_5: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_5'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-18
    platform_editor_toolbar_aifc_renderer_selection: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_renderer_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_text_highlight_padding: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_text_highlight_padding'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-24
    platform_editor_lovability_user_intent: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_user_intent'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-17
    cc_complexit_fe_emoji_stability: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_complexit_fe_emoji_stability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-23
    cc_editor_ttvc_release_bundle_one: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_ttvc_release_bundle_one'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-07
    platform_editor_plain_text_support: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_plain_text_support',
            confluence: 'platform_editor_plain_text_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-26
    platform_editor_toolbar_aifc_patch_6: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_6'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-17
    confluence_content_mode_replace_dense_with_compact: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_content_mode_replace_dense_with_compact'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-01
    platform_inline_smartcard_connect_button_exp: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_inline_smartcard_connect_button_exp',
            jira: 'platform_inline_smartcard_connect_button_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'test1',
            'test2'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-10
    platform_editor_new_list_decorations_logic: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_new_list_decorations_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-15
    platform_editor_new_mentions_detection_logic: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_new_mentions_detection_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-20
    confluence_whiteboards_quick_insert_localised: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-28
    confluence_whiteboards_quick_insert_localised_aa: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-22
    platform_editor_remove_bidi_char_warning: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_remove_bidi_char_warning'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-24
    platform_editor_fix_clone_nesting_exp: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_clone_nesting_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $856a57b67e416c72$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-04
    platform_editor_disable_lazy_load_media: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_disable_lazy_load_media'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $856a57b67e416c72$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};
module.exports["editorExperimentsConfig"] = $2b0767b4f0dbf85f$export$6cbb856f286b07ef;

});

parcelRegister("9WAeG", function(module, exports) {

var $kGrzq = parcelRequire("kGrzq");

class $7b5f61d5ad055a5c$var$SSRMeasure extends (0, $kGrzq.BaseMeasures) {
    fetchCountIncr() {
        this.fetchCount++;
    }
    getFetchCount() {
        return this.fetchCount;
    }
    errorCountIncr() {
        this.errorCount++;
    }
    getErrorCount() {
        return this.errorCount;
    }
    operationsCountIncr() {
        this.operationsCount++;
    }
    getOperationsCount() {
        return this.operationsCount;
    }
    setStartTime(startTimeOffset = 0) {
        this.startTimeOffset = startTimeOffset;
        if (!this.startTime) this.startTime = Math.floor(performance.now());
    }
    getStartTime() {
        return this.startTime;
    }
    nowFromStartTime() {
        return Math.floor(performance.now()) - this.startTime;
    }
    now() {
        return this.nowFromStartTime() + this.startTimeOffset;
    }
    setMeasureDuration(name, duration) {
        const entry = this.measures[name];
        if (entry) entry.duration = duration;
    }
    addMeasure(name, duration, offsetStartByDuration = false) {
        if (this.measures[name]) return;
        this.measures[name] = {
            startTime: offsetStartByDuration ? this.now() - duration : this.now(),
            duration: duration
        };
    }
    markMeasureStart(name) {
        if (!this.measures[name]) this.measures[name] = {
            startTime: this.now(),
            duration: 0
        };
    }
    markMeasureEnd(name) {
        const entry = this.measures[name];
        if (entry) entry.duration = this.now() - entry.startTime;
    }
    clearMeasures() {
        this.startTimeOffset = 0;
        this.startTime = 0;
        this.fetchCount = 0;
        this.errorCount = 0;
        this.operationsCount = 0;
        this.measures = {};
    }
    constructor(...args){
        super(...args);
        this.startTimeOffset = 0;
        this.startTime = 0;
        // fetch count (counts batched operations as one fetch)
        this.fetchCount = 0;
        // total operations (counts individual operations even in batched operations)
        this.operationsCount = 0;
        this.errorCount = 0;
    }
}
const $7b5f61d5ad055a5c$export$5467c8c7fa0f4d06 = new $7b5f61d5ad055a5c$var$SSRMeasure();
module.exports["SSRMeasures"] = $7b5f61d5ad055a5c$export$5467c8c7fa0f4d06;

});

parcelRegister("5ZqQS", function(module, exports) {

var $lMdlY = parcelRequire("lMdlY");


var $4u5NT = parcelRequire("4u5NT");


var $7W8i8 = parcelRequire("7W8i8");


var $04e9M = parcelRequire("04e9M");


var $eSuZj = parcelRequire("eSuZj");


var $6X8o4 = parcelRequire("6X8o4");


var $6fil2 = parcelRequire("6fil2");


var $9wGTI = parcelRequire("9wGTI");


var $2XqLN = parcelRequire("2XqLN");








var $50bhB = parcelRequire("50bhB");


var $fJlJm = parcelRequire("fJlJm");

const $1965025ede6bc114$var$cloudFrontRegex = /(https?):\/\/[a-z0-9]+\.cloudfront\.net\//g;
const $1965025ede6bc114$var$cloudFrontS3Regex = /(https?):\/\/[a-z0-9]+\.cloudfront\.net\/download\//g;
// Used to match web resource URLs like this:
//   .../wiki/s/99914b932bd37a50b983c5e7c90ae93b-CDN/-1510873586/6452/236c4aa50522e3b557db968ff45d01d44604ffe1/1000.0.53/_/download/...
//   .../wiki/s/d41d8cd98f00b204e9800998ecf8427e-CDN/-783152381/h/2ddebfb80ae902fe7ab6e15441fe94e2/_/download/batch/...
//   .../wiki/s/d065fee603fdcf75115204ec65310e1c-CDN/-1510873586/6452/236c4aa50522e3b557db968ff45d01d44604ffe1/11d5083bb8bb9dac4c3a5987eeac4b5b/_/download/contextbatch/...
//   .../wiki/s/1283600969/6452/571d5459a4fbf60c255c41bb4e0d3ef3b8022627/_/download/resources/...
const $1965025ede6bc114$var$wrmResourceRegex = /s\/[^_]+_\/download\//g;
/**
 * For values which represent a stringified JSON, tries to extract the `"message"`
 * property and returns it if found. Returned result defaults to input value.
 */ function $1965025ede6bc114$var$tryExtractMessage(value) {
    try {
        const parsedValue = JSON.parse(value);
        return parsedValue.message || value;
    } catch (_) {
        return value;
    }
}
// Turns the culprit URL into .../wiki/download/... to remove the hash information.
function $1965025ede6bc114$var$stripHashAndCDNHost(url) {
    return url.match($1965025ede6bc114$var$wrmResourceRegex) ? url.replace($1965025ede6bc114$var$wrmResourceRegex, 'download/').replace($1965025ede6bc114$var$cloudFrontRegex, '$1://') : url;
}
function $1965025ede6bc114$var$getErrorFingerprint(error) {
    // See docs at https://docs.sentry.io/platforms/javascript/data-management/event-grouping/sdk-fingerprinting/
    const DEFAULT_FINGERPRINT = '{{ default }}';
    if (error.message.startsWith('Quota exceeded on key') || error.message.startsWith('QuotaExceededError')) return [
        'storage-quota-error'
    ];
    if (error.message.startsWith('Maximum call stack size exceeded') || error.message.startsWith('too much recursion')) // Most (if not all) of these errors originate from editor/prosemirror, and they
    // are hard to troubleshoot. So, although they all might represent a
    // different error, we're bundling them together
    return [
        'maximum-call-stack'
    ];
    if (error.message.startsWith('Invalid position')) // These errors originate from editor/prosemirror. The rest of the message
    // is the position number itself, and Sentry seldom groups those together.
    // By giving them all the same fingerprint, we're forcing Sentry to treat all
    // of those as the occurrence of one and the same error.
    return [
        'invalid-position'
    ];
    if (error.message.match(/Loading chunk .+? failed/)) // These are webpack chunk load errors, which often have very different stack traces.
    // We're grouping them together.
    return [
        'chunk-load-error'
    ];
    if (error.message.startsWith('Error creating blueprint content:')) // Grouping those by message should work better than looking at the stack trace
    return [
        'blueprint-creation-error',
        error.message.substr(0, 100)
    ];
    if (error.message.startsWith('Error from synchrony plugin')) // These are hard to troubleshoot, so to reduce noise we group them together
    return [
        'error-from-synchrony-plugin'
    ];
    if (error.message.includes('Error fetching data from identity - Error has been logged with execution ID:')) // The "execution ID" part in these errors is always different.
    return [
        'identity-fetching-error'
    ];
    if (error.message.includes('java.net.SocketTimeoutException')) return [
        'socket-timeout'
    ];
    if (error instanceof URIError) // This will group all URI errors together, as they often have different stack traces
    return [
        'malformed-uri-error'
    ];
    if (error instanceof (0, $50bhB.ConfluenceRestApiError) && error.route) // These errors tend to produce unpredictable messages which are hard to group.
    // So, instead of grouping by message, we'll group them by `route` and status code (which should be more predictable)
    return [
        `rest-api-${error.route}-${error.statusCode}`
    ];
    const logSafeAttributes = (0, $fJlJm.getLogSafeErrorAttributes)(error);
    if (logSafeAttributes.failedSlaExperience) {
        if (logSafeAttributes.operationName || logSafeAttributes.statusCode) // This code branch is for GraphQL/REST failures which result in experience failures.
        // Since the same backend errors can be thrown for different operations/endpoints,
        // we're applying a per-message grouping.
        // Also, we're **not** including default fingerprint here.
        return [
            `experience-${logSafeAttributes.failedSlaExperience}`,
            $1965025ede6bc114$var$tryExtractMessage(error.message).substr(0, 100)
        ];
        else // this way SLA-affecting errors shouldn't be bundled with other types of errors
        return [
            DEFAULT_FINGERPRINT,
            `experience-${logSafeAttributes.failedSlaExperience}`
        ];
    }
    return undefined;
}
const $1965025ede6bc114$var$dataTransformer = function(data, hint) {
    let fromWRM = false;
    let fromS3 = false;
    if (data.exception?.values) // Go through the stack trace and sanitize all the exception URLs.
    data.exception.values = data.exception.values.map((exception)=>{
        if (exception.stacktrace && exception.stacktrace.frames) exception.stacktrace.frames = exception.stacktrace.frames.map((frame)=>{
            if (frame.filename) {
                fromWRM = Boolean(frame.filename.match($1965025ede6bc114$var$wrmResourceRegex));
                fromS3 = Boolean(frame.filename.match($1965025ede6bc114$var$cloudFrontS3Regex));
                frame.filename = $1965025ede6bc114$var$stripHashAndCDNHost(frame.filename);
            }
            return frame;
        });
        return exception;
    });
    if (typeof hint?.originalException === 'object' && hint?.originalException !== null) {
        data.fingerprint = $1965025ede6bc114$var$getErrorFingerprint(hint.originalException);
        const { componentStack: _1, // this field is very big
        failedSlaExperience: _2, // this one is included as tag
        ...rest } = (0, $fJlJm.getLogSafeErrorAttributes)(hint.originalException);
        data.extra = {
            ...data.extra,
            ...rest
        };
    }
    if (fromWRM) data.logger = 'wrm';
    else if (fromS3) data.logger = 'react';
    else data.logger = 'javascript';
    // strip out url and breadcrumbs which include customer sensitive data
    if (data.request) delete data.request.url;
    delete data.breadcrumbs;
    data.transaction = ''; // transactions can have URLs in them, too
    return data;
};
// Structure: https://<PUBLIC_KEY>@o55978.ingest.sentry.io/<PROJECT_ID>
// See: https://hello.atlassian.net/wiki/spaces/OBSERVABILITY/pages/1436386358/Sentry+Cloud+-+Getting+Started#Setting-up-the-Sentry-SDK-for-your-project
function $1965025ede6bc114$var$getSentryDsn() {
    // https://sentry.io/settings/atlassian-2y/projects/confluence/keys/
    const SENTRY_DSN_PROD = 'https://1f56d81aaaae4b1ea5ca08bca6633223@o55978.ingest.sentry.io/5988811';
    // https://sentry.io/settings/atlassian-2y/projects/confluence-staging/keys/
    const SENTRY_DSN_STAGING = 'https://ce2ea70bbd2a439793b772cc1d59e2fe@o55978.ingest.sentry.io/5988871';
    return SENTRY_DSN_PROD;
}
function $1965025ede6bc114$var$getSentryEnvironment() {
    const SENTRY_ENV_PROD = 'CONFLUENCE';
    const SENTRY_ENV_STAGING = 'CONFLUENCE-STAGING';
    const SENTRY_ENV_HELLO = 'HELLO';
    return SENTRY_ENV_PROD;
}
function $1965025ede6bc114$var$getSentryOptions(dsn) {
    const additionalOptions = {};
    return {
        release: (0, $eSuZj.getBuildInfo)().FRONTEND_VERSION,
        dsn: dsn,
        environment: $1965025ede6bc114$var$getSentryEnvironment(),
        beforeSend (event, hint) {
            return $1965025ede6bc114$var$dataTransformer(event, hint);
        },
        ignoreErrors: [
            'Transport destroyed',
            // Error being thrown by media that won't be resolved any time soon.
            'Worker was destroyed',
            // Error being thrown by media that won't be resolved any time soon.
            'Failed to connect on any of the ADC ports',
            // Error being thrown by media that won't be resolved any time soon.
            "Cannot read property 'postMessage' of undefined",
            // Error being thrown by Connect that won't be resolved any time soon.
            "Cannot read property 'postMessage' of null",
            // Error being thrown by Connect that won't be resolved any time soon.
            'd.hide is not a function',
            // From com.atlassian.auiplugin:aui-date-picker,
            /^network error/i,
            // We can't do anything about network issues
            /^network failure/i,
            // We can't do anything about network issues
            'TypeError: Failed to fetch',
            // We can't do anything about network issues
            'ResizeObserver loop limit exceeded',
            // A benign error, see https://stackoverflow.com/a/50387233/2645305
            /ResizeObserver loop completed with undelivered notifications/
        ],
        autoSessionTracking: false,
        ...additionalOptions
    };
}

const $1965025ede6bc114$export$c2e2a07dfafd1ea2 = (0, $2XqLN.default)(async ()=>{
    // https://sentry.io/settings/atlassian-2y/projects/confluence-sla/keys/
    const SENTRY_DSN_SLA = 'https://2d329ea4a8a04cf0b19117b4675b336f@o55978.ingest.sentry.io/5988900';
    return (0, $6X8o4.liftPromiseState)((parcelRequire("6lHVh")).then(({ BrowserClient: BrowserClient, Hub: Hub })=>{
        const client = new BrowserClient($1965025ede6bc114$var$getSentryOptions(SENTRY_DSN_SLA));
        return new Hub(client);
    }).catch(()=>{
        // noop, there's nowhere to report this error
        return null;
    }));
});

function $1965025ede6bc114$export$1f7656c617418e15() {
    (parcelRequire("6lHVh")).then(({ init: init })=>{
        init($1965025ede6bc114$var$getSentryOptions($1965025ede6bc114$var$getSentryDsn()));
    }).catch(()=>{
    // noop, there's nowhere to report this error
    });
}


/* eslint-disable no-useless-constructor */ class $c8946d14d771a4cc$export$704b12ddc1dacdd2 {
    add(item) {
        this.scheduleFlush();
        this.currentBatch.push(item);
        if (this.currentBatch.length >= this.batchMaxSize) this.flush();
    }
    onFlush(callback) {
        if (!(callback instanceof Function)) throw new Error(`"onFlush" callback is supposed to be a function; saw ${typeof callback} instead`);
        this.onFlushCallbacks.add(callback);
        return {
            unsubscribe: ()=>{
                this.onFlushCallbacks.delete(callback);
            }
        };
    }
    /**
   * Forcefully flushes the batcher. Noop if current batch is empty.
   */ forceFlush() {
        // Currently force-flush is synchronous. Make sure the call sites are updated if
        // this is changed to a promise-based approach
        this.flush();
    }
    renewBatch() {
        const oldBatch = this.currentBatch;
        this.currentBatch = [];
        return oldBatch;
    }
    scheduleFlush() {
        if (!this.flushIntervalId) this.flushIntervalId = window.setInterval(this.flush, this.flushIntervalMs);
    }
    unscheduleFlush() {
        if (this.flushIntervalId) {
            window.clearInterval(this.flushIntervalId);
            this.flushIntervalId = undefined;
        }
    }
    constructor(flushIntervalMs, batchMaxSize){
        this.flushIntervalMs = flushIntervalMs;
        this.batchMaxSize = batchMaxSize;
        this.flushIntervalId = void 0;
        this.onFlushCallbacks = new Set();
        this.currentBatch = [];
        this.flush = ()=>{
            const batch = this.renewBatch();
            this.unscheduleFlush();
            if (batch.length === 0) return;
            this.onFlushCallbacks.forEach((cb)=>{
                try {
                    cb(batch);
                } catch (e) {
                    // rethrow error asynchronously to allow other callbacks to execute
                    setTimeout(()=>{
                        /* eslint-disable-next-line no-console */ console.error(`"onFlush" callback threw the below error. Please make sure your callbacks have proper error handling`);
                        throw e;
                    }, 0);
                }
            });
        };
    }
}





const $5c815a7d2f4ec0f7$var$logger = (0, $7W8i8.getLogger)('CustomMonitoringClient');

class $5c815a7d2f4ec0f7$export$a54226afd3e3cacc {
    enableNewSentry() {
        this.newSentryEnabled = true;
    }
    enableSendErrorsToTelemetryService() {
        this.sendErrorsToTelemetryService = true;
    }
    submitError(error, errorData) {
        if (!error) return;
        if (this.errorsPerCurrentTransition === this.errorsPerTransitionLimit) // limit reached; do not submit the errors
        return;
        this.errorsPerCurrentTransition++;
        const logSafeErrorAttributes = (0, $fJlJm.getLogSafeErrorAttributes)(error);
        const { attribution: attribution } = errorData;
        let isFirstInSession = this.firstErrorInSession;
        const errorWithStackTrace = error && error.stack && error.message ? error : new Error(error && error.message || String(error));
        if ($5c815a7d2f4ec0f7$var$isErrorIgnorableByOnCall(errorWithStackTrace, attribution, logSafeErrorAttributes)) isFirstInSession = false;
        else this.firstErrorInSession = false;
        this.incrementCounter('jsErrors', [
            `attribution:${attribution}`,
            `firstInSession:${isFirstInSession}`,
            ...logSafeErrorAttributes.operationName ? [
                `queryName:${logSafeErrorAttributes.operationName}`
            ] : []
        ]);
        const sentryTags = {
            attribution: attribution
        };
        if (this.context.slaExperience) sentryTags.slaExperience = this.context.slaExperience;
        if (this.context.pageName) sentryTags.pageName = this.context.pageName;
        if (logSafeErrorAttributes.failedSlaExperience) sentryTags.failedSlaExperience = logSafeErrorAttributes.failedSlaExperience;
        if (logSafeErrorAttributes.operationName) sentryTags.operationName = logSafeErrorAttributes.operationName;
        sentryTags.ssrRendered = Boolean(window.__SSR_RENDERED__).toString();
        if (logSafeErrorAttributes.failedSlaExperience) this.logSlaErrorToSentry(errorWithStackTrace, sentryTags).catch((sentryError)=>{
            this.logError(sentryError, {
                attribution: 'backbone'
            });
        });
        else if (this.newSentryEnabled) this.logErrorToSentry(errorWithStackTrace, sentryTags);
        this.logError(errorWithStackTrace, {
            ...errorData,
            ...logSafeErrorAttributes,
            firstInSession: isFirstInSession
        });
    }
    updateContext(update) {
        if (update.transitionId !== undefined && (update.transitionId === 0 || this.context.transitionId !== update.transitionId)) {
            this.incrementCounter('session', [
                `type:${update.transitionId === 0 ? 'initial' : 'transition'}`
            ]);
            // Next error will be first in the session when there is a initial load (transition id = 0) or a SPA transition.
            this.firstErrorInSession = true;
            this.errorsPerCurrentTransition = 0;
        }
        if (update.pageName && this.context.pageName !== update.pageName) // since the page name changed, all the events in the current batch were done
        // under an old page name. Hence we force-flush the batch, and only then set the new context.
        {
            if (this.context.pageName !== undefined) // skip force-flush if that's the first time we set pageName (i.e. initial navigation)
            this.batcher.forceFlush();
        }
        Object.assign(this.context, update);
    }
    incrementCounter(counterName, tags) {
        this.batcher.add(this.createMetric({
            type: 'increment',
            name: counterName,
            value: 1,
            tags: tags
        }));
    }
    logErrorToSentry(error, tags) {
        (parcelRequire("6lHVh")).then(({ withScope: withScope, captureException: captureException })=>{
            withScope((scope)=>{
                scope.setTags(tags);
                captureException(error);
            });
        }).catch((sentryError)=>{
            this.logError(sentryError, {
                attribution: 'backbone'
            });
        });
    }
    async logSlaErrorToSentry(error, tags) {
        let sentryHub = null;
        const standaloneSentryPromise = (0, $1965025ede6bc114$export$c2e2a07dfafd1ea2)();
        if ((0, $6X8o4.isResolved)(standaloneSentryPromise)) sentryHub = (0, $6X8o4.getValue)(standaloneSentryPromise);
        else sentryHub = await standaloneSentryPromise;
        if (sentryHub) sentryHub.withScope((scope)=>{
            scope.setTags(tags);
            sentryHub.captureException(error);
        });
    }
    /**
   * There is a 64kb payload limit for navigator.sendBeacon requests
   * 10 events sent max.
   * 3 fields that are being trimmed
   * That allows for 65536/10/3 = 2184.5 per field
   * we add a bit of buffer for the rest of the payload by reducing that number further to 1000
   * @param errorAttributes
   * @returns a new object with trimmed attributes if they exceed the limit determined by
   * errorBatchMsgTrimLength` which is calculated based on the following details
   */ trimAttributes(errorAttributes) {
        const attributesToTrim = [
            'error',
            'stack',
            'componentStack'
        ];
        const newErrorAttributes = {
            ...errorAttributes
        };
        if (errorAttributes.error?.startsWith?.('Minified React error #130') && (0, $9wGTI.fg)('confluence_frontend_untrimmed_react_errors')) {
            // Oct 2025: Log the (hopefully entire) stack for minified react error 130, to aid investigations into increased occurrences. Still trims to <64kb limit.
            newErrorAttributes.error = this.trimTextLength(newErrorAttributes.error, 2000);
            newErrorAttributes.stack = this.trimTextLength(newErrorAttributes.stack, 25000);
            newErrorAttributes.componentStack = this.trimTextLength(newErrorAttributes.componentStack, 25000);
        } else attributesToTrim.forEach((attribute)=>{
            if (newErrorAttributes[attribute]) newErrorAttributes[attribute] = this.trimTextLength(newErrorAttributes[attribute], this.errorBatchMsgTrimLength);
        });
        return newErrorAttributes;
    }
    async logError(error, additionalData) {
        try {
            const analyticsWebClientPromise = (0, $04e9M.getAnalyticsWebClient)();
            let client;
            if ((0, $6X8o4.isResolved)(analyticsWebClientPromise)) client = (0, $6X8o4.getValue)(analyticsWebClientPromise);
            else client = await analyticsWebClientPromise;
            const errorAttributes = {
                error: error.message || String(error),
                stack: error.stack,
                browserInfo: window.navigator.userAgent,
                ssrRendered: Boolean(window.__SSR_RENDERED__),
                releaseId: (0, $eSuZj.getBuildInfo)().FRONTEND_VERSION,
                track: (0, $eSuZj.getBuildInfo)().RELEASE_TRACK,
                pageName: this.context.pageName,
                shard: this.context.shard,
                edition: this.context.edition,
                jqVer: window.jQuery?.fn?.jquery,
                activeExperiences: this.context.activeExperiences ? Array.from(this.context.activeExperiences) : undefined,
                slaExperience: this.context.slaExperience,
                ufoTraceId: (0, $lMdlY.getActiveTrace)()?.traceId,
                ufoTraceType: (0, $lMdlY.getActiveTrace)()?.type,
                ...additionalData
            };
            const trimmedErrorAttributes = this.trimAttributes(errorAttributes);
            const hydrationFailed = window && window.__HYDRATION_FAILED__ && (0, $9wGTI.fg)('confluence_prevent_hydration_ufo_abort');
            if (!hydrationFailed) (0, $4u5NT.addErrorToAll)('confluence-frontend-monitoring-client', null, 'interaction unhandled error', errorAttributes.error);
            client.sendOperationalEvent({
                source: 'ui',
                action: 'unhandledError',
                actionSubject: 'ui',
                attributes: trimmedErrorAttributes
            });
            if (this.sendErrorsToTelemetryService) this.errorBatcher.add({
                event: trimmedErrorAttributes
            });
        } catch  {
        // no-op, if an error occurs here, there's really nowhere to submit it
        }
    }
    /**
   * Defines an allow-list of context attributes that will be sent as "global" tags to FE Telemetry and SignalFX with every event.
   * Tags additionally have to be allow-listed in the FE Telemetry repository. We PURPOSELY exclude certain tags (that are allowed by FE Telemetry)
   * such as "edition", as we do not want to be sending that tag for every experience event (thereby increasing metric cardinality). Instead, those tags
   * are included with specific experience events.
   * @private
   */ formatContextAsTags() {
        const tags = [];
        if (this.context.pageName) tags.push(`page:${this.context.pageName}`);
        if (this.context.tenantId) tags.push(`cloudId:${this.context.tenantId}`);
        if (this.context.shard) tags.push(`shard:${this.context.shard}`);
        if (this.context.product) tags.push(`product:${this.context.product}`);
        const { FRONTEND_VERSION: frontendVersion, RELEASE_TRACK: releaseTrack } = (0, $eSuZj.getBuildInfo)();
        if (frontendVersion) tags.push(`version:${frontendVersion}`);
        if (releaseTrack) tags.push(`track:${releaseTrack}`);
        return tags;
    }
    onBatch(batch) {
        const payload = {
            type: 'metric',
            meta: {
                globalTags: this.formatContextAsTags()
            },
            data: batch
        };
        this.send(payload);
    }
    onErrorBatch(batch) {
        const payload = {
            type: 'error',
            meta: {
                globalTags: this.formatContextAsTags()
            },
            data: batch
        };
        this.send(payload);
    }
    send(telemetryPayload) {
        try {
            $5c815a7d2f4ec0f7$var$logger.info`Sending monitoring events: ${telemetryPayload}`;
            const reportingUrl = '/gateway/api/telemetry';
            const data = JSON.stringify(telemetryPayload);
            let isSentViaBeacon = false;
            if (navigator.sendBeacon) isSentViaBeacon = navigator.sendBeacon(reportingUrl, data);
            if (!isSentViaBeacon) {
                // resorting to XMLHttpRequest instead of fetch here so that we can submit these events *synchronously* when
                // the page unloads (`fetch` can't do that)
                const client = new XMLHttpRequest();
                const shouldBeSync = this.isWindowUnloading;
                client.open('POST', reportingUrl, !shouldBeSync);
                // we're setting the "Content-Type" header to "text/plain" to behave as closely to `sendBeacon` as possible
                client.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
                client.send(data);
            }
        } catch (e) {
            // ignore - there's nothing we can do when monitoring is down
            $5c815a7d2f4ec0f7$var$logger.error`Sending monitoring data failed: ${e}`;
        }
    }
    createMetric({ type: type, name: name, value: value, tags: tags = [] }) {
        return {
            type: type,
            name: name,
            value: value,
            sampleRate: 1,
            tags: tags,
            timestamp: new Date().toISOString()
        };
    }
    trimTextLength(text, trimmedLength) {
        if (!text || !trimmedLength) return text;
        if (text.length > trimmedLength) return `${text.substring(0, trimmedLength)}...`;
        return text;
    }
    constructor({ errorsPerTransitionLimit: errorsPerTransitionLimit = 1000, metricBatchMaxSize: metricBatchMaxSize = 50, metricBatchFlushIntervalMs: metricBatchFlushIntervalMs = 10000, errorBatchFlushIntervalMs: errorBatchFlushIntervalMs = 10000, errorBatchMaxSize: errorBatchMaxSize = 10, errorBatchMsgTrimLength: errorBatchMsgTrimLength = 1000 } = {}){
        this.batcher = void 0;
        this.errorBatcher = void 0;
        this.isWindowUnloading = false;
        this.context = {};
        // First error occurred in initial load or transition
        this.firstErrorInSession = true;
        this.newSentryEnabled = false;
        this.sendErrorsToTelemetryService = false;
        this.errorsPerTransitionLimit = void 0;
        this.errorsPerCurrentTransition = 0;
        this.errorBatchMsgTrimLength = void 0;
        this.errorsPerTransitionLimit = errorsPerTransitionLimit;
        this.errorBatchMsgTrimLength = errorBatchMsgTrimLength;
        this.batcher = new (0, $c8946d14d771a4cc$export$704b12ddc1dacdd2)(metricBatchFlushIntervalMs, metricBatchMaxSize);
        this.errorBatcher = new (0, $c8946d14d771a4cc$export$704b12ddc1dacdd2)(errorBatchFlushIntervalMs, errorBatchMaxSize);
        this.batcher.onFlush((batch)=>{
            this.onBatch(batch);
        });
        this.errorBatcher.onFlush((batch)=>{
            this.onErrorBatch(batch);
        });
        const unloadListener = ()=>{
            this.isWindowUnloading = true;
            this.batcher.forceFlush();
            this.errorBatcher.forceFlush();
        };
        window.addEventListener('pagehide', unloadListener);
    }
}
function $5c815a7d2f4ec0f7$var$isErrorIgnorableByOnCall(error, attribution, attrs) {
    // make sure that this condition remains first, as it should override everything else
    if (Boolean(attrs.failedSlaExperience)) // non-ignorable, because it resulted in a failure of an SLA-bound experience
    return false;
    if ((0, $6fil2.containsNetworkError)(error)) // ignorable, because on-call can't do much about user-side network connectivity
    return true;
    if (attribution === 'backbone-loadable') // while we do want to report those, we don't want to overwhelm our error rate detector
    return true;
    if (error.message.includes('com.atlassian.confluence.api.service.exceptions.PermissionException') || error.message.includes('Authorization failed: Principal has insufficient permissions') || error.message.includes('com.atlassian.confluence.api.service.exceptions.NotFoundException') || attrs.statusCode === 401 || attrs.statusCode === 403) // on-call engineers can't do much about those errors, because they indicate a client-side issue
    return true;
    return false;
}


class $c344a94841b8c8c5$export$97cc0a779e2b1c0d {
    submitError() {}
    updateContext() {}
    incrementCounter() {}
}



let $b63a154ad6e5cc75$var$monitoringClient;
const $b63a154ad6e5cc75$export$39a3b7739331403b = ()=>{
    if (!$b63a154ad6e5cc75$var$monitoringClient) {
        if (/bot/i.test(window.navigator.userAgent)) // Do nothing for search engine crawlers
        $b63a154ad6e5cc75$var$monitoringClient = new (0, $c344a94841b8c8c5$export$97cc0a779e2b1c0d)();
        else $b63a154ad6e5cc75$var$monitoringClient = new (0, $5c815a7d2f4ec0f7$export$a54226afd3e3cacc)();
    }
    return $b63a154ad6e5cc75$var$monitoringClient;
};
const $b63a154ad6e5cc75$export$b97a02aaddc4fced = ()=>{
    if ($b63a154ad6e5cc75$var$monitoringClient instanceof (0, $5c815a7d2f4ec0f7$export$a54226afd3e3cacc)) $b63a154ad6e5cc75$var$monitoringClient.enableSendErrorsToTelemetryService();
};
module.exports["getMonitoringClient"] = $b63a154ad6e5cc75$export$39a3b7739331403b;
module.exports["enableSendErrorsToTelemetryService"] = $b63a154ad6e5cc75$export$b97a02aaddc4fced;

});

parcelRegister("50bhB", function(module, exports) {
/**
 * The error returned if an error occurs while calling a REST API.
 */ class $b13ce33266da6499$export$e704fce35c66bf42 extends Error {
    constructor({ message: message, method: method, url: url, 'status-code': statusCode }, { route: route, traceId: traceId } = {}){
        const formattedMessage = message.length ? message : `Failed to ${method} ${route || url}`;
        super(formattedMessage);
        /**
     * The URL of the failed request.
     */ this.url = void 0;
        /**
     * The attempted http request method.
     */ this.method = void 0;
        /**
     * The status code returned in the response
     */ this.statusCode = void 0;
        /**
     * The name of the requested route (without UGC/PII)
     */ this.route = void 0;
        /**
     * The traceId of the request
     */ this.traceId = void 0;
        this.url = url;
        this.route = route;
        this.method = method;
        this.statusCode = statusCode;
        this.traceId = traceId;
    }
}
module.exports["ConfluenceRestApiError"] = $b13ce33266da6499$export$e704fce35c66bf42;

});

parcelRegister("fJlJm", function(module, exports) {
// Please only keep this import as a *type import* to avoid bringing in the entire lib

var $hBkCm = parcelRequire("hBkCm");

var $50bhB = parcelRequire("50bhB");

var $9kGfD = parcelRequire("9kGfD");

function $abd29dc8c63e723c$var$isApolloError(error) {
    // theoretically this could be an `instanceof ApolloError` check, but bringing another
    // dependency to this package for the sake of this single check seems like an overkill
    return typeof error === 'object' && error !== null && ('graphQLErrors' in error || 'networkError' in error);
}
const $abd29dc8c63e723c$var$REACT_ERROR_CONTEXT_SYMBOL = Symbol('React error context');
function $abd29dc8c63e723c$export$df1c6d0ba3db287e(error, context) {
    if (typeof error === 'object' && error !== null) error[$abd29dc8c63e723c$var$REACT_ERROR_CONTEXT_SYMBOL] = context;
}
function $abd29dc8c63e723c$export$8b5fa6128aa81e5e(error) {
    if (typeof error === 'object' && error !== null) return error[$abd29dc8c63e723c$var$REACT_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $abd29dc8c63e723c$var$GRAPHQL_ERROR_CONTEXT_SYMBOL = Symbol('Graphql error context');
function $abd29dc8c63e723c$export$6f0dbe4e2bbe0509(error, context) {
    if (typeof error === 'object' && error !== null) error[$abd29dc8c63e723c$var$GRAPHQL_ERROR_CONTEXT_SYMBOL] = context;
}
function $abd29dc8c63e723c$export$b19e649eafc62480(error) {
    if (typeof error !== 'object' || error === null) return undefined;
    if (error[$abd29dc8c63e723c$var$GRAPHQL_ERROR_CONTEXT_SYMBOL]) return error[$abd29dc8c63e723c$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
    // Currently the graphql error context is set on the first entry of the `graphqlErrors`
    // property of `ApolloError`. That way, `ApolloError` itself does not have the context
    // set properly. This method is a measure to overcome this and make sure that
    // we are able to retrieve the context correctly.
    return $abd29dc8c63e723c$var$getGraphqlErrorAttributesFromApolloError(error);
}
function $abd29dc8c63e723c$var$getGraphqlErrorAttributesFromApolloError(error) {
    if (!$abd29dc8c63e723c$var$isApolloError(error)) return undefined;
    const graphqlErrors = error.graphQLErrors;
    // the context is populated by next/packages/graphql/src/links/OnErrorLink.ts
    if (graphqlErrors && graphqlErrors.length > 0 && graphqlErrors[0][$abd29dc8c63e723c$var$GRAPHQL_ERROR_CONTEXT_SYMBOL]) return graphqlErrors[0][$abd29dc8c63e723c$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
    if (error.networkError) return error.networkError[$abd29dc8c63e723c$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $abd29dc8c63e723c$var$SLA_ERROR_CONTEXT_SYMBOL = Symbol('SLA error context');
function $abd29dc8c63e723c$export$d4fe004fb0aaaf4f(error) {
    if (typeof error === 'object' && error !== null) return error[$abd29dc8c63e723c$var$SLA_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
function $abd29dc8c63e723c$export$a986f274521b30d7(error, context) {
    if (typeof error === 'object' && error !== null) error[$abd29dc8c63e723c$var$SLA_ERROR_CONTEXT_SYMBOL] = context;
}
function $abd29dc8c63e723c$var$getBadStatusErrorAttributes(error) {
    if (!(error instanceof (0, $hBkCm.BadStatusError))) return undefined;
    return {
        statusCode: error.response.status,
        traceId: (0, $9kGfD.getTraceIdFromResponse)(error.response)
    };
}
function $abd29dc8c63e723c$var$getConfluenceRestApiErrorAttributes(error) {
    if (!(error instanceof (0, $50bhB.ConfluenceRestApiError))) return undefined;
    return {
        statusCode: error.statusCode,
        restMethod: error.method,
        restRoute: error.route,
        traceId: error.traceId
    };
}
const $abd29dc8c63e723c$var$CONTENT_ERROR_CONTEXT_SYMBOL = Symbol('Content error context');
function $abd29dc8c63e723c$export$c37ca7d37ab54fcc(error, context) {
    if (typeof error === 'object' && error !== null) error[$abd29dc8c63e723c$var$CONTENT_ERROR_CONTEXT_SYMBOL] = context;
}
function $abd29dc8c63e723c$export$bc010311f017b17c(error) {
    if (typeof error === 'object' && error !== null) return error[$abd29dc8c63e723c$var$CONTENT_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $abd29dc8c63e723c$var$LOADABLE_ERROR_CONTEXT_SYMBOL = Symbol('Loadable error context');
function $abd29dc8c63e723c$export$6f86bd8e510ff607(error, context) {
    if (typeof error === 'object' && error !== null) error[$abd29dc8c63e723c$var$LOADABLE_ERROR_CONTEXT_SYMBOL] = context;
}
function $abd29dc8c63e723c$export$b8f8f1e62c6397ed(error) {
    if (typeof error === 'object' && error !== null) return error[$abd29dc8c63e723c$var$LOADABLE_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
function $abd29dc8c63e723c$export$69408b85ed2a0e77(error) {
    const traceId = $abd29dc8c63e723c$export$b19e649eafc62480(error)?.traceId || $abd29dc8c63e723c$export$b19e649eafc62480(error?.graphQLErrors?.[0])?.traceId;
    if (traceId) return traceId;
    // handle experimental query error
    if (error.graphQLErrors?.[0].originalError instanceof (0, $hBkCm.BadStatusError)) return error.graphQLErrors[0].originalError?.traceId;
    return null;
}
function $abd29dc8c63e723c$export$d08bac32cb78075f(error) {
    if (!error || typeof error !== 'object') return {};
    return {
        ...$abd29dc8c63e723c$export$8b5fa6128aa81e5e(error),
        ...$abd29dc8c63e723c$export$b19e649eafc62480(error),
        ...$abd29dc8c63e723c$export$d4fe004fb0aaaf4f(error),
        ...$abd29dc8c63e723c$export$bc010311f017b17c(error),
        ...$abd29dc8c63e723c$export$b8f8f1e62c6397ed(error),
        ...$abd29dc8c63e723c$var$getConfluenceRestApiErrorAttributes(error),
        ...$abd29dc8c63e723c$var$getBadStatusErrorAttributes(error)
    };
}
module.exports["setReactErrorAttributes"] = $abd29dc8c63e723c$export$df1c6d0ba3db287e;
module.exports["getReactErrorAttributes"] = $abd29dc8c63e723c$export$8b5fa6128aa81e5e;
module.exports["setGraphqlErrorAttributes"] = $abd29dc8c63e723c$export$6f0dbe4e2bbe0509;
module.exports["getGraphqlErrorAttributes"] = $abd29dc8c63e723c$export$b19e649eafc62480;
module.exports["setSlaErrorAttributes"] = $abd29dc8c63e723c$export$a986f274521b30d7;
module.exports["setContentErrorAttributes"] = $abd29dc8c63e723c$export$c37ca7d37ab54fcc;
module.exports["setLoadableErrorAttributes"] = $abd29dc8c63e723c$export$6f86bd8e510ff607;
module.exports["getTraceIdFromApolloError"] = $abd29dc8c63e723c$export$69408b85ed2a0e77;
module.exports["getLogSafeErrorAttributes"] = $abd29dc8c63e723c$export$d08bac32cb78075f;

});

parcelRegister("6lHVh", function(module, exports) {

let $49f6c662d7d00a45$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $49f6c662d7d00a45$var$load("6FB4U"),
    $49f6c662d7d00a45$var$load("aSHvy"),
    $49f6c662d7d00a45$var$load("kC80R")
]).then(()=>parcelRequire('7hGsm'));

});

parcelRegister("1uFM6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aMcHK = parcelRequire("aMcHK");





var $3QIlf = parcelRequire("3QIlf");

class $51acce01cca937d7$export$a6c66dc6b08c87fe extends (0, $42omo.Component) {
    componentDidCatch(error) {
        if (this.props.isKnownError(error)) {
            this.props.onError?.(error);
            this.setState({
                error: error
            });
        } else throw error;
    }
    render() {
        const { error: error } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3QIlf.KnownErrorBoundaryContext).Consumer, null, (willCatch)=>{
            this.willParentCatch = willCatch;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3QIlf.KnownErrorBoundaryContext).Provider, {
                value: this.willCatch
            }, error ? this.props.renderOnError(error) : this.props.children);
        });
    }
    constructor(...args){
        super(...args);
        this.willParentCatch = void 0;
        this.state = {
            error: null
        };
        this.willCatch = (error)=>Boolean(this.props.isKnownError(error) || this.willParentCatch?.(error));
    }
}


const $3e715362d34c6fb3$export$616870549cbd985 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $51acce01cca937d7$export$a6c66dc6b08c87fe), {
        isKnownError: $3e715362d34c6fb3$export$55152de1f925fd05,
        ...props
    });
/**
 * https://pug.jira-dev.com/wiki/spaces/CCB/pages/4709260932/GraphQL+Errors+Contract+for+Status+Code+401+and+403
 */ const $3e715362d34c6fb3$var$isLegacyUnauthorizedGraphQLError = (error)=>error?.extensions?.data?.authorized === false;
const $3e715362d34c6fb3$export$55152de1f925fd05 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '403', $3e715362d34c6fb3$var$isLegacyUnauthorizedGraphQLError);
module.exports["UnauthorizedErrorBoundary"] = $3e715362d34c6fb3$export$616870549cbd985;
module.exports["isUnauthorizedError"] = $3e715362d34c6fb3$export$55152de1f925fd05;

});

parcelRegister("aMcHK", function(module, exports) {

var $9wEpK = parcelRequire("9wEpK");

function $c1983a57b72eb5dc$export$93aea9a3d680252e(error, statusCode, statusCodeAlternative) {
    if (error) {
        if ((0, $9wEpK.isApolloError)(error)) return error.graphQLErrors?.some((graphQLError)=>$c1983a57b72eb5dc$var$isStatusCodeNonApolloError(graphQLError, statusCode, statusCodeAlternative)) || $c1983a57b72eb5dc$var$isStatusCodeNonApolloError(error?.networkError, statusCode, statusCodeAlternative);
        return $c1983a57b72eb5dc$var$isStatusCodeNonApolloError(error, statusCode, statusCodeAlternative);
    }
    return false;
}
function $c1983a57b72eb5dc$export$4b7f1fcb987c29b8(error) {
    if (error) {
        if ((0, $9wEpK.isApolloError)(error)) {
            for (const graphQLError of error?.graphQLErrors || []){
                const result = $c1983a57b72eb5dc$var$getStatusCodeNonApolloError(graphQLError);
                if (result) return result;
            }
            const networkErrorStatusCode = $c1983a57b72eb5dc$var$getStatusCodeNonApolloError(error?.networkError);
            if (networkErrorStatusCode) return networkErrorStatusCode;
        }
        return $c1983a57b72eb5dc$var$getStatusCodeNonApolloError(error);
    }
    return undefined;
}
function $c1983a57b72eb5dc$var$isStatusCodeNonApolloError(error, statusCode, statusCodeAlternative) {
    if (error) {
        if ($c1983a57b72eb5dc$export$68868794c9b58e55(error) === statusCode || statusCodeAlternative?.(error)) return true;
        const { originalError: originalError } = error;
        if (originalError) return $c1983a57b72eb5dc$export$93aea9a3d680252e(originalError, statusCode, statusCodeAlternative);
    }
    return false;
}
function $c1983a57b72eb5dc$var$getStatusCodeNonApolloError(error) {
    if (error) {
        const result = $c1983a57b72eb5dc$export$68868794c9b58e55(error);
        if (result) return result;
        const { originalError: originalError } = error;
        if (originalError) return $c1983a57b72eb5dc$export$68868794c9b58e55(originalError);
    }
    return undefined;
}
function $c1983a57b72eb5dc$export$68868794c9b58e55(error) {
    if (error) {
        let status = error?.response?.status;
        if (status == null) {
            const { extensions: extensions } = error;
            if (extensions) status = extensions.statusCode || extensions.http?.status;
        }
        // Coercing to string because backend is inconsistent in the response type,
        // both string and number have been seen in practice:
        return status?.toString();
    }
    return undefined;
}
module.exports["isStatusCodeError"] = $c1983a57b72eb5dc$export$93aea9a3d680252e;
module.exports["getStatusCodeError"] = $c1983a57b72eb5dc$export$4b7f1fcb987c29b8;
module.exports["getStatusCode"] = $c1983a57b72eb5dc$export$68868794c9b58e55;

});

parcelRegister("7Sm4c", function(module, exports) {

var $9wEpK = parcelRequire("9wEpK");


var $5ZqQS = parcelRequire("5ZqQS");


function $bef4b00c86d1ff04$var$onGraphqlError(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: 'graphql'
    });
}
// NOTE: use `Symbol.for(...)` here because this module is bundled into two separate
// chunks - preloader and main app. Creating it via `Symbol(...)` will result in two
// different symbols, so errors that are handled in the preloader won't be identified
// as handled in the main app.
const $bef4b00c86d1ff04$var$HANDLED_ERROR_MARK_SYMBOL = Symbol.for('error marked as handled');
class $bef4b00c86d1ff04$export$bba8f5318e9cae27 {
    scheduleErrorReporting(error) {
        const timeoutId = window.setTimeout(()=>{
            // NOTE: This is an extra measure to prevent over-reporting of an otherwise handled error.
            // When query is preloaded and errors out, the reporting is scheduled by onErrorLink from
            // both preloader and from the place where query data is processed, but `errorsToHandle`
            // would only contain the entry of the error mapped to the latest timeoutId.
            if (this.isErrorMarkedAsHandled(error)) return;
            this.errorHandler(error);
            $bef4b00c86d1ff04$export$702f853386561b84(error);
        }, this.gracefulHandlingPeriodMs);
        this.errorsToHandle.set(error, timeoutId);
    }
    // eslint-disable-next-line no-useless-constructor
    constructor(gracefulHandlingPeriodMs, errorHandler){
        this.gracefulHandlingPeriodMs = gracefulHandlingPeriodMs;
        this.errorHandler = errorHandler;
        // map of Error to timeoutId of when the generic error handling will kick-off
        this.errorsToHandle = new Map();
        this.processError = (error)=>{
            if (error) this.scheduleErrorReporting(error);
        };
        this.isErrorMarkedAsHandled = (error)=>{
            if (!error) return false;
            if (typeof error !== 'object') return false;
            return Boolean(error[$bef4b00c86d1ff04$var$HANDLED_ERROR_MARK_SYMBOL]);
        };
        this.markErrorAsHandled = (error)=>{
            if (!error) return;
            if ((0, $9wEpK.isApolloError)(error)) {
                (error.graphQLErrors || []).forEach((e)=>this.markErrorAsHandled(e));
                this.markErrorAsHandled(error.networkError);
            }
            const timeoutId = this.errorsToHandle.get(error);
            if (typeof error === 'object') error[$bef4b00c86d1ff04$var$HANDLED_ERROR_MARK_SYMBOL] = true;
            window.clearTimeout(timeoutId);
            this.errorsToHandle.delete(error);
        };
    }
}
const $bef4b00c86d1ff04$var$GRACEFUL_ERROR_HANDLING_PERIOD_MS = 100;
// GraphqlErrorProcessor is stateful and should be a singleton. Given that this module
// is bundled into two separate chunks - preloader and main app, we need to make sure
// that the same instance is used in both places.
const $bef4b00c86d1ff04$var$graphqlErrorProcessor = new $bef4b00c86d1ff04$export$bba8f5318e9cae27($bef4b00c86d1ff04$var$GRACEFUL_ERROR_HANDLING_PERIOD_MS, $bef4b00c86d1ff04$var$onGraphqlError);
const $bef4b00c86d1ff04$export$db43d00048f0afe4 = $bef4b00c86d1ff04$var$GRACEFUL_ERROR_HANDLING_PERIOD_MS;
const $bef4b00c86d1ff04$export$702f853386561b84 = $bef4b00c86d1ff04$var$graphqlErrorProcessor.markErrorAsHandled;
const $bef4b00c86d1ff04$export$792efb60958ecf86 = $bef4b00c86d1ff04$var$graphqlErrorProcessor.isErrorMarkedAsHandled;
const $bef4b00c86d1ff04$export$83457a6c00af4df7 = $bef4b00c86d1ff04$var$graphqlErrorProcessor.processError;
module.exports["markErrorAsHandled"] = $bef4b00c86d1ff04$export$702f853386561b84;
module.exports["isErrorMarkedAsHandled"] = $bef4b00c86d1ff04$export$792efb60958ecf86;
module.exports["processError"] = $bef4b00c86d1ff04$export$83457a6c00af4df7;

});

parcelRegister("gFHOP", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $e67eec7423072f68$export$e344c3770925712a = (0, $eSUdr.default)`query SiteInformationQuery{tenant{shard cloudId environment activationId}organization{orgId}userForAnalytics:confluence_atlassianUser{id}user:confluence_atlassianUser(current:true){id displayName confluence{accessStatus accountId userKey locale}timeZone}getAIConfig(product:CONFLUENCE){isEnabled isRovoEnabled isRovoLLMEnabled}confluence_tenantContext{licenseStates{confluence{ccpEntitlementId}}timeZone editions{confluence}monolithRegion}isSiteAdmin abTestCohorts experimentFeatures userCanCreateContent isNewUser siteSettings{homepage{uri title}siteTitle showApplicationTitle frontCover{frontCoverState}companyHubName}siteDescription{logoUrl}currentConfluenceUser{isAnonymous}}`;
module.exports["SiteInformationQuery"] = $e67eec7423072f68$export$e344c3770925712a;

});

parcelRegister("eSUdr", function(module, exports) {
$parcel$export(module.exports, "gql", () => $ad61b71d509c5dd4$export$72e4926bf8358653);
$parcel$export(module.exports, "default", () => $ad61b71d509c5dd4$export$2e2bcd8739ae039);

var $hXuPC = parcelRequire("hXuPC");


var $3uZvj = parcelRequire("3uZvj");

var $ad61b71d509c5dd4$var$docCache = new Map();
var $ad61b71d509c5dd4$var$fragmentSourceMap = new Map();
var $ad61b71d509c5dd4$var$printFragmentWarnings = true;
var $ad61b71d509c5dd4$var$experimentalFragmentVariables = false;
function $ad61b71d509c5dd4$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $ad61b71d509c5dd4$var$cacheKeyFromLoc(loc) {
    return $ad61b71d509c5dd4$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $ad61b71d509c5dd4$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $ad61b71d509c5dd4$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $ad61b71d509c5dd4$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($ad61b71d509c5dd4$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $ad61b71d509c5dd4$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, ast), {
        definitions: definitions
    });
}
function $ad61b71d509c5dd4$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $ad61b71d509c5dd4$var$parseDocument(source) {
    var cacheKey = $ad61b71d509c5dd4$var$normalize(source);
    if (!$ad61b71d509c5dd4$var$docCache.has(cacheKey)) {
        var parsed = (0, $3uZvj.parse)(source, {
            experimentalFragmentVariables: $ad61b71d509c5dd4$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $ad61b71d509c5dd4$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $ad61b71d509c5dd4$var$docCache.set(cacheKey, $ad61b71d509c5dd4$var$stripLoc($ad61b71d509c5dd4$var$processFragments(parsed)));
    }
    return $ad61b71d509c5dd4$var$docCache.get(cacheKey);
}
function $ad61b71d509c5dd4$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $ad61b71d509c5dd4$var$parseDocument(result);
}
function $ad61b71d509c5dd4$export$657554ef4dc7ac2d() {
    $ad61b71d509c5dd4$var$docCache.clear();
    $ad61b71d509c5dd4$var$fragmentSourceMap.clear();
}
function $ad61b71d509c5dd4$export$e4294e638636c6ab() {
    $ad61b71d509c5dd4$var$printFragmentWarnings = false;
}
function $ad61b71d509c5dd4$export$78cf889af350c840() {
    $ad61b71d509c5dd4$var$experimentalFragmentVariables = true;
}
function $ad61b71d509c5dd4$export$5290df9bbbd3cfa() {
    $ad61b71d509c5dd4$var$experimentalFragmentVariables = false;
}
var $ad61b71d509c5dd4$var$extras = {
    gql: $ad61b71d509c5dd4$export$72e4926bf8358653,
    resetCaches: $ad61b71d509c5dd4$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $ad61b71d509c5dd4$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $ad61b71d509c5dd4$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $ad61b71d509c5dd4$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $ad61b71d509c5dd4$var$extras.gql, gql_1.resetCaches = $ad61b71d509c5dd4$var$extras.resetCaches, gql_1.disableFragmentWarnings = $ad61b71d509c5dd4$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $ad61b71d509c5dd4$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $ad61b71d509c5dd4$var$extras.disableExperimentalFragmentVariables;
})($ad61b71d509c5dd4$export$72e4926bf8358653 || ($ad61b71d509c5dd4$export$72e4926bf8358653 = {}));
$ad61b71d509c5dd4$export$72e4926bf8358653["default"] = $ad61b71d509c5dd4$export$72e4926bf8358653;
var $ad61b71d509c5dd4$export$2e2bcd8739ae039 = $ad61b71d509c5dd4$export$72e4926bf8358653;

});

parcelRegister("3uZvj", function(module, exports) {

var $aAxiE = parcelRequire("aAxiE");

function $b0627a199ced19e3$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $aAxiE.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}



var $q7IQV = parcelRequire("q7IQV");


var $t4pTu = parcelRequire("t4pTu");


var $7WVJw = parcelRequire("7WVJw");


var $kdJ3v = parcelRequire("kdJ3v");


var $3F3t4 = parcelRequire("3F3t4");


var $6mpIf = parcelRequire("6mpIf");


var $aLMpN = parcelRequire("aLMpN");

function $ee7dd6e1a29bdeb9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ee7dd6e1a29bdeb9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ee7dd6e1a29bdeb9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ee7dd6e1a29bdeb9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $ee7dd6e1a29bdeb9$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $6mpIf.default)(0, "Body must be a string. Received: ".concat((0, $3F3t4.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $6mpIf.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $6mpIf.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $ee7dd6e1a29bdeb9$var$_createClass(Source, [
        {
            key: (0, $kdJ3v.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $ee7dd6e1a29bdeb9$export$75135ee9ed6e435b(source) {
    return (0, $aLMpN.default)(source, $ee7dd6e1a29bdeb9$export$1d2df86270c81ecb);
}



var $8ro6o = parcelRequire("8ro6o");









var $7GRom = parcelRequire("7GRom");

var $c960701b8de6efb4$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $7WVJw.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $c960701b8de6efb4$var$readToken(this, token);
        }while (token.kind === (0, $7WVJw.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $c960701b8de6efb4$export$59ac0f4da287406a(kind) {
    return kind === (0, $7WVJw.TokenKind).BANG || kind === (0, $7WVJw.TokenKind).DOLLAR || kind === (0, $7WVJw.TokenKind).AMP || kind === (0, $7WVJw.TokenKind).PAREN_L || kind === (0, $7WVJw.TokenKind).PAREN_R || kind === (0, $7WVJw.TokenKind).SPREAD || kind === (0, $7WVJw.TokenKind).COLON || kind === (0, $7WVJw.TokenKind).EQUALS || kind === (0, $7WVJw.TokenKind).AT || kind === (0, $7WVJw.TokenKind).BRACKET_L || kind === (0, $7WVJw.TokenKind).BRACKET_R || kind === (0, $7WVJw.TokenKind).BRACE_L || kind === (0, $7WVJw.TokenKind).PIPE || kind === (0, $7WVJw.TokenKind).BRACE_R;
}
function $c960701b8de6efb4$var$printCharCode(code) {
    return isNaN(code) ? (0, $7WVJw.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $c960701b8de6efb4$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $c960701b8de6efb4$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $c960701b8de6efb4$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $c960701b8de6efb4$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $c960701b8de6efb4$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $c960701b8de6efb4$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $b0627a199ced19e3$export$bbee0c6176c019d4)(source, pos, $c960701b8de6efb4$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $c960701b8de6efb4$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($c960701b8de6efb4$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($c960701b8de6efb4$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $c960701b8de6efb4$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $c960701b8de6efb4$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $b0627a199ced19e3$export$bbee0c6176c019d4)(source, position, "Invalid number, unexpected digit after 0: ".concat($c960701b8de6efb4$var$printCharCode(code), "."));
    } else {
        position = $c960701b8de6efb4$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $c960701b8de6efb4$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $c960701b8de6efb4$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $c960701b8de6efb4$var$isNameStart(code)) throw (0, $b0627a199ced19e3$export$bbee0c6176c019d4)(source, position, "Invalid number, expected digit but got: ".concat($c960701b8de6efb4$var$printCharCode(code), "."));
    return new (0, $t4pTu.Token)(isFloat ? (0, $7WVJw.TokenKind).FLOAT : (0, $7WVJw.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $c960701b8de6efb4$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $b0627a199ced19e3$export$bbee0c6176c019d4)(source, position, "Invalid number, expected digit but got: ".concat($c960701b8de6efb4$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $c960701b8de6efb4$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $b0627a199ced19e3$export$bbee0c6176c019d4)(source, position, "Invalid character within String: ".concat($c960701b8de6efb4$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $c960701b8de6efb4$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $b0627a199ced19e3$export$bbee0c6176c019d4)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $b0627a199ced19e3$export$bbee0c6176c019d4)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $b0627a199ced19e3$export$bbee0c6176c019d4)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $c960701b8de6efb4$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $7GRom.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $b0627a199ced19e3$export$bbee0c6176c019d4)(source, position, "Invalid character within String: ".concat($c960701b8de6efb4$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $b0627a199ced19e3$export$bbee0c6176c019d4)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $c960701b8de6efb4$var$uniCharCode(a, b, c, d) {
    return $c960701b8de6efb4$var$char2hex(a) << 12 | $c960701b8de6efb4$var$char2hex(b) << 8 | $c960701b8de6efb4$var$char2hex(c) << 4 | $c960701b8de6efb4$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $c960701b8de6efb4$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $c960701b8de6efb4$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $t4pTu.Token)((0, $7WVJw.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $c960701b8de6efb4$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}


function $28c3e1d5e07cd21b$export$98e6a39c04603d36(source, options) {
    var parser = new $28c3e1d5e07cd21b$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $28c3e1d5e07cd21b$export$5303528d1070ff6f(source, options) {
    var parser = new $28c3e1d5e07cd21b$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $7WVJw.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $7WVJw.TokenKind).EOF);
    return value;
}
function $28c3e1d5e07cd21b$export$28b8f402ccc88182(source, options) {
    var parser = new $28c3e1d5e07cd21b$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $7WVJw.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $7WVJw.TokenKind).EOF);
    return type;
}
var $28c3e1d5e07cd21b$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $ee7dd6e1a29bdeb9$export$75135ee9ed6e435b)(source) ? source : new (0, $ee7dd6e1a29bdeb9$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $c960701b8de6efb4$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $7WVJw.TokenKind).NAME);
        return {
            kind: (0, $q7IQV.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $q7IQV.Kind).DOCUMENT,
            definitions: this.many((0, $7WVJw.TokenKind).SOF, this.parseDefinition, (0, $7WVJw.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $7WVJw.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $7WVJw.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $7WVJw.TokenKind).BRACE_L)) return {
            kind: (0, $q7IQV.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $7WVJw.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $q7IQV.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $7WVJw.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $7WVJw.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $7WVJw.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $q7IQV.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $7WVJw.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $7WVJw.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $7WVJw.TokenKind).DOLLAR);
        return {
            kind: (0, $q7IQV.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $q7IQV.Kind).SELECTION_SET,
            selections: this.many((0, $7WVJw.TokenKind).BRACE_L, this.parseSelection, (0, $7WVJw.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $7WVJw.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $7WVJw.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $q7IQV.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $7WVJw.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $7WVJw.TokenKind).PAREN_L, item, (0, $7WVJw.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $7WVJw.TokenKind).COLON);
        return {
            kind: (0, $q7IQV.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $q7IQV.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $7WVJw.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $7WVJw.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $7WVJw.TokenKind).NAME)) return {
            kind: (0, $q7IQV.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $q7IQV.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $q7IQV.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $q7IQV.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $7WVJw.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $7WVJw.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $7WVJw.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $q7IQV.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $7WVJw.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $q7IQV.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $7WVJw.TokenKind).STRING:
            case (0, $7WVJw.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $7WVJw.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $q7IQV.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $q7IQV.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $q7IQV.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $q7IQV.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $7WVJw.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $q7IQV.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $7WVJw.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $q7IQV.Kind).LIST,
            values: this.any((0, $7WVJw.TokenKind).BRACKET_L, item, (0, $7WVJw.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $q7IQV.Kind).OBJECT,
            fields: this.any((0, $7WVJw.TokenKind).BRACE_L, item, (0, $7WVJw.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $7WVJw.TokenKind).COLON);
        return {
            kind: (0, $q7IQV.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $7WVJw.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $7WVJw.TokenKind).AT);
        return {
            kind: (0, $q7IQV.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $7WVJw.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $7WVJw.TokenKind).BRACKET_R);
            type = {
                kind: (0, $q7IQV.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $7WVJw.TokenKind).BANG)) return {
            kind: (0, $q7IQV.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $q7IQV.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $7WVJw.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $7WVJw.TokenKind).STRING) || this.peek((0, $7WVJw.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $7WVJw.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $7WVJw.TokenKind).BRACE_R);
        return {
            kind: (0, $q7IQV.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $7WVJw.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $q7IQV.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $q7IQV.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $q7IQV.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $7WVJw.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $7WVJw.TokenKind).AMP) || this.peek((0, $7WVJw.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $7WVJw.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $7WVJw.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $7WVJw.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $7WVJw.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $7WVJw.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $7WVJw.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $q7IQV.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $7WVJw.TokenKind).PAREN_L, this.parseInputValueDef, (0, $7WVJw.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $7WVJw.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $7WVJw.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $q7IQV.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $q7IQV.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $q7IQV.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $7WVJw.TokenKind).EQUALS) ? this.delimitedMany((0, $7WVJw.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $q7IQV.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $7WVJw.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $7WVJw.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $q7IQV.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $q7IQV.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $7WVJw.TokenKind).BRACE_L, this.parseInputValueDef, (0, $7WVJw.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $7WVJw.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $7WVJw.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $7WVJw.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $q7IQV.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $q7IQV.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $q7IQV.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $q7IQV.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $q7IQV.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $q7IQV.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $q7IQV.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $7WVJw.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $q7IQV.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $7WVJw.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $8ro6o.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $t4pTu.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $b0627a199ced19e3$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Expected ".concat($28c3e1d5e07cd21b$var$getTokenKindDesc(kind), ", found ").concat($28c3e1d5e07cd21b$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $7WVJw.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $b0627a199ced19e3$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($28c3e1d5e07cd21b$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $7WVJw.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $b0627a199ced19e3$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Unexpected ".concat($28c3e1d5e07cd21b$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $28c3e1d5e07cd21b$var$getTokenDesc(token) {
    var value = token.value;
    return $28c3e1d5e07cd21b$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $28c3e1d5e07cd21b$var$getTokenKindDesc(kind) {
    return (0, $c960701b8de6efb4$export$59ac0f4da287406a)(kind) ? "\"".concat(kind, "\"") : kind;
}
module.exports["parse"] = $28c3e1d5e07cd21b$export$98e6a39c04603d36;

});

parcelRegister("q7IQV", function(module, exports) {
/**
 * The set of allowed kind values for AST nodes.
 */ var $04e86b5629550e52$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 
module.exports["Kind"] = $04e86b5629550e52$export$a84bdc57c5122798;

});

parcelRegister("7WVJw", function(module, exports) {
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $5c9abbca75933d2a$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 
module.exports["TokenKind"] = $5c9abbca75933d2a$export$8b9d26ab11394711;

});

parcelRegister("aLMpN", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d73d963a800b537$export$2e2bcd8739ae039);

function $7d73d963a800b537$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7d73d963a800b537$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7d73d963a800b537$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7d73d963a800b537$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$7d73d963a800b537$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});

parcelRegister("8ro6o", function(module, exports) {
/**
 * The set of allowed directive location values.
 */ var $62538a8ace8d4340$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 
module.exports["DirectiveLocation"] = $62538a8ace8d4340$export$b45ffd2948484c41;

});

parcelRegister("7GRom", function(module, exports) {
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $5995df2eedf87996$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $5995df2eedf87996$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $5995df2eedf87996$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $5995df2eedf87996$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $5995df2eedf87996$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $5995df2eedf87996$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $5995df2eedf87996$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}
module.exports["dedentBlockStringValue"] = $5995df2eedf87996$export$fd88c0b652c46ccc;
module.exports["printBlockString"] = $5995df2eedf87996$export$adb6ca997eeb1f45;

});

parcelRegister("4VJDS", function(module, exports) {

var $cO8uZ = parcelRequire("cO8uZ");


var $c6GJD = parcelRequire("c6GJD");

class $d209d7de5393726f$var$StatsigConfigurations {
    static initialize(instance) {
        this.configCollection = instance;
        if ((0, $c6GJD.default).initializeCompleted()) this.initializeOverrides();
    }
    static initializeFromValues(configCollectionValues) {
        if (typeof configCollectionValues === 'string') // @deprecated
        this.initialize((0, $cO8uZ.ConfigCollection).fromValues(configCollectionValues));
        else this.initialize((0, $cO8uZ.ConfigCollection).fromData(configCollectionValues));
    }
    static initializeOverrides() {
        const featureGateOverrides = (0, $c6GJD.default).getOverrides();
        this.configOverrides = Object.entries(featureGateOverrides.configs).reduce((overrideConfigs, [name, value])=>{
            // We currently use FeatureGates library for Statsig gate and experiment overrides.
            // Experiment overrides are stored in the same configs object, so we need to extract the
            // overrides for dynamic configs.
            if (Object.keys(value).length === 1 && value.hasOwnProperty('value')) overrideConfigs[name] = value;
            return overrideConfigs;
        }, {});
    }
    static getValueOrDefault(getFunction, configName, defaultVal) {
        if (this.configOverrides && Object.keys(this.configOverrides).length > 0) {
            const override = this.configOverrides[configName];
            if (override && typeof override.value === typeof defaultVal) return override.value;
        }
        if (!this.configCollection) return defaultVal;
        const configResult = getFunction.call(this.configCollection, configName);
        if (!configResult || 'error' in configResult || !('value' in configResult)) return defaultVal;
        return configResult.value;
    }
    static isKillSwitchOn(configName) {
        return this.getValueOrDefault(this.configCollection?.getBoolean, configName, false);
    }
    static getBoolean(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getBoolean, configName, defaultVal);
    }
    static getString(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getString, configName, defaultVal);
    }
    static getNumber(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getNumber, configName, defaultVal);
    }
    static getStringList(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getStringList, configName, defaultVal);
    }
    static getNumberList(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getNumberList, configName, defaultVal);
    }
}
/* eslint-disable import/no-default-export */ $d209d7de5393726f$var$StatsigConfigurations.configCollection = void 0;
$d209d7de5393726f$var$StatsigConfigurations.configOverrides = void 0;
var $d209d7de5393726f$export$2e2bcd8739ae039 = $d209d7de5393726f$var$StatsigConfigurations;
module.exports["default"] = $d209d7de5393726f$export$2e2bcd8739ae039;

});

parcelRegister("gLLcz", function(module, exports) {
var $c355a66627c2a25c$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($c355a66627c2a25c$export$7debb50ef11d5e0b || ($c355a66627c2a25c$export$7debb50ef11d5e0b = {}));
var $c355a66627c2a25c$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($c355a66627c2a25c$export$4aa2142c225fd5c7 || ($c355a66627c2a25c$export$4aa2142c225fd5c7 = {}));
const $c355a66627c2a25c$export$5716da67bfaa244d = $c355a66627c2a25c$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $c355a66627c2a25c$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $c355a66627c2a25c$export$5716da67bfaa244d.undefined;
        case "string":
            return $c355a66627c2a25c$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $c355a66627c2a25c$export$5716da67bfaa244d.nan : $c355a66627c2a25c$export$5716da67bfaa244d.number;
        case "boolean":
            return $c355a66627c2a25c$export$5716da67bfaa244d.boolean;
        case "function":
            return $c355a66627c2a25c$export$5716da67bfaa244d.function;
        case "bigint":
            return $c355a66627c2a25c$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $c355a66627c2a25c$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $c355a66627c2a25c$export$5716da67bfaa244d.array;
            if (data === null) return $c355a66627c2a25c$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $c355a66627c2a25c$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $c355a66627c2a25c$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $c355a66627c2a25c$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $c355a66627c2a25c$export$5716da67bfaa244d.date;
            return $c355a66627c2a25c$export$5716da67bfaa244d.object;
        default:
            return $c355a66627c2a25c$export$5716da67bfaa244d.unknown;
    }
};
const $c355a66627c2a25c$export$5ba560653e4a1035 = $c355a66627c2a25c$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $c355a66627c2a25c$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $c355a66627c2a25c$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $c355a66627c2a25c$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $c355a66627c2a25c$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
}
$c355a66627c2a25c$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $c355a66627c2a25c$export$f98dac4b251ab333(issues);
    return error;
};
const $c355a66627c2a25c$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $c355a66627c2a25c$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $c355a66627c2a25c$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $c355a66627c2a25c$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $c355a66627c2a25c$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$c355a66627c2a25c$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $c355a66627c2a25c$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $c355a66627c2a25c$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$c355a66627c2a25c$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $c355a66627c2a25c$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$c355a66627c2a25c$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $c355a66627c2a25c$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $c355a66627c2a25c$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $c355a66627c2a25c$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $c355a66627c2a25c$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $c355a66627c2a25c$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $c355a66627c2a25c$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $c355a66627c2a25c$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $c355a66627c2a25c$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $c355a66627c2a25c$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $c355a66627c2a25c$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $c355a66627c2a25c$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $c355a66627c2a25c$var$overrideErrorMap = $c355a66627c2a25c$export$341b0b6e0a6f5099;
function $c355a66627c2a25c$export$1097a8289cfd22d7(map) {
    $c355a66627c2a25c$var$overrideErrorMap = map;
}
function $c355a66627c2a25c$export$32f27c719778d4c4() {
    return $c355a66627c2a25c$var$overrideErrorMap;
}
const $c355a66627c2a25c$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $c355a66627c2a25c$export$1526d2e05f74572 = [];
function $c355a66627c2a25c$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $c355a66627c2a25c$export$32f27c719778d4c4();
    const issue = $c355a66627c2a25c$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $c355a66627c2a25c$export$341b0b6e0a6f5099 ? undefined : $c355a66627c2a25c$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $c355a66627c2a25c$export$5b20a5c3d05c1f6f {
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $c355a66627c2a25c$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $c355a66627c2a25c$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $c355a66627c2a25c$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $c355a66627c2a25c$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
    constructor(){
        this.value = "valid";
    }
}
const $c355a66627c2a25c$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $c355a66627c2a25c$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $c355a66627c2a25c$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $c355a66627c2a25c$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $c355a66627c2a25c$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $c355a66627c2a25c$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $c355a66627c2a25c$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $c355a66627c2a25c$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c355a66627c2a25c$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $c355a66627c2a25c$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($c355a66627c2a25c$var$errorUtil || ($c355a66627c2a25c$var$errorUtil = {}));
var $c355a66627c2a25c$var$_ZodEnum_cache, $c355a66627c2a25c$var$_ZodNativeEnum_cache;
class $c355a66627c2a25c$var$ParseInputLazyPath {
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
}
const $c355a66627c2a25c$var$handleResult = (ctx, result)=>{
    if ($c355a66627c2a25c$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $c355a66627c2a25c$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $c355a66627c2a25c$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $c355a66627c2a25c$export$19342e026b58ebb7 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $c355a66627c2a25c$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $c355a66627c2a25c$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $c355a66627c2a25c$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $c355a66627c2a25c$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($c355a66627c2a25c$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $c355a66627c2a25c$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $c355a66627c2a25c$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        var _a, _b;
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $c355a66627c2a25c$export$3e9057828ebd5c7a(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return $c355a66627c2a25c$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if ((_b = (_a = err === null || err === void 0 ? void 0 : err.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>$c355a66627c2a25c$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $c355a66627c2a25c$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($c355a66627c2a25c$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $c355a66627c2a25c$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $c355a66627c2a25c$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $c355a66627c2a25c$export$a60af00cc0ce2582({
            schema: this,
            typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $c355a66627c2a25c$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $c355a66627c2a25c$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $c355a66627c2a25c$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $c355a66627c2a25c$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $c355a66627c2a25c$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $c355a66627c2a25c$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $c355a66627c2a25c$export$a60af00cc0ce2582({
            ...$c355a66627c2a25c$var$processCreateParams(this._def),
            schema: this,
            typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $c355a66627c2a25c$export$bb19b37874861e7e({
            ...$c355a66627c2a25c$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $c355a66627c2a25c$export$66b0c798a395271f({
            typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$c355a66627c2a25c$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $c355a66627c2a25c$export$75a44ec6249ac76b({
            ...$c355a66627c2a25c$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $c355a66627c2a25c$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $c355a66627c2a25c$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
}
const $c355a66627c2a25c$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $c355a66627c2a25c$var$cuid2Regex = /^[0-9a-z]+$/;
const $c355a66627c2a25c$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $c355a66627c2a25c$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $c355a66627c2a25c$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $c355a66627c2a25c$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $c355a66627c2a25c$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $c355a66627c2a25c$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $c355a66627c2a25c$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $c355a66627c2a25c$var$emojiRegex;
// faster, simpler, safer
const $c355a66627c2a25c$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $c355a66627c2a25c$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $c355a66627c2a25c$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $c355a66627c2a25c$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $c355a66627c2a25c$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $c355a66627c2a25c$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $c355a66627c2a25c$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $c355a66627c2a25c$var$dateRegex = new RegExp(`^${$c355a66627c2a25c$var$dateRegexSource}$`);
function $c355a66627c2a25c$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $c355a66627c2a25c$var$timeRegex(args) {
    return new RegExp(`^${$c355a66627c2a25c$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $c355a66627c2a25c$export$a4b563879add27a(args) {
    let regex = `${$c355a66627c2a25c$var$dateRegexSource}T${$c355a66627c2a25c$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $c355a66627c2a25c$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $c355a66627c2a25c$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $c355a66627c2a25c$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $c355a66627c2a25c$var$isValidJWT(jwt, alg) {
    if (!$c355a66627c2a25c$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if (!decoded.typ || !decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch (_a) {
        return false;
    }
}
function $c355a66627c2a25c$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $c355a66627c2a25c$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $c355a66627c2a25c$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $c355a66627c2a25c$export$1230eb29b8d3b502 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        const status = new $c355a66627c2a25c$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$c355a66627c2a25c$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$c355a66627c2a25c$var$emojiRegex) $c355a66627c2a25c$var$emojiRegex = new RegExp($c355a66627c2a25c$var$_emojiRegex, "u");
                if (!$c355a66627c2a25c$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$c355a66627c2a25c$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$c355a66627c2a25c$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$c355a66627c2a25c$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$c355a66627c2a25c$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$c355a66627c2a25c$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $c355a66627c2a25c$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $c355a66627c2a25c$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $c355a66627c2a25c$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$c355a66627c2a25c$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$c355a66627c2a25c$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$c355a66627c2a25c$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        validation: "jwt",
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$c355a66627c2a25c$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        validation: "cidr",
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$c355a66627c2a25c$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$c355a66627c2a25c$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        validation: "base64url",
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $c355a66627c2a25c$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_string,
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $c355a66627c2a25c$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...$c355a66627c2a25c$var$errorUtil.errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$c355a66627c2a25c$var$errorUtil.errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...$c355a66627c2a25c$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$c355a66627c2a25c$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$c355a66627c2a25c$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$c355a66627c2a25c$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$c355a66627c2a25c$var$errorUtil.errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, $c355a66627c2a25c$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $c355a66627c2a25c$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $c355a66627c2a25c$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $c355a66627c2a25c$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$c355a66627c2a25c$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $c355a66627c2a25c$export$1230eb29b8d3b502({
        checks: [],
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $c355a66627c2a25c$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $c355a66627c2a25c$export$5b070a55c0c43e09 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $c355a66627c2a25c$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$c355a66627c2a25c$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($c355a66627c2a25c$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $c355a66627c2a25c$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $c355a66627c2a25c$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $c355a66627c2a25c$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $c355a66627c2a25c$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $c355a66627c2a25c$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $c355a66627c2a25c$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $c355a66627c2a25c$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $c355a66627c2a25c$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $c355a66627c2a25c$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $c355a66627c2a25c$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $c355a66627c2a25c$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $c355a66627c2a25c$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $c355a66627c2a25c$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $c355a66627c2a25c$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $c355a66627c2a25c$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $c355a66627c2a25c$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $c355a66627c2a25c$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $c355a66627c2a25c$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
}
$c355a66627c2a25c$export$5b070a55c0c43e09.create = (params)=>{
    return new $c355a66627c2a25c$export$5b070a55c0c43e09({
        checks: [],
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$67d741fd70ff98f4 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch (_a) {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new $c355a66627c2a25c$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $c355a66627c2a25c$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
            code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
            expected: $c355a66627c2a25c$export$5716da67bfaa244d.bigint,
            received: ctx.parsedType
        });
        return $c355a66627c2a25c$export$9a105a556e65c2c0;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $c355a66627c2a25c$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $c355a66627c2a25c$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $c355a66627c2a25c$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $c355a66627c2a25c$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $c355a66627c2a25c$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $c355a66627c2a25c$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $c355a66627c2a25c$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $c355a66627c2a25c$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $c355a66627c2a25c$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $c355a66627c2a25c$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $c355a66627c2a25c$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $c355a66627c2a25c$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
}
$c355a66627c2a25c$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $c355a66627c2a25c$export$67d741fd70ff98f4({
        checks: [],
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$723d146f80596191 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        return $c355a66627c2a25c$export$c6813a8d51f77eaf(input.data);
    }
}
$c355a66627c2a25c$export$723d146f80596191.create = (params)=>{
    return new $c355a66627c2a25c$export$723d146f80596191({
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$e974be33bdc55521 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_date
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        const status = new $c355a66627c2a25c$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $c355a66627c2a25c$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $c355a66627c2a25c$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $c355a66627c2a25c$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $c355a66627c2a25c$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$c355a66627c2a25c$export$e974be33bdc55521.create = (params)=>{
    return new $c355a66627c2a25c$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodDate,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$bcc3b40f6b638044 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        return $c355a66627c2a25c$export$c6813a8d51f77eaf(input.data);
    }
}
$c355a66627c2a25c$export$bcc3b40f6b638044.create = (params)=>{
    return new $c355a66627c2a25c$export$bcc3b40f6b638044({
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodSymbol,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$4e780e961c30340d extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        return $c355a66627c2a25c$export$c6813a8d51f77eaf(input.data);
    }
}
$c355a66627c2a25c$export$4e780e961c30340d.create = (params)=>{
    return new $c355a66627c2a25c$export$4e780e961c30340d({
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodUndefined,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$a96281f914484f2d extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        return $c355a66627c2a25c$export$c6813a8d51f77eaf(input.data);
    }
}
$c355a66627c2a25c$export$a96281f914484f2d.create = (params)=>{
    return new $c355a66627c2a25c$export$a96281f914484f2d({
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodNull,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$b9d1edb536b4e4eb extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        return $c355a66627c2a25c$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
}
$c355a66627c2a25c$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $c355a66627c2a25c$export$b9d1edb536b4e4eb({
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodAny,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$ef3b1bb1630977ae extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        return $c355a66627c2a25c$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
}
$c355a66627c2a25c$export$ef3b1bb1630977ae.create = (params)=>{
    return new $c355a66627c2a25c$export$ef3b1bb1630977ae({
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodUnknown,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$1e576a20c3ce9fb5 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
            code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
            expected: $c355a66627c2a25c$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $c355a66627c2a25c$export$9a105a556e65c2c0;
    }
}
$c355a66627c2a25c$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $c355a66627c2a25c$export$1e576a20c3ce9fb5({
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodNever,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$7d39f5df85f21031 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        return $c355a66627c2a25c$export$c6813a8d51f77eaf(input.data);
    }
}
$c355a66627c2a25c$export$7d39f5df85f21031.create = (params)=>{
    return new $c355a66627c2a25c$export$7d39f5df85f21031({
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodVoid,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$7acfc3e64785411 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.array) {
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $c355a66627c2a25c$export$5ba560653e4a1035.too_big : $c355a66627c2a25c$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                    code: $c355a66627c2a25c$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                    code: $c355a66627c2a25c$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $c355a66627c2a25c$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $c355a66627c2a25c$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $c355a66627c2a25c$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $c355a66627c2a25c$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $c355a66627c2a25c$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $c355a66627c2a25c$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $c355a66627c2a25c$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $c355a66627c2a25c$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $c355a66627c2a25c$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $c355a66627c2a25c$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$c355a66627c2a25c$export$7acfc3e64785411.create = (schema, params)=>{
    return new $c355a66627c2a25c$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodArray,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
function $c355a66627c2a25c$var$deepPartialify(schema) {
    if (schema instanceof $c355a66627c2a25c$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $c355a66627c2a25c$export$aa56fec1e9d629b8.create($c355a66627c2a25c$var$deepPartialify(fieldSchema));
        }
        return new $c355a66627c2a25c$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $c355a66627c2a25c$export$7acfc3e64785411) return new $c355a66627c2a25c$export$7acfc3e64785411({
        ...schema._def,
        type: $c355a66627c2a25c$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $c355a66627c2a25c$export$aa56fec1e9d629b8) return $c355a66627c2a25c$export$aa56fec1e9d629b8.create($c355a66627c2a25c$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $c355a66627c2a25c$export$aaac0b8b429cef5) return $c355a66627c2a25c$export$aaac0b8b429cef5.create($c355a66627c2a25c$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $c355a66627c2a25c$export$e2a18bb771d8e6a3) return $c355a66627c2a25c$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$c355a66627c2a25c$var$deepPartialify(item)));
    else return schema;
}
class $c355a66627c2a25c$export$736315c5b55efbad extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $c355a66627c2a25c$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $c355a66627c2a25c$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $c355a66627c2a25c$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $c355a66627c2a25c$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                        code: $c355a66627c2a25c$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $c355a66627c2a25c$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $c355a66627c2a25c$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $c355a66627c2a25c$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $c355a66627c2a25c$var$errorUtil.errToObj;
        return new $c355a66627c2a25c$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $c355a66627c2a25c$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $c355a66627c2a25c$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $c355a66627c2a25c$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $c355a66627c2a25c$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $c355a66627c2a25c$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $c355a66627c2a25c$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $c355a66627c2a25c$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $c355a66627c2a25c$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $c355a66627c2a25c$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $c355a66627c2a25c$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $c355a66627c2a25c$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $c355a66627c2a25c$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $c355a66627c2a25c$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $c355a66627c2a25c$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $c355a66627c2a25c$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $c355a66627c2a25c$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $c355a66627c2a25c$var$createZodEnum($c355a66627c2a25c$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
}
$c355a66627c2a25c$export$736315c5b55efbad.create = (shape, params)=>{
    return new $c355a66627c2a25c$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $c355a66627c2a25c$export$1e576a20c3ce9fb5.create(),
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodObject,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
$c355a66627c2a25c$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $c355a66627c2a25c$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $c355a66627c2a25c$export$1e576a20c3ce9fb5.create(),
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodObject,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
$c355a66627c2a25c$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $c355a66627c2a25c$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $c355a66627c2a25c$export$1e576a20c3ce9fb5.create(),
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodObject,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$a8b236cb5070a311 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $c355a66627c2a25c$export$f98dac4b251ab333(result.ctx.common.issues));
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $c355a66627c2a25c$export$f98dac4b251ab333(issues));
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$c355a66627c2a25c$export$a8b236cb5070a311.create = (types, params)=>{
    return new $c355a66627c2a25c$export$a8b236cb5070a311({
        options: types,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodUnion,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $c355a66627c2a25c$var$getDiscriminator = (type)=>{
    if (type instanceof $c355a66627c2a25c$export$378d0cfce37406e6) return $c355a66627c2a25c$var$getDiscriminator(type.schema);
    else if (type instanceof $c355a66627c2a25c$export$a60af00cc0ce2582) return $c355a66627c2a25c$var$getDiscriminator(type.innerType());
    else if (type instanceof $c355a66627c2a25c$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $c355a66627c2a25c$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $c355a66627c2a25c$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $c355a66627c2a25c$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $c355a66627c2a25c$export$bb19b37874861e7e) return $c355a66627c2a25c$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $c355a66627c2a25c$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $c355a66627c2a25c$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $c355a66627c2a25c$export$aa56fec1e9d629b8) return [
        undefined,
        ...$c355a66627c2a25c$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $c355a66627c2a25c$export$aaac0b8b429cef5) return [
        null,
        ...$c355a66627c2a25c$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $c355a66627c2a25c$export$66b0c798a395271f) return $c355a66627c2a25c$var$getDiscriminator(type.unwrap());
    else if (type instanceof $c355a66627c2a25c$export$5d1f7ef05c4e493a) return $c355a66627c2a25c$var$getDiscriminator(type.unwrap());
    else if (type instanceof $c355a66627c2a25c$export$75a44ec6249ac76b) return $c355a66627c2a25c$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $c355a66627c2a25c$export$5ef2424805ac76a3 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.object) {
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $c355a66627c2a25c$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $c355a66627c2a25c$export$5ef2424805ac76a3({
            typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$c355a66627c2a25c$var$processCreateParams(params)
        });
    }
}
function $c355a66627c2a25c$var$mergeValues(a, b) {
    const aType = $c355a66627c2a25c$export$3e9057828ebd5c7a(a);
    const bType = $c355a66627c2a25c$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $c355a66627c2a25c$export$5716da67bfaa244d.object && bType === $c355a66627c2a25c$export$5716da67bfaa244d.object) {
        const bKeys = $c355a66627c2a25c$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $c355a66627c2a25c$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $c355a66627c2a25c$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $c355a66627c2a25c$export$5716da67bfaa244d.array && bType === $c355a66627c2a25c$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $c355a66627c2a25c$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $c355a66627c2a25c$export$5716da67bfaa244d.date && bType === $c355a66627c2a25c$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $c355a66627c2a25c$export$c02deaf0bb5203d4 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($c355a66627c2a25c$export$afa861e3c5730743(parsedLeft) || $c355a66627c2a25c$export$afa861e3c5730743(parsedRight)) return $c355a66627c2a25c$export$9a105a556e65c2c0;
            const merged = $c355a66627c2a25c$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                    code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $c355a66627c2a25c$export$9a105a556e65c2c0;
            }
            if ($c355a66627c2a25c$export$910b6cdd390341b3(parsedLeft) || $c355a66627c2a25c$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$c355a66627c2a25c$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $c355a66627c2a25c$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodIntersection,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$e2a18bb771d8e6a3 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.array) {
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $c355a66627c2a25c$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $c355a66627c2a25c$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $c355a66627c2a25c$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $c355a66627c2a25c$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$c355a66627c2a25c$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $c355a66627c2a25c$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$a2acc09968cb4b7f extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.object) {
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $c355a66627c2a25c$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $c355a66627c2a25c$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $c355a66627c2a25c$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $c355a66627c2a25c$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $c355a66627c2a25c$export$19342e026b58ebb7) return new $c355a66627c2a25c$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodRecord,
            ...$c355a66627c2a25c$var$processCreateParams(third)
        });
        return new $c355a66627c2a25c$export$a2acc09968cb4b7f({
            keyType: $c355a66627c2a25c$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodRecord,
            ...$c355a66627c2a25c$var$processCreateParams(second)
        });
    }
}
class $c355a66627c2a25c$export$163b6a2b712d9542 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.map) {
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $c355a66627c2a25c$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $c355a66627c2a25c$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $c355a66627c2a25c$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $c355a66627c2a25c$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$c355a66627c2a25c$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $c355a66627c2a25c$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodMap,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$977057706f816712 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.set) {
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                    code: $c355a66627c2a25c$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                    code: $c355a66627c2a25c$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $c355a66627c2a25c$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $c355a66627c2a25c$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $c355a66627c2a25c$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $c355a66627c2a25c$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $c355a66627c2a25c$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $c355a66627c2a25c$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$c355a66627c2a25c$export$977057706f816712.create = (valueType, params)=>{
    return new $c355a66627c2a25c$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodSet,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$d4602ba55673f53c extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.function) {
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $c355a66627c2a25c$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $c355a66627c2a25c$export$32f27c719778d4c4(),
                    $c355a66627c2a25c$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $c355a66627c2a25c$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $c355a66627c2a25c$export$32f27c719778d4c4(),
                    $c355a66627c2a25c$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $c355a66627c2a25c$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $c355a66627c2a25c$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $c355a66627c2a25c$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $c355a66627c2a25c$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $c355a66627c2a25c$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $c355a66627c2a25c$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $c355a66627c2a25c$export$d4602ba55673f53c({
            ...this._def,
            args: $c355a66627c2a25c$export$e2a18bb771d8e6a3.create(items).rest($c355a66627c2a25c$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $c355a66627c2a25c$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $c355a66627c2a25c$export$d4602ba55673f53c({
            args: args ? args : $c355a66627c2a25c$export$e2a18bb771d8e6a3.create([]).rest($c355a66627c2a25c$export$ef3b1bb1630977ae.create()),
            returns: returns || $c355a66627c2a25c$export$ef3b1bb1630977ae.create(),
            typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodFunction,
            ...$c355a66627c2a25c$var$processCreateParams(params)
        });
    }
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
}
class $c355a66627c2a25c$export$378d0cfce37406e6 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$c355a66627c2a25c$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $c355a66627c2a25c$export$378d0cfce37406e6({
        getter: getter,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodLazy,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$7e44096782a165d3 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$c355a66627c2a25c$export$7e44096782a165d3.create = (value, params)=>{
    return new $c355a66627c2a25c$export$7e44096782a165d3({
        value: value,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodLiteral,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
function $c355a66627c2a25c$var$createZodEnum(values, params) {
    return new $c355a66627c2a25c$export$d325d1f0e1c20179({
        values: values,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodEnum,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
}
class $c355a66627c2a25c$export$d325d1f0e1c20179 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                expected: $c355a66627c2a25c$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        if (!$c355a66627c2a25c$var$__classPrivateFieldGet(this, $c355a66627c2a25c$var$_ZodEnum_cache, "f")) $c355a66627c2a25c$var$__classPrivateFieldSet(this, $c355a66627c2a25c$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$c355a66627c2a25c$var$__classPrivateFieldGet(this, $c355a66627c2a25c$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        return $c355a66627c2a25c$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $c355a66627c2a25c$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $c355a66627c2a25c$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
    constructor(){
        super(...arguments);
        $c355a66627c2a25c$var$_ZodEnum_cache.set(this, void 0);
    }
}
$c355a66627c2a25c$var$_ZodEnum_cache = new WeakMap();
$c355a66627c2a25c$export$d325d1f0e1c20179.create = $c355a66627c2a25c$var$createZodEnum;
class $c355a66627c2a25c$export$370b2e8d6d6f5c56 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $c355a66627c2a25c$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.string && ctx.parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.number) {
            const expectedValues = $c355a66627c2a25c$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                expected: $c355a66627c2a25c$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        if (!$c355a66627c2a25c$var$__classPrivateFieldGet(this, $c355a66627c2a25c$var$_ZodNativeEnum_cache, "f")) $c355a66627c2a25c$var$__classPrivateFieldSet(this, $c355a66627c2a25c$var$_ZodNativeEnum_cache, new Set($c355a66627c2a25c$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$c355a66627c2a25c$var$__classPrivateFieldGet(this, $c355a66627c2a25c$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $c355a66627c2a25c$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        return $c355a66627c2a25c$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
    constructor(){
        super(...arguments);
        $c355a66627c2a25c$var$_ZodNativeEnum_cache.set(this, void 0);
    }
}
$c355a66627c2a25c$var$_ZodNativeEnum_cache = new WeakMap();
$c355a66627c2a25c$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $c355a66627c2a25c$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodNativeEnum,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$3f196b0127d6e50a extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $c355a66627c2a25c$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $c355a66627c2a25c$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$c355a66627c2a25c$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $c355a66627c2a25c$export$3f196b0127d6e50a({
        type: schema,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodPromise,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$a60af00cc0ce2582 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $c355a66627c2a25c$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $c355a66627c2a25c$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $c355a66627c2a25c$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $c355a66627c2a25c$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $c355a66627c2a25c$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $c355a66627c2a25c$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $c355a66627c2a25c$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $c355a66627c2a25c$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $c355a66627c2a25c$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $c355a66627c2a25c$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $c355a66627c2a25c$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $c355a66627c2a25c$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$c355a66627c2a25c$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$c355a66627c2a25c$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $c355a66627c2a25c$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$c355a66627c2a25c$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $c355a66627c2a25c$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
$c355a66627c2a25c$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $c355a66627c2a25c$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodEffects,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$aa56fec1e9d629b8 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $c355a66627c2a25c$export$5716da67bfaa244d.undefined) return $c355a66627c2a25c$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$c355a66627c2a25c$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $c355a66627c2a25c$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodOptional,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$aaac0b8b429cef5 extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $c355a66627c2a25c$export$5716da67bfaa244d.null) return $c355a66627c2a25c$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$c355a66627c2a25c$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $c355a66627c2a25c$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodNullable,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$bb19b37874861e7e extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $c355a66627c2a25c$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$c355a66627c2a25c$export$bb19b37874861e7e.create = (type, params)=>{
    return new $c355a66627c2a25c$export$bb19b37874861e7e({
        innerType: type,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$75a44ec6249ac76b extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($c355a66627c2a25c$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $c355a66627c2a25c$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $c355a66627c2a25c$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$c355a66627c2a25c$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $c355a66627c2a25c$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
class $c355a66627c2a25c$export$26ccfa0145e8511f extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $c355a66627c2a25c$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $c355a66627c2a25c$export$db7caee60e5d514d(ctx, {
                code: $c355a66627c2a25c$export$5ba560653e4a1035.invalid_type,
                expected: $c355a66627c2a25c$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $c355a66627c2a25c$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$c355a66627c2a25c$export$26ccfa0145e8511f.create = (params)=>{
    return new $c355a66627c2a25c$export$26ccfa0145e8511f({
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodNaN,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
const $c355a66627c2a25c$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $c355a66627c2a25c$export$66b0c798a395271f extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $c355a66627c2a25c$export$a3c3ef8a0e95c6da extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $c355a66627c2a25c$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $c355a66627c2a25c$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $c355a66627c2a25c$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $c355a66627c2a25c$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $c355a66627c2a25c$export$5d1f7ef05c4e493a extends $c355a66627c2a25c$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($c355a66627c2a25c$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $c355a66627c2a25c$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$c355a66627c2a25c$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $c355a66627c2a25c$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $c355a66627c2a25c$export$558106ce543bd011.ZodReadonly,
        ...$c355a66627c2a25c$var$processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $c355a66627c2a25c$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $c355a66627c2a25c$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $c355a66627c2a25c$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            var _a, _b;
            if (!r) {
                const params = $c355a66627c2a25c$var$cleanParams(_params, data);
                const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = $c355a66627c2a25c$var$cleanParams(_params, data);
            const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return $c355a66627c2a25c$export$b9d1edb536b4e4eb.create();
}
const $c355a66627c2a25c$export$1ee8ee30835eab8b = {
    object: $c355a66627c2a25c$export$736315c5b55efbad.lazycreate
};
var $c355a66627c2a25c$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($c355a66627c2a25c$export$558106ce543bd011 || ($c355a66627c2a25c$export$558106ce543bd011 = {}));
const $c355a66627c2a25c$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$c355a66627c2a25c$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $c355a66627c2a25c$export$22b082955e083ec3 = $c355a66627c2a25c$export$1230eb29b8d3b502.create;
const $c355a66627c2a25c$export$98e628dec113755e = $c355a66627c2a25c$export$5b070a55c0c43e09.create;
const $c355a66627c2a25c$export$9e06de0973666692 = $c355a66627c2a25c$export$26ccfa0145e8511f.create;
const $c355a66627c2a25c$export$a0f65b52274bcc00 = $c355a66627c2a25c$export$67d741fd70ff98f4.create;
const $c355a66627c2a25c$export$4a21f16c33752377 = $c355a66627c2a25c$export$723d146f80596191.create;
const $c355a66627c2a25c$export$324d90190a8b822a = $c355a66627c2a25c$export$e974be33bdc55521.create;
const $c355a66627c2a25c$export$8f701197936bc2a6 = $c355a66627c2a25c$export$bcc3b40f6b638044.create;
const $c355a66627c2a25c$export$1db45310990710a5 = $c355a66627c2a25c$export$4e780e961c30340d.create;
const $c355a66627c2a25c$export$7b1b591b262c240 = $c355a66627c2a25c$export$a96281f914484f2d.create;
const $c355a66627c2a25c$export$4154a199d7d90455 = $c355a66627c2a25c$export$b9d1edb536b4e4eb.create;
const $c355a66627c2a25c$export$19282c40b967aec6 = $c355a66627c2a25c$export$ef3b1bb1630977ae.create;
const $c355a66627c2a25c$export$b3e22bcfd64c1022 = $c355a66627c2a25c$export$1e576a20c3ce9fb5.create;
const $c355a66627c2a25c$export$490e536ee7389aeb = $c355a66627c2a25c$export$7d39f5df85f21031.create;
const $c355a66627c2a25c$export$2f23118c22fb2630 = $c355a66627c2a25c$export$7acfc3e64785411.create;
const $c355a66627c2a25c$export$be5493f9613cbbe = $c355a66627c2a25c$export$736315c5b55efbad.create;
const $c355a66627c2a25c$export$8fb0df5f40d0b477 = $c355a66627c2a25c$export$736315c5b55efbad.strictCreate;
const $c355a66627c2a25c$export$971dd5b0dfd021b6 = $c355a66627c2a25c$export$a8b236cb5070a311.create;
const $c355a66627c2a25c$export$4b888e40c4ee26dd = $c355a66627c2a25c$export$5ef2424805ac76a3.create;
const $c355a66627c2a25c$export$bc86dfbf7795668c = $c355a66627c2a25c$export$c02deaf0bb5203d4.create;
const $c355a66627c2a25c$export$65e3907585753458 = $c355a66627c2a25c$export$e2a18bb771d8e6a3.create;
const $c355a66627c2a25c$export$e5185e241753e543 = $c355a66627c2a25c$export$a2acc09968cb4b7f.create;
const $c355a66627c2a25c$export$871de8747c9eaa88 = $c355a66627c2a25c$export$163b6a2b712d9542.create;
const $c355a66627c2a25c$export$adaa4cf7ef1b65be = $c355a66627c2a25c$export$977057706f816712.create;
const $c355a66627c2a25c$export$44e51c8aac7c2deb = $c355a66627c2a25c$export$d4602ba55673f53c.create;
const $c355a66627c2a25c$export$488013bae63b21da = $c355a66627c2a25c$export$378d0cfce37406e6.create;
const $c355a66627c2a25c$export$c8ec6e1ec9fefcb0 = $c355a66627c2a25c$export$7e44096782a165d3.create;
const $c355a66627c2a25c$export$78a99c8d44d72635 = $c355a66627c2a25c$export$d325d1f0e1c20179.create;
const $c355a66627c2a25c$export$6fe7eca19ebe5199 = $c355a66627c2a25c$export$370b2e8d6d6f5c56.create;
const $c355a66627c2a25c$export$c957ef27a0ebfd4 = $c355a66627c2a25c$export$3f196b0127d6e50a.create;
const $c355a66627c2a25c$export$dc573d8a6576cdb3 = $c355a66627c2a25c$export$a60af00cc0ce2582.create;
const $c355a66627c2a25c$export$516e28dec6a4b6d4 = $c355a66627c2a25c$export$aa56fec1e9d629b8.create;
const $c355a66627c2a25c$export$133fc36489ac9add = $c355a66627c2a25c$export$aaac0b8b429cef5.create;
const $c355a66627c2a25c$export$fc37fe19dfda43ee = $c355a66627c2a25c$export$a60af00cc0ce2582.createWithPreprocess;
const $c355a66627c2a25c$export$43f28b24e1eb8181 = $c355a66627c2a25c$export$a3c3ef8a0e95c6da.create;
const $c355a66627c2a25c$export$3b3d07727c5b702c = ()=>$c355a66627c2a25c$export$22b082955e083ec3().optional();
const $c355a66627c2a25c$export$eb150471a61fced6 = ()=>$c355a66627c2a25c$export$98e628dec113755e().optional();
const $c355a66627c2a25c$export$269251733cdcbbf1 = ()=>$c355a66627c2a25c$export$4a21f16c33752377().optional();
const $c355a66627c2a25c$export$8c14e57e778d3873 = {
    string: (arg)=>$c355a66627c2a25c$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$c355a66627c2a25c$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$c355a66627c2a25c$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$c355a66627c2a25c$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$c355a66627c2a25c$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $c355a66627c2a25c$export$96c94437c95d7862 = $c355a66627c2a25c$export$9a105a556e65c2c0;
var $c355a66627c2a25c$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $c355a66627c2a25c$export$341b0b6e0a6f5099,
    setErrorMap: $c355a66627c2a25c$export$1097a8289cfd22d7,
    getErrorMap: $c355a66627c2a25c$export$32f27c719778d4c4,
    makeIssue: $c355a66627c2a25c$export$244a85fde9c419ed,
    EMPTY_PATH: $c355a66627c2a25c$export$1526d2e05f74572,
    addIssueToContext: $c355a66627c2a25c$export$db7caee60e5d514d,
    ParseStatus: $c355a66627c2a25c$export$5b20a5c3d05c1f6f,
    INVALID: $c355a66627c2a25c$export$9a105a556e65c2c0,
    DIRTY: $c355a66627c2a25c$export$325a211da9693fcf,
    OK: $c355a66627c2a25c$export$c6813a8d51f77eaf,
    isAborted: $c355a66627c2a25c$export$afa861e3c5730743,
    isDirty: $c355a66627c2a25c$export$910b6cdd390341b3,
    isValid: $c355a66627c2a25c$export$1ea939691cdc45b8,
    isAsync: $c355a66627c2a25c$export$aefee5ebe1dcfd9e,
    get util () {
        return $c355a66627c2a25c$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $c355a66627c2a25c$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $c355a66627c2a25c$export$5716da67bfaa244d,
    getParsedType: $c355a66627c2a25c$export$3e9057828ebd5c7a,
    ZodType: $c355a66627c2a25c$export$19342e026b58ebb7,
    datetimeRegex: $c355a66627c2a25c$export$a4b563879add27a,
    ZodString: $c355a66627c2a25c$export$1230eb29b8d3b502,
    ZodNumber: $c355a66627c2a25c$export$5b070a55c0c43e09,
    ZodBigInt: $c355a66627c2a25c$export$67d741fd70ff98f4,
    ZodBoolean: $c355a66627c2a25c$export$723d146f80596191,
    ZodDate: $c355a66627c2a25c$export$e974be33bdc55521,
    ZodSymbol: $c355a66627c2a25c$export$bcc3b40f6b638044,
    ZodUndefined: $c355a66627c2a25c$export$4e780e961c30340d,
    ZodNull: $c355a66627c2a25c$export$a96281f914484f2d,
    ZodAny: $c355a66627c2a25c$export$b9d1edb536b4e4eb,
    ZodUnknown: $c355a66627c2a25c$export$ef3b1bb1630977ae,
    ZodNever: $c355a66627c2a25c$export$1e576a20c3ce9fb5,
    ZodVoid: $c355a66627c2a25c$export$7d39f5df85f21031,
    ZodArray: $c355a66627c2a25c$export$7acfc3e64785411,
    ZodObject: $c355a66627c2a25c$export$736315c5b55efbad,
    ZodUnion: $c355a66627c2a25c$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $c355a66627c2a25c$export$5ef2424805ac76a3,
    ZodIntersection: $c355a66627c2a25c$export$c02deaf0bb5203d4,
    ZodTuple: $c355a66627c2a25c$export$e2a18bb771d8e6a3,
    ZodRecord: $c355a66627c2a25c$export$a2acc09968cb4b7f,
    ZodMap: $c355a66627c2a25c$export$163b6a2b712d9542,
    ZodSet: $c355a66627c2a25c$export$977057706f816712,
    ZodFunction: $c355a66627c2a25c$export$d4602ba55673f53c,
    ZodLazy: $c355a66627c2a25c$export$378d0cfce37406e6,
    ZodLiteral: $c355a66627c2a25c$export$7e44096782a165d3,
    ZodEnum: $c355a66627c2a25c$export$d325d1f0e1c20179,
    ZodNativeEnum: $c355a66627c2a25c$export$370b2e8d6d6f5c56,
    ZodPromise: $c355a66627c2a25c$export$3f196b0127d6e50a,
    ZodEffects: $c355a66627c2a25c$export$a60af00cc0ce2582,
    ZodTransformer: $c355a66627c2a25c$export$a60af00cc0ce2582,
    ZodOptional: $c355a66627c2a25c$export$aa56fec1e9d629b8,
    ZodNullable: $c355a66627c2a25c$export$aaac0b8b429cef5,
    ZodDefault: $c355a66627c2a25c$export$bb19b37874861e7e,
    ZodCatch: $c355a66627c2a25c$export$75a44ec6249ac76b,
    ZodNaN: $c355a66627c2a25c$export$26ccfa0145e8511f,
    BRAND: $c355a66627c2a25c$export$cf2deea74cde46b4,
    ZodBranded: $c355a66627c2a25c$export$66b0c798a395271f,
    ZodPipeline: $c355a66627c2a25c$export$a3c3ef8a0e95c6da,
    ZodReadonly: $c355a66627c2a25c$export$5d1f7ef05c4e493a,
    custom: $c355a66627c2a25c$export$4c00f665f0d4b443,
    Schema: $c355a66627c2a25c$export$19342e026b58ebb7,
    ZodSchema: $c355a66627c2a25c$export$19342e026b58ebb7,
    late: $c355a66627c2a25c$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $c355a66627c2a25c$export$558106ce543bd011;
    },
    coerce: $c355a66627c2a25c$export$8c14e57e778d3873,
    any: $c355a66627c2a25c$export$4154a199d7d90455,
    array: $c355a66627c2a25c$export$2f23118c22fb2630,
    bigint: $c355a66627c2a25c$export$a0f65b52274bcc00,
    boolean: $c355a66627c2a25c$export$4a21f16c33752377,
    date: $c355a66627c2a25c$export$324d90190a8b822a,
    discriminatedUnion: $c355a66627c2a25c$export$4b888e40c4ee26dd,
    effect: $c355a66627c2a25c$export$dc573d8a6576cdb3,
    'enum': $c355a66627c2a25c$export$78a99c8d44d72635,
    'function': $c355a66627c2a25c$export$44e51c8aac7c2deb,
    'instanceof': $c355a66627c2a25c$export$3d916e7c22dbd8b5,
    intersection: $c355a66627c2a25c$export$bc86dfbf7795668c,
    lazy: $c355a66627c2a25c$export$488013bae63b21da,
    literal: $c355a66627c2a25c$export$c8ec6e1ec9fefcb0,
    map: $c355a66627c2a25c$export$871de8747c9eaa88,
    nan: $c355a66627c2a25c$export$9e06de0973666692,
    nativeEnum: $c355a66627c2a25c$export$6fe7eca19ebe5199,
    never: $c355a66627c2a25c$export$b3e22bcfd64c1022,
    'null': $c355a66627c2a25c$export$7b1b591b262c240,
    nullable: $c355a66627c2a25c$export$133fc36489ac9add,
    number: $c355a66627c2a25c$export$98e628dec113755e,
    object: $c355a66627c2a25c$export$be5493f9613cbbe,
    oboolean: $c355a66627c2a25c$export$269251733cdcbbf1,
    onumber: $c355a66627c2a25c$export$eb150471a61fced6,
    optional: $c355a66627c2a25c$export$516e28dec6a4b6d4,
    ostring: $c355a66627c2a25c$export$3b3d07727c5b702c,
    pipeline: $c355a66627c2a25c$export$43f28b24e1eb8181,
    preprocess: $c355a66627c2a25c$export$fc37fe19dfda43ee,
    promise: $c355a66627c2a25c$export$c957ef27a0ebfd4,
    record: $c355a66627c2a25c$export$e5185e241753e543,
    set: $c355a66627c2a25c$export$adaa4cf7ef1b65be,
    strictObject: $c355a66627c2a25c$export$8fb0df5f40d0b477,
    string: $c355a66627c2a25c$export$22b082955e083ec3,
    symbol: $c355a66627c2a25c$export$8f701197936bc2a6,
    transformer: $c355a66627c2a25c$export$dc573d8a6576cdb3,
    tuple: $c355a66627c2a25c$export$65e3907585753458,
    'undefined': $c355a66627c2a25c$export$1db45310990710a5,
    union: $c355a66627c2a25c$export$971dd5b0dfd021b6,
    unknown: $c355a66627c2a25c$export$19282c40b967aec6,
    'void': $c355a66627c2a25c$export$490e536ee7389aeb,
    NEVER: $c355a66627c2a25c$export$96c94437c95d7862,
    ZodIssueCode: $c355a66627c2a25c$export$5ba560653e4a1035,
    quotelessJson: $c355a66627c2a25c$export$913eddeaf297cfea,
    ZodError: $c355a66627c2a25c$export$f98dac4b251ab333
});
module.exports["ZodIssueCode"] = $c355a66627c2a25c$export$5ba560653e4a1035;
module.exports["ZodError"] = $c355a66627c2a25c$export$f98dac4b251ab333;
module.exports["z"] = $c355a66627c2a25c$export$2e2bcd8739ae039;

});

parcelRegister("6VdZc", function(module, exports) {
const $395744933753531e$export$cae3e50f876b8cc = {
    transitionId: 0,
    pageLoadStartTimestamp: 0,
    routeName: null,
    previousRoute: null,
    startTimes: {},
    previousContentId: null,
    contentId: null
};
const $395744933753531e$export$5700203954193e40 = ()=>$395744933753531e$export$cae3e50f876b8cc.transitionId === 0;
module.exports["browserMetricsState"] = $395744933753531e$export$cae3e50f876b8cc;
module.exports["isInitial"] = $395744933753531e$export$5700203954193e40;

});

parcelRegister("17wUi", function(module, exports) {
$parcel$export(module.exports, "confluenceLocalStorageInstance", () => $a45406714c4ff091$export$7691d7c35a352a10);
$parcel$export(module.exports, "confluenceSessionStorageInstance", () => $a45406714c4ff091$export$fb051bd2501e65b3);

var $c4TO3 = parcelRequire("c4TO3");


var $9wGTI = parcelRequire("9wGTI");


var $5MeCb = parcelRequire("5MeCb");


var $fPYum = parcelRequire("fPYum");



var $i6sMX = parcelRequire("i6sMX");

// check if local and session storage are valid
const $a45406714c4ff091$var$isStorageValid = (storage)=>{
    try {
        return typeof storage !== 'undefined' && 'setItem' in storage && // in IE8 typeof localStorage.setItem === 'object'
        !!storage.setItem;
    } catch (e) {
        return false;
    }
};
const $a45406714c4ff091$var$getStorage = (type)=>{
    if (typeof window === 'object' && $a45406714c4ff091$var$isStorageValid(window[type])) return window[type];
    return null;
};
let $a45406714c4ff091$export$7691d7c35a352a10;
let $a45406714c4ff091$export$fb051bd2501e65b3;
const $a45406714c4ff091$export$68017d60ff81319c = async (initializationData)=>{
    let confluenceLocalStorage = null;
    let confluenceSessionStorage = null;
    if ((0, $9wGTI.fg)('confluence_browser_storage_controls')) {
        confluenceLocalStorage = (0, $c4TO3.AtlBrowserStorageLocal);
        confluenceSessionStorage = (0, $c4TO3.AtlBrowserStorageSession);
    } else {
        confluenceLocalStorage = $a45406714c4ff091$var$getStorage('localStorage');
        confluenceSessionStorage = $a45406714c4ff091$var$getStorage('sessionStorage');
    }
    $a45406714c4ff091$export$7691d7c35a352a10 = new (0, $5MeCb.StorageManager)(confluenceLocalStorage, (0, $fPYum.STORAGE_MANAGER_PREFIX), (0, $fPYum.STORAGE_MANAGER_ID), (0, $fPYum.LOCAL_STORAGE_MANAGER), initializationData);
    $a45406714c4ff091$export$fb051bd2501e65b3 = new (0, $5MeCb.StorageManager)(confluenceSessionStorage, (0, $fPYum.STORAGE_MANAGER_PREFIX), (0, $fPYum.STORAGE_MANAGER_ID), (0, $fPYum.SESSION_STORAGE_MANAGER), initializationData);
    const result = await (0, $i6sMX.getRemoteLocalStorage)(initializationData);
    if (result) $a45406714c4ff091$export$7691d7c35a352a10.initializeFromServer(result);
};
module.exports["initializeStorageManager"] = $a45406714c4ff091$export$68017d60ff81319c;

});

parcelRegister("c4TO3", function(module, exports) {
$parcel$export(module.exports, "WebStorageType", () => (parcelRequire("hohxW")).WebStorageType);

var $2i8PW = parcelRequire("2i8PW");

var $kfwMJ = parcelRequire("kfwMJ");


var $6ZgEd = parcelRequire("6ZgEd");


var $ccRXO = parcelRequire("ccRXO");


var $8oAcs = parcelRequire("8oAcs");


var $hohxW = parcelRequire("hohxW");


var $c5a0x = parcelRequire("c5a0x");




const $bbae81025aa9741c$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $c5a0x.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};





var $6RSiP = parcelRequire("6RSiP");













const $b351bf29be3f52e2$export$5ee8760f703d9d62 = async (itemKey, value, storageType, productName, browserStorage)=>{
    // user belongs to an org that opted into cookies management and we should respect their preferences
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetItem = await (0, $6RSiP.isProcessingAllowedByPreferences)({
        itemKey: itemKey,
        storageType: storageType === (0, $hohxW.WebStorageType).LocalStorage ? (0, $ccRXO.CategoryStorageType).LocalStorage : (0, $ccRXO.CategoryStorageType).SessionStorage,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $c5a0x.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // Store the item as a record in our IDB service to track that we've seen it before.
            // That way, when we can confirm/deny that this has been set by our service when we check again.
            // If it fails for some reason, it will be caught before actually setting the item
            await (0, $8oAcs.BSCIndexedDB).setRecord(itemKey);
            browserStorage.setItem(itemKey, value);
            return (0, $ccRXO.Status).SUCCESS;
        } else return (0, $ccRXO.Status).BLOCKED;
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetItemError',
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`
        });
        return (0, $ccRXO.Status).BLOCKED;
    }
};













const $a68a22533abb1f74$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    // Flag disabled, allow all items.
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $c5a0x.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        // Store the item as a record in our IDB service to track that we've seen it before.
        // That way, when we can confirm/deny that this has been set by our service when we check again.
        // If it fails for some reason, it will be caught before actually setting the item
        // As setting Strictly Necessary requires synchronous operation, wait on the promise in an OG fashion
        (0, $8oAcs.BSCIndexedDB).setRecord(itemKey).then(()=>{
        // NOTE: Should this just no-op/be removed? It already set and returned the item theoretically since this main func is sync
        }).catch((e)=>{
            // Rethrow to the above catch clause since this is async within a sync func
            throw new Error(e.message || '');
        });
        browserStorage.setItem(itemKey, value);
        return (0, $ccRXO.Status).SUCCESS;
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $ccRXO.Status).FAILED;
    }
};


class $eb1e45e810a4d372$export$8e4a3cf07a10930b {
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStoragedEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, $2i8PW.getBscGlobalState)().webStorageEnabled) return true;
        (0, $6ZgEd.Logger).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $6ZgEd.Logger).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, $bbae81025aa9741c$export$e612bb1301d659de)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $6ZgEd.Logger).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            return;
        }
        const globalStateProduct = (0, $2i8PW.getBscGlobalState)().product;
        const itemSetStatus = await (0, $b351bf29be3f52e2$export$5ee8760f703d9d62)(key, value, this.storageType, globalStateProduct, this.storage);
        (0, $6ZgEd.Logger).debug(`${itemSetStatus === (0, $ccRXO.Status).SUCCESS ? 'Successfully' : 'Failed to'} set item ${key} with value ${value}`);
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $6ZgEd.Logger).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, $a68a22533abb1f74$export$f1b0c189562aa9fd)(key, value, this.storageType, this.storage);
        (0, $6ZgEd.Logger).debug(`${itemSetStatus === (0, $ccRXO.Status).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $6ZgEd.Logger).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $kfwMJ.isSSR)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
    constructor(storage, storageType){
        this.storage = void 0;
        this.storageType = void 0;
        this.isAvailable = false;
        this.checkIfSetByPackage = async ({ itemKey: itemKey, isSetCallback: isSetCallback = ()=>{}, isNotSetCallback: isNotSetCallback = ()=>{} })=>{
            // As IDB is asynchronous in nature, when this in invoked, we need to rely on the callbacks
            // to actually do something with the result.
            try {
                const record = await (0, $8oAcs.BSCIndexedDB).getRecord(itemKey);
                if (record) {
                    isSetCallback();
                    return true;
                } else {
                    isNotSetCallback();
                    return false;
                }
            } catch (e) {
                // If it fails to pull from IDB, we can't validate that it's been set by our package or not, so log the error
                // and assume it hasn't been set by our package. This will only impact our analytics correctness.
                (0, $6ZgEd.Logger).errorWithOperationalEvent({
                    action: 'usedCheckIfSetByPackageError',
                    message: `IDB lookup failed to check if item was set by package. ${e.message || ''}`,
                    attributes: {
                        itemKey: itemKey
                    }
                });
                isNotSetCallback();
                return false;
            }
        };
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
}
const $eb1e45e810a4d372$export$c8cc3ffd3f2c1d2f = new $eb1e45e810a4d372$export$8e4a3cf07a10930b(window?.localStorage, (0, $hohxW.WebStorageType).LocalStorage);
const $eb1e45e810a4d372$export$edbae459bdf957a5 = new $eb1e45e810a4d372$export$8e4a3cf07a10930b(window?.sessionStorage, (0, $hohxW.WebStorageType).SessionStorage);
const $eb1e45e810a4d372$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $hohxW.WebStorageType).LocalStorage]: $eb1e45e810a4d372$export$c8cc3ffd3f2c1d2f,
        [(0, $hohxW.WebStorageType).SessionStorage]: $eb1e45e810a4d372$export$edbae459bdf957a5
    })[type];
};
module.exports["AtlBrowserStorageLocal"] = $eb1e45e810a4d372$export$c8cc3ffd3f2c1d2f;
module.exports["AtlBrowserStorageSession"] = $eb1e45e810a4d372$export$edbae459bdf957a5;
module.exports["findStorageTarget"] = $eb1e45e810a4d372$export$14921bfc334334c0;

});

parcelRegister("2i8PW", function(module, exports) {

var $5k5F7 = parcelRequire("5k5F7");


var $dh538 = parcelRequire("dh538");


var $ccRXO = parcelRequire("ccRXO");








var $6ZgEd = parcelRequire("6ZgEd");


var $iL7bG = parcelRequire("iL7bG");

class $ee0817fc7043f39c$export$e479342c697b82a9 {
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
   * Unpacks the response promise from the categories CDN
   *
   * errors if that request was unsuccessful, returns the categories data otherwise
   *
   */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || response?.json();
        return this.localResponseJsonPromiseCache;
    }
    async loadStorageControlsData() {
        if (this.localResponseCache) return this.localResponseCache;
        else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $6ZgEd.Logger).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            return this.localResponseCache;
        } catch (e) {
            (0, $6ZgEd.Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
    constructor(storageType, perimeter = 'commercial'){
        this.cacheUrl = void 0;
        /**
     * Cache variable for storing categorized cookies cache
     */ this.localResponseCache = void 0;
        /**
     * Cache variable for storing a promise that's been fired by a different invocation of loadStorageControls
     *
     * Allows for many invocations to happen simultaneously, and for only one fetch to go out
     */ this.localResponsePromiseCache = void 0;
        /**
     * Cache variable for storing the promise returned from the response object's json method
     *
     * Ensures we don't invoke response.json multiple times
     */ this.localResponseJsonPromiseCache = void 0;
        if (!(0, $dh538.fg)('fedramp-cookies-controls')) switch(storageType){
            case (0, $ccRXO.CategoryStorageType).Cookies:
                this.cacheUrl = (0, $iL7bG.COOKIE_CACHE_URL_COMMERCIAL_PROD);
                break;
            case (0, $ccRXO.CategoryStorageType).LocalStorage:
                this.cacheUrl = (0, $iL7bG.LOCAL_STORAGE_CACHE_URL_COMMERCIAL_PROD);
                break;
            case (0, $ccRXO.CategoryStorageType).SessionStorage:
                this.cacheUrl = (0, $iL7bG.SESSION_STORAGE_CACHE_URL_COMMERCIAL_PROD);
                break;
            default:
                this.cacheUrl = (0, $iL7bG.LEGACY_COOKIE_CACHE_URL_PROD);
        }
        else {
            // If a new perimeter type is added, but not supported by us yet, default to commercial URLs
            const cacheUrlLookup = (0, $iL7bG.CATEGORY_CACHE_URL_PERIMETER_LOOKUP)[perimeter] || (0, $iL7bG.COMMERCIAL_CATEGORY_CACHE_URL_LOOKUP);
            this.cacheUrl = cacheUrlLookup[storageType];
        }
    }
}





let $d0f80ab9024add60$var$analyticsEnabledGlobalState;
let $d0f80ab9024add60$var$productGlobalState;
let $d0f80ab9024add60$var$perimeterGlobalState;
let $d0f80ab9024add60$var$webStorageControlsEnabledGlobalState;
let $d0f80ab9024add60$var$localConsentModeGlobalState;
let $d0f80ab9024add60$var$packageDebugModeEnabledGlobalState;
let $d0f80ab9024add60$var$allowUncategorizedCookiesInOverridesGlobalState;
let $d0f80ab9024add60$var$hasInitialized = false;
let $d0f80ab9024add60$var$cookiesCacheLoader;
let $d0f80ab9024add60$var$localStorageCacheLoader;
let $d0f80ab9024add60$var$sessionStorageCacheLoader;
let $d0f80ab9024add60$var$loadCache = async (storageType)=>{
    switch(storageType){
        case (0, $ccRXO.CategoryStorageType).Cookies:
            return await $d0f80ab9024add60$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $ccRXO.CategoryStorageType).LocalStorage:
            return await $d0f80ab9024add60$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $ccRXO.CategoryStorageType).SessionStorage:
            return await $d0f80ab9024add60$var$sessionStorageCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
const $d0f80ab9024add60$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $d0f80ab9024add60$var$analyticsEnabledGlobalState ?? true,
        product: $d0f80ab9024add60$var$productGlobalState,
        perimeter: $d0f80ab9024add60$var$perimeterGlobalState,
        webStorageEnabled: $d0f80ab9024add60$var$webStorageControlsEnabledGlobalState ?? false,
        localConsentMode: $d0f80ab9024add60$var$localConsentModeGlobalState ?? false,
        packageDebugMode: $d0f80ab9024add60$var$packageDebugModeEnabledGlobalState,
        allowUncategorizedCookiesInOverrides: $d0f80ab9024add60$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        cookiesCacheLoader: $d0f80ab9024add60$var$cookiesCacheLoader,
        localStorageCacheLoader: $d0f80ab9024add60$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $d0f80ab9024add60$var$sessionStorageCacheLoader,
        loadCache: $d0f80ab9024add60$var$loadCache,
        hasInitialized: $d0f80ab9024add60$var$hasInitialized
    };
};
const $d0f80ab9024add60$export$882c4530c58781d8 = ({ webStorageEnabled: webStorageEnabled, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, localConsentMode: localConsentMode = false, product: product = 'all', perimeter: perimeter = 'commercial', analyticsEnabled: analyticsEnabled = true } = {})=>{
    (0, $6ZgEd.Logger).debug('Initialize global state invoked');
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!$d0f80ab9024add60$var$productGlobalState || $d0f80ab9024add60$var$productGlobalState == null || $d0f80ab9024add60$var$productGlobalState === 'all') && product) $d0f80ab9024add60$var$productGlobalState = product;
    // Treating webStorageEnabled and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    if (webStorageEnabled !== undefined && $d0f80ab9024add60$var$webStorageControlsEnabledGlobalState === undefined) $d0f80ab9024add60$var$webStorageControlsEnabledGlobalState = webStorageEnabled && !(0, $dh538.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $dh538.fg)('platform_moonjelly_bsc_web_storage_killswitch');
    if (allowUncategorizedCookiesInOverrides !== undefined && $d0f80ab9024add60$var$allowUncategorizedCookiesInOverridesGlobalState === undefined) $d0f80ab9024add60$var$allowUncategorizedCookiesInOverridesGlobalState = allowUncategorizedCookiesInOverrides;
    // All other state can only be initialized once and is defaulted if not passed on the first initialization
    if ($d0f80ab9024add60$var$hasInitialized) return;
    if (!(0, $dh538.fg)('fedramp-cookies-controls')) $d0f80ab9024add60$var$localConsentModeGlobalState = localConsentMode;
    else // Force local consent mode when in the FedRAMP Moderate perimeter because ConsentHub is
    // not hydrated in the perimeter as of this comment
    $d0f80ab9024add60$var$localConsentModeGlobalState = localConsentMode || perimeter === 'fedramp-moderate';
    $d0f80ab9024add60$var$analyticsEnabledGlobalState = analyticsEnabled;
    $d0f80ab9024add60$var$perimeterGlobalState = perimeter;
    $d0f80ab9024add60$var$cookiesCacheLoader = new (0, $ee0817fc7043f39c$export$e479342c697b82a9)((0, $ccRXO.CategoryStorageType).Cookies, perimeter);
    $d0f80ab9024add60$var$localStorageCacheLoader = new (0, $ee0817fc7043f39c$export$e479342c697b82a9)((0, $ccRXO.CategoryStorageType).LocalStorage, perimeter);
    $d0f80ab9024add60$var$sessionStorageCacheLoader = new (0, $ee0817fc7043f39c$export$e479342c697b82a9)((0, $ccRXO.CategoryStorageType).SessionStorage, perimeter);
    if ((0, $dh538.fg)('platform_moonjelly_bsc_debug_mode')) $d0f80ab9024add60$var$packageDebugModeEnabledGlobalState = Boolean((0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).get('atl-bsc-debug-mode'));
    $d0f80ab9024add60$var$hasInitialized = true;
};
const $d0f80ab9024add60$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, product: overrideProduct })=>{
    if (overrideLoadCache) $d0f80ab9024add60$var$loadCache = overrideLoadCache;
    if (overrideProduct) $d0f80ab9024add60$var$productGlobalState = overrideProduct;
};
const $d0f80ab9024add60$export$ac7c2edd09656c05 = ()=>{
    $d0f80ab9024add60$var$analyticsEnabledGlobalState = undefined;
    $d0f80ab9024add60$var$productGlobalState = undefined;
    $d0f80ab9024add60$var$webStorageControlsEnabledGlobalState = undefined;
    $d0f80ab9024add60$var$localConsentModeGlobalState = undefined;
    $d0f80ab9024add60$var$packageDebugModeEnabledGlobalState = undefined;
    $d0f80ab9024add60$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $d0f80ab9024add60$var$cookiesCacheLoader = undefined;
    $d0f80ab9024add60$var$localStorageCacheLoader = undefined;
    $d0f80ab9024add60$var$sessionStorageCacheLoader = undefined;
    $d0f80ab9024add60$var$hasInitialized = false;
};
module.exports["getBscGlobalState"] = $d0f80ab9024add60$export$3b78a1ea01f5ec28;
module.exports["initializeGlobalState"] = $d0f80ab9024add60$export$882c4530c58781d8;

});

parcelRegister("ccRXO", function(module, exports) {
var $5f54433b8b296b64$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $5f54433b8b296b64$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $5f54433b8b296b64$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $5f54433b8b296b64$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $5f54433b8b296b64$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $5f54433b8b296b64$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    return CategoryStorageType;
}({});
var $5f54433b8b296b64$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});
var $5f54433b8b296b64$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});
module.exports["PreferenceCategory"] = $5f54433b8b296b64$export$ba064dbfe4bb66d7;
module.exports["ConsentPreferenceV2"] = $5f54433b8b296b64$export$cdef20bac194f235;
module.exports["ContextualConsentProperty"] = $5f54433b8b296b64$export$fac80ad19b60e313;
module.exports["PrefetchedPreferenceState"] = $5f54433b8b296b64$export$5d6594a0bba4ab8a;
module.exports["CategoryStorageType"] = $5f54433b8b296b64$export$2506b012eb637f61;
module.exports["Status"] = $5f54433b8b296b64$export$96e9906d6d93a972;

});

parcelRegister("6ZgEd", function(module, exports) {
/* eslint-disable no-console */ 
var $dh538 = parcelRequire("dh538");


var $c5a0x = parcelRequire("c5a0x");


var $2i8PW = parcelRequire("2i8PW");

const $db6c09c54436b4b9$var$LOG_PREFIX = '[browser-storage-controls]';
class $db6c09c54436b4b9$export$efa9a398d6368992 {
    static info(message, metadata) {
        console.log(`${$db6c09c54436b4b9$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static error(message, metadata) {
        console.error(`${$db6c09c54436b4b9$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            (0, $c5a0x.sendPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata ? JSON.stringify(metadata) : '');
    }
    static warn(message, metadata) {
        console.warn(`${$db6c09c54436b4b9$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    /**
   * Logger for additional debugging of the package. Debug logs are only sent when the
   * atl-bsc-debug-mode cookie is set on the browser. This is evaluated via global state
   */ static debug(message, metadata) {
        if ((0, $2i8PW.getBscGlobalState)().packageDebugMode && (0, $dh538.fg)('platform_moonjelly_bsc_debug_mode')) console.debug(`${$db6c09c54436b4b9$var$LOG_PREFIX}: DEBUG ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
}
module.exports["Logger"] = $db6c09c54436b4b9$export$efa9a398d6368992;

});

parcelRegister("c5a0x", function(module, exports) {

var $a9sR2 = parcelRequire("a9sR2");

var $5DUgU = parcelRequire("5DUgU");


var $2i8PW = parcelRequire("2i8PW");


var $6ZgEd = parcelRequire("6ZgEd");

const $85089a659aa0f6a0$export$9345d7360ffe0722 = "platform-pkg" ?? '';
const $85089a659aa0f6a0$export$91546b032799aa40 = "0.0.0-use.local" ?? '';



var $ccRXO = parcelRequire("ccRXO");




class $be56294e3642020b$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
    constructor(){
        this.cache = void 0;
    }
}


const $2fa9fd5c1c6e215e$export$69a3209f1a06c04d = new (0, $be56294e3642020b$export$b886edaf6623554a)();



var $kfwMJ = parcelRequire("kfwMJ");

const $769f0e6f7d98c46f$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 100,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    usedCheckIfSetByPackageError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $769f0e6f7d98c46f$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $769f0e6f7d98c46f$var$loadSamplingConfig() {
    if ((0, $2fa9fd5c1c6e215e$export$69a3209f1a06c04d).cachedSamplingConfig) return (0, $2fa9fd5c1c6e215e$export$69a3209f1a06c04d).cachedSamplingConfig;
    if ((0, $kfwMJ.isSSR)()) return undefined;
    const { loadCache: loadCache } = (0, $2i8PW.getBscGlobalState)();
    const controlsData = await loadCache((0, $ccRXO.CategoryStorageType).Cookies);
    const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
    (0, $2fa9fd5c1c6e215e$export$69a3209f1a06c04d).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $769f0e6f7d98c46f$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($769f0e6f7d98c46f$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $769f0e6f7d98c46f$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $769f0e6f7d98c46f$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $769f0e6f7d98c46f$export$1138592b3c099377;
    const samplingRatio = samplingConfig?.[analyticsEventKey] !== undefined ? samplingConfig[analyticsEventKey] : $769f0e6f7d98c46f$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $769f0e6f7d98c46f$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
       ________
      /\       \
     /()\   ()  \
    /    \_______\
    \    /()     /
     \()/   ()  /
      \/_____()/
  */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $769f0e6f7d98c46f$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $769f0e6f7d98c46f$export$b286f5e8716d11ad(analyticsEventKey);
    $769f0e6f7d98c46f$export$dc2f0946255b3f89(ratio, cb);
}


const $b83574581275e153$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.') || hostname.includes('.jira-dev.') || hostname.includes('.jira-stg.')) return (0, $5DUgU.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $5DUgU.envType).DEV;
    return (0, $5DUgU.envType).PROD;
};
const $b83574581275e153$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $b83574581275e153$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $b83574581275e153$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $b83574581275e153$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $b83574581275e153$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $b83574581275e153$var$decorateEventAttributes = (attributes)=>{
    const { domain: domain, product: product } = $b83574581275e153$export$fce3dd735e04d566();
    return {
        packageName: $85089a659aa0f6a0$export$9345d7360ffe0722,
        packageVersion: $85089a659aa0f6a0$export$91546b032799aa40,
        domain: domain,
        product: (0, $2i8PW.getBscGlobalState)().product?.toLowerCase() ?? product,
        ...attributes && attributes
    };
};
const $b83574581275e153$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $2i8PW.getBscGlobalState)().analyticsEnabled) instance = new (0, $a9sR2.default)({
                env: $b83574581275e153$var$getEnvironment(),
                product: 'atlassianCookies'
            }, {
                // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                // When set to false, the client will use a stargate proxy for the current URL to send events
                // to GAS. Said another way:
                // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                // false => events are sent to <the current domain>/gasv3/api/v1/batch
                //
                // By default, this should be set to false.  If you need to validate that analytics events
                // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                // won't be able to proxy to GAS via stargate.
                useLegacyUrl: false,
                disableCookiePersistence: true
            });
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            (0, $6ZgEd.Logger).error(`Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $2i8PW.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $b83574581275e153$export$5bfe55348e7aebc1(properties) {
    (0, $769f0e6f7d98c46f$export$67b6e87f323cb6ad)(properties.action, ()=>$b83574581275e153$export$fde53e78fd93a54d()?.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $b83574581275e153$var$decorateEventAttributes(properties.attributes)
        }));
}
function $b83574581275e153$export$1aecf263098db667(properties) {
    $b83574581275e153$export$fde53e78fd93a54d()?.sendUIEvent({
        ...properties,
        attributes: $b83574581275e153$var$decorateEventAttributes(properties.attributes)
    });
}
function $b83574581275e153$export$22a3b1671f38a193(properties) {
    $b83574581275e153$export$fde53e78fd93a54d()?.sendScreenEvent({
        ...properties,
        attributes: $b83574581275e153$var$decorateEventAttributes(properties.attributes)
    });
}
function $b83574581275e153$export$1ba525b8a711eaac(properties) {
    $b83574581275e153$export$fde53e78fd93a54d()?.sendTrackEvent({
        ...properties,
        attributes: $b83574581275e153$var$decorateEventAttributes(properties.attributes)
    });
}
module.exports["getAnalyticsClient"] = $b83574581275e153$export$fde53e78fd93a54d;
module.exports["sendPackageOperationalEvent"] = $b83574581275e153$export$5bfe55348e7aebc1;
module.exports["sendUIEvent"] = $b83574581275e153$export$1aecf263098db667;
module.exports["sendScreenEvent"] = $b83574581275e153$export$22a3b1671f38a193;
module.exports["sendTrackEvent"] = $b83574581275e153$export$1ba525b8a711eaac;

});

parcelRegister("kfwMJ", function(module, exports) {

var $a9sR2 = parcelRequire("a9sR2");


var $dh538 = parcelRequire("dh538");

const $655e54454efd9c73$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $dh538.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $a9sR2.default));
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};
module.exports["isSSR"] = $655e54454efd9c73$export$48d7c418edadb60c;

});

parcelRegister("7MEbC", function(module, exports) {

var $2i8PW = parcelRequire("2i8PW");

var $kfwMJ = parcelRequire("kfwMJ");


var $301rJ = parcelRequire("301rJ");





var $hEbxW = parcelRequire("hEbxW");







const $aeecb3bd7a78465f$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $hEbxW.getCookie)((0, $301rJ.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};



var $iUc7J = parcelRequire("iUc7J");


var $dh538 = parcelRequire("dh538");





var $6RCHl = parcelRequire("6RCHl");


var $6gmJj = parcelRequire("6gmJj");

const $8ca3b9a2789bb5d6$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $6RCHl.fetchConsentPreferences)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $6gmJj.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else if ((0, $dh538.fg)('platform_moonjelly_bsc_fallback_token_audit')) {
            const version = (0, $301rJ.V003_SCHEMA_KEY);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        } else // Temporary: Sets the default token to have true consentedUnderXXXX bits
        // when ConsentHub is inaccessible and there is not fallback token. This
        // will ensure the banner isn't shown when ConsentHub is down.
        consentToken = `${consentToken.slice(0, 8)}1111`;
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};


const $a3f302f220b048aa$export$f1b8f2ca713fca08 = async ()=>{
    const fallbackConsentToken = (0, $hEbxW.getCookie)((0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $8ca3b9a2789bb5d6$export$c515de1cc9cebc71)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $aeecb3bd7a78465f$export$b5282052fc15e1ae)(consentToken);
        const testingConsentOverride = (0, $hEbxW.getCookie)((0, $301rJ.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $iUc7J.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, $iUc7J.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $iUc7J.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};








async function $ae6e4777014e490b$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $2i8PW.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $hEbxW.getCookie)((0, $301rJ.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $6gmJj.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $hEbxW.getCookie)((0, $301rJ.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $a3f302f220b048aa$export$f1b8f2ca713fca08)();
            if ((0, $kfwMJ.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $6gmJj.unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, $6gmJj.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}
module.exports["getPreferences"] = $ae6e4777014e490b$export$1de6a888ae076ff8;

});

parcelRegister("301rJ", function(module, exports) {

var $ccRXO = parcelRequire("ccRXO");

const $40c7c2c8d2a7c49c$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $40c7c2c8d2a7c49c$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $40c7c2c8d2a7c49c$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $40c7c2c8d2a7c49c$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $40c7c2c8d2a7c49c$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $40c7c2c8d2a7c49c$export$37073d560ecebada = 'atl-testing-consents';
const $40c7c2c8d2a7c49c$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $40c7c2c8d2a7c49c$export$b28b5d760fe14a21 = {
    [(0, $ccRXO.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $ccRXO.PreferenceCategory).Functional]: true,
    [(0, $ccRXO.PreferenceCategory).Marketing]: true,
    [(0, $ccRXO.PreferenceCategory).Analytics]: true,
    [(0, $ccRXO.PreferenceCategory).Unknown]: true // Includes uncategorized cookies
};
const $40c7c2c8d2a7c49c$export$4a12f9e99971760a = {
    [(0, $ccRXO.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $ccRXO.PreferenceCategory).Functional]: false,
    [(0, $ccRXO.PreferenceCategory).Marketing]: false,
    [(0, $ccRXO.PreferenceCategory).Analytics]: false,
    [(0, $ccRXO.PreferenceCategory).Unknown]: false
};
const $40c7c2c8d2a7c49c$export$f0fd1d13ec1d48f2 = {
    ...$40c7c2c8d2a7c49c$export$4a12f9e99971760a,
    [(0, $ccRXO.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $ccRXO.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $40c7c2c8d2a7c49c$export$f95182b7aa141c57 = '001';
const $40c7c2c8d2a7c49c$export$1f25427b34f9c405 = '002';
const $40c7c2c8d2a7c49c$export$31deaeaebce525bb = '003';
module.exports["LEGACY_ATLASSIAN_GDPR_COOKIE_KEY"] = $40c7c2c8d2a7c49c$export$10d7db8e1a856fd8;
module.exports["ATLASSIAN_CONSENT_COOKIE_KEY"] = $40c7c2c8d2a7c49c$export$435de28e5b000487;
module.exports["ATLASSIAN_SHOW_BANNER_COOKIE_KEY"] = $40c7c2c8d2a7c49c$export$4b17acc0e875ba2a;
module.exports["ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY"] = $40c7c2c8d2a7c49c$export$23a1e02c3c0b0d08;
module.exports["TESTING_TOKEN_OVERRIDE_COOKIE_KEY"] = $40c7c2c8d2a7c49c$export$37073d560ecebada;
module.exports["ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY"] = $40c7c2c8d2a7c49c$export$5dc0026db06844f3;
module.exports["ACCEPT_ALL_PREFERENCES"] = $40c7c2c8d2a7c49c$export$b28b5d760fe14a21;
module.exports["ONLY_NECESSARY_PREFERENCES"] = $40c7c2c8d2a7c49c$export$4a12f9e99971760a;
module.exports["DEFAULT_PREFERENCES"] = $40c7c2c8d2a7c49c$export$f0fd1d13ec1d48f2;
module.exports["V001_SCHEMA_KEY"] = $40c7c2c8d2a7c49c$export$f95182b7aa141c57;
module.exports["V002_SCHEMA_KEY"] = $40c7c2c8d2a7c49c$export$1f25427b34f9c405;
module.exports["V003_SCHEMA_KEY"] = $40c7c2c8d2a7c49c$export$31deaeaebce525bb;

});

parcelRegister("hEbxW", function(module, exports) {

var $5k5F7 = parcelRequire("5k5F7");


var $dh538 = parcelRequire("dh538");


var $c5a0x = parcelRequire("c5a0x");


var $6ZgEd = parcelRequire("6ZgEd");

function $8e95c28822451851$export$4be65e66cfa2648a(key) {
    if ((0, $dh538.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).get();
    try {
        (0, $c5a0x.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).get();
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}
module.exports["getCookie"] = $8e95c28822451851$export$4be65e66cfa2648a;

});

parcelRegister("iUc7J", function(module, exports) {

var $9P7Na = parcelRequire("9P7Na");

var $6ZgEd = parcelRequire("6ZgEd");


var $301rJ = parcelRequire("301rJ");


var $26elP = parcelRequire("26elP");


var $gqmdp = parcelRequire("gqmdp");

const $37dc478bedf1c7a1$export$8e560d0760f733a2 = (consentToken)=>{
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $gqmdp.setStrictlyNecessaryCookie)((0, $301rJ.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $6ZgEd.Logger).debug(`Set Consent Token ${(0, $301rJ.ATLASSIAN_CONSENT_COOKIE_KEY)} ${consentToken}`);
};
const $37dc478bedf1c7a1$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $gqmdp.setStrictlyNecessaryCookie)((0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $6ZgEd.Logger).debug(`set fallback consent token: ${(0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)} ${consentToken}`);
};
const $37dc478bedf1c7a1$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $26elP.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $9P7Na.getBitValueFromBool)(!!bannerVisibility);
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $gqmdp.setStrictlyNecessaryCookie)((0, $301rJ.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $6ZgEd.Logger).debug(`set shouldShowBannerCookie: ${(0, $301rJ.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)} ${shouldShowBanner}`);
};
const $37dc478bedf1c7a1$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $37dc478bedf1c7a1$export$8e560d0760f733a2(consentToken);
    $37dc478bedf1c7a1$export$99ecece88c58d938(consentToken, consentTimestamps);
};
module.exports["setConsentTokenCookie"] = $37dc478bedf1c7a1$export$8e560d0760f733a2;
module.exports["setConsentTokenFallbackCookie"] = $37dc478bedf1c7a1$export$133cd762b0f705a2;
module.exports["setShouldShowBannerCookie"] = $37dc478bedf1c7a1$export$99ecece88c58d938;
module.exports["setRequiredConsentCookies"] = $37dc478bedf1c7a1$export$b3365240280cb3c3;

});

parcelRegister("26elP", function(module, exports) {

var $5k5F7 = parcelRequire("5k5F7");


var $c6GJD = parcelRequire("c6GJD");


var $kfwMJ = parcelRequire("kfwMJ");


var $9P7Na = parcelRequire("9P7Na");


var $301rJ = parcelRequire("301rJ");


var $hvqgK = parcelRequire("hvqgK");


var $hEbxW = parcelRequire("hEbxW");


var $6gmJj = parcelRequire("6gmJj");

const $0e690d47726d7678$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $6gmJj.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $0e690d47726d7678$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $0e690d47726d7678$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $9P7Na.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $hvqgK.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $0e690d47726d7678$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $hvqgK.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $0e690d47726d7678$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $hvqgK.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $0e690d47726d7678$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $0e690d47726d7678$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $9P7Na.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $hvqgK.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
        They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
        then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)

        UX Problem:
        Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
        But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
        is infrequent (either via Account Privacy Page or once this fallback expires in a year).

        Example:
        While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
        fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
        because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...

        We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
        to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
        persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.

        Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
        consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year

        Result: Show the banner again and hope we officially recapture consents this time around
      */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $0e690d47726d7678$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $hvqgK.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $0e690d47726d7678$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $hvqgK.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $0e690d47726d7678$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents })=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    // Detect if js-cookie has been replaced with SSR-safe version (Confluence only)
    const isJsCookieSSRSafe = typeof (0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).__SSR_INITIALIZE_COOKIES__ === 'function' && (0, $c6GJD.default).getExperimentValue('confluence_ssr_use_fallback_token', 'isEnabled', false);
    const fallbackConsentToken = (0, $kfwMJ.isSSR)() ? fallbackConsents || (isJsCookieSSRSafe ? (0, $hEbxW.getCookie)((0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)) : undefined) : fallbackConsents || (0, $hEbxW.getCookie)((0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = $0e690d47726d7678$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $9P7Na.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $0e690d47726d7678$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $0e690d47726d7678$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};
module.exports["getBannerVisibility"] = $0e690d47726d7678$export$bfdb9f82a9194c1e;

});

parcelRegister("hvqgK", function(module, exports) {

var $9P7Na = parcelRequire("9P7Na");


var $301rJ = parcelRequire("301rJ");


var $hEbxW = parcelRequire("hEbxW");


var $ccRXO = parcelRequire("ccRXO");

var $6512ea116fbd6587$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});


const $2616b1a95751a75f$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $301rJ.V002_SCHEMA_KEY);
    return isV2Schema;
};
const $2616b1a95751a75f$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $301rJ.V001_SCHEMA_KEY);
    return isV1Schema;
};
const $2616b1a95751a75f$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($2616b1a95751a75f$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $2616b1a95751a75f$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $2616b1a95751a75f$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $2616b1a95751a75f$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $2616b1a95751a75f$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $9P7Na.getBoolFromBitValue)(consentToken[7]);
    return isDefaultTokenV3;
};
const $2616b1a95751a75f$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $301rJ.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $301rJ.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $ccRXO.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $ccRXO.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $9P7Na.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $9P7Na.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $9P7Na.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $2616b1a95751a75f$export$42a0b3fb1e53e7b9 = (consents)=>{
    const version = (0, $301rJ.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $9P7Na.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $6512ea116fbd6587$export$31140359b1e505cf).Functional)?.granted);
    const analyticsConsent = (0, $9P7Na.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $6512ea116fbd6587$export$31140359b1e505cf).Analytics)?.granted);
    const marketingConsent = (0, $9P7Na.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $6512ea116fbd6587$export$31140359b1e505cf).Marketing)?.granted);
    const unknownConsent = (0, $9P7Na.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $6512ea116fbd6587$export$31140359b1e505cf).Unknown)?.granted);
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $2616b1a95751a75f$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $hEbxW.getCookie)((0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $2616b1a95751a75f$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $2616b1a95751a75f$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $2616b1a95751a75f$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $2616b1a95751a75f$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $ccRXO.PreferenceCategory).StrictlyNecessary,
        (0, $ccRXO.PreferenceCategory).Functional,
        (0, $ccRXO.PreferenceCategory).Analytics,
        (0, $ccRXO.PreferenceCategory).Marketing,
        (0, $ccRXO.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $ccRXO.PreferenceCategory).StrictlyNecessary]: (0, $6512ea116fbd6587$export$31140359b1e505cf).StrictlyNecessary,
        [(0, $ccRXO.PreferenceCategory).Functional]: (0, $6512ea116fbd6587$export$31140359b1e505cf).Functional,
        [(0, $ccRXO.PreferenceCategory).Analytics]: (0, $6512ea116fbd6587$export$31140359b1e505cf).Analytics,
        [(0, $ccRXO.PreferenceCategory).Marketing]: (0, $6512ea116fbd6587$export$31140359b1e505cf).Marketing,
        [(0, $ccRXO.PreferenceCategory).Unknown]: (0, $6512ea116fbd6587$export$31140359b1e505cf).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $2616b1a95751a75f$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $2616b1a95751a75f$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
class $2616b1a95751a75f$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = void 0;
        this.status = status;
        Object.setPrototypeOf(this, $2616b1a95751a75f$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $2616b1a95751a75f$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}
module.exports["hasLegacyV2TokenConsentedPreviously"] = $2616b1a95751a75f$export$42b0ca8aba2631e4;
module.exports["checkIfTokenIsDefault"] = $2616b1a95751a75f$export$497a647f0eb30ef4;
module.exports["serializeConsents"] = $2616b1a95751a75f$export$92ba0b2fe50f90df;
module.exports["deserializeConsents"] = $2616b1a95751a75f$export$bfa0c91662787fb0;
module.exports["getConsentTimestamp"] = $2616b1a95751a75f$export$13e4cff933f26b03;
module.exports["checkIfConsentsAreStale"] = $2616b1a95751a75f$export$3387347b75450ae1;
module.exports["StatusCodeError"] = $2616b1a95751a75f$export$a79c0ea3d7c2444a;

});

parcelRegister("6gmJj", function(module, exports) {

var $2i8PW = parcelRequire("2i8PW");


var $9P7Na = parcelRequire("9P7Na");


var $301rJ = parcelRequire("301rJ");


var $hvqgK = parcelRequire("hvqgK");


var $ccRXO = parcelRequire("ccRXO");

const $5eb06e64c98e776e$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $301rJ.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $301rJ.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, $301rJ.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $301rJ.V001_SCHEMA_KEY),
        (0, $301rJ.V002_SCHEMA_KEY),
        (0, $301rJ.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $5eb06e64c98e776e$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $301rJ.V001_SCHEMA_KEY);
    return [
        version,
        (0, $9P7Na.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $9P7Na.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $9P7Na.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $9P7Na.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $5eb06e64c98e776e$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $ccRXO.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $ccRXO.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $ccRXO.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $ccRXO.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $ccRXO.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $5eb06e64c98e776e$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $301rJ.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, $ccRXO.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $ccRXO.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $ccRXO.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $ccRXO.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.PreferenceCategory).Functional]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.PreferenceCategory).Analytics]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.PreferenceCategory).Marketing]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.PreferenceCategory).Unknown]),
        (0, $9P7Na.getBitValueFromBool)(isDefaultConsentBit),
        (0, $9P7Na.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $9P7Na.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const $5eb06e64c98e776e$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $hvqgK.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$5eb06e64c98e776e$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $ccRXO.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $ccRXO.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $5eb06e64c98e776e$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $301rJ.V003_SCHEMA_KEY);
    return [
        version,
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.PreferenceCategory).Functional]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.PreferenceCategory).Analytics]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.PreferenceCategory).Marketing]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.PreferenceCategory).Unknown]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $9P7Na.getBitValueFromBool)(userPreferences[(0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const $5eb06e64c98e776e$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $ccRXO.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $ccRXO.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $ccRXO.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $ccRXO.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $ccRXO.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $ccRXO.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $ccRXO.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $5eb06e64c98e776e$var$V002SpecificBitKeys = [
    (0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $ccRXO.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $ccRXO.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $ccRXO.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $ccRXO.ConsentPreferenceV2).ConsentedUnderFADP
];
const $5eb06e64c98e776e$var$V003SpecificBitKeys = [
    (0, $ccRXO.ContextualConsentProperty).ConsentsAreDefault,
    (0, $ccRXO.ContextualConsentProperty).UserIsAuthenticated,
    (0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable
];
function $5eb06e64c98e776e$export$3199823fec979bd1(userPreferences) {
    if ((0, $2i8PW.getBscGlobalState)().localConsentMode) return $5eb06e64c98e776e$var$packPrefsVersion001(userPreferences);
    const isV002 = $5eb06e64c98e776e$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $5eb06e64c98e776e$var$packPrefsVersion002(userPreferences);
    const isV003 = $5eb06e64c98e776e$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $5eb06e64c98e776e$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $5eb06e64c98e776e$var$packPrefsVersion001(userPreferences);
}
function $5eb06e64c98e776e$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $2i8PW.getBscGlobalState)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $301rJ.V001_SCHEMA_KEY)) return $5eb06e64c98e776e$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $5eb06e64c98e776e$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $5eb06e64c98e776e$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $5eb06e64c98e776e$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $5eb06e64c98e776e$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $5eb06e64c98e776e$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $5eb06e64c98e776e$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $ccRXO.PrefetchedPreferenceState).INTERNAL) {
        if ($5eb06e64c98e776e$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $5eb06e64c98e776e$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $hvqgK.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = $5eb06e64c98e776e$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $ccRXO.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};
module.exports["checkTokenVersionValidity"] = $5eb06e64c98e776e$export$64b31470e8522819;
module.exports["packUserPreferences"] = $5eb06e64c98e776e$export$3199823fec979bd1;
module.exports["unpackUserPreferencesCookie"] = $5eb06e64c98e776e$export$8d213cb390bab4fa;
module.exports["initialPreferencesAreMissing"] = $5eb06e64c98e776e$export$67f70eb55341bd29;
module.exports["initializePreferencesData"] = $5eb06e64c98e776e$export$7962405c3ca274b1;

});

parcelRegister("gqmdp", function(module, exports) {

var $5k5F7 = parcelRequire("5k5F7");


var $dh538 = parcelRequire("dh538");


var $c5a0x = parcelRequire("c5a0x");


var $6ZgEd = parcelRequire("6ZgEd");

const $716b9b66ec43bd8d$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $dh538.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        (0, $c5a0x.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};
module.exports["setStrictlyNecessaryCookie"] = $716b9b66ec43bd8d$export$93509ff9a62ee022;

});

parcelRegister("6RCHl", function(module, exports) {

var $6ZgEd = parcelRequire("6ZgEd");


var $hvqgK = parcelRequire("hvqgK");

const $78d0e78883127ca6$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $78d0e78883127ca6$var$POST_CONSENTS_URL = `${$78d0e78883127ca6$var$BASE_CONSENTS_URL}/user`;
const $78d0e78883127ca6$var$GET_CONSENTS_URL = `${$78d0e78883127ca6$var$POST_CONSENTS_URL}/consents/cookies`;
const $78d0e78883127ca6$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $hvqgK.serializeConsents)(consentData);
        const consentTimestamp = (0, $hvqgK.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $hvqgK.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const $78d0e78883127ca6$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$78d0e78883127ca6$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $78d0e78883127ca6$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $78d0e78883127ca6$export$bd9f5bcbf9cd947c();
    }
};
const $78d0e78883127ca6$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $hvqgK.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $78d0e78883127ca6$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$78d0e78883127ca6$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: $78d0e78883127ca6$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $hvqgK.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};
module.exports["buildConsentPreferences"] = $78d0e78883127ca6$export$bd9f5bcbf9cd947c;
module.exports["fetchConsentPreferences"] = $78d0e78883127ca6$export$86467566615ab85e;
module.exports["saveConsentPreferences"] = $78d0e78883127ca6$export$f8422650c3dec8b2;

});

parcelRegister("1UApO", function(module, exports) {
const $490666dac3ea5b14$export$ed97f33186d4b816 = {
    DISCOVER_ROUTE: 'discover.route.last',
    GLOBAL_SIDEBAR_PANEL: 'sidebar.global.panel',
    EDITOR_SURVEY_LAST_SUBMITTED: 'editor.survey.last.submitted',
    SUPERADMIN_SURVEY_REQUESTED: 'superadmin.survey.requested',
    SUPERADMIN_SURVEY_SUBMITTED: 'superadmin.survey.submitted',
    SUPERADMIN_SESSION_EXPIRED: 'superadmin.session.expired',
    RESTRICTED_PAGE_CONFIRMED: 'restricted.page.confirmed',
    HOME_ONBOARDING: 'home.onboarding',
    PAGE_JUST_CONVERTED: 'migration.page.just.converted',
    NAVIGATION_CLASSIC_OPT_OUT: 'navigation.classic.opt.out',
    NAVIGATION_HOME_OPT_OUT: 'navigation.home.opt.out',
    NAVIGATION_DEFAULT_OPTED_OUT: 'navigation.default.opted.out',
    NAVIGATION_OPT_IN_SEEN_SPOTLIGHT: 'navigation.opt.in.seen.spotlight',
    NAVIGATION_CLICKED_LOUD_OPT_IN_OR_VIEWED_FLAG: 'navigation.clicked.loud.opt.in.or.viewed.flag',
    NOTIFICATION_SPOTLIGHT_VIEWED: 'notification.spotlight.viewed',
    HOME_SECTION_COLLAPSED: 'home.section.collapsed',
    RECENTLY_WATCHED_SPACE: 'recentlyWatchedSpace',
    GROWTH_EXPERIMENT_REQUEST_UPGRADE_SENT: 'growth.experiment.request.upgrade.sent',
    GROWTH_EXPERIMENT_UPGRADE_DISMISSED_COUNT: 'growth.experiment.engagedUpgrade.dismissed.count',
    GROWTH_EXPERIMENT_UPGRADE_LAST_DISMISSED_DATE: 'growth.experiment.engagedUpgrade.last.dismissed.date',
    LOCAL_STORAGE_DISPLAYS_NEXT_AT_KEY: 'growth.experiment.engagedBilling.displays.next.at',
    LOCAL_STORAGE_HAS_BILLING_DETAILS: 'growth.experiment.engagedBilling.has.billing.details',
    LOCAL_STORAGE_BILLING_API_NEXT_CALLED_AT_KEY: 'growth.experiment.engagedBilling.billing.api.next.called.at',
    LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION: 'ce.content.view.best.element.scroll.position',
    CONFLUENCE_SLACK_APP_IS_ENABLED: 'growth.experiment.confluence.slack-is-enabled',
    INVITE_ON_LINK_INSERT_DISMISSAL_COUNT: 'growth.experiment.confluence.invite-on-link-insert-dismissal-count',
    INVITE_ON_LINK_INSERT_OPT_OUT: 'growth.experiment.confluence.invite-on-link-insert-opt-out',
    CROSS_JOIN_NUDGES_V3_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-v3-visited',
    CROSS_JOIN_NUDGES_JPD_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-jpd-visited',
    CROSS_JOIN_NUDGES_MSR_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-msr-visited',
    CROSS_JOIN_NUDGES_MSR_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-msr-opt-out',
    CROSS_JOIN_NUDGES_MSR_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-msr-visited-count',
    CROSS_JOIN_NUDGES_V3_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-v3-visited-count',
    CROSS_JOIN_NUDGES_JPD_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-jpd-visited-count',
    CROSS_JOIN_NUDGES_V3_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-v3-opt-out',
    CROSS_JOIN_NUDGES_JPD_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-jpd-opt-out',
    CROSS_JOIN_NUDGES_ELIGIBILITY_KEY: 'growth.experiment.confluence.cross-join-nudges-eligibility',
    CROSS_JOIN_NUDGES_EVENT_CACHE_KEY: 'growth.experiment.confluence.cross-join-nudges-event-cache',
    CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY: 'growth.experiment.confluence.cross-join-nudges-loom-event-cache',
    CROSS_JOIN_THIRD_PARTY_NUDGES_VISITED_KEY: 'growth.experiment.confluence.cross-join-third-party-nudges-v2-visited',
    CROSS_JOIN_THIRD_PARTY_NUDGES_VISITED_COUNT: 'growth.experiment.confluence.cross-join-third-party-nudges-v2-visited-count',
    CROSS_JOIN_NUDGES_LOOM_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-loom-visited',
    CROSS_JOIN_NUDGES_LOOM_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-loom-visited-count',
    CROSS_JOIN_NUDGES_LOOM_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-loom-opt-out',
    /**
   * The width of the right panel on Home
   */ HOME_SIDEBAR_WIDTH: 'home.sidebar.width',
    /**
   * Used to store starred/favorited feature flags for the dev tools panel
   */ STARRED_FEATURE_FLAGS: 'confluence-frontend-next.starredFeatureFlags',
    /**
   * Indicates that "Copy space permissions" (implemented by
   * @confluence/copy-space-permissions) has completed i.e. space permissions
   * have been copied.
   */ COPIED_SPACE_PERMISSIONS: 'copied.space.permissions',
    PERSIST_SCROLL_POSITION_IN_VIEW_PAGE: 'editor-persit-scroll-position',
    ID_START_CONTENT_IN_VIEW_PAGE: 'main-content',
    FABRIC_PAGE_OPTIN_MIGRATION_BANNER: 'fabric.page.optin.migration.banner.discovery.feature',
    FABRIC_TEMPLATE_MIGRATION_SUCCESS_FLAG: 'fabric-template-migration.success.flag',
    FABRIC_TEMPLATE_MIGRATION_ERROR_FLAG: 'fabric-template-migration.error.flag',
    BYLINE_APPS_SHOW_ALL: 'byline.apps.show-all',
    SPACENAV_APPS_SHOW_ALL: 'spacenav.apps.show-all',
    HIDE_BULK_CONFIRMATION_DIALOG_LOCAL_STORAGE_KEY: 'archive-pages.bulk-archive.confirmation-dialog.opt-out',
    ONBOARDING_STEP_INDEX: 'onboarding.account.setup.step.index',
    ONBOARDING_STEP_HAS_TEAM_NAME: 'onboarding.account.setup.step.hasTeamName',
    ONBOARDING_FORM_VALUES: 'onboarding.account.setup.form.values',
    RIGHT_SIDEBAR: 'right.sidebar',
    CONNECT_APP_ANALYTICS: 'ecosystem.confluence.connect.analytics',
    /**
   * Auto Convert TinyMCE pages
   */ EDITOR_REVERTED: 'autoconverted.pages.reverted',
    BLOGPOST_PERMISSIONS_NOTICE: 'blogpost.permissions.notice.error',
    QUERY_OVERRIDES: 'query.overrides',
    CANVAS_SERVER: 'canvas-server',
    CANVAS_RELAY: 'canvas-relay',
    CANVAS_FRONTEND_VERSION: 'canvas-frontend-version',
    // Below are cc-automation keys for in-context discoverability messages
    AUTOMATION_DISCOVER_ARCHIVE_FROM_OVERFLOW_MENU: 'automation.discover.archive-from-overflow-menu',
    AUTOMATION_DISCOVER_ARCHIVE_FROM_HOVER_OVER_PAGE_TITLE: 'automation.discover.archive-from-hover-over-page-title',
    AUTOMATION_DISCOVER_BULK_ARCHIVE: 'automation.discover.bulk-archive',
    AUTOMATION_DISCOVER_BULK_CHANGE_PAGE_OWNER: 'automation.discover.bulk-change-page-owner',
    AUTOMATION_DISCOVER_ADD_LABEL_TO_PAGE: 'automation.discover.add-label-to-page',
    AUTOMATION_DISCOVER_MEETING_NOTES_TEMPLATE: 'automation.discover.meeting-notes-template',
    AUTOMATION_DISCOVER_JIRA_LINK: 'automation.discover.jira-link',
    AUTOMATION_DISCOVER_MANUAL_TRIGGER: 'automation.discover.manual.trigger',
    AUTOMATION_DISCOVER_MANUAL_RULE_COUNT: 'automation.discover.manual.rule.count',
    AUTOMTION_DISCOVER_MANUAL_RULE_SMART_BUTTON: 'automation.discover.manual.rule.smart.button',
    AUTOMATION_DISCOVER_PAGE_PUBLIC_LINK: 'automation.discover.page-public-link',
    AUTOMATION_DISCOVER_GLOBAL_PUBLIC_LINK: 'automation.discover.global-public-link',
    AUTOMATION_DISCOVER_SPACE_ASSIGNED_BULK: 'automation.discover.space-assigned-bulk',
    AUTOMATION_DISCOVER_SPACE_ASSIGNED_INDIVIDUAL: 'automation.discover.space-assigned-individual',
    AUTOMATION_DISCOVER_GLOBAL_DEFAULT_SPACE: 'automation.discover.global-default-space',
    AUTOMATION_DISCOVER_VERIFIED_CONTENT: 'automation.discover.verified.content',
    AUTOMATION_DISCOVER_WHITE_BOARDS: 'automation.discover.publish.white.boards',
    AUTOMATION_DISCOVER_SHARE_SLACK: 'automation.discover.share.slack',
    AUTOMATION_DISCOVER_SET_CONTENT_STATE: 'automation.discover.set-content-state',
    AUTOMATION_DISCOVER_PRODUCT_REQUIREMENTS: 'automation.discover.product-requirements',
    AUTOMATION_DISCOVER_FEEDBACK_ANALYSIS: 'automation.discover.feedback-analysis',
    AUTOMATION_DISCOVER_RELEASE_NOTES: 'automation.discover.release-notes',
    AUTOMATION_ONBOARDING: 'automation.onboarding',
    AUTOMATION_EXECUTION_LIMIT: 'automation.execution.limit',
    SPACE_SETTINGS_NAV_SECTIONS_EXPANDED_STATES: 'space-settings-nav.sections.expand-states',
    SITE_SETTINGS_NAV_SECTIONS_EXPANDED_STATES: 'site-settings-nav.sections.expand-states',
    /**
   * Comment Drafts
   */ COMMENT_DRAFTS_PAGE_CREATE: 'comments.drafts.page.create',
    COMMENT_DRAFTS_PAGE_EDIT: 'comments.drafts.page.edit',
    COMMENT_DRAFTS_PAGE_REPLY: 'comments.drafts.page.reply',
    COMMENT_DRAFTS_INLINE_CREATE: 'comments.drafts.inline.comments.create',
    COMMENT_DRAFTS_INLINE_EDIT: 'comments.drafts.inline.comments.edit',
    COMMENT_DRAFTS_INLINE_REPLY: 'comments.drafts.inline.reply',
    COMMENT_DRAFTS_EDITOR_INLINE_CREATE: 'comments.drafts.editor.inline.create',
    COMMENT_DRAFTS_EDITOR_INLINE_EDIT: 'comments.drafts.editor.inline.edit',
    COMMENT_DRAFTS_EDITOR_INLINE_REPLY: 'comments.drafts.editor.inline.reply',
    LOOM_BETA_ENABLED: 'loom.beta.enabled',
    BROWSER_BANNER_CLOSED_BY_USER: 'devloop.browser-support-warning.closed',
    /**
   * Home Feeds
   */ HOME_FOLLOWING_FEED_SESSION_ID: 'home.follow-feed.sessionId',
    HOME_POPULAR_FEED_SESSION_ID: 'home.popular-feed.sessionId',
    HOME_FOLLOWING_FEED_SORTING: 'home.follow-feed.sorting',
    HOME_POPULAR_FEED_TIME_GRANULARITY: 'home.popular-feed.time-granularity',
    /**
   * Live Pages
   */ LIVE_PAGES_IN_PRODUCT_PROMPT_MODAL_LAST_DISMISSED: 'live-pages.in-product-prompt.modal.last-dismissed',
    LIVE_PAGES_IN_PRODUCT_PROMPT_BANNER_SPACE_SETTINGS_LAST_DISMISSED: 'live-pages.in-product-prompt.banner.space-settings.last-dismissed',
    LIVE_PAGES_IN_PRODUCT_PROMPT_BANNER_MISSION_CONTROL_LAST_DISMISSED: 'live-pages.in-product-prompt.banner.mission-control.last-dismissed',
    LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN: 'live-pages.mode-switcher.flag.shown',
    LIVE_PAGES_OPEN_BETA_PROMPT_MODAL_FIRST_SEEN: 'live-pages.open-beta-prompt-modal.first-seen',
    LIVE_PAGES_OPEN_BETA_PROMPT_GLOBAL_BANNER_FIRST_DISMISSED: 'live-pages.open-beta-prompt-global-banner.first-dismissed',
    LIVE_DOCS_HAS_INIT_MODERNIZE: 'live-docs.has-init-modernize',
    LIVE_DOCS_HAS_INIT_MODERNIZE_POST_EXP: 'live-docs.has-init-modernize-post-exp',
    LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER: 'live-docs.new-lozenge-shown-tracker',
    /**
   * AI First Creation
   */ HAS_INIT_AIFC_EXP: 'ai-first-creation.has-init-aifc-exp',
    CREATE_WITH_ROVO_MODAL_CLOSE_FEEDBACK_FLAG_LAST_SHOWN: 'create-with-rovo-modal-close-feedback-flag.last-shown',
    CREATE_WITH_ROVO_UPDATE_COMPLETE_FEEDBACK_FLAG_LAST_SHOWN: 'create-with-rovo-update-complete-feedback-flag.last-shown',
    /**
   * Confluence Notes
   */ NOTES_FLOATING_POSITION: 'confluence-notes.floating-position',
    UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL: 'universal-shortcuts.deprecated-shortcut-flag.hide-until',
    // Bold new pages experiment
    UNREAD_PAGES_VISITED: 'bold-new-pages.experiment.unread-pages.visited',
    // Mention Reminders experiment
    MENTION_REMINDERS_SENT: 'mention-reminders.experiment.sent',
    // Nav 4 Site/Space settings back button URL
    NAV4_SETTINGS_BACK_BUTTON_URL: 'navigation.settings.back-button.url',
    // Nav 4 opt out cache
    NAV4_OPT_OUT_CACHE: 'navigation.opt-out',
    // Nav 4 admin opt in cache
    NAV4_ADMIN_OPT_IN_CACHE: 'navigation.admin.opt-in',
    // Nav 4 misaligned nav versions flag
    NAV4_MISALIGNED_NAV_VERSIONS_FLAG: 'navigation.misaligned.nav.versions.flag',
    // EOT Banner experiment
    EOT_BANNER_DISMISS_UNTIL: 'eot-banner.dismiss-until',
    // Issue Create
    ISSUE_CREATE_WITH_AI: 'issue-create.with-ai',
    // AI Unsplash Header Experiment
    AI_UNSPLASH_HEADER_ACCEPTED: 'ai-unsplash.header.accepted',
    //Notify User On 1st View expeirment
    NOTIFY_USERS_ON_FIRST_VIEW_MUTATION_FIRED: 'notify-users-on-first-view.mutation.fired',
    NAVDEX_STORAGE_KEY: 'navigationSession',
    // Super Admin Timeout
    SUPER_ADMIN_TIMEOUT: 'confluence.super.admin.timeout',
    // Premium Onboarding
    PTO_PHASE_TWO_SPOTLIGHT_TARGET: 'pto-phase-two-spotlight',
    // Have I Seen It prefix
    HAVE_I_SEEN_IT_PREFIX: 'cf_hisi_',
    // Migrations
    IMPORT_CONTENT_TIMESTAMP: 'importContentTimestamp',
    // Page Experience
    AE_TABLE_COPIED: 'copied',
    AE_TABLE_COPIED_COLS: 'copiedCols',
    LAST_TAB_SUFFIX: 'last-tab',
    // AI Audio Playback Speed
    AI_AUDIO_PLAYBACK_SPEED: 'ai.audio.playback-speed',
    AI_AUDIO_BRIEFING_CUSTOMIZATION: 'ai.audio.briefing.customization',
    // EditorTeamCreatedFlag
    RETROSPECTIVE_BLUEPRINT_TEAM_CREATED: 'retrospective-blueprint.team.created',
    RETROSPECTIVE_BLUEPRINT_TEAM_USED: 'retrospective-blueprint.team.used',
    // Confluence Custom Origins
    CONFLUENCE_CUSTOM_ORIGINS: 'confluenceCustomOrigins',
    // Dev and Testing
    HIDE_FEATURE_FLAG_ICON: 'confluence-frontend-next.hideFeatureFlagIcon',
    FE_FIXTURE_PARAMS: '__confluence-frontend-fixture-params',
    TEST_FAILURES_LINK_MODE: 'testFailuresLink.mode',
    TEST_FAILURES_LINK_OPERATIONS_PREFIX: 'testFailuresLink.operations.',
    // Disable Engagement for tests
    DISABLE_ENGAGEMENT_FOR_TESTS: 'confluence.disable-engagement-for-tests',
    // Jira Crossflow Experiment
    JIRA_ACCESS_REQUESTED: 'jira_access_requested',
    JIRA_TRIAL_REQUESTED: 'jira_trial_requested',
    // Feature Discovery Override
    FEATURE_DISCOVERY_OVERRIDE_PREFIX: 'featureDiscoveryOverride-',
    // Chrome Extension
    CONFLUENCE_SSR_OUTLINE_PRIORITY: 'confluence.ssr-outline-priority',
    CONFLUENCE_SSR_OUTLINE_ENABLED: 'confluence.ssr-outline-enabled',
    CONFLUENCE_LOADABLE_STEP_OVER_ENABLED: 'confluence.loadable-step-over-enabled'
};
const $490666dac3ea5b14$export$84dce893719feb44 = {
    //keys stored on backend start with persisted
    PERSISTED_LEFT_SIDEBAR_WIDTH: 'persisted.left.sidebar.width',
    PERSISTED_LEFT_SIDEBAR_COLLAPSED: 'persisted.left.sidebar.collapsed',
    PERSISTED_GROWTH_PERSISTENT_UPGRADE_PRETRIAL_BANNER: 'persisted.growth.persistent.upgrade.preTrial.banner',
    PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES: 'persisted.space-nav.sections.expand-states',
    // The next time to show the External Collaboration Guest Satisfaction Survey to this guest user
    PERSISTED_GUEST_SURVEY_NEXT_TIME_TO_SHOW: 'persisted.guest.survey.next.time.to.show',
    // Overrided feature flags. These are persisted to the server so they can be
    // used when rendering in SSR
    PERSISTED_OVERRIDE_FEATURE_FLAGS: 'persisted.enterprise-experience.override.feature.flags',
    PERSISTED_OVERRIDES_STATSIG: 'persisted.enterprise-experience.override.statsig',
    PERSISTED_ADMIN_ANNOUNCEMENT_BANNER: 'persisted.admin.announcement.banner',
    PERSISTED_ADMIN_ANNOUNCEMENT_BANNER_MIGRATOR_PROMPT: 'persisted.admin.announcement.banner.migrator.prompt',
    PERSISTED_STORAGE_ENFORCEMENT_BANNER: 'persisted.storage.enforcement.banner',
    // Public Links Modals
    PERSISTED_RESTRICTIONS_DIALOG_PUBLIC_LINKS_MODAL: 'persisted.restrictions.dialog.public.links.modal',
    PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_ON_MODAL: 'persisted.share.dialog.public.links.toggle.on.modal',
    PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_ON_MODAL_SMART_SECTIONS: 'persisted.share.dialog.public.links.toggle.on.modal.smart.sections',
    PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_OFF_MODAL: 'persisted.share.dialog.public.links.toggle.off.modal',
    // Public Links Edit Whiteboard Banner
    PERSISTED_PUBLIC_LINKS_EDIT_WHITEBOARD_BANNER: 'persisted.public.links.edit.whiteboard.banner',
    // Theming
    PERSISTED_USER_THEME_PREFERENCE: 'persisted.ecosystem.user.theme.preference',
    // Premium feature highlight
    PERSISTED_PREMIUM_FEATURE_HIGHLIGHT: 'persisted.premium.feature.highlight',
    // Reading Aids
    PERSISTED_READING_AIDS_AUTO_HIGHLIGHT: 'persisted.reading.aids.auto.highlight',
    // Bold new pages experiment
    PERSISTED_BOLD_NEW_PAGES_SATISFACTION_SURVEY_HAS_SEEN: 'persisted.bold-new-pages.experiment.satisfaction-survey.has-seen',
    // Previously trialed premium users experiment
    PERSISTED_PREVIOUSLY_TRIALED_PREMIUM_USERS_DISMISSED: 'persisted.previously.trialed.premium.users.banner.dismissed',
    // Quick Summary Experiment
    PERSISTED_QUICK_SUMMARY_REQUEST_SENT: 'persisted.growth.quick-summary-request-sent',
    // AIFC Banner Persistence
    PERSISTED_SMART_CREATE_FEEDBACK_BANNER_LAST_DISMISSED: 'persisted.smart-create.feedback-banner.last-dismissed',
    // Editor Controls
    PERSISTED_EDITOR_CONTROLS_ONBOARDING_BANNER_NEW_PINNING_DISMISSED: 'persisted.editor-controls.onboarding-banner-new-pinning.dismissed',
    //Bite Sized Generic Premium Messages
    PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_GENERIC_CADENCE: 'persisted.bite-sized.premium-messages.generic.cadence',
    //Bite Sized Automation Premium Messages
    PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_AUTOMATION_CADENCE: 'persisted.bite-sized.premium-messages.automation.cadence',
    //Role Based Access Control
    PERSISTED_RBAC_TRACKING: 'persisted.rbac.tracking',
    // Loom cross_flow ad-control not interested preference
    PERSISTED_LOOM_CROSS_FLOW_AD_CONTROL_NOT_INTERESTED: 'persisted.loom-cross-flow.ad-control.not-interested',
    // Status of exposure to a series of spotlight pulse outlines
    // highlighting Loom entrypoints to cross-sell-eligible customers
    PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED: 'persisted.loom-cross-sell.discoverability-pulses.have-ended',
    // Jira Cloud ID preference for site picker on Jira Issue Create
    PERSISTED_JIRA_CLOUD_ID_PREFERENCE: 'persisted.jira-cloud-id.preference',
    // Selected site, project and issue type from the configure view on bulk AI Jira Issue Create
    PERSISTED_BULK_CREATE_JIRA_CONFIG_FOR_USER: 'persisted.bulk-create.jira.config.for.user',
    // Selected site, project and issue type from the single work create form
    PERSISTED_SINGLE_CREATE_JIRA_CONFIG_FOR_USER: 'persisted.single-create.jira.config.for.user',
    PERSISTED_SHOULD_USE_GIC_EMBED: 'persisted.should-use-gic-embed',
    // Importers
    PERSISTED_IMPORT_FEEDBACK_DISABLED: 'persisted.imports.import-feedback-disabled',
    PERSISTED_RT_PAID_FEATURE_EDUCATION_SPOTLIGHT_SEEN: 'persisted.rt-paid-feature-education.spotlight.seen'
};
module.exports["keys"] = $490666dac3ea5b14$export$ed97f33186d4b816;
module.exports["PERSISTED_KEYS_ON_SERVER"] = $490666dac3ea5b14$export$84dce893719feb44;

});

parcelRegister("i6sMX", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $9WAeG = parcelRequire("9WAeG");


var $9wGTI = parcelRequire("9wGTI");


var $d6NtA = parcelRequire("d6NtA");

const $045f09a1878b32fd$export$72dc662ac05b1fbb = `
  query LocalStorageQuery($stringKeys: [String]!) {
    localStorage {
      stringValues(keys: $stringKeys) {
        key
        value
      }
    }
  }
`;



var $573Av = parcelRequire("573Av");

async function $3dc381592a319f3c$export$efc60d6604f5fc7a({ userId: userId, isLicensed: isLicensed }) {
    if (window['__REMOTE_LOCAL_STORAGE__']) return window['__REMOTE_LOCAL_STORAGE__'];
    const URI = (0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint') ? '/gateway/api/graphql/slow' : window['GLOBAL_APOLLO_CLIENT_URI'] || '/cgraphql';
    return window['__REMOTE_LOCAL_STORAGE__'] = (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:LocalStorageQuery', async ()=>{
        let result = null;
        try {
            if (isLicensed && userId) {
                const variables = {
                    stringKeys: (0, $573Av.getKeysForLocalStorageQuery)(userId)
                };
                const res = await (0, $f7B1p.cfetch)(`${URI}?q=LocalStorageQuery`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'X-APOLLO-OPERATION-NAME': 'LocalStorageQuery',
                        'Content-Type': 'application/json',
                        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                        ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                            'x-ssr-asap-audience': 'cc-graphql'
                        } : {}
                    },
                    body: JSON.stringify({
                        operationName: 'LocalStorageQuery',
                        query: (0, $045f09a1878b32fd$export$72dc662ac05b1fbb),
                        variables: variables
                    })
                });
                if (res.ok) {
                    const { data: data } = await res.json();
                    result = data?.localStorage?.stringValues;
                }
            }
        } catch (e) {}
        return window['__REMOTE_LOCAL_STORAGE__'] = result;
    });
}
module.exports["getRemoteLocalStorage"] = $3dc381592a319f3c$export$efc60d6604f5fc7a;

});

parcelRegister("d6NtA", function(module, exports) {
var $54fed5011c3efebd$export$c32b36f46293e67b = /*#__PURE__*/ function(MicrosEnvironmentType) {
    MicrosEnvironmentType["local"] = "local";
    MicrosEnvironmentType["dev"] = "dev";
    MicrosEnvironmentType["staging"] = "staging";
    MicrosEnvironmentType["prod"] = "prod";
    return MicrosEnvironmentType;
}({});
const $54fed5011c3efebd$export$6dd1bbd39f571125 = ()=>false;
const $54fed5011c3efebd$export$23da1d24a38b0bde = ()=>globalThis.ssrContext.environmentType === "staging";
const $54fed5011c3efebd$export$64471597a28217e6 = ()=>$54fed5011c3efebd$export$6dd1bbd39f571125() || $54fed5011c3efebd$export$23da1d24a38b0bde() || globalThis.ssrContext.environmentType === "dev";
const $54fed5011c3efebd$export$4bd44a2aa29d3d6e = ()=>globalThis.ssrContext.environment;
const $54fed5011c3efebd$export$1038046b28a1d92e = ()=>globalThis.ssrContext.environmentType;
const $54fed5011c3efebd$export$94e128262c4fa6c3 = ()=>globalThis.ssrContext.entryScriptVersionId;
module.exports["isLocal"] = $54fed5011c3efebd$export$6dd1bbd39f571125;

});

parcelRegister("gpK3n", function(module, exports) {

var $kGrzq = parcelRequire("kGrzq");

const $ebf4d3ce910d3665$export$6adfe6668ae1a7f8 = (prefix)=>{
    const filteredMarkers = (window.performance?.getEntriesByType?.('mark') || []).filter((marker)=>marker.name.startsWith(prefix));
    filteredMarkers.sort((a, b)=>a.startTime - b.startTime);
    return filteredMarkers;
};
const $ebf4d3ce910d3665$export$a52fc5851be9b858 = (prefix)=>{
    const measures = new (0, $kGrzq.BaseMeasures)();
    for (const { name: name, startTime: startTime } of $ebf4d3ce910d3665$export$6adfe6668ae1a7f8(prefix)){
        const fieldName = name.replace(/\.start|\.end$/, '').replace(prefix, '');
        // Handle multiple pairs of markers due to re-renders
        if (name.endsWith('.start')) measures.markMeasureStart(fieldName, Math.floor(startTime));
        else measures.markMeasureEnd(fieldName, Math.floor(startTime), true);
    }
    const durations = {};
    for (const [name, { duration: duration }] of Object.entries(measures.getMeasures()))durations[name] = duration;
    return durations;
};
module.exports["getPerformanceEntries"] = $ebf4d3ce910d3665$export$6adfe6668ae1a7f8;
module.exports["collectDurationFromPerfMarkers"] = $ebf4d3ce910d3665$export$a52fc5851be9b858;

});

parcelRegister("2v1PW", function(module, exports) {

var $uxMYQ = parcelRequire("uxMYQ");


var $1oCLl = parcelRequire("1oCLl");

/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $dh538 = parcelRequire("dh538");

class $69eb8457e1e4692b$export$715a4ea2578407b6 {
    startFeature(featureName) {
        this.latestPeriodFeatures.add(featureName);
        this.periodMeasurements[this.state].features.add(featureName);
    }
    startHeavyTask(heavyTaskName) {
        this.latestHeavyTasks.add(heavyTaskName);
        this.periodMeasurements[this.state].heavyTasks.add(heavyTaskName);
        this.pause(heavyTaskName);
    }
    endHeavyTask(heavyTaskName) {
        this.resume(heavyTaskName);
    }
    /**
   * Sets a pause based on a key.  If this is the first pause, then it will also halt
   * running interactivity measures, and update the current measurements duration.
   */ pause(pauseName) {
        if (this.pauses.size === 0) {
            this.periodMeasurements[this.state].duration = this.periodMeasurements[this.state].duration + (performance.now() - this.currentPeriodStart);
            for (const periodMeasurer of this.session.insm.periodMeasurers)periodMeasurer.pause();
        }
        this.pauses.add(pauseName);
    }
    /**
   * Releases a pause for a key.
   *
   * **NOTE**: The session will only resume if this was the only
   * currently tracked pause key.
   */ resume(pauseName) {
        this.pauses.delete(pauseName);
        if (this.pauses.size === 0) {
            this.currentPeriodStart = performance.now();
            for (const periodMeasurer of this.session.insm.periodMeasurers)periodMeasurer.resume();
        }
    }
    get endResults() {
        this.changePeriodAndTrackLast(this.state);
        if ((0, $dh538.fg)('cc_editor_insm_fix_attributes')) return {
            active: {
                features: Array.from(this.periodMeasurements.active.features),
                heavyTasks: Array.from(this.periodMeasurements.active.heavyTasks),
                measurements: this.periodMeasurements.active.measurements,
                duration: this.periodMeasurements.active.duration,
                count: this.periodMeasurements.active.count
            },
            inactive: {
                features: Array.from(this.periodMeasurements.inactive.features),
                heavyTasks: Array.from(this.periodMeasurements.inactive.heavyTasks),
                measurements: this.periodMeasurements.inactive.measurements,
                duration: this.periodMeasurements.inactive.duration,
                count: this.periodMeasurements.inactive.count
            }
        };
        return this.periodMeasurements;
    }
    setupActiveStartInteractionListeners() {
        const events = [
            'mousemove',
            'pointerdown',
            'pointerup',
            'click',
            'keydown',
            'keyup',
            'scroll'
        ];
        for (const event of events){
            const eventListener = ()=>{
                // start event
                this.changePeriodAndTrackLast('inactive', 'active');
            };
            window.addEventListener(event, eventListener, {
                once: true
            });
            this.activeStartListeners.push([
                event,
                eventListener
            ]);
        }
    }
    setupEndActiveInteractionListeners() {
        this.activeEndCountDownVisibilityListener = ()=>{
            if (document.visibilityState === 'hidden') endSession();
        };
        window.addEventListener('visibilitychange', this.activeEndCountDownVisibilityListener);
        const events = [
            'mousemove',
            'pointerdown',
            'pointerup',
            'click',
            'keydown',
            'keyup',
            'scroll'
        ];
        for (const event of events){
            const eventListener = ()=>{
                this.activeEndCountDownAbortController.abort();
                this.activeEndCountDownAbortController = new AbortController();
                $69eb8457e1e4692b$var$startPeriodEndCountDown(this.activeEndCountDownAbortController.signal, ()=>{
                    endSession();
                });
            };
            window.addEventListener(event, eventListener);
            this.activeEndListeners.push([
                event,
                eventListener
            ]);
        }
        const endSession = ()=>{
            this.activeEndCountDownAbortController.abort();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            window.removeEventListener('visibilitychange', this.activeEndCountDownVisibilityListener);
            for (const activeEndListener of this.activeEndListeners)window.removeEventListener(activeEndListener[0], activeEndListener[1]);
            this.changePeriodAndTrackLast('active', 'inactive');
        };
        // When first setting up -- there has just been an interaction -- so we start a countdown
        this.activeEndCountDownAbortController.abort();
        this.activeEndCountDownAbortController = new AbortController();
        $69eb8457e1e4692b$var$startPeriodEndCountDown(this.activeEndCountDownAbortController.signal, ()=>{
            endSession();
        });
    }
    changePeriodAndTrackLast(lastPeriod, newPeriod) {
        this.periodMeasurements[lastPeriod].duration = this.periodMeasurements[lastPeriod].duration + (performance.now() - this.currentPeriodStart);
        this.periodMeasurements[lastPeriod].count++;
        const interactivityMeasuresPaused = this.latestHeavyTasks.size !== 0;
        for (const interactivityMeasure of this.session.insm.periodMeasurers){
            const finalResult = newPeriod ? interactivityMeasure.start(interactivityMeasuresPaused) : interactivityMeasure.end();
            const tracked = this.periodMeasurements[lastPeriod].measurements[interactivityMeasure.name];
            if (finalResult.average === 0) ;
            else if (tracked.average === 0) // In this case -- we haven't had any entries come through yet - so we replace any existing entries
            this.periodMeasurements[lastPeriod].measurements[interactivityMeasure.name] = finalResult;
            else {
                // In this case there is a new measurement which we merge with the previous measurement
                const merged = {
                    numerator: finalResult.numerator + tracked.numerator,
                    denominator: finalResult.denominator + tracked.denominator,
                    average: (finalResult.numerator + tracked.numerator) / (finalResult.denominator + tracked.denominator),
                    max: tracked.max === 0 || finalResult.max > tracked.max ? finalResult.max : tracked.max,
                    min: tracked.min === 0 || finalResult.min < tracked.min ? finalResult.min : tracked.min
                };
                this.periodMeasurements[lastPeriod].measurements[interactivityMeasure.name] = merged;
            }
        }
        for (const listener of this.activeStartListeners)window.removeEventListener(listener[0], listener[1]);
        for (const listener of this.activeEndListeners)window.removeEventListener(listener[0], listener[1]);
        this.activeEndCountDownAbortController?.abort();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        window.removeEventListener('visibilitychange', this.activeEndCountDownVisibilityListener);
        if (newPeriod) {
            this.latestPeriodFeatures = new Set(this.session.runningFeatures);
            this.session.runningFeatures.forEach((featureName)=>{
                this.periodMeasurements[newPeriod].features.add(featureName);
            });
            this.latestHeavyTasks = new Set(this.session.insm.runningHeavyTasks);
            this.currentPeriodStart = performance.now();
            switch(newPeriod){
                case 'active':
                    this.setupEndActiveInteractionListeners();
                    this.state = 'active';
                    break;
                case 'inactive':
                    this.setupActiveStartInteractionListeners();
                    this.state = 'inactive';
                    break;
            }
        }
    }
    constructor(session){
        this.periodMeasurements = {
            active: {
                features: new Set(),
                heavyTasks: new Set(),
                measurements: {},
                duration: 0,
                count: 0
            },
            inactive: {
                features: new Set(),
                heavyTasks: new Set(),
                measurements: {},
                duration: 0,
                count: 0
            }
        };
        /**
     * On creation - this is set to the currently running sessions features,
     * and is updated throughout the period for any additional features triggered.
     * It is reset when starting a new period.
     */ // Currently unused - this will be used when the outlier periods tracking is updated
        this.latestPeriodFeatures = void 0;
        // Currently unused - this will be used when the outlier periods tracking is updated
        this.latestHeavyTasks = void 0;
        this.state = 'inactive';
        this.pauses = new Set();
        /**
     * Warning: this can be reset mid period when pausing/resuming.
     * It's intended use is to build the `periodMeasurements` duration.
     */ this.currentPeriodStart = performance.now();
        this.session = void 0;
        this.activeStartListeners = [];
        this.activeEndListeners = [];
        /**
     * This works by;
     * On setup
     * - starts activity listeners
     *   - on activity received
     *     - possible end active count down started.
     *       3 animation frames or 3 seconds of inactivity - whichever comes first
     *     - any existing end count down ended
     */ this.activeEndCountDownAbortController = new AbortController();
        this.activeEndCountDownVisibilityListener = void 0;
        this.session = session;
        this.latestPeriodFeatures = new Set(session.runningFeatures);
        this.latestHeavyTasks = new Set(session.insm.runningHeavyTasks);
        this.pauses = new Set(session.insm.runningHeavyTasks);
        const startInteractivityMeasuresPaused = this.latestHeavyTasks.size !== 0;
        for (const periodMeasurer of session.insm.periodMeasurers){
            periodMeasurer.start(startInteractivityMeasuresPaused);
            this.periodMeasurements.active.measurements[periodMeasurer.name] = {
                numerator: 0,
                denominator: 0,
                max: 0,
                min: 0,
                average: 0
            };
            this.periodMeasurements.inactive.measurements[periodMeasurer.name] = {
                numerator: 0,
                denominator: 0,
                max: 0,
                min: 0,
                average: 0
            };
        }
        this.setupActiveStartInteractionListeners();
    }
}
function $69eb8457e1e4692b$var$startPeriodEndCountDown(signal, handleEnd) {
    let animationFramesSinceLastInteraction = 0;
    let inactiveTimeReached = false;
    let timer;
    let animationFrameHandler;
    const monitorAnimationFrames = ()=>{
        animationFrameHandler = requestAnimationFrame(()=>{
            animationFramesSinceLastInteraction++;
            if (animationFramesSinceLastInteraction < 3) monitorAnimationFrames();
            else if (inactiveTimeReached) handleEnd();
        });
    };
    const monitorTime = ()=>{
        timer = setTimeout(()=>{
            inactiveTimeReached = true;
            if (animationFramesSinceLastInteraction === 3) handleEnd();
        }, 3000);
    };
    monitorTime();
    monitorAnimationFrames();
    signal.addEventListener('abort', ()=>{
        clearTimeout(timer);
        cancelAnimationFrame(animationFrameHandler);
    });
}


class $28bb35d84d7323ac$export$c53843efd6e2e499 {
    handleBatch(batch) {
        for(let batchIndex = 0; batchIndex < batch.length; batchIndex++){
            const animationFrame = batch[batchIndex];
            // Only process frames that exceed the reporting threshold
            if (animationFrame.duration < this.options.reportingThreshold) continue;
            // Process all scripts in this long animation frame
            if (animationFrame.scripts && animationFrame.scripts.length > 0) for (const script of animationFrame.scripts)this.processScript(script, animationFrame);
        }
    }
    createScriptTiming(script, animationFrame) {
        return {
            duration: script.duration,
            forcedStyleAndLayoutDuration: script.forcedStyleAndLayoutDuration,
            invoker: script.invoker,
            invokerType: script.invokerType,
            sourceCharPosition: script.sourceCharPosition,
            sourceFunctionName: script.sourceFunctionName,
            sourceURL: script.sourceURL,
            features: Array.from(this.options.insmSession.runningFeatures),
            afDuration: animationFrame.duration
        };
    }
    processScript(script, animationFrame) {
        const scriptDuration = script.duration;
        const len = this.longestScriptTimings.length;
        // Not yet at capacity: append and update min tracking incrementally
        if (len < this.options.limit) {
            const scriptTiming = this.createScriptTiming(script, animationFrame);
            this.longestScriptTimings[len] = scriptTiming;
            if (len === 0 || scriptDuration < this.minimumDuration) {
                this.minimumDuration = scriptDuration;
                this.minimumIndex = len;
            }
            return;
        }
        // At capacity: only do work if we beat the current min
        if (scriptDuration <= this.minimumDuration) return;
        const scriptTiming = this.createScriptTiming(script, animationFrame);
        // Replace the current min
        this.longestScriptTimings[this.minimumIndex] = scriptTiming;
        // Find new minimum
        let newMinimumIndex = 0;
        let newMinimumDuration = this.longestScriptTimings[0].duration;
        for(let i = 1; i < this.options.limit; i++)if (this.longestScriptTimings[i].duration < newMinimumDuration) {
            newMinimumIndex = i;
            newMinimumDuration = this.longestScriptTimings[i].duration;
        }
        // Update the min tracking
        this.minimumIndex = newMinimumIndex;
        this.minimumDuration = newMinimumDuration;
    }
    /**
   * Pauses tracking
   */ pause() {
        this.paused = true;
    }
    /**
   * Resumes tracking
   */ resume() {
        this.paused = false;
    }
    /**
   * Returns the current tracked longest script timings sorted by duration
   */ get current() {
        const copy = this.longestScriptTimings.slice();
        copy.sort((a, b)=>b.duration - a.duration);
        return copy;
    }
    /**
   * Cleans up the performance tracking (tracking cannot be resumed following this).
   */ cleanup() {
        this.observer?.disconnect();
    }
    constructor(options){
        this.observer = void 0;
        this.longestScriptTimings = [];
        this.options = void 0;
        this.paused = void 0;
        this.minimumIndex = -1;
        this.minimumDuration = Infinity;
        this.options = options;
        this.paused = options.insmSession.insm.runningHeavyTasks.size !== 0;
        if (PerformanceObserver.supportedEntryTypes.includes('long-animation-frame')) {
            this.observer = new PerformanceObserver((list)=>{
                if (!this.paused) // only handle batches when tracking is not paused
                this.handleBatch(list.getEntries());
            });
            this.observer.observe({
                type: 'long-animation-frame',
                buffered: options.initial
            });
        }
    }
}


class $b5df66dc872c3f15$export$15db790bb6e6f6d1 {
    /**
   * Completes the page load timing. This is called automatically when ending a heavy task
   * with the key 'PageLoad'.
   */ completePageLoad() {
        this.pageLoadTime = performance.now() - this.startedAt;
    }
    updateExperienceKey(experienceKey) {
        this.experienceKey = experienceKey;
    }
    /**
   * Adds a feature to the currently running session
   */ startFeature(featureName) {
        this.runningFeatures.add(featureName);
        this.periodTracking?.startFeature(featureName);
    }
    /**
   * Ends a features usage in the currently running session
   */ endFeature(featureName) {
        this.runningFeatures.delete(featureName);
    }
    /**
   * Returns details on the current session.
   */ get details() {
        return {
            experienceKey: this.experienceKey,
            experienceProperties: this.experienceProperties,
            paused: this.periodTracking.pauses.size > 0,
            periodState: this.periodTracking.state,
            /**
       * The only scenario where this value should return false is when
       * the experience has been stopped early.
       */ running: this.running
        };
    }
    /**
   * This api takes either a static single-level key-value object, or callbacks which return the same and
   * will be evaluated on session end.
   *
   * When ending a session, all properties received via this api are merged, in order, into the resulting
   * insm event’s properties; last write wins.
   *
   * Callback values are evaluated at session end.
   *
   * For example, for the following
   *
   * ```ts
   * insm.experience.addProperties({ one: 1, two: 2 });
   * insm.experience.addProperties(() => ({ one: 'one' }));
   * insm.experience.addProperties({ three: 3 });
   * ```
   *
   * The resulting added properties will be
   *
   * ```ts
   * { one: 'one', two: 2, three: 3 }
   * ```
   */ addProperties(propertiesToAdd) {
        this.addedProperties.push(propertiesToAdd);
    }
    /**
   * In some scenarios (ie. when a page error boundary is hit), you will want to exit early.
   * This is api supports these scenarios
   *
   * ```ts
   * insm.stopEarly(reasonKey: string, description: string);
   * ```
   *
   * Sessions closed early are identifiable by their end details
   * `"endDetails": { stoppedBy: "early-stop", reasonKey, description }`.
   *
   * **Note**: The session is ended as soon as this is called, and any `addProperties` handlers will
   * called immediately.
   */ earlyStop(reason, description) {
        this.end({
            stoppedBy: 'early-stop',
            reason: reason,
            description: description
        });
    }
    end(endDetails) {
        if (this.running === false) // If an experience has already been ended -- don't repeat the ending
        return;
        this.running = false;
        const endedAt = performance.now();
        const duration = endedAt - this.startedAt;
        const evaluatedAddedProperties = {};
        for (const addedProperty of this.addedProperties)if (typeof addedProperty === 'function') Object.assign(evaluatedAddedProperties, addedProperty());
        else Object.assign(evaluatedAddedProperties, addedProperty);
        const periodResults = this.periodTracking.endResults;
        /**
     * This event ends up as "insm measured"
     */ const operationalEvent = {
            actionSubject: 'insm',
            action: 'measured',
            attributes: {
                // Added first to ensure these don't overwrite any insm properties
                ...evaluatedAddedProperties,
                experienceKey: this.experienceKey,
                initial: this.experienceProperties.initial,
                contentId: this.experienceProperties.contentId,
                timing: {
                    startedAt: this.startedAt,
                    duration: // Note: this will not match up with the periods sum of durations, as it includes
                    // time paused when heavy tasks were running, and/or the page is in the background.
                    duration
                },
                periods: periodResults,
                endDetails: endDetails,
                ...(0, $1oCLl.expValEquals)('cc_editor_insm_outlier_events', 'cohort', 'test') ? {
                    longScripts: this.longAnimationFrameMeasurer.current,
                    pageLoadTime: this.pageLoadTime,
                    deviceDetails: $b5df66dc872c3f15$var$getDeviceDetails()
                } : {},
                // these health attributes drive our SLOs
                healthAFPS: periodResults.active.measurements.afps?.average ? periodResults.active.measurements.afps?.average >= 50 : undefined,
                healthINP: periodResults.active.measurements.inp?.average ? periodResults.active.measurements.inp?.average >= 200 : undefined
            },
            highPriority: true,
            tags: [
                'editor'
            ],
            source: 'unknown'
        };
        this.insm.analyticsWebClient?.sendOperationalEvent(operationalEvent);
        this.longAnimationFrameMeasurer.cleanup();
    }
    constructor(experienceKey, experienceProperties, insm){
        this.experienceKey = void 0;
        this.experienceProperties = void 0;
        this.startedAt = performance.now();
        this.pageLoadTime = null;
        this.insm = void 0;
        this.running = true;
        this.addedProperties = [];
        this.runningFeatures = new Set();
        this.periodTracking = void 0;
        this.longAnimationFrameMeasurer = void 0;
        this.experienceKey = experienceKey;
        this.experienceProperties = experienceProperties;
        this.insm = insm;
        this.periodTracking = new (0, $69eb8457e1e4692b$export$715a4ea2578407b6)(this);
        this.longAnimationFrameMeasurer = new (0, $28bb35d84d7323ac$export$c53843efd6e2e499)({
            initial: this.experienceProperties.initial,
            limit: 3,
            insmSession: this,
            reportingThreshold: 500
        });
    }
}
// Functionality vendored from UFO
function $b5df66dc872c3f15$var$getDeviceDetails() {
    const telemetry = {};
    // /platform/packages/data/ufo-internal/src/core/publisher/plugins/browser.ts
    if ((0, (/*@__PURE__*/$parcel$interopDefault($uxMYQ))).getParser) {
        const browser = (0, (/*@__PURE__*/$parcel$interopDefault($uxMYQ))).getParser((typeof window !== 'undefined' && !!window ? window : undefined)?.navigator?.userAgent || '');
        Object.assign(telemetry, {
            'event:browser:name': browser.getBrowserName(),
            'event:browser:version': browser.getBrowserVersion()
        });
    }
    // /platform/packages/data/ufo-internal/src/core/publisher/plugins/cpus.ts
    Object.assign(telemetry, {
        'event:cpus': navigator.hardwareConcurrency
    });
    // /platform/packages/data/ufo-internal/src/core/publisher/plugins/memory.ts
    // @ts-ignore: deviceMemory is exposed in some browsers
    Object.assign(telemetry, {
        'event:memory': navigator.deviceMemory
    });
    // /platform/packages/data/ufo-internal/src/core/publisher/plugins/network.ts
    Object.assign(telemetry, {
        // Network
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection?.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection?.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection?.downlink
    });
    return telemetry;
}


class $ea850af5aa7a5082$export$dcf27b52d88d889b {
    start(paused) {
        const result = this.monitor.startNewWindow(paused);
        return result;
    }
    end() {
        const result = this.monitor.end();
        return result;
    }
    pause() {
        this.monitor.pause();
    }
    resume() {
        this.monitor.resume();
    }
    constructor(){
        /**
     * AFPS stands for Animation Frames Per Second
     */ this.name = 'afps';
        this.monitor = new $ea850af5aa7a5082$var$AnimationFPSMonitor();
    }
}
class $ea850af5aa7a5082$var$AnimationFPSMonitor {
    measureWindowFPS() {
        // Calculate FPS for this window
        // Note: windowFrameCount and windowTotalTime is reset after each window measurement
        const windowSeconds = this.windowTotalTime / 1000;
        // frames / seconds
        const windowFPS = this.windowFrameCount / windowSeconds;
        // Update overall tracking
        this.currentState.numerator += this.windowFrameCount;
        // The denominator is seconds not ms
        this.currentState.denominator += windowSeconds;
        // Calculate overall average FPS: (total frames / total time measured in seconds
        this.currentState.average = this.currentState.numerator / this.currentState.denominator;
        if (this.currentState.max === 0 || windowFPS > this.currentState.max) this.currentState.max = windowFPS;
        if (this.currentState.min === 0 || windowFPS < this.currentState.min) this.currentState.min = windowFPS;
    }
    /**
   * If there is running tracking - it will be reset
   */ startWindowTracking() {
        // Clear any previous tracking state
        this.resetOverallTracking();
        const measureFrame = ()=>{
            this.currentFrameStart = $parcel$global.performance.now();
            this.animationFrame = requestAnimationFrame(()=>{
                // While measurement is paused -- we don't count the animation frame towards the monitored
                // period.
                if (!this.paused) {
                    const frameDuration = performance.now() - this.currentFrameStart;
                    // Add frame to current window
                    this.windowFrameCount++;
                    this.windowTotalTime += frameDuration;
                    // Check if window is >= 1 second (1000ms)
                    // When the page is running smoothly it's expected this will not be hit frequently
                    if (this.windowTotalTime >= 1000) {
                        this.measureWindowFPS();
                        // Reset window for next measurement
                        this.resetWindow();
                    }
                }
                measureFrame();
            });
        };
        measureFrame();
    }
    startNewWindow(paused) {
        const lastWindowResult = {
            numerator: this.currentState.numerator,
            denominator: this.currentState.denominator,
            max: this.currentState.max,
            min: this.currentState.min,
            average: this.currentState.average
        };
        this.paused = paused;
        this.startWindowTracking();
        return lastWindowResult;
    }
    resetWindow() {
        this.windowFrameCount = 0;
        this.windowTotalTime = 0;
    // Note this.currentFrameStart is over ridden
    // as part of tracking - so does not need to be
    // reset.
    }
    endWindowTracking() {
        if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
    }
    resetOverallTracking() {
        this.resetWindow();
        this.endWindowTracking();
        this.currentState = {
            numerator: 0,
            denominator: 0,
            max: 0,
            min: 0,
            average: 0
        };
    }
    end() {
        try {
            this.measureWindowFPS();
            return this.currentState;
        } finally{
            this.resetOverallTracking();
        }
    }
    pause() {
        // Note - we leave the tracking animationFrame monitoring running, and on resume
        // simply set the currentFrameStart and paused to true
        // This works because the tracking builds windows of tracked time rather than
        // basing itself off a window start time and time elapsed time since then.
        this.paused = true;
    }
    resume() {
        // Note - We don't need to handle the gap in measurement - as the raf logic builds/increments a window time
        // based on the currentFrameStart (and any previous measurements which can only happen while the tracking
        // is not paused).
        this.currentFrameStart = performance.now();
        this.paused = false;
        if (!this.animationFrame) this.startWindowTracking();
    }
    constructor(){
        this.paused = false;
        this.currentState = {
            numerator: 0,
            denominator: 0,
            max: 0,
            average: 0,
            min: 0
        };
        // Current measurement window
        this.windowFrameCount = 0;
        this.windowTotalTime = 0;
        this.currentFrameStart = 0;
        this.animationFrame = void 0;
    }
}


class $29aed8e5a643c0ff$export$4551d640419205b3 {
    start(paused) {
        const result = this.monitor.start(paused);
        return result;
    }
    end() {
        const result = this.monitor.end();
        return result;
    }
    pause() {
        this.monitor.pause();
    }
    resume() {
        this.monitor.resume();
    }
    constructor(options){
        /**
     * INP stands for Interaction to Next Paint
     */ this.name = 'inp';
        this.monitor = void 0;
        this.includedInteractions = void 0;
        this.includedInteractions = options?.includedInteractions || [
            'pointerdown',
            'pointerup',
            'click',
            'keydown',
            'keyup'
        ];
        this.monitor = new $29aed8e5a643c0ff$var$InteractionTracker(this.includedInteractions);
    }
}
class $29aed8e5a643c0ff$var$InteractionResult {
    update(duration) {
        if (duration > this.max) this.max = duration;
        if (duration < this.min) this.min = duration;
        this.numerator += duration;
        this.count += 1;
        this.average = this.numerator / this.count;
    }
    toMeasure() {
        return {
            min: this.count === 0 ? 0 : this.min,
            max: this.max,
            average: this.average,
            numerator: this.numerator,
            denominator: this.count
        };
    }
    constructor(){
        this.min = void 0;
        this.max = void 0;
        this.average = void 0;
        this.numerator = void 0;
        this.count = void 0;
        this.min = Infinity;
        this.max = 0;
        this.average = 0;
        this.numerator = 0;
        this.count = 0;
    }
}
class $29aed8e5a643c0ff$var$InteractionTracker {
    stopTracking() {
        this.performanceObserver?.disconnect();
        this.performanceObserver = null;
    }
    startTracking() {
        this.performanceObserver = new PerformanceObserver((list)=>{
            // Note: find link to actual safari issue .. good to get rid of this if Safari has fixed this
            // Delay by a microtask to workaround a bug in Safari where the
            // callback is invoked immediately, rather than in a separate task.
            // See: https://github.com/GoogleChrome/web-vitals/issues/277
            Promise.resolve().then(()=>{
                const entries = list.getEntries();
                entries.forEach((entry)=>{
                    // Skip further processing for entries that cannot be INP candidates.
                    //
                    // When a user interacts with a web page, a user interaction (for example a click) usually triggers a sequence of events.
                    // To measure the latency of this series of events, the events share the same interactionId.
                    // An interactionId is only computed for the following event types belonging to a user interaction. It is 0 otherwise.
                    // * click / tap / drag events: 'pointerdown', 'pointerup', 'click'
                    // * keypress events: 'keydown', 'keyup'
                    //
                    if (!entry.interactionId) return;
                    if (this.includedInteractions.includes(entry.name)) this.interactionResult.update(entry.duration);
                });
            });
        });
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        if (PerformanceObserver.supportedEntryTypes.includes('event')) this.performanceObserver.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 40
        });
    }
    reset() {
        this.stopTracking();
        this.interactionResult = new $29aed8e5a643c0ff$var$InteractionResult();
    }
    start(paused) {
        const lastResult = this.interactionResult.toMeasure();
        this.reset();
        this.paused = paused;
        if (!paused) this.startTracking();
        return lastResult;
    }
    end() {
        try {
            return this.interactionResult.toMeasure();
        } finally{
            this.reset();
        }
    }
    pause() {
        if (this.paused) return;
        this.paused = true;
        this.stopTracking();
    }
    resume() {
        if (!this.paused) return;
        this.paused = false;
        this.startTracking();
    }
    constructor(includedInteractions){
        this.paused = false;
        this.performanceObserver = void 0;
        this.interactionResult = void 0;
        this.includedInteractions = void 0;
        this.performanceObserver = null;
        this.interactionResult = new $29aed8e5a643c0ff$var$InteractionResult();
        this.includedInteractions = includedInteractions;
    }
}





class $10169176d7d277e2$export$4b79d93e0c782a13 {
    /**
   * Starts a heavy task in the currently running session.
   *
   * This also pauses measurement.
   *
   * For PageLoads using the key 'PageLoad' will mean the heavy task duration
   * is added to the insm session event as pageLoadTime.
   */ startHeavyTask(heavyTaskName) {
        this.runningHeavyTasks.add(heavyTaskName);
        this.runningSession?.periodTracking?.startHeavyTask(heavyTaskName);
        this.runningSession?.periodTracking.pause(heavyTaskName);
        this.runningSession?.longAnimationFrameMeasurer.pause();
    }
    /**
   * Ends a heavy task in the currently running session
   */ endHeavyTask(heavyTaskName) {
        this.runningHeavyTasks.delete(heavyTaskName);
        this.runningSession?.periodTracking.resume(heavyTaskName);
        if (this.runningHeavyTasks.size === 0) this.runningSession?.longAnimationFrameMeasurer.resume();
        if ((0, $1oCLl.expValEquals)('cc_editor_insm_outlier_events', 'cohort', 'test')) {
            if (heavyTaskName === 'PageLoad') this.runningSession?.completePageLoad();
        }
    }
    /**
   * Call this when starting a new experience.  This is expected to be wired to the product
   * routing solution.
   *
   * It's expected this call will be paired with a `insm.session.startHeavyTask('PageLoad')` and
   * subsequent `insm.session.endHeavyTask('PageLoad')` so that performance degradations linked
   * to the page initialisation are excluded from the active interactivity monitoring.
   *
   * Using the key 'PageLoad' is special and will result in the heavy task duration being added to the
   * insm session event as pageLoadTime.
   *
   *
   * ```ts
   * insm.start('edit-page', { initial: true, contentId: '9001' })
   * insm.session.startHeavyTask('PageLoad')
   * // ... heavy initialisation work
   * insm.session.endHeavyTask('PageLoad')
   * ```
   */ start(experienceKey, experienceProperties) {
        if (this.runningSession !== undefined) this.runningSession.end({
            stoppedBy: 'new-experience',
            experienceKey: experienceKey,
            contentId: experienceProperties.contentId
        });
        this.lastStartedExperienceProperties = experienceProperties;
        if (this.options.experiences[experienceKey]?.enabled) this.runningSession = new (0, $b5df66dc872c3f15$export$15db790bb6e6f6d1)(experienceKey, experienceProperties, this);
    }
    /**
   * Call this to update the name of the running session after it's started
   * In the case it's been started with an unregistered name, and there is not running
   * session. This will also trigger the session being started.
   */ overrideExperienceKey(experienceKey) {
        if (this.runningSession !== undefined) // If there is a running session - we update its name
        this.runningSession.updateExperienceKey(experienceKey);
        else // otherwise - we assume the last session was not registered, and start it with the new name
        if (this.options.experiences[experienceKey]?.enabled && this.lastStartedExperienceProperties) this.runningSession = new (0, $b5df66dc872c3f15$export$15db790bb6e6f6d1)(experienceKey, this.lastStartedExperienceProperties, this);
    }
    /**
   * This prematurely halts any running experience measurement. It's expected to be used in
   * scenarios such as when error boundaries are hit.
   */ stopEarly(reasonKey, description) {
        this.runningSession?.earlyStop(reasonKey, description);
    }
    /**
   * Gets the current running session details
   */ get session() {
        return this.runningSession;
    }
    constructor(options){
        this.analyticsWebClient = void 0;
        this.runningSession = void 0;
        this.options = void 0;
        this.periodMeasurers = void 0;
        /**
     * Heavy tasks are tracked at the insm layer as heavy tasks
     * are expected at times to be unrelated to the current
     * page session.
     */ this.runningHeavyTasks = new Set();
        this.lastStartedExperienceProperties = void 0;
        this.periodMeasurers = [
            new (0, $ea850af5aa7a5082$export$dcf27b52d88d889b)(),
            new (0, $29aed8e5a643c0ff$export$4551d640419205b3)()
        ];
        this.options = options;
        // If this does throw -- we do want an unhandledRejection rejection to be passed to the window
        // this is to ease debugging.
        options.getAnalyticsWebClient.then((analyticsWebClient)=>this.analyticsWebClient = analyticsWebClient);
        // No cleanup needs to be performed -- as this tooling is intended to run until the tab is closed
        // The use of beforeunload here is because using pagehide does not reliably result in the analytics
        // being fired by the analytics web client.
        // The use of this means we will miss events from mobile safari which does not reliably call this api
        // however mobile browsers do not call when a browser closes - so we expect limited mobile data from
        // this tooling in its current form.
        // window will not be defined in server envs - in these envs -- there can never be a session end
        if (typeof window !== 'undefined') // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('beforeunload', ()=>{
            this.runningSession?.end({
                stoppedBy: 'beforeunload'
            });
        });
    }
}


let $e458a95ec00cb69e$var$initialisedInsm;
function $e458a95ec00cb69e$export$2cd8252107eb640b(options) {
    $e458a95ec00cb69e$var$initialisedInsm = new (0, $10169176d7d277e2$export$4b79d93e0c782a13)(options);
}
function $e458a95ec00cb69e$var$insmInitialised() {
    if (!$e458a95ec00cb69e$var$initialisedInsm) return false;
    return true;
}
const $e458a95ec00cb69e$export$2945ea0ab201da79 = {
    startHeavyTask (heavyTaskName) {
        if ($e458a95ec00cb69e$var$insmInitialised()) $e458a95ec00cb69e$var$initialisedInsm.startHeavyTask(heavyTaskName);
    },
    endHeavyTask (heavyTaskName) {
        if ($e458a95ec00cb69e$var$insmInitialised()) $e458a95ec00cb69e$var$initialisedInsm.endHeavyTask(heavyTaskName);
    },
    start (experienceKey, experienceProperties) {
        if ($e458a95ec00cb69e$var$insmInitialised()) $e458a95ec00cb69e$var$initialisedInsm.start(experienceKey, experienceProperties);
    },
    overrideExperienceKey (experienceKey) {
        if ($e458a95ec00cb69e$var$insmInitialised()) $e458a95ec00cb69e$var$initialisedInsm.overrideExperienceKey(experienceKey);
    },
    stopEarly (reasonKey, description) {
        if ($e458a95ec00cb69e$var$insmInitialised()) $e458a95ec00cb69e$var$initialisedInsm.stopEarly(reasonKey, description);
    },
    // We only expose details and feature start/stop to consumers
    // as the other properties are internals for the insm and InsmPeriod
    // to interact with the running session.
    get session () {
        if ($e458a95ec00cb69e$var$insmInitialised()) return $e458a95ec00cb69e$var$initialisedInsm.runningSession;
    },
    // @ts-expect-error Private method for testing purposes
    __setAnalyticsWebClient (analyticsWebClient) {
        if ($e458a95ec00cb69e$var$initialisedInsm) $e458a95ec00cb69e$var$initialisedInsm.analyticsWebClient = analyticsWebClient;
    }
};
module.exports["init"] = $e458a95ec00cb69e$export$2cd8252107eb640b;
module.exports["insm"] = $e458a95ec00cb69e$export$2945ea0ab201da79;

});

parcelRegister("1oCLl", function(module, exports) {

var $8Qxmq = parcelRequire("8Qxmq");

function $b91c6871269ae091$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $8Qxmq.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}
module.exports["expValEquals"] = $b91c6871269ae091$export$45abdb3f977b5b14;

});

parcelRegister("8Qxmq", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $g68Gk = parcelRequire("g68Gk");


var $8ihu7 = parcelRequire("8ihu7");

function $c46fb32b198a4cae$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $8ihu7._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $8ihu7._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $c6GJD.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $c6GJD.default).getExperimentValue(experimentName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $c6GJD.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $g68Gk.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue === experimentExpectedValue;
}
module.exports["expValEqualsInternal"] = $c46fb32b198a4cae$export$58e581060588c6bb;

});

parcelRegister("3kTfj", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $7RgFv = parcelRequire("7RgFv");


var $69Zr8 = parcelRequire("69Zr8");


var $2BcbG = parcelRequire("2BcbG");


var $c1uRl = parcelRequire("c1uRl");


var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $j4jXg = parcelRequire("j4jXg");

const $473ea7efe1dbee82$var$makeBrowserMetrics = ()=>{
    const bm = {
        init (config) {
            (0, $2BcbG.visibilityChangeObserver).start();
            if (config.events[(0, $j4jXg.BMEventsType).WEB_VITALS]?.enabled) (0, $c1uRl.webVitalsObserver).start();
            if (config.debug) {
                (0, $7RgFv.logger).enable();
                (0, $11Zqj.submitter).setDebug(true);
                (0, $69Zr8.pageLoadMetaMetric).setDebug(true);
            }
            (0, $11Zqj.submitter).configure(config);
            if (config.ssr?.getDoneMark) (0, $h6RR2.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute (newRoute) {
            (0, $lH7GJ.Route).setRoute(newRoute);
        },
        startPageLoad (params) {
            (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
                isInitial: false,
                cancelStarted: true,
                ...params
            });
        },
        getPageLoadMetric () {
            return 0, $69Zr8.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks (name, startMark, stopMark, initialOnly = true) {
            if (initialOnly && !(0, $69Zr8.pageLoadMetaMetric).isInitialLoad()) return;
            const start = performance.getEntriesByName(startMark);
            const stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $69Zr8.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    const startMark = start[start.length - 1];
                    const timing = {
                        startTime: Math.round(startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - startMark.startTime)
                    };
                    (0, $69Zr8.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
const $473ea7efe1dbee82$export$c08e7affcf78b064 = $473ea7efe1dbee82$var$makeBrowserMetrics();
module.exports["browserMetrics"] = $473ea7efe1dbee82$export$c08e7affcf78b064;

});

parcelRegister("h6RR2", function(module, exports) {
const $ccbe82b8c20465d3$export$9e87a201397ac0a9 = {
    getDoneMark: ()=>null,
    setGetDoneMark: (fn)=>{
        $ccbe82b8c20465d3$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};
module.exports["SSRGetDoneMark"] = $ccbe82b8c20465d3$export$9e87a201397ac0a9;

});

parcelRegister("7RgFv", function(module, exports) {
const $de756a2051fbb2ae$export$af88d00dbe7f521 = {
    enabled: false,
    enable () {
        this.enabled = true;
    },
    log (...args) {
        if (this.enabled) // eslint-disable-next-line no-console
        console.log('BM log: ', ...args);
    },
    logCond (condition, ...args) {
        if (this.enabled && condition && args.length > 1) this.log(...args);
    }
};
module.exports["logger"] = $de756a2051fbb2ae$export$af88d00dbe7f521;

});

parcelRegister("69Zr8", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");


var $3znwT = parcelRequire("3znwT");

class $31e407dce760f8b0$export$9609608c00ea5077 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad({ cancelStarted: cancelStarted, ...startPageLoadParams } = {
        isInitial: false,
        cancelStarted: false
    }) {
        if (cancelStarted || this.state !== (0, $4k3LC.MetricState).STARTED) super.startPageLoad(startPageLoadParams);
    }
    setActive(metric) {
        this.activePageLoadMetric = metric;
    }
    setDebug(debug) {
        this.config.debug = debug;
    }
    isDebugMode() {
        return this.config.debug;
    }
    isInitialLoad() {
        return this.isInitial;
    }
    clear() {
        this.activePageLoadMetric && this.activePageLoadMetric.cancel();
        super.clear();
    }
    include(metric) {
        if (!this.config.include) this.config.include = [
            metric
        ];
        else this.config.include.push(metric);
    }
    experimental__addExplicitTiming(name, timing) {
        if (this.explicitTimings === null) this.explicitTimings = {};
        this.explicitTimings[name] = timing;
    }
    constructor(...args){
        super(...args);
        this.activePageLoadMetric = null;
    }
}
const $31e407dce760f8b0$export$24b7a1a311eb05dc = new $31e407dce760f8b0$export$9609608c00ea5077({
    type: (0, $j4jXg.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});
module.exports["pageLoadMetaMetric"] = $31e407dce760f8b0$export$24b7a1a311eb05dc;

});

parcelRegister("j4jXg", function(module, exports) {

var $4k3LC = parcelRequire("4k3LC");

var $d2d81ebd075ab34b$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $d2d81ebd075ab34b$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $d2d81ebd075ab34b$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $d2d81ebd075ab34b$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $d2d81ebd075ab34b$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $d2d81ebd075ab34b$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $d2d81ebd075ab34b$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $d2d81ebd075ab34b$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
const $d2d81ebd075ab34b$export$5866f95702a15142 = (data)=>{
    return Boolean(data.initial);
};
const $d2d81ebd075ab34b$export$f087a59bd717e49d = (data)=>{
    return Boolean(data.initial);
};
const $d2d81ebd075ab34b$export$153c4c72fa5eeece = (data)=>{
    const obj = data;
    return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
const $d2d81ebd075ab34b$export$b10c1d9a7db7765b = (data)=>{
    const obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};
var $d2d81ebd075ab34b$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});
module.exports["BMEventsType"] = $d2d81ebd075ab34b$export$9c73e297d4be9159;
module.exports["StorableBMEventsType"] = $d2d81ebd075ab34b$export$9b7037ec30489597;
module.exports["BMPageLoadMetrics"] = $d2d81ebd075ab34b$export$74c1fb0997d51e2a;
module.exports["BMPageSegmentLoadMetrics"] = $d2d81ebd075ab34b$export$88195ac8200d03a6;
module.exports["BMInteractionMetrics"] = $d2d81ebd075ab34b$export$6e28252a002afdb2;
module.exports["PageSegmentPageLoadMetricsOptions"] = $d2d81ebd075ab34b$export$474154836bfd8dd9;
module.exports["PageVisibleFields"] = $d2d81ebd075ab34b$export$e89802082dab5633;
module.exports["PageVisibleValueOrigin"] = $d2d81ebd075ab34b$export$983b017156c2aee2;
module.exports["isDetailedPageLoadSlo"] = $d2d81ebd075ab34b$export$5866f95702a15142;
module.exports["isDetailedPageSegmentLoadSlo"] = $d2d81ebd075ab34b$export$f087a59bd717e49d;
module.exports["isInteractionMetricsSlo"] = $d2d81ebd075ab34b$export$b10c1d9a7db7765b;
module.exports["IncludeSSRFeatureFlagsConfig"] = $d2d81ebd075ab34b$export$60c0193054fc3040;

});

parcelRegister("4k3LC", function(module, exports) {

var $jGRlW = parcelRequire("jGRlW");


var $7RgFv = parcelRequire("7RgFv");


var $2BcbG = parcelRequire("2BcbG");

class $36ec057a8677823e$export$3fcc0936ee2cc852 {
    static fromConfig(config) {
        return new $36ec057a8677823e$export$3fcc0936ee2cc852(config.experience, config.useFmpAsUntilStopTime);
    }
    static fromMetric(metric) {
        return new $36ec057a8677823e$export$3fcc0936ee2cc852(metric);
    }
    /**
   * If FMP mark is present, return that
   * otherwise return the eventual load
   */ getFmp() {
        const { marks: marks, stop: stop } = this.experience.getData();
        return marks[$36ec057a8677823e$export$3fcc0936ee2cc852.FMP] ?? stop;
    }
    getDependencyStopTime() {
        if (this.useFmpAsUntilStopTime) return this.getFmp();
        return this.experience.getData().stop;
    }
    /**
   * Get the time it takes for a segment to become fully interactable,
   * regardless of whether it uses the FMP as the stop time. (Eventual load)
   */ getFullyInteractiveStopTime() {
        return this.experience.getData().stop;
    }
    getIsSegmentLoadOverrided() {
        if (this.useFmpAsUntilStopTime) {
            const { marks: marks } = this.experience.getData();
            return marks[$36ec057a8677823e$export$3fcc0936ee2cc852.FMP] ? true : false;
        }
        return false;
    }
    getKey() {
        return this.experience.getData().key;
    }
    constructor(experience, useFmpAsUntilStopTime){
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
}
$36ec057a8677823e$export$3fcc0936ee2cc852.FMP = 'fmp';


var $233403977176019b$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $233403977176019b$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $233403977176019b$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? "visible" : "hidden";
}
class $233403977176019b$export$2bce4ffdd840e878 {
    get untilMetrics() {
        const { until: until } = this.config;
        if (!until) return [];
        else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
        return this.getConfiguredUntilMetricArray([
            until
        ]);
    }
    start({ startTime: startTime = window.performance.now() } = {}) {
        this.clear();
        (0, $7RgFv.logger).logCond(!!this.config.debug, this.key, startTime);
        this.state = "started";
        this.startTime = startTime;
        this.pageVisibleState = $233403977176019b$var$getPageVisibleState();
        (0, $2BcbG.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
        this.watchUntil();
    }
    stop(stopArguments = {}) {
        const { stopTime: stopTime = window.performance.now() } = stopArguments;
        if (this.state !== "started" || this.startTime === null) {
            (0, $7RgFv.logger).log(`metric ${this.config.key} has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopTime < this.startTime) {
            (0, $7RgFv.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${this.startTime}; stopTime: ${stopTime}`);
            return false;
        }
        this.stopTime = stopTime;
        this.state = "finished";
        this.handleStop(stopArguments);
        (0, $2BcbG.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return true;
    }
    handleStop(stopArguments) {
        const { customData: customData = null } = stopArguments;
        if (customData) this.custom = {
            ...this.custom,
            ...customData
        };
        this.config.include && this.config.include.forEach((metric)=>{
            const included = metric.getData();
            if (included.state === "finished" && included.start !== null && included.start >= (this.startTime || 0)) this.addSubMetric(metric.getData());
        });
        this.onStopCallbacks.forEach(([success])=>{
            success(stopArguments);
        });
        this.onStopCallbacks = [];
        (0, $7RgFv.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
    }
    mark(mark, timestamp = window.performance.now()) {
        this.marks[mark] = timestamp;
    }
    cancel() {
        if (this.state !== "started") return;
        this.state = "cancelled";
        this.cancelUntil();
        this.onStopCallbacks.forEach(([, cancel])=>{
            cancel();
        });
        this.onStopCallbacks = [];
        (0, $2BcbG.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
    }
    merge(mergeData) {
        this.state = mergeData.state;
        this.pageVisibleState = mergeData.pageVisibleState;
        this.startTime = mergeData.start;
        this.stopTime = mergeData.stop;
        this.marks = {
            ...this.marks,
            ...mergeData.marks
        };
        this.submetrics = [
            ...this.submetrics,
            ...mergeData.submetrics
        ];
        this.onStopCallbacks = [
            ...this.onStopCallbacks,
            ...mergeData.onStopCallbacks
        ];
    }
    onStop(success, cancel) {
        this.onStopCallbacks.push([
            success,
            cancel
        ]);
    }
    removeOnStopCallback(success) {
        const index = this.onStopCallbacks.findIndex(([successCallback])=>{
            return success === successCallback;
        });
        if (index > -1) this.onStopCallbacks.splice(index, 1);
    }
    getData() {
        return {
            key: this.key,
            state: this.state,
            start: this.startTime,
            stop: this.stopTime,
            //todo ranges
            // ranges: this.makeRanges()
            marks: this.marks,
            // todo make copy
            custom: this.custom,
            submetrics: this.submetrics,
            config: this.config,
            route: this.route,
            pageVisibleState: this.pageVisibleState,
            type: this.config.type
        };
    }
    getDataToMerge() {
        return {
            ...this.getData(),
            onStopCallbacks: this.onStopCallbacks
        };
    }
    addSubMetric(data) {
        this.submetrics.push(data);
    }
    /**
   *
   * @param metric
   * The array of Until metrics can be of two types
   * This function returns an UntilExperience
   */ getConfiguredUntilMetric(metricOrConfig) {
        return metricOrConfig instanceof $233403977176019b$export$2bce4ffdd840e878 ? (0, $36ec057a8677823e$export$3fcc0936ee2cc852).fromMetric(metricOrConfig) : (0, $36ec057a8677823e$export$3fcc0936ee2cc852).fromConfig(metricOrConfig);
    }
    getConfiguredUntilMetricArray(metricArray) {
        if (!metricArray.length) return [];
        return metricArray.map((metric)=>this.getConfiguredUntilMetric(metric));
    }
    isUntilFinished() {
        return this.untilMetrics.every((metric)=>metric.experience.getData().state === "finished");
    }
    handleAllUntilFinished() {
        // Order by ascending stop time
        const sorted = [
            ...this.untilMetrics
        ].sort((m1, m2)=>{
            return m1.getDependencyStopTime() - m2.getDependencyStopTime();
        });
        // Find the latest page segment to become fully interactive
        const latestFullyInteractiveSegment = [
            ...this.untilMetrics
        ].reduce((currentLatestSegment, metric)=>{
            const currentLatestStopTime = currentLatestSegment?.getFullyInteractiveStopTime() ?? 0;
            const metricStopTime = metric.getFullyInteractiveStopTime() ?? 0;
            return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
        }, undefined);
        // Accumulate the custom data from each metric, later metrics take priority
        const accumulatedCustomData = {};
        sorted.forEach((metric)=>{
            Object.assign(accumulatedCustomData, metric.experience.getData().custom);
        });
        const latestSegment = sorted[sorted.length - 1];
        const latestFullyInteractiveStopTime = latestFullyInteractiveSegment?.getFullyInteractiveStopTime();
        this.stop({
            stopTime: latestSegment.getDependencyStopTime(),
            customData: {
                ...accumulatedCustomData,
                segment: latestSegment.getKey(),
                segmentOverrided: latestSegment.getIsSegmentLoadOverrided(),
                ...latestFullyInteractiveStopTime ? {
                    latestFullyInteractiveSegment: latestFullyInteractiveSegment?.getKey(),
                    latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                } : {}
            }
        });
    }
    watchUntil() {
        if (!this.untilMetrics.length) return;
        if (this.isUntilFinished()) {
            // Already finished, handle it immediately
            this.handleAllUntilFinished();
            return;
        }
        // If not currently finished, register stop callbacks to re-check
        this.untilOnStopCallback = ()=>{
            if (this.isUntilFinished()) this.handleAllUntilFinished();
        };
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "finished") metric.experience.onStop(this.untilOnStopCallback, ()=>this.cancel());
        });
    }
    cancelUntil() {
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "cancelled" && this.untilOnStopCallback) metric.experience.removeOnStopCallback(this.untilOnStopCallback);
        });
    }
    clear() {
        // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
        this.cancelUntil();
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.pageVisibleState = $233403977176019b$var$getPageVisibleState();
    }
    constructor(config){
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.onStopCallbacks = [];
        this.custom = null;
        this.config = void 0;
        this.submetrics = [];
        this.route = null;
        this.untilOnStopCallback = null;
        this.pageVisibleState = $233403977176019b$var$getPageVisibleState();
        this.key = void 0;
        this.type = void 0;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = "mixed";
        };
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        this.config.timings?.forEach((entry)=>{
            if ((0, $jGRlW.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn(`Entry ${entry.key} is restricted and has been renamed to custom__${entry.key}`);
                entry.key = `custom__${entry.key}`;
            }
        });
    }
}
$233403977176019b$export$2bce4ffdd840e878.FMP = 'fmp';
module.exports["MetricState"] = $233403977176019b$export$1e458f18c0c7bfe3;
module.exports["PageVisibleState"] = $233403977176019b$export$a12c67b37a306b13;
module.exports["BaseMetric"] = $233403977176019b$export$2bce4ffdd840e878;

});

parcelRegister("3znwT", function(module, exports) {

var $7RgFv = parcelRequire("7RgFv");


var $4k3LC = parcelRequire("4k3LC");

class $f7f7f3887cc305ae$export$fd1447b187f590fe extends (0, $4k3LC.BaseMetric) {
    start({} = {}) {
        // please use startPageLoad
        return;
    }
    startPageLoad(params = {
        isInitial: false
    }) {
        // todo this should update meta page load metric
        this.isInitial = params.isInitial;
        if (params.isInitial) super.start({
            startTime: 0
        });
        else super.start(params);
        (0, $7RgFv.logger).logCond(!!this.config.debug, this.key, this.startTime);
    }
    stopPageLoad(pageLoadMetaMetricData, stopArguments = {
        stopTime: window.performance.now()
    }) {
        if (pageLoadMetaMetricData.state !== (0, $4k3LC.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
            (0, $7RgFv.logger).log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
            (0, $7RgFv.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
            return false;
        }
        this.merge(pageLoadMetaMetricData);
        this.stopTime = stopArguments.stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.handleStop(stopArguments);
        return true;
    }
    handleStop(stopArguments) {
        const { until: until } = this.config;
        const fmpWasMarked = $f7f7f3887cc305ae$export$fd1447b187f590fe.FMP in this.marks;
        if (!fmpWasMarked && until) {
            // Extract the maximum FMP value from the until metrics
            const untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                until
            ]);
            const untilFmpMarks = untilArr.map((metric)=>metric.getFmp());
            if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max(...untilFmpMarks));
        }
        super.handleStop(stopArguments);
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $f7f7f3887cc305ae$export$fd1447b187f590fe.FMP) return;
        super.mark(mark, timestamp);
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
        this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? {
            ...mergeData.explicitTimings,
            ...this.explicitTimings
        } : null;
    }
    markFMP(timestamp) {
        super.mark($f7f7f3887cc305ae$export$fd1447b187f590fe.FMP, timestamp);
    }
    getPageLoadData() {
        return {
            isInitial: this.isInitial,
            explicitTimings: this.explicitTimings
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageLoadData()
        };
    }
    clear() {
        this.explicitTimings = null;
        super.clear();
    }
    constructor(args){
        super(args);
        this.isInitial = true;
        this.explicitTimings = null;
        this.config = void 0;
        this.config = args;
    }
}
$f7f7f3887cc305ae$export$fd1447b187f590fe.FMP = 'fmp';
module.exports["BasePageLoadMetric"] = $f7f7f3887cc305ae$export$fd1447b187f590fe;

});

parcelRegister("e2x0y", function(module, exports) {

let $a38adb42723edd5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a38adb42723edd5b$var$load("1pxHe").then(()=>parcelRequire('1y3eu'));

});

parcelRegister("ia8Qs", function(module, exports) {

let $d3900597f25f55c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d3900597f25f55c0$var$load("3GBzS").then(()=>parcelRequire('ayPUe'));

});

parcelRegister("lH7GJ", function(module, exports) {
const $3241056149fc9c6f$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};
module.exports["Route"] = $3241056149fc9c6f$export$e7b0ac011bb776c6;

});

parcelRegister("11Zqj", function(module, exports) {

var $4u5NT = parcelRequire("4u5NT");


var $j4jXg = parcelRequire("j4jXg");


var $jGRlW = parcelRequire("jGRlW");


var $7RgFv = parcelRequire("7RgFv");




const $efcc8f2969c1a9e1$export$b0e12e7abb0bff11 = (data)=>{
    return data.type === (0, $j4jXg.BMEventsType).PAGE_LOAD;
};
const $efcc8f2969c1a9e1$export$83d0099ee6dbb5b0 = (data)=>{
    return data.type === (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $efcc8f2969c1a9e1$export$8672fa27ba8bba88 = (data)=>{
    return data.type === (0, $j4jXg.BMEventsType).PAGE_LOAD;
};
const $efcc8f2969c1a9e1$export$abe063537ef4987b = (data)=>{
    return data.type === (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $efcc8f2969c1a9e1$export$ae68674b6a9353be = (data)=>{
    return data.type === (0, $j4jXg.BMEventsType).INLINE_RESULT;
};
const $efcc8f2969c1a9e1$export$b493eb8b2ba87421 = (data)=>{
    return data.type === (0, $j4jXg.BMEventsType).CUSTOM;
};


const $424dc36f0807a928$export$e34e4529b979f74c = (_config, _data, globalConfig)=>{
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};


const $6e8b1c857eebec48$export$82ae485178b37419 = (_config, _data, globalConfig)=>{
    const pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};


const $70dbe12aa2dfd563$export$5cafa465fc876895 = ()=>{
    return {
        'bm:version': 3
    };
};


const $6e6463ef8e4e0e74$export$f7e743c7db162193 = (_config, data)=>{
    const custom = {};
    let changed = false;
    if (data.custom) Object.entries(data.custom).forEach(([key, value])=>{
        changed = true;
        custom[`custom:${key}`] = value;
    });
    return changed ? custom : null;
};


const $44a21ec37983890e$export$aed28df7ac07d79a = (config)=>{
    return {
        'event:id': config.key
    };
};



const $99dd6e3f6551d108$export$fa8e91d436b3ef8b = (_config, data)=>{
    if (!(0, $efcc8f2969c1a9e1$export$b0e12e7abb0bff11)(data) && !(0, $efcc8f2969c1a9e1$export$83d0099ee6dbb5b0)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};





const $80dc3af8237ab164$export$b334d07f11140768 = (type)=>{
    switch(type){
        case (0, $j4jXg.BMEventsType).CUSTOM:
            return (0, $j4jXg.StorableBMEventsType).CUSTOM;
        case (0, $j4jXg.BMEventsType).INLINE_RESULT:
            return (0, $j4jXg.StorableBMEventsType).INLINE_RESULT;
        case (0, $j4jXg.BMEventsType).PAGE_LOAD:
            return (0, $j4jXg.StorableBMEventsType).PAGE_LOAD;
        case (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $j4jXg.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $j4jXg.BMEventsType).WEB_VITALS:
            return (0, $j4jXg.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};


const $9e765cb34550f933$export$10be2d3a558d3f88 = (config, _data, globalConfig)=>{
    return {
        'event:key': `${globalConfig.product}.fe.${(0, $80dc3af8237ab164$export$b334d07f11140768)(config.type)}.${config.key}`
    };
};



var $dWCFT = parcelRequire("dWCFT");

const $80a17b6788fb547a$export$5219854ae7ec45da = ()=>({
        'event:localHour': parseInt((0, $dWCFT.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $dWCFT.default)(new Date(), 'i'), 10)
    });


const $2f0a4cde357a0769$export$a7df4e8088db8843 = (_config, _data, globalConfig)=>{
    return {
        'event:product': `${globalConfig.product}`
    };
};


const $35cb4ac3a690a03e$export$d0117b71adcdebc0 = (_config, _data, globalConfig)=>{
    return {
        'event:region': `${globalConfig.region}`
    };
};


const $910243865496e322$export$44d3627af289ca16 = (_config, data)=>{
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};



const $87a77fb0e31b1cc0$export$4c045e605d532c98 = (config)=>{
    return {
        'event:type': (0, $80dc3af8237ab164$export$b334d07f11140768)(config.type)
    };
};


const $04ff6b238051e023$export$e62953d023125748 = (config, _data, globalConfig)=>{
    const localFeatureFlags = config.featureFlags?.reduce((acc, ffName)=>{
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {}) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: {
            ...localFeatureFlags,
            ...globalConfig.featureFlags
        }
    };
};


const $50145cd0851d18bd$export$640106f6dc7d2706 = (_config, _data, globalConfig)=>{
    return {
        hostname: globalConfig.hostname
    };
};



const $b4ccb9ab041da62a$export$cab039265c52a2e9 = (config, data, globalConfig)=>{
    if (!(0, $efcc8f2969c1a9e1$export$b493eb8b2ba87421)(config)) return null;
    const payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (config.slo?.threshold !== undefined) {
        payload['metric:duration:slo'] = payload['metric:duration'] <= config.slo?.threshold;
        payload['metric:duration:slo:threshold'] = config.slo?.threshold;
    }
    if (config.histogram?.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};


const $ab2376fa3ea38ed7$export$cc95aa3f6ea8e5cb = ()=>{
    const metrics = {};
    performance.getEntriesByType('paint').forEach((entry)=>{
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};






const $671959ab64cde9bf$export$86db56030b57ba34 = (config, data, globalConfig)=>{
    if (!(0, $efcc8f2969c1a9e1$export$ae68674b6a9353be)(config)) return null;
    const result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if (config.histogram?.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $j4jXg.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $j4jXg.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if (config.histogram?.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $j4jXg.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            if (histogram.result !== undefined) result['metric:response:histogramBuckets'] = histogram[(0, $j4jXg.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $j4jXg.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};


const $e10e43a829a5023f$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};






const $0b776cd311b78b58$var$getThreshold = (isInitial, metric)=>{
    return (0, $j4jXg.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $0b776cd311b78b58$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $0b776cd311b78b58$export$2878bf482e539059 = (config, data, globalConfig)=>{
    if (!(0, $efcc8f2969c1a9e1$export$8672fa27ba8bba88)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    const fmp = data.marks[(0, $j4jXg.BMPageLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $0b776cd311b78b58$var$getHistogram(data.isInitial, (0, $j4jXg.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $0b776cd311b78b58$var$getHistogram(data.isInitial, (0, $j4jXg.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $0b776cd311b78b58$var$getHistogram(data.isInitial, (0, $j4jXg.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $0b776cd311b78b58$var$getHistogram(data.isInitial, (0, $j4jXg.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        const threshold = $0b776cd311b78b58$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        const threshold = $0b776cd311b78b58$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    return result;
};



var $69Zr8 = parcelRequire("69Zr8");





const $22ff91b9f30764a0$var$getThreshold = (isInitial, metric)=>{
    return (0, $j4jXg.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $22ff91b9f30764a0$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $22ff91b9f30764a0$export$ba86cb47f2f22db5 = (config, data, globalConfig)=>{
    if (!(0, $efcc8f2969c1a9e1$export$abe063537ef4987b)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    const fmp = data.marks[(0, $j4jXg.BMPageSegmentLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $22ff91b9f30764a0$var$getHistogram(data.isInitial, (0, $j4jXg.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $22ff91b9f30764a0$var$getHistogram(data.isInitial, (0, $j4jXg.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $22ff91b9f30764a0$var$getHistogram(data.isInitial, (0, $j4jXg.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $22ff91b9f30764a0$var$getHistogram(data.isInitial, (0, $j4jXg.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if (config.slo?.fmp) {
        const threshold = $22ff91b9f30764a0$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo?.tti) {
        const threshold = $22ff91b9f30764a0$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    if (config.includePageLoadTimings === (0, $j4jXg.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        const fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $j4jXg.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        const tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: fmp,
            tti: tti
        };
    }
    return result;
};



var $4k3LC = parcelRequire("4k3LC");


var $2BcbG = parcelRequire("2BcbG");


var $c1uRl = parcelRequire("c1uRl");






const $6b008d45a834dab9$export$177b923114656380 = (_config, data, globalConfig)=>{
    const value = globalConfig.pageVisibleValueOrigin === (0, $j4jXg.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $4k3LC.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};


const $7ec2d928c9c84cee$export$3731db279f590f30 = async (config, data, globalConfig)=>{
    let pageVisibleState = data.pageVisibleState;
    const setPageVisibleStateToMixed = ()=>{
        pageVisibleState = (0, $4k3LC.PageVisibleState).MIXED;
    };
    (0, $2BcbG.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
    const ttciEnabled = globalConfig.webVitals?.ttciEnabled !== undefined ? globalConfig.webVitals?.ttciEnabled : true;
    const webVitalMetrics = await $7ec2d928c9c84cee$export$193ae490b52081dd(ttciEnabled, globalConfig.webVitals?.timeout || 30000);
    (0, $2BcbG.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
    return {
        ...webVitalMetrics,
        'pageVisible:state': pageVisibleState,
        ...(0, $6b008d45a834dab9$export$177b923114656380)(config, data, globalConfig)
    };
};
const $7ec2d928c9c84cee$export$193ae490b52081dd = async (ttciEnabled, timeout)=>{
    // wait for webVitalsObserver.ttciDetermined if ttciEnabled is true
    await (ttciEnabled ? (0, $c1uRl.webVitalsObserver).ttciDetermined : Promise.resolve());
    // wait up to $timeout ms longer for web-vitals until returning
    const timeoutWindow = new Promise((resolve)=>setTimeout(resolve, timeout));
    await Promise.race([
        timeoutWindow,
        (0, $c1uRl.webVitalsObserver).webVitalsDetermined
    ]);
    return (0, $c1uRl.webVitalsObserver).data;
};


const $15e782691c8a124e$export$723b4c298aca63af = (_config, data)=>{
    return {
        'pageVisible:state': data.pageVisibleState
    };
};



const $15388c422c57c113$export$fa2af6e412815a74 = async (_config, data, globalConfig)=>{
    if (!globalConfig.custom && !globalConfig.plugins) return null;
    const result = {};
    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(([key, value])=>{
        result[`${globalConfig.product}:${key}`] = value;
    });
    if (globalConfig.plugins) {
        const pluginOutputs = await Promise.all(globalConfig.plugins.map((plugin)=>plugin({
                start: data.start,
                stop: data.stop,
                key: data.key
            })));
        pluginOutputs.forEach((pluginOutput)=>{
            if (pluginOutput === null) return;
            Object.entries(pluginOutput).forEach(([key, value])=>{
                result[`${globalConfig.product}:${key}`] = value;
            });
        });
    }
    return result;
};





const $280e5be904f73614$var$retrieveFeatureFlags = async (getFeatureFlags)=>{
    try {
        const featureFlags = await getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};
const $280e5be904f73614$export$fdbea518c19dfa8 = async (config, _data, globalConfig)=>{
    // no config or missing
    if (!globalConfig.ssr?.getFeatureFlags) return null;
    const includeFeatureFlags = config.ssr?.includeFeatureFlags || globalConfig.ssr?.includeFeatureFlags || (0, $j4jXg.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
    if (includeFeatureFlags === (0, $j4jXg.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || config.ssr?.doneAsFmp && includeFeatureFlags === (0, $j4jXg.IncludeSSRFeatureFlagsConfig).WHEN_FMP) return await $280e5be904f73614$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
    return null;
};


const $ab47fb9471ac947b$export$a3dc8251cf55b2e0 = (config, _data, globalConfig)=>{
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};



var $uxMYQ = parcelRequire("uxMYQ");

const $f09d583c5e93983f$export$386b10ac64a50b1 = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($uxMYQ))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($uxMYQ))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};


const $1159930910719782$export$9f84cb359ed29139 = ()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};


const $4c8b1c6ed30d2c96$export$496c14d72b257e07 = ()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};


const $7a6e7161ff6869e1$export$88bf7b55f7fc4e8e = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};





const $53fd409e91f6c97b$export$b98e411ae80c806f = '/';


const $ff3b864a7caa86f4$var$retrieveTimings = (config, data, relativeTo = 0, prefix = '')=>{
    const configTimings = config.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        const startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        const duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries[`${prefix}${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $ff3b864a7caa86f4$export$6126f85083a72c6e = (config, data)=>{
    if (!config.timings && data.submetrics.length === 0) return null;
    const timings = $ff3b864a7caa86f4$var$retrieveTimings(config, data);
    data.submetrics.forEach((submetric)=>{
        if (submetric.start !== null && submetric.stop !== null) {
            const submetricPrefix = `include:${submetric.config.key}`;
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $ff3b864a7caa86f4$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $53fd409e91f6c97b$export$b98e411ae80c806f)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};



const $98616be5571fa4a4$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $98616be5571fa4a4$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $98616be5571fa4a4$var$SSR_PREFIX = 'ssr';
const $98616be5571fa4a4$var$mapKey = (key)=>{
    if (key === 'total') return $98616be5571fa4a4$var$SSR_PREFIX;
    return `${$98616be5571fa4a4$var$SSR_PREFIX}${0, $53fd409e91f6c97b$export$b98e411ae80c806f}${key}`;
};
const $98616be5571fa4a4$export$130f411261a599c5 = (_config, _data, globalConfig)=>{
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    const timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($98616be5571fa4a4$var$filterEntry(entry[1])) acc[$98616be5571fa4a4$var$mapKey(entry[0])] = $98616be5571fa4a4$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};


const $d50599dd2bf33f2d$export$e952f50a4f2d02da = (config, data, globalConfig)=>{
    const explicitTimings = config.type === (0, $j4jXg.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    const timings = (0, $ff3b864a7caa86f4$export$6126f85083a72c6e)(config, data);
    const ssr = config.type === (0, $j4jXg.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $98616be5571fa4a4$export$130f411261a599c5)(config, data, globalConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};


const $cc11d350e6fa37d7$var$bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance)=>{
    const started = {};
    const timings = {};
    const enableBundleEvalTimings = globalConfig?.enableBundleEvalTimings ?? true;
    performance.getEntriesByType('mark').forEach((mark)=>{
        if (!globalConfig.bundleEvalTimings) return;
        const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
const $cc11d350e6fa37d7$export$1a2bb347935fc536 = (...args)=>{
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve($cc11d350e6fa37d7$var$bundleEvalTimingsInternal(...args));
        });
    });
};


const $6df3a42a4d7960d4$var$cacheableTypes = [
    'script',
    'link'
];
const $6df3a42a4d7960d4$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $6df3a42a4d7960d4$var$CACHE_NETWORK = 'network';
const $6df3a42a4d7960d4$var$CACHE_MEMORY = 'memory';
const $6df3a42a4d7960d4$var$CACHE_DISK = 'disk';
const $6df3a42a4d7960d4$var$calculateTransferType = (type, duration, size)=>{
    if (!$6df3a42a4d7960d4$var$cacheableTypes.includes(type)) return $6df3a42a4d7960d4$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $6df3a42a4d7960d4$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $6df3a42a4d7960d4$var$CACHE_DISK;
    if (size === undefined) return null;
    return $6df3a42a4d7960d4$var$CACHE_NETWORK;
};
const $6df3a42a4d7960d4$var$hasAccessToResourceSize = (url, type, hasTimingHeaders)=>{
    return !$6df3a42a4d7960d4$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
const $6df3a42a4d7960d4$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $6df3a42a4d7960d4$var$withoutHeaders = ()=>false;
const $6df3a42a4d7960d4$var$evaluateAccessToResourceTimings = (entry)=>{
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
const $6df3a42a4d7960d4$var$getEvaluatedTimingHeader = (entry, enabled = false, hasTimingHeaders = $6df3a42a4d7960d4$var$withoutHeaders)=>{
    if (!enabled) return null;
    const manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    const autoResolution = $6df3a42a4d7960d4$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
const $6df3a42a4d7960d4$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $6df3a42a4d7960d4$var$getNetworkData = (item, eventStart, hasTimingHeaders = $6df3a42a4d7960d4$var$withoutHeaders)=>{
    const { name: name, duration: duration, transferSize: size, initiatorType: type, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$6df3a42a4d7960d4$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($6df3a42a4d7960d4$var$cacheableTypes.includes(type)) {
        const transferType = $6df3a42a4d7960d4$var$calculateTransferType(type, duration, size);
        if (!transferType) return {
            ttfb: ttfb,
            ...$6df3a42a4d7960d4$var$getSizeObject(size)
        };
        if (transferType !== $6df3a42a4d7960d4$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$6df3a42a4d7960d4$var$getSizeObject(size)
        };
    }
    return {
        ttfb: ttfb,
        ...$6df3a42a4d7960d4$var$getSizeObject(size)
    };
};
const $6df3a42a4d7960d4$export$81a7d52441a06b50 = (_config, data, globalConfig, performance = window.performance)=>{
    if (data.start === null) return null;
    const resources = performance.getEntriesByType('resource').filter((entry)=>entry.startTime >= data.start);
    if (!resources.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = globalConfig.resourceTimings;
    const reportedInitiatorTypes = $6df3a42a4d7960d4$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: type } = item;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $6df3a42a4d7960d4$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type,
            ...$6df3a42a4d7960d4$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders),
            ...$6df3a42a4d7960d4$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};





const $e006c4b0ad00daa3$var$defaultSet = [
    (0, $9e765cb34550f933$export$10be2d3a558d3f88),
    (0, $87a77fb0e31b1cc0$export$4c045e605d532c98),
    (0, $2f0a4cde357a0769$export$a7df4e8088db8843),
    (0, $910243865496e322$export$44d3627af289ca16),
    (0, $44a21ec37983890e$export$aed28df7ac07d79a),
    (0, $80a17b6788fb547a$export$5219854ae7ec45da),
    (0, $35cb4ac3a690a03e$export$d0117b71adcdebc0),
    (0, $424dc36f0807a928$export$e34e4529b979f74c),
    (0, $6e8b1c857eebec48$export$82ae485178b37419),
    (0, $70dbe12aa2dfd563$export$5cafa465fc876895),
    (0, $f09d583c5e93983f$export$386b10ac64a50b1),
    (0, $1159930910719782$export$9f84cb359ed29139),
    (0, $4c8b1c6ed30d2c96$export$496c14d72b257e07),
    (0, $7a6e7161ff6869e1$export$88bf7b55f7fc4e8e),
    (0, $6e6463ef8e4e0e74$export$f7e743c7db162193),
    (0, $04ff6b238051e023$export$e62953d023125748),
    (0, $50145cd0851d18bd$export$640106f6dc7d2706),
    (0, $15388c422c57c113$export$fa2af6e412815a74),
    (0, $d50599dd2bf33f2d$export$e952f50a4f2d02da),
    (0, $6df3a42a4d7960d4$export$81a7d52441a06b50)
];
const $e006c4b0ad00daa3$var$pageLoadCommon = [
    ...$e006c4b0ad00daa3$var$defaultSet,
    (0, $15e782691c8a124e$export$723b4c298aca63af),
    (0, $6b008d45a834dab9$export$177b923114656380),
    (0, $99dd6e3f6551d108$export$fa8e91d436b3ef8b),
    (0, $0b776cd311b78b58$export$2878bf482e539059),
    (0, $cc11d350e6fa37d7$export$1a2bb347935fc536)
];
const $e006c4b0ad00daa3$var$initialPageLoadSet = [
    ...$e006c4b0ad00daa3$var$pageLoadCommon,
    (0, $ab2376fa3ea38ed7$export$cc95aa3f6ea8e5cb),
    (0, $e10e43a829a5023f$export$b88d990436be0f8a),
    (0, $ab47fb9471ac947b$export$a3dc8251cf55b2e0),
    (0, $280e5be904f73614$export$fdbea518c19dfa8)
];
const $e006c4b0ad00daa3$var$spaTransitionSet = [
    ...$e006c4b0ad00daa3$var$pageLoadCommon
];
const $e006c4b0ad00daa3$var$pageSegmentLoadSet = [
    ...$e006c4b0ad00daa3$var$defaultSet,
    (0, $22ff91b9f30764a0$export$ba86cb47f2f22db5),
    (0, $15e782691c8a124e$export$723b4c298aca63af),
    (0, $6b008d45a834dab9$export$177b923114656380),
    (0, $99dd6e3f6551d108$export$fa8e91d436b3ef8b),
    (0, $cc11d350e6fa37d7$export$1a2bb347935fc536)
];
const $e006c4b0ad00daa3$var$interactionSet = [
    ...$e006c4b0ad00daa3$var$defaultSet,
    (0, $15e782691c8a124e$export$723b4c298aca63af),
    (0, $6b008d45a834dab9$export$177b923114656380),
    (0, $671959ab64cde9bf$export$86db56030b57ba34)
];
const $e006c4b0ad00daa3$var$customMetricSet = [
    ...$e006c4b0ad00daa3$var$defaultSet,
    (0, $15e782691c8a124e$export$723b4c298aca63af),
    (0, $6b008d45a834dab9$export$177b923114656380),
    (0, $b4ccb9ab041da62a$export$cab039265c52a2e9)
];
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
const $e006c4b0ad00daa3$var$webVitalsMetricSet = [
    ...$e006c4b0ad00daa3$var$defaultSet,
    (0, $7ec2d928c9c84cee$export$3731db279f590f30)
];
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
const $e006c4b0ad00daa3$var$waitForCLS = (delay = (0, $jGRlW.clsWaitTimeMs) + 500)=>{
    return new Promise((resolve)=>setTimeout(resolve, delay));
};
const $e006c4b0ad00daa3$export$896b6e121bbaec25 = async (globalConfig, data)=>{
    if (data.start === null || data.stop === null) {
        (0, $7RgFv.logger).log(`eventDataProcessor: Metric "${data.key}" start or stop are incorrect; start: ${data.start}; stop: ${data.stop}`);
        return null;
    }
    let set = [];
    if (data.config.type === (0, $j4jXg.BMEventsType).PAGE_LOAD && (0, $efcc8f2969c1a9e1$export$b0e12e7abb0bff11)(data) && data.isInitial) set = $e006c4b0ad00daa3$var$initialPageLoadSet;
    if (data.config.type === (0, $j4jXg.BMEventsType).PAGE_LOAD && (0, $efcc8f2969c1a9e1$export$b0e12e7abb0bff11)(data) && !data.isInitial) set = $e006c4b0ad00daa3$var$spaTransitionSet;
    if (data.config.type === (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD && (0, $efcc8f2969c1a9e1$export$83d0099ee6dbb5b0)(data)) set = $e006c4b0ad00daa3$var$pageSegmentLoadSet;
    if (data.config.type === (0, $j4jXg.BMEventsType).INLINE_RESULT) set = $e006c4b0ad00daa3$var$interactionSet;
    if (data.config.type === (0, $j4jXg.BMEventsType).CUSTOM) set = $e006c4b0ad00daa3$var$customMetricSet;
    if (data.config.type === (0, $j4jXg.BMEventsType).WEB_VITALS) {
        set = $e006c4b0ad00daa3$var$webVitalsMetricSet;
        // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
        await $e006c4b0ad00daa3$var$waitForCLS();
    }
    //TODO if type is different - do not send at all
    const plugins = [];
    for (const plugin of set){
        const result = await plugin(data.config, data, globalConfig);
        if (result) plugins.push(result);
    }
    const pluginResults = await Promise.all(plugins);
    const generated = {};
    pluginResults.forEach((pluginResult)=>{
        if (pluginResult === null) return;
        Object.keys(pluginResult).forEach((key)=>{
            const keyResult = pluginResult[key];
            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
        });
    });
    return generated;
};





const $eb97406c20d3bb4c$var$makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags)=>{
    const featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push(...allFeatureFlags);
    if (eventTypeFeatureFlags) featureFlagsForType.push(...eventTypeFeatureFlags);
    return featureFlagsForType;
};
const $eb97406c20d3bb4c$var$makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig)=>{
    const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    const eventConfigCustom = eventConfig && eventConfig.custom;
    const custom = (allEventsConfigCustom || eventConfigCustom) && {
        ...allEventsConfigCustom,
        ...eventConfigCustom
    } || undefined;
    const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    const eventConfigPlugins = eventConfig && eventConfig.plugins;
    const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [
        ...allEventsConfigPlugins || [],
        ...eventConfigPlugins || []
    ] || undefined;
    const pageVisibleValueOrigin = eventConfig?.pageVisibleValueOrigin ?? allEventsConfig?.pageVisibleValueOrigin ?? (0, $j4jXg.PageVisibleValueOrigin).documentHidden;
    return Object.freeze({
        ...global,
        featureFlags: Object.freeze($eb97406c20d3bb4c$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value)=>{
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig?.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig?.enableBundleEvalTimings
    });
};
const $eb97406c20d3bb4c$export$5b4fb14409a2a825 = async (globalConfig)=>{
    const ffClient = await globalConfig.plugins.featureFlags.client;
    const global = {
        app: globalConfig.info.app,
        product: globalConfig.info.product,
        region: globalConfig.info.region,
        resourceTimings: globalConfig.plugins.resourceTimings,
        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
        ffClient: ffClient,
        hostname: globalConfig.info.hostname || window.location.hostname,
        ssr: globalConfig.ssr,
        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
        webVitals: {
            enabled: globalConfig.events[(0, $j4jXg.BMEventsType).WEB_VITALS]?.enabled,
            timeout: globalConfig.events[(0, $j4jXg.BMEventsType).WEB_VITALS]?.timeout,
            ttciEnabled: globalConfig.events[(0, $j4jXg.BMEventsType).WEB_VITALS]?.ttciEnabled
        }
    };
    return {
        [(0, $j4jXg.BMEventsType).PAGE_LOAD]: $eb97406c20d3bb4c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $j4jXg.BMEventsType).PAGE_LOAD]),
        [(0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD]: $eb97406c20d3bb4c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD]),
        [(0, $j4jXg.BMEventsType).INLINE_RESULT]: $eb97406c20d3bb4c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $j4jXg.BMEventsType).INLINE_RESULT]),
        [(0, $j4jXg.BMEventsType).CUSTOM]: $eb97406c20d3bb4c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $j4jXg.BMEventsType).CUSTOM]),
        [(0, $j4jXg.BMEventsType).WEB_VITALS]: $eb97406c20d3bb4c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $j4jXg.BMEventsType).WEB_VITALS])
    };
};


const $8505cab7e2dd39df$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure (config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $eb97406c20d3bb4c$export$5b4fb14409a2a825)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $j4jXg.PageVisibleFields).pageVisibleState;
    },
    setDebug (debug) {
        this.debug = debug;
    },
    async queue (data) {
        if (this.config.enableReactUFOTracker) (0, $4u5NT.addBrowserMetricEvent)(data);
        if (!this.config.configChunk) {
            // eslint-disable-next-line no-console
            this.debug && console.warn('Submitter is not configured');
            return null;
        }
        const chunk = await this.config.configChunk;
        const payload = await (0, $e006c4b0ad00daa3$export$896b6e121bbaec25)(chunk[data.config.type], data);
        if (payload === null) return;
        if (this.config.gasv3 !== undefined) {
            const client = await this.config.gasv3;
            const attributes = {
                task: payload['event:key'],
                properties: payload
            };
            client && client.sendOperationalEvent({
                actionSubject: 'performance',
                attributes: attributes,
                source: 'performance',
                action: 'measured'
            });
        }
        return;
    }
};
module.exports["submitter"] = $8505cab7e2dd39df$export$c21a25872e3f5a2b;

});

parcelRegister("dWCFT", function(module, exports) {
$parcel$export(module.exports, "default", () => $a26eb12161113ff6$export$2e2bcd8739ae039);

var $cFEpk = parcelRequire("cFEpk");


var $f5SRR = parcelRequire("f5SRR");


var $egXhZ = parcelRequire("egXhZ");





var $b5utg = parcelRequire("b5utg");

var $abd4f978374b79e2$var$MILLISECONDS_IN_DAY = 86400000;
function $abd4f978374b79e2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $abd4f978374b79e2$var$MILLISECONDS_IN_DAY) + 1;
}



var $8mXz6 = parcelRequire("8mXz6");


var $1SHEm = parcelRequire("1SHEm");


var $ld8ZT = parcelRequire("ld8ZT");


var $40Dd9 = parcelRequire("40Dd9");


var $dWysp = parcelRequire("dWysp");




/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $52e3158998a11065$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $dWysp.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $dWysp.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $dWysp.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $dWysp.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $dWysp.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $dWysp.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $dWysp.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $dWysp.default)(fractionalSeconds, token.length);
    }
};
var $52e3158998a11065$export$2e2bcd8739ae039 = $52e3158998a11065$var$formatters;


var $4cac5e53f4f4843f$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $4cac5e53f4f4843f$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $52e3158998a11065$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $40Dd9.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $dWysp.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $dWysp.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $1SHEm.default)(date);
        // Padding
        return (0, $dWysp.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $dWysp.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $dWysp.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $dWysp.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $52e3158998a11065$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $dWysp.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $ld8ZT.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $dWysp.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $8mXz6.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $dWysp.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $52e3158998a11065$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $abd4f978374b79e2$export$2e2bcd8739ae039)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $dWysp.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $dWysp.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $dWysp.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $dWysp.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $4cac5e53f4f4843f$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $4cac5e53f4f4843f$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $4cac5e53f4f4843f$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $4cac5e53f4f4843f$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $4cac5e53f4f4843f$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $4cac5e53f4f4843f$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $52e3158998a11065$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $52e3158998a11065$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $dWysp.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $dWysp.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $52e3158998a11065$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $52e3158998a11065$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $52e3158998a11065$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $4cac5e53f4f4843f$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $4cac5e53f4f4843f$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $4cac5e53f4f4843f$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $4cac5e53f4f4843f$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $4cac5e53f4f4843f$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $4cac5e53f4f4843f$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $4cac5e53f4f4843f$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $4cac5e53f4f4843f$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $4cac5e53f4f4843f$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $4cac5e53f4f4843f$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $dWysp.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $dWysp.default)(timestamp, token.length);
    }
};
function $4cac5e53f4f4843f$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $dWysp.default)(minutes, 2);
}
function $4cac5e53f4f4843f$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $dWysp.default)(Math.abs(offset) / 60, 2);
    }
    return $4cac5e53f4f4843f$var$formatTimezone(offset, dirtyDelimiter);
}
function $4cac5e53f4f4843f$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $dWysp.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $dWysp.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $4cac5e53f4f4843f$export$2e2bcd8739ae039 = $4cac5e53f4f4843f$var$formatters;



var $1tT8e = parcelRequire("1tT8e");


var $qc9ak = parcelRequire("qc9ak");


var $671gj = parcelRequire("671gj");


var $jZ39j = parcelRequire("jZ39j");





var $2h3f7 = parcelRequire("2h3f7");


var $g3Gzi = parcelRequire("g3Gzi");

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $a26eb12161113ff6$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $a26eb12161113ff6$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $a26eb12161113ff6$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $a26eb12161113ff6$var$doubleQuoteRegExp = /''/g;
var $a26eb12161113ff6$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $a26eb12161113ff6$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $b5utg.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $g3Gzi.default);
    var firstWeekContainsDate = (0, $jZ39j.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $jZ39j.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $egXhZ.default)(dirtyDate);
    if (!(0, $cFEpk.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $qc9ak.default)(originalDate);
    var utcDate = (0, $f5SRR.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($a26eb12161113ff6$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $1tT8e.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($a26eb12161113ff6$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $a26eb12161113ff6$var$cleanEscapedString(substring);
        var formatter = (0, $4cac5e53f4f4843f$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $671gj.isProtectedWeekYearToken)(substring)) (0, $671gj.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $671gj.isProtectedDayOfYearToken)(substring)) (0, $671gj.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($a26eb12161113ff6$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $a26eb12161113ff6$var$cleanEscapedString(input) {
    var matched = input.match($a26eb12161113ff6$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($a26eb12161113ff6$var$doubleQuoteRegExp, "'");
}

});

parcelRegister("cFEpk", function(module, exports) {
$parcel$export(module.exports, "default", () => $9398a87630e50e54$export$2e2bcd8739ae039);

var $da6O1 = parcelRequire("da6O1");


var $b5utg = parcelRequire("b5utg");

function $04277d24b6269171$export$2e2bcd8739ae039(value) {
    (0, $b5utg.default)(1, arguments);
    return value instanceof Date || (0, $da6O1.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}



var $egXhZ = parcelRequire("egXhZ");




function $9398a87630e50e54$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    if (!(0, $04277d24b6269171$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $egXhZ.default)(dirtyDate);
    return !isNaN(Number(date));
}

});

parcelRegister("f5SRR", function(module, exports) {
$parcel$export(module.exports, "default", () => $afd1e238bf904de2$export$2e2bcd8739ae039);

var $lshox = parcelRequire("lshox");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $afd1e238bf904de2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $lshox.default)(dirtyDate, -amount);
}

});

parcelRegister("lshox", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9e9b4bebeab4183$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $f9e9b4bebeab4183$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var timestamp = (0, $egXhZ.default)(dirtyDate).getTime();
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});

parcelRegister("jZ39j", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8c628341edb3956$export$2e2bcd8739ae039);
function $e8c628341edb3956$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});

parcelRegister("8mXz6", function(module, exports) {
$parcel$export(module.exports, "default", () => $617e953928f1cd28$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $3QScg = parcelRequire("3QScg");


var $1SHEm = parcelRequire("1SHEm");





var $b5utg = parcelRequire("b5utg");

function $a73c9798e6fc14c5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var year = (0, $1SHEm.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $3QScg.default)(fourthOfJanuary);
    return date;
}





var $617e953928f1cd28$var$MILLISECONDS_IN_WEEK = 604800000;
function $617e953928f1cd28$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var diff = (0, $3QScg.default)(date).getTime() - (0, $a73c9798e6fc14c5$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $617e953928f1cd28$var$MILLISECONDS_IN_WEEK) + 1;
}

});

parcelRegister("3QScg", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ce044c65b4ccc72$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $2ce044c65b4ccc72$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("ld8ZT", function(module, exports) {
$parcel$export(module.exports, "default", () => $f711ca8863d92ffa$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $d1KG5 = parcelRequire("d1KG5");


var $40Dd9 = parcelRequire("40Dd9");


var $b5utg = parcelRequire("b5utg");





var $jZ39j = parcelRequire("jZ39j");


var $2h3f7 = parcelRequire("2h3f7");

function $1178fa32d4bfd400$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b5utg.default)(1, arguments);
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var firstWeekContainsDate = (0, $jZ39j.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $40Dd9.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $d1KG5.default)(firstWeek, options);
    return date;
}





var $f711ca8863d92ffa$var$MILLISECONDS_IN_WEEK = 604800000;
function $f711ca8863d92ffa$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var diff = (0, $d1KG5.default)(date, options).getTime() - (0, $1178fa32d4bfd400$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $f711ca8863d92ffa$var$MILLISECONDS_IN_WEEK) + 1;
}

});

parcelRegister("d1KG5", function(module, exports) {
$parcel$export(module.exports, "default", () => $97bf939b0219c41f$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");


var $2h3f7 = parcelRequire("2h3f7");

function $97bf939b0219c41f$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b5utg.default)(1, arguments);
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var weekStartsOn = (0, $jZ39j.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("2h3f7", function(module, exports) {
var $1a7faf3fa4635cd9$var$defaultOptions = {};
function $1a7faf3fa4635cd9$export$430a3269e24b912e() {
    return $1a7faf3fa4635cd9$var$defaultOptions;
}
function $1a7faf3fa4635cd9$export$95365be1b0704abc(newOptions) {
    $1a7faf3fa4635cd9$var$defaultOptions = newOptions;
}
module.exports["getDefaultOptions"] = $1a7faf3fa4635cd9$export$430a3269e24b912e;

});

parcelRegister("40Dd9", function(module, exports) {
$parcel$export(module.exports, "default", () => $2eb5940b79911365$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");


var $d1KG5 = parcelRequire("d1KG5");


var $jZ39j = parcelRequire("jZ39j");


var $2h3f7 = parcelRequire("2h3f7");

function $2eb5940b79911365$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var firstWeekContainsDate = (0, $jZ39j.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $d1KG5.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $d1KG5.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});

parcelRegister("dWysp", function(module, exports) {
$parcel$export(module.exports, "default", () => $a26b6b9cf30af8c3$export$2e2bcd8739ae039);
function $a26b6b9cf30af8c3$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("1tT8e", function(module, exports) {
var $114343e5c54a08d5$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $114343e5c54a08d5$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $114343e5c54a08d5$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $114343e5c54a08d5$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $114343e5c54a08d5$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $114343e5c54a08d5$var$timeLongFormatter(timePattern, formatLong));
};
var $114343e5c54a08d5$var$longFormatters = {
    p: $114343e5c54a08d5$var$timeLongFormatter,
    P: $114343e5c54a08d5$var$dateTimeLongFormatter
};
var $114343e5c54a08d5$export$2e2bcd8739ae039 = $114343e5c54a08d5$var$longFormatters;
module.exports["default"] = $114343e5c54a08d5$export$2e2bcd8739ae039;

});

parcelRegister("671gj", function(module, exports) {
var $473460292dd1cd07$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $473460292dd1cd07$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $473460292dd1cd07$export$c6cc36aa33304772(token) {
    return $473460292dd1cd07$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $473460292dd1cd07$export$c6b49d6dceb604a1(token) {
    return $473460292dd1cd07$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $473460292dd1cd07$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
module.exports["isProtectedDayOfYearToken"] = $473460292dd1cd07$export$c6cc36aa33304772;
module.exports["isProtectedWeekYearToken"] = $473460292dd1cd07$export$c6b49d6dceb604a1;
module.exports["throwProtectedError"] = $473460292dd1cd07$export$8073c1ae88f0e727;

});

parcelRegister("g3Gzi", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb0df251b2526fe7$export$2e2bcd8739ae039);

var $9gbhg = parcelRequire("9gbhg");

var $bb0df251b2526fe7$export$2e2bcd8739ae039 = (0, $9gbhg.default);

});

parcelRegister("9gbhg", function(module, exports) {

var $hnQFw = parcelRequire("hnQFw");


var $ke66V = parcelRequire("ke66V");

var $0f2b55a6095aeb55$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $0f2b55a6095aeb55$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $0f2b55a6095aeb55$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $0f2b55a6095aeb55$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $0f2b55a6095aeb55$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $0f2b55a6095aeb55$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $0f2b55a6095aeb55$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $0f2b55a6095aeb55$export$2e2bcd8739ae039 = $0f2b55a6095aeb55$var$formatLong;



var $jdGf6 = parcelRequire("jdGf6");


var $7Aaku = parcelRequire("7Aaku");


var $afCHX = parcelRequire("afCHX");

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $6bde5b2559d48331$var$locale = {
    code: 'en-US',
    formatDistance: (0, $hnQFw.default),
    formatLong: (0, $0f2b55a6095aeb55$export$2e2bcd8739ae039),
    formatRelative: (0, $jdGf6.default),
    localize: (0, $7Aaku.default),
    match: (0, $afCHX.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $6bde5b2559d48331$export$2e2bcd8739ae039 = $6bde5b2559d48331$var$locale;
module.exports["default"] = $6bde5b2559d48331$export$2e2bcd8739ae039;

});

parcelRegister("hnQFw", function(module, exports) {
var $ca7d708ae70d76d1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $ca7d708ae70d76d1$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ca7d708ae70d76d1$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $ca7d708ae70d76d1$export$2e2bcd8739ae039 = $ca7d708ae70d76d1$var$formatDistance;
module.exports["default"] = $ca7d708ae70d76d1$export$2e2bcd8739ae039;

});

parcelRegister("ke66V", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb99dae93d9983e7$export$2e2bcd8739ae039);
function $eb99dae93d9983e7$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});

parcelRegister("jdGf6", function(module, exports) {
var $dfdfffb2765e4eb3$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $dfdfffb2765e4eb3$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $dfdfffb2765e4eb3$var$formatRelativeLocale[token];
};
var $dfdfffb2765e4eb3$export$2e2bcd8739ae039 = $dfdfffb2765e4eb3$var$formatRelative;
module.exports["default"] = $dfdfffb2765e4eb3$export$2e2bcd8739ae039;

});

parcelRegister("7Aaku", function(module, exports) {

var $lo4TZ = parcelRequire("lo4TZ");

var $5853e8645f8ee8c8$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $5853e8645f8ee8c8$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $5853e8645f8ee8c8$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $5853e8645f8ee8c8$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $5853e8645f8ee8c8$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $5853e8645f8ee8c8$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $5853e8645f8ee8c8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $5853e8645f8ee8c8$var$localize = {
    ordinalNumber: $5853e8645f8ee8c8$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $5853e8645f8ee8c8$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $5853e8645f8ee8c8$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $5853e8645f8ee8c8$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $5853e8645f8ee8c8$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $5853e8645f8ee8c8$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $5853e8645f8ee8c8$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $5853e8645f8ee8c8$export$2e2bcd8739ae039 = $5853e8645f8ee8c8$var$localize;
module.exports["default"] = $5853e8645f8ee8c8$export$2e2bcd8739ae039;

});

parcelRegister("lo4TZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f91fa44d6fff5f0e$export$2e2bcd8739ae039);
function $f91fa44d6fff5f0e$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});

parcelRegister("afCHX", function(module, exports) {

var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $776954b0a744a496$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $776954b0a744a496$var$parseOrdinalNumberPattern = /\d+/i;
var $776954b0a744a496$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $776954b0a744a496$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $776954b0a744a496$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $776954b0a744a496$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $776954b0a744a496$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $776954b0a744a496$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $776954b0a744a496$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $776954b0a744a496$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $776954b0a744a496$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $776954b0a744a496$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $776954b0a744a496$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $776954b0a744a496$var$matchOrdinalNumberPattern,
        parsePattern: $776954b0a744a496$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $776954b0a744a496$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $776954b0a744a496$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $776954b0a744a496$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $776954b0a744a496$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $776954b0a744a496$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $776954b0a744a496$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $776954b0a744a496$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $776954b0a744a496$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $776954b0a744a496$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $776954b0a744a496$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $776954b0a744a496$export$2e2bcd8739ae039 = $776954b0a744a496$var$match;
module.exports["default"] = $776954b0a744a496$export$2e2bcd8739ae039;

});

parcelRegister("jLTD6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e64d8efe5b838ba8$export$2e2bcd8739ae039);
function $e64d8efe5b838ba8$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $e64d8efe5b838ba8$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $e64d8efe5b838ba8$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $e64d8efe5b838ba8$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $e64d8efe5b838ba8$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("aqoqo", function(module, exports) {
$parcel$export(module.exports, "default", () => $796f4751fc0da33b$export$2e2bcd8739ae039);
function $796f4751fc0da33b$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});

parcelRegister("6vg9V", function(module, exports) {

var $eSuZj = parcelRequire("eSuZj");


var $6X8o4 = parcelRequire("6X8o4");

let $45686ac01c9cf60d$var$provideClient;
const $45686ac01c9cf60d$var$metalClientPromise = (0, $6X8o4.liftPromiseState)(new Promise((resolve)=>{
    $45686ac01c9cf60d$var$provideClient = resolve;
}));

const $45686ac01c9cf60d$export$3a42ebcb7c12336a = ({ environment: environment, synthetic: synthetic })=>{
    Promise.all([
        (parcelRequire("h8Cm2"))
    ]).then(([MetalClientModule])=>{
        const { default: MetalClient, envTypes: envTypes } = MetalClientModule;
        const metalEnvironment = // In dev, proxying to a site will give that site's environment,
        // which is not what we want
        window.location.hostname === 'localhost' ? envTypes.DEV : environment === 'STAGING' ? envTypes.STAGING : environment === 'PRODUCTION' ? envTypes.PROD : envTypes.DEV;
        const productInfo = {
            metalId: '88dcca98-e854-4063-954c-eabe3aeb25d2',
            version: (0, $eSuZj.getBuildInfo)().FRONTEND_VERSION,
            env: metalEnvironment
        };
        const settings = {
            meta: {
                synthetic: synthetic
            }
        };
        const metalClient = new MetalClient({
            productInfo: productInfo,
            settings: settings
        });
        $45686ac01c9cf60d$var$provideClient(metalClient);
    }).catch((error)=>{
        throw new Error(`Fail to import metal-client: ${error}`);
    });
};
const $45686ac01c9cf60d$export$7ac70c72d404ac36 = ()=>$45686ac01c9cf60d$var$metalClientPromise;
module.exports["initMetalClient"] = $45686ac01c9cf60d$export$3a42ebcb7c12336a;
module.exports["getMetalClient"] = $45686ac01c9cf60d$export$7ac70c72d404ac36;

});

parcelRegister("h8Cm2", function(module, exports) {

let $c7a0ef6d1168fb05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c7a0ef6d1168fb05$var$load("3GBzS"),
    $c7a0ef6d1168fb05$var$load("567AN")
]).then(()=>parcelRequire('f3rHG'));

});

parcelRegister("lgmus", function(module, exports) {

var $j9w5K = parcelRequire("j9w5K");


var $jspCk = parcelRequire("jspCk");

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $f7ac89b1ee105b8d$var$merge = $jspCk(function(object, source, srcIndex) {
    $j9w5K(object, source, srcIndex);
});
module.exports = $f7ac89b1ee105b8d$var$merge;

});

parcelRegister("j9w5K", function(module, exports) {

var $en5bh = parcelRequire("en5bh");

var $61d767cedefee205$exports = {};

var $3PAnx = parcelRequire("3PAnx");


var $ERH8u = parcelRequire("ERH8u");

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $61d767cedefee205$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$ERH8u(object[key], value) || value === undefined && !(key in object)) $3PAnx(object, key, value);
}
$61d767cedefee205$exports = $61d767cedefee205$var$assignMergeValue;



var $9d5GH = parcelRequire("9d5GH");

var $67028763d174d44d$exports = {};


var $dYI4C = parcelRequire("dYI4C");


var $jDkcM = parcelRequire("jDkcM");


var $irmBX = parcelRequire("irmBX");


var $8LtzT = parcelRequire("8LtzT");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");


var $bVtKl = parcelRequire("bVtKl");


var $cSA01 = parcelRequire("cSA01");


var $bsrY7 = parcelRequire("bsrY7");


var $lc9ud = parcelRequire("lc9ud");


var $gTZCn = parcelRequire("gTZCn");


var $gQUlr = parcelRequire("gQUlr");

var $1b0b9e625448aac0$exports = {};
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $1b0b9e625448aac0$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
$1b0b9e625448aac0$exports = $1b0b9e625448aac0$var$safeGet;


var $da74f480f8f5f7c1$exports = {};

var $gR42R = parcelRequire("gR42R");


var $jVTxf = parcelRequire("jVTxf");

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $da74f480f8f5f7c1$var$toPlainObject(value) {
    return $gR42R(value, $jVTxf(value));
}
$da74f480f8f5f7c1$exports = $da74f480f8f5f7c1$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $67028763d174d44d$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $1b0b9e625448aac0$exports(object, key), srcValue = $1b0b9e625448aac0$exports(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $61d767cedefee205$exports(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $fZxmY(srcValue), isBuff = !isArr && $cSA01(srcValue), isTyped = !isArr && !isBuff && $gQUlr(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($fZxmY(objValue)) newValue = objValue;
            else if ($bVtKl(objValue)) newValue = $irmBX(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $dYI4C(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $jDkcM(srcValue, true);
            } else newValue = [];
        } else if ($gTZCn(srcValue) || $dI6Ko(srcValue)) {
            newValue = objValue;
            if ($dI6Ko(objValue)) newValue = $da74f480f8f5f7c1$exports(objValue);
            else if (!$lc9ud(objValue) || $bsrY7(objValue)) newValue = $8LtzT(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $61d767cedefee205$exports(object, key, newValue);
}
$67028763d174d44d$exports = $67028763d174d44d$var$baseMergeDeep;









/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $df17c050c026ec86$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $9d5GH(source, function(srcValue, key) {
        stack || (stack = new $en5bh);
        if ($lc9ud(srcValue)) $67028763d174d44d$exports(object, source, key, srcIndex, $df17c050c026ec86$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($1b0b9e625448aac0$exports(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $61d767cedefee205$exports(object, key, newValue);
        }
    }, $jVTxf);
}
module.exports = $df17c050c026ec86$var$baseMerge;

});

parcelRegister("3PAnx", function(module, exports) {

var $bv8vS = parcelRequire("bv8vS");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $2ca25a8f8de9f3ef$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $bv8vS) $bv8vS(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $2ca25a8f8de9f3ef$var$baseAssignValue;

});

parcelRegister("9d5GH", function(module, exports) {
var $80cd5915e4984703$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $80cd5915e4984703$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$80cd5915e4984703$exports = $80cd5915e4984703$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $6b49bd6dbac252b3$var$baseFor = $80cd5915e4984703$exports();
module.exports = $6b49bd6dbac252b3$var$baseFor;

});

parcelRegister("dYI4C", function(module, exports) {

var $c2Pwh = parcelRequire("c2Pwh");

/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $c2Pwh.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("jDkcM", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $e4b15528d1b09254$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $jZrbP(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $e4b15528d1b09254$var$cloneTypedArray;

});

parcelRegister("jZrbP", function(module, exports) {

var $egtNM = parcelRequire("egtNM");

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e8d8ce20552ca89e$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $egtNM(result).set(new $egtNM(arrayBuffer));
    return result;
}
module.exports = $e8d8ce20552ca89e$var$cloneArrayBuffer;

});

parcelRegister("irmBX", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $d6cc49b4a1bc67d9$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $d6cc49b4a1bc67d9$var$copyArray;

});

parcelRegister("8LtzT", function(module, exports) {

var $4gItC = parcelRequire("4gItC");


var $iRjkT = parcelRequire("iRjkT");


var $erbrP = parcelRequire("erbrP");

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $6619a81215b69a1e$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$erbrP(object) ? $4gItC($iRjkT(object)) : {};
}
module.exports = $6619a81215b69a1e$var$initCloneObject;

});

parcelRegister("4gItC", function(module, exports) {

var $lc9ud = parcelRequire("lc9ud");

/** Built-in value references. */ var $31bb282c300537dc$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $31bb282c300537dc$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$lc9ud(proto)) return {};
        if ($31bb282c300537dc$var$objectCreate) return $31bb282c300537dc$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $31bb282c300537dc$var$baseCreate;

});

parcelRegister("bVtKl", function(module, exports) {

var $bRRFB = parcelRequire("bRRFB");


var $6eZU2 = parcelRequire("6eZU2");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $8aec1798bcc1f232$var$isArrayLikeObject(value) {
    return $6eZU2(value) && $bRRFB(value);
}
module.exports = $8aec1798bcc1f232$var$isArrayLikeObject;

});

parcelRegister("gTZCn", function(module, exports) {

var $9vwa5 = parcelRequire("9vwa5");


var $iRjkT = parcelRequire("iRjkT");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $c4e1946d8384d9ee$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $c4e1946d8384d9ee$var$funcProto = Function.prototype, $c4e1946d8384d9ee$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $c4e1946d8384d9ee$var$funcToString = $c4e1946d8384d9ee$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c4e1946d8384d9ee$var$hasOwnProperty = $c4e1946d8384d9ee$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $c4e1946d8384d9ee$var$objectCtorString = $c4e1946d8384d9ee$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $c4e1946d8384d9ee$var$isPlainObject(value) {
    if (!$6eZU2(value) || $9vwa5(value) != $c4e1946d8384d9ee$var$objectTag) return false;
    var proto = $iRjkT(value);
    if (proto === null) return true;
    var Ctor = $c4e1946d8384d9ee$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $c4e1946d8384d9ee$var$funcToString.call(Ctor) == $c4e1946d8384d9ee$var$objectCtorString;
}
module.exports = $c4e1946d8384d9ee$var$isPlainObject;

});

parcelRegister("gR42R", function(module, exports) {

var $jykdj = parcelRequire("jykdj");


var $3PAnx = parcelRequire("3PAnx");

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $c454bbd8f5054d6a$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $3PAnx(object, key, newValue);
        else $jykdj(object, key, newValue);
    }
    return object;
}
module.exports = $c454bbd8f5054d6a$var$copyObject;

});

parcelRegister("jykdj", function(module, exports) {

var $3PAnx = parcelRequire("3PAnx");


var $ERH8u = parcelRequire("ERH8u");

/** Used for built-in method references. */ var $e3c0df4f89c7bbe8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e3c0df4f89c7bbe8$var$hasOwnProperty = $e3c0df4f89c7bbe8$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $e3c0df4f89c7bbe8$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($e3c0df4f89c7bbe8$var$hasOwnProperty.call(object, key) && $ERH8u(objValue, value)) || value === undefined && !(key in object)) $3PAnx(object, key, value);
}
module.exports = $e3c0df4f89c7bbe8$var$assignValue;

});

parcelRegister("jVTxf", function(module, exports) {

var $dP6hW = parcelRequire("dP6hW");

var $b918f5e29749d77d$exports = {};

var $lc9ud = parcelRequire("lc9ud");


var $erbrP = parcelRequire("erbrP");

var $ae345e98b04fbad8$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ae345e98b04fbad8$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$ae345e98b04fbad8$exports = $ae345e98b04fbad8$var$nativeKeysIn;


/** Used for built-in method references. */ var $b918f5e29749d77d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b918f5e29749d77d$var$hasOwnProperty = $b918f5e29749d77d$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $b918f5e29749d77d$var$baseKeysIn(object) {
    if (!$lc9ud(object)) return $ae345e98b04fbad8$exports(object);
    var isProto = $erbrP(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$b918f5e29749d77d$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$b918f5e29749d77d$exports = $b918f5e29749d77d$var$baseKeysIn;



var $bRRFB = parcelRequire("bRRFB");

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $e82e6b572035f327$var$keysIn(object) {
    return $bRRFB(object) ? $dP6hW(object, true) : $b918f5e29749d77d$exports(object);
}
module.exports = $e82e6b572035f327$var$keysIn;

});

parcelRegister("jspCk", function(module, exports) {

var $9JSQw = parcelRequire("9JSQw");


var $4U5Tv = parcelRequire("4U5Tv");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $03a7d087bafa3d3a$var$createAssigner(assigner) {
    return $9JSQw(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $4U5Tv(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $03a7d087bafa3d3a$var$createAssigner;

});

parcelRegister("9JSQw", function(module, exports) {

var $eN7zR = parcelRequire("eN7zR");


var $iK2Oc = parcelRequire("iK2Oc");


var $gnVVm = parcelRequire("gnVVm");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $7172dc4d69d93294$var$baseRest(func, start) {
    return $gnVVm($iK2Oc(func, start, $eN7zR), func + '');
}
module.exports = $7172dc4d69d93294$var$baseRest;

});

parcelRegister("eN7zR", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $ac4b84ff9a070e15$var$identity(value) {
    return value;
}
module.exports = $ac4b84ff9a070e15$var$identity;

});

parcelRegister("iK2Oc", function(module, exports) {

var $1UMF8 = parcelRequire("1UMF8");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $da4eb3a1083dc739$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $da4eb3a1083dc739$var$overRest(func, start, transform) {
    start = $da4eb3a1083dc739$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $da4eb3a1083dc739$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $1UMF8(func, this, otherArgs);
    };
}
module.exports = $da4eb3a1083dc739$var$overRest;

});

parcelRegister("1UMF8", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $1650c4c0ffe17cf6$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $1650c4c0ffe17cf6$var$apply;

});

parcelRegister("gnVVm", function(module, exports) {
var $2f1484d4aaeeb405$exports = {};
var $4731ccb38327ed31$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $4731ccb38327ed31$var$constant(value) {
    return function() {
        return value;
    };
}
$4731ccb38327ed31$exports = $4731ccb38327ed31$var$constant;



var $bv8vS = parcelRequire("bv8vS");


var $eN7zR = parcelRequire("eN7zR");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $2f1484d4aaeeb405$var$baseSetToString = !$bv8vS ? $eN7zR : function(func, string) {
    return $bv8vS(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $4731ccb38327ed31$exports(string),
        'writable': true
    });
};
$2f1484d4aaeeb405$exports = $2f1484d4aaeeb405$var$baseSetToString;



var $bcv8r = parcelRequire("bcv8r");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $bedbb9d9ccb82b09$var$setToString = $bcv8r($2f1484d4aaeeb405$exports);
module.exports = $bedbb9d9ccb82b09$var$setToString;

});

parcelRegister("bcv8r", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $8278f77b243c65bd$var$HOT_COUNT = 800, $8278f77b243c65bd$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8278f77b243c65bd$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $8278f77b243c65bd$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $8278f77b243c65bd$var$nativeNow(), remaining = $8278f77b243c65bd$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $8278f77b243c65bd$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $8278f77b243c65bd$var$shortOut;

});

parcelRegister("4U5Tv", function(module, exports) {

var $ERH8u = parcelRequire("ERH8u");


var $bRRFB = parcelRequire("bRRFB");


var $1UktQ = parcelRequire("1UktQ");


var $lc9ud = parcelRequire("lc9ud");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $3920f6e0059cfbb8$var$isIterateeCall(value, index, object) {
    if (!$lc9ud(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $bRRFB(object) && $1UktQ(index, object.length) : type == 'string' && index in object) return $ERH8u(object[index], value);
    return false;
}
module.exports = $3920f6e0059cfbb8$var$isIterateeCall;

});

parcelRegister("hWvFC", function(module, exports) {
var $d2e160d2590e5bf5$exports = {};

var $6Ovzg = parcelRequire("6Ovzg");


var $bJedp = parcelRequire("bJedp");

var $d1bfd8139e3b9ea7$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d1bfd8139e3b9ea7$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$d1bfd8139e3b9ea7$exports = $d1bfd8139e3b9ea7$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $d2e160d2590e5bf5$var$baseMatches(source) {
    var matchData = $bJedp(source);
    if (matchData.length == 1 && matchData[0][2]) return $d1bfd8139e3b9ea7$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $6Ovzg(object, source, matchData);
    };
}
$d2e160d2590e5bf5$exports = $d2e160d2590e5bf5$var$baseMatches;


var $ad88328484680289$exports = {};

var $cndcq = parcelRequire("cndcq");


var $kkhbp = parcelRequire("kkhbp");


var $7U49l = parcelRequire("7U49l");


var $1XoFm = parcelRequire("1XoFm");


var $45dI4 = parcelRequire("45dI4");



var $w287Y = parcelRequire("w287Y");

/** Used to compose bitmasks for value comparisons. */ var $ad88328484680289$var$COMPARE_PARTIAL_FLAG = 1, $ad88328484680289$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $ad88328484680289$var$baseMatchesProperty(path, srcValue) {
    if ($1XoFm(path) && $45dI4(srcValue)) return $d1bfd8139e3b9ea7$exports($w287Y(path), srcValue);
    return function(object) {
        var objValue = $kkhbp(object, path);
        return objValue === undefined && objValue === srcValue ? $7U49l(object, path) : $cndcq(srcValue, objValue, $ad88328484680289$var$COMPARE_PARTIAL_FLAG | $ad88328484680289$var$COMPARE_UNORDERED_FLAG);
    };
}
$ad88328484680289$exports = $ad88328484680289$var$baseMatchesProperty;



var $eN7zR = parcelRequire("eN7zR");


var $fZxmY = parcelRequire("fZxmY");

var $a79b7777f4717755$exports = {};

var $3wOKU = parcelRequire("3wOKU");

var $c94e5efa99cc2f3b$exports = {};

var $aT80v = parcelRequire("aT80v");

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $c94e5efa99cc2f3b$var$basePropertyDeep(path) {
    return function(object) {
        return $aT80v(object, path);
    };
}
$c94e5efa99cc2f3b$exports = $c94e5efa99cc2f3b$var$basePropertyDeep;








/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $a79b7777f4717755$var$property(path) {
    return $1XoFm(path) ? $3wOKU($w287Y(path)) : $c94e5efa99cc2f3b$exports(path);
}
$a79b7777f4717755$exports = $a79b7777f4717755$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $d1006b7d95a308d8$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $eN7zR;
    if (typeof value == 'object') return $fZxmY(value) ? $ad88328484680289$exports(value[0], value[1]) : $d2e160d2590e5bf5$exports(value);
    return $a79b7777f4717755$exports(value);
}
module.exports = $d1006b7d95a308d8$var$baseIteratee;

});

parcelRegister("kkhbp", function(module, exports) {

var $aT80v = parcelRequire("aT80v");

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $ecc30115e2bd4b3e$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $aT80v(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $ecc30115e2bd4b3e$var$get;

});

parcelRegister("aT80v", function(module, exports) {

var $f2rYC = parcelRequire("f2rYC");


var $w287Y = parcelRequire("w287Y");

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $7ed54082a05d2070$var$baseGet(object, path) {
    path = $f2rYC(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$w287Y(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $7ed54082a05d2070$var$baseGet;

});

parcelRegister("f2rYC", function(module, exports) {

var $fZxmY = parcelRequire("fZxmY");


var $1XoFm = parcelRequire("1XoFm");


var $8VWvY = parcelRequire("8VWvY");


var $fPVB6 = parcelRequire("fPVB6");

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $af2cbe84f47ca694$var$castPath(value, object) {
    if ($fZxmY(value)) return value;
    return $1XoFm(value, object) ? [
        value
    ] : $8VWvY($fPVB6(value));
}
module.exports = $af2cbe84f47ca694$var$castPath;

});

parcelRegister("hDVEF", function(module, exports) {

var $9vwa5 = parcelRequire("9vwa5");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $cd82cd45a90806be$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $cd82cd45a90806be$var$isSymbol(value) {
    return typeof value == 'symbol' || $6eZU2(value) && $9vwa5(value) == $cd82cd45a90806be$var$symbolTag;
}
module.exports = $cd82cd45a90806be$var$isSymbol;

});

parcelRegister("8VWvY", function(module, exports) {
var $c62d88c6e0b73e81$exports = {};

var $5d9b4 = parcelRequire("5d9b4");

/** Used as the maximum memoize cache size. */ var $c62d88c6e0b73e81$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $c62d88c6e0b73e81$var$memoizeCapped(func) {
    var result = $5d9b4(func, function(key) {
        if (cache.size === $c62d88c6e0b73e81$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$c62d88c6e0b73e81$exports = $c62d88c6e0b73e81$var$memoizeCapped;


/** Used to match property names within property paths. */ var $6811096664beaca5$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $6811096664beaca5$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $6811096664beaca5$var$stringToPath = $c62d88c6e0b73e81$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($6811096664beaca5$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($6811096664beaca5$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $6811096664beaca5$var$stringToPath;

});

parcelRegister("5d9b4", function(module, exports) {

var $aSUgi = parcelRequire("aSUgi");

/** Error message constants. */ var $3cb54924866466f7$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $3cb54924866466f7$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($3cb54924866466f7$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($3cb54924866466f7$var$memoize.Cache || $aSUgi);
    return memoized;
}
// Expose `MapCache`.
$3cb54924866466f7$var$memoize.Cache = $aSUgi;
module.exports = $3cb54924866466f7$var$memoize;

});

parcelRegister("fPVB6", function(module, exports) {

var $daAKm = parcelRequire("daAKm");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $b8784c149c64166a$var$toString(value) {
    return value == null ? '' : $daAKm(value);
}
module.exports = $b8784c149c64166a$var$toString;

});

parcelRegister("daAKm", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $5ukOg = parcelRequire("5ukOg");


var $fZxmY = parcelRequire("fZxmY");


var $hDVEF = parcelRequire("hDVEF");

/** Used as references for various `Number` constants. */ var $9968b6acb1bdfbb6$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $9968b6acb1bdfbb6$var$symbolProto = $agzqu ? $agzqu.prototype : undefined, $9968b6acb1bdfbb6$var$symbolToString = $9968b6acb1bdfbb6$var$symbolProto ? $9968b6acb1bdfbb6$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $9968b6acb1bdfbb6$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($fZxmY(value)) // Recursively convert values (susceptible to call stack limits).
    return $5ukOg(value, $9968b6acb1bdfbb6$var$baseToString) + '';
    if ($hDVEF(value)) return $9968b6acb1bdfbb6$var$symbolToString ? $9968b6acb1bdfbb6$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$9968b6acb1bdfbb6$var$INFINITY ? '-0' : result;
}
module.exports = $9968b6acb1bdfbb6$var$baseToString;

});

parcelRegister("5ukOg", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $3fefe578b96568c8$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $3fefe578b96568c8$var$arrayMap;

});

parcelRegister("w287Y", function(module, exports) {

var $hDVEF = parcelRequire("hDVEF");

/** Used as references for various `Number` constants. */ var $0604a443fbfdda1e$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $0604a443fbfdda1e$var$toKey(value) {
    if (typeof value == 'string' || $hDVEF(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$0604a443fbfdda1e$var$INFINITY ? '-0' : result;
}
module.exports = $0604a443fbfdda1e$var$toKey;

});

parcelRegister("7U49l", function(module, exports) {
var $ece047c371db127f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $ece047c371db127f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$ece047c371db127f$exports = $ece047c371db127f$var$baseHasIn;


var $a606ea82a4e002ab$exports = {};

var $f2rYC = parcelRequire("f2rYC");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");


var $1UktQ = parcelRequire("1UktQ");


var $4CWcc = parcelRequire("4CWcc");


var $w287Y = parcelRequire("w287Y");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $a606ea82a4e002ab$var$hasPath(object, path, hasFunc) {
    path = $f2rYC(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $w287Y(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $4CWcc(length) && $1UktQ(key, length) && ($fZxmY(object) || $dI6Ko(object));
}
$a606ea82a4e002ab$exports = $a606ea82a4e002ab$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $5c10fb64c6c15717$var$hasIn(object, path) {
    return object != null && $a606ea82a4e002ab$exports(object, path, $ece047c371db127f$exports);
}
module.exports = $5c10fb64c6c15717$var$hasIn;

});

parcelRegister("3wOKU", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $291bbb3db91d8faf$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $291bbb3db91d8faf$var$baseProperty;

});

parcelRegister("hpjl4", function(module, exports) {
const $8ec1d41979385654$export$9ef9aab55130f276 = ':load-start';
const $8ec1d41979385654$export$c3d490e973eda5e2 = ':load-end';
module.exports["JS_LOAD_START"] = $8ec1d41979385654$export$9ef9aab55130f276;
module.exports["JS_LOAD_END"] = $8ec1d41979385654$export$c3d490e973eda5e2;

});

parcelRegister("78QFu", function(module, exports) {

var $lMdlY = parcelRequire("lMdlY");

const $eb84b6996ee1c453$export$1e9642d012cc75d6 = {
    uuid: null,
    pageId: '',
    routeName: '',
    transitionId: 0,
    routingTimestamp: 0,
    currentSavedTimestamp: 0,
    isLivePage: null
};


const $f3219f2436e4dde1$export$3dc3660453120ccc = ()=>{
    (0, $eb84b6996ee1c453$export$1e9642d012cc75d6).currentSavedTimestamp = performance.now();
    const activeTrace = (0, $lMdlY.getActiveTrace)();
    const activeTraceId = activeTrace?.traceId;
    return {
        uuid: (0, $eb84b6996ee1c453$export$1e9642d012cc75d6).uuid,
        contentId: (0, $eb84b6996ee1c453$export$1e9642d012cc75d6).pageId,
        isInitial: (0, $eb84b6996ee1c453$export$1e9642d012cc75d6).transitionId === 0,
        isSSR: Boolean(window['__SSR_RENDERED__']),
        routingDuration: (0, $eb84b6996ee1c453$export$1e9642d012cc75d6).currentSavedTimestamp - (0, $eb84b6996ee1c453$export$1e9642d012cc75d6).routingTimestamp,
        ...activeTraceId ? {
            ufoTraceId: activeTraceId,
            ufoTraceType: activeTrace.type
        } : {},
        ...(0, $eb84b6996ee1c453$export$1e9642d012cc75d6).isLivePage !== null ? {
            isLivePage: (0, $eb84b6996ee1c453$export$1e9642d012cc75d6).isLivePage
        } : {}
    };
};
const $f3219f2436e4dde1$export$eef458cd11f4b6e7 = ()=>{
    return (0, $eb84b6996ee1c453$export$1e9642d012cc75d6).currentSavedTimestamp;
};
const $f3219f2436e4dde1$export$8c17c676096b7909 = (routeName = '', match, transitionId, userInfo)=>{
    const contentId = match?.params?.contentId;
    const useUserInfo = userInfo.userId;
    if ((0, $eb84b6996ee1c453$export$1e9642d012cc75d6).pageId !== contentId || (0, $eb84b6996ee1c453$export$1e9642d012cc75d6).routeName !== routeName) {
        let savedUniqueId;
        if (useUserInfo) savedUniqueId = $f3219f2436e4dde1$var$createPageLoadId(routeName, contentId, userInfo);
        else savedUniqueId = $f3219f2436e4dde1$var$createUniqueId();
        (0, $eb84b6996ee1c453$export$1e9642d012cc75d6).uuid = savedUniqueId;
        (0, $eb84b6996ee1c453$export$1e9642d012cc75d6).routeName = routeName;
        (0, $eb84b6996ee1c453$export$1e9642d012cc75d6).pageId = contentId;
        (0, $eb84b6996ee1c453$export$1e9642d012cc75d6).transitionId = transitionId;
        (0, $eb84b6996ee1c453$export$1e9642d012cc75d6).routingTimestamp = performance.now();
    }
};
const $f3219f2436e4dde1$export$2cb0d16c23c1cda0 = (isLivePage)=>{
    (0, $eb84b6996ee1c453$export$1e9642d012cc75d6).isLivePage = isLivePage;
};
// refer to https://gist.github.com/jed/982883 for uuid generation
// For Anonymous users
const $f3219f2436e4dde1$var$createUniqueId = ()=>{
    return `${1e7}${-1000}${-4000}${-8000}${-100000000000}`.replace(/1|0/g, function() {
        // This is a LEGACY disable statement after rule addition. Use `Math.floor()` next time
        // eslint-disable-next-line no-bitwise
        return (0 | Math.random() * 16).toString(16);
    });
};
// For Atlassian users
const $f3219f2436e4dde1$var$createPageLoadId = (routeName, contentId, userInfo)=>{
    const { userId: userId, cloudId: cloudId } = userInfo;
    routeName = routeName || 'route';
    contentId = contentId || 'page';
    // TO-DO ask Dennis if he wants to take any of these out
    return `${routeName}-${contentId}-${userId}-${cloudId}-${Date.now()}`;
};
module.exports["getUniquePageLoadId"] = $f3219f2436e4dde1$export$3dc3660453120ccc;
module.exports["setUniquePageLoadId"] = $f3219f2436e4dde1$export$8c17c676096b7909;
module.exports["setIsLivePage"] = $f3219f2436e4dde1$export$2cb0d16c23c1cda0;

});

parcelRegister("dPJCf", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");


var $054Kg = parcelRequire("054Kg");

const $58376b192eccc221$var$nullNoop = ()=>null;
const $58376b192eccc221$var$objNoop = ()=>({});
const $58376b192eccc221$var$stringNoop = ()=>'';
const $58376b192eccc221$var$voidNoop = ()=>{};
const $58376b192eccc221$var$RouteStore = (0, $1P1Tu.createStore)({
    initialState: {
        getHref: $58376b192eccc221$var$stringNoop,
        history: null,
        location: null,
        match: null,
        transitionId: null,
        toUrl: $58376b192eccc221$var$stringNoop,
        matchRoute: $58376b192eccc221$var$nullNoop,
        matchSupportedRoute: $58376b192eccc221$var$nullNoop,
        getQueryParams: $58376b192eccc221$var$objNoop,
        setQueryParams: $58376b192eccc221$var$voidNoop,
        getHash: $58376b192eccc221$var$stringNoop,
        setHash: $58376b192eccc221$var$voidNoop,
        replace: $58376b192eccc221$var$voidNoop,
        routes: [],
        push: $58376b192eccc221$var$voidNoop,
        open: $58376b192eccc221$var$nullNoop,
        onPageReload: $58376b192eccc221$var$voidNoop,
        preloadRoute: $58376b192eccc221$var$voidNoop
    },
    actions: {
        push (...args) {
            return ({ getState: getState })=>getState().push(...args);
        },
        replace (...args) {
            return ({ getState: getState })=>getState().replace(...args);
        },
        setQueryParams: (query, replace)=>({ getState: getState })=>getState().setQueryParams(query, replace),
        setHash: (hash)=>({ getState: getState })=>getState().setHash(hash),
        getLatestRouteData: ()=>({ getState: getState })=>{
                const match = getState().match;
                return {
                    routeName: match?.name,
                    routeParams: match?.params ?? {},
                    hash: getState().location?.hash?.substring(1) ?? '',
                    href: getState().getHref(),
                    queryParams: (0, $jiJCD.parse)(getState().location?.search ?? '', true)?.query,
                    toUrl: match?.toUrl?.bind(match) ?? function() {
                        return '';
                    }
                };
            },
        overrideUFORouteName: (newName)=>({ getState: getState })=>{
                (0, $054Kg.updatePageloadName)(newName, getState().match?.name);
            },
        preloadRoute: (matchOrUrl, options)=>({ getState: getState })=>getState().preloadRoute(matchOrUrl, options)
    },
    name: 'RouteState'
});
const $58376b192eccc221$export$52c04f66b1983f2a = (0, $FOT9i.createContainer)($58376b192eccc221$var$RouteStore, {
    onInit: ()=>({ setState: setState }, routeState)=>{
            setState(routeState);
        },
    onUpdate: ()=>({ setState: setState }, routeState)=>{
            setState(routeState);
        }
});
const $58376b192eccc221$export$d4f74eb8532c85b4 = (0, $j1v0l.createSubscriber)($58376b192eccc221$var$RouteStore);
/**
 * `useAllRouteActions` exposes all RouteState actions for internal use.
 * This is used to limit which route actions are publicly exposed.
 */ const $58376b192eccc221$var$useAllRouteActions = (0, $9zUhf.createActionsHook)($58376b192eccc221$var$RouteStore);
const $58376b192eccc221$export$2467ee40aa778f80 = ()=>{
    const { push: push, replace: replace, setQueryParams: setQueryParams, setHash: setHash, overrideUFORouteName: overrideUFORouteName, preloadRoute: preloadRoute } = $58376b192eccc221$var$useAllRouteActions();
    return {
        push: /** See {@link RouteActionsType.push} for documentation */ push,
        replace: /** See {@link RouteActionsType.replace} for documentation */ replace,
        setQueryParams: /** See {@link RouteActionsType.setQueryParams} for documentation */ setQueryParams,
        setHash: /** See {@link RouteActionsType.setHash} for documentation */ setHash,
        overrideUFORouteName: /** See {@link RouteActionsType.overrideUFORouteName} for documentation */ overrideUFORouteName,
        preloadRoute: /** See {@link RouteActionsType.preloadRoute} for documentation */ preloadRoute
    };
};
const $58376b192eccc221$export$a434162a7524cfb3 = (routeParam)=>(0, $9zUhf.createStateHook)($58376b192eccc221$var$RouteStore, {
        selector: (state)=>state?.match?.params?.[routeParam]
    });
const $58376b192eccc221$export$a3421b85303fa9de = (queryParam)=>$58376b192eccc221$export$a7bf969075a175d2(queryParam, (parseResult)=>$58376b192eccc221$var$singleQueryParamParser(parseResult));
const $58376b192eccc221$export$2c2c4e775b5e6393 = (queryParam)=>$58376b192eccc221$export$a7bf969075a175d2(queryParam, (parseResult)=>{
        if (parseResult === '') return [];
        else if (typeof parseResult === 'string') return [
            parseResult
        ];
        return parseResult;
    });
const $58376b192eccc221$export$a7bf969075a175d2 = (queryParam, customParser)=>(0, $9zUhf.createStateHook)($58376b192eccc221$var$RouteStore, {
        selector: (state)=>{
            const parseResult = (0, $jiJCD.parse)(state.location?.search ?? '', true)?.query?.[queryParam];
            return customParser(parseResult);
        }
    });
const $58376b192eccc221$export$b1482fdc3ffb1b4a = (0, $9zUhf.createStateHook)($58376b192eccc221$var$RouteStore, {
    selector: (state)=>{
        const hash = state.location?.hash;
        return hash ? hash.substring(1) : '';
    }
});
const $58376b192eccc221$export$244d8f2aa1ab504f = (0, $9zUhf.createStateHook)($58376b192eccc221$var$RouteStore, {
    selector: (state, { selector: selector })=>{
        return selector(state.match?.url);
    }
});
const $58376b192eccc221$export$30aadaab39fae199 = (0, $9zUhf.createStateHook)($58376b192eccc221$var$RouteStore, {
    selector: (state, { selector: selector })=>{
        return selector(state.match?.name);
    }
});
function $58376b192eccc221$var$singleQueryParamParser(parseResult) {
    return Array.isArray(parseResult) ? parseResult?.[0] : parseResult;
}
function $58376b192eccc221$export$85e000103cdf6a77(route) {
    return $58376b192eccc221$export$30aadaab39fae199({
        selector: (matchName)=>matchName === route.name
    });
}
const $58376b192eccc221$export$c9f0d094e50e1bbc = ()=>{
    const { getLatestRouteData: getLatestRouteData } = $58376b192eccc221$var$useAllRouteActions();
    return (0, $42omo.useMemo)(()=>({
            get current () {
                return getLatestRouteData();
            }
        }), [
        getLatestRouteData
    ]);
};
const $58376b192eccc221$export$7926129229271134 = (0, $9zUhf.createStateHook)($58376b192eccc221$var$RouteStore, {
    selector: (state)=>state.transitionId ?? 0
});
const $58376b192eccc221$export$632429935326e9d2 = (0, $9zUhf.createStateHook)($58376b192eccc221$var$RouteStore, {
    selector: (state)=>!!state.transitionId
});
const $58376b192eccc221$export$3420e1dc2c4a518c = (0, $9zUhf.createStateHook)($58376b192eccc221$var$RouteStore, {
    selector: (state)=>state.history
});
const $58376b192eccc221$export$d2ec911fa7f74821 = (0, $9zUhf.createStateHook)($58376b192eccc221$var$RouteStore, {
    selector: (state)=>state.matchRoute
});
const $58376b192eccc221$export$ce9ea1d788472f7b = (0, $9zUhf.createStateHook)($58376b192eccc221$var$RouteStore, {
    selector: (state, { selector: selector })=>{
        return selector(state.location?.pathname);
    }
});
module.exports["RouteStateContainer"] = $58376b192eccc221$export$52c04f66b1983f2a;
module.exports["useRouteActions"] = $58376b192eccc221$export$2467ee40aa778f80;
module.exports["createRouteParamHook"] = $58376b192eccc221$export$a434162a7524cfb3;
module.exports["createSingleQueryParamHook"] = $58376b192eccc221$export$a3421b85303fa9de;
module.exports["useHash"] = $58376b192eccc221$export$b1482fdc3ffb1b4a;
module.exports["useRouteUrl"] = $58376b192eccc221$export$244d8f2aa1ab504f;
module.exports["useRouteName"] = $58376b192eccc221$export$30aadaab39fae199;
module.exports["useIsOnRoute"] = $58376b192eccc221$export$85e000103cdf6a77;
module.exports["useRouteDataRef"] = $58376b192eccc221$export$c9f0d094e50e1bbc;
module.exports["useTransitionId"] = $58376b192eccc221$export$7926129229271134;
module.exports["useIsTransition"] = $58376b192eccc221$export$632429935326e9d2;
module.exports["useHistory"] = $58376b192eccc221$export$3420e1dc2c4a518c;
module.exports["useMatchRoute"] = $58376b192eccc221$export$d2ec911fa7f74821;
module.exports["usePathnameMatcher"] = $58376b192eccc221$export$ce9ea1d788472f7b;

});

parcelRegister("9zUhf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxT4C = parcelRequire("hxT4C");


var $e3NzX = parcelRequire("e3NzX");


var $cclHy = parcelRequire("cclHy");

const $6f930969923edae7$var$EMPTY_SELECTOR = ()=>undefined;
const $6f930969923edae7$var$DEFAULT_SELECTOR = (state)=>state;
function $6f930969923edae7$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $42omo.useContext)((0, $e3NzX.Context));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $42omo.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $42omo.useMemo)(()=>selector ? (0, $cclHy.getSelectorInstance)(selector, storeState, hasPropsArg) : selector === null ? $6f930969923edae7$var$EMPTY_SELECTOR : $6f930969923edae7$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $42omo.useState)({})[1];
        const getSnapshot = (0, $42omo.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $hxT4C.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $6f930969923edae7$export$7c643e1d6648e418(Store) {
    const useHook = $6f930969923edae7$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $6f930969923edae7$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $6f930969923edae7$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}
module.exports["createHook"] = $6f930969923edae7$export$e7f733c8fc2b8a24;
module.exports["createActionsHook"] = $6f930969923edae7$export$7c643e1d6648e418;
module.exports["createStateHook"] = $6f930969923edae7$export$6e4e5611de132e85;

});

parcelRegister("hxT4C", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kZtwk"));

});

parcelRegister("kZtwk", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", () => $f480675013eb288f$export$306c0aa65ff9ec16, (v) => $f480675013eb288f$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f480675013eb288f$export$306c0aa65ff9ec16;
"use strict";

var $42omo = parcelRequire("42omo");

function $f480675013eb288f$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $f480675013eb288f$var$objectIs = "function" === typeof Object.is ? Object.is : $f480675013eb288f$var$is, $f480675013eb288f$var$useState = $42omo.useState, $f480675013eb288f$var$useEffect = $42omo.useEffect, $f480675013eb288f$var$useLayoutEffect = $42omo.useLayoutEffect, $f480675013eb288f$var$useDebugValue = $42omo.useDebugValue;
function $f480675013eb288f$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $f480675013eb288f$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $f480675013eb288f$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $f480675013eb288f$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $f480675013eb288f$var$useEffect(function() {
        $f480675013eb288f$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $f480675013eb288f$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $f480675013eb288f$var$useDebugValue(value);
    return value;
}
function $f480675013eb288f$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$f480675013eb288f$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $f480675013eb288f$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $f480675013eb288f$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $f480675013eb288f$var$useSyncExternalStore$1 : $f480675013eb288f$var$useSyncExternalStore$2;
$f480675013eb288f$export$306c0aa65ff9ec16 = void 0 !== $42omo.useSyncExternalStore ? $42omo.useSyncExternalStore : $f480675013eb288f$var$shim;

});

parcelRegister("4HDYO", function(module, exports) {

var $l5f4C = parcelRequire("l5f4C");


var $davT6 = parcelRequire("davT6");


var $fyrKY = parcelRequire("fyrKY");


var $2ObRk = parcelRequire("2ObRk");

const $3eb5f9eb53d03718$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $2ObRk.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $3eb5f9eb53d03718$export$2e2bcd8739ae039 = $3eb5f9eb53d03718$var$updateMiddleware;


const $767cfacaee8d2dc9$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $3eb5f9eb53d03718$export$2e2bcd8739ae039)).reduceRight((next, mw)=>mw(storeState)(next), (0, $fyrKY.default).mutator);
var $767cfacaee8d2dc9$export$2e2bcd8739ae039 = $767cfacaee8d2dc9$var$applyMiddleware;





const $e1c1fbab332c8ab2$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $e1c1fbab332c8ab2$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $fyrKY.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $fyrKY.default).devtools === 'function' ? (0, $fyrKY.default).devtools(storeState) : {};
                        devTools = $e1c1fbab332c8ab2$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $e1c1fbab332c8ab2$export$2e2bcd8739ae039 = $e1c1fbab332c8ab2$var$withDevtools;









var $goduw = parcelRequire("goduw");




const $2c895b344693a870$var$QUEUE = [];
let $2c895b344693a870$var$scheduled;
function $2c895b344693a870$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $fyrKY.default).batchUpdates || !(0, $l5f4C.default).scheduling()) return (0, $goduw.batch)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$2c895b344693a870$var$QUEUE.includes(fn)) $2c895b344693a870$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($2c895b344693a870$var$scheduled) return;
    $2c895b344693a870$var$scheduled = (0, $goduw.batch)(()=>{
        let queueFn;
        while(queueFn = $2c895b344693a870$var$QUEUE.shift())queueFn();
        $2c895b344693a870$var$scheduled = null;
    });
}


function $f1ed4915923b7426$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $2c895b344693a870$export$2e2bcd8739ae039)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $767cfacaee8d2dc9$export$2e2bcd8739ae039)(storeState, (0, $fyrKY.default).middlewares);
    return storeState;
}
var $f1ed4915923b7426$export$2e2bcd8739ae039 = (0, $e1c1fbab332c8ab2$export$2e2bcd8739ae039)($f1ed4915923b7426$var$createStoreState);


const $36ca30c3ff031f8b$export$e4d628ba0054221b = '__global__';
class $36ca30c3ff031f8b$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $36ca30c3ff031f8b$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $l5f4C.default).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $f1ed4915923b7426$export$2e2bcd8739ae039)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $davT6.bindActions)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $36ca30c3ff031f8b$export$9d726ae4880b1060 = new $36ca30c3ff031f8b$export$acb47f32da33501e();
module.exports["StoreRegistry"] = $36ca30c3ff031f8b$export$acb47f32da33501e;
module.exports["defaultRegistry"] = $36ca30c3ff031f8b$export$9d726ae4880b1060;

});

parcelRegister("fyrKY", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b52f8fdf5c4d562c$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $b52f8fdf5c4d562c$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($42omo))),
    devtools: false,
    middlewares: new Set(),
    mutator: $b52f8fdf5c4d562c$var$defaultMutator
};
var $b52f8fdf5c4d562c$export$2e2bcd8739ae039 = $b52f8fdf5c4d562c$var$defaults;
module.exports["default"] = $b52f8fdf5c4d562c$export$2e2bcd8739ae039;

});

parcelRegister("goduw", function(module, exports) {
/* eslint-disable import/no-unresolved */ 
var $jTxSS = parcelRequire("jTxSS");


var $eggFB = parcelRequire("eggFB");


var $fyrKY = parcelRequire("fyrKY");


var $l5f4C = parcelRequire("l5f4C");

let $bee95a5323e074c9$var$isInsideBatchedSchedule = false;
function $bee95a5323e074c9$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $fyrKY.default).batchUpdates || !(0, $l5f4C.default).scheduling() || $bee95a5323e074c9$var$isInsideBatchedSchedule) return (0, $jTxSS.unstable_batchedUpdates)(fn);
    $bee95a5323e074c9$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $eggFB.unstable_scheduleCallback)((0, $eggFB.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $jTxSS.unstable_batchedUpdates)(fn);
        $bee95a5323e074c9$var$isInsideBatchedSchedule = false;
    });
}
module.exports["batch"] = $bee95a5323e074c9$export$712ea50be43a7858;

});

parcelRegister("cclHy", function(module, exports) {

var $2ObRk = parcelRequire("2ObRk");

function $35c1a600db56d7a9$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $35c1a600db56d7a9$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $2ObRk.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$35c1a600db56d7a9$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $35c1a600db56d7a9$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $35c1a600db56d7a9$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $2ObRk.default)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}


function $8e177076e08eda1f$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $35c1a600db56d7a9$export$2e2bcd8739ae039)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $35c1a600db56d7a9$export$2e2bcd8739ae039)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $8e177076e08eda1f$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $8e177076e08eda1f$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $8e177076e08eda1f$var$cache = new WeakMap();
function $8e177076e08eda1f$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$8e177076e08eda1f$var$cache.has(storeState)) $8e177076e08eda1f$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $8e177076e08eda1f$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $8e177076e08eda1f$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $8e177076e08eda1f$export$d2c200d79fc82f8c(selector);
}
module.exports["createSelector"] = $8e177076e08eda1f$export$595d22ed68ca2841;
module.exports["getSelectorInstance"] = $8e177076e08eda1f$export$38d24f3c60944dd5;

});

parcelRegister("FOT9i", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $e3NzX = parcelRequire("e3NzX");


var $davT6 = parcelRequire("davT6");

var $4HDYO = parcelRequire("4HDYO");


var $2ObRk = parcelRequire("2ObRk");

const $07db4dd87477e2b1$var$_excluded = [
    "children"
], $07db4dd87477e2b1$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $07db4dd87477e2b1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $07db4dd87477e2b1$var$noop = ()=>()=>{};
function $07db4dd87477e2b1$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $07db4dd87477e2b1$var$noop, onUpdate: onUpdate = $07db4dd87477e2b1$var$noop, onCleanup: onCleanup = $07db4dd87477e2b1$var$noop, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $07db4dd87477e2b1$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $07db4dd87477e2b1$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $07db4dd87477e2b1$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $07db4dd87477e2b1$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $07db4dd87477e2b1$var$createFunctionContainer(StoreOrOptions);
}
function $07db4dd87477e2b1$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $42omo.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $4HDYO.StoreRegistry)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $07db4dd87477e2b1$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $42omo.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $42omo.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $davT6.bindActions)(Store.actions, storeState, config);
            const handlers = (0, $davT6.bindActions)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $07db4dd87477e2b1$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $42omo.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $42omo.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $07db4dd87477e2b1$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $07db4dd87477e2b1$var$_objectWithoutPropertiesLoose(props, $07db4dd87477e2b1$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $07db4dd87477e2b1$var$_objectWithoutPropertiesLoose(restProps, $07db4dd87477e2b1$var$_excluded2);
        const ctx = (0, $42omo.useContext)((0, $e3NzX.Context));
        const registry = $07db4dd87477e2b1$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $42omo.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $07db4dd87477e2b1$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $07db4dd87477e2b1$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $2ObRk.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $42omo.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate());
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $42omo.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e3NzX.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
    };
    return FunctionContainer;
}
module.exports["createContainer"] = $07db4dd87477e2b1$export$26ae5ca175b4ec5a;

});

parcelRegister("4xcIM", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $34d41caa7857cd74$var$ReactIs, $34d41caa7857cd74$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("1B1Kx"))();

});

parcelRegister("1B1Kx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $a39a06a170644056$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $a39a06a170644056$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
$a39a06a170644056$exports = $a39a06a170644056$var$ReactPropTypesSecret;


function $129a9a964f8ccaa5$var$emptyFunction() {}
function $129a9a964f8ccaa5$var$emptyFunctionWithReset() {}
$129a9a964f8ccaa5$var$emptyFunctionWithReset.resetWarningCache = $129a9a964f8ccaa5$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $a39a06a170644056$exports) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $129a9a964f8ccaa5$var$emptyFunctionWithReset,
        resetWarningCache: $129a9a964f8ccaa5$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});

parcelRegister("1P1Tu", function(module, exports) {
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $be45c4cb69059593$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}


function $153c05fa024af60d$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $be45c4cb69059593$export$2e2bcd8739ae039)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $153c05fa024af60d$export$f51a9068ac82ea43(_ref) {
    let { name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $153c05fa024af60d$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}
module.exports["createStore"] = $153c05fa024af60d$export$f51a9068ac82ea43;

});

parcelRegister("j1v0l", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

const $dd96292cf29f052c$var$_excluded = [
    "children"
];
function $dd96292cf29f052c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $dd96292cf29f052c$var$hasAdditionalProps(props) {
    for(let i in props)return true;
    return false;
}
function $dd96292cf29f052c$export$48f338a7e080595c(Store, _temp) {
    let { selector: selector, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    const useStore = (0, $9zUhf.createHook)(Store, {
        selector: selector
    });
    const Subscriber = function Subscriber(_ref) {
        let { children: children } = _ref, rest = $dd96292cf29f052c$var$_objectWithoutPropertiesLoose(_ref, $dd96292cf29f052c$var$_excluded);
        const api = useStore($dd96292cf29f052c$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
    return Subscriber;
}
module.exports["createSubscriber"] = $dd96292cf29f052c$export$48f338a7e080595c;

});

parcelRegister("jWs8F", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $guZe9 = parcelRequire("guZe9");

function $782b8c4f3c7e9f62$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $782b8c4f3c7e9f62$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $782b8c4f3c7e9f62$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $782b8c4f3c7e9f62$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $782b8c4f3c7e9f62$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $782b8c4f3c7e9f62$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $782b8c4f3c7e9f62$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $782b8c4f3c7e9f62$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $782b8c4f3c7e9f62$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $guZe9.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $guZe9.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $782b8c4f3c7e9f62$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $782b8c4f3c7e9f62$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $782b8c4f3c7e9f62$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $782b8c4f3c7e9f62$export$94affb487e701bf2;
$782b8c4f3c7e9f62$export$94affb487e701bf2 || ($782b8c4f3c7e9f62$export$94affb487e701bf2 = {});





var $b3YTN = parcelRequire("b3YTN");

// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $8f7b73a034762827$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $8f7b73a034762827$var$MISSING_VALUE = {};
var $8f7b73a034762827$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $8f7b73a034762827$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $8f7b73a034762827$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $8f7b73a034762827$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $8f7b73a034762827$var$MISSING_VALUE) break;
                if (context_1 !== $8f7b73a034762827$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $8f7b73a034762827$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($8f7b73a034762827$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $8f7b73a034762827$var$currentContext.slots[this.id] = $8f7b73a034762827$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $8f7b73a034762827$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $8f7b73a034762827$var$currentContext;
            $8f7b73a034762827$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $8f7b73a034762827$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $8f7b73a034762827$var$currentContext;
            return function() {
                var saved = $8f7b73a034762827$var$currentContext;
                try {
                    $8f7b73a034762827$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $8f7b73a034762827$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($8f7b73a034762827$var$currentContext) {
                var saved = $8f7b73a034762827$var$currentContext;
                try {
                    $8f7b73a034762827$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $8f7b73a034762827$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $8f7b73a034762827$var$globalKey = "@wry/context:Slot";
var $8f7b73a034762827$var$host = Array;
var $8f7b73a034762827$export$8c6ed5c666ac1360 = $8f7b73a034762827$var$host[$8f7b73a034762827$var$globalKey] || function() {
    var Slot = $8f7b73a034762827$var$makeSlotClass();
    try {
        Object.defineProperty($8f7b73a034762827$var$host, $8f7b73a034762827$var$globalKey, {
            value: $8f7b73a034762827$var$host[$8f7b73a034762827$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $8f7b73a034762827$export$2385a24977818dd0 = $8f7b73a034762827$export$8c6ed5c666ac1360.bind, $8f7b73a034762827$export$9fa6f2e300a97f8 = $8f7b73a034762827$export$8c6ed5c666ac1360.noContext;
function $8f7b73a034762827$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($8f7b73a034762827$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $8f7b73a034762827$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $8f7b73a034762827$export$2385a24977818dd0(gen.next);
        var boundThrow = $8f7b73a034762827$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($8f7b73a034762827$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $8f7b73a034762827$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $8f7b73a034762827$var$wrappedFibers = [];
function $8f7b73a034762827$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($8f7b73a034762827$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $8f7b73a034762827$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $8f7b73a034762827$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


function $4475f3bed12ec93d$var$defaultDispose() {}
var $4475f3bed12ec93d$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $4475f3bed12ec93d$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $4475f3bed12ec93d$var$parentEntrySlot = new (0, $8f7b73a034762827$export$8c6ed5c666ac1360)();
var $4475f3bed12ec93d$var$reusableEmptyArray = [];
var $4475f3bed12ec93d$var$emptySetPool = [];
var $4475f3bed12ec93d$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $4475f3bed12ec93d$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $4475f3bed12ec93d$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $4475f3bed12ec93d$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $4475f3bed12ec93d$var$valueCopy(value) {
    return value.slice(0);
}
var $4475f3bed12ec93d$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $4475f3bed12ec93d$var$assert(!this.recomputing, "already recomputing");
        if (!$4475f3bed12ec93d$var$rememberParent(this) && $4475f3bed12ec93d$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $4475f3bed12ec93d$var$mightBeDirty(this) ? $4475f3bed12ec93d$var$reallyRecompute(this) : $4475f3bed12ec93d$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $4475f3bed12ec93d$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $4475f3bed12ec93d$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $4475f3bed12ec93d$var$forgetChildren(this).forEach($4475f3bed12ec93d$var$maybeReportOrphan);
        $4475f3bed12ec93d$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $4475f3bed12ec93d$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $4475f3bed12ec93d$var$rememberParent(child) {
    var parent = $4475f3bed12ec93d$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($4475f3bed12ec93d$var$mightBeDirty(child)) $4475f3bed12ec93d$var$reportDirtyChild(parent, child);
        else $4475f3bed12ec93d$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $4475f3bed12ec93d$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $4475f3bed12ec93d$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $4475f3bed12ec93d$var$parentEntrySlot.withValue(entry, $4475f3bed12ec93d$var$recomputeNewValue, [
        entry
    ]);
    if ($4475f3bed12ec93d$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $4475f3bed12ec93d$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($4475f3bed12ec93d$var$maybeReportOrphan);
    return $4475f3bed12ec93d$var$valueGet(entry.value);
}
function $4475f3bed12ec93d$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $4475f3bed12ec93d$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $4475f3bed12ec93d$var$setClean(entry) {
    entry.dirty = false;
    if ($4475f3bed12ec93d$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $4475f3bed12ec93d$var$reportClean(entry);
}
function $4475f3bed12ec93d$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $4475f3bed12ec93d$var$reportDirtyChild(parent, child);
    });
}
function $4475f3bed12ec93d$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $4475f3bed12ec93d$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $4475f3bed12ec93d$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $4475f3bed12ec93d$var$assert(parent.childValues.has(child));
    $4475f3bed12ec93d$var$assert($4475f3bed12ec93d$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $4475f3bed12ec93d$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $4475f3bed12ec93d$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $4475f3bed12ec93d$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $4475f3bed12ec93d$var$assert(parent.childValues.has(child));
    $4475f3bed12ec93d$var$assert(!$4475f3bed12ec93d$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $4475f3bed12ec93d$var$valueCopy(child.value));
    else if (!$4475f3bed12ec93d$var$valueIs(childValue, child.value)) parent.setDirty();
    $4475f3bed12ec93d$var$removeDirtyChild(parent, child);
    if ($4475f3bed12ec93d$var$mightBeDirty(parent)) return;
    $4475f3bed12ec93d$var$reportClean(parent);
}
function $4475f3bed12ec93d$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($4475f3bed12ec93d$var$emptySetPool.length < $4475f3bed12ec93d$var$POOL_TARGET_SIZE) $4475f3bed12ec93d$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $4475f3bed12ec93d$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $4475f3bed12ec93d$var$forgetChildren(parent) {
    var children = $4475f3bed12ec93d$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $4475f3bed12ec93d$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $4475f3bed12ec93d$var$assert(parent.dirtyChildren === null);
    return children;
}
function $4475f3bed12ec93d$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $4475f3bed12ec93d$var$removeDirtyChild(parent, child);
}
function $4475f3bed12ec93d$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $4475f3bed12ec93d$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $4475f3bed12ec93d$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $4475f3bed12ec93d$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $4475f3bed12ec93d$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $4475f3bed12ec93d$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $4475f3bed12ec93d$var$keyTrie = new $4475f3bed12ec93d$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $4475f3bed12ec93d$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $4475f3bed12ec93d$var$keyTrie.lookupArray(args);
}
var $4475f3bed12ec93d$var$caches = new Set();
function $4475f3bed12ec93d$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $4475f3bed12ec93d$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $4475f3bed12ec93d$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$4475f3bed12ec93d$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $4475f3bed12ec93d$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $4475f3bed12ec93d$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$4475f3bed12ec93d$var$parentEntrySlot.hasValue()) {
            $4475f3bed12ec93d$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $4475f3bed12ec93d$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}



var $7RTAm = parcelRequire("7RTAm");


var $lB1H3 = parcelRequire("lB1H3");

var $e84942dd9ef5c0de$var$haveWarned = false;
function $e84942dd9ef5c0de$var$shouldWarn() {
    var answer = !$e84942dd9ef5c0de$var$haveWarned;
    if (!(0, $guZe9.isTest)()) $e84942dd9ef5c0de$var$haveWarned = true;
    return answer;
}
var $e84942dd9ef5c0de$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $e84942dd9ef5c0de$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $e84942dd9ef5c0de$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $e84942dd9ef5c0de$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $7RTAm.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $7RTAm.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $e84942dd9ef5c0de$var$hasOwn = Object.prototype.hasOwnProperty;
var $e84942dd9ef5c0de$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $4475f3bed12ec93d$export$4997ffc0176396a6)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($e84942dd9ef5c0de$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$e84942dd9ef5c0de$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $e84942dd9ef5c0de$var$defaultNormalizedCacheFactory(seed) {
    return new $e84942dd9ef5c0de$var$DepTrackingCache(seed);
}
var $e84942dd9ef5c0de$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $4475f3bed12ec93d$export$6bd8d8299be3ac82)((0, $guZe9.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $4475f3bed12ec93d$export$4997ffc0176396a6)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $e84942dd9ef5c0de$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $4475f3bed12ec93d$export$4997ffc0176396a6)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $e84942dd9ef5c0de$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $4475f3bed12ec93d$export$4997ffc0176396a6)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $e84942dd9ef5c0de$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $guZe9.getQueryDefinition)(query);
        variables = (0, $guZe9.assign)({}, (0, $guZe9.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $7RTAm.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $b3YTN.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $e84942dd9ef5c0de$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $guZe9.getMainDefinition)(query);
        var fragments = (0, $guZe9.getFragmentDefinitions)(query);
        var fragmentMap = (0, $guZe9.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $guZe9.shouldInclude)(selection, variables)) return;
            if ((0, $guZe9.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $guZe9.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $guZe9.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $7RTAm.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $guZe9.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $guZe9.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $guZe9.resultKeyNameFromField)(field),
            directives: (0, $guZe9.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $e84942dd9ef5c0de$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $e84942dd9ef5c0de$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $e84942dd9ef5c0de$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $e84942dd9ef5c0de$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $guZe9.isIdValue)(value)) throw new (0, $7RTAm.InvariantError)(10);
}
function $e84942dd9ef5c0de$var$defaultFragmentMatcher() {
    return true;
}
function $e84942dd9ef5c0de$export$7a4899fe13f33235(idValue) {
    (0, $7RTAm.invariant)((0, $guZe9.isIdValue)(idValue), 11);
}
function $e84942dd9ef5c0de$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $guZe9.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $guZe9.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $guZe9.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $e84942dd9ef5c0de$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $e84942dd9ef5c0de$export$7e2b40d1002de152(seed) {
    return new $e84942dd9ef5c0de$export$ee7258b8691956a3(seed);
}
var $e84942dd9ef5c0de$export$de4e6870dc6ac801 = function(_super) {
    (0, $hXuPC.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $e84942dd9ef5c0de$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $e84942dd9ef5c0de$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $e84942dd9ef5c0de$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $e84942dd9ef5c0de$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $e84942dd9ef5c0de$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $guZe9.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $guZe9.assign)({}, (0, $guZe9.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $guZe9.createFragmentMap)((0, $guZe9.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $e84942dd9ef5c0de$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $guZe9.shouldInclude)(selection, variables)) return;
            if ((0, $guZe9.isField)(selection)) {
                var resultFieldKey = (0, $guZe9.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $guZe9.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $7RTAm.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $guZe9.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $e84942dd9ef5c0de$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $guZe9.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $guZe9.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$e84942dd9ef5c0de$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $7RTAm.invariant)(!semanticId || !$e84942dd9ef5c0de$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$e84942dd9ef5c0de$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $guZe9.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $guZe9.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $7RTAm.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $7RTAm.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $e84942dd9ef5c0de$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $b3YTN.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$e84942dd9ef5c0de$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $guZe9.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $e84942dd9ef5c0de$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $e84942dd9ef5c0de$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $guZe9.isIdValue)(value) && $e84942dd9ef5c0de$var$isGeneratedId(value.id) && (0, $guZe9.isIdValue)(realValue) && !(0, $b3YTN.equal)(value, realValue) && $e84942dd9ef5c0de$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, generated), real);
    if ((0, $b3YTN.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $e84942dd9ef5c0de$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $e84942dd9ef5c0de$var$defaultConfig = {
    fragmentMatcher: new $e84942dd9ef5c0de$export$5d3fcf53267091de(),
    dataIdFromObject: $e84942dd9ef5c0de$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $e84942dd9ef5c0de$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $e84942dd9ef5c0de$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $e84942dd9ef5c0de$var$OptimisticCacheLayer = function(_super) {
    (0, $hXuPC.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $e84942dd9ef5c0de$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($e84942dd9ef5c0de$export$ee7258b8691956a3);
var $e84942dd9ef5c0de$export$467265324939f47f = function(_super) {
    (0, $hXuPC.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $4475f3bed12ec93d$export$6bd8d8299be3ac82)((0, $guZe9.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $e84942dd9ef5c0de$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $e84942dd9ef5c0de$var$DepTrackingCache() : new $e84942dd9ef5c0de$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $e84942dd9ef5c0de$export$eb8361c5d132fb8f();
        _this.storeReader = new $e84942dd9ef5c0de$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        _this.dedupedQueryMap = new Map();
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $4475f3bed12ec93d$export$4997ffc0176396a6)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $e84942dd9ef5c0de$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        if (InMemoryCache.__watchPerformanceImprovementsEnabled) {
            var queryWatchKey = `${(0, $lB1H3.print)(watch.query)}|${JSON.stringify(watch.variables)}|${watch.optimistic}`;
            var existingWatches = this.dedupedQueryMap.get(queryWatchKey);
            if (!existingWatches) this.dedupedQueryMap.set(queryWatchKey, new Set([
                watch
            ]));
            else existingWatches.add(watch);
        }
        return function() {
            if (InMemoryCache.__watchPerformanceImprovementsEnabled) {
                const existingWatches = _this.dedupedQueryMap.get(queryWatchKey);
                if (existingWatches) {
                    existingWatches.delete(watch);
                    if (existingWatches.size === 0) _this.dedupedQueryMap.delete(queryWatchKey);
                }
            }
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $7RTAm.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $e84942dd9ef5c0de$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $e84942dd9ef5c0de$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $guZe9.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!_this.silenceBroadcast) {
            if (InMemoryCache.__watchPerformanceImprovementsEnabled) for (var watches of _this.dedupedQueryMap.values()){
                var result;
                var computedWithPrevious;
                for (var watch of watches)if (watch.previousResult) {
                    var previousResult = watch.previousResult();
                    if (previousResult === computedWithPrevious && result) watch.callback(result);
                    else {
                        var nextResult = _this.diff({
                            query: watch.query,
                            variables: watch.variables,
                            previousResult: previousResult,
                            optimistic: watch.optimistic
                        });
                        if (!(0, $b3YTN.equal)(result, nextResult)) {
                            result = nextResult;
                            computedWithPrevious = previousResult;
                        } else nextResult = result;
                        watch.callback(result);
                    }
                } else watch.callback(_this.diff({
                    query: watch.query,
                    variables: watch.variables,
                    optimistic: watch.optimistic
                }));
            }
            else _this.watches.forEach(function(c) {
                return _this.maybeBroadcastWatch(c);
            });
        }
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $782b8c4f3c7e9f62$export$5fc74f25506aa9c));
module.exports["IntrospectionFragmentMatcher"] = $e84942dd9ef5c0de$export$3b71c6b829c99d21;
module.exports["defaultDataIdFromObject"] = $e84942dd9ef5c0de$export$bd03c5a9c99d6bce;
module.exports["InMemoryCache"] = $e84942dd9ef5c0de$export$467265324939f47f;

});

parcelRegister("lB1H3", function(module, exports) {

var $19Cca = parcelRequire("19Cca");


var $7GRom = parcelRequire("7GRom");

function $fb8e5df0874cefed$export$c2d084dc44961371(ast) {
    return (0, $19Cca.visit)(ast, {
        leave: $fb8e5df0874cefed$var$printDocASTReducer
    });
}
var $fb8e5df0874cefed$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $fb8e5df0874cefed$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $fb8e5df0874cefed$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $fb8e5df0874cefed$var$wrap('(', $fb8e5df0874cefed$var$join(node.variableDefinitions, ', '), ')');
        var directives = $fb8e5df0874cefed$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $fb8e5df0874cefed$var$join([
            op,
            $fb8e5df0874cefed$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $fb8e5df0874cefed$var$wrap(' = ', defaultValue) + $fb8e5df0874cefed$var$wrap(' ', $fb8e5df0874cefed$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $fb8e5df0874cefed$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $fb8e5df0874cefed$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $fb8e5df0874cefed$var$wrap('(', $fb8e5df0874cefed$var$join(args, ', '), ')');
        if (argsLine.length > $fb8e5df0874cefed$var$MAX_LINE_LENGTH) argsLine = prefix + $fb8e5df0874cefed$var$wrap('(\n', $fb8e5df0874cefed$var$indent($fb8e5df0874cefed$var$join(args, '\n')), '\n)');
        return $fb8e5df0874cefed$var$join([
            argsLine,
            $fb8e5df0874cefed$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $fb8e5df0874cefed$var$wrap(' ', $fb8e5df0874cefed$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $fb8e5df0874cefed$var$join([
            '...',
            $fb8e5df0874cefed$var$wrap('on ', typeCondition),
            $fb8e5df0874cefed$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($fb8e5df0874cefed$var$wrap('(', $fb8e5df0874cefed$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($fb8e5df0874cefed$var$wrap('', $fb8e5df0874cefed$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $7GRom.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $fb8e5df0874cefed$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $fb8e5df0874cefed$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $fb8e5df0874cefed$var$wrap('(', $fb8e5df0874cefed$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $fb8e5df0874cefed$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $fb8e5df0874cefed$var$join([
            'schema',
            $fb8e5df0874cefed$var$join(directives, ' '),
            $fb8e5df0874cefed$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $fb8e5df0874cefed$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $fb8e5df0874cefed$var$join([
            'scalar',
            name,
            $fb8e5df0874cefed$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $fb8e5df0874cefed$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $fb8e5df0874cefed$var$join([
            'type',
            name,
            $fb8e5df0874cefed$var$wrap('implements ', $fb8e5df0874cefed$var$join(interfaces, ' & ')),
            $fb8e5df0874cefed$var$join(directives, ' '),
            $fb8e5df0874cefed$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $fb8e5df0874cefed$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($fb8e5df0874cefed$var$hasMultilineItems(args) ? $fb8e5df0874cefed$var$wrap('(\n', $fb8e5df0874cefed$var$indent($fb8e5df0874cefed$var$join(args, '\n')), '\n)') : $fb8e5df0874cefed$var$wrap('(', $fb8e5df0874cefed$var$join(args, ', '), ')')) + ': ' + type + $fb8e5df0874cefed$var$wrap(' ', $fb8e5df0874cefed$var$join(directives, ' '));
    }),
    InputValueDefinition: $fb8e5df0874cefed$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $fb8e5df0874cefed$var$join([
            name + ': ' + type,
            $fb8e5df0874cefed$var$wrap('= ', defaultValue),
            $fb8e5df0874cefed$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $fb8e5df0874cefed$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $fb8e5df0874cefed$var$join([
            'interface',
            name,
            $fb8e5df0874cefed$var$wrap('implements ', $fb8e5df0874cefed$var$join(interfaces, ' & ')),
            $fb8e5df0874cefed$var$join(directives, ' '),
            $fb8e5df0874cefed$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $fb8e5df0874cefed$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $fb8e5df0874cefed$var$join([
            'union',
            name,
            $fb8e5df0874cefed$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $fb8e5df0874cefed$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $fb8e5df0874cefed$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $fb8e5df0874cefed$var$join([
            'enum',
            name,
            $fb8e5df0874cefed$var$join(directives, ' '),
            $fb8e5df0874cefed$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $fb8e5df0874cefed$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $fb8e5df0874cefed$var$join([
            name,
            $fb8e5df0874cefed$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $fb8e5df0874cefed$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $fb8e5df0874cefed$var$join([
            'input',
            name,
            $fb8e5df0874cefed$var$join(directives, ' '),
            $fb8e5df0874cefed$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $fb8e5df0874cefed$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($fb8e5df0874cefed$var$hasMultilineItems(args) ? $fb8e5df0874cefed$var$wrap('(\n', $fb8e5df0874cefed$var$indent($fb8e5df0874cefed$var$join(args, '\n')), '\n)') : $fb8e5df0874cefed$var$wrap('(', $fb8e5df0874cefed$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $fb8e5df0874cefed$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $fb8e5df0874cefed$var$join([
            'extend schema',
            $fb8e5df0874cefed$var$join(directives, ' '),
            $fb8e5df0874cefed$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $fb8e5df0874cefed$var$join([
            'extend scalar',
            name,
            $fb8e5df0874cefed$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $fb8e5df0874cefed$var$join([
            'extend type',
            name,
            $fb8e5df0874cefed$var$wrap('implements ', $fb8e5df0874cefed$var$join(interfaces, ' & ')),
            $fb8e5df0874cefed$var$join(directives, ' '),
            $fb8e5df0874cefed$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $fb8e5df0874cefed$var$join([
            'extend interface',
            name,
            $fb8e5df0874cefed$var$wrap('implements ', $fb8e5df0874cefed$var$join(interfaces, ' & ')),
            $fb8e5df0874cefed$var$join(directives, ' '),
            $fb8e5df0874cefed$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $fb8e5df0874cefed$var$join([
            'extend union',
            name,
            $fb8e5df0874cefed$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $fb8e5df0874cefed$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $fb8e5df0874cefed$var$join([
            'extend enum',
            name,
            $fb8e5df0874cefed$var$join(directives, ' '),
            $fb8e5df0874cefed$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $fb8e5df0874cefed$var$join([
            'extend input',
            name,
            $fb8e5df0874cefed$var$join(directives, ' '),
            $fb8e5df0874cefed$var$block(fields)
        ], ' ');
    }
};
function $fb8e5df0874cefed$var$addDescription(cb) {
    return function(node) {
        return $fb8e5df0874cefed$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $fb8e5df0874cefed$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $fb8e5df0874cefed$var$block(array) {
    return $fb8e5df0874cefed$var$wrap('{\n', $fb8e5df0874cefed$var$indent($fb8e5df0874cefed$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $fb8e5df0874cefed$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $fb8e5df0874cefed$var$indent(str) {
    return $fb8e5df0874cefed$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $fb8e5df0874cefed$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $fb8e5df0874cefed$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($fb8e5df0874cefed$var$isMultiline);
}
module.exports["print"] = $fb8e5df0874cefed$export$c2d084dc44961371;

});

parcelRegister("hp2SH", function(module, exports) {

var $eHj6r = parcelRequire("eHj6r");

// Make sure there is only one client being created in the app
let $3c7e293513d9f078$var$apolloClient = null;
function $3c7e293513d9f078$export$1e6cfeaf8b88bd01({ initializeNewCache: initializeNewCache = false } = {}) {
    // Ensure tests are using the same apollo client.
    // Also allow query in @confluence/query-preloader to use apollo without direct dependency.
    if (window['GLOBAL_APOLLO_CLIENT']) return window['GLOBAL_APOLLO_CLIENT'];
    if (!$3c7e293513d9f078$var$apolloClient) $3c7e293513d9f078$var$apolloClient = (0, $eHj6r.createClient)({
        initializeNewCache: initializeNewCache
    });
    window['GLOBAL_APOLLO_CLIENT'] = $3c7e293513d9f078$var$apolloClient;
    return $3c7e293513d9f078$var$apolloClient;
}
module.exports["getApolloClient"] = $3c7e293513d9f078$export$1e6cfeaf8b88bd01;

});

parcelRegister("eHj6r", function(module, exports) {

var $9wEpK = parcelRequire("9wEpK");


var $5v4fk = parcelRequire("5v4fk");


var $jxz2A = parcelRequire("jxz2A");


var $hXuPC = parcelRequire("hXuPC");


var $jLTuK = parcelRequire("jLTuK");


var $hqQq0 = parcelRequire("hqQq0");







var $d05f34e3d6b1fc67$export$3ab8d6927b94aa05 = function() {
    function OperationBatcher(_a) {
        var batchInterval = _a.batchInterval, batchMax = _a.batchMax, batchHandler = _a.batchHandler, batchKey = _a.batchKey;
        this.queuedRequests = new Map();
        this.batchInterval = batchInterval;
        this.batchMax = batchMax || 0;
        this.batchHandler = batchHandler;
        this.batchKey = batchKey || function() {
            return '';
        };
    }
    OperationBatcher.prototype.enqueueRequest = function(request) {
        var _this = this;
        var requestCopy = (0, $hXuPC.__assign)({}, request);
        var queued = false;
        var key = this.batchKey(request.operation);
        if (!requestCopy.observable) requestCopy.observable = new (0, $jLTuK.default)(function(observer) {
            if (!_this.queuedRequests.has(key)) _this.queuedRequests.set(key, []);
            if (!queued) {
                _this.queuedRequests.get(key).push(requestCopy);
                queued = true;
            }
            requestCopy.next = requestCopy.next || [];
            if (observer.next) requestCopy.next.push(observer.next.bind(observer));
            requestCopy.error = requestCopy.error || [];
            if (observer.error) requestCopy.error.push(observer.error.bind(observer));
            requestCopy.complete = requestCopy.complete || [];
            if (observer.complete) requestCopy.complete.push(observer.complete.bind(observer));
            if (_this.queuedRequests.get(key).length === 1) _this.scheduleQueueConsumption(key);
            if (_this.queuedRequests.get(key).length === _this.batchMax) _this.consumeQueue(key);
        });
        return requestCopy.observable;
    };
    OperationBatcher.prototype.consumeQueue = function(key) {
        var requestKey = key || '';
        var queuedRequests = this.queuedRequests.get(requestKey);
        if (!queuedRequests) return;
        this.queuedRequests.delete(requestKey);
        var requests = queuedRequests.map(function(queuedRequest) {
            return queuedRequest.operation;
        });
        var forwards = queuedRequests.map(function(queuedRequest) {
            return queuedRequest.forward;
        });
        var observables = [];
        var nexts = [];
        var errors = [];
        var completes = [];
        queuedRequests.forEach(function(batchableRequest, index) {
            observables.push(batchableRequest.observable);
            nexts.push(batchableRequest.next);
            errors.push(batchableRequest.error);
            completes.push(batchableRequest.complete);
        });
        var batchedObservable = this.batchHandler(requests, forwards) || (0, $jLTuK.default).of();
        var onError = function(error) {
            errors.forEach(function(rejecters) {
                if (rejecters) rejecters.forEach(function(e) {
                    return e(error);
                });
            });
        };
        batchedObservable.subscribe({
            next: function(results) {
                if (!Array.isArray(results)) results = [
                    results
                ];
                if (nexts.length !== results.length) {
                    var error = new Error("server returned results with length " + results.length + ", expected length of " + nexts.length);
                    error.result = results;
                    return onError(error);
                }
                results.forEach(function(result, index) {
                    if (nexts[index]) nexts[index].forEach(function(next) {
                        return next(result);
                    });
                });
            },
            error: onError,
            complete: function() {
                completes.forEach(function(complete) {
                    if (complete) complete.forEach(function(c) {
                        return c();
                    });
                });
            }
        });
        return observables;
    };
    OperationBatcher.prototype.scheduleQueueConsumption = function(key) {
        var _this = this;
        var requestKey = key || '';
        setTimeout(function() {
            if (_this.queuedRequests.get(requestKey) && _this.queuedRequests.get(requestKey).length) _this.consumeQueue(requestKey);
        }, this.batchInterval);
    };
    return OperationBatcher;
}();
var $d05f34e3d6b1fc67$export$3d225ee1d8724cca = function(_super) {
    (0, $hXuPC.__extends)(BatchLink, _super);
    function BatchLink(fetchParams) {
        var _this = _super.call(this) || this;
        var _a = fetchParams || {}, _b = _a.batchInterval, batchInterval = _b === void 0 ? 10 : _b, _c = _a.batchMax, batchMax = _c === void 0 ? 0 : _c, _d = _a.batchHandler, batchHandler = _d === void 0 ? function() {
            return null;
        } : _d, _e = _a.batchKey, batchKey = _e === void 0 ? function() {
            return '';
        } : _e;
        _this.batcher = new $d05f34e3d6b1fc67$export$3ab8d6927b94aa05({
            batchInterval: batchInterval,
            batchMax: batchMax,
            batchHandler: batchHandler,
            batchKey: batchKey
        });
        if (fetchParams.batchHandler.length <= 1) _this.request = function(operation) {
            return _this.batcher.enqueueRequest({
                operation: operation
            });
        };
        return _this;
    }
    BatchLink.prototype.request = function(operation, forward) {
        return this.batcher.enqueueRequest({
            operation: operation,
            forward: forward
        });
    };
    return BatchLink;
}((0, $5v4fk.ApolloLink));


var $2393b0245a6e8cf8$export$8bdd29847e87555f = function(_super) {
    (0, $hXuPC.__extends)(BatchHttpLink, _super);
    function BatchHttpLink(fetchParams) {
        var _this = _super.call(this) || this;
        var _a = fetchParams || {}, _b = _a.uri, uri = _b === void 0 ? '/graphql' : _b, fetcher = _a.fetch, includeExtensions = _a.includeExtensions, batchInterval = _a.batchInterval, batchMax = _a.batchMax, batchKey = _a.batchKey, requestOptions = (0, $hXuPC.__rest)(_a, [
            "uri",
            "fetch",
            "includeExtensions",
            "batchInterval",
            "batchMax",
            "batchKey"
        ]);
        (0, $hqQq0.checkFetcher)(fetcher);
        if (!fetcher) fetcher = fetch;
        var linkConfig = {
            http: {
                includeExtensions: includeExtensions
            },
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers
        };
        _this.batchInterval = batchInterval || 10;
        _this.batchMax = batchMax || 10;
        var batchHandler = function(operations) {
            var chosenURI = (0, $hqQq0.selectURI)(operations[0], uri);
            var context = operations[0].getContext();
            var clientAwarenessHeaders = {};
            if (context.clientAwareness) {
                var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
                if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
                if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
            }
            var contextConfig = {
                http: context.http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: (0, $hXuPC.__assign)({}, clientAwarenessHeaders, context.headers)
            };
            var optsAndBody = operations.map(function(operation) {
                return (0, $hqQq0.selectHttpOptionsAndBody)(operation, (0, $hqQq0.fallbackHttpConfig), linkConfig, contextConfig);
            });
            var loadedBody = optsAndBody.map(function(_a) {
                var body = _a.body;
                return body;
            });
            var options = optsAndBody[0].options;
            if (options.method === 'GET') return (0, $5v4fk.fromError)(new Error('apollo-link-batch-http does not support GET requests'));
            try {
                options.body = (0, $hqQq0.serializeFetchParameter)(loadedBody, 'Payload');
            } catch (parseError) {
                return (0, $5v4fk.fromError)(parseError);
            }
            var controller;
            if (!options.signal) {
                var _b = (0, $hqQq0.createSignalIfSupported)(), _controller = _b.controller, signal = _b.signal;
                controller = _controller;
                if (controller) options.signal = signal;
            }
            return new (0, $jLTuK.default)(function(observer) {
                fetcher(chosenURI, options).then(function(response) {
                    operations.forEach(function(operation) {
                        return operation.setContext({
                            response: response
                        });
                    });
                    return response;
                }).then((0, $hqQq0.parseAndCheckHttpResponse)(operations)).then(function(result) {
                    observer.next(result);
                    observer.complete();
                    return result;
                }).catch(function(err) {
                    if (err.name === 'AbortError') return;
                    if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                    observer.error(err);
                });
                return function() {
                    if (controller) controller.abort();
                };
            });
        };
        batchKey = batchKey || function(operation) {
            var context = operation.getContext();
            var contextConfig = {
                http: context.http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: context.headers
            };
            return (0, $hqQq0.selectURI)(operation, uri) + JSON.stringify(contextConfig);
        };
        _this.batcher = new (0, $d05f34e3d6b1fc67$export$3d225ee1d8724cca)({
            batchInterval: _this.batchInterval,
            batchMax: _this.batchMax,
            batchKey: batchKey,
            batchHandler: batchHandler
        });
        return _this;
    }
    BatchHttpLink.prototype.request = function(operation) {
        return this.batcher.request(operation);
    };
    return BatchHttpLink;
}((0, $5v4fk.ApolloLink));



var $jWs8F = parcelRequire("jWs8F");


var $gTOUc = parcelRequire("gTOUc");


var $4VJDS = parcelRequire("4VJDS");


var $9wGTI = parcelRequire("9wGTI");


var $6fil2 = parcelRequire("6fil2");

var $f7B1p = parcelRequire("f7B1p");

var $flE5X = parcelRequire("flE5X");



// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 






var $7W8i8 = parcelRequire("7W8i8");


var $hBkCm = parcelRequire("hBkCm");



var $lbti1 = parcelRequire("lbti1");







var $6mKj3 = parcelRequire("6mKj3");


var $ikfiQ = parcelRequire("ikfiQ");


var $3m5TZ = parcelRequire("3m5TZ");


var $eSUdr = parcelRequire("eSUdr");

const $042d88bae11db39d$export$bffc74e781c27d1e = (0, $eSUdr.default)`query NetworkStatusLinkQuery{network{status}}`;


function $93dbb5ab38237866$var$readNetworkStatus(cache) {
    if ((0, $6mKj3.expValEquals)('confluence_replace_apollo_client_schema', 'isEnabled', true)) return (0, $ikfiQ.getNetworkStatus)();
    else try {
        const data = cache.readQuery({
            query: (0, $042d88bae11db39d$export$bffc74e781c27d1e)
        });
        return data?.network?.status;
    } catch (e) {
        return undefined;
    }
}
function $93dbb5ab38237866$export$67a1ea7955e5b308(cache, status) {
    const currentStatus = $93dbb5ab38237866$var$readNetworkStatus(cache);
    if (currentStatus === (0, $3m5TZ.ClientNetworkStatus).SESSION_EXPIRED) // recovering from this error only via page reload
    return;
    if (currentStatus !== status) {
        if ((0, $6mKj3.expValEquals)('confluence_replace_apollo_client_schema', 'isEnabled', true)) (0, $ikfiQ.setNetworkStatus)(status);
        else cache.writeQuery({
            query: (0, $042d88bae11db39d$export$bffc74e781c27d1e),
            data: {
                network: {
                    // @ts-ignore
                    __typename: 'ClientNetwork',
                    status: status
                }
            }
        });
    }
}
const $93dbb5ab38237866$export$c6899cfecb91c18f = ()=>{
    const logger = (0, $7W8i8.getLogger)($93dbb5ab38237866$export$c6899cfecb91c18f);
    return new (0, $5v4fk.ApolloLink)((operation, forward)=>{
        return new (0, $jLTuK.default)((observer)=>{
            forward(operation).subscribe({
                next (result) {
                    const context = operation.getContext();
                    if (result.errors?.some((0, $lbti1.isSessionExpiredError))) {
                        $93dbb5ab38237866$export$67a1ea7955e5b308(context.cache, (0, $3m5TZ.ClientNetworkStatus).SESSION_EXPIRED);
                        const sessionExpiredError = new (0, $lbti1.SessionExpiredError)(operation.operationName, context.response || {});
                        // Don't throw original errors when translating them:
                        // 1. By Error's convention, the original cause of the Error is in
                        //    `cause`.
                        // 2. By our convention inspired by GraphQLError, the original cause
                        //    of the Error is in `originalError`).
                        sessionExpiredError.originalError = sessionExpiredError.cause = new (0, $9wEpK.ApolloError)({
                            graphQLErrors: result.errors
                        });
                        observer.error(sessionExpiredError);
                    } else {
                        $93dbb5ab38237866$export$67a1ea7955e5b308(context.cache, (0, $3m5TZ.ClientNetworkStatus).ONLINE);
                        observer.next(result);
                    }
                },
                error (error) {
                    const context = operation.getContext();
                    if (error instanceof (0, $hBkCm.BadStatusError)) switch(error.response.status){
                        case /* Forbidden */ 403:
                            logger.log`IP blocked for ${operation}`;
                            $93dbb5ab38237866$export$67a1ea7955e5b308(context.cache, (0, $3m5TZ.ClientNetworkStatus).IP_BLOCKED);
                            return; // as it doesn't call observer next/error, the request will stay in unresolved state
                        case /* Too Many Requests */ 429:
                            logger.log`Rate limit was reached for ${operation}`;
                            $93dbb5ab38237866$export$67a1ea7955e5b308(context.cache, (0, $3m5TZ.ClientNetworkStatus).RATE_LIMITED);
                            observer.error(error);
                            return;
                    }
                    else if (error instanceof (0, $flE5X.NoNetworkError) && !error.ignore && !(0, $6fil2.causedByAbortError)(error)) {
                        logger.log`Network is offline for ${operation}`;
                        $93dbb5ab38237866$export$67a1ea7955e5b308(context.cache, (0, $3m5TZ.ClientNetworkStatus).OFFLINE);
                        if ((0, $9wGTI.fg)('platform_editor_bubble_cfe_gql_network_errors')) {
                            // Attach metadata to be picked up by analytics, to make monitoring easier while this is being rolled out and tested
                            error.wasBubbledUp = true;
                            observer.error(error);
                        }
                        return; // as it doesn't call observer next/error, the request will stay in unresolved state;
                    }
                    observer.error(error);
                },
                complete () {
                    observer.complete();
                }
            });
        });
    });
};






var $1NBp8 = parcelRequire("1NBp8");

const $d1576ec57364495d$export$624b4ef2030b3ab5 = new (0, $5v4fk.ApolloLink)((operation, forward)=>{
    const { allowOnExternalPage: allowOnExternalPage = false } = operation.getContext();
    const isExternalShareRequest = !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
    // this issue has given developers a lot of gripe, since things fail silently
    if (isExternalShareRequest && !allowOnExternalPage) // eslint-disable-next-line no-console
    console.warn('Trying to make a call on an external route without allowOnExternalPage', operation.operationName);
    if (allowOnExternalPage || !isExternalShareRequest) return forward(operation);
    return new (0, $jLTuK.default)((observer)=>{
        observer.complete();
    });
});






var $6jrkJ = parcelRequire("6jrkJ");




const $e6ea36789beff9b8$var$SUPER_ADMIN_DIRECTIVE = 'asSuperAdmin';
const $e6ea36789beff9b8$export$6c3fe9c8b11bbd40 = new (0, $5v4fk.ApolloLink)((operation, forward)=>{
    if ((0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint')) return forward(operation);
    const { asSuperAdmin: asSuperAdmin = true } = operation.getContext();
    if (asSuperAdmin && (0, $6jrkJ.getSuperAdminClaim)()) operation.query.definitions.forEach((definition)=>{
        if (!('operation' in definition)) return;
        const { operation: operation, directives: directives } = definition;
        if (operation === 'query' || operation === 'mutation') {
            const superAdminDirectiveExists = directives?.some((directive)=>directive.name.value === $e6ea36789beff9b8$var$SUPER_ADMIN_DIRECTIVE);
            if (!superAdminDirectiveExists) {
                const superAdminDirective = {
                    arguments: [],
                    kind: 'Directive',
                    name: {
                        kind: 'Name',
                        value: $e6ea36789beff9b8$var$SUPER_ADMIN_DIRECTIVE
                    }
                };
                // @ts-ignore "directive" is marked as ReadonlyArray in types
                directives?.push(superAdminDirective);
            }
        }
    });
    return forward(operation);
});




var $e43zd = parcelRequire("e43zd");


var $9jPdT = parcelRequire("9jPdT");


var $b2nDI = parcelRequire("b2nDI");





var $aAxiE = parcelRequire("aAxiE");





var $1UApO = parcelRequire("1UApO");

const $7d17e916549f650a$var$createGraphQLError = (operationName, message = `This is a test error from \"testFailuresLink\". To skip this query from triggering a test error, run this in console:\n  excludeOperationFromFailureGeneration(\"${operationName}\")`, status = 500)=>{
    return new (0, $aAxiE.GraphQLError)(message, undefined, undefined, undefined, undefined, undefined, {
        statusCode: status,
        http: {
            status: status
        }
    });
};
function $7d17e916549f650a$var$devOnlyLinkImplementation() {
    class OperationController {
        get mode() {
            return this._mode;
        }
        set mode(value) {
            this._mode = value;
            switch(value){
                case 'include':
                case 'exclude':
                    // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
                    sessionStorage.setItem((0, $1UApO.keys).TEST_FAILURES_LINK_MODE, value);
                    break;
                case 'off':
                    sessionStorage.removeItem((0, $1UApO.keys).TEST_FAILURES_LINK_MODE);
            }
        }
        onOperationRequested(operationName) {
            if (this.mode === 'off') return {
                error: undefined
            };
            this.requestedOperations.add(operationName);
            this.scheduleDebugReporting();
            if (!this.shouldGenerateError(operationName)) return {
                error: undefined
            };
            switch(this.mode){
                case 'include':
                    {
                        const operations = this.getOperations();
                        return {
                            error: operations.get(operationName)
                        };
                    }
                case 'exclude':
                    return {
                        error: $7d17e916549f650a$var$createGraphQLError(operationName)
                    };
            }
        }
        addOperation(operationName, message, status) {
            const error = $7d17e916549f650a$var$createGraphQLError(operationName, message, status);
            const operations = this.getOperations();
            operations.set(operationName, error);
            // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
            sessionStorage.setItem(this.operationsStorageKey, JSON.stringify(Array.from(operations)));
        }
        removeOperation(operationName) {
            const operations = this.getOperations();
            operations.delete(operationName);
            // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
            sessionStorage.setItem(this.operationsStorageKey, JSON.stringify(Array.from(operations)));
        }
        getOperations() {
            return new Map(JSON.parse(sessionStorage.getItem(this.operationsStorageKey) || '[]'));
        }
        reset() {
            const modes = [
                'include',
                'exclude',
                'off'
            ];
            modes.forEach((mode)=>{
                this.mode = mode;
                sessionStorage.removeItem(this.operationsStorageKey);
            });
            sessionStorage.removeItem((0, $1UApO.keys).TEST_FAILURES_LINK_MODE);
            this._mode = 'off';
            this.requestedOperations.clear();
        }
        scheduleDebugReporting() {
            if (this.mode === 'off') return;
            window.clearTimeout(this.currentDebugReportingTimeoutId);
            this.currentDebugReportingTimeoutId = window.setTimeout(()=>{
                if (this.mode === 'include') {
                    const configuredOperations = this.getOperations();
                    const operationsThatWereFailedExplicitly = Array.from(this.requestedOperations).filter((op)=>configuredOperations.has(op));
                    const notYetRequestedOperations = Array.from(configuredOperations).filter((op)=>!this.requestedOperations.has(op[0]));
                    this.logger.log`OperationController mode: "include".`;
                    this.logger.log`Operations which have been failed explicitly:`;
                    this.logger.log`${operationsThatWereFailedExplicitly}`;
                    this.logger.log`Operations which were configured to fail explicitly, but have not been requested yet:`;
                    this.logger.log`${notYetRequestedOperations}`;
                } else if (this.mode === 'exclude') {
                    const configuredOperations = this.getOperations();
                    const operationsThatWereFailedExplicitly = Array.from(this.requestedOperations).filter((op)=>!configuredOperations.has(op));
                    const notYetRequestedOperations = Array.from(configuredOperations).filter((op)=>!this.requestedOperations.has(op[0]));
                    this.logger.log`OperationController mode: "exclude".`;
                    this.logger.log`Operations which have been failed explicitly:`;
                    this.logger.log`${operationsThatWereFailedExplicitly}`;
                    this.logger.log`Operations which were excluded from failures, but have not been requested yet:`;
                    this.logger.log`${notYetRequestedOperations}`;
                }
            }, 1000);
        }
        shouldGenerateError(operationName) {
            switch(this.mode){
                case 'off':
                    return false;
                case 'include':
                    return this.getOperations().has(operationName);
                case 'exclude':
                    return !this.getOperations().has(operationName);
            }
        }
        get operationsStorageKey() {
            return `${(0, $1UApO.keys).TEST_FAILURES_LINK_OPERATIONS_PREFIX}${this.mode}`;
        }
        constructor(){
            this.logger = (0, $7W8i8.getLogger)('DevOnlyGraphqlErrorGenerator');
            this._mode = 'off';
            this.currentDebugReportingTimeoutId = void 0;
            this.requestedOperations = new Set();
            const configuredMode = sessionStorage.getItem((0, $1UApO.keys).TEST_FAILURES_LINK_MODE);
            if (configuredMode === 'include' || configuredMode === 'exclude') this.mode = configuredMode;
        }
    }
    const operationController = new OperationController();
    window.graphqlOperationController = operationController;
    window.enableArtificialGraphqlFailures = ()=>{
        operationController.mode = 'exclude';
    };
    window.excludeOperationFromFailureGeneration = (operationName)=>{
        operationController.mode = 'exclude';
        operationController.addOperation(operationName);
    };
    window.includeOperationInFailureGeneration = (operationName, message, status)=>{
        operationController.mode = 'include';
        operationController.addOperation(operationName, message, status);
    };
    window.unexcludeOperationFromFailureGeneration = (operationName)=>{
        operationController.mode = 'exclude';
        operationController.removeOperation(operationName);
    };
    window.unincludeOperationInFailureGeneration = (operationName)=>{
        operationController.mode = 'include';
        operationController.removeOperation(operationName);
    };
    window.disableArtificialGraphqlFailures = ()=>{
        operationController.reset();
    };
    window.getArtificialGraphqlFailures = ()=>{
        return operationController.getOperations();
    };
    return new (0, $5v4fk.ApolloLink)((operation, forward)=>{
        return forward(operation).map((response)=>{
            const { error: error } = operationController.onOperationRequested(operation.operationName);
            if (error) {
                delete response.data;
                response.errors = [
                    error
                ];
            }
            return response;
        });
    });
}
function $7d17e916549f650a$var$noopLink() {
    return new (0, $5v4fk.ApolloLink)((operation, forward)=>forward(operation));
}
const $7d17e916549f650a$export$4669f4f7e5b2e8a0 = ()=>{
    return $7d17e916549f650a$var$noopLink();
};






function $b72b30640e216768$export$8990c5a8045f5ebc() {
    return new (0, $5v4fk.ApolloLink)((operation)=>{
        return new (0, $jLTuK.default)((observer)=>{
            (parcelRequire("gqvAh")).then(({ getSchemaLink: getSchemaLink })=>{
                (0, $5v4fk.execute)(getSchemaLink(), operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            });
        });
    });
}









var $9S3jU = parcelRequire("9S3jU");

var $81f2e008fe739aa4$export$c6ec1f112bd949a0 = function(_super) {
    (0, $hXuPC.__extends)(WebSocketLink, _super);
    function WebSocketLink(paramsOrClient) {
        var _this = _super.call(this) || this;
        if (paramsOrClient instanceof (0, $9S3jU.SubscriptionClient)) _this.subscriptionClient = paramsOrClient;
        else _this.subscriptionClient = new (0, $9S3jU.SubscriptionClient)(paramsOrClient.uri, paramsOrClient.options, paramsOrClient.webSocketImpl);
        return _this;
    }
    WebSocketLink.prototype.request = function(operation) {
        return this.subscriptionClient.request(operation);
    };
    return WebSocketLink;
}((0, $5v4fk.ApolloLink));






var $eq9Qf = parcelRequire("eq9Qf");

let $e08c21cc4a2f58a8$var$hasWebSocketLinkConnection;
function $e08c21cc4a2f58a8$var$getWebsocketURI() {
    let WEBSOCKET_URI;
    WEBSOCKET_URI = `wss://${window.location.host}/subscriptions/subscriptions`;
    return WEBSOCKET_URI;
}
let $e08c21cc4a2f58a8$var$subscriptionClient;
function $e08c21cc4a2f58a8$export$8f441d0995f71d98() {
    const WEBSOCKET_URI = $e08c21cc4a2f58a8$var$getWebsocketURI();
    // NOTE: current usage is geared towards quick reload, and subscription can be terminated by
    // next/packages/quick-reload/src/useWsSubscription.ts -> unsubscribeAll() call
    if (!$e08c21cc4a2f58a8$var$subscriptionClient) $e08c21cc4a2f58a8$var$subscriptionClient = new (0, $9S3jU.SubscriptionClient)(WEBSOCKET_URI, {
        reconnect: true,
        reconnectionAttempts: 2,
        // WS library closes a connection after a short timeout if the server was too slow to respond
        // https://github.com/apollographql/subscriptions-transport-ws/issues/377
        // https://github.com/apollographql/subscriptions-transport-ws/blob/master/src/client.ts#L548
        minTimeout: 5000,
        lazy: true
    });
    return $e08c21cc4a2f58a8$var$subscriptionClient;
}
const $e08c21cc4a2f58a8$export$1aba72d2a9bf603 = ()=>new (0, $81f2e008fe739aa4$export$c6ec1f112bd949a0)($e08c21cc4a2f58a8$export$8f441d0995f71d98());
const $e08c21cc4a2f58a8$export$e0cd372dee37c8be = ()=>{
    const WEBSOCKET_URI = $e08c21cc4a2f58a8$var$getWebsocketURI();
    if ($e08c21cc4a2f58a8$var$hasWebSocketLinkConnection === undefined) $e08c21cc4a2f58a8$var$hasWebSocketLinkConnection = (0, $eq9Qf.checkWebSocketConnectivity)(WEBSOCKET_URI);
    return $e08c21cc4a2f58a8$var$hasWebSocketLinkConnection;
};







var $e7879b03d4bd1eb8$exports = {};
$e7879b03d4bd1eb8$exports = JSON.parse("[{\"kind\":\"UNION\",\"name\":\"ActivitiesEventExtension\",\"possibleTypes\":[{\"name\":\"ActivitiesCommentedEvent\"},{\"name\":\"ActivitiesTransitionedEvent\"}]},{\"kind\":\"UNION\",\"name\":\"ActivitiesObjectExtension\",\"possibleTypes\":[{\"name\":\"ActivitiesJiraIssue\"}]},{\"kind\":\"UNION\",\"name\":\"ActivityObjectData\",\"possibleTypes\":[{\"name\":\"ConfluenceBlogPost\"},{\"name\":\"ConfluenceDatabase\"},{\"name\":\"ConfluenceEmbed\"},{\"name\":\"ConfluenceFooterComment\"},{\"name\":\"ConfluenceInlineComment\"},{\"name\":\"ConfluencePage\"},{\"name\":\"ConfluenceWhiteboard\"}]},{\"kind\":\"INTERFACE\",\"name\":\"AllUpdatesFeedEvent\",\"possibleTypes\":[{\"name\":\"CommentUpdate\"},{\"name\":\"CreateUpdate\"},{\"name\":\"EditUpdate\"}]},{\"kind\":\"INTERFACE\",\"name\":\"CommentLocation\",\"possibleTypes\":[{\"name\":\"FooterComment\"},{\"name\":\"InlineComment\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluenceAncestor\",\"possibleTypes\":[{\"name\":\"ConfluenceDatabase\"},{\"name\":\"ConfluenceEmbed\"},{\"name\":\"ConfluenceFolder\"},{\"name\":\"ConfluencePage\"},{\"name\":\"ConfluenceWhiteboard\"}]},{\"kind\":\"INTERFACE\",\"name\":\"ConfluenceComment\",\"possibleTypes\":[{\"name\":\"ConfluenceFooterComment\"},{\"name\":\"ConfluenceInlineComment\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluenceCommentContainer\",\"possibleTypes\":[{\"name\":\"ConfluenceBlogPost\"},{\"name\":\"ConfluencePage\"},{\"name\":\"ConfluenceWhiteboard\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluenceInlineTaskContainer\",\"possibleTypes\":[{\"name\":\"ConfluenceBlogPost\"},{\"name\":\"ConfluencePage\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluenceLongTaskResult\",\"possibleTypes\":[{\"name\":\"ConfluenceCopyPageTaskResult\"}]},{\"kind\":\"INTERFACE\",\"name\":\"ConfluenceLongTaskState\",\"possibleTypes\":[{\"name\":\"ConfluenceLongTaskFailed\"},{\"name\":\"ConfluenceLongTaskInProgress\"},{\"name\":\"ConfluenceLongTaskSuccess\"}]},{\"kind\":\"INTERFACE\",\"name\":\"ConfluenceSearchResult\",\"possibleTypes\":[{\"name\":\"ConfluenceContentSearchResult\"},{\"name\":\"ConfluenceSpaceSearchResult\"}]},{\"kind\":\"INTERFACE\",\"name\":\"FeedEvent\",\"possibleTypes\":[{\"name\":\"FeedEventComment\"},{\"name\":\"FeedEventCreate\"},{\"name\":\"FeedEventEdit\"},{\"name\":\"FeedEventEditLive\"},{\"name\":\"FeedEventPublishLive\"}]},{\"kind\":\"UNION\",\"name\":\"MediaAttachmentOrError\",\"possibleTypes\":[{\"name\":\"MediaAttachment\"},{\"name\":\"MediaAttachmentError\"}]},{\"kind\":\"INTERFACE\",\"name\":\"MutationErrorExtension\",\"possibleTypes\":[{\"name\":\"AdminAnnouncementBannerMutationErrorExtension\"},{\"name\":\"ConfluenceUpdateContentAccessRequestMutationErrorExtension\"},{\"name\":\"ConfluenceUpdateCustomContentPermissionsMutationErrorExtension\"},{\"name\":\"ConfluenceUpdatePdfExportConfigurationMutationErrorExtension\"},{\"name\":\"ConfluenceUpdateSiteConfigurationMutationErrorExtension\"},{\"name\":\"GenericMutationErrorExtension\"},{\"name\":\"PatchCommentsSummaryMutationErrorExtension\"},{\"name\":\"ReopenCommentsMutationErrorExtension\"},{\"name\":\"ResolveCommentsMutationErrorExtension\"},{\"name\":\"ResolveRestrictionsForSubjectMutationErrorExtension\"},{\"name\":\"UpdateExCoSpacePermissionsMutationErrorExtension\"},{\"name\":\"UpdateSpacePermissionsMutationErrorExtension\"}]},{\"kind\":\"INTERFACE\",\"name\":\"Node\",\"possibleTypes\":[{\"name\":\"ActivitiesEvent\"},{\"name\":\"ActivitiesItem\"},{\"name\":\"ActivitiesObject\"},{\"name\":\"ActivityNode\"},{\"name\":\"ConfluenceBlogPost\"}]},{\"kind\":\"INTERFACE\",\"name\":\"PageActivityEvent\",\"possibleTypes\":[{\"name\":\"PageActivityEventCreatedComment\"},{\"name\":\"PageActivityEventCreatedPage\"},{\"name\":\"PageActivityEventPublishedPage\"},{\"name\":\"PageActivityEventSnapshottedPage\"},{\"name\":\"PageActivityEventStartedPage\"},{\"name\":\"PageActivityEventUpdatedPage\"}]},{\"kind\":\"INTERFACE\",\"name\":\"Payload\",\"possibleTypes\":[{\"name\":\"ActivatePaywallContentPayload\"},{\"name\":\"AddPublicLinkPermissionsPayload\"},{\"name\":\"ArchiveSpacePayload\"},{\"name\":\"BulkDeleteContentDataClassificationLevelPayload\"},{\"name\":\"BulkRemoveRoleAssignmentFromSpacesPayload\"},{\"name\":\"BulkSetRoleAssignmentToSpacesPayload\"},{\"name\":\"BulkSetSpacePermissionAsyncPayload\"},{\"name\":\"BulkSetSpacePermissionPayload\"},{\"name\":\"BulkUpdateContentDataClassificationLevelPayload\"},{\"name\":\"ConfluenceAddCustomApplicationLinkPayload\"},{\"name\":\"ConfluenceChangeOrderOfCustomApplicationLinkPayload\"},{\"name\":\"ConfluenceCopySpaceSecurityConfigurationPayload\"},{\"name\":\"ConfluenceCreateAnswerPayload\"},{\"name\":\"ConfluenceCreateBlogPostPayload\"},{\"name\":\"ConfluenceCreateCustomRolePayload\"},{\"name\":\"ConfluenceCreateFooterCommentOnBlogPostPayload\"},{\"name\":\"ConfluenceCreateFooterCommentOnPagePayload\"},{\"name\":\"ConfluenceCreatePagePayload\"},{\"name\":\"ConfluenceCreatePdfExportTaskForBulkContentPayload\"},{\"name\":\"ConfluenceCreateCsvExportTaskPayload\"},{\"name\":\"ConfluenceCreatePdfExportTaskForSingleContentPayload\"},{\"name\":\"ConfluenceCreateQuestionPayload\"},{\"name\":\"ConfluenceCreateSpacePayload\"},{\"name\":\"ConfluenceDeleteAnswerPayload\"},{\"name\":\"ConfluenceDeleteCalendarCustomEventTypePayload\"},{\"name\":\"ConfluenceDeleteCustomApplicationLinkPayload\"},{\"name\":\"ConfluenceDeleteCustomRolePayload\"},{\"name\":\"ConfluenceDeleteGlobalPageTemplatePayload\"},{\"name\":\"ConfluenceDeleteQuestionPayload\"},{\"name\":\"ConfluenceDeleteSubCalendarAllFutureEventsPayload\"},{\"name\":\"ConfluenceDeleteSubCalendarEventPayload\"},{\"name\":\"ConfluenceDeleteSubCalendarHiddenEventsPayload\"},{\"name\":\"ConfluenceDeleteSubCalendarSingleEventPayload\"},{\"name\":\"ConfluenceDisableBlueprintPayload\"},{\"name\":\"ConfluenceDisableDefaultSpaceLogoPayload\"},{\"name\":\"ConfluenceDisableGlobalPageBlueprintPayload\"},{\"name\":\"ConfluenceDisableSpaceBlueprintPayload\"},{\"name\":\"ConfluenceEnableBlueprintPayload\"},{\"name\":\"ConfluenceEnableDefaultSpaceLogoPayload\"},{\"name\":\"ConfluenceEnableGlobalPageBlueprintPayload\"},{\"name\":\"ConfluenceImportSpacePayload\"},{\"name\":\"ConfluenceMarkAllCommentsAsReadPayload\"},{\"name\":\"ConfluencePromoteBlueprintPayload\"},{\"name\":\"ConfluencePromotePageTemplatePayload\"},{\"name\":\"ConfluencePublishBlogPostPayload\"},{\"name\":\"ConfluencePublishPagePayload\"},{\"name\":\"ConfluencePurgeBlogPostPayload\"},{\"name\":\"ConfluencePurgePagePayload\"},{\"name\":\"ConfluenceReopenCommentPayload\"},{\"name\":\"ConfluenceRepairJiraMacroAppLinksPayload\"},{\"name\":\"ConfluenceRequestSpaceAccessPayload\"},{\"name\":\"ConfluenceResetDefaultSpaceLogoPayload\"},{\"name\":\"ConfluenceResetJiraMacroAppLinksScanStatusPayload\"},{\"name\":\"ConfluenceResolveCommentByContentIdPayload\"},{\"name\":\"ConfluenceResolveCommentsPayload\"},{\"name\":\"ConfluenceSaveOrUpdateSpaceOwnerPayload\"},{\"name\":\"ConfluenceScanJiraMacroAppLinksPayload\"},{\"name\":\"ConfluenceTrashBlogPostPayload\"},{\"name\":\"ConfluenceTrashPagePayload\"},{\"name\":\"ConfluenceUnpromoteBlueprintPayload\"},{\"name\":\"ConfluenceUnpromotePageTemplatePayload\"},{\"name\":\"ConfluenceUpdateAnswerPayload\"},{\"name\":\"ConfluenceUpdateCurrentBlogPostPayload\"},{\"name\":\"ConfluenceUpdateCurrentPagePayload\"},{\"name\":\"ConfluenceUpdateCustomApplicationLinkPayload\"},{\"name\":\"ConfluenceUpdateCustomContentPermissionsPayload\"},{\"name\":\"ConfluenceUpdateCustomPageConfigurationPayload\"},{\"name\":\"ConfluenceUpdateCustomRolePayload\"},{\"name\":\"ConfluenceUpdateDraftBlogPostPayload\"},{\"name\":\"ConfluenceUpdateDraftPagePayload\"},{\"name\":\"ConfluenceUpdateEmailSiteConfigurationPayload\"},{\"name\":\"ConfluenceUpdateGlobalDefaultLocaleConfigurationPayload\"},{\"name\":\"ConfluenceUpdateGlobalPageTemplateDescriptionPayload\"},{\"name\":\"ConfluenceUpdateGlobalThemePayload\"},{\"name\":\"ConfluenceUpdateIndexingLanguageConfigurationPayload\"},{\"name\":\"ConfluenceUpdateManageAppsSettingsPayload\"},{\"name\":\"ConfluenceUpdateNewCodeMacroPayload\"},{\"name\":\"ConfluenceUpdatePdfExportConfigurationPayload\"},{\"name\":\"ConfluenceUpdateQuestionPayload\"},{\"name\":\"ConfluenceUpdateSiteConfigurationPayload\"},{\"name\":\"ConfluenceUpdateSiteSecurityConfigurationPayload\"},{\"name\":\"ConfluenceUpdateSiteSenderEmailAddressPayload\"},{\"name\":\"ConfluenceUpdateSlackSiteConfigurationPayload\"},{\"name\":\"ConfluenceUpdateSpacePayload\"},{\"name\":\"ConfluenceUpdateSpaceSettingsPayload\"},{\"name\":\"ConfluenceUpdateSpaceThemePayload\"},{\"name\":\"ConfluenceUpdateSubCalendarHiddenEventsPayload\"},{\"name\":\"ConfluenceUpdateTeamPresenceSiteConfigurationPayload\"},{\"name\":\"ConfluenceUploadDefaultSpaceLogoPayload\"},{\"name\":\"ConvertPageToLiveEditActionPayload\"},{\"name\":\"CreateContentMentionNotificationActionPayload\"},{\"name\":\"CreateFaviconFilesPayload\"},{\"name\":\"CreateInlineTaskNotificationPayload\"},{\"name\":\"CreateMentionNotificationPayload\"},{\"name\":\"CreateMentionReminderNotificationPayload\"},{\"name\":\"DeactivatePaywallContentPayload\"},{\"name\":\"DeleteContentDataClassificationLevelPayload\"},{\"name\":\"DeleteDefaultSpaceRoleAssignmentsPayload\"},{\"name\":\"DeleteExCoSpacePermissionsPayload\"},{\"name\":\"DeleteExternalCollaboratorDefaultSpacePayload\"},{\"name\":\"DeleteSpaceDefaultClassificationLevelPayload\"},{\"name\":\"DeleteSpaceRoleAssignmentsPayload\"},{\"name\":\"EditorDraftSyncPayload\"},{\"name\":\"FavouriteSpaceBulkPayload\"},{\"name\":\"NotificationResponsePayload\"},{\"name\":\"RecoverSpaceAdminPermissionPayload\"},{\"name\":\"RecoverSpaceWithAdminRoleAssignmentPayload\"},{\"name\":\"RemovePublicLinkPermissionsPayload\"},{\"name\":\"ResetSpaceRolesFromAnotherSpacePayload\"},{\"name\":\"ResetToDefaultSpaceRoleAssignmentsPayload\"},{\"name\":\"ResolveRestrictionsPayload\"},{\"name\":\"RestoreSpacePayload\"},{\"name\":\"SetDefaultSpaceRoleAssignmentsPayload\"},{\"name\":\"SetSpaceRoleAssignmentsPayload\"},{\"name\":\"SoftDeleteSpacePayload\"},{\"name\":\"UnarchiveSpacePayload\"},{\"name\":\"UpdateContentDataClassificationLevelPayload\"},{\"name\":\"UpdateCoverPictureWidthPayload\"},{\"name\":\"UpdateDefaultSpacePermissionsPayloadV2\"},{\"name\":\"UpdateExCoSpacePermissionsPayload\"},{\"name\":\"UpdateExternalCollaboratorDefaultSpacePayload\"},{\"name\":\"UpdateNestedPageOwnersPayload\"},{\"name\":\"UpdatePageOwnersPayload\"},{\"name\":\"UpdatePageStatusesPayload\"},{\"name\":\"UpdateSiteLookAndFeelPayload\"},{\"name\":\"UpdateSpaceDefaultClassificationLevelPayload\"},{\"name\":\"UpdateSpaceDetailsPayload\"},{\"name\":\"UpdateSpacePermissionsPayloadV2\"},{\"name\":\"UpdateSpaceTypeSettingsPayload\"}]},{\"kind\":\"INTERFACE\",\"name\":\"Person\",\"possibleTypes\":[{\"name\":\"Anonymous\"},{\"name\":\"KnownUser\"},{\"name\":\"UnknownUser\"},{\"name\":\"User\"}]},{\"kind\":\"INTERFACE\",\"name\":\"SmartFeaturesResultResponse\",\"possibleTypes\":[{\"name\":\"SmartFeaturesPageResultResponse\"},{\"name\":\"SmartFeaturesSpaceResultResponse\"},{\"name\":\"SmartFeaturesUserResultResponse\"}]},{\"kind\":\"INTERFACE\",\"name\":\"SmartLink\",\"possibleTypes\":[{\"name\":\"BlockSmartLink\"},{\"name\":\"EmbeddedSmartLink\"},{\"name\":\"InlineSmartLink\"}]},{\"kind\":\"INTERFACE\",\"name\":\"SpaceRolePrincipal\",\"possibleTypes\":[{\"name\":\"SpaceRoleAccessClassPrincipal\"},{\"name\":\"SpaceRoleGroupPrincipal\"},{\"name\":\"SpaceRoleGuestPrincipal\"},{\"name\":\"SpaceRoleUserPrincipal\"},{\"name\":\"SpaceRoleAppPrincipal\"}]}]");


const $d3507e581863e385$export$851a7159daf49c89 = new (0, $jWs8F.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($e7879b03d4bd1eb8$exports)))
        }
    }
});





const $aea7a2153c208241$export$625a51ede6ece419 = (object)=>{
    if (object.__typename === 'WebItem') return `${object.completeKey || object.id}; ${object.url}`;
    else if (object.__typename === 'OnboardingState') return object.key;
    else if (object.__typename === 'WebSection') return object.cacheKey || object.id;
    else if (object.__typename === 'DetailsSummaryLines') return `${object.macroId}_${object.currentPage}`;
    else if (object.__typename === 'DetailLine') return `${object.id}_${object.rowId}_${object.macroId}`;
    else if (object.__typename === 'ConfluenceSystemTemplate') return object.moduleCompleteKey;
    else if (object.id === null) return;
    return (0, $jWs8F.defaultDataIdFromObject)(object);
};





const $c03fd16f3d96dc13$export$a79ab6376735332c = {
    Query: {
        singleContent (_, { id: id }, { getCacheKey: getCacheKey }) {
            return getCacheKey({
                __typename: 'Content',
                id: id
            });
        },
        onboardingState (_, { key: key }, { getCacheKey: getCacheKey }) {
            if (!(0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false)) return;
            const keys = Array.isArray(key) ? key : [
                key
            ];
            return keys.map((k)=>{
                return getCacheKey({
                    __typename: 'OnboardingState',
                    key: k
                });
            });
        }
    }
};



var $3aShZ = parcelRequire("3aShZ");




const $89ff56af6ad50e06$export$bf57708a85b8c0a4 = (0, $eSUdr.default)`type FabricEditor{editorMode:String}directive@client on FIELD directive@connection(key:String!filter:[String])on FIELD extend type Query{network:ClientNetwork fabricEditor:FabricEditor localActivity:[LocalActivityEvent!]!}type ClientNetwork{status:ClientNetworkStatus}enum ClientNetworkStatus{IP_BLOCKED OFFLINE ONLINE RATE_LIMITED SESSION_EXPIRED}type LocalActivityEvent{id:ID!action:LocalActivityAction!timestamp:String!content:Content!}enum LocalActivityAction{viewed deleted}`;



var $iMHGI = parcelRequire("iMHGI");



var $11MAl = parcelRequire("11MAl");

// NOTE: URI should be cleaned up along with `cc-agg-migration-use-agg-endpoint`, once all skip queries are gone
const $fa0df9a02d059b52$var$URI = '/cgraphql';
const $fa0df9a02d059b52$var$MAX_CONCURRENCY_FOR_THROTTLED = 8;
const $fa0df9a02d059b52$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)(false);
const $fa0df9a02d059b52$var$SSR_NAMESPACE = 'cgraphql';
const $fa0df9a02d059b52$var$DEFAULT_MAX_BATCH_SIZE = 4;
const $fa0df9a02d059b52$var$DEFAULT_BATCH_INTERVAL = 0;
function $fa0df9a02d059b52$export$d4ebe6281d18dc6a() {
    window.__APOLLO_STATS__ = {
        // Used in node_modules/apollo-client/bundle.esm.js
        broadcast: {}
    };
}
class $fa0df9a02d059b52$export$20ea4794208ad66b extends (0, $jWs8F.InMemoryCache) {
    broadcastWatches() {
        if (this.shouldBroadcast) super.broadcastWatches();
    }
    setShouldBroadcast(shouldBroadcast) {
        this.shouldBroadcast = shouldBroadcast;
    }
    constructor(...args){
        super(...args);
        this.shouldBroadcast = true;
    }
}
const $fa0df9a02d059b52$var$createCache = ()=>{
    return new $fa0df9a02d059b52$export$20ea4794208ad66b({
        fragmentMatcher: $d3507e581863e385$export$851a7159daf49c89,
        dataIdFromObject: $aea7a2153c208241$export$625a51ede6ece419,
        cacheRedirects: $c03fd16f3d96dc13$export$a79ab6376735332c
    });
};
/**
 * Override fetch function used in terminating (http batch) link, to throttle network requests.
 * Concurrent network requests are limited based on MAX_CONCURRENCY_FOR_THROTTLED constant.
 *
 * Realistically, this will be used when there are a large volume of queries are triggered together, upon page load. Therefore,
 * resolving requests in approximate order is sufficient.
 */ const $fa0df9a02d059b52$var$requestPool = [];
const $fa0df9a02d059b52$var$throttledFetch = (uri, options)=>{
    if ($fa0df9a02d059b52$var$requestPool.length >= $fa0df9a02d059b52$var$MAX_CONCURRENCY_FOR_THROTTLED) {
        // pool is full, so queue up next request behind the first request in the pool
        const queuedFetchFn = async ()=>{
            await $fa0df9a02d059b52$var$requestPool.shift();
            return $fa0df9a02d059b52$var$wrappedFetch(uri, options);
        };
        const queuedFetch = queuedFetchFn();
        $fa0df9a02d059b52$var$requestPool.push(queuedFetch);
        return queuedFetch;
    }
    // pool has available slot - add new request to pool and begin request immediately
    const nextFetch = $fa0df9a02d059b52$var$wrappedFetch(uri, options);
    $fa0df9a02d059b52$var$requestPool.push(nextFetch);
    return nextFetch;
};
const $fa0df9a02d059b52$var$createLink = ({ experimentalSchemaLinkOverride: experimentalSchemaLinkOverride, ccGraphqlSchemaLinkOverride: ccGraphqlSchemaLinkOverride })=>{
    const httpLinkOptions = {
        uri: $fa0df9a02d059b52$var$URI,
        credentials: 'same-origin',
        fetch: $fa0df9a02d059b52$var$wrappedFetch
    };
    var getContext;
    {
        const httpLink = (0, $5v4fk.split)(({ getContext: getContext })=>{
            return getContext().single || // In integration tests we deliberately block some queries in order to test the loading state
            // Randomly batching other queries with them will make UI fail to load
            // @ts-ignore TODO FIXME
            window.Cypress || window.__CRITERION__ || // @ts-ignore Property 'isPlaywright' does not exist on type 'Window & typeof globalThis'
            Boolean(window.isPlaywright) || // we don't want query batching for contract tests
            // @ts-expect-error Property isContract doesn't exist on window
            Boolean(window.isContract) || !(0, $4VJDS.default).isKillSwitchOn('confluence_spa_query_batching');
        }, new (0, $jxz2A.HttpLink)(httpLinkOptions), (0, $5v4fk.split)(({ getContext: getContext })=>!!getContext().throttle, new (0, $jxz2A.HttpLink)({
            ...httpLinkOptions,
            fetch: $fa0df9a02d059b52$var$throttledFetch
        }), new (0, $2393b0245a6e8cf8$export$8bdd29847e87555f)(httpLinkOptions)));
        const processingLinks = [
            (0, $e6ea36789beff9b8$export$6c3fe9c8b11bbd40),
            (0, $11MAl.SSRClientLink)($fa0df9a02d059b52$var$SSR_NAMESPACE, $fa0df9a02d059b52$export$2aa8a08d369336c5),
            (0, $93dbb5ab38237866$export$c6899cfecb91c18f)(),
            (0, $b2nDI.statusCodeRetryLink),
            (0, $e43zd.networkErrorRetryLink),
            (0, $d1576ec57364495d$export$624b4ef2030b3ab5),
            ...(0, $9wGTI.fg)('confluence_ufo_remove_network_graphql_timings') ? [] : [
                (0, $gTOUc.UFOLoggerLink)
            ]
        ];
        let ccGraphLink;
        ccGraphLink = (0, $5v4fk.from)(processingLinks).split((0, $3aShZ.isWS), (0, $e08c21cc4a2f58a8$export$1aba72d2a9bf603)(), httpLink);
        const links = [
            (0, $9jPdT.createOnErrorLink)(),
            (0, $7d17e916549f650a$export$4669f4f7e5b2e8a0)()
        ];
        return (0, $5v4fk.from)(links).split(// Condition
        (operation)=>(0, $3aShZ.isExperimental)(operation), // If query contains @experimental directive
        experimentalSchemaLinkOverride || (0, $b72b30640e216768$export$8990c5a8045f5ebc)(), // Else
        ccGraphqlSchemaLinkOverride || ccGraphLink);
    }
};
const $fa0df9a02d059b52$export$2aa8a08d369336c5 = $fa0df9a02d059b52$var$createCache();
const $fa0df9a02d059b52$export$5d730b7aed1a3eb0 = (options = {})=>{
    // Creates window.__APOLLO_STATS__ call before creating the client
    $fa0df9a02d059b52$export$d4ebe6281d18dc6a();
    const cache = options.initializeNewCache ? $fa0df9a02d059b52$var$createCache() : $fa0df9a02d059b52$export$2aa8a08d369336c5;
    if (typeof window['__APOLLO_STATE__'] === 'object') cache.restore(window['__APOLLO_STATE__']);
    const client = new (0, $9wEpK.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        link: $fa0df9a02d059b52$var$createLink(options),
        typeDefs: (0, $89ff56af6ad50e06$export$bf57708a85b8c0a4),
        cache: cache
    });
    // Don't initialize the client cache for tests so we can mock it
    if (!options.ccGraphqlSchemaLinkOverride) (0, $93dbb5ab38237866$export$67a1ea7955e5b308)(client.cache, (0, $3m5TZ.ClientNetworkStatus).ONLINE);
    (0, $f7B1p.cfetch).subscribe((response, error)=>{
        if (response) // It's NetworkStatusLink's responsibility/concern to interpret
        // cc-graphql/agg errors (which may be carried in an OK HTTP response).
        {
            if (response.url?.indexOf($fa0df9a02d059b52$var$URI) === -1 || response.url?.indexOf((0, $iMHGI.AGG_SLOW_URI)) === -1) (0, $93dbb5ab38237866$export$67a1ea7955e5b308)(client.cache, (0, $3m5TZ.ClientNetworkStatus).ONLINE);
        } else if (error instanceof (0, $flE5X.NoNetworkError) && !error.ignore && !(0, $6fil2.causedByAbortError)(error)) (0, $93dbb5ab38237866$export$67a1ea7955e5b308)(client.cache, (0, $3m5TZ.ClientNetworkStatus).OFFLINE);
    });
    return client;
};
module.exports["resetApolloStats"] = $fa0df9a02d059b52$export$d4ebe6281d18dc6a;
module.exports["apolloCache"] = $fa0df9a02d059b52$export$2aa8a08d369336c5;
module.exports["createClient"] = $fa0df9a02d059b52$export$5d730b7aed1a3eb0;

});

parcelRegister("lbti1", function(module, exports) {

var $9wEpK = parcelRequire("9wEpK");


var $hBkCm = parcelRequire("hBkCm");

const $5b75579fd3114473$var$CAUGHT_SESSION_ERROR_TEXT = 'Session expired';
class $5b75579fd3114473$export$8220cdf0bd206e05 extends (0, $hBkCm.BadStatusError) {
    constructor(message, response){
        super(`${message} ${$5b75579fd3114473$var$CAUGHT_SESSION_ERROR_TEXT}`, response);
    }
}
function $5b75579fd3114473$export$1bd7f0128d65baef(error) {
    if (!error) return false;
    if (error instanceof $5b75579fd3114473$export$8220cdf0bd206e05) return true;
    const errorMessage = error?.message || '';
    if (errorMessage.indexOf($5b75579fd3114473$var$CAUGHT_SESSION_ERROR_TEXT) != -1) return true;
    const errorStatusCode = error?.extensions?.statusCode;
    if (errorStatusCode == 401) return true;
    return false;
}
function $5b75579fd3114473$export$b8c2308c7b82c3a9(error) {
    if (!error) return false;
    if ($5b75579fd3114473$export$1bd7f0128d65baef(error)) return true;
    if ((0, $9wEpK.isApolloError)(error)) {
        const { graphQLErrors: graphQLErrors, networkError: networkError } = error;
        if ($5b75579fd3114473$export$1bd7f0128d65baef(networkError)) return true;
        if ((graphQLErrors || []).some($5b75579fd3114473$export$1bd7f0128d65baef)) return true;
    }
    return false;
}
module.exports["SessionExpiredError"] = $5b75579fd3114473$export$8220cdf0bd206e05;
module.exports["isSessionExpiredError"] = $5b75579fd3114473$export$1bd7f0128d65baef;
module.exports["containsSessionExpiredError"] = $5b75579fd3114473$export$b8c2308c7b82c3a9;

});

parcelRegister("ikfiQ", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4HDYO = parcelRequire("4HDYO");

var $256a8763316d30fa$var$ClientNetworkStatus = /*#__PURE__*/ function(ClientNetworkStatus) {
    ClientNetworkStatus["IP_BLOCKED"] = "IP_BLOCKED";
    ClientNetworkStatus["OFFLINE"] = "OFFLINE";
    ClientNetworkStatus["ONLINE"] = "ONLINE";
    ClientNetworkStatus["RATE_LIMITED"] = "RATE_LIMITED";
    ClientNetworkStatus["SESSION_EXPIRED"] = "SESSION_EXPIRED";
    return ClientNetworkStatus;
}($256a8763316d30fa$var$ClientNetworkStatus || {});
const $256a8763316d30fa$var$useNetworkStatusListenerCacheStore = (0, $1P1Tu.createStore)({
    name: 'useNetworkStatusListenerCache',
    initialState: {
        network: undefined
    },
    actions: {
        setNetworkStatus: (status)=>({ setState: setState })=>{
                setState({
                    network: status
                });
            },
        getNetworkStatus: ()=>({ getState: getState })=>{
                return getState().network;
            }
    }
});
const $256a8763316d30fa$export$76ecc1780e6b2a4f = (0, $9zUhf.createStateHook)($256a8763316d30fa$var$useNetworkStatusListenerCacheStore, {
    selector: (state)=>state.network
});
const $256a8763316d30fa$export$6deca5169ea2bc9b = (0, $9zUhf.createActionsHook)($256a8763316d30fa$var$useNetworkStatusListenerCacheStore);
const $256a8763316d30fa$export$614f83ae5074794 = (0, $4HDYO.defaultRegistry).getStore($256a8763316d30fa$var$useNetworkStatusListenerCacheStore);
const $256a8763316d30fa$export$dd21a720657c8b6 = ()=>{
    return $256a8763316d30fa$export$614f83ae5074794.storeState.getState().network;
};
const $256a8763316d30fa$export$e1cdf42adca53186 = (status)=>{
    return $256a8763316d30fa$export$614f83ae5074794.actions.setNetworkStatus(status);
};
module.exports["useNetworkStatusListenerCache"] = $256a8763316d30fa$export$76ecc1780e6b2a4f;
module.exports["getNetworkStatus"] = $256a8763316d30fa$export$dd21a720657c8b6;
module.exports["setNetworkStatus"] = $256a8763316d30fa$export$e1cdf42adca53186;

});

parcelRegister("1NBp8", function(module, exports) {
/* eslint-disable prefer-template */ 
var $fMEnQ = parcelRequire("fMEnQ");


var $jlIaF = parcelRequire("jlIaF");


var $bqMNb = parcelRequire("bqMNb");

// Please do NOT remove /*@__PURE__*/ in this file.
// These comments hints Terser (webpack's minifier) to remove the definition if they are not used.
//
// Please do NOT change string concatenation to string interpolation.
// String interpolations are compiled to "".concat("").concat("") because even the latest edge don't support them natively.
// This made minifier give up removing the dead code because it can't ensure the function call won't have side effects.
//
// Please keep these optimizations here and follow the existing one if you need to add new ones.
const $ca532a827038ae75$var$contentTransition = (prev, curr)=>prev.params.contentId !== curr.params.contentId;
const $ca532a827038ae75$var$spaceTransition = (prev, curr)=>prev.params.spaceKey !== curr.params.spaceKey;
const $ca532a827038ae75$export$9e15ff8aa6bc996f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'BASE',
    pattern: '/'
});
const $ca532a827038ae75$export$2fd309376969662f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'WIKI',
    pattern: (0, $jlIaF.CONTEXT_PATH),
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'HomeRoute',
            whichExportToUse: 'HomeRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-wiki-home-route-killswitch'
    }
});
const $ca532a827038ae75$export$a7c5707626fc90f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'HOME',
    ufoName: 'confluence-home',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/home/:view?',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'HomeRoute',
            whichExportToUse: 'HomeRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-wiki-home-route-killswitch'
    }
});
const $ca532a827038ae75$export$6ccd7dc0d5aa30b0 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'TEMPLATE_GALLERY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/templates'
});
const $ca532a827038ae75$export$7d65e474be175151 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CALENDAR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/calendar/mycalendar.action'
});
const $ca532a827038ae75$export$ec8a7da990877da3 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MY_CALENDAR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/mycalendar'
});
const $ca532a827038ae75$export$e492b3d04985e9fb = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MULTIPLE_SUBCALENDAR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/multiCalendars'
});
const $ca532a827038ae75$export$57fb93d8931ad943 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EMBEDDED_MULTIPLE_SUBCALENDAR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/embedded/multiCalendars'
});
const $ca532a827038ae75$export$aa473411bddb7e17 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'QUESTIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/plugins/servlet/ac/com.atlassian.confluence.plugins.confluence-questions/globalQuestionsViewer\\?ac.com.atlassian.confluence.plugins.confluence-questions.pattern=/questions/ask'
});
const $ca532a827038ae75$export$42bb8ba9cae96927 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'QUESTIONS_NATIVE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/questions'
});
const $ca532a827038ae75$export$1e92de3a3dba0876 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'QUESTION_NATIVE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/questions/:spaceKey/:questionId',
    /**
   * this will incorrectly match QUESTIONS_TOPIC_NATIVE
   * condition is used to prevent this
   */ condition: ({ params: params })=>Boolean(params.spaceKey && params.spaceKey !== 'topics')
});
const $ca532a827038ae75$export$dec9f53c339ce8f8 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'QUESTIONS_TOPICS_NATIVE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/questions/topics'
});
const $ca532a827038ae75$export$f80d02217688b484 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'QUESTIONS_TOPIC_NATIVE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/questions/topics/:topicName'
});
const $ca532a827038ae75$export$fdfdf584a0978d20 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'QUESTIONS_EXPERTS_NATIVE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/questions/experts'
});
const $ca532a827038ae75$export$6a85914fb9ca80a2 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CONTENT_HISTORY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/history/:contentId(\\d+)/:contentSlug?'
});
const $ca532a827038ae75$export$1f238fcead086ec3 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CONTENT_HISTORY_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/viewpreviousversions.action'
});
const $ca532a827038ae75$export$b74c113024023274 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_PAGE',
    ufoName: 'edit-page',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/:contentType(pages)/edit/:contentId(\\d+)'
});
const $ca532a827038ae75$export$45222bf0cb32d6e2 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_BLOG',
    ufoName: 'edit-page',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/:contentType(blog)/edit/:contentId(\\d+)'
});
const $ca532a827038ae75$export$7b1285e36c635f1f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_PAGE_V2',
    ufoName: 'edit-page',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/:contentType(pages)/edit-v2/:contentId(\\d+)',
    isTransition: $ca532a827038ae75$var$contentTransition
});
const $ca532a827038ae75$export$36dcea4e08feb5c9 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_BLOG_V2',
    ufoName: 'edit-page',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/:contentType(blog)/edit-v2/:contentId(\\d+)',
    isTransition: $ca532a827038ae75$var$contentTransition
});
const $ca532a827038ae75$export$e63a462ee45b57cf = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_PAGE_EMBED',
    ufoName: 'edit-page-embed',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/:contentType(pages)/edit-embed/:contentId(\\d+)'
});
const $ca532a827038ae75$export$bd17e6e353522e0d = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_PAGE_SMART_CREATE',
    ufoName: 'edit-page-smart-create',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/:contentType(pages)/edit-smart-create/:contentId(\\d+)'
});
const $ca532a827038ae75$export$4fe224de953acb46 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SMART_CREATE',
    ufoName: 'space-smart-create',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/space-smart-create'
});
const $ca532a827038ae75$export$54edf7c16c47aeef = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_CONTENT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/create-content/:contentType'
});
const $ca532a827038ae75$export$d6ae9e544e98926f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_PAGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/:contentType(pages)/create'
});
const $ca532a827038ae75$export$e8253e1b7e500d1c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_BLOG',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/:contentType(blog)/create'
});
const $ca532a827038ae75$export$9a4ff2d809fc4156 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'DELETE_PAGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/removepage.action\\?pageId=:contentId(\\d+)'
});
const $ca532a827038ae75$export$19c176cd0a878008 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ONBOARDING',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/welcome'
});
const $ca532a827038ae75$export$439074745692fe65 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_DIRECTORY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces'
});
const $ca532a827038ae75$export$2de9a69f9b51bb83 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/viewspacesummary.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$10f0439b47c8fdaf = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_REORDERPAGES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/reorderpages.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$d0ac6fa12f3acafa = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_HIDDEN_PAGES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/listorphanedpages.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$35123576da2e521 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_UNDEFINED_PAGES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/listundefinedpages.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$e18ccd8ffafdf3dd = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_ATTACHMENTS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/listattachmentsforspace.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$9c4e8cdcbbacdf8f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_APPLICATION_LINKS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + 'spaces/listentitylinks.action'
});
const $ca532a827038ae75$export$f85f59869a8dbbf8 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_RSS_FEEDS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + 'spaces/listrssfeeds.action'
});
const $ca532a827038ae75$export$d87089dbdd7eeaf3 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_OVERVIEW_REDIRECT_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/viewspace.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$dd174db99b3e6fea = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'DELETE_SPACE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/doremovespace.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$ef26ce515f06bc5e = Object.assign(/*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_INDEX',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey',
    /**
   * /spaces/:spaceKey will incorrectly match /spaces/something.action.
   * In that case the request should be sent to Monolith.
   */ condition: ({ params: params })=>Boolean(params.spaceKey && !params.spaceKey.endsWith('.action')),
    isTransition: $ca532a827038ae75$var$spaceTransition
}), {
    /**
   * Used for optimization purposes. See SPACE_OVERVIEW for more detail.
   */ HOMEPAGE_ID_QUERY_KEY: 'homepageId'
});
const $ca532a827038ae75$export$65b723bb995d4fb6 = Object.assign(/*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_OVERVIEW',
    ufoName: 'space-overview',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/overview',
    isTransition: $ca532a827038ae75$var$spaceTransition
}), {
    /**
   * The key/name of the optional space overview URL query parameter which was
   * introduced for optimization purposes only and is used by
   * `@confluence/query-preloaders` to preload space
   * homepage-related queries.
   */ HOMEPAGE_ID_QUERY_KEY: 'homepageId'
});
const $ca532a827038ae75$export$1009a7f2cc1ac09f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'HUB',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/hub'
});
const $ca532a827038ae75$export$4dd08bdd46db5924 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'HUB_EDIT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/hub/edit'
});
const $ca532a827038ae75$export$ada7925da580b561 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'COMPANY_HUB',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/company-hub'
});
const $ca532a827038ae75$export$29df24b01e938adf = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'COMPANY_HUB_ANALYTICS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/company-hub/analytics'
});
const $ca532a827038ae75$export$e003e97fab6b4368 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'COMPANY_HUB_EDIT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/company-hub/edit'
});
const $ca532a827038ae75$export$5f7be6e90830de0c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'COMPANY_HUB_SETTINGS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/company-hub/settings/:tab(general)?'
});
const $ca532a827038ae75$export$9257b5b55c8e2555 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'VIEW_PAGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?',
    isTransition: (previousMatch, currentMatch)=>(0, $bqMNb.isForceTransition)(previousMatch, currentMatch) || $ca532a827038ae75$var$contentTransition(previousMatch, currentMatch),
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'ViewPageRoute',
            whichExportToUse: 'ViewPageRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-view-page-route-killswitch'
    }
});
const $ca532a827038ae75$export$475fdaba8e6145bb = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'NEXT_VIEW_PAGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/next-pages/:contentId(\\d+)/:contentSlug?',
    isTransition: $ca532a827038ae75$var$contentTransition
});
const $ca532a827038ae75$export$347d3b5edaae00e0 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'BLOG_HOME',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/blog'
});
const $ca532a827038ae75$export$91f49e7b30a9d34 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'VIEW_BLOG',
    ufoName: 'blog',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/blog/:contentId(\\d+)/:contentSlug?',
    isTransition: $ca532a827038ae75$var$contentTransition,
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'ViewBlogRoute',
            whichExportToUse: 'ViewBlogRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-view-blog-route-killswitch'
    }
});
const $ca532a827038ae75$export$c259921a01da55b4 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'WHITEBOARD_HOME',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/whiteboard'
});
const $ca532a827038ae75$export$5b90ced7e51bcea0 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'WHITEBOARD_BOARD',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/whiteboard/:contentId'
});
const $ca532a827038ae75$export$7d8684a463b78f54 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CONTACT_ADMINISTRATOR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/contact-administrators'
});
const $ca532a827038ae75$export$eb54044908e4e0bd = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_SETTINGS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin'
});
const $ca532a827038ae75$export$506a1a071415f2e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_GLOBAL_AUTOMATION',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/automation'
});
const $ca532a827038ae75$export$4e4c6a9eb23f65ec = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_EDIT_EXTERNAL_SHARING',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/public-links'
});
const $ca532a827038ae75$export$37055aaa9d88b944 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_FORGE_APPS_REDIRECT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/forge\\?id=:id(.+)'
});
const $ca532a827038ae75$export$b17d28dbf200fde0 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_FORGE_APPS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/forge/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)?/:appRoutePath*'
});
const $ca532a827038ae75$export$5bfa1fef1b53dfdd = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_NEW_GLOBAL_PERMISSIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/permissions/global'
});
const $ca532a827038ae75$export$dd6de41f650dae89 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_COMPANY_HUB_PERMISSIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/permissions/hub/:tab(groups|users|guests)?'
});
const $ca532a827038ae75$export$8c6393d6207d929 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_COMPANY_HOME_BUILDER',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/look-and-feel/company-home-builder'
});
const $ca532a827038ae75$export$9397e0d80cf06055 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_CUSTOMIZE_NAVIGATION',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/look-and-feel/customize-navigation'
});
const $ca532a827038ae75$export$f107e7a692a3a54e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_NEW_GLOBAL_PERMISSIONS_USER_DETAILS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/permissions/global/user/:accountId'
});
const $ca532a827038ae75$export$5bbec961de23dce7 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_SITE_SPACE_PERMISSIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/permissions/space-permissions/:tab(defaults|allspaces|roles)?'
});
const $ca532a827038ae75$export$f0e8d063cba10e9c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_AUDIT_LOG',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/auditlogging.action'
});
const $ca532a827038ae75$export$3039840c47d9a13d = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_BROWSE_SHORTCUTS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/browseshortcuts.action'
});
const $ca532a827038ae75$export$e1e5a41fa357e66f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_CREATE_SHORTCUT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/createshortcut.action'
});
const $ca532a827038ae75$export$4fcc3f53642c593a = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_REMOVE_SHORTCUT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/removeshortcut.action'
});
const $ca532a827038ae75$export$7234e6926944adc0 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_DARK_FEATURES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/darkfeatures.action'
});
const $ca532a827038ae75$export$b86d7bd984fb9727 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_ENABLE_DARK_FEATURE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/enabledarkfeature.action'
});
const $ca532a827038ae75$export$1afd9317831e345e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_DISABLE_DARK_FEATURE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/disabledarkfeature.action'
});
const $ca532a827038ae75$export$9e8d02f6bdb565e9 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_BETA_FEATURES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/betafeatures'
});
const $ca532a827038ae75$export$f03a4adc711219ed = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_NEW_FEATURES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/newfeatures'
});
const $ca532a827038ae75$export$af040d7344c912d1 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_LIVE_EDIT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/liveedit'
});
const $ca532a827038ae75$export$70e53b90503ea1b9 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_NBM_MIGRATION',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/nbm-migration'
});
const $ca532a827038ae75$export$688990fbefa748b3 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_DC_SCRIPT_MIGRATION',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/script-migration'
});
const $ca532a827038ae75$export$99ff0b9560c4fd04 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_NBM_PERFORMANCE_REPORT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/nbm-performance-report'
});
const $ca532a827038ae75$export$2925d036bbc38c7 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_CALENDAR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/calendars\\?src=sidebar&openAddCalDialog=true'
});
const $ca532a827038ae75$export$351b62e6f5786a73 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_CALENDARS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/calendars'
});
const $ca532a827038ae75$export$4a2048bb71da8b4b = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_CALENDARS_SUBCALENDAR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/calendars/:subCalendarId'
});
const $ca532a827038ae75$export$7de5b687836953bd = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_EMBEDDED_SUBCALENDAR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/embedded/calendars/:subCalendarId'
});
const $ca532a827038ae75$export$27b2e48e28163360 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'DISCOVER',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/discover'
});
const $ca532a827038ae75$export$f178fb5b1e822288 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ALL_UPDATES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/discover/all-updates'
});
const $ca532a827038ae75$export$777796688df78f56 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'POPULAR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/discover/popular'
});
const $ca532a827038ae75$export$3907c7d8e57f70ba = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MY_WORK_HOME',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/my'
});
const $ca532a827038ae75$export$fe97ee265fd89939 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MY_WORK_DRAFTS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/my/drafts'
});
const $ca532a827038ae75$export$b71609db3dda2696 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MY_WORK_RECENT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/my/recent-work'
});
const $ca532a827038ae75$export$730392c243a0a367 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MY_RECENTLY_VISITED',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/my/recently-visited'
});
const $ca532a827038ae75$export$85bd3cea0cecb26c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MY_SAVED_FOR_LATER',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/my/saved-for-later'
});
const $ca532a827038ae75$export$c8a37c9f76d4d03f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'RECENT_PAGES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/recent'
});
const $ca532a827038ae75$export$771b75a6ca136f91 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'RECENT_VISITED',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/recent/visited'
});
const $ca532a827038ae75$export$8e4a8343b1614a02 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'RECENT_DRAFTS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/recent/draft'
});
const $ca532a827038ae75$export$2c9cf254b3b24ff = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'RECENT_SAVED',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/recent/saved'
});
const $ca532a827038ae75$export$d925029e7ceadd51 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'TEMPLATE_MIGRATION_PREVIEW',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/template/migration/preview\\?templateId=:contentId([0-9a-z-]+)'
});
const $ca532a827038ae75$export$e84c491e2d88d9f6 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_TEMPLATE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/templates/edit/:contentId([0-9a-z-]+)'
});
const $ca532a827038ae75$export$4ce9d0d8218b9d84 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SITE_SETTINGS_EDIT_TEMPLATE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/templates2/editpagetemplate.action',
    condition: ({ query: query })=>Boolean(query.entityId && Object.keys(query).length === 1)
});
const $ca532a827038ae75$export$a990a60696f54618 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_TEMPLATE_BLUEPRINT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/templates/edit/:pluginKey/:moduleKey'
});
const $ca532a827038ae75$export$f8d71dcb352ebe8c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_DEFAULT_BLUEPRINT_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/plugins/createcontent/edit-template.action',
    condition: ({ query: query })=>Boolean(query.key && query.contentTemplateRefId && Object.keys(query).length === 2) || Boolean(query.contentTemplateRefId && Object.keys(query).length === 1)
});
const $ca532a827038ae75$export$b45af2e1d7abb289 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SITE_SETTINGS_EDIT_SYSTEM_TEMPLATE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/plugins/createcontent/edit-template.action',
    condition: ({ query: query })=>Boolean(query.pluginKey && query.moduleKey && Object.keys(query).length === 2)
});
const $ca532a827038ae75$export$c0a209b0b0b16c75 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_TEMPLATE_SPACE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/templates/edit/:contentId([0-9a-z-]+)'
});
const $ca532a827038ae75$export$dcee5dee04648c93 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_TEMPLATE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/templates/create'
});
const $ca532a827038ae75$export$793ade69cc97583f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_TEMPLATE_SITE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/templates2/createpagetemplate.action'
});
const $ca532a827038ae75$export$499f432aa493cdd2 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_TEMPLATE_SPACE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/templates2/createpagetemplate.action',
    condition: ({ query: query })=>Boolean(query.key && Object.keys(query).length === 1)
});
const $ca532a827038ae75$export$dcda7f8b6fe54ba = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_TEMPLATE_SPACE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/templates/create'
});
const $ca532a827038ae75$export$9e430f65574f5333 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'HELLO_WORLD',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/hello-world'
});
const $ca532a827038ae75$export$e9d78b13bbb4e56f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'DASHBOARD_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/dashboard.action'
});
const $ca532a827038ae75$export$d7be6003270f6c2d = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPA_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spa.action'
});
const $ca532a827038ae75$export$b49467be269d2629 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'INDEX_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/index.action'
});
const $ca532a827038ae75$export$e52245e856f5c06 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_PAGE_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/createpage.action'
});
const $ca532a827038ae75$export$926e3916067d7530 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_BLOG_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/createblogpost.action'
});
const $ca532a827038ae75$export$e720b1e170b46aae = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CREATE_PAGE_VARIABLES_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/createpage-entervariables.action'
});
const $ca532a827038ae75$export$6c7b95dcf08f3a6d = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'RESUME_DRAFT_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/resumedraft.action'
});
const $ca532a827038ae75$export$b010f02787df1e6 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'COPY_PAGE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/copypage.action'
});
const $ca532a827038ae75$export$ecc28d15af39a8b2 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'VIEW_PAGE_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/viewpage.action',
    // viewpage.action should be served from Monolith when it has pageVersion query
    condition: ({ query: query })=>Boolean(query.pageId && Object.keys(query).length === 1)
});
const $ca532a827038ae75$export$482db086bc8c2289 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_OVERVIEW_INDEX_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/overview/index.action'
});
const $ca532a827038ae75$export$3afea7266d0d139b = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_INDEX_ACTION_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/index.action'
});
const $ca532a827038ae75$export$4eb80c3a4e6fbe0f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_PAGES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/pages'
});
const $ca532a827038ae75$export$bd2c9bb170b3681d = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'VIEW_BLOG_DATE_LEGACY',
    ufoName: 'blog',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?',
    isTransition: $ca532a827038ae75$var$contentTransition,
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'ViewBlogRoute',
            whichExportToUse: 'ViewBlogRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-view-blog-route-killswitch'
    }
});
const $ca532a827038ae75$export$5c9eaf42f32252ea = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ACTION_REDIRECT_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/(.*).action',
    condition: ({ query: query })=>query.key == null
});
const $ca532a827038ae75$export$7ae0ea91a2dfc4d9 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADVANCED_SEARCH_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/dosearchsite.action'
});
const $ca532a827038ae75$export$3bd4ec9f05d79904 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADVANCED_SEARCH',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/search',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'AdvancedSearchRoute',
            whichExportToUse: 'AdvancedSearchRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-search-route-killswitch'
    }
});
const $ca532a827038ae75$export$2bc30aa6642650c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'LABELLED_CONTENT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/label/:spaceKey/:labelName(.+)'
});
const $ca532a827038ae75$export$d593e642a326a501 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EXTERNAL_SHARE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/external/:contentId?/:externalToken'
});
const $ca532a827038ae75$export$6490fab56523ceda = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'PDF_EXPORT_PAGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pdf/spaces/:spaceKey/pages/:contentId(\\d+)'
});
const $ca532a827038ae75$export$dcb1d1a9cda087b1 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'PDF_EXPORT_SPACE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pdf/spaces/:spaceKey/pages/overview'
});
const $ca532a827038ae75$export$6b2db7909585abd7 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'LEGACY_SPACE_PDF_EXPORT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/flyingpdf/flyingpdf.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$2dd65cdecd8b05d7 = new (0, $fMEnQ.Route)({
    name: 'EXPORT_SPACE_CSV',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/exportspacecsv.action\\?key=:spaceKey'
});
const $ca532a827038ae75$export$d78f611c1ddf7234 = new (0, $fMEnQ.Route)({
    name: 'EXPORT_SPACE_XML',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/exportspacexml.action\\?key=:spaceKey'
});
const $ca532a827038ae75$export$9dc7f7e5e1435bc = new (0, $fMEnQ.Route)({
    name: 'EXPORT_SPACE_HTML',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/exportspacehtml.action\\?key=:spaceKey'
});
const $ca532a827038ae75$export$1bc544543b946246 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'VIEW_PAGE_MOBILE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/mobile/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?'
});
const $ca532a827038ae75$export$d387bb8ca9ce25d1 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'VIEW_BLOG_MOBILE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/mobile/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?'
});
const $ca532a827038ae75$export$3d8579587b62bb96 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MOBILE_MACRO_RENDERER',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/mobileapp/macro/:contentId(\\d+)'
});
const $ca532a827038ae75$export$f7bf92a6467c1557 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'PEOPLE_DIRECTORY_SEARCH',
    pattern: '/people/search'
});
const $ca532a827038ae75$export$ed260c82a3e70a6a = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CONFLUENCE_PEOPLE_DIRECTORY_SEARCH',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/people/search'
});
const $ca532a827038ae75$export$a90430d7f36bfe9e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MARKETPLACE_FIND_APPS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/marketplace(.*)'
});
const $ca532a827038ae75$export$22bb05181a4b1501 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MARKETPLACE_APP_REQUESTS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/marketplace/manage/app-requests'
});
const $ca532a827038ae75$export$cb73aa9f5b7d1ea0 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MARKETPLACE_MANAGE_PROMOTIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/marketplace/manage/promotions'
});
const $ca532a827038ae75$export$df78b182760b42f4 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'PEOPLE_DIRECTORY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/people/([\\w:-]+)*'
});
const $ca532a827038ae75$export$2d3703cff5d9a27 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_RESTRICTED_PAGES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/listpermissionpages.action'
});
const $ca532a827038ae75$export$60773cf116cf5f30 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_ARCHIVED_PAGES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/archivedpages'
});
const $ca532a827038ae75$export$40e965fb568c3c83 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'PAGE_DIFF_BY_VERSION',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/diffpagesbyversion.action'
});
const $ca532a827038ae75$export$cb80c94a905e11b6 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SITE_ANALYTICS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/analytics/:tab(overview|spaces|users|search)?'
});
const $ca532a827038ae75$export$93b558a6e07dbdac = new (0, $fMEnQ.Route)({
    name: 'SITE_ANALYTICS_PERMISSIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/analytics/permissions'
});
const $ca532a827038ae75$export$67acd8a63f03bc8 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_ANALYTICS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/analytics/:tab(overview|content|users)?'
});
const $ca532a827038ae75$export$6b9c632e635b4d77 = new (0, $fMEnQ.Route)({
    name: 'SPACE_ANALYTICS_PERMISSIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/analytics/permissions'
});
const $ca532a827038ae75$export$37a588b556645c19 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'PAGE_ANALYTICS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/analytics/:contentId(\\d+)/:tab(overview|mentions|links)?'
});
const $ca532a827038ae75$export$aded01fc53d469df = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_QUESTIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/display/:spaceKey/customcontent/list/ac%3Acom.atlassian.confluence.plugins.confluence-questions%3Aquestion'
});
const $ca532a827038ae75$export$cdd412f0619f2d7e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_QUESTIONS_NATIVE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/questions'
});
const $ca532a827038ae75$export$aa72b945229db170 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_QUESTION_NATIVE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/questions/:questionId'
});
const $ca532a827038ae75$export$f0c4a6dc3b3437aa = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_CUSTOM_CONTENT_LIST',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/display/:spaceKey/customcontent/list/:type'
});
const $ca532a827038ae75$export$1a5e481ee166ad7c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CUSTOM_CONTENT_VIEW',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/display/:spaceKey/customcontent/:contentId(\\d+)'
});
const $ca532a827038ae75$export$f39a30a3a5635bab = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_BULK_TOOLS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/bulktools'
});
const $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH = (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/settings';
const $ca532a827038ae75$export$3101773a7a844077 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_LANDING_PAGE',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/home'
});
const $ca532a827038ae75$export$f03524b1e395be4a = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_LANDING_PAGE_ALT',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH
});
const $ca532a827038ae75$export$38b94ff4631b44df = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_AUTOMATION',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/automation'
});
const $ca532a827038ae75$export$5f63ad7e18293ec2 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_DETAILS',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/details'
});
const $ca532a827038ae75$export$26dfba554adbf87e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_ARCHIVE_SPACE',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/archiveSpace'
});
const $ca532a827038ae75$export$1b93424785e5f745 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_TRASH_SPACE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/removespace.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$2cc9af506d64ef72 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_EDITOR_CONVERSION',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/editorConversion'
});
const $ca532a827038ae75$export$693d9b367ae8d0f7 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_RELATED_PAGES',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/relatedPages'
});
const $ca532a827038ae75$export$22f8e464aee70413 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_EDIT_FEATURES',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/editFeatures'
});
const $ca532a827038ae75$export$345aea7dc51bac8a = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_TEMPLATES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/settings/look-and-feel/templates'
});
const $ca532a827038ae75$export$499a561f6d1a011 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_EDIT_TEMPLATE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/templates2/editpagetemplate.action',
    condition: ({ query: query })=>Boolean(query.entityId && query.key && Object.keys(query).length === 2)
});
const $ca532a827038ae75$export$4f46a1e4250ebe18 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_LOOK_AND_FEEL_SETTINGS',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/look-and-feel/:tab(themes|templates|page-layout|pdf-export)'
});
const $ca532a827038ae75$export$e64d4514fc584fbe = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_PERMISSIONS_SETTINGS',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/permissions/:tab(groups|users|guests|anonymous|public-links|analytics|apps)?'
});
const $ca532a827038ae75$export$323161697c5fa666 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ROLE_BASED_ACCESS_CONTROL_HUB',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/roles-hub'
});
const $ca532a827038ae75$export$2f6a532274e0cd9d = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_PERMISSIONS_APPS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/addonpermissions.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$a007a4f7553ffc16 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EDIT_SPACE_PERMISSIONS_APPS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/editaddonpermissions.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$629e966630a1f92e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_MEMBERS',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/members'
});
const $ca532a827038ae75$export$f0e860396acf6277 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_FORGE_APPS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)/:appRoutePath*'
});
const $ca532a827038ae75$export$4442c9c7bb716896 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'GLOBAL_PAGE_FORGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)/:appRoutePath*'
});
const $ca532a827038ae75$export$abe337275802eab4 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'FULL_PAGE_FORGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/full-page/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:appRoutePath*'
});
const $ca532a827038ae75$export$ffd880217e61385f = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_FORGE_APPS',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)?/:appRoutePath*'
});
const $ca532a827038ae75$export$8bf619366f9e74f2 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_AVATARS_AND_STATUS',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/avatarsAndStatus'
});
const $ca532a827038ae75$export$a85b9c60514cd043 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_CONTENT_STATE',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/contentStatuses'
});
const $ca532a827038ae75$export$19b893a9e64dac94 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_DATA_CLASSIFICATION',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/classifications'
});
const $ca532a827038ae75$export$3d39129bec795227 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_WATERMARK_CONFIGURATION',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/watermark'
});
const $ca532a827038ae75$export$939b28e9f8987d97 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/exportSpaceUnavailable'
});
const $ca532a827038ae75$export$3582accdd821993a = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_EXPORT',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/export'
});
const $ca532a827038ae75$export$871ac71d42c178c5 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_LEGACY_CONTENT',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/legacy-content'
});
const $ca532a827038ae75$export$b8adcf19ff927cec = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_EXPORT_SPACE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/exportspacewelcome.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$751ae19fa150b7c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_TRASH',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/viewtrash.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$526ccce5d32f7beb = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'MOBILE_TAKEOVER_PAGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/mobileapp'
});
const $ca532a827038ae75$export$ed19a29c446e24d8 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'DEFAULT_ADMIN_MANAGE_APPS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/plugins/servlet/upm'
});
const $ca532a827038ae75$export$7de52f6cc232129e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_APP_AUDIT_LOGS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/plugins/servlet/upm/log'
});
const $ca532a827038ae75$export$81cfd93b1b89cd07 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_SETTINGS_TEMPLATE_LIST_PAGE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/pages/templates2/listpagetemplates.action\\?key=:spaceKey([^&]+)'
});
const $ca532a827038ae75$export$31745f3bff21cd = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_TEMPLATES_AND_BLUEPRINTS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/templates-and-blueprints'
});
const $ca532a827038ae75$export$7af7a1e753a92264 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_APPLICATION_NAVIGATOR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/application-navigator'
});
const $ca532a827038ae75$export$28e7e683f23a58d3 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'CUSTOM_CONTENTS_ON_PAGE_LIST',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/display/:spaceKey/pages/:contentId(\\d+)/customcontents/:type?'
});
const $ca532a827038ae75$export$3ce513606c31c918 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_ANNOUNCEMENT_BANNER_RENDERER',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/announcements/:id(.*)?'
});
const $ca532a827038ae75$export$dfa725d05e18145e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'USER_ACCESS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/user-access'
});
const $ca532a827038ae75$export$8674e83405059790 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'PERMISSIONS_EXPORT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/permissions-export'
});
const $ca532a827038ae75$export$652395dc5ff9b416 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'IMPORTER_STATUS_DASHBOARD',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/importer-status-dashboard'
});
const $ca532a827038ae75$export$4d1bccc78b263a8e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'SPACE_MANAGER',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/space-manager'
});
const $ca532a827038ae75$export$df327d9b56ca6b7c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_CENTER',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/center'
});
const $ca532a827038ae75$export$53f195d79ef3d4dd = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_CENTER_SPACE',
    pattern: $ca532a827038ae75$var$SPACE_SETTINGS_CONTEXT_PATH + '/mission-control'
});
const $ca532a827038ae75$export$23e7002e5e9ef89e = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_TEAM_CALENDARS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/teamcalendars'
});
const $ca532a827038ae75$export$299af9061dea1f09 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_CONFIGURATION',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/configuration'
});
const $ca532a827038ae75$export$eb5a785192323bd3 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_DEFAULT_SPACE_LOGO',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/default-space-logo'
});
const $ca532a827038ae75$export$168f3acd059931e0 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_HEADER_AND_FOOTER',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/header-and-footer'
});
const $ca532a827038ae75$export$3bcebf4f1e82d3ad = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_SECURITY_CONFIGURATION',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/security-configuration'
});
const $ca532a827038ae75$export$42599f111394c36c = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_SPACE_REPORTS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/space-reports'
});
const $ca532a827038ae75$export$e05db3c2f69bd3ae = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_COLOR_SCHEME',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/color-scheme'
});
const $ca532a827038ae75$export$4c6bf75100b3b72 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_CODE_MACRO_CONFIGURATION',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/code-macro-configuration'
});
const $ca532a827038ae75$export$70914a626e2f0488 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_TRASHED_SPACES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/trashed-spaces'
});
const $ca532a827038ae75$export$3d0698fcdc33631d = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_IMPORT_SPACES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/space-import'
});
const $ca532a827038ae75$export$85c61af9d225a707 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_JIRA_MACRO_REPAIR',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/jira-macro-repair'
});
const $ca532a827038ae75$export$c0d0d3f98d45e5f1 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_MACRO_USAGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/macro-usage'
});
const $ca532a827038ae75$export$69df75bd8c217ade = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_MACRO_USAGE_LEGACY',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/pluginusage.action'
});
const $ca532a827038ae75$export$e8beba40e140a443 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_THEMES',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/themes'
});
const $ca532a827038ae75$export$c471be73599ccae1 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_PDF_EXPORT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/pdf-export'
});
const $ca532a827038ae75$export$9859a7a7049d0585 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'DATABASE_CUSTOM_OVERVIEW',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/custom/database/overview'
});
const $ca532a827038ae75$export$90480461935b54cc = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'DATABASE_CUSTOM_VIEW',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/custom/database/:contentId(\\d+)'
});
const $ca532a827038ae75$export$851ba2be5095d586 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'DATABASE_VIEW',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/database/:contentId'
});
const $ca532a827038ae75$export$84b5e15197aaaa12 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'EMBED_VIEW',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/embed/:contentId'
});
const $ca532a827038ae75$export$4dcf771d1a1901ef = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'FOLDER_VIEW',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/folder/:contentId'
});
const $ca532a827038ae75$export$752c480a913a6712 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_BULK_PERMISSIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/permissions/bulk-permissions'
});
const $ca532a827038ae75$export$16172a64bcdb79f8 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ADMIN_NOTIFICATIONS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/notifications'
});
const $ca532a827038ae75$export$59a52cdd0906f4cb = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'TOPICS',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/topics/:topicId'
});
const $ca532a827038ae75$export$57a75dda1f25b360 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'PREMIUM_ADMIN_FEATURES_EXPERIMENT',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/admin/premium-admin-features'
});
const $ca532a827038ae75$export$3ebf2fc23df50648 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'ATTACHMENTS_PAGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/spaces/:spaceKey/attachments/:contentId(\\d+)?'
});
const $ca532a827038ae75$export$96e9320cb2b14c85 = /*@__PURE__*/ new (0, $fMEnQ.Route)({
    name: 'AI_SEARCH_PAGE',
    pattern: (0, $jlIaF.CONTEXT_PATH) + '/ai-search/'
});
module.exports["BASE"] = $ca532a827038ae75$export$9e15ff8aa6bc996f;
module.exports["WIKI"] = $ca532a827038ae75$export$2fd309376969662f;
module.exports["HOME"] = $ca532a827038ae75$export$a7c5707626fc90f;
module.exports["TEMPLATE_GALLERY"] = $ca532a827038ae75$export$6ccd7dc0d5aa30b0;
module.exports["CALENDAR"] = $ca532a827038ae75$export$7d65e474be175151;
module.exports["MY_CALENDAR"] = $ca532a827038ae75$export$ec8a7da990877da3;
module.exports["MULTIPLE_SUBCALENDAR"] = $ca532a827038ae75$export$e492b3d04985e9fb;
module.exports["EMBEDDED_MULTIPLE_SUBCALENDAR"] = $ca532a827038ae75$export$57fb93d8931ad943;
module.exports["QUESTIONS"] = $ca532a827038ae75$export$aa473411bddb7e17;
module.exports["QUESTIONS_NATIVE"] = $ca532a827038ae75$export$42bb8ba9cae96927;
module.exports["QUESTION_NATIVE"] = $ca532a827038ae75$export$1e92de3a3dba0876;
module.exports["QUESTIONS_TOPICS_NATIVE"] = $ca532a827038ae75$export$dec9f53c339ce8f8;
module.exports["QUESTIONS_TOPIC_NATIVE"] = $ca532a827038ae75$export$f80d02217688b484;
module.exports["QUESTIONS_EXPERTS_NATIVE"] = $ca532a827038ae75$export$fdfdf584a0978d20;
module.exports["CONTENT_HISTORY"] = $ca532a827038ae75$export$6a85914fb9ca80a2;
module.exports["CONTENT_HISTORY_LEGACY"] = $ca532a827038ae75$export$1f238fcead086ec3;
module.exports["EDIT_PAGE"] = $ca532a827038ae75$export$b74c113024023274;
module.exports["EDIT_BLOG"] = $ca532a827038ae75$export$45222bf0cb32d6e2;
module.exports["EDIT_PAGE_V2"] = $ca532a827038ae75$export$7b1285e36c635f1f;
module.exports["EDIT_BLOG_V2"] = $ca532a827038ae75$export$36dcea4e08feb5c9;
module.exports["EDIT_PAGE_EMBED"] = $ca532a827038ae75$export$e63a462ee45b57cf;
module.exports["EDIT_PAGE_SMART_CREATE"] = $ca532a827038ae75$export$bd17e6e353522e0d;
module.exports["SPACE_SMART_CREATE"] = $ca532a827038ae75$export$4fe224de953acb46;
module.exports["CREATE_CONTENT"] = $ca532a827038ae75$export$54edf7c16c47aeef;
module.exports["CREATE_PAGE"] = $ca532a827038ae75$export$d6ae9e544e98926f;
module.exports["CREATE_BLOG"] = $ca532a827038ae75$export$e8253e1b7e500d1c;
module.exports["DELETE_PAGE"] = $ca532a827038ae75$export$9a4ff2d809fc4156;
module.exports["ONBOARDING"] = $ca532a827038ae75$export$19c176cd0a878008;
module.exports["SPACE_DIRECTORY"] = $ca532a827038ae75$export$439074745692fe65;
module.exports["SPACE_SETTINGS"] = $ca532a827038ae75$export$2de9a69f9b51bb83;
module.exports["SPACE_SETTINGS_REORDERPAGES"] = $ca532a827038ae75$export$10f0439b47c8fdaf;
module.exports["SPACE_SETTINGS_HIDDEN_PAGES"] = $ca532a827038ae75$export$d0ac6fa12f3acafa;
module.exports["SPACE_SETTINGS_UNDEFINED_PAGES"] = $ca532a827038ae75$export$35123576da2e521;
module.exports["SPACE_SETTINGS_ATTACHMENTS"] = $ca532a827038ae75$export$e18ccd8ffafdf3dd;
module.exports["SPACE_SETTINGS_APPLICATION_LINKS"] = $ca532a827038ae75$export$9c4e8cdcbbacdf8f;
module.exports["SPACE_SETTINGS_RSS_FEEDS"] = $ca532a827038ae75$export$f85f59869a8dbbf8;
module.exports["SPACE_OVERVIEW_REDIRECT_LEGACY"] = $ca532a827038ae75$export$d87089dbdd7eeaf3;
module.exports["DELETE_SPACE_LEGACY"] = $ca532a827038ae75$export$dd174db99b3e6fea;
module.exports["SPACE_INDEX"] = $ca532a827038ae75$export$ef26ce515f06bc5e;
module.exports["SPACE_OVERVIEW"] = $ca532a827038ae75$export$65b723bb995d4fb6;
module.exports["HUB"] = $ca532a827038ae75$export$1009a7f2cc1ac09f;
module.exports["HUB_EDIT"] = $ca532a827038ae75$export$4dd08bdd46db5924;
module.exports["COMPANY_HUB"] = $ca532a827038ae75$export$ada7925da580b561;
module.exports["COMPANY_HUB_ANALYTICS"] = $ca532a827038ae75$export$29df24b01e938adf;
module.exports["COMPANY_HUB_EDIT"] = $ca532a827038ae75$export$e003e97fab6b4368;
module.exports["COMPANY_HUB_SETTINGS"] = $ca532a827038ae75$export$5f7be6e90830de0c;
module.exports["VIEW_PAGE"] = $ca532a827038ae75$export$9257b5b55c8e2555;
module.exports["NEXT_VIEW_PAGE"] = $ca532a827038ae75$export$475fdaba8e6145bb;
module.exports["BLOG_HOME"] = $ca532a827038ae75$export$347d3b5edaae00e0;
module.exports["VIEW_BLOG"] = $ca532a827038ae75$export$91f49e7b30a9d34;
module.exports["WHITEBOARD_HOME"] = $ca532a827038ae75$export$c259921a01da55b4;
module.exports["WHITEBOARD_BOARD"] = $ca532a827038ae75$export$5b90ced7e51bcea0;
module.exports["CONTACT_ADMINISTRATOR"] = $ca532a827038ae75$export$7d8684a463b78f54;
module.exports["ADMIN_SETTINGS"] = $ca532a827038ae75$export$eb54044908e4e0bd;
module.exports["ADMIN_GLOBAL_AUTOMATION"] = $ca532a827038ae75$export$506a1a071415f2e;
module.exports["ADMIN_EDIT_EXTERNAL_SHARING"] = $ca532a827038ae75$export$4e4c6a9eb23f65ec;
module.exports["ADMIN_FORGE_APPS_REDIRECT"] = $ca532a827038ae75$export$37055aaa9d88b944;
module.exports["ADMIN_FORGE_APPS"] = $ca532a827038ae75$export$b17d28dbf200fde0;
module.exports["ADMIN_NEW_GLOBAL_PERMISSIONS"] = $ca532a827038ae75$export$5bfa1fef1b53dfdd;
module.exports["ADMIN_COMPANY_HUB_PERMISSIONS"] = $ca532a827038ae75$export$dd6de41f650dae89;
module.exports["ADMIN_COMPANY_HOME_BUILDER"] = $ca532a827038ae75$export$8c6393d6207d929;
module.exports["ADMIN_CUSTOMIZE_NAVIGATION"] = $ca532a827038ae75$export$9397e0d80cf06055;
module.exports["ADMIN_NEW_GLOBAL_PERMISSIONS_USER_DETAILS"] = $ca532a827038ae75$export$f107e7a692a3a54e;
module.exports["ADMIN_SITE_SPACE_PERMISSIONS"] = $ca532a827038ae75$export$5bbec961de23dce7;
module.exports["ADMIN_AUDIT_LOG"] = $ca532a827038ae75$export$f0e8d063cba10e9c;
module.exports["ADMIN_BROWSE_SHORTCUTS"] = $ca532a827038ae75$export$3039840c47d9a13d;
module.exports["ADMIN_CREATE_SHORTCUT"] = $ca532a827038ae75$export$e1e5a41fa357e66f;
module.exports["ADMIN_REMOVE_SHORTCUT"] = $ca532a827038ae75$export$4fcc3f53642c593a;
module.exports["ADMIN_DARK_FEATURES"] = $ca532a827038ae75$export$7234e6926944adc0;
module.exports["ADMIN_ENABLE_DARK_FEATURE"] = $ca532a827038ae75$export$b86d7bd984fb9727;
module.exports["ADMIN_DISABLE_DARK_FEATURE"] = $ca532a827038ae75$export$1afd9317831e345e;
module.exports["ADMIN_BETA_FEATURES"] = $ca532a827038ae75$export$9e8d02f6bdb565e9;
module.exports["ADMIN_NEW_FEATURES"] = $ca532a827038ae75$export$f03a4adc711219ed;
module.exports["ADMIN_LIVE_EDIT"] = $ca532a827038ae75$export$af040d7344c912d1;
module.exports["ADMIN_NBM_MIGRATION"] = $ca532a827038ae75$export$70e53b90503ea1b9;
module.exports["ADMIN_DC_SCRIPT_MIGRATION"] = $ca532a827038ae75$export$688990fbefa748b3;
module.exports["ADMIN_NBM_PERFORMANCE_REPORT"] = $ca532a827038ae75$export$99ff0b9560c4fd04;
module.exports["SPACE_CALENDAR"] = $ca532a827038ae75$export$2925d036bbc38c7;
module.exports["SPACE_CALENDARS"] = $ca532a827038ae75$export$351b62e6f5786a73;
module.exports["SPACE_CALENDARS_SUBCALENDAR"] = $ca532a827038ae75$export$4a2048bb71da8b4b;
module.exports["SPACE_EMBEDDED_SUBCALENDAR"] = $ca532a827038ae75$export$7de5b687836953bd;
module.exports["DISCOVER"] = $ca532a827038ae75$export$27b2e48e28163360;
module.exports["ALL_UPDATES"] = $ca532a827038ae75$export$f178fb5b1e822288;
module.exports["POPULAR"] = $ca532a827038ae75$export$777796688df78f56;
module.exports["MY_WORK_HOME"] = $ca532a827038ae75$export$3907c7d8e57f70ba;
module.exports["MY_WORK_DRAFTS"] = $ca532a827038ae75$export$fe97ee265fd89939;
module.exports["MY_WORK_RECENT"] = $ca532a827038ae75$export$b71609db3dda2696;
module.exports["MY_RECENTLY_VISITED"] = $ca532a827038ae75$export$730392c243a0a367;
module.exports["MY_SAVED_FOR_LATER"] = $ca532a827038ae75$export$85bd3cea0cecb26c;
module.exports["RECENT_PAGES"] = $ca532a827038ae75$export$c8a37c9f76d4d03f;
module.exports["RECENT_VISITED"] = $ca532a827038ae75$export$771b75a6ca136f91;
module.exports["RECENT_DRAFTS"] = $ca532a827038ae75$export$8e4a8343b1614a02;
module.exports["RECENT_SAVED"] = $ca532a827038ae75$export$2c9cf254b3b24ff;
module.exports["TEMPLATE_MIGRATION_PREVIEW"] = $ca532a827038ae75$export$d925029e7ceadd51;
module.exports["EDIT_TEMPLATE"] = $ca532a827038ae75$export$e84c491e2d88d9f6;
module.exports["SITE_SETTINGS_EDIT_TEMPLATE_LEGACY"] = $ca532a827038ae75$export$4ce9d0d8218b9d84;
module.exports["EDIT_TEMPLATE_BLUEPRINT"] = $ca532a827038ae75$export$a990a60696f54618;
module.exports["EDIT_DEFAULT_BLUEPRINT_LEGACY"] = $ca532a827038ae75$export$f8d71dcb352ebe8c;
module.exports["SITE_SETTINGS_EDIT_SYSTEM_TEMPLATE_LEGACY"] = $ca532a827038ae75$export$b45af2e1d7abb289;
module.exports["EDIT_TEMPLATE_SPACE"] = $ca532a827038ae75$export$c0a209b0b0b16c75;
module.exports["CREATE_TEMPLATE"] = $ca532a827038ae75$export$dcee5dee04648c93;
module.exports["CREATE_TEMPLATE_SITE_LEGACY"] = $ca532a827038ae75$export$793ade69cc97583f;
module.exports["CREATE_TEMPLATE_SPACE_LEGACY"] = $ca532a827038ae75$export$499f432aa493cdd2;
module.exports["CREATE_TEMPLATE_SPACE"] = $ca532a827038ae75$export$dcda7f8b6fe54ba;
module.exports["HELLO_WORLD"] = $ca532a827038ae75$export$9e430f65574f5333;
module.exports["DASHBOARD_ACTION_LEGACY"] = $ca532a827038ae75$export$e9d78b13bbb4e56f;
module.exports["SPA_ACTION_LEGACY"] = $ca532a827038ae75$export$d7be6003270f6c2d;
module.exports["INDEX_ACTION_LEGACY"] = $ca532a827038ae75$export$b49467be269d2629;
module.exports["CREATE_PAGE_ACTION_LEGACY"] = $ca532a827038ae75$export$e52245e856f5c06;
module.exports["CREATE_BLOG_ACTION_LEGACY"] = $ca532a827038ae75$export$926e3916067d7530;
module.exports["CREATE_PAGE_VARIABLES_ACTION_LEGACY"] = $ca532a827038ae75$export$e720b1e170b46aae;
module.exports["RESUME_DRAFT_LEGACY"] = $ca532a827038ae75$export$6c7b95dcf08f3a6d;
module.exports["COPY_PAGE_LEGACY"] = $ca532a827038ae75$export$b010f02787df1e6;
module.exports["VIEW_PAGE_ACTION_LEGACY"] = $ca532a827038ae75$export$ecc28d15af39a8b2;
module.exports["SPACE_OVERVIEW_INDEX_ACTION_LEGACY"] = $ca532a827038ae75$export$482db086bc8c2289;
module.exports["SPACE_INDEX_ACTION_LEGACY"] = $ca532a827038ae75$export$3afea7266d0d139b;
module.exports["SPACE_PAGES"] = $ca532a827038ae75$export$4eb80c3a4e6fbe0f;
module.exports["VIEW_BLOG_DATE_LEGACY"] = $ca532a827038ae75$export$bd2c9bb170b3681d;
module.exports["ACTION_REDIRECT_LEGACY"] = $ca532a827038ae75$export$5c9eaf42f32252ea;
module.exports["ADVANCED_SEARCH_LEGACY"] = $ca532a827038ae75$export$7ae0ea91a2dfc4d9;
module.exports["ADVANCED_SEARCH"] = $ca532a827038ae75$export$3bd4ec9f05d79904;
module.exports["LABELLED_CONTENT"] = $ca532a827038ae75$export$2bc30aa6642650c;
module.exports["EXTERNAL_SHARE"] = $ca532a827038ae75$export$d593e642a326a501;
module.exports["PDF_EXPORT_PAGE"] = $ca532a827038ae75$export$6490fab56523ceda;
module.exports["PDF_EXPORT_SPACE"] = $ca532a827038ae75$export$dcb1d1a9cda087b1;
module.exports["LEGACY_SPACE_PDF_EXPORT"] = $ca532a827038ae75$export$6b2db7909585abd7;
module.exports["EXPORT_SPACE_CSV"] = $ca532a827038ae75$export$2dd65cdecd8b05d7;
module.exports["EXPORT_SPACE_XML"] = $ca532a827038ae75$export$d78f611c1ddf7234;
module.exports["EXPORT_SPACE_HTML"] = $ca532a827038ae75$export$9dc7f7e5e1435bc;
module.exports["VIEW_PAGE_MOBILE"] = $ca532a827038ae75$export$1bc544543b946246;
module.exports["VIEW_BLOG_MOBILE"] = $ca532a827038ae75$export$d387bb8ca9ce25d1;
module.exports["MOBILE_MACRO_RENDERER"] = $ca532a827038ae75$export$3d8579587b62bb96;
module.exports["PEOPLE_DIRECTORY_SEARCH"] = $ca532a827038ae75$export$f7bf92a6467c1557;
module.exports["CONFLUENCE_PEOPLE_DIRECTORY_SEARCH"] = $ca532a827038ae75$export$ed260c82a3e70a6a;
module.exports["MARKETPLACE_FIND_APPS"] = $ca532a827038ae75$export$a90430d7f36bfe9e;
module.exports["MARKETPLACE_APP_REQUESTS"] = $ca532a827038ae75$export$22bb05181a4b1501;
module.exports["MARKETPLACE_MANAGE_PROMOTIONS"] = $ca532a827038ae75$export$cb73aa9f5b7d1ea0;
module.exports["PEOPLE_DIRECTORY"] = $ca532a827038ae75$export$df78b182760b42f4;
module.exports["SPACE_RESTRICTED_PAGES"] = $ca532a827038ae75$export$2d3703cff5d9a27;
module.exports["SPACE_ARCHIVED_PAGES"] = $ca532a827038ae75$export$60773cf116cf5f30;
module.exports["PAGE_DIFF_BY_VERSION"] = $ca532a827038ae75$export$40e965fb568c3c83;
module.exports["SITE_ANALYTICS"] = $ca532a827038ae75$export$cb80c94a905e11b6;
module.exports["SITE_ANALYTICS_PERMISSIONS"] = $ca532a827038ae75$export$93b558a6e07dbdac;
module.exports["SPACE_ANALYTICS"] = $ca532a827038ae75$export$67acd8a63f03bc8;
module.exports["SPACE_ANALYTICS_PERMISSIONS"] = $ca532a827038ae75$export$6b9c632e635b4d77;
module.exports["PAGE_ANALYTICS"] = $ca532a827038ae75$export$37a588b556645c19;
module.exports["SPACE_QUESTIONS"] = $ca532a827038ae75$export$aded01fc53d469df;
module.exports["SPACE_QUESTIONS_NATIVE"] = $ca532a827038ae75$export$cdd412f0619f2d7e;
module.exports["SPACE_QUESTION_NATIVE"] = $ca532a827038ae75$export$aa72b945229db170;
module.exports["SPACE_CUSTOM_CONTENT_LIST"] = $ca532a827038ae75$export$f0c4a6dc3b3437aa;
module.exports["CUSTOM_CONTENT_VIEW"] = $ca532a827038ae75$export$1a5e481ee166ad7c;
module.exports["SPACE_BULK_TOOLS"] = $ca532a827038ae75$export$f39a30a3a5635bab;
module.exports["SPACE_SETTINGS_LANDING_PAGE"] = $ca532a827038ae75$export$3101773a7a844077;
module.exports["SPACE_SETTINGS_LANDING_PAGE_ALT"] = $ca532a827038ae75$export$f03524b1e395be4a;
module.exports["SPACE_SETTINGS_AUTOMATION"] = $ca532a827038ae75$export$38b94ff4631b44df;
module.exports["SPACE_SETTINGS_DETAILS"] = $ca532a827038ae75$export$5f63ad7e18293ec2;
module.exports["SPACE_SETTINGS_ARCHIVE_SPACE"] = $ca532a827038ae75$export$26dfba554adbf87e;
module.exports["SPACE_SETTINGS_TRASH_SPACE"] = $ca532a827038ae75$export$1b93424785e5f745;
module.exports["SPACE_SETTINGS_EDITOR_CONVERSION"] = $ca532a827038ae75$export$2cc9af506d64ef72;
module.exports["SPACE_SETTINGS_RELATED_PAGES"] = $ca532a827038ae75$export$693d9b367ae8d0f7;
module.exports["SPACE_SETTINGS_EDIT_FEATURES"] = $ca532a827038ae75$export$22f8e464aee70413;
module.exports["SPACE_SETTINGS_TEMPLATES"] = $ca532a827038ae75$export$345aea7dc51bac8a;
module.exports["SPACE_SETTINGS_EDIT_TEMPLATE_LEGACY"] = $ca532a827038ae75$export$499a561f6d1a011;
module.exports["SPACE_LOOK_AND_FEEL_SETTINGS"] = $ca532a827038ae75$export$4f46a1e4250ebe18;
module.exports["SPACE_PERMISSIONS_SETTINGS"] = $ca532a827038ae75$export$e64d4514fc584fbe;
module.exports["ROLE_BASED_ACCESS_CONTROL_HUB"] = $ca532a827038ae75$export$323161697c5fa666;
module.exports["SPACE_PERMISSIONS_APPS"] = $ca532a827038ae75$export$2f6a532274e0cd9d;
module.exports["EDIT_SPACE_PERMISSIONS_APPS"] = $ca532a827038ae75$export$a007a4f7553ffc16;
module.exports["SPACE_MEMBERS"] = $ca532a827038ae75$export$629e966630a1f92e;
module.exports["SPACE_FORGE_APPS"] = $ca532a827038ae75$export$f0e860396acf6277;
module.exports["GLOBAL_PAGE_FORGE"] = $ca532a827038ae75$export$4442c9c7bb716896;
module.exports["FULL_PAGE_FORGE"] = $ca532a827038ae75$export$abe337275802eab4;
module.exports["SPACE_SETTINGS_FORGE_APPS"] = $ca532a827038ae75$export$ffd880217e61385f;
module.exports["SPACE_SETTINGS_AVATARS_AND_STATUS"] = $ca532a827038ae75$export$8bf619366f9e74f2;
module.exports["SPACE_SETTINGS_CONTENT_STATE"] = $ca532a827038ae75$export$a85b9c60514cd043;
module.exports["SPACE_SETTINGS_DATA_CLASSIFICATION"] = $ca532a827038ae75$export$19b893a9e64dac94;
module.exports["SPACE_SETTINGS_WATERMARK_CONFIGURATION"] = $ca532a827038ae75$export$3d39129bec795227;
module.exports["SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE"] = $ca532a827038ae75$export$939b28e9f8987d97;
module.exports["SPACE_SETTINGS_EXPORT"] = $ca532a827038ae75$export$3582accdd821993a;
module.exports["SPACE_LEGACY_CONTENT"] = $ca532a827038ae75$export$871ac71d42c178c5;
module.exports["SPACE_SETTINGS_EXPORT_SPACE"] = $ca532a827038ae75$export$b8adcf19ff927cec;
module.exports["SPACE_TRASH"] = $ca532a827038ae75$export$751ae19fa150b7c;
module.exports["MOBILE_TAKEOVER_PAGE"] = $ca532a827038ae75$export$526ccce5d32f7beb;
module.exports["DEFAULT_ADMIN_MANAGE_APPS"] = $ca532a827038ae75$export$ed19a29c446e24d8;
module.exports["ADMIN_APP_AUDIT_LOGS"] = $ca532a827038ae75$export$7de52f6cc232129e;
module.exports["SPACE_SETTINGS_TEMPLATE_LIST_PAGE_LEGACY"] = $ca532a827038ae75$export$81cfd93b1b89cd07;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS"] = $ca532a827038ae75$export$31745f3bff21cd;
module.exports["ADMIN_APPLICATION_NAVIGATOR"] = $ca532a827038ae75$export$7af7a1e753a92264;
module.exports["CUSTOM_CONTENTS_ON_PAGE_LIST"] = $ca532a827038ae75$export$28e7e683f23a58d3;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_RENDERER"] = $ca532a827038ae75$export$3ce513606c31c918;
module.exports["USER_ACCESS"] = $ca532a827038ae75$export$dfa725d05e18145e;
module.exports["PERMISSIONS_EXPORT"] = $ca532a827038ae75$export$8674e83405059790;
module.exports["IMPORTER_STATUS_DASHBOARD"] = $ca532a827038ae75$export$652395dc5ff9b416;
module.exports["SPACE_MANAGER"] = $ca532a827038ae75$export$4d1bccc78b263a8e;
module.exports["ADMIN_CENTER"] = $ca532a827038ae75$export$df327d9b56ca6b7c;
module.exports["ADMIN_CENTER_SPACE"] = $ca532a827038ae75$export$53f195d79ef3d4dd;
module.exports["ADMIN_TEAM_CALENDARS"] = $ca532a827038ae75$export$23e7002e5e9ef89e;
module.exports["ADMIN_CONFIGURATION"] = $ca532a827038ae75$export$299af9061dea1f09;
module.exports["ADMIN_DEFAULT_SPACE_LOGO"] = $ca532a827038ae75$export$eb5a785192323bd3;
module.exports["ADMIN_HEADER_AND_FOOTER"] = $ca532a827038ae75$export$168f3acd059931e0;
module.exports["ADMIN_SECURITY_CONFIGURATION"] = $ca532a827038ae75$export$3bcebf4f1e82d3ad;
module.exports["ADMIN_SPACE_REPORTS"] = $ca532a827038ae75$export$42599f111394c36c;
module.exports["ADMIN_COLOR_SCHEME"] = $ca532a827038ae75$export$e05db3c2f69bd3ae;
module.exports["ADMIN_CODE_MACRO_CONFIGURATION"] = $ca532a827038ae75$export$4c6bf75100b3b72;
module.exports["ADMIN_TRASHED_SPACES"] = $ca532a827038ae75$export$70914a626e2f0488;
module.exports["ADMIN_IMPORT_SPACES"] = $ca532a827038ae75$export$3d0698fcdc33631d;
module.exports["ADMIN_JIRA_MACRO_REPAIR"] = $ca532a827038ae75$export$85c61af9d225a707;
module.exports["ADMIN_MACRO_USAGE"] = $ca532a827038ae75$export$c0d0d3f98d45e5f1;
module.exports["ADMIN_MACRO_USAGE_LEGACY"] = $ca532a827038ae75$export$69df75bd8c217ade;
module.exports["ADMIN_THEMES"] = $ca532a827038ae75$export$e8beba40e140a443;
module.exports["ADMIN_PDF_EXPORT"] = $ca532a827038ae75$export$c471be73599ccae1;
module.exports["DATABASE_CUSTOM_OVERVIEW"] = $ca532a827038ae75$export$9859a7a7049d0585;
module.exports["DATABASE_CUSTOM_VIEW"] = $ca532a827038ae75$export$90480461935b54cc;
module.exports["DATABASE_VIEW"] = $ca532a827038ae75$export$851ba2be5095d586;
module.exports["EMBED_VIEW"] = $ca532a827038ae75$export$84b5e15197aaaa12;
module.exports["FOLDER_VIEW"] = $ca532a827038ae75$export$4dcf771d1a1901ef;
module.exports["ADMIN_BULK_PERMISSIONS"] = $ca532a827038ae75$export$752c480a913a6712;
module.exports["ADMIN_NOTIFICATIONS"] = $ca532a827038ae75$export$16172a64bcdb79f8;
module.exports["TOPICS"] = $ca532a827038ae75$export$59a52cdd0906f4cb;
module.exports["PREMIUM_ADMIN_FEATURES_EXPERIMENT"] = $ca532a827038ae75$export$57a75dda1f25b360;
module.exports["ATTACHMENTS_PAGE"] = $ca532a827038ae75$export$3ebf2fc23df50648;
module.exports["AI_SEARCH_PAGE"] = $ca532a827038ae75$export$96e9320cb2b14c85;

});

parcelRegister("fMEnQ", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $QU6QS = parcelRequire("QU6QS");

function $115737db32c49698$export$b5d8fba258cc9e89(pattern, url) {
    const parsed = (0, $jiJCD.parse)(url, true);
    const pathname = parsed.pathname || '';
    let match = (0, $QU6QS.matchPath)(pathname, {
        path: pattern,
        exact: true
    });
    // some of our routes need query params to match
    if (!match) match = (0, $QU6QS.matchPath)(`${pathname}${parsed.search}`, {
        path: pattern,
        exact: true
    });
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match.params) for (const [key, value] of Object.entries(match.params)){
        let decodedValue = value;
        if (typeof value !== 'undefined') {
            try {
                // decodeURIComponent("%") throws "URI malformed" error
                decodedValue = decodeURIComponent(value);
            } catch (e) {}
            decodedParams[key] = decodedValue;
        }
    }
    return {
        url: url,
        pathname: pathname,
        search: parsed.search || '',
        hash: parsed.hash || '',
        pattern: pattern,
        params: decodedParams,
        query: parsed.query || ''
    };
}






var $6u8gz = parcelRequire("6u8gz");

const $2727220b73d8e0f6$export$1758be3e5622c165 = (pattern, params = {}, options = {})=>{
    const toPath = (0, $6u8gz.compile)(pattern, {
        encode: decodeURIComponent
    });
    const path = toPath(params);
    const parsed = (0, $jiJCD.parse)(path, true);
    return (0, $jiJCD.format)({
        pathname: parsed.pathname,
        query: {
            ...parsed.query,
            ...options.query || {}
        },
        hash: options.hash
    });
};


class $7279e7f5ffc03607$export$e7b0ac011bb776c6 {
    static matchFirst(routes, url) {
        for (const route of routes){
            if (!(route instanceof $7279e7f5ffc03607$export$e7b0ac011bb776c6)) continue;
            const matchResult = route.match(url);
            if (matchResult) return matchResult;
        }
        return null;
    }
    match(url) {
        const urlMatch = (0, $115737db32c49698$export$b5d8fba258cc9e89)(this.pattern, url);
        if (urlMatch) {
            if (this.condition && !this.condition(urlMatch)) return null;
            return {
                ...urlMatch,
                name: this.name
            };
        }
        return null;
    }
    toUrl(params, options) {
        return (0, $2727220b73d8e0f6$export$1758be3e5622c165)(this.pattern, params, options);
    }
    constructor(props){
        this.name = void 0;
        this.ufoName = void 0;
        this.bifrost = void 0;
        this.pattern = void 0;
        this.condition = void 0;
        this.isTransition = void 0;
        this.name = props.name;
        this.ufoName = props.ufoName;
        this.bifrost = props.bifrost;
        this.pattern = props.pattern;
        this.condition = props.condition ? props.condition : ()=>true;
        this.isTransition = (previous, current)=>{
            if (!previous) return true;
            if (props.isTransition) return previous.name === current.name ? props.isTransition(previous, current) : true;
            return previous.pathname !== current.pathname;
        };
    }
}
module.exports["Route"] = $7279e7f5ffc03607$export$e7b0ac011bb776c6;

});

parcelRegister("QU6QS", function(module, exports) {

var $4tRVV = parcelRequire("4tRVV");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $fgJFQ = parcelRequire("fgJFQ");



var $dRnqM = parcelRequire("dRnqM");


var $7Q5yr = parcelRequire("7Q5yr");

var $0f7e592998f4f742$exports = {};
var $998b320f04b08bc3$exports = {};
$998b320f04b08bc3$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $0f7e592998f4f742$exports = $0f7e592998f4f742$var$pathToRegexp;
$0f7e592998f4f742$exports.parse = $0f7e592998f4f742$var$parse;
$0f7e592998f4f742$exports.compile = $0f7e592998f4f742$var$compile;
$0f7e592998f4f742$exports.tokensToFunction = $0f7e592998f4f742$var$tokensToFunction;
$0f7e592998f4f742$exports.tokensToRegExp = $0f7e592998f4f742$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $0f7e592998f4f742$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $0f7e592998f4f742$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $0f7e592998f4f742$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $0f7e592998f4f742$var$escapeGroup(pattern) : asterisk ? '.*' : $0f7e592998f4f742$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $0f7e592998f4f742$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $0f7e592998f4f742$var$escapeString(delimiter) + ']+?';
    return $0f7e592998f4f742$var$escapeString(prevText) + '|(?:(?!' + $0f7e592998f4f742$var$escapeString(prevText) + ')[^' + $0f7e592998f4f742$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $0f7e592998f4f742$var$compile(str, options) {
    return $0f7e592998f4f742$var$tokensToFunction($0f7e592998f4f742$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $0f7e592998f4f742$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $0f7e592998f4f742$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $0f7e592998f4f742$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $0f7e592998f4f742$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $0f7e592998f4f742$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($998b320f04b08bc3$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $0f7e592998f4f742$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $0f7e592998f4f742$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $0f7e592998f4f742$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $0f7e592998f4f742$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $0f7e592998f4f742$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $0f7e592998f4f742$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $0f7e592998f4f742$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $0f7e592998f4f742$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($0f7e592998f4f742$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $0f7e592998f4f742$var$flags(options));
    return $0f7e592998f4f742$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $0f7e592998f4f742$var$stringToRegexp(path, keys, options) {
    return $0f7e592998f4f742$var$tokensToRegExp($0f7e592998f4f742$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $0f7e592998f4f742$var$tokensToRegExp(tokens, keys, options) {
    if (!$998b320f04b08bc3$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $0f7e592998f4f742$var$escapeString(token);
        else {
            var prefix = $0f7e592998f4f742$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $0f7e592998f4f742$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $0f7e592998f4f742$var$attachKeys(new RegExp('^' + route, $0f7e592998f4f742$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $0f7e592998f4f742$var$pathToRegexp(path, keys, options) {
    if (!$998b320f04b08bc3$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $0f7e592998f4f742$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($998b320f04b08bc3$exports(path)) return $0f7e592998f4f742$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $0f7e592998f4f742$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $e335ed00adaa3dea$exports = {};
'use strict';

$e335ed00adaa3dea$exports = (parcelRequire("70Jiv"));



var $bDniu = parcelRequire("bDniu");


var $56GFp = parcelRequire("56GFp");

var $09f0619fc07a7029$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $09f0619fc07a7029$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $09f0619fc07a7029$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $09f0619fc07a7029$var$commonjsGlobal[key] = ($09f0619fc07a7029$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $09f0619fc07a7029$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $09f0619fc07a7029$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $09f0619fc07a7029$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $09f0619fc07a7029$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $09f0619fc07a7029$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $4tRVV.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $09f0619fc07a7029$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($09f0619fc07a7029$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $09f0619fc07a7029$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $4tRVV.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $09f0619fc07a7029$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $09f0619fc07a7029$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $09f0619fc07a7029$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $09f0619fc07a7029$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext || $09f0619fc07a7029$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $09f0619fc07a7029$var$createNamedContext = function createNamedContext(name) {
    var context = $09f0619fc07a7029$var$createContext();
    context.displayName = name;
    return context;
};
var $09f0619fc07a7029$export$c213558b66925821 = /*#__PURE__*/ $09f0619fc07a7029$var$createNamedContext("Router-History");
var $09f0619fc07a7029$export$63baa8ccbe60bb07 = /*#__PURE__*/ $09f0619fc07a7029$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $09f0619fc07a7029$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09f0619fc07a7029$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09f0619fc07a7029$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $09f0619fc07a7029$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $fgJFQ.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09f0619fc07a7029$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
var $09f0619fc07a7029$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $09f0619fc07a7029$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09f0619fc07a7029$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $dRnqM.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09f0619fc07a7029$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $09f0619fc07a7029$var$messageType;
var $09f0619fc07a7029$var$cache = {};
var $09f0619fc07a7029$var$cacheLimit = 10000;
var $09f0619fc07a7029$var$cacheCount = 0;
function $09f0619fc07a7029$var$compilePath(path) {
    if ($09f0619fc07a7029$var$cache[path]) return $09f0619fc07a7029$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($0f7e592998f4f742$exports))).compile(path);
    if ($09f0619fc07a7029$var$cacheCount < $09f0619fc07a7029$var$cacheLimit) {
        $09f0619fc07a7029$var$cache[path] = generator;
        $09f0619fc07a7029$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $09f0619fc07a7029$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $09f0619fc07a7029$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $09f0619fc07a7029$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09f0619fc07a7029$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $dRnqM.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $fgJFQ.createLocation)(computedMatch ? typeof to === "string" ? $09f0619fc07a7029$export$82476f982757e71e(to, computedMatch.params) : (0, $7Q5yr.default)({}, to, {
            pathname: $09f0619fc07a7029$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09f0619fc07a7029$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $fgJFQ.createLocation)(prevProps.to);
                if (!(0, $fgJFQ.locationsAreEqual)(prevLocation, (0, $7Q5yr.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $09f0619fc07a7029$var$cache$1 = {};
var $09f0619fc07a7029$var$cacheLimit$1 = 10000;
var $09f0619fc07a7029$var$cacheCount$1 = 0;
function $09f0619fc07a7029$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $09f0619fc07a7029$var$cache$1[cacheKey] || ($09f0619fc07a7029$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($0f7e592998f4f742$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($09f0619fc07a7029$var$cacheCount$1 < $09f0619fc07a7029$var$cacheLimit$1) {
        pathCache[path] = result;
        $09f0619fc07a7029$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $09f0619fc07a7029$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $09f0619fc07a7029$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $09f0619fc07a7029$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) === 0;
}
function $09f0619fc07a7029$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $09f0619fc07a7029$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09f0619fc07a7029$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $dRnqM.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $09f0619fc07a7029$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $7Q5yr.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $09f0619fc07a7029$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09f0619fc07a7029$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
function $09f0619fc07a7029$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $09f0619fc07a7029$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $7Q5yr.default)({}, location, {
        pathname: $09f0619fc07a7029$var$addLeadingSlash(basename) + location.pathname
    });
}
function $09f0619fc07a7029$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $09f0619fc07a7029$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $7Q5yr.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $09f0619fc07a7029$var$createURL(location) {
    return typeof location === "string" ? location : (0, $fgJFQ.createPath)(location);
}
function $09f0619fc07a7029$var$staticHandler(methodName) {
    return function() {
        (0, $dRnqM.default)(false);
    };
}
function $09f0619fc07a7029$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $09f0619fc07a7029$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $09f0619fc07a7029$var$noop;
        };
        _this.handleBlock = function() {
            return $09f0619fc07a7029$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $09f0619fc07a7029$var$addBasename(basename, (0, $fgJFQ.createLocation)(location));
        context.url = $09f0619fc07a7029$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $bDniu.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $09f0619fc07a7029$var$addLeadingSlash(basename + $09f0619fc07a7029$var$createURL(path));
            },
            action: "POP",
            location: $09f0619fc07a7029$var$stripBasename(basename, (0, $fgJFQ.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $09f0619fc07a7029$var$staticHandler("go"),
            goBack: $09f0619fc07a7029$var$staticHandler("goBack"),
            goForward: $09f0619fc07a7029$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09f0619fc07a7029$export$55185c17a0fcbe46, (0, $7Q5yr.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $09f0619fc07a7029$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09f0619fc07a7029$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $dRnqM.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $09f0619fc07a7029$export$81336c211d5ff295(location.pathname, (0, $7Q5yr.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $09f0619fc07a7029$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $bDniu.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09f0619fc07a7029$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $dRnqM.default)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, (0, $7Q5yr.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($56GFp)))(C, Component);
}
var $09f0619fc07a7029$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext;
function $09f0619fc07a7029$export$3420e1dc2c4a518c() {
    return $09f0619fc07a7029$var$useContext($09f0619fc07a7029$export$c213558b66925821);
}
function $09f0619fc07a7029$export$45d76561a5302f2b() {
    return $09f0619fc07a7029$var$useContext($09f0619fc07a7029$export$63baa8ccbe60bb07).location;
}
function $09f0619fc07a7029$export$99eaa27ddbbb95ef() {
    var match = $09f0619fc07a7029$var$useContext($09f0619fc07a7029$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $09f0619fc07a7029$export$632be4bb944c1bc7(path) {
    var location = $09f0619fc07a7029$export$45d76561a5302f2b();
    var match = $09f0619fc07a7029$var$useContext($09f0619fc07a7029$export$63baa8ccbe60bb07).match;
    return path ? $09f0619fc07a7029$export$81336c211d5ff295(location.pathname, path) : match;
}
var $09f0619fc07a7029$var$global$1, $09f0619fc07a7029$var$key, $09f0619fc07a7029$var$buildNames, $09f0619fc07a7029$var$initialBuildName, $09f0619fc07a7029$var$secondaryBuildName;
module.exports["__RouterContext"] = $09f0619fc07a7029$export$63baa8ccbe60bb07;
module.exports["Router"] = $09f0619fc07a7029$export$55185c17a0fcbe46;
module.exports["Prompt"] = $09f0619fc07a7029$export$83716a4aa1642908;
module.exports["matchPath"] = $09f0619fc07a7029$export$81336c211d5ff295;
module.exports["withRouter"] = $09f0619fc07a7029$export$369b6b2b30582e8e;
module.exports["useHistory"] = $09f0619fc07a7029$export$3420e1dc2c4a518c;
module.exports["useLocation"] = $09f0619fc07a7029$export$45d76561a5302f2b;

});

parcelRegister("4tRVV", function(module, exports) {

var $9JDHm = parcelRequire("9JDHm");

function $3433b4dfc1ac4ecb$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $9JDHm.default)(t, o);
}
module.exports["default"] = $3433b4dfc1ac4ecb$export$2e2bcd8739ae039;

});

parcelRegister("9JDHm", function(module, exports) {
$parcel$export(module.exports, "default", () => $71671c456887521a$export$2e2bcd8739ae039);
function $71671c456887521a$export$2e2bcd8739ae039(t, e) {
    return $71671c456887521a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $71671c456887521a$export$2e2bcd8739ae039(t, e);
}

});

parcelRegister("fgJFQ", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");

function $358fc4a163162d94$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $358fc4a163162d94$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $358fc4a163162d94$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $358fc4a163162d94$var$isAbsolute(to);
    var isFromAbs = from && $358fc4a163162d94$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $358fc4a163162d94$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $358fc4a163162d94$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $358fc4a163162d94$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $358fc4a163162d94$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$358fc4a163162d94$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $358fc4a163162d94$export$2e2bcd8739ae039 = $358fc4a163162d94$var$resolvePathname;


function $83d7d2eec8fc7ce5$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $83d7d2eec8fc7ce5$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $83d7d2eec8fc7ce5$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $83d7d2eec8fc7ce5$var$valueOf(a);
        var bValue = $83d7d2eec8fc7ce5$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $83d7d2eec8fc7ce5$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $83d7d2eec8fc7ce5$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $83d7d2eec8fc7ce5$export$2e2bcd8739ae039 = $83d7d2eec8fc7ce5$var$valueEqual;




var $dRnqM = parcelRequire("dRnqM");

function $b1dbc78436a042d2$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $b1dbc78436a042d2$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $b1dbc78436a042d2$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $b1dbc78436a042d2$var$stripBasename(path, prefix) {
    return $b1dbc78436a042d2$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $b1dbc78436a042d2$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $b1dbc78436a042d2$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $b1dbc78436a042d2$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $b1dbc78436a042d2$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $b1dbc78436a042d2$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $7Q5yr.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $358fc4a163162d94$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $b1dbc78436a042d2$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $83d7d2eec8fc7ce5$export$2e2bcd8739ae039)(a.state, b.state);
}
function $b1dbc78436a042d2$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $b1dbc78436a042d2$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $b1dbc78436a042d2$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $b1dbc78436a042d2$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $b1dbc78436a042d2$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $b1dbc78436a042d2$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $b1dbc78436a042d2$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $b1dbc78436a042d2$var$PopStateEvent = 'popstate';
var $b1dbc78436a042d2$var$HashChangeEvent = 'hashchange';
function $b1dbc78436a042d2$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $b1dbc78436a042d2$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$b1dbc78436a042d2$var$canUseDOM && (0, $dRnqM.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $b1dbc78436a042d2$var$supportsHistory();
    var needsHashChangeListener = !$b1dbc78436a042d2$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $b1dbc78436a042d2$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $b1dbc78436a042d2$var$stripTrailingSlash($b1dbc78436a042d2$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $b1dbc78436a042d2$var$stripBasename(path, basename);
        return $b1dbc78436a042d2$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $b1dbc78436a042d2$var$createTransitionManager();
    function setState(nextState) {
        (0, $7Q5yr.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($b1dbc78436a042d2$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($b1dbc78436a042d2$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($b1dbc78436a042d2$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $b1dbc78436a042d2$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $b1dbc78436a042d2$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $b1dbc78436a042d2$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($b1dbc78436a042d2$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($b1dbc78436a042d2$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($b1dbc78436a042d2$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($b1dbc78436a042d2$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $b1dbc78436a042d2$var$HashChangeEvent$1 = 'hashchange';
var $b1dbc78436a042d2$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $b1dbc78436a042d2$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $b1dbc78436a042d2$var$stripLeadingSlash,
        decodePath: $b1dbc78436a042d2$var$addLeadingSlash
    },
    slash: {
        encodePath: $b1dbc78436a042d2$var$addLeadingSlash,
        decodePath: $b1dbc78436a042d2$var$addLeadingSlash
    }
};
function $b1dbc78436a042d2$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $b1dbc78436a042d2$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $b1dbc78436a042d2$var$pushHashPath(path) {
    window.location.hash = path;
}
function $b1dbc78436a042d2$var$replaceHashPath(path) {
    window.location.replace($b1dbc78436a042d2$var$stripHash(window.location.href) + '#' + path);
}
function $b1dbc78436a042d2$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$b1dbc78436a042d2$var$canUseDOM && (0, $dRnqM.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $b1dbc78436a042d2$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $b1dbc78436a042d2$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $b1dbc78436a042d2$var$stripTrailingSlash($b1dbc78436a042d2$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $b1dbc78436a042d2$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($b1dbc78436a042d2$var$getHashPath());
        if (basename) path = $b1dbc78436a042d2$var$stripBasename(path, basename);
        return $b1dbc78436a042d2$export$90c043f1c57770b8(path);
    }
    var transitionManager = $b1dbc78436a042d2$var$createTransitionManager();
    function setState(nextState) {
        (0, $7Q5yr.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $b1dbc78436a042d2$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $b1dbc78436a042d2$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $b1dbc78436a042d2$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($b1dbc78436a042d2$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($b1dbc78436a042d2$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $b1dbc78436a042d2$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $b1dbc78436a042d2$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $b1dbc78436a042d2$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $b1dbc78436a042d2$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $b1dbc78436a042d2$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $b1dbc78436a042d2$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $b1dbc78436a042d2$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $b1dbc78436a042d2$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $b1dbc78436a042d2$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($b1dbc78436a042d2$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $b1dbc78436a042d2$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $b1dbc78436a042d2$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $b1dbc78436a042d2$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $b1dbc78436a042d2$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($b1dbc78436a042d2$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($b1dbc78436a042d2$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($b1dbc78436a042d2$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $b1dbc78436a042d2$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $b1dbc78436a042d2$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $b1dbc78436a042d2$var$createTransitionManager();
    function setState(nextState) {
        (0, $7Q5yr.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $b1dbc78436a042d2$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $b1dbc78436a042d2$export$90c043f1c57770b8(entry, undefined, createKey()) : $b1dbc78436a042d2$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $b1dbc78436a042d2$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $b1dbc78436a042d2$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $b1dbc78436a042d2$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $b1dbc78436a042d2$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}
module.exports["parsePath"] = $b1dbc78436a042d2$export$8ccf933b0513f8d0;
module.exports["createPath"] = $b1dbc78436a042d2$export$fe53371bee54353d;
module.exports["createLocation"] = $b1dbc78436a042d2$export$90c043f1c57770b8;
module.exports["locationsAreEqual"] = $b1dbc78436a042d2$export$c3e8bb440bd55b18;
module.exports["createBrowserHistory"] = $b1dbc78436a042d2$export$719fc203c4e16dee;
module.exports["createHashHistory"] = $b1dbc78436a042d2$export$b71fdd3798280242;
module.exports["createMemoryHistory"] = $b1dbc78436a042d2$export$2b76ad033c6e6d08;

});

parcelRegister("dRnqM", function(module, exports) {
var $a1726680ad17d4ef$var$isProduction = true;
var $a1726680ad17d4ef$var$prefix = 'Invariant failed';
function $a1726680ad17d4ef$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($a1726680ad17d4ef$var$isProduction) throw new Error($a1726680ad17d4ef$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($a1726680ad17d4ef$var$prefix, ": ").concat(provided) : $a1726680ad17d4ef$var$prefix;
    throw new Error(value);
}
module.exports["default"] = $a1726680ad17d4ef$export$2e2bcd8739ae039;

});

parcelRegister("70Jiv", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $51abab9e408a8893$export$2b8d127b894957b9, (v) => $51abab9e408a8893$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $51abab9e408a8893$export$cea3a54a6425200c, (v) => $51abab9e408a8893$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $51abab9e408a8893$export$a7c73072b1a182ae, (v) => $51abab9e408a8893$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $51abab9e408a8893$export$9f27bc3417b4524d, (v) => $51abab9e408a8893$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $51abab9e408a8893$export$db77ccec0bb4ccac, (v) => $51abab9e408a8893$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $51abab9e408a8893$export$8392c0c9d3dcbd35, (v) => $51abab9e408a8893$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $51abab9e408a8893$export$ffb0004e005737fa, (v) => $51abab9e408a8893$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $51abab9e408a8893$export$b624eff549462981, (v) => $51abab9e408a8893$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $51abab9e408a8893$export$7897aa7841a5380c, (v) => $51abab9e408a8893$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $51abab9e408a8893$export$602eac185826482c, (v) => $51abab9e408a8893$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $51abab9e408a8893$export$e2c29f18771995cb, (v) => $51abab9e408a8893$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $51abab9e408a8893$export$5f8d39834fd61797, (v) => $51abab9e408a8893$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $51abab9e408a8893$export$74bf444e3cd11ea5, (v) => $51abab9e408a8893$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $51abab9e408a8893$export$92387174baf9b227, (v) => $51abab9e408a8893$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $51abab9e408a8893$export$ec112efeb987d9c6, (v) => $51abab9e408a8893$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $51abab9e408a8893$export$b706b080d889d2c9, (v) => $51abab9e408a8893$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $51abab9e408a8893$export$5be5a87408f70ddc, (v) => $51abab9e408a8893$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $51abab9e408a8893$export$45a5e7f76e0caa8d, (v) => $51abab9e408a8893$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $51abab9e408a8893$export$455c2e768291efa6, (v) => $51abab9e408a8893$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $51abab9e408a8893$export$9522e17588c12572, (v) => $51abab9e408a8893$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $51abab9e408a8893$export$2110ac352bb060b9, (v) => $51abab9e408a8893$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $51abab9e408a8893$export$56885ab8b9c456ab, (v) => $51abab9e408a8893$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $51abab9e408a8893$export$d927fcb6adf8f9de, (v) => $51abab9e408a8893$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $51abab9e408a8893$export$b82d16f27459e05a, (v) => $51abab9e408a8893$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $51abab9e408a8893$export$522c17b4f5e123e8, (v) => $51abab9e408a8893$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $51abab9e408a8893$export$1aabd8a0274ecfd6, (v) => $51abab9e408a8893$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $51abab9e408a8893$export$9b621391a187a31a, (v) => $51abab9e408a8893$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $51abab9e408a8893$export$f5bbd400c2f4426f, (v) => $51abab9e408a8893$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $51abab9e408a8893$export$2b8d127b894957b9;
var $51abab9e408a8893$export$cea3a54a6425200c;
var $51abab9e408a8893$export$a7c73072b1a182ae;
var $51abab9e408a8893$export$9f27bc3417b4524d;
var $51abab9e408a8893$export$db77ccec0bb4ccac;
var $51abab9e408a8893$export$8392c0c9d3dcbd35;
var $51abab9e408a8893$export$ffb0004e005737fa;
var $51abab9e408a8893$export$b624eff549462981;
var $51abab9e408a8893$export$7897aa7841a5380c;
var $51abab9e408a8893$export$602eac185826482c;
var $51abab9e408a8893$export$e2c29f18771995cb;
var $51abab9e408a8893$export$5f8d39834fd61797;
var $51abab9e408a8893$export$74bf444e3cd11ea5;
var $51abab9e408a8893$export$92387174baf9b227;
var $51abab9e408a8893$export$ec112efeb987d9c6;
var $51abab9e408a8893$export$b706b080d889d2c9;
var $51abab9e408a8893$export$5be5a87408f70ddc;
var $51abab9e408a8893$export$45a5e7f76e0caa8d;
var $51abab9e408a8893$export$455c2e768291efa6;
var $51abab9e408a8893$export$9522e17588c12572;
var $51abab9e408a8893$export$2110ac352bb060b9;
var $51abab9e408a8893$export$56885ab8b9c456ab;
var $51abab9e408a8893$export$d927fcb6adf8f9de;
var $51abab9e408a8893$export$b82d16f27459e05a;
var $51abab9e408a8893$export$522c17b4f5e123e8;
var $51abab9e408a8893$export$1aabd8a0274ecfd6;
var $51abab9e408a8893$export$9b621391a187a31a;
var $51abab9e408a8893$export$f5bbd400c2f4426f;
'use strict';
var $51abab9e408a8893$var$b = "function" === typeof Symbol && Symbol.for, $51abab9e408a8893$var$c = $51abab9e408a8893$var$b ? Symbol.for("react.element") : 60103, $51abab9e408a8893$var$d = $51abab9e408a8893$var$b ? Symbol.for("react.portal") : 60106, $51abab9e408a8893$var$e = $51abab9e408a8893$var$b ? Symbol.for("react.fragment") : 60107, $51abab9e408a8893$var$f = $51abab9e408a8893$var$b ? Symbol.for("react.strict_mode") : 60108, $51abab9e408a8893$var$g = $51abab9e408a8893$var$b ? Symbol.for("react.profiler") : 60114, $51abab9e408a8893$var$h = $51abab9e408a8893$var$b ? Symbol.for("react.provider") : 60109, $51abab9e408a8893$var$k = $51abab9e408a8893$var$b ? Symbol.for("react.context") : 60110, $51abab9e408a8893$var$l = $51abab9e408a8893$var$b ? Symbol.for("react.async_mode") : 60111, $51abab9e408a8893$var$m = $51abab9e408a8893$var$b ? Symbol.for("react.concurrent_mode") : 60111, $51abab9e408a8893$var$n = $51abab9e408a8893$var$b ? Symbol.for("react.forward_ref") : 60112, $51abab9e408a8893$var$p = $51abab9e408a8893$var$b ? Symbol.for("react.suspense") : 60113, $51abab9e408a8893$var$q = $51abab9e408a8893$var$b ? Symbol.for("react.suspense_list") : 60120, $51abab9e408a8893$var$r = $51abab9e408a8893$var$b ? Symbol.for("react.memo") : 60115, $51abab9e408a8893$var$t = $51abab9e408a8893$var$b ? Symbol.for("react.lazy") : 60116, $51abab9e408a8893$var$v = $51abab9e408a8893$var$b ? Symbol.for("react.block") : 60121, $51abab9e408a8893$var$w = $51abab9e408a8893$var$b ? Symbol.for("react.fundamental") : 60117, $51abab9e408a8893$var$x = $51abab9e408a8893$var$b ? Symbol.for("react.responder") : 60118, $51abab9e408a8893$var$y = $51abab9e408a8893$var$b ? Symbol.for("react.scope") : 60119;
function $51abab9e408a8893$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $51abab9e408a8893$var$c:
                switch(a = a.type, a){
                    case $51abab9e408a8893$var$l:
                    case $51abab9e408a8893$var$m:
                    case $51abab9e408a8893$var$e:
                    case $51abab9e408a8893$var$g:
                    case $51abab9e408a8893$var$f:
                    case $51abab9e408a8893$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $51abab9e408a8893$var$k:
                            case $51abab9e408a8893$var$n:
                            case $51abab9e408a8893$var$t:
                            case $51abab9e408a8893$var$r:
                            case $51abab9e408a8893$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $51abab9e408a8893$var$d:
                return u;
        }
    }
}
function $51abab9e408a8893$var$A(a) {
    return $51abab9e408a8893$var$z(a) === $51abab9e408a8893$var$m;
}
$51abab9e408a8893$export$2b8d127b894957b9 = $51abab9e408a8893$var$l;
$51abab9e408a8893$export$cea3a54a6425200c = $51abab9e408a8893$var$m;
$51abab9e408a8893$export$a7c73072b1a182ae = $51abab9e408a8893$var$k;
$51abab9e408a8893$export$9f27bc3417b4524d = $51abab9e408a8893$var$h;
$51abab9e408a8893$export$db77ccec0bb4ccac = $51abab9e408a8893$var$c;
$51abab9e408a8893$export$8392c0c9d3dcbd35 = $51abab9e408a8893$var$n;
$51abab9e408a8893$export$ffb0004e005737fa = $51abab9e408a8893$var$e;
$51abab9e408a8893$export$b624eff549462981 = $51abab9e408a8893$var$t;
$51abab9e408a8893$export$7897aa7841a5380c = $51abab9e408a8893$var$r;
$51abab9e408a8893$export$602eac185826482c = $51abab9e408a8893$var$d;
$51abab9e408a8893$export$e2c29f18771995cb = $51abab9e408a8893$var$g;
$51abab9e408a8893$export$5f8d39834fd61797 = $51abab9e408a8893$var$f;
$51abab9e408a8893$export$74bf444e3cd11ea5 = $51abab9e408a8893$var$p;
$51abab9e408a8893$export$92387174baf9b227 = function(a) {
    return $51abab9e408a8893$var$A(a) || $51abab9e408a8893$var$z(a) === $51abab9e408a8893$var$l;
};
$51abab9e408a8893$export$ec112efeb987d9c6 = $51abab9e408a8893$var$A;
$51abab9e408a8893$export$b706b080d889d2c9 = function(a) {
    return $51abab9e408a8893$var$z(a) === $51abab9e408a8893$var$k;
};
$51abab9e408a8893$export$5be5a87408f70ddc = function(a) {
    return $51abab9e408a8893$var$z(a) === $51abab9e408a8893$var$h;
};
$51abab9e408a8893$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $51abab9e408a8893$var$c;
};
$51abab9e408a8893$export$455c2e768291efa6 = function(a) {
    return $51abab9e408a8893$var$z(a) === $51abab9e408a8893$var$n;
};
$51abab9e408a8893$export$9522e17588c12572 = function(a) {
    return $51abab9e408a8893$var$z(a) === $51abab9e408a8893$var$e;
};
$51abab9e408a8893$export$2110ac352bb060b9 = function(a) {
    return $51abab9e408a8893$var$z(a) === $51abab9e408a8893$var$t;
};
$51abab9e408a8893$export$56885ab8b9c456ab = function(a) {
    return $51abab9e408a8893$var$z(a) === $51abab9e408a8893$var$r;
};
$51abab9e408a8893$export$d927fcb6adf8f9de = function(a) {
    return $51abab9e408a8893$var$z(a) === $51abab9e408a8893$var$d;
};
$51abab9e408a8893$export$b82d16f27459e05a = function(a) {
    return $51abab9e408a8893$var$z(a) === $51abab9e408a8893$var$g;
};
$51abab9e408a8893$export$522c17b4f5e123e8 = function(a) {
    return $51abab9e408a8893$var$z(a) === $51abab9e408a8893$var$f;
};
$51abab9e408a8893$export$1aabd8a0274ecfd6 = function(a) {
    return $51abab9e408a8893$var$z(a) === $51abab9e408a8893$var$p;
};
$51abab9e408a8893$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $51abab9e408a8893$var$e || a === $51abab9e408a8893$var$m || a === $51abab9e408a8893$var$g || a === $51abab9e408a8893$var$f || a === $51abab9e408a8893$var$p || a === $51abab9e408a8893$var$q || "object" === typeof a && null !== a && (a.$$typeof === $51abab9e408a8893$var$t || a.$$typeof === $51abab9e408a8893$var$r || a.$$typeof === $51abab9e408a8893$var$h || a.$$typeof === $51abab9e408a8893$var$k || a.$$typeof === $51abab9e408a8893$var$n || a.$$typeof === $51abab9e408a8893$var$w || a.$$typeof === $51abab9e408a8893$var$x || a.$$typeof === $51abab9e408a8893$var$y || a.$$typeof === $51abab9e408a8893$var$v);
};
$51abab9e408a8893$export$f5bbd400c2f4426f = $51abab9e408a8893$var$z;

});

parcelRegister("bDniu", function(module, exports) {
function $8785689403608a2a$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports["default"] = $8785689403608a2a$export$2e2bcd8739ae039;

});

parcelRegister("6u8gz", function(module, exports) {
/**
 * Tokenize input string.
 */ function $4b8bf4effa3bddcd$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $4b8bf4effa3bddcd$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $4b8bf4effa3bddcd$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($4b8bf4effa3bddcd$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($4b8bf4effa3bddcd$var$escapeString(prevText), ")[^").concat($4b8bf4effa3bddcd$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $4b8bf4effa3bddcd$export$ef7acd7185315e22(str, options) {
    return $4b8bf4effa3bddcd$export$5b9bad9e403cf3d9($4b8bf4effa3bddcd$export$98e6a39c04603d36(str, options), options);
}
function $4b8bf4effa3bddcd$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $4b8bf4effa3bddcd$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $4b8bf4effa3bddcd$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $4b8bf4effa3bddcd$export$71304158c7e35877(str, keys, options);
    return $4b8bf4effa3bddcd$export$968e97c88708237a(re, keys, options);
}
function $4b8bf4effa3bddcd$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $4b8bf4effa3bddcd$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $4b8bf4effa3bddcd$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $4b8bf4effa3bddcd$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $4b8bf4effa3bddcd$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $4b8bf4effa3bddcd$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $4b8bf4effa3bddcd$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $4b8bf4effa3bddcd$var$stringToRegexp(path, keys, options) {
    return $4b8bf4effa3bddcd$export$9a9303716def6456($4b8bf4effa3bddcd$export$98e6a39c04603d36(path, options), keys, options);
}
function $4b8bf4effa3bddcd$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($4b8bf4effa3bddcd$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($4b8bf4effa3bddcd$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $4b8bf4effa3bddcd$var$escapeString(encode(token));
        else {
            var prefix = $4b8bf4effa3bddcd$var$escapeString(encode(token.prefix));
            var suffix = $4b8bf4effa3bddcd$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $4b8bf4effa3bddcd$var$flags(options));
}
function $4b8bf4effa3bddcd$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $4b8bf4effa3bddcd$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $4b8bf4effa3bddcd$var$arrayToRegexp(path, keys, options);
    return $4b8bf4effa3bddcd$var$stringToRegexp(path, keys, options);
}
module.exports["compile"] = $4b8bf4effa3bddcd$export$ef7acd7185315e22;
module.exports["pathToRegexp"] = $4b8bf4effa3bddcd$export$71304158c7e35877;

});

parcelRegister("jlIaF", function(module, exports) {
const $91bc4b300d6f4b96$export$8c6bf2df244e6a99 = '/wiki';
module.exports["CONTEXT_PATH"] = $91bc4b300d6f4b96$export$8c6bf2df244e6a99;

});

parcelRegister("bqMNb", function(module, exports) {
const $316991bab9a5c4bb$export$e6eb0c6cf0c4b7e3 = 'force_transition';
const $316991bab9a5c4bb$export$b5402fcece797a50 = (prevMatch, currentMatch)=>{
    const currentForceTransitionId = currentMatch?.query?.[$316991bab9a5c4bb$export$e6eb0c6cf0c4b7e3];
    const previousForceTransitionId = prevMatch?.query?.[$316991bab9a5c4bb$export$e6eb0c6cf0c4b7e3];
    return Boolean(currentForceTransitionId && currentForceTransitionId !== previousForceTransitionId);
};
module.exports["FORCE_TRANSITION_QUERY_PARAM"] = $316991bab9a5c4bb$export$e6eb0c6cf0c4b7e3;
module.exports["isForceTransition"] = $316991bab9a5c4bb$export$b5402fcece797a50;

});

parcelRegister("6jrkJ", function(module, exports) {

var $68uaC = parcelRequire("68uaC");

const $00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE = 'confluence.asSuperAdmin';
function $00ee7f2affe27fcd$export$2fc1623749affa1a() {
    return Boolean((0, $68uaC.Cookies).get($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE));
}
function $00ee7f2affe27fcd$export$b097cdee5288154b() {
    (0, $68uaC.Cookies).remove($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE);
}
async function $00ee7f2affe27fcd$export$f5d5d0f409509831() {
    await (0, $68uaC.Cookies).set($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE, 'true', undefined, (0, $68uaC.CookieLevel).NECESSARY);
}
module.exports["getSuperAdminClaim"] = $00ee7f2affe27fcd$export$2fc1623749affa1a;
module.exports["removeSuperAdminClaim"] = $00ee7f2affe27fcd$export$b097cdee5288154b;
module.exports["setSuperAdminClaim"] = $00ee7f2affe27fcd$export$f5d5d0f409509831;

});

parcelRegister("68uaC", function(module, exports) {

var $2urbH = parcelRequire("2urbH");

var $ajypD = parcelRequire("ajypD");

var $hEbxW = parcelRequire("hEbxW");

var $hU6fs = parcelRequire("hU6fs");

var $eGd7K = parcelRequire("eGd7K");

var $gqmdp = parcelRequire("gqmdp");

var $7L5zP = parcelRequire("7L5zP");


var $lzcvT = parcelRequire("lzcvT");

var $T9xHm = parcelRequire("T9xHm");


var $9wGTI = parcelRequire("9wGTI");

var $d7bce23cc4785c4a$export$bd5b8250c8cdfbb5 = /*#__PURE__*/ function(CookieLevel) {
    CookieLevel["USE_PREFERENCES"] = "USE_PREFERENCES";
    CookieLevel["NECESSARY"] = "NECESSARY";
    return CookieLevel;
}({});
class $d7bce23cc4785c4a$export$3a9db9793503eddb {
    static initialize() {
        // we want to store cookies locally when in Isolated Cloud (IC) because like FedRAMP, Consent Hub is not hydrated in IC
        // (note: this property is ignored and forced to "true" when a FedRAMP perimeter is passed in)
        const shouldUseLocalConsentMode = (0, $T9xHm.isIsolatedCloud)();
        // Initialize browser-storage-controls with webStorageEnabled
        // This will override browser default LocalStorage and SessionStorage
        if ((0, $9wGTI.fg)('confluence_browser_storage_controls')) {
            if ((0, $9wGTI.fg)('fedramp-cookies-controls')) return (0, $hU6fs.initializeControls)({
                product: 'Confluence',
                webStorageEnabled: true,
                perimeter: (0, $lzcvT.isFedRamp)() ? 'fedramp-moderate' : 'commercial',
                localConsentMode: shouldUseLocalConsentMode
            });
            return (0, $hU6fs.initializeControls)({
                product: 'Confluence',
                webStorageEnabled: true,
                localConsentMode: shouldUseLocalConsentMode
            });
        }
        if ((0, $9wGTI.fg)('fedramp-cookies-controls')) return (0, $hU6fs.initializeControls)({
            product: 'Confluence',
            perimeter: (0, $lzcvT.isFedRamp)() ? 'fedramp-moderate' : 'commercial',
            localConsentMode: shouldUseLocalConsentMode
        });
        else return (0, $hU6fs.initializeControls)({
            product: 'Confluence',
            localConsentMode: shouldUseLocalConsentMode
        });
    }
    /**
   * Attempts to set a cookie asynchronously using the user's preferences
   * @param level Describes how necessary the cookie is. Only use NECESSARY if the cookie is absolutely required.
   * @returns true if the cookie succeeded in being set based on the user's preferences
   */ static async set(key, value, attributes, level = "USE_PREFERENCES") {
        // This does not need to be behind the FF because
        // if the cookie is strictly necessary, its set synchronously using js-cookie anyways
        if (level === "NECESSARY") {
            (0, $gqmdp.setStrictlyNecessaryCookie)(key, value, attributes);
            return Promise.resolve(true);
        }
        return await (0, $eGd7K.setCookie)(key, value, attributes) === (0, $7L5zP.Status).SUCCESS;
    }
    // eslint-disable-next-line no-dupe-class-members
    static get(key) {
        if (!key) return (0, $hEbxW.getCookie)();
        return (0, $hEbxW.getCookie)(key);
    }
    /**
   * Deletes a cookie given a key
   */ static remove(key, attributes) {
        (0, $ajypD.deleteCookie)(key, attributes);
    }
    /**
   * Executes a callback if the user has allowed or denied a third party cookie
   */ static async checkThirdParty(key, onAllowed, onDenied) {
        await (0, $2urbH.checkThirdParty)(key, onAllowed, onDenied);
    }
}
module.exports["CookieLevel"] = $d7bce23cc4785c4a$export$bd5b8250c8cdfbb5;
module.exports["Cookies"] = $d7bce23cc4785c4a$export$3a9db9793503eddb;

});

parcelRegister("2urbH", function(module, exports) {

var $c5a0x = parcelRequire("c5a0x");


var $6ZgEd = parcelRequire("6ZgEd");


var $2i8PW = parcelRequire("2i8PW");


var $ccRXO = parcelRequire("ccRXO");


var $7MEbC = parcelRequire("7MEbC");

const $190e6f4243fd9d93$export$3df7084d4be668cd = async (thirdParty)=>{
    /*
    If no preferences for whatever reason, deny
    If prefs exist and are default, they will default to block all
    If third party has no category for whatever reason or the data doesn't resolve, deny
    If third party has a category, check preferences and allow/deny
  */ const preferences = await (0, $7MEbC.getPreferences)();
    if (!preferences) return Promise.resolve(false);
    let shouldDenyThirdParty = false;
    let storageControlsData;
    const { loadCache: loadCache } = (0, $2i8PW.getBscGlobalState)();
    storageControlsData = await loadCache((0, $ccRXO.CategoryStorageType).Cookies);
    if (storageControlsData) {
        const { thirdPartyKeys: thirdPartyKeys, categories: categories } = storageControlsData;
        const thirdPartyCategoryNumber = thirdPartyKeys[thirdParty];
        const numToCategoryMap = {
            [categories.STRICTLY_NECESSARY]: (0, $ccRXO.PreferenceCategory).StrictlyNecessary,
            [categories.FUNCTIONAL]: (0, $ccRXO.PreferenceCategory).Functional,
            [categories.ANALYTICS]: (0, $ccRXO.PreferenceCategory).Analytics,
            [categories.MARKETING]: (0, $ccRXO.PreferenceCategory).Marketing,
            [categories.UNKNOWN]: (0, $ccRXO.PreferenceCategory).Unknown
        };
        const thirdPartyCategory = thirdPartyCategoryNumber !== null ? numToCategoryMap[thirdPartyCategoryNumber] : null;
        let hasPreferencesForCategoryType = false;
        if (!!thirdPartyCategory) hasPreferencesForCategoryType = preferences[thirdPartyCategory];
        shouldDenyThirdParty = hasPreferencesForCategoryType;
    }
    return Promise.resolve(shouldDenyThirdParty);
};


const $c2a064e2efbad315$export$6112f3b5ec1bcd0 = async (thirdParty, onAllowed, onDenied)=>{
    try {
        const isAllowed = await (0, $190e6f4243fd9d93$export$3df7084d4be668cd)(thirdParty);
        (0, $c5a0x.sendPackageOperationalEvent)({
            action: 'usedCheckThirdParty',
            attributes: {
                wasRejected: !isAllowed,
                thirdParty: thirdParty
            }
        });
        return isAllowed ? onAllowed() : onDenied?.();
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'checkThirdPartyError',
            attributes: {
                wasRejected: true,
                thirdParty: thirdParty
            },
            message: `Failed to use check third party. ${e.message || ''}`
        });
    }
};
module.exports["checkThirdParty"] = $c2a064e2efbad315$export$6112f3b5ec1bcd0;

});

parcelRegister("ajypD", function(module, exports) {

var $5k5F7 = parcelRequire("5k5F7");


var $dh538 = parcelRequire("dh538");


var $c5a0x = parcelRequire("c5a0x");


var $6ZgEd = parcelRequire("6ZgEd");

const $de038b90d1226c0e$export$b43e45590305ffaa = (key, attributes)=>{
    if ((0, $dh538.fg)('platform_moonjelly_bsc_master_killswitch')) // Delete the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).remove(key, attributes);
    else try {
        (0, $c5a0x.sendPackageOperationalEvent)({
            action: 'usedDeleteCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).remove(key, attributes);
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'usedDeleteCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use delete cookie. ${e.message || ''}`
        });
    }
};
module.exports["deleteCookie"] = $de038b90d1226c0e$export$b43e45590305ffaa;

});

parcelRegister("hU6fs", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $c5a0x = parcelRequire("c5a0x");

var $kfwMJ = parcelRequire("kfwMJ");

var $6ZgEd = parcelRequire("6ZgEd");


var $2i8PW = parcelRequire("2i8PW");

parcelRequire("c4TO3");
var $hohxW = parcelRequire("hohxW");


var $iMbr2 = parcelRequire("iMbr2");


var $gNXDk = parcelRequire("gNXDk");

const $bb4d89404279468d$export$919040c32a62c7db = async (args = {
    analyticsEnabled: true
})=>{
    if ((0, $dh538.fg)('platform_moonjelly_bsc_master_killswitch')) // Exit if the master killswitch is enabled
    return;
    try {
        (0, $6ZgEd.Logger).debug('initializeControls invoked');
        (0, $2i8PW.initializeGlobalState)(args);
        // Exit silently if in SSR context
        if ((0, $kfwMJ.isSSR)()) return;
        // Ensures that the AWC is constructed before overwriting any native methods.
        const analyticsWebClientInstance = (0, $c5a0x.getAnalyticsClient)();
        // If AWC is not initialized, it will be undefined
        const isAnalyticsInitialized = !!analyticsWebClientInstance;
        if (args.analyticsEnabled && !isAnalyticsInitialized) throw new Error(`Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.`);
        await (0, $iMbr2.createDocumentCookiePassthrough)();
        const isWebStorageControlsEnabled = (0, $2i8PW.getBscGlobalState)().webStorageEnabled;
        if (!isWebStorageControlsEnabled) return;
        await (0, $gNXDk.createWebStoragePassthrough)((0, $hohxW.WebStorageType).LocalStorage);
        await (0, $gNXDk.createWebStoragePassthrough)((0, $hohxW.WebStorageType).SessionStorage);
        (0, $6ZgEd.Logger).debug('initiizeControls finished');
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: `Failed to initialize browser storage controls. ${e.message || ''}`
        });
    }
};
module.exports["initializeControls"] = $bb4d89404279468d$export$919040c32a62c7db;

});

parcelRegister("eGd7K", function(module, exports) {

var $5k5F7 = parcelRequire("5k5F7");


var $dh538 = parcelRequire("dh538");


var $2i8PW = parcelRequire("2i8PW");

var $c5a0x = parcelRequire("c5a0x");


var $6RSiP = parcelRequire("6RSiP");


var $6ZgEd = parcelRequire("6ZgEd");


var $ccRXO = parcelRequire("ccRXO");

const $caeb0e16e3fd62a1$export$110700823644f4a6 = async (key, value, attributes)=>{
    if ((0, $dh538.fg)('platform_moonjelly_bsc_master_killswitch')) {
        // Set the cookie without checking user preferences
        // when master killswitch is enabled
        (0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
        return (0, $ccRXO.Status).SUCCESS;
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    const productName = (0, $2i8PW.getBscGlobalState)().product;
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetCookie = await (0, $6RSiP.isProcessingAllowedByPreferences)({
        itemKey: key,
        storageType: (0, $ccRXO.CategoryStorageType).Cookies,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetCookie,
        cookieKey: key
    };
    try {
        (0, $c5a0x.sendPackageOperationalEvent)({
            action: 'usedSetCookie',
            attributes: eventAttributes
        });
        if (shouldSetCookie) {
            (0, (/*@__PURE__*/$parcel$interopDefault($5k5F7))).set(key, value, {
                ...attributes,
                'atl-set-cookie': true
            });
            return (0, $ccRXO.Status).SUCCESS;
        } else return (0, $ccRXO.Status).BLOCKED;
    } catch (e) {
        (0, $6ZgEd.Logger).errorWithOperationalEvent({
            action: 'usedSetCookieError',
            attributes: eventAttributes,
            message: `Failed to use set cookie. ${e.message || ''}`
        });
        return (0, $ccRXO.Status).BLOCKED;
    }
};
module.exports["setCookie"] = $caeb0e16e3fd62a1$export$110700823644f4a6;

});

parcelRegister("7L5zP", function(module, exports) {
var $028268adc8ed6848$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});
module.exports["Status"] = $028268adc8ed6848$export$96e9906d6d93a972;

});

parcelRegister("gqvAh", function(module, exports) {

let $bf5793062cfb8e55$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bf5793062cfb8e55$var$load("97s9d"),
    $bf5793062cfb8e55$var$load("7lNQq"),
    $bf5793062cfb8e55$var$load("gGSRo")
]).then(()=>parcelRequire('cqeVP'));

});

parcelRegister("eq9Qf", function(module, exports) {
function $e55c37f1a957f9bd$export$4aacc15ba69cddd2(url) {
    // we don't want WS connection to be established during SSR
    if (typeof window != 'undefined' && typeof window.WebSocket !== 'undefined') try {
        const ws = new window.WebSocket(url, 'graphql-ws');
        ws.onopen = ()=>{
            setTimeout(()=>{
                // do not pollute connection pool, but do not disconnect immediately as it causes error
                // "WebSocket is closed before the connection is established."
                ws.close();
            }, 100);
        };
        return true;
    } catch (error) {
    /* NOOP */ }
    return false;
}
module.exports["checkWebSocketConnectivity"] = $e55c37f1a957f9bd$export$4aacc15ba69cddd2;

});

parcelRegister("3aShZ", function(module, exports) {
function $0bce626b95208d8b$var$isOperationDefinitionNode(node) {
    return 'operation' in node;
}
function $0bce626b95208d8b$var$hasDirective(name) {
    return (operation)=>{
        if (!operation.query.definitions) return false;
        for (const { operation: type, directives: directives } of operation.query.definitions.filter($0bce626b95208d8b$var$isOperationDefinitionNode)){
            if (type === 'query' || type === 'mutation') return (directives ?? []).some((directive)=>directive.name.value === name);
        }
        return false;
    };
}
// keeping this for now since we don't actually check for directives
// on subscription types
function $0bce626b95208d8b$var$isWSOperation() {
    return (operation)=>{
        if (!operation.query.definitions) return false;
        for (const { operation: type } of operation.query.definitions.filter($0bce626b95208d8b$var$isOperationDefinitionNode)){
            if (type === 'subscription') return true;
        }
        return false;
    };
}
const $0bce626b95208d8b$export$8de27827a7b1def2 = $0bce626b95208d8b$var$hasDirective('experimental');
const $0bce626b95208d8b$export$96fdb682321c31c1 = $0bce626b95208d8b$var$hasDirective('SLA');
const $0bce626b95208d8b$export$fada5ef602d0fc36 = $0bce626b95208d8b$var$isWSOperation();
module.exports["isExperimental"] = $0bce626b95208d8b$export$8de27827a7b1def2;
module.exports["isSLA"] = $0bce626b95208d8b$export$96fdb682321c31c1;
module.exports["isWS"] = $0bce626b95208d8b$export$fada5ef602d0fc36;

});

parcelRegister("60cDW", function(module, exports) {
let $54ddb4ed97d05eb8$var$ssrRenderInputs = {};
function $54ddb4ed97d05eb8$export$23e824c634636b62(inputs) {
    $54ddb4ed97d05eb8$var$ssrRenderInputs = inputs;
}
function $54ddb4ed97d05eb8$export$5a7bc2bed2a23636() {
    return $54ddb4ed97d05eb8$var$ssrRenderInputs;
}
module.exports["getSSRRenderInputs"] = $54ddb4ed97d05eb8$export$5a7bc2bed2a23636;

});

parcelRegister("eecps", function(module, exports) {

var $fGzMp = parcelRequire("fGzMp");


var $14DR2 = parcelRequire("14DR2");

var $f7B1p = parcelRequire("f7B1p");

var $3P4tJ = parcelRequire("3P4tJ");

var $c0BL4 = parcelRequire("c0BL4");

function $854bdac570650ebc$export$3dbb48b3da33bedb() {
    return (resource, init = {})=>{
        const activeSlaExperience = (0, $fGzMp.getLatestActiveSlaExperience)();
        if (activeSlaExperience) {
            init.headers = init.headers || {};
            // Here we're very far from where the query was triggered and we haven't
            // been told explicitly that the query was triggered because of any of the
            // currently active experiences but we're presuming there's a correlation
            // because it's our best available guess. If the header was already added
            // (e.g. when preloading a route on transition) and because we can only
            // send one experience at this time, presume that whoever added the header
            // before us knew better:
            (0, $14DR2.appendHeader)(init.headers, (0, $c0BL4.X_ATL_EXPERIENCE), (0, $3P4tJ.getHeaderValue)(init.headers, (0, $c0BL4.X_ATL_EXPERIENCE)) || activeSlaExperience.name);
            (0, $14DR2.appendHeader)(init.headers, (0, $c0BL4.X_ATL_EXPERIENCE_ID), (0, $3P4tJ.getHeaderValue)(init.headers, (0, $c0BL4.X_ATL_EXPERIENCE_ID)) || (activeSlaExperience.attributes?.uniqueExperienceId ?? activeSlaExperience.id));
        }
        // eslint-disable-next-line no-restricted-syntax
        return (0, $f7B1p.cfetch)(resource, init);
    };
}
const $854bdac570650ebc$export$be6d8e5a7e346e2e = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return true;
};
module.exports["createExperienceAwareFetch"] = $854bdac570650ebc$export$3dbb48b3da33bedb;
module.exports["isExperienceAwareFetchAlwaysEnabled"] = $854bdac570650ebc$export$be6d8e5a7e346e2e;

});

parcelRegister("fGzMp", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $kyKWe = parcelRequire("kyKWe");


var $kquTo = parcelRequire("kquTo");


var $04e9M = parcelRequire("04e9M");


var $8EsbU = parcelRequire("8EsbU");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $cEgMD = parcelRequire("cEgMD");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $kmyYx = parcelRequire("kmyYx");


var $949zl = parcelRequire("949zl");

const $9713ba3226cd0c48$var$SLA_EXPERIENCES = new Set([
    // Currently not SLA experience, but will be in the future
    (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
    (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
    (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
    // SLA experiences ⬇️
    (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
    (0, $irVI7.CREATE_PAGE_EXPERIENCE),
    (0, $irVI7.EDIT_PAGE_EXPERIENCE),
    (0, $irVI7.VIEW_PAGE_EXPERIENCE)
]);
const $9713ba3226cd0c48$var$activeSlaExperiences = new Map();
const $9713ba3226cd0c48$var$activeExperiences = new Set();
const $9713ba3226cd0c48$var$currentRoute = {
    routeName: '',
    successfulExperiences: new Set()
};
const $9713ba3226cd0c48$var$previousRoute = {
    routeName: '',
    successfulExperiences: new Set()
};
function $9713ba3226cd0c48$export$6369eb07eb8a8518({ action: action, name: name, id: id, attributes: attributes = {} }) {
    const isSlaExperience = $9713ba3226cd0c48$var$SLA_EXPERIENCES.has(name);
    if (action === 'taskStart') {
        if (isSlaExperience) {
            // Create a unique experience ID for request headers
            attributes.uniqueExperienceId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
            $9713ba3226cd0c48$var$activeSlaExperiences.set(name, {
                id: id,
                attributes: attributes
            });
        }
        $9713ba3226cd0c48$var$activeExperiences.add(name);
    } else {
        if (isSlaExperience) {
            // Extract unique experience ID to attach to event attributes for analytics/monitoring logs
            attributes.uniqueExperienceId = $9713ba3226cd0c48$var$activeSlaExperiences.get(name)?.attributes?.uniqueExperienceId;
            $9713ba3226cd0c48$var$activeSlaExperiences.delete(name);
        }
        $9713ba3226cd0c48$var$activeExperiences.delete(name);
        if (action === 'taskSuccess') $9713ba3226cd0c48$var$currentRoute.successfulExperiences.add(name);
    }
    const slaExperience = $9713ba3226cd0c48$export$1e7d0a9a962cdd28();
    const experiences = $9713ba3226cd0c48$var$activeExperiences.size > 0 ? $9713ba3226cd0c48$var$activeExperiences : null;
    if (slaExperience || experiences) {
        const updatedContext = {};
        if (experiences) updatedContext.activeExperiences = $9713ba3226cd0c48$var$activeExperiences;
        if (slaExperience) updatedContext.slaExperience = slaExperience.name;
        (0, $5ZqQS.getMonitoringClient)().updateContext(updatedContext);
    }
}
function $9713ba3226cd0c48$export$1e7d0a9a962cdd28() {
    if ($9713ba3226cd0c48$var$activeSlaExperiences.size === 0) return null;
    const experienceEntry = Array.from($9713ba3226cd0c48$var$activeSlaExperiences).pop();
    return {
        ...experienceEntry[1],
        name: experienceEntry[0]
    };
}
const $9713ba3226cd0c48$export$a1fa58e5690a5a9a = (0, $2XqLN.default)(()=>{
    const tracker = new (0, $kmyYx.ExperienceTracker)();
    // Do nothing for search engine crawlers
    if (/bot/i.test(window.navigator.userAgent)) return tracker;
    tracker.subscribe((event)=>{
        //
        // View Page SLA Split
        //
        if (event.name === (0, $irVI7.VIEW_CONTENT_EXPERIENCE)) {
            $9713ba3226cd0c48$var$splitViewContentExperience(tracker, event);
            // View-content was introduced only to split space-overview out of
            // view-page, because view-page is covered by Premium SLA and
            // space-overview was not satisfactorily reliable. View-content is not
            // allowlisted in cc-fe-telemetry so submitting through MonitoringClient
            // below is a waste. Sending through AnalyticsWebClient is a waste too
            // since view-content is not tracked as an SLO and it could be derived
            // from view-page and space-overview which are tracked as separate SLOs
            // already anyway. Splunk found 23 million view-content events in the last
            // 24 hours which is about 3% of experience-tracker events.
            return;
        }
        $9713ba3226cd0c48$export$6369eb07eb8a8518(event);
        //
        // AnalyticsWebClient
        //
        (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
            client.sendOperationalEvent((0, $kquTo.createExperienceTrackerAnalyticsEventPayload)($9713ba3226cd0c48$var$provideGenericAttributes(event)));
        });
        //
        // MonitoringClient
        //
        const isTimeoutError = event.action === 'taskFail' && event?.error?.name === 'ExperienceTimeoutError' || event.action === 'taskAbort' && typeof event?.reason === 'string' && event.reason.startsWith('ExperienceTimeout');
        const isPermissionError = event.name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) && event.action === 'taskAbort' && (event.reason?.includes?.('401') || event.reason?.includes?.('403'));
        const tags = [
            `action:${event.action}`,
            `isActiveTab:${document.visibilityState === 'visible'}`,
            ...event.action === 'taskFail' || event.action === 'taskAbort' ? [
                `isTimeoutError:${isTimeoutError}`
            ] : [],
            ...event.name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) && event.action === 'taskAbort' ? [
                `isPermissionError:${isPermissionError}`
            ] : []
        ];
        if (event.attributes) for(const a in event.attributes)tags.push(`${a}:${event.attributes[a]}`);
        if (event.action === 'taskFail' && $9713ba3226cd0c48$var$SLA_EXPERIENCES.has(event.name)) {
            // in this section, we submit information about SLA-affecting experience failures.
            // We don't submit timeout errors to monitoring systems however; they would be submitted to Analytics instead.
            // cc-fe-telemetry will filter these additional tags before sending to SFX, these are only for "Raw TelemetryEvent" Splunk logs
            if (event?.error?.message) tags.push(`error:${event.error.message}`);
            // Supply additional information from alternative sources, for case where SessionDataQuery is not available
            tags.push(`hostname:${window.location.hostname}`);
            tags.push(`tenantIdMeta:${(0, $8EsbU.getOverride)('cloud-id')}`);
            (0, $5ZqQS.getMonitoringClient)().incrementCounter(`experience-tracker:${event.name}`, tags);
            if (!(event.error instanceof (0, $glCMv.ExperienceTimeoutError))) {
                (0, $fJlJm.setContentErrorAttributes)(event.error, {
                    objectId: event.attributes?.contentId
                });
                (0, $fJlJm.setSlaErrorAttributes)(event.error, {
                    failedSlaExperience: event.name,
                    experienceId: event.attributes?.uniqueExperienceId ?? event.id
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(event.error, {
                    attribution: 'sla'
                });
            }
        } else (0, $5ZqQS.getMonitoringClient)().incrementCounter(`experience-tracker:${event.name}`, tags);
    });
    return tracker;
});
function $9713ba3226cd0c48$export$720dc4209419df4e(name, error, attributes) {
    $9713ba3226cd0c48$export$a1fa58e5690a5a9a().stopOnError({
        name: name,
        error: error,
        attributes: attributes
    });
}
const $9713ba3226cd0c48$export$1c9cdc2685ab8d2 = (tracker, event, name = event.name)=>{
    switch(event.action){
        case 'taskStart':
            tracker.start({
                ...event,
                name: name
            });
            break;
        case 'taskSuccess':
            tracker.succeed({
                ...event,
                name: name
            });
            break;
        case 'taskFail':
            tracker.fail({
                ...event,
                name: name
            });
            break;
        case 'taskAbort':
            tracker.abort({
                ...event,
                name: name
            });
    }
};
function $9713ba3226cd0c48$export$e8918c537d57dc96(routeName) {
    $9713ba3226cd0c48$var$previousRoute.routeName = $9713ba3226cd0c48$var$currentRoute.routeName;
    $9713ba3226cd0c48$var$previousRoute.successfulExperiences = $9713ba3226cd0c48$var$currentRoute.successfulExperiences;
    $9713ba3226cd0c48$var$currentRoute.routeName = routeName;
    $9713ba3226cd0c48$var$currentRoute.successfulExperiences = new Set();
}
function $9713ba3226cd0c48$export$5259f71d975e46f5() {
    return {
        ...$9713ba3226cd0c48$var$previousRoute
    };
}
const $9713ba3226cd0c48$var$splitViewContentExperience = (tracker, event)=>{
    let name;
    if (event.attributes?.contentType === 'space') {
        name = (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE);
        const spaceKey = event.attributes?.spaceKey;
        if (typeof spaceKey === 'string' && (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) name = (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE);
    } else {
        name = (0, $irVI7.VIEW_PAGE_EXPERIENCE);
        if (event.action === 'taskStart') (0, $949zl.startViewPageSessionExperience)({
            tracker: tracker,
            attributes: {
                ...event.attributes
            },
            startTime: event.startTime,
            id: event.id
        });
    }
    $9713ba3226cd0c48$export$1c9cdc2685ab8d2(tracker, event, name);
};
/**
 * Extend the ExperienceEvent with Confluence-specific additional attributes based on available data and type of event.
 *
 * @param event ExperienceEvent
 * @returns ExperienceEvent with additional attributes
 */ const $9713ba3226cd0c48$var$provideGenericAttributes = (event)=>{
    const errorTraceId = event.action === 'taskFail' && !!event?.error ? (0, $fJlJm.getLogSafeErrorAttributes)(event.error)?.traceId : undefined;
    // Expected that condition will be extended with && for other attributes added in the future
    if (!errorTraceId) return event;
    event.attributes = {
        ...!!errorTraceId && {
            traceId: errorTraceId
        },
        ...event.attributes
    };
    return event;
};
module.exports["getLatestActiveSlaExperience"] = $9713ba3226cd0c48$export$1e7d0a9a962cdd28;
module.exports["getExperienceTracker"] = $9713ba3226cd0c48$export$a1fa58e5690a5a9a;
module.exports["stopExperienceOnError"] = $9713ba3226cd0c48$export$720dc4209419df4e;
module.exports["forwardExperience"] = $9713ba3226cd0c48$export$1c9cdc2685ab8d2;
module.exports["captureRouteChange"] = $9713ba3226cd0c48$export$e8918c537d57dc96;
module.exports["getPreviousRouteExperienceData"] = $9713ba3226cd0c48$export$5259f71d975e46f5;

});

parcelRegister("kquTo", function(module, exports) {
const $84862b0cf58a5511$export$9c05e7ef9f2c8895 = (event)=>({
        // Events should match the schema defined here:
        // https://hello.atlassian.net/wiki/spaces/BIZOPS/pages/387788554/Analytics+Event+Schema+for+SLA
        source: 'ui',
        actionSubject: 'ui',
        action: event.action,
        eventType: 'operational',
        attributes: $84862b0cf58a5511$var$createExperienceTrackerAnalyticsAttributes(event)
    });
function $84862b0cf58a5511$var$createExperienceTrackerAnalyticsAttributes(event) {
    const { action: action, name: name, id: id, attributes: experienceAttributes, ...rest } = event;
    const attributes = {
        ...experienceAttributes,
        ...rest,
        task: name,
        taskId: id
    };
    if (attributes.error) {
        let error;
        if (typeof attributes.error === 'string') error = new Error(attributes.error);
        else error = attributes.error;
        delete attributes.error;
        attributes.errorName = error.name;
        if (!attributes.traceId && error.traceId) attributes.traceId = error.traceId;
        attributes.errorMessage = error.message;
    }
    attributes.browserInfo = window.navigator.userAgent;
    // Matches the analytics-web-client's apdex event
    attributes.isActiveTab = document.visibilityState === 'visible';
    return attributes;
}
module.exports["createExperienceTrackerAnalyticsEventPayload"] = $84862b0cf58a5511$export$9c05e7ef9f2c8895;

});

parcelRegister("8EsbU", function(module, exports) {
/**
 * confluence/meta is used to access dynamic metadata passed from the
 * server to JavaScript via the page HTML.
 */ /**
 *  A backing map to use if the user sets data.
 */ const $60f04d82b79373b9$export$1591b5b8c61dbb9c = {};
const $60f04d82b79373b9$export$357972e1dc28ee9f = (key, value)=>{
    $60f04d82b79373b9$export$1591b5b8c61dbb9c[key] = value;
};
const $60f04d82b79373b9$export$70f24959ef00553b = (value)=>{
    const evaluatedValue = typeof value === 'string' ? value.toLowerCase() : '';
    const booleanEnum = {
        true: true,
        false: false
    };
    return evaluatedValue in booleanEnum ? booleanEnum[evaluatedValue] : value;
};
const $60f04d82b79373b9$export$72427a1521dd0069 = (key)=>{
    // Check if we're server-side or client-side
    if ($60f04d82b79373b9$export$9542afab8c2a5f48()) {
        const metaEl = document.querySelector(`meta[name='ajs-${key}']`);
        if (metaEl) return $60f04d82b79373b9$export$70f24959ef00553b(metaEl.content);
        return $60f04d82b79373b9$export$1591b5b8c61dbb9c[key];
    }
    // Always return undefined on the server-side
    return undefined;
};
const $60f04d82b79373b9$export$49258654c956d9af = ()=>{
    const map = {};
    if (!document?.querySelectorAll?.length) return map;
    const metas = document.querySelectorAll('meta[name^=ajs-]');
    if (metas) for(let i = 0; i < metas.length; i++){
        const { name: name, content: content } = metas[i];
        map[name.substring(4)] = content;
    }
    return Object.assign(map, $60f04d82b79373b9$export$1591b5b8c61dbb9c);
};
const $60f04d82b79373b9$export$594c6655c9709eda = ()=>{
    const metaData = {};
    if ($60f04d82b79373b9$export$9542afab8c2a5f48()) {
        const metaTags = document.querySelectorAll('meta[name^=ajs-]');
        for(let i = 0; i < metaTags.length; i++){
            const { name: name, content: content } = metaTags[i];
            metaData[name.replace(/^ajs-/, '')] = content;
        }
    }
    return metaData;
};
const $60f04d82b79373b9$export$9542afab8c2a5f48 = ()=>{
    return typeof document !== 'undefined';
};
const $60f04d82b79373b9$export$578af21a462ae10b = ()=>{
    Object.keys($60f04d82b79373b9$export$1591b5b8c61dbb9c).forEach((key)=>{
        delete $60f04d82b79373b9$export$1591b5b8c61dbb9c[key];
    });
};
module.exports["setOverride"] = $60f04d82b79373b9$export$357972e1dc28ee9f;
module.exports["getOverride"] = $60f04d82b79373b9$export$72427a1521dd0069;
module.exports["getAllAsMap"] = $60f04d82b79373b9$export$49258654c956d9af;
module.exports["getTagsAsMap"] = $60f04d82b79373b9$export$594c6655c9709eda;

});

parcelRegister("cEgMD", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $6X8o4 = parcelRequire("6X8o4");

const $b72d43032a695cf0$var$COMPANY_HUB_SPACE_KEY_PREFIX = '~HUB';
const $b72d43032a695cf0$export$5ab9c400208ad907 = (spaceKey)=>!!(spaceKey?.startsWith($b72d43032a695cf0$var$COMPANY_HUB_SPACE_KEY_PREFIX) && spaceKey?.endsWith('~'));
const $b72d43032a695cf0$export$6193f65d76fa4c00 = (sessionData)=>{
    if (!sessionData?.activationId || !sessionData?.cloudId) sessionData = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)());
    if (sessionData) {
        const { activationId: activationId, cloudId: cloudId } = sessionData;
        if (activationId && cloudId) return `${$b72d43032a695cf0$var$COMPANY_HUB_SPACE_KEY_PREFIX}-${cloudId}-${activationId}~`;
    }
    // We used to return undefined, but pretty much always we fell back to the empty string with code like `?? ''` or `|| ''`.
    // Instead of sprinkling noise like that all over, it's less complex to do the de facto fallback here.
    return '';
};
var $b72d43032a695cf0$export$8b92a390c1734cf9 = /*#__PURE__*/ function(FrontCoverStateEnum) {
    FrontCoverStateEnum["UNSET"] = "unset";
    FrontCoverStateEnum["HIDDEN"] = "hidden";
    FrontCoverStateEnum["EDITORS_ONLY"] = "editors_only";
    FrontCoverStateEnum["SHOWN"] = "shown";
    return FrontCoverStateEnum;
}({});
var $b72d43032a695cf0$export$ec1312b61cf60ef3 = /*#__PURE__*/ function(FrontCoverStateInputEnum) {
    FrontCoverStateInputEnum["UNSET"] = "UNSET";
    FrontCoverStateInputEnum["HIDDEN"] = "HIDDEN";
    FrontCoverStateInputEnum["SHOWN"] = "SHOWN";
    return FrontCoverStateInputEnum;
}({});
module.exports["isCompanyHubSpaceKey"] = $b72d43032a695cf0$export$5ab9c400208ad907;
module.exports["getCompanyHubSpaceKey"] = $b72d43032a695cf0$export$6193f65d76fa4c00;
module.exports["FrontCoverStateEnum"] = $b72d43032a695cf0$export$8b92a390c1734cf9;

});

parcelRegister("irVI7", function(module, exports) {
// Deep link visiting
const $4a617be77ace987f$export$61f782d99db03c49 = 'follow-deep-link';
const $4a617be77ace987f$export$ed2197e4948fef6c = 'view-macro-renderer';
const $4a617be77ace987f$export$136d4e1bb3adaa98 = 'view-macro-editor';
const $4a617be77ace987f$export$54747aca26cee3f8 = 'view-all-macro';
const $4a617be77ace987f$export$f8afba90a5a815ad = 'view-jira-macro';
const $4a617be77ace987f$export$87daa9a1b1dd910d = 'migrate-page';
const $4a617be77ace987f$export$6c0a7d453b9ba427 = 'migrate-page/publish';
const $4a617be77ace987f$export$b39a77dbc03575b1 = 'migrate-template';
const $4a617be77ace987f$export$f94e85276e6d639f = 'add-page-comment';
const $4a617be77ace987f$export$31bd7de6ca230764 = 'add-page-comment/load';
const $4a617be77ace987f$export$4cb6cf73aff93e7d = 'add-page-comment/publish';
const $4a617be77ace987f$export$2a99a63e28df64fd = 'edit-page-comment';
const $4a617be77ace987f$export$515913089a77cb7c = 'edit-page-comment/load';
const $4a617be77ace987f$export$c0906b23fa1e3b63 = 'edit-page-comment/publish';
const $4a617be77ace987f$export$e9a5501ca0d5d256 = 'reply-to-page-comment';
const $4a617be77ace987f$export$3fdffa656412b99a = 'reply-to-page-comment/load';
const $4a617be77ace987f$export$bfebfbab40727cd6 = 'reply-to-page-comment/publish';
const $4a617be77ace987f$export$91d50c2b267d0461 = 'delete-page-comment';
const $4a617be77ace987f$export$24ef8c79de5598b9 = 'resolve-page-comment';
const $4a617be77ace987f$export$8c6422f793f7efae = 'mark-comments-as-read';
const $4a617be77ace987f$export$98dbdebd041da61c = 'mark-all-comments-as-read';
const $4a617be77ace987f$export$6f58645a9a5f7936 = 'create-inline-comment';
const $4a617be77ace987f$export$8180a49fb6c681b1 = 'create-inline-comment/init';
const $4a617be77ace987f$export$ed5e210bce3a41a9 = 'create-inline-comment/draft-to-publish';
const $4a617be77ace987f$export$db23cb60632b0aa0 = 'create-inline-comment/attach-comment';
const $4a617be77ace987f$export$f8e0e16825f0d222 = 'select-inline-comment';
const $4a617be77ace987f$export$2003fd9c8f509d96 = 'add-inline-comment';
const $4a617be77ace987f$export$a69ecd33d83d56ce = 'add-inline-comment/load';
const $4a617be77ace987f$export$eb89dbd7422d8194 = 'add-inline-comment/publish';
const $4a617be77ace987f$export$29c433981d13c955 = 'edit-inline-comment';
const $4a617be77ace987f$export$a557d8a611f835b = 'edit-inline-comment/load';
const $4a617be77ace987f$export$e9dafdd46fb3d4ed = 'edit-inline-comment/publish';
const $4a617be77ace987f$export$20fbac00cba3c8a = 'view-inline-comment';
const $4a617be77ace987f$export$533f2a7cfe4f757e = 'view-inline-comment/toplevel';
const $4a617be77ace987f$export$fb1f28583d577755 = 'view-inline-comment/reply';
const $4a617be77ace987f$export$9d157677f817543f = 'reply-to-inline-comment';
const $4a617be77ace987f$export$b4f2ad99abb89883 = 'reply-to-inline-comment/load';
const $4a617be77ace987f$export$32059abd767a1104 = 'reply-to-inline-comment/publish';
const $4a617be77ace987f$export$bcfccb61f33e9641 = 'delete-inline-comment';
const $4a617be77ace987f$export$819fbef15068ac1d = 'resolve-inline-comment';
const $4a617be77ace987f$export$996a096215f40255 = 'unresolve-inline-comment';
const $4a617be77ace987f$export$c64ae72fd2ff5bed = 'resolved-inline-comments-dialog-sort';
const $4a617be77ace987f$export$a32711b0e13e94b7 = 'reattach-inline-comment';
const $4a617be77ace987f$export$d6f52083721d3342 = 'view-reactions';
const $4a617be77ace987f$export$e6f0efe9d461092e = 'view-reaction-user-list';
const $4a617be77ace987f$export$ba45b443cf775f1b = 'add-reaction';
const $4a617be77ace987f$export$63f7987e2f1f8f3 = 'delete-reaction';
const $4a617be77ace987f$export$aa1b3aa6132c5165 = 'add-quick-reaction';
const $4a617be77ace987f$export$7321222ee6dc4c8a = 'copy-space-permissions';
const $4a617be77ace987f$export$227ea80a7d6d8ef2 = 'create-page';
const $4a617be77ace987f$export$1773354263fb7a1f = 'create-page/load-dialog';
const $4a617be77ace987f$export$5f80ef7b2915bb38 = 'create-page/template-variable-input';
const $4a617be77ace987f$export$f27db95814bbdf0 = 'create-whiteboard';
const $4a617be77ace987f$export$13566a78bbba7568 = 'create-database';
const $4a617be77ace987f$export$c6222c9fbf47e43b = 'create-embed';
const $4a617be77ace987f$export$63a2c018dc189e0 = 'create-folder';
const $4a617be77ace987f$export$9c40f417713b17ea = 'edit-page-smart-create/load';
const $4a617be77ace987f$export$dd70d6707192298e = 'edit-page';
const $4a617be77ace987f$export$cd96dc6a09f60949 = 'edit-legacy-page';
const $4a617be77ace987f$export$b6f302e969b56ed5 = 'edit-page-embed';
const $4a617be77ace987f$export$cfe717283b384dee = 'edit-page/loader'; // loader to determine editor routing (next vs. classic)
const $4a617be77ace987f$export$54650b8dd9597591 = 'edit-page/load';
const $4a617be77ace987f$export$9cfef550e5af515d = 'edit-legacy-page/load';
const $4a617be77ace987f$export$4aed0cf42acf9c68 = 'edit-page/publish';
const $4a617be77ace987f$export$770ea955fed26e20 = 'edit-legacy-page/publish';
const $4a617be77ace987f$export$4abcdf78bb75330c = 'edit-page/publish-as-blog';
const $4a617be77ace987f$export$92edebd76eb1ad1 = 'edit-page/close';
const $4a617be77ace987f$export$1339ae8dc80b092c = 'edit-legacy-page/close';
const $4a617be77ace987f$export$42ce143b9452f768 = 'edit-page/revert-draft';
const $4a617be77ace987f$export$d3dcb341de2e384f = 'live-page';
const $4a617be77ace987f$export$f8e950d04ce466ff = 'live-page/edit';
const $4a617be77ace987f$export$3814d28dd3802a02 = 'live-page-session';
const $4a617be77ace987f$export$40fb2b7b657bf7d = 'live-page/publish';
const $4a617be77ace987f$export$9e0dcc9389703292 = 'create-and-edit-page';
const $4a617be77ace987f$export$b9892a850189b3e9 = 'template-edit-page';
const $4a617be77ace987f$export$3604f7decc6e0567 = 'template-edit-page/load';
const $4a617be77ace987f$export$1a3cf6b911b3771 = 'template-edit-page/close';
const $4a617be77ace987f$export$a7f90c693668eabe = 'template-edit-page/publish';
const $4a617be77ace987f$export$3c5dcebba4317c7e = 'template-edit-page/publish/template-body';
const $4a617be77ace987f$export$3a8f568ddb8f3189 = 'template-edit-page/publish/template-properties';
const $4a617be77ace987f$export$583391c24e8a1735 = 'in-editor-templates-load-panel';
const $4a617be77ace987f$export$6afe1d2e05c85172 = 'in-editor-templates-load-panel/template-list';
const $4a617be77ace987f$export$6085a8760b035f6 = 'in-editor-templates-load-panel/categories';
const $4a617be77ace987f$export$cbd9dfa0a050a0e0 = 'in-editor-templates-load-panel/space-selector';
const $4a617be77ace987f$export$8fcf8395eb106389 = 'in-editor-templates-update-content';
const $4a617be77ace987f$export$eac277758b783558 = 'in-editor-templates-update-content/refresh-editor';
const $4a617be77ace987f$export$d3b70eeb61a68ef1 = 'template-suggestions';
const $4a617be77ace987f$export$89e30156af35c723 = 'view-in-product-help';
const $4a617be77ace987f$export$1072a5750cf51c7e = 'search-in-product-help';
const $4a617be77ace987f$export$85f8b3853315a126 = 'search-in-product-help/load';
const $4a617be77ace987f$export$49e4c787a6cc62e = 'view-article-in-product-help';
const $4a617be77ace987f$export$3d1292b099f0e166 = 'view-article-in-product-help/load';
const $4a617be77ace987f$export$54615853abc6859 = 'template-gallery';
const $4a617be77ace987f$export$82c983e2a60f2e28 = 'template-gallery/space-selector';
const $4a617be77ace987f$export$61439b391c5a3aca = 'template-gallery/categories';
const $4a617be77ace987f$export$81cd8bf6923e1bf1 = 'template-gallery/cards';
const $4a617be77ace987f$export$b6af3a64b182b9d0 = 'template-gallery/template-detail';
const $4a617be77ace987f$export$588acf29fbd8637d = 'template-gallery/template-detail-update';
const $4a617be77ace987f$export$a1cf4f28febc3bee = 'template-gallery/template-detail/header';
const $4a617be77ace987f$export$b802716fd0c5b93f = 'template-preview';
const $4a617be77ace987f$export$e0195c05e32ed777 = 'refresh-editor-content';
const $4a617be77ace987f$export$9194ae178043ade6 = 'create-content-from-template';
const $4a617be77ace987f$export$1545639c80579c53 = 'blueprint-wizard-load-dialog';
const $4a617be77ace987f$export$fc0c176abc30d17b = 'connect-addon';
const $4a617be77ace987f$export$97b170c4be77228 = 'quick-reload';
const $4a617be77ace987f$export$9625ccab45afe35a = 'quick-reload-v3';
const $4a617be77ace987f$export$dbbd27df623b094f = 'restricted-page';
const $4a617be77ace987f$export$8f404e4bd2a13aa = 'restricted-space-for-guest';
const $4a617be77ace987f$export$727b779ceeca0a78 = 'restricted-space';
const $4a617be77ace987f$export$b9ee7465c962e842 = 'restrictions-dialog';
const $4a617be77ace987f$export$2e96e7e6b8da0317 = 'restrictions-dialog/load';
const $4a617be77ace987f$export$6b54d78a736a983b = 'restrictions-dialog/apply';
const $4a617be77ace987f$export$a66250c876dd8838 = 'publish-modal/load-restrictions';
const $4a617be77ace987f$export$e64caae0c75dd921 = 'impersonation-flag';
const $4a617be77ace987f$export$7ebe8ae2b3f231cb = 'inspect-permissions';
const $4a617be77ace987f$export$b659623b19114e87 = 'user-access';
const $4a617be77ace987f$export$9d715fddec195756 = 'upsell-edition';
const $4a617be77ace987f$export$a7ffbea51ff646ee = 'upsell-edition-upflow';
const $4a617be77ace987f$export$bd5028ea224c4de1 = 'archiving/archive-pages';
const $4a617be77ace987f$export$e63a17e805ed8387 = 'archiving/restore-pages';
const $4a617be77ace987f$export$d74c17e82f5dbc27 = 'archiving/view-space-archived-pages';
const $4a617be77ace987f$export$b7a40ae431fd676d = 'archiving/view-space-archived-pages/paginate';
const $4a617be77ace987f$export$b84de3b67d7aa4be = 'archiving/edit-notes-archive-pages';
const $4a617be77ace987f$export$9efd42121cbefbff = 'archiving/bulk-edit-notes-archive-pages';
const $4a617be77ace987f$export$c30b739e25dc756b = 'archiving/archived-page-banner';
const $4a617be77ace987f$export$fc9036c892e05ff9 = 'automation-discovery/add-label';
const $4a617be77ace987f$export$abe2705723fc11ac = 'automation-discovery/publish-meeting-notes';
const $4a617be77ace987f$export$90d9afd417e81733 = 'automation-discovery/archive-page';
const $4a617be77ace987f$export$bcf33c3d2ec343df = 'automation-discovery/hover-over-page-title';
const $4a617be77ace987f$export$8b43be9232ec143f = 'automation-discovery/jira-link';
const $4a617be77ace987f$export$adc097acaa5bd53a = 'automation-discovery/manual-trigger';
const $4a617be77ace987f$export$184da8822d56484c = 'automation-discovery/bulk-archive';
const $4a617be77ace987f$export$65a0bbd38d8f5b63 = 'automation-discovery/page-public-link';
const $4a617be77ace987f$export$c7dca20d997e95ed = 'automation-manual-triggers';
const $4a617be77ace987f$export$2504afae65d57ffb = 'automation-discovery/whiteboards';
const $4a617be77ace987f$export$cf23f74117283d17 = 'automation-discovery/bulk-change-page-owner';
const $4a617be77ace987f$export$78bf51c34f43d049 = 'automation-smart-button-run-rule';
const $4a617be77ace987f$export$d0afbe071e52a5cf = 'automation-smart-button-create-rule';
const $4a617be77ace987f$export$b30eb768fa4c3967 = 'automation-smart-button-edit-rule';
const $4a617be77ace987f$export$2cc8139334567c4f = 'automation-smart-button-preview-rule';
const $4a617be77ace987f$export$cab2a1e3c7ddbb06 = 'automation-side-nav-bar';
const $4a617be77ace987f$export$a03bf7627f412dc4 = 'automation-upsell';
const $4a617be77ace987f$export$a26e99521ea3a9f4 = 'delete-page';
const $4a617be77ace987f$export$57cc53c6e3b9be1b = 'bulk-delete-pages';
const $4a617be77ace987f$export$91d3a54b5d7e1b7f = 'bulk-change-owner';
const $4a617be77ace987f$export$ba8b23dd795f5f9e = 'bulk-change-status';
const $4a617be77ace987f$export$7bea875d555696ca = 'bulk-convert-page-to-live-doc';
const $4a617be77ace987f$export$a837ee39f68fa2dd = 'edit-sidebar';
const $4a617be77ace987f$export$e69ba0c4a7667861 = 'edit-sidebar/update';
const $4a617be77ace987f$export$c6fd99844ee488c5 = 'manage-pages';
const $4a617be77ace987f$export$8fc86f50c7402da0 = 'manage-pages/paginate';
const $4a617be77ace987f$export$d4b4a08489e4dfe2 = 'content-manager';
const $4a617be77ace987f$export$c03f98139dd9719e = 'move-page-dialog-load';
const $4a617be77ace987f$export$1167cf561a6df618 = 'move-published-page';
const $4a617be77ace987f$export$95c6dda6cbbf364 = 'move-blog';
const $4a617be77ace987f$export$fbbc408e16c59382 = 'not-found';
const $4a617be77ace987f$export$cf73dfff88c1f700 = 'view-content';
const $4a617be77ace987f$export$d4712ac27cc4e72f = 'view-page';
const $4a617be77ace987f$export$5e30e9d7ea54dcd2 = 'view-page-session';
const $4a617be77ace987f$export$2a57468d23984a9d = 'space-overview';
const $4a617be77ace987f$export$54504a2cc31519bf = 'breadcrumbs';
const $4a617be77ace987f$export$68af05e1cf40b8e6 = 'breadcrumbs/dropdown';
const $4a617be77ace987f$export$863ebd92a50403cf = 'view-page/title';
const $4a617be77ace987f$export$df0793573ff7d63c = 'view-page/reactions';
const $4a617be77ace987f$export$bdd2d0f331a38827 = 'view-page/labels'; //After confluence_frontend_labels_in_footer is rolled out, this will only beused for tiny pages which show the old view page labels experience
const $4a617be77ace987f$export$def55fa9fa47c777 = 'view-page/labels/footer';
const $4a617be77ace987f$export$49fde5724a27b431 = 'view-page/byline';
const $4a617be77ace987f$export$7a119c18309263c = 'view-page/byline/forge';
const $4a617be77ace987f$export$45c9f537ef090ccd = 'view-page/comments';
const $4a617be77ace987f$export$d7d1b2bdd9bd08f4 = 'view-page/direct-comment-data-flow';
const $4a617be77ace987f$export$dc03e514628af5e9 = 'view-page/edit';
const $4a617be77ace987f$export$38478feb41239856 = 'view-page/content-tools';
const $4a617be77ace987f$export$ef641459105e6b1a = 'view-page/content-tools/forge';
const $4a617be77ace987f$export$255077470163d493 = 'view-page/context-menu';
const $4a617be77ace987f$export$43081e88ffac9568 = 'view-page/context-menu/forge';
const $4a617be77ace987f$export$14a39beec323232a = 'view-page/content-header'; // for old view page header
const $4a617be77ace987f$export$5870dabed6d7b7fc = 'view-page/favorite';
const $4a617be77ace987f$export$857306718a36d667 = 'view-page/share-button';
const $4a617be77ace987f$export$b7907767002e32d = 'view-page/restrictions-button';
const $4a617be77ace987f$export$aa15347df133b367 = 'view-page/comment-button';
const $4a617be77ace987f$export$18cb1bed3afb8173 = 'view-page/discover-inline-comments-feature';
const $4a617be77ace987f$export$b500820ed8b3aee5 = 'view-page/publish-as-blog';
const $4a617be77ace987f$export$a83700d85c7e0745 = 'whiteboard-page';
const $4a617be77ace987f$export$bdaf5db6d84a5581 = 'whiteboard-page/content';
const $4a617be77ace987f$export$4252e8d96c415d57 = 'whiteboard-version-history-side-panel';
const $4a617be77ace987f$export$b8cdecdc06b6252 = 'whiteboard-restore-version';
const $4a617be77ace987f$export$90f5a89f66458e77 = 'whiteboard-version-history-restore-modal';
const $4a617be77ace987f$export$f02aef641190ead6 = 'database-page';
const $4a617be77ace987f$export$7140ccdb0c7b2b37 = 'database-page/content';
const $4a617be77ace987f$export$857587c3b96ae00c = 'database-version-history-side-panel';
const $4a617be77ace987f$export$bdbfe4dafa70ffab = 'database-restore-version';
const $4a617be77ace987f$export$7cc7b880d5b3f324 = 'database-version-history-restore-modal';
const $4a617be77ace987f$export$ba3b240cb9a3ffd0 = 'database-load-historical-version';
const $4a617be77ace987f$export$c85a8dac7f241add = 'embed-page';
const $4a617be77ace987f$export$927658f514adba70 = 'embed-page/content';
const $4a617be77ace987f$export$c1092431c58e1571 = 'edit-embed';
const $4a617be77ace987f$export$3485e62ad9c27d0b = 'folder-page';
const $4a617be77ace987f$export$6237c6dbe5a63f05 = 'folder-page/content';
const $4a617be77ace987f$export$7fd0425089f6d999 = 'content-types-header';
const $4a617be77ace987f$export$47f14e5e827cfff3 = 'content-types-header/watch';
const $4a617be77ace987f$export$748b7f600814978a = 'content-creation-paywall';
const $4a617be77ace987f$export$5e1aeeb6f31be57a = 'record-loom-entry-point';
const $4a617be77ace987f$export$c427a8b1052a6522 = 'loom-page-header-content-insertion';
const $4a617be77ace987f$export$6ca90e5df7047c10 = 'loom-cross-sell';
const $4a617be77ace987f$export$96f8e8997d2c8722 = 'edit-page/labels';
const $4a617be77ace987f$export$e9e0897b7cf2ab3f = 'labels/add-label';
const $4a617be77ace987f$export$5a4fc6855f9c48e = 'labels/create-label';
const $4a617be77ace987f$export$3f19e9a9a0d72413 = 'labels/delete-label';
const $4a617be77ace987f$export$39d403abc2174e5e = 'labels/search-label';
const $4a617be77ace987f$export$4d573c9dfbc9337c = 'labels/recommended';
const $4a617be77ace987f$export$8af5d568de2d4e43 = 'template-edit-page/labels';
const $4a617be77ace987f$export$c5ef6dea1c804893 = 'template-edit-page/labels/add-label';
const $4a617be77ace987f$export$fa82b911a68fea4d = 'template-edit-page/labels/create-label';
const $4a617be77ace987f$export$20b2f79b83628af0 = 'template-edit-page/labels/delete-label';
const $4a617be77ace987f$export$479dc90f08ae49d = 'template-edit-page/labels/search-label';
const $4a617be77ace987f$export$d8e5793fc3893dd0 = 'header-items/group-load';
const $4a617be77ace987f$export$66f0a82e06e92ea = 'home';
const $4a617be77ace987f$export$8856e11bfa69959d = 'home/spaces';
const $4a617be77ace987f$export$8ef0e6a462dfc555 = 'home/recent-pages';
const $4a617be77ace987f$export$d931b261468db3be = 'home/right-panel';
const $4a617be77ace987f$export$cd6478684fc4b278 = 'home/right-panel/activity';
const $4a617be77ace987f$export$45cf379c9ef28a2d = 'home/right-panel/welcome-message';
const $4a617be77ace987f$export$ceb391a6374fc2 = 'home/right-panel/calendars';
const $4a617be77ace987f$export$799c1b543715aab4 = 'home/right-panel/apps';
const $4a617be77ace987f$export$519eb6f457873738 = 'home/right-panel/forge';
const $4a617be77ace987f$export$b57c8eba324f4ab1 = 'home/right-panel/recommendations';
const $4a617be77ace987f$export$cf6a4f3279a69e87 = 'confluence';
const $4a617be77ace987f$export$680e462c4f71cea1 = 'feed';
const $4a617be77ace987f$export$d660d67b42309542 = 'home/overview';
const $4a617be77ace987f$export$f987075f870b167d = 'home/overview/recent';
const $4a617be77ace987f$export$6c96437f170477a4 = 'home/overview/recent/paginate';
const $4a617be77ace987f$export$94f2ecf008a81b99 = 'home/recent';
const $4a617be77ace987f$export$45d7f7ed7a82bcd = 'home/starred';
const $4a617be77ace987f$export$ecf5fd41d4da9bf8 = 'home/watching';
const $4a617be77ace987f$export$9b242f2ddcd908fc = 'home/drafts';
const $4a617be77ace987f$export$5393f7f46c9e5055 = 'advanced-search';
const $4a617be77ace987f$export$91a00c702eb82c2c = 'advanced-search/space-filter';
const $4a617be77ace987f$export$3f0c1a8eb5419bb4 = 'advanced-search/contributor-filter';
const $4a617be77ace987f$export$bda2c35d9a84e22c = 'advanced-search/smart-contributor-filter';
const $4a617be77ace987f$export$ec545137ad6ac054 = 'quick-search/pre-query';
const $4a617be77ace987f$export$e64dfa2771353f5c = 'recent-dropdown/visited';
const $4a617be77ace987f$export$53f4f21972586e42 = 'recent-dropdown/created-by-me';
const $4a617be77ace987f$export$985013c384c228e1 = 'recent-dropdown/worked-on';
const $4a617be77ace987f$export$605220fac97de = 'recent-dropdown/drafts';
const $4a617be77ace987f$export$7c6d9e11a2120c1b = 'recent-dropdown/starred';
const $4a617be77ace987f$export$59a9c2c7ae337de7 = 'page-tree';
const $4a617be77ace987f$export$bbc326cd1f124322 = 'page-tree/dnd';
const $4a617be77ace987f$export$f9d04e98575a0216 = 'page-tree/quick-actions';
const $4a617be77ace987f$export$cd3eec90d152a8ea = 'page-tree/rename';
const $4a617be77ace987f$export$9d1f80f618a6627b = 'blog-tree';
const $4a617be77ace987f$export$899513ff8720fa55 = 'blog-tree/pagination';
const $4a617be77ace987f$export$d200becb25c80dc0 = 'activity/tailored';
const $4a617be77ace987f$export$8729a78bfed79808 = 'activity/create-space-button';
const $4a617be77ace987f$export$b0be9d71080b7c81 = 'activity/right-sidebar';
const $4a617be77ace987f$export$2783f61e72caafb5 = 'feed-migration/activity/popular';
const $4a617be77ace987f$export$fcff442a18d04a5d = 'feed-migration/activity/all-updates';
const $4a617be77ace987f$export$357a2b9b5fb0f4e4 = 'navigation/nav-2-admin-navigation/forge';
const $4a617be77ace987f$export$9b5915bb3a4fbcae = 'navigation/app-nav-global-navigation';
const $4a617be77ace987f$export$e3e183dd97af67fd = 'navigation/app-nav-container-navigation';
const $4a617be77ace987f$export$14b67f3e8f5e6f95 = 'navigation/app-nav-admin-navigation';
const $4a617be77ace987f$export$f089f204ab93864e = 'navigation/app-nav-spaces-dropdown';
const $4a617be77ace987f$export$5c3671291c82150b = 'navigation/app-nav-pages-dropdown';
const $4a617be77ace987f$export$63d03b6879925116 = 'navigation/app-nav-apps-dropdown';
const $4a617be77ace987f$export$fa160b39d3766fc0 = 'navigation/app-nav-notifications-dropdown';
const $4a617be77ace987f$export$986139018de1521a = 'navigation/app-nav-profile-dropdown';
const $4a617be77ace987f$export$6cebb7e0b005cd28 = 'space-directory';
const $4a617be77ace987f$export$aeda23f4b92ccc3b = 'space-directory/your-spaces';
const $4a617be77ace987f$export$4a890f75d0a61967 = 'space-directory/filter';
const $4a617be77ace987f$export$39e9ebfcfd8e8bad = 'space-directory/paginate';
const $4a617be77ace987f$export$de6098630f95035a = 'create-space/submit';
const $4a617be77ace987f$export$9b47bc79e174bc93 = 'create-space/validate';
const $4a617be77ace987f$export$1d45fd96fcd751f5 = 'onboarding/start';
const $4a617be77ace987f$export$c33c0eca528dad5c = 'onboarding/invite-users';
const $4a617be77ace987f$export$6d895b52727161d4 = 'onboarding/remove-invite-users';
const $4a617be77ace987f$export$be07109624e8a07e = 'onboarding/create-a-space';
const $4a617be77ace987f$export$d5e6e79f726e8007 = 'onboarding/choose-a-space';
const $4a617be77ace987f$export$87a646b39eb224a = 'onboarding/end';
const $4a617be77ace987f$export$a453322b492264d1 = 'onboarding/choose-a-space-card';
const $4a617be77ace987f$export$4ead33eb5b37dee5 = 'onboarding/follow-spaces';
const $4a617be77ace987f$export$59c55b717acdcf15 = 'onboarding/auto-follow-spaces';
const $4a617be77ace987f$export$a09834a747086083 = 'onboarding/shared-link-spotlight';
const $4a617be77ace987f$export$749c4d9c23381805 = 'onboarding/nudge';
const $4a617be77ace987f$export$1aaba3dd5fd71b43 = 'onboarding-account-setup-modal';
const $4a617be77ace987f$export$7989a920a6248647 = 'onboarding-jsw-xflow/admin-switcher-tour';
const $4a617be77ace987f$export$55172161173a2d6e = 'onboarding-jsw-xflow/nth-switcher-tour';
const $4a617be77ace987f$export$aaf55a29d2f12a6e = 'onboarding-jsw-xflow/invite-teammate-task';
const $4a617be77ace987f$export$e40755126e0d0b54 = 'onboarding-editor/draft-banner';
const $4a617be77ace987f$export$32b7ff7de164c7ad = 'onboarding-editor/land-in-editor-banner';
const $4a617be77ace987f$export$b154482ef737e03a = 'onboarding-editor/quickstart-tutorial-task';
const $4a617be77ace987f$export$d04515c6314fec11 = 'onboarding-editor/publish-modal-prompt';
const $4a617be77ace987f$export$8425321c06a7c373 = 'onboarding-editor/publish-success-flag';
const $4a617be77ace987f$export$f3de65caafc09b21 = 'onboarding-editor/recent-draft-spotlight';
const $4a617be77ace987f$export$25e1b00b32cd992d = 'onboarding/query/labels';
const $4a617be77ace987f$export$8ef86f4d4da92fa5 = 'onboarding/grace-period-banner';
const $4a617be77ace987f$export$8125e64b190d01e2 = 'onboarding/storage-enforcement-banner';
const $4a617be77ace987f$export$343afc350dc963df = 'onboarding/storage-enforcement-banner/dismiss';
const $4a617be77ace987f$export$9491541521237449 = 'onboarding/storage-enforcement-flags';
const $4a617be77ace987f$export$616864953f0d339 = 'onboarding/storage-enforcement/block-create-modal';
const $4a617be77ace987f$export$61418bee30087820 = 'onboarding/home/templates-collection';
const $4a617be77ace987f$export$70cb2a8c47e6afd8 = 'onboarding/home/templates-collection/create-template';
const $4a617be77ace987f$export$e61bc67cff9e0f2 = 'onboarding/ibo/new-home/recent-page';
const $4a617be77ace987f$export$c1f744d5e0181dd = 'onboarding/ibo/new-home/spaces';
const $4a617be77ace987f$export$5ddea2545ba37329 = 'onboarding/ibo/new-home';
const $4a617be77ace987f$export$c03570fb82968b7e = 'onboarding/nth-user-setup-modal';
const $4a617be77ace987f$export$59679d849f29c62b = 'onboarding/onboarding-tracker';
const $4a617be77ace987f$export$7893ecd5dfd2c478 = 'onboarding/onboarding-tracker/organize-space/spotlight';
const $4a617be77ace987f$export$f63cf886d6298a0d = 'onboarding/onboarding-tracker/add-content/spotlight';
const $4a617be77ace987f$export$7b13a63caff7cb41 = 'onboarding/onboarding-tracker/invite-people/spotlight';
const $4a617be77ace987f$export$3971f3f0bdcc083 = 'onboarding/onboarding-surface-import/global-import/create-page';
const $4a617be77ace987f$export$7e62e90cd8969fd8 = 'onboarding/confluence-recap-modal';
const $4a617be77ace987f$export$5612c7c22aba3ae8 = 'onboarding/confluence-home-onboarding-takeover-v2';
const $4a617be77ace987f$export$3edd3fbbb3bde42a = 'onboarding/nth-user-confluence-home-onboarding-takeover';
const $4a617be77ace987f$export$e97003dd72490d60 = 'onboarding/confluence-home-onboarding-takeover-v2/home-nudge';
const $4a617be77ace987f$export$be5f66bc85ac48a2 = 'onboarding/confluence-personalized-templates-v2';
const $4a617be77ace987f$export$4ef813fe853a14e1 = 'onboarding/nth-user-home-onboarding-revamp';
const $4a617be77ace987f$export$241c40e7f0f7d7b2 = 'content-action-apps/forge';
const $4a617be77ace987f$export$404655cfa9ecfbc3 = 'byline-apps/forge';
const $4a617be77ace987f$export$224bdd20537c043c = 'context-menu-apps/forge';
const $4a617be77ace987f$export$fe9e3a7216162400 = 'settings-page-apps/forge';
const $4a617be77ace987f$export$16a139fd3cad706d = 'custom-content-apps/forge';
const $4a617be77ace987f$export$a333c0535291436a = 'space-page-apps/forge';
const $4a617be77ace987f$export$4e660f0eec1b7b63 = 'space-settings/integrations/forge';
const $4a617be77ace987f$export$42fe8757b12b9abb = 'space-settings-v2/integrations/forge';
const $4a617be77ace987f$export$e4e961f07f20b1e9 = 'space-settings-v2/landing-page';
const $4a617be77ace987f$export$30670c5b5576bc9d = 'global-page-apps/forge';
const $4a617be77ace987f$export$de2b763dff9c90e = 'full-page-apps/forge';
const $4a617be77ace987f$export$7fee035e8993093b = 'background-script-apps/forge';
const $4a617be77ace987f$export$d773e3323beb4d91 = 'site-permission/space-access';
const $4a617be77ace987f$export$1fdf87b44bf66203 = 'space-pages';
const $4a617be77ace987f$export$eab5c9963f80520c = 'space-pages/filter';
const $4a617be77ace987f$export$6af7d14b23c7ed20 = 'space-pages/paginate';
const $4a617be77ace987f$export$1ae7d5b32e27dd1b = 'space-views/initial';
const $4a617be77ace987f$export$92e7a42b4d134675 = 'space-views/change';
const $4a617be77ace987f$export$cd0c9383cd80d210 = 'space-views/paginate';
const $4a617be77ace987f$export$90dff6c3d9facebb = 'space-views/hover-page-card';
const $4a617be77ace987f$export$8a00f2824cff2c5e = 'site-permissions/space-access/remove';
const $4a617be77ace987f$export$30e6c2e5c854e3d7 = 'site-permissions/space-access/add';
const $4a617be77ace987f$export$b07723d1eb2313ad = 'site-permissions/space-access/guest/change';
const $4a617be77ace987f$export$94d2e4338cb54b2c = 'insights/page-byline';
const $4a617be77ace987f$export$27bffcf643f6c238 = 'insights/page-dialog';
const $4a617be77ace987f$export$460c09ff51f88f24 = 'insights/page-dialog-upsell';
const $4a617be77ace987f$export$371cd738ccd37b38 = 'insights/page-analytics';
const $4a617be77ace987f$export$3861bdd55a91a4a0 = 'insights/page-analytics/view-chart';
const $4a617be77ace987f$export$968182ed9835d21a = 'insights/page-analytics/total-views-card';
const $4a617be77ace987f$export$24ed3cf43f154734 = 'insights/page-analytics/unique-viewers-card';
const $4a617be77ace987f$export$a531b5e2ff0b9747 = 'insights/page-analytics/mentioned-users-card';
const $4a617be77ace987f$export$27ccd506e08e0e = 'insights/page-analytics/viewers-table';
const $4a617be77ace987f$export$ec84fc419c424bb5 = 'insights/page-analytics/mentioned-users-reminder';
const $4a617be77ace987f$export$8ddcb6f0d9ebf30e = 'insights/page-analytics/mentioned-users-table';
const $4a617be77ace987f$export$f8f3f70f34becef9 = 'insights/page-analytics/links-inbound-total-clicks-card';
const $4a617be77ace987f$export$3d388f0f7fc44c3f = 'insights/page-analytics/links-inbound-ctr-card';
const $4a617be77ace987f$export$310d1207c2b3ca7d = 'insights/page-analytics/links-inbound-table';
const $4a617be77ace987f$export$ab6abc47e6a1b436 = 'insights/page-analytics/links-outbound-total-clicks-card';
const $4a617be77ace987f$export$a1934b3cd762057c = 'insights/page-analytics/links-outbound-ctr-card';
const $4a617be77ace987f$export$11b4f841e984d2a8 = 'insights/page-analytics/links-outbound-table';
const $4a617be77ace987f$export$5478a6cbf2100291 = 'insights/space-analytics';
const $4a617be77ace987f$export$12f42654844570d0 = 'insights/space-analytics/overview-chart';
const $4a617be77ace987f$export$40a98279383e549e = 'insights/space-analytics/popular-content-card';
const $4a617be77ace987f$export$340eeaf9226a3e00 = 'insights/space-analytics/active-readers-card';
const $4a617be77ace987f$export$327f825878dc4802 = 'insights/space-analytics/active-contributors-card';
const $4a617be77ace987f$export$9595ac2edfb0edec = 'insights/space-analytics/content-activity-table';
const $4a617be77ace987f$export$bfbd1b5517d327f6 = 'insights/space-analytics/user-activity-table';
const $4a617be77ace987f$export$ae73006a481ab5bc = 'insights/space-analytics/async-export';
const $4a617be77ace987f$export$e27cd103e9670e33 = 'insights/space-analytics/permissions/load';
const $4a617be77ace987f$export$5a507008b468c991 = 'insights/space-analytics/permissions/update';
const $4a617be77ace987f$export$8ed4273d919d1070 = 'insights/site-analytics';
const $4a617be77ace987f$export$f2d660eb8a9ba56e = 'insights/site-analytics/overview-chart';
const $4a617be77ace987f$export$8e5ed6a75264c549 = 'insights/site-analytics/popular-spaces-card';
const $4a617be77ace987f$export$7cc392d1f03d59f9 = 'insights/site-analytics/active-readers-card';
const $4a617be77ace987f$export$e5b5e8161ac66e90 = 'insights/site-analytics/popular-searches-card';
const $4a617be77ace987f$export$221bc81bca00257 = 'insights/site-analytics/spaces-table';
const $4a617be77ace987f$export$31b3362136d95230 = 'insights/site-analytics/users-table';
const $4a617be77ace987f$export$86dcda8aa2b50b8a = 'insights/site-analytics/search-table';
const $4a617be77ace987f$export$91ffba1860245927 = 'insights/site-analytics/search-panel';
const $4a617be77ace987f$export$1b7a393d48199f1c = 'insights/site-analytics/search-panel/graph';
const $4a617be77ace987f$export$4020b74c723b4607 = 'insights/site-analytics/search-panel/content-list';
const $4a617be77ace987f$export$343c48c7798baab8 = 'insights/site-analytics/search-panel/spaces-list';
const $4a617be77ace987f$export$58ad08103bb62c4b = 'insights/site-analytics/permissions/load';
const $4a617be77ace987f$export$f73b370055c8cbef = 'insights/site-analytics/permissions/update';
const $4a617be77ace987f$export$5d12872cd9595692 = 'bulk-space-permissions';
const $4a617be77ace987f$export$ee395498ea9fc566 = 'global-perms';
const $4a617be77ace987f$export$bbc6348b8482e5b1 = 'expand-group';
const $4a617be77ace987f$export$f96f0a60f840676c = 'group-members-load-more';
const $4a617be77ace987f$export$7b06f43e66d37bd9 = 'view-space-guest-list';
const $4a617be77ace987f$export$b3639316349424 = 'team-calendar';
const $4a617be77ace987f$export$b731d5eab77f5ae2 = 'team-calendar-upsell';
const $4a617be77ace987f$export$6e2e950545a96fb5 = 'team-calendars/calendar/add';
const $4a617be77ace987f$export$e60dce5b561d6551 = 'team-calendars/calendar/add-existing';
const $4a617be77ace987f$export$25067b28cdd34cc6 = 'team-calendars/calendar/delete';
const $4a617be77ace987f$export$19d86a52695ae312 = 'team-calendars/calendar/remove';
const $4a617be77ace987f$export$120ce8feec0488aa = 'team-calendars/calendar/subscribe';
const $4a617be77ace987f$export$dc96bc0456e09d60 = 'team-calendars/calendar/update';
const $4a617be77ace987f$export$d23cc4800e46d1e6 = 'team-calendars/calendar/import';
const $4a617be77ace987f$export$13b2254026213b46 = 'team-calendars/event-type/add';
const $4a617be77ace987f$export$c348a46d97587ee4 = 'team-calendars/event-type/delete';
const $4a617be77ace987f$export$bfd3172de881908e = 'team-calendars/event-type/update';
const $4a617be77ace987f$export$e1a32de918001908 = 'team-calendars/event/add';
const $4a617be77ace987f$export$36abe825d06f7b68 = 'team-calendars/event/jira-calendar';
const $4a617be77ace987f$export$1be22ae521e809a9 = 'team-calendars/event/update';
const $4a617be77ace987f$export$eb40d48a494923c8 = 'team-calendars/event/delete';
const $4a617be77ace987f$export$66104f246f979de9 = 'team-calendars/restrictions/update';
const $4a617be77ace987f$export$a245b5e8e50aca4e = 'edit-space-logo/restore';
const $4a617be77ace987f$export$38c64d0e786460e8 = 'edit-space-logo/save';
const $4a617be77ace987f$export$53b6eab7c794efdf = 'edit-space-logo/details-load';
const $4a617be77ace987f$export$d4e50447c54e832a = 'cover-picture/unsplash-upload';
const $4a617be77ace987f$export$3b296e5e8d4fbd72 = 'cover-picture/media-upload';
const $4a617be77ace987f$export$75c73b1e1363abb2 = 'cover-picture/remove';
const $4a617be77ace987f$export$56b59e3252d65c77 = 'view-app-suggestions';
const $4a617be77ace987f$export$61ad3866e7413864 = 'conditional_publish_dialog';
const $4a617be77ace987f$export$5685c80727d12c34 = 'extension_point_byline';
const $4a617be77ace987f$export$4b9cf95d297cf82f = 'extension_point_space_buttons';
const $4a617be77ace987f$export$811ef7c3a5f94996 = 'extension_point_home_footer';
const $4a617be77ace987f$export$dfab08323861cbc1 = 'extension_point_home_header';
const $4a617be77ace987f$export$aa9a33eaf0b3cefa = 'extension_point_editor_savebar';
const $4a617be77ace987f$export$4933a09c775176cb = 'extension_point_page_metadata_banner';
const $4a617be77ace987f$export$645909341bfebc9b = 'extension_point_page_banner';
const $4a617be77ace987f$export$facf18b53398c3d7 = 'extension_point_space_settings_tabs';
const $4a617be77ace987f$export$23be08d2ca73ecf = 'core-invites';
const $4a617be77ace987f$export$b1dd9d960d4ea959 = 'custom-content-page-all';
const $4a617be77ace987f$export$38660dec2eb2a695 = 'custom-content-space-list-view';
const $4a617be77ace987f$export$7b1fe4d076a9542a = 'custom-content-page-list-view';
const $4a617be77ace987f$export$ad06e79f63068f5e = 'custom-content-view';
const $4a617be77ace987f$export$eef674482902ef6d = 'connections-panel-view';
const $4a617be77ace987f$export$c5bcbbcb1df627e5 = 'end-of-page-recommendations';
const $4a617be77ace987f$export$3b683344868f9f0a = 'notify-on-first-view';
const $4a617be77ace987f$export$4fdd9934209dba0e = 'presenter-mode/view';
const $4a617be77ace987f$export$40638d9b45e8ceca = 'presenter-mode/full-screen-api';
const $4a617be77ace987f$export$b1f7a84b45eb9afb = 'view-public-link-site-settings';
const $4a617be77ace987f$export$8294c237289049c4 = 'view-public-link-spaces-table';
const $4a617be77ace987f$export$ec6e09c5fd9fa221 = 'view-public-links-page-table';
const $4a617be77ace987f$export$5cc7e9470bfae723 = 'public-links-spaces-table-action';
const $4a617be77ace987f$export$c102a9d514fc95ac = 'public-link-site-toggle-change';
const $4a617be77ace987f$export$ff2fb656c8231637 = 'view-public-links-space-settings';
const $4a617be77ace987f$export$ba803d464f49a265 = 'public-links-space-toggle-change';
const $4a617be77ace987f$export$d95bcf023bd8993 = 'view-public-links-default-space-settings';
const $4a617be77ace987f$export$7362876707c57af9 = 'public-links-default-space-toggle-change';
const $4a617be77ace987f$export$c7ff49e7eaa45ff1 = 'view-public-link-shared-page';
const $4a617be77ace987f$export$24cbec84f278c600 = 'public-link-rendered';
const $4a617be77ace987f$export$5b89a66b04cea206 = 'public-link-toggle-change';
const $4a617be77ace987f$export$44b7602dc9689e08 = 'public-link-disable-from-restrictions';
const $4a617be77ace987f$export$eed7907041fecd69 = 'public-link-page-table-action';
const $4a617be77ace987f$export$49a01ffc1a18656b = 'external-share';
const $4a617be77ace987f$export$e25df1f458506fcd = 'copy-content-link';
const $4a617be77ace987f$export$7c34e8285a2b9238 = 'content-history';
const $4a617be77ace987f$export$b9b41dfe39f06772 = 'view-tasks';
const $4a617be77ace987f$export$6be3453279e7dd85 = 'set-task-complete';
const $4a617be77ace987f$export$80a3b142ba868b57 = 'change-page-owner';
const $4a617be77ace987f$export$19875313f499fad9 = 'content-ownership/dialog';
const $4a617be77ace987f$export$e94c6163c32592ce = 'admin-announcement-banner';
const $4a617be77ace987f$export$7653dfd9fd5557b = 'admin-announcement-banner-dismissed';
const $4a617be77ace987f$export$394294e59b36efb9 = 'admin-announcement-banner-settings';
const $4a617be77ace987f$export$8f017785cc4bb995 = 'admin-announcement-banner-publish';
const $4a617be77ace987f$export$a4d890726485d79a = 'admin-announcement-banner-turn-off';
const $4a617be77ace987f$export$47d510c88b13ea8d = 'admin-announcement-banner-table';
const $4a617be77ace987f$export$548adb1a2fe6e6b1 = 'space-manager';
const $4a617be77ace987f$export$35f739fc0b127205 = 'space-manager-quick-action-item';
const $4a617be77ace987f$export$bfe6ff6cddeed6e3 = 'importer-dashboard';
const $4a617be77ace987f$export$2decaadcf840e6b3 = 'company-hub-general-settings';
const $4a617be77ace987f$export$23b4a008c670d304 = 'company-hub-general-settings-your-hub';
const $4a617be77ace987f$export$c6198e9d6ab9e417 = 'company-hub-general-settings-your-hub-actions';
const $4a617be77ace987f$export$e1b506612f6e9657 = 'company-hub-general-settings-recent-activity';
const $4a617be77ace987f$export$dfdc3f1142f40689 = 'company-hub-general-settings-hub-views';
const $4a617be77ace987f$export$e9845af7b7fd8501 = 'company-hub-general-settings-most-clicks';
const $4a617be77ace987f$export$237a7d3a8e219dbb = 'admin-center';
const $4a617be77ace987f$export$b7b3a9d4d05ffd12 = 'admin-center-confluence-admins';
const $4a617be77ace987f$export$367f60a3ad6918c1 = 'admin-center-search-count';
const $4a617be77ace987f$export$9a8113803e6447cf = 'admin-center-search-ctr';
const $4a617be77ace987f$export$8f37d7eb1e6f681d = 'admin-center-top-searches';
const $4a617be77ace987f$export$2ad5d40786f81da0 = 'admin-center-top-unsuccessful-searches';
const $4a617be77ace987f$export$e68566fb281dbb33 = 'admin-center-external-access';
const $4a617be77ace987f$export$a7f1ee469fd8596c = 'admin-center-beta-features';
const $4a617be77ace987f$export$8a3b06f53918d80e = 'admin-center-total-spaces';
const $4a617be77ace987f$export$d4f2672a4a997be2 = 'admin-center-total-content';
const $4a617be77ace987f$export$61440d1f5d765856 = 'admin-center-grouped-summary-section';
const $4a617be77ace987f$export$a122d82c3b13ba99 = 'admin-center-inactive-pages';
const $4a617be77ace987f$export$bf035e1987052c42 = 'admin-center-top-inactive-pages';
const $4a617be77ace987f$export$1613edca53571ea3 = 'admin-center-deactivated-owner-pages';
const $4a617be77ace987f$export$4ba2b40dc30760f9 = 'admin-center-top-deactivated-owner-pages';
const $4a617be77ace987f$export$5d6b6234c4e9f70d = 'admin-center-content-created';
const $4a617be77ace987f$export$39552d32ae5efc36 = 'admin-center-content-updated';
const $4a617be77ace987f$export$a4934c826482e207 = 'admin-center-content-views';
const $4a617be77ace987f$export$4c0549ea0cf0f43d = 'admin-center-top-content-views';
const $4a617be77ace987f$export$6b8c8a94a6fb0b10 = 'admin-center-grouped-summary-section-v2-update';
const $4a617be77ace987f$export$a4855248cbcdc638 = 'admin-center-grouped-summary-section-v2';
const $4a617be77ace987f$export$f1c6b44ad858e24f = 'admin-center-search-count-summary';
const $4a617be77ace987f$export$aaba8c517b5b0014 = 'admin-center-search-ctr-summary';
const $4a617be77ace987f$export$3463471aa64d2a20 = 'admin-center-total-spaces-summary';
const $4a617be77ace987f$export$aed49d47c6d277d2 = 'admin-center-total-content-summary';
const $4a617be77ace987f$export$c89944dc251c7694 = 'admin-center-inactive-pages-num-summary';
const $4a617be77ace987f$export$45d06e7b1bc06ed4 = 'admin-center-inactive-pages-percent-summary';
const $4a617be77ace987f$export$50744fb70a2982a2 = 'admin-center-deactivated-owner-pages-num-summary';
const $4a617be77ace987f$export$35f523c785c60e15 = 'admin-center-deactivated-owner-pages-percent-summary';
const $4a617be77ace987f$export$d4f40a3c80d7fa00 = 'admin-center-content-created-summary';
const $4a617be77ace987f$export$3e98f2df16d1f652 = 'admin-center-content-updated-summary';
const $4a617be77ace987f$export$512d403dd28c8f13 = 'admin-center-content-views-summary';
const $4a617be77ace987f$export$b5db801ede6fe9e5 = 'admin-center-public-link-views-summary';
const $4a617be77ace987f$export$2df6bcfd56d7c9e8 = 'admin-center-public-links-summary';
const $4a617be77ace987f$export$6c98543cf0a07a9f = 'admin-center-suggestions';
const $4a617be77ace987f$export$9f5be3c30e870f46 = 'admin-center-suggestions-unassigned-guest';
const $4a617be77ace987f$export$56c7132579558fc8 = 'admin-center-suggestions-inactive-pages';
const $4a617be77ace987f$export$4bc17e6067981b1f = 'admin-center-suggestions-deactivated-owner-pages';
const $4a617be77ace987f$export$2f62829f51afa45a = 'admin-center-suggestions-space-manager';
const $4a617be77ace987f$export$19020e617b152304 = 'admin-center-suggestions-user-access';
const $4a617be77ace987f$export$12a435102ccb624a = 'admin-center-suggestions-quick-action-item';
const $4a617be77ace987f$export$dec2cee4628ab9c4 = 'admin-center-suggestions-metric-cta';
const $4a617be77ace987f$export$88a8c07833ef47b1 = 'space-admin-center';
const $4a617be77ace987f$export$fb0bb005ed2de56c = 'space-admin-center-grouped-summary-section';
const $4a617be77ace987f$export$73c5a862f5073e46 = 'space-admin-center-external-access';
const $4a617be77ace987f$export$4d72041a86e9e003 = 'space-admin-center-space-admins';
const $4a617be77ace987f$export$724928cbf61f8819 = 'space-admin-center-content-views';
const $4a617be77ace987f$export$eee5f90734589227 = 'space-admin-center-top-content-views';
const $4a617be77ace987f$export$a5e95165e3a702d1 = 'space-admin-center-content-created';
const $4a617be77ace987f$export$32dde1d12c499528 = 'space-admin-center-content-updated';
const $4a617be77ace987f$export$147226654b32f956 = 'space-admin-center-total-content';
const $4a617be77ace987f$export$648d00fafa66ae14 = 'space-admin-center-inactive-pages';
const $4a617be77ace987f$export$a3fdce9bb003f0b8 = 'space-admin-center-top-inactive-pages';
const $4a617be77ace987f$export$71daddda71b57298 = 'space-admin-center-deactivated-owner-pages';
const $4a617be77ace987f$export$62d9e5dacf2e073d = 'space-admin-center-top-deactivated-owner-pages';
const $4a617be77ace987f$export$8c3b600f7a5dce0f = 'dwell-time/start';
const $4a617be77ace987f$export$b0fe8424f6f27f51 = 'trial-components/lozenge-view';
const $4a617be77ace987f$export$40c0cee2cad141c5 = 'trial-components/flag-view';
const $4a617be77ace987f$export$d6bad6d87d8c028f = 'trial-components/premium-insights-action-menu-item-view';
const $4a617be77ace987f$export$d0e7688ec900110c = 'team-presence/avatar-group-view';
const $4a617be77ace987f$export$655feba7d95d5b26 = 'team-presence/click-to-find';
const $4a617be77ace987f$export$a3748c7e642ec857 = 'flywheel-feature-discovery';
const $4a617be77ace987f$export$f8372d329c2aeea0 = 'quick-summary';
const $4a617be77ace987f$export$31e4e6e2658a6cae = 'quick-summary-whiteboards';
const $4a617be77ace987f$export$4a493e4dc06e57e7 = 'quick-summary-to-page';
const $4a617be77ace987f$export$5565b0bba4d72eee = 'comments-summary';
const $4a617be77ace987f$export$8d9dfd2f17501337 = 'ai-content-catchup';
const $4a617be77ace987f$export$eb38477d5de37f36 = 'ai-presentation-generation-view';
const $4a617be77ace987f$export$ed3e815374d54f04 = 'ai-presentation-generation-create';
const $4a617be77ace987f$export$bb8fdee2f545676e = 'ai-snippet';
const $4a617be77ace987f$export$c114a6d7848b93cb = 'ai-bulk-issue-create';
const $4a617be77ace987f$export$a48ee5f2c131dea3 = 'ai-audio';
const $4a617be77ace987f$export$f9a8f9ac1a851fe7 = 'ai-audio-briefing';
const $4a617be77ace987f$export$6086ea87dfcad89d = 'ai-audio-narration';
const $4a617be77ace987f$export$daafa0ab79e187e5 = 'ai-title-generation';
const $4a617be77ace987f$export$8091bb21bb2521cb = 'ai-header-image-generation';
const $4a617be77ace987f$export$530e334566c01c65 = 'plan-comparison-modal';
const $4a617be77ace987f$export$af3f8586c2e30e0 = 'pendo-installation';
const $4a617be77ace987f$export$7f32d11b06ee25ff = 'reading-aids';
const $4a617be77ace987f$export$38e6a52d8f0a641f = 'ai-definitions-autohighlight';
const $4a617be77ace987f$export$9bd965a890617f5b = 'view-guest-request-to-upgrade';
const $4a617be77ace987f$export$85b1366ed05e7209 = 'submit-guest-request-to-upgrade';
const $4a617be77ace987f$export$7ca653e6d1fa2509 = 'view-guest-request-to-upgrade-side-nav';
const $4a617be77ace987f$export$30addda68c1793d0 = 'submit-guest-request-to-upgrade-side-nav';
const $4a617be77ace987f$export$aace851408b6de3e = 'submit-guest-mentions-upgrade-flow';
const $4a617be77ace987f$export$611140537004e76c = 'view-guest-spaces-menu-request-to-upgrade';
const $4a617be77ace987f$export$e73147035caab2f2 = 'submit-guest-spaces-menu-request-to-upgrade';
const $4a617be77ace987f$export$11311af26ac8cb8b = 'restore-space';
const $4a617be77ace987f$export$dec29f1de3a4a5ce = 'hard-delete-space';
const $4a617be77ace987f$export$e69556d68987dda1 = 'view-space-permissions';
const $4a617be77ace987f$export$a5bcda9ae1f6839a = 'edit-space-permissions';
const $4a617be77ace987f$export$22c9153bc8c871f3 = 'view-app-custom-content-permissions';
const $4a617be77ace987f$export$32f7f39f260e234c = 'edit-app-custom-content-permissions';
const $4a617be77ace987f$export$c39bf2cb4e8cc70c = 'view-jsm-banner';
const $4a617be77ace987f$export$4e373788dac39943 = 'disable-jsm-permissions';
const $4a617be77ace987f$export$f7308c84ae7be9c8 = 'view-default-space-permissions';
const $4a617be77ace987f$export$85cd19170159a085 = 'edit-default-space-permissions';
const $4a617be77ace987f$export$3cfa8e4552e9e6ce = 'view-all-spaces-tab';
const $4a617be77ace987f$export$c9f8ebbba8f73eeb = 'company-home-builder-load';
const $4a617be77ace987f$export$d4d3fc5b22a2a5d2 = 'company-home-builder-edit';
const $4a617be77ace987f$export$cc438f9a49eb57aa = 'company-home-builder-edit/upload';
const $4a617be77ace987f$export$90e15cc4582adffa = 'company-hub-creation';
const $4a617be77ace987f$export$9458ecd4beb6dc6b = 'company-hub-change-hub-name';
const $4a617be77ace987f$export$7f2689ec25c432a4 = 'front-cover-load'; // TODO: rename this to COMPANY_HUB_LOAD_EXPERIENCE
const $4a617be77ace987f$export$c8ff6311a26d2c8c = 'company-hub-unpublish-hub';
const $4a617be77ace987f$export$f5a5045f5872d850 = 'company-hub-analytics';
const $4a617be77ace987f$export$2c2b8afe13693d2b = 'company-hub-analytics-box-row';
const $4a617be77ace987f$export$db8c2f7bf58fe015 = 'company-hub-analytics-chart';
const $4a617be77ace987f$export$b0852f88603c392f = 'company-hub-analytics-table';
const $4a617be77ace987f$export$c5e974e322d233b1 = 'company-hub-card-ai-description';
const $4a617be77ace987f$export$c6d05c48b9430e3c = 'company-hub-editor';
const $4a617be77ace987f$export$35975591aeab4dd6 = 'company-hub-editor/load';
const $4a617be77ace987f$export$7a3dfdccebea9c7b = 'company-hub-editor/close';
const $4a617be77ace987f$export$eef6122c9774ba1c = 'front-cover-publish'; // TODO: rename this to COMPANY_HUB_PUBLISH_EXPERIENCE
const $4a617be77ace987f$export$b414a79d615eda80 = 'end-of-trial-modal';
const $4a617be77ace987f$export$393f60effc43223a = 'end-of-trial-modal/number-of-users';
const $4a617be77ace987f$export$85f2b0ac7d403e39 = 'end-of-trial-modal/guest-access';
const $4a617be77ace987f$export$d28aabd131a0c82d = 'end-of-trial-modal/page-insights';
const $4a617be77ace987f$export$a3809cd1b0c7c1f9 = 'end-of-trial-modal/page-restrictions';
const $4a617be77ace987f$export$82fbc9c9caa0525b = 'end-of-trial-modal/osb-link';
const $4a617be77ace987f$export$651b4e780cbf5647 = 'cards-image-upload';
const $4a617be77ace987f$export$3e70adb2ef2d5f7a = 'admin-team-calendars-load';
const $4a617be77ace987f$export$18051474a34eda87 = 'admin-team-calendars-update';
const $4a617be77ace987f$export$7e4c7c98306e835d = 'standard-differentiators-onboarding';
const $4a617be77ace987f$export$1230cc550a8fe90f = 'standard-differentiators-help';
const $4a617be77ace987f$export$dc2f45d36e47ca3a = 'admin-general-configuration-load';
const $4a617be77ace987f$export$b27bac0c0dea2a55 = 'admin-general-configuration-update';
const $4a617be77ace987f$export$a3c4dc4a199ee1b8 = 'admin-general-configuration-update/favicon-upload';
const $4a617be77ace987f$export$d32cd699d9dbf985 = 'notifications-site-settings-load';
const $4a617be77ace987f$export$6fd7ab2f1e137193 = 'notifications-site-settings-update';
const $4a617be77ace987f$export$7875e1f75aa15306 = 'admin-configure-code-macro-load';
const $4a617be77ace987f$export$164e825247db8d43 = 'admin-configure-code-macro-update';
const $4a617be77ace987f$export$c390f9e07c545581 = 'admin-default-space-logo-config-load';
const $4a617be77ace987f$export$4090d6a71e5b3ead = 'admin-default-space-logo-config-media-service-load';
const $4a617be77ace987f$export$a1986920605a1163 = 'admin-default-space-logo-config-update';
const $4a617be77ace987f$export$313ad6157a5a0ea9 = 'admin-header-and-footer-load';
const $4a617be77ace987f$export$dd6c028654f91f02 = 'admin-header-and-footer-update';
const $4a617be77ace987f$export$bb009baa1a9cbcf0 = 'space-settings-admin-page-layout-load';
const $4a617be77ace987f$export$6d0fbdff5b6fa174 = 'space-settings-admin-page-layout-update';
const $4a617be77ace987f$export$8abd8604ca7982c7 = 'admin-security-configuration-load';
const $4a617be77ace987f$export$21855cac8c6f3d91 = 'admin-security-configuration-update';
const $4a617be77ace987f$export$faa6a1cbc50fd4a5 = 'admin-templates-and-blueprints-load';
const $4a617be77ace987f$export$9cfd44509d36312b = 'admin-templates-and-blueprints-load/page-templates';
const $4a617be77ace987f$export$fb29220c46f6993 = 'admin-templates-and-blueprints-load/page-blueprints';
const $4a617be77ace987f$export$90402aae1ab35229 = 'admin-templates-and-blueprints-load/system-templates';
const $4a617be77ace987f$export$8e008c4796774e26 = 'space-settings-admin-templates-and-blueprints-load';
const $4a617be77ace987f$export$bc61a3e94ba2560e = 'admin-import-spaces-configuration-load';
const $4a617be77ace987f$export$936492407dd3e3ab = 'admin-import-spaces-import';
const $4a617be77ace987f$export$99f32e90f59041e7 = 'admin-trashed-spaces-load';
const $4a617be77ace987f$export$1057adadb9206825 = 'admin-trashed-spaces-restore';
const $4a617be77ace987f$export$9f610d573468ea4 = 'admin-trashed-spaces-hard-delete';
const $4a617be77ace987f$export$86fdc512ee3200db = 'admin-color-scheme-load';
const $4a617be77ace987f$export$db764d23341437ca = 'admin-color-scheme-update';
const $4a617be77ace987f$export$4447822883006e0 = 'admin-application-navigator-load';
const $4a617be77ace987f$export$93194ca916026abe = 'admin-application-navigator-update';
const $4a617be77ace987f$export$c226034eea0cb4de = 'admin-application-navigator-add';
const $4a617be77ace987f$export$22f1f1a21c7d0c50 = 'admin-themes-load';
const $4a617be77ace987f$export$12093307e4f8fd56 = 'admin-themes-update';
const $4a617be77ace987f$export$a48b049eb2fcbe71 = 'space-settings-admin-themes-load';
const $4a617be77ace987f$export$5b92dfbf1efa2144 = 'space-settings-admin-themes-update';
const $4a617be77ace987f$export$565897f0a51f5efd = 'admin-jira-macro-repair-load';
const $4a617be77ace987f$export$2292c61864873ec0 = 'admin-jira-macro-repair-update';
const $4a617be77ace987f$export$d8f5df97692e60be = 'admin-pdf-export-load-experience';
const $4a617be77ace987f$export$e2eb28f9e03e0850 = 'admin-pdf-export-update-experience';
const $4a617be77ace987f$export$ab0128b7a160aaed = 'space-settings-admin-pdf-export-load-experience';
const $4a617be77ace987f$export$e65a54ac514355c1 = 'space-settings-admin-pdf-export-update-experience';
const $4a617be77ace987f$export$9e6e2adcf47359af = 'space-settings-admin-pdf-export-load-experience-ncs';
const $4a617be77ace987f$export$9fb76bc73314ca1e = 'space-settings-csv-export-experience';
const $4a617be77ace987f$export$fde5d45e43ea2ca4 = 'export-page-tree-load';
const $4a617be77ace987f$export$b9b428ecdf423548 = 'export-page-export-completed-export-and-download';
const $4a617be77ace987f$export$5fa322173b52c417 = 'pdf-export-page';
const $4a617be77ace987f$export$bda7d7fc953c118f = 'space-settings-legacy-content-report-experience';
const $4a617be77ace987f$export$c08c7422d3e7a141 = 'admin-macro-usage-load';
const $4a617be77ace987f$export$d6369a194e24ad7f = 'watch-dialog-watch';
const $4a617be77ace987f$export$8012a45d3107312e = 'watch-dialog-watch-children';
const $4a617be77ace987f$export$84a690fd513af1de = 'manage-watchers-dialog-unfiltered';
const $4a617be77ace987f$export$7c7b27adbfa0b2a1 = 'auto-upgrade-awareness-modal';
const $4a617be77ace987f$export$6d5416d96215c2a6 = 'space-settings-admin-look-and-feel-experience';
const $4a617be77ace987f$export$ce75b3763db649b5 = 'user-access-update';
const $4a617be77ace987f$export$ae036afd16ed2b49 = 'user-access-space-permissions-report';
const $4a617be77ace987f$export$2361c2310cf691ea = 'convert-page-to-folder';
const $4a617be77ace987f$export$e85b045b69985ed1 = 'share-and-restrict-button-load';
const $4a617be77ace987f$export$4717394ee1c94acc = 'share-and-restrict-dialog-load';
const $4a617be77ace987f$export$15b0dc8b7eaf2460 = 'share-and-restrict-dialog-save-action';
const $4a617be77ace987f$export$d7fbaabd51b7e8aa = 'share-and-restrict-dialog-share-action';
const $4a617be77ace987f$export$62f393504fed6ed = 'flyout-messaging';
const $4a617be77ace987f$export$5409fe2736a41b4e = 'confluence-eot-premium-recommend-standard-buy';
const $4a617be77ace987f$export$b3185617ebec44c9 = 'view-space-role-assignments';
const $4a617be77ace987f$export$2bf4fa4e191abad2 = 'edit-space-role-assignments';
const $4a617be77ace987f$export$a2e8aa26b8f23b29 = 'view-default-space-role-assignments';
const $4a617be77ace987f$export$f615f6649fe944d3 = 'edit-default-space-role-assignments';
const $4a617be77ace987f$export$c355f58335217bcc = 'view-site-roles';
const $4a617be77ace987f$export$ea342babb9acb6bc = 'edit-site-roles';
const $4a617be77ace987f$export$f6c4ac51d51b4d11 = 'space-details-load';
const $4a617be77ace987f$export$e6949233f3fd16fa = 'space-details-update';
const $4a617be77ace987f$export$ac4798c67f4aca63 = 'space-details-space-label-search';
const $4a617be77ace987f$export$13c8bebb873a5fd2 = 'object-header';
const $4a617be77ace987f$export$717078a23de7ce41 = 'sidebar-details-panel-load';
const $4a617be77ace987f$export$8bb2fdea912e6360 = 'sidebar-comments-panel-load';
const $4a617be77ace987f$export$785ec834db7448db = 'sidebar-comments-panel-load-open';
const $4a617be77ace987f$export$9455f903a440f62b = 'sidebar-comments-panel-load-unread';
const $4a617be77ace987f$export$9eb18c236ac889d2 = 'sidebar-comments-panel-load-resolved';
const $4a617be77ace987f$export$e6d0321727a888ba = 'sidebar-comments-panel-load-deleted-content';
const $4a617be77ace987f$export$89c31c18d20e326d = 'comments-data-background-load';
const $4a617be77ace987f$export$1f5ef81ae9b1b308 = 'import-content';
const $4a617be77ace987f$export$8e0f9138cc943183 = 'import-miro-users';
const $4a617be77ace987f$export$c81d8b61dfed18d = 'mpucup-free-to-standard-fg-modal';
const $4a617be77ace987f$export$bf23e3ec80d510d = 'content-overflow-menu';
const $4a617be77ace987f$export$5167cfad2b30339a = 'mobile-macro-renderer-query';
const $4a617be77ace987f$export$db5f7458e232d5f3 = 'mobile-macro-renderer';
const $4a617be77ace987f$export$d4235a0083f21618 = 'permissions-audit-generation';
const $4a617be77ace987f$export$a992b43898fc066a = 'permissions-audit-generation-view';
module.exports["FOLLOW_DEEP_LINK_EXPERIENCE"] = $4a617be77ace987f$export$61f782d99db03c49;
module.exports["VIEW_ALL_MACRO_EXPERIENCE"] = $4a617be77ace987f$export$54747aca26cee3f8;
module.exports["VIEW_JIRA_MACRO_EXPERIENCE"] = $4a617be77ace987f$export$f8afba90a5a815ad;
module.exports["MIGRATE_PAGE_EXPERIENCE"] = $4a617be77ace987f$export$87daa9a1b1dd910d;
module.exports["MIGRATE_PAGE_PUBLISH_EXPERIENCE"] = $4a617be77ace987f$export$6c0a7d453b9ba427;
module.exports["MIGRATE_TEMPLATE_EXPERIENCE"] = $4a617be77ace987f$export$b39a77dbc03575b1;
module.exports["ADD_PAGE_COMMENT_EXPERIENCE"] = $4a617be77ace987f$export$f94e85276e6d639f;
module.exports["ADD_PAGE_COMMENT_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$31bd7de6ca230764;
module.exports["ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE"] = $4a617be77ace987f$export$4cb6cf73aff93e7d;
module.exports["EDIT_PAGE_COMMENT_EXPERIENCE"] = $4a617be77ace987f$export$2a99a63e28df64fd;
module.exports["EDIT_PAGE_COMMENT_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$515913089a77cb7c;
module.exports["EDIT_PAGE_COMMENT_PUBLISH_EXPERIENCE"] = $4a617be77ace987f$export$c0906b23fa1e3b63;
module.exports["REPLY_TO_PAGE_COMMENT_EXPERIENCE"] = $4a617be77ace987f$export$e9a5501ca0d5d256;
module.exports["REPLY_TO_PAGE_COMMENT_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$3fdffa656412b99a;
module.exports["REPLY_TO_PAGE_COMMENT_PUBLISH_EXPERIENCE"] = $4a617be77ace987f$export$bfebfbab40727cd6;
module.exports["DELETE_PAGE_COMMENT_EXPERIENCE"] = $4a617be77ace987f$export$91d50c2b267d0461;
module.exports["RESOLVE_PAGE_COMMENT_EXPERIENCE"] = $4a617be77ace987f$export$24ef8c79de5598b9;
module.exports["MARK_COMMENTS_AS_READ_EXPERIENCE"] = $4a617be77ace987f$export$8c6422f793f7efae;
module.exports["MARK_ALL_COMMENTS_AS_READ_EXPERIENCE"] = $4a617be77ace987f$export$98dbdebd041da61c;
module.exports["CREATE_INLINE_COMMENT_EXPERIENCE"] = $4a617be77ace987f$export$6f58645a9a5f7936;
module.exports["CREATE_INLINE_COMMENT_INIT_EXPERIENCE"] = $4a617be77ace987f$export$8180a49fb6c681b1;
module.exports["CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE"] = $4a617be77ace987f$export$ed5e210bce3a41a9;
module.exports["CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE"] = $4a617be77ace987f$export$db23cb60632b0aa0;
module.exports["SELECT_INLINE_COMMENT_EXPERIENCE"] = $4a617be77ace987f$export$f8e0e16825f0d222;
module.exports["ADD_INLINE_COMMENT_EXPERIENCE"] = $4a617be77ace987f$export$2003fd9c8f509d96;
module.exports["ADD_INLINE_COMMENT_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$a69ecd33d83d56ce;
module.exports["ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE"] = $4a617be77ace987f$export$eb89dbd7422d8194;
module.exports["EDIT_INLINE_COMMENT_EXPERIENCE"] = $4a617be77ace987f$export$29c433981d13c955;
module.exports["EDIT_INLINE_COMMENT_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$a557d8a611f835b;
module.exports["EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE"] = $4a617be77ace987f$export$e9dafdd46fb3d4ed;
module.exports["VIEW_INLINE_COMMENT_EXPERIENCE"] = $4a617be77ace987f$export$20fbac00cba3c8a;
module.exports["VIEW_INLINE_COMMENT_TOP_LEVEL_EXPERIENCE"] = $4a617be77ace987f$export$533f2a7cfe4f757e;
module.exports["VIEW_INLINE_COMMENT_REPLY_EXPERIENCE"] = $4a617be77ace987f$export$fb1f28583d577755;
module.exports["REPLY_TO_INLINE_COMMENT_EXPERIENCE"] = $4a617be77ace987f$export$9d157677f817543f;
module.exports["REPLY_TO_INLINE_COMMENT_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$b4f2ad99abb89883;
module.exports["REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE"] = $4a617be77ace987f$export$32059abd767a1104;
module.exports["DELETE_INLINE_COMMENT_EXPERIENCE"] = $4a617be77ace987f$export$bcfccb61f33e9641;
module.exports["RESOLVE_INLINE_COMMENT_EXPERIENCE"] = $4a617be77ace987f$export$819fbef15068ac1d;
module.exports["UNRESOLVE_INLINE_COMMENT_EXPERIENCE"] = $4a617be77ace987f$export$996a096215f40255;
module.exports["REATTACH_INLINE_COMMENT_EXPERIENCE"] = $4a617be77ace987f$export$a32711b0e13e94b7;
module.exports["VIEW_REACTIONS_EXPERIENCE"] = $4a617be77ace987f$export$d6f52083721d3342;
module.exports["VIEW_REACTION_USER_LIST_EXPERIENCE"] = $4a617be77ace987f$export$e6f0efe9d461092e;
module.exports["ADD_REACTION_EXPERIENCE"] = $4a617be77ace987f$export$ba45b443cf775f1b;
module.exports["DELETE_REACTION_EXPERIENCE"] = $4a617be77ace987f$export$63f7987e2f1f8f3;
module.exports["ADD_QUICK_REACTION_EXPERIENCE"] = $4a617be77ace987f$export$aa1b3aa6132c5165;
module.exports["COPY_SPACE_PERMISSIONS_EXPERIENCE"] = $4a617be77ace987f$export$7321222ee6dc4c8a;
module.exports["CREATE_PAGE_EXPERIENCE"] = $4a617be77ace987f$export$227ea80a7d6d8ef2;
module.exports["CREATE_PAGE_LOAD_DIALOG_EXPERIENCE"] = $4a617be77ace987f$export$1773354263fb7a1f;
module.exports["CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE"] = $4a617be77ace987f$export$5f80ef7b2915bb38;
module.exports["CREATE_WHITEBOARD_EXPERIENCE"] = $4a617be77ace987f$export$f27db95814bbdf0;
module.exports["CREATE_DATABASE_EXPERIENCE"] = $4a617be77ace987f$export$13566a78bbba7568;
module.exports["CREATE_EMBED_EXPERIENCE"] = $4a617be77ace987f$export$c6222c9fbf47e43b;
module.exports["CREATE_FOLDER_EXPERIENCE"] = $4a617be77ace987f$export$63a2c018dc189e0;
module.exports["EDIT_PAGE_SMART_CREATE_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$9c40f417713b17ea;
module.exports["EDIT_PAGE_EXPERIENCE"] = $4a617be77ace987f$export$dd70d6707192298e;
module.exports["EDIT_LEGACY_PAGE_EXPERIENCE"] = $4a617be77ace987f$export$cd96dc6a09f60949;
module.exports["EDIT_PAGE_EMBED_EXPERIENCE"] = $4a617be77ace987f$export$b6f302e969b56ed5;
module.exports["EDIT_PAGE_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$54650b8dd9597591;
module.exports["EDIT_LEGACY_PAGE_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$9cfef550e5af515d;
module.exports["EDIT_PAGE_PUBLISH_EXPERIENCE"] = $4a617be77ace987f$export$4aed0cf42acf9c68;
module.exports["EDIT_LEGACY_PAGE_PUBLISH_EXPERIENCE"] = $4a617be77ace987f$export$770ea955fed26e20;
module.exports["EDIT_PAGE_PUBLISH_AS_BLOG_EXPERIENCE"] = $4a617be77ace987f$export$4abcdf78bb75330c;
module.exports["EDIT_PAGE_CLOSE_EXPERIENCE"] = $4a617be77ace987f$export$92edebd76eb1ad1;
module.exports["EDIT_LEGACY_PAGE_CLOSE_EXPERIENCE"] = $4a617be77ace987f$export$1339ae8dc80b092c;
module.exports["EDIT_PAGE_REVERT_DRAFT_EXPERIENCE"] = $4a617be77ace987f$export$42ce143b9452f768;
module.exports["LIVE_PAGE_VIEW_EXPERIENCE"] = $4a617be77ace987f$export$d3dcb341de2e384f;
module.exports["LIVE_PAGE_EDIT_EXPERIENCE"] = $4a617be77ace987f$export$f8e950d04ce466ff;
module.exports["LIVE_PAGE_SESSION_EXPERIENCE"] = $4a617be77ace987f$export$3814d28dd3802a02;
module.exports["LIVE_PAGE_PUBLISH_EXPERIENCE"] = $4a617be77ace987f$export$40fb2b7b657bf7d;
module.exports["CREATE_AND_EDIT_PAGE_EXPERIENCE"] = $4a617be77ace987f$export$9e0dcc9389703292;
module.exports["TEMPLATE_EDIT_PAGE_EXPERIENCE"] = $4a617be77ace987f$export$b9892a850189b3e9;
module.exports["TEMPLATE_EDIT_PAGE_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$3604f7decc6e0567;
module.exports["TEMPLATE_EDIT_PAGE_CLOSE_EXPERIENCE"] = $4a617be77ace987f$export$1a3cf6b911b3771;
module.exports["TEMPLATE_EDIT_PAGE_PUBLISH_EXPERIENCE"] = $4a617be77ace987f$export$a7f90c693668eabe;
module.exports["TEMPLATE_EDIT_PAGE_PUBLISH_TEMPLATE_BODY_EXPERIENCE"] = $4a617be77ace987f$export$3c5dcebba4317c7e;
module.exports["TEMPLATE_EDIT_PAGE_PUBLISH_TEMPLATE_PROPERTIES_EXPERIENCE"] = $4a617be77ace987f$export$3a8f568ddb8f3189;
module.exports["IN_EDITOR_TEMPLATES_LOAD_PANEL_EXPERIENCE"] = $4a617be77ace987f$export$583391c24e8a1735;
module.exports["IN_EDITOR_TEMPLATES_LOAD_PANEL_TEMPLATE_LIST_EXPERIENCE"] = $4a617be77ace987f$export$6afe1d2e05c85172;
module.exports["IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE"] = $4a617be77ace987f$export$6085a8760b035f6;
module.exports["IN_EDITOR_TEMPLATES_LOAD_PANEL_SPACE_SELECTOR_EXPERIENCE"] = $4a617be77ace987f$export$cbd9dfa0a050a0e0;
module.exports["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_EXPERIENCE"] = $4a617be77ace987f$export$8fcf8395eb106389;
module.exports["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR_EXPERIENCE"] = $4a617be77ace987f$export$eac277758b783558;
module.exports["VIEW_IN_PRODUCT_HELP_EXPERIENCE"] = $4a617be77ace987f$export$89e30156af35c723;
module.exports["SEARCH_IN_PRODUCT_HELP_EXPERIENCE"] = $4a617be77ace987f$export$1072a5750cf51c7e;
module.exports["VIEW_ARTICLE_IN_PRODUCT_HELP_EXPERIENCE"] = $4a617be77ace987f$export$49e4c787a6cc62e;
module.exports["TEMPLATE_GALLERY_EXPERIENCE"] = $4a617be77ace987f$export$54615853abc6859;
module.exports["TEMPLATE_GALLERY_SPACE_SELECTOR_EXPERIENCE"] = $4a617be77ace987f$export$82c983e2a60f2e28;
module.exports["TEMPLATE_GALLERY_CATEGORIES_EXPERIENCE"] = $4a617be77ace987f$export$61439b391c5a3aca;
module.exports["TEMPLATE_GALLERY_CARDS_EXPERIENCE"] = $4a617be77ace987f$export$81cd8bf6923e1bf1;
module.exports["TEMPLATE_GALLERY_TEMPLATE_DETAIL_EXPERIENCE"] = $4a617be77ace987f$export$b6af3a64b182b9d0;
module.exports["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$588acf29fbd8637d;
module.exports["TEMPLATE_GALLERY_TEMPLATE_DETAIL_HEADER_EXPERIENCE"] = $4a617be77ace987f$export$a1cf4f28febc3bee;
module.exports["TEMPLATE_PREVIEW_EXPERIENCE"] = $4a617be77ace987f$export$b802716fd0c5b93f;
module.exports["REFRESH_EDITOR_CONTENT_EXPERIENCE"] = $4a617be77ace987f$export$e0195c05e32ed777;
module.exports["CREATE_CONTENT_FROM_TEMPLATE_EXPERIENCE"] = $4a617be77ace987f$export$9194ae178043ade6;
module.exports["BLUEPRINT_WIZARD_LOAD_DIALOG_EXPERIENCE"] = $4a617be77ace987f$export$1545639c80579c53;
module.exports["CONNECT_ADDON_EXPERIENCE"] = $4a617be77ace987f$export$fc0c176abc30d17b;
module.exports["QUICK_RELOAD_EXPERIENCE"] = $4a617be77ace987f$export$97b170c4be77228;
module.exports["RESTRICTED_PAGE_EXPERIENCE"] = $4a617be77ace987f$export$dbbd27df623b094f;
module.exports["RESTRICTED_SPACE_FOR_GUEST_EXPERIENCE"] = $4a617be77ace987f$export$8f404e4bd2a13aa;
module.exports["RESTRICTED_SPACE_EXPERIENCE"] = $4a617be77ace987f$export$727b779ceeca0a78;
module.exports["RESTRICTIONS_DIALOG_EXPERIENCE"] = $4a617be77ace987f$export$b9ee7465c962e842;
module.exports["RESTRICTIONS_DIALOG_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$2e96e7e6b8da0317;
module.exports["RESTRICTIONS_DIALOG_APPLY_EXPERIENCE"] = $4a617be77ace987f$export$6b54d78a736a983b;
module.exports["PUBLISH_MODAL_LOAD_RESTRICTIONS_EXPERIENCE"] = $4a617be77ace987f$export$a66250c876dd8838;
module.exports["IMPERSONATION_FLAG_EXPERIENCE"] = $4a617be77ace987f$export$e64caae0c75dd921;
module.exports["INSPECT_PERMISSIONS_EXPERIENCE"] = $4a617be77ace987f$export$7ebe8ae2b3f231cb;
module.exports["USER_ACCESS_EXPERIENCE"] = $4a617be77ace987f$export$b659623b19114e87;
module.exports["UPSELL_EDITION_PREMIUM_EXPERIENCE"] = $4a617be77ace987f$export$9d715fddec195756;
module.exports["UPSELL_EDITION_UPFLOW_EXPERIENCE"] = $4a617be77ace987f$export$a7ffbea51ff646ee;
module.exports["ARCHIVE_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$bd5028ea224c4de1;
module.exports["RESTORE_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$e63a17e805ed8387;
module.exports["SPACE_ARCHIVED_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$d74c17e82f5dbc27;
module.exports["SPACE_ARCHIVED_PAGES_PAGINATE_EXPERIENCE"] = $4a617be77ace987f$export$b7a40ae431fd676d;
module.exports["NOTES_ARCHIVE_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$b84de3b67d7aa4be;
module.exports["BULK_NOTES_ARCHIVE_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$9efd42121cbefbff;
module.exports["ARCHIVED_PAGE_BANNER_EXPERIENCE"] = $4a617be77ace987f$export$c30b739e25dc756b;
module.exports["AUTOMATION_DISCOVERY_ADD_LABEL_EXPERIENCE"] = $4a617be77ace987f$export$fc9036c892e05ff9;
module.exports["AUTOMATION_DISCOVERY_PUBLISH_MEETING_NOTES_EXPERIENCE"] = $4a617be77ace987f$export$abe2705723fc11ac;
module.exports["AUTOMATION_DISCOVERY_ARCHIVE_PAGE_EXPERIENCE"] = $4a617be77ace987f$export$90d9afd417e81733;
module.exports["AUTOMATION_DISCOVERY_HOVER_OVER_PAGE_TITLE_EXPERIENCE"] = $4a617be77ace987f$export$bcf33c3d2ec343df;
module.exports["AUTOMATION_DISCOVERY_JIRA_LINK"] = $4a617be77ace987f$export$8b43be9232ec143f;
module.exports["AUTOMATION_DISCOVERY_PAGE_PUBLIC_LINK"] = $4a617be77ace987f$export$65a0bbd38d8f5b63;
module.exports["AUTOMATION_MANUAL_TRIGGERS"] = $4a617be77ace987f$export$c7dca20d997e95ed;
module.exports["AUTOMATION_DISCOVERY_WHITEBOARDS"] = $4a617be77ace987f$export$2504afae65d57ffb;
module.exports["AUTOMATION_SMART_BUTTON_RUN_RULE"] = $4a617be77ace987f$export$78bf51c34f43d049;
module.exports["AUTOMATION_SMART_BUTTON_CREATE_RULE"] = $4a617be77ace987f$export$d0afbe071e52a5cf;
module.exports["AUTOMATION_SMART_BUTTON_EDIT_RULE"] = $4a617be77ace987f$export$b30eb768fa4c3967;
module.exports["AUTOMATION_SMART_BUTTON_PREVIEW_RULE"] = $4a617be77ace987f$export$2cc8139334567c4f;
module.exports["AUTOMATION_SIDE_NAV_BAR_EXPERIENCE"] = $4a617be77ace987f$export$cab2a1e3c7ddbb06;
module.exports["AUTOMATION_UPSELL_EXPERIENCE"] = $4a617be77ace987f$export$a03bf7627f412dc4;
module.exports["DELETE_PAGE_EXPERIENCE"] = $4a617be77ace987f$export$a26e99521ea3a9f4;
module.exports["BULK_DELETE_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$57cc53c6e3b9be1b;
module.exports["BULK_CHANGE_OWNER_EXPERIENCE"] = $4a617be77ace987f$export$91d3a54b5d7e1b7f;
module.exports["BULK_CHANGE_STATUS_EXPERIENCE"] = $4a617be77ace987f$export$ba8b23dd795f5f9e;
module.exports["BULK_CONVERT_PAGE_TO_LIVE_DOC_EXPERIENCE"] = $4a617be77ace987f$export$7bea875d555696ca;
module.exports["EDIT_SIDEBAR_EXPERIENCE"] = $4a617be77ace987f$export$a837ee39f68fa2dd;
module.exports["EDIT_SIDEBAR_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$e69ba0c4a7667861;
module.exports["MANAGE_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$c6fd99844ee488c5;
module.exports["CONTENT_MANAGER_EXPERIENCE"] = $4a617be77ace987f$export$d4b4a08489e4dfe2;
module.exports["MOVE_PAGE_DIALOG_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$c03f98139dd9719e;
module.exports["MOVE_PAGE_EXPERIENCE"] = $4a617be77ace987f$export$1167cf561a6df618;
module.exports["MOVE_BLOG_EXPERIENCE"] = $4a617be77ace987f$export$95c6dda6cbbf364;
module.exports["NOT_FOUND_EXPERIENCE"] = $4a617be77ace987f$export$fbbc408e16c59382;
module.exports["VIEW_CONTENT_EXPERIENCE"] = $4a617be77ace987f$export$cf73dfff88c1f700;
module.exports["VIEW_PAGE_EXPERIENCE"] = $4a617be77ace987f$export$d4712ac27cc4e72f;
module.exports["VIEW_PAGE_SESSION_EXPERIENCE"] = $4a617be77ace987f$export$5e30e9d7ea54dcd2;
module.exports["SPACE_OVERVIEW_EXPERIENCE"] = $4a617be77ace987f$export$2a57468d23984a9d;
module.exports["BREADCRUMBS_EXPERIENCE"] = $4a617be77ace987f$export$54504a2cc31519bf;
module.exports["BREADCRUMBS_DROPDOWN_EXPERIENCE"] = $4a617be77ace987f$export$68af05e1cf40b8e6;
module.exports["VIEW_PAGE_TITLE_EXPERIENCE"] = $4a617be77ace987f$export$863ebd92a50403cf;
module.exports["VIEW_PAGE_LABELS_EXPERIENCE"] = $4a617be77ace987f$export$bdd2d0f331a38827;
module.exports["VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE"] = $4a617be77ace987f$export$def55fa9fa47c777;
module.exports["VIEW_PAGE_BYLINE_EXPERIENCE"] = $4a617be77ace987f$export$49fde5724a27b431;
module.exports["VIEW_PAGE_BYLINE_FORGE_EXPERIENCE"] = $4a617be77ace987f$export$7a119c18309263c;
module.exports["VIEW_PAGE_COMMENTS_EXPERIENCE"] = $4a617be77ace987f$export$45c9f537ef090ccd;
module.exports["VIEW_PAGE_DIRECT_COMMENT_DATA_FLOW_EXPERIENCE"] = $4a617be77ace987f$export$d7d1b2bdd9bd08f4;
module.exports["VIEW_PAGE_EDIT_BUTTON_EXPERIENCE"] = $4a617be77ace987f$export$dc03e514628af5e9;
module.exports["VIEW_PAGE_CONTENT_TOOLS_EXPERIENCE"] = $4a617be77ace987f$export$38478feb41239856;
module.exports["VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE"] = $4a617be77ace987f$export$ef641459105e6b1a;
module.exports["VIEW_PAGE_CONTEXT_MENU_EXPERIENCE"] = $4a617be77ace987f$export$255077470163d493;
module.exports["VIEW_PAGE_CONTEXT_MENU_FORGE_EXPERIENCE"] = $4a617be77ace987f$export$43081e88ffac9568;
module.exports["VIEW_PAGE_CONTENT_HEADER_EXPERIENCE"] = $4a617be77ace987f$export$14a39beec323232a;
module.exports["VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE"] = $4a617be77ace987f$export$5870dabed6d7b7fc;
module.exports["VIEW_PAGE_SHARE_BUTTON_EXPERIENCE"] = $4a617be77ace987f$export$857306718a36d667;
module.exports["VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE"] = $4a617be77ace987f$export$b7907767002e32d;
module.exports["VIEW_PAGE_COMMENT_BUTTON_EXPERIENCE"] = $4a617be77ace987f$export$aa15347df133b367;
module.exports["VIEW_PAGE_DISCOVER_INLINE_COMMENTS_FEATURE_EXPERIENCE"] = $4a617be77ace987f$export$18cb1bed3afb8173;
module.exports["VIEW_PAGE_PUBLISH_AS_BLOG_EXPERIENCE"] = $4a617be77ace987f$export$b500820ed8b3aee5;
module.exports["WHITEBOARD_EXPERIENCE"] = $4a617be77ace987f$export$a83700d85c7e0745;
module.exports["WHITEBOARD_CONTENT_EXPERIENCE"] = $4a617be77ace987f$export$bdaf5db6d84a5581;
module.exports["WHITEBOARD_VERSION_HISTORY_SIDE_PANEL_EXPERIENCE"] = $4a617be77ace987f$export$4252e8d96c415d57;
module.exports["WHITEBOARD_VERSION_HISTORY_RESTORE_EXPERIENCE"] = $4a617be77ace987f$export$b8cdecdc06b6252;
module.exports["WHITEBOARD_VERSION_HISTORY_LOAD_RESTORE_MODAL"] = $4a617be77ace987f$export$90f5a89f66458e77;
module.exports["DATABASE_EXPERIENCE"] = $4a617be77ace987f$export$f02aef641190ead6;
module.exports["DATABASE_CONTENT_EXPERIENCE"] = $4a617be77ace987f$export$7140ccdb0c7b2b37;
module.exports["DATABASE_VERSION_HISTORY_SIDE_PANEL_EXPERIENCE"] = $4a617be77ace987f$export$857587c3b96ae00c;
module.exports["DATABASE_VERSION_HISTORY_RESTORE_EXPERIENCE"] = $4a617be77ace987f$export$bdbfe4dafa70ffab;
module.exports["DATABASE_VERSION_HISTORY_LOAD_RESTORE_MODAL"] = $4a617be77ace987f$export$7cc7b880d5b3f324;
module.exports["DATABASE_LOAD_HISTORICAL_VERSION"] = $4a617be77ace987f$export$ba3b240cb9a3ffd0;
module.exports["EMBED_EXPERIENCE"] = $4a617be77ace987f$export$c85a8dac7f241add;
module.exports["EMBED_CONTENT_EXPERIENCE"] = $4a617be77ace987f$export$927658f514adba70;
module.exports["EDIT_EMBED_EXPERIENCE"] = $4a617be77ace987f$export$c1092431c58e1571;
module.exports["FOLDER_EXPERIENCE"] = $4a617be77ace987f$export$3485e62ad9c27d0b;
module.exports["FOLDER_CONTENT_EXPERIENCE"] = $4a617be77ace987f$export$6237c6dbe5a63f05;
module.exports["CONTENT_TYPES_HEADER_EXPERIENCE"] = $4a617be77ace987f$export$7fd0425089f6d999;
module.exports["CONTENT_TYPES_HEADER_WATCH_EXPERIENCE"] = $4a617be77ace987f$export$47f14e5e827cfff3;
module.exports["CONTENT_CREATION_PAYWALL_EXPERIENCE"] = $4a617be77ace987f$export$748b7f600814978a;
module.exports["RECORD_LOOM_ENTRY_POINT"] = $4a617be77ace987f$export$5e1aeeb6f31be57a;
module.exports["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = $4a617be77ace987f$export$c427a8b1052a6522;
module.exports["LOOM_CROSS_SELL_EXPERIENCE"] = $4a617be77ace987f$export$6ca90e5df7047c10;
module.exports["EDIT_PAGE_LABELS_EXPERIENCE"] = $4a617be77ace987f$export$96f8e8997d2c8722;
module.exports["LABELS_ADD_LABEL_EXPERIENCE"] = $4a617be77ace987f$export$e9e0897b7cf2ab3f;
module.exports["LABELS_CREATE_LABEL_EXPERIENCE"] = $4a617be77ace987f$export$5a4fc6855f9c48e;
module.exports["LABELS_DELETE_LABEL_EXPERIENCE"] = $4a617be77ace987f$export$3f19e9a9a0d72413;
module.exports["LABELS_SEARCH_LABEL_EXPERIENCE"] = $4a617be77ace987f$export$39d403abc2174e5e;
module.exports["LABELS_RECOMMENDED_EXPERIENCE"] = $4a617be77ace987f$export$4d573c9dfbc9337c;
module.exports["TEMPLATE_EDIT_PAGE_LABELS_EXPERIENCE"] = $4a617be77ace987f$export$8af5d568de2d4e43;
module.exports["TEMPLATE_EDIT_PAGE_LABELS_ADD_LABEL_EXPERIENCE"] = $4a617be77ace987f$export$c5ef6dea1c804893;
module.exports["TEMPLATE_EDIT_PAGE_LABELS_CREATE_LABEL_EXPERIENCE"] = $4a617be77ace987f$export$fa82b911a68fea4d;
module.exports["TEMPLATE_EDIT_PAGE_LABELS_DELETE_LABEL_EXPERIENCE"] = $4a617be77ace987f$export$20b2f79b83628af0;
module.exports["TEMPLATE_EDIT_PAGE_LABELS_SEARCH_LABEL_EXPERIENCE"] = $4a617be77ace987f$export$479dc90f08ae49d;
module.exports["HOME_EXPERIENCE"] = $4a617be77ace987f$export$66f0a82e06e92ea;
module.exports["HOME_SPACES_EXPERIENCE"] = $4a617be77ace987f$export$8856e11bfa69959d;
module.exports["HOME_RIGHT_PANEL_EXPERIENCE"] = $4a617be77ace987f$export$d931b261468db3be;
module.exports["HOME_RIGHT_PANEL_WELCOME_MESSAGE_EXPERIENCE"] = $4a617be77ace987f$export$45cf379c9ef28a2d;
module.exports["HOME_RIGHT_PANEL_CALENDARS_EXPERIENCE"] = $4a617be77ace987f$export$ceb391a6374fc2;
module.exports["HOME_RIGHT_PANEL_APPS_EXPERIENCE"] = $4a617be77ace987f$export$799c1b543715aab4;
module.exports["HOME_RIGHT_PANEL_FORGE_EXPERIENCE"] = $4a617be77ace987f$export$519eb6f457873738;
module.exports["FEED_EXPERIENCE"] = $4a617be77ace987f$export$680e462c4f71cea1;
module.exports["HOME_OVERVIEW_EXPERIENCE"] = $4a617be77ace987f$export$d660d67b42309542;
module.exports["HOME_OVERVIEW_RECENT_EXPERIENCE"] = $4a617be77ace987f$export$f987075f870b167d;
module.exports["HOME_RECENT_EXPERIENCE"] = $4a617be77ace987f$export$94f2ecf008a81b99;
module.exports["HOME_STARRED_EXPERIENCE"] = $4a617be77ace987f$export$45d7f7ed7a82bcd;
module.exports["HOME_WATCHING_EXPERIENCE"] = $4a617be77ace987f$export$ecf5fd41d4da9bf8;
module.exports["HOME_DRAFTS_EXPERIENCE"] = $4a617be77ace987f$export$9b242f2ddcd908fc;
module.exports["ADVANCED_SEARCH_EXPERIENCE"] = $4a617be77ace987f$export$5393f7f46c9e5055;
module.exports["QUICK_SEARCH_PRE_QUERY"] = $4a617be77ace987f$export$ec545137ad6ac054;
module.exports["RECENT_DROPDOWN_VISITED_EXPERIENCE"] = $4a617be77ace987f$export$e64dfa2771353f5c;
module.exports["RECENT_DROPDOWN_CREATED_BY_ME_EXPERIENCE"] = $4a617be77ace987f$export$53f4f21972586e42;
module.exports["RECENT_DROPDOWN_WORKED_ON_EXPERIENCE"] = $4a617be77ace987f$export$985013c384c228e1;
module.exports["RECENT_DROPDOWN_DRAFTS_EXPERIENCE"] = $4a617be77ace987f$export$605220fac97de;
module.exports["RECENT_DROPDOWN_STARRED_EXPERIENCE"] = $4a617be77ace987f$export$7c6d9e11a2120c1b;
module.exports["PAGE_TREE_EXPERIENCE"] = $4a617be77ace987f$export$59a9c2c7ae337de7;
module.exports["PAGE_TREE_DND_EXPERIENCE"] = $4a617be77ace987f$export$bbc326cd1f124322;
module.exports["PAGE_TREE_QUICK_ACTIONS_EXPERIENCE"] = $4a617be77ace987f$export$f9d04e98575a0216;
module.exports["PAGE_TREE_RENAME_EXPERIENCE"] = $4a617be77ace987f$export$cd3eec90d152a8ea;
module.exports["BLOG_TREE_EXPERIENCE"] = $4a617be77ace987f$export$9d1f80f618a6627b;
module.exports["BLOG_TREE_PAGINATION_EXPERIENCE"] = $4a617be77ace987f$export$899513ff8720fa55;
module.exports["NAV2_ADMIN_FORGE_EXPERIENCE"] = $4a617be77ace987f$export$357a2b9b5fb0f4e4;
module.exports["APP_NAV_GLOBAL_EXPERIENCE"] = $4a617be77ace987f$export$9b5915bb3a4fbcae;
module.exports["APP_NAV_CONTAINER_EXPERIENCE"] = $4a617be77ace987f$export$e3e183dd97af67fd;
module.exports["APP_NAV_ADMIN_EXPERIENCE"] = $4a617be77ace987f$export$14b67f3e8f5e6f95;
module.exports["APP_NAV_SPACES_DROPDOWN_EXPERIENCE"] = $4a617be77ace987f$export$f089f204ab93864e;
module.exports["APP_NAV_PAGES_DROPDOWN_EXPERIENCE"] = $4a617be77ace987f$export$5c3671291c82150b;
module.exports["APP_NAV_APPS_DROPDOWN_EXPERIENCE"] = $4a617be77ace987f$export$63d03b6879925116;
module.exports["APP_NAV_PROFILE_DROPDOWN_EXPERIENCE"] = $4a617be77ace987f$export$986139018de1521a;
module.exports["SPACE_DIRECTORY_EXPERIENCE"] = $4a617be77ace987f$export$6cebb7e0b005cd28;
module.exports["SPACE_DIRECTORY_YOUR_SPACES_EXPERIENCE"] = $4a617be77ace987f$export$aeda23f4b92ccc3b;
module.exports["SPACE_DIRECTORY_FILTER_EXPERIENCE"] = $4a617be77ace987f$export$4a890f75d0a61967;
module.exports["SPACE_DIRECTORY_PAGINATE_EXPERIENCE"] = $4a617be77ace987f$export$39e9ebfcfd8e8bad;
module.exports["CREATE_SPACE_SUBMIT_EXPERIENCE"] = $4a617be77ace987f$export$de6098630f95035a;
module.exports["CREATE_SPACE_VALIDATE_EXPERIENCE"] = $4a617be77ace987f$export$9b47bc79e174bc93;
module.exports["ONBOARDING_START_EXPERIENCE"] = $4a617be77ace987f$export$1d45fd96fcd751f5;
module.exports["ONBOARDING_FOLLOW_SPACES_EXPERIENCE"] = $4a617be77ace987f$export$4ead33eb5b37dee5;
module.exports["ONBOARDING_AUTO_FOLLOW_SPACES_EXPERIENCE"] = $4a617be77ace987f$export$59c55b717acdcf15;
module.exports["ONBOARDING_NUDGE_EXPERIENCE"] = $4a617be77ace987f$export$749c4d9c23381805;
module.exports["ONBOARDING_ACCOUNT_SETUP_MODAL_EXPERIENCE"] = $4a617be77ace987f$export$1aaba3dd5fd71b43;
module.exports["ONBOARDING_EDITOR_DRAFT_BANNER_EXPERIENCE"] = $4a617be77ace987f$export$e40755126e0d0b54;
module.exports["ONBOARDING_LAND_IN_EDITOR_BANNER_EXPERIENCE"] = $4a617be77ace987f$export$32b7ff7de164c7ad;
module.exports["ONBOARDING_EDITOR_PUBLISH_MODAL_PROMPT_EXPERIENCE"] = $4a617be77ace987f$export$d04515c6314fec11;
module.exports["ONBOARDING_EDITOR_PUBLISH_SUCCESS_FLAG_EXPERIENCE"] = $4a617be77ace987f$export$8425321c06a7c373;
module.exports["ONBOARDING_EDITOR_RECENT_DRAFT_SPOTLIGHT_EXPERIENCE"] = $4a617be77ace987f$export$f3de65caafc09b21;
module.exports["ONBOARDING_GRACE_PERIOD_BANNER_EXPERIENCE"] = $4a617be77ace987f$export$8ef86f4d4da92fa5;
module.exports["ONBOARDING_STORAGE_ENFORCEMENT_BANNER_EXPERIENCE"] = $4a617be77ace987f$export$8125e64b190d01e2;
module.exports["ONBOARDING_STORAGE_ENFORCEMENT_BANNER_DISMISS_EXPERIENCE"] = $4a617be77ace987f$export$343afc350dc963df;
module.exports["ONBOARDING_STORAGE_ENFORCEMENT_FLAGS_EXPERIENCE"] = $4a617be77ace987f$export$9491541521237449;
module.exports["ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL"] = $4a617be77ace987f$export$616864953f0d339;
module.exports["ONBOARDING_TEMPLATE_COLLECTIONS_EXPERIENCE"] = $4a617be77ace987f$export$61418bee30087820;
module.exports["ONBOARDING_TEMPLATE_COLLECTIONS_CREATE_TEMPLATE_EXPERIENCE"] = $4a617be77ace987f$export$70cb2a8c47e6afd8;
module.exports["ONBOARDING_IBO_NEW_HOME_RECENT_PAGE_EXPERIENCE"] = $4a617be77ace987f$export$e61bc67cff9e0f2;
module.exports["ONBOARDING_IBO_NEW_HOME_SPACES_EXPERIENCE"] = $4a617be77ace987f$export$c1f744d5e0181dd;
module.exports["ONBOARDING_NTH_USER_SETUP_MODAL_EXPERIENCE"] = $4a617be77ace987f$export$c03570fb82968b7e;
module.exports["ONBOARDING_CONFLUENCE_RECAP_MODAL_EXPERIENCE"] = $4a617be77ace987f$export$7e62e90cd8969fd8;
module.exports["ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER"] = $4a617be77ace987f$export$3edd3fbbb3bde42a;
module.exports["ONBOARDING_PERSONALIZED_TEMPLATES_V2"] = $4a617be77ace987f$export$be5f66bc85ac48a2;
module.exports["ONBOARDING_NTH_USER_HOME_ONBOARDING_REVAMP"] = $4a617be77ace987f$export$4ef813fe853a14e1;
module.exports["CONTENT_ACTION_APPS_FORGE_EXPERIENCE"] = $4a617be77ace987f$export$241c40e7f0f7d7b2;
module.exports["BYLINE_APPS_FORGE_EXPERIENCE"] = $4a617be77ace987f$export$404655cfa9ecfbc3;
module.exports["CONTEXT_MENU_FORGE_EXPERIENCE"] = $4a617be77ace987f$export$224bdd20537c043c;
module.exports["SETTINGS_PAGE_FORGE_EXPERIENCE"] = $4a617be77ace987f$export$fe9e3a7216162400;
module.exports["CUSTOM_CONTENT_FORGE_EXPERIENCE"] = $4a617be77ace987f$export$16a139fd3cad706d;
module.exports["SPACE_PAGE_APPS_FORGE_EXPERIENCE"] = $4a617be77ace987f$export$a333c0535291436a;
module.exports["SPACE_SETTINGS_INTEGRATIONS_FORGE_EXPERIENCE"] = $4a617be77ace987f$export$4e660f0eec1b7b63;
module.exports["SPACE_SETTINGS_V2_INTEGRATIONS_FORGE_EXPERIENCE"] = $4a617be77ace987f$export$42fe8757b12b9abb;
module.exports["SPACE_SETTINGS_LANDING_PAGE_EXPERIENCE"] = $4a617be77ace987f$export$e4e961f07f20b1e9;
module.exports["GLOBAL_PAGE_APPS_FORGE_EXPERIENCE"] = $4a617be77ace987f$export$30670c5b5576bc9d;
module.exports["FULL_PAGE_APPS_FORGE_EXPERIENCE"] = $4a617be77ace987f$export$de2b763dff9c90e;
module.exports["BACKGROUND_SCRIPT_APPS_FORGE_EXPERIENCE"] = $4a617be77ace987f$export$7fee035e8993093b;
module.exports["SPACE_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$1fdf87b44bf66203;
module.exports["SPACE_PAGES_FILTER_EXPERIENCE"] = $4a617be77ace987f$export$eab5c9963f80520c;
module.exports["SPACE_PAGES_PAGINATE_EXPERIENCE"] = $4a617be77ace987f$export$6af7d14b23c7ed20;
module.exports["SPACE_VIEWS_INITIAL_EXPERIENCE"] = $4a617be77ace987f$export$1ae7d5b32e27dd1b;
module.exports["SPACE_VIEWS_CHANGE_EXPERIENCE"] = $4a617be77ace987f$export$92e7a42b4d134675;
module.exports["SPACE_VIEWS_PAGINATE_EXPERIENCE"] = $4a617be77ace987f$export$cd0c9383cd80d210;
module.exports["SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE"] = $4a617be77ace987f$export$90dff6c3d9facebb;
module.exports["SITE_PERMISSION_REMOVE_SPACE_ACCESS_EXPERIENCE"] = $4a617be77ace987f$export$8a00f2824cff2c5e;
module.exports["SITE_PERMISSION_ADD_SPACE_ACCESS_EXPERIENCE"] = $4a617be77ace987f$export$30e6c2e5c854e3d7;
module.exports["SITE_PERMISSION_CHANGE_GUEST_SPACE_ACCESS_EXPERIENCE"] = $4a617be77ace987f$export$b07723d1eb2313ad;
module.exports["ANALYTICS_BYLINE_EXPERIENCE"] = $4a617be77ace987f$export$94d2e4338cb54b2c;
module.exports["ANALYTICS_DIALOG_EXPERIENCE"] = $4a617be77ace987f$export$27bffcf643f6c238;
module.exports["ANALYTICS_DIALOG_UPSELL_EXPERIENCE"] = $4a617be77ace987f$export$460c09ff51f88f24;
module.exports["PAGE_ANALYTICS_EXPERIENCE"] = $4a617be77ace987f$export$371cd738ccd37b38;
module.exports["PAGE_ANALYTICS_VIEW_CHART_EXPERIENCE"] = $4a617be77ace987f$export$3861bdd55a91a4a0;
module.exports["PAGE_ANALYTICS_TOTAL_VIEWS_CARD_EXPERIENCE"] = $4a617be77ace987f$export$968182ed9835d21a;
module.exports["PAGE_ANALYTICS_UNIQUE_VIEWERS_CARD_EXPERIENCE"] = $4a617be77ace987f$export$24ed3cf43f154734;
module.exports["PAGE_ANALYTICS_MENTIONED_USERS_CARD_EXPERIENCE"] = $4a617be77ace987f$export$a531b5e2ff0b9747;
module.exports["PAGE_ANALYTICS_VIEWERS_TABLE_EXPERIENCE"] = $4a617be77ace987f$export$27ccd506e08e0e;
module.exports["PAGE_ANALYTICS_MENTIONED_USERS_REMINDER_EXPERIENCE"] = $4a617be77ace987f$export$ec84fc419c424bb5;
module.exports["PAGE_ANALYTICS_MENTIONED_USERS_TABLE_EXPERIENCE"] = $4a617be77ace987f$export$8ddcb6f0d9ebf30e;
module.exports["PAGE_ANALYTICS_LINKS_INBOUND_TOTAL_CLICKS_CARD_EXPERIENCE"] = $4a617be77ace987f$export$f8f3f70f34becef9;
module.exports["PAGE_ANALYTICS_LINKS_INBOUND_CTR_CARD_EXPERIENCE"] = $4a617be77ace987f$export$3d388f0f7fc44c3f;
module.exports["PAGE_ANALYTICS_LINKS_INBOUND_TABLE_EXPERIENCE"] = $4a617be77ace987f$export$310d1207c2b3ca7d;
module.exports["PAGE_ANALYTICS_LINKS_OUTBOUND_TOTAL_CLICKS_CARD_EXPERIENCE"] = $4a617be77ace987f$export$ab6abc47e6a1b436;
module.exports["PAGE_ANALYTICS_LINKS_OUTBOUND_CTR_CARD_EXPERIENCE"] = $4a617be77ace987f$export$a1934b3cd762057c;
module.exports["PAGE_ANALYTICS_LINKS_OUTBOUND_TABLE_EXPERIENCE"] = $4a617be77ace987f$export$11b4f841e984d2a8;
module.exports["SPACE_ANALYTICS_EXPERIENCE"] = $4a617be77ace987f$export$5478a6cbf2100291;
module.exports["SPACE_ANALYTICS_OVERVIEW_CHART_EXPERIENCE"] = $4a617be77ace987f$export$12f42654844570d0;
module.exports["SPACE_ANALYTICS_POPULAR_CONTENT_CARD_EXPERIENCE"] = $4a617be77ace987f$export$40a98279383e549e;
module.exports["SPACE_ANALYTICS_ACTIVE_READERS_CARD_EXPERIENCE"] = $4a617be77ace987f$export$340eeaf9226a3e00;
module.exports["SPACE_ANALYTICS_ACTIVE_CONTRIBUTORS_CARD_EXPERIENCE"] = $4a617be77ace987f$export$327f825878dc4802;
module.exports["SPACE_ANALYTICS_CONTENT_ACTIVITY_TABLE_EXPERIENCE"] = $4a617be77ace987f$export$9595ac2edfb0edec;
module.exports["SPACE_ANALYTICS_USER_ACTIVITY_TABLE_EXPERIENCE"] = $4a617be77ace987f$export$bfbd1b5517d327f6;
module.exports["SPACE_ANALYTICS_ASYNC_EXPORT_EXPERIENCE"] = $4a617be77ace987f$export$ae73006a481ab5bc;
module.exports["SPACE_ANALYTICS_PERMISSIONS_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$e27cd103e9670e33;
module.exports["SPACE_ANALYTICS_PERMISSIONS_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$5a507008b468c991;
module.exports["SITE_ANALYTICS_EXPERIENCE"] = $4a617be77ace987f$export$8ed4273d919d1070;
module.exports["SITE_ANALYTICS_OVERVIEW_CHART_EXPERIENCE"] = $4a617be77ace987f$export$f2d660eb8a9ba56e;
module.exports["SITE_ANALYTICS_POPULAR_SPACES_CARD_EXPERIENCE"] = $4a617be77ace987f$export$8e5ed6a75264c549;
module.exports["SITE_ANALYTICS_ACTIVE_READERS_CARD_EXPERIENCE"] = $4a617be77ace987f$export$7cc392d1f03d59f9;
module.exports["SITE_ANALYTICS_POPULAR_SEARCHES_CARD_EXPERIENCE"] = $4a617be77ace987f$export$e5b5e8161ac66e90;
module.exports["SITE_ANALYTICS_SPACES_TABLE_EXPERIENCE"] = $4a617be77ace987f$export$221bc81bca00257;
module.exports["SITE_ANALYTICS_USERS_TABLE_EXPERIENCE"] = $4a617be77ace987f$export$31b3362136d95230;
module.exports["SITE_ANALYTICS_SEARCH_TABLE_EXPERIENCE"] = $4a617be77ace987f$export$86dcda8aa2b50b8a;
module.exports["SITE_ANALYTICS_SEARCH_PANEL_EXPERIENCE"] = $4a617be77ace987f$export$91ffba1860245927;
module.exports["SITE_ANALYTICS_SEARCH_PANEL_GRAPH_EXPERIENCE"] = $4a617be77ace987f$export$1b7a393d48199f1c;
module.exports["SITE_ANALYTICS_SEARCH_PANEL_CONTENT_LIST_EXPERIENCE"] = $4a617be77ace987f$export$4020b74c723b4607;
module.exports["SITE_ANALYTICS_SEARCH_PANEL_SPACES_LIST_EXPERIENCE"] = $4a617be77ace987f$export$343c48c7798baab8;
module.exports["SITE_ANALYTICS_PERMISSIONS_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$58ad08103bb62c4b;
module.exports["SITE_ANALYTICS_PERMISSIONS_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$f73b370055c8cbef;
module.exports["BULK_SPACE_PERMISSIONS_EXPERIENCE"] = $4a617be77ace987f$export$5d12872cd9595692;
module.exports["GLOBAL_PERMS_EXPERIENCE"] = $4a617be77ace987f$export$ee395498ea9fc566;
module.exports["EXPAND_GROUP_EXPERIENCE"] = $4a617be77ace987f$export$bbc6348b8482e5b1;
module.exports["GROUP_MEMBERS_LOAD_MORE_EXPERIENCE"] = $4a617be77ace987f$export$f96f0a60f840676c;
module.exports["TEAM_CALENDAR_EXPERIENCE"] = $4a617be77ace987f$export$b3639316349424;
module.exports["TEAM_CALENDAR_UPSELL_EXPERIENCE"] = $4a617be77ace987f$export$b731d5eab77f5ae2;
module.exports["TEAM_CALENDARS_ADD_NEW_CALENDAR_EXPERIENCE"] = $4a617be77ace987f$export$6e2e950545a96fb5;
module.exports["TEAM_CALENDARS_ADD_EXISTING_CALENDAR_EXPERIENCE"] = $4a617be77ace987f$export$e60dce5b561d6551;
module.exports["TEAM_CALENDARS_DELETE_CALENDAR_EXPERIENCE"] = $4a617be77ace987f$export$25067b28cdd34cc6;
module.exports["TEAM_CALENDARS_REMOVE_CALENDAR_EXPERIENCE"] = $4a617be77ace987f$export$19d86a52695ae312;
module.exports["TEAM_CALENDARS_SUBSCRIBE_CALENDAR_EXPERIENCE"] = $4a617be77ace987f$export$120ce8feec0488aa;
module.exports["TEAM_CALENDARS_UPDATE_CALENDAR_EXPERIENCE"] = $4a617be77ace987f$export$dc96bc0456e09d60;
module.exports["TEAM_CALENDARS_IMPORT_CALENDAR_EXPERIENCE"] = $4a617be77ace987f$export$d23cc4800e46d1e6;
module.exports["TEAM_CALENDARS_ADD_EVENT_TYPE_EXPERIENCE"] = $4a617be77ace987f$export$13b2254026213b46;
module.exports["TEAM_CALENDARS_DELETE_EVENT_TYPE_EXPERIENCE"] = $4a617be77ace987f$export$c348a46d97587ee4;
module.exports["TEAM_CALENDARS_UPDATE_EVENT_TYPE_EXPERIENCE"] = $4a617be77ace987f$export$bfd3172de881908e;
module.exports["TEAM_CALENDARS_ADD_EVENT_EXPERIENCE"] = $4a617be77ace987f$export$e1a32de918001908;
module.exports["TEAM_CALENDARS_JIRA_CALENDAR_EXPERIENCE"] = $4a617be77ace987f$export$36abe825d06f7b68;
module.exports["TEAM_CALENDARS_UPDATE_EVENT_EXPERIENCE"] = $4a617be77ace987f$export$1be22ae521e809a9;
module.exports["TEAM_CALENDARS_DELETE_EVENT_EXPERIENCE"] = $4a617be77ace987f$export$eb40d48a494923c8;
module.exports["TEAM_CALENDARS_UPDATE_RESTRICTIONS_EXPERIENCE"] = $4a617be77ace987f$export$66104f246f979de9;
module.exports["EDIT_SPACE_LOGO_RESTORE_EXPERIENCE"] = $4a617be77ace987f$export$a245b5e8e50aca4e;
module.exports["EDIT_SPACE_LOGO_SAVE_EXPERIENCE"] = $4a617be77ace987f$export$38c64d0e786460e8;
module.exports["EDIT_SPACE_LOGO_DETAILS_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$53b6eab7c794efdf;
module.exports["COVER_PICTURE_UNSPLASH_UPLOAD_EXPERIENCE"] = $4a617be77ace987f$export$d4e50447c54e832a;
module.exports["COVER_PICTURE_MEDIA_UPLOAD_EXPERIENCE"] = $4a617be77ace987f$export$3b296e5e8d4fbd72;
module.exports["COVER_PICTURE_REMOVE_EXPERIENCE"] = $4a617be77ace987f$export$75c73b1e1363abb2;
module.exports["VIEW_APP_SUGGESTIONS_EXPERIENCE"] = $4a617be77ace987f$export$56b59e3252d65c77;
module.exports["CONDITIONAL_PUBLISH_DIALOG_EXPERIENCE"] = $4a617be77ace987f$export$61ad3866e7413864;
module.exports["EXTENSION_POINT_BYLINE_EXPERIENCE"] = $4a617be77ace987f$export$5685c80727d12c34;
module.exports["EXTENSION_POINT_SPACE_BUTTONS_EXPERIENCE"] = $4a617be77ace987f$export$4b9cf95d297cf82f;
module.exports["EXTENSION_POINT_HOME_FOOTER_EXPERIENCE"] = $4a617be77ace987f$export$811ef7c3a5f94996;
module.exports["EXTENSION_POINT_HOME_HEADER_EXPERIENCE"] = $4a617be77ace987f$export$dfab08323861cbc1;
module.exports["EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE"] = $4a617be77ace987f$export$aa9a33eaf0b3cefa;
module.exports["EXTENSION_POINT_PAGE_METADATA_BANNER_EXPERIENCE"] = $4a617be77ace987f$export$4933a09c775176cb;
module.exports["EXTENSION_POINT_PAGE_BANNER_EXPERIENCE"] = $4a617be77ace987f$export$645909341bfebc9b;
module.exports["EXTENSION_POINT_SPACE_SETTINGS_TABS_EXPERIENCE"] = $4a617be77ace987f$export$facf18b53398c3d7;
module.exports["CORE_INVITES_EXPERIENCE"] = $4a617be77ace987f$export$23be08d2ca73ecf;
module.exports["CUSTOM_CONTENT_PAGE_ALL_EXPERIENCE"] = $4a617be77ace987f$export$b1dd9d960d4ea959;
module.exports["CUSTOM_CONTENT_SPACE_LIST_VIEW_EXPERIENCE"] = $4a617be77ace987f$export$38660dec2eb2a695;
module.exports["CUSTOM_CONTENT_PAGE_LIST_VIEW_EXPERIENCE"] = $4a617be77ace987f$export$7b1fe4d076a9542a;
module.exports["CUSTOM_CONTENT_VIEW_EXPERIENCE"] = $4a617be77ace987f$export$ad06e79f63068f5e;
module.exports["CONNECTIONS_PANEL_VIEW_EXPERIENCE"] = $4a617be77ace987f$export$eef674482902ef6d;
module.exports["EOP_RECS_EXPERIENCE"] = $4a617be77ace987f$export$c5bcbbcb1df627e5;
module.exports["NOTIFY_ON_FIRST_VIEW_EXPERIENCE"] = $4a617be77ace987f$export$3b683344868f9f0a;
module.exports["PRESENTER_MODE_VIEW_EXPERIENCE"] = $4a617be77ace987f$export$4fdd9934209dba0e;
module.exports["PRESENTER_MODE_FULLSCREEN_API_EXPERIENCE"] = $4a617be77ace987f$export$40638d9b45e8ceca;
module.exports["VIEW_PUBLIC_LINK_SITE_SETTINGS_EXPERIENCE"] = $4a617be77ace987f$export$b1f7a84b45eb9afb;
module.exports["VIEW_PUBLIC_LINK_SPACES_TABLE_EXPERIENCE"] = $4a617be77ace987f$export$8294c237289049c4;
module.exports["VIEW_PUBLIC_LINKS_PAGE_TABLE_EXPERIENCE"] = $4a617be77ace987f$export$ec6e09c5fd9fa221;
module.exports["PUBLIC_LINKS_SPACES_TABLE_ACTION_EXPERIENCE"] = $4a617be77ace987f$export$5cc7e9470bfae723;
module.exports["PUBLIC_LINK_SITE_TOGGLE_CHANGE_EXPERIENCE"] = $4a617be77ace987f$export$c102a9d514fc95ac;
module.exports["VIEW_PUBLIC_LINKS_SPACE_SETTINGS_EXPERIENCE"] = $4a617be77ace987f$export$ff2fb656c8231637;
module.exports["PUBLIC_LINKS_SPACE_TOGGLE_CHANGE_EXPERIENCE"] = $4a617be77ace987f$export$ba803d464f49a265;
module.exports["VIEW_PUBLIC_LINKS_DEFAULT_SPACE_SETTINGS_EXPERIENCE"] = $4a617be77ace987f$export$d95bcf023bd8993;
module.exports["PUBLIC_LINKS_DEFAULT_SPACE_TOGGLE_CHANGE_EXPERIENCE"] = $4a617be77ace987f$export$7362876707c57af9;
module.exports["VIEW_PUBLIC_LINK_SHARED_PAGE_EXPERIENCE"] = $4a617be77ace987f$export$c7ff49e7eaa45ff1;
module.exports["PUBLIC_LINK_RENDERED_EXPERIENCE"] = $4a617be77ace987f$export$24cbec84f278c600;
module.exports["PUBLIC_LINK_TOGGLE_CHANGE_EXPERIENCE"] = $4a617be77ace987f$export$5b89a66b04cea206;
module.exports["PUBLIC_LINK_DISABLE_FROM_RESTRICTIONS_EXPERIENCE"] = $4a617be77ace987f$export$44b7602dc9689e08;
module.exports["PUBLIC_LINK_PAGE_TABLE_ACTION_EXPERIENCE"] = $4a617be77ace987f$export$eed7907041fecd69;
module.exports["EXTERNAL_SHARE_EXPERIENCE"] = $4a617be77ace987f$export$49a01ffc1a18656b;
module.exports["COPY_CONTENT_LINK_EXPERIENCE"] = $4a617be77ace987f$export$e25df1f458506fcd;
module.exports["CONTENT_HISTORY_EXPERIENCE"] = $4a617be77ace987f$export$7c34e8285a2b9238;
module.exports["VIEW_TASKS_EXPERIENCE"] = $4a617be77ace987f$export$b9b41dfe39f06772;
module.exports["SET_TASK_COMPLETE_EXPERIENCE"] = $4a617be77ace987f$export$6be3453279e7dd85;
module.exports["CHANGE_PAGE_OWNER_EXPERIENCE"] = $4a617be77ace987f$export$80a3b142ba868b57;
module.exports["CONTENT_OWNERSHIP_DIALOG_EXPERIENCE"] = $4a617be77ace987f$export$19875313f499fad9;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_EXPERIENCE"] = $4a617be77ace987f$export$e94c6163c32592ce;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_DISMISS_EXPERIENCE"] = $4a617be77ace987f$export$7653dfd9fd5557b;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTINGS_EXPERIENCE"] = $4a617be77ace987f$export$394294e59b36efb9;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_PUBLISH_EXPERIENCE"] = $4a617be77ace987f$export$8f017785cc4bb995;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_TURN_OFF_EXPERIENCE"] = $4a617be77ace987f$export$a4d890726485d79a;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_TABLE_EXPERIENCE"] = $4a617be77ace987f$export$47d510c88b13ea8d;
module.exports["SPACE_MANAGER_EXPERIENCE"] = $4a617be77ace987f$export$548adb1a2fe6e6b1;
module.exports["SPACE_MANAGER_QUICK_ACTION_ITEM_EXPERIENCE"] = $4a617be77ace987f$export$35f739fc0b127205;
module.exports["IMPORTER_DASHBOARD_EXPERIENCE"] = $4a617be77ace987f$export$bfe6ff6cddeed6e3;
module.exports["COMPANY_HUB_GENERAL_SETTINGS_EXPERIENCE"] = $4a617be77ace987f$export$2decaadcf840e6b3;
module.exports["COMPANY_HUB_GENERAL_SETTINGS_YOUR_HUB_EXPERIENCE"] = $4a617be77ace987f$export$23b4a008c670d304;
module.exports["COMPANY_HUB_GENERAL_SETTINGS_YOUR_HUB_ACTIONS_EXPERIENCE"] = $4a617be77ace987f$export$c6198e9d6ab9e417;
module.exports["COMPANY_HUB_GENERAL_SETTINGS_HUB_RECENT_ACTIVITY_EXPERIENCE"] = $4a617be77ace987f$export$e1b506612f6e9657;
module.exports["COMPANY_HUB_GENERAL_SETTINGS_HUB_VIEWS_EXPERIENCE"] = $4a617be77ace987f$export$dfdc3f1142f40689;
module.exports["COMPANY_HUB_GENERAL_SETTINGS_MOST_CLICKS_EXPERIENCE"] = $4a617be77ace987f$export$e9845af7b7fd8501;
module.exports["ADMIN_CENTER_EXPERIENCE"] = $4a617be77ace987f$export$237a7d3a8e219dbb;
module.exports["ADMIN_CENTER_CONFLUENCE_ADMINS_EXPERIENCE"] = $4a617be77ace987f$export$b7b3a9d4d05ffd12;
module.exports["ADMIN_CENTER_SEARCH_COUNT_EXPERIENCE"] = $4a617be77ace987f$export$367f60a3ad6918c1;
module.exports["ADMIN_CENTER_SEARCH_CTR_EXPERIENCE"] = $4a617be77ace987f$export$9a8113803e6447cf;
module.exports["ADMIN_CENTER_TOP_SEARCHES_EXPERIENCE"] = $4a617be77ace987f$export$8f37d7eb1e6f681d;
module.exports["ADMIN_CENTER_TOP_UNSUCCESSFUL_SEARCHES_EXPERIENCE"] = $4a617be77ace987f$export$2ad5d40786f81da0;
module.exports["ADMIN_CENTER_EXTERNAL_ACCESS_EXPERIENCE"] = $4a617be77ace987f$export$e68566fb281dbb33;
module.exports["ADMIN_CENTER_BETA_FEATURES_EXPERIENCE"] = $4a617be77ace987f$export$a7f1ee469fd8596c;
module.exports["ADMIN_CENTER_TOTAL_SPACES_EXPERIENCE"] = $4a617be77ace987f$export$8a3b06f53918d80e;
module.exports["ADMIN_CENTER_TOTAL_CONTENT_EXPERIENCE"] = $4a617be77ace987f$export$d4f2672a4a997be2;
module.exports["ADMIN_CENTER_GROUPED_SUMMARY_EXPERIENCE"] = $4a617be77ace987f$export$61440d1f5d765856;
module.exports["ADMIN_CENTER_INACTIVE_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$a122d82c3b13ba99;
module.exports["ADMIN_CENTER_TOP_INACTIVE_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$bf035e1987052c42;
module.exports["ADMIN_CENTER_DEACTIVATED_OWNER_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$1613edca53571ea3;
module.exports["ADMIN_CENTER_TOP_DEACTIVATED_OWNER_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$4ba2b40dc30760f9;
module.exports["ADMIN_CENTER_CONTENT_CREATED_EXPERIENCE"] = $4a617be77ace987f$export$5d6b6234c4e9f70d;
module.exports["ADMIN_CENTER_CONTENT_UPDATED_EXPERIENCE"] = $4a617be77ace987f$export$39552d32ae5efc36;
module.exports["ADMIN_CENTER_CONTENT_VIEWS_EXPERIENCE"] = $4a617be77ace987f$export$a4934c826482e207;
module.exports["ADMIN_CENTER_TOP_CONTENT_VIEWS_EXPERIENCE"] = $4a617be77ace987f$export$4c0549ea0cf0f43d;
module.exports["ADMIN_CENTER_OVERVIEW_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$6b8c8a94a6fb0b10;
module.exports["ADMIN_CENTER_OVERVIEW_EXPERIENCE"] = $4a617be77ace987f$export$a4855248cbcdc638;
module.exports["ADMIN_CENTER_OVERVIEW_SEARCH_COUNT_EXPERIENCE"] = $4a617be77ace987f$export$f1c6b44ad858e24f;
module.exports["ADMIN_CENTER_OVERVIEW_SEARCH_CTR_EXPERIENCE"] = $4a617be77ace987f$export$aaba8c517b5b0014;
module.exports["ADMIN_CENTER_OVERVIEW_TOTAL_SPACES_EXPERIENCE"] = $4a617be77ace987f$export$3463471aa64d2a20;
module.exports["ADMIN_CENTER_OVERVIEW_TOTAL_CONTENT_EXPERIENCE"] = $4a617be77ace987f$export$aed49d47c6d277d2;
module.exports["ADMIN_CENTER_OVERVIEW_INACTIVE_PAGES_NUM_EXPERIENCE"] = $4a617be77ace987f$export$c89944dc251c7694;
module.exports["ADMIN_CENTER_OVERVIEW_INACTIVE_PAGES_PERCENT_EXPERIENCE"] = $4a617be77ace987f$export$45d06e7b1bc06ed4;
module.exports["ADMIN_CENTER_OVERVIEW_DEACTIVATED_OWNER_PAGES_NUM_EXPERIENCE"] = $4a617be77ace987f$export$50744fb70a2982a2;
module.exports["ADMIN_CENTER_OVERVIEW_DEACTIVATED_OWNER_PAGES_PERCENT_EXPERIENCE"] = $4a617be77ace987f$export$35f523c785c60e15;
module.exports["ADMIN_CENTER_OVERVIEW_CONTENT_CREATED_EXPERIENCE"] = $4a617be77ace987f$export$d4f40a3c80d7fa00;
module.exports["ADMIN_CENTER_OVERVIEW_CONTENT_UPDATED_EXPERIENCE"] = $4a617be77ace987f$export$3e98f2df16d1f652;
module.exports["ADMIN_CENTER_OVERVIEW_CONTENT_VIEWS_EXPERIENCE"] = $4a617be77ace987f$export$512d403dd28c8f13;
module.exports["ADMIN_CENTER_OVERVIEW_PUBLIC_LINK_VIEWS_EXPERIENCE"] = $4a617be77ace987f$export$b5db801ede6fe9e5;
module.exports["ADMIN_CENTER_OVERVIEW_PUBLIC_LINKS_EXPERIENCE"] = $4a617be77ace987f$export$2df6bcfd56d7c9e8;
module.exports["ADMIN_CENTER_SUGGESTIONS_EXPERIENCE"] = $4a617be77ace987f$export$6c98543cf0a07a9f;
module.exports["ADMIN_CENTER_SUGGESTIONS_UNASSIGNED_GUEST_EXPERIENCE"] = $4a617be77ace987f$export$9f5be3c30e870f46;
module.exports["ADMIN_CENTER_SUGGESTIONS_INACTIVE_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$56c7132579558fc8;
module.exports["ADMIN_CENTER_SUGGESTIONS_DEACTIVATED_OWNER_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$4bc17e6067981b1f;
module.exports["ADMIN_CENTER_SUGGESTIONS_SPACE_MANAGER_EXPERIENCE"] = $4a617be77ace987f$export$2f62829f51afa45a;
module.exports["ADMIN_CENTER_SUGGESTIONS_USER_ACCESS_EXPERIENCE"] = $4a617be77ace987f$export$19020e617b152304;
module.exports["ADMIN_CENTER_SUGGESTIONS_QUICK_ACTION_ITEM_EXPERIENCE"] = $4a617be77ace987f$export$12a435102ccb624a;
module.exports["ADMIN_CENTER_SUGGESTIONS_METRIC_CTA_EXPERIENCE"] = $4a617be77ace987f$export$dec2cee4628ab9c4;
module.exports["SPACE_ADMIN_CENTER_EXPERIENCE"] = $4a617be77ace987f$export$88a8c07833ef47b1;
module.exports["SPACE_ADMIN_CENTER_GROUPED_SUMMARY_EXPERIENCE"] = $4a617be77ace987f$export$fb0bb005ed2de56c;
module.exports["SPACE_ADMIN_CENTER_EXTERNAL_ACCESS_EXPERIENCE"] = $4a617be77ace987f$export$73c5a862f5073e46;
module.exports["SPACE_ADMIN_CENTER_SPACE_ADMINS_EXPERIENCE"] = $4a617be77ace987f$export$4d72041a86e9e003;
module.exports["SPACE_ADMIN_CENTER_CONTENT_VIEWS_EXPERIENCE"] = $4a617be77ace987f$export$724928cbf61f8819;
module.exports["SPACE_ADMIN_CENTER_TOP_CONTENT_VIEWS_EXPERIENCE"] = $4a617be77ace987f$export$eee5f90734589227;
module.exports["SPACE_ADMIN_CENTER_CONTENT_CREATED_EXPERIENCE"] = $4a617be77ace987f$export$a5e95165e3a702d1;
module.exports["SPACE_ADMIN_CENTER_CONTENT_UPDATED_EXPERIENCE"] = $4a617be77ace987f$export$32dde1d12c499528;
module.exports["SPACE_ADMIN_CENTER_TOTAL_CONTENT_EXPERIENCE"] = $4a617be77ace987f$export$147226654b32f956;
module.exports["SPACE_ADMIN_CENTER_INACTIVE_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$648d00fafa66ae14;
module.exports["SPACE_ADMIN_CENTER_TOP_INACTIVE_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$a3fdce9bb003f0b8;
module.exports["SPACE_ADMIN_CENTER_DEACTIVATED_OWNER_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$71daddda71b57298;
module.exports["SPACE_ADMIN_CENTER_TOP_DEACTIVATED_OWNER_PAGES_EXPERIENCE"] = $4a617be77ace987f$export$62d9e5dacf2e073d;
module.exports["DWELL_TIME_START_EXPERIENCE"] = $4a617be77ace987f$export$8c3b600f7a5dce0f;
module.exports["TRIAL_COMPONENTS_LOZENGE_VIEW_EXPERIENCE"] = $4a617be77ace987f$export$b0fe8424f6f27f51;
module.exports["TRIAL_COMPONENTS_FLAG_VIEW_EXPERIENCE"] = $4a617be77ace987f$export$40c0cee2cad141c5;
module.exports["TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE"] = $4a617be77ace987f$export$d0e7688ec900110c;
module.exports["TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE"] = $4a617be77ace987f$export$655feba7d95d5b26;
module.exports["QUICK_SUMMARY_EXPERIENCE"] = $4a617be77ace987f$export$f8372d329c2aeea0;
module.exports["QUICK_SUMMARY_WHITEBOARDS_EXPERIENCE"] = $4a617be77ace987f$export$31e4e6e2658a6cae;
module.exports["QUICK_SUMMARY_TO_PAGE_EXPERIENCE"] = $4a617be77ace987f$export$4a493e4dc06e57e7;
module.exports["COMMENTS_SUMMARY_EXPERIENCE"] = $4a617be77ace987f$export$5565b0bba4d72eee;
module.exports["AI_CONTENT_CATCHUP_EXPERIENCE"] = $4a617be77ace987f$export$8d9dfd2f17501337;
module.exports["AI_PRESENTATION_GENERATION_VIEW_EXPERIENCE"] = $4a617be77ace987f$export$eb38477d5de37f36;
module.exports["AI_PRESENTATION_GENERATION_CREATE_EXPERIENCE"] = $4a617be77ace987f$export$ed3e815374d54f04;
module.exports["AI_AUDIO_BRIEFING"] = $4a617be77ace987f$export$f9a8f9ac1a851fe7;
module.exports["AI_AUDIO_NARRATION"] = $4a617be77ace987f$export$6086ea87dfcad89d;
module.exports["AI_TITLE_GENERATION"] = $4a617be77ace987f$export$daafa0ab79e187e5;
module.exports["AI_HEADER_IMAGE_GENERATION"] = $4a617be77ace987f$export$8091bb21bb2521cb;
module.exports["PLAN_COMPARISON_MODAL"] = $4a617be77ace987f$export$530e334566c01c65;
module.exports["READING_AIDS_EXPERIENCE"] = $4a617be77ace987f$export$7f32d11b06ee25ff;
module.exports["AI_DEFINITIONS_AUTOHIGHLIGHT_EXPERIENCE"] = $4a617be77ace987f$export$38e6a52d8f0a641f;
module.exports["VIEW_GUEST_REQUEST_TO_UPGRADE_EXPERIENCE"] = $4a617be77ace987f$export$9bd965a890617f5b;
module.exports["SUBMIT_GUEST_REQUEST_TO_UPGRADE_EXPERIENCE"] = $4a617be77ace987f$export$85b1366ed05e7209;
module.exports["SUBMIT_GUEST_MENTIONS_UPGRADE_FLOW_EXPERIENCE"] = $4a617be77ace987f$export$aace851408b6de3e;
module.exports["VIEW_GUEST_SPACES_MENU_REQUEST_TO_UPGRADE_EXPERIENCE"] = $4a617be77ace987f$export$611140537004e76c;
module.exports["SUBMIT_GUEST_SPACES_MENU_REQUEST_TO_UPGRADE_EXPERIENCE"] = $4a617be77ace987f$export$e73147035caab2f2;
module.exports["RESTORE_SPACE_EXPERIENCE"] = $4a617be77ace987f$export$11311af26ac8cb8b;
module.exports["HARD_DELETE_SPACE_EXPERIENCE"] = $4a617be77ace987f$export$dec29f1de3a4a5ce;
module.exports["VIEW_SPACE_PERMISSIONS"] = $4a617be77ace987f$export$e69556d68987dda1;
module.exports["EDIT_SPACE_PERMISSIONS"] = $4a617be77ace987f$export$a5bcda9ae1f6839a;
module.exports["VIEW_APP_CUSTOM_CONTENT_PERMISSIONS"] = $4a617be77ace987f$export$22c9153bc8c871f3;
module.exports["EDIT_APP_CUSTOM_CONTENT_PERMISSIONS"] = $4a617be77ace987f$export$32f7f39f260e234c;
module.exports["VIEW_JSM_BANNER"] = $4a617be77ace987f$export$c39bf2cb4e8cc70c;
module.exports["DISABLE_JSM_PERMISSIONS"] = $4a617be77ace987f$export$4e373788dac39943;
module.exports["VIEW_DEFAULT_SPACE_PERMISSIONS"] = $4a617be77ace987f$export$f7308c84ae7be9c8;
module.exports["EDIT_DEFAULT_SPACE_PERMISSIONS"] = $4a617be77ace987f$export$85cd19170159a085;
module.exports["VIEW_ALL_SPACES_TAB"] = $4a617be77ace987f$export$3cfa8e4552e9e6ce;
module.exports["COMPANY_HOME_BUILDER_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$c9f8ebbba8f73eeb;
module.exports["COMPANY_HOME_BUILDER_EDIT_EXPERIENCE"] = $4a617be77ace987f$export$d4d3fc5b22a2a5d2;
module.exports["COMPANY_HOME_BUILDER_UPLOAD_EXPERIENCE"] = $4a617be77ace987f$export$cc438f9a49eb57aa;
module.exports["COMPANY_HUB_CREATION_EXPERIENCE"] = $4a617be77ace987f$export$90e15cc4582adffa;
module.exports["COMPANY_HUB_CHANGE_HUB_NAME_EXPERIENCE"] = $4a617be77ace987f$export$9458ecd4beb6dc6b;
module.exports["FRONT_COVER_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$7f2689ec25c432a4;
module.exports["COMPANY_HUB_UNPUBLISH_HUB_EXPERIENCE"] = $4a617be77ace987f$export$c8ff6311a26d2c8c;
module.exports["COMPANY_HUB_ANALYTICS_EXPERIENCE"] = $4a617be77ace987f$export$f5a5045f5872d850;
module.exports["COMPANY_HUB_ANALYTICS_BOX_ROW_EXPERIENCE"] = $4a617be77ace987f$export$2c2b8afe13693d2b;
module.exports["COMPANY_HUB_ANALYTICS_CHART_EXPERIENCE"] = $4a617be77ace987f$export$db8c2f7bf58fe015;
module.exports["COMPANY_HUB_ANALYTICS_TABLE_EXPERIENCE"] = $4a617be77ace987f$export$b0852f88603c392f;
module.exports["COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE"] = $4a617be77ace987f$export$c5e974e322d233b1;
module.exports["COMPANY_HUB_EDITOR_EXPERIENCE"] = $4a617be77ace987f$export$c6d05c48b9430e3c;
module.exports["COMPANY_HUB_EDITOR_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$35975591aeab4dd6;
module.exports["COMPANY_HUB_EDITOR_CLOSE_EXPERIENCE"] = $4a617be77ace987f$export$7a3dfdccebea9c7b;
module.exports["FRONT_COVER_PUBLISH_EXPERIENCE"] = $4a617be77ace987f$export$eef6122c9774ba1c;
module.exports["CARDS_IMAGE_UPLOAD_EXPERIENCE"] = $4a617be77ace987f$export$651b4e780cbf5647;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$3e70adb2ef2d5f7a;
module.exports["ADMIN_TEAM_CALENDARS_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$18051474a34eda87;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$dc2f45d36e47ca3a;
module.exports["ADMIN_GENERAL_CONFIGURATION_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$b27bac0c0dea2a55;
module.exports["ADMIN_GENERAL_CONFIGURATION_UPDATE_FAVICON_UPLOAD_EXPERIENCE"] = $4a617be77ace987f$export$a3c4dc4a199ee1b8;
module.exports["NOTIFICATIONS_SITE_SETTINGS_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$d32cd699d9dbf985;
module.exports["NOTIFICATIONS_SITE_SETTINGS_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$6fd7ab2f1e137193;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$7875e1f75aa15306;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$164e825247db8d43;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$c390f9e07c545581;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_MEDIA_SERVICE_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$4090d6a71e5b3ead;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$a1986920605a1163;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$313ad6157a5a0ea9;
module.exports["ADMIN_HEADER_AND_FOOTER_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$dd6c028654f91f02;
module.exports["SPACE_SETTINGS_ADMIN_PAGE_LAYOUT_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$bb009baa1a9cbcf0;
module.exports["SPACE_SETTINGS_ADMIN_PAGE_LAYOUT_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$6d0fbdff5b6fa174;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$8abd8604ca7982c7;
module.exports["ADMIN_SECURITY_CONFIGURATION_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$21855cac8c6f3d91;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$faa6a1cbc50fd4a5;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_PAGE_TEMPLATES_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$9cfd44509d36312b;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_PAGE_BLUEPRINTS_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$fb29220c46f6993;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_SYSTEM_TEMPLATES_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$90402aae1ab35229;
module.exports["SPACE_SETTINGS_ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$8e008c4796774e26;
module.exports["ADMIN_IMPORT_SPACES_CONFIGURATION_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$bc61a3e94ba2560e;
module.exports["ADMIN_IMPORT_SPACES_IMPORT_EXPERIENCE"] = $4a617be77ace987f$export$936492407dd3e3ab;
module.exports["ADMIN_TRASHED_SPACES_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$99f32e90f59041e7;
module.exports["ADMIN_RESTORE_SPACE_EXPERIENCE"] = $4a617be77ace987f$export$1057adadb9206825;
module.exports["ADMIN_HARD_DELETE_SPACE_EXPERIENCE"] = $4a617be77ace987f$export$9f610d573468ea4;
module.exports["ADMIN_APPLICATION_NAVIGATOR_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$4447822883006e0;
module.exports["ADMIN_APPLICATION_NAVIGATOR_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$93194ca916026abe;
module.exports["ADMIN_APPLICATION_NAVIGATOR_ADD_EXPERIENCE"] = $4a617be77ace987f$export$c226034eea0cb4de;
module.exports["ADMIN_THEMES_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$22f1f1a21c7d0c50;
module.exports["ADMIN_THEMES_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$12093307e4f8fd56;
module.exports["SPACE_SETTINGS_ADMIN_THEMES_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$a48b049eb2fcbe71;
module.exports["SPACE_SETTINGS_ADMIN_THEMES_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$5b92dfbf1efa2144;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$565897f0a51f5efd;
module.exports["ADMIN_JIRA_MACRO_REPAIR_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$2292c61864873ec0;
module.exports["ADMIN_PDF_EXPORT_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$d8f5df97692e60be;
module.exports["ADMIN_PDF_EXPORT_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$e2eb28f9e03e0850;
module.exports["SPACE_SETTINGS_ADMIN_PDF_EXPORT_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$ab0128b7a160aaed;
module.exports["SPACE_SETTINGS_ADMIN_PDF_EXPORT_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$e65a54ac514355c1;
module.exports["SPACE_SETTINGS_ADMIN_PDF_EXPORT_LOAD_EXPERIENCE_NCS"] = $4a617be77ace987f$export$9e6e2adcf47359af;
module.exports["SPACE_SETTINGS_CSV_EXPORT_EXPERIENCE"] = $4a617be77ace987f$export$9fb76bc73314ca1e;
module.exports["SPACE_SETTINGS_EXPORT_SPACE_LOAD_PAGE_TREE"] = $4a617be77ace987f$export$fde5d45e43ea2ca4;
module.exports["SPACE_SETTINGS_EXPORT_COMPLETED_EXPORT_AND_DOWNLOAD"] = $4a617be77ace987f$export$b9b428ecdf423548;
module.exports["PDF_EXPORT_PAGE_EXPERIENCE"] = $4a617be77ace987f$export$5fa322173b52c417;
module.exports["SPACE_SETTINGS_LEGACY_CONTENT_REPORT"] = $4a617be77ace987f$export$bda7d7fc953c118f;
module.exports["ADMIN_MACRO_USAGE_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$c08c7422d3e7a141;
module.exports["WATCH_DIALOG_WATCH_EXPERIENCE"] = $4a617be77ace987f$export$d6369a194e24ad7f;
module.exports["WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE"] = $4a617be77ace987f$export$8012a45d3107312e;
module.exports["MANAGE_WATCHERS_DIALOG_UNFILTERED_EXPERIENCE"] = $4a617be77ace987f$export$84a690fd513af1de;
module.exports["SPACE_SETTINGS_ADMIN_LOOK_AND_FEEL_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$6d5416d96215c2a6;
module.exports["SPACE_PERMISSIONS_REPORT_EXPERIENCE"] = $4a617be77ace987f$export$ae036afd16ed2b49;
module.exports["CONVERT_PAGE_TO_FOLDER_EXPERIENCE"] = $4a617be77ace987f$export$2361c2310cf691ea;
module.exports["SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$e85b045b69985ed1;
module.exports["SHARE_AND_RESTRICT_DIALOG_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$4717394ee1c94acc;
module.exports["SHARE_AND_RESTRICT_DIALOG_SAVE_ACTION_EXPERIENCE"] = $4a617be77ace987f$export$15b0dc8b7eaf2460;
module.exports["SHARE_AND_RESTRICT_DIALOG_SHARE_ACTION_EXPERIENCE"] = $4a617be77ace987f$export$d7fbaabd51b7e8aa;
module.exports["RBAC_VIEW_EXPERIENCE"] = $4a617be77ace987f$export$b3185617ebec44c9;
module.exports["RBAC_EDIT_EXPERIENCE"] = $4a617be77ace987f$export$2bf4fa4e191abad2;
module.exports["DEFAULT_RBAC_VIEW_EXPERIENCE"] = $4a617be77ace987f$export$a2e8aa26b8f23b29;
module.exports["DEFAULT_RBAC_EDIT_EXPERIENCE"] = $4a617be77ace987f$export$f615f6649fe944d3;
module.exports["SITE_RBAC_VIEW_EXPERIENCE"] = $4a617be77ace987f$export$c355f58335217bcc;
module.exports["SITE_RBAC_EDIT_EXPERIENCE"] = $4a617be77ace987f$export$ea342babb9acb6bc;
module.exports["SPACE_DETAILS_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$f6c4ac51d51b4d11;
module.exports["SPACE_DETAILS_UPDATE_EXPERIENCE"] = $4a617be77ace987f$export$e6949233f3fd16fa;
module.exports["SPACE_DETAILS_SPACE_LABEL_SEARCH_EXPERIENCE"] = $4a617be77ace987f$export$ac4798c67f4aca63;
module.exports["OBJECT_HEADER_EXPERIENCE"] = $4a617be77ace987f$export$13c8bebb873a5fd2;
module.exports["SIDEBAR_DETAILS_PANEL_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$717078a23de7ce41;
module.exports["SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE"] = $4a617be77ace987f$export$8bb2fdea912e6360;
module.exports["SIDEBAR_COMMENTS_PANEL_LOAD_OPEN_EXPERIENCE"] = $4a617be77ace987f$export$785ec834db7448db;
module.exports["SIDEBAR_COMMENTS_PANEL_LOAD_UNREAD_EXPERIENCE"] = $4a617be77ace987f$export$9455f903a440f62b;
module.exports["SIDEBAR_COMMENTS_PANEL_LOAD_RESOLVED_EXPERIENCE"] = $4a617be77ace987f$export$9eb18c236ac889d2;
module.exports["SIDEBAR_COMMENTS_PANEL_LOAD_DELETED_CONTENT_EXPERIENCE"] = $4a617be77ace987f$export$e6d0321727a888ba;
module.exports["IMPORT_CONTENT_EXPERIENCE"] = $4a617be77ace987f$export$1f5ef81ae9b1b308;
module.exports["IMPORT_MIRO_USERS"] = $4a617be77ace987f$export$8e0f9138cc943183;
module.exports["CONTENT_OVERFLOW_MENU"] = $4a617be77ace987f$export$bf23e3ec80d510d;
module.exports["MOBILE_MACRO_RENDERER_QUERY_EXPERIENCE"] = $4a617be77ace987f$export$5167cfad2b30339a;
module.exports["MOBILE_MACRO_RENDERER_EXPERIENCE"] = $4a617be77ace987f$export$db5f7458e232d5f3;
module.exports["PERMISSIONS_AUDIT_GENERATION"] = $4a617be77ace987f$export$d4235a0083f21618;
module.exports["PERMISSIONS_AUDIT_GENERATION_VIEW"] = $4a617be77ace987f$export$a992b43898fc066a;

});

parcelRegister("glCMv", function(module, exports) {
class $fe10bf271dd83f00$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $fe10bf271dd83f00$export$d27a2b6293f7631c;

});

parcelRegister("kmyYx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $7W8i8 = parcelRequire("7W8i8");


var $6fil2 = parcelRequire("6fil2");

var $lbti1 = parcelRequire("lbti1");


var $2XqLN = parcelRequire("2XqLN");


var $78QFu = parcelRequire("78QFu");


var $9wGTI = parcelRequire("9wGTI");


var $1dnxO = parcelRequire("1dnxO");


var $glCMv = parcelRequire("glCMv");


var $2KpT3 = parcelRequire("2KpT3");




class $9cb197567841b4e3$export$51cec848073e2e7a {
    start() {
        let lastFreezeStart;
        if (typeof document !== 'undefined') {
            document.addEventListener('freeze', ()=>{
                lastFreezeStart = performance.now();
            });
            document.addEventListener('resume', ()=>{
                // probably zero chance of it happening, but still
                if (typeof lastFreezeStart !== 'number') return;
                const now = performance.now();
                for (const callback of this.callbacks.values())callback(now - lastFreezeStart);
            });
        }
    }
    subscribe(name, callback) {
        // We are not subscribe and unsubscribe with callback's reference.
        // Because there are known cases that experiences are not properly stopped.
        // In order prevent from memory leak here we are using the name as the key since the variation is bounded.
        this.callbacks.set(name, callback);
    }
    unsubscribe(name) {
        this.callbacks.delete(name);
    }
    constructor(){
        this.callbacks = new Map();
    }
}
const $9cb197567841b4e3$export$40336562f0f00c2a = (0, $2XqLN.default)(()=>new $9cb197567841b4e3$export$51cec848073e2e7a());



var $irVI7 = parcelRequire("irVI7");

// Whenever we want to target view-page experience, we should ensure we're targeting all correlated view-page experiences.
// This is more complete and helps avoid bugs related to view-content experience forwarding to view-page.
const $2b8b14878b3a8327$var$VIEW_PAGE_EXPERIENCES = [
    (0, $irVI7.VIEW_PAGE_EXPERIENCE),
    (0, $irVI7.VIEW_CONTENT_EXPERIENCE),
    (0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE)
];
// Experience timeouts by default are considered taskFails. Certain experiences should instead treat timeouts as aborts, to reduce unnecessary noise and improve SLI accuracy.
const $2b8b14878b3a8327$var$EXPERIENCE_TIMEOUTS_TO_ABORT = [
    (0, $irVI7.CREATE_PAGE_EXPERIENCE),
    ...$2b8b14878b3a8327$var$VIEW_PAGE_EXPERIENCES,
    (0, $irVI7.WHITEBOARD_EXPERIENCE),
    (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE),
    (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE)
];
// Errors that are thrown by client side and can be ignored, this is to avoid treating these as fails that can impact SLOs.
// ideally we can show the user a flag that shows something is wrong, please avoid adding to this list unless absolutely necessary.
const $2b8b14878b3a8327$var$IGNORABLE_CLIENT_SIDE_ERRORS = [
    "can't access dead object"
];
/**
 * A list of experiences that should have debugMessages attached to abort events.
 *
 * This is not a safe default, as at time of addition ~20% of experiences
 * with some events having ~90% abort rates with high volume (>10k per 15m)
 *
 * If adding -- ensure you first review the event and abort volume.
 */ const $2b8b14878b3a8327$var$EXPERIENCES_TO_DEBUG_ON_ABORT = [
    (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE)
];
class $2b8b14878b3a8327$export$c90b54e658fc4d7c {
    succeed(attributes, publishDebugPoints) {
        if (this.hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getAbsoluteDuration(),
            activeDuration: this.getDurationAdjustedForActive(),
            adjustedDuration: this.getDurationAdjustedForTabActivity(),
            ...publishDebugPoints && {
                debugPoints: this.debugPoints
            },
            attributes: {
                ...(0, $78QFu.getUniquePageLoadId)(),
                ...this.getFeatureGateAttributes(),
                ...this.attributes,
                ...attributes
            }
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this.hasStopped) return;
        if (error?.message && $2b8b14878b3a8327$var$IGNORABLE_CLIENT_SIDE_ERRORS.includes(error.message)) {
            this.abort({
                reason: 'Aborted because of client side error',
                attributes: {
                    ...attributes,
                    clientSideError: error.message
                }
            });
            return;
        }
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getAbsoluteDuration(),
            activeDuration: this.getDurationAdjustedForActive(),
            adjustedDuration: this.getDurationAdjustedForTabActivity(),
            debugPoints: this.debugPoints,
            error: error,
            attributes: {
                ...(0, $78QFu.getUniquePageLoadId)(),
                ...this.getFeatureGateAttributes(),
                ...this.attributes,
                ...attributes
            }
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true, publishDebugPoints: /**
     * @deprecated
     * This will not attach debug points in the event that the experience in scenarios where
     * the abort is not coming from consumer code (e.g. when the experience is stopped due
     * to a new experience starting).
     */ publishDebugPoints = false }) {
        if (this.hasStopped) return;
        const adjustedDuration = this.getDurationAdjustedForTabActivity();
        const isTimeout = checkForTimeout && this.timeout != null && adjustedDuration >= this.timeout;
        // Check if the experience should have failed due to timeout
        if (isTimeout) // We want to abort timeouts from view-page and create-page to improve SLO reliability accuracy as they're not guaranteed to be correlated to real user impact. For more info see MODES-4806.
        {
            if (!$2b8b14878b3a8327$var$EXPERIENCE_TIMEOUTS_TO_ABORT.includes(this.name)) {
                this.fail({
                    attributes: {
                        originalAbortReason: reason,
                        ...attributes
                    },
                    error: new (0, $glCMv.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
                });
                return;
            }
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getAbsoluteDuration(),
            activeDuration: this.getDurationAdjustedForActive(),
            adjustedDuration: adjustedDuration,
            ...$2b8b14878b3a8327$var$EXPERIENCES_TO_DEBUG_ON_ABORT.includes(this.name) ? {
                debugPoints: this.debugPoints
            } : {},
            ...publishDebugPoints && {
                debugPoints: this.debugPoints
            },
            reason: isTimeout ? `ExperienceTimeout: ${this.name} failed to complete in ${this.timeout}ms` : reason,
            checkForTimeout: checkForTimeout,
            attributes: {
                originalAbortReason: isTimeout ? reason : undefined,
                ...(0, $78QFu.getUniquePageLoadId)(),
                ...this.getFeatureGateAttributes(),
                ...this.attributes,
                ...attributes
            }
        });
    }
    /**
   * Called on experience to stop it with the same action (success / failure / abort) and attributes as another event.
   * For example, compound experience (e.g. edit-page) is failed if sub-experience (e.g. edit-page/publish) fails.
   */ stopOn(event, extraAttributes = {}) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed({});
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            attributes: {
                ...extraAttributes,
                stoppedOn: event.name,
                stoppedOnPath: this.getStoppedOnPath(event)
            },
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error,
            attributes: {
                ...extraAttributes,
                stoppedOn: event.name,
                stoppedOnPath: this.getStoppedOnPath(event)
            }
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    attachDebugPoint(message, attributes = {}) {
        if (this.debugPoints?.some((debugPoint)=>debugPoint.message === message)) // Avoid adding duplicate debug points
        return;
        this.debugPoints.push({
            timestamp: new Date().toISOString(),
            now: window.performance.now(),
            message: message,
            attributes: attributes
        });
    }
    getState() {
        return {
            taskId: this.id,
            timeout: this.timeout,
            hasStopped: this.hasStopped,
            stopState: this.stopState,
            startTime: this.startTime,
            name: this.name,
            attributes: this.attributes
        };
    }
    get hasStopped() {
        return this.stopState !== null;
    }
    stop(event) {
        this.stopState = event.action;
        if (this.onStop) this.onStop(event);
        (0, $9cb197567841b4e3$export$40336562f0f00c2a)().unsubscribe(this.name);
    }
    getAbsoluteDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    getDurationAdjustedForTabActivity() {
        return this.getAbsoluteDuration() - (0, $2KpT3.getTabInactivityTracker)().getInactiveMillisecondsSince(this.startTime);
    }
    getDurationAdjustedForActive() {
        return this.getAbsoluteDuration() - this.freezeTime;
    }
    getStoppedOnPath(event) {
        if (!event.attributes?.stoppedOnPath) return event.name;
        return `${event.name},${event.attributes.stoppedOnPath}`;
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this.freezeTime = 0;
        this.stopState = null;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.debugPoints = [];
        // Include certain broad-impact feature gates in experience events
        this.getFeatureGateAttributes = (0, $2XqLN.default)(()=>{
            return {
                isContentWrapperEnabled: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
                isNav4Enabled: (0, $1dnxO.getIsNav4Enabled)()
            };
        });
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: {
                ...(0, $78QFu.getUniquePageLoadId)(),
                ...attributes,
                ...this.getFeatureGateAttributes()
            }
        };
        if (onStart) this.onStop = onStart(startEvent);
        (0, $9cb197567841b4e3$export$40336562f0f00c2a)().subscribe(name, (time)=>{
            this.freezeTime += time;
        });
    }
}




var $7v9li = parcelRequire("7v9li");


var $949zl = parcelRequire("949zl");





var $amL1s = parcelRequire("amL1s");

function $1061b47f4cb3b15f$var$getExperienceStopReason(error) {
    // message text check is a stop-gap measure due to re-packaging of errors. refactoring is underway.
    if ((0, $lbti1.containsSessionExpiredError)(error)) return `Aborted because of session expiration error: ${error.toString()}`;
    if ((0, $6fil2.containsNetworkError)(error)) return `Aborted because of network error: ${error.toString()}`;
    return undefined;
}
class $1061b47f4cb3b15f$export$12b6b072930fd68f {
    start({ name: name, id: id = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))(), timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        // Do not restart an experience that has the same id and is still running
        if (current && current.id === id && !current.hasStopped) return;
        // Before replacing a current experience, abort it to ensure it is cleaned up.
        if (current && !current.hasStopped) current.abort({
            reason: 'Aborted because the same experience was started with a new id',
            attributes: {
                newTaskId: id
            }
        });
        const experience = new (0, $2b8b14878b3a8327$export$c90b54e658fc4d7c)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes, publishDebugPoints: publishDebugPoints }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes, publishDebugPoints);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout, publishDebugPoints: publishDebugPoints }) {
        Object.values(this.experiences).forEach((experience)=>{
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes,
                publishDebugPoints: publishDebugPoints
            });
        });
    }
    stopOnError({ error: error, name: name, attributes: attributes }) {
        const reason = $1061b47f4cb3b15f$var$getExperienceStopReason(error);
        if (reason) {
            this.abort({
                name: name,
                reason: reason,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    getExperienceState(experienceName) {
        return this.experiences[experienceName] ? this.experiences[experienceName].getState() : null;
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    attachDebugPoint({ name: name, message: message, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.attachDebugPoint(message, attributes);
    }
    emit(event) {
        this.logger.debug`${event.action} ${event}`;
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {
                this.logger.error`Error occurred in ExperienceTracker subscriber ${e} when handling event ${event}`;
            }
        });
    }
    constructor(){
        this.experiences = {};
        this.subscribers = [];
        this.logger = (0, $7W8i8.getLogger)('ExperienceTracker');
        (0, $9cb197567841b4e3$export$40336562f0f00c2a)().start();
        if (typeof window !== 'undefined') window.addEventListener('pagehide', ()=>{
            const livePageEditExperienceName = (0, $amL1s.getLivePageEditExperienceName)();
            const livePageEditExperienceState = this.getExperienceState(livePageEditExperienceName);
            const livePageSessionExperienceState = this.getExperienceState((0, $irVI7.LIVE_PAGE_SESSION_EXPERIENCE));
            const experiencesToSucceed = [
                {
                    name: livePageEditExperienceName,
                    successCondition: livePageEditExperienceState && !livePageEditExperienceState.hasStopped && livePageEditExperienceState.attributes?.isLivePage
                },
                {
                    name: (0, $irVI7.EDIT_PAGE_EXPERIENCE),
                    successCondition: (0, $7v9li.hasHealthyRunningEditPageExperience)()
                },
                {
                    name: (0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE),
                    successCondition: (0, $949zl.hasHealthyRunningViewPageExperience)()
                },
                {
                    name: (0, $irVI7.LIVE_PAGE_SESSION_EXPERIENCE),
                    successCondition: livePageSessionExperienceState && !livePageSessionExperienceState.hasStopped
                }
            ];
            experiencesToSucceed.forEach(({ name: name, successCondition: successCondition })=>{
                if (successCondition) this.succeed({
                    name: name
                });
            });
            // Abort the rest of our experiences.
            this.abort({
                reason: 'Window unloading'
            });
        });
    }
}
module.exports["ExperienceTracker"] = $1061b47f4cb3b15f$export$12b6b072930fd68f;

});

parcelRegister("1dnxO", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $9hcBu = parcelRequire("9hcBu");


var $deyhs = parcelRequire("deyhs");


var $iuIEr = parcelRequire("iuIEr");

const $a8a6b891166fd1bc$export$2af1f7a69c1ab0ad = ()=>{
    const currentGAPhase = (0, $deyhs.getNav4GAPhase)();
    if (currentGAPhase === 2) return true;
    if ((0, $9hcBu.getNav4OptOutCache)()) return false;
    return(// checks both site opt-in and admin only opt-in
    (0, $9wGTI.fg)('confluence_nav_4') || (0, $6mKj3.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false) || currentGAPhase === 1 && ((0, $iuIEr.getNav4AdminOptInCache)() || (0, $9hcBu.getNav4GAOptInCache)()));
};
module.exports["getIsNav4Enabled"] = $a8a6b891166fd1bc$export$2af1f7a69c1ab0ad;

});

parcelRegister("1KmJq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7hXu9 = parcelRequire("7hXu9");


var $9x4nt = parcelRequire("9x4nt");


var $kH7bh = parcelRequire("kH7bh");

const $1f2fbbafdbe2bc31$export$609860bf8b0084c = (...args)=>{
    const ufoContext = (0, $42omo.useContext)((0, $9x4nt.default));
    const apolloResult = (0, $7hXu9.useMutation)(...args);
    const [query] = args;
    const operationName = (0, $kH7bh.default)(query);
    const isLoading = apolloResult?.[1]?.loading;
    (0, $42omo.useEffect)(()=>{
        if (isLoading) return ufoContext?.hold(operationName);
    }, [
        isLoading,
        operationName,
        ufoContext
    ]);
    return apolloResult;
};
module.exports["useMutation"] = $1f2fbbafdbe2bc31$export$609860bf8b0084c;

});

parcelRegister("7hXu9", function(module, exports) {

var $3sW76 = parcelRequire("3sW76");


var $hXuPC = parcelRequire("hXuPC");


var $42omo = parcelRequire("42omo");


var $9wEpK = parcelRequire("9wEpK");


var $b3YTN = parcelRequire("b3YTN");


var $7RTAm = parcelRequire("7RTAm");

var $54e8437b56dccdb0$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $b3YTN.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $7RTAm.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $3sW76.parser)(document);
        var requiredOperationName = (0, $3sW76.operationName)(type);
        var usedOperationName = (0, $3sW76.operationName)(operation.type);
        (0, $7RTAm.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $54e8437b56dccdb0$var$QueryData = function(_super) {
    (0, $hXuPC.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $9wEpK.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $9wEpK.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $3sW76.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $hXuPC.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $b3YTN.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $b3YTN.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $b3YTN.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $9wEpK.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $9wEpK.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $b3YTN.equal)(this.previousOptions.query, query) && (0, $b3YTN.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($54e8437b56dccdb0$var$OperationData);
function $54e8437b56dccdb0$var$useDeepMemo(memoFn, key) {
    var ref = (0, $42omo.useRef)();
    if (!ref.current || !(0, $b3YTN.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $54e8437b56dccdb0$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $42omo.useContext)((0, $3sW76.getApolloContext)());
    var _a = (0, $42omo.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $42omo.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $54e8437b56dccdb0$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $54e8437b56dccdb0$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $42omo.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $42omo.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $54e8437b56dccdb0$export$dd0a697e1782aedd(query, options) {
    return $54e8437b56dccdb0$var$useBaseQuery(query, options, false);
}
function $54e8437b56dccdb0$export$fd83eea6ecd2d8fa(query, options) {
    return $54e8437b56dccdb0$var$useBaseQuery(query, options, true);
}
var $54e8437b56dccdb0$var$MutationData = function(_super) {
    (0, $hXuPC.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $3sW76.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $3sW76.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $hXuPC.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $hXuPC.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $9wEpK.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $b3YTN.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($54e8437b56dccdb0$var$OperationData);
function $54e8437b56dccdb0$export$609860bf8b0084c(mutation, options) {
    var context = (0, $42omo.useContext)((0, $3sW76.getApolloContext)());
    var _a = (0, $42omo.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $42omo.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $54e8437b56dccdb0$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $42omo.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $54e8437b56dccdb0$var$SubscriptionData = function(_super) {
    (0, $hXuPC.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $b3YTN.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($54e8437b56dccdb0$var$OperationData);
function $54e8437b56dccdb0$export$368b4214baeb914c(subscription, options) {
    var context = (0, $42omo.useContext)((0, $3sW76.getApolloContext)());
    var updatedOptions = options ? (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $42omo.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $42omo.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $54e8437b56dccdb0$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $42omo.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $42omo.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $54e8437b56dccdb0$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3sW76.getApolloContext)()).client;
    (0, $7RTAm.invariant)(client, 1);
    return client;
}
function $54e8437b56dccdb0$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $54e8437b56dccdb0$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $54e8437b56dccdb0$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();
module.exports["useQuery"] = $54e8437b56dccdb0$export$dd0a697e1782aedd;
module.exports["useLazyQuery"] = $54e8437b56dccdb0$export$fd83eea6ecd2d8fa;
module.exports["useMutation"] = $54e8437b56dccdb0$export$609860bf8b0084c;
module.exports["useSubscription"] = $54e8437b56dccdb0$export$368b4214baeb914c;
module.exports["useApolloClient"] = $54e8437b56dccdb0$export$eb9a56e7a29e494;

});

parcelRegister("inPa6", function(module, exports) {

var $hQK66 = parcelRequire("hQK66");


var $6v6KC = parcelRequire("6v6KC");


var $fFVny = parcelRequire("fFVny");

function $f1cee2cc4b3c9808$export$5bf35293e545f20c() {
    const analyticsContext = (0, $fFVny.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $hQK66.useCallbackOne)((payload)=>{
        return new (0, $6v6KC.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}
module.exports["useAnalyticsEvents"] = $f1cee2cc4b3c9808$export$5bf35293e545f20c;

});

parcelRegister("hQK66", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $cfeb0d01c0bbd32a$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $cfeb0d01c0bbd32a$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $42omo.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $42omo.useRef)(true);
    var committed = (0, $42omo.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $cfeb0d01c0bbd32a$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $42omo.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $cfeb0d01c0bbd32a$export$33752cf3ee811995(callback, inputs) {
    return $cfeb0d01c0bbd32a$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $cfeb0d01c0bbd32a$export$1538c33de8887b59 = $cfeb0d01c0bbd32a$export$b6feb8998cd9b342;
var $cfeb0d01c0bbd32a$export$35808ee640e87ca7 = $cfeb0d01c0bbd32a$export$33752cf3ee811995;
module.exports["useMemoOne"] = $cfeb0d01c0bbd32a$export$b6feb8998cd9b342;
module.exports["useCallbackOne"] = $cfeb0d01c0bbd32a$export$33752cf3ee811995;

});

parcelRegister("6v6KC", function(module, exports) {
/// <reference types="node" />

var $feHMU = parcelRequire("feHMU");

const $e874e3d2f5965fb8$export$35f8383928ba8d7 = (obj)=>obj instanceof $e874e3d2f5965fb8$export$2e2bcd8739ae039 || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';
class $e874e3d2f5965fb8$export$2e2bcd8739ae039 extends (0, $feHMU.default) {
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
    constructor(props){
        super(props);
        this.context = void 0;
        this.handlers = void 0;
        this.hasFired = void 0;
        this._isUIAnalyticsEvent = true;
        this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ const payload = JSON.parse(JSON.stringify(this.payload));
            return new $e874e3d2f5965fb8$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        };
        this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>handler(this, channel));
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
}
module.exports["isUIAnalyticsEvent"] = $e874e3d2f5965fb8$export$35f8383928ba8d7;
module.exports["default"] = $e874e3d2f5965fb8$export$2e2bcd8739ae039;

});

parcelRegister("2xIMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $1da166296fbcbaa2$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

const $7566ec9ad7909d38$var$AnalyticsNextContext = (0, $42omo.createContext)({
    getAtlaskitAnalyticsContext: ()=>[],
    getAtlaskitAnalyticsEventHandlers: ()=>[]
});
var $7566ec9ad7909d38$export$2e2bcd8739ae039 = $7566ec9ad7909d38$var$AnalyticsNextContext;


var $1da166296fbcbaa2$export$2e2bcd8739ae039 = (0, $7566ec9ad7909d38$export$2e2bcd8739ae039);

});

parcelRegister("jtuBN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wEpK = parcelRequire("9wEpK");


var $86okN = parcelRequire("86okN");

const $f25e6fd2c736a9df$var$queryResults = new WeakMap();
function $f25e6fd2c736a9df$export$33c3a40e92be94b0(query, options) {
    query = (0, $86okN.toDocumentNode)(query);
    const client = options?.client ?? window['GLOBAL_APOLLO_CLIENT'];
    let dataFromCache = null;
    try {
        if (!options?.skip) dataFromCache = client.readQuery({
            query: query,
            ...options
        });
    } catch  {}
    const [result, setResult] = (0, $42omo.useState)(()=>{
        return dataFromCache ? {
            data: dataFromCache,
            loading: false,
            networkStatus: (0, $9wEpK.NetworkStatus).ready
        } : {
            data: null,
            loading: true,
            networkStatus: (0, $9wEpK.NetworkStatus).loading
        };
    });
    (0, $42omo.useEffect)(()=>{
        if (result.loading && !options?.skip) {
            // technically not a hash but it's good enough since variable is an plain object.
            const variablesHash = JSON.stringify(options?.variables || {});
            // Same query + variable should reuse the same promise to avoid going through expensive Apollo client.
            let queryResultPromise;
            if ($f25e6fd2c736a9df$var$queryResults.has(query) && $f25e6fd2c736a9df$var$queryResults.get(query).has(variablesHash)) queryResultPromise = $f25e6fd2c736a9df$var$queryResults.get(query)?.get(variablesHash);
            else {
                queryResultPromise = client.query({
                    query: query,
                    ...options
                });
                if (!$f25e6fd2c736a9df$var$queryResults.has(query)) $f25e6fd2c736a9df$var$queryResults.set(query, new Map());
                $f25e6fd2c736a9df$var$queryResults.get(query).set(variablesHash, queryResultPromise);
            }
            queryResultPromise.then((result)=>setResult(result)).catch((e)=>{
                setResult({
                    ...result,
                    loading: false,
                    networkStatus: (0, $9wEpK.NetworkStatus).ready,
                    error: e
                });
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return result;
}
module.exports["useQueryNoFurtherUpdateInterop"] = $f25e6fd2c736a9df$export$33c3a40e92be94b0;

});

parcelRegister("86okN", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

function $4081b4bcd817239f$export$7c1c2f97801b533e(graphqlTaggedNode) {
    if (typeof graphqlTaggedNode === 'string') // For backwards-compatibility only; that's why `string` is not specified as an accepted argument type
    return (0, $eSUdr.default)(graphqlTaggedNode);
    if ('kind' in graphqlTaggedNode && 'definitions' in graphqlTaggedNode) return graphqlTaggedNode;
    if (!('params' in graphqlTaggedNode)) throw new Error('[Relay Migration] unsupported tagged node provided. Please make sure you generated Relay artifacts for your operation');
    const operationText = graphqlTaggedNode.params.text;
    if (!operationText) throw new Error('[Relay Migration] The provided `ConcreteRequest` did not specify `params.text` properties that is required for Apollo deprecation. Make sure you keep the `persiste: { includeQueryText: true }` Relay compiler configuration option ');
    return (0, $eSUdr.default)(graphqlTaggedNode.params.text);
}
module.exports["toDocumentNode"] = $4081b4bcd817239f$export$7c1c2f97801b533e;

});

parcelRegister("bQm3c", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $f7i8j = parcelRequire("f7i8j");

const $f754a96b8722739c$export$3571dffcff931902 = ()=>(0, $42omo.useContext)((0, $f7i8j.SessionDataContext));
module.exports["useSessionData"] = $f754a96b8722739c$export$3571dffcff931902;

});

parcelRegister("f7i8j", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $651dccbfa84cc225$export$47bf0d5265bb1324 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(// The app should not be making use of `SessionDataContext` until it's loaded.
// It *should* be safe to assert the presence of SessionData by this point.
undefined);
$651dccbfa84cc225$export$47bf0d5265bb1324.displayName = 'SessionDataContext';
module.exports["SessionDataContext"] = $651dccbfa84cc225$export$47bf0d5265bb1324;

});

parcelRegister("d9tcB", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});
module.exports["AccessStatus"] = $adbc8f20ade62008$export$9d38595f26d62a61;
module.exports["ConfluenceEdition"] = $adbc8f20ade62008$export$68577d543b14ae02;

});

parcelRegister("deyhs", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $ae73c93d192e1e2d$export$827babb08d748504 = ()=>{
    if ((0, $9wGTI.fg)('confluence_nav4_ga_phase_2')) return 2;
    if ((0, $9wGTI.fg)('confluence_nav4_ga_phase_1')) return 1;
    return 0;
};
module.exports["getNav4GAPhase"] = $ae73c93d192e1e2d$export$827babb08d748504;

});

parcelRegister("2KpT3", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $7W8i8 = parcelRequire("7W8i8");

class $74ab39b5aaac21ba$export$a00c080e726db0b {
    initialize() {
        if (typeof document === 'undefined') return {
            teardown: ()=>{}
        };
        if (document.hidden) // if the tab is active, `onVisibilityChange` will result in invariant violation
        this.onVisibilityChange();
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        return {
            teardown: ()=>{
                document.removeEventListener('visibilitychange', this.onVisibilityChange);
            }
        };
    }
    getInactiveMillisecondsSince(timestamp) {
        let inactivityDuration = 0;
        // for-loop will allow us to perform an early exit
        for (const [start, end] of this.inactivityIntervals){
            // cases:
            // - timestamp < start     < end        : Relevant
            // - start     < timestamp < end        : Relevant
            // - start     < timestamp ; end=null   : Relevant
            // - start     < end       < timestamp  : Irrelevant
            const inactivityEnd = end || window.performance.now();
            if (timestamp > inactivityEnd) break;
            inactivityDuration += inactivityEnd - Math.max(start, timestamp);
        }
        return inactivityDuration;
    }
    constructor({ maxIntervalsToStore: maxIntervalsToStore } = {}){
        /**
     * Stores intervals in reverse order (that is, latest interval will be the first item in the array).
     * The items in this array are tuples of [intervalStartTimestamp, intervalEndTimestamp].
     * If `intervalEndTimestamp` is `null`, that means that tab is still inactive.
     * Example value (number would actually be timestamps, but they are exemplified differently for ease of understanding):
     * ```js
     * // if the tab is currently active, but was hidden before
     * [ [500, 600], [300, 400], [100, 200] ]
     *
     * // while the tab is still inactive
     * [ [500, null], [100, 200] ]
     *
     * // if the tab has never been hidden
     * [ ]
     * ```
     */ this.inactivityIntervals = [];
        this.logger = (0, $7W8i8.getLogger)('TabInactivityTracker');
        // in order to not increase memory footprint indefinitely, we'll cap the maximum amount of items
        this.maxIntervalsToStore = void 0;
        this.onVisibilityChange = ()=>{
            if (!document.hidden) {
                // we were inactive before, which means that there is an "unfinished" interval
                // we'll finish it after verifying invariants
                if (this.inactivityIntervals.length === 0 || this.inactivityIntervals[0][1] != null) this.logger.error`Invariant violation: tab is currently active, but inactivity intervals are in inconsistent state`;
                else this.inactivityIntervals[0][1] = window.performance.now();
            } else {
                if (this.inactivityIntervals.length >= this.maxIntervalsToStore) // we're about to add a new interval; but we're also at max array capacity, so we'll
                // intentionally lose the most dated items in the array in the hope that they won't be needed anymore.
                this.inactivityIntervals.splice(this.maxIntervalsToStore - 1);
                // tab just became inactive; we'll create a new "unfinished" interval
                this.inactivityIntervals.unshift([
                    window.performance.now(),
                    null
                ]);
            }
        };
        const DEFAULT_MAX_INTERVALS_TO_STORE = 100;
        this.maxIntervalsToStore = typeof maxIntervalsToStore === 'number' ? maxIntervalsToStore : DEFAULT_MAX_INTERVALS_TO_STORE;
    }
}
const $74ab39b5aaac21ba$export$39c3eb20723b04b = (0, $2XqLN.default)(()=>{
    const tracker = new $74ab39b5aaac21ba$export$a00c080e726db0b();
    tracker.initialize();
    return tracker;
});
module.exports["getTabInactivityTracker"] = $74ab39b5aaac21ba$export$39c3eb20723b04b;

});

parcelRegister("7v9li", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $gykrH = parcelRequire("gykrH");


var $fGzMp = parcelRequire("fGzMp");

const $76d2f84cb77df08d$var$EDIT_PAGE_SUBEXPERIENCES = [
    (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE),
    (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE),
    (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE)
];
const $76d2f84cb77df08d$var$COMPANY_HUB_EDITOR_SUBEXPERIENCES = [
    (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE),
    (0, $irVI7.COMPANY_HUB_EDITOR_CLOSE_EXPERIENCE),
    (0, $irVI7.FRONT_COVER_PUBLISH_EXPERIENCE)
];
const $76d2f84cb77df08d$export$b4cbec267823a12e = ()=>{
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_AND_EDIT_PAGE_EXPERIENCE),
        collect: $76d2f84cb77df08d$export$bb44f104e3c54dae
    });
};
const $76d2f84cb77df08d$export$bb44f104e3c54dae = (events, experience)=>{
    experience.stopOn($76d2f84cb77df08d$export$e2067cc0ba855137(events, 'taskSuccess'));
    experience.stopOn($76d2f84cb77df08d$export$e2067cc0ba855137(events, 'taskFail'));
};
const $76d2f84cb77df08d$export$e2067cc0ba855137 = (events, action)=>{
    return events.find((event)=>event.action === action && (0, $gykrH.hasName)(event, (0, $irVI7.EDIT_PAGE_EXPERIENCE)));
};
const $76d2f84cb77df08d$export$2b69dcd5daaf6a2c = ()=>{
    const tracker = (0, $fGzMp.getExperienceTracker)();
    const editPageExperienceState = tracker.getExperienceState((0, $irVI7.EDIT_PAGE_EXPERIENCE));
    const isEditPageRunning = editPageExperienceState && !editPageExperienceState.hasStopped;
    if (!isEditPageRunning) return false;
    // Validate all subexperiences are healthy. If any experience is unhealthy, `every` will immediately return false, otherwise true
    return $76d2f84cb77df08d$var$EDIT_PAGE_SUBEXPERIENCES.every((subexperience)=>{
        const subexperienceState = tracker.getExperienceState(subexperience);
        // Subexperience has not run, so edit-page is still healthy
        if (!subexperienceState) return true;
        // Subexperience has not run for current edit-page's contentId, so edit-page is still healthy
        if (subexperienceState.attributes?.contentId !== editPageExperienceState.attributes?.contentId) return true;
        // Subexperience has run and has finished successfully, so edit-page is still healthy
        if (subexperienceState.stopState === 'taskSuccess') return true;
        // Subexperience has run and has not finished successfully, so edit-page is unhealthy
        return false;
    });
};
const $76d2f84cb77df08d$export$c15dc70f74e1c751 = ()=>{
    const tracker = (0, $fGzMp.getExperienceTracker)();
    const hubEditorExperienceState = tracker.getExperienceState((0, $irVI7.COMPANY_HUB_EDITOR_EXPERIENCE));
    const isHubEditorRunning = hubEditorExperienceState && !hubEditorExperienceState.hasStopped;
    if (!isHubEditorRunning) return false;
    // Validate all subexperiences are healthy. If any experience is unhealthy, `every` will immediately return false, otherwise true
    return $76d2f84cb77df08d$var$COMPANY_HUB_EDITOR_SUBEXPERIENCES.every((subexperience)=>{
        const subexperienceState = tracker.getExperienceState(subexperience);
        // Subexperience has not run, so hub editor experience is still healthy
        if (!subexperienceState) return true;
        // Subexperience has run and has finished successfully, so hub editor experience is still healthy
        if (subexperienceState.stopState === 'taskSuccess') return true;
        // Subexperience has run and has not finished successfully, so hub editor experience is unhealthy
        return false;
    });
};
module.exports["startCreateAndEditPage"] = $76d2f84cb77df08d$export$b4cbec267823a12e;
module.exports["hasHealthyRunningEditPageExperience"] = $76d2f84cb77df08d$export$2b69dcd5daaf6a2c;
module.exports["hasHealthyRunningCompanyHubEditExperience"] = $76d2f84cb77df08d$export$c15dc70f74e1c751;

});

parcelRegister("gykrH", function(module, exports) {
const $69558f20f281edc8$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $69558f20f281edc8$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);
const $69558f20f281edc8$export$7895096fcdde5712 = (event, key, value)=>Boolean(event.attributes?.hasOwnProperty(key) && event.attributes[key] === value);
module.exports["isStop"] = $69558f20f281edc8$export$16e3f1b03b231b35;
module.exports["hasName"] = $69558f20f281edc8$export$57069f5b2ecc9128;
module.exports["hasAttribute"] = $69558f20f281edc8$export$7895096fcdde5712;

});

parcelRegister("949zl", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");

// eslint-disable-next-line import/no-cycle

var $fGzMp = parcelRequire("fGzMp");

const $1d28c59b5f724925$export$11699410c9e76883 = ({ parentExperience: parentExperience, subExperiences: subExperiences })=>{
    const tracker = (0, $fGzMp.getExperienceTracker)();
    const parentExperienceState = tracker.getExperienceState(parentExperience);
    const isParentExperienceRunning = parentExperienceState && !parentExperienceState.hasStopped;
    if (!isParentExperienceRunning) return false;
    const parentExperienceContentId = String(parentExperienceState.attributes?.contentId);
    return $1d28c59b5f724925$var$areSubExperiencesHealthy({
        parentExperienceContentId: parentExperienceContentId,
        subExperiences: subExperiences
    });
};
const $1d28c59b5f724925$var$areSubExperiencesHealthy = ({ parentExperienceContentId: parentExperienceContentId, subExperiences: subExperiences = [] })=>{
    const tracker = (0, $fGzMp.getExperienceTracker)();
    // Validate all subExperiences are healthy. If any experience is unhealthy, `every` will immediately return false, otherwise true
    return subExperiences.every((subExperience)=>{
        const subExperienceState = tracker.getExperienceState(subExperience);
        // Subexperience has not run, so parent is still healthy
        if (!subExperienceState) return true;
        // Subexperience has not run for current parentExperience's contentId, so parentExperience is still healthy
        const isSubExperienceForDifferentContent = parentExperienceContentId !== subExperienceState.attributes?.contentId;
        if (isSubExperienceForDifferentContent) return true;
        const hasSubExperienceCompletedSuccessfully = subExperienceState.stopState === 'taskSuccess';
        if (hasSubExperienceCompletedSuccessfully) return true;
        // Subexperience has run and has not finished successfully, so parentExperience is unhealthy
        return false;
    });
};


const $dc61e055cb121158$export$77dd5573732a240c = ()=>(0, $1d28c59b5f724925$export$11699410c9e76883)({
        parentExperience: (0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE),
        subExperiences: [
            (0, $irVI7.VIEW_PAGE_EXPERIENCE)
        ]
    });
const $dc61e055cb121158$export$41f7b734fb3e4a50 = ({ id: id, tracker: tracker, attributes: attributes, startTime: startTime })=>{
    tracker.start({
        name: (0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE),
        id: id,
        startTime: startTime,
        attributes: attributes,
        collect: (events, experience)=>{
            const viewExperienceLoadingFailed = events.find(({ action: action, name: name })=>action === 'taskFail' && name === (0, $irVI7.VIEW_PAGE_EXPERIENCE));
            const viewExperienceLoadingAborted = events.find(({ action: action, name: name })=>action === 'taskAbort' && name === (0, $irVI7.VIEW_PAGE_EXPERIENCE));
            if (viewExperienceLoadingFailed) experience.fail({
                error: new Error('View page load experience failed')
            });
            else if (viewExperienceLoadingAborted) experience.abort({
                reason: 'View page load experience aborted'
            });
        }
    });
};
module.exports["hasHealthyRunningViewPageExperience"] = $dc61e055cb121158$export$77dd5573732a240c;
module.exports["startViewPageSessionExperience"] = $dc61e055cb121158$export$41f7b734fb3e4a50;

});

parcelRegister("amL1s", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");

const $cb18db7a80e4108b$export$fc45374fcefeb0f1 = (0, $2XqLN.default)(()=>{
    return (0, $9wGTI.fg)('live_page_exp_to_core_exp_migration') ? (0, $irVI7.VIEW_PAGE_EXPERIENCE) : (0, $irVI7.LIVE_PAGE_VIEW_EXPERIENCE);
});
const $cb18db7a80e4108b$export$44bb710761a63941 = (0, $2XqLN.default)(()=>{
    return (0, $9wGTI.fg)('live_page_exp_to_core_exp_migration') ? (0, $irVI7.EDIT_PAGE_EXPERIENCE) : (0, $irVI7.LIVE_PAGE_EDIT_EXPERIENCE);
});
module.exports["getLivePageViewExperienceName"] = $cb18db7a80e4108b$export$fc45374fcefeb0f1;
module.exports["getLivePageEditExperienceName"] = $cb18db7a80e4108b$export$44bb710761a63941;

});

parcelRegister("a4TK8", function(module, exports) {

var $cndcq = parcelRequire("cndcq");

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $756584857e6366b9$var$isEqual(value, other) {
    return $cndcq(value, other);
}
module.exports = $756584857e6366b9$var$isEqual;

});

parcelRegister("1z9oK", function(module, exports) {
$parcel$export(module.exports, "getClientStream", () => (parcelRequire("dr1zO")).getClientStream);

var $dr1zO = parcelRequire("dr1zO");


});

parcelRegister("75Obx", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $iRjkT = parcelRequire("iRjkT");


var $jcne3 = parcelRequire("jcne3");


var $2l40N = parcelRequire("2l40N");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $529fedb95dbeafef$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $529fedb95dbeafef$var$getSymbolsIn = !$529fedb95dbeafef$var$nativeGetSymbols ? $2l40N : function(object) {
    var result = [];
    while(object){
        $hwwIB(result, $jcne3(object));
        object = $iRjkT(object);
    }
    return result;
};
module.exports = $529fedb95dbeafef$var$getSymbolsIn;

});

parcelRegister("jHiyU", function(module, exports) {

var $dJQeL = parcelRequire("dJQeL");


var $75Obx = parcelRequire("75Obx");


var $jVTxf = parcelRequire("jVTxf");

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e5706e8341b39dd4$var$getAllKeysIn(object) {
    return $dJQeL(object, $jVTxf, $75Obx);
}
module.exports = $e5706e8341b39dd4$var$getAllKeysIn;

});

parcelRegister("apAFY", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $7948b04487479f33$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $7948b04487479f33$var$last;

});

parcelRegister("3BqCC", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $29f97a5542d2ea0f$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $29f97a5542d2ea0f$var$baseSlice;

});

parcelRegister("gKr8t", function(module, exports) {

var $9wEpK = parcelRequire("9wEpK");


var $5v4fk = parcelRequire("5v4fk");


var $guZe9 = parcelRequire("guZe9");


var $jxz2A = parcelRequire("jxz2A");


var $jWs8F = parcelRequire("jWs8F");


var $gTOUc = parcelRequire("gTOUc");


var $9wGTI = parcelRequire("9wGTI");

var $77186562fbe5696a$exports = {};
$77186562fbe5696a$exports = JSON.parse("[{\"possibleTypes\":[{\"name\":\"SearchConfluencePageBlogAttachment\"},{\"name\":\"SearchConfluenceSpace\"}],\"kind\":\"INTERFACE\",\"name\":\"SearchResult\"},{\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"ConfluenceBlogPost\"}],\"kind\":\"UNION\",\"name\":\"SearchConfluenceEntity\"},{\"possibleTypes\":[{\"name\":\"AppUser\"},{\"name\":\"AtlassianAccountUser\"},{\"name\":\"CustomerUser\"}],\"kind\":\"INTERFACE\",\"name\":\"User\"},{\"possibleTypes\":[{\"name\":\"InvokeAuxEffectsResponse\"},{\"name\":\"InvokeExtensionResponse\"}],\"kind\":\"INTERFACE\",\"name\":\"Payload\"}]");



var $9jPdT = parcelRequire("9jPdT");




var $iMHGI = parcelRequire("iMHGI");


var $bKqeQ = parcelRequire("bKqeQ");


var $jLTuK = parcelRequire("jLTuK");


var $lB1H3 = parcelRequire("lB1H3");








var $04e9M = parcelRequire("04e9M");

/**
 * This will be removed in favour of @confluence/relay-network/src/getInternetConnectionState.ts when we move to Relay.
 */ // partially copied from Trello modified to use confluences network check
const $3d23f6bbdf409903$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};


/**
 * This will be removed in favour of @confluence/relay-network/src/getBackOffDelay.ts when we move to Relay.
 */ // copied from Trello
/**
 * This will be removed in favour of @confluence/relay-network/src/calculateBackOffRange.ts when we move to Relay.
 */ // copied from Trello
/**
 * This will be removed in favour of @confluence/relay-network/src/backOffConfig.ts when we move to Relay.
 */ // copied from Trello
const $0b8d464841156fc9$var$TEN_MINUTES_IN_MS = 600000;
const $0b8d464841156fc9$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $0b8d464841156fc9$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $0b8d464841156fc9$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $0b8d464841156fc9$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};


function $35212ac5bc2e900f$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $0b8d464841156fc9$export$e5680a2329370bd3)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $0b8d464841156fc9$export$d89658363be37383)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $0b8d464841156fc9$export$1b131e77a0e75a0a)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $0b8d464841156fc9$export$a1d6d3ff41cd93e9);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}


function $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $5a87cb4548ea235b$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $5a87cb4548ea235b$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $35212ac5bc2e900f$export$de85ae9dfb4a57bc)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};



const $fca9c472df15863c$export$e9ff5bb5c39478ed = 600000;
class $fca9c472df15863c$export$b26b2f8eae2af9a extends (0, $5v4fk.ApolloLink) {
    request(operation) {
        // Add null check for operation.getContext to prevent "Cannot read properties of undefined" errors
        const context = operation.getContext?.() || {};
        // context is coming from a previous link since we are using apollo v2
        // subscriptions does not have context or extensions in some cases
        return new (0, $jLTuK.default)((observer)=>{
            const subscription = this.client.subscribe({
                ...operation,
                query: (0, $lB1H3.print)(operation.query),
                extensions: context?.extensions
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                        client.sendOperationalEvent({
                            source: 'confluence-AGGWebSocketLink',
                            actionSubject: 'webSocket',
                            action: 'closed-socket-error',
                            attributes: {
                                reason: this.closedInfo?.reason,
                                code: this.closedInfo?.code,
                                wasClean: this.closedInfo?.wasClean
                            }
                        });
                    });
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $9wEpK.ApolloError)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
            // keep track of the subscription so we can unsubscribe later
            this.replayQueries[operation.operationName] = {
                unsubscribe: subscription,
                query: (0, $lB1H3.print)(operation.query)
            };
            return subscription;
        });
    }
    constructor(options){
        super();
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $3d23f6bbdf409903$export$ddfffe3f5c167fa6)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $5a87cb4548ea235b$export$ac8ba6656a385f56)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $5a87cb4548ea235b$export$73e02b3a26ecb0d7)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $35212ac5bc2e900f$export$de85ae9dfb4a57bc)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $5a87cb4548ea235b$export$73e02b3a26ecb0d7)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        if ((0, $9wGTI.fg)('confluence_enable_agg_subscription_link_replay')) {
                            // unsubscribe so that we can reconnect with new arguments
                            for(const key in this.replayQueries)// when this gate is enabled it unsubscribes queries so that we can reconnect
                            // with new arguments
                            if (this.replayQueries[key]) {
                                this.replayQueries[key].unsubscribe();
                                delete this.replayQueries[key];
                            }
                            this.client.terminate();
                        }
                    }, $fca9c472df15863c$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}


function $aa9065bb91596100$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
let $aa9065bb91596100$var$wsLink;
function $aa9065bb91596100$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $aa9065bb91596100$export$91893b414ff080f2();
    if (!$aa9065bb91596100$var$wsLink) $aa9065bb91596100$var$wsLink = new (0, $fca9c472df15863c$export$b26b2f8eae2af9a)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $fca9c472df15863c$export$e9ff5bb5c39478ed),
        retryAttempts: 5
    });
    return $aa9065bb91596100$var$wsLink;
}








const $eb414ef0fc36a486$export$51a2bb897a605125 = new (0, $5v4fk.ApolloLink)((operation, forward)=>{
    if (operation.variables && operation.variables.__extensions && (0, $9wGTI.fg)('confluence_enable_agg_subscription_link_replay')) {
        operation.setContext({
            extensions: operation.variables.__extensions
        });
        // remove the property since it's not an actual valid variable
        delete operation.variables.__extensions;
    }
    return forward(operation);
});




var $11MAl = parcelRequire("11MAl");

let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)(true);
const $6d0c6b833ab477dd$export$ed315e0c0d70f648 = 'agg';
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $jWs8F.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($77186562fbe5696a$exports)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $jWs8F.InMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.GLOBAL_APOLLO_AGG_CLIENT = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    if (!(0, $9wGTI.fg)('confluence_ufo_remove_network_graphql_timings')) links.push((0, $gTOUc.UFOLoggerLink));
    links.push((0, $11MAl.SSRClientLink)($6d0c6b833ab477dd$export$ed315e0c0d70f648, $6d0c6b833ab477dd$export$8ddb56c88a6a3feb));
    subscriptionLinks.push((0, $eb414ef0fc36a486$export$51a2bb897a605125));
    subscriptionLinks.push((0, $aa9065bb91596100$export$4b71fe053d09625a)());
    links.push(new (0, $jxz2A.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $5v4fk.split)(// Condition for handling subscriptions
    // we don't want to use subscriptions in SSR mode
    ({ query: query })=>{
        if ((0, $9wGTI.fg)('confluence_enable_agg_subscription_link')) {
            const definition = (0, $guZe9.getMainDefinition)(query);
            return definition?.kind === 'OperationDefinition' && definition?.operation === 'subscription' && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            !Boolean(undefined);
        } else return false;
    }, // WebSocket link for subscriptions
    (0, $5v4fk.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $5v4fk.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $9wEpK.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $5v4fk.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};
module.exports["getAGGClient"] = $6d0c6b833ab477dd$export$13fdb03e350a572c;

});

parcelRegister("6acb5", function(module, exports) {
function $47cd1f7c9e5f34cf$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports["_"] = $47cd1f7c9e5f34cf$export$71511d61b312f219;

});

parcelRegister("ezH4I", function(module, exports) {

var $l3KBO = parcelRequire("l3KBO");


var $398ES = parcelRequire("398ES");

// Fix case for <p><span><marker start><span></p><marker end>
// Increase the depth needed if found other cases
const $4b3ec0821606f7ca$var$MAX_MOVE_UP_LEVEL_FOR_BEGIN_MARKER = 2;
const $4b3ec0821606f7ca$var$serverMarkup = new Map();
const $4b3ec0821606f7ca$var$serverMarkupIndexMap = new Map();
const $4b3ec0821606f7ca$var$serverMarkupCollected = new Set();
const $4b3ec0821606f7ca$var$refToOriginalElement = new WeakMap();
const $4b3ec0821606f7ca$export$18e9263e8e05fc3 = 10000; // 10s
const $4b3ec0821606f7ca$var$dataLoadableBeginRegex = /data-loadable-begin="([^"]*)"/;
const $4b3ec0821606f7ca$var$dataLoadableEndRegex = /data-loadable-end="([^"]*)"/;
let $4b3ec0821606f7ca$var$totalElementsToHydrate = 0;
function $4b3ec0821606f7ca$export$63934da3851c8633(el) {
    if (window?.__HYDRATABLE__) // When we doing real hydration elements are not recreated.
    // Thus stop adding the extra hidden input that can break the hydration.
    return false;
    const tagName = el.tagName.toUpperCase();
    return tagName === 'VIDEO' || tagName === 'AUDIO' || tagName === 'IMG';
}
function $4b3ec0821606f7ca$var$saveRefToOriginalElement(el, clone) {
    if (!(el instanceof Element) || !(clone instanceof Element)) return;
    // For certain node like img. Inserting a cloned node or re-creating triggers the load again.
    // This caused flickering in emoji and media image. HOT-105601
    // Here we are walking the DOM tree and keeping a map of cloned node to original node.
    // Later when creating the placeholder from SSR result we can use the original node directly.
    if ($4b3ec0821606f7ca$export$63934da3851c8633(el)) $4b3ec0821606f7ca$var$refToOriginalElement.set(clone, el);
    el.childNodes.forEach((child, i)=>{
        $4b3ec0821606f7ca$var$saveRefToOriginalElement(child, clone.childNodes[i]);
    });
}
function $4b3ec0821606f7ca$export$e2641d9526374e60(el) {
    return $4b3ec0821606f7ca$var$refToOriginalElement.get(el);
}
function $4b3ec0821606f7ca$export$c42217d53a7ebafb(fromEl, loadableId) {
    let el = fromEl;
    const nodes = [];
    while(el = el.nextSibling){
        if (el instanceof HTMLElement) {
            if (el.dataset?.loadableEnd === loadableId) break;
            if (el.dataset?.loadableBegin || el.dataset?.loadableEnd) continue;
        }
        const clone = el.cloneNode(true);
        $4b3ec0821606f7ca$var$saveRefToOriginalElement(el, clone);
        nodes.push($4b3ec0821606f7ca$var$filterMarkers(clone));
    }
    return nodes;
}
function $4b3ec0821606f7ca$export$ccab362c10c055(fromEl, loadableId) {
    let el = fromEl;
    let foundCloseMarker = false;
    const nodes = [];
    while(el = el.nextSibling){
        const match = el?.nodeValue?.match($4b3ec0821606f7ca$var$dataLoadableEndRegex);
        if (match && match[1] === loadableId) {
            foundCloseMarker = true;
            break;
        }
        if (el instanceof Element) {
            const clone = el.cloneNode(true);
            $4b3ec0821606f7ca$var$saveRefToOriginalElement(el, clone);
            nodes.push(clone);
        }
    }
    return {
        cloned: nodes,
        foundCloseMarker: foundCloseMarker
    };
}
function $4b3ec0821606f7ca$var$filterMarkers(el) {
    // Deleted node doesn't have childNodes so wait until the end
    const pendingRemove = [];
    el.childNodes.forEach((child)=>{
        if (child instanceof HTMLElement && (child.dataset?.loadableBegin || child.dataset?.loadableEnd)) pendingRemove.push(child);
        $4b3ec0821606f7ca$var$filterMarkers(child);
    });
    pendingRemove.forEach((node)=>node.remove());
    return el;
}
function $4b3ec0821606f7ca$var$findAndCollectCommentMarkers(root, findPlaceholderId) {
    const nodes = root.childNodes;
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        const nodeType = node.nodeType;
        if (nodeType === Node.COMMENT_NODE && node?.nodeValue?.includes('data-loadable-begin')) {
            const match = node.nodeValue?.match($4b3ec0821606f7ca$var$dataLoadableBeginRegex);
            if (!match) continue;
            const loadableId = match[1];
            if (findPlaceholderId && loadableId !== findPlaceholderId) continue;
            /**
			 * This is a bit messed up.
			 * In renderer there are case like <span><!-- begin -->..<div>...<!-- end --></span>
			 * This is an invalid HTML browser will correct it by closing the span tag.
			 * It ends up like <span><!-- begin --></span>..<div>...<!-- end --></div>
			 * In this case the ancestor of the begin marker should be treated as the begin marker.
			 */ let clonedElements = [];
            let beginNode = node;
            let moveUpLevelCount = 0;
            while(beginNode && moveUpLevelCount <= $4b3ec0821606f7ca$var$MAX_MOVE_UP_LEVEL_FOR_BEGIN_MARKER){
                const { cloned: cloned, foundCloseMarker: foundCloseMarker } = $4b3ec0821606f7ca$export$ccab362c10c055(beginNode, loadableId);
                if (foundCloseMarker) {
                    clonedElements = cloned;
                    break;
                } else {
                    // If we didn't find the close marker, we need to go up the tree and find the next begin marker.
                    beginNode = beginNode.parentNode;
                    moveUpLevelCount++;
                }
            }
            if (!clonedElements.length) continue;
            $4b3ec0821606f7ca$var$totalElementsToHydrate += 1;
            if ($4b3ec0821606f7ca$var$serverMarkup.has(loadableId)) $4b3ec0821606f7ca$var$serverMarkup.get(loadableId).push(clonedElements);
            else {
                $4b3ec0821606f7ca$var$serverMarkup.set(loadableId, [
                    clonedElements
                ]);
                $4b3ec0821606f7ca$var$serverMarkupIndexMap.set(loadableId, 0);
            }
        } else if (nodeType === Node.ELEMENT_NODE) $4b3ec0821606f7ca$var$findAndCollectCommentMarkers(node, findPlaceholderId);
    }
}
function $4b3ec0821606f7ca$export$c0d0f0d932478a98() {
    return $4b3ec0821606f7ca$var$serverMarkup;
}
function $4b3ec0821606f7ca$export$4bb360e7ccd41a27() {
    return $4b3ec0821606f7ca$var$serverMarkupIndexMap;
}
function $4b3ec0821606f7ca$export$84b00002df734b1f() {
    return $4b3ec0821606f7ca$var$totalElementsToHydrate;
}
function $4b3ec0821606f7ca$export$69945a3a97aa6a3f() {
    // Delay cleaning up server markups.
    // On a slower device or poor network connection, the client side rendering might not be completed,
    // server markups are still in use. Therefore, wait for ${DELAY_CLEAN_UP_SERVER_MARKUP_TIME}(10s) before clean it up.
    (0, $l3KBO.getTaskManager)().push({
        id: 'clean-up-server-markup',
        task: ()=>{
            setTimeout(()=>{
                $4b3ec0821606f7ca$var$serverMarkup.clear();
                $4b3ec0821606f7ca$var$serverMarkupIndexMap.clear();
                $4b3ec0821606f7ca$var$totalElementsToHydrate = 0;
            }, $4b3ec0821606f7ca$export$18e9263e8e05fc3);
        },
        priority: (0, $398ES.LoadingPriority).BACKGROUND
    });
}
function $4b3ec0821606f7ca$export$7586ec50b538bb99(placeholderId, uniquePlaceholderId = false) {
    if (!placeholderId) return;
    if (!$4b3ec0821606f7ca$var$serverMarkupCollected.has(placeholderId)) {
        $4b3ec0821606f7ca$var$findAndCollectCommentMarkers(document.body, placeholderId);
        $4b3ec0821606f7ca$var$serverMarkupCollected.add(placeholderId);
    }
    if (uniquePlaceholderId) return $4b3ec0821606f7ca$export$c0d0f0d932478a98().get(placeholderId)?.[0] ?? null;
    else {
        if (!$4b3ec0821606f7ca$var$serverMarkupIndexMap.has(placeholderId)) return;
        const index = $4b3ec0821606f7ca$var$serverMarkupIndexMap.get(placeholderId);
        $4b3ec0821606f7ca$var$serverMarkupIndexMap.set(placeholderId, index + 1);
        return index !== undefined ? $4b3ec0821606f7ca$export$c0d0f0d932478a98().get(placeholderId)?.[index] : null;
    }
}
function $4b3ec0821606f7ca$export$4b9c7f6314918efd() {
    $4b3ec0821606f7ca$var$serverMarkup.clear();
    $4b3ec0821606f7ca$var$serverMarkupIndexMap.clear();
    $4b3ec0821606f7ca$var$serverMarkupCollected.clear();
    $4b3ec0821606f7ca$var$totalElementsToHydrate = 0;
}
module.exports["shouldUseOriginalElement"] = $4b3ec0821606f7ca$export$63934da3851c8633;
module.exports["lookupOriginalElement"] = $4b3ec0821606f7ca$export$e2641d9526374e60;
module.exports["getServerMarkup"] = $4b3ec0821606f7ca$export$c0d0f0d932478a98;
module.exports["getTotalHydratedElements"] = $4b3ec0821606f7ca$export$84b00002df734b1f;
module.exports["cleanUpLoadablePlaceholders"] = $4b3ec0821606f7ca$export$69945a3a97aa6a3f;
module.exports["collectAndGetMarkup"] = $4b3ec0821606f7ca$export$7586ec50b538bb99;

});

parcelRegister("jSnXV", function(module, exports) {

var $lc9ud = parcelRequire("lc9ud");

var $7e79da40b44b13de$exports = {};

var $c2Pwh = parcelRequire("c2Pwh");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $7e79da40b44b13de$var$now = function() {
    return $c2Pwh.Date.now();
};
$7e79da40b44b13de$exports = $7e79da40b44b13de$var$now;



var $abOaY = parcelRequire("abOaY");

/** Error message constants. */ var $e785a680659019d0$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e785a680659019d0$var$nativeMax = Math.max, $e785a680659019d0$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $e785a680659019d0$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($e785a680659019d0$var$FUNC_ERROR_TEXT);
    wait = $abOaY(wait) || 0;
    if ($lc9ud(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $e785a680659019d0$var$nativeMax($abOaY(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        if (typeof setTimeout !== 'undefined') timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $e785a680659019d0$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $7e79da40b44b13de$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($7e79da40b44b13de$exports());
    }
    function debounced() {
        var time = $7e79da40b44b13de$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $e785a680659019d0$var$debounce;

});

parcelRegister("abOaY", function(module, exports) {
var $1aceab6f3159f09f$exports = {};
var $9903d10785514656$exports = {};
/** Used to match a single whitespace character. */ var $9903d10785514656$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $9903d10785514656$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $9903d10785514656$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$9903d10785514656$exports = $9903d10785514656$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $1aceab6f3159f09f$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $1aceab6f3159f09f$var$baseTrim(string) {
    return string ? string.slice(0, $9903d10785514656$exports(string) + 1).replace($1aceab6f3159f09f$var$reTrimStart, '') : string;
}
$1aceab6f3159f09f$exports = $1aceab6f3159f09f$var$baseTrim;



var $lc9ud = parcelRequire("lc9ud");


var $hDVEF = parcelRequire("hDVEF");

/** Used as references for various `Number` constants. */ var $76b1da5bc5696d7e$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $76b1da5bc5696d7e$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $76b1da5bc5696d7e$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $76b1da5bc5696d7e$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $76b1da5bc5696d7e$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $76b1da5bc5696d7e$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($hDVEF(value)) return $76b1da5bc5696d7e$var$NAN;
    if ($lc9ud(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $lc9ud(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $1aceab6f3159f09f$exports(value);
    var isBinary = $76b1da5bc5696d7e$var$reIsBinary.test(value);
    return isBinary || $76b1da5bc5696d7e$var$reIsOctal.test(value) ? $76b1da5bc5696d7e$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $76b1da5bc5696d7e$var$reIsBadHex.test(value) ? $76b1da5bc5696d7e$var$NAN : +value;
}
module.exports = $76b1da5bc5696d7e$var$toNumber;

});

parcelRegister("398ES", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $9a0adacc260d241b$export$30478ea03273cd5 = /*#__PURE__*/ function(LoadingPriority) {
    LoadingPriority[LoadingPriority["PAINT"] = 0] = "PAINT";
    // setting hover priority higher than after paint because there could be after paint components inside hover
    // and that can mess up the hierarchy order of components
    LoadingPriority[LoadingPriority["HYDRATE_ON_HOVER"] = 1] = "HYDRATE_ON_HOVER";
    LoadingPriority[LoadingPriority["AFTER_PAINT"] = 2] = "AFTER_PAINT";
    LoadingPriority[LoadingPriority["ACTIVATABLE"] = 3] = "ACTIVATABLE";
    LoadingPriority[LoadingPriority["LAZY"] = 4] = "LAZY";
    LoadingPriority[LoadingPriority["BACKGROUND"] = 5] = "BACKGROUND";
    LoadingPriority[LoadingPriority["MAX_PRIORITY"] = 5] = "MAX_PRIORITY";
    return LoadingPriority;
}({});
const $9a0adacc260d241b$export$5702a91a6f42969f = ()=>null;
module.exports["LoadingPriority"] = $9a0adacc260d241b$export$30478ea03273cd5;
module.exports["NOOP"] = $9a0adacc260d241b$export$5702a91a6f42969f;

});

parcelRegister("3GQl6", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $7W8i8 = parcelRequire("7W8i8");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");

parcelRequire("1z9oK");
var $dr1zO = parcelRequire("dr1zO");

parcelRequire("gSgn8");
var $eUgss = parcelRequire("eUgss");


var $b6HON = parcelRequire("b6HON");

const $c077ecb804e28fe3$var$logger = (0, $7W8i8.getLogger)('Loadable');
const $c077ecb804e28fe3$var$LOADING_TIMEOUT = 8500;
let $c077ecb804e28fe3$var$pending = [];
let $c077ecb804e28fe3$var$pendingPreloadInvokes = {};
let $c077ecb804e28fe3$var$resolveMap = {};
const $c077ecb804e28fe3$var$pendingImmediatePreloadInvokes = new Set();
const $c077ecb804e28fe3$var$loadableSet = new Set();
const $c077ecb804e28fe3$var$EVENT_STREAM_NAME = 'loadables';
let $c077ecb804e28fe3$var$clientInitialized = false;
function $c077ecb804e28fe3$var$enqueueLoadable(id) {
    if ($c077ecb804e28fe3$var$resolveMap[id]) return;
    const { resolve: resolve, promise: promise } = (0, $b6HON.defer)($c077ecb804e28fe3$var$LOADING_TIMEOUT, ()=>{
        var _window;
        $c077ecb804e28fe3$var$logger.error`Loadable initialization timed out: ${id}`;
        ((_window = window).__LOADABLE_TIMEOUTS__ || (_window.__LOADABLE_TIMEOUTS__ = [])).push(id);
    });
    $c077ecb804e28fe3$var$pending.push(promise);
    $c077ecb804e28fe3$var$resolveMap[id] = resolve;
    // Enqueue can happen before or after a loadable is discovered.
    // If enqueue happens before, we need to invoke the preload immediately when we discover the loadable.
    $c077ecb804e28fe3$var$pendingImmediatePreloadInvokes.add(id);
    // If enqueue happens after, we need to call preload() on previously discovered loadable.
    $c077ecb804e28fe3$var$pendingPreloadInvokes[id]?.();
}
function $c077ecb804e28fe3$var$initializeLoadable() {
    // We might not know if streaming is enabled at this point.
    // Listen to the events anyway.
    if (!$c077ecb804e28fe3$var$clientInitialized) {
        $c077ecb804e28fe3$var$clientInitialized = true;
        (0, $dr1zO.getClientStream)($c077ecb804e28fe3$var$EVENT_STREAM_NAME).addListener((event)=>{
            $c077ecb804e28fe3$var$enqueueLoadable(event.id);
        });
    }
    // enqueueLoadable is safe to call multiple times.
    for (const nameOrId of window.__LOADABLE__ || [])$c077ecb804e28fe3$var$enqueueLoadable(nameOrId);
}
async function $c077ecb804e28fe3$export$a6e3ec3b92c2b541() {
    $c077ecb804e28fe3$var$initializeLoadable();
    try {
        await (async ()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult = await Promise.all($c077ecb804e28fe3$var$pending);
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            return _asyncResult;
        })();
        if (window.__LOADABLE_TIMEOUTS__?.length) {
            const error = new Error(`Loadable initialization timeout`);
            const loadableIds = window.__LOADABLE_TIMEOUTS__;
            (0, $fJlJm.setLoadableErrorAttributes)(error, {
                loadableIds: loadableIds
            });
            // NOTE: apparently there's plenty of timeout errors happen during the normal flow of operation.
            // While we need to troubleshoot and fix them eventually, we don't want to flood the monitoring,
            // but we also want to track and alert upon them. Hence using a separate attribution.
            if (navigator.onLine) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: 'backbone-loadable'
            });
        }
    } finally{
        // Note here we don't clear resolveMap logic is using this to avoid load loadable twice.
        $c077ecb804e28fe3$var$pending = [];
        $c077ecb804e28fe3$var$pendingPreloadInvokes = {};
        $c077ecb804e28fe3$var$pendingImmediatePreloadInvokes.clear();
    }
}
function $c077ecb804e28fe3$export$be3c90707c2c118c(id, name, preload) {
    $c077ecb804e28fe3$var$initializeLoadable();
    const invokePreload = ()=>{
        if (id) delete $c077ecb804e28fe3$var$pendingPreloadInvokes[id];
        if (name) delete $c077ecb804e28fe3$var$pendingPreloadInvokes[name];
        if (id && id in $c077ecb804e28fe3$var$resolveMap || name && name in $c077ecb804e28fe3$var$resolveMap) {
            const resolve = ()=>{
                // Note that due to the _mustPreloadWhenRenderingSPA logic the loadable may appear
                // in the list of loadables both under id and under name. If we have 2 entries for
                // the loadable, we should resolve both.
                if (id && $c077ecb804e28fe3$var$resolveMap[id]) $c077ecb804e28fe3$var$resolveMap[id]();
                if (name && $c077ecb804e28fe3$var$resolveMap[name]) $c077ecb804e28fe3$var$resolveMap[name]();
            };
            $c077ecb804e28fe3$var$logger.debug`SSR Preload: ${name || id}`;
            (()=>{
                const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
                return preload().then((_result)=>{
                    (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
                    return resolve(_result);
                }, (e)=>{
                    (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
                    $c077ecb804e28fe3$var$logger.error(e);
                    resolve();
                });
            })();
        }
    };
    if (id && $c077ecb804e28fe3$var$pendingImmediatePreloadInvokes.has(id) || name && $c077ecb804e28fe3$var$pendingImmediatePreloadInvokes.has(name)) invokePreload();
    else {
        // __LOADABLE__ is not available when we execute code splits early than DOMContentLoaded
        // As soon as loadable are imported preloadIfNeeded gonna run because they are defined at module level.
        // In these cases we don't have a resolveMap to work with.
        // So we are saving the ids and invoke later when we get signal from SSR either stream or final __LOADABLE__
        if (id) $c077ecb804e28fe3$var$pendingPreloadInvokes[id] = invokePreload;
        if (name) $c077ecb804e28fe3$var$pendingPreloadInvokes[name] = invokePreload;
    }
}
function $c077ecb804e28fe3$export$4ea5af06371f7b61(id) {
    if (!id) return;
    if (window?.__SSR_REACT_STREAMING__) {
        if (!$c077ecb804e28fe3$var$loadableSet.has(id)) {
            $c077ecb804e28fe3$var$loadableSet.add(id);
            (0, $eUgss.getServerStream)($c077ecb804e28fe3$var$EVENT_STREAM_NAME).emit({
                id: id
            });
        }
    } else $c077ecb804e28fe3$var$loadableSet.add(id);
}
function $c077ecb804e28fe3$export$cab4cd9f10ff9148() {
    return Array.from($c077ecb804e28fe3$var$loadableSet);
}
function $c077ecb804e28fe3$export$30d89501e59f558f(loadableIds) {
    var id;
}
function $c077ecb804e28fe3$export$bb24ec95ef11c72f() {
    $c077ecb804e28fe3$var$pending = [];
    $c077ecb804e28fe3$var$resolveMap = {};
    $c077ecb804e28fe3$var$pendingPreloadInvokes = {};
    $c077ecb804e28fe3$var$loadableSet.clear();
    $c077ecb804e28fe3$var$pendingImmediatePreloadInvokes.clear();
    $c077ecb804e28fe3$var$clientInitialized = false;
}
module.exports["preloadLoadable"] = $c077ecb804e28fe3$export$a6e3ec3b92c2b541;
module.exports["preloadIfNeeded"] = $c077ecb804e28fe3$export$be3c90707c2c118c;
module.exports["mustPreloadWhenRenderingSPA"] = $c077ecb804e28fe3$export$30d89501e59f558f;

});

parcelRegister("4JHZe", function(module, exports) {
window.__PRELOAD_BOUNDARY_NAME__ = 'default';
function $599fde85de4e319f$export$108d7a7d456d844b() {
    return window.__PRELOAD_BOUNDARY_NAME__ || 'default';
}
function $599fde85de4e319f$export$4179f5118919b007(beforeResult) {
    window.__PRELOAD_BOUNDARY_NAME__ = beforeResult || 'default';
}
module.exports["beforePreloaderAsyncCall"] = $599fde85de4e319f$export$108d7a7d456d844b;
module.exports["afterPreloaderAsyncCall"] = $599fde85de4e319f$export$4179f5118919b007;

});

parcelRegister("gSgn8", function(module, exports) {
$parcel$export(module.exports, "getServerStream", () => (parcelRequire("eUgss")).getServerStream);
$parcel$export(module.exports, "getStreamInject", () => (parcelRequire("eUgss")).getStreamInject);

var $eUgss = parcelRequire("eUgss");


});

parcelRegister("8vxJi", function(module, exports) {
const $3896ba78f77b5103$var$ESCAPED_CHARS = {
    '<': '\\u003C',
    '>': '\\u003E',
    '/': '\\u002F',
    '\u2028': '\\u2028',
    '\u2029': '\\u2029'
};
const $3896ba78f77b5103$var$UNSAFE_CHARS_REGEXP_EXCLUDE_QUOTES = /[<>\/\u2028\u2029]/g;
function $3896ba78f77b5103$export$495a406d55070013(data) {
    // JSON.stringify(undefined) returns undefined, so we need to handle it separately
    // JSON.stringify(null) returns 'null'
    if (data === undefined) return String(data);
    return JSON.stringify(data).replace($3896ba78f77b5103$var$UNSAFE_CHARS_REGEXP_EXCLUDE_QUOTES, (char)=>$3896ba78f77b5103$var$ESCAPED_CHARS[char]);
}
module.exports["stringifyForSSR"] = $3896ba78f77b5103$export$495a406d55070013;

});

parcelRegister("9j59h", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3e043679f890d9f3$export$bd1eaa02d03f4b49 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "viEzP",
    name: "BrowserNotSupportedLoader",
    loader: async ()=>(await (parcelRequire("l5z6t"))).BrowserNotSupported
});
module.exports["BrowserNotSupportedLoader"] = $3e043679f890d9f3$export$bd1eaa02d03f4b49;

});

parcelRegister("jmjWc", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $l3KBO = parcelRequire("l3KBO");


var $3GQl6 = parcelRequire("3GQl6");


var $398ES = parcelRequire("398ES");


var $hpjl4 = parcelRequire("hpjl4");

const $8e1dec05b5f88fdc$var$loaded = new Set();
function $8e1dec05b5f88fdc$export$2f56a0fa8840f30a(id) {
    return id ? $8e1dec05b5f88fdc$var$loaded.has(id) : false;
}
function $8e1dec05b5f88fdc$export$8482f065b8e1680a(id) {
    if (id) $8e1dec05b5f88fdc$var$loaded.add(id);
}
function $8e1dec05b5f88fdc$export$a9ab3d224786f2e4() {
    $8e1dec05b5f88fdc$var$loaded.clear();
}



var $42omo = parcelRequire("42omo");


var $fwDOR = parcelRequire("fwDOR");


var $4VJDS = parcelRequire("4VJDS");





var $1aGr8 = parcelRequire("1aGr8");


var $5nSna = parcelRequire("5nSna");







function $c7e815481f3ced80$export$bbc8cfbe31c5396c(id) {
    const { ancestors: ancestors } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    const ids = [
        id
    ];
    for (const ancestor of ancestors){
        // Because SPA and SSR App roots from different components.
        // SPA's root is Loadable(ViewOrEditRoute)
        // SSR App's root is Loadable(MainLayout)
        // We need to stop at the common ancestor.
        if (ancestor.rootForServerPlaceholderId) break;
        // RouteComponent when set as loadables in classic package
        // do not have a similar mapping in SSR
        // causing hierarchy mismatch issues
        if (!ancestor.name?.includes('Route')) ids.push(ancestor.id);
    }
    return ids.join(':');
}



var $ezH4I = parcelRequire("ezH4I");


var $b6HON = parcelRequire("b6HON");


var $dVUnn = parcelRequire("dVUnn");

const $a5d00472ad834ee9$var$DELAY_HYRATION_ON_HOVER_FF = 'confluence_frontend_delay_hydration_on_hover';
const $a5d00472ad834ee9$var$loadableCountByNameAndId = new Map();
function $a5d00472ad834ee9$export$9b162f78e814433({ __loadable_id__: __loadable_id__, isReactLoadable: isReactLoadable, render: render, loading: loading = (0, $398ES.NOOP), _reactTreeRootForServerPlaceholderId: // Following props are internal APIs.
// Do NOT use unless consulted with the performance team.
_reactTreeRootForServerPlaceholderId, _addVCPlaceholderWrapper: _addVCPlaceholderWrapper, hydrateImmediately: hydrateImmediately }, { displayName: displayName, loadableName: loadableName, priority: priority, load: load, loadedModuleRef: // Using ref here because we want to get the latest value not a snapshot of the reference
loadedModuleRef }) {
    const LoadableClientComponent = (props)=>{
        const [error, setError] = (0, $42omo.useState)(null);
        const active = (0, $42omo.useRef)(true);
        const elementRef = (0, $42omo.useRef)(null);
        const [module, setModule] = (0, $42omo.useState)(()=>loadedModuleRef.ref);
        const currentOccurrenceIndex = (0, $42omo.useRef)(0);
        const placeholderId = (0, $c7e815481f3ced80$export$bbc8cfbe31c5396c)(__loadable_id__);
        const loadableNameWithId = `${loadableName}:${placeholderId}`;
        // similar to LoadableServerComponent, LoadableClientComponent needs a unique placeholderReplaceId.
        // Each client component uses a combination of its loadable's placeholderId and the nth occurrence, which
        // matches the id attached to the corresponding element coming from the server-side
        (0, $42omo.useEffect)(()=>{
            const currentIndex = $a5d00472ad834ee9$var$loadableCountByNameAndId.get(loadableNameWithId) || 0;
            $a5d00472ad834ee9$var$loadableCountByNameAndId.set(loadableNameWithId, currentIndex + 1);
            currentOccurrenceIndex.current = currentIndex;
            return ()=>{
                const currentIndex = $a5d00472ad834ee9$var$loadableCountByNameAndId.get(loadableNameWithId);
                if (currentIndex) $a5d00472ad834ee9$var$loadableCountByNameAndId.set(loadableNameWithId, currentIndex - 1);
            };
        }, [
            placeholderId,
            loadableNameWithId
        ]);
        const placeholderReplaceId = `${placeholderId}-${currentOccurrenceIndex.current}`;
        const isHydrating = (0, $ezH4I.getServerMarkup)().has(placeholderId);
        const updateModule = (0, $42omo.useCallback)((m)=>{
            if (m instanceof Error) setError(()=>m);
            else setModule(()=>m);
        }, []);
        LoadableClientComponent.setLoadedModule = updateModule;
        // Correct the priority with nearest React Loadable ancestor
        // Because we force all React Loadable to be AFTER_PAINT. We can't render any PAINT under AFTER_PAINT.
        // Don't change priority directly as this is scope variable that gonna change all the instances of the component.
        const newPriority = (0, $5nSna.useAutoCorrectPriorityWithAncestor)(priority);
        const runLoadFn = (0, $42omo.useCallback)((retry)=>{
            if (module || error && !retry) return;
            load(newPriority, isHydrating).then((m)=>{
                if (active.current) updateModule(m);
            });
        }, [
            module,
            error,
            isHydrating,
            newPriority,
            updateModule
        ]);
        (0, $42omo.useLayoutEffect)(()=>{
            active.current = true;
            const delayHydrationOnHoverTimeout = (0, $4VJDS.default).getNumber($a5d00472ad834ee9$var$DELAY_HYRATION_ON_HOVER_FF, 0);
            if (delayHydrationOnHoverTimeout > 0 && priority === (0, $398ES.LoadingPriority).HYDRATE_ON_HOVER && !hydrateImmediately?.() && window?.__SSR_RENDERED__) (0, $b6HON.defer)(delayHydrationOnHoverTimeout ?? 0, ()=>runLoadFn(false));
            else runLoadFn(false);
            return ()=>{
                active.current = false;
            };
        }, [
            runLoadFn
        ]);
        let element;
        if (module) {
            // Render is backward compatible with React Loadable
            // note render is a function not a functional component so you can't use hooks in it
            element = render ? render(module, props) : (0, $dVUnn.createElementWithCheckForInvalidType)(module, props, loadableName);
            if (_addVCPlaceholderWrapper) element = (0, $dVUnn.createElementWithCheckForInvalidType)(_addVCPlaceholderWrapper, {
                'data-loadable-vc-wrapper': true,
                'data-ssr-placeholder-replace': placeholderReplaceId,
                children: element
            }, loadableName);
        } else {
            let mergedProps;
            if (isReactLoadable) {
                // Compatible with React Loadable
                // https://github.com/jamiebuilds/react-loadable#propserror
                const reactLoadableLoadingProps = {};
                if (error) {
                    reactLoadableLoadingProps.error = error;
                    reactLoadableLoadingProps.retry = runLoadFn.bind(null, true);
                }
                mergedProps = {
                    // Do not override user's error or retry props
                    ...reactLoadableLoadingProps,
                    ...props
                };
            } else mergedProps = props;
            // Render SSR markup-based placeholder when available, with fallback to
            // client-side placeholder in case server markup could not be retrieved
            element = window['__SSR_RENDERED__'] && (newPriority === (0, $398ES.LoadingPriority).AFTER_PAINT || newPriority === (0, $398ES.LoadingPriority).HYDRATE_ON_HOVER) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1aGr8.LoadablePlaceholderClient), {
                placeholderId: placeholderId,
                clientPlaceholder: loading,
                elementRef: elementRef,
                ...mergedProps
            }) : (0, $dVUnn.createElementWithCheckForInvalidType)(loading, mergedProps, loadableName);
            if (priority !== (0, $398ES.LoadingPriority).BACKGROUND) element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
                name: `${loadableName}Placeholder`
            }, element);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nSna.LoadableAncestorsProvider), {
            id: __loadable_id__,
            // placeholderReplaceId is passed to the context so that on hydration,
            // each element can access it and add a new attribute data-ssr-placeholder-replace, whose value is the placeholderId.
            // This data-attribute's value will be checked against the value of the data-ssr-placeholder (added to the initial SSR response).
            // If the placeholderIds match, as well as the size and position of the element, the element is excluded from the TTVC calculation.
            placeholderReplaceId: placeholderReplaceId,
            name: loadableName,
            priority: newPriority,
            rootForServerPlaceholderId: Boolean(_reactTreeRootForServerPlaceholderId),
            isReactLoadable: isReactLoadable
        }, element);
    };
    LoadableClientComponent.displayName = displayName;
    // Default priority is designed for predictive preloading.
    // E.g. preload the editor when on view page.
    LoadableClientComponent.preload = ()=>{
        if (loadedModuleRef.ref) return Promise.resolve(loadedModuleRef.ref);
        return load((0, $398ES.LoadingPriority).PAINT);
    };
    LoadableClientComponent.hydrateOnHover = ()=>{
        const delayHydrationOnHoverTimeout = (0, $4VJDS.default).getNumber($a5d00472ad834ee9$var$DELAY_HYRATION_ON_HOVER_FF, 0) || 0;
        if (delayHydrationOnHoverTimeout === 0 || loadedModuleRef.ref || hydrateImmediately?.() || !window?.__SSR_RENDERED__) return;
        return load((0, $398ES.LoadingPriority).HYDRATE_ON_HOVER).then((m)=>{
            LoadableClientComponent.setLoadedModule?.(m);
        });
    };
    return LoadableClientComponent;
}







var $inPa6 = parcelRequire("inPa6");





var $gIaMn = parcelRequire("gIaMn");









var $5Abqh = parcelRequire("5Abqh");




function $8a48995831d19bab$export$2665580c35c1dde3() {
    let resolve;
    let status = 'suspended';
    const promise = new Promise((r)=>resolve = r);
    const resolveOnce = ()=>{
        if (status !== 'resolved') {
            status = 'resolved';
            resolve();
        }
    };
    const setLoading = ()=>{
        if (status === 'suspended') status = 'loading';
    };
    return {
        promise: promise,
        resolve: resolveOnce,
        getStatus: ()=>status,
        setLoading: setLoading
    };
}
function $8a48995831d19bab$export$e84e3311da80fa67(gate, id, loader, hostRef, onLoaded, loaderPromiseRef, createAnalyticsEvent) {
    // Return existing promise if already loading
    if (loaderPromiseRef.current) return loaderPromiseRef.current;
    gate.setLoading?.();
    const promise = Promise.resolve().then(()=>loader()).then((mod)=>{
        try {
            onLoaded(mod);
            if (typeof window !== 'undefined') {
                const host = hostRef?.current;
                gate.resolve();
                const root = window.__REACT_ROOT__;
                const target = host?.firstElementChild || host || undefined;
                root?.unstable_scheduleHydration?.(target);
            }
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'loadable',
                    action: 'hydrationFailed',
                    actionSubject: 'loadableComponent',
                    attributes: {
                        placeholderId: id,
                        errorMessage: error instanceof Error ? error.message : 'Unknown error',
                        errorStack: error instanceof Error ? error.stack : undefined
                    }
                }
            }).fire();
        }
    }).catch((error)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'loadable',
                action: 'loadFailed',
                actionSubject: 'loadableComponent',
                attributes: {
                    placeholderId: id,
                    errorMessage: error instanceof Error ? error.message : 'Unknown error',
                    errorStack: error instanceof Error ? error.stack : undefined
                }
            }
        }).fire();
    });
    loaderPromiseRef.current = promise;
    return promise;
}
function $8a48995831d19bab$export$b4bc28ee584f979c({ gate: gate, render: render, ssrSuccessCheckName: ssrSuccessCheckName, activateComponent: activateComponent }) {
    //eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if (gate && gate.getStatus() !== 'resolved') {
        // Unlock the gate immediately if we're not able to hydrate the page (or if the react-dom patch isn't present)
        // Or, if the component didn't fully render on the server (checkSSRPartialSuccess = false)
        const shouldUnlock = !window?.__SSR_RENDERED__ || !window?.__HYDRATABLE__ || window?.__HYDRATION_FAILED__ || !window.__CC_REACT_DOM_CONTEXT_PATCH__ || !ssrSuccessCheckName || !(0, $5Abqh.checkSSRPartialSuccess)(ssrSuccessCheckName);
        if (shouldUnlock) // Trigger unlocking in the background
        activateComponent((0, $gIaMn.ActivationReason).IMMEDIATE_UNLOCK);
        // Keep the boundary suspended until the gate is resolved
        throw gate.promise;
    }
    return render();
}















function $476ead65dc85d826$export$b2b7e1923b1f62a6({ id: id, gate: gate, loader: loader, hostRef: hostRef, onLoaded: onLoaded, loaderPromiseRef: loaderPromiseRef, loadableName: loadableName, activateComponent: activateComponent, ssrSuccessCheckName: ssrSuccessCheckName }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const content = (0, $42omo.useMemo)(()=>{
        if (typeof window === 'undefined') return null;
        const el = document.querySelector(`[data-hydration-shield="${id}"]`);
        const innerHTML = el?.innerHTML || '';
        return innerHTML || null;
    }, [
        id
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'loadable',
                action: 'fallbackRendered',
                actionSubject: 'loadableComponent',
                attributes: {
                    loadableName: loadableName,
                    hadSSRContent: !!content,
                    placeholderId: id
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        loadableName,
        content,
        id
    ]);
    (0, $42omo.useEffect)(()=>{
        // Only auto-activate if we have no/incomplete SSR content to show
        // If we have SSR content, we should wait for other means of activation (hover, timeout, etc.)
        // This prevents parent Suspense boundaries from breaking the activation flow
        if ((!content || !ssrSuccessCheckName || !(0, $5Abqh.checkSSRPartialSuccess)(ssrSuccessCheckName)) && gate && gate.getStatus() !== 'resolved') activateComponent((0, $gIaMn.ActivationReason).FALLBACK);
    }, [
        content,
        gate,
        id,
        loader,
        hostRef,
        onLoaded,
        loaderPromiseRef,
        loadableName,
        createAnalyticsEvent,
        activateComponent,
        ssrSuccessCheckName
    ]);
    if (!content) return null;
    // Render  SSR content directly for fast fallback display
    // eslint-disable-next-line react/no-danger
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
}
const $476ead65dc85d826$export$f43eab0e9866fe6f = /*#__PURE__*/ (0, $42omo.memo)(function BoundaryComponent({ gate: gate, id: id, loader: loader, hostRef: hostRef, onLoaded: onLoaded, render: render, loaderPromiseRef: loaderPromiseRef, loadableName: loadableName, ssrSuccessCheckName: ssrSuccessCheckName, activateComponent: activateComponent }) {
    // We add a wrapper div above Gate to match the structure of the SnapshotFallback
    // that way, if React forces the fallback to render it will not cause a TTVC mutation as long as the SSR result is correct
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($476ead65dc85d826$export$b2b7e1923b1f62a6, {
            id: id,
            gate: gate,
            loader: loader,
            hostRef: hostRef,
            onLoaded: onLoaded,
            loaderPromiseRef: loaderPromiseRef,
            loadableName: loadableName,
            activateComponent: activateComponent,
            ssrSuccessCheckName: ssrSuccessCheckName
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a48995831d19bab$export$b4bc28ee584f979c), {
        gate: gate,
        id: id,
        loader: loader,
        hostRef: hostRef,
        onLoaded: onLoaded,
        render: render,
        loaderPromiseRef: loaderPromiseRef,
        ssrSuccessCheckName: ssrSuccessCheckName,
        activateComponent: activateComponent
    })));
}, (prev, next)=>{
    // Once the gate is resolved, allow all prop changes to flow through
    if (next.resolved) return false;
    // Before resolution, only re-render when resolved state changes
    return prev.resolved === next.resolved;
});


function $9266a06a694a6e21$var$hasDefault(m) {
    return typeof m === 'object' && m !== null && 'default' in m;
}
function $9266a06a694a6e21$export$eaa50eb2becd1019({ __loadable_id__: __loadable_id__, loader: loader, name: name, triggers: triggers, ssrSuccessCheckName: ssrSuccessCheckName }, { loadableName: loadableName, loadedModuleRef: loadedModuleRef, displayName: displayName }) {
    const LoadableSuspenseClientComponent = (props)=>{
        const hostRef = (0, $42omo.useRef)(null);
        const observerRef = (0, $42omo.useRef)(null);
        const [isInViewport, setIsInViewport] = (0, $42omo.useState)(false);
        const baseId = __loadable_id__ || name || loadableName;
        const placeholderId = (0, $c7e815481f3ced80$export$bbc8cfbe31c5396c)(baseId);
        const gate = (0, $42omo.useMemo)(()=>(0, $8a48995831d19bab$export$2665580c35c1dde3)(), []);
        const loaderPromiseRef = (0, $42omo.useRef)(null);
        const startTimeRef = (0, $42omo.useRef)(null);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
        const triggerCleanupRef = (0, $42omo.useRef)(null);
        const autoActivateTimeoutRef = (0, $42omo.useRef)(null);
        const renderChildren = (0, $42omo.useCallback)(()=>{
            if (loadedModuleRef.ref) return /*#__PURE__*/ (0, $42omo.createElement)(loadedModuleRef.ref, props);
            return null;
        }, [
            props
        ]);
        const onLoaded = (0, $42omo.useCallback)((m)=>{
            loadedModuleRef.ref = $9266a06a694a6e21$var$hasDefault(m) ? m.default : m;
        }, []);
        const activateComponent = (0, $42omo.useCallback)((reason)=>{
            if (!loadedModuleRef.ref && !startTimeRef.current) startTimeRef.current = performance.now();
            if (gate?.getStatus() === 'suspended') {
                clearTimeout(autoActivateTimeoutRef.current ?? undefined);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: 'loadable',
                        action: 'activated',
                        actionSubject: 'loadableComponent',
                        attributes: {
                            loadableName: loadableName,
                            triggers: triggers,
                            placeholderId: placeholderId,
                            activationReason: reason
                        }
                    }
                }).fire();
                (0, $8a48995831d19bab$export$e84e3311da80fa67)(gate, placeholderId, loader, hostRef, onLoaded, loaderPromiseRef, createAnalyticsEvent);
            }
        }, [
            gate,
            placeholderId,
            hostRef,
            onLoaded,
            createAnalyticsEvent
        ]);
        const createTriggerHandlers = (0, $42omo.useCallback)((element, triggerList)=>{
            const removers = [];
            triggerList.forEach((trigger)=>{
                if (trigger.type === (0, $gIaMn.ActivationTriggerType).HOVER) {
                    const handleHover = ()=>{
                        activateComponent((0, $gIaMn.ActivationReason).USER_ACTIVATION);
                    };
                    element.addEventListener('mouseenter', handleHover, {
                        passive: true
                    });
                    removers.push(()=>{
                        element.removeEventListener('mouseenter', handleHover);
                    });
                } else if (trigger.type === (0, $gIaMn.ActivationTriggerType).SCROLL_INTO_VIEW) {
                    if (element && !isInViewport) {
                        if (!observerRef.current) observerRef.current = new IntersectionObserver(([entry])=>{
                            if (entry.isIntersecting) {
                                setIsInViewport(true);
                                observerRef.current?.disconnect();
                            }
                        });
                        observerRef.current.observe(element);
                        removers.push(()=>{
                            observerRef.current?.disconnect();
                        });
                    }
                }
            });
            return ()=>{
                removers.forEach((off)=>off());
            };
        }, [
            activateComponent,
            isInViewport
        ]);
        const hostRefWithActivation = (0, $42omo.useCallback)((element)=>{
            hostRef.current = element;
            if (element) {
                if (triggers && triggers.length) triggerCleanupRef.current = createTriggerHandlers(element, triggers);
            }
        }, [
            createTriggerHandlers
        ]);
        (0, $42omo.useEffect)(()=>{
            if (isInViewport) activateComponent((0, $gIaMn.ActivationReason).USER_ACTIVATION);
        }, [
            isInViewport,
            activateComponent
        ]);
        (0, $42omo.useEffect)(()=>{
            const ms = (0, $4VJDS.default).getNumber('confluence_loadable_auto_activate_timeout_ms', 0);
            if (ms) autoActivateTimeoutRef.current = window.setTimeout(()=>{
                if (gate?.getStatus() === 'suspended') activateComponent((0, $gIaMn.ActivationReason).AUTO_TIMEOUT);
            }, ms);
            return ()=>{
                clearTimeout(autoActivateTimeoutRef.current ?? undefined);
                triggerCleanupRef.current?.();
                if (gate?.getStatus() === 'suspended' && triggers && triggers.length) createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: 'loadable',
                        action: 'unmounted',
                        actionSubject: 'loadableComponent',
                        attributes: {
                            loadableName: loadableName,
                            wasEverActivated: false,
                            placeholderId: placeholderId
                        }
                    }
                }).fire();
            };
        }, [
            activateComponent,
            gate,
            createAnalyticsEvent,
            placeholderId
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nSna.LoadableAncestorsProvider), {
            id: __loadable_id__,
            name: loadableName,
            priority: (0, $398ES.LoadingPriority).ACTIVATABLE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: hostRefWithActivation,
            "data-hydration-shield": placeholderId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $476ead65dc85d826$export$f43eab0e9866fe6f), {
            id: placeholderId,
            loader: loader,
            hostRef: hostRef,
            gate: gate,
            onLoaded: onLoaded,
            resolved: gate?.getStatus?.() === 'resolved',
            render: renderChildren,
            loaderPromiseRef: loaderPromiseRef,
            loadableName: loadableName,
            ssrSuccessCheckName: ssrSuccessCheckName,
            activateComponent: activateComponent
        })));
    };
    LoadableSuspenseClientComponent.displayName = displayName;
    return LoadableSuspenseClientComponent;
}



/**
 * Force imports under the loadable to be resolved early in all jest tests.
 * This prevents the first running test from becoming disproportionately slow.
 * Leaves behavior in integration tests unchanged.
 */ function $85958d8769010b93$export$9a92a3060e3f5e60() {
    return false;
}


const $88e8236427be3059$var$logger = (0, $7W8i8.getLogger)('Loadable');
function $88e8236427be3059$var$markLoadingStart(loadableName, priority) {
    const startMark = `${loadableName}(${priority})${(0, $hpjl4.JS_LOAD_START)}`;
    if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    priority <= (0, $398ES.LoadingPriority).AFTER_PAINT && performance?.getEntriesByName?.(startMark)?.length === 0) performance.mark(startMark);
}
function $88e8236427be3059$var$markLoadingEnd(loadableName, priority) {
    const endMark = `${loadableName}(${priority})${(0, $hpjl4.JS_LOAD_END)}`;
    if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    priority <= (0, $398ES.LoadingPriority).AFTER_PAINT && performance?.getEntriesByName?.(endMark)?.length === 0) performance.mark(endMark);
}
/**
 * Wraps a promise-returning function with a network online check.
 * If the network is online, it returns the function as is.
 * If the network is offline, it returns a new function that waits for the network to come online before calling the original function.
 * @param fn - The function to wrap.
 * @returns A new function that checks the network status before calling the original function.
 * @internal
 */ function $88e8236427be3059$var$wrapWithNetworkOnlineCheck(fn) {
    if (window.navigator.onLine) // If online, no delay is needed
    return fn;
    return ()=>new Promise((resolve)=>{
            if (window.navigator.onLine) // If online, resolve the promise immediately
            // We're double-checking here incase the network status changes between initializing this callback and running it
            resolve(fn());
            else {
                const onNetworkChange = ()=>{
                    if (window.navigator.onLine) {
                        // If online, resolve the promise and remove the event listener
                        resolve(fn());
                        window.removeEventListener('online', onNetworkChange);
                    }
                };
                window.addEventListener('online', onNetworkChange);
            }
        });
}
function $88e8236427be3059$var$evaluateBooleanOrPredicate(condition) {
    if (typeof condition === 'function') return condition();
    return condition;
}
function $88e8236427be3059$export$7036027578ebb3d7(priority) {
    return (definition)=>{
        const { __loadable_id__: __loadable_id__, _maybeSyncLoader: _maybeSyncLoader, loader: loader, name: name, waitForNetworkOnline: waitForNetworkOnline = false } = definition;
        const loadableName = name || __loadable_id__ || 'unknown';
        const displayName = `Loadable(${loadableName})`;
        const loadedModuleRef = {
            ref: null
        };
        const totalHydratedAtOnce = 10;
        /**
		 * DON'T CACHE THE LOADER RESULT OR PROMISE
		 * There are quite a few places that calls function defined in outer scope like packages/confluence-fabric-editor/src/components/EditorLoader/Loader.tsx
		 * There is no guarantee they won't change and loader result is consistent. Caching the result might lead to bugs.
		 * We can theoretically run babel plugin to find out these cases and exclude them https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/commits/6ab47236eec2fa7c4a7542ad05b8c45964443ba1
		 * However I don't feel worth the effort of maintaining another piece of logic in babel plugin and risk of missing out the side effects in loader function.
		 * So I am leaving it as it is.
		 */ const cleanup = ()=>{
            $88e8236427be3059$var$markLoadingEnd(loadableName, priority);
            (0, $8e1dec05b5f88fdc$export$8482f065b8e1680a)(__loadable_id__);
        };
        const runLoader = ()=>{
            $88e8236427be3059$var$markLoadingStart(loadableName, priority);
            const handleResolve = (module)=>{
                cleanup();
                return loadedModuleRef.ref = module?.default || module;
            };
            const handleError = (e)=>{
                cleanup();
                if ((0, $9wGTI.fg)('confluence_frontend_surface_loadable_errors')) {
                    (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                        attribution: 'backbone-loadable'
                    });
                    $88e8236427be3059$var$logger.error`Error loading loadable component ${loadableName}. Please check with #cc-fe-performance if you need help with this.\n`;
                }
                return e;
            };
            if (_maybeSyncLoader) try {
                // Unfortunately for sync loader we lose the ability to make it aware of network status.
                // However good news is if loader was made sync it means it is definitely not a network call.
                const result = loader();
                // It is maybe sync so it can still return a promise.
                if (result instanceof Promise) return result.then(handleResolve, handleError);
                else // Still return a promised result to keep everywhere else happy.
                // But we have saved the module to the ref. Everything should work fine. :)
                return Promise.resolve(handleResolve(result));
            } catch (e) {
                return Promise.resolve(handleError(e));
            }
            else {
                const loaderWithNetworkOnline = // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                $88e8236427be3059$var$evaluateBooleanOrPredicate(waitForNetworkOnline) && true ? $88e8236427be3059$var$wrapWithNetworkOnlineCheck(loader) : loader;
                // At the time when a promise is rejected, it must already been attached with a catch.
                // However it is not the case when running in the task manager.
                // Because a task can return a promise or a value. We have to check before attaching a catch.
                // This makes the rejection unhandled. So we are converting it to a resolved promise with an error.
                // The error object will be handled later in LoadableComponent.
                return loaderWithNetworkOnline().then(handleResolve, handleError);
            }
        };
        const load = (priorityOverride = -1, isHydrating = false)=>{
            if (loadedModuleRef.ref) return Promise.resolve(loadedModuleRef.ref);
            if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            (0, $8e1dec05b5f88fdc$export$2f56a0fa8840f30a)(__loadable_id__) || _maybeSyncLoader || (0, $85958d8769010b93$export$9a92a3060e3f5e60)()) return runLoader();
            return (0, $l3KBO.getTaskManager)({
                totalHydratedAtOnce: totalHydratedAtOnce
            }).push({
                id: __loadable_id__,
                priority: priorityOverride >= (0, $398ES.LoadingPriority).PAINT ? priorityOverride : priority,
                task: runLoader,
                _delayHydration: isHydrating
            });
        };
        if (_maybeSyncLoader || (0, $85958d8769010b93$export$9a92a3060e3f5e60)()) load();
        else /*
			 * Preload dynamic split when:
			 * - In React SSR mode
			 * - id of the component is in the magical __LOADABLE__ array
			 * Note: __LOADABLE__ array is produced by React SSR server where server knows what loadable has been used on the server side.
			 * Client will preload everything in __LOADABLE__ so component do not flip back to the loading state.
			 *
			 * Note: __SSR_RENDERED__ is not checked here because we initialize loadable very early that is before SSR full result.
			 */ (0, $3GQl6.preloadIfNeeded)(__loadable_id__, name, ()=>load((0, $398ES.LoadingPriority).PAINT));
        if (priority === (0, $398ES.LoadingPriority).ACTIVATABLE) return (0, $9266a06a694a6e21$export$eaa50eb2becd1019)(definition, {
            displayName: displayName,
            loadableName: loadableName,
            priority: priority,
            load: load,
            loadedModuleRef: loadedModuleRef
        });
        return (0, $a5d00472ad834ee9$export$9b162f78e814433)(definition, {
            displayName: displayName,
            loadableName: loadableName,
            priority: priority,
            load: load,
            loadedModuleRef: loadedModuleRef
        });
    };
}
const $88e8236427be3059$export$8227ef1c198f3b6c = $88e8236427be3059$export$7036027578ebb3d7((0, $398ES.LoadingPriority).PAINT);
const $88e8236427be3059$export$c96dcd31adf45b8c = $88e8236427be3059$export$7036027578ebb3d7((0, $398ES.LoadingPriority).AFTER_PAINT);
const $88e8236427be3059$export$d0978c060f6515fd = $88e8236427be3059$export$7036027578ebb3d7((0, $398ES.LoadingPriority).LAZY);
const $88e8236427be3059$export$a81c0ed1ccdb363e = $88e8236427be3059$export$7036027578ebb3d7((0, $398ES.LoadingPriority).BACKGROUND);
const $88e8236427be3059$export$6f7fe07ec2db9207 = $88e8236427be3059$export$7036027578ebb3d7((0, $398ES.LoadingPriority).HYDRATE_ON_HOVER);
const $88e8236427be3059$export$4ae628cf1e7f3bd9 = $88e8236427be3059$export$7036027578ebb3d7((0, $398ES.LoadingPriority).ACTIVATABLE);
module.exports["createLoadable"] = $88e8236427be3059$export$7036027578ebb3d7;
module.exports["LoadablePaint"] = $88e8236427be3059$export$8227ef1c198f3b6c;
module.exports["LoadableAfterPaint"] = $88e8236427be3059$export$c96dcd31adf45b8c;
module.exports["LoadableLazy"] = $88e8236427be3059$export$d0978c060f6515fd;
module.exports["LoadableBackground"] = $88e8236427be3059$export$a81c0ed1ccdb363e;
module.exports["LoadableHydrateOnHover"] = $88e8236427be3059$export$6f7fe07ec2db9207;
module.exports["LoadableActivatable"] = $88e8236427be3059$export$4ae628cf1e7f3bd9;

});

parcelRegister("1aGr8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7W8i8 = parcelRequire("7W8i8");


var $lojHn = parcelRequire("lojHn");


var $ezH4I = parcelRequire("ezH4I");





var $inPa6 = parcelRequire("inPa6");




const $d902131b12376e56$export$c500cee86d483c82 = new Set([
    'allowfullscreen',
    'async',
    'autofocus',
    'autoplay',
    'checked',
    'controls',
    'default',
    'defer',
    'disabled',
    'formnovalidate',
    'hidden',
    'inert',
    'ismap',
    'itemscope',
    'loop',
    'multiple',
    'muted',
    'nomodule',
    'novalidate',
    'open',
    'playsinline',
    'readonly',
    'required',
    'reversed',
    'selected'
]);


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // Adopted from https://github.com/facebook/react/blob/main/packages/react-dom-bindings/src/shared/possibleStandardNames.js
// Filtered out ones that are equivalent to the original name.
const $d32e3205c2513f7b$export$bbecfff5ecf65cd8 = Object.assign(Object.create(null), {
    acceptcharset: 'acceptCharset',
    'accept-charset': 'acceptCharset',
    accesskey: 'accessKey',
    allowfullscreen: 'allowFullScreen',
    autocapitalize: 'autoCapitalize',
    autocomplete: 'autoComplete',
    autocorrect: 'autoCorrect',
    autofocus: 'autoFocus',
    autoplay: 'autoPlay',
    autosave: 'autoSave',
    cellpadding: 'cellPadding',
    cellspacing: 'cellSpacing',
    charset: 'charSet',
    class: 'className',
    classid: 'classID',
    classname: 'className',
    colspan: 'colSpan',
    contenteditable: 'contentEditable',
    contextmenu: 'contextMenu',
    controlslist: 'controlsList',
    crossorigin: 'crossOrigin',
    dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
    datetime: 'dateTime',
    defaultchecked: 'defaultChecked',
    defaultvalue: 'defaultValue',
    disablepictureinpicture: 'disablePictureInPicture',
    disableremoteplayback: 'disableRemotePlayback',
    enctype: 'encType',
    enterkeyhint: 'enterKeyHint',
    fetchpriority: 'fetchPriority',
    for: 'htmlFor',
    formmethod: 'formMethod',
    formaction: 'formAction',
    formenctype: 'formEncType',
    formnovalidate: 'formNoValidate',
    formtarget: 'formTarget',
    frameborder: 'frameBorder',
    hreflang: 'hrefLang',
    htmlfor: 'htmlFor',
    httpequiv: 'httpEquiv',
    'http-equiv': 'httpEquiv',
    imagesizes: 'imageSizes',
    imagesrcset: 'imageSrcSet',
    innerhtml: 'innerHTML',
    inputmode: 'inputMode',
    itemid: 'itemID',
    itemprop: 'itemProp',
    itemref: 'itemRef',
    itemscope: 'itemScope',
    itemtype: 'itemType',
    keyparams: 'keyParams',
    keytype: 'keyType',
    marginwidth: 'marginWidth',
    marginheight: 'marginHeight',
    maxlength: 'maxLength',
    mediagroup: 'mediaGroup',
    minlength: 'minLength',
    nomodule: 'noModule',
    novalidate: 'noValidate',
    playsinline: 'playsInline',
    radiogroup: 'radioGroup',
    readonly: 'readOnly',
    referrerpolicy: 'referrerPolicy',
    rowspan: 'rowSpan',
    spellcheck: 'spellCheck',
    srcdoc: 'srcDoc',
    srclang: 'srcLang',
    srcset: 'srcSet',
    tabindex: 'tabIndex',
    usemap: 'useMap',
    accentheight: 'accentHeight',
    'accent-height': 'accentHeight',
    alignmentbaseline: 'alignmentBaseline',
    'alignment-baseline': 'alignmentBaseline',
    allowreorder: 'allowReorder',
    arabicform: 'arabicForm',
    'arabic-form': 'arabicForm',
    attributename: 'attributeName',
    attributetype: 'attributeType',
    autoreverse: 'autoReverse',
    basefrequency: 'baseFrequency',
    baselineshift: 'baselineShift',
    'baseline-shift': 'baselineShift',
    baseprofile: 'baseProfile',
    calcmode: 'calcMode',
    capheight: 'capHeight',
    'cap-height': 'capHeight',
    clippath: 'clipPath',
    'clip-path': 'clipPath',
    clippathunits: 'clipPathUnits',
    cliprule: 'clipRule',
    'clip-rule': 'clipRule',
    colorinterpolation: 'colorInterpolation',
    'color-interpolation': 'colorInterpolation',
    colorinterpolationfilters: 'colorInterpolationFilters',
    'color-interpolation-filters': 'colorInterpolationFilters',
    colorprofile: 'colorProfile',
    'color-profile': 'colorProfile',
    colorrendering: 'colorRendering',
    'color-rendering': 'colorRendering',
    contentscripttype: 'contentScriptType',
    contentstyletype: 'contentStyleType',
    diffuseconstant: 'diffuseConstant',
    dominantbaseline: 'dominantBaseline',
    'dominant-baseline': 'dominantBaseline',
    edgemode: 'edgeMode',
    enablebackground: 'enableBackground',
    'enable-background': 'enableBackground',
    externalresourcesrequired: 'externalResourcesRequired',
    fillopacity: 'fillOpacity',
    'fill-opacity': 'fillOpacity',
    fillrule: 'fillRule',
    'fill-rule': 'fillRule',
    filterres: 'filterRes',
    filterunits: 'filterUnits',
    floodopacity: 'floodOpacity',
    'flood-opacity': 'floodOpacity',
    floodcolor: 'floodColor',
    'flood-color': 'floodColor',
    fontfamily: 'fontFamily',
    'font-family': 'fontFamily',
    fontsize: 'fontSize',
    'font-size': 'fontSize',
    fontsizeadjust: 'fontSizeAdjust',
    'font-size-adjust': 'fontSizeAdjust',
    fontstretch: 'fontStretch',
    'font-stretch': 'fontStretch',
    fontstyle: 'fontStyle',
    'font-style': 'fontStyle',
    fontvariant: 'fontVariant',
    'font-variant': 'fontVariant',
    fontweight: 'fontWeight',
    'font-weight': 'fontWeight',
    glyphname: 'glyphName',
    'glyph-name': 'glyphName',
    glyphorientationhorizontal: 'glyphOrientationHorizontal',
    'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
    glyphorientationvertical: 'glyphOrientationVertical',
    'glyph-orientation-vertical': 'glyphOrientationVertical',
    glyphref: 'glyphRef',
    gradienttransform: 'gradientTransform',
    gradientunits: 'gradientUnits',
    horizadvx: 'horizAdvX',
    'horiz-adv-x': 'horizAdvX',
    horizoriginx: 'horizOriginX',
    'horiz-origin-x': 'horizOriginX',
    imagerendering: 'imageRendering',
    'image-rendering': 'imageRendering',
    kernelmatrix: 'kernelMatrix',
    kernelunitlength: 'kernelUnitLength',
    keypoints: 'keyPoints',
    keysplines: 'keySplines',
    keytimes: 'keyTimes',
    lengthadjust: 'lengthAdjust',
    letterspacing: 'letterSpacing',
    'letter-spacing': 'letterSpacing',
    lightingcolor: 'lightingColor',
    'lighting-color': 'lightingColor',
    limitingconeangle: 'limitingConeAngle',
    markerend: 'markerEnd',
    'marker-end': 'markerEnd',
    markerheight: 'markerHeight',
    markermid: 'markerMid',
    'marker-mid': 'markerMid',
    markerstart: 'markerStart',
    'marker-start': 'markerStart',
    markerunits: 'markerUnits',
    markerwidth: 'markerWidth',
    maskcontentunits: 'maskContentUnits',
    maskunits: 'maskUnits',
    numoctaves: 'numOctaves',
    overlineposition: 'overlinePosition',
    'overline-position': 'overlinePosition',
    overlinethickness: 'overlineThickness',
    'overline-thickness': 'overlineThickness',
    paintorder: 'paintOrder',
    'paint-order': 'paintOrder',
    'panose-1': 'panose1',
    pathlength: 'pathLength',
    patterncontentunits: 'patternContentUnits',
    patterntransform: 'patternTransform',
    patternunits: 'patternUnits',
    pointerevents: 'pointerEvents',
    'pointer-events': 'pointerEvents',
    pointsatx: 'pointsAtX',
    pointsaty: 'pointsAtY',
    pointsatz: 'pointsAtZ',
    preservealpha: 'preserveAlpha',
    preserveaspectratio: 'preserveAspectRatio',
    primitiveunits: 'primitiveUnits',
    refx: 'refX',
    refy: 'refY',
    renderingintent: 'renderingIntent',
    'rendering-intent': 'renderingIntent',
    repeatcount: 'repeatCount',
    repeatdur: 'repeatDur',
    requiredextensions: 'requiredExtensions',
    requiredfeatures: 'requiredFeatures',
    shaperendering: 'shapeRendering',
    'shape-rendering': 'shapeRendering',
    specularconstant: 'specularConstant',
    specularexponent: 'specularExponent',
    spreadmethod: 'spreadMethod',
    startoffset: 'startOffset',
    stddeviation: 'stdDeviation',
    stitchtiles: 'stitchTiles',
    stopcolor: 'stopColor',
    'stop-color': 'stopColor',
    stopopacity: 'stopOpacity',
    'stop-opacity': 'stopOpacity',
    strikethroughposition: 'strikethroughPosition',
    'strikethrough-position': 'strikethroughPosition',
    strikethroughthickness: 'strikethroughThickness',
    'strikethrough-thickness': 'strikethroughThickness',
    strokedasharray: 'strokeDasharray',
    'stroke-dasharray': 'strokeDasharray',
    strokedashoffset: 'strokeDashoffset',
    'stroke-dashoffset': 'strokeDashoffset',
    strokelinecap: 'strokeLinecap',
    'stroke-linecap': 'strokeLinecap',
    strokelinejoin: 'strokeLinejoin',
    'stroke-linejoin': 'strokeLinejoin',
    strokemiterlimit: 'strokeMiterlimit',
    'stroke-miterlimit': 'strokeMiterlimit',
    strokewidth: 'strokeWidth',
    'stroke-width': 'strokeWidth',
    strokeopacity: 'strokeOpacity',
    'stroke-opacity': 'strokeOpacity',
    suppresscontenteditablewarning: 'suppressContentEditableWarning',
    suppresshydrationwarning: 'suppressHydrationWarning',
    surfacescale: 'surfaceScale',
    systemlanguage: 'systemLanguage',
    tablevalues: 'tableValues',
    targetx: 'targetX',
    targety: 'targetY',
    textanchor: 'textAnchor',
    'text-anchor': 'textAnchor',
    textdecoration: 'textDecoration',
    'text-decoration': 'textDecoration',
    textlength: 'textLength',
    textrendering: 'textRendering',
    'text-rendering': 'textRendering',
    transformorigin: 'transformOrigin',
    'transform-origin': 'transformOrigin',
    underlineposition: 'underlinePosition',
    'underline-position': 'underlinePosition',
    underlinethickness: 'underlineThickness',
    'underline-thickness': 'underlineThickness',
    unicodebidi: 'unicodeBidi',
    'unicode-bidi': 'unicodeBidi',
    unicoderange: 'unicodeRange',
    'unicode-range': 'unicodeRange',
    unitsperem: 'unitsPerEm',
    'units-per-em': 'unitsPerEm',
    valphabetic: 'vAlphabetic',
    'v-alphabetic': 'vAlphabetic',
    vectoreffect: 'vectorEffect',
    'vector-effect': 'vectorEffect',
    vertadvy: 'vertAdvY',
    'vert-adv-y': 'vertAdvY',
    vertoriginx: 'vertOriginX',
    'vert-origin-x': 'vertOriginX',
    vertoriginy: 'vertOriginY',
    'vert-origin-y': 'vertOriginY',
    vhanging: 'vHanging',
    'v-hanging': 'vHanging',
    videographic: 'vIdeographic',
    'v-ideographic': 'vIdeographic',
    viewbox: 'viewBox',
    viewtarget: 'viewTarget',
    vmathematical: 'vMathematical',
    'v-mathematical': 'vMathematical',
    wordspacing: 'wordSpacing',
    'word-spacing': 'wordSpacing',
    writingmode: 'writingMode',
    'writing-mode': 'writingMode',
    xchannelselector: 'xChannelSelector',
    xheight: 'xHeight',
    'x-height': 'xHeight',
    xlinkactuate: 'xlinkActuate',
    'xlink:actuate': 'xlinkActuate',
    xlinkarcrole: 'xlinkArcrole',
    'xlink:arcrole': 'xlinkArcrole',
    xlinkhref: 'xlinkHref',
    'xlink:href': 'xlinkHref',
    xlinkrole: 'xlinkRole',
    'xlink:role': 'xlinkRole',
    xlinkshow: 'xlinkShow',
    'xlink:show': 'xlinkShow',
    xlinktitle: 'xlinkTitle',
    'xlink:title': 'xlinkTitle',
    xlinktype: 'xlinkType',
    'xlink:type': 'xlinkType',
    xmlbase: 'xmlBase',
    'xml:base': 'xmlBase',
    xmllang: 'xmlLang',
    'xml:lang': 'xmlLang',
    'xml:space': 'xmlSpace',
    xmlnsxlink: 'xmlnsXlink',
    'xmlns:xlink': 'xmlnsXlink',
    xmlspace: 'xmlSpace',
    ychannelselector: 'yChannelSelector',
    zoomandpan: 'zoomAndPan'
});


function $e02f9ffb6adca9c2$export$57a1142d3de30c74(style) {
    return style.split(';').reduce((styleObj, entity)=>{
        const keyValuePair = entity.split(':', 2);
        const value = keyValuePair[1] || '';
        // -ms-style-property -> msStyleProperty
        // -moz-style-property -> MozStyleProperty
        // -webkit-style-property -> WebkitStyleProperty
        // style-property -> styleProperty
        let name = keyValuePair[0].replace(/^-ms-/, 'ms-').replace(/^-moz-/, 'Moz-').replace(/^-webkit-/, 'Webkit-');
        if (!name.startsWith('--')) name = name.replace(/-(.)/g, (_, ch)=>ch.toUpperCase());
        name = name.trim();
        if (name) styleObj[name] = value.trim();
        return styleObj;
    }, {});
}
function $e02f9ffb6adca9c2$export$8a4197eb95130994(attrs) {
    const props = {};
    for(let i = 0; i < attrs.length; i++){
        const attr = attrs[i];
        const name = attr.name.toLowerCase();
        if (name === 'style') props['style'] = $e02f9ffb6adca9c2$export$57a1142d3de30c74(attr.value);
        else if ((0, $d902131b12376e56$export$c500cee86d483c82).has(name)) props[name] = true;
        else props[(0, $d32e3205c2513f7b$export$bbecfff5ecf65cd8)[name] || name] = attr.value;
    }
    return props;
}





const $29e2a393702ce3bd$var$nodeRemovalTasks = [];
let $29e2a393702ce3bd$var$nodeRemovalTimerHandle = null;
// scheduled tasks will be executed in the next microtask tick,
// this allows preventing unnecessary/expensive DOM manipulations during react render phase
function $29e2a393702ce3bd$var$scheduleNodeRemoval(fn) {
    $29e2a393702ce3bd$var$nodeRemovalTasks.push(fn);
    if (!$29e2a393702ce3bd$var$nodeRemovalTimerHandle) $29e2a393702ce3bd$var$nodeRemovalTimerHandle = setTimeout(()=>{
        for (const task of $29e2a393702ce3bd$var$nodeRemovalTasks)task();
        $29e2a393702ce3bd$var$nodeRemovalTimerHandle = null;
        $29e2a393702ce3bd$var$nodeRemovalTasks.length = 0;
    }, 0);
}
function $29e2a393702ce3bd$export$a61c075e1a7ff8fc({ attrs: attrs, innerHTML: innerHTML, nonce: nonce }) {
    (0, $42omo.useLayoutEffect)(()=>{
        const scriptElement = document.createElement('script');
        scriptElement.innerHTML = innerHTML;
        for(let i = 0; i < attrs.length; i++)scriptElement.setAttribute(attrs[i].name, attrs[i].value);
        if (nonce) scriptElement.nonce = nonce;
        document.body.appendChild(scriptElement);
        return ()=>$29e2a393702ce3bd$var$scheduleNodeRemoval(()=>{
                if (scriptElement.parentNode === document.body) document.body.removeChild(scriptElement);
            });
    }, [
        attrs,
        innerHTML,
        nonce
    ]);
    return null;
}
function $29e2a393702ce3bd$var$DOMElementFromSSRResult({ el: el }) {
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        const target = ref.current;
        const parent = target?.parentNode;
        if (parent) {
            const originalNode = (0, $ezH4I.lookupOriginalElement)(el);
            if (originalNode) parent.insertBefore(originalNode, target.nextSibling);
            return ()=>$29e2a393702ce3bd$var$scheduleNodeRemoval(()=>{
                    if (originalNode && originalNode.parentNode === parent) parent.removeChild(originalNode);
                });
        }
    }, [
        el
    ]);
    // There is no way around in React. We need a reference point to do the DOM manipulation.
    // We also can't operate on this node directly, because the siblings will reference to it.
    // Similar to https://github.com/facebook/react/issues/11538 it will cause exception.
    // data-loadable-ref here has no meaning. Just to add something to DOM so it can be trace back to here.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        ref: ref,
        "data-loadable-ref": true
    });
}
function $29e2a393702ce3bd$var$createElement(el, elementRef) {
    /**
	 * The value of Element.tagName, that is the uppercase name of the element tag if an HTML element,
	 * or the lowercase element tag if an XML element (like a SVG or MATHML element).
	 * https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeName
	 */ let tag = el.nodeName;
    if (tag === tag.toUpperCase()) tag = tag.toLowerCase();
    const attrs = el.attributes;
    const type = attrs.getNamedItem('type')?.value;
    const skipInlineScript = attrs.getNamedItem('data-skip-in-placeholder')?.value;
    if ((0, $ezH4I.shouldUseOriginalElement)(el)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($29e2a393702ce3bd$var$DOMElementFromSSRResult, {
        el: el
    });
    else if (tag === 'script' && (!type || type === 'text/javascript' || type === 'module') && !skipInlineScript) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($29e2a393702ce3bd$export$a61c075e1a7ff8fc, {
        nonce: el.nonce,
        attrs: attrs,
        innerHTML: el.innerHTML
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tag, {
        ...(0, $e02f9ffb6adca9c2$export$8a4197eb95130994)(attrs),
        ref: elementRef
    }, // do not pass ref to children as ref for viewport is only needed for parent node
    ...el.childNodes.length ? $29e2a393702ce3bd$var$convertToReactElements(el.childNodes) : []);
}
function $29e2a393702ce3bd$var$convertToReactElements(nodes, elementRef) {
    return Array.from(nodes).map((node)=>{
        switch(node.nodeType){
            case Node.COMMENT_NODE:
                return null;
            case Node.TEXT_NODE:
                return node.textContent;
            case Node.ELEMENT_NODE:
                //pass ref to parent node only
                return $29e2a393702ce3bd$var$createElement(node, elementRef);
        }
        throw new Error(`Unsupported node type (${node.nodeType}): ${node?.outerHTML}`);
    });
}
function $29e2a393702ce3bd$export$80b13ad49275e3fd({ content: content, showDebugOutline: showDebugOutline, elementRef: elementRef }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (!content) return null;
    try {
        const placeholder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {}, ...$29e2a393702ce3bd$var$convertToReactElements(content, elementRef));
        return showDebugOutline ? (0, $lojHn.withOutline)('blue', placeholder) : placeholder;
    } catch (e) {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'loadable',
                action: 'failed',
                actionSubject: 'convertToReactElements',
                attributes: {
                    message: e.message,
                    stack: e.stack
                }
            }
        }).fire();
        return null;
    }
}



var $dVUnn = parcelRequire("dVUnn");

const $9c50b78343bd774d$var$logger = (0, $7W8i8.getLogger)('LoadablePlaceholder');
const $9c50b78343bd774d$export$e524011ccbd7a3be = ({ debugName: debugName, placeholderId: placeholderId, children: children, tag: tag = 'input', ssrPlaceholderId: ssrPlaceholderId, ssrPlaceholderIgnored: ssrPlaceholderIgnored })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $9c50b78343bd774d$export$659822d4296e941e = /*#__PURE__*/ (0, $42omo.memo)(({ name: name, placeholderId: placeholderId, clientPlaceholder: clientPlaceholder, outlineJestEnforce: outlineJestEnforce = false, uniquePlaceholderId: uniquePlaceholderId = false, elementRef: elementRef, ...rest })=>{
    name = name || placeholderId;
    let shouldOutline = false;
    try {
        // handle The "operation is insecure" when cookie is disabled
        shouldOutline = typeof window !== 'undefined' && Boolean((0, $17wUi.confluenceSessionStorageInstance)?.getItem((0, $1UApO.keys).CONFLUENCE_SSR_OUTLINE_ENABLED));
    } catch (e) {}
    const content = (0, $42omo.useMemo)(()=>{
        if (!placeholderId) return null;
        // One placeholderId could possibly map to multiple different contents.
        // For example, if one page has multiple Table of Content macros with different config, flat or bullet list.
        // The placeholderId represents TableOfContentsLoader, the contents are different for each ToC macro.
        //
        // Unique means in html there are each boundary has unique placeholderId.
        // Also this will allow placeholders to be used more than once. Event after LoadablePlaceholderClient is unmounted.
        return (0, $ezH4I.collectAndGetMarkup)(placeholderId, uniquePlaceholderId);
    }, [
        uniquePlaceholderId,
        placeholderId
    ]);
    const showDebugOutline = outlineJestEnforce || shouldOutline;
    if (!placeholderId || !content) {
        const clientPlaceHolderElement = (0, $dVUnn.createElementWithCheckForInvalidType)(clientPlaceholder, rest, name);
        $9c50b78343bd774d$var$logger.debug`Can't find server placeholder for ${name}. Rendering client placeholder.`;
        // When outlining is enabled, outline client-based placeholders in red
        return showDebugOutline ? (0, $lojHn.withOutline)('red', clientPlaceHolderElement) : clientPlaceHolderElement;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $29e2a393702ce3bd$export$80b13ad49275e3fd), {
        content: content,
        showDebugOutline: showDebugOutline,
        elementRef: elementRef
    });
});
module.exports["LoadablePlaceholderServer"] = $9c50b78343bd774d$export$e524011ccbd7a3be;
module.exports["LoadablePlaceholderClient"] = $9c50b78343bd774d$export$659822d4296e941e;

});

parcelRegister("gMc0m", function(module, exports) {
$parcel$export(module.exports, "default", () => $c36a70ed3cda44ab$export$2e2bcd8739ae039);
const $c36a70ed3cda44ab$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $c36a70ed3cda44ab$var$ATOMIC_GROUP_LENGTH = 5;
function $c36a70ed3cda44ab$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $c36a70ed3cda44ab$var$UNDERSCORE_UNICODE ? $c36a70ed3cda44ab$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("5nSna", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $lojHn = parcelRequire("lojHn");


var $398ES = parcelRequire("398ES");

const $18fee0a06ef04028$var$PRIORITY_COLORS = {
    [(0, $398ES.LoadingPriority).PAINT]: 'red',
    [(0, $398ES.LoadingPriority).AFTER_PAINT]: 'yellow',
    [(0, $398ES.LoadingPriority).BACKGROUND]: 'blue',
    [(0, $398ES.LoadingPriority).LAZY]: 'green'
};
const $18fee0a06ef04028$export$5a6fb2dde15997f8 = /*#__PURE__*/ (0, $42omo.createContext)({
    ancestors: []
});
const $18fee0a06ef04028$export$109af415c07093f3 = ({ id: id, name: name, priority: priority, rootForServerPlaceholderId: rootForServerPlaceholderId, isReactLoadable: isReactLoadable })=>{
    // Returns an array of Loadable names that appear as ancestors,
    // including the current one if `self` is supplied.
    const { ancestors: ancestors } = (0, $42omo.useContext)($18fee0a06ef04028$export$5a6fb2dde15997f8);
    const parent = ancestors[0];
    // Loadable names should be static, so this array should never be
    // recomputed to avoid excessive re-renders
    const [ancestorsIncludingSelf] = (0, $42omo.useState)(()=>[
            {
                id: id || name,
                name: name,
                priority: priority,
                rootForServerPlaceholderId: rootForServerPlaceholderId ?? false,
                isReactLoadable: isReactLoadable ?? false
            }
        ].concat(ancestors));
    if (parent && priority === (0, $398ES.LoadingPriority).PAINT && priority < parent.priority) return [
        false,
        parent,
        ancestorsIncludingSelf
    ];
    return [
        true,
        parent,
        ancestorsIncludingSelf
    ];
};
const $18fee0a06ef04028$export$1349e294f501f033 = (priority)=>{
    const { ancestors: ancestors } = (0, $42omo.useContext)($18fee0a06ef04028$export$5a6fb2dde15997f8);
    const ancestor = ancestors.find((ancestor)=>ancestor.isReactLoadable);
    // if ancestor is AFTER_PAINT and current is PAINT. Correct the current
    if (ancestor && ancestor.priority > priority) return ancestor.priority;
    return priority;
};
const $18fee0a06ef04028$export$4767a5b9f9a4f709 = (props)=>{
    const [correct, parent, ancestorsIncludingSelf] = $18fee0a06ef04028$export$109af415c07093f3(props);
    const { name: name, placeholderReplaceId: placeholderReplaceId, priority: priority, children: children } = props;
    // This setting allows to display the outline for Loadable components with a
    // specific priority, which helps to troubleshoot the page loading performance.
    let priorityToOutline = -1;
    try {
        // handle The "operation is insecure" when cookie is disabled
        priorityToOutline = typeof window !== 'undefined' ? Number((0, $17wUi.confluenceSessionStorageInstance)?.getItem((0, $1UApO.keys).CONFLUENCE_SSR_OUTLINE_PRIORITY) || '-1') : -1;
    } catch (e) {}
    const wrappedChildren = priorityToOutline === priority ? (0, $lojHn.withOutline)($18fee0a06ef04028$var$PRIORITY_COLORS[priority], children) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($18fee0a06ef04028$export$5a6fb2dde15997f8.Provider, {
        value: (0, $42omo.useMemo)(()=>({
                ancestors: ancestorsIncludingSelf,
                placeholderReplaceId: placeholderReplaceId
            }), [
            ancestorsIncludingSelf,
            placeholderReplaceId
        ])
    }, wrappedChildren);
};
module.exports["LoadableAncestorsContext"] = $18fee0a06ef04028$export$5a6fb2dde15997f8;
module.exports["useAutoCorrectPriorityWithAncestor"] = $18fee0a06ef04028$export$1349e294f501f033;
module.exports["LoadableAncestorsProvider"] = $18fee0a06ef04028$export$4767a5b9f9a4f709;

});

parcelRegister("gIaMn", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $8f1e2b66ad569311$export$60fcc451eb1e9eeb = /*#__PURE__*/ function(ActivationTriggerType) {
    ActivationTriggerType["HOVER"] = "hover";
    ActivationTriggerType["IMMEDIATE"] = "immediate";
    ActivationTriggerType["SCROLL_INTO_VIEW"] = "scroll_into_view";
    return ActivationTriggerType;
}({});
var $8f1e2b66ad569311$export$d6d766bc143f7f7 = /*#__PURE__*/ function(ActivationReason) {
    ActivationReason["AUTO_TIMEOUT"] = "auto-timeout";
    ActivationReason["USER_ACTIVATION"] = "user-activation";
    ActivationReason["IMMEDIATE_UNLOCK"] = "immediate-unlock";
    ActivationReason["FALLBACK"] = "fallback";
    return ActivationReason;
}({});
module.exports["ActivationTriggerType"] = $8f1e2b66ad569311$export$60fcc451eb1e9eeb;
module.exports["ActivationReason"] = $8f1e2b66ad569311$export$d6d766bc143f7f7;

});

parcelRegister("5Abqh", function(module, exports) {
const $dbe1faed53254825$export$816adaed6346a011 = {
    AdminAnnouncementBanner: 'AdminAnnouncementBanner',
    PageTree: 'PageTree',
    AnalyticsByLine: 'AnalyticsByLine',
    EndOfPageRecommendation: 'EndOfPageRecommendation'
};
let $dbe1faed53254825$var$ssrPartialSuccess = null;
function $dbe1faed53254825$export$c248d402f991de43(name) {}
const $dbe1faed53254825$export$f2067e89b3060d54 = ({ name: name })=>{
    $dbe1faed53254825$export$c248d402f991de43(name);
    return null;
};
function $dbe1faed53254825$export$333ae8817a24741a(name) {
    if (!$dbe1faed53254825$var$ssrPartialSuccess) $dbe1faed53254825$var$ssrPartialSuccess = window.__SSR_PARTIAL_SUCCESS__ || {};
    return Boolean($dbe1faed53254825$var$ssrPartialSuccess[name]);
}
function $dbe1faed53254825$export$afda26353a9720a7() {
    return $dbe1faed53254825$var$ssrPartialSuccess;
}
function $dbe1faed53254825$export$dc2046fd74b6895c() {
    $dbe1faed53254825$var$ssrPartialSuccess = null;
}
module.exports["SSR_PARTIAL_COMPONENT"] = $dbe1faed53254825$export$816adaed6346a011;
module.exports["setSSRPartialSuccess"] = $dbe1faed53254825$export$c248d402f991de43;
module.exports["SetSSRPartialSuccess"] = $dbe1faed53254825$export$f2067e89b3060d54;
module.exports["checkSSRPartialSuccess"] = $dbe1faed53254825$export$333ae8817a24741a;

});

parcelRegister("l5z6t", function(module, exports) {

let $f5a54b63e91b571e$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("6wHgv"), 5)),
    $f5a54b63e91b571e$var$load("UnKVe")
]).then(()=>parcelRequire('2rIPr'));

});

parcelRegister("alui6", function(module, exports) {
"use strict";

var $h4lNe = parcelRequire("h4lNe");

module.exports = $h4lNe(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        let isCurrentBundle = function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});

parcelRegister("h4lNe", function(module, exports) {
"use strict";
let $c6d3b70899d3a8aa$var$cachedBundles = {};
let $c6d3b70899d3a8aa$var$cachedPreloads = {};
let $c6d3b70899d3a8aa$var$cachedPrefetches = {};
function $c6d3b70899d3a8aa$var$getCache(type) {
    switch(type){
        case 'preload':
            return $c6d3b70899d3a8aa$var$cachedPreloads;
        case 'prefetch':
            return $c6d3b70899d3a8aa$var$cachedPrefetches;
        default:
            return $c6d3b70899d3a8aa$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $c6d3b70899d3a8aa$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});

parcelRegister("9K4OG", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("6dGgK")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("6dGgK")).w);

var $6dGgK = parcelRequire("6dGgK");


var $42omo = parcelRequire("42omo");


var $dmgN7 = parcelRequire("dmgN7");


var $jjudR = parcelRequire("jjudR");


var $g2YHK = parcelRequire("g2YHK");

parcelRequire("egy7N");

parcelRequire("7Q5yr");

parcelRequire("jZwD7");


parcelRequire("56GFp");

var $717c25612b091e83$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $717c25612b091e83$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $6dGgK.h).call(props, 'css')) // $FlowFixMe
    return $42omo.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $6dGgK.E);
    createElementArgArray[1] = (0, $6dGgK.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $42omo.createElement.apply(null, createElementArgArray);
};
var $717c25612b091e83$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $717c25612b091e83$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $6dGgK.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $g2YHK.serializeStyles)([
        styles
    ], undefined, $42omo.useContext((0, $6dGgK.T)));
    if (!(0, $6dGgK.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $42omo.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $42omo.useRef();
    (0, $jjudR.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $jjudR.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $dmgN7.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $717c25612b091e83$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $g2YHK.serializeStyles)(args);
}
var $717c25612b091e83$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $717c25612b091e83$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $717c25612b091e83$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $717c25612b091e83$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $dmgN7.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $717c25612b091e83$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $jjudR.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $dmgN7.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $717c25612b091e83$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $6dGgK.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $g2YHK.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $dmgN7.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $717c25612b091e83$var$merge(cache.registered, css, $717c25612b091e83$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $42omo.useContext((0, $6dGgK.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement($717c25612b091e83$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $717c25612b091e83$var$isBrowser, $717c25612b091e83$var$isTestEnv, $717c25612b091e83$var$globalContext, $717c25612b091e83$var$globalKey;
module.exports["Global"] = $717c25612b091e83$export$98f03c5d19621d70;
module.exports["css"] = $717c25612b091e83$export$dbf350e5966cf602;
module.exports["keyframes"] = $717c25612b091e83$export$d25ddfdf17c3ad3e;
module.exports["ClassNames"] = $717c25612b091e83$export$9b9c0f9d9f3552b8;
module.exports["jsx"] = $717c25612b091e83$export$c8a8987d4410bf2d;

});

parcelRegister("a9dFP", function(module, exports) {
const $813968f9df797436$export$4ef52930e33717cd = 'data-theme';
const $813968f9df797436$export$a00eac3f8684bcd0 = 'data-color-mode';
const $813968f9df797436$export$2112803007239c61 = 'data-contrast-mode';
const $813968f9df797436$export$352e418ed5b6193a = 'data-custom-theme';
const $813968f9df797436$export$6f0c6fb8c80fcc92 = 'ds';
const $813968f9df797436$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
const $813968f9df797436$export$dddac1532e822863 = `--${$813968f9df797436$export$6f0c6fb8c80fcc92}-token-not-found`;
const $813968f9df797436$export$9d7b58831ae93caa = `--${$813968f9df797436$export$6f0c6fb8c80fcc92}-elevation-surface-current`;
module.exports["THEME_DATA_ATTRIBUTE"] = $813968f9df797436$export$4ef52930e33717cd;
module.exports["COLOR_MODE_ATTRIBUTE"] = $813968f9df797436$export$a00eac3f8684bcd0;
module.exports["CONTRAST_MODE_ATTRIBUTE"] = $813968f9df797436$export$2112803007239c61;
module.exports["CUSTOM_THEME_ATTRIBUTE"] = $813968f9df797436$export$352e418ed5b6193a;
module.exports["CURRENT_SURFACE_CSS_VAR"] = $813968f9df797436$export$9d7b58831ae93caa;

});

parcelRegister("cgtv4", function(module, exports) {
$parcel$export(module.exports, "FormattedDateTimeRange", () => (parcelRequire("g0khF")).default);
$parcel$export(module.exports, "FormattedMessage", () => (parcelRequire("gtD4K")).default);
$parcel$export(module.exports, "FormattedPlural", () => (parcelRequire("bCOYK")).default);
$parcel$export(module.exports, "FormattedRelativeTime", () => (parcelRequire("a2dru")).default);
$parcel$export(module.exports, "IntlContext", () => (parcelRequire("gmMgo")).Context);
$parcel$export(module.exports, "IntlProvider", () => (parcelRequire("1e2E5")).default);
$parcel$export(module.exports, "RawIntlProvider", () => (parcelRequire("gmMgo")).Provider);
$parcel$export(module.exports, "createIntl", () => (parcelRequire("1e2E5")).createIntl);
$parcel$export(module.exports, "injectIntl", () => (parcelRequire("gmMgo")).default);
$parcel$export(module.exports, "useIntl", () => (parcelRequire("8C5kA")).default);
$parcel$export(module.exports, "createIntlCache", () => (parcelRequire("fI8ba")).createIntlCache);
$parcel$export(module.exports, "UnsupportedFormatterError", () => (parcelRequire("6ttb4")).UnsupportedFormatterError);
$parcel$export(module.exports, "InvalidConfigError", () => (parcelRequire("6ttb4")).InvalidConfigError);
$parcel$export(module.exports, "MissingDataError", () => (parcelRequire("6ttb4")).MissingDataError);
$parcel$export(module.exports, "MessageFormatError", () => (parcelRequire("6ttb4")).MessageFormatError);
$parcel$export(module.exports, "MissingTranslationError", () => (parcelRequire("6ttb4")).MissingTranslationError);
$parcel$export(module.exports, "ReactIntlErrorCode", () => (parcelRequire("6ttb4")).IntlErrorCode);
$parcel$export(module.exports, "ReactIntlError", () => (parcelRequire("6ttb4")).IntlError);
$parcel$export(module.exports, "FormattedNumberParts", () => (parcelRequire("6iiHx")).FormattedNumberParts);
$parcel$export(module.exports, "FormattedListParts", () => (parcelRequire("6iiHx")).FormattedListParts);

var $6iiHx = parcelRequire("6iiHx");


var $gmMgo = parcelRequire("gmMgo");


var $8C5kA = parcelRequire("8C5kA");


var $1e2E5 = parcelRequire("1e2E5");


var $a2dru = parcelRequire("a2dru");


var $bCOYK = parcelRequire("bCOYK");


var $gtD4K = parcelRequire("gtD4K");


var $g0khF = parcelRequire("g0khF");


var $fI8ba = parcelRequire("fI8ba");

var $6ttb4 = parcelRequire("6ttb4");

function $8edddcc6c7b52069$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $8edddcc6c7b52069$export$747d244ee58120dd(msg) {
    return msg;
}
var $8edddcc6c7b52069$export$40ae3194919d16b = (0, $6iiHx.createFormattedComponent)('formatDate');
var $8edddcc6c7b52069$export$5b390a54f8a846f7 = (0, $6iiHx.createFormattedComponent)('formatTime');
var $8edddcc6c7b52069$export$db80edc1e6b2f63d = (0, $6iiHx.createFormattedComponent)('formatNumber');
var $8edddcc6c7b52069$export$f52b44e459e6e71d = (0, $6iiHx.createFormattedComponent)('formatList');
var $8edddcc6c7b52069$export$c2336ea5aaab92fa = (0, $6iiHx.createFormattedComponent)('formatDisplayName');
var $8edddcc6c7b52069$export$7fdc7d2c91ce149b = (0, $6iiHx.createFormattedDateTimePartsComponent)('formatDate');
var $8edddcc6c7b52069$export$ec35873761676c2a = (0, $6iiHx.createFormattedDateTimePartsComponent)('formatTime');
module.exports["defineMessages"] = $8edddcc6c7b52069$export$1adfeb024f5185b;
module.exports["defineMessage"] = $8edddcc6c7b52069$export$747d244ee58120dd;
module.exports["FormattedDate"] = $8edddcc6c7b52069$export$40ae3194919d16b;
module.exports["FormattedTime"] = $8edddcc6c7b52069$export$5b390a54f8a846f7;
module.exports["FormattedNumber"] = $8edddcc6c7b52069$export$db80edc1e6b2f63d;
module.exports["FormattedList"] = $8edddcc6c7b52069$export$f52b44e459e6e71d;
module.exports["FormattedDisplayName"] = $8edddcc6c7b52069$export$c2336ea5aaab92fa;
module.exports["FormattedDateParts"] = $8edddcc6c7b52069$export$7fdc7d2c91ce149b;
module.exports["FormattedTimeParts"] = $8edddcc6c7b52069$export$ec35873761676c2a;

});

parcelRegister("8C5kA", function(module, exports) {
$parcel$export(module.exports, "default", () => $645601f8cef5e2a6$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $lIKdq = parcelRequire("lIKdq");

function $645601f8cef5e2a6$export$2e2bcd8739ae039() {
    var intl = $42omo.useContext((0, $gmMgo.Context));
    (0, $lIKdq.invariantIntlContext)(intl);
    return intl;
}

});

parcelRegister("gmMgo", function(module, exports) {
$parcel$export(module.exports, "default", () => $bea423835c8c4b69$export$2e2bcd8739ae039);

var $hXuPC = parcelRequire("hXuPC");


var $42omo = parcelRequire("42omo");


var $56GFp = parcelRequire("56GFp");


var $lIKdq = parcelRequire("lIKdq");

function $bea423835c8c4b69$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// TODO: We should provide initial value here
var $bea423835c8c4b69$var$IntlContext = $42omo.createContext(null);
var $bea423835c8c4b69$var$IntlConsumer = $bea423835c8c4b69$var$IntlContext.Consumer, $bea423835c8c4b69$var$IntlProvider = $bea423835c8c4b69$var$IntlContext.Provider;
var $bea423835c8c4b69$export$2881499e37b75b9a = $bea423835c8c4b69$var$IntlProvider;
var $bea423835c8c4b69$export$841858b892ce1f4c = $bea423835c8c4b69$var$IntlContext;
function $bea423835c8c4b69$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $42omo.createElement($bea423835c8c4b69$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $lIKdq.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $42omo.createElement(WrappedComponent, (0, $hXuPC.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($bea423835c8c4b69$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($56GFp)))($42omo.forwardRef(function(props, ref) {
        return $42omo.createElement(WithIntl, (0, $hXuPC.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($56GFp)))(WithIntl, WrappedComponent);
}
module.exports["Provider"] = $bea423835c8c4b69$export$2881499e37b75b9a;
module.exports["Context"] = $bea423835c8c4b69$export$841858b892ce1f4c;

});

parcelRegister("fI8ba", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $29bcO = parcelRequire("29bcO");

//
// Main
//
function $204ad0462242bda5$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $204ad0462242bda5$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $204ad0462242bda5$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $204ad0462242bda5$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $204ad0462242bda5$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $204ad0462242bda5$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $204ad0462242bda5$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $204ad0462242bda5$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $204ad0462242bda5$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $204ad0462242bda5$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $204ad0462242bda5$var$monadic : $204ad0462242bda5$var$variadic;
    return $204ad0462242bda5$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $204ad0462242bda5$var$strategyVariadic(fn, options) {
    return $204ad0462242bda5$var$assemble(fn, this, $204ad0462242bda5$var$variadic, options.cache.create(), options.serializer);
}
function $204ad0462242bda5$var$strategyMonadic(fn, options) {
    return $204ad0462242bda5$var$assemble(fn, this, $204ad0462242bda5$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $204ad0462242bda5$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $204ad0462242bda5$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$204ad0462242bda5$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$204ad0462242bda5$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $204ad0462242bda5$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $204ad0462242bda5$var$ObjectWithoutPrototypeCache();
    }
};
var $204ad0462242bda5$export$c5491a8691a23b9e = {
    variadic: $204ad0462242bda5$var$strategyVariadic,
    monadic: $204ad0462242bda5$var$strategyMonadic
};



var $6ttb4 = parcelRequire("6ttb4");

function $b7014f4709127b76$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $b7014f4709127b76$var$defaultErrorHandler = function(error) {};
var $b7014f4709127b76$var$defaultWarnHandler = function(warning) {};
var $b7014f4709127b76$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $b7014f4709127b76$var$defaultErrorHandler,
    onWarn: $b7014f4709127b76$var$defaultWarnHandler
};
function $b7014f4709127b76$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $b7014f4709127b76$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $b7014f4709127b76$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $b7014f4709127b76$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $204ad0462242bda5$export$2e2bcd8739ae039)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $hXuPC.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b7014f4709127b76$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $204ad0462242bda5$export$c5491a8691a23b9e).variadic
    });
    var getNumberFormat = (0, $204ad0462242bda5$export$2e2bcd8739ae039)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $hXuPC.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b7014f4709127b76$var$createFastMemoizeCache(cache.number),
        strategy: (0, $204ad0462242bda5$export$c5491a8691a23b9e).variadic
    });
    var getPluralRules = (0, $204ad0462242bda5$export$2e2bcd8739ae039)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $hXuPC.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b7014f4709127b76$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $204ad0462242bda5$export$c5491a8691a23b9e).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $204ad0462242bda5$export$2e2bcd8739ae039)(function(message, locales, overrideFormats, opts) {
            return new (0, $29bcO.IntlMessageFormat)(message, locales, overrideFormats, (0, $hXuPC.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $b7014f4709127b76$var$createFastMemoizeCache(cache.message),
            strategy: (0, $204ad0462242bda5$export$c5491a8691a23b9e).variadic
        }),
        getRelativeTimeFormat: (0, $204ad0462242bda5$export$2e2bcd8739ae039)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $hXuPC.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b7014f4709127b76$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $204ad0462242bda5$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $204ad0462242bda5$export$2e2bcd8739ae039)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $hXuPC.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b7014f4709127b76$var$createFastMemoizeCache(cache.list),
            strategy: (0, $204ad0462242bda5$export$c5491a8691a23b9e).variadic
        }),
        getDisplayNames: (0, $204ad0462242bda5$export$2e2bcd8739ae039)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $hXuPC.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b7014f4709127b76$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $204ad0462242bda5$export$c5491a8691a23b9e).variadic
        })
    };
}
function $b7014f4709127b76$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $6ttb4.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}
module.exports["filterProps"] = $b7014f4709127b76$export$d697c39a2985a4c;
module.exports["DEFAULT_INTL_CONFIG"] = $b7014f4709127b76$export$b52f8d6fc0d47415;
module.exports["createIntlCache"] = $b7014f4709127b76$export$51c4f4e973f2dc00;
module.exports["createFormatters"] = $b7014f4709127b76$export$c3f4cd5551df13fd;
module.exports["getNamedFormat"] = $b7014f4709127b76$export$4ee1db8ce44a209b;

});

parcelRegister("1e2E5", function(module, exports) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $hXuPC = parcelRequire("hXuPC");


var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $lIKdq = parcelRequire("lIKdq");





var $fI8ba = parcelRequire("fI8ba");


var $6ttb4 = parcelRequire("6ttb4");







var $8ffafcde33565743$var$NUMBER_FORMAT_OPTIONS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem'
];
function $8ffafcde33565743$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $fI8ba.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $fI8ba.filterProps)(options, $8ffafcde33565743$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $8ffafcde33565743$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $8ffafcde33565743$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $6ttb4.IntlError)((0, $6ttb4.IntlErrorCode).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return String(value);
}
function $8ffafcde33565743$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $8ffafcde33565743$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $6ttb4.IntlError)((0, $6ttb4.IntlErrorCode).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return [];
}






var $lRVkV = parcelRequire("lRVkV");




var $c4ba3f77c88d1a20$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $c4ba3f77c88d1a20$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $fI8ba.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $fI8ba.filterProps)(options, $c4ba3f77c88d1a20$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $c4ba3f77c88d1a20$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $lRVkV.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $lRVkV.ErrorCode).MISSING_INTL_API));
    try {
        return $c4ba3f77c88d1a20$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $6ttb4.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}











var $ac304f57ccc25c76$var$DATE_TIME_FORMAT_OPTIONS = [
    'localeMatcher',
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem'
];
function $ac304f57ccc25c76$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $fI8ba.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $fI8ba.filterProps)(options, $ac304f57ccc25c76$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $ac304f57ccc25c76$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $ac304f57ccc25c76$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $6ttb4.IntlError)((0, $6ttb4.IntlErrorCode).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return String(date);
}
function $ac304f57ccc25c76$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $ac304f57ccc25c76$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $6ttb4.IntlError)((0, $6ttb4.IntlErrorCode).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return String(date);
}
function $ac304f57ccc25c76$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $fI8ba.filterProps)(options, $ac304f57ccc25c76$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $6ttb4.IntlError)((0, $6ttb4.IntlErrorCode).FORMAT_ERROR, 'Error formatting date time range.', e));
    }
    return String(from);
}
function $ac304f57ccc25c76$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $ac304f57ccc25c76$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $6ttb4.IntlError)((0, $6ttb4.IntlErrorCode).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return [];
}
function $ac304f57ccc25c76$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $ac304f57ccc25c76$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $6ttb4.IntlError)((0, $6ttb4.IntlErrorCode).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return [];
}











var $1217f71b7d4a4e07$var$PLURAL_FORMAT_OPTIONS = [
    'localeMatcher',
    'type'
];
function $1217f71b7d4a4e07$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $lRVkV.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $lRVkV.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $fI8ba.filterProps)(options, $1217f71b7d4a4e07$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $6ttb4.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}





/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $8daf0d310f2eedfd$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $8daf0d310f2eedfd$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $8daf0d310f2eedfd$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $8daf0d310f2eedfd$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $8daf0d310f2eedfd$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $8daf0d310f2eedfd$export$3fae2929ed23c202(map, pl, field) {
    return $8daf0d310f2eedfd$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $8daf0d310f2eedfd$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $8daf0d310f2eedfd$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $8daf0d310f2eedfd$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $8daf0d310f2eedfd$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $8daf0d310f2eedfd$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}



var $29bcO = parcelRequire("29bcO");









var $cd3080ca2efa65a0$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($cd3080ca2efa65a0$export$896afd8541959ee5 || ($cd3080ca2efa65a0$export$896afd8541959ee5 = {}));







var $d2KKO = parcelRequire("d2KKO");

// @generated from regex-gen.ts
var $145896b2e53cf72d$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $145896b2e53cf72d$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;


parcelRequire("eqdqo");
var $4Duar = parcelRequire("4Duar");
var $alwPZ = parcelRequire("alwPZ");

// @generated from time-data-gen.ts
// prettier-ignore  
var $d002a2e7c7a8c25b$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};


function $bc9d4a00af30f539$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $bc9d4a00af30f539$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $bc9d4a00af30f539$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $d002a2e7c7a8c25b$export$a8c9209db4084317)[regionTag || ''] || (0, $d002a2e7c7a8c25b$export$a8c9209db4084317)[languageTag || ''] || (0, $d002a2e7c7a8c25b$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $d002a2e7c7a8c25b$export$a8c9209db4084317)['001'];
    return hourCycles[0];
}


var $5ce7bdfe2fa4d133$var$_a;
var $5ce7bdfe2fa4d133$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $145896b2e53cf72d$export$523451f94304dd6c).source, "*"));
var $5ce7bdfe2fa4d133$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $145896b2e53cf72d$export$523451f94304dd6c).source, "*$"));
function $5ce7bdfe2fa4d133$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $5ce7bdfe2fa4d133$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $5ce7bdfe2fa4d133$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $5ce7bdfe2fa4d133$var$hasNativeFromEntries = !!Object.fromEntries;
var $5ce7bdfe2fa4d133$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $5ce7bdfe2fa4d133$var$hasTrimStart = !!String.prototype.trimStart;
var $5ce7bdfe2fa4d133$var$hasTrimEnd = !!String.prototype.trimEnd;
var $5ce7bdfe2fa4d133$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $5ce7bdfe2fa4d133$var$isSafeInteger = $5ce7bdfe2fa4d133$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $5ce7bdfe2fa4d133$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $5ce7bdfe2fa4d133$var$re = $5ce7bdfe2fa4d133$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $5ce7bdfe2fa4d133$var$REGEX_SUPPORTS_U_AND_Y = (($5ce7bdfe2fa4d133$var$_a = $5ce7bdfe2fa4d133$var$re.exec('a')) === null || $5ce7bdfe2fa4d133$var$_a === void 0 ? void 0 : $5ce7bdfe2fa4d133$var$_a[0]) === 'a';
} catch (_) {
    $5ce7bdfe2fa4d133$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $5ce7bdfe2fa4d133$var$startsWith = $5ce7bdfe2fa4d133$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $5ce7bdfe2fa4d133$var$fromCodePoint = $5ce7bdfe2fa4d133$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $5ce7bdfe2fa4d133$var$fromEntries = // native
$5ce7bdfe2fa4d133$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $5ce7bdfe2fa4d133$var$codePointAt = $5ce7bdfe2fa4d133$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $5ce7bdfe2fa4d133$var$trimStart = $5ce7bdfe2fa4d133$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($5ce7bdfe2fa4d133$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $5ce7bdfe2fa4d133$var$trimEnd = $5ce7bdfe2fa4d133$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($5ce7bdfe2fa4d133$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $5ce7bdfe2fa4d133$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $5ce7bdfe2fa4d133$var$matchIdentifierAtIndex;
if ($5ce7bdfe2fa4d133$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $5ce7bdfe2fa4d133$var$IDENTIFIER_PREFIX_RE_1 = $5ce7bdfe2fa4d133$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $5ce7bdfe2fa4d133$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $5ce7bdfe2fa4d133$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $5ce7bdfe2fa4d133$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$5ce7bdfe2fa4d133$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $5ce7bdfe2fa4d133$var$codePointAt(s, index);
        if (c === undefined || $5ce7bdfe2fa4d133$var$_isWhiteSpace(c) || $5ce7bdfe2fa4d133$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $5ce7bdfe2fa4d133$var$fromCodePoint.apply(void 0, match);
};
var $5ce7bdfe2fa4d133$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $d2KKO.TYPE).pound,
                    location: $5ce7bdfe2fa4d133$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $5ce7bdfe2fa4d133$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $5ce7bdfe2fa4d133$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $d2KKO.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $5ce7bdfe2fa4d133$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$5ce7bdfe2fa4d133$var$_isAlpha(this.char())) return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).INVALID_TAG, $5ce7bdfe2fa4d133$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $5ce7bdfe2fa4d133$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).INVALID_TAG, $5ce7bdfe2fa4d133$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $d2KKO.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $5ce7bdfe2fa4d133$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).UNCLOSED_TAG, $5ce7bdfe2fa4d133$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).INVALID_TAG, $5ce7bdfe2fa4d133$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $5ce7bdfe2fa4d133$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $5ce7bdfe2fa4d133$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $d2KKO.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$5ce7bdfe2fa4d133$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $5ce7bdfe2fa4d133$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $5ce7bdfe2fa4d133$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $5ce7bdfe2fa4d133$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).EMPTY_ARGUMENT, $5ce7bdfe2fa4d133$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).MALFORMED_ARGUMENT, $5ce7bdfe2fa4d133$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $5ce7bdfe2fa4d133$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $d2KKO.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $5ce7bdfe2fa4d133$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $5ce7bdfe2fa4d133$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).MALFORMED_ARGUMENT, $5ce7bdfe2fa4d133$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $5ce7bdfe2fa4d133$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $5ce7bdfe2fa4d133$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $5ce7bdfe2fa4d133$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $5ce7bdfe2fa4d133$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $5ce7bdfe2fa4d133$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $5ce7bdfe2fa4d133$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $5ce7bdfe2fa4d133$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $5ce7bdfe2fa4d133$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $5ce7bdfe2fa4d133$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $d2KKO.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $bc9d4a00af30f539$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $d2KKO.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $4Duar.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $d2KKO.TYPE).date : (0, $d2KKO.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $d2KKO.TYPE).number : argType === 'date' ? (0, $d2KKO.TYPE).date : (0, $d2KKO.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $5ce7bdfe2fa4d133$var$createLocation(typeEndPosition_1, (0, $hXuPC.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $5ce7bdfe2fa4d133$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $cd3080ca2efa65a0$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $cd3080ca2efa65a0$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $5ce7bdfe2fa4d133$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $d2KKO.TYPE).select,
                        value: value,
                        options: $5ce7bdfe2fa4d133$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $d2KKO.TYPE).plural,
                        value: value,
                        options: $5ce7bdfe2fa4d133$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $5ce7bdfe2fa4d133$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $5ce7bdfe2fa4d133$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $5ce7bdfe2fa4d133$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $alwPZ.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $d2KKO.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $alwPZ.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $cd3080ca2efa65a0$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $cd3080ca2efa65a0$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $5ce7bdfe2fa4d133$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $cd3080ca2efa65a0$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $cd3080ca2efa65a0$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $cd3080ca2efa65a0$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $cd3080ca2efa65a0$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $5ce7bdfe2fa4d133$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $5ce7bdfe2fa4d133$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $cd3080ca2efa65a0$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $cd3080ca2efa65a0$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $5ce7bdfe2fa4d133$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $cd3080ca2efa65a0$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $5ce7bdfe2fa4d133$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $5ce7bdfe2fa4d133$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$5ce7bdfe2fa4d133$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $5ce7bdfe2fa4d133$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($5ce7bdfe2fa4d133$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $5ce7bdfe2fa4d133$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $5ce7bdfe2fa4d133$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $5ce7bdfe2fa4d133$var$_isAlphaOrSlash(codepoint) {
    return $5ce7bdfe2fa4d133$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $5ce7bdfe2fa4d133$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $5ce7bdfe2fa4d133$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $5ce7bdfe2fa4d133$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}





function $31cb7a3d7bc7069a$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $d2KKO.isSelectElement)(el) || (0, $d2KKO.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $31cb7a3d7bc7069a$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $d2KKO.isNumberElement)(el) && (0, $d2KKO.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $d2KKO.isDateElement)(el) || (0, $d2KKO.isTimeElement)(el)) && (0, $d2KKO.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $d2KKO.isTagElement)(el)) $31cb7a3d7bc7069a$var$pruneLocation(el.children);
    });
}
function $31cb7a3d7bc7069a$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $hXuPC.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $5ce7bdfe2fa4d133$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $cd3080ca2efa65a0$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $31cb7a3d7bc7069a$var$pruneLocation(result.val);
    return result.val;
}


function $b0a0312a8f8cbe46$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $hXuPC.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $b0a0312a8f8cbe46$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $b0a0312a8f8cbe46$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $29bcO.IntlMessageFormat).formats;
    return (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, mfFormats), f1), {
        date: $b0a0312a8f8cbe46$var$deepMergeOptions($b0a0312a8f8cbe46$var$setTimeZoneInOptions(mfFormats.date, timeZone), $b0a0312a8f8cbe46$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $b0a0312a8f8cbe46$var$deepMergeOptions($b0a0312a8f8cbe46$var$setTimeZoneInOptions(mfFormats.time, timeZone), $b0a0312a8f8cbe46$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
function $b0a0312a8f8cbe46$export$25868d1e8e76735f(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $8daf0d310f2eedfd$export$f5708dca728d7177)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $d2KKO.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, defaultRichTextElements), values || {});
    formats = $b0a0312a8f8cbe46$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $b0a0312a8f8cbe46$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $6ttb4.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $6ttb4.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $hXuPC.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $6ttb4.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $6ttb4.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
}














var $607c342b1fbf59ec$var$LIST_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
    'style'
];
var $607c342b1fbf59ec$var$now = Date.now();
function $607c342b1fbf59ec$var$generateToken(i) {
    return "".concat($607c342b1fbf59ec$var$now, "_").concat(i, "_").concat($607c342b1fbf59ec$var$now);
}
function $607c342b1fbf59ec$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $607c342b1fbf59ec$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function $607c342b1fbf59ec$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $lRVkV.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $lRVkV.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $fI8ba.filterProps)(options, $607c342b1fbf59ec$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $607c342b1fbf59ec$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $6ttb4.IntlError)((0, $6ttb4.IntlErrorCode).FORMAT_ERROR, 'Error formatting list.', e));
    }
    // @ts-ignore
    return values;
}











var $f706d2d27669af07$var$DISPLAY_NAMES_OPTONS = [
    'localeMatcher',
    'style',
    'type',
    'fallback'
];
function $f706d2d27669af07$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $lRVkV.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $lRVkV.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $fI8ba.filterProps)(options, $f706d2d27669af07$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $6ttb4.IntlError)((0, $6ttb4.IntlErrorCode).FORMAT_ERROR, 'Error formatting display name.', e));
    }
}


function $23e37139fee188c6$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $23e37139fee188c6$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $23e37139fee188c6$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $23e37139fee188c6$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $fI8ba.createFormatters)(cache);
    var resolvedConfig = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, (0, $fI8ba.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $6ttb4.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $6ttb4.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $6ttb4.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $23e37139fee188c6$var$verifyConfigMessages(resolvedConfig);
    return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $8ffafcde33565743$export$f5dd818bff069720).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $8ffafcde33565743$export$6871080848f10b2f).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $c4ba3f77c88d1a20$export$b4ea3b48dcf921f6).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $ac304f57ccc25c76$export$3ae94a2503e890a1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $ac304f57ccc25c76$export$dc1f059bce486b1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $ac304f57ccc25c76$export$3203edd9e5edd663).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $ac304f57ccc25c76$export$a7fc3a91cb2ec376).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $ac304f57ccc25c76$export$af6e5d7a5c73edeb).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $1217f71b7d4a4e07$export$bbbd05c900f3568d).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $b0a0312a8f8cbe46$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        $t: (0, $b0a0312a8f8cbe46$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        formatList: (0, $607c342b1fbf59ec$export$e8b8be48b45905bb).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $607c342b1fbf59ec$export$6f284aad1934db69).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $f706d2d27669af07$export$62fe1a4d9e891fa2).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}





var $eUSop = parcelRequire("eUSop");

function $0e49269b6c09a680$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $0e49269b6c09a680$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $eUSop.isFormatXMLElementFn)(v) ? (0, $lIKdq.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $0e49269b6c09a680$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $0e49269b6c09a680$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $b0a0312a8f8cbe46$export$25868d1e8e76735f).apply(void 0, (0, $hXuPC.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $42omo.Children.toArray(chunks);
    return chunks;
};
var $0e49269b6c09a680$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $hXuPC.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $0e49269b6c09a680$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $23e37139fee188c6$export$7e4cbedfdd7b4c0d)((0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, (0, $lIKdq.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, coreIntl), {
        formatMessage: $0e49269b6c09a680$var$formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements
        }, coreIntl.formatters)
    });
};
var $0e49269b6c09a680$var$IntlProvider = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $fI8ba.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $0e49269b6c09a680$export$7e4cbedfdd7b4c0d($0e49269b6c09a680$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $0e49269b6c09a680$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $0e49269b6c09a680$var$processIntlConfig(props);
        if (!(0, $lIKdq.shallowEqual)(prevConfig, config)) return {
            intl: $0e49269b6c09a680$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $lIKdq.invariantIntlContext)(this.state.intl);
        return $42omo.createElement((0, $gmMgo.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $lIKdq.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($42omo.PureComponent);
var $0e49269b6c09a680$export$2e2bcd8739ae039 = $0e49269b6c09a680$var$IntlProvider;
module.exports["createIntl"] = $0e49269b6c09a680$export$7e4cbedfdd7b4c0d;
module.exports["default"] = $0e49269b6c09a680$export$2e2bcd8739ae039;

});

parcelRegister("a2dru", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $42omo = parcelRequire("42omo");


var $eZGdB = parcelRequire("eZGdB");


var $8C5kA = parcelRequire("8C5kA");

var $74e484adc399c5b2$var$MINUTE = 60;
var $74e484adc399c5b2$var$HOUR = 3600;
var $74e484adc399c5b2$var$DAY = 86400;
function $74e484adc399c5b2$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $74e484adc399c5b2$var$MINUTE) return 'second';
    if (absValue < $74e484adc399c5b2$var$HOUR) return 'minute';
    if (absValue < $74e484adc399c5b2$var$DAY) return 'hour';
    return 'day';
}
function $74e484adc399c5b2$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $74e484adc399c5b2$var$MINUTE;
        case 'hour':
            return $74e484adc399c5b2$var$HOUR;
        default:
            return $74e484adc399c5b2$var$DAY;
    }
}
function $74e484adc399c5b2$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $74e484adc399c5b2$var$MINUTE;
        default:
            return value * $74e484adc399c5b2$var$HOUR;
    }
}
var $74e484adc399c5b2$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $74e484adc399c5b2$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $74e484adc399c5b2$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $74e484adc399c5b2$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $8C5kA.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $hXuPC.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $42omo.createElement(Text, null, formattedRelativeTime);
    return $42omo.createElement($42omo.Fragment, null, formattedRelativeTime);
};
var $74e484adc399c5b2$var$FormattedRelativeTime = function(_a) {
    var value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $hXuPC.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $eZGdB.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $74e484adc399c5b2$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _b = $42omo.useState(), prevUnit = _b[0], setPrevUnit = _b[1];
    var _c = $42omo.useState(0), prevValue = _c[0], setPrevValue = _c[1];
    var _d = $42omo.useState(0), currentValueInSeconds = _d[0], setCurrentValueInSeconds = _d[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($74e484adc399c5b2$var$canIncrement(unit) ? $74e484adc399c5b2$var$valueToSeconds(value, unit) : 0);
    }
    $42omo.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$74e484adc399c5b2$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $74e484adc399c5b2$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $74e484adc399c5b2$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($74e484adc399c5b2$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $74e484adc399c5b2$var$selectUnit(currentValueInSeconds);
        var unitDuration = $74e484adc399c5b2$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $42omo.createElement($74e484adc399c5b2$var$SimpleFormattedRelativeTime, (0, $hXuPC.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$74e484adc399c5b2$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
$74e484adc399c5b2$var$FormattedRelativeTime.defaultProps = {
    value: 0,
    unit: 'second'
};
var $74e484adc399c5b2$export$2e2bcd8739ae039 = $74e484adc399c5b2$var$FormattedRelativeTime;
module.exports["default"] = $74e484adc399c5b2$export$2e2bcd8739ae039;

});

parcelRegister("gtD4K", function(module, exports) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $hXuPC = parcelRequire("hXuPC");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $lIKdq = parcelRequire("lIKdq");

function $bfedaa60c3bc0584$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $hXuPC.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $hXuPC.__rest)(nextProps, [
        "values"
    ]);
    return (0, $lIKdq.shallowEqual)(nextValues, values) && (0, $lIKdq.shallowEqual)(otherProps, nextOtherProps);
}
function $bfedaa60c3bc0584$var$FormattedMessage(props) {
    var intl = (0, $8C5kA.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $42omo.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $42omo.createElement(Component, null, $42omo.Children.toArray(nodes));
    return $42omo.createElement($42omo.Fragment, null, nodes);
}
$bfedaa60c3bc0584$var$FormattedMessage.displayName = 'FormattedMessage';
var $bfedaa60c3bc0584$var$MemoizedFormattedMessage = $42omo.memo($bfedaa60c3bc0584$var$FormattedMessage, $bfedaa60c3bc0584$var$areEqual);
$bfedaa60c3bc0584$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $bfedaa60c3bc0584$export$2e2bcd8739ae039 = $bfedaa60c3bc0584$var$MemoizedFormattedMessage;
module.exports["default"] = $bfedaa60c3bc0584$export$2e2bcd8739ae039;

});

parcelRegister("1kHsc", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $e1c74140bf6f0b05$export$a7b0697657ed8bd0 = /*#__PURE__*/ (0, $42omo.createContext)({
    start () {},
    succeed () {},
    fail () {},
    abort () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    },
    getExperienceState () {
        return null;
    },
    updateAttributes () {},
    attachDebugPoint () {}
});
function $e1c74140bf6f0b05$export$f88dde183f4d31cb(WrappedComponent) {
    const withExperienceTracker = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e1c74140bf6f0b05$export$a7b0697657ed8bd0.Consumer, null, (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                ...props,
                experienceTracker: value
            }));
    withExperienceTracker.displayName = `withExperienceTracker(${WrappedComponent.displayName || WrappedComponent.name})`;
    return withExperienceTracker;
}
module.exports["ExperienceTrackerContext"] = $e1c74140bf6f0b05$export$a7b0697657ed8bd0;
module.exports["withExperienceTracker"] = $e1c74140bf6f0b05$export$f88dde183f4d31cb;

});

parcelRegister("1Whri", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("42omo");

const $5e3d6f8f8aeeeab3$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $5e3d6f8f8aeeeab3$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};



var $1bHXt = parcelRequire("1bHXt");

function $a00a138161b4b7bc$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $5e3d6f8f8aeeeab3$export$c4df1cb0c2b4d77c)();
        },
        cssMap () {
            throw (0, $5e3d6f8f8aeeeab3$export$c4df1cb0c2b4d77c)();
        },
        cx: $1bHXt.cx,
        XCSSProp () {
            throw (0, $5e3d6f8f8aeeeab3$export$c4df1cb0c2b4d77c)();
        }
    };
}


const $bed9dac56d676fa5$var$strictApi = (0, $a00a138161b4b7bc$export$39716b4af53f4ad)();
const $bed9dac56d676fa5$export$dbf350e5966cf602 = $bed9dac56d676fa5$var$strictApi.css;
const $bed9dac56d676fa5$export$eb1ecd84a24ee424 = $bed9dac56d676fa5$var$strictApi.cssMap;
$bed9dac56d676fa5$var$strictApi.cssMap;
const $bed9dac56d676fa5$export$a274e22fb40f762e = $bed9dac56d676fa5$var$strictApi.cx;
const $bed9dac56d676fa5$var$XCSSProp = $bed9dac56d676fa5$var$strictApi.XCSSProp;
module.exports["cx"] = $bed9dac56d676fa5$export$a274e22fb40f762e;

});

parcelRegister("1bHXt", function(module, exports) {

var $gMc0m = parcelRequire("gMc0m");

const $0dd8eab57dec46cd$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $gMc0m.default)(actualStyles);
};
module.exports["cx"] = $0dd8eab57dec46cd$export$a274e22fb40f762e;

});

parcelRegister("gxtzC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $fTXBo = parcelRequire("fTXBo");

function $121bfbcfa071ca74$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $fTXBo.useTrackedRef)(analyticsData);
    const fnRef = (0, $fTXBo.useTrackedRef)(fn);
    const handler = (0, $42omo.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}
module.exports["usePlatformLeafEventHandler"] = $121bfbcfa071ca74$export$a4687b0234b40e28;

});

parcelRegister("fTXBo", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $9a0610f9508374ad$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $42omo.useRef)(value);
    ref.current = value;
    return ref;
};
module.exports["useTrackedRef"] = $9a0610f9508374ad$export$1d27a74659855e44;

});

parcelRegister("ee7An", function(module, exports) {
$parcel$export(module.exports, "default", () => $84d1a8298454c0b5$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $84d1a8298454c0b5$export$2e2bcd8739ae039() {}

});

parcelRegister("c0qxy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $j9gwA = parcelRequire("j9gwA");


var $dh538 = parcelRequire("dh538");

// @ts-ignore - useId is not accessible in React 16
const $1be93bb4d62cd6c7$var$react18UseId = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useId ?? undefined;
function $1be93bb4d62cd6c7$export$f680877a34711e37() {
    if ($1be93bb4d62cd6c7$var$react18UseId && (0, $dh538.fg)('platform-dst-react-18-use-id')) {
        if ((0, $dh538.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $1be93bb4d62cd6c7$var$react18UseId().replace(/[:«»]/g, '_');
        return $1be93bb4d62cd6c7$var$react18UseId();
    }
    return `uid${(0, $j9gwA.useUID)()}`;
}
const $1be93bb4d62cd6c7$export$6be90bcb437e928f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${$1be93bb4d62cd6c7$export$f680877a34711e37()}${postfix}`;
    (0, $42omo.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
function $1be93bb4d62cd6c7$export$6ee17796e3d70de2() {
    if ($1be93bb4d62cd6c7$var$react18UseId && (0, $dh538.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        const uid = $1be93bb4d62cd6c7$export$f680877a34711e37();
        return (id)=>`${uid}-${id.toString()}`;
    }
    return (0, $j9gwA.useUIDSeed)();
}
module.exports["useId"] = $1be93bb4d62cd6c7$export$f680877a34711e37;
module.exports["IdProvider"] = $1be93bb4d62cd6c7$export$6be90bcb437e928f;
module.exports["useIdSeed"] = $1be93bb4d62cd6c7$export$6ee17796e3d70de2;

});

parcelRegister("j9gwA", function(module, exports) {

var $42omo = parcelRequire("42omo");





var $gf1Wm = parcelRequire("gf1Wm");

const $9f0690206dc3aaf7$export$1921362e86c73c88 = (prefix = '')=>({
        value: 1,
        prefix: prefix,
        uid: (0, $gf1Wm.generateUID)()
    });
const $9f0690206dc3aaf7$export$e575061ef2a070eb = $9f0690206dc3aaf7$export$1921362e86c73c88();
const $9f0690206dc3aaf7$export$b4d5da5f34fb77ad = $42omo.createContext($9f0690206dc3aaf7$export$1921362e86c73c88());
const $9f0690206dc3aaf7$export$218c8c3169c024d2 = (source)=>source.value++;
const $9f0690206dc3aaf7$export$36e24695f02d4503 = (source)=>source ? source.prefix : '';


const $df0bad01443b87b9$var$generateUID = (context)=>{
    const quartz = context || (0, $9f0690206dc3aaf7$export$e575061ef2a070eb);
    const prefix = (0, $9f0690206dc3aaf7$export$36e24695f02d4503)(quartz);
    const id = (0, $9f0690206dc3aaf7$export$218c8c3169c024d2)(quartz);
    const uid = prefix + id;
    const gen = (item)=>uid + quartz.uid(item);
    return {
        uid: uid,
        gen: gen
    };
};
const $df0bad01443b87b9$var$useUIDState = ()=>{
    const context = (0, $42omo.useContext)((0, $9f0690206dc3aaf7$export$b4d5da5f34fb77ad));
    const [uid] = (0, $42omo.useState)(()=>$df0bad01443b87b9$var$generateUID(context));
    return uid;
};
const $df0bad01443b87b9$export$87d05f07e65211f1 = ()=>{
    const { uid: uid } = $df0bad01443b87b9$var$useUIDState();
    return uid;
};
const $df0bad01443b87b9$export$bb5ca5fba6fb4f1f = ()=>{
    const { gen: gen } = $df0bad01443b87b9$var$useUIDState();
    return gen;
};
module.exports["useUID"] = $df0bad01443b87b9$export$87d05f07e65211f1;
module.exports["useUIDSeed"] = $df0bad01443b87b9$export$bb5ca5fba6fb4f1f;

});

parcelRegister("gf1Wm", function(module, exports) {
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ const $bd2f8d5ee18cc25b$export$bdbb4cbb3078e58d = ()=>{
    let counter = 1;
    const map = new WeakMap();
    /**
     * @borrows {uid}
     */ const uid = (item, index)=>{
        if (typeof item === 'number' || typeof item === 'string') return index ? `idx-${index}` : `val-${item}`;
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
const $bd2f8d5ee18cc25b$export$e2a22331486dcca0 = $bd2f8d5ee18cc25b$export$bdbb4cbb3078e58d();
module.exports["generateUID"] = $bd2f8d5ee18cc25b$export$bdbb4cbb3078e58d;
module.exports["uid"] = $bd2f8d5ee18cc25b$export$e2a22331486dcca0;

});

parcelRegister("6F6hl", function(module, exports) {
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $c5c5f50cde9c0a7a$var$visuallyHiddenStyles = null; /**
                                    * __Visually hidden__
                                    *
                                    * A composable element to apply a visually hidden effect to children.
                                    * Useful for accessibility compliance.
                                    *
                                    * @example
                                    * ```jsx
                                    * import VisuallyHidden from '@atlaskit/visually-hidden';
                                    *
                                    * export default () => (
                                    *   <div style={{ border: '1px solid black' }}>
                                    *      There is text hidden between the brackets [
                                    *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
                                    *   </div>
                                    * );
                                    * ```
                                    */ 
const $c5c5f50cde9c0a7a$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ]),
        children: children
    });
};
var $c5c5f50cde9c0a7a$export$2e2bcd8739ae039 = $c5c5f50cde9c0a7a$var$VisuallyHidden;
module.exports["default"] = $c5c5f50cde9c0a7a$export$2e2bcd8739ae039;

});

parcelRegister("8n9tL", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $42omo = parcelRequire("42omo");


var $QU6QS = parcelRequire("QU6QS");


var $a4TK8 = parcelRequire("a4TK8");


var $9x4nt = parcelRequire("9x4nt");


var $9wGTI = parcelRequire("9wGTI");


var $cb6fO = parcelRequire("cb6fO");


var $fMEnQ = parcelRequire("fMEnQ");


var $dHSeC = parcelRequire("dHSeC");


var $6OtsR = parcelRequire("6OtsR");


var $7W8i8 = parcelRequire("7W8i8");

class $db4891e4acf47b4d$export$aea2bc6590a5ea49 {
    /**
   * Registers a prompt string with its associated callback function.
   * This should be used in place of react-router's Prompt functionality. When registered, the callback
   * will be executed on every route change attempt, blocking the route change (the transition).
   *
   * The callback should return:
   * - true to show the prompt and block navigation
   * - false to allow navigation without prompting
   *
   * User interaction flow:
   * - If callback returns true, the user will see a browser confirmation dialog (window.confirm) with the provided message.
   * - If user clicks "OK", the route change continues and the prompt is automatically cleared.
   * - If user clicks "Cancel", the route change is prevented and the prompt remains active.
   * - If the route change is successful even if prompt wasn't shown, the prompt state is cleared automatically.
   *
   * Technical Reminders:
   * - When registering a prompt, ensure your implementation clears the prompt if it is no longer needed, by invoking clear().
   * - There can only be a maximum of one prompt registered at a time. Ensure your code flow won't conflict with existing use cases of registerPrompt.
   *
   * @param {Object} params - The parameters for the prompt registration.
   * @param {string} params.promptString - The message displayed in the browser confirmation dialog.
   * @param {PromptCallback} params.callback - A function that receives route transition info and returns true to show the confirmation dialog, false to allow navigation without prompting.
   */ registerPrompt({ promptString: promptString, callback: callback, onConfirm: onConfirm, onCancel: onCancel }) {
        this.promptString = promptString;
        this.promptCallback = callback;
        this.onConfirm = onConfirm ?? null;
        this.onCancel = onCancel ?? null;
    }
    /**
   * Clears the currently stored prompt string and callback, resetting the handler state.
   * This is done automatically on successful route change, but you should invoke it if you registered the prompt and no longer need it.
   */ clear() {
        this.promptString = null;
        this.promptCallback = null;
        this.onConfirm = null;
        this.onCancel = null;
    }
    /**
   * Gets the current prompt string if it exists and the callback returns true.
   *
   * @param {Object} args - The route transition arguments.
   * @param {RouteMatch | null} args.previousMatch - The previous route match.
   * @param {RouteMatch} args.nextMatch - The next route match.
   * @returns {string | null} The prompt string if conditions are met, null otherwise.
   */ getPromptString(args) {
        if (!this.promptString || !this.promptCallback) return null;
        try {
            const shouldPrompt = this.promptCallback({
                previousMatch: args.previousMatch,
                nextMatch: args.nextMatch
            });
            return shouldPrompt ? this.promptString : null;
        } catch (error) {
            this.logger.error`Error executing prompt callback: ${error}`;
            return null;
        }
    }
    /**
   * Triggers the prompt if it exists and the prompt callback returns true.
   *
   * @param {Object} args - The route transition arguments.
   * @param {RouteMatch | null} args.previousMatch - The previous route match.
   * @param {RouteMatch} args.nextMatch - The next route match.
   * @returns {Object} Returns {isPromptBlocking: true} if transition should be blocked because prompt was shown and user canceled,
   *                   otherwise returns {isPromptBlocking: false}
   */ triggerPrompt({ previousMatch: previousMatch, nextMatch: nextMatch }) {
        if (!this.promptString) return {
            isPromptBlocking: false
        };
        const promptString = this.getPromptString({
            previousMatch: previousMatch,
            nextMatch: nextMatch
        });
        if (promptString) {
            const userConfirmed = window.confirm(promptString);
            if (userConfirmed) {
                this.onConfirm?.();
                this.clear();
            } else {
                this.onCancel?.();
                // User cancelled, block the transition
                return {
                    isPromptBlocking: true
                };
            }
        }
        return {
            isPromptBlocking: false
        };
    }
    constructor(){
        this.logger = (0, $7W8i8.getLogger)('GlobalPromptHandler');
        this.promptString = null;
        this.promptCallback = null;
        this.onConfirm = null;
        this.onCancel = null;
    }
}



var $7zgzO = parcelRequire("7zgzO");


var $dPJCf = parcelRequire("dPJCf");


var $ek3aD = parcelRequire("ek3aD");

const $edae94fe65ac72a1$var$NOOP = ()=>{};
function $edae94fe65ac72a1$export$b6024a131a1561d9(routes, url) {
    // routes can be module from "import" which is not iterable
    const iterableRoutes = Object.values(routes);
    for (const route of iterableRoutes){
        if (!(route instanceof (0, $fMEnQ.Route))) continue;
        const match = route.match(url);
        if (match) // FIXME `route` is a `class` instance so it is not 100% safe to spread!
        // But we've been running with it for quite some time, we're not aware of
        // actual problems and I'm only discovering it now while translating to
        // TypeScript.
        //
        // @ts-ignore
        return {
            ...route,
            ...match
        };
    }
    return null;
}
const $edae94fe65ac72a1$export$5050caba5e109cc4 = (queryParams)=>{
    const array = Object.entries(queryParams);
    return array.length ? array.reduce((accumulator, current, index)=>`${accumulator + current[0]}=${encodeURIComponent(current[1])}${index < array.length - 1 ? '&' : ''}`, '?') : '';
};
const $edae94fe65ac72a1$var$routeActionHistoryMap = {
    PUSH: ({ location: location1, history: history })=>history.push(location1),
    REPLACE: ({ location: location1, history: history })=>history.replace(location1),
    POP: ({ history: history })=>history.go(-1)
};
class $edae94fe65ac72a1$var$RouteManagerInner extends (0, $42omo.Component) {
    componentDidMount() {
        const { location: location1, history: history } = this.props;
        const initialMatch = this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`);
        let previousMatch = initialMatch;
        const routeChangeHandler = (location1, action)=>{
            // we de-structure `onTransition` prop here instead of in enclosing scope
            // because otherwise changes to `onTransition` props will be ignored (as this function
            // will have a "cached" version of it via closure).
            const { onTransition: onTransition } = this.props;
            // New logic determine if it is a transition by calling isTransition on route.
            const match = this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`);
            if (onTransition && match && match.isTransition(previousMatch, match)) {
                if (action === 'PUSH' || action === 'POP') this.transitionId++;
                onTransition(match, this.transitionId, action);
                // Clear any prompt on successful route change
                this.globalPromptHandler.clear();
                // Inform GlobalTransitionPreloader that the transition is complete, allowing app to continue registering GlobalTransitionPreloader callbacks.
                const globalTransitionPreloader = (0, $ek3aD.getGlobalTransitionPreloader)();
                globalTransitionPreloader.onTransitionComplete(this.transitionId);
                // Call the pending UFO stop hold function if it exists, then clear it to prevent multiple calls
                if (this.pendingUfoStopHold) {
                    this.pendingUfoStopHold();
                    this.pendingUfoStopHold = undefined;
                }
                // Delete the SSR streaming global on route navigation to prevent it from affecting
                // suspense boundary rendering decisions during client-side navigation
                if (typeof window !== 'undefined' && window.__SSR_REACT_STREAMING__) delete window.__SSR_REACT_STREAMING__;
            }
            previousMatch = match;
        };
        // Return false to cancel transition (route will not change). Otherwise transition continues. Does not support waiting for promises - if we need to do that we should return false and have the promise re-invoke the route change when ready.
        const routeBlockHandler = (location1, action)=>{
            try {
                const match = this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`);
                const isTransition = match && match.isTransition(previousMatch, match);
                if (isTransition) {
                    // Check for global prompt. (This replaces react-router's <Prompt> component)
                    const { isPromptBlocking: isPromptBlocking } = this.globalPromptHandler.triggerPrompt({
                        previousMatch: previousMatch,
                        nextMatch: match
                    });
                    if (isPromptBlocking) return false;
                    // Check if we have a transition callback promise that should resolve before continuing transition.
                    // Do not support POP (back/forward) - too many edge cases caused by trying to partially support it.
                    const globalTransitionPreloader = (0, $ek3aD.getGlobalTransitionPreloader)();
                    if (action !== 'POP') {
                        const isProcessingTransitionPromise = globalTransitionPreloader.processTransitionCallback?.({
                            match: match,
                            onRouteContinue: ()=>{
                                $edae94fe65ac72a1$var$routeActionHistoryMap[action?.toUpperCase()]?.({
                                    location: location1,
                                    history: history
                                });
                            },
                            transitionId: this.transitionId,
                            interactionContext: this.props.interactionContext,
                            startPageLoadMetrics: this.props.startPageLoadMetrics
                        });
                        if (isProcessingTransitionPromise.isProcessingCallback) {
                            // Store the ufoStopHold function to be called in routeChangeHandler
                            this.pendingUfoStopHold = isProcessingTransitionPromise.ufoStopHold;
                            return false;
                        }
                    } else // If user does POP action, reset global transition preloader to ensure no transition callbacks are processed.
                    globalTransitionPreloader.reset();
                }
            } catch  {
            // Everything in this function should have its own try-catch/error handling, but in case of an unexpected error, the user shouldn't be blocked from navigating.
            }
        };
        if (this.props.setBrowserHistoryListener) {
            // Ensure RouteManager's `listen` handler is called before the listen handler registered by ConnectedRouter and redux action
            this.unlistenToHistory = this.props.setBrowserHistoryListener(routeChangeHandler);
            if ((0, $9wGTI.fg)('confluence_frontend_transition_preloading_system')) this.unlistenToHistoryBlock = history.block(routeBlockHandler);
        } else if ((0, $9wGTI.fg)('confluence_frontend_transition_preloading_system')) this.unlistenToHistory = history.block((location1, action)=>{
            const routeBlockHandlerResult = routeBlockHandler(location1, action);
            if (routeBlockHandlerResult === false) return false;
            else routeChangeHandler(location1, action);
        });
        else this.unlistenToHistory = history.block(routeChangeHandler);
    }
    componentWillUnmount() {
        this.unlistenToHistory?.();
        this.unlistenToHistoryBlock?.();
    }
    mapRoutes(routeComponents) {
        const supportedRoutes = Object.keys(routeComponents);
        return supportedRoutes.map((name)=>{
            const route = this.getRoute(name);
            const mappedRoute = new (0, $fMEnQ.Route)({
                name: route.name,
                ufoName: route.ufoName,
                pattern: route.pattern,
                condition: route.condition,
                isTransition: route.isTransition
            });
            // @ts-ignore FIXME Who's using `component` on "mapped" `Route`?
            mappedRoute['component'] = routeComponents[name];
            return mappedRoute;
        });
    }
    getRoute(name) {
        const { namedRoutes: namedRoutes } = this.props;
        const route = namedRoutes[name];
        if (!route) throw new Error(`Unknown route name: ${name}`);
        return route;
    }
    matchAndRenderComponent(match) {
        const { notFound: notFound, routeComponents: routeComponents } = this.props;
        if (match === null) return notFound ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(notFound) : null;
        else {
            window.performance.mark('CFP-63.route-component-render');
            const memoizedComponent = this.memoizedRouteComponents.get(routeComponents[match.name]);
            return memoizedComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(memoizedComponent, match) : null;
        }
    }
    getHref() {
        return location.pathname + location.search;
    }
    render() {
        const { children: children } = this.props;
        const routesContextValue = this.getRoutesContextValue();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6OtsR.GlobalPromptContextProvider), {
            globalPromptHandler: this.globalPromptHandler
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dPJCf.RouteStateContainer), routesContextValue, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Provider, {
            value: routesContextValue
        }, this.matchAndRenderComponent(routesContextValue.match), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dHSeC.GlobalAnchorHandler), null))));
    }
    constructor(props){
        super(props);
        this.pendingUfoStopHold = void 0;
        this.memoizedRouteComponents = new WeakMap();
        this.globalPromptHandler = new (0, $db4891e4acf47b4d$export$aea2bc6590a5ea49)();
        // transitionId is incremented on every push/pop to distinguish a deliberate
        // user navigation from an automatic redirect (replace). An id of 0 indicates that
        // we are currently on the initial load.
        //
        // Ideally this would be in component state, since it is passed down through context,
        // and should trigger a re-render when changed.
        // However, we don't want to re-render with the updated value until the location
        // changes, which unfortunately is controlled by <ConnectedRouter>.
        // At the same time, this state cannot be purely derived from location changes,
        // since we need to look at the action that caused the update.
        // When we remove react-router and can make both state changes atomically then
        // this can move into component state alongside the current location.
        this.transitionId = 0;
        this.pendingQueryParams = {};
        /**
     * Mapping components to named routes
     */ this.routes = this.mapRoutes(this.props.routeComponents);
        this.toUrl = (name, params = {})=>{
            const href = params['href'];
            if (href) return href;
            if (!name) return '';
            const query = params.query || {};
            const hash = params.hash || '';
            return this.getRoute(name).toUrl(params, {
                query: query,
                hash: hash
            });
        };
        this.matchRoute = (url)=>{
            const { namedRoutes: namedRoutes } = this.props;
            return $edae94fe65ac72a1$export$b6024a131a1561d9(namedRoutes, url);
        };
        this.matchSupportedRoute = (url)=>{
            const parsed = (0, $jiJCD.parse)(url);
            // Note here we are using location from window not from withRouter
            // history's location doesn't have host field
            // See https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/api/history.md
            //What is this doing?
            if (parsed.host && parsed.host !== window.location.host) return null;
            return $edae94fe65ac72a1$export$b6024a131a1561d9(this.routes, url);
        };
        this.replace = (url, forceReload = false)=>{
            const { history: history, onPageReload: onPageReload = $edae94fe65ac72a1$var$RouteManagerInner.defaultProps.onPageReload } = this.props;
            let match;
            if (!forceReload && (match = this.matchSupportedRoute(url))) // replace only supports pushing a path.
            // here the url might be a full URL that has same domain
            history.replace((0, $jiJCD.format)({
                pathname: match.pathname,
                search: match.search,
                hash: match.hash
            }));
            else {
                onPageReload(url, true);
                // eslint-disable-next-line no-restricted-syntax
                window.location.replace(url);
            }
        };
        this.open = (url, target, features)=>window.open(url, target, features);
        this.defaultPush = (url, forceReload = false)=>{
            const { history: history, onPageReload: onPageReload = $edae94fe65ac72a1$var$RouteManagerInner.defaultProps.onPageReload, location: location1 } = this.props;
            let match;
            if (!forceReload && (match = this.matchSupportedRoute((0, $cb6fO.isHashedOnlyURL)(url) ? (0, $jiJCD.format)({
                pathname: location1.pathname,
                search: location1.search,
                hash: url
            }) : url))) // push only supports pushing a path.
            // here the url might be a full URL that has same domain
            history.push((0, $jiJCD.format)({
                pathname: match.pathname,
                search: match.search,
                hash: match.hash
            }));
            else {
                onPageReload(url, false);
                // eslint-disable-next-line no-restricted-syntax
                window.location.assign(url);
            }
        };
        this.push = (url, forceReload = false)=>{
            const { routePolicy: routePolicy } = this.props;
            if (routePolicy) return routePolicy.push({
                ...this.getRoutesContextValue(),
                push: this.defaultPush
            }, url, forceReload);
            return this.defaultPush(url, forceReload);
        };
        this.getQueryParams = ()=>{
            const { location: location1 } = this.props;
            return (0, $jiJCD.parse)(location1.search, true).query;
        };
        this.setQueryParams = (query, replace = false)=>{
            if (query && typeof query === 'object') {
                const { history: history } = this.props;
                const queryParams = {
                    ...this.getQueryParams(),
                    ...this.pendingQueryParams,
                    ...query
                };
                Object.keys(queryParams).forEach((key)=>{
                    if (queryParams[key] === null || queryParams[key] === undefined) delete queryParams[key];
                });
                const search = this.buildQueryString(queryParams);
                (replace ? history.replace : history.push)({
                    search: search
                });
                Object.assign(this.pendingQueryParams, query);
                // https://github.com/ReactTraining/history/issues/767#issuecomment-573358882
                setTimeout(()=>this.pendingQueryParams = {});
            }
        };
        this.buildQueryString = $edae94fe65ac72a1$export$5050caba5e109cc4;
        this.getHash = ()=>{
            const { location: location1 } = this.props;
            return location1.hash ? location1.hash.substring(1) : '';
        };
        this.setHash = (hash)=>{
            const { history: history, location: location1 } = this.props;
            history.replace({
                ...location1,
                hash: hash
            });
        };
        this.preloadRoute = (matchOrUrl, options)=>{
            // URL match and string are among the most common representations in our
            // codebase. RouteManager owns converting between them so reduce the
            // strain on the caller and accept both:
            const match = typeof matchOrUrl === 'string' ? this.matchSupportedRoute(matchOrUrl) : matchOrUrl;
            if (match) {
                const previousMatch = this.matchSupportedRoute(this.getHref());
                const { onPreload: onPreload } = this.props;
                if (onPreload) onPreload(match, previousMatch, options);
            }
        };
        this.getRoutesContextValue = ()=>{
            const { history: history, location: location1, onPageReload: onPageReload } = this.props;
            return {
                getHref: this.getHref,
                history: history,
                location: location1,
                match: this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`),
                transitionId: this.transitionId,
                toUrl: this.toUrl,
                matchRoute: this.matchRoute,
                matchSupportedRoute: this.matchSupportedRoute,
                getQueryParams: this.getQueryParams,
                setQueryParams: this.setQueryParams,
                getHash: this.getHash,
                setHash: this.setHash,
                replace: this.replace,
                routes: this.routes,
                push: this.push,
                open: this.open,
                onPageReload: onPageReload || $edae94fe65ac72a1$var$NOOP,
                preloadRoute: this.preloadRoute
            };
        };
        const { location: _location, onInitialize: onInitialize, routeComponents: routeComponents } = this.props;
        // Keep a component => memo(component) mapping so later in matchAndRenderComponent we can render the memoized one.
        // We are not re-creating the routeComponents object because several items in the object may share the same reference.
        // If that is the case then our memoized component should sharing the same reference as well.
        for(const key in routeComponents){
            const component = routeComponents[key];
            if (!this.memoizedRouteComponents.has(component)) this.memoizedRouteComponents.set(component, /*#__PURE__*/ (0, $42omo.memo)(component, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))));
        }
        const _match = this.matchSupportedRoute(`${_location.pathname}${_location.search}${_location.hash}`);
        if (onInitialize) onInitialize(_match, this.transitionId);
    }
}
$edae94fe65ac72a1$var$RouteManagerInner.defaultProps = {
    routeComponents: {},
    namedRoutes: {},
    onPageReload: $edae94fe65ac72a1$var$NOOP
};
const $edae94fe65ac72a1$var$withInteractionContext = (ChildComponent)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_transition_preloading_system')) return ChildComponent;
    const WithInteractionContextComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x4nt.default).Consumer, null, (interactionContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ChildComponent, {
                ...props,
                interactionContext: interactionContext
            }));
    WithInteractionContextComponent.displayName = `withInteractionContext(${ChildComponent.displayName || ChildComponent.name})`;
    return WithInteractionContextComponent;
};
const $edae94fe65ac72a1$export$1b5af09f58fb97da = (0, $QU6QS.withRouter)($edae94fe65ac72a1$var$withInteractionContext($edae94fe65ac72a1$var$RouteManagerInner));
const $edae94fe65ac72a1$export$3b81431e16eb41b6 = $edae94fe65ac72a1$var$withInteractionContext;
module.exports["findAndMatchRoute"] = $edae94fe65ac72a1$export$b6024a131a1561d9;
module.exports["RouteManager"] = $edae94fe65ac72a1$export$1b5af09f58fb97da;

});

parcelRegister("cb6fO", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $1j3sF = parcelRequire("1j3sF");


var $33JSI = parcelRequire("33JSI");

const $66bd17d244a68303$export$8c6bf2df244e6a99 = '/wiki';
const $66bd17d244a68303$var$SPACE_ROOT = 'spaces';
const $66bd17d244a68303$export$ad28e141050c1e34 = (title)=>{
    if (!title) return;
    const slug = title// replace groups of reservered chars with a space
    // From https://www.ietf.org/rfc/rfc3986.txt
    // unreserved  = ALPHA / DIGIT / "-" / "." / "_" / "~"
    .replaceAll(/[^A-Za-z0-9\-._~]+/g, ' ')// trim the edges
    .trim()// replace spaces with '+'
    .replaceAll(' ', '+');
    // guard against relative url attacks
    if (slug === '.' || slug === '..') return undefined;
    return slug || undefined;
};
const $66bd17d244a68303$export$cbc5b385481fb319 = (href, query)=>{
    const parsedUrl = {
        ...(0, $jiJCD.parse)(href, true),
        search: undefined
    };
    parsedUrl.query = {
        ...parsedUrl.query,
        ...query
    };
    parsedUrl.query = (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))(parsedUrl.query, (0, (/*@__PURE__*/$parcel$interopDefault($33JSI))));
    return (0, $jiJCD.format)(parsedUrl);
};
const $66bd17d244a68303$export$8189558ac52562eb = (params, href)=>{
    const parsedUrl = {
        ...(0, $jiJCD.parse)(href, true),
        search: undefined
    };
    params.forEach((paramName)=>delete parsedUrl.query[paramName]);
    return (0, $jiJCD.format)(parsedUrl);
};
const $66bd17d244a68303$var$removeAllAnchorsFromUrl = (href)=>{
    return href.split('#')[0];
};
const $66bd17d244a68303$var$removeAllQueryParamsFromUrl = (href)=>{
    return href.split('?')[0];
};
const $66bd17d244a68303$export$64f436133a65fc62 = (href)=>{
    return $66bd17d244a68303$var$removeAllAnchorsFromUrl($66bd17d244a68303$var$removeAllQueryParamsFromUrl(href));
};
const $66bd17d244a68303$export$cefcfecf0835bcd9 = (spaceKey, path = '')=>{
    spaceKey = encodeURIComponent(spaceKey);
    let spacePath = (typeof path === 'string' ? path : path.pathname) || '';
    if (spacePath.startsWith($66bd17d244a68303$export$8c6bf2df244e6a99)) spacePath = spacePath.substring($66bd17d244a68303$export$8c6bf2df244e6a99.length);
    if (spacePath.startsWith('/')) spacePath = spacePath.substring(1);
    const link = `${$66bd17d244a68303$export$8c6bf2df244e6a99}/${$66bd17d244a68303$var$SPACE_ROOT}/${spaceKey}${spacePath ? `/${spacePath}` : ''}`;
    if (typeof path === 'string') return link;
    return {
        ...path,
        pathname: link
    };
};
const $66bd17d244a68303$var$getBlogRoute = (spaceKey)=>$66bd17d244a68303$export$cefcfecf0835bcd9(spaceKey, 'blog');
const $66bd17d244a68303$var$getPagesRoute = (spaceKey)=>$66bd17d244a68303$export$cefcfecf0835bcd9(spaceKey, 'pages');
const $66bd17d244a68303$export$6b45500787cf696 = (spaceKey, id, contentType, createdDate, slug)=>{
    const trailingSlug = slug ? `/${slug}` : '';
    switch(contentType){
        case 'blogpost':
            const [yy, mm, dd] = createdDate.slice(0, 10).split('-');
            return `${$66bd17d244a68303$var$getBlogRoute(spaceKey)}/${yy}/${mm}/${dd}/${id}${trailingSlug}`;
        case 'page':
            return `${$66bd17d244a68303$var$getPagesRoute(spaceKey)}/${id}${trailingSlug}`;
        default:
            throw new Error(`Expected content type 'blogpost' or 'page', but received '${contentType}'`);
    }
};
const $66bd17d244a68303$export$257d483fa4a3254f = /^(http(s)?:)?\/\//;
const $66bd17d244a68303$export$bfc29523388820d7 = (url, isContextAware)=>isContextAware && url.toString().indexOf($66bd17d244a68303$export$8c6bf2df244e6a99) !== 0 ? $66bd17d244a68303$export$8c6bf2df244e6a99 : '';
const $66bd17d244a68303$export$6a80a340d4e68de1 = (url, isContextAware)=>{
    if ($66bd17d244a68303$export$257d483fa4a3254f.test(url)) return url;
    else return `${$66bd17d244a68303$export$bfc29523388820d7(url, isContextAware)}${url}`;
};
const $66bd17d244a68303$export$feb8df2d5227ff6c = (urn)=>urn.charAt(0) === '#';
module.exports["CONTEXT_PATH"] = $66bd17d244a68303$export$8c6bf2df244e6a99;
module.exports["generateSlug"] = $66bd17d244a68303$export$ad28e141050c1e34;
module.exports["addQueryParams"] = $66bd17d244a68303$export$cbc5b385481fb319;
module.exports["removeEverythingAfterContentSlug"] = $66bd17d244a68303$export$64f436133a65fc62;
module.exports["getSpaceLink"] = $66bd17d244a68303$export$cefcfecf0835bcd9;
module.exports["buildContentPath"] = $66bd17d244a68303$export$6b45500787cf696;
module.exports["getContextAwareFullPath"] = $66bd17d244a68303$export$6a80a340d4e68de1;
module.exports["isHashedOnlyURL"] = $66bd17d244a68303$export$feb8df2d5227ff6c;

});

parcelRegister("1j3sF", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");

var $1713f77b91c7201c$exports = {};
/** Error message constants. */ var $1713f77b91c7201c$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function $1713f77b91c7201c$var$negate(predicate) {
    if (typeof predicate != 'function') throw new TypeError($1713f77b91c7201c$var$FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
$1713f77b91c7201c$exports = $1713f77b91c7201c$var$negate;


var $7a758928bd337697$exports = {};

var $5ukOg = parcelRequire("5ukOg");





var $egNUN = parcelRequire("egNUN");


var $jHiyU = parcelRequire("jHiyU");

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $7a758928bd337697$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $5ukOg($jHiyU(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $hWvFC(predicate);
    return $egNUN(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
$7a758928bd337697$exports = $7a758928bd337697$var$pickBy;


/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */ function $0f3a402934ec3574$var$omitBy(object, predicate) {
    return $7a758928bd337697$exports(object, $1713f77b91c7201c$exports($hWvFC(predicate)));
}
module.exports = $0f3a402934ec3574$var$omitBy;

});

parcelRegister("egNUN", function(module, exports) {

var $aT80v = parcelRequire("aT80v");


var $92z90 = parcelRequire("92z90");


var $f2rYC = parcelRequire("f2rYC");

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $a6394769c36a3ed4$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $aT80v(object, path);
        if (predicate(value, path)) $92z90(result, $f2rYC(path, object), value);
    }
    return result;
}
module.exports = $a6394769c36a3ed4$var$basePickBy;

});

parcelRegister("92z90", function(module, exports) {

var $jykdj = parcelRequire("jykdj");


var $f2rYC = parcelRequire("f2rYC");


var $1UktQ = parcelRequire("1UktQ");


var $lc9ud = parcelRequire("lc9ud");


var $w287Y = parcelRequire("w287Y");

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $694f8fe0d3aaec21$var$baseSet(object, path, value, customizer) {
    if (!$lc9ud(object)) return object;
    path = $f2rYC(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $w287Y(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $lc9ud(objValue) ? objValue : $1UktQ(path[index + 1]) ? [] : {};
        }
        $jykdj(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $694f8fe0d3aaec21$var$baseSet;

});

parcelRegister("dHSeC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");

function $691595bcd2385e34$export$cf1af05a5f90ab81() {
    $691595bcd2385e34$var$useAnchorEventListener('click', $691595bcd2385e34$var$spaTransitionOnAnchorClick, false);
    $691595bcd2385e34$var$useAnchorEventListener('mousedown', $691595bcd2385e34$var$preloadRouteOnMouseDown, true);
    $691595bcd2385e34$var$useAnchorEventListener('preloadOnHover', $691595bcd2385e34$var$preloadRouteOnMouseHover, true);
    return null;
}
function $691595bcd2385e34$var$createAnchorEventListener(eventListener, routesContext) {
    return (e)=>{
        // Some code already handled this
        if (e.defaultPrevented) return;
        const details = $691595bcd2385e34$export$bd34341d1dc0003f(e, routesContext);
        if (details) eventListener(e, routesContext, details);
    };
}
function $691595bcd2385e34$var$isContentEditable(element) {
    return element instanceof HTMLElement && element.isContentEditable;
}
function $691595bcd2385e34$export$bd34341d1dc0003f(e, routesContext) {
    if (e.type === 'preloadOnHover') {
        const detail = e.detail;
        if (detail?.preloadUrl) {
            const { preloadUrl: preloadUrl, ...preloadOptions } = detail;
            return {
                href: preloadUrl,
                ...preloadOptions
            };
        }
        return;
    }
    if (!('button' in e) || e['button'] !== 0 /* main button */ ) return;
    // Don't handle if modifier keys used
    if (e['ctrlKey'] || e['shiftKey'] || e['altKey'] || e['metaKey']) return;
    const { target: target } = e;
    if (!target || !(target instanceof Element)) return;
    // This might be the child of an anchor (such as the span inside of a smart card),
    // so check for a parent anchor.
    const anchor = target.closest('a');
    if (!anchor) return;
    //ignore hash links, they're handled by scroll handlers that also listen to document click
    if (!(anchor instanceof HTMLAnchorElement) || 'hash' in anchor && anchor['hash']) return;
    // Links in contenteditable elements are not clickable
    // https://product-fabric.atlassian.net/browse/CEMS-951
    // Checking closest 'contentEditable' for anchor,
    // In case there are "contenteditable=false" in between target and anchor.
    // Also check the property, since contenteditable="false" is possible
    const closestContentEditableFromAnchor = anchor.closest('[contenteditable]');
    const closestContentEditableFromTarget = target.closest('[contenteditable]');
    if ($691595bcd2385e34$var$isContentEditable(closestContentEditableFromAnchor) || $691595bcd2385e34$var$isContentEditable(closestContentEditableFromTarget)) return;
    const noGlobalAnchorHandler = target.closest('[data-no-global-anchor-handler]');
    if (noGlobalAnchorHandler) return;
    // Only handle anchors with relevant targets
    if (anchor.target && anchor.target !== '_self') return;
    const { href: href } = anchor;
    if (!href) return;
    // CONFCLOUD-69367
    // skip copy page legacy to allow user to edit page title
    // CEMS-1140
    // skip create page legacy to allow user to create a page using newer working fabric creation
    if (!routesContext || typeof routesContext.matchRoute !== 'function') return;
    const match = routesContext.matchRoute(href);
    if (match && (match.name === (0, $1NBp8.COPY_PAGE_LEGACY).name || match.name === (0, $1NBp8.CREATE_PAGE_ACTION_LEGACY).name)) return;
    return {
        href: href
    };
}
function $691595bcd2385e34$var$preloadRouteOnMouseDown(_, { preloadRoute: preloadRoute }, { href: href }) {
    preloadRoute(href);
}
function $691595bcd2385e34$var$preloadRouteOnMouseHover(_, { preloadRoute: preloadRoute }, { href: href, ...preloadOptions }) {
    preloadRoute(href, preloadOptions);
}
function $691595bcd2385e34$var$spaTransitionOnAnchorClick(e, { push: push }, { href: href }) {
    e.preventDefault();
    push(href, Boolean((0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname)));
}
function $691595bcd2385e34$var$useAnchorEventListener(type, anchorEventListener, useCapture) {
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const eventListener = (0, $42omo.useMemo)(()=>$691595bcd2385e34$var$createAnchorEventListener(anchorEventListener, routesContext), [
        anchorEventListener,
        routesContext
    ]);
    (0, $42omo.useEffect)(()=>{
        if (eventListener) window.addEventListener(type, eventListener, useCapture);
        return ()=>{
            if (eventListener) window.removeEventListener(type, eventListener, useCapture);
        };
    }, [
        eventListener,
        type,
        useCapture
    ]);
}
module.exports["GlobalAnchorHandler"] = $691595bcd2385e34$export$cf1af05a5f90ab81;
module.exports["getSpaTransitionDetails"] = $691595bcd2385e34$export$bd34341d1dc0003f;

});

parcelRegister("7zgzO", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $75b27f9b06ddd759$var$nullNoop = ()=>null;
const $75b27f9b06ddd759$var$objNoop = ()=>({});
const $75b27f9b06ddd759$var$stringNoop = ()=>'';
const $75b27f9b06ddd759$var$voidNoop = ()=>{};
const $75b27f9b06ddd759$export$779e8f71c6bb38c = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getHref: $75b27f9b06ddd759$var$stringNoop,
    history: null,
    location: null,
    match: null,
    transitionId: null,
    toUrl: $75b27f9b06ddd759$var$stringNoop,
    matchRoute: $75b27f9b06ddd759$var$nullNoop,
    matchSupportedRoute: $75b27f9b06ddd759$var$nullNoop,
    getQueryParams: $75b27f9b06ddd759$var$objNoop,
    setQueryParams: $75b27f9b06ddd759$var$voidNoop,
    getHash: $75b27f9b06ddd759$var$stringNoop,
    setHash: $75b27f9b06ddd759$var$voidNoop,
    replace: $75b27f9b06ddd759$var$voidNoop,
    routes: [],
    push: $75b27f9b06ddd759$var$voidNoop,
    open: $75b27f9b06ddd759$var$nullNoop,
    onPageReload: $75b27f9b06ddd759$var$voidNoop,
    preloadRoute: $75b27f9b06ddd759$var$voidNoop
});
$75b27f9b06ddd759$export$779e8f71c6bb38c.displayName = 'RoutesContext';
module.exports["RoutesContext"] = $75b27f9b06ddd759$export$779e8f71c6bb38c;

});

parcelRegister("6OtsR", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f5ab03ea100c4e96$var$GlobalPromptContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $f5ab03ea100c4e96$export$71d99832f5dd52ec = ()=>(0, $42omo.useContext)($f5ab03ea100c4e96$var$GlobalPromptContext);
const $f5ab03ea100c4e96$export$a082affa499ae96f = ({ children: children, globalPromptHandler: globalPromptHandler })=>{
    const contextValue = (0, $42omo.useMemo)(()=>({
            globalPromptHandler: globalPromptHandler
        }), [
        globalPromptHandler
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ab03ea100c4e96$var$GlobalPromptContext.Provider, {
        value: contextValue
    }, children);
};
module.exports["useGlobalPromptContext"] = $f5ab03ea100c4e96$export$71d99832f5dd52ec;
module.exports["GlobalPromptContextProvider"] = $f5ab03ea100c4e96$export$a082affa499ae96f;

});

parcelRegister("ek3aD", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $04e9M = parcelRequire("04e9M");


var $7W8i8 = parcelRequire("7W8i8");


var $9wGTI = parcelRequire("9wGTI");

class $b2c33a4aa51f5065$export$46a841557056026b extends Error {
    constructor(message){
        super(message);
        this.name = 'ExternalRejectionError';
    }
}
class $b2c33a4aa51f5065$export$2f8f0e0ec8218c4b {
    /**
   * Registers a transition callback that will be awaited on a route change.
   * The callback will only be invoked if the `onlyCalledIfFunc` returns true or if `onlyCalledIfFunc` is not provided. e.g. To check that a contentId is what you expect it should be. `onlyCalledIfFunc` should be very performant as it will run every route change.
   *
   * PERFORMANCE WARNING: `onlyCalledIfFunc` is executed every route change, and `callback` promise is awaited every time `onlyCalledIfFunc` returns `true` (or if it doesn't exist).
   *                      If either of these functions are not very performant, it could cause undesirable performance degradation on every transition.
   *                      Try to avoid any time-intensive invocations, especially in `onlyCalledIfFunc`. `onlyCalledIfFunc` ideally only runs a condition the `match` that it's passed, e.g. to check `match.params.contentId` or `match.pathname`.
   *                      BEFORE REGISTERING A NEW TRANSITION CALLBACK, you must be confident that the negative performance impact is acceptable.
   *
   * @example registerTransitionCallback({
   *     id: 'unique-id-related-to-my-code',
   *     callback: ({match}) => {
   *         // Do preloading logic, must return a promise
   *         return new Promise((resolve) => {
   *             const nextContentId = match.params?.contentId;
   *             // do logic that is a hard pre-requisite for next route and cannot be lazy/concurrently loaded, ideally shouldn't be slow
   *             resolve(); // route change gets unblocked after these callback promises are resolved
   *         }
   *     },
   *     onlyCalledIfFunc: ({match}) => {
   *         // Optional but recommended
   *         const nextContentId = match.params?.contentId;
   *         // Do very quick logic, ideally no logic that we need to wait for, this function is run every route change
   *         if (isLiveDoc(contentId)) {
   *             return true;
   *         } else {
   *             return false;
   *         }
   *     },
   *     onPerformanceMetricStart: ({match}) => {
   *         // Optional but recommended
   *         const nextContentId = match.params?.contentId;
   *         // Should be used to quickly start any page load performance metrics that you want to track for this route change
   *         // If you don't use this, your existing page load metric will likely start after the preloading and after the route change.
   *         // We want page load metrics to start before preloading, not after.
   *     },
   *     onRouteContinueCallback: async ({match}) => {
   *		   // Optional, must return a promise (i.e. or be async)
   *         const nextContentId = match.params?.contentId;
   *         // Do very quick logic that will run only if we're about to transition routes, runs after callback promise.
   *         // Can be used to do logic that you want to ensure doesn't occur on outdated route changes, e.g. connecting to nextContentId's collab provider
   *     },
   * });
   *
   * @param {Object} params - The parameters for the transition callback.
   * @param {string} params.id - A unique identifier used to inform other components the callback was run, to clean up outdated promises, and to prevent duplicate callback registrations.
   * @param {TransitionCallback} params.callback - The callback function to be executed during a route transition. Must return a promise.
   * @param {OnlyCalledIfFunc} params.onlyCalledIfFunc - A function that determines whether the callback should be called.
   * @param {OnRouteContinueCallback} params.onRouteContinueCallback - Callback function that must return a promise. This is called right after the transition callback promises finish but before we continue the route transition, the returned promise blocks route transition. This function won't be called if route has changed before callback promise resolves.
   * @param {OnPerformanceMetricStartCallback} params.onPerformanceMetricStart - Callback function to start performance metrics. Called as we start running the transition callback promises.
   * @returns {boolean} - Returns `true` if the transition callback was registered, `false` if it was not registered (due to already being registered or being mid-transition).
   */ registerTransitionCallback({ id: id, callback: callback, onlyCalledIfFunc: onlyCalledIfFunc, onRouteContinueCallback: onRouteContinueCallback, onPerformanceMetricStart: onPerformanceMetricStart }) {
        // We want to keep transition callbacks unique to guarantee we aren't duplicating work, so we tie callbacks to an ID. If there are multiple registrations of the same callback ID, we ignore registration attempts if we're already registered.
        // We don't allow registering transition callbacks while transitioning, to avoid race conditions leading to infinite route change loops.
        if (this.transitionProcessingState !== 'not_processing' || this.callbacks.has(id)) return false;
        this.callbacks.set(id, {
            callback: callback,
            onlyCalledIfFunc: onlyCalledIfFunc,
            onRouteContinueCallback: onRouteContinueCallback,
            onPerformanceMetricStart: onPerformanceMetricStart
        });
        return true;
    }
    /**
   * Processes transition callbacks during a route change, checking if we need to create promises from callbacks, and waiting for them to resolve/reject before continuing the route change.
   * `processTransitionCallback` will set `this.isTransitionCallbackRunning` to true, preventing callback registration. RouteManager is responsible for clearing it via `onTransitionComplete`.
   *
   * @param {{ match: Match; onRouteContinue: () => void; transitionId: number; interactionContext?: UFOInteractionContextType | null }} args - The arguments containing the route `match` object, RouteManager `transitionId`, the `onRouteContinue` continuation function, and optional UFO interaction context.
   *                                                                                     `onRouteContinue` is called once promises resolve and should finish executing the route change.
   * @returns {boolean} - Returns `true` if processing transition callback and transition should not continue (until promise finishes and calls onRouteContinue).
   *                      Returns `false` if not processing transition callback and routeChangeHandler should continue running.
   */ processTransitionCallback({ match: match, transitionId: transitionId, onRouteContinue: onRouteContinue, interactionContext: interactionContext, startPageLoadMetrics: startPageLoadMetrics }) {
        try {
            if (!this.callbacks.size) {
                // Update latest route details to keep this.getCurrentRouteCallbackIds() is accurate. If transitionId has changed, accurately reflect that there are no callbackIds for that route change.
                if (transitionId !== this.currentRouteDetails.transitionId) this.currentRouteDetails = {
                    transitionId: transitionId,
                    callbackIds: [],
                    pathname: match?.pathname || ''
                };
                return {
                    isProcessingCallback: false
                };
            }
            this.transitionProcessingState = 'processing';
            const previousPathname = this.latestPathname;
            this.latestPathname = match?.pathname;
            if (this.latestPathname !== previousPathname) // Cancel all currently running promises because we're going to a different route. Helps prevent multiple quick route changes from causing race condition that could send user to outdated route change.
            // If needed, `getCallbackPromises` below will create new promises for the latest route.
            this.cancelActivePromises();
            const { callbackIds: callbackIds } = this.getCallbackIds({
                match: match
            });
            const { callbackPromises: callbackPromises, callbackPromiseIds: callbackPromiseIds, callbackPromiseObjects: callbackPromiseObjects } = this.getCallbackPromises({
                match: match,
                callbackIds: callbackIds
            });
            // Cancel outdated actively running promises that aren't for the latest callbackIds
            this.cleanupOutdatedCallbacks(callbackIds);
            if (!callbackPromises.length) {
                // If there are no callback promises, route change will immediately continue. Reset our callbacks state as we don't want registered callbacks to linger once the user leaves the route. Callbacks should be registered on page/etc load if needed.
                // EDGE CASE: If the user is on a live doc and quickly clicks a non-live-doc like a view page, then quickly clicks back into a live doc before the view page has loaded, the preload-live-doc callback may have been removed, slowing down load time into that live doc.
                //            We'll solve for this in the future by always checking if we should preload a live doc on any route change, by never unregistering that callback
                this.reset();
                return {
                    isProcessingCallback: false
                };
            }
            // Start browser metrics page load
            startPageLoadMetrics?.(match?.name ?? '', match?.ufoName, transitionId, match?.params?.contentId);
            // Ensure UFO page load metric continues tracking the page load from start of preloading. If we don't hold here, UFO metric finishes prematurely on route change.
            // We should stop holding right after the route change is completed.
            const ufoStopHold = interactionContext?.hold?.('GlobalTransitionPreloader');
            callbackPromiseObjects.forEach(({ onPerformanceMetricStart: onPerformanceMetricStart })=>{
                onPerformanceMetricStart?.({
                    match: match
                });
            });
            // Timeout for all promises to prevent indefinite waiting
            const TIMEOUT_MS = 10000; // 10 seconds
            let timeoutId = null;
            // Flag to prevent race conditions between timeout and promise completion
            // Only one of them should trigger the route transition
            let hasRouteTransitionCompleted = false;
            // Set up timeout if feature gate is enabled
            if ((0, $9wGTI.fg)('confluence_live_doc_smooth_transition_timeout')) timeoutId = setTimeout(()=>{
                // Only execute if route transition hasn't been completed by promise resolution
                if (!hasRouteTransitionCompleted) {
                    hasRouteTransitionCompleted = true;
                    this.logger.error`Callback promises timed out after ${TIMEOUT_MS}ms, forcing route transition`;
                    this.reset();
                    onRouteContinue();
                    (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                        analyticsWebClient.sendOperationalEvent({
                            action: 'confluence_live_doc_smooth_transition_timeout',
                            actionSubject: 'callback_promises_timed_out',
                            attributes: {
                                callbackPromiseIds: callbackPromiseIds.join(',')
                            },
                            source: 'GlobalTransitionPreloader'
                        });
                    });
                }
            }, TIMEOUT_MS);
            // Handle all the promises and then send the user to the next route if appropriate.
            Promise.allSettled(callbackPromises).then((promiseResults)=>{
                // Only proceed if timeout hasn't already triggered the route transition
                if (hasRouteTransitionCompleted) return;
                // Mark that we're handling the route transition to prevent timeout from also executing
                hasRouteTransitionCompleted = true;
                // Clear timeout if callbacks completed first
                if (timeoutId) clearTimeout(timeoutId);
                const onRouteContinueCallbacks = [];
                let externallyRejectedCount = 0;
                promiseResults.forEach((result, index)=>{
                    if (result.status === 'rejected') {
                        if (callbackPromiseObjects[index].isExternallyRejected) externallyRejectedCount++;
                        else this.logger.error`There was an error with a transition callback promise: ${result.reason}, active callbackPromiseIds: ${callbackPromiseIds.join(',')}`;
                    } else {
                        const { onRouteContinueCallback: onRouteContinueCallback } = callbackPromiseObjects[index];
                        if (onRouteContinueCallback) onRouteContinueCallbacks.push(onRouteContinueCallback);
                    }
                });
                if (externallyRejectedCount < callbackPromises.length) {
                    const onRouteContinueCallbackPromises = onRouteContinueCallbacks.map((callback)=>callback({
                            match: match
                        }));
                    // Only update state if most promises weren't externally rejected (indicating this is still the current transition)
                    this.currentRouteDetails.callbackIds = callbackPromiseIds;
                    this.currentRouteDetails.transitionId = transitionId;
                    this.currentRouteDetails.pathname = match?.pathname || '';
                    this.transitionProcessingState = 'processing_completed';
                    // On successful next route, we clear the currently registered callbacks. Callbacks should be registered on page/etc load if needed.
                    this.callbacks = new Map();
                    this.activelyRunningCallbackPromises = {};
                    Promise.allSettled(onRouteContinueCallbackPromises).then(()=>{
                        // If all promises have been externally rejected, that means these promises are for an outdated route change, the user has since changed routes again, so we don't want to redirect the user to the route.
                        // This avoids race condition scenarios where user goes from Doc A -> Doc B -> Doc C, but ends up on Doc B because its promises finished after Doc C's promises.
                        // On successful next route, we clear the currently registered callbacks. Callbacks should be registered on page/etc load if needed.
                        this.callbacks = new Map();
                        this.activelyRunningCallbackPromises = {};
                        onRouteContinue();
                    });
                }
            });
            return {
                isProcessingCallback: true,
                ufoStopHold: ufoStopHold ? ()=>ufoStopHold?.() : undefined
            };
        } catch (error) {
            this.logger.error`There was an error running processTransitionCallback: ${error}, registered callbackIds: ${Array.from(this.callbacks.keys()).join(',')}`;
        }
        return {
            isProcessingCallback: false
        };
    }
    /**
   * Retrieve callback IDs that ran on the current route. Can be useful to determine if your page was already preloaded or not.
   * Recommended to only run this if you are finished transitioning. If you may be mid-transition (unlikely unless using Prompt), use `getRouteCallbackIdsByMatch`.
   *
   * @returns {string[]} - List of registered transition callback IDs that ran on current route when transitioning into it
   */ getCurrentRouteCallbackIds() {
        return [
            ...this.currentRouteDetails.callbackIds
        ];
    }
    /**
   * Retrieve callback IDs that will be run on the specified match. This function looks at this.transitionProcessingState to determine which callback IDs to return.
   * Recommended to only run this if you may be mid-transition, otherwise `getCurrentRouteCallbackIds` is preferable.
   * Can be useful to determine if the match will be preloaded or not during transition, e.g. to determine whether a Prompt callback shows prompt.
   *
   * @returns {string[]} - List of registered transition callback IDs that will run speciifed match when transitioning into it
   */ getRouteCallbackIdsByMatch(match) {
        if (!match?.pathname) return [];
        /**
     *  - If GlobalTransitionPreloader.processTransitionCallback is processing the same match as the specified match:
     *    - If we're mid-transition ('processing'), we use the memoized callback IDs that were set when `processingTransitionCallback` called `getCallbackIds`.
     *      - If memoized callback IDs don't exist (e.g. calling this too quickly right after processingTransitionCallback is called), we fetch the callback IDs for the specified match.
     *    - If we're finished processing ('processing_completed') but haven't finished transitioning yet, we use the current route callback IDs.
     *
     *  - If the specified match is different from the match being processed, or if we are not processing a match ('not_processing'), then we fetch the callback IDs for the specified match.
     */ if (this.transitionProcessingState === 'processing' && this.cachedCallbackIds?.callbackIds && this.cachedCallbackIds?.pathname === match.pathname) return [
            ...this.cachedCallbackIds.callbackIds
        ];
        else if (this.transitionProcessingState === 'processing_completed' && this.currentRouteDetails.pathname === match.pathname) return [
            ...this.currentRouteDetails.callbackIds
        ];
        else return this.getCallbackIds({
            match: match
        }).callbackIds;
    }
    /**
   * Resets the preloader to its initial state by clearing all registered callbacks,
   * canceling any actively running promises, and resetting internal state.
   * This can be useful for cleanup or testing scenarios.
   */ reset() {
        this.cancelActivePromises();
        this.callbacks = new Map();
        this.activelyRunningCallbackPromises = {};
        this.latestPathname = '';
        this.currentRouteDetails.callbackIds = [];
        this.currentRouteDetails.pathname = '';
        this.cachedCallbackIds = null;
        // If we started processing, mark as processing completed. We only set to not_processing in onTransitionComplete, to disallow registering callbacks mid-transition.
        if (this.transitionProcessingState !== 'not_processing') this.transitionProcessingState = 'processing_completed';
    }
    /**
   * Router is responsible for running this function when the route has technically changed (routeChangeHandler).
   @param {number} transitionId - The transition ID of the route that has completed, coming from RouteManager
   */ onTransitionComplete(transitionId) {
        // When GlobalTransitionPreloader processes transition callbacks, it sets its transition running flag to true.
        // When it's done processing transition callbacks and the route has changed, we should clear the transition running flag.
        // This is used to prevent race conditions caused by problematic globalTransitionPreloader callback registrations during route changes.
        // For instance: If a callback is registered mid-transition, then when `routeBlockHandler` is called a second time by `onRouteContinue`,
        //               processTransitionCallback may try to process it after it has already processed it, leading to an infinite loop.
        this.transitionProcessingState = 'not_processing';
        this.cachedCallbackIds = null;
        // Transition ID from RouteManager is stored in this.currentRouteDetails before we call `routeChangeHandler`.
        // If we processed a transition callback, it'll always be one behind RouteManager
        // If transition IDs are misaligned and currentRouteDetails.callbackIds is non-empty, we're in an invalid state likely due to routeBlockHandler/processTransitionCallback unexpectedly not being triggered
        // If we're in this invalid state, reset the current route details callback IDs to prevent components from thinking we're in a preloaded state when we're not.
        if (this.currentRouteDetails.transitionId + 1 !== transitionId && this.currentRouteDetails.callbackIds.length > 0) {
            this.logger.error`GlobalTransitionPreloader is in an invalid state, transitionId mismatch, callbackIds are non-empty. Resetting callbackIds. Invalid callbackIds are: ${this.currentRouteDetails.callbackIds.join(',')}`;
            this.currentRouteDetails.callbackIds = [];
        }
    }
    /**
   * Generates an array of callback ids that should be processed before the next transition, filtering out
   * callbacks which are not supposed to run based on their `onlyCalledIfFunc` evaluation.
   * Caches most recent array of callback IDs as `this.cachedCallbackIds`
   * @param { match: Match } params The params for the method including the match object.
   * @returns { callbackIds: Array<string> } An object containing an array of callback ids that should be processed
   */ getCallbackIds({ match: match }) {
        const callbackIds = [];
        if (!this.callbacks.size) {
            this.cachedCallbackIds = {
                pathname: match.pathname,
                callbackIds: []
            };
            return {
                callbackIds: callbackIds
            };
        }
        this.callbacks.forEach(({ onlyCalledIfFunc: onlyCalledIfFunc }, callbackId)=>{
            // Call our `onlyCalledIfFunc` if it's set, we're only waiting for this callback promise if it's `true` or if it's not set.
            const isCallAllowed = onlyCalledIfFunc ? onlyCalledIfFunc({
                match: match
            }) : true;
            if (isCallAllowed) callbackIds.push(callbackId);
        });
        // Cache the result for the most recent invocation, may be fetched by `getRouteCallbackIdsByMatch` when we're mid-transition, avoids additional onlyCalledIfFunc calls.
        this.cachedCallbackIds = {
            pathname: match.pathname,
            callbackIds: [
                ...callbackIds
            ]
        };
        return {
            callbackIds: callbackIds
        };
    }
    /**
   * Creates an array of promises from registered callbacks that should be executed
   * during a route transition. This method checks conditions under which each callback
   * should be called and manages the lifecycle of the promises.
   * Will clean up outdated promises.
   *
   * @private
   * @param { match: Match, callbackIds: Array<string> } params - The parameters for the method, containing the match object and callback IDs.
   * @returns { callbackPromises: Array<Promise<void>>, callbackPromiseIds: Array<string> } An object containing an array of promises and their corresponding IDs.
   */ getCallbackPromises({ match: match, callbackIds: callbackIds }) {
        const callbackPromises = [];
        const callbackPromiseIds = []; // Recommendation is to use this to help provide context to promise errors
        const callbackPromiseObjects = [];
        callbackIds.forEach((callbackId)=>{
            const callbackConfig = this.callbacks.get(callbackId);
            if (!callbackConfig) return; // This should never happen
            const { callback: callback, onRouteContinueCallback: onRouteContinueCallback, onPerformanceMetricStart: onPerformanceMetricStart } = callbackConfig;
            const activeCallbackPromise = this.activelyRunningCallbackPromises[callbackId];
            // If we want to trigger a callback promise, return the already running one if we have it, otherwise create a new one.
            if (activeCallbackPromise) {
                callbackPromises.push(activeCallbackPromise.promise);
                callbackPromiseIds.push(callbackId);
                callbackPromiseObjects.push(activeCallbackPromise);
            } else {
                // Start the promise and store the promise and its reject function in state (this.processTransitionCallback may call `reject` if the user changes route)
                let callbackPromiseReject;
                const callbackPromise = new Promise((resolve, reject)=>{
                    callbackPromiseReject = reject;
                    callback({
                        match: match
                    }).then(resolve).catch(reject);
                });
                callbackPromises.push(callbackPromise);
                callbackPromiseIds.push(callbackId);
                const callbackPromiseObject = {
                    promise: callbackPromise,
                    onRouteContinueCallback: onRouteContinueCallback,
                    onPerformanceMetricStart: onPerformanceMetricStart,
                    reject: (reason)=>callbackPromiseReject(new $b2c33a4aa51f5065$export$46a841557056026b(reason)),
                    isExternallyRejected: false
                };
                callbackPromiseObjects.push(callbackPromiseObject);
                this.activelyRunningCallbackPromises[callbackId] = callbackPromiseObject;
            }
        });
        return {
            callbackPromises: callbackPromises,
            callbackPromiseIds: callbackPromiseIds,
            callbackPromiseObjects: callbackPromiseObjects
        };
    }
    /**
   * Cancels all actively running callback promises by rejecting them and marking as externally rejected
   */ cancelActivePromises() {
        Object.entries(this.activelyRunningCallbackPromises).forEach(([callbackId, { reject: reject }])=>{
            reject();
            this.activelyRunningCallbackPromises[callbackId].isExternallyRejected = true;
            delete this.activelyRunningCallbackPromises[callbackId];
        });
    }
    /**
   * Cleans up any callback promises that are no longer valid for the current route.
   * @param validCallbackIds - The callback ids that are valid for the current route.
   */ cleanupOutdatedCallbacks(validCallbackIds) {
        Object.keys(this.activelyRunningCallbackPromises).forEach((activelyRunningCallbackId)=>{
            if (!validCallbackIds.includes(activelyRunningCallbackId)) {
                const activeCallbackPromise = this.activelyRunningCallbackPromises[activelyRunningCallbackId];
                if (activeCallbackPromise) {
                    activeCallbackPromise.reject?.();
                    activeCallbackPromise.isExternallyRejected = true;
                    delete this.activelyRunningCallbackPromises[activelyRunningCallbackId];
                }
            }
        });
    }
    constructor(){
        this.logger = (0, $7W8i8.getLogger)('GlobalTransitionPreloader');
        this.callbacks = new Map();
        this.activelyRunningCallbackPromises = {};
        this.latestPathname = '';
        this.currentRouteDetails = {
            transitionId: -1,
            callbackIds: [],
            pathname: ''
        };
        this.transitionProcessingState = 'not_processing';
        this.cachedCallbackIds = null;
    }
}


const $a13e9b2ce62d19e5$export$9675c02ec7fc88a8 = (0, $2XqLN.default)(()=>{
    return new (0, $b2c33a4aa51f5065$export$2f8f0e0ec8218c4b)();
});
module.exports["getGlobalTransitionPreloader"] = $a13e9b2ce62d19e5$export$9675c02ec7fc88a8;

});

parcelRegister("64KID", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $6b577cb9f675ff80$export$d4971375353d0454 = [
    $1NBp8.BASE,
    $1NBp8.WIKI,
    $1NBp8.HOME,
    $1NBp8.TEMPLATE_GALLERY,
    $1NBp8.CALENDAR,
    $1NBp8.MY_CALENDAR,
    $1NBp8.QUESTIONS,
    $1NBp8.QUESTIONS_NATIVE,
    $1NBp8.QUESTIONS_TOPICS_NATIVE,
    $1NBp8.QUESTIONS_TOPIC_NATIVE,
    $1NBp8.QUESTIONS_EXPERTS_NATIVE,
    $1NBp8.QUESTION_NATIVE,
    $1NBp8.CONTENT_HISTORY,
    $1NBp8.CONTENT_HISTORY_LEGACY,
    $1NBp8.EDIT_PAGE,
    $1NBp8.EDIT_BLOG,
    $1NBp8.EDIT_PAGE_V2,
    $1NBp8.EDIT_BLOG_V2,
    $1NBp8.EDIT_PAGE_EMBED,
    $1NBp8.EDIT_PAGE_SMART_CREATE,
    $1NBp8.CREATE_CONTENT,
    $1NBp8.CREATE_PAGE,
    $1NBp8.CREATE_BLOG,
    $1NBp8.DELETE_PAGE,
    $1NBp8.ONBOARDING,
    $1NBp8.SPACE_DIRECTORY,
    $1NBp8.SPACE_SETTINGS,
    $1NBp8.SPACE_SETTINGS_REORDERPAGES,
    $1NBp8.SPACE_OVERVIEW_REDIRECT_LEGACY,
    $1NBp8.DELETE_SPACE_LEGACY,
    $1NBp8.SPACE_INDEX,
    $1NBp8.SPACE_OVERVIEW,
    $1NBp8.SPACE_SMART_CREATE,
    $1NBp8.HUB,
    $1NBp8.HUB_EDIT,
    $1NBp8.COMPANY_HUB,
    $1NBp8.COMPANY_HUB_ANALYTICS,
    $1NBp8.COMPANY_HUB_EDIT,
    $1NBp8.COMPANY_HUB_SETTINGS,
    $1NBp8.VIEW_PAGE,
    $1NBp8.NEXT_VIEW_PAGE,
    $1NBp8.BLOG_HOME,
    $1NBp8.VIEW_BLOG,
    $1NBp8.WHITEBOARD_HOME,
    $1NBp8.WHITEBOARD_BOARD,
    $1NBp8.CONTACT_ADMINISTRATOR,
    $1NBp8.ADMIN_SETTINGS,
    $1NBp8.ADMIN_GLOBAL_AUTOMATION,
    $1NBp8.ADMIN_EDIT_EXTERNAL_SHARING,
    $1NBp8.ADMIN_FORGE_APPS_REDIRECT,
    $1NBp8.ADMIN_FORGE_APPS,
    $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS,
    $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS,
    $1NBp8.ADMIN_COMPANY_HOME_BUILDER,
    $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION,
    $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS_USER_DETAILS,
    $1NBp8.ADMIN_SITE_SPACE_PERMISSIONS,
    $1NBp8.SPACE_PERMISSIONS_APPS,
    $1NBp8.EDIT_SPACE_PERMISSIONS_APPS,
    $1NBp8.ADMIN_AUDIT_LOG,
    $1NBp8.ADMIN_BROWSE_SHORTCUTS,
    $1NBp8.ADMIN_CREATE_SHORTCUT,
    $1NBp8.ADMIN_REMOVE_SHORTCUT,
    $1NBp8.ADMIN_DARK_FEATURES,
    $1NBp8.ADMIN_ENABLE_DARK_FEATURE,
    $1NBp8.ADMIN_DISABLE_DARK_FEATURE,
    $1NBp8.ADMIN_BETA_FEATURES,
    $1NBp8.ADMIN_NEW_FEATURES,
    $1NBp8.ADMIN_LIVE_EDIT,
    $1NBp8.SPACE_CALENDAR,
    $1NBp8.SPACE_CALENDARS,
    $1NBp8.SPACE_CALENDARS_SUBCALENDAR,
    $1NBp8.SPACE_EMBEDDED_SUBCALENDAR,
    $1NBp8.MULTIPLE_SUBCALENDAR,
    $1NBp8.EMBEDDED_MULTIPLE_SUBCALENDAR,
    $1NBp8.DISCOVER,
    $1NBp8.ALL_UPDATES,
    $1NBp8.POPULAR,
    $1NBp8.MY_WORK_HOME,
    $1NBp8.MY_WORK_DRAFTS,
    $1NBp8.MY_WORK_RECENT,
    $1NBp8.MY_RECENTLY_VISITED,
    $1NBp8.MY_SAVED_FOR_LATER,
    $1NBp8.RECENT_PAGES,
    $1NBp8.RECENT_VISITED,
    $1NBp8.RECENT_DRAFTS,
    $1NBp8.RECENT_SAVED,
    $1NBp8.TEMPLATE_MIGRATION_PREVIEW,
    $1NBp8.EDIT_TEMPLATE,
    $1NBp8.EDIT_TEMPLATE_BLUEPRINT,
    $1NBp8.EDIT_TEMPLATE_SPACE,
    $1NBp8.CREATE_TEMPLATE,
    $1NBp8.CREATE_TEMPLATE_SPACE,
    $1NBp8.HELLO_WORLD,
    $1NBp8.DASHBOARD_ACTION_LEGACY,
    $1NBp8.SPA_ACTION_LEGACY,
    $1NBp8.INDEX_ACTION_LEGACY,
    $1NBp8.CREATE_PAGE_ACTION_LEGACY,
    $1NBp8.CREATE_BLOG_ACTION_LEGACY,
    $1NBp8.CREATE_PAGE_VARIABLES_ACTION_LEGACY,
    $1NBp8.RESUME_DRAFT_LEGACY,
    $1NBp8.COPY_PAGE_LEGACY,
    $1NBp8.VIEW_PAGE_ACTION_LEGACY,
    $1NBp8.SPACE_OVERVIEW_INDEX_ACTION_LEGACY,
    $1NBp8.SPACE_INDEX_ACTION_LEGACY,
    $1NBp8.SPACE_PAGES,
    $1NBp8.VIEW_BLOG_DATE_LEGACY,
    $1NBp8.ACTION_REDIRECT_LEGACY,
    $1NBp8.ADVANCED_SEARCH_LEGACY,
    $1NBp8.ADVANCED_SEARCH,
    $1NBp8.EXTERNAL_SHARE,
    $1NBp8.PDF_EXPORT_PAGE,
    $1NBp8.PDF_EXPORT_SPACE,
    $1NBp8.LEGACY_SPACE_PDF_EXPORT,
    $1NBp8.EXPORT_SPACE_CSV,
    $1NBp8.EXPORT_SPACE_XML,
    $1NBp8.EXPORT_SPACE_HTML,
    $1NBp8.SPACE_SETTINGS_EXPORT,
    $1NBp8.SPACE_LEGACY_CONTENT,
    $1NBp8.VIEW_PAGE_MOBILE,
    $1NBp8.VIEW_BLOG_MOBILE,
    $1NBp8.PEOPLE_DIRECTORY_SEARCH,
    $1NBp8.CONFLUENCE_PEOPLE_DIRECTORY_SEARCH,
    $1NBp8.MARKETPLACE_FIND_APPS,
    $1NBp8.MARKETPLACE_APP_REQUESTS,
    $1NBp8.MARKETPLACE_MANAGE_PROMOTIONS,
    $1NBp8.PEOPLE_DIRECTORY,
    $1NBp8.SPACE_RESTRICTED_PAGES,
    $1NBp8.SPACE_ARCHIVED_PAGES,
    $1NBp8.PAGE_DIFF_BY_VERSION,
    $1NBp8.SITE_ANALYTICS,
    $1NBp8.SITE_ANALYTICS_PERMISSIONS,
    $1NBp8.SPACE_ANALYTICS,
    $1NBp8.SPACE_ANALYTICS_PERMISSIONS,
    $1NBp8.PAGE_ANALYTICS,
    $1NBp8.SPACE_QUESTIONS,
    $1NBp8.SPACE_QUESTIONS_NATIVE,
    $1NBp8.SPACE_QUESTION_NATIVE,
    $1NBp8.SPACE_CUSTOM_CONTENT_LIST,
    $1NBp8.CUSTOM_CONTENT_VIEW,
    $1NBp8.SPACE_BULK_TOOLS,
    $1NBp8.SPACE_SETTINGS_LANDING_PAGE,
    $1NBp8.SPACE_SETTINGS_LANDING_PAGE_ALT,
    $1NBp8.SPACE_SETTINGS_AUTOMATION,
    $1NBp8.SPACE_SETTINGS_ARCHIVE_SPACE,
    $1NBp8.SPACE_SETTINGS_TRASH_SPACE,
    $1NBp8.SPACE_FORGE_APPS,
    $1NBp8.GLOBAL_PAGE_FORGE,
    $1NBp8.FULL_PAGE_FORGE,
    $1NBp8.SPACE_SETTINGS_FORGE_APPS,
    $1NBp8.SPACE_SETTINGS_AVATARS_AND_STATUS,
    $1NBp8.SPACE_SETTINGS_CONTENT_STATE,
    $1NBp8.SPACE_SETTINGS_DATA_CLASSIFICATION,
    $1NBp8.SPACE_SETTINGS_WATERMARK_CONFIGURATION,
    $1NBp8.SPACE_SETTINGS_EXPORT_SPACE,
    $1NBp8.SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE,
    $1NBp8.SPACE_SETTINGS_HIDDEN_PAGES,
    $1NBp8.SPACE_SETTINGS_RELATED_PAGES,
    $1NBp8.SPACE_SETTINGS_UNDEFINED_PAGES,
    $1NBp8.SPACE_SETTINGS_ATTACHMENTS,
    $1NBp8.SPACE_SETTINGS_APPLICATION_LINKS,
    $1NBp8.SPACE_SETTINGS_RSS_FEEDS,
    $1NBp8.SPACE_SETTINGS_EDITOR_CONVERSION,
    $1NBp8.SPACE_LOOK_AND_FEEL_SETTINGS,
    $1NBp8.SPACE_TRASH,
    $1NBp8.MOBILE_TAKEOVER_PAGE,
    $1NBp8.MOBILE_MACRO_RENDERER,
    $1NBp8.DEFAULT_ADMIN_MANAGE_APPS,
    $1NBp8.ADMIN_APP_AUDIT_LOGS,
    $1NBp8.SPACE_SETTINGS_TEMPLATE_LIST_PAGE_LEGACY,
    $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS,
    $1NBp8.ADMIN_APPLICATION_NAVIGATOR,
    $1NBp8.CUSTOM_CONTENTS_ON_PAGE_LIST,
    $1NBp8.SPACE_PERMISSIONS_SETTINGS,
    $1NBp8.ROLE_BASED_ACCESS_CONTROL_HUB,
    $1NBp8.USER_ACCESS,
    $1NBp8.PERMISSIONS_EXPORT,
    $1NBp8.ADMIN_ANNOUNCEMENT_BANNER_RENDERER,
    $1NBp8.IMPORTER_STATUS_DASHBOARD,
    $1NBp8.SPACE_MANAGER,
    $1NBp8.ADMIN_CENTER,
    $1NBp8.ADMIN_CENTER_SPACE,
    $1NBp8.ADMIN_TEAM_CALENDARS,
    $1NBp8.ADMIN_CONFIGURATION,
    $1NBp8.ADMIN_DEFAULT_SPACE_LOGO,
    $1NBp8.ADMIN_HEADER_AND_FOOTER,
    $1NBp8.ADMIN_SECURITY_CONFIGURATION,
    $1NBp8.ADMIN_SPACE_REPORTS,
    $1NBp8.ADMIN_CODE_MACRO_CONFIGURATION,
    $1NBp8.ADMIN_COLOR_SCHEME,
    $1NBp8.DATABASE_VIEW,
    $1NBp8.DATABASE_CUSTOM_OVERVIEW,
    $1NBp8.DATABASE_CUSTOM_VIEW,
    $1NBp8.EMBED_VIEW,
    $1NBp8.FOLDER_VIEW,
    $1NBp8.SPACE_SETTINGS_EDIT_FEATURES,
    $1NBp8.ADMIN_BULK_PERMISSIONS,
    $1NBp8.ADMIN_NOTIFICATIONS,
    $1NBp8.ADMIN_TRASHED_SPACES,
    $1NBp8.ADMIN_JIRA_MACRO_REPAIR,
    $1NBp8.ADMIN_IMPORT_SPACES,
    $1NBp8.ADMIN_MACRO_USAGE,
    $1NBp8.ADMIN_MACRO_USAGE_LEGACY,
    $1NBp8.ADMIN_NBM_MIGRATION,
    $1NBp8.ADMIN_DC_SCRIPT_MIGRATION,
    $1NBp8.ADMIN_NBM_PERFORMANCE_REPORT,
    $1NBp8.SPACE_MEMBERS,
    $1NBp8.ADMIN_THEMES,
    $1NBp8.ADMIN_PDF_EXPORT,
    $1NBp8.CREATE_TEMPLATE_SITE_LEGACY,
    $1NBp8.CREATE_TEMPLATE_SPACE_LEGACY,
    $1NBp8.SITE_SETTINGS_EDIT_TEMPLATE_LEGACY,
    $1NBp8.SPACE_SETTINGS_TEMPLATES,
    $1NBp8.SPACE_SETTINGS_EDIT_TEMPLATE_LEGACY,
    $1NBp8.TOPICS,
    $1NBp8.LABELLED_CONTENT,
    $1NBp8.SITE_SETTINGS_EDIT_SYSTEM_TEMPLATE_LEGACY,
    $1NBp8.EDIT_DEFAULT_BLUEPRINT_LEGACY,
    $1NBp8.SPACE_SETTINGS_DETAILS,
    $1NBp8.PREMIUM_ADMIN_FEATURES_EXPERIMENT,
    $1NBp8.ATTACHMENTS_PAGE,
    $1NBp8.AI_SEARCH_PAGE
].reduce((acc, route)=>{
    acc[route.name] = route;
    return acc;
}, {});
module.exports["namedRoutes"] = $6b577cb9f675ff80$export$d4971375353d0454;

});

parcelRegister("1AV5C", function(module, exports) {
// @ts-ignore

var $7UOIm = parcelRequire("7UOIm");

function $296ae6b56fdf64d7$var$hash(algorithm, data, asBytes = false) {
    const hash1 = (0, (/*@__PURE__*/$parcel$interopDefault($7UOIm))).createHash(algorithm);
    hash1.update(data);
    if (asBytes) return Array.from(hash1.digest());
    return hash1.digest('hex');
}
function $296ae6b56fdf64d7$export$7904c6256691057a(data) {
    return $296ae6b56fdf64d7$var$hash('sha256', data);
}
function $296ae6b56fdf64d7$export$5fdf8c875acfc1b3(data) {
    return $296ae6b56fdf64d7$var$hash('sha256', data, true);
}
function $296ae6b56fdf64d7$export$bf9b056bcf5cf86a(data) {
    return $296ae6b56fdf64d7$var$hash('sha1', data);
}
module.exports["hashData"] = $296ae6b56fdf64d7$export$7904c6256691057a;
module.exports["hashDataAsByte"] = $296ae6b56fdf64d7$export$5fdf8c875acfc1b3;
module.exports["hashDataWithSha1_DO_NOT_USE"] = $296ae6b56fdf64d7$export$bf9b056bcf5cf86a;

});

parcelRegister("7UOIm", function(module, exports) {
$parcel$export(module.exports, "randomBytes", () => $5c351a33725583b1$export$5f828d93ff035aa8, (v) => $5c351a33725583b1$export$5f828d93ff035aa8 = v);
$parcel$export(module.exports, "rng", () => $5c351a33725583b1$export$cd94982b18c6332c, (v) => $5c351a33725583b1$export$cd94982b18c6332c = v);
$parcel$export(module.exports, "pseudoRandomBytes", () => $5c351a33725583b1$export$1d518568e4f529b0, (v) => $5c351a33725583b1$export$1d518568e4f529b0 = v);
$parcel$export(module.exports, "prng", () => $5c351a33725583b1$export$5285b6d41c912b41, (v) => $5c351a33725583b1$export$5285b6d41c912b41 = v);
$parcel$export(module.exports, "createHash", () => $5c351a33725583b1$export$2fb37efbf6ae0c0e, (v) => $5c351a33725583b1$export$2fb37efbf6ae0c0e = v);
$parcel$export(module.exports, "Hash", () => $5c351a33725583b1$export$ab85ecd77ce6a5cd, (v) => $5c351a33725583b1$export$ab85ecd77ce6a5cd = v);
$parcel$export(module.exports, "createHmac", () => $5c351a33725583b1$export$da39cf97e1eb7c91, (v) => $5c351a33725583b1$export$da39cf97e1eb7c91 = v);
$parcel$export(module.exports, "Hmac", () => $5c351a33725583b1$export$52a9039d7177394f, (v) => $5c351a33725583b1$export$52a9039d7177394f = v);
$parcel$export(module.exports, "getHashes", () => $5c351a33725583b1$export$f7201db400317331, (v) => $5c351a33725583b1$export$f7201db400317331 = v);
$parcel$export(module.exports, "pbkdf2", () => $5c351a33725583b1$export$448fa22aedc9dbca, (v) => $5c351a33725583b1$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $5c351a33725583b1$export$b80c7ba289c8fa56, (v) => $5c351a33725583b1$export$b80c7ba289c8fa56 = v);
$parcel$export(module.exports, "Cipher", () => $5c351a33725583b1$export$26e5786e8ac8e530, (v) => $5c351a33725583b1$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipher", () => $5c351a33725583b1$export$bdd223f16383713e, (v) => $5c351a33725583b1$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipheriv", () => $5c351a33725583b1$export$20533d26f07f1ee0, (v) => $5c351a33725583b1$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createCipheriv", () => $5c351a33725583b1$export$2f64596b8cbf08b4, (v) => $5c351a33725583b1$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Decipher", () => $5c351a33725583b1$export$2ce6d8d0e8b04e1a, (v) => $5c351a33725583b1$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipher", () => $5c351a33725583b1$export$12ada9414fbc594c, (v) => $5c351a33725583b1$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipheriv", () => $5c351a33725583b1$export$f5e7e39d57cd9700, (v) => $5c351a33725583b1$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "createDecipheriv", () => $5c351a33725583b1$export$36b6d6ef312eab39, (v) => $5c351a33725583b1$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $5c351a33725583b1$export$58a258485f1e49f6, (v) => $5c351a33725583b1$export$58a258485f1e49f6 = v);
$parcel$export(module.exports, "listCiphers", () => $5c351a33725583b1$export$dedd8dc3dc62b370, (v) => $5c351a33725583b1$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "DiffieHellmanGroup", () => $5c351a33725583b1$export$971862a2fcb1bb40, (v) => $5c351a33725583b1$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $5c351a33725583b1$export$c6ff6a88acbeaf40, (v) => $5c351a33725583b1$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $5c351a33725583b1$export$fdc27893e98845cc, (v) => $5c351a33725583b1$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $5c351a33725583b1$export$6671fb9a1323bed, (v) => $5c351a33725583b1$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $5c351a33725583b1$export$d74daf141a551db, (v) => $5c351a33725583b1$export$d74daf141a551db = v);
$parcel$export(module.exports, "createSign", () => $5c351a33725583b1$export$45df7cae684751af, (v) => $5c351a33725583b1$export$45df7cae684751af = v);
$parcel$export(module.exports, "Sign", () => $5c351a33725583b1$export$1db683ad541682f6, (v) => $5c351a33725583b1$export$1db683ad541682f6 = v);
$parcel$export(module.exports, "createVerify", () => $5c351a33725583b1$export$6f65485f87568e37, (v) => $5c351a33725583b1$export$6f65485f87568e37 = v);
$parcel$export(module.exports, "Verify", () => $5c351a33725583b1$export$91a8e56769aeb334, (v) => $5c351a33725583b1$export$91a8e56769aeb334 = v);
$parcel$export(module.exports, "createECDH", () => $5c351a33725583b1$export$2d4117e99c2179e4, (v) => $5c351a33725583b1$export$2d4117e99c2179e4 = v);
$parcel$export(module.exports, "publicEncrypt", () => $5c351a33725583b1$export$512823e338ddb1b7, (v) => $5c351a33725583b1$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateEncrypt", () => $5c351a33725583b1$export$9d0e0c0c4a8d30f3, (v) => $5c351a33725583b1$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $5c351a33725583b1$export$b9d55ff329113abd, (v) => $5c351a33725583b1$export$b9d55ff329113abd = v);
$parcel$export(module.exports, "privateDecrypt", () => $5c351a33725583b1$export$7efb24e2fddf99b9, (v) => $5c351a33725583b1$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "randomFill", () => $5c351a33725583b1$export$bb1abf2ce84fc7e8, (v) => $5c351a33725583b1$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $5c351a33725583b1$export$2f7171e78e524d5e, (v) => $5c351a33725583b1$export$2f7171e78e524d5e = v);
$parcel$export(module.exports, "createCredentials", () => $5c351a33725583b1$export$e1d879b482f37d98, (v) => $5c351a33725583b1$export$e1d879b482f37d98 = v);
$parcel$export(module.exports, "constants", () => $5c351a33725583b1$export$1a988e7317c65621, (v) => $5c351a33725583b1$export$1a988e7317c65621 = v);
// eslint-disable-next-line no-multi-assign
var $5c351a33725583b1$export$5f828d93ff035aa8;
var $5c351a33725583b1$export$cd94982b18c6332c;
var $5c351a33725583b1$export$1d518568e4f529b0;
var $5c351a33725583b1$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $5c351a33725583b1$export$2fb37efbf6ae0c0e;
var $5c351a33725583b1$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $5c351a33725583b1$export$da39cf97e1eb7c91;
var $5c351a33725583b1$export$52a9039d7177394f;
var $5c351a33725583b1$export$f7201db400317331;
var $5c351a33725583b1$export$448fa22aedc9dbca;
var $5c351a33725583b1$export$b80c7ba289c8fa56;
var $5c351a33725583b1$export$26e5786e8ac8e530;
var $5c351a33725583b1$export$bdd223f16383713e;
var $5c351a33725583b1$export$20533d26f07f1ee0;
var $5c351a33725583b1$export$2f64596b8cbf08b4;
var $5c351a33725583b1$export$2ce6d8d0e8b04e1a;
var $5c351a33725583b1$export$12ada9414fbc594c;
var $5c351a33725583b1$export$f5e7e39d57cd9700;
var $5c351a33725583b1$export$36b6d6ef312eab39;
var $5c351a33725583b1$export$58a258485f1e49f6;
var $5c351a33725583b1$export$dedd8dc3dc62b370;
var $5c351a33725583b1$export$971862a2fcb1bb40;
var $5c351a33725583b1$export$c6ff6a88acbeaf40;
var $5c351a33725583b1$export$fdc27893e98845cc;
var $5c351a33725583b1$export$6671fb9a1323bed;
var $5c351a33725583b1$export$d74daf141a551db;
var $5c351a33725583b1$export$45df7cae684751af;
var $5c351a33725583b1$export$1db683ad541682f6;
var $5c351a33725583b1$export$6f65485f87568e37;
var $5c351a33725583b1$export$91a8e56769aeb334;
var $5c351a33725583b1$export$2d4117e99c2179e4;
var $5c351a33725583b1$export$512823e338ddb1b7;
var $5c351a33725583b1$export$9d0e0c0c4a8d30f3;
var $5c351a33725583b1$export$b9d55ff329113abd;
var $5c351a33725583b1$export$7efb24e2fddf99b9;
var $5c351a33725583b1$export$bb1abf2ce84fc7e8;
var $5c351a33725583b1$export$2f7171e78e524d5e;
var $5c351a33725583b1$export$e1d879b482f37d98;
var $5c351a33725583b1$export$1a988e7317c65621;
'use strict';

$5c351a33725583b1$export$5f828d93ff035aa8 = $5c351a33725583b1$export$cd94982b18c6332c = $5c351a33725583b1$export$1d518568e4f529b0 = $5c351a33725583b1$export$5285b6d41c912b41 = (parcelRequire("97jsf"));

$5c351a33725583b1$export$2fb37efbf6ae0c0e = $5c351a33725583b1$export$ab85ecd77ce6a5cd = (parcelRequire("abSTA"));

$5c351a33725583b1$export$da39cf97e1eb7c91 = $5c351a33725583b1$export$52a9039d7177394f = (parcelRequire("b1JBa"));
var $04dc38bd2ae545b3$exports = {};
'use strict';

$04dc38bd2ae545b3$exports = (parcelRequire("0izgv"));


var $5c351a33725583b1$var$algoKeys = Object.keys($04dc38bd2ae545b3$exports);
var $5c351a33725583b1$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($5c351a33725583b1$var$algoKeys);
$5c351a33725583b1$export$f7201db400317331 = function() {
    return $5c351a33725583b1$var$hashes;
};

var $h8Kts = parcelRequire("h8Kts");

$5c351a33725583b1$export$448fa22aedc9dbca = $h8Kts.pbkdf2;
$5c351a33725583b1$export$b80c7ba289c8fa56 = $h8Kts.pbkdf2Sync;
var $7e852089dfabbbfd$export$bdd223f16383713e;
var $7e852089dfabbbfd$export$26e5786e8ac8e530;
var $7e852089dfabbbfd$export$2f64596b8cbf08b4;
var $7e852089dfabbbfd$export$20533d26f07f1ee0;
var $7e852089dfabbbfd$export$12ada9414fbc594c;
var $7e852089dfabbbfd$export$2ce6d8d0e8b04e1a;
var $7e852089dfabbbfd$export$36b6d6ef312eab39;
var $7e852089dfabbbfd$export$f5e7e39d57cd9700;
var $7e852089dfabbbfd$export$dedd8dc3dc62b370;
var $7e852089dfabbbfd$export$58a258485f1e49f6;
var $0b8e5539cf77f537$exports = {};

var $3xrS3 = parcelRequire("3xrS3");

var $145a3eab147d4459$export$eab97d15b1788b8d;
var $145a3eab147d4459$export$26e5786e8ac8e530;
var $145a3eab147d4459$export$cc8859615686b300;
var $145a3eab147d4459$export$8ad3f227af08fcc5;
var $145a3eab147d4459$export$947646e34766044f;
'use strict';

$145a3eab147d4459$export$eab97d15b1788b8d = (parcelRequire("aqm7A"));

$145a3eab147d4459$export$26e5786e8ac8e530 = (parcelRequire("6qpJT"));

$145a3eab147d4459$export$cc8859615686b300 = (parcelRequire("jwgTG"));

$145a3eab147d4459$export$8ad3f227af08fcc5 = (parcelRequire("czrgF"));

$145a3eab147d4459$export$947646e34766044f = (parcelRequire("5Jmd3"));



var $dMzRp = parcelRequire("dMzRp");


var $eI8vp = parcelRequire("eI8vp");

var $0b8e5539cf77f537$require$Buffer = $eI8vp.Buffer;
var $0b8e5539cf77f537$var$modes = {
    'des-ede3-cbc': $145a3eab147d4459$export$8ad3f227af08fcc5.instantiate($145a3eab147d4459$export$947646e34766044f),
    'des-ede3': $145a3eab147d4459$export$947646e34766044f,
    'des-ede-cbc': $145a3eab147d4459$export$8ad3f227af08fcc5.instantiate($145a3eab147d4459$export$947646e34766044f),
    'des-ede': $145a3eab147d4459$export$947646e34766044f,
    'des-cbc': $145a3eab147d4459$export$8ad3f227af08fcc5.instantiate($145a3eab147d4459$export$cc8859615686b300),
    'des-ecb': $145a3eab147d4459$export$cc8859615686b300
};
$0b8e5539cf77f537$var$modes.des = $0b8e5539cf77f537$var$modes['des-cbc'];
$0b8e5539cf77f537$var$modes.des3 = $0b8e5539cf77f537$var$modes['des-ede3-cbc'];
$0b8e5539cf77f537$exports = $0b8e5539cf77f537$var$DES;
$dMzRp($0b8e5539cf77f537$var$DES, $3xrS3);
function $0b8e5539cf77f537$var$DES(opts) {
    $3xrS3.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $0b8e5539cf77f537$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$0b8e5539cf77f537$require$Buffer.isBuffer(key)) key = $0b8e5539cf77f537$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $0b8e5539cf77f537$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$0b8e5539cf77f537$require$Buffer.isBuffer(iv)) iv = $0b8e5539cf77f537$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$0b8e5539cf77f537$var$DES.prototype._update = function(data) {
    return $0b8e5539cf77f537$require$Buffer.from(this._des.update(data));
};
$0b8e5539cf77f537$var$DES.prototype._final = function() {
    return $0b8e5539cf77f537$require$Buffer.from(this._des.final());
};



var $j9ccG = parcelRequire("j9ccG");


var $e6oz7 = parcelRequire("e6oz7");

var $9fcff94de07f9b69$exports = {};
$parcel$export($9fcff94de07f9b69$exports, "des-ecb", () => $9fcff94de07f9b69$export$116f8a5cee447347, (v) => $9fcff94de07f9b69$export$116f8a5cee447347 = v);
$parcel$export($9fcff94de07f9b69$exports, "des-cbc", () => $9fcff94de07f9b69$export$7483c4066bfb7ae9, (v) => $9fcff94de07f9b69$export$7483c4066bfb7ae9 = v);
$parcel$export($9fcff94de07f9b69$exports, "des", () => $9fcff94de07f9b69$export$e7a565d2e588bb06, (v) => $9fcff94de07f9b69$export$e7a565d2e588bb06 = v);
$parcel$export($9fcff94de07f9b69$exports, "des-ede3-cbc", () => $9fcff94de07f9b69$export$aaa2f54a426f3eb8, (v) => $9fcff94de07f9b69$export$aaa2f54a426f3eb8 = v);
$parcel$export($9fcff94de07f9b69$exports, "des3", () => $9fcff94de07f9b69$export$eba20568dde4ada, (v) => $9fcff94de07f9b69$export$eba20568dde4ada = v);
$parcel$export($9fcff94de07f9b69$exports, "des-ede3", () => $9fcff94de07f9b69$export$d3b5e5996938f5ae, (v) => $9fcff94de07f9b69$export$d3b5e5996938f5ae = v);
$parcel$export($9fcff94de07f9b69$exports, "des-ede-cbc", () => $9fcff94de07f9b69$export$57c08356130bc99b, (v) => $9fcff94de07f9b69$export$57c08356130bc99b = v);
$parcel$export($9fcff94de07f9b69$exports, "des-ede", () => $9fcff94de07f9b69$export$c7169791d5c1e65d, (v) => $9fcff94de07f9b69$export$c7169791d5c1e65d = v);
var $9fcff94de07f9b69$export$116f8a5cee447347;
var $9fcff94de07f9b69$export$7483c4066bfb7ae9;
var $9fcff94de07f9b69$export$e7a565d2e588bb06;
var $9fcff94de07f9b69$export$aaa2f54a426f3eb8;
var $9fcff94de07f9b69$export$eba20568dde4ada;
var $9fcff94de07f9b69$export$d3b5e5996938f5ae;
var $9fcff94de07f9b69$export$57c08356130bc99b;
var $9fcff94de07f9b69$export$c7169791d5c1e65d;
$9fcff94de07f9b69$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$9fcff94de07f9b69$export$7483c4066bfb7ae9 = $9fcff94de07f9b69$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$9fcff94de07f9b69$export$aaa2f54a426f3eb8 = $9fcff94de07f9b69$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$9fcff94de07f9b69$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$9fcff94de07f9b69$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$9fcff94de07f9b69$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};



var $kexZs = parcelRequire("kexZs");

function $7e852089dfabbbfd$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($e6oz7[suite]) {
        keyLen = $e6oz7[suite].key;
        ivLen = $e6oz7[suite].iv;
    } else if ($9fcff94de07f9b69$exports[suite]) {
        keyLen = $9fcff94de07f9b69$exports[suite].key * 8;
        ivLen = $9fcff94de07f9b69$exports[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $kexZs(password, false, keyLen, ivLen);
    return $7e852089dfabbbfd$var$createCipheriv(suite, keys.key, keys.iv);
}
function $7e852089dfabbbfd$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($e6oz7[suite]) {
        keyLen = $e6oz7[suite].key;
        ivLen = $e6oz7[suite].iv;
    } else if ($9fcff94de07f9b69$exports[suite]) {
        keyLen = $9fcff94de07f9b69$exports[suite].key * 8;
        ivLen = $9fcff94de07f9b69$exports[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $kexZs(password, false, keyLen, ivLen);
    return $7e852089dfabbbfd$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $7e852089dfabbbfd$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($e6oz7[suite]) return $j9ccG.createCipheriv(suite, key, iv);
    if ($9fcff94de07f9b69$exports[suite]) return new $0b8e5539cf77f537$exports({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $7e852089dfabbbfd$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($e6oz7[suite]) return $j9ccG.createDecipheriv(suite, key, iv);
    if ($9fcff94de07f9b69$exports[suite]) return new $0b8e5539cf77f537$exports({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $7e852089dfabbbfd$var$getCiphers() {
    return Object.keys($9fcff94de07f9b69$exports).concat($j9ccG.getCiphers());
}
$7e852089dfabbbfd$export$bdd223f16383713e = $7e852089dfabbbfd$export$26e5786e8ac8e530 = $7e852089dfabbbfd$var$createCipher;
$7e852089dfabbbfd$export$2f64596b8cbf08b4 = $7e852089dfabbbfd$export$20533d26f07f1ee0 = $7e852089dfabbbfd$var$createCipheriv;
$7e852089dfabbbfd$export$12ada9414fbc594c = $7e852089dfabbbfd$export$2ce6d8d0e8b04e1a = $7e852089dfabbbfd$var$createDecipher;
$7e852089dfabbbfd$export$36b6d6ef312eab39 = $7e852089dfabbbfd$export$f5e7e39d57cd9700 = $7e852089dfabbbfd$var$createDecipheriv;
$7e852089dfabbbfd$export$dedd8dc3dc62b370 = $7e852089dfabbbfd$export$58a258485f1e49f6 = $7e852089dfabbbfd$var$getCiphers;


$5c351a33725583b1$export$26e5786e8ac8e530 = $7e852089dfabbbfd$export$26e5786e8ac8e530;
$5c351a33725583b1$export$bdd223f16383713e = $7e852089dfabbbfd$export$bdd223f16383713e;
$5c351a33725583b1$export$20533d26f07f1ee0 = $7e852089dfabbbfd$export$20533d26f07f1ee0;
$5c351a33725583b1$export$2f64596b8cbf08b4 = $7e852089dfabbbfd$export$2f64596b8cbf08b4;
$5c351a33725583b1$export$2ce6d8d0e8b04e1a = $7e852089dfabbbfd$export$2ce6d8d0e8b04e1a;
$5c351a33725583b1$export$12ada9414fbc594c = $7e852089dfabbbfd$export$12ada9414fbc594c;
$5c351a33725583b1$export$f5e7e39d57cd9700 = $7e852089dfabbbfd$export$f5e7e39d57cd9700;
$5c351a33725583b1$export$36b6d6ef312eab39 = $7e852089dfabbbfd$export$36b6d6ef312eab39;
$5c351a33725583b1$export$58a258485f1e49f6 = $7e852089dfabbbfd$export$58a258485f1e49f6;
$5c351a33725583b1$export$dedd8dc3dc62b370 = $7e852089dfabbbfd$export$dedd8dc3dc62b370;
var $d32f31019e3a809e$export$971862a2fcb1bb40;
var $d32f31019e3a809e$export$c6ff6a88acbeaf40;
var $d32f31019e3a809e$export$fdc27893e98845cc;
var $d32f31019e3a809e$export$6671fb9a1323bed;
var $d32f31019e3a809e$export$d74daf141a551db;

var $iA9co = parcelRequire("iA9co");

var $d32f31019e3a809e$require$Buffer = $iA9co.Buffer;
var $ad91bc525e7b6d58$exports = {};

var $97jsf = parcelRequire("97jsf");

$ad91bc525e7b6d58$exports = $ad91bc525e7b6d58$var$findPrime;
$ad91bc525e7b6d58$var$findPrime.simpleSieve = $ad91bc525e7b6d58$var$simpleSieve;
$ad91bc525e7b6d58$var$findPrime.fermatTest = $ad91bc525e7b6d58$var$fermatTest;

var $hpluo = parcelRequire("hpluo");

var $ad91bc525e7b6d58$var$TWENTYFOUR = new $hpluo(24);
var $d3a1cd24b72eebc0$exports = {};




var $7VcJI = parcelRequire("7VcJI");

function $d3a1cd24b72eebc0$var$MillerRabin(rand) {
    this.rand = rand || new $7VcJI.Rand();
}
$d3a1cd24b72eebc0$exports = $d3a1cd24b72eebc0$var$MillerRabin;
$d3a1cd24b72eebc0$var$MillerRabin.create = function create(rand) {
    return new $d3a1cd24b72eebc0$var$MillerRabin(rand);
};
$d3a1cd24b72eebc0$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $hpluo(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$d3a1cd24b72eebc0$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$d3a1cd24b72eebc0$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $hpluo.mont(n);
    var rone = new $hpluo(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $hpluo(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$d3a1cd24b72eebc0$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $hpluo.mont(n);
    var rone = new $hpluo(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $hpluo(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};


var $ad91bc525e7b6d58$var$millerRabin = new $d3a1cd24b72eebc0$exports();
var $ad91bc525e7b6d58$var$ONE = new $hpluo(1);
var $ad91bc525e7b6d58$var$TWO = new $hpluo(2);
var $ad91bc525e7b6d58$var$FIVE = new $hpluo(5);
var $ad91bc525e7b6d58$var$SIXTEEN = new $hpluo(16);
var $ad91bc525e7b6d58$var$EIGHT = new $hpluo(8);
var $ad91bc525e7b6d58$var$TEN = new $hpluo(10);
var $ad91bc525e7b6d58$var$THREE = new $hpluo(3);
var $ad91bc525e7b6d58$var$SEVEN = new $hpluo(7);
var $ad91bc525e7b6d58$var$ELEVEN = new $hpluo(11);
var $ad91bc525e7b6d58$var$FOUR = new $hpluo(4);
var $ad91bc525e7b6d58$var$TWELVE = new $hpluo(12);
var $ad91bc525e7b6d58$var$primes = null;
function $ad91bc525e7b6d58$var$_getPrimes() {
    if ($ad91bc525e7b6d58$var$primes !== null) return $ad91bc525e7b6d58$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $ad91bc525e7b6d58$var$primes = res;
    return res;
}
function $ad91bc525e7b6d58$var$simpleSieve(p) {
    var primes = $ad91bc525e7b6d58$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $ad91bc525e7b6d58$var$fermatTest(p) {
    var red = $hpluo.mont(p);
    return $ad91bc525e7b6d58$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $ad91bc525e7b6d58$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $hpluo([
            0x8c,
            0x7b
        ]);
        else return new $hpluo([
            0x8c,
            0x27
        ]);
    }
    gen = new $hpluo(gen);
    var num, n2;
    while(true){
        num = new $hpluo($97jsf(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($ad91bc525e7b6d58$var$ONE);
        if (!num.testn(1)) num.iadd($ad91bc525e7b6d58$var$TWO);
        if (!gen.cmp($ad91bc525e7b6d58$var$TWO)) while(num.mod($ad91bc525e7b6d58$var$TWENTYFOUR).cmp($ad91bc525e7b6d58$var$ELEVEN))num.iadd($ad91bc525e7b6d58$var$FOUR);
        else if (!gen.cmp($ad91bc525e7b6d58$var$FIVE)) while(num.mod($ad91bc525e7b6d58$var$TEN).cmp($ad91bc525e7b6d58$var$THREE))num.iadd($ad91bc525e7b6d58$var$FOUR);
        n2 = num.shrn(1);
        if ($ad91bc525e7b6d58$var$simpleSieve(n2) && $ad91bc525e7b6d58$var$simpleSieve(num) && $ad91bc525e7b6d58$var$fermatTest(n2) && $ad91bc525e7b6d58$var$fermatTest(num) && $ad91bc525e7b6d58$var$millerRabin.test(n2) && $ad91bc525e7b6d58$var$millerRabin.test(num)) return num;
    }
}


var $d8796468f5d9a427$exports = {};
$d8796468f5d9a427$exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");


var $23ef7c679c341182$exports = {};



var $23ef7c679c341182$require$Buffer = $iA9co.Buffer;




var $23ef7c679c341182$var$millerRabin = new $d3a1cd24b72eebc0$exports();
var $23ef7c679c341182$var$TWENTYFOUR = new $hpluo(24);
var $23ef7c679c341182$var$ELEVEN = new $hpluo(11);
var $23ef7c679c341182$var$TEN = new $hpluo(10);
var $23ef7c679c341182$var$THREE = new $hpluo(3);
var $23ef7c679c341182$var$SEVEN = new $hpluo(7);




$23ef7c679c341182$exports = $23ef7c679c341182$var$DH;
function $23ef7c679c341182$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$23ef7c679c341182$require$Buffer.isBuffer(pub)) pub = new $23ef7c679c341182$require$Buffer(pub, enc);
    this._pub = new $hpluo(pub);
    return this;
}
function $23ef7c679c341182$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$23ef7c679c341182$require$Buffer.isBuffer(priv)) priv = new $23ef7c679c341182$require$Buffer(priv, enc);
    this._priv = new $hpluo(priv);
    return this;
}
var $23ef7c679c341182$var$primeCache = {};
function $23ef7c679c341182$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $23ef7c679c341182$var$primeCache) return $23ef7c679c341182$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$ad91bc525e7b6d58$exports.simpleSieve || !$ad91bc525e7b6d58$exports.fermatTest(prime) || !$23ef7c679c341182$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $23ef7c679c341182$var$primeCache[hex] = error;
        return error;
    }
    if (!$23ef7c679c341182$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($23ef7c679c341182$var$TWENTYFOUR).cmp($23ef7c679c341182$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($23ef7c679c341182$var$TEN);
            if (rem.cmp($23ef7c679c341182$var$THREE) && rem.cmp($23ef7c679c341182$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $23ef7c679c341182$var$primeCache[hex] = error;
    return error;
}
function $23ef7c679c341182$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $hpluo(prime);
    this._prime = $hpluo.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $23ef7c679c341182$var$setPublicKey;
        this.setPrivateKey = $23ef7c679c341182$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($23ef7c679c341182$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $23ef7c679c341182$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$23ef7c679c341182$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $hpluo($97jsf(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$23ef7c679c341182$var$DH.prototype.computeSecret = function(other) {
    other = new $hpluo(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $23ef7c679c341182$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $23ef7c679c341182$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $23ef7c679c341182$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$23ef7c679c341182$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $23ef7c679c341182$var$formatReturnValue(this._pub, enc);
};
$23ef7c679c341182$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $23ef7c679c341182$var$formatReturnValue(this._priv, enc);
};
$23ef7c679c341182$var$DH.prototype.getPrime = function(enc) {
    return $23ef7c679c341182$var$formatReturnValue(this.__prime, enc);
};
$23ef7c679c341182$var$DH.prototype.getGenerator = function(enc) {
    return $23ef7c679c341182$var$formatReturnValue(this._gen, enc);
};
$23ef7c679c341182$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$23ef7c679c341182$require$Buffer.isBuffer(gen)) gen = new $23ef7c679c341182$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $hpluo(gen);
    return this;
};
function $23ef7c679c341182$var$formatReturnValue(bn, enc) {
    var buf = new $23ef7c679c341182$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}


function $d32f31019e3a809e$var$getDiffieHellman(mod) {
    var prime = new $d32f31019e3a809e$require$Buffer($d8796468f5d9a427$exports[mod].prime, 'hex');
    var gen = new $d32f31019e3a809e$require$Buffer($d8796468f5d9a427$exports[mod].gen, 'hex');
    return new $23ef7c679c341182$exports(prime, gen);
}
var $d32f31019e3a809e$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $d32f31019e3a809e$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($d32f31019e3a809e$require$Buffer.isBuffer(enc) || $d32f31019e3a809e$var$ENCODINGS[enc] === undefined) return $d32f31019e3a809e$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $d32f31019e3a809e$require$Buffer([
        2
    ]);
    if (!$d32f31019e3a809e$require$Buffer.isBuffer(generator)) generator = new $d32f31019e3a809e$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $23ef7c679c341182$exports($ad91bc525e7b6d58$exports(prime, generator), generator, true);
    if (!$d32f31019e3a809e$require$Buffer.isBuffer(prime)) prime = new $d32f31019e3a809e$require$Buffer(prime, enc);
    return new $23ef7c679c341182$exports(prime, generator, true);
}
$d32f31019e3a809e$export$971862a2fcb1bb40 = $d32f31019e3a809e$export$c6ff6a88acbeaf40 = $d32f31019e3a809e$export$fdc27893e98845cc = $d32f31019e3a809e$var$getDiffieHellman;
$d32f31019e3a809e$export$6671fb9a1323bed = $d32f31019e3a809e$export$d74daf141a551db = $d32f31019e3a809e$var$createDiffieHellman;


$5c351a33725583b1$export$971862a2fcb1bb40 = $d32f31019e3a809e$export$971862a2fcb1bb40;
$5c351a33725583b1$export$c6ff6a88acbeaf40 = $d32f31019e3a809e$export$c6ff6a88acbeaf40;
$5c351a33725583b1$export$fdc27893e98845cc = $d32f31019e3a809e$export$fdc27893e98845cc;
$5c351a33725583b1$export$6671fb9a1323bed = $d32f31019e3a809e$export$6671fb9a1323bed;
$5c351a33725583b1$export$d74daf141a551db = $d32f31019e3a809e$export$d74daf141a551db;
var $4b876b889d94e27e$exports = {};
'use strict';



var $4b876b889d94e27e$require$Buffer = $eI8vp.Buffer;

var $abSTA = parcelRequire("abSTA");


var $eNro0 = parcelRequire("eNro0");




var $efa0447c39c0c2fb$exports = {};
'use strict';



var $efa0447c39c0c2fb$require$Buffer = $eI8vp.Buffer;

var $b1JBa = parcelRequire("b1JBa");


var $1fiU8 = parcelRequire("1fiU8");


var $gBIbs = parcelRequire("gBIbs");

var $efa0447c39c0c2fb$require$EC = $gBIbs.ec;

var $j3uQG = parcelRequire("j3uQG");


var $jpRkG = parcelRequire("jpRkG");

var $da772705e85cec25$exports = {};
$da772705e85cec25$exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");


var $efa0447c39c0c2fb$var$RSA_PKCS1_PADDING = 1;
function $efa0447c39c0c2fb$var$sign(hash, key, hashType, signType, tag) {
    var priv = $jpRkG(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $efa0447c39c0c2fb$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $efa0447c39c0c2fb$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $efa0447c39c0c2fb$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $efa0447c39c0c2fb$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $1fiU8(pad, priv);
    return out;
}
function $efa0447c39c0c2fb$var$ecSign(hash, priv) {
    var curveId = $da772705e85cec25$exports[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $efa0447c39c0c2fb$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $efa0447c39c0c2fb$require$Buffer.from(out.toDER());
}
function $efa0447c39c0c2fb$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $j3uQG(0);
    var k;
    var H = $efa0447c39c0c2fb$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $efa0447c39c0c2fb$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $efa0447c39c0c2fb$var$makeKey(q, kv, algo);
        r = $efa0447c39c0c2fb$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $j3uQG(0);
        }
    }
    return $efa0447c39c0c2fb$var$toDER(r, s);
}
function $efa0447c39c0c2fb$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $efa0447c39c0c2fb$require$Buffer.from(res);
}
function $efa0447c39c0c2fb$var$getKey(x, q, hash, algo) {
    x = $efa0447c39c0c2fb$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $efa0447c39c0c2fb$require$Buffer.alloc(q.byteLength() - x.length);
        x = $efa0447c39c0c2fb$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $efa0447c39c0c2fb$var$bits2octets(hash, q);
    var v = $efa0447c39c0c2fb$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $efa0447c39c0c2fb$require$Buffer.alloc(hlen);
    k = $b1JBa(algo, k).update(v).update($efa0447c39c0c2fb$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $b1JBa(algo, k).update(v).digest();
    k = $b1JBa(algo, k).update(v).update($efa0447c39c0c2fb$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $b1JBa(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $efa0447c39c0c2fb$var$bits2int(obits, q) {
    var bits = new $j3uQG(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $efa0447c39c0c2fb$var$bits2octets(bits, q) {
    bits = $efa0447c39c0c2fb$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $efa0447c39c0c2fb$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $efa0447c39c0c2fb$require$Buffer.alloc(q.byteLength() - out.length);
        out = $efa0447c39c0c2fb$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $efa0447c39c0c2fb$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $efa0447c39c0c2fb$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $b1JBa(algo, kv.k).update(kv.v).digest();
            t = $efa0447c39c0c2fb$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $efa0447c39c0c2fb$var$bits2int(t, q);
        kv.k = $b1JBa(algo, kv.k).update(kv.v).update($efa0447c39c0c2fb$require$Buffer.from([
            0
        ])).digest();
        kv.v = $b1JBa(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $efa0447c39c0c2fb$var$makeR(g, k, p, q) {
    return g.toRed($j3uQG.mont(p)).redPow(k).fromRed().mod(q);
}
$efa0447c39c0c2fb$exports = $efa0447c39c0c2fb$var$sign;
$efa0447c39c0c2fb$exports.getKey = $efa0447c39c0c2fb$var$getKey;
$efa0447c39c0c2fb$exports.makeKey = $efa0447c39c0c2fb$var$makeKey;


var $5b913adfad433ec3$exports = {};
'use strict';



var $5b913adfad433ec3$require$Buffer = $eI8vp.Buffer;






var $5b913adfad433ec3$require$EC = $gBIbs.ec;




function $5b913adfad433ec3$var$verify(sig, hash, key, signType, tag) {
    var pub = $jpRkG(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $5b913adfad433ec3$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $5b913adfad433ec3$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $5b913adfad433ec3$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $5b913adfad433ec3$require$Buffer.from(pad);
    var red = $j3uQG.mont(pub.modulus);
    sig = new $j3uQG(sig).toRed(red);
    sig = sig.redPow(new $j3uQG(pub.publicExponent));
    sig = $5b913adfad433ec3$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $5b913adfad433ec3$var$ecVerify(sig, hash, pub) {
    var curveId = $da772705e85cec25$exports[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $5b913adfad433ec3$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $5b913adfad433ec3$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $jpRkG.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $5b913adfad433ec3$var$checkValue(s, q);
    $5b913adfad433ec3$var$checkValue(r, q);
    var montp = $j3uQG.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $j3uQG(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $5b913adfad433ec3$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
$5b913adfad433ec3$exports = $5b913adfad433ec3$var$verify;



var $0izgv = parcelRequire("0izgv");

Object.keys($0izgv).forEach(function(key) {
    $0izgv[key].id = $4b876b889d94e27e$require$Buffer.from($0izgv[key].id, 'hex');
    $0izgv[key.toLowerCase()] = $0izgv[key];
});
function $4b876b889d94e27e$var$Sign(algorithm) {
    $eNro0.Writable.call(this);
    var data = $0izgv[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $abSTA(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dMzRp($4b876b889d94e27e$var$Sign, $eNro0.Writable);
$4b876b889d94e27e$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$4b876b889d94e27e$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $4b876b889d94e27e$require$Buffer.from(data, enc) : data);
    return this;
};
$4b876b889d94e27e$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $efa0447c39c0c2fb$exports(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $4b876b889d94e27e$var$Verify(algorithm) {
    $eNro0.Writable.call(this);
    var data = $0izgv[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $abSTA(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dMzRp($4b876b889d94e27e$var$Verify, $eNro0.Writable);
$4b876b889d94e27e$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$4b876b889d94e27e$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $4b876b889d94e27e$require$Buffer.from(data, enc) : data);
    return this;
};
$4b876b889d94e27e$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $4b876b889d94e27e$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $5b913adfad433ec3$exports(sigBuffer, hash, key, this._signType, this._tag);
};
function $4b876b889d94e27e$var$createSign(algorithm) {
    return new $4b876b889d94e27e$var$Sign(algorithm);
}
function $4b876b889d94e27e$var$createVerify(algorithm) {
    return new $4b876b889d94e27e$var$Verify(algorithm);
}
$4b876b889d94e27e$exports = {
    Sign: $4b876b889d94e27e$var$createSign,
    Verify: $4b876b889d94e27e$var$createVerify,
    createSign: $4b876b889d94e27e$var$createSign,
    createVerify: $4b876b889d94e27e$var$createVerify
};


$5c351a33725583b1$export$45df7cae684751af = $4b876b889d94e27e$exports.createSign;
$5c351a33725583b1$export$1db683ad541682f6 = $4b876b889d94e27e$exports.Sign;
$5c351a33725583b1$export$6f65485f87568e37 = $4b876b889d94e27e$exports.createVerify;
$5c351a33725583b1$export$91a8e56769aeb334 = $4b876b889d94e27e$exports.Verify;

$5c351a33725583b1$export$2d4117e99c2179e4 = (parcelRequire("dqaxD"));

var $2QUb5 = parcelRequire("2QUb5");

$5c351a33725583b1$export$512823e338ddb1b7 = $2QUb5.publicEncrypt;
$5c351a33725583b1$export$9d0e0c0c4a8d30f3 = $2QUb5.privateEncrypt;
$5c351a33725583b1$export$b9d55ff329113abd = $2QUb5.publicDecrypt;
$5c351a33725583b1$export$7efb24e2fddf99b9 = $2QUb5.privateDecrypt;
var $9a112bcd4fd2a0c5$export$bb1abf2ce84fc7e8;
var $9a112bcd4fd2a0c5$export$2f7171e78e524d5e;

var $kyRHQ = parcelRequire("kyRHQ");

'use strict';
function $9a112bcd4fd2a0c5$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}






var $9a112bcd4fd2a0c5$var$Buffer = $eI8vp.Buffer;
var $9a112bcd4fd2a0c5$var$kBufferMaxLength = $eI8vp.kMaxLength;
var $9a112bcd4fd2a0c5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $9a112bcd4fd2a0c5$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $9a112bcd4fd2a0c5$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $9a112bcd4fd2a0c5$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $9a112bcd4fd2a0c5$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $9a112bcd4fd2a0c5$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $9a112bcd4fd2a0c5$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $9a112bcd4fd2a0c5$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($9a112bcd4fd2a0c5$var$crypto && $9a112bcd4fd2a0c5$var$crypto.getRandomValues || false) {
    $9a112bcd4fd2a0c5$export$bb1abf2ce84fc7e8 = $9a112bcd4fd2a0c5$var$randomFill;
    $9a112bcd4fd2a0c5$export$2f7171e78e524d5e = $9a112bcd4fd2a0c5$var$randomFillSync;
} else {
    $9a112bcd4fd2a0c5$export$bb1abf2ce84fc7e8 = $9a112bcd4fd2a0c5$var$oldBrowser;
    $9a112bcd4fd2a0c5$export$2f7171e78e524d5e = $9a112bcd4fd2a0c5$var$oldBrowser;
}
function $9a112bcd4fd2a0c5$var$randomFill(buf, offset, size, cb) {
    if (!$9a112bcd4fd2a0c5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $9a112bcd4fd2a0c5$var$assertOffset(offset, buf.length);
    $9a112bcd4fd2a0c5$var$assertSize(size, offset, buf.length);
    return $9a112bcd4fd2a0c5$var$actualFill(buf, offset, size, cb);
}
function $9a112bcd4fd2a0c5$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $9a112bcd4fd2a0c5$var$crypto.getRandomValues(uint);
    if (cb) {
        $kyRHQ.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $97jsf(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $97jsf(size);
    bytes.copy(buf, offset);
    return buf;
}
function $9a112bcd4fd2a0c5$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$9a112bcd4fd2a0c5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $9a112bcd4fd2a0c5$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $9a112bcd4fd2a0c5$var$assertSize(size, offset, buf.length);
    return $9a112bcd4fd2a0c5$var$actualFill(buf, offset, size);
}


$5c351a33725583b1$export$bb1abf2ce84fc7e8 = $9a112bcd4fd2a0c5$export$bb1abf2ce84fc7e8;
$5c351a33725583b1$export$2f7171e78e524d5e = $9a112bcd4fd2a0c5$export$2f7171e78e524d5e;
$5c351a33725583b1$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$5c351a33725583b1$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});

parcelRegister("97jsf", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");

'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $6a33dbc2639ad94c$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $6a33dbc2639ad94c$var$MAX_UINT32 = 4294967295;

var $eI8vp = parcelRequire("eI8vp");

var $6a33dbc2639ad94c$require$Buffer = $eI8vp.Buffer;
var $6a33dbc2639ad94c$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
module.exports = function(size, cb) {
    if ($6a33dbc2639ad94c$var$crypto && $6a33dbc2639ad94c$var$crypto.getRandomValues) // browser
    return $6a33dbc2639ad94c$var$randomBytes(size, cb);
    else {
        if (globalThis.crypto && globalThis.crypto.randomBytes) // tesseract runtime
        return globalThis.crypto.randomBytes(size, cb);
        else // tesseract init time
        throw new Error('No randomBytes() support in current environment.');
    }
};
function $6a33dbc2639ad94c$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $6a33dbc2639ad94c$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $6a33dbc2639ad94c$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $6a33dbc2639ad94c$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $6a33dbc2639ad94c$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $6a33dbc2639ad94c$var$crypto.getRandomValues(bytes.slice(generated, generated + $6a33dbc2639ad94c$var$MAX_BYTES));
        else $6a33dbc2639ad94c$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $kyRHQ.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});

parcelRegister("abSTA", function(module, exports) {
'use strict';

var $dMzRp = parcelRequire("dMzRp");


var $DPs2c = parcelRequire("DPs2c");


var $iG9PD = parcelRequire("iG9PD");


var $hyb5G = parcelRequire("hyb5G");


var $3xrS3 = parcelRequire("3xrS3");

function $76b583955fda21cf$var$Hash(hash) {
    $3xrS3.call(this, 'digest');
    this._hash = hash;
}
$dMzRp($76b583955fda21cf$var$Hash, $3xrS3);
$76b583955fda21cf$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$76b583955fda21cf$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $DPs2c();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $iG9PD();
    return new $76b583955fda21cf$var$Hash($hyb5G(alg));
};

});

parcelRegister("dMzRp", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("5rDjV", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $3f6df9957031a214$var$R = typeof Reflect === 'object' ? Reflect : null;
var $3f6df9957031a214$var$ReflectApply = $3f6df9957031a214$var$R && typeof $3f6df9957031a214$var$R.apply === 'function' ? $3f6df9957031a214$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $3f6df9957031a214$var$ReflectOwnKeys;
if ($3f6df9957031a214$var$R && typeof $3f6df9957031a214$var$R.ownKeys === 'function') $3f6df9957031a214$var$ReflectOwnKeys = $3f6df9957031a214$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $3f6df9957031a214$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $3f6df9957031a214$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $3f6df9957031a214$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $3f6df9957031a214$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $3f6df9957031a214$var$EventEmitter() {
    $3f6df9957031a214$var$EventEmitter.init.call(this);
}
module.exports = $3f6df9957031a214$var$EventEmitter;
module.exports.once = $3f6df9957031a214$var$once;
// Backwards-compat with node 0.10.x
$3f6df9957031a214$var$EventEmitter.EventEmitter = $3f6df9957031a214$var$EventEmitter;
$3f6df9957031a214$var$EventEmitter.prototype._events = undefined;
$3f6df9957031a214$var$EventEmitter.prototype._eventsCount = 0;
$3f6df9957031a214$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $3f6df9957031a214$var$defaultMaxListeners = 10;
function $3f6df9957031a214$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($3f6df9957031a214$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $3f6df9957031a214$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $3f6df9957031a214$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $3f6df9957031a214$var$defaultMaxListeners = arg;
    }
});
$3f6df9957031a214$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$3f6df9957031a214$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $3f6df9957031a214$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $3f6df9957031a214$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $3f6df9957031a214$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$3f6df9957031a214$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $3f6df9957031a214$var$_getMaxListeners(this);
};
$3f6df9957031a214$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $3f6df9957031a214$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $3f6df9957031a214$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$3f6df9957031a214$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $3f6df9957031a214$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $3f6df9957031a214$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $3f6df9957031a214$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $3f6df9957031a214$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$3f6df9957031a214$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $3f6df9957031a214$var$_addListener(this, type, listener, false);
};
$3f6df9957031a214$var$EventEmitter.prototype.on = $3f6df9957031a214$var$EventEmitter.prototype.addListener;
$3f6df9957031a214$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $3f6df9957031a214$var$_addListener(this, type, listener, true);
};
function $3f6df9957031a214$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $3f6df9957031a214$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $3f6df9957031a214$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$3f6df9957031a214$var$EventEmitter.prototype.once = function once(type, listener) {
    $3f6df9957031a214$var$checkListener(listener);
    this.on(type, $3f6df9957031a214$var$_onceWrap(this, type, listener));
    return this;
};
$3f6df9957031a214$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $3f6df9957031a214$var$checkListener(listener);
    this.prependListener(type, $3f6df9957031a214$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$3f6df9957031a214$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $3f6df9957031a214$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $3f6df9957031a214$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$3f6df9957031a214$var$EventEmitter.prototype.off = $3f6df9957031a214$var$EventEmitter.prototype.removeListener;
$3f6df9957031a214$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $3f6df9957031a214$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $3f6df9957031a214$var$unwrapListeners(evlistener) : $3f6df9957031a214$var$arrayClone(evlistener, evlistener.length);
}
$3f6df9957031a214$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $3f6df9957031a214$var$_listeners(this, type, true);
};
$3f6df9957031a214$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $3f6df9957031a214$var$_listeners(this, type, false);
};
$3f6df9957031a214$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $3f6df9957031a214$var$listenerCount.call(emitter, type);
};
$3f6df9957031a214$var$EventEmitter.prototype.listenerCount = $3f6df9957031a214$var$listenerCount;
function $3f6df9957031a214$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$3f6df9957031a214$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $3f6df9957031a214$var$ReflectOwnKeys(this._events) : [];
};
function $3f6df9957031a214$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $3f6df9957031a214$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $3f6df9957031a214$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $3f6df9957031a214$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $3f6df9957031a214$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $3f6df9957031a214$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $3f6df9957031a214$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $3f6df9957031a214$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $3f6df9957031a214$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("cjCi4", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $kyRHQ = parcelRequire("kyRHQ");

'use strict';
module.exports = $8f74f616279871c4$var$Readable;
/*<replacement>*/ var $8f74f616279871c4$var$Duplex;
/*</replacement>*/ $8f74f616279871c4$var$Readable.ReadableState = $8f74f616279871c4$var$ReadableState;

var $5rDjV = parcelRequire("5rDjV");

var $8f74f616279871c4$require$EE = $5rDjV.EventEmitter;
var $8f74f616279871c4$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $lD5Li = parcelRequire("lD5Li");


var $iA9co = parcelRequire("iA9co");

var $8f74f616279871c4$require$Buffer = $iA9co.Buffer;
var $8f74f616279871c4$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $8f74f616279871c4$var$_uint8ArrayToBuffer(chunk) {
    return $8f74f616279871c4$require$Buffer.from(chunk);
}
function $8f74f616279871c4$var$_isUint8Array(obj) {
    return $8f74f616279871c4$require$Buffer.isBuffer(obj) || obj instanceof $8f74f616279871c4$var$OurUint8Array;
}

var $h1hUh = parcelRequire("h1hUh");

var $8f74f616279871c4$var$debug;
if ($h1hUh && $h1hUh.debuglog) $8f74f616279871c4$var$debug = $h1hUh.debuglog('stream');
else $8f74f616279871c4$var$debug = function debug() {};
var $8939976a45456a31$exports = {};
'use strict';
function $8939976a45456a31$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8939976a45456a31$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8939976a45456a31$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8939976a45456a31$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8939976a45456a31$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8939976a45456a31$var$_defineProperty(obj, key, value) {
    key = $8939976a45456a31$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8939976a45456a31$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8939976a45456a31$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $8939976a45456a31$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $8939976a45456a31$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8939976a45456a31$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8939976a45456a31$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8939976a45456a31$var$_toPropertyKey(arg) {
    var key = $8939976a45456a31$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $8939976a45456a31$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}



var $8939976a45456a31$var$Buffer = $iA9co.Buffer;



var $8939976a45456a31$var$inspect = $h1hUh.inspect;
var $8939976a45456a31$var$custom = $8939976a45456a31$var$inspect && $8939976a45456a31$var$inspect.custom || 'inspect';
function $8939976a45456a31$var$copyBuffer(src, target, offset) {
    $8939976a45456a31$var$Buffer.prototype.copy.call(src, target, offset);
}
$8939976a45456a31$exports = /*#__PURE__*/ function() {
    function BufferList() {
        $8939976a45456a31$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $8939976a45456a31$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $8939976a45456a31$var$Buffer.alloc(0);
                var ret = $8939976a45456a31$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $8939976a45456a31$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $8939976a45456a31$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $8939976a45456a31$var$custom,
            value: function value(_, options) {
                return $8939976a45456a31$var$inspect(this, $8939976a45456a31$var$_objectSpread($8939976a45456a31$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();



var $8omKJ = parcelRequire("8omKJ");


var $dh1Ip = parcelRequire("dh1Ip");

var $8f74f616279871c4$var$getHighWaterMark = $dh1Ip.getHighWaterMark;

var $7x5Xe = parcelRequire("7x5Xe");

var $8f74f616279871c4$require$_require$codes = $7x5Xe.codes;
var $8f74f616279871c4$var$ERR_INVALID_ARG_TYPE = $8f74f616279871c4$require$_require$codes.ERR_INVALID_ARG_TYPE, $8f74f616279871c4$var$ERR_STREAM_PUSH_AFTER_EOF = $8f74f616279871c4$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $8f74f616279871c4$var$ERR_METHOD_NOT_IMPLEMENTED = $8f74f616279871c4$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8f74f616279871c4$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $8f74f616279871c4$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $8f74f616279871c4$var$StringDecoder;
var $8f74f616279871c4$var$createReadableStreamAsyncIterator;
var $8f74f616279871c4$var$from;

(parcelRequire("dMzRp"))($8f74f616279871c4$var$Readable, $lD5Li);
var $8f74f616279871c4$var$errorOrDestroy = $8omKJ.errorOrDestroy;
var $8f74f616279871c4$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $8f74f616279871c4$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $8f74f616279871c4$var$ReadableState(options, stream, isDuplex) {
    $8f74f616279871c4$var$Duplex = $8f74f616279871c4$var$Duplex || (parcelRequire("1UQ2d"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $8f74f616279871c4$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $8f74f616279871c4$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $8939976a45456a31$exports();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$8f74f616279871c4$var$StringDecoder) $8f74f616279871c4$var$StringDecoder = (parcelRequire("4jSqR")).StringDecoder;
        this.decoder = new $8f74f616279871c4$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $8f74f616279871c4$var$Readable(options) {
    $8f74f616279871c4$var$Duplex = $8f74f616279871c4$var$Duplex || (parcelRequire("1UQ2d"));
    if (!(this instanceof $8f74f616279871c4$var$Readable)) return new $8f74f616279871c4$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $8f74f616279871c4$var$Duplex;
    this._readableState = new $8f74f616279871c4$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $lD5Li.call(this);
}
Object.defineProperty($8f74f616279871c4$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$8f74f616279871c4$var$Readable.prototype.destroy = $8omKJ.destroy;
$8f74f616279871c4$var$Readable.prototype._undestroy = $8omKJ.undestroy;
$8f74f616279871c4$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$8f74f616279871c4$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $8f74f616279871c4$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $8f74f616279871c4$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$8f74f616279871c4$var$Readable.prototype.unshift = function(chunk) {
    return $8f74f616279871c4$var$readableAddChunk(this, chunk, null, true, false);
};
function $8f74f616279871c4$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $8f74f616279871c4$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $8f74f616279871c4$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $8f74f616279871c4$var$chunkInvalid(state, chunk);
        if (er) $8f74f616279871c4$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $8f74f616279871c4$require$Buffer.prototype) chunk = $8f74f616279871c4$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $8f74f616279871c4$var$errorOrDestroy(stream, new $8f74f616279871c4$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $8f74f616279871c4$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $8f74f616279871c4$var$errorOrDestroy(stream, new $8f74f616279871c4$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $8f74f616279871c4$var$addChunk(stream, state, chunk, false);
                    else $8f74f616279871c4$var$maybeReadMore(stream, state);
                } else $8f74f616279871c4$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $8f74f616279871c4$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $8f74f616279871c4$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $8f74f616279871c4$var$emitReadable(stream);
    }
    $8f74f616279871c4$var$maybeReadMore(stream, state);
}
function $8f74f616279871c4$var$chunkInvalid(state, chunk) {
    var er;
    if (!$8f74f616279871c4$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $8f74f616279871c4$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$8f74f616279871c4$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$8f74f616279871c4$var$Readable.prototype.setEncoding = function(enc) {
    if (!$8f74f616279871c4$var$StringDecoder) $8f74f616279871c4$var$StringDecoder = (parcelRequire("4jSqR")).StringDecoder;
    var decoder = new $8f74f616279871c4$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $8f74f616279871c4$var$MAX_HWM = 0x40000000;
function $8f74f616279871c4$var$computeNewHighWaterMark(n) {
    if (n >= $8f74f616279871c4$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $8f74f616279871c4$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8f74f616279871c4$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $8f74f616279871c4$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$8f74f616279871c4$var$Readable.prototype.read = function(n) {
    $8f74f616279871c4$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $8f74f616279871c4$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $8f74f616279871c4$var$endReadable(this);
        else $8f74f616279871c4$var$emitReadable(this);
        return null;
    }
    n = $8f74f616279871c4$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $8f74f616279871c4$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $8f74f616279871c4$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $8f74f616279871c4$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $8f74f616279871c4$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $8f74f616279871c4$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $8f74f616279871c4$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $8f74f616279871c4$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $8f74f616279871c4$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $8f74f616279871c4$var$onEofChunk(stream, state) {
    $8f74f616279871c4$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $8f74f616279871c4$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $8f74f616279871c4$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $8f74f616279871c4$var$emitReadable(stream) {
    var state = stream._readableState;
    $8f74f616279871c4$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $8f74f616279871c4$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $kyRHQ.nextTick($8f74f616279871c4$var$emitReadable_, stream);
    }
}
function $8f74f616279871c4$var$emitReadable_(stream) {
    var state = stream._readableState;
    $8f74f616279871c4$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $8f74f616279871c4$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $8f74f616279871c4$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $kyRHQ.nextTick($8f74f616279871c4$var$maybeReadMore_, stream, state);
    }
}
function $8f74f616279871c4$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $8f74f616279871c4$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$8f74f616279871c4$var$Readable.prototype._read = function(n) {
    $8f74f616279871c4$var$errorOrDestroy(this, new $8f74f616279871c4$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$8f74f616279871c4$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $8f74f616279871c4$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $kyRHQ.stdout && dest !== $kyRHQ.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $kyRHQ.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $8f74f616279871c4$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $8f74f616279871c4$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $8f74f616279871c4$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $8f74f616279871c4$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $8f74f616279871c4$var$debug('ondata');
        var ret = dest.write(chunk);
        $8f74f616279871c4$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $8f74f616279871c4$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $8f74f616279871c4$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $8f74f616279871c4$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($8f74f616279871c4$var$EElistenerCount(dest, 'error') === 0) $8f74f616279871c4$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $8f74f616279871c4$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $8f74f616279871c4$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $8f74f616279871c4$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $8f74f616279871c4$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $8f74f616279871c4$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $8f74f616279871c4$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $8f74f616279871c4$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $8f74f616279871c4$var$flow(src);
        }
    };
}
$8f74f616279871c4$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $8f74f616279871c4$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$8f74f616279871c4$var$Readable.prototype.on = function(ev, fn) {
    var res = $lD5Li.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $8f74f616279871c4$var$debug('on readable', state.length, state.reading);
            if (state.length) $8f74f616279871c4$var$emitReadable(this);
            else if (!state.reading) $kyRHQ.nextTick($8f74f616279871c4$var$nReadingNextTick, this);
        }
    }
    return res;
};
$8f74f616279871c4$var$Readable.prototype.addListener = $8f74f616279871c4$var$Readable.prototype.on;
$8f74f616279871c4$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $lD5Li.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $kyRHQ.nextTick($8f74f616279871c4$var$updateReadableListening, this);
    return res;
};
$8f74f616279871c4$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $lD5Li.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $kyRHQ.nextTick($8f74f616279871c4$var$updateReadableListening, this);
    return res;
};
function $8f74f616279871c4$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $8f74f616279871c4$var$nReadingNextTick(self1) {
    $8f74f616279871c4$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$8f74f616279871c4$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $8f74f616279871c4$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $8f74f616279871c4$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $8f74f616279871c4$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $kyRHQ.nextTick($8f74f616279871c4$var$resume_, stream, state);
    }
}
function $8f74f616279871c4$var$resume_(stream, state) {
    $8f74f616279871c4$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $8f74f616279871c4$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$8f74f616279871c4$var$Readable.prototype.pause = function() {
    $8f74f616279871c4$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $8f74f616279871c4$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $8f74f616279871c4$var$flow(stream) {
    var state = stream._readableState;
    $8f74f616279871c4$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$8f74f616279871c4$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $8f74f616279871c4$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $8f74f616279871c4$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $8f74f616279871c4$var$kProxyEvents.length; n++)stream.on($8f74f616279871c4$var$kProxyEvents[n], this.emit.bind(this, $8f74f616279871c4$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $8f74f616279871c4$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $8f74f616279871c4$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($8f74f616279871c4$var$createReadableStreamAsyncIterator === undefined) $8f74f616279871c4$var$createReadableStreamAsyncIterator = (parcelRequire("3b32q"));
    return $8f74f616279871c4$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($8f74f616279871c4$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($8f74f616279871c4$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($8f74f616279871c4$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$8f74f616279871c4$var$Readable._fromList = $8f74f616279871c4$var$fromList;
Object.defineProperty($8f74f616279871c4$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8f74f616279871c4$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $8f74f616279871c4$var$endReadable(stream) {
    var state = stream._readableState;
    $8f74f616279871c4$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $kyRHQ.nextTick($8f74f616279871c4$var$endReadableNT, state, stream);
    }
}
function $8f74f616279871c4$var$endReadableNT(state, stream) {
    $8f74f616279871c4$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $8f74f616279871c4$var$Readable.from = function(iterable, opts) {
    if ($8f74f616279871c4$var$from === undefined) $8f74f616279871c4$var$from = (parcelRequire("aWjsr"));
    return $8f74f616279871c4$var$from($8f74f616279871c4$var$Readable, iterable, opts);
};
function $8f74f616279871c4$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});

parcelRegister("7x5Xe", function(module, exports) {
$parcel$export(module.exports, "codes", () => $57c03be4ad4cbb04$export$e45cb6485273080e, (v) => $57c03be4ad4cbb04$export$e45cb6485273080e = v);
var $57c03be4ad4cbb04$export$e45cb6485273080e;
'use strict';
function $57c03be4ad4cbb04$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $57c03be4ad4cbb04$var$codes = {};
function $57c03be4ad4cbb04$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $57c03be4ad4cbb04$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $57c03be4ad4cbb04$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $57c03be4ad4cbb04$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $57c03be4ad4cbb04$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $57c03be4ad4cbb04$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $57c03be4ad4cbb04$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$57c03be4ad4cbb04$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$57c03be4ad4cbb04$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $57c03be4ad4cbb04$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($57c03be4ad4cbb04$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($57c03be4ad4cbb04$var$oneOf(expected, 'type'));
    else {
        var type = $57c03be4ad4cbb04$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($57c03be4ad4cbb04$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$57c03be4ad4cbb04$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$57c03be4ad4cbb04$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$57c03be4ad4cbb04$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$57c03be4ad4cbb04$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$57c03be4ad4cbb04$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$57c03be4ad4cbb04$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$57c03be4ad4cbb04$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$57c03be4ad4cbb04$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$57c03be4ad4cbb04$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$57c03be4ad4cbb04$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$57c03be4ad4cbb04$export$e45cb6485273080e = $57c03be4ad4cbb04$var$codes;

});

parcelRegister("1UQ2d", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $kyRHQ = parcelRequire("kyRHQ");

'use strict';
/*<replacement>*/ var $1653626b0b40253c$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $1653626b0b40253c$var$Duplex;

var $cjCi4 = parcelRequire("cjCi4");


var $8cM2j = parcelRequire("8cM2j");


(parcelRequire("dMzRp"))($1653626b0b40253c$var$Duplex, $cjCi4);
// Allow the keys array to be GC'ed.
var $1653626b0b40253c$var$keys = $1653626b0b40253c$var$objectKeys($8cM2j.prototype);
for(var $1653626b0b40253c$var$v = 0; $1653626b0b40253c$var$v < $1653626b0b40253c$var$keys.length; $1653626b0b40253c$var$v++){
    var $1653626b0b40253c$var$method = $1653626b0b40253c$var$keys[$1653626b0b40253c$var$v];
    if (!$1653626b0b40253c$var$Duplex.prototype[$1653626b0b40253c$var$method]) $1653626b0b40253c$var$Duplex.prototype[$1653626b0b40253c$var$method] = $8cM2j.prototype[$1653626b0b40253c$var$method];
}
function $1653626b0b40253c$var$Duplex(options) {
    if (!(this instanceof $1653626b0b40253c$var$Duplex)) return new $1653626b0b40253c$var$Duplex(options);
    $cjCi4.call(this, options);
    $8cM2j.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $1653626b0b40253c$var$onend);
        }
    }
}
Object.defineProperty($1653626b0b40253c$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($1653626b0b40253c$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($1653626b0b40253c$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $1653626b0b40253c$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $kyRHQ.nextTick($1653626b0b40253c$var$onEndNT, this);
}
function $1653626b0b40253c$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($1653626b0b40253c$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});

parcelRegister("8cM2j", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $kyRHQ = parcelRequire("kyRHQ");

'use strict';
module.exports = $5f94b4b59ec4425d$var$Writable;
/* <replacement> */ function $5f94b4b59ec4425d$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5f94b4b59ec4425d$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5f94b4b59ec4425d$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5f94b4b59ec4425d$var$Duplex;
/*</replacement>*/ $5f94b4b59ec4425d$var$Writable.WritableState = $5f94b4b59ec4425d$var$WritableState;

/*<replacement>*/ var $5f94b4b59ec4425d$var$internalUtil = {
    deprecate: (parcelRequire("dv3qK"))
};

var $lD5Li = parcelRequire("lD5Li");


var $iA9co = parcelRequire("iA9co");

var $5f94b4b59ec4425d$require$Buffer = $iA9co.Buffer;
var $5f94b4b59ec4425d$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $5f94b4b59ec4425d$var$_uint8ArrayToBuffer(chunk) {
    return $5f94b4b59ec4425d$require$Buffer.from(chunk);
}
function $5f94b4b59ec4425d$var$_isUint8Array(obj) {
    return $5f94b4b59ec4425d$require$Buffer.isBuffer(obj) || obj instanceof $5f94b4b59ec4425d$var$OurUint8Array;
}

var $8omKJ = parcelRequire("8omKJ");


var $dh1Ip = parcelRequire("dh1Ip");

var $5f94b4b59ec4425d$var$getHighWaterMark = $dh1Ip.getHighWaterMark;

var $7x5Xe = parcelRequire("7x5Xe");

var $5f94b4b59ec4425d$require$_require$codes = $7x5Xe.codes;
var $5f94b4b59ec4425d$var$ERR_INVALID_ARG_TYPE = $5f94b4b59ec4425d$require$_require$codes.ERR_INVALID_ARG_TYPE, $5f94b4b59ec4425d$var$ERR_METHOD_NOT_IMPLEMENTED = $5f94b4b59ec4425d$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5f94b4b59ec4425d$var$ERR_MULTIPLE_CALLBACK = $5f94b4b59ec4425d$require$_require$codes.ERR_MULTIPLE_CALLBACK, $5f94b4b59ec4425d$var$ERR_STREAM_CANNOT_PIPE = $5f94b4b59ec4425d$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $5f94b4b59ec4425d$var$ERR_STREAM_DESTROYED = $5f94b4b59ec4425d$require$_require$codes.ERR_STREAM_DESTROYED, $5f94b4b59ec4425d$var$ERR_STREAM_NULL_VALUES = $5f94b4b59ec4425d$require$_require$codes.ERR_STREAM_NULL_VALUES, $5f94b4b59ec4425d$var$ERR_STREAM_WRITE_AFTER_END = $5f94b4b59ec4425d$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $5f94b4b59ec4425d$var$ERR_UNKNOWN_ENCODING = $5f94b4b59ec4425d$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $5f94b4b59ec4425d$var$errorOrDestroy = $8omKJ.errorOrDestroy;

(parcelRequire("dMzRp"))($5f94b4b59ec4425d$var$Writable, $lD5Li);
function $5f94b4b59ec4425d$var$nop() {}

function $5f94b4b59ec4425d$var$WritableState(options, stream, isDuplex) {
    $5f94b4b59ec4425d$var$Duplex = $5f94b4b59ec4425d$var$Duplex || (parcelRequire("1UQ2d"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $5f94b4b59ec4425d$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $5f94b4b59ec4425d$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5f94b4b59ec4425d$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5f94b4b59ec4425d$var$CorkedRequest(this);
}
$5f94b4b59ec4425d$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5f94b4b59ec4425d$var$WritableState.prototype, 'buffer', {
            get: $5f94b4b59ec4425d$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5f94b4b59ec4425d$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $5f94b4b59ec4425d$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5f94b4b59ec4425d$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($5f94b4b59ec4425d$var$realHasInstance.call(this, object)) return true;
            if (this !== $5f94b4b59ec4425d$var$Writable) return false;
            return object && object._writableState instanceof $5f94b4b59ec4425d$var$WritableState;
        }
    });
} else $5f94b4b59ec4425d$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $5f94b4b59ec4425d$var$Writable(options) {
    $5f94b4b59ec4425d$var$Duplex = $5f94b4b59ec4425d$var$Duplex || (parcelRequire("1UQ2d"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $5f94b4b59ec4425d$var$Duplex;
    if (!isDuplex && !$5f94b4b59ec4425d$var$realHasInstance.call($5f94b4b59ec4425d$var$Writable, this)) return new $5f94b4b59ec4425d$var$Writable(options);
    this._writableState = new $5f94b4b59ec4425d$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $lD5Li.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$5f94b4b59ec4425d$var$Writable.prototype.pipe = function() {
    $5f94b4b59ec4425d$var$errorOrDestroy(this, new $5f94b4b59ec4425d$var$ERR_STREAM_CANNOT_PIPE());
};
function $5f94b4b59ec4425d$var$writeAfterEnd(stream, cb) {
    var er = new $5f94b4b59ec4425d$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $5f94b4b59ec4425d$var$errorOrDestroy(stream, er);
    $kyRHQ.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5f94b4b59ec4425d$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $5f94b4b59ec4425d$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $5f94b4b59ec4425d$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $5f94b4b59ec4425d$var$errorOrDestroy(stream, er);
        $kyRHQ.nextTick(cb, er);
        return false;
    }
    return true;
}
$5f94b4b59ec4425d$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5f94b4b59ec4425d$var$_isUint8Array(chunk);
    if (isBuf && !$5f94b4b59ec4425d$require$Buffer.isBuffer(chunk)) chunk = $5f94b4b59ec4425d$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $5f94b4b59ec4425d$var$nop;
    if (state.ending) $5f94b4b59ec4425d$var$writeAfterEnd(this, cb);
    else if (isBuf || $5f94b4b59ec4425d$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5f94b4b59ec4425d$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5f94b4b59ec4425d$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$5f94b4b59ec4425d$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5f94b4b59ec4425d$var$clearBuffer(this, state);
    }
};
$5f94b4b59ec4425d$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $5f94b4b59ec4425d$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($5f94b4b59ec4425d$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $5f94b4b59ec4425d$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $5f94b4b59ec4425d$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5f94b4b59ec4425d$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5f94b4b59ec4425d$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5f94b4b59ec4425d$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5f94b4b59ec4425d$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5f94b4b59ec4425d$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $5f94b4b59ec4425d$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5f94b4b59ec4425d$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $kyRHQ.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $kyRHQ.nextTick($5f94b4b59ec4425d$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $5f94b4b59ec4425d$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $5f94b4b59ec4425d$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $5f94b4b59ec4425d$var$finishMaybe(stream, state);
    }
}
function $5f94b4b59ec4425d$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5f94b4b59ec4425d$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $5f94b4b59ec4425d$var$ERR_MULTIPLE_CALLBACK();
    $5f94b4b59ec4425d$var$onwriteStateUpdate(state);
    if (er) $5f94b4b59ec4425d$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5f94b4b59ec4425d$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5f94b4b59ec4425d$var$clearBuffer(stream, state);
        if (sync) $kyRHQ.nextTick($5f94b4b59ec4425d$var$afterWrite, stream, state, finished, cb);
        else $5f94b4b59ec4425d$var$afterWrite(stream, state, finished, cb);
    }
}
function $5f94b4b59ec4425d$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5f94b4b59ec4425d$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5f94b4b59ec4425d$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5f94b4b59ec4425d$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $5f94b4b59ec4425d$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5f94b4b59ec4425d$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5f94b4b59ec4425d$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5f94b4b59ec4425d$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5f94b4b59ec4425d$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $5f94b4b59ec4425d$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$5f94b4b59ec4425d$var$Writable.prototype._writev = null;
$5f94b4b59ec4425d$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $5f94b4b59ec4425d$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($5f94b4b59ec4425d$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $5f94b4b59ec4425d$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5f94b4b59ec4425d$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $5f94b4b59ec4425d$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $5f94b4b59ec4425d$var$finishMaybe(stream, state);
    });
}
function $5f94b4b59ec4425d$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $kyRHQ.nextTick($5f94b4b59ec4425d$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $5f94b4b59ec4425d$var$finishMaybe(stream, state) {
    var need = $5f94b4b59ec4425d$var$needFinish(state);
    if (need) {
        $5f94b4b59ec4425d$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $5f94b4b59ec4425d$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5f94b4b59ec4425d$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $kyRHQ.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5f94b4b59ec4425d$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($5f94b4b59ec4425d$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5f94b4b59ec4425d$var$Writable.prototype.destroy = $8omKJ.destroy;
$5f94b4b59ec4425d$var$Writable.prototype._undestroy = $8omKJ.undestroy;
$5f94b4b59ec4425d$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});

parcelRegister("dv3qK", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $9d40d4d400d1cb0b$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $9d40d4d400d1cb0b$var$deprecate(fn, msg) {
    if ($9d40d4d400d1cb0b$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($9d40d4d400d1cb0b$var$config('throwDeprecation')) throw new Error(msg);
            else if ($9d40d4d400d1cb0b$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $9d40d4d400d1cb0b$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});

parcelRegister("4jSqR", function(module, exports) {
$parcel$export(module.exports, "StringDecoder", () => $325328e44d85bf6a$export$63a7aa211a91ed69, (v) => $325328e44d85bf6a$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $325328e44d85bf6a$export$63a7aa211a91ed69;
'use strict';

var $eI8vp = parcelRequire("eI8vp");

var $325328e44d85bf6a$require$Buffer = $eI8vp.Buffer;
/*</replacement>*/ var $325328e44d85bf6a$var$isEncoding = $325328e44d85bf6a$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $325328e44d85bf6a$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $325328e44d85bf6a$var$normalizeEncoding(enc) {
    var nenc = $325328e44d85bf6a$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($325328e44d85bf6a$require$Buffer.isEncoding === $325328e44d85bf6a$var$isEncoding || !$325328e44d85bf6a$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$325328e44d85bf6a$export$63a7aa211a91ed69 = $325328e44d85bf6a$var$StringDecoder;
function $325328e44d85bf6a$var$StringDecoder(encoding) {
    this.encoding = $325328e44d85bf6a$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $325328e44d85bf6a$var$utf16Text;
            this.end = $325328e44d85bf6a$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $325328e44d85bf6a$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $325328e44d85bf6a$var$base64Text;
            this.end = $325328e44d85bf6a$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $325328e44d85bf6a$var$simpleWrite;
            this.end = $325328e44d85bf6a$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $325328e44d85bf6a$require$Buffer.allocUnsafe(nb);
}
$325328e44d85bf6a$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$325328e44d85bf6a$var$StringDecoder.prototype.end = $325328e44d85bf6a$var$utf8End;
// Returns only complete characters in a Buffer
$325328e44d85bf6a$var$StringDecoder.prototype.text = $325328e44d85bf6a$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$325328e44d85bf6a$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $325328e44d85bf6a$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $325328e44d85bf6a$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $325328e44d85bf6a$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $325328e44d85bf6a$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $325328e44d85bf6a$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $325328e44d85bf6a$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $325328e44d85bf6a$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $325328e44d85bf6a$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $325328e44d85bf6a$var$utf8Text(buf, i) {
    var total = $325328e44d85bf6a$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $325328e44d85bf6a$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $325328e44d85bf6a$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $325328e44d85bf6a$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $325328e44d85bf6a$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $325328e44d85bf6a$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $325328e44d85bf6a$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $325328e44d85bf6a$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("3b32q", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");

'use strict';
var $2504c17664bb4bb0$var$_Object$setPrototypeO;
function $2504c17664bb4bb0$var$_defineProperty(obj, key, value) {
    key = $2504c17664bb4bb0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2504c17664bb4bb0$var$_toPropertyKey(arg) {
    var key = $2504c17664bb4bb0$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2504c17664bb4bb0$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $ehL28 = parcelRequire("ehL28");

var $2504c17664bb4bb0$var$kLastResolve = Symbol('lastResolve');
var $2504c17664bb4bb0$var$kLastReject = Symbol('lastReject');
var $2504c17664bb4bb0$var$kError = Symbol('error');
var $2504c17664bb4bb0$var$kEnded = Symbol('ended');
var $2504c17664bb4bb0$var$kLastPromise = Symbol('lastPromise');
var $2504c17664bb4bb0$var$kHandlePromise = Symbol('handlePromise');
var $2504c17664bb4bb0$var$kStream = Symbol('stream');
function $2504c17664bb4bb0$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $2504c17664bb4bb0$var$readAndResolve(iter) {
    var resolve = iter[$2504c17664bb4bb0$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$2504c17664bb4bb0$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$2504c17664bb4bb0$var$kLastPromise] = null;
            iter[$2504c17664bb4bb0$var$kLastResolve] = null;
            iter[$2504c17664bb4bb0$var$kLastReject] = null;
            resolve($2504c17664bb4bb0$var$createIterResult(data, false));
        }
    }
}
function $2504c17664bb4bb0$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $kyRHQ.nextTick($2504c17664bb4bb0$var$readAndResolve, iter);
}
function $2504c17664bb4bb0$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$2504c17664bb4bb0$var$kEnded]) {
                resolve($2504c17664bb4bb0$var$createIterResult(undefined, true));
                return;
            }
            iter[$2504c17664bb4bb0$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $2504c17664bb4bb0$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $2504c17664bb4bb0$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($2504c17664bb4bb0$var$_Object$setPrototypeO = {
    get stream () {
        return this[$2504c17664bb4bb0$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$2504c17664bb4bb0$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$2504c17664bb4bb0$var$kEnded]) return Promise.resolve($2504c17664bb4bb0$var$createIterResult(undefined, true));
        if (this[$2504c17664bb4bb0$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $kyRHQ.nextTick(function() {
                if (_this[$2504c17664bb4bb0$var$kError]) reject(_this[$2504c17664bb4bb0$var$kError]);
                else resolve($2504c17664bb4bb0$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$2504c17664bb4bb0$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($2504c17664bb4bb0$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$2504c17664bb4bb0$var$kStream].read();
            if (data !== null) return Promise.resolve($2504c17664bb4bb0$var$createIterResult(data, false));
            promise = new Promise(this[$2504c17664bb4bb0$var$kHandlePromise]);
        }
        this[$2504c17664bb4bb0$var$kLastPromise] = promise;
        return promise;
    }
}, $2504c17664bb4bb0$var$_defineProperty($2504c17664bb4bb0$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $2504c17664bb4bb0$var$_defineProperty($2504c17664bb4bb0$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$2504c17664bb4bb0$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($2504c17664bb4bb0$var$createIterResult(undefined, true));
        });
    });
}), $2504c17664bb4bb0$var$_Object$setPrototypeO), $2504c17664bb4bb0$var$AsyncIteratorPrototype);
var $2504c17664bb4bb0$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($2504c17664bb4bb0$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $2504c17664bb4bb0$var$_defineProperty(_Object$create, $2504c17664bb4bb0$var$kStream, {
        value: stream,
        writable: true
    }), $2504c17664bb4bb0$var$_defineProperty(_Object$create, $2504c17664bb4bb0$var$kLastResolve, {
        value: null,
        writable: true
    }), $2504c17664bb4bb0$var$_defineProperty(_Object$create, $2504c17664bb4bb0$var$kLastReject, {
        value: null,
        writable: true
    }), $2504c17664bb4bb0$var$_defineProperty(_Object$create, $2504c17664bb4bb0$var$kError, {
        value: null,
        writable: true
    }), $2504c17664bb4bb0$var$_defineProperty(_Object$create, $2504c17664bb4bb0$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $2504c17664bb4bb0$var$_defineProperty(_Object$create, $2504c17664bb4bb0$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$2504c17664bb4bb0$var$kStream].read();
            if (data) {
                iterator[$2504c17664bb4bb0$var$kLastPromise] = null;
                iterator[$2504c17664bb4bb0$var$kLastResolve] = null;
                iterator[$2504c17664bb4bb0$var$kLastReject] = null;
                resolve($2504c17664bb4bb0$var$createIterResult(data, false));
            } else {
                iterator[$2504c17664bb4bb0$var$kLastResolve] = resolve;
                iterator[$2504c17664bb4bb0$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$2504c17664bb4bb0$var$kLastPromise] = null;
    $ehL28(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$2504c17664bb4bb0$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$2504c17664bb4bb0$var$kLastPromise] = null;
                iterator[$2504c17664bb4bb0$var$kLastResolve] = null;
                iterator[$2504c17664bb4bb0$var$kLastReject] = null;
                reject(err);
            }
            iterator[$2504c17664bb4bb0$var$kError] = err;
            return;
        }
        var resolve = iterator[$2504c17664bb4bb0$var$kLastResolve];
        if (resolve !== null) {
            iterator[$2504c17664bb4bb0$var$kLastPromise] = null;
            iterator[$2504c17664bb4bb0$var$kLastResolve] = null;
            iterator[$2504c17664bb4bb0$var$kLastReject] = null;
            resolve($2504c17664bb4bb0$var$createIterResult(undefined, true));
        }
        iterator[$2504c17664bb4bb0$var$kEnded] = true;
    });
    stream.on('readable', $2504c17664bb4bb0$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $2504c17664bb4bb0$var$createReadableStreamAsyncIterator;

});

parcelRegister("ehL28", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $a667230eca5f4a5c$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("7x5Xe")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $a667230eca5f4a5c$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $a667230eca5f4a5c$var$noop() {}
function $a667230eca5f4a5c$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $a667230eca5f4a5c$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $a667230eca5f4a5c$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $a667230eca5f4a5c$var$once(callback || $a667230eca5f4a5c$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $a667230eca5f4a5c$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $a667230eca5f4a5c$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($a667230eca5f4a5c$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $a667230eca5f4a5c$var$eos;

});

parcelRegister("aWjsr", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});

parcelRegister("9kubK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $6cad661afe29683d$var$Transform;

var $7x5Xe = parcelRequire("7x5Xe");

var $6cad661afe29683d$require$_require$codes = $7x5Xe.codes;
var $6cad661afe29683d$var$ERR_METHOD_NOT_IMPLEMENTED = $6cad661afe29683d$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $6cad661afe29683d$var$ERR_MULTIPLE_CALLBACK = $6cad661afe29683d$require$_require$codes.ERR_MULTIPLE_CALLBACK, $6cad661afe29683d$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $6cad661afe29683d$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $6cad661afe29683d$var$ERR_TRANSFORM_WITH_LENGTH_0 = $6cad661afe29683d$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $1UQ2d = parcelRequire("1UQ2d");


(parcelRequire("dMzRp"))($6cad661afe29683d$var$Transform, $1UQ2d);
function $6cad661afe29683d$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $6cad661afe29683d$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $6cad661afe29683d$var$Transform(options) {
    if (!(this instanceof $6cad661afe29683d$var$Transform)) return new $6cad661afe29683d$var$Transform(options);
    $1UQ2d.call(this, options);
    this._transformState = {
        afterTransform: $6cad661afe29683d$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $6cad661afe29683d$var$prefinish);
}
function $6cad661afe29683d$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $6cad661afe29683d$var$done(_this, er, data);
    });
    else $6cad661afe29683d$var$done(this, null, null);
}
$6cad661afe29683d$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $1UQ2d.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$6cad661afe29683d$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $6cad661afe29683d$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$6cad661afe29683d$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$6cad661afe29683d$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$6cad661afe29683d$var$Transform.prototype._destroy = function(err, cb) {
    $1UQ2d.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $6cad661afe29683d$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $6cad661afe29683d$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $6cad661afe29683d$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("kSdiX", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $f3232bde0659fd7a$var$PassThrough;

var $9kubK = parcelRequire("9kubK");


(parcelRequire("dMzRp"))($f3232bde0659fd7a$var$PassThrough, $9kubK);
function $f3232bde0659fd7a$var$PassThrough(options) {
    if (!(this instanceof $f3232bde0659fd7a$var$PassThrough)) return new $f3232bde0659fd7a$var$PassThrough(options);
    $9kubK.call(this, options);
}
$f3232bde0659fd7a$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("3DNUy", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $2a6bbaea4c223864$var$eos;
function $2a6bbaea4c223864$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $7x5Xe = parcelRequire("7x5Xe");

var $2a6bbaea4c223864$require$_require$codes = $7x5Xe.codes;
var $2a6bbaea4c223864$var$ERR_MISSING_ARGS = $2a6bbaea4c223864$require$_require$codes.ERR_MISSING_ARGS, $2a6bbaea4c223864$var$ERR_STREAM_DESTROYED = $2a6bbaea4c223864$require$_require$codes.ERR_STREAM_DESTROYED;
function $2a6bbaea4c223864$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $2a6bbaea4c223864$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $2a6bbaea4c223864$var$destroyer(stream, reading, writing, callback) {
    callback = $2a6bbaea4c223864$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($2a6bbaea4c223864$var$eos === undefined) $2a6bbaea4c223864$var$eos = (parcelRequire("ehL28"));
    $2a6bbaea4c223864$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($2a6bbaea4c223864$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $2a6bbaea4c223864$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $2a6bbaea4c223864$var$call(fn) {
    fn();
}
function $2a6bbaea4c223864$var$pipe(from, to) {
    return from.pipe(to);
}
function $2a6bbaea4c223864$var$popCallback(streams) {
    if (!streams.length) return $2a6bbaea4c223864$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $2a6bbaea4c223864$var$noop;
    return streams.pop();
}
function $2a6bbaea4c223864$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $2a6bbaea4c223864$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $2a6bbaea4c223864$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $2a6bbaea4c223864$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($2a6bbaea4c223864$var$call);
            if (reading) return;
            destroys.forEach($2a6bbaea4c223864$var$call);
            callback(error);
        });
    });
    return streams.reduce($2a6bbaea4c223864$var$pipe);
}
module.exports = $2a6bbaea4c223864$var$pipeline;

});

parcelRegister("ceK8O", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $dMzRp = parcelRequire("dMzRp");


var $2fUgV = parcelRequire("2fUgV");


var $eI8vp = parcelRequire("eI8vp");

var $8e8a9581a75a44d1$require$Buffer = $eI8vp.Buffer;
var $8e8a9581a75a44d1$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $8e8a9581a75a44d1$var$W = new Array(80);
function $8e8a9581a75a44d1$var$Sha() {
    this.init();
    this._w = $8e8a9581a75a44d1$var$W;
    $2fUgV.call(this, 64, 56);
}
$dMzRp($8e8a9581a75a44d1$var$Sha, $2fUgV);
$8e8a9581a75a44d1$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $8e8a9581a75a44d1$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $8e8a9581a75a44d1$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $8e8a9581a75a44d1$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$8e8a9581a75a44d1$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $8e8a9581a75a44d1$var$rotl5(a) + $8e8a9581a75a44d1$var$ft(s, b, c, d) + e + W[j] + $8e8a9581a75a44d1$var$K[s] | 0;
        e = d;
        d = c;
        c = $8e8a9581a75a44d1$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$8e8a9581a75a44d1$var$Sha.prototype._hash = function() {
    var H = $8e8a9581a75a44d1$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $8e8a9581a75a44d1$var$Sha;

});

parcelRegister("1MHz3", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $dMzRp = parcelRequire("dMzRp");


var $2fUgV = parcelRequire("2fUgV");


var $eI8vp = parcelRequire("eI8vp");

var $14cc111c0e73520d$require$Buffer = $eI8vp.Buffer;
var $14cc111c0e73520d$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $14cc111c0e73520d$var$W = new Array(80);
function $14cc111c0e73520d$var$Sha1() {
    this.init();
    this._w = $14cc111c0e73520d$var$W;
    $2fUgV.call(this, 64, 56);
}
$dMzRp($14cc111c0e73520d$var$Sha1, $2fUgV);
$14cc111c0e73520d$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $14cc111c0e73520d$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $14cc111c0e73520d$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $14cc111c0e73520d$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $14cc111c0e73520d$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$14cc111c0e73520d$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $14cc111c0e73520d$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $14cc111c0e73520d$var$rotl5(a) + $14cc111c0e73520d$var$ft(s, b, c, d) + e + W[j] + $14cc111c0e73520d$var$K[s] | 0;
        e = d;
        d = c;
        c = $14cc111c0e73520d$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$14cc111c0e73520d$var$Sha1.prototype._hash = function() {
    var H = $14cc111c0e73520d$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $14cc111c0e73520d$var$Sha1;

});

parcelRegister("1p5m5", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dMzRp = parcelRequire("dMzRp");


var $4fDtH = parcelRequire("4fDtH");


var $2fUgV = parcelRequire("2fUgV");


var $eI8vp = parcelRequire("eI8vp");

var $105c47ad5696a8c7$require$Buffer = $eI8vp.Buffer;
var $105c47ad5696a8c7$var$W = new Array(64);
function $105c47ad5696a8c7$var$Sha224() {
    this.init();
    this._w = $105c47ad5696a8c7$var$W // new Array(64)
    ;
    $2fUgV.call(this, 64, 56);
}
$dMzRp($105c47ad5696a8c7$var$Sha224, $4fDtH);
$105c47ad5696a8c7$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$105c47ad5696a8c7$var$Sha224.prototype._hash = function() {
    var H = $105c47ad5696a8c7$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $105c47ad5696a8c7$var$Sha224;

});

parcelRegister("4fDtH", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dMzRp = parcelRequire("dMzRp");


var $2fUgV = parcelRequire("2fUgV");


var $eI8vp = parcelRequire("eI8vp");

var $31872fac0a7db9d7$require$Buffer = $eI8vp.Buffer;
var $31872fac0a7db9d7$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $31872fac0a7db9d7$var$W = new Array(64);
function $31872fac0a7db9d7$var$Sha256() {
    this.init();
    this._w = $31872fac0a7db9d7$var$W // new Array(64)
    ;
    $2fUgV.call(this, 64, 56);
}
$dMzRp($31872fac0a7db9d7$var$Sha256, $2fUgV);
$31872fac0a7db9d7$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $31872fac0a7db9d7$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $31872fac0a7db9d7$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $31872fac0a7db9d7$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $31872fac0a7db9d7$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $31872fac0a7db9d7$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $31872fac0a7db9d7$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$31872fac0a7db9d7$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $31872fac0a7db9d7$var$gamma1(W[i - 2]) + W[i - 7] + $31872fac0a7db9d7$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $31872fac0a7db9d7$var$sigma1(e) + $31872fac0a7db9d7$var$ch(e, f, g) + $31872fac0a7db9d7$var$K[j] + W[j] | 0;
        var T2 = $31872fac0a7db9d7$var$sigma0(a) + $31872fac0a7db9d7$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$31872fac0a7db9d7$var$Sha256.prototype._hash = function() {
    var H = $31872fac0a7db9d7$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $31872fac0a7db9d7$var$Sha256;

});

parcelRegister("662NC", function(module, exports) {

var $dMzRp = parcelRequire("dMzRp");


var $7rB3k = parcelRequire("7rB3k");


var $2fUgV = parcelRequire("2fUgV");


var $eI8vp = parcelRequire("eI8vp");

var $470579832f07eff4$require$Buffer = $eI8vp.Buffer;
var $470579832f07eff4$var$W = new Array(160);
function $470579832f07eff4$var$Sha384() {
    this.init();
    this._w = $470579832f07eff4$var$W;
    $2fUgV.call(this, 128, 112);
}
$dMzRp($470579832f07eff4$var$Sha384, $7rB3k);
$470579832f07eff4$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$470579832f07eff4$var$Sha384.prototype._hash = function() {
    var H = $470579832f07eff4$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $470579832f07eff4$var$Sha384;

});

parcelRegister("7rB3k", function(module, exports) {

var $dMzRp = parcelRequire("dMzRp");


var $2fUgV = parcelRequire("2fUgV");


var $eI8vp = parcelRequire("eI8vp");

var $56b7cbef982be87f$require$Buffer = $eI8vp.Buffer;
var $56b7cbef982be87f$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $56b7cbef982be87f$var$W = new Array(160);
function $56b7cbef982be87f$var$Sha512() {
    this.init();
    this._w = $56b7cbef982be87f$var$W;
    $2fUgV.call(this, 128, 112);
}
$dMzRp($56b7cbef982be87f$var$Sha512, $2fUgV);
$56b7cbef982be87f$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $56b7cbef982be87f$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $56b7cbef982be87f$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $56b7cbef982be87f$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $56b7cbef982be87f$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $56b7cbef982be87f$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $56b7cbef982be87f$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $56b7cbef982be87f$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $56b7cbef982be87f$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $56b7cbef982be87f$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$56b7cbef982be87f$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $56b7cbef982be87f$var$Gamma0(xh, xl);
        var gamma0l = $56b7cbef982be87f$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $56b7cbef982be87f$var$Gamma1(xh, xl);
        var gamma1l = $56b7cbef982be87f$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $56b7cbef982be87f$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $56b7cbef982be87f$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $56b7cbef982be87f$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $56b7cbef982be87f$var$maj(ah, bh, ch);
        var majl = $56b7cbef982be87f$var$maj(al, bl, cl);
        var sigma0h = $56b7cbef982be87f$var$sigma0(ah, al);
        var sigma0l = $56b7cbef982be87f$var$sigma0(al, ah);
        var sigma1h = $56b7cbef982be87f$var$sigma1(eh, el);
        var sigma1l = $56b7cbef982be87f$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $56b7cbef982be87f$var$K[j];
        var Kil = $56b7cbef982be87f$var$K[j + 1];
        var chh = $56b7cbef982be87f$var$Ch(eh, fh, gh);
        var chl = $56b7cbef982be87f$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $56b7cbef982be87f$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $56b7cbef982be87f$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $56b7cbef982be87f$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $56b7cbef982be87f$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $56b7cbef982be87f$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $56b7cbef982be87f$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $56b7cbef982be87f$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $56b7cbef982be87f$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $56b7cbef982be87f$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $56b7cbef982be87f$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $56b7cbef982be87f$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $56b7cbef982be87f$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $56b7cbef982be87f$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $56b7cbef982be87f$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $56b7cbef982be87f$var$getCarry(this._hl, hl) | 0;
};
$56b7cbef982be87f$var$Sha512.prototype._hash = function() {
    var H = $56b7cbef982be87f$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $56b7cbef982be87f$var$Sha512;

});

parcelRegister("b1JBa", function(module, exports) {
'use strict';

var $dMzRp = parcelRequire("dMzRp");

var $0ebf4eaa63dd488e$exports = {};
'use strict';




var $eI8vp = parcelRequire("eI8vp");

var $0ebf4eaa63dd488e$require$Buffer = $eI8vp.Buffer;

var $3xrS3 = parcelRequire("3xrS3");

var $0ebf4eaa63dd488e$var$ZEROS = $0ebf4eaa63dd488e$require$Buffer.alloc(128);
var $0ebf4eaa63dd488e$var$blocksize = 64;
function $0ebf4eaa63dd488e$var$Hmac(alg, key) {
    $3xrS3.call(this, 'digest');
    if (typeof key === 'string') key = $0ebf4eaa63dd488e$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $0ebf4eaa63dd488e$var$blocksize) key = alg(key);
    else if (key.length < $0ebf4eaa63dd488e$var$blocksize) key = $0ebf4eaa63dd488e$require$Buffer.concat([
        key,
        $0ebf4eaa63dd488e$var$ZEROS
    ], $0ebf4eaa63dd488e$var$blocksize);
    var ipad = this._ipad = $0ebf4eaa63dd488e$require$Buffer.allocUnsafe($0ebf4eaa63dd488e$var$blocksize);
    var opad = this._opad = $0ebf4eaa63dd488e$require$Buffer.allocUnsafe($0ebf4eaa63dd488e$var$blocksize);
    for(var i = 0; i < $0ebf4eaa63dd488e$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dMzRp($0ebf4eaa63dd488e$var$Hmac, $3xrS3);
$0ebf4eaa63dd488e$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$0ebf4eaa63dd488e$var$Hmac.prototype._final = function() {
    var h = this._alg($0ebf4eaa63dd488e$require$Buffer.concat(this._hash));
    return this._alg($0ebf4eaa63dd488e$require$Buffer.concat([
        this._opad,
        h
    ]));
};
$0ebf4eaa63dd488e$exports = $0ebf4eaa63dd488e$var$Hmac;








var $80732898d50a404b$require$Buffer = $eI8vp.Buffer;
var $cc52a76734c22d99$exports = {};

var $DPs2c = parcelRequire("DPs2c");

$cc52a76734c22d99$exports = function(buffer) {
    return new $DPs2c().update(buffer).digest();
};



var $iG9PD = parcelRequire("iG9PD");


var $hyb5G = parcelRequire("hyb5G");

var $80732898d50a404b$var$ZEROS = $80732898d50a404b$require$Buffer.alloc(128);
function $80732898d50a404b$var$Hmac(alg, key) {
    $3xrS3.call(this, 'digest');
    if (typeof key === 'string') key = $80732898d50a404b$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $iG9PD() : $hyb5G(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $80732898d50a404b$require$Buffer.concat([
        key,
        $80732898d50a404b$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $80732898d50a404b$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $80732898d50a404b$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $iG9PD() : $hyb5G(alg);
    this._hash.update(ipad);
}
$dMzRp($80732898d50a404b$var$Hmac, $3xrS3);
$80732898d50a404b$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$80732898d50a404b$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $iG9PD() : $hyb5G(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $80732898d50a404b$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $0ebf4eaa63dd488e$exports($cc52a76734c22d99$exports, key);
    return new $80732898d50a404b$var$Hmac(alg, key);
};

});

parcelRegister("0izgv", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});

parcelRegister("7rIrX", function(module, exports) {
'use strict';

var $eI8vp = parcelRequire("eI8vp");

var $56bd88df2a8b1b69$require$Buffer = $eI8vp.Buffer;

var $8THs5 = parcelRequire("8THs5");


var $jmQ5f = parcelRequire("jmQ5f");


var $kZS47 = parcelRequire("kZS47");


var $9Jtnp = parcelRequire("9Jtnp");

var $56bd88df2a8b1b69$var$ZERO_BUF;
var $56bd88df2a8b1b69$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $56bd88df2a8b1b69$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $56bd88df2a8b1b69$var$checks = [];
var $56bd88df2a8b1b69$var$nextTick;
function $56bd88df2a8b1b69$var$getNextTick() {
    if ($56bd88df2a8b1b69$var$nextTick) return $56bd88df2a8b1b69$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $56bd88df2a8b1b69$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $56bd88df2a8b1b69$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $56bd88df2a8b1b69$var$nextTick = $parcel$global.setImmediate;
    else $56bd88df2a8b1b69$var$nextTick = $parcel$global.setTimeout;
    return $56bd88df2a8b1b69$var$nextTick;
}
function $56bd88df2a8b1b69$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $56bd88df2a8b1b69$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $56bd88df2a8b1b69$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $56bd88df2a8b1b69$require$Buffer.from(res);
    });
}
function $56bd88df2a8b1b69$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$56bd88df2a8b1b69$var$subtle || !$56bd88df2a8b1b69$var$subtle.importKey || !$56bd88df2a8b1b69$var$subtle.deriveBits) return Promise.resolve(false);
    if ($56bd88df2a8b1b69$var$checks[algo] !== undefined) return $56bd88df2a8b1b69$var$checks[algo];
    $56bd88df2a8b1b69$var$ZERO_BUF = $56bd88df2a8b1b69$var$ZERO_BUF || $56bd88df2a8b1b69$require$Buffer.alloc(8);
    var prom = $56bd88df2a8b1b69$var$browserPbkdf2($56bd88df2a8b1b69$var$ZERO_BUF, $56bd88df2a8b1b69$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $56bd88df2a8b1b69$var$checks[algo] = prom;
    return prom;
}
function $56bd88df2a8b1b69$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $56bd88df2a8b1b69$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $56bd88df2a8b1b69$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    digest = digest || 'sha1';
    var algo = $56bd88df2a8b1b69$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $56bd88df2a8b1b69$var$getNextTick()(function() {
            var out;
            try {
                out = $kZS47(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $8THs5(iterations, keylen);
    password = $9Jtnp(password, $jmQ5f, 'Password');
    salt = $9Jtnp(salt, $jmQ5f, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    $56bd88df2a8b1b69$var$resolvePromise($56bd88df2a8b1b69$var$checkNative(algo).then(function(resp) {
        if (resp) return $56bd88df2a8b1b69$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $kZS47(password, salt, iterations, keylen, digest);
    }), callback);
};

});

parcelRegister("kZS47", function(module, exports) {
'use strict';
var $24f89d3e82a360b5$exports = {};
'use strict';
var $b2def48881237d29$exports = {};

var $iA9co = parcelRequire("iA9co");

var $b2def48881237d29$require$Buffer = $iA9co.Buffer;
'use strict';
var $b2def48881237d29$var$intSize = 4;
var $b2def48881237d29$var$zeroBuffer = new $b2def48881237d29$require$Buffer($b2def48881237d29$var$intSize);
$b2def48881237d29$var$zeroBuffer.fill(0);
var $b2def48881237d29$var$charSize = 8;
var $b2def48881237d29$var$hashSize = 16;
function $b2def48881237d29$var$toArray(buf) {
    if (buf.length % $b2def48881237d29$var$intSize !== 0) {
        var len = buf.length + ($b2def48881237d29$var$intSize - buf.length % $b2def48881237d29$var$intSize);
        buf = $b2def48881237d29$require$Buffer.concat([
            buf,
            $b2def48881237d29$var$zeroBuffer
        ], len);
    }
    var arr = new Array(buf.length >>> 2);
    for(var i = 0, j = 0; i < buf.length; i += $b2def48881237d29$var$intSize, j++)arr[j] = buf.readInt32LE(i);
    return arr;
}
$b2def48881237d29$exports = function hash(buf, fn) {
    var arr = fn($b2def48881237d29$var$toArray(buf), buf.length * $b2def48881237d29$var$charSize);
    buf = new $b2def48881237d29$require$Buffer($b2def48881237d29$var$hashSize);
    for(var i = 0; i < arr.length; i++)buf.writeInt32LE(arr[i], i << 2, true);
    return buf;
};


/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */ function $24f89d3e82a360b5$var$core_md5(x, len) {
    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    for(var i = 0; i < x.length; i += 16){
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;
        a = $24f89d3e82a360b5$var$md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
        d = $24f89d3e82a360b5$var$md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = $24f89d3e82a360b5$var$md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = $24f89d3e82a360b5$var$md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = $24f89d3e82a360b5$var$md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = $24f89d3e82a360b5$var$md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = $24f89d3e82a360b5$var$md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = $24f89d3e82a360b5$var$md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = $24f89d3e82a360b5$var$md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = $24f89d3e82a360b5$var$md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = $24f89d3e82a360b5$var$md5_ff(c, d, a, b, x[i + 10], 17, -42063);
        b = $24f89d3e82a360b5$var$md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = $24f89d3e82a360b5$var$md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = $24f89d3e82a360b5$var$md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = $24f89d3e82a360b5$var$md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = $24f89d3e82a360b5$var$md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = $24f89d3e82a360b5$var$md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = $24f89d3e82a360b5$var$md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = $24f89d3e82a360b5$var$md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = $24f89d3e82a360b5$var$md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
        a = $24f89d3e82a360b5$var$md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = $24f89d3e82a360b5$var$md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = $24f89d3e82a360b5$var$md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = $24f89d3e82a360b5$var$md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = $24f89d3e82a360b5$var$md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = $24f89d3e82a360b5$var$md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = $24f89d3e82a360b5$var$md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = $24f89d3e82a360b5$var$md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = $24f89d3e82a360b5$var$md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = $24f89d3e82a360b5$var$md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = $24f89d3e82a360b5$var$md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = $24f89d3e82a360b5$var$md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = $24f89d3e82a360b5$var$md5_hh(a, b, c, d, x[i + 5], 4, -378558);
        d = $24f89d3e82a360b5$var$md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = $24f89d3e82a360b5$var$md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = $24f89d3e82a360b5$var$md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = $24f89d3e82a360b5$var$md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = $24f89d3e82a360b5$var$md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = $24f89d3e82a360b5$var$md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = $24f89d3e82a360b5$var$md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = $24f89d3e82a360b5$var$md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = $24f89d3e82a360b5$var$md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
        c = $24f89d3e82a360b5$var$md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = $24f89d3e82a360b5$var$md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = $24f89d3e82a360b5$var$md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = $24f89d3e82a360b5$var$md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = $24f89d3e82a360b5$var$md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = $24f89d3e82a360b5$var$md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = $24f89d3e82a360b5$var$md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
        d = $24f89d3e82a360b5$var$md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = $24f89d3e82a360b5$var$md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = $24f89d3e82a360b5$var$md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = $24f89d3e82a360b5$var$md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = $24f89d3e82a360b5$var$md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = $24f89d3e82a360b5$var$md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = $24f89d3e82a360b5$var$md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = $24f89d3e82a360b5$var$md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = $24f89d3e82a360b5$var$md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = $24f89d3e82a360b5$var$md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = $24f89d3e82a360b5$var$md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = $24f89d3e82a360b5$var$md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = $24f89d3e82a360b5$var$md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = $24f89d3e82a360b5$var$md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = $24f89d3e82a360b5$var$md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = $24f89d3e82a360b5$var$safe_add(a, olda);
        b = $24f89d3e82a360b5$var$safe_add(b, oldb);
        c = $24f89d3e82a360b5$var$safe_add(c, oldc);
        d = $24f89d3e82a360b5$var$safe_add(d, oldd);
    }
    return [
        a,
        b,
        c,
        d
    ];
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */ function $24f89d3e82a360b5$var$md5_cmn(q, a, b, x, s, t) {
    return $24f89d3e82a360b5$var$safe_add($24f89d3e82a360b5$var$bit_rol($24f89d3e82a360b5$var$safe_add($24f89d3e82a360b5$var$safe_add(a, q), $24f89d3e82a360b5$var$safe_add(x, t)), s), b);
}
function $24f89d3e82a360b5$var$md5_ff(a, b, c, d, x, s, t) {
    return $24f89d3e82a360b5$var$md5_cmn(b & c | ~b & d, a, b, x, s, t);
}
function $24f89d3e82a360b5$var$md5_gg(a, b, c, d, x, s, t) {
    return $24f89d3e82a360b5$var$md5_cmn(b & d | c & ~d, a, b, x, s, t);
}
function $24f89d3e82a360b5$var$md5_hh(a, b, c, d, x, s, t) {
    return $24f89d3e82a360b5$var$md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function $24f89d3e82a360b5$var$md5_ii(a, b, c, d, x, s, t) {
    return $24f89d3e82a360b5$var$md5_cmn(c ^ (b | ~d), a, b, x, s, t);
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function $24f89d3e82a360b5$var$safe_add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */ function $24f89d3e82a360b5$var$bit_rol(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
}
$24f89d3e82a360b5$exports = function md5(buf) {
    return $b2def48881237d29$exports(buf, $24f89d3e82a360b5$var$core_md5);
};


var $ec2e808e9dff0626$exports = {};



var $ec2e808e9dff0626$require$Buffer = $iA9co.Buffer;
'use strict';

var $dMzRp = parcelRequire("dMzRp");

var $321672f8ac224499$exports = {};



var $321672f8ac224499$require$Buffer = $iA9co.Buffer;
'use strict';

var $kQLUz = parcelRequire("kQLUz");

var $321672f8ac224499$require$Transform = $kQLUz.Transform;



function $321672f8ac224499$var$HashBase(blockSize) {
    $321672f8ac224499$require$Transform.call(this);
    this._block = new $321672f8ac224499$require$Buffer(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dMzRp($321672f8ac224499$var$HashBase, $321672f8ac224499$require$Transform);
$321672f8ac224499$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        if (encoding !== 'buffer') chunk = new $321672f8ac224499$require$Buffer(chunk, encoding);
        this.update(chunk);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$321672f8ac224499$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this._digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$321672f8ac224499$var$HashBase.prototype.update = function(data, encoding) {
    if (!$321672f8ac224499$require$Buffer.isBuffer(data) && typeof data !== 'string') throw new TypeError('Data must be a string or a buffer');
    if (this._finalized) throw new Error('Digest already called');
    if (!$321672f8ac224499$require$Buffer.isBuffer(data)) data = new $321672f8ac224499$require$Buffer(data, encoding || 'binary');
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$321672f8ac224499$var$HashBase.prototype._update = function(data) {
    throw new Error('_update is not implemented');
};
$321672f8ac224499$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    return digest;
};
$321672f8ac224499$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
$321672f8ac224499$exports = $321672f8ac224499$var$HashBase;


function $ec2e808e9dff0626$var$RIPEMD160() {
    $321672f8ac224499$exports.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dMzRp($ec2e808e9dff0626$var$RIPEMD160, $321672f8ac224499$exports);
$ec2e808e9dff0626$var$RIPEMD160.prototype._update = function() {
    var m = new Array(16);
    for(var i = 0; i < 16; ++i)m[i] = this._block.readInt32LE(i * 4);
    var al = this._a;
    var bl = this._b;
    var cl = this._c;
    var dl = this._d;
    var el = this._e;
    // Mj = 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15
    // K = 0x00000000
    // Sj = 11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8
    al = $ec2e808e9dff0626$var$fn1(al, bl, cl, dl, el, m[0], 0x00000000, 11);
    cl = $ec2e808e9dff0626$var$rotl(cl, 10);
    el = $ec2e808e9dff0626$var$fn1(el, al, bl, cl, dl, m[1], 0x00000000, 14);
    bl = $ec2e808e9dff0626$var$rotl(bl, 10);
    dl = $ec2e808e9dff0626$var$fn1(dl, el, al, bl, cl, m[2], 0x00000000, 15);
    al = $ec2e808e9dff0626$var$rotl(al, 10);
    cl = $ec2e808e9dff0626$var$fn1(cl, dl, el, al, bl, m[3], 0x00000000, 12);
    el = $ec2e808e9dff0626$var$rotl(el, 10);
    bl = $ec2e808e9dff0626$var$fn1(bl, cl, dl, el, al, m[4], 0x00000000, 5);
    dl = $ec2e808e9dff0626$var$rotl(dl, 10);
    al = $ec2e808e9dff0626$var$fn1(al, bl, cl, dl, el, m[5], 0x00000000, 8);
    cl = $ec2e808e9dff0626$var$rotl(cl, 10);
    el = $ec2e808e9dff0626$var$fn1(el, al, bl, cl, dl, m[6], 0x00000000, 7);
    bl = $ec2e808e9dff0626$var$rotl(bl, 10);
    dl = $ec2e808e9dff0626$var$fn1(dl, el, al, bl, cl, m[7], 0x00000000, 9);
    al = $ec2e808e9dff0626$var$rotl(al, 10);
    cl = $ec2e808e9dff0626$var$fn1(cl, dl, el, al, bl, m[8], 0x00000000, 11);
    el = $ec2e808e9dff0626$var$rotl(el, 10);
    bl = $ec2e808e9dff0626$var$fn1(bl, cl, dl, el, al, m[9], 0x00000000, 13);
    dl = $ec2e808e9dff0626$var$rotl(dl, 10);
    al = $ec2e808e9dff0626$var$fn1(al, bl, cl, dl, el, m[10], 0x00000000, 14);
    cl = $ec2e808e9dff0626$var$rotl(cl, 10);
    el = $ec2e808e9dff0626$var$fn1(el, al, bl, cl, dl, m[11], 0x00000000, 15);
    bl = $ec2e808e9dff0626$var$rotl(bl, 10);
    dl = $ec2e808e9dff0626$var$fn1(dl, el, al, bl, cl, m[12], 0x00000000, 6);
    al = $ec2e808e9dff0626$var$rotl(al, 10);
    cl = $ec2e808e9dff0626$var$fn1(cl, dl, el, al, bl, m[13], 0x00000000, 7);
    el = $ec2e808e9dff0626$var$rotl(el, 10);
    bl = $ec2e808e9dff0626$var$fn1(bl, cl, dl, el, al, m[14], 0x00000000, 9);
    dl = $ec2e808e9dff0626$var$rotl(dl, 10);
    al = $ec2e808e9dff0626$var$fn1(al, bl, cl, dl, el, m[15], 0x00000000, 8);
    cl = $ec2e808e9dff0626$var$rotl(cl, 10);
    // Mj = 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8
    // K = 0x5a827999
    // Sj = 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12
    el = $ec2e808e9dff0626$var$fn2(el, al, bl, cl, dl, m[7], 0x5a827999, 7);
    bl = $ec2e808e9dff0626$var$rotl(bl, 10);
    dl = $ec2e808e9dff0626$var$fn2(dl, el, al, bl, cl, m[4], 0x5a827999, 6);
    al = $ec2e808e9dff0626$var$rotl(al, 10);
    cl = $ec2e808e9dff0626$var$fn2(cl, dl, el, al, bl, m[13], 0x5a827999, 8);
    el = $ec2e808e9dff0626$var$rotl(el, 10);
    bl = $ec2e808e9dff0626$var$fn2(bl, cl, dl, el, al, m[1], 0x5a827999, 13);
    dl = $ec2e808e9dff0626$var$rotl(dl, 10);
    al = $ec2e808e9dff0626$var$fn2(al, bl, cl, dl, el, m[10], 0x5a827999, 11);
    cl = $ec2e808e9dff0626$var$rotl(cl, 10);
    el = $ec2e808e9dff0626$var$fn2(el, al, bl, cl, dl, m[6], 0x5a827999, 9);
    bl = $ec2e808e9dff0626$var$rotl(bl, 10);
    dl = $ec2e808e9dff0626$var$fn2(dl, el, al, bl, cl, m[15], 0x5a827999, 7);
    al = $ec2e808e9dff0626$var$rotl(al, 10);
    cl = $ec2e808e9dff0626$var$fn2(cl, dl, el, al, bl, m[3], 0x5a827999, 15);
    el = $ec2e808e9dff0626$var$rotl(el, 10);
    bl = $ec2e808e9dff0626$var$fn2(bl, cl, dl, el, al, m[12], 0x5a827999, 7);
    dl = $ec2e808e9dff0626$var$rotl(dl, 10);
    al = $ec2e808e9dff0626$var$fn2(al, bl, cl, dl, el, m[0], 0x5a827999, 12);
    cl = $ec2e808e9dff0626$var$rotl(cl, 10);
    el = $ec2e808e9dff0626$var$fn2(el, al, bl, cl, dl, m[9], 0x5a827999, 15);
    bl = $ec2e808e9dff0626$var$rotl(bl, 10);
    dl = $ec2e808e9dff0626$var$fn2(dl, el, al, bl, cl, m[5], 0x5a827999, 9);
    al = $ec2e808e9dff0626$var$rotl(al, 10);
    cl = $ec2e808e9dff0626$var$fn2(cl, dl, el, al, bl, m[2], 0x5a827999, 11);
    el = $ec2e808e9dff0626$var$rotl(el, 10);
    bl = $ec2e808e9dff0626$var$fn2(bl, cl, dl, el, al, m[14], 0x5a827999, 7);
    dl = $ec2e808e9dff0626$var$rotl(dl, 10);
    al = $ec2e808e9dff0626$var$fn2(al, bl, cl, dl, el, m[11], 0x5a827999, 13);
    cl = $ec2e808e9dff0626$var$rotl(cl, 10);
    el = $ec2e808e9dff0626$var$fn2(el, al, bl, cl, dl, m[8], 0x5a827999, 12);
    bl = $ec2e808e9dff0626$var$rotl(bl, 10);
    // Mj = 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12
    // K = 0x6ed9eba1
    // Sj = 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5
    dl = $ec2e808e9dff0626$var$fn3(dl, el, al, bl, cl, m[3], 0x6ed9eba1, 11);
    al = $ec2e808e9dff0626$var$rotl(al, 10);
    cl = $ec2e808e9dff0626$var$fn3(cl, dl, el, al, bl, m[10], 0x6ed9eba1, 13);
    el = $ec2e808e9dff0626$var$rotl(el, 10);
    bl = $ec2e808e9dff0626$var$fn3(bl, cl, dl, el, al, m[14], 0x6ed9eba1, 6);
    dl = $ec2e808e9dff0626$var$rotl(dl, 10);
    al = $ec2e808e9dff0626$var$fn3(al, bl, cl, dl, el, m[4], 0x6ed9eba1, 7);
    cl = $ec2e808e9dff0626$var$rotl(cl, 10);
    el = $ec2e808e9dff0626$var$fn3(el, al, bl, cl, dl, m[9], 0x6ed9eba1, 14);
    bl = $ec2e808e9dff0626$var$rotl(bl, 10);
    dl = $ec2e808e9dff0626$var$fn3(dl, el, al, bl, cl, m[15], 0x6ed9eba1, 9);
    al = $ec2e808e9dff0626$var$rotl(al, 10);
    cl = $ec2e808e9dff0626$var$fn3(cl, dl, el, al, bl, m[8], 0x6ed9eba1, 13);
    el = $ec2e808e9dff0626$var$rotl(el, 10);
    bl = $ec2e808e9dff0626$var$fn3(bl, cl, dl, el, al, m[1], 0x6ed9eba1, 15);
    dl = $ec2e808e9dff0626$var$rotl(dl, 10);
    al = $ec2e808e9dff0626$var$fn3(al, bl, cl, dl, el, m[2], 0x6ed9eba1, 14);
    cl = $ec2e808e9dff0626$var$rotl(cl, 10);
    el = $ec2e808e9dff0626$var$fn3(el, al, bl, cl, dl, m[7], 0x6ed9eba1, 8);
    bl = $ec2e808e9dff0626$var$rotl(bl, 10);
    dl = $ec2e808e9dff0626$var$fn3(dl, el, al, bl, cl, m[0], 0x6ed9eba1, 13);
    al = $ec2e808e9dff0626$var$rotl(al, 10);
    cl = $ec2e808e9dff0626$var$fn3(cl, dl, el, al, bl, m[6], 0x6ed9eba1, 6);
    el = $ec2e808e9dff0626$var$rotl(el, 10);
    bl = $ec2e808e9dff0626$var$fn3(bl, cl, dl, el, al, m[13], 0x6ed9eba1, 5);
    dl = $ec2e808e9dff0626$var$rotl(dl, 10);
    al = $ec2e808e9dff0626$var$fn3(al, bl, cl, dl, el, m[11], 0x6ed9eba1, 12);
    cl = $ec2e808e9dff0626$var$rotl(cl, 10);
    el = $ec2e808e9dff0626$var$fn3(el, al, bl, cl, dl, m[5], 0x6ed9eba1, 7);
    bl = $ec2e808e9dff0626$var$rotl(bl, 10);
    dl = $ec2e808e9dff0626$var$fn3(dl, el, al, bl, cl, m[12], 0x6ed9eba1, 5);
    al = $ec2e808e9dff0626$var$rotl(al, 10);
    // Mj = 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2
    // K = 0x8f1bbcdc
    // Sj = 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12
    cl = $ec2e808e9dff0626$var$fn4(cl, dl, el, al, bl, m[1], 0x8f1bbcdc, 11);
    el = $ec2e808e9dff0626$var$rotl(el, 10);
    bl = $ec2e808e9dff0626$var$fn4(bl, cl, dl, el, al, m[9], 0x8f1bbcdc, 12);
    dl = $ec2e808e9dff0626$var$rotl(dl, 10);
    al = $ec2e808e9dff0626$var$fn4(al, bl, cl, dl, el, m[11], 0x8f1bbcdc, 14);
    cl = $ec2e808e9dff0626$var$rotl(cl, 10);
    el = $ec2e808e9dff0626$var$fn4(el, al, bl, cl, dl, m[10], 0x8f1bbcdc, 15);
    bl = $ec2e808e9dff0626$var$rotl(bl, 10);
    dl = $ec2e808e9dff0626$var$fn4(dl, el, al, bl, cl, m[0], 0x8f1bbcdc, 14);
    al = $ec2e808e9dff0626$var$rotl(al, 10);
    cl = $ec2e808e9dff0626$var$fn4(cl, dl, el, al, bl, m[8], 0x8f1bbcdc, 15);
    el = $ec2e808e9dff0626$var$rotl(el, 10);
    bl = $ec2e808e9dff0626$var$fn4(bl, cl, dl, el, al, m[12], 0x8f1bbcdc, 9);
    dl = $ec2e808e9dff0626$var$rotl(dl, 10);
    al = $ec2e808e9dff0626$var$fn4(al, bl, cl, dl, el, m[4], 0x8f1bbcdc, 8);
    cl = $ec2e808e9dff0626$var$rotl(cl, 10);
    el = $ec2e808e9dff0626$var$fn4(el, al, bl, cl, dl, m[13], 0x8f1bbcdc, 9);
    bl = $ec2e808e9dff0626$var$rotl(bl, 10);
    dl = $ec2e808e9dff0626$var$fn4(dl, el, al, bl, cl, m[3], 0x8f1bbcdc, 14);
    al = $ec2e808e9dff0626$var$rotl(al, 10);
    cl = $ec2e808e9dff0626$var$fn4(cl, dl, el, al, bl, m[7], 0x8f1bbcdc, 5);
    el = $ec2e808e9dff0626$var$rotl(el, 10);
    bl = $ec2e808e9dff0626$var$fn4(bl, cl, dl, el, al, m[15], 0x8f1bbcdc, 6);
    dl = $ec2e808e9dff0626$var$rotl(dl, 10);
    al = $ec2e808e9dff0626$var$fn4(al, bl, cl, dl, el, m[14], 0x8f1bbcdc, 8);
    cl = $ec2e808e9dff0626$var$rotl(cl, 10);
    el = $ec2e808e9dff0626$var$fn4(el, al, bl, cl, dl, m[5], 0x8f1bbcdc, 6);
    bl = $ec2e808e9dff0626$var$rotl(bl, 10);
    dl = $ec2e808e9dff0626$var$fn4(dl, el, al, bl, cl, m[6], 0x8f1bbcdc, 5);
    al = $ec2e808e9dff0626$var$rotl(al, 10);
    cl = $ec2e808e9dff0626$var$fn4(cl, dl, el, al, bl, m[2], 0x8f1bbcdc, 12);
    el = $ec2e808e9dff0626$var$rotl(el, 10);
    // Mj = 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
    // K = 0xa953fd4e
    // Sj = 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
    bl = $ec2e808e9dff0626$var$fn5(bl, cl, dl, el, al, m[4], 0xa953fd4e, 9);
    dl = $ec2e808e9dff0626$var$rotl(dl, 10);
    al = $ec2e808e9dff0626$var$fn5(al, bl, cl, dl, el, m[0], 0xa953fd4e, 15);
    cl = $ec2e808e9dff0626$var$rotl(cl, 10);
    el = $ec2e808e9dff0626$var$fn5(el, al, bl, cl, dl, m[5], 0xa953fd4e, 5);
    bl = $ec2e808e9dff0626$var$rotl(bl, 10);
    dl = $ec2e808e9dff0626$var$fn5(dl, el, al, bl, cl, m[9], 0xa953fd4e, 11);
    al = $ec2e808e9dff0626$var$rotl(al, 10);
    cl = $ec2e808e9dff0626$var$fn5(cl, dl, el, al, bl, m[7], 0xa953fd4e, 6);
    el = $ec2e808e9dff0626$var$rotl(el, 10);
    bl = $ec2e808e9dff0626$var$fn5(bl, cl, dl, el, al, m[12], 0xa953fd4e, 8);
    dl = $ec2e808e9dff0626$var$rotl(dl, 10);
    al = $ec2e808e9dff0626$var$fn5(al, bl, cl, dl, el, m[2], 0xa953fd4e, 13);
    cl = $ec2e808e9dff0626$var$rotl(cl, 10);
    el = $ec2e808e9dff0626$var$fn5(el, al, bl, cl, dl, m[10], 0xa953fd4e, 12);
    bl = $ec2e808e9dff0626$var$rotl(bl, 10);
    dl = $ec2e808e9dff0626$var$fn5(dl, el, al, bl, cl, m[14], 0xa953fd4e, 5);
    al = $ec2e808e9dff0626$var$rotl(al, 10);
    cl = $ec2e808e9dff0626$var$fn5(cl, dl, el, al, bl, m[1], 0xa953fd4e, 12);
    el = $ec2e808e9dff0626$var$rotl(el, 10);
    bl = $ec2e808e9dff0626$var$fn5(bl, cl, dl, el, al, m[3], 0xa953fd4e, 13);
    dl = $ec2e808e9dff0626$var$rotl(dl, 10);
    al = $ec2e808e9dff0626$var$fn5(al, bl, cl, dl, el, m[8], 0xa953fd4e, 14);
    cl = $ec2e808e9dff0626$var$rotl(cl, 10);
    el = $ec2e808e9dff0626$var$fn5(el, al, bl, cl, dl, m[11], 0xa953fd4e, 11);
    bl = $ec2e808e9dff0626$var$rotl(bl, 10);
    dl = $ec2e808e9dff0626$var$fn5(dl, el, al, bl, cl, m[6], 0xa953fd4e, 8);
    al = $ec2e808e9dff0626$var$rotl(al, 10);
    cl = $ec2e808e9dff0626$var$fn5(cl, dl, el, al, bl, m[15], 0xa953fd4e, 5);
    el = $ec2e808e9dff0626$var$rotl(el, 10);
    bl = $ec2e808e9dff0626$var$fn5(bl, cl, dl, el, al, m[13], 0xa953fd4e, 6);
    dl = $ec2e808e9dff0626$var$rotl(dl, 10);
    var ar = this._a;
    var br = this._b;
    var cr = this._c;
    var dr = this._d;
    var er = this._e;
    // M'j = 5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12
    // K' = 0x50a28be6
    // S'j = 8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6
    ar = $ec2e808e9dff0626$var$fn5(ar, br, cr, dr, er, m[5], 0x50a28be6, 8);
    cr = $ec2e808e9dff0626$var$rotl(cr, 10);
    er = $ec2e808e9dff0626$var$fn5(er, ar, br, cr, dr, m[14], 0x50a28be6, 9);
    br = $ec2e808e9dff0626$var$rotl(br, 10);
    dr = $ec2e808e9dff0626$var$fn5(dr, er, ar, br, cr, m[7], 0x50a28be6, 9);
    ar = $ec2e808e9dff0626$var$rotl(ar, 10);
    cr = $ec2e808e9dff0626$var$fn5(cr, dr, er, ar, br, m[0], 0x50a28be6, 11);
    er = $ec2e808e9dff0626$var$rotl(er, 10);
    br = $ec2e808e9dff0626$var$fn5(br, cr, dr, er, ar, m[9], 0x50a28be6, 13);
    dr = $ec2e808e9dff0626$var$rotl(dr, 10);
    ar = $ec2e808e9dff0626$var$fn5(ar, br, cr, dr, er, m[2], 0x50a28be6, 15);
    cr = $ec2e808e9dff0626$var$rotl(cr, 10);
    er = $ec2e808e9dff0626$var$fn5(er, ar, br, cr, dr, m[11], 0x50a28be6, 15);
    br = $ec2e808e9dff0626$var$rotl(br, 10);
    dr = $ec2e808e9dff0626$var$fn5(dr, er, ar, br, cr, m[4], 0x50a28be6, 5);
    ar = $ec2e808e9dff0626$var$rotl(ar, 10);
    cr = $ec2e808e9dff0626$var$fn5(cr, dr, er, ar, br, m[13], 0x50a28be6, 7);
    er = $ec2e808e9dff0626$var$rotl(er, 10);
    br = $ec2e808e9dff0626$var$fn5(br, cr, dr, er, ar, m[6], 0x50a28be6, 7);
    dr = $ec2e808e9dff0626$var$rotl(dr, 10);
    ar = $ec2e808e9dff0626$var$fn5(ar, br, cr, dr, er, m[15], 0x50a28be6, 8);
    cr = $ec2e808e9dff0626$var$rotl(cr, 10);
    er = $ec2e808e9dff0626$var$fn5(er, ar, br, cr, dr, m[8], 0x50a28be6, 11);
    br = $ec2e808e9dff0626$var$rotl(br, 10);
    dr = $ec2e808e9dff0626$var$fn5(dr, er, ar, br, cr, m[1], 0x50a28be6, 14);
    ar = $ec2e808e9dff0626$var$rotl(ar, 10);
    cr = $ec2e808e9dff0626$var$fn5(cr, dr, er, ar, br, m[10], 0x50a28be6, 14);
    er = $ec2e808e9dff0626$var$rotl(er, 10);
    br = $ec2e808e9dff0626$var$fn5(br, cr, dr, er, ar, m[3], 0x50a28be6, 12);
    dr = $ec2e808e9dff0626$var$rotl(dr, 10);
    ar = $ec2e808e9dff0626$var$fn5(ar, br, cr, dr, er, m[12], 0x50a28be6, 6);
    cr = $ec2e808e9dff0626$var$rotl(cr, 10);
    // M'j = 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2
    // K' = 0x5c4dd124
    // S'j = 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11
    er = $ec2e808e9dff0626$var$fn4(er, ar, br, cr, dr, m[6], 0x5c4dd124, 9);
    br = $ec2e808e9dff0626$var$rotl(br, 10);
    dr = $ec2e808e9dff0626$var$fn4(dr, er, ar, br, cr, m[11], 0x5c4dd124, 13);
    ar = $ec2e808e9dff0626$var$rotl(ar, 10);
    cr = $ec2e808e9dff0626$var$fn4(cr, dr, er, ar, br, m[3], 0x5c4dd124, 15);
    er = $ec2e808e9dff0626$var$rotl(er, 10);
    br = $ec2e808e9dff0626$var$fn4(br, cr, dr, er, ar, m[7], 0x5c4dd124, 7);
    dr = $ec2e808e9dff0626$var$rotl(dr, 10);
    ar = $ec2e808e9dff0626$var$fn4(ar, br, cr, dr, er, m[0], 0x5c4dd124, 12);
    cr = $ec2e808e9dff0626$var$rotl(cr, 10);
    er = $ec2e808e9dff0626$var$fn4(er, ar, br, cr, dr, m[13], 0x5c4dd124, 8);
    br = $ec2e808e9dff0626$var$rotl(br, 10);
    dr = $ec2e808e9dff0626$var$fn4(dr, er, ar, br, cr, m[5], 0x5c4dd124, 9);
    ar = $ec2e808e9dff0626$var$rotl(ar, 10);
    cr = $ec2e808e9dff0626$var$fn4(cr, dr, er, ar, br, m[10], 0x5c4dd124, 11);
    er = $ec2e808e9dff0626$var$rotl(er, 10);
    br = $ec2e808e9dff0626$var$fn4(br, cr, dr, er, ar, m[14], 0x5c4dd124, 7);
    dr = $ec2e808e9dff0626$var$rotl(dr, 10);
    ar = $ec2e808e9dff0626$var$fn4(ar, br, cr, dr, er, m[15], 0x5c4dd124, 7);
    cr = $ec2e808e9dff0626$var$rotl(cr, 10);
    er = $ec2e808e9dff0626$var$fn4(er, ar, br, cr, dr, m[8], 0x5c4dd124, 12);
    br = $ec2e808e9dff0626$var$rotl(br, 10);
    dr = $ec2e808e9dff0626$var$fn4(dr, er, ar, br, cr, m[12], 0x5c4dd124, 7);
    ar = $ec2e808e9dff0626$var$rotl(ar, 10);
    cr = $ec2e808e9dff0626$var$fn4(cr, dr, er, ar, br, m[4], 0x5c4dd124, 6);
    er = $ec2e808e9dff0626$var$rotl(er, 10);
    br = $ec2e808e9dff0626$var$fn4(br, cr, dr, er, ar, m[9], 0x5c4dd124, 15);
    dr = $ec2e808e9dff0626$var$rotl(dr, 10);
    ar = $ec2e808e9dff0626$var$fn4(ar, br, cr, dr, er, m[1], 0x5c4dd124, 13);
    cr = $ec2e808e9dff0626$var$rotl(cr, 10);
    er = $ec2e808e9dff0626$var$fn4(er, ar, br, cr, dr, m[2], 0x5c4dd124, 11);
    br = $ec2e808e9dff0626$var$rotl(br, 10);
    // M'j = 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13
    // K' = 0x6d703ef3
    // S'j = 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5
    dr = $ec2e808e9dff0626$var$fn3(dr, er, ar, br, cr, m[15], 0x6d703ef3, 9);
    ar = $ec2e808e9dff0626$var$rotl(ar, 10);
    cr = $ec2e808e9dff0626$var$fn3(cr, dr, er, ar, br, m[5], 0x6d703ef3, 7);
    er = $ec2e808e9dff0626$var$rotl(er, 10);
    br = $ec2e808e9dff0626$var$fn3(br, cr, dr, er, ar, m[1], 0x6d703ef3, 15);
    dr = $ec2e808e9dff0626$var$rotl(dr, 10);
    ar = $ec2e808e9dff0626$var$fn3(ar, br, cr, dr, er, m[3], 0x6d703ef3, 11);
    cr = $ec2e808e9dff0626$var$rotl(cr, 10);
    er = $ec2e808e9dff0626$var$fn3(er, ar, br, cr, dr, m[7], 0x6d703ef3, 8);
    br = $ec2e808e9dff0626$var$rotl(br, 10);
    dr = $ec2e808e9dff0626$var$fn3(dr, er, ar, br, cr, m[14], 0x6d703ef3, 6);
    ar = $ec2e808e9dff0626$var$rotl(ar, 10);
    cr = $ec2e808e9dff0626$var$fn3(cr, dr, er, ar, br, m[6], 0x6d703ef3, 6);
    er = $ec2e808e9dff0626$var$rotl(er, 10);
    br = $ec2e808e9dff0626$var$fn3(br, cr, dr, er, ar, m[9], 0x6d703ef3, 14);
    dr = $ec2e808e9dff0626$var$rotl(dr, 10);
    ar = $ec2e808e9dff0626$var$fn3(ar, br, cr, dr, er, m[11], 0x6d703ef3, 12);
    cr = $ec2e808e9dff0626$var$rotl(cr, 10);
    er = $ec2e808e9dff0626$var$fn3(er, ar, br, cr, dr, m[8], 0x6d703ef3, 13);
    br = $ec2e808e9dff0626$var$rotl(br, 10);
    dr = $ec2e808e9dff0626$var$fn3(dr, er, ar, br, cr, m[12], 0x6d703ef3, 5);
    ar = $ec2e808e9dff0626$var$rotl(ar, 10);
    cr = $ec2e808e9dff0626$var$fn3(cr, dr, er, ar, br, m[2], 0x6d703ef3, 14);
    er = $ec2e808e9dff0626$var$rotl(er, 10);
    br = $ec2e808e9dff0626$var$fn3(br, cr, dr, er, ar, m[10], 0x6d703ef3, 13);
    dr = $ec2e808e9dff0626$var$rotl(dr, 10);
    ar = $ec2e808e9dff0626$var$fn3(ar, br, cr, dr, er, m[0], 0x6d703ef3, 13);
    cr = $ec2e808e9dff0626$var$rotl(cr, 10);
    er = $ec2e808e9dff0626$var$fn3(er, ar, br, cr, dr, m[4], 0x6d703ef3, 7);
    br = $ec2e808e9dff0626$var$rotl(br, 10);
    dr = $ec2e808e9dff0626$var$fn3(dr, er, ar, br, cr, m[13], 0x6d703ef3, 5);
    ar = $ec2e808e9dff0626$var$rotl(ar, 10);
    // M'j = 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14
    // K' = 0x7a6d76e9
    // S'j = 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8
    cr = $ec2e808e9dff0626$var$fn2(cr, dr, er, ar, br, m[8], 0x7a6d76e9, 15);
    er = $ec2e808e9dff0626$var$rotl(er, 10);
    br = $ec2e808e9dff0626$var$fn2(br, cr, dr, er, ar, m[6], 0x7a6d76e9, 5);
    dr = $ec2e808e9dff0626$var$rotl(dr, 10);
    ar = $ec2e808e9dff0626$var$fn2(ar, br, cr, dr, er, m[4], 0x7a6d76e9, 8);
    cr = $ec2e808e9dff0626$var$rotl(cr, 10);
    er = $ec2e808e9dff0626$var$fn2(er, ar, br, cr, dr, m[1], 0x7a6d76e9, 11);
    br = $ec2e808e9dff0626$var$rotl(br, 10);
    dr = $ec2e808e9dff0626$var$fn2(dr, er, ar, br, cr, m[3], 0x7a6d76e9, 14);
    ar = $ec2e808e9dff0626$var$rotl(ar, 10);
    cr = $ec2e808e9dff0626$var$fn2(cr, dr, er, ar, br, m[11], 0x7a6d76e9, 14);
    er = $ec2e808e9dff0626$var$rotl(er, 10);
    br = $ec2e808e9dff0626$var$fn2(br, cr, dr, er, ar, m[15], 0x7a6d76e9, 6);
    dr = $ec2e808e9dff0626$var$rotl(dr, 10);
    ar = $ec2e808e9dff0626$var$fn2(ar, br, cr, dr, er, m[0], 0x7a6d76e9, 14);
    cr = $ec2e808e9dff0626$var$rotl(cr, 10);
    er = $ec2e808e9dff0626$var$fn2(er, ar, br, cr, dr, m[5], 0x7a6d76e9, 6);
    br = $ec2e808e9dff0626$var$rotl(br, 10);
    dr = $ec2e808e9dff0626$var$fn2(dr, er, ar, br, cr, m[12], 0x7a6d76e9, 9);
    ar = $ec2e808e9dff0626$var$rotl(ar, 10);
    cr = $ec2e808e9dff0626$var$fn2(cr, dr, er, ar, br, m[2], 0x7a6d76e9, 12);
    er = $ec2e808e9dff0626$var$rotl(er, 10);
    br = $ec2e808e9dff0626$var$fn2(br, cr, dr, er, ar, m[13], 0x7a6d76e9, 9);
    dr = $ec2e808e9dff0626$var$rotl(dr, 10);
    ar = $ec2e808e9dff0626$var$fn2(ar, br, cr, dr, er, m[9], 0x7a6d76e9, 12);
    cr = $ec2e808e9dff0626$var$rotl(cr, 10);
    er = $ec2e808e9dff0626$var$fn2(er, ar, br, cr, dr, m[7], 0x7a6d76e9, 5);
    br = $ec2e808e9dff0626$var$rotl(br, 10);
    dr = $ec2e808e9dff0626$var$fn2(dr, er, ar, br, cr, m[10], 0x7a6d76e9, 15);
    ar = $ec2e808e9dff0626$var$rotl(ar, 10);
    cr = $ec2e808e9dff0626$var$fn2(cr, dr, er, ar, br, m[14], 0x7a6d76e9, 8);
    er = $ec2e808e9dff0626$var$rotl(er, 10);
    // M'j = 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
    // K' = 0x00000000
    // S'j = 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
    br = $ec2e808e9dff0626$var$fn1(br, cr, dr, er, ar, m[12], 0x00000000, 8);
    dr = $ec2e808e9dff0626$var$rotl(dr, 10);
    ar = $ec2e808e9dff0626$var$fn1(ar, br, cr, dr, er, m[15], 0x00000000, 5);
    cr = $ec2e808e9dff0626$var$rotl(cr, 10);
    er = $ec2e808e9dff0626$var$fn1(er, ar, br, cr, dr, m[10], 0x00000000, 12);
    br = $ec2e808e9dff0626$var$rotl(br, 10);
    dr = $ec2e808e9dff0626$var$fn1(dr, er, ar, br, cr, m[4], 0x00000000, 9);
    ar = $ec2e808e9dff0626$var$rotl(ar, 10);
    cr = $ec2e808e9dff0626$var$fn1(cr, dr, er, ar, br, m[1], 0x00000000, 12);
    er = $ec2e808e9dff0626$var$rotl(er, 10);
    br = $ec2e808e9dff0626$var$fn1(br, cr, dr, er, ar, m[5], 0x00000000, 5);
    dr = $ec2e808e9dff0626$var$rotl(dr, 10);
    ar = $ec2e808e9dff0626$var$fn1(ar, br, cr, dr, er, m[8], 0x00000000, 14);
    cr = $ec2e808e9dff0626$var$rotl(cr, 10);
    er = $ec2e808e9dff0626$var$fn1(er, ar, br, cr, dr, m[7], 0x00000000, 6);
    br = $ec2e808e9dff0626$var$rotl(br, 10);
    dr = $ec2e808e9dff0626$var$fn1(dr, er, ar, br, cr, m[6], 0x00000000, 8);
    ar = $ec2e808e9dff0626$var$rotl(ar, 10);
    cr = $ec2e808e9dff0626$var$fn1(cr, dr, er, ar, br, m[2], 0x00000000, 13);
    er = $ec2e808e9dff0626$var$rotl(er, 10);
    br = $ec2e808e9dff0626$var$fn1(br, cr, dr, er, ar, m[13], 0x00000000, 6);
    dr = $ec2e808e9dff0626$var$rotl(dr, 10);
    ar = $ec2e808e9dff0626$var$fn1(ar, br, cr, dr, er, m[14], 0x00000000, 5);
    cr = $ec2e808e9dff0626$var$rotl(cr, 10);
    er = $ec2e808e9dff0626$var$fn1(er, ar, br, cr, dr, m[0], 0x00000000, 15);
    br = $ec2e808e9dff0626$var$rotl(br, 10);
    dr = $ec2e808e9dff0626$var$fn1(dr, er, ar, br, cr, m[3], 0x00000000, 13);
    ar = $ec2e808e9dff0626$var$rotl(ar, 10);
    cr = $ec2e808e9dff0626$var$fn1(cr, dr, er, ar, br, m[9], 0x00000000, 11);
    er = $ec2e808e9dff0626$var$rotl(er, 10);
    br = $ec2e808e9dff0626$var$fn1(br, cr, dr, er, ar, m[11], 0x00000000, 11);
    dr = $ec2e808e9dff0626$var$rotl(dr, 10);
    // change state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$ec2e808e9dff0626$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = new $ec2e808e9dff0626$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $ec2e808e9dff0626$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $ec2e808e9dff0626$var$fn1(a, b, c, d, e, m, k, s) {
    return $ec2e808e9dff0626$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $ec2e808e9dff0626$var$fn2(a, b, c, d, e, m, k, s) {
    return $ec2e808e9dff0626$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $ec2e808e9dff0626$var$fn3(a, b, c, d, e, m, k, s) {
    return $ec2e808e9dff0626$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $ec2e808e9dff0626$var$fn4(a, b, c, d, e, m, k, s) {
    return $ec2e808e9dff0626$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $ec2e808e9dff0626$var$fn5(a, b, c, d, e, m, k, s) {
    return $ec2e808e9dff0626$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
$ec2e808e9dff0626$exports = $ec2e808e9dff0626$var$RIPEMD160;



var $hyb5G = parcelRequire("hyb5G");


var $eI8vp = parcelRequire("eI8vp");

var $f493716718ecf168$require$Buffer = $eI8vp.Buffer;

var $8THs5 = parcelRequire("8THs5");


var $jmQ5f = parcelRequire("jmQ5f");


var $9Jtnp = parcelRequire("9Jtnp");

var $f493716718ecf168$var$ZEROS = $f493716718ecf168$require$Buffer.alloc(128);
var $f493716718ecf168$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $f493716718ecf168$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $f493716718ecf168$var$rmd160Func(data) {
    return new $ec2e808e9dff0626$exports().update(data).digest();
}
function $f493716718ecf168$var$getDigest(alg) {
    function shaFunc(data) {
        return $hyb5G(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $f493716718ecf168$var$rmd160Func;
    if (alg === 'md5') return $24f89d3e82a360b5$exports;
    return shaFunc;
}
function $f493716718ecf168$var$Hmac(alg, key, saltLen) {
    var hash = $f493716718ecf168$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $f493716718ecf168$require$Buffer.concat([
        key,
        $f493716718ecf168$var$ZEROS
    ], blocksize);
    var ipad = $f493716718ecf168$require$Buffer.allocUnsafe(blocksize + $f493716718ecf168$var$sizes[alg]);
    var opad = $f493716718ecf168$require$Buffer.allocUnsafe(blocksize + $f493716718ecf168$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $f493716718ecf168$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $f493716718ecf168$var$sizes[alg];
}
$f493716718ecf168$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $f493716718ecf168$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $8THs5(iterations, keylen);
    password = $9Jtnp(password, $jmQ5f, 'Password');
    salt = $9Jtnp(salt, $jmQ5f, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $f493716718ecf168$var$mapping[lowerDigest] || lowerDigest;
    var size = $f493716718ecf168$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $f493716718ecf168$var$Hmac(mappedDigest, password, salt.length);
    var DK = $f493716718ecf168$require$Buffer.allocUnsafe(keylen);
    var block1 = $f493716718ecf168$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $f493716718ecf168$var$pbkdf2;

});

parcelRegister("howAI", function(module, exports) {
var $ca9df57cbcb5440a$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $ca9df57cbcb5440a$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("7vkYj", function(module, exports) {
'use strict';

var $khd9U = parcelRequire("khd9U");

/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$khd9U(value);
};

});

parcelRegister("khd9U", function(module, exports) {
'use strict';
var $2540668c4dc561a4$exports = {};
'use strict';
var $55a1fd46a3c07ab0$exports = {};
'use strict';
var $55a1fd46a3c07ab0$var$fnToStr = Function.prototype.toString;
var $55a1fd46a3c07ab0$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $55a1fd46a3c07ab0$var$badArrayLike;
var $55a1fd46a3c07ab0$var$isCallableMarker;
if (typeof $55a1fd46a3c07ab0$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $55a1fd46a3c07ab0$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $55a1fd46a3c07ab0$var$isCallableMarker;
        }
    });
    $55a1fd46a3c07ab0$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $55a1fd46a3c07ab0$var$reflectApply(function() {
        throw 42;
    }, null, $55a1fd46a3c07ab0$var$badArrayLike);
} catch (_) {
    if (_ !== $55a1fd46a3c07ab0$var$isCallableMarker) $55a1fd46a3c07ab0$var$reflectApply = null;
}
else $55a1fd46a3c07ab0$var$reflectApply = null;
var $55a1fd46a3c07ab0$var$constructorRegex = /^\s*class\b/;
var $55a1fd46a3c07ab0$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $55a1fd46a3c07ab0$var$fnToStr.call(value);
        return $55a1fd46a3c07ab0$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $55a1fd46a3c07ab0$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($55a1fd46a3c07ab0$var$isES6ClassFn(value)) return false;
        $55a1fd46a3c07ab0$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $55a1fd46a3c07ab0$var$toStr = Object.prototype.toString;
var $55a1fd46a3c07ab0$var$objectClass = '[object Object]';
var $55a1fd46a3c07ab0$var$fnClass = '[object Function]';
var $55a1fd46a3c07ab0$var$genClass = '[object GeneratorFunction]';
var $55a1fd46a3c07ab0$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $55a1fd46a3c07ab0$var$ddaClass2 = '[object HTML document.all class]';
var $55a1fd46a3c07ab0$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $55a1fd46a3c07ab0$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $55a1fd46a3c07ab0$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $55a1fd46a3c07ab0$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $55a1fd46a3c07ab0$var$all = document.all;
    if ($55a1fd46a3c07ab0$var$toStr.call($55a1fd46a3c07ab0$var$all) === $55a1fd46a3c07ab0$var$toStr.call(document.all)) $55a1fd46a3c07ab0$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($55a1fd46a3c07ab0$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $55a1fd46a3c07ab0$var$toStr.call(value);
            return (str === $55a1fd46a3c07ab0$var$ddaClass || str === $55a1fd46a3c07ab0$var$ddaClass2 || str === $55a1fd46a3c07ab0$var$ddaClass3 // opera 12.16
             || str === $55a1fd46a3c07ab0$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
$55a1fd46a3c07ab0$exports = $55a1fd46a3c07ab0$var$reflectApply ? function isCallable(value) {
    if ($55a1fd46a3c07ab0$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $55a1fd46a3c07ab0$var$reflectApply(value, null, $55a1fd46a3c07ab0$var$badArrayLike);
    } catch (e) {
        if (e !== $55a1fd46a3c07ab0$var$isCallableMarker) return false;
    }
    return !$55a1fd46a3c07ab0$var$isES6ClassFn(value) && $55a1fd46a3c07ab0$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($55a1fd46a3c07ab0$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($55a1fd46a3c07ab0$var$hasToStringTag) return $55a1fd46a3c07ab0$var$tryFunctionObject(value);
    if ($55a1fd46a3c07ab0$var$isES6ClassFn(value)) return false;
    var strClass = $55a1fd46a3c07ab0$var$toStr.call(value);
    if (strClass !== $55a1fd46a3c07ab0$var$fnClass && strClass !== $55a1fd46a3c07ab0$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $55a1fd46a3c07ab0$var$tryFunctionObject(value);
};


var $2540668c4dc561a4$var$toStr = Object.prototype.toString;
var $2540668c4dc561a4$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $2540668c4dc561a4$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($2540668c4dc561a4$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $2540668c4dc561a4$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $2540668c4dc561a4$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($2540668c4dc561a4$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $2540668c4dc561a4$var$isArray(x) {
    return $2540668c4dc561a4$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ $2540668c4dc561a4$exports = function forEach(list, iterator, thisArg) {
    if (!$55a1fd46a3c07ab0$exports(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($2540668c4dc561a4$var$isArray(list)) $2540668c4dc561a4$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $2540668c4dc561a4$var$forEachString(list, iterator, receiver);
    else $2540668c4dc561a4$var$forEachObject(list, iterator, receiver);
};


var $311bd3146f9f8f55$exports = {};
'use strict';
var $dd362867790351c6$exports = {};
'use strict';
/** @type {import('.')} */ $dd362867790351c6$exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];


var $311bd3146f9f8f55$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ $311bd3146f9f8f55$exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $dd362867790351c6$exports.length; i++)if (typeof $311bd3146f9f8f55$var$g[$dd362867790351c6$exports[i]] === 'function') // @ts-expect-error
    out[out.length] = $dd362867790351c6$exports[i];
    return out;
};



var $i3fmO = parcelRequire("i3fmO");


var $aahHV = parcelRequire("aahHV");


var $aFqsr = parcelRequire("aFqsr");

var $6b5014cc276e74bc$exports = {};
'use strict';
var $ff0550dcb0ddf8d2$exports = {};
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ $ff0550dcb0ddf8d2$exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;


var $4445cb7c7846b6c4$exports = {};
'use strict';

var $j4PUi = parcelRequire("j4PUi");

/** @type {import('./Object.getPrototypeOf')} */ $4445cb7c7846b6c4$exports = $j4PUi.getPrototypeOf || null;


var $7bc9b93bba43b3d2$exports = {};
'use strict';

var $bVf2p = parcelRequire("bVf2p");




var $7bc9b93bba43b3d2$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $7bc9b93bba43b3d2$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $7bc9b93bba43b3d2$var$desc = !!$7bc9b93bba43b3d2$var$hasProtoAccessor && $aFqsr && $aFqsr(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $7bc9b93bba43b3d2$var$$Object = Object;
var $7bc9b93bba43b3d2$var$$getPrototypeOf = $7bc9b93bba43b3d2$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ $7bc9b93bba43b3d2$exports = $7bc9b93bba43b3d2$var$desc && typeof $7bc9b93bba43b3d2$var$desc.get === 'function' ? $bVf2p([
    $7bc9b93bba43b3d2$var$desc.get
]) : typeof $7bc9b93bba43b3d2$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $7bc9b93bba43b3d2$var$$getPrototypeOf(value == null ? value : $7bc9b93bba43b3d2$var$$Object(value));
} : false;


/** @type {import('.')} */ $6b5014cc276e74bc$exports = $ff0550dcb0ddf8d2$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $ff0550dcb0ddf8d2$exports(O);
} : $4445cb7c7846b6c4$exports ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $4445cb7c7846b6c4$exports(O);
} : $7bc9b93bba43b3d2$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $7bc9b93bba43b3d2$exports(O);
} : null;


var $ec2f9a40aa7b05ee$var$$toString = $aahHV('Object.prototype.toString');

var $ec2f9a40aa7b05ee$var$hasToStringTag = (parcelRequire("8an01"))();
var $ec2f9a40aa7b05ee$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $ec2f9a40aa7b05ee$var$typedArrays = $311bd3146f9f8f55$exports();
var $ec2f9a40aa7b05ee$var$$slice = $aahHV('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $ec2f9a40aa7b05ee$var$$indexOf = $aahHV('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $ec2f9a40aa7b05ee$var$cache = {
    __proto__: null
};
if ($ec2f9a40aa7b05ee$var$hasToStringTag && $aFqsr && $6b5014cc276e74bc$exports) $2540668c4dc561a4$exports($ec2f9a40aa7b05ee$var$typedArrays, function(typedArray) {
    var arr = new $ec2f9a40aa7b05ee$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $6b5014cc276e74bc$exports) {
        var proto = $6b5014cc276e74bc$exports(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $aFqsr(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $6b5014cc276e74bc$exports(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $aFqsr(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $ec2f9a40aa7b05ee$var$cache['$' + typedArray] = $i3fmO(descriptor.get);
    }
});
else $2540668c4dc561a4$exports($ec2f9a40aa7b05ee$var$typedArrays, function(typedArray) {
    var arr = new $ec2f9a40aa7b05ee$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $ec2f9a40aa7b05ee$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $i3fmO(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $ec2f9a40aa7b05ee$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $2540668c4dc561a4$exports(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $ec2f9a40aa7b05ee$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $ec2f9a40aa7b05ee$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $ec2f9a40aa7b05ee$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $2540668c4dc561a4$exports(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $ec2f9a40aa7b05ee$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $ec2f9a40aa7b05ee$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$ec2f9a40aa7b05ee$var$hasToStringTag) {
        /** @type {string} */ var tag = $ec2f9a40aa7b05ee$var$$slice($ec2f9a40aa7b05ee$var$$toString(value), 8, -1);
        if ($ec2f9a40aa7b05ee$var$$indexOf($ec2f9a40aa7b05ee$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $ec2f9a40aa7b05ee$var$trySlices(value);
    }
    if (!$aFqsr) return null;
     // unknown engine
    return $ec2f9a40aa7b05ee$var$tryTypedArrays(value);
};

});

parcelRegister("i3fmO", function(module, exports) {
'use strict';
var $d32a12ef1dda14ad$exports = {};
'use strict';

var $92atP = parcelRequire("92atP");


var $gglQq = parcelRequire("gglQq");


var $d32a12ef1dda14ad$var$hasDescriptors = (parcelRequire("lUjLg"))();

var $aFqsr = parcelRequire("aFqsr");


var $bLmKG = parcelRequire("bLmKG");

var $d32a12ef1dda14ad$var$$floor = $92atP('%Math.floor%');
/** @type {import('.')} */ $d32a12ef1dda14ad$exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $bLmKG('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $d32a12ef1dda14ad$var$$floor(length) !== length) throw new $bLmKG('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $aFqsr) {
        var desc = $aFqsr(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($d32a12ef1dda14ad$var$hasDescriptors) $gglQq(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $gglQq(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};



var $cy5uq = parcelRequire("cy5uq");


var $bVf2p = parcelRequire("bVf2p");

var $a4c2fec4bca5f487$exports = {};
'use strict';

var $7WErB = parcelRequire("7WErB");


var $4fQJo = parcelRequire("4fQJo");


var $2kBNA = parcelRequire("2kBNA");

/** @type {import('./applyBind')} */ $a4c2fec4bca5f487$exports = function applyBind() {
    return $2kBNA($7WErB, $4fQJo, arguments);
};


module.exports = function callBind(originalFunction) {
    var func = $bVf2p(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $d32a12ef1dda14ad$exports(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($cy5uq) $cy5uq(module.exports, 'apply', {
    value: $a4c2fec4bca5f487$exports
});
else module.exports.apply = $a4c2fec4bca5f487$exports;

});

parcelRegister("gglQq", function(module, exports) {
'use strict';

var $cy5uq = parcelRequire("cy5uq");


var $f0OSc = parcelRequire("f0OSc");


var $bLmKG = parcelRequire("bLmKG");


var $aFqsr = parcelRequire("aFqsr");

/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $bLmKG('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $bLmKG('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $bLmKG('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $bLmKG('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $bLmKG('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $bLmKG('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$aFqsr && $aFqsr(obj, property);
    if ($cy5uq) $cy5uq(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $f0OSc('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("lUjLg", function(module, exports) {
'use strict';

var $cy5uq = parcelRequire("cy5uq");

var $041da5cedd3ec586$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$cy5uq;
};
$041da5cedd3ec586$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$cy5uq) return null;
    try {
        return $cy5uq([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $041da5cedd3ec586$var$hasPropertyDescriptors;

});

parcelRegister("j4PUi", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("8an01", function(module, exports) {
'use strict';

var $23Da1 = parcelRequire("23Da1");

/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $23Da1() && !!Symbol.toStringTag;
};

});

parcelRegister("aqm7A", function(module, exports) {
$parcel$export(module.exports, "readUInt32BE", () => $796d7dec09097a65$export$cfaef8ed399428b0, (v) => $796d7dec09097a65$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $796d7dec09097a65$export$a80c7deaea7cbd80, (v) => $796d7dec09097a65$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $796d7dec09097a65$export$ed7577ae6e1cd0ef, (v) => $796d7dec09097a65$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $796d7dec09097a65$export$5dcbef3aa594f567, (v) => $796d7dec09097a65$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $796d7dec09097a65$export$5bc8001ca71ed9c5, (v) => $796d7dec09097a65$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $796d7dec09097a65$export$3e714e2c5d5d8cb2, (v) => $796d7dec09097a65$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $796d7dec09097a65$export$94c3e544fd062b7f, (v) => $796d7dec09097a65$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $796d7dec09097a65$export$9f77e0932fb78f72, (v) => $796d7dec09097a65$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $796d7dec09097a65$export$d865ce2836f5927f, (v) => $796d7dec09097a65$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $796d7dec09097a65$export$95e62ad65da8b7d2, (v) => $796d7dec09097a65$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $796d7dec09097a65$export$209139ff098c441a, (v) => $796d7dec09097a65$export$209139ff098c441a = v);
var $796d7dec09097a65$export$cfaef8ed399428b0;
var $796d7dec09097a65$export$a80c7deaea7cbd80;
var $796d7dec09097a65$export$ed7577ae6e1cd0ef;
var $796d7dec09097a65$export$5dcbef3aa594f567;
var $796d7dec09097a65$export$5bc8001ca71ed9c5;
var $796d7dec09097a65$export$3e714e2c5d5d8cb2;
var $796d7dec09097a65$export$94c3e544fd062b7f;
var $796d7dec09097a65$export$9f77e0932fb78f72;
var $796d7dec09097a65$export$d865ce2836f5927f;
var $796d7dec09097a65$export$95e62ad65da8b7d2;
var $796d7dec09097a65$export$209139ff098c441a;
'use strict';
$796d7dec09097a65$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$796d7dec09097a65$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$796d7dec09097a65$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$796d7dec09097a65$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$796d7dec09097a65$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$796d7dec09097a65$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $796d7dec09097a65$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$796d7dec09097a65$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $796d7dec09097a65$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $796d7dec09097a65$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $796d7dec09097a65$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $796d7dec09097a65$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$796d7dec09097a65$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $796d7dec09097a65$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$796d7dec09097a65$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $796d7dec09097a65$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $796d7dec09097a65$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $796d7dec09097a65$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$796d7dec09097a65$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $796d7dec09097a65$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $796d7dec09097a65$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$796d7dec09097a65$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("6qpJT", function(module, exports) {
'use strict';

var $gLTb0 = parcelRequire("gLTb0");

function $4ad923085e0bcd66$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $4ad923085e0bcd66$var$Cipher;
$4ad923085e0bcd66$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$4ad923085e0bcd66$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$4ad923085e0bcd66$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$4ad923085e0bcd66$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$4ad923085e0bcd66$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$4ad923085e0bcd66$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$4ad923085e0bcd66$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$4ad923085e0bcd66$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$4ad923085e0bcd66$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$4ad923085e0bcd66$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$4ad923085e0bcd66$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $gLTb0.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});

parcelRegister("jwgTG", function(module, exports) {
'use strict';

var $gLTb0 = parcelRequire("gLTb0");


var $dMzRp = parcelRequire("dMzRp");


var $aqm7A = parcelRequire("aqm7A");


var $6qpJT = parcelRequire("6qpJT");

function $e35e1ce4442a393e$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $e35e1ce4442a393e$var$DES(options) {
    $6qpJT.call(this, options);
    var state = new $e35e1ce4442a393e$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dMzRp($e35e1ce4442a393e$var$DES, $6qpJT);
module.exports = $e35e1ce4442a393e$var$DES;
$e35e1ce4442a393e$var$DES.create = function create(options) {
    return new $e35e1ce4442a393e$var$DES(options);
};
var $e35e1ce4442a393e$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$e35e1ce4442a393e$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $gLTb0.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $aqm7A.readUInt32BE(key, 0);
    var kR = $aqm7A.readUInt32BE(key, 4);
    $aqm7A.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $e35e1ce4442a393e$var$shiftTable[i >>> 1];
        kL = $aqm7A.r28shl(kL, shift);
        kR = $aqm7A.r28shl(kR, shift);
        $aqm7A.pc2(kL, kR, state.keys, i);
    }
};
$e35e1ce4442a393e$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $aqm7A.readUInt32BE(inp, inOff);
    var r = $aqm7A.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $aqm7A.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $aqm7A.writeUInt32BE(out, l, outOff);
    $aqm7A.writeUInt32BE(out, r, outOff + 4);
};
$e35e1ce4442a393e$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$e35e1ce4442a393e$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$gLTb0.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$e35e1ce4442a393e$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $aqm7A.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $aqm7A.substitute(keyL, keyR);
        var f = $aqm7A.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $aqm7A.rip(r, l, out, off);
};
$e35e1ce4442a393e$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $aqm7A.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $aqm7A.substitute(keyL, keyR);
        var f = $aqm7A.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $aqm7A.rip(l, r, out, off);
};

});

parcelRegister("czrgF", function(module, exports) {
$parcel$export(module.exports, "instantiate", () => $926de7baf4966bfe$export$f9bb8d20ccc7477a, (v) => $926de7baf4966bfe$export$f9bb8d20ccc7477a = v);
var $926de7baf4966bfe$export$f9bb8d20ccc7477a;
'use strict';

var $gLTb0 = parcelRequire("gLTb0");


var $dMzRp = parcelRequire("dMzRp");

var $926de7baf4966bfe$var$proto = {};
function $926de7baf4966bfe$var$CBCState(iv) {
    $gLTb0.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $926de7baf4966bfe$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dMzRp(CBC, Base);
    var keys = Object.keys($926de7baf4966bfe$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $926de7baf4966bfe$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$926de7baf4966bfe$export$f9bb8d20ccc7477a = $926de7baf4966bfe$var$instantiate;
$926de7baf4966bfe$var$proto._cbcInit = function _cbcInit() {
    var state = new $926de7baf4966bfe$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$926de7baf4966bfe$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("5Jmd3", function(module, exports) {
'use strict';

var $gLTb0 = parcelRequire("gLTb0");


var $dMzRp = parcelRequire("dMzRp");


var $6qpJT = parcelRequire("6qpJT");


var $jwgTG = parcelRequire("jwgTG");

function $42c2620f18d20721$var$EDEState(type, key) {
    $gLTb0.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $jwgTG.create({
            type: 'encrypt',
            key: k1
        }),
        $jwgTG.create({
            type: 'decrypt',
            key: k2
        }),
        $jwgTG.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $jwgTG.create({
            type: 'decrypt',
            key: k3
        }),
        $jwgTG.create({
            type: 'encrypt',
            key: k2
        }),
        $jwgTG.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $42c2620f18d20721$var$EDE(options) {
    $6qpJT.call(this, options);
    var state = new $42c2620f18d20721$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dMzRp($42c2620f18d20721$var$EDE, $6qpJT);
module.exports = $42c2620f18d20721$var$EDE;
$42c2620f18d20721$var$EDE.create = function create(options) {
    return new $42c2620f18d20721$var$EDE(options);
};
$42c2620f18d20721$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$42c2620f18d20721$var$EDE.prototype._pad = $jwgTG.prototype._pad;
$42c2620f18d20721$var$EDE.prototype._unpad = $jwgTG.prototype._unpad;

});

parcelRegister("4YL5h", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $3a0149f81604de33$export$5b0f6292f11d1d18, (v) => $3a0149f81604de33$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $3a0149f81604de33$export$e85a0c9a1067c5d3, (v) => $3a0149f81604de33$export$e85a0c9a1067c5d3 = v);
var $3a0149f81604de33$export$5b0f6292f11d1d18;
var $3a0149f81604de33$export$e85a0c9a1067c5d3;
$3a0149f81604de33$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$3a0149f81604de33$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("l92H7", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $f64c874acd4a5ef1$export$5b0f6292f11d1d18, (v) => $f64c874acd4a5ef1$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $f64c874acd4a5ef1$export$e85a0c9a1067c5d3, (v) => $f64c874acd4a5ef1$export$e85a0c9a1067c5d3 = v);
var $f64c874acd4a5ef1$export$5b0f6292f11d1d18;
var $f64c874acd4a5ef1$export$e85a0c9a1067c5d3;

var $479P8 = parcelRequire("479P8");

$f64c874acd4a5ef1$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $479P8(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$f64c874acd4a5ef1$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $479P8(out, pad);
};

});

parcelRegister("iTSsV", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $dc279cc322ef5895$export$5b0f6292f11d1d18, (v) => $dc279cc322ef5895$export$5b0f6292f11d1d18 = v);
var $dc279cc322ef5895$export$5b0f6292f11d1d18;

var $eI8vp = parcelRequire("eI8vp");

var $dc279cc322ef5895$require$Buffer = $eI8vp.Buffer;

var $479P8 = parcelRequire("479P8");

function $dc279cc322ef5895$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $479P8(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $dc279cc322ef5895$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$dc279cc322ef5895$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $dc279cc322ef5895$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $dc279cc322ef5895$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $dc279cc322ef5895$require$Buffer.concat([
                out,
                $dc279cc322ef5895$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $dc279cc322ef5895$require$Buffer.concat([
                out,
                $dc279cc322ef5895$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("sGGPC", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $0563baf37ab9c32d$export$5b0f6292f11d1d18, (v) => $0563baf37ab9c32d$export$5b0f6292f11d1d18 = v);
var $0563baf37ab9c32d$export$5b0f6292f11d1d18;

var $eI8vp = parcelRequire("eI8vp");

var $0563baf37ab9c32d$require$Buffer = $eI8vp.Buffer;
function $0563baf37ab9c32d$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $0563baf37ab9c32d$require$Buffer.concat([
        self._prev.slice(1),
        $0563baf37ab9c32d$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$0563baf37ab9c32d$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $0563baf37ab9c32d$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $0563baf37ab9c32d$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("eqJyk", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $a816d43ca31246f2$export$5b0f6292f11d1d18, (v) => $a816d43ca31246f2$export$5b0f6292f11d1d18 = v);
var $a816d43ca31246f2$export$5b0f6292f11d1d18;

var $eI8vp = parcelRequire("eI8vp");

var $a816d43ca31246f2$require$Buffer = $eI8vp.Buffer;
function $a816d43ca31246f2$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $a816d43ca31246f2$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $a816d43ca31246f2$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $a816d43ca31246f2$require$Buffer.allocUnsafe(buffer.length);
    buffer = $a816d43ca31246f2$require$Buffer.concat([
        buffer,
        $a816d43ca31246f2$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$a816d43ca31246f2$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $a816d43ca31246f2$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $a816d43ca31246f2$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("dITno", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $9fda57051203cb75$export$5b0f6292f11d1d18, (v) => $9fda57051203cb75$export$5b0f6292f11d1d18 = v);
var $9fda57051203cb75$export$5b0f6292f11d1d18;

var $iA9co = parcelRequire("iA9co");

var $9fda57051203cb75$require$Buffer = $iA9co.Buffer;

var $479P8 = parcelRequire("479P8");

function $9fda57051203cb75$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$9fda57051203cb75$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $9fda57051203cb75$require$Buffer.concat([
        self._cache,
        $9fda57051203cb75$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $479P8(chunk, pad);
};

});

parcelRegister("8ERF1", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $64dbaf04db66b9d0$export$5b0f6292f11d1d18, (v) => $64dbaf04db66b9d0$export$5b0f6292f11d1d18 = v);
var $64dbaf04db66b9d0$export$5b0f6292f11d1d18;

var $479P8 = parcelRequire("479P8");


var $eI8vp = parcelRequire("eI8vp");

var $64dbaf04db66b9d0$require$Buffer = $eI8vp.Buffer;

var $1VL9i = parcelRequire("1VL9i");

function $64dbaf04db66b9d0$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $1VL9i(self._prev);
    return out;
}
var $64dbaf04db66b9d0$var$blockSize = 16;
$64dbaf04db66b9d0$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $64dbaf04db66b9d0$var$blockSize);
    var start = self._cache.length;
    self._cache = $64dbaf04db66b9d0$require$Buffer.concat([
        self._cache,
        $64dbaf04db66b9d0$require$Buffer.allocUnsafe(chunkNum * $64dbaf04db66b9d0$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $64dbaf04db66b9d0$var$getBlock(self);
        var offset = start + i * $64dbaf04db66b9d0$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $479P8(chunk, pad);
};

});

parcelRegister("hpluo", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("h1hUh")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7VcJI", function(module, exports) {
var $5c47bc772fa9079b$var$r;
module.exports = function rand(len) {
    if (!$5c47bc772fa9079b$var$r) $5c47bc772fa9079b$var$r = new $5c47bc772fa9079b$var$Rand(null);
    return $5c47bc772fa9079b$var$r.generate(len);
};
function $5c47bc772fa9079b$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5c47bc772fa9079b$var$Rand;
$5c47bc772fa9079b$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5c47bc772fa9079b$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5c47bc772fa9079b$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5c47bc772fa9079b$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $5c47bc772fa9079b$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5c47bc772fa9079b$var$crypto = (parcelRequire("h1hUh"));
    if (typeof $5c47bc772fa9079b$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $5c47bc772fa9079b$var$Rand.prototype._rand = function _rand(n) {
        return $5c47bc772fa9079b$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("eNro0", function(module, exports) {

exports = module.exports = (parcelRequire("d5F34"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("eikIa"));

exports.Duplex = (parcelRequire("3P7uE"));

exports.Transform = (parcelRequire("kdJo9"));

exports.PassThrough = (parcelRequire("fedgh"));

});

parcelRegister("d5F34", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $kyRHQ = parcelRequire("kyRHQ");

'use strict';

var $eigVC = parcelRequire("eigVC");

/*</replacement>*/ module.exports = $987b955deee37040$var$Readable;
var $b2e53dc51933f99f$exports = {};
var $b2e53dc51933f99f$var$toString = {}.toString;
$b2e53dc51933f99f$exports = Array.isArray || function(arr) {
    return $b2e53dc51933f99f$var$toString.call(arr) == '[object Array]';
};


/*</replacement>*/ /*<replacement>*/ var $987b955deee37040$var$Duplex;
/*</replacement>*/ $987b955deee37040$var$Readable.ReadableState = $987b955deee37040$var$ReadableState;

var $5rDjV = parcelRequire("5rDjV");

var $987b955deee37040$require$EE = $5rDjV.EventEmitter;
var $987b955deee37040$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $jHaCq = parcelRequire("jHaCq");


var $6Y114 = parcelRequire("6Y114");

var $987b955deee37040$require$Buffer = $6Y114.Buffer;
var $987b955deee37040$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $987b955deee37040$var$_uint8ArrayToBuffer(chunk) {
    return $987b955deee37040$require$Buffer.from(chunk);
}
function $987b955deee37040$var$_isUint8Array(obj) {
    return $987b955deee37040$require$Buffer.isBuffer(obj) || obj instanceof $987b955deee37040$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $987b955deee37040$var$util = Object.create((parcelRequire("7WEZ9")));

$987b955deee37040$var$util.inherits = (parcelRequire("dMzRp"));

var $h1hUh = parcelRequire("h1hUh");

var $987b955deee37040$var$debug = void 0;
if ($h1hUh && $h1hUh.debuglog) $987b955deee37040$var$debug = $h1hUh.debuglog('stream');
else $987b955deee37040$var$debug = function() {};

var $gLkWG = parcelRequire("gLkWG");


var $epYxt = parcelRequire("epYxt");

var $987b955deee37040$var$StringDecoder;
$987b955deee37040$var$util.inherits($987b955deee37040$var$Readable, $jHaCq);
var $987b955deee37040$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $987b955deee37040$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($b2e53dc51933f99f$exports(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $987b955deee37040$var$ReadableState(options, stream) {
    $987b955deee37040$var$Duplex = $987b955deee37040$var$Duplex || (parcelRequire("3P7uE"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $987b955deee37040$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $gLkWG();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$987b955deee37040$var$StringDecoder) $987b955deee37040$var$StringDecoder = (parcelRequire("eqyB5")).StringDecoder;
        this.decoder = new $987b955deee37040$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $987b955deee37040$var$Readable(options) {
    $987b955deee37040$var$Duplex = $987b955deee37040$var$Duplex || (parcelRequire("3P7uE"));
    if (!(this instanceof $987b955deee37040$var$Readable)) return new $987b955deee37040$var$Readable(options);
    this._readableState = new $987b955deee37040$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $jHaCq.call(this);
}
Object.defineProperty($987b955deee37040$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$987b955deee37040$var$Readable.prototype.destroy = $epYxt.destroy;
$987b955deee37040$var$Readable.prototype._undestroy = $epYxt.undestroy;
$987b955deee37040$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$987b955deee37040$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $987b955deee37040$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $987b955deee37040$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$987b955deee37040$var$Readable.prototype.unshift = function(chunk) {
    return $987b955deee37040$var$readableAddChunk(this, chunk, null, true, false);
};
function $987b955deee37040$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $987b955deee37040$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $987b955deee37040$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $987b955deee37040$require$Buffer.prototype) chunk = $987b955deee37040$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $987b955deee37040$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $987b955deee37040$var$addChunk(stream, state, chunk, false);
                    else $987b955deee37040$var$maybeReadMore(stream, state);
                } else $987b955deee37040$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $987b955deee37040$var$needMoreData(state);
}
function $987b955deee37040$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $987b955deee37040$var$emitReadable(stream);
    }
    $987b955deee37040$var$maybeReadMore(stream, state);
}
function $987b955deee37040$var$chunkInvalid(state, chunk) {
    var er;
    if (!$987b955deee37040$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $987b955deee37040$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$987b955deee37040$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$987b955deee37040$var$Readable.prototype.setEncoding = function(enc) {
    if (!$987b955deee37040$var$StringDecoder) $987b955deee37040$var$StringDecoder = (parcelRequire("eqyB5")).StringDecoder;
    this._readableState.decoder = new $987b955deee37040$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $987b955deee37040$var$MAX_HWM = 0x800000;
function $987b955deee37040$var$computeNewHighWaterMark(n) {
    if (n >= $987b955deee37040$var$MAX_HWM) n = $987b955deee37040$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $987b955deee37040$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $987b955deee37040$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$987b955deee37040$var$Readable.prototype.read = function(n) {
    $987b955deee37040$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $987b955deee37040$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $987b955deee37040$var$endReadable(this);
        else $987b955deee37040$var$emitReadable(this);
        return null;
    }
    n = $987b955deee37040$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $987b955deee37040$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $987b955deee37040$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $987b955deee37040$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $987b955deee37040$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $987b955deee37040$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $987b955deee37040$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $987b955deee37040$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $987b955deee37040$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $987b955deee37040$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $987b955deee37040$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $987b955deee37040$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $987b955deee37040$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $eigVC.nextTick($987b955deee37040$var$emitReadable_, stream);
        else $987b955deee37040$var$emitReadable_(stream);
    }
}
function $987b955deee37040$var$emitReadable_(stream) {
    $987b955deee37040$var$debug('emit readable');
    stream.emit('readable');
    $987b955deee37040$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $987b955deee37040$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $eigVC.nextTick($987b955deee37040$var$maybeReadMore_, stream, state);
    }
}
function $987b955deee37040$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $987b955deee37040$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$987b955deee37040$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$987b955deee37040$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $987b955deee37040$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $kyRHQ.stdout && dest !== $kyRHQ.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eigVC.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $987b955deee37040$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $987b955deee37040$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $987b955deee37040$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $987b955deee37040$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $987b955deee37040$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $987b955deee37040$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $987b955deee37040$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $987b955deee37040$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($987b955deee37040$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $987b955deee37040$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $987b955deee37040$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $987b955deee37040$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $987b955deee37040$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $987b955deee37040$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $987b955deee37040$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $987b955deee37040$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $987b955deee37040$var$flow(src);
        }
    };
}
$987b955deee37040$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $987b955deee37040$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$987b955deee37040$var$Readable.prototype.on = function(ev, fn) {
    var res = $jHaCq.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $eigVC.nextTick($987b955deee37040$var$nReadingNextTick, this);
            else if (state.length) $987b955deee37040$var$emitReadable(this);
        }
    }
    return res;
};
$987b955deee37040$var$Readable.prototype.addListener = $987b955deee37040$var$Readable.prototype.on;
function $987b955deee37040$var$nReadingNextTick(self1) {
    $987b955deee37040$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$987b955deee37040$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $987b955deee37040$var$debug('resume');
        state.flowing = true;
        $987b955deee37040$var$resume(this, state);
    }
    return this;
};
function $987b955deee37040$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eigVC.nextTick($987b955deee37040$var$resume_, stream, state);
    }
}
function $987b955deee37040$var$resume_(stream, state) {
    if (!state.reading) {
        $987b955deee37040$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $987b955deee37040$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$987b955deee37040$var$Readable.prototype.pause = function() {
    $987b955deee37040$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $987b955deee37040$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $987b955deee37040$var$flow(stream) {
    var state = stream._readableState;
    $987b955deee37040$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$987b955deee37040$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $987b955deee37040$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $987b955deee37040$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $987b955deee37040$var$kProxyEvents.length; n++)stream.on($987b955deee37040$var$kProxyEvents[n], this.emit.bind(this, $987b955deee37040$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $987b955deee37040$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($987b955deee37040$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$987b955deee37040$var$Readable._fromList = $987b955deee37040$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $987b955deee37040$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $987b955deee37040$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $987b955deee37040$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $987b955deee37040$var$copyFromBufferString(n, list) : $987b955deee37040$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $987b955deee37040$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $987b955deee37040$var$copyFromBuffer(n, list) {
    var ret = $987b955deee37040$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $987b955deee37040$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $eigVC.nextTick($987b955deee37040$var$endReadableNT, state, stream);
    }
}
function $987b955deee37040$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $987b955deee37040$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});

parcelRegister("7WEZ9", function(module, exports) {
$parcel$export(module.exports, "isArray", () => $5c8dbe0668fe4966$export$43bee75e5e14138e, (v) => $5c8dbe0668fe4966$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $5c8dbe0668fe4966$export$f9ce7b637dfbe238, (v) => $5c8dbe0668fe4966$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $5c8dbe0668fe4966$export$630801d484da15df, (v) => $5c8dbe0668fe4966$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $5c8dbe0668fe4966$export$bedb7023a7733221, (v) => $5c8dbe0668fe4966$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $5c8dbe0668fe4966$export$7e4aa119212bc614, (v) => $5c8dbe0668fe4966$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $5c8dbe0668fe4966$export$844ec244b1367d54, (v) => $5c8dbe0668fe4966$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $5c8dbe0668fe4966$export$a244864fd9645c7f, (v) => $5c8dbe0668fe4966$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $5c8dbe0668fe4966$export$fce6876652108ab, (v) => $5c8dbe0668fe4966$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $5c8dbe0668fe4966$export$49841c62b9eff15, (v) => $5c8dbe0668fe4966$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $5c8dbe0668fe4966$export$a6cdc56e425d0d0a, (v) => $5c8dbe0668fe4966$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $5c8dbe0668fe4966$export$871608497c498473, (v) => $5c8dbe0668fe4966$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $5c8dbe0668fe4966$export$e6127cc7fe7395c3, (v) => $5c8dbe0668fe4966$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $5c8dbe0668fe4966$export$f6e2535fb5126e54, (v) => $5c8dbe0668fe4966$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $5c8dbe0668fe4966$export$c3825b437cbdea5c, (v) => $5c8dbe0668fe4966$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $5c8dbe0668fe4966$export$a7884ebc965f8f54, (v) => $5c8dbe0668fe4966$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $5c8dbe0668fe4966$export$43bee75e5e14138e;
var $5c8dbe0668fe4966$export$f9ce7b637dfbe238;
var $5c8dbe0668fe4966$export$630801d484da15df;
var $5c8dbe0668fe4966$export$bedb7023a7733221;
var $5c8dbe0668fe4966$export$7e4aa119212bc614;
var $5c8dbe0668fe4966$export$844ec244b1367d54;
var $5c8dbe0668fe4966$export$a244864fd9645c7f;
var $5c8dbe0668fe4966$export$fce6876652108ab;
var $5c8dbe0668fe4966$export$49841c62b9eff15;
var $5c8dbe0668fe4966$export$a6cdc56e425d0d0a;
var $5c8dbe0668fe4966$export$871608497c498473;
var $5c8dbe0668fe4966$export$e6127cc7fe7395c3;
var $5c8dbe0668fe4966$export$f6e2535fb5126e54;
var $5c8dbe0668fe4966$export$c3825b437cbdea5c;
var $5c8dbe0668fe4966$export$a7884ebc965f8f54;
function $5c8dbe0668fe4966$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $5c8dbe0668fe4966$var$objectToString(arg) === '[object Array]';
}
$5c8dbe0668fe4966$export$43bee75e5e14138e = $5c8dbe0668fe4966$var$isArray;
function $5c8dbe0668fe4966$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$5c8dbe0668fe4966$export$f9ce7b637dfbe238 = $5c8dbe0668fe4966$var$isBoolean;
function $5c8dbe0668fe4966$var$isNull(arg) {
    return arg === null;
}
$5c8dbe0668fe4966$export$630801d484da15df = $5c8dbe0668fe4966$var$isNull;
function $5c8dbe0668fe4966$var$isNullOrUndefined(arg) {
    return arg == null;
}
$5c8dbe0668fe4966$export$bedb7023a7733221 = $5c8dbe0668fe4966$var$isNullOrUndefined;
function $5c8dbe0668fe4966$var$isNumber(arg) {
    return typeof arg === 'number';
}
$5c8dbe0668fe4966$export$7e4aa119212bc614 = $5c8dbe0668fe4966$var$isNumber;
function $5c8dbe0668fe4966$var$isString(arg) {
    return typeof arg === 'string';
}
$5c8dbe0668fe4966$export$844ec244b1367d54 = $5c8dbe0668fe4966$var$isString;
function $5c8dbe0668fe4966$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$5c8dbe0668fe4966$export$a244864fd9645c7f = $5c8dbe0668fe4966$var$isSymbol;
function $5c8dbe0668fe4966$var$isUndefined(arg) {
    return arg === void 0;
}
$5c8dbe0668fe4966$export$fce6876652108ab = $5c8dbe0668fe4966$var$isUndefined;
function $5c8dbe0668fe4966$var$isRegExp(re) {
    return $5c8dbe0668fe4966$var$objectToString(re) === '[object RegExp]';
}
$5c8dbe0668fe4966$export$49841c62b9eff15 = $5c8dbe0668fe4966$var$isRegExp;
function $5c8dbe0668fe4966$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$5c8dbe0668fe4966$export$a6cdc56e425d0d0a = $5c8dbe0668fe4966$var$isObject;
function $5c8dbe0668fe4966$var$isDate(d) {
    return $5c8dbe0668fe4966$var$objectToString(d) === '[object Date]';
}
$5c8dbe0668fe4966$export$871608497c498473 = $5c8dbe0668fe4966$var$isDate;
function $5c8dbe0668fe4966$var$isError(e) {
    return $5c8dbe0668fe4966$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$5c8dbe0668fe4966$export$e6127cc7fe7395c3 = $5c8dbe0668fe4966$var$isError;
function $5c8dbe0668fe4966$var$isFunction(arg) {
    return typeof arg === 'function';
}
$5c8dbe0668fe4966$export$f6e2535fb5126e54 = $5c8dbe0668fe4966$var$isFunction;
function $5c8dbe0668fe4966$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$5c8dbe0668fe4966$export$c3825b437cbdea5c = $5c8dbe0668fe4966$var$isPrimitive;

$5c8dbe0668fe4966$export$a7884ebc965f8f54 = (parcelRequire("iA9co")).Buffer.isBuffer;
function $5c8dbe0668fe4966$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("3P7uE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $eigVC = parcelRequire("eigVC");

/*</replacement>*/ /*<replacement>*/ var $2c8bf28a21a1d0ae$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $2c8bf28a21a1d0ae$var$Duplex;

/*<replacement>*/ var $2c8bf28a21a1d0ae$var$util = Object.create((parcelRequire("7WEZ9")));

$2c8bf28a21a1d0ae$var$util.inherits = (parcelRequire("dMzRp"));

var $d5F34 = parcelRequire("d5F34");


var $eikIa = parcelRequire("eikIa");

$2c8bf28a21a1d0ae$var$util.inherits($2c8bf28a21a1d0ae$var$Duplex, $d5F34);
// avoid scope creep, the keys array can then be collected
var $2c8bf28a21a1d0ae$var$keys = $2c8bf28a21a1d0ae$var$objectKeys($eikIa.prototype);
for(var $2c8bf28a21a1d0ae$var$v = 0; $2c8bf28a21a1d0ae$var$v < $2c8bf28a21a1d0ae$var$keys.length; $2c8bf28a21a1d0ae$var$v++){
    var $2c8bf28a21a1d0ae$var$method = $2c8bf28a21a1d0ae$var$keys[$2c8bf28a21a1d0ae$var$v];
    if (!$2c8bf28a21a1d0ae$var$Duplex.prototype[$2c8bf28a21a1d0ae$var$method]) $2c8bf28a21a1d0ae$var$Duplex.prototype[$2c8bf28a21a1d0ae$var$method] = $eikIa.prototype[$2c8bf28a21a1d0ae$var$method];
}
function $2c8bf28a21a1d0ae$var$Duplex(options) {
    if (!(this instanceof $2c8bf28a21a1d0ae$var$Duplex)) return new $2c8bf28a21a1d0ae$var$Duplex(options);
    $d5F34.call(this, options);
    $eikIa.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $2c8bf28a21a1d0ae$var$onend);
}
Object.defineProperty($2c8bf28a21a1d0ae$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $2c8bf28a21a1d0ae$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $eigVC.nextTick($2c8bf28a21a1d0ae$var$onEndNT, this);
}
function $2c8bf28a21a1d0ae$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($2c8bf28a21a1d0ae$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$2c8bf28a21a1d0ae$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $eigVC.nextTick(cb, err);
};

});

parcelRegister("eikIa", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eigVC = parcelRequire("eigVC");

/*</replacement>*/ module.exports = $a682cfff89c86bf8$var$Writable;
/* <replacement> */ function $a682cfff89c86bf8$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $a682cfff89c86bf8$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $a682cfff89c86bf8$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $a682cfff89c86bf8$var$asyncWrite = (0, $eigVC.nextTick);
/*</replacement>*/ /*<replacement>*/ var $a682cfff89c86bf8$var$Duplex;
/*</replacement>*/ $a682cfff89c86bf8$var$Writable.WritableState = $a682cfff89c86bf8$var$WritableState;

/*<replacement>*/ var $a682cfff89c86bf8$var$util = Object.create((parcelRequire("7WEZ9")));

$a682cfff89c86bf8$var$util.inherits = (parcelRequire("dMzRp"));

/*</replacement>*/ /*<replacement>*/ var $a682cfff89c86bf8$var$internalUtil = {
    deprecate: (parcelRequire("dv3qK"))
};

var $jHaCq = parcelRequire("jHaCq");


var $6Y114 = parcelRequire("6Y114");

var $a682cfff89c86bf8$require$Buffer = $6Y114.Buffer;
var $a682cfff89c86bf8$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $a682cfff89c86bf8$var$_uint8ArrayToBuffer(chunk) {
    return $a682cfff89c86bf8$require$Buffer.from(chunk);
}
function $a682cfff89c86bf8$var$_isUint8Array(obj) {
    return $a682cfff89c86bf8$require$Buffer.isBuffer(obj) || obj instanceof $a682cfff89c86bf8$var$OurUint8Array;
}

var $epYxt = parcelRequire("epYxt");

$a682cfff89c86bf8$var$util.inherits($a682cfff89c86bf8$var$Writable, $jHaCq);
function $a682cfff89c86bf8$var$nop() {}

function $a682cfff89c86bf8$var$WritableState(options, stream) {
    $a682cfff89c86bf8$var$Duplex = $a682cfff89c86bf8$var$Duplex || (parcelRequire("3P7uE"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $a682cfff89c86bf8$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $a682cfff89c86bf8$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $a682cfff89c86bf8$var$CorkedRequest(this);
}
$a682cfff89c86bf8$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($a682cfff89c86bf8$var$WritableState.prototype, 'buffer', {
            get: $a682cfff89c86bf8$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $a682cfff89c86bf8$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $a682cfff89c86bf8$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($a682cfff89c86bf8$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($a682cfff89c86bf8$var$realHasInstance.call(this, object)) return true;
            if (this !== $a682cfff89c86bf8$var$Writable) return false;
            return object && object._writableState instanceof $a682cfff89c86bf8$var$WritableState;
        }
    });
} else $a682cfff89c86bf8$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $a682cfff89c86bf8$var$Writable(options) {
    $a682cfff89c86bf8$var$Duplex = $a682cfff89c86bf8$var$Duplex || (parcelRequire("3P7uE"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$a682cfff89c86bf8$var$realHasInstance.call($a682cfff89c86bf8$var$Writable, this) && !(this instanceof $a682cfff89c86bf8$var$Duplex)) return new $a682cfff89c86bf8$var$Writable(options);
    this._writableState = new $a682cfff89c86bf8$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $jHaCq.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$a682cfff89c86bf8$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $a682cfff89c86bf8$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $eigVC.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $a682cfff89c86bf8$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $eigVC.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$a682cfff89c86bf8$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $a682cfff89c86bf8$var$_isUint8Array(chunk);
    if (isBuf && !$a682cfff89c86bf8$require$Buffer.isBuffer(chunk)) chunk = $a682cfff89c86bf8$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $a682cfff89c86bf8$var$nop;
    if (state.ended) $a682cfff89c86bf8$var$writeAfterEnd(this, cb);
    else if (isBuf || $a682cfff89c86bf8$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $a682cfff89c86bf8$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$a682cfff89c86bf8$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$a682cfff89c86bf8$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $a682cfff89c86bf8$var$clearBuffer(this, state);
    }
};
$a682cfff89c86bf8$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $a682cfff89c86bf8$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $a682cfff89c86bf8$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($a682cfff89c86bf8$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $a682cfff89c86bf8$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $a682cfff89c86bf8$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $a682cfff89c86bf8$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $a682cfff89c86bf8$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $a682cfff89c86bf8$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $eigVC.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $eigVC.nextTick($a682cfff89c86bf8$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $a682cfff89c86bf8$var$finishMaybe(stream, state);
    }
}
function $a682cfff89c86bf8$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $a682cfff89c86bf8$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $a682cfff89c86bf8$var$onwriteStateUpdate(state);
    if (er) $a682cfff89c86bf8$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $a682cfff89c86bf8$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $a682cfff89c86bf8$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $a682cfff89c86bf8$var$asyncWrite($a682cfff89c86bf8$var$afterWrite, stream, state, finished, cb);
        else $a682cfff89c86bf8$var$afterWrite(stream, state, finished, cb);
    }
}
function $a682cfff89c86bf8$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $a682cfff89c86bf8$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $a682cfff89c86bf8$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $a682cfff89c86bf8$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $a682cfff89c86bf8$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $a682cfff89c86bf8$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $a682cfff89c86bf8$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $a682cfff89c86bf8$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$a682cfff89c86bf8$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$a682cfff89c86bf8$var$Writable.prototype._writev = null;
$a682cfff89c86bf8$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $a682cfff89c86bf8$var$endWritable(this, state, cb);
};
function $a682cfff89c86bf8$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $a682cfff89c86bf8$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $a682cfff89c86bf8$var$finishMaybe(stream, state);
    });
}
function $a682cfff89c86bf8$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $eigVC.nextTick($a682cfff89c86bf8$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $a682cfff89c86bf8$var$finishMaybe(stream, state) {
    var need = $a682cfff89c86bf8$var$needFinish(state);
    if (need) {
        $a682cfff89c86bf8$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $a682cfff89c86bf8$var$endWritable(stream, state, cb) {
    state.ending = true;
    $a682cfff89c86bf8$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $eigVC.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $a682cfff89c86bf8$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($a682cfff89c86bf8$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$a682cfff89c86bf8$var$Writable.prototype.destroy = $epYxt.destroy;
$a682cfff89c86bf8$var$Writable.prototype._undestroy = $epYxt.undestroy;
$a682cfff89c86bf8$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});

parcelRegister("eqyB5", function(module, exports) {
$parcel$export(module.exports, "StringDecoder", () => $a80e54a60c16e913$export$63a7aa211a91ed69, (v) => $a80e54a60c16e913$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $a80e54a60c16e913$export$63a7aa211a91ed69;
'use strict';

var $eSDVW = parcelRequire("eSDVW");

var $a80e54a60c16e913$require$Buffer = $eSDVW.Buffer;
/*</replacement>*/ var $a80e54a60c16e913$var$isEncoding = $a80e54a60c16e913$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $a80e54a60c16e913$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $a80e54a60c16e913$var$normalizeEncoding(enc) {
    var nenc = $a80e54a60c16e913$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($a80e54a60c16e913$require$Buffer.isEncoding === $a80e54a60c16e913$var$isEncoding || !$a80e54a60c16e913$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$a80e54a60c16e913$export$63a7aa211a91ed69 = $a80e54a60c16e913$var$StringDecoder;
function $a80e54a60c16e913$var$StringDecoder(encoding) {
    this.encoding = $a80e54a60c16e913$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $a80e54a60c16e913$var$utf16Text;
            this.end = $a80e54a60c16e913$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $a80e54a60c16e913$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $a80e54a60c16e913$var$base64Text;
            this.end = $a80e54a60c16e913$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $a80e54a60c16e913$var$simpleWrite;
            this.end = $a80e54a60c16e913$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $a80e54a60c16e913$require$Buffer.allocUnsafe(nb);
}
$a80e54a60c16e913$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$a80e54a60c16e913$var$StringDecoder.prototype.end = $a80e54a60c16e913$var$utf8End;
// Returns only complete characters in a Buffer
$a80e54a60c16e913$var$StringDecoder.prototype.text = $a80e54a60c16e913$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$a80e54a60c16e913$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $a80e54a60c16e913$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $a80e54a60c16e913$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $a80e54a60c16e913$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $a80e54a60c16e913$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $a80e54a60c16e913$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $a80e54a60c16e913$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $a80e54a60c16e913$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $a80e54a60c16e913$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $a80e54a60c16e913$var$utf8Text(buf, i) {
    var total = $a80e54a60c16e913$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $a80e54a60c16e913$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $a80e54a60c16e913$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $a80e54a60c16e913$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $a80e54a60c16e913$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $a80e54a60c16e913$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $a80e54a60c16e913$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $a80e54a60c16e913$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("kdJo9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $eb883ac596da5de8$var$Transform;

var $3P7uE = parcelRequire("3P7uE");


/*<replacement>*/ var $eb883ac596da5de8$var$util = Object.create((parcelRequire("7WEZ9")));

$eb883ac596da5de8$var$util.inherits = (parcelRequire("dMzRp"));
/*</replacement>*/ $eb883ac596da5de8$var$util.inherits($eb883ac596da5de8$var$Transform, $3P7uE);
function $eb883ac596da5de8$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $eb883ac596da5de8$var$Transform(options) {
    if (!(this instanceof $eb883ac596da5de8$var$Transform)) return new $eb883ac596da5de8$var$Transform(options);
    $3P7uE.call(this, options);
    this._transformState = {
        afterTransform: $eb883ac596da5de8$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $eb883ac596da5de8$var$prefinish);
}
function $eb883ac596da5de8$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $eb883ac596da5de8$var$done(_this, er, data);
    });
    else $eb883ac596da5de8$var$done(this, null, null);
}
$eb883ac596da5de8$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $3P7uE.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$eb883ac596da5de8$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$eb883ac596da5de8$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$eb883ac596da5de8$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$eb883ac596da5de8$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $3P7uE.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $eb883ac596da5de8$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("fedgh", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $b162734f2a408339$var$PassThrough;

var $kdJo9 = parcelRequire("kdJo9");


/*<replacement>*/ var $b162734f2a408339$var$util = Object.create((parcelRequire("7WEZ9")));

$b162734f2a408339$var$util.inherits = (parcelRequire("dMzRp"));
/*</replacement>*/ $b162734f2a408339$var$util.inherits($b162734f2a408339$var$PassThrough, $kdJo9);
function $b162734f2a408339$var$PassThrough(options) {
    if (!(this instanceof $b162734f2a408339$var$PassThrough)) return new $b162734f2a408339$var$PassThrough(options);
    $kdJo9.call(this, options);
}
$b162734f2a408339$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("cGJih", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("h1hUh")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("5kU12", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("ljKeU", function(module, exports) {
'use strict';
var $f84f3d84ea9282ba$var$utils = module.exports;

var $hpluo = parcelRequire("hpluo");


var $gLTb0 = parcelRequire("gLTb0");


var $hjBPv = parcelRequire("hjBPv");

$f84f3d84ea9282ba$var$utils.assert = $gLTb0;
$f84f3d84ea9282ba$var$utils.toArray = $hjBPv.toArray;
$f84f3d84ea9282ba$var$utils.zero2 = $hjBPv.zero2;
$f84f3d84ea9282ba$var$utils.toHex = $hjBPv.toHex;
$f84f3d84ea9282ba$var$utils.encode = $hjBPv.encode;
// Represent num in a w-NAF form
function $f84f3d84ea9282ba$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$f84f3d84ea9282ba$var$utils.getNAF = $f84f3d84ea9282ba$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $f84f3d84ea9282ba$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$f84f3d84ea9282ba$var$utils.getJSF = $f84f3d84ea9282ba$var$getJSF;
function $f84f3d84ea9282ba$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$f84f3d84ea9282ba$var$utils.cachedProperty = $f84f3d84ea9282ba$var$cachedProperty;
function $f84f3d84ea9282ba$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $f84f3d84ea9282ba$var$utils.toArray(bytes, 'hex') : bytes;
}
$f84f3d84ea9282ba$var$utils.parseBytes = $f84f3d84ea9282ba$var$parseBytes;
function $f84f3d84ea9282ba$var$intFromLE(bytes) {
    return new $hpluo(bytes, 'hex', 'le');
}
$f84f3d84ea9282ba$var$utils.intFromLE = $f84f3d84ea9282ba$var$intFromLE;

});

parcelRegister("fFhvD", function(module, exports) {
'use strict';
var $b678445424b7c327$var$curve = module.exports;

$b678445424b7c327$var$curve.base = (parcelRequire("lJPXx"));

$b678445424b7c327$var$curve.short = (parcelRequire("7uDpO"));

$b678445424b7c327$var$curve.mont = (parcelRequire("ivHwc"));

$b678445424b7c327$var$curve.edwards = (parcelRequire("lybDc"));

});

parcelRegister("lJPXx", function(module, exports) {
'use strict';

var $hpluo = parcelRequire("hpluo");


var $ljKeU = parcelRequire("ljKeU");

var $fd361af3bbe5e322$var$getNAF = $ljKeU.getNAF;
var $fd361af3bbe5e322$var$getJSF = $ljKeU.getJSF;
var $fd361af3bbe5e322$var$assert = $ljKeU.assert;
function $fd361af3bbe5e322$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $hpluo(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $hpluo.red(conf.prime) : $hpluo.mont(this.p);
    // Useful for many curves
    this.zero = new $hpluo(0).toRed(this.red);
    this.one = new $hpluo(1).toRed(this.red);
    this.two = new $hpluo(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $hpluo(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $fd361af3bbe5e322$var$BaseCurve;
$fd361af3bbe5e322$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$fd361af3bbe5e322$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$fd361af3bbe5e322$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $fd361af3bbe5e322$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $fd361af3bbe5e322$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$fd361af3bbe5e322$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $fd361af3bbe5e322$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $fd361af3bbe5e322$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$fd361af3bbe5e322$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $fd361af3bbe5e322$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $fd361af3bbe5e322$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $fd361af3bbe5e322$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $fd361af3bbe5e322$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$fd361af3bbe5e322$var$BaseCurve.BasePoint = $fd361af3bbe5e322$var$BasePoint;
$fd361af3bbe5e322$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$fd361af3bbe5e322$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$fd361af3bbe5e322$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $ljKeU.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $fd361af3bbe5e322$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $fd361af3bbe5e322$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$fd361af3bbe5e322$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$fd361af3bbe5e322$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$fd361af3bbe5e322$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $ljKeU.encode(this._encode(compact), enc);
};
$fd361af3bbe5e322$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$fd361af3bbe5e322$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$fd361af3bbe5e322$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$fd361af3bbe5e322$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$fd361af3bbe5e322$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$fd361af3bbe5e322$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("7uDpO", function(module, exports) {
'use strict';

var $ljKeU = parcelRequire("ljKeU");


var $hpluo = parcelRequire("hpluo");


var $dMzRp = parcelRequire("dMzRp");


var $lJPXx = parcelRequire("lJPXx");

var $5749e8d31d125016$var$assert = $ljKeU.assert;
function $5749e8d31d125016$var$ShortCurve(conf) {
    $lJPXx.call(this, 'short', conf);
    this.a = new $hpluo(conf.a, 16).toRed(this.red);
    this.b = new $hpluo(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dMzRp($5749e8d31d125016$var$ShortCurve, $lJPXx);
module.exports = $5749e8d31d125016$var$ShortCurve;
$5749e8d31d125016$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $hpluo(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $hpluo(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $5749e8d31d125016$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $hpluo(vec.a, 16),
            b: new $hpluo(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$5749e8d31d125016$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $hpluo.mont(num);
    var tinv = new $hpluo(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $hpluo(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$5749e8d31d125016$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $hpluo(1);
    var y1 = new $hpluo(0);
    var x2 = new $hpluo(0);
    var y2 = new $hpluo(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$5749e8d31d125016$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$5749e8d31d125016$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $hpluo(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$5749e8d31d125016$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$5749e8d31d125016$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $5749e8d31d125016$var$Point(curve, x, y, isRed) {
    $lJPXx.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $hpluo(x, 16);
        this.y = new $hpluo(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dMzRp($5749e8d31d125016$var$Point, $lJPXx.BasePoint);
$5749e8d31d125016$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $5749e8d31d125016$var$Point(this, x, y, isRed);
};
$5749e8d31d125016$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $5749e8d31d125016$var$Point.fromJSON(this, obj, red);
};
$5749e8d31d125016$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$5749e8d31d125016$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$5749e8d31d125016$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$5749e8d31d125016$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$5749e8d31d125016$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$5749e8d31d125016$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$5749e8d31d125016$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$5749e8d31d125016$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$5749e8d31d125016$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$5749e8d31d125016$var$Point.prototype.mul = function mul(k) {
    k = new $hpluo(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$5749e8d31d125016$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$5749e8d31d125016$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$5749e8d31d125016$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$5749e8d31d125016$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$5749e8d31d125016$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $5749e8d31d125016$var$JPoint(curve, x, y, z) {
    $lJPXx.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $hpluo(0);
    } else {
        this.x = new $hpluo(x, 16);
        this.y = new $hpluo(y, 16);
        this.z = new $hpluo(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dMzRp($5749e8d31d125016$var$JPoint, $lJPXx.BasePoint);
$5749e8d31d125016$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $5749e8d31d125016$var$JPoint(this, x, y, z);
};
$5749e8d31d125016$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$5749e8d31d125016$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$5749e8d31d125016$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$5749e8d31d125016$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$5749e8d31d125016$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$5749e8d31d125016$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$5749e8d31d125016$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$5749e8d31d125016$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$5749e8d31d125016$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$5749e8d31d125016$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$5749e8d31d125016$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $hpluo(k, kbase);
    return this.curve._wnafMul(this, k);
};
$5749e8d31d125016$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$5749e8d31d125016$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$5749e8d31d125016$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$5749e8d31d125016$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("ivHwc", function(module, exports) {
'use strict';

var $hpluo = parcelRequire("hpluo");


var $dMzRp = parcelRequire("dMzRp");


var $lJPXx = parcelRequire("lJPXx");


var $ljKeU = parcelRequire("ljKeU");

function $d79ce111e21d9494$var$MontCurve(conf) {
    $lJPXx.call(this, 'mont', conf);
    this.a = new $hpluo(conf.a, 16).toRed(this.red);
    this.b = new $hpluo(conf.b, 16).toRed(this.red);
    this.i4 = new $hpluo(4).toRed(this.red).redInvm();
    this.two = new $hpluo(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dMzRp($d79ce111e21d9494$var$MontCurve, $lJPXx);
module.exports = $d79ce111e21d9494$var$MontCurve;
$d79ce111e21d9494$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $d79ce111e21d9494$var$Point(curve, x, z) {
    $lJPXx.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $hpluo(x, 16);
        this.z = new $hpluo(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dMzRp($d79ce111e21d9494$var$Point, $lJPXx.BasePoint);
$d79ce111e21d9494$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($ljKeU.toArray(bytes, enc), 1);
};
$d79ce111e21d9494$var$MontCurve.prototype.point = function point(x, z) {
    return new $d79ce111e21d9494$var$Point(this, x, z);
};
$d79ce111e21d9494$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $d79ce111e21d9494$var$Point.fromJSON(this, obj);
};
$d79ce111e21d9494$var$Point.prototype.precompute = function precompute() {
// No-op
};
$d79ce111e21d9494$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$d79ce111e21d9494$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $d79ce111e21d9494$var$Point(curve, obj[0], obj[1] || curve.one);
};
$d79ce111e21d9494$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$d79ce111e21d9494$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$d79ce111e21d9494$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$d79ce111e21d9494$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$d79ce111e21d9494$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$d79ce111e21d9494$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$d79ce111e21d9494$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$d79ce111e21d9494$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$d79ce111e21d9494$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$d79ce111e21d9494$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$d79ce111e21d9494$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("lybDc", function(module, exports) {
'use strict';

var $ljKeU = parcelRequire("ljKeU");


var $hpluo = parcelRequire("hpluo");


var $dMzRp = parcelRequire("dMzRp");


var $lJPXx = parcelRequire("lJPXx");

var $fb05cba62a17b402$var$assert = $ljKeU.assert;
function $fb05cba62a17b402$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $lJPXx.call(this, 'edwards', conf);
    this.a = new $hpluo(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $hpluo(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $hpluo(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $fb05cba62a17b402$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dMzRp($fb05cba62a17b402$var$EdwardsCurve, $lJPXx);
module.exports = $fb05cba62a17b402$var$EdwardsCurve;
$fb05cba62a17b402$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$fb05cba62a17b402$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$fb05cba62a17b402$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$fb05cba62a17b402$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $hpluo(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$fb05cba62a17b402$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $hpluo(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$fb05cba62a17b402$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $fb05cba62a17b402$var$Point(curve, x, y, z, t) {
    $lJPXx.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $hpluo(x, 16);
        this.y = new $hpluo(y, 16);
        this.z = z ? new $hpluo(z, 16) : this.curve.one;
        this.t = t && new $hpluo(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dMzRp($fb05cba62a17b402$var$Point, $lJPXx.BasePoint);
$fb05cba62a17b402$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $fb05cba62a17b402$var$Point.fromJSON(this, obj);
};
$fb05cba62a17b402$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $fb05cba62a17b402$var$Point(this, x, y, z, t);
};
$fb05cba62a17b402$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $fb05cba62a17b402$var$Point(curve, obj[0], obj[1], obj[2]);
};
$fb05cba62a17b402$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$fb05cba62a17b402$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$fb05cba62a17b402$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$fb05cba62a17b402$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$fb05cba62a17b402$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$fb05cba62a17b402$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$fb05cba62a17b402$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$fb05cba62a17b402$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$fb05cba62a17b402$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$fb05cba62a17b402$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$fb05cba62a17b402$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$fb05cba62a17b402$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$fb05cba62a17b402$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$fb05cba62a17b402$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$fb05cba62a17b402$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$fb05cba62a17b402$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$fb05cba62a17b402$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$fb05cba62a17b402$var$Point.prototype.toP = $fb05cba62a17b402$var$Point.prototype.normalize;
$fb05cba62a17b402$var$Point.prototype.mixedAdd = $fb05cba62a17b402$var$Point.prototype.add;

});

parcelRegister("6DqYG", function(module, exports) {
'use strict';
var $4d4b4fd2f6ff8160$var$curves = module.exports;

var $52esc = parcelRequire("52esc");


var $fFhvD = parcelRequire("fFhvD");


var $ljKeU = parcelRequire("ljKeU");

var $4d4b4fd2f6ff8160$var$assert = $ljKeU.assert;
function $4d4b4fd2f6ff8160$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $fFhvD.short(options);
    else if (options.type === 'edwards') this.curve = new $fFhvD.edwards(options);
    else this.curve = new $fFhvD.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $4d4b4fd2f6ff8160$var$assert(this.g.validate(), 'Invalid curve');
    $4d4b4fd2f6ff8160$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$4d4b4fd2f6ff8160$var$curves.PresetCurve = $4d4b4fd2f6ff8160$var$PresetCurve;
function $4d4b4fd2f6ff8160$var$defineCurve(name, options) {
    Object.defineProperty($4d4b4fd2f6ff8160$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $4d4b4fd2f6ff8160$var$PresetCurve(options);
            Object.defineProperty($4d4b4fd2f6ff8160$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$4d4b4fd2f6ff8160$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $52esc.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$4d4b4fd2f6ff8160$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $52esc.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$4d4b4fd2f6ff8160$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $52esc.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$4d4b4fd2f6ff8160$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $52esc.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$4d4b4fd2f6ff8160$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $52esc.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$4d4b4fd2f6ff8160$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $52esc.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$4d4b4fd2f6ff8160$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $52esc.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $4d4b4fd2f6ff8160$var$pre;

try {
    $4d4b4fd2f6ff8160$var$pre = (parcelRequire("dvCLU"));
} catch (e) {
    $4d4b4fd2f6ff8160$var$pre = undefined;
}
$4d4b4fd2f6ff8160$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $52esc.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $4d4b4fd2f6ff8160$var$pre
    ]
});

});

parcelRegister("29p5P", function(module, exports) {
$parcel$export(module.exports, "inherits", () => $190fe2f5ac34ff92$export$69f1b2dcda23c5f8, (v) => $190fe2f5ac34ff92$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $190fe2f5ac34ff92$export$45b10814cc054894, (v) => $190fe2f5ac34ff92$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $190fe2f5ac34ff92$export$7ea66e3774a60b67, (v) => $190fe2f5ac34ff92$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $190fe2f5ac34ff92$export$34a52f00f601f6f1, (v) => $190fe2f5ac34ff92$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $190fe2f5ac34ff92$export$812b0cbd5e8a72ab, (v) => $190fe2f5ac34ff92$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $190fe2f5ac34ff92$export$f24f9e11d63bb314, (v) => $190fe2f5ac34ff92$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $190fe2f5ac34ff92$export$b71357c7e07ca1f1, (v) => $190fe2f5ac34ff92$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $190fe2f5ac34ff92$export$2e58a4b541fdcbe8, (v) => $190fe2f5ac34ff92$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $190fe2f5ac34ff92$export$183b950bde9faab8, (v) => $190fe2f5ac34ff92$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $190fe2f5ac34ff92$export$4785c77169fea59e, (v) => $190fe2f5ac34ff92$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $190fe2f5ac34ff92$export$242a185dfcffac5b, (v) => $190fe2f5ac34ff92$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $190fe2f5ac34ff92$export$58c04ae0ae31877d, (v) => $190fe2f5ac34ff92$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $190fe2f5ac34ff92$export$d058ca695f8c6f11, (v) => $190fe2f5ac34ff92$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $190fe2f5ac34ff92$export$a1efd7fc3e986367, (v) => $190fe2f5ac34ff92$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $190fe2f5ac34ff92$export$bbfea4a2b5abaab4, (v) => $190fe2f5ac34ff92$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $190fe2f5ac34ff92$export$97ad4afc7de86152, (v) => $190fe2f5ac34ff92$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $190fe2f5ac34ff92$export$ce4673d9a79f6a4b, (v) => $190fe2f5ac34ff92$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $190fe2f5ac34ff92$export$786cc99fc6eedc0b, (v) => $190fe2f5ac34ff92$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $190fe2f5ac34ff92$export$45c59b9a1848dd0, (v) => $190fe2f5ac34ff92$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $190fe2f5ac34ff92$export$50d8f613e76d3034, (v) => $190fe2f5ac34ff92$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $190fe2f5ac34ff92$export$b8e83683c60ee162, (v) => $190fe2f5ac34ff92$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $190fe2f5ac34ff92$export$aeeb51790d1bcc4a, (v) => $190fe2f5ac34ff92$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $190fe2f5ac34ff92$export$bb7c616f719ad9c, (v) => $190fe2f5ac34ff92$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $190fe2f5ac34ff92$export$4d63290824f9d7df, (v) => $190fe2f5ac34ff92$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $190fe2f5ac34ff92$export$2f64ceb90ef28ea1, (v) => $190fe2f5ac34ff92$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $190fe2f5ac34ff92$export$8d2089d465f6d10d, (v) => $190fe2f5ac34ff92$export$8d2089d465f6d10d = v);
var $190fe2f5ac34ff92$export$69f1b2dcda23c5f8;
var $190fe2f5ac34ff92$export$45b10814cc054894;
var $190fe2f5ac34ff92$export$7ea66e3774a60b67;
var $190fe2f5ac34ff92$export$34a52f00f601f6f1;
var $190fe2f5ac34ff92$export$812b0cbd5e8a72ab;
var $190fe2f5ac34ff92$export$f24f9e11d63bb314;
var $190fe2f5ac34ff92$export$b71357c7e07ca1f1;
var $190fe2f5ac34ff92$export$2e58a4b541fdcbe8;
var $190fe2f5ac34ff92$export$183b950bde9faab8;
var $190fe2f5ac34ff92$export$4785c77169fea59e;
var $190fe2f5ac34ff92$export$242a185dfcffac5b;
var $190fe2f5ac34ff92$export$58c04ae0ae31877d;
var $190fe2f5ac34ff92$export$d058ca695f8c6f11;
var $190fe2f5ac34ff92$export$a1efd7fc3e986367;
var $190fe2f5ac34ff92$export$bbfea4a2b5abaab4;
var $190fe2f5ac34ff92$export$97ad4afc7de86152;
var $190fe2f5ac34ff92$export$ce4673d9a79f6a4b;
var $190fe2f5ac34ff92$export$786cc99fc6eedc0b;
var $190fe2f5ac34ff92$export$45c59b9a1848dd0;
var $190fe2f5ac34ff92$export$50d8f613e76d3034;
var $190fe2f5ac34ff92$export$b8e83683c60ee162;
var $190fe2f5ac34ff92$export$aeeb51790d1bcc4a;
var $190fe2f5ac34ff92$export$bb7c616f719ad9c;
var $190fe2f5ac34ff92$export$4d63290824f9d7df;
var $190fe2f5ac34ff92$export$2f64ceb90ef28ea1;
var $190fe2f5ac34ff92$export$8d2089d465f6d10d;
'use strict';

var $gLTb0 = parcelRequire("gLTb0");


var $dMzRp = parcelRequire("dMzRp");

$190fe2f5ac34ff92$export$69f1b2dcda23c5f8 = $dMzRp;
function $190fe2f5ac34ff92$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $190fe2f5ac34ff92$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($190fe2f5ac34ff92$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$190fe2f5ac34ff92$export$45b10814cc054894 = $190fe2f5ac34ff92$var$toArray;
function $190fe2f5ac34ff92$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $190fe2f5ac34ff92$var$zero2(msg[i].toString(16));
    return res;
}
$190fe2f5ac34ff92$export$7ea66e3774a60b67 = $190fe2f5ac34ff92$var$toHex;
function $190fe2f5ac34ff92$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$190fe2f5ac34ff92$export$34a52f00f601f6f1 = $190fe2f5ac34ff92$var$htonl;
function $190fe2f5ac34ff92$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $190fe2f5ac34ff92$var$htonl(w);
        res += $190fe2f5ac34ff92$var$zero8(w.toString(16));
    }
    return res;
}
$190fe2f5ac34ff92$export$812b0cbd5e8a72ab = $190fe2f5ac34ff92$var$toHex32;
function $190fe2f5ac34ff92$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$190fe2f5ac34ff92$export$f24f9e11d63bb314 = $190fe2f5ac34ff92$var$zero2;
function $190fe2f5ac34ff92$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$190fe2f5ac34ff92$export$b71357c7e07ca1f1 = $190fe2f5ac34ff92$var$zero8;
function $190fe2f5ac34ff92$var$join32(msg, start, end, endian) {
    var len = end - start;
    $gLTb0(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$190fe2f5ac34ff92$export$2e58a4b541fdcbe8 = $190fe2f5ac34ff92$var$join32;
function $190fe2f5ac34ff92$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$190fe2f5ac34ff92$export$183b950bde9faab8 = $190fe2f5ac34ff92$var$split32;
function $190fe2f5ac34ff92$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$190fe2f5ac34ff92$export$4785c77169fea59e = $190fe2f5ac34ff92$var$rotr32;
function $190fe2f5ac34ff92$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$190fe2f5ac34ff92$export$242a185dfcffac5b = $190fe2f5ac34ff92$var$rotl32;
function $190fe2f5ac34ff92$var$sum32(a, b) {
    return a + b >>> 0;
}
$190fe2f5ac34ff92$export$58c04ae0ae31877d = $190fe2f5ac34ff92$var$sum32;
function $190fe2f5ac34ff92$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$190fe2f5ac34ff92$export$d058ca695f8c6f11 = $190fe2f5ac34ff92$var$sum32_3;
function $190fe2f5ac34ff92$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$190fe2f5ac34ff92$export$a1efd7fc3e986367 = $190fe2f5ac34ff92$var$sum32_4;
function $190fe2f5ac34ff92$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$190fe2f5ac34ff92$export$bbfea4a2b5abaab4 = $190fe2f5ac34ff92$var$sum32_5;
function $190fe2f5ac34ff92$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$190fe2f5ac34ff92$export$97ad4afc7de86152 = $190fe2f5ac34ff92$var$sum64;
function $190fe2f5ac34ff92$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$190fe2f5ac34ff92$export$ce4673d9a79f6a4b = $190fe2f5ac34ff92$var$sum64_hi;
function $190fe2f5ac34ff92$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$190fe2f5ac34ff92$export$786cc99fc6eedc0b = $190fe2f5ac34ff92$var$sum64_lo;
function $190fe2f5ac34ff92$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$190fe2f5ac34ff92$export$45c59b9a1848dd0 = $190fe2f5ac34ff92$var$sum64_4_hi;
function $190fe2f5ac34ff92$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$190fe2f5ac34ff92$export$50d8f613e76d3034 = $190fe2f5ac34ff92$var$sum64_4_lo;
function $190fe2f5ac34ff92$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$190fe2f5ac34ff92$export$b8e83683c60ee162 = $190fe2f5ac34ff92$var$sum64_5_hi;
function $190fe2f5ac34ff92$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$190fe2f5ac34ff92$export$aeeb51790d1bcc4a = $190fe2f5ac34ff92$var$sum64_5_lo;
function $190fe2f5ac34ff92$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$190fe2f5ac34ff92$export$bb7c616f719ad9c = $190fe2f5ac34ff92$var$rotr64_hi;
function $190fe2f5ac34ff92$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$190fe2f5ac34ff92$export$4d63290824f9d7df = $190fe2f5ac34ff92$var$rotr64_lo;
function $190fe2f5ac34ff92$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$190fe2f5ac34ff92$export$2f64ceb90ef28ea1 = $190fe2f5ac34ff92$var$shr64_hi;
function $190fe2f5ac34ff92$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$190fe2f5ac34ff92$export$8d2089d465f6d10d = $190fe2f5ac34ff92$var$shr64_lo;

});

parcelRegister("cxiAS", function(module, exports) {
$parcel$export(module.exports, "BlockHash", () => $9206fd739ffdcd5d$export$8687658379b577e6, (v) => $9206fd739ffdcd5d$export$8687658379b577e6 = v);
var $9206fd739ffdcd5d$export$8687658379b577e6;
'use strict';

var $29p5P = parcelRequire("29p5P");


var $gLTb0 = parcelRequire("gLTb0");

function $9206fd739ffdcd5d$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$9206fd739ffdcd5d$export$8687658379b577e6 = $9206fd739ffdcd5d$var$BlockHash;
$9206fd739ffdcd5d$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $29p5P.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $29p5P.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$9206fd739ffdcd5d$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $gLTb0(this.pending === null);
    return this._digest(enc);
};
$9206fd739ffdcd5d$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("8lXl4", function(module, exports) {
$parcel$export(module.exports, "sha1", () => $614e50563dda986c$export$5091bdda49ba90f5, (v) => $614e50563dda986c$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $614e50563dda986c$export$97b70509d4e397ea, (v) => $614e50563dda986c$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $614e50563dda986c$export$bced8d2aada2d1c9, (v) => $614e50563dda986c$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $614e50563dda986c$export$612d47d55dedde45, (v) => $614e50563dda986c$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $614e50563dda986c$export$a888d2532e6dc7bb, (v) => $614e50563dda986c$export$a888d2532e6dc7bb = v);
var $614e50563dda986c$export$5091bdda49ba90f5;
var $614e50563dda986c$export$97b70509d4e397ea;
var $614e50563dda986c$export$bced8d2aada2d1c9;
var $614e50563dda986c$export$612d47d55dedde45;
var $614e50563dda986c$export$a888d2532e6dc7bb;
'use strict';

$614e50563dda986c$export$5091bdda49ba90f5 = (parcelRequire("30Ahp"));

$614e50563dda986c$export$97b70509d4e397ea = (parcelRequire("bH7GZ"));

$614e50563dda986c$export$bced8d2aada2d1c9 = (parcelRequire("4eGeY"));

$614e50563dda986c$export$612d47d55dedde45 = (parcelRequire("3w5Uw"));

$614e50563dda986c$export$a888d2532e6dc7bb = (parcelRequire("3xWLw"));

});

parcelRegister("30Ahp", function(module, exports) {
'use strict';

var $29p5P = parcelRequire("29p5P");


var $cxiAS = parcelRequire("cxiAS");


var $48OKc = parcelRequire("48OKc");

var $230d839ce151c71d$var$rotl32 = $29p5P.rotl32;
var $230d839ce151c71d$var$sum32 = $29p5P.sum32;
var $230d839ce151c71d$var$sum32_5 = $29p5P.sum32_5;
var $230d839ce151c71d$var$ft_1 = $48OKc.ft_1;
var $230d839ce151c71d$var$BlockHash = $cxiAS.BlockHash;
var $230d839ce151c71d$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $230d839ce151c71d$var$SHA1() {
    if (!(this instanceof $230d839ce151c71d$var$SHA1)) return new $230d839ce151c71d$var$SHA1();
    $230d839ce151c71d$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$29p5P.inherits($230d839ce151c71d$var$SHA1, $230d839ce151c71d$var$BlockHash);
module.exports = $230d839ce151c71d$var$SHA1;
$230d839ce151c71d$var$SHA1.blockSize = 512;
$230d839ce151c71d$var$SHA1.outSize = 160;
$230d839ce151c71d$var$SHA1.hmacStrength = 80;
$230d839ce151c71d$var$SHA1.padLength = 64;
$230d839ce151c71d$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $230d839ce151c71d$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $230d839ce151c71d$var$sum32_5($230d839ce151c71d$var$rotl32(a, 5), $230d839ce151c71d$var$ft_1(s, b, c, d), e, W[i], $230d839ce151c71d$var$sha1_K[s]);
        e = d;
        d = c;
        c = $230d839ce151c71d$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $230d839ce151c71d$var$sum32(this.h[0], a);
    this.h[1] = $230d839ce151c71d$var$sum32(this.h[1], b);
    this.h[2] = $230d839ce151c71d$var$sum32(this.h[2], c);
    this.h[3] = $230d839ce151c71d$var$sum32(this.h[3], d);
    this.h[4] = $230d839ce151c71d$var$sum32(this.h[4], e);
};
$230d839ce151c71d$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $29p5P.toHex32(this.h, 'big');
    else return $29p5P.split32(this.h, 'big');
};

});

parcelRegister("bH7GZ", function(module, exports) {
'use strict';

var $29p5P = parcelRequire("29p5P");


var $4eGeY = parcelRequire("4eGeY");

function $8839ad6b6ba5f76a$var$SHA224() {
    if (!(this instanceof $8839ad6b6ba5f76a$var$SHA224)) return new $8839ad6b6ba5f76a$var$SHA224();
    $4eGeY.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$29p5P.inherits($8839ad6b6ba5f76a$var$SHA224, $4eGeY);
module.exports = $8839ad6b6ba5f76a$var$SHA224;
$8839ad6b6ba5f76a$var$SHA224.blockSize = 512;
$8839ad6b6ba5f76a$var$SHA224.outSize = 224;
$8839ad6b6ba5f76a$var$SHA224.hmacStrength = 192;
$8839ad6b6ba5f76a$var$SHA224.padLength = 64;
$8839ad6b6ba5f76a$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $29p5P.toHex32(this.h.slice(0, 7), 'big');
    else return $29p5P.split32(this.h.slice(0, 7), 'big');
};

});

parcelRegister("4eGeY", function(module, exports) {
'use strict';

var $29p5P = parcelRequire("29p5P");


var $cxiAS = parcelRequire("cxiAS");


var $48OKc = parcelRequire("48OKc");


var $gLTb0 = parcelRequire("gLTb0");

var $31593c520290c592$var$sum32 = $29p5P.sum32;
var $31593c520290c592$var$sum32_4 = $29p5P.sum32_4;
var $31593c520290c592$var$sum32_5 = $29p5P.sum32_5;
var $31593c520290c592$var$ch32 = $48OKc.ch32;
var $31593c520290c592$var$maj32 = $48OKc.maj32;
var $31593c520290c592$var$s0_256 = $48OKc.s0_256;
var $31593c520290c592$var$s1_256 = $48OKc.s1_256;
var $31593c520290c592$var$g0_256 = $48OKc.g0_256;
var $31593c520290c592$var$g1_256 = $48OKc.g1_256;
var $31593c520290c592$var$BlockHash = $cxiAS.BlockHash;
var $31593c520290c592$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $31593c520290c592$var$SHA256() {
    if (!(this instanceof $31593c520290c592$var$SHA256)) return new $31593c520290c592$var$SHA256();
    $31593c520290c592$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $31593c520290c592$var$sha256_K;
    this.W = new Array(64);
}
$29p5P.inherits($31593c520290c592$var$SHA256, $31593c520290c592$var$BlockHash);
module.exports = $31593c520290c592$var$SHA256;
$31593c520290c592$var$SHA256.blockSize = 512;
$31593c520290c592$var$SHA256.outSize = 256;
$31593c520290c592$var$SHA256.hmacStrength = 192;
$31593c520290c592$var$SHA256.padLength = 64;
$31593c520290c592$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $31593c520290c592$var$sum32_4($31593c520290c592$var$g1_256(W[i - 2]), W[i - 7], $31593c520290c592$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $gLTb0(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $31593c520290c592$var$sum32_5(h, $31593c520290c592$var$s1_256(e), $31593c520290c592$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $31593c520290c592$var$sum32($31593c520290c592$var$s0_256(a), $31593c520290c592$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $31593c520290c592$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $31593c520290c592$var$sum32(T1, T2);
    }
    this.h[0] = $31593c520290c592$var$sum32(this.h[0], a);
    this.h[1] = $31593c520290c592$var$sum32(this.h[1], b);
    this.h[2] = $31593c520290c592$var$sum32(this.h[2], c);
    this.h[3] = $31593c520290c592$var$sum32(this.h[3], d);
    this.h[4] = $31593c520290c592$var$sum32(this.h[4], e);
    this.h[5] = $31593c520290c592$var$sum32(this.h[5], f);
    this.h[6] = $31593c520290c592$var$sum32(this.h[6], g);
    this.h[7] = $31593c520290c592$var$sum32(this.h[7], h);
};
$31593c520290c592$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $29p5P.toHex32(this.h, 'big');
    else return $29p5P.split32(this.h, 'big');
};

});

parcelRegister("3w5Uw", function(module, exports) {
'use strict';

var $29p5P = parcelRequire("29p5P");


var $3xWLw = parcelRequire("3xWLw");

function $28f8f1fba7726651$var$SHA384() {
    if (!(this instanceof $28f8f1fba7726651$var$SHA384)) return new $28f8f1fba7726651$var$SHA384();
    $3xWLw.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$29p5P.inherits($28f8f1fba7726651$var$SHA384, $3xWLw);
module.exports = $28f8f1fba7726651$var$SHA384;
$28f8f1fba7726651$var$SHA384.blockSize = 1024;
$28f8f1fba7726651$var$SHA384.outSize = 384;
$28f8f1fba7726651$var$SHA384.hmacStrength = 192;
$28f8f1fba7726651$var$SHA384.padLength = 128;
$28f8f1fba7726651$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $29p5P.toHex32(this.h.slice(0, 12), 'big');
    else return $29p5P.split32(this.h.slice(0, 12), 'big');
};

});

parcelRegister("3xWLw", function(module, exports) {
'use strict';

var $29p5P = parcelRequire("29p5P");


var $cxiAS = parcelRequire("cxiAS");


var $gLTb0 = parcelRequire("gLTb0");

var $295209be13d76331$var$rotr64_hi = $29p5P.rotr64_hi;
var $295209be13d76331$var$rotr64_lo = $29p5P.rotr64_lo;
var $295209be13d76331$var$shr64_hi = $29p5P.shr64_hi;
var $295209be13d76331$var$shr64_lo = $29p5P.shr64_lo;
var $295209be13d76331$var$sum64 = $29p5P.sum64;
var $295209be13d76331$var$sum64_hi = $29p5P.sum64_hi;
var $295209be13d76331$var$sum64_lo = $29p5P.sum64_lo;
var $295209be13d76331$var$sum64_4_hi = $29p5P.sum64_4_hi;
var $295209be13d76331$var$sum64_4_lo = $29p5P.sum64_4_lo;
var $295209be13d76331$var$sum64_5_hi = $29p5P.sum64_5_hi;
var $295209be13d76331$var$sum64_5_lo = $29p5P.sum64_5_lo;
var $295209be13d76331$var$BlockHash = $cxiAS.BlockHash;
var $295209be13d76331$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $295209be13d76331$var$SHA512() {
    if (!(this instanceof $295209be13d76331$var$SHA512)) return new $295209be13d76331$var$SHA512();
    $295209be13d76331$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $295209be13d76331$var$sha512_K;
    this.W = new Array(160);
}
$29p5P.inherits($295209be13d76331$var$SHA512, $295209be13d76331$var$BlockHash);
module.exports = $295209be13d76331$var$SHA512;
$295209be13d76331$var$SHA512.blockSize = 1024;
$295209be13d76331$var$SHA512.outSize = 512;
$295209be13d76331$var$SHA512.hmacStrength = 192;
$295209be13d76331$var$SHA512.padLength = 128;
$295209be13d76331$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $295209be13d76331$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $295209be13d76331$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $295209be13d76331$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $295209be13d76331$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $295209be13d76331$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $295209be13d76331$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$295209be13d76331$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $gLTb0(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $295209be13d76331$var$s1_512_hi(eh, el);
        var c1_lo = $295209be13d76331$var$s1_512_lo(eh, el);
        var c2_hi = $295209be13d76331$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $295209be13d76331$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $295209be13d76331$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $295209be13d76331$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $295209be13d76331$var$s0_512_hi(ah, al);
        c0_lo = $295209be13d76331$var$s0_512_lo(ah, al);
        c1_hi = $295209be13d76331$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $295209be13d76331$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $295209be13d76331$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $295209be13d76331$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $295209be13d76331$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $295209be13d76331$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $295209be13d76331$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $295209be13d76331$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $295209be13d76331$var$sum64(this.h, 0, ah, al);
    $295209be13d76331$var$sum64(this.h, 2, bh, bl);
    $295209be13d76331$var$sum64(this.h, 4, ch, cl);
    $295209be13d76331$var$sum64(this.h, 6, dh, dl);
    $295209be13d76331$var$sum64(this.h, 8, eh, el);
    $295209be13d76331$var$sum64(this.h, 10, fh, fl);
    $295209be13d76331$var$sum64(this.h, 12, gh, gl);
    $295209be13d76331$var$sum64(this.h, 14, hh, hl);
};
$295209be13d76331$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $29p5P.toHex32(this.h, 'big');
    else return $29p5P.split32(this.h, 'big');
};
function $295209be13d76331$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $295209be13d76331$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $295209be13d76331$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $295209be13d76331$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $295209be13d76331$var$s0_512_hi(xh, xl) {
    var c0_hi = $295209be13d76331$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $295209be13d76331$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $295209be13d76331$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $295209be13d76331$var$s0_512_lo(xh, xl) {
    var c0_lo = $295209be13d76331$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $295209be13d76331$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $295209be13d76331$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $295209be13d76331$var$s1_512_hi(xh, xl) {
    var c0_hi = $295209be13d76331$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $295209be13d76331$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $295209be13d76331$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $295209be13d76331$var$s1_512_lo(xh, xl) {
    var c0_lo = $295209be13d76331$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $295209be13d76331$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $295209be13d76331$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $295209be13d76331$var$g0_512_hi(xh, xl) {
    var c0_hi = $295209be13d76331$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $295209be13d76331$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $295209be13d76331$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $295209be13d76331$var$g0_512_lo(xh, xl) {
    var c0_lo = $295209be13d76331$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $295209be13d76331$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $295209be13d76331$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $295209be13d76331$var$g1_512_hi(xh, xl) {
    var c0_hi = $295209be13d76331$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $295209be13d76331$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $295209be13d76331$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $295209be13d76331$var$g1_512_lo(xh, xl) {
    var c0_lo = $295209be13d76331$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $295209be13d76331$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $295209be13d76331$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});

parcelRegister("keqck", function(module, exports) {
$parcel$export(module.exports, "ripemd160", () => $eba96fcbbc18b6ce$export$d1cea0ee4e3f0d3e, (v) => $eba96fcbbc18b6ce$export$d1cea0ee4e3f0d3e = v);
var $eba96fcbbc18b6ce$export$d1cea0ee4e3f0d3e;
'use strict';

var $29p5P = parcelRequire("29p5P");


var $cxiAS = parcelRequire("cxiAS");

var $eba96fcbbc18b6ce$var$rotl32 = $29p5P.rotl32;
var $eba96fcbbc18b6ce$var$sum32 = $29p5P.sum32;
var $eba96fcbbc18b6ce$var$sum32_3 = $29p5P.sum32_3;
var $eba96fcbbc18b6ce$var$sum32_4 = $29p5P.sum32_4;
var $eba96fcbbc18b6ce$var$BlockHash = $cxiAS.BlockHash;
function $eba96fcbbc18b6ce$var$RIPEMD160() {
    if (!(this instanceof $eba96fcbbc18b6ce$var$RIPEMD160)) return new $eba96fcbbc18b6ce$var$RIPEMD160();
    $eba96fcbbc18b6ce$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$29p5P.inherits($eba96fcbbc18b6ce$var$RIPEMD160, $eba96fcbbc18b6ce$var$BlockHash);
$eba96fcbbc18b6ce$export$d1cea0ee4e3f0d3e = $eba96fcbbc18b6ce$var$RIPEMD160;
$eba96fcbbc18b6ce$var$RIPEMD160.blockSize = 512;
$eba96fcbbc18b6ce$var$RIPEMD160.outSize = 160;
$eba96fcbbc18b6ce$var$RIPEMD160.hmacStrength = 192;
$eba96fcbbc18b6ce$var$RIPEMD160.padLength = 64;
$eba96fcbbc18b6ce$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $eba96fcbbc18b6ce$var$sum32($eba96fcbbc18b6ce$var$rotl32($eba96fcbbc18b6ce$var$sum32_4(A, $eba96fcbbc18b6ce$var$f(j, B, C, D), msg[$eba96fcbbc18b6ce$var$r[j] + start], $eba96fcbbc18b6ce$var$K(j)), $eba96fcbbc18b6ce$var$s[j]), E);
        A = E;
        E = D;
        D = $eba96fcbbc18b6ce$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $eba96fcbbc18b6ce$var$sum32($eba96fcbbc18b6ce$var$rotl32($eba96fcbbc18b6ce$var$sum32_4(Ah, $eba96fcbbc18b6ce$var$f(79 - j, Bh, Ch, Dh), msg[$eba96fcbbc18b6ce$var$rh[j] + start], $eba96fcbbc18b6ce$var$Kh(j)), $eba96fcbbc18b6ce$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $eba96fcbbc18b6ce$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $eba96fcbbc18b6ce$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $eba96fcbbc18b6ce$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $eba96fcbbc18b6ce$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $eba96fcbbc18b6ce$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $eba96fcbbc18b6ce$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$eba96fcbbc18b6ce$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $29p5P.toHex32(this.h, 'little');
    else return $29p5P.split32(this.h, 'little');
};
function $eba96fcbbc18b6ce$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $eba96fcbbc18b6ce$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $eba96fcbbc18b6ce$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $eba96fcbbc18b6ce$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $eba96fcbbc18b6ce$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $eba96fcbbc18b6ce$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $eba96fcbbc18b6ce$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("7SPJd", function(module, exports) {
'use strict';

var $29p5P = parcelRequire("29p5P");


var $gLTb0 = parcelRequire("gLTb0");

function $5bd5b3bb2470a70a$var$Hmac(hash, key, enc) {
    if (!(this instanceof $5bd5b3bb2470a70a$var$Hmac)) return new $5bd5b3bb2470a70a$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($29p5P.toArray(key, enc));
}
module.exports = $5bd5b3bb2470a70a$var$Hmac;
$5bd5b3bb2470a70a$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $gLTb0(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$5bd5b3bb2470a70a$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$5bd5b3bb2470a70a$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});

parcelRegister("dvCLU", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});

parcelRegister("kiFNt", function(module, exports) {
'use strict';

var $hpluo = parcelRequire("hpluo");

var $c888488be55408fc$exports = {};
'use strict';

var $52esc = parcelRequire("52esc");


var $hjBPv = parcelRequire("hjBPv");


var $gLTb0 = parcelRequire("gLTb0");

function $c888488be55408fc$var$HmacDRBG(options) {
    if (!(this instanceof $c888488be55408fc$var$HmacDRBG)) return new $c888488be55408fc$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $hjBPv.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $hjBPv.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $hjBPv.toArray(options.pers, options.persEnc || 'hex');
    $gLTb0(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
$c888488be55408fc$exports = $c888488be55408fc$var$HmacDRBG;
$c888488be55408fc$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$c888488be55408fc$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $52esc.hmac(this.hash, this.K);
};
$c888488be55408fc$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$c888488be55408fc$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $hjBPv.toArray(entropy, entropyEnc);
    add = $hjBPv.toArray(add, addEnc);
    $gLTb0(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$c888488be55408fc$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $hjBPv.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $hjBPv.encode(res, enc);
};



var $ljKeU = parcelRequire("ljKeU");


var $6DqYG = parcelRequire("6DqYG");


var $7VcJI = parcelRequire("7VcJI");

var $ec75e91dc1874054$var$assert = $ljKeU.assert;
var $86dca4639570f7c0$exports = {};
'use strict';






var $86dca4639570f7c0$var$assert = $ljKeU.assert;
function $86dca4639570f7c0$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
$86dca4639570f7c0$exports = $86dca4639570f7c0$var$KeyPair;
$86dca4639570f7c0$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $86dca4639570f7c0$var$KeyPair) return pub;
    return new $86dca4639570f7c0$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$86dca4639570f7c0$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $86dca4639570f7c0$var$KeyPair) return priv;
    return new $86dca4639570f7c0$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$86dca4639570f7c0$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$86dca4639570f7c0$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$86dca4639570f7c0$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$86dca4639570f7c0$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $hpluo(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$86dca4639570f7c0$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $86dca4639570f7c0$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $86dca4639570f7c0$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$86dca4639570f7c0$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $86dca4639570f7c0$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$86dca4639570f7c0$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$86dca4639570f7c0$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$86dca4639570f7c0$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


var $998b412c5350e2c0$exports = {};
'use strict';






var $998b412c5350e2c0$var$assert = $ljKeU.assert;
function $998b412c5350e2c0$var$Signature(options, enc) {
    if (options instanceof $998b412c5350e2c0$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $998b412c5350e2c0$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $hpluo(options.r, 16);
    this.s = new $hpluo(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
$998b412c5350e2c0$exports = $998b412c5350e2c0$var$Signature;
function $998b412c5350e2c0$var$Position() {
    this.place = 0;
}
function $998b412c5350e2c0$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $998b412c5350e2c0$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$998b412c5350e2c0$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $ljKeU.toArray(data, enc);
    var p = new $998b412c5350e2c0$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $998b412c5350e2c0$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $998b412c5350e2c0$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $998b412c5350e2c0$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $hpluo(r);
    this.s = new $hpluo(s);
    this.recoveryParam = null;
    return true;
};
function $998b412c5350e2c0$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$998b412c5350e2c0$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $998b412c5350e2c0$var$rmPadding(r);
    s = $998b412c5350e2c0$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $998b412c5350e2c0$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $998b412c5350e2c0$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $998b412c5350e2c0$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $ljKeU.encode(res, enc);
};


function $ec75e91dc1874054$var$EC(options) {
    if (!(this instanceof $ec75e91dc1874054$var$EC)) return new $ec75e91dc1874054$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $ec75e91dc1874054$var$assert(Object.prototype.hasOwnProperty.call($6DqYG, options), 'Unknown curve ' + options);
        options = $6DqYG[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $6DqYG.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $ec75e91dc1874054$var$EC;
$ec75e91dc1874054$var$EC.prototype.keyPair = function keyPair(options) {
    return new $86dca4639570f7c0$exports(this, options);
};
$ec75e91dc1874054$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $86dca4639570f7c0$exports.fromPrivate(this, priv, enc);
};
$ec75e91dc1874054$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $86dca4639570f7c0$exports.fromPublic(this, pub, enc);
};
$ec75e91dc1874054$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $c888488be55408fc$exports({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $7VcJI(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $hpluo(2));
    for(;;){
        var priv = new $hpluo(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$ec75e91dc1874054$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($hpluo.isBN(msg) || typeof msg === 'number') {
        msg = new $hpluo(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $hpluo(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $hpluo(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$ec75e91dc1874054$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$hpluo.isBN(msg)) {
        $ec75e91dc1874054$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $ec75e91dc1874054$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$ec75e91dc1874054$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $ec75e91dc1874054$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $ec75e91dc1874054$var$assert(new $hpluo(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $c888488be55408fc$exports({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $hpluo(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $hpluo(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $998b412c5350e2c0$exports({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$ec75e91dc1874054$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $998b412c5350e2c0$exports(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$ec75e91dc1874054$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $ec75e91dc1874054$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $998b412c5350e2c0$exports(signature, enc);
    var n = this.n;
    var e = new $hpluo(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$ec75e91dc1874054$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $998b412c5350e2c0$exports(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});

parcelRegister("7XMT8", function(module, exports) {
'use strict';

var $52esc = parcelRequire("52esc");


var $6DqYG = parcelRequire("6DqYG");


var $ljKeU = parcelRequire("ljKeU");

var $5cc3f7424fe0277d$var$assert = $ljKeU.assert;
var $5cc3f7424fe0277d$var$parseBytes = $ljKeU.parseBytes;
var $8c7126363d301d9c$exports = {};
'use strict';



var $8c7126363d301d9c$var$assert = $ljKeU.assert;
var $8c7126363d301d9c$var$parseBytes = $ljKeU.parseBytes;
var $8c7126363d301d9c$var$cachedProperty = $ljKeU.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $8c7126363d301d9c$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $8c7126363d301d9c$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $8c7126363d301d9c$var$parseBytes(params.pub);
}
$8c7126363d301d9c$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $8c7126363d301d9c$var$KeyPair) return pub;
    return new $8c7126363d301d9c$var$KeyPair(eddsa, {
        pub: pub
    });
};
$8c7126363d301d9c$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $8c7126363d301d9c$var$KeyPair) return secret;
    return new $8c7126363d301d9c$var$KeyPair(eddsa, {
        secret: secret
    });
};
$8c7126363d301d9c$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$8c7126363d301d9c$var$cachedProperty($8c7126363d301d9c$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$8c7126363d301d9c$var$cachedProperty($8c7126363d301d9c$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$8c7126363d301d9c$var$cachedProperty($8c7126363d301d9c$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$8c7126363d301d9c$var$cachedProperty($8c7126363d301d9c$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$8c7126363d301d9c$var$cachedProperty($8c7126363d301d9c$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$8c7126363d301d9c$var$cachedProperty($8c7126363d301d9c$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$8c7126363d301d9c$var$KeyPair.prototype.sign = function sign(message) {
    $8c7126363d301d9c$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$8c7126363d301d9c$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$8c7126363d301d9c$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $8c7126363d301d9c$var$assert(this._secret, 'KeyPair is public only');
    return $ljKeU.encode(this.secret(), enc);
};
$8c7126363d301d9c$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $ljKeU.encode(this.pubBytes(), enc);
};
$8c7126363d301d9c$exports = $8c7126363d301d9c$var$KeyPair;


var $ae74a6c181c747e2$exports = {};
'use strict';

var $hpluo = parcelRequire("hpluo");




var $ae74a6c181c747e2$var$assert = $ljKeU.assert;
var $ae74a6c181c747e2$var$cachedProperty = $ljKeU.cachedProperty;
var $ae74a6c181c747e2$var$parseBytes = $ljKeU.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $ae74a6c181c747e2$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $ae74a6c181c747e2$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $ae74a6c181c747e2$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $ae74a6c181c747e2$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $hpluo) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$ae74a6c181c747e2$var$cachedProperty($ae74a6c181c747e2$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$ae74a6c181c747e2$var$cachedProperty($ae74a6c181c747e2$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$ae74a6c181c747e2$var$cachedProperty($ae74a6c181c747e2$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$ae74a6c181c747e2$var$cachedProperty($ae74a6c181c747e2$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$ae74a6c181c747e2$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$ae74a6c181c747e2$var$Signature.prototype.toHex = function toHex() {
    return $ljKeU.encode(this.toBytes(), 'hex').toUpperCase();
};
$ae74a6c181c747e2$exports = $ae74a6c181c747e2$var$Signature;


function $5cc3f7424fe0277d$var$EDDSA(curve) {
    $5cc3f7424fe0277d$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $5cc3f7424fe0277d$var$EDDSA)) return new $5cc3f7424fe0277d$var$EDDSA(curve);
    curve = $6DqYG[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $52esc.sha512;
}
module.exports = $5cc3f7424fe0277d$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $5cc3f7424fe0277d$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $5cc3f7424fe0277d$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $5cc3f7424fe0277d$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $5cc3f7424fe0277d$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$5cc3f7424fe0277d$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $ljKeU.intFromLE(hash.digest()).umod(this.curve.n);
};
$5cc3f7424fe0277d$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $8c7126363d301d9c$exports.fromPublic(this, pub);
};
$5cc3f7424fe0277d$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $8c7126363d301d9c$exports.fromSecret(this, secret);
};
$5cc3f7424fe0277d$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $ae74a6c181c747e2$exports) return sig;
    return new $ae74a6c181c747e2$exports(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $5cc3f7424fe0277d$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$5cc3f7424fe0277d$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $ljKeU.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $ljKeU.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$5cc3f7424fe0277d$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$5cc3f7424fe0277d$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $ljKeU.intFromLE(bytes);
};
$5cc3f7424fe0277d$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});

parcelRegister("j3uQG", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("h1hUh")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("4PflA", function(module, exports) {

var $k3MQ7 = parcelRequire("k3MQ7");


var $dMzRp = parcelRequire("dMzRp");

var $3837d479e097a031$var$api = module.exports;
$3837d479e097a031$var$api.define = function define(name, body) {
    return new $3837d479e097a031$var$Entity(name, body);
};
function $3837d479e097a031$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$3837d479e097a031$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("ikSub")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $dMzRp(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$3837d479e097a031$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($k3MQ7.decoders[enc]);
    return this.decoders[enc];
};
$3837d479e097a031$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$3837d479e097a031$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($k3MQ7.encoders[enc]);
    return this.encoders[enc];
};
$3837d479e097a031$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});

parcelRegister("ikSub", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});

parcelRegister("aTE7O", function(module, exports) {
var $7eee2a6b30858784$var$base = module.exports;

$7eee2a6b30858784$var$base.Reporter = (parcelRequire("2hHYN")).Reporter;

$7eee2a6b30858784$var$base.DecoderBuffer = (parcelRequire("7zZey")).DecoderBuffer;

$7eee2a6b30858784$var$base.EncoderBuffer = (parcelRequire("7zZey")).EncoderBuffer;

$7eee2a6b30858784$var$base.Node = (parcelRequire("cJkT9"));

});

parcelRegister("2hHYN", function(module, exports) {
$parcel$export(module.exports, "Reporter", () => $1a9f48bb0591c761$export$957313a2f485e5ed, (v) => $1a9f48bb0591c761$export$957313a2f485e5ed = v);
var $1a9f48bb0591c761$export$957313a2f485e5ed;

var $dMzRp = parcelRequire("dMzRp");

function $1a9f48bb0591c761$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$1a9f48bb0591c761$export$957313a2f485e5ed = $1a9f48bb0591c761$var$Reporter;
$1a9f48bb0591c761$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $1a9f48bb0591c761$var$ReporterError;
};
$1a9f48bb0591c761$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$1a9f48bb0591c761$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$1a9f48bb0591c761$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$1a9f48bb0591c761$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$1a9f48bb0591c761$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$1a9f48bb0591c761$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$1a9f48bb0591c761$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$1a9f48bb0591c761$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$1a9f48bb0591c761$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $1a9f48bb0591c761$var$ReporterError;
    if (inherited) err = msg;
    else err = new $1a9f48bb0591c761$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$1a9f48bb0591c761$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $1a9f48bb0591c761$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dMzRp($1a9f48bb0591c761$var$ReporterError, Error);
$1a9f48bb0591c761$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $1a9f48bb0591c761$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("7zZey", function(module, exports) {
$parcel$export(module.exports, "DecoderBuffer", () => $584b4d02374cae9e$export$bf9f79cdc4a49163, (v) => $584b4d02374cae9e$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $584b4d02374cae9e$export$8ff24f7760c7a78e, (v) => $584b4d02374cae9e$export$8ff24f7760c7a78e = v);
var $584b4d02374cae9e$export$bf9f79cdc4a49163;
var $584b4d02374cae9e$export$8ff24f7760c7a78e;

var $dMzRp = parcelRequire("dMzRp");


var $aTE7O = parcelRequire("aTE7O");

var $584b4d02374cae9e$require$Reporter = $aTE7O.Reporter;

var $iA9co = parcelRequire("iA9co");

var $584b4d02374cae9e$require$Buffer = $iA9co.Buffer;
function $584b4d02374cae9e$var$DecoderBuffer(base, options) {
    $584b4d02374cae9e$require$Reporter.call(this, options);
    if (!$584b4d02374cae9e$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dMzRp($584b4d02374cae9e$var$DecoderBuffer, $584b4d02374cae9e$require$Reporter);
$584b4d02374cae9e$export$bf9f79cdc4a49163 = $584b4d02374cae9e$var$DecoderBuffer;
$584b4d02374cae9e$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $584b4d02374cae9e$require$Reporter.prototype.save.call(this)
    };
};
$584b4d02374cae9e$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $584b4d02374cae9e$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $584b4d02374cae9e$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$584b4d02374cae9e$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$584b4d02374cae9e$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$584b4d02374cae9e$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $584b4d02374cae9e$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$584b4d02374cae9e$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $584b4d02374cae9e$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $584b4d02374cae9e$var$EncoderBuffer)) item = new $584b4d02374cae9e$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $584b4d02374cae9e$require$Buffer.byteLength(value);
    } else if ($584b4d02374cae9e$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$584b4d02374cae9e$export$8ff24f7760c7a78e = $584b4d02374cae9e$var$EncoderBuffer;
$584b4d02374cae9e$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $584b4d02374cae9e$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($584b4d02374cae9e$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("cJkT9", function(module, exports) {

var $aTE7O = parcelRequire("aTE7O");

var $9449e40df76ea646$require$Reporter = $aTE7O.Reporter;



var $9449e40df76ea646$require$EncoderBuffer = $aTE7O.EncoderBuffer;



var $9449e40df76ea646$require$DecoderBuffer = $aTE7O.DecoderBuffer;

var $gLTb0 = parcelRequire("gLTb0");

// Supported tags
var $9449e40df76ea646$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $9449e40df76ea646$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($9449e40df76ea646$var$tags);
// Overrided methods list
var $9449e40df76ea646$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $9449e40df76ea646$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $9449e40df76ea646$var$Node;
var $9449e40df76ea646$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$9449e40df76ea646$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $9449e40df76ea646$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$9449e40df76ea646$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $9449e40df76ea646$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$9449e40df76ea646$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $gLTb0(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $gLTb0.equal(state.children.length, 1, 'Root node can have only one child');
};
$9449e40df76ea646$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $gLTb0(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $gLTb0(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$9449e40df76ea646$var$overrided.forEach(function(method) {
    $9449e40df76ea646$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$9449e40df76ea646$var$tags.forEach(function(tag) {
    $9449e40df76ea646$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $gLTb0(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$9449e40df76ea646$var$Node.prototype.use = function use(item) {
    $gLTb0(item);
    var state = this._baseState;
    $gLTb0(state.use === null);
    state.use = item;
    return this;
};
$9449e40df76ea646$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$9449e40df76ea646$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $gLTb0(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$9449e40df76ea646$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $gLTb0(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$9449e40df76ea646$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $gLTb0(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$9449e40df76ea646$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$9449e40df76ea646$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $gLTb0(state.key === null);
    state.key = newKey;
    return this;
};
$9449e40df76ea646$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$9449e40df76ea646$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $gLTb0(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$9449e40df76ea646$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $gLTb0(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$9449e40df76ea646$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $9449e40df76ea646$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$9449e40df76ea646$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$9449e40df76ea646$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $gLTb0(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$9449e40df76ea646$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$9449e40df76ea646$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $9449e40df76ea646$require$EncoderBuffer(data, this.reporter);
};
$9449e40df76ea646$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$9449e40df76ea646$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $9449e40df76ea646$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$9449e40df76ea646$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $gLTb0(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$9449e40df76ea646$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$9449e40df76ea646$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$9449e40df76ea646$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});

parcelRegister("cqiEw", function(module, exports) {
var $90b661c3153c7d5e$var$constants = module.exports;
// Helper
$90b661c3153c7d5e$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$90b661c3153c7d5e$var$constants.der = (parcelRequire("bdeaT"));

});

parcelRegister("bdeaT", function(module, exports) {
$parcel$export(module.exports, "tagClass", () => $829be76241237f5b$export$3584c46ed60baee8, (v) => $829be76241237f5b$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $829be76241237f5b$export$f18596ef8d632e49, (v) => $829be76241237f5b$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $829be76241237f5b$export$2b067c6666111485, (v) => $829be76241237f5b$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $829be76241237f5b$export$f17df38a421ab9e3, (v) => $829be76241237f5b$export$f17df38a421ab9e3 = v);
var $829be76241237f5b$export$3584c46ed60baee8;
var $829be76241237f5b$export$f18596ef8d632e49;
var $829be76241237f5b$export$2b067c6666111485;
var $829be76241237f5b$export$f17df38a421ab9e3;

var $cqiEw = parcelRequire("cqiEw");

$829be76241237f5b$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$829be76241237f5b$export$f18596ef8d632e49 = $cqiEw._reverse($829be76241237f5b$export$3584c46ed60baee8);
$829be76241237f5b$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$829be76241237f5b$export$f17df38a421ab9e3 = $cqiEw._reverse($829be76241237f5b$export$2b067c6666111485);

});

parcelRegister("a30dO", function(module, exports) {
var $750a5b3eaa2e9df4$var$decoders = module.exports;

$750a5b3eaa2e9df4$var$decoders.der = (parcelRequire("2CEYk"));

$750a5b3eaa2e9df4$var$decoders.pem = (parcelRequire("5oika"));

});

parcelRegister("2CEYk", function(module, exports) {

var $dMzRp = parcelRequire("dMzRp");


var $k3MQ7 = parcelRequire("k3MQ7");

var $1e8ee98e090027cc$var$base = $k3MQ7.base;
var $1e8ee98e090027cc$var$bignum = $k3MQ7.bignum;
// Import DER constants
var $1e8ee98e090027cc$var$der = $k3MQ7.constants.der;
function $1e8ee98e090027cc$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1e8ee98e090027cc$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1e8ee98e090027cc$var$DERDecoder;
$1e8ee98e090027cc$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $1e8ee98e090027cc$var$base.DecoderBuffer)) data = new $1e8ee98e090027cc$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $1e8ee98e090027cc$var$DERNode(parent) {
    $1e8ee98e090027cc$var$base.Node.call(this, 'der', parent);
}
$dMzRp($1e8ee98e090027cc$var$DERNode, $1e8ee98e090027cc$var$base.Node);
$1e8ee98e090027cc$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $1e8ee98e090027cc$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$1e8ee98e090027cc$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $1e8ee98e090027cc$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $1e8ee98e090027cc$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$1e8ee98e090027cc$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $1e8ee98e090027cc$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $1e8ee98e090027cc$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$1e8ee98e090027cc$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$1e8ee98e090027cc$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$1e8ee98e090027cc$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$1e8ee98e090027cc$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$1e8ee98e090027cc$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$1e8ee98e090027cc$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$1e8ee98e090027cc$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $1e8ee98e090027cc$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$1e8ee98e090027cc$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $1e8ee98e090027cc$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $1e8ee98e090027cc$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $1e8ee98e090027cc$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $1e8ee98e090027cc$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("5oika", function(module, exports) {

var $dMzRp = parcelRequire("dMzRp");


var $iA9co = parcelRequire("iA9co");

var $3ecd6871f309807d$require$Buffer = $iA9co.Buffer;

var $2CEYk = parcelRequire("2CEYk");

function $3ecd6871f309807d$var$PEMDecoder(entity) {
    $2CEYk.call(this, entity);
    this.enc = 'pem';
}
$dMzRp($3ecd6871f309807d$var$PEMDecoder, $2CEYk);
module.exports = $3ecd6871f309807d$var$PEMDecoder;
$3ecd6871f309807d$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $3ecd6871f309807d$require$Buffer(base64, 'base64');
    return $2CEYk.prototype.decode.call(this, input, options);
};

});

parcelRegister("8tslJ", function(module, exports) {
var $62b705c2bb1254ca$var$encoders = module.exports;

$62b705c2bb1254ca$var$encoders.der = (parcelRequire("hHyDI"));

$62b705c2bb1254ca$var$encoders.pem = (parcelRequire("8TOil"));

});

parcelRegister("hHyDI", function(module, exports) {

var $dMzRp = parcelRequire("dMzRp");


var $iA9co = parcelRequire("iA9co");

var $ce31527f5124c026$require$Buffer = $iA9co.Buffer;

var $k3MQ7 = parcelRequire("k3MQ7");

var $ce31527f5124c026$var$base = $k3MQ7.base;
// Import DER constants
var $ce31527f5124c026$var$der = $k3MQ7.constants.der;
function $ce31527f5124c026$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $ce31527f5124c026$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $ce31527f5124c026$var$DEREncoder;
$ce31527f5124c026$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $ce31527f5124c026$var$DERNode(parent) {
    $ce31527f5124c026$var$base.Node.call(this, 'der', parent);
}
$dMzRp($ce31527f5124c026$var$DERNode, $ce31527f5124c026$var$base.Node);
$ce31527f5124c026$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $ce31527f5124c026$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $ce31527f5124c026$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $ce31527f5124c026$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$ce31527f5124c026$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $ce31527f5124c026$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$ce31527f5124c026$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $ce31527f5124c026$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $ce31527f5124c026$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$ce31527f5124c026$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $ce31527f5124c026$var$two(date.getFullYear()),
        $ce31527f5124c026$var$two(date.getUTCMonth() + 1),
        $ce31527f5124c026$var$two(date.getUTCDate()),
        $ce31527f5124c026$var$two(date.getUTCHours()),
        $ce31527f5124c026$var$two(date.getUTCMinutes()),
        $ce31527f5124c026$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $ce31527f5124c026$var$two(date.getFullYear() % 100),
        $ce31527f5124c026$var$two(date.getUTCMonth() + 1),
        $ce31527f5124c026$var$two(date.getUTCDate()),
        $ce31527f5124c026$var$two(date.getUTCHours()),
        $ce31527f5124c026$var$two(date.getUTCMinutes()),
        $ce31527f5124c026$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$ce31527f5124c026$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$ce31527f5124c026$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$ce31527f5124c026$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $ce31527f5124c026$require$Buffer(numArray);
    }
    if ($ce31527f5124c026$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $ce31527f5124c026$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $ce31527f5124c026$require$Buffer(out));
};
$ce31527f5124c026$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$ce31527f5124c026$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$ce31527f5124c026$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $ce31527f5124c026$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($ce31527f5124c026$var$der.tagByName.hasOwnProperty(tag)) res = $ce31527f5124c026$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $ce31527f5124c026$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("8TOil", function(module, exports) {

var $dMzRp = parcelRequire("dMzRp");


var $hHyDI = parcelRequire("hHyDI");

function $67aa79463c5e0a14$var$PEMEncoder(entity) {
    $hHyDI.call(this, entity);
    this.enc = 'pem';
}
$dMzRp($67aa79463c5e0a14$var$PEMEncoder, $hHyDI);
module.exports = $67aa79463c5e0a14$var$PEMEncoder;
$67aa79463c5e0a14$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $hHyDI.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});

parcelRegister("5St6j", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $k3MQ7 = parcelRequire("k3MQ7");

var $447891b6be16cf98$var$Time = $k3MQ7.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $447891b6be16cf98$var$AttributeTypeValue = $k3MQ7.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $447891b6be16cf98$var$AlgorithmIdentifier = $k3MQ7.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $447891b6be16cf98$var$SubjectPublicKeyInfo = $k3MQ7.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($447891b6be16cf98$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $447891b6be16cf98$var$RelativeDistinguishedName = $k3MQ7.define('RelativeDistinguishedName', function() {
    this.setof($447891b6be16cf98$var$AttributeTypeValue);
});
var $447891b6be16cf98$var$RDNSequence = $k3MQ7.define('RDNSequence', function() {
    this.seqof($447891b6be16cf98$var$RelativeDistinguishedName);
});
var $447891b6be16cf98$var$Name = $k3MQ7.define('Name', function() {
    this.choice({
        rdnSequence: this.use($447891b6be16cf98$var$RDNSequence)
    });
});
var $447891b6be16cf98$var$Validity = $k3MQ7.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($447891b6be16cf98$var$Time), this.key('notAfter').use($447891b6be16cf98$var$Time));
});
var $447891b6be16cf98$var$Extension = $k3MQ7.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $447891b6be16cf98$var$TBSCertificate = $k3MQ7.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($447891b6be16cf98$var$AlgorithmIdentifier), this.key('issuer').use($447891b6be16cf98$var$Name), this.key('validity').use($447891b6be16cf98$var$Validity), this.key('subject').use($447891b6be16cf98$var$Name), this.key('subjectPublicKeyInfo').use($447891b6be16cf98$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($447891b6be16cf98$var$Extension).optional());
});
var $447891b6be16cf98$var$X509Certificate = $k3MQ7.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($447891b6be16cf98$var$TBSCertificate), this.key('signatureAlgorithm').use($447891b6be16cf98$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $447891b6be16cf98$var$X509Certificate;

});

parcelRegister("dqaxD", function(module, exports) {

var $iA9co = parcelRequire("iA9co");

var $9c55e1604a6f300b$require$Buffer = $iA9co.Buffer;

var $gBIbs = parcelRequire("gBIbs");


var $hpluo = parcelRequire("hpluo");

module.exports = function createECDH(curve) {
    return new $9c55e1604a6f300b$var$ECDH(curve);
};
var $9c55e1604a6f300b$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$9c55e1604a6f300b$var$aliases.p224 = $9c55e1604a6f300b$var$aliases.secp224r1;
$9c55e1604a6f300b$var$aliases.p256 = $9c55e1604a6f300b$var$aliases.secp256r1 = $9c55e1604a6f300b$var$aliases.prime256v1;
$9c55e1604a6f300b$var$aliases.p192 = $9c55e1604a6f300b$var$aliases.secp192r1 = $9c55e1604a6f300b$var$aliases.prime192v1;
$9c55e1604a6f300b$var$aliases.p384 = $9c55e1604a6f300b$var$aliases.secp384r1;
$9c55e1604a6f300b$var$aliases.p521 = $9c55e1604a6f300b$var$aliases.secp521r1;
function $9c55e1604a6f300b$var$ECDH(curve) {
    this.curveType = $9c55e1604a6f300b$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $gBIbs.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$9c55e1604a6f300b$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$9c55e1604a6f300b$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$9c55e1604a6f300b$require$Buffer.isBuffer(other)) other = new $9c55e1604a6f300b$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $9c55e1604a6f300b$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$9c55e1604a6f300b$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $9c55e1604a6f300b$var$formatReturnValue(key, enc);
};
$9c55e1604a6f300b$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $9c55e1604a6f300b$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$9c55e1604a6f300b$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$9c55e1604a6f300b$require$Buffer.isBuffer(pub)) pub = new $9c55e1604a6f300b$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$9c55e1604a6f300b$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$9c55e1604a6f300b$require$Buffer.isBuffer(priv)) priv = new $9c55e1604a6f300b$require$Buffer(priv, enc);
    var _priv = new $hpluo(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $9c55e1604a6f300b$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $9c55e1604a6f300b$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $9c55e1604a6f300b$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $9c55e1604a6f300b$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRegister("ksS2r", function(module, exports) {

var $jpRkG = parcelRequire("jpRkG");


var $97jsf = parcelRequire("97jsf");


var $abSTA = parcelRequire("abSTA");


var $egef1 = parcelRequire("egef1");


var $k5wZL = parcelRequire("k5wZL");


var $hpluo = parcelRequire("hpluo");


var $kFyyv = parcelRequire("kFyyv");


var $1fiU8 = parcelRequire("1fiU8");


var $eI8vp = parcelRequire("eI8vp");

var $ee6057103e40de10$require$Buffer = $eI8vp.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $jpRkG(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $ee6057103e40de10$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $ee6057103e40de10$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $hpluo(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $1fiU8(paddedMsg, key);
    else return $kFyyv(paddedMsg, key);
};
function $ee6057103e40de10$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $abSTA('sha1').update($ee6057103e40de10$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $ee6057103e40de10$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $97jsf(hLen);
    var maskedDb = $k5wZL($ee6057103e40de10$require$Buffer.concat([
        iHash,
        ps,
        $ee6057103e40de10$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $egef1(seed, dblen));
    var maskedSeed = $k5wZL(seed, $egef1(maskedDb, hLen));
    return new $hpluo($ee6057103e40de10$require$Buffer.concat([
        $ee6057103e40de10$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $ee6057103e40de10$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $ee6057103e40de10$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $ee6057103e40de10$var$nonZero(k - mLen - 3);
    return new $hpluo($ee6057103e40de10$require$Buffer.concat([
        $ee6057103e40de10$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $ee6057103e40de10$require$Buffer.alloc(1),
        msg
    ], k));
}
function $ee6057103e40de10$var$nonZero(len) {
    var out = $ee6057103e40de10$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $97jsf(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $97jsf(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});

parcelRegister("7zmOG", function(module, exports) {

var $jpRkG = parcelRequire("jpRkG");


var $egef1 = parcelRequire("egef1");


var $k5wZL = parcelRequire("k5wZL");


var $hpluo = parcelRequire("hpluo");


var $1fiU8 = parcelRequire("1fiU8");


var $abSTA = parcelRequire("abSTA");


var $kFyyv = parcelRequire("kFyyv");


var $eI8vp = parcelRequire("eI8vp");

var $582d8029d2b8400d$require$Buffer = $eI8vp.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $jpRkG(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $hpluo(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $kFyyv(new $hpluo(enc), key);
    else msg = $1fiU8(enc, key);
    var zBuffer = $582d8029d2b8400d$require$Buffer.alloc(k - msg.length);
    msg = $582d8029d2b8400d$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $582d8029d2b8400d$var$oaep(key, msg);
    else if (padding === 1) return $582d8029d2b8400d$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $582d8029d2b8400d$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $abSTA('sha1').update($582d8029d2b8400d$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $k5wZL(maskedSeed, $egef1(maskedDb, hLen));
    var db = $k5wZL(maskedDb, $egef1(seed, k - hLen - 1));
    if ($582d8029d2b8400d$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $582d8029d2b8400d$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $582d8029d2b8400d$var$compare(a, b) {
    a = $582d8029d2b8400d$require$Buffer.from(a);
    b = $582d8029d2b8400d$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});

parcelRegister("c3Qwv", function(module, exports) {
function $8e6d57004e7493a0$export$69b4b1e5f81fb1ea(queryParams, paramName) {
    const value = queryParams?.[paramName];
    return Array.isArray(value) ? value[0] : value;
}
function $8e6d57004e7493a0$export$a44568e95e5c4a5c(queryParams, paramName, defaultValue) {
    const value = $8e6d57004e7493a0$export$69b4b1e5f81fb1ea(queryParams, paramName);
    const intValue = parseInt(value ?? '', 10);
    return isNaN(intValue) ? defaultValue : intValue;
}
module.exports["getSingleParam"] = $8e6d57004e7493a0$export$69b4b1e5f81fb1ea;
module.exports["getSingleParamInt"] = $8e6d57004e7493a0$export$a44568e95e5c4a5c;

});

parcelRegister("ajqJ5", function(module, exports) {

var $dh538 = parcelRequire("dh538");

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::4131829e60733a1a5e513dcc84af81de>>
 * @codegenCommand yarn build tokens
 */ 















const $18c1f3b13d61b93d$var$themeImportsMap = {
    'light': ()=>(parcelRequire("a2rgr")),
    'light-future': ()=>(parcelRequire("bOgLH")),
    'light-increased-contrast': ()=>(parcelRequire("jXyHu")),
    'dark': ()=>(parcelRequire("5u7zr")),
    'dark-future': ()=>(parcelRequire("883Tt")),
    'dark-increased-contrast': ()=>(parcelRequire("bRJIB")),
    'legacy-light': ()=>(parcelRequire("b38n8")),
    'legacy-dark': ()=>(parcelRequire("hiSqO")),
    'spacing': ()=>(parcelRequire("bTGF4")),
    'typography': ()=>(parcelRequire("enjgh")),
    'typography-adg3': ()=>(parcelRequire("jeouj")),
    'shape': ()=>(parcelRequire("PiYIj")),
    'typography-modernized': ()=>(parcelRequire("iJ4Ci")),
    'typography-refreshed': ()=>(parcelRequire("Bssc2")),
    'light-brand-refresh': ()=>(parcelRequire("2OVAF")),
    'dark-brand-refresh': ()=>(parcelRequire("65o13"))
};
var $18c1f3b13d61b93d$export$2e2bcd8739ae039 = $18c1f3b13d61b93d$var$themeImportsMap;



var $a9dFP = parcelRequire("a9dFP");

const $669d2abcffd4d3b1$export$26cd7ae85c7144e5 = async (themeId)=>{
    if (document.head.querySelector(`style[${(0, $a9dFP.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $a9dFP.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = await $669d2abcffd4d3b1$export$8a48286ed7df6720(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $669d2abcffd4d3b1$export$8a48286ed7df6720 = async (themeId)=>{
    if ((themeId === 'light' || themeId === 'dark') && (0, $dh538.fg)('platform-component-visual-refresh')) themeId += '-brand-refresh';
    const { default: themeCss } = await (0, $18c1f3b13d61b93d$export$2e2bcd8739ae039)[themeId]();
    return themeCss;
};
const $669d2abcffd4d3b1$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $669d2abcffd4d3b1$export$8662df6937d86fcb = '(prefers-contrast: more)';
module.exports["loadAndAppendThemeCss"] = $669d2abcffd4d3b1$export$26cd7ae85c7144e5;
module.exports["loadThemeCss"] = $669d2abcffd4d3b1$export$8a48286ed7df6720;
module.exports["darkModeMediaQuery"] = $669d2abcffd4d3b1$export$bb1e815119d30f8b;
module.exports["moreContrastMediaQuery"] = $669d2abcffd4d3b1$export$8662df6937d86fcb;

});

parcelRegister("a2rgr", function(module, exports) {

let $74ef3d6826ba984c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74ef3d6826ba984c$var$load("h1tW8").then(()=>parcelRequire('abuh9'));

});

parcelRegister("bOgLH", function(module, exports) {

let $89915f0cdae011c4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $89915f0cdae011c4$var$load("jNRei").then(()=>parcelRequire('epBk0'));

});

parcelRegister("jXyHu", function(module, exports) {

let $e87e71d0a3cbb4d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e87e71d0a3cbb4d1$var$load("3GB7D").then(()=>parcelRequire('lDnIk'));

});

parcelRegister("5u7zr", function(module, exports) {

let $3fe5a074e0b5b215$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3fe5a074e0b5b215$var$load("ebMC9").then(()=>parcelRequire('dzoJk'));

});

parcelRegister("883Tt", function(module, exports) {

let $5eb21753215955ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5eb21753215955ea$var$load("iedV6").then(()=>parcelRequire('alLvI'));

});

parcelRegister("bRJIB", function(module, exports) {

let $8a381ba9f3e1c337$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8a381ba9f3e1c337$var$load("l8hHe").then(()=>parcelRequire('3BTlS'));

});

parcelRegister("b38n8", function(module, exports) {

let $80b67807d82a47ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80b67807d82a47ce$var$load("56HnP").then(()=>parcelRequire('bzEe0'));

});

parcelRegister("hiSqO", function(module, exports) {

let $c98e5712881456cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c98e5712881456cb$var$load("hP5UZ").then(()=>parcelRequire('7UVx9'));

});

parcelRegister("bTGF4", function(module, exports) {

let $8a95ec6c43d289a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8a95ec6c43d289a6$var$load("heSmI").then(()=>parcelRequire('7p1sh'));

});

parcelRegister("enjgh", function(module, exports) {

let $a772279b274b112e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a772279b274b112e$var$load("1rT79").then(()=>parcelRequire('aWcsq'));

});

parcelRegister("jeouj", function(module, exports) {

let $e00251e626bb651b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e00251e626bb651b$var$load("hck5E").then(()=>parcelRequire('gArBD'));

});

parcelRegister("PiYIj", function(module, exports) {

let $09a37c3879fd7c91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $09a37c3879fd7c91$var$load("kpiLR").then(()=>parcelRequire('iPpEE'));

});

parcelRegister("iJ4Ci", function(module, exports) {

let $da2002b81f360c9c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $da2002b81f360c9c$var$load("be4Ow").then(()=>parcelRequire('9jf84'));

});

parcelRegister("Bssc2", function(module, exports) {

let $070987224a984df9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $070987224a984df9$var$load("9ZdQB").then(()=>parcelRequire('1KpW7'));

});

parcelRegister("2OVAF", function(module, exports) {

let $20dcec8bcd5f71d4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $20dcec8bcd5f71d4$var$load("k8jK1").then(()=>parcelRequire('glnls'));

});

parcelRegister("65o13", function(module, exports) {

let $46e5d6cb98053632$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $46e5d6cb98053632$var$load("iA8EQ").then(()=>parcelRequire('i33Fc'));

});

parcelRegister("hY0xh", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $a9dFP = parcelRequire("a9dFP");


var $fwSE5 = parcelRequire("fwSE5");


var $j6S25 = parcelRequire("j6S25");


var $9NuSR = parcelRequire("9NuSR");


var $jf7dC = parcelRequire("jf7dC");

const $6273d1ed92320a12$var$defaultColorMode = 'light';
const $6273d1ed92320a12$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ const $6273d1ed92320a12$var$getThemeHtmlAttrs = ({ colorMode: colorMode = (0, $fwSE5.themeStateDefaults)['colorMode'], dark: dark = (0, $fwSE5.themeStateDefaults)['dark'], light: light = (0, $fwSE5.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $fwSE5.themeStateDefaults)['contrastMode'], shape: shape = (0, $fwSE5.themeStateDefaults)['shape'], spacing: spacing = (0, $fwSE5.themeStateDefaults)['spacing'], typography: typography = (0, $fwSE5.themeStateDefaults)['typography'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $fwSE5.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $j6S25.themeObjectToString)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $a9dFP.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $a9dFP.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $6273d1ed92320a12$var$defaultColorMode : colorMode
    };
    if ((0, $dh538.fg)('platform_increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $a9dFP.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $6273d1ed92320a12$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $9NuSR.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $jf7dC.hash)(optionString);
        result[0, $a9dFP.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $6273d1ed92320a12$export$2e2bcd8739ae039 = $6273d1ed92320a12$var$getThemeHtmlAttrs;
module.exports["default"] = $6273d1ed92320a12$export$2e2bcd8739ae039;

});

parcelRegister("fwSE5", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $4388733435d61915$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ const $4388733435d61915$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
const $4388733435d61915$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'light-brand-refresh',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'dark-brand-refresh',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography',
    'typography-adg3',
    'typography-modernized',
    'typography-refreshed'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ const $4388733435d61915$var$themeOverrideIds = [];
const $4388733435d61915$export$92ba366331403db2 = [
    ...$4388733435d61915$export$7d43e72a58e3283f,
    ...$4388733435d61915$var$themeOverrideIds
];
const $4388733435d61915$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-modernized': {
        id: 'typography-modernized',
        displayName: 'Atlassian Typography (Modernized)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-refreshed': {
        id: 'typography-refreshed',
        displayName: 'Atlassian Typography (Refreshed)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-light-brand-refresh': {
        id: 'light-brand-refresh',
        displayName: 'Light theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-dark-brand-refresh': {
        id: 'dark-brand-refresh',
        displayName: 'Dark theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    }
};
const $4388733435d61915$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: undefined,
    spacing: 'spacing',
    typography: ()=>{
        if ((0, $dh538.fg)('platform-disable-default-typography')) return undefined;
        return 'typography';
    },
    UNSAFE_themeOptions: undefined
};
var $4388733435d61915$export$2e2bcd8739ae039 = $4388733435d61915$var$themeConfig;
module.exports["themeColorModes"] = $4388733435d61915$export$83993de8eb66733;
module.exports["themeIds"] = $4388733435d61915$export$7d43e72a58e3283f;
module.exports["themeIdsWithOverrides"] = $4388733435d61915$export$92ba366331403db2;
module.exports["themeStateDefaults"] = $4388733435d61915$export$9aedcfa7336a207;
module.exports["default"] = $4388733435d61915$export$2e2bcd8739ae039;

});

parcelRegister("j6S25", function(module, exports) {

var $fwSE5 = parcelRequire("fwSE5");

const $8634106acb00ae52$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
const $8634106acb00ae52$var$customThemeOptions = 'UNSAFE_themeOptions';
const $8634106acb00ae52$var$isThemeKind = (themeKind)=>{
    return $8634106acb00ae52$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};
const $8634106acb00ae52$var$isThemeIds = (themeId)=>{
    return (0, $fwSE5.themeIds).find((id)=>id === themeId) !== undefined;
};
const $8634106acb00ae52$var$isColorMode = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
const $8634106acb00ae52$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map((theme)=>theme.split(RegExp(":(.*)", "s"))).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && $8634106acb00ae52$var$isColorMode(id)) themeObject[kind] = id;
        if ($8634106acb00ae52$var$isThemeKind(kind) && $8634106acb00ae52$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $8634106acb00ae52$var$customThemeOptions) try {
            themeObject[$8634106acb00ae52$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
const $8634106acb00ae52$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $8634106acb00ae52$var$isColorMode(id) || // custom theme state
        kind === $8634106acb00ae52$var$customThemeOptions && typeof id === 'object' || // other theme states
        $8634106acb00ae52$var$isThemeKind(kind) && typeof id === 'string' && $8634106acb00ae52$var$isThemeIds(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');
module.exports["themeStringToObject"] = $8634106acb00ae52$export$f19b488f7c0547ee;
module.exports["themeObjectToString"] = $8634106acb00ae52$export$62c37ab81302621a;

});

parcelRegister("9NuSR", function(module, exports) {
// valid hex color with 6 digits
const $7629a259bf911f3c$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);
// valid hex color with 4, 6 or 8 digits
const $7629a259bf911f3c$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
function $7629a259bf911f3c$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $7629a259bf911f3c$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $7629a259bf911f3c$export$b36dbdb4f463f05c(hex) {
    if (!$7629a259bf911f3c$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $7629a259bf911f3c$export$1212645cf40ebf71(hex)
    ];
}
function $7629a259bf911f3c$export$5a544e13ad4e1fa5(hex) {
    if (!$7629a259bf911f3c$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $7629a259bf911f3c$export$47ea145a83f50dc0(hex) {
    if (!$7629a259bf911f3c$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $7629a259bf911f3c$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $7629a259bf911f3c$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $7629a259bf911f3c$export$d061e26956a60b0a(foreground, background) {
    if (!$7629a259bf911f3c$var$isValidHex(foreground) || !$7629a259bf911f3c$var$isValidHex(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $7629a259bf911f3c$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $7629a259bf911f3c$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $7629a259bf911f3c$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $7629a259bf911f3c$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $7629a259bf911f3c$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $7629a259bf911f3c$var$rgbToLab(rgbA);
    let labB = $7629a259bf911f3c$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $7629a259bf911f3c$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}
module.exports["isValidBrandHex"] = $7629a259bf911f3c$export$53031ac1ecb71f44;
module.exports["rgbToHex"] = $7629a259bf911f3c$export$34d09c4a771c46ef;
module.exports["hexToRgbA"] = $7629a259bf911f3c$export$b36dbdb4f463f05c;
module.exports["hexToRgb"] = $7629a259bf911f3c$export$5a544e13ad4e1fa5;
module.exports["hexToHSL"] = $7629a259bf911f3c$export$47ea145a83f50dc0;
module.exports["HSLToRGB"] = $7629a259bf911f3c$export$1ff93e992dd58bec;
module.exports["relativeLuminanceW3C"] = $7629a259bf911f3c$export$e770b01b744f3745;
module.exports["getContrastRatio"] = $7629a259bf911f3c$export$d061e26956a60b0a;
module.exports["deltaE"] = $7629a259bf911f3c$export$e8ddad763b4bebf9;

});

parcelRegister("jf7dC", function(module, exports) {
const $1e92a1c02d71d6b4$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};
module.exports["hash"] = $1e92a1c02d71d6b4$export$d6af199866bfb566;

});

parcelRegister("geGFh", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $fwSE5 = parcelRequire("fwSE5");


var $9NuSR = parcelRequire("9NuSR");


var $1oKVt = parcelRequire("1oKVt");


var $ajqJ5 = parcelRequire("ajqJ5");


/**
 * Takes an object containing theme preferences, and returns an array of objects for use in applying styles to the document head.
 * Only supplies the color themes necessary for initial render, based on the current themeState. I.e. if in light mode, dark mode themes are not returned.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns A Promise of an object array, containing theme IDs, data-attributes to attach to the theme, and the theme CSS.
 * If an error is encountered while loading themes, the themes array will be empty.
 */ const $1a5b891e60ca97ce$var$getThemeStyles = async (preferences)=>{
    let themePreferences;
    let themeOverridePreferences = [];
    if (preferences === 'all') {
        themePreferences = (0, $fwSE5.themeIdsWithOverrides);
        // CLEANUP: Remove
        if (!(0, $dh538.fg)('platform_increased-contrast-themes')) themePreferences = themePreferences.filter((n)=>n !== 'light-increased-contrast' && n !== 'dark-increased-contrast');
        themePreferences = themePreferences.filter((n)=>n !== 'light-brand-refresh' && n !== 'dark-brand-refresh');
    } else {
        const themeState = {
            colorMode: preferences?.colorMode || (0, $fwSE5.themeStateDefaults)['colorMode'],
            contrastMode: preferences?.contrastMode || (0, $fwSE5.themeStateDefaults)['contrastMode'],
            dark: preferences?.dark || (0, $fwSE5.themeStateDefaults)['dark'],
            light: preferences?.light || (0, $fwSE5.themeStateDefaults)['light'],
            shape: preferences?.shape || (0, $fwSE5.themeStateDefaults)['shape'],
            spacing: preferences?.spacing || (0, $fwSE5.themeStateDefaults)['spacing'],
            typography: preferences?.typography || (0, $fwSE5.themeStateDefaults)['typography']()
        };
        themePreferences = (0, $1oKVt.getThemePreferences)(themeState);
        themeOverridePreferences = (0, $1oKVt.getThemeOverridePreferences)(themeState);
    }
    const results = await Promise.all([
        ...[
            ...themePreferences,
            ...themeOverridePreferences
        ].map(async (themeId)=>{
            try {
                const css = await (0, $ajqJ5.loadThemeCss)(themeId);
                return {
                    id: themeId,
                    attrs: {
                        'data-theme': themeId
                    },
                    css: css
                };
            } catch  {
                // Return undefined if there's an error loading it, will be filtered out later.
                return undefined;
            }
        }),
        // Add custom themes if they're present
        (async ()=>{
            if (preferences !== 'all' && preferences?.UNSAFE_themeOptions && (0, $9NuSR.isValidBrandHex)(preferences?.UNSAFE_themeOptions?.brandColor)) try {
                const { getCustomThemeStyles: getCustomThemeStyles } = await (parcelRequire("5jDN5"));
                const customThemeStyles = await getCustomThemeStyles({
                    colorMode: preferences?.colorMode || (0, $fwSE5.themeStateDefaults)['colorMode'],
                    UNSAFE_themeOptions: preferences?.UNSAFE_themeOptions
                });
                return customThemeStyles;
            } catch  {
                // Return undefined if there's an error loading it, will be filtered out later.
                return undefined;
            }
            return undefined;
        })()
    ]);
    return results.flat().filter((theme)=>theme !== undefined);
};
var $1a5b891e60ca97ce$export$2e2bcd8739ae039 = $1a5b891e60ca97ce$var$getThemeStyles;
module.exports["default"] = $1a5b891e60ca97ce$export$2e2bcd8739ae039;

});

parcelRegister("5jDN5", function(module, exports) {

let $3ded97b94da36f9f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ded97b94da36f9f$var$load("4tr9u").then(()=>parcelRequire('18QBh'));

});

parcelRegister("4icxs", function(module, exports) {

var $1vDIt = parcelRequire("1vDIt");


var $a9dFP = parcelRequire("a9dFP");


var $jf7dC = parcelRequire("jf7dC");

function $1ea4a2d7bbefbd1e$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $jf7dC.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $a9dFP.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $a9dFP.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $1ea4a2d7bbefbd1e$export$e7ae172320e03461(sizeThreshold) {
    const styleTags = [
        ...Array.from(document.head.querySelectorAll(`style[${(0, $a9dFP.CUSTOM_THEME_ATTRIBUTE)}][${(0, $a9dFP.THEME_DATA_ATTRIBUTE)}]`))
    ];
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach((element)=>element.remove());
}
function $1ea4a2d7bbefbd1e$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce((acc, [key, value])=>{
        const cssVar = (0, $1vDIt.default)[key];
        return cssVar ? `${acc}\n  ${cssVar}: ${typeof value === 'string' ? value : themeRamp[value]};` : acc;
    }, '');
}
module.exports["findMissingCustomStyleElements"] = $1ea4a2d7bbefbd1e$export$bd1ac9300b0e885a;
module.exports["limitSizeOfCustomStyleElements"] = $1ea4a2d7bbefbd1e$export$e7ae172320e03461;
module.exports["reduceTokenMap"] = $1ea4a2d7bbefbd1e$export$e673f367da2ff23e;

});

parcelRegister("1vDIt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e7897709d50bd1f9582875a2a591b896>>
 * @codegenCommand yarn build tokens
 */ const $da652f7b9238bbc8$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $da652f7b9238bbc8$export$2e2bcd8739ae039 = $da652f7b9238bbc8$var$tokens;
module.exports["default"] = $da652f7b9238bbc8$export$2e2bcd8739ae039;

});

parcelRegister("58u2L", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8a43a65da3aff11c$export$1fdf6d3d1e0ee29c = ()=>{
    return {
        dark: 'dark',
        light: 'light',
        colorMode: (0, $9wGTI.fg)('shared-user-preferences') ? 'auto' : 'light',
        typography: 'typography'
    };
};
module.exports["getDefaultTheme"] = $8a43a65da3aff11c$export$1fdf6d3d1e0ee29c;

});

parcelRegister("bj5fB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jiJCD = parcelRequire("jiJCD");


var $7zgzO = parcelRequire("7zgzO");


var $lJlG6 = parcelRequire("lJlG6");

const $8579ac0d0bed5d4d$export$ee773ad61083d113 = (uri)=>{
    const { location: location, getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    let { parentProduct: parentProduct = '', presentationMode: presentationMode = '' } = getQueryParams();
    // If we have a uri string, we are being asked to check the query params from the uri
    if (uri) ({ parentProduct: parentProduct = '', presentationMode: presentationMode = '' } = (0, $jiJCD.parse)(uri, true)?.query ?? {});
    else if (location === null) // If the RoutesContext is not available, we need to parse the query params from window.location
    ({ parentProduct: parentProduct = '', presentationMode: presentationMode = '' } = (0, $jiJCD.parse)(window?.location?.search, true)?.query ?? {});
    return {
        isMobileApp: (0, $lJlG6.checkForValidParam)(presentationMode, (0, $lJlG6.MOBILE_APP_QUERY_PARAM_VALUES)) || (0, $lJlG6.checkForValidParam)(parentProduct, (0, $lJlG6.MOBILE_APP_QUERY_PARAM_VALUES)),
        isMobileAppWithCommenting: (0, $lJlG6.checkForValidParam)(presentationMode, (0, $lJlG6.MOBILE_APP_WITH_COMMENTING_QUERY_PARAM_VALUES)) || (0, $lJlG6.checkForValidParam)(parentProduct, (0, $lJlG6.MOBILE_APP_WITH_COMMENTING_QUERY_PARAM_VALUES)),
        isMobileAppWithEditing: (0, $lJlG6.checkForValidParam)(presentationMode, (0, $lJlG6.MOBILE_APP_WITH_EDITING_QUERY_PARAM_VALUES)) || (0, $lJlG6.checkForValidParam)(parentProduct, (0, $lJlG6.MOBILE_APP_WITH_EDITING_QUERY_PARAM_VALUES))
    };
};
module.exports["useIsMobileApp"] = $8579ac0d0bed5d4d$export$ee773ad61083d113;

});

parcelRegister("7Lnfv", function(module, exports) {
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}
module.exports["UNEXPECTED_RESPONSE"] = $b5dd42974905c1cd$export$974b1060e58e0a3f;
module.exports["getOperationName"] = $b5dd42974905c1cd$export$41bca9dc6871dd4e;

});

parcelRegister("jQ6FG", function(module, exports) {
function $c42fc28a75665357$export$1f99beb156766eb5(operationName, variables) {
    if (!operationName) return '';
    let name = operationName;
    if (operationName === 'WebItemLocationQuery' || operationName === 'WebPanelLocationQuery') name = `${operationName}:${variables?.location || (variables?.locations || []).join(',') || ''}`;
    return name.replace(/[^\-\.\w]/g, '_');
}
module.exports["getQueryName"] = $c42fc28a75665357$export$1f99beb156766eb5;

});

parcelRegister("3joiD", function(module, exports) {

var $7Lnfv = parcelRequire("7Lnfv");


var $jQ6FG = parcelRequire("jQ6FG");

const $7bd333c4107e77c7$var$QueryPreloadedWithNetworkOnly = new Set();
function $7bd333c4107e77c7$var$getKey(name, variables) {
    if (!variables) return name;
    const sortedVariables = Object.entries(variables).sort(([a], [b])=>a.localeCompare(b)).reduce((r, [k, v])=>({
            ...r,
            [k]: v
        }), {});
    return `${name}:${JSON.stringify(sortedVariables)}`;
}
function $7bd333c4107e77c7$export$48f37ae0123d54a5(name, variables, fetchPolicy) {
    const key = $7bd333c4107e77c7$var$getKey(name, variables);
    if (fetchPolicy === 'network-only') $7bd333c4107e77c7$var$QueryPreloadedWithNetworkOnly.add(key);
    else $7bd333c4107e77c7$var$QueryPreloadedWithNetworkOnly.delete(key);
}
function $7bd333c4107e77c7$export$4fe9299564f25d28(options) {
    const [query, queryOptions] = $7bd333c4107e77c7$export$419dbf8acbf3b9db(options);
    return {
        query: query,
        ...queryOptions
    };
}
function $7bd333c4107e77c7$export$419dbf8acbf3b9db(options) {
    const { query: query, ...queryOptions } = options;
    if (!query) return [
        query,
        queryOptions
    ];
    const { variables: variables = {}, fetchPolicy: fetchPolicy } = queryOptions;
    const name = (0, $7Lnfv.getOperationName)(query);
    const queryName = (0, $jQ6FG.getQueryName)(name, variables);
    const shouldUseCacheFirst = // If SSRed then the query has just been preloaded on server-side the data is fresh
    window.__SSR_RENDERED__ || // If we can ensure the query was preloaded with network-only then it is safe to read from cache
    $7bd333c4107e77c7$var$QueryPreloadedWithNetworkOnly.has($7bd333c4107e77c7$var$getKey(queryName, variables));
    return [
        query,
        {
            ...queryOptions,
            fetchPolicy: shouldUseCacheFirst ? 'cache-first' : // Otherwise use whatever passed in
            fetchPolicy
        }
    ];
}
module.exports["flagQueryPreloadedByNetworkOnly"] = $7bd333c4107e77c7$export$48f37ae0123d54a5;
module.exports["getQueryPropsAndSetFetchPolicyForNetworkOnlyQuery"] = $7bd333c4107e77c7$export$4fe9299564f25d28;
module.exports["getQueryParamsAndSetFetchPolicyForNetworkOnlyQuery"] = $7bd333c4107e77c7$export$419dbf8acbf3b9db;

});

parcelRegister("xwvlW", function(module, exports) {
function $265d8d4484e6fbd7$var$sessionDataLikeToPreloadFnContext(data) {
    return {
        isLoggedIn: Boolean(data.isLoggedIn),
        isLicensed: Boolean(data.isLicensed),
        accessStatus: data.accessStatus || null,
        userId: data.userId || null,
        cloudId: data.cloudId || '',
        orgId: data.orgId,
        edition: data.edition || null,
        activationId: data.activationId || '',
        environment: data.environment || 'PRODUCTION',
        // Note: the locale from session data is not standard aa-AA format. It is aa_AA
        locale: data.locale?.replace('_', '-') || 'en-US',
        isAdminHubAIEnabled: Boolean(data.isAdminHubAIEnabled),
        isRovoEnabled: Boolean(data.isRovoEnabled),
        isRovoLLMEnabled: Boolean(data.isRovoLLMEnabled)
    };
}
let $265d8d4484e6fbd7$var$preloadContext = null;
function $265d8d4484e6fbd7$export$4facd4e9bac676da(context) {
    $265d8d4484e6fbd7$var$preloadContext = $265d8d4484e6fbd7$var$sessionDataLikeToPreloadFnContext(context);
}
function $265d8d4484e6fbd7$export$54288b855f86de9e() {
    if (!$265d8d4484e6fbd7$var$preloadContext) throw new Error('Preload function context not initialized');
    return $265d8d4484e6fbd7$var$preloadContext;
}
module.exports["initializePreloaderFnContext"] = $265d8d4484e6fbd7$export$4facd4e9bac676da;
module.exports["getPreloaderFnContext"] = $265d8d4484e6fbd7$export$54288b855f86de9e;

});

parcelRegister("bUqLQ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $a50c782784c2bfae$export$d4f1513c33ce7d87 = (0, $eSUdr.default)`query FrontendResourceRenderQuery{internalFrontendResource{resourceList{type url attributes{key value}}}}`;
module.exports["FrontendResourceRenderQuery"] = $a50c782784c2bfae$export$d4f1513c33ce7d87;

});

parcelRegister("lesra", function(module, exports) {

var $j6S25 = parcelRequire("j6S25");


var $hxeND = parcelRequire("hxeND");


var $58u2L = parcelRequire("58u2L");

const $7aee2c9bb6aa1dbe$export$758dd268a3743917 = 'default';
const $7aee2c9bb6aa1dbe$export$736646d09a814fb6 = 'original';
const $7aee2c9bb6aa1dbe$export$f0d5a0615e86ce0 = (themeStateSerialized)=>{
    if ([
        $7aee2c9bb6aa1dbe$export$736646d09a814fb6,
        $7aee2c9bb6aa1dbe$export$758dd268a3743917
    ].includes(themeStateSerialized)) return (0, $58u2L.getDefaultTheme)();
    return (0, $hxeND.buildThemeFromState)((0, $j6S25.themeStringToObject)(themeStateSerialized));
};
const $7aee2c9bb6aa1dbe$export$64359bcab6734a31 = (themeStateOrDefault)=>{
    if (themeStateOrDefault === $7aee2c9bb6aa1dbe$export$758dd268a3743917 || themeStateOrDefault === $7aee2c9bb6aa1dbe$export$736646d09a814fb6) return themeStateOrDefault;
    return (0, $j6S25.themeObjectToString)(themeStateOrDefault);
};
module.exports["API_DEFAULT_THEME_STATE"] = $7aee2c9bb6aa1dbe$export$758dd268a3743917;
module.exports["API_ORIGINAL_THEME_STATE"] = $7aee2c9bb6aa1dbe$export$736646d09a814fb6;
module.exports["getEffectiveThemeState"] = $7aee2c9bb6aa1dbe$export$f0d5a0615e86ce0;
module.exports["getEffectiveThemeStateSerialized"] = $7aee2c9bb6aa1dbe$export$64359bcab6734a31;

});

parcelRegister("3NXcb", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");

// src/core/registered-ari.ts
var $2c53ddb1fb6005cd$export$579ee78b1dcf0a11 = class extends (0, $k4HRJ.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $k4HRJ.AnyAri).parse(this.toString());
    }
};
module.exports["RegisteredAri"] = $2c53ddb1fb6005cd$export$579ee78b1dcf0a11;

});

parcelRegister("k4HRJ", function(module, exports) {

var $6yCpa = parcelRequire("6yCpa");

// src/core/ari.ts
var $e9d63528c8c42cdf$export$3a4885701291260b = class {
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
    constructor(opts){
        this._ati = (0, $6yCpa.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
};
// src/any-ari.ts
var $e9d63528c8c42cdf$export$44a7af7122933d6b = class _AnyAri extends $e9d63528c8c42cdf$export$3a4885701291260b {
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $6yCpa.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $6yCpa.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
    constructor(opts){
        super(opts);
    }
};
module.exports["Ari"] = $e9d63528c8c42cdf$export$3a4885701291260b;
module.exports["AnyAri"] = $e9d63528c8c42cdf$export$44a7af7122933d6b;

});

parcelRegister("6yCpa", function(module, exports) {

var $4FsX0 = parcelRequire("4FsX0");

// src/core/rules/platform-qualifier.ts
function $60a13ae980619827$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $4FsX0.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $60a13ae980619827$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $4FsX0.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $60a13ae980619827$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $4FsX0.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $60a13ae980619827$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $4FsX0.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $60a13ae980619827$var$NUMBER_OF_BASE_SEGMENTS = 5, $60a13ae980619827$var$SEGMENT_SEPARATOR = ":", $60a13ae980619827$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($60a13ae980619827$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $4FsX0.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $60a13ae980619827$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($60a13ae980619827$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($60a13ae980619827$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};





// src/core/rules/cloud-id.ts
function $4c63b571df2930ff$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
    if (!cloudId.match(format)) throw new (0, $4FsX0.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $4c63b571df2930ff$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:;{}=]+(/[!a-zA-Z0-9\\-_.~@:;{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $4FsX0.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $4c63b571df2930ff$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $4c63b571df2930ff$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $4c63b571df2930ff$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $4FsX0.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $4c63b571df2930ff$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $4FsX0.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $4c63b571df2930ff$var$NUMBER_OF_ARI_SEGMENTS = 5, $4c63b571df2930ff$export$4c3a8cde7a55740b = class extends (0, $60a13ae980619827$export$3d09a5c28ff3e040) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $4c63b571df2930ff$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), Object.keys(ariProperties.resourceIdSegmentFormats)) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $60a13ae980619827$export$822bcd2b6f6774a1)(qualifier), (0, $60a13ae980619827$export$4f6e8fa90a16fdc4)(platformQualifier), $4c63b571df2930ff$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $4c63b571df2930ff$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $4c63b571df2930ff$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $4c63b571df2930ff$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, expectedKeys) {
        let regexpResult = new RegExp("^" + slug.replace(/\{(.*?)\}/g, "(?<$1>.*?)") + "$").exec(incomingSegments);
        if (!regexpResult) throw new (0, $4FsX0.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a;
            if (!((_a = regexpResult.groups) != null && _a[expectedKey])) throw new (0, $4FsX0.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $4c63b571df2930ff$var$NUMBER_OF_ATI_SEGMENTS = 4, $4c63b571df2930ff$var$AtiParser = class extends (0, $60a13ae980619827$export$3d09a5c28ff3e040) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $4c63b571df2930ff$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $60a13ae980619827$export$da331df28ad1f3d9)(qualifier), (0, $60a13ae980619827$export$4f6e8fa90a16fdc4)(platformQualifier), $4c63b571df2930ff$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $4c63b571df2930ff$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $60a13ae980619827$export$da331df28ad1f3d9)(qualifier), (0, $60a13ae980619827$export$4f6e8fa90a16fdc4)(platformQualifier), $4c63b571df2930ff$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $4c63b571df2930ff$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $4c63b571df2930ff$export$ab4b293d0121b8ee = class _Ati {
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $4c63b571df2930ff$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
};
module.exports["AriParser"] = $4c63b571df2930ff$export$4c3a8cde7a55740b;
module.exports["Ati"] = $4c63b571df2930ff$export$ab4b293d0121b8ee;

});

parcelRegister("4FsX0", function(module, exports) {
// src/errors.ts
var $366172c045611615$export$2191b9da168c6cf0 = class extends Error {
};
module.exports["ValidationError"] = $366172c045611615$export$2191b9da168c6cf0;

});

parcelRegister("ep3mz", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $FOT9i = parcelRequire("FOT9i");

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");

const $e24805fae35ad0b6$export$296aceb5cc7d453f = (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).shape({
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).symbol
    ]),
    contentIdLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    contentSlug: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    embeddedContentRender: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    queryHash: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    routeName: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number,
    searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    isLite: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'page',
        'blogpost',
        'whiteboard',
        'database',
        'embed'
    ])
});
const $e24805fae35ad0b6$var$actions = {
    setPageStore: (pageState)=>({ setState: setState })=>setState(pageState)
};
const $e24805fae35ad0b6$export$5bc91d282e4edb5e = {
    contentId: undefined,
    contentType: undefined,
    contentIdLoading: false,
    contentSlug: undefined,
    embeddedContentRender: undefined,
    queryHash: undefined,
    routeName: undefined,
    spaceKey: undefined,
    versionOverride: undefined,
    isLite: false
};
const $e24805fae35ad0b6$var$PageStore = (0, $1P1Tu.createStore)({
    name: 'PageStore',
    initialState: $e24805fae35ad0b6$export$5bc91d282e4edb5e,
    actions: $e24805fae35ad0b6$var$actions
});
const $e24805fae35ad0b6$export$18653b487e721221 = (0, $FOT9i.createContainer)($e24805fae35ad0b6$var$PageStore, {
    onInit: ()=>({ setState: setState }, pageState)=>{
            setState(pageState);
        },
    onUpdate: ()=>({ setState: setState }, pageState)=>{
            setState(pageState);
        }
});
const $e24805fae35ad0b6$export$59f09755fe720062 = (0, $j1v0l.createSubscriber)($e24805fae35ad0b6$var$PageStore);
const $e24805fae35ad0b6$export$d2bdb7c20492cc5 = (0, $9zUhf.createHook)($e24805fae35ad0b6$var$PageStore);
const $e24805fae35ad0b6$export$456b2a163af76e89 = (0, $9zUhf.createHook)($e24805fae35ad0b6$var$PageStore, {
    selector: (state)=>state.contentId
});
const $e24805fae35ad0b6$export$88a2d28db423ed67 = (0, $9zUhf.createHook)($e24805fae35ad0b6$var$PageStore, {
    selector: (state)=>state.spaceKey
});
const $e24805fae35ad0b6$export$1508d269525fc6e8 = (0, $9zUhf.createHook)($e24805fae35ad0b6$var$PageStore, {
    selector: (state)=>state.contentType
});
module.exports["pageStateShape"] = $e24805fae35ad0b6$export$296aceb5cc7d453f;
module.exports["initialPageState"] = $e24805fae35ad0b6$export$5bc91d282e4edb5e;
module.exports["PageStateContainer"] = $e24805fae35ad0b6$export$18653b487e721221;
module.exports["PageSubscriber"] = $e24805fae35ad0b6$export$59f09755fe720062;
module.exports["usePageState"] = $e24805fae35ad0b6$export$d2bdb7c20492cc5;
module.exports["usePageContentId"] = $e24805fae35ad0b6$export$456b2a163af76e89;
module.exports["usePageSpaceKey"] = $e24805fae35ad0b6$export$88a2d28db423ed67;
module.exports["useContentType"] = $e24805fae35ad0b6$export$1508d269525fc6e8;

});

parcelRegister("xQxzY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7hXu9 = parcelRequire("7hXu9");


var $9x4nt = parcelRequire("9x4nt");


var $kH7bh = parcelRequire("kH7bh");

const $3e40b354eb23a248$export$dd0a697e1782aedd = (...args)=>{
    const ufoContext = (0, $42omo.useContext)((0, $9x4nt.default));
    const apolloResult = (0, $7hXu9.useQuery)(...args);
    const [query] = args;
    const operationName = (0, $kH7bh.default)(query);
    const isLoading = apolloResult?.loading;
    (0, $42omo.useEffect)(()=>{
        if (isLoading) return ufoContext?.hold(operationName);
    }, [
        isLoading,
        operationName,
        ufoContext
    ]);
    return apolloResult;
};
module.exports["useQuery"] = $3e40b354eb23a248$export$dd0a697e1782aedd;

});

parcelRegister("7TH2w", function(module, exports) {
// same types defined in analytics-web-client but avoid creating dependency with that
const $c1d340ae8dab4627$export$a1562d08625f5d7e = 'ui';
const $c1d340ae8dab4627$export$947dac6c72b26f81 = 'track';
const $c1d340ae8dab4627$export$f1d537d508d2945a = 'screen';
const $c1d340ae8dab4627$export$12346a674644c156 = 'operational';
const $c1d340ae8dab4627$export$b055de0e665cb20c = 'unknown';
module.exports["UI_EVENT_TYPE"] = $c1d340ae8dab4627$export$a1562d08625f5d7e;
module.exports["TRACK_EVENT_TYPE"] = $c1d340ae8dab4627$export$947dac6c72b26f81;
module.exports["SCREEN_EVENT_TYPE"] = $c1d340ae8dab4627$export$f1d537d508d2945a;
module.exports["OPERATIONAL_EVENT_TYPE"] = $c1d340ae8dab4627$export$12346a674644c156;
module.exports["DEFAULT_SOURCE"] = $c1d340ae8dab4627$export$b055de0e665cb20c;

});

parcelRegister("kDuN4", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a6a1dbb8af9a9ed$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2xIMp = parcelRequire("2xIMp");


var $fFVny = parcelRequire("fFVny");


var $fTXBo = parcelRequire("fTXBo");

const $fcdbf3af0374115c$var$AnalyticsListener = ({ children: children, channel: channel, onEvent: onEvent })=>{
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = ()=>[], getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext } = (0, $fFVny.useAnalyticsContext)();
    const onEventRef = (0, $fTXBo.useTrackedRef)(onEvent);
    const channelRef = (0, $fTXBo.useTrackedRef)(channel);
    const getAnalyticsEventHandlers = (0, $42omo.useCallback)(()=>{
        const thisHandler = (event, eventChannel)=>{
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler,
            ...getAtlaskitAnalyticsEventHandlers()
        ];
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    const value = (0, $42omo.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2xIMp.default).Provider, {
        value: value,
        children: children
    });
};
var $fcdbf3af0374115c$export$2e2bcd8739ae039 = $fcdbf3af0374115c$var$AnalyticsListener;


var $2a6a1dbb8af9a9ed$export$2e2bcd8739ae039 = (0, $fcdbf3af0374115c$export$2e2bcd8739ae039);

});

parcelRegister("j1Ss3", function(module, exports) {
$parcel$export(module.exports, "useQuery", () => (parcelRequire("xQxzY")).useQuery);
$parcel$export(module.exports, "useLazyQuery", () => (parcelRequire("jxs8y")).useLazyQuery);
$parcel$export(module.exports, "useMutation", () => (parcelRequire("1KmJq")).useMutation);
$parcel$export(module.exports, "useApolloClient", () => (parcelRequire("7hXu9")).useApolloClient);
$parcel$export(module.exports, "ApolloProvider", () => (parcelRequire("3sW76")).ApolloProvider);
$parcel$export(module.exports, "ApolloConsumer", () => (parcelRequire("3sW76")).ApolloConsumer);
$parcel$export(module.exports, "withApollo", () => (parcelRequire("bojLi")).withApollo);
// exports of our version of react-apollo's components and hooks, with proper integration for UFO holds


var $7hXu9 = parcelRequire("7hXu9");

var $jxs8y = parcelRequire("jxs8y");

var $1KmJq = parcelRequire("1KmJq");

var $xQxzY = parcelRequire("xQxzY");


var $3sW76 = parcelRequire("3sW76");

var $bojLi = parcelRequire("bojLi");


});

parcelRegister("jxs8y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7hXu9 = parcelRequire("7hXu9");


var $9x4nt = parcelRequire("9x4nt");


var $kH7bh = parcelRequire("kH7bh");

const $b3cf7016ab40112b$export$fd83eea6ecd2d8fa = (...args)=>{
    const ufoContext = (0, $42omo.useContext)((0, $9x4nt.default));
    const apolloResult = (0, $7hXu9.useLazyQuery)(...args);
    const [query] = args;
    const operationName = (0, $kH7bh.default)(query);
    const isLoading = apolloResult?.[1]?.loading;
    (0, $42omo.useEffect)(()=>{
        if (isLoading) return ufoContext?.hold(operationName);
    }, [
        isLoading,
        operationName,
        ufoContext
    ]);
    return apolloResult;
};
module.exports["useLazyQuery"] = $b3cf7016ab40112b$export$fd83eea6ecd2d8fa;

});

parcelRegister("gYXuI", function(module, exports) {
// In order to allow us to fetch any data for draft content always we need to specify the status
const $0a2b5b16106e7926$export$3211963609921415 = [
    'current',
    'draft',
    'archived'
];
module.exports["ALLOWED_CONTENT_STATUSES"] = $0a2b5b16106e7926$export$3211963609921415;

});

parcelRegister("hL5Va", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $f12d759194a93053$export$db66a07381b14db8 = (0, $eSUdr.default)`query PageRestrictionsQuery($contentId:ID!$status:[String]$includeAncestors:Boolean!){singleContent(id:$contentId status:$status){id hasInheritedRestrictions hasViewRestrictions hasRestrictions ancestors@include(if:$includeAncestors){id title hasRestrictions links{webui}}}}`;
module.exports["PageRestrictionsQuery"] = $f12d759194a93053$export$db66a07381b14db8;

});

parcelRegister("lztxY", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $3b0f8352614b0ede$export$abc0031a08dd95cf = (0, $eSUdr.default)`query getDraftContentAppearanceProperty($contentId:ID$status:[String]){content(id:$contentId status:$status){nodes{id appearanceDraft:properties(key:"content-appearance-draft"){nodes{id key value version{number}}}}}}`;
const $3b0f8352614b0ede$export$aed0dcf8ce9eb36 = (0, $eSUdr.default)`query getPublishedContentAppearanceProperty($contentId:ID$status:[String]){content(id:$contentId status:$status){nodes{id appearancePublished:properties(key:"content-appearance-published"){nodes{id key value version{number}}}}}}`;
module.exports["getDraftContentAppearanceProperty"] = $3b0f8352614b0ede$export$abc0031a08dd95cf;
module.exports["getPublishedContentAppearanceProperty"] = $3b0f8352614b0ede$export$aed0dcf8ce9eb36;

});

parcelRegister("8z9j5", function(module, exports) {

var $a9dFP = parcelRequire("a9dFP");


var $fwSE5 = parcelRequire("fwSE5");


var $j6S25 = parcelRequire("j6S25");

const $b2dfb7fd832b1de2$var$isThemeColorMode = (colorMode)=>{
    return (0, $fwSE5.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};
const $b2dfb7fd832b1de2$var$getGlobalTheme = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $a9dFP.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $a9dFP.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $j6S25.themeStringToObject)(theme),
        ...$b2dfb7fd832b1de2$var$isThemeColorMode(colorMode) && {
            colorMode: colorMode
        }
    };
};
var $b2dfb7fd832b1de2$export$2e2bcd8739ae039 = $b2dfb7fd832b1de2$var$getGlobalTheme;
module.exports["default"] = $b2dfb7fd832b1de2$export$2e2bcd8739ae039;

});

parcelRegister("60yhz", function(module, exports) {

var $a9dFP = parcelRequire("a9dFP");


var $8z9j5 = parcelRequire("8z9j5");

class $2b02187130652f29$export$2e2bcd8739ae039 {
    observe() {
        if (!$2b02187130652f29$export$2e2bcd8739ae039.observer) {
            $2b02187130652f29$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                const theme = (0, $8z9j5.default)();
                $2b02187130652f29$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $2b02187130652f29$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $a9dFP.THEME_DATA_ATTRIBUTE),
                    (0, $a9dFP.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $2b02187130652f29$export$2e2bcd8739ae039.callbacks.delete(this.callback);
        if ($2b02187130652f29$export$2e2bcd8739ae039.callbacks.size === 0 && $2b02187130652f29$export$2e2bcd8739ae039.observer) {
            $2b02187130652f29$export$2e2bcd8739ae039.observer.disconnect();
            $2b02187130652f29$export$2e2bcd8739ae039.observer = null;
        }
    }
    constructor(callback){
        this.legacyObserver = null;
        this.callback = void 0;
        this.callback = callback;
        $2b02187130652f29$export$2e2bcd8739ae039.callbacks.add(callback);
    }
}
$2b02187130652f29$export$2e2bcd8739ae039.observer = null;
$2b02187130652f29$export$2e2bcd8739ae039.callbacks = new Set();
module.exports["default"] = $2b02187130652f29$export$2e2bcd8739ae039;

});

parcelRegister("6fnsQ", function(module, exports) {
// Reds
const $4300ebad5a984131$export$4b84fd0e2c617bd = '#FFEBE6';
const $4300ebad5a984131$export$b34b069eff244586 = '#FFBDAD';
const $4300ebad5a984131$export$be802dd0d8b57f35 = '#FF8F73';
const $4300ebad5a984131$export$60847d42f9da92a6 = '#FF7452';
const $4300ebad5a984131$export$4a7404f376229999 = '#FF5630';
const $4300ebad5a984131$export$2010d0fb4295b346 = '#DE350B';
const $4300ebad5a984131$export$2837b5a1a71d5c02 = '#BF2600';
const $4300ebad5a984131$export$8d9596b529bbb9cf = '#FFFAE6';
const $4300ebad5a984131$export$41060a744ab0b7ae = '#FFF0B3';
const $4300ebad5a984131$export$1cc05bbbf340e559 = '#FFE380';
const $4300ebad5a984131$export$5aae31392d72caaa = '#FFC400';
const $4300ebad5a984131$export$c6930421db9fa514 = '#FFAB00';
const $4300ebad5a984131$export$59619663aa6500fb = '#FF991F';
const $4300ebad5a984131$export$874739ea9e379ab6 = '#FF8B00';
const $4300ebad5a984131$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $4300ebad5a984131$export$69a3bf21b9686c2b = '#ABF5D1';
const $4300ebad5a984131$export$afbce1382ec95f73 = '#79F2C0';
const $4300ebad5a984131$export$747d86715d4175de = '#57D9A3';
const $4300ebad5a984131$export$940e1f69e873f202 = '#36B37E';
const $4300ebad5a984131$export$a49394138f7b8e85 = '#00875A';
const $4300ebad5a984131$export$6fa04827ac68a4fb = '#006644';
const $4300ebad5a984131$export$226de0355ed012f8 = '#DEEBFF';
const $4300ebad5a984131$export$8c13c2ee36917869 = '#B3D4FF';
const $4300ebad5a984131$export$ecfc1dff386a3e7a = '#4C9AFF';
const $4300ebad5a984131$export$215b7063051591f1 = '#2684FF';
const $4300ebad5a984131$export$e62e8919cca44969 = '#0065FF';
const $4300ebad5a984131$export$b3de0ae08da2ce64 = '#0052CC';
const $4300ebad5a984131$export$a6ee3d71bc067634 = '#0747A6';
const $4300ebad5a984131$export$67f15409e87642a1 = '#669DF1';
const $4300ebad5a984131$export$f0539dbc42dbb067 = '#8FB8F6';
const $4300ebad5a984131$export$363e4475840015bb = '#EAE6FF';
const $4300ebad5a984131$export$4b0a4417ed59760f = '#C0B6F2';
const $4300ebad5a984131$export$6011520a64d9a187 = '#998DD9';
const $4300ebad5a984131$export$a7175d4e9206bc80 = '#8777D9';
const $4300ebad5a984131$export$b48405b95304b5a1 = '#6554C0';
const $4300ebad5a984131$export$c71e4279dd54a18d = '#5243AA';
const $4300ebad5a984131$export$147899de772240ec = '#403294';
const $4300ebad5a984131$export$2cf711fe14c66f06 = '#E6FCFF';
const $4300ebad5a984131$export$7a8f4d33f6f9772c = '#B3F5FF';
const $4300ebad5a984131$export$776c9c497ef08533 = '#79E2F2';
const $4300ebad5a984131$export$69cb3ca10c1e330e = '#00C7E6';
const $4300ebad5a984131$export$9dc1ef0f3f48059b = '#00B8D9';
const $4300ebad5a984131$export$7c835c78b6fcdef8 = '#00A3BF';
const $4300ebad5a984131$export$6036577f95c3877e = '#008DA6';
const $4300ebad5a984131$export$29a4f05edc054374 = '#FFFFFF';
const $4300ebad5a984131$export$e655ef011c4aa1a2 = '#FAFBFC';
const $4300ebad5a984131$export$9fdfb749e33cdf97 = '#F4F5F7';
const $4300ebad5a984131$export$3e51e8f1440314ba = '#EBECF0';
const $4300ebad5a984131$export$1ce2d1575d444ceb = '#DFE1E6';
const $4300ebad5a984131$export$8754fc7e6d8b3000 = '#C1C7D0';
const $4300ebad5a984131$export$c2e91cbeada39b8b = '#B3BAC5';
const $4300ebad5a984131$export$5f71e19f3a7ad9de = '#A5ADBA';
const $4300ebad5a984131$export$eaa8c8a70ac22806 = '#97A0AF';
const $4300ebad5a984131$export$7c87d337fb91a97d = '#8993A4';
const $4300ebad5a984131$export$d6447c357493214f = '#7A869A';
const $4300ebad5a984131$export$f563ee71e9ee74cd = '#6B778C';
const $4300ebad5a984131$export$e2ef2124cf4024b1 = '#5E6C84';
const $4300ebad5a984131$export$eece5f492e429f08 = '#505F79';
const $4300ebad5a984131$export$c39c0fe0f26207ae = '#42526E';
const $4300ebad5a984131$export$7090862dc3038a9f = '#344563';
const $4300ebad5a984131$export$ad0bacf983b7ddaa = '#253858';
const $4300ebad5a984131$export$7d61b15e0da132af = '#172B4D';
const $4300ebad5a984131$export$fbda843f0a27fe96 = '#091E42';
const $4300ebad5a984131$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $4300ebad5a984131$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $4300ebad5a984131$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $4300ebad5a984131$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $4300ebad5a984131$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $4300ebad5a984131$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $4300ebad5a984131$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $4300ebad5a984131$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $4300ebad5a984131$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $4300ebad5a984131$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $4300ebad5a984131$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $4300ebad5a984131$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $4300ebad5a984131$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $4300ebad5a984131$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $4300ebad5a984131$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $4300ebad5a984131$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $4300ebad5a984131$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $4300ebad5a984131$export$2f6319cf7d736c2a = '#E6EDFA';
const $4300ebad5a984131$export$95126bc8884d6634 = '#DCE5F5';
const $4300ebad5a984131$export$8338d8c35d44ff1 = '#CED9EB';
const $4300ebad5a984131$export$5368d76ae4fbbda7 = '#B8C7E0';
const $4300ebad5a984131$export$9f0a771d16ec8d36 = '#ABBBD6';
const $4300ebad5a984131$export$abcf8c38338b4aa5 = '#9FB0CC';
const $4300ebad5a984131$export$97e81faa16a182c7 = '#8C9CB8';
const $4300ebad5a984131$export$bfe21c59123ecf33 = '#7988A3';
const $4300ebad5a984131$export$ee82aa2ea6a1558 = '#67758F';
const $4300ebad5a984131$export$682927c6ed76be02 = '#56637A';
const $4300ebad5a984131$export$91fd9994c5be9757 = '#455166';
const $4300ebad5a984131$export$d281fbfe3cff2df6 = '#3B475C';
const $4300ebad5a984131$export$3902c91d8b98a753 = '#313D52';
const $4300ebad5a984131$export$8e8133c1ba5845b5 = '#283447';
const $4300ebad5a984131$export$33ff357f6620b39 = '#202B3D';
const $4300ebad5a984131$export$633847cf062b69e0 = '#1B2638';
const $4300ebad5a984131$export$9776a6e503bdbf76 = '#121A29';
const $4300ebad5a984131$export$6c813d5160dff5db = '#0E1624';
const $4300ebad5a984131$export$3d4f271a500072a = '#0D1424';
const $4300ebad5a984131$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $4300ebad5a984131$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $4300ebad5a984131$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $4300ebad5a984131$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $4300ebad5a984131$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $4300ebad5a984131$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $4300ebad5a984131$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $4300ebad5a984131$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $4300ebad5a984131$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $4300ebad5a984131$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $4300ebad5a984131$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $4300ebad5a984131$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $4300ebad5a984131$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $4300ebad5a984131$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $4300ebad5a984131$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $4300ebad5a984131$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $4300ebad5a984131$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $4300ebad5a984131$export$d2adc5dedf09fced = '#292A2E';
const $4300ebad5a984131$export$f51762073d2bb381 = '#94C748';
const $4300ebad5a984131$export$95e26d54def96891 = '#B3DF72';
module.exports["R50"] = $4300ebad5a984131$export$4b84fd0e2c617bd;
module.exports["R75"] = $4300ebad5a984131$export$b34b069eff244586;
module.exports["R100"] = $4300ebad5a984131$export$be802dd0d8b57f35;
module.exports["R200"] = $4300ebad5a984131$export$60847d42f9da92a6;
module.exports["R300"] = $4300ebad5a984131$export$4a7404f376229999;
module.exports["R400"] = $4300ebad5a984131$export$2010d0fb4295b346;
module.exports["R500"] = $4300ebad5a984131$export$2837b5a1a71d5c02;
module.exports["Y50"] = $4300ebad5a984131$export$8d9596b529bbb9cf;
module.exports["Y75"] = $4300ebad5a984131$export$41060a744ab0b7ae;
module.exports["Y100"] = $4300ebad5a984131$export$1cc05bbbf340e559;
module.exports["Y200"] = $4300ebad5a984131$export$5aae31392d72caaa;
module.exports["Y300"] = $4300ebad5a984131$export$c6930421db9fa514;
module.exports["Y400"] = $4300ebad5a984131$export$59619663aa6500fb;
module.exports["Y500"] = $4300ebad5a984131$export$874739ea9e379ab6;
module.exports["G50"] = $4300ebad5a984131$export$8a6341c32b6a3ee6;
module.exports["G75"] = $4300ebad5a984131$export$69a3bf21b9686c2b;
module.exports["G100"] = $4300ebad5a984131$export$afbce1382ec95f73;
module.exports["G200"] = $4300ebad5a984131$export$747d86715d4175de;
module.exports["G300"] = $4300ebad5a984131$export$940e1f69e873f202;
module.exports["G400"] = $4300ebad5a984131$export$a49394138f7b8e85;
module.exports["G500"] = $4300ebad5a984131$export$6fa04827ac68a4fb;
module.exports["B50"] = $4300ebad5a984131$export$226de0355ed012f8;
module.exports["B75"] = $4300ebad5a984131$export$8c13c2ee36917869;
module.exports["B100"] = $4300ebad5a984131$export$ecfc1dff386a3e7a;
module.exports["B200"] = $4300ebad5a984131$export$215b7063051591f1;
module.exports["B300"] = $4300ebad5a984131$export$e62e8919cca44969;
module.exports["B400"] = $4300ebad5a984131$export$b3de0ae08da2ce64;
module.exports["B500"] = $4300ebad5a984131$export$a6ee3d71bc067634;
module.exports["B600"] = $4300ebad5a984131$export$67f15409e87642a1;
module.exports["B700"] = $4300ebad5a984131$export$f0539dbc42dbb067;
module.exports["P50"] = $4300ebad5a984131$export$363e4475840015bb;
module.exports["P75"] = $4300ebad5a984131$export$4b0a4417ed59760f;
module.exports["P100"] = $4300ebad5a984131$export$6011520a64d9a187;
module.exports["P200"] = $4300ebad5a984131$export$a7175d4e9206bc80;
module.exports["P300"] = $4300ebad5a984131$export$b48405b95304b5a1;
module.exports["P400"] = $4300ebad5a984131$export$c71e4279dd54a18d;
module.exports["P500"] = $4300ebad5a984131$export$147899de772240ec;
module.exports["T50"] = $4300ebad5a984131$export$2cf711fe14c66f06;
module.exports["T75"] = $4300ebad5a984131$export$7a8f4d33f6f9772c;
module.exports["T100"] = $4300ebad5a984131$export$776c9c497ef08533;
module.exports["T200"] = $4300ebad5a984131$export$69cb3ca10c1e330e;
module.exports["T300"] = $4300ebad5a984131$export$9dc1ef0f3f48059b;
module.exports["T400"] = $4300ebad5a984131$export$7c835c78b6fcdef8;
module.exports["T500"] = $4300ebad5a984131$export$6036577f95c3877e;
module.exports["N0"] = $4300ebad5a984131$export$29a4f05edc054374;
module.exports["N10"] = $4300ebad5a984131$export$e655ef011c4aa1a2;
module.exports["N20"] = $4300ebad5a984131$export$9fdfb749e33cdf97;
module.exports["N30"] = $4300ebad5a984131$export$3e51e8f1440314ba;
module.exports["N40"] = $4300ebad5a984131$export$1ce2d1575d444ceb;
module.exports["N50"] = $4300ebad5a984131$export$8754fc7e6d8b3000;
module.exports["N60"] = $4300ebad5a984131$export$c2e91cbeada39b8b;
module.exports["N70"] = $4300ebad5a984131$export$5f71e19f3a7ad9de;
module.exports["N80"] = $4300ebad5a984131$export$eaa8c8a70ac22806;
module.exports["N90"] = $4300ebad5a984131$export$7c87d337fb91a97d;
module.exports["N100"] = $4300ebad5a984131$export$d6447c357493214f;
module.exports["N200"] = $4300ebad5a984131$export$f563ee71e9ee74cd;
module.exports["N300"] = $4300ebad5a984131$export$e2ef2124cf4024b1;
module.exports["N400"] = $4300ebad5a984131$export$eece5f492e429f08;
module.exports["N500"] = $4300ebad5a984131$export$c39c0fe0f26207ae;
module.exports["N600"] = $4300ebad5a984131$export$7090862dc3038a9f;
module.exports["N700"] = $4300ebad5a984131$export$ad0bacf983b7ddaa;
module.exports["N800"] = $4300ebad5a984131$export$7d61b15e0da132af;
module.exports["N900"] = $4300ebad5a984131$export$fbda843f0a27fe96;
module.exports["N10A"] = $4300ebad5a984131$export$791e57b27ca738ef;
module.exports["N20A"] = $4300ebad5a984131$export$8d43898f60b96a82;
module.exports["N30A"] = $4300ebad5a984131$export$920c0d5c49070351;
module.exports["N40A"] = $4300ebad5a984131$export$46987b49aab6d1a8;
module.exports["N50A"] = $4300ebad5a984131$export$7d3359664e8bb0e5;
module.exports["N60A"] = $4300ebad5a984131$export$d2d3bedfb276cac0;
module.exports["N70A"] = $4300ebad5a984131$export$6e5e7499ff054f6d;
module.exports["N80A"] = $4300ebad5a984131$export$59264b346c877fa7;
module.exports["N90A"] = $4300ebad5a984131$export$d092757d7c64925c;
module.exports["N100A"] = $4300ebad5a984131$export$486ab785e4bac3c6;
module.exports["N200A"] = $4300ebad5a984131$export$fba592bbc6419fea;
module.exports["N300A"] = $4300ebad5a984131$export$13609db0e6812ab8;
module.exports["N400A"] = $4300ebad5a984131$export$fbae4efaa892d883;
module.exports["N500A"] = $4300ebad5a984131$export$f13946d26f440ce6;
module.exports["N600A"] = $4300ebad5a984131$export$19f58225ac52a306;
module.exports["N700A"] = $4300ebad5a984131$export$6384f09da70e7b62;
module.exports["N800A"] = $4300ebad5a984131$export$d0dccc730683edc2;
module.exports["DN900"] = $4300ebad5a984131$export$2f6319cf7d736c2a;
module.exports["DN800"] = $4300ebad5a984131$export$95126bc8884d6634;
module.exports["DN700"] = $4300ebad5a984131$export$8338d8c35d44ff1;
module.exports["DN600"] = $4300ebad5a984131$export$5368d76ae4fbbda7;
module.exports["DN500"] = $4300ebad5a984131$export$9f0a771d16ec8d36;
module.exports["DN400"] = $4300ebad5a984131$export$abcf8c38338b4aa5;
module.exports["DN300"] = $4300ebad5a984131$export$97e81faa16a182c7;
module.exports["DN200"] = $4300ebad5a984131$export$bfe21c59123ecf33;
module.exports["DN100"] = $4300ebad5a984131$export$ee82aa2ea6a1558;
module.exports["DN90"] = $4300ebad5a984131$export$682927c6ed76be02;
module.exports["DN80"] = $4300ebad5a984131$export$91fd9994c5be9757;
module.exports["DN70"] = $4300ebad5a984131$export$d281fbfe3cff2df6;
module.exports["DN60"] = $4300ebad5a984131$export$3902c91d8b98a753;
module.exports["DN50"] = $4300ebad5a984131$export$8e8133c1ba5845b5;
module.exports["DN40"] = $4300ebad5a984131$export$33ff357f6620b39;
module.exports["DN30"] = $4300ebad5a984131$export$633847cf062b69e0;
module.exports["DN20"] = $4300ebad5a984131$export$9776a6e503bdbf76;
module.exports["DN10"] = $4300ebad5a984131$export$6c813d5160dff5db;
module.exports["DN0"] = $4300ebad5a984131$export$3d4f271a500072a;
module.exports["DN800A"] = $4300ebad5a984131$export$fe151285c22759ec;
module.exports["DN700A"] = $4300ebad5a984131$export$a101c6190d0da34;
module.exports["DN600A"] = $4300ebad5a984131$export$4b16f52932fda51;
module.exports["DN500A"] = $4300ebad5a984131$export$a74bcd7b9845b0d8;
module.exports["DN400A"] = $4300ebad5a984131$export$9209c179316d1751;
module.exports["DN300A"] = $4300ebad5a984131$export$88f55133f636c8dd;
module.exports["DN200A"] = $4300ebad5a984131$export$51126f85d1009512;
module.exports["DN100A"] = $4300ebad5a984131$export$a069b547bd23af78;
module.exports["DN90A"] = $4300ebad5a984131$export$40cce05af3b2600a;
module.exports["DN80A"] = $4300ebad5a984131$export$b78942185925a0d;
module.exports["DN70A"] = $4300ebad5a984131$export$e058fb44b8eaafca;
module.exports["DN60A"] = $4300ebad5a984131$export$92b0b8de26920c18;
module.exports["DN50A"] = $4300ebad5a984131$export$67564f7459d3fc9e;
module.exports["DN40A"] = $4300ebad5a984131$export$77868e1ca884ffa3;
module.exports["DN30A"] = $4300ebad5a984131$export$2afd71d7d3ea2cd5;
module.exports["DN20A"] = $4300ebad5a984131$export$f2a0acaab9972c70;
module.exports["DN10A"] = $4300ebad5a984131$export$9ab70e67d6475361;
module.exports["T30"] = $4300ebad5a984131$export$d2adc5dedf09fced;
module.exports["L50"] = $4300ebad5a984131$export$f51762073d2bb381;
module.exports["L75"] = $4300ebad5a984131$export$95e26d54def96891;

});

parcelRegister("3gadb", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");





var $inPa6 = parcelRequire("inPa6");


var $fTXBo = parcelRequire("fTXBo");

function $5975fb3f46b99358$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $fTXBo.useTrackedRef)(analyticsData);
    const fnRef = (0, $fTXBo.useTrackedRef)(fn);
    const handler = (0, $42omo.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $ee7An = parcelRequire("ee7An");


var $cr6pC = parcelRequire("cr6pC");


var $g6aM3 = parcelRequire("g6aM3");


var $if5rb = parcelRequire("if5rb");


var $g9Srd = parcelRequire("g9Srd");

var $fT2ta = parcelRequire("fT2ta");


var $dh538 = parcelRequire("dh538");


var $lqsSp = parcelRequire("lqsSp");


var $caX7N = parcelRequire("caX7N");


var $dTk3A = parcelRequire("dTk3A");

/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 


const $de67ee6726340b5c$var$registrations = new Set();
let $de67ee6726340b5c$var$cleanupEndEventListeners = null;
function $de67ee6726340b5c$var$onDragStart() {
    if ($de67ee6726340b5c$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $de67ee6726340b5c$var$cleanupEndEventListeners = (0, $fFa3V.bindAll)(window, [
        {
            type: 'dragend',
            listener: $de67ee6726340b5c$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $de67ee6726340b5c$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $de67ee6726340b5c$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($de67ee6726340b5c$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $de67ee6726340b5c$var$onDragEnd() {
    $de67ee6726340b5c$var$cleanupEndEventListeners?.();
    $de67ee6726340b5c$var$cleanupEndEventListeners = null;
    const clone = Array.from($de67ee6726340b5c$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $de67ee6726340b5c$var$bindStartEvents() {
    return (0, $fFa3V.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $de67ee6726340b5c$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $de67ee6726340b5c$var$onDragStart
        }
    ]);
}
let $de67ee6726340b5c$var$cleanupStartEventListeners = null;
function $de67ee6726340b5c$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$de67ee6726340b5c$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $de67ee6726340b5c$var$cleanupStartEventListeners = $de67ee6726340b5c$var$bindStartEvents();
    $de67ee6726340b5c$var$registrations.add(registration);
    /**
	 * The reasoning for this behavior is so that if a tooltip mounts during
	 * a drag it can still be suppressed.
	 *
	 * We use a separate callback instead of onDragStart to avoid infinite loops.
	 */ registration.onRegister({
        isDragging: $de67ee6726340b5c$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $de67ee6726340b5c$var$registrations.delete(registration);
        if ($de67ee6726340b5c$var$registrations.size === 0) {
            $de67ee6726340b5c$var$cleanupStartEventListeners?.();
            $de67ee6726340b5c$var$cleanupStartEventListeners = null;
        }
    };
}


let $376da88e101dc401$var$delayId = null;
function $376da88e101dc401$export$eaf678f6f93f5250() {
    if ($376da88e101dc401$var$delayId != null) {
        window.clearTimeout($376da88e101dc401$var$delayId);
        $376da88e101dc401$var$delayId = null;
    }
}
function $376da88e101dc401$export$5f4d6617421d489b(fn, delay) {
    $376da88e101dc401$export$eaf678f6f93f5250();
    $376da88e101dc401$var$delayId = window.setTimeout(()=>{
        $376da88e101dc401$var$delayId = null;
        fn();
    }, delay);
}


let $65794b5be37fefa8$var$active = null;
function $65794b5be37fefa8$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($65794b5be37fefa8$var$active && $65794b5be37fefa8$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $376da88e101dc401$export$eaf678f6f93f5250)();
            $65794b5be37fefa8$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $376da88e101dc401$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $376da88e101dc401$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $376da88e101dc401$export$5f4d6617421d489b)(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        const showImmediately = Boolean($65794b5be37fefa8$var$active && $65794b5be37fefa8$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($65794b5be37fefa8$var$active) {
            (0, $376da88e101dc401$export$eaf678f6f93f5250)();
            $65794b5be37fefa8$var$active.entry.hide({
                isImmediate: true
            });
            $65794b5be37fefa8$var$active.entry.done();
            $65794b5be37fefa8$var$active = null;
        }
        // this tooltip is now the active tooltip
        $65794b5be37fefa8$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $376da88e101dc401$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}



var $c0qxy = parcelRequire("c0qxy");

function $cf844e3a7d1984bc$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $c0qxy.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");





var $afneb = parcelRequire("afneb");

const $bf8463e499a7348e$var$styles = {
    base: "_2rkofajl _11c8dcr7 _vchhusvi _p12fp3fh _bfhkcdhy _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
    baseRefreshedPadding: "_1q511b66 _85i51b66",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
}; /**
    * Used as the default tooltip container component for the exported `Tooltip` component.
    * Adds some styles to the tooltip primitive.
    */ 
const $bf8463e499a7348e$var$TooltipContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $afneb.default), {
        ref: ref,
        style: style,
        className: (0, $gMc0m.default)([
            $bf8463e499a7348e$var$styles.base,
            (0, $dh538.fg)('platform-dst-tooltip-shortcuts') && $bf8463e499a7348e$var$styles.baseRefreshedPadding,
            truncate && $bf8463e499a7348e$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        children: children
    });
});
$bf8463e499a7348e$var$TooltipContainer.displayName = 'TooltipContainer';
var $bf8463e499a7348e$export$2e2bcd8739ae039 = $bf8463e499a7348e$var$TooltipContainer;


function $46554e5432af7c58$export$642213d516a9b928(mouseCoordinates) {
    const safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    const getBoundingClientRect = ()=>({
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        });
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}


const $2caa4a7e85ae2d24$var$tooltipZIndex = (0, $dTk3A.layers).tooltip();
const $2caa4a7e85ae2d24$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
// Inverts motion direction
const $2caa4a7e85ae2d24$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $2caa4a7e85ae2d24$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $2caa4a7e85ae2d24$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
component: Container = (0, $bf8463e499a7348e$export$2e2bcd8739ae039), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $ee7An.default), onHide: onHide = (0, $ee7An.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false, shortcut: shortcut }) {
    const tooltipPosition = position === 'mouse' ? mousePosition : position;
    const onShowHandler = (0, $5975fb3f46b99358$export$1a04351537078b55)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$2caa4a7e85ae2d24$var$analyticsAttributes
    });
    const onHideHandler = (0, $5975fb3f46b99358$export$1a04351537078b55)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$2caa4a7e85ae2d24$var$analyticsAttributes
    });
    const apiRef = (0, $42omo.useRef)(null);
    const [state, setState] = (0, $42omo.useState)('hide');
    const targetRef = (0, $42omo.useRef)(null);
    const containerRef = (0, $42omo.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $42omo.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $g6aM3.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $g6aM3.default)(onShowHandler);
    const onHideHandlerStable = (0, $g6aM3.default)(onHideHandler);
    const delayStable = (0, $g6aM3.default)(delay);
    const canAppearStable = (0, $g6aM3.default)(canAppear);
    const hasCalledShowHandler = (0, $42omo.useRef)(false);
    const start = (0, $42omo.useCallback)((api)=>{
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $42omo.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $42omo.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $42omo.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return (0, $de67ee6726340b5c$export$6503ec6e8aabbaf)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    const tryShowTooltip = (0, $42omo.useCallback)((source)=>{
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !canAppearStable.current?.()) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        const api = (0, $65794b5be37fefa8$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    const hideTooltipOnEsc = (0, $42omo.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $cr6pC.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $42omo.useEffect)(()=>{
        if (state === 'hide') return 0, $ee7An.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    const onClick = (0, $42omo.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $42omo.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        const source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $46554e5432af7c58$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $42omo.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = position === 'mouse' ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePosition = (0, $46554e5432af7c58$export$642213d516a9b928)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    const onMouseOverTooltip = (0, $42omo.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $42omo.useCallback)((e)=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible') && (0, $dh538.fg)('platform-tooltip-focus-visible-new')) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $42omo.useCallback)(()=>{
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $42omo.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    const handleOpenLayerObserverCloseSignal = (0, $42omo.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $if5rb.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        if (position === 'mouse' && apiRef.current?.mousePosition) return apiRef.current?.mousePosition;
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $cf844e3a7d1984bc$export$2e2bcd8739ae039)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = `${testId}--container`;
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $42omo.useEffect)(()=>{
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
            // attribute back into the tooltipTriggerProps and make it required
            // instead of optional in `types`
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    children({
                        ...tooltipTriggerProps,
                        'aria-describedby': tooltipIdForHiddenContent,
                        ref: setDirectRef
                    }),
                    hiddenContent
                ]
            }) : // @ts-ignore
            /*#__PURE__*/ (0, $l998X.jsxs)(CastTargetContainer, {
                ...tooltipTriggerProps,
                ref: setImplicitRefFromChildren,
                /**
     * TODO: Why is role="presentation" added?
     * - Is it only to "remove" the `Container` from screen readers?
     * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
     * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
     */ role: "presentation",
                children: [
                    children,
                    hiddenContent
                ]
            }),
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
                zIndex: $2caa4a7e85ae2d24$var$tooltipZIndex,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lqsSp.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        // Invert the entrance and exit directions.
                        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
                        // This gives the effect the tooltip is appearing from the target
                        const direction = position === 'mouse' ? undefined : $2caa4a7e85ae2d24$var$invertedDirection[$2caa4a7e85ae2d24$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $l998X.jsx)(Container, {
                                        ref: ref,
                                        /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        shortcut: shortcut,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
var $2caa4a7e85ae2d24$export$2e2bcd8739ae039 = $2caa4a7e85ae2d24$var$Tooltip;
module.exports["default"] = $2caa4a7e85ae2d24$export$2e2bcd8739ae039;

});

parcelRegister("cr6pC", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed62970505a64678$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $4JWgN = parcelRequire("4JWgN");

function $ed62970505a64678$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $42omo.useRef)(false);
    const onKeyDown = (0, $42omo.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $4JWgN.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $42omo.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $42omo.useEffect)(()=>{
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $fFa3V.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});

parcelRegister("4JWgN", function(module, exports) {
/**
 * Character key codes which can be used in keyboard events.
 */ const $86459c7074d8d3c8$export$390330c10ff2b9a1 = 'ArrowUp';
const $86459c7074d8d3c8$export$a80636c6f41931fe = 'ArrowDown';
const $86459c7074d8d3c8$export$4af703091671bc = 'Home';
const $86459c7074d8d3c8$export$e2bc30913faa5db7 = 'End';
const $86459c7074d8d3c8$export$10f6869ed0a7d75b = 'Tab';
const $86459c7074d8d3c8$export$8152f929a25a0ff4 = 'Enter';
const $86459c7074d8d3c8$export$e51a3576c045c8d5 = 'Space';
const $86459c7074d8d3c8$export$2bb790b9008907b4 = 'Escape';
module.exports["KEY_UP"] = $86459c7074d8d3c8$export$390330c10ff2b9a1;
module.exports["KEY_DOWN"] = $86459c7074d8d3c8$export$a80636c6f41931fe;
module.exports["KEY_HOME"] = $86459c7074d8d3c8$export$4af703091671bc;
module.exports["KEY_END"] = $86459c7074d8d3c8$export$e2bc30913faa5db7;
module.exports["KEY_TAB"] = $86459c7074d8d3c8$export$10f6869ed0a7d75b;
module.exports["KEY_ENTER"] = $86459c7074d8d3c8$export$8152f929a25a0ff4;
module.exports["KEY_SPACE"] = $86459c7074d8d3c8$export$e51a3576c045c8d5;
module.exports["ESCAPE"] = $86459c7074d8d3c8$export$2bb790b9008907b4;

});

parcelRegister("g6aM3", function(module, exports) {
$parcel$export(module.exports, "default", () => $67db7a8b3e03080f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $67db7a8b3e03080f$export$2e2bcd8739ae039(value) {
    const ref = (0, $42omo.useRef)(value);
    (0, $42omo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("if5rb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iHNqU = parcelRequire("iHNqU");


var $4pUFZ = parcelRequire("4pUFZ");

function $c5d9ea856be07e85$export$469bb693f11edc7f({ isOpen: isOpen, type: type, onClose: onClose }) {
    const context = (0, $42omo.useContext)((0, $iHNqU.OpenLayerObserverContext));
    const namespace = (0, $4pUFZ.useOpenLayerObserverNamespace)();
    (0, $42omo.useEffect)(()=>{
        /**
		 * Registers the `onClose` callback with the OpenLayerObserver.
		 */ if (context === null) return;
        if (!isOpen) /**
			 * If the layer is not open, we are not registering the `onClose` callback.
			 * This is important to prevent the `onClose` from being called for layers that
			 * are not open.
			 *
			 * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
			 * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
			 */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}
module.exports["useNotifyOpenLayerObserver"] = $c5d9ea856be07e85$export$469bb693f11edc7f;

});

parcelRegister("iHNqU", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $74b93f9437d114b9$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $42omo.createContext)(null);
module.exports["OpenLayerObserverContext"] = $74b93f9437d114b9$export$5fbf4d7fae6cdc00;

});

parcelRegister("4pUFZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cGkQr = parcelRequire("cGkQr");

function $6a9a54d980ef75c0$export$1d57e79091cc3046() {
    const namespace = (0, $42omo.useContext)((0, $cGkQr.OpenLayerObserverNamespaceContext));
    return namespace;
}
module.exports["useOpenLayerObserverNamespace"] = $6a9a54d980ef75c0$export$1d57e79091cc3046;

});

parcelRegister("cGkQr", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $a33883aec82c2423$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $42omo.createContext)(null);
module.exports["OpenLayerObserverNamespaceContext"] = $a33883aec82c2423$export$644a49f3b8c50fcd;

});

parcelRegister("g9Srd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

// We define empty context here so the object doesn't change.
const $5f2ebc72f672914d$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ const $5f2ebc72f672914d$var$ExitingContext = /*#__PURE__*/ (0, $42omo.createContext)($5f2ebc72f672914d$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $5f2ebc72f672914d$var$wrapChildWithContextProvider = (child, value = $5f2ebc72f672914d$var$emptyContext)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($5f2ebc72f672914d$var$ExitingContext.Provider, {
        value: value,
        children: child
    }, `${child.key}-provider`);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $5f2ebc72f672914d$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $42omo.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const $5f2ebc72f672914d$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $5f2ebc72f672914d$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const $5f2ebc72f672914d$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $5f2ebc72f672914d$var$getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $5f2ebc72f672914d$var$ExitingPersistence = /*#__PURE__*/ (0, $42omo.memo)(({ appear: appear = false, children: children, exitThenEnter: exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, $42omo.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, $42omo.useState)([]);
    const [defaultContext, setDefaultContext] = (0, $42omo.useState)(()=>({
            appear: appear,
            isExiting: false
        }));
    (0, $42omo.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
		 * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
		 * useState is mocked to return a boolean value.
		 */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = $5f2ebc72f672914d$var$childrenToArray(previousChildren);
    const current = $5f2ebc72f672914d$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    const missingKeys = $5f2ebc72f672914d$var$getMissingKeys(current, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $5f2ebc72f672914d$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        return $5f2ebc72f672914d$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>$5f2ebc72f672914d$var$wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
const $5f2ebc72f672914d$export$3b6f38abbdcbd000 = ()=>{
    return (0, $42omo.useContext)($5f2ebc72f672914d$var$ExitingContext);
};
$5f2ebc72f672914d$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $5f2ebc72f672914d$export$2e2bcd8739ae039 = $5f2ebc72f672914d$var$ExitingPersistence;
module.exports["useExitingPersistence"] = $5f2ebc72f672914d$export$3b6f38abbdcbd000;
module.exports["default"] = $5f2ebc72f672914d$export$2e2bcd8739ae039;

});

parcelRegister("fT2ta", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gZTYb = parcelRequire("gZTYb");

const $e955c5befcdaf659$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $e955c5befcdaf659$var$FadeIn = ({ children: children, duration: duration = 'large', entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? $e955c5befcdaf659$var$invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gZTYb.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
var $e955c5befcdaf659$export$2e2bcd8739ae039 = $e955c5befcdaf659$var$FadeIn;
module.exports["default"] = $e955c5befcdaf659$export$2e2bcd8739ae039;

});

parcelRegister("gZTYb", function(module, exports) {
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $7hpmn = parcelRequire("7hpmn");


var $4c48T = parcelRequire("4c48T");


var $jtTDB = parcelRequire("jtTDB");


var $g9Srd = parcelRequire("g9Srd");


var $bl9WW = parcelRequire("bl9WW");

const $a0fcea6deeb8006c$var$zoomIn = null;
const $a0fcea6deeb8006c$var$zoomOut = null;
const $a0fcea6deeb8006c$var$fadeIn = null;
const $a0fcea6deeb8006c$var$fadeOut = null;
const $a0fcea6deeb8006c$var$fadeInFromTop = null;
const $a0fcea6deeb8006c$var$fadeOutFromTop = null;
const $a0fcea6deeb8006c$var$fadeInFromLeft = null;
const $a0fcea6deeb8006c$var$fadeOutFromLeft = null;
const $a0fcea6deeb8006c$var$fadeInFromBottom = null;
const $a0fcea6deeb8006c$var$fadeOutFromBottom = null;
const $a0fcea6deeb8006c$var$fadeInFromRight = null;
const $a0fcea6deeb8006c$var$fadeOutFromRight = null;
const $a0fcea6deeb8006c$var$fadeInFromTopConstant = null;
const $a0fcea6deeb8006c$var$fadeOutFromTopConstant = null;
const $a0fcea6deeb8006c$var$fadeInFromLeftConstant = null;
const $a0fcea6deeb8006c$var$fadeOutFromLeftConstant = null;
const $a0fcea6deeb8006c$var$fadeInFromBottomConstant = null;
const $a0fcea6deeb8006c$var$fadeOutFromBottomConstant = null;
const $a0fcea6deeb8006c$var$fadeInFromRightConstant = null;
const $a0fcea6deeb8006c$var$fadeOutFromRightConstant = null;
const $a0fcea6deeb8006c$var$slideInFromTop = null;
const $a0fcea6deeb8006c$var$slideOutFromTop = null;
const $a0fcea6deeb8006c$var$slideInFromRight = null;
const $a0fcea6deeb8006c$var$slideOutFromRight = null;
const $a0fcea6deeb8006c$var$slideInFromBottom = null;
const $a0fcea6deeb8006c$var$slideOutFromBottom = null;
const $a0fcea6deeb8006c$var$slideInFromLeft = null;
const $a0fcea6deeb8006c$var$slideOutFromLeft = null;
const $a0fcea6deeb8006c$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, animationTimingFunctionExiting: animationTimingFunctionExiting = animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation = enteringAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = 'large' })=>{
    const staggered = (0, $bl9WW.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $g9Srd.useExitingPersistence)();
    const setTimeout = (0, $jtTDB.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $42omo.useState)(appear);
    (0, $42omo.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
         // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        } /**
       * Updates relevant state.
       * Called when the animation is finished, or immediately with reduced motion.
       */ 
        const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion?.(state);
        };
        if ((0, $7hpmn.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        } // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true); // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $4c48T.exitingDurations)[duration] : (0, $4c48T.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        }; // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $gMc0m.default)([
            (0, $gMc0m.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $gMc0m.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $gMc0m.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $gMc0m.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $gMc0m.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $gMc0m.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $gMc0m.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $gMc0m.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $gMc0m.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $gMc0m.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $gMc0m.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $gMc0m.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $gMc0m.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $gMc0m.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $gMc0m.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $gMc0m.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $gMc0m.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $gMc0m.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $gMc0m.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $gMc0m.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $gMc0m.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $gMc0m.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $gMc0m.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $gMc0m.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $gMc0m.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $gMc0m.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $gMc0m.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $gMc0m.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $gMc0m.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $gMc0m.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $gMc0m.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $gMc0m.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $gMc0m.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $gMc0m.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $gMc0m.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $gMc0m.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $gMc0m.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $gMc0m.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $gMc0m.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $gMc0m.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $gMc0m.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $gMc0m.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $gMc0m.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $gMc0m.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $gMc0m.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $gMc0m.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $gMc0m.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $gMc0m.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $gMc0m.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $gMc0m.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $gMc0m.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: `${delay}ms`
        }
    }, state);
};
var $a0fcea6deeb8006c$export$2e2bcd8739ae039 = $a0fcea6deeb8006c$var$EnteringMotion;
module.exports["default"] = $a0fcea6deeb8006c$export$2e2bcd8739ae039;

});

parcelRegister("7hpmn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");

const $e4514a84fb33dbe3$var$isMatchMediaAvailable = ()=>typeof window !== 'undefined' && 'matchMedia' in window;
const $e4514a84fb33dbe3$export$b7baf7667a68d87c = ()=>{
    if (!$e4514a84fb33dbe3$var$isMatchMediaAvailable()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};
const $e4514a84fb33dbe3$export$c537e63161742ce3 = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $42omo.useState)($e4514a84fb33dbe3$export$b7baf7667a68d87c);
    (0, $42omo.useEffect)(()=>{
        if (!$e4514a84fb33dbe3$var$isMatchMediaAvailable()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $fFa3V.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
const $e4514a84fb33dbe3$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
const $e4514a84fb33dbe3$export$ff7706047246b98b = ()=>$e4514a84fb33dbe3$export$f0f789643ba5a83c;
module.exports["isReducedMotion"] = $e4514a84fb33dbe3$export$b7baf7667a68d87c;
module.exports["useIsReducedMotion"] = $e4514a84fb33dbe3$export$c537e63161742ce3;
module.exports["reduceMotionAsPerUserPreference"] = $e4514a84fb33dbe3$export$f0f789643ba5a83c;
module.exports["prefersReducedMotion"] = $e4514a84fb33dbe3$export$ff7706047246b98b;

});

parcelRegister("4c48T", function(module, exports) {
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $84a6236c125dbba8$export$368bacef0dacbe05 = 25;
const $84a6236c125dbba8$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $84a6236c125dbba8$var$EXITING_MOTION_MULTIPLIER = 0.5;
const $84a6236c125dbba8$export$30fa1a2e62ae150c = {
    none: $84a6236c125dbba8$export$38b928a7167ce124.none,
    small: $84a6236c125dbba8$export$38b928a7167ce124.small * $84a6236c125dbba8$var$EXITING_MOTION_MULTIPLIER,
    medium: $84a6236c125dbba8$export$38b928a7167ce124.medium * $84a6236c125dbba8$var$EXITING_MOTION_MULTIPLIER,
    large: $84a6236c125dbba8$export$38b928a7167ce124.large * $84a6236c125dbba8$var$EXITING_MOTION_MULTIPLIER
};
module.exports["durations"] = $84a6236c125dbba8$export$38b928a7167ce124;
module.exports["exitingDurations"] = $84a6236c125dbba8$export$30fa1a2e62ae150c;

});

parcelRegister("jtTDB", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $4547f72065f13ecd$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $4547f72065f13ecd$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $4547f72065f13ecd$var$getHookDeps(opts));
    return (0, $42omo.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
const $4547f72065f13ecd$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $4547f72065f13ecd$var$getHookDeps(opts));
    return (0, $42omo.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $4547f72065f13ecd$export$1775f27e7c8051ca;
module.exports["useSetTimeout"] = $4547f72065f13ecd$export$4f34107a2b00f39c;

});

parcelRegister("bl9WW", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $dclyF = parcelRequire("dclyF");

/* eslint-disable @repo/internal/react/disallow-unstable-values */ 


function $c56773c239eec070$export$c485849f2e393253() {
    const identifier = (0, $42omo.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


const $044d9e84371c83c1$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $42omo.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $ee7An.default)
    }));
const $044d9e84371c83c1$export$25c7213fc07ec080 = ()=>{
    const indentifier = (0, $c56773c239eec070$export$c485849f2e393253)();
    const context = (0, $42omo.useContext)($044d9e84371c83c1$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $044d9e84371c83c1$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $42omo.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $42omo.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)($044d9e84371c83c1$var$StaggeredEntranceContext.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        },
        children: children
    });
};
var $044d9e84371c83c1$export$2e2bcd8739ae039 = $044d9e84371c83c1$var$StaggeredEntrance;
module.exports["useStaggeredEntrance"] = $044d9e84371c83c1$export$25c7213fc07ec080;
module.exports["default"] = $044d9e84371c83c1$export$2e2bcd8739ae039;

});

parcelRegister("dclyF", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $fb461de404a34100$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $42omo.useEffect) : (0, $42omo.useLayoutEffect);
module.exports["useLayoutEffect"] = $fb461de404a34100$export$e5c5a5f917a5871c;

});

parcelRegister("lqsSp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1K6bS = parcelRequire("1K6bS");

function $4f270dfd41d88c95$export$6d8c2b45c99d6e3f({ viewportPadding: viewportPadding }) {
    return [
        {
            /**
			 * Performing DOM measurements in the 'read' phase,
			 * which is the convention for popper modifiers
			 */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state: state, name: name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
			 * Applying max size CSS
			 */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state: state }) {
                const data = state.modifiersData.maxSizeData;
                if (typeof data?.viewport?.width !== 'number' || typeof data?.viewport?.height !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport: viewport } = data;
                const { popperOffsets: popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                const placementOffset = state.modifiersData?.offset?.[state.placement] ?? {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}



const $ecca7c16c8de9b75$var$viewportPadding = 5;
const $ecca7c16c8de9b75$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $ecca7c16c8de9b75$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $ecca7c16c8de9b75$var$defaultChildrenFn() {
    return null;
}
const $ecca7c16c8de9b75$var$defaultOffset = [
    0,
    8
];
function $ecca7c16c8de9b75$export$badac9ada3a0bdf9({ children: children = $ecca7c16c8de9b75$var$defaultChildrenFn, offset: offset = $ecca7c16c8de9b75$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed', shouldFitViewport: shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, $42omo.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $ecca7c16c8de9b75$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, $4f270dfd41d88c95$export$6d8c2b45c99d6e3f)({
            viewportPadding: $ecca7c16c8de9b75$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [
            ...$ecca7c16c8de9b75$var$constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $42omo.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1K6bS.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement,
        children: children
    });
}
module.exports["Popper"] = $ecca7c16c8de9b75$export$badac9ada3a0bdf9;

});

parcelRegister("1K6bS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2xusd = parcelRequire("2xusd");


var $dhTbP = parcelRequire("dhTbP");





var $jTxSS = parcelRequire("jTxSS");


var $i4Myo = parcelRequire("i4Myo");


var $biLb4 = parcelRequire("biLb4");




var $83f90416d0304bb1$var$EMPTY_MODIFIERS = [];
var $83f90416d0304bb1$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $42omo.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $83f90416d0304bb1$var$EMPTY_MODIFIERS
    };
    var _React$useState = $42omo.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $42omo.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $jTxSS.flushSync(function() {
                    setState({
                        styles: (0, $dhTbP.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $dhTbP.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $42omo.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($biLb4)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $42omo.useRef();
    (0, $dhTbP.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $dhTbP.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $i4Myo.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};


var $144ee39df6a67626$var$NOOP = function NOOP() {
    return void 0;
};
var $144ee39df6a67626$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $144ee39df6a67626$var$EMPTY_MODIFIERS = [];
function $144ee39df6a67626$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $144ee39df6a67626$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $42omo.useContext((0, $2xusd.ManagerReferenceNodeContext));
    var _React$useState = $42omo.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $42omo.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $42omo.useEffect(function() {
        (0, $dhTbP.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $42omo.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $83f90416d0304bb1$export$f4d5bf230a36dd6e)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $42omo.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $144ee39df6a67626$var$NOOP,
            update: update || $144ee39df6a67626$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $dhTbP.unwrapArray)(children)(childrenProps);
}
module.exports["Popper"] = $144ee39df6a67626$export$badac9ada3a0bdf9;

});

parcelRegister("2xusd", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $1d96495cbe7f821b$export$3dbd3405086fec7b = $42omo.createContext();
var $1d96495cbe7f821b$export$cbabb21c2529b130 = $42omo.createContext();
function $1d96495cbe7f821b$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $42omo.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $42omo.useRef(false);
    $42omo.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $42omo.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $42omo.createElement($1d96495cbe7f821b$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $42omo.createElement($1d96495cbe7f821b$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}
module.exports["ManagerReferenceNodeContext"] = $1d96495cbe7f821b$export$3dbd3405086fec7b;
module.exports["ManagerReferenceNodeSetterContext"] = $1d96495cbe7f821b$export$cbabb21c2529b130;
module.exports["Manager"] = $1d96495cbe7f821b$export$d0d38e7dec7a1a61;

});

parcelRegister("i4Myo", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $d28e437c9ba69398$export$8f7491d57c8f97a9);

var $dseO2 = parcelRequire("dseO2");


var $abBQX = parcelRequire("abBQX");

var $76ef79aaecc6dad3$var$passive = {
    passive: true
};
function $76ef79aaecc6dad3$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $abBQX.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $76ef79aaecc6dad3$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $76ef79aaecc6dad3$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $76ef79aaecc6dad3$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $76ef79aaecc6dad3$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $76ef79aaecc6dad3$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $76ef79aaecc6dad3$var$effect,
    data: {}
};



var $gjl0U = parcelRequire("gjl0U");

function $29ebdc30f9e18b3c$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $gjl0U.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $29ebdc30f9e18b3c$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $29ebdc30f9e18b3c$var$popperOffsets,
    data: {}
};



var $eX4ca = parcelRequire("eX4ca");


var $d90wo = parcelRequire("d90wo");





var $cBZBQ = parcelRequire("cBZBQ");


var $1idVR = parcelRequire("1idVR");


var $gLRTP = parcelRequire("gLRTP");


var $fd6rO = parcelRequire("fd6rO");


var $fEu2C = parcelRequire("fEu2C");

var $d3c36413ee2ca2e0$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $d3c36413ee2ca2e0$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $fEu2C.round)(x * dpr) / dpr || 0,
        y: (0, $fEu2C.round)(y * dpr) / dpr || 0
    };
}
function $d3c36413ee2ca2e0$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $eX4ca.left);
    var sideY = (0, $eX4ca.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $d90wo.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $abBQX.default)(popper)) {
            offsetParent = (0, $cBZBQ.default)(popper);
            if ((0, $1idVR.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $eX4ca.top) || (placement === (0, $eX4ca.left) || placement === (0, $eX4ca.right)) && variation === (0, $eX4ca.end)) {
            sideY = (0, $eX4ca.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $eX4ca.left) || (placement === (0, $eX4ca.top) || placement === (0, $eX4ca.bottom)) && variation === (0, $eX4ca.end)) {
            sideX = (0, $eX4ca.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $d3c36413ee2ca2e0$var$unsetSides);
    var _ref4 = roundOffsets === true ? $d3c36413ee2ca2e0$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $abBQX.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $d3c36413ee2ca2e0$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $gLRTP.default)(state.placement),
        variation: (0, $fd6rO.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $d3c36413ee2ca2e0$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $d3c36413ee2ca2e0$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $d3c36413ee2ca2e0$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $d3c36413ee2ca2e0$var$computeStyles,
    data: {}
};



var $2X8fC = parcelRequire("2X8fC");


var $kXrr0 = parcelRequire("kXrr0");

// and applies them to the HTMLElements such as popper and arrow
function $c0812cd6e22b6755$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $kXrr0.isHTMLElement)(element) || !(0, $2X8fC.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $c0812cd6e22b6755$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $kXrr0.isHTMLElement)(element) || !(0, $2X8fC.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $c0812cd6e22b6755$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $c0812cd6e22b6755$var$applyStyles,
    effect: $c0812cd6e22b6755$var$effect,
    requires: [
        'computeStyles'
    ]
};








function $2c0bc9dd51256be8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $gLRTP.default)(placement);
    var invertDistance = [
        (0, $eX4ca.left),
        (0, $eX4ca.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $eX4ca.left),
        (0, $eX4ca.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $2c0bc9dd51256be8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $eX4ca.placements).reduce(function(acc, placement) {
        acc[placement] = $2c0bc9dd51256be8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $2c0bc9dd51256be8$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $2c0bc9dd51256be8$var$offset
};


var $a89d30f4acddffe6$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $a89d30f4acddffe6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $a89d30f4acddffe6$var$hash[matched];
    });
}





var $c9d3dec92af1ba61$var$hash = {
    start: 'end',
    end: 'start'
};
function $c9d3dec92af1ba61$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $c9d3dec92af1ba61$var$hash[matched];
    });
}



var $1ldyQ = parcelRequire("1ldyQ");













function $7ecb56ea1686edbd$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $eX4ca.placements) : _options$allowedAutoP;
    var variation = (0, $fd6rO.default)(placement);
    var placements = variation ? flipVariations ? (0, $eX4ca.variationPlacements) : (0, $eX4ca.variationPlacements).filter(function(placement) {
        return (0, $fd6rO.default)(placement) === variation;
    }) : (0, $eX4ca.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $1ldyQ.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $gLRTP.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}








function $4441ea014e24fea8$var$getExpandedFallbackPlacements(placement) {
    if ((0, $gLRTP.default)(placement) === (0, $eX4ca.auto)) return [];
    var oppositePlacement = (0, $a89d30f4acddffe6$export$2e2bcd8739ae039)(placement);
    return [
        (0, $c9d3dec92af1ba61$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $c9d3dec92af1ba61$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $4441ea014e24fea8$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $gLRTP.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $a89d30f4acddffe6$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $4441ea014e24fea8$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $gLRTP.default)(placement) === (0, $eX4ca.auto) ? (0, $7ecb56ea1686edbd$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $gLRTP.default)(placement);
        var isStartVariation = (0, $fd6rO.default)(placement) === (0, $eX4ca.start);
        var isVertical = [
            (0, $eX4ca.top),
            (0, $eX4ca.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $1ldyQ.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $eX4ca.right) : (0, $eX4ca.left) : isStartVariation ? (0, $eX4ca.bottom) : (0, $eX4ca.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $a89d30f4acddffe6$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $a89d30f4acddffe6$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4441ea014e24fea8$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $4441ea014e24fea8$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};









var $7ONHI = parcelRequire("7ONHI");

function $04913fb8fe7768e2$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}





function $031bb8ab0862fe56$export$f28d906d67a997f3(min, value, max) {
    return (0, $fEu2C.max)(min, (0, $fEu2C.min)(value, max));
}
function $031bb8ab0862fe56$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $031bb8ab0862fe56$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}



var $j7Ucr = parcelRequire("j7Ucr");











var $lFhaR = parcelRequire("lFhaR");




function $b9d23f0039eff25c$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $1ldyQ.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $gLRTP.default)(state.placement);
    var variation = (0, $fd6rO.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $7ONHI.default)(basePlacement);
    var altAxis = (0, $04913fb8fe7768e2$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $eX4ca.top) : (0, $eX4ca.left);
        var altSide = mainAxis === 'y' ? (0, $eX4ca.bottom) : (0, $eX4ca.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $eX4ca.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $eX4ca.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $j7Ucr.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $lFhaR.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $031bb8ab0862fe56$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $d90wo.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $031bb8ab0862fe56$export$f28d906d67a997f3)(tether ? (0, $fEu2C.min)(min, tetherMin) : min, offset, tether ? (0, $fEu2C.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $eX4ca.top) : (0, $eX4ca.left);
        var _altSide = mainAxis === 'x' ? (0, $eX4ca.bottom) : (0, $eX4ca.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $eX4ca.top),
            (0, $eX4ca.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $031bb8ab0862fe56$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $031bb8ab0862fe56$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b9d23f0039eff25c$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $b9d23f0039eff25c$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};









var $7bTYu = parcelRequire("7bTYu");









var $jD11d = parcelRequire("jD11d");


var $ge7rQ = parcelRequire("ge7rQ");




var $5a840e009e6f15d2$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $jD11d.default)(typeof padding !== 'number' ? padding : (0, $ge7rQ.default)(padding, (0, $eX4ca.basePlacements)));
};
function $5a840e009e6f15d2$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $gLRTP.default)(state.placement);
    var axis = (0, $7ONHI.default)(basePlacement);
    var isVertical = [
        (0, $eX4ca.left),
        (0, $eX4ca.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $5a840e009e6f15d2$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $j7Ucr.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $eX4ca.top) : (0, $eX4ca.left);
    var maxProp = axis === 'y' ? (0, $eX4ca.bottom) : (0, $eX4ca.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $d90wo.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $031bb8ab0862fe56$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $5a840e009e6f15d2$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $7bTYu.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $5a840e009e6f15d2$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $5a840e009e6f15d2$var$arrow,
    effect: $5a840e009e6f15d2$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $3c899507227a719f$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $3c899507227a719f$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $eX4ca.top),
        (0, $eX4ca.right),
        (0, $eX4ca.bottom),
        (0, $eX4ca.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $3c899507227a719f$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $1ldyQ.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $1ldyQ.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $3c899507227a719f$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $3c899507227a719f$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $3c899507227a719f$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $3c899507227a719f$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $3c899507227a719f$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $3c899507227a719f$var$hide
};




var $d28e437c9ba69398$export$d34966752335dd47 = [
    (0, $76ef79aaecc6dad3$export$2e2bcd8739ae039),
    (0, $29ebdc30f9e18b3c$export$2e2bcd8739ae039),
    (0, $d3c36413ee2ca2e0$export$2e2bcd8739ae039),
    (0, $c0812cd6e22b6755$export$2e2bcd8739ae039),
    (0, $2c0bc9dd51256be8$export$2e2bcd8739ae039),
    (0, $4441ea014e24fea8$export$2e2bcd8739ae039),
    (0, $b9d23f0039eff25c$export$2e2bcd8739ae039),
    (0, $5a840e009e6f15d2$export$2e2bcd8739ae039),
    (0, $3c899507227a719f$export$2e2bcd8739ae039)
];
var $d28e437c9ba69398$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $dseO2.popperGenerator)({
    defaultModifiers: $d28e437c9ba69398$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});

parcelRegister("biLb4", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $83a5f89d224bce20$var$hasElementType = typeof Element !== 'undefined';
var $83a5f89d224bce20$var$hasMap = typeof Map === 'function';
var $83a5f89d224bce20$var$hasSet = typeof Set === 'function';
var $83a5f89d224bce20$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $83a5f89d224bce20$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$83a5f89d224bce20$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($83a5f89d224bce20$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$83a5f89d224bce20$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($83a5f89d224bce20$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($83a5f89d224bce20$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($83a5f89d224bce20$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$83a5f89d224bce20$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $83a5f89d224bce20$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("caX7N", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4dd5f555438ec52$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");

const $99ea7c45d47170fe$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $99ea7c45d47170fe$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $99ea7c45d47170fe$export$13f57c02915787b3 = 'atlaskit-portal';


const $2f4e9fedc9ef26c3$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $99ea7c45d47170fe$export$13f57c02915787b3);
    container.style.zIndex = `${zIndex}`;
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $2f4e9fedc9ef26c3$var$getBody = ()=>{
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ const $2f4e9fedc9ef26c3$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $99ea7c45d47170fe$export$72f415121273627e));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $99ea7c45d47170fe$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        $2f4e9fedc9ef26c3$var$getBody()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $2f4e9fedc9ef26c3$export$da99f98bf3fe55b3 = (container)=>{
    $2f4e9fedc9ef26c3$var$getPortalParent().removeChild(container);
};
const $2f4e9fedc9ef26c3$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $2f4e9fedc9ef26c3$var$getPortalParent().appendChild(container);
};
const $2f4e9fedc9ef26c3$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $2f4e9fedc9ef26c3$export$fef014d7cef9e543 = (zIndex)=>{
    //atlaskit-portal div
    if ($2f4e9fedc9ef26c3$var$isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $99ea7c45d47170fe$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
    return;
};
const $2f4e9fedc9ef26c3$export$95029ca7aca2989e = ()=>{
    //atlaskit-portal-container div
    if ($2f4e9fedc9ef26c3$var$isDocumentDefined()) {
        const parentElement = document.querySelector((0, $99ea7c45d47170fe$export$72f415121273627e));
        if (!parentElement) {
            const parent = document.createElement('div');
            parent.className = (0, $99ea7c45d47170fe$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            $2f4e9fedc9ef26c3$var$getBody()?.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};


function $e8cb7e18b4c8e020$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const container = (0, $42omo.useMemo)(()=>(0, $2f4e9fedc9ef26c3$export$26ae5ca175b4ec5a)(zIndex), [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $2f4e9fedc9ef26c3$export$c582005add11e141)(container);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            (0, $2f4e9fedc9ef26c3$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $jTxSS.createPortal)(children, container);
}














const $0b6ae911d7dbb2a8$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $42omo.useLayoutEffect) : (0, $42omo.useEffect);



function $a0145b3d0001629a$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, $42omo.useState)(null);
    (0, $0b6ae911d7dbb2a8$export$700979bc83e7db82)(()=>{
        const tempPortalContainer = (0, $2f4e9fedc9ef26c3$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        const portalParent = (0, $2f4e9fedc9ef26c3$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return ()=>{
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
	 * We wrap portal children with a Suspense boundary because in React 18 concurrent,
	 * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
	 * our portal gets in an infinite loop of rendering.
	 */ const suspendedChildren = /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: null,
        children: children
    });
    return atlaskitPortal ? /*#__PURE__*/ (0, $jTxSS.createPortal)(suspendedChildren, atlaskitPortal) : null;
}






const $86c76191573711ee$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $42omo.useState)(false);
    const [useMountEffect] = (0, $42omo.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $0b6ae911d7dbb2a8$export$700979bc83e7db82) : (0, $42omo.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $86c76191573711ee$export$2e2bcd8739ae039 = $86c76191573711ee$var$useIsSubsequentRender;





const $fe064809d28b4ab5$export$ed5835cc67e87f72 = 'akPortalMount';
const $fe064809d28b4ab5$export$80816bd900e5bd00 = 'akPortalUnmount';


const $6df29763b6e7b48a$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $6df29763b6e7b48a$var$getLayerName = (zIndex)=>{
    return $6df29763b6e7b48a$var$zIndexToName.hasOwnProperty(zIndex) ? $6df29763b6e7b48a$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $6df29763b6e7b48a$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $6df29763b6e7b48a$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $6df29763b6e7b48a$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $6df29763b6e7b48a$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


const $46d63ccdf36bf175$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $42omo.useEffect)(()=>{
        (0, $6df29763b6e7b48a$export$2e2bcd8739ae039)((0, $fe064809d28b4ab5$export$ed5835cc67e87f72), zIndexNumber);
        return ()=>{
            (0, $6df29763b6e7b48a$export$2e2bcd8739ae039)((0, $fe064809d28b4ab5$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $46d63ccdf36bf175$export$2e2bcd8739ae039 = $46d63ccdf36bf175$var$useFirePortalEvent;


function $f4dd5f555438ec52$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect' }) {
    const isSubsequentRender = (0, $86c76191573711ee$export$2e2bcd8739ae039)(mountStrategy);
    (0, $46d63ccdf36bf175$export$2e2bcd8739ae039)(zIndex);
    return !(0, $dh538.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e8cb7e18b4c8e020$export$2e2bcd8739ae039), {
        zIndex: zIndex,
        children: children
    }) : null : /*#__PURE__*/ (0, $l998X.jsx)((0, $a0145b3d0001629a$export$2e2bcd8739ae039), {
        zIndex: zIndex,
        children: children
    });
}

});

parcelRegister("dTk3A", function(module, exports) {

var $bo9I4 = parcelRequire("bo9I4");


var $6fnsQ = parcelRequire("6fnsQ");

const $45878ddd0fe449a8$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $45878ddd0fe449a8$export$c93026a968943f95 = 'light';
const $45878ddd0fe449a8$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $45878ddd0fe449a8$export$8e24544ddba725ee = (color = `var(--ds-border-focused, ${0, $6fnsQ.B200})`, outlineWidth = 2)=>{
    (0, $bo9I4.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return `
  &:focus {
    outline: none;
    box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
  }
`;
};
const $45878ddd0fe449a8$export$c0dd343266bc3261 = ()=>`
  box-shadow: none;
`;
const $45878ddd0fe449a8$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};
const $45878ddd0fe449a8$export$a1b3edb637fb4f35 = ()=>{
    (0, $bo9I4.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
const $45878ddd0fe449a8$export$ba1d834b86d72a09 = $45878ddd0fe449a8$export$a1b3edb637fb4f35;
const $45878ddd0fe449a8$export$e497e856b4f89fcd = ()=>({
        css: {
            backgroundColor: `var(--ds-skeleton, ${0, $6fnsQ.N20A})`,
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: `var(--ds-skeleton, ${0, $6fnsQ.N20A})`
            },
            to: {
                backgroundColor: `var(--ds-skeleton-subtle, ${0, $6fnsQ.N30A})`
            }
        }
    });
module.exports["layers"] = $45878ddd0fe449a8$export$7be255094ccdc533;
module.exports["skeletonShimmer"] = $45878ddd0fe449a8$export$e497e856b4f89fcd;

});

parcelRegister("bo9I4", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cda9b359fee0756$export$2e2bcd8739ae039);

var $4S9ET = parcelRequire("4S9ET");


var $kyRHQ = parcelRequire("kyRHQ");

function $2cda9b359fee0756$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $4S9ET.default)(`[${packageName}]: The ${api} is deprecated.${additionalMessage && ` ${additionalMessage}`}`);
}
function $2cda9b359fee0756$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $kyRHQ;
}

});

parcelRegister("4S9ET", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c9c08079e62c333$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $2c9c08079e62c333$var$printed = {};
function $2c9c08079e62c333$export$2e2bcd8739ae039(message) {
    if ($2c9c08079e62c333$var$printed[message]) return;
    $2c9c08079e62c333$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});

parcelRegister("afneb", function(module, exports) {
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $7c7d7d92d560a3bc$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c81u0j _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d7jlr _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
const $7c7d7d92d560a3bc$export$5bcbc43c84236222 = ({ shortcut: shortcut })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $7c7d7d92d560a3bc$var$styles.shortcutSegmentsContainer
        ]),
        children: shortcut.map((segment, index)=>/*#__PURE__*/ (0, $l998X.jsx)("kbd", {
                className: (0, $gMc0m.default)([
                    $7c7d7d92d560a3bc$var$styles.shortcutSegment
                ]),
                children: segment
            }, `${segment}-${index}`))
    });
};


const $9a3fad30e262233e$var$primitiveStyles = null; /**
                               * The lower level component for rendering a tooltip.
                               */ 
const $9a3fad30e262233e$var$TooltipPrimitive = /*#__PURE__*/ (0, $42omo.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? `${testId}--wrapper` : undefined,
        children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            role: "tooltip" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            ,
            className: (0, $gMc0m.default)([
                "_80om73ad",
                className
            ]),
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
            onMouseOver: onMouseOver,
            "data-placement": placement,
            "data-testid": testId,
            id: id,
            children: [
                children,
                shortcut && (0, $dh538.fg)('platform-dst-tooltip-shortcuts') && /*#__PURE__*/ (0, $l998X.jsx)((0, $7c7d7d92d560a3bc$export$5bcbc43c84236222), {
                    shortcut: shortcut
                })
            ]
        })
    });
});
$9a3fad30e262233e$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $9a3fad30e262233e$export$2e2bcd8739ae039 = $9a3fad30e262233e$var$TooltipPrimitive;
module.exports["default"] = $9a3fad30e262233e$export$2e2bcd8739ae039;

});

parcelRegister("bOG3Z", function(module, exports) {
$parcel$export(module.exports, "useGlobalTheme", () => $c1fc4d2bf2235e40$export$7692396083754928);

var $9j05A = parcelRequire("9j05A");

// Create default global light theme
const { Provider: $c1fc4d2bf2235e40$var$Provider, Consumer: $c1fc4d2bf2235e40$var$Consumer, useTheme: $c1fc4d2bf2235e40$export$7692396083754928 } = (0, $9j05A.createTheme)(()=>({
        mode: 'light'
    }));
const $c1fc4d2bf2235e40$var$Theme = {
    Provider: $c1fc4d2bf2235e40$var$Provider,
    Consumer: $c1fc4d2bf2235e40$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c1fc4d2bf2235e40$export$2e2bcd8739ae039 = $c1fc4d2bf2235e40$var$Theme;
module.exports["default"] = $c1fc4d2bf2235e40$export$2e2bcd8739ae039;

});

parcelRegister("9j05A", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $a094bcf44d918c5b$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
	 * Internally, Theme uses React Context, with internal providers and consumers.
	 * The React Context passes only a function that gets props, and turns them into tokens. This
	 * function gets mixed as more Providers with their own themes are added. This mixed function
	 * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
	 * the theme.
	 */ const ThemeContext = /*#__PURE__*/ (0, $42omo.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $42omo.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: children(tokens)
        });
    }
    /**
	 * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
	 * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
	 * - The getTokens function isn't called immediately - instead the props are passed
	 *    through a mix of parent theming functions
	 * Children of this provider will receive this mixed theme
	 */ function Provider(props) {
        const themeFn = (0, $42omo.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $42omo.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)(ThemeContext.Provider, {
            value: mixedFn,
            children: props.children
        });
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}
module.exports["createTheme"] = $a094bcf44d918c5b$export$25d302a5b900a763;

});

parcelRegister("f93tv", function(module, exports) {
$parcel$export(module.exports, "default", () => $420664e92ad6d15c$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $420664e92ad6d15c$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("dOMrE", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");

const $90bd866f17043fb3$var$BORDER_WIDTH = 2;
const $90bd866f17043fb3$var$baseFocusOutsideStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #2684FF)"}`,
    outlineOffset: $90bd866f17043fb3$var$BORDER_WIDTH
});
const $90bd866f17043fb3$var$baseInsetStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$90bd866f17043fb3$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
const $90bd866f17043fb3$var$focusRingStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $90bd866f17043fb3$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $90bd866f17043fb3$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`
        }
    }
});
const $90bd866f17043fb3$var$insetFocusRingStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $90bd866f17043fb3$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $90bd866f17043fb3$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ const $90bd866f17043fb3$var$FocusRing = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $90bd866f17043fb3$var$baseInsetStyles : $90bd866f17043fb3$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $90bd866f17043fb3$var$insetFocusRingStyles : $90bd866f17043fb3$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9K4OG.ClassNames), null, ({ css: css, cx: cx })=>(0, $42omo.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$90bd866f17043fb3$var$FocusRing.displayName = 'FocusRing';
var $90bd866f17043fb3$export$2e2bcd8739ae039 = $90bd866f17043fb3$var$FocusRing;
module.exports["default"] = $90bd866f17043fb3$export$2e2bcd8739ae039;

});

parcelRegister("1DWH0", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");







function $1d9881ad5a9270b6$export$9ebb5a84d17e5d18(createEventMap = {}, wrappedComponentProps) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handlerCache = (0, $42omo.useRef)({});
    const patchedProps = (0, $42omo.useMemo)(()=>{
        const cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter((key)=>!(key in createEventMap)).forEach((key)=>delete cache[key]);
        return Object.keys(createEventMap).reduce((p, k)=>{
            const eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes(typeof eventCreator)) return p;
            const propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return {
                ...p,
                [k]: cache[k].wrappedCallback
            };
            const wrappedCallback = (...args)=>{
                const analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') propValue(...args, analyticsEvent);
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return {
                ...p,
                [k]: wrappedCallback
            };
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}


const $4b27ee6b189e0611$var$withAnalyticsEvents = (createEventMap = {})=>(WrappedComponent)=>{
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            const { patchedEventProps: patchedEventProps } = (0, $1d9881ad5a9270b6$export$9ebb5a84d17e5d18)(createEventMap, props);
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
            return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
                ...props,
                ...patchedEventProps,
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            });
        });
        WithAnalyticsEvents.displayName = `WithAnalyticsEvents(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsEvents;
    };
var $4b27ee6b189e0611$export$2e2bcd8739ae039 = $4b27ee6b189e0611$var$withAnalyticsEvents;
module.exports["default"] = $4b27ee6b189e0611$export$2e2bcd8739ae039;

});

parcelRegister("9hlns", function(module, exports) {
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $90YwQ = parcelRequire("90YwQ");

const $ecfb4828e95a67e7$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


function $3da242b485cc4514$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-inverse, #FFFFFF)";
}
const $3da242b485cc4514$var$rotate = null; /**
                      * There are three parts to the load in animation:
                      * 1. Accelerated spin
                      * 2. Stretch the spinner line
                      */ 
const $3da242b485cc4514$var$loadIn = null;
const $3da242b485cc4514$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
}; /**
    * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
    * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
    * which makes things simpler than doing an `isServer` check or a `null` check.
    *
    * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
    */ 
const $3da242b485cc4514$var$useLayoutEffect = typeof window === 'undefined' ? (0, $42omo.useEffect) : (0, $42omo.useLayoutEffect); /**
                                                                                          * __Spinner__
                                                                                          *
                                                                                          * A spinner is an animated spinning icon that lets users know content is being loaded.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/spinner/examples)
                                                                                          * - [Code](https://atlassian.design/components/spinner/code)
                                                                                          * - [Usage](https://atlassian.design/components/spinner/usage)
                                                                                          */ 
const $3da242b485cc4514$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $ecfb4828e95a67e7$export$4e9f1640bbe7a1a8)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $3da242b485cc4514$var$getStrokeColor(appearance);
    const context = (0, $42omo.useContext)((0, $90YwQ.default));
    $3da242b485cc4514$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]); /**
                                   * The Spinner animation uses a combination of two
                                   * css animations on two separate elements.
                                   */ 
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        /**
                * This span exists to off-load animations from the circle element,
                * which were causing performance issues (style recalculations)
                * on Safari and older versions of Chrome.
                *
                * This can be removed and styles placed back on the circle element once
                * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
                */ "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $gMc0m.default)([
            $3da242b485cc4514$var$styles.wrapperStyles,
            $3da242b485cc4514$var$styles.rotateStyles
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId,
            ref: ref,
            "aria-label": label || undefined,
            style: {
                animationDelay: animationDelay
            },
            role: label ? 'img' : 'none',
            className: (0, $gMc0m.default)([
                $3da242b485cc4514$var$styles.loadInStyles
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7",
                style: {
                    stroke: stroke
                },
                className: (0, $gMc0m.default)([
                    $3da242b485cc4514$var$styles.circleStyles
                ])
            })
        })
    });
}));
var $3da242b485cc4514$export$2e2bcd8739ae039 = $3da242b485cc4514$var$Spinner;
module.exports["default"] = $3da242b485cc4514$export$2e2bcd8739ae039;

});

parcelRegister("9I2p1", function(module, exports) {
function $510a49780a2fe3ed$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $510a49780a2fe3ed$var$isIPhone() {
    return $510a49780a2fe3ed$var$testPlatform(/^iPhone/i);
}
function $510a49780a2fe3ed$var$isMac() {
    return $510a49780a2fe3ed$var$testPlatform(/^Mac/i);
}
function $510a49780a2fe3ed$var$isIPad() {
    return $510a49780a2fe3ed$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $510a49780a2fe3ed$var$isMac() && navigator.maxTouchPoints > 1;
}
function $510a49780a2fe3ed$var$isIOS() {
    return $510a49780a2fe3ed$var$isIPhone() || $510a49780a2fe3ed$var$isIPad();
}
function $510a49780a2fe3ed$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $510a49780a2fe3ed$export$e1865c3bedcd822b() {
    return $510a49780a2fe3ed$var$isMac() || $510a49780a2fe3ed$var$isIOS();
}
module.exports["isSafari"] = $510a49780a2fe3ed$export$95df08bae54cb4df;
module.exports["isAppleDevice"] = $510a49780a2fe3ed$export$e1865c3bedcd822b;

});

parcelRegister("3654r", function(module, exports) {
$parcel$export(module.exports, "default", () => $522abdc1035f6a47$export$2e2bcd8739ae039);
function $522abdc1035f6a47$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("7hXDW", function(module, exports) {
/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $avd77 = parcelRequire("avd77");


var $5rrZR = parcelRequire("5rrZR");


var $1fLvy = parcelRequire("1fLvy");


var $kyRHQ = parcelRequire("kyRHQ");

const $a5ad3e09f473ba51$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
const $a5ad3e09f473ba51$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
const $a5ad3e09f473ba51$var$headingColorStylesMap = {
    'color.text': "_syaz1fxt",
    'color.text.inverse': "_syaz15cr",
    'color.text.warning.inverse': "_syazal3n"
}; /**
    * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
    * @codegen <<SignedSource::406afb01e5634a0b459f50de660d8c2e>>
    * @codegenId typography
    * @codegenCommand yarn workspace @atlaskit/heading codegen
    */ 
const $a5ad3e09f473ba51$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
const $a5ad3e09f473ba51$var$useColor = (colorProp)=>{
    const surface = (0, $5rrZR.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $avd77.inverseColorMap).hasOwnProperty(surface)) return (0, $avd77.inverseColorMap)[surface];
    return 'color.text';
}; /**
    * __Heading__
    *
    * Heading is a typography component used to display text in defined sizes and styles.
    *
    * @example
    *
    * ```jsx
    * <Heading size="xxlarge">Page title</Heading>
    * ```
    */ 
const $a5ad3e09f473ba51$var$Heading = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { children: children, size: size, id: id, testId: testId, as: as, color: colorProp } = props;
    typeof $kyRHQ;
    const [hLevel, inferredElement] = (0, $1fLvy.useHeading)($a5ad3e09f473ba51$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $a5ad3e09f473ba51$var$useColor(colorProp);
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $gMc0m.default)([
            $a5ad3e09f473ba51$var$styles.reset,
            size && $a5ad3e09f473ba51$var$headingSizeStylesMap[size],
            $a5ad3e09f473ba51$var$headingColorStylesMap[color]
        ]),
        children: children
    });
});
var $a5ad3e09f473ba51$export$2e2bcd8739ae039 = $a5ad3e09f473ba51$var$Heading;
module.exports["default"] = $a5ad3e09f473ba51$export$2e2bcd8739ae039;

});

parcelRegister("1fLvy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $d5887b98fd518b08$var$HeadingLevelContext = /*#__PURE__*/ (0, $42omo.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ const $d5887b98fd518b08$var$useHeadingLevel = ()=>{
    return (0, $42omo.useContext)($d5887b98fd518b08$var$HeadingLevelContext);
};
const $d5887b98fd518b08$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = $d5887b98fd518b08$var$useHeadingLevel();
    /**
	 * Order here is important, we for now apply
	 * 1. inferred a11y level (this only applies if context is present)
	 * 2. default final fallback
	 */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ const $d5887b98fd518b08$var$HeadingLevelContextProvider = ({ children: children, value: value })=>{
    const parentHeadingLevel = $d5887b98fd518b08$var$useHeadingLevel();
    const headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, $l998X.jsx)($d5887b98fd518b08$var$HeadingLevelContext.Provider, {
        value: value || headingLevel,
        children: children
    });
};
var $d5887b98fd518b08$export$2e2bcd8739ae039 = $d5887b98fd518b08$var$HeadingLevelContextProvider;
module.exports["useHeading"] = $d5887b98fd518b08$export$97a37b1befbbf9b1;
module.exports["default"] = $d5887b98fd518b08$export$2e2bcd8739ae039;

});

parcelRegister("5zdke", function(module, exports) {
$parcel$export(module.exports, "default", () => $40da8ec3d4d7454a$export$2e2bcd8739ae039);

var $bDniu = parcelRequire("bDniu");


var $7Q5yr = parcelRequire("7Q5yr");


var $42omo = parcelRequire("42omo");









var $8m5WU = parcelRequire("8m5WU");


var $iP9n7 = parcelRequire("iP9n7");





var $7afb99a5963ccb8b$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $7afb99a5963ccb8b$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $7afb99a5963ccb8b$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $42omo.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $7afb99a5963ccb8b$export$b8c7b07253306600
    }));
};
$7afb99a5963ccb8b$var$InFocusGuard.propTypes = {};
var $7afb99a5963ccb8b$export$2e2bcd8739ae039 = $7afb99a5963ccb8b$var$InFocusGuard;



var $8vNC8 = parcelRequire("8vNC8");

var $937ff71770415d2c$export$5733e022b1d538cb = (0, $8vNC8.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $937ff71770415d2c$export$b3e9a9312f73723c = (0, $8vNC8.createMedium)();
var $937ff71770415d2c$export$3a1d52767cbc07b8 = (0, $8vNC8.createMedium)();
var $937ff71770415d2c$export$892cbf28e5518020 = (0, $8vNC8.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});





var $5688a3eb650fb3fe$export$f5272e9b1168239c = /*#__PURE__*/ (0, $42omo.createContext)(undefined);


var $b6078fd006f9f8f7$var$emptyArray = [];
var $b6078fd006f9f8f7$var$FocusLock = /*#__PURE__*/ $42omo.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $42omo.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $42omo.useRef();
    var isActive = $42omo.useRef(false);
    var originalFocusedElement = $42omo.useRef(null);
    var _React$useState2 = $42omo.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $b6078fd006f9f8f7$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $42omo.useState({}), id = _React$useState3[0];
    var onActivation = $42omo.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $42omo.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $42omo.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $42omo.useCallback(function(event) {
        if (isActive.current) (0, $937ff71770415d2c$export$5733e022b1d538cb).useMedium(event);
    }, []);
    var onBlur = (0, $937ff71770415d2c$export$b3e9a9312f73723c).useMedium;
    var setObserveNode = $42omo.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $7Q5yr.default)((_extends2 = {}, _extends2[$8m5WU.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$8m5WU.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $iP9n7.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $42omo.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $42omo.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $7afb99a5963ccb8b$export$b8c7b07253306600)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $42omo.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $7afb99a5963ccb8b$export$b8c7b07253306600)
        }) : null
    ], !disabled && /*#__PURE__*/ $42omo.createElement(SideCar, {
        id: id,
        sideCar: (0, $937ff71770415d2c$export$892cbf28e5518020),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $42omo.createElement(Container, (0, $7Q5yr.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $42omo.createElement((0, $5688a3eb650fb3fe$export$f5272e9b1168239c).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $42omo.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $7afb99a5963ccb8b$export$b8c7b07253306600)
    }));
});
$b6078fd006f9f8f7$var$FocusLock.propTypes = {};
var $b6078fd006f9f8f7$export$2e2bcd8739ae039 = $b6078fd006f9f8f7$var$FocusLock;







var $llxFe = parcelRequire("llxFe");


var $2VuPT = parcelRequire("2VuPT");

var $kX89W = parcelRequire("kX89W");

var $cAqZd = parcelRequire("cAqZd");

var $brWu4 = parcelRequire("brWu4");

var $gqJu5 = parcelRequire("gqJu5");
parcelRequire("beVSF");
var $kcGU6 = parcelRequire("kcGU6");

function $b35781ac134dbb63$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $b35781ac134dbb63$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $b35781ac134dbb63$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};



var $bfb06dba1d393960$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $bfb06dba1d393960$var$isFreeFocus = function isFreeFocus() {
    return $bfb06dba1d393960$var$focusOnBody() || (0, $gqJu5.focusIsHidden)();
};
var $bfb06dba1d393960$var$lastActiveTrap = null;
var $bfb06dba1d393960$var$lastActiveFocus = null;
var $bfb06dba1d393960$var$lastPortaledElement = null;
var $bfb06dba1d393960$var$focusWasOutsideWindow = false;
var $bfb06dba1d393960$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $bfb06dba1d393960$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($bfb06dba1d393960$var$lastActiveTrap.whiteList || $bfb06dba1d393960$var$defaultWhitelist)(activeElement);
};
var $bfb06dba1d393960$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $bfb06dba1d393960$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $bfb06dba1d393960$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $bfb06dba1d393960$var$lastPortaledElement && $bfb06dba1d393960$var$lastPortaledElement.portaledElement === element;
};
function $bfb06dba1d393960$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $bfb06dba1d393960$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($bfb06dba1d393960$var$focusWasOutsideWindow);
    return $bfb06dba1d393960$var$focusWasOutsideWindow === 'meanwhile';
};
var $bfb06dba1d393960$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $bfb06dba1d393960$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $bfb06dba1d393960$var$checkInHost(activeElement, area, area);
    });
};
var $bfb06dba1d393960$var$activateTrap = function activateTrap() {
    var result = false;
    if ($bfb06dba1d393960$var$lastActiveTrap) {
        var _lastActiveTrap = $bfb06dba1d393960$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $bfb06dba1d393960$var$lastPortaledElement && $bfb06dba1d393960$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $b35781ac134dbb63$export$c613fed06e332533)).filter(Boolean));
            if (!activeElement || $bfb06dba1d393960$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $bfb06dba1d393960$var$focusWasOutside(crossFrame) || !$bfb06dba1d393960$var$isFreeFocus() || !$bfb06dba1d393960$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $brWu4.focusInside)(workingArea) || activeElement && $bfb06dba1d393960$var$withinHost(activeElement, workingArea) || $bfb06dba1d393960$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$bfb06dba1d393960$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $kcGU6.moveFocusInside)(workingArea, $bfb06dba1d393960$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $bfb06dba1d393960$var$lastPortaledElement = {};
                        }
                    }
                    $bfb06dba1d393960$var$focusWasOutsideWindow = false;
                    $bfb06dba1d393960$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $kX89W.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $bfb06dba1d393960$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $bfb06dba1d393960$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $bfb06dba1d393960$var$onTrap = function onTrap(event) {
    if ($bfb06dba1d393960$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $bfb06dba1d393960$var$onBlur = function onBlur() {
    return (0, $b35781ac134dbb63$export$6523025722806278)($bfb06dba1d393960$var$activateTrap);
};
var $bfb06dba1d393960$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $bfb06dba1d393960$var$recordPortal(currentNode, source);
};
var $bfb06dba1d393960$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $bfb06dba1d393960$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $42omo.createElement("div", {
        onBlur: $bfb06dba1d393960$var$onBlur,
        onFocus: $bfb06dba1d393960$var$onFocus
    }, children);
};
$bfb06dba1d393960$var$FocusTrap.propTypes = {};
var $bfb06dba1d393960$var$onWindowBlur = function onWindowBlur() {
    $bfb06dba1d393960$var$focusWasOutsideWindow = 'just';
    (0, $b35781ac134dbb63$export$6523025722806278)(function() {
        $bfb06dba1d393960$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $bfb06dba1d393960$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $bfb06dba1d393960$var$onTrap);
    document.addEventListener('focusout', $bfb06dba1d393960$var$onBlur);
    window.addEventListener('blur', $bfb06dba1d393960$var$onWindowBlur);
};
var $bfb06dba1d393960$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $bfb06dba1d393960$var$onTrap);
    document.removeEventListener('focusout', $bfb06dba1d393960$var$onBlur);
    window.removeEventListener('blur', $bfb06dba1d393960$var$onWindowBlur);
};
function $bfb06dba1d393960$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $bfb06dba1d393960$var$focusLockAPI = {
    moveFocusInside: (0, $kcGU6.moveFocusInside),
    focusInside: (0, $brWu4.focusInside),
    focusNextElement: (0, $cAqZd.focusNextElement),
    focusPrevElement: (0, $cAqZd.focusPrevElement),
    focusFirstElement: (0, $cAqZd.focusFirstElement),
    focusLastElement: (0, $cAqZd.focusLastElement),
    captureFocusRestore: (0, $2VuPT.captureFocusRestore)
};
function $bfb06dba1d393960$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$bfb06dba1d393960$var$lastActiveTrap) $bfb06dba1d393960$var$attachHandler();
    var lastTrap = $bfb06dba1d393960$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $bfb06dba1d393960$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $bfb06dba1d393960$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($bfb06dba1d393960$var$focusLockAPI);
        $bfb06dba1d393960$var$activateTrap(true);
        (0, $b35781ac134dbb63$export$6523025722806278)($bfb06dba1d393960$var$activateTrap);
    } else {
        $bfb06dba1d393960$var$detachHandler();
        $bfb06dba1d393960$var$lastActiveFocus = null;
    }
}
(0, $937ff71770415d2c$export$5733e022b1d538cb).assignSyncMedium($bfb06dba1d393960$var$onFocus);
(0, $937ff71770415d2c$export$b3e9a9312f73723c).assignMedium($bfb06dba1d393960$var$onBlur);
(0, $937ff71770415d2c$export$3a1d52767cbc07b8).assignMedium(function(cb) {
    return cb($bfb06dba1d393960$var$focusLockAPI);
});
var $bfb06dba1d393960$export$2e2bcd8739ae039 = (0, $llxFe.default)($bfb06dba1d393960$var$reducePropsToState, $bfb06dba1d393960$var$handleStateChangeOnClient)($bfb06dba1d393960$var$FocusWatcher);


var $cf569c0a493718bb$var$FocusLockCombination = /*#__PURE__*/ $42omo.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $42omo.createElement((0, $b6078fd006f9f8f7$export$2e2bcd8739ae039), (0, $7Q5yr.default)({
        sideCar: (0, $bfb06dba1d393960$export$2e2bcd8739ae039),
        ref: ref
    }, props));
});
var $cf569c0a493718bb$var$_ref = (0, $b6078fd006f9f8f7$export$2e2bcd8739ae039).propTypes || {}, $cf569c0a493718bb$var$sideCar = $cf569c0a493718bb$var$_ref.sideCar, $cf569c0a493718bb$var$propTypes = (0, $bDniu.default)($cf569c0a493718bb$var$_ref, [
    "sideCar"
]);
$cf569c0a493718bb$var$FocusLockCombination.propTypes = {};
var $cf569c0a493718bb$export$2e2bcd8739ae039 = $cf569c0a493718bb$var$FocusLockCombination;



var $40da8ec3d4d7454a$export$2e2bcd8739ae039 = (0, $cf569c0a493718bb$export$2e2bcd8739ae039);

});

parcelRegister("8m5WU", function(module, exports) {
/**
 * defines a focus group
 */ var $6154fe33394159ee$export$4f9a06cb7441a087 = 'data-focus-lock';
var $6154fe33394159ee$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $6154fe33394159ee$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $6154fe33394159ee$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $6154fe33394159ee$export$134ebef29fd94853 = 'data-no-autofocus';
module.exports["FOCUS_GROUP"] = $6154fe33394159ee$export$4f9a06cb7441a087;
module.exports["FOCUS_DISABLED"] = $6154fe33394159ee$export$aeda8252e54b50f7;
module.exports["FOCUS_ALLOW"] = $6154fe33394159ee$export$54ecf528c58f9ef6;
module.exports["FOCUS_AUTO"] = $6154fe33394159ee$export$70e9b4a1820af101;
module.exports["FOCUS_NO_AUTOFOCUS"] = $6154fe33394159ee$export$134ebef29fd94853;

});

parcelRegister("iP9n7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $51c7W = parcelRequire("51c7W");




function $aeda11f15e7fbcf3$export$25bec8c6f54ee79a(initialValue, callback) {
    const [ref] = (0, $42omo.useState)(()=>({
            // value
            value: initialValue,
            callback: // last callback
            callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    const last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        }));
    // update callback
    ref.callback = callback;
    return ref.facade;
}


const $db4442799c9f03a3$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $42omo.useLayoutEffect : $42omo.useEffect;
const $db4442799c9f03a3$var$currentValues = new WeakMap();
function $db4442799c9f03a3$export$74665b213cb5c4cf(refs, defaultValue) {
    const callbackRef = (0, $aeda11f15e7fbcf3$export$25bec8c6f54ee79a)(defaultValue || null, (newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
    // handle refs changes - added or removed
    $db4442799c9f03a3$var$useIsomorphicLayoutEffect(()=>{
        const oldValue = $db4442799c9f03a3$var$currentValues.get(callbackRef);
        if (oldValue) {
            const prevRefs = new Set(oldValue);
            const nextRefs = new Set(refs);
            const current = callbackRef.current;
            prevRefs.forEach((ref)=>{
                if (!nextRefs.has(ref)) (0, $51c7W.assignRef)(ref, null);
            });
            nextRefs.forEach((ref)=>{
                if (!prevRefs.has(ref)) (0, $51c7W.assignRef)(ref, current);
            });
        }
        $db4442799c9f03a3$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}
module.exports["useMergeRefs"] = $db4442799c9f03a3$export$74665b213cb5c4cf;

});

parcelRegister("51c7W", function(module, exports) {
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $3a7673f34a80cfff$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}
module.exports["assignRef"] = $3a7673f34a80cfff$export$d734136a7b018efe;

});

parcelRegister("8vNC8", function(module, exports) {
function $6327b44801949fd6$var$ItoI(a) {
    return a;
}
function $6327b44801949fd6$var$innerCreateMedium(defaults, middleware = $6327b44801949fd6$var$ItoI) {
    let buffer = [];
    let assigned = false;
    const medium = {
        read () {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium (data) {
            const item = middleware(data, assigned);
            buffer.push(item);
            return ()=>{
                buffer = buffer.filter((x)=>x !== item);
            };
        },
        assignSyncMedium (cb) {
            assigned = true;
            while(buffer.length){
                const cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: (x)=>cb(x),
                filter: ()=>buffer
            };
        },
        assignMedium (cb) {
            assigned = true;
            let pendingQueue = [];
            if (buffer.length) {
                const cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            const executeQueue = ()=>{
                const cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            const cycle = ()=>Promise.resolve().then(executeQueue);
            cycle();
            buffer = {
                push: (x)=>{
                    pendingQueue.push(x);
                    cycle();
                },
                filter: (filter)=>{
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $6327b44801949fd6$export$9ffbfcaf067b02c6(defaults, middleware = $6327b44801949fd6$var$ItoI) {
    return $6327b44801949fd6$var$innerCreateMedium(defaults, middleware);
}
function $6327b44801949fd6$export$e13ec7dd7a14088d(options = {}) {
    const medium = $6327b44801949fd6$var$innerCreateMedium(null);
    medium.options = {
        async: true,
        ssr: false,
        ...options
    };
    return medium;
}
module.exports["createMedium"] = $6327b44801949fd6$export$9ffbfcaf067b02c6;
module.exports["createSidecarMedium"] = $6327b44801949fd6$export$e13ec7dd7a14088d;

});

parcelRegister("llxFe", function(module, exports) {

var $4tRVV = parcelRequire("4tRVV");


var $iLaQ6 = parcelRequire("iLaQ6");


var $42omo = parcelRequire("42omo");

function $f8a5ac189426c91a$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $4tRVV.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $42omo.PureComponent));
        (0, $iLaQ6.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $f8a5ac189426c91a$export$2e2bcd8739ae039 = $f8a5ac189426c91a$var$withSideEffect;
module.exports["default"] = $f8a5ac189426c91a$export$2e2bcd8739ae039;

});

parcelRegister("iLaQ6", function(module, exports) {

var $gCRro = parcelRequire("gCRro");

function $da85064685168e73$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $gCRro.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports["default"] = $da85064685168e73$export$2e2bcd8739ae039;

});

parcelRegister("gCRro", function(module, exports) {

var $da6O1 = parcelRequire("da6O1");




function $78b40f6d523018fc$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $da6O1.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $da6O1.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $c1a9a63172eca1c8$export$2e2bcd8739ae039(t) {
    var i = (0, $78b40f6d523018fc$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $da6O1.default)(i) ? i : i + "";
}
module.exports["default"] = $c1a9a63172eca1c8$export$2e2bcd8739ae039;

});

parcelRegister("2VuPT", function(module, exports) {

var $9OOUs = parcelRequire("9OOUs");

function $2218d3049304f6dd$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $2218d3049304f6dd$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $2218d3049304f6dd$var$weakRef(currentElement),
            parent: $2218d3049304f6dd$var$weakRef(currentElement.parentElement),
            left: $2218d3049304f6dd$var$weakRef(currentElement.previousElementSibling),
            right: $2218d3049304f6dd$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $2218d3049304f6dd$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $2218d3049304f6dd$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $9OOUs.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $2218d3049304f6dd$export$d357db6e554ff59a = function(targetElement) {
    var location = $2218d3049304f6dd$export$5061a7725be48ff9(targetElement);
    return function() {
        return $2218d3049304f6dd$var$restoreFocusTo(location);
    };
};
module.exports["captureFocusRestore"] = $2218d3049304f6dd$export$d357db6e554ff59a;

});

parcelRegister("9OOUs", function(module, exports) {

var $jietZ = parcelRequire("jietZ");


var $cdwZR = parcelRequire("cdwZR");


var $8k0Cv = parcelRequire("8k0Cv");


var $71ClY = parcelRequire("71ClY");

var $726046279a8514e0$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $jietZ.toArray)(nodes).filter(function(node) {
        return (0, $cdwZR.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $cdwZR.notHiddenInput)(node);
    });
};
var $726046279a8514e0$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $jietZ.toArray)(nodes).filter(function(node) {
        return (0, $cdwZR.isAutoFocusAllowedCached)(cache, node);
    });
};
var $726046279a8514e0$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $8k0Cv.orderByTabIndex)($726046279a8514e0$export$6266a5cd5915dc33((0, $71ClY.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $726046279a8514e0$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $8k0Cv.orderByTabIndex)($726046279a8514e0$export$6266a5cd5915dc33((0, $71ClY.getFocusables)(topNodes), visibilityCache), false);
};
var $726046279a8514e0$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $726046279a8514e0$export$6266a5cd5915dc33((0, $71ClY.getParentAutofocusables)(topNode), visibilityCache);
};
var $726046279a8514e0$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $726046279a8514e0$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $jietZ.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $726046279a8514e0$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $726046279a8514e0$export$2344b14b097df817(child, element);
        });
    }
};
module.exports["filterAutoFocusable"] = $726046279a8514e0$export$2f70373d403a5d2b;
module.exports["getTabbableNodes"] = $726046279a8514e0$export$3738e313571e2ad2;
module.exports["getFocusableNodes"] = $726046279a8514e0$export$493d05a3a8e6532d;
module.exports["parentAutofocusables"] = $726046279a8514e0$export$dc26309a71d1ce47;
module.exports["contains"] = $726046279a8514e0$export$2344b14b097df817;

});

parcelRegister("kX89W", function(module, exports) {

var $9mFgj = parcelRequire("9mFgj");


var $cdwZR = parcelRequire("cdwZR");


var $bIaib = parcelRequire("bIaib");


var $8k0Cv = parcelRequire("8k0Cv");


var $71ClY = parcelRequire("71ClY");

var $f40fa59a9688bb2e$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $9mFgj.getAllAffectedNodes)(topNode).filter((0, $cdwZR.isNotAGuard));
    var commonParent = (0, $bIaib.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $8k0Cv.orderByTabIndex)((0, $71ClY.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $71ClY.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $cdwZR.isGuard)(node)
        };
    });
};
module.exports["expandFocusableNodes"] = $f40fa59a9688bb2e$export$f89ac71e91767111;

});

parcelRegister("cAqZd", function(module, exports) {

var $2s4CC = parcelRequire("2s4CC");


var $9OOUs = parcelRequire("9OOUs");


var $jietZ = parcelRequire("jietZ");

var $929dc7bd937341b7$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $jietZ.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $9OOUs.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $9OOUs.getTabbableNodes)(shards, new Map()) : (0, $9OOUs.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $929dc7bd937341b7$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $9OOUs.getTabbableNodes)((0, $jietZ.asArray)(shards), new Map()) : (0, $9OOUs.getFocusableNodes)((0, $jietZ.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $929dc7bd937341b7$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $929dc7bd937341b7$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $929dc7bd937341b7$var$defaultOptions(options);
    var solution = $929dc7bd937341b7$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $2s4CC.focusOn)(target.node, newOptions.focusOptions);
};
var $929dc7bd937341b7$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $929dc7bd937341b7$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $929dc7bd937341b7$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $929dc7bd937341b7$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $929dc7bd937341b7$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $929dc7bd937341b7$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $2s4CC.focusOn)(node.node, options.focusOptions);
};
var $929dc7bd937341b7$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $929dc7bd937341b7$var$pickBoundary(scope, options, 'first');
};
var $929dc7bd937341b7$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $929dc7bd937341b7$var$pickBoundary(scope, options, 'last');
};
module.exports["focusNextElement"] = $929dc7bd937341b7$export$3b0237e8566c8d65;
module.exports["focusPrevElement"] = $929dc7bd937341b7$export$33b47db07a82b2fb;
module.exports["focusFirstElement"] = $929dc7bd937341b7$export$2a791d8097a66406;
module.exports["focusLastElement"] = $929dc7bd937341b7$export$6a79073ddabfd6c3;

});

parcelRegister("brWu4", function(module, exports) {

var $9OOUs = parcelRequire("9OOUs");


var $9mFgj = parcelRequire("9mFgj");


var $jietZ = parcelRequire("jietZ");


var $8AJ6G = parcelRequire("8AJ6G");

var $855f9501c3eebe3e$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $855f9501c3eebe3e$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $jietZ.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $855f9501c3eebe3e$var$focusInFrame(node, activeElement);
    }));
};
var $855f9501c3eebe3e$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $8AJ6G.getActiveElement)((0, $jietZ.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $9mFgj.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $9OOUs.contains)(node, activeElement) || $855f9501c3eebe3e$var$focusInsideIframe(node, activeElement);
    });
};
module.exports["focusInside"] = $855f9501c3eebe3e$export$20115f8da7baa6fa;

});

parcelRegister("gqJu5", function(module, exports) {

var $8m5WU = parcelRequire("8m5WU");


var $9OOUs = parcelRequire("9OOUs");


var $jietZ = parcelRequire("jietZ");


var $8AJ6G = parcelRequire("8AJ6G");

var $bf625b45d77adaae$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $8AJ6G.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $jietZ.toArray)(inDocument.querySelectorAll("[".concat((0, $8m5WU.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $9OOUs.contains)(node, activeElement);
    });
};
module.exports["focusIsHidden"] = $bf625b45d77adaae$export$be6b21806d3fd485;

});

parcelRegister("beVSF", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("kcGU6")).moveFocusInside);

var $8m5WU = parcelRequire("8m5WU");


var $brWu4 = parcelRequire("brWu4");


var $gqJu5 = parcelRequire("gqJu5");



var $kX89W = parcelRequire("kX89W");


var $kcGU6 = parcelRequire("kcGU6");


var $2VuPT = parcelRequire("2VuPT");


var $cAqZd = parcelRequire("cAqZd");


var $9OOUs = parcelRequire("9OOUs");

/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $82ede66d2b7944af$export$1a988e7317c65621 = $8m5WU;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $82ede66d2b7944af$var$deprecated_default_moveFocusInside = (0, $kcGU6.moveFocusInside);
var $82ede66d2b7944af$export$2e2bcd8739ae039 //
 = $82ede66d2b7944af$var$deprecated_default_moveFocusInside;

});

parcelRegister("iqsGx", function(module, exports) {
var $a833b5a125ff8400$exports = {};
$a833b5a125ff8400$exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $a833b5a125ff8400$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $a833b5a125ff8400$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}


var $d6a0e7fc51e1339c$var$listeningFocusTrap = null;
function $d6a0e7fc51e1339c$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $d6a0e7fc51e1339c$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($d6a0e7fc51e1339c$var$listeningFocusTrap) $d6a0e7fc51e1339c$var$listeningFocusTrap.pause();
        $d6a0e7fc51e1339c$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        $d6a0e7fc51e1339c$var$tryFocus(firstFocusNode());
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $d6a0e7fc51e1339c$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $d6a0e7fc51e1339c$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $d6a0e7fc51e1339c$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $d6a0e7fc51e1339c$var$tryFocus(lastTabbableNode);
            return $d6a0e7fc51e1339c$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $d6a0e7fc51e1339c$var$tryFocus(firstTabbableNode);
        $d6a0e7fc51e1339c$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $a833b5a125ff8400$exports(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $d6a0e7fc51e1339c$var$tryFocus(lastTabbableNode);
        $d6a0e7fc51e1339c$var$tryFocus(firstTabbableNode);
    }
}
function $d6a0e7fc51e1339c$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $d6a0e7fc51e1339c$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $d6a0e7fc51e1339c$var$focusTrap;

});

parcelRegister("2P8Ax", function(module, exports) {
var $20e701aaf9ab2a04$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $20e701aaf9ab2a04$export$2e2bcd8739ae039 = $20e701aaf9ab2a04$var$rafSchd;
module.exports["default"] = $20e701aaf9ab2a04$export$2e2bcd8739ae039;

});

parcelRegister("3IBnw", function(module, exports) {
/**
 * What makes a good attribution? The answer is vertical name. While having an
 * attribution be other than your vertical name can be acceptable in certain
 * cases, the main purpose of attribution is to ensure the first responder is
 * picked correctly (e.g. on a team-by-team basis). In order to understand what
 * exact part of functionality is broken one would add experience tracking for
 * this functionality, not error boundary.
 */ var $c03205d5f10e46ff$export$c18a293673ef2524 = /*#__PURE__*/ function(Attribution) {
    Attribution["INHERIT"] = "inherit";
    //
    // Verticals:
    //
    // Not all attribution are using the enum due to circular dependency.
    // Check plain string `attribution: 'backbone'` or `attribution: 'backbone-` as well
    Attribution["BACKBONE"] = "backbone";
    Attribution["INTEGRATIONS"] = "integrations";
    Attribution["COLLABORATION"] = "collaboration";
    Attribution["DISCO"] = "disco";
    Attribution["DLP"] = "dlp";
    Attribution["ECOSYSTEM"] = "ecosystem";
    Attribution["EXTERNAL_COLLAB"] = "external-collaboration";
    Attribution["GROWTH"] = "growth";
    Attribution["GROWTH_LUNA"] = "growth-luna";
    Attribution["GROWTH_MULTIPLIERS"] = "growth-multipliers";
    Attribution["GROWTH_PUMA"] = "growth-puma";
    Attribution["GROWTH_STARBURST"] = "growth-starburst";
    Attribution["GROWTH_TRANSMUTERS"] = "growth-transmuters";
    Attribution["GROWTH_TRAILBLAZERS"] = "growth-traiblazers";
    Attribution["FLYWHEEL_ACTIVATION"] = "flywheel-activation";
    Attribution["FLYWHEEL_ENGAGEMENT"] = "flywheel-engagement";
    Attribution["FLYWHEEL_FEATURE_DISCOVERY"] = "flywheel-feature-discovery";
    Attribution["NAVX"] = "navx";
    Attribution["COMPANY_HUB"] = "company-hub";
    Attribution["SMARTS"] = "smarts";
    Attribution["CC_ANALYTICS"] = "cc-analytics";
    Attribution["ECONOMY"] = "economy";
    Attribution["CONTENT_TYPES"] = "content-types";
    Attribution["CONTENPLATES"] = "contenplates";
    Attribution["AI_MATE"] = "ai-mate";
    Attribution["KNOWLEDGE_DISCOVERY"] = "knowledge-discovery";
    Attribution["STATSIG"] = "statsig";
    Attribution["AUTOMATION_FOR_CONFLUENCE"] = "automation-for-confluence";
    Attribution["PERMISSIONS_EXPERIENCE"] = "permissions-experience";
    Attribution["WHITEBOARDS"] = "whiteboards";
    Attribution["DATABASES"] = "databases";
    Attribution["ADMIN_EXPERIENCE"] = "admin-experience";
    Attribution["PAGE_EXPERIENCES"] = "page-experiences";
    Attribution["PAGE_EXTENSIONS"] = "page-extensions";
    Attribution["NOTIFICATIONS"] = "cc-notifications";
    Attribution["PAGE_MODES"] = "page-modes";
    Attribution["POST_OFFICE"] = "post-office";
    Attribution["COMMENTS"] = "comments";
    Attribution["TOPICS"] = "topics";
    Attribution["CC_INSIGHTS_AND_REPORTING"] = "cc-insights-and-reporting";
    Attribution["MIGRATIONS"] = "migrations";
    Attribution["CC_EDITOR_AI"] = "cc-editor-ai";
    Attribution["EDITOR_CORE"] = "editor-core";
    Attribution["COLLABORATION_PRESENCE"] = "collaboration-presence";
    Attribution["CC_IMPORTER"] = "cc-importer";
    Attribution["CC_MOBILE_APP"] = "cc-mobile-app";
    return Attribution;
}({});
module.exports["Attribution"] = $c03205d5f10e46ff$export$c18a293673ef2524;

});

parcelRegister("euL71", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $51adb6f8b97e4ad9$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
module.exports["ConfluenceEdition"] = $51adb6f8b97e4ad9$export$68577d543b14ae02;

});

parcelRegister("9A0hR", function(module, exports) {

var $9wEpK = parcelRequire("9wEpK");


var $aAxiE = parcelRequire("aAxiE");

class $2f64180a33ebe455$export$3ad5d0415dc12c65 extends (0, $9wEpK.ApolloError) {
    constructor(options){
        const graphQLErrors = options.graphQLErrors?.map((error)=>{
            const message = error.message;
            const nodes = 'nodes' in error ? error.nodes : undefined;
            const source = 'source' in error ? error.source : undefined;
            const positions = 'positions' in error ? error.positions : undefined;
            const path = error.path;
            const originalError = 'originalError' in error ? error.originalError : undefined;
            const extensions = error.extensions;
            return new (0, $aAxiE.GraphQLError)(message, nodes, source, positions, path, originalError, extensions);
        });
        super({
            ...options,
            graphQLErrors: graphQLErrors
        });
        // Fix prototype chain for instanceof checks
        // This is necessary when extending Error-based classes in JavaScript
        Object.setPrototypeOf(this, $2f64180a33ebe455$export$3ad5d0415dc12c65.prototype);
    }
}
module.exports["ApolloErrorInterop"] = $2f64180a33ebe455$export$3ad5d0415dc12c65;

});

parcelRegister("5jrGM", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $3de43490561dba32$export$b02c0b814e843e71 = (0, $eSUdr.default)`query ScreenQuery($spaceKey:String!){space(key:$spaceKey){id homepage{id}}}`;
module.exports["ScreenQuery"] = $3de43490561dba32$export$b02c0b814e843e71;

});

parcelRegister("ffCOo", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => (parcelRequire("cT1Md")).ELEMENTS_CONTEXT);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => (parcelRequire("cT1Md")).FabricElementsAnalyticsContext);
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => (parcelRequire("1oYFx")).NAVIGATION_CONTEXT);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("1oYFx")).NavigationAnalyticsContext);
$parcel$export(module.exports, "EDITOR_CONTEXT", () => (parcelRequire("7i8J9")).EDITOR_CONTEXT);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => (parcelRequire("7i8J9")).FabricEditorAnalyticsContext);
$parcel$export(module.exports, "MEDIA_CONTEXT", () => (parcelRequire("gSKON")).MEDIA_CONTEXT);
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => (parcelRequire("gqplE")).PEOPLE_TEAMS_CONTEXT);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => (parcelRequire("gqplE")).PeopleTeamsAnalyticsContext);
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => (parcelRequire("ePh4F")).NOTIFICATIONS_CONTEXT);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => (parcelRequire("ePh4F")).NotificationsAnalyticsContext);
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => (parcelRequire("8hvil")).RECENT_WORK_CONTEXT);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => (parcelRequire("8hvil")).RecentWorkAnalyticsContext);
$parcel$export(module.exports, "ATLAS_CONTEXT", () => (parcelRequire("dWoPW")).ATLAS_CONTEXT);
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => (parcelRequire("2mJpK")).TOWNSQUARE_HOME_CONTEXT);
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => (parcelRequire("kwKGS")).LINKING_PLATFORM_CONTEXT);
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => (parcelRequire("26stD")).POST_OFFICE_CONTEXT);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => (parcelRequire("26stD")).PostOfficeAnalyticsContext);
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => (parcelRequire("2jQZn")).AI_MATE_CONTEXT);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => (parcelRequire("2jQZn")).AIMateAnalyticsContext);
$parcel$export(module.exports, "AVP_CONTEXT", () => (parcelRequire("aVIsj")).AVP_CONTEXT);
$parcel$export(module.exports, "GROWTH_CONTEXT", () => (parcelRequire("hcByP")).GROWTH_CONTEXT);
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => (parcelRequire("aldCG")).OMNI_CHANNEL_CONTEXT);
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => (parcelRequire("lJwkv")).ROVO_EXTENSION_CONTEXT);

var $cT1Md = parcelRequire("cT1Md");


var $1oYFx = parcelRequire("1oYFx");


var $7i8J9 = parcelRequire("7i8J9");


var $gSKON = parcelRequire("gSKON");


var $gqplE = parcelRequire("gqplE");


var $ePh4F = parcelRequire("ePh4F");


var $8hvil = parcelRequire("8hvil");


var $dWoPW = parcelRequire("dWoPW");


var $2mJpK = parcelRequire("2mJpK");


var $kwKGS = parcelRequire("kwKGS");


var $26stD = parcelRequire("26stD");


var $2jQZn = parcelRequire("2jQZn");


var $aVIsj = parcelRequire("aVIsj");


var $hcByP = parcelRequire("hcByP");


var $aldCG = parcelRequire("aldCG");


var $lJwkv = parcelRequire("lJwkv");


});

parcelRegister("bYRk6", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea8853976ea9996a$export$2e2bcd8739ae039);

var $5kH4g = parcelRequire("5kH4g");

var $ea8853976ea9996a$export$2e2bcd8739ae039 = (0, $5kH4g.default);

});

parcelRegister("5kH4g", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2xIMp = parcelRequire("2xIMp");


var $fFVny = parcelRequire("fFVny");


var $fTXBo = parcelRequire("fTXBo");

const $111872f54037d6c3$var$AnalyticsContext = ({ data: data, children: children })=>{
    const dataRef = (0, $fTXBo.useTrackedRef)(data);
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsContext: getOriginalAnalyticsContext } = (0, $fFVny.useAnalyticsContext)();
    const getAtlaskitAnalyticsContext = (0, $42omo.useCallback)(()=>{
        return [
            ...getOriginalAnalyticsContext(),
            dataRef.current
        ];
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    const value = (0, $42omo.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2xIMp.default).Provider, {
        value: value,
        children: children
    });
};
var $111872f54037d6c3$export$2e2bcd8739ae039 = $111872f54037d6c3$var$AnalyticsContext;
module.exports["default"] = $111872f54037d6c3$export$2e2bcd8739ae039;

});

parcelRegister("7i8J9", function(module, exports) {

var $lzPoe = parcelRequire("lzPoe");

const $b5cba05215695b9c$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $b5cba05215695b9c$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
const $b5cba05215695b9c$export$629cada6c5e621e1 = (0, $lzPoe.default)($b5cba05215695b9c$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');
module.exports["EDITOR_CONTEXT"] = $b5cba05215695b9c$export$8c8f6d8f1fa796f0;
module.exports["EDITOR_APPEARANCE_CONTEXT"] = $b5cba05215695b9c$export$9eb2b47430ed3f7c;
module.exports["FabricEditorAnalyticsContext"] = $b5cba05215695b9c$export$629cada6c5e621e1;

});

parcelRegister("gSKON", function(module, exports) {
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $4d0bf9efc7729ff2$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx
module.exports["MEDIA_CONTEXT"] = $4d0bf9efc7729ff2$export$70df29c238ba7306;

});

parcelRegister("6auOX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $fw9LG = parcelRequire("fw9LG");


var $9Oif4 = parcelRequire("9Oif4");

class $76b7cc3ac50fdae1$export$44bee9c9373d59fb extends (0, $9Oif4.ChoreographerPlugin) {
    constructor(product, env, metaMetricsData = {}){
        super(product, env, metaMetricsData);
    }
}



var $aD1SW = parcelRequire("aD1SW");


var $6sxJX = parcelRequire("6sxJX");

const $b19b0d58a00642e5$export$9879a8e0db317538 = (0, $6sxJX.wrapComponentForChoreographer)((0, $aD1SW.default));


var $15EjN = parcelRequire("15EjN");




const $7fb5c97ca53d1775$export$3b4e64e77073e307 = (0, $6sxJX.wrapComponentForChoreographer)((0, $15EjN.default));


var $eCEXz = parcelRequire("eCEXz");




const $4d9494329fe7700e$export$48ea269755562084 = (0, $6sxJX.wrapComponentForChoreographer)((0, $eCEXz.default));


var $hPd3F = parcelRequire("hPd3F");




const $cca4986a061dde06$export$c7313f750e9cbc9d = (0, $6sxJX.wrapToggleableComponentForChoreographer)((0, $hPd3F.default), 'isOpen');


var $8CZUH = parcelRequire("8CZUH");




const $2aa064f91d3e3a1e$export$2b77a92f1a5ad772 = (0, $6sxJX.wrapComponentForChoreographer)((0, $8CZUH.default));


var $bqAtB = parcelRequire("bqAtB");




const $678769aa0bd77385$export$d7e1f420b25549ff = (0, $6sxJX.wrapToggleableComponentForChoreographer)((0, $bqAtB.PopoverContent), 'isVisible');


var $lqsSp = parcelRequire("lqsSp");




const $468edaccd0529729$export$badac9ada3a0bdf9 = (0, $6sxJX.wrapComponentForChoreographer)((0, $lqsSp.Popper));

parcelRequire("lGgRw");
var $2mqmH = parcelRequire("2mqmH");




const $d13ffcfee2ff3666$export$129a32eedafa97c5 = (0, $6sxJX.wrapToggleableComponentForChoreographer)((0, $2mqmH.Popup), 'isOpen');




var $5RBJ9 = parcelRequire("5RBJ9");




const $e745bdec4f55f1ed$export$1033c28b5e1c2deb = (0, $6sxJX.wrapComponentForChoreographer)((0, $5RBJ9.default));


var $91xA1 = parcelRequire("91xA1");




const $faebbb111c596651$export$14710e13fc01d383 = (0, $6sxJX.wrapComponentForChoreographer)((0, $91xA1.default));


function $2bc8c852c894953d$export$55d2aeb17c4cfbe(productId, env, metaMetricsData = {}, choreographerOptions = {
    enableChoreographer: true
}) {
    // Instantiate our plugin instance, passing the productId through for segmenting any messageId's from any other plugins
    const plugin = new (0, $76b7cc3ac50fdae1$export$44bee9c9373d59fb)(productId, env, metaMetricsData);
    // Capture plugin-wide TTL from options
    const pluginTtl = choreographerOptions.messageTtl;
    /**
	 * React hook that provides startMessage and stopMessage functions that call through the plugin API with the provided messageId, for easy assignment to React event handlers.
	 *
	 * @param messageId The messageId to be provided to the choreographer API whenever the startMessage and stopMessage callbacks are invoked.
	 * @param callbacks An object containing start and stop callbacks.
	 * @param messageTtl Optional TTL for messages started via the returned startMessage function. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use plugin-wide TTL or global default (5 minutes). Message-level TTL takes priority over plugin-wide TTL.
	 * @returns An object with startMessage and stopMessage callbacks, which contain references to the messageId to be passed to the choreographer API, so that the consumer no longer needs to specify that at call time.
	 */ const useChoreographer = (messageId, { [(0, $fw9LG.MessageEventType).START]: startCallback, [(0, $fw9LG.MessageEventType).STOP]: stopCallback } = {}, messageTtl)=>{
        const isMessageStarted = (0, $42omo.useRef)(false);
        const startRef = (0, $42omo.useRef)(startCallback);
        const stopRef = (0, $42omo.useRef)(stopCallback);
        // Callback that uses a ref to track any changes in the received startCallback parameter, so the caller doesn't have to worry about memoization
        const startMessageCallback = (0, $42omo.useCallback)(async (...args)=>{
            const didMessageStart = await startRef.current?.(...args) ?? true;
            isMessageStarted.current = didMessageStart;
            return didMessageStart;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's startMessage function, for use in components.
        // Use message-level TTL if provided, otherwise fall back to plugin-wide TTL
        const startMessage = (0, $42omo.useCallback)((...args)=>{
            plugin.onStart(messageId, ()=>startMessageCallback(...args));
            // Message-level TTL takes priority over plugin-wide TTL, if provided
            return plugin.startMessage(messageId, {}, messageTtl !== undefined ? messageTtl : pluginTtl);
        }, [
            messageId,
            startMessageCallback,
            messageTtl
        ]);
        // Callback that uses a ref to track any changes in the received stopCallback parameter, so the caller doesn't have to worry about memoization
        const stopMessageCallback = (0, $42omo.useCallback)(async (...args)=>{
            const didMessageStop = await stopRef.current?.(...args) ?? true;
            isMessageStarted.current = !didMessageStop;
            return didMessageStop;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's stopMessage function, for use in components.
        const stopMessage = (0, $42omo.useCallback)((...args)=>{
            if (isMessageStarted.current) {
                plugin.onStop(messageId, ()=>stopMessageCallback(...args));
                return plugin.stopMessage(messageId);
            }
            return Promise.resolve((0, $fw9LG.MessageDeliveryStatus).STOPPED);
        }, [
            isMessageStarted,
            messageId,
            stopMessageCallback
        ]);
        // Stable function reference that invokes whichever start or stop handler is appropriate for the message's current display state.
        // Tracking this state with a ref allows us to know the current display state in real-time, so that potentially subsequent calls
        // can be made to toggle its state, without requiring tracking a useState value and requiring rerenders to update the callback
        // with the latest display state, and without generating false blocked messages from cached/outdated toggleMessage references.
        const toggleMessage = (0, $42omo.useCallback)(()=>{
            return isMessageStarted.current ? stopMessage() : startMessage();
        }, [
            isMessageStarted,
            startMessage,
            stopMessage
        ]);
        // Syncs any incoming startCallback and stopCallback functions as the latest version to be invoked when a startMessage or stopMessage call is issued through the choreographer API
        (0, $42omo.useLayoutEffect)(()=>{
            startRef.current = startCallback;
            stopRef.current = stopCallback;
        }, [
            startCallback,
            stopCallback
        ]);
        /**
		 * At component mount, we want to default a start and stop function, which invokes these functions with no additional parameters,
		 * just to supply some sane defaults. If startMessage or stopMessage are called explicitly, they can optionally supply some extra
		 * parameters, at which point, a just-in-time registration of a new callback version will be supplied to the choreographer, which
		 * will proxy those parameter through to the target state-setter functions. But if they are not called explicitly, such as in the
		 * case where a message is started and never stopped, and is timed out from the Choreographer, we want to have a default version
		 * available to execute against.
		 *
		 * At component unmount, stop the current message, if it's displayed, and unsubscribe the stop callback for this messageId within
		 * the plugin.
		 */ (0, $42omo.useLayoutEffect)(()=>{
            plugin.on(messageId, {
                start: async ()=>{
                    return await startMessage() === (0, $fw9LG.MessageDeliveryStatus).STARTED;
                },
                stop: async ()=>{
                    return await stopMessage() === (0, $fw9LG.MessageDeliveryStatus).STOPPED;
                }
            });
            return ()=>{
                // If unsubscribing, fire the stopMessageCallback one last time to ensure the component can clear the local state responsible for displaying its message
                stopMessage(messageId);
                plugin.off(messageId);
            };
        }, [
            messageId,
            startMessage,
            stopMessage
        ]);
        // Return the wrapped startMessage and stopMessage functions to the consumer, which will route their requests through the choreographer API with the messageId proxied straight through on behalf of the caller
        return (0, $42omo.useMemo)(()=>({
                startMessage: startMessage,
                stopMessage: stopMessage,
                toggleMessage: toggleMessage
            }), [
            startMessage,
            stopMessage,
            toggleMessage
        ]);
    };
    const shouldBeChoreographed = (props, toggleableProp)=>{
        if ((0, $dh538.fg)('post-office_move_shouldbechoreographed')) return plugin.shouldBeChoreographed(props, choreographerOptions, toggleableProp);
        return (0, $6sxJX.shouldBeChoreographed)(props, choreographerOptions);
    };
    const useChoreographedRender = ({ messageId: messageId, onMessageDisposition: onMessageDisposition, messageTtl: messageTtl })=>{
        const [shouldRender, setShouldRender] = (0, $42omo.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
            start: ()=>setShouldRender(true),
            stop: ()=>setShouldRender(false)
        }, messageTtl);
        (0, $42omo.useLayoutEffect)(()=>{
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            const stopMessageAsync = async ()=>{
                const disposition = await stopMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>void stopMessageAsync();
        }, [
            messageId,
            onMessageDisposition,
            startMessage,
            stopMessage,
            messageTtl
        ]);
        return shouldRender;
    };
    const withChoreographedRender = (Component)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, messageTtl: messageTtl, ...props }) {
            const shouldRender = useChoreographedRender({
                messageId: messageId,
                onMessageDisposition: onMessageDisposition,
                messageTtl: messageTtl
            });
            if (shouldRender) // Need to cast "props" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition" | "messageTtl"> is the same as T
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props);
            return null;
        }
        ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
        return ChoreographedComponent;
    };
    const withChoreographedToggle = (Component, toggleableProp)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, messageTtl: messageTtl, ...rest }) {
            // Need to cast "rest" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition" | "messageTtl"> is the same as T
            const props = rest;
            const toggleablePropValue = props[toggleableProp];
            const [shouldRender, setShouldRender] = (0, $42omo.useState)(false);
            const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
                start: ()=>setShouldRender(true),
                stop: ()=>setShouldRender(false)
            }, messageTtl);
            (0, $42omo.useLayoutEffect)(()=>{
                const startMessageAsync = async ()=>{
                    const disposition = await startMessage();
                    onMessageDisposition?.(disposition);
                };
                const stopMessageAsync = async ()=>{
                    const disposition = await stopMessage();
                    onMessageDisposition?.(disposition);
                };
                if (toggleablePropValue && !shouldRender) startMessageAsync();
                else if (!toggleablePropValue && shouldRender) stopMessageAsync();
                return ()=>{
                    if (!toggleablePropValue && shouldRender) stopMessageAsync();
                };
            }, [
                messageId,
                onMessageDisposition,
                shouldRender,
                startMessage,
                stopMessage,
                toggleablePropValue,
                messageTtl
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                ...props,
                [toggleableProp]: shouldRender
            });
        }
        return ChoreographedComponent;
    };
    function wrapWithFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedRender: withChoreographedRender
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    function wrapWithToggleFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    const AutoDismissFlag = wrapWithFactoryFunctions((0, $b19b0d58a00642e5$export$9879a8e0db317538));
    const Banner = wrapWithFactoryFunctions((0, $7fb5c97ca53d1775$export$3b4e64e77073e307));
    const Flag = wrapWithFactoryFunctions((0, $4d9494329fe7700e$export$48ea269755562084));
    const Modal = wrapWithFactoryFunctions((0, $2aa064f91d3e3a1e$export$2b77a92f1a5ad772));
    const Popper = wrapWithFactoryFunctions((0, $468edaccd0529729$export$badac9ada3a0bdf9));
    const Spotlight = wrapWithFactoryFunctions((0, $e745bdec4f55f1ed$export$1033c28b5e1c2deb));
    const SpotlightCard = wrapWithFactoryFunctions((0, $faebbb111c596651$export$14710e13fc01d383));
    const InlineDialog = wrapWithToggleFactoryFunctions((0, $cca4986a061dde06$export$c7313f750e9cbc9d));
    // Similar to Popup, PopoverContent uses a union type and so must be wrapped manually.
    const PopoverContent = function() {
        function WrappedPopoverContent(props) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $678769aa0bd77385$export$d7e1f420b25549ff), {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        WrappedPopoverContent.displayName = `ChoreographerFactory(${(0, $678769aa0bd77385$export$d7e1f420b25549ff).displayName})`;
        return WrappedPopoverContent;
    }();
    // Would ideally like to use wrapWithToggleFactoryFunctions here, but the Popup component's props is a union
    // type, and that for some reason causes ToggleableChoreographerUtilities to be passed through to the
    // consumer-exposed Popup component's prop type, which is not what we want, so we'll just wrap it manually here
    const Popup = function() {
        function WrappedPopup(props) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d13ffcfee2ff3666$export$129a32eedafa97c5), {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        WrappedPopup.displayName = `ChoreographerFactory(${(0, $d13ffcfee2ff3666$export$129a32eedafa97c5).displayName})`;
        return WrappedPopup;
    }();
    // Return these items from the factory function for use within React products
    return {
        plugin: plugin,
        useChoreographer: useChoreographer,
        shouldBeChoreographed: shouldBeChoreographed,
        useChoreographedRender: useChoreographedRender,
        withChoreographedRender: withChoreographedRender,
        withChoreographedToggle: withChoreographedToggle,
        AutoDismissFlag: AutoDismissFlag,
        Banner: Banner,
        Flag: Flag,
        InlineDialog: InlineDialog,
        Modal: Modal,
        Popper: Popper,
        Popup: Popup,
        Spotlight: Spotlight,
        SpotlightCard: SpotlightCard,
        PopoverContent: PopoverContent
    };
}
module.exports["choreographerFactory"] = $2bc8c852c894953d$export$55d2aeb17c4cfbe;

});

parcelRegister("fw9LG", function(module, exports) {
const $b14cc3666efa8496$export$d33b097e0a285bc2 = {
    START: 'start',
    STOP: 'stop'
};
const $b14cc3666efa8496$export$f6a9504bc1305cf0 = {
    BLOCKED: 'blocked',
    CANCELED: 'canceled',
    ERROR: 'error',
    STARTED: 'started',
    STOPPED: 'stopped',
    UNREGISTERED: 'unregistered',
    // TEMPORARY: used to track when a transactional message is requested to be choreographed
    // when the choreographer is currently blocked.
    REQUESTED: 'requested'
};
var $b14cc3666efa8496$export$7fb117db98868be6 = /*#__PURE__*/ function(ProductIds) {
    ProductIds["CONFLUENCE"] = "confluence";
    ProductIds["ENGAGEKIT"] = "Engagekit";
    ProductIds["INTERCOM"] = "intercom";
    ProductIds["JIRA"] = "jira";
    ProductIds["PENDO"] = "pendo";
    ProductIds["CLOUDADMIN"] = "cloudadmin";
    ProductIds["BITBUCKET"] = "bitbucket";
    ProductIds["POST_OFFICE"] = "post-office";
    ProductIds["LOOM"] = "loom";
    return ProductIds;
}({});
const $b14cc3666efa8496$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $b14cc3666efa8496$export$dbe9e38c9d6f26d0 = [
    $b14cc3666efa8496$export$94e85cf3348f045a.ENGAGEMENT,
    $b14cc3666efa8496$export$94e85cf3348f045a.MARKETING
];
const $b14cc3666efa8496$export$865c0eaaa43d90f8 = {
    START: 'messageStart',
    STOP: 'messageStop'
};
const $b14cc3666efa8496$export$fc6a8b8cb405f50 = {
    INFO: 'info',
    VERBOSE: 'verbose'
};
module.exports["MessageEventType"] = $b14cc3666efa8496$export$d33b097e0a285bc2;
module.exports["MessageDeliveryStatus"] = $b14cc3666efa8496$export$f6a9504bc1305cf0;
module.exports["ProductIds"] = $b14cc3666efa8496$export$7fb117db98868be6;
module.exports["MessageTypesEnum"] = $b14cc3666efa8496$export$94e85cf3348f045a;
module.exports["IntegratedChoreographerMessageTypesEnum"] = $b14cc3666efa8496$export$dbe9e38c9d6f26d0;
module.exports["MessageAction"] = $b14cc3666efa8496$export$865c0eaaa43d90f8;

});

parcelRegister("aD1SW", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $43a9bd12f06a7115$var$packageName = "platform-pkg";
const $43a9bd12f06a7115$var$packageVersion = "0.0.0-use.local";
const $43a9bd12f06a7115$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const $43a9bd12f06a7115$var$AutoDismissFlag = (props)=>{
    const { id: id, analyticsContext: analyticsContext, onDismissed: onDismissedProp = (0, $ee7An.default) } = props;
    const autoDismissTimer = (0, $42omo.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $6uGcC.useFlagGroup)();
    const onDismissed = (0, $42omo.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $43a9bd12f06a7115$var$packageName,
        packageVersion: $43a9bd12f06a7115$var$packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, $42omo.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, $42omo.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, $42omo.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, $43a9bd12f06a7115$export$66c3d409977b5615 * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed
    ]);
    (0, $42omo.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eCEXz.default), {
        ...props,
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    });
};
var $43a9bd12f06a7115$export$2e2bcd8739ae039 = $43a9bd12f06a7115$var$AutoDismissFlag;
module.exports["default"] = $43a9bd12f06a7115$export$2e2bcd8739ae039;

});

parcelRegister("eCEXz", function(module, exports) {
/* flag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $7hXDW = parcelRequire("7hXDW");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $6F6hl = parcelRequire("6F6hl");

const $f1e025004f98561c$export$d6830277b06edd6 = 'normal';


/* flag-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 


parcelRequire("42omo");





var $4KS7f = parcelRequire("4KS7f");








parcelRequire("42omo");


var $2Agkp = parcelRequire("2Agkp");


var $lVBH4 = parcelRequire("lVBH4");


var $8Y8Qi = parcelRequire("8Y8Qi");


var $5MACL = parcelRequire("5MACL");


var $6fnsQ = parcelRequire("6fnsQ");

const $effc7874d3d3411e$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};
const $effc7874d3d3411e$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #626F86)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #172B4D)"
};
const $effc7874d3d3411e$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Agkp))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`,
        LEGACY_secondaryColor: "var(--ds-background-danger-bold, #C9372C)"
    }),
    info: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lVBH4))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`,
        LEGACY_secondaryColor: "var(--ds-background-neutral-bold, #44546F)"
    }),
    normal: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lVBH4))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-subtle, ${(0, $6fnsQ.N500)})`,
        LEGACY_secondaryColor: "var(--ds-surface-overlay, #FFFFFF)"
    }),
    success: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Y8Qi))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`,
        LEGACY_secondaryColor: "var(--ds-background-success-bold, #1F845A)"
    }),
    warning: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5MACL))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-warning-inverse, ${(0, $6fnsQ.N700)})`,
        LEGACY_secondaryColor: "var(--ds-background-warning-bold, #F5CD47)"
    })
};
const $effc7874d3d3411e$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};
const $effc7874d3d3411e$export$13b42cd9d596bfe0 = {
    error: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
    info: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
    normal: `var(--ds-text, ${(0, $6fnsQ.N800)})`,
    success: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
    warning: `var(--ds-text-warning-inverse, ${(0, $6fnsQ.N700)})`
};
const $effc7874d3d3411e$export$81ba6b63eedb299f = {
    success: {
        default: `var(--ds-background-inverse-subtle, ${(0, $6fnsQ.N30A)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $6fnsQ.N30A)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $6fnsQ.N30A)})`
    },
    info: {
        default: `var(--ds-background-inverse-subtle, ${(0, $6fnsQ.N30A)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $6fnsQ.N30A)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $6fnsQ.N30A)})`
    },
    error: {
        default: `var(--ds-background-inverse-subtle, ${(0, $6fnsQ.N30A)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $6fnsQ.N30A)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $6fnsQ.N30A)})`
    },
    warning: {
        default: `var(--ds-background-inverse-subtle, ${(0, $6fnsQ.N30A)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $6fnsQ.N30A)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $6fnsQ.N30A)})`
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};
const $effc7874d3d3411e$export$7bcfe3cca4dd78b6 = {
    success: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
    info: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
    error: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
    warning: `var(--ds-text-warning-inverse, ${(0, $6fnsQ.N700)})`,
    normal: `var(--ds-link, ${(0, $6fnsQ.B400)})`
};


const $94057a5e7a8c60bb$var$buttonStyles = null;
const $94057a5e7a8c60bb$var$fontStyles = null;
const $94057a5e7a8c60bb$var$appearanceNormalButtonStyles = null;
const $94057a5e7a8c60bb$var$appearanceNormalActionsContainerStyles = null;
const $94057a5e7a8c60bb$var$FlagActions = (props)=>{
    const { appearance: appearance = (0, $f1e025004f98561c$export$d6830277b06edd6), actions: actions = [], linkComponent: linkComponent, testId: testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, $f1e025004f98561c$export$d6830277b06edd6);
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c82smr"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            space: "space.100",
            shouldWrap: true,
            alignBlock: "center",
            separator: isBold ? undefined : "\xb7",
            testId: testId && `${testId}-actions`,
            children: actions.map((action, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4KS7f.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $effc7874d3d3411e$export$7bcfe3cca4dd78b6)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $effc7874d3d3411e$export$81ba6b63eedb299f)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $effc7874d3d3411e$export$81ba6b63eedb299f)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $effc7874d3d3411e$export$81ba6b63eedb299f)[appearance].active
                    },
                    className: (0, $gMc0m.default)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        appearance === (0, $f1e025004f98561c$export$d6830277b06edd6) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index))
        })
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $94057a5e7a8c60bb$export$2e2bcd8739ae039 = $94057a5e7a8c60bb$var$FlagActions;



var $6uGcC = parcelRequire("6uGcC");








var $1qfLF = parcelRequire("1qfLF");


var $lh5eH = parcelRequire("lh5eH");


var $bcA7r = parcelRequire("bcA7r");


var $jNfTW = parcelRequire("jNfTW");


const $5c61e4adb052f9c6$var$DismissButtonComponent = ({ appearance: appearance, onClick: onClick, isBold: isBold, isExpanded: isExpanded, testId: testId })=>{
    let ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($jNfTW)));
    let buttonLabel = 'Dismiss';
    let size = 'small';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($bcA7r))) : (0, (/*@__PURE__*/$parcel$interopDefault($lh5eH)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        size = 'medium';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)(ButtonIcon, {
                ...iconProps,
                LEGACY_size: size,
                size: "small",
                label: "",
                color: (0, $effc7874d3d3411e$export$13b42cd9d596bfe0)[appearance]
            }),
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
const $5c61e4adb052f9c6$var$DismissButton = /*#__PURE__*/ (0, $42omo.memo)($5c61e4adb052f9c6$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5c61e4adb052f9c6$export$2e2bcd8739ae039 = $5c61e4adb052f9c6$var$DismissButton;

/* expander.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $g9Srd = parcelRequire("g9Srd");

var $fT2ta = parcelRequire("fT2ta");






const $9bf4348f0ae69e93$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
const $9bf4348f0ae69e93$var$Expander = ({ children: children, isExpanded: isExpanded, testId: testId })=>{
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $9bf4348f0ae69e93$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && `${testId}-expander`,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
            appear: true,
            children: isExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
                children: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $9bf4348f0ae69e93$var$styles.container,
                        ...props,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                            space: "space.100",
                            children: children
                        })
                    })
            })
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9bf4348f0ae69e93$export$2e2bcd8739ae039 = $9bf4348f0ae69e93$var$Expander;



const $b5a25210448b050f$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkofajl _1reo15vq _18m915vq _v564z97a _16qs1cd0 _1pbyni7l _1bsb1osq"
};
const $b5a25210448b050f$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
const $b5a25210448b050f$var$descriptionStyles = null;
const $b5a25210448b050f$var$iconWrapperStyles = null;
const $b5a25210448b050f$var$flagWrapperStyles = null;
const $b5a25210448b050f$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $b5a25210448b050f$var$transitionStyles = null; /**
                                * __Flag__
                                *
                                * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
                                * often displayed using a flag group.
                                *
                                * - [Examples](https://atlassian.design/components/flag/examples)
                                * - [Code](https://atlassian.design/components/flag/code)
                                * - [Usage](https://atlassian.design/components/flag/usage)
                                */ 
const $b5a25210448b050f$var$Flag = (props)=>{
    const { actions: actions = [], appearance: appearance = (0, $f1e025004f98561c$export$d6830277b06edd6), icon: icon, title: title, description: description, linkComponent: linkComponent, onMouseOver: onMouseOver, onFocus: onFocus = (0, $ee7An.default), onMouseOut: onMouseOut, onBlur: onBlur = (0, $ee7An.default), onDismissed: onDismissedProp = (0, $ee7An.default), testId: testId, id: id, analyticsContext: analyticsContext, delayAnnouncement: delayAnnouncement, headingLevel: headingLevel = 2 } = props;
    const [isDelayToAnnounce, setIsDelayToAnnounce] = (0, $42omo.useState)(false);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $6uGcC.useFlagGroup)();
    const onDismissed = (0, $42omo.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const onDismissedAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        ...$b5a25210448b050f$var$analyticsAttributes
    });
    const isBold = appearance !== (0, $f1e025004f98561c$export$d6830277b06edd6);
    const toggleExpand = (0, $42omo.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, $42omo.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $42omo.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!delayAnnouncement) return;
        setTimeout(()=>{
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    const onFocusAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext,
        ...$b5a25210448b050f$var$analyticsAttributes
    });
    const onBlurAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext,
        ...$b5a25210448b050f$var$analyticsAttributes
    });
    const autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, $effc7874d3d3411e$export$f50075b2584087f)[appearance];
    const iconColor = (0, $effc7874d3d3411e$export$7f70afe2167f8235)[appearance];
    const iconGlyph = (0, $effc7874d3d3411e$export$73f08aee70487cd4)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded; // when delayAnnouncement is available we will use a hidden content for announcement
    const delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $6F6hl.default), {
        children: [
            title,
            description
        ]
    }) : undefined;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "alert",
        "data-testid": testId,
        ...autoDismissProps,
        className: (0, $gMc0m.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            padding: "space.200",
            backgroundColor: (0, $effc7874d3d3411e$export$59e42969c95d314)[appearance],
            xcss: $b5a25210448b050f$var$styles.flag,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                alignBlock: "start",
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    , {
                        style: {
                            [$b5a25210448b050f$var$CSS_VAR_ICON_COLOR]: iconColor
                        },
                        "data-testid": testId && `${testId}-icon-container`,
                        className: (0, $gMc0m.default)([
                            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0"
                        ]),
                        children: icon || iconGlyph
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("span", {
                        className: (0, $gMc0m.default)([
                            "_v5641hdc _16jlkb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            space: shouldRenderGap ? 'space.100' : 'space.0',
                            children: [
                                isDelayToAnnounce && delayedAnnouncement,
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                    alignBlock: "stretch",
                                    space: "space.100",
                                    spread: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            paddingBlockStart: "space.050",
                                            paddingBlockEnd: "space.025",
                                            xcss: $b5a25210448b050f$var$styles.overflowWrap,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                                                as: `h${headingLevel}`,
                                                size: "xsmall",
                                                color: textColor,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                                                    /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                                    children: title
                                                })
                                            })
                                        }),
                                        isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ (0, $l998X.jsx)((0, $5c61e4adb052f9c6$export$2e2bcd8739ae039), {
                                            testId: testId,
                                            appearance: appearance,
                                            isBold: isBold,
                                            isExpanded: isExpanded,
                                            onClick: isBold ? toggleExpand : buttonActionCallback
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $9bf4348f0ae69e93$export$2e2bcd8739ae039), {
                                    isExpanded: !isBold || isExpanded,
                                    testId: testId,
                                    children: [
                                        description && /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        , {
                                            style: {
                                                color: (0, $effc7874d3d3411e$export$13b42cd9d596bfe0)[appearance]
                                            },
                                            "data-testid": testId && `${testId}-description`,
                                            "aria-hidden": isDelayToAnnounce,
                                            className: (0, $gMc0m.default)([
                                                "_11c82smr _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
                                            ]),
                                            children: description
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $94057a5e7a8c60bb$export$2e2bcd8739ae039), {
                                            actions: actions,
                                            appearance: appearance,
                                            linkComponent: linkComponent,
                                            testId: testId
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $b5a25210448b050f$export$2e2bcd8739ae039 = $b5a25210448b050f$var$Flag;
module.exports["default"] = $b5a25210448b050f$export$2e2bcd8739ae039;

});

parcelRegister("6uGcC", function(module, exports) {
/* flag-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $ee7An = parcelRequire("ee7An");


var $g9Srd = parcelRequire("g9Srd");

var $h3cbw = parcelRequire("h3cbw");


var $caX7N = parcelRequire("caX7N");


var $dTk3A = parcelRequire("dTk3A");


var $6F6hl = parcelRequire("6F6hl");

const $b67362102deb1f23$export$1eee5ddc4f6d41c5 = 400;
const $b67362102deb1f23$var$defaultFlagGroupContext = {
    onDismissed: (0, $ee7An.default),
    isDismissAllowed: false
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $b67362102deb1f23$export$c57ba665aaa722be = /*#__PURE__*/ (0, $42omo.createContext)($b67362102deb1f23$var$defaultFlagGroupContext); // eslint-disable-next-line @repo/internal/react/require-jsdoc
function $b67362102deb1f23$export$e91ea202abb66350() {
    return (0, $42omo.useContext)($b67362102deb1f23$export$c57ba665aaa722be);
} // transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $b67362102deb1f23$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
}; // Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const $b67362102deb1f23$var$dismissAllowedStyles = null;
const $b67362102deb1f23$var$flagGroupContainerStyles = null; /**
                                        * __Flag group__
                                        *
                                        * A flag group is used to group a set of related flags, with entry and exit animations.
                                        *
                                        * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
                                        * - [Code](https://atlassian.design/components/flag/flag-group/code)
                                        */ 
const $b67362102deb1f23$var$FlagGroup = (props)=>{
    const { id: id, label: label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent: shouldRenderToParent = false, children: children, onDismissed: onDismissed = (0, $ee7An.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const dismissFlagContext = (0, $42omo.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, $42omo.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $h3cbw.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in",
                children: ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    , {
                        className: (0, $gMc0m.default)([
                            $b67362102deb1f23$var$groupStyles.root,
                            index === 0 && $b67362102deb1f23$var$groupStyles.first,
                            index === 1 && $b67362102deb1f23$var$groupStyles.second,
                            index >= 1 && $b67362102deb1f23$var$groupStyles.nth,
                            index >= 2 && $b67362102deb1f23$var$groupStyles.hidden,
                            isDismissAllowed && "_12a7luct",
                            className
                        ]),
                        ref: ref,
                        "data-vc-oob": true,
                        children: /*#__PURE__*/ (0, $l998X.jsx)($b67362102deb1f23$export$c57ba665aaa722be.Provider, {
                            value: // Only the first flag should be able to be dismissed.
                            isDismissAllowed ? dismissFlagContext : $b67362102deb1f23$var$defaultFlagGroupContext,
                            children: flag
                        })
                    })
            });
        }) : false;
    };
    const flags = /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, $gMc0m.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ]),
        children: [
            hasFlags ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)(LabelTag, {
                    children: label
                })
            }) : null,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
                appear: false,
                children: renderChildren()
            })
        ]
    });
    return shouldRenderToParent ? flags : /*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
        zIndex: (0, $dTk3A.layers).flag(),
        children: flags
    });
};
var $b67362102deb1f23$export$2e2bcd8739ae039 = $b67362102deb1f23$var$FlagGroup;
module.exports["useFlagGroup"] = $b67362102deb1f23$export$e91ea202abb66350;
module.exports["default"] = $b67362102deb1f23$export$2e2bcd8739ae039;

});

parcelRegister("h3cbw", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gZTYb = parcelRequire("gZTYb");

/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ const $8e228db1926f0e35$var$SlideIn = ({ children: children, enterFrom: enterFrom, exitTo: exitTo, duration: duration = 'medium', isPaused: isPaused, onFinish: onFinish, animationTimingFunction: animationTimingFunction = 'ease-out', animationTimingFunctionExiting: animationTimingFunctionExiting = 'ease-in' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gZTYb.default), {
        duration: duration,
        enteringAnimation: `slide-in-from-${enterFrom}`,
        exitingAnimation: `slide-out-from-${exitTo || enterFrom}`,
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish,
        children: children
    });
};
var $8e228db1926f0e35$export$2e2bcd8739ae039 = $8e228db1926f0e35$var$SlideIn;
module.exports["default"] = $8e228db1926f0e35$export$2e2bcd8739ae039;

});

parcelRegister("15EjN", function(module, exports) {
/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

const $ae6f75ae0a49f00d$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
const $ae6f75ae0a49f00d$var$inlineStyles = {
    root: "_1ul9idpf"
};
const $ae6f75ae0a49f00d$var$textStyles = {
    root: "_11c82smr _1reo15vq _18m915vq _syaz12s4 _k48p1wq8 _1bto1l2s _o5721q9c _59381r31 _7hxb1r31 _9m7f1r31 _rfqo1r31 _qfs11r31 _yha28stv _15zv8stv _w7sw8stv _1bgk8stv _s41o8stv _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _43ds1r31 _p03c1r31 _oavv1r31 _oxk41r31 _1cay1r31"
};
const $ae6f75ae0a49f00d$var$backgroundColors = {
    warning: 'color.background.warning.bold',
    error: 'color.background.danger.bold',
    announcement: 'color.background.neutral.bold'
};
const $ae6f75ae0a49f00d$var$tokenBackgroundColors = {
    warning: "var(--ds-background-warning-bold, #F5CD47)",
    error: "var(--ds-background-danger-bold, #C9372C)",
    announcement: "var(--ds-background-neutral-bold, #44546F)"
};
const $ae6f75ae0a49f00d$var$tokenTextColors = {
    warning: "var(--ds-text-warning-inverse, #172B4D)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    announcement: "var(--ds-text-inverse, #FFFFFF)"
};
const $ae6f75ae0a49f00d$var$containerStyles = {
    root: "_4t3i1wto _4cvr1h6o _1e0c1txw"
};
const $ae6f75ae0a49f00d$var$iconWrapperStyles = {
    root: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1k8s _4t3i1k8s _1o9zidpf"
};
const $ae6f75ae0a49f00d$var$Banner = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance = 'warning', children: children, icon: icon, testId: testId }, ref)=>{
    const appearanceType = appearance in $ae6f75ae0a49f00d$var$backgroundColors ? appearance : 'warning';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $ae6f75ae0a49f00d$var$containerStyles.root,
        backgroundColor: $ae6f75ae0a49f00d$var$backgroundColors[appearanceType],
        padding: "space.150",
        testId: testId,
        ref: ref,
        role: "alert",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "start",
            xcss: $ae6f75ae0a49f00d$var$inlineStyles.root,
            children: [
                icon ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $ae6f75ae0a49f00d$var$iconWrapperStyles.root,
                    style: {
                        fill: $ae6f75ae0a49f00d$var$tokenBackgroundColors[appearanceType],
                        color: $ae6f75ae0a49f00d$var$tokenTextColors[appearanceType]
                    },
                    children: icon
                }) : null,
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    style: {
                        [$ae6f75ae0a49f00d$var$CSS_VAR_TEXT_COLOR]: $ae6f75ae0a49f00d$var$tokenTextColors[appearanceType]
                    },
                    className: (0, $gMc0m.default)([
                        $ae6f75ae0a49f00d$var$textStyles.root
                    ]),
                    children: children
                })
            ]
        })
    });
});
var $ae6f75ae0a49f00d$export$2e2bcd8739ae039 = $ae6f75ae0a49f00d$var$Banner;
module.exports["default"] = $ae6f75ae0a49f00d$export$2e2bcd8739ae039;

});

parcelRegister("hPd3F", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $iug2J = parcelRequire("iug2J");

var $16xFS = parcelRequire("16xFS");


var $2xusd = parcelRequire("2xusd");

var $lqsSp = parcelRequire("lqsSp");

var $cs0ez = parcelRequire("cs0ez");

/* container.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");

const $d578f7e8fcdfb2c7$var$CSS_THEME_BACKGROUND = '--theme-background';
const $d578f7e8fcdfb2c7$var$CSS_THEME_COLOR = '--theme-color';
const $d578f7e8fcdfb2c7$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
const $d578f7e8fcdfb2c7$var$containerStyles = null;
const $d578f7e8fcdfb2c7$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        style: {
            [$d578f7e8fcdfb2c7$var$CSS_THEME_BACKGROUND]: "var(--ds-surface-overlay, #FFFFFF)",
            [$d578f7e8fcdfb2c7$var$CSS_THEME_COLOR]: "var(--ds-text, #172B4D)",
            [$d578f7e8fcdfb2c7$var$CSS_THEME_BOX_SHADOW]: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
            ...style
        },
        className: (0, $gMc0m.default)([
            "_11q7gluh _2rkofajl _vchh1ntv _p12flti4 _c71llti4 _1pbyowjs _16qs1r44 _syazjslb _85i5pxbi _1q51pxbi _y4ti1ejb _bozg1ejb _nt751r31 _49pcglyw _1hvw1o36"
        ]),
        children: typeof children === 'function' ? children() : children
    });
});


const $9c1ccf76fa34aae8$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $9c1ccf76fa34aae8$var$checkIsChildOfPortal(node.parentElement);
};
// Close manager for layering
const $9c1ccf76fa34aae8$var$CloseManager = ({ handleEscapeClose: handleEscapeClose, handleClick: handleClick })=>{
    (0, $16xFS.useCloseOnEscapePress)({
        onClose: handleEscapeClose
    });
    const { isLayerDisabled: isLayerDisabled } = (0, $16xFS.useLayering)();
    (0, $42omo.useEffect)(()=>{
        return (0, $fFa3V.bind)(window, {
            type: 'click',
            listener: (e)=>{
                if (isLayerDisabled()) return;
                handleClick(e);
            },
            options: {
                capture: true
            }
        });
    }, [
        handleClick,
        isLayerDisabled
    ]);
    // only create a dummy component for using ths hook in class component
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {});
};
const $9c1ccf76fa34aae8$var$InlineDialog = /*#__PURE__*/ (0, $42omo.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $ee7An.default), onContentClick: onContentClick = (0, $ee7An.default), onContentFocus: onContentFocus = (0, $ee7An.default), onClose: providedOnClose = (0, $ee7An.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children, fallbackPlacements: fallbackPlacements }) {
    const containerRef = (0, $42omo.useRef)(null);
    const triggerRef = (0, $42omo.useRef)(null);
    const onClose = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>providedOnClose(event),
        action: 'closed',
        componentName: 'inlineDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $42omo.useRef)(onClose);
    (0, $42omo.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $42omo.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isOpen) {
            onCloseRef.current?.({
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($9c1ccf76fa34aae8$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
            isOpen: false,
            event: event
        });
    }, [
        isOpen
    ]);
    const handleClick = (0, $42omo.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        if (containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        containerRef,
        triggerRef
    ]);
    /**
   * Auto-flip is enabled by default in `@atlaskit/popper` and
   * the `InlineDialog` API does not allow disabling it.
   *
   * We only need to override it if there are `fallbackPlacements` specified.
   */ const modifiers = (0, $42omo.useMemo)(()=>fallbackPlacements ? [
            {
                name: 'flip',
                options: {
                    fallbackPlacements: fallbackPlacements
                }
            }
        ] : [], [
        fallbackPlacements
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lqsSp.Popper), {
        placement: placement,
        strategy: strategy,
        modifiers: modifiers,
        children: ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $d578f7e8fcdfb2c7$export$42a852a2b6b56249), {
                onBlur: onContentBlur,
                onFocus: onContentFocus,
                onClick: onContentClick,
                ref: (node)=>{
                    if (node) {
                        containerRef.current = node;
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                    }
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                testId: testId,
                children: typeof content === 'function' ? content() : content
            })
    }) : null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2xusd.Manager), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cs0ez.Reference), {
                children: ({ ref: ref })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                        ref: (node)=>{
                            // Resolve to the first element child of the div in `children`
                            const firstElementChild = node?.firstElementChild || null;
                            triggerRef.current = firstElementChild;
                            if (typeof ref === 'function') ref(firstElementChild);
                            else ref.current = firstElementChild;
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                            children: children
                        })
                    })
            }),
            isOpen ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $iug2J.Layering), {
                isDisabled: false,
                children: [
                    popper,
                    /*#__PURE__*/ (0, $l998X.jsx)($9c1ccf76fa34aae8$var$CloseManager, {
                        handleEscapeClose: handleCloseRequest,
                        handleClick: handleClick
                    })
                ]
            }) : popper
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9c1ccf76fa34aae8$export$2e2bcd8739ae039 = $9c1ccf76fa34aae8$var$InlineDialog;
module.exports["default"] = $9c1ccf76fa34aae8$export$2e2bcd8739ae039;

});

parcelRegister("iug2J", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

class $63cc470c807fbe2f$export$da4f61fd78d35243 {
    addChild(node) {
        this.childNodes.push(node);
    }
    removeChild(node) {
        this.childNodes = this.childNodes.filter((child)=>child.id !== node.id);
    }
    getLevel() {
        if (!this.parent) return 1;
        return this.parent.getLevel() + 1;
    }
    getHeight() {
        if (this.childNodes.length === 0) return 1;
        return Math.max(...this.childNodes.map((child)=>child.getHeight())) + 1;
    }
    constructor(id, parent){
        this.id = void 0;
        this.childNodes = void 0;
        this.parent = void 0;
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
}


const $eabb819e9bea5c4b$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $42omo.createContext)(0);
const $eabb819e9bea5c4b$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $42omo.createContext)({
    current: null
});
const $eabb819e9bea5c4b$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $42omo.createContext)({
    current: null
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ const $eabb819e9bea5c4b$var$LevelProvider = ({ children: children, currentLevel: currentLevel, node: levelNode })=>{
    (0, $42omo.useEffect)(()=>{
        const levelNodeSafe = levelNode.current;
        const parentNode = levelNodeSafe.parent;
        parentNode?.addChild(levelNodeSafe);
        return ()=>{
            parentNode?.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($eabb819e9bea5c4b$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel,
        children: /*#__PURE__*/ (0, $l998X.jsx)($eabb819e9bea5c4b$export$18f4d8b5b3a77f59.Provider, {
            value: levelNode,
            children: children
        })
    });
};
const $eabb819e9bea5c4b$export$7c885f891c940977 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $42omo.useContext)($eabb819e9bea5c4b$export$650d12d3c2ddb8fc);
    const parentNode = (0, $42omo.useContext)($eabb819e9bea5c4b$export$18f4d8b5b3a77f59);
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const newNode = (0, $42omo.useRef)(new (0, $63cc470c807fbe2f$export$da4f61fd78d35243)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, $l998X.jsx)($eabb819e9bea5c4b$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode,
        children: children
    });
    return isNested ? content : /*#__PURE__*/ (0, $l998X.jsx)($eabb819e9bea5c4b$export$fa973f110e8f6ca8.Provider, {
        value: newNode,
        children: content
    });
};
module.exports["LevelContext"] = $eabb819e9bea5c4b$export$650d12d3c2ddb8fc;
module.exports["LevelNodeContext"] = $eabb819e9bea5c4b$export$18f4d8b5b3a77f59;
module.exports["RootNodeContext"] = $eabb819e9bea5c4b$export$fa973f110e8f6ca8;
module.exports["Layering"] = $eabb819e9bea5c4b$export$7c885f891c940977;

});

parcelRegister("16xFS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $iug2J = parcelRequire("iug2J");

const $abe89ff2765d17a5$var$ESCAPE = 'Escape';
function $abe89ff2765d17a5$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $42omo.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = $abe89ff2765d17a5$export$c8b4d54e03dee6ed();
    const onKeyDown = (0, $42omo.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $abe89ff2765d17a5$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $42omo.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $42omo.useEffect)(()=>{
        return (0, $fFa3V.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $abe89ff2765d17a5$export$c8b4d54e03dee6ed() {
    const currentLevel = (0, $42omo.useContext)((0, $iug2J.LevelContext));
    const layerNode = (0, $42omo.useContext)((0, $iug2J.LevelNodeContext));
    const rootNode = (0, $42omo.useContext)((0, $iug2J.RootNodeContext));
    const isLayerDisabled = (0, $42omo.useCallback)(()=>{
        // This is an impossible case, added for type safety
        if (!layerNode?.current || !rootNode?.current) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    const getTopLevel = (0, $42omo.useCallback)(()=>rootNode?.current ? rootNode.current.getHeight() : null, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}
module.exports["useCloseOnEscapePress"] = $abe89ff2765d17a5$export$4a4bf067ea9e7886;
module.exports["useLayering"] = $abe89ff2765d17a5$export$c8b4d54e03dee6ed;

});

parcelRegister("cs0ez", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $211OA = parcelRequire("211OA");


var $2xusd = parcelRequire("2xusd");


var $dhTbP = parcelRequire("dhTbP");

function $91084804ab7f7e7c$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $42omo.useContext((0, $2xusd.ManagerReferenceNodeSetterContext));
    var refHandler = $42omo.useCallback(function(node) {
        (0, $dhTbP.setRef)(innerRef, node);
        (0, $dhTbP.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $42omo.useEffect(function() {
        return function() {
            return (0, $dhTbP.setRef)(innerRef, null);
        };
    }, []);
    $42omo.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($211OA)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $dhTbP.unwrapArray)(children)({
        ref: refHandler
    });
}
module.exports["Reference"] = $91084804ab7f7e7c$export$e0be378c32fb70a7;

});

parcelRegister("211OA", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $177d152a7c98dda4$var$__DEV__ = false;
var $177d152a7c98dda4$var$warning = function() {};
if ($177d152a7c98dda4$var$__DEV__) {
    var $177d152a7c98dda4$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $177d152a7c98dda4$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $177d152a7c98dda4$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $177d152a7c98dda4$var$warning;

});

parcelRegister("bqAtB", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3654r = parcelRequire("3654r");


var $lqsSp = parcelRequire("lqsSp");


var $2MPqq = parcelRequire("2MPqq");





var $fFa3V = parcelRequire("fFa3V");


var $hTKp4 = parcelRequire("hTKp4");

const $856ac0d01785f9f7$export$420e68273165f4ec = (ref)=>{
    const [active, setActive] = (0, $42omo.useState)(null);
    const updateFocusedElement = (0, $42omo.useCallback)(()=>{
        const doc = (0, $hTKp4.getDocument)();
        const activeElement = doc?.activeElement || null;
        if (!ref || !ref.current) {
            setActive(null);
            return;
        }
        if (!activeElement) {
            setActive(null);
            return;
        }
        // Check if the focused element is within the ref element
        if (!ref.current.contains(activeElement)) {
            setActive(null);
            return;
        }
        setActive(activeElement);
    }, [
        ref
    ]);
    (0, $42omo.useEffect)(()=>{
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) return;
        updateFocusedElement();
        const unbindFocusIn = (0, $fFa3V.bind)(doc, {
            type: 'focusin',
            listener: updateFocusedElement
        });
        return ()=>{
            unbindFocusIn();
        };
    }, [
        updateFocusedElement
    ]);
    return active;
};














const $4771a1d592488f6b$export$9afc64c180e82dc4 = (onClickOutside)=>{
    const { card: card } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const ref = card.ref;
    (0, $42omo.useEffect)(()=>{
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) return;
        const unbindMouseUp = (0, $fFa3V.bind)(doc, {
            type: 'mouseup',
            listener: (event)=>{
                if (!ref || !ref.current) return;
                const target = event.target instanceof Node ? event.target : null;
                if (ref.current.contains(target)) return;
                onClickOutside(event);
            }
        });
        return ()=>{
            unbindMouseUp();
        };
    }, [
        onClickOutside,
        ref
    ]);
};











const $196a96515413bb69$var$onKeyDown = (event, { onEscape: onEscape })=>{
    switch(event.key){
        case 'Escape':
            onEscape();
            break;
        default:
            break;
    }
};
const $196a96515413bb69$export$795d56022f0285ed = (onEscape)=>{
    (0, $42omo.useEffect)(()=>{
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) return;
        const unbindFocusIn = (0, $fFa3V.bind)(doc, {
            type: 'keydown',
            listener: (event)=>$196a96515413bb69$var$onKeyDown(event, {
                    onEscape: ()=>onEscape(event)
                })
        });
        return ()=>{
            unbindFocusIn();
        };
    }, [
        onEscape
    ]);
};


const $45fed98be6e0091d$var$styles = {
    root: "_1pby1fw0"
}; /**
    * Taken from `@atlaskit/popper`
    */ 
const $45fed98be6e0091d$var$defaultOffset = [
    0,
    2
];
/**
 * The Spotlight card can be positioned in many different configurations, but the caret should always point to
 * the center of the target element. `@atlaskit/popper` uses `'top' | 'right' | 'bottom' | 'left'` values for
 * this center alignment along the respective face. So we translate between the Spotlight position, and the
 * Popper position using this map.
 */ const $45fed98be6e0091d$var$popperPlacementMap = {
    'top-start': 'top',
    'top-center': 'top',
    'top-end': 'top',
    'bottom-start': 'bottom',
    'bottom-center': 'bottom',
    'bottom-end': 'bottom',
    'right-start': 'right',
    'right-end': 'right',
    'left-start': 'left',
    'left-end': 'left'
}; /**
    * __PopoverContent__
    *
    * A `PopoverContent` is the element that is shown as a popover.
    */ 
const $45fed98be6e0091d$export$d7e1f420b25549ff = (props)=>{
    const { children: children, placement: placement, isVisible: isVisible = true, shouldDismissOnClickOutside: shouldDismissOnClickOutside = true, dismiss: dismiss, back: back, testId: testId, offset: offset = $45fed98be6e0091d$var$defaultOffset } = props; /**
              * A user should only be able to pass a `done` or a `next`. Not both.
              * The type is set up as a discriminant union. So, we need a typeguard
              * here to destructure it properly.
              */ 
    const done = 'done' in props ? props.done : undefined;
    const next = 'next' in props ? props.next : undefined;
    const updateRef = (0, $42omo.useRef)(()=>new Promise(()=>undefined));
    const ref = (0, $42omo.useRef)();
    const { heading: heading, popoverContent: popoverContent, card: card, primaryAction: primaryAction, secondaryAction: secondaryAction } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const focusWithin = (0, $856ac0d01785f9f7$export$420e68273165f4ec)(popoverContent.ref);
    (0, $42omo.useEffect)(()=>{
        popoverContent.setRef(ref);
    }, [
        ref,
        popoverContent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!done && !next) return;
        if (done) {
            primaryAction.setAction(done);
            return;
        } else if (next) {
            primaryAction.setAction(next);
            return;
        }
    }, [
        done,
        next,
        primaryAction
    ]);
    (0, $42omo.useEffect)(()=>{
        popoverContent.setDismiss(dismiss);
    }, [
        dismiss,
        popoverContent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!back) return;
        secondaryAction.setAction(back);
    }, [
        back,
        secondaryAction
    ]);
    (0, $42omo.useEffect)(()=>{
        card.setPlacement(placement);
    }, [
        placement,
        card
    ]);
    (0, $42omo.useEffect)(()=>{
        if (updateRef.current) popoverContent.setUpdate(()=>updateRef.current);
    }, [
        popoverContent
    ]);
    (0, $196a96515413bb69$export$795d56022f0285ed)((event)=>{
        if (!focusWithin) return;
        popoverContent.dismiss.current(event);
    });
    (0, $4771a1d592488f6b$export$9afc64c180e82dc4)((event)=>{
        if (!shouldDismissOnClickOutside) return;
        popoverContent.dismiss.current(event);
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lqsSp.Popper), {
        offset: offset,
        placement: $45fed98be6e0091d$var$popperPlacementMap[placement],
        children: ({ ref: localRef, style: style, update: update })=>{
            if (!isVisible) return;
            updateRef.current = update;
            return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                role: "dialog",
                "data-testid": testId,
                "aria-labelledby": heading.id,
                ref: (0, $3654r.default)([
                    ref,
                    localRef
                ]),
                style: style,
                className: (0, $gMc0m.default)([
                    $45fed98be6e0091d$var$styles.root
                ]),
                children: children
            });
        }
    });
};
module.exports["PopoverContent"] = $45fed98be6e0091d$export$d7e1f420b25549ff;

});

parcelRegister("2MPqq", function(module, exports) {
/* context.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $f8a24c6682aa0c4a$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $42omo.createContext)({
    card: {
        ref: null,
        setRef: ()=>undefined,
        placement: 'bottom-end',
        setPlacement: ()=>undefined
    },
    heading: {
        id: '',
        setId: ()=>undefined
    },
    popoverContent: {
        ref: undefined,
        setRef: ()=>undefined,
        update: ()=>()=>new Promise(()=>null),
        setUpdate: ()=>()=>new Promise(()=>null),
        dismiss: {
            current: ()=>undefined
        },
        setDismiss: ()=>undefined
    },
    primaryAction: {
        action: {
            current: ()=>undefined
        },
        setAction: ()=>undefined
    },
    secondaryAction: {
        action: {
            current: ()=>undefined
        },
        setAction: ()=>undefined
    }
});
const $f8a24c6682aa0c4a$export$ad26233dae620a42 = ({ children: children })=>{
    const id = (0, $42omo.useId)();
    const [placement, setPlacement] = (0, $42omo.useState)('bottom-end');
    const [headingId, setHeadingId] = (0, $42omo.useState)(`${id}-heading`);
    const [update, setUpdate] = (0, $42omo.useState)(()=>async ()=>undefined);
    const [popoverRef, setPopoverRef] = (0, $42omo.useState)();
    const [cardRef, setCardRef] = (0, $42omo.useState)(null);
    const dismissRef = (0, $42omo.useRef)(()=>undefined);
    const setDismiss = (dismissFn)=>{
        dismissRef.current = dismissFn;
    };
    const secondaryActionRef = (0, $42omo.useRef)(()=>undefined);
    const setSecondaryAction = (actionFn)=>{
        secondaryActionRef.current = actionFn;
    };
    const primaryActionRef = (0, $42omo.useRef)(()=>undefined);
    const setPrimaryAction = (actionFn)=>{
        primaryActionRef.current = actionFn;
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($f8a24c6682aa0c4a$export$7b5aa0f5b37a336d.Provider, {
        value: {
            card: {
                ref: cardRef,
                setRef: setCardRef,
                placement: placement,
                setPlacement: setPlacement
            },
            heading: {
                id: headingId,
                setId: setHeadingId
            },
            popoverContent: {
                ref: popoverRef,
                setRef: setPopoverRef,
                update: update,
                setUpdate: setUpdate,
                dismiss: dismissRef,
                setDismiss: setDismiss
            },
            primaryAction: {
                action: primaryActionRef,
                setAction: setPrimaryAction
            },
            secondaryAction: {
                action: secondaryActionRef,
                setAction: setSecondaryAction
            }
        },
        children: children
    });
};
module.exports["SpotlightContext"] = $f8a24c6682aa0c4a$export$7b5aa0f5b37a336d;
module.exports["SpotlightContextProvider"] = $f8a24c6682aa0c4a$export$ad26233dae620a42;

});

parcelRegister("lGgRw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e30c70ca2cd01247$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Popup", () => (parcelRequire("2mqmH")).Popup);

var $2mqmH = parcelRequire("2mqmH");

var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e30c70ca2cd01247$export$2e2bcd8739ae039 = (0, $2mqmH.Popup);

});

parcelRegister("2cdko", function(module, exports) {
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $16xFS = parcelRequire("16xFS");


var $dh538 = parcelRequire("dh538");


var $lqsSp = parcelRequire("lqsSp");







const $358e604dbfb8af77$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $42omo.useRef)(true);
    (0, $42omo.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: children
    });
};






var $fFa3V = parcelRequire("fFa3V");


var $ee7An = parcelRequire("ee7An");







const $55ef7559dd2f6324$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
const $55ef7559dd2f6324$export$3dee5e4542c672d9 = (element)=>{
    if ($55ef7559dd2f6324$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};





const $bfd399335701df88$export$641fa9c94086b46e = ()=>{
    const animationsRef = (0, $42omo.useRef)([]);
    const requestFrame = (0, $42omo.useCallback)((callback)=>{
        const id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    const cancelFrame = (0, $42omo.useCallback)((id)=>{
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
    }, []);
    const cancelAllFrames = (0, $42omo.useCallback)(()=>{
        animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};


const $b6349930617ff547$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $bfd399335701df88$export$641fa9c94086b46e)();
    const mouseDownTarget = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (!isOpen || !popupRef) return 0, $ee7An.default;
        const inIframe = window && window.self !== window.top && (0, $dh538.fg)('fix-dropdown-close-outside-iframe');
        const closePopup = (event)=>{
            if (onClose) {
                let currentLevel = null;
                if (event.target instanceof HTMLElement) currentLevel = event.target.closest(`[data-ds--level]`)?.getAttribute('data-ds--level') ?? null;
                currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $dh538.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(()=>{
                triggerRef?.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        const onClick = (event)=>{
            const { target: target } = event;
            const doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    const layeredElement = target.closest?.(`[data-ds--level]`);
                    if (layeredElement) {
                        const closeType = layeredElement.getAttribute('[data-ds--close--type]');
                        if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        const levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            const didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $55ef7559dd2f6324$export$3dee5e4542c672d9)(document.activeElement) && (0, $dh538.fg)('platform_dst_popup-disable-focuslock')) triggerRef?.focus();
            }
        };
        const onMouseDown = (event)=>{
            /**
			 * Tracking the target of the mouse down event.
			 * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
			 * moves the mouse outside the popup before releasing the mouse button.
			 *
			 * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
			 * so they try to cancel their click by moving their mouse away from what they had moused down on.
			 *
			 * Blanket uses the same technique.
			 */ mouseDownTarget.current = event.target;
        };
        const onKeyDown = (event)=>{
            if ((0, $dh538.fg)('platform_dst_popup-disable-focuslock')) {
                const { key: key, shiftKey: shiftKey } = event;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(()=>{
                        const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef?.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && document.activeElement?.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(()=>{
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                const { key: key } = event;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        let parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $fFa3V.bind)(window.parent.window, {
            type: 'click',
            listener: onClick,
            options: {
                capture: capture
            }
        });
        let unbind = (0, $ee7An.default);
        if ((0, $dh538.fg)('popup-onclose-fix')) setTimeout(()=>{
            unbind = (0, $fFa3V.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $fFa3V.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        let unbindBlur = (0, $ee7An.default);
        unbindBlur = (0, $fFa3V.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return ()=>{
            if ((0, $dh538.fg)('popup-onclose-fix')) setTimeout(()=>{
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            parentUnbind?.();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};






var $iqsGx = parcelRequire("iqsGx");











const $f5b63653351b33e7$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $bfd399335701df88$export$641fa9c94086b46e)();
    const { currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    (0, $42omo.useEffect)(()=>{
        if (!popupRef || shouldCloseOnTab) return 0, $ee7An.default;
        if (shouldDisableFocusTrap && (0, $dh538.fg)('platform_dst_popup-disable-focuslock')) {
            const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(()=>{
                    triggerRef?.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $ee7An.default;
            }
        }
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($iqsGx)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(()=>{
            focusTrap.activate();
        });
        return ()=>{
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};


const $f664ccea70fe7a55$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $f664ccea70fe7a55$var$fullWidthStyles = null;
const $f664ccea70fe7a55$var$wrapperStyles = {
    root: "_2rko12b0 _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs1cd0 _syaz1fxt _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36"
};
const $f664ccea70fe7a55$var$scrollableStyles = null;
const $f664ccea70fe7a55$var$blanketStyles = null;
const $f664ccea70fe7a55$var$modalStyles = null;
const $f664ccea70fe7a55$var$focusRingStyles = {
    root: "_mizu1p6i _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
const $f664ccea70fe7a55$var$DefaultPopupComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, className: className, isReferenceHidden: isReferenceHidden, ...htmlAttributes } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            $f664ccea70fe7a55$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            !shouldRenderToParent && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ]),
        ...htmlAttributes,
        ref: ref,
        children: children
    });
});
function $f664ccea70fe7a55$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
popupComponent: PopupContainer = $f664ccea70fe7a55$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default' }) {
    const [popupRef, setPopupRef] = (0, $42omo.useState)(null);
    const [initialFocusRef, setInitialFocusRef] = (0, $42omo.useState)(null); // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    const shouldDisableFocusTrap = role !== 'dialog';
    (0, $f5b63653351b33e7$export$10c5169755ce7bd7)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $b6349930617ff547$export$92dae2778ae88f9d)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    const { currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    const mergedModifiers = (0, $42omo.useMemo)(()=>[
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            },
            ...modifiers || []
        ], [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lqsSp.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        children: ({ ref: ref, style: style, placement: placement, update: update, isReferenceHidden: isReferenceHidden })=>{
            const popupContainer = /*#__PURE__*/ (0, $l998X.jsx)(PopupContainer // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    xcss,
                    // @ts-expect-error: `ax` is not typed correctly
                    !initialFocusRef && (0, $dh538.fg)('platform-design-system-apply-popup-wrapper-focus') && $f664ccea70fe7a55$var$focusRingStyles.root
                ]),
                appearance: appearance,
                id: id,
                "data-ds--level": currentLevel,
                "data-placement": placement,
                "data-testid": testId,
                role: role,
                "aria-label": label,
                "aria-labelledby": titleId,
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
                // first on the browser address bar when using keyboard
                tabIndex: autoFocus ? 0 : undefined,
                shouldRenderToParent: shouldRenderToParent,
                shouldFitContainer: shouldFitContainer,
                isReferenceHidden: isReferenceHidden,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $358e604dbfb8af77$export$51eddd7655ca235a), {
                    update: update,
                    children: content({
                        update: update,
                        isOpen: isOpen,
                        onClose: onClose,
                        setInitialFocusRef: setInitialFocusRef
                    })
                })
            });
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                children: [
                    popupContainer,
                    appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            "_1r04idpf _kqsw1n9t _bfhk10xm"
                        ])
                    })
                ]
            });
        }
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f664ccea70fe7a55$export$2e2bcd8739ae039 = $f664ccea70fe7a55$var$PopperWrapper;
module.exports["default"] = $f664ccea70fe7a55$export$2e2bcd8739ae039;

});

parcelRegister("fiAWX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2hNw6 = parcelRequire("2hNw6");

function $84f8030b6f5953d1$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
    const mq = (0, $2hNw6.UNSAFE_useMediaQuery)('below.sm', (e)=>{
        setIsSmallViewport(!!e.matches);
    });
    const [isSmallViewport, setIsSmallViewport] = (0, $42omo.useState)(!!mq?.matches);
    const appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}
module.exports["usePopupAppearance"] = $84f8030b6f5953d1$export$4065aef1d79a5730;

});

parcelRegister("9Ghf3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");

const $17aa3267309602ff$export$7cc5c058dd769dff = ()=>{
    const [getMemoizedMergedTriggerRef] = (0, $42omo.useState)(()=>(0, $2XqLN.default)((ref, setTriggerRef, isOpen)=>{
            return (node)=>{
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRef;
};
module.exports["useGetMemoizedMergedTriggerRef"] = $17aa3267309602ff$export$7cc5c058dd769dff;

});

parcelRegister("advfQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");

const $eb7a244451737e86$export$5d3a2de79e07b376 = ()=>{
    const [getMemoizedMergedTriggerRefNew] = (0, $42omo.useState)(()=>(0, $2XqLN.default)((ref, setTriggerRef)=>{
            return (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRefNew;
};
module.exports["useGetMemoizedMergedTriggerRefNew"] = $eb7a244451737e86$export$5d3a2de79e07b376;

});

parcelRegister("5RBJ9", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");





var $42omo = parcelRequire("42omo");


var $5dBQh = parcelRequire("5dBQh");


var $crya1 = parcelRequire("crya1");

function $32721019eaeb91a7$var$t(t) {
    return "object" == typeof t && null != t && 1 === t.nodeType;
}
function $32721019eaeb91a7$var$e(t, e) {
    return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}
function $32721019eaeb91a7$var$n(t, n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return $32721019eaeb91a7$var$e(r.overflowY, n) || $32721019eaeb91a7$var$e(r.overflowX, n) || function(t) {
            var e = function(t) {
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            }(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        }(t);
    }
    return !1;
}
function $32721019eaeb91a7$var$r(t, e, n, r, i, o, l, d) {
    return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}
var $32721019eaeb91a7$export$2e2bcd8739ae039 = function(e, i) {
    var o = window, l = i.scrollMode, d = i.block, f = i.inline, h = i.boundary, u = i.skipOverflowHiddenElements, s = "function" == typeof h ? h : function(t) {
        return t !== h;
    };
    if (!$32721019eaeb91a7$var$t(e)) throw new TypeError("Invalid target");
    for(var a, c, g = document.scrollingElement || document.documentElement, p = [], m = e; $32721019eaeb91a7$var$t(m) && s(m);){
        if ((m = null == (c = (a = m).parentElement) ? a.getRootNode().host || null : c) === g) {
            p.push(m);
            break;
        }
        null != m && m === document.body && $32721019eaeb91a7$var$n(m) && !$32721019eaeb91a7$var$n(document.documentElement) || null != m && $32721019eaeb91a7$var$n(m, u) && p.push(m);
    }
    for(var w = o.visualViewport ? o.visualViewport.width : innerWidth, v = o.visualViewport ? o.visualViewport.height : innerHeight, W = window.scrollX || pageXOffset, H = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), y = b.height, E = b.width, M = b.top, V = b.right, x = b.bottom, I = b.left, C = "start" === d || "nearest" === d ? M : "end" === d ? x : M + y / 2, R = "center" === f ? I + E / 2 : "end" === f ? V : I, T = [], k = 0; k < p.length; k++){
        var B = p[k], D = B.getBoundingClientRect(), O = D.height, X = D.width, Y = D.top, L = D.right, S = D.bottom, j = D.left;
        if ("if-needed" === l && M >= 0 && I >= 0 && x <= v && V <= w && M >= Y && x <= S && I >= j && V <= L) return T;
        var N = getComputedStyle(B), q = parseInt(N.borderLeftWidth, 10), z = parseInt(N.borderTopWidth, 10), A = parseInt(N.borderRightWidth, 10), F = parseInt(N.borderBottomWidth, 10), G = 0, J = 0, K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q - A : 0, P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z - F : 0, Q = "offsetWidth" in B ? 0 === B.offsetWidth ? 0 : X / B.offsetWidth : 0, U = "offsetHeight" in B ? 0 === B.offsetHeight ? 0 : O / B.offsetHeight : 0;
        if (g === B) G = "start" === d ? C : "end" === d ? C - v : "nearest" === d ? $32721019eaeb91a7$var$r(H, H + v, v, z, F, H + C, H + C + y, y) : C - v / 2, J = "start" === f ? R : "center" === f ? R - w / 2 : "end" === f ? R - w : $32721019eaeb91a7$var$r(W, W + w, w, q, A, W + R, W + R + E, E), G = Math.max(0, G + H), J = Math.max(0, J + W);
        else {
            G = "start" === d ? C - Y - z : "end" === d ? C - S + F + P : "nearest" === d ? $32721019eaeb91a7$var$r(Y, S, O, z, F + P, C, C + y, y) : C - (Y + O / 2) + P / 2, J = "start" === f ? R - j - q : "center" === f ? R - (j + X / 2) + K / 2 : "end" === f ? R - L + A + K : $32721019eaeb91a7$var$r(j, L, X, q, A + K, R, R + E, E);
            var Z = B.scrollLeft, $ = B.scrollTop;
            C += $ - (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P))), R += Z - (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K)));
        }
        T.push({
            el: B,
            top: G,
            left: J
        });
    }
    return T;
};


function $a10174edd8d4f02a$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $a10174edd8d4f02a$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $a10174edd8d4f02a$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($a10174edd8d4f02a$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $a10174edd8d4f02a$var$scrollIntoView(target, options) {
    var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
    if ($a10174edd8d4f02a$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(isTargetAttached ? (0, $32721019eaeb91a7$export$2e2bcd8739ae039)(target, options) : []);
    if (!isTargetAttached) return;
    var computeOptions = $a10174edd8d4f02a$var$getOptions(options);
    return $a10174edd8d4f02a$var$defaultBehavior((0, $32721019eaeb91a7$export$2e2bcd8739ae039)(target, computeOptions), computeOptions.behavior);
}
var $a10174edd8d4f02a$export$2e2bcd8739ae039 = $a10174edd8d4f02a$var$scrollIntoView;



var $iug2J = parcelRequire("iug2J");


var $g9Srd = parcelRequire("g9Srd");

var $fT2ta = parcelRequire("fT2ta");


var $dh538 = parcelRequire("dh538");


var $caX7N = parcelRequire("caX7N");





var $fFa3V = parcelRequire("fFa3V");




// The minimum interval between position updates in milliseconds
const $9c7b365b14a69429$var$POSITION_UPDATE_INTERVAL = 200;
const $9c7b365b14a69429$var$getElementRect = (element)=>{
    const { height: height, left: left, top: top, width: width } = element.getBoundingClientRect();
    return {
        height: height,
        left: left,
        top: top,
        width: width
    };
};
const $9c7b365b14a69429$var$useResizeAwareElementBox = (element, updateMethod)=>{
    const [box, setBox] = (0, $42omo.useState)({
        width: 0,
        height: 0,
        left: 0,
        top: 0
    });
    (0, $42omo.useLayoutEffect)(()=>{
        if (updateMethod === 'resizeListener') {
            if ((0, $dh538.fg)('scroll-lock-replacement')) // use setTimeout 0 to defer the state update to avoid content shifting when pages have scrollbars
            // more details are https://www.loom.com/share/96a5d7c2afd74146a3c005bf20a8c69e?sid=968b00c1-e5ab-4ea0-9fe4-e534fe7088e4
            setTimeout(()=>{
                setBox($9c7b365b14a69429$var$getElementRect(element));
            }, 0);
            else setBox($9c7b365b14a69429$var$getElementRect(element));
        }
    }, [
        element,
        updateMethod
    ]);
    (0, $42omo.useEffect)(()=>{
        const onResize = ()=>{
            requestAnimationFrame(()=>{
                setBox($9c7b365b14a69429$var$getElementRect(element));
            });
        };
        if (updateMethod === 'resizeListener') return (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: onResize
        });
        return ()=>{};
    }, [
        element,
        updateMethod
    ]);
    return box;
};
const $9c7b365b14a69429$var$usePollingElementBox = (element, updateMethod)=>{
    // These are intentionally tracked as number primitives rather than as a shared `box` object.
    // Since the requestAnimationFrame code below updates this often, we want to avoid re-renders
    // when the values are the same.  React uses `Object.is` to figure out if the state changed after a setState.
    // If we represent this as a shared `box` object, this will re-render even if the two objects have identical contents.
    const [width, setWidth] = (0, $42omo.useState)(0);
    const [height, setHeight] = (0, $42omo.useState)(0);
    const [left, setLeft] = (0, $42omo.useState)(0);
    const [top, setTop] = (0, $42omo.useState)(0);
    (0, $42omo.useLayoutEffect)(()=>{
        if (updateMethod === 'polling') {
            if ((0, $dh538.fg)('scroll-lock-replacement')) // use setTimeout 0 to defer the state update to avoid content shifting when pages have scrollbars
            // more details are https://www.loom.com/share/96a5d7c2afd74146a3c005bf20a8c69e?sid=968b00c1-e5ab-4ea0-9fe4-e534fe7088e4
            setTimeout(()=>{
                const newBox = $9c7b365b14a69429$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
            }, 0);
            else {
                const newBox = $9c7b365b14a69429$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
            }
        }
    }, [
        element,
        updateMethod
    ]);
    // Souce: https://css-tricks.com/using-requestanimationframe-with-react-hooks/
    // Use useRef for mutable variables that we want to persist
    // without triggering a re-render on their change
    const requestRef = (0, $42omo.useRef)();
    const previousUpdateTimeRef = (0, $42omo.useRef)();
    const animate = (0, $42omo.useCallback)((time)=>{
        if (previousUpdateTimeRef.current !== undefined) {
            const timeSinceLastUpdate = time - previousUpdateTimeRef.current;
            if (timeSinceLastUpdate > $9c7b365b14a69429$var$POSITION_UPDATE_INTERVAL) {
                const newBox = $9c7b365b14a69429$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
                previousUpdateTimeRef.current = time;
            }
        } else // Initialize previousUpdateTimeRef
        previousUpdateTimeRef.current = time;
        requestRef.current = requestAnimationFrame(animate);
    }, [
        element
    ]);
    (0, $42omo.useEffect)(()=>{
        if (updateMethod === 'polling') requestRef.current = requestAnimationFrame(animate);
        return ()=>{
            if (requestRef.current !== undefined) cancelAnimationFrame(requestRef.current);
        };
    // This useEffect should only run on mount and when `element` or `updateMethod` changes.
    }, [
        animate,
        element,
        updateMethod
    ]);
    const box = (0, $42omo.useMemo)(()=>({
            width: width,
            height: height,
            left: left,
            top: top
        }), [
        width,
        height,
        left,
        top
    ]);
    return box;
};
/**
 * Will listen to the document resizing to see if an element has moved positions.
 * Not using ResizeObserver because of IE11 support.
 * @param element HTMLElement to watch when resizing.
 */ const $9c7b365b14a69429$var$useElementBox = (element, resizeUpdateMethod)=>{
    const updateMethod = resizeUpdateMethod || 'resizeListener';
    const boxViaResizeListener = $9c7b365b14a69429$var$useResizeAwareElementBox(element, updateMethod);
    const boxViaPolling = $9c7b365b14a69429$var$usePollingElementBox(element, updateMethod);
    return updateMethod === 'resizeListener' ? boxViaResizeListener : boxViaPolling;
};
const $9c7b365b14a69429$export$1b6719bd7aff3c00 = (props)=>{
    const box = $9c7b365b14a69429$var$useElementBox(props.element, props.resizeUpdateMethod);
    return props.children(box);
};









var $1lhEF = parcelRequire("1lhEF");




function $d6343403a6ef2ee3$export$729bafd4e621fba0(element, opts = {}) {
    const { onChange: onChange, disableWatch: disableWatch = false } = opts;
    // This state is used to force a re-render when the target changes
    const [targetContentVersion, setTargetContentVersion] = (0, $42omo.useState)(0);
    const mutationObserver = (0, $42omo.useRef)(undefined);
    const cancelIdleCallback1 = (0, $42omo.useRef)(undefined);
    const disposer = (0, $42omo.useCallback)(()=>{
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = undefined;
        mutationObserver.current?.disconnect();
        mutationObserver.current = undefined;
    }, []);
    const onMutation = (0, $42omo.useCallback)(()=>{
        // MutationObserver can make multiple calls to the callback in quick succession so debounce when idle
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = $d6343403a6ef2ee3$var$callWhenIdle(()=>setTargetContentVersion((v)=>{
                const version = v + 1;
                onChange?.(version);
                return version;
            }));
    }, [
        onChange
    ]);
    (0, $42omo.useEffect)(()=>{
        // Clean up any existing observer in the case that the target node has changed
        disposer();
        if (!disableWatch && element) {
            mutationObserver.current = new MutationObserver(onMutation);
            mutationObserver.current.observe(element, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        return disposer;
    }, [
        disableWatch,
        disposer,
        element,
        onMutation
    ]);
    return targetContentVersion;
}
/**
 * When the browser is idle call the callback.
 *
 * This function will use `requestIdleCallback` if available, otherwise it will fallback to `setTimeout`.
 *
 * @param callback The function to call when the browser is idle.
 * @param [opts] Options for the idle callback.
 * @param [opts.timeout=100] The maximum time to wait for the browser to be idle.
 *
 * @returns A function that can be called to cancel the idle callback.
 *
 * @internal
 */ function $d6343403a6ef2ee3$var$callWhenIdle(callback, opts = {}) {
    const { timeout: timeout = 100 } = opts;
    if (typeof window.requestIdleCallback === 'function') {
        const idleHandle = window.requestIdleCallback(callback, {
            timeout: timeout
        });
        return ()=>cancelIdleCallback(idleHandle);
    }
    // Fallback to setTimeout if requestIdleCallback is not available
    const timeoutHandle = setTimeout(callback, timeout);
    return ()=>clearTimeout(timeoutHandle);
}


const $acd3e7dd0e53336b$var$computedStyleAttributesToClone = [
    'fontSize',
    'fontWeight',
    'lineHeight',
    'padding',
    'color',
    'textOverflow'
];
function $acd3e7dd0e53336b$var$cloneAndOverrideStyles(node) {
    const shouldCloneChildren = true;
    const clonedNode = node.cloneNode(shouldCloneChildren);
    const computedStyles = getComputedStyle(node);
    $acd3e7dd0e53336b$var$computedStyleAttributesToClone.forEach((attribute)=>{
        clonedNode.style[attribute] = computedStyles[attribute];
    });
    clonedNode.style.margin = '0';
    clonedNode.style.position = 'static';
    // The target may have other transforms applied. Avoid unintended side effects
    // by zeroing out "translate" rather than applying a value of "none".
    clonedNode.style.transform = 'translate(0, 0) translate3d(0, 0, 0)';
    return clonedNode;
}
/**
 * __Clone__
 *
 * Used for cloning spotlight targets. The clone is positioned on top of the spotlight target with
 * a pulsing animation.
 *
 * @internal
 */ const $acd3e7dd0e53336b$var$Clone = (props)=>{
    const { pulse: pulse, style: style, shouldWatch: shouldWatch, target: target, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetNode: targetNode, targetRadius: targetRadius, testId: testId } = props;
    const contentVersion = (0, $d6343403a6ef2ee3$export$729bafd4e621fba0)(targetNode, {
        disableWatch: !shouldWatch
    });
    const contentHTML = (0, $42omo.useMemo)(()=>$acd3e7dd0e53336b$var$cloneAndOverrideStyles(targetNode).outerHTML, // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to update when the content changes
    [
        contentVersion,
        targetNode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1lhEF.TargetInner), {
        "data-testid": testId,
        pulse: pulse,
        bgColor: targetBgColor,
        radius: targetRadius,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: contentHTML
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    height: '100%',
                    pointerEvents: 'none'
                }
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1lhEF.TargetOverlay), {
                onClick: targetOnClick ? (event)=>targetOnClick({
                        event: event,
                        target: target
                    }) : undefined
            })
        ]
    });
};
var $acd3e7dd0e53336b$export$2e2bcd8739ae039 = $acd3e7dd0e53336b$var$Clone;









var $e8Hkv = parcelRequire("e8Hkv");

/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $449aef48fe228d6d$var$NodeResolverSpotlightInner = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    const divRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (!hasNodeResolver) innerRef(divRef.current?.firstElementChild);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasNodeResolver
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8Hkv))), {
        innerRef: innerRef,
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: divRef,
        children: children
    });
};
var $449aef48fe228d6d$export$2e2bcd8739ae039 = $449aef48fe228d6d$var$NodeResolverSpotlightInner;









var $5zdke = parcelRequire("5zdke");


var $lqsSp = parcelRequire("lqsSp");


var $gdv5Z = parcelRequire("gdv5Z");


var $2tfwO = parcelRequire("2tfwO");


var $91xA1 = parcelRequire("91xA1");




class $3d6c5b008d24705f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) this.props.onChange();
    }
    render() {
        return this.props.children;
    }
}


/**
 * __Spotlight dialog__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $086cd565d48ecbc4$var$SpotlightDialogComponent extends (0, $42omo.Component) {
    componentDidMount() {
        this.focusLockTimeoutId = window.setTimeout(()=>{
            // we delay the enabling of the focus lock to avoid the scroll position
            // jumping around in some situations
            this.setState({
                focusLockDisabled: false
            });
        }, 200);
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusLockTimeoutId);
    }
    render() {
        const { actions: actions, actionsBeforeElement: actionsBeforeElement, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label = 'Introducing new feature', titleId: titleId, targetNode: targetNode, testId: testId } = this.props;
        const { focusLockDisabled: focusLockDisabled } = this.state;
        const dialogLabel = !heading && !titleId ? label : undefined;
        const dialogLabelledBy = titleId || (heading ? 'spotlight-dialog-label' : undefined);
        const translatedPlacement = dialogPlacement ? ({
            'top left': 'top-start',
            'top center': 'top',
            'top right': 'top-end',
            'right top': 'right-start',
            'right middle': 'right',
            'right bottom': 'right-end',
            'bottom left': 'bottom-start',
            'bottom center': 'bottom',
            'bottom right': 'bottom-end',
            'left top': 'left-start',
            'left middle': 'left',
            'left bottom': 'left-end'
        })[dialogPlacement] : undefined;
        // If there's no room on either side of the popper, it will extend off-screen.
        //  This looks buggy when scroll-lock and focus is placed on the dialog, so we
        //  customise popper so it overflows the spotlight instead with altAxis=true.
        const modifiers = [
            {
                name: 'preventOverflow',
                options: {
                    padding: 5,
                    rootBoundary: 'document',
                    altAxis: true,
                    tether: false
                }
            }
        ];
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $lqsSp.Popper), {
            modifiers: modifiers,
            referenceElement: targetNode,
            placement: translatedPlacement,
            children: ({ ref: ref, style: style, update: update })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3d6c5b008d24705f$export$2e2bcd8739ae039), {
                    value: dialogWidth,
                    onChange: update,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5zdke.default), {
                        disabled: focusLockDisabled,
                        returnFocus: false,
                        autoFocus: true,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: style,
                            ref: ref,
                            "aria-modal": true,
                            role: "dialog",
                            "aria-label": dialogLabel,
                            "aria-labelledby": dialogLabelledBy,
                            testId: `${testId}-container`,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $91xA1.default), {
                                testId: testId,
                                width: dialogWidth,
                                actions: actions,
                                actionsBeforeElement: actionsBeforeElement,
                                image: image && /*#__PURE__*/ (0, $l998X.jsx)((0, $2tfwO.DialogImage), {
                                    alt: heading,
                                    src: image
                                }),
                                components: {
                                    Header: header,
                                    Footer: footer
                                },
                                heading: heading,
                                headingId: "spotlight-dialog-label",
                                headingAfterElement: headingAfterElement,
                                // This should be heading level 1 since this is technically a modal, including a focus lock on the modal window.
                                // But because it is not a _true_ modal, we are setting it to `2` until that is fixed.
                                headingLevel: 2,
                                children: children
                            })
                        })
                    })
                })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            focusLockDisabled: true
        };
        this.focusLockTimeoutId = void 0;
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$086cd565d48ecbc4$export$2e2bcd8739ae039 = $086cd565d48ecbc4$var$SpotlightDialogComponent;



var $2Fndw = parcelRequire("2Fndw");

/**
 * __Spotlight inner__
 *
 * Renders the spotlight target clone and dialog.
 *
 * @internal
 */ class $979e9e34546576db$var$SpotlightInner extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.targetNode !== this.props.targetNode) (0, $a10174edd8d4f02a$export$2e2bcd8739ae039)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
    }
    componentDidMount() {
        (0, $a10174edd8d4f02a$export$2e2bcd8739ae039)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
        this.props.onOpened();
    }
    componentWillUnmount() {
        this.props.onClosed();
    }
    render() {
        const { pulse: pulse, shouldWatchTarget: shouldWatchTarget, target: target, targetNode: targetNode, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetRadius: targetRadius, testId: testId, targetReplacement: TargetReplacement } = this.props;
        const { replacementElement: replacementElement } = this.state;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Fndw.SpotlightTransitionConsumer), {
            children: ({ isOpen: isOpen, onExited: onExited })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $caX7N.default), {
                    zIndex: 701,
                    children: [
                        TargetReplacement ? /*#__PURE__*/ (0, $l998X.jsx)((0, $449aef48fe228d6d$export$2e2bcd8739ae039), {
                            hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                            innerRef: (elem)=>this.setState({
                                    replacementElement: elem
                                }),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9c7b365b14a69429$export$1b6719bd7aff3c00), {
                                element: targetNode,
                                resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined,
                                children: (box)=>/*#__PURE__*/ (0, $l998X.jsx)(TargetReplacement, {
                                        "data-testid": `${testId}--target`,
                                        ...this.getTargetNodeStyle(box)
                                    })
                            })
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9c7b365b14a69429$export$1b6719bd7aff3c00), {
                            element: targetNode,
                            resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined,
                            children: (box)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $acd3e7dd0e53336b$export$2e2bcd8739ae039), {
                                    shouldWatch: shouldWatchTarget,
                                    testId: `${testId}--target`,
                                    pulse: pulse,
                                    target: target,
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                    style: this.getTargetNodeStyle(box),
                                    targetBgColor: targetBgColor,
                                    targetNode: targetNode,
                                    targetOnClick: targetOnClick,
                                    targetRadius: targetRadius
                                })
                        }),
                        TargetReplacement && !replacementElement ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $iug2J.Layering), {
                            isDisabled: false,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
                                appear: true,
                                children: isOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
                                    onFinish: (state)=>{
                                        state === 'exiting' && onExited();
                                    },
                                    duration: "medium",
                                    children: ({ ref: ref, className: className, style: style })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                                            ref: ref,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                                            className: className,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                                            style: style,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $086cd565d48ecbc4$export$2e2bcd8739ae039), {
                                                testId: `${testId}--dialog`,
                                                actions: this.props.actions,
                                                actionsBeforeElement: this.props.actionsBeforeElement,
                                                children: this.props.children,
                                                dialogPlacement: this.props.dialogPlacement,
                                                dialogWidth: this.props.dialogWidth,
                                                footer: this.props.footer,
                                                header: this.props.header,
                                                heading: this.props.heading,
                                                titleId: this.props.titleId,
                                                label: this.props.label,
                                                headingAfterElement: this.props.headingAfterElement,
                                                image: this.props.image,
                                                targetNode: replacementElement || targetNode
                                            })
                                        })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($crya1))), {})
                    ]
                })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            // This is only used when targetReplacement is specified.
            // In this case, we have to render the targetReplacement component,
            // get a dom reference from that component, then render again passing
            // that reference into SpotlightDialog (Popper).
            replacementElement: null
        };
        this.getTargetNodeStyle = (box)=>{
            if (!(0, $5dBQh.canUseDOM)) return {};
            const { height: height, left: left, top: top, width: width, ...rest } = box;
            return {
                // Handling this just in case there are invalid elements being sent in to
                // the `box` arg
                ...rest,
                height: height,
                left: left,
                top: top,
                width: width,
                position: 'fixed',
                // when width is 0, set visibility hidden to avoid the target flashing issue
                ...width === 0 && (0, $dh538.fg)('scroll-lock-replacement') && {
                    visibility: 'hidden'
                }
            };
        };
    }
}
$979e9e34546576db$var$SpotlightInner.defaultProps = {
    dialogWidth: 400,
    pulse: true
};
var $979e9e34546576db$export$2e2bcd8739ae039 = $979e9e34546576db$var$SpotlightInner;



var $6cnUO = parcelRequire("6cnUO");

/**
 * __Spotlight__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $7334bd40f3f3a2f6$var$Spotlight = ({ actions: actions, actionsBeforeElement: actionsBeforeElement, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth = 400, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label, pulse: pulse = true, scrollPositionBlock: scrollPositionBlock, shouldWatchTarget: shouldWatchTarget = false, target: target, targetBgColor: targetBgColor, targetNode: targetNode, targetOnClick: targetOnClick, targetRadius: targetRadius, targetReplacement: targetReplacement, testId: testId = 'spotlight', titleId: titleId, ...rest })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.SpotlightConsumer), {
        children: ({ opened: opened, closed: closed, targets: targets })=>{
            // use the targetNode prop or try get the target from context targets using name
            const actualTargetNode = targetNode || (typeof target === 'string' ? targets[target] : undefined);
            return actualTargetNode ? /*#__PURE__*/ (0, $l998X.jsx)((0, $979e9e34546576db$export$2e2bcd8739ae039), {
                ...rest,
                actions: actions,
                actionsBeforeElement: actionsBeforeElement,
                children: children,
                dialogPlacement: dialogPlacement,
                dialogWidth: dialogWidth,
                footer: footer,
                header: header,
                heading: heading,
                headingAfterElement: headingAfterElement,
                image: image,
                label: label,
                onClosed: closed,
                onOpened: opened,
                pulse: pulse,
                scrollPositionBlock: scrollPositionBlock,
                shouldWatchTarget: shouldWatchTarget,
                target: target,
                targetBgColor: targetBgColor,
                targetNode: actualTargetNode,
                targetOnClick: targetOnClick,
                targetRadius: targetRadius,
                targetReplacement: targetReplacement,
                testId: testId,
                titleId: titleId
            }) : null;
        }
    });
var $7334bd40f3f3a2f6$export$2e2bcd8739ae039 = $7334bd40f3f3a2f6$var$Spotlight;
module.exports["default"] = $7334bd40f3f3a2f6$export$2e2bcd8739ae039;

});

parcelRegister("5dBQh", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("crya1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7T0iB = parcelRequire("7T0iB");

Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $90f28139a9a35f0b$var$_interopRequireDefault($7T0iB).default;
    }
});

var $fsOG6 = parcelRequire("fsOG6");

Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $fsOG6.TouchScrollable;
    }
});
function $90f28139a9a35f0b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});

parcelRegister("1lhEF", function(module, exports) {
/* target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $027c081b8a3db08f$var$reduceMotionAsPerUserPreference = null;
// Pulse color "rgb(101, 84, 192)" derived from "colors.P300"
const $027c081b8a3db08f$var$baseShadow = `0 0 0 2px ${"var(--ds-border-discovery, #8270DB)"}`;
const $027c081b8a3db08f$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $027c081b8a3db08f$var$pulseKeyframes = null;
const $027c081b8a3db08f$var$animationStyles = null;
const $027c081b8a3db08f$var$Base = ({ bgColor: bgColor, children: children, className: className, radius: radius, testId: testId, style: style, // The rest of these props are from `HTMLDivElement`
...props })=>/*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: className,
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style is not allowed at the moment
            ...style,
            backgroundColor: bgColor,
            borderRadius: radius ? `${radius}px` : undefined
        },
        ...props,
        children: children
    }); /**
          * __Target inner__
          *
          * Used to apply spotlight border and pulse to spotlight targets.
          *
          * @internal
          */ 
const $027c081b8a3db08f$export$b1542cc928b93af = ({ bgColor: bgColor, children: children, className: className, pulse: pulse, radius: radius, testId: testId, // Thes rest of these are from `HTMLDivElement`
...props })=>/*#__PURE__*/ (0, $l998X.jsx)($027c081b8a3db08f$var$Base, {
        bgColor: bgColor,
        className: (0, $gMc0m.default)([
            pulse && "",
            pulse && "_5sagi11n _tip812c5 _j7hq1ukm _1pglmcjr _16qs1wx8",
            "_1bumglyw _sedtglyw",
            className
        ]),
        radius: radius,
        testId: testId,
        ...props,
        style: props.style,
        children: children
    });
const $027c081b8a3db08f$var$targetOverlayStyles = null; /**
                                   * __Target overlay__
                                   *
                                   * Overlays a spotlight target, allowing for custom click events that are intended
                                   * only for onboarding.
                                   *
                                   * @internal
                                   */ 
const $027c081b8a3db08f$export$a28a07e0025d709d = ({ onClick: onClick, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        onClick: onClick,
        ...props,
        style: {
            cursor: onClick ? 'pointer' : 'auto'
        },
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1osq _kqswstnw _152tze3t _1e02ze3t"
        ])
    }); /**
                                                                                                      * __Spotlight pulse__
                                                                                                      *
                                                                                                      * A spotlight pulse draws attention to a new feature.
                                                                                                      *
                                                                                                      * - [Examples](https://atlassian.design/components/onboarding/examples)
                                                                                                      * - [Code](https://atlassian.design/components/onboarding/code)
                                                                                                      * - [Usage](https://atlassian.design/components/onboarding/usage)
                                                                                                      *
                                                                                                      * @deprecated Use `@atlaskit/spotlight` instead.
                                                                                                      */ 
const $027c081b8a3db08f$export$927d63e2511364c0 = ({ bgColor: bgColor, children: children, className: className, radius: radius, pulse: pulse = true, testId: testId, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)($027c081b8a3db08f$var$Base, {
        bgColor: bgColor,
        className: (0, $gMc0m.default)([
            pulse && "",
            pulse && "_5sagi11n _tip812c5 _j7hq1ukm _1pglmcjr _16qs1wx8",
            "_1bumglyw _sedtglyw",
            className
        ]),
        radius: radius,
        testId: testId,
        ...props,
        style: props.style,
        children: children
    });
module.exports["TargetInner"] = $027c081b8a3db08f$export$b1542cc928b93af;
module.exports["TargetOverlay"] = $027c081b8a3db08f$export$a28a07e0025d709d;
module.exports["Pulse"] = $027c081b8a3db08f$export$927d63e2511364c0;

});

parcelRegister("e8Hkv", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $k1UQN = parcelRequire("k1UQN");

Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $a4b36c713005f0c9$var$_interopRequireDefault($k1UQN).default;
    }
});
function $a4b36c713005f0c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});

parcelRegister("91xA1", function(module, exports) {
/* spotlight-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4KS7f = parcelRequire("4KS7f");

var $boHsq = parcelRequire("boHsq");


var $1Whri = parcelRequire("1Whri");


var $7hXDW = parcelRequire("7hXDW");


var $16xFS = parcelRequire("16xFS");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $2tfwO = parcelRequire("2tfwO");


var $9BPJm = parcelRequire("9BPJm");

const $e3cd8811b45d4630$var$bodyStyles = null;
const $e3cd8811b45d4630$var$imageStyles = null;
const $e3cd8811b45d4630$var$defaultHeaderStyles = null;
const $e3cd8811b45d4630$var$DefaultHeader = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1q9y _1bah1yb4 _85i5u2gc"
        ]),
        children: children
    });
const $e3cd8811b45d4630$var$defaultFooterStyles = null;
const $e3cd8811b45d4630$var$DefaultFooter = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "spotlight--dialog-footer",
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1q51u2gc"
        ]),
        children: children
    });
const $e3cd8811b45d4630$var$containerStyles = {
    root: "_2rko12b0 _1reo1wug _18m91wug _4t3i1ns9 _syaz15cr _1ul91lit _p12f1ogm"
};
const $e3cd8811b45d4630$var$containerShadowStyles = {
    root: "_16qszucj"
}; /**
    * __Spotlight card__
    *
    * A spotlight card is for onboarding messages that need a more flexible layout, or don't require a dialog.
    *
    * - [Examples](https://atlassian.design/components/onboarding/spotlight-card/examples)
    * - [Code](https://atlassian.design/components/onboarding/spotlight-card/code)
    * - [Usage](https://atlassian.design/components/onboarding/spotlight-card/usage)
    *
    * @deprecated Use `@atlaskit/spotlight` instead.
    */ 
const $e3cd8811b45d4630$var$SpotlightCard = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { actions: actions = [], actionsBeforeElement: actionsBeforeElement, children: children, components: components = {}, heading: heading, headingLevel: headingLevel = 4, headingAfterElement: headingAfterElement, image: image, innerRef: innerRef, isFlat: isFlat, testId: testId, width: width = 400, headingId: headingId } = props;
    const { Header: Header = $e3cd8811b45d4630$var$DefaultHeader, Footer: Footer = $e3cd8811b45d4630$var$DefaultFooter } = components;
    const { currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $boHsq.default).Provider, {
        value: (0, $9BPJm.spotlightButtonTheme),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            backgroundColor: "color.background.discovery.bold",
            xcss: (0, $1Whri.cx)($e3cd8811b45d4630$var$containerStyles.root, !isFlat && $e3cd8811b45d4630$var$containerShadowStyles.root),
            style: {
                width: width
            },
            ref: ref || innerRef,
            testId: testId,
            "data-ds--level": currentLevel,
            "data-ds--close--type": "single",
            children: [
                typeof image === 'string' ? /*#__PURE__*/ (0, $l998X.jsx)("img", {
                    src: image,
                    alt: "",
                    className: (0, $gMc0m.default)([
                        "_1e0c1ule"
                    ])
                }) : image,
                /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                    className: (0, $gMc0m.default)([
                        "_1e0c1txw _2lx21bp4 _85i5pxbi _1q51pxbi _y4tiv47k _bozgv47k"
                    ]),
                    children: [
                        heading || headingAfterElement ? /*#__PURE__*/ (0, $l998X.jsxs)(Header, {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                                    id: headingId,
                                    size: "medium",
                                    as: `h${headingLevel}`,
                                    color: "color.text.inverse",
                                    children: heading
                                }),
                                headingAfterElement
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: children
                        }),
                        actions.length > 0 || actionsBeforeElement ? /*#__PURE__*/ (0, $l998X.jsxs)(Footer, {
                            children: [
                                actionsBeforeElement || /*#__PURE__*/ (0, $l998X.jsx)("span", {}),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $2tfwO.DialogActionItemContainer), {
                                    children: actions.map(({ text: text, key: key, ...rest }, idx)=>{
                                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2tfwO.DialogActionItem), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4KS7f.default), {
                                                ...rest,
                                                children: text
                                            })
                                        }, key || (typeof text === 'string' ? text : `${idx}`));
                                    })
                                })
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
});
$e3cd8811b45d4630$var$SpotlightCard.displayName = 'SpotlightCard';
var $e3cd8811b45d4630$export$2e2bcd8739ae039 = $e3cd8811b45d4630$var$SpotlightCard;
module.exports["default"] = $e3cd8811b45d4630$export$2e2bcd8739ae039;

});

parcelRegister("9BPJm", function(module, exports) {
const $8861ef687fb5b99a$var$spotlightTheme = {
    default: {
        background: {
            default: "var(--ds-background-inverse-subtle, #00000029)",
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: "var(--ds-background-disabled, #091E4208)",
            selected: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            focus: "var(--ds-background-inverse-subtle, #00000029)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #091E424F)",
                dark: "var(--ds-text-disabled, #091E424F)"
            },
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        background: {
            default: 'none',
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: 'none',
            selected: {
                light: "var(--ds-background-selected-hovered, #CCE0FF)",
                dark: "var(--ds-background-selected-hovered, #CCE0FF)"
            },
            focusSelected: {
                light: "var(--ds-background-selected-hovered, #CCE0FF)",
                dark: "var(--ds-background-selected-hovered, #CCE0FF)"
            }
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-disabled, #091E424F)",
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    'subtle-link': {
        textDecoration: {
            hover: `underline ${"var(--ds-text-inverse, #FFFFFF)"}`
        },
        textDecorationLine: {
            active: 'none'
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-discovery, #5E4DB2)",
            selected: "var(--ds-text-selected, #0C66E4)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $8861ef687fb5b99a$var$modalTheme = {
    primary: {
        background: {
            default: "var(--ds-background-discovery-bold, #6E5DC6)",
            hover: "var(--ds-background-discovery-bold-hovered, #5E4DB2)",
            active: "var(--ds-background-discovery-bold-pressed, #352C63)",
            disabled: {
                light: "var(--ds-background-disabled, #091E4208)",
                dark: "var(--ds-background-disabled, #091E4208)"
            },
            selected: "var(--ds-background-selected-hovered, #CCE0FF)",
            focus: "var(--ds-background-discovery-bold-hovered, #5E4DB2)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #091E424F)",
                dark: "var(--ds-text-disabled, #091E424F)"
            },
            selected: "var(--ds-text-selected, #0C66E4)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
function $8861ef687fb5b99a$var$extract(newTheme, { mode: mode, appearance: appearance, state: state }) {
    if (!newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!node[item]) return undefined;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return undefined;
            }
            node = node[item];
            return undefined;
        });
        return acc;
    }, {});
}
const $8861ef687fb5b99a$export$39a36121076ca24 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$8861ef687fb5b99a$var$extract($8861ef687fb5b99a$var$spotlightTheme, themeProps)
        },
        ...rest
    };
};
const $8861ef687fb5b99a$export$d131eb21ba4cbd16 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$8861ef687fb5b99a$var$extract($8861ef687fb5b99a$var$modalTheme, themeProps)
        },
        ...rest
    };
};
module.exports["spotlightButtonTheme"] = $8861ef687fb5b99a$export$39a36121076ca24;
module.exports["modalButtonTheme"] = $8861ef687fb5b99a$export$d131eb21ba4cbd16;

});

parcelRegister("2Fndw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $c5e8b79346cf6bce$var$SpotlightTransitionContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isOpen: true,
    onExited: (0, $ee7An.default)
});
// checks if children exist and are truthy
const $c5e8b79346cf6bce$var$hasChildren = (children)=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) > 0 && ((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children || false, (child)=>!!child)?.filter(Boolean)?.length || 0) > 0;
/**
 * __Spotlight transition__
 *
 * A spotlight transition holds onto spotlights so they can fade out when exiting the viewport.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ class $c5e8b79346cf6bce$var$SpotlightTransition extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromProps(props, state) {
        const { currentChildren: previousChildren } = state;
        const exiting = $c5e8b79346cf6bce$var$hasChildren(previousChildren) && !$c5e8b79346cf6bce$var$hasChildren(props.children);
        return {
            currentChildren: exiting ? previousChildren : props.children
        };
    }
    render() {
        return /*#__PURE__*/ (0, $l998X.jsx)($c5e8b79346cf6bce$var$SpotlightTransitionContext.Provider, {
            value: {
                onExited: this.onExited,
                isOpen: $c5e8b79346cf6bce$var$hasChildren(this.props.children)
            },
            children: this.state.currentChildren
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            currentChildren: undefined
        };
        this.onExited = ()=>{
            this.setState({
                currentChildren: this.props.children
            });
        };
    }
}
const $c5e8b79346cf6bce$export$7d63b19b854c2fe8 = $c5e8b79346cf6bce$var$SpotlightTransitionContext.Consumer;
var $c5e8b79346cf6bce$export$2e2bcd8739ae039 = $c5e8b79346cf6bce$var$SpotlightTransition;
module.exports["SpotlightTransitionConsumer"] = $c5e8b79346cf6bce$export$7d63b19b854c2fe8;
module.exports["default"] = $c5e8b79346cf6bce$export$2e2bcd8739ae039;

});

parcelRegister("6cnUO", function(module, exports) {
$parcel$export(module.exports, "TargetConsumer", () => $e5b53c53ad1b1f53$export$f643dd64c1952cc8);
$parcel$export(module.exports, "SpotlightConsumer", () => $e5b53c53ad1b1f53$export$3503199acd121708);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $ee7An = parcelRequire("ee7An");


var $g9Srd = parcelRequire("g9Srd");

var $fT2ta = parcelRequire("fT2ta");


var $dh538 = parcelRequire("dh538");


var $caX7N = parcelRequire("caX7N");

/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");

// to body instead of nearest stacking context (Portal in our case).
const $d5d7146d37e8bdeb$var$blanketStyles = null;
const $d5d7146d37e8bdeb$var$Blanket = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isTinted: isTinted, onBlanketClicked: onBlanketClicked, style: style, className: className }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: ref,
        role: "presentation" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        ,
        className: (0, $gMc0m.default)([
            "_1r04idpf _v56414ka _kqsw1n9t _1pby1fw0",
            className
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style props are not allowed
            ...style,
            backgroundColor: isTinted ? "var(--ds-blanket, #091E427D)" : 'transparent'
        },
        onClick: onBlanketClicked
    });
});
var $d5d7146d37e8bdeb$export$2e2bcd8739ae039 = $d5d7146d37e8bdeb$var$Blanket;



var $kyRHQ = parcelRequire("kyRHQ");

const { Consumer: $e5b53c53ad1b1f53$export$f643dd64c1952cc8, Provider: $e5b53c53ad1b1f53$var$TargetProvider } = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $e5b53c53ad1b1f53$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $42omo.createContext)({
    opened: (0, $ee7An.default),
    closed: (0, $ee7An.default),
    targets: {}
});
const { Consumer: $e5b53c53ad1b1f53$export$3503199acd121708, Provider: $e5b53c53ad1b1f53$var$SpotlightStateProvider } = $e5b53c53ad1b1f53$export$7b5aa0f5b37a336d;
const $e5b53c53ad1b1f53$var$Container = ({ component: Wrapper, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)(Wrapper, {
        children: children
    });
class $e5b53c53ad1b1f53$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    componentDidMount() {
        typeof $kyRHQ;
    }
    render() {
        const { blanketIsTinted: blanketIsTinted, children: children, component: Tag, onBlanketClicked: onBlanketClicked } = this.props;
        const isActive = this.state.spotlightCount > 0;
        return /*#__PURE__*/ (0, $l998X.jsx)($e5b53c53ad1b1f53$var$SpotlightStateProvider, {
            value: this.getStateProviderValue(this.state.targets),
            children: /*#__PURE__*/ (0, $l998X.jsx)($e5b53c53ad1b1f53$var$TargetProvider, {
                value: this.getTargetRef,
                children: /*#__PURE__*/ (0, $l998X.jsxs)($e5b53c53ad1b1f53$var$Container, {
                    component: Tag || (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
                            children: isActive && /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
                                duration: "medium",
                                children: ({ ref: ref, className: className, style: style })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
                                        zIndex: 700,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d5d7146d37e8bdeb$export$2e2bcd8739ae039), {
                                            ref: ref,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                                            className: className,
                                            /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
                                            isTinted: blanketIsTinted,
                                            onBlanketClicked: onBlanketClicked
                                        })
                                    })
                            })
                        }),
                        children
                    ]
                })
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            spotlightCount: 0,
            targets: {}
        };
        /*
     * When enabling React Streaming in Confluence, a
     * "This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering"
     * error happens.
     * This is to fix this error by wrapping the state update in startTransition as suggested by React: https://react.dev/errors/421?invariant=421
     */ this.getTargetRef = (0, $dh538.fg)('platform_fix_component_state_update_for_suspense') ? (name)=>(element)=>{
                (0, $42omo.startTransition)(()=>{
                    this.setState((state)=>({
                            targets: {
                                ...state.targets,
                                [name]: element || undefined
                            }
                        }));
                });
            } : (name)=>(element)=>{
                this.setState((state)=>({
                        targets: {
                            ...state.targets,
                            [name]: element || undefined
                        }
                    }));
            };
        this.spotlightOpen = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount + 1
                }));
        };
        this.spotlightClose = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount - 1
                }));
        };
        this.getStateProviderValue = (0, $2XqLN.default)((targets)=>({
                opened: this.spotlightOpen,
                closed: this.spotlightClose,
                targets: targets
            }));
    }
}
$e5b53c53ad1b1f53$export$2e2bcd8739ae039.defaultProps = {
    blanketIsTinted: true
};
module.exports["SpotlightContext"] = $e5b53c53ad1b1f53$export$7b5aa0f5b37a336d;
module.exports["default"] = $e5b53c53ad1b1f53$export$2e2bcd8739ae039;

});

parcelRegister("4kfV4", function(module, exports) {
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");

const $e0a8596802612558$var$packageName = "platform-pkg";
const $e0a8596802612558$var$packageVersion = "0.0.0-use.local";
const $e0a8596802612558$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $e0a8596802612558$var$packageName,
    packageVersion: $e0a8596802612558$var$packageVersion
};
const $e0a8596802612558$var$baseStyles = null;
const $e0a8596802612558$var$shouldAllowClickThroughStyles = null;
const $e0a8596802612558$var$invisibleStyles = null; /**
                               * __Blanket__
                               *
                               * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
                               *
                               * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
                               */ 
const $e0a8596802612558$var$Blanket = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $ee7An.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
    const mouseDownTarget = (0, $42omo.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$e0a8596802612558$var$analyticsAttributes
    });
    const blanketClickOutsideChildren = (0, $42omo.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, $42omo.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk10xm _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        children: children
    });
}));
$e0a8596802612558$var$Blanket.displayName = 'Blanket';
var $e0a8596802612558$export$2e2bcd8739ae039 = $e0a8596802612558$var$Blanket;
module.exports["default"] = $e0a8596802612558$export$2e2bcd8739ae039;

});

parcelRegister("aCLu8", function(module, exports) {
$parcel$export(module.exports, "default", () => $f34424c3c229a18a$export$2e2bcd8739ae039);

var $9GKca = parcelRequire("9GKca");

function $f34424c3c229a18a$export$2e2bcd8739ae039(callback) {
    const ref = (0, $9GKca.default)(()=>callback);
    return ref.current;
}

});

parcelRegister("9GKca", function(module, exports) {
$parcel$export(module.exports, "default", () => $a43cd06ec205beb8$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

const $a43cd06ec205beb8$var$uniqueReferencedValue = {};
function $a43cd06ec205beb8$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $42omo.useRef)($a43cd06ec205beb8$var$uniqueReferencedValue);
    if (ref.current === $a43cd06ec205beb8$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});

parcelRegister("bzNqF", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f807ab48e3c4806$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $5f807ab48e3c4806$export$2e2bcd8739ae039(value) {
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("i9I6M", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7b5ac2306f5e1f9$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $e7b5ac2306f5e1f9$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $42omo.useState)(initialState);
    const valueRef = (0, $42omo.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});

parcelRegister("bSjaC", function(module, exports) {
$parcel$export(module.exports, "combine", () => (parcelRequire("bSwyQ")).combine);

var $bSwyQ = parcelRequire("bSwyQ");


});

parcelRegister("bSwyQ", function(module, exports) {
function $7f85d759c07fedff$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}
module.exports["combine"] = $7f85d759c07fedff$export$1be1fc439b849fdf;

});

parcelRegister("4T4vf", function(module, exports) {
$parcel$export(module.exports, "draggable", () => (parcelRequire("3CnSH")).draggable);
$parcel$export(module.exports, "dropTargetForElements", () => (parcelRequire("3CnSH")).dropTargetForElements);
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("3CnSH")).monitorForElements);

var $3CnSH = parcelRequire("3CnSH");


});

parcelRegister("3CnSH", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $66utD = parcelRequire("66utD");


var $75LZI = parcelRequire("75LZI");


var $iKd0N = parcelRequire("iKd0N");


var $bSwyQ = parcelRequire("bSwyQ");


var $aYpzB = parcelRequire("aYpzB");


var $gz7GF = parcelRequire("gz7GF");


var $ic3Jg = parcelRequire("ic3Jg");


var $btsNM = parcelRequire("btsNM");


var $k5wZ1 = parcelRequire("k5wZ1");

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $e7958150b312f60f$export$4c44a460f123106 = 'text/uri-list';



var $839Yz = parcelRequire("839Yz");

const $12f499d4dfb562d1$var$draggableRegistry = new WeakMap();
function $12f499d4dfb562d1$var$addToRegistry(args) {
    $12f499d4dfb562d1$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $12f499d4dfb562d1$var$draggableRegistry.delete(args.element);
    };
}
const $12f499d4dfb562d1$var$honeyPotFix = (0, $75LZI.makeHoneyPotFix)();
const $12f499d4dfb562d1$var$adapter = (0, $iKd0N.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
		 * this adapter always gets preference over the text adapter.
		 * `document` is the first `EventTarget` under `window`
		 * https://twitter.com/alexandereardon/status/1604658588311465985
		 */ return (0, $bSwyQ.combine)($12f499d4dfb562d1$var$honeyPotFix.bindEvents(), (0, $fFa3V.bind)(document, {
            type: 'dragstart',
            listener (event) {
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                const entry = $12f499d4dfb562d1$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
					 * A text selection drag _can_ have the `draggable` element be
					 * the `event.target` if the user is dragging the text selection
					 * from the `draggable`.
					 *
					 * To know if the `draggable` is being dragged, we look at whether any
					 * `"text/plain"` data is being dragged. If it is, then a text selection
					 * drag is occurring.
					 *
					 * This behaviour has been validated on:
					 *
					 * - Chrome@128 on Android@14
					 * - Chrome@128 on iOS@17.6.1
					 * - Chrome@128 on Windows@11
					 * - Chrome@128 on MacOS@14.6.1
					 * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
					 * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
					 *
					 * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
					 * but unfortunately ProseMirror is always setting `""` as the dragged text
					 *
					 * Note: Unfortunately editor is (heavily) leaning on the current functionality today
					 * and unwinding it will be a decent amount of effort. So for now, a text selection
					 * where the `event.target` is a `draggable` element will still trigger the
					 * element adapter.
					 *
					 * // Future state:
					 * if(event.dataTransfer.getData(textMediaType)) {
					 * 	return;
					 * }
					 *
					 */ const input = (0, $btsNM.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $66utD.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                /**
					 *  **Goal**
					 *  Pass information to other applications
					 *
					 * **Approach**
					 *  Put data into the native data store
					 *
					 *  **What about the native adapter?**
					 *  When the element adapter puts native data into the native data store
					 *  the native adapter is not triggered in the current window,
					 *  but a native adapter in an external window _can_ be triggered
					 *
					 *  **Why bake this into core?**
					 *  This functionality could be pulled out and exposed inside of
					 *  `onGenerateDragPreview`. But decided to make it a part of the
					 *  base API as it felt like a common enough use case and ended
					 *  up being a similar amount of code to include this function as
					 *  it was to expose the hook for it
					 */ const nativeData = entry.getInitialDataForExternal?.(feedback) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
					 *  📱 For Android devices, a drag operation will not start unless
					 * "text/plain" or "text/uri-list" data exists in the native data store
					 * https://twitter.com/alexandereardon/status/1732189803754713424
					 *
					 * Tested on:
					 * Device: Google Pixel 5
					 * Android version: 14 (November 5, 2023)
					 * Chrome version: 120.0
					 */ if ((0, $ic3Jg.isAndroid)() && !event.dataTransfer.types.includes((0, $k5wZ1.textMediaType)) && !event.dataTransfer.types.includes((0, $e7958150b312f60f$export$4c44a460f123106))) event.dataTransfer.setData((0, $k5wZ1.textMediaType), (0, $ic3Jg.androidFallbackText));
                /**
					 * 1. Must set any media type for `iOS15` to work
					 * 2. We are also doing adding data so that the native adapter
					 * can know that the element adapter has handled this drag
					 *
					 * We used to wrap this `setData()` in a `try/catch` for Firefox,
					 * but it looks like that was not needed.
					 *
					 * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
					 *
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
					 * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
					 *
					 * // just checking a few more combinations to be super safe
					 *
					 * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
					 * - ✅ Chrome@78 (Oct 2019) on Windows 10
					 * - ✅ Safari@14.1 on macOS Big Sur
					 */ event.dataTransfer.setData((0, $839Yz.elementAdapterNativeDataKey), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: entry.getInitialData?.(feedback) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        $12f499d4dfb562d1$var$draggableRegistry.get(payload.source.element)?.[eventName]?.(// I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $12f499d4dfb562d1$var$honeyPotFix.getOnPostDispatch()
});
const $12f499d4dfb562d1$export$e7140b68045b5036 = $12f499d4dfb562d1$var$adapter.dropTarget;
const $12f499d4dfb562d1$export$59a074bac4c54f54 = $12f499d4dfb562d1$var$adapter.monitor;
function $12f499d4dfb562d1$export$c746a5152d4ba26c(args) {
    const cleanup = (0, $bSwyQ.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $12f499d4dfb562d1$var$adapter.registerUsage(), $12f499d4dfb562d1$var$addToRegistry(args), (0, $gz7GF.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $aYpzB.once)(cleanup);
}
module.exports["dropTargetForElements"] = $12f499d4dfb562d1$export$e7140b68045b5036;
module.exports["monitorForElements"] = $12f499d4dfb562d1$export$59a074bac4c54f54;
module.exports["draggable"] = $12f499d4dfb562d1$export$c746a5152d4ba26c;

});

parcelRegister("66utD", function(module, exports) {

var $i4gTI = parcelRequire("i4gTI");

function $da7bea83c5260f30$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $i4gTI.isHoneyPotElement)(top)) return second ?? null;
    return top;
}
module.exports["getElementFromPointWithoutHoneypot"] = $da7bea83c5260f30$export$81d0353f25f5dd;

});

parcelRegister("f7qXf", function(module, exports) {
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $3e3de3bfe64952da$export$7d0a15ee70427305 = 2147483647;
module.exports["maxZIndex"] = $3e3de3bfe64952da$export$7d0a15ee70427305;

});

parcelRegister("aYpzB", function(module, exports) {
/** Provide a function that you only ever want to be called a single time */ function $d20a69cade0a9ae7$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}
module.exports["once"] = $d20a69cade0a9ae7$export$d2de3aaeafa91619;

});

parcelRegister("e880Z", function(module, exports) {

var $aYpzB = parcelRequire("aYpzB");

const $381be54fdfb26235$export$95df08bae54cb4df = (0, $aYpzB.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});
module.exports["isSafari"] = $381be54fdfb26235$export$95df08bae54cb4df;

});

parcelRegister("cmcCB", function(module, exports) {
function $86d2bbe13c882731$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}
module.exports["getBindingsForBrokenDrags"] = $86d2bbe13c882731$export$ac5e5b0daf997b2;

});

parcelRegister("ic3Jg", function(module, exports) {

var $aYpzB = parcelRequire("aYpzB");

const $283520dac20c3817$export$a11b0059900ceec8 = (0, $aYpzB.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $283520dac20c3817$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';
module.exports["isAndroid"] = $283520dac20c3817$export$a11b0059900ceec8;
module.exports["androidFallbackText"] = $283520dac20c3817$export$aceb3ed8b7f7bd2c;

});

parcelRegister("feJ8f", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", () => (parcelRequire("7J9Bb")).monitorForExternal);
$parcel$export(module.exports, "dropTargetForExternal", () => (parcelRequire("7J9Bb")).dropTargetForExternal);

var $7J9Bb = parcelRequire("7J9Bb");


});

parcelRegister("fNPGC", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => (parcelRequire("894UW")).monitorForTextSelection);

var $894UW = parcelRequire("894UW");


});

parcelRegister("ig6yX", function(module, exports) {
const $394e2d9e5b8112d3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $394e2d9e5b8112d3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $394e2d9e5b8112d3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $394e2d9e5b8112d3$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
const $394e2d9e5b8112d3$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
const $394e2d9e5b8112d3$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
const $394e2d9e5b8112d3$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';
module.exports["easeInOut"] = $394e2d9e5b8112d3$export$c07234257a03d5e9;
module.exports["easeOut"] = $394e2d9e5b8112d3$export$57636bb43b1ccbb0;

});

parcelRegister("12IaO", function(module, exports) {
var $d8bac6a1656ae9d6$exports = {};

var $hDMkC = parcelRequire("hDMkC");


var $32VMC = parcelRequire("32VMC");


var $lJMdL = parcelRequire("lJMdL");


var $fPVB6 = parcelRequire("fPVB6");

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $d8bac6a1656ae9d6$var$createCaseFirst(methodName) {
    return function(string) {
        string = $fPVB6(string);
        var strSymbols = $32VMC(string) ? $lJMdL(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $hDMkC(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$d8bac6a1656ae9d6$exports = $d8bac6a1656ae9d6$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $0c283e41c1b20e3c$var$upperFirst = $d8bac6a1656ae9d6$exports('toUpperCase');
module.exports = $0c283e41c1b20e3c$var$upperFirst;

});

parcelRegister("hDMkC", function(module, exports) {

var $3BqCC = parcelRequire("3BqCC");

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $cd7b91d3ec7edcbc$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $3BqCC(array, start, end);
}
module.exports = $cd7b91d3ec7edcbc$var$castSlice;

});

parcelRegister("32VMC", function(module, exports) {
/** Used to compose unicode character classes. */ var $237e618df24813a3$var$rsAstralRange = '\\ud800-\\udfff', $237e618df24813a3$var$rsComboMarksRange = '\\u0300-\\u036f', $237e618df24813a3$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $237e618df24813a3$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $237e618df24813a3$var$rsComboRange = $237e618df24813a3$var$rsComboMarksRange + $237e618df24813a3$var$reComboHalfMarksRange + $237e618df24813a3$var$rsComboSymbolsRange, $237e618df24813a3$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $237e618df24813a3$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $237e618df24813a3$var$reHasUnicode = RegExp('[' + $237e618df24813a3$var$rsZWJ + $237e618df24813a3$var$rsAstralRange + $237e618df24813a3$var$rsComboRange + $237e618df24813a3$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $237e618df24813a3$var$hasUnicode(string) {
    return $237e618df24813a3$var$reHasUnicode.test(string);
}
module.exports = $237e618df24813a3$var$hasUnicode;

});

parcelRegister("lJMdL", function(module, exports) {
var $160ed8c5ee11e437$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $160ed8c5ee11e437$var$asciiToArray(string) {
    return string.split('');
}
$160ed8c5ee11e437$exports = $160ed8c5ee11e437$var$asciiToArray;



var $32VMC = parcelRequire("32VMC");

var $085935f65eafe453$exports = {};
/** Used to compose unicode character classes. */ var $085935f65eafe453$var$rsAstralRange = '\\ud800-\\udfff', $085935f65eafe453$var$rsComboMarksRange = '\\u0300-\\u036f', $085935f65eafe453$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $085935f65eafe453$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $085935f65eafe453$var$rsComboRange = $085935f65eafe453$var$rsComboMarksRange + $085935f65eafe453$var$reComboHalfMarksRange + $085935f65eafe453$var$rsComboSymbolsRange, $085935f65eafe453$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $085935f65eafe453$var$rsAstral = '[' + $085935f65eafe453$var$rsAstralRange + ']', $085935f65eafe453$var$rsCombo = '[' + $085935f65eafe453$var$rsComboRange + ']', $085935f65eafe453$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $085935f65eafe453$var$rsModifier = '(?:' + $085935f65eafe453$var$rsCombo + '|' + $085935f65eafe453$var$rsFitz + ')', $085935f65eafe453$var$rsNonAstral = '[^' + $085935f65eafe453$var$rsAstralRange + ']', $085935f65eafe453$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $085935f65eafe453$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $085935f65eafe453$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $085935f65eafe453$var$reOptMod = $085935f65eafe453$var$rsModifier + '?', $085935f65eafe453$var$rsOptVar = '[' + $085935f65eafe453$var$rsVarRange + ']?', $085935f65eafe453$var$rsOptJoin = '(?:' + $085935f65eafe453$var$rsZWJ + '(?:' + [
    $085935f65eafe453$var$rsNonAstral,
    $085935f65eafe453$var$rsRegional,
    $085935f65eafe453$var$rsSurrPair
].join('|') + ')' + $085935f65eafe453$var$rsOptVar + $085935f65eafe453$var$reOptMod + ')*', $085935f65eafe453$var$rsSeq = $085935f65eafe453$var$rsOptVar + $085935f65eafe453$var$reOptMod + $085935f65eafe453$var$rsOptJoin, $085935f65eafe453$var$rsSymbol = '(?:' + [
    $085935f65eafe453$var$rsNonAstral + $085935f65eafe453$var$rsCombo + '?',
    $085935f65eafe453$var$rsCombo,
    $085935f65eafe453$var$rsRegional,
    $085935f65eafe453$var$rsSurrPair,
    $085935f65eafe453$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $085935f65eafe453$var$reUnicode = RegExp($085935f65eafe453$var$rsFitz + '(?=' + $085935f65eafe453$var$rsFitz + ')|' + $085935f65eafe453$var$rsSymbol + $085935f65eafe453$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $085935f65eafe453$var$unicodeToArray(string) {
    return string.match($085935f65eafe453$var$reUnicode) || [];
}
$085935f65eafe453$exports = $085935f65eafe453$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $fd3334a765a32136$var$stringToArray(string) {
    return $32VMC(string) ? $085935f65eafe453$exports(string) : $160ed8c5ee11e437$exports(string);
}
module.exports = $fd3334a765a32136$var$stringToArray;

});

parcelRegister("7sObp", function(module, exports) {
$parcel$export(module.exports, "default", () => $56f2133c4d537e8d$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $56f2133c4d537e8d$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("3pfAb", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("7l88B")).default);
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("k7eoe")).FabricChannel);

var $7l88B = parcelRequire("7l88B");


var $cCg1W = parcelRequire("cCg1W");


var $k7eoe = parcelRequire("k7eoe");


});

parcelRegister("k7eoe", function(module, exports) {
var $12953c8cc50d9b6a$export$8faa0b115ef0268b = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    FabricChannel["omniChannel"] = "omniChannel";
    FabricChannel["townsquareHome"] = "townsquareHome";
    FabricChannel["rovoExtension"] = "rovoExtension";
    return FabricChannel;
}({});
module.exports["FabricChannel"] = $12953c8cc50d9b6a$export$8faa0b115ef0268b;

});

parcelRegister("hpRUx", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jkoRA"));

});

parcelRegister("jkoRA", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $e1232be890059ab0$export$bf730a2d8bf68b42, (v) => $e1232be890059ab0$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e1232be890059ab0$export$bf730a2d8bf68b42;
"use strict";

var $42omo = parcelRequire("42omo");


var $hxT4C = parcelRequire("hxT4C");

function $e1232be890059ab0$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $e1232be890059ab0$var$objectIs = "function" === typeof Object.is ? Object.is : $e1232be890059ab0$var$is, $e1232be890059ab0$var$useSyncExternalStore = $hxT4C.useSyncExternalStore, $e1232be890059ab0$var$useRef = $42omo.useRef, $e1232be890059ab0$var$useEffect = $42omo.useEffect, $e1232be890059ab0$var$useMemo = $42omo.useMemo, $e1232be890059ab0$var$useDebugValue = $42omo.useDebugValue;
$e1232be890059ab0$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $e1232be890059ab0$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $e1232be890059ab0$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($e1232be890059ab0$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $e1232be890059ab0$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $e1232be890059ab0$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $e1232be890059ab0$var$useDebugValue(value);
    return value;
};

});

parcelRegister("bRSdj", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $8z9j5 = parcelRequire("8z9j5");


var $fwSE5 = parcelRequire("fwSE5");


var $9NuSR = parcelRequire("9NuSR");





var $hY0xh = parcelRequire("hY0xh");


var $fFa3V = parcelRequire("fFa3V");


var $a9dFP = parcelRequire("a9dFP");


var $ajqJ5 = parcelRequire("ajqJ5");

const $06d4924e4f58c3fc$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $06d4924e4f58c3fc$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $a9dFP.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $06d4924e4f58c3fc$var$darkModeMql = $06d4924e4f58c3fc$var$isMatchMediaAvailable && window.matchMedia((0, $ajqJ5.darkModeMediaQuery));
class $06d4924e4f58c3fc$var$ColorModeObserver {
    getColorMode() {
        if (!$06d4924e4f58c3fc$var$darkModeMql) return 'light';
        return $06d4924e4f58c3fc$var$darkModeMql?.matches ? 'dark' : 'light';
    }
    bind() {
        if ($06d4924e4f58c3fc$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $fFa3V.bind)($06d4924e4f58c3fc$var$darkModeMql, {
            type: 'change',
            listener: $06d4924e4f58c3fc$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $06d4924e4f58c3fc$var$SingletonColorModeObserver = new $06d4924e4f58c3fc$var$ColorModeObserver();
var $06d4924e4f58c3fc$export$2e2bcd8739ae039 = $06d4924e4f58c3fc$var$SingletonColorModeObserver;











const $0a87d142ec6e5dd5$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $0a87d142ec6e5dd5$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $a9dFP.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $0a87d142ec6e5dd5$var$contrastModeMql = $0a87d142ec6e5dd5$var$isMatchMediaAvailable && window.matchMedia((0, $ajqJ5.moreContrastMediaQuery));
class $0a87d142ec6e5dd5$var$ContrastModeObserver {
    getContrastMode() {
        if (!$0a87d142ec6e5dd5$var$contrastModeMql) return 'no-preference';
        return $0a87d142ec6e5dd5$var$contrastModeMql?.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($0a87d142ec6e5dd5$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $fFa3V.bind)($0a87d142ec6e5dd5$var$contrastModeMql, {
            type: 'change',
            listener: $0a87d142ec6e5dd5$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $0a87d142ec6e5dd5$var$SingletonContrastModeObserver = new $0a87d142ec6e5dd5$var$ContrastModeObserver();
var $0a87d142ec6e5dd5$export$2e2bcd8739ae039 = $0a87d142ec6e5dd5$var$SingletonContrastModeObserver;


function $64f73cf756421a81$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $06d4924e4f58c3fc$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $06d4924e4f58c3fc$export$2e2bcd8739ae039).bind();
    } else (0, $06d4924e4f58c3fc$export$2e2bcd8739ae039).unbind();
    if ((0, $dh538.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $0a87d142ec6e5dd5$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $0a87d142ec6e5dd5$export$2e2bcd8739ae039).bind();
        } else (0, $0a87d142ec6e5dd5$export$2e2bcd8739ae039).unbind();
    }
    const themeAttributes = (0, $hY0xh.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $06d4924e4f58c3fc$export$2e2bcd8739ae039).unbind();
        if ((0, $dh538.fg)('platform_increased-contrast-themes')) (0, $0a87d142ec6e5dd5$export$2e2bcd8739ae039).unbind();
    };
}



var $4icxs = parcelRequire("4icxs");


var $1oKVt = parcelRequire("1oKVt");





/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $e70f44cacbaf4963$var$setGlobalTheme = async (nextThemeState = {}, themeLoader)=>{
    let { colorMode: colorMode = (0, $fwSE5.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $fwSE5.themeStateDefaults)['contrastMode'], dark: dark = (0, $fwSE5.themeStateDefaults)['dark'], light: light = (0, $fwSE5.themeStateDefaults)['light'], shape: shape = (0, $fwSE5.themeStateDefaults)['shape'], spacing: spacing = (0, $fwSE5.themeStateDefaults)['spacing'], typography: typography = (0, $fwSE5.themeStateDefaults)['typography'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $fwSE5.themeStateDefaults)['UNSAFE_themeOptions'] } = typeof nextThemeState === 'function' ? nextThemeState({
        ...(0, $fwSE5.themeStateDefaults),
        typography: (0, $fwSE5.themeStateDefaults)['typography'](),
        ...(0, $8z9j5.default)()
    }) : nextThemeState;
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $dh538.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    let themePreferences = (0, $1oKVt.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $ajqJ5.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $9NuSR.isValidBrandHex)(UNSAFE_themeOptions?.brandColor)) {
        const mode = colorMode || (0, $fwSE5.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $4icxs.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("5jDN5"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    const themeOverridePreferences = (0, $1oKVt.getThemeOverridePreferences)(themeState);
    for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    const autoUnbind = (0, $64f73cf756421a81$export$2e2bcd8739ae039)(themeState);
    return autoUnbind;
};
var $e70f44cacbaf4963$export$2e2bcd8739ae039 = $e70f44cacbaf4963$var$setGlobalTheme;
module.exports["default"] = $e70f44cacbaf4963$export$2e2bcd8739ae039;

});

parcelRegister("bCMS0", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $876926dfe2431ebd$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $876926dfe2431ebd$var$baseClamp;

});

parcelRegister("ehlgT", function(module, exports) {

var $h86W2 = parcelRequire("h86W2");

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $a65327488841282e$var$toInteger(value) {
    var result = $h86W2(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $a65327488841282e$var$toInteger;

});

parcelRegister("h86W2", function(module, exports) {

var $abOaY = parcelRequire("abOaY");

/** Used as references for various `Number` constants. */ var $c788902bb672fe63$var$INFINITY = 1 / 0, $c788902bb672fe63$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $c788902bb672fe63$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $abOaY(value);
    if (value === $c788902bb672fe63$var$INFINITY || value === -$c788902bb672fe63$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $c788902bb672fe63$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $c788902bb672fe63$var$toFinite;

});

parcelRegister("99uSl", function(module, exports) {
$parcel$export(module.exports, "createStore", () => (parcelRequire("k5Cbm")).default);

var $k5Cbm = parcelRequire("k5Cbm");


var $dr3FA = parcelRequire("dr3FA");


var $kVUld = parcelRequire("kVUld");


var $7r3UO = parcelRequire("7r3UO");


var $lRjVN = parcelRequire("lRjVN");

parcelRequire("eOnB8");

/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/ function $6a9ce78b4cf413f5$var$isCrushed() {}

});

parcelRegister("irOoi", function(module, exports) {
/**
 * Relay v0.0.0-main-6ff96079
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("4uoyH"));

});

parcelRegister("4uoyH", function(module, exports) {
'use strict';

var $f8mcb = parcelRequire("f8mcb");

var $1805fc819b1afdb5$exports = {};
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $1805fc819b1afdb5$var$_interopRequireDefault = $eGvGZ.default;

var $1805fc819b1afdb5$var$_extends2 = $1805fc819b1afdb5$var$_interopRequireDefault((parcelRequire("fLNXX")));

var $1805fc819b1afdb5$var$_objectWithoutPropertiesLoose2 = $1805fc819b1afdb5$var$_interopRequireDefault((parcelRequire("6Ahnn")));

var $1805fc819b1afdb5$var$_assertThisInitialized2 = $1805fc819b1afdb5$var$_interopRequireDefault((parcelRequire("gurtx")));

var $1805fc819b1afdb5$var$_inheritsLoose2 = $1805fc819b1afdb5$var$_interopRequireDefault((parcelRequire("lNM3R")));

var $1805fc819b1afdb5$var$_defineProperty2 = $1805fc819b1afdb5$var$_interopRequireDefault((parcelRequire("l2SD1")));
var $1805fc819b1afdb5$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];
var $c10a0a355ace0c0c$exports = {};
'use strict';



var $c10a0a355ace0c0c$var$_interopRequireDefault = $eGvGZ.default;

var $c10a0a355ace0c0c$var$_extends2 = $c10a0a355ace0c0c$var$_interopRequireDefault((parcelRequire("fLNXX")));
var $dc0bb7104bd0e7bc$exports = {};
'use strict';

var $q03Nf = parcelRequire("q03Nf");

function $dc0bb7104bd0e7bc$var$assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === 'object') && $q03Nf(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === 'object' || typeof fragment === 'function')) && $q03Nf(false);
    }
}
$dc0bb7104bd0e7bc$exports = $dc0bb7104bd0e7bc$var$assertFragmentMap;


var $ab97928a32c98123$exports = {};
'use strict';
function $ab97928a32c98123$var$getComponentName(component) {
    return component.displayName || component.name || 'Component';
}
function $ab97928a32c98123$var$getContainerName(Component) {
    return 'Relay(' + $ab97928a32c98123$var$getComponentName(Component) + ')';
}
$ab97928a32c98123$exports = {
    getComponentName: $ab97928a32c98123$var$getComponentName,
    getContainerName: $ab97928a32c98123$var$getContainerName
};


var $c10a0a355ace0c0c$var$getComponentName = $ab97928a32c98123$exports.getComponentName, $c10a0a355ace0c0c$var$getContainerName = $ab97928a32c98123$exports.getContainerName;



var $2496516b09e14df5$exports = {};
'use strict';

var $42omo = parcelRequire("42omo");

$2496516b09e14df5$exports = $42omo.createContext({
    rootIsQueryRenderer: false
});









var $3e6Uc = parcelRequire("3e6Uc");

var $c10a0a355ace0c0c$var$getFragment = $3e6Uc.getFragment;
var $c10a0a355ace0c0c$var$useContext = $42omo.useContext;
function $c10a0a355ace0c0c$var$buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = $c10a0a355ace0c0c$var$getContainerName(ComponentClass);
    $dc0bb7104bd0e7bc$exports($c10a0a355ace0c0c$var$getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = $c10a0a355ace0c0c$var$getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
        var _queryRendererContext;
        var context = $c10a0a355ace0c0c$var$useContext($f8mcb);
        !(context != null) && $q03Nf(false);
        var queryRendererContext = $c10a0a355ace0c0c$var$useContext($2496516b09e14df5$exports);
        return /*#__PURE__*/ $42omo.createElement(Container, (0, $c10a0a355ace0c0c$var$_extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = $42omo.forwardRef(ForwardRef);
    return ForwardContainer;
}
$c10a0a355ace0c0c$exports = $c10a0a355ace0c0c$var$buildReactRelayContainer;



var $1805fc819b1afdb5$var$getContainerName = $ab97928a32c98123$exports.getContainerName;
var $0cda9a0821493e9f$exports = {};
'use strict';
var $74fa2fd77d94bd94$exports = {};
'use strict';
function $74fa2fd77d94bd94$var$isRelayEnvironment(environment) {
    return typeof environment === 'object' && environment !== null && typeof environment.check === 'function' && typeof environment.lookup === 'function' && typeof environment.retain === 'function' && typeof environment.execute === 'function' && typeof environment.subscribe === 'function';
}
$74fa2fd77d94bd94$exports = $74fa2fd77d94bd94$var$isRelayEnvironment;





function $0cda9a0821493e9f$var$assertRelayContext(relay) {
    !$0cda9a0821493e9f$var$isRelayContext(relay) && $q03Nf(false);
    return relay;
}
function $0cda9a0821493e9f$var$isRelayContext(context) {
    return typeof context === 'object' && context !== null && !Array.isArray(context) && $74fa2fd77d94bd94$exports(context.environment);
}
$0cda9a0821493e9f$exports = {
    assertRelayContext: $0cda9a0821493e9f$var$assertRelayContext,
    isRelayContext: $0cda9a0821493e9f$var$isRelayContext
};


var $1805fc819b1afdb5$var$assertRelayContext = $0cda9a0821493e9f$exports.assertRelayContext;

var $8w3GE = parcelRequire("8w3GE");







var $1805fc819b1afdb5$var$createFragmentSpecResolver = $3e6Uc.createFragmentSpecResolver, $1805fc819b1afdb5$var$getDataIDsFromObject = $3e6Uc.getDataIDsFromObject, $1805fc819b1afdb5$var$isScalarAndEqual = $3e6Uc.isScalarAndEqual;
function $1805fc819b1afdb5$var$createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = $1805fc819b1afdb5$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $1805fc819b1afdb5$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $1805fc819b1afdb5$var$_defineProperty2["default"])((0, $1805fc819b1afdb5$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: $1805fc819b1afdb5$var$getRelayProp(updatedState.relayProp.environment)
                    } : null;
                });
            });
            var relayContext = $1805fc819b1afdb5$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            var resolver = $1805fc819b1afdb5$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: $1805fc819b1afdb5$var$getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $1805fc819b1afdb5$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $1805fc819b1afdb5$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $1805fc819b1afdb5$var$getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$8w3GE(prevIDs, nextIDs)) {
                resolver = $1805fc819b1afdb5$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevPropsContext: relayContext,
                    prevProps: nextProps,
                    relayProp: $1805fc819b1afdb5$var$getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $1805fc819b1afdb5$var$getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$1805fc819b1afdb5$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $1805fc819b1afdb5$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $1805fc819b1afdb5$var$_excluded);
            return /*#__PURE__*/ $42omo.createElement(Component, (0, $1805fc819b1afdb5$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }($42omo.Component), (0, $1805fc819b1afdb5$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $1805fc819b1afdb5$var$getRelayProp(environment) {
    return {
        environment: environment
    };
}
function $1805fc819b1afdb5$var$createContainer(Component, fragmentSpec) {
    return $c10a0a355ace0c0c$exports(Component, fragmentSpec, $1805fc819b1afdb5$var$createContainerWithFragments);
}
$1805fc819b1afdb5$exports = {
    createContainer: $1805fc819b1afdb5$var$createContainer
};


var $d3c1d0415f47021f$exports = {};
'use strict';













var $d3c1d0415f47021f$var$createOperationDescriptor = $3e6Uc.createOperationDescriptor, $d3c1d0415f47021f$var$deepFreeze = $3e6Uc.deepFreeze, $d3c1d0415f47021f$var$getRequest = $3e6Uc.getRequest;
var $d3c1d0415f47021f$var$useLayoutEffect = $42omo.useLayoutEffect, $d3c1d0415f47021f$var$useState = $42omo.useState, $d3c1d0415f47021f$var$useRef = $42omo.useRef, $d3c1d0415f47021f$var$useMemo = $42omo.useMemo;
var $d3c1d0415f47021f$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
function $d3c1d0415f47021f$var$useDeepCompare(value) {
    var latestValue = $42omo.useRef(value);
    if (!$8w3GE(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function $d3c1d0415f47021f$var$ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = $d3c1d0415f47021f$var$useDeepCompare(variables);
    var operation = $d3c1d0415f47021f$var$useMemo(function() {
        var request = $d3c1d0415f47021f$var$getRequest(query);
        return $d3c1d0415f47021f$var$createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = $d3c1d0415f47021f$var$useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    var dataRef = $d3c1d0415f47021f$var$useRef(null);
    var _useState = $d3c1d0415f47021f$var$useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = $d3c1d0415f47021f$var$useRef(null);
    var snapshot = $d3c1d0415f47021f$var$useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    $d3c1d0415f47021f$var$useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ $42omo.createElement($f8mcb.Provider, {
        value: relayContext
    }, /*#__PURE__*/ $42omo.createElement($2496516b09e14df5$exports.Provider, {
        value: $d3c1d0415f47021f$var$queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
$d3c1d0415f47021f$exports = $d3c1d0415f47021f$var$ReactRelayLocalQueryRenderer;


var $cd554001552bb350$exports = {};
'use strict';



var $cd554001552bb350$var$_interopRequireDefault = $eGvGZ.default;

var $cd554001552bb350$var$_extends2 = $cd554001552bb350$var$_interopRequireDefault((parcelRequire("fLNXX")));

var $cd554001552bb350$var$_objectWithoutPropertiesLoose2 = $cd554001552bb350$var$_interopRequireDefault((parcelRequire("6Ahnn")));

var $cd554001552bb350$var$_assertThisInitialized2 = $cd554001552bb350$var$_interopRequireDefault((parcelRequire("gurtx")));

var $cd554001552bb350$var$_inheritsLoose2 = $cd554001552bb350$var$_interopRequireDefault((parcelRequire("lNM3R")));

var $cd554001552bb350$var$_defineProperty2 = $cd554001552bb350$var$_interopRequireDefault((parcelRequire("l2SD1")));

var $cd554001552bb350$var$_objectSpread3 = $cd554001552bb350$var$_interopRequireDefault((parcelRequire("6g2zv")));
var $cd554001552bb350$var$_excluded = [
    "componentRef"
], $cd554001552bb350$var$_excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], $cd554001552bb350$var$_excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $5dd23818955297f1$exports = {};
'use strict';



var $5dd23818955297f1$var$_interopRequireDefault = $eGvGZ.default;

var $5dd23818955297f1$var$_objectSpread2 = $5dd23818955297f1$var$_interopRequireDefault((parcelRequire("6g2zv")));



var $5dd23818955297f1$var$getSelector = $3e6Uc.getSelector;
function $5dd23818955297f1$var$getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = $5dd23818955297f1$var$getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === 'PluralReaderSelector' ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, $5dd23818955297f1$var$_objectSpread2["default"])((0, $5dd23818955297f1$var$_objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
$5dd23818955297f1$exports = $5dd23818955297f1$var$getRootVariablesForFragments;



var $cd554001552bb350$var$getComponentName = $ab97928a32c98123$exports.getComponentName, $cd554001552bb350$var$getContainerName = $ab97928a32c98123$exports.getContainerName;



var $f3308b4a79a8dc97$exports = {};
'use strict';



var $f3308b4a79a8dc97$var$_interopRequireDefault = $eGvGZ.default;

var $f3308b4a79a8dc97$var$_defineProperty2 = $f3308b4a79a8dc97$var$_interopRequireDefault((parcelRequire("l2SD1")));






var $f3308b4a79a8dc97$var$fetchQuery = $3e6Uc.__internal.fetchQuery, $f3308b4a79a8dc97$var$createOperationDescriptor = $3e6Uc.createOperationDescriptor, $f3308b4a79a8dc97$var$isRelayModernEnvironment = $3e6Uc.isRelayModernEnvironment;
var $f3308b4a79a8dc97$var$ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, $f3308b4a79a8dc97$var$_defineProperty2["default"])(this, "_selectionReferences", []);
        (0, $f3308b4a79a8dc97$var$_defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === 'store-and-network' || fetchPolicy === 'store-or-network') {
            if (environment.check(operation).status === 'available') {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!$f3308b4a79a8dc97$var$isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return $f3308b4a79a8dc97$var$fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && $q03Nf(false);
        if (typeof onDataChange === 'function') {
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? $f3308b4a79a8dc97$var$createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                _this2._didFetchFinish = true;
                _this2._error = null;
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && $q03Nf(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && $q03Nf(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
$f3308b4a79a8dc97$exports = $f3308b4a79a8dc97$var$ReactRelayQueryFetcher;



var $cd554001552bb350$var$assertRelayContext = $0cda9a0821493e9f$exports.assertRelayContext;












var $cd554001552bb350$var$ConnectionInterface = $3e6Uc.ConnectionInterface, $cd554001552bb350$var$Observable = $3e6Uc.Observable, $cd554001552bb350$var$RelayFeatureFlags = $3e6Uc.RelayFeatureFlags, $cd554001552bb350$var$createFragmentSpecResolver = $3e6Uc.createFragmentSpecResolver, $cd554001552bb350$var$createOperationDescriptor = $3e6Uc.createOperationDescriptor, $cd554001552bb350$var$getDataIDsFromObject = $3e6Uc.getDataIDsFromObject, $cd554001552bb350$var$getRequest = $3e6Uc.getRequest, $cd554001552bb350$var$getVariablesFromObject = $3e6Uc.getVariablesFromObject, $cd554001552bb350$var$isScalarAndEqual = $3e6Uc.isScalarAndEqual;
parcelRequire("eEWwZ");

var $cd554001552bb350$var$FORWARD = 'forward';
function $cd554001552bb350$var$createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && $q03Nf(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || typeof data !== 'object') return null;
            data = data[path[i]];
        }
        return data;
    };
}
function $cd554001552bb350$var$createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && $q03Nf(false);
    return function(prevVars, totalCount) {
        return (0, $cd554001552bb350$var$_objectSpread3["default"])((0, $cd554001552bb350$var$_objectSpread3["default"])({}, prevVars), {}, (0, $cd554001552bb350$var$_defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function $cd554001552bb350$var$findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && $q03Nf(false);
            !!foundConnectionMetadata && $q03Nf(false);
            foundConnectionMetadata = (0, $cd554001552bb350$var$_objectSpread3["default"])((0, $cd554001552bb350$var$_objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && $q03Nf(false);
    return foundConnectionMetadata || {};
}
function $cd554001552bb350$var$toObserver(observerOrCallback) {
    return typeof observerOrCallback === 'function' ? {
        error: observerOrCallback,
        complete: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === 'function' && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function $cd554001552bb350$var$createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = $cd554001552bb350$var$getComponentName(Component);
    var containerName = $cd554001552bb350$var$getContainerName(Component);
    var metadata = $cd554001552bb350$var$findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || $cd554001552bb350$var$createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && $q03Nf(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || $cd554001552bb350$var$createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $cd554001552bb350$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $cd554001552bb350$var$_defineProperty2["default"])((0, $cd554001552bb350$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, $cd554001552bb350$var$_defineProperty2["default"])((0, $cd554001552bb350$var$_assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, $cd554001552bb350$var$_defineProperty2["default"])((0, $cd554001552bb350$var$_assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, $cd554001552bb350$var$_defineProperty2["default"])((0, $cd554001552bb350$var$_assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage('refetchConnection')) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, $cd554001552bb350$var$toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, $cd554001552bb350$var$_defineProperty2["default"])((0, $cd554001552bb350$var$_assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage('loadMore')) return {
                    dispose: function dispose() {}
                };
                var observer = $cd554001552bb350$var$toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    $cd554001552bb350$var$Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = $cd554001552bb350$var$ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = $cd554001552bb350$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if ($cd554001552bb350$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = $cd554001552bb350$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = $cd554001552bb350$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                contextForChildren: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if ($cd554001552bb350$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($cd554001552bb350$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = $cd554001552bb350$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $cd554001552bb350$var$getDataIDsFromObject(fragments, this.props);
            var nextIDs = $cd554001552bb350$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $5dd23818955297f1$exports(fragments, this.props);
            var nextRootVariables = $5dd23818955297f1$exports(fragments, nextProps);
            if (relayContext.environment !== this.state.prevContext.environment || !$8w3GE(prevRootVariables, nextRootVariables) || !$8w3GE(prevIDs, nextIDs)) {
                this._cleanup();
                if ($cd554001552bb350$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = $cd554001552bb350$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = $cd554001552bb350$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        prevContext: relayContext,
                        contextForChildren: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$cd554001552bb350$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection,
                environment: relayContext.environment
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getConnectionData = function _getConnectionData() {
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, $cd554001552bb350$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $cd554001552bb350$var$_excluded);
            var props = (0, $cd554001552bb350$var$_objectSpread3["default"])((0, $cd554001552bb350$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = $cd554001552bb350$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !(typeof connectionData === 'object') && $q03Nf(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && $q03Nf(false);
            !(typeof pageInfo === 'object') && $q03Nf(false);
            var hasMore = direction === $cd554001552bb350$var$FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === $cd554001552bb350$var$FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== 'boolean' || edges.length !== 0 && typeof cursor === 'undefined') return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $f3308b4a79a8dc97$exports();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = $cd554001552bb350$var$assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, $cd554001552bb350$var$_objectWithoutPropertiesLoose2["default"])(_this$props2, $cd554001552bb350$var$_excluded2);
            var props = (0, $cd554001552bb350$var$_objectSpread3["default"])((0, $cd554001552bb350$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = $5dd23818955297f1$exports(fragments, restProps);
            fragmentVariables = $cd554001552bb350$var$getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, $cd554001552bb350$var$_objectSpread3["default"])((0, $cd554001552bb350$var$_objectSpread3["default"])((0, $cd554001552bb350$var$_objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !(typeof fetchVariables === 'object' && fetchVariables !== null) && $q03Nf(false);
            fetchVariables = (0, $cd554001552bb350$var$_objectSpread3["default"])((0, $cd554001552bb350$var$_objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, $cd554001552bb350$var$_objectSpread3["default"])((0, $cd554001552bb350$var$_objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = $cd554001552bb350$var$getRequest(connectionConfig.query);
            var operation = $cd554001552bb350$var$createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                if (!$8w3GE(prevData, nextData)) _this3.setState({
                    data: nextData,
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    }
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return $cd554001552bb350$var$Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next();
                        sink.complete();
                    });
                });
            })["do"]({
                error: cleanup,
                complete: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, $cd554001552bb350$var$_objectWithoutPropertiesLoose2["default"])(_this$props3, $cd554001552bb350$var$_excluded3);
            return /*#__PURE__*/ $42omo.createElement($f8mcb.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ $42omo.createElement(Component, (0, $cd554001552bb350$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }($42omo.Component), (0, $cd554001552bb350$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $cd554001552bb350$var$createContainer(Component, fragmentSpec, connectionConfig) {
    return $c10a0a355ace0c0c$exports(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $cd554001552bb350$var$createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
$cd554001552bb350$exports = {
    createContainer: $cd554001552bb350$var$createContainer
};


var $af9f233856ec81f7$exports = {};
'use strict';



var $af9f233856ec81f7$var$_interopRequireDefault = $eGvGZ.default;

var $af9f233856ec81f7$var$_objectSpread2 = $af9f233856ec81f7$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $af9f233856ec81f7$var$_assertThisInitialized2 = $af9f233856ec81f7$var$_interopRequireDefault((parcelRequire("gurtx")));

var $af9f233856ec81f7$var$_inheritsLoose2 = $af9f233856ec81f7$var$_interopRequireDefault((parcelRequire("lNM3R")));

var $af9f233856ec81f7$var$_defineProperty2 = $af9f233856ec81f7$var$_interopRequireDefault((parcelRequire("l2SD1")));














var $af9f233856ec81f7$var$createOperationDescriptor = $3e6Uc.createOperationDescriptor, $af9f233856ec81f7$var$deepFreeze = $3e6Uc.deepFreeze, $af9f233856ec81f7$var$getRequest = $3e6Uc.getRequest;
var $af9f233856ec81f7$var$requestCache = {};
var $af9f233856ec81f7$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
var $af9f233856ec81f7$var$ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, $af9f233856ec81f7$var$_inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        (0, $af9f233856ec81f7$var$_defineProperty2["default"])((0, $af9f233856ec81f7$var$_assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $af9f233856ec81f7$var$requestCache[prevRequestCacheKey];
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: $af9f233856ec81f7$var$getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = $af9f233856ec81f7$var$getRequest(query);
            requestCacheKey = $af9f233856ec81f7$var$getRequestCacheKey(request.params, props.variables);
            queryFetcher = $af9f233856ec81f7$var$requestCache[requestCacheKey] ? $af9f233856ec81f7$var$requestCache[requestCacheKey].queryFetcher : new $f3308b4a79a8dc97$exports();
        } else queryFetcher = new $f3308b4a79a8dc97$exports();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, $af9f233856ec81f7$var$_objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, $af9f233856ec81f7$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !$8w3GE(prevState.prevPropsVariables, nextProps.variables)) return $af9f233856ec81f7$var$resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            this._maybeHiddenOrFastRefresh = false;
            this.setState(function(prevState) {
                var newState = $af9f233856ec81f7$var$resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && $af9f233856ec81f7$var$requestCache[requestCacheKey] != null) queryFetcher.setOnDataChange(_this2._handleDataChange);
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        if (requestCacheKey) delete $af9f233856ec81f7$var$requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $af9f233856ec81f7$var$requestCache[prevRequestCacheKey];
                return {
                    renderProps: $af9f233856ec81f7$var$getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete $af9f233856ec81f7$var$requestCache[requestCacheKey];
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ $42omo.createElement($f8mcb.Provider, {
            value: relayContext
        }, /*#__PURE__*/ $42omo.createElement($2496516b09e14df5$exports.Provider, {
            value: $af9f233856ec81f7$var$queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}($42omo.Component);
function $af9f233856ec81f7$var$getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        retry: null
    };
}
function $af9f233856ec81f7$var$getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        retry: null
    };
}
function $af9f233856ec81f7$var$getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === 'function') retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === 'function') retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function $af9f233856ec81f7$var$getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function $af9f233856ec81f7$var$resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = $af9f233856ec81f7$var$getRequest(query);
        var requestCacheKey = $af9f233856ec81f7$var$getRequestCacheKey(request.params, props.variables);
        queryFetcher = $af9f233856ec81f7$var$requestCache[requestCacheKey] ? $af9f233856ec81f7$var$requestCache[requestCacheKey].queryFetcher : new $f3308b4a79a8dc97$exports(prevSelectionReferences);
    } else queryFetcher = new $f3308b4a79a8dc97$exports(prevSelectionReferences);
    return (0, $af9f233856ec81f7$var$_objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, $af9f233856ec81f7$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function $af9f233856ec81f7$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = $af9f233856ec81f7$var$getRequest(query);
        var operation = $af9f233856ec81f7$var$createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === 'string' && $af9f233856ec81f7$var$requestCache[requestCacheKey]) {
            var snapshot = $af9f233856ec81f7$var$requestCache[requestCacheKey].snapshot;
            if (snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $af9f233856ec81f7$var$getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else return {
                error: null,
                relayContext: relayContext,
                renderProps: $af9f233856ec81f7$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            var _snapshot = querySnapshot || storeSnapshot;
            requestCacheKey = requestCacheKey || $af9f233856ec81f7$var$getRequestCacheKey(request.params, props.variables);
            $af9f233856ec81f7$var$requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $af9f233856ec81f7$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $af9f233856ec81f7$var$getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: $af9f233856ec81f7$var$getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: $af9f233856ec81f7$var$getEmptyRenderProps(),
            requestCacheKey: null
        };
    }
}
$af9f233856ec81f7$exports = $af9f233856ec81f7$var$ReactRelayQueryRenderer;


var $099896940ddf30b7$exports = {};
'use strict';



var $099896940ddf30b7$var$_interopRequireDefault = $eGvGZ.default;

var $099896940ddf30b7$var$_extends2 = $099896940ddf30b7$var$_interopRequireDefault((parcelRequire("fLNXX")));

var $099896940ddf30b7$var$_objectWithoutPropertiesLoose2 = $099896940ddf30b7$var$_interopRequireDefault((parcelRequire("6Ahnn")));

var $099896940ddf30b7$var$_objectSpread2 = $099896940ddf30b7$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $099896940ddf30b7$var$_assertThisInitialized2 = $099896940ddf30b7$var$_interopRequireDefault((parcelRequire("gurtx")));

var $099896940ddf30b7$var$_inheritsLoose2 = $099896940ddf30b7$var$_interopRequireDefault((parcelRequire("lNM3R")));

var $099896940ddf30b7$var$_defineProperty2 = $099896940ddf30b7$var$_interopRequireDefault((parcelRequire("l2SD1")));
var $099896940ddf30b7$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];



var $099896940ddf30b7$var$getContainerName = $ab97928a32c98123$exports.getContainerName;





var $099896940ddf30b7$var$assertRelayContext = $0cda9a0821493e9f$exports.assertRelayContext;









var $099896940ddf30b7$var$Observable = $3e6Uc.Observable, $099896940ddf30b7$var$createFragmentSpecResolver = $3e6Uc.createFragmentSpecResolver, $099896940ddf30b7$var$createOperationDescriptor = $3e6Uc.createOperationDescriptor, $099896940ddf30b7$var$getDataIDsFromObject = $3e6Uc.getDataIDsFromObject, $099896940ddf30b7$var$getRequest = $3e6Uc.getRequest, $099896940ddf30b7$var$getVariablesFromObject = $3e6Uc.getVariablesFromObject, $099896940ddf30b7$var$isScalarAndEqual = $3e6Uc.isScalarAndEqual;
parcelRequire("eEWwZ");

function $099896940ddf30b7$var$createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = $099896940ddf30b7$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $099896940ddf30b7$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $099896940ddf30b7$var$_defineProperty2["default"])((0, $099896940ddf30b7$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null;
                });
            });
            (0, $099896940ddf30b7$var$_defineProperty2["default"])((0, $099896940ddf30b7$var$_assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = $099896940ddf30b7$var$assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = $5dd23818955297f1$exports(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === 'function' ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, $099896940ddf30b7$var$_objectSpread2["default"])((0, $099896940ddf30b7$var$_objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, $099896940ddf30b7$var$_objectSpread2["default"])((0, $099896940ddf30b7$var$_objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === 'function' ? {
                    next: observerOrCallback,
                    error: observerOrCallback
                } : observerOrCallback || {};
                var query = $099896940ddf30b7$var$getRequest(taggedNode);
                var operation = $099896940ddf30b7$var$createOperationDescriptor(query, fetchVariables, cacheConfig);
                _this.state.localVariables = fetchVariables;
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            data: latestState.resolver.resolve(),
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            }
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return $099896940ddf30b7$var$Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                data: latestState.resolver.resolve(),
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                }
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, $099896940ddf30b7$var$_objectSpread2["default"])((0, $099896940ddf30b7$var$_objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = $099896940ddf30b7$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            var resolver = $099896940ddf30b7$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                contextForChildren: relayContext,
                relayProp: $099896940ddf30b7$var$getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $099896940ddf30b7$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $099896940ddf30b7$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $099896940ddf30b7$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $5dd23818955297f1$exports(fragments, prevProps);
            var nextRootVariables = $5dd23818955297f1$exports(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$8w3GE(prevRootVariables, nextRootVariables) || !$8w3GE(prevIDs, nextIDs)) {
                resolver = $099896940ddf30b7$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    contextForChildren: relayContext,
                    relayProp: $099896940ddf30b7$var$getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$099896940ddf30b7$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return $099896940ddf30b7$var$getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $f3308b4a79a8dc97$exports();
            return this._queryFetcher;
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $099896940ddf30b7$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $099896940ddf30b7$var$_excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ $42omo.createElement($f8mcb.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ $42omo.createElement(Component, (0, $099896940ddf30b7$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }($42omo.Component), (0, $099896940ddf30b7$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $099896940ddf30b7$var$getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
function $099896940ddf30b7$var$createContainer(Component, fragmentSpec, taggedNode) {
    return $c10a0a355ace0c0c$exports(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $099896940ddf30b7$var$createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
$099896940ddf30b7$exports = {
    createContainer: $099896940ddf30b7$var$createContainer
};



var $8Vn7T = parcelRequire("8Vn7T");


var $6Zkil = parcelRequire("6Zkil");


var $6jBTV = parcelRequire("6jBTV");

var $344d0397310d198f$var$loadQuery = $6jBTV.loadQuery;

var $c2Tw9 = parcelRequire("c2Tw9");


var $i42kM = parcelRequire("i42kM");

var $def41498113b1b2a$exports = {};
'use strict';



var $def41498113b1b2a$var$_interopRequireDefault = $eGvGZ.default;

var $def41498113b1b2a$var$_objectSpread2 = $def41498113b1b2a$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $a5rI4 = parcelRequire("a5rI4");

function $def41498113b1b2a$var$useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return $a5rI4(query, variables, (0, $def41498113b1b2a$var$_objectSpread2["default"])((0, $def41498113b1b2a$var$_objectSpread2["default"])({}, options), {}, {
        fetchPolicy: 'store-only'
    }));
}
$def41498113b1b2a$exports = $def41498113b1b2a$var$useClientQuery;



var $5RqGi = parcelRequire("5RqGi");


var $5RO7w = parcelRequire("5RO7w");





var $edz3c = parcelRequire("edz3c");


var $aUuHB = parcelRequire("aUuHB");


var $j2uow = parcelRequire("j2uow");


var $2g3bG = parcelRequire("2g3bG");


var $eDK61 = parcelRequire("eDK61");


var $amoBB = parcelRequire("amoBB");


var $dPWxj = parcelRequire("dPWxj");


var $4H2Ae = parcelRequire("4H2Ae");




module.exports = {
    ConnectionHandler: $3e6Uc.ConnectionHandler,
    QueryRenderer: $af9f233856ec81f7$exports,
    LocalQueryRenderer: $d3c1d0415f47021f$exports,
    MutationTypes: $3e6Uc.MutationTypes,
    RangeOperations: $3e6Uc.RangeOperations,
    ReactRelayContext: $f8mcb,
    applyOptimisticMutation: $3e6Uc.applyOptimisticMutation,
    commitLocalUpdate: $3e6Uc.commitLocalUpdate,
    commitMutation: $3e6Uc.commitMutation,
    createFragmentContainer: $1805fc819b1afdb5$exports.createContainer,
    createPaginationContainer: $cd554001552bb350$exports.createContainer,
    createRefetchContainer: $099896940ddf30b7$exports.createContainer,
    fetchQuery_DEPRECATED: $3e6Uc.fetchQuery_DEPRECATED,
    graphql: $3e6Uc.graphql,
    readInlineData: $3e6Uc.readInlineData,
    requestSubscription: $3e6Uc.requestSubscription,
    EntryPointContainer: $8Vn7T,
    RelayEnvironmentProvider: $i42kM,
    ProfilerContext: $c2Tw9,
    fetchQuery: $3e6Uc.fetchQuery,
    loadQuery: $344d0397310d198f$var$loadQuery,
    loadEntryPoint: $6Zkil,
    useClientQuery: $def41498113b1b2a$exports,
    useFragment: $5RO7w,
    useLazyLoadQuery: $a5rI4,
    useEntryPointLoader: $5RqGi,
    useQueryLoader: $2g3bG,
    useMutation: $edz3c,
    usePaginationFragment: $aUuHB,
    usePreloadedQuery: $j2uow,
    useRefetchableFragment: $eDK61,
    useRelayEnvironment: $amoBB,
    useSubscribeToInvalidationState: $dPWxj,
    useSubscription: $4H2Ae
};

});

parcelRegister("3e6Uc", function(module, exports) {
/**
 * Relay v0.0.0-main-6ff96079
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("5zubY"));

});

parcelRegister("5zubY", function(module, exports) {
'use strict';
var $57525bba5d60eb62$exports = {};
'use strict';

var $fub1S = parcelRequire("fub1S");

var $57525bba5d60eb62$var$generateClientID = $fub1S.generateClientID;

var $jZOVE = parcelRequire("jZOVE");

var $57525bba5d60eb62$var$getStableStorageKey = $jZOVE.getStableStorageKey;

var $6TFlP = parcelRequire("6TFlP");

var $4357197e55b7bed0$exports = {};
'use strict';
var $4357197e55b7bed0$var$CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var $4357197e55b7bed0$var$config = {
    CURSOR: 'cursor',
    EDGES: 'edges',
    END_CURSOR: 'endCursor',
    HAS_NEXT_PAGE: 'hasNextPage',
    HAS_PREV_PAGE: 'hasPreviousPage',
    NODE: 'node',
    PAGE_INFO_TYPE: 'PageInfo',
    PAGE_INFO: 'pageInfo',
    START_CURSOR: 'startCursor'
};
var $4357197e55b7bed0$var$ConnectionInterface = {
    inject: function inject(newConfig) {
        $4357197e55b7bed0$var$config = newConfig;
    },
    get: function get() {
        return $4357197e55b7bed0$var$config;
    },
    isConnectionCall: function isConnectionCall(call) {
        return $4357197e55b7bed0$var$CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
$4357197e55b7bed0$exports = $4357197e55b7bed0$var$ConnectionInterface;



var $q03Nf = parcelRequire("q03Nf");

parcelRequire("eEWwZ");

var $57525bba5d60eb62$var$CONNECTION = 'connection';
var $57525bba5d60eb62$var$NEXT_EDGE_INDEX = '__connection_next_edge_index';
function $57525bba5d60eb62$var$update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = $4357197e55b7bed0$exports.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey);
        return;
    }
    var clientConnectionID = $57525bba5d60eb62$var$generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, $57525bba5d60eb62$var$NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return $57525bba5d60eb62$var$buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create($57525bba5d60eb62$var$generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return $57525bba5d60eb62$var$buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                var _clientPageInfo;
                var clientEndCursor = (_clientPageInfo = clientPageInfo) === null || _clientPageInfo === void 0 ? void 0 : _clientPageInfo.getValue(END_CURSOR);
                var serverEndCursor = serverPageInfo === null || serverPageInfo === void 0 ? void 0 : serverPageInfo.getValue(END_CURSOR);
                var isAddingEdgesAfterCurrentPage = clientPageInfo && args.after === clientEndCursor;
                var isFillingOutCurrentPage = clientPageInfo && clientEndCursor === serverEndCursor;
                if (isAddingEdgesAfterCurrentPage || isFillingOutCurrentPage) {
                    var nodeIDs = new Set();
                    $57525bba5d60eb62$var$mergeEdges(prevEdges, nextEdges, nodeIDs);
                    $57525bba5d60eb62$var$mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    $57525bba5d60eb62$var$mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    $57525bba5d60eb62$var$mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else nextEdges = prevEdges;
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === 'string') clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === 'string') clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
function $57525bba5d60eb62$var$getConnection(record, key, filters) {
    var handleKey = $6TFlP($57525bba5d60eb62$var$CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
function $57525bba5d60eb62$var$getConnectionID(recordID, key, filters) {
    var handleKey = $6TFlP($57525bba5d60eb62$var$CONNECTION, key, null);
    var storageKey = $57525bba5d60eb62$var$getStableStorageKey(handleKey, filters);
    return $57525bba5d60eb62$var$generateClientID(recordID, storageKey);
}
function $57525bba5d60eb62$var$insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = $4357197e55b7bed0$exports.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $57525bba5d60eb62$var$createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = $4357197e55b7bed0$exports.get(), NODE = _ConnectionInterface$3.NODE;
    var edgeID = $57525bba5d60eb62$var$generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue('cursor') == null) edge.setValue(null, 'cursor');
    return edge;
}
function $57525bba5d60eb62$var$insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = $4357197e55b7bed0$exports.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $57525bba5d60eb62$var$deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = $4357197e55b7bed0$exports.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
function $57525bba5d60eb62$var$buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = $4357197e55b7bed0$exports.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue($57525bba5d60eb62$var$NEXT_EDGE_INDEX);
    !(typeof edgeIndex === 'number') && $q03Nf(false);
    var edgeID = $57525bba5d60eb62$var$generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue('cursor') == null) connectionEdge.setValue(null, 'cursor');
    connection.setValue(edgeIndex + 1, $57525bba5d60eb62$var$NEXT_EDGE_INDEX);
    return connectionEdge;
}
function $57525bba5d60eb62$var$mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = $4357197e55b7bed0$exports.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
$57525bba5d60eb62$exports = {
    buildConnectionEdge: $57525bba5d60eb62$var$buildConnectionEdge,
    createEdge: $57525bba5d60eb62$var$createEdge,
    deleteNode: $57525bba5d60eb62$var$deleteNode,
    getConnection: $57525bba5d60eb62$var$getConnection,
    getConnectionID: $57525bba5d60eb62$var$getConnectionID,
    insertEdgeAfter: $57525bba5d60eb62$var$insertEdgeAfter,
    insertEdgeBefore: $57525bba5d60eb62$var$insertEdgeBefore,
    update: $57525bba5d60eb62$var$update
};



var $18f563715feefed6$exports = {};
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $18f563715feefed6$var$_interopRequireDefault = $eGvGZ.default;

var $18f563715feefed6$var$_createForOfIteratorHelper2 = $18f563715feefed6$var$_interopRequireDefault((parcelRequire("5YwI0")));





parcelRequire("eEWwZ");

var $18f563715feefed6$var$DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === 'string') store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === 'string') store["delete"](id);
            });
        }
    }
};
var $18f563715feefed6$var$DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $q03Nf(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === 'string') {
                var _iterator = (0, $18f563715feefed6$var$_createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        $57525bba5d60eb62$exports.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var $18f563715feefed6$var$AppendEdgeHandler = {
    update: $18f563715feefed6$var$edgeUpdater($57525bba5d60eb62$exports.insertEdgeAfter)
};
var $18f563715feefed6$var$PrependEdgeHandler = {
    update: $18f563715feefed6$var$edgeUpdater($57525bba5d60eb62$exports.insertEdgeBefore)
};
var $18f563715feefed6$var$AppendNodeHandler = {
    update: $18f563715feefed6$var$nodeUpdater($57525bba5d60eb62$exports.insertEdgeAfter)
};
var $18f563715feefed6$var$PrependNodeHandler = {
    update: $18f563715feefed6$var$nodeUpdater($57525bba5d60eb62$exports.insertEdgeBefore)
};
function $18f563715feefed6$var$edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $q03Nf(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = $4357197e55b7bed0$exports.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, $18f563715feefed6$var$_createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord('node');
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, $18f563715feefed6$var$_createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $57525bba5d60eb62$exports.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && $q03Nf(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function $18f563715feefed6$var$nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && $q03Nf(false);
        !(edgeTypeName != null) && $q03Nf(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = $4357197e55b7bed0$exports.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, $18f563715feefed6$var$_createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, $18f563715feefed6$var$_createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $57525bba5d60eb62$exports.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && $q03Nf(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
$18f563715feefed6$exports = {
    AppendEdgeHandler: $18f563715feefed6$var$AppendEdgeHandler,
    DeleteRecordHandler: $18f563715feefed6$var$DeleteRecordHandler,
    PrependEdgeHandler: $18f563715feefed6$var$PrependEdgeHandler,
    AppendNodeHandler: $18f563715feefed6$var$AppendNodeHandler,
    PrependNodeHandler: $18f563715feefed6$var$PrependNodeHandler,
    DeleteEdgeHandler: $18f563715feefed6$var$DeleteEdgeHandler
};


var $cca99455e46f9cec$exports = {};
'use strict';





function $cca99455e46f9cec$var$RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case 'connection':
            return $57525bba5d60eb62$exports;
        case 'deleteRecord':
            return $18f563715feefed6$exports.DeleteRecordHandler;
        case 'deleteEdge':
            return $18f563715feefed6$exports.DeleteEdgeHandler;
        case 'appendEdge':
            return $18f563715feefed6$exports.AppendEdgeHandler;
        case 'prependEdge':
            return $18f563715feefed6$exports.PrependEdgeHandler;
        case 'appendNode':
            return $18f563715feefed6$exports.AppendNodeHandler;
        case 'prependNode':
            return $18f563715feefed6$exports.PrependNodeHandler;
    }
    $q03Nf(false);
}
$cca99455e46f9cec$exports = $cca99455e46f9cec$var$RelayDefaultHandlerProvider;


var $03bd9bb249baf9e0$exports = {};
'use strict';

var $befAO = parcelRequire("befAO");

var $03bd9bb249baf9e0$var$getRequest = $befAO.getRequest;
var $e80875a03a3119eb$exports = {};
'use strict';
function $e80875a03a3119eb$var$isRelayModernEnvironment(environment) {
    return Boolean(environment && environment['@@RelayModernEnvironment']);
}
$e80875a03a3119eb$exports = $e80875a03a3119eb$var$isRelayModernEnvironment;


var $c85a09fe2966e1e2$exports = {};
'use strict';
parcelRequire("kiICD");

var $f9c6d9883a5e2e5c$exports = {};
'use strict';

var $hQyFA = parcelRequire("hQyFA");




function $f9c6d9883a5e2e5c$var$getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && $q03Nf(false);
    return requestID + JSON.stringify($hQyFA(variables));
}
$f9c6d9883a5e2e5c$exports = $f9c6d9883a5e2e5c$var$getRequestIdentifier;



var $dMDnw = parcelRequire("dMDnw");

var $c85a09fe2966e1e2$var$getOperationVariables = $dMDnw.getOperationVariables;

var $75e3H = parcelRequire("75e3H");

var $c85a09fe2966e1e2$var$createNormalizationSelector = $75e3H.createNormalizationSelector, $c85a09fe2966e1e2$var$createReaderSelector = $75e3H.createReaderSelector;



var $c85a09fe2966e1e2$var$ROOT_ID = $jZOVE.ROOT_ID;
function $c85a09fe2966e1e2$var$createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $c85a09fe2966e1e2$var$ROOT_ID;
    var operation = request.operation;
    var operationVariables = $c85a09fe2966e1e2$var$getOperationVariables(operation, request.params.providedVariables, variables);
    var requestDescriptor = $c85a09fe2966e1e2$var$createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: $c85a09fe2966e1e2$var$createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: $c85a09fe2966e1e2$var$createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function $c85a09fe2966e1e2$var$createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: $f9c6d9883a5e2e5c$exports(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
$c85a09fe2966e1e2$exports = {
    createOperationDescriptor: $c85a09fe2966e1e2$var$createOperationDescriptor,
    createRequestDescriptor: $c85a09fe2966e1e2$var$createRequestDescriptor
};


var $03bd9bb249baf9e0$var$createOperationDescriptor = $c85a09fe2966e1e2$exports.createOperationDescriptor;
var $572030bb2a35d6c3$exports = {};
'use strict';



var $572030bb2a35d6c3$var$_interopRequireDefault = $eGvGZ.default;

var $572030bb2a35d6c3$var$_createForOfIteratorHelper2 = $572030bb2a35d6c3$var$_interopRequireDefault((parcelRequire("5YwI0")));

parcelRequire("eEWwZ");

var $572030bb2a35d6c3$var$MutationTypes = Object.freeze({
    RANGE_ADD: 'RANGE_ADD',
    RANGE_DELETE: 'RANGE_DELETE',
    NODE_DELETE: 'NODE_DELETE'
});
var $572030bb2a35d6c3$var$RangeOperations = Object.freeze({
    APPEND: 'append',
    PREPEND: 'prepend'
});
function $572030bb2a35d6c3$var$convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case 'NODE_DELETE':
                var nodeDeleteResult = $572030bb2a35d6c3$var$nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case 'RANGE_ADD':
                var rangeAddResult = $572030bb2a35d6c3$var$rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case 'RANGE_DELETE':
                var rangeDeleteResult = $572030bb2a35d6c3$var$rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function $572030bb2a35d6c3$var$nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = $572030bb2a35d6c3$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === 'string') store["delete"](id);
        });
    };
}
function $572030bb2a35d6c3$var$rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = $572030bb2a35d6c3$var$getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, $572030bb2a35d6c3$var$_createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = $57525bba5d60eb62$exports.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = $57525bba5d60eb62$exports.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case 'append':
                        $57525bba5d60eb62$exports.insertEdgeAfter(connection, clientEdge);
                        break;
                    case 'prepend':
                        $57525bba5d60eb62$exports.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function $572030bb2a35d6c3$var$rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = $572030bb2a35d6c3$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, $572030bb2a35d6c3$var$_createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === 'object') deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === 'object' && typeof idObject.id === 'string') deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === 'string') deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === 'string' && typeof deletedIDField === 'object') {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === 'string') deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === 'string') deleteIDs.push(id);
            });
        }
        $572030bb2a35d6c3$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function $572030bb2a35d6c3$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, $572030bb2a35d6c3$var$_createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = $57525bba5d60eb62$exports.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                $57525bba5d60eb62$exports.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $572030bb2a35d6c3$var$getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === 'LinkedField') return request.fragment.selections[0].name;
    return null;
}
$572030bb2a35d6c3$exports = {
    MutationTypes: $572030bb2a35d6c3$var$MutationTypes,
    RangeOperations: $572030bb2a35d6c3$var$RangeOperations,
    convert: $572030bb2a35d6c3$var$convert
};





function $03bd9bb249baf9e0$var$applyOptimisticMutation(environment, config) {
    !$e80875a03a3119eb$exports(environment) && $q03Nf(false);
    var mutation = $03bd9bb249baf9e0$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = $03bd9bb249baf9e0$var$createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = $572030bb2a35d6c3$exports.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
$03bd9bb249baf9e0$exports = $03bd9bb249baf9e0$var$applyOptimisticMutation;


var $7ffad1bf7c1a523f$exports = {};
'use strict';
function $7ffad1bf7c1a523f$var$commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
$7ffad1bf7c1a523f$exports = $7ffad1bf7c1a523f$var$commitLocalUpdate;


var $e75c52f4cdee6bbc$exports = {};
'use strict';



var $e75c52f4cdee6bbc$var$_interopRequireDefault = $eGvGZ.default;

var $e75c52f4cdee6bbc$var$_toConsumableArray2 = $e75c52f4cdee6bbc$var$_interopRequireDefault((parcelRequire("aUSZ9")));



var $e75c52f4cdee6bbc$var$getRequest = $befAO.getRequest;



var $e75c52f4cdee6bbc$var$generateUniqueClientID = $fub1S.generateUniqueClientID;


var $e75c52f4cdee6bbc$var$createOperationDescriptor = $c85a09fe2966e1e2$exports.createOperationDescriptor;

var $613580553289a45f$exports = {};
'use strict';



var $613580553289a45f$var$_interopRequireDefault = $eGvGZ.default;

var $613580553289a45f$var$_objectSpread2 = $613580553289a45f$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $ceyF6 = parcelRequire("ceyF6");

var $613580553289a45f$var$ACTOR_CHANGE = $ceyF6.ACTOR_CHANGE, $613580553289a45f$var$CLIENT_COMPONENT = $ceyF6.CLIENT_COMPONENT, $613580553289a45f$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $ceyF6.CLIENT_EDGE_TO_CLIENT_OBJECT, $613580553289a45f$var$CLIENT_EXTENSION = $ceyF6.CLIENT_EXTENSION, $613580553289a45f$var$CONDITION = $ceyF6.CONDITION, $613580553289a45f$var$DEFER = $ceyF6.DEFER, $613580553289a45f$var$FRAGMENT_SPREAD = $ceyF6.FRAGMENT_SPREAD, $613580553289a45f$var$INLINE_FRAGMENT = $ceyF6.INLINE_FRAGMENT, $613580553289a45f$var$LINKED_FIELD = $ceyF6.LINKED_FIELD, $613580553289a45f$var$LINKED_HANDLE = $ceyF6.LINKED_HANDLE, $613580553289a45f$var$MODULE_IMPORT = $ceyF6.MODULE_IMPORT, $613580553289a45f$var$RELAY_LIVE_RESOLVER = $ceyF6.RELAY_LIVE_RESOLVER, $613580553289a45f$var$RELAY_RESOLVER = $ceyF6.RELAY_RESOLVER, $613580553289a45f$var$SCALAR_FIELD = $ceyF6.SCALAR_FIELD, $613580553289a45f$var$SCALAR_HANDLE = $ceyF6.SCALAR_HANDLE, $613580553289a45f$var$STREAM = $ceyF6.STREAM, $613580553289a45f$var$TYPE_DISCRIMINATOR = $ceyF6.TYPE_DISCRIMINATOR;
parcelRequire("eEWwZ");

var $613580553289a45f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $613580553289a45f$var$validateMutation = function validateMutation() {};
var $613580553289a45f$var$addFieldToDiff, $613580553289a45f$var$validateSelections, $613580553289a45f$var$validateSelection, $613580553289a45f$var$validateModuleImport, $613580553289a45f$var$validateAbstractKey, $613580553289a45f$var$validateField, $613580553289a45f$var$validateOptimisticResponse;
$613580553289a45f$exports = $613580553289a45f$var$validateMutation;





parcelRequire("eEWwZ");

function $e75c52f4cdee6bbc$var$commitMutation(environment, config) {
    !$e80875a03a3119eb$exports(environment) && $q03Nf(false);
    var mutation = $e75c52f4cdee6bbc$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    if (mutation.kind !== 'Request') throw new Error('commitMutation: Expected mutation to be of type request');
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = $e75c52f4cdee6bbc$var$createOperationDescriptor(mutation, variables, cacheConfig, $e75c52f4cdee6bbc$var$generateUniqueClientID());
    if (typeof optimisticResponse === 'function') optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = $572030bb2a35d6c3$exports.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, $e75c52f4cdee6bbc$var$_toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, $e75c52f4cdee6bbc$var$_toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
$e75c52f4cdee6bbc$exports = $e75c52f4cdee6bbc$var$commitMutation;



var $c0ee250a52593da7$exports = {};
'use strict';
var $597cc922188e47e7$exports = {};
'use strict';
parcelRequire("8w3GE");

parcelRequire("eEWwZ");

var $597cc922188e47e7$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $597cc922188e47e7$var$debugCache = $597cc922188e47e7$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $597cc922188e47e7$var$withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            if (!$597cc922188e47e7$var$debugCache.has(providerFunction)) {
                $597cc922188e47e7$var$debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = $597cc922188e47e7$var$debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
$597cc922188e47e7$var$withProvidedVariables.tests_only_resetDebugCache = undefined;
$597cc922188e47e7$exports = $597cc922188e47e7$var$withProvidedVariables;


var $61c8eab64e406046$exports = {};
'use strict';
var $bc831eb90cd34dd5$exports = {};
'use strict';
var $4bec3f38163c33d4$exports = {};
'use strict';
function $4bec3f38163c33d4$var$isPromise(p) {
    return p != null && typeof p === 'object' && typeof p.then === 'function';
}
$4bec3f38163c33d4$exports = $4bec3f38163c33d4$var$isPromise;


var $bc831eb90cd34dd5$var$hostReportError = $bc831eb90cd34dd5$var$swallowError;
var $bc831eb90cd34dd5$var$RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        $bc831eb90cd34dd5$var$hostReportError = callback;
    };
    RelayObservable.from = function from(obj) {
        return $bc831eb90cd34dd5$var$isObservable(obj) ? $bc831eb90cd34dd5$var$fromObservable(obj) : $4bec3f38163c33d4$exports(obj) ? $bc831eb90cd34dd5$var$fromPromise(obj) : $bc831eb90cd34dd5$var$fromValue(obj);
    };
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    };
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        $bc831eb90cd34dd5$var$hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both('start'),
                next: both('next'),
                error: both('error'),
                complete: both('complete'),
                unsubscribe: both('unsubscribe')
            });
        });
    };
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    };
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current;
            current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto.subscribe = function subscribe(observer) {
        return $bc831eb90cd34dd5$var$_subscribe(this._source, observer);
    };
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    };
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    };
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    };
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}();
function $bc831eb90cd34dd5$var$isObservable(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.subscribe === 'function';
}
function $bc831eb90cd34dd5$var$fromObservable(obj) {
    return obj instanceof $bc831eb90cd34dd5$var$RelayObservable ? obj : $bc831eb90cd34dd5$var$RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function $bc831eb90cd34dd5$var$fromPromise(promise) {
    return $bc831eb90cd34dd5$var$RelayObservable.create(function(sink) {
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function $bc831eb90cd34dd5$var$fromValue(value) {
    return $bc831eb90cd34dd5$var$RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function $bc831eb90cd34dd5$var$_subscribe(source, observer) {
    var closed = false;
    var cleanup;
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, 'closed', {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                $bc831eb90cd34dd5$var$hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    $bc831eb90cd34dd5$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        $bc831eb90cd34dd5$var$hostReportError(error, true);
    }
    if (closed) return subscription;
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                $bc831eb90cd34dd5$var$hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                $bc831eb90cd34dd5$var$hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    $bc831eb90cd34dd5$var$hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    $bc831eb90cd34dd5$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    if (closed) doCleanup();
    return subscription;
}
function $bc831eb90cd34dd5$var$swallowError(_error, _isUncaughtThrownError) {}
$bc831eb90cd34dd5$exports = $bc831eb90cd34dd5$var$RelayObservable;


function $61c8eab64e406046$var$convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        if (result instanceof Error) return $bc831eb90cd34dd5$exports.create(function(sink) {
            return sink.error(result);
        });
        return $bc831eb90cd34dd5$exports.from(result);
    };
}
$61c8eab64e406046$exports = {
    convertFetch: $61c8eab64e406046$var$convertFetch
};


var $c0ee250a52593da7$var$convertFetch = $61c8eab64e406046$exports.convertFetch;



function $c0ee250a52593da7$var$create(fetchFn, subscribe) {
    var observeFetch = $c0ee250a52593da7$var$convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = $597cc922188e47e7$exports(variables, request.providedVariables);
        if (request.operationKind === 'subscription') {
            !subscribe && $q03Nf(false);
            !!uploadables && $q03Nf(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && $q03Nf(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
$c0ee250a52593da7$exports = {
    create: $c0ee250a52593da7$var$create
};



var $a426543098dd08aa$exports = {};
'use strict';



var $a426543098dd08aa$var$_interopRequireDefault = $eGvGZ.default;

var $a426543098dd08aa$var$_objectSpread2 = $a426543098dd08aa$var$_interopRequireDefault((parcelRequire("6g2zv")));






var $a426543098dd08aa$var$RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && $q03Nf(false);
        !(ttl > 0) && $q03Nf(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = $a426543098dd08aa$var$getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!$a426543098dd08aa$var$isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, $a426543098dd08aa$var$_objectSpread2["default"])((0, $a426543098dd08aa$var$_objectSpread2["default"])({}, payload), {}, {
                extensions: (0, $a426543098dd08aa$var$_objectSpread2["default"])((0, $a426543098dd08aa$var$_objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, $a426543098dd08aa$var$_objectSpread2["default"])((0, $a426543098dd08aa$var$_objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, $a426543098dd08aa$var$_objectSpread2["default"])((0, $a426543098dd08aa$var$_objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = $a426543098dd08aa$var$getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey);
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function $a426543098dd08aa$var$getCacheKey(queryID, variables) {
    return JSON.stringify($hQyFA({
        queryID: queryID,
        variables: variables
    }));
}
function $a426543098dd08aa$var$isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
$a426543098dd08aa$exports = $a426543098dd08aa$var$RelayQueryResponseCache;


var $34c6b65fcb8f94bf$exports = {};
'use strict';



var $34c6b65fcb8f94bf$var$_interopRequireDefault = $eGvGZ.default;

var $34c6b65fcb8f94bf$var$_objectSpread2 = $34c6b65fcb8f94bf$var$_interopRequireDefault((parcelRequire("6g2zv")));


var $34c6b65fcb8f94bf$var$createOperationDescriptor = $c85a09fe2966e1e2$exports.createOperationDescriptor;
var $adb61a88756c1d17$exports = {};
'use strict';



var $adb61a88756c1d17$var$_interopRequireDefault = $eGvGZ.default;

var $adb61a88756c1d17$var$_createForOfIteratorHelper2 = $adb61a88756c1d17$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $lBYAg = parcelRequire("lBYAg");


var $adb61a88756c1d17$var$_RelayFeatureFlags = $adb61a88756c1d17$var$_interopRequireDefault((parcelRequire("ek4t1")));
function $adb61a88756c1d17$var$handlePotentialSnapshotErrors(environment, missingRequiredFields, relayResolverErrors, errorResponseFields, throwOnFieldError) {
    var _iterator = (0, $adb61a88756c1d17$var$_createForOfIteratorHelper2["default"])(relayResolverErrors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var resolverError = _step.value;
            environment.relayFieldLogger({
                kind: 'relay_resolver.error',
                owner: resolverError.field.owner,
                fieldPath: resolverError.field.path,
                error: resolverError.error
            });
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (relayResolverErrors.length > 0 && ($adb61a88756c1d17$var$_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT || throwOnFieldError)) throw new $lBYAg.RelayFieldError("Relay: Unexpected resolver exception", relayResolverErrors.map(function(e) {
        return {
            message: e.error.message
        };
    }));
    if (($adb61a88756c1d17$var$_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING || throwOnFieldError) && errorResponseFields != null) {
        if (errorResponseFields != null) {
            var _iterator2 = (0, $adb61a88756c1d17$var$_createForOfIteratorHelper2["default"])(errorResponseFields), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var fieldError = _step2.value;
                    var path = fieldError.path, owner = fieldError.owner, error = fieldError.error;
                    environment.relayFieldLogger({
                        kind: 'relay_field_payload.error',
                        owner: owner,
                        fieldPath: path,
                        error: error
                    });
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
        if ($adb61a88756c1d17$var$_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT || throwOnFieldError) throw new $lBYAg.RelayFieldError("Relay: Unexpected response payload - this object includes an errors property in which you can access the underlying errors", errorResponseFields.map(function(_ref) {
            var error = _ref.error;
            return error;
        }));
    }
    if (missingRequiredFields != null) switch(missingRequiredFields.action){
        case 'THROW':
            var _missingRequiredField = missingRequiredFields.field, _path = _missingRequiredField.path, _owner = _missingRequiredField.owner;
            environment.relayFieldLogger({
                kind: 'missing_field.throw',
                owner: _owner,
                fieldPath: _path
            });
            throw new Error("Relay: Missing @required value at path '".concat(_path, "' in '").concat(_owner, "'."));
        case 'LOG':
            missingRequiredFields.fields.forEach(function(_ref2) {
                var path = _ref2.path, owner = _ref2.owner;
                environment.relayFieldLogger({
                    kind: 'missing_field.log',
                    owner: owner,
                    fieldPath: path
                });
            });
            break;
        default:
            missingRequiredFields.action;
    }
}
$adb61a88756c1d17$exports = $adb61a88756c1d17$var$handlePotentialSnapshotErrors;


var $2477bd787cf8c706$exports = {};
'use strict';

var $ef598fdf09302eac$exports = {};
'use strict';



var $ef598fdf09302eac$var$_interopRequireDefault = $eGvGZ.default;

var $ef598fdf09302eac$var$_createForOfIteratorHelper2 = $ef598fdf09302eac$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $ef598fdf09302eac$var$_defineProperty2 = $ef598fdf09302eac$var$_interopRequireDefault((parcelRequire("l2SD1")));




var $ef598fdf09302eac$var$RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, $ef598fdf09302eac$var$_defineProperty2["default"])(this, "_complete", false);
        (0, $ef598fdf09302eac$var$_defineProperty2["default"])(this, "_events", []);
        (0, $ef598fdf09302eac$var$_defineProperty2["default"])(this, "_sinks", new Set());
        (0, $ef598fdf09302eac$var$_defineProperty2["default"])(this, "_subscription", []);
        this._observable = $bc831eb90cd34dd5$exports.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case 'complete':
                        sink.complete();
                        break;
                    case 'error':
                        sink.error(event.error);
                        break;
                    case 'next':
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        $q03Nf(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'complete'
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'error',
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: 'next',
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, $ef598fdf09302eac$var$_createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
$ef598fdf09302eac$exports = $ef598fdf09302eac$var$RelayReplaySubject;





var $2477bd787cf8c706$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $2477bd787cf8c706$var$requestCachesByEnvironment = $2477bd787cf8c706$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $2477bd787cf8c706$var$fetchQuery(environment, operation) {
    return $2477bd787cf8c706$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
function $2477bd787cf8c706$var$fetchQueryDeduped(environment, identifier, fetchFn) {
    return $bc831eb90cd34dd5$exports.create(function(sink) {
        var requestCache = $2477bd787cf8c706$var$getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new $ef598fdf09302eac$exports(),
                    subjectForInFlightStatus: new $ef598fdf09302eac$exports(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = $2477bd787cf8c706$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = $2477bd787cf8c706$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = $2477bd787cf8c706$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = $2477bd787cf8c706$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && $q03Nf(false);
        return $2477bd787cf8c706$var$getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
function $2477bd787cf8c706$var$getObservableForCachedRequest(requestCache, cachedRequest) {
    return $bc831eb90cd34dd5$exports.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
function $2477bd787cf8c706$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return $bc831eb90cd34dd5$exports.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
function $2477bd787cf8c706$var$getPromiseForActiveRequest(environment, request) {
    var requestCache = $2477bd787cf8c706$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        $2477bd787cf8c706$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    return promise;
}
function $2477bd787cf8c706$var$getObservableForActiveRequest(environment, request) {
    var requestCache = $2477bd787cf8c706$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return $2477bd787cf8c706$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
function $2477bd787cf8c706$var$getRequestCache(environment) {
    var cached = $2477bd787cf8c706$var$requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    $2477bd787cf8c706$var$requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
function $2477bd787cf8c706$var$getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && $q03Nf(false);
    return cached;
}
$2477bd787cf8c706$exports = {
    fetchQuery: $2477bd787cf8c706$var$fetchQuery,
    fetchQueryDeduped: $2477bd787cf8c706$var$fetchQueryDeduped,
    getPromiseForActiveRequest: $2477bd787cf8c706$var$getPromiseForActiveRequest,
    getObservableForActiveRequest: $2477bd787cf8c706$var$getObservableForActiveRequest
};





var $34c6b65fcb8f94bf$var$getRequest = $befAO.getRequest;



function $34c6b65fcb8f94bf$var$fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = $34c6b65fcb8f94bf$var$getRequest(query);
    !(queryNode.params.operationKind === 'query') && $q03Nf(false);
    var networkCacheConfig = (0, $34c6b65fcb8f94bf$var$_objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = $34c6b65fcb8f94bf$var$createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'network-only';
    function readData(snapshot) {
        var _queryNode$fragment$m, _queryNode$fragment$m2;
        $adb61a88756c1d17$exports(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_queryNode$fragment$m = (_queryNode$fragment$m2 = queryNode.fragment.metadata) === null || _queryNode$fragment$m2 === void 0 ? void 0 : _queryNode$fragment$m2.throwOnFieldError) !== null && _queryNode$fragment$m !== void 0 ? _queryNode$fragment$m : false);
        return snapshot.data;
    }
    switch(fetchPolicy){
        case 'network-only':
            return $34c6b65fcb8f94bf$var$getNetworkObservable(environment, operation).map(readData);
        case 'store-or-network':
            if (environment.check(operation).status === 'available') return $bc831eb90cd34dd5$exports.from(environment.lookup(operation.fragment)).map(readData);
            return $34c6b65fcb8f94bf$var$getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error('fetchQuery: Invalid fetchPolicy ' + fetchPolicy);
    }
}
function $34c6b65fcb8f94bf$var$getNetworkObservable(environment, operation) {
    return $2477bd787cf8c706$exports.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
$34c6b65fcb8f94bf$exports = $34c6b65fcb8f94bf$var$fetchQuery;


var $46a956a4d5cb813d$exports = {};
'use strict';

var $46a956a4d5cb813d$var$createOperationDescriptor = $c85a09fe2966e1e2$exports.createOperationDescriptor;



var $46a956a4d5cb813d$var$getRequest = $befAO.getRequest;
function $46a956a4d5cb813d$var$fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = $46a956a4d5cb813d$var$getRequest(taggedNode);
    if (query.params.operationKind !== 'query') throw new Error('fetchQuery: Expected query operation');
    var operation = $46a956a4d5cb813d$var$createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
$46a956a4d5cb813d$exports = $46a956a4d5cb813d$var$fetchQuery_DEPRECATED;






var $f08a4d3012c085bf$exports = {};
'use strict';
var $f08a4d3012c085bf$var$PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var $f08a4d3012c085bf$var$preloadableQueryRegistry = new $f08a4d3012c085bf$var$PreloadableQueryRegistry();
$f08a4d3012c085bf$exports = $f08a4d3012c085bf$var$preloadableQueryRegistry;





var $40e7a42a5c152c35$var$generateClientID = $fub1S.generateClientID, $40e7a42a5c152c35$var$generateUniqueClientID = $fub1S.generateUniqueClientID, $40e7a42a5c152c35$var$isClientID = $fub1S.isClientID;
var $e36628f7435615c1$exports = {};
'use strict';
var $ecaba00bc1589fcb$exports = {};
'use strict';



var $ecaba00bc1589fcb$var$_interopRequireDefault = $eGvGZ.default;

var $ecaba00bc1589fcb$var$_objectSpread2 = $ecaba00bc1589fcb$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $ecaba00bc1589fcb$var$_defineProperty2 = $ecaba00bc1589fcb$var$_interopRequireDefault((parcelRequire("l2SD1")));
var $b7a8c75ef88b6a92$exports = {};
'use strict';

var $b7a8c75ef88b6a92$var$getPromiseForActiveRequest = $2477bd787cf8c706$exports.getPromiseForActiveRequest;
function $b7a8c75ef88b6a92$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = $b7a8c75ef88b6a92$var$getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var result = environment.getOperationTracker().getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(',')) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = 'Unknown pending operation';
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    promise.displayName = promiseDisplayName;
    environment.__log({
        name: 'pendingoperation.found',
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
$b7a8c75ef88b6a92$exports = $b7a8c75ef88b6a92$var$getPendingOperationsForFragment;



var $3d6d39ec5eeed659$exports = {};
'use strict';
function $3d6d39ec5eeed659$var$isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== 'object');
}
$3d6d39ec5eeed659$exports = $3d6d39ec5eeed659$var$isScalarAndEqual;



var $kU32t = parcelRequire("kU32t");


var $ek4t1 = parcelRequire("ek4t1");


var $ecaba00bc1589fcb$var$createRequestDescriptor = $c85a09fe2966e1e2$exports.createRequestDescriptor;



var $ecaba00bc1589fcb$var$areEqualSelectors = $75e3H.areEqualSelectors, $ecaba00bc1589fcb$var$createReaderSelector = $75e3H.createReaderSelector, $ecaba00bc1589fcb$var$getSelectorsFromObject = $75e3H.getSelectorsFromObject;

var $8w3GE = parcelRequire("8w3GE");




parcelRequire("eEWwZ");

var $ecaba00bc1589fcb$var$RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, $ecaba00bc1589fcb$var$_defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === 'function') _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) $ecaba00bc1589fcb$var$disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, $ecaba00bc1589fcb$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !$3d6d39ec5eeed659$exports(_nextItem, prevItem)) {
                        nextData = nextData || (0, $ecaba00bc1589fcb$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if ($ek4t1.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = $ecaba00bc1589fcb$var$getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === 'PluralReaderSelector') {
                if (resolver == null) resolver = new $ecaba00bc1589fcb$var$SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof $ecaba00bc1589fcb$var$SelectorListResolver) && $q03Nf(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new $ecaba00bc1589fcb$var$SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof $ecaba00bc1589fcb$var$SelectorResolver) && $q03Nf(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
var $ecaba00bc1589fcb$var$SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, $ecaba00bc1589fcb$var$_defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._missingRequiredFields = snapshot.missingRequiredFields;
            _this2._errorResponseFields = snapshot.errorResponseFields;
            _this2._relayResolverErrors = snapshot.relayResolverErrors;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._missingRequiredFields = _snapshot.missingRequiredFields;
        this._errorResponseFields = _snapshot.errorResponseFields;
        this._relayResolverErrors = _snapshot.relayResolverErrors;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if ($ek4t1.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        var _this$_selector$node$, _this$_selector$node$2;
        if (this._isMissingData === true) {
            var pendingOperationsResult = $b7a8c75ef88b6a92$exports(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: 'suspense.fragment',
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        $adb61a88756c1d17$exports(this._environment, this._missingRequiredFields, this._relayResolverErrors, this._errorResponseFields, (_this$_selector$node$ = (_this$_selector$node$2 = this._selector.node.metadata) === null || _this$_selector$node$2 === void 0 ? void 0 : _this$_selector$node$2.throwOnFieldError) !== null && _this$_selector$node$ !== void 0 ? _this$_selector$node$ : false);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && $ecaba00bc1589fcb$var$areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = $kU32t(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._missingRequiredFields = snapshot.missingRequiredFields;
        this._errorResponseFields = snapshot.errorResponseFields;
        this._relayResolverErrors = snapshot.relayResolverErrors;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if ($8w3GE(variables, this._selector.variables)) return;
        var requestDescriptor = $ecaba00bc1589fcb$var$createRequestDescriptor(request, variables);
        var selector = $ecaba00bc1589fcb$var$createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
var $ecaba00bc1589fcb$var$SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, $ecaba00bc1589fcb$var$_defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach($ecaba00bc1589fcb$var$disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new $ecaba00bc1589fcb$var$SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function $ecaba00bc1589fcb$var$disposeCallback(disposable) {
    disposable && disposable.dispose();
}
$ecaba00bc1589fcb$exports = $ecaba00bc1589fcb$var$RelayModernFragmentSpecResolver;


parcelRequire("eEWwZ");

function $e36628f7435615c1$var$createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new $ecaba00bc1589fcb$exports(context, fragments, props, callback, rootIsQueryRenderer);
}
$e36628f7435615c1$exports = $e36628f7435615c1$var$createFragmentSpecResolver;


var $6d99152a4e5c556c$exports = {};
'use strict';



var $6d99152a4e5c556c$var$relayContext;
var $6d99152a4e5c556c$var$firstReact;
function $6d99152a4e5c556c$var$createRelayContext(react) {
    if (!$6d99152a4e5c556c$var$relayContext) {
        $6d99152a4e5c556c$var$relayContext = react.createContext(null);
        $6d99152a4e5c556c$var$firstReact = react;
    }
    !(react === $6d99152a4e5c556c$var$firstReact) && $q03Nf(false);
    return $6d99152a4e5c556c$var$relayContext;
}
$6d99152a4e5c556c$exports = $6d99152a4e5c556c$var$createRelayContext;



var $fusLc = parcelRequire("fusLc");

var $40e7a42a5c152c35$var$isSuspenseSentinel = $fusLc.isSuspenseSentinel, $40e7a42a5c152c35$var$suspenseSentinel = $fusLc.suspenseSentinel;

var $2433602de6011eac$exports = {};
'use strict';



var $2433602de6011eac$var$_interopRequireDefault = $eGvGZ.default;

var $2433602de6011eac$var$_objectSpread2 = $2433602de6011eac$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $2433602de6011eac$var$_RelayModernRecord = $2433602de6011eac$var$_interopRequireDefault((parcelRequire("jO6uW")));

var $2433602de6011eac$var$_RelayRecordSource = $2433602de6011eac$var$_interopRequireDefault((parcelRequire("bsBg6")));

var $2433602de6011eac$var$_RelayResponseNormalizer = $2433602de6011eac$var$_interopRequireDefault((parcelRequire("5uj6g")));
function $2433602de6011eac$var$normalizeResponse(response, selector, typeName, options) {
    var _response$extensions;
    var data = response.data, errors = response.errors;
    var source = $2433602de6011eac$var$_RelayRecordSource["default"].create();
    var record = $2433602de6011eac$var$_RelayModernRecord["default"].create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = $2433602de6011eac$var$_RelayResponseNormalizer["default"].normalize(source, selector, data, options, errors);
    return (0, $2433602de6011eac$var$_objectSpread2["default"])((0, $2433602de6011eac$var$_objectSpread2["default"])({}, relayPayload), {}, {
        isFinal: ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.is_final) === true
    });
}
$2433602de6011eac$exports = $2433602de6011eac$var$normalizeResponse;


var $d72c09e83c8c63ea$exports = {};
'use strict';



var $d72c09e83c8c63ea$var$getInlineDataFragment = $befAO.getInlineDataFragment;



var $d72c09e83c8c63ea$var$FRAGMENTS_KEY = $jZOVE.FRAGMENTS_KEY;



function $d72c09e83c8c63ea$var$readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = $d72c09e83c8c63ea$var$getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === 'object') && $q03Nf(false);
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[$d72c09e83c8c63ea$var$FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && $q03Nf(false);
    return inlineData;
}
$d72c09e83c8c63ea$exports = $d72c09e83c8c63ea$var$readInlineData;





var $80a4be38c0c6d6ee$exports = {};
'use strict';



var $80a4be38c0c6d6ee$var$_interopRequireDefault = $eGvGZ.default;

var $80a4be38c0c6d6ee$var$_objectSpread2 = $80a4be38c0c6d6ee$var$_interopRequireDefault((parcelRequire("6g2zv")));


var $gf5pM = parcelRequire("gf5pM");

var $80a4be38c0c6d6ee$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $gf5pM.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $80a4be38c0c6d6ee$var$assertInternalActorIdentifier = $gf5pM.assertInternalActorIdentifier;

var $43859e2619d09026$exports = {};
'use strict';
var $93a245d176fbf34b$exports = {};
'use strict';
var $93a245d176fbf34b$var$id = 100000;
function $93a245d176fbf34b$var$generateID() {
    return $93a245d176fbf34b$var$id++;
}
$93a245d176fbf34b$exports = $93a245d176fbf34b$var$generateID;


function $43859e2619d09026$var$wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables) {
            var networkRequestId = $93a245d176fbf34b$exports();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: 'network.start',
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: 'network.next',
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: 'network.error',
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: 'network.complete',
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: 'network.unsubscribe',
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: 'network.info',
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo)["do"](logObserver);
        }
    };
}
$43859e2619d09026$exports = $43859e2619d09026$var$wrapNetworkWithLogObserver;


var $cf13c72a303d7592$exports = {};
'use strict';



var $cf13c72a303d7592$var$_interopRequireDefault = $eGvGZ.default;

var $cf13c72a303d7592$var$_createForOfIteratorHelper2 = $cf13c72a303d7592$var$_interopRequireDefault((parcelRequire("5YwI0")));



var $cf13c72a303d7592$var$RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, $cf13c72a303d7592$var$_createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, $cf13c72a303d7592$var$_createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    };
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        var completedOwnersIdentifier = new Set();
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, $cf13c72a303d7592$var$_createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, $cf13c72a303d7592$var$_createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, $cf13c72a303d7592$var$_createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && $q03Nf(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
$cf13c72a303d7592$exports = $cf13c72a303d7592$var$RelayOperationTracker;


var $0e48c2206feb3207$exports = {};
'use strict';
function $0e48c2206feb3207$var$registerEnvironmentWithDevTools(environment) {
    var _global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
$0e48c2206feb3207$exports = $0e48c2206feb3207$var$registerEnvironmentWithDevTools;



var $e9MkZ = parcelRequire("e9MkZ");

var $f8c22d3ea516624d$exports = {};
'use strict';
var $f8c22d3ea516624d$var$defaultRelayFieldLogger = function defaultRelayFieldLogger(event) {};
$f8c22d3ea516624d$exports = $f8c22d3ea516624d$var$defaultRelayFieldLogger;



var $e7e441917f5d5709$exports = {};
'use strict';



var $e7e441917f5d5709$var$_interopRequireDefault = $eGvGZ.default;

var $e7e441917f5d5709$var$_createForOfIteratorHelper2 = $e7e441917f5d5709$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $e7e441917f5d5709$var$_toConsumableArray2 = $e7e441917f5d5709$var$_interopRequireDefault((parcelRequire("aUSZ9")));



var $cCwaC = parcelRequire("cCwaC");

var $9d62b7bbb186e2a3$exports = {};
'use strict';
function $9d62b7bbb186e2a3$var$createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ]
    });
    if (error.stack === undefined) try {
        throw error;
    } catch (_unused) {}
    return error;
}
$9d62b7bbb186e2a3$exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return $9d62b7bbb186e2a3$var$createError.apply(void 0, [
            'error',
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return $9d62b7bbb186e2a3$var$createError.apply(void 0, [
            'warn',
            name,
            messageFormat
        ].concat(messageParams));
    }
};








var $3adecde257784562$exports = {};
'use strict';
var $3adecde257784562$var$_window, $3adecde257784562$var$_window$performance;
var $3adecde257784562$var$isPerformanceNowAvailable = typeof window !== 'undefined' && typeof (($3adecde257784562$var$_window = window) === null || $3adecde257784562$var$_window === void 0 ? void 0 : ($3adecde257784562$var$_window$performance = $3adecde257784562$var$_window.performance) === null || $3adecde257784562$var$_window$performance === void 0 ? void 0 : $3adecde257784562$var$_window$performance.now) === 'function';
function $3adecde257784562$var$currentTimestamp() {
    if ($3adecde257784562$var$isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function $3adecde257784562$var$withDuration(cb) {
    var startTime = $3adecde257784562$var$currentTimestamp();
    var result = cb();
    return [
        $3adecde257784562$var$currentTimestamp() - startTime,
        result
    ];
}
$3adecde257784562$exports = $3adecde257784562$var$withDuration;





var $e7e441917f5d5709$var$generateClientID = $fub1S.generateClientID, $e7e441917f5d5709$var$generateUniqueClientID = $fub1S.generateUniqueClientID;



var $e7e441917f5d5709$var$getLocalVariables = $dMDnw.getLocalVariables;

var $jO6uW = parcelRequire("jO6uW");




var $e7e441917f5d5709$var$createNormalizationSelector = $75e3H.createNormalizationSelector, $e7e441917f5d5709$var$createReaderSelector = $75e3H.createReaderSelector;

var $bsBg6 = parcelRequire("bsBg6");




var $e7e441917f5d5709$var$ROOT_TYPE = $jZOVE.ROOT_TYPE, $e7e441917f5d5709$var$TYPENAME_KEY = $jZOVE.TYPENAME_KEY, $e7e441917f5d5709$var$getStorageKey = $jZOVE.getStorageKey;



parcelRequire("eEWwZ");

function $e7e441917f5d5709$var$execute(config) {
    return new $e7e441917f5d5709$var$Executor(config);
}
var $e7e441917f5d5709$var$Executor = /*#__PURE__*/ function() {
    function Executor(_ref2) {
        var _this = this;
        var actorIdentifier = _ref2.actorIdentifier, getDataID = _ref2.getDataID, getPublishQueue = _ref2.getPublishQueue, getStore = _ref2.getStore, isClientPayload = _ref2.isClientPayload, operation = _ref2.operation, operationExecutions = _ref2.operationExecutions, operationLoader = _ref2.operationLoader, operationTracker = _ref2.operationTracker, optimisticConfig = _ref2.optimisticConfig, scheduler = _ref2.scheduler, shouldProcessClientComponents = _ref2.shouldProcessClientComponents, sink = _ref2.sink, source = _ref2.source, treatMissingFieldsAsNull = _ref2.treatMissingFieldsAsNull, updater = _ref2.updater, log = _ref2.log, normalizeResponse = _ref2.normalizeResponse;
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = $93a245d176fbf34b$exports();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = 'started';
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === 'subscription';
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        this._normalizeResponse = normalizeResponse;
        var id = this._nextSubscriptionId++;
        if ($ek4t1.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ;
                _this._start(id, subscription);
                _this._log({
                    name: 'execute.start',
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ = _this._operation.request.cacheConfig) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : {}
                });
            }
        });
        if (!$ek4t1.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === 'completed') return;
        this._state = 'completed';
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case 'started':
                activeState = 'active';
                break;
            case 'loading_incremental':
                activeState = 'active';
                break;
            case 'completed':
                activeState = 'inactive';
                break;
            case 'loading_final':
                activeState = this._pendingModulePayloadsCount > 0 ? 'active' : 'inactive';
                break;
            default:
                this._state;
                $q03Nf(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            $bc831eb90cd34dd5$exports.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                });
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: 'execute.complete',
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: 'execute.error',
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        this._schedule(function() {
            var _withDuration = $3adecde257784562$exports(function() {
                _this4._handleNext(response);
                _this4._maybeCompleteSubscriptionOperationTracking();
            }), duration = _withDuration[0];
            _this4._log({
                name: 'execute.next',
                executeId: _this4._executeId,
                response: response,
                duration: duration
            });
        });
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty('errors')) return;
            else if (response.data == null) {
                var errors = response.hasOwnProperty('errors') && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref3) {
                    var message = _ref3.message;
                    return message;
                }).join('\n') : '(No errors)';
                var error = $9d62b7bbb186e2a3$exports.create('RelayNetwork', 'No data returned for operation `' + _this5._operation.request.node.params.name + '`, got error(s):\n' + messages + '\n\nSee the error `source` property for more information.');
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    };
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) $q03Nf(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== 'started') $q03Nf(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === 'completed') return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = 'loading_final';
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = $e7e441917f5d5709$var$partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        if (hasNonIncrementalResponses) {
            if (this._isSubscriptionOperation) {
                var nextID = $e7e441917f5d5709$var$generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: $e7e441917f5d5709$var$createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: $e7e441917f5d5709$var$createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups);
        }
        if (this._isSubscriptionOperation) {
            if (responsesWithData[0].extensions == null) responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && $q03Nf(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = this._normalizeResponse(response, this._operation.root, $e7e441917f5d5709$var$ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                path: [],
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            });
            $e7e441917f5d5709$var$validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $bsBg6.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        var updatedOwners = this._runPublishQueue();
        if ($ek4t1.ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES) this._updateOperationTracker(updatedOwners);
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, $e7e441917f5d5709$var$_createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case 'ModuleImportPayload':
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, $e7e441917f5d5709$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case 'ActorPayload':
                            break;
                        default:
                            followupPayload;
                            $q03Nf(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === 'SplitOperation' && followupPayload.kind === 'ModuleImportPayload') variables = $e7e441917f5d5709$var$getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = $e7e441917f5d5709$var$createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        return this._normalizeResponse({
            data: followupPayload.data
        }, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: followupPayload.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = $cCwaC(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        $e7e441917f5d5709$var$validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== 'started') return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, $e7e441917f5d5709$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = _this8._normalizeResponse(payloadPart, _this8._operation.root, $e7e441917f5d5709$var$ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                path: [],
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            });
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            return relayPayload;
        });
    };
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === 'completed') return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? 'loading_final' : 'loading_incremental';
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== 'loading_final';
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === 'loading_final') {
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === 'defer') relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    };
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case 'ModuleImportPayload':
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) this._processFollowupPayloadWithNormalizationNode(followupPayload, $cCwaC(node));
                else {
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    var networkObservable = $bc831eb90cd34dd5$exports.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    $bc831eb90cd34dd5$exports.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = $cCwaC(loadedNode);
                                            var batchAsyncModuleUpdatesFN = $ek4t1.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withDuration2 = $3adecde257784562$exports(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), duration = _withDuration2[0];
                                            _this10._log({
                                                name: 'execute.async.module',
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case 'ActorPayload':
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                $q03Nf(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    };
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join('.');
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === 'response' ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: 'placeholder',
            placeholder: placeholder
        });
        var parentID;
        if (placeholder.kind === 'stream') parentID = placeholder.parentID;
        else if (placeholder.kind === 'defer') parentID = placeholder.selector.dataID;
        else {
            placeholder;
            $q03Nf(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = $e7e441917f5d5709$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return fieldPayload.dataID === parentID || fieldID === parentID;
        });
        !(parentRecord != null) && $q03Nf(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            nextParentRecord = $jO6uW.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = $e7e441917f5d5709$var$stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    };
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf('$defer$') !== -1) {
                var pathKey = path.map(String).join('.');
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === 'response') {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === 'defer') && $q03Nf(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                var _pathKey = path.slice(0, -2).map(String).join('.');
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === 'response') {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === 'stream') && $q03Nf(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: placeholder.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $q03Nf(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions2;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $bsBg6.create(),
                isFinal: ((_response$extensions2 = response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        var field = node.selections[0];
        !(field != null && field.kind === 'LinkedField' && field.plural === true) && $q03Nf(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) return;
            var nextItems = (0, $e7e441917f5d5709$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $bsBg6.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref, _this$_getDataID;
        var data = response.data;
        !(typeof data === 'object') && $q03Nf(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $e7e441917f5d5709$var$getStorageKey(field, variables);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $q03Nf(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        var prevIDs = $jO6uW.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && $q03Nf(false);
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && $q03Nf(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[$e7e441917f5d5709$var$TYPENAME_KEY];
        !(typeof typeName === 'string') && $q03Nf(false);
        var itemID = (_ref = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref !== void 0 ? _ref : $e7e441917f5d5709$var$generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === 'string') && $q03Nf(false);
        var selector = $e7e441917f5d5709$var$createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = $jO6uW.clone(parentRecord);
        var nextIDs = (0, $e7e441917f5d5709$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $jO6uW.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: [].concat((0, $e7e441917f5d5709$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, $e7e441917f5d5709$var$_createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, $e7e441917f5d5709$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, $e7e441917f5d5709$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, $e7e441917f5d5709$var$_createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && $q03Nf(false);
        return operationLoader;
    };
    return Executor;
}();
function $e7e441917f5d5709$var$partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    responses.forEach(function(response) {
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) $q03Nf(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses
    ];
}
function $e7e441917f5d5709$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($hQyFA(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
}
function $e7e441917f5d5709$var$validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) $q03Nf(false);
}
$e7e441917f5d5709$exports = {
    execute: $e7e441917f5d5709$var$execute
};


var $2797f1e06529c47c$exports = {};
'use strict';
var $2797f1e06529c47c$var$_global$ErrorUtils$ap, $2797f1e06529c47c$var$_global$ErrorUtils;

var $1YPEa = parcelRequire("1YPEa");


var $kin3U = parcelRequire("kin3U");

var $711c56ee538a54b1$exports = {};
'use strict';



var $711c56ee538a54b1$var$ROOT_TYPE = $jZOVE.ROOT_TYPE, $711c56ee538a54b1$var$getStorageKey = $jZOVE.getStorageKey;

var $6lAfP = parcelRequire("6lAfP");

var $711c56ee538a54b1$var$_readUpdatableFragment = $6lAfP.readUpdatableFragment;

var $e48nX = parcelRequire("e48nX");

var $711c56ee538a54b1$var$_readUpdatableQuery = $e48nX.readUpdatableQuery;



var $711c56ee538a54b1$var$RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, $711c56ee538a54b1$var$ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === 'LinkedField' && selection.name === fieldName || selection.kind === 'RequiredField' && selection.field.name === fieldName;
        });
        if (field && field.kind === 'RequiredField') field = field.field;
        !(field && field.kind === 'LinkedField') && $q03Nf(false);
        !(field.plural === plural) && $q03Nf(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = $711c56ee538a54b1$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = $711c56ee538a54b1$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $711c56ee538a54b1$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $711c56ee538a54b1$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
$711c56ee538a54b1$exports = $711c56ee538a54b1$var$RelayRecordSourceSelectorProxy;



var $3oKZ4 = parcelRequire("3oKZ4");







parcelRequire("eEWwZ");

var $2797f1e06529c47c$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
var $2797f1e06529c47c$var$applyWithGuard = ($2797f1e06529c47c$var$_global$ErrorUtils$ap = $2797f1e06529c47c$var$_global === null || $2797f1e06529c47c$var$_global === void 0 ? void 0 : ($2797f1e06529c47c$var$_global$ErrorUtils = $2797f1e06529c47c$var$_global.ErrorUtils) === null || $2797f1e06529c47c$var$_global$ErrorUtils === void 0 ? void 0 : $2797f1e06529c47c$var$_global$ErrorUtils.applyWithGuard) !== null && $2797f1e06529c47c$var$_global$ErrorUtils$ap !== void 0 ? $2797f1e06529c47c$var$_global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
var $2797f1e06529c47c$var$RelayPublishQueue = /*#__PURE__*/ function() {
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && $q03Nf(false);
        this._pendingOptimisticUpdates.add(updater);
    };
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    };
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    };
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'payload',
            operation: operation,
            payload: payload,
            updater: updater
        });
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'updater',
            updater: updater
        });
    };
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'source',
            source: source
        });
    };
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        if (runIsANoop) return [];
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        return this._store.notify(sourceOperation, invalidatedStore);
    };
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new $1YPEa(this._store.getSource(), source);
        var recordSourceProxy = new $kin3U(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $q03Nf(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && $q03Nf(false);
            var recordSourceSelectorProxy = new $711c56ee538a54b1$exports(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = $2797f1e06529c47c$var$lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    };
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === 'payload') {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === 'source') {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = $bsBg6.create();
                var mutator = new $1YPEa(_this2._store.getSource(), sink);
                var recordSourceProxy = new $kin3U(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers);
                $2797f1e06529c47c$var$applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:commitData');
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    };
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = $bsBg6.create();
        var mutator = new $1YPEa(this._store.getSource(), sink);
        var recordSourceProxy = new $kin3U(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                $2797f1e06529c47c$var$applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:applyUpdates');
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = $2797f1e06529c47c$var$lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new $711c56ee538a54b1$exports(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    $2797f1e06529c47c$var$applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, 'RelayPublishQueue:applyUpdates');
                }
            }
        };
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function $2797f1e06529c47c$var$lookupSelector(source, selector) {
    var selectorData = $3oKZ4.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
$2797f1e06529c47c$exports = $2797f1e06529c47c$var$RelayPublishQueue;





parcelRequire("q03Nf");

var $80a4be38c0c6d6ee$var$RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$log, _config$relayFieldLog, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$normalizeResp, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : $80a4be38c0c6d6ee$var$emptyFunction;
        this.relayFieldLogger = (_config$relayFieldLog = config.relayFieldLogger) !== null && _config$relayFieldLog !== void 0 ? _config$relayFieldLog : $f8c22d3ea516624d$exports;
        this._defaultRenderPolicy = (_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : 'partial';
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = $43859e2619d09026$exports(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $e9MkZ;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new $2797f1e06529c47c$exports(config.store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : $cca99455e46f9cec$exports, this._getDataID, this._missingFieldHandlers);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = config.store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this._normalizeResponse = (_config$normalizeResp = config.normalizeResponse) !== null && _config$normalizeResp !== void 0 ? _config$normalizeResp : $2433602de6011eac$exports;
        this.__setNet = function(newNet) {
            return _this._network = $43859e2619d09026$exports(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new $cf13c72a303d7592$exports();
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        $0e48c2206feb3207$exports(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === 'active';
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return $bc831eb90cd34dd5$exports.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !$80a4be38c0c6d6ee$var$operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return $bc831eb90cd34dd5$exports.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = $bsBg6.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: $80a4be38c0c6d6ee$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                $80a4be38c0c6d6ee$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                $80a4be38c0c6d6ee$var$assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    };
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    };
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, $80a4be38c0c6d6ee$var$_objectSpread2["default"])((0, $80a4be38c0c6d6ee$var$_objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    };
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : '', ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return $bc831eb90cd34dd5$exports.create(function(sink) {
            var executor = $e7e441917f5d5709$exports.execute({
                actorIdentifier: $80a4be38c0c6d6ee$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    $80a4be38c0c6d6ee$var$assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    $80a4be38c0c6d6ee$var$assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater,
                normalizeResponse: _this10._normalizeResponse
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function $80a4be38c0c6d6ee$var$operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === 'Operation' && operation.root.node.clientAbstractTypes != null;
}
$80a4be38c0c6d6ee$var$RelayModernEnvironment.prototype['@@RelayModernEnvironment'] = true;
function $80a4be38c0c6d6ee$var$emptyFunction() {}
$80a4be38c0c6d6ee$exports = $80a4be38c0c6d6ee$var$RelayModernEnvironment;









var $6715958441fc8889$exports = {};
'use strict';



var $6715958441fc8889$var$_interopRequireDefault = $eGvGZ.default;

var $6715958441fc8889$var$_createForOfIteratorHelper2 = $6715958441fc8889$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $6715958441fc8889$var$_defineProperty2 = $6715958441fc8889$var$_interopRequireDefault((parcelRequire("l2SD1")));



var $6715958441fc8889$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $gf5pM.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $6715958441fc8889$var$assertInternalActorIdentifier = $gf5pM.assertInternalActorIdentifier;
parcelRequire("kiICD");





var $2qNEJ = parcelRequire("2qNEJ");


var $k4tKO = parcelRequire("k4tKO");








var $v7WaB = parcelRequire("v7WaB");





var $cJt0g = parcelRequire("cJt0g");


var $bxVYb = parcelRequire("bxVYb");







var $6715958441fc8889$var$ROOT_ID = $jZOVE.ROOT_ID, $6715958441fc8889$var$ROOT_TYPE = $jZOVE.ROOT_TYPE;

var $fYxua = parcelRequire("fYxua");

var $6715958441fc8889$var$RecordResolverCache = $fYxua.RecordResolverCache;



var $6715958441fc8889$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $6715958441fc8889$var$RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa;
        (0, $6715958441fc8889$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $6715958441fc8889$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $2qNEJ;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $e9MkZ;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $6715958441fc8889$var$RecordResolverCache(function() {
            return _this._getMutableRecordSource();
        });
        this._storeSubscriptions = new $bxVYb(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents;
        $6715958441fc8889$var$initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $6715958441fc8889$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $6715958441fc8889$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $k4tKO.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $6715958441fc8889$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return $6715958441fc8889$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = $3oKZ4.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        if ($ek4t1.ENABLE_RELAY_RESOLVERS) this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $6715958441fc8889$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'RelayModernStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $jO6uW.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $6715958441fc8889$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $q03Nf(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $v7WaB.create(this.getSource());
    };
    _proto.restore = function restore() {
        !(this._optimisticSource != null) && $q03Nf(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        top: while(true){
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $6715958441fc8889$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $cJt0g.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) continue top;
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var log = this.__log;
            if (log != null) log({
                name: 'store.gc',
                references: references
            });
            if (references.size === 0) this._recordSource.clear();
            else {
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) this._recordSource.remove(dataID);
                }
            }
            return;
        }
    };
    return RelayModernStore;
}();
function $6715958441fc8889$var$initializeRecordSource(target) {
    if (!target.has($6715958441fc8889$var$ROOT_ID)) {
        var rootRecord = $jO6uW.create($6715958441fc8889$var$ROOT_ID, $6715958441fc8889$var$ROOT_TYPE);
        target.set($6715958441fc8889$var$ROOT_ID, rootRecord);
    }
}
function $6715958441fc8889$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $jO6uW.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $jO6uW.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $jO6uW.setValue(nextRecord, $jZOVE.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $jO6uW.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $6715958441fc8889$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
$6715958441fc8889$exports = $6715958441fc8889$var$RelayModernStore;










var $lQmu3 = parcelRequire("lQmu3");


var $1uPIp = parcelRequire("1uPIp");

var $31bab7c3dcdf6cbb$exports = {};
'use strict';




var $31bab7c3dcdf6cbb$var$getRequest = $befAO.getRequest;

var $31bab7c3dcdf6cbb$var$createOperationDescriptor = $c85a09fe2966e1e2$exports.createOperationDescriptor;



var $31bab7c3dcdf6cbb$var$createReaderSelector = $75e3H.createReaderSelector;
parcelRequire("eEWwZ");

function $31bab7c3dcdf6cbb$var$requestSubscription(environment, config) {
    var subscription = $31bab7c3dcdf6cbb$var$getRequest(config.subscription);
    if (subscription.params.operationKind !== 'subscription') throw new Error('requestSubscription: Must use Subscription operation');
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = $31bab7c3dcdf6cbb$var$createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? $572030bb2a35d6c3$exports.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === 'string') selector = $31bab7c3dcdf6cbb$var$createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
$31bab7c3dcdf6cbb$exports = $31bab7c3dcdf6cbb$var$requestSubscription;


var $1a9f33d6f74168c8$exports = {};
'use strict';



var $1a9f33d6f74168c8$var$_interopRequireDefault = $eGvGZ.default;

var $1a9f33d6f74168c8$var$_objectSpread2 = $1a9f33d6f74168c8$var$_interopRequireDefault((parcelRequire("6g2zv")));



var $1a9f33d6f74168c8$var$getModuleComponentKey = $jZOVE.getModuleComponentKey, $1a9f33d6f74168c8$var$getModuleOperationKey = $jZOVE.getModuleOperationKey;
function $1a9f33d6f74168c8$var$createPayloadFor3DField(name, operation, component, response) {
    var data = (0, $1a9f33d6f74168c8$var$_objectSpread2["default"])({}, response);
    data[$1a9f33d6f74168c8$var$getModuleComponentKey(name)] = component;
    data[$1a9f33d6f74168c8$var$getModuleOperationKey(name)] = operation;
    return data;
}
$1a9f33d6f74168c8$exports = $1a9f33d6f74168c8$var$createPayloadFor3DField;



var $kiICD = parcelRequire("kiICD");

var $e7a0db431716a294$exports = {};
'use strict';



var $e7a0db431716a294$var$getDataIDsFromFragment = $75e3H.getDataIDsFromFragment, $e7a0db431716a294$var$getSelector = $75e3H.getSelector, $e7a0db431716a294$var$getVariablesFromFragment = $75e3H.getVariablesFromFragment;
var $591d8223885954df$exports = {};
'use strict';
var $591d8223885954df$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $591d8223885954df$var$isEmptyObject(obj) {
    for(var _key in obj){
        if ($591d8223885954df$var$hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
$591d8223885954df$exports = $591d8223885954df$var$isEmptyObject;









var $571eK = parcelRequire("571eK");

var $e7a0db431716a294$var$intern = $571eK.intern;
function $e7a0db431716a294$var$getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = $e7a0db431716a294$var$getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? 'null' : selector.kind === 'SingularReaderSelector' ? selector.owner.identifier : '[' + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(',') + ']';
    var fragmentVariables = $e7a0db431716a294$var$getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = $e7a0db431716a294$var$getDataIDsFromFragment(fragmentNode, fragmentRef);
    if ($ek4t1.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === 'undefined' ? 'missing' : dataIDs == null ? 'null' : Array.isArray(dataIDs) ? '[' + dataIDs.join(',') + ']' : dataIDs;
        ids = $ek4t1.STRING_INTERN_LEVEL <= 1 ? ids : $e7a0db431716a294$var$intern(ids, $ek4t1.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + (fragmentVariables == null || $591d8223885954df$exports(fragmentVariables) ? '{}' : JSON.stringify($hQyFA(fragmentVariables))) + '/' + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'missing';
        _ids = $ek4t1.STRING_INTERN_LEVEL <= 1 ? _ids : $e7a0db431716a294$var$intern(_ids, $ek4t1.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + JSON.stringify($hQyFA(fragmentVariables)) + '/' + _ids;
    }
}
$e7a0db431716a294$exports = $e7a0db431716a294$var$getFragmentIdentifier;


var $d3495b10d610aeaa$exports = {};
'use strict';
var $1a03e2dcde1c2082$exports = {};
'use strict';



function $1a03e2dcde1c2082$var$getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && $q03Nf(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && $q03Nf(false);
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== 'string') && $q03Nf(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    if (identifierInfo != null) {
        !(identifierInfo.identifierField == null || typeof identifierInfo.identifierField === 'string') && $q03Nf(false);
        !(identifierInfo.identifierQueryVariableName == null || typeof identifierInfo.identifierQueryVariableName === 'string') && $q03Nf(false);
    }
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierInfo: identifierInfo,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
$1a03e2dcde1c2082$exports = $1a03e2dcde1c2082$var$getRefetchMetadata;





function $d3495b10d610aeaa$var$getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = $1a03e2dcde1c2082$exports(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && $q03Nf(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && $q03Nf(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    !((identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) == null || typeof identifierInfo.identifierField === 'string') && $q03Nf(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
$d3495b10d610aeaa$exports = $d3495b10d610aeaa$var$getPaginationMetadata;


var $66222dae6a3fc8e5$exports = {};
'use strict';



var $66222dae6a3fc8e5$var$_interopRequireDefault = $eGvGZ.default;

var $66222dae6a3fc8e5$var$_defineProperty2 = $66222dae6a3fc8e5$var$_interopRequireDefault((parcelRequire("l2SD1")));

var $66222dae6a3fc8e5$var$_objectSpread4 = $66222dae6a3fc8e5$var$_interopRequireDefault((parcelRequire("6g2zv")));



parcelRequire("eEWwZ");

function $66222dae6a3fc8e5$var$getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === 'backward') {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && $q03Nf(false);
        var _paginationVariables = (0, $66222dae6a3fc8e5$var$_objectSpread4["default"])((0, $66222dae6a3fc8e5$var$_objectSpread4["default"])((0, $66222dae6a3fc8e5$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, $66222dae6a3fc8e5$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, $66222dae6a3fc8e5$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && $q03Nf(false);
    var paginationVariables = (0, $66222dae6a3fc8e5$var$_objectSpread4["default"])((0, $66222dae6a3fc8e5$var$_objectSpread4["default"])((0, $66222dae6a3fc8e5$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, $66222dae6a3fc8e5$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, $66222dae6a3fc8e5$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
$66222dae6a3fc8e5$exports = $66222dae6a3fc8e5$var$getPaginationVariables;








var $99ff82f6ec06f811$exports = {};
'use strict';



var $99ff82f6ec06f811$var$_interopRequireDefault = $eGvGZ.default;

var $99ff82f6ec06f811$var$_createForOfIteratorHelper2 = $99ff82f6ec06f811$var$_interopRequireDefault((parcelRequire("5YwI0")));



function $99ff82f6ec06f811$var$getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, $99ff82f6ec06f811$var$_createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === 'number') {
                !Array.isArray(result) && $q03Nf(false);
                result = result[key];
            } else {
                !(typeof result === 'object' && !Array.isArray(result)) && $q03Nf(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
$99ff82f6ec06f811$exports = $99ff82f6ec06f811$var$getValueAtPath;












var $f7irG = parcelRequire("f7irG");





var $d512ca64c9f37237$exports = {};
'use strict';
var $d512ca64c9f37237$var$profileHandlersByName = {};
var $d512ca64c9f37237$var$defaultProfiler = {
    stop: function stop() {}
};
var $d512ca64c9f37237$var$RelayProfiler = {
    profile: function profile(name, state) {
        var handlers = $d512ca64c9f37237$var$profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return $d512ca64c9f37237$var$defaultProfiler;
    },
    attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!$d512ca64c9f37237$var$profileHandlersByName.hasOwnProperty(name)) $d512ca64c9f37237$var$profileHandlersByName[name] = [];
        $d512ca64c9f37237$var$profileHandlersByName[name].push(handler);
    },
    detachProfileHandler: function detachProfileHandler(name, handler) {
        if ($d512ca64c9f37237$var$profileHandlersByName.hasOwnProperty(name)) $d512ca64c9f37237$var$removeFromArray($d512ca64c9f37237$var$profileHandlersByName[name], handler);
    }
};
function $d512ca64c9f37237$var$removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
$d512ca64c9f37237$exports = $d512ca64c9f37237$var$RelayProfiler;







var $40e7a42a5c152c35$var$mapStr, $40e7a42a5c152c35$var$setStr, $40e7a42a5c152c35$var$promiseStr, $40e7a42a5c152c35$var$objStr;
module.exports = {
    Environment: $80a4be38c0c6d6ee$exports,
    Network: $c0ee250a52593da7$exports,
    Observable: $bc831eb90cd34dd5$exports,
    QueryResponseCache: $a426543098dd08aa$exports,
    RecordSource: $bsBg6,
    Record: $jO6uW,
    ReplaySubject: $ef598fdf09302eac$exports,
    Store: $6715958441fc8889$exports,
    areEqualSelectors: $75e3H.areEqualSelectors,
    createFragmentSpecResolver: $e36628f7435615c1$exports,
    createNormalizationSelector: $75e3H.createNormalizationSelector,
    createOperationDescriptor: $c85a09fe2966e1e2$exports.createOperationDescriptor,
    createReaderSelector: $75e3H.createReaderSelector,
    createRequestDescriptor: $c85a09fe2966e1e2$exports.createRequestDescriptor,
    getArgumentValues: $jZOVE.getArgumentValues,
    getDataIDsFromFragment: $75e3H.getDataIDsFromFragment,
    getDataIDsFromObject: $75e3H.getDataIDsFromObject,
    getNode: $befAO.getNode,
    getFragment: $befAO.getFragment,
    getInlineDataFragment: $befAO.getInlineDataFragment,
    getModuleComponentKey: $jZOVE.getModuleComponentKey,
    getModuleOperationKey: $jZOVE.getModuleOperationKey,
    getPaginationFragment: $befAO.getPaginationFragment,
    getPluralSelector: $75e3H.getPluralSelector,
    getRefetchableFragment: $befAO.getRefetchableFragment,
    getRequest: $befAO.getRequest,
    getRequestIdentifier: $f9c6d9883a5e2e5c$exports,
    getSelector: $75e3H.getSelector,
    getSelectorsFromObject: $75e3H.getSelectorsFromObject,
    getSingularSelector: $75e3H.getSingularSelector,
    getStorageKey: $jZOVE.getStorageKey,
    getVariablesFromFragment: $75e3H.getVariablesFromFragment,
    getVariablesFromObject: $75e3H.getVariablesFromObject,
    getVariablesFromPluralFragment: $75e3H.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $75e3H.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: $adb61a88756c1d17$exports,
    graphql: $befAO.graphql,
    isFragment: $befAO.isFragment,
    isInlineDataFragment: $befAO.isInlineDataFragment,
    isSuspenseSentinel: $40e7a42a5c152c35$var$isSuspenseSentinel,
    suspenseSentinel: $40e7a42a5c152c35$var$suspenseSentinel,
    isRequest: $befAO.isRequest,
    readInlineData: $d72c09e83c8c63ea$exports,
    MutationTypes: $572030bb2a35d6c3$exports.MutationTypes,
    RangeOperations: $572030bb2a35d6c3$exports.RangeOperations,
    DefaultHandlerProvider: $cca99455e46f9cec$exports,
    ConnectionHandler: $57525bba5d60eb62$exports,
    MutationHandlers: $18f563715feefed6$exports,
    VIEWER_ID: $1uPIp.VIEWER_ID,
    VIEWER_TYPE: $1uPIp.VIEWER_TYPE,
    applyOptimisticMutation: $03bd9bb249baf9e0$exports,
    commitLocalUpdate: $7ffad1bf7c1a523f$exports,
    commitMutation: $e75c52f4cdee6bbc$exports,
    fetchQuery: $34c6b65fcb8f94bf$exports,
    fetchQuery_DEPRECATED: $46a956a4d5cb813d$exports,
    isRelayModernEnvironment: $e80875a03a3119eb$exports,
    requestSubscription: $31bab7c3dcdf6cbb$exports,
    ConnectionInterface: $4357197e55b7bed0$exports,
    PreloadableQueryRegistry: $f08a4d3012c085bf$exports,
    RelayProfiler: $d512ca64c9f37237$exports,
    createPayloadFor3DField: $1a9f33d6f74168c8$exports,
    RelayConcreteNode: $ceyF6,
    RelayError: $9d62b7bbb186e2a3$exports,
    RelayFeatureFlags: $ek4t1,
    DEFAULT_HANDLE_KEY: $f7irG.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: $jZOVE.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: $jZOVE.FRAGMENT_OWNER_KEY,
    ID_KEY: $jZOVE.ID_KEY,
    REF_KEY: $jZOVE.REF_KEY,
    REFS_KEY: $jZOVE.REFS_KEY,
    ROOT_ID: $jZOVE.ROOT_ID,
    ROOT_TYPE: $jZOVE.ROOT_TYPE,
    TYPENAME_KEY: $jZOVE.TYPENAME_KEY,
    deepFreeze: $kiICD,
    generateClientID: $40e7a42a5c152c35$var$generateClientID,
    generateUniqueClientID: $40e7a42a5c152c35$var$generateUniqueClientID,
    getRelayHandleKey: $6TFlP,
    isClientID: $40e7a42a5c152c35$var$isClientID,
    isPromise: $4bec3f38163c33d4$exports,
    isScalarAndEqual: $3d6d39ec5eeed659$exports,
    recycleNodesInto: $kU32t,
    stableCopy: $hQyFA,
    getFragmentIdentifier: $e7a0db431716a294$exports,
    getRefetchMetadata: $1a03e2dcde1c2082$exports,
    getPaginationMetadata: $d3495b10d610aeaa$exports,
    getPaginationVariables: $66222dae6a3fc8e5$exports,
    getPendingOperationsForFragment: $b7a8c75ef88b6a92$exports,
    getValueAtPath: $99ff82f6ec06f811$exports,
    __internal: {
        ResolverFragments: $lQmu3,
        OperationTracker: $cf13c72a303d7592$exports,
        createRelayContext: $6d99152a4e5c556c$exports,
        getOperationVariables: $dMDnw.getOperationVariables,
        getLocalVariables: $dMDnw.getLocalVariables,
        fetchQuery: $2477bd787cf8c706$exports.fetchQuery,
        fetchQueryDeduped: $2477bd787cf8c706$exports.fetchQueryDeduped,
        getPromiseForActiveRequest: $2477bd787cf8c706$exports.getPromiseForActiveRequest,
        getObservableForActiveRequest: $2477bd787cf8c706$exports.getObservableForActiveRequest,
        normalizeResponse: $2433602de6011eac$exports,
        withProvidedVariables: $597cc922188e47e7$exports
    }
};

});

parcelRegister("ek4t1", function(module, exports) {
'use strict';
var $a6d6660124aa78ae$var$RelayFeatureFlags = {
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_LOAD_QUERY_REQUEST_DEDUPING: true,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    LOG_MISSING_RECORDS_IN_PROD: false,
    ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION: false,
    ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES: false,
    ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE: false,
    ENABLE_FIELD_ERROR_HANDLING: false,
    ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT: false,
    ENABLE_FIELD_ERROR_HANDLING_CATCH_DIRECTIVE: false,
    PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION: false,
    MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD: false
};
module.exports = $a6d6660124aa78ae$var$RelayFeatureFlags;

});

parcelRegister("eGvGZ", function(module, exports) {
function $ab0d92605cfae571$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $ab0d92605cfae571$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aUSZ9", function(module, exports) {

var $9CxbP = parcelRequire("9CxbP");


var $dQXcU = parcelRequire("dQXcU");


var $dLmhD = parcelRequire("dLmhD");


var $6OV2B = parcelRequire("6OV2B");

function $7f29c946f3db0506$var$_toConsumableArray(r) {
    return $9CxbP(r) || $dQXcU(r) || $dLmhD(r) || $6OV2B();
}
module.exports = $7f29c946f3db0506$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5YwI0", function(module, exports) {

var $dLmhD = parcelRequire("dLmhD");

function $459bed9f343fd8b5$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $dLmhD(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = $459bed9f343fd8b5$var$_createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6g2zv", function(module, exports) {

var $l2SD1 = parcelRequire("l2SD1");

function $48e63b5c23438773$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $48e63b5c23438773$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $48e63b5c23438773$var$ownKeys(Object(t), !0).forEach(function(r) {
            $l2SD1(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $48e63b5c23438773$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $48e63b5c23438773$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("l2SD1", function(module, exports) {

var $atzas = parcelRequire("atzas");

function $f52428f60ad3d9c4$var$_defineProperty(e, r, t) {
    return (r = $atzas(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $f52428f60ad3d9c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("atzas", function(module, exports) {

var $crVe8 = parcelRequire("crVe8");

var $7a07e45cfbd468ef$var$_typeof = $crVe8.default;

var $8numO = parcelRequire("8numO");

function $7a07e45cfbd468ef$var$toPropertyKey(t) {
    var i = $8numO(t, "string");
    return "symbol" == $7a07e45cfbd468ef$var$_typeof(i) ? i : i + "";
}
module.exports = $7a07e45cfbd468ef$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("crVe8", function(module, exports) {
function $910465c15fa4cd69$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $910465c15fa4cd69$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $910465c15fa4cd69$var$_typeof(o);
}
module.exports = $910465c15fa4cd69$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6Ahnn", function(module, exports) {
function $4cb39561269a2eff$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $4cb39561269a2eff$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lNM3R", function(module, exports) {

var $gHZmH = parcelRequire("gHZmH");

function $fdf374868a8d47ce$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $gHZmH(t, o);
}
module.exports = $fdf374868a8d47ce$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gHZmH", function(module, exports) {
function $c2a04355d3a0a989$var$_setPrototypeOf(t, e) {
    return module.exports = $c2a04355d3a0a989$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $c2a04355d3a0a989$var$_setPrototypeOf(t, e);
}
module.exports = $c2a04355d3a0a989$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7w1RD", function(module, exports) {

var $18f43 = parcelRequire("18f43");


var $gHZmH = parcelRequire("gHZmH");


var $lr3oT = parcelRequire("lr3oT");


var $ga7FX = parcelRequire("ga7FX");

function $578cf7b720220db3$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $578cf7b720220db3$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$lr3oT(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $ga7FX(t, arguments, $18f43(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $gHZmH(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $578cf7b720220db3$var$_wrapNativeSuper(t);
}
module.exports = $578cf7b720220db3$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("18f43", function(module, exports) {
function $0d32394a09e156ce$var$_getPrototypeOf(t) {
    return module.exports = $0d32394a09e156ce$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $0d32394a09e156ce$var$_getPrototypeOf(t);
}
module.exports = $0d32394a09e156ce$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jO6uW", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $e6b7ba3bc9bc0b82$var$_interopRequireDefault = $eGvGZ.default;

var $e6b7ba3bc9bc0b82$var$_defineProperty2 = $e6b7ba3bc9bc0b82$var$_interopRequireDefault((parcelRequire("l2SD1")));

var $e6b7ba3bc9bc0b82$var$_objectWithoutPropertiesLoose2 = $e6b7ba3bc9bc0b82$var$_interopRequireDefault((parcelRequire("6Ahnn")));

var $e6b7ba3bc9bc0b82$var$_toPropertyKey2 = $e6b7ba3bc9bc0b82$var$_interopRequireDefault((parcelRequire("atzas")));

var $e6b7ba3bc9bc0b82$var$_objectSpread2 = $e6b7ba3bc9bc0b82$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $kiICD = parcelRequire("kiICD");


var $fub1S = parcelRequire("fub1S");

var $e6b7ba3bc9bc0b82$var$generateClientObjectClientID = $fub1S.generateClientObjectClientID, $e6b7ba3bc9bc0b82$var$isClientID = $fub1S.isClientID;

var $fusLc = parcelRequire("fusLc");

var $e6b7ba3bc9bc0b82$var$isSuspenseSentinel = $fusLc.isSuspenseSentinel;

var $jZOVE = parcelRequire("jZOVE");

var $e6b7ba3bc9bc0b82$var$ACTOR_IDENTIFIER_KEY = $jZOVE.ACTOR_IDENTIFIER_KEY, $e6b7ba3bc9bc0b82$var$ERRORS_KEY = $jZOVE.ERRORS_KEY, $e6b7ba3bc9bc0b82$var$ID_KEY = $jZOVE.ID_KEY, $e6b7ba3bc9bc0b82$var$INVALIDATED_AT_KEY = $jZOVE.INVALIDATED_AT_KEY, $e6b7ba3bc9bc0b82$var$REF_KEY = $jZOVE.REF_KEY, $e6b7ba3bc9bc0b82$var$REFS_KEY = $jZOVE.REFS_KEY, $e6b7ba3bc9bc0b82$var$RELAY_RESOLVER_VALUE_KEY = $jZOVE.RELAY_RESOLVER_VALUE_KEY, $e6b7ba3bc9bc0b82$var$ROOT_ID = $jZOVE.ROOT_ID, $e6b7ba3bc9bc0b82$var$TYPENAME_KEY = $jZOVE.TYPENAME_KEY;

var $8w3GE = parcelRequire("8w3GE");


var $q03Nf = parcelRequire("q03Nf");

parcelRequire("eEWwZ");

function $e6b7ba3bc9bc0b82$var$clone(record) {
    return (0, $e6b7ba3bc9bc0b82$var$_objectSpread2["default"])({}, record);
}
function $e6b7ba3bc9bc0b82$var$copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== $e6b7ba3bc9bc0b82$var$ID_KEY && key !== $e6b7ba3bc9bc0b82$var$TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
function $e6b7ba3bc9bc0b82$var$create(dataID, typeName) {
    var record = {};
    record[$e6b7ba3bc9bc0b82$var$ID_KEY] = dataID;
    record[$e6b7ba3bc9bc0b82$var$TYPENAME_KEY] = typeName;
    return record;
}
function $e6b7ba3bc9bc0b82$var$fromObject(json) {
    return json;
}
function $e6b7ba3bc9bc0b82$var$getDataID(record) {
    return record[$e6b7ba3bc9bc0b82$var$ID_KEY];
}
function $e6b7ba3bc9bc0b82$var$getFields(record) {
    if ($e6b7ba3bc9bc0b82$var$ERRORS_KEY in record) return Object.keys(record).filter(function(field) {
        return field !== $e6b7ba3bc9bc0b82$var$ERRORS_KEY;
    });
    return Object.keys(record);
}
function $e6b7ba3bc9bc0b82$var$getType(record) {
    return record[$e6b7ba3bc9bc0b82$var$TYPENAME_KEY];
}
function $e6b7ba3bc9bc0b82$var$getErrors(record, storageKey) {
    var _record$ERRORS_KEY;
    return (_record$ERRORS_KEY = record[$e6b7ba3bc9bc0b82$var$ERRORS_KEY]) === null || _record$ERRORS_KEY === void 0 ? void 0 : _record$ERRORS_KEY[storageKey];
}
function $e6b7ba3bc9bc0b82$var$getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === 'object') !(!value.hasOwnProperty($e6b7ba3bc9bc0b82$var$REF_KEY) && !value.hasOwnProperty($e6b7ba3bc9bc0b82$var$REFS_KEY)) && $q03Nf(false);
    return value;
}
function $e6b7ba3bc9bc0b82$var$hasValue(record, storageKey) {
    return storageKey in record;
}
function $e6b7ba3bc9bc0b82$var$getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    var link = maybeLink;
    !(typeof link === 'object' && link && typeof link[$e6b7ba3bc9bc0b82$var$REF_KEY] === 'string') && $q03Nf(false);
    return link[$e6b7ba3bc9bc0b82$var$REF_KEY];
}
function $e6b7ba3bc9bc0b82$var$hasLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return false;
    var link = maybeLink;
    return typeof link === 'object' && link && typeof link[$e6b7ba3bc9bc0b82$var$REF_KEY] === 'string';
}
function $e6b7ba3bc9bc0b82$var$getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === 'object' && Array.isArray(links[$e6b7ba3bc9bc0b82$var$REFS_KEY])) && $q03Nf(false);
    return links[$e6b7ba3bc9bc0b82$var$REFS_KEY];
}
function $e6b7ba3bc9bc0b82$var$hasLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return false;
    return typeof links === 'object' && Array.isArray(links[$e6b7ba3bc9bc0b82$var$REFS_KEY]) && links[$e6b7ba3bc9bc0b82$var$REFS_KEY].every(function(link) {
        return typeof link === 'string';
    });
}
function $e6b7ba3bc9bc0b82$var$getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[$e6b7ba3bc9bc0b82$var$INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== 'number') return null;
    return invalidatedAt;
}
function $e6b7ba3bc9bc0b82$var$update(prevRecord, nextRecord) {
    var _updated2;
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var prevErrorsByKey = prevRecord[$e6b7ba3bc9bc0b82$var$ERRORS_KEY];
    var nextErrorsByKey = nextRecord[$e6b7ba3bc9bc0b82$var$ERRORS_KEY];
    var updated = null;
    if (prevErrorsByKey == null && nextErrorsByKey == null) {
        var _updated;
        for(var storageKey in nextRecord)if (updated || !$8w3GE(prevRecord[storageKey], nextRecord[storageKey])) {
            updated = updated !== null ? updated : (0, $e6b7ba3bc9bc0b82$var$_objectSpread2["default"])({}, prevRecord);
            updated[storageKey] = nextRecord[storageKey];
        }
        return (_updated = updated) !== null && _updated !== void 0 ? _updated : prevRecord;
    }
    for(var _storageKey2 in nextRecord){
        if (_storageKey2 === $e6b7ba3bc9bc0b82$var$ERRORS_KEY) continue;
        var nextValue = nextRecord[_storageKey2];
        var nextErrors = nextErrorsByKey === null || nextErrorsByKey === void 0 ? void 0 : nextErrorsByKey[_storageKey2];
        if (updated == null) {
            var prevValue = prevRecord[_storageKey2];
            var prevErrors = prevErrorsByKey === null || prevErrorsByKey === void 0 ? void 0 : prevErrorsByKey[_storageKey2];
            if ($8w3GE(prevValue, nextValue) && $8w3GE(prevErrors, nextErrors)) continue;
            updated = (0, $e6b7ba3bc9bc0b82$var$_objectSpread2["default"])({}, prevRecord);
            if (prevErrorsByKey != null) updated[$e6b7ba3bc9bc0b82$var$ERRORS_KEY] = (0, $e6b7ba3bc9bc0b82$var$_objectSpread2["default"])({}, prevErrorsByKey);
        }
        $e6b7ba3bc9bc0b82$var$setValue(updated, _storageKey2, nextValue);
        $e6b7ba3bc9bc0b82$var$setErrors(updated, _storageKey2, nextErrors);
    }
    return (_updated2 = updated) !== null && _updated2 !== void 0 ? _updated2 : prevRecord;
}
function $e6b7ba3bc9bc0b82$var$merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    if ($e6b7ba3bc9bc0b82$var$ERRORS_KEY in record1 || $e6b7ba3bc9bc0b82$var$ERRORS_KEY in record2) {
        var errors1 = record1[$e6b7ba3bc9bc0b82$var$ERRORS_KEY], fields1 = (0, $e6b7ba3bc9bc0b82$var$_objectWithoutPropertiesLoose2["default"])(record1, [
            $e6b7ba3bc9bc0b82$var$ERRORS_KEY
        ].map($e6b7ba3bc9bc0b82$var$_toPropertyKey2["default"]));
        var errors2 = record2[$e6b7ba3bc9bc0b82$var$ERRORS_KEY], fields2 = (0, $e6b7ba3bc9bc0b82$var$_objectWithoutPropertiesLoose2["default"])(record2, [
            $e6b7ba3bc9bc0b82$var$ERRORS_KEY
        ].map($e6b7ba3bc9bc0b82$var$_toPropertyKey2["default"]));
        var updated = (0, $e6b7ba3bc9bc0b82$var$_objectSpread2["default"])((0, $e6b7ba3bc9bc0b82$var$_objectSpread2["default"])({}, fields1), fields2);
        if (errors1 == null && errors2 == null) return updated;
        var updatedErrors = {};
        for(var storageKey in errors1){
            if (fields2.hasOwnProperty(storageKey)) continue;
            updatedErrors[storageKey] = errors1[storageKey];
        }
        for(var _storageKey3 in errors2)updatedErrors[_storageKey3] = errors2[_storageKey3];
        for(var _storageKey in updatedErrors){
            updated[$e6b7ba3bc9bc0b82$var$ERRORS_KEY] = updatedErrors;
            break;
        }
        return updated;
    } else return (0, $e6b7ba3bc9bc0b82$var$_objectSpread2["default"])((0, $e6b7ba3bc9bc0b82$var$_objectSpread2["default"])({}, record1), record2);
}
function $e6b7ba3bc9bc0b82$var$freeze(record) {
    $kiICD(record);
}
function $e6b7ba3bc9bc0b82$var$setErrors(record, storageKey, errors) {
    var errorsByStorageKey = record[$e6b7ba3bc9bc0b82$var$ERRORS_KEY];
    if (errors != null && errors.length > 0) {
        if (errorsByStorageKey == null) record[$e6b7ba3bc9bc0b82$var$ERRORS_KEY] = (0, $e6b7ba3bc9bc0b82$var$_defineProperty2["default"])({}, storageKey, errors);
        else errorsByStorageKey[storageKey] = errors;
    } else if (errorsByStorageKey != null) {
        if (delete errorsByStorageKey[storageKey]) {
            for(var otherStorageKey in errorsByStorageKey){
                if (errorsByStorageKey.hasOwnProperty(otherStorageKey)) return;
            }
            delete record[$e6b7ba3bc9bc0b82$var$ERRORS_KEY];
        }
    }
}
function $e6b7ba3bc9bc0b82$var$setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
function $e6b7ba3bc9bc0b82$var$setLinkedRecordID(record, storageKey, linkedID) {
    var link = {};
    link[$e6b7ba3bc9bc0b82$var$REF_KEY] = linkedID;
    record[storageKey] = link;
}
function $e6b7ba3bc9bc0b82$var$setLinkedRecordIDs(record, storageKey, linkedIDs) {
    var links = {};
    links[$e6b7ba3bc9bc0b82$var$REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
function $e6b7ba3bc9bc0b82$var$setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    var link = {};
    link[$e6b7ba3bc9bc0b82$var$REF_KEY] = linkedID;
    link[$e6b7ba3bc9bc0b82$var$ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
function $e6b7ba3bc9bc0b82$var$getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === 'object' && typeof link[$e6b7ba3bc9bc0b82$var$REF_KEY] === 'string' && link[$e6b7ba3bc9bc0b82$var$ACTOR_IDENTIFIER_KEY] != null) && $q03Nf(false);
    return [
        link[$e6b7ba3bc9bc0b82$var$ACTOR_IDENTIFIER_KEY],
        link[$e6b7ba3bc9bc0b82$var$REF_KEY]
    ];
}
function $e6b7ba3bc9bc0b82$var$getResolverLinkedRecordID(record, typeName) {
    var id = $e6b7ba3bc9bc0b82$var$getValue(record, $e6b7ba3bc9bc0b82$var$RELAY_RESOLVER_VALUE_KEY);
    if (id == null || $e6b7ba3bc9bc0b82$var$isSuspenseSentinel(id)) return null;
    if (typeof id === 'object') id = id.id;
    !(typeof id === 'string') && $q03Nf(false);
    return $e6b7ba3bc9bc0b82$var$generateClientObjectClientID(typeName, id);
}
function $e6b7ba3bc9bc0b82$var$getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = $e6b7ba3bc9bc0b82$var$getValue(record, $e6b7ba3bc9bc0b82$var$RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || $e6b7ba3bc9bc0b82$var$isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && $q03Nf(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        if (typeof id === 'object') id = id.id;
        !(typeof id === 'string') && $q03Nf(false);
        return $e6b7ba3bc9bc0b82$var$generateClientObjectClientID(typeName, id);
    });
}
function $e6b7ba3bc9bc0b82$var$toJSON(record) {
    return record;
}
module.exports = {
    clone: $e6b7ba3bc9bc0b82$var$clone,
    copyFields: $e6b7ba3bc9bc0b82$var$copyFields,
    create: $e6b7ba3bc9bc0b82$var$create,
    freeze: $e6b7ba3bc9bc0b82$var$freeze,
    fromObject: $e6b7ba3bc9bc0b82$var$fromObject,
    getDataID: $e6b7ba3bc9bc0b82$var$getDataID,
    getErrors: $e6b7ba3bc9bc0b82$var$getErrors,
    getFields: $e6b7ba3bc9bc0b82$var$getFields,
    getInvalidationEpoch: $e6b7ba3bc9bc0b82$var$getInvalidationEpoch,
    getLinkedRecordID: $e6b7ba3bc9bc0b82$var$getLinkedRecordID,
    getLinkedRecordIDs: $e6b7ba3bc9bc0b82$var$getLinkedRecordIDs,
    getType: $e6b7ba3bc9bc0b82$var$getType,
    getValue: $e6b7ba3bc9bc0b82$var$getValue,
    hasValue: $e6b7ba3bc9bc0b82$var$hasValue,
    hasLinkedRecordID: $e6b7ba3bc9bc0b82$var$hasLinkedRecordID,
    hasLinkedRecordIDs: $e6b7ba3bc9bc0b82$var$hasLinkedRecordIDs,
    merge: $e6b7ba3bc9bc0b82$var$merge,
    setErrors: $e6b7ba3bc9bc0b82$var$setErrors,
    setValue: $e6b7ba3bc9bc0b82$var$setValue,
    setLinkedRecordID: $e6b7ba3bc9bc0b82$var$setLinkedRecordID,
    setLinkedRecordIDs: $e6b7ba3bc9bc0b82$var$setLinkedRecordIDs,
    update: $e6b7ba3bc9bc0b82$var$update,
    getActorLinkedRecordID: $e6b7ba3bc9bc0b82$var$getActorLinkedRecordID,
    setActorLinkedRecordID: $e6b7ba3bc9bc0b82$var$setActorLinkedRecordID,
    getResolverLinkedRecordID: $e6b7ba3bc9bc0b82$var$getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: $e6b7ba3bc9bc0b82$var$getResolverLinkedRecordIDs,
    toJSON: $e6b7ba3bc9bc0b82$var$toJSON
};

});

parcelRegister("bsBg6", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $857f3608f8c805fe$var$_interopRequireDefault = $eGvGZ.default;

var $857f3608f8c805fe$var$_createForOfIteratorHelper2 = $857f3608f8c805fe$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $jO6uW = parcelRequire("jO6uW");


var $eFVpV = parcelRequire("eFVpV");

var $857f3608f8c805fe$var$EXISTENT = $eFVpV.EXISTENT, $857f3608f8c805fe$var$NONEXISTENT = $eFVpV.NONEXISTENT, $857f3608f8c805fe$var$UNKNOWN = $eFVpV.UNKNOWN;
var $857f3608f8c805fe$var$RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            var object = records[key];
            var record = $jO6uW.fromObject(object);
            _this._records.set(key, record);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return $857f3608f8c805fe$var$UNKNOWN;
        return this._records.get(dataID) == null ? $857f3608f8c805fe$var$NONEXISTENT : $857f3608f8c805fe$var$EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, $857f3608f8c805fe$var$_createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], record = _step$value[1];
                obj[key] = $jO6uW.toJSON(record);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = $857f3608f8c805fe$var$RelayRecordSource;

});

parcelRegister("5uj6g", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $3fee91f26116c8a1$var$_interopRequireDefault = $eGvGZ.default;

var $3fee91f26116c8a1$var$_createForOfIteratorHelper2 = $3fee91f26116c8a1$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $3fee91f26116c8a1$var$_toConsumableArray2 = $3fee91f26116c8a1$var$_interopRequireDefault((parcelRequire("aUSZ9")));
var $293412c6b65f2533$exports = {};
'use strict';
var $293412c6b65f2533$var$ACTOR_IDENTIFIER_FIELD_NAME = 'actor_key';

var $gf5pM = parcelRequire("gf5pM");

var $293412c6b65f2533$var$getActorIdentifier = $gf5pM.getActorIdentifier;
function $293412c6b65f2533$var$getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === 'object' && typeof payload[$293412c6b65f2533$var$ACTOR_IDENTIFIER_FIELD_NAME] === 'string') return $293412c6b65f2533$var$getActorIdentifier(payload[$293412c6b65f2533$var$ACTOR_IDENTIFIER_FIELD_NAME]);
}
$293412c6b65f2533$exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: $293412c6b65f2533$var$ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: $293412c6b65f2533$var$getActorIdentifierFromPayload
};


var $3fee91f26116c8a1$var$ACTOR_IDENTIFIER_FIELD_NAME = $293412c6b65f2533$exports.ACTOR_IDENTIFIER_FIELD_NAME, $3fee91f26116c8a1$var$getActorIdentifierFromPayload = $293412c6b65f2533$exports.getActorIdentifierFromPayload;

var $ceyF6 = parcelRequire("ceyF6");

var $3fee91f26116c8a1$var$ACTOR_CHANGE = $ceyF6.ACTOR_CHANGE, $3fee91f26116c8a1$var$CLIENT_COMPONENT = $ceyF6.CLIENT_COMPONENT, $3fee91f26116c8a1$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $ceyF6.CLIENT_EDGE_TO_CLIENT_OBJECT, $3fee91f26116c8a1$var$CLIENT_EXTENSION = $ceyF6.CLIENT_EXTENSION, $3fee91f26116c8a1$var$CONDITION = $ceyF6.CONDITION, $3fee91f26116c8a1$var$DEFER = $ceyF6.DEFER, $3fee91f26116c8a1$var$FRAGMENT_SPREAD = $ceyF6.FRAGMENT_SPREAD, $3fee91f26116c8a1$var$INLINE_FRAGMENT = $ceyF6.INLINE_FRAGMENT, $3fee91f26116c8a1$var$LINKED_FIELD = $ceyF6.LINKED_FIELD, $3fee91f26116c8a1$var$LINKED_HANDLE = $ceyF6.LINKED_HANDLE, $3fee91f26116c8a1$var$MODULE_IMPORT = $ceyF6.MODULE_IMPORT, $3fee91f26116c8a1$var$RELAY_LIVE_RESOLVER = $ceyF6.RELAY_LIVE_RESOLVER, $3fee91f26116c8a1$var$RELAY_RESOLVER = $ceyF6.RELAY_RESOLVER, $3fee91f26116c8a1$var$SCALAR_FIELD = $ceyF6.SCALAR_FIELD, $3fee91f26116c8a1$var$SCALAR_HANDLE = $ceyF6.SCALAR_HANDLE, $3fee91f26116c8a1$var$STREAM = $ceyF6.STREAM, $3fee91f26116c8a1$var$TYPE_DISCRIMINATOR = $ceyF6.TYPE_DISCRIMINATOR;

var $fub1S = parcelRequire("fub1S");

var $3fee91f26116c8a1$var$generateClientID = $fub1S.generateClientID, $3fee91f26116c8a1$var$isClientID = $fub1S.isClientID;

var $dMDnw = parcelRequire("dMDnw");

var $3fee91f26116c8a1$var$getLocalVariables = $dMDnw.getLocalVariables;

var $lBYAg = parcelRequire("lBYAg");

var $3fee91f26116c8a1$var$buildErrorTrie = $lBYAg.buildErrorTrie, $3fee91f26116c8a1$var$getErrorsByKey = $lBYAg.getErrorsByKey, $3fee91f26116c8a1$var$getNestedErrorTrieByKey = $lBYAg.getNestedErrorTrieByKey;

var $jO6uW = parcelRequire("jO6uW");


var $75e3H = parcelRequire("75e3H");

var $3fee91f26116c8a1$var$createNormalizationSelector = $75e3H.createNormalizationSelector;

var $jZOVE = parcelRequire("jZOVE");

var $3fee91f26116c8a1$var$ROOT_ID = $jZOVE.ROOT_ID, $3fee91f26116c8a1$var$TYPENAME_KEY = $jZOVE.TYPENAME_KEY, $3fee91f26116c8a1$var$getArgumentValues = $jZOVE.getArgumentValues, $3fee91f26116c8a1$var$getHandleStorageKey = $jZOVE.getHandleStorageKey, $3fee91f26116c8a1$var$getModuleComponentKey = $jZOVE.getModuleComponentKey, $3fee91f26116c8a1$var$getModuleOperationKey = $jZOVE.getModuleOperationKey, $3fee91f26116c8a1$var$getStorageKey = $jZOVE.getStorageKey;

var $a1r1h = parcelRequire("a1r1h");

var $3fee91f26116c8a1$var$TYPE_SCHEMA_TYPE = $a1r1h.TYPE_SCHEMA_TYPE, $3fee91f26116c8a1$var$generateTypeID = $a1r1h.generateTypeID;
parcelRequire("8w3GE");


var $q03Nf = parcelRequire("q03Nf");

parcelRequire("eEWwZ");

function $3fee91f26116c8a1$var$normalize(recordSource, selector, response, options, errors) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new $3fee91f26116c8a1$var$RelayResponseNormalizer(recordSource, variables, options);
    return normalizer.normalizeResponse(node, dataID, response, errors);
}
var $3fee91f26116c8a1$var$RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._followupPayloads = [];
        this._path = options.path ? (0, $3fee91f26116c8a1$var$_toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data, errors) {
        var record = this._recordSource.get(dataID);
        !record && $q03Nf(false);
        this._assignClientAbstractTypes(node);
        this._errorTrie = $3fee91f26116c8a1$var$buildErrorTrie(errors);
        this._traverseSelections(node, record, data);
        return {
            errors: errors,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, $3fee91f26116c8a1$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = $3fee91f26116c8a1$var$generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $jO6uW.create(typeID, $3fee91f26116c8a1$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $jO6uW.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $q03Nf(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[$3fee91f26116c8a1$var$TYPENAME_KEY];
        !(typeName != null) && $q03Nf(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case $3fee91f26116c8a1$var$SCALAR_FIELD:
                case $3fee91f26116c8a1$var$LINKED_FIELD:
                    this._normalizeField(selection, record, data);
                    break;
                case $3fee91f26116c8a1$var$CONDITION:
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case $3fee91f26116c8a1$var$FRAGMENT_SPREAD:
                    var prevVariables = this._variables;
                    this._variables = $3fee91f26116c8a1$var$getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case $3fee91f26116c8a1$var$INLINE_FRAGMENT:
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = $jO6uW.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = data.hasOwnProperty(abstractKey);
                        var _typeName = $jO6uW.getType(record);
                        var typeID = $3fee91f26116c8a1$var$generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = $jO6uW.create(typeID, $3fee91f26116c8a1$var$TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        $jO6uW.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case $3fee91f26116c8a1$var$TYPE_DISCRIMINATOR:
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = data.hasOwnProperty(_abstractKey);
                    var _typeName2 = $jO6uW.getType(record);
                    var _typeID = $3fee91f26116c8a1$var$generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = $jO6uW.create(_typeID, $3fee91f26116c8a1$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    $jO6uW.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case $3fee91f26116c8a1$var$LINKED_HANDLE:
                case $3fee91f26116c8a1$var$SCALAR_HANDLE:
                    var args = selection.args ? $3fee91f26116c8a1$var$getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = $3fee91f26116c8a1$var$getStorageKey(selection, this._variables);
                    var handleKey = $3fee91f26116c8a1$var$getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: $jO6uW.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? $3fee91f26116c8a1$var$getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case $3fee91f26116c8a1$var$MODULE_IMPORT:
                    this._normalizeModuleImport(selection, record, data);
                    break;
                case $3fee91f26116c8a1$var$DEFER:
                    this._normalizeDefer(selection, record, data);
                    break;
                case $3fee91f26116c8a1$var$STREAM:
                    this._normalizeStream(selection, record, data);
                    break;
                case $3fee91f26116c8a1$var$CLIENT_EXTENSION:
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case $3fee91f26116c8a1$var$CLIENT_COMPONENT:
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case $3fee91f26116c8a1$var$ACTOR_CHANGE:
                    this._normalizeActorChange(selection, record, data);
                    break;
                case $3fee91f26116c8a1$var$RELAY_RESOLVER:
                    this._normalizeResolver(selection, record, data);
                    break;
                case $3fee91f26116c8a1$var$RELAY_LIVE_RESOLVER:
                    this._normalizeResolver(selection, record, data);
                    break;
                case $3fee91f26116c8a1$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    $q03Nf(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) this._traverseSelections(defer, record, data);
        else this._incrementalPlaceholders.push({
            kind: 'defer',
            data: data,
            label: defer.label,
            path: (0, $3fee91f26116c8a1$var$_toConsumableArray2["default"])(this._path),
            selector: $3fee91f26116c8a1$var$createNormalizationSelector(defer, $jO6uW.getDataID(record), this._variables),
            typeName: $jO6uW.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) this._incrementalPlaceholders.push({
            kind: 'stream',
            label: stream.label,
            path: (0, $3fee91f26116c8a1$var$_toConsumableArray2["default"])(this._path),
            parentID: $jO6uW.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(moduleImport, record, data) {
        !(typeof data === 'object' && data) && $q03Nf(false);
        var typeName = $jO6uW.getType(record);
        var componentKey = $3fee91f26116c8a1$var$getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        $jO6uW.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = $3fee91f26116c8a1$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        $jO6uW.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: 'ModuleImportPayload',
            args: moduleImport.args,
            data: data,
            dataID: $jO6uW.getDataID(record),
            operationReference: operationReference,
            path: (0, $3fee91f26116c8a1$var$_toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(selection, record, data) {
        !(typeof data === 'object' && data) && $q03Nf(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = $3fee91f26116c8a1$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $jO6uW.setValue(record, storageKey, null);
            var errorTrie = this._errorTrie;
            if (errorTrie != null) {
                var errors = $3fee91f26116c8a1$var$getErrorsByKey(errorTrie, responseKey);
                if (errors != null) $jO6uW.setErrors(record, storageKey, errors);
            }
            return;
        }
        if (selection.kind === $3fee91f26116c8a1$var$SCALAR_FIELD) $jO6uW.setValue(record, storageKey, fieldValue);
        else if (selection.kind === $3fee91f26116c8a1$var$LINKED_FIELD) {
            this._path.push(responseKey);
            var oldErrorTrie = this._errorTrie;
            this._errorTrie = oldErrorTrie == null ? null : $3fee91f26116c8a1$var$getNestedErrorTrieByKey(oldErrorTrie, responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._errorTrie = oldErrorTrie;
            this._path.pop();
        } else {
            selection;
            $q03Nf(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === 'object' && data) && $q03Nf(false);
        var responseKey = field.alias || field.name;
        var storageKey = $3fee91f26116c8a1$var$getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $jO6uW.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = $3fee91f26116c8a1$var$getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            $jO6uW.setValue(record, storageKey, null);
            return;
        }
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(fieldValue, typeName) || $jO6uW.getLinkedRecordID(record, storageKey) || $3fee91f26116c8a1$var$generateClientID($jO6uW.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $q03Nf(false);
        $jO6uW.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: 'ActorPayload',
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, $3fee91f26116c8a1$var$_toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === 'object' && fieldValue) && $q03Nf(false);
        var nextID = this._getDataId(fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || $jO6uW.getLinkedRecordID(record, storageKey) || $3fee91f26116c8a1$var$generateClientID($jO6uW.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $q03Nf(false);
        $jO6uW.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = $jO6uW.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        }
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && $q03Nf(false);
        var prevIDs = $jO6uW.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            var oldErrorTrie = _this._errorTrie;
            _this._errorTrie = oldErrorTrie == null ? null : $3fee91f26116c8a1$var$getNestedErrorTrieByKey(oldErrorTrie, nextIndex);
            !(typeof item === 'object') && $q03Nf(false);
            var nextID = _this._getDataId(item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || $3fee91f26116c8a1$var$generateClientID($jO6uW.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === 'string') && $q03Nf(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = $jO6uW.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            }
            _this._traverseSelections(field, nextRecord, item);
            _this._errorTrie = oldErrorTrie;
            _this._path.pop();
        });
        $jO6uW.setLinkedRecordIDs(record, storageKey, nextIDs);
    };
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        var _field$concreteType4;
        var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
        var dataID = $jO6uW.getDataID(record);
    };
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var dataID, previousValue;
    };
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(prevID, nextID, storageKey) {};
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: $3fee91f26116c8a1$var$normalize
};

});

parcelRegister("fLNXX", function(module, exports) {
function $b7b201050a777619$var$_extends() {
    return module.exports = $b7b201050a777619$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b7b201050a777619$var$_extends.apply(null, arguments);
}
module.exports = $b7b201050a777619$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gurtx", function(module, exports) {
function $c014c2b912dd8532$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $c014c2b912dd8532$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8Vn7T", function(module, exports) {
'use strict';

var $c2Tw9 = parcelRequire("c2Tw9");


var $amoBB = parcelRequire("amoBB");


var $42omo = parcelRequire("42omo");




var $67f59602f18177ee$var$useContext = $42omo.useContext, $67f59602f18177ee$var$useEffect = $42omo.useEffect;
parcelRequire("eEWwZ");

function $67f59602f18177ee$var$EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = $67f59602f18177ee$var$useContext($c2Tw9);
    var environment = $amoBB();
    $67f59602f18177ee$var$useEffect(function() {
        environment.__log({
            name: 'entrypoint.root.consume',
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ $42omo.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = $67f59602f18177ee$var$EntryPointContainer;

});

parcelRegister("c2Tw9", function(module, exports) {
'use strict';

var $42omo = parcelRequire("42omo");

var $8c50bc8f34bf9708$var$ProfilerContext = $42omo.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = $8c50bc8f34bf9708$var$ProfilerContext;

});

parcelRegister("amoBB", function(module, exports) {
'use strict';

var $f8mcb = parcelRequire("f8mcb");


var $q03Nf = parcelRequire("q03Nf");


var $42omo = parcelRequire("42omo");

var $78af0b9edaa75590$var$useContext = $42omo.useContext;
function $78af0b9edaa75590$var$useRelayEnvironment() {
    var context = $78af0b9edaa75590$var$useContext($f8mcb);
    !(context != null) && $q03Nf(false);
    return context.environment;
}
module.exports = $78af0b9edaa75590$var$useRelayEnvironment;

});

parcelRegister("6Zkil", function(module, exports) {
'use strict';

var $6jBTV = parcelRequire("6jBTV");

var $015021c91e4c3ac8$var$loadQuery = $6jBTV.loadQuery;
function $015021c91e4c3ac8$var$loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var _queries$queryPropNam = queries[queryPropName], environmentProviderOptions = _queries$queryPropNam.environmentProviderOptions, options = _queries$queryPropNam.options, parameters = _queries$queryPropNam.parameters, variables = _queries$queryPropNam.variables;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            preloadedQueries[queryPropName] = $015021c91e4c3ac8$var$loadQuery(environment, parameters, variables, {
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
                __nameForWarning: 'loadEntryPoint'
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = $015021c91e4c3ac8$var$loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
            return component;
        },
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = $015021c91e4c3ac8$var$loadEntryPoint;

});

parcelRegister("6jBTV", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $4991eacab8384595$var$_interopRequireDefault = $eGvGZ.default;

var $4991eacab8384595$var$_objectSpread2 = $4991eacab8384595$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $q03Nf = parcelRequire("q03Nf");


var $42omo = parcelRequire("42omo");


var $3e6Uc = parcelRequire("3e6Uc");

var $4991eacab8384595$var$fetchQueryDeduped = $3e6Uc.__internal.fetchQueryDeduped, $4991eacab8384595$var$Observable = $3e6Uc.Observable, $4991eacab8384595$var$PreloadableQueryRegistry = $3e6Uc.PreloadableQueryRegistry, $4991eacab8384595$var$RelayFeatureFlags = $3e6Uc.RelayFeatureFlags, $4991eacab8384595$var$ReplaySubject = $3e6Uc.ReplaySubject, $4991eacab8384595$var$createOperationDescriptor = $3e6Uc.createOperationDescriptor, $4991eacab8384595$var$getRequest = $3e6Uc.getRequest, $4991eacab8384595$var$getRequestIdentifier = $3e6Uc.getRequestIdentifier;
parcelRequire("eEWwZ");

var $4991eacab8384595$var$RenderDispatcher = null;
var $4991eacab8384595$var$fetchKey = 100001;
function $4991eacab8384595$var$useTrackLoadQueryInRender() {
    if ($4991eacab8384595$var$RenderDispatcher === null) {
        var _React$__SECRET_INTER, _React$__SECRET_INTER2;
        $4991eacab8384595$var$RenderDispatcher = (_React$__SECRET_INTER = $42omo.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React$__SECRET_INTER === void 0 ? void 0 : (_React$__SECRET_INTER2 = _React$__SECRET_INTER.ReactCurrentDispatcher) === null || _React$__SECRET_INTER2 === void 0 ? void 0 : _React$__SECRET_INTER2.current;
    }
}
function $4991eacab8384595$var$loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _React$__SECRET_INTER3, _React$__SECRET_INTER4, _options$__nameForWar, _options$fetchPolicy;
    var CurrentDispatcher = (_React$__SECRET_INTER3 = $42omo.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React$__SECRET_INTER3 === void 0 ? void 0 : (_React$__SECRET_INTER4 = _React$__SECRET_INTER3.ReactCurrentDispatcher) === null || _React$__SECRET_INTER4 === void 0 ? void 0 : _React$__SECRET_INTER4.current;
    $4991eacab8384595$var$fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'store-or-network';
    var networkCacheConfig = (0, $4991eacab8384595$var$_objectSpread2["default"])((0, $4991eacab8384595$var$_objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    var executionSubject = new $4991eacab8384595$var$ReplaySubject();
    var returnedObservable = $4991eacab8384595$var$Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params) {
        didMakeNetworkRequest = true;
        var observable;
        var subject = new $4991eacab8384595$var$ReplaySubject();
        if ($4991eacab8384595$var$RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) {
            var identifier = 'raw-network-request-' + $4991eacab8384595$var$getRequestIdentifier(params, variables);
            observable = $4991eacab8384595$var$fetchQueryDeduped(environment, identifier, function() {
                var network = environment.getNetwork();
                return network.execute(params, variables, networkCacheConfig);
            });
        } else {
            var network = environment.getNetwork();
            observable = network.execute(params, variables, networkCacheConfig);
        }
        var _observable$subscribe = observable.subscribe({
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            },
            complete: function complete() {
                subject.complete();
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return $4991eacab8384595$var$Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        if ($4991eacab8384595$var$RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) didMakeNetworkRequest = true;
        var _fetchQueryDeduped$su = $4991eacab8384595$var$fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            },
            complete: function complete() {
                executionSubject.complete();
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = $4991eacab8384595$var$createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === 'store-only') return;
        var shouldFetch = fetchPolicy !== 'store-or-network' || environment.check(operation).status !== 'available';
        if (shouldFetch) executeDeduped(operation, function() {
            var networkObservable = makeNetworkRequest(concreteRequest.params);
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && $q03Nf(false);
        var _module = $4991eacab8384595$var$PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            var networkObservable = fetchPolicy === 'store-only' ? null : makeNetworkRequest(params);
            var _PreloadableQueryRegi = $4991eacab8384595$var$PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = $4991eacab8384595$var$createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = $4991eacab8384595$var$getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        kind: 'PreloadedQuery',
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        releaseQuery: releaseQuery,
        cancelNetworkRequest: cancelNetworkRequest,
        fetchKey: $4991eacab8384595$var$fetchKey,
        id: queryId,
        get isDisposed () {
            return isDisposed || isReleased;
        },
        get networkError () {
            return networkError;
        },
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        fetchPolicy: fetchPolicy,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: $4991eacab8384595$var$loadQuery,
    useTrackLoadQueryInRender: $4991eacab8384595$var$useTrackLoadQueryInRender
};

});

parcelRegister("i42kM", function(module, exports) {
'use strict';

var $f8mcb = parcelRequire("f8mcb");


var $42omo = parcelRequire("42omo");

var $d26a69367d43d6b6$var$useMemo = $42omo.useMemo;
function $d26a69367d43d6b6$var$RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = $d26a69367d43d6b6$var$useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ $42omo.createElement($f8mcb.Provider, {
        value: context
    }, children);
}
module.exports = $d26a69367d43d6b6$var$RelayEnvironmentProvider;

});

parcelRegister("a5rI4", function(module, exports) {
'use strict';

var $6jBTV = parcelRequire("6jBTV");

var $757fdd9f5eb14d03$var$useTrackLoadQueryInRender = $6jBTV.useTrackLoadQueryInRender;

var $e3rvE = parcelRequire("e3rvE");


var $76FYg = parcelRequire("76FYg");


var $amoBB = parcelRequire("amoBB");


var $3e6Uc = parcelRequire("3e6Uc");

var $757fdd9f5eb14d03$var$fetchQuery = $3e6Uc.__internal.fetchQuery;
function $757fdd9f5eb14d03$var$useLazyLoadQuery(gqlQuery, variables, options) {
    $757fdd9f5eb14d03$var$useTrackLoadQueryInRender();
    var environment = $amoBB();
    var query = $76FYg(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = $e3rvE({
        componentDisplayName: 'useLazyLoadQuery()',
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: $757fdd9f5eb14d03$var$fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = $757fdd9f5eb14d03$var$useLazyLoadQuery;

});

parcelRegister("5RqGi", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $4446994d70317538$var$_interopRequireDefault = $eGvGZ.default;

var $4446994d70317538$var$_createForOfIteratorHelper2 = $4446994d70317538$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $6Zkil = parcelRequire("6Zkil");


var $6jBTV = parcelRequire("6jBTV");

var $4446994d70317538$var$useTrackLoadQueryInRender = $6jBTV.useTrackLoadQueryInRender;

var $4QlpF = parcelRequire("4QlpF");


var $42omo = parcelRequire("42omo");

var $4446994d70317538$var$useCallback = $42omo.useCallback, $4446994d70317538$var$useEffect = $42omo.useEffect, $4446994d70317538$var$useRef = $42omo.useRef, $4446994d70317538$var$useState = $42omo.useState;
var $4446994d70317538$var$initialNullEntryPointReferenceState = {
    kind: 'NullEntryPointReference'
};
function $4446994d70317538$var$useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    $4446994d70317538$var$useTrackLoadQueryInRender();
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : $4446994d70317538$var$initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = $4QlpF();
    var undisposedEntryPointReferencesRef = $4446994d70317538$var$useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = $4446994d70317538$var$useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = $4446994d70317538$var$useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = $4446994d70317538$var$useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: 'NullEntryPointReference'
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = $4446994d70317538$var$useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = $6Zkil(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $4446994d70317538$var$useRef(false);
    $4446994d70317538$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $4446994d70317538$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== 'NullEntryPointReference' && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $4446994d70317538$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== 'NullEntryPointReference') undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    $4446994d70317538$var$useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            var _iterator2 = (0, $4446994d70317538$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== 'NullEntryPointReference') unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === 'NullEntryPointReference' ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = $4446994d70317538$var$useLoadEntryPoint;

});

parcelRegister("5RO7w", function(module, exports) {
'use strict';

var $6jBTV = parcelRequire("6jBTV");

var $4458c7db5e56c8ad$var$useTrackLoadQueryInRender = $6jBTV.useTrackLoadQueryInRender;

var $fFePu = parcelRequire("fFePu");


var $4MqaE = parcelRequire("4MqaE");


var $42omo = parcelRequire("42omo");

var $4458c7db5e56c8ad$var$useDebugValue = $42omo.useDebugValue;

var $3e6Uc = parcelRequire("3e6Uc");

var $4458c7db5e56c8ad$var$getFragment = $3e6Uc.getFragment;
function $4458c7db5e56c8ad$var$useFragment(fragment, key) {
    $4458c7db5e56c8ad$var$useTrackLoadQueryInRender();
    var fragmentNode = $4458c7db5e56c8ad$var$getFragment(fragment);
    $4MqaE(fragmentNode, 'first argument of useFragment()');
    var data = $fFePu(fragmentNode, key, 'useFragment()');
    return data;
}
module.exports = $4458c7db5e56c8ad$var$useFragment;

});

parcelRegister("edz3c", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $a59d77e25a7648c3$var$_interopRequireDefault = $eGvGZ.default;

var $a59d77e25a7648c3$var$_objectSpread2 = $a59d77e25a7648c3$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $4QlpF = parcelRequire("4QlpF");


var $amoBB = parcelRequire("amoBB");


var $42omo = parcelRequire("42omo");


var $3e6Uc = parcelRequire("3e6Uc");

var $a59d77e25a7648c3$var$defaultCommitMutation = $3e6Uc.commitMutation;
var $a59d77e25a7648c3$var$useState = $42omo.useState, $a59d77e25a7648c3$var$useEffect = $42omo.useEffect, $a59d77e25a7648c3$var$useRef = $42omo.useRef, $a59d77e25a7648c3$var$useCallback = $42omo.useCallback;
function $a59d77e25a7648c3$var$useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a59d77e25a7648c3$var$defaultCommitMutation;
    var environment = $amoBB();
    var isMountedRef = $4QlpF();
    var environmentRef = $a59d77e25a7648c3$var$useRef(environment);
    var mutationRef = $a59d77e25a7648c3$var$useRef(mutation);
    var inFlightMutationsRef = $a59d77e25a7648c3$var$useRef(new Set());
    var _useState = $a59d77e25a7648c3$var$useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = $a59d77e25a7648c3$var$useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            if (isMountedRef.current) setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    $a59d77e25a7648c3$var$useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            if (isMountedRef.current) setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    var commit = $a59d77e25a7648c3$var$useCallback(function(config) {
        if (isMountedRef.current) setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, $a59d77e25a7648c3$var$_objectSpread2["default"])((0, $a59d77e25a7648c3$var$_objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        isMountedRef,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = $a59d77e25a7648c3$var$useMutation;

});

parcelRegister("aUuHB", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $7f16f331ce5d10fe$var$_interopRequireDefault = $eGvGZ.default;

var $7f16f331ce5d10fe$var$_objectSpread2 = $7f16f331ce5d10fe$var$_interopRequireDefault((parcelRequire("6g2zv")));
var $21b3d36ae052f2bc$exports = {};
'use strict';



var $21b3d36ae052f2bc$var$_interopRequireDefault = $eGvGZ.default;

var $21b3d36ae052f2bc$var$_objectSpread2 = $21b3d36ae052f2bc$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $gGM3K = parcelRequire("gGM3K");


var $4QlpF = parcelRequire("4QlpF");

var $e860a94ddbf65ac3$exports = {};
'use strict';

var $amoBB = parcelRequire("amoBB");


var $q03Nf = parcelRequire("q03Nf");


var $42omo = parcelRequire("42omo");


var $3e6Uc = parcelRequire("3e6Uc");

var $e860a94ddbf65ac3$var$getObservableForActiveRequest = $3e6Uc.__internal.getObservableForActiveRequest, $e860a94ddbf65ac3$var$getSelector = $3e6Uc.getSelector;
var $e860a94ddbf65ac3$var$useEffect = $42omo.useEffect, $e860a94ddbf65ac3$var$useState = $42omo.useState, $e860a94ddbf65ac3$var$useMemo = $42omo.useMemo;
function $e860a94ddbf65ac3$var$useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = $amoBB();
    var observable = $e860a94ddbf65ac3$var$useMemo(function() {
        var selector = $e860a94ddbf65ac3$var$getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === 'SingularReaderSelector') && $q03Nf(false);
        return $e860a94ddbf65ac3$var$getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = $e860a94ddbf65ac3$var$useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    $e860a94ddbf65ac3$var$useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
$e860a94ddbf65ac3$exports = $e860a94ddbf65ac3$var$useIsOperationNodeActive;











var $21b3d36ae052f2bc$var$useCallback = $42omo.useCallback, $21b3d36ae052f2bc$var$useEffect = $42omo.useEffect, $21b3d36ae052f2bc$var$useState = $42omo.useState;



var $21b3d36ae052f2bc$var$fetchQuery = $3e6Uc.__internal.fetchQuery, $21b3d36ae052f2bc$var$ConnectionInterface = $3e6Uc.ConnectionInterface, $21b3d36ae052f2bc$var$createOperationDescriptor = $3e6Uc.createOperationDescriptor, $21b3d36ae052f2bc$var$getPaginationVariables = $3e6Uc.getPaginationVariables, $21b3d36ae052f2bc$var$getRefetchMetadata = $3e6Uc.getRefetchMetadata, $21b3d36ae052f2bc$var$getSelector = $3e6Uc.getSelector, $21b3d36ae052f2bc$var$getValueAtPath = $3e6Uc.getValueAtPath;
parcelRequire("eEWwZ");

function $21b3d36ae052f2bc$var$useLoadMoreFunction(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $amoBB();
    var _useFetchTrackingRef = $gGM3K(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = $21b3d36ae052f2bc$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = $4QlpF();
    var _useState = $21b3d36ae052f2bc$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $21b3d36ae052f2bc$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $e860a94ddbf65ac3$exports(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $21b3d36ae052f2bc$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    $21b3d36ae052f2bc$var$useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var loadMore = $21b3d36ae052f2bc$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $21b3d36ae052f2bc$var$getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || fragmentData == null || isParentQueryActive) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $q03Nf(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $21b3d36ae052f2bc$var$_objectSpread2["default"])((0, $21b3d36ae052f2bc$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $21b3d36ae052f2bc$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $21b3d36ae052f2bc$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $21b3d36ae052f2bc$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $21b3d36ae052f2bc$var$fetchQuery(environment, paginationQuery).subscribe((0, $21b3d36ae052f2bc$var$_objectSpread2["default"])((0, $21b3d36ae052f2bc$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isParentQueryActive,
        fragmentData,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
function $21b3d36ae052f2bc$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = $21b3d36ae052f2bc$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = $21b3d36ae052f2bc$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !(typeof connection === 'object') && $q03Nf(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && $q03Nf(false);
    !(typeof pageInfo === 'object') && $q03Nf(false);
    var cursor = direction === 'forward' ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === 'string') && $q03Nf(false);
    var hasMore;
    if (direction === 'forward') hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
$21b3d36ae052f2bc$exports = $21b3d36ae052f2bc$var$useLoadMoreFunction;



var $8g1lf = parcelRequire("8g1lf");





var $4MqaE = parcelRequire("4MqaE");




var $7f16f331ce5d10fe$var$useCallback = $42omo.useCallback, $7f16f331ce5d10fe$var$useDebugValue = $42omo.useDebugValue, $7f16f331ce5d10fe$var$useState = $42omo.useState;



var $7f16f331ce5d10fe$var$getFragment = $3e6Uc.getFragment, $7f16f331ce5d10fe$var$getFragmentIdentifier = $3e6Uc.getFragmentIdentifier, $7f16f331ce5d10fe$var$getPaginationMetadata = $3e6Uc.getPaginationMetadata;
function $7f16f331ce5d10fe$var$usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = $7f16f331ce5d10fe$var$getFragment(fragmentInput);
    $4MqaE(fragmentNode, 'first argument of usePaginationFragment()');
    var componentDisplayName = 'usePaginationFragment()';
    var _getPaginationMetadat = $7f16f331ce5d10fe$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $8g1lf(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $7f16f331ce5d10fe$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = $7f16f331ce5d10fe$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'backward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = $7f16f331ce5d10fe$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = $7f16f331ce5d10fe$var$useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, $7f16f331ce5d10fe$var$_objectSpread2["default"])((0, $7f16f331ce5d10fe$var$_objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function $7f16f331ce5d10fe$var$useLoadMore(args) {
    var environment = $amoBB();
    var _useState = $7f16f331ce5d10fe$var$useState(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    };
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        }
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = $21b3d36ae052f2bc$exports((0, $7f16f331ce5d10fe$var$_objectSpread2["default"])((0, $7f16f331ce5d10fe$var$_objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
module.exports = $7f16f331ce5d10fe$var$usePaginationFragment;

});

parcelRegister("2g3bG", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $1a4f8c582025b9b6$var$_interopRequireDefault = $eGvGZ.default;

var $1a4f8c582025b9b6$var$_createForOfIteratorHelper2 = $1a4f8c582025b9b6$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $6jBTV = parcelRequire("6jBTV");

var $1a4f8c582025b9b6$var$loadQuery = $6jBTV.loadQuery, $1a4f8c582025b9b6$var$useTrackLoadQueryInRender = $6jBTV.useTrackLoadQueryInRender;

var $4QlpF = parcelRequire("4QlpF");


var $amoBB = parcelRequire("amoBB");


var $42omo = parcelRequire("42omo");

var $1a4f8c582025b9b6$var$useCallback = $42omo.useCallback, $1a4f8c582025b9b6$var$useEffect = $42omo.useEffect, $1a4f8c582025b9b6$var$useRef = $42omo.useRef, $1a4f8c582025b9b6$var$useState = $42omo.useState;

var $3e6Uc = parcelRequire("3e6Uc");

var $1a4f8c582025b9b6$var$getRequest = $3e6Uc.getRequest;
var $1a4f8c582025b9b6$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $1a4f8c582025b9b6$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $1a4f8c582025b9b6$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function $1a4f8c582025b9b6$var$useQueryLoader(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $1a4f8c582025b9b6$var$initialNullQueryReferenceState;
    var environment = $amoBB();
    $1a4f8c582025b9b6$var$useTrackLoadQueryInRender();
    var isMountedRef = $4QlpF();
    var undisposedQueryReferencesRef = $1a4f8c582025b9b6$var$useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = $1a4f8c582025b9b6$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $1a4f8c582025b9b6$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $1a4f8c582025b9b6$var$useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add($1a4f8c582025b9b6$var$initialNullQueryReferenceState);
            setQueryReference($1a4f8c582025b9b6$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $1a4f8c582025b9b6$var$useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = $1a4f8c582025b9b6$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $1a4f8c582025b9b6$var$useRef(false);
    $1a4f8c582025b9b6$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $1a4f8c582025b9b6$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== 'NullQueryReference') queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $1a4f8c582025b9b6$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($1a4f8c582025b9b6$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    $1a4f8c582025b9b6$var$useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            var _iterator2 = (0, $1a4f8c582025b9b6$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($1a4f8c582025b9b6$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $1a4f8c582025b9b6$var$useQueryLoader;

});

parcelRegister("j2uow", function(module, exports) {
'use strict';

var $6jBTV = parcelRequire("6jBTV");

var $ddc5c7eced9b0e23$var$useTrackLoadQueryInRender = $6jBTV.useTrackLoadQueryInRender;

var $e3rvE = parcelRequire("e3rvE");


var $76FYg = parcelRequire("76FYg");


var $amoBB = parcelRequire("amoBB");


var $q03Nf = parcelRequire("q03Nf");


var $42omo = parcelRequire("42omo");

var $ddc5c7eced9b0e23$var$useDebugValue = $42omo.useDebugValue;

var $3e6Uc = parcelRequire("3e6Uc");

var $ddc5c7eced9b0e23$var$_require3$__internal = $3e6Uc.__internal, $ddc5c7eced9b0e23$var$fetchQueryDeduped = $ddc5c7eced9b0e23$var$_require3$__internal.fetchQueryDeduped, $ddc5c7eced9b0e23$var$fetchQuery = $ddc5c7eced9b0e23$var$_require3$__internal.fetchQuery;
parcelRequire("eEWwZ");

function $ddc5c7eced9b0e23$var$usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    $ddc5c7eced9b0e23$var$useTrackLoadQueryInRender();
    var environment = $amoBB();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = $76FYg(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === 'PreloadedQuery_DEPRECATED') {
        !(operation.request.node.params.name === preloadedQuery.name) && $q03Nf(false);
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchKey: fetchKey,
            fetchObservable: $ddc5c7eced9b0e23$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
                if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                    operation: operation,
                    source: source
                });
                else return environment.execute({
                    operation: operation
                });
            }),
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    } else {
        var fallbackFetchObservable = $ddc5c7eced9b0e23$var$fetchQuery(environment, operation);
        var fetchObservable;
        if (source != null && environment === preloadedQuery.environment) fetchObservable = source.ifEmpty(fallbackFetchObservable);
        else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
        else fetchObservable = fallbackFetchObservable;
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchObservable: fetchObservable,
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    }
    var data = $e3rvE(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = $ddc5c7eced9b0e23$var$usePreloadedQuery;

});

parcelRegister("eDK61", function(module, exports) {
'use strict';

var $8g1lf = parcelRequire("8g1lf");


var $4MqaE = parcelRequire("4MqaE");


var $42omo = parcelRequire("42omo");

var $aa8876ed7c319310$var$useDebugValue = $42omo.useDebugValue;

var $3e6Uc = parcelRequire("3e6Uc");

var $aa8876ed7c319310$var$getFragment = $3e6Uc.getFragment;
function $aa8876ed7c319310$var$useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = $aa8876ed7c319310$var$getFragment(fragmentInput);
    $4MqaE(fragmentNode, 'first argument of useRefetchableFragment()');
    var _useRefetchableFragme = $8g1lf(fragmentNode, fragmentRef, 'useRefetchableFragment()'), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    return [
        fragmentData,
        refetch
    ];
}
module.exports = $aa8876ed7c319310$var$useRefetchableFragment;

});

parcelRegister("dPWxj", function(module, exports) {
'use strict';

var $amoBB = parcelRequire("amoBB");


var $42omo = parcelRequire("42omo");

var $a12d71de0d4188f9$var$useEffect = $42omo.useEffect, $a12d71de0d4188f9$var$useRef = $42omo.useRef;
function $a12d71de0d4188f9$var$useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = $amoBB();
    var disposableRef = $a12d71de0d4188f9$var$useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join('');
    $a12d71de0d4188f9$var$useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = $a12d71de0d4188f9$var$useSubscribeToInvalidationState;

});

parcelRegister("4H2Ae", function(module, exports) {
'use strict';

var $amoBB = parcelRequire("amoBB");


var $42omo = parcelRequire("42omo");

var $36ad2e99ef998215$var$useEffect = $42omo.useEffect;

var $3e6Uc = parcelRequire("3e6Uc");

var $36ad2e99ef998215$var$requestSubscription = $3e6Uc.requestSubscription;
function $36ad2e99ef998215$var$useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : $36ad2e99ef998215$var$requestSubscription;
    var environment = $amoBB();
    $36ad2e99ef998215$var$useEffect(function() {
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = $36ad2e99ef998215$var$useSubscription;

});

parcelRegister("b3j2Y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");

function $ff81fbcf85bdaf85$export$d56b0569bceb92ae({ children: children, error: error }) {
    const [errorListenerIsReady, setErrorListenerIsReady] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const listener = (event)=>{
            if (event.error === error) // this way we're preventing React from showing an ugly message in the console
            // because the developer is doing everything right
            event.preventDefault();
        };
        window.addEventListener('error', listener);
        setErrorListenerIsReady(true);
        return ()=>{
            window.removeEventListener('error', listener);
            setErrorListenerIsReady(false);
        };
    }, [
        error,
        setErrorListenerIsReady
    ]);
    const renderOnError = (0, $42omo.useCallback)((_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children), [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).INHERIT,
        renderOnError: renderOnError
    }, errorListenerIsReady ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ff81fbcf85bdaf85$export$4d51f41a5e7cc382, {
        error: error
    }) : null);
}
function $ff81fbcf85bdaf85$export$4d51f41a5e7cc382({ error: error }) {
    throw error;
}
module.exports["ErrorDisplay"] = $ff81fbcf85bdaf85$export$d56b0569bceb92ae;

});

parcelRegister("eCryJ", function(module, exports) {
/* eslint-disable react/prop-types */ 
var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9x4nt = parcelRequire("9x4nt");


var $feexy = parcelRequire("feexy");


var $4u5NT = parcelRequire("4u5NT");


var $1AV5C = parcelRequire("1AV5C");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3QIlf = parcelRequire("3QIlf");





var $3IBnw = parcelRequire("3IBnw");

const $d01e2abd0e062cfa$export$e0d764cccd459a26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext('unknown');
$d01e2abd0e062cfa$export$e0d764cccd459a26.displayName = 'AttributionContext';
function $d01e2abd0e062cfa$export$46b870813daca3d4(attribution) {
    const inheritedAttribution = (0, $42omo.useContext)($d01e2abd0e062cfa$export$e0d764cccd459a26);
    return attribution === (0, $3IBnw.Attribution).INHERIT ? inheritedAttribution : attribution;
}






var $jmjWc = parcelRequire("jmjWc");

parcelRequire("awd1Q");
var $d4U2f = parcelRequire("d4U2f");


const $f3487e06591b6bc9$export$1b0d5999522d82d7 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "zalc1",
    name: "IntlNextProvider",
    loader: async ()=>(await Promise.resolve((parcelRequire("cgtv4")))).IntlProvider
});
const $f3487e06591b6bc9$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $f3487e06591b6bc9$export$e57b625af5985ba6 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch(error) {
        // else we re-propagate the non-react-intl-next error
        throw error;
    }
    render() {
        if (this.state?.missingIntlProviderInAncestry) {
            const { locale: locale, messages: messages } = (0, $d4U2f.getTranslation)();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f3487e06591b6bc9$export$1b0d5999522d82d7, {
                key: locale,
                "data-test-language": locale,
                locale: locale,
                defaultLocale: (0, $d4U2f.DEFAULT_LOCALE),
                messages: messages,
                textComponent: "span"
            }, this.props.children);
        }
        return this.props.children;
    }
}


/**
 * Implements as minial as possible a `Component` to allow
 * `GenericErrorBoundary` to be a function component.
 */ class $60cbc013ea7aa356$var$GenericErrorBoundaryComponent extends (0, $42omo.Component) {
    componentDidMount() {
        this.checkForAttributionError();
    }
    componentDidUpdate() {
        this.checkForAttributionError();
    }
    componentDidCatch(error, errorInfo) {
        this.props.onError(error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }
    checkForAttributionError() {}
    render() {
        const { attribution: attribution, children: children, renderOnError: RenderOnError } = this.props;
        return this.state && this.state.error && this.state.errorInfo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(RenderOnError, {
            attribution: attribution,
            error: this.state.error,
            errorInfo: this.state.errorInfo
        }) : children;
    }
}
function $60cbc013ea7aa356$export$9e9b5b3f9c08ce57(props) {
    const { children: children, onError: onError, renderOnError: RenderOnError } = props;
    const attribution = (0, $d01e2abd0e062cfa$export$46b870813daca3d4)(props.attribution);
    const ufoInteractionId = (0, $42omo.useContext)((0, $feexy.default));
    const ufoContext = (0, $42omo.useContext)((0, $9x4nt.default));
    const isKnownError = (0, $42omo.useContext)((0, $3QIlf.KnownErrorBoundaryContext));
    const handleError = (0, $42omo.useCallback)((error, errorInfo)=>{
        if (ufoInteractionId?.current && ufoContext?.labelStack) (0, $4u5NT.addError)(ufoInteractionId.current, `GenericErrorBoundary:${attribution}`, ufoContext.labelStack, error.name, error.message, error.stack);
        if (isKnownError && isKnownError(error)) throw error;
        (0, $fJlJm.setReactErrorAttributes)(error, {
            componentStack: errorInfo.componentStack ?? '',
            errorHashCode: $60cbc013ea7aa356$export$aee074596d734311(error, errorInfo)
        });
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) {
            // only report errors which haven't been marked as handled yet
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: attribution
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
        if (onError) onError(error, errorInfo);
    }, [
        attribution,
        isKnownError,
        onError,
        ufoInteractionId,
        ufoContext
    ]);
    const renderOnError = (0, $42omo.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(RenderOnError, props), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d01e2abd0e062cfa$export$e0d764cccd459a26).Provider, {
        value: attribution
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($60cbc013ea7aa356$var$GenericErrorBoundaryComponent, {
        __boundaryMarker: true,
        attribution: attribution,
        onError: handleError,
        renderOnError: renderOnError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f3487e06591b6bc9$export$e57b625af5985ba6), null, children)));
}
$60cbc013ea7aa356$export$9e9b5b3f9c08ce57.propTypes = {
    attribution: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onError: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    renderOnError: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
/**
 * Used to group errors containing a specified string under a stable hash
 * by providing a static input that always produces the same hash.
 *
 * ex. "Some error text to look for": "stableHashInputToEncode"
 *
 * IMPORTANT: Please use this functionality sparingly. If you do happen to add a new stable
 * hash input to this list, please document the generated hash code (ex. "g7s4p"), notify
 * the Counfluence Cloud support team of the new hash code, and consider adding it to
 * this document: https://hello.atlassian.net/wiki/spaces/~7012120740227026c440094e9900a280bba1c/pages/2918914324/Confluence+error+codes
 *
 * More context: https://product-fabric.atlassian.net/browse/PCC-3398
 */ const $60cbc013ea7aa356$var$stableHashMap = {
    'Minified React error #301': 'React error #301'
};
function $60cbc013ea7aa356$export$aee074596d734311(error, errorInfo) {
    let bytes = [];
    const stableHashInputKey = Object.keys($60cbc013ea7aa356$var$stableHashMap).find((errorText)=>`${error.message || String(error)}`.includes(errorText));
    if (stableHashInputKey) {
        // if the error matches one of the errors listed in the stableHashMap, produce a stable hash
        const stableHashInput = $60cbc013ea7aa356$var$stableHashMap[stableHashInputKey];
        bytes = (0, $1AV5C.hashDataAsByte)(stableHashInput);
    } else // otherwise hash using the message & component stack
    bytes = (0, $1AV5C.hashDataAsByte)(`${error.message || String(error)}${errorInfo.componentStack}`);
    return(// the bitwise operations are expected below
    /* eslint-disable no-bitwise */ ((bytes[0] & 0xff | (bytes[1] & 0xff) << 8 | (bytes[2] & 0xff) << 16 | (bytes[3] & 0xff) << 24) & /* eslint-enable no-bitwise */ 0x3fffffff).toString(32 /* 5 bits per character */ ));
}
module.exports["GenericErrorBoundary"] = $60cbc013ea7aa356$export$9e9b5b3f9c08ce57;

});

parcelRegister("awd1Q", function(module, exports) {
$parcel$export(module.exports, "loadTranslation", () => (parcelRequire("d4U2f")).loadTranslation);
$parcel$export(module.exports, "getTranslation", () => (parcelRequire("d4U2f")).getTranslation);
$parcel$export(module.exports, "DEFAULT_LOCALE", () => (parcelRequire("d4U2f")).DEFAULT_LOCALE);

var $d4U2f = parcelRequire("d4U2f");


});

parcelRegister("lKRGI", function(module, exports) {

let $fd678a30290e40d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fd678a30290e40d3$var$load("j0PWv"),
    $fd678a30290e40d3$var$load("ksTQ6"),
    $fd678a30290e40d3$var$load("eBoC7"),
    $fd678a30290e40d3$var$load("j5F5K"),
    $fd678a30290e40d3$var$load("cukQS"),
    $fd678a30290e40d3$var$load("5FaEJ")
]).then(()=>parcelRequire('gnzRa'));

});

parcelRegister("jJa9X", function(module, exports) {

let $e5ca19c6a1acc1a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e5ca19c6a1acc1a1$var$load("j0PWv"),
    $e5ca19c6a1acc1a1$var$load("ksTQ6"),
    $e5ca19c6a1acc1a1$var$load("eBoC7"),
    $e5ca19c6a1acc1a1$var$load("j5F5K"),
    $e5ca19c6a1acc1a1$var$load("cukQS"),
    $e5ca19c6a1acc1a1$var$load("5FaEJ")
]).then(()=>parcelRequire('eEPOC'));

});

parcelRegister("byL3E", function(module, exports) {

let $86a75f639fa85010$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $86a75f639fa85010$var$load("j0PWv"),
    $86a75f639fa85010$var$load("ksTQ6"),
    $86a75f639fa85010$var$load("eBoC7"),
    $86a75f639fa85010$var$load("j5F5K"),
    $86a75f639fa85010$var$load("cukQS"),
    $86a75f639fa85010$var$load("5FaEJ")
]).then(()=>parcelRequire('e4Fch'));

});

parcelRegister("jBneR", function(module, exports) {

let $e4537fb82e548909$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e4537fb82e548909$var$load("j0PWv"),
    $e4537fb82e548909$var$load("ksTQ6"),
    $e4537fb82e548909$var$load("eBoC7"),
    $e4537fb82e548909$var$load("j5F5K"),
    $e4537fb82e548909$var$load("cukQS"),
    $e4537fb82e548909$var$load("5FaEJ")
]).then(()=>parcelRequire('8wRyR'));

});

parcelRegister("i9aRg", function(module, exports) {

let $d3617d76f19e3a0c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d3617d76f19e3a0c$var$load("j0PWv"),
    $d3617d76f19e3a0c$var$load("ksTQ6"),
    $d3617d76f19e3a0c$var$load("eBoC7"),
    $d3617d76f19e3a0c$var$load("j5F5K"),
    $d3617d76f19e3a0c$var$load("cukQS"),
    $d3617d76f19e3a0c$var$load("5FaEJ")
]).then(()=>parcelRequire('4FRcU'));

});

parcelRegister("25lVW", function(module, exports) {

let $184d0ff148ddbd6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $184d0ff148ddbd6e$var$load("j0PWv"),
    $184d0ff148ddbd6e$var$load("ksTQ6"),
    $184d0ff148ddbd6e$var$load("eBoC7"),
    $184d0ff148ddbd6e$var$load("j5F5K"),
    $184d0ff148ddbd6e$var$load("cukQS"),
    $184d0ff148ddbd6e$var$load("5FaEJ")
]).then(()=>parcelRequire('cwgsE'));

});

parcelRegister("ksGWf", function(module, exports) {

let $ee57bad6b9d51c88$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ee57bad6b9d51c88$var$load("j0PWv"),
    $ee57bad6b9d51c88$var$load("ksTQ6"),
    $ee57bad6b9d51c88$var$load("eBoC7"),
    $ee57bad6b9d51c88$var$load("j5F5K"),
    $ee57bad6b9d51c88$var$load("cukQS"),
    $ee57bad6b9d51c88$var$load("5FaEJ")
]).then(()=>parcelRequire('9fM41'));

});

parcelRegister("aR9ep", function(module, exports) {

let $7e7603c56bc20cc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7e7603c56bc20cc2$var$load("j0PWv"),
    $7e7603c56bc20cc2$var$load("ksTQ6"),
    $7e7603c56bc20cc2$var$load("eBoC7"),
    $7e7603c56bc20cc2$var$load("j5F5K"),
    $7e7603c56bc20cc2$var$load("cukQS"),
    $7e7603c56bc20cc2$var$load("5FaEJ")
]).then(()=>parcelRequire('5SuH4'));

});

parcelRegister("gSJcL", function(module, exports) {

let $c4a4c13995a1e651$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c4a4c13995a1e651$var$load("j0PWv"),
    $c4a4c13995a1e651$var$load("ksTQ6"),
    $c4a4c13995a1e651$var$load("eBoC7"),
    $c4a4c13995a1e651$var$load("j5F5K"),
    $c4a4c13995a1e651$var$load("cukQS"),
    $c4a4c13995a1e651$var$load("5FaEJ")
]).then(()=>parcelRequire('fnqcW'));

});

parcelRegister("1ncQy", function(module, exports) {

let $1001e783769c7891$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1001e783769c7891$var$load("j0PWv"),
    $1001e783769c7891$var$load("ksTQ6"),
    $1001e783769c7891$var$load("eBoC7"),
    $1001e783769c7891$var$load("j5F5K"),
    $1001e783769c7891$var$load("cukQS"),
    $1001e783769c7891$var$load("5FaEJ")
]).then(()=>parcelRequire('246GD'));

});

parcelRegister("9ncev", function(module, exports) {

let $6d2fc04428043225$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6d2fc04428043225$var$load("j0PWv"),
    $6d2fc04428043225$var$load("ksTQ6"),
    $6d2fc04428043225$var$load("eBoC7"),
    $6d2fc04428043225$var$load("j5F5K"),
    $6d2fc04428043225$var$load("cukQS"),
    $6d2fc04428043225$var$load("5FaEJ")
]).then(()=>parcelRequire('7qCqp'));

});

parcelRegister("kafcO", function(module, exports) {

let $eae0895ba7b41aba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eae0895ba7b41aba$var$load("j0PWv"),
    $eae0895ba7b41aba$var$load("ksTQ6"),
    $eae0895ba7b41aba$var$load("eBoC7"),
    $eae0895ba7b41aba$var$load("j5F5K"),
    $eae0895ba7b41aba$var$load("cukQS"),
    $eae0895ba7b41aba$var$load("5FaEJ")
]).then(()=>parcelRequire('PLdJF'));

});

parcelRegister("dShyO", function(module, exports) {

let $a19df0a35b39a66f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a19df0a35b39a66f$var$load("j0PWv"),
    $a19df0a35b39a66f$var$load("ksTQ6"),
    $a19df0a35b39a66f$var$load("eBoC7"),
    $a19df0a35b39a66f$var$load("j5F5K"),
    $a19df0a35b39a66f$var$load("cukQS"),
    $a19df0a35b39a66f$var$load("5FaEJ")
]).then(()=>parcelRequire('1M1oj'));

});

parcelRegister("7GlmA", function(module, exports) {

let $597d06f1f0c00ac6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $597d06f1f0c00ac6$var$load("j0PWv"),
    $597d06f1f0c00ac6$var$load("ksTQ6"),
    $597d06f1f0c00ac6$var$load("eBoC7"),
    $597d06f1f0c00ac6$var$load("j5F5K"),
    $597d06f1f0c00ac6$var$load("cukQS"),
    $597d06f1f0c00ac6$var$load("5FaEJ")
]).then(()=>parcelRequire('cUkSa'));

});

parcelRegister("9d2Gs", function(module, exports) {

let $6b4768e7e29e4aeb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6b4768e7e29e4aeb$var$load("j0PWv"),
    $6b4768e7e29e4aeb$var$load("ksTQ6"),
    $6b4768e7e29e4aeb$var$load("eBoC7"),
    $6b4768e7e29e4aeb$var$load("j5F5K"),
    $6b4768e7e29e4aeb$var$load("cukQS"),
    $6b4768e7e29e4aeb$var$load("5FaEJ")
]).then(()=>parcelRequire('dnJzi'));

});

parcelRegister("1j4bG", function(module, exports) {

let $0f3ad051ff1b0cc4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0f3ad051ff1b0cc4$var$load("j0PWv"),
    $0f3ad051ff1b0cc4$var$load("ksTQ6"),
    $0f3ad051ff1b0cc4$var$load("eBoC7"),
    $0f3ad051ff1b0cc4$var$load("j5F5K"),
    $0f3ad051ff1b0cc4$var$load("cukQS"),
    $0f3ad051ff1b0cc4$var$load("5FaEJ")
]).then(()=>parcelRequire('lt9Ls'));

});

parcelRegister("9Ja0P", function(module, exports) {

let $715015456e6009ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $715015456e6009ea$var$load("j0PWv"),
    $715015456e6009ea$var$load("ksTQ6"),
    $715015456e6009ea$var$load("eBoC7"),
    $715015456e6009ea$var$load("j5F5K"),
    $715015456e6009ea$var$load("cukQS"),
    $715015456e6009ea$var$load("5FaEJ")
]).then(()=>parcelRequire('ioCvi'));

});

parcelRegister("kRsvf", function(module, exports) {

let $f2feddffdae78361$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f2feddffdae78361$var$load("j0PWv"),
    $f2feddffdae78361$var$load("ksTQ6"),
    $f2feddffdae78361$var$load("eBoC7"),
    $f2feddffdae78361$var$load("j5F5K"),
    $f2feddffdae78361$var$load("cukQS"),
    $f2feddffdae78361$var$load("5FaEJ")
]).then(()=>parcelRequire('EHYXh'));

});

parcelRegister("2kKla", function(module, exports) {

let $1b3165450c618020$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b3165450c618020$var$load("j0PWv"),
    $1b3165450c618020$var$load("ksTQ6"),
    $1b3165450c618020$var$load("eBoC7"),
    $1b3165450c618020$var$load("j5F5K"),
    $1b3165450c618020$var$load("cukQS"),
    $1b3165450c618020$var$load("5FaEJ")
]).then(()=>parcelRequire('29nf6'));

});

parcelRegister("6Hi6c", function(module, exports) {

let $4e04cc5270852f61$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e04cc5270852f61$var$load("j0PWv"),
    $4e04cc5270852f61$var$load("ksTQ6"),
    $4e04cc5270852f61$var$load("eBoC7"),
    $4e04cc5270852f61$var$load("j5F5K"),
    $4e04cc5270852f61$var$load("cukQS"),
    $4e04cc5270852f61$var$load("5FaEJ")
]).then(()=>parcelRequire('azdl1'));

});

parcelRegister("6ZgSe", function(module, exports) {

let $5165875caee21817$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5165875caee21817$var$load("j0PWv"),
    $5165875caee21817$var$load("ksTQ6"),
    $5165875caee21817$var$load("eBoC7"),
    $5165875caee21817$var$load("j5F5K"),
    $5165875caee21817$var$load("cukQS"),
    $5165875caee21817$var$load("5FaEJ")
]).then(()=>parcelRequire('iT0Dr'));

});

parcelRegister("7zwKU", function(module, exports) {

let $583535daf193bc87$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $583535daf193bc87$var$load("j0PWv"),
    $583535daf193bc87$var$load("ksTQ6"),
    $583535daf193bc87$var$load("eBoC7"),
    $583535daf193bc87$var$load("j5F5K"),
    $583535daf193bc87$var$load("cukQS"),
    $583535daf193bc87$var$load("5FaEJ")
]).then(()=>parcelRequire('jDEcr'));

});

parcelRegister("dBhWl", function(module, exports) {

let $9e6ca5994daeb2b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9e6ca5994daeb2b1$var$load("j0PWv"),
    $9e6ca5994daeb2b1$var$load("ksTQ6"),
    $9e6ca5994daeb2b1$var$load("eBoC7"),
    $9e6ca5994daeb2b1$var$load("j5F5K"),
    $9e6ca5994daeb2b1$var$load("cukQS"),
    $9e6ca5994daeb2b1$var$load("5FaEJ")
]).then(()=>parcelRequire('jEWub'));

});

parcelRegister("25Pzt", function(module, exports) {

let $18640d576fc976ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $18640d576fc976ca$var$load("j0PWv"),
    $18640d576fc976ca$var$load("ksTQ6"),
    $18640d576fc976ca$var$load("eBoC7"),
    $18640d576fc976ca$var$load("j5F5K"),
    $18640d576fc976ca$var$load("cukQS"),
    $18640d576fc976ca$var$load("5FaEJ")
]).then(()=>parcelRequire('26iqL'));

});

parcelRegister("5vkLT", function(module, exports) {

let $401ff5c1b1228d91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $401ff5c1b1228d91$var$load("j0PWv"),
    $401ff5c1b1228d91$var$load("ksTQ6"),
    $401ff5c1b1228d91$var$load("eBoC7"),
    $401ff5c1b1228d91$var$load("j5F5K"),
    $401ff5c1b1228d91$var$load("cukQS"),
    $401ff5c1b1228d91$var$load("5FaEJ")
]).then(()=>parcelRequire('5Lz5N'));

});

parcelRegister("4P1nf", function(module, exports) {

let $382cfdaaef3fd3cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $382cfdaaef3fd3cd$var$load("j0PWv"),
    $382cfdaaef3fd3cd$var$load("ksTQ6"),
    $382cfdaaef3fd3cd$var$load("eBoC7"),
    $382cfdaaef3fd3cd$var$load("j5F5K"),
    $382cfdaaef3fd3cd$var$load("cukQS"),
    $382cfdaaef3fd3cd$var$load("5FaEJ")
]).then(()=>parcelRequire('ib2B8'));

});

parcelRegister("vW363", function(module, exports) {

let $05ffecad447217d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $05ffecad447217d8$var$load("j0PWv"),
    $05ffecad447217d8$var$load("ksTQ6"),
    $05ffecad447217d8$var$load("eBoC7"),
    $05ffecad447217d8$var$load("j5F5K"),
    $05ffecad447217d8$var$load("cukQS"),
    $05ffecad447217d8$var$load("5FaEJ")
]).then(()=>parcelRequire('itnEk'));

});

parcelRegister("4nN3W", function(module, exports) {

let $330f5e3a2cfbc7d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $330f5e3a2cfbc7d7$var$load("j0PWv"),
    $330f5e3a2cfbc7d7$var$load("ksTQ6"),
    $330f5e3a2cfbc7d7$var$load("eBoC7"),
    $330f5e3a2cfbc7d7$var$load("j5F5K"),
    $330f5e3a2cfbc7d7$var$load("cukQS"),
    $330f5e3a2cfbc7d7$var$load("5FaEJ")
]).then(()=>parcelRequire('gBlip'));

});

parcelRegister("3jDyq", function(module, exports) {

let $26a1d416dc914590$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $26a1d416dc914590$var$load("j0PWv"),
    $26a1d416dc914590$var$load("ksTQ6"),
    $26a1d416dc914590$var$load("eBoC7"),
    $26a1d416dc914590$var$load("j5F5K"),
    $26a1d416dc914590$var$load("cukQS"),
    $26a1d416dc914590$var$load("5FaEJ")
]).then(()=>parcelRequire('gw8oo'));

});

parcelRegister("kDXpa", function(module, exports) {

let $f07587b98d6886bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f07587b98d6886bb$var$load("j0PWv"),
    $f07587b98d6886bb$var$load("ksTQ6"),
    $f07587b98d6886bb$var$load("eBoC7"),
    $f07587b98d6886bb$var$load("j5F5K"),
    $f07587b98d6886bb$var$load("cukQS"),
    $f07587b98d6886bb$var$load("5FaEJ")
]).then(()=>parcelRequire('1ySWz'));

});

parcelRegister("heetv", function(module, exports) {

let $c8aef8e00675439a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c8aef8e00675439a$var$load("j0PWv"),
    $c8aef8e00675439a$var$load("ksTQ6"),
    $c8aef8e00675439a$var$load("eBoC7"),
    $c8aef8e00675439a$var$load("j5F5K"),
    $c8aef8e00675439a$var$load("cukQS"),
    $c8aef8e00675439a$var$load("5FaEJ")
]).then(()=>parcelRequire('gGPUn'));

});

parcelRegister("4SDkZ", function(module, exports) {

let $38dab82b14c71d75$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $38dab82b14c71d75$var$load("j0PWv"),
    $38dab82b14c71d75$var$load("ksTQ6"),
    $38dab82b14c71d75$var$load("eBoC7"),
    $38dab82b14c71d75$var$load("j5F5K"),
    $38dab82b14c71d75$var$load("cukQS"),
    $38dab82b14c71d75$var$load("5FaEJ")
]).then(()=>parcelRequire('5gZGe'));

});

parcelRegister("6lfP8", function(module, exports) {

let $49e0fa88f665c9b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $49e0fa88f665c9b6$var$load("j0PWv"),
    $49e0fa88f665c9b6$var$load("ksTQ6"),
    $49e0fa88f665c9b6$var$load("eBoC7"),
    $49e0fa88f665c9b6$var$load("j5F5K"),
    $49e0fa88f665c9b6$var$load("cukQS"),
    $49e0fa88f665c9b6$var$load("5FaEJ")
]).then(()=>parcelRequire('8fn2v'));

});

parcelRegister("bhBKd", function(module, exports) {

let $836e8f81378bdcbc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $836e8f81378bdcbc$var$load("j0PWv"),
    $836e8f81378bdcbc$var$load("ksTQ6"),
    $836e8f81378bdcbc$var$load("eBoC7"),
    $836e8f81378bdcbc$var$load("j5F5K"),
    $836e8f81378bdcbc$var$load("cukQS"),
    $836e8f81378bdcbc$var$load("5FaEJ")
]).then(()=>parcelRequire('fHV1b'));

});

parcelRegister("4iAbq", function(module, exports) {

let $3214e9210c19510f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3214e9210c19510f$var$load("j0PWv"),
    $3214e9210c19510f$var$load("ksTQ6"),
    $3214e9210c19510f$var$load("eBoC7"),
    $3214e9210c19510f$var$load("j5F5K"),
    $3214e9210c19510f$var$load("cukQS"),
    $3214e9210c19510f$var$load("5FaEJ")
]).then(()=>parcelRequire('6kq3q'));

});

parcelRegister("5SxZH", function(module, exports) {

let $447c5d6acf423445$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $447c5d6acf423445$var$load("j0PWv"),
    $447c5d6acf423445$var$load("ksTQ6"),
    $447c5d6acf423445$var$load("eBoC7"),
    $447c5d6acf423445$var$load("j5F5K"),
    $447c5d6acf423445$var$load("cukQS"),
    $447c5d6acf423445$var$load("5FaEJ")
]).then(()=>parcelRequire('cGPxs'));

});

parcelRegister("85COw", function(module, exports) {

let $5e3ce5fcd9456829$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5e3ce5fcd9456829$var$load("j0PWv"),
    $5e3ce5fcd9456829$var$load("ksTQ6"),
    $5e3ce5fcd9456829$var$load("eBoC7"),
    $5e3ce5fcd9456829$var$load("j5F5K"),
    $5e3ce5fcd9456829$var$load("cukQS"),
    $5e3ce5fcd9456829$var$load("5FaEJ")
]).then(()=>parcelRequire('hFCKc'));

});

parcelRegister("d9OHC", function(module, exports) {

let $9943721147da398c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9943721147da398c$var$load("j0PWv"),
    $9943721147da398c$var$load("ksTQ6"),
    $9943721147da398c$var$load("eBoC7"),
    $9943721147da398c$var$load("j5F5K"),
    $9943721147da398c$var$load("cukQS"),
    $9943721147da398c$var$load("5FaEJ")
]).then(()=>parcelRequire('fQyzN'));

});

parcelRegister("d02bW", function(module, exports) {

let $976cf9ac7953728c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $976cf9ac7953728c$var$load("j0PWv"),
    $976cf9ac7953728c$var$load("ksTQ6"),
    $976cf9ac7953728c$var$load("eBoC7"),
    $976cf9ac7953728c$var$load("j5F5K"),
    $976cf9ac7953728c$var$load("cukQS"),
    $976cf9ac7953728c$var$load("5FaEJ")
]).then(()=>parcelRequire('dYtch'));

});

parcelRegister("8HW2u", function(module, exports) {

let $656f5c411b688e1b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $656f5c411b688e1b$var$load("j0PWv"),
    $656f5c411b688e1b$var$load("ksTQ6"),
    $656f5c411b688e1b$var$load("eBoC7"),
    $656f5c411b688e1b$var$load("j5F5K"),
    $656f5c411b688e1b$var$load("cukQS"),
    $656f5c411b688e1b$var$load("5FaEJ")
]).then(()=>parcelRequire('c6G0e'));

});

parcelRegister("7Oob2", function(module, exports) {

let $5afff4fa95ff0a72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5afff4fa95ff0a72$var$load("j0PWv"),
    $5afff4fa95ff0a72$var$load("ksTQ6"),
    $5afff4fa95ff0a72$var$load("eBoC7"),
    $5afff4fa95ff0a72$var$load("j5F5K"),
    $5afff4fa95ff0a72$var$load("cukQS"),
    $5afff4fa95ff0a72$var$load("5FaEJ")
]).then(()=>parcelRequire('egHxW'));

});

parcelRegister("b7k1w", function(module, exports) {

let $817fe1693d5d116d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $817fe1693d5d116d$var$load("j0PWv"),
    $817fe1693d5d116d$var$load("ksTQ6"),
    $817fe1693d5d116d$var$load("eBoC7"),
    $817fe1693d5d116d$var$load("j5F5K"),
    $817fe1693d5d116d$var$load("cukQS"),
    $817fe1693d5d116d$var$load("5FaEJ")
]).then(()=>parcelRequire('jk3c9'));

});

parcelRegister("8LKOI", function(module, exports) {

let $66270763b847b411$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $66270763b847b411$var$load("j0PWv"),
    $66270763b847b411$var$load("ksTQ6"),
    $66270763b847b411$var$load("eBoC7"),
    $66270763b847b411$var$load("j5F5K"),
    $66270763b847b411$var$load("cukQS"),
    $66270763b847b411$var$load("5FaEJ")
]).then(()=>parcelRequire('6JOlS'));

});

parcelRegister("43Xkp", function(module, exports) {

let $2f557694e2f8097d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2f557694e2f8097d$var$load("j0PWv"),
    $2f557694e2f8097d$var$load("ksTQ6"),
    $2f557694e2f8097d$var$load("eBoC7"),
    $2f557694e2f8097d$var$load("j5F5K"),
    $2f557694e2f8097d$var$load("cukQS"),
    $2f557694e2f8097d$var$load("5FaEJ")
]).then(()=>parcelRequire('2UhDO'));

});

parcelRegister("lVEhc", function(module, exports) {

let $ff6e29e5914afff7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ff6e29e5914afff7$var$load("j0PWv"),
    $ff6e29e5914afff7$var$load("ksTQ6"),
    $ff6e29e5914afff7$var$load("eBoC7"),
    $ff6e29e5914afff7$var$load("j5F5K"),
    $ff6e29e5914afff7$var$load("cukQS"),
    $ff6e29e5914afff7$var$load("5FaEJ")
]).then(()=>parcelRequire('eDffh'));

});

parcelRegister("aGgqX", function(module, exports) {

let $7c6a930369c0c478$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7c6a930369c0c478$var$load("j0PWv"),
    $7c6a930369c0c478$var$load("ksTQ6"),
    $7c6a930369c0c478$var$load("eBoC7"),
    $7c6a930369c0c478$var$load("j5F5K"),
    $7c6a930369c0c478$var$load("cukQS"),
    $7c6a930369c0c478$var$load("5FaEJ")
]).then(()=>parcelRequire('9U4Jz'));

});

parcelRegister("fouQR", function(module, exports) {

let $b3510766403dd382$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b3510766403dd382$var$load("j0PWv"),
    $b3510766403dd382$var$load("ksTQ6"),
    $b3510766403dd382$var$load("eBoC7"),
    $b3510766403dd382$var$load("j5F5K"),
    $b3510766403dd382$var$load("cukQS"),
    $b3510766403dd382$var$load("5FaEJ")
]).then(()=>parcelRequire('acdOC'));

});

parcelRegister("aZrhv", function(module, exports) {

let $8004c3601a5409c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8004c3601a5409c3$var$load("j0PWv"),
    $8004c3601a5409c3$var$load("ksTQ6"),
    $8004c3601a5409c3$var$load("eBoC7"),
    $8004c3601a5409c3$var$load("j5F5K"),
    $8004c3601a5409c3$var$load("cukQS"),
    $8004c3601a5409c3$var$load("5FaEJ")
]).then(()=>parcelRequire('7ewuQ'));

});

parcelRegister("1wpD8", function(module, exports) {

let $11bca93b222c2c74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $11bca93b222c2c74$var$load("j0PWv"),
    $11bca93b222c2c74$var$load("ksTQ6"),
    $11bca93b222c2c74$var$load("eBoC7"),
    $11bca93b222c2c74$var$load("j5F5K"),
    $11bca93b222c2c74$var$load("cukQS"),
    $11bca93b222c2c74$var$load("5FaEJ")
]).then(()=>parcelRequire('kHoqv'));

});

parcelRegister("bQCsy", function(module, exports) {

let $8a0262525a041e53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a0262525a041e53$var$load("17m16"),
    $8a0262525a041e53$var$load("kAg8V"),
    $8a0262525a041e53$var$load("cMubu"),
    $8a0262525a041e53$var$load("9Cdzw"),
    $8a0262525a041e53$var$load("cHWSM"),
    $8a0262525a041e53$var$load("35Ssm")
]).then(()=>parcelRequire('j19wH'));

});

parcelRegister("cIdVA", function(module, exports) {

let $941465dfe9007dba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $941465dfe9007dba$var$load("17m16"),
    $941465dfe9007dba$var$load("kAg8V"),
    $941465dfe9007dba$var$load("cMubu"),
    $941465dfe9007dba$var$load("9Cdzw"),
    $941465dfe9007dba$var$load("cHWSM"),
    $941465dfe9007dba$var$load("35Ssm")
]).then(()=>parcelRequire('b9sjx'));

});

parcelRegister("1EwpP", function(module, exports) {

let $1342abf1b8bb05dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1342abf1b8bb05dc$var$load("17m16"),
    $1342abf1b8bb05dc$var$load("kAg8V"),
    $1342abf1b8bb05dc$var$load("cMubu"),
    $1342abf1b8bb05dc$var$load("9Cdzw"),
    $1342abf1b8bb05dc$var$load("cHWSM"),
    $1342abf1b8bb05dc$var$load("35Ssm")
]).then(()=>parcelRequire('ViizB'));

});

parcelRegister("5AXwb", function(module, exports) {

let $412e7b95ff5b1ff5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $412e7b95ff5b1ff5$var$load("17m16"),
    $412e7b95ff5b1ff5$var$load("kAg8V"),
    $412e7b95ff5b1ff5$var$load("cMubu"),
    $412e7b95ff5b1ff5$var$load("9Cdzw"),
    $412e7b95ff5b1ff5$var$load("cHWSM"),
    $412e7b95ff5b1ff5$var$load("35Ssm")
]).then(()=>parcelRequire('lMsFR'));

});

parcelRegister("64ipj", function(module, exports) {

let $46b16516058a247a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $46b16516058a247a$var$load("17m16"),
    $46b16516058a247a$var$load("kAg8V"),
    $46b16516058a247a$var$load("cMubu"),
    $46b16516058a247a$var$load("9Cdzw"),
    $46b16516058a247a$var$load("cHWSM"),
    $46b16516058a247a$var$load("35Ssm")
]).then(()=>parcelRequire('225Fx'));

});

parcelRegister("gQp1P", function(module, exports) {

let $c434eacdd4f158f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c434eacdd4f158f6$var$load("17m16"),
    $c434eacdd4f158f6$var$load("kAg8V"),
    $c434eacdd4f158f6$var$load("cMubu"),
    $c434eacdd4f158f6$var$load("9Cdzw"),
    $c434eacdd4f158f6$var$load("cHWSM"),
    $c434eacdd4f158f6$var$load("35Ssm")
]).then(()=>parcelRequire('d7MLS'));

});

parcelRegister("caRTX", function(module, exports) {

let $8dd03af04994390a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8dd03af04994390a$var$load("17m16"),
    $8dd03af04994390a$var$load("kAg8V"),
    $8dd03af04994390a$var$load("cMubu"),
    $8dd03af04994390a$var$load("9Cdzw"),
    $8dd03af04994390a$var$load("cHWSM"),
    $8dd03af04994390a$var$load("35Ssm")
]).then(()=>parcelRequire('a0pbo'));

});

parcelRegister("6OyGQ", function(module, exports) {

let $4f62524a1d149380$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f62524a1d149380$var$load("17m16"),
    $4f62524a1d149380$var$load("kAg8V"),
    $4f62524a1d149380$var$load("cMubu"),
    $4f62524a1d149380$var$load("9Cdzw"),
    $4f62524a1d149380$var$load("cHWSM"),
    $4f62524a1d149380$var$load("35Ssm")
]).then(()=>parcelRequire('gYv97'));

});

parcelRegister("8fs7c", function(module, exports) {

let $60158883eb0f406e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $60158883eb0f406e$var$load("17m16"),
    $60158883eb0f406e$var$load("kAg8V"),
    $60158883eb0f406e$var$load("cMubu"),
    $60158883eb0f406e$var$load("9Cdzw"),
    $60158883eb0f406e$var$load("cHWSM"),
    $60158883eb0f406e$var$load("35Ssm")
]).then(()=>parcelRequire('B4EgR'));

});

parcelRegister("cvRbd", function(module, exports) {

let $91c1a1b9aa1a04f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $91c1a1b9aa1a04f6$var$load("17m16"),
    $91c1a1b9aa1a04f6$var$load("kAg8V"),
    $91c1a1b9aa1a04f6$var$load("cMubu"),
    $91c1a1b9aa1a04f6$var$load("9Cdzw"),
    $91c1a1b9aa1a04f6$var$load("cHWSM"),
    $91c1a1b9aa1a04f6$var$load("35Ssm")
]).then(()=>parcelRequire('hw2KQ'));

});

parcelRegister("9dBYl", function(module, exports) {

let $6b62c874b318a053$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6b62c874b318a053$var$load("17m16"),
    $6b62c874b318a053$var$load("kAg8V"),
    $6b62c874b318a053$var$load("cMubu"),
    $6b62c874b318a053$var$load("9Cdzw"),
    $6b62c874b318a053$var$load("cHWSM"),
    $6b62c874b318a053$var$load("35Ssm")
]).then(()=>parcelRequire('gfNaO'));

});

parcelRegister("3srrQ", function(module, exports) {

let $28494739f285de93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $28494739f285de93$var$load("17m16"),
    $28494739f285de93$var$load("kAg8V"),
    $28494739f285de93$var$load("cMubu"),
    $28494739f285de93$var$load("9Cdzw"),
    $28494739f285de93$var$load("cHWSM"),
    $28494739f285de93$var$load("35Ssm")
]).then(()=>parcelRequire('6mrsC'));

});

parcelRegister("fRxL7", function(module, exports) {

let $b8c5fe19fae558be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b8c5fe19fae558be$var$load("17m16"),
    $b8c5fe19fae558be$var$load("kAg8V"),
    $b8c5fe19fae558be$var$load("cMubu"),
    $b8c5fe19fae558be$var$load("9Cdzw"),
    $b8c5fe19fae558be$var$load("cHWSM"),
    $b8c5fe19fae558be$var$load("35Ssm")
]).then(()=>parcelRequire('6QY4I'));

});

parcelRegister("6cJme", function(module, exports) {

let $48470c219dbfad22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $48470c219dbfad22$var$load("17m16"),
    $48470c219dbfad22$var$load("kAg8V"),
    $48470c219dbfad22$var$load("cMubu"),
    $48470c219dbfad22$var$load("9Cdzw"),
    $48470c219dbfad22$var$load("cHWSM"),
    $48470c219dbfad22$var$load("35Ssm")
]).then(()=>parcelRequire('37xrd'));

});

parcelRegister("70MHg", function(module, exports) {

let $51ae4ea3c85f940a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $51ae4ea3c85f940a$var$load("17m16"),
    $51ae4ea3c85f940a$var$load("kAg8V"),
    $51ae4ea3c85f940a$var$load("cMubu"),
    $51ae4ea3c85f940a$var$load("9Cdzw"),
    $51ae4ea3c85f940a$var$load("cHWSM"),
    $51ae4ea3c85f940a$var$load("35Ssm")
]).then(()=>parcelRequire('gxpCh'));

});

parcelRegister("6zV8W", function(module, exports) {

let $4ca25667dad8d14c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4ca25667dad8d14c$var$load("17m16"),
    $4ca25667dad8d14c$var$load("kAg8V"),
    $4ca25667dad8d14c$var$load("cMubu"),
    $4ca25667dad8d14c$var$load("9Cdzw"),
    $4ca25667dad8d14c$var$load("cHWSM"),
    $4ca25667dad8d14c$var$load("35Ssm")
]).then(()=>parcelRequire('18l55'));

});

parcelRegister("5N98w", function(module, exports) {

let $43789daabc13e50c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $43789daabc13e50c$var$load("17m16"),
    $43789daabc13e50c$var$load("kAg8V"),
    $43789daabc13e50c$var$load("cMubu"),
    $43789daabc13e50c$var$load("9Cdzw"),
    $43789daabc13e50c$var$load("cHWSM"),
    $43789daabc13e50c$var$load("35Ssm")
]).then(()=>parcelRequire('btGRq'));

});

parcelRegister("b6gTp", function(module, exports) {

let $814d5bc30c9c0f28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $814d5bc30c9c0f28$var$load("17m16"),
    $814d5bc30c9c0f28$var$load("kAg8V"),
    $814d5bc30c9c0f28$var$load("cMubu"),
    $814d5bc30c9c0f28$var$load("9Cdzw"),
    $814d5bc30c9c0f28$var$load("cHWSM"),
    $814d5bc30c9c0f28$var$load("35Ssm")
]).then(()=>parcelRequire('unuyV'));

});

parcelRegister("1x1Bp", function(module, exports) {

let $11da1dba6659acdd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $11da1dba6659acdd$var$load("17m16"),
    $11da1dba6659acdd$var$load("kAg8V"),
    $11da1dba6659acdd$var$load("cMubu"),
    $11da1dba6659acdd$var$load("9Cdzw"),
    $11da1dba6659acdd$var$load("cHWSM"),
    $11da1dba6659acdd$var$load("35Ssm")
]).then(()=>parcelRequire('4GFkJ'));

});

parcelRegister("6Q0A2", function(module, exports) {

let $4fa80ca2dbcb4c2e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4fa80ca2dbcb4c2e$var$load("17m16"),
    $4fa80ca2dbcb4c2e$var$load("kAg8V"),
    $4fa80ca2dbcb4c2e$var$load("cMubu"),
    $4fa80ca2dbcb4c2e$var$load("9Cdzw"),
    $4fa80ca2dbcb4c2e$var$load("cHWSM"),
    $4fa80ca2dbcb4c2e$var$load("35Ssm")
]).then(()=>parcelRequire('cf5Cc'));

});

parcelRegister("4dt5q", function(module, exports) {

let $311ef0480ac27569$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $311ef0480ac27569$var$load("17m16"),
    $311ef0480ac27569$var$load("kAg8V"),
    $311ef0480ac27569$var$load("cMubu"),
    $311ef0480ac27569$var$load("9Cdzw"),
    $311ef0480ac27569$var$load("cHWSM"),
    $311ef0480ac27569$var$load("35Ssm")
]).then(()=>parcelRequire('h1adL'));

});

parcelRegister("8rUdF", function(module, exports) {

let $626c745e882c064e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $626c745e882c064e$var$load("17m16"),
    $626c745e882c064e$var$load("kAg8V"),
    $626c745e882c064e$var$load("cMubu"),
    $626c745e882c064e$var$load("9Cdzw"),
    $626c745e882c064e$var$load("cHWSM"),
    $626c745e882c064e$var$load("35Ssm")
]).then(()=>parcelRequire('jm3Rd'));

});

parcelRegister("Bnums", function(module, exports) {

let $0705ad2e9b69a074$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0705ad2e9b69a074$var$load("17m16"),
    $0705ad2e9b69a074$var$load("kAg8V"),
    $0705ad2e9b69a074$var$load("cMubu"),
    $0705ad2e9b69a074$var$load("9Cdzw"),
    $0705ad2e9b69a074$var$load("cHWSM"),
    $0705ad2e9b69a074$var$load("35Ssm")
]).then(()=>parcelRequire('dRtqg'));

});

parcelRegister("8xnwm", function(module, exports) {

let $019aa3b7f3b65dae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $019aa3b7f3b65dae$var$load("17m16"),
    $019aa3b7f3b65dae$var$load("kAg8V"),
    $019aa3b7f3b65dae$var$load("cMubu"),
    $019aa3b7f3b65dae$var$load("9Cdzw"),
    $019aa3b7f3b65dae$var$load("cHWSM"),
    $019aa3b7f3b65dae$var$load("35Ssm")
]).then(()=>parcelRequire('4wARa'));

});

parcelRegister("hu7fb", function(module, exports) {

let $cbaadb83053e6048$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cbaadb83053e6048$var$load("17m16"),
    $cbaadb83053e6048$var$load("kAg8V"),
    $cbaadb83053e6048$var$load("cMubu"),
    $cbaadb83053e6048$var$load("9Cdzw"),
    $cbaadb83053e6048$var$load("cHWSM"),
    $cbaadb83053e6048$var$load("35Ssm")
]).then(()=>parcelRequire('8ASqp'));

});

parcelRegister("2j2vD", function(module, exports) {

let $1adf4d623931377d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1adf4d623931377d$var$load("17m16"),
    $1adf4d623931377d$var$load("kAg8V"),
    $1adf4d623931377d$var$load("cMubu"),
    $1adf4d623931377d$var$load("9Cdzw"),
    $1adf4d623931377d$var$load("cHWSM"),
    $1adf4d623931377d$var$load("35Ssm")
]).then(()=>parcelRequire('61zag'));

});

parcelRegister("c600P", function(module, exports) {

let $8ce60e0887e9eeb7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8ce60e0887e9eeb7$var$load("17m16"),
    $8ce60e0887e9eeb7$var$load("kAg8V"),
    $8ce60e0887e9eeb7$var$load("cMubu"),
    $8ce60e0887e9eeb7$var$load("9Cdzw"),
    $8ce60e0887e9eeb7$var$load("cHWSM"),
    $8ce60e0887e9eeb7$var$load("35Ssm")
]).then(()=>parcelRequire('ep44r'));

});

parcelRegister("jSOD3", function(module, exports) {

let $e79a554c446f33d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e79a554c446f33d0$var$load("17m16"),
    $e79a554c446f33d0$var$load("kAg8V"),
    $e79a554c446f33d0$var$load("cMubu"),
    $e79a554c446f33d0$var$load("9Cdzw"),
    $e79a554c446f33d0$var$load("cHWSM"),
    $e79a554c446f33d0$var$load("35Ssm")
]).then(()=>parcelRequire('9X8Ju'));

});

parcelRegister("88Z56", function(module, exports) {

let $5ede7391a03ddd28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5ede7391a03ddd28$var$load("17m16"),
    $5ede7391a03ddd28$var$load("kAg8V"),
    $5ede7391a03ddd28$var$load("cMubu"),
    $5ede7391a03ddd28$var$load("9Cdzw"),
    $5ede7391a03ddd28$var$load("cHWSM"),
    $5ede7391a03ddd28$var$load("35Ssm")
]).then(()=>parcelRequire('GkgNK'));

});

parcelRegister("93WMc", function(module, exports) {

let $01b3e72bedb63c69$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $01b3e72bedb63c69$var$load("17m16"),
    $01b3e72bedb63c69$var$load("kAg8V"),
    $01b3e72bedb63c69$var$load("cMubu"),
    $01b3e72bedb63c69$var$load("9Cdzw"),
    $01b3e72bedb63c69$var$load("cHWSM"),
    $01b3e72bedb63c69$var$load("35Ssm")
]).then(()=>parcelRequire('5IKmi'));

});

parcelRegister("59TZ0", function(module, exports) {

let $3c19380f3f05ee1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3c19380f3f05ee1f$var$load("17m16"),
    $3c19380f3f05ee1f$var$load("kAg8V"),
    $3c19380f3f05ee1f$var$load("cMubu"),
    $3c19380f3f05ee1f$var$load("9Cdzw"),
    $3c19380f3f05ee1f$var$load("cHWSM"),
    $3c19380f3f05ee1f$var$load("35Ssm")
]).then(()=>parcelRequire('jqNWJ'));

});

parcelRegister("j6WqW", function(module, exports) {

let $de9be7890f31d069$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $de9be7890f31d069$var$load("17m16"),
    $de9be7890f31d069$var$load("kAg8V"),
    $de9be7890f31d069$var$load("cMubu"),
    $de9be7890f31d069$var$load("9Cdzw"),
    $de9be7890f31d069$var$load("cHWSM"),
    $de9be7890f31d069$var$load("35Ssm")
]).then(()=>parcelRequire('1gXdU'));

});

parcelRegister("103gp", function(module, exports) {

let $0ba852a5ca18e1d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0ba852a5ca18e1d6$var$load("17m16"),
    $0ba852a5ca18e1d6$var$load("kAg8V"),
    $0ba852a5ca18e1d6$var$load("cMubu"),
    $0ba852a5ca18e1d6$var$load("9Cdzw"),
    $0ba852a5ca18e1d6$var$load("cHWSM"),
    $0ba852a5ca18e1d6$var$load("35Ssm")
]).then(()=>parcelRequire('9mJU1'));

});

parcelRegister("dBUQx", function(module, exports) {

let $9e8ad395d8d19307$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9e8ad395d8d19307$var$load("17m16"),
    $9e8ad395d8d19307$var$load("kAg8V"),
    $9e8ad395d8d19307$var$load("cMubu"),
    $9e8ad395d8d19307$var$load("9Cdzw"),
    $9e8ad395d8d19307$var$load("cHWSM"),
    $9e8ad395d8d19307$var$load("35Ssm")
]).then(()=>parcelRequire('92PTi'));

});

parcelRegister("awVjk", function(module, exports) {

let $7aa95944f9d53d99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7aa95944f9d53d99$var$load("17m16"),
    $7aa95944f9d53d99$var$load("kAg8V"),
    $7aa95944f9d53d99$var$load("cMubu"),
    $7aa95944f9d53d99$var$load("9Cdzw"),
    $7aa95944f9d53d99$var$load("cHWSM"),
    $7aa95944f9d53d99$var$load("35Ssm")
]).then(()=>parcelRequire('lgsAv'));

});

parcelRegister("9Fn1Y", function(module, exports) {

let $7099cedc62e769f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7099cedc62e769f0$var$load("17m16"),
    $7099cedc62e769f0$var$load("kAg8V"),
    $7099cedc62e769f0$var$load("cMubu"),
    $7099cedc62e769f0$var$load("9Cdzw"),
    $7099cedc62e769f0$var$load("cHWSM"),
    $7099cedc62e769f0$var$load("35Ssm")
]).then(()=>parcelRequire('awhs8'));

});

parcelRegister("d63Ye", function(module, exports) {

let $988eea6108e937f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $988eea6108e937f0$var$load("17m16"),
    $988eea6108e937f0$var$load("kAg8V"),
    $988eea6108e937f0$var$load("cMubu"),
    $988eea6108e937f0$var$load("9Cdzw"),
    $988eea6108e937f0$var$load("cHWSM"),
    $988eea6108e937f0$var$load("35Ssm")
]).then(()=>parcelRequire('6qqPD'));

});

parcelRegister("8wNYI", function(module, exports) {

let $6358148954bcdc6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6358148954bcdc6b$var$load("17m16"),
    $6358148954bcdc6b$var$load("kAg8V"),
    $6358148954bcdc6b$var$load("cMubu"),
    $6358148954bcdc6b$var$load("9Cdzw"),
    $6358148954bcdc6b$var$load("cHWSM"),
    $6358148954bcdc6b$var$load("35Ssm")
]).then(()=>parcelRequire('4f1t8'));

});

parcelRegister("j7h7l", function(module, exports) {

let $deabf2f41ba1af50$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $deabf2f41ba1af50$var$load("17m16"),
    $deabf2f41ba1af50$var$load("kAg8V"),
    $deabf2f41ba1af50$var$load("cMubu"),
    $deabf2f41ba1af50$var$load("9Cdzw"),
    $deabf2f41ba1af50$var$load("cHWSM"),
    $deabf2f41ba1af50$var$load("35Ssm")
]).then(()=>parcelRequire('g8AHf'));

});

parcelRegister("bAC7W", function(module, exports) {

let $8700a1c2aa68d813$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8700a1c2aa68d813$var$load("17m16"),
    $8700a1c2aa68d813$var$load("kAg8V"),
    $8700a1c2aa68d813$var$load("cMubu"),
    $8700a1c2aa68d813$var$load("9Cdzw"),
    $8700a1c2aa68d813$var$load("cHWSM"),
    $8700a1c2aa68d813$var$load("35Ssm")
]).then(()=>parcelRequire('h24zs'));

});

parcelRegister("Mk6iP", function(module, exports) {

let $0914136198a6f6de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0914136198a6f6de$var$load("17m16"),
    $0914136198a6f6de$var$load("kAg8V"),
    $0914136198a6f6de$var$load("cMubu"),
    $0914136198a6f6de$var$load("9Cdzw"),
    $0914136198a6f6de$var$load("cHWSM"),
    $0914136198a6f6de$var$load("35Ssm")
]).then(()=>parcelRequire('1Lu20'));

});

parcelRegister("lhr39", function(module, exports) {

let $f7e02b09fa62ba34$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f7e02b09fa62ba34$var$load("17m16"),
    $f7e02b09fa62ba34$var$load("kAg8V"),
    $f7e02b09fa62ba34$var$load("cMubu"),
    $f7e02b09fa62ba34$var$load("9Cdzw"),
    $f7e02b09fa62ba34$var$load("cHWSM"),
    $f7e02b09fa62ba34$var$load("35Ssm")
]).then(()=>parcelRequire('bAwZB'));

});

parcelRegister("aDBvo", function(module, exports) {

let $7beaa3b40809e7cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7beaa3b40809e7cd$var$load("17m16"),
    $7beaa3b40809e7cd$var$load("kAg8V"),
    $7beaa3b40809e7cd$var$load("cMubu"),
    $7beaa3b40809e7cd$var$load("9Cdzw"),
    $7beaa3b40809e7cd$var$load("cHWSM"),
    $7beaa3b40809e7cd$var$load("35Ssm")
]).then(()=>parcelRequire('cUUQB'));

});

parcelRegister("8CLA3", function(module, exports) {

let $6476c7d6f859c067$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6476c7d6f859c067$var$load("17m16"),
    $6476c7d6f859c067$var$load("kAg8V"),
    $6476c7d6f859c067$var$load("cMubu"),
    $6476c7d6f859c067$var$load("9Cdzw"),
    $6476c7d6f859c067$var$load("cHWSM"),
    $6476c7d6f859c067$var$load("35Ssm")
]).then(()=>parcelRequire('hjhw2'));

});

parcelRegister("aMKDm", function(module, exports) {

let $7da28f9cd7c86608$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7da28f9cd7c86608$var$load("17m16"),
    $7da28f9cd7c86608$var$load("kAg8V"),
    $7da28f9cd7c86608$var$load("cMubu"),
    $7da28f9cd7c86608$var$load("9Cdzw"),
    $7da28f9cd7c86608$var$load("cHWSM"),
    $7da28f9cd7c86608$var$load("35Ssm")
]).then(()=>parcelRequire('cbjE7'));

});

parcelRegister("11b9v", function(module, exports) {

let $0bde890f0b2e8398$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0bde890f0b2e8398$var$load("17m16"),
    $0bde890f0b2e8398$var$load("kAg8V"),
    $0bde890f0b2e8398$var$load("cMubu"),
    $0bde890f0b2e8398$var$load("9Cdzw"),
    $0bde890f0b2e8398$var$load("cHWSM"),
    $0bde890f0b2e8398$var$load("35Ssm")
]).then(()=>parcelRequire('d8L9r'));

});

parcelRegister("6Lzfk", function(module, exports) {

let $4ed27903f06351fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4ed27903f06351fa$var$load("17m16"),
    $4ed27903f06351fa$var$load("kAg8V"),
    $4ed27903f06351fa$var$load("cMubu"),
    $4ed27903f06351fa$var$load("9Cdzw"),
    $4ed27903f06351fa$var$load("cHWSM"),
    $4ed27903f06351fa$var$load("35Ssm")
]).then(()=>parcelRequire('9pdPw'));

});

parcelRegister("4uy4d", function(module, exports) {

let $345463bf88ae0109$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $345463bf88ae0109$var$load("17m16"),
    $345463bf88ae0109$var$load("kAg8V"),
    $345463bf88ae0109$var$load("cMubu"),
    $345463bf88ae0109$var$load("9Cdzw"),
    $345463bf88ae0109$var$load("cHWSM"),
    $345463bf88ae0109$var$load("35Ssm")
]).then(()=>parcelRequire('jlXId'));

});

parcelRegister("5kWzc", function(module, exports) {

let $3e2c4022a32ff85d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3e2c4022a32ff85d$var$load("17m16"),
    $3e2c4022a32ff85d$var$load("kAg8V"),
    $3e2c4022a32ff85d$var$load("cMubu"),
    $3e2c4022a32ff85d$var$load("9Cdzw"),
    $3e2c4022a32ff85d$var$load("cHWSM"),
    $3e2c4022a32ff85d$var$load("35Ssm")
]).then(()=>parcelRequire('9W6mi'));

});

parcelRegister("fwmTr", function(module, exports) {

let $b4cb9a47f4688df8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b4cb9a47f4688df8$var$load("17m16"),
    $b4cb9a47f4688df8$var$load("kAg8V"),
    $b4cb9a47f4688df8$var$load("cMubu"),
    $b4cb9a47f4688df8$var$load("9Cdzw"),
    $b4cb9a47f4688df8$var$load("cHWSM"),
    $b4cb9a47f4688df8$var$load("35Ssm")
]).then(()=>parcelRequire('eAZCa'));

});

parcelRegister("ant2c", function(module, exports) {

let $78e29306bf141510$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $78e29306bf141510$var$load("6dERU"),
    $78e29306bf141510$var$load("7gF8f"),
    $78e29306bf141510$var$load("gd4qs"),
    $78e29306bf141510$var$load("YEGhv"),
    $78e29306bf141510$var$load("dBb6q"),
    $78e29306bf141510$var$load("eJgH8")
]).then(()=>parcelRequire('gU4LI'));

});

parcelRegister("fc4je", function(module, exports) {

let $b0fb51b8c5e37044$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b0fb51b8c5e37044$var$load("6dERU"),
    $b0fb51b8c5e37044$var$load("7gF8f"),
    $b0fb51b8c5e37044$var$load("gd4qs"),
    $b0fb51b8c5e37044$var$load("YEGhv"),
    $b0fb51b8c5e37044$var$load("dBb6q"),
    $b0fb51b8c5e37044$var$load("eJgH8")
]).then(()=>parcelRequire('4Wx0w'));

});

parcelRegister("aq1Eq", function(module, exports) {

let $795d9cee46b9620b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $795d9cee46b9620b$var$load("6dERU"),
    $795d9cee46b9620b$var$load("7gF8f"),
    $795d9cee46b9620b$var$load("gd4qs"),
    $795d9cee46b9620b$var$load("YEGhv"),
    $795d9cee46b9620b$var$load("dBb6q"),
    $795d9cee46b9620b$var$load("eJgH8")
]).then(()=>parcelRequire('alkG3'));

});

parcelRegister("dUpVF", function(module, exports) {

let $a2049e523b8b45b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a2049e523b8b45b6$var$load("6dERU"),
    $a2049e523b8b45b6$var$load("7gF8f"),
    $a2049e523b8b45b6$var$load("gd4qs"),
    $a2049e523b8b45b6$var$load("YEGhv"),
    $a2049e523b8b45b6$var$load("dBb6q"),
    $a2049e523b8b45b6$var$load("eJgH8")
]).then(()=>parcelRequire('kSspz'));

});

parcelRegister("lFZTV", function(module, exports) {

let $fc7d71932d716c70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fc7d71932d716c70$var$load("6dERU"),
    $fc7d71932d716c70$var$load("7gF8f"),
    $fc7d71932d716c70$var$load("gd4qs"),
    $fc7d71932d716c70$var$load("YEGhv"),
    $fc7d71932d716c70$var$load("dBb6q"),
    $fc7d71932d716c70$var$load("eJgH8")
]).then(()=>parcelRequire('e7zr1'));

});

parcelRegister("b91Om", function(module, exports) {

let $81d1f0ac09603091$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $81d1f0ac09603091$var$load("6dERU"),
    $81d1f0ac09603091$var$load("7gF8f"),
    $81d1f0ac09603091$var$load("gd4qs"),
    $81d1f0ac09603091$var$load("YEGhv"),
    $81d1f0ac09603091$var$load("dBb6q"),
    $81d1f0ac09603091$var$load("eJgH8")
]).then(()=>parcelRequire('LXDBu'));

});

parcelRegister("kRP4O", function(module, exports) {

let $f31060a02f8c4581$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f31060a02f8c4581$var$load("6dERU"),
    $f31060a02f8c4581$var$load("7gF8f"),
    $f31060a02f8c4581$var$load("gd4qs"),
    $f31060a02f8c4581$var$load("YEGhv"),
    $f31060a02f8c4581$var$load("dBb6q"),
    $f31060a02f8c4581$var$load("eJgH8")
]).then(()=>parcelRequire('c9O6m'));

});

parcelRegister("fFuqn", function(module, exports) {

let $b68249012e4bf3ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b68249012e4bf3ec$var$load("6dERU"),
    $b68249012e4bf3ec$var$load("7gF8f"),
    $b68249012e4bf3ec$var$load("gd4qs"),
    $b68249012e4bf3ec$var$load("YEGhv"),
    $b68249012e4bf3ec$var$load("dBb6q"),
    $b68249012e4bf3ec$var$load("eJgH8")
]).then(()=>parcelRequire('28QMN'));

});

parcelRegister("c6G5D", function(module, exports) {

let $8d06b1bc1f43bf87$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8d06b1bc1f43bf87$var$load("6dERU"),
    $8d06b1bc1f43bf87$var$load("7gF8f"),
    $8d06b1bc1f43bf87$var$load("gd4qs"),
    $8d06b1bc1f43bf87$var$load("YEGhv"),
    $8d06b1bc1f43bf87$var$load("dBb6q"),
    $8d06b1bc1f43bf87$var$load("eJgH8")
]).then(()=>parcelRequire('8so3a'));

});

parcelRegister("4p46Z", function(module, exports) {

let $334cafbe2e29fe6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $334cafbe2e29fe6d$var$load("6dERU"),
    $334cafbe2e29fe6d$var$load("7gF8f"),
    $334cafbe2e29fe6d$var$load("gd4qs"),
    $334cafbe2e29fe6d$var$load("YEGhv"),
    $334cafbe2e29fe6d$var$load("dBb6q"),
    $334cafbe2e29fe6d$var$load("eJgH8")
]).then(()=>parcelRequire('cKaxg'));

});

parcelRegister("jqDvG", function(module, exports) {

let $e24f17e20bc396fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e24f17e20bc396fc$var$load("6dERU"),
    $e24f17e20bc396fc$var$load("7gF8f"),
    $e24f17e20bc396fc$var$load("gd4qs"),
    $e24f17e20bc396fc$var$load("YEGhv"),
    $e24f17e20bc396fc$var$load("dBb6q"),
    $e24f17e20bc396fc$var$load("eJgH8")
]).then(()=>parcelRequire('oVpHS'));

});

parcelRegister("5kyZB", function(module, exports) {

let $3e19f6d107837bdf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3e19f6d107837bdf$var$load("6dERU"),
    $3e19f6d107837bdf$var$load("7gF8f"),
    $3e19f6d107837bdf$var$load("gd4qs"),
    $3e19f6d107837bdf$var$load("YEGhv"),
    $3e19f6d107837bdf$var$load("dBb6q"),
    $3e19f6d107837bdf$var$load("eJgH8")
]).then(()=>parcelRequire('bptXN'));

});

parcelRegister("kfOaY", function(module, exports) {

let $ebec2146010f0448$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ebec2146010f0448$var$load("6dERU"),
    $ebec2146010f0448$var$load("7gF8f"),
    $ebec2146010f0448$var$load("gd4qs"),
    $ebec2146010f0448$var$load("YEGhv"),
    $ebec2146010f0448$var$load("dBb6q"),
    $ebec2146010f0448$var$load("eJgH8")
]).then(()=>parcelRequire('d6lfc'));

});

parcelRegister("9fnZO", function(module, exports) {

let $6bb820dfa47df040$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6bb820dfa47df040$var$load("6dERU"),
    $6bb820dfa47df040$var$load("7gF8f"),
    $6bb820dfa47df040$var$load("gd4qs"),
    $6bb820dfa47df040$var$load("YEGhv"),
    $6bb820dfa47df040$var$load("dBb6q"),
    $6bb820dfa47df040$var$load("eJgH8")
]).then(()=>parcelRequire('kjqKG'));

});

parcelRegister("dCntC", function(module, exports) {

let $9ea108f7836b49f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9ea108f7836b49f6$var$load("6dERU"),
    $9ea108f7836b49f6$var$load("7gF8f"),
    $9ea108f7836b49f6$var$load("gd4qs"),
    $9ea108f7836b49f6$var$load("YEGhv"),
    $9ea108f7836b49f6$var$load("dBb6q"),
    $9ea108f7836b49f6$var$load("eJgH8")
]).then(()=>parcelRequire('8K7MZ'));

});

parcelRegister("5OcxY", function(module, exports) {

let $43ab5ad56b025892$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $43ab5ad56b025892$var$load("6dERU"),
    $43ab5ad56b025892$var$load("7gF8f"),
    $43ab5ad56b025892$var$load("gd4qs"),
    $43ab5ad56b025892$var$load("YEGhv"),
    $43ab5ad56b025892$var$load("dBb6q"),
    $43ab5ad56b025892$var$load("eJgH8")
]).then(()=>parcelRequire('9D3Wg'));

});

parcelRegister("cIGUw", function(module, exports) {

let $942ae1485c024b37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $942ae1485c024b37$var$load("6dERU"),
    $942ae1485c024b37$var$load("7gF8f"),
    $942ae1485c024b37$var$load("gd4qs"),
    $942ae1485c024b37$var$load("YEGhv"),
    $942ae1485c024b37$var$load("dBb6q"),
    $942ae1485c024b37$var$load("eJgH8")
]).then(()=>parcelRequire('nEYSn'));

});

parcelRegister("9pxxR", function(module, exports) {

let $01c4a719cb5e88a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $01c4a719cb5e88a1$var$load("6dERU"),
    $01c4a719cb5e88a1$var$load("7gF8f"),
    $01c4a719cb5e88a1$var$load("gd4qs"),
    $01c4a719cb5e88a1$var$load("YEGhv"),
    $01c4a719cb5e88a1$var$load("dBb6q"),
    $01c4a719cb5e88a1$var$load("eJgH8")
]).then(()=>parcelRequire('kqFte'));

});

parcelRegister("22KPu", function(module, exports) {

let $17d0180c49f497b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $17d0180c49f497b0$var$load("6dERU"),
    $17d0180c49f497b0$var$load("7gF8f"),
    $17d0180c49f497b0$var$load("gd4qs"),
    $17d0180c49f497b0$var$load("YEGhv"),
    $17d0180c49f497b0$var$load("dBb6q"),
    $17d0180c49f497b0$var$load("eJgH8")
]).then(()=>parcelRequire('8YYHz'));

});

parcelRegister("hM6ew", function(module, exports) {

let $cf0bc12162207980$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cf0bc12162207980$var$load("6dERU"),
    $cf0bc12162207980$var$load("7gF8f"),
    $cf0bc12162207980$var$load("gd4qs"),
    $cf0bc12162207980$var$load("YEGhv"),
    $cf0bc12162207980$var$load("dBb6q"),
    $cf0bc12162207980$var$load("eJgH8")
]).then(()=>parcelRequire('aJrGo'));

});

parcelRegister("eLqUQ", function(module, exports) {

let $abfa55663a5080cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $abfa55663a5080cb$var$load("6dERU"),
    $abfa55663a5080cb$var$load("7gF8f"),
    $abfa55663a5080cb$var$load("gd4qs"),
    $abfa55663a5080cb$var$load("YEGhv"),
    $abfa55663a5080cb$var$load("dBb6q"),
    $abfa55663a5080cb$var$load("eJgH8")
]).then(()=>parcelRequire('4akmm'));

});

parcelRegister("6XJHZ", function(module, exports) {

let $511bb5818bcc440e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $511bb5818bcc440e$var$load("6dERU"),
    $511bb5818bcc440e$var$load("7gF8f"),
    $511bb5818bcc440e$var$load("gd4qs"),
    $511bb5818bcc440e$var$load("YEGhv"),
    $511bb5818bcc440e$var$load("dBb6q"),
    $511bb5818bcc440e$var$load("eJgH8")
]).then(()=>parcelRequire('6iLPN'));

});

parcelRegister("c7V0X", function(module, exports) {

let $8d425d60d3afb845$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8d425d60d3afb845$var$load("6dERU"),
    $8d425d60d3afb845$var$load("7gF8f"),
    $8d425d60d3afb845$var$load("gd4qs"),
    $8d425d60d3afb845$var$load("YEGhv"),
    $8d425d60d3afb845$var$load("dBb6q"),
    $8d425d60d3afb845$var$load("eJgH8")
]).then(()=>parcelRequire('2LgCK'));

});

parcelRegister("5VPPI", function(module, exports) {

let $451a7b99ee51e4e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $451a7b99ee51e4e2$var$load("6dERU"),
    $451a7b99ee51e4e2$var$load("7gF8f"),
    $451a7b99ee51e4e2$var$load("gd4qs"),
    $451a7b99ee51e4e2$var$load("YEGhv"),
    $451a7b99ee51e4e2$var$load("dBb6q"),
    $451a7b99ee51e4e2$var$load("eJgH8")
]).then(()=>parcelRequire('Pd4Mz'));

});

parcelRegister("jGyoB", function(module, exports) {

let $e54c9ee1b78c20e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e54c9ee1b78c20e4$var$load("6dERU"),
    $e54c9ee1b78c20e4$var$load("7gF8f"),
    $e54c9ee1b78c20e4$var$load("gd4qs"),
    $e54c9ee1b78c20e4$var$load("YEGhv"),
    $e54c9ee1b78c20e4$var$load("dBb6q"),
    $e54c9ee1b78c20e4$var$load("eJgH8")
]).then(()=>parcelRequire('1yQta'));

});

parcelRegister("12EHY", function(module, exports) {

let $0c258e23762aaa92$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0c258e23762aaa92$var$load("6dERU"),
    $0c258e23762aaa92$var$load("7gF8f"),
    $0c258e23762aaa92$var$load("gd4qs"),
    $0c258e23762aaa92$var$load("YEGhv"),
    $0c258e23762aaa92$var$load("dBb6q"),
    $0c258e23762aaa92$var$load("eJgH8")
]).then(()=>parcelRequire('9VCgg'));

});

parcelRegister("9Bk5u", function(module, exports) {

let $6fd726bb888cc6a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6fd726bb888cc6a5$var$load("6dERU"),
    $6fd726bb888cc6a5$var$load("7gF8f"),
    $6fd726bb888cc6a5$var$load("gd4qs"),
    $6fd726bb888cc6a5$var$load("YEGhv"),
    $6fd726bb888cc6a5$var$load("dBb6q"),
    $6fd726bb888cc6a5$var$load("eJgH8")
]).then(()=>parcelRequire('ghtBk'));

});

parcelRegister("gq8Xj", function(module, exports) {

let $bf460570ca459296$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bf460570ca459296$var$load("6dERU"),
    $bf460570ca459296$var$load("7gF8f"),
    $bf460570ca459296$var$load("gd4qs"),
    $bf460570ca459296$var$load("YEGhv"),
    $bf460570ca459296$var$load("dBb6q"),
    $bf460570ca459296$var$load("eJgH8")
]).then(()=>parcelRequire('7z5pS'));

});

parcelRegister("RYO6Q", function(module, exports) {

let $0a241e661167bb58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0a241e661167bb58$var$load("6dERU"),
    $0a241e661167bb58$var$load("7gF8f"),
    $0a241e661167bb58$var$load("gd4qs"),
    $0a241e661167bb58$var$load("YEGhv"),
    $0a241e661167bb58$var$load("dBb6q"),
    $0a241e661167bb58$var$load("eJgH8")
]).then(()=>parcelRequire('ceOCC'));

});

parcelRegister("1aYnM", function(module, exports) {

let $0db5905b170bcbdf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0db5905b170bcbdf$var$load("6dERU"),
    $0db5905b170bcbdf$var$load("7gF8f"),
    $0db5905b170bcbdf$var$load("gd4qs"),
    $0db5905b170bcbdf$var$load("YEGhv"),
    $0db5905b170bcbdf$var$load("dBb6q"),
    $0db5905b170bcbdf$var$load("eJgH8")
]).then(()=>parcelRequire('kHq45'));

});

parcelRegister("7s4Gp", function(module, exports) {

let $56cec7e69b311f12$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $56cec7e69b311f12$var$load("6dERU"),
    $56cec7e69b311f12$var$load("7gF8f"),
    $56cec7e69b311f12$var$load("gd4qs"),
    $56cec7e69b311f12$var$load("YEGhv"),
    $56cec7e69b311f12$var$load("dBb6q"),
    $56cec7e69b311f12$var$load("eJgH8")
]).then(()=>parcelRequire('41slP'));

});

parcelRegister("4Qjsa", function(module, exports) {

let $386b1bc41f7d6899$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $386b1bc41f7d6899$var$load("6dERU"),
    $386b1bc41f7d6899$var$load("7gF8f"),
    $386b1bc41f7d6899$var$load("gd4qs"),
    $386b1bc41f7d6899$var$load("YEGhv"),
    $386b1bc41f7d6899$var$load("dBb6q"),
    $386b1bc41f7d6899$var$load("eJgH8")
]).then(()=>parcelRequire('4zej3'));

});

parcelRegister("8xC7R", function(module, exports) {

let $637efac52e6f9f77$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $637efac52e6f9f77$var$load("6dERU"),
    $637efac52e6f9f77$var$load("7gF8f"),
    $637efac52e6f9f77$var$load("gd4qs"),
    $637efac52e6f9f77$var$load("YEGhv"),
    $637efac52e6f9f77$var$load("dBb6q"),
    $637efac52e6f9f77$var$load("eJgH8")
]).then(()=>parcelRequire('2Go83'));

});

parcelRegister("gUE67", function(module, exports) {

let $c500fae2642ad431$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c500fae2642ad431$var$load("6dERU"),
    $c500fae2642ad431$var$load("7gF8f"),
    $c500fae2642ad431$var$load("gd4qs"),
    $c500fae2642ad431$var$load("YEGhv"),
    $c500fae2642ad431$var$load("dBb6q"),
    $c500fae2642ad431$var$load("eJgH8")
]).then(()=>parcelRequire('Oz8gk'));

});

parcelRegister("6im8C", function(module, exports) {

let $495598a7c60717e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $495598a7c60717e0$var$load("6dERU"),
    $495598a7c60717e0$var$load("7gF8f"),
    $495598a7c60717e0$var$load("gd4qs"),
    $495598a7c60717e0$var$load("YEGhv"),
    $495598a7c60717e0$var$load("dBb6q"),
    $495598a7c60717e0$var$load("eJgH8")
]).then(()=>parcelRequire('1RnOO'));

});

parcelRegister("kQzCW", function(module, exports) {

let $f2d44cc93eedf5ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f2d44cc93eedf5ba$var$load("6dERU"),
    $f2d44cc93eedf5ba$var$load("7gF8f"),
    $f2d44cc93eedf5ba$var$load("gd4qs"),
    $f2d44cc93eedf5ba$var$load("YEGhv"),
    $f2d44cc93eedf5ba$var$load("dBb6q"),
    $f2d44cc93eedf5ba$var$load("eJgH8")
]).then(()=>parcelRequire('d5Wt5'));

});

parcelRegister("5RcRV", function(module, exports) {

let $443be276f2f78d8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $443be276f2f78d8f$var$load("6dERU"),
    $443be276f2f78d8f$var$load("7gF8f"),
    $443be276f2f78d8f$var$load("gd4qs"),
    $443be276f2f78d8f$var$load("YEGhv"),
    $443be276f2f78d8f$var$load("dBb6q"),
    $443be276f2f78d8f$var$load("eJgH8")
]).then(()=>parcelRequire('8JbNx'));

});

parcelRegister("aavdM", function(module, exports) {

let $76730e6f41e45869$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $76730e6f41e45869$var$load("6dERU"),
    $76730e6f41e45869$var$load("7gF8f"),
    $76730e6f41e45869$var$load("gd4qs"),
    $76730e6f41e45869$var$load("YEGhv"),
    $76730e6f41e45869$var$load("dBb6q"),
    $76730e6f41e45869$var$load("eJgH8")
]).then(()=>parcelRequire('f72Ys'));

});

parcelRegister("5XnXI", function(module, exports) {

let $45650cd453c935c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $45650cd453c935c6$var$load("6dERU"),
    $45650cd453c935c6$var$load("7gF8f"),
    $45650cd453c935c6$var$load("gd4qs"),
    $45650cd453c935c6$var$load("YEGhv"),
    $45650cd453c935c6$var$load("dBb6q"),
    $45650cd453c935c6$var$load("eJgH8")
]).then(()=>parcelRequire('gi5Fg'));

});

parcelRegister("fSlKh", function(module, exports) {

let $b8ecc456f89ba2e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b8ecc456f89ba2e6$var$load("6dERU"),
    $b8ecc456f89ba2e6$var$load("7gF8f"),
    $b8ecc456f89ba2e6$var$load("gd4qs"),
    $b8ecc456f89ba2e6$var$load("YEGhv"),
    $b8ecc456f89ba2e6$var$load("dBb6q"),
    $b8ecc456f89ba2e6$var$load("eJgH8")
]).then(()=>parcelRequire('kU0T7'));

});

parcelRegister("2fhU5", function(module, exports) {

let $1a2adecbab836436$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1a2adecbab836436$var$load("6dERU"),
    $1a2adecbab836436$var$load("7gF8f"),
    $1a2adecbab836436$var$load("gd4qs"),
    $1a2adecbab836436$var$load("YEGhv"),
    $1a2adecbab836436$var$load("dBb6q"),
    $1a2adecbab836436$var$load("eJgH8")
]).then(()=>parcelRequire('04hGF'));

});

parcelRegister("9q1e5", function(module, exports) {

let $6db77e3ee6917646$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6db77e3ee6917646$var$load("6dERU"),
    $6db77e3ee6917646$var$load("7gF8f"),
    $6db77e3ee6917646$var$load("gd4qs"),
    $6db77e3ee6917646$var$load("YEGhv"),
    $6db77e3ee6917646$var$load("dBb6q"),
    $6db77e3ee6917646$var$load("eJgH8")
]).then(()=>parcelRequire('4uOA7'));

});

parcelRegister("24c8C", function(module, exports) {

let $18155ed542575480$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $18155ed542575480$var$load("6dERU"),
    $18155ed542575480$var$load("7gF8f"),
    $18155ed542575480$var$load("gd4qs"),
    $18155ed542575480$var$load("YEGhv"),
    $18155ed542575480$var$load("dBb6q"),
    $18155ed542575480$var$load("eJgH8")
]).then(()=>parcelRequire('kS48C'));

});

parcelRegister("hRU4W", function(module, exports) {

let $d022e2fde5ef651e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d022e2fde5ef651e$var$load("6dERU"),
    $d022e2fde5ef651e$var$load("7gF8f"),
    $d022e2fde5ef651e$var$load("gd4qs"),
    $d022e2fde5ef651e$var$load("YEGhv"),
    $d022e2fde5ef651e$var$load("dBb6q"),
    $d022e2fde5ef651e$var$load("eJgH8")
]).then(()=>parcelRequire('35zCn'));

});

parcelRegister("6QI6Z", function(module, exports) {

let $4fc9d10f3b281ccc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4fc9d10f3b281ccc$var$load("6dERU"),
    $4fc9d10f3b281ccc$var$load("7gF8f"),
    $4fc9d10f3b281ccc$var$load("gd4qs"),
    $4fc9d10f3b281ccc$var$load("YEGhv"),
    $4fc9d10f3b281ccc$var$load("dBb6q"),
    $4fc9d10f3b281ccc$var$load("eJgH8")
]).then(()=>parcelRequire('2fTtK'));

});

parcelRegister("1gxq9", function(module, exports) {

let $0ec135bc67dbaa0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0ec135bc67dbaa0d$var$load("6dERU"),
    $0ec135bc67dbaa0d$var$load("7gF8f"),
    $0ec135bc67dbaa0d$var$load("gd4qs"),
    $0ec135bc67dbaa0d$var$load("YEGhv"),
    $0ec135bc67dbaa0d$var$load("dBb6q"),
    $0ec135bc67dbaa0d$var$load("eJgH8")
]).then(()=>parcelRequire('enH5p'));

});

parcelRegister("eKFPk", function(module, exports) {

let $abd5ce7d000cf53e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $abd5ce7d000cf53e$var$load("6dERU"),
    $abd5ce7d000cf53e$var$load("7gF8f"),
    $abd5ce7d000cf53e$var$load("gd4qs"),
    $abd5ce7d000cf53e$var$load("YEGhv"),
    $abd5ce7d000cf53e$var$load("dBb6q"),
    $abd5ce7d000cf53e$var$load("eJgH8")
]).then(()=>parcelRequire('cZ9rh'));

});

parcelRegister("gthL6", function(module, exports) {

let $bfdd214d7329c022$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bfdd214d7329c022$var$load("6dERU"),
    $bfdd214d7329c022$var$load("7gF8f"),
    $bfdd214d7329c022$var$load("gd4qs"),
    $bfdd214d7329c022$var$load("YEGhv"),
    $bfdd214d7329c022$var$load("dBb6q"),
    $bfdd214d7329c022$var$load("eJgH8")
]).then(()=>parcelRequire('aud6M'));

});

parcelRegister("6tnhg", function(module, exports) {

let $4b6781f19923783d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4b6781f19923783d$var$load("6dERU"),
    $4b6781f19923783d$var$load("7gF8f"),
    $4b6781f19923783d$var$load("gd4qs"),
    $4b6781f19923783d$var$load("YEGhv"),
    $4b6781f19923783d$var$load("dBb6q"),
    $4b6781f19923783d$var$load("eJgH8")
]).then(()=>parcelRequire('3GQSj'));

});

parcelRegister("h5I7u", function(module, exports) {

let $c715208ddc37e989$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c715208ddc37e989$var$load("6dERU"),
    $c715208ddc37e989$var$load("7gF8f"),
    $c715208ddc37e989$var$load("gd4qs"),
    $c715208ddc37e989$var$load("YEGhv"),
    $c715208ddc37e989$var$load("dBb6q"),
    $c715208ddc37e989$var$load("eJgH8")
]).then(()=>parcelRequire('1zC89'));

});

parcelRegister("5COaO", function(module, exports) {

let $41876bc5e9e05c8c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $41876bc5e9e05c8c$var$load("38sfA"),
    $41876bc5e9e05c8c$var$load("awkVi"),
    $41876bc5e9e05c8c$var$load("h4OCL"),
    $41876bc5e9e05c8c$var$load("6yRq3"),
    $41876bc5e9e05c8c$var$load("ktSfi"),
    $41876bc5e9e05c8c$var$load("9GZ76")
]).then(()=>parcelRequire('dbbA6'));

});

parcelRegister("hvX00", function(module, exports) {

let $cc0318e6ad34a303$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cc0318e6ad34a303$var$load("38sfA"),
    $cc0318e6ad34a303$var$load("awkVi"),
    $cc0318e6ad34a303$var$load("h4OCL"),
    $cc0318e6ad34a303$var$load("6yRq3"),
    $cc0318e6ad34a303$var$load("ktSfi"),
    $cc0318e6ad34a303$var$load("9GZ76")
]).then(()=>parcelRequire('gHoLN'));

});

parcelRegister("kqu9A", function(module, exports) {

let $ededa03bf580c070$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ededa03bf580c070$var$load("38sfA"),
    $ededa03bf580c070$var$load("awkVi"),
    $ededa03bf580c070$var$load("h4OCL"),
    $ededa03bf580c070$var$load("6yRq3"),
    $ededa03bf580c070$var$load("ktSfi"),
    $ededa03bf580c070$var$load("9GZ76")
]).then(()=>parcelRequire('fKZKi'));

});

parcelRegister("fkwqh", function(module, exports) {

let $b291dfc693d4d593$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b291dfc693d4d593$var$load("38sfA"),
    $b291dfc693d4d593$var$load("awkVi"),
    $b291dfc693d4d593$var$load("h4OCL"),
    $b291dfc693d4d593$var$load("6yRq3"),
    $b291dfc693d4d593$var$load("ktSfi"),
    $b291dfc693d4d593$var$load("9GZ76")
]).then(()=>parcelRequire('3japI'));

});

parcelRegister("6JizP", function(module, exports) {

let $4e655b09bcdf4bbb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e655b09bcdf4bbb$var$load("38sfA"),
    $4e655b09bcdf4bbb$var$load("awkVi"),
    $4e655b09bcdf4bbb$var$load("h4OCL"),
    $4e655b09bcdf4bbb$var$load("6yRq3"),
    $4e655b09bcdf4bbb$var$load("ktSfi"),
    $4e655b09bcdf4bbb$var$load("9GZ76")
]).then(()=>parcelRequire('cF55v'));

});

parcelRegister("fVT8P", function(module, exports) {

let $b996f3d655700207$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b996f3d655700207$var$load("38sfA"),
    $b996f3d655700207$var$load("awkVi"),
    $b996f3d655700207$var$load("h4OCL"),
    $b996f3d655700207$var$load("6yRq3"),
    $b996f3d655700207$var$load("ktSfi"),
    $b996f3d655700207$var$load("9GZ76")
]).then(()=>parcelRequire('9Dgyh'));

});

parcelRegister("fpPp8", function(module, exports) {

let $b39110a94f112f0f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b39110a94f112f0f$var$load("38sfA"),
    $b39110a94f112f0f$var$load("awkVi"),
    $b39110a94f112f0f$var$load("h4OCL"),
    $b39110a94f112f0f$var$load("6yRq3"),
    $b39110a94f112f0f$var$load("ktSfi"),
    $b39110a94f112f0f$var$load("9GZ76")
]).then(()=>parcelRequire('hwuOA'));

});

parcelRegister("kYDpE", function(module, exports) {

let $f457fbd05f56c37d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f457fbd05f56c37d$var$load("38sfA"),
    $f457fbd05f56c37d$var$load("awkVi"),
    $f457fbd05f56c37d$var$load("h4OCL"),
    $f457fbd05f56c37d$var$load("6yRq3"),
    $f457fbd05f56c37d$var$load("ktSfi"),
    $f457fbd05f56c37d$var$load("9GZ76")
]).then(()=>parcelRequire('hflsJ'));

});

parcelRegister("knkpn", function(module, exports) {

let $ed55c949803957ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ed55c949803957ee$var$load("38sfA"),
    $ed55c949803957ee$var$load("awkVi"),
    $ed55c949803957ee$var$load("h4OCL"),
    $ed55c949803957ee$var$load("6yRq3"),
    $ed55c949803957ee$var$load("ktSfi"),
    $ed55c949803957ee$var$load("9GZ76")
]).then(()=>parcelRequire('fcP5z'));

});

parcelRegister("gLkBH", function(module, exports) {

let $c3410541a60cc924$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c3410541a60cc924$var$load("38sfA"),
    $c3410541a60cc924$var$load("awkVi"),
    $c3410541a60cc924$var$load("h4OCL"),
    $c3410541a60cc924$var$load("6yRq3"),
    $c3410541a60cc924$var$load("ktSfi"),
    $c3410541a60cc924$var$load("9GZ76")
]).then(()=>parcelRequire('ldEQF'));

});

parcelRegister("gCqQJ", function(module, exports) {

let $c19505b9d08bb281$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c19505b9d08bb281$var$load("38sfA"),
    $c19505b9d08bb281$var$load("awkVi"),
    $c19505b9d08bb281$var$load("h4OCL"),
    $c19505b9d08bb281$var$load("6yRq3"),
    $c19505b9d08bb281$var$load("ktSfi"),
    $c19505b9d08bb281$var$load("9GZ76")
]).then(()=>parcelRequire('zfyRh'));

});

parcelRegister("1RReW", function(module, exports) {

let $15c40a0bda74fef9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $15c40a0bda74fef9$var$load("38sfA"),
    $15c40a0bda74fef9$var$load("awkVi"),
    $15c40a0bda74fef9$var$load("h4OCL"),
    $15c40a0bda74fef9$var$load("6yRq3"),
    $15c40a0bda74fef9$var$load("ktSfi"),
    $15c40a0bda74fef9$var$load("9GZ76")
]).then(()=>parcelRequire('kkTYy'));

});

parcelRegister("b9WlS", function(module, exports) {

let $81fdcc70cd3a3523$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $81fdcc70cd3a3523$var$load("38sfA"),
    $81fdcc70cd3a3523$var$load("awkVi"),
    $81fdcc70cd3a3523$var$load("h4OCL"),
    $81fdcc70cd3a3523$var$load("6yRq3"),
    $81fdcc70cd3a3523$var$load("ktSfi"),
    $81fdcc70cd3a3523$var$load("9GZ76")
]).then(()=>parcelRequire('4xKLM'));

});

parcelRegister("i5adi", function(module, exports) {

let $d2a09dd1cbf12f31$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d2a09dd1cbf12f31$var$load("38sfA"),
    $d2a09dd1cbf12f31$var$load("awkVi"),
    $d2a09dd1cbf12f31$var$load("h4OCL"),
    $d2a09dd1cbf12f31$var$load("6yRq3"),
    $d2a09dd1cbf12f31$var$load("ktSfi"),
    $d2a09dd1cbf12f31$var$load("9GZ76")
]).then(()=>parcelRequire('lM2nS'));

});

parcelRegister("llCCX", function(module, exports) {

let $f8a985b61c74205f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f8a985b61c74205f$var$load("38sfA"),
    $f8a985b61c74205f$var$load("awkVi"),
    $f8a985b61c74205f$var$load("h4OCL"),
    $f8a985b61c74205f$var$load("6yRq3"),
    $f8a985b61c74205f$var$load("ktSfi"),
    $f8a985b61c74205f$var$load("9GZ76")
]).then(()=>parcelRequire('bp2ak'));

});

parcelRegister("dnSJ9", function(module, exports) {

let $9be7e006634aa185$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9be7e006634aa185$var$load("38sfA"),
    $9be7e006634aa185$var$load("awkVi"),
    $9be7e006634aa185$var$load("h4OCL"),
    $9be7e006634aa185$var$load("6yRq3"),
    $9be7e006634aa185$var$load("ktSfi"),
    $9be7e006634aa185$var$load("9GZ76")
]).then(()=>parcelRequire('60bto'));

});

parcelRegister("8Mgtj", function(module, exports) {

let $663f955f0fe47f93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $663f955f0fe47f93$var$load("38sfA"),
    $663f955f0fe47f93$var$load("awkVi"),
    $663f955f0fe47f93$var$load("h4OCL"),
    $663f955f0fe47f93$var$load("6yRq3"),
    $663f955f0fe47f93$var$load("ktSfi"),
    $663f955f0fe47f93$var$load("9GZ76")
]).then(()=>parcelRequire('cCcsq'));

});

parcelRegister("2pTEE", function(module, exports) {

let $1c291671aed0e42b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1c291671aed0e42b$var$load("38sfA"),
    $1c291671aed0e42b$var$load("awkVi"),
    $1c291671aed0e42b$var$load("h4OCL"),
    $1c291671aed0e42b$var$load("6yRq3"),
    $1c291671aed0e42b$var$load("ktSfi"),
    $1c291671aed0e42b$var$load("9GZ76")
]).then(()=>parcelRequire('dvmRd'));

});

parcelRegister("jpv7D", function(module, exports) {

let $e2187e556ea81cd7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e2187e556ea81cd7$var$load("38sfA"),
    $e2187e556ea81cd7$var$load("awkVi"),
    $e2187e556ea81cd7$var$load("h4OCL"),
    $e2187e556ea81cd7$var$load("6yRq3"),
    $e2187e556ea81cd7$var$load("ktSfi"),
    $e2187e556ea81cd7$var$load("9GZ76")
]).then(()=>parcelRequire('cDvK1'));

});

parcelRegister("h9yAS", function(module, exports) {

let $c7ce1c8ab1b22a14$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c7ce1c8ab1b22a14$var$load("38sfA"),
    $c7ce1c8ab1b22a14$var$load("awkVi"),
    $c7ce1c8ab1b22a14$var$load("h4OCL"),
    $c7ce1c8ab1b22a14$var$load("6yRq3"),
    $c7ce1c8ab1b22a14$var$load("ktSfi"),
    $c7ce1c8ab1b22a14$var$load("9GZ76")
]).then(()=>parcelRequire('bcOcg'));

});

parcelRegister("2rhuV", function(module, exports) {

let $1c6bad188405c010$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1c6bad188405c010$var$load("38sfA"),
    $1c6bad188405c010$var$load("awkVi"),
    $1c6bad188405c010$var$load("h4OCL"),
    $1c6bad188405c010$var$load("6yRq3"),
    $1c6bad188405c010$var$load("ktSfi"),
    $1c6bad188405c010$var$load("9GZ76")
]).then(()=>parcelRequire('8I5Jn'));

});

parcelRegister("lAtht", function(module, exports) {

let $fb73ac5a2ee0836d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fb73ac5a2ee0836d$var$load("38sfA"),
    $fb73ac5a2ee0836d$var$load("awkVi"),
    $fb73ac5a2ee0836d$var$load("h4OCL"),
    $fb73ac5a2ee0836d$var$load("6yRq3"),
    $fb73ac5a2ee0836d$var$load("ktSfi"),
    $fb73ac5a2ee0836d$var$load("9GZ76")
]).then(()=>parcelRequire('eyF6F'));

});

parcelRegister("iDOtR", function(module, exports) {

let $d92306edf0299e36$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d92306edf0299e36$var$load("38sfA"),
    $d92306edf0299e36$var$load("awkVi"),
    $d92306edf0299e36$var$load("h4OCL"),
    $d92306edf0299e36$var$load("6yRq3"),
    $d92306edf0299e36$var$load("ktSfi"),
    $d92306edf0299e36$var$load("9GZ76")
]).then(()=>parcelRequire('5dmaB'));

});

parcelRegister("ftF7U", function(module, exports) {

let $b4497754e3c326a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b4497754e3c326a3$var$load("38sfA"),
    $b4497754e3c326a3$var$load("awkVi"),
    $b4497754e3c326a3$var$load("h4OCL"),
    $b4497754e3c326a3$var$load("6yRq3"),
    $b4497754e3c326a3$var$load("ktSfi"),
    $b4497754e3c326a3$var$load("9GZ76")
]).then(()=>parcelRequire('2xytQ'));

});

parcelRegister("ddghb", function(module, exports) {

let $99e91d5e074fb342$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $99e91d5e074fb342$var$load("38sfA"),
    $99e91d5e074fb342$var$load("awkVi"),
    $99e91d5e074fb342$var$load("h4OCL"),
    $99e91d5e074fb342$var$load("6yRq3"),
    $99e91d5e074fb342$var$load("ktSfi"),
    $99e91d5e074fb342$var$load("9GZ76")
]).then(()=>parcelRequire('1uLuc'));

});

parcelRegister("dVqdf", function(module, exports) {

let $a234ee83e146fc03$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a234ee83e146fc03$var$load("38sfA"),
    $a234ee83e146fc03$var$load("awkVi"),
    $a234ee83e146fc03$var$load("h4OCL"),
    $a234ee83e146fc03$var$load("6yRq3"),
    $a234ee83e146fc03$var$load("ktSfi"),
    $a234ee83e146fc03$var$load("9GZ76")
]).then(()=>parcelRequire('3Z08V'));

});

parcelRegister("6rLAU", function(module, exports) {

let $4b1a2ef0b46720e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4b1a2ef0b46720e1$var$load("38sfA"),
    $4b1a2ef0b46720e1$var$load("awkVi"),
    $4b1a2ef0b46720e1$var$load("h4OCL"),
    $4b1a2ef0b46720e1$var$load("6yRq3"),
    $4b1a2ef0b46720e1$var$load("ktSfi"),
    $4b1a2ef0b46720e1$var$load("9GZ76")
]).then(()=>parcelRequire('1uvKQ'));

});

parcelRegister("6HgQ9", function(module, exports) {

let $4e03d258320e6f43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e03d258320e6f43$var$load("38sfA"),
    $4e03d258320e6f43$var$load("awkVi"),
    $4e03d258320e6f43$var$load("h4OCL"),
    $4e03d258320e6f43$var$load("6yRq3"),
    $4e03d258320e6f43$var$load("ktSfi"),
    $4e03d258320e6f43$var$load("9GZ76")
]).then(()=>parcelRequire('iYbUM'));

});

parcelRegister("eEYqK", function(module, exports) {

let $aac3ad54c79ced83$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aac3ad54c79ced83$var$load("38sfA"),
    $aac3ad54c79ced83$var$load("awkVi"),
    $aac3ad54c79ced83$var$load("h4OCL"),
    $aac3ad54c79ced83$var$load("6yRq3"),
    $aac3ad54c79ced83$var$load("ktSfi"),
    $aac3ad54c79ced83$var$load("9GZ76")
]).then(()=>parcelRequire('cxGSp'));

});

parcelRegister("2YQCO", function(module, exports) {

let $22ba01993cd1263b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $22ba01993cd1263b$var$load("38sfA"),
    $22ba01993cd1263b$var$load("awkVi"),
    $22ba01993cd1263b$var$load("h4OCL"),
    $22ba01993cd1263b$var$load("6yRq3"),
    $22ba01993cd1263b$var$load("ktSfi"),
    $22ba01993cd1263b$var$load("9GZ76")
]).then(()=>parcelRequire('493uy'));

});

parcelRegister("8wO31", function(module, exports) {

let $635822500d10d044$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $635822500d10d044$var$load("38sfA"),
    $635822500d10d044$var$load("awkVi"),
    $635822500d10d044$var$load("h4OCL"),
    $635822500d10d044$var$load("6yRq3"),
    $635822500d10d044$var$load("ktSfi"),
    $635822500d10d044$var$load("9GZ76")
]).then(()=>parcelRequire('j2WUp'));

});

parcelRegister("bDOTt", function(module, exports) {

let $879ad0a3dfe9406c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $879ad0a3dfe9406c$var$load("38sfA"),
    $879ad0a3dfe9406c$var$load("awkVi"),
    $879ad0a3dfe9406c$var$load("h4OCL"),
    $879ad0a3dfe9406c$var$load("6yRq3"),
    $879ad0a3dfe9406c$var$load("ktSfi"),
    $879ad0a3dfe9406c$var$load("9GZ76")
]).then(()=>parcelRequire('guCQp'));

});

parcelRegister("04IYy", function(module, exports) {

let $00e3430cf3ea58a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $00e3430cf3ea58a1$var$load("38sfA"),
    $00e3430cf3ea58a1$var$load("awkVi"),
    $00e3430cf3ea58a1$var$load("h4OCL"),
    $00e3430cf3ea58a1$var$load("6yRq3"),
    $00e3430cf3ea58a1$var$load("ktSfi"),
    $00e3430cf3ea58a1$var$load("9GZ76")
]).then(()=>parcelRequire('bjwq7'));

});

parcelRegister("hXuM9", function(module, exports) {

let $d12fd1c5bc559fd1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d12fd1c5bc559fd1$var$load("38sfA"),
    $d12fd1c5bc559fd1$var$load("awkVi"),
    $d12fd1c5bc559fd1$var$load("h4OCL"),
    $d12fd1c5bc559fd1$var$load("6yRq3"),
    $d12fd1c5bc559fd1$var$load("ktSfi"),
    $d12fd1c5bc559fd1$var$load("9GZ76")
]).then(()=>parcelRequire('3KmqJ'));

});

parcelRegister("4sZ5E", function(module, exports) {

let $34092a32d77247d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $34092a32d77247d3$var$load("38sfA"),
    $34092a32d77247d3$var$load("awkVi"),
    $34092a32d77247d3$var$load("h4OCL"),
    $34092a32d77247d3$var$load("6yRq3"),
    $34092a32d77247d3$var$load("ktSfi"),
    $34092a32d77247d3$var$load("9GZ76")
]).then(()=>parcelRequire('lOGNR'));

});

parcelRegister("dGePy", function(module, exports) {

let $9f5ab39e3a9a955a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9f5ab39e3a9a955a$var$load("38sfA"),
    $9f5ab39e3a9a955a$var$load("awkVi"),
    $9f5ab39e3a9a955a$var$load("h4OCL"),
    $9f5ab39e3a9a955a$var$load("6yRq3"),
    $9f5ab39e3a9a955a$var$load("ktSfi"),
    $9f5ab39e3a9a955a$var$load("9GZ76")
]).then(()=>parcelRequire('5k5nc'));

});

parcelRegister("d5n8x", function(module, exports) {

let $986db076ef403b3d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $986db076ef403b3d$var$load("38sfA"),
    $986db076ef403b3d$var$load("awkVi"),
    $986db076ef403b3d$var$load("h4OCL"),
    $986db076ef403b3d$var$load("6yRq3"),
    $986db076ef403b3d$var$load("ktSfi"),
    $986db076ef403b3d$var$load("9GZ76")
]).then(()=>parcelRequire('6NoQT'));

});

parcelRegister("ixiPm", function(module, exports) {

let $037b83c546067863$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $037b83c546067863$var$load("38sfA"),
    $037b83c546067863$var$load("awkVi"),
    $037b83c546067863$var$load("h4OCL"),
    $037b83c546067863$var$load("6yRq3"),
    $037b83c546067863$var$load("ktSfi"),
    $037b83c546067863$var$load("9GZ76")
]).then(()=>parcelRequire('iOsEl'));

});

parcelRegister("isYwl", function(module, exports) {

let $d719c9ad96a0a159$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d719c9ad96a0a159$var$load("38sfA"),
    $d719c9ad96a0a159$var$load("awkVi"),
    $d719c9ad96a0a159$var$load("h4OCL"),
    $d719c9ad96a0a159$var$load("6yRq3"),
    $d719c9ad96a0a159$var$load("ktSfi"),
    $d719c9ad96a0a159$var$load("9GZ76")
]).then(()=>parcelRequire('aRJm6'));

});

parcelRegister("54x7S", function(module, exports) {

let $3b17059950d6122e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3b17059950d6122e$var$load("38sfA"),
    $3b17059950d6122e$var$load("awkVi"),
    $3b17059950d6122e$var$load("h4OCL"),
    $3b17059950d6122e$var$load("6yRq3"),
    $3b17059950d6122e$var$load("ktSfi"),
    $3b17059950d6122e$var$load("9GZ76")
]).then(()=>parcelRequire('gbpRj'));

});

parcelRegister("3MBDQ", function(module, exports) {

let $2c130daaa51094f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2c130daaa51094f2$var$load("38sfA"),
    $2c130daaa51094f2$var$load("awkVi"),
    $2c130daaa51094f2$var$load("h4OCL"),
    $2c130daaa51094f2$var$load("6yRq3"),
    $2c130daaa51094f2$var$load("ktSfi"),
    $2c130daaa51094f2$var$load("9GZ76")
]).then(()=>parcelRequire('eMsCn'));

});

parcelRegister("1xHL2", function(module, exports) {

let $11fad0e44d80b45b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $11fad0e44d80b45b$var$load("38sfA"),
    $11fad0e44d80b45b$var$load("awkVi"),
    $11fad0e44d80b45b$var$load("h4OCL"),
    $11fad0e44d80b45b$var$load("6yRq3"),
    $11fad0e44d80b45b$var$load("ktSfi"),
    $11fad0e44d80b45b$var$load("9GZ76")
]).then(()=>parcelRequire('7dcao'));

});

parcelRegister("2Dl1E", function(module, exports) {

let $1eaf88907f809454$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1eaf88907f809454$var$load("38sfA"),
    $1eaf88907f809454$var$load("awkVi"),
    $1eaf88907f809454$var$load("h4OCL"),
    $1eaf88907f809454$var$load("6yRq3"),
    $1eaf88907f809454$var$load("ktSfi"),
    $1eaf88907f809454$var$load("9GZ76")
]).then(()=>parcelRequire('9pmbM'));

});

parcelRegister("6Vhav", function(module, exports) {

let $50a56241b83c0b66$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $50a56241b83c0b66$var$load("38sfA"),
    $50a56241b83c0b66$var$load("awkVi"),
    $50a56241b83c0b66$var$load("h4OCL"),
    $50a56241b83c0b66$var$load("6yRq3"),
    $50a56241b83c0b66$var$load("ktSfi"),
    $50a56241b83c0b66$var$load("9GZ76")
]).then(()=>parcelRequire('b8I3p'));

});

parcelRegister("f4foO", function(module, exports) {

let $af832cb37a947e96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $af832cb37a947e96$var$load("38sfA"),
    $af832cb37a947e96$var$load("awkVi"),
    $af832cb37a947e96$var$load("h4OCL"),
    $af832cb37a947e96$var$load("6yRq3"),
    $af832cb37a947e96$var$load("ktSfi"),
    $af832cb37a947e96$var$load("9GZ76")
]).then(()=>parcelRequire('5unzT'));

});

parcelRegister("cbfay", function(module, exports) {

let $8de247628f639e34$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8de247628f639e34$var$load("38sfA"),
    $8de247628f639e34$var$load("awkVi"),
    $8de247628f639e34$var$load("h4OCL"),
    $8de247628f639e34$var$load("6yRq3"),
    $8de247628f639e34$var$load("ktSfi"),
    $8de247628f639e34$var$load("9GZ76")
]).then(()=>parcelRequire('c7GmR'));

});

parcelRegister("fwORh", function(module, exports) {

let $b4e14b99c653a5c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b4e14b99c653a5c1$var$load("38sfA"),
    $b4e14b99c653a5c1$var$load("awkVi"),
    $b4e14b99c653a5c1$var$load("h4OCL"),
    $b4e14b99c653a5c1$var$load("6yRq3"),
    $b4e14b99c653a5c1$var$load("ktSfi"),
    $b4e14b99c653a5c1$var$load("9GZ76")
]).then(()=>parcelRequire('iOvy4'));

});

parcelRegister("e1vQv", function(module, exports) {

let $a359dca26979c4a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a359dca26979c4a0$var$load("38sfA"),
    $a359dca26979c4a0$var$load("awkVi"),
    $a359dca26979c4a0$var$load("h4OCL"),
    $a359dca26979c4a0$var$load("6yRq3"),
    $a359dca26979c4a0$var$load("ktSfi"),
    $a359dca26979c4a0$var$load("9GZ76")
]).then(()=>parcelRequire('bjVxx'));

});

parcelRegister("l9hgx", function(module, exports) {

let $f657d4d5857dab99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f657d4d5857dab99$var$load("38sfA"),
    $f657d4d5857dab99$var$load("awkVi"),
    $f657d4d5857dab99$var$load("h4OCL"),
    $f657d4d5857dab99$var$load("6yRq3"),
    $f657d4d5857dab99$var$load("ktSfi"),
    $f657d4d5857dab99$var$load("9GZ76")
]).then(()=>parcelRequire('bJMQR'));

});

parcelRegister("dJEql", function(module, exports) {

let $9ffed5ac069e9321$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9ffed5ac069e9321$var$load("38sfA"),
    $9ffed5ac069e9321$var$load("awkVi"),
    $9ffed5ac069e9321$var$load("h4OCL"),
    $9ffed5ac069e9321$var$load("6yRq3"),
    $9ffed5ac069e9321$var$load("ktSfi"),
    $9ffed5ac069e9321$var$load("9GZ76")
]).then(()=>parcelRequire('j21X8'));

});

parcelRegister("dn93j", function(module, exports) {

let $9bc471f17c3d680d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9bc471f17c3d680d$var$load("dlmud"),
    $9bc471f17c3d680d$var$load("5CGnz"),
    $9bc471f17c3d680d$var$load("bNv64"),
    $9bc471f17c3d680d$var$load("dXu4x"),
    $9bc471f17c3d680d$var$load("3CucM"),
    $9bc471f17c3d680d$var$load("9yemY")
]).then(()=>parcelRequire('7vmw8'));

});

parcelRegister("9weE3", function(module, exports) {

let $6ee276687f0390b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6ee276687f0390b0$var$load("dlmud"),
    $6ee276687f0390b0$var$load("5CGnz"),
    $6ee276687f0390b0$var$load("bNv64"),
    $6ee276687f0390b0$var$load("dXu4x"),
    $6ee276687f0390b0$var$load("3CucM"),
    $6ee276687f0390b0$var$load("9yemY")
]).then(()=>parcelRequire('8EREH'));

});

parcelRegister("4ItCw", function(module, exports) {

let $36f23f704ed081d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $36f23f704ed081d0$var$load("dlmud"),
    $36f23f704ed081d0$var$load("5CGnz"),
    $36f23f704ed081d0$var$load("bNv64"),
    $36f23f704ed081d0$var$load("dXu4x"),
    $36f23f704ed081d0$var$load("3CucM"),
    $36f23f704ed081d0$var$load("9yemY")
]).then(()=>parcelRequire('Y851Q'));

});

parcelRegister("eRefA", function(module, exports) {

let $ad1111c87eaf684f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ad1111c87eaf684f$var$load("dlmud"),
    $ad1111c87eaf684f$var$load("5CGnz"),
    $ad1111c87eaf684f$var$load("bNv64"),
    $ad1111c87eaf684f$var$load("dXu4x"),
    $ad1111c87eaf684f$var$load("3CucM"),
    $ad1111c87eaf684f$var$load("9yemY")
]).then(()=>parcelRequire('cSifk'));

});

parcelRegister("hhFaw", function(module, exports) {

let $c953f575fddaaeb7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c953f575fddaaeb7$var$load("dlmud"),
    $c953f575fddaaeb7$var$load("5CGnz"),
    $c953f575fddaaeb7$var$load("bNv64"),
    $c953f575fddaaeb7$var$load("dXu4x"),
    $c953f575fddaaeb7$var$load("3CucM"),
    $c953f575fddaaeb7$var$load("9yemY")
]).then(()=>parcelRequire('bG4aH'));

});

parcelRegister("c8wt5", function(module, exports) {

let $8d5f6ae70ecfcca5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8d5f6ae70ecfcca5$var$load("dlmud"),
    $8d5f6ae70ecfcca5$var$load("5CGnz"),
    $8d5f6ae70ecfcca5$var$load("bNv64"),
    $8d5f6ae70ecfcca5$var$load("dXu4x"),
    $8d5f6ae70ecfcca5$var$load("3CucM"),
    $8d5f6ae70ecfcca5$var$load("9yemY")
]).then(()=>parcelRequire('lr7iY'));

});

parcelRegister("ksp6c", function(module, exports) {

let $ee49e45384e4d026$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ee49e45384e4d026$var$load("dlmud"),
    $ee49e45384e4d026$var$load("5CGnz"),
    $ee49e45384e4d026$var$load("bNv64"),
    $ee49e45384e4d026$var$load("dXu4x"),
    $ee49e45384e4d026$var$load("3CucM"),
    $ee49e45384e4d026$var$load("9yemY")
]).then(()=>parcelRequire('fwp8v'));

});

parcelRegister("eknul", function(module, exports) {

let $a6e52741eba16ad7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a6e52741eba16ad7$var$load("dlmud"),
    $a6e52741eba16ad7$var$load("5CGnz"),
    $a6e52741eba16ad7$var$load("bNv64"),
    $a6e52741eba16ad7$var$load("dXu4x"),
    $a6e52741eba16ad7$var$load("3CucM"),
    $a6e52741eba16ad7$var$load("9yemY")
]).then(()=>parcelRequire('7TuuZ'));

});

parcelRegister("d2WOP", function(module, exports) {

let $97f916721fb0e49f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $97f916721fb0e49f$var$load("dlmud"),
    $97f916721fb0e49f$var$load("5CGnz"),
    $97f916721fb0e49f$var$load("bNv64"),
    $97f916721fb0e49f$var$load("dXu4x"),
    $97f916721fb0e49f$var$load("3CucM"),
    $97f916721fb0e49f$var$load("9yemY")
]).then(()=>parcelRequire('bjsPb'));

});

parcelRegister("4EtrO", function(module, exports) {

let $3631bd88ca1a356c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3631bd88ca1a356c$var$load("dlmud"),
    $3631bd88ca1a356c$var$load("5CGnz"),
    $3631bd88ca1a356c$var$load("bNv64"),
    $3631bd88ca1a356c$var$load("dXu4x"),
    $3631bd88ca1a356c$var$load("3CucM"),
    $3631bd88ca1a356c$var$load("9yemY")
]).then(()=>parcelRequire('9LIHd'));

});

parcelRegister("lapQH", function(module, exports) {

let $f68e95378dcb930e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f68e95378dcb930e$var$load("dlmud"),
    $f68e95378dcb930e$var$load("5CGnz"),
    $f68e95378dcb930e$var$load("bNv64"),
    $f68e95378dcb930e$var$load("dXu4x"),
    $f68e95378dcb930e$var$load("3CucM"),
    $f68e95378dcb930e$var$load("9yemY")
]).then(()=>parcelRequire('iy8ZX'));

});

parcelRegister("iew7M", function(module, exports) {

let $d462740f036bd0dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d462740f036bd0dd$var$load("dlmud"),
    $d462740f036bd0dd$var$load("5CGnz"),
    $d462740f036bd0dd$var$load("bNv64"),
    $d462740f036bd0dd$var$load("dXu4x"),
    $d462740f036bd0dd$var$load("3CucM"),
    $d462740f036bd0dd$var$load("9yemY")
]).then(()=>parcelRequire('fLr71'));

});

parcelRegister("3NEgH", function(module, exports) {

let $2c452f2e65b72faa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2c452f2e65b72faa$var$load("dlmud"),
    $2c452f2e65b72faa$var$load("5CGnz"),
    $2c452f2e65b72faa$var$load("bNv64"),
    $2c452f2e65b72faa$var$load("dXu4x"),
    $2c452f2e65b72faa$var$load("3CucM"),
    $2c452f2e65b72faa$var$load("9yemY")
]).then(()=>parcelRequire('b7VxC'));

});

parcelRegister("ksebp", function(module, exports) {

let $ee416ca25d546c43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ee416ca25d546c43$var$load("dlmud"),
    $ee416ca25d546c43$var$load("5CGnz"),
    $ee416ca25d546c43$var$load("bNv64"),
    $ee416ca25d546c43$var$load("dXu4x"),
    $ee416ca25d546c43$var$load("3CucM"),
    $ee416ca25d546c43$var$load("9yemY")
]).then(()=>parcelRequire('cRIcG'));

});

parcelRegister("lF2vA", function(module, exports) {

let $fc4f5f730652619c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fc4f5f730652619c$var$load("dlmud"),
    $fc4f5f730652619c$var$load("5CGnz"),
    $fc4f5f730652619c$var$load("bNv64"),
    $fc4f5f730652619c$var$load("dXu4x"),
    $fc4f5f730652619c$var$load("3CucM"),
    $fc4f5f730652619c$var$load("9yemY")
]).then(()=>parcelRequire('gvE09'));

});

parcelRegister("iJ9Jb", function(module, exports) {

let $da23f9b23078c9bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $da23f9b23078c9bc$var$load("dlmud"),
    $da23f9b23078c9bc$var$load("5CGnz"),
    $da23f9b23078c9bc$var$load("bNv64"),
    $da23f9b23078c9bc$var$load("dXu4x"),
    $da23f9b23078c9bc$var$load("3CucM"),
    $da23f9b23078c9bc$var$load("9yemY")
]).then(()=>parcelRequire('l8fNN'));

});

parcelRegister("5kZ9D", function(module, exports) {

let $3e2e41fe615effac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3e2e41fe615effac$var$load("dlmud"),
    $3e2e41fe615effac$var$load("5CGnz"),
    $3e2e41fe615effac$var$load("bNv64"),
    $3e2e41fe615effac$var$load("dXu4x"),
    $3e2e41fe615effac$var$load("3CucM"),
    $3e2e41fe615effac$var$load("9yemY")
]).then(()=>parcelRequire('hK0fV'));

});

parcelRegister("lXdTE", function(module, exports) {

let $ffb9e340abd2d137$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ffb9e340abd2d137$var$load("dlmud"),
    $ffb9e340abd2d137$var$load("5CGnz"),
    $ffb9e340abd2d137$var$load("bNv64"),
    $ffb9e340abd2d137$var$load("dXu4x"),
    $ffb9e340abd2d137$var$load("3CucM"),
    $ffb9e340abd2d137$var$load("9yemY")
]).then(()=>parcelRequire('eZIhV'));

});

parcelRegister("b5Ihu", function(module, exports) {

let $813282a6cdd8c8ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $813282a6cdd8c8ed$var$load("dlmud"),
    $813282a6cdd8c8ed$var$load("5CGnz"),
    $813282a6cdd8c8ed$var$load("bNv64"),
    $813282a6cdd8c8ed$var$load("dXu4x"),
    $813282a6cdd8c8ed$var$load("3CucM"),
    $813282a6cdd8c8ed$var$load("9yemY")
]).then(()=>parcelRequire('wgY32'));

});

parcelRegister("80lc4", function(module, exports) {

let $5d3ec36baefe6c13$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5d3ec36baefe6c13$var$load("dlmud"),
    $5d3ec36baefe6c13$var$load("5CGnz"),
    $5d3ec36baefe6c13$var$load("bNv64"),
    $5d3ec36baefe6c13$var$load("dXu4x"),
    $5d3ec36baefe6c13$var$load("3CucM"),
    $5d3ec36baefe6c13$var$load("9yemY")
]).then(()=>parcelRequire('3ol7V'));

});

parcelRegister("5VQ9X", function(module, exports) {

let $451abc70789d0d4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $451abc70789d0d4a$var$load("dlmud"),
    $451abc70789d0d4a$var$load("5CGnz"),
    $451abc70789d0d4a$var$load("bNv64"),
    $451abc70789d0d4a$var$load("dXu4x"),
    $451abc70789d0d4a$var$load("3CucM"),
    $451abc70789d0d4a$var$load("9yemY")
]).then(()=>parcelRequire('bPYSK'));

});

parcelRegister("kqX74", function(module, exports) {

let $ee0416f330d0da70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ee0416f330d0da70$var$load("dlmud"),
    $ee0416f330d0da70$var$load("5CGnz"),
    $ee0416f330d0da70$var$load("bNv64"),
    $ee0416f330d0da70$var$load("dXu4x"),
    $ee0416f330d0da70$var$load("3CucM"),
    $ee0416f330d0da70$var$load("9yemY")
]).then(()=>parcelRequire('iwG0s'));

});

parcelRegister("3QlSH", function(module, exports) {

let $2cc733909973ea90$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2cc733909973ea90$var$load("dlmud"),
    $2cc733909973ea90$var$load("5CGnz"),
    $2cc733909973ea90$var$load("bNv64"),
    $2cc733909973ea90$var$load("dXu4x"),
    $2cc733909973ea90$var$load("3CucM"),
    $2cc733909973ea90$var$load("9yemY")
]).then(()=>parcelRequire('kyk0f'));

});

parcelRegister("kPOaW", function(module, exports) {

let $f2af7de4f7b3049d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f2af7de4f7b3049d$var$load("dlmud"),
    $f2af7de4f7b3049d$var$load("5CGnz"),
    $f2af7de4f7b3049d$var$load("bNv64"),
    $f2af7de4f7b3049d$var$load("dXu4x"),
    $f2af7de4f7b3049d$var$load("3CucM"),
    $f2af7de4f7b3049d$var$load("9yemY")
]).then(()=>parcelRequire('dR1Za'));

});

parcelRegister("4Xxhw", function(module, exports) {

let $39c67d1f4bd7564f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $39c67d1f4bd7564f$var$load("dlmud"),
    $39c67d1f4bd7564f$var$load("5CGnz"),
    $39c67d1f4bd7564f$var$load("bNv64"),
    $39c67d1f4bd7564f$var$load("dXu4x"),
    $39c67d1f4bd7564f$var$load("3CucM"),
    $39c67d1f4bd7564f$var$load("9yemY")
]).then(()=>parcelRequire('9v2bS'));

});

parcelRegister("8WSpN", function(module, exports) {

let $683df339c0948e46$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $683df339c0948e46$var$load("dlmud"),
    $683df339c0948e46$var$load("5CGnz"),
    $683df339c0948e46$var$load("bNv64"),
    $683df339c0948e46$var$load("dXu4x"),
    $683df339c0948e46$var$load("3CucM"),
    $683df339c0948e46$var$load("9yemY")
]).then(()=>parcelRequire('fCkpP'));

});

parcelRegister("i8KLr", function(module, exports) {

let $d34d3fc2bfd66b29$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d34d3fc2bfd66b29$var$load("dlmud"),
    $d34d3fc2bfd66b29$var$load("5CGnz"),
    $d34d3fc2bfd66b29$var$load("bNv64"),
    $d34d3fc2bfd66b29$var$load("dXu4x"),
    $d34d3fc2bfd66b29$var$load("3CucM"),
    $d34d3fc2bfd66b29$var$load("9yemY")
]).then(()=>parcelRequire('2HN8N'));

});

parcelRegister("2oMfn", function(module, exports) {

let $1bf33f7fa014daf2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1bf33f7fa014daf2$var$load("dlmud"),
    $1bf33f7fa014daf2$var$load("5CGnz"),
    $1bf33f7fa014daf2$var$load("bNv64"),
    $1bf33f7fa014daf2$var$load("dXu4x"),
    $1bf33f7fa014daf2$var$load("3CucM"),
    $1bf33f7fa014daf2$var$load("9yemY")
]).then(()=>parcelRequire('9KnaZ'));

});

parcelRegister("1zI6L", function(module, exports) {

let $125b464973024fc6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $125b464973024fc6$var$load("dlmud"),
    $125b464973024fc6$var$load("5CGnz"),
    $125b464973024fc6$var$load("bNv64"),
    $125b464973024fc6$var$load("dXu4x"),
    $125b464973024fc6$var$load("3CucM"),
    $125b464973024fc6$var$load("9yemY")
]).then(()=>parcelRequire('59Sko'));

});

parcelRegister("758zj", function(module, exports) {

let $527fa5912033d336$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $527fa5912033d336$var$load("dlmud"),
    $527fa5912033d336$var$load("5CGnz"),
    $527fa5912033d336$var$load("bNv64"),
    $527fa5912033d336$var$load("dXu4x"),
    $527fa5912033d336$var$load("3CucM"),
    $527fa5912033d336$var$load("9yemY")
]).then(()=>parcelRequire('bN6YH'));

});

parcelRegister("1ryZM", function(module, exports) {

let $10d3756e84e26400$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $10d3756e84e26400$var$load("dlmud"),
    $10d3756e84e26400$var$load("5CGnz"),
    $10d3756e84e26400$var$load("bNv64"),
    $10d3756e84e26400$var$load("dXu4x"),
    $10d3756e84e26400$var$load("3CucM"),
    $10d3756e84e26400$var$load("9yemY")
]).then(()=>parcelRequire('ELGF9'));

});

parcelRegister("emb1U", function(module, exports) {

let $a73bad0b970a6282$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a73bad0b970a6282$var$load("dlmud"),
    $a73bad0b970a6282$var$load("5CGnz"),
    $a73bad0b970a6282$var$load("bNv64"),
    $a73bad0b970a6282$var$load("dXu4x"),
    $a73bad0b970a6282$var$load("3CucM"),
    $a73bad0b970a6282$var$load("9yemY")
]).then(()=>parcelRequire('3fCsu'));

});

parcelRegister("1KR1V", function(module, exports) {

let $147338fbb52c5a4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $147338fbb52c5a4f$var$load("dlmud"),
    $147338fbb52c5a4f$var$load("5CGnz"),
    $147338fbb52c5a4f$var$load("bNv64"),
    $147338fbb52c5a4f$var$load("dXu4x"),
    $147338fbb52c5a4f$var$load("3CucM"),
    $147338fbb52c5a4f$var$load("9yemY")
]).then(()=>parcelRequire('jwDkc'));

});

parcelRegister("jLp8w", function(module, exports) {

let $e635e7af332c8fd2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e635e7af332c8fd2$var$load("dlmud"),
    $e635e7af332c8fd2$var$load("5CGnz"),
    $e635e7af332c8fd2$var$load("bNv64"),
    $e635e7af332c8fd2$var$load("dXu4x"),
    $e635e7af332c8fd2$var$load("3CucM"),
    $e635e7af332c8fd2$var$load("9yemY")
]).then(()=>parcelRequire('ca8zp'));

});

parcelRegister("9YYuu", function(module, exports) {

let $7448a3e29d380e4b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7448a3e29d380e4b$var$load("dlmud"),
    $7448a3e29d380e4b$var$load("5CGnz"),
    $7448a3e29d380e4b$var$load("bNv64"),
    $7448a3e29d380e4b$var$load("dXu4x"),
    $7448a3e29d380e4b$var$load("3CucM"),
    $7448a3e29d380e4b$var$load("9yemY")
]).then(()=>parcelRequire('l6Hrk'));

});

parcelRegister("6Wi7n", function(module, exports) {

let $50d636b3f161d5c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $50d636b3f161d5c1$var$load("dlmud"),
    $50d636b3f161d5c1$var$load("5CGnz"),
    $50d636b3f161d5c1$var$load("bNv64"),
    $50d636b3f161d5c1$var$load("dXu4x"),
    $50d636b3f161d5c1$var$load("3CucM"),
    $50d636b3f161d5c1$var$load("9yemY")
]).then(()=>parcelRequire('kosLT'));

});

parcelRegister("3Dfxg", function(module, exports) {

let $2a5110a8f42765be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2a5110a8f42765be$var$load("dlmud"),
    $2a5110a8f42765be$var$load("5CGnz"),
    $2a5110a8f42765be$var$load("bNv64"),
    $2a5110a8f42765be$var$load("dXu4x"),
    $2a5110a8f42765be$var$load("3CucM"),
    $2a5110a8f42765be$var$load("9yemY")
]).then(()=>parcelRequire('bPJJz'));

});

parcelRegister("iiP4O", function(module, exports) {

let $d531872bb43eb675$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d531872bb43eb675$var$load("dlmud"),
    $d531872bb43eb675$var$load("5CGnz"),
    $d531872bb43eb675$var$load("bNv64"),
    $d531872bb43eb675$var$load("dXu4x"),
    $d531872bb43eb675$var$load("3CucM"),
    $d531872bb43eb675$var$load("9yemY")
]).then(()=>parcelRequire('dHYwL'));

});

parcelRegister("9NBbq", function(module, exports) {

let $7225887ea6e8301e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7225887ea6e8301e$var$load("dlmud"),
    $7225887ea6e8301e$var$load("5CGnz"),
    $7225887ea6e8301e$var$load("bNv64"),
    $7225887ea6e8301e$var$load("dXu4x"),
    $7225887ea6e8301e$var$load("3CucM"),
    $7225887ea6e8301e$var$load("9yemY")
]).then(()=>parcelRequire('aeyZq'));

});

parcelRegister("64jNc", function(module, exports) {

let $46b2782d4a9db8b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $46b2782d4a9db8b3$var$load("dlmud"),
    $46b2782d4a9db8b3$var$load("5CGnz"),
    $46b2782d4a9db8b3$var$load("bNv64"),
    $46b2782d4a9db8b3$var$load("dXu4x"),
    $46b2782d4a9db8b3$var$load("3CucM"),
    $46b2782d4a9db8b3$var$load("9yemY")
]).then(()=>parcelRequire('2zXds'));

});

parcelRegister("t5OKm", function(module, exports) {

let $057738c8081de0af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $057738c8081de0af$var$load("dlmud"),
    $057738c8081de0af$var$load("5CGnz"),
    $057738c8081de0af$var$load("bNv64"),
    $057738c8081de0af$var$load("dXu4x"),
    $057738c8081de0af$var$load("3CucM"),
    $057738c8081de0af$var$load("9yemY")
]).then(()=>parcelRequire('9Dkdb'));

});

parcelRegister("kNrlR", function(module, exports) {

let $f23d99b89379dbfb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f23d99b89379dbfb$var$load("dlmud"),
    $f23d99b89379dbfb$var$load("5CGnz"),
    $f23d99b89379dbfb$var$load("bNv64"),
    $f23d99b89379dbfb$var$load("dXu4x"),
    $f23d99b89379dbfb$var$load("3CucM"),
    $f23d99b89379dbfb$var$load("9yemY")
]).then(()=>parcelRequire('kTgPH'));

});

parcelRegister("cCQYk", function(module, exports) {

let $93121fc68d526edc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $93121fc68d526edc$var$load("dlmud"),
    $93121fc68d526edc$var$load("5CGnz"),
    $93121fc68d526edc$var$load("bNv64"),
    $93121fc68d526edc$var$load("dXu4x"),
    $93121fc68d526edc$var$load("3CucM"),
    $93121fc68d526edc$var$load("9yemY")
]).then(()=>parcelRequire('l6yTs'));

});

parcelRegister("bdNA6", function(module, exports) {

let $82b75e65a139eece$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $82b75e65a139eece$var$load("dlmud"),
    $82b75e65a139eece$var$load("5CGnz"),
    $82b75e65a139eece$var$load("bNv64"),
    $82b75e65a139eece$var$load("dXu4x"),
    $82b75e65a139eece$var$load("3CucM"),
    $82b75e65a139eece$var$load("9yemY")
]).then(()=>parcelRequire('88ybR'));

});

parcelRegister("gCd0U", function(module, exports) {

let $c18a4a34b8c32a2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c18a4a34b8c32a2d$var$load("dlmud"),
    $c18a4a34b8c32a2d$var$load("5CGnz"),
    $c18a4a34b8c32a2d$var$load("bNv64"),
    $c18a4a34b8c32a2d$var$load("dXu4x"),
    $c18a4a34b8c32a2d$var$load("3CucM"),
    $c18a4a34b8c32a2d$var$load("9yemY")
]).then(()=>parcelRequire('ioioP'));

});

parcelRegister("dWGPI", function(module, exports) {

let $a271eaed04c92570$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a271eaed04c92570$var$load("dlmud"),
    $a271eaed04c92570$var$load("5CGnz"),
    $a271eaed04c92570$var$load("bNv64"),
    $a271eaed04c92570$var$load("dXu4x"),
    $a271eaed04c92570$var$load("3CucM"),
    $a271eaed04c92570$var$load("9yemY")
]).then(()=>parcelRequire('3WZWc'));

});

parcelRegister("gPm8e", function(module, exports) {

let $c40293acba23429d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c40293acba23429d$var$load("dlmud"),
    $c40293acba23429d$var$load("5CGnz"),
    $c40293acba23429d$var$load("bNv64"),
    $c40293acba23429d$var$load("dXu4x"),
    $c40293acba23429d$var$load("3CucM"),
    $c40293acba23429d$var$load("9yemY")
]).then(()=>parcelRequire('9EWJB'));

});

parcelRegister("1k62a", function(module, exports) {

let $0f6c56efd3291d85$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0f6c56efd3291d85$var$load("dlmud"),
    $0f6c56efd3291d85$var$load("5CGnz"),
    $0f6c56efd3291d85$var$load("bNv64"),
    $0f6c56efd3291d85$var$load("dXu4x"),
    $0f6c56efd3291d85$var$load("3CucM"),
    $0f6c56efd3291d85$var$load("9yemY")
]).then(()=>parcelRequire('4UyDw'));

});

parcelRegister("k21Jj", function(module, exports) {

let $e955560d06f5dfd8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e955560d06f5dfd8$var$load("bjmre"),
    $e955560d06f5dfd8$var$load("11DLa"),
    $e955560d06f5dfd8$var$load("bcQs2"),
    $e955560d06f5dfd8$var$load("cft22"),
    $e955560d06f5dfd8$var$load("iouLY"),
    $e955560d06f5dfd8$var$load("4sOIV")
]).then(()=>parcelRequire('gVvM0'));

});

parcelRegister("01PkK", function(module, exports) {

let $0057e9e5e4f67464$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0057e9e5e4f67464$var$load("bjmre"),
    $0057e9e5e4f67464$var$load("11DLa"),
    $0057e9e5e4f67464$var$load("bcQs2"),
    $0057e9e5e4f67464$var$load("cft22"),
    $0057e9e5e4f67464$var$load("iouLY"),
    $0057e9e5e4f67464$var$load("4sOIV")
]).then(()=>parcelRequire('5FLbD'));

});

parcelRegister("cqYa4", function(module, exports) {

let $90d6948816b2095f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90d6948816b2095f$var$load("bjmre"),
    $90d6948816b2095f$var$load("11DLa"),
    $90d6948816b2095f$var$load("bcQs2"),
    $90d6948816b2095f$var$load("cft22"),
    $90d6948816b2095f$var$load("iouLY"),
    $90d6948816b2095f$var$load("4sOIV")
]).then(()=>parcelRequire('f9oto'));

});

parcelRegister("dP1Ki", function(module, exports) {

let $a101646b861e424c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a101646b861e424c$var$load("bjmre"),
    $a101646b861e424c$var$load("11DLa"),
    $a101646b861e424c$var$load("bcQs2"),
    $a101646b861e424c$var$load("cft22"),
    $a101646b861e424c$var$load("iouLY"),
    $a101646b861e424c$var$load("4sOIV")
]).then(()=>parcelRequire('7xmMz'));

});

parcelRegister("hscz1", function(module, exports) {

let $cb4ecc1cea6498b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cb4ecc1cea6498b9$var$load("bjmre"),
    $cb4ecc1cea6498b9$var$load("11DLa"),
    $cb4ecc1cea6498b9$var$load("bcQs2"),
    $cb4ecc1cea6498b9$var$load("cft22"),
    $cb4ecc1cea6498b9$var$load("iouLY"),
    $cb4ecc1cea6498b9$var$load("4sOIV")
]).then(()=>parcelRequire('4IbNl'));

});

parcelRegister("4QSiG", function(module, exports) {

let $388623ab3c780e04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $388623ab3c780e04$var$load("bjmre"),
    $388623ab3c780e04$var$load("11DLa"),
    $388623ab3c780e04$var$load("bcQs2"),
    $388623ab3c780e04$var$load("cft22"),
    $388623ab3c780e04$var$load("iouLY"),
    $388623ab3c780e04$var$load("4sOIV")
]).then(()=>parcelRequire('hbela'));

});

parcelRegister("9sB5X", function(module, exports) {

let $6e3380e2c439b48b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6e3380e2c439b48b$var$load("bjmre"),
    $6e3380e2c439b48b$var$load("11DLa"),
    $6e3380e2c439b48b$var$load("bcQs2"),
    $6e3380e2c439b48b$var$load("cft22"),
    $6e3380e2c439b48b$var$load("iouLY"),
    $6e3380e2c439b48b$var$load("4sOIV")
]).then(()=>parcelRequire('3KUUd'));

});

parcelRegister("2fyIl", function(module, exports) {

let $1a37e90640afb61a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1a37e90640afb61a$var$load("bjmre"),
    $1a37e90640afb61a$var$load("11DLa"),
    $1a37e90640afb61a$var$load("bcQs2"),
    $1a37e90640afb61a$var$load("cft22"),
    $1a37e90640afb61a$var$load("iouLY"),
    $1a37e90640afb61a$var$load("4sOIV")
]).then(()=>parcelRequire('73LWR'));

});

parcelRegister("178Ja", function(module, exports) {

let $0cfd36fb8ab8d94a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0cfd36fb8ab8d94a$var$load("bjmre"),
    $0cfd36fb8ab8d94a$var$load("11DLa"),
    $0cfd36fb8ab8d94a$var$load("bcQs2"),
    $0cfd36fb8ab8d94a$var$load("cft22"),
    $0cfd36fb8ab8d94a$var$load("iouLY"),
    $0cfd36fb8ab8d94a$var$load("4sOIV")
]).then(()=>parcelRequire('liSWT'));

});

parcelRegister("lIQA8", function(module, exports) {

let $fd067eb636471540$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fd067eb636471540$var$load("bjmre"),
    $fd067eb636471540$var$load("11DLa"),
    $fd067eb636471540$var$load("bcQs2"),
    $fd067eb636471540$var$load("cft22"),
    $fd067eb636471540$var$load("iouLY"),
    $fd067eb636471540$var$load("4sOIV")
]).then(()=>parcelRequire('l4Hxk'));

});

parcelRegister("52OQT", function(module, exports) {

let $3ac495cec3ec16fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3ac495cec3ec16fa$var$load("bjmre"),
    $3ac495cec3ec16fa$var$load("11DLa"),
    $3ac495cec3ec16fa$var$load("bcQs2"),
    $3ac495cec3ec16fa$var$load("cft22"),
    $3ac495cec3ec16fa$var$load("iouLY"),
    $3ac495cec3ec16fa$var$load("4sOIV")
]).then(()=>parcelRequire('czXBj'));

});

parcelRegister("hOfip", function(module, exports) {

let $cf72f8a58f160291$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cf72f8a58f160291$var$load("bjmre"),
    $cf72f8a58f160291$var$load("11DLa"),
    $cf72f8a58f160291$var$load("bcQs2"),
    $cf72f8a58f160291$var$load("cft22"),
    $cf72f8a58f160291$var$load("iouLY"),
    $cf72f8a58f160291$var$load("4sOIV")
]).then(()=>parcelRequire('6xwuv'));

});

parcelRegister("R9hyw", function(module, exports) {

let $09fc269866e36778$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $09fc269866e36778$var$load("bjmre"),
    $09fc269866e36778$var$load("11DLa"),
    $09fc269866e36778$var$load("bcQs2"),
    $09fc269866e36778$var$load("cft22"),
    $09fc269866e36778$var$load("iouLY"),
    $09fc269866e36778$var$load("4sOIV")
]).then(()=>parcelRequire('fzGEY'));

});

parcelRegister("fSiBm", function(module, exports) {

let $b8ea540e65d5fff4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b8ea540e65d5fff4$var$load("bjmre"),
    $b8ea540e65d5fff4$var$load("11DLa"),
    $b8ea540e65d5fff4$var$load("bcQs2"),
    $b8ea540e65d5fff4$var$load("cft22"),
    $b8ea540e65d5fff4$var$load("iouLY"),
    $b8ea540e65d5fff4$var$load("4sOIV")
]).then(()=>parcelRequire('eS7e3'));

});

parcelRegister("cAlfu", function(module, exports) {

let $9299546325b96adb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9299546325b96adb$var$load("bjmre"),
    $9299546325b96adb$var$load("11DLa"),
    $9299546325b96adb$var$load("bcQs2"),
    $9299546325b96adb$var$load("cft22"),
    $9299546325b96adb$var$load("iouLY"),
    $9299546325b96adb$var$load("4sOIV")
]).then(()=>parcelRequire('jxk0c'));

});

parcelRegister("iNn3k", function(module, exports) {

let $daeeaf67396e54ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $daeeaf67396e54ac$var$load("bjmre"),
    $daeeaf67396e54ac$var$load("11DLa"),
    $daeeaf67396e54ac$var$load("bcQs2"),
    $daeeaf67396e54ac$var$load("cft22"),
    $daeeaf67396e54ac$var$load("iouLY"),
    $daeeaf67396e54ac$var$load("4sOIV")
]).then(()=>parcelRequire('2ZKr3'));

});

parcelRegister("euUEL", function(module, exports) {

let $a8dfd0d8e446ef8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a8dfd0d8e446ef8a$var$load("bjmre"),
    $a8dfd0d8e446ef8a$var$load("11DLa"),
    $a8dfd0d8e446ef8a$var$load("bcQs2"),
    $a8dfd0d8e446ef8a$var$load("cft22"),
    $a8dfd0d8e446ef8a$var$load("iouLY"),
    $a8dfd0d8e446ef8a$var$load("4sOIV")
]).then(()=>parcelRequire('uuhdj'));

});

parcelRegister("3Mi1u", function(module, exports) {

let $2c03d5cf2b36a386$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2c03d5cf2b36a386$var$load("bjmre"),
    $2c03d5cf2b36a386$var$load("11DLa"),
    $2c03d5cf2b36a386$var$load("bcQs2"),
    $2c03d5cf2b36a386$var$load("cft22"),
    $2c03d5cf2b36a386$var$load("iouLY"),
    $2c03d5cf2b36a386$var$load("4sOIV")
]).then(()=>parcelRequire('hrMGD'));

});

parcelRegister("6tl5d", function(module, exports) {

let $4b65ce2ee31ce25c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4b65ce2ee31ce25c$var$load("bjmre"),
    $4b65ce2ee31ce25c$var$load("11DLa"),
    $4b65ce2ee31ce25c$var$load("bcQs2"),
    $4b65ce2ee31ce25c$var$load("cft22"),
    $4b65ce2ee31ce25c$var$load("iouLY"),
    $4b65ce2ee31ce25c$var$load("4sOIV")
]).then(()=>parcelRequire('f16xs'));

});

parcelRegister("bDyHb", function(module, exports) {

let $878e400afac5d224$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $878e400afac5d224$var$load("bjmre"),
    $878e400afac5d224$var$load("11DLa"),
    $878e400afac5d224$var$load("bcQs2"),
    $878e400afac5d224$var$load("cft22"),
    $878e400afac5d224$var$load("iouLY"),
    $878e400afac5d224$var$load("4sOIV")
]).then(()=>parcelRequire('ezzhj'));

});

parcelRegister("kMRbA", function(module, exports) {

let $f2218bed51eb81ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f2218bed51eb81ed$var$load("bjmre"),
    $f2218bed51eb81ed$var$load("11DLa"),
    $f2218bed51eb81ed$var$load("bcQs2"),
    $f2218bed51eb81ed$var$load("cft22"),
    $f2218bed51eb81ed$var$load("iouLY"),
    $f2218bed51eb81ed$var$load("4sOIV")
]).then(()=>parcelRequire('jxCZO'));

});

parcelRegister("kjbMO", function(module, exports) {

let $ec8eb97fcae09c88$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ec8eb97fcae09c88$var$load("bjmre"),
    $ec8eb97fcae09c88$var$load("11DLa"),
    $ec8eb97fcae09c88$var$load("bcQs2"),
    $ec8eb97fcae09c88$var$load("cft22"),
    $ec8eb97fcae09c88$var$load("iouLY"),
    $ec8eb97fcae09c88$var$load("4sOIV")
]).then(()=>parcelRequire('69U6R'));

});

parcelRegister("gUzRE", function(module, exports) {

let $c4fdb23746e23fad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c4fdb23746e23fad$var$load("bjmre"),
    $c4fdb23746e23fad$var$load("11DLa"),
    $c4fdb23746e23fad$var$load("bcQs2"),
    $c4fdb23746e23fad$var$load("cft22"),
    $c4fdb23746e23fad$var$load("iouLY"),
    $c4fdb23746e23fad$var$load("4sOIV")
]).then(()=>parcelRequire('gx48o'));

});

parcelRegister("685kr", function(module, exports) {

let $47679f9b6eb8bf08$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $47679f9b6eb8bf08$var$load("bjmre"),
    $47679f9b6eb8bf08$var$load("11DLa"),
    $47679f9b6eb8bf08$var$load("bcQs2"),
    $47679f9b6eb8bf08$var$load("cft22"),
    $47679f9b6eb8bf08$var$load("iouLY"),
    $47679f9b6eb8bf08$var$load("4sOIV")
]).then(()=>parcelRequire('cfNqY'));

});

parcelRegister("gfGbG", function(module, exports) {

let $030da859410b1e28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $030da859410b1e28$var$load("bjmre"),
    $030da859410b1e28$var$load("11DLa"),
    $030da859410b1e28$var$load("bcQs2"),
    $030da859410b1e28$var$load("cft22"),
    $030da859410b1e28$var$load("iouLY"),
    $030da859410b1e28$var$load("4sOIV")
]).then(()=>parcelRequire('4supz'));

});

parcelRegister("3TGTI", function(module, exports) {

let $2d67c8b9119712d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2d67c8b9119712d6$var$load("bjmre"),
    $2d67c8b9119712d6$var$load("11DLa"),
    $2d67c8b9119712d6$var$load("bcQs2"),
    $2d67c8b9119712d6$var$load("cft22"),
    $2d67c8b9119712d6$var$load("iouLY"),
    $2d67c8b9119712d6$var$load("4sOIV")
]).then(()=>parcelRequire('52fRd'));

});

parcelRegister("kqqmc", function(module, exports) {

let $edeaae50db0b3c85$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $edeaae50db0b3c85$var$load("bjmre"),
    $edeaae50db0b3c85$var$load("11DLa"),
    $edeaae50db0b3c85$var$load("bcQs2"),
    $edeaae50db0b3c85$var$load("cft22"),
    $edeaae50db0b3c85$var$load("iouLY"),
    $edeaae50db0b3c85$var$load("4sOIV")
]).then(()=>parcelRequire('fLWaV'));

});

parcelRegister("i8ppi", function(module, exports) {

let $d33caea514597c3b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d33caea514597c3b$var$load("bjmre"),
    $d33caea514597c3b$var$load("11DLa"),
    $d33caea514597c3b$var$load("bcQs2"),
    $d33caea514597c3b$var$load("cft22"),
    $d33caea514597c3b$var$load("iouLY"),
    $d33caea514597c3b$var$load("4sOIV")
]).then(()=>parcelRequire('5E3FM'));

});

parcelRegister("9DzvR", function(module, exports) {

let $70434dab2041f6e8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $70434dab2041f6e8$var$load("bjmre"),
    $70434dab2041f6e8$var$load("11DLa"),
    $70434dab2041f6e8$var$load("bcQs2"),
    $70434dab2041f6e8$var$load("cft22"),
    $70434dab2041f6e8$var$load("iouLY"),
    $70434dab2041f6e8$var$load("4sOIV")
]).then(()=>parcelRequire('ixYuM'));

});

parcelRegister("hF2LE", function(module, exports) {

let $cdb869981325c8ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cdb869981325c8ba$var$load("bjmre"),
    $cdb869981325c8ba$var$load("11DLa"),
    $cdb869981325c8ba$var$load("bcQs2"),
    $cdb869981325c8ba$var$load("cft22"),
    $cdb869981325c8ba$var$load("iouLY"),
    $cdb869981325c8ba$var$load("4sOIV")
]).then(()=>parcelRequire('92bEz'));

});

parcelRegister("hvV6G", function(module, exports) {

let $cc01a127f4bf62ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cc01a127f4bf62ea$var$load("bjmre"),
    $cc01a127f4bf62ea$var$load("11DLa"),
    $cc01a127f4bf62ea$var$load("bcQs2"),
    $cc01a127f4bf62ea$var$load("cft22"),
    $cc01a127f4bf62ea$var$load("iouLY"),
    $cc01a127f4bf62ea$var$load("4sOIV")
]).then(()=>parcelRequire('9EupN'));

});

parcelRegister("fPtyC", function(module, exports) {

let $b8628bef69d7435c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b8628bef69d7435c$var$load("bjmre"),
    $b8628bef69d7435c$var$load("11DLa"),
    $b8628bef69d7435c$var$load("bcQs2"),
    $b8628bef69d7435c$var$load("cft22"),
    $b8628bef69d7435c$var$load("iouLY"),
    $b8628bef69d7435c$var$load("4sOIV")
]).then(()=>parcelRequire('kaenN'));

});

parcelRegister("8qjyp", function(module, exports) {

let $621feb6f767ed6c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $621feb6f767ed6c9$var$load("bjmre"),
    $621feb6f767ed6c9$var$load("11DLa"),
    $621feb6f767ed6c9$var$load("bcQs2"),
    $621feb6f767ed6c9$var$load("cft22"),
    $621feb6f767ed6c9$var$load("iouLY"),
    $621feb6f767ed6c9$var$load("4sOIV")
]).then(()=>parcelRequire('1HPbr'));

});

parcelRegister("lR6hc", function(module, exports) {

let $fe936a8ef7e1e00e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fe936a8ef7e1e00e$var$load("bjmre"),
    $fe936a8ef7e1e00e$var$load("11DLa"),
    $fe936a8ef7e1e00e$var$load("bcQs2"),
    $fe936a8ef7e1e00e$var$load("cft22"),
    $fe936a8ef7e1e00e$var$load("iouLY"),
    $fe936a8ef7e1e00e$var$load("4sOIV")
]).then(()=>parcelRequire('3GbG1'));

});

parcelRegister("dNTKH", function(module, exports) {

let $a0cb192eea273adb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a0cb192eea273adb$var$load("bjmre"),
    $a0cb192eea273adb$var$load("11DLa"),
    $a0cb192eea273adb$var$load("bcQs2"),
    $a0cb192eea273adb$var$load("cft22"),
    $a0cb192eea273adb$var$load("iouLY"),
    $a0cb192eea273adb$var$load("4sOIV")
]).then(()=>parcelRequire('5UIGd'));

});

parcelRegister("bAwwv", function(module, exports) {

let $86fc48f91c4f340f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $86fc48f91c4f340f$var$load("bjmre"),
    $86fc48f91c4f340f$var$load("11DLa"),
    $86fc48f91c4f340f$var$load("bcQs2"),
    $86fc48f91c4f340f$var$load("cft22"),
    $86fc48f91c4f340f$var$load("iouLY"),
    $86fc48f91c4f340f$var$load("4sOIV")
]).then(()=>parcelRequire('8R1NN'));

});

parcelRegister("1jtdV", function(module, exports) {

let $0f4e3c040fe97ea1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0f4e3c040fe97ea1$var$load("bjmre"),
    $0f4e3c040fe97ea1$var$load("11DLa"),
    $0f4e3c040fe97ea1$var$load("bcQs2"),
    $0f4e3c040fe97ea1$var$load("cft22"),
    $0f4e3c040fe97ea1$var$load("iouLY"),
    $0f4e3c040fe97ea1$var$load("4sOIV")
]).then(()=>parcelRequire('4McjS'));

});

parcelRegister("3fpTR", function(module, exports) {

let $25d6dd052dd6a03d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $25d6dd052dd6a03d$var$load("bjmre"),
    $25d6dd052dd6a03d$var$load("11DLa"),
    $25d6dd052dd6a03d$var$load("bcQs2"),
    $25d6dd052dd6a03d$var$load("cft22"),
    $25d6dd052dd6a03d$var$load("iouLY"),
    $25d6dd052dd6a03d$var$load("4sOIV")
]).then(()=>parcelRequire('aIqdH'));

});

parcelRegister("8qqCf", function(module, exports) {

let $622565c88f0bf366$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $622565c88f0bf366$var$load("bjmre"),
    $622565c88f0bf366$var$load("11DLa"),
    $622565c88f0bf366$var$load("bcQs2"),
    $622565c88f0bf366$var$load("cft22"),
    $622565c88f0bf366$var$load("iouLY"),
    $622565c88f0bf366$var$load("4sOIV")
]).then(()=>parcelRequire('gaE5c'));

});

parcelRegister("2nSdZ", function(module, exports) {

let $1bc7caa98c34d65e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1bc7caa98c34d65e$var$load("bjmre"),
    $1bc7caa98c34d65e$var$load("11DLa"),
    $1bc7caa98c34d65e$var$load("bcQs2"),
    $1bc7caa98c34d65e$var$load("cft22"),
    $1bc7caa98c34d65e$var$load("iouLY"),
    $1bc7caa98c34d65e$var$load("4sOIV")
]).then(()=>parcelRequire('7QWuh'));

});

parcelRegister("feERk", function(module, exports) {

let $b177db9442a3aab3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b177db9442a3aab3$var$load("bjmre"),
    $b177db9442a3aab3$var$load("11DLa"),
    $b177db9442a3aab3$var$load("bcQs2"),
    $b177db9442a3aab3$var$load("cft22"),
    $b177db9442a3aab3$var$load("iouLY"),
    $b177db9442a3aab3$var$load("4sOIV")
]).then(()=>parcelRequire('h0KE6'));

});

parcelRegister("fkIJN", function(module, exports) {

let $b29b6d422419e736$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b29b6d422419e736$var$load("bjmre"),
    $b29b6d422419e736$var$load("11DLa"),
    $b29b6d422419e736$var$load("bcQs2"),
    $b29b6d422419e736$var$load("cft22"),
    $b29b6d422419e736$var$load("iouLY"),
    $b29b6d422419e736$var$load("4sOIV")
]).then(()=>parcelRequire('aG2DU'));

});

parcelRegister("4mS0j", function(module, exports) {

let $32e31b9362ef3525$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $32e31b9362ef3525$var$load("bjmre"),
    $32e31b9362ef3525$var$load("11DLa"),
    $32e31b9362ef3525$var$load("bcQs2"),
    $32e31b9362ef3525$var$load("cft22"),
    $32e31b9362ef3525$var$load("iouLY"),
    $32e31b9362ef3525$var$load("4sOIV")
]).then(()=>parcelRequire('6aUlk'));

});

parcelRegister("2r0ky", function(module, exports) {

let $1c5e5c034330a548$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1c5e5c034330a548$var$load("bjmre"),
    $1c5e5c034330a548$var$load("11DLa"),
    $1c5e5c034330a548$var$load("bcQs2"),
    $1c5e5c034330a548$var$load("cft22"),
    $1c5e5c034330a548$var$load("iouLY"),
    $1c5e5c034330a548$var$load("4sOIV")
]).then(()=>parcelRequire('1iPeb'));

});

parcelRegister("3cUfk", function(module, exports) {

let $255e1f6e3c3671b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $255e1f6e3c3671b6$var$load("bjmre"),
    $255e1f6e3c3671b6$var$load("11DLa"),
    $255e1f6e3c3671b6$var$load("bcQs2"),
    $255e1f6e3c3671b6$var$load("cft22"),
    $255e1f6e3c3671b6$var$load("iouLY"),
    $255e1f6e3c3671b6$var$load("4sOIV")
]).then(()=>parcelRequire('7xSZD'));

});

parcelRegister("8VNhj", function(module, exports) {

let $6809df3d66834fd3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6809df3d66834fd3$var$load("bjmre"),
    $6809df3d66834fd3$var$load("11DLa"),
    $6809df3d66834fd3$var$load("bcQs2"),
    $6809df3d66834fd3$var$load("cft22"),
    $6809df3d66834fd3$var$load("iouLY"),
    $6809df3d66834fd3$var$load("4sOIV")
]).then(()=>parcelRequire('hPSHR'));

});

parcelRegister("d9uo9", function(module, exports) {

let $9933b02719c97ee9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9933b02719c97ee9$var$load("bjmre"),
    $9933b02719c97ee9$var$load("11DLa"),
    $9933b02719c97ee9$var$load("bcQs2"),
    $9933b02719c97ee9$var$load("cft22"),
    $9933b02719c97ee9$var$load("iouLY"),
    $9933b02719c97ee9$var$load("4sOIV")
]).then(()=>parcelRequire('hWNT7'));

});

parcelRegister("iT4kI", function(module, exports) {

let $dc00b98a167e421f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dc00b98a167e421f$var$load("bjmre"),
    $dc00b98a167e421f$var$load("11DLa"),
    $dc00b98a167e421f$var$load("bcQs2"),
    $dc00b98a167e421f$var$load("cft22"),
    $dc00b98a167e421f$var$load("iouLY"),
    $dc00b98a167e421f$var$load("4sOIV")
]).then(()=>parcelRequire('1z47m'));

});

parcelRegister("ev9yT", function(module, exports) {

let $a8eb60b21def760c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a8eb60b21def760c$var$load("bjmre"),
    $a8eb60b21def760c$var$load("11DLa"),
    $a8eb60b21def760c$var$load("bcQs2"),
    $a8eb60b21def760c$var$load("cft22"),
    $a8eb60b21def760c$var$load("iouLY"),
    $a8eb60b21def760c$var$load("4sOIV")
]).then(()=>parcelRequire('fDkX9'));

});

parcelRegister("863q1", function(module, exports) {

let $5e518923bc3cf60d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5e518923bc3cf60d$var$load("bjmre"),
    $5e518923bc3cf60d$var$load("11DLa"),
    $5e518923bc3cf60d$var$load("bcQs2"),
    $5e518923bc3cf60d$var$load("cft22"),
    $5e518923bc3cf60d$var$load("iouLY"),
    $5e518923bc3cf60d$var$load("4sOIV")
]).then(()=>parcelRequire('8miyv'));

});

parcelRegister("7KEdW", function(module, exports) {

let $5a4c07ec692c481c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5a4c07ec692c481c$var$load("3fuR9"),
    $5a4c07ec692c481c$var$load("2bqSD"),
    $5a4c07ec692c481c$var$load("gZU54"),
    $5a4c07ec692c481c$var$load("e8jpx"),
    $5a4c07ec692c481c$var$load("bGhLc"),
    $5a4c07ec692c481c$var$load("iRKhU")
]).then(()=>parcelRequire('j6Zgo'));

});

parcelRegister("kdBqJ", function(module, exports) {

let $eb820e63e88f1267$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eb820e63e88f1267$var$load("3fuR9"),
    $eb820e63e88f1267$var$load("2bqSD"),
    $eb820e63e88f1267$var$load("gZU54"),
    $eb820e63e88f1267$var$load("e8jpx"),
    $eb820e63e88f1267$var$load("bGhLc"),
    $eb820e63e88f1267$var$load("iRKhU")
]).then(()=>parcelRequire('aSfKa'));

});

parcelRegister("dluhI", function(module, exports) {

let $9b74ba7793af5815$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9b74ba7793af5815$var$load("3fuR9"),
    $9b74ba7793af5815$var$load("2bqSD"),
    $9b74ba7793af5815$var$load("gZU54"),
    $9b74ba7793af5815$var$load("e8jpx"),
    $9b74ba7793af5815$var$load("bGhLc"),
    $9b74ba7793af5815$var$load("iRKhU")
]).then(()=>parcelRequire('6b5RU'));

});

parcelRegister("3wULy", function(module, exports) {

let $292064ca58e9942b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $292064ca58e9942b$var$load("3fuR9"),
    $292064ca58e9942b$var$load("2bqSD"),
    $292064ca58e9942b$var$load("gZU54"),
    $292064ca58e9942b$var$load("e8jpx"),
    $292064ca58e9942b$var$load("bGhLc"),
    $292064ca58e9942b$var$load("iRKhU")
]).then(()=>parcelRequire('5RjyS'));

});

parcelRegister("hAOSE", function(module, exports) {

let $cced4444f2af941e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cced4444f2af941e$var$load("3fuR9"),
    $cced4444f2af941e$var$load("2bqSD"),
    $cced4444f2af941e$var$load("gZU54"),
    $cced4444f2af941e$var$load("e8jpx"),
    $cced4444f2af941e$var$load("bGhLc"),
    $cced4444f2af941e$var$load("iRKhU")
]).then(()=>parcelRequire('jwd3r'));

});

parcelRegister("aZqBU", function(module, exports) {

let $80043e26a185fc48$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $80043e26a185fc48$var$load("3fuR9"),
    $80043e26a185fc48$var$load("2bqSD"),
    $80043e26a185fc48$var$load("gZU54"),
    $80043e26a185fc48$var$load("e8jpx"),
    $80043e26a185fc48$var$load("bGhLc"),
    $80043e26a185fc48$var$load("iRKhU")
]).then(()=>parcelRequire('ejnrO'));

});

parcelRegister("6hemr", function(module, exports) {

let $491f785f80b8bbf0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $491f785f80b8bbf0$var$load("3fuR9"),
    $491f785f80b8bbf0$var$load("2bqSD"),
    $491f785f80b8bbf0$var$load("gZU54"),
    $491f785f80b8bbf0$var$load("e8jpx"),
    $491f785f80b8bbf0$var$load("bGhLc"),
    $491f785f80b8bbf0$var$load("iRKhU")
]).then(()=>parcelRequire('4iWHF'));

});

parcelRegister("6PDRB", function(module, exports) {

let $4f966d907af63461$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f966d907af63461$var$load("3fuR9"),
    $4f966d907af63461$var$load("2bqSD"),
    $4f966d907af63461$var$load("gZU54"),
    $4f966d907af63461$var$load("e8jpx"),
    $4f966d907af63461$var$load("bGhLc"),
    $4f966d907af63461$var$load("iRKhU")
]).then(()=>parcelRequire('lRfBG'));

});

parcelRegister("6Lo6W", function(module, exports) {

let $4ec9d5cc03f1891e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4ec9d5cc03f1891e$var$load("3fuR9"),
    $4ec9d5cc03f1891e$var$load("2bqSD"),
    $4ec9d5cc03f1891e$var$load("gZU54"),
    $4ec9d5cc03f1891e$var$load("e8jpx"),
    $4ec9d5cc03f1891e$var$load("bGhLc"),
    $4ec9d5cc03f1891e$var$load("iRKhU")
]).then(()=>parcelRequire('UK5pP'));

});

parcelRegister("7ZOwR", function(module, exports) {

let $5d256ceb1bfcc4f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5d256ceb1bfcc4f3$var$load("3fuR9"),
    $5d256ceb1bfcc4f3$var$load("2bqSD"),
    $5d256ceb1bfcc4f3$var$load("gZU54"),
    $5d256ceb1bfcc4f3$var$load("e8jpx"),
    $5d256ceb1bfcc4f3$var$load("bGhLc"),
    $5d256ceb1bfcc4f3$var$load("iRKhU")
]).then(()=>parcelRequire('9ikOx'));

});

parcelRegister("bcOcq", function(module, exports) {

let $8287c13ce4e8ad75$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8287c13ce4e8ad75$var$load("3fuR9"),
    $8287c13ce4e8ad75$var$load("2bqSD"),
    $8287c13ce4e8ad75$var$load("gZU54"),
    $8287c13ce4e8ad75$var$load("e8jpx"),
    $8287c13ce4e8ad75$var$load("bGhLc"),
    $8287c13ce4e8ad75$var$load("iRKhU")
]).then(()=>parcelRequire('2mD47'));

});

parcelRegister("h3DUz", function(module, exports) {

let $c6b1ad0c9582fd83$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c6b1ad0c9582fd83$var$load("3fuR9"),
    $c6b1ad0c9582fd83$var$load("2bqSD"),
    $c6b1ad0c9582fd83$var$load("gZU54"),
    $c6b1ad0c9582fd83$var$load("e8jpx"),
    $c6b1ad0c9582fd83$var$load("bGhLc"),
    $c6b1ad0c9582fd83$var$load("iRKhU")
]).then(()=>parcelRequire('98QTw'));

});

parcelRegister("kkjUK", function(module, exports) {

let $ecc51f7a604dfa7d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ecc51f7a604dfa7d$var$load("3fuR9"),
    $ecc51f7a604dfa7d$var$load("2bqSD"),
    $ecc51f7a604dfa7d$var$load("gZU54"),
    $ecc51f7a604dfa7d$var$load("e8jpx"),
    $ecc51f7a604dfa7d$var$load("bGhLc"),
    $ecc51f7a604dfa7d$var$load("iRKhU")
]).then(()=>parcelRequire('37Hue'));

});

parcelRegister("e608R", function(module, exports) {

let $a431bc6874e0d071$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a431bc6874e0d071$var$load("3fuR9"),
    $a431bc6874e0d071$var$load("2bqSD"),
    $a431bc6874e0d071$var$load("gZU54"),
    $a431bc6874e0d071$var$load("e8jpx"),
    $a431bc6874e0d071$var$load("bGhLc"),
    $a431bc6874e0d071$var$load("iRKhU")
]).then(()=>parcelRequire('kwT2K'));

});

parcelRegister("3pC5u", function(module, exports) {

let $27c14044f4d6a7c7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $27c14044f4d6a7c7$var$load("3fuR9"),
    $27c14044f4d6a7c7$var$load("2bqSD"),
    $27c14044f4d6a7c7$var$load("gZU54"),
    $27c14044f4d6a7c7$var$load("e8jpx"),
    $27c14044f4d6a7c7$var$load("bGhLc"),
    $27c14044f4d6a7c7$var$load("iRKhU")
]).then(()=>parcelRequire('fmlyw'));

});

parcelRegister("5nm3d", function(module, exports) {

let $3ea034957ce3b039$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3ea034957ce3b039$var$load("3fuR9"),
    $3ea034957ce3b039$var$load("2bqSD"),
    $3ea034957ce3b039$var$load("gZU54"),
    $3ea034957ce3b039$var$load("e8jpx"),
    $3ea034957ce3b039$var$load("bGhLc"),
    $3ea034957ce3b039$var$load("iRKhU")
]).then(()=>parcelRequire('cpwql'));

});

parcelRegister("1ArxI", function(module, exports) {

let $127e84b06ab921f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $127e84b06ab921f4$var$load("3fuR9"),
    $127e84b06ab921f4$var$load("2bqSD"),
    $127e84b06ab921f4$var$load("gZU54"),
    $127e84b06ab921f4$var$load("e8jpx"),
    $127e84b06ab921f4$var$load("bGhLc"),
    $127e84b06ab921f4$var$load("iRKhU")
]).then(()=>parcelRequire('6CcyL'));

});

parcelRegister("6i3Ao", function(module, exports) {

let $494734a021cdb290$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $494734a021cdb290$var$load("3fuR9"),
    $494734a021cdb290$var$load("2bqSD"),
    $494734a021cdb290$var$load("gZU54"),
    $494734a021cdb290$var$load("e8jpx"),
    $494734a021cdb290$var$load("bGhLc"),
    $494734a021cdb290$var$load("iRKhU")
]).then(()=>parcelRequire('3x2ID'));

});

parcelRegister("dPoZx", function(module, exports) {

let $a1136c9aad1e3ed6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a1136c9aad1e3ed6$var$load("3fuR9"),
    $a1136c9aad1e3ed6$var$load("2bqSD"),
    $a1136c9aad1e3ed6$var$load("gZU54"),
    $a1136c9aad1e3ed6$var$load("e8jpx"),
    $a1136c9aad1e3ed6$var$load("bGhLc"),
    $a1136c9aad1e3ed6$var$load("iRKhU")
]).then(()=>parcelRequire('lpVqo'));

});

parcelRegister("faiza", function(module, exports) {

let $b0a63106c27935e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b0a63106c27935e6$var$load("3fuR9"),
    $b0a63106c27935e6$var$load("2bqSD"),
    $b0a63106c27935e6$var$load("gZU54"),
    $b0a63106c27935e6$var$load("e8jpx"),
    $b0a63106c27935e6$var$load("bGhLc"),
    $b0a63106c27935e6$var$load("iRKhU")
]).then(()=>parcelRequire('fmx3D'));

});

parcelRegister("hr5n6", function(module, exports) {

let $cb191ffdf9ddfa75$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cb191ffdf9ddfa75$var$load("3fuR9"),
    $cb191ffdf9ddfa75$var$load("2bqSD"),
    $cb191ffdf9ddfa75$var$load("gZU54"),
    $cb191ffdf9ddfa75$var$load("e8jpx"),
    $cb191ffdf9ddfa75$var$load("bGhLc"),
    $cb191ffdf9ddfa75$var$load("iRKhU")
]).then(()=>parcelRequire('iq6DN'));

});

parcelRegister("ahPAX", function(module, exports) {

let $77d383a5ab4229ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $77d383a5ab4229ac$var$load("3fuR9"),
    $77d383a5ab4229ac$var$load("2bqSD"),
    $77d383a5ab4229ac$var$load("gZU54"),
    $77d383a5ab4229ac$var$load("e8jpx"),
    $77d383a5ab4229ac$var$load("bGhLc"),
    $77d383a5ab4229ac$var$load("iRKhU")
]).then(()=>parcelRequire('2WPKR'));

});

parcelRegister("gf2kN", function(module, exports) {

let $bd2fdba57832223d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bd2fdba57832223d$var$load("3fuR9"),
    $bd2fdba57832223d$var$load("2bqSD"),
    $bd2fdba57832223d$var$load("gZU54"),
    $bd2fdba57832223d$var$load("e8jpx"),
    $bd2fdba57832223d$var$load("bGhLc"),
    $bd2fdba57832223d$var$load("iRKhU")
]).then(()=>parcelRequire('287WG'));

});

parcelRegister("9zIhO", function(module, exports) {

let $6f89bc44ccde2ccb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6f89bc44ccde2ccb$var$load("3fuR9"),
    $6f89bc44ccde2ccb$var$load("2bqSD"),
    $6f89bc44ccde2ccb$var$load("gZU54"),
    $6f89bc44ccde2ccb$var$load("e8jpx"),
    $6f89bc44ccde2ccb$var$load("bGhLc"),
    $6f89bc44ccde2ccb$var$load("iRKhU")
]).then(()=>parcelRequire('1ODlc'));

});

parcelRegister("72xvc", function(module, exports) {

let $5202b526ffc5aaff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5202b526ffc5aaff$var$load("3fuR9"),
    $5202b526ffc5aaff$var$load("2bqSD"),
    $5202b526ffc5aaff$var$load("gZU54"),
    $5202b526ffc5aaff$var$load("e8jpx"),
    $5202b526ffc5aaff$var$load("bGhLc"),
    $5202b526ffc5aaff$var$load("iRKhU")
]).then(()=>parcelRequire('489aN'));

});

parcelRegister("3ihb5", function(module, exports) {

let $266060afa0d04fb2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $266060afa0d04fb2$var$load("3fuR9"),
    $266060afa0d04fb2$var$load("2bqSD"),
    $266060afa0d04fb2$var$load("gZU54"),
    $266060afa0d04fb2$var$load("e8jpx"),
    $266060afa0d04fb2$var$load("bGhLc"),
    $266060afa0d04fb2$var$load("iRKhU")
]).then(()=>parcelRequire('ieltE'));

});

parcelRegister("fMN6V", function(module, exports) {

let $b7e16f11fd94ae39$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b7e16f11fd94ae39$var$load("3fuR9"),
    $b7e16f11fd94ae39$var$load("2bqSD"),
    $b7e16f11fd94ae39$var$load("gZU54"),
    $b7e16f11fd94ae39$var$load("e8jpx"),
    $b7e16f11fd94ae39$var$load("bGhLc"),
    $b7e16f11fd94ae39$var$load("iRKhU")
]).then(()=>parcelRequire('gCbcW'));

});

parcelRegister("8Z6nZ", function(module, exports) {

let $68a8f9559d978b07$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $68a8f9559d978b07$var$load("3fuR9"),
    $68a8f9559d978b07$var$load("2bqSD"),
    $68a8f9559d978b07$var$load("gZU54"),
    $68a8f9559d978b07$var$load("e8jpx"),
    $68a8f9559d978b07$var$load("bGhLc"),
    $68a8f9559d978b07$var$load("iRKhU")
]).then(()=>parcelRequire('7AJJ9'));

});

parcelRegister("8WwfW", function(module, exports) {

let $682cc2eda717f84f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $682cc2eda717f84f$var$load("3fuR9"),
    $682cc2eda717f84f$var$load("2bqSD"),
    $682cc2eda717f84f$var$load("gZU54"),
    $682cc2eda717f84f$var$load("e8jpx"),
    $682cc2eda717f84f$var$load("bGhLc"),
    $682cc2eda717f84f$var$load("iRKhU")
]).then(()=>parcelRequire('1sbTD'));

});

parcelRegister("25J5q", function(module, exports) {

let $185f05aaa9ef5e98$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $185f05aaa9ef5e98$var$load("3fuR9"),
    $185f05aaa9ef5e98$var$load("2bqSD"),
    $185f05aaa9ef5e98$var$load("gZU54"),
    $185f05aaa9ef5e98$var$load("e8jpx"),
    $185f05aaa9ef5e98$var$load("bGhLc"),
    $185f05aaa9ef5e98$var$load("iRKhU")
]).then(()=>parcelRequire('43JQz'));

});

parcelRegister("7Hj6K", function(module, exports) {

let $59ab5efbbfea43e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $59ab5efbbfea43e3$var$load("3fuR9"),
    $59ab5efbbfea43e3$var$load("2bqSD"),
    $59ab5efbbfea43e3$var$load("gZU54"),
    $59ab5efbbfea43e3$var$load("e8jpx"),
    $59ab5efbbfea43e3$var$load("bGhLc"),
    $59ab5efbbfea43e3$var$load("iRKhU")
]).then(()=>parcelRequire('tKwhB'));

});

parcelRegister("hfFBb", function(module, exports) {

let $c8f41b0070c2e69f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c8f41b0070c2e69f$var$load("3fuR9"),
    $c8f41b0070c2e69f$var$load("2bqSD"),
    $c8f41b0070c2e69f$var$load("gZU54"),
    $c8f41b0070c2e69f$var$load("e8jpx"),
    $c8f41b0070c2e69f$var$load("bGhLc"),
    $c8f41b0070c2e69f$var$load("iRKhU")
]).then(()=>parcelRequire('bQy2v'));

});

parcelRegister("iV0Xw", function(module, exports) {

let $dc5e4b4d44c4542c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dc5e4b4d44c4542c$var$load("3fuR9"),
    $dc5e4b4d44c4542c$var$load("2bqSD"),
    $dc5e4b4d44c4542c$var$load("gZU54"),
    $dc5e4b4d44c4542c$var$load("e8jpx"),
    $dc5e4b4d44c4542c$var$load("bGhLc"),
    $dc5e4b4d44c4542c$var$load("iRKhU")
]).then(()=>parcelRequire('b8H25'));

});

parcelRegister("lj5Na", function(module, exports) {

let $f82fdd79d214ecfb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f82fdd79d214ecfb$var$load("3fuR9"),
    $f82fdd79d214ecfb$var$load("2bqSD"),
    $f82fdd79d214ecfb$var$load("gZU54"),
    $f82fdd79d214ecfb$var$load("e8jpx"),
    $f82fdd79d214ecfb$var$load("bGhLc"),
    $f82fdd79d214ecfb$var$load("iRKhU")
]).then(()=>parcelRequire('5hCQs'));

});

parcelRegister("021th", function(module, exports) {

let $0061542888ba782b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0061542888ba782b$var$load("3fuR9"),
    $0061542888ba782b$var$load("2bqSD"),
    $0061542888ba782b$var$load("gZU54"),
    $0061542888ba782b$var$load("e8jpx"),
    $0061542888ba782b$var$load("bGhLc"),
    $0061542888ba782b$var$load("iRKhU")
]).then(()=>parcelRequire('98gRf'));

});

parcelRegister("fUipc", function(module, exports) {

let $b94a5ced70c15fbc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b94a5ced70c15fbc$var$load("3fuR9"),
    $b94a5ced70c15fbc$var$load("2bqSD"),
    $b94a5ced70c15fbc$var$load("gZU54"),
    $b94a5ced70c15fbc$var$load("e8jpx"),
    $b94a5ced70c15fbc$var$load("bGhLc"),
    $b94a5ced70c15fbc$var$load("iRKhU")
]).then(()=>parcelRequire('gpo11'));

});

parcelRegister("79ylg", function(module, exports) {

let $53540341f86db15c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $53540341f86db15c$var$load("3fuR9"),
    $53540341f86db15c$var$load("2bqSD"),
    $53540341f86db15c$var$load("gZU54"),
    $53540341f86db15c$var$load("e8jpx"),
    $53540341f86db15c$var$load("bGhLc"),
    $53540341f86db15c$var$load("iRKhU")
]).then(()=>parcelRequire('egjZu'));

});

parcelRegister("1hD9Q", function(module, exports) {

let $0ef5c0eb0eacf218$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0ef5c0eb0eacf218$var$load("3fuR9"),
    $0ef5c0eb0eacf218$var$load("2bqSD"),
    $0ef5c0eb0eacf218$var$load("gZU54"),
    $0ef5c0eb0eacf218$var$load("e8jpx"),
    $0ef5c0eb0eacf218$var$load("bGhLc"),
    $0ef5c0eb0eacf218$var$load("iRKhU")
]).then(()=>parcelRequire('5JjoD'));

});

parcelRegister("f2u0Z", function(module, exports) {

let $af2e5340efb66231$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $af2e5340efb66231$var$load("3fuR9"),
    $af2e5340efb66231$var$load("2bqSD"),
    $af2e5340efb66231$var$load("gZU54"),
    $af2e5340efb66231$var$load("e8jpx"),
    $af2e5340efb66231$var$load("bGhLc"),
    $af2e5340efb66231$var$load("iRKhU")
]).then(()=>parcelRequire('7cfqh'));

});

parcelRegister("fSQd6", function(module, exports) {

let $b904660b503079c4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b904660b503079c4$var$load("3fuR9"),
    $b904660b503079c4$var$load("2bqSD"),
    $b904660b503079c4$var$load("gZU54"),
    $b904660b503079c4$var$load("e8jpx"),
    $b904660b503079c4$var$load("bGhLc"),
    $b904660b503079c4$var$load("iRKhU")
]).then(()=>parcelRequire('k36HF'));

});

parcelRegister("a6jSu", function(module, exports) {

let $75a9e23b848c3540$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $75a9e23b848c3540$var$load("3fuR9"),
    $75a9e23b848c3540$var$load("2bqSD"),
    $75a9e23b848c3540$var$load("gZU54"),
    $75a9e23b848c3540$var$load("e8jpx"),
    $75a9e23b848c3540$var$load("bGhLc"),
    $75a9e23b848c3540$var$load("iRKhU")
]).then(()=>parcelRequire('bHXNj'));

});

parcelRegister("1gD8I", function(module, exports) {

let $0ec5a561f3be755e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0ec5a561f3be755e$var$load("3fuR9"),
    $0ec5a561f3be755e$var$load("2bqSD"),
    $0ec5a561f3be755e$var$load("gZU54"),
    $0ec5a561f3be755e$var$load("e8jpx"),
    $0ec5a561f3be755e$var$load("bGhLc"),
    $0ec5a561f3be755e$var$load("iRKhU")
]).then(()=>parcelRequire('jRM9T'));

});

parcelRegister("hCfMc", function(module, exports) {

let $cd323924de1471db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cd323924de1471db$var$load("3fuR9"),
    $cd323924de1471db$var$load("2bqSD"),
    $cd323924de1471db$var$load("gZU54"),
    $cd323924de1471db$var$load("e8jpx"),
    $cd323924de1471db$var$load("bGhLc"),
    $cd323924de1471db$var$load("iRKhU")
]).then(()=>parcelRequire('s2jyE'));

});

parcelRegister("fzZOG", function(module, exports) {

let $b57a1360bbc1b11b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b57a1360bbc1b11b$var$load("3fuR9"),
    $b57a1360bbc1b11b$var$load("2bqSD"),
    $b57a1360bbc1b11b$var$load("gZU54"),
    $b57a1360bbc1b11b$var$load("e8jpx"),
    $b57a1360bbc1b11b$var$load("bGhLc"),
    $b57a1360bbc1b11b$var$load("iRKhU")
]).then(()=>parcelRequire('9pmup'));

});

parcelRegister("lhsZr", function(module, exports) {

let $f7e1ac4be9c4db00$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f7e1ac4be9c4db00$var$load("3fuR9"),
    $f7e1ac4be9c4db00$var$load("2bqSD"),
    $f7e1ac4be9c4db00$var$load("gZU54"),
    $f7e1ac4be9c4db00$var$load("e8jpx"),
    $f7e1ac4be9c4db00$var$load("bGhLc"),
    $f7e1ac4be9c4db00$var$load("iRKhU")
]).then(()=>parcelRequire('imoHb'));

});

parcelRegister("fVdQR", function(module, exports) {

let $b976ec86d12dde0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b976ec86d12dde0b$var$load("3fuR9"),
    $b976ec86d12dde0b$var$load("2bqSD"),
    $b976ec86d12dde0b$var$load("gZU54"),
    $b976ec86d12dde0b$var$load("e8jpx"),
    $b976ec86d12dde0b$var$load("bGhLc"),
    $b976ec86d12dde0b$var$load("iRKhU")
]).then(()=>parcelRequire('ieYWE'));

});

parcelRegister("7Da0Y", function(module, exports) {

let $58e3f1a1f3a37dff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $58e3f1a1f3a37dff$var$load("3fuR9"),
    $58e3f1a1f3a37dff$var$load("2bqSD"),
    $58e3f1a1f3a37dff$var$load("gZU54"),
    $58e3f1a1f3a37dff$var$load("e8jpx"),
    $58e3f1a1f3a37dff$var$load("bGhLc"),
    $58e3f1a1f3a37dff$var$load("iRKhU")
]).then(()=>parcelRequire('5uFwl'));

});

parcelRegister("4A7fy", function(module, exports) {

let $356025e7f18c5784$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $356025e7f18c5784$var$load("3fuR9"),
    $356025e7f18c5784$var$load("2bqSD"),
    $356025e7f18c5784$var$load("gZU54"),
    $356025e7f18c5784$var$load("e8jpx"),
    $356025e7f18c5784$var$load("bGhLc"),
    $356025e7f18c5784$var$load("iRKhU")
]).then(()=>parcelRequire('04vVX'));

});

parcelRegister("hSp9J", function(module, exports) {

let $d03afe4185f0b2b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d03afe4185f0b2b9$var$load("3fuR9"),
    $d03afe4185f0b2b9$var$load("2bqSD"),
    $d03afe4185f0b2b9$var$load("gZU54"),
    $d03afe4185f0b2b9$var$load("e8jpx"),
    $d03afe4185f0b2b9$var$load("bGhLc"),
    $d03afe4185f0b2b9$var$load("iRKhU")
]).then(()=>parcelRequire('4uOXr'));

});

parcelRegister("5lRLj", function(module, exports) {

let $3e589df46ed606d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3e589df46ed606d6$var$load("3fuR9"),
    $3e589df46ed606d6$var$load("2bqSD"),
    $3e589df46ed606d6$var$load("gZU54"),
    $3e589df46ed606d6$var$load("e8jpx"),
    $3e589df46ed606d6$var$load("bGhLc"),
    $3e589df46ed606d6$var$load("iRKhU")
]).then(()=>parcelRequire('dFrD2'));

});

parcelRegister("8BeV9", function(module, exports) {

let $642d5a665b49d31b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $642d5a665b49d31b$var$load("aGECO").then(()=>parcelRequire('f4Sbd'));

});

parcelRegister("crWmJ", function(module, exports) {

let $910547de53934c13$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $910547de53934c13$var$load("aGECO").then(()=>parcelRequire('dXB7R'));

});

parcelRegister("bHrFd", function(module, exports) {

let $88492b4d8361b6ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $88492b4d8361b6ff$var$load("aGECO").then(()=>parcelRequire('6CqDX'));

});

parcelRegister("7lF6v", function(module, exports) {

let $559a60f21599e127$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $559a60f21599e127$var$load("aGECO").then(()=>parcelRequire('iMa2r'));

});

parcelRegister("eD8co", function(module, exports) {

let $aa6b115a311b9fd0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa6b115a311b9fd0$var$load("aGECO").then(()=>parcelRequire('c2Dmg'));

});

parcelRegister("3GzA6", function(module, exports) {

let $2af0e50c30411044$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2af0e50c30411044$var$load("aGECO").then(()=>parcelRequire('90He8'));

});

parcelRegister("e9hzu", function(module, exports) {

let $a4cf89465e7835b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a4cf89465e7835b0$var$load("aGECO").then(()=>parcelRequire('irrHX'));

});

parcelRegister("3uDBq", function(module, exports) {

let $28b2e4acfcba4c74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $28b2e4acfcba4c74$var$load("aGECO").then(()=>parcelRequire('7MEzT'));

});

parcelRegister("fiBVu", function(module, exports) {

let $b235f4d1ca0ad523$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b235f4d1ca0ad523$var$load("aGECO").then(()=>parcelRequire('hqDaz'));

});

parcelRegister("4PYdP", function(module, exports) {

let $385aa3af9159d2ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $385aa3af9159d2ca$var$load("aGECO").then(()=>parcelRequire('kHi7w'));

});

parcelRegister("8Dvkp", function(module, exports) {

let $649a4462f2566383$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $649a4462f2566383$var$load("fMrUo"),
    $649a4462f2566383$var$load("bJykp"),
    $649a4462f2566383$var$load("4Wdqb"),
    $649a4462f2566383$var$load("fjbzp"),
    $649a4462f2566383$var$load("9v6ER"),
    $649a4462f2566383$var$load("aEAsN")
]).then(()=>parcelRequire('cLN01'));

});

parcelRegister("kTz1D", function(module, exports) {

let $f3641d01962e4132$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f3641d01962e4132$var$load("fMrUo"),
    $f3641d01962e4132$var$load("bJykp"),
    $f3641d01962e4132$var$load("4Wdqb"),
    $f3641d01962e4132$var$load("fjbzp"),
    $f3641d01962e4132$var$load("9v6ER"),
    $f3641d01962e4132$var$load("aEAsN")
]).then(()=>parcelRequire('dLctv'));

});

parcelRegister("fjKDV", function(module, exports) {

let $b26ccfb57b2f9d29$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b26ccfb57b2f9d29$var$load("fMrUo"),
    $b26ccfb57b2f9d29$var$load("bJykp"),
    $b26ccfb57b2f9d29$var$load("4Wdqb"),
    $b26ccfb57b2f9d29$var$load("fjbzp"),
    $b26ccfb57b2f9d29$var$load("9v6ER"),
    $b26ccfb57b2f9d29$var$load("aEAsN")
]).then(()=>parcelRequire('5UaLs'));

});

parcelRegister("cjj2j", function(module, exports) {

let $8f6606941803ea4e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8f6606941803ea4e$var$load("fMrUo"),
    $8f6606941803ea4e$var$load("bJykp"),
    $8f6606941803ea4e$var$load("4Wdqb"),
    $8f6606941803ea4e$var$load("fjbzp"),
    $8f6606941803ea4e$var$load("9v6ER"),
    $8f6606941803ea4e$var$load("aEAsN")
]).then(()=>parcelRequire('4layl'));

});

parcelRegister("cNuSQ", function(module, exports) {

let $9512047ab03d1338$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9512047ab03d1338$var$load("fMrUo"),
    $9512047ab03d1338$var$load("bJykp"),
    $9512047ab03d1338$var$load("4Wdqb"),
    $9512047ab03d1338$var$load("fjbzp"),
    $9512047ab03d1338$var$load("9v6ER"),
    $9512047ab03d1338$var$load("aEAsN")
]).then(()=>parcelRequire('fkCIe'));

});

parcelRegister("d39o7", function(module, exports) {

let $9802d67105775177$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9802d67105775177$var$load("fMrUo"),
    $9802d67105775177$var$load("bJykp"),
    $9802d67105775177$var$load("4Wdqb"),
    $9802d67105775177$var$load("fjbzp"),
    $9802d67105775177$var$load("9v6ER"),
    $9802d67105775177$var$load("aEAsN")
]).then(()=>parcelRequire('kCmuH'));

});

parcelRegister("94T2T", function(module, exports) {

let $69bf2fb0d7cfb165$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $69bf2fb0d7cfb165$var$load("fMrUo"),
    $69bf2fb0d7cfb165$var$load("bJykp"),
    $69bf2fb0d7cfb165$var$load("4Wdqb"),
    $69bf2fb0d7cfb165$var$load("fjbzp"),
    $69bf2fb0d7cfb165$var$load("9v6ER"),
    $69bf2fb0d7cfb165$var$load("aEAsN")
]).then(()=>parcelRequire('3QY0x'));

});

parcelRegister("9Ebk4", function(module, exports) {

let $7060a1f473265dc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7060a1f473265dc8$var$load("fMrUo"),
    $7060a1f473265dc8$var$load("bJykp"),
    $7060a1f473265dc8$var$load("4Wdqb"),
    $7060a1f473265dc8$var$load("fjbzp"),
    $7060a1f473265dc8$var$load("9v6ER"),
    $7060a1f473265dc8$var$load("aEAsN")
]).then(()=>parcelRequire('hZouV'));

});

parcelRegister("jgAV4", function(module, exports) {

let $e06c26676f971dbe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e06c26676f971dbe$var$load("fMrUo"),
    $e06c26676f971dbe$var$load("bJykp"),
    $e06c26676f971dbe$var$load("4Wdqb"),
    $e06c26676f971dbe$var$load("fjbzp"),
    $e06c26676f971dbe$var$load("9v6ER"),
    $e06c26676f971dbe$var$load("aEAsN")
]).then(()=>parcelRequire('cKyEk'));

});

parcelRegister("3qLfN", function(module, exports) {

let $27f87471d341c6ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $27f87471d341c6ee$var$load("fMrUo"),
    $27f87471d341c6ee$var$load("bJykp"),
    $27f87471d341c6ee$var$load("4Wdqb"),
    $27f87471d341c6ee$var$load("fjbzp"),
    $27f87471d341c6ee$var$load("9v6ER"),
    $27f87471d341c6ee$var$load("aEAsN")
]).then(()=>parcelRequire('jl05c'));

});

parcelRegister("ci5Cc", function(module, exports) {

let $8f2b85845cfb9fa9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8f2b85845cfb9fa9$var$load("fMrUo"),
    $8f2b85845cfb9fa9$var$load("bJykp"),
    $8f2b85845cfb9fa9$var$load("4Wdqb"),
    $8f2b85845cfb9fa9$var$load("fjbzp"),
    $8f2b85845cfb9fa9$var$load("9v6ER"),
    $8f2b85845cfb9fa9$var$load("aEAsN")
]).then(()=>parcelRequire('kOCLQ'));

});

parcelRegister("higsq", function(module, exports) {

let $c970e237f83d8116$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c970e237f83d8116$var$load("fMrUo"),
    $c970e237f83d8116$var$load("bJykp"),
    $c970e237f83d8116$var$load("4Wdqb"),
    $c970e237f83d8116$var$load("fjbzp"),
    $c970e237f83d8116$var$load("9v6ER"),
    $c970e237f83d8116$var$load("aEAsN")
]).then(()=>parcelRequire('6yXvq'));

});

parcelRegister("dACbQ", function(module, exports) {

let $9e4c42e5ed8553a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9e4c42e5ed8553a1$var$load("fMrUo"),
    $9e4c42e5ed8553a1$var$load("bJykp"),
    $9e4c42e5ed8553a1$var$load("4Wdqb"),
    $9e4c42e5ed8553a1$var$load("fjbzp"),
    $9e4c42e5ed8553a1$var$load("9v6ER"),
    $9e4c42e5ed8553a1$var$load("aEAsN")
]).then(()=>parcelRequire('hklRK'));

});

parcelRegister("9fDpX", function(module, exports) {

let $6bc41750bb683bbe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6bc41750bb683bbe$var$load("fMrUo"),
    $6bc41750bb683bbe$var$load("bJykp"),
    $6bc41750bb683bbe$var$load("4Wdqb"),
    $6bc41750bb683bbe$var$load("fjbzp"),
    $6bc41750bb683bbe$var$load("9v6ER"),
    $6bc41750bb683bbe$var$load("aEAsN")
]).then(()=>parcelRequire('7vli6'));

});

parcelRegister("5YBIO", function(module, exports) {

let $459fd11e0b124cce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $459fd11e0b124cce$var$load("fMrUo"),
    $459fd11e0b124cce$var$load("bJykp"),
    $459fd11e0b124cce$var$load("4Wdqb"),
    $459fd11e0b124cce$var$load("fjbzp"),
    $459fd11e0b124cce$var$load("9v6ER"),
    $459fd11e0b124cce$var$load("aEAsN")
]).then(()=>parcelRequire('6ztoV'));

});

parcelRegister("2e8HC", function(module, exports) {

let $19f3a3b4ff21d619$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $19f3a3b4ff21d619$var$load("fMrUo"),
    $19f3a3b4ff21d619$var$load("bJykp"),
    $19f3a3b4ff21d619$var$load("4Wdqb"),
    $19f3a3b4ff21d619$var$load("fjbzp"),
    $19f3a3b4ff21d619$var$load("9v6ER"),
    $19f3a3b4ff21d619$var$load("aEAsN")
]).then(()=>parcelRequire('dOK5O'));

});

parcelRegister("kaWKs", function(module, exports) {

let $eb025006a3da47d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eb025006a3da47d2$var$load("fMrUo"),
    $eb025006a3da47d2$var$load("bJykp"),
    $eb025006a3da47d2$var$load("4Wdqb"),
    $eb025006a3da47d2$var$load("fjbzp"),
    $eb025006a3da47d2$var$load("9v6ER"),
    $eb025006a3da47d2$var$load("aEAsN")
]).then(()=>parcelRequire('8CgL0'));

});

parcelRegister("3W3jF", function(module, exports) {

let $2dd95c6c9bac3988$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2dd95c6c9bac3988$var$load("fMrUo"),
    $2dd95c6c9bac3988$var$load("bJykp"),
    $2dd95c6c9bac3988$var$load("4Wdqb"),
    $2dd95c6c9bac3988$var$load("fjbzp"),
    $2dd95c6c9bac3988$var$load("9v6ER"),
    $2dd95c6c9bac3988$var$load("aEAsN")
]).then(()=>parcelRequire('bLb11'));

});

parcelRegister("ge4kn", function(module, exports) {

let $bd014f85e53d84f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bd014f85e53d84f3$var$load("fMrUo"),
    $bd014f85e53d84f3$var$load("bJykp"),
    $bd014f85e53d84f3$var$load("4Wdqb"),
    $bd014f85e53d84f3$var$load("fjbzp"),
    $bd014f85e53d84f3$var$load("9v6ER"),
    $bd014f85e53d84f3$var$load("aEAsN")
]).then(()=>parcelRequire('2nJpt'));

});

parcelRegister("dALWD", function(module, exports) {

let $9e53d3fd610ccc9d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9e53d3fd610ccc9d$var$load("fMrUo"),
    $9e53d3fd610ccc9d$var$load("bJykp"),
    $9e53d3fd610ccc9d$var$load("4Wdqb"),
    $9e53d3fd610ccc9d$var$load("fjbzp"),
    $9e53d3fd610ccc9d$var$load("9v6ER"),
    $9e53d3fd610ccc9d$var$load("aEAsN")
]).then(()=>parcelRequire('ksOte'));

});

parcelRegister("fZwia", function(module, exports) {

let $ba459a07b2be279a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ba459a07b2be279a$var$load("fMrUo"),
    $ba459a07b2be279a$var$load("bJykp"),
    $ba459a07b2be279a$var$load("4Wdqb"),
    $ba459a07b2be279a$var$load("fjbzp"),
    $ba459a07b2be279a$var$load("9v6ER"),
    $ba459a07b2be279a$var$load("aEAsN")
]).then(()=>parcelRequire('4Ktvw'));

});

parcelRegister("eFhvS", function(module, exports) {

let $aad27ac9e6dd5583$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aad27ac9e6dd5583$var$load("fMrUo"),
    $aad27ac9e6dd5583$var$load("bJykp"),
    $aad27ac9e6dd5583$var$load("4Wdqb"),
    $aad27ac9e6dd5583$var$load("fjbzp"),
    $aad27ac9e6dd5583$var$load("9v6ER"),
    $aad27ac9e6dd5583$var$load("aEAsN")
]).then(()=>parcelRequire('fUVaQ'));

});

parcelRegister("2nXZ8", function(module, exports) {

let $1bcc4286573c4cf3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1bcc4286573c4cf3$var$load("fMrUo"),
    $1bcc4286573c4cf3$var$load("bJykp"),
    $1bcc4286573c4cf3$var$load("4Wdqb"),
    $1bcc4286573c4cf3$var$load("fjbzp"),
    $1bcc4286573c4cf3$var$load("9v6ER"),
    $1bcc4286573c4cf3$var$load("aEAsN")
]).then(()=>parcelRequire('6cRxb'));

});

parcelRegister("jmZFT", function(module, exports) {

let $e19fe9b8f9288ec5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e19fe9b8f9288ec5$var$load("fMrUo"),
    $e19fe9b8f9288ec5$var$load("bJykp"),
    $e19fe9b8f9288ec5$var$load("4Wdqb"),
    $e19fe9b8f9288ec5$var$load("fjbzp"),
    $e19fe9b8f9288ec5$var$load("9v6ER"),
    $e19fe9b8f9288ec5$var$load("aEAsN")
]).then(()=>parcelRequire('eJaxC'));

});

parcelRegister("6Y3b8", function(module, exports) {

let $512acfe6743db3a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $512acfe6743db3a0$var$load("fMrUo"),
    $512acfe6743db3a0$var$load("bJykp"),
    $512acfe6743db3a0$var$load("4Wdqb"),
    $512acfe6743db3a0$var$load("fjbzp"),
    $512acfe6743db3a0$var$load("9v6ER"),
    $512acfe6743db3a0$var$load("aEAsN")
]).then(()=>parcelRequire('gat70'));

});

parcelRegister("a1uRE", function(module, exports) {

let $74c1f0626d7f9ce8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $74c1f0626d7f9ce8$var$load("fMrUo"),
    $74c1f0626d7f9ce8$var$load("bJykp"),
    $74c1f0626d7f9ce8$var$load("4Wdqb"),
    $74c1f0626d7f9ce8$var$load("fjbzp"),
    $74c1f0626d7f9ce8$var$load("9v6ER"),
    $74c1f0626d7f9ce8$var$load("aEAsN")
]).then(()=>parcelRequire('bglo8'));

});

parcelRegister("HG6tA", function(module, exports) {

let $0834ad22e7c877de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0834ad22e7c877de$var$load("fMrUo"),
    $0834ad22e7c877de$var$load("bJykp"),
    $0834ad22e7c877de$var$load("4Wdqb"),
    $0834ad22e7c877de$var$load("fjbzp"),
    $0834ad22e7c877de$var$load("9v6ER"),
    $0834ad22e7c877de$var$load("aEAsN")
]).then(()=>parcelRequire('itmpX'));

});

parcelRegister("bt2el", function(module, exports) {

let $8594220df09656fb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8594220df09656fb$var$load("fMrUo"),
    $8594220df09656fb$var$load("bJykp"),
    $8594220df09656fb$var$load("4Wdqb"),
    $8594220df09656fb$var$load("fjbzp"),
    $8594220df09656fb$var$load("9v6ER"),
    $8594220df09656fb$var$load("aEAsN")
]).then(()=>parcelRequire('jY3IN'));

});

parcelRegister("3ZSwL", function(module, exports) {

let $2e915d98cbd3a697$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2e915d98cbd3a697$var$load("fMrUo"),
    $2e915d98cbd3a697$var$load("bJykp"),
    $2e915d98cbd3a697$var$load("4Wdqb"),
    $2e915d98cbd3a697$var$load("fjbzp"),
    $2e915d98cbd3a697$var$load("9v6ER"),
    $2e915d98cbd3a697$var$load("aEAsN")
]).then(()=>parcelRequire('5CqNQ'));

});

parcelRegister("hHPqE", function(module, exports) {

let $ce3e5883de980983$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ce3e5883de980983$var$load("fMrUo"),
    $ce3e5883de980983$var$load("bJykp"),
    $ce3e5883de980983$var$load("4Wdqb"),
    $ce3e5883de980983$var$load("fjbzp"),
    $ce3e5883de980983$var$load("9v6ER"),
    $ce3e5883de980983$var$load("aEAsN")
]).then(()=>parcelRequire('iq9vR'));

});

parcelRegister("gIBZU", function(module, exports) {

let $c2be3af10d497f44$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c2be3af10d497f44$var$load("fMrUo"),
    $c2be3af10d497f44$var$load("bJykp"),
    $c2be3af10d497f44$var$load("4Wdqb"),
    $c2be3af10d497f44$var$load("fjbzp"),
    $c2be3af10d497f44$var$load("9v6ER"),
    $c2be3af10d497f44$var$load("aEAsN")
]).then(()=>parcelRequire('fzDaX'));

});

parcelRegister("9o60R", function(module, exports) {

let $6d5b04f989167e7f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6d5b04f989167e7f$var$load("fMrUo"),
    $6d5b04f989167e7f$var$load("bJykp"),
    $6d5b04f989167e7f$var$load("4Wdqb"),
    $6d5b04f989167e7f$var$load("fjbzp"),
    $6d5b04f989167e7f$var$load("9v6ER"),
    $6d5b04f989167e7f$var$load("aEAsN")
]).then(()=>parcelRequire('eFX3Q'));

});

parcelRegister("eAQcA", function(module, exports) {

let $a9fcebb310d27af8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a9fcebb310d27af8$var$load("fMrUo"),
    $a9fcebb310d27af8$var$load("bJykp"),
    $a9fcebb310d27af8$var$load("4Wdqb"),
    $a9fcebb310d27af8$var$load("fjbzp"),
    $a9fcebb310d27af8$var$load("9v6ER"),
    $a9fcebb310d27af8$var$load("aEAsN")
]).then(()=>parcelRequire('bChZ5'));

});

parcelRegister("bqdqd", function(module, exports) {

let $850c88b23c3a2fa6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $850c88b23c3a2fa6$var$load("fMrUo"),
    $850c88b23c3a2fa6$var$load("bJykp"),
    $850c88b23c3a2fa6$var$load("4Wdqb"),
    $850c88b23c3a2fa6$var$load("fjbzp"),
    $850c88b23c3a2fa6$var$load("9v6ER"),
    $850c88b23c3a2fa6$var$load("aEAsN")
]).then(()=>parcelRequire('55P6z'));

});

parcelRegister("jCl1E", function(module, exports) {

let $e481e02fdc24e709$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e481e02fdc24e709$var$load("fMrUo"),
    $e481e02fdc24e709$var$load("bJykp"),
    $e481e02fdc24e709$var$load("4Wdqb"),
    $e481e02fdc24e709$var$load("fjbzp"),
    $e481e02fdc24e709$var$load("9v6ER"),
    $e481e02fdc24e709$var$load("aEAsN")
]).then(()=>parcelRequire('bKi5Y'));

});

parcelRegister("bUlYI", function(module, exports) {

let $8ab5f91d38dabe04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8ab5f91d38dabe04$var$load("fMrUo"),
    $8ab5f91d38dabe04$var$load("bJykp"),
    $8ab5f91d38dabe04$var$load("4Wdqb"),
    $8ab5f91d38dabe04$var$load("fjbzp"),
    $8ab5f91d38dabe04$var$load("9v6ER"),
    $8ab5f91d38dabe04$var$load("aEAsN")
]).then(()=>parcelRequire('epI6x'));

});

parcelRegister("7YG1Z", function(module, exports) {

let $5ceebd7afd3c5cf5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5ceebd7afd3c5cf5$var$load("fMrUo"),
    $5ceebd7afd3c5cf5$var$load("bJykp"),
    $5ceebd7afd3c5cf5$var$load("4Wdqb"),
    $5ceebd7afd3c5cf5$var$load("fjbzp"),
    $5ceebd7afd3c5cf5$var$load("9v6ER"),
    $5ceebd7afd3c5cf5$var$load("aEAsN")
]).then(()=>parcelRequire('1ot39'));

});

parcelRegister("dQTJB", function(module, exports) {

let $a15b5d6d35ea23e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a15b5d6d35ea23e9$var$load("fMrUo"),
    $a15b5d6d35ea23e9$var$load("bJykp"),
    $a15b5d6d35ea23e9$var$load("4Wdqb"),
    $a15b5d6d35ea23e9$var$load("fjbzp"),
    $a15b5d6d35ea23e9$var$load("9v6ER"),
    $a15b5d6d35ea23e9$var$load("aEAsN")
]).then(()=>parcelRequire('kJ9vR'));

});

parcelRegister("kI5sJ", function(module, exports) {

let $f13c276f0b294cc0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f13c276f0b294cc0$var$load("fMrUo"),
    $f13c276f0b294cc0$var$load("bJykp"),
    $f13c276f0b294cc0$var$load("4Wdqb"),
    $f13c276f0b294cc0$var$load("fjbzp"),
    $f13c276f0b294cc0$var$load("9v6ER"),
    $f13c276f0b294cc0$var$load("aEAsN")
]).then(()=>parcelRequire('jReTM'));

});

parcelRegister("d3mtm", function(module, exports) {

let $980cfcc55d8e6a0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $980cfcc55d8e6a0d$var$load("fMrUo"),
    $980cfcc55d8e6a0d$var$load("bJykp"),
    $980cfcc55d8e6a0d$var$load("4Wdqb"),
    $980cfcc55d8e6a0d$var$load("fjbzp"),
    $980cfcc55d8e6a0d$var$load("9v6ER"),
    $980cfcc55d8e6a0d$var$load("aEAsN")
]).then(()=>parcelRequire('40eED'));

});

parcelRegister("eK9gf", function(module, exports) {

let $abbc8b98672645cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $abbc8b98672645cb$var$load("fMrUo"),
    $abbc8b98672645cb$var$load("bJykp"),
    $abbc8b98672645cb$var$load("4Wdqb"),
    $abbc8b98672645cb$var$load("fjbzp"),
    $abbc8b98672645cb$var$load("9v6ER"),
    $abbc8b98672645cb$var$load("aEAsN")
]).then(()=>parcelRequire('lX1JT'));

});

parcelRegister("91wjI", function(module, exports) {

let $691d4687e82232bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $691d4687e82232bf$var$load("fMrUo"),
    $691d4687e82232bf$var$load("bJykp"),
    $691d4687e82232bf$var$load("4Wdqb"),
    $691d4687e82232bf$var$load("fjbzp"),
    $691d4687e82232bf$var$load("9v6ER"),
    $691d4687e82232bf$var$load("aEAsN")
]).then(()=>parcelRequire('amhCJ'));

});

parcelRegister("cSIGQ", function(module, exports) {

let $960d31b5f18209d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $960d31b5f18209d2$var$load("fMrUo"),
    $960d31b5f18209d2$var$load("bJykp"),
    $960d31b5f18209d2$var$load("4Wdqb"),
    $960d31b5f18209d2$var$load("fjbzp"),
    $960d31b5f18209d2$var$load("9v6ER"),
    $960d31b5f18209d2$var$load("aEAsN")
]).then(()=>parcelRequire('dUARU'));

});

parcelRegister("s6lRK", function(module, exports) {

let $05478af335115d3b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $05478af335115d3b$var$load("fMrUo"),
    $05478af335115d3b$var$load("bJykp"),
    $05478af335115d3b$var$load("4Wdqb"),
    $05478af335115d3b$var$load("fjbzp"),
    $05478af335115d3b$var$load("9v6ER"),
    $05478af335115d3b$var$load("aEAsN")
]).then(()=>parcelRequire('9vWeC'));

});

parcelRegister("8fOrs", function(module, exports) {

let $6026da24d20b0090$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6026da24d20b0090$var$load("fMrUo"),
    $6026da24d20b0090$var$load("bJykp"),
    $6026da24d20b0090$var$load("4Wdqb"),
    $6026da24d20b0090$var$load("fjbzp"),
    $6026da24d20b0090$var$load("9v6ER"),
    $6026da24d20b0090$var$load("aEAsN")
]).then(()=>parcelRequire('87orX'));

});

parcelRegister("5zdpU", function(module, exports) {

let $40daa0f633fec3f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $40daa0f633fec3f4$var$load("fMrUo"),
    $40daa0f633fec3f4$var$load("bJykp"),
    $40daa0f633fec3f4$var$load("4Wdqb"),
    $40daa0f633fec3f4$var$load("fjbzp"),
    $40daa0f633fec3f4$var$load("9v6ER"),
    $40daa0f633fec3f4$var$load("aEAsN")
]).then(()=>parcelRequire('d4tIY'));

});

parcelRegister("kj3LF", function(module, exports) {

let $ec88813524dc1dab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ec88813524dc1dab$var$load("fMrUo"),
    $ec88813524dc1dab$var$load("bJykp"),
    $ec88813524dc1dab$var$load("4Wdqb"),
    $ec88813524dc1dab$var$load("fjbzp"),
    $ec88813524dc1dab$var$load("9v6ER"),
    $ec88813524dc1dab$var$load("aEAsN")
]).then(()=>parcelRequire('90ZSB'));

});

parcelRegister("lJcGW", function(module, exports) {

let $fd17a538e1134a0e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fd17a538e1134a0e$var$load("fMrUo"),
    $fd17a538e1134a0e$var$load("bJykp"),
    $fd17a538e1134a0e$var$load("4Wdqb"),
    $fd17a538e1134a0e$var$load("fjbzp"),
    $fd17a538e1134a0e$var$load("9v6ER"),
    $fd17a538e1134a0e$var$load("aEAsN")
]).then(()=>parcelRequire('9Il0G'));

});

parcelRegister("lbVXE", function(module, exports) {

let $f6d795eeba988f09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f6d795eeba988f09$var$load("fMrUo"),
    $f6d795eeba988f09$var$load("bJykp"),
    $f6d795eeba988f09$var$load("4Wdqb"),
    $f6d795eeba988f09$var$load("fjbzp"),
    $f6d795eeba988f09$var$load("9v6ER"),
    $f6d795eeba988f09$var$load("aEAsN")
]).then(()=>parcelRequire('fLw4q'));

});

parcelRegister("8XQ8w", function(module, exports) {

let $686c46a30fa64b23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $686c46a30fa64b23$var$load("fMrUo"),
    $686c46a30fa64b23$var$load("bJykp"),
    $686c46a30fa64b23$var$load("4Wdqb"),
    $686c46a30fa64b23$var$load("fjbzp"),
    $686c46a30fa64b23$var$load("9v6ER"),
    $686c46a30fa64b23$var$load("aEAsN")
]).then(()=>parcelRequire('1EpQW'));

});

parcelRegister("d9Ik0", function(module, exports) {

let $993e7efd34baa3a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $993e7efd34baa3a1$var$load("deyvi"),
    $993e7efd34baa3a1$var$load("cdeuH"),
    $993e7efd34baa3a1$var$load("4UPfH"),
    $993e7efd34baa3a1$var$load("aNg21"),
    $993e7efd34baa3a1$var$load("1Mp9N"),
    $993e7efd34baa3a1$var$load("2Fu3d")
]).then(()=>parcelRequire('15Tdz'));

});

parcelRegister("byDVw", function(module, exports) {

let $86a1d7512263dfbf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $86a1d7512263dfbf$var$load("deyvi"),
    $86a1d7512263dfbf$var$load("cdeuH"),
    $86a1d7512263dfbf$var$load("4UPfH"),
    $86a1d7512263dfbf$var$load("aNg21"),
    $86a1d7512263dfbf$var$load("1Mp9N"),
    $86a1d7512263dfbf$var$load("2Fu3d")
]).then(()=>parcelRequire('cg8m4'));

});

parcelRegister("8L1el", function(module, exports) {

let $6603aadc2c171b79$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6603aadc2c171b79$var$load("deyvi"),
    $6603aadc2c171b79$var$load("cdeuH"),
    $6603aadc2c171b79$var$load("4UPfH"),
    $6603aadc2c171b79$var$load("aNg21"),
    $6603aadc2c171b79$var$load("1Mp9N"),
    $6603aadc2c171b79$var$load("2Fu3d")
]).then(()=>parcelRequire('ebQs8'));

});

parcelRegister("aHczM", function(module, exports) {

let $7c97acde7f8a616f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7c97acde7f8a616f$var$load("deyvi"),
    $7c97acde7f8a616f$var$load("cdeuH"),
    $7c97acde7f8a616f$var$load("4UPfH"),
    $7c97acde7f8a616f$var$load("aNg21"),
    $7c97acde7f8a616f$var$load("1Mp9N"),
    $7c97acde7f8a616f$var$load("2Fu3d")
]).then(()=>parcelRequire('8rMrl'));

});

parcelRegister("1xR7J", function(module, exports) {

let $120214bfbab1fc59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $120214bfbab1fc59$var$load("deyvi"),
    $120214bfbab1fc59$var$load("cdeuH"),
    $120214bfbab1fc59$var$load("4UPfH"),
    $120214bfbab1fc59$var$load("aNg21"),
    $120214bfbab1fc59$var$load("1Mp9N"),
    $120214bfbab1fc59$var$load("2Fu3d")
]).then(()=>parcelRequire('biDFC'));

});

parcelRegister("fsZT8", function(module, exports) {

let $b4297a42f3d56bdb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b4297a42f3d56bdb$var$load("deyvi"),
    $b4297a42f3d56bdb$var$load("cdeuH"),
    $b4297a42f3d56bdb$var$load("4UPfH"),
    $b4297a42f3d56bdb$var$load("aNg21"),
    $b4297a42f3d56bdb$var$load("1Mp9N"),
    $b4297a42f3d56bdb$var$load("2Fu3d")
]).then(()=>parcelRequire('djvs6'));

});

parcelRegister("hWH5l", function(module, exports) {

let $d109463feaea6737$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d109463feaea6737$var$load("deyvi"),
    $d109463feaea6737$var$load("cdeuH"),
    $d109463feaea6737$var$load("4UPfH"),
    $d109463feaea6737$var$load("aNg21"),
    $d109463feaea6737$var$load("1Mp9N"),
    $d109463feaea6737$var$load("2Fu3d")
]).then(()=>parcelRequire('7HAe3'));

});

parcelRegister("f7BwS", function(module, exports) {

let $b0249f0177bf955a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b0249f0177bf955a$var$load("deyvi"),
    $b0249f0177bf955a$var$load("cdeuH"),
    $b0249f0177bf955a$var$load("4UPfH"),
    $b0249f0177bf955a$var$load("aNg21"),
    $b0249f0177bf955a$var$load("1Mp9N"),
    $b0249f0177bf955a$var$load("2Fu3d")
]).then(()=>parcelRequire('5CXR9'));

});

parcelRegister("3iZBc", function(module, exports) {

let $2682d5ca6bec98b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2682d5ca6bec98b1$var$load("deyvi"),
    $2682d5ca6bec98b1$var$load("cdeuH"),
    $2682d5ca6bec98b1$var$load("4UPfH"),
    $2682d5ca6bec98b1$var$load("aNg21"),
    $2682d5ca6bec98b1$var$load("1Mp9N"),
    $2682d5ca6bec98b1$var$load("2Fu3d")
]).then(()=>parcelRequire('5KGDH'));

});

parcelRegister("g3jku", function(module, exports) {

let $bafbeb99ec01cb2e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bafbeb99ec01cb2e$var$load("deyvi"),
    $bafbeb99ec01cb2e$var$load("cdeuH"),
    $bafbeb99ec01cb2e$var$load("4UPfH"),
    $bafbeb99ec01cb2e$var$load("aNg21"),
    $bafbeb99ec01cb2e$var$load("1Mp9N"),
    $bafbeb99ec01cb2e$var$load("2Fu3d")
]).then(()=>parcelRequire('bZDTF'));

});

parcelRegister("c4axN", function(module, exports) {

let $8c8e099d99691a18$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8c8e099d99691a18$var$load("deyvi"),
    $8c8e099d99691a18$var$load("cdeuH"),
    $8c8e099d99691a18$var$load("4UPfH"),
    $8c8e099d99691a18$var$load("aNg21"),
    $8c8e099d99691a18$var$load("1Mp9N"),
    $8c8e099d99691a18$var$load("2Fu3d")
]).then(()=>parcelRequire('f2JIn'));

});

parcelRegister("1DN08", function(module, exports) {

let $131f719500fef2ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $131f719500fef2ac$var$load("deyvi"),
    $131f719500fef2ac$var$load("cdeuH"),
    $131f719500fef2ac$var$load("4UPfH"),
    $131f719500fef2ac$var$load("aNg21"),
    $131f719500fef2ac$var$load("1Mp9N"),
    $131f719500fef2ac$var$load("2Fu3d")
]).then(()=>parcelRequire('gWtu0'));

});

parcelRegister("5r4T2", function(module, exports) {

let $3f5343c26cf9ed82$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f5343c26cf9ed82$var$load("deyvi"),
    $3f5343c26cf9ed82$var$load("cdeuH"),
    $3f5343c26cf9ed82$var$load("4UPfH"),
    $3f5343c26cf9ed82$var$load("aNg21"),
    $3f5343c26cf9ed82$var$load("1Mp9N"),
    $3f5343c26cf9ed82$var$load("2Fu3d")
]).then(()=>parcelRequire('2lvJW'));

});

parcelRegister("frJRn", function(module, exports) {

let $b3ecf36e3ee31ed0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b3ecf36e3ee31ed0$var$load("deyvi"),
    $b3ecf36e3ee31ed0$var$load("cdeuH"),
    $b3ecf36e3ee31ed0$var$load("4UPfH"),
    $b3ecf36e3ee31ed0$var$load("aNg21"),
    $b3ecf36e3ee31ed0$var$load("1Mp9N"),
    $b3ecf36e3ee31ed0$var$load("2Fu3d")
]).then(()=>parcelRequire('baR74'));

});

parcelRegister("6RhHb", function(module, exports) {

let $4fe56b41d69ef828$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4fe56b41d69ef828$var$load("deyvi"),
    $4fe56b41d69ef828$var$load("cdeuH"),
    $4fe56b41d69ef828$var$load("4UPfH"),
    $4fe56b41d69ef828$var$load("aNg21"),
    $4fe56b41d69ef828$var$load("1Mp9N"),
    $4fe56b41d69ef828$var$load("2Fu3d")
]).then(()=>parcelRequire('2jHH0'));

});

parcelRegister("79T8R", function(module, exports) {

let $536425b3457e04fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $536425b3457e04fc$var$load("deyvi"),
    $536425b3457e04fc$var$load("cdeuH"),
    $536425b3457e04fc$var$load("4UPfH"),
    $536425b3457e04fc$var$load("aNg21"),
    $536425b3457e04fc$var$load("1Mp9N"),
    $536425b3457e04fc$var$load("2Fu3d")
]).then(()=>parcelRequire('lFb12'));

});

parcelRegister("doQkv", function(module, exports) {

let $9c161bdc1933c3e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9c161bdc1933c3e4$var$load("deyvi"),
    $9c161bdc1933c3e4$var$load("cdeuH"),
    $9c161bdc1933c3e4$var$load("4UPfH"),
    $9c161bdc1933c3e4$var$load("aNg21"),
    $9c161bdc1933c3e4$var$load("1Mp9N"),
    $9c161bdc1933c3e4$var$load("2Fu3d")
]).then(()=>parcelRequire('iZn0V'));

});

parcelRegister("bsi3C", function(module, exports) {

let $8570511190f1dafd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8570511190f1dafd$var$load("deyvi"),
    $8570511190f1dafd$var$load("cdeuH"),
    $8570511190f1dafd$var$load("4UPfH"),
    $8570511190f1dafd$var$load("aNg21"),
    $8570511190f1dafd$var$load("1Mp9N"),
    $8570511190f1dafd$var$load("2Fu3d")
]).then(()=>parcelRequire('4eVVU'));

});

parcelRegister("85hJ3", function(module, exports) {

let $5e2c8a507cd6fe8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5e2c8a507cd6fe8a$var$load("deyvi"),
    $5e2c8a507cd6fe8a$var$load("cdeuH"),
    $5e2c8a507cd6fe8a$var$load("4UPfH"),
    $5e2c8a507cd6fe8a$var$load("aNg21"),
    $5e2c8a507cd6fe8a$var$load("1Mp9N"),
    $5e2c8a507cd6fe8a$var$load("2Fu3d")
]).then(()=>parcelRequire('93jah'));

});

parcelRegister("aC4DH", function(module, exports) {

let $7ba10d3f46db17d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7ba10d3f46db17d1$var$load("deyvi"),
    $7ba10d3f46db17d1$var$load("cdeuH"),
    $7ba10d3f46db17d1$var$load("4UPfH"),
    $7ba10d3f46db17d1$var$load("aNg21"),
    $7ba10d3f46db17d1$var$load("1Mp9N"),
    $7ba10d3f46db17d1$var$load("2Fu3d")
]).then(()=>parcelRequire('4dfVD'));

});

parcelRegister("hC4Lh", function(module, exports) {

let $cd29add7ed7c8b42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cd29add7ed7c8b42$var$load("deyvi"),
    $cd29add7ed7c8b42$var$load("cdeuH"),
    $cd29add7ed7c8b42$var$load("4UPfH"),
    $cd29add7ed7c8b42$var$load("aNg21"),
    $cd29add7ed7c8b42$var$load("1Mp9N"),
    $cd29add7ed7c8b42$var$load("2Fu3d")
]).then(()=>parcelRequire('jik1Z'));

});

parcelRegister("iqmqJ", function(module, exports) {

let $d69c0dd9bb9ce6a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d69c0dd9bb9ce6a6$var$load("deyvi"),
    $d69c0dd9bb9ce6a6$var$load("cdeuH"),
    $d69c0dd9bb9ce6a6$var$load("4UPfH"),
    $d69c0dd9bb9ce6a6$var$load("aNg21"),
    $d69c0dd9bb9ce6a6$var$load("1Mp9N"),
    $d69c0dd9bb9ce6a6$var$load("2Fu3d")
]).then(()=>parcelRequire('1zjGd'));

});

parcelRegister("LC2CN", function(module, exports) {

let $08f1e61e04bccd7a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $08f1e61e04bccd7a$var$load("deyvi"),
    $08f1e61e04bccd7a$var$load("cdeuH"),
    $08f1e61e04bccd7a$var$load("4UPfH"),
    $08f1e61e04bccd7a$var$load("aNg21"),
    $08f1e61e04bccd7a$var$load("1Mp9N"),
    $08f1e61e04bccd7a$var$load("2Fu3d")
]).then(()=>parcelRequire('h8lWz'));

});

parcelRegister("a1Dfy", function(module, exports) {

let $74c871900346c7bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $74c871900346c7bd$var$load("deyvi"),
    $74c871900346c7bd$var$load("cdeuH"),
    $74c871900346c7bd$var$load("4UPfH"),
    $74c871900346c7bd$var$load("aNg21"),
    $74c871900346c7bd$var$load("1Mp9N"),
    $74c871900346c7bd$var$load("2Fu3d")
]).then(()=>parcelRequire('5jm5G'));

});

parcelRegister("kGzms", function(module, exports) {

let $f0f328e24231ae65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f0f328e24231ae65$var$load("deyvi"),
    $f0f328e24231ae65$var$load("cdeuH"),
    $f0f328e24231ae65$var$load("4UPfH"),
    $f0f328e24231ae65$var$load("aNg21"),
    $f0f328e24231ae65$var$load("1Mp9N"),
    $f0f328e24231ae65$var$load("2Fu3d")
]).then(()=>parcelRequire('1vCye'));

});

parcelRegister("iBqVt", function(module, exports) {

let $d8b091a82dd47d30$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d8b091a82dd47d30$var$load("deyvi"),
    $d8b091a82dd47d30$var$load("cdeuH"),
    $d8b091a82dd47d30$var$load("4UPfH"),
    $d8b091a82dd47d30$var$load("aNg21"),
    $d8b091a82dd47d30$var$load("1Mp9N"),
    $d8b091a82dd47d30$var$load("2Fu3d")
]).then(()=>parcelRequire('5GVzQ'));

});

parcelRegister("7BZ9C", function(module, exports) {

let $58ab6d0bacf14a86$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $58ab6d0bacf14a86$var$load("deyvi"),
    $58ab6d0bacf14a86$var$load("cdeuH"),
    $58ab6d0bacf14a86$var$load("4UPfH"),
    $58ab6d0bacf14a86$var$load("aNg21"),
    $58ab6d0bacf14a86$var$load("1Mp9N"),
    $58ab6d0bacf14a86$var$load("2Fu3d")
]).then(()=>parcelRequire('EzP52'));

});

parcelRegister("bzecu", function(module, exports) {

let $86bdfa85206d5819$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $86bdfa85206d5819$var$load("deyvi"),
    $86bdfa85206d5819$var$load("cdeuH"),
    $86bdfa85206d5819$var$load("4UPfH"),
    $86bdfa85206d5819$var$load("aNg21"),
    $86bdfa85206d5819$var$load("1Mp9N"),
    $86bdfa85206d5819$var$load("2Fu3d")
]).then(()=>parcelRequire('9F3eE'));

});

parcelRegister("dNZ7N", function(module, exports) {

let $a0cf44125954fbd7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a0cf44125954fbd7$var$load("deyvi"),
    $a0cf44125954fbd7$var$load("cdeuH"),
    $a0cf44125954fbd7$var$load("4UPfH"),
    $a0cf44125954fbd7$var$load("aNg21"),
    $a0cf44125954fbd7$var$load("1Mp9N"),
    $a0cf44125954fbd7$var$load("2Fu3d")
]).then(()=>parcelRequire('fxxUP'));

});

parcelRegister("a5CS2", function(module, exports) {

let $758885e474981c27$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $758885e474981c27$var$load("deyvi"),
    $758885e474981c27$var$load("cdeuH"),
    $758885e474981c27$var$load("4UPfH"),
    $758885e474981c27$var$load("aNg21"),
    $758885e474981c27$var$load("1Mp9N"),
    $758885e474981c27$var$load("2Fu3d")
]).then(()=>parcelRequire('hDAuO'));

});

parcelRegister("kqoD7", function(module, exports) {

let $ede95755a41ae5b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ede95755a41ae5b1$var$load("deyvi"),
    $ede95755a41ae5b1$var$load("cdeuH"),
    $ede95755a41ae5b1$var$load("4UPfH"),
    $ede95755a41ae5b1$var$load("aNg21"),
    $ede95755a41ae5b1$var$load("1Mp9N"),
    $ede95755a41ae5b1$var$load("2Fu3d")
]).then(()=>parcelRequire('a2Y1o'));

});

parcelRegister("eCZos", function(module, exports) {

let $aa643cc9c1e6357c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aa643cc9c1e6357c$var$load("deyvi"),
    $aa643cc9c1e6357c$var$load("cdeuH"),
    $aa643cc9c1e6357c$var$load("4UPfH"),
    $aa643cc9c1e6357c$var$load("aNg21"),
    $aa643cc9c1e6357c$var$load("1Mp9N"),
    $aa643cc9c1e6357c$var$load("2Fu3d")
]).then(()=>parcelRequire('4RfDl'));

});

parcelRegister("di64X", function(module, exports) {

let $9ad1abfb32101b1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9ad1abfb32101b1f$var$load("deyvi"),
    $9ad1abfb32101b1f$var$load("cdeuH"),
    $9ad1abfb32101b1f$var$load("4UPfH"),
    $9ad1abfb32101b1f$var$load("aNg21"),
    $9ad1abfb32101b1f$var$load("1Mp9N"),
    $9ad1abfb32101b1f$var$load("2Fu3d")
]).then(()=>parcelRequire('6ft6c'));

});

parcelRegister("72kZ1", function(module, exports) {

let $51f8ff29c2e44045$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $51f8ff29c2e44045$var$load("deyvi"),
    $51f8ff29c2e44045$var$load("cdeuH"),
    $51f8ff29c2e44045$var$load("4UPfH"),
    $51f8ff29c2e44045$var$load("aNg21"),
    $51f8ff29c2e44045$var$load("1Mp9N"),
    $51f8ff29c2e44045$var$load("2Fu3d")
]).then(()=>parcelRequire('hR6ke'));

});

parcelRegister("gyczk", function(module, exports) {

let $c0c9923d7b6e4de0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c0c9923d7b6e4de0$var$load("deyvi"),
    $c0c9923d7b6e4de0$var$load("cdeuH"),
    $c0c9923d7b6e4de0$var$load("4UPfH"),
    $c0c9923d7b6e4de0$var$load("aNg21"),
    $c0c9923d7b6e4de0$var$load("1Mp9N"),
    $c0c9923d7b6e4de0$var$load("2Fu3d")
]).then(()=>parcelRequire('3absz'));

});

parcelRegister("99SMa", function(module, exports) {

let $6aaf71a82331a9ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6aaf71a82331a9ee$var$load("deyvi"),
    $6aaf71a82331a9ee$var$load("cdeuH"),
    $6aaf71a82331a9ee$var$load("4UPfH"),
    $6aaf71a82331a9ee$var$load("aNg21"),
    $6aaf71a82331a9ee$var$load("1Mp9N"),
    $6aaf71a82331a9ee$var$load("2Fu3d")
]).then(()=>parcelRequire('bO2d0'));

});

parcelRegister("4vXmH", function(module, exports) {

let $34981b5b41af74be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $34981b5b41af74be$var$load("deyvi"),
    $34981b5b41af74be$var$load("cdeuH"),
    $34981b5b41af74be$var$load("4UPfH"),
    $34981b5b41af74be$var$load("aNg21"),
    $34981b5b41af74be$var$load("1Mp9N"),
    $34981b5b41af74be$var$load("2Fu3d")
]).then(()=>parcelRequire('4Speu'));

});

parcelRegister("6H2n8", function(module, exports) {

let $4df8994ce2cf1f31$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4df8994ce2cf1f31$var$load("deyvi"),
    $4df8994ce2cf1f31$var$load("cdeuH"),
    $4df8994ce2cf1f31$var$load("4UPfH"),
    $4df8994ce2cf1f31$var$load("aNg21"),
    $4df8994ce2cf1f31$var$load("1Mp9N"),
    $4df8994ce2cf1f31$var$load("2Fu3d")
]).then(()=>parcelRequire('5T7BQ'));

});

parcelRegister("kTT3m", function(module, exports) {

let $f373a619ed9297a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f373a619ed9297a4$var$load("deyvi"),
    $f373a619ed9297a4$var$load("cdeuH"),
    $f373a619ed9297a4$var$load("4UPfH"),
    $f373a619ed9297a4$var$load("aNg21"),
    $f373a619ed9297a4$var$load("1Mp9N"),
    $f373a619ed9297a4$var$load("2Fu3d")
]).then(()=>parcelRequire('7F0FV'));

});

parcelRegister("fbtaD", function(module, exports) {

let $b0de82c7d0aa6c6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b0de82c7d0aa6c6d$var$load("deyvi"),
    $b0de82c7d0aa6c6d$var$load("cdeuH"),
    $b0de82c7d0aa6c6d$var$load("4UPfH"),
    $b0de82c7d0aa6c6d$var$load("aNg21"),
    $b0de82c7d0aa6c6d$var$load("1Mp9N"),
    $b0de82c7d0aa6c6d$var$load("2Fu3d")
]).then(()=>parcelRequire('3CzqR'));

});

parcelRegister("fCU8B", function(module, exports) {

let $b605f36561e7ce03$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b605f36561e7ce03$var$load("deyvi"),
    $b605f36561e7ce03$var$load("cdeuH"),
    $b605f36561e7ce03$var$load("4UPfH"),
    $b605f36561e7ce03$var$load("aNg21"),
    $b605f36561e7ce03$var$load("1Mp9N"),
    $b605f36561e7ce03$var$load("2Fu3d")
]).then(()=>parcelRequire('aU3fj'));

});

parcelRegister("bIFjS", function(module, exports) {

let $8883daf85e66b4b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8883daf85e66b4b3$var$load("deyvi"),
    $8883daf85e66b4b3$var$load("cdeuH"),
    $8883daf85e66b4b3$var$load("4UPfH"),
    $8883daf85e66b4b3$var$load("aNg21"),
    $8883daf85e66b4b3$var$load("1Mp9N"),
    $8883daf85e66b4b3$var$load("2Fu3d")
]).then(()=>parcelRequire('hKsY8'));

});

parcelRegister("474bn", function(module, exports) {

let $2feb0f6a65b8ea7f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2feb0f6a65b8ea7f$var$load("deyvi"),
    $2feb0f6a65b8ea7f$var$load("cdeuH"),
    $2feb0f6a65b8ea7f$var$load("4UPfH"),
    $2feb0f6a65b8ea7f$var$load("aNg21"),
    $2feb0f6a65b8ea7f$var$load("1Mp9N"),
    $2feb0f6a65b8ea7f$var$load("2Fu3d")
]).then(()=>parcelRequire('l593g'));

});

parcelRegister("kOD1A", function(module, exports) {

let $f276bfa280eb4149$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f276bfa280eb4149$var$load("deyvi"),
    $f276bfa280eb4149$var$load("cdeuH"),
    $f276bfa280eb4149$var$load("4UPfH"),
    $f276bfa280eb4149$var$load("aNg21"),
    $f276bfa280eb4149$var$load("1Mp9N"),
    $f276bfa280eb4149$var$load("2Fu3d")
]).then(()=>parcelRequire('3mzdS'));

});

parcelRegister("hBv8R", function(module, exports) {

let $cd0e0c81a4d51eb4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cd0e0c81a4d51eb4$var$load("deyvi"),
    $cd0e0c81a4d51eb4$var$load("cdeuH"),
    $cd0e0c81a4d51eb4$var$load("4UPfH"),
    $cd0e0c81a4d51eb4$var$load("aNg21"),
    $cd0e0c81a4d51eb4$var$load("1Mp9N"),
    $cd0e0c81a4d51eb4$var$load("2Fu3d")
]).then(()=>parcelRequire('83xqX'));

});

parcelRegister("9AVwI", function(module, exports) {

let $6fc41970c437139f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6fc41970c437139f$var$load("deyvi"),
    $6fc41970c437139f$var$load("cdeuH"),
    $6fc41970c437139f$var$load("4UPfH"),
    $6fc41970c437139f$var$load("aNg21"),
    $6fc41970c437139f$var$load("1Mp9N"),
    $6fc41970c437139f$var$load("2Fu3d")
]).then(()=>parcelRequire('7WYIv'));

});

parcelRegister("ergUs", function(module, exports) {

let $a830b437158d76ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a830b437158d76ff$var$load("deyvi"),
    $a830b437158d76ff$var$load("cdeuH"),
    $a830b437158d76ff$var$load("4UPfH"),
    $a830b437158d76ff$var$load("aNg21"),
    $a830b437158d76ff$var$load("1Mp9N"),
    $a830b437158d76ff$var$load("2Fu3d")
]).then(()=>parcelRequire('fCU1c'));

});

parcelRegister("cZ1Kt", function(module, exports) {

let $973c89c0bbd12063$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $973c89c0bbd12063$var$load("deyvi"),
    $973c89c0bbd12063$var$load("cdeuH"),
    $973c89c0bbd12063$var$load("4UPfH"),
    $973c89c0bbd12063$var$load("aNg21"),
    $973c89c0bbd12063$var$load("1Mp9N"),
    $973c89c0bbd12063$var$load("2Fu3d")
]).then(()=>parcelRequire('8oF2Y'));

});

parcelRegister("b32TI", function(module, exports) {

let $80b238e998044e95$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $80b238e998044e95$var$load("deyvi"),
    $80b238e998044e95$var$load("cdeuH"),
    $80b238e998044e95$var$load("4UPfH"),
    $80b238e998044e95$var$load("aNg21"),
    $80b238e998044e95$var$load("1Mp9N"),
    $80b238e998044e95$var$load("2Fu3d")
]).then(()=>parcelRequire('dqKPX'));

});

parcelRegister("3dkeg", function(module, exports) {

let $2572471600aa2a0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2572471600aa2a0b$var$load("deyvi"),
    $2572471600aa2a0b$var$load("cdeuH"),
    $2572471600aa2a0b$var$load("4UPfH"),
    $2572471600aa2a0b$var$load("aNg21"),
    $2572471600aa2a0b$var$load("1Mp9N"),
    $2572471600aa2a0b$var$load("2Fu3d")
]).then(()=>parcelRequire('j8Xp5'));

});

parcelRegister("3TmS7", function(module, exports) {

let $2d5840032c8ffbf2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2d5840032c8ffbf2$var$load("7snhF"),
    $2d5840032c8ffbf2$var$load("X0Jic"),
    $2d5840032c8ffbf2$var$load("bAoKR"),
    $2d5840032c8ffbf2$var$load("34YSq"),
    $2d5840032c8ffbf2$var$load("5IaSN")
]).then(()=>parcelRequire('aeGBk'));

});

parcelRegister("iO4nx", function(module, exports) {

let $db104b02c33f2325$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $db104b02c33f2325$var$load("7snhF"),
    $db104b02c33f2325$var$load("X0Jic"),
    $db104b02c33f2325$var$load("bAoKR"),
    $db104b02c33f2325$var$load("34YSq"),
    $db104b02c33f2325$var$load("5IaSN")
]).then(()=>parcelRequire('a2bAW'));

});

parcelRegister("44JeZ", function(module, exports) {

let $2f7aa107e17ad361$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2f7aa107e17ad361$var$load("7snhF"),
    $2f7aa107e17ad361$var$load("X0Jic"),
    $2f7aa107e17ad361$var$load("bAoKR"),
    $2f7aa107e17ad361$var$load("34YSq"),
    $2f7aa107e17ad361$var$load("5IaSN")
]).then(()=>parcelRequire('lTO3M'));

});

parcelRegister("7czRk", function(module, exports) {

let $53e5784959018163$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $53e5784959018163$var$load("7snhF"),
    $53e5784959018163$var$load("X0Jic"),
    $53e5784959018163$var$load("bAoKR"),
    $53e5784959018163$var$load("34YSq"),
    $53e5784959018163$var$load("5IaSN")
]).then(()=>parcelRequire('jd2D8'));

});

parcelRegister("6K20d", function(module, exports) {

let $4e88979a9f6e5698$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e88979a9f6e5698$var$load("7snhF"),
    $4e88979a9f6e5698$var$load("X0Jic"),
    $4e88979a9f6e5698$var$load("bAoKR"),
    $4e88979a9f6e5698$var$load("34YSq"),
    $4e88979a9f6e5698$var$load("5IaSN")
]).then(()=>parcelRequire('kVRsY'));

});

parcelRegister("g9h5M", function(module, exports) {

let $bc1abebdbdf80b4c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bc1abebdbdf80b4c$var$load("7snhF"),
    $bc1abebdbdf80b4c$var$load("X0Jic"),
    $bc1abebdbdf80b4c$var$load("bAoKR"),
    $bc1abebdbdf80b4c$var$load("34YSq"),
    $bc1abebdbdf80b4c$var$load("5IaSN")
]).then(()=>parcelRequire('axlpK'));

});

parcelRegister("dexYO", function(module, exports) {

let $9a26f0e10944500a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9a26f0e10944500a$var$load("7snhF"),
    $9a26f0e10944500a$var$load("X0Jic"),
    $9a26f0e10944500a$var$load("bAoKR"),
    $9a26f0e10944500a$var$load("34YSq"),
    $9a26f0e10944500a$var$load("5IaSN")
]).then(()=>parcelRequire('d9A0j'));

});

parcelRegister("bByvU", function(module, exports) {

let $872dec1fb0a4d27b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $872dec1fb0a4d27b$var$load("7snhF"),
    $872dec1fb0a4d27b$var$load("X0Jic"),
    $872dec1fb0a4d27b$var$load("bAoKR"),
    $872dec1fb0a4d27b$var$load("34YSq"),
    $872dec1fb0a4d27b$var$load("5IaSN")
]).then(()=>parcelRequire('3rara'));

});

parcelRegister("8LRp6", function(module, exports) {

let $662c236f1870a4da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $662c236f1870a4da$var$load("7snhF"),
    $662c236f1870a4da$var$load("X0Jic"),
    $662c236f1870a4da$var$load("bAoKR"),
    $662c236f1870a4da$var$load("34YSq"),
    $662c236f1870a4da$var$load("5IaSN")
]).then(()=>parcelRequire('aM2eo'));

});

parcelRegister("5JS0e", function(module, exports) {

let $42db0b8b7d579c8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $42db0b8b7d579c8f$var$load("7snhF"),
    $42db0b8b7d579c8f$var$load("X0Jic"),
    $42db0b8b7d579c8f$var$load("bAoKR"),
    $42db0b8b7d579c8f$var$load("34YSq"),
    $42db0b8b7d579c8f$var$load("5IaSN")
]).then(()=>parcelRequire('H1FjW'));

});

parcelRegister("ja1eS", function(module, exports) {

let $df2fe98264e7d4e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $df2fe98264e7d4e3$var$load("7snhF"),
    $df2fe98264e7d4e3$var$load("X0Jic"),
    $df2fe98264e7d4e3$var$load("bAoKR"),
    $df2fe98264e7d4e3$var$load("34YSq"),
    $df2fe98264e7d4e3$var$load("5IaSN")
]).then(()=>parcelRequire('2bO4n'));

});

parcelRegister("hOjAI", function(module, exports) {

let $cf764d9aeaf52b3a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cf764d9aeaf52b3a$var$load("cbkj0"),
    $cf764d9aeaf52b3a$var$load("9Oxgj"),
    $cf764d9aeaf52b3a$var$load("4Afgd"),
    $cf764d9aeaf52b3a$var$load("18TX5"),
    $cf764d9aeaf52b3a$var$load("lp8Wm"),
    $cf764d9aeaf52b3a$var$load("l2LZP")
]).then(()=>parcelRequire('iDsnj'));

});

parcelRegister("kAg4J", function(module, exports) {

let $efc3a3aa568d2e5c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $efc3a3aa568d2e5c$var$load("cbkj0"),
    $efc3a3aa568d2e5c$var$load("9Oxgj"),
    $efc3a3aa568d2e5c$var$load("4Afgd"),
    $efc3a3aa568d2e5c$var$load("18TX5"),
    $efc3a3aa568d2e5c$var$load("lp8Wm"),
    $efc3a3aa568d2e5c$var$load("l2LZP")
]).then(()=>parcelRequire('heDdi'));

});

parcelRegister("aJrZf", function(module, exports) {

let $7d03d0f731f23079$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7d03d0f731f23079$var$load("cbkj0"),
    $7d03d0f731f23079$var$load("9Oxgj"),
    $7d03d0f731f23079$var$load("4Afgd"),
    $7d03d0f731f23079$var$load("18TX5"),
    $7d03d0f731f23079$var$load("lp8Wm"),
    $7d03d0f731f23079$var$load("l2LZP")
]).then(()=>parcelRequire('5AWOx'));

});

parcelRegister("bOPON", function(module, exports) {

let $89ac8f3b2cad1d57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $89ac8f3b2cad1d57$var$load("cbkj0"),
    $89ac8f3b2cad1d57$var$load("9Oxgj"),
    $89ac8f3b2cad1d57$var$load("4Afgd"),
    $89ac8f3b2cad1d57$var$load("18TX5"),
    $89ac8f3b2cad1d57$var$load("lp8Wm"),
    $89ac8f3b2cad1d57$var$load("l2LZP")
]).then(()=>parcelRequire('cCPXp'));

});

parcelRegister("6yeY4", function(module, exports) {

let $4c51875c6d7f70f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4c51875c6d7f70f2$var$load("cbkj0"),
    $4c51875c6d7f70f2$var$load("9Oxgj"),
    $4c51875c6d7f70f2$var$load("4Afgd"),
    $4c51875c6d7f70f2$var$load("18TX5"),
    $4c51875c6d7f70f2$var$load("lp8Wm"),
    $4c51875c6d7f70f2$var$load("l2LZP")
]).then(()=>parcelRequire('FrZOj'));

});

parcelRegister("75D4e", function(module, exports) {

let $52974df416eb60e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $52974df416eb60e0$var$load("cbkj0"),
    $52974df416eb60e0$var$load("9Oxgj"),
    $52974df416eb60e0$var$load("4Afgd"),
    $52974df416eb60e0$var$load("18TX5"),
    $52974df416eb60e0$var$load("lp8Wm"),
    $52974df416eb60e0$var$load("l2LZP")
]).then(()=>parcelRequire('eqTvU'));

});

parcelRegister("hJaAz", function(module, exports) {

let $ce7eda5c98a7170c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ce7eda5c98a7170c$var$load("cbkj0"),
    $ce7eda5c98a7170c$var$load("9Oxgj"),
    $ce7eda5c98a7170c$var$load("4Afgd"),
    $ce7eda5c98a7170c$var$load("18TX5"),
    $ce7eda5c98a7170c$var$load("lp8Wm"),
    $ce7eda5c98a7170c$var$load("l2LZP")
]).then(()=>parcelRequire('eVNA1'));

});

parcelRegister("8YOOq", function(module, exports) {

let $689b579161cb51e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $689b579161cb51e4$var$load("cbkj0"),
    $689b579161cb51e4$var$load("9Oxgj"),
    $689b579161cb51e4$var$load("4Afgd"),
    $689b579161cb51e4$var$load("18TX5"),
    $689b579161cb51e4$var$load("lp8Wm"),
    $689b579161cb51e4$var$load("l2LZP")
]).then(()=>parcelRequire('ezgWl'));

});

parcelRegister("eYYJB", function(module, exports) {

let $ae85c7e787f25cc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ae85c7e787f25cc2$var$load("cbkj0"),
    $ae85c7e787f25cc2$var$load("9Oxgj"),
    $ae85c7e787f25cc2$var$load("4Afgd"),
    $ae85c7e787f25cc2$var$load("18TX5"),
    $ae85c7e787f25cc2$var$load("lp8Wm"),
    $ae85c7e787f25cc2$var$load("l2LZP")
]).then(()=>parcelRequire('5RTxu'));

});

parcelRegister("1i9hU", function(module, exports) {

let $0f0ead46c0645ae9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0f0ead46c0645ae9$var$load("cbkj0"),
    $0f0ead46c0645ae9$var$load("9Oxgj"),
    $0f0ead46c0645ae9$var$load("4Afgd"),
    $0f0ead46c0645ae9$var$load("18TX5"),
    $0f0ead46c0645ae9$var$load("lp8Wm"),
    $0f0ead46c0645ae9$var$load("l2LZP")
]).then(()=>parcelRequire('4Nitg'));

});

parcelRegister("6sWdk", function(module, exports) {

let $4b5283aee43425eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4b5283aee43425eb$var$load("cbkj0"),
    $4b5283aee43425eb$var$load("9Oxgj"),
    $4b5283aee43425eb$var$load("4Afgd"),
    $4b5283aee43425eb$var$load("18TX5"),
    $4b5283aee43425eb$var$load("lp8Wm"),
    $4b5283aee43425eb$var$load("l2LZP")
]).then(()=>parcelRequire('jMzcV'));

});

parcelRegister("irj7Y", function(module, exports) {

let $d6c995f290eb1913$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d6c995f290eb1913$var$load("cbkj0"),
    $d6c995f290eb1913$var$load("9Oxgj"),
    $d6c995f290eb1913$var$load("4Afgd"),
    $d6c995f290eb1913$var$load("18TX5"),
    $d6c995f290eb1913$var$load("lp8Wm"),
    $d6c995f290eb1913$var$load("l2LZP")
]).then(()=>parcelRequire('hK1FZ'));

});

parcelRegister("aIRz0", function(module, exports) {

let $7ce790156b8ae976$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7ce790156b8ae976$var$load("cbkj0"),
    $7ce790156b8ae976$var$load("9Oxgj"),
    $7ce790156b8ae976$var$load("4Afgd"),
    $7ce790156b8ae976$var$load("18TX5"),
    $7ce790156b8ae976$var$load("lp8Wm"),
    $7ce790156b8ae976$var$load("l2LZP")
]).then(()=>parcelRequire('4bz8w'));

});

parcelRegister("aqhcc", function(module, exports) {

let $7969abc97dba133f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7969abc97dba133f$var$load("cbkj0"),
    $7969abc97dba133f$var$load("9Oxgj"),
    $7969abc97dba133f$var$load("4Afgd"),
    $7969abc97dba133f$var$load("18TX5"),
    $7969abc97dba133f$var$load("lp8Wm"),
    $7969abc97dba133f$var$load("l2LZP")
]).then(()=>parcelRequire('6d4D9'));

});

parcelRegister("8aZma", function(module, exports) {

let $5f3eda043488df22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5f3eda043488df22$var$load("cbkj0"),
    $5f3eda043488df22$var$load("9Oxgj"),
    $5f3eda043488df22$var$load("4Afgd"),
    $5f3eda043488df22$var$load("18TX5"),
    $5f3eda043488df22$var$load("lp8Wm"),
    $5f3eda043488df22$var$load("l2LZP")
]).then(()=>parcelRequire('hBKGT'));

});

parcelRegister("giCMm", function(module, exports) {

let $bddc687801e09c1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bddc687801e09c1c$var$load("cbkj0"),
    $bddc687801e09c1c$var$load("9Oxgj"),
    $bddc687801e09c1c$var$load("4Afgd"),
    $bddc687801e09c1c$var$load("18TX5"),
    $bddc687801e09c1c$var$load("lp8Wm"),
    $bddc687801e09c1c$var$load("l2LZP")
]).then(()=>parcelRequire('dGr1q'));

});

parcelRegister("7cXmg", function(module, exports) {

let $53f7b2a98fe9748f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $53f7b2a98fe9748f$var$load("cbkj0"),
    $53f7b2a98fe9748f$var$load("9Oxgj"),
    $53f7b2a98fe9748f$var$load("4Afgd"),
    $53f7b2a98fe9748f$var$load("18TX5"),
    $53f7b2a98fe9748f$var$load("lp8Wm"),
    $53f7b2a98fe9748f$var$load("l2LZP")
]).then(()=>parcelRequire('3tyT4'));

});

parcelRegister("anTn4", function(module, exports) {

let $78f700e3e9811b57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $78f700e3e9811b57$var$load("cbkj0"),
    $78f700e3e9811b57$var$load("9Oxgj"),
    $78f700e3e9811b57$var$load("4Afgd"),
    $78f700e3e9811b57$var$load("18TX5"),
    $78f700e3e9811b57$var$load("lp8Wm"),
    $78f700e3e9811b57$var$load("l2LZP")
]).then(()=>parcelRequire('3xLyL'));

});

parcelRegister("46lt6", function(module, exports) {

let $2fc8602a24bf8da8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2fc8602a24bf8da8$var$load("cbkj0"),
    $2fc8602a24bf8da8$var$load("9Oxgj"),
    $2fc8602a24bf8da8$var$load("4Afgd"),
    $2fc8602a24bf8da8$var$load("18TX5"),
    $2fc8602a24bf8da8$var$load("lp8Wm"),
    $2fc8602a24bf8da8$var$load("l2LZP")
]).then(()=>parcelRequire('6bp4T'));

});

parcelRegister("iMasR", function(module, exports) {

let $dab4d3b99cd9eb96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dab4d3b99cd9eb96$var$load("cbkj0"),
    $dab4d3b99cd9eb96$var$load("9Oxgj"),
    $dab4d3b99cd9eb96$var$load("4Afgd"),
    $dab4d3b99cd9eb96$var$load("18TX5"),
    $dab4d3b99cd9eb96$var$load("lp8Wm"),
    $dab4d3b99cd9eb96$var$load("l2LZP")
]).then(()=>parcelRequire('kMgpE'));

});

parcelRegister("9Euzu", function(module, exports) {

let $706f9059466c1933$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $706f9059466c1933$var$load("cbkj0"),
    $706f9059466c1933$var$load("9Oxgj"),
    $706f9059466c1933$var$load("4Afgd"),
    $706f9059466c1933$var$load("18TX5"),
    $706f9059466c1933$var$load("lp8Wm"),
    $706f9059466c1933$var$load("l2LZP")
]).then(()=>parcelRequire('kvGOb'));

});

parcelRegister("hs7Tn", function(module, exports) {

let $cb4b2c653fd29f9a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cb4b2c653fd29f9a$var$load("cbkj0"),
    $cb4b2c653fd29f9a$var$load("9Oxgj"),
    $cb4b2c653fd29f9a$var$load("4Afgd"),
    $cb4b2c653fd29f9a$var$load("18TX5"),
    $cb4b2c653fd29f9a$var$load("lp8Wm"),
    $cb4b2c653fd29f9a$var$load("l2LZP")
]).then(()=>parcelRequire('5lJbt'));

});

parcelRegister("34hMn", function(module, exports) {

let $23bf896b9166b817$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $23bf896b9166b817$var$load("cbkj0"),
    $23bf896b9166b817$var$load("9Oxgj"),
    $23bf896b9166b817$var$load("4Afgd"),
    $23bf896b9166b817$var$load("18TX5"),
    $23bf896b9166b817$var$load("lp8Wm"),
    $23bf896b9166b817$var$load("l2LZP")
]).then(()=>parcelRequire('7Hsr9'));

});

parcelRegister("4zoGR", function(module, exports) {

let $353d954e2feb4a3e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $353d954e2feb4a3e$var$load("cbkj0"),
    $353d954e2feb4a3e$var$load("9Oxgj"),
    $353d954e2feb4a3e$var$load("4Afgd"),
    $353d954e2feb4a3e$var$load("18TX5"),
    $353d954e2feb4a3e$var$load("lp8Wm"),
    $353d954e2feb4a3e$var$load("l2LZP")
]).then(()=>parcelRequire('lGjbe'));

});

parcelRegister("W955n", function(module, exports) {

let $0aec76327e0f4179$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0aec76327e0f4179$var$load("cbkj0"),
    $0aec76327e0f4179$var$load("9Oxgj"),
    $0aec76327e0f4179$var$load("4Afgd"),
    $0aec76327e0f4179$var$load("18TX5"),
    $0aec76327e0f4179$var$load("lp8Wm"),
    $0aec76327e0f4179$var$load("l2LZP")
]).then(()=>parcelRequire('kHEKL'));

});

parcelRegister("adyGO", function(module, exports) {

let $770606e95234f438$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $770606e95234f438$var$load("cbkj0"),
    $770606e95234f438$var$load("9Oxgj"),
    $770606e95234f438$var$load("4Afgd"),
    $770606e95234f438$var$load("18TX5"),
    $770606e95234f438$var$load("lp8Wm"),
    $770606e95234f438$var$load("l2LZP")
]).then(()=>parcelRequire('iQD66'));

});

parcelRegister("8aSXD", function(module, exports) {

let $5f39e3fbd3237212$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5f39e3fbd3237212$var$load("cbkj0"),
    $5f39e3fbd3237212$var$load("9Oxgj"),
    $5f39e3fbd3237212$var$load("4Afgd"),
    $5f39e3fbd3237212$var$load("18TX5"),
    $5f39e3fbd3237212$var$load("lp8Wm"),
    $5f39e3fbd3237212$var$load("l2LZP")
]).then(()=>parcelRequire('2RVQ2'));

});

parcelRegister("4CCNY", function(module, exports) {

let $35d8cfe2b7fd716d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $35d8cfe2b7fd716d$var$load("cbkj0"),
    $35d8cfe2b7fd716d$var$load("9Oxgj"),
    $35d8cfe2b7fd716d$var$load("4Afgd"),
    $35d8cfe2b7fd716d$var$load("18TX5"),
    $35d8cfe2b7fd716d$var$load("lp8Wm"),
    $35d8cfe2b7fd716d$var$load("l2LZP")
]).then(()=>parcelRequire('9gVqi'));

});

parcelRegister("gMXBx", function(module, exports) {

let $c38f5d3e78ecb933$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c38f5d3e78ecb933$var$load("cbkj0"),
    $c38f5d3e78ecb933$var$load("9Oxgj"),
    $c38f5d3e78ecb933$var$load("4Afgd"),
    $c38f5d3e78ecb933$var$load("18TX5"),
    $c38f5d3e78ecb933$var$load("lp8Wm"),
    $c38f5d3e78ecb933$var$load("l2LZP")
]).then(()=>parcelRequire('7RRPC'));

});

parcelRegister("iPlMM", function(module, exports) {

let $db4de39f1907209d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $db4de39f1907209d$var$load("cbkj0"),
    $db4de39f1907209d$var$load("9Oxgj"),
    $db4de39f1907209d$var$load("4Afgd"),
    $db4de39f1907209d$var$load("18TX5"),
    $db4de39f1907209d$var$load("lp8Wm"),
    $db4de39f1907209d$var$load("l2LZP")
]).then(()=>parcelRequire('c6nOz'));

});

parcelRegister("3hSLZ", function(module, exports) {

let $264d72693da56c1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $264d72693da56c1d$var$load("cbkj0"),
    $264d72693da56c1d$var$load("9Oxgj"),
    $264d72693da56c1d$var$load("4Afgd"),
    $264d72693da56c1d$var$load("18TX5"),
    $264d72693da56c1d$var$load("lp8Wm"),
    $264d72693da56c1d$var$load("l2LZP")
]).then(()=>parcelRequire('2SZ1m'));

});

parcelRegister("4N5hB", function(module, exports) {

let $37cfd614fdb89b2f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $37cfd614fdb89b2f$var$load("cbkj0"),
    $37cfd614fdb89b2f$var$load("9Oxgj"),
    $37cfd614fdb89b2f$var$load("4Afgd"),
    $37cfd614fdb89b2f$var$load("18TX5"),
    $37cfd614fdb89b2f$var$load("lp8Wm"),
    $37cfd614fdb89b2f$var$load("l2LZP")
]).then(()=>parcelRequire('7sxox'));

});

parcelRegister("6RqBf", function(module, exports) {

let $4fec53772a3a4c69$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4fec53772a3a4c69$var$load("cbkj0"),
    $4fec53772a3a4c69$var$load("9Oxgj"),
    $4fec53772a3a4c69$var$load("4Afgd"),
    $4fec53772a3a4c69$var$load("18TX5"),
    $4fec53772a3a4c69$var$load("lp8Wm"),
    $4fec53772a3a4c69$var$load("l2LZP")
]).then(()=>parcelRequire('a53wY'));

});

parcelRegister("1mcMr", function(module, exports) {

let $0fd1c269809f3594$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0fd1c269809f3594$var$load("cbkj0"),
    $0fd1c269809f3594$var$load("9Oxgj"),
    $0fd1c269809f3594$var$load("4Afgd"),
    $0fd1c269809f3594$var$load("18TX5"),
    $0fd1c269809f3594$var$load("lp8Wm"),
    $0fd1c269809f3594$var$load("l2LZP")
]).then(()=>parcelRequire('8hf0W'));

});

parcelRegister("3tUrN", function(module, exports) {

let $288fddcb1ba3ca10$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $288fddcb1ba3ca10$var$load("cbkj0"),
    $288fddcb1ba3ca10$var$load("9Oxgj"),
    $288fddcb1ba3ca10$var$load("4Afgd"),
    $288fddcb1ba3ca10$var$load("18TX5"),
    $288fddcb1ba3ca10$var$load("lp8Wm"),
    $288fddcb1ba3ca10$var$load("l2LZP")
]).then(()=>parcelRequire('iiPbX'));

});

parcelRegister("3WvZO", function(module, exports) {

let $2def9ba08a3eebb7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2def9ba08a3eebb7$var$load("cbkj0"),
    $2def9ba08a3eebb7$var$load("9Oxgj"),
    $2def9ba08a3eebb7$var$load("4Afgd"),
    $2def9ba08a3eebb7$var$load("18TX5"),
    $2def9ba08a3eebb7$var$load("lp8Wm"),
    $2def9ba08a3eebb7$var$load("l2LZP")
]).then(()=>parcelRequire('ghn9b'));

});

parcelRegister("eNqGF", function(module, exports) {

let $ac5a57cb75bd68eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ac5a57cb75bd68eb$var$load("cbkj0"),
    $ac5a57cb75bd68eb$var$load("9Oxgj"),
    $ac5a57cb75bd68eb$var$load("4Afgd"),
    $ac5a57cb75bd68eb$var$load("18TX5"),
    $ac5a57cb75bd68eb$var$load("lp8Wm"),
    $ac5a57cb75bd68eb$var$load("l2LZP")
]).then(()=>parcelRequire('e150h'));

});

parcelRegister("giq8v", function(module, exports) {

let $bdd299deab137fd5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bdd299deab137fd5$var$load("cbkj0"),
    $bdd299deab137fd5$var$load("9Oxgj"),
    $bdd299deab137fd5$var$load("4Afgd"),
    $bdd299deab137fd5$var$load("18TX5"),
    $bdd299deab137fd5$var$load("lp8Wm"),
    $bdd299deab137fd5$var$load("l2LZP")
]).then(()=>parcelRequire('ggDJR'));

});

parcelRegister("5qNyO", function(module, exports) {

let $3f45d31d1f6a13e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f45d31d1f6a13e4$var$load("cbkj0"),
    $3f45d31d1f6a13e4$var$load("9Oxgj"),
    $3f45d31d1f6a13e4$var$load("4Afgd"),
    $3f45d31d1f6a13e4$var$load("18TX5"),
    $3f45d31d1f6a13e4$var$load("lp8Wm"),
    $3f45d31d1f6a13e4$var$load("l2LZP")
]).then(()=>parcelRequire('WRCcY'));

});

parcelRegister("7y9ZQ", function(module, exports) {

let $57f37676359f0850$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $57f37676359f0850$var$load("cbkj0"),
    $57f37676359f0850$var$load("9Oxgj"),
    $57f37676359f0850$var$load("4Afgd"),
    $57f37676359f0850$var$load("18TX5"),
    $57f37676359f0850$var$load("lp8Wm"),
    $57f37676359f0850$var$load("l2LZP")
]).then(()=>parcelRequire('gfrgP'));

});

parcelRegister("lbsop", function(module, exports) {

let $f6c0a63a660cc0c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f6c0a63a660cc0c1$var$load("cbkj0"),
    $f6c0a63a660cc0c1$var$load("9Oxgj"),
    $f6c0a63a660cc0c1$var$load("4Afgd"),
    $f6c0a63a660cc0c1$var$load("18TX5"),
    $f6c0a63a660cc0c1$var$load("lp8Wm"),
    $f6c0a63a660cc0c1$var$load("l2LZP")
]).then(()=>parcelRequire('4l1gQ'));

});

parcelRegister("1mUUj", function(module, exports) {

let $0ff3fd1ad907f98f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0ff3fd1ad907f98f$var$load("cbkj0"),
    $0ff3fd1ad907f98f$var$load("9Oxgj"),
    $0ff3fd1ad907f98f$var$load("4Afgd"),
    $0ff3fd1ad907f98f$var$load("18TX5"),
    $0ff3fd1ad907f98f$var$load("lp8Wm"),
    $0ff3fd1ad907f98f$var$load("l2LZP")
]).then(()=>parcelRequire('gZbvu'));

});

parcelRegister("6OSOg", function(module, exports) {

let $4f71edabebbcd553$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f71edabebbcd553$var$load("cbkj0"),
    $4f71edabebbcd553$var$load("9Oxgj"),
    $4f71edabebbcd553$var$load("4Afgd"),
    $4f71edabebbcd553$var$load("18TX5"),
    $4f71edabebbcd553$var$load("lp8Wm"),
    $4f71edabebbcd553$var$load("l2LZP")
]).then(()=>parcelRequire('9GSdj'));

});

parcelRegister("8LsJU", function(module, exports) {

let $66190198206e2120$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $66190198206e2120$var$load("cbkj0"),
    $66190198206e2120$var$load("9Oxgj"),
    $66190198206e2120$var$load("4Afgd"),
    $66190198206e2120$var$load("18TX5"),
    $66190198206e2120$var$load("lp8Wm"),
    $66190198206e2120$var$load("l2LZP")
]).then(()=>parcelRequire('95YIE'));

});

parcelRegister("d3d3B", function(module, exports) {

let $9805af068d6bd396$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9805af068d6bd396$var$load("cbkj0"),
    $9805af068d6bd396$var$load("9Oxgj"),
    $9805af068d6bd396$var$load("4Afgd"),
    $9805af068d6bd396$var$load("18TX5"),
    $9805af068d6bd396$var$load("lp8Wm"),
    $9805af068d6bd396$var$load("l2LZP")
]).then(()=>parcelRequire('kg2U2'));

});

parcelRegister("6jDDp", function(module, exports) {

let $4993430edcb085cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4993430edcb085cc$var$load("cbkj0"),
    $4993430edcb085cc$var$load("9Oxgj"),
    $4993430edcb085cc$var$load("4Afgd"),
    $4993430edcb085cc$var$load("18TX5"),
    $4993430edcb085cc$var$load("lp8Wm"),
    $4993430edcb085cc$var$load("l2LZP")
]).then(()=>parcelRequire('j7Qlq'));

});

parcelRegister("7rsL3", function(module, exports) {

let $56b15cc5adc3aebf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $56b15cc5adc3aebf$var$load("cbkj0"),
    $56b15cc5adc3aebf$var$load("9Oxgj"),
    $56b15cc5adc3aebf$var$load("4Afgd"),
    $56b15cc5adc3aebf$var$load("18TX5"),
    $56b15cc5adc3aebf$var$load("lp8Wm"),
    $56b15cc5adc3aebf$var$load("l2LZP")
]).then(()=>parcelRequire('evDud'));

});

parcelRegister("8J2b3", function(module, exports) {

let $65a437159bc1b460$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $65a437159bc1b460$var$load("cbkj0"),
    $65a437159bc1b460$var$load("9Oxgj"),
    $65a437159bc1b460$var$load("4Afgd"),
    $65a437159bc1b460$var$load("18TX5"),
    $65a437159bc1b460$var$load("lp8Wm"),
    $65a437159bc1b460$var$load("l2LZP")
]).then(()=>parcelRequire('g7b3W'));

});

parcelRegister("k8YM1", function(module, exports) {

let $eaa3b25b758b6145$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eaa3b25b758b6145$var$load("cbkj0"),
    $eaa3b25b758b6145$var$load("9Oxgj"),
    $eaa3b25b758b6145$var$load("4Afgd"),
    $eaa3b25b758b6145$var$load("18TX5"),
    $eaa3b25b758b6145$var$load("lp8Wm"),
    $eaa3b25b758b6145$var$load("l2LZP")
]).then(()=>parcelRequire('bB2xa'));

});

parcelRegister("04pAv", function(module, exports) {

let $00d43910f7a3fd9d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $00d43910f7a3fd9d$var$load("cbkj0"),
    $00d43910f7a3fd9d$var$load("9Oxgj"),
    $00d43910f7a3fd9d$var$load("4Afgd"),
    $00d43910f7a3fd9d$var$load("18TX5"),
    $00d43910f7a3fd9d$var$load("lp8Wm"),
    $00d43910f7a3fd9d$var$load("l2LZP")
]).then(()=>parcelRequire('dFJde'));

});

parcelRegister("h4UaP", function(module, exports) {

let $c6ee624818e27b54$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c6ee624818e27b54$var$load("b4NO6"),
    $c6ee624818e27b54$var$load("fM2oh"),
    $c6ee624818e27b54$var$load("3fLE9"),
    $c6ee624818e27b54$var$load("guNAg"),
    $c6ee624818e27b54$var$load("b37xN"),
    $c6ee624818e27b54$var$load("ik6u5")
]).then(()=>parcelRequire('iy7L3'));

});

parcelRegister("3vp2D", function(module, exports) {

let $28d7b1123af7d60b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $28d7b1123af7d60b$var$load("b4NO6"),
    $28d7b1123af7d60b$var$load("fM2oh"),
    $28d7b1123af7d60b$var$load("3fLE9"),
    $28d7b1123af7d60b$var$load("guNAg"),
    $28d7b1123af7d60b$var$load("b37xN"),
    $28d7b1123af7d60b$var$load("ik6u5")
]).then(()=>parcelRequire('1a3n4'));

});

parcelRegister("3kTSZ", function(module, exports) {

let $26de972393ab99c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $26de972393ab99c3$var$load("b4NO6"),
    $26de972393ab99c3$var$load("fM2oh"),
    $26de972393ab99c3$var$load("3fLE9"),
    $26de972393ab99c3$var$load("guNAg"),
    $26de972393ab99c3$var$load("b37xN"),
    $26de972393ab99c3$var$load("ik6u5")
]).then(()=>parcelRequire('bgYxE'));

});

parcelRegister("3pojl", function(module, exports) {

let $27b6908e6f3865ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $27b6908e6f3865ae$var$load("b4NO6"),
    $27b6908e6f3865ae$var$load("fM2oh"),
    $27b6908e6f3865ae$var$load("3fLE9"),
    $27b6908e6f3865ae$var$load("guNAg"),
    $27b6908e6f3865ae$var$load("b37xN"),
    $27b6908e6f3865ae$var$load("ik6u5")
]).then(()=>parcelRequire('8QBWd'));

});

parcelRegister("12Fd8", function(module, exports) {

let $0c25f1fae1e33601$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0c25f1fae1e33601$var$load("b4NO6"),
    $0c25f1fae1e33601$var$load("fM2oh"),
    $0c25f1fae1e33601$var$load("3fLE9"),
    $0c25f1fae1e33601$var$load("guNAg"),
    $0c25f1fae1e33601$var$load("b37xN"),
    $0c25f1fae1e33601$var$load("ik6u5")
]).then(()=>parcelRequire('alG1N'));

});

parcelRegister("8Qd1R", function(module, exports) {

let $66fd4953cc88b149$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $66fd4953cc88b149$var$load("b4NO6"),
    $66fd4953cc88b149$var$load("fM2oh"),
    $66fd4953cc88b149$var$load("3fLE9"),
    $66fd4953cc88b149$var$load("guNAg"),
    $66fd4953cc88b149$var$load("b37xN"),
    $66fd4953cc88b149$var$load("ik6u5")
]).then(()=>parcelRequire('dsU2O'));

});

parcelRegister("g4xdF", function(module, exports) {

let $bb36c9bb855f9da4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bb36c9bb855f9da4$var$load("b4NO6"),
    $bb36c9bb855f9da4$var$load("fM2oh"),
    $bb36c9bb855f9da4$var$load("3fLE9"),
    $bb36c9bb855f9da4$var$load("guNAg"),
    $bb36c9bb855f9da4$var$load("b37xN"),
    $bb36c9bb855f9da4$var$load("ik6u5")
]).then(()=>parcelRequire('9AIXr'));

});

parcelRegister("dGum9", function(module, exports) {

let $9f66beb49bfeaa07$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9f66beb49bfeaa07$var$load("b4NO6"),
    $9f66beb49bfeaa07$var$load("fM2oh"),
    $9f66beb49bfeaa07$var$load("3fLE9"),
    $9f66beb49bfeaa07$var$load("guNAg"),
    $9f66beb49bfeaa07$var$load("b37xN"),
    $9f66beb49bfeaa07$var$load("ik6u5")
]).then(()=>parcelRequire('bVNwo'));

});

parcelRegister("3mnOL", function(module, exports) {

let $2725e6e01246ab50$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2725e6e01246ab50$var$load("b4NO6"),
    $2725e6e01246ab50$var$load("fM2oh"),
    $2725e6e01246ab50$var$load("3fLE9"),
    $2725e6e01246ab50$var$load("guNAg"),
    $2725e6e01246ab50$var$load("b37xN"),
    $2725e6e01246ab50$var$load("ik6u5")
]).then(()=>parcelRequire('tPMRe'));

});

parcelRegister("3pTic", function(module, exports) {

let $27ce98dd2a6dbbc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $27ce98dd2a6dbbc2$var$load("b4NO6"),
    $27ce98dd2a6dbbc2$var$load("fM2oh"),
    $27ce98dd2a6dbbc2$var$load("3fLE9"),
    $27ce98dd2a6dbbc2$var$load("guNAg"),
    $27ce98dd2a6dbbc2$var$load("b37xN"),
    $27ce98dd2a6dbbc2$var$load("ik6u5")
]).then(()=>parcelRequire('jgi8A'));

});

parcelRegister("gVlep", function(module, exports) {

let $c522704e93c473bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c522704e93c473bb$var$load("b4NO6"),
    $c522704e93c473bb$var$load("fM2oh"),
    $c522704e93c473bb$var$load("3fLE9"),
    $c522704e93c473bb$var$load("guNAg"),
    $c522704e93c473bb$var$load("b37xN"),
    $c522704e93c473bb$var$load("ik6u5")
]).then(()=>parcelRequire('6sVCc'));

});

parcelRegister("4Wv3d", function(module, exports) {

let $3994aa47083293d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3994aa47083293d6$var$load("b4NO6"),
    $3994aa47083293d6$var$load("fM2oh"),
    $3994aa47083293d6$var$load("3fLE9"),
    $3994aa47083293d6$var$load("guNAg"),
    $3994aa47083293d6$var$load("b37xN"),
    $3994aa47083293d6$var$load("ik6u5")
]).then(()=>parcelRequire('3HHVh'));

});

parcelRegister("lre2p", function(module, exports) {

let $f9b702370d5b15dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f9b702370d5b15dd$var$load("b4NO6"),
    $f9b702370d5b15dd$var$load("fM2oh"),
    $f9b702370d5b15dd$var$load("3fLE9"),
    $f9b702370d5b15dd$var$load("guNAg"),
    $f9b702370d5b15dd$var$load("b37xN"),
    $f9b702370d5b15dd$var$load("ik6u5")
]).then(()=>parcelRequire('iUnd5'));

});

parcelRegister("fbTYr", function(module, exports) {

let $b0f34d50f6c5c9af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b0f34d50f6c5c9af$var$load("b4NO6"),
    $b0f34d50f6c5c9af$var$load("fM2oh"),
    $b0f34d50f6c5c9af$var$load("3fLE9"),
    $b0f34d50f6c5c9af$var$load("guNAg"),
    $b0f34d50f6c5c9af$var$load("b37xN"),
    $b0f34d50f6c5c9af$var$load("ik6u5")
]).then(()=>parcelRequire('dQsky'));

});

parcelRegister("ehB6l", function(module, exports) {

let $a65f6ec493f46bf2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a65f6ec493f46bf2$var$load("b4NO6"),
    $a65f6ec493f46bf2$var$load("fM2oh"),
    $a65f6ec493f46bf2$var$load("3fLE9"),
    $a65f6ec493f46bf2$var$load("guNAg"),
    $a65f6ec493f46bf2$var$load("b37xN"),
    $a65f6ec493f46bf2$var$load("ik6u5")
]).then(()=>parcelRequire('dQnsk'));

});

parcelRegister("fgWDV", function(module, exports) {

let $b1e5d6e66dd3940d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b1e5d6e66dd3940d$var$load("b4NO6"),
    $b1e5d6e66dd3940d$var$load("fM2oh"),
    $b1e5d6e66dd3940d$var$load("3fLE9"),
    $b1e5d6e66dd3940d$var$load("guNAg"),
    $b1e5d6e66dd3940d$var$load("b37xN"),
    $b1e5d6e66dd3940d$var$load("ik6u5")
]).then(()=>parcelRequire('fzCrs'));

});

parcelRegister("lNCBE", function(module, exports) {

let $fdec1efd68c53548$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fdec1efd68c53548$var$load("b4NO6"),
    $fdec1efd68c53548$var$load("fM2oh"),
    $fdec1efd68c53548$var$load("3fLE9"),
    $fdec1efd68c53548$var$load("guNAg"),
    $fdec1efd68c53548$var$load("b37xN"),
    $fdec1efd68c53548$var$load("ik6u5")
]).then(()=>parcelRequire('60sfA'));

});

parcelRegister("cBy0t", function(module, exports) {

let $92d351bb1ab0370b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $92d351bb1ab0370b$var$load("b4NO6"),
    $92d351bb1ab0370b$var$load("fM2oh"),
    $92d351bb1ab0370b$var$load("3fLE9"),
    $92d351bb1ab0370b$var$load("guNAg"),
    $92d351bb1ab0370b$var$load("b37xN"),
    $92d351bb1ab0370b$var$load("ik6u5")
]).then(()=>parcelRequire('hZrdz'));

});

parcelRegister("gavcE", function(module, exports) {

let $bc55c8c85d3d53f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bc55c8c85d3d53f8$var$load("b4NO6"),
    $bc55c8c85d3d53f8$var$load("fM2oh"),
    $bc55c8c85d3d53f8$var$load("3fLE9"),
    $bc55c8c85d3d53f8$var$load("guNAg"),
    $bc55c8c85d3d53f8$var$load("b37xN"),
    $bc55c8c85d3d53f8$var$load("ik6u5")
]).then(()=>parcelRequire('4NJ4u'));

});

parcelRegister("72TUS", function(module, exports) {

let $5214181f925acf8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5214181f925acf8a$var$load("b4NO6"),
    $5214181f925acf8a$var$load("fM2oh"),
    $5214181f925acf8a$var$load("3fLE9"),
    $5214181f925acf8a$var$load("guNAg"),
    $5214181f925acf8a$var$load("b37xN"),
    $5214181f925acf8a$var$load("ik6u5")
]).then(()=>parcelRequire('dMw6u'));

});

parcelRegister("lX7ZB", function(module, exports) {

let $ffb54ed8d16f18fb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ffb54ed8d16f18fb$var$load("b4NO6"),
    $ffb54ed8d16f18fb$var$load("fM2oh"),
    $ffb54ed8d16f18fb$var$load("3fLE9"),
    $ffb54ed8d16f18fb$var$load("guNAg"),
    $ffb54ed8d16f18fb$var$load("b37xN"),
    $ffb54ed8d16f18fb$var$load("ik6u5")
]).then(()=>parcelRequire('firDj'));

});

parcelRegister("44MZj", function(module, exports) {

let $2f7d891ccabc3e58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2f7d891ccabc3e58$var$load("b4NO6"),
    $2f7d891ccabc3e58$var$load("fM2oh"),
    $2f7d891ccabc3e58$var$load("3fLE9"),
    $2f7d891ccabc3e58$var$load("guNAg"),
    $2f7d891ccabc3e58$var$load("b37xN"),
    $2f7d891ccabc3e58$var$load("ik6u5")
]).then(()=>parcelRequire('e8GqL'));

});

parcelRegister("kiL6P", function(module, exports) {

let $ec7a07f823b50ff0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ec7a07f823b50ff0$var$load("b4NO6"),
    $ec7a07f823b50ff0$var$load("fM2oh"),
    $ec7a07f823b50ff0$var$load("3fLE9"),
    $ec7a07f823b50ff0$var$load("guNAg"),
    $ec7a07f823b50ff0$var$load("b37xN"),
    $ec7a07f823b50ff0$var$load("ik6u5")
]).then(()=>parcelRequire('9EZ51'));

});

parcelRegister("57Xmt", function(module, exports) {

let $3bbba72803ded46b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3bbba72803ded46b$var$load("b4NO6"),
    $3bbba72803ded46b$var$load("fM2oh"),
    $3bbba72803ded46b$var$load("3fLE9"),
    $3bbba72803ded46b$var$load("guNAg"),
    $3bbba72803ded46b$var$load("b37xN"),
    $3bbba72803ded46b$var$load("ik6u5")
]).then(()=>parcelRequire('i9Una'));

});

parcelRegister("kOAsS", function(module, exports) {

let $f274c34c71125602$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f274c34c71125602$var$load("b4NO6"),
    $f274c34c71125602$var$load("fM2oh"),
    $f274c34c71125602$var$load("3fLE9"),
    $f274c34c71125602$var$load("guNAg"),
    $f274c34c71125602$var$load("b37xN"),
    $f274c34c71125602$var$load("ik6u5")
]).then(()=>parcelRequire('b3bIy'));

});

parcelRegister("22175", function(module, exports) {

let $17aca1bf4e30e877$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $17aca1bf4e30e877$var$load("b4NO6"),
    $17aca1bf4e30e877$var$load("fM2oh"),
    $17aca1bf4e30e877$var$load("3fLE9"),
    $17aca1bf4e30e877$var$load("guNAg"),
    $17aca1bf4e30e877$var$load("b37xN"),
    $17aca1bf4e30e877$var$load("ik6u5")
]).then(()=>parcelRequire('dl4D4'));

});

parcelRegister("5VTGq", function(module, exports) {

let $451d7828476782ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $451d7828476782ce$var$load("b4NO6"),
    $451d7828476782ce$var$load("fM2oh"),
    $451d7828476782ce$var$load("3fLE9"),
    $451d7828476782ce$var$load("guNAg"),
    $451d7828476782ce$var$load("b37xN"),
    $451d7828476782ce$var$load("ik6u5")
]).then(()=>parcelRequire('lrok6'));

});

parcelRegister("kblFP", function(module, exports) {

let $eb15a5ad44ee44eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eb15a5ad44ee44eb$var$load("b4NO6"),
    $eb15a5ad44ee44eb$var$load("fM2oh"),
    $eb15a5ad44ee44eb$var$load("3fLE9"),
    $eb15a5ad44ee44eb$var$load("guNAg"),
    $eb15a5ad44ee44eb$var$load("b37xN"),
    $eb15a5ad44ee44eb$var$load("ik6u5")
]).then(()=>parcelRequire('5ujNp'));

});

parcelRegister("1pViZ", function(module, exports) {

let $108493e4aa258ded$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $108493e4aa258ded$var$load("b4NO6"),
    $108493e4aa258ded$var$load("fM2oh"),
    $108493e4aa258ded$var$load("3fLE9"),
    $108493e4aa258ded$var$load("guNAg"),
    $108493e4aa258ded$var$load("b37xN"),
    $108493e4aa258ded$var$load("ik6u5")
]).then(()=>parcelRequire('7p0Te'));

});

parcelRegister("6kIEp", function(module, exports) {

let $49c73f0c4bb0e869$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $49c73f0c4bb0e869$var$load("b4NO6"),
    $49c73f0c4bb0e869$var$load("fM2oh"),
    $49c73f0c4bb0e869$var$load("3fLE9"),
    $49c73f0c4bb0e869$var$load("guNAg"),
    $49c73f0c4bb0e869$var$load("b37xN"),
    $49c73f0c4bb0e869$var$load("ik6u5")
]).then(()=>parcelRequire('7FBUF'));

});

parcelRegister("fQ8ub", function(module, exports) {

let $b8824b74a09a85fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b8824b74a09a85fa$var$load("b4NO6"),
    $b8824b74a09a85fa$var$load("fM2oh"),
    $b8824b74a09a85fa$var$load("3fLE9"),
    $b8824b74a09a85fa$var$load("guNAg"),
    $b8824b74a09a85fa$var$load("b37xN"),
    $b8824b74a09a85fa$var$load("ik6u5")
]).then(()=>parcelRequire('6jzpP'));

});

parcelRegister("2sNKf", function(module, exports) {

let $1cb4c8970de0b04b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1cb4c8970de0b04b$var$load("b4NO6"),
    $1cb4c8970de0b04b$var$load("fM2oh"),
    $1cb4c8970de0b04b$var$load("3fLE9"),
    $1cb4c8970de0b04b$var$load("guNAg"),
    $1cb4c8970de0b04b$var$load("b37xN"),
    $1cb4c8970de0b04b$var$load("ik6u5")
]).then(()=>parcelRequire('8HYOT'));

});

parcelRegister("fBE45", function(module, exports) {

let $b5c963c75203e37a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b5c963c75203e37a$var$load("b4NO6"),
    $b5c963c75203e37a$var$load("fM2oh"),
    $b5c963c75203e37a$var$load("3fLE9"),
    $b5c963c75203e37a$var$load("guNAg"),
    $b5c963c75203e37a$var$load("b37xN"),
    $b5c963c75203e37a$var$load("ik6u5")
]).then(()=>parcelRequire('h4uvl'));

});

parcelRegister("cigct", function(module, exports) {

let $8f33bb7d08140b3f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8f33bb7d08140b3f$var$load("b4NO6"),
    $8f33bb7d08140b3f$var$load("fM2oh"),
    $8f33bb7d08140b3f$var$load("3fLE9"),
    $8f33bb7d08140b3f$var$load("guNAg"),
    $8f33bb7d08140b3f$var$load("b37xN"),
    $8f33bb7d08140b3f$var$load("ik6u5")
]).then(()=>parcelRequire('5aOLq'));

});

parcelRegister("azU1D", function(module, exports) {

let $7b38a1c2a9cfa53f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7b38a1c2a9cfa53f$var$load("b4NO6"),
    $7b38a1c2a9cfa53f$var$load("fM2oh"),
    $7b38a1c2a9cfa53f$var$load("3fLE9"),
    $7b38a1c2a9cfa53f$var$load("guNAg"),
    $7b38a1c2a9cfa53f$var$load("b37xN"),
    $7b38a1c2a9cfa53f$var$load("ik6u5")
]).then(()=>parcelRequire('78JR2'));

});

parcelRegister("042s4", function(module, exports) {

let $00c246affc98605d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $00c246affc98605d$var$load("b4NO6"),
    $00c246affc98605d$var$load("fM2oh"),
    $00c246affc98605d$var$load("3fLE9"),
    $00c246affc98605d$var$load("guNAg"),
    $00c246affc98605d$var$load("b37xN"),
    $00c246affc98605d$var$load("ik6u5")
]).then(()=>parcelRequire('k5UMG'));

});

parcelRegister("7SOfW", function(module, exports) {

let $5bd48f64a2f02945$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5bd48f64a2f02945$var$load("b4NO6"),
    $5bd48f64a2f02945$var$load("fM2oh"),
    $5bd48f64a2f02945$var$load("3fLE9"),
    $5bd48f64a2f02945$var$load("guNAg"),
    $5bd48f64a2f02945$var$load("b37xN"),
    $5bd48f64a2f02945$var$load("ik6u5")
]).then(()=>parcelRequire('3nfCl'));

});

parcelRegister("ahVuR", function(module, exports) {

let $77d81794eb5110e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $77d81794eb5110e0$var$load("b4NO6"),
    $77d81794eb5110e0$var$load("fM2oh"),
    $77d81794eb5110e0$var$load("3fLE9"),
    $77d81794eb5110e0$var$load("guNAg"),
    $77d81794eb5110e0$var$load("b37xN"),
    $77d81794eb5110e0$var$load("ik6u5")
]).then(()=>parcelRequire('3xm6B'));

});

parcelRegister("5on6f", function(module, exports) {

let $3ed11cc04dbffbfa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3ed11cc04dbffbfa$var$load("b4NO6"),
    $3ed11cc04dbffbfa$var$load("fM2oh"),
    $3ed11cc04dbffbfa$var$load("3fLE9"),
    $3ed11cc04dbffbfa$var$load("guNAg"),
    $3ed11cc04dbffbfa$var$load("b37xN"),
    $3ed11cc04dbffbfa$var$load("ik6u5")
]).then(()=>parcelRequire('jwVfB'));

});

parcelRegister("kZd4d", function(module, exports) {

let $f473a3ff62d5f08a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f473a3ff62d5f08a$var$load("b4NO6"),
    $f473a3ff62d5f08a$var$load("fM2oh"),
    $f473a3ff62d5f08a$var$load("3fLE9"),
    $f473a3ff62d5f08a$var$load("guNAg"),
    $f473a3ff62d5f08a$var$load("b37xN"),
    $f473a3ff62d5f08a$var$load("ik6u5")
]).then(()=>parcelRequire('56nbu'));

});

parcelRegister("29xop", function(module, exports) {

let $1916531c59851c08$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1916531c59851c08$var$load("b4NO6"),
    $1916531c59851c08$var$load("fM2oh"),
    $1916531c59851c08$var$load("3fLE9"),
    $1916531c59851c08$var$load("guNAg"),
    $1916531c59851c08$var$load("b37xN"),
    $1916531c59851c08$var$load("ik6u5")
]).then(()=>parcelRequire('bq2TL'));

});

parcelRegister("8m0jZ", function(module, exports) {

let $6150a09d7d96063d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6150a09d7d96063d$var$load("b4NO6"),
    $6150a09d7d96063d$var$load("fM2oh"),
    $6150a09d7d96063d$var$load("3fLE9"),
    $6150a09d7d96063d$var$load("guNAg"),
    $6150a09d7d96063d$var$load("b37xN"),
    $6150a09d7d96063d$var$load("ik6u5")
]).then(()=>parcelRequire('8971y'));

});

parcelRegister("lyu5f", function(module, exports) {

let $fb141bec364ce109$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fb141bec364ce109$var$load("b4NO6"),
    $fb141bec364ce109$var$load("fM2oh"),
    $fb141bec364ce109$var$load("3fLE9"),
    $fb141bec364ce109$var$load("guNAg"),
    $fb141bec364ce109$var$load("b37xN"),
    $fb141bec364ce109$var$load("ik6u5")
]).then(()=>parcelRequire('2mqgo'));

});

parcelRegister("furZw", function(module, exports) {

let $b46f5edb5c010d55$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b46f5edb5c010d55$var$load("b4NO6"),
    $b46f5edb5c010d55$var$load("fM2oh"),
    $b46f5edb5c010d55$var$load("3fLE9"),
    $b46f5edb5c010d55$var$load("guNAg"),
    $b46f5edb5c010d55$var$load("b37xN"),
    $b46f5edb5c010d55$var$load("ik6u5")
]).then(()=>parcelRequire('4yfXi'));

});

parcelRegister("6HUYI", function(module, exports) {

let $4e22f4ead8c57cc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e22f4ead8c57cc8$var$load("b4NO6"),
    $4e22f4ead8c57cc8$var$load("fM2oh"),
    $4e22f4ead8c57cc8$var$load("3fLE9"),
    $4e22f4ead8c57cc8$var$load("guNAg"),
    $4e22f4ead8c57cc8$var$load("b37xN"),
    $4e22f4ead8c57cc8$var$load("ik6u5")
]).then(()=>parcelRequire('ch8XN'));

});

parcelRegister("eFDCy", function(module, exports) {

let $aae3a0df7bd80e94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aae3a0df7bd80e94$var$load("b4NO6"),
    $aae3a0df7bd80e94$var$load("fM2oh"),
    $aae3a0df7bd80e94$var$load("3fLE9"),
    $aae3a0df7bd80e94$var$load("guNAg"),
    $aae3a0df7bd80e94$var$load("b37xN"),
    $aae3a0df7bd80e94$var$load("ik6u5")
]).then(()=>parcelRequire('21Ywh'));

});

parcelRegister("k3Mc5", function(module, exports) {

let $e9a978c0158fc540$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e9a978c0158fc540$var$load("b4NO6"),
    $e9a978c0158fc540$var$load("fM2oh"),
    $e9a978c0158fc540$var$load("3fLE9"),
    $e9a978c0158fc540$var$load("guNAg"),
    $e9a978c0158fc540$var$load("b37xN"),
    $e9a978c0158fc540$var$load("ik6u5")
]).then(()=>parcelRequire('h9NzE'));

});

parcelRegister("5WCJp", function(module, exports) {

let $454069c71d584254$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $454069c71d584254$var$load("b4NO6"),
    $454069c71d584254$var$load("fM2oh"),
    $454069c71d584254$var$load("3fLE9"),
    $454069c71d584254$var$load("guNAg"),
    $454069c71d584254$var$load("b37xN"),
    $454069c71d584254$var$load("ik6u5")
]).then(()=>parcelRequire('jTBBc'));

});

parcelRegister("lbRE3", function(module, exports) {

let $f6d43cdbb173d7c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f6d43cdbb173d7c2$var$load("b4NO6"),
    $f6d43cdbb173d7c2$var$load("fM2oh"),
    $f6d43cdbb173d7c2$var$load("3fLE9"),
    $f6d43cdbb173d7c2$var$load("guNAg"),
    $f6d43cdbb173d7c2$var$load("b37xN"),
    $f6d43cdbb173d7c2$var$load("ik6u5")
]).then(()=>parcelRequire('bjRaQ'));

});

parcelRegister("ilYgv", function(module, exports) {

let $d5c8ef97cd11cbb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d5c8ef97cd11cbb9$var$load("b4NO6"),
    $d5c8ef97cd11cbb9$var$load("fM2oh"),
    $d5c8ef97cd11cbb9$var$load("3fLE9"),
    $d5c8ef97cd11cbb9$var$load("guNAg"),
    $d5c8ef97cd11cbb9$var$load("b37xN"),
    $d5c8ef97cd11cbb9$var$load("ik6u5")
]).then(()=>parcelRequire('joTiT'));

});

parcelRegister("8XMSq", function(module, exports) {

let $6869bf54bbb0b690$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6869bf54bbb0b690$var$load("fModo").then(()=>parcelRequire('gptiB'));

});

parcelRegister("dJ6Pi", function(module, exports) {

let $9fe4c5e3bbeeb3c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9fe4c5e3bbeeb3c3$var$load("fModo").then(()=>parcelRequire('lQyzT'));

});

parcelRegister("lUn5i", function(module, exports) {

let $ff30bc0b6c13576f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ff30bc0b6c13576f$var$load("fModo").then(()=>parcelRequire('3Uagz'));

});

parcelRegister("8e7x9", function(module, exports) {

let $5fd579910606d9cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5fd579910606d9cc$var$load("fModo").then(()=>parcelRequire('02tsy'));

});

parcelRegister("6WBDv", function(module, exports) {

let $50e55a9c41508cf6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $50e55a9c41508cf6$var$load("fModo").then(()=>parcelRequire('3TUMy'));

});

parcelRegister("lxOk8", function(module, exports) {

let $faf3b74b78566057$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $faf3b74b78566057$var$load("fModo").then(()=>parcelRequire('1rOkd'));

});

parcelRegister("UR9zx", function(module, exports) {

let $0aae763bb67b9dd3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0aae763bb67b9dd3$var$load("fModo").then(()=>parcelRequire('6V5d9'));

});

parcelRegister("ahHe3", function(module, exports) {

let $77cd059eaa2b082a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $77cd059eaa2b082a$var$load("1K1Fj"),
    $77cd059eaa2b082a$var$load("xnqy2"),
    $77cd059eaa2b082a$var$load("8hOn0"),
    $77cd059eaa2b082a$var$load("cM3gY"),
    $77cd059eaa2b082a$var$load("7PjNK"),
    $77cd059eaa2b082a$var$load("Vt6S9")
]).then(()=>parcelRequire('1kxh5'));

});

parcelRegister("6lwg0", function(module, exports) {

let $49edb9dd33c58b5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $49edb9dd33c58b5b$var$load("1K1Fj"),
    $49edb9dd33c58b5b$var$load("xnqy2"),
    $49edb9dd33c58b5b$var$load("8hOn0"),
    $49edb9dd33c58b5b$var$load("cM3gY"),
    $49edb9dd33c58b5b$var$load("7PjNK"),
    $49edb9dd33c58b5b$var$load("Vt6S9")
]).then(()=>parcelRequire('9TMai'));

});

parcelRegister("9SUaK", function(module, exports) {

let $7324bad9a84a8d15$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7324bad9a84a8d15$var$load("1K1Fj"),
    $7324bad9a84a8d15$var$load("xnqy2"),
    $7324bad9a84a8d15$var$load("8hOn0"),
    $7324bad9a84a8d15$var$load("cM3gY"),
    $7324bad9a84a8d15$var$load("7PjNK"),
    $7324bad9a84a8d15$var$load("Vt6S9")
]).then(()=>parcelRequire('eqHnL'));

});

parcelRegister("efE2E", function(module, exports) {

let $a60186e35260e625$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a60186e35260e625$var$load("1K1Fj"),
    $a60186e35260e625$var$load("xnqy2"),
    $a60186e35260e625$var$load("8hOn0"),
    $a60186e35260e625$var$load("cM3gY"),
    $a60186e35260e625$var$load("7PjNK"),
    $a60186e35260e625$var$load("Vt6S9")
]).then(()=>parcelRequire('eMqDh'));

});

parcelRegister("4E3Th", function(module, exports) {

let $361dea6d6188d6ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $361dea6d6188d6ba$var$load("1K1Fj"),
    $361dea6d6188d6ba$var$load("xnqy2"),
    $361dea6d6188d6ba$var$load("8hOn0"),
    $361dea6d6188d6ba$var$load("cM3gY"),
    $361dea6d6188d6ba$var$load("7PjNK"),
    $361dea6d6188d6ba$var$load("Vt6S9")
]).then(()=>parcelRequire('gSUUF'));

});

parcelRegister("4Qs4Q", function(module, exports) {

let $3871cc4521fa53f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3871cc4521fa53f6$var$load("1K1Fj"),
    $3871cc4521fa53f6$var$load("xnqy2"),
    $3871cc4521fa53f6$var$load("8hOn0"),
    $3871cc4521fa53f6$var$load("cM3gY"),
    $3871cc4521fa53f6$var$load("7PjNK"),
    $3871cc4521fa53f6$var$load("Vt6S9")
]).then(()=>parcelRequire('jTJ2Q'));

});

parcelRegister("2yqT6", function(module, exports) {

let $1dc39d168c2450be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1dc39d168c2450be$var$load("1K1Fj"),
    $1dc39d168c2450be$var$load("xnqy2"),
    $1dc39d168c2450be$var$load("8hOn0"),
    $1dc39d168c2450be$var$load("cM3gY"),
    $1dc39d168c2450be$var$load("7PjNK"),
    $1dc39d168c2450be$var$load("Vt6S9")
]).then(()=>parcelRequire('aHso4'));

});

parcelRegister("7VYYf", function(module, exports) {

let $5c6d26ccb5f94785$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5c6d26ccb5f94785$var$load("1K1Fj"),
    $5c6d26ccb5f94785$var$load("xnqy2"),
    $5c6d26ccb5f94785$var$load("8hOn0"),
    $5c6d26ccb5f94785$var$load("cM3gY"),
    $5c6d26ccb5f94785$var$load("7PjNK"),
    $5c6d26ccb5f94785$var$load("Vt6S9")
]).then(()=>parcelRequire('lxZVf'));

});

parcelRegister("5D3sR", function(module, exports) {

let $4193483cb80f62b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4193483cb80f62b4$var$load("1K1Fj"),
    $4193483cb80f62b4$var$load("xnqy2"),
    $4193483cb80f62b4$var$load("8hOn0"),
    $4193483cb80f62b4$var$load("cM3gY"),
    $4193483cb80f62b4$var$load("7PjNK"),
    $4193483cb80f62b4$var$load("Vt6S9")
]).then(()=>parcelRequire('bVayQ'));

});

parcelRegister("2efCB", function(module, exports) {

let $19f901b832bbd2ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $19f901b832bbd2ca$var$load("1K1Fj"),
    $19f901b832bbd2ca$var$load("xnqy2"),
    $19f901b832bbd2ca$var$load("8hOn0"),
    $19f901b832bbd2ca$var$load("cM3gY"),
    $19f901b832bbd2ca$var$load("7PjNK"),
    $19f901b832bbd2ca$var$load("Vt6S9")
]).then(()=>parcelRequire('cmmhC'));

});

parcelRegister("i6Zgr", function(module, exports) {

let $d2f84f552b2cd76f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d2f84f552b2cd76f$var$load("1K1Fj"),
    $d2f84f552b2cd76f$var$load("xnqy2"),
    $d2f84f552b2cd76f$var$load("8hOn0"),
    $d2f84f552b2cd76f$var$load("cM3gY"),
    $d2f84f552b2cd76f$var$load("7PjNK"),
    $d2f84f552b2cd76f$var$load("Vt6S9")
]).then(()=>parcelRequire('lCr2G'));

});

parcelRegister("lFsTu", function(module, exports) {

let $fc63d70dca23dc6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fc63d70dca23dc6d$var$load("1K1Fj"),
    $fc63d70dca23dc6d$var$load("xnqy2"),
    $fc63d70dca23dc6d$var$load("8hOn0"),
    $fc63d70dca23dc6d$var$load("cM3gY"),
    $fc63d70dca23dc6d$var$load("7PjNK"),
    $fc63d70dca23dc6d$var$load("Vt6S9")
]).then(()=>parcelRequire('5lALU'));

});

parcelRegister("N953D", function(module, exports) {

let $093b9eee494163e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $093b9eee494163e3$var$load("1K1Fj"),
    $093b9eee494163e3$var$load("xnqy2"),
    $093b9eee494163e3$var$load("8hOn0"),
    $093b9eee494163e3$var$load("cM3gY"),
    $093b9eee494163e3$var$load("7PjNK"),
    $093b9eee494163e3$var$load("Vt6S9")
]).then(()=>parcelRequire('6DFbP'));

});

parcelRegister("2u2kR", function(module, exports) {

let $1cf031df2ee043b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1cf031df2ee043b4$var$load("1K1Fj"),
    $1cf031df2ee043b4$var$load("xnqy2"),
    $1cf031df2ee043b4$var$load("8hOn0"),
    $1cf031df2ee043b4$var$load("cM3gY"),
    $1cf031df2ee043b4$var$load("7PjNK"),
    $1cf031df2ee043b4$var$load("Vt6S9")
]).then(()=>parcelRequire('aOxLa'));

});

parcelRegister("8MTu9", function(module, exports) {

let $665dd8ac7eaa5074$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $665dd8ac7eaa5074$var$load("1K1Fj"),
    $665dd8ac7eaa5074$var$load("xnqy2"),
    $665dd8ac7eaa5074$var$load("8hOn0"),
    $665dd8ac7eaa5074$var$load("cM3gY"),
    $665dd8ac7eaa5074$var$load("7PjNK"),
    $665dd8ac7eaa5074$var$load("Vt6S9")
]).then(()=>parcelRequire('cpn1Z'));

});

parcelRegister("kRiRv", function(module, exports) {

let $f2f7638061eab12e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f2f7638061eab12e$var$load("1K1Fj"),
    $f2f7638061eab12e$var$load("xnqy2"),
    $f2f7638061eab12e$var$load("8hOn0"),
    $f2f7638061eab12e$var$load("cM3gY"),
    $f2f7638061eab12e$var$load("7PjNK"),
    $f2f7638061eab12e$var$load("Vt6S9")
]).then(()=>parcelRequire('kKdu4'));

});

parcelRegister("aooVH", function(module, exports) {

let $790f7bc1f761c448$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $790f7bc1f761c448$var$load("1K1Fj"),
    $790f7bc1f761c448$var$load("xnqy2"),
    $790f7bc1f761c448$var$load("8hOn0"),
    $790f7bc1f761c448$var$load("cM3gY"),
    $790f7bc1f761c448$var$load("7PjNK"),
    $790f7bc1f761c448$var$load("Vt6S9")
]).then(()=>parcelRequire('9xBAG'));

});

parcelRegister("ibFQv", function(module, exports) {

let $d3d9b6c7610418d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d3d9b6c7610418d9$var$load("1K1Fj"),
    $d3d9b6c7610418d9$var$load("xnqy2"),
    $d3d9b6c7610418d9$var$load("8hOn0"),
    $d3d9b6c7610418d9$var$load("cM3gY"),
    $d3d9b6c7610418d9$var$load("7PjNK"),
    $d3d9b6c7610418d9$var$load("Vt6S9")
]).then(()=>parcelRequire('cx6DD'));

});

parcelRegister("bVrxR", function(module, exports) {

let $8aea62728eade5c4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8aea62728eade5c4$var$load("1K1Fj"),
    $8aea62728eade5c4$var$load("xnqy2"),
    $8aea62728eade5c4$var$load("8hOn0"),
    $8aea62728eade5c4$var$load("cM3gY"),
    $8aea62728eade5c4$var$load("7PjNK"),
    $8aea62728eade5c4$var$load("Vt6S9")
]).then(()=>parcelRequire('g8Fnr'));

});

parcelRegister("7ah00", function(module, exports) {

let $5376a73ccc327741$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5376a73ccc327741$var$load("1K1Fj"),
    $5376a73ccc327741$var$load("xnqy2"),
    $5376a73ccc327741$var$load("8hOn0"),
    $5376a73ccc327741$var$load("cM3gY"),
    $5376a73ccc327741$var$load("7PjNK"),
    $5376a73ccc327741$var$load("Vt6S9")
]).then(()=>parcelRequire('5Lzpa'));

});

parcelRegister("228Zl", function(module, exports) {

let $17b2bd9109045578$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $17b2bd9109045578$var$load("1K1Fj"),
    $17b2bd9109045578$var$load("xnqy2"),
    $17b2bd9109045578$var$load("8hOn0"),
    $17b2bd9109045578$var$load("cM3gY"),
    $17b2bd9109045578$var$load("7PjNK"),
    $17b2bd9109045578$var$load("Vt6S9")
]).then(()=>parcelRequire('7ckUm'));

});

parcelRegister("4au4n", function(module, exports) {

let $308f6bc78ff4db4d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $308f6bc78ff4db4d$var$load("1K1Fj"),
    $308f6bc78ff4db4d$var$load("xnqy2"),
    $308f6bc78ff4db4d$var$load("8hOn0"),
    $308f6bc78ff4db4d$var$load("cM3gY"),
    $308f6bc78ff4db4d$var$load("7PjNK"),
    $308f6bc78ff4db4d$var$load("Vt6S9")
]).then(()=>parcelRequire('b2Gxi'));

});

parcelRegister("iR6Xu", function(module, exports) {

let $dba2930ddf7170ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dba2930ddf7170ae$var$load("1K1Fj"),
    $dba2930ddf7170ae$var$load("xnqy2"),
    $dba2930ddf7170ae$var$load("8hOn0"),
    $dba2930ddf7170ae$var$load("cM3gY"),
    $dba2930ddf7170ae$var$load("7PjNK"),
    $dba2930ddf7170ae$var$load("Vt6S9")
]).then(()=>parcelRequire('hpzN8'));

});

parcelRegister("fkzqw", function(module, exports) {

let $b294344b38a507c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b294344b38a507c3$var$load("1K1Fj"),
    $b294344b38a507c3$var$load("xnqy2"),
    $b294344b38a507c3$var$load("8hOn0"),
    $b294344b38a507c3$var$load("cM3gY"),
    $b294344b38a507c3$var$load("7PjNK"),
    $b294344b38a507c3$var$load("Vt6S9")
]).then(()=>parcelRequire('gGO7C'));

});

parcelRegister("bSpOm", function(module, exports) {

let $8a58c26aa3b67694$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a58c26aa3b67694$var$load("1K1Fj"),
    $8a58c26aa3b67694$var$load("xnqy2"),
    $8a58c26aa3b67694$var$load("8hOn0"),
    $8a58c26aa3b67694$var$load("cM3gY"),
    $8a58c26aa3b67694$var$load("7PjNK"),
    $8a58c26aa3b67694$var$load("Vt6S9")
]).then(()=>parcelRequire('dKgoa'));

});

parcelRegister("hwNwq", function(module, exports) {

let $cc2bd6dbf280a69f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cc2bd6dbf280a69f$var$load("1K1Fj"),
    $cc2bd6dbf280a69f$var$load("xnqy2"),
    $cc2bd6dbf280a69f$var$load("8hOn0"),
    $cc2bd6dbf280a69f$var$load("cM3gY"),
    $cc2bd6dbf280a69f$var$load("7PjNK"),
    $cc2bd6dbf280a69f$var$load("Vt6S9")
]).then(()=>parcelRequire('6wE9Q'));

});

parcelRegister("3Vy0v", function(module, exports) {

let $2dc113163b42a9cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2dc113163b42a9cb$var$load("1K1Fj"),
    $2dc113163b42a9cb$var$load("xnqy2"),
    $2dc113163b42a9cb$var$load("8hOn0"),
    $2dc113163b42a9cb$var$load("cM3gY"),
    $2dc113163b42a9cb$var$load("7PjNK"),
    $2dc113163b42a9cb$var$load("Vt6S9")
]).then(()=>parcelRequire('cvJTl'));

});

parcelRegister("a0Qfs", function(module, exports) {

let $74a26ee8a9d3cb4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $74a26ee8a9d3cb4a$var$load("1K1Fj"),
    $74a26ee8a9d3cb4a$var$load("xnqy2"),
    $74a26ee8a9d3cb4a$var$load("8hOn0"),
    $74a26ee8a9d3cb4a$var$load("cM3gY"),
    $74a26ee8a9d3cb4a$var$load("7PjNK"),
    $74a26ee8a9d3cb4a$var$load("Vt6S9")
]).then(()=>parcelRequire('lOsst'));

});

parcelRegister("gFkVa", function(module, exports) {

let $c220b42ed21be1d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c220b42ed21be1d5$var$load("1K1Fj"),
    $c220b42ed21be1d5$var$load("xnqy2"),
    $c220b42ed21be1d5$var$load("8hOn0"),
    $c220b42ed21be1d5$var$load("cM3gY"),
    $c220b42ed21be1d5$var$load("7PjNK"),
    $c220b42ed21be1d5$var$load("Vt6S9")
]).then(()=>parcelRequire('4GztV'));

});

parcelRegister("948bX", function(module, exports) {

let $699ad77f32890970$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $699ad77f32890970$var$load("1K1Fj"),
    $699ad77f32890970$var$load("xnqy2"),
    $699ad77f32890970$var$load("8hOn0"),
    $699ad77f32890970$var$load("cM3gY"),
    $699ad77f32890970$var$load("7PjNK"),
    $699ad77f32890970$var$load("Vt6S9")
]).then(()=>parcelRequire('kLNOH'));

});

parcelRegister("j4BCj", function(module, exports) {

let $de2b91f9e59c6072$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $de2b91f9e59c6072$var$load("1K1Fj"),
    $de2b91f9e59c6072$var$load("xnqy2"),
    $de2b91f9e59c6072$var$load("8hOn0"),
    $de2b91f9e59c6072$var$load("cM3gY"),
    $de2b91f9e59c6072$var$load("7PjNK"),
    $de2b91f9e59c6072$var$load("Vt6S9")
]).then(()=>parcelRequire('a3K3c'));

});

parcelRegister("gleDJ", function(module, exports) {

let $be59f6ad84c8766d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $be59f6ad84c8766d$var$load("1K1Fj"),
    $be59f6ad84c8766d$var$load("xnqy2"),
    $be59f6ad84c8766d$var$load("8hOn0"),
    $be59f6ad84c8766d$var$load("cM3gY"),
    $be59f6ad84c8766d$var$load("7PjNK"),
    $be59f6ad84c8766d$var$load("Vt6S9")
]).then(()=>parcelRequire('eaXue'));

});

parcelRegister("1GLjy", function(module, exports) {

let $13ae6a5abaac76af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $13ae6a5abaac76af$var$load("1K1Fj"),
    $13ae6a5abaac76af$var$load("xnqy2"),
    $13ae6a5abaac76af$var$load("8hOn0"),
    $13ae6a5abaac76af$var$load("cM3gY"),
    $13ae6a5abaac76af$var$load("7PjNK"),
    $13ae6a5abaac76af$var$load("Vt6S9")
]).then(()=>parcelRequire('c83RL'));

});

parcelRegister("7Sx4H", function(module, exports) {

let $5bc73b899796d414$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5bc73b899796d414$var$load("1K1Fj"),
    $5bc73b899796d414$var$load("xnqy2"),
    $5bc73b899796d414$var$load("8hOn0"),
    $5bc73b899796d414$var$load("cM3gY"),
    $5bc73b899796d414$var$load("7PjNK"),
    $5bc73b899796d414$var$load("Vt6S9")
]).then(()=>parcelRequire('2Ulo3'));

});

parcelRegister("ekfAU", function(module, exports) {

let $a6df07a27fe2d647$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a6df07a27fe2d647$var$load("1K1Fj"),
    $a6df07a27fe2d647$var$load("xnqy2"),
    $a6df07a27fe2d647$var$load("8hOn0"),
    $a6df07a27fe2d647$var$load("cM3gY"),
    $a6df07a27fe2d647$var$load("7PjNK"),
    $a6df07a27fe2d647$var$load("Vt6S9")
]).then(()=>parcelRequire('j0eQP'));

});

parcelRegister("hog0H", function(module, exports) {

let $ca9118d9b8437f64$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ca9118d9b8437f64$var$load("1K1Fj"),
    $ca9118d9b8437f64$var$load("xnqy2"),
    $ca9118d9b8437f64$var$load("8hOn0"),
    $ca9118d9b8437f64$var$load("cM3gY"),
    $ca9118d9b8437f64$var$load("7PjNK"),
    $ca9118d9b8437f64$var$load("Vt6S9")
]).then(()=>parcelRequire('l9h9Z'));

});

parcelRegister("3RT2u", function(module, exports) {

let $2d1103f483b14a23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2d1103f483b14a23$var$load("1K1Fj"),
    $2d1103f483b14a23$var$load("xnqy2"),
    $2d1103f483b14a23$var$load("8hOn0"),
    $2d1103f483b14a23$var$load("cM3gY"),
    $2d1103f483b14a23$var$load("7PjNK"),
    $2d1103f483b14a23$var$load("Vt6S9")
]).then(()=>parcelRequire('6mRQz'));

});

parcelRegister("2WFcU", function(module, exports) {

let $2250f66f63e15d94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2250f66f63e15d94$var$load("1K1Fj"),
    $2250f66f63e15d94$var$load("xnqy2"),
    $2250f66f63e15d94$var$load("8hOn0"),
    $2250f66f63e15d94$var$load("cM3gY"),
    $2250f66f63e15d94$var$load("7PjNK"),
    $2250f66f63e15d94$var$load("Vt6S9")
]).then(()=>parcelRequire('abc2w'));

});

parcelRegister("ll7nG", function(module, exports) {

let $f89148df3e26be12$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f89148df3e26be12$var$load("1K1Fj"),
    $f89148df3e26be12$var$load("xnqy2"),
    $f89148df3e26be12$var$load("8hOn0"),
    $f89148df3e26be12$var$load("cM3gY"),
    $f89148df3e26be12$var$load("7PjNK"),
    $f89148df3e26be12$var$load("Vt6S9")
]).then(()=>parcelRequire('3yDxt'));

});

parcelRegister("OleXG", function(module, exports) {

let $09752582e0ec6b8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $09752582e0ec6b8a$var$load("1K1Fj"),
    $09752582e0ec6b8a$var$load("xnqy2"),
    $09752582e0ec6b8a$var$load("8hOn0"),
    $09752582e0ec6b8a$var$load("cM3gY"),
    $09752582e0ec6b8a$var$load("7PjNK"),
    $09752582e0ec6b8a$var$load("Vt6S9")
]).then(()=>parcelRequire('bo3y3'));

});

parcelRegister("aQEiB", function(module, exports) {

let $7e5e0543dd3a242d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7e5e0543dd3a242d$var$load("1K1Fj"),
    $7e5e0543dd3a242d$var$load("xnqy2"),
    $7e5e0543dd3a242d$var$load("8hOn0"),
    $7e5e0543dd3a242d$var$load("cM3gY"),
    $7e5e0543dd3a242d$var$load("7PjNK"),
    $7e5e0543dd3a242d$var$load("Vt6S9")
]).then(()=>parcelRequire('iyVZx'));

});

parcelRegister("hGlAj", function(module, exports) {

let $cdf71a32a0ffe225$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cdf71a32a0ffe225$var$load("1K1Fj"),
    $cdf71a32a0ffe225$var$load("xnqy2"),
    $cdf71a32a0ffe225$var$load("8hOn0"),
    $cdf71a32a0ffe225$var$load("cM3gY"),
    $cdf71a32a0ffe225$var$load("7PjNK"),
    $cdf71a32a0ffe225$var$load("Vt6S9")
]).then(()=>parcelRequire('2qr4e'));

});

parcelRegister("7g65d", function(module, exports) {

let $548ebf02f1a9c0de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $548ebf02f1a9c0de$var$load("1K1Fj"),
    $548ebf02f1a9c0de$var$load("xnqy2"),
    $548ebf02f1a9c0de$var$load("8hOn0"),
    $548ebf02f1a9c0de$var$load("cM3gY"),
    $548ebf02f1a9c0de$var$load("7PjNK"),
    $548ebf02f1a9c0de$var$load("Vt6S9")
]).then(()=>parcelRequire('eoyn6'));

});

parcelRegister("amRwH", function(module, exports) {

let $78c57aaacdd07eb2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $78c57aaacdd07eb2$var$load("1K1Fj"),
    $78c57aaacdd07eb2$var$load("xnqy2"),
    $78c57aaacdd07eb2$var$load("8hOn0"),
    $78c57aaacdd07eb2$var$load("cM3gY"),
    $78c57aaacdd07eb2$var$load("7PjNK"),
    $78c57aaacdd07eb2$var$load("Vt6S9")
]).then(()=>parcelRequire('51jsl'));

});

parcelRegister("3Ab0c", function(module, exports) {

let $29bd44b0a279167f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $29bd44b0a279167f$var$load("1K1Fj"),
    $29bd44b0a279167f$var$load("xnqy2"),
    $29bd44b0a279167f$var$load("8hOn0"),
    $29bd44b0a279167f$var$load("cM3gY"),
    $29bd44b0a279167f$var$load("7PjNK"),
    $29bd44b0a279167f$var$load("Vt6S9")
]).then(()=>parcelRequire('eXAWa'));

});

parcelRegister("1JMes", function(module, exports) {

let $143f68538659bc33$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $143f68538659bc33$var$load("1K1Fj"),
    $143f68538659bc33$var$load("xnqy2"),
    $143f68538659bc33$var$load("8hOn0"),
    $143f68538659bc33$var$load("cM3gY"),
    $143f68538659bc33$var$load("7PjNK"),
    $143f68538659bc33$var$load("Vt6S9")
]).then(()=>parcelRequire('b6vFQ'));

});

parcelRegister("amuYS", function(module, exports) {

let $78b3fda1ded42215$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $78b3fda1ded42215$var$load("1K1Fj"),
    $78b3fda1ded42215$var$load("xnqy2"),
    $78b3fda1ded42215$var$load("8hOn0"),
    $78b3fda1ded42215$var$load("cM3gY"),
    $78b3fda1ded42215$var$load("7PjNK"),
    $78b3fda1ded42215$var$load("Vt6S9")
]).then(()=>parcelRequire('g45EP'));

});

parcelRegister("9chGX", function(module, exports) {

let $6b22f54458819be7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6b22f54458819be7$var$load("1K1Fj"),
    $6b22f54458819be7$var$load("xnqy2"),
    $6b22f54458819be7$var$load("8hOn0"),
    $6b22f54458819be7$var$load("cM3gY"),
    $6b22f54458819be7$var$load("7PjNK"),
    $6b22f54458819be7$var$load("Vt6S9")
]).then(()=>parcelRequire('jIoxW'));

});

parcelRegister("g5ykP", function(module, exports) {

let $bb67bf2ff3b00f34$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bb67bf2ff3b00f34$var$load("1K1Fj"),
    $bb67bf2ff3b00f34$var$load("xnqy2"),
    $bb67bf2ff3b00f34$var$load("8hOn0"),
    $bb67bf2ff3b00f34$var$load("cM3gY"),
    $bb67bf2ff3b00f34$var$load("7PjNK"),
    $bb67bf2ff3b00f34$var$load("Vt6S9")
]).then(()=>parcelRequire('gpk82'));

});

parcelRegister("alUyM", function(module, exports) {

let $7897bd2af58b7ebf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7897bd2af58b7ebf$var$load("1K1Fj"),
    $7897bd2af58b7ebf$var$load("xnqy2"),
    $7897bd2af58b7ebf$var$load("8hOn0"),
    $7897bd2af58b7ebf$var$load("cM3gY"),
    $7897bd2af58b7ebf$var$load("7PjNK"),
    $7897bd2af58b7ebf$var$load("Vt6S9")
]).then(()=>parcelRequire('fgSdB'));

});

parcelRegister("dMN5u", function(module, exports) {

let $a095d5cd06e28285$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a095d5cd06e28285$var$load("7v6wU"),
    $a095d5cd06e28285$var$load("a8heY"),
    $a095d5cd06e28285$var$load("b544F"),
    $a095d5cd06e28285$var$load("9PPH7"),
    $a095d5cd06e28285$var$load("dzIm8"),
    $a095d5cd06e28285$var$load("hrf1M")
]).then(()=>parcelRequire('3QCDD'));

});

parcelRegister("9Sy6S", function(module, exports) {

let $73139db64bb9b533$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $73139db64bb9b533$var$load("7v6wU"),
    $73139db64bb9b533$var$load("a8heY"),
    $73139db64bb9b533$var$load("b544F"),
    $73139db64bb9b533$var$load("9PPH7"),
    $73139db64bb9b533$var$load("dzIm8"),
    $73139db64bb9b533$var$load("hrf1M")
]).then(()=>parcelRequire('9hAXc'));

});

parcelRegister("2sR2M", function(module, exports) {

let $1cb757aca1d9c96a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1cb757aca1d9c96a$var$load("7v6wU"),
    $1cb757aca1d9c96a$var$load("a8heY"),
    $1cb757aca1d9c96a$var$load("b544F"),
    $1cb757aca1d9c96a$var$load("9PPH7"),
    $1cb757aca1d9c96a$var$load("dzIm8"),
    $1cb757aca1d9c96a$var$load("hrf1M")
]).then(()=>parcelRequire('kblsY'));

});

parcelRegister("lOHWU", function(module, exports) {

let $fe205bdabac71dfd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fe205bdabac71dfd$var$load("7v6wU"),
    $fe205bdabac71dfd$var$load("a8heY"),
    $fe205bdabac71dfd$var$load("b544F"),
    $fe205bdabac71dfd$var$load("9PPH7"),
    $fe205bdabac71dfd$var$load("dzIm8"),
    $fe205bdabac71dfd$var$load("hrf1M")
]).then(()=>parcelRequire('9bGZv'));

});

parcelRegister("jf7Wf", function(module, exports) {

let $e025936dfb4925e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e025936dfb4925e6$var$load("7v6wU"),
    $e025936dfb4925e6$var$load("a8heY"),
    $e025936dfb4925e6$var$load("b544F"),
    $e025936dfb4925e6$var$load("9PPH7"),
    $e025936dfb4925e6$var$load("dzIm8"),
    $e025936dfb4925e6$var$load("hrf1M")
]).then(()=>parcelRequire('lGLcJ'));

});

parcelRegister("cJ0AU", function(module, exports) {

let $943a2608ad899810$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $943a2608ad899810$var$load("7v6wU"),
    $943a2608ad899810$var$load("a8heY"),
    $943a2608ad899810$var$load("b544F"),
    $943a2608ad899810$var$load("9PPH7"),
    $943a2608ad899810$var$load("dzIm8"),
    $943a2608ad899810$var$load("hrf1M")
]).then(()=>parcelRequire('4A5oU'));

});

parcelRegister("fjeb2", function(module, exports) {

let $b253a0a1e657b048$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b253a0a1e657b048$var$load("7v6wU"),
    $b253a0a1e657b048$var$load("a8heY"),
    $b253a0a1e657b048$var$load("b544F"),
    $b253a0a1e657b048$var$load("9PPH7"),
    $b253a0a1e657b048$var$load("dzIm8"),
    $b253a0a1e657b048$var$load("hrf1M")
]).then(()=>parcelRequire('kZ5TM'));

});

parcelRegister("jZyhc", function(module, exports) {

let $e8de4d6e31a68774$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e8de4d6e31a68774$var$load("7v6wU"),
    $e8de4d6e31a68774$var$load("a8heY"),
    $e8de4d6e31a68774$var$load("b544F"),
    $e8de4d6e31a68774$var$load("9PPH7"),
    $e8de4d6e31a68774$var$load("dzIm8"),
    $e8de4d6e31a68774$var$load("hrf1M")
]).then(()=>parcelRequire('573SD'));

});

parcelRegister("bL83i", function(module, exports) {

let $88fa547c1c888ac0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $88fa547c1c888ac0$var$load("7v6wU"),
    $88fa547c1c888ac0$var$load("a8heY"),
    $88fa547c1c888ac0$var$load("b544F"),
    $88fa547c1c888ac0$var$load("9PPH7"),
    $88fa547c1c888ac0$var$load("dzIm8"),
    $88fa547c1c888ac0$var$load("hrf1M")
]).then(()=>parcelRequire('jfPKi'));

});

parcelRegister("4Sfek", function(module, exports) {

let $38c804ee5c79e084$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $38c804ee5c79e084$var$load("7v6wU"),
    $38c804ee5c79e084$var$load("a8heY"),
    $38c804ee5c79e084$var$load("b544F"),
    $38c804ee5c79e084$var$load("9PPH7"),
    $38c804ee5c79e084$var$load("dzIm8"),
    $38c804ee5c79e084$var$load("hrf1M")
]).then(()=>parcelRequire('eYEqr'));

});

parcelRegister("fQBV7", function(module, exports) {

let $b89920857eec1b68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b89920857eec1b68$var$load("7v6wU"),
    $b89920857eec1b68$var$load("a8heY"),
    $b89920857eec1b68$var$load("b544F"),
    $b89920857eec1b68$var$load("9PPH7"),
    $b89920857eec1b68$var$load("dzIm8"),
    $b89920857eec1b68$var$load("hrf1M")
]).then(()=>parcelRequire('9Blvx'));

});

parcelRegister("aHOHt", function(module, exports) {

let $7cb53f8c73df99d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7cb53f8c73df99d0$var$load("7v6wU"),
    $7cb53f8c73df99d0$var$load("a8heY"),
    $7cb53f8c73df99d0$var$load("b544F"),
    $7cb53f8c73df99d0$var$load("9PPH7"),
    $7cb53f8c73df99d0$var$load("dzIm8"),
    $7cb53f8c73df99d0$var$load("hrf1M")
]).then(()=>parcelRequire('1WvJN'));

});

parcelRegister("lkDzP", function(module, exports) {

let $f87a2a6225be1da4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f87a2a6225be1da4$var$load("7v6wU"),
    $f87a2a6225be1da4$var$load("a8heY"),
    $f87a2a6225be1da4$var$load("b544F"),
    $f87a2a6225be1da4$var$load("9PPH7"),
    $f87a2a6225be1da4$var$load("dzIm8"),
    $f87a2a6225be1da4$var$load("hrf1M")
]).then(()=>parcelRequire('fp7aR'));

});

parcelRegister("acAF0", function(module, exports) {

let $76d77661c07305fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $76d77661c07305fa$var$load("7v6wU"),
    $76d77661c07305fa$var$load("a8heY"),
    $76d77661c07305fa$var$load("b544F"),
    $76d77661c07305fa$var$load("9PPH7"),
    $76d77661c07305fa$var$load("dzIm8"),
    $76d77661c07305fa$var$load("hrf1M")
]).then(()=>parcelRequire('gf2E5'));

});

parcelRegister("3WzYO", function(module, exports) {

let $2df2b2c029efc414$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2df2b2c029efc414$var$load("7v6wU"),
    $2df2b2c029efc414$var$load("a8heY"),
    $2df2b2c029efc414$var$load("b544F"),
    $2df2b2c029efc414$var$load("9PPH7"),
    $2df2b2c029efc414$var$load("dzIm8"),
    $2df2b2c029efc414$var$load("hrf1M")
]).then(()=>parcelRequire('5Mz5E'));

});

parcelRegister("2ZzQp", function(module, exports) {

let $22dd15383c3ee8b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $22dd15383c3ee8b3$var$load("7v6wU"),
    $22dd15383c3ee8b3$var$load("a8heY"),
    $22dd15383c3ee8b3$var$load("b544F"),
    $22dd15383c3ee8b3$var$load("9PPH7"),
    $22dd15383c3ee8b3$var$load("dzIm8"),
    $22dd15383c3ee8b3$var$load("hrf1M")
]).then(()=>parcelRequire('j3xsn'));

});

parcelRegister("1WKn0", function(module, exports) {

let $16af2d5d6ff530bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $16af2d5d6ff530bb$var$load("7v6wU"),
    $16af2d5d6ff530bb$var$load("a8heY"),
    $16af2d5d6ff530bb$var$load("b544F"),
    $16af2d5d6ff530bb$var$load("9PPH7"),
    $16af2d5d6ff530bb$var$load("dzIm8"),
    $16af2d5d6ff530bb$var$load("hrf1M")
]).then(()=>parcelRequire('1GNtt'));

});

parcelRegister("gXZbC", function(module, exports) {

let $c5a19e5fe0f87fa5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c5a19e5fe0f87fa5$var$load("7v6wU"),
    $c5a19e5fe0f87fa5$var$load("a8heY"),
    $c5a19e5fe0f87fa5$var$load("b544F"),
    $c5a19e5fe0f87fa5$var$load("9PPH7"),
    $c5a19e5fe0f87fa5$var$load("dzIm8"),
    $c5a19e5fe0f87fa5$var$load("hrf1M")
]).then(()=>parcelRequire('4lHRm'));

});

parcelRegister("dT0l0", function(module, exports) {

let $a1c0ac7a63a613a9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a1c0ac7a63a613a9$var$load("7v6wU"),
    $a1c0ac7a63a613a9$var$load("a8heY"),
    $a1c0ac7a63a613a9$var$load("b544F"),
    $a1c0ac7a63a613a9$var$load("9PPH7"),
    $a1c0ac7a63a613a9$var$load("dzIm8"),
    $a1c0ac7a63a613a9$var$load("hrf1M")
]).then(()=>parcelRequire('g0MkC'));

});

parcelRegister("dncYR", function(module, exports) {

let $9bc77e0a8c51d8c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9bc77e0a8c51d8c2$var$load("7v6wU"),
    $9bc77e0a8c51d8c2$var$load("a8heY"),
    $9bc77e0a8c51d8c2$var$load("b544F"),
    $9bc77e0a8c51d8c2$var$load("9PPH7"),
    $9bc77e0a8c51d8c2$var$load("dzIm8"),
    $9bc77e0a8c51d8c2$var$load("hrf1M")
]).then(()=>parcelRequire('4RP7y'));

});

parcelRegister("8SY41", function(module, exports) {

let $6781f552656ae108$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6781f552656ae108$var$load("7v6wU"),
    $6781f552656ae108$var$load("a8heY"),
    $6781f552656ae108$var$load("b544F"),
    $6781f552656ae108$var$load("9PPH7"),
    $6781f552656ae108$var$load("dzIm8"),
    $6781f552656ae108$var$load("hrf1M")
]).then(()=>parcelRequire('a0SnZ'));

});

parcelRegister("13Wx0", function(module, exports) {

let $0c63795caf72b89a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0c63795caf72b89a$var$load("7v6wU"),
    $0c63795caf72b89a$var$load("a8heY"),
    $0c63795caf72b89a$var$load("b544F"),
    $0c63795caf72b89a$var$load("9PPH7"),
    $0c63795caf72b89a$var$load("dzIm8"),
    $0c63795caf72b89a$var$load("hrf1M")
]).then(()=>parcelRequire('iEcp9'));

});

parcelRegister("5qYkf", function(module, exports) {

let $3f4e2cdac5acc3e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f4e2cdac5acc3e9$var$load("7v6wU"),
    $3f4e2cdac5acc3e9$var$load("a8heY"),
    $3f4e2cdac5acc3e9$var$load("b544F"),
    $3f4e2cdac5acc3e9$var$load("9PPH7"),
    $3f4e2cdac5acc3e9$var$load("dzIm8"),
    $3f4e2cdac5acc3e9$var$load("hrf1M")
]).then(()=>parcelRequire('bi9WR'));

});

parcelRegister("eMQbd", function(module, exports) {

let $ac3e06333c450b0a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ac3e06333c450b0a$var$load("7v6wU"),
    $ac3e06333c450b0a$var$load("a8heY"),
    $ac3e06333c450b0a$var$load("b544F"),
    $ac3e06333c450b0a$var$load("9PPH7"),
    $ac3e06333c450b0a$var$load("dzIm8"),
    $ac3e06333c450b0a$var$load("hrf1M")
]).then(()=>parcelRequire('hDf28'));

});

parcelRegister("jDjEq", function(module, exports) {

let $e4b0e72070db969c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e4b0e72070db969c$var$load("7v6wU"),
    $e4b0e72070db969c$var$load("a8heY"),
    $e4b0e72070db969c$var$load("b544F"),
    $e4b0e72070db969c$var$load("9PPH7"),
    $e4b0e72070db969c$var$load("dzIm8"),
    $e4b0e72070db969c$var$load("hrf1M")
]).then(()=>parcelRequire('8gDZw'));

});

parcelRegister("jvWch", function(module, exports) {

let $e34e0e528157f2b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e34e0e528157f2b3$var$load("7v6wU"),
    $e34e0e528157f2b3$var$load("a8heY"),
    $e34e0e528157f2b3$var$load("b544F"),
    $e34e0e528157f2b3$var$load("9PPH7"),
    $e34e0e528157f2b3$var$load("dzIm8"),
    $e34e0e528157f2b3$var$load("hrf1M")
]).then(()=>parcelRequire('7VsE7'));

});

parcelRegister("im8t4", function(module, exports) {

let $d5d0d9966284fdde$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d5d0d9966284fdde$var$load("7v6wU"),
    $d5d0d9966284fdde$var$load("a8heY"),
    $d5d0d9966284fdde$var$load("b544F"),
    $d5d0d9966284fdde$var$load("9PPH7"),
    $d5d0d9966284fdde$var$load("dzIm8"),
    $d5d0d9966284fdde$var$load("hrf1M")
]).then(()=>parcelRequire('emfWs'));

});

parcelRegister("lP9lz", function(module, exports) {

let $fe359c80c85b72d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fe359c80c85b72d2$var$load("7v6wU"),
    $fe359c80c85b72d2$var$load("a8heY"),
    $fe359c80c85b72d2$var$load("b544F"),
    $fe359c80c85b72d2$var$load("9PPH7"),
    $fe359c80c85b72d2$var$load("dzIm8"),
    $fe359c80c85b72d2$var$load("hrf1M")
]).then(()=>parcelRequire('kjoF8'));

});

parcelRegister("eJom7", function(module, exports) {

let $ab982932bf33d990$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ab982932bf33d990$var$load("7v6wU"),
    $ab982932bf33d990$var$load("a8heY"),
    $ab982932bf33d990$var$load("b544F"),
    $ab982932bf33d990$var$load("9PPH7"),
    $ab982932bf33d990$var$load("dzIm8"),
    $ab982932bf33d990$var$load("hrf1M")
]).then(()=>parcelRequire('d8wp6'));

});

parcelRegister("dVscl", function(module, exports) {

let $a23678ce69a62eee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a23678ce69a62eee$var$load("7v6wU"),
    $a23678ce69a62eee$var$load("a8heY"),
    $a23678ce69a62eee$var$load("b544F"),
    $a23678ce69a62eee$var$load("9PPH7"),
    $a23678ce69a62eee$var$load("dzIm8"),
    $a23678ce69a62eee$var$load("hrf1M")
]).then(()=>parcelRequire('a9HoB'));

});

parcelRegister("gJdES", function(module, exports) {

let $c2db718c4bb88287$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c2db718c4bb88287$var$load("7v6wU"),
    $c2db718c4bb88287$var$load("a8heY"),
    $c2db718c4bb88287$var$load("b544F"),
    $c2db718c4bb88287$var$load("9PPH7"),
    $c2db718c4bb88287$var$load("dzIm8"),
    $c2db718c4bb88287$var$load("hrf1M")
]).then(()=>parcelRequire('ctgr2'));

});

parcelRegister("gIU5D", function(module, exports) {

let $c2cc43b114b705cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c2cc43b114b705cd$var$load("7v6wU"),
    $c2cc43b114b705cd$var$load("a8heY"),
    $c2cc43b114b705cd$var$load("b544F"),
    $c2cc43b114b705cd$var$load("9PPH7"),
    $c2cc43b114b705cd$var$load("dzIm8"),
    $c2cc43b114b705cd$var$load("hrf1M")
]).then(()=>parcelRequire('e1aX9'));

});

parcelRegister("gUMoH", function(module, exports) {

let $c5076b01bdc25721$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c5076b01bdc25721$var$load("7v6wU"),
    $c5076b01bdc25721$var$load("a8heY"),
    $c5076b01bdc25721$var$load("b544F"),
    $c5076b01bdc25721$var$load("9PPH7"),
    $c5076b01bdc25721$var$load("dzIm8"),
    $c5076b01bdc25721$var$load("hrf1M")
]).then(()=>parcelRequire('3xFjs'));

});

parcelRegister("1xJ6S", function(module, exports) {

let $11fbdd699b040ce2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $11fbdd699b040ce2$var$load("7v6wU"),
    $11fbdd699b040ce2$var$load("a8heY"),
    $11fbdd699b040ce2$var$load("b544F"),
    $11fbdd699b040ce2$var$load("9PPH7"),
    $11fbdd699b040ce2$var$load("dzIm8"),
    $11fbdd699b040ce2$var$load("hrf1M")
]).then(()=>parcelRequire('cQpjk'));

});

parcelRegister("iA00J", function(module, exports) {

let $d86b98ef7cc4c1cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d86b98ef7cc4c1cf$var$load("7v6wU"),
    $d86b98ef7cc4c1cf$var$load("a8heY"),
    $d86b98ef7cc4c1cf$var$load("b544F"),
    $d86b98ef7cc4c1cf$var$load("9PPH7"),
    $d86b98ef7cc4c1cf$var$load("dzIm8"),
    $d86b98ef7cc4c1cf$var$load("hrf1M")
]).then(()=>parcelRequire('lMFiU'));

});

parcelRegister("hjIWO", function(module, exports) {

let $c9b713a5cc42ac1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c9b713a5cc42ac1e$var$load("7v6wU"),
    $c9b713a5cc42ac1e$var$load("a8heY"),
    $c9b713a5cc42ac1e$var$load("b544F"),
    $c9b713a5cc42ac1e$var$load("9PPH7"),
    $c9b713a5cc42ac1e$var$load("dzIm8"),
    $c9b713a5cc42ac1e$var$load("hrf1M")
]).then(()=>parcelRequire('jD1kq'));

});

parcelRegister("2mKTO", function(module, exports) {

let $1b920411635385b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b920411635385b6$var$load("7v6wU"),
    $1b920411635385b6$var$load("a8heY"),
    $1b920411635385b6$var$load("b544F"),
    $1b920411635385b6$var$load("9PPH7"),
    $1b920411635385b6$var$load("dzIm8"),
    $1b920411635385b6$var$load("hrf1M")
]).then(()=>parcelRequire('ekfmK'));

});

parcelRegister("64Exp", function(module, exports) {

let $46c28fc7b80d6e14$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $46c28fc7b80d6e14$var$load("7v6wU"),
    $46c28fc7b80d6e14$var$load("a8heY"),
    $46c28fc7b80d6e14$var$load("b544F"),
    $46c28fc7b80d6e14$var$load("9PPH7"),
    $46c28fc7b80d6e14$var$load("dzIm8"),
    $46c28fc7b80d6e14$var$load("hrf1M")
]).then(()=>parcelRequire('bZefw'));

});

parcelRegister("2whfU", function(module, exports) {

let $1d5bf4873c05a56d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1d5bf4873c05a56d$var$load("7v6wU"),
    $1d5bf4873c05a56d$var$load("a8heY"),
    $1d5bf4873c05a56d$var$load("b544F"),
    $1d5bf4873c05a56d$var$load("9PPH7"),
    $1d5bf4873c05a56d$var$load("dzIm8"),
    $1d5bf4873c05a56d$var$load("hrf1M")
]).then(()=>parcelRequire('etwfl'));

});

parcelRegister("2oUhU", function(module, exports) {

let $1bf97c41ee7f7dc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1bf97c41ee7f7dc2$var$load("7v6wU"),
    $1bf97c41ee7f7dc2$var$load("a8heY"),
    $1bf97c41ee7f7dc2$var$load("b544F"),
    $1bf97c41ee7f7dc2$var$load("9PPH7"),
    $1bf97c41ee7f7dc2$var$load("dzIm8"),
    $1bf97c41ee7f7dc2$var$load("hrf1M")
]).then(()=>parcelRequire('f8IWM'));

});

parcelRegister("n6J1z", function(module, exports) {

let $04575d94cce8c035$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $04575d94cce8c035$var$load("7v6wU"),
    $04575d94cce8c035$var$load("a8heY"),
    $04575d94cce8c035$var$load("b544F"),
    $04575d94cce8c035$var$load("9PPH7"),
    $04575d94cce8c035$var$load("dzIm8"),
    $04575d94cce8c035$var$load("hrf1M")
]).then(()=>parcelRequire('iDFnq'));

});

parcelRegister("iYl0v", function(module, exports) {

let $dcfe202d31b63b66$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dcfe202d31b63b66$var$load("7v6wU"),
    $dcfe202d31b63b66$var$load("a8heY"),
    $dcfe202d31b63b66$var$load("b544F"),
    $dcfe202d31b63b66$var$load("9PPH7"),
    $dcfe202d31b63b66$var$load("dzIm8"),
    $dcfe202d31b63b66$var$load("hrf1M")
]).then(()=>parcelRequire('9dt1t'));

});

parcelRegister("ajmHX", function(module, exports) {

let $781d4b0e0bbc2b89$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $781d4b0e0bbc2b89$var$load("7v6wU"),
    $781d4b0e0bbc2b89$var$load("a8heY"),
    $781d4b0e0bbc2b89$var$load("b544F"),
    $781d4b0e0bbc2b89$var$load("9PPH7"),
    $781d4b0e0bbc2b89$var$load("dzIm8"),
    $781d4b0e0bbc2b89$var$load("hrf1M")
]).then(()=>parcelRequire('hTlim'));

});

parcelRegister("gcFuD", function(module, exports) {

let $bcbdf3f996fb18cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bcbdf3f996fb18cf$var$load("7v6wU"),
    $bcbdf3f996fb18cf$var$load("a8heY"),
    $bcbdf3f996fb18cf$var$load("b544F"),
    $bcbdf3f996fb18cf$var$load("9PPH7"),
    $bcbdf3f996fb18cf$var$load("dzIm8"),
    $bcbdf3f996fb18cf$var$load("hrf1M")
]).then(()=>parcelRequire('4wLfw'));

});

parcelRegister("fBUMu", function(module, exports) {

let $b5d65b42e72b6a95$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b5d65b42e72b6a95$var$load("7v6wU"),
    $b5d65b42e72b6a95$var$load("a8heY"),
    $b5d65b42e72b6a95$var$load("b544F"),
    $b5d65b42e72b6a95$var$load("9PPH7"),
    $b5d65b42e72b6a95$var$load("dzIm8"),
    $b5d65b42e72b6a95$var$load("hrf1M")
]).then(()=>parcelRequire('cso1d'));

});

parcelRegister("8p4qh", function(module, exports) {

let $61e416d58806bb41$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $61e416d58806bb41$var$load("7v6wU"),
    $61e416d58806bb41$var$load("a8heY"),
    $61e416d58806bb41$var$load("b544F"),
    $61e416d58806bb41$var$load("9PPH7"),
    $61e416d58806bb41$var$load("dzIm8"),
    $61e416d58806bb41$var$load("hrf1M")
]).then(()=>parcelRequire('iA0Fl'));

});

parcelRegister("jkRu0", function(module, exports) {

let $e1395f3383592583$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e1395f3383592583$var$load("7v6wU"),
    $e1395f3383592583$var$load("a8heY"),
    $e1395f3383592583$var$load("b544F"),
    $e1395f3383592583$var$load("9PPH7"),
    $e1395f3383592583$var$load("dzIm8"),
    $e1395f3383592583$var$load("hrf1M")
]).then(()=>parcelRequire('dvLJ9'));

});

parcelRegister("litwj", function(module, exports) {

let $f8122d7ed03fab14$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f8122d7ed03fab14$var$load("7v6wU"),
    $f8122d7ed03fab14$var$load("a8heY"),
    $f8122d7ed03fab14$var$load("b544F"),
    $f8122d7ed03fab14$var$load("9PPH7"),
    $f8122d7ed03fab14$var$load("dzIm8"),
    $f8122d7ed03fab14$var$load("hrf1M")
]).then(()=>parcelRequire('6uSjO'));

});

parcelRegister("cdWqu", function(module, exports) {

let $8e64052f4b9a0430$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8e64052f4b9a0430$var$load("7v6wU"),
    $8e64052f4b9a0430$var$load("a8heY"),
    $8e64052f4b9a0430$var$load("b544F"),
    $8e64052f4b9a0430$var$load("9PPH7"),
    $8e64052f4b9a0430$var$load("dzIm8"),
    $8e64052f4b9a0430$var$load("hrf1M")
]).then(()=>parcelRequire('3CBAF'));

});

parcelRegister("cDKFi", function(module, exports) {

let $933d53492af1a16a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $933d53492af1a16a$var$load("7v6wU"),
    $933d53492af1a16a$var$load("a8heY"),
    $933d53492af1a16a$var$load("b544F"),
    $933d53492af1a16a$var$load("9PPH7"),
    $933d53492af1a16a$var$load("dzIm8"),
    $933d53492af1a16a$var$load("hrf1M")
]).then(()=>parcelRequire('29WOn'));

});

parcelRegister("h7jes", function(module, exports) {

let $c762023b3cac393e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c762023b3cac393e$var$load("asvK9"),
    $c762023b3cac393e$var$load("barSq"),
    $c762023b3cac393e$var$load("aBa7j"),
    $c762023b3cac393e$var$load("gctEz"),
    $c762023b3cac393e$var$load("hPZE5"),
    $c762023b3cac393e$var$load("QTjdE")
]).then(()=>parcelRequire('hSCCx'));

});

parcelRegister("aFVpw", function(module, exports) {

let $7c5a444488d55232$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7c5a444488d55232$var$load("asvK9"),
    $7c5a444488d55232$var$load("barSq"),
    $7c5a444488d55232$var$load("aBa7j"),
    $7c5a444488d55232$var$load("gctEz"),
    $7c5a444488d55232$var$load("hPZE5"),
    $7c5a444488d55232$var$load("QTjdE")
]).then(()=>parcelRequire('lRW0v'));

});

parcelRegister("pcTb4", function(module, exports) {

let $04bc5564bc8ae39b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $04bc5564bc8ae39b$var$load("asvK9"),
    $04bc5564bc8ae39b$var$load("barSq"),
    $04bc5564bc8ae39b$var$load("aBa7j"),
    $04bc5564bc8ae39b$var$load("gctEz"),
    $04bc5564bc8ae39b$var$load("hPZE5"),
    $04bc5564bc8ae39b$var$load("QTjdE")
]).then(()=>parcelRequire('6wuEn'));

});

parcelRegister("hwCQi", function(module, exports) {

let $cc238e1d5907c928$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cc238e1d5907c928$var$load("asvK9"),
    $cc238e1d5907c928$var$load("barSq"),
    $cc238e1d5907c928$var$load("aBa7j"),
    $cc238e1d5907c928$var$load("gctEz"),
    $cc238e1d5907c928$var$load("hPZE5"),
    $cc238e1d5907c928$var$load("QTjdE")
]).then(()=>parcelRequire('is7g5'));

});

parcelRegister("fprwv", function(module, exports) {

let $b37e8a5d340c47f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b37e8a5d340c47f4$var$load("asvK9"),
    $b37e8a5d340c47f4$var$load("barSq"),
    $b37e8a5d340c47f4$var$load("aBa7j"),
    $b37e8a5d340c47f4$var$load("gctEz"),
    $b37e8a5d340c47f4$var$load("hPZE5"),
    $b37e8a5d340c47f4$var$load("QTjdE")
]).then(()=>parcelRequire('jKge3'));

});

parcelRegister("euPQu", function(module, exports) {

let $a8dc1582406d468f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a8dc1582406d468f$var$load("asvK9"),
    $a8dc1582406d468f$var$load("barSq"),
    $a8dc1582406d468f$var$load("aBa7j"),
    $a8dc1582406d468f$var$load("gctEz"),
    $a8dc1582406d468f$var$load("hPZE5"),
    $a8dc1582406d468f$var$load("QTjdE")
]).then(()=>parcelRequire('18iDn'));

});

parcelRegister("b1mVA", function(module, exports) {

let $806192b6b952aca7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $806192b6b952aca7$var$load("asvK9"),
    $806192b6b952aca7$var$load("barSq"),
    $806192b6b952aca7$var$load("aBa7j"),
    $806192b6b952aca7$var$load("gctEz"),
    $806192b6b952aca7$var$load("hPZE5"),
    $806192b6b952aca7$var$load("QTjdE")
]).then(()=>parcelRequire('6frTB'));

});

parcelRegister("bg7zY", function(module, exports) {

let $8327116b751c843f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8327116b751c843f$var$load("asvK9"),
    $8327116b751c843f$var$load("barSq"),
    $8327116b751c843f$var$load("aBa7j"),
    $8327116b751c843f$var$load("gctEz"),
    $8327116b751c843f$var$load("hPZE5"),
    $8327116b751c843f$var$load("QTjdE")
]).then(()=>parcelRequire('h0YR4'));

});

parcelRegister("469Km", function(module, exports) {

let $2fbf4877daa34fac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2fbf4877daa34fac$var$load("asvK9"),
    $2fbf4877daa34fac$var$load("barSq"),
    $2fbf4877daa34fac$var$load("aBa7j"),
    $2fbf4877daa34fac$var$load("gctEz"),
    $2fbf4877daa34fac$var$load("hPZE5"),
    $2fbf4877daa34fac$var$load("QTjdE")
]).then(()=>parcelRequire('6F1or'));

});

parcelRegister("6MZlt", function(module, exports) {

let $4f16cfada4c9c221$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f16cfada4c9c221$var$load("asvK9"),
    $4f16cfada4c9c221$var$load("barSq"),
    $4f16cfada4c9c221$var$load("aBa7j"),
    $4f16cfada4c9c221$var$load("gctEz"),
    $4f16cfada4c9c221$var$load("hPZE5"),
    $4f16cfada4c9c221$var$load("QTjdE")
]).then(()=>parcelRequire('f0428'));

});

parcelRegister("40MMk", function(module, exports) {

let $2ebcffecb7a9ffaf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2ebcffecb7a9ffaf$var$load("asvK9"),
    $2ebcffecb7a9ffaf$var$load("barSq"),
    $2ebcffecb7a9ffaf$var$load("aBa7j"),
    $2ebcffecb7a9ffaf$var$load("gctEz"),
    $2ebcffecb7a9ffaf$var$load("hPZE5"),
    $2ebcffecb7a9ffaf$var$load("QTjdE")
]).then(()=>parcelRequire('e4lFW'));

});

parcelRegister("1V9j9", function(module, exports) {

let $166255ad7396622e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $166255ad7396622e$var$load("asvK9"),
    $166255ad7396622e$var$load("barSq"),
    $166255ad7396622e$var$load("aBa7j"),
    $166255ad7396622e$var$load("gctEz"),
    $166255ad7396622e$var$load("hPZE5"),
    $166255ad7396622e$var$load("QTjdE")
]).then(()=>parcelRequire('gs0Um'));

});

parcelRegister("aXTPJ", function(module, exports) {

let $7fbab96f6b007073$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7fbab96f6b007073$var$load("asvK9"),
    $7fbab96f6b007073$var$load("barSq"),
    $7fbab96f6b007073$var$load("aBa7j"),
    $7fbab96f6b007073$var$load("gctEz"),
    $7fbab96f6b007073$var$load("hPZE5"),
    $7fbab96f6b007073$var$load("QTjdE")
]).then(()=>parcelRequire('w1yis'));

});

parcelRegister("88wo1", function(module, exports) {

let $5ec83159b364a0ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5ec83159b364a0ad$var$load("asvK9"),
    $5ec83159b364a0ad$var$load("barSq"),
    $5ec83159b364a0ad$var$load("aBa7j"),
    $5ec83159b364a0ad$var$load("gctEz"),
    $5ec83159b364a0ad$var$load("hPZE5"),
    $5ec83159b364a0ad$var$load("QTjdE")
]).then(()=>parcelRequire('dJPHE'));

});

parcelRegister("4vIkx", function(module, exports) {

let $348c71bdb543360c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $348c71bdb543360c$var$load("asvK9"),
    $348c71bdb543360c$var$load("barSq"),
    $348c71bdb543360c$var$load("aBa7j"),
    $348c71bdb543360c$var$load("gctEz"),
    $348c71bdb543360c$var$load("hPZE5"),
    $348c71bdb543360c$var$load("QTjdE")
]).then(()=>parcelRequire('awmxy'));

});

parcelRegister("32iGc", function(module, exports) {

let $23600c6988a35f72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $23600c6988a35f72$var$load("asvK9"),
    $23600c6988a35f72$var$load("barSq"),
    $23600c6988a35f72$var$load("aBa7j"),
    $23600c6988a35f72$var$load("gctEz"),
    $23600c6988a35f72$var$load("hPZE5"),
    $23600c6988a35f72$var$load("QTjdE")
]).then(()=>parcelRequire('8svQx'));

});

parcelRegister("3Y0WQ", function(module, exports) {

let $2e37b5f453ab3d00$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2e37b5f453ab3d00$var$load("asvK9"),
    $2e37b5f453ab3d00$var$load("barSq"),
    $2e37b5f453ab3d00$var$load("aBa7j"),
    $2e37b5f453ab3d00$var$load("gctEz"),
    $2e37b5f453ab3d00$var$load("hPZE5"),
    $2e37b5f453ab3d00$var$load("QTjdE")
]).then(()=>parcelRequire('cyKX8'));

});

parcelRegister("98RbQ", function(module, exports) {

let $6a7e1eda20606cfa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6a7e1eda20606cfa$var$load("asvK9"),
    $6a7e1eda20606cfa$var$load("barSq"),
    $6a7e1eda20606cfa$var$load("aBa7j"),
    $6a7e1eda20606cfa$var$load("gctEz"),
    $6a7e1eda20606cfa$var$load("hPZE5"),
    $6a7e1eda20606cfa$var$load("QTjdE")
]).then(()=>parcelRequire('g0mXN'));

});

parcelRegister("fFZZA", function(module, exports) {

let $b69ac5b998e85ad2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b69ac5b998e85ad2$var$load("asvK9"),
    $b69ac5b998e85ad2$var$load("barSq"),
    $b69ac5b998e85ad2$var$load("aBa7j"),
    $b69ac5b998e85ad2$var$load("gctEz"),
    $b69ac5b998e85ad2$var$load("hPZE5"),
    $b69ac5b998e85ad2$var$load("QTjdE")
]).then(()=>parcelRequire('6P5eq'));

});

parcelRegister("xH2GM", function(module, exports) {

let $0654788005ad7ebc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0654788005ad7ebc$var$load("asvK9"),
    $0654788005ad7ebc$var$load("barSq"),
    $0654788005ad7ebc$var$load("aBa7j"),
    $0654788005ad7ebc$var$load("gctEz"),
    $0654788005ad7ebc$var$load("hPZE5"),
    $0654788005ad7ebc$var$load("QTjdE")
]).then(()=>parcelRequire('kIPzK'));

});

parcelRegister("iBKof", function(module, exports) {

let $d8bfaad243069cf6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d8bfaad243069cf6$var$load("asvK9"),
    $d8bfaad243069cf6$var$load("barSq"),
    $d8bfaad243069cf6$var$load("aBa7j"),
    $d8bfaad243069cf6$var$load("gctEz"),
    $d8bfaad243069cf6$var$load("hPZE5"),
    $d8bfaad243069cf6$var$load("QTjdE")
]).then(()=>parcelRequire('6nMli'));

});

parcelRegister("jB9y9", function(module, exports) {

let $e448e16e14348ccb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e448e16e14348ccb$var$load("asvK9"),
    $e448e16e14348ccb$var$load("barSq"),
    $e448e16e14348ccb$var$load("aBa7j"),
    $e448e16e14348ccb$var$load("gctEz"),
    $e448e16e14348ccb$var$load("hPZE5"),
    $e448e16e14348ccb$var$load("QTjdE")
]).then(()=>parcelRequire('2HG0n'));

});

parcelRegister("iZu39", function(module, exports) {

let $dd353bc7f01d56c4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dd353bc7f01d56c4$var$load("asvK9"),
    $dd353bc7f01d56c4$var$load("barSq"),
    $dd353bc7f01d56c4$var$load("aBa7j"),
    $dd353bc7f01d56c4$var$load("gctEz"),
    $dd353bc7f01d56c4$var$load("hPZE5"),
    $dd353bc7f01d56c4$var$load("QTjdE")
]).then(()=>parcelRequire('5eDPu'));

});

parcelRegister("gFLJ1", function(module, exports) {

let $c2357ee0282b21d4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c2357ee0282b21d4$var$load("asvK9"),
    $c2357ee0282b21d4$var$load("barSq"),
    $c2357ee0282b21d4$var$load("aBa7j"),
    $c2357ee0282b21d4$var$load("gctEz"),
    $c2357ee0282b21d4$var$load("hPZE5"),
    $c2357ee0282b21d4$var$load("QTjdE")
]).then(()=>parcelRequire('b6CVH'));

});

parcelRegister("1MZwk", function(module, exports) {

let $14d9fed57b395e84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $14d9fed57b395e84$var$load("asvK9"),
    $14d9fed57b395e84$var$load("barSq"),
    $14d9fed57b395e84$var$load("aBa7j"),
    $14d9fed57b395e84$var$load("gctEz"),
    $14d9fed57b395e84$var$load("hPZE5"),
    $14d9fed57b395e84$var$load("QTjdE")
]).then(()=>parcelRequire('3h5xQ'));

});

parcelRegister("g5owg", function(module, exports) {

let $bb60220788faddf0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bb60220788faddf0$var$load("asvK9"),
    $bb60220788faddf0$var$load("barSq"),
    $bb60220788faddf0$var$load("aBa7j"),
    $bb60220788faddf0$var$load("gctEz"),
    $bb60220788faddf0$var$load("hPZE5"),
    $bb60220788faddf0$var$load("QTjdE")
]).then(()=>parcelRequire('hmKw7'));

});

parcelRegister("jAgyb", function(module, exports) {

let $e41e37a709f177e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e41e37a709f177e1$var$load("asvK9"),
    $e41e37a709f177e1$var$load("barSq"),
    $e41e37a709f177e1$var$load("aBa7j"),
    $e41e37a709f177e1$var$load("gctEz"),
    $e41e37a709f177e1$var$load("hPZE5"),
    $e41e37a709f177e1$var$load("QTjdE")
]).then(()=>parcelRequire('4gSIU'));

});

parcelRegister("2fO8a", function(module, exports) {

let $1a43de65836bdd96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1a43de65836bdd96$var$load("asvK9"),
    $1a43de65836bdd96$var$load("barSq"),
    $1a43de65836bdd96$var$load("aBa7j"),
    $1a43de65836bdd96$var$load("gctEz"),
    $1a43de65836bdd96$var$load("hPZE5"),
    $1a43de65836bdd96$var$load("QTjdE")
]).then(()=>parcelRequire('fxhvl'));

});

parcelRegister("4MUUK", function(module, exports) {

let $37c7cb1bf1ee8a3a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $37c7cb1bf1ee8a3a$var$load("asvK9"),
    $37c7cb1bf1ee8a3a$var$load("barSq"),
    $37c7cb1bf1ee8a3a$var$load("aBa7j"),
    $37c7cb1bf1ee8a3a$var$load("gctEz"),
    $37c7cb1bf1ee8a3a$var$load("hPZE5"),
    $37c7cb1bf1ee8a3a$var$load("QTjdE")
]).then(()=>parcelRequire('6OeBV'));

});

parcelRegister("kS9Ey", function(module, exports) {

let $f32056ac58b64e2e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f32056ac58b64e2e$var$load("asvK9"),
    $f32056ac58b64e2e$var$load("barSq"),
    $f32056ac58b64e2e$var$load("aBa7j"),
    $f32056ac58b64e2e$var$load("gctEz"),
    $f32056ac58b64e2e$var$load("hPZE5"),
    $f32056ac58b64e2e$var$load("QTjdE")
]).then(()=>parcelRequire('efuMl'));

});

parcelRegister("bWVFp", function(module, exports) {

let $8b31d7f10cd1f838$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8b31d7f10cd1f838$var$load("asvK9"),
    $8b31d7f10cd1f838$var$load("barSq"),
    $8b31d7f10cd1f838$var$load("aBa7j"),
    $8b31d7f10cd1f838$var$load("gctEz"),
    $8b31d7f10cd1f838$var$load("hPZE5"),
    $8b31d7f10cd1f838$var$load("QTjdE")
]).then(()=>parcelRequire('2VuDR'));

});

parcelRegister("hejHg", function(module, exports) {

let $c8b305d744dea240$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c8b305d744dea240$var$load("asvK9"),
    $c8b305d744dea240$var$load("barSq"),
    $c8b305d744dea240$var$load("aBa7j"),
    $c8b305d744dea240$var$load("gctEz"),
    $c8b305d744dea240$var$load("hPZE5"),
    $c8b305d744dea240$var$load("QTjdE")
]).then(()=>parcelRequire('4xpHa'));

});

parcelRegister("5K6uD", function(module, exports) {

let $42e6490c19d9c3b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $42e6490c19d9c3b2$var$load("asvK9"),
    $42e6490c19d9c3b2$var$load("barSq"),
    $42e6490c19d9c3b2$var$load("aBa7j"),
    $42e6490c19d9c3b2$var$load("gctEz"),
    $42e6490c19d9c3b2$var$load("hPZE5"),
    $42e6490c19d9c3b2$var$load("QTjdE")
]).then(()=>parcelRequire('cQCfJ'));

});

parcelRegister("18fJW", function(module, exports) {

let $0d32bf69ff611d4c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0d32bf69ff611d4c$var$load("asvK9"),
    $0d32bf69ff611d4c$var$load("barSq"),
    $0d32bf69ff611d4c$var$load("aBa7j"),
    $0d32bf69ff611d4c$var$load("gctEz"),
    $0d32bf69ff611d4c$var$load("hPZE5"),
    $0d32bf69ff611d4c$var$load("QTjdE")
]).then(()=>parcelRequire('jKcej'));

});

parcelRegister("9T6gR", function(module, exports) {

let $732e1d61b2131389$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $732e1d61b2131389$var$load("asvK9"),
    $732e1d61b2131389$var$load("barSq"),
    $732e1d61b2131389$var$load("aBa7j"),
    $732e1d61b2131389$var$load("gctEz"),
    $732e1d61b2131389$var$load("hPZE5"),
    $732e1d61b2131389$var$load("QTjdE")
]).then(()=>parcelRequire('e0Zsu'));

});

parcelRegister("a5W4o", function(module, exports) {

let $01e589f9b55f4574$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $01e589f9b55f4574$var$load("asvK9"),
    $01e589f9b55f4574$var$load("barSq"),
    $01e589f9b55f4574$var$load("aBa7j"),
    $01e589f9b55f4574$var$load("gctEz"),
    $01e589f9b55f4574$var$load("hPZE5"),
    $01e589f9b55f4574$var$load("QTjdE")
]).then(()=>parcelRequire('3Aus6'));

});

parcelRegister("3UlWm", function(module, exports) {

let $2d879eed79672d74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2d879eed79672d74$var$load("asvK9"),
    $2d879eed79672d74$var$load("barSq"),
    $2d879eed79672d74$var$load("aBa7j"),
    $2d879eed79672d74$var$load("gctEz"),
    $2d879eed79672d74$var$load("hPZE5"),
    $2d879eed79672d74$var$load("QTjdE")
]).then(()=>parcelRequire('jhqSm'));

});

parcelRegister("gSP59", function(module, exports) {

let $c4a950583758ed8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c4a950583758ed8f$var$load("asvK9"),
    $c4a950583758ed8f$var$load("barSq"),
    $c4a950583758ed8f$var$load("aBa7j"),
    $c4a950583758ed8f$var$load("gctEz"),
    $c4a950583758ed8f$var$load("hPZE5"),
    $c4a950583758ed8f$var$load("QTjdE")
]).then(()=>parcelRequire('6B9u2'));

});

parcelRegister("jx6sy", function(module, exports) {

let $e3861c2384e5878a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e3861c2384e5878a$var$load("asvK9"),
    $e3861c2384e5878a$var$load("barSq"),
    $e3861c2384e5878a$var$load("aBa7j"),
    $e3861c2384e5878a$var$load("gctEz"),
    $e3861c2384e5878a$var$load("hPZE5"),
    $e3861c2384e5878a$var$load("QTjdE")
]).then(()=>parcelRequire('hoy0J'));

});

parcelRegister("ee9aR", function(module, exports) {

let $a5b97d4a1840f1a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a5b97d4a1840f1a3$var$load("asvK9"),
    $a5b97d4a1840f1a3$var$load("barSq"),
    $a5b97d4a1840f1a3$var$load("aBa7j"),
    $a5b97d4a1840f1a3$var$load("gctEz"),
    $a5b97d4a1840f1a3$var$load("hPZE5"),
    $a5b97d4a1840f1a3$var$load("QTjdE")
]).then(()=>parcelRequire('dA2b2'));

});

parcelRegister("45KR4", function(module, exports) {

let $2fabf973f1231b28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2fabf973f1231b28$var$load("asvK9"),
    $2fabf973f1231b28$var$load("barSq"),
    $2fabf973f1231b28$var$load("aBa7j"),
    $2fabf973f1231b28$var$load("gctEz"),
    $2fabf973f1231b28$var$load("hPZE5"),
    $2fabf973f1231b28$var$load("QTjdE")
]).then(()=>parcelRequire('1r0I7'));

});

parcelRegister("lhlg8", function(module, exports) {

let $f7dbad288c4818aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f7dbad288c4818aa$var$load("asvK9"),
    $f7dbad288c4818aa$var$load("barSq"),
    $f7dbad288c4818aa$var$load("aBa7j"),
    $f7dbad288c4818aa$var$load("gctEz"),
    $f7dbad288c4818aa$var$load("hPZE5"),
    $f7dbad288c4818aa$var$load("QTjdE")
]).then(()=>parcelRequire('gfHfa'));

});

parcelRegister("7SSt6", function(module, exports) {

let $5bd7d3d65d0a1a35$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5bd7d3d65d0a1a35$var$load("asvK9"),
    $5bd7d3d65d0a1a35$var$load("barSq"),
    $5bd7d3d65d0a1a35$var$load("aBa7j"),
    $5bd7d3d65d0a1a35$var$load("gctEz"),
    $5bd7d3d65d0a1a35$var$load("hPZE5"),
    $5bd7d3d65d0a1a35$var$load("QTjdE")
]).then(()=>parcelRequire('6XPyl'));

});

parcelRegister("bP4ZN", function(module, exports) {

let $89b8552f55a97b85$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $89b8552f55a97b85$var$load("asvK9"),
    $89b8552f55a97b85$var$load("barSq"),
    $89b8552f55a97b85$var$load("aBa7j"),
    $89b8552f55a97b85$var$load("gctEz"),
    $89b8552f55a97b85$var$load("hPZE5"),
    $89b8552f55a97b85$var$load("QTjdE")
]).then(()=>parcelRequire('avxFh'));

});

parcelRegister("dpA9w", function(module, exports) {

let $02850f15fe271e1b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $02850f15fe271e1b$var$load("asvK9"),
    $02850f15fe271e1b$var$load("barSq"),
    $02850f15fe271e1b$var$load("aBa7j"),
    $02850f15fe271e1b$var$load("gctEz"),
    $02850f15fe271e1b$var$load("hPZE5"),
    $02850f15fe271e1b$var$load("QTjdE")
]).then(()=>parcelRequire('kqXAv'));

});

parcelRegister("eGaQ6", function(module, exports) {

let $aafd65699c0b5db4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aafd65699c0b5db4$var$load("asvK9"),
    $aafd65699c0b5db4$var$load("barSq"),
    $aafd65699c0b5db4$var$load("aBa7j"),
    $aafd65699c0b5db4$var$load("gctEz"),
    $aafd65699c0b5db4$var$load("hPZE5"),
    $aafd65699c0b5db4$var$load("QTjdE")
]).then(()=>parcelRequire('i6wRd'));

});

parcelRegister("dufY6", function(module, exports) {

let $9d1a76b1c87e5122$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9d1a76b1c87e5122$var$load("asvK9"),
    $9d1a76b1c87e5122$var$load("barSq"),
    $9d1a76b1c87e5122$var$load("aBa7j"),
    $9d1a76b1c87e5122$var$load("gctEz"),
    $9d1a76b1c87e5122$var$load("hPZE5"),
    $9d1a76b1c87e5122$var$load("QTjdE")
]).then(()=>parcelRequire('kEEFk'));

});

parcelRegister("8DgxY", function(module, exports) {

let $648ecd25d45c9401$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $648ecd25d45c9401$var$load("asvK9"),
    $648ecd25d45c9401$var$load("barSq"),
    $648ecd25d45c9401$var$load("aBa7j"),
    $648ecd25d45c9401$var$load("gctEz"),
    $648ecd25d45c9401$var$load("hPZE5"),
    $648ecd25d45c9401$var$load("QTjdE")
]).then(()=>parcelRequire('iC8rz'));

});

parcelRegister("eWf9o", function(module, exports) {

let $ae023c0c75f31bd9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ae023c0c75f31bd9$var$load("asvK9"),
    $ae023c0c75f31bd9$var$load("barSq"),
    $ae023c0c75f31bd9$var$load("aBa7j"),
    $ae023c0c75f31bd9$var$load("gctEz"),
    $ae023c0c75f31bd9$var$load("hPZE5"),
    $ae023c0c75f31bd9$var$load("QTjdE")
]).then(()=>parcelRequire('eoZsz'));

});

parcelRegister("NF1yG", function(module, exports) {

let $09546641ba17d509$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $09546641ba17d509$var$load("asvK9"),
    $09546641ba17d509$var$load("barSq"),
    $09546641ba17d509$var$load("aBa7j"),
    $09546641ba17d509$var$load("gctEz"),
    $09546641ba17d509$var$load("hPZE5"),
    $09546641ba17d509$var$load("QTjdE")
]).then(()=>parcelRequire('e9SeI'));

});

parcelRegister("gVudA", function(module, exports) {

let $c52968e24f2b7ae9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c52968e24f2b7ae9$var$load("aEpRh"),
    $c52968e24f2b7ae9$var$load("6hlNE"),
    $c52968e24f2b7ae9$var$load("K6fhx"),
    $c52968e24f2b7ae9$var$load("1y1eN"),
    $c52968e24f2b7ae9$var$load("jqwnR"),
    $c52968e24f2b7ae9$var$load("lsloj")
]).then(()=>parcelRequire('lT2Hu'));

});

parcelRegister("cvgc1", function(module, exports) {

let $02595eb94f86acde$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $02595eb94f86acde$var$load("aEpRh"),
    $02595eb94f86acde$var$load("6hlNE"),
    $02595eb94f86acde$var$load("K6fhx"),
    $02595eb94f86acde$var$load("1y1eN"),
    $02595eb94f86acde$var$load("jqwnR"),
    $02595eb94f86acde$var$load("lsloj")
]).then(()=>parcelRequire('4mCP6'));

});

parcelRegister("eoZ7g", function(module, exports) {

let $a7c2b6f95560fd08$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a7c2b6f95560fd08$var$load("aEpRh"),
    $a7c2b6f95560fd08$var$load("6hlNE"),
    $a7c2b6f95560fd08$var$load("K6fhx"),
    $a7c2b6f95560fd08$var$load("1y1eN"),
    $a7c2b6f95560fd08$var$load("jqwnR"),
    $a7c2b6f95560fd08$var$load("lsloj")
]).then(()=>parcelRequire('9YE9p'));

});

parcelRegister("1zBiF", function(module, exports) {

let $1255fe5ef1d1d860$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1255fe5ef1d1d860$var$load("aEpRh"),
    $1255fe5ef1d1d860$var$load("6hlNE"),
    $1255fe5ef1d1d860$var$load("K6fhx"),
    $1255fe5ef1d1d860$var$load("1y1eN"),
    $1255fe5ef1d1d860$var$load("jqwnR"),
    $1255fe5ef1d1d860$var$load("lsloj")
]).then(()=>parcelRequire('ceO1g'));

});

parcelRegister("9fkYT", function(module, exports) {

let $6bb5ca2b4502f6ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6bb5ca2b4502f6ec$var$load("aEpRh"),
    $6bb5ca2b4502f6ec$var$load("6hlNE"),
    $6bb5ca2b4502f6ec$var$load("K6fhx"),
    $6bb5ca2b4502f6ec$var$load("1y1eN"),
    $6bb5ca2b4502f6ec$var$load("jqwnR"),
    $6bb5ca2b4502f6ec$var$load("lsloj")
]).then(()=>parcelRequire('d7PIu'));

});

parcelRegister("8jWMf", function(module, exports) {

let $60edb0fb82357c18$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $60edb0fb82357c18$var$load("aEpRh"),
    $60edb0fb82357c18$var$load("6hlNE"),
    $60edb0fb82357c18$var$load("K6fhx"),
    $60edb0fb82357c18$var$load("1y1eN"),
    $60edb0fb82357c18$var$load("jqwnR"),
    $60edb0fb82357c18$var$load("lsloj")
]).then(()=>parcelRequire('jZWJw'));

});

parcelRegister("29zH2", function(module, exports) {

let $19181bf0ae788ae1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $19181bf0ae788ae1$var$load("aEpRh"),
    $19181bf0ae788ae1$var$load("6hlNE"),
    $19181bf0ae788ae1$var$load("K6fhx"),
    $19181bf0ae788ae1$var$load("1y1eN"),
    $19181bf0ae788ae1$var$load("jqwnR"),
    $19181bf0ae788ae1$var$load("lsloj")
]).then(()=>parcelRequire('kn4iW'));

});

parcelRegister("73k0F", function(module, exports) {

let $522855b77bdc07d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $522855b77bdc07d2$var$load("aEpRh"),
    $522855b77bdc07d2$var$load("6hlNE"),
    $522855b77bdc07d2$var$load("K6fhx"),
    $522855b77bdc07d2$var$load("1y1eN"),
    $522855b77bdc07d2$var$load("jqwnR"),
    $522855b77bdc07d2$var$load("lsloj")
]).then(()=>parcelRequire('8sMYh'));

});

parcelRegister("4X4g9", function(module, exports) {

let $39aff9f878864028$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $39aff9f878864028$var$load("aEpRh"),
    $39aff9f878864028$var$load("6hlNE"),
    $39aff9f878864028$var$load("K6fhx"),
    $39aff9f878864028$var$load("1y1eN"),
    $39aff9f878864028$var$load("jqwnR"),
    $39aff9f878864028$var$load("lsloj")
]).then(()=>parcelRequire('ccyLS'));

});

parcelRegister("jwi97", function(module, exports) {

let $e35f14efc6716683$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e35f14efc6716683$var$load("aEpRh"),
    $e35f14efc6716683$var$load("6hlNE"),
    $e35f14efc6716683$var$load("K6fhx"),
    $e35f14efc6716683$var$load("1y1eN"),
    $e35f14efc6716683$var$load("jqwnR"),
    $e35f14efc6716683$var$load("lsloj")
]).then(()=>parcelRequire('6Jsp2'));

});

parcelRegister("7PxsC", function(module, exports) {

let $5b37406a22c0e05e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5b37406a22c0e05e$var$load("aEpRh"),
    $5b37406a22c0e05e$var$load("6hlNE"),
    $5b37406a22c0e05e$var$load("K6fhx"),
    $5b37406a22c0e05e$var$load("1y1eN"),
    $5b37406a22c0e05e$var$load("jqwnR"),
    $5b37406a22c0e05e$var$load("lsloj")
]).then(()=>parcelRequire('l6esU'));

});

parcelRegister("9yoPQ", function(module, exports) {

let $6f4a8dc67b14a908$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6f4a8dc67b14a908$var$load("aEpRh"),
    $6f4a8dc67b14a908$var$load("6hlNE"),
    $6f4a8dc67b14a908$var$load("K6fhx"),
    $6f4a8dc67b14a908$var$load("1y1eN"),
    $6f4a8dc67b14a908$var$load("jqwnR"),
    $6f4a8dc67b14a908$var$load("lsloj")
]).then(()=>parcelRequire('gQG16'));

});

parcelRegister("lkZoc", function(module, exports) {

let $f88b15e3a61b6c3e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f88b15e3a61b6c3e$var$load("aEpRh"),
    $f88b15e3a61b6c3e$var$load("6hlNE"),
    $f88b15e3a61b6c3e$var$load("K6fhx"),
    $f88b15e3a61b6c3e$var$load("1y1eN"),
    $f88b15e3a61b6c3e$var$load("jqwnR"),
    $f88b15e3a61b6c3e$var$load("lsloj")
]).then(()=>parcelRequire('2ePcG'));

});

parcelRegister("3G17e", function(module, exports) {

let $2ad628dca7171ba6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2ad628dca7171ba6$var$load("aEpRh"),
    $2ad628dca7171ba6$var$load("6hlNE"),
    $2ad628dca7171ba6$var$load("K6fhx"),
    $2ad628dca7171ba6$var$load("1y1eN"),
    $2ad628dca7171ba6$var$load("jqwnR"),
    $2ad628dca7171ba6$var$load("lsloj")
]).then(()=>parcelRequire('bJYvw'));

});

parcelRegister("3pPwF", function(module, exports) {

let $27cbace410f047ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $27cbace410f047ac$var$load("aEpRh"),
    $27cbace410f047ac$var$load("6hlNE"),
    $27cbace410f047ac$var$load("K6fhx"),
    $27cbace410f047ac$var$load("1y1eN"),
    $27cbace410f047ac$var$load("jqwnR"),
    $27cbace410f047ac$var$load("lsloj")
]).then(()=>parcelRequire('lbM8c'));

});

parcelRegister("lvXhC", function(module, exports) {

let $fa9a7a9bf6f275d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fa9a7a9bf6f275d1$var$load("aEpRh"),
    $fa9a7a9bf6f275d1$var$load("6hlNE"),
    $fa9a7a9bf6f275d1$var$load("K6fhx"),
    $fa9a7a9bf6f275d1$var$load("1y1eN"),
    $fa9a7a9bf6f275d1$var$load("jqwnR"),
    $fa9a7a9bf6f275d1$var$load("lsloj")
]).then(()=>parcelRequire('dXAEg'));

});

parcelRegister("edVEs", function(module, exports) {

let $a5aefff880dbad90$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a5aefff880dbad90$var$load("aEpRh"),
    $a5aefff880dbad90$var$load("6hlNE"),
    $a5aefff880dbad90$var$load("K6fhx"),
    $a5aefff880dbad90$var$load("1y1eN"),
    $a5aefff880dbad90$var$load("jqwnR"),
    $a5aefff880dbad90$var$load("lsloj")
]).then(()=>parcelRequire('e2qmK'));

});

parcelRegister("7OuiO", function(module, exports) {

let $5b04b55d43639a93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5b04b55d43639a93$var$load("aEpRh"),
    $5b04b55d43639a93$var$load("6hlNE"),
    $5b04b55d43639a93$var$load("K6fhx"),
    $5b04b55d43639a93$var$load("1y1eN"),
    $5b04b55d43639a93$var$load("jqwnR"),
    $5b04b55d43639a93$var$load("lsloj")
]).then(()=>parcelRequire('4DbYK'));

});

parcelRegister("alhJp", function(module, exports) {

let $78799e9d9c95931a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $78799e9d9c95931a$var$load("aEpRh"),
    $78799e9d9c95931a$var$load("6hlNE"),
    $78799e9d9c95931a$var$load("K6fhx"),
    $78799e9d9c95931a$var$load("1y1eN"),
    $78799e9d9c95931a$var$load("jqwnR"),
    $78799e9d9c95931a$var$load("lsloj")
]).then(()=>parcelRequire('5Ml5D'));

});

parcelRegister("cFUs5", function(module, exports) {

let $93a51a96e34ab000$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $93a51a96e34ab000$var$load("aEpRh"),
    $93a51a96e34ab000$var$load("6hlNE"),
    $93a51a96e34ab000$var$load("K6fhx"),
    $93a51a96e34ab000$var$load("1y1eN"),
    $93a51a96e34ab000$var$load("jqwnR"),
    $93a51a96e34ab000$var$load("lsloj")
]).then(()=>parcelRequire('43DFy'));

});

parcelRegister("acCtp", function(module, exports) {

let $76d8de647336e2d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $76d8de647336e2d2$var$load("aEpRh"),
    $76d8de647336e2d2$var$load("6hlNE"),
    $76d8de647336e2d2$var$load("K6fhx"),
    $76d8de647336e2d2$var$load("1y1eN"),
    $76d8de647336e2d2$var$load("jqwnR"),
    $76d8de647336e2d2$var$load("lsloj")
]).then(()=>parcelRequire('2HTKD'));

});

parcelRegister("kbyT1", function(module, exports) {

let $eb1fe577e124e71d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eb1fe577e124e71d$var$load("aEpRh"),
    $eb1fe577e124e71d$var$load("6hlNE"),
    $eb1fe577e124e71d$var$load("K6fhx"),
    $eb1fe577e124e71d$var$load("1y1eN"),
    $eb1fe577e124e71d$var$load("jqwnR"),
    $eb1fe577e124e71d$var$load("lsloj")
]).then(()=>parcelRequire('btBdP'));

});

parcelRegister("6YnnP", function(module, exports) {

let $513a7c1a5e866b87$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $513a7c1a5e866b87$var$load("aEpRh"),
    $513a7c1a5e866b87$var$load("6hlNE"),
    $513a7c1a5e866b87$var$load("K6fhx"),
    $513a7c1a5e866b87$var$load("1y1eN"),
    $513a7c1a5e866b87$var$load("jqwnR"),
    $513a7c1a5e866b87$var$load("lsloj")
]).then(()=>parcelRequire('j4Ddr'));

});

parcelRegister("licQg", function(module, exports) {

let $f8053d907f32e2f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f8053d907f32e2f9$var$load("aEpRh"),
    $f8053d907f32e2f9$var$load("6hlNE"),
    $f8053d907f32e2f9$var$load("K6fhx"),
    $f8053d907f32e2f9$var$load("1y1eN"),
    $f8053d907f32e2f9$var$load("jqwnR"),
    $f8053d907f32e2f9$var$load("lsloj")
]).then(()=>parcelRequire('2Tt6k'));

});

parcelRegister("aSDlt", function(module, exports) {

let $7ebd77b5c1b47187$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7ebd77b5c1b47187$var$load("aEpRh"),
    $7ebd77b5c1b47187$var$load("6hlNE"),
    $7ebd77b5c1b47187$var$load("K6fhx"),
    $7ebd77b5c1b47187$var$load("1y1eN"),
    $7ebd77b5c1b47187$var$load("jqwnR"),
    $7ebd77b5c1b47187$var$load("lsloj")
]).then(()=>parcelRequire('AwwmO'));

});

parcelRegister("6la3D", function(module, exports) {

let $49dc81808c26c17e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $49dc81808c26c17e$var$load("aEpRh"),
    $49dc81808c26c17e$var$load("6hlNE"),
    $49dc81808c26c17e$var$load("K6fhx"),
    $49dc81808c26c17e$var$load("1y1eN"),
    $49dc81808c26c17e$var$load("jqwnR"),
    $49dc81808c26c17e$var$load("lsloj")
]).then(()=>parcelRequire('8VEyH'));

});

parcelRegister("kCQLZ", function(module, exports) {

let $f0404ae71b83a923$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f0404ae71b83a923$var$load("aEpRh"),
    $f0404ae71b83a923$var$load("6hlNE"),
    $f0404ae71b83a923$var$load("K6fhx"),
    $f0404ae71b83a923$var$load("1y1eN"),
    $f0404ae71b83a923$var$load("jqwnR"),
    $f0404ae71b83a923$var$load("lsloj")
]).then(()=>parcelRequire('hfcD3'));

});

parcelRegister("i3EHa", function(module, exports) {

let $d25813087693980e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d25813087693980e$var$load("aEpRh"),
    $d25813087693980e$var$load("6hlNE"),
    $d25813087693980e$var$load("K6fhx"),
    $d25813087693980e$var$load("1y1eN"),
    $d25813087693980e$var$load("jqwnR"),
    $d25813087693980e$var$load("lsloj")
]).then(()=>parcelRequire('dM6Op'));

});

parcelRegister("jAjQ2", function(module, exports) {

let $e420c491a49c55cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e420c491a49c55cd$var$load("aEpRh"),
    $e420c491a49c55cd$var$load("6hlNE"),
    $e420c491a49c55cd$var$load("K6fhx"),
    $e420c491a49c55cd$var$load("1y1eN"),
    $e420c491a49c55cd$var$load("jqwnR"),
    $e420c491a49c55cd$var$load("lsloj")
]).then(()=>parcelRequire('lTErn'));

});

parcelRegister("eVRAq", function(module, exports) {

let $adeff4b9ba27adbe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $adeff4b9ba27adbe$var$load("aEpRh"),
    $adeff4b9ba27adbe$var$load("6hlNE"),
    $adeff4b9ba27adbe$var$load("K6fhx"),
    $adeff4b9ba27adbe$var$load("1y1eN"),
    $adeff4b9ba27adbe$var$load("jqwnR"),
    $adeff4b9ba27adbe$var$load("lsloj")
]).then(()=>parcelRequire('auxnr'));

});

parcelRegister("isq2S", function(module, exports) {

let $d6ff0b9b255fe6fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d6ff0b9b255fe6fd$var$load("aEpRh"),
    $d6ff0b9b255fe6fd$var$load("6hlNE"),
    $d6ff0b9b255fe6fd$var$load("K6fhx"),
    $d6ff0b9b255fe6fd$var$load("1y1eN"),
    $d6ff0b9b255fe6fd$var$load("jqwnR"),
    $d6ff0b9b255fe6fd$var$load("lsloj")
]).then(()=>parcelRequire('cEBS3'));

});

parcelRegister("gOoQN", function(module, exports) {

let $c3d497adffbf8c37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c3d497adffbf8c37$var$load("aEpRh"),
    $c3d497adffbf8c37$var$load("6hlNE"),
    $c3d497adffbf8c37$var$load("K6fhx"),
    $c3d497adffbf8c37$var$load("1y1eN"),
    $c3d497adffbf8c37$var$load("jqwnR"),
    $c3d497adffbf8c37$var$load("lsloj")
]).then(()=>parcelRequire('ceQnS'));

});

parcelRegister("5FIM9", function(module, exports) {

let $4213839249c4a8e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4213839249c4a8e1$var$load("aEpRh"),
    $4213839249c4a8e1$var$load("6hlNE"),
    $4213839249c4a8e1$var$load("K6fhx"),
    $4213839249c4a8e1$var$load("1y1eN"),
    $4213839249c4a8e1$var$load("jqwnR"),
    $4213839249c4a8e1$var$load("lsloj")
]).then(()=>parcelRequire('5Fevi'));

});

parcelRegister("hLynJ", function(module, exports) {

let $cef17ef9db6fbaff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cef17ef9db6fbaff$var$load("aEpRh"),
    $cef17ef9db6fbaff$var$load("6hlNE"),
    $cef17ef9db6fbaff$var$load("K6fhx"),
    $cef17ef9db6fbaff$var$load("1y1eN"),
    $cef17ef9db6fbaff$var$load("jqwnR"),
    $cef17ef9db6fbaff$var$load("lsloj")
]).then(()=>parcelRequire('bQfJF'));

});

parcelRegister("68y2U", function(module, exports) {

let $477de64270be0a99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $477de64270be0a99$var$load("aEpRh"),
    $477de64270be0a99$var$load("6hlNE"),
    $477de64270be0a99$var$load("K6fhx"),
    $477de64270be0a99$var$load("1y1eN"),
    $477de64270be0a99$var$load("jqwnR"),
    $477de64270be0a99$var$load("lsloj")
]).then(()=>parcelRequire('f0ujF'));

});

parcelRegister("dfrAP", function(module, exports) {

let $9a521477235df4cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9a521477235df4cc$var$load("aEpRh"),
    $9a521477235df4cc$var$load("6hlNE"),
    $9a521477235df4cc$var$load("K6fhx"),
    $9a521477235df4cc$var$load("1y1eN"),
    $9a521477235df4cc$var$load("jqwnR"),
    $9a521477235df4cc$var$load("lsloj")
]).then(()=>parcelRequire('eJjTT'));

});

parcelRegister("f0q8G", function(module, exports) {

let $aecb21c3f6b50f1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aecb21c3f6b50f1f$var$load("aEpRh"),
    $aecb21c3f6b50f1f$var$load("6hlNE"),
    $aecb21c3f6b50f1f$var$load("K6fhx"),
    $aecb21c3f6b50f1f$var$load("1y1eN"),
    $aecb21c3f6b50f1f$var$load("jqwnR"),
    $aecb21c3f6b50f1f$var$load("lsloj")
]).then(()=>parcelRequire('aY2UQ'));

});

parcelRegister("7IZCm", function(module, exports) {

let $59fc7072be340846$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $59fc7072be340846$var$load("aEpRh"),
    $59fc7072be340846$var$load("6hlNE"),
    $59fc7072be340846$var$load("K6fhx"),
    $59fc7072be340846$var$load("1y1eN"),
    $59fc7072be340846$var$load("jqwnR"),
    $59fc7072be340846$var$load("lsloj")
]).then(()=>parcelRequire('kzj9p'));

});

parcelRegister("5oFEH", function(module, exports) {

let $3edf818c2aa7aadf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3edf818c2aa7aadf$var$load("aEpRh"),
    $3edf818c2aa7aadf$var$load("6hlNE"),
    $3edf818c2aa7aadf$var$load("K6fhx"),
    $3edf818c2aa7aadf$var$load("1y1eN"),
    $3edf818c2aa7aadf$var$load("jqwnR"),
    $3edf818c2aa7aadf$var$load("lsloj")
]).then(()=>parcelRequire('66Wlt'));

});

parcelRegister("3OUob", function(module, exports) {

let $2c81c84c5012e80c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2c81c84c5012e80c$var$load("aEpRh"),
    $2c81c84c5012e80c$var$load("6hlNE"),
    $2c81c84c5012e80c$var$load("K6fhx"),
    $2c81c84c5012e80c$var$load("1y1eN"),
    $2c81c84c5012e80c$var$load("jqwnR"),
    $2c81c84c5012e80c$var$load("lsloj")
]).then(()=>parcelRequire('1T1Uj'));

});

parcelRegister("8ihmZ", function(module, exports) {

let $609d7a75361e3637$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $609d7a75361e3637$var$load("aEpRh"),
    $609d7a75361e3637$var$load("6hlNE"),
    $609d7a75361e3637$var$load("K6fhx"),
    $609d7a75361e3637$var$load("1y1eN"),
    $609d7a75361e3637$var$load("jqwnR"),
    $609d7a75361e3637$var$load("lsloj")
]).then(()=>parcelRequire('dsuKz'));

});

parcelRegister("eKt5X", function(module, exports) {

let $abcbee3d59cf3e42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $abcbee3d59cf3e42$var$load("aEpRh"),
    $abcbee3d59cf3e42$var$load("6hlNE"),
    $abcbee3d59cf3e42$var$load("K6fhx"),
    $abcbee3d59cf3e42$var$load("1y1eN"),
    $abcbee3d59cf3e42$var$load("jqwnR"),
    $abcbee3d59cf3e42$var$load("lsloj")
]).then(()=>parcelRequire('aBfCL'));

});

parcelRegister("dMfhL", function(module, exports) {

let $a07b9d7369c6f702$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a07b9d7369c6f702$var$load("aEpRh"),
    $a07b9d7369c6f702$var$load("6hlNE"),
    $a07b9d7369c6f702$var$load("K6fhx"),
    $a07b9d7369c6f702$var$load("1y1eN"),
    $a07b9d7369c6f702$var$load("jqwnR"),
    $a07b9d7369c6f702$var$load("lsloj")
]).then(()=>parcelRequire('dYQdg'));

});

parcelRegister("b507v", function(module, exports) {

let $8110412e4e0257b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8110412e4e0257b0$var$load("aEpRh"),
    $8110412e4e0257b0$var$load("6hlNE"),
    $8110412e4e0257b0$var$load("K6fhx"),
    $8110412e4e0257b0$var$load("1y1eN"),
    $8110412e4e0257b0$var$load("jqwnR"),
    $8110412e4e0257b0$var$load("lsloj")
]).then(()=>parcelRequire('bJrI7'));

});

parcelRegister("4bGBS", function(module, exports) {

let $30c93df82573ea5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $30c93df82573ea5d$var$load("aEpRh"),
    $30c93df82573ea5d$var$load("6hlNE"),
    $30c93df82573ea5d$var$load("K6fhx"),
    $30c93df82573ea5d$var$load("1y1eN"),
    $30c93df82573ea5d$var$load("jqwnR"),
    $30c93df82573ea5d$var$load("lsloj")
]).then(()=>parcelRequire('dtgGJ'));

});

parcelRegister("1Avk6", function(module, exports) {

let $12817360dc7b7c01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $12817360dc7b7c01$var$load("aEpRh"),
    $12817360dc7b7c01$var$load("6hlNE"),
    $12817360dc7b7c01$var$load("K6fhx"),
    $12817360dc7b7c01$var$load("1y1eN"),
    $12817360dc7b7c01$var$load("jqwnR"),
    $12817360dc7b7c01$var$load("lsloj")
]).then(()=>parcelRequire('31lwM'));

});

parcelRegister("jxXUD", function(module, exports) {

let $e3af92bc0cec653d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e3af92bc0cec653d$var$load("aEpRh"),
    $e3af92bc0cec653d$var$load("6hlNE"),
    $e3af92bc0cec653d$var$load("K6fhx"),
    $e3af92bc0cec653d$var$load("1y1eN"),
    $e3af92bc0cec653d$var$load("jqwnR"),
    $e3af92bc0cec653d$var$load("lsloj")
]).then(()=>parcelRequire('4QhAY'));

});

parcelRegister("NVO1b", function(module, exports) {

let $09616abbfa2026f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $09616abbfa2026f3$var$load("aEpRh"),
    $09616abbfa2026f3$var$load("6hlNE"),
    $09616abbfa2026f3$var$load("K6fhx"),
    $09616abbfa2026f3$var$load("1y1eN"),
    $09616abbfa2026f3$var$load("jqwnR"),
    $09616abbfa2026f3$var$load("lsloj")
]).then(()=>parcelRequire('2wB7P'));

});

parcelRegister("hZZzn", function(module, exports) {

let $d1a7e49cd2622490$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d1a7e49cd2622490$var$load("aEpRh"),
    $d1a7e49cd2622490$var$load("6hlNE"),
    $d1a7e49cd2622490$var$load("K6fhx"),
    $d1a7e49cd2622490$var$load("1y1eN"),
    $d1a7e49cd2622490$var$load("jqwnR"),
    $d1a7e49cd2622490$var$load("lsloj")
]).then(()=>parcelRequire('kHBbC'));

});

parcelRegister("6pemw", function(module, exports) {

let $4aa037e7b5f5d8f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4aa037e7b5f5d8f6$var$load("aEpRh"),
    $4aa037e7b5f5d8f6$var$load("6hlNE"),
    $4aa037e7b5f5d8f6$var$load("K6fhx"),
    $4aa037e7b5f5d8f6$var$load("1y1eN"),
    $4aa037e7b5f5d8f6$var$load("jqwnR"),
    $4aa037e7b5f5d8f6$var$load("lsloj")
]).then(()=>parcelRequire('f20n3'));

});

parcelRegister("g1mTU", function(module, exports) {

let $ba9e80ee90d5496d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ba9e80ee90d5496d$var$load("bSjyK"),
    $ba9e80ee90d5496d$var$load("j6IGj"),
    $ba9e80ee90d5496d$var$load("hlJc4"),
    $ba9e80ee90d5496d$var$load("6tWAg"),
    $ba9e80ee90d5496d$var$load("aOdaf")
]).then(()=>parcelRequire('3o50X'));

});

parcelRegister("2iMjb", function(module, exports) {

let $1ad2bc4599dfe2d4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1ad2bc4599dfe2d4$var$load("bSjyK"),
    $1ad2bc4599dfe2d4$var$load("j6IGj"),
    $1ad2bc4599dfe2d4$var$load("hlJc4"),
    $1ad2bc4599dfe2d4$var$load("6tWAg"),
    $1ad2bc4599dfe2d4$var$load("aOdaf")
]).then(()=>parcelRequire('8chQR'));

});

parcelRegister("40naj", function(module, exports) {

let $2ea921ad3b020765$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2ea921ad3b020765$var$load("bSjyK"),
    $2ea921ad3b020765$var$load("j6IGj"),
    $2ea921ad3b020765$var$load("hlJc4"),
    $2ea921ad3b020765$var$load("6tWAg"),
    $2ea921ad3b020765$var$load("aOdaf")
]).then(()=>parcelRequire('6XTGa'));

});

parcelRegister("Ev419", function(module, exports) {

let $079bd52a4f6d646f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $079bd52a4f6d646f$var$load("bSjyK"),
    $079bd52a4f6d646f$var$load("j6IGj"),
    $079bd52a4f6d646f$var$load("hlJc4"),
    $079bd52a4f6d646f$var$load("6tWAg"),
    $079bd52a4f6d646f$var$load("aOdaf")
]).then(()=>parcelRequire('l9Ug4'));

});

parcelRegister("kdSeN", function(module, exports) {

let $eb8f1805b369f954$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eb8f1805b369f954$var$load("bSjyK"),
    $eb8f1805b369f954$var$load("j6IGj"),
    $eb8f1805b369f954$var$load("hlJc4"),
    $eb8f1805b369f954$var$load("6tWAg"),
    $eb8f1805b369f954$var$load("aOdaf")
]).then(()=>parcelRequire('fkfWe'));

});

parcelRegister("88EVY", function(module, exports) {

let $5eced2b9f8d594cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5eced2b9f8d594cf$var$load("bSjyK"),
    $5eced2b9f8d594cf$var$load("j6IGj"),
    $5eced2b9f8d594cf$var$load("hlJc4"),
    $5eced2b9f8d594cf$var$load("6tWAg"),
    $5eced2b9f8d594cf$var$load("aOdaf")
]).then(()=>parcelRequire('dGjHO'));

});

parcelRegister("gnWy6", function(module, exports) {

let $bedc35efb3734a2c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bedc35efb3734a2c$var$load("bSjyK"),
    $bedc35efb3734a2c$var$load("j6IGj"),
    $bedc35efb3734a2c$var$load("hlJc4"),
    $bedc35efb3734a2c$var$load("6tWAg"),
    $bedc35efb3734a2c$var$load("aOdaf")
]).then(()=>parcelRequire('alf8C'));

});

parcelRegister("7KYU2", function(module, exports) {

let $5a5c1254aeed3684$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5a5c1254aeed3684$var$load("bSjyK"),
    $5a5c1254aeed3684$var$load("j6IGj"),
    $5a5c1254aeed3684$var$load("hlJc4"),
    $5a5c1254aeed3684$var$load("6tWAg"),
    $5a5c1254aeed3684$var$load("aOdaf")
]).then(()=>parcelRequire('eFgEH'));

});

parcelRegister("kou5y", function(module, exports) {

let $ed8d6380431da793$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ed8d6380431da793$var$load("5WkxF").then(()=>parcelRequire('aOLJW'));

});

parcelRegister("3RRnu", function(module, exports) {

let $2d0fba0c2fd26fdf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2d0fba0c2fd26fdf$var$load("5WkxF").then(()=>parcelRequire('g0CZR'));

});

parcelRegister("hzmCK", function(module, exports) {

let $cca74135102cb89c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cca74135102cb89c$var$load("5WkxF").then(()=>parcelRequire('bXFr8'));

});

parcelRegister("1yd01", function(module, exports) {

let $12130cd407a75a20$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $12130cd407a75a20$var$load("5WkxF").then(()=>parcelRequire('4AHSJ'));

});

parcelRegister("dVKWy", function(module, exports) {

let $a245033a20d44784$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a245033a20d44784$var$load("5WkxF").then(()=>parcelRequire('hW2zm'));

});

parcelRegister("9l2PM", function(module, exports) {

let $6cc84600ad161a74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cc84600ad161a74$var$load("5WkxF").then(()=>parcelRequire('46MuN'));

});

parcelRegister("cTdgN", function(module, exports) {

let $9624ea380a10d6f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9624ea380a10d6f3$var$load("5WkxF").then(()=>parcelRequire('jzTw0'));

});

parcelRegister("dcTqb", function(module, exports) {

let $99d762e0c558ead8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99d762e0c558ead8$var$load("5WkxF").then(()=>parcelRequire('e68Bq'));

});

parcelRegister("16noY", function(module, exports) {

let $0cd881153311e092$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0cd881153311e092$var$load("5WkxF").then(()=>parcelRequire('6LMXR'));

});

parcelRegister("eEY1A", function(module, exports) {

let $aac35cb947f381d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aac35cb947f381d0$var$load("5WkxF").then(()=>parcelRequire('3Pvlz'));

});

parcelRegister("9fnFP", function(module, exports) {

let $6bb7e0e2c70cf7fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6bb7e0e2c70cf7fa$var$load("5WkxF").then(()=>parcelRequire('2Ww5O'));

});

parcelRegister("5IJ7c", function(module, exports) {

let $42a40eb9bd792e97$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $42a40eb9bd792e97$var$load("1jsQH"),
    $42a40eb9bd792e97$var$load("bv8GZ"),
    $42a40eb9bd792e97$var$load("i5eMd"),
    $42a40eb9bd792e97$var$load("i9sd0"),
    $42a40eb9bd792e97$var$load("gyXEE"),
    $42a40eb9bd792e97$var$load("hoPZ9")
]).then(()=>parcelRequire('hhErb'));

});

parcelRegister("haekz", function(module, exports) {

let $c7ee7ca1bbea290b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c7ee7ca1bbea290b$var$load("1jsQH"),
    $c7ee7ca1bbea290b$var$load("bv8GZ"),
    $c7ee7ca1bbea290b$var$load("i5eMd"),
    $c7ee7ca1bbea290b$var$load("i9sd0"),
    $c7ee7ca1bbea290b$var$load("gyXEE"),
    $c7ee7ca1bbea290b$var$load("hoPZ9")
]).then(()=>parcelRequire('hNmwG'));

});

parcelRegister("2VLdk", function(module, exports) {

let $22258757c5f55635$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $22258757c5f55635$var$load("1jsQH"),
    $22258757c5f55635$var$load("bv8GZ"),
    $22258757c5f55635$var$load("i5eMd"),
    $22258757c5f55635$var$load("i9sd0"),
    $22258757c5f55635$var$load("gyXEE"),
    $22258757c5f55635$var$load("hoPZ9")
]).then(()=>parcelRequire('5LyIQ'));

});

parcelRegister("l5U9N", function(module, exports) {

let $f5b5a03b8f97fb23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f5b5a03b8f97fb23$var$load("1jsQH"),
    $f5b5a03b8f97fb23$var$load("bv8GZ"),
    $f5b5a03b8f97fb23$var$load("i5eMd"),
    $f5b5a03b8f97fb23$var$load("i9sd0"),
    $f5b5a03b8f97fb23$var$load("gyXEE"),
    $f5b5a03b8f97fb23$var$load("hoPZ9")
]).then(()=>parcelRequire('9YmZU'));

});

parcelRegister("fJeFi", function(module, exports) {

let $b7366f2a54fcf505$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b7366f2a54fcf505$var$load("1jsQH"),
    $b7366f2a54fcf505$var$load("bv8GZ"),
    $b7366f2a54fcf505$var$load("i5eMd"),
    $b7366f2a54fcf505$var$load("i9sd0"),
    $b7366f2a54fcf505$var$load("gyXEE"),
    $b7366f2a54fcf505$var$load("hoPZ9")
]).then(()=>parcelRequire('6Yuab'));

});

parcelRegister("hA8pw", function(module, exports) {

let $cccc52a4eb91e10f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cccc52a4eb91e10f$var$load("1jsQH"),
    $cccc52a4eb91e10f$var$load("bv8GZ"),
    $cccc52a4eb91e10f$var$load("i5eMd"),
    $cccc52a4eb91e10f$var$load("i9sd0"),
    $cccc52a4eb91e10f$var$load("gyXEE"),
    $cccc52a4eb91e10f$var$load("hoPZ9")
]).then(()=>parcelRequire('1vqLd'));

});

parcelRegister("dtwe8", function(module, exports) {

let $9cf6fb64e9c3380a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9cf6fb64e9c3380a$var$load("1jsQH"),
    $9cf6fb64e9c3380a$var$load("bv8GZ"),
    $9cf6fb64e9c3380a$var$load("i5eMd"),
    $9cf6fb64e9c3380a$var$load("i9sd0"),
    $9cf6fb64e9c3380a$var$load("gyXEE"),
    $9cf6fb64e9c3380a$var$load("hoPZ9")
]).then(()=>parcelRequire('fV6QY'));

});

parcelRegister("7hJ4k", function(module, exports) {

let $54dd14a370a92a6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $54dd14a370a92a6d$var$load("1jsQH"),
    $54dd14a370a92a6d$var$load("bv8GZ"),
    $54dd14a370a92a6d$var$load("i5eMd"),
    $54dd14a370a92a6d$var$load("i9sd0"),
    $54dd14a370a92a6d$var$load("gyXEE"),
    $54dd14a370a92a6d$var$load("hoPZ9")
]).then(()=>parcelRequire('k82rV'));

});

parcelRegister("gYY23", function(module, exports) {

let $c5d0d10ef94529b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c5d0d10ef94529b5$var$load("1jsQH"),
    $c5d0d10ef94529b5$var$load("bv8GZ"),
    $c5d0d10ef94529b5$var$load("i5eMd"),
    $c5d0d10ef94529b5$var$load("i9sd0"),
    $c5d0d10ef94529b5$var$load("gyXEE"),
    $c5d0d10ef94529b5$var$load("hoPZ9")
]).then(()=>parcelRequire('fSItB'));

});

parcelRegister("i6DYd", function(module, exports) {

let $d2e7cac62798eb78$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d2e7cac62798eb78$var$load("1jsQH"),
    $d2e7cac62798eb78$var$load("bv8GZ"),
    $d2e7cac62798eb78$var$load("i5eMd"),
    $d2e7cac62798eb78$var$load("i9sd0"),
    $d2e7cac62798eb78$var$load("gyXEE"),
    $d2e7cac62798eb78$var$load("hoPZ9")
]).then(()=>parcelRequire('jLkf4'));

});

parcelRegister("fssKD", function(module, exports) {

let $b40fc5ef3477fbda$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b40fc5ef3477fbda$var$load("1jsQH"),
    $b40fc5ef3477fbda$var$load("bv8GZ"),
    $b40fc5ef3477fbda$var$load("i5eMd"),
    $b40fc5ef3477fbda$var$load("i9sd0"),
    $b40fc5ef3477fbda$var$load("gyXEE"),
    $b40fc5ef3477fbda$var$load("hoPZ9")
]).then(()=>parcelRequire('koRJI'));

});

parcelRegister("epNJv", function(module, exports) {

let $a7e9fa6a25c4195f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a7e9fa6a25c4195f$var$load("1jsQH"),
    $a7e9fa6a25c4195f$var$load("bv8GZ"),
    $a7e9fa6a25c4195f$var$load("i5eMd"),
    $a7e9fa6a25c4195f$var$load("i9sd0"),
    $a7e9fa6a25c4195f$var$load("gyXEE"),
    $a7e9fa6a25c4195f$var$load("hoPZ9")
]).then(()=>parcelRequire('3uAOF'));

});

parcelRegister("jDTSe", function(module, exports) {

let $e4cd002d999f05a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e4cd002d999f05a1$var$load("1jsQH"),
    $e4cd002d999f05a1$var$load("bv8GZ"),
    $e4cd002d999f05a1$var$load("i5eMd"),
    $e4cd002d999f05a1$var$load("i9sd0"),
    $e4cd002d999f05a1$var$load("gyXEE"),
    $e4cd002d999f05a1$var$load("hoPZ9")
]).then(()=>parcelRequire('6gxDB'));

});

parcelRegister("bUjED", function(module, exports) {

let $8ab42ba53ac86143$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8ab42ba53ac86143$var$load("1jsQH"),
    $8ab42ba53ac86143$var$load("bv8GZ"),
    $8ab42ba53ac86143$var$load("i5eMd"),
    $8ab42ba53ac86143$var$load("i9sd0"),
    $8ab42ba53ac86143$var$load("gyXEE"),
    $8ab42ba53ac86143$var$load("hoPZ9")
]).then(()=>parcelRequire('7oLij'));

});

parcelRegister("1D6mn", function(module, exports) {

let $12fe5de564f82284$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $12fe5de564f82284$var$load("1jsQH"),
    $12fe5de564f82284$var$load("bv8GZ"),
    $12fe5de564f82284$var$load("i5eMd"),
    $12fe5de564f82284$var$load("i9sd0"),
    $12fe5de564f82284$var$load("gyXEE"),
    $12fe5de564f82284$var$load("hoPZ9")
]).then(()=>parcelRequire('jdfub'));

});

parcelRegister("lsKzd", function(module, exports) {

let $fa0055b830117d9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fa0055b830117d9b$var$load("1jsQH"),
    $fa0055b830117d9b$var$load("bv8GZ"),
    $fa0055b830117d9b$var$load("i5eMd"),
    $fa0055b830117d9b$var$load("i9sd0"),
    $fa0055b830117d9b$var$load("gyXEE"),
    $fa0055b830117d9b$var$load("hoPZ9")
]).then(()=>parcelRequire('ki92G'));

});

parcelRegister("e6Mh1", function(module, exports) {

let $a457125ee8c27318$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a457125ee8c27318$var$load("1jsQH"),
    $a457125ee8c27318$var$load("bv8GZ"),
    $a457125ee8c27318$var$load("i5eMd"),
    $a457125ee8c27318$var$load("i9sd0"),
    $a457125ee8c27318$var$load("gyXEE"),
    $a457125ee8c27318$var$load("hoPZ9")
]).then(()=>parcelRequire('8Egc9'));

});

parcelRegister("4igGY", function(module, exports) {

let $3205ca8fe9c37f5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3205ca8fe9c37f5a$var$load("1jsQH"),
    $3205ca8fe9c37f5a$var$load("bv8GZ"),
    $3205ca8fe9c37f5a$var$load("i5eMd"),
    $3205ca8fe9c37f5a$var$load("i9sd0"),
    $3205ca8fe9c37f5a$var$load("gyXEE"),
    $3205ca8fe9c37f5a$var$load("hoPZ9")
]).then(()=>parcelRequire('3TQcd'));

});

parcelRegister("kKlml", function(module, exports) {

let $f1a8ac10efd023d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f1a8ac10efd023d3$var$load("1jsQH"),
    $f1a8ac10efd023d3$var$load("bv8GZ"),
    $f1a8ac10efd023d3$var$load("i5eMd"),
    $f1a8ac10efd023d3$var$load("i9sd0"),
    $f1a8ac10efd023d3$var$load("gyXEE"),
    $f1a8ac10efd023d3$var$load("hoPZ9")
]).then(()=>parcelRequire('41dWS'));

});

parcelRegister("55ZbW", function(module, exports) {

let $3b5ce2c51781adee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3b5ce2c51781adee$var$load("1jsQH"),
    $3b5ce2c51781adee$var$load("bv8GZ"),
    $3b5ce2c51781adee$var$load("i5eMd"),
    $3b5ce2c51781adee$var$load("i9sd0"),
    $3b5ce2c51781adee$var$load("gyXEE"),
    $3b5ce2c51781adee$var$load("hoPZ9")
]).then(()=>parcelRequire('kZYBr'));

});

parcelRegister("8QRlX", function(module, exports) {

let $671c90e0786151c7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $671c90e0786151c7$var$load("1jsQH"),
    $671c90e0786151c7$var$load("bv8GZ"),
    $671c90e0786151c7$var$load("i5eMd"),
    $671c90e0786151c7$var$load("i9sd0"),
    $671c90e0786151c7$var$load("gyXEE"),
    $671c90e0786151c7$var$load("hoPZ9")
]).then(()=>parcelRequire('idP3M'));

});

parcelRegister("4UYKE", function(module, exports) {

let $394b845d8ef6b5d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $394b845d8ef6b5d2$var$load("1jsQH"),
    $394b845d8ef6b5d2$var$load("bv8GZ"),
    $394b845d8ef6b5d2$var$load("i5eMd"),
    $394b845d8ef6b5d2$var$load("i9sd0"),
    $394b845d8ef6b5d2$var$load("gyXEE"),
    $394b845d8ef6b5d2$var$load("hoPZ9")
]).then(()=>parcelRequire('3EuZR'));

});

parcelRegister("dmuIJ", function(module, exports) {

let $9ba528df99039f7f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9ba528df99039f7f$var$load("1jsQH"),
    $9ba528df99039f7f$var$load("bv8GZ"),
    $9ba528df99039f7f$var$load("i5eMd"),
    $9ba528df99039f7f$var$load("i9sd0"),
    $9ba528df99039f7f$var$load("gyXEE"),
    $9ba528df99039f7f$var$load("hoPZ9")
]).then(()=>parcelRequire('dYpoo'));

});

parcelRegister("dp0SK", function(module, exports) {

let $9c1e4b4ba09b2def$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9c1e4b4ba09b2def$var$load("1jsQH"),
    $9c1e4b4ba09b2def$var$load("bv8GZ"),
    $9c1e4b4ba09b2def$var$load("i5eMd"),
    $9c1e4b4ba09b2def$var$load("i9sd0"),
    $9c1e4b4ba09b2def$var$load("gyXEE"),
    $9c1e4b4ba09b2def$var$load("hoPZ9")
]).then(()=>parcelRequire('ezOKB'));

});

parcelRegister("fE1BU", function(module, exports) {

let $b63bd73f903d049a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b63bd73f903d049a$var$load("1jsQH"),
    $b63bd73f903d049a$var$load("bv8GZ"),
    $b63bd73f903d049a$var$load("i5eMd"),
    $b63bd73f903d049a$var$load("i9sd0"),
    $b63bd73f903d049a$var$load("gyXEE"),
    $b63bd73f903d049a$var$load("hoPZ9")
]).then(()=>parcelRequire('dFugs'));

});

parcelRegister("djF45", function(module, exports) {

let $9b1ce75b6dce9070$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9b1ce75b6dce9070$var$load("1jsQH"),
    $9b1ce75b6dce9070$var$load("bv8GZ"),
    $9b1ce75b6dce9070$var$load("i5eMd"),
    $9b1ce75b6dce9070$var$load("i9sd0"),
    $9b1ce75b6dce9070$var$load("gyXEE"),
    $9b1ce75b6dce9070$var$load("hoPZ9")
]).then(()=>parcelRequire('8nPWF'));

});

parcelRegister("bYDKL", function(module, exports) {

let $8b842278fb86d69f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8b842278fb86d69f$var$load("1jsQH"),
    $8b842278fb86d69f$var$load("bv8GZ"),
    $8b842278fb86d69f$var$load("i5eMd"),
    $8b842278fb86d69f$var$load("i9sd0"),
    $8b842278fb86d69f$var$load("gyXEE"),
    $8b842278fb86d69f$var$load("hoPZ9")
]).then(()=>parcelRequire('40ihR'));

});

parcelRegister("djluV", function(module, exports) {

let $9b0db9b6ba3e2922$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9b0db9b6ba3e2922$var$load("1jsQH"),
    $9b0db9b6ba3e2922$var$load("bv8GZ"),
    $9b0db9b6ba3e2922$var$load("i5eMd"),
    $9b0db9b6ba3e2922$var$load("i9sd0"),
    $9b0db9b6ba3e2922$var$load("gyXEE"),
    $9b0db9b6ba3e2922$var$load("hoPZ9")
]).then(()=>parcelRequire('iIov7'));

});

parcelRegister("hYcrq", function(module, exports) {

let $d151b0e176129e6a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d151b0e176129e6a$var$load("1jsQH"),
    $d151b0e176129e6a$var$load("bv8GZ"),
    $d151b0e176129e6a$var$load("i5eMd"),
    $d151b0e176129e6a$var$load("i9sd0"),
    $d151b0e176129e6a$var$load("gyXEE"),
    $d151b0e176129e6a$var$load("hoPZ9")
]).then(()=>parcelRequire('4NJDP'));

});

parcelRegister("lfBS4", function(module, exports) {

let $f78860143d35b890$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f78860143d35b890$var$load("1jsQH"),
    $f78860143d35b890$var$load("bv8GZ"),
    $f78860143d35b890$var$load("i5eMd"),
    $f78860143d35b890$var$load("i9sd0"),
    $f78860143d35b890$var$load("gyXEE"),
    $f78860143d35b890$var$load("hoPZ9")
]).then(()=>parcelRequire('3Fxgl'));

});

parcelRegister("cm23V", function(module, exports) {

let $8fe923a22c7c1c31$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8fe923a22c7c1c31$var$load("1jsQH"),
    $8fe923a22c7c1c31$var$load("bv8GZ"),
    $8fe923a22c7c1c31$var$load("i5eMd"),
    $8fe923a22c7c1c31$var$load("i9sd0"),
    $8fe923a22c7c1c31$var$load("gyXEE"),
    $8fe923a22c7c1c31$var$load("hoPZ9")
]).then(()=>parcelRequire('elAt5'));

});

parcelRegister("2YiJd", function(module, exports) {

let $229fb66ade79daad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $229fb66ade79daad$var$load("1jsQH"),
    $229fb66ade79daad$var$load("bv8GZ"),
    $229fb66ade79daad$var$load("i5eMd"),
    $229fb66ade79daad$var$load("i9sd0"),
    $229fb66ade79daad$var$load("gyXEE"),
    $229fb66ade79daad$var$load("hoPZ9")
]).then(()=>parcelRequire('aYOMr'));

});

parcelRegister("05g36", function(module, exports) {

let $00fceac55c140190$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $00fceac55c140190$var$load("1jsQH"),
    $00fceac55c140190$var$load("bv8GZ"),
    $00fceac55c140190$var$load("i5eMd"),
    $00fceac55c140190$var$load("i9sd0"),
    $00fceac55c140190$var$load("gyXEE"),
    $00fceac55c140190$var$load("hoPZ9")
]).then(()=>parcelRequire('8qxwY'));

});

parcelRegister("2nCDy", function(module, exports) {

let $1bbbb340304e6fce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1bbbb340304e6fce$var$load("1jsQH"),
    $1bbbb340304e6fce$var$load("bv8GZ"),
    $1bbbb340304e6fce$var$load("i5eMd"),
    $1bbbb340304e6fce$var$load("i9sd0"),
    $1bbbb340304e6fce$var$load("gyXEE"),
    $1bbbb340304e6fce$var$load("hoPZ9")
]).then(()=>parcelRequire('5OPjC'));

});

parcelRegister("7RCJa", function(module, exports) {

let $5b9b8623c33ca4fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5b9b8623c33ca4fc$var$load("1jsQH"),
    $5b9b8623c33ca4fc$var$load("bv8GZ"),
    $5b9b8623c33ca4fc$var$load("i5eMd"),
    $5b9b8623c33ca4fc$var$load("i9sd0"),
    $5b9b8623c33ca4fc$var$load("gyXEE"),
    $5b9b8623c33ca4fc$var$load("hoPZ9")
]).then(()=>parcelRequire('02bk4'));

});

parcelRegister("50uHu", function(module, exports) {

let $3a54c44b884b3d86$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3a54c44b884b3d86$var$load("1jsQH"),
    $3a54c44b884b3d86$var$load("bv8GZ"),
    $3a54c44b884b3d86$var$load("i5eMd"),
    $3a54c44b884b3d86$var$load("i9sd0"),
    $3a54c44b884b3d86$var$load("gyXEE"),
    $3a54c44b884b3d86$var$load("hoPZ9")
]).then(()=>parcelRequire('e8AS0'));

});

parcelRegister("eIlsK", function(module, exports) {

let $ab65d2c7f17f68ef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ab65d2c7f17f68ef$var$load("1jsQH"),
    $ab65d2c7f17f68ef$var$load("bv8GZ"),
    $ab65d2c7f17f68ef$var$load("i5eMd"),
    $ab65d2c7f17f68ef$var$load("i9sd0"),
    $ab65d2c7f17f68ef$var$load("gyXEE"),
    $ab65d2c7f17f68ef$var$load("hoPZ9")
]).then(()=>parcelRequire('4O160'));

});

parcelRegister("eHyl3", function(module, exports) {

let $ab3fb7c0e4617e80$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ab3fb7c0e4617e80$var$load("1jsQH"),
    $ab3fb7c0e4617e80$var$load("bv8GZ"),
    $ab3fb7c0e4617e80$var$load("i5eMd"),
    $ab3fb7c0e4617e80$var$load("i9sd0"),
    $ab3fb7c0e4617e80$var$load("gyXEE"),
    $ab3fb7c0e4617e80$var$load("hoPZ9")
]).then(()=>parcelRequire('br2f9'));

});

parcelRegister("eMs9r", function(module, exports) {

let $ac2b62a04ba8a1db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ac2b62a04ba8a1db$var$load("1jsQH"),
    $ac2b62a04ba8a1db$var$load("bv8GZ"),
    $ac2b62a04ba8a1db$var$load("i5eMd"),
    $ac2b62a04ba8a1db$var$load("i9sd0"),
    $ac2b62a04ba8a1db$var$load("gyXEE"),
    $ac2b62a04ba8a1db$var$load("hoPZ9")
]).then(()=>parcelRequire('9bTQb'));

});

parcelRegister("htEbN", function(module, exports) {

let $cb9451d7d42563f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cb9451d7d42563f2$var$load("1jsQH"),
    $cb9451d7d42563f2$var$load("bv8GZ"),
    $cb9451d7d42563f2$var$load("i5eMd"),
    $cb9451d7d42563f2$var$load("i9sd0"),
    $cb9451d7d42563f2$var$load("gyXEE"),
    $cb9451d7d42563f2$var$load("hoPZ9")
]).then(()=>parcelRequire('iCQxS'));

});

parcelRegister("fXsDX", function(module, exports) {

let $b9e295afec4af891$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b9e295afec4af891$var$load("1jsQH"),
    $b9e295afec4af891$var$load("bv8GZ"),
    $b9e295afec4af891$var$load("i5eMd"),
    $b9e295afec4af891$var$load("i9sd0"),
    $b9e295afec4af891$var$load("gyXEE"),
    $b9e295afec4af891$var$load("hoPZ9")
]).then(()=>parcelRequire('2AHGb'));

});

parcelRegister("gssRx", function(module, exports) {

let $bfb5a65dcba7cd56$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bfb5a65dcba7cd56$var$load("1jsQH"),
    $bfb5a65dcba7cd56$var$load("bv8GZ"),
    $bfb5a65dcba7cd56$var$load("i5eMd"),
    $bfb5a65dcba7cd56$var$load("i9sd0"),
    $bfb5a65dcba7cd56$var$load("gyXEE"),
    $bfb5a65dcba7cd56$var$load("hoPZ9")
]).then(()=>parcelRequire('4wQQi'));

});

parcelRegister("9J20P", function(module, exports) {

let $7149e0a65bdca301$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7149e0a65bdca301$var$load("1jsQH"),
    $7149e0a65bdca301$var$load("bv8GZ"),
    $7149e0a65bdca301$var$load("i5eMd"),
    $7149e0a65bdca301$var$load("i9sd0"),
    $7149e0a65bdca301$var$load("gyXEE"),
    $7149e0a65bdca301$var$load("hoPZ9")
]).then(()=>parcelRequire('gtsDG'));

});

parcelRegister("hxniA", function(module, exports) {

let $cc479765903bc672$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cc479765903bc672$var$load("1jsQH"),
    $cc479765903bc672$var$load("bv8GZ"),
    $cc479765903bc672$var$load("i5eMd"),
    $cc479765903bc672$var$load("i9sd0"),
    $cc479765903bc672$var$load("gyXEE"),
    $cc479765903bc672$var$load("hoPZ9")
]).then(()=>parcelRequire('1b2Sz'));

});

parcelRegister("8SxNE", function(module, exports) {

let $676d95cefd146c90$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $676d95cefd146c90$var$load("1jsQH"),
    $676d95cefd146c90$var$load("bv8GZ"),
    $676d95cefd146c90$var$load("i5eMd"),
    $676d95cefd146c90$var$load("i9sd0"),
    $676d95cefd146c90$var$load("gyXEE"),
    $676d95cefd146c90$var$load("hoPZ9")
]).then(()=>parcelRequire('la0KH'));

});

parcelRegister("cGFVw", function(module, exports) {

let $93c9ee0b81dc0d2a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $93c9ee0b81dc0d2a$var$load("1jsQH"),
    $93c9ee0b81dc0d2a$var$load("bv8GZ"),
    $93c9ee0b81dc0d2a$var$load("i5eMd"),
    $93c9ee0b81dc0d2a$var$load("i9sd0"),
    $93c9ee0b81dc0d2a$var$load("gyXEE"),
    $93c9ee0b81dc0d2a$var$load("hoPZ9")
]).then(()=>parcelRequire('c2FNi'));

});

parcelRegister("4xjsK", function(module, exports) {

let $34d95761f212c4fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $34d95761f212c4fe$var$load("1jsQH"),
    $34d95761f212c4fe$var$load("bv8GZ"),
    $34d95761f212c4fe$var$load("i5eMd"),
    $34d95761f212c4fe$var$load("i9sd0"),
    $34d95761f212c4fe$var$load("gyXEE"),
    $34d95761f212c4fe$var$load("hoPZ9")
]).then(()=>parcelRequire('lFMla'));

});

parcelRegister("bxtFe", function(module, exports) {

let $8669c969eb357e65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8669c969eb357e65$var$load("1jsQH"),
    $8669c969eb357e65$var$load("bv8GZ"),
    $8669c969eb357e65$var$load("i5eMd"),
    $8669c969eb357e65$var$load("i9sd0"),
    $8669c969eb357e65$var$load("gyXEE"),
    $8669c969eb357e65$var$load("hoPZ9")
]).then(()=>parcelRequire('92HFt'));

});

parcelRegister("8BwAK", function(module, exports) {

let $643b0f73bfc015c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $643b0f73bfc015c8$var$load("1jsQH"),
    $643b0f73bfc015c8$var$load("bv8GZ"),
    $643b0f73bfc015c8$var$load("i5eMd"),
    $643b0f73bfc015c8$var$load("i9sd0"),
    $643b0f73bfc015c8$var$load("gyXEE"),
    $643b0f73bfc015c8$var$load("hoPZ9")
]).then(()=>parcelRequire('eTLIA'));

});

parcelRegister("gT2Dr", function(module, exports) {

let $c4b3d3b2892b9663$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c4b3d3b2892b9663$var$load("1jsQH"),
    $c4b3d3b2892b9663$var$load("bv8GZ"),
    $c4b3d3b2892b9663$var$load("i5eMd"),
    $c4b3d3b2892b9663$var$load("i9sd0"),
    $c4b3d3b2892b9663$var$load("gyXEE"),
    $c4b3d3b2892b9663$var$load("hoPZ9")
]).then(()=>parcelRequire('gqdIF'));

});

parcelRegister("gygIs", function(module, exports) {

let $c0ccc9c19d3d7b63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c0ccc9c19d3d7b63$var$load("9eNkX"),
    $c0ccc9c19d3d7b63$var$load("dh2Er"),
    $c0ccc9c19d3d7b63$var$load("k10Cs"),
    $c0ccc9c19d3d7b63$var$load("1pFHs"),
    $c0ccc9c19d3d7b63$var$load("8Mz40"),
    $c0ccc9c19d3d7b63$var$load("l6YHr")
]).then(()=>parcelRequire('4VjzZ'));

});

parcelRegister("2cAsa", function(module, exports) {

let $19a8faa144cbc2e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $19a8faa144cbc2e5$var$load("9eNkX"),
    $19a8faa144cbc2e5$var$load("dh2Er"),
    $19a8faa144cbc2e5$var$load("k10Cs"),
    $19a8faa144cbc2e5$var$load("1pFHs"),
    $19a8faa144cbc2e5$var$load("8Mz40"),
    $19a8faa144cbc2e5$var$load("l6YHr")
]).then(()=>parcelRequire('dLoPa'));

});

parcelRegister("idofV", function(module, exports) {

let $d42c419bfe1e528b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d42c419bfe1e528b$var$load("9eNkX"),
    $d42c419bfe1e528b$var$load("dh2Er"),
    $d42c419bfe1e528b$var$load("k10Cs"),
    $d42c419bfe1e528b$var$load("1pFHs"),
    $d42c419bfe1e528b$var$load("8Mz40"),
    $d42c419bfe1e528b$var$load("l6YHr")
]).then(()=>parcelRequire('9mF1p'));

});

parcelRegister("59soY", function(module, exports) {

let $3c03d303a4b67461$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3c03d303a4b67461$var$load("9eNkX"),
    $3c03d303a4b67461$var$load("dh2Er"),
    $3c03d303a4b67461$var$load("k10Cs"),
    $3c03d303a4b67461$var$load("1pFHs"),
    $3c03d303a4b67461$var$load("8Mz40"),
    $3c03d303a4b67461$var$load("l6YHr")
]).then(()=>parcelRequire('45SMe'));

});

parcelRegister("gWnqr", function(module, exports) {

let $c5543bf094c58547$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c5543bf094c58547$var$load("9eNkX"),
    $c5543bf094c58547$var$load("dh2Er"),
    $c5543bf094c58547$var$load("k10Cs"),
    $c5543bf094c58547$var$load("1pFHs"),
    $c5543bf094c58547$var$load("8Mz40"),
    $c5543bf094c58547$var$load("l6YHr")
]).then(()=>parcelRequire('gR0Ux'));

});

parcelRegister("2zWSc", function(module, exports) {

let $1e0c84a9aa5d5635$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1e0c84a9aa5d5635$var$load("9eNkX"),
    $1e0c84a9aa5d5635$var$load("dh2Er"),
    $1e0c84a9aa5d5635$var$load("k10Cs"),
    $1e0c84a9aa5d5635$var$load("1pFHs"),
    $1e0c84a9aa5d5635$var$load("8Mz40"),
    $1e0c84a9aa5d5635$var$load("l6YHr")
]).then(()=>parcelRequire('1R9iT'));

});

parcelRegister("d3zGC", function(module, exports) {

let $98173cbaf0a926d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $98173cbaf0a926d1$var$load("9eNkX"),
    $98173cbaf0a926d1$var$load("dh2Er"),
    $98173cbaf0a926d1$var$load("k10Cs"),
    $98173cbaf0a926d1$var$load("1pFHs"),
    $98173cbaf0a926d1$var$load("8Mz40"),
    $98173cbaf0a926d1$var$load("l6YHr")
]).then(()=>parcelRequire('4ZPCd'));

});

parcelRegister("1qMg4", function(module, exports) {

let $10ada735bef2940d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $10ada735bef2940d$var$load("9eNkX"),
    $10ada735bef2940d$var$load("dh2Er"),
    $10ada735bef2940d$var$load("k10Cs"),
    $10ada735bef2940d$var$load("1pFHs"),
    $10ada735bef2940d$var$load("8Mz40"),
    $10ada735bef2940d$var$load("l6YHr")
]).then(()=>parcelRequire('4LH4L'));

});

parcelRegister("gtUoU", function(module, exports) {

let $bffb1ad0b72b9eb6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bffb1ad0b72b9eb6$var$load("9eNkX"),
    $bffb1ad0b72b9eb6$var$load("dh2Er"),
    $bffb1ad0b72b9eb6$var$load("k10Cs"),
    $bffb1ad0b72b9eb6$var$load("1pFHs"),
    $bffb1ad0b72b9eb6$var$load("8Mz40"),
    $bffb1ad0b72b9eb6$var$load("l6YHr")
]).then(()=>parcelRequire('9jOdE'));

});

parcelRegister("0517g", function(module, exports) {

let $00f1555f299682da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $00f1555f299682da$var$load("9eNkX"),
    $00f1555f299682da$var$load("dh2Er"),
    $00f1555f299682da$var$load("k10Cs"),
    $00f1555f299682da$var$load("1pFHs"),
    $00f1555f299682da$var$load("8Mz40"),
    $00f1555f299682da$var$load("l6YHr")
]).then(()=>parcelRequire('aS062'));

});

parcelRegister("lwbVR", function(module, exports) {

let $faa5d7a5e0273eca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $faa5d7a5e0273eca$var$load("9eNkX"),
    $faa5d7a5e0273eca$var$load("dh2Er"),
    $faa5d7a5e0273eca$var$load("k10Cs"),
    $faa5d7a5e0273eca$var$load("1pFHs"),
    $faa5d7a5e0273eca$var$load("8Mz40"),
    $faa5d7a5e0273eca$var$load("l6YHr")
]).then(()=>parcelRequire('3qrgQ'));

});

parcelRegister("bfPXA", function(module, exports) {

let $8319669c61ae2d69$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8319669c61ae2d69$var$load("9eNkX"),
    $8319669c61ae2d69$var$load("dh2Er"),
    $8319669c61ae2d69$var$load("k10Cs"),
    $8319669c61ae2d69$var$load("1pFHs"),
    $8319669c61ae2d69$var$load("8Mz40"),
    $8319669c61ae2d69$var$load("l6YHr")
]).then(()=>parcelRequire('h11RW'));

});

parcelRegister("85Xbu", function(module, exports) {

let $5e4cb31ecd4ab874$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5e4cb31ecd4ab874$var$load("9eNkX"),
    $5e4cb31ecd4ab874$var$load("dh2Er"),
    $5e4cb31ecd4ab874$var$load("k10Cs"),
    $5e4cb31ecd4ab874$var$load("1pFHs"),
    $5e4cb31ecd4ab874$var$load("8Mz40"),
    $5e4cb31ecd4ab874$var$load("l6YHr")
]).then(()=>parcelRequire('6F7ay'));

});

parcelRegister("9fYMB", function(module, exports) {

let $6bd4a9f75e00b33d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6bd4a9f75e00b33d$var$load("9eNkX"),
    $6bd4a9f75e00b33d$var$load("dh2Er"),
    $6bd4a9f75e00b33d$var$load("k10Cs"),
    $6bd4a9f75e00b33d$var$load("1pFHs"),
    $6bd4a9f75e00b33d$var$load("8Mz40"),
    $6bd4a9f75e00b33d$var$load("l6YHr")
]).then(()=>parcelRequire('5kbqa'));

});

parcelRegister("2WCM6", function(module, exports) {

let $224f13676e4e187b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $224f13676e4e187b$var$load("9eNkX"),
    $224f13676e4e187b$var$load("dh2Er"),
    $224f13676e4e187b$var$load("k10Cs"),
    $224f13676e4e187b$var$load("1pFHs"),
    $224f13676e4e187b$var$load("8Mz40"),
    $224f13676e4e187b$var$load("l6YHr")
]).then(()=>parcelRequire('cPZVY'));

});

parcelRegister("4Kylo", function(module, exports) {

let $375619533d3d62d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $375619533d3d62d1$var$load("9eNkX"),
    $375619533d3d62d1$var$load("dh2Er"),
    $375619533d3d62d1$var$load("k10Cs"),
    $375619533d3d62d1$var$load("1pFHs"),
    $375619533d3d62d1$var$load("8Mz40"),
    $375619533d3d62d1$var$load("l6YHr")
]).then(()=>parcelRequire('hBA7n'));

});

parcelRegister("ei5Av", function(module, exports) {

let $a67714c09c57809d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a67714c09c57809d$var$load("9eNkX"),
    $a67714c09c57809d$var$load("dh2Er"),
    $a67714c09c57809d$var$load("k10Cs"),
    $a67714c09c57809d$var$load("1pFHs"),
    $a67714c09c57809d$var$load("8Mz40"),
    $a67714c09c57809d$var$load("l6YHr")
]).then(()=>parcelRequire('aZ75K'));

});

parcelRegister("dxCfe", function(module, exports) {

let $9dbc060cc688597b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9dbc060cc688597b$var$load("9eNkX"),
    $9dbc060cc688597b$var$load("dh2Er"),
    $9dbc060cc688597b$var$load("k10Cs"),
    $9dbc060cc688597b$var$load("1pFHs"),
    $9dbc060cc688597b$var$load("8Mz40"),
    $9dbc060cc688597b$var$load("l6YHr")
]).then(()=>parcelRequire('3GY0W'));

});

parcelRegister("1aoGA", function(module, exports) {

let $0d99dfb44af69fb1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0d99dfb44af69fb1$var$load("9eNkX"),
    $0d99dfb44af69fb1$var$load("dh2Er"),
    $0d99dfb44af69fb1$var$load("k10Cs"),
    $0d99dfb44af69fb1$var$load("1pFHs"),
    $0d99dfb44af69fb1$var$load("8Mz40"),
    $0d99dfb44af69fb1$var$load("l6YHr")
]).then(()=>parcelRequire('jXHGs'));

});

parcelRegister("dJCBo", function(module, exports) {

let $9ffd6be58b865c2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9ffd6be58b865c2d$var$load("9eNkX"),
    $9ffd6be58b865c2d$var$load("dh2Er"),
    $9ffd6be58b865c2d$var$load("k10Cs"),
    $9ffd6be58b865c2d$var$load("1pFHs"),
    $9ffd6be58b865c2d$var$load("8Mz40"),
    $9ffd6be58b865c2d$var$load("l6YHr")
]).then(()=>parcelRequire('hJWhT'));

});

parcelRegister("lJZW0", function(module, exports) {

let $fd3dd7dd009ef48d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fd3dd7dd009ef48d$var$load("9eNkX"),
    $fd3dd7dd009ef48d$var$load("dh2Er"),
    $fd3dd7dd009ef48d$var$load("k10Cs"),
    $fd3dd7dd009ef48d$var$load("1pFHs"),
    $fd3dd7dd009ef48d$var$load("8Mz40"),
    $fd3dd7dd009ef48d$var$load("l6YHr")
]).then(()=>parcelRequire('hFZcj'));

});

parcelRegister("5QFye", function(module, exports) {

let $44220a45a53afafa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $44220a45a53afafa$var$load("9eNkX"),
    $44220a45a53afafa$var$load("dh2Er"),
    $44220a45a53afafa$var$load("k10Cs"),
    $44220a45a53afafa$var$load("1pFHs"),
    $44220a45a53afafa$var$load("8Mz40"),
    $44220a45a53afafa$var$load("l6YHr")
]).then(()=>parcelRequire('9Bpym'));

});

parcelRegister("4zmXl", function(module, exports) {

let $353c3cef8dd3335d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $353c3cef8dd3335d$var$load("9eNkX"),
    $353c3cef8dd3335d$var$load("dh2Er"),
    $353c3cef8dd3335d$var$load("k10Cs"),
    $353c3cef8dd3335d$var$load("1pFHs"),
    $353c3cef8dd3335d$var$load("8Mz40"),
    $353c3cef8dd3335d$var$load("l6YHr")
]).then(()=>parcelRequire('NakWh'));

});

parcelRegister("5e72D", function(module, exports) {

let $3ce3b8d86ee04c03$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3ce3b8d86ee04c03$var$load("9eNkX"),
    $3ce3b8d86ee04c03$var$load("dh2Er"),
    $3ce3b8d86ee04c03$var$load("k10Cs"),
    $3ce3b8d86ee04c03$var$load("1pFHs"),
    $3ce3b8d86ee04c03$var$load("8Mz40"),
    $3ce3b8d86ee04c03$var$load("l6YHr")
]).then(()=>parcelRequire('4jPje'));

});

parcelRegister("kkfHx", function(module, exports) {

let $ecc1dadb2c8a129b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ecc1dadb2c8a129b$var$load("9eNkX"),
    $ecc1dadb2c8a129b$var$load("dh2Er"),
    $ecc1dadb2c8a129b$var$load("k10Cs"),
    $ecc1dadb2c8a129b$var$load("1pFHs"),
    $ecc1dadb2c8a129b$var$load("8Mz40"),
    $ecc1dadb2c8a129b$var$load("l6YHr")
]).then(()=>parcelRequire('7UDYE'));

});

parcelRegister("bDv1U", function(module, exports) {

let $878b6816fed3bf0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $878b6816fed3bf0d$var$load("9eNkX"),
    $878b6816fed3bf0d$var$load("dh2Er"),
    $878b6816fed3bf0d$var$load("k10Cs"),
    $878b6816fed3bf0d$var$load("1pFHs"),
    $878b6816fed3bf0d$var$load("8Mz40"),
    $878b6816fed3bf0d$var$load("l6YHr")
]).then(()=>parcelRequire('hZmNz'));

});

parcelRegister("01sCo", function(module, exports) {

let $00464b185f8d94cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $00464b185f8d94cc$var$load("9eNkX"),
    $00464b185f8d94cc$var$load("dh2Er"),
    $00464b185f8d94cc$var$load("k10Cs"),
    $00464b185f8d94cc$var$load("1pFHs"),
    $00464b185f8d94cc$var$load("8Mz40"),
    $00464b185f8d94cc$var$load("l6YHr")
]).then(()=>parcelRequire('kZEgA'));

});

parcelRegister("1qZ55", function(module, exports) {

let $10b7999220e01ebf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $10b7999220e01ebf$var$load("9eNkX"),
    $10b7999220e01ebf$var$load("dh2Er"),
    $10b7999220e01ebf$var$load("k10Cs"),
    $10b7999220e01ebf$var$load("1pFHs"),
    $10b7999220e01ebf$var$load("8Mz40"),
    $10b7999220e01ebf$var$load("l6YHr")
]).then(()=>parcelRequire('4UnkR'));

});

parcelRegister("heq0d", function(module, exports) {

let $c8b7ea0230163748$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c8b7ea0230163748$var$load("9eNkX"),
    $c8b7ea0230163748$var$load("dh2Er"),
    $c8b7ea0230163748$var$load("k10Cs"),
    $c8b7ea0230163748$var$load("1pFHs"),
    $c8b7ea0230163748$var$load("8Mz40"),
    $c8b7ea0230163748$var$load("l6YHr")
]).then(()=>parcelRequire('bhnJ2'));

});

parcelRegister("6mL38", function(module, exports) {

let $4a294b36f05272cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4a294b36f05272cd$var$load("9eNkX"),
    $4a294b36f05272cd$var$load("dh2Er"),
    $4a294b36f05272cd$var$load("k10Cs"),
    $4a294b36f05272cd$var$load("1pFHs"),
    $4a294b36f05272cd$var$load("8Mz40"),
    $4a294b36f05272cd$var$load("l6YHr")
]).then(()=>parcelRequire('5nn1x'));

});

parcelRegister("4ZMhF", function(module, exports) {

let $3a32501f812a8a8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3a32501f812a8a8d$var$load("9eNkX"),
    $3a32501f812a8a8d$var$load("dh2Er"),
    $3a32501f812a8a8d$var$load("k10Cs"),
    $3a32501f812a8a8d$var$load("1pFHs"),
    $3a32501f812a8a8d$var$load("8Mz40"),
    $3a32501f812a8a8d$var$load("l6YHr")
]).then(()=>parcelRequire('lWjVy'));

});

parcelRegister("i9tIA", function(module, exports) {

let $d3701ea38a8282d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d3701ea38a8282d7$var$load("9eNkX"),
    $d3701ea38a8282d7$var$load("dh2Er"),
    $d3701ea38a8282d7$var$load("k10Cs"),
    $d3701ea38a8282d7$var$load("1pFHs"),
    $d3701ea38a8282d7$var$load("8Mz40"),
    $d3701ea38a8282d7$var$load("l6YHr")
]).then(()=>parcelRequire('gt3m4'));

});

parcelRegister("iymfG", function(module, exports) {

let $d81ca9c13c50b14d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d81ca9c13c50b14d$var$load("9eNkX"),
    $d81ca9c13c50b14d$var$load("dh2Er"),
    $d81ca9c13c50b14d$var$load("k10Cs"),
    $d81ca9c13c50b14d$var$load("1pFHs"),
    $d81ca9c13c50b14d$var$load("8Mz40"),
    $d81ca9c13c50b14d$var$load("l6YHr")
]).then(()=>parcelRequire('gw4c4'));

});

parcelRegister("5CV3W", function(module, exports) {

let $418cc3c7dad8347f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $418cc3c7dad8347f$var$load("9eNkX"),
    $418cc3c7dad8347f$var$load("dh2Er"),
    $418cc3c7dad8347f$var$load("k10Cs"),
    $418cc3c7dad8347f$var$load("1pFHs"),
    $418cc3c7dad8347f$var$load("8Mz40"),
    $418cc3c7dad8347f$var$load("l6YHr")
]).then(()=>parcelRequire('7SQgh'));

});

parcelRegister("iSk4v", function(module, exports) {

let $dbdcd6f082504818$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dbdcd6f082504818$var$load("9eNkX"),
    $dbdcd6f082504818$var$load("dh2Er"),
    $dbdcd6f082504818$var$load("k10Cs"),
    $dbdcd6f082504818$var$load("1pFHs"),
    $dbdcd6f082504818$var$load("8Mz40"),
    $dbdcd6f082504818$var$load("l6YHr")
]).then(()=>parcelRequire('dFo9j'));

});

parcelRegister("g2iSE", function(module, exports) {

let $bacb7a800faab7bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bacb7a800faab7bc$var$load("9eNkX"),
    $bacb7a800faab7bc$var$load("dh2Er"),
    $bacb7a800faab7bc$var$load("k10Cs"),
    $bacb7a800faab7bc$var$load("1pFHs"),
    $bacb7a800faab7bc$var$load("8Mz40"),
    $bacb7a800faab7bc$var$load("l6YHr")
]).then(()=>parcelRequire('23ZvC'));

});

parcelRegister("5sdAA", function(module, exports) {

let $3f8a1bcbd775f579$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f8a1bcbd775f579$var$load("9eNkX"),
    $3f8a1bcbd775f579$var$load("dh2Er"),
    $3f8a1bcbd775f579$var$load("k10Cs"),
    $3f8a1bcbd775f579$var$load("1pFHs"),
    $3f8a1bcbd775f579$var$load("8Mz40"),
    $3f8a1bcbd775f579$var$load("l6YHr")
]).then(()=>parcelRequire('hW3z1'));

});

parcelRegister("9Oobr", function(module, exports) {

let $724b8ae4af0e812a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $724b8ae4af0e812a$var$load("9eNkX"),
    $724b8ae4af0e812a$var$load("dh2Er"),
    $724b8ae4af0e812a$var$load("k10Cs"),
    $724b8ae4af0e812a$var$load("1pFHs"),
    $724b8ae4af0e812a$var$load("8Mz40"),
    $724b8ae4af0e812a$var$load("l6YHr")
]).then(()=>parcelRequire('vKazA'));

});

parcelRegister("aH2Wx", function(module, exports) {

let $7c9033fda01455fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7c9033fda01455fe$var$load("9eNkX"),
    $7c9033fda01455fe$var$load("dh2Er"),
    $7c9033fda01455fe$var$load("k10Cs"),
    $7c9033fda01455fe$var$load("1pFHs"),
    $7c9033fda01455fe$var$load("8Mz40"),
    $7c9033fda01455fe$var$load("l6YHr")
]).then(()=>parcelRequire('1G3L8'));

});

parcelRegister("3S2W0", function(module, exports) {

let $2d18b0fca6791948$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2d18b0fca6791948$var$load("9eNkX"),
    $2d18b0fca6791948$var$load("dh2Er"),
    $2d18b0fca6791948$var$load("k10Cs"),
    $2d18b0fca6791948$var$load("1pFHs"),
    $2d18b0fca6791948$var$load("8Mz40"),
    $2d18b0fca6791948$var$load("l6YHr")
]).then(()=>parcelRequire('9o8Q9'));

});

parcelRegister("7KXL4", function(module, exports) {

let $5a5b2eff3e219b6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5a5b2eff3e219b6b$var$load("9eNkX"),
    $5a5b2eff3e219b6b$var$load("dh2Er"),
    $5a5b2eff3e219b6b$var$load("k10Cs"),
    $5a5b2eff3e219b6b$var$load("1pFHs"),
    $5a5b2eff3e219b6b$var$load("8Mz40"),
    $5a5b2eff3e219b6b$var$load("l6YHr")
]).then(()=>parcelRequire('caQCF'));

});

parcelRegister("7oiGZ", function(module, exports) {

let $56194632c86e11b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $56194632c86e11b2$var$load("9eNkX"),
    $56194632c86e11b2$var$load("dh2Er"),
    $56194632c86e11b2$var$load("k10Cs"),
    $56194632c86e11b2$var$load("1pFHs"),
    $56194632c86e11b2$var$load("8Mz40"),
    $56194632c86e11b2$var$load("l6YHr")
]).then(()=>parcelRequire('3RukW'));

});

parcelRegister("cek4L", function(module, exports) {

let $8e765d7bb272c343$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8e765d7bb272c343$var$load("9eNkX"),
    $8e765d7bb272c343$var$load("dh2Er"),
    $8e765d7bb272c343$var$load("k10Cs"),
    $8e765d7bb272c343$var$load("1pFHs"),
    $8e765d7bb272c343$var$load("8Mz40"),
    $8e765d7bb272c343$var$load("l6YHr")
]).then(()=>parcelRequire('dbmJk'));

});

parcelRegister("dkc7j", function(module, exports) {

let $9b368ac76ff442ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9b368ac76ff442ce$var$load("9eNkX"),
    $9b368ac76ff442ce$var$load("dh2Er"),
    $9b368ac76ff442ce$var$load("k10Cs"),
    $9b368ac76ff442ce$var$load("1pFHs"),
    $9b368ac76ff442ce$var$load("8Mz40"),
    $9b368ac76ff442ce$var$load("l6YHr")
]).then(()=>parcelRequire('kVZ6a'));

});

parcelRegister("likbX", function(module, exports) {

let $f80af1195106006e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f80af1195106006e$var$load("9eNkX"),
    $f80af1195106006e$var$load("dh2Er"),
    $f80af1195106006e$var$load("k10Cs"),
    $f80af1195106006e$var$load("1pFHs"),
    $f80af1195106006e$var$load("8Mz40"),
    $f80af1195106006e$var$load("l6YHr")
]).then(()=>parcelRequire('i9SOf'));

});

parcelRegister("aIVPF", function(module, exports) {

let $7ceadfbf44aea19d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7ceadfbf44aea19d$var$load("9eNkX"),
    $7ceadfbf44aea19d$var$load("dh2Er"),
    $7ceadfbf44aea19d$var$load("k10Cs"),
    $7ceadfbf44aea19d$var$load("1pFHs"),
    $7ceadfbf44aea19d$var$load("8Mz40"),
    $7ceadfbf44aea19d$var$load("l6YHr")
]).then(()=>parcelRequire('O76LZ'));

});

parcelRegister("d3V3a", function(module, exports) {

let $9827cf1f173dc0f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9827cf1f173dc0f4$var$load("9eNkX"),
    $9827cf1f173dc0f4$var$load("dh2Er"),
    $9827cf1f173dc0f4$var$load("k10Cs"),
    $9827cf1f173dc0f4$var$load("1pFHs"),
    $9827cf1f173dc0f4$var$load("8Mz40"),
    $9827cf1f173dc0f4$var$load("l6YHr")
]).then(()=>parcelRequire('dQw9e'));

});

parcelRegister("lSVUW", function(module, exports) {

let $feeb915190f6408c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $feeb915190f6408c$var$load("9eNkX"),
    $feeb915190f6408c$var$load("dh2Er"),
    $feeb915190f6408c$var$load("k10Cs"),
    $feeb915190f6408c$var$load("1pFHs"),
    $feeb915190f6408c$var$load("8Mz40"),
    $feeb915190f6408c$var$load("l6YHr")
]).then(()=>parcelRequire('kIJp7'));

});

parcelRegister("jx5hF", function(module, exports) {

let $e38532a72646ac4c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e38532a72646ac4c$var$load("9eNkX"),
    $e38532a72646ac4c$var$load("dh2Er"),
    $e38532a72646ac4c$var$load("k10Cs"),
    $e38532a72646ac4c$var$load("1pFHs"),
    $e38532a72646ac4c$var$load("8Mz40"),
    $e38532a72646ac4c$var$load("l6YHr")
]).then(()=>parcelRequire('e43Se'));

});

parcelRegister("bVmps", function(module, exports) {

let $8ae666aec94b6cd0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8ae666aec94b6cd0$var$load("9eNkX"),
    $8ae666aec94b6cd0$var$load("dh2Er"),
    $8ae666aec94b6cd0$var$load("k10Cs"),
    $8ae666aec94b6cd0$var$load("1pFHs"),
    $8ae666aec94b6cd0$var$load("8Mz40"),
    $8ae666aec94b6cd0$var$load("l6YHr")
]).then(()=>parcelRequire('jqBqk'));

});

parcelRegister("kCgDJ", function(module, exports) {

let $f0244394220572e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f0244394220572e6$var$load("gDiIK"),
    $f0244394220572e6$var$load("eLlpV"),
    $f0244394220572e6$var$load("f1B4n"),
    $f0244394220572e6$var$load("7sItg"),
    $f0244394220572e6$var$load("1Tuyb"),
    $f0244394220572e6$var$load("7iCpI")
]).then(()=>parcelRequire('6QVCK'));

});

parcelRegister("4qfEE", function(module, exports) {

let $3385bbd35cdaf7fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3385bbd35cdaf7fe$var$load("gDiIK"),
    $3385bbd35cdaf7fe$var$load("eLlpV"),
    $3385bbd35cdaf7fe$var$load("f1B4n"),
    $3385bbd35cdaf7fe$var$load("7sItg"),
    $3385bbd35cdaf7fe$var$load("1Tuyb"),
    $3385bbd35cdaf7fe$var$load("7iCpI")
]).then(()=>parcelRequire('6XvEn'));

});

parcelRegister("2hO4g", function(module, exports) {

let $1aa401bd7e1e9bef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1aa401bd7e1e9bef$var$load("gDiIK"),
    $1aa401bd7e1e9bef$var$load("eLlpV"),
    $1aa401bd7e1e9bef$var$load("f1B4n"),
    $1aa401bd7e1e9bef$var$load("7sItg"),
    $1aa401bd7e1e9bef$var$load("1Tuyb"),
    $1aa401bd7e1e9bef$var$load("7iCpI")
]).then(()=>parcelRequire('igHdQ'));

});

parcelRegister("8i4WU", function(module, exports) {

let $6093d7f7707c3b0f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6093d7f7707c3b0f$var$load("gDiIK"),
    $6093d7f7707c3b0f$var$load("eLlpV"),
    $6093d7f7707c3b0f$var$load("f1B4n"),
    $6093d7f7707c3b0f$var$load("7sItg"),
    $6093d7f7707c3b0f$var$load("1Tuyb"),
    $6093d7f7707c3b0f$var$load("7iCpI")
]).then(()=>parcelRequire('6A8Au'));

});

parcelRegister("fPuGj", function(module, exports) {

let $b8636b2854fd3c69$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b8636b2854fd3c69$var$load("gDiIK"),
    $b8636b2854fd3c69$var$load("eLlpV"),
    $b8636b2854fd3c69$var$load("f1B4n"),
    $b8636b2854fd3c69$var$load("7sItg"),
    $b8636b2854fd3c69$var$load("1Tuyb"),
    $b8636b2854fd3c69$var$load("7iCpI")
]).then(()=>parcelRequire('jKBtA'));

});

parcelRegister("cv67e", function(module, exports) {

let $919d1fbabca06402$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $919d1fbabca06402$var$load("gDiIK"),
    $919d1fbabca06402$var$load("eLlpV"),
    $919d1fbabca06402$var$load("f1B4n"),
    $919d1fbabca06402$var$load("7sItg"),
    $919d1fbabca06402$var$load("1Tuyb"),
    $919d1fbabca06402$var$load("7iCpI")
]).then(()=>parcelRequire('fFFDo'));

});

parcelRegister("Ntwva", function(module, exports) {

let $094b7a6a1cc472a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $094b7a6a1cc472a3$var$load("gDiIK"),
    $094b7a6a1cc472a3$var$load("eLlpV"),
    $094b7a6a1cc472a3$var$load("f1B4n"),
    $094b7a6a1cc472a3$var$load("7sItg"),
    $094b7a6a1cc472a3$var$load("1Tuyb"),
    $094b7a6a1cc472a3$var$load("7iCpI")
]).then(()=>parcelRequire('8KOQh'));

});

parcelRegister("eCrXN", function(module, exports) {

let $aa4a4e447cb6bda0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aa4a4e447cb6bda0$var$load("gDiIK"),
    $aa4a4e447cb6bda0$var$load("eLlpV"),
    $aa4a4e447cb6bda0$var$load("f1B4n"),
    $aa4a4e447cb6bda0$var$load("7sItg"),
    $aa4a4e447cb6bda0$var$load("1Tuyb"),
    $aa4a4e447cb6bda0$var$load("7iCpI")
]).then(()=>parcelRequire('5WXmf'));

});

parcelRegister("d7mnE", function(module, exports) {

let $98cd4a1ea989497c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $98cd4a1ea989497c$var$load("gDiIK"),
    $98cd4a1ea989497c$var$load("eLlpV"),
    $98cd4a1ea989497c$var$load("f1B4n"),
    $98cd4a1ea989497c$var$load("7sItg"),
    $98cd4a1ea989497c$var$load("1Tuyb"),
    $98cd4a1ea989497c$var$load("7iCpI")
]).then(()=>parcelRequire('8N0Ia'));

});

parcelRegister("gaZlZ", function(module, exports) {

let $bc6d2c0cbe2b50ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bc6d2c0cbe2b50ae$var$load("gDiIK"),
    $bc6d2c0cbe2b50ae$var$load("eLlpV"),
    $bc6d2c0cbe2b50ae$var$load("f1B4n"),
    $bc6d2c0cbe2b50ae$var$load("7sItg"),
    $bc6d2c0cbe2b50ae$var$load("1Tuyb"),
    $bc6d2c0cbe2b50ae$var$load("7iCpI")
]).then(()=>parcelRequire('2lN8c'));

});

parcelRegister("frhpg", function(module, exports) {

let $b3d6e1367b60f475$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b3d6e1367b60f475$var$load("gDiIK"),
    $b3d6e1367b60f475$var$load("eLlpV"),
    $b3d6e1367b60f475$var$load("f1B4n"),
    $b3d6e1367b60f475$var$load("7sItg"),
    $b3d6e1367b60f475$var$load("1Tuyb"),
    $b3d6e1367b60f475$var$load("7iCpI")
]).then(()=>parcelRequire('b5zD1'));

});

parcelRegister("9SR7e", function(module, exports) {

let $73225be1e50277bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $73225be1e50277bd$var$load("gDiIK"),
    $73225be1e50277bd$var$load("eLlpV"),
    $73225be1e50277bd$var$load("f1B4n"),
    $73225be1e50277bd$var$load("7sItg"),
    $73225be1e50277bd$var$load("1Tuyb"),
    $73225be1e50277bd$var$load("7iCpI")
]).then(()=>parcelRequire('ggpMi'));

});

parcelRegister("fg8fT", function(module, exports) {

let $b1bec0f5d05dc26d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b1bec0f5d05dc26d$var$load("gDiIK"),
    $b1bec0f5d05dc26d$var$load("eLlpV"),
    $b1bec0f5d05dc26d$var$load("f1B4n"),
    $b1bec0f5d05dc26d$var$load("7sItg"),
    $b1bec0f5d05dc26d$var$load("1Tuyb"),
    $b1bec0f5d05dc26d$var$load("7iCpI")
]).then(()=>parcelRequire('kdfal'));

});

parcelRegister("8rIKC", function(module, exports) {

let $62638ef78935596c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $62638ef78935596c$var$load("gDiIK"),
    $62638ef78935596c$var$load("eLlpV"),
    $62638ef78935596c$var$load("f1B4n"),
    $62638ef78935596c$var$load("7sItg"),
    $62638ef78935596c$var$load("1Tuyb"),
    $62638ef78935596c$var$load("7iCpI")
]).then(()=>parcelRequire('lduxP'));

});

parcelRegister("bbIQ2", function(module, exports) {

let $825380c34c2f4862$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $825380c34c2f4862$var$load("gDiIK"),
    $825380c34c2f4862$var$load("eLlpV"),
    $825380c34c2f4862$var$load("f1B4n"),
    $825380c34c2f4862$var$load("7sItg"),
    $825380c34c2f4862$var$load("1Tuyb"),
    $825380c34c2f4862$var$load("7iCpI")
]).then(()=>parcelRequire('ea83r'));

});

parcelRegister("i4Utk", function(module, exports) {

let $d29467e71a60faf9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d29467e71a60faf9$var$load("gDiIK"),
    $d29467e71a60faf9$var$load("eLlpV"),
    $d29467e71a60faf9$var$load("f1B4n"),
    $d29467e71a60faf9$var$load("7sItg"),
    $d29467e71a60faf9$var$load("1Tuyb"),
    $d29467e71a60faf9$var$load("7iCpI")
]).then(()=>parcelRequire('91VzV'));

});

parcelRegister("irZzC", function(module, exports) {

let $d6ea82cd1a09e954$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d6ea82cd1a09e954$var$load("gDiIK"),
    $d6ea82cd1a09e954$var$load("eLlpV"),
    $d6ea82cd1a09e954$var$load("f1B4n"),
    $d6ea82cd1a09e954$var$load("7sItg"),
    $d6ea82cd1a09e954$var$load("1Tuyb"),
    $d6ea82cd1a09e954$var$load("7iCpI")
]).then(()=>parcelRequire('13oZu'));

});

parcelRegister("2WuKG", function(module, exports) {

let $2248da3ae1ed1ebb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2248da3ae1ed1ebb$var$load("gDiIK"),
    $2248da3ae1ed1ebb$var$load("eLlpV"),
    $2248da3ae1ed1ebb$var$load("f1B4n"),
    $2248da3ae1ed1ebb$var$load("7sItg"),
    $2248da3ae1ed1ebb$var$load("1Tuyb"),
    $2248da3ae1ed1ebb$var$load("7iCpI")
]).then(()=>parcelRequire('6rKLI'));

});

parcelRegister("blkN1", function(module, exports) {

let $8421c846fdce6c71$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8421c846fdce6c71$var$load("gDiIK"),
    $8421c846fdce6c71$var$load("eLlpV"),
    $8421c846fdce6c71$var$load("f1B4n"),
    $8421c846fdce6c71$var$load("7sItg"),
    $8421c846fdce6c71$var$load("1Tuyb"),
    $8421c846fdce6c71$var$load("7iCpI")
]).then(()=>parcelRequire('7CKM8'));

});

parcelRegister("wsFXm", function(module, exports) {

let $06193bac6e658402$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $06193bac6e658402$var$load("gDiIK"),
    $06193bac6e658402$var$load("eLlpV"),
    $06193bac6e658402$var$load("f1B4n"),
    $06193bac6e658402$var$load("7sItg"),
    $06193bac6e658402$var$load("1Tuyb"),
    $06193bac6e658402$var$load("7iCpI")
]).then(()=>parcelRequire('1kKoV'));

});

parcelRegister("cjzkx", function(module, exports) {

let $8f72aa40fc6e62ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8f72aa40fc6e62ae$var$load("gDiIK"),
    $8f72aa40fc6e62ae$var$load("eLlpV"),
    $8f72aa40fc6e62ae$var$load("f1B4n"),
    $8f72aa40fc6e62ae$var$load("7sItg"),
    $8f72aa40fc6e62ae$var$load("1Tuyb"),
    $8f72aa40fc6e62ae$var$load("7iCpI")
]).then(()=>parcelRequire('gr9D8'));

});

parcelRegister("8AnHw", function(module, exports) {

let $64041206d23fa0ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $64041206d23fa0ad$var$load("gDiIK"),
    $64041206d23fa0ad$var$load("eLlpV"),
    $64041206d23fa0ad$var$load("f1B4n"),
    $64041206d23fa0ad$var$load("7sItg"),
    $64041206d23fa0ad$var$load("1Tuyb"),
    $64041206d23fa0ad$var$load("7iCpI")
]).then(()=>parcelRequire('fdYvn'));

});

parcelRegister("gwyWM", function(module, exports) {

let $c07abe3eec71a15c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c07abe3eec71a15c$var$load("gDiIK"),
    $c07abe3eec71a15c$var$load("eLlpV"),
    $c07abe3eec71a15c$var$load("f1B4n"),
    $c07abe3eec71a15c$var$load("7sItg"),
    $c07abe3eec71a15c$var$load("1Tuyb"),
    $c07abe3eec71a15c$var$load("7iCpI")
]).then(()=>parcelRequire('eiQMd'));

});

parcelRegister("jpubq", function(module, exports) {

let $e217c3e3e660139a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e217c3e3e660139a$var$load("gDiIK"),
    $e217c3e3e660139a$var$load("eLlpV"),
    $e217c3e3e660139a$var$load("f1B4n"),
    $e217c3e3e660139a$var$load("7sItg"),
    $e217c3e3e660139a$var$load("1Tuyb"),
    $e217c3e3e660139a$var$load("7iCpI")
]).then(()=>parcelRequire('g36wP'));

});

parcelRegister("f0Mty", function(module, exports) {

let $aedc7562474e0934$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aedc7562474e0934$var$load("gDiIK"),
    $aedc7562474e0934$var$load("eLlpV"),
    $aedc7562474e0934$var$load("f1B4n"),
    $aedc7562474e0934$var$load("7sItg"),
    $aedc7562474e0934$var$load("1Tuyb"),
    $aedc7562474e0934$var$load("7iCpI")
]).then(()=>parcelRequire('fMZS7'));

});

parcelRegister("4q5qH", function(module, exports) {

let $337dcd57851b88f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $337dcd57851b88f0$var$load("gDiIK"),
    $337dcd57851b88f0$var$load("eLlpV"),
    $337dcd57851b88f0$var$load("f1B4n"),
    $337dcd57851b88f0$var$load("7sItg"),
    $337dcd57851b88f0$var$load("1Tuyb"),
    $337dcd57851b88f0$var$load("7iCpI")
]).then(()=>parcelRequire('g1lJo'));

});

parcelRegister("gE1YK", function(module, exports) {

let $c1e1eabc0a020f47$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c1e1eabc0a020f47$var$load("gDiIK"),
    $c1e1eabc0a020f47$var$load("eLlpV"),
    $c1e1eabc0a020f47$var$load("f1B4n"),
    $c1e1eabc0a020f47$var$load("7sItg"),
    $c1e1eabc0a020f47$var$load("1Tuyb"),
    $c1e1eabc0a020f47$var$load("7iCpI")
]).then(()=>parcelRequire('bXvEd'));

});

parcelRegister("a3MCo", function(module, exports) {

let $752fe5bea68905c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $752fe5bea68905c9$var$load("gDiIK"),
    $752fe5bea68905c9$var$load("eLlpV"),
    $752fe5bea68905c9$var$load("f1B4n"),
    $752fe5bea68905c9$var$load("7sItg"),
    $752fe5bea68905c9$var$load("1Tuyb"),
    $752fe5bea68905c9$var$load("7iCpI")
]).then(()=>parcelRequire('aGwmi'));

});

parcelRegister("1DGKK", function(module, exports) {

let $131a98ce2b14db23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $131a98ce2b14db23$var$load("gDiIK"),
    $131a98ce2b14db23$var$load("eLlpV"),
    $131a98ce2b14db23$var$load("f1B4n"),
    $131a98ce2b14db23$var$load("7sItg"),
    $131a98ce2b14db23$var$load("1Tuyb"),
    $131a98ce2b14db23$var$load("7iCpI")
]).then(()=>parcelRequire('bGeA3'));

});

parcelRegister("l8zxR", function(module, exports) {

let $f635ead9de1c7877$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f635ead9de1c7877$var$load("gDiIK"),
    $f635ead9de1c7877$var$load("eLlpV"),
    $f635ead9de1c7877$var$load("f1B4n"),
    $f635ead9de1c7877$var$load("7sItg"),
    $f635ead9de1c7877$var$load("1Tuyb"),
    $f635ead9de1c7877$var$load("7iCpI")
]).then(()=>parcelRequire('kpvhh'));

});

parcelRegister("kGQe4", function(module, exports) {

let $f1003ddd14263ae8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f1003ddd14263ae8$var$load("gDiIK"),
    $f1003ddd14263ae8$var$load("eLlpV"),
    $f1003ddd14263ae8$var$load("f1B4n"),
    $f1003ddd14263ae8$var$load("7sItg"),
    $f1003ddd14263ae8$var$load("1Tuyb"),
    $f1003ddd14263ae8$var$load("7iCpI")
]).then(()=>parcelRequire('kZd4Y'));

});

parcelRegister("iEHWY", function(module, exports) {

let $0381424a5799a542$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0381424a5799a542$var$load("gDiIK"),
    $0381424a5799a542$var$load("eLlpV"),
    $0381424a5799a542$var$load("f1B4n"),
    $0381424a5799a542$var$load("7sItg"),
    $0381424a5799a542$var$load("1Tuyb"),
    $0381424a5799a542$var$load("7iCpI")
]).then(()=>parcelRequire('ctJgd'));

});

parcelRegister("kCIZm", function(module, exports) {

let $f03a41146a0dbbe2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f03a41146a0dbbe2$var$load("gDiIK"),
    $f03a41146a0dbbe2$var$load("eLlpV"),
    $f03a41146a0dbbe2$var$load("f1B4n"),
    $f03a41146a0dbbe2$var$load("7sItg"),
    $f03a41146a0dbbe2$var$load("1Tuyb"),
    $f03a41146a0dbbe2$var$load("7iCpI")
]).then(()=>parcelRequire('9CH5i'));

});

parcelRegister("1Pemw", function(module, exports) {

let $1545b1ed7832f70b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1545b1ed7832f70b$var$load("gDiIK"),
    $1545b1ed7832f70b$var$load("eLlpV"),
    $1545b1ed7832f70b$var$load("f1B4n"),
    $1545b1ed7832f70b$var$load("7sItg"),
    $1545b1ed7832f70b$var$load("1Tuyb"),
    $1545b1ed7832f70b$var$load("7iCpI")
]).then(()=>parcelRequire('iXK8O'));

});

parcelRegister("2cQTL", function(module, exports) {

let $19b5bc42e8b61d74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $19b5bc42e8b61d74$var$load("gDiIK"),
    $19b5bc42e8b61d74$var$load("eLlpV"),
    $19b5bc42e8b61d74$var$load("f1B4n"),
    $19b5bc42e8b61d74$var$load("7sItg"),
    $19b5bc42e8b61d74$var$load("1Tuyb"),
    $19b5bc42e8b61d74$var$load("7iCpI")
]).then(()=>parcelRequire('leSGD'));

});

parcelRegister("5Bquy", function(module, exports) {

let $4144f52998a5b703$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4144f52998a5b703$var$load("gDiIK"),
    $4144f52998a5b703$var$load("eLlpV"),
    $4144f52998a5b703$var$load("f1B4n"),
    $4144f52998a5b703$var$load("7sItg"),
    $4144f52998a5b703$var$load("1Tuyb"),
    $4144f52998a5b703$var$load("7iCpI")
]).then(()=>parcelRequire('3Gv94'));

});

parcelRegister("hmVpw", function(module, exports) {

let $ca510646712a8ed4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ca510646712a8ed4$var$load("gDiIK"),
    $ca510646712a8ed4$var$load("eLlpV"),
    $ca510646712a8ed4$var$load("f1B4n"),
    $ca510646712a8ed4$var$load("7sItg"),
    $ca510646712a8ed4$var$load("1Tuyb"),
    $ca510646712a8ed4$var$load("7iCpI")
]).then(()=>parcelRequire('5zGnG'));

});

parcelRegister("jMgDu", function(module, exports) {

let $e65f678a4e9318a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e65f678a4e9318a1$var$load("gDiIK"),
    $e65f678a4e9318a1$var$load("eLlpV"),
    $e65f678a4e9318a1$var$load("f1B4n"),
    $e65f678a4e9318a1$var$load("7sItg"),
    $e65f678a4e9318a1$var$load("1Tuyb"),
    $e65f678a4e9318a1$var$load("7iCpI")
]).then(()=>parcelRequire('hc8vA'));

});

parcelRegister("78OkM", function(module, exports) {

let $53305312927ab680$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $53305312927ab680$var$load("gDiIK"),
    $53305312927ab680$var$load("eLlpV"),
    $53305312927ab680$var$load("f1B4n"),
    $53305312927ab680$var$load("7sItg"),
    $53305312927ab680$var$load("1Tuyb"),
    $53305312927ab680$var$load("7iCpI")
]).then(()=>parcelRequire('aCtVP'));

});

parcelRegister("3jJh8", function(module, exports) {

let $26a6442a834ba9df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $26a6442a834ba9df$var$load("gDiIK"),
    $26a6442a834ba9df$var$load("eLlpV"),
    $26a6442a834ba9df$var$load("f1B4n"),
    $26a6442a834ba9df$var$load("7sItg"),
    $26a6442a834ba9df$var$load("1Tuyb"),
    $26a6442a834ba9df$var$load("7iCpI")
]).then(()=>parcelRequire('59j1T'));

});

parcelRegister("dKzkX", function(module, exports) {

let $a02afb69c51d8e87$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a02afb69c51d8e87$var$load("gDiIK"),
    $a02afb69c51d8e87$var$load("eLlpV"),
    $a02afb69c51d8e87$var$load("f1B4n"),
    $a02afb69c51d8e87$var$load("7sItg"),
    $a02afb69c51d8e87$var$load("1Tuyb"),
    $a02afb69c51d8e87$var$load("7iCpI")
]).then(()=>parcelRequire('4MCxA'));

});

parcelRegister("3RiGn", function(module, exports) {

let $2cf4d04f8a0d58c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2cf4d04f8a0d58c6$var$load("gDiIK"),
    $2cf4d04f8a0d58c6$var$load("eLlpV"),
    $2cf4d04f8a0d58c6$var$load("f1B4n"),
    $2cf4d04f8a0d58c6$var$load("7sItg"),
    $2cf4d04f8a0d58c6$var$load("1Tuyb"),
    $2cf4d04f8a0d58c6$var$load("7iCpI")
]).then(()=>parcelRequire('3n8T5'));

});

parcelRegister("2XIfy", function(module, exports) {

let $22836a9434e1acdd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $22836a9434e1acdd$var$load("gDiIK"),
    $22836a9434e1acdd$var$load("eLlpV"),
    $22836a9434e1acdd$var$load("f1B4n"),
    $22836a9434e1acdd$var$load("7sItg"),
    $22836a9434e1acdd$var$load("1Tuyb"),
    $22836a9434e1acdd$var$load("7iCpI")
]).then(()=>parcelRequire('6lhAp'));

});

parcelRegister("kXTyV", function(module, exports) {

let $f4346ad5333432d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f4346ad5333432d7$var$load("gDiIK"),
    $f4346ad5333432d7$var$load("eLlpV"),
    $f4346ad5333432d7$var$load("f1B4n"),
    $f4346ad5333432d7$var$load("7sItg"),
    $f4346ad5333432d7$var$load("1Tuyb"),
    $f4346ad5333432d7$var$load("7iCpI")
]).then(()=>parcelRequire('3XUnZ'));

});

parcelRegister("8zP6u", function(module, exports) {

let $63e93bb87b1b0225$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63e93bb87b1b0225$var$load("gDiIK"),
    $63e93bb87b1b0225$var$load("eLlpV"),
    $63e93bb87b1b0225$var$load("f1B4n"),
    $63e93bb87b1b0225$var$load("7sItg"),
    $63e93bb87b1b0225$var$load("1Tuyb"),
    $63e93bb87b1b0225$var$load("7iCpI")
]).then(()=>parcelRequire('4SEiN'));

});

parcelRegister("gYPsP", function(module, exports) {

let $c5ca2b9c4f5d498b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c5ca2b9c4f5d498b$var$load("gDiIK"),
    $c5ca2b9c4f5d498b$var$load("eLlpV"),
    $c5ca2b9c4f5d498b$var$load("f1B4n"),
    $c5ca2b9c4f5d498b$var$load("7sItg"),
    $c5ca2b9c4f5d498b$var$load("1Tuyb"),
    $c5ca2b9c4f5d498b$var$load("7iCpI")
]).then(()=>parcelRequire('9PKH8'));

});

parcelRegister("621Nl", function(module, exports) {

let $46445267f291defc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $46445267f291defc$var$load("gDiIK"),
    $46445267f291defc$var$load("eLlpV"),
    $46445267f291defc$var$load("f1B4n"),
    $46445267f291defc$var$load("7sItg"),
    $46445267f291defc$var$load("1Tuyb"),
    $46445267f291defc$var$load("7iCpI")
]).then(()=>parcelRequire('b0BGs'));

});

parcelRegister("6oWhF", function(module, exports) {

let $4a9231f5cd93e17a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4a9231f5cd93e17a$var$load("gDiIK"),
    $4a9231f5cd93e17a$var$load("eLlpV"),
    $4a9231f5cd93e17a$var$load("f1B4n"),
    $4a9231f5cd93e17a$var$load("7sItg"),
    $4a9231f5cd93e17a$var$load("1Tuyb"),
    $4a9231f5cd93e17a$var$load("7iCpI")
]).then(()=>parcelRequire('iVjWj'));

});

parcelRegister("8KoP3", function(module, exports) {

let $65e5dfd892fb51d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $65e5dfd892fb51d5$var$load("gDiIK"),
    $65e5dfd892fb51d5$var$load("eLlpV"),
    $65e5dfd892fb51d5$var$load("f1B4n"),
    $65e5dfd892fb51d5$var$load("7sItg"),
    $65e5dfd892fb51d5$var$load("1Tuyb"),
    $65e5dfd892fb51d5$var$load("7iCpI")
]).then(()=>parcelRequire('cXysQ'));

});

parcelRegister("hVxyg", function(module, exports) {

let $d0d1c92ccaa891ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d0d1c92ccaa891ca$var$load("gDiIK"),
    $d0d1c92ccaa891ca$var$load("eLlpV"),
    $d0d1c92ccaa891ca$var$load("f1B4n"),
    $d0d1c92ccaa891ca$var$load("7sItg"),
    $d0d1c92ccaa891ca$var$load("1Tuyb"),
    $d0d1c92ccaa891ca$var$load("7iCpI")
]).then(()=>parcelRequire('e6TKr'));

});

parcelRegister("2IuuZ", function(module, exports) {

let $1fa759474c56ae86$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1fa759474c56ae86$var$load("j9OUx"),
    $1fa759474c56ae86$var$load("bV8sS"),
    $1fa759474c56ae86$var$load("l079e"),
    $1fa759474c56ae86$var$load("kKXTS"),
    $1fa759474c56ae86$var$load("hF4v3"),
    $1fa759474c56ae86$var$load("afU9w")
]).then(()=>parcelRequire('ignUV'));

});

parcelRegister("4Qogz", function(module, exports) {

let $386ed781723c6c02$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $386ed781723c6c02$var$load("j9OUx"),
    $386ed781723c6c02$var$load("bV8sS"),
    $386ed781723c6c02$var$load("l079e"),
    $386ed781723c6c02$var$load("kKXTS"),
    $386ed781723c6c02$var$load("hF4v3"),
    $386ed781723c6c02$var$load("afU9w")
]).then(()=>parcelRequire('7EwjJ'));

});

parcelRegister("6fq6p", function(module, exports) {

let $48c8643132706c24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $48c8643132706c24$var$load("j9OUx"),
    $48c8643132706c24$var$load("bV8sS"),
    $48c8643132706c24$var$load("l079e"),
    $48c8643132706c24$var$load("kKXTS"),
    $48c8643132706c24$var$load("hF4v3"),
    $48c8643132706c24$var$load("afU9w")
]).then(()=>parcelRequire('jt6zg'));

});

parcelRegister("4IUb2", function(module, exports) {

let $3706d91964e5085f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3706d91964e5085f$var$load("j9OUx"),
    $3706d91964e5085f$var$load("bV8sS"),
    $3706d91964e5085f$var$load("l079e"),
    $3706d91964e5085f$var$load("kKXTS"),
    $3706d91964e5085f$var$load("hF4v3"),
    $3706d91964e5085f$var$load("afU9w")
]).then(()=>parcelRequire('7hDnX'));

});

parcelRegister("9CnN2", function(module, exports) {

let $700a1ddb84c616e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $700a1ddb84c616e4$var$load("j9OUx"),
    $700a1ddb84c616e4$var$load("bV8sS"),
    $700a1ddb84c616e4$var$load("l079e"),
    $700a1ddb84c616e4$var$load("kKXTS"),
    $700a1ddb84c616e4$var$load("hF4v3"),
    $700a1ddb84c616e4$var$load("afU9w")
]).then(()=>parcelRequire('lRTsu'));

});

parcelRegister("bO3GU", function(module, exports) {

let $89873a324f137131$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $89873a324f137131$var$load("j9OUx"),
    $89873a324f137131$var$load("bV8sS"),
    $89873a324f137131$var$load("l079e"),
    $89873a324f137131$var$load("kKXTS"),
    $89873a324f137131$var$load("hF4v3"),
    $89873a324f137131$var$load("afU9w")
]).then(()=>parcelRequire('crJQR'));

});

parcelRegister("3sKHD", function(module, exports) {

let $285836ceb69f0f1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $285836ceb69f0f1c$var$load("j9OUx"),
    $285836ceb69f0f1c$var$load("bV8sS"),
    $285836ceb69f0f1c$var$load("l079e"),
    $285836ceb69f0f1c$var$load("kKXTS"),
    $285836ceb69f0f1c$var$load("hF4v3"),
    $285836ceb69f0f1c$var$load("afU9w")
]).then(()=>parcelRequire('l3SRu'));

});

parcelRegister("8BAgg", function(module, exports) {

let $643de82df908b7b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $643de82df908b7b3$var$load("j9OUx"),
    $643de82df908b7b3$var$load("bV8sS"),
    $643de82df908b7b3$var$load("l079e"),
    $643de82df908b7b3$var$load("kKXTS"),
    $643de82df908b7b3$var$load("hF4v3"),
    $643de82df908b7b3$var$load("afU9w")
]).then(()=>parcelRequire('6PXdj'));

});

parcelRegister("bvN9u", function(module, exports) {

let $8618b788244b6f8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8618b788244b6f8a$var$load("j9OUx"),
    $8618b788244b6f8a$var$load("bV8sS"),
    $8618b788244b6f8a$var$load("l079e"),
    $8618b788244b6f8a$var$load("kKXTS"),
    $8618b788244b6f8a$var$load("hF4v3"),
    $8618b788244b6f8a$var$load("afU9w")
]).then(()=>parcelRequire('iUxNS'));

});

parcelRegister("cDueA", function(module, exports) {

let $93309474224ae451$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $93309474224ae451$var$load("j9OUx"),
    $93309474224ae451$var$load("bV8sS"),
    $93309474224ae451$var$load("l079e"),
    $93309474224ae451$var$load("kKXTS"),
    $93309474224ae451$var$load("hF4v3"),
    $93309474224ae451$var$load("afU9w")
]).then(()=>parcelRequire('7oUTT'));

});

parcelRegister("ar2qP", function(module, exports) {

let $798e4fe5ab781f4c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $798e4fe5ab781f4c$var$load("j9OUx"),
    $798e4fe5ab781f4c$var$load("bV8sS"),
    $798e4fe5ab781f4c$var$load("l079e"),
    $798e4fe5ab781f4c$var$load("kKXTS"),
    $798e4fe5ab781f4c$var$load("hF4v3"),
    $798e4fe5ab781f4c$var$load("afU9w")
]).then(()=>parcelRequire('kPU5q'));

});

parcelRegister("bE3dj", function(module, exports) {

let $87a5ec52db269299$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $87a5ec52db269299$var$load("j9OUx"),
    $87a5ec52db269299$var$load("bV8sS"),
    $87a5ec52db269299$var$load("l079e"),
    $87a5ec52db269299$var$load("kKXTS"),
    $87a5ec52db269299$var$load("hF4v3"),
    $87a5ec52db269299$var$load("afU9w")
]).then(()=>parcelRequire('5L7lK'));

});

parcelRegister("5SMsY", function(module, exports) {

let $448797479c863b66$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $448797479c863b66$var$load("j9OUx"),
    $448797479c863b66$var$load("bV8sS"),
    $448797479c863b66$var$load("l079e"),
    $448797479c863b66$var$load("kKXTS"),
    $448797479c863b66$var$load("hF4v3"),
    $448797479c863b66$var$load("afU9w")
]).then(()=>parcelRequire('eg68j'));

});

parcelRegister("jYMGc", function(module, exports) {

let $e8b961ad3c97e6dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e8b961ad3c97e6dc$var$load("j9OUx"),
    $e8b961ad3c97e6dc$var$load("bV8sS"),
    $e8b961ad3c97e6dc$var$load("l079e"),
    $e8b961ad3c97e6dc$var$load("kKXTS"),
    $e8b961ad3c97e6dc$var$load("hF4v3"),
    $e8b961ad3c97e6dc$var$load("afU9w")
]).then(()=>parcelRequire('ay1Qf'));

});

parcelRegister("6yjSe", function(module, exports) {

let $4c555588a23d66c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4c555588a23d66c5$var$load("j9OUx"),
    $4c555588a23d66c5$var$load("bV8sS"),
    $4c555588a23d66c5$var$load("l079e"),
    $4c555588a23d66c5$var$load("kKXTS"),
    $4c555588a23d66c5$var$load("hF4v3"),
    $4c555588a23d66c5$var$load("afU9w")
]).then(()=>parcelRequire('dPHT6'));

});

parcelRegister("3C2dA", function(module, exports) {

let $2a16a42abfbb7eca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2a16a42abfbb7eca$var$load("j9OUx"),
    $2a16a42abfbb7eca$var$load("bV8sS"),
    $2a16a42abfbb7eca$var$load("l079e"),
    $2a16a42abfbb7eca$var$load("kKXTS"),
    $2a16a42abfbb7eca$var$load("hF4v3"),
    $2a16a42abfbb7eca$var$load("afU9w")
]).then(()=>parcelRequire('3XVRA'));

});

parcelRegister("glqkY", function(module, exports) {

let $be63098ad9b78743$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $be63098ad9b78743$var$load("j9OUx"),
    $be63098ad9b78743$var$load("bV8sS"),
    $be63098ad9b78743$var$load("l079e"),
    $be63098ad9b78743$var$load("kKXTS"),
    $be63098ad9b78743$var$load("hF4v3"),
    $be63098ad9b78743$var$load("afU9w")
]).then(()=>parcelRequire('dpbjJ'));

});

parcelRegister("f4vRL", function(module, exports) {

let $af8ff2b4c619e3c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $af8ff2b4c619e3c2$var$load("j9OUx"),
    $af8ff2b4c619e3c2$var$load("bV8sS"),
    $af8ff2b4c619e3c2$var$load("l079e"),
    $af8ff2b4c619e3c2$var$load("kKXTS"),
    $af8ff2b4c619e3c2$var$load("hF4v3"),
    $af8ff2b4c619e3c2$var$load("afU9w")
]).then(()=>parcelRequire('6uNmH'));

});

parcelRegister("4Nozy", function(module, exports) {

let $37decc955d971faa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $37decc955d971faa$var$load("j9OUx"),
    $37decc955d971faa$var$load("bV8sS"),
    $37decc955d971faa$var$load("l079e"),
    $37decc955d971faa$var$load("kKXTS"),
    $37decc955d971faa$var$load("hF4v3"),
    $37decc955d971faa$var$load("afU9w")
]).then(()=>parcelRequire('ahfQJ'));

});

parcelRegister("1BuHK", function(module, exports) {

let $12b11073666d3d73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $12b11073666d3d73$var$load("j9OUx"),
    $12b11073666d3d73$var$load("bV8sS"),
    $12b11073666d3d73$var$load("l079e"),
    $12b11073666d3d73$var$load("kKXTS"),
    $12b11073666d3d73$var$load("hF4v3"),
    $12b11073666d3d73$var$load("afU9w")
]).then(()=>parcelRequire('5A2f8'));

});

parcelRegister("hgiFl", function(module, exports) {

let $c91268f38612aa4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c91268f38612aa4f$var$load("j9OUx"),
    $c91268f38612aa4f$var$load("bV8sS"),
    $c91268f38612aa4f$var$load("l079e"),
    $c91268f38612aa4f$var$load("kKXTS"),
    $c91268f38612aa4f$var$load("hF4v3"),
    $c91268f38612aa4f$var$load("afU9w")
]).then(()=>parcelRequire('bBhsX'));

});

parcelRegister("4oWJF", function(module, exports) {

let $3346f6feea98538a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3346f6feea98538a$var$load("j9OUx"),
    $3346f6feea98538a$var$load("bV8sS"),
    $3346f6feea98538a$var$load("l079e"),
    $3346f6feea98538a$var$load("kKXTS"),
    $3346f6feea98538a$var$load("hF4v3"),
    $3346f6feea98538a$var$load("afU9w")
]).then(()=>parcelRequire('5T2AD'));

});

parcelRegister("8uSaY", function(module, exports) {

let $62fb2645dd581677$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $62fb2645dd581677$var$load("j9OUx"),
    $62fb2645dd581677$var$load("bV8sS"),
    $62fb2645dd581677$var$load("l079e"),
    $62fb2645dd581677$var$load("kKXTS"),
    $62fb2645dd581677$var$load("hF4v3"),
    $62fb2645dd581677$var$load("afU9w")
]).then(()=>parcelRequire('joMkE'));

});

parcelRegister("3Ajke", function(module, exports) {

let $29c3b97ed51fe249$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $29c3b97ed51fe249$var$load("j9OUx"),
    $29c3b97ed51fe249$var$load("bV8sS"),
    $29c3b97ed51fe249$var$load("l079e"),
    $29c3b97ed51fe249$var$load("kKXTS"),
    $29c3b97ed51fe249$var$load("hF4v3"),
    $29c3b97ed51fe249$var$load("afU9w")
]).then(()=>parcelRequire('eg1n9'));

});

parcelRegister("ky9In", function(module, exports) {

let $ef5e84bfa6523c4e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef5e84bfa6523c4e$var$load("j9OUx"),
    $ef5e84bfa6523c4e$var$load("bV8sS"),
    $ef5e84bfa6523c4e$var$load("l079e"),
    $ef5e84bfa6523c4e$var$load("kKXTS"),
    $ef5e84bfa6523c4e$var$load("hF4v3"),
    $ef5e84bfa6523c4e$var$load("afU9w")
]).then(()=>parcelRequire('ceLE3'));

});

parcelRegister("hGspX", function(module, exports) {

let $cdfc670e2bb91f94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cdfc670e2bb91f94$var$load("j9OUx"),
    $cdfc670e2bb91f94$var$load("bV8sS"),
    $cdfc670e2bb91f94$var$load("l079e"),
    $cdfc670e2bb91f94$var$load("kKXTS"),
    $cdfc670e2bb91f94$var$load("hF4v3"),
    $cdfc670e2bb91f94$var$load("afU9w")
]).then(()=>parcelRequire('7O2l4'));

});

parcelRegister("fOV3L", function(module, exports) {

let $b847c9643cc36002$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b847c9643cc36002$var$load("j9OUx"),
    $b847c9643cc36002$var$load("bV8sS"),
    $b847c9643cc36002$var$load("l079e"),
    $b847c9643cc36002$var$load("kKXTS"),
    $b847c9643cc36002$var$load("hF4v3"),
    $b847c9643cc36002$var$load("afU9w")
]).then(()=>parcelRequire('kZoJG'));

});

parcelRegister("gJnJ1", function(module, exports) {

let $c2e340a3caefb18e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c2e340a3caefb18e$var$load("j9OUx"),
    $c2e340a3caefb18e$var$load("bV8sS"),
    $c2e340a3caefb18e$var$load("l079e"),
    $c2e340a3caefb18e$var$load("kKXTS"),
    $c2e340a3caefb18e$var$load("hF4v3"),
    $c2e340a3caefb18e$var$load("afU9w")
]).then(()=>parcelRequire('5hkDV'));

});

parcelRegister("aOmjA", function(module, exports) {

let $7defe226e8102509$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7defe226e8102509$var$load("j9OUx"),
    $7defe226e8102509$var$load("bV8sS"),
    $7defe226e8102509$var$load("l079e"),
    $7defe226e8102509$var$load("kKXTS"),
    $7defe226e8102509$var$load("hF4v3"),
    $7defe226e8102509$var$load("afU9w")
]).then(()=>parcelRequire('h9sH2'));

});

parcelRegister("aquFR", function(module, exports) {

let $79742056902f9f90$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $79742056902f9f90$var$load("j9OUx"),
    $79742056902f9f90$var$load("bV8sS"),
    $79742056902f9f90$var$load("l079e"),
    $79742056902f9f90$var$load("kKXTS"),
    $79742056902f9f90$var$load("hF4v3"),
    $79742056902f9f90$var$load("afU9w")
]).then(()=>parcelRequire('gE1aG'));

});

parcelRegister("11QG0", function(module, exports) {

let $0bfebee360e4e8ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0bfebee360e4e8ac$var$load("j9OUx"),
    $0bfebee360e4e8ac$var$load("bV8sS"),
    $0bfebee360e4e8ac$var$load("l079e"),
    $0bfebee360e4e8ac$var$load("kKXTS"),
    $0bfebee360e4e8ac$var$load("hF4v3"),
    $0bfebee360e4e8ac$var$load("afU9w")
]).then(()=>parcelRequire('ckNIJ'));

});

parcelRegister("fzZK6", function(module, exports) {

let $b57a04b360a0c091$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b57a04b360a0c091$var$load("j9OUx"),
    $b57a04b360a0c091$var$load("bV8sS"),
    $b57a04b360a0c091$var$load("l079e"),
    $b57a04b360a0c091$var$load("kKXTS"),
    $b57a04b360a0c091$var$load("hF4v3"),
    $b57a04b360a0c091$var$load("afU9w")
]).then(()=>parcelRequire('6E8Y8'));

});

parcelRegister("aQrK1", function(module, exports) {

let $7e544789db5cfa44$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7e544789db5cfa44$var$load("j9OUx"),
    $7e544789db5cfa44$var$load("bV8sS"),
    $7e544789db5cfa44$var$load("l079e"),
    $7e544789db5cfa44$var$load("kKXTS"),
    $7e544789db5cfa44$var$load("hF4v3"),
    $7e544789db5cfa44$var$load("afU9w")
]).then(()=>parcelRequire('2ZsG7'));

});

parcelRegister("dT7X0", function(module, exports) {

let $a1c6943ceb69ec48$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a1c6943ceb69ec48$var$load("j9OUx"),
    $a1c6943ceb69ec48$var$load("bV8sS"),
    $a1c6943ceb69ec48$var$load("l079e"),
    $a1c6943ceb69ec48$var$load("kKXTS"),
    $a1c6943ceb69ec48$var$load("hF4v3"),
    $a1c6943ceb69ec48$var$load("afU9w")
]).then(()=>parcelRequire('imojH'));

});

parcelRegister("k1y06", function(module, exports) {

let $e93e467aaa80c8b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e93e467aaa80c8b5$var$load("j9OUx"),
    $e93e467aaa80c8b5$var$load("bV8sS"),
    $e93e467aaa80c8b5$var$load("l079e"),
    $e93e467aaa80c8b5$var$load("kKXTS"),
    $e93e467aaa80c8b5$var$load("hF4v3"),
    $e93e467aaa80c8b5$var$load("afU9w")
]).then(()=>parcelRequire('edm7t'));

});

parcelRegister("3ZXdN", function(module, exports) {

let $2e9501c6f4bf1edd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2e9501c6f4bf1edd$var$load("j9OUx"),
    $2e9501c6f4bf1edd$var$load("bV8sS"),
    $2e9501c6f4bf1edd$var$load("l079e"),
    $2e9501c6f4bf1edd$var$load("kKXTS"),
    $2e9501c6f4bf1edd$var$load("hF4v3"),
    $2e9501c6f4bf1edd$var$load("afU9w")
]).then(()=>parcelRequire('5M5EC'));

});

parcelRegister("adYmX", function(module, exports) {

let $7719f25e0dc71937$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7719f25e0dc71937$var$load("j9OUx"),
    $7719f25e0dc71937$var$load("bV8sS"),
    $7719f25e0dc71937$var$load("l079e"),
    $7719f25e0dc71937$var$load("kKXTS"),
    $7719f25e0dc71937$var$load("hF4v3"),
    $7719f25e0dc71937$var$load("afU9w")
]).then(()=>parcelRequire('6QK8K'));

});

parcelRegister("5ORh0", function(module, exports) {

let $43caf23f930d4ef1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $43caf23f930d4ef1$var$load("j9OUx"),
    $43caf23f930d4ef1$var$load("bV8sS"),
    $43caf23f930d4ef1$var$load("l079e"),
    $43caf23f930d4ef1$var$load("kKXTS"),
    $43caf23f930d4ef1$var$load("hF4v3"),
    $43caf23f930d4ef1$var$load("afU9w")
]).then(()=>parcelRequire('hP4wC'));

});

parcelRegister("gRdNA", function(module, exports) {

let $c45c4cb7be8ebd4b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c45c4cb7be8ebd4b$var$load("j9OUx"),
    $c45c4cb7be8ebd4b$var$load("bV8sS"),
    $c45c4cb7be8ebd4b$var$load("l079e"),
    $c45c4cb7be8ebd4b$var$load("kKXTS"),
    $c45c4cb7be8ebd4b$var$load("hF4v3"),
    $c45c4cb7be8ebd4b$var$load("afU9w")
]).then(()=>parcelRequire('kGVhZ'));

});

parcelRegister("dYj34", function(module, exports) {

let $a2bfa79411071305$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a2bfa79411071305$var$load("j9OUx"),
    $a2bfa79411071305$var$load("bV8sS"),
    $a2bfa79411071305$var$load("l079e"),
    $a2bfa79411071305$var$load("kKXTS"),
    $a2bfa79411071305$var$load("hF4v3"),
    $a2bfa79411071305$var$load("afU9w")
]).then(()=>parcelRequire('5Dig0'));

});

parcelRegister("aaBhI", function(module, exports) {

let $7677c287ded7eafc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7677c287ded7eafc$var$load("j9OUx"),
    $7677c287ded7eafc$var$load("bV8sS"),
    $7677c287ded7eafc$var$load("l079e"),
    $7677c287ded7eafc$var$load("kKXTS"),
    $7677c287ded7eafc$var$load("hF4v3"),
    $7677c287ded7eafc$var$load("afU9w")
]).then(()=>parcelRequire('k7fv3'));

});

parcelRegister("fBwpI", function(module, exports) {

let $b5c37467e982eec0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b5c37467e982eec0$var$load("j9OUx"),
    $b5c37467e982eec0$var$load("bV8sS"),
    $b5c37467e982eec0$var$load("l079e"),
    $b5c37467e982eec0$var$load("kKXTS"),
    $b5c37467e982eec0$var$load("hF4v3"),
    $b5c37467e982eec0$var$load("afU9w")
]).then(()=>parcelRequire('iD8My'));

});

parcelRegister("lrUUy", function(module, exports) {

let $f9d843f6dc6719d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f9d843f6dc6719d5$var$load("j9OUx"),
    $f9d843f6dc6719d5$var$load("bV8sS"),
    $f9d843f6dc6719d5$var$load("l079e"),
    $f9d843f6dc6719d5$var$load("kKXTS"),
    $f9d843f6dc6719d5$var$load("hF4v3"),
    $f9d843f6dc6719d5$var$load("afU9w")
]).then(()=>parcelRequire('ew2WM'));

});

parcelRegister("9ysds", function(module, exports) {

let $6f4d2d28f2c0f1d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6f4d2d28f2c0f1d6$var$load("j9OUx"),
    $6f4d2d28f2c0f1d6$var$load("bV8sS"),
    $6f4d2d28f2c0f1d6$var$load("l079e"),
    $6f4d2d28f2c0f1d6$var$load("kKXTS"),
    $6f4d2d28f2c0f1d6$var$load("hF4v3"),
    $6f4d2d28f2c0f1d6$var$load("afU9w")
]).then(()=>parcelRequire('b2mXB'));

});

parcelRegister("6cdAA", function(module, exports) {

let $482e679913350850$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $482e679913350850$var$load("j9OUx"),
    $482e679913350850$var$load("bV8sS"),
    $482e679913350850$var$load("l079e"),
    $482e679913350850$var$load("kKXTS"),
    $482e679913350850$var$load("hF4v3"),
    $482e679913350850$var$load("afU9w")
]).then(()=>parcelRequire('90YOQ'));

});

parcelRegister("70nmK", function(module, exports) {

let $519aa872cc35ab9a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $519aa872cc35ab9a$var$load("j9OUx"),
    $519aa872cc35ab9a$var$load("bV8sS"),
    $519aa872cc35ab9a$var$load("l079e"),
    $519aa872cc35ab9a$var$load("kKXTS"),
    $519aa872cc35ab9a$var$load("hF4v3"),
    $519aa872cc35ab9a$var$load("afU9w")
]).then(()=>parcelRequire('iVBaS'));

});

parcelRegister("jM3pb", function(module, exports) {

let $e65524326985a621$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e65524326985a621$var$load("j9OUx"),
    $e65524326985a621$var$load("bV8sS"),
    $e65524326985a621$var$load("l079e"),
    $e65524326985a621$var$load("kKXTS"),
    $e65524326985a621$var$load("hF4v3"),
    $e65524326985a621$var$load("afU9w")
]).then(()=>parcelRequire('19XZn'));

});

parcelRegister("0dv56", function(module, exports) {

let $000a791515195b0e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $000a791515195b0e$var$load("j9OUx"),
    $000a791515195b0e$var$load("bV8sS"),
    $000a791515195b0e$var$load("l079e"),
    $000a791515195b0e$var$load("kKXTS"),
    $000a791515195b0e$var$load("hF4v3"),
    $000a791515195b0e$var$load("afU9w")
]).then(()=>parcelRequire('3pp8N'));

});

parcelRegister("6YNhw", function(module, exports) {

let $514e92f3ad16f968$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $514e92f3ad16f968$var$load("j9OUx"),
    $514e92f3ad16f968$var$load("bV8sS"),
    $514e92f3ad16f968$var$load("l079e"),
    $514e92f3ad16f968$var$load("kKXTS"),
    $514e92f3ad16f968$var$load("hF4v3"),
    $514e92f3ad16f968$var$load("afU9w")
]).then(()=>parcelRequire('g3Wce'));

});

parcelRegister("aRmNy", function(module, exports) {

let $7e8089e1b7d67e8b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7e8089e1b7d67e8b$var$load("j9OUx"),
    $7e8089e1b7d67e8b$var$load("bV8sS"),
    $7e8089e1b7d67e8b$var$load("l079e"),
    $7e8089e1b7d67e8b$var$load("kKXTS"),
    $7e8089e1b7d67e8b$var$load("hF4v3"),
    $7e8089e1b7d67e8b$var$load("afU9w")
]).then(()=>parcelRequire('b183a'));

});

parcelRegister("ipS8E", function(module, exports) {

let $d6848e9851924e66$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d6848e9851924e66$var$load("h0uBE"),
    $d6848e9851924e66$var$load("eBLgB"),
    $d6848e9851924e66$var$load("1n8w9"),
    $d6848e9851924e66$var$load("d0Fxy"),
    $d6848e9851924e66$var$load("6NHX3"),
    $d6848e9851924e66$var$load("77dzh")
]).then(()=>parcelRequire('eBV1M'));

});

parcelRegister("6Cc41", function(module, exports) {

let $4d0fa653310b3b19$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4d0fa653310b3b19$var$load("h0uBE"),
    $4d0fa653310b3b19$var$load("eBLgB"),
    $4d0fa653310b3b19$var$load("1n8w9"),
    $4d0fa653310b3b19$var$load("d0Fxy"),
    $4d0fa653310b3b19$var$load("6NHX3"),
    $4d0fa653310b3b19$var$load("77dzh")
]).then(()=>parcelRequire('jzOsq'));

});

parcelRegister("kSjT1", function(module, exports) {

let $f32846cee342c316$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f32846cee342c316$var$load("h0uBE"),
    $f32846cee342c316$var$load("eBLgB"),
    $f32846cee342c316$var$load("1n8w9"),
    $f32846cee342c316$var$load("d0Fxy"),
    $f32846cee342c316$var$load("6NHX3"),
    $f32846cee342c316$var$load("77dzh")
]).then(()=>parcelRequire('24OvT'));

});

parcelRegister("6jSEb", function(module, exports) {

let $499ee82fef58970f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $499ee82fef58970f$var$load("h0uBE"),
    $499ee82fef58970f$var$load("eBLgB"),
    $499ee82fef58970f$var$load("1n8w9"),
    $499ee82fef58970f$var$load("d0Fxy"),
    $499ee82fef58970f$var$load("6NHX3"),
    $499ee82fef58970f$var$load("77dzh")
]).then(()=>parcelRequire('8PU9Z'));

});

parcelRegister("2zfpe", function(module, exports) {

let $1deaccf3280454ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1deaccf3280454ea$var$load("h0uBE"),
    $1deaccf3280454ea$var$load("eBLgB"),
    $1deaccf3280454ea$var$load("1n8w9"),
    $1deaccf3280454ea$var$load("d0Fxy"),
    $1deaccf3280454ea$var$load("6NHX3"),
    $1deaccf3280454ea$var$load("77dzh")
]).then(()=>parcelRequire('4dnaM'));

});

parcelRegister("36j9T", function(module, exports) {

let $2420cb262bed45a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2420cb262bed45a6$var$load("h0uBE"),
    $2420cb262bed45a6$var$load("eBLgB"),
    $2420cb262bed45a6$var$load("1n8w9"),
    $2420cb262bed45a6$var$load("d0Fxy"),
    $2420cb262bed45a6$var$load("6NHX3"),
    $2420cb262bed45a6$var$load("77dzh")
]).then(()=>parcelRequire('jRxlC'));

});

parcelRegister("ckPPk", function(module, exports) {

let $8faf8e06374f6df8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8faf8e06374f6df8$var$load("h0uBE"),
    $8faf8e06374f6df8$var$load("eBLgB"),
    $8faf8e06374f6df8$var$load("1n8w9"),
    $8faf8e06374f6df8$var$load("d0Fxy"),
    $8faf8e06374f6df8$var$load("6NHX3"),
    $8faf8e06374f6df8$var$load("77dzh")
]).then(()=>parcelRequire('4r1nM'));

});

parcelRegister("17U1Q", function(module, exports) {

let $0d21e80a89096c8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0d21e80a89096c8f$var$load("h0uBE"),
    $0d21e80a89096c8f$var$load("eBLgB"),
    $0d21e80a89096c8f$var$load("1n8w9"),
    $0d21e80a89096c8f$var$load("d0Fxy"),
    $0d21e80a89096c8f$var$load("6NHX3"),
    $0d21e80a89096c8f$var$load("77dzh")
]).then(()=>parcelRequire('kepuY'));

});

parcelRegister("j3dnL", function(module, exports) {

let $dde8ad965c490074$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dde8ad965c490074$var$load("h0uBE"),
    $dde8ad965c490074$var$load("eBLgB"),
    $dde8ad965c490074$var$load("1n8w9"),
    $dde8ad965c490074$var$load("d0Fxy"),
    $dde8ad965c490074$var$load("6NHX3"),
    $dde8ad965c490074$var$load("77dzh")
]).then(()=>parcelRequire('cfVzx'));

});

parcelRegister("8lyjk", function(module, exports) {

let $613ae6507abe0eaf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $613ae6507abe0eaf$var$load("h0uBE"),
    $613ae6507abe0eaf$var$load("eBLgB"),
    $613ae6507abe0eaf$var$load("1n8w9"),
    $613ae6507abe0eaf$var$load("d0Fxy"),
    $613ae6507abe0eaf$var$load("6NHX3"),
    $613ae6507abe0eaf$var$load("77dzh")
]).then(()=>parcelRequire('fglhK'));

});

parcelRegister("dIHgW", function(module, exports) {

let $9fd0f3684a0c5d4b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9fd0f3684a0c5d4b$var$load("h0uBE"),
    $9fd0f3684a0c5d4b$var$load("eBLgB"),
    $9fd0f3684a0c5d4b$var$load("1n8w9"),
    $9fd0f3684a0c5d4b$var$load("d0Fxy"),
    $9fd0f3684a0c5d4b$var$load("6NHX3"),
    $9fd0f3684a0c5d4b$var$load("77dzh")
]).then(()=>parcelRequire('kcfNY'));

});

parcelRegister("cicjm", function(module, exports) {

let $8f30b73815a4ed44$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8f30b73815a4ed44$var$load("h0uBE"),
    $8f30b73815a4ed44$var$load("eBLgB"),
    $8f30b73815a4ed44$var$load("1n8w9"),
    $8f30b73815a4ed44$var$load("d0Fxy"),
    $8f30b73815a4ed44$var$load("6NHX3"),
    $8f30b73815a4ed44$var$load("77dzh")
]).then(()=>parcelRequire('11nrb'));

});

parcelRegister("b4HSq", function(module, exports) {

let $81021a7a6030a70b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $81021a7a6030a70b$var$load("h0uBE"),
    $81021a7a6030a70b$var$load("eBLgB"),
    $81021a7a6030a70b$var$load("1n8w9"),
    $81021a7a6030a70b$var$load("d0Fxy"),
    $81021a7a6030a70b$var$load("6NHX3"),
    $81021a7a6030a70b$var$load("77dzh")
]).then(()=>parcelRequire('gH2R4'));

});

parcelRegister("58W22", function(module, exports) {

let $3beab70c5b68d4f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3beab70c5b68d4f0$var$load("h0uBE"),
    $3beab70c5b68d4f0$var$load("eBLgB"),
    $3beab70c5b68d4f0$var$load("1n8w9"),
    $3beab70c5b68d4f0$var$load("d0Fxy"),
    $3beab70c5b68d4f0$var$load("6NHX3"),
    $3beab70c5b68d4f0$var$load("77dzh")
]).then(()=>parcelRequire('EGJr4'));

});

parcelRegister("6r3yr", function(module, exports) {

let $4af8058986a02587$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4af8058986a02587$var$load("h0uBE"),
    $4af8058986a02587$var$load("eBLgB"),
    $4af8058986a02587$var$load("1n8w9"),
    $4af8058986a02587$var$load("d0Fxy"),
    $4af8058986a02587$var$load("6NHX3"),
    $4af8058986a02587$var$load("77dzh")
]).then(()=>parcelRequire('633nq'));

});

parcelRegister("03uca", function(module, exports) {

let $00a7b40f64bce3d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $00a7b40f64bce3d3$var$load("h0uBE"),
    $00a7b40f64bce3d3$var$load("eBLgB"),
    $00a7b40f64bce3d3$var$load("1n8w9"),
    $00a7b40f64bce3d3$var$load("d0Fxy"),
    $00a7b40f64bce3d3$var$load("6NHX3"),
    $00a7b40f64bce3d3$var$load("77dzh")
]).then(()=>parcelRequire('ehIfn'));

});

parcelRegister("3mqHt", function(module, exports) {

let $27282340569740d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $27282340569740d1$var$load("h0uBE"),
    $27282340569740d1$var$load("eBLgB"),
    $27282340569740d1$var$load("1n8w9"),
    $27282340569740d1$var$load("d0Fxy"),
    $27282340569740d1$var$load("6NHX3"),
    $27282340569740d1$var$load("77dzh")
]).then(()=>parcelRequire('beepI'));

});

parcelRegister("2iat6", function(module, exports) {

let $1ab56201dece2466$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1ab56201dece2466$var$load("h0uBE"),
    $1ab56201dece2466$var$load("eBLgB"),
    $1ab56201dece2466$var$load("1n8w9"),
    $1ab56201dece2466$var$load("d0Fxy"),
    $1ab56201dece2466$var$load("6NHX3"),
    $1ab56201dece2466$var$load("77dzh")
]).then(()=>parcelRequire('3NTky'));

});

parcelRegister("9CJod", function(module, exports) {

let $701adf1bf3655f4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $701adf1bf3655f4a$var$load("h0uBE"),
    $701adf1bf3655f4a$var$load("eBLgB"),
    $701adf1bf3655f4a$var$load("1n8w9"),
    $701adf1bf3655f4a$var$load("d0Fxy"),
    $701adf1bf3655f4a$var$load("6NHX3"),
    $701adf1bf3655f4a$var$load("77dzh")
]).then(()=>parcelRequire('nfKKY'));

});

parcelRegister("aUYkR", function(module, exports) {

let $7f2defb126711374$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f2defb126711374$var$load("h0uBE"),
    $7f2defb126711374$var$load("eBLgB"),
    $7f2defb126711374$var$load("1n8w9"),
    $7f2defb126711374$var$load("d0Fxy"),
    $7f2defb126711374$var$load("6NHX3"),
    $7f2defb126711374$var$load("77dzh")
]).then(()=>parcelRequire('imtvR'));

});

parcelRegister("9LWsl", function(module, exports) {

let $71d5d9045213a6e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $71d5d9045213a6e1$var$load("h0uBE"),
    $71d5d9045213a6e1$var$load("eBLgB"),
    $71d5d9045213a6e1$var$load("1n8w9"),
    $71d5d9045213a6e1$var$load("d0Fxy"),
    $71d5d9045213a6e1$var$load("6NHX3"),
    $71d5d9045213a6e1$var$load("77dzh")
]).then(()=>parcelRequire('7WJlV'));

});

parcelRegister("2HJJD", function(module, exports) {

let $1f8312eeb7140392$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1f8312eeb7140392$var$load("h0uBE"),
    $1f8312eeb7140392$var$load("eBLgB"),
    $1f8312eeb7140392$var$load("1n8w9"),
    $1f8312eeb7140392$var$load("d0Fxy"),
    $1f8312eeb7140392$var$load("6NHX3"),
    $1f8312eeb7140392$var$load("77dzh")
]).then(()=>parcelRequire('kFA9y'));

});

parcelRegister("bzHCQ", function(module, exports) {

let $86d4cdb24330867e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $86d4cdb24330867e$var$load("h0uBE"),
    $86d4cdb24330867e$var$load("eBLgB"),
    $86d4cdb24330867e$var$load("1n8w9"),
    $86d4cdb24330867e$var$load("d0Fxy"),
    $86d4cdb24330867e$var$load("6NHX3"),
    $86d4cdb24330867e$var$load("77dzh")
]).then(()=>parcelRequire('qyZze'));

});

parcelRegister("cGT0B", function(module, exports) {

let $93d413e09e747934$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $93d413e09e747934$var$load("h0uBE"),
    $93d413e09e747934$var$load("eBLgB"),
    $93d413e09e747934$var$load("1n8w9"),
    $93d413e09e747934$var$load("d0Fxy"),
    $93d413e09e747934$var$load("6NHX3"),
    $93d413e09e747934$var$load("77dzh")
]).then(()=>parcelRequire('kaxhg'));

});

parcelRegister("kwPXa", function(module, exports) {

let $ef1f18a215acba5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef1f18a215acba5e$var$load("h0uBE"),
    $ef1f18a215acba5e$var$load("eBLgB"),
    $ef1f18a215acba5e$var$load("1n8w9"),
    $ef1f18a215acba5e$var$load("d0Fxy"),
    $ef1f18a215acba5e$var$load("6NHX3"),
    $ef1f18a215acba5e$var$load("77dzh")
]).then(()=>parcelRequire('lW9Pi'));

});

parcelRegister("9Tj1I", function(module, exports) {

let $733802631d6960c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $733802631d6960c9$var$load("h0uBE"),
    $733802631d6960c9$var$load("eBLgB"),
    $733802631d6960c9$var$load("1n8w9"),
    $733802631d6960c9$var$load("d0Fxy"),
    $733802631d6960c9$var$load("6NHX3"),
    $733802631d6960c9$var$load("77dzh")
]).then(()=>parcelRequire('2zYgh'));

});

parcelRegister("647dl", function(module, exports) {

let $46a8b66ad3fdbefb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $46a8b66ad3fdbefb$var$load("h0uBE"),
    $46a8b66ad3fdbefb$var$load("eBLgB"),
    $46a8b66ad3fdbefb$var$load("1n8w9"),
    $46a8b66ad3fdbefb$var$load("d0Fxy"),
    $46a8b66ad3fdbefb$var$load("6NHX3"),
    $46a8b66ad3fdbefb$var$load("77dzh")
]).then(()=>parcelRequire('iZdlm'));

});

parcelRegister("bmtNL", function(module, exports) {

let $8458ddc494f3b447$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8458ddc494f3b447$var$load("h0uBE"),
    $8458ddc494f3b447$var$load("eBLgB"),
    $8458ddc494f3b447$var$load("1n8w9"),
    $8458ddc494f3b447$var$load("d0Fxy"),
    $8458ddc494f3b447$var$load("6NHX3"),
    $8458ddc494f3b447$var$load("77dzh")
]).then(()=>parcelRequire('iT24I'));

});

parcelRegister("cON8f", function(module, exports) {

let $955044223057ba9f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $955044223057ba9f$var$load("h0uBE"),
    $955044223057ba9f$var$load("eBLgB"),
    $955044223057ba9f$var$load("1n8w9"),
    $955044223057ba9f$var$load("d0Fxy"),
    $955044223057ba9f$var$load("6NHX3"),
    $955044223057ba9f$var$load("77dzh")
]).then(()=>parcelRequire('kg8Eh'));

});

parcelRegister("loYIc", function(module, exports) {

let $f94aeefa14802575$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f94aeefa14802575$var$load("h0uBE"),
    $f94aeefa14802575$var$load("eBLgB"),
    $f94aeefa14802575$var$load("1n8w9"),
    $f94aeefa14802575$var$load("d0Fxy"),
    $f94aeefa14802575$var$load("6NHX3"),
    $f94aeefa14802575$var$load("77dzh")
]).then(()=>parcelRequire('4Wssb'));

});

parcelRegister("22QUF", function(module, exports) {

let $17d4d016b592bf89$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $17d4d016b592bf89$var$load("h0uBE"),
    $17d4d016b592bf89$var$load("eBLgB"),
    $17d4d016b592bf89$var$load("1n8w9"),
    $17d4d016b592bf89$var$load("d0Fxy"),
    $17d4d016b592bf89$var$load("6NHX3"),
    $17d4d016b592bf89$var$load("77dzh")
]).then(()=>parcelRequire('ggtix'));

});

parcelRegister("g7B8P", function(module, exports) {

let $bbca1c49f47d1731$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bbca1c49f47d1731$var$load("h0uBE"),
    $bbca1c49f47d1731$var$load("eBLgB"),
    $bbca1c49f47d1731$var$load("1n8w9"),
    $bbca1c49f47d1731$var$load("d0Fxy"),
    $bbca1c49f47d1731$var$load("6NHX3"),
    $bbca1c49f47d1731$var$load("77dzh")
]).then(()=>parcelRequire('kCgp2'));

});

parcelRegister("c6mWx", function(module, exports) {

let $8cf7d7a1f225ee74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8cf7d7a1f225ee74$var$load("h0uBE"),
    $8cf7d7a1f225ee74$var$load("eBLgB"),
    $8cf7d7a1f225ee74$var$load("1n8w9"),
    $8cf7d7a1f225ee74$var$load("d0Fxy"),
    $8cf7d7a1f225ee74$var$load("6NHX3"),
    $8cf7d7a1f225ee74$var$load("77dzh")
]).then(()=>parcelRequire('fJY11'));

});

parcelRegister("5XBUQ", function(module, exports) {

let $456fdfbbedcfb24a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $456fdfbbedcfb24a$var$load("h0uBE"),
    $456fdfbbedcfb24a$var$load("eBLgB"),
    $456fdfbbedcfb24a$var$load("1n8w9"),
    $456fdfbbedcfb24a$var$load("d0Fxy"),
    $456fdfbbedcfb24a$var$load("6NHX3"),
    $456fdfbbedcfb24a$var$load("77dzh")
]).then(()=>parcelRequire('bfO0G'));

});

parcelRegister("7tBlJ", function(module, exports) {

let $571836ad744712cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $571836ad744712cc$var$load("h0uBE"),
    $571836ad744712cc$var$load("eBLgB"),
    $571836ad744712cc$var$load("1n8w9"),
    $571836ad744712cc$var$load("d0Fxy"),
    $571836ad744712cc$var$load("6NHX3"),
    $571836ad744712cc$var$load("77dzh")
]).then(()=>parcelRequire('gXKeJ'));

});

parcelRegister("jIX5A", function(module, exports) {

let $e5bff63edc323e9f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e5bff63edc323e9f$var$load("h0uBE"),
    $e5bff63edc323e9f$var$load("eBLgB"),
    $e5bff63edc323e9f$var$load("1n8w9"),
    $e5bff63edc323e9f$var$load("d0Fxy"),
    $e5bff63edc323e9f$var$load("6NHX3"),
    $e5bff63edc323e9f$var$load("77dzh")
]).then(()=>parcelRequire('bcK8H'));

});

parcelRegister("ayk8s", function(module, exports) {

let $7aecb2d15af26c11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7aecb2d15af26c11$var$load("h0uBE"),
    $7aecb2d15af26c11$var$load("eBLgB"),
    $7aecb2d15af26c11$var$load("1n8w9"),
    $7aecb2d15af26c11$var$load("d0Fxy"),
    $7aecb2d15af26c11$var$load("6NHX3"),
    $7aecb2d15af26c11$var$load("77dzh")
]).then(()=>parcelRequire('kkQrM'));

});

parcelRegister("lst71", function(module, exports) {

let $f9f2cb9bca20fc7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f9f2cb9bca20fc7b$var$load("h0uBE"),
    $f9f2cb9bca20fc7b$var$load("eBLgB"),
    $f9f2cb9bca20fc7b$var$load("1n8w9"),
    $f9f2cb9bca20fc7b$var$load("d0Fxy"),
    $f9f2cb9bca20fc7b$var$load("6NHX3"),
    $f9f2cb9bca20fc7b$var$load("77dzh")
]).then(()=>parcelRequire('8P1aa'));

});

parcelRegister("jjWma", function(module, exports) {

let $e10d0f0d38b4dccc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e10d0f0d38b4dccc$var$load("h0uBE"),
    $e10d0f0d38b4dccc$var$load("eBLgB"),
    $e10d0f0d38b4dccc$var$load("1n8w9"),
    $e10d0f0d38b4dccc$var$load("d0Fxy"),
    $e10d0f0d38b4dccc$var$load("6NHX3"),
    $e10d0f0d38b4dccc$var$load("77dzh")
]).then(()=>parcelRequire('dhWIx'));

});

parcelRegister("ixOWR", function(module, exports) {

let $d802d45bf730df72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d802d45bf730df72$var$load("h0uBE"),
    $d802d45bf730df72$var$load("eBLgB"),
    $d802d45bf730df72$var$load("1n8w9"),
    $d802d45bf730df72$var$load("d0Fxy"),
    $d802d45bf730df72$var$load("6NHX3"),
    $d802d45bf730df72$var$load("77dzh")
]).then(()=>parcelRequire('iC2kp'));

});

parcelRegister("adF3X", function(module, exports) {

let $770af87d1b255554$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $770af87d1b255554$var$load("h0uBE"),
    $770af87d1b255554$var$load("eBLgB"),
    $770af87d1b255554$var$load("1n8w9"),
    $770af87d1b255554$var$load("d0Fxy"),
    $770af87d1b255554$var$load("6NHX3"),
    $770af87d1b255554$var$load("77dzh")
]).then(()=>parcelRequire('c4lcK'));

});

parcelRegister("fkaJs", function(module, exports) {

let $b2810c78ad271510$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b2810c78ad271510$var$load("h0uBE"),
    $b2810c78ad271510$var$load("eBLgB"),
    $b2810c78ad271510$var$load("1n8w9"),
    $b2810c78ad271510$var$load("d0Fxy"),
    $b2810c78ad271510$var$load("6NHX3"),
    $b2810c78ad271510$var$load("77dzh")
]).then(()=>parcelRequire('7kBAi'));

});

parcelRegister("bjCJ2", function(module, exports) {

let $83cf822418c0f288$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $83cf822418c0f288$var$load("h0uBE"),
    $83cf822418c0f288$var$load("eBLgB"),
    $83cf822418c0f288$var$load("1n8w9"),
    $83cf822418c0f288$var$load("d0Fxy"),
    $83cf822418c0f288$var$load("6NHX3"),
    $83cf822418c0f288$var$load("77dzh")
]).then(()=>parcelRequire('5RSl9'));

});

parcelRegister("cYqNL", function(module, exports) {

let $971fe0e1eeeb7a35$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $971fe0e1eeeb7a35$var$load("h0uBE"),
    $971fe0e1eeeb7a35$var$load("eBLgB"),
    $971fe0e1eeeb7a35$var$load("1n8w9"),
    $971fe0e1eeeb7a35$var$load("d0Fxy"),
    $971fe0e1eeeb7a35$var$load("6NHX3"),
    $971fe0e1eeeb7a35$var$load("77dzh")
]).then(()=>parcelRequire('fvzwM'));

});

parcelRegister("5EmqU", function(module, exports) {

let $41d216e8676d4494$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $41d216e8676d4494$var$load("h0uBE"),
    $41d216e8676d4494$var$load("eBLgB"),
    $41d216e8676d4494$var$load("1n8w9"),
    $41d216e8676d4494$var$load("d0Fxy"),
    $41d216e8676d4494$var$load("6NHX3"),
    $41d216e8676d4494$var$load("77dzh")
]).then(()=>parcelRequire('7X3BG'));

});

parcelRegister("bakss", function(module, exports) {

let $82107f65d0c74e49$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $82107f65d0c74e49$var$load("h0uBE"),
    $82107f65d0c74e49$var$load("eBLgB"),
    $82107f65d0c74e49$var$load("1n8w9"),
    $82107f65d0c74e49$var$load("d0Fxy"),
    $82107f65d0c74e49$var$load("6NHX3"),
    $82107f65d0c74e49$var$load("77dzh")
]).then(()=>parcelRequire('6aq9k'));

});

parcelRegister("fr3Bx", function(module, exports) {

let $b3cc2c66f72195b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b3cc2c66f72195b6$var$load("h0uBE"),
    $b3cc2c66f72195b6$var$load("eBLgB"),
    $b3cc2c66f72195b6$var$load("1n8w9"),
    $b3cc2c66f72195b6$var$load("d0Fxy"),
    $b3cc2c66f72195b6$var$load("6NHX3"),
    $b3cc2c66f72195b6$var$load("77dzh")
]).then(()=>parcelRequire('is8v7'));

});

parcelRegister("f4UP8", function(module, exports) {

let $afa34ec65aa11e13$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $afa34ec65aa11e13$var$load("h0uBE"),
    $afa34ec65aa11e13$var$load("eBLgB"),
    $afa34ec65aa11e13$var$load("1n8w9"),
    $afa34ec65aa11e13$var$load("d0Fxy"),
    $afa34ec65aa11e13$var$load("6NHX3"),
    $afa34ec65aa11e13$var$load("77dzh")
]).then(()=>parcelRequire('h2wZo'));

});

parcelRegister("1lk68", function(module, exports) {

let $0fa757a3cf076552$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0fa757a3cf076552$var$load("kTurq"),
    $0fa757a3cf076552$var$load("djb49"),
    $0fa757a3cf076552$var$load("fviv5"),
    $0fa757a3cf076552$var$load("d8WL7"),
    $0fa757a3cf076552$var$load("2RQvP"),
    $0fa757a3cf076552$var$load("7Lkvk")
]).then(()=>parcelRequire('3okML'));

});

parcelRegister("5wUxs", function(module, exports) {

let $406bcc4cf286935f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $406bcc4cf286935f$var$load("kTurq"),
    $406bcc4cf286935f$var$load("djb49"),
    $406bcc4cf286935f$var$load("fviv5"),
    $406bcc4cf286935f$var$load("d8WL7"),
    $406bcc4cf286935f$var$load("2RQvP"),
    $406bcc4cf286935f$var$load("7Lkvk")
]).then(()=>parcelRequire('gHFZt'));

});

parcelRegister("c9V23", function(module, exports) {

let $8da290b187c52fde$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8da290b187c52fde$var$load("kTurq"),
    $8da290b187c52fde$var$load("djb49"),
    $8da290b187c52fde$var$load("fviv5"),
    $8da290b187c52fde$var$load("d8WL7"),
    $8da290b187c52fde$var$load("2RQvP"),
    $8da290b187c52fde$var$load("7Lkvk")
]).then(()=>parcelRequire('8rFLj'));

});

parcelRegister("92AbJ", function(module, exports) {

let $69505f3359c53c31$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $69505f3359c53c31$var$load("kTurq"),
    $69505f3359c53c31$var$load("djb49"),
    $69505f3359c53c31$var$load("fviv5"),
    $69505f3359c53c31$var$load("d8WL7"),
    $69505f3359c53c31$var$load("2RQvP"),
    $69505f3359c53c31$var$load("7Lkvk")
]).then(()=>parcelRequire('asNEt'));

});

parcelRegister("eR1v2", function(module, exports) {

let $ad072dbde3fa0191$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ad072dbde3fa0191$var$load("kTurq"),
    $ad072dbde3fa0191$var$load("djb49"),
    $ad072dbde3fa0191$var$load("fviv5"),
    $ad072dbde3fa0191$var$load("d8WL7"),
    $ad072dbde3fa0191$var$load("2RQvP"),
    $ad072dbde3fa0191$var$load("7Lkvk")
]).then(()=>parcelRequire('4ykQ2'));

});

parcelRegister("7u0db", function(module, exports) {

let $572b7fc94ddd522d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $572b7fc94ddd522d$var$load("kTurq"),
    $572b7fc94ddd522d$var$load("djb49"),
    $572b7fc94ddd522d$var$load("fviv5"),
    $572b7fc94ddd522d$var$load("d8WL7"),
    $572b7fc94ddd522d$var$load("2RQvP"),
    $572b7fc94ddd522d$var$load("7Lkvk")
]).then(()=>parcelRequire('eYr6k'));

});

parcelRegister("7Fn13", function(module, exports) {

let $594e3742accd0422$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $594e3742accd0422$var$load("kTurq"),
    $594e3742accd0422$var$load("djb49"),
    $594e3742accd0422$var$load("fviv5"),
    $594e3742accd0422$var$load("d8WL7"),
    $594e3742accd0422$var$load("2RQvP"),
    $594e3742accd0422$var$load("7Lkvk")
]).then(()=>parcelRequire('kJoum'));

});

parcelRegister("ha0by", function(module, exports) {

let $c7e383a68a92aaa7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c7e383a68a92aaa7$var$load("kTurq"),
    $c7e383a68a92aaa7$var$load("djb49"),
    $c7e383a68a92aaa7$var$load("fviv5"),
    $c7e383a68a92aaa7$var$load("d8WL7"),
    $c7e383a68a92aaa7$var$load("2RQvP"),
    $c7e383a68a92aaa7$var$load("7Lkvk")
]).then(()=>parcelRequire('b4NXj'));

});

parcelRegister("kqJvS", function(module, exports) {

let $edf98a4dd3f69f67$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $edf98a4dd3f69f67$var$load("kTurq"),
    $edf98a4dd3f69f67$var$load("djb49"),
    $edf98a4dd3f69f67$var$load("fviv5"),
    $edf98a4dd3f69f67$var$load("d8WL7"),
    $edf98a4dd3f69f67$var$load("2RQvP"),
    $edf98a4dd3f69f67$var$load("7Lkvk")
]).then(()=>parcelRequire('imSKL'));

});

parcelRegister("aXGoh", function(module, exports) {

let $7fb04bf795423f5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7fb04bf795423f5f$var$load("kTurq"),
    $7fb04bf795423f5f$var$load("djb49"),
    $7fb04bf795423f5f$var$load("fviv5"),
    $7fb04bf795423f5f$var$load("d8WL7"),
    $7fb04bf795423f5f$var$load("2RQvP"),
    $7fb04bf795423f5f$var$load("7Lkvk")
]).then(()=>parcelRequire('ftHHC'));

});

parcelRegister("lwrmz", function(module, exports) {

let $fab1cfd9c70e33a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fab1cfd9c70e33a0$var$load("kTurq"),
    $fab1cfd9c70e33a0$var$load("djb49"),
    $fab1cfd9c70e33a0$var$load("fviv5"),
    $fab1cfd9c70e33a0$var$load("d8WL7"),
    $fab1cfd9c70e33a0$var$load("2RQvP"),
    $fab1cfd9c70e33a0$var$load("7Lkvk")
]).then(()=>parcelRequire('ehHfM'));

});

parcelRegister("fu6d4", function(module, exports) {

let $b45e79820c1b29b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b45e79820c1b29b3$var$load("kTurq"),
    $b45e79820c1b29b3$var$load("djb49"),
    $b45e79820c1b29b3$var$load("fviv5"),
    $b45e79820c1b29b3$var$load("d8WL7"),
    $b45e79820c1b29b3$var$load("2RQvP"),
    $b45e79820c1b29b3$var$load("7Lkvk")
]).then(()=>parcelRequire('hdAEU'));

});

parcelRegister("i6TKI", function(module, exports) {

let $d2f408cc1a0db14e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d2f408cc1a0db14e$var$load("kTurq"),
    $d2f408cc1a0db14e$var$load("djb49"),
    $d2f408cc1a0db14e$var$load("fviv5"),
    $d2f408cc1a0db14e$var$load("d8WL7"),
    $d2f408cc1a0db14e$var$load("2RQvP"),
    $d2f408cc1a0db14e$var$load("7Lkvk")
]).then(()=>parcelRequire('bEFDz'));

});

parcelRegister("l1p3M", function(module, exports) {

let $f4dd215b194e63da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f4dd215b194e63da$var$load("kTurq"),
    $f4dd215b194e63da$var$load("djb49"),
    $f4dd215b194e63da$var$load("fviv5"),
    $f4dd215b194e63da$var$load("d8WL7"),
    $f4dd215b194e63da$var$load("2RQvP"),
    $f4dd215b194e63da$var$load("7Lkvk")
]).then(()=>parcelRequire('eEEMw'));

});

parcelRegister("i9Bna", function(module, exports) {

let $d3760ead33277f24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d3760ead33277f24$var$load("kTurq"),
    $d3760ead33277f24$var$load("djb49"),
    $d3760ead33277f24$var$load("fviv5"),
    $d3760ead33277f24$var$load("d8WL7"),
    $d3760ead33277f24$var$load("2RQvP"),
    $d3760ead33277f24$var$load("7Lkvk")
]).then(()=>parcelRequire('9eCbu'));

});

parcelRegister("1BmbT", function(module, exports) {

let $12aa75cdd033f156$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $12aa75cdd033f156$var$load("kTurq"),
    $12aa75cdd033f156$var$load("djb49"),
    $12aa75cdd033f156$var$load("fviv5"),
    $12aa75cdd033f156$var$load("d8WL7"),
    $12aa75cdd033f156$var$load("2RQvP"),
    $12aa75cdd033f156$var$load("7Lkvk")
]).then(()=>parcelRequire('5b8Rf'));

});

parcelRegister("euYEG", function(module, exports) {

let $a8e2eade90445a0f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a8e2eade90445a0f$var$load("kTurq"),
    $a8e2eade90445a0f$var$load("djb49"),
    $a8e2eade90445a0f$var$load("fviv5"),
    $a8e2eade90445a0f$var$load("d8WL7"),
    $a8e2eade90445a0f$var$load("2RQvP"),
    $a8e2eade90445a0f$var$load("7Lkvk")
]).then(()=>parcelRequire('1rbp7'));

});

parcelRegister("7SiaK", function(module, exports) {

let $5bbbac32e4ac1f42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5bbbac32e4ac1f42$var$load("kTurq"),
    $5bbbac32e4ac1f42$var$load("djb49"),
    $5bbbac32e4ac1f42$var$load("fviv5"),
    $5bbbac32e4ac1f42$var$load("d8WL7"),
    $5bbbac32e4ac1f42$var$load("2RQvP"),
    $5bbbac32e4ac1f42$var$load("7Lkvk")
]).then(()=>parcelRequire('idmAf'));

});

parcelRegister("a8eEr", function(module, exports) {

let $7606043257de2a49$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7606043257de2a49$var$load("kTurq"),
    $7606043257de2a49$var$load("djb49"),
    $7606043257de2a49$var$load("fviv5"),
    $7606043257de2a49$var$load("d8WL7"),
    $7606043257de2a49$var$load("2RQvP"),
    $7606043257de2a49$var$load("7Lkvk")
]).then(()=>parcelRequire('5qYor'));

});

parcelRegister("4Eyqr", function(module, exports) {

let $36359a0830e12ea6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $36359a0830e12ea6$var$load("kTurq"),
    $36359a0830e12ea6$var$load("djb49"),
    $36359a0830e12ea6$var$load("fviv5"),
    $36359a0830e12ea6$var$load("d8WL7"),
    $36359a0830e12ea6$var$load("2RQvP"),
    $36359a0830e12ea6$var$load("7Lkvk")
]).then(()=>parcelRequire('94em7'));

});

parcelRegister("9noVS", function(module, exports) {

let $6d399a1cf22d4233$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6d399a1cf22d4233$var$load("kTurq"),
    $6d399a1cf22d4233$var$load("djb49"),
    $6d399a1cf22d4233$var$load("fviv5"),
    $6d399a1cf22d4233$var$load("d8WL7"),
    $6d399a1cf22d4233$var$load("2RQvP"),
    $6d399a1cf22d4233$var$load("7Lkvk")
]).then(()=>parcelRequire('bC5NB'));

});

parcelRegister("3Nw8M", function(module, exports) {

let $2c3ee12c71bb80dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2c3ee12c71bb80dc$var$load("kTurq"),
    $2c3ee12c71bb80dc$var$load("djb49"),
    $2c3ee12c71bb80dc$var$load("fviv5"),
    $2c3ee12c71bb80dc$var$load("d8WL7"),
    $2c3ee12c71bb80dc$var$load("2RQvP"),
    $2c3ee12c71bb80dc$var$load("7Lkvk")
]).then(()=>parcelRequire('7zXEw'));

});

parcelRegister("3gcR9", function(module, exports) {

let $25fcd6b0bc2570e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $25fcd6b0bc2570e1$var$load("kTurq"),
    $25fcd6b0bc2570e1$var$load("djb49"),
    $25fcd6b0bc2570e1$var$load("fviv5"),
    $25fcd6b0bc2570e1$var$load("d8WL7"),
    $25fcd6b0bc2570e1$var$load("2RQvP"),
    $25fcd6b0bc2570e1$var$load("7Lkvk")
]).then(()=>parcelRequire('89Dcw'));

});

parcelRegister("10VOJ", function(module, exports) {

let $0bd2a3dbbf96b6c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0bd2a3dbbf96b6c0$var$load("kTurq"),
    $0bd2a3dbbf96b6c0$var$load("djb49"),
    $0bd2a3dbbf96b6c0$var$load("fviv5"),
    $0bd2a3dbbf96b6c0$var$load("d8WL7"),
    $0bd2a3dbbf96b6c0$var$load("2RQvP"),
    $0bd2a3dbbf96b6c0$var$load("7Lkvk")
]).then(()=>parcelRequire('aFArD'));

});

parcelRegister("2bGAH", function(module, exports) {

let $197da5829d1a29d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $197da5829d1a29d8$var$load("kTurq"),
    $197da5829d1a29d8$var$load("djb49"),
    $197da5829d1a29d8$var$load("fviv5"),
    $197da5829d1a29d8$var$load("d8WL7"),
    $197da5829d1a29d8$var$load("2RQvP"),
    $197da5829d1a29d8$var$load("7Lkvk")
]).then(()=>parcelRequire('fcmBu'));

});

parcelRegister("1d6GX", function(module, exports) {

let $0e1c323053722d65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0e1c323053722d65$var$load("kTurq"),
    $0e1c323053722d65$var$load("djb49"),
    $0e1c323053722d65$var$load("fviv5"),
    $0e1c323053722d65$var$load("d8WL7"),
    $0e1c323053722d65$var$load("2RQvP"),
    $0e1c323053722d65$var$load("7Lkvk")
]).then(()=>parcelRequire('coZ2w'));

});

parcelRegister("4XFOq", function(module, exports) {

let $39cd1b29e23156d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $39cd1b29e23156d9$var$load("kTurq"),
    $39cd1b29e23156d9$var$load("djb49"),
    $39cd1b29e23156d9$var$load("fviv5"),
    $39cd1b29e23156d9$var$load("d8WL7"),
    $39cd1b29e23156d9$var$load("2RQvP"),
    $39cd1b29e23156d9$var$load("7Lkvk")
]).then(()=>parcelRequire('1dLTl'));

});

parcelRegister("eQYGM", function(module, exports) {

let $ad04ff99e6c05d32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ad04ff99e6c05d32$var$load("kTurq"),
    $ad04ff99e6c05d32$var$load("djb49"),
    $ad04ff99e6c05d32$var$load("fviv5"),
    $ad04ff99e6c05d32$var$load("d8WL7"),
    $ad04ff99e6c05d32$var$load("2RQvP"),
    $ad04ff99e6c05d32$var$load("7Lkvk")
]).then(()=>parcelRequire('hagVT'));

});

parcelRegister("HnRWw", function(module, exports) {

let $082688299011abd8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $082688299011abd8$var$load("kTurq"),
    $082688299011abd8$var$load("djb49"),
    $082688299011abd8$var$load("fviv5"),
    $082688299011abd8$var$load("d8WL7"),
    $082688299011abd8$var$load("2RQvP"),
    $082688299011abd8$var$load("7Lkvk")
]).then(()=>parcelRequire('aQ69C'));

});

parcelRegister("8zUbk", function(module, exports) {

let $63ed2c228d8c2d4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63ed2c228d8c2d4f$var$load("kTurq"),
    $63ed2c228d8c2d4f$var$load("djb49"),
    $63ed2c228d8c2d4f$var$load("fviv5"),
    $63ed2c228d8c2d4f$var$load("d8WL7"),
    $63ed2c228d8c2d4f$var$load("2RQvP"),
    $63ed2c228d8c2d4f$var$load("7Lkvk")
]).then(()=>parcelRequire('9hwIL'));

});

parcelRegister("dq42d", function(module, exports) {

let $9c50d542465a883c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9c50d542465a883c$var$load("kTurq"),
    $9c50d542465a883c$var$load("djb49"),
    $9c50d542465a883c$var$load("fviv5"),
    $9c50d542465a883c$var$load("d8WL7"),
    $9c50d542465a883c$var$load("2RQvP"),
    $9c50d542465a883c$var$load("7Lkvk")
]).then(()=>parcelRequire('809P1'));

});

parcelRegister("5Iyy7", function(module, exports) {

let $429bdc96ce17f1c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $429bdc96ce17f1c9$var$load("kTurq"),
    $429bdc96ce17f1c9$var$load("djb49"),
    $429bdc96ce17f1c9$var$load("fviv5"),
    $429bdc96ce17f1c9$var$load("d8WL7"),
    $429bdc96ce17f1c9$var$load("2RQvP"),
    $429bdc96ce17f1c9$var$load("7Lkvk")
]).then(()=>parcelRequire('iyKJG'));

});

parcelRegister("ca331", function(module, exports) {

let $8da8c868c9ec07f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8da8c868c9ec07f4$var$load("kTurq"),
    $8da8c868c9ec07f4$var$load("djb49"),
    $8da8c868c9ec07f4$var$load("fviv5"),
    $8da8c868c9ec07f4$var$load("d8WL7"),
    $8da8c868c9ec07f4$var$load("2RQvP"),
    $8da8c868c9ec07f4$var$load("7Lkvk")
]).then(()=>parcelRequire('iThhC'));

});

parcelRegister("crPcP", function(module, exports) {

let $90ffba13de4f8d25$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90ffba13de4f8d25$var$load("kTurq"),
    $90ffba13de4f8d25$var$load("djb49"),
    $90ffba13de4f8d25$var$load("fviv5"),
    $90ffba13de4f8d25$var$load("d8WL7"),
    $90ffba13de4f8d25$var$load("2RQvP"),
    $90ffba13de4f8d25$var$load("7Lkvk")
]).then(()=>parcelRequire('ffWs7'));

});

parcelRegister("5ZZn2", function(module, exports) {

let $45e2413179426cd2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $45e2413179426cd2$var$load("kTurq"),
    $45e2413179426cd2$var$load("djb49"),
    $45e2413179426cd2$var$load("fviv5"),
    $45e2413179426cd2$var$load("d8WL7"),
    $45e2413179426cd2$var$load("2RQvP"),
    $45e2413179426cd2$var$load("7Lkvk")
]).then(()=>parcelRequire('UVBHs'));

});

parcelRegister("gxG4k", function(module, exports) {

let $c0b05c66a1073790$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c0b05c66a1073790$var$load("kTurq"),
    $c0b05c66a1073790$var$load("djb49"),
    $c0b05c66a1073790$var$load("fviv5"),
    $c0b05c66a1073790$var$load("d8WL7"),
    $c0b05c66a1073790$var$load("2RQvP"),
    $c0b05c66a1073790$var$load("7Lkvk")
]).then(()=>parcelRequire('0Xemw'));

});

parcelRegister("5aA4m", function(module, exports) {

let $3c39dd86c7e2175c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3c39dd86c7e2175c$var$load("kTurq"),
    $3c39dd86c7e2175c$var$load("djb49"),
    $3c39dd86c7e2175c$var$load("fviv5"),
    $3c39dd86c7e2175c$var$load("d8WL7"),
    $3c39dd86c7e2175c$var$load("2RQvP"),
    $3c39dd86c7e2175c$var$load("7Lkvk")
]).then(()=>parcelRequire('dIfXn'));

});

parcelRegister("34nYu", function(module, exports) {

let $23c457af1ebeab15$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $23c457af1ebeab15$var$load("kTurq"),
    $23c457af1ebeab15$var$load("djb49"),
    $23c457af1ebeab15$var$load("fviv5"),
    $23c457af1ebeab15$var$load("d8WL7"),
    $23c457af1ebeab15$var$load("2RQvP"),
    $23c457af1ebeab15$var$load("7Lkvk")
]).then(()=>parcelRequire('3zmBy'));

});

parcelRegister("a9iSw", function(module, exports) {

let $7639637fa1ecb0fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7639637fa1ecb0fc$var$load("kTurq"),
    $7639637fa1ecb0fc$var$load("djb49"),
    $7639637fa1ecb0fc$var$load("fviv5"),
    $7639637fa1ecb0fc$var$load("d8WL7"),
    $7639637fa1ecb0fc$var$load("2RQvP"),
    $7639637fa1ecb0fc$var$load("7Lkvk")
]).then(()=>parcelRequire('2zbyK'));

});

parcelRegister("3m7mh", function(module, exports) {

let $2719226555ff30a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2719226555ff30a5$var$load("kTurq"),
    $2719226555ff30a5$var$load("djb49"),
    $2719226555ff30a5$var$load("fviv5"),
    $2719226555ff30a5$var$load("d8WL7"),
    $2719226555ff30a5$var$load("2RQvP"),
    $2719226555ff30a5$var$load("7Lkvk")
]).then(()=>parcelRequire('a6dja'));

});

parcelRegister("7o23c", function(module, exports) {

let $560c5d7ffd275a32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $560c5d7ffd275a32$var$load("kTurq"),
    $560c5d7ffd275a32$var$load("djb49"),
    $560c5d7ffd275a32$var$load("fviv5"),
    $560c5d7ffd275a32$var$load("d8WL7"),
    $560c5d7ffd275a32$var$load("2RQvP"),
    $560c5d7ffd275a32$var$load("7Lkvk")
]).then(()=>parcelRequire('1hZkD'));

});

parcelRegister("8uvTB", function(module, exports) {

let $62e9dde9572d3306$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $62e9dde9572d3306$var$load("kTurq"),
    $62e9dde9572d3306$var$load("djb49"),
    $62e9dde9572d3306$var$load("fviv5"),
    $62e9dde9572d3306$var$load("d8WL7"),
    $62e9dde9572d3306$var$load("2RQvP"),
    $62e9dde9572d3306$var$load("7Lkvk")
]).then(()=>parcelRequire('23Wxe'));

});

parcelRegister("9lBgB", function(module, exports) {

let $6ce2fba4d20a2cf9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6ce2fba4d20a2cf9$var$load("kTurq"),
    $6ce2fba4d20a2cf9$var$load("djb49"),
    $6ce2fba4d20a2cf9$var$load("fviv5"),
    $6ce2fba4d20a2cf9$var$load("d8WL7"),
    $6ce2fba4d20a2cf9$var$load("2RQvP"),
    $6ce2fba4d20a2cf9$var$load("7Lkvk")
]).then(()=>parcelRequire('8XK4U'));

});

parcelRegister("ashCg", function(module, exports) {

let $79ca2f1ede796682$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $79ca2f1ede796682$var$load("kTurq"),
    $79ca2f1ede796682$var$load("djb49"),
    $79ca2f1ede796682$var$load("fviv5"),
    $79ca2f1ede796682$var$load("d8WL7"),
    $79ca2f1ede796682$var$load("2RQvP"),
    $79ca2f1ede796682$var$load("7Lkvk")
]).then(()=>parcelRequire('jjtmw'));

});

parcelRegister("fdn1c", function(module, exports) {

let $b139ecdf6834c37c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b139ecdf6834c37c$var$load("kTurq"),
    $b139ecdf6834c37c$var$load("djb49"),
    $b139ecdf6834c37c$var$load("fviv5"),
    $b139ecdf6834c37c$var$load("d8WL7"),
    $b139ecdf6834c37c$var$load("2RQvP"),
    $b139ecdf6834c37c$var$load("7Lkvk")
]).then(()=>parcelRequire('7k1V6'));

});

parcelRegister("9Nrds", function(module, exports) {

let $721dcd3356c2becd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $721dcd3356c2becd$var$load("kTurq"),
    $721dcd3356c2becd$var$load("djb49"),
    $721dcd3356c2becd$var$load("fviv5"),
    $721dcd3356c2becd$var$load("d8WL7"),
    $721dcd3356c2becd$var$load("2RQvP"),
    $721dcd3356c2becd$var$load("7Lkvk")
]).then(()=>parcelRequire('9DCf3'));

});

parcelRegister("5ykbE", function(module, exports) {

let $40afc96724c5be3c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $40afc96724c5be3c$var$load("kTurq"),
    $40afc96724c5be3c$var$load("djb49"),
    $40afc96724c5be3c$var$load("fviv5"),
    $40afc96724c5be3c$var$load("d8WL7"),
    $40afc96724c5be3c$var$load("2RQvP"),
    $40afc96724c5be3c$var$load("7Lkvk")
]).then(()=>parcelRequire('8Rtfl'));

});

parcelRegister("cRwiz", function(module, exports) {

let $95d37d1664a801be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $95d37d1664a801be$var$load("kTurq"),
    $95d37d1664a801be$var$load("djb49"),
    $95d37d1664a801be$var$load("fviv5"),
    $95d37d1664a801be$var$load("d8WL7"),
    $95d37d1664a801be$var$load("2RQvP"),
    $95d37d1664a801be$var$load("7Lkvk")
]).then(()=>parcelRequire('jCuqu'));

});

parcelRegister("9xhsN", function(module, exports) {

let $6f14be03b4234adb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6f14be03b4234adb$var$load("2YffH").then(()=>parcelRequire('8zeNo'));

});

parcelRegister("01seq", function(module, exports) {

let $0045fe522909c71a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0045fe522909c71a$var$load("2YffH").then(()=>parcelRequire('l67DE'));

});

parcelRegister("jTiFB", function(module, exports) {

let $e7b1a2de186a49b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e7b1a2de186a49b3$var$load("2YffH").then(()=>parcelRequire('62Ykk'));

});

parcelRegister("1Ykrb", function(module, exports) {

let $16fb3f7dda0a8c00$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $16fb3f7dda0a8c00$var$load("2YffH").then(()=>parcelRequire('ksxpk'));

});

parcelRegister("9F414", function(module, exports) {

let $708b0ee9fd886046$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $708b0ee9fd886046$var$load("2YffH").then(()=>parcelRequire('3ku7m'));

});

parcelRegister("jclLy", function(module, exports) {

let $dfa0059905f4f87d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dfa0059905f4f87d$var$load("2YffH").then(()=>parcelRequire('1qmxj'));

});

parcelRegister("ilJbA", function(module, exports) {

let $d5bd3d245a1817ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5bd3d245a1817ff$var$load("2YffH").then(()=>parcelRequire('iaMDd'));

});

parcelRegister("aRrRe", function(module, exports) {

let $7e84769135d8ba83$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7e84769135d8ba83$var$load("2YffH").then(()=>parcelRequire('cUgAc'));

});

parcelRegister("3k2KC", function(module, exports) {

let $26b55fa495f1a092$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $26b55fa495f1a092$var$load("2YffH").then(()=>parcelRequire('jT2TW'));

});

parcelRegister("lf7GA", function(module, exports) {

let $f770f5f439e4a317$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f770f5f439e4a317$var$load("2YffH").then(()=>parcelRequire('bcxcq'));

});

parcelRegister("jMq97", function(module, exports) {

let $e666c812c8e61557$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e666c812c8e61557$var$load("2YffH").then(()=>parcelRequire('3CQDq'));

});

parcelRegister("8m6PI", function(module, exports) {

let $6155adb69c99193d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6155adb69c99193d$var$load("2YffH").then(()=>parcelRequire('cZiB3'));

});

parcelRegister("ef8wK", function(module, exports) {

let $a5e914b653dda6cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a5e914b653dda6cc$var$load("2YffH").then(()=>parcelRequire('eNRbc'));

});

parcelRegister("io22p", function(module, exports) {

let $d62c0c928efa917d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d62c0c928efa917d$var$load("2YffH").then(()=>parcelRequire('1qt4R'));

});

parcelRegister("1e3By", function(module, exports) {

let $0e49e515be82675a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e49e515be82675a$var$load("2YffH").then(()=>parcelRequire('6ygMR'));

});

parcelRegister("5twea", function(module, exports) {

let $3fc8a8e755b35ba7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3fc8a8e755b35ba7$var$load("2YffH").then(()=>parcelRequire('gbdrY'));

});

parcelRegister("jenK5", function(module, exports) {

let $e001bdd737d2d303$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e001bdd737d2d303$var$load("2YffH").then(()=>parcelRequire('8CvsG'));

});

parcelRegister("908Pr", function(module, exports) {

let $68daf652f878492a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $68daf652f878492a$var$load("2YffH").then(()=>parcelRequire('3rcDX'));

});

parcelRegister("2rukH", function(module, exports) {

let $1c75a1ddb2c4db05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c75a1ddb2c4db05$var$load("2YffH").then(()=>parcelRequire('5h8br'));

});

parcelRegister("996CT", function(module, exports) {

let $6a8a18288cdd9125$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a8a18288cdd9125$var$load("2YffH").then(()=>parcelRequire('i1Uc7'));

});

parcelRegister("eqC8j", function(module, exports) {

let $a81112d773aad884$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a81112d773aad884$var$load("2YffH").then(()=>parcelRequire('XMgVa'));

});

parcelRegister("iGLM7", function(module, exports) {

let $d9b1356069e09dc0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d9b1356069e09dc0$var$load("2YffH").then(()=>parcelRequire('iKBJy'));

});

parcelRegister("3SnQ2", function(module, exports) {

let $2d28e80c2a8b7803$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2d28e80c2a8b7803$var$load("2YffH").then(()=>parcelRequire('01KlC'));

});

parcelRegister("8tnJG", function(module, exports) {

let $62b371a139e00f42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $62b371a139e00f42$var$load("2YffH").then(()=>parcelRequire('cffA9'));

});

parcelRegister("6jcuv", function(module, exports) {

let $497e34dd1ad59dfd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $497e34dd1ad59dfd$var$load("2YffH").then(()=>parcelRequire('dxmPd'));

});

parcelRegister("kRtaI", function(module, exports) {

let $f2ff62d3690cb8f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f2ff62d3690cb8f9$var$load("2YffH").then(()=>parcelRequire('j7nH6'));

});

parcelRegister("32DbA", function(module, exports) {

let $236ff4823f5f5e99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $236ff4823f5f5e99$var$load("2YffH").then(()=>parcelRequire('eCU4b'));

});

parcelRegister("i8SNb", function(module, exports) {

let $d35379f0f07444eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d35379f0f07444eb$var$load("2YffH").then(()=>parcelRequire('2sRhj'));

});

parcelRegister("fgBr2", function(module, exports) {

let $b1d56375301a92a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1d56375301a92a4$var$load("2YffH").then(()=>parcelRequire('edQZa'));

});

parcelRegister("7nTwf", function(module, exports) {

let $5605bf4e1380eae1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5605bf4e1380eae1$var$load("2YffH").then(()=>parcelRequire('gdYwy'));

});

parcelRegister("9EXEt", function(module, exports) {

let $70861f1b2226ebc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70861f1b2226ebc8$var$load("2YffH").then(()=>parcelRequire('8wxIW'));

});

parcelRegister("8b4oS", function(module, exports) {

let $5f42c39f3c1a9f01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f42c39f3c1a9f01$var$load("2YffH").then(()=>parcelRequire('auiS6'));

});

parcelRegister("keFAg", function(module, exports) {

let $ebb55f287c195342$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ebb55f287c195342$var$load("2YffH").then(()=>parcelRequire('fcasl'));

});

parcelRegister("9gxeP", function(module, exports) {

let $6bef6411b52b6b32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6bef6411b52b6b32$var$load("2YffH").then(()=>parcelRequire('3XOfU'));

});

parcelRegister("czRCp", function(module, exports) {

let $92825875eb048337$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $92825875eb048337$var$load("2YffH").then(()=>parcelRequire('4LrFA'));

});

parcelRegister("8cXyi", function(module, exports) {

let $5f9da38b630bef1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f9da38b630bef1d$var$load("2YffH").then(()=>parcelRequire('HoRo1'));

});

parcelRegister("7ogQg", function(module, exports) {

let $5617d6c257571186$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5617d6c257571186$var$load("2YffH").then(()=>parcelRequire('3cIwE'));

});

parcelRegister("ciDVS", function(module, exports) {

let $8f462443536b09e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f462443536b09e9$var$load("2YffH").then(()=>parcelRequire('93vxT'));

});

parcelRegister("knOJh", function(module, exports) {

let $ed6d4e6d4b8e0584$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ed6d4e6d4b8e0584$var$load("2YffH").then(()=>parcelRequire('iHpDm'));

});

parcelRegister("acYBW", function(module, exports) {

let $76ea0a6e40fedbac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $76ea0a6e40fedbac$var$load("2YffH").then(()=>parcelRequire('ohVBG'));

});

parcelRegister("5ZePp", function(module, exports) {

let $45be26d87e1234df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $45be26d87e1234df$var$load("2YffH").then(()=>parcelRequire('dQQkV'));

});

parcelRegister("1Puba", function(module, exports) {

let $1551f6d3ed82f868$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1551f6d3ed82f868$var$load("2YffH").then(()=>parcelRequire('cx50L'));

});

parcelRegister("fb5VQ", function(module, exports) {

let $b0cc7c16876dbcdf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b0cc7c16876dbcdf$var$load("2YffH").then(()=>parcelRequire('0uURL'));

});

parcelRegister("lzD0e", function(module, exports) {

let $fb4b1ef7c93779db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fb4b1ef7c93779db$var$load("2YffH").then(()=>parcelRequire('aXwiX'));

});

parcelRegister("nJZRb", function(module, exports) {

let $0475d414e3afa2e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0475d414e3afa2e2$var$load("2YffH").then(()=>parcelRequire('fUefW'));

});

parcelRegister("22D0q", function(module, exports) {

let $17ca066e8375d6e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17ca066e8375d6e4$var$load("2YffH").then(()=>parcelRequire('4nNTh'));

});

parcelRegister("gc6fa", function(module, exports) {

let $bca29c331035989b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bca29c331035989b$var$load("2YffH").then(()=>parcelRequire('l3Pn8'));

});

parcelRegister("frVR3", function(module, exports) {

let $b3f641646b07ce4e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b3f641646b07ce4e$var$load("2YffH").then(()=>parcelRequire('3nUs4'));

});

parcelRegister("8PKGr", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $1822894219f78ebf$export$bf55d4f65f07791b = (fromValue)=>{
    if (!(0, $9wGTI.fg)('cc-agg-migration_client-region-steering')) window['GLOBAL_AGG_REGION_STEERING_HINT'] = null;
    else if (fromValue && window['GLOBAL_AGG_REGION_STEERING_HINT'] === undefined) window['GLOBAL_AGG_REGION_STEERING_HINT'] = fromValue;
    return window['GLOBAL_AGG_REGION_STEERING_HINT'];
};
module.exports["initializeAggRegionSteeringHint"] = $1822894219f78ebf$export$bf55d4f65f07791b;

});

parcelRegister("aXEzU", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $c6GJD = parcelRequire("c6GJD");

var $7OROP = parcelRequire("7OROP");


var $5ZqQS = parcelRequire("5ZqQS");




const $3e63b9120b40dcf7$export$1652e838423b3090 = (rawEnvironment)=>{
    let environment;
    switch(rawEnvironment){
        case 'PRODUCTION':
        case 'prod':
            environment = (0, $7OROP.FeatureGateEnvironment).Production;
            break;
        case 'STAGING':
        case 'staging':
            environment = (0, $7OROP.FeatureGateEnvironment).Staging;
            break;
        default:
            environment = (0, $7OROP.FeatureGateEnvironment).Development;
    }
    return environment;
};



var $4VJDS = parcelRequire("4VJDS");

// https://bitbucket.org/atlassian/feature-flag-service/src/a6adccc26a95818c8128c63e4eb817414793b3c2/src/main/resources/application.yml#lines-386
const $346d869f4696e20b$var$TARGET_APP = 'confluence_web';
async function $346d869f4696e20b$export$a62a6a16b93dc541({ identifiers: identifiers, environment: confluenceEnvironment, clientSdkKey: clientSdkKey, experimentValues: experimentValues, customAttributes: customAttributes, configCollectionValues: configCollectionValues }) {
    if ((0, $c6GJD.default).initializeCompleted()) return;
    const { userId: userId, tenantId: tenantId, orgId: orgId } = identifiers;
    try {
        await (0, $c6GJD.default).initializeFromValues({
            sdkKey: clientSdkKey,
            environment: (0, $3e63b9120b40dcf7$export$1652e838423b3090)(confluenceEnvironment),
            targetApp: $346d869f4696e20b$var$TARGET_APP,
            perimeter: (0, (0, $7OROP.PerimeterType).COMMERCIAL)
        }, {
            atlassianAccountId: userId || undefined,
            tenantId: tenantId,
            atlassianOrgId: orgId
        }, customAttributes, experimentValues);
        (0, $4VJDS.default).initializeFromValues(configCollectionValues || {});
    } catch (error) {
        if (error instanceof Error) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: 'statsig'
        });
    }
}











var $itW76 = parcelRequire("itW76");

const $f5bfc54e9f34af10$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $f5bfc54e9f34af10$var$PROD_BASE_URL = 'https://api.atlassian.com/flags';
const $f5bfc54e9f34af10$var$STAGING_BASE_URL = 'https://api.stg.atlassian.com/flags';
const $f5bfc54e9f34af10$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $f5bfc54e9f34af10$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $f5bfc54e9f34af10$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $f5bfc54e9f34af10$export$450bd8fb2a6d7ace = '/gateway/api/flags';
const $f5bfc54e9f34af10$export$1e164866fd37d1a9 = 'v2';
class $f5bfc54e9f34af10$export$2e2bcd8739ae039 {
    static async fetchClientSdkKey(clientVersion, fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(clientVersion, url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(clientVersion, fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest(clientVersion, `/api/${$f5bfc54e9f34af10$export$1e164866fd37d1a9}/frontend/experimentValues`, 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $itW76.ResponseError)('Non 2xx response status received', response.status, JSON.stringify(body));
        }
        if (response.status === 204) throw new (0, $itW76.ResponseError)('Unexpected 204 response', response.status, '');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter = (0, $7OROP.PerimeterType).COMMERCIAL) {
        if (useGatewayUrl) return $f5bfc54e9f34af10$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $7OROP.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $7OROP.FeatureGateEnvironment).Production:
                return $f5bfc54e9f34af10$export$18c93900db9358a4;
            case (0, $7OROP.FeatureGateEnvironment).Staging:
                return $f5bfc54e9f34af10$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $7OROP.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $7OROP.FeatureGateEnvironment).Development:
                return $f5bfc54e9f34af10$export$f058dbf75c3bc647;
            case (0, $7OROP.FeatureGateEnvironment).Staging:
                return $f5bfc54e9f34af10$var$STAGING_BASE_URL;
            default:
                return $f5bfc54e9f34af10$var$PROD_BASE_URL;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(clientVersion, path, method, fetcherOptions, body) {
        const baseUrl = $f5bfc54e9f34af10$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $f5bfc54e9f34af10$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': clientVersion,
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
}


class $4aec896bf9d29db1$export$2e2bcd8739ae039 {
    setClientVersion(clientVersion) {
        this.clientVersion = clientVersion;
    }
    async setProfile(clientOptions, identifiers, customAttributes) {
        this.clientOptions = clientOptions;
        this.identifiers = identifiers;
        this.customAttributes = customAttributes;
    }
    async getExperimentValues() {
        if (!this.clientVersion) throw new Error('Client version has not been set');
        if (!this.clientOptions || !this.identifiers) throw new Error('Profile has not been set');
        const fetcherOptions = {
            ...this.clientOptions,
            ...this.providerOptions
        };
        return await (0, $f5bfc54e9f34af10$export$2e2bcd8739ae039).fetchExperimentValues(this.clientVersion, fetcherOptions, this.identifiers, this.customAttributes).then((result)=>({
                experimentValues: result.experimentValues,
                customAttributesFromFetch: result.customAttributes,
                clientSdkKey: result.clientSdkKey
            }));
    }
    async getClientSdkKey() {
        if (!this.clientVersion) throw new Error('Client version has not been set');
        if (!this.clientOptions) throw new Error('Profile has not been set');
        const fetcherOptions = {
            ...this.clientOptions,
            ...this.providerOptions
        };
        const result = await (0, $f5bfc54e9f34af10$export$2e2bcd8739ae039).fetchClientSdkKey(this.clientVersion, fetcherOptions);
        return result.clientSdkKey;
    }
    getApiKey() {
        return this.providerOptions.apiKey;
    }
    constructor(providerOptions){
        this.providerOptions = void 0;
        this.clientVersion = void 0;
        this.clientOptions = void 0;
        this.identifiers = void 0;
        this.customAttributes = void 0;
        this.providerOptions = providerOptions;
    }
}



var $cO8uZ = parcelRequire("cO8uZ");

class $aaa29444afa37cfe$export$8489e2f039bfcc4c {
    static async fetch(options) {
        const fetch = options.fetch ?? globalThis.fetch;
        const response = await fetch(`${options.ffsBaseUrl}/api/v2/configurations`, {
            method: 'POST',
            body: JSON.stringify(options.context),
            headers: {
                'content-type': 'application/json',
                'x-api-key': options.ffsApiKey
            }
        });
        if (!response.ok) throw new Error(`Unexpected response ${response.status}: ${await response.text()}`);
        const valuesPayload = await response.text();
        return (0, $cO8uZ.ConfigCollection).fromValues(valuesPayload);
    }
}



var $lzcvT = parcelRequire("lzcvT");











function $661b7a7aeb2926fe$export$32abf1f362303a40(confluenceEnvironment) {
    // see http://go/fx3/resources/api-keys
    switch(confluenceEnvironment){
        case 'PRODUCTION':
        case 'prod':
            return (0, $lzcvT.isFedRamp)() ? 'bfa7d1a5-f85f-45ae-8dd1-ce35820db2ca' : '5f23756f-37cc-4259-8261-3e4e081559c8';
        case 'STAGING':
        case 'staging':
            return (0, $lzcvT.isFedRamp)() ? '12825e24-5928-40bf-98d8-ad76ac07060a' : '48512e86-2695-4b50-a4c5-da6bb1bcd591';
        case 'DEVELOPMENT':
        default:
            return 'f10b0994-2e84-4eb9-a02a-ac9cb34c954d';
    }
}


async function $76e51c08c669d54f$export$b39861e45618f8b7({ cloudId: cloudId, environment: environment, userId: userId }) {
    // https://bitbucket.org/atlassian/feature-flag-service/src/a6adccc26a95818c8128c63e4eb817414793b3c2/src/main/resources/application.yml#lines-386
    const TARGET_APP = 'confluence_web';
    try {
        const provider = new (0, $4aec896bf9d29db1$export$2e2bcd8739ae039)({
            apiKey: (0, $661b7a7aeb2926fe$export$32abf1f362303a40)(environment)
        });
        const [configClientInstance] = await Promise.all([
            (0, $aaa29444afa37cfe$export$8489e2f039bfcc4c).fetch({
                // Base URL of the feature-flag-service
                ffsBaseUrl: '/gateway/api/flags',
                ffsApiKey: (0, $661b7a7aeb2926fe$export$32abf1f362303a40)(environment),
                // User context to evaluate the configuration against
                context: {
                    namespace: TARGET_APP,
                    identifiers: {
                        atlassianAccountId: userId || undefined,
                        tenantId: cloudId || undefined
                    },
                    metadata: {}
                }
            }),
            (0, $c6GJD.default).initializeWithProvider({
                environment: (0, $3e63b9120b40dcf7$export$1652e838423b3090)(environment),
                targetApp: TARGET_APP,
                perimeter: (0, $lzcvT.isFedRamp)() ? (0, $7OROP.PerimeterType).FEDRAMP_MODERATE : (0, $7OROP.PerimeterType).COMMERCIAL
            }, provider, {
                atlassianAccountId: userId || undefined,
                tenantId: cloudId || undefined
            })
        ]);
        // StatsigConfigurations reads FeatureGates this must be initialized after FeatureGates
        (0, $4VJDS.default).initialize(configClientInstance);
    } catch (error) {
        if (error instanceof Error) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: 'statsig'
        });
    }
}


function $13a6a801047ad4ee$var$getMetadata(name) {
    return document.querySelector(`meta[name="${name}"]`)?.getAttribute('content') || '';
}
let $13a6a801047ad4ee$var$statsigInitialized;
const $13a6a801047ad4ee$var$statsigInitializedPromise = new Promise((resolve)=>{
    $13a6a801047ad4ee$var$statsigInitialized = resolve;
});
async function $13a6a801047ad4ee$export$4aeaeaf2287e012e() {
    return $13a6a801047ad4ee$var$statsigInitializedPromise;
}
async function $13a6a801047ad4ee$export$9b4db06b88d8ad3d() {
    let sessionData;
    if (window.__SSR_RENDERED__) {
        // When SSRed getSessionData is synchronous
        sessionData = await (0, $ge2sX.getSessionData)();
        const { userId: userId, cloudId: cloudId, orgId: orgId, environment: environment } = sessionData;
        // __STATSIG_BOOTSTRAP__ is from cc-frontend-ssr or bifrost template
        const bootstrappedOptions = window.__STATSIG_BOOTSTRAP__;
        if (bootstrappedOptions) {
            const { clientSdkKey: clientSdkKey, experimentValues: experimentValues, configCollectionValues: configCollectionValues } = bootstrappedOptions;
            // Although this function returns a promise, it is actually synchronous when experimentValues are provided
            await (0, $346d869f4696e20b$export$a62a6a16b93dc541)({
                identifiers: {
                    userId: userId,
                    tenantId: cloudId || '',
                    orgId: orgId
                },
                environment: environment,
                clientSdkKey: clientSdkKey,
                experimentValues: experimentValues,
                configCollectionValues: configCollectionValues
            });
        } else await (0, $76e51c08c669d54f$export$b39861e45618f8b7)({
            cloudId: cloudId,
            userId: userId,
            environment: environment
        });
    } else {
        const cloudId = $13a6a801047ad4ee$var$getMetadata('ajs-cloud-id');
        const userId = $13a6a801047ad4ee$var$getMetadata('ajs-atlassian-account-id');
        const environment = $13a6a801047ad4ee$var$getMetadata('ajs-environment');
        if (userId && cloudId && environment) {
            // Initialize client in parallel if we have all the metadata
            const promiseAllResult = await Promise.all([
                (0, $ge2sX.getSessionData)(),
                // No orgId in the metadata
                (0, $76e51c08c669d54f$export$b39861e45618f8b7)({
                    cloudId: cloudId,
                    userId: userId,
                    environment: environment
                })
            ]);
            sessionData = promiseAllResult[0];
        } else {
            // If we don't have all the info. Eg in standalone mode there is no environment metadata
            // Downgrade to waterfall
            sessionData = await (0, $ge2sX.getSessionData)();
            const { userId: userId, cloudId: cloudId, environment: environment } = sessionData;
            await (0, $76e51c08c669d54f$export$b39861e45618f8b7)({
                cloudId: cloudId,
                userId: userId,
                environment: environment
            });
        }
    }
    $13a6a801047ad4ee$var$statsigInitialized(true);
    return sessionData;
}
module.exports["waitUntilStatsigInitialized"] = $13a6a801047ad4ee$export$4aeaeaf2287e012e;
module.exports["getSessionDataAndInitializeStatsig"] = $13a6a801047ad4ee$export$9b4db06b88d8ad3d;

});

parcelRegister("gnYQc", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


function $f25d1cf6f831867e$var$parseParamGate(gate) {
    const [rawGateName, rawGateValue] = gate.split(':');
    // Set default gate value to true
    let gateValue = rawGateValue ?? 'true';
    // Convert string values to real boolean values.
    if (gateValue.toLowerCase() === 'true') gateValue = true;
    else if (gateValue.toLowerCase() === 'false') gateValue = false;
    return [
        rawGateName,
        gateValue
    ];
}
const $f25d1cf6f831867e$export$22dc5b768495ef8e = ()=>{
    let search;
    search = window.location.search;
    const queryParams = new URLSearchParams(search);
    if (!queryParams?.get || !queryParams.get('fg')) return null;
    const paramGates = (queryParams.get('fg') || '').split(',');
    const urlOverrides = {};
    let hasOverrides = false;
    paramGates.forEach((gate)=>{
        const [gateName, gateValue] = $f25d1cf6f831867e$var$parseParamGate(gate);
        // filter out feature gates with non-boolean values
        if (typeof gateValue === 'boolean') {
            urlOverrides[gateName] = gateValue;
            hasOverrides = true;
        }
    });
    return hasOverrides ? urlOverrides : null;
};




var $7W8i8 = parcelRequire("7W8i8");

const $55f0500be58b3896$var$STATSIG_OVERRIDES_STORAGE_KEY = (0, $1UApO.PERSISTED_KEYS_ON_SERVER)?.PERSISTED_OVERRIDES_STATSIG;
const $55f0500be58b3896$var$logger = (0, $7W8i8.getLogger)('persistedStatsigOverrides');
const $55f0500be58b3896$export$ba7d7ab1019e9971 = (overrides)=>{
    if (0, $17wUi.confluenceLocalStorageInstance) (0, $17wUi.confluenceLocalStorageInstance).setItem($55f0500be58b3896$var$STATSIG_OVERRIDES_STORAGE_KEY, overrides);
};
const $55f0500be58b3896$export$4c475fb68f50ce97 = (additionalOverrides)=>{
    let overrides;
    if (window.__SSR_RENDERED__) // When hydrate overrides are provided by server
    overrides = window?.__STATSIG_BOOTSTRAP__?.persistedStatsigOverrides;
    else // Otherwise get from persisted storage
    if (0, $17wUi.confluenceLocalStorageInstance) overrides = (0, $17wUi.confluenceLocalStorageInstance).getItem($55f0500be58b3896$var$STATSIG_OVERRIDES_STORAGE_KEY);
    let configs = overrides?.configs || {};
    let gates = overrides?.gates || {};
    let layers = overrides?.layers || {};
    // On client-side PlayWright have client only overrides
    try {
        const clientOnlyOverrides = JSON.parse(window.sessionStorage.getItem('clientOnlyOverrides') || '{}');
        if (clientOnlyOverrides) {
            configs = {
                ...configs,
                ...clientOnlyOverrides?.configs
            };
            gates = {
                ...gates,
                ...clientOnlyOverrides?.gates
            };
            layers = {
                ...layers,
                ...clientOnlyOverrides?.layers
            };
        }
    } catch  {}
    // Finally user can override with ?fg=fg1:value,fg2:value
    // Server will handle fg query and pass along in persistedStatsigOverrides
    // Here we are only handling no-SSR case
    const urlOverrideGates = (0, $f25d1cf6f831867e$export$22dc5b768495ef8e)();
    if (urlOverrideGates) gates = {
        ...gates,
        ...urlOverrideGates
    };
    if (additionalOverrides) {
        gates = {
            ...gates,
            ...additionalOverrides?.gates
        };
        configs = {
            ...configs,
            ...additionalOverrides?.configs
        };
        layers = {
            ...layers,
            ...additionalOverrides?.layers
        };
    }
    (0, $c6GJD.default).setOverrides({
        configs: configs,
        layers: layers,
        gates: gates
    });
    $55f0500be58b3896$var$logger.info`Statsig overrides applied: ${{
        configs: configs,
        layers: layers,
        gates: gates
    }}`;
};
module.exports["updatePersistedStatsigOverrides"] = $55f0500be58b3896$export$ba7d7ab1019e9971;
module.exports["applyPersistedStatsigOverrides"] = $55f0500be58b3896$export$4c475fb68f50ce97;

});

parcelRegister("2DVQX", function(module, exports) {
// This file was automatically generated and should not be edited.
const $e1e486c4f7efdb15$export$43ac22cc425ea52e = /Edge?\/(8[5-9]|9\d|\d{3,})\.\d+(\.\d+|)|Firefox\/(7[7-9]|[89]\d|\d{3,})\.\d+(\.\d+|)|Chrom(ium|e)\/(8[5-9]|9\d|\d{3,})\.\d+(\.\d+|)|(Maci|X1{2}).+ Version\/(13\.([1-9]|\d{2,})|(1[4-9]|[2-9]\d|\d{3,})\.\d+)([,.]\d+|)( \(\w+\)|)( Mobile\/\w+|) Safari\/|Chrome.+OPR\/(8[5-9]|9\d|\d{3,})\.\d+\.\d+|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(14[._]\d+|(1[5-9]|[2-9]\d|\d{3,})[._]\d+)([._]\d+|)|Android:?[ /-](129|1[3-9]\d|[2-9]\d{2}|\d{4,})(\.\d+|)(\.\d+|)|Mobile Safari.+OPR\/([89]\d|\d{3,})\.\d+\.\d+|Android.+Firefox\/(13\d|1[4-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Android.+Chrom(ium|e)\/(129|1[3-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Android.+(UC? ?Browser|UCWEB|U3)[ /]?(15\.([5-9]|\d{2,})|(1[6-9]|[2-9]\d|\d{3,})\.\d+)\.\d+|SamsungBrowser\/(2[4-9]|[3-9]\d|\d{3,})\.\d+|Android.+MQ{2}Browser\/(14(\.(9|\d{2,})|)|(1[5-9]|[2-9]\d|\d{3,})(\.\d+|))(\.\d+|)|K[Aa][Ii]OS\/(3\.\d+|([4-9]|\d{2,})\.\d+)(\.\d+|)/;


const $6da18ce9d3ba5905$export$c754a3a767dfb813 = ()=>!(0, $e1e486c4f7efdb15$export$43ac22cc425ea52e).test(navigator.userAgent);
module.exports["coreBrowserNotSupported"] = $6da18ce9d3ba5905$export$c754a3a767dfb813;

});

parcelRegister("3Tw8v", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d5f6fbfb5c3dc75$export$2e2bcd8739ae039);

var $9hOZ1 = parcelRequire("9hOZ1");


var $8aej1 = parcelRequire("8aej1");

var $2dfb7d7c6b6c1326$export$1e511d4a378977f5;
var $2dfb7d7c6b6c1326$export$2e2bcd8739ae039;
'use strict';
$2dfb7d7c6b6c1326$export$1e511d4a378977f5 = true;
function $2dfb7d7c6b6c1326$var$createThunkMiddleware(extraArgument) {
    return function(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                if (typeof action === 'function') return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
}
var $2dfb7d7c6b6c1326$var$thunk = $2dfb7d7c6b6c1326$var$createThunkMiddleware();
$2dfb7d7c6b6c1326$var$thunk.withExtraArgument = $2dfb7d7c6b6c1326$var$createThunkMiddleware;
$2dfb7d7c6b6c1326$export$2e2bcd8739ae039 = $2dfb7d7c6b6c1326$var$thunk;



var $hmRc4 = parcelRequire("hmRc4");


var $lIOgB = parcelRequire("lIOgB");


var $5cBWV = parcelRequire("5cBWV");

// should implement action lifecycle management inside redux?
// this makes me super uncomfortable
const $dd1eaf48c6b4ba66$var$calling = {};
var $dd1eaf48c6b4ba66$export$2e2bcd8739ae039 = ()=>(next)=>(action)=>{
            const callAPI = action[0, $5cBWV.CALL_API];
            if (typeof callAPI === 'undefined') return next(action);
            const { apiMethod: apiMethod, types: types, options: options, actionOptions: actionOptions } = callAPI;
            const callKey = JSON.stringify({
                types: types,
                options: options
            });
            function actionWith(data) {
                const finalAction = Object.assign({}, action, data);
                delete finalAction[0, $5cBWV.CALL_API];
                return finalAction;
            }
            const [requestType, successType, failureType] = types;
            if (callKey in $dd1eaf48c6b4ba66$var$calling) return $dd1eaf48c6b4ba66$var$calling[callKey];
            next(actionWith({
                type: requestType,
                ...options
            }));
            let promiseResolve;
            let promiseReject;
            const deferredPromise = new Promise((resolve, reject)=>{
                promiseResolve = resolve;
                promiseReject = reject;
            });
            $dd1eaf48c6b4ba66$var$calling[callKey] = deferredPromise;
            apiMethod(options, (err, response)=>{
                delete $dd1eaf48c6b4ba66$var$calling[callKey];
                if (err) {
                    const errorResponse = actionOptions && actionOptions.errorHandler && actionOptions.errorHandler(err, response, options);
                    if (!errorResponse) {
                        let errorMessage;
                        try {
                            errorMessage = JSON.parse(err.message);
                        } catch (e) {
                            if (err.message && err.message.indexOf('<!DOCTYPE html>') > -1) console.error('A rest call returned a HTML document that could not be parsed by the rest API middleware.', {
                                failureType: failureType,
                                options: options,
                                err: err,
                                response: response
                            });
                            else console.error(`Could not parse response from rest API: ${err.message}`, {
                                failureType: failureType,
                                options: options,
                                err: err,
                                response: response
                            });
                            errorMessage = err.message;
                        }
                        promiseReject(err);
                        return next(actionWith({
                            type: failureType,
                            message: errorMessage,
                            error: err,
                            options: options
                        }));
                    } else response = errorResponse;
                }
                if (actionOptions && actionOptions.schema) {
                    const normalized = (0, $lIOgB.normalize)(response, actionOptions.schema);
                    response = {
                        ...response,
                        ...normalized
                    };
                }
                promiseResolve();
                return next(actionWith({
                    type: successType,
                    response: response,
                    ...options
                }));
            });
            return deferredPromise;
        };



var $9wEpK = parcelRequire("9wEpK");





var $6g1oe = parcelRequire("6g1oe");


var $hp2SH = parcelRequire("hp2SH");

/**
 * Recursively omits a key from any javascript type.
 *
 * @param val
 * @param keyToOmit
 *
 */ const $c72c8d4ad9ba26d7$var$omitDeep = (val, keyToOmit)=>{
    const type = typeof val;
    if (type !== 'object' || val === null || val === undefined) return val;
    if (Array.isArray(val)) return val.map((arrItem)=>$c72c8d4ad9ba26d7$var$omitDeep(arrItem, keyToOmit));
    if (type === 'object') return Object.keys(val).reduce((newObj, key)=>{
        if (key !== keyToOmit) newObj[key] = $c72c8d4ad9ba26d7$var$omitDeep(val[key], keyToOmit);
        return newObj;
    }, {});
    throw new Error(`Unsupported type "${type}" confronted in omitDeep function`);
};
var $c72c8d4ad9ba26d7$export$2e2bcd8739ae039 = $c72c8d4ad9ba26d7$var$omitDeep;


const $184060ff10462130$var$applyTransformers = (store, response, variables, actionName, transformer, schema)=>{
    const actionNames = actionName instanceof Array ? actionName : [
        actionName
    ];
    for (const actionType of actionNames)try {
        const data = response.data && $184060ff10462130$var$transformGraphqlResponseToState(response.data, variables, transformer, schema);
        if (!data) return;
        store.dispatch({
            type: `${actionType}_SUCCESS`,
            response: (0, $c72c8d4ad9ba26d7$export$2e2bcd8739ae039)(data, '__typename'),
            ...variables
        });
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).console.error(error);
        store.dispatch({
            type: `${actionType}_FAILED`,
            error: error
        });
    }
};
const $184060ff10462130$var$transformGraphqlResponseToState = (data, variables, transformer, schema)=>{
    const transformed = transformer ? transformer(data, variables) : data;
    if (!transformed) return null;
    if (!schema) return transformed;
    const normalized = (0, $lIOgB.normalize)(transformed, schema);
    return {
        ...transformed,
        ...normalized
    };
};
var $184060ff10462130$export$2e2bcd8739ae039 = (store)=>(next)=>(action)=>{
            if (action.type === 'APOLLO_QUERY') {
                if (action.errorFilter && action.batch) throw new Error('errorFilter is only supported when batch=false');
                const actionNames = action.actionName instanceof Array ? action.actionName : action.actionName ? [
                    action.actionName
                ] : [];
                for (const actionName of actionNames)store.dispatch({
                    type: `${actionName}_REQUEST`,
                    ...action.variables
                });
                const gqlClientQueryOptions = {
                    query: action.query,
                    variables: action.variables,
                    context: {
                        single: !action.batch
                    }
                };
                if (action.fetchPolicy) gqlClientQueryOptions.fetchPolicy = action.fetchPolicy;
                // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
                const queryPromise = (0, $hp2SH.getApolloClient)().query(gqlClientQueryOptions);
                queryPromise.then((response)=>{
                    if (response instanceof Array) {
                        let errors = response[0].errors;
                        if (errors && action.errorsFilter) errors = action.errorsFilter(errors);
                        if (errors) throw new (0, $9wEpK.ApolloError)({
                            graphQLErrors: response[0].errors
                        });
                        return response[0];
                    }
                    return response;
                }).then((response)=>store.dispatch({
                        type: 'APOLLO_QUERY_SUCCESS',
                        response: response,
                        actionName: action.actionName,
                        transformer: action.transformer,
                        schema: action.schema,
                        variables: action.variables
                    })).catch((error)=>{
                    store.dispatch({
                        type: 'APOLLO_QUERY_FAILURE',
                        error: error,
                        actionName: action.actionName,
                        variables: action.variables
                    });
                });
                next(action);
                return queryPromise;
            } else if (action.type === 'APOLLO_QUERY_SUCCESS') {
                if (action.response.data && action.response.data.content && action.response.data.content.nodes && !action.response.data.content.nodes.length) {
                    if (action.actionName === 'EDITOR_CONTENT_V2') return store.dispatch({
                        type: `${action.actionName}_FAILURE`,
                        error: {
                            statusCode: 404
                        },
                        options: action.variables
                    });
                    // TODO: this should be removed in favour of generic failure action above
                    return store.dispatch({
                        type: 'CONTENT_FAILURE',
                        error: {
                            statusCode: 404
                        }
                    });
                } else $184060ff10462130$var$applyTransformers(store, action.response, action.variables, action.actionName, action.transformer, action.schema);
            } else if (action.type === 'APOLLO_QUERY_FAILURE') {
                let error = action.error?.graphQLErrors?.length ? action.error?.graphQLErrors[0] : action.error;
                if (error?.response?.status) error = {
                    ...error,
                    statusCode: error.response.status
                };
                const message = error ? error.message : action.error.message;
                const actionNames = action.actionName instanceof Array ? action.actionName : [
                    action.actionName
                ];
                for (const actionName of actionNames)store.dispatch({
                    type: `${actionName}_FAILURE`,
                    error: error,
                    message: message,
                    options: action.variables
                });
            }
            return next(action);
        };


// eslint-disable-next-line check-cross-package-imports/dont-import-redux-in-next

var $3P3UD = parcelRequire("3P3UD");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $04e9M = parcelRequire("04e9M");

const $1a38fd4db987f5e5$var$trackAnalyticEvents = (store)=>(next)=>(action)=>{
            const state = store.getState();
            const { error: error } = action;
            switch(action.type){
                case 'EDITOR_CONTENT_PUBLISH_SUCCESS':
                case 'EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH_SUCCESS':
                    $1a38fd4db987f5e5$var$triggerAnalyticsForPage(action, state);
                    (0, $fGzMp.getExperienceTracker)().succeed({
                        name: (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE)
                    });
                    break;
                case 'EDITOR_CONTENT_PUBLISH_FAILURE':
                case 'EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH_FAILURE':
                    const statusCode = error?.statusCode || 0;
                    // does not let ExperienceTracker track user errors
                    if (statusCode === 0 || statusCode >= 500 && statusCode <= 599) // User (e.g. 0 status code) or non-user (e.g. 5xx status code) error.
                    // Abort or fail, respectively, the experience.
                    (0, $fGzMp.stopExperienceOnError)((0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE), error);
                    else if (statusCode >= 400 && statusCode <= 499) // User error. Don't fail the experience which includes don't let the
                    // experience time out so abort the experience.
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE),
                        reason: error?.message || action?.message?.message,
                        checkForTimeout: false
                    });
                    break;
            }
            return next(action);
        };
const $1a38fd4db987f5e5$var$callAnalyticsEvent = (analyticsObj)=>{
    (0, $04e9M.getAnalyticsWebClient)().then((analyticWebClientResponse)=>{
        analyticWebClientResponse.sendTrackEvent(analyticsObj);
    });
};
const $1a38fd4db987f5e5$var$triggerAnalyticsForPage = (action, state)=>{
    let spaceId;
    let spaceType;
    let homepageId;
    const { id: id, type: type, version: version } = action.response;
    try {
        const spaceKey = state.router.params.spaceKey;
        const space = (0, $3P3UD.getSpaceInfoSelector)(state, spaceKey);
        spaceId = space.id;
        spaceType = space.type;
        homepageId = space.homepageId;
    } catch (e) {}
    const analyticsObject = {
        containerType: 'space',
        containerId: spaceId,
        source: 'editPageScreen',
        objectType: 'page',
        objectId: id,
        action: version?.number === 1 ? 'created' : 'updated',
        actionSubject: 'page',
        actionSubjectId: id,
        attributes: {
            pageType: type,
            spaceType: spaceType,
            versionNum: version?.number,
            createExperience: null,
            isOverviewPage: homepageId === id
        }
    };
    analyticsObject.attributes.createExperience = 'createPageModal';
    $1a38fd4db987f5e5$var$callAnalyticsEvent(analyticsObject);
};
var $1a38fd4db987f5e5$export$2e2bcd8739ae039 = $1a38fd4db987f5e5$var$trackAnalyticEvents;






var $64Cib = parcelRequire("64Cib");




var $4516f26c30387249$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["HANDLE_PUBLISH_EVENT"] = "HANDLE_PUBLISH_EVENT";
    ActionTypes["HANDLE_VERSION_UPDATE"] = "HANDLE_VERSION_UPDATE";
    ActionTypes["SYNCHRONY_UPDATE_STATUS"] = "SYNCHRONY_UPDATE_STATUS";
    ActionTypes["CONNECTION_OFFLINE"] = "CONNECTION_OFFLINE";
    ActionTypes["CONNECTION_ONLINE"] = "CONNECTION_ONLINE";
    ActionTypes["INIT_COLLAB_PROVIDER_FAILURE"] = "INIT_COLLAB_PROVIDER_FAILURE";
    ActionTypes["INIT_COLLAB_PROVIDER_SUCCESS"] = "INIT_COLLAB_PROVIDER_SUCCESS";
    ActionTypes["INIT_COLLAB_PROVIDER_REQUEST"] = "INIT_COLLAB_PROVIDER_REQUEST";
    ActionTypes["RESET_COLLAB_PROVIDER"] = "RESET_COLLAB_PROVIDER";
    return ActionTypes;
}({});


var $4baa5f8073ff2654$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["RESET_EDITOR_STATE"] = "RESET_EDITOR_STATE";
    return ActionTypes;
}({});


const $17444e379c4f4dcc$export$49d5fc8cba920a0 = {
    // default value is null to indicate a value of first page loading
    status: null,
    synchronyConfigMap: {},
    contentReconciliationStatus: {
        isRequesting: false
    },
    synchronyProviderMap: {}
};
function $17444e379c4f4dcc$export$25d14d759b7df9bc(synchronyAppId, contentId) {
    return synchronyAppId === null || contentId === null ? null : `/${synchronyAppId}/confluence-adf-${contentId}`;
}
function $17444e379c4f4dcc$export$2e2bcd8739ae039(state = $17444e379c4f4dcc$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case (0, $4516f26c30387249$export$1385d81a6c6bbcd4).CONNECTION_OFFLINE:
            return {
                ...state,
                status: 'disconnected'
            };
        case (0, $4516f26c30387249$export$1385d81a6c6bbcd4).CONNECTION_ONLINE:
            return {
                ...state,
                status: 'connected'
            };
        case (0, $4516f26c30387249$export$1385d81a6c6bbcd4).SYNCHRONY_UPDATE_STATUS:
            return {
                ...state,
                status: action.status
            };
        case (0, $4baa5f8073ff2654$export$1385d81a6c6bbcd4).RESET_EDITOR_STATE:
            return {
                ...$17444e379c4f4dcc$export$49d5fc8cba920a0,
                synchronyConfigMap: state.synchronyConfigMap
            };
        case (0, $4516f26c30387249$export$1385d81a6c6bbcd4).INIT_COLLAB_PROVIDER_REQUEST:
            return {
                ...state,
                synchronyProviderMap: {
                    ...state.synchronyProviderMap,
                    [action.contentId]: {
                        ...state.synchronyProviderMap[action.contentId],
                        isInitializingProvider: true,
                        preInitSucceeded: false
                    }
                }
            };
        case (0, $4516f26c30387249$export$1385d81a6c6bbcd4).INIT_COLLAB_PROVIDER_FAILURE:
            return {
                ...state,
                synchronyProviderMap: {
                    ...state.synchronyProviderMap,
                    [action.contentId]: {
                        provider: null,
                        isInitializingProvider: false,
                        preInitSucceeded: false
                    }
                }
            };
        case (0, $4516f26c30387249$export$1385d81a6c6bbcd4).INIT_COLLAB_PROVIDER_SUCCESS:
            return {
                ...state,
                synchronyProviderMap: {
                    ...state.synchronyProviderMap,
                    [action.contentId]: {
                        provider: action.provider,
                        isInitializingProvider: false,
                        preInitSucceeded: action.preInitSucceeded
                    }
                }
            };
        case (0, $4516f26c30387249$export$1385d81a6c6bbcd4).RESET_COLLAB_PROVIDER:
            delete state.synchronyProviderMap[action.contentId];
            return {
                ...state
            };
        default:
            return state;
    }
}









var $1d2ww = parcelRequire("1d2ww");


var $8VcPj = parcelRequire("8VcPj");




const $e94ecf4f7002a765$export$51a8fff1191e00 = 'EDITOR_CONTENT_PREVIEW';
const $e94ecf4f7002a765$export$9ae8757b668977b9 = 'CHANGE_EDITOR_MODE';
var $e94ecf4f7002a765$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["CHANGE_EDITOR_TITLE"] = "CHANGE_EDITOR_TITLE";
    ActionTypes["CLOSE_EDITOR_ERROR"] = "CLOSE_EDITOR_ERROR";
    ActionTypes["SHOW_EDITOR_ERROR"] = "SHOW_EDITOR_ERROR";
    ActionTypes["EDITOR_CONTENT_V2_REQUEST"] = "EDITOR_CONTENT_V2_REQUEST";
    ActionTypes["EDITOR_CONTENT_V2_SUCCESS"] = "EDITOR_CONTENT_V2_SUCCESS";
    ActionTypes["EDITOR_CONTENT_V2_FAILURE"] = "EDITOR_CONTENT_V2_FAILURE";
    ActionTypes["EDITOR_CONTENT_PUBLISH_REQUEST"] = "EDITOR_CONTENT_PUBLISH_REQUEST";
    ActionTypes["EDITOR_CONTENT_PUBLISH_SUCCESS"] = "EDITOR_CONTENT_PUBLISH_SUCCESS";
    ActionTypes["EDITOR_CONTENT_PUBLISH_FAILURE"] = "EDITOR_CONTENT_PUBLISH_FAILURE";
    ActionTypes["EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH_SUCCESS"] = "EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH_SUCCESS";
    ActionTypes["EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH_FAILURE"] = "EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH_FAILURE";
    ActionTypes["EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_REQUEST"] = "EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_REQUEST";
    ActionTypes["EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_SUCCESS"] = "EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_SUCCESS";
    ActionTypes["EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_FAILURE"] = "EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_FAILURE";
    ActionTypes["EDITOR_CONTENT_PREVIEW"] = "EDITOR_CONTENT_PREVIEW";
    ActionTypes["EDITOR_CONTENT_PREVIEW_REQUEST"] = "EDITOR_CONTENT_PREVIEW_REQUEST";
    ActionTypes["EDITOR_CONTENT_PREVIEW_SUCCESS"] = "EDITOR_CONTENT_PREVIEW_SUCCESS";
    ActionTypes["EDITOR_CONTENT_PREVIEW_FAILURE"] = "EDITOR_CONTENT_PREVIEW_FAILURE";
    ActionTypes["EDITOR_DRAFT_SAVE_SUCCESS"] = "EDITOR_DRAFT_SAVE_SUCCESS";
    ActionTypes["SET_IS_PUBLISHING_CONTENT"] = "SET_IS_PUBLISHING_CONTENT";
    ActionTypes["UPDATE_CONTENT_SPACE_KEY"] = "UPDATE_CONTENT_SPACE_KEY";
    ActionTypes["CHANGE_EDITOR_MODE"] = "CHANGE_EDITOR_MODE";
    ActionTypes["CONTENT_SUCCESS"] = "CONTENT_SUCCESS";
    ActionTypes["HANDLE_PUBLISH_EVENT"] = "HANDLE_PUBLISH_EVENT";
    ActionTypes["FEATURE_DISCOVERED_MARK_SUCCESS"] = "FEATURE_DISCOVERED_MARK_SUCCESS";
    ActionTypes["EDITOR_SHOW_SCHEDULED_PUBLISH_DIALOG"] = "EDITOR_SHOW_SCHEDULED_PUBLISH_DIALOG";
    ActionTypes["EDITOR_HIDE_SCHEDULED_PUBLISH_COMPONENT"] = "EDITOR_HIDE_SCHEDULED_PUBLISH_COMPONENT";
    ActionTypes["EDITOR_CURRENTLY_SCHEDULED_PUBLISH_DATE"] = "EDITOR_CURRENTLY_SCHEDULED_PUBLISH_DATE";
    ActionTypes["EDITOR_CANCEL_SCHEDULED_PUBLISH"] = "EDITOR_CANCEL_SCHEDULED_PUBLISH";
    ActionTypes["SET_IS_SCHEDULING_PUBLISH"] = "SET_IS_SCHEDULING_PUBLISH";
    return ActionTypes;
}({});
var $e94ecf4f7002a765$export$c5c68a3d26246634 = /*#__PURE__*/ function(ContentTypeType) {
    ContentTypeType["PAGE"] = "page";
    ContentTypeType["BLOGPOST"] = "blogpost";
    return ContentTypeType;
}({});




var $bx6Tx = parcelRequire("bx6Tx");

const $b2219e7f428639b5$export$c6813a8d51f77eaf = 200;
const $b2219e7f428639b5$export$8bca792d963eb0ef = 404;
const $b2219e7f428639b5$export$8c5e74eae7b64cc2 = 412;
const $b2219e7f428639b5$export$e813cd7045fcc98d = 500;
const $b2219e7f428639b5$export$5ed7505d2b52f8b1 = 503;


// TODO: Move these back when typing the synchrony state
// import {
//   HANDLE_PUBLISH_EVENT,
// } from "../../support/synchrony-support/action-types";
const $31c2a1429cbabe2b$var$noError = {
    errorData: $31c2a1429cbabe2b$var$_getErrorData(null),
    statusCode: null
};
function $31c2a1429cbabe2b$var$_getErrorData(error) {
    if (error === null) return {};
    const errorMap = {};
    if (error.data && error.data.errors) error.data.errors.forEach((error)=>{
        errorMap[error.message.key] = error.details || true;
    });
    return {
        [error.message]: error.details || true,
        ...errorMap
    };
}
const $31c2a1429cbabe2b$export$49d5fc8cba920a0 = {
    hasRequestedEditorContent: false,
    contentId: undefined,
    editorContent: null,
    title: null,
    hasRefreshedPage: false,
    contentType: null,
    editorMode: (0, $bx6Tx.EDITOR_NAV_DESTINATION).NONE,
    isUnpublishedDraft: null,
    isPublishingContent: false,
    syncRev: null,
    confRev: null,
    lastPublisher: null,
    publishedEditorContent: null,
    isADFContentInvalid: false,
    publishedTitle: '',
    contentSpaceKey: '',
    fetchReconciledEditorContentFinished: false,
    fetchReconciledEditorContentFailure: false,
    fetchReconciledEditorContentRequest: false,
    nextTryIn: null,
    contentAppearanceDraft: {
        appearance: (0, $1d2ww.ContentAppearanceType).DEFAULT,
        version: -1
    },
    contentAppearancePublished: {
        appearance: (0, $1d2ww.ContentAppearanceType).DEFAULT,
        version: -1
    },
    contentAppearanceLoading: false,
    showErrorOnUpdateContentAppearanceDraftConflict: false,
    showErrorOnUpdateContentAppearancePublishedConflict: false,
    shouldShowScheduledPublishDialog: false,
    shouldShowScheduledPublishModal: false,
    currentlyScheduledPublishDate: null,
    isSchedulingPublish: false,
    ...$31c2a1429cbabe2b$var$noError
};
function $31c2a1429cbabe2b$export$2e2bcd8739ae039(state = $31c2a1429cbabe2b$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_REQUEST:
            if (state.contentId !== action.contentId) return state;
            // updating the published and draft content appearance is the same except for the key. so this reducer handles both.
            // defining new state here is important for getting type safety on conditional key name
            // also does this for EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_SUCCESS
            const updatedAppearanceState = {
                ...state,
                contentAppearanceLoading: true
            };
            if (action.propertyKey === (0, $1d2ww.ContentAppearancePropertyKey).PUBLISHED) updatedAppearanceState.contentAppearancePublished = {
                ...updatedAppearanceState.contentAppearancePublished,
                appearance: action.propertyValue
            };
            else updatedAppearanceState.contentAppearanceDraft = {
                ...updatedAppearanceState.contentAppearanceDraft,
                appearance: action.propertyValue
            };
            return updatedAppearanceState;
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_SUCCESS:
            if (state.contentId !== action.contentId) return state;
            const contentAppearance = {
                appearance: action.response.value,
                version: action.response.version.number
            };
            const updatedState = {
                ...state,
                contentAppearanceLoading: false
            };
            if (action.response.key === (0, $1d2ww.ContentAppearancePropertyKey).PUBLISHED) {
                updatedState.contentAppearancePublished = contentAppearance;
                updatedState.showErrorOnUpdateContentAppearancePublishedConflict = false;
            } else {
                updatedState.contentAppearanceDraft = contentAppearance;
                updatedState.showErrorOnUpdateContentAppearanceDraftConflict = false;
            }
            return updatedState;
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY_FAILURE:
            if (state.contentId !== action.options.contentId) return state;
            if (action.error?.statusCode === 409) {
                if (action.options.propertyKey === (0, $1d2ww.ContentAppearancePropertyKey).DRAFT) {
                    if (!state.showErrorOnUpdateContentAppearanceDraftConflict) return {
                        ...state,
                        contentAppearanceLoading: false,
                        showErrorOnUpdateContentAppearanceDraftConflict: true
                    };
                } else {
                    if (!state.showErrorOnUpdateContentAppearancePublishedConflict) return {
                        ...state,
                        contentAppearanceLoading: false,
                        showErrorOnUpdateContentAppearancePublishedConflict: true
                    };
                }
            }
            return {
                ...state,
                contentAppearanceLoading: false,
                statusCode: action.error && action.error.statusCode,
                errorData: $31c2a1429cbabe2b$var$_getErrorData(action.message)
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).CHANGE_EDITOR_MODE:
            return {
                ...state,
                editorMode: action.mode
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).CHANGE_EDITOR_TITLE:
            return {
                ...state,
                title: action.title
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).EDITOR_CONTENT_V2_REQUEST:
            if (state.contentId !== action.contentId) return {
                ...state,
                contentId: action.contentId,
                editorContent: null,
                publishedEditorContent: null,
                isADFContentInvalid: false,
                hasRequestedEditorContent: false,
                fetchReconciledEditorContentRequest: true,
                ...$31c2a1429cbabe2b$var$noError
            };
            else // This typically happens if we need to perform a second request to obtain published content
            // like after content reconciliation asks the confluence backend to perform a recovery.
            // When that happens, we should not wipe out the existing content and state.
            return {
                ...state,
                hasRequestedEditorContent: false
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).EDITOR_CONTENT_V2_SUCCESS:
            if (state.contentId !== action.contentId) return state;
            const document = action.response.editorContent[action.docFormat];
            const { isADFContentInvalid: isADFContentInvalid = false, value: publishedEditorContent } = document;
            const publishedTitle = action.response.title || '';
            const contentAppearanceDraft = (0, $8VcPj.getContentAppearanceFromContentProperties)(action.response.appearanceDraft, (0, $1d2ww.ContentAppearancePropertyKey).DRAFT);
            const contentAppearancePublished = (0, $8VcPj.getContentAppearanceFromContentProperties)(action.response.appearancePublished, (0, $1d2ww.ContentAppearancePropertyKey).PUBLISHED);
            const schedulePublishDate = action.response.schedulePublishDate;
            const currentlyScheduledPublishDate = schedulePublishDate ? new Date(schedulePublishDate) : null;
            return {
                ...state,
                publishedEditorContent: publishedEditorContent,
                publishedTitle: publishedTitle,
                contentSpaceKey: action?.response?.space?.key || '',
                statusCode: (0, $b2219e7f428639b5$export$c6813a8d51f77eaf),
                hasRequestedEditorContent: true,
                errorData: $31c2a1429cbabe2b$var$_getErrorData(null),
                contentType: action.response.type,
                isUnpublishedDraft: action.response.isUnpublishedDraft,
                isADFContentInvalid: isADFContentInvalid,
                contentAppearanceDraft: contentAppearanceDraft,
                contentAppearancePublished: contentAppearancePublished,
                currentlyScheduledPublishDate: currentlyScheduledPublishDate
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).EDITOR_CONTENT_V2_FAILURE:
            if (state.contentId !== action.options.contentId) return state;
            return {
                ...state,
                statusCode: action.error && action.error.statusCode,
                errorData: $31c2a1429cbabe2b$var$_getErrorData(action.message || null),
                hasRequestedEditorContent: true,
                // In case of editor failure the reconciliation request thunk chain will be terminated before it get's
                // to a promise catch part, so we need to flag that content reconciliation has ended
                fetchReconciledEditorContentFinished: true,
                fetchReconciledEditorContentFailure: true,
                fetchReconciledEditorContentRequest: false
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).UPDATE_CONTENT_SPACE_KEY:
            return {
                ...state,
                contentSpaceKey: action.spaceKey
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).SET_IS_PUBLISHING_CONTENT:
            return {
                ...state,
                isPublishingContent: action.isPublishingContent
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).SET_IS_SCHEDULING_PUBLISH:
            return {
                ...state,
                isSchedulingPublish: action.isSchedulingPublish
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).EDITOR_CONTENT_PUBLISH_REQUEST:
            return {
                ...state,
                isPublishingContent: !action.content.schedulePublishDate
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).EDITOR_CONTENT_PUBLISH_FAILURE:
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH_FAILURE:
            const contentId = action?.options?.content?.id;
            // contentId is undefined for new templates
            if (contentId && contentId.toString() !== state.contentId) return state;
            if (action.options.migratedRecently) (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.MIGRATE_PAGE_PUBLISH_EXPERIENCE),
                error: new Error(JSON.stringify($31c2a1429cbabe2b$var$_getErrorData(action.message || null)))
            });
            // Don't show an error message if we are going to retry
            if (action.options && action.options.retryOnConflict && action.error && action.error.statusCode === 409) return state;
            return {
                ...state,
                isPublishingContent: false,
                isSchedulingPublish: false,
                statusCode: action.error && action.error.statusCode,
                errorData: $31c2a1429cbabe2b$var$_getErrorData(action.message)
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).EDITOR_CONTENT_PUBLISH_SUCCESS:
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH_SUCCESS:
            if (action.migratedRecently) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.MIGRATE_PAGE_PUBLISH_EXPERIENCE)
            });
            return {
                ...state,
                isUnpublishedDraft: action.content.schedulePublishDate ? state.isUnpublishedDraft : false,
                isPublishingContent: false,
                isSchedulingPublish: false,
                editorMode: action.editorMode
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).CLOSE_EDITOR_ERROR:
            return {
                ...state,
                ...$31c2a1429cbabe2b$var$noError
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).SHOW_EDITOR_ERROR:
            return {
                ...state,
                statusCode: action.statusCode || null,
                errorData: action.errorData
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).EDITOR_CONTENT_PREVIEW_FAILURE:
            return {
                ...state,
                statusCode: action.error && action.error.statusCode,
                errorData: $31c2a1429cbabe2b$var$_getErrorData(action.message)
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).HANDLE_PUBLISH_EVENT:
            if (state.contentId !== action.contentId) return state;
            return {
                ...state,
                statusCode: null,
                errorData: $31c2a1429cbabe2b$var$_getErrorData({
                    message: 'other-publish'
                }),
                isUnpublishedDraft: false,
                lastPublisher: action.lastPublisher
            };
        case (0, $4baa5f8073ff2654$export$1385d81a6c6bbcd4).RESET_EDITOR_STATE:
            return $31c2a1429cbabe2b$export$49d5fc8cba920a0;
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).EDITOR_SHOW_SCHEDULED_PUBLISH_DIALOG:
            return {
                ...state,
                ...action.context === 'modal' ? {
                    shouldShowScheduledPublishModal: true
                } : {
                    shouldShowScheduledPublishDialog: true
                }
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).EDITOR_HIDE_SCHEDULED_PUBLISH_COMPONENT:
            return {
                ...state,
                shouldShowScheduledPublishDialog: false,
                shouldShowScheduledPublishModal: false
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).EDITOR_CURRENTLY_SCHEDULED_PUBLISH_DATE:
            return {
                ...state,
                currentlyScheduledPublishDate: action.currentlyScheduledPublishDate
            };
        case (0, $e94ecf4f7002a765$export$1385d81a6c6bbcd4).EDITOR_CANCEL_SCHEDULED_PUBLISH:
            return {
                ...state,
                currentlyScheduledPublishDate: null
            };
        default:
            return state;
    }
}



var $btz1y = parcelRequire("btz1y");

const $eecbe12cc5f62c7c$var$previewerInitialState = {
    currentMediaItem: null,
    isOpen: false
};
const $eecbe12cc5f62c7c$export$126a5094a834342d = (state = $eecbe12cc5f62c7c$var$previewerInitialState, action)=>{
    switch(action.type){
        case 0, $btz1y.OPEN_PREVIEWER:
            return Object.assign({}, state, {
                currentMediaItem: action.item.id,
                isOpen: true
            });
        case 0, $btz1y.CLOSE_PREVIEWER:
            return $eecbe12cc5f62c7c$var$previewerInitialState;
    }
    return state;
};


var $d5433d48db1ede97$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["EDITOR_DRAFT_SAVE_REQUEST"] = "EDITOR_DRAFT_SAVE_REQUEST";
    ActionTypes["EDITOR_DRAFT_SAVE_SUCCESS"] = "EDITOR_DRAFT_SAVE_SUCCESS";
    ActionTypes["EDITOR_DRAFT_SAVE_FAILURE"] = "EDITOR_DRAFT_SAVE_FAILURE";
    ActionTypes["SET_SAVE_DRAFT"] = "SET_SAVE_DRAFT";
    return ActionTypes;
}({});



const $db94512ebab9c421$export$49d5fc8cba920a0 = {
    isSaving: false,
    isError: false,
    errorCode: null
};
function $db94512ebab9c421$export$2e2bcd8739ae039(state = $db94512ebab9c421$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case (0, $d5433d48db1ede97$export$1385d81a6c6bbcd4).EDITOR_DRAFT_SAVE_REQUEST:
            return {
                isSaving: true,
                isError: false,
                errorCode: null
            };
        case (0, $d5433d48db1ede97$export$1385d81a6c6bbcd4).EDITOR_DRAFT_SAVE_FAILURE:
            return {
                isSaving: false,
                isError: true,
                errorCode: action.message && action.message.statusCode
            };
        case (0, $d5433d48db1ede97$export$1385d81a6c6bbcd4).EDITOR_DRAFT_SAVE_SUCCESS:
            return {
                isSaving: false,
                isError: false,
                errorCode: null
            };
        case (0, $d5433d48db1ede97$export$1385d81a6c6bbcd4).SET_SAVE_DRAFT:
            return {
                isSaving: action.isSaving === undefined ? false : action.isSaving,
                isError: false,
                errorCode: null
            };
        case (0, $4baa5f8073ff2654$export$1385d81a6c6bbcd4).RESET_EDITOR_STATE:
            return $db94512ebab9c421$export$49d5fc8cba920a0;
        default:
            return state;
    }
}


var $79b7be3fcb035b95$export$2e2bcd8739ae039 = (0, $9hOZ1.combineReducers)({
    editorContentV2: $31c2a1429cbabe2b$export$2e2bcd8739ae039,
    mediaPreviewer: $eecbe12cc5f62c7c$export$126a5094a834342d,
    draft: $db94512ebab9c421$export$2e2bcd8739ae039
});


var $dfdf14fbf1783baa$export$2e2bcd8739ae039 = (0, $9hOZ1.combineReducers)({
    synchrony: $17444e379c4f4dcc$export$2e2bcd8739ae039,
    views: $79b7be3fcb035b95$export$2e2bcd8739ae039
});



var $eH0qm = parcelRequire("eH0qm");








var $cb6fO = parcelRequire("cb6fO");

const $29a2cc98ace825c0$var$UserContext = (0, $64Cib.Record)({
    isFavourite: null,
    favouritedDate: null,
    lastSeen: null,
    lastModified: null,
    contentStatus: null
});
const $29a2cc98ace825c0$var$Link = (0, $64Cib.Record)({
    editui: null,
    webui: null,
    webuiIsSpa: null,
    viewChangesLink: null
});
const $29a2cc98ace825c0$var$CardCount = (0, $64Cib.Record)({
    cssClass: null,
    iconType: null,
    count: 0
});
const $29a2cc98ace825c0$var$Body = (0, $64Cib.Record)({
    html: null,
    editorHtml: null,
    cssTags: '',
    jsUris: (0, $64Cib.List)([])
});
class $29a2cc98ace825c0$export$2e2bcd8739ae039 extends (0, $64Cib.Record)({
    id: null,
    type: null,
    iconType: null,
    kind: null,
    title: null,
    slug: null,
    links: null,
    version: null,
    summary: null,
    iconCssClass: null,
    iconPath: null,
    createdBy: null,
    createdDate: null,
    friendlyDate: null,
    contentCssClass: null,
    userContext: null,
    numberOfLikes: null,
    numberOfComments: null,
    willbedeleted: null,
    cardCounts: (0, $64Cib.fromJS)([]),
    contributors: (0, $64Cib.List)([]),
    hasChildren: null,
    childNodes: (0, $64Cib.List)([]),
    body: null,
    position: null,
    webItems: (0, $64Cib.Set)([]),
    ancestors: (0, $64Cib.OrderedSet)([]),
    currentUserPermissions: (0, $64Cib.Set)([]),
    labels: (0, $64Cib.Set)([]),
    spaceKey: null,
    // `isUnauthorized` is set to be `true` explicitly in a content reducer.
    // `isUnauthorized` can not be `false`
    // because while merging old and new content entities in `entityReducerCommon,
    // we don't want the new content entity can override `isUnauthorized` prop and make it from `true` to `false`.
    isUnauthorized: null,
    hasInheritedRestrictions: null,
    lastFetchTime: null,
    viewers: (0, $64Cib.List)([]),
    editorVersion: null
}) {
    constructor(recordData){
        super(recordData);
        return this.withMutations((contentData)=>{
            if (recordData.links) contentData.set('links', new $29a2cc98ace825c0$var$Link(recordData.links));
            if (recordData.userContext) contentData.set('userContext', new $29a2cc98ace825c0$var$UserContext(recordData.userContext));
            if (recordData.cardCounts) contentData.set('cardCounts', (0, $64Cib.fromJS)(recordData.cardCounts, (key, val)=>{
                const isIndexed = (0, $64Cib.Iterable).isIndexed(val);
                return isIndexed ? val.toList() : new $29a2cc98ace825c0$var$CardCount(val);
            }));
            if (recordData.viewers) contentData.set('viewers', (0, $64Cib.List)(recordData.viewers));
            if (recordData.childNodes) contentData.set('childNodes', (0, $64Cib.List)(recordData.childNodes));
            if (recordData.contributors) contentData.set('contributors', (0, $64Cib.List)(recordData.contributors));
            if (recordData.body) contentData.set('body', new $29a2cc98ace825c0$var$Body(recordData.body));
            if (recordData.ancestors) contentData.set('ancestors', (0, $64Cib.OrderedSet)(recordData.ancestors));
            if (recordData.currentUserPermissions) contentData.set('currentUserPermissions', (0, $64Cib.Set)(recordData.currentUserPermissions));
            if (recordData.title) contentData.set('slug', (0, $cb6fO.generateSlug)(recordData.title));
            if (recordData.labels) contentData.set('labels', (0, $64Cib.Set)(recordData.labels));
            // schema of content entity `schemas/entities.js` has a `space` prop.
            // Before normalizr, `content.space` is a space object.
            // After normalizr, `content.space` is a space key value
            if (recordData.space) contentData.set('spaceKey', recordData.space);
            return contentData;
        });
    }
}





const $5b48c1fb1fe4a908$var$Version = (0, $64Cib.Record)({
    id: null,
    by: null,
    when: null,
    message: null,
    friendlyWhen: null,
    number: null,
    syncRev: null,
    confRev: null
});
var $5b48c1fb1fe4a908$export$2e2bcd8739ae039 = $5b48c1fb1fe4a908$var$Version;





const $de0a30b1544dd4ed$var$User = (0, $64Cib.Record)({
    isAnonymous: false,
    displayName: null,
    fullName: null,
    email: null,
    avatarUrl: null,
    isCurrentUser: null,
    currentUserCanFollow: null,
    currentUserIsFollowing: null,
    currentUserCanViewProfile: null,
    detailsPosition: null,
    detailsDepartment: null,
    detailsLocation: null,
    hasPersonalSpace: null,
    hasBlog: null,
    accountId: null,
    unknownUser: null
});
var $de0a30b1544dd4ed$export$2e2bcd8739ae039 = $de0a30b1544dd4ed$var$User;








const $71cac4f0d22dbe71$var$OperationRecord = (0, $64Cib.Record)({
    operation: null,
    targetType: null
});
var $71cac4f0d22dbe71$export$2e2bcd8739ae039 = $71cac4f0d22dbe71$var$OperationRecord;





const $80493364ed2e8c98$var$LookAndFeel = (0, $64Cib.Record)({
    headings: null,
    header: null,
    content: null
});
var $80493364ed2e8c98$export$2e2bcd8739ae039 = $80493364ed2e8c98$var$LookAndFeel;





const $cc137ca62277422b$var$ThemeRecord = new (0, $64Cib.Record)({
    addonKey: null,
    moduleKey: null
});
var $cc137ca62277422b$export$2e2bcd8739ae039 = $cc137ca62277422b$var$ThemeRecord;


const $14a6f39917c86841$var$Settings = (0, $64Cib.Record)({
    routeOverrideEnabled: null
});
class $14a6f39917c86841$export$2e2bcd8739ae039 extends (0, $64Cib.Record)({
    id: null,
    key: null,
    name: null,
    alias: null,
    type: null,
    description: null,
    iconPath: null,
    isFavourite: null,
    isWatched: null,
    labels: [],
    homepageId: null,
    currentUserPermissions: null,
    operations: (0, $64Cib.List)([]),
    shortcutLinks: null,
    settings: new $14a6f39917c86841$var$Settings({}),
    lookAndFeel: new (0, $80493364ed2e8c98$export$2e2bcd8739ae039)({}),
    theme: new (0, $cc137ca62277422b$export$2e2bcd8739ae039)({})
}) {
    constructor(recordData){
        super(recordData);
        return this.withMutations((spaceData)=>{
            if (recordData.currentUserPermissions) spaceData.set('currentUserPermissions', (0, $64Cib.List)(recordData.currentUserPermissions));
            if (recordData.settings) spaceData.set('settings', new $14a6f39917c86841$var$Settings(recordData.settings));
            if (recordData.operations) spaceData.set('operations', (0, $64Cib.fromJS)(recordData.operations, (key, val)=>{
                const isIndexed = (0, $64Cib.Iterable).isIndexed(val);
                return isIndexed ? val.toList() : new (0, $71cac4f0d22dbe71$export$2e2bcd8739ae039)(val);
            }));
            if (recordData.lookAndFeel) spaceData.set('lookAndFeel', new (0, $80493364ed2e8c98$export$2e2bcd8739ae039)(recordData.lookAndFeel));
            if (recordData.theme) spaceData.set('theme', new (0, $cc137ca62277422b$export$2e2bcd8739ae039)(recordData.theme));
            return spaceData;
        });
    }
}





const $db61ef3e61ad2825$var$Label = (0, $64Cib.Record)({
    id: null,
    name: null,
    prefix: null
});
var $db61ef3e61ad2825$export$2e2bcd8739ae039 = $db61ef3e61ad2825$var$Label;
const $db61ef3e61ad2825$export$13a00d386e124fe1 = (0, $64Cib.Record)({
    message: '',
    messageKey: '',
    args: []
});


const $9f1c715f0cac804e$export$643b14d94ff0897b = {
    FABRIC: 'FABRIC',
    TINY_MCE: 'TINY_MCE'
};
const $9f1c715f0cac804e$export$b8df60f367f4105 = (0, $64Cib.fromJS)({
    spaces: {},
    lookAndFeelSettings: {},
    contents: {},
    versions: {},
    users: {},
    labels: {}
});
const $9f1c715f0cac804e$var$entityReducerCommon = (state, action, entityKey, recordCreator = (0, $64Cib.fromJS))=>{
    if (!action.response || !action.response.entities || !action.response.entities.hasOwnProperty(entityKey)) return state;
    const actionEntities = action.response.entities[entityKey];
    for (const key of Object.keys(actionEntities)){
        const stateEntity = state.get(key);
        let record = recordCreator(actionEntities[key]);
        if (stateEntity) record = stateEntity.mergeDeepWith((prev, next)=>{
            if (next === null) return prev;
            return next;
        }, record);
        state = state.set(key, record);
    }
    return state;
};
const $9f1c715f0cac804e$var$contents = (state, action)=>{
    state = $9f1c715f0cac804e$var$entityReducerCommon(state, action, 'contents', (item)=>new (0, $29a2cc98ace825c0$export$2e2bcd8739ae039)(item));
    switch(action.type){
        case 'CONTENT_FAILURE':
        case 'EDITOR_CONTENT_V2_FAILURE':
            if (action.error?.extensions?.statusCode === 403) {
                let hasInheritedRestrictions = false;
                let data = action.error && action.error.data;
                // handle the REST case, which will be removed soon
                if (action.message && action.message.data) data = action.message && action.message.data;
                if (data) {
                    if ((data.errors || []).some((error)=>error.message.key === 'confluence.space.restricted')) // Show not found when user doesn't have permission to view the space
                    // Make it consistent with pre-SPA
                    return state;
                    hasInheritedRestrictions = (data.errors || []).some((error)=>error.message.key === 'confluence.content.restricted.inherited');
                }
                // replace by new content record
                state = state.set(action.options.contentId, new (0, $29a2cc98ace825c0$export$2e2bcd8739ae039)({
                    id: action.options.contentId,
                    isUnauthorized: true,
                    hasInheritedRestrictions: hasInheritedRestrictions
                }));
            }
            return state;
        case 'QUICK_RELOAD_SUCCESS':
        case 'CONTENT_SUCCESS':
            if (action.type === 'CONTENT_SUCCESS') {
                const editorValue = action?.response?.properties?.editor?.value;
                const editorVersion = editorValue === 'v2' ? $9f1c715f0cac804e$export$643b14d94ff0897b.FABRIC : $9f1c715f0cac804e$export$643b14d94ff0897b.TINY_MCE;
                state = state.setIn([
                    action.contentId,
                    'editorVersion'
                ], editorVersion);
            }
            // update last fetched time.
            const lastFetchTime = action.response && action.response.lastFetchTime ? action.response.lastFetchTime : new Date().getTime();
            return state.setIn([
                action.contentId,
                'lastFetchTime'
            ], lastFetchTime);
        case 'EDITOR_CONTENT_METADATA_SUCCESS':
            const updatedAncestors = action.response?.ancestors?.map((ancestor)=>{
                return ancestor.id;
            });
            if (updatedAncestors) return state.setIn([
                action.contentId,
                'ancestors'
            ], (0, $64Cib.OrderedSet)(updatedAncestors));
    }
    return state;
};
const $9f1c715f0cac804e$var$users = (state, action)=>$9f1c715f0cac804e$var$entityReducerCommon(state, action, 'users', (item)=>new (0, $de0a30b1544dd4ed$export$2e2bcd8739ae039)(item));
const $9f1c715f0cac804e$var$lookAndFeelSettings = (state, action)=>$9f1c715f0cac804e$var$entityReducerCommon(state, action, 'lookAndFeelSettings', (item)=>(0, $64Cib.fromJS)(item));
const $9f1c715f0cac804e$var$labels = (state, action)=>$9f1c715f0cac804e$var$entityReducerCommon(state, action, 'labels', (item)=>new (0, $db61ef3e61ad2825$export$2e2bcd8739ae039)(item));
const $9f1c715f0cac804e$var$versions = (state, action)=>{
    state = $9f1c715f0cac804e$var$entityReducerCommon(state, action, 'versions', (item)=>new (0, $5b48c1fb1fe4a908$export$2e2bcd8739ae039)(item));
    if (action.type === 'HANDLE_VERSION_UPDATE') state = state.setIn([
        action.contentId,
        'number'
    ], action.version);
    return state;
};
function $9f1c715f0cac804e$export$efbef60d53829a48(state, action) {
    const spaceKeyInRequest = action.key || action.spaceKey;
    if (!spaceKeyInRequest || !action.response || !action.response.entities || !action.response.entities.spaces) return state;
    const spaceKeysInResponse = Object.keys(action.response.entities.spaces);
    if (spaceKeysInResponse.length) {
        const spaceKeyInResponse = spaceKeysInResponse[0];
        if (spaceKeyInRequest !== spaceKeyInResponse && spaceKeyInRequest.toLowerCase() === spaceKeyInResponse.toLowerCase()) // Front-end is fetching a space with wrong letter case
        // Copy the record to correct place that rest of the code is expecting.
        state = state.withMutations((spaces)=>{
            spaces.set(spaceKeyInRequest, spaces.get(spaceKeyInResponse)).delete(spaceKeyInResponse);
        });
    }
    return state;
}
const $9f1c715f0cac804e$var$spaces = (state, action)=>{
    const previousState = state;
    state = $9f1c715f0cac804e$var$entityReducerCommon(state, action, 'spaces', (item)=>new (0, $14a6f39917c86841$export$2e2bcd8739ae039)(item));
    if (state !== previousState) state = $9f1c715f0cac804e$export$efbef60d53829a48(state, action);
    if (action.type === 'SPACE_HOME_CONTENT_SUCCESS') {
        if (state.get(action.spaceKey)) return state.mergeDeep({
            [action.spaceKey]: {
                homepageId: action.response.id
            }
        });
        return state;
    } else return state;
};
const $9f1c715f0cac804e$var$entityReducers = {
    contents: $9f1c715f0cac804e$var$contents,
    versions: $9f1c715f0cac804e$var$versions,
    users: $9f1c715f0cac804e$var$users,
    spaces: $9f1c715f0cac804e$var$spaces,
    lookAndFeelSettings: $9f1c715f0cac804e$var$lookAndFeelSettings,
    labels: $9f1c715f0cac804e$var$labels
};
const $9f1c715f0cac804e$var$invokeEntityReducer = (state, action, entityKey)=>{
    const entityReducer = $9f1c715f0cac804e$var$entityReducers[entityKey];
    let stateEntities = state.get(entityKey);
    stateEntities = entityReducer(stateEntities, action);
    return state.set(entityKey, stateEntities);
};
function $9f1c715f0cac804e$export$5345fd892b40e1f6(state = $9f1c715f0cac804e$export$b8df60f367f4105, action) {
    return state.withMutations((state)=>{
        for (const entityKey of Object.keys($9f1c715f0cac804e$var$entityReducers))state = $9f1c715f0cac804e$var$invokeEntityReducer(state, action, entityKey);
        return state;
    });
}



var $jiJCD = parcelRequire("jiJCD");


var $dBmJE = parcelRequire("dBmJE");

var $kJOOQ = parcelRequire("kJOOQ");


var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");




/*
    This is a temporary solution for adding screenNames to named-routes.

    Rather than explicitly couple analytics to routing, we will end up moving screenName to a
    wrapper component that will take care of sending screen events, and will also have a decorator to
    add screenName to all events below it.
*/ const $c01598d377ef7a00$export$e603d10457baeb34 = {
    EDIT_PAGE: 'editPageScreen',
    EDIT_BLOG: 'editPageScreen',
    EDIT_PAGE_V2: 'editPageScreen',
    EDIT_BLOG_V2: 'editPageScreen',
    EDIT_PAGE_EMBED: 'editPageEmbedScreen',
    CREATE_PAGE: 'editPageScreen',
    CREATE_BLOG: 'editPageScreen',
    SPACE_OVERVIEW: 'spaceOverviewScreen',
    VIEW_PAGE: 'viewPageScreen',
    VIEW_BLOG_DATE_LEGACY: 'viewPageScreen',
    VIEW_BLOG: 'viewPageScreen',
    SPACE_CALENDARS: 'spaceCalendarsScreen',
    ALL_UPDATES: 'allUpdatesScreen',
    POPULAR: 'popularScreen',
    MY_WORK_DRAFTS: 'draftsScreen',
    RECENT_DRAFTS: 'recentDraftsScreen',
    MY_WORK_RECENT: 'recentlyWorkedOnScreen',
    RECENT_PAGES: 'recentPagesScreen',
    MY_RECENTLY_VISITED: 'recentlyVisitedScreen',
    RECENT_VISITED: 'recentVisitedScreen',
    MY_SAVED_FOR_LATER: 'savedScreen',
    RECENT_SAVED_FOR_LATER: 'recentSavedScreen',
    HOME: 'homeScreen',
    PDF_EXPORT_PAGE: 'pdfExportScreen',
    PDF_EXPORT_SPACE: 'pdfExportScreen',
    TOPICS: 'topicsScreen',
    AI_SEARCH_PAGE: 'aiSearchPageScreen'
};
const $c01598d377ef7a00$var$mapRoutesToScreenName = (routes, screenNames = $c01598d377ef7a00$export$e603d10457baeb34)=>{
    for(const name in routes)if (typeof routes[name] === 'object') routes[name].screenName = screenNames[name];
    return routes;
};
var $c01598d377ef7a00$export$2e2bcd8739ae039 = $c01598d377ef7a00$var$mapRoutesToScreenName;


const $7b651915a8161023$var$routes = Object.values((0, $c01598d377ef7a00$export$2e2bcd8739ae039)((0, $64KID.namedRoutes)));
function $7b651915a8161023$var$replaceParams(token) {
    return token.replace(/^:\w+/g, '').replace(/\(.+?\)/g, '');
}
function $7b651915a8161023$export$96ef22564cc59326(a, b) {
    const tokensA = a.definition.pattern.split('/');
    const tokensB = b.definition.pattern.split('/');
    for(let i = 0; i < tokensA.length || i < tokensB.length; i++){
        if (i < tokensA.length && i < tokensB.length) {
            const lengthA = $7b651915a8161023$var$replaceParams(tokensA[i]).length;
            const lengthB = $7b651915a8161023$var$replaceParams(tokensB[i]).length;
            if (lengthA < lengthB) return 1;
            else if (lengthA > lengthB) return -1;
        } else if (i < tokensA.length) return -1;
        else return 1;
    }
    return 0;
}
var $7b651915a8161023$export$2e2bcd8739ae039 = (pathname)=>{
    if (typeof pathname !== 'string') return {
        match: null,
        routeName: ''
    };
    const matches = [];
    for (const definition of $7b651915a8161023$var$routes){
        if (!(definition instanceof (0, $fMEnQ.Route))) continue;
        const match = definition.match((0, $cb6fO.getContextAwareFullPath)(pathname, true));
        if (match) matches.push({
            definition: definition,
            match: match
        });
    }
    if (matches.length >= 1) {
        let match = matches[0];
        if (matches.length > 1) {
            // Match as many literals as possible
            matches.sort($7b651915a8161023$export$96ef22564cc59326);
            match = matches[0];
        }
        return {
            match: match.match,
            routeName: match.definition.name,
            screenName: match.definition.screenName || ''
        };
    }
    return {
        match: null,
        routeName: '',
        screenName: ''
    };
};


var /**
 * Takes a LOCATION_CHANGE action from connected-react-router and augments it with a "query" object (which represents the
 * querystring parameters), and the route parameters extracted from Confluence's supported routes.
 *
 * This was written for backwards compatibility with the state provided by redux-router (which we moved away from).
 *
 * @param {object} state
 * @param {object} action
 * @returns {{ location: object, params: object }}
 */ $a5318ef16786ff1d$export$2e2bcd8739ae039 = (browserHistory)=>{
    const routerReducer = browserHistory ? (0, $dBmJE.connectRouter)(browserHistory) : (state = null)=>state;
    return (state, action)=>{
        const newState = routerReducer(state, action);
        if (action && action.type === (0, $kJOOQ.LOCATION_CHANGE)) {
            const { match: match, routeName: routeName, screenName: screenName } = (0, $7b651915a8161023$export$2e2bcd8739ae039)(action.payload.location.pathname);
            const query = newState.location.search ? (0, $jiJCD.parse)(newState.location.search, true).query : {};
            return {
                action: newState.action,
                location: {
                    ...newState.location,
                    query: query,
                    routeName: routeName,
                    screenName: screenName
                },
                params: match ? match.params : {}
            };
        }
        return newState;
    };
};















var $iU8DZ = parcelRequire("iU8DZ");





var $eYNcX = parcelRequire("eYNcX");


var $flE5X = parcelRequire("flE5X");

const $5a91c9f814b51343$export$b0cd0e90c2f435c7 = (0, $64Cib.Record)({
    error: false,
    type: undefined,
    title: undefined,
    body: undefined,
    bodyKey: undefined,
    close: undefined,
    isNetworkConnected: true
});
function $5a91c9f814b51343$export$2e2bcd8739ae039(state = new $5a91c9f814b51343$export$b0cd0e90c2f435c7(), action) {
    if (action.error && /_FAILURE$/.test(action.type)) {
        if (action.error instanceof TypeError || action.error instanceof (0, $flE5X.NoNetworkError)) {
            if (!state.isNetworkConnected) // local network is disconnected, but fetch attempted
            return new $5a91c9f814b51343$export$b0cd0e90c2f435c7({
                error: true,
                type: 'error',
                title: 'error.connection.lost.title',
                bodyKey: 'error.connection.lost.body',
                close: 'manual',
                isNetworkConnected: false
            });
        } else if (action.error.statusCode === (0, $eYNcX.INTERNAL_SERVER_ERROR) || action.error.statusCode === (0, $eYNcX.SERVICE_UNAVAILABLE_ERROR)) return new $5a91c9f814b51343$export$b0cd0e90c2f435c7({
            error: true,
            type: 'error',
            title: 'error.server-error.title',
            bodyKey: 'error.server-error.body',
            close: 'auto'
        });
    }
    switch(action.type){
        case 'CONNECTION_OFFLINE':
            return new $5a91c9f814b51343$export$b0cd0e90c2f435c7({
                error: false,
                isNetworkConnected: false
            });
        case 'CONNECTION_ONLINE':
            if (state.error) // 'connection lost' message displayed, connection recovered
            return new $5a91c9f814b51343$export$b0cd0e90c2f435c7({
                error: true,
                type: 'success',
                title: 'error.connection.recovered.title',
                body: '<button onclick="window.location.reload()" class="aui-button aui-button-link btn-reload-content">i18nPlaceholder</button>',
                bodyKey: 'error.connection.recovered.action',
                close: 'manual',
                isNetworkConnected: true
            });
            return new $5a91c9f814b51343$export$b0cd0e90c2f435c7({
                isNetworkConnected: true
            });
        case 'REMOVE_ERROR':
            return new $5a91c9f814b51343$export$b0cd0e90c2f435c7({
                error: false
            }).set('isNetworkConnected', state.isNetworkConnected);
    }
    return state;
}


const $c19d5fe3ca344db2$var$MAXIMUM_ITEM_SAVE_IN_HISTORY = 10;
const $c19d5fe3ca344db2$var$rootState = {
    session: {
        history: (0, $64Cib.List)([]),
        analytics: (0, $64Cib.fromJS)({
            currentSection: '',
            previousSection: '',
            searchSessionId: ''
        })
    }
};
function $c19d5fe3ca344db2$export$55abd4691b317664(state = $c19d5fe3ca344db2$var$rootState.session.history, action) {
    switch(action.type){
        case 0, $kJOOQ.LOCATION_CHANGE:
            return state.push(action.payload.location.pathname).takeLast($c19d5fe3ca344db2$var$MAXIMUM_ITEM_SAVE_IN_HISTORY);
        default:
            return state;
    }
}
function $c19d5fe3ca344db2$export$71a493436f9bccb6(state = $c19d5fe3ca344db2$var$rootState.session.analytics, action) {
    switch(action.type){
        case 0, $kJOOQ.LOCATION_CHANGE:
            const previousSection = state.get('currentSection');
            const currentSection = (0, $iU8DZ.stripContentTitlesFromURL)(action.payload.location.pathname);
            const searchSessionId = (0, $jiJCD.parse)(action.payload.location.search, true).query.search_id || state.get('searchSessionId');
            return state.merge({
                currentSection: currentSection,
                previousSection: previousSection,
                searchSessionId: searchSessionId
            });
        default:
            return state;
    }
}
var $c19d5fe3ca344db2$export$2e2bcd8739ae039 = (0, $9hOZ1.combineReducers)({
    errors: $5a91c9f814b51343$export$2e2bcd8739ae039,
    history: $c19d5fe3ca344db2$export$55abd4691b317664,
    analytics: $c19d5fe3ca344db2$export$71a493436f9bccb6
});









var $9FYW3 = parcelRequire("9FYW3");

const $2be391618f9d81c5$var$DEFAULT_SPOTLIGHT_STATE = (0, $64Cib.fromJS)({
    id: -1,
    ready: false,
    requested: false,
    dismissed: false,
    attributes: {
        heading: '',
        footer: '',
        dialogPlacement: 'right top',
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetRadius: 4
    }
});
const $2be391618f9d81c5$var$ORIGINAL_FLOW_SET = (0, $9FYW3.SPOTLIGHTS_FLOWS).map((flow)=>flow.map((id)=>$2be391618f9d81c5$var$DEFAULT_SPOTLIGHT_STATE.merge({
            id: id
        })));
const $2be391618f9d81c5$var$DEFAULT_STATE = (0, $64Cib.fromJS)({
    index: -1,
    flow: -1,
    loaded: 0,
    spotlights: $2be391618f9d81c5$var$ORIGINAL_FLOW_SET
});
function $2be391618f9d81c5$export$2e2bcd8739ae039(state = $2be391618f9d81c5$var$DEFAULT_STATE, action = {}) {
    const { spotlightId: spotlightId } = action;
    const spotlights = state.get('spotlights');
    const index = state.get('index');
    switch(action.type){
        case 'CHANGEBOARDING_NEXT':
            return state.merge({
                index: index + 1
            });
        case 'CHANGEBOARDING_PREV':
            return state.merge({
                index: index - 1
            });
        case 'CHANGEBOARDING_TARGET_READY':
            for(let flowIndex = 0; flowIndex < spotlights.size; flowIndex++){
                let flowReady = !!spotlights.get(flowIndex).size;
                for(let spotlightIndex = 0; spotlightIndex < spotlights.get(flowIndex).size; spotlightIndex++){
                    if (spotlights.getIn([
                        flowIndex,
                        spotlightIndex,
                        'id'
                    ]) === spotlightId) {
                        state = state.setIn([
                            'spotlights',
                            flowIndex,
                            spotlightIndex,
                            'loaded'
                        ], true);
                        const { spotlightAttributes: spotlightAttributes } = action;
                        const existingAttributes = state.getIn([
                            'spotlights',
                            flowIndex,
                            spotlightIndex,
                            'attributes'
                        ]);
                        const newAttributes = (0, $64Cib.fromJS)(spotlightAttributes);
                        /*
                    pass in spotlightAttributes from action to the state (if there is any)
                   */ state = state.setIn([
                            'spotlights',
                            flowIndex,
                            spotlightIndex,
                            'attributes'
                        ], existingAttributes.merge(newAttributes));
                    }
                    flowReady = flowReady && state.getIn([
                        'spotlights',
                        flowIndex,
                        spotlightIndex,
                        'loaded'
                    ]);
                }
                if (flowReady) return state.merge({
                    flow: flowIndex,
                    index: 0,
                    loaded: spotlights.get(flowIndex).size
                });
            }
            break;
        case 'CHANGEBOARDING_DISMISS':
            const flow = state.get('flow');
            // The last flow should be empty.
            const last = spotlights.size - 1;
            if (flow === last) return state.setIn([
                'spotlights',
                last
            ], (0, $64Cib.List)([]));
            else /*
              for multi step flow, clear the spotlights on dismiss to make it disappear
             */ return state.deleteIn([
                'spotlights',
                flow
            ]);
        case 'CHANGEBOARDING_INVOKE':
            for(let flowIndex = 0; flowIndex < spotlights.size; flowIndex++){
                for(let spotlightIndex = 0; spotlightIndex < spotlights.get(flowIndex).size; spotlightIndex++)if (spotlights.getIn([
                    flowIndex,
                    spotlightIndex,
                    'id'
                ]) === spotlightId) {
                    let newState = state.setIn([
                        'spotlights',
                        flowIndex,
                        spotlightIndex,
                        'requested'
                    ], true);
                    const { spotlightAttributes: spotlightAttributes } = action;
                    const existingAttributes = newState.getIn([
                        'spotlights',
                        flowIndex,
                        spotlightIndex,
                        'attributes'
                    ]);
                    const newAttributes = (0, $64Cib.fromJS)(spotlightAttributes);
                    /*
                    pass in spotlightAttributes from action to the state (if there is any)
                   */ newState = newState.setIn([
                        'spotlights',
                        flowIndex,
                        spotlightIndex,
                        'attributes'
                    ], existingAttributes.merge(newAttributes));
                    return newState;
                }
            }
            return state.setIn([
                'spotlights',
                spotlights.size - 1,
                spotlights.get(spotlights.size - 1).size
            ], $2be391618f9d81c5$var$DEFAULT_SPOTLIGHT_STATE.merge({
                id: spotlightId
            }));
        case 'CHANGEBOARDING_SET_SPOTLIGHT_ATTRIBUTES':
            const { spotlightAttributes: spotlightAttributes } = action;
            for(let flowIndex = 0; flowIndex < spotlights.size; flowIndex++)for(let spotlightIndex = 0; spotlightIndex < spotlights.get(flowIndex).size; spotlightIndex++){
                if (spotlights.getIn([
                    flowIndex,
                    spotlightIndex,
                    'id'
                ]) === spotlightId) return state.setIn([
                    'spotlights',
                    flowIndex,
                    spotlightIndex,
                    'attributes'
                ], spotlightAttributes);
            }
            break;
    }
    return state;
}





function $f518d0aa4952ed94$export$a5f98448b9315739(state = (0, $64Cib.Map)({}), action) {
    switch(action.type){
        case 'GET_EXPERIMENT_FEATURES_SUCCESS':
        case 'DASHBOARD_VIEW_MODEL_SUCCESS':
            return state.merge({
                ...action.response
            });
        default:
            return state;
    }
}











const $d6bdd22f8ce8e6ba$var$DEFAULT_STATE = (0, $64Cib.fromJS)({});
function $d6bdd22f8ce8e6ba$export$2e2bcd8739ae039(state = $d6bdd22f8ce8e6ba$var$DEFAULT_STATE, action) {
    switch(action.type){
        case 'SPACE_HOME_CONTENT_SUCCESS':
            return state.mergeIn([
                action.spaceKey
            ], {
                isSpaceFound: action?.response?.result !== undefined
            });
        default:
            return state;
    }
}


const $f9d0597e01a892ba$var$DEFAULT_SPACE_INFO_STATE = (0, $64Cib.fromJS)({
    results: [],
    isRequesting: null,
    hasFetched: false
});
function $f9d0597e01a892ba$export$144592bc8f143152(state = $f9d0597e01a892ba$var$DEFAULT_SPACE_INFO_STATE, action) {
    switch(action.type){
        case 'SPACE_INFO_SUCCESS':
            const isFound = action.response.results.length > 0;
            return state.merge({
                isRequesting: false,
                hasFetched: true,
                spaceKey: action.spaceKey,
                isFound: isFound
            });
        case 'SPACE_INFO_REQUEST':
            return state.merge({
                hasFetched: false,
                isRequesting: true,
                spaceKey: action.spaceKey
            });
        case 'SPACE_INFO_FAILURE':
            return state.merge({
                hasFetched: false,
                isRequesting: false,
                spaceKey: action.spaceKey
            });
        default:
            return state;
    }
}
var $f9d0597e01a892ba$export$2e2bcd8739ae039 = (0, $9hOZ1.combineReducers)({
    currentSpace: $f9d0597e01a892ba$export$144592bc8f143152,
    homePage: $d6bdd22f8ce8e6ba$export$2e2bcd8739ae039
});









var $h0zqw = parcelRequire("h0zqw");


var $irL2R = parcelRequire("irL2R");





const $8256da07864d1748$export$39202f2f00fd507c = 'ADD_LABELS';
const $8256da07864d1748$export$7d307ae1a0d03697 = 'DELETE_LABELS';
const $8256da07864d1748$export$866f750dcc9450e4 = 'SUGGEST_LABELS';
const $8256da07864d1748$export$9f56054b244900a7 = 'SHOW_EDIT_LABEL_DIALOG';
const $8256da07864d1748$export$68a3f93e71fbe3f8 = 'CLOSE_EDIT_LABEL_DIALOG';
const $8256da07864d1748$export$59689cff3c76c06b = 'CLEAR_SUGGESTIONS';
const $8256da07864d1748$export$e714584b2a07100d = 'CLEAR_ERROR_MESSAGES';


const $804ccb6cde257677$var$rootState = {
    labels: (0, $64Cib.fromJS)({
        isShowingDialog: false
    }),
    labelDialog: (0, $64Cib.fromJS)({
        error: '',
        suggestions: []
    })
};
const $804ccb6cde257677$export$92448cc3bc36f688 = (errorMsgObject)=>{
    let message = '';
    let messageKey = '';
    const args = [];
    if (typeof errorMsgObject === 'object' && errorMsgObject.message) message = errorMsgObject.message;
    // try to get error key and its arguments from error message string
    if (typeof message === 'string' && message.indexOf('messageKey') >= 0) {
        // Regular expression to parse error message key and its arguments.
        // Here is exmaple of error string which is returned from server side
        // Ex: "com.atlassian.confluence.core.service.NotValidException: [ValidationError [messageKey=label.contains.invalid.chars, args=[a:b, 1, 2, 3]]]"
        // `(?:\w|\.)+` : is a non-capturing group - to match with message key value
        // `{1}` - exactly 1 time
        // `\s*` : match any white space character
        const re = /\[messageKey=((?:\w|\.)+){1},\s*args=\[((?:.)+)?\]\]\]/;
        if (re.test(message)) {
            const results = re.exec(message);
            // first element of array which is returned from `re.exec` is ful string of charecter matched.
            // Ex: if message="com.atlassian.confluence.core.service.NotValidException: [ValidationError [messageKey=label.contains.invalid.chars, args=[a:b, 1, 2, 3]]]"
            // results[0] = "[ValidationError [messageKey=label.contains.invalid.chars, args=[a:b, 1, 2, 3]]]"
            // Full detail: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec
            messageKey = results[1];
            // Basing on all error messages patterns, there are maximum of 2 arguments for message.
            const argArray = results[2] ? results[2].split(',') : '';
            if (argArray) {
                args[0] = (0, (/*@__PURE__*/$parcel$interopDefault($irL2R)))(argArray);
                args[1] = (argArray || []).slice(1).join(', ');
            }
        }
    }
    return new (0, $db61ef3e61ad2825$export$13a00d386e124fe1)({
        message: message,
        messageKey: messageKey,
        args: args
    });
};
const $804ccb6cde257677$export$a238cb463698c900 = (state = $804ccb6cde257677$var$rootState.labels, action)=>{
    switch(action.type){
        case 0, $8256da07864d1748$export$9f56054b244900a7:
            return state.merge({
                isShowingDialog: true
            });
        case 0, $8256da07864d1748$export$68a3f93e71fbe3f8:
            return state.merge({
                isShowingDialog: false
            });
        default:
            return state;
    }
};
const $804ccb6cde257677$export$69dd859854a593f5 = (state = $804ccb6cde257677$var$rootState.labelDialog, action)=>{
    switch(action.type){
        case `${0, $8256da07864d1748$export$39202f2f00fd507c}_REQUEST`:
            return state.merge({
                error: ''
            });
        case `${0, $8256da07864d1748$export$39202f2f00fd507c}_FAILURE`:
            return state.merge({
                error: $804ccb6cde257677$export$92448cc3bc36f688(action.message)
            });
        case `${0, $8256da07864d1748$export$39202f2f00fd507c}_SUCCESS`:
            return state.merge({
                error: '',
                results: action.response.result.results
            });
        case `${0, $8256da07864d1748$export$7d307ae1a0d03697}_FAILURE`:
            return state.merge({
                error: $804ccb6cde257677$export$92448cc3bc36f688(action.message)
            });
        case `${0, $8256da07864d1748$export$866f750dcc9450e4}_SUCCESS`:
            return state.set('suggestions', action.response.results);
        case 0, $8256da07864d1748$export$59689cff3c76c06b:
            return state.merge({
                suggestions: []
            });
        case 0, $8256da07864d1748$export$e714584b2a07100d:
            return state.merge({
                error: null
            });
        default:
            return state;
    }
};





const $5237cc873ace9795$var$defaultState = {
    contentId: null,
    isEditorLoaded: false,
    isContentEditable: false
};
const $5237cc873ace9795$export$b5d042d2b680aed6 = (state = $5237cc873ace9795$var$defaultState, action)=>{
    switch(action.type){
        case 0, $h0zqw.SHOW_EDITOR:
            return {
                ...state,
                contentId: action.contentId
            };
        case 0, $h0zqw.HIDE_EDITOR:
            return {
                ...state,
                contentId: null
            };
        case 0, $h0zqw.EDITOR_LOAD_COMPLETE:
            return {
                ...state,
                isEditorLoaded: true
            };
        case 0, $h0zqw.EDITOR_CONTENT_EDITABLE:
            return {
                ...state,
                isContentEditable: true
            };
        default:
            return state;
    }
};











const $cde21dc327dc8089$var$defaultState = (0, $64Cib.fromJS)({
    contentId: null,
    hasFetched: null,
    result: null,
    errorData: null,
    statusCode: null,
    silent: null,
    spaceKey: null
});
function $cde21dc327dc8089$export$2e2bcd8739ae039(state = $cde21dc327dc8089$var$defaultState, action) {
    switch(action.type){
        case `${0, $h0zqw.EDITOR_CONTENT}_REQUEST`:
            return state.merge({
                contentId: action.contentId,
                silent: !!action.silent,
                hasFetched: false,
                result: null,
                errorData: null,
                statusCode: null,
                spaceKey: null
            });
        case `${0, $h0zqw.EDITOR_CONTENT}_SUCCESS`:
            if (state.get('contentId') !== action.contentId) return state;
            return state.merge({
                hasFetched: true,
                result: action.response && action.response._originalResponse,
                statusCode: (0, $eYNcX.OK),
                errorData: null,
                spaceKey: action.response.spaceKey
            });
        case `${0, $h0zqw.EDITOR_CONTENT}_FAILURE`:
            if (state.get('contentId') !== action.options.contentId) return state;
            return state.merge({
                hasFetched: true,
                statusCode: action.error && action.error.statusCode,
                errorData: action.message
            });
        case 0, $h0zqw.RESET_EDITOR_STATE:
            return $cde21dc327dc8089$var$defaultState;
        default:
            return state;
    }
}


const $dcd2b35d4e6c1054$var$defaultState = (0, $64Cib.fromJS)({
    contentId: null,
    hasLoaded: false
});
function $dcd2b35d4e6c1054$export$8a24ff1d7713b626(state = $dcd2b35d4e6c1054$var$defaultState, action) {
    switch(action.type){
        case 0, $h0zqw.EDITOR_PRELOAD_START:
            if (state.get('contentId') === action.contentId) return state;
            return state.merge({
                hasLoaded: false,
                contentId: action.contentId
            });
        case 0, $h0zqw.EDITOR_PRELOAD_FINISH:
            if (state.get('contentId') !== action.contentId) return state;
            return state.merge({
                hasLoaded: true
            });
        default:
            return state;
    }
}
var $dcd2b35d4e6c1054$export$2e2bcd8739ae039 = (0, $9hOZ1.combineReducers)({
    editorContent: $cde21dc327dc8089$export$2e2bcd8739ae039,
    labels: $804ccb6cde257677$export$a238cb463698c900,
    labelDialog: $804ccb6cde257677$export$69dd859854a593f5,
    editor: $5237cc873ace9795$export$b5d042d2b680aed6,
    quickEditPreload: $dcd2b35d4e6c1054$export$8a24ff1d7713b626
});











var $ca5066a8f1d56a2f$export$2e2bcd8739ae039 = (0, $64Cib.Record)({
    id: null,
    webItemKey: null,
    webItemCompleteKey: null,
    title: null,
    url: null,
    position: null,
    icon: null,
    iconClass: null,
    styleClass: null,
    hidden: null,
    canHide: null,
    tooltip: null,
    urlWithoutContextPath: null
});



var $jBnsv = parcelRequire("jBnsv");

const $a9b94e02b9cec0e3$var$ALWAYS_VISIBLE_WEBITEMS = [
    (0, $jBnsv.SPACE_TAB_PAGES_KEY),
    (0, $jBnsv.SPACE_SETTINGS_KEY)
];
// items that shouldn't appear in ADG3 sidebar
const $a9b94e02b9cec0e3$var$blacklist = [
    'spacebar-profile'
];
function $a9b94e02b9cec0e3$export$463d32b91de8b4d(state = (0, $64Cib.Map)({}), action) {
    switch(action.type){
        case 'GET_SPACE_LINKS_SUCCESS':
            const spaceKey = action.spaceKey;
            Object.keys(action.response).forEach((group)=>{
                const allowedItems = action.response[group].filter((link)=>{
                    return !(link.webItemKey && $a9b94e02b9cec0e3$var$blacklist.indexOf(link.webItemKey) !== -1);
                });
                const spaceLinks = allowedItems.map((link)=>{
                    const item = {
                        ...link
                    };
                    if (group === 'quick') item.canHide = true;
                    // force "pages" and "space settings" always visible
                    if ($a9b94e02b9cec0e3$var$ALWAYS_VISIBLE_WEBITEMS.indexOf(item.webItemCompleteKey) !== -1) {
                        item.hidden = false;
                        item.canHide = false;
                    }
                    return (0, $ca5066a8f1d56a2f$export$2e2bcd8739ae039)(item);
                });
                state = state.setIn([
                    spaceKey,
                    group
                ], (0, $64Cib.List)(spaceLinks));
            });
            return state;
        case 'MOVE_SPACE_LINK_REQUEST':
            const { group: group } = action;
            return state.updateIn([
                action.spaceKey,
                group
            ], (items)=>{
                const indexSource = items.findIndex((item)=>item.id === action.id);
                if (indexSource !== -1) {
                    const item = items.get(indexSource);
                    const updatedItems = items.delete(indexSource);
                    let indexDestination = -1;
                    if (action.position && action.position === 'First') // Move to the first
                    indexDestination = 0;
                    else if (action.after) // Move the item to a item with certain id
                    indexDestination = updatedItems.findIndex((item)=>item.id === action.after) + 1;
                    if (indexDestination !== -1) return updatedItems.insert(indexDestination, item);
                }
                return items;
            });
        case 'TOGGLE_SPACE_LINK_REQUEST':
            const path = [
                action.spaceKey,
                action.group
            ];
            const index = state.getIn(path).findIndex((item)=>item.id === action.id);
            return state.updateIn(path.concat(index), (item)=>item.set('hidden', !item.hidden));
        case 'REMOVE_SPACE_SHORTCUT_LINK_REQUEST':
            const { linkId: linkId } = action;
            return state.updateIn([
                action.spaceKey,
                'quick'
            ], (items)=>{
                const indexSource = items.findIndex((item)=>item.id === linkId);
                return items.delete(indexSource);
            });
        default:
            return state;
    }
}
function $a9b94e02b9cec0e3$export$8c9a508833948c64(state = (0, $64Cib.OrderedSet)(), action) {
    switch(action.type){
        case 'GET_SPACES_SUCCESS':
            if (action.response.result.allSpaces && action.response.result.allSpaces.results.length) return (0, $64Cib.OrderedSet)(action.response.result.allSpaces.results);
            return state;
    }
    return state;
}
var $a9b94e02b9cec0e3$export$2e2bcd8739ae039 = (0, $9hOZ1.combineReducers)({
    links: $a9b94e02b9cec0e3$export$463d32b91de8b4d,
    allSpaces: $a9b94e02b9cec0e3$export$8c9a508833948c64
});


var $b31fd5b8991a5273$export$2e2bcd8739ae039 = (0, $9hOZ1.combineReducers)({
    dashboard: $f518d0aa4952ed94$export$a5f98448b9315739,
    spaceHome: $f9d0597e01a892ba$export$2e2bcd8739ae039,
    viewPage: $dcd2b35d4e6c1054$export$2e2bcd8739ae039,
    space: $a9b94e02b9cec0e3$export$2e2bcd8739ae039,
    changeboarding: $2be391618f9d81c5$export$2e2bcd8739ae039
});


function $4921329f71e36dc5$export$2e2bcd8739ae039(state = {}, action) {
    switch(action.type){
        case 'SET_ACTIVE_MODAL':
            return {
                modalComponent: action.component,
                modalProps: action.props
            };
        case 'CLOSE_ACTIVE_MODAL':
            return {};
    }
    return state;
}






var $19fl2 = parcelRequire("19fl2");

// TODO: temporary to support the transition from the 'confluence-dashboard' plugin name
const $987b86ef1844383b$var$updateFeature = (feature)=>{
    if (feature.pluginKey.indexOf('confluence-dashboard') !== -1) feature.pluginKey = feature.pluginKey.replace('confluence-dashboard', 'confluence-frontend-support');
    return feature;
};
const $987b86ef1844383b$export$49d5fc8cba920a0 = (0, $64Cib.fromJS)({
    hasLoaded: false,
    list: (0, $64Cib.List)([])
});
function $987b86ef1844383b$export$2e2bcd8739ae039(state = $987b86ef1844383b$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 'DISCOVERED_FEATURES_SUCCESS':
            const newList = (0, $64Cib.List)(action.response && action.response.map($987b86ef1844383b$var$updateFeature));
            return state.withMutations((state)=>{
                state.set('hasLoaded', true);
                // merge 2 list
                const currentList = state.get('list');
                const updatedList = currentList.concat(newList.filter((item)=>!(0, $19fl2.hasFeatureBeenDiscovered)(currentList, item)));
                state.set('list', updatedList);
                return state;
            });
        case 'FEATURE_DISCOVERED_MARK_REQUEST':
        case 'FEATURE_DISCOVERED_MARK_SUCCESS':
            // there is no success action dispatch for mark feature discover
            // because the POST request does not return any response
            // this change is necessary to update the state after the action happens
            // and mark that the feature has been discovered
            const alreadyDiscovered = (0, $19fl2.hasFeatureBeenDiscovered)(state.get('list'), action);
            if (alreadyDiscovered) return state;
            else {
                const newEntry = {
                    pluginKey: action.pluginKey,
                    featureKey: action.featureKey
                };
                return state.set('list', state.get('list').push(newEntry));
            }
        default:
            return state;
    }
}


const $b67d640653fa7387$var$isServerRenderedPage = (state = null)=>state;
const $b67d640653fa7387$var$meta = (state = (0, $64Cib.Map)())=>state;
function $b67d640653fa7387$export$2e2bcd8739ae039(extraReducers, browserHistory) {
    return (0, $9hOZ1.combineReducers)({
        router: (0, $a5318ef16786ff1d$export$2e2bcd8739ae039)(browserHistory),
        session: $c19d5fe3ca344db2$export$2e2bcd8739ae039,
        views: $b31fd5b8991a5273$export$2e2bcd8739ae039,
        entities: $9f1c715f0cac804e$export$5345fd892b40e1f6,
        meta: $b67d640653fa7387$var$meta,
        modal: $4921329f71e36dc5$export$2e2bcd8739ae039,
        discoveredFeatures: $987b86ef1844383b$export$2e2bcd8739ae039,
        editor: $eH0qm.default,
        fabricEditor: $dfdf14fbf1783baa$export$2e2bcd8739ae039,
        isServerRenderedPage: $b67d640653fa7387$var$isServerRenderedPage,
        ...extraReducers
    });
}





var $161419671c9aa8e4$exports = {};

$161419671c9aa8e4$exports = (parcelRequire("aExmg"));


/**
 * Takes an object and returns a new object with the specified keys removed.
 * @param {Object} obj - The object that will have keys removed.
 * @param {Set} keys - The keys to remove from the target object.
 * @returns {Object}
 */ function $3b638b65f923b951$export$44c361b8ec72ef7f(obj, keys) {
    return Object.keys(obj).reduce((newObj, key)=>{
        if (!keys.has(key)) newObj[key] = obj[key];
        return newObj;
    }, {});
}
function $3b638b65f923b951$export$871de8747c9eaa88(obj, fn) {
    const newObj = {};
    Object.keys(obj || {}).forEach((key)=>{
        newObj[key] = fn(obj[key], key, obj);
    });
    return newObj;
}



var $8EsbU = parcelRequire("8EsbU");

const $eb003b822bc822f9$export$3934bd4722d03882 = new Set([
    'i18n',
    'watches',
    'pagination',
    'session',
    'views',
    'hover',
    'meta',
    'isServerRenderedPage'
]);
// This blacklist is so we can gradually remove the usage of meta tags from the server-side.
const $eb003b822bc822f9$var$META_BLACKLIST = new Set([
    'discovered-plugin-features'
]);
function $eb003b822bc822f9$export$2e2bcd8739ae039(windowGlobal = $parcel$global, extraState = {}) {
    const initialState = Object.assign(windowGlobal.__INITIAL_STATE__ || {}, extraState);
    initialState.meta = (0, (/*@__PURE__*/$parcel$interopDefault($161419671c9aa8e4$exports)))(initialState.meta || {}, (0, $3b638b65f923b951$export$44c361b8ec72ef7f)((0, $8EsbU.getAllAsMap)(), $eb003b822bc822f9$var$META_BLACKLIST));
    return (0, $3b638b65f923b951$export$871de8747c9eaa88)(initialState, (value, key)=>{
        if (!$eb003b822bc822f9$export$3934bd4722d03882.has(key)) console.error(`Unsupported key \"${key}\" was found in the __INITIAL_STATE__.\nCheck if it works and add it to the whitelist of the initialStateFactory.`);
        return (0, $64Cib.fromJS)(value);
    });
}


function $2d5f6fbfb5c3dc75$export$2e2bcd8739ae039(initialState = {}) {
    const devMiddleware = [
        // Uncomment this line to enable timing middleware.
        // It will provide some helpful information to tune the performance.
        // applyMiddleware(require('../middleware/timing').default),
        // if you want devtools, install the chrome extension
        // https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd
        typeof $parcel$global.__REDUX_DEVTOOLS_EXTENSION__ === 'function' ? $parcel$global.__REDUX_DEVTOOLS_EXTENSION__() : (f)=>f
    ];
    const browserHistory = (0, $hmRc4.getBrowserHistory)();
    const finalCreateStore = (0, $9hOZ1.compose)((0, $9hOZ1.applyMiddleware)((0, $2dfb7d7c6b6c1326$export$2e2bcd8739ae039), (0, $dd1eaf48c6b4ba66$export$2e2bcd8739ae039), (0, $184060ff10462130$export$2e2bcd8739ae039), (0, $1a38fd4db987f5e5$export$2e2bcd8739ae039)), (0, $9hOZ1.applyMiddleware)((0, $8aej1.default)(browserHistory)), ...[])((0, $9hOZ1.createStore));
    return finalCreateStore((0, $b67d640653fa7387$export$2e2bcd8739ae039)({}, browserHistory), (0, $eb003b822bc822f9$export$2e2bcd8739ae039)($parcel$global, initialState));
}

});

parcelRegister("9hOZ1", function(module, exports) {

var $iLaQ6 = parcelRequire("iLaQ6");

function $92a352d4f887d76d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $92a352d4f887d76d$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $92a352d4f887d76d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iLaQ6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $92a352d4f887d76d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $6c2d3fcab1c4415e$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $6c2d3fcab1c4415e$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $6c2d3fcab1c4415e$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $6c2d3fcab1c4415e$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $6c2d3fcab1c4415e$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $6c2d3fcab1c4415e$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $6c2d3fcab1c4415e$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $6c2d3fcab1c4415e$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $6c2d3fcab1c4415e$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($6c2d3fcab1c4415e$var$isDate(val)) return 'date';
    if ($6c2d3fcab1c4415e$var$isError(val)) return 'error';
    var constructorName = $6c2d3fcab1c4415e$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $6c2d3fcab1c4415e$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $6c2d3fcab1c4415e$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $6c2d3fcab1c4415e$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $6c2d3fcab1c4415e$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $6c2d3fcab1c4415e$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(1));
        return enhancer($6c2d3fcab1c4415e$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$6c2d3fcab1c4415e$var$isPlainObject(action)) throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $6c2d3fcab1c4415e$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$6c2d3fcab1c4415e$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $6c2d3fcab1c4415e$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$6c2d3fcab1c4415e$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $6c2d3fcab1c4415e$export$8928921ea2d3b126 = $6c2d3fcab1c4415e$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $6c2d3fcab1c4415e$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $6c2d3fcab1c4415e$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $6c2d3fcab1c4415e$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$6c2d3fcab1c4415e$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $6c2d3fcab1c4415e$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $6c2d3fcab1c4415e$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $6c2d3fcab1c4415e$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $6c2d3fcab1c4415e$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $6c2d3fcab1c4415e$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $6c2d3fcab1c4415e$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $6c2d3fcab1c4415e$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $6c2d3fcab1c4415e$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $6c2d3fcab1c4415e$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $6c2d3fcab1c4415e$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $6c2d3fcab1c4415e$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $6c2d3fcab1c4415e$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $6c2d3fcab1c4415e$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($6c2d3fcab1c4415e$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $6c2d3fcab1c4415e$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $92a352d4f887d76d$export$2e2bcd8739ae039)((0, $92a352d4f887d76d$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}
module.exports["createStore"] = $6c2d3fcab1c4415e$export$f51a9068ac82ea43;
module.exports["combineReducers"] = $6c2d3fcab1c4415e$export$66e4520cdb265d18;
module.exports["compose"] = $6c2d3fcab1c4415e$export$f672e0b6f7222cd7;
module.exports["applyMiddleware"] = $6c2d3fcab1c4415e$export$9ff26e0402cc7b7;

});

parcelRegister("lIOgB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.denormalize = module.exports.normalize = module.exports.schema = undefined;
var $fd04b2f2e5df4bc0$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $fd04b2f2e5df4bc0$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var $kwHsV = parcelRequire("kwHsV");

var $fd04b2f2e5df4bc0$var$_Entity2 = $fd04b2f2e5df4bc0$var$_interopRequireDefault($kwHsV);

var $7SvvE = parcelRequire("7SvvE");

var $fd04b2f2e5df4bc0$var$_Union2 = $fd04b2f2e5df4bc0$var$_interopRequireDefault($7SvvE);

var $cVJRr = parcelRequire("cVJRr");

var $fd04b2f2e5df4bc0$var$_Values2 = $fd04b2f2e5df4bc0$var$_interopRequireDefault($cVJRr);

var $6GEE8 = parcelRequire("6GEE8");

var $fd04b2f2e5df4bc0$var$ArrayUtils = $fd04b2f2e5df4bc0$var$_interopRequireWildcard($6GEE8);

var $7jEGY = parcelRequire("7jEGY");

var $fd04b2f2e5df4bc0$var$ObjectUtils = $fd04b2f2e5df4bc0$var$_interopRequireWildcard($7jEGY);

var $jkp6O = parcelRequire("jkp6O");

var $fd04b2f2e5df4bc0$var$ImmutableUtils = $fd04b2f2e5df4bc0$var$_interopRequireWildcard($jkp6O);
function $fd04b2f2e5df4bc0$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $fd04b2f2e5df4bc0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fd04b2f2e5df4bc0$var$visit = function visit(value, parent, key, schema, addEntity) {
    if ((typeof value === 'undefined' ? 'undefined' : $fd04b2f2e5df4bc0$var$_typeof(value)) !== 'object' || !value) return value;
    if ((typeof schema === 'undefined' ? 'undefined' : $fd04b2f2e5df4bc0$var$_typeof(schema)) === 'object' && (!schema.normalize || typeof schema.normalize !== 'function')) {
        var method = Array.isArray(schema) ? $fd04b2f2e5df4bc0$var$ArrayUtils.normalize : $fd04b2f2e5df4bc0$var$ObjectUtils.normalize;
        return method(schema, value, parent, key, visit, addEntity);
    }
    return schema.normalize(value, parent, key, visit, addEntity);
};
var $fd04b2f2e5df4bc0$var$addEntities = function addEntities(entities) {
    return function(schema, processedEntity, value, parent, key) {
        var schemaKey = schema.key;
        var id = schema.getId(value, parent, key);
        if (!(schemaKey in entities)) entities[schemaKey] = {};
        var existingEntity = entities[schemaKey][id];
        if (existingEntity) entities[schemaKey][id] = schema.merge(existingEntity, processedEntity);
        else entities[schemaKey][id] = processedEntity;
    };
};
var $fd04b2f2e5df4bc0$var$schema = module.exports.schema = {
    Array: $fd04b2f2e5df4bc0$var$ArrayUtils.default,
    Entity: $fd04b2f2e5df4bc0$var$_Entity2.default,
    Object: $fd04b2f2e5df4bc0$var$ObjectUtils.default,
    Union: $fd04b2f2e5df4bc0$var$_Union2.default,
    Values: $fd04b2f2e5df4bc0$var$_Values2.default
};
var $fd04b2f2e5df4bc0$var$normalize = module.exports.normalize = function normalize(input, schema) {
    if (!input || (typeof input === 'undefined' ? 'undefined' : $fd04b2f2e5df4bc0$var$_typeof(input)) !== 'object') throw new Error('Unexpected input given to normalize. Expected type to be "object", found "' + (typeof input === 'undefined' ? 'undefined' : $fd04b2f2e5df4bc0$var$_typeof(input)) + '".');
    var entities = {};
    var addEntity = $fd04b2f2e5df4bc0$var$addEntities(entities);
    var result = $fd04b2f2e5df4bc0$var$visit(input, input, null, schema, addEntity);
    return {
        entities: entities,
        result: result
    };
};
var $fd04b2f2e5df4bc0$var$unvisitEntity = function unvisitEntity(id, schema, unvisit, getEntity, cache) {
    var entity = getEntity(id, schema);
    if ((typeof entity === 'undefined' ? 'undefined' : $fd04b2f2e5df4bc0$var$_typeof(entity)) !== 'object' || entity === null) return entity;
    if (!cache[schema.key]) cache[schema.key] = {};
    if (!cache[schema.key][id]) {
        // Ensure we don't mutate it non-immutable objects
        var entityCopy = $fd04b2f2e5df4bc0$var$ImmutableUtils.isImmutable(entity) ? entity : $fd04b2f2e5df4bc0$var$_extends({}, entity);
        // Need to set this first so that if it is referenced further within the
        // denormalization the reference will already exist.
        cache[schema.key][id] = entityCopy;
        cache[schema.key][id] = schema.denormalize(entityCopy, unvisit);
    }
    return cache[schema.key][id];
};
var $fd04b2f2e5df4bc0$var$getUnvisit = function getUnvisit(entities) {
    var cache = {};
    var getEntity = $fd04b2f2e5df4bc0$var$getEntities(entities);
    return function unvisit(input, schema) {
        if ((typeof schema === 'undefined' ? 'undefined' : $fd04b2f2e5df4bc0$var$_typeof(schema)) === 'object' && (!schema.denormalize || typeof schema.denormalize !== 'function')) {
            var method = Array.isArray(schema) ? $fd04b2f2e5df4bc0$var$ArrayUtils.denormalize : $fd04b2f2e5df4bc0$var$ObjectUtils.denormalize;
            return method(schema, input, unvisit);
        }
        if (input === undefined || input === null) return input;
        if (schema instanceof $fd04b2f2e5df4bc0$var$_Entity2.default) return $fd04b2f2e5df4bc0$var$unvisitEntity(input, schema, unvisit, getEntity, cache);
        return schema.denormalize(input, unvisit);
    };
};
var $fd04b2f2e5df4bc0$var$getEntities = function getEntities(entities) {
    var isImmutable = $fd04b2f2e5df4bc0$var$ImmutableUtils.isImmutable(entities);
    return function(entityOrId, schema) {
        var schemaKey = schema.key;
        if ((typeof entityOrId === 'undefined' ? 'undefined' : $fd04b2f2e5df4bc0$var$_typeof(entityOrId)) === 'object') return entityOrId;
        return isImmutable ? entities.getIn([
            schemaKey,
            entityOrId.toString()
        ]) : entities[schemaKey][entityOrId];
    };
};
var $fd04b2f2e5df4bc0$var$denormalize = module.exports.denormalize = function denormalize(input, schema, entities) {
    if (typeof input !== 'undefined') return $fd04b2f2e5df4bc0$var$getUnvisit(entities)(input, schema);
};

});

parcelRegister("5cBWV", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $3c9b82b99b8428ca$export$294b0449955347ad = Symbol('Call API');
function $3c9b82b99b8428ca$export$83aefcfe5d77bdc1(type, apiMethod, actionOptions) {
    return (options)=>({
            [$3c9b82b99b8428ca$export$294b0449955347ad]: {
                types: [
                    `${type}_REQUEST`,
                    `${type}_SUCCESS`,
                    `${type}_FAILURE`
                ],
                apiMethod: apiMethod,
                options: options,
                actionOptions: actionOptions
            }
        });
}
function $3c9b82b99b8428ca$export$69915ab5a7dce1ca(type) {
    return (options)=>({
            type: type,
            ...options
        });
}
function $3c9b82b99b8428ca$export$b914a335c72ca6b6(type, apiMethod, actionOptions) {
    return $3c9b82b99b8428ca$export$83aefcfe5d77bdc1(type, apiMethod, actionOptions);
}
function $3c9b82b99b8428ca$export$48f3ba85f13d91ae(type) {
    return $3c9b82b99b8428ca$export$69915ab5a7dce1ca(type);
}
module.exports["CALL_API"] = $3c9b82b99b8428ca$export$294b0449955347ad;
module.exports["restActionCreator"] = $3c9b82b99b8428ca$export$83aefcfe5d77bdc1;
module.exports["commonActionCreator"] = $3c9b82b99b8428ca$export$69915ab5a7dce1ca;

});

parcelRegister("6g1oe", function(module, exports) {
'use strict';
module.exports = typeof self === 'object' && self.self === self && self || typeof $parcel$global === 'object' && $parcel$global.global === $parcel$global && $parcel$global || module.exports;

});

parcelRegister("3P3UD", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $b4Wym = parcelRequire("b4Wym");


var $64Cib = parcelRequire("64Cib");

const $2c892b785fc45978$export$52f6ec48775979e3 = ()=>{
    const selectorCreator = (0, $b4Wym.createSelectorCreator)((0, $b4Wym.defaultMemoize), (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
    return selectorCreator((ids)=>ids, (ids, state)=>state.entities.get('spaces'), (ids, spaces)=>{
        if (!ids || !ids.size) return (0, $64Cib.Set)([]);
        return ids.map((id)=>id ? spaces.get(`${id}`) : null);
    });
};
const $2c892b785fc45978$export$f49532ceefece8fc = (0, $b4Wym.createSelector)((spaceKey)=>spaceKey, (spaceKey, state)=>state.entities.get('spaces'), (spaceKey, spaces)=>spaces.getIn([
        spaceKey,
        'homepageId'
    ], null));
const $2c892b785fc45978$export$1942ba3c2094e3ed = (0, $b4Wym.createSelector)([
    (state)=>state.entities.get('spaces'),
    (state, spaceKey)=>spaceKey
], (spaces, spaceKey)=>spaces.get(spaceKey, null));
module.exports["getSpaceInfoSelector"] = $2c892b785fc45978$export$1942ba3c2094e3ed;

});

parcelRegister("b4Wym", function(module, exports) {
$parcel$export(module.exports, "defaultMemoize", () => $810d7ce6f4fda362$export$281bff7f05488aa2, (v) => $810d7ce6f4fda362$export$281bff7f05488aa2 = v);
$parcel$export(module.exports, "createSelectorCreator", () => $810d7ce6f4fda362$export$5943f4447f6ef248, (v) => $810d7ce6f4fda362$export$5943f4447f6ef248 = v);
$parcel$export(module.exports, "createSelector", () => $810d7ce6f4fda362$export$595d22ed68ca2841, (v) => $810d7ce6f4fda362$export$595d22ed68ca2841 = v);
var $810d7ce6f4fda362$export$1e511d4a378977f5;
var $810d7ce6f4fda362$export$281bff7f05488aa2;
var $810d7ce6f4fda362$export$5943f4447f6ef248;
var $810d7ce6f4fda362$export$595d22ed68ca2841;
var $810d7ce6f4fda362$export$75979cfcd91bf38f;
'use strict';
$810d7ce6f4fda362$export$1e511d4a378977f5 = true;
$810d7ce6f4fda362$export$281bff7f05488aa2 = $810d7ce6f4fda362$var$defaultMemoize;
$810d7ce6f4fda362$export$5943f4447f6ef248 = $810d7ce6f4fda362$var$createSelectorCreator;
$810d7ce6f4fda362$export$595d22ed68ca2841 = $810d7ce6f4fda362$var$createSelector;
$810d7ce6f4fda362$export$75979cfcd91bf38f = $810d7ce6f4fda362$var$createStructuredSelector;
function $810d7ce6f4fda362$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function $810d7ce6f4fda362$var$defaultEqualityCheck(a, b) {
    return a === b;
}
function $810d7ce6f4fda362$var$defaultMemoize(func) {
    var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? $810d7ce6f4fda362$var$defaultEqualityCheck : arguments[1];
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (lastArgs !== null && lastArgs.length === args.length && args.every(function(value, index) {
            return equalityCheck(value, lastArgs[index]);
        })) return lastResult;
        lastArgs = args;
        lastResult = func.apply(undefined, args);
        return lastResult;
    };
}
function $810d7ce6f4fda362$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(', ');
        throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }
    return dependencies;
}
function $810d7ce6f4fda362$var$createSelectorCreator(memoize) {
    for(var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)memoizeOptions[_key2 - 1] = arguments[_key2];
    return function() {
        for(var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)funcs[_key3] = arguments[_key3];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = $810d7ce6f4fda362$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                return resultFunc.apply(undefined, arguments);
            }
        ].concat(memoizeOptions));
        var selector = function selector(state, props) {
            for(var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++)args[_key4 - 2] = arguments[_key4];
            var params = dependencies.map(function(dependency) {
                return dependency.apply(undefined, [
                    state,
                    props
                ].concat(args));
            });
            return memoizedResultFunc.apply(undefined, $810d7ce6f4fda362$var$_toConsumableArray(params));
        };
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
function $810d7ce6f4fda362$var$createSelector() {
    return $810d7ce6f4fda362$var$createSelectorCreator($810d7ce6f4fda362$var$defaultMemoize).apply(undefined, arguments);
}
function $810d7ce6f4fda362$var$createStructuredSelector(selectors) {
    var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? $810d7ce6f4fda362$var$createSelector : arguments[1];
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++)values[_key5] = arguments[_key5];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}

});

parcelRegister("64Cib", function(module, exports) {
/**
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var DELETE = 'delete';
// Constants describing the size of trie nodes.
var SHIFT = 5; // Resulted in best performance after ______?
var SIZE = 1 << SHIFT;
var MASK = SIZE - 1;
// A consistent shared value representing "not set" which equals nothing other
// than itself, and nothing that could be provided externally.
var NOT_SET = {};
// Boolean references, Rough equivalent of `bool &`.
function MakeRef() {
    return {
        value: false
    };
}
function SetRef(ref) {
    if (ref) ref.value = true;
}
// A function which returns a value representing an "owner" for transient writes
// to tries. The return value will only ever equal itself, and will not equal
// the return of any subsequent call of this function.
function OwnerID() {}
function ensureSize(iter) {
    if (iter.size === undefined) iter.size = iter.__iterate(returnTrue);
    return iter.size;
}
function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
        var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
        if ('' + uint32Index !== index || uint32Index === 4294967295) return NaN;
        index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
}
function returnTrue() {
    return true;
}
function wholeSlice(begin, end, size) {
    return (begin === 0 && !isNeg(begin) || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
}
function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
}
function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
}
function resolveIndex(index, size, defaultIndex) {
    // Sanitize indices using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    return index === undefined ? defaultIndex : isNeg(index) ? size === Infinity ? size : Math.max(0, size + index) | 0 : size === undefined || size === index ? index : Math.min(size, index) | 0;
}
function isNeg(value) {
    // Account for -0 which is negative, but not less than 0.
    return value < 0 || value === 0 && 1 / value === -Infinity;
}
var IS_COLLECTION_SYMBOL = '@@__IMMUTABLE_ITERABLE__@@';
function isCollection(maybeCollection) {
    return Boolean(maybeCollection && maybeCollection[IS_COLLECTION_SYMBOL]);
}
var IS_KEYED_SYMBOL = '@@__IMMUTABLE_KEYED__@@';
function isKeyed(maybeKeyed) {
    return Boolean(maybeKeyed && maybeKeyed[IS_KEYED_SYMBOL]);
}
var IS_INDEXED_SYMBOL = '@@__IMMUTABLE_INDEXED__@@';
function isIndexed(maybeIndexed) {
    return Boolean(maybeIndexed && maybeIndexed[IS_INDEXED_SYMBOL]);
}
function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
}
var Collection = function Collection(value) {
    // eslint-disable-next-line no-constructor-return
    return isCollection(value) ? value : Seq(value);
};
var KeyedCollection = /*@__PURE__*/ function(Collection) {
    function KeyedCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isKeyed(value) ? value : KeyedSeq(value);
    }
    if (Collection) KeyedCollection.__proto__ = Collection;
    KeyedCollection.prototype = Object.create(Collection && Collection.prototype);
    KeyedCollection.prototype.constructor = KeyedCollection;
    return KeyedCollection;
}(Collection);
var IndexedCollection = /*@__PURE__*/ function(Collection) {
    function IndexedCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isIndexed(value) ? value : IndexedSeq(value);
    }
    if (Collection) IndexedCollection.__proto__ = Collection;
    IndexedCollection.prototype = Object.create(Collection && Collection.prototype);
    IndexedCollection.prototype.constructor = IndexedCollection;
    return IndexedCollection;
}(Collection);
var SetCollection = /*@__PURE__*/ function(Collection) {
    function SetCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isCollection(value) && !isAssociative(value) ? value : SetSeq(value);
    }
    if (Collection) SetCollection.__proto__ = Collection;
    SetCollection.prototype = Object.create(Collection && Collection.prototype);
    SetCollection.prototype.constructor = SetCollection;
    return SetCollection;
}(Collection);
Collection.Keyed = KeyedCollection;
Collection.Indexed = IndexedCollection;
Collection.Set = SetCollection;
var IS_SEQ_SYMBOL = '@@__IMMUTABLE_SEQ__@@';
function isSeq(maybeSeq) {
    return Boolean(maybeSeq && maybeSeq[IS_SEQ_SYMBOL]);
}
var IS_RECORD_SYMBOL = '@@__IMMUTABLE_RECORD__@@';
function isRecord(maybeRecord) {
    return Boolean(maybeRecord && maybeRecord[IS_RECORD_SYMBOL]);
}
function isImmutable(maybeImmutable) {
    return isCollection(maybeImmutable) || isRecord(maybeImmutable);
}
var IS_ORDERED_SYMBOL = '@@__IMMUTABLE_ORDERED__@@';
function isOrdered(maybeOrdered) {
    return Boolean(maybeOrdered && maybeOrdered[IS_ORDERED_SYMBOL]);
}
var ITERATE_KEYS = 0;
var ITERATE_VALUES = 1;
var ITERATE_ENTRIES = 2;
var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
var Iterator = function Iterator(next) {
    this.next = next;
};
Iterator.prototype.toString = function toString() {
    return '[Iterator]';
};
Iterator.KEYS = ITERATE_KEYS;
Iterator.VALUES = ITERATE_VALUES;
Iterator.ENTRIES = ITERATE_ENTRIES;
Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
    return this.toString();
};
Iterator.prototype[ITERATOR_SYMBOL] = function() {
    return this;
};
function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [
        k,
        v
    ];
    iteratorResult ? iteratorResult.value = value : iteratorResult = {
        value: value,
        done: false
    };
    return iteratorResult;
}
function iteratorDone() {
    return {
        value: undefined,
        done: true
    };
}
function hasIterator(maybeIterable) {
    if (Array.isArray(maybeIterable)) // IE11 trick as it does not support `Symbol.iterator`
    return true;
    return !!getIteratorFn(maybeIterable);
}
function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
}
function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
}
function getIteratorFn(iterable) {
    var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') return iteratorFn;
}
function isEntriesIterable(maybeIterable) {
    var iteratorFn = getIteratorFn(maybeIterable);
    return iteratorFn && iteratorFn === maybeIterable.entries;
}
function isKeysIterable(maybeIterable) {
    var iteratorFn = getIteratorFn(maybeIterable);
    return iteratorFn && iteratorFn === maybeIterable.keys;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isArrayLike(value) {
    if (Array.isArray(value) || typeof value === 'string') return true;
    return value && typeof value === 'object' && Number.isInteger(value.length) && value.length >= 0 && (value.length === 0 ? Object.keys(value).length === 1 : // in the array-like may be found (which could be undefined).
    value.hasOwnProperty(value.length - 1));
}
var Seq = /*@__PURE__*/ function(Collection) {
    function Seq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence() : isImmutable(value) ? value.toSeq() : seqFromValue(value);
    }
    if (Collection) Seq.__proto__ = Collection;
    Seq.prototype = Object.create(Collection && Collection.prototype);
    Seq.prototype.constructor = Seq;
    Seq.prototype.toSeq = function toSeq() {
        return this;
    };
    Seq.prototype.toString = function toString() {
        return this.__toString('Seq {', '}');
    };
    Seq.prototype.cacheResult = function cacheResult() {
        if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
        }
        return this;
    };
    // abstract __iterateUncached(fn, reverse)
    Seq.prototype.__iterate = function __iterate(fn, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            while(i !== size){
                var entry = cache[reverse ? size - ++i : i++];
                if (fn(entry[1], entry[0], this) === false) break;
            }
            return i;
        }
        return this.__iterateUncached(fn, reverse);
    };
    // abstract __iteratorUncached(type, reverse)
    Seq.prototype.__iterator = function __iterator(type, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            return new Iterator(function() {
                if (i === size) return iteratorDone();
                var entry = cache[reverse ? size - ++i : i++];
                return iteratorValue(type, entry[0], entry[1]);
            });
        }
        return this.__iteratorUncached(type, reverse);
    };
    return Seq;
}(Collection);
var KeyedSeq = /*@__PURE__*/ function(Seq) {
    function KeyedSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence().toKeyedSeq() : isCollection(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : isRecord(value) ? value.toSeq() : keyedSeqFromValue(value);
    }
    if (Seq) KeyedSeq.__proto__ = Seq;
    KeyedSeq.prototype = Object.create(Seq && Seq.prototype);
    KeyedSeq.prototype.constructor = KeyedSeq;
    KeyedSeq.prototype.toKeyedSeq = function toKeyedSeq() {
        return this;
    };
    return KeyedSeq;
}(Seq);
var IndexedSeq = /*@__PURE__*/ function(Seq) {
    function IndexedSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence() : isCollection(value) ? isKeyed(value) ? value.entrySeq() : value.toIndexedSeq() : isRecord(value) ? value.toSeq().entrySeq() : indexedSeqFromValue(value);
    }
    if (Seq) IndexedSeq.__proto__ = Seq;
    IndexedSeq.prototype = Object.create(Seq && Seq.prototype);
    IndexedSeq.prototype.constructor = IndexedSeq;
    IndexedSeq.of = function of() {
        return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function toIndexedSeq() {
        return this;
    };
    IndexedSeq.prototype.toString = function toString() {
        return this.__toString('Seq [', ']');
    };
    return IndexedSeq;
}(Seq);
var SetSeq = /*@__PURE__*/ function(Seq) {
    function SetSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return (isCollection(value) && !isAssociative(value) ? value : IndexedSeq(value)).toSetSeq();
    }
    if (Seq) SetSeq.__proto__ = Seq;
    SetSeq.prototype = Object.create(Seq && Seq.prototype);
    SetSeq.prototype.constructor = SetSeq;
    SetSeq.of = function of() {
        return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function toSetSeq() {
        return this;
    };
    return SetSeq;
}(Seq);
Seq.isSeq = isSeq;
Seq.Keyed = KeyedSeq;
Seq.Set = SetSeq;
Seq.Indexed = IndexedSeq;
Seq.prototype[IS_SEQ_SYMBOL] = true;
// #pragma Root Sequences
var ArraySeq = /*@__PURE__*/ function(IndexedSeq) {
    function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
    }
    if (IndexedSeq) ArraySeq.__proto__ = IndexedSeq;
    ArraySeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ArraySeq.prototype.constructor = ArraySeq;
    ArraySeq.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function __iterate(fn, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        while(i !== size){
            var ii = reverse ? size - ++i : i++;
            if (fn(array[ii], ii, this) === false) break;
        }
        return i;
    };
    ArraySeq.prototype.__iterator = function __iterator(type, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var ii = reverse ? size - ++i : i++;
            return iteratorValue(type, ii, array[ii]);
        });
    };
    return ArraySeq;
}(IndexedSeq);
var ObjectSeq = /*@__PURE__*/ function(KeyedSeq) {
    function ObjectSeq(object) {
        var keys = Object.keys(object).concat(Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(object) : []);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
    }
    if (KeyedSeq) ObjectSeq.__proto__ = KeyedSeq;
    ObjectSeq.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ObjectSeq.prototype.constructor = ObjectSeq;
    ObjectSeq.prototype.get = function get(key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) return notSetValue;
        return this._object[key];
    };
    ObjectSeq.prototype.has = function has(key) {
        return hasOwnProperty.call(this._object, key);
    };
    ObjectSeq.prototype.__iterate = function __iterate(fn, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        while(i !== size){
            var key = keys[reverse ? size - ++i : i++];
            if (fn(object[key], key, this) === false) break;
        }
        return i;
    };
    ObjectSeq.prototype.__iterator = function __iterator(type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var key = keys[reverse ? size - ++i : i++];
            return iteratorValue(type, key, object[key]);
        });
    };
    return ObjectSeq;
}(KeyedSeq);
ObjectSeq.prototype[IS_ORDERED_SYMBOL] = true;
var CollectionSeq = /*@__PURE__*/ function(IndexedSeq) {
    function CollectionSeq(collection) {
        this._collection = collection;
        this.size = collection.length || collection.size;
    }
    if (IndexedSeq) CollectionSeq.__proto__ = IndexedSeq;
    CollectionSeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    CollectionSeq.prototype.constructor = CollectionSeq;
    CollectionSeq.prototype.__iterateUncached = function __iterateUncached(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        var iterations = 0;
        if (isIterator(iterator)) {
            var step;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
        }
        return iterations;
    };
    CollectionSeq.prototype.__iteratorUncached = function __iteratorUncached(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        if (!isIterator(iterator)) return new Iterator(iteratorDone);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value);
        });
    };
    return CollectionSeq;
}(IndexedSeq);
// # pragma Helper functions
var EMPTY_SEQ;
function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
}
function keyedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq.fromEntrySeq();
    if (typeof value === 'object') return new ObjectSeq(value);
    throw new TypeError('Expected Array or collection object of [k, v] entries, or keyed object: ' + value);
}
function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq;
    throw new TypeError('Expected Array or collection object of values: ' + value);
}
function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return isEntriesIterable(value) ? seq.fromEntrySeq() : isKeysIterable(value) ? seq.toSetSeq() : seq;
    if (typeof value === 'object') return new ObjectSeq(value);
    throw new TypeError('Expected Array or collection object of values, or keyed object: ' + value);
}
function maybeIndexedSeqFromValue(value) {
    return isArrayLike(value) ? new ArraySeq(value) : hasIterator(value) ? new CollectionSeq(value) : undefined;
}
var IS_MAP_SYMBOL = '@@__IMMUTABLE_MAP__@@';
function isMap(maybeMap) {
    return Boolean(maybeMap && maybeMap[IS_MAP_SYMBOL]);
}
function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
}
function isValueObject(maybeValue) {
    return Boolean(maybeValue && typeof maybeValue.equals === 'function' && typeof maybeValue.hashCode === 'function');
}
/**
 * An extension of the "same-value" algorithm as [described for use by ES6 Map
 * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
 *
 * NaN is considered the same as NaN, however -0 and 0 are considered the same
 * value, which is different from the algorithm described by
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
 *
 * This is extended further to allow Objects to describe the values they
 * represent, by way of `valueOf` or `equals` (and `hashCode`).
 *
 * Note: because of this extension, the key equality of Immutable.Map and the
 * value equality of Immutable.Set will differ from ES6 Map and Set.
 *
 * ### Defining custom values
 *
 * The easiest way to describe the value an object represents is by implementing
 * `valueOf`. For example, `Date` represents a value by returning a unix
 * timestamp for `valueOf`:
 *
 *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
 *     var date2 = new Date(1234567890000);
 *     date1.valueOf(); // 1234567890000
 *     assert( date1 !== date2 );
 *     assert( Immutable.is( date1, date2 ) );
 *
 * Note: overriding `valueOf` may have other implications if you use this object
 * where JavaScript expects a primitive, such as implicit string coercion.
 *
 * For more complex types, especially collections, implementing `valueOf` may
 * not be performant. An alternative is to implement `equals` and `hashCode`.
 *
 * `equals` takes another object, presumably of similar type, and returns true
 * if it is equal. Equality is symmetrical, so the same result should be
 * returned if this and the argument are flipped.
 *
 *     assert( a.equals(b) === b.equals(a) );
 *
 * `hashCode` returns a 32bit integer number representing the object which will
 * be used to determine how to store the value object in a Map or Set. You must
 * provide both or neither methods, one must not exist without the other.
 *
 * Also, an important relationship between these methods must be upheld: if two
 * values are equal, they *must* return the same hashCode. If the values are not
 * equal, they might have the same hashCode; this is called a hash collision,
 * and while undesirable for performance reasons, it is acceptable.
 *
 *     if (a.equals(b)) {
 *       assert( a.hashCode() === b.hashCode() );
 *     }
 *
 * All Immutable collections are Value Objects: they implement `equals()`
 * and `hashCode()`.
 */ function is(valueA, valueB) {
    if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
    if (!valueA || !valueB) return false;
    if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
        valueA = valueA.valueOf();
        valueB = valueB.valueOf();
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
        if (!valueA || !valueB) return false;
    }
    return !!(isValueObject(valueA) && isValueObject(valueB) && valueA.equals(valueB));
}
var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
    a |= 0; // int
    b |= 0; // int
    var c = a & 0xffff;
    var d = b & 0xffff;
    // Shift by 0 fixes the sign on the high part.
    return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
};
// v8 has an optimization for storing 31-bit signed numbers.
// Values which have either 00 or 11 as the high order bits qualify.
// This function drops the highest order bit in a signed number, maintaining
// the sign bit.
function smi(i32) {
    return i32 >>> 1 & 0x40000000 | i32 & 0xbfffffff;
}
var defaultValueOf = Object.prototype.valueOf;
function hash(o) {
    if (o == null) return hashNullish(o);
    if (typeof o.hashCode === 'function') // Drop any high bits from accidentally long hash codes.
    return smi(o.hashCode(o));
    var v = valueOf(o);
    if (v == null) return hashNullish(v);
    switch(typeof v){
        case 'boolean':
            // The hash values for built-in constants are a 1 value for each 5-byte
            // shift region expect for the first, which encodes the value. This
            // reduces the odds of a hash collision for these common values.
            return v ? 0x42108421 : 0x42108420;
        case 'number':
            return hashNumber(v);
        case 'string':
            return v.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(v) : hashString(v);
        case 'object':
        case 'function':
            return hashJSObj(v);
        case 'symbol':
            return hashSymbol(v);
        default:
            if (typeof v.toString === 'function') return hashString(v.toString());
            throw new Error('Value type ' + typeof v + ' cannot be hashed.');
    }
}
function hashNullish(nullish) {
    return nullish === null ? 0x42108422 : /* undefined */ 0x42108423;
}
// Compress arbitrarily large numbers into smi hashes.
function hashNumber(n) {
    if (n !== n || n === Infinity) return 0;
    var hash = n | 0;
    if (hash !== n) hash ^= n * 0xffffffff;
    while(n > 0xffffffff){
        n /= 0xffffffff;
        hash ^= n;
    }
    return smi(hash);
}
function cachedHashString(string) {
    var hashed = stringHashCache[string];
    if (hashed === undefined) {
        hashed = hashString(string);
        if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
            STRING_HASH_CACHE_SIZE = 0;
            stringHashCache = {};
        }
        STRING_HASH_CACHE_SIZE++;
        stringHashCache[string] = hashed;
    }
    return hashed;
}
// http://jsperf.com/hashing-strings
function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hashed = 0;
    for(var ii = 0; ii < string.length; ii++)hashed = 31 * hashed + string.charCodeAt(ii) | 0;
    return smi(hashed);
}
function hashSymbol(sym) {
    var hashed = symbolMap[sym];
    if (hashed !== undefined) return hashed;
    hashed = nextHash();
    symbolMap[sym] = hashed;
    return hashed;
}
function hashJSObj(obj) {
    var hashed;
    if (usingWeakMap) {
        hashed = weakMap.get(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = obj[UID_HASH_KEY];
    if (hashed !== undefined) return hashed;
    if (!canDefineProperty) {
        hashed = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
        if (hashed !== undefined) return hashed;
        hashed = getIENodeHash(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = nextHash();
    if (usingWeakMap) weakMap.set(obj, hashed);
    else if (isExtensible !== undefined && isExtensible(obj) === false) throw new Error('Non-extensible objects are not allowed as keys.');
    else if (canDefineProperty) Object.defineProperty(obj, UID_HASH_KEY, {
        enumerable: false,
        configurable: false,
        writable: false,
        value: hashed
    });
    else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
        // Since we can't define a non-enumerable property on the object
        // we'll hijack one of the less-used non-enumerable properties to
        // save our hash on it. Since this is a function it will not show up in
        // `JSON.stringify` which is what we want.
        obj.propertyIsEnumerable = function() {
            return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
        };
        obj.propertyIsEnumerable[UID_HASH_KEY] = hashed;
    } else if (obj.nodeType !== undefined) // At this point we couldn't get the IE `uniqueID` to use as a hash
    // and we couldn't use a non-enumerable property to exploit the
    // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
    // itself.
    obj[UID_HASH_KEY] = hashed;
    else throw new Error('Unable to set a non-enumerable property on object.');
    return hashed;
}
// Get references to ES5 object methods.
var isExtensible = Object.isExtensible;
// True if Object.defineProperty works as expected. IE8 fails this test.
var canDefineProperty = function() {
    try {
        Object.defineProperty({}, '@', {});
        return true;
    } catch (e) {
        return false;
    }
}();
// IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
// and avoid memory leaks from the IE cloneNode bug.
function getIENodeHash(node) {
    if (node && node.nodeType > 0) switch(node.nodeType){
        case 1:
            return node.uniqueID;
        case 9:
            return node.documentElement && node.documentElement.uniqueID;
    }
}
function valueOf(obj) {
    return obj.valueOf !== defaultValueOf && typeof obj.valueOf === 'function' ? obj.valueOf(obj) : obj;
}
function nextHash() {
    var nextHash = ++_objHashUID;
    if (_objHashUID & 0x40000000) _objHashUID = 0;
    return nextHash;
}
// If possible, use a WeakMap.
var usingWeakMap = typeof WeakMap === 'function';
var weakMap;
if (usingWeakMap) weakMap = new WeakMap();
var symbolMap = Object.create(null);
var _objHashUID = 0;
var UID_HASH_KEY = '__immutablehash__';
if (typeof Symbol === 'function') UID_HASH_KEY = Symbol(UID_HASH_KEY);
var STRING_HASH_CACHE_MIN_STRLEN = 16;
var STRING_HASH_CACHE_MAX_SIZE = 255;
var STRING_HASH_CACHE_SIZE = 0;
var stringHashCache = {};
var ToKeyedSequence = /*@__PURE__*/ function(KeyedSeq) {
    function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
    }
    if (KeyedSeq) ToKeyedSequence.__proto__ = KeyedSeq;
    ToKeyedSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ToKeyedSequence.prototype.constructor = ToKeyedSequence;
    ToKeyedSequence.prototype.get = function get(key, notSetValue) {
        return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function has(key) {
        return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function valueSeq() {
        return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function reverse() {
        var this$1$1 = this;
        var reversedSequence = reverseFactory(this, true);
        if (!this._useKeys) reversedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().reverse();
        };
        return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        var mappedSequence = mapFactory(this, mapper, context);
        if (!this._useKeys) mappedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().map(mapper, context);
        };
        return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
    };
    ToKeyedSequence.prototype.__iterator = function __iterator(type, reverse) {
        return this._iter.__iterator(type, reverse);
    };
    return ToKeyedSequence;
}(KeyedSeq);
ToKeyedSequence.prototype[IS_ORDERED_SYMBOL] = true;
var ToIndexedSequence = /*@__PURE__*/ function(IndexedSeq) {
    function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (IndexedSeq) ToIndexedSequence.__proto__ = IndexedSeq;
    ToIndexedSequence.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ToIndexedSequence.prototype.constructor = ToIndexedSequence;
    ToIndexedSequence.prototype.includes = function includes(value) {
        return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        reverse && ensureSize(this);
        return this._iter.__iterate(function(v) {
            return fn(v, reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var i = 0;
        reverse && ensureSize(this);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, reverse ? this$1$1.size - ++i : i++, step.value, step);
        });
    };
    return ToIndexedSequence;
}(IndexedSeq);
var ToSetSequence = /*@__PURE__*/ function(SetSeq) {
    function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (SetSeq) ToSetSequence.__proto__ = SetSeq;
    ToSetSequence.prototype = Object.create(SetSeq && SetSeq.prototype);
    ToSetSequence.prototype.constructor = ToSetSequence;
    ToSetSequence.prototype.has = function has(key) {
        return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v) {
            return fn(v, v, this$1$1);
        }, reverse);
    };
    ToSetSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, step.value, step.value, step);
        });
    };
    return ToSetSequence;
}(SetSeq);
var FromEntriesSequence = /*@__PURE__*/ function(KeyedSeq) {
    function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
    }
    if (KeyedSeq) FromEntriesSequence.__proto__ = KeyedSeq;
    FromEntriesSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    FromEntriesSequence.prototype.constructor = FromEntriesSequence;
    FromEntriesSequence.prototype.entrySeq = function entrySeq() {
        return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
                validateEntry(entry);
                var indexedCollection = isCollection(entry);
                return fn(indexedCollection ? entry.get(1) : entry[1], indexedCollection ? entry.get(0) : entry[0], this$1$1);
            }
        }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    validateEntry(entry);
                    var indexedCollection = isCollection(entry);
                    return iteratorValue(type, indexedCollection ? entry.get(0) : entry[0], indexedCollection ? entry.get(1) : entry[1], step);
                }
            }
        });
    };
    return FromEntriesSequence;
}(KeyedSeq);
ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
function flipFactory(collection) {
    var flipSequence = makeSequence(collection);
    flipSequence._iter = collection;
    flipSequence.size = collection.size;
    flipSequence.flip = function() {
        return collection;
    };
    flipSequence.reverse = function() {
        var reversedSequence = collection.reverse.apply(this); // super.reverse()
        reversedSequence.flip = function() {
            return collection.reverse();
        };
        return reversedSequence;
    };
    flipSequence.has = function(key) {
        return collection.includes(key);
    };
    flipSequence.includes = function(key) {
        return collection.has(key);
    };
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k) {
            return fn(k, v, this$1$1) !== false;
        }, reverse);
    };
    flipSequence.__iteratorUncached = function(type, reverse) {
        if (type === ITERATE_ENTRIES) {
            var iterator = collection.__iterator(type, reverse);
            return new Iterator(function() {
                var step = iterator.next();
                if (!step.done) {
                    var k = step.value[0];
                    step.value[0] = step.value[1];
                    step.value[1] = k;
                }
                return step;
            });
        }
        return collection.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
    };
    return flipSequence;
}
function mapFactory(collection, mapper, context) {
    var mappedSequence = makeSequence(collection);
    mappedSequence.size = collection.size;
    mappedSequence.has = function(key) {
        return collection.has(key);
    };
    mappedSequence.get = function(key, notSetValue) {
        var v = collection.get(key, NOT_SET);
        return v === NOT_SET ? notSetValue : mapper.call(context, v, key, collection);
    };
    mappedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k, c) {
            return fn(mapper.call(context, v, k, c), k, this$1$1) !== false;
        }, reverse);
    };
    mappedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var key = entry[0];
            return iteratorValue(type, key, mapper.call(context, entry[1], key, collection), step);
        });
    };
    return mappedSequence;
}
function reverseFactory(collection, useKeys) {
    var this$1$1 = this;
    var reversedSequence = makeSequence(collection);
    reversedSequence._iter = collection;
    reversedSequence.size = collection.size;
    reversedSequence.reverse = function() {
        return collection;
    };
    if (collection.flip) reversedSequence.flip = function() {
        var flipSequence = flipFactory(collection);
        flipSequence.reverse = function() {
            return collection.flip();
        };
        return flipSequence;
    };
    reversedSequence.get = function(key, notSetValue) {
        return collection.get(useKeys ? key : -1 - key, notSetValue);
    };
    reversedSequence.has = function(key) {
        return collection.has(useKeys ? key : -1 - key);
    };
    reversedSequence.includes = function(value) {
        return collection.includes(value);
    };
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        reverse && ensureSize(collection);
        return collection.__iterate(function(v, k) {
            return fn(v, useKeys ? k : reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, !reverse);
    };
    reversedSequence.__iterator = function(type, reverse) {
        var i = 0;
        reverse && ensureSize(collection);
        var iterator = collection.__iterator(ITERATE_ENTRIES, !reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            return iteratorValue(type, useKeys ? entry[0] : reverse ? this$1$1.size - ++i : i++, entry[1], step);
        });
    };
    return reversedSequence;
}
function filterFactory(collection, predicate, context, useKeys) {
    var filterSequence = makeSequence(collection);
    if (useKeys) {
        filterSequence.has = function(key) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && !!predicate.call(context, v, key, collection);
        };
        filterSequence.get = function(key, notSetValue) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && predicate.call(context, v, key, collection) ? v : notSetValue;
        };
    }
    filterSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        }, reverse);
        return iterations;
    };
    filterSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterations = 0;
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var key = entry[0];
                var value = entry[1];
                if (predicate.call(context, value, key, collection)) return iteratorValue(type, useKeys ? key : iterations++, value, step);
            }
        });
    };
    return filterSequence;
}
function countByFactory(collection, grouper, context) {
    var groups = Map().asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), 0, function(a) {
            return a + 1;
        });
    });
    return groups.asImmutable();
}
function groupByFactory(collection, grouper, context) {
    var isKeyedIter = isKeyed(collection);
    var groups = (isOrdered(collection) ? OrderedMap() : Map()).asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), function(a) {
            return a = a || [], a.push(isKeyedIter ? [
                k,
                v
            ] : v), a;
        });
    });
    var coerce = collectionClass(collection);
    return groups.map(function(arr) {
        return reify(collection, coerce(arr));
    }).asImmutable();
}
function partitionFactory(collection, predicate, context) {
    var isKeyedIter = isKeyed(collection);
    var groups = [
        [],
        []
    ];
    collection.__iterate(function(v, k) {
        groups[predicate.call(context, v, k, collection) ? 1 : 0].push(isKeyedIter ? [
            k,
            v
        ] : v);
    });
    var coerce = collectionClass(collection);
    return groups.map(function(arr) {
        return reify(collection, coerce(arr));
    });
}
function sliceFactory(collection, begin, end, useKeys) {
    var originalSize = collection.size;
    if (wholeSlice(begin, end, originalSize)) return collection;
    // begin or end can not be resolved if they were provided as negative numbers and
    // this collection's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (typeof originalSize === 'undefined' && (begin < 0 || end < 0)) return sliceFactory(collection.toSeq().cacheResult(), begin, end, useKeys);
    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);
    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    var sliceSeq = makeSequence(collection);
    // If collection.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : collection.size && sliceSize || undefined;
    if (!useKeys && isSeq(collection) && sliceSize >= 0) sliceSeq.get = function(index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ? collection.get(index + resolvedBegin, notSetValue) : notSetValue;
    };
    sliceSeq.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (sliceSize === 0) return 0;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var skipped = 0;
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k) {
            if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1) !== false && iterations !== sliceSize;
            }
        });
        return iterations;
    };
    sliceSeq.__iteratorUncached = function(type, reverse) {
        if (sliceSize !== 0 && reverse) return this.cacheResult().__iterator(type, reverse);
        // Don't bother instantiating parent iterator if taking 0.
        if (sliceSize === 0) return new Iterator(iteratorDone);
        var iterator = collection.__iterator(type, reverse);
        var skipped = 0;
        var iterations = 0;
        return new Iterator(function() {
            while(skipped++ < resolvedBegin)iterator.next();
            if (++iterations > sliceSize) return iteratorDone();
            var step = iterator.next();
            if (useKeys || type === ITERATE_VALUES || step.done) return step;
            if (type === ITERATE_KEYS) return iteratorValue(type, iterations - 1, undefined, step);
            return iteratorValue(type, iterations - 1, step.value[1], step);
        });
    };
    return sliceSeq;
}
function takeWhileFactory(collection, predicate, context) {
    var takeSequence = makeSequence(collection);
    takeSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$1$1);
        });
        return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterating = true;
        return new Iterator(function() {
            if (!iterating) return iteratorDone();
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var k = entry[0];
            var v = entry[1];
            if (!predicate.call(context, v, k, this$1$1)) {
                iterating = false;
                return iteratorDone();
            }
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return takeSequence;
}
function skipWhileFactory(collection, predicate, context, useKeys) {
    var skipSequence = makeSequence(collection);
    skipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        });
        return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var skipping = true;
        var iterations = 0;
        return new Iterator(function() {
            var step;
            var k;
            var v;
            do {
                step = iterator.next();
                if (step.done) {
                    if (useKeys || type === ITERATE_VALUES) return step;
                    if (type === ITERATE_KEYS) return iteratorValue(type, iterations++, undefined, step);
                    return iteratorValue(type, iterations++, step.value[1], step);
                }
                var entry = step.value;
                k = entry[0];
                v = entry[1];
                skipping && (skipping = predicate.call(context, v, k, this$1$1));
            }while (skipping);
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return skipSequence;
}
function concatFactory(collection, values) {
    var isKeyedCollection = isKeyed(collection);
    var iters = [
        collection
    ].concat(values).map(function(v) {
        if (!isCollection(v)) v = isKeyedCollection ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [
            v
        ]);
        else if (isKeyedCollection) v = KeyedCollection(v);
        return v;
    }).filter(function(v) {
        return v.size !== 0;
    });
    if (iters.length === 0) return collection;
    if (iters.length === 1) {
        var singleton = iters[0];
        if (singleton === collection || isKeyedCollection && isKeyed(singleton) || isIndexed(collection) && isIndexed(singleton)) return singleton;
    }
    var concatSeq = new ArraySeq(iters);
    if (isKeyedCollection) concatSeq = concatSeq.toKeyedSeq();
    else if (!isIndexed(collection)) concatSeq = concatSeq.toSetSeq();
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(function(sum, seq) {
        if (sum !== undefined) {
            var size = seq.size;
            if (size !== undefined) return sum + size;
        }
    }, 0);
    return concatSeq;
}
function flattenFactory(collection, depth, useKeys) {
    var flatSequence = makeSequence(collection);
    flatSequence.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        var stopped = false;
        function flatDeep(iter, currentDepth) {
            iter.__iterate(function(v, k) {
                if ((!depth || currentDepth < depth) && isCollection(v)) flatDeep(v, currentDepth + 1);
                else {
                    iterations++;
                    if (fn(v, useKeys ? k : iterations - 1, flatSequence) === false) stopped = true;
                }
                return !stopped;
            }, reverse);
        }
        flatDeep(collection, 0);
        return iterations;
    };
    flatSequence.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(type, reverse);
        var stack = [];
        var iterations = 0;
        return new Iterator(function() {
            while(iterator){
                var step = iterator.next();
                if (step.done !== false) {
                    iterator = stack.pop();
                    continue;
                }
                var v = step.value;
                if (type === ITERATE_ENTRIES) v = v[1];
                if ((!depth || stack.length < depth) && isCollection(v)) {
                    stack.push(iterator);
                    iterator = v.__iterator(type, reverse);
                } else return useKeys ? step : iteratorValue(type, iterations++, v, step);
            }
            return iteratorDone();
        });
    };
    return flatSequence;
}
function flatMapFactory(collection, mapper, context) {
    var coerce = collectionClass(collection);
    return collection.toSeq().map(function(v, k) {
        return coerce(mapper.call(context, v, k, collection));
    }).flatten(true);
}
function interposeFactory(collection, separator) {
    var interposedSequence = makeSequence(collection);
    interposedSequence.size = collection.size && collection.size * 2 - 1;
    interposedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v) {
            return (!iterations || fn(separator, iterations++, this$1$1) !== false) && fn(v, iterations++, this$1$1) !== false;
        }, reverse);
        return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_VALUES, reverse);
        var iterations = 0;
        var step;
        return new Iterator(function() {
            if (!step || iterations % 2) {
                step = iterator.next();
                if (step.done) return step;
            }
            return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
        });
    };
    return interposedSequence;
}
function sortFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    var isKeyedCollection = isKeyed(collection);
    var index = 0;
    var entries = collection.toSeq().map(function(v, k) {
        return [
            k,
            v,
            index++,
            mapper ? mapper(v, k, collection) : v
        ];
    }).valueSeq().toArray();
    entries.sort(function(a, b) {
        return comparator(a[3], b[3]) || a[2] - b[2];
    }).forEach(isKeyedCollection ? function(v, i) {
        entries[i].length = 2;
    } : function(v, i) {
        entries[i] = v[1];
    });
    return isKeyedCollection ? KeyedSeq(entries) : isIndexed(collection) ? IndexedSeq(entries) : SetSeq(entries);
}
function maxFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    if (mapper) {
        var entry = collection.toSeq().map(function(v, k) {
            return [
                v,
                mapper(v, k, collection)
            ];
        }).reduce(function(a, b) {
            return maxCompare(comparator, a[1], b[1]) ? b : a;
        });
        return entry && entry[0];
    }
    return collection.reduce(function(a, b) {
        return maxCompare(comparator, a, b) ? b : a;
    });
}
function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
}
function zipWithFactory(keyIter, zipper, iters, zipAll) {
    var zipSequence = makeSequence(keyIter);
    var sizes = new ArraySeq(iters).map(function(i) {
        return i.size;
    });
    zipSequence.size = zipAll ? sizes.max() : sizes.min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
        /* generic:
    var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      iterations++;
      if (fn(step.value[1], step.value[0], this) === false) {
        break;
      }
    }
    return iterations;
    */ // indexed:
        var iterator = this.__iterator(ITERATE_VALUES, reverse);
        var step;
        var iterations = 0;
        while(!(step = iterator.next()).done){
            if (fn(step.value, iterations++, this) === false) break;
        }
        return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
        var iterators = iters.map(function(i) {
            return i = Collection(i), getIterator(reverse ? i.reverse() : i);
        });
        var iterations = 0;
        var isDone = false;
        return new Iterator(function() {
            var steps;
            if (!isDone) {
                steps = iterators.map(function(i) {
                    return i.next();
                });
                isDone = zipAll ? steps.every(function(s) {
                    return s.done;
                }) : steps.some(function(s) {
                    return s.done;
                });
            }
            if (isDone) return iteratorDone();
            return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                return s.value;
            })));
        });
    };
    return zipSequence;
}
// #pragma Helper Functions
function reify(iter, seq) {
    return iter === seq ? iter : isSeq(iter) ? seq : iter.constructor(seq);
}
function validateEntry(entry) {
    if (entry !== Object(entry)) throw new TypeError('Expected [K, V] tuple: ' + entry);
}
function collectionClass(collection) {
    return isKeyed(collection) ? KeyedCollection : isIndexed(collection) ? IndexedCollection : SetCollection;
}
function makeSequence(collection) {
    return Object.create((isKeyed(collection) ? KeyedSeq : isIndexed(collection) ? IndexedSeq : SetSeq).prototype);
}
function cacheResultThrough() {
    if (this._iter.cacheResult) {
        this._iter.cacheResult();
        this.size = this._iter.size;
        return this;
    }
    return Seq.prototype.cacheResult.call(this);
}
function defaultComparator(a, b) {
    if (a === undefined && b === undefined) return 0;
    if (a === undefined) return 1;
    if (b === undefined) return -1;
    return a > b ? 1 : a < b ? -1 : 0;
}
function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for(var ii = 0; ii < len; ii++)newArr[ii] = arr[ii + offset];
    return newArr;
}
function invariant(condition, error) {
    if (!condition) throw new Error(error);
}
function assertNotInfinite(size) {
    invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
}
function coerceKeyPath(keyPath) {
    if (isArrayLike(keyPath) && typeof keyPath !== 'string') return keyPath;
    if (isOrdered(keyPath)) return keyPath.toArray();
    throw new TypeError('Invalid keyPath: expected Ordered Collection or Array: ' + keyPath);
}
var toString = Object.prototype.toString;
function isPlainObject(value) {
    // The base prototype's toString deals with Argument objects and native namespaces like Math
    if (!value || typeof value !== 'object' || toString.call(value) !== '[object Object]') return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    // Iteratively going up the prototype chain is needed for cross-realm environments (differing contexts, iframes, etc)
    var parentProto = proto;
    var nextProto = Object.getPrototypeOf(proto);
    while(nextProto !== null){
        parentProto = nextProto;
        nextProto = Object.getPrototypeOf(parentProto);
    }
    return parentProto === proto;
}
/**
 * Returns true if the value is a potentially-persistent data structure, either
 * provided by Immutable.js or a plain Array or Object.
 */ function isDataStructure(value) {
    return typeof value === 'object' && (isImmutable(value) || Array.isArray(value) || isPlainObject(value));
}
function quoteString(value) {
    try {
        return typeof value === 'string' ? JSON.stringify(value) : String(value);
    } catch (_ignoreError) {
        return JSON.stringify(value);
    }
}
function has(collection, key) {
    return isImmutable(collection) ? collection.has(key) : isDataStructure(collection) && hasOwnProperty.call(collection, key);
}
function get(collection, key, notSetValue) {
    return isImmutable(collection) ? collection.get(key, notSetValue) : !has(collection, key) ? notSetValue : typeof collection.get === 'function' ? collection.get(key) : collection[key];
}
function shallowCopy(from) {
    if (Array.isArray(from)) return arrCopy(from);
    var to = {};
    for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
    return to;
}
function remove(collection, key) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot update non-data-structure value: ' + collection);
    if (isImmutable(collection)) {
        if (!collection.remove) throw new TypeError('Cannot update immutable value without .remove() method: ' + collection);
        return collection.remove(key);
    }
    if (!hasOwnProperty.call(collection, key)) return collection;
    var collectionCopy = shallowCopy(collection);
    if (Array.isArray(collectionCopy)) collectionCopy.splice(key, 1);
    else delete collectionCopy[key];
    return collectionCopy;
}
function set(collection, key, value) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot update non-data-structure value: ' + collection);
    if (isImmutable(collection)) {
        if (!collection.set) throw new TypeError('Cannot update immutable value without .set() method: ' + collection);
        return collection.set(key, value);
    }
    if (hasOwnProperty.call(collection, key) && value === collection[key]) return collection;
    var collectionCopy = shallowCopy(collection);
    collectionCopy[key] = value;
    return collectionCopy;
}
function updateIn$1(collection, keyPath, notSetValue, updater) {
    if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
    }
    var updatedValue = updateInDeeply(isImmutable(collection), collection, coerceKeyPath(keyPath), 0, notSetValue, updater);
    return updatedValue === NOT_SET ? notSetValue : updatedValue;
}
function updateInDeeply(inImmutable, existing, keyPath, i, notSetValue, updater) {
    var wasNotSet = existing === NOT_SET;
    if (i === keyPath.length) {
        var existingValue = wasNotSet ? notSetValue : existing;
        var newValue = updater(existingValue);
        return newValue === existingValue ? existing : newValue;
    }
    if (!wasNotSet && !isDataStructure(existing)) throw new TypeError('Cannot update within non-data-structure value in path [' + keyPath.slice(0, i).map(quoteString) + ']: ' + existing);
    var key = keyPath[i];
    var nextExisting = wasNotSet ? NOT_SET : get(existing, key, NOT_SET);
    var nextUpdated = updateInDeeply(nextExisting === NOT_SET ? inImmutable : isImmutable(nextExisting), nextExisting, keyPath, i + 1, notSetValue, updater);
    return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? remove(existing, key) : set(wasNotSet ? inImmutable ? emptyMap() : {} : existing, key, nextUpdated);
}
function setIn$1(collection, keyPath, value) {
    return updateIn$1(collection, keyPath, NOT_SET, function() {
        return value;
    });
}
function setIn(keyPath, v) {
    return setIn$1(this, keyPath, v);
}
function removeIn(collection, keyPath) {
    return updateIn$1(collection, keyPath, function() {
        return NOT_SET;
    });
}
function deleteIn(keyPath) {
    return removeIn(this, keyPath);
}
function update$1(collection, key, notSetValue, updater) {
    return updateIn$1(collection, [
        key
    ], notSetValue, updater);
}
function update(key, notSetValue, updater) {
    return arguments.length === 1 ? key(this) : update$1(this, key, notSetValue, updater);
}
function updateIn(keyPath, notSetValue, updater) {
    return updateIn$1(this, keyPath, notSetValue, updater);
}
function merge$1() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeIntoKeyedWith(this, iters);
}
function mergeWith$1(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    if (typeof merger !== 'function') throw new TypeError('Invalid merger function: ' + merger);
    return mergeIntoKeyedWith(this, iters, merger);
}
function mergeIntoKeyedWith(collection, collections, merger) {
    var iters = [];
    for(var ii = 0; ii < collections.length; ii++){
        var collection$1 = KeyedCollection(collections[ii]);
        if (collection$1.size !== 0) iters.push(collection$1);
    }
    if (iters.length === 0) return collection;
    if (collection.toSeq().size === 0 && !collection.__ownerID && iters.length === 1) return collection.constructor(iters[0]);
    return collection.withMutations(function(collection) {
        var mergeIntoCollection = merger ? function(value, key) {
            update$1(collection, key, NOT_SET, function(oldVal) {
                return oldVal === NOT_SET ? value : merger(oldVal, value, key);
            });
        } : function(value, key) {
            collection.set(key, value);
        };
        for(var ii = 0; ii < iters.length; ii++)iters[ii].forEach(mergeIntoCollection);
    });
}
function merge(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeWithSources(collection, sources);
}
function mergeWith(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeWithSources(collection, sources, merger);
}
function mergeDeep$1(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeDeepWithSources(collection, sources);
}
function mergeDeepWith$1(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeDeepWithSources(collection, sources, merger);
}
function mergeDeepWithSources(collection, sources, merger) {
    return mergeWithSources(collection, sources, deepMergerWith(merger));
}
function mergeWithSources(collection, sources, merger) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot merge into non-data-structure value: ' + collection);
    if (isImmutable(collection)) return typeof merger === 'function' && collection.mergeWith ? collection.mergeWith.apply(collection, [
        merger
    ].concat(sources)) : collection.merge ? collection.merge.apply(collection, sources) : collection.concat.apply(collection, sources);
    var isArray = Array.isArray(collection);
    var merged = collection;
    var Collection = isArray ? IndexedCollection : KeyedCollection;
    var mergeItem = isArray ? function(value) {
        // Copy on write
        if (merged === collection) merged = shallowCopy(merged);
        merged.push(value);
    } : function(value, key) {
        var hasVal = hasOwnProperty.call(merged, key);
        var nextVal = hasVal && merger ? merger(merged[key], value, key) : value;
        if (!hasVal || nextVal !== merged[key]) {
            // Copy on write
            if (merged === collection) merged = shallowCopy(merged);
            merged[key] = nextVal;
        }
    };
    for(var i = 0; i < sources.length; i++)Collection(sources[i]).forEach(mergeItem);
    return merged;
}
function deepMergerWith(merger) {
    function deepMerger(oldValue, newValue, key) {
        return isDataStructure(oldValue) && isDataStructure(newValue) && areMergeable(oldValue, newValue) ? mergeWithSources(oldValue, [
            newValue
        ], deepMerger) : merger ? merger(oldValue, newValue, key) : newValue;
    }
    return deepMerger;
}
/**
 * It's unclear what the desired behavior is for merging two collections that
 * fall into separate categories between keyed, indexed, or set-like, so we only
 * consider them mergeable if they fall into the same category.
 */ function areMergeable(oldDataStructure, newDataStructure) {
    var oldSeq = Seq(oldDataStructure);
    var newSeq = Seq(newDataStructure);
    // This logic assumes that a sequence can only fall into one of the three
    // categories mentioned above (since there's no `isSetLike()` method).
    return isIndexed(oldSeq) === isIndexed(newSeq) && isKeyed(oldSeq) === isKeyed(newSeq);
}
function mergeDeep() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeDeepWithSources(this, iters);
}
function mergeDeepWith(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return mergeDeepWithSources(this, iters, merger);
}
function mergeIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn$1(this, keyPath, emptyMap(), function(m) {
        return mergeWithSources(m, iters);
    });
}
function mergeDeepIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn$1(this, keyPath, emptyMap(), function(m) {
        return mergeDeepWithSources(m, iters);
    });
}
function withMutations(fn) {
    var mutable = this.asMutable();
    fn(mutable);
    return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
}
function asMutable() {
    return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
}
function asImmutable() {
    return this.__ensureOwner();
}
function wasAltered() {
    return this.__altered;
}
var Map = /*@__PURE__*/ function(KeyedCollection) {
    function Map(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (KeyedCollection) Map.__proto__ = KeyedCollection;
    Map.prototype = Object.create(KeyedCollection && KeyedCollection.prototype);
    Map.prototype.constructor = Map;
    Map.of = function of() {
        var keyValues = [], len = arguments.length;
        while(len--)keyValues[len] = arguments[len];
        return emptyMap().withMutations(function(map) {
            for(var i = 0; i < keyValues.length; i += 2){
                if (i + 1 >= keyValues.length) throw new Error('Missing value for key: ' + keyValues[i]);
                map.set(keyValues[i], keyValues[i + 1]);
            }
        });
    };
    Map.prototype.toString = function toString() {
        return this.__toString('Map {', '}');
    };
    // @pragma Access
    Map.prototype.get = function get(k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    };
    // @pragma Modification
    Map.prototype.set = function set(k, v) {
        return updateMap(this, k, v);
    };
    Map.prototype.remove = function remove(k) {
        return updateMap(this, k, NOT_SET);
    };
    Map.prototype.deleteAll = function deleteAll(keys) {
        var collection = Collection(keys);
        if (collection.size === 0) return this;
        return this.withMutations(function(map) {
            collection.forEach(function(key) {
                return map.remove(key);
            });
        });
    };
    Map.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyMap();
    };
    // @pragma Composition
    Map.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator));
    };
    Map.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator, mapper));
    };
    Map.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(_map) {
            _map.forEach(function(value, key) {
                _map.set(key, mapper.call(context, value, key, this$1$1));
            });
        });
    };
    // @pragma Mutability
    Map.prototype.__iterator = function __iterator(type, reverse) {
        return new MapIterator(this, type, reverse);
    };
    Map.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        this._root && this._root.iterate(function(entry) {
            iterations++;
            return fn(entry[1], entry[0], this$1$1);
        }, reverse);
        return iterations;
    };
    Map.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeMap(this.size, this._root, ownerID, this.__hash);
    };
    return Map;
}(KeyedCollection);
Map.isMap = isMap;
var MapPrototype = Map.prototype;
MapPrototype[IS_MAP_SYMBOL] = true;
MapPrototype[DELETE] = MapPrototype.remove;
MapPrototype.removeAll = MapPrototype.deleteAll;
MapPrototype.setIn = setIn;
MapPrototype.removeIn = MapPrototype.deleteIn = deleteIn;
MapPrototype.update = update;
MapPrototype.updateIn = updateIn;
MapPrototype.merge = MapPrototype.concat = merge$1;
MapPrototype.mergeWith = mergeWith$1;
MapPrototype.mergeDeep = mergeDeep;
MapPrototype.mergeDeepWith = mergeDeepWith;
MapPrototype.mergeIn = mergeIn;
MapPrototype.mergeDeepIn = mergeDeepIn;
MapPrototype.withMutations = withMutations;
MapPrototype.wasAltered = wasAltered;
MapPrototype.asImmutable = asImmutable;
MapPrototype['@@transducer/init'] = MapPrototype.asMutable = asMutable;
MapPrototype['@@transducer/step'] = function(result, arr) {
    return result.set(arr[0], arr[1]);
};
MapPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
// #pragma Trie Nodes
var ArrayMapNode = function ArrayMapNode(ownerID, entries) {
    this.ownerID = ownerID;
    this.entries = entries;
};
ArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if (is(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
ArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if (is(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && entries.length === 1) return; // undefined
    if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) return createNodes(ownerID, entries, key, value);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new ArrayMapNode(ownerID, newEntries);
};
var BitmapIndexedNode = function BitmapIndexedNode(ownerID, bitmap, nodes) {
    this.ownerID = ownerID;
    this.bitmap = bitmap;
    this.nodes = nodes;
};
BitmapIndexedNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
    var bitmap = this.bitmap;
    return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
};
BitmapIndexedNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var bit = 1 << keyHashFrag;
    var bitmap = this.bitmap;
    var exists = (bitmap & bit) !== 0;
    if (!exists && value === NOT_SET) return this;
    var idx = popCount(bitmap & bit - 1);
    var nodes = this.nodes;
    var node = exists ? nodes[idx] : undefined;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
    if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) return nodes[idx ^ 1];
    if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) return newNode;
    var isEditable = ownerID && ownerID === this.ownerID;
    var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
    var newNodes = exists ? newNode ? setAt(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
    }
    return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
};
var HashArrayMapNode = function HashArrayMapNode(ownerID, count, nodes) {
    this.ownerID = ownerID;
    this.count = count;
    this.nodes = nodes;
};
HashArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var node = this.nodes[idx];
    return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
};
HashArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var removed = value === NOT_SET;
    var nodes = this.nodes;
    var node = nodes[idx];
    if (removed && !node) return this;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    var newCount = this.count;
    if (!node) newCount++;
    else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) return packNodes(ownerID, nodes, newCount, idx);
    }
    var isEditable = ownerID && ownerID === this.ownerID;
    var newNodes = setAt(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
    }
    return new HashArrayMapNode(ownerID, newCount, newNodes);
};
var HashCollisionNode = function HashCollisionNode(ownerID, keyHash, entries) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entries = entries;
};
HashCollisionNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if (is(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
HashCollisionNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var removed = value === NOT_SET;
    if (keyHash !== this.keyHash) {
        if (removed) return this;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [
            key,
            value
        ]);
    }
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if (is(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && len === 2) return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new HashCollisionNode(ownerID, this.keyHash, newEntries);
};
var ValueNode = function ValueNode(ownerID, keyHash, entry) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entry = entry;
};
ValueNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
};
ValueNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var keyMatch = is(key, this.entry[0]);
    if (keyMatch ? value === this.entry[1] : removed) return this;
    SetRef(didAlter);
    if (removed) {
        SetRef(didChangeSize);
        return; // undefined
    }
    if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
            this.entry[1] = value;
            return this;
        }
        return new ValueNode(ownerID, this.keyHash, [
            key,
            value
        ]);
    }
    SetRef(didChangeSize);
    return mergeIntoNode(this, ownerID, shift, hash(key), [
        key,
        value
    ]);
};
// #pragma Iterators
ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
    var entries = this.entries;
    for(var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++){
        if (fn(entries[reverse ? maxIndex - ii : ii]) === false) return false;
    }
};
BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
    var nodes = this.nodes;
    for(var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++){
        var node = nodes[reverse ? maxIndex - ii : ii];
        if (node && node.iterate(fn, reverse) === false) return false;
    }
};
// eslint-disable-next-line no-unused-vars
ValueNode.prototype.iterate = function(fn, reverse) {
    return fn(this.entry);
};
var MapIterator = /*@__PURE__*/ function(Iterator) {
    function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && mapIteratorFrame(map._root);
    }
    if (Iterator) MapIterator.__proto__ = Iterator;
    MapIterator.prototype = Object.create(Iterator && Iterator.prototype);
    MapIterator.prototype.constructor = MapIterator;
    MapIterator.prototype.next = function next() {
        var type = this._type;
        var stack = this._stack;
        while(stack){
            var node = stack.node;
            var index = stack.index++;
            var maxIndex = void 0;
            if (node.entry) {
                if (index === 0) return mapIteratorValue(type, node.entry);
            } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
            } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                    var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return mapIteratorValue(type, subNode.entry);
                        stack = this._stack = mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
            }
            stack = this._stack = this._stack.__prev;
        }
        return iteratorDone();
    };
    return MapIterator;
}(Iterator);
function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
}
function mapIteratorFrame(node, prev) {
    return {
        node: node,
        index: 0,
        __prev: prev
    };
}
function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var EMPTY_MAP;
function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
}
function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
        if (v === NOT_SET) return map;
        newSize = 1;
        newRoot = new ArrayMapNode(map.__ownerID, [
            [
                k,
                v
            ]
        ]);
    } else {
        var didChangeSize = MakeRef();
        var didAlter = MakeRef();
        newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
        if (!didAlter.value) return map;
        newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
        map.size = newSize;
        map._root = newRoot;
        map.__hash = undefined;
        map.__altered = true;
        return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
}
function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
        if (value === NOT_SET) return node;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return new ValueNode(ownerID, keyHash, [
            key,
            value
        ]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
}
function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
}
function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) return new HashCollisionNode(ownerID, keyHash, [
        node.entry,
        entry
    ]);
    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var newNode;
    var nodes = idx1 === idx2 ? [
        mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)
    ] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [
        node,
        newNode
    ] : [
        newNode,
        node
    ]);
    return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
}
function createNodes(ownerID, entries, key, value) {
    if (!ownerID) ownerID = new OwnerID();
    var node = new ValueNode(ownerID, hash(key), [
        key,
        value
    ]);
    for(var ii = 0; ii < entries.length; ii++){
        var entry = entries[ii];
        node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
}
function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for(var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1){
        var node = nodes[ii];
        if (node !== undefined && ii !== excluding) {
            bitmap |= bit;
            packedNodes[packedII++] = node;
        }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
}
function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for(var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1)expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
}
function popCount(x) {
    x -= x >> 1 & 0x55555555;
    x = (x & 0x33333333) + (x >> 2 & 0x33333333);
    x = x + (x >> 4) & 0x0f0f0f0f;
    x += x >> 8;
    x += x >> 16;
    return x & 0x7f;
}
function setAt(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
}
function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
        array[idx] = val;
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++)if (ii === idx) {
        newArray[ii] = val;
        after = -1;
    } else newArray[ii] = array[ii + after];
    return newArray;
}
function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
        array.pop();
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++){
        if (ii === idx) after = 1;
        newArray[ii] = array[ii + after];
    }
    return newArray;
}
var MAX_ARRAY_MAP_SIZE = SIZE / 4;
var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
var IS_LIST_SYMBOL = '@@__IMMUTABLE_LIST__@@';
function isList(maybeList) {
    return Boolean(maybeList && maybeList[IS_LIST_SYMBOL]);
}
var List = /*@__PURE__*/ function(IndexedCollection) {
    function List(value) {
        var empty = emptyList();
        if (value === undefined || value === null) // eslint-disable-next-line no-constructor-return
        return empty;
        if (isList(value)) // eslint-disable-next-line no-constructor-return
        return value;
        var iter = IndexedCollection(value);
        var size = iter.size;
        if (size === 0) // eslint-disable-next-line no-constructor-return
        return empty;
        assertNotInfinite(size);
        if (size > 0 && size < SIZE) // eslint-disable-next-line no-constructor-return
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
        // eslint-disable-next-line no-constructor-return
        return empty.withMutations(function(list) {
            list.setSize(size);
            iter.forEach(function(v, i) {
                return list.set(i, v);
            });
        });
    }
    if (IndexedCollection) List.__proto__ = IndexedCollection;
    List.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    List.prototype.constructor = List;
    List.of = function of() {
        return this(arguments);
    };
    List.prototype.toString = function toString() {
        return this.__toString('List [', ']');
    };
    // @pragma Access
    List.prototype.get = function get(index, notSetValue) {
        index = wrapIndex(this, index);
        if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = listNodeFor(this, index);
            return node && node.array[index & MASK];
        }
        return notSetValue;
    };
    // @pragma Modification
    List.prototype.set = function set(index, value) {
        return updateList(this, index, value);
    };
    List.prototype.remove = function remove(index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List.prototype.insert = function insert(index, value) {
        return this.splice(index, 0, value);
    };
    List.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = SHIFT;
            this._root = this._tail = this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyList();
    };
    List.prototype.push = function push() {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function(list) {
            setListBounds(list, 0, oldSize + values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(oldSize + ii, values[ii]);
        });
    };
    List.prototype.pop = function pop() {
        return setListBounds(this, 0, -1);
    };
    List.prototype.unshift = function unshift() {
        var values = arguments;
        return this.withMutations(function(list) {
            setListBounds(list, -values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(ii, values[ii]);
        });
    };
    List.prototype.shift = function shift() {
        return setListBounds(this, 1);
    };
    // @pragma Composition
    List.prototype.concat = function concat() {
        var arguments$1 = arguments;
        var seqs = [];
        for(var i = 0; i < arguments.length; i++){
            var argument = arguments$1[i];
            var seq = IndexedCollection(typeof argument !== 'string' && hasIterator(argument) ? argument : [
                argument
            ]);
            if (seq.size !== 0) seqs.push(seq);
        }
        if (seqs.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && seqs.length === 1) return this.constructor(seqs[0]);
        return this.withMutations(function(list) {
            seqs.forEach(function(seq) {
                return seq.forEach(function(value) {
                    return list.push(value);
                });
            });
        });
    };
    List.prototype.setSize = function setSize(size) {
        return setListBounds(this, 0, size);
    };
    List.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(list) {
            for(var i = 0; i < this$1$1.size; i++)list.set(i, mapper.call(context, list.get(i), i, this$1$1));
        });
    };
    // @pragma Iteration
    List.prototype.slice = function slice(begin, end) {
        var size = this.size;
        if (wholeSlice(begin, end, size)) return this;
        return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
    };
    List.prototype.__iterator = function __iterator(type, reverse) {
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        return new Iterator(function() {
            var value = values();
            return value === DONE ? iteratorDone() : iteratorValue(type, reverse ? --index : index++, value);
        });
    };
    List.prototype.__iterate = function __iterate(fn, reverse) {
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        var value;
        while((value = values()) !== DONE){
            if (fn(value, reverse ? --index : index++, this) === false) break;
        }
        return index;
    };
    List.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyList();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    return List;
}(IndexedCollection);
List.isList = isList;
var ListPrototype = List.prototype;
ListPrototype[IS_LIST_SYMBOL] = true;
ListPrototype[DELETE] = ListPrototype.remove;
ListPrototype.merge = ListPrototype.concat;
ListPrototype.setIn = setIn;
ListPrototype.deleteIn = ListPrototype.removeIn = deleteIn;
ListPrototype.update = update;
ListPrototype.updateIn = updateIn;
ListPrototype.mergeIn = mergeIn;
ListPrototype.mergeDeepIn = mergeDeepIn;
ListPrototype.withMutations = withMutations;
ListPrototype.wasAltered = wasAltered;
ListPrototype.asImmutable = asImmutable;
ListPrototype['@@transducer/init'] = ListPrototype.asMutable = asMutable;
ListPrototype['@@transducer/step'] = function(result, arr) {
    return result.push(arr);
};
ListPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
var VNode = function VNode(array, ownerID) {
    this.array = array;
    this.ownerID = ownerID;
};
// TODO: seems like these methods are very similar
VNode.prototype.removeBefore = function removeBefore(ownerID, level, index) {
    if (index === level ? 1 << level : this.array.length === 0) return this;
    var originIndex = index >>> level & MASK;
    if (originIndex >= this.array.length) return new VNode([], ownerID);
    var removingFirst = originIndex === 0;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) return this;
    }
    if (removingFirst && !newChild) return this;
    var editable = editableVNode(this, ownerID);
    if (!removingFirst) for(var ii = 0; ii < originIndex; ii++)editable.array[ii] = undefined;
    if (newChild) editable.array[originIndex] = newChild;
    return editable;
};
VNode.prototype.removeAfter = function removeAfter(ownerID, level, index) {
    if (index === (level ? 1 << level : 0) || this.array.length === 0) return this;
    var sizeIndex = index - 1 >>> level & MASK;
    if (sizeIndex >= this.array.length) return this;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) return this;
    }
    var editable = editableVNode(this, ownerID);
    editable.array.splice(sizeIndex + 1);
    if (newChild) editable.array[sizeIndex] = newChild;
    return editable;
};
var DONE = {};
function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;
    return iterateNodeOrLeaf(list._root, list._level, 0);
    function iterateNodeOrLeaf(node, level, offset) {
        return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
    }
    function iterateLeaf(node, offset) {
        var array = offset === tailPos ? tail && tail.array : node && node.array;
        var from = offset > left ? 0 : left - offset;
        var to = right - offset;
        if (to > SIZE) to = SIZE;
        return function() {
            if (from === to) return DONE;
            var idx = reverse ? --to : from++;
            return array && array[idx];
        };
    }
    function iterateNode(node, level, offset) {
        var values;
        var array = node && node.array;
        var from = offset > left ? 0 : left - offset >> level;
        var to = (right - offset >> level) + 1;
        if (to > SIZE) to = SIZE;
        return function() {
            while(true){
                if (values) {
                    var value = values();
                    if (value !== DONE) return value;
                    values = null;
                }
                if (from === to) return DONE;
                var idx = reverse ? --to : from++;
                values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
            }
        };
    }
}
function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
}
var EMPTY_LIST;
function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
}
function updateList(list, index, value) {
    index = wrapIndex(list, index);
    if (index !== index) return list;
    if (index >= list.size || index < 0) return list.withMutations(function(list) {
        index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
    });
    index += list._origin;
    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef();
    if (index >= getTailOffset(list._capacity)) newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    else newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    if (!didAlter.value) return list;
    if (list.__ownerID) {
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
}
function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = index >>> level & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) return node;
    var newNode;
    if (level > 0) {
        var lowerNode = node && node.array[idx];
        var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
        if (newLowerNode === lowerNode) return node;
        newNode = editableVNode(node, ownerID);
        newNode.array[idx] = newLowerNode;
        return newNode;
    }
    if (nodeHas && node.array[idx] === value) return node;
    if (didAlter) SetRef(didAlter);
    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) newNode.array.pop();
    else newNode.array[idx] = value;
    return newNode;
}
function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) return node;
    return new VNode(node ? node.array.slice() : [], ownerID);
}
function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) return list._tail;
    if (rawIndex < 1 << list._level + SHIFT) {
        var node = list._root;
        var level = list._level;
        while(node && level > 0){
            node = node.array[rawIndex >>> level & MASK];
            level -= SHIFT;
        }
        return node;
    }
}
function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) begin |= 0;
    if (end !== undefined) end |= 0;
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) return list.clear();
    var newLevel = list._level;
    var newRoot = list._root;
    // New origin might need creating a higher root.
    var offsetShift = 0;
    while(newOrigin + offsetShift < 0){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            undefined,
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
        offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
        newOrigin += offsetShift;
        oldOrigin += offsetShift;
        newCapacity += offsetShift;
        oldCapacity += offsetShift;
    }
    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);
    // New size might need creating a higher root.
    while(newTailOffset >= 1 << newLevel + SHIFT){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
    }
    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
        newRoot = editableVNode(newRoot, owner);
        var node = newRoot;
        for(var level = newLevel; level > SHIFT; level -= SHIFT){
            var idx = oldTailOffset >>> level & MASK;
            node = node.array[idx] = editableVNode(node.array[idx], owner);
        }
        node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
    }
    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
        newOrigin -= newTailOffset;
        newCapacity -= newTailOffset;
        newLevel = SHIFT;
        newRoot = null;
        newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
        offsetShift = 0;
        // Identify the new top root node of the subtree of the old root.
        while(newRoot){
            var beginIndex = newOrigin >>> newLevel & MASK;
            if (beginIndex !== newTailOffset >>> newLevel & MASK) break;
            if (beginIndex) offsetShift += (1 << newLevel) * beginIndex;
            newLevel -= SHIFT;
            newRoot = newRoot.array[beginIndex];
        }
        // Trim the new sides of the new root.
        if (newRoot && newOrigin > oldOrigin) newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
        if (newRoot && newTailOffset < oldTailOffset) newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
        if (offsetShift) {
            newOrigin -= offsetShift;
            newCapacity -= offsetShift;
        }
    }
    if (list.__ownerID) {
        list.size = newCapacity - newOrigin;
        list._origin = newOrigin;
        list._capacity = newCapacity;
        list._level = newLevel;
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
}
function getTailOffset(size) {
    return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
}
var OrderedMap = /*@__PURE__*/ function(Map) {
    function OrderedMap(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (Map) OrderedMap.__proto__ = Map;
    OrderedMap.prototype = Object.create(Map && Map.prototype);
    OrderedMap.prototype.constructor = OrderedMap;
    OrderedMap.of = function of() {
        return this(arguments);
    };
    OrderedMap.prototype.toString = function toString() {
        return this.__toString('OrderedMap {', '}');
    };
    // @pragma Access
    OrderedMap.prototype.get = function get(k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };
    // @pragma Modification
    OrderedMap.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._map.clear();
            this._list.clear();
            this.__altered = true;
            return this;
        }
        return emptyOrderedMap();
    };
    OrderedMap.prototype.set = function set(k, v) {
        return updateOrderedMap(this, k, v);
    };
    OrderedMap.prototype.remove = function remove(k) {
        return updateOrderedMap(this, k, NOT_SET);
    };
    OrderedMap.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._list.__iterate(function(entry) {
            return entry && fn(entry[1], entry[0], this$1$1);
        }, reverse);
    };
    OrderedMap.prototype.__iterator = function __iterator(type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
    };
    OrderedMap.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return emptyOrderedMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            this._map = newMap;
            this._list = newList;
            return this;
        }
        return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    return OrderedMap;
}(Map);
OrderedMap.isOrderedMap = isOrderedMap;
OrderedMap.prototype[IS_ORDERED_SYMBOL] = true;
OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    omap.__altered = false;
    return omap;
}
var EMPTY_ORDERED_MAP;
function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
}
function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) {
        // removed
        if (!has) return omap;
        if (list.size >= SIZE && list.size >= map.size * 2) {
            newList = list.filter(function(entry, idx) {
                return entry !== undefined && i !== idx;
            });
            newMap = newList.toKeyedSeq().map(function(entry) {
                return entry[0];
            }).flip().toMap();
            if (omap.__ownerID) newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        } else {
            newMap = map.remove(k);
            newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
        }
    } else if (has) {
        if (v === list.get(i)[1]) return omap;
        newMap = map;
        newList = list.set(i, [
            k,
            v
        ]);
    } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [
            k,
            v
        ]);
    }
    if (omap.__ownerID) {
        omap.size = newMap.size;
        omap._map = newMap;
        omap._list = newList;
        omap.__hash = undefined;
        omap.__altered = true;
        return omap;
    }
    return makeOrderedMap(newMap, newList);
}
var IS_STACK_SYMBOL = '@@__IMMUTABLE_STACK__@@';
function isStack(maybeStack) {
    return Boolean(maybeStack && maybeStack[IS_STACK_SYMBOL]);
}
var Stack = /*@__PURE__*/ function(IndexedCollection) {
    function Stack(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyStack() : isStack(value) ? value : emptyStack().pushAll(value);
    }
    if (IndexedCollection) Stack.__proto__ = IndexedCollection;
    Stack.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    Stack.prototype.constructor = Stack;
    Stack.of = function of() {
        return this(arguments);
    };
    Stack.prototype.toString = function toString() {
        return this.__toString('Stack [', ']');
    };
    // @pragma Access
    Stack.prototype.get = function get(index, notSetValue) {
        var head = this._head;
        index = wrapIndex(this, index);
        while(head && index--)head = head.next;
        return head ? head.value : notSetValue;
    };
    Stack.prototype.peek = function peek() {
        return this._head && this._head.value;
    };
    // @pragma Modification
    Stack.prototype.push = function push() {
        var arguments$1 = arguments;
        if (arguments.length === 0) return this;
        var newSize = this.size + arguments.length;
        var head = this._head;
        for(var ii = arguments.length - 1; ii >= 0; ii--)head = {
            value: arguments$1[ii],
            next: head
        };
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pushAll = function pushAll(iter) {
        iter = IndexedCollection(iter);
        if (iter.size === 0) return this;
        if (this.size === 0 && isStack(iter)) return iter;
        assertNotInfinite(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.__iterate(function(value) {
            newSize++;
            head = {
                value: value,
                next: head
            };
        }, /* reverse */ true);
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pop = function pop() {
        return this.slice(1);
    };
    Stack.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyStack();
    };
    Stack.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        var resolvedBegin = resolveBegin(begin, this.size);
        var resolvedEnd = resolveEnd(end, this.size);
        if (resolvedEnd !== this.size) // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while(resolvedBegin--)head = head.next;
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    // @pragma Mutability
    Stack.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyStack();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeStack(this.size, this._head, ownerID, this.__hash);
    };
    // @pragma Iteration
    Stack.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return new ArraySeq(this.toArray()).__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
        var iterations = 0;
        var node = this._head;
        while(node){
            if (fn(node.value, iterations++, this) === false) break;
            node = node.next;
        }
        return iterations;
    };
    Stack.prototype.__iterator = function __iterator(type, reverse) {
        if (reverse) return new ArraySeq(this.toArray()).__iterator(type, reverse);
        var iterations = 0;
        var node = this._head;
        return new Iterator(function() {
            if (node) {
                var value = node.value;
                node = node.next;
                return iteratorValue(type, iterations++, value);
            }
            return iteratorDone();
        });
    };
    return Stack;
}(IndexedCollection);
Stack.isStack = isStack;
var StackPrototype = Stack.prototype;
StackPrototype[IS_STACK_SYMBOL] = true;
StackPrototype.shift = StackPrototype.pop;
StackPrototype.unshift = StackPrototype.push;
StackPrototype.unshiftAll = StackPrototype.pushAll;
StackPrototype.withMutations = withMutations;
StackPrototype.wasAltered = wasAltered;
StackPrototype.asImmutable = asImmutable;
StackPrototype['@@transducer/init'] = StackPrototype.asMutable = asMutable;
StackPrototype['@@transducer/step'] = function(result, arr) {
    return result.unshift(arr);
};
StackPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var EMPTY_STACK;
function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
}
var IS_SET_SYMBOL = '@@__IMMUTABLE_SET__@@';
function isSet(maybeSet) {
    return Boolean(maybeSet && maybeSet[IS_SET_SYMBOL]);
}
function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
}
function deepEqual(a, b) {
    if (a === b) return true;
    if (!isCollection(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) return false;
    if (a.size === 0 && b.size === 0) return true;
    var notAssociative = !isAssociative(a);
    if (isOrdered(a)) {
        var entries = a.entries();
        return b.every(function(v, k) {
            var entry = entries.next().value;
            return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
        }) && entries.next().done;
    }
    var flipped = false;
    if (a.size === undefined) {
        if (b.size === undefined) {
            if (typeof a.cacheResult === 'function') a.cacheResult();
        } else {
            flipped = true;
            var _ = a;
            a = b;
            b = _;
        }
    }
    var allEqual = true;
    var bSize = b.__iterate(function(v, k) {
        if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
            allEqual = false;
            return false;
        }
    });
    return allEqual && a.size === bSize;
}
function mixin(ctor, methods) {
    var keyCopier = function(key) {
        ctor.prototype[key] = methods[key];
    };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
}
function toJS(value) {
    if (!value || typeof value !== 'object') return value;
    if (!isCollection(value)) {
        if (!isDataStructure(value)) return value;
        value = Seq(value);
    }
    if (isKeyed(value)) {
        var result$1 = {};
        value.__iterate(function(v, k) {
            result$1[k] = toJS(v);
        });
        return result$1;
    }
    var result = [];
    value.__iterate(function(v) {
        result.push(toJS(v));
    });
    return result;
}
var Set = /*@__PURE__*/ function(SetCollection) {
    function Set(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (SetCollection) Set.__proto__ = SetCollection;
    Set.prototype = Object.create(SetCollection && SetCollection.prototype);
    Set.prototype.constructor = Set;
    Set.of = function of() {
        return this(arguments);
    };
    Set.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    Set.intersect = function intersect(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.intersect.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.union = function union(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.union.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.prototype.toString = function toString() {
        return this.__toString('Set {', '}');
    };
    // @pragma Access
    Set.prototype.has = function has(value) {
        return this._map.has(value);
    };
    // @pragma Modification
    Set.prototype.add = function add(value) {
        return updateSet(this, this._map.set(value, value));
    };
    Set.prototype.remove = function remove(value) {
        return updateSet(this, this._map.remove(value));
    };
    Set.prototype.clear = function clear() {
        return updateSet(this, this._map.clear());
    };
    // @pragma Composition
    Set.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        // keep track if the set is altered by the map function
        var didChanges = false;
        var newMap = updateSet(this, this._map.mapEntries(function(ref) {
            var v = ref[1];
            var mapped = mapper.call(context, v, v, this$1$1);
            if (mapped !== v) didChanges = true;
            return [
                mapped,
                mapped
            ];
        }, context));
        return didChanges ? newMap : this;
    };
    Set.prototype.union = function union() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && iters.length === 1) return this.constructor(iters[0]);
        return this.withMutations(function(set) {
            for(var ii = 0; ii < iters.length; ii++)if (typeof iters[ii] === 'string') set.add(iters[ii]);
            else SetCollection(iters[ii]).forEach(function(value) {
                return set.add(value);
            });
        });
    };
    Set.prototype.intersect = function intersect() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (!iters.every(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.subtract = function subtract() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (iters.some(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator));
    };
    Set.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator, mapper));
    };
    Set.prototype.wasAltered = function wasAltered() {
        return this._map.wasAltered();
    };
    Set.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._map.__iterate(function(k) {
            return fn(k, k, this$1$1);
        }, reverse);
    };
    Set.prototype.__iterator = function __iterator(type, reverse) {
        return this._map.__iterator(type, reverse);
    };
    Set.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return this.__empty();
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return this.__make(newMap, ownerID);
    };
    return Set;
}(SetCollection);
Set.isSet = isSet;
var SetPrototype = Set.prototype;
SetPrototype[IS_SET_SYMBOL] = true;
SetPrototype[DELETE] = SetPrototype.remove;
SetPrototype.merge = SetPrototype.concat = SetPrototype.union;
SetPrototype.withMutations = withMutations;
SetPrototype.asImmutable = asImmutable;
SetPrototype['@@transducer/init'] = SetPrototype.asMutable = asMutable;
SetPrototype['@@transducer/step'] = function(result, arr) {
    return result.add(arr);
};
SetPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
SetPrototype.__empty = emptySet;
SetPrototype.__make = makeSet;
function updateSet(set, newMap) {
    if (set.__ownerID) {
        set.size = newMap.size;
        set._map = newMap;
        return set;
    }
    return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
}
function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var EMPTY_SET;
function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
}
/**
 * Returns a lazy seq of nums from start (inclusive) to end
 * (exclusive), by step, where start defaults to 0, step to 1, and end to
 * infinity. When start is equal to end, returns empty list.
 */ var Range = /*@__PURE__*/ function(IndexedSeq) {
    function Range(start, end, step) {
        if (!(this instanceof Range)) // eslint-disable-next-line no-constructor-return
        return new Range(start, end, step);
        invariant(step !== 0, 'Cannot step a Range by 0');
        start = start || 0;
        if (end === undefined) end = Infinity;
        step = step === undefined ? 1 : Math.abs(step);
        if (end < start) step = -step;
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
            if (EMPTY_RANGE) // eslint-disable-next-line no-constructor-return
            return EMPTY_RANGE;
            EMPTY_RANGE = this;
        }
    }
    if (IndexedSeq) Range.__proto__ = IndexedSeq;
    Range.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Range.prototype.constructor = Range;
    Range.prototype.toString = function toString() {
        if (this.size === 0) return 'Range []';
        return 'Range [ ' + this._start + '...' + this._end + (this._step !== 1 ? ' by ' + this._step : '') + ' ]';
    };
    Range.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function includes(searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        begin = resolveBegin(begin, this.size);
        end = resolveEnd(end, this.size);
        if (end <= begin) return new Range(0, 0);
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function indexOf(searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;
            if (index >= 0 && index < this.size) return index;
        }
        return -1;
    };
    Range.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        while(i !== size){
            if (fn(value, reverse ? size - ++i : i++, this) === false) break;
            value += reverse ? -step : step;
        }
        return i;
    };
    Range.prototype.__iterator = function __iterator(type, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var v = value;
            value += reverse ? -step : step;
            return iteratorValue(type, reverse ? size - ++i : i++, v);
        });
    };
    Range.prototype.equals = function equals(other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
    };
    return Range;
}(IndexedSeq);
var EMPTY_RANGE;
function getIn$1(collection, searchKeyPath, notSetValue) {
    var keyPath = coerceKeyPath(searchKeyPath);
    var i = 0;
    while(i !== keyPath.length){
        collection = get(collection, keyPath[i++], NOT_SET);
        if (collection === NOT_SET) return notSetValue;
    }
    return collection;
}
function getIn(searchKeyPath, notSetValue) {
    return getIn$1(this, searchKeyPath, notSetValue);
}
function hasIn$1(collection, keyPath) {
    return getIn$1(collection, keyPath, NOT_SET) !== NOT_SET;
}
function hasIn(searchKeyPath) {
    return hasIn$1(this, searchKeyPath);
}
function toObject() {
    assertNotInfinite(this.size);
    var object = {};
    this.__iterate(function(v, k) {
        object[k] = v;
    });
    return object;
}
// Note: all of these methods are deprecated.
Collection.isIterable = isCollection;
Collection.isKeyed = isKeyed;
Collection.isIndexed = isIndexed;
Collection.isAssociative = isAssociative;
Collection.isOrdered = isOrdered;
Collection.Iterator = Iterator;
mixin(Collection, {
    // ### Conversion to other types
    toArray: function toArray() {
        assertNotInfinite(this.size);
        var array = new Array(this.size || 0);
        var useTuples = isKeyed(this);
        var i = 0;
        this.__iterate(function(v, k) {
            // Keyed collections produce an array of tuples.
            array[i++] = useTuples ? [
                k,
                v
            ] : v;
        });
        return array;
    },
    toIndexedSeq: function toIndexedSeq() {
        return new ToIndexedSequence(this);
    },
    toJS: function toJS$1() {
        return toJS(this);
    },
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, true);
    },
    toMap: function toMap() {
        // Use Late Binding here to solve the circular dependency.
        return Map(this.toKeyedSeq());
    },
    toObject: toObject,
    toOrderedMap: function toOrderedMap() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedMap(this.toKeyedSeq());
    },
    toOrderedSet: function toOrderedSet() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },
    toSet: function toSet() {
        // Use Late Binding here to solve the circular dependency.
        return Set(isKeyed(this) ? this.valueSeq() : this);
    },
    toSetSeq: function toSetSeq() {
        return new ToSetSequence(this);
    },
    toSeq: function toSeq() {
        return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
    },
    toStack: function toStack() {
        // Use Late Binding here to solve the circular dependency.
        return Stack(isKeyed(this) ? this.valueSeq() : this);
    },
    toList: function toList() {
        // Use Late Binding here to solve the circular dependency.
        return List(isKeyed(this) ? this.valueSeq() : this);
    },
    // ### Common JavaScript methods and properties
    toString: function toString() {
        return '[Collection]';
    },
    __toString: function __toString(head, tail) {
        if (this.size === 0) return head + tail;
        return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    concat: function concat() {
        var values = [], len = arguments.length;
        while(len--)values[len] = arguments[len];
        return reify(this, concatFactory(this, values));
    },
    includes: function includes(searchValue) {
        return this.some(function(value) {
            return is(value, searchValue);
        });
    },
    entries: function entries() {
        return this.__iterator(ITERATE_ENTRIES);
    },
    every: function every(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = true;
        this.__iterate(function(v, k, c) {
            if (!predicate.call(context, v, k, c)) {
                returnValue = false;
                return false;
            }
        });
        return returnValue;
    },
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, true));
    },
    partition: function partition(predicate, context) {
        return partitionFactory(this, predicate, context);
    },
    find: function find(predicate, context, notSetValue) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[1] : notSetValue;
    },
    forEach: function forEach(sideEffect, context) {
        assertNotInfinite(this.size);
        return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },
    join: function join(separator) {
        assertNotInfinite(this.size);
        separator = separator !== undefined ? '' + separator : ',';
        var joined = '';
        var isFirst = true;
        this.__iterate(function(v) {
            isFirst ? isFirst = false : joined += separator;
            joined += v !== null && v !== undefined ? v.toString() : '';
        });
        return joined;
    },
    keys: function keys() {
        return this.__iterator(ITERATE_KEYS);
    },
    map: function map(mapper, context) {
        return reify(this, mapFactory(this, mapper, context));
    },
    reduce: function reduce$1(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, false);
    },
    reduceRight: function reduceRight(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, true);
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, true));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, true));
    },
    some: function some(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = false;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                returnValue = true;
                return false;
            }
        });
        return returnValue;
    },
    sort: function sort(comparator) {
        return reify(this, sortFactory(this, comparator));
    },
    values: function values() {
        return this.__iterator(ITERATE_VALUES);
    },
    // ### More sequential methods
    butLast: function butLast() {
        return this.slice(0, -1);
    },
    isEmpty: function isEmpty() {
        return this.size !== undefined ? this.size === 0 : !this.some(function() {
            return true;
        });
    },
    count: function count(predicate, context) {
        return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
    },
    countBy: function countBy(grouper, context) {
        return countByFactory(this, grouper, context);
    },
    equals: function equals(other) {
        return deepEqual(this, other);
    },
    entrySeq: function entrySeq() {
        var collection = this;
        if (collection._cache) // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(collection._cache);
        var entriesSequence = collection.toSeq().map(entryMapper).toIndexedSeq();
        entriesSequence.fromEntrySeq = function() {
            return collection.toSeq();
        };
        return entriesSequence;
    },
    filterNot: function filterNot(predicate, context) {
        return this.filter(not(predicate), context);
    },
    findEntry: function findEntry(predicate, context, notSetValue) {
        var found = notSetValue;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                found = [
                    k,
                    v
                ];
                return false;
            }
        });
        return found;
    },
    findKey: function findKey(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry && entry[0];
    },
    findLast: function findLast(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },
    findLastEntry: function findLastEntry(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },
    findLastKey: function findLastKey(predicate, context) {
        return this.toKeyedSeq().reverse().findKey(predicate, context);
    },
    first: function first(notSetValue) {
        return this.find(returnTrue, null, notSetValue);
    },
    flatMap: function flatMap(mapper, context) {
        return reify(this, flatMapFactory(this, mapper, context));
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, true));
    },
    fromEntrySeq: function fromEntrySeq() {
        return new FromEntriesSequence(this);
    },
    get: function get(searchKey, notSetValue) {
        return this.find(function(_, key) {
            return is(key, searchKey);
        }, undefined, notSetValue);
    },
    getIn: getIn,
    groupBy: function groupBy(grouper, context) {
        return groupByFactory(this, grouper, context);
    },
    has: function has(searchKey) {
        return this.get(searchKey, NOT_SET) !== NOT_SET;
    },
    hasIn: hasIn,
    isSubset: function isSubset(iter) {
        iter = typeof iter.includes === 'function' ? iter : Collection(iter);
        return this.every(function(value) {
            return iter.includes(value);
        });
    },
    isSuperset: function isSuperset(iter) {
        iter = typeof iter.isSubset === 'function' ? iter : Collection(iter);
        return iter.isSubset(this);
    },
    keyOf: function keyOf(searchValue) {
        return this.findKey(function(value) {
            return is(value, searchValue);
        });
    },
    keySeq: function keySeq() {
        return this.toSeq().map(keyMapper).toIndexedSeq();
    },
    last: function last(notSetValue) {
        return this.toSeq().reverse().first(notSetValue);
    },
    lastKeyOf: function lastKeyOf(searchValue) {
        return this.toKeyedSeq().reverse().keyOf(searchValue);
    },
    max: function max(comparator) {
        return maxFactory(this, comparator);
    },
    maxBy: function maxBy(mapper, comparator) {
        return maxFactory(this, comparator, mapper);
    },
    min: function min(comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },
    minBy: function minBy(mapper, comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },
    rest: function rest() {
        return this.slice(1);
    },
    skip: function skip(amount) {
        return amount === 0 ? this : this.slice(Math.max(0, amount));
    },
    skipLast: function skipLast(amount) {
        return amount === 0 ? this : this.slice(0, -Math.max(0, amount));
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, true));
    },
    skipUntil: function skipUntil(predicate, context) {
        return this.skipWhile(not(predicate), context);
    },
    sortBy: function sortBy(mapper, comparator) {
        return reify(this, sortFactory(this, comparator, mapper));
    },
    take: function take(amount) {
        return this.slice(0, Math.max(0, amount));
    },
    takeLast: function takeLast(amount) {
        return this.slice(-Math.max(0, amount));
    },
    takeWhile: function takeWhile(predicate, context) {
        return reify(this, takeWhileFactory(this, predicate, context));
    },
    takeUntil: function takeUntil(predicate, context) {
        return this.takeWhile(not(predicate), context);
    },
    update: function update(fn) {
        return fn(this);
    },
    valueSeq: function valueSeq() {
        return this.toIndexedSeq();
    },
    // ### Hashable Object
    hashCode: function hashCode() {
        return this.__hash || (this.__hash = hashCollection(this));
    }
});
var CollectionPrototype = Collection.prototype;
CollectionPrototype[IS_COLLECTION_SYMBOL] = true;
CollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.values;
CollectionPrototype.toJSON = CollectionPrototype.toArray;
CollectionPrototype.__toStringMapper = quoteString;
CollectionPrototype.inspect = CollectionPrototype.toSource = function() {
    return this.toString();
};
CollectionPrototype.chain = CollectionPrototype.flatMap;
CollectionPrototype.contains = CollectionPrototype.includes;
mixin(KeyedCollection, {
    // ### More sequential methods
    flip: function flip() {
        return reify(this, flipFactory(this));
    },
    mapEntries: function mapEntries(mapper, context) {
        var this$1$1 = this;
        var iterations = 0;
        return reify(this, this.toSeq().map(function(v, k) {
            return mapper.call(context, [
                k,
                v
            ], iterations++, this$1$1);
        }).fromEntrySeq());
    },
    mapKeys: function mapKeys(mapper, context) {
        var this$1$1 = this;
        return reify(this, this.toSeq().flip().map(function(k, v) {
            return mapper.call(context, k, v, this$1$1);
        }).flip());
    }
});
var KeyedCollectionPrototype = KeyedCollection.prototype;
KeyedCollectionPrototype[IS_KEYED_SYMBOL] = true;
KeyedCollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.entries;
KeyedCollectionPrototype.toJSON = toObject;
KeyedCollectionPrototype.__toStringMapper = function(v, k) {
    return quoteString(k) + ': ' + quoteString(v);
};
mixin(IndexedCollection, {
    // ### Conversion to other types
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, false);
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, false));
    },
    findIndex: function findIndex(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    indexOf: function indexOf(searchValue) {
        var key = this.keyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    lastIndexOf: function lastIndexOf(searchValue) {
        var key = this.lastKeyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, false));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, false));
    },
    splice: function splice(index, removeNum /*, ...values*/ ) {
        var numArgs = arguments.length;
        removeNum = Math.max(removeNum || 0, 0);
        if (numArgs === 0 || numArgs === 2 && !removeNum) return this;
        // If index is negative, it should resolve relative to the size of the
        // collection. However size may be expensive to compute if not cached, so
        // only call count() if the number is in fact negative.
        index = resolveBegin(index, index < 0 ? this.count() : this.size);
        var spliced = this.slice(0, index);
        return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
    },
    // ### More collection methods
    findLastIndex: function findLastIndex(predicate, context) {
        var entry = this.findLastEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    first: function first(notSetValue) {
        return this.get(0, notSetValue);
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, false));
    },
    get: function get(index, notSetValue) {
        index = wrapIndex(this, index);
        return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function(_, key) {
            return key === index;
        }, undefined, notSetValue);
    },
    has: function has(index) {
        index = wrapIndex(this, index);
        return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
    },
    interpose: function interpose(separator) {
        return reify(this, interposeFactory(this, separator));
    },
    interleave: function interleave() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, collections);
        var interleaved = zipped.flatten(true);
        if (zipped.size) interleaved.size = zipped.size * collections.length;
        return reify(this, interleaved);
    },
    keySeq: function keySeq() {
        return Range(0, this.size);
    },
    last: function last(notSetValue) {
        return this.get(-1, notSetValue);
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, false));
    },
    zip: function zip() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections));
    },
    zipAll: function zipAll() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections, true));
    },
    zipWith: function zipWith(zipper /*, ...collections */ ) {
        var collections = arrCopy(arguments);
        collections[0] = this;
        return reify(this, zipWithFactory(this, zipper, collections));
    }
});
var IndexedCollectionPrototype = IndexedCollection.prototype;
IndexedCollectionPrototype[IS_INDEXED_SYMBOL] = true;
IndexedCollectionPrototype[IS_ORDERED_SYMBOL] = true;
mixin(SetCollection, {
    // ### ES6 Collection methods (ES6 Array and Map)
    get: function get(value, notSetValue) {
        return this.has(value) ? value : notSetValue;
    },
    includes: function includes(value) {
        return this.has(value);
    },
    // ### More sequential methods
    keySeq: function keySeq() {
        return this.valueSeq();
    }
});
var SetCollectionPrototype = SetCollection.prototype;
SetCollectionPrototype.has = CollectionPrototype.includes;
SetCollectionPrototype.contains = SetCollectionPrototype.includes;
SetCollectionPrototype.keys = SetCollectionPrototype.values;
// Mixin subclasses
mixin(KeyedSeq, KeyedCollectionPrototype);
mixin(IndexedSeq, IndexedCollectionPrototype);
mixin(SetSeq, SetCollectionPrototype);
// #pragma Helper functions
function reduce(collection, reducer, reduction, context, useFirst, reverse) {
    assertNotInfinite(collection.size);
    collection.__iterate(function(v, k, c) {
        if (useFirst) {
            useFirst = false;
            reduction = v;
        } else reduction = reducer.call(context, reduction, v, k, c);
    }, reverse);
    return reduction;
}
function keyMapper(v, k) {
    return k;
}
function entryMapper(v, k) {
    return [
        k,
        v
    ];
}
function not(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}
function neg(predicate) {
    return function() {
        return -predicate.apply(this, arguments);
    };
}
function defaultZipper() {
    return arrCopy(arguments);
}
function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function hashCollection(collection) {
    if (collection.size === Infinity) return 0;
    var ordered = isOrdered(collection);
    var keyed = isKeyed(collection);
    var h = ordered ? 1 : 0;
    var size = collection.__iterate(keyed ? ordered ? function(v, k) {
        h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
    } : function(v, k) {
        h = h + hashMerge(hash(v), hash(k)) | 0;
    } : ordered ? function(v) {
        h = 31 * h + hash(v) | 0;
    } : function(v) {
        h = h + hash(v) | 0;
    });
    return murmurHashOfSize(size, h);
}
function murmurHashOfSize(size, h) {
    h = imul(h, 0xcc9e2d51);
    h = imul(h << 15 | h >>> -15, 0x1b873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xe6546b64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85ebca6b);
    h = imul(h ^ h >>> 13, 0xc2b2ae35);
    h = smi(h ^ h >>> 16);
    return h;
}
function hashMerge(a, b) {
    return a ^ b + 0x9e3779b9 + (a << 6) + (a >> 2) | 0; // int
}
var OrderedSet = /*@__PURE__*/ function(Set) {
    function OrderedSet(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (Set) OrderedSet.__proto__ = Set;
    OrderedSet.prototype = Object.create(Set && Set.prototype);
    OrderedSet.prototype.constructor = OrderedSet;
    OrderedSet.of = function of() {
        return this(arguments);
    };
    OrderedSet.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    OrderedSet.prototype.toString = function toString() {
        return this.__toString('OrderedSet {', '}');
    };
    return OrderedSet;
}(Set);
OrderedSet.isOrderedSet = isOrderedSet;
var OrderedSetPrototype = OrderedSet.prototype;
OrderedSetPrototype[IS_ORDERED_SYMBOL] = true;
OrderedSetPrototype.zip = IndexedCollectionPrototype.zip;
OrderedSetPrototype.zipWith = IndexedCollectionPrototype.zipWith;
OrderedSetPrototype.zipAll = IndexedCollectionPrototype.zipAll;
OrderedSetPrototype.__empty = emptyOrderedSet;
OrderedSetPrototype.__make = makeOrderedSet;
function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var EMPTY_ORDERED_SET;
function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
}
var PairSorting = {
    LeftThenRight: -1,
    RightThenLeft: 1
};
function throwOnInvalidDefaultValues(defaultValues) {
    if (isRecord(defaultValues)) throw new Error('Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead.');
    if (isImmutable(defaultValues)) throw new Error('Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead.');
    if (defaultValues === null || typeof defaultValues !== 'object') throw new Error('Can not call `Record` with a non-object as default values. Use a plain javascript object instead.');
}
var Record = function Record(defaultValues, name) {
    var hasInitialized;
    throwOnInvalidDefaultValues(defaultValues);
    var RecordType = function Record(values) {
        var this$1$1 = this;
        if (values instanceof RecordType) return values;
        if (!(this instanceof RecordType)) return new RecordType(values);
        if (!hasInitialized) {
            hasInitialized = true;
            var keys = Object.keys(defaultValues);
            var indices = RecordTypePrototype._indices = {};
            // Deprecated: left to attempt not to break any external code which
            // relies on a ._name property existing on record instances.
            // Use Record.getDescriptiveName() instead
            RecordTypePrototype._name = name;
            RecordTypePrototype._keys = keys;
            RecordTypePrototype._defaultValues = defaultValues;
            for(var i = 0; i < keys.length; i++){
                var propName = keys[i];
                indices[propName] = i;
                if (RecordTypePrototype[propName]) /* eslint-disable no-console */ typeof console === 'object' && console.warn && console.warn('Cannot define ' + recordName(this) + ' with property "' + propName + '" since that property name is part of the Record API.');
                else setProp(RecordTypePrototype, propName);
            }
        }
        this.__ownerID = undefined;
        this._values = List().withMutations(function(l) {
            l.setSize(this$1$1._keys.length);
            KeyedCollection(values).forEach(function(v, k) {
                l.set(this$1$1._indices[k], v === this$1$1._defaultValues[k] ? undefined : v);
            });
        });
        return this;
    };
    var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
    RecordTypePrototype.constructor = RecordType;
    if (name) RecordType.displayName = name;
    // eslint-disable-next-line no-constructor-return
    return RecordType;
};
Record.prototype.toString = function toString() {
    var str = recordName(this) + ' { ';
    var keys = this._keys;
    var k;
    for(var i = 0, l = keys.length; i !== l; i++){
        k = keys[i];
        str += (i ? ', ' : '') + k + ': ' + quoteString(this.get(k));
    }
    return str + ' }';
};
Record.prototype.equals = function equals(other) {
    return this === other || isRecord(other) && recordSeq(this).equals(recordSeq(other));
};
Record.prototype.hashCode = function hashCode() {
    return recordSeq(this).hashCode();
};
// @pragma Access
Record.prototype.has = function has(k) {
    return this._indices.hasOwnProperty(k);
};
Record.prototype.get = function get(k, notSetValue) {
    if (!this.has(k)) return notSetValue;
    var index = this._indices[k];
    var value = this._values.get(index);
    return value === undefined ? this._defaultValues[k] : value;
};
// @pragma Modification
Record.prototype.set = function set(k, v) {
    if (this.has(k)) {
        var newValues = this._values.set(this._indices[k], v === this._defaultValues[k] ? undefined : v);
        if (newValues !== this._values && !this.__ownerID) return makeRecord(this, newValues);
    }
    return this;
};
Record.prototype.remove = function remove(k) {
    return this.set(k);
};
Record.prototype.clear = function clear() {
    var newValues = this._values.clear().setSize(this._keys.length);
    return this.__ownerID ? this : makeRecord(this, newValues);
};
Record.prototype.wasAltered = function wasAltered() {
    return this._values.wasAltered();
};
Record.prototype.toSeq = function toSeq() {
    return recordSeq(this);
};
Record.prototype.toJS = function toJS$1() {
    return toJS(this);
};
Record.prototype.entries = function entries() {
    return this.__iterator(ITERATE_ENTRIES);
};
Record.prototype.__iterator = function __iterator(type, reverse) {
    return recordSeq(this).__iterator(type, reverse);
};
Record.prototype.__iterate = function __iterate(fn, reverse) {
    return recordSeq(this).__iterate(fn, reverse);
};
Record.prototype.__ensureOwner = function __ensureOwner(ownerID) {
    if (ownerID === this.__ownerID) return this;
    var newValues = this._values.__ensureOwner(ownerID);
    if (!ownerID) {
        this.__ownerID = ownerID;
        this._values = newValues;
        return this;
    }
    return makeRecord(this, newValues, ownerID);
};
Record.isRecord = isRecord;
Record.getDescriptiveName = recordName;
var RecordPrototype = Record.prototype;
RecordPrototype[IS_RECORD_SYMBOL] = true;
RecordPrototype[DELETE] = RecordPrototype.remove;
RecordPrototype.deleteIn = RecordPrototype.removeIn = deleteIn;
RecordPrototype.getIn = getIn;
RecordPrototype.hasIn = CollectionPrototype.hasIn;
RecordPrototype.merge = merge$1;
RecordPrototype.mergeWith = mergeWith$1;
RecordPrototype.mergeIn = mergeIn;
RecordPrototype.mergeDeep = mergeDeep;
RecordPrototype.mergeDeepWith = mergeDeepWith;
RecordPrototype.mergeDeepIn = mergeDeepIn;
RecordPrototype.setIn = setIn;
RecordPrototype.update = update;
RecordPrototype.updateIn = updateIn;
RecordPrototype.withMutations = withMutations;
RecordPrototype.asMutable = asMutable;
RecordPrototype.asImmutable = asImmutable;
RecordPrototype[ITERATOR_SYMBOL] = RecordPrototype.entries;
RecordPrototype.toJSON = RecordPrototype.toObject = CollectionPrototype.toObject;
RecordPrototype.inspect = RecordPrototype.toSource = function() {
    return this.toString();
};
function makeRecord(likeRecord, values, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._values = values;
    record.__ownerID = ownerID;
    return record;
}
function recordName(record) {
    return record.constructor.displayName || record.constructor.name || 'Record';
}
function recordSeq(record) {
    return keyedSeqFromValue(record._keys.map(function(k) {
        return [
            k,
            record.get(k)
        ];
    }));
}
function setProp(prototype, name) {
    try {
        Object.defineProperty(prototype, name, {
            get: function() {
                return this.get(name);
            },
            set: function(value) {
                invariant(this.__ownerID, 'Cannot set on an immutable record.');
                this.set(name, value);
            }
        });
    } catch (error) {
    // Object.defineProperty failed. Probably IE8.
    }
}
/**
 * Returns a lazy Seq of `value` repeated `times` times. When `times` is
 * undefined, returns an infinite sequence of `value`.
 */ var Repeat = /*@__PURE__*/ function(IndexedSeq) {
    function Repeat(value, times) {
        if (!(this instanceof Repeat)) // eslint-disable-next-line no-constructor-return
        return new Repeat(value, times);
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
            if (EMPTY_REPEAT) // eslint-disable-next-line no-constructor-return
            return EMPTY_REPEAT;
            EMPTY_REPEAT = this;
        }
    }
    if (IndexedSeq) Repeat.__proto__ = IndexedSeq;
    Repeat.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Repeat.prototype.constructor = Repeat;
    Repeat.prototype.toString = function toString() {
        if (this.size === 0) return 'Repeat []';
        return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };
    Repeat.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
    };
    Repeat.prototype.includes = function includes(searchValue) {
        return is(this._value, searchValue);
    };
    Repeat.prototype.slice = function slice(begin, end) {
        var size = this.size;
        return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };
    Repeat.prototype.reverse = function reverse() {
        return this;
    };
    Repeat.prototype.indexOf = function indexOf(searchValue) {
        if (is(this._value, searchValue)) return 0;
        return -1;
    };
    Repeat.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        if (is(this._value, searchValue)) return this.size;
        return -1;
    };
    Repeat.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var i = 0;
        while(i !== size){
            if (fn(this._value, reverse ? size - ++i : i++, this) === false) break;
        }
        return i;
    };
    Repeat.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var size = this.size;
        var i = 0;
        return new Iterator(function() {
            return i === size ? iteratorDone() : iteratorValue(type, reverse ? size - ++i : i++, this$1$1._value);
        });
    };
    Repeat.prototype.equals = function equals(other) {
        return other instanceof Repeat ? is(this._value, other._value) : deepEqual(this, other);
    };
    return Repeat;
}(IndexedSeq);
var EMPTY_REPEAT;
function fromJS(value, converter) {
    return fromJSWith([], converter || defaultConverter, value, '', converter && converter.length > 2 ? [] : undefined, {
        '': value
    });
}
function fromJSWith(stack, converter, value, key, keyPath, parentValue) {
    if (typeof value !== 'string' && !isImmutable(value) && (isArrayLike(value) || hasIterator(value) || isPlainObject(value))) {
        if (~stack.indexOf(value)) throw new TypeError('Cannot convert circular structure to Immutable');
        stack.push(value);
        keyPath && key !== '' && keyPath.push(key);
        var converted = converter.call(parentValue, key, Seq(value).map(function(v, k) {
            return fromJSWith(stack, converter, v, k, keyPath, value);
        }), keyPath && keyPath.slice());
        stack.pop();
        keyPath && keyPath.pop();
        return converted;
    }
    return value;
}
function defaultConverter(k, v) {
    // Effectively the opposite of "Collection.toSeq()"
    return isIndexed(v) ? v.toList() : isKeyed(v) ? v.toMap() : v.toSet();
}
var version = "4.3.7";
var Immutable = {
    version: version,
    Collection: Collection,
    // Note: Iterable is deprecated
    Iterable: Collection,
    Seq: Seq,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,
    PairSorting: PairSorting,
    Record: Record,
    Range: Range,
    Repeat: Repeat,
    is: is,
    fromJS: fromJS,
    hash: hash,
    isImmutable: isImmutable,
    isCollection: isCollection,
    isKeyed: isKeyed,
    isIndexed: isIndexed,
    isAssociative: isAssociative,
    isOrdered: isOrdered,
    isValueObject: isValueObject,
    isPlainObject: isPlainObject,
    isSeq: isSeq,
    isList: isList,
    isMap: isMap,
    isOrderedMap: isOrderedMap,
    isStack: isStack,
    isSet: isSet,
    isOrderedSet: isOrderedSet,
    isRecord: isRecord,
    get: get,
    getIn: getIn$1,
    has: has,
    hasIn: hasIn$1,
    merge: merge,
    mergeDeep: mergeDeep$1,
    mergeWith: mergeWith,
    mergeDeepWith: mergeDeepWith$1,
    remove: remove,
    removeIn: removeIn,
    set: set,
    setIn: setIn$1,
    update: update$1,
    updateIn: updateIn$1
};
// Note: Iterable is deprecated
var Iterable = Collection;
var $46c0d1dee9537ec2$export$2e2bcd8739ae039 = Immutable;
module.exports["Map"] = Map;
module.exports["List"] = List;
module.exports["Set"] = Set;
module.exports["OrderedSet"] = OrderedSet;
module.exports["Record"] = Record;
module.exports["fromJS"] = fromJS;
module.exports["Iterable"] = Iterable;

});

parcelRegister("1d2ww", function(module, exports) {
var $10046ab4436c1de6$export$12d28147ee0fcd7c = /*#__PURE__*/ function(ContentAppearancePropertyKey) {
    ContentAppearancePropertyKey["PUBLISHED"] = "content-appearance-published";
    ContentAppearancePropertyKey["DRAFT"] = "content-appearance-draft";
    return ContentAppearancePropertyKey;
}({});
var $10046ab4436c1de6$export$72beb3923a6d34b3 = /*#__PURE__*/ function(ContentAppearanceType) {
    ContentAppearanceType["DEFAULT"] = "default";
    ContentAppearanceType["FULL_WIDTH"] = "full-width";
    return ContentAppearanceType;
}({});
module.exports["ContentAppearancePropertyKey"] = $10046ab4436c1de6$export$12d28147ee0fcd7c;
module.exports["ContentAppearanceType"] = $10046ab4436c1de6$export$72beb3923a6d34b3;

});

parcelRegister("8VcPj", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");


var $lztxY = parcelRequire("lztxY");


var $1d2ww = parcelRequire("1d2ww");

const $df5e53df2c3ce3a1$export$b1d01ffe4898696d = (properties, key)=>{
    const contentAppearanceProperty = properties?.find((property)=>property?.key === key && property?.version);
    let appearance = (0, $1d2ww.ContentAppearanceType).DEFAULT;
    let version = 0;
    if (contentAppearanceProperty) {
        appearance = contentAppearanceProperty.value ? JSON.parse(contentAppearanceProperty.value) : appearance;
        version = contentAppearanceProperty.version?.number || version;
    }
    return {
        appearance: appearance,
        version: version
    };
};
const $df5e53df2c3ce3a1$export$3435d65c6da71431 = (content)=>{
    return $df5e53df2c3ce3a1$export$b1d01ffe4898696d(content.appearanceDraft?.nodes ?? null, (0, $1d2ww.ContentAppearancePropertyKey).DRAFT);
};
const $df5e53df2c3ce3a1$export$31055ca3b35a4c84 = (content)=>{
    return $df5e53df2c3ce3a1$export$b1d01ffe4898696d(content.appearancePublished?.nodes ?? null, (0, $1d2ww.ContentAppearancePropertyKey).PUBLISHED);
};
const $df5e53df2c3ce3a1$export$2521257be0c7ea48 = async (updateContentAppearanceProperty, params, apolloClient, collabEditProvider)=>{
    try {
        await updateContentAppearanceProperty(params);
        $df5e53df2c3ce3a1$export$444e60a54db64042(collabEditProvider, params);
        return params;
    } catch (error) {
        // If it was an HTTP 409 conflict, retry once with the latest version number + 1
        if ((0, $aMcHK.isStatusCodeError)(error, '409')) {
            const appearanceProperty = await $df5e53df2c3ce3a1$export$1e0fa67d5da0b9b3(params.contentId, params.propertyKey, apolloClient, 'network-only');
            if (appearanceProperty.version) {
                params = $df5e53df2c3ce3a1$export$b7d46c1a2c850d6c(params, appearanceProperty);
                await updateContentAppearanceProperty(params);
                $df5e53df2c3ce3a1$export$444e60a54db64042(collabEditProvider, params);
                return params;
            }
        }
        throw error;
    }
};
const $df5e53df2c3ce3a1$export$b7d46c1a2c850d6c = (params, appearanceProperty)=>{
    params.versionNumber = appearanceProperty.version + 1;
    if (params.propertyValue !== appearanceProperty.appearance) params.propertyValue = appearanceProperty.appearance === (0, $1d2ww.ContentAppearanceType).DEFAULT ? (0, $1d2ww.ContentAppearanceType).FULL_WIDTH : (0, $1d2ww.ContentAppearanceType).DEFAULT;
    return params;
};
function $df5e53df2c3ce3a1$export$7490752b89a3fa25(propertyKey) {
    return propertyKey === (0, $1d2ww.ContentAppearancePropertyKey).PUBLISHED ? (0, $lztxY.getPublishedContentAppearanceProperty) : (0, $lztxY.getDraftContentAppearanceProperty);
}
function $df5e53df2c3ce3a1$export$95c1397e685f545a(data, propertyKey) {
    const content = data?.content?.nodes?.[0];
    if (content) return propertyKey === (0, $1d2ww.ContentAppearancePropertyKey).PUBLISHED ? $df5e53df2c3ce3a1$export$31055ca3b35a4c84(content) : $df5e53df2c3ce3a1$export$3435d65c6da71431(content);
    return $df5e53df2c3ce3a1$export$a03a5edc3d041369();
}
const $df5e53df2c3ce3a1$export$1e0fa67d5da0b9b3 = async (contentId, propertyKey, apolloClient, fetchPolicy = 'cache-first')=>{
    const query = $df5e53df2c3ce3a1$export$7490752b89a3fa25(propertyKey);
    // This is dummy variable is used to force "network-only" requests to only be run as network calls.
    // A bug in Apollo sometimes makes this query return data from the cache even if the policy is "network-only"
    // See for more details: https://pug.jira-dev.com/wiki/spaces/~683304838/pages/5971970200/Apollo+Client+-+weird+refetch+behavior
    const dummy = fetchPolicy === 'network-only' ? Date.now() : undefined;
    const contentAppearanceDraftProperty = await apolloClient.query({
        query: query,
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            dummy: dummy
        },
        fetchPolicy: fetchPolicy,
        context: {
            single: 'true'
        }
    });
    return $df5e53df2c3ce3a1$export$95c1397e685f545a(contentAppearanceDraftProperty?.data, propertyKey);
};
const $df5e53df2c3ce3a1$export$a03a5edc3d041369 = ()=>{
    return {
        appearance: (0, $1d2ww.ContentAppearanceType).DEFAULT,
        version: 0
    };
};
const $df5e53df2c3ce3a1$export$bf8bc2ce12ceefdd = 'editorAppearance';
const $df5e53df2c3ce3a1$export$444e60a54db64042 = (collabEditProvider, params)=>{
    if (!collabEditProvider) return;
    // Implies NCS provider
    if (typeof collabEditProvider.setMetadata === 'function') collabEditProvider.setMetadata({
        ...collabEditProvider.getMetadata(),
        metadataSource: 'client',
        editorWidth: {
            value: params.propertyValue,
            version: params.versionNumber
        }
    });
    else collabEditProvider.sendMessage({
        type: $df5e53df2c3ce3a1$export$bf8bc2ce12ceefdd,
        appearance: params.propertyValue,
        version: params.versionNumber
    });
};
const $df5e53df2c3ce3a1$export$acf12c613e8460b9 = async (appearanceProperty, params, updateContentAppearanceProperty, collabEditProvider)=>{
    const newParams = {
        ...params,
        propertyValue: appearanceProperty.appearance,
        versionNumber: appearanceProperty.version + 1
    };
    if (appearanceProperty.version) {
        await updateContentAppearanceProperty(newParams);
        $df5e53df2c3ce3a1$export$444e60a54db64042(collabEditProvider, newParams);
    }
};
module.exports["getContentAppearanceFromContentProperties"] = $df5e53df2c3ce3a1$export$b1d01ffe4898696d;
module.exports["getContentAppearancePublished"] = $df5e53df2c3ce3a1$export$31055ca3b35a4c84;
module.exports["updateContentAppearancePropertyWithRetry"] = $df5e53df2c3ce3a1$export$2521257be0c7ea48;
module.exports["updateAppearanceForCollab"] = $df5e53df2c3ce3a1$export$444e60a54db64042;
module.exports["fetchContentAppearanceProperty"] = $df5e53df2c3ce3a1$export$1e0fa67d5da0b9b3;
module.exports["getContentAppearanceQuery"] = $df5e53df2c3ce3a1$export$7490752b89a3fa25;
module.exports["getContentAppearanceFromQueryData"] = $df5e53df2c3ce3a1$export$95c1397e685f545a;
module.exports["updateContentAppearancePropertyAfterOfflineMode"] = $df5e53df2c3ce3a1$export$acf12c613e8460b9;

});

parcelRegister("bx6Tx", function(module, exports) {
var $06836d9e9d0af6ba$export$5607a6f6a1982099 = /*#__PURE__*/ function(EDITOR_NAV_DESTINATION) {
    EDITOR_NAV_DESTINATION["NONE"] = "none";
    EDITOR_NAV_DESTINATION["PREVIEW"] = "preview";
    EDITOR_NAV_DESTINATION["VIEWPAGE"] = "viewpage";
    EDITOR_NAV_DESTINATION["HOMEPAGE"] = "homepage";
    return EDITOR_NAV_DESTINATION;
}({});
const $06836d9e9d0af6ba$export$12c3fa6b8a339bbd = 255;
const $06836d9e9d0af6ba$export$643b14d94ff0897b = {
    FABRIC: 'FABRIC',
    TINY_MCE: 'TINY_MCE'
};
var $06836d9e9d0af6ba$export$9c28bc693ca74328 = /*#__PURE__*/ function(SYNC_STATUS_KEY) {
    SYNC_STATUS_KEY["CONNECTED"] = "connected";
    SYNC_STATUS_KEY["DISCONNECTED"] = "disconnected";
    SYNC_STATUS_KEY["ERROR"] = "error";
    SYNC_STATUS_KEY["COLLAB_LIMIT"] = "collab-limit";
    SYNC_STATUS_KEY["PERMISSION_CHANGED"] = "permission-changed";
    return SYNC_STATUS_KEY;
}({});
const $06836d9e9d0af6ba$export$f292b2b582c6bbae = {
    ["connected"]: {
        text: 'collab.status.connected',
        tooltip: 'collab.status.tooltip.success',
        shouldAutoHide: true,
        type: 'success'
    },
    ["error"]: {
        text: 'collab.status.error',
        tooltip: 'collab.status.tooltip.error',
        shouldAutoHide: false,
        type: 'error'
    },
    ["collab-limit"]: {
        text: 'editor.collab.user.limit.title',
        tooltip: 'editor.collab.user.limit.body',
        shouldAutoHide: false,
        type: 'error'
    },
    ["permission-changed"]: {
        text: 'fabric.editor.permission.removed.title',
        tooltip: 'fabric.editor.permission.removed.description',
        shouldAutoHide: false,
        type: 'error'
    }
};
const $06836d9e9d0af6ba$export$ebc7c6dde3af2f94 = 8;
const $06836d9e9d0af6ba$export$ad0dea64d86a0b40 = 12;
const $06836d9e9d0af6ba$export$2319941692274211 = 'editor.content.placeholder.easy.mentions';
const $06836d9e9d0af6ba$export$65b686286dab5755 = 'editor.onboarding.draft.placeholder';
const $06836d9e9d0af6ba$export$7f03b831e2e40b16 = 'editor.content.placeholder.ai';
const $06836d9e9d0af6ba$export$6a44b93c4f739392 = "Type /ai for Atlassian Intelligence, / to add elements, or @ to mention someone (we\u2019ll let them know).";
module.exports["EDITOR_NAV_DESTINATION"] = $06836d9e9d0af6ba$export$5607a6f6a1982099;
module.exports["MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH"] = $06836d9e9d0af6ba$export$12c3fa6b8a339bbd;

});

parcelRegister("btz1y", function(module, exports) {

var $5cBWV = parcelRequire("5cBWV");

const $85ad922d79aba78f$export$248a2cbc69bbb275 = 'OPEN_PREVIEWER';
const $85ad922d79aba78f$export$66c06c0cd94c0b11 = (0, $5cBWV.commonActionCreator)($85ad922d79aba78f$export$248a2cbc69bbb275);
const $85ad922d79aba78f$export$c891abbc061364af = 'CLOSE_PREVIEWER';
const $85ad922d79aba78f$export$6305e437e46c6e97 = (0, $5cBWV.commonActionCreator)($85ad922d79aba78f$export$c891abbc061364af);
module.exports["OPEN_PREVIEWER"] = $85ad922d79aba78f$export$248a2cbc69bbb275;
module.exports["CLOSE_PREVIEWER"] = $85ad922d79aba78f$export$c891abbc061364af;
module.exports["closePreviewer"] = $85ad922d79aba78f$export$6305e437e46c6e97;

});

parcelRegister("eH0qm", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab256916bdf15e30$export$2e2bcd8739ae039);

var $64Cib = parcelRequire("64Cib");


var $b4Wym = parcelRequire("b4Wym");


var $h0zqw = parcelRequire("h0zqw");

const $ab256916bdf15e30$var$OK = 200;
// This is based on viewpage's defaultState
const $ab256916bdf15e30$var$defaultState = (0, $64Cib.fromJS)({
    draftId: null,
    isRequesting: false,
    hasFetched: false,
    result: null,
    errorData: null,
    statusCode: null,
    silent: null
});
const $ab256916bdf15e30$var$copyFromOriginalResponse = (response, keys)=>{
    if (!response || !response._originalResponse) return {};
    return Object.keys(response._originalResponse).filter((key)=>keys.indexOf(key) > -1).reduce((filteredKeys, key)=>{
        filteredKeys[key] = response._originalResponse[key];
        return filteredKeys;
    }, {});
};
function $ab256916bdf15e30$export$2e2bcd8739ae039(state = $ab256916bdf15e30$var$defaultState, action) {
    switch(action.type){
        // Creating page.
        case `${0, $h0zqw.EDITOR_CREATE_PAGE}_REQUEST`:
            return state.merge({
                draftId: null,
                isRequesting: true,
                hasFetched: false,
                result: null,
                errorData: null,
                statusCode: null,
                silent: !!action.silent
            });
        case `${0, $h0zqw.EDITOR_CREATE_PAGE}_SUCCESS`:
            return state.merge({
                draftId: action.response.id,
                isRequesting: false,
                hasFetched: true,
                result: {
                    title: '',
                    editorContent: '',
                    ...action.response
                },
                statusCode: $ab256916bdf15e30$var$OK,
                errorData: null
            });
        case `${0, $h0zqw.EDITOR_CREATE_PAGE}_FAILURE`:
            if (state.get('draftId') !== action.options.contentId) return state;
            return state.merge({
                isRequesting: false,
                hasFetched: true,
                statusCode: action.error && action.error.statusCode,
                errorData: action.message
            });
        // Loading existing draft.
        case `${0, $h0zqw.EDITOR_LOAD_DRAFT}_REQUEST`:
            return state.merge({
                draftId: action.contentId,
                isRequesting: true,
                hasFetched: false,
                result: null,
                errorData: null,
                statusCode: null,
                silent: !!action.silent
            });
        case `${0, $h0zqw.EDITOR_LOAD_DRAFT}_SUCCESS`:
            return state.mergeDeep({
                draftId: action.response.id.toString(),
                isRequesting: false,
                hasFetched: true,
                result: {
                    // editorContent - Not having this attribute causes failure in collaborative-helper.js on 'rte-loaded' event and collaborative editing is never initialised propertly.
                    // syncRev - needed by collab editing plugin when loading draft
                    ...$ab256916bdf15e30$var$copyFromOriginalResponse(action.response, [
                        'ancestors',
                        'confRev',
                        'editorContent',
                        'spaceKey',
                        'syncRev',
                        'syncRevSource',
                        'type',
                        'publishedId'
                    ]),
                    ...action.response,
                    title: action.response && action.response.title ? action.response.title : ''
                },
                statusCode: $ab256916bdf15e30$var$OK,
                errorData: null
            });
        case `${0, $h0zqw.EDITOR_LOAD_DRAFT}_FAILURE`:
            if (state.get('draftId') !== action.options.contentId) return state;
            return state.merge({
                isRequesting: false,
                hasFetched: true,
                statusCode: action.error && action.error.statusCode,
                errorData: action.message
            });
        // Loading metadata for existing draft (ancestors, spaceKey etc).
        case `${0, $h0zqw.EDITOR_LOAD_DRAFTMETADATA}_REQUEST`:
            return state.merge({});
        case `${0, $h0zqw.EDITOR_LOAD_DRAFTMETADATA}_SUCCESS`:
            return state.mergeDeep({
                result: {
                    ...action.response
                }
            });
        case `${0, $h0zqw.EDITOR_LOAD_DRAFTMETADATA}_FAILURE`:
            if (state.get('draftId') !== action.options.contentId) return state;
            return state.merge({
                hasFetched: true,
                statusCode: action.error && action.error.statusCode,
                errorData: action.message
            });
        default:
            return state;
    }
}
/*
 * Selectors
 */ const $ab256916bdf15e30$var$getEditorContentState = (state)=>state.editor;
const $ab256916bdf15e30$export$b2f908ac75c2cd6a = ()=>(0, $b4Wym.createSelector)($ab256916bdf15e30$var$getEditorContentState, (contentState)=>{
        const isRequesting = contentState.get('isRequesting', false);
        const hasFetched = contentState.get('hasFetched', false);
        const draftId = contentState.get('draftId');
        const silent = contentState.get('silent', false);
        const statusCode = contentState.get('statusCode');
        const errorData = contentState.get('errorData', null);
        const result = contentState.get('result', null);
        return {
            draftId: draftId,
            isRequesting: isRequesting,
            hasFetched: hasFetched,
            result: result && typeof result.toJS === 'function' ? result.toJS() : result,
            statusCode: statusCode,
            errorData: errorData && typeof errorData.toJS === 'function' ? errorData.toJS() : errorData,
            // calculated data
            shouldNavigateToEditPage: !silent && hasFetched && statusCode === $ab256916bdf15e30$var$OK
        };
    });
module.exports["createEditorContentSelector"] = $ab256916bdf15e30$export$b2f908ac75c2cd6a;

});

parcelRegister("h0zqw", function(module, exports) {
const $c61deac1d0fcb139$export$adab377c3747e6ec = 'SHOW_EDITOR';
const $c61deac1d0fcb139$export$769680a800b3e49b = 'HIDE_EDITOR';
const $c61deac1d0fcb139$export$f536364345fa901 = 'CHANGE_EDITOR_TITLE';
const $c61deac1d0fcb139$export$cf3830159073b5c6 = 'CLOSE_EDITOR_ERROR';
const $c61deac1d0fcb139$export$8d355854b1568521 = 'SHOW_EDITOR_ERROR';
const $c61deac1d0fcb139$export$bb74b4aa9d2a7883 = 'EDITOR_LOAD_COMPLETE';
const $c61deac1d0fcb139$export$844e5d28d7c53716 = 'EDITOR_PRELOAD_START';
const $c61deac1d0fcb139$export$5414e4eb34232361 = 'EDITOR_PRELOAD_FINISH';
const $c61deac1d0fcb139$export$df4d75fdeb9b0a75 = 'RESET_EDITOR_STATE';
const $c61deac1d0fcb139$export$1b6e2215dbbf3c21 = 'EDITOR_CONTENT';
const $c61deac1d0fcb139$export$1280b2627d9867ba = 'EDITOR_CONTENT_V2';
const $c61deac1d0fcb139$export$1d1f1f4f7efebacf = 'EDITOR_CONTENT_PUBLISH';
const $c61deac1d0fcb139$export$e0b0325845bd4c65 = 'EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH';
const $c61deac1d0fcb139$export$9ae8757b668977b9 = 'CHANGE_EDITOR_MODE';
const $c61deac1d0fcb139$export$8bea51dc3517b81a = 'EDITOR_CONTENT_EDITABLE';
const $c61deac1d0fcb139$export$80c3dfc9d5cacb39 = 'EDITOR_DRAFT_SAVE';
const $c61deac1d0fcb139$export$be00ff52a5d342df = 'SET_SAVE_DRAFT';
const $c61deac1d0fcb139$export$1b2c38a78682fc42 = 'EDITOR_CREATE_PAGE';
const $c61deac1d0fcb139$export$bb7a1e42ff29bee3 = 'EDITOR_LOAD_DRAFT';
const $c61deac1d0fcb139$export$8e503201b9a4fa83 = 'EDITOR_LOAD_DRAFTMETADATA';
const $c61deac1d0fcb139$export$660d7837b5f43300 = 'SET_IS_PUBLISHING_CONTENT';
const $c61deac1d0fcb139$export$6abc1bce3635b823 = 'EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY';
const $c61deac1d0fcb139$export$1bcb5f8fa4e3ec7b = 'UPDATE_CONTENT_SPACE_KEY';
const $c61deac1d0fcb139$export$8a1237499437174d = 'EDITOR_SHOW_SCHEDULED_PUBLISH_DIALOG';
const $c61deac1d0fcb139$export$c44d1aa4144e442a = 'EDITOR_HIDE_SCHEDULED_PUBLISH_COMPONENT';
const $c61deac1d0fcb139$export$9a9886cb61805b71 = 'EDITOR_CURRENTLY_SCHEDULED_PUBLISH_DATE';
const $c61deac1d0fcb139$export$80219463b60ef911 = 'EDITOR_CANCEL_SCHEDULED_PUBLISH';
const $c61deac1d0fcb139$export$8dfd7df63c7e238c = 'SET_IS_SCHEDULING_PUBLISH';
module.exports["SHOW_EDITOR"] = $c61deac1d0fcb139$export$adab377c3747e6ec;
module.exports["HIDE_EDITOR"] = $c61deac1d0fcb139$export$769680a800b3e49b;
module.exports["CHANGE_EDITOR_TITLE"] = $c61deac1d0fcb139$export$f536364345fa901;
module.exports["CLOSE_EDITOR_ERROR"] = $c61deac1d0fcb139$export$cf3830159073b5c6;
module.exports["SHOW_EDITOR_ERROR"] = $c61deac1d0fcb139$export$8d355854b1568521;
module.exports["EDITOR_LOAD_COMPLETE"] = $c61deac1d0fcb139$export$bb74b4aa9d2a7883;
module.exports["EDITOR_PRELOAD_START"] = $c61deac1d0fcb139$export$844e5d28d7c53716;
module.exports["EDITOR_PRELOAD_FINISH"] = $c61deac1d0fcb139$export$5414e4eb34232361;
module.exports["RESET_EDITOR_STATE"] = $c61deac1d0fcb139$export$df4d75fdeb9b0a75;
module.exports["EDITOR_CONTENT"] = $c61deac1d0fcb139$export$1b6e2215dbbf3c21;
module.exports["EDITOR_CONTENT_PUBLISH"] = $c61deac1d0fcb139$export$1d1f1f4f7efebacf;
module.exports["EDITOR_CONTENT_FROM_TEMPLATE_PUBLISH"] = $c61deac1d0fcb139$export$e0b0325845bd4c65;
module.exports["CHANGE_EDITOR_MODE"] = $c61deac1d0fcb139$export$9ae8757b668977b9;
module.exports["EDITOR_CONTENT_EDITABLE"] = $c61deac1d0fcb139$export$8bea51dc3517b81a;
module.exports["EDITOR_DRAFT_SAVE"] = $c61deac1d0fcb139$export$80c3dfc9d5cacb39;
module.exports["SET_SAVE_DRAFT"] = $c61deac1d0fcb139$export$be00ff52a5d342df;
module.exports["EDITOR_CREATE_PAGE"] = $c61deac1d0fcb139$export$1b2c38a78682fc42;
module.exports["EDITOR_LOAD_DRAFT"] = $c61deac1d0fcb139$export$bb7a1e42ff29bee3;
module.exports["EDITOR_LOAD_DRAFTMETADATA"] = $c61deac1d0fcb139$export$8e503201b9a4fa83;
module.exports["SET_IS_PUBLISHING_CONTENT"] = $c61deac1d0fcb139$export$660d7837b5f43300;
module.exports["EDITOR_UPDATE_CONTENT_APPEARANCE_PROPERTY"] = $c61deac1d0fcb139$export$6abc1bce3635b823;
module.exports["UPDATE_CONTENT_SPACE_KEY"] = $c61deac1d0fcb139$export$1bcb5f8fa4e3ec7b;
module.exports["EDITOR_SHOW_SCHEDULED_PUBLISH_DIALOG"] = $c61deac1d0fcb139$export$8a1237499437174d;
module.exports["EDITOR_HIDE_SCHEDULED_PUBLISH_COMPONENT"] = $c61deac1d0fcb139$export$c44d1aa4144e442a;
module.exports["EDITOR_CURRENTLY_SCHEDULED_PUBLISH_DATE"] = $c61deac1d0fcb139$export$9a9886cb61805b71;
module.exports["EDITOR_CANCEL_SCHEDULED_PUBLISH"] = $c61deac1d0fcb139$export$80219463b60ef911;
module.exports["SET_IS_SCHEDULING_PUBLISH"] = $c61deac1d0fcb139$export$8dfd7df63c7e238c;

});

parcelRegister("iU8DZ", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $6g1oe = parcelRequire("6g1oe");


var $1NBp8 = parcelRequire("1NBp8");


var $aTWRz = parcelRequire("aTWRz");

const $dc34297d07844a72$export$ecf541e09a511845 = (param, url)=>$dc34297d07844a72$export$ec161d740909e39d(url)[param];
const $dc34297d07844a72$export$ec161d740909e39d = (url)=>{
    /* istanbul ignore next */ if (typeof url === 'undefined') url = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).location.href;
    const parsedUrl = (0, $jiJCD.parse)(url, true);
    return parsedUrl.query || {};
};
const $dc34297d07844a72$export$6d562956a780c337 = (url)=>{
    if (0, $aTWRz.CONTEXT_PATH) url = url.replace((0, $aTWRz.CONTEXT_PATH), '');
    return url.replace(/^\/(.*)/, '$1');
};
const $dc34297d07844a72$var$PAGE_CONTENT_SLUG_REGEX = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/([^\/]+)/pages/([0-9]+)/([^?/]+)`);
const $dc34297d07844a72$var$BLOG_CONTENT_SLUG_REGEX = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/([^\/]+)/blog/(\\d{4})/(\\d{2})/(\\d{2})/([0-9]+)/([^?/]+)`);
const $dc34297d07844a72$export$bd2270b4ca226dc6 = (url)=>{
    if (!url) return '';
    else if ($dc34297d07844a72$var$PAGE_CONTENT_SLUG_REGEX.test(url)) return url.replace($dc34297d07844a72$var$PAGE_CONTENT_SLUG_REGEX, '/spaces/$1/pages/$2/:contentSlug');
    else if ($dc34297d07844a72$var$BLOG_CONTENT_SLUG_REGEX.test(url)) return url.replace($dc34297d07844a72$var$BLOG_CONTENT_SLUG_REGEX, '/spaces/$1/blog/$2/$3/$4/$5/:contentSlug');
    else return url.replace((0, $aTWRz.CONTEXT_PATH), '') || '/';
};
const $dc34297d07844a72$export$53355f81448f1b1f = (params, url)=>{
    const parsedUrl = (0, $jiJCD.parse)(url, true);
    delete parsedUrl.search;
    parsedUrl.query = {
        ...parsedUrl.query,
        ...params
    };
    return (0, $jiJCD.format)(parsedUrl);
};
const $dc34297d07844a72$export$8189558ac52562eb = (params, url)=>{
    const parsedUrl = (0, $jiJCD.parse)(url, true);
    delete parsedUrl.search;
    params.forEach((paramName)=>delete parsedUrl.query[paramName]);
    return (0, $jiJCD.format)(parsedUrl);
};
const $dc34297d07844a72$export$8c0251135969de83 = (spaceKey)=>$dc34297d07844a72$var$getSpaceLink(spaceKey, 'pages');
const $dc34297d07844a72$export$85bee227b225f54c = (spaceKey, year, month, day, contentId, slug)=>$dc34297d07844a72$var$getSpaceLink(spaceKey, `blog/${year}/${month}/${day}/${contentId}${slug ? `/${slug}` : ''}`);
const $dc34297d07844a72$export$72f2ced4cb2807e1 = (spaceKey)=>$dc34297d07844a72$var$getSpaceLink(spaceKey, 'overview');
const $dc34297d07844a72$export$d926fe7959ff33ad = (spaceKey)=>$dc34297d07844a72$var$getSpaceLink(spaceKey, 'questions');
const $dc34297d07844a72$export$e1cedf0f16f74081 = (spaceKey)=>$dc34297d07844a72$var$getSpaceLink(spaceKey, 'calendars');
const $dc34297d07844a72$export$826b1d418b638b4b = (spaceKey)=>`${0, $aTWRz.CONTEXT_PATH}/${0, $aTWRz.SPACE_ROOT}/viewspacesummary.action?key=${encodeURIComponent(spaceKey)}&src=spacetools`;
const $dc34297d07844a72$export$31fff003e6b0fa09 = (spaceKey, contentType, contentId)=>{
    const contentTypeRoute = contentType === 'blogpost' ? 'blog' : 'pages';
    return $dc34297d07844a72$var$getSpaceLink(spaceKey, `${contentTypeRoute}/edit/${contentId}`);
};
const $dc34297d07844a72$export$51becd8adde0429c = (spaceKey, contentType, contentId)=>{
    const contentTypeRoute = contentType === 'blogpost' ? 'blog' : 'pages';
    return $dc34297d07844a72$var$getSpaceLink(spaceKey, `${contentTypeRoute}/edit-v2/${contentId}`);
};
const $dc34297d07844a72$export$ed1bbdbf30c51bda = (contentId, spaceKey)=>{
    if (spaceKey) return $dc34297d07844a72$var$getSpaceLink(spaceKey, `templates/edit/${contentId}`);
    return `${0, $aTWRz.CONTEXT_PATH}/templates/edit/${contentId}`;
};
const $dc34297d07844a72$export$b75aa7172d174854 = (spaceKey, contentId)=>`${$dc34297d07844a72$export$8c0251135969de83(spaceKey)}/${contentId}`;
/**
 * Build a space link. If path starts with contains context path then it will be removed
 *
 * @param spaceKey
 * @param path
 * @returns {string|*}
 */ const $dc34297d07844a72$var$getSpaceLink = (spaceKey, path = '')=>{
    spaceKey = encodeURIComponent(spaceKey);
    let spacePath = (typeof path === 'string' ? path : path.pathname) || '';
    if (spacePath.startsWith((0, $aTWRz.CONTEXT_PATH))) spacePath = spacePath.substring((0, $aTWRz.CONTEXT_PATH).length);
    if (spacePath.startsWith('/')) spacePath = spacePath.substring(1);
    const link = `${(0, $aTWRz.CONTEXT_PATH)}/${(0, $aTWRz.SPACE_ROOT)}/${spaceKey}${spacePath ? `/${spacePath}` : ''}`;
    if (typeof path === 'string') return link;
    return {
        ...path,
        pathname: link
    };
};
const $dc34297d07844a72$export$c6e1a1f2787e89f3 = (spaceKey)=>(0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
const $dc34297d07844a72$export$828af32839880b11 = (spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
    return (0, $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS).toUrl();
};
const $dc34297d07844a72$export$6687a923d0d006ad = ()=>`${0, $aTWRz.CONTEXT_PATH}/admin/configuration`;
const $dc34297d07844a72$export$43c82211f01dfa9 = (location)=>$dc34297d07844a72$export$4abd56cd4494d96(location) || $dc34297d07844a72$export$65ea6c3cfd39f693(location);
const $dc34297d07844a72$var$myWorkMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/${(0, $aTWRz.MY_WORK_ROOT)}`);
const $dc34297d07844a72$export$4abd56cd4494d96 = (location)=>$dc34297d07844a72$var$myWorkMatcher.test(location.pathname);
const $dc34297d07844a72$var$discoverMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/${(0, $aTWRz.DISCOVER_ROOT)}`);
const $dc34297d07844a72$export$65ea6c3cfd39f693 = (location)=>$dc34297d07844a72$var$discoverMatcher.test(location.pathname);
const $dc34297d07844a72$var$viewPageMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/pages/[0-9]+`);
const $dc34297d07844a72$export$a9ddd6d29c62e50e = (location)=>$dc34297d07844a72$var$viewPageMatcher.test(location.pathname);
const $dc34297d07844a72$var$legacyViewPageMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/pages/viewpage\.action`);
const $dc34297d07844a72$export$ed7272ed68dfabd2 = (location)=>$dc34297d07844a72$var$legacyViewPageMatcher.test(location.pathname);
const $dc34297d07844a72$var$blogpostMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/blog/[0-9]+`);
const $dc34297d07844a72$export$44d25c3a122172cb = (location)=>$dc34297d07844a72$var$blogpostMatcher.test(location.pathname);
const $dc34297d07844a72$var$legacySpaceMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/viewspace.action`);
const $dc34297d07844a72$export$6c15954bf6aeeacc = (location)=>$dc34297d07844a72$var$legacySpaceMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceOverviewMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/overview`);
const $dc34297d07844a72$export$d6ed4b21ccee5919 = (location)=>$dc34297d07844a72$var$spaceOverviewMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceShortcutsMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/shortcuts`);
const $dc34297d07844a72$export$addc150fc0e323b8 = (location)=>$dc34297d07844a72$var$spaceShortcutsMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceBlogMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/blog`);
const $dc34297d07844a72$export$c84b760c145ebd67 = (location)=>$dc34297d07844a72$var$spaceBlogMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceQuestionMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/questions`);
const $dc34297d07844a72$export$f72f595c5ad62068 = (location)=>$dc34297d07844a72$var$spaceQuestionMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceLegacyCalendarMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/${(0, $aTWRz.DISPLAY_ROOT)}/[^\/]+/calendar`);
const $dc34297d07844a72$export$c5bfac930eea07f5 = (location)=>$dc34297d07844a72$var$spaceLegacyCalendarMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceToolMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/${(0, $aTWRz.SPACE_ROOT)}/viewspacesummary.action`);
const $dc34297d07844a72$export$f9d4d3f2b95c40d6 = (location)=>$dc34297d07844a72$var$spaceToolMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceLegacyQuestionMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/${(0, $aTWRz.DISPLAY_ROOT)}/[^\/]+/customcontent/list/ac%3Acom.atlassian.confluence.plugins.confluence-questions%3Aquestion`);
const $dc34297d07844a72$export$27879a875df890c5 = (location)=>$dc34297d07844a72$var$spaceLegacyQuestionMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceCalendarMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/calendars`);
const $dc34297d07844a72$export$547a8bbd531e6b17 = (location)=>$dc34297d07844a72$var$spaceCalendarMatcher.test(location.pathname);
const $dc34297d07844a72$var$spaceAddonMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/addon`);
const $dc34297d07844a72$export$fb83911ae0e73188 = (location)=>$dc34297d07844a72$var$spaceAddonMatcher.test(location.pathname);
const $dc34297d07844a72$var$fabricEditorMatcher = new RegExp(`${(0, $aTWRz.CONTEXT_PATH)}/spaces/[^\/]+/(pages|blog)/edit-v2/`);
const $dc34297d07844a72$export$2540db8c6c588f9e = (location)=>$dc34297d07844a72$var$fabricEditorMatcher.test(location.pathname);
module.exports["stripContentTitlesFromURL"] = $dc34297d07844a72$export$bd2270b4ca226dc6;
module.exports["getEditPageV2"] = $dc34297d07844a72$export$51becd8adde0429c;
module.exports["isSpaceOverviewRoute"] = $dc34297d07844a72$export$d6ed4b21ccee5919;

});

parcelRegister("aTWRz", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");

const $7efcb36d690ff658$var$contextPathFromPathname = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).location && (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).location.pathname.split('/')[1];
const $7efcb36d690ff658$export$8c6bf2df244e6a99 = $7efcb36d690ff658$var$contextPathFromPathname ? `/${$7efcb36d690ff658$var$contextPathFromPathname}` : '/wiki';
const $7efcb36d690ff658$export$1c377798a4ee5636 = 'spaces';
const $7efcb36d690ff658$export$34022960ff006f30 = 'display';
const $7efcb36d690ff658$export$f897f771d110c086 = 'display';
const $7efcb36d690ff658$export$c3c32b74ef7566a2 = 'discover';
const $7efcb36d690ff658$export$d9cb79c4fd8ef00a = 'my';
const $7efcb36d690ff658$export$ec55178b655ee174 = 'recent';
module.exports["CONTEXT_PATH"] = $7efcb36d690ff658$export$8c6bf2df244e6a99;
module.exports["SPACE_ROOT"] = $7efcb36d690ff658$export$1c377798a4ee5636;
module.exports["DISPLAY_ROOT"] = $7efcb36d690ff658$export$34022960ff006f30;
module.exports["DISCOVER_ROOT"] = $7efcb36d690ff658$export$c3c32b74ef7566a2;
module.exports["MY_WORK_ROOT"] = $7efcb36d690ff658$export$d9cb79c4fd8ef00a;

});

parcelRegister("eYNcX", function(module, exports) {
const $ae7cd6f4cdfae775$export$c6813a8d51f77eaf = 200;
const $ae7cd6f4cdfae775$export$8bca792d963eb0ef = 404;
const $ae7cd6f4cdfae775$export$8c5e74eae7b64cc2 = 412;
const $ae7cd6f4cdfae775$export$e813cd7045fcc98d = 500;
const $ae7cd6f4cdfae775$export$5ed7505d2b52f8b1 = 503;
module.exports["OK"] = $ae7cd6f4cdfae775$export$c6813a8d51f77eaf;
module.exports["NOT_FOUND"] = $ae7cd6f4cdfae775$export$8bca792d963eb0ef;
module.exports["INTERNAL_SERVER_ERROR"] = $ae7cd6f4cdfae775$export$e813cd7045fcc98d;
module.exports["SERVICE_UNAVAILABLE_ERROR"] = $ae7cd6f4cdfae775$export$5ed7505d2b52f8b1;

});

parcelRegister("9FYW3", function(module, exports) {
const $70b735e63ef1b24f$export$4b2ae5d9ac5f5c38 = 'example.spotlight';
const $70b735e63ef1b24f$export$29775c4096cc1552 = 'editor.help.center.spotlight.on.help.menu';
const $70b735e63ef1b24f$export$8c85345117119989 = [
    []
];
const $70b735e63ef1b24f$export$7f5de72135b17c6b = {};
module.exports["EXAMPLE_SPOTLIGHT"] = $70b735e63ef1b24f$export$4b2ae5d9ac5f5c38;
module.exports["HELP_MENU_SPOTLIGHT"] = $70b735e63ef1b24f$export$29775c4096cc1552;
module.exports["SPOTLIGHTS_FLOWS"] = $70b735e63ef1b24f$export$8c85345117119989;
module.exports["SPOTLIGHT_CALLBACKS"] = $70b735e63ef1b24f$export$7f5de72135b17c6b;

});

parcelRegister("irL2R", function(module, exports) {

module.exports = (parcelRequire("67mXi"));

});

parcelRegister("67mXi", function(module, exports) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function $47453401ae89f39c$var$head(array) {
    return array && array.length ? array[0] : undefined;
}
module.exports = $47453401ae89f39c$var$head;

});

parcelRegister("jBnsv", function(module, exports) {
const $4bdd9ca75c1e9e19$export$d1ca15e02cb0246b = 'com.atlassian.plugins.atlassian-connect-plugin';
const $4bdd9ca75c1e9e19$export$40c6e950ae94b0da = 'confluence.sections.page.temp:pagefavourite';
const $4bdd9ca75c1e9e19$export$eb1c4b0864d522cc = 'confluence.sections.page.temp:edit-page';
const $4bdd9ca75c1e9e19$export$3b945464f5d89ed3 = 'confluence.sections.page.temp:edit-blogpost';
const $4bdd9ca75c1e9e19$export$4bf4f0ec2f25e202 = 'com.atlassian.confluence.plugins.watch-button:watch';
const $4bdd9ca75c1e9e19$export$5ed0fed1719982a1 = 'com.atlassian.confluence.plugins.share-page:share';
const $4bdd9ca75c1e9e19$export$9ca243087e50564a = 'com.atlassian.confluence.plugins.confluence-invite-to-edit:share';
const $4bdd9ca75c1e9e19$export$b8499a432f3f0b75 = 'confluence.sections.page.temp:pageunfavourite';
const $4bdd9ca75c1e9e19$export$ea940583a16e119b = 'com.atlassian.confluence.plugins.confluence-create-content-plugin:create-blog-post';
const $4bdd9ca75c1e9e19$export$ceee661d99c6cdff = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-pages';
const $4bdd9ca75c1e9e19$export$f618e448a4ddfafa = 'com.atlassian.confluence.plugins.confluence-frontend-support:space-tools-link';
module.exports["CONNECT_APP_PREFIX_KEY"] = $4bdd9ca75c1e9e19$export$d1ca15e02cb0246b;
module.exports["PAGE_FAVOURITE_KEY"] = $4bdd9ca75c1e9e19$export$40c6e950ae94b0da;
module.exports["EDIT_BUTTON_PAGE_KEY"] = $4bdd9ca75c1e9e19$export$eb1c4b0864d522cc;
module.exports["EDIT_BUTTON_BLOGPOST_KEY"] = $4bdd9ca75c1e9e19$export$3b945464f5d89ed3;
module.exports["WATCH_BUTTON_KEY"] = $4bdd9ca75c1e9e19$export$4bf4f0ec2f25e202;
module.exports["INVITE_TO_EDIT_KEY"] = $4bdd9ca75c1e9e19$export$9ca243087e50564a;
module.exports["PAGE_UNFAVOURITE_KEY"] = $4bdd9ca75c1e9e19$export$b8499a432f3f0b75;
module.exports["CREATE_NEW_BLOGPOST_KEY"] = $4bdd9ca75c1e9e19$export$ea940583a16e119b;
module.exports["SPACE_TAB_PAGES_KEY"] = $4bdd9ca75c1e9e19$export$ceee661d99c6cdff;
module.exports["SPACE_SETTINGS_KEY"] = $4bdd9ca75c1e9e19$export$f618e448a4ddfafa;

});

parcelRegister("19fl2", function(module, exports) {
const $0d628794a509b7d9$export$58d7cf3acebc0ad9 = (discoveredFeatures, { pluginKey: pluginKey = '', featureKey: featureKey = '' } = {})=>(typeof discoveredFeatures?.some === 'function' ? discoveredFeatures : []).some((discoveredFeature)=>discoveredFeature?.pluginKey === pluginKey && discoveredFeature?.featureKey === featureKey);
module.exports["hasFeatureBeenDiscovered"] = $0d628794a509b7d9$export$58d7cf3acebc0ad9;

});

parcelRegister("aExmg", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jspCk = parcelRequire("jspCk");


var $jVTxf = parcelRequire("jVTxf");

/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */ var $7c178404ea11fe53$var$assignIn = $jspCk(function(object, source) {
    $gR42R(source, $jVTxf(source), object);
});
module.exports = $7c178404ea11fe53$var$assignIn;

});

parcelRegister("kFqI2", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("2GFTt")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("gG0AJ")).default);
$parcel$export(module.exports, "ReactReduxContext", () => (parcelRequire("ldVC5")).ReactReduxContext);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("8eIct")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("kDIqF")).useSelector);
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $hxT4C = parcelRequire("hxT4C");


var $hpRUx = parcelRequire("hpRUx");

parcelRequire("6bFuJ");
var $jTxSS = parcelRequire("jTxSS");


var $dMy3z = parcelRequire("dMy3z");


var $kDIqF = parcelRequire("kDIqF");


var $2GFTt = parcelRequire("2GFTt");

parcelRequire("eIqD0");

(0, $kDIqF.initializeUseSelector)((0, $hpRUx.useSyncExternalStoreWithSelector));
(0, $2GFTt.initializeConnect)((0, $hxT4C.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $dMy3z.setBatch)((0, $jTxSS.unstable_batchedUpdates));

});

parcelRegister("hwKTG", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8A9Gb"));

});

parcelRegister("8A9Gb", function(module, exports) {
$parcel$export(module.exports, "ContextConsumer", () => $63f931a41f545447$export$a7c73072b1a182ae, (v) => $63f931a41f545447$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $63f931a41f545447$export$9f27bc3417b4524d, (v) => $63f931a41f545447$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $63f931a41f545447$export$db77ccec0bb4ccac, (v) => $63f931a41f545447$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $63f931a41f545447$export$8392c0c9d3dcbd35, (v) => $63f931a41f545447$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $63f931a41f545447$export$ffb0004e005737fa, (v) => $63f931a41f545447$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $63f931a41f545447$export$b624eff549462981, (v) => $63f931a41f545447$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $63f931a41f545447$export$7897aa7841a5380c, (v) => $63f931a41f545447$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $63f931a41f545447$export$602eac185826482c, (v) => $63f931a41f545447$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $63f931a41f545447$export$e2c29f18771995cb, (v) => $63f931a41f545447$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $63f931a41f545447$export$5f8d39834fd61797, (v) => $63f931a41f545447$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $63f931a41f545447$export$74bf444e3cd11ea5, (v) => $63f931a41f545447$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $63f931a41f545447$export$998bcd577473dd93, (v) => $63f931a41f545447$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $63f931a41f545447$export$92387174baf9b227, (v) => $63f931a41f545447$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $63f931a41f545447$export$ec112efeb987d9c6, (v) => $63f931a41f545447$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $63f931a41f545447$export$b706b080d889d2c9, (v) => $63f931a41f545447$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $63f931a41f545447$export$5be5a87408f70ddc, (v) => $63f931a41f545447$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $63f931a41f545447$export$45a5e7f76e0caa8d, (v) => $63f931a41f545447$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $63f931a41f545447$export$455c2e768291efa6, (v) => $63f931a41f545447$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $63f931a41f545447$export$9522e17588c12572, (v) => $63f931a41f545447$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $63f931a41f545447$export$2110ac352bb060b9, (v) => $63f931a41f545447$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $63f931a41f545447$export$56885ab8b9c456ab, (v) => $63f931a41f545447$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $63f931a41f545447$export$d927fcb6adf8f9de, (v) => $63f931a41f545447$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $63f931a41f545447$export$b82d16f27459e05a, (v) => $63f931a41f545447$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $63f931a41f545447$export$522c17b4f5e123e8, (v) => $63f931a41f545447$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $63f931a41f545447$export$1aabd8a0274ecfd6, (v) => $63f931a41f545447$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $63f931a41f545447$export$3d6c20d97e46b957, (v) => $63f931a41f545447$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $63f931a41f545447$export$9b621391a187a31a, (v) => $63f931a41f545447$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $63f931a41f545447$export$f5bbd400c2f4426f, (v) => $63f931a41f545447$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $63f931a41f545447$export$a7c73072b1a182ae;
var $63f931a41f545447$export$9f27bc3417b4524d;
var $63f931a41f545447$export$db77ccec0bb4ccac;
var $63f931a41f545447$export$8392c0c9d3dcbd35;
var $63f931a41f545447$export$ffb0004e005737fa;
var $63f931a41f545447$export$b624eff549462981;
var $63f931a41f545447$export$7897aa7841a5380c;
var $63f931a41f545447$export$602eac185826482c;
var $63f931a41f545447$export$e2c29f18771995cb;
var $63f931a41f545447$export$5f8d39834fd61797;
var $63f931a41f545447$export$74bf444e3cd11ea5;
var $63f931a41f545447$export$998bcd577473dd93;
var $63f931a41f545447$export$92387174baf9b227;
var $63f931a41f545447$export$ec112efeb987d9c6;
var $63f931a41f545447$export$b706b080d889d2c9;
var $63f931a41f545447$export$5be5a87408f70ddc;
var $63f931a41f545447$export$45a5e7f76e0caa8d;
var $63f931a41f545447$export$455c2e768291efa6;
var $63f931a41f545447$export$9522e17588c12572;
var $63f931a41f545447$export$2110ac352bb060b9;
var $63f931a41f545447$export$56885ab8b9c456ab;
var $63f931a41f545447$export$d927fcb6adf8f9de;
var $63f931a41f545447$export$b82d16f27459e05a;
var $63f931a41f545447$export$522c17b4f5e123e8;
var $63f931a41f545447$export$1aabd8a0274ecfd6;
var $63f931a41f545447$export$3d6c20d97e46b957;
var $63f931a41f545447$export$9b621391a187a31a;
var $63f931a41f545447$export$f5bbd400c2f4426f;
'use strict';
var $63f931a41f545447$var$b = Symbol.for("react.element"), $63f931a41f545447$var$c = Symbol.for("react.portal"), $63f931a41f545447$var$d = Symbol.for("react.fragment"), $63f931a41f545447$var$e = Symbol.for("react.strict_mode"), $63f931a41f545447$var$f = Symbol.for("react.profiler"), $63f931a41f545447$var$g = Symbol.for("react.provider"), $63f931a41f545447$var$h = Symbol.for("react.context"), $63f931a41f545447$var$k = Symbol.for("react.server_context"), $63f931a41f545447$var$l = Symbol.for("react.forward_ref"), $63f931a41f545447$var$m = Symbol.for("react.suspense"), $63f931a41f545447$var$n = Symbol.for("react.suspense_list"), $63f931a41f545447$var$p = Symbol.for("react.memo"), $63f931a41f545447$var$q = Symbol.for("react.lazy"), $63f931a41f545447$var$t = Symbol.for("react.offscreen"), $63f931a41f545447$var$u;
$63f931a41f545447$var$u = Symbol.for("react.module.reference");
function $63f931a41f545447$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $63f931a41f545447$var$b:
                switch(a = a.type, a){
                    case $63f931a41f545447$var$d:
                    case $63f931a41f545447$var$f:
                    case $63f931a41f545447$var$e:
                    case $63f931a41f545447$var$m:
                    case $63f931a41f545447$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $63f931a41f545447$var$k:
                            case $63f931a41f545447$var$h:
                            case $63f931a41f545447$var$l:
                            case $63f931a41f545447$var$q:
                            case $63f931a41f545447$var$p:
                            case $63f931a41f545447$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $63f931a41f545447$var$c:
                return r;
        }
    }
}
$63f931a41f545447$export$a7c73072b1a182ae = $63f931a41f545447$var$h;
$63f931a41f545447$export$9f27bc3417b4524d = $63f931a41f545447$var$g;
$63f931a41f545447$export$db77ccec0bb4ccac = $63f931a41f545447$var$b;
$63f931a41f545447$export$8392c0c9d3dcbd35 = $63f931a41f545447$var$l;
$63f931a41f545447$export$ffb0004e005737fa = $63f931a41f545447$var$d;
$63f931a41f545447$export$b624eff549462981 = $63f931a41f545447$var$q;
$63f931a41f545447$export$7897aa7841a5380c = $63f931a41f545447$var$p;
$63f931a41f545447$export$602eac185826482c = $63f931a41f545447$var$c;
$63f931a41f545447$export$e2c29f18771995cb = $63f931a41f545447$var$f;
$63f931a41f545447$export$5f8d39834fd61797 = $63f931a41f545447$var$e;
$63f931a41f545447$export$74bf444e3cd11ea5 = $63f931a41f545447$var$m;
$63f931a41f545447$export$998bcd577473dd93 = $63f931a41f545447$var$n;
$63f931a41f545447$export$92387174baf9b227 = function() {
    return !1;
};
$63f931a41f545447$export$ec112efeb987d9c6 = function() {
    return !1;
};
$63f931a41f545447$export$b706b080d889d2c9 = function(a) {
    return $63f931a41f545447$var$v(a) === $63f931a41f545447$var$h;
};
$63f931a41f545447$export$5be5a87408f70ddc = function(a) {
    return $63f931a41f545447$var$v(a) === $63f931a41f545447$var$g;
};
$63f931a41f545447$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $63f931a41f545447$var$b;
};
$63f931a41f545447$export$455c2e768291efa6 = function(a) {
    return $63f931a41f545447$var$v(a) === $63f931a41f545447$var$l;
};
$63f931a41f545447$export$9522e17588c12572 = function(a) {
    return $63f931a41f545447$var$v(a) === $63f931a41f545447$var$d;
};
$63f931a41f545447$export$2110ac352bb060b9 = function(a) {
    return $63f931a41f545447$var$v(a) === $63f931a41f545447$var$q;
};
$63f931a41f545447$export$56885ab8b9c456ab = function(a) {
    return $63f931a41f545447$var$v(a) === $63f931a41f545447$var$p;
};
$63f931a41f545447$export$d927fcb6adf8f9de = function(a) {
    return $63f931a41f545447$var$v(a) === $63f931a41f545447$var$c;
};
$63f931a41f545447$export$b82d16f27459e05a = function(a) {
    return $63f931a41f545447$var$v(a) === $63f931a41f545447$var$f;
};
$63f931a41f545447$export$522c17b4f5e123e8 = function(a) {
    return $63f931a41f545447$var$v(a) === $63f931a41f545447$var$e;
};
$63f931a41f545447$export$1aabd8a0274ecfd6 = function(a) {
    return $63f931a41f545447$var$v(a) === $63f931a41f545447$var$m;
};
$63f931a41f545447$export$3d6c20d97e46b957 = function(a) {
    return $63f931a41f545447$var$v(a) === $63f931a41f545447$var$n;
};
$63f931a41f545447$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $63f931a41f545447$var$d || a === $63f931a41f545447$var$f || a === $63f931a41f545447$var$e || a === $63f931a41f545447$var$m || a === $63f931a41f545447$var$n || a === $63f931a41f545447$var$t || "object" === typeof a && null !== a && (a.$$typeof === $63f931a41f545447$var$q || a.$$typeof === $63f931a41f545447$var$p || a.$$typeof === $63f931a41f545447$var$g || a.$$typeof === $63f931a41f545447$var$h || a.$$typeof === $63f931a41f545447$var$l || a.$$typeof === $63f931a41f545447$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$63f931a41f545447$export$f5bbd400c2f4426f = $63f931a41f545447$var$v;

});

parcelRegister("h7Ze1", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */ function isEqualWith(value, other, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    var result = customizer ? customizer(value, other) : undefined;
    return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = isEqualWith;

});

parcelRegister("9F7Qb", function(module, exports) {
parcelRequire("fY9o0");
var $7MCqB = parcelRequire("7MCqB");

function $708e066696694052$export$ec068583843480e7(store) {
    store.subscribe(()=>{
        (0, $7MCqB.debouncedConfigureRestApiClient)(store);
    });
    (0, $7MCqB.debouncedConfigureRestApiClient)(store);
}
module.exports["subscribe"] = $708e066696694052$export$ec068583843480e7;

});

parcelRegister("fY9o0", function(module, exports) {
$parcel$export(module.exports, "configureRestApiClient", () => (parcelRequire("7MCqB")).debouncedConfigureRestApiClient);
$parcel$export(module.exports, "updateContentProperty", () => (parcelRequire("gCs5d")).updateContentProperty);
$parcel$export(module.exports, "editPageMetadata", () => (parcelRequire("chDZy")).editPageMetadata);
$parcel$export(module.exports, "editorPage", () => (parcelRequire("chDZy")).editorPage);
$parcel$export(module.exports, "publishEditorPage", () => (parcelRequire("chDZy")).publishEditorPage);
$parcel$export(module.exports, "syncEditorDraft", () => (parcelRequire("chDZy")).syncEditorDraft);
$parcel$export(module.exports, "publishEditorPageFromTemplate", () => (parcelRequire("chDZy")).publishEditorPageFromTemplate);
$parcel$export(module.exports, "createPage", () => (parcelRequire("chDZy")).createPage);
$parcel$export(module.exports, "draftMetadata", () => (parcelRequire("chDZy")).draftMetadata);
$parcel$export(module.exports, "cancelScheduledPublish", () => (parcelRequire("chDZy")).cancelScheduledPublish);
$parcel$export(module.exports, "getPluginCodeLanguages", () => (parcelRequire("3xce3")).getPluginCodeLanguages);
$parcel$export(module.exports, "getWikiConfluenceToXhtml", () => (parcelRequire("3xce3")).getWikiConfluenceToXhtml);
$parcel$export(module.exports, "getWikiMarkdownToXhtml", () => (parcelRequire("3xce3")).getWikiMarkdownToXhtml);
$parcel$export(module.exports, "space", () => (parcelRequire("1OVaR")).space);
$parcel$export(module.exports, "markDiscovered", () => (parcelRequire("2cpJ0")).markDiscovered);

var $EGdrQ = parcelRequire("EGdrQ");


var $7MCqB = parcelRequire("7MCqB");


var $chDZy = parcelRequire("chDZy");

var $3xce3 = parcelRequire("3xce3");

var $2cpJ0 = parcelRequire("2cpJ0");

var $1OVaR = parcelRequire("1OVaR");

var $gCs5d = parcelRequire("gCs5d");


});

parcelRegister("1wgMJ", function(module, exports) {
$parcel$export(module.exports, "redirectToLoginPage", () => (parcelRequire("6cikW")).redirectToLoginPage);

var $6cikW = parcelRequire("6cikW");


});

parcelRegister("T1bCI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bqHkV = parcelRequire("bqHkV");

var $0a560ec731d72845$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $0a560ec731d72845$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0a560ec731d72845$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $0a560ec731d72845$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $0a560ec731d72845$var$StateContext = (0, (/*@__PURE__*/$parcel$interopDefault($bqHkV)))(null);
var $0a560ec731d72845$export$42a852a2b6b56249 = function() {
    function Container() {
        var _this = this;
        $0a560ec731d72845$var$_classCallCheck(this, Container);
        this._listeners = [];
        $0a560ec731d72845$var$CONTAINER_DEBUG_CALLBACKS.forEach(function(cb) {
            return cb(_this);
        });
    }
    Container.prototype.setState = function setState(updater, callback) {
        var _this2 = this;
        return Promise.resolve().then(function() {
            var nextState = void 0;
            if (typeof updater === 'function') nextState = updater(_this2.state);
            else nextState = updater;
            if (nextState == null) {
                if (callback) callback();
                return;
            }
            _this2.state = Object.assign({}, _this2.state, nextState);
            var promises = _this2._listeners.map(function(listener) {
                return listener();
            });
            return Promise.all(promises).then(function() {
                if (callback) return callback();
            });
        });
    };
    Container.prototype.subscribe = function subscribe(fn) {
        this._listeners.push(fn);
    };
    Container.prototype.unsubscribe = function unsubscribe(fn) {
        this._listeners = this._listeners.filter(function(f) {
            return f !== fn;
        });
    };
    return Container;
}();
var $0a560ec731d72845$var$DUMMY_STATE = {};
var $0a560ec731d72845$export$b5b6bb8bb5273115 = function(_React$Component) {
    $0a560ec731d72845$var$_inherits(Subscribe, _React$Component);
    function Subscribe() {
        var _temp, _this3, _ret;
        $0a560ec731d72845$var$_classCallCheck(this, Subscribe);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this3 = $0a560ec731d72845$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this3), _this3.state = {}, _this3.instances = [], _this3.unmounted = false, _this3.onUpdate = function() {
            return new Promise(function(resolve) {
                if (!_this3.unmounted) _this3.setState($0a560ec731d72845$var$DUMMY_STATE, resolve);
                else resolve();
            });
        }, _temp), $0a560ec731d72845$var$_possibleConstructorReturn(_this3, _ret);
    }
    Subscribe.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounted = true;
        this._unsubscribe();
    };
    Subscribe.prototype._unsubscribe = function _unsubscribe() {
        var _this4 = this;
        this.instances.forEach(function(container) {
            container.unsubscribe(_this4.onUpdate);
        });
    };
    Subscribe.prototype._createInstances = function _createInstances(map, containers) {
        var _this5 = this;
        this._unsubscribe();
        if (map === null) throw new Error('You must wrap your <Subscribe> components with a <Provider>');
        var safeMap = map;
        var instances = containers.map(function(ContainerItem) {
            var instance = void 0;
            if ((typeof ContainerItem === 'undefined' ? 'undefined' : $0a560ec731d72845$var$_typeof(ContainerItem)) === 'object' && ContainerItem instanceof $0a560ec731d72845$export$42a852a2b6b56249) instance = ContainerItem;
            else {
                instance = safeMap.get(ContainerItem);
                if (!instance) {
                    instance = new ContainerItem();
                    safeMap.set(ContainerItem, instance);
                }
            }
            instance.unsubscribe(_this5.onUpdate);
            instance.subscribe(_this5.onUpdate);
            return instance;
        });
        this.instances = instances;
        return instances;
    };
    Subscribe.prototype.render = function render() {
        var _this6 = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a560ec731d72845$var$StateContext.Consumer, null, function(map) {
            return _this6.props.children.apply(null, _this6._createInstances(map, _this6.props.to));
        });
    };
    return Subscribe;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
function $0a560ec731d72845$export$2881499e37b75b9a(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a560ec731d72845$var$StateContext.Consumer, null, function(parentMap) {
        var childMap = new Map(parentMap);
        if (props.inject) props.inject.forEach(function(instance) {
            childMap.set(instance.constructor, instance);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a560ec731d72845$var$StateContext.Provider, {
            value: childMap
        }, props.children);
    });
}
var $0a560ec731d72845$var$CONTAINER_DEBUG_CALLBACKS = [];
// If your name isn't Sindre, this is not for you.
// I might ruin your day suddenly if you depend on this without talking to me.
function $0a560ec731d72845$export$de2643c78580ed01(callback) {
    $0a560ec731d72845$var$CONTAINER_DEBUG_CALLBACKS.push(callback);
}
module.exports["Container"] = $0a560ec731d72845$export$42a852a2b6b56249;
module.exports["Subscribe"] = $0a560ec731d72845$export$b5b6bb8bb5273115;
module.exports["Provider"] = $0a560ec731d72845$export$2881499e37b75b9a;

});

parcelRegister("3jwuS", function(module, exports) {

var $efvKr = parcelRequire("efvKr");


var $eNbbn = parcelRequire("eNbbn");

const $5e7dba3a8b909406$export$e251530099f9a5aa = ()=>{
    const [isLiveClientside] = (0, $efvKr.useIsCurrentPageLiveRaw)();
    const { isTypeKnown: isSSRKnown, isLive: isLiveSSR } = (0, $eNbbn.useLivePageSSRStatus)();
    // Use SSR value if we know we're in SSR mode, otherwise fall back to client-side store value
    return isSSRKnown ? !!isLiveSSR : isLiveClientside;
};
module.exports["useIsCurrentPageLive"] = $5e7dba3a8b909406$export$e251530099f9a5aa;

});

parcelRegister("efvKr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $686b59ca96a4b29b$var$initialState = {
    isLive: false,
    mode: undefined
};
// Action creators
/**
 * Switches the live status of the page to control whether the page is currently live or not.
 * @param isLive - A boolean indicating the desired live status of the page. Accepts:
 *                 - `true`: The page is live.
 *                 - `false`: The page is not live.
 */ const $686b59ca96a4b29b$var$setIsLive = (isLive)=>({ setState: setState })=>{
        setState({
            isLive: isLive
        });
    };
/**
 * Switches the page mode to control how users see a live page: 'view' mode for a read only view,
 * and 'edit' mode to allow a user to make changes to the page.
 *
 * @param mode - The desired mode for the page. Accepts:
 *               - 'view': Users can only view content.
 *               - 'edit': Users can modify the content.
 */ const $686b59ca96a4b29b$var$setMode = (mode)=>({ setState: setState })=>{
        setState({
            mode: mode
        });
    };
const $686b59ca96a4b29b$var$actions = {
    setIsLive: $686b59ca96a4b29b$var$setIsLive,
    setMode: $686b59ca96a4b29b$var$setMode
};
// Store creation
const $686b59ca96a4b29b$var$LivePagesStore = (0, $1P1Tu.createStore)({
    initialState: $686b59ca96a4b29b$var$initialState,
    actions: $686b59ca96a4b29b$var$actions,
    name: 'live-pages-store'
});
// Selectors
const $686b59ca96a4b29b$var$selectIsLive = (state)=>state.isLive;
const $686b59ca96a4b29b$var$selectMode = (state)=>({
        mode: state.mode,
        isEditMode: state.mode === 'edit',
        isViewMode: state.mode === 'view'
    });
const $686b59ca96a4b29b$export$bf6645c1c39d60e9 = (0, $9zUhf.createHook)($686b59ca96a4b29b$var$LivePagesStore, {
    selector: $686b59ca96a4b29b$var$selectIsLive
});
const $686b59ca96a4b29b$export$2b0a7d308d70bcce = (0, $9zUhf.createActionsHook)($686b59ca96a4b29b$var$LivePagesStore);
const $686b59ca96a4b29b$export$4b142161af17c82a = (0, $9zUhf.createHook)($686b59ca96a4b29b$var$LivePagesStore, {
    selector: $686b59ca96a4b29b$var$selectMode
});
const $686b59ca96a4b29b$export$2bf92e65e8a188f0 = (0, $9zUhf.createHook)($686b59ca96a4b29b$var$LivePagesStore);
module.exports["useIsCurrentPageLiveRaw"] = $686b59ca96a4b29b$export$bf6645c1c39d60e9;
module.exports["useLivePageStoreActions"] = $686b59ca96a4b29b$export$2b0a7d308d70bcce;
module.exports["useLivePageMode"] = $686b59ca96a4b29b$export$4b142161af17c82a;

});

parcelRegister("eNbbn", function(module, exports) {

const $b55b7feb878ccd35$export$1ba073176000cd58 = ()=>{
    if (window.__SSR_RENDERED__ && window.__SSR_IS_LIVE_PAGE__ !== undefined) return {
        isLive: window.__SSR_IS_LIVE_PAGE__,
        isTypeKnown: true
    };
    return {
        isLive: undefined,
        isTypeKnown: false
    };
};
module.exports["useLivePageSSRStatus"] = $b55b7feb878ccd35$export$1ba073176000cd58;

});

parcelRegister("lonEO", function(module, exports) {

var $42omo = parcelRequire("42omo");

parcelRequire("j1Ss3");
var $3sW76 = parcelRequire("3sW76");


var $irOoi = parcelRequire("irOoi");


var $3e6Uc = parcelRequire("3e6Uc");


var $jWs8F = parcelRequire("jWs8F");


var $3tMMZ = parcelRequire("3tMMZ");





var $2gQQV = parcelRequire("2gQQV");


var $bDPoq = parcelRequire("bDPoq");


var $hvWxm = parcelRequire("hvWxm");


var $iMHGI = parcelRequire("iMHGI");


var $4VJDS = parcelRequire("4VJDS");


var $fcZiu = parcelRequire("fcZiu");

let $a941162a349ec077$var$cachedOverrides = null;
// Loads query overrides once and caches them.
const $a941162a349ec077$var$getOverrides = ()=>{
    if ($a941162a349ec077$var$cachedOverrides == null) $a941162a349ec077$var$cachedOverrides = (0, $fcZiu.loadOverridesFromStorage)();
    return $a941162a349ec077$var$cachedOverrides;
};
const $a941162a349ec077$export$e8a30029afdeaa76 = ()=>{
    $a941162a349ec077$var$cachedOverrides = null;
};
const $a941162a349ec077$export$da6427ffe02505d0 = (response, request)=>{
    if (response?.data == null) return response;
    const overrides = $a941162a349ec077$var$getOverrides();
    // no overrides are present in localStorage
    if (Object.keys(overrides).length === 0) return response;
    return (0, $fcZiu.applyQueryOverridesToResponse)({
        overrides: overrides,
        response: response,
        relayRequest: request
    });
};
const $a941162a349ec077$export$49ce5cea0ad922b8 = ()=>{
    return false;
};


const $ccacd3f20514e62e$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)(false);
const $ccacd3f20514e62e$var$MAX_CONCURRENCY_FOR_THROTTLED = 8;
const $ccacd3f20514e62e$var$requestPool = [];
const $ccacd3f20514e62e$var$throttledFetch = (uri, options)=>{
    if ($ccacd3f20514e62e$var$requestPool.length >= $ccacd3f20514e62e$var$MAX_CONCURRENCY_FOR_THROTTLED) {
        const queuedFetchFn = async ()=>{
            await $ccacd3f20514e62e$var$requestPool.shift();
            return $ccacd3f20514e62e$var$wrappedFetch(uri, options);
        };
        const queuedFetch = queuedFetchFn();
        $ccacd3f20514e62e$var$requestPool.push(queuedFetch);
        return queuedFetch;
    }
    const nextFetch = $ccacd3f20514e62e$var$wrappedFetch(uri, options);
    $ccacd3f20514e62e$var$requestPool.push(nextFetch);
    return nextFetch;
};
const $ccacd3f20514e62e$var$fetchFunctions = {
    throttledFetch: $ccacd3f20514e62e$var$throttledFetch,
    wrappedFetch: $ccacd3f20514e62e$var$wrappedFetch
};
const $ccacd3f20514e62e$export$71c11950843448dc = {
    requestPool: $ccacd3f20514e62e$var$requestPool,
    fetchFunctions: $ccacd3f20514e62e$var$fetchFunctions
};
const $ccacd3f20514e62e$var$shouldDisableBatchingForEnvironment = ()=>{
    if (typeof window === 'undefined') return false;
    return Boolean(window.Cypress) || Boolean(window.__CRITERION__) || Boolean(window.isPlaywright) || Boolean(window.isContract) || !(0, $4VJDS.default).isKillSwitchOn('confluence_spa_query_batching');
};
const $ccacd3f20514e62e$export$837a021df494847 = {
    maxBatchSize: 5,
    batchInterval: 50 // 50ms
};
class $ccacd3f20514e62e$export$2816a23e3c7d0533 {
    generateRequestId() {
        return `req_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    }
    async processSingleRequest(request, variables, cacheConfig, shouldThrottle) {
        const endpoint = (0, $2gQQV.getAggEndpoint)(request, cacheConfig);
        const body = (0, $2gQQV.getRequestBody)(request, variables);
        const fetchFn = shouldThrottle ? $ccacd3f20514e62e$var$fetchFunctions.throttledFetch : $ccacd3f20514e62e$var$fetchFunctions.wrappedFetch;
        const response = await fetchFn(endpoint, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': (0, $bDPoq.RelayExperimentalApis).join(',')
            },
            body: body
        });
        let parsedResponse = await response.json();
        if ('errors' in parsedResponse && parsedResponse.errors && parsedResponse.errors.length > 0) {
            const errors = parsedResponse.errors;
            const requestId = parsedResponse.extensions?.gateway?.request_id;
            (0, $hvWxm.captureErrors)(errors, {
                operationName: request.name,
                requestId: requestId
            });
        }
        if ((0, $a941162a349ec077$export$49ce5cea0ad922b8)()) parsedResponse = (0, $a941162a349ec077$export$da6427ffe02505d0)(parsedResponse, request);
        return parsedResponse;
    }
    /**
   * Groups requests by endpoint.
   *
   * @param requests - An array of BatchedRequest objects.
   * @returns A record of requests grouped by endpoint.
   */ getRequestsByEndpoint(requests) {
        const requestsByEndpoint = {};
        for (const request of requests){
            const endpoint = (0, $2gQQV.getAggEndpoint)(request.request, request.cacheConfig);
            if (!requestsByEndpoint[endpoint]) requestsByEndpoint[endpoint] = [];
            requestsByEndpoint[endpoint].push(request);
        }
        return requestsByEndpoint;
    }
    /**
   * Processes a batch of requests for a given endpoint.
   *
   * @param endpoint - The endpoint to process.
   * @param endpointRequests - An array of BatchedRequest objects for the endpoint.
   * @returns A promise that resolves when the requests are processed.
   */ async processBatchForEndpoint(endpoint, endpointRequests) {
        if (endpointRequests.length === 1) {
            // Single request - use processSingleRequest
            const [request] = endpointRequests;
            try {
                const result = await this.processSingleRequest(request.request, request.variables, request.cacheConfig);
                request.resolve(result);
            } catch (error) {
                request.reject(error);
            }
        } else {
            // Multiple requests - batch them
            const batchBody = JSON.stringify(endpointRequests.map((req)=>(0, $2gQQV.getRequestBody)(req.request, req.variables)));
            try {
                const response = await $ccacd3f20514e62e$var$wrappedFetch(endpoint, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'content-type': 'application/json',
                        'X-ExperimentalApi': (0, $bDPoq.RelayExperimentalApis).join(',')
                    },
                    body: batchBody
                });
                const batchResponse = await response.json();
                endpointRequests.forEach((req, index)=>{
                    let batchedRes = batchResponse[index];
                    if (batchedRes && 'errors' in batchedRes && batchedRes.errors && batchedRes.errors.length > 0) {
                        const errors = batchedRes.errors;
                        const requestId = batchedRes?.extensions?.gateway?.request_id;
                        (0, $hvWxm.captureErrors)(errors, {
                            operationName: req.request.name,
                            requestId: requestId
                        });
                    }
                    // Apply query overrides if enabled
                    if ((0, $a941162a349ec077$export$49ce5cea0ad922b8)()) batchedRes = (0, $a941162a349ec077$export$da6427ffe02505d0)(batchedRes, req.request);
                    req.resolve(batchedRes); // always resolve, reject only in case of network level error
                });
            } catch (error) {
                // If batch request fails, reject all requests for this endpoint
                endpointRequests.forEach((req)=>{
                    req.reject(error);
                });
            }
        }
    }
    /**
   * Processes a batch of requests.
   *
   * @param requests - An array of BatchedRequest objects.
   * @returns A promise that resolves when the requests are processed.
   */ async processBatch(requests) {
        if (requests.length === 0) return;
        if (requests.length === 1) {
            const [request] = requests;
            try {
                const result = await this.processSingleRequest(request.request, request.variables, request.cacheConfig);
                request.resolve(result);
            } catch (error) {
                request.reject(error);
            }
            return;
        }
        const requestsByEndpoint = this.getRequestsByEndpoint(requests);
        // Process each endpoint group separately
        const promises = Object.entries(requestsByEndpoint).map(async ([endpoint, endpointRequests])=>{
            await this.processBatchForEndpoint(endpoint, endpointRequests);
        });
        await Promise.allSettled(promises);
    }
    /**
   * Schedules a batch of requests.
   *
   * @returns A promise that resolves when the requests are processed.
   */ scheduleBatch() {
        if (this.batchTimeout) clearTimeout(this.batchTimeout);
        this.batchTimeout = setTimeout(()=>{
            if (this.requestQueue.length > 0) {
                const batch = this.requestQueue.splice(0, this.batchingConfig.maxBatchSize);
                this.processBatch(batch);
                // If there are more requests in the queue, schedule another batch
                if (this.requestQueue.length > 0) this.scheduleBatch();
            }
        }, this.batchingConfig.batchInterval);
    }
    /**
   * Main method to fetch a request.
   *
   * @param request - The request to fetch.
   * @param variables - The variables to fetch.
   * @param cacheConfig - The cache config to fetch.
   * @returns A promise that resolves when the request is processed.
   */ fetch(request, variables, cacheConfig) {
        // This bypass logic mirrors Apollo's split logic
        const shouldBypassBatch = !this.batchingConfig.enabled || cacheConfig.metadata?.single || cacheConfig.metadata?.throttle === true || $ccacd3f20514e62e$var$shouldDisableBatchingForEnvironment();
        const shouldThrottle = // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        !$ccacd3f20514e62e$var$shouldDisableBatchingForEnvironment() && cacheConfig.metadata?.throttle === true;
        if (shouldBypassBatch) return this.processSingleRequest(request, variables, cacheConfig, shouldThrottle);
        return new Promise((resolve, reject)=>{
            const batchedRequest = {
                request: request,
                variables: variables,
                cacheConfig: cacheConfig,
                resolve: resolve,
                reject: reject,
                id: this.generateRequestId()
            };
            this.requestQueue.push(batchedRequest);
            if (this.requestQueue.length >= this.batchingConfig.maxBatchSize) {
                const batch = this.requestQueue.splice(0, this.batchingConfig.maxBatchSize);
                this.processBatch(batch);
            } else this.scheduleBatch();
        });
    }
    setBatchingConfig(config) {
        this.batchingConfig = {
            ...this.batchingConfig,
            ...config
        };
    }
    getBatchingConfig() {
        return {
            ...this.batchingConfig
        };
    }
    clearRequestQueue() {
        // Reject all pending requests
        this.requestQueue.forEach((req)=>{
            req.reject(new Error('Request queue cleared'));
        });
        this.requestQueue = [];
        if (this.batchTimeout) {
            clearTimeout(this.batchTimeout);
            this.batchTimeout = null;
        }
    }
    constructor(config = $ccacd3f20514e62e$export$837a021df494847){
        this.batchingConfig = void 0;
        this.requestQueue = void 0;
        this.batchTimeout = null;
        this.batchingConfig = config;
        this.requestQueue = [];
    }
}



var $1NBp8 = parcelRequire("1NBp8");

const $2399f925b542799d$export$ee52ccb0f5a1cc72 = ({ operationName: operationName, metadata: metadata })=>{
    const isExternalShareRequest = !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
    const allowOnExternalPage = metadata?.allowOnExternalPage ?? false;
    const shouldTerminate = isExternalShareRequest && !allowOnExternalPage;
    if (shouldTerminate) // eslint-disable-next-line no-console
    console.warn('Trying to make a call on an external route without allowOnExternalPage', operationName);
    return shouldTerminate;
};





// import { graphql } from 'react-relay';

var $a4TK8 = parcelRequire("a4TK8");

parcelRequire("1z9oK");
var $dr1zO = parcelRequire("dr1zO");

function $ba079c3e0faaefe3$var$hasRootLevelErrors(eventResult) {
    if (!Array.isArray(eventResult.errors)) return false;
    return eventResult.errors.some((error)=>error.path && error.path.length === 1);
}
class $ba079c3e0faaefe3$export$dbda14e90ed6db9b {
    getMatchingResult(query, variables) {
        const results = this.queryResults.get(query);
        if (!results) return null;
        const matchingQueryResult = results.findIndex((result)=>(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(result.variables, variables));
        if (matchingQueryResult === -1) return null;
        const matchingData = results[matchingQueryResult].result;
        results.splice(matchingQueryResult, 1);
        this.queryResults.set(query, results);
        return matchingData;
    }
    addResult(query, result, variables) {
        const results = this.queryResults.get(query) || [];
        results.push({
            result: result,
            variables: variables
        });
        this.queryResults.set(query, results);
    }
    constructor(namespace){
        this.queryResults = void 0;
        this.queryResults = new Map();
        const data = (0, $dr1zO.getClientStream)(namespace);
        data.addListener((event)=>{
            if (event.type === 'result') try {
                if (!$ba079c3e0faaefe3$var$hasRootLevelErrors(event.result)) this.addResult(event.operation, event.result.data, event.variables);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('Failed to cache query result', e);
            // TODO: Submit errors to observability system
            }
        });
    }
}


parcelRequire("gSgn8");
var $eUgss = parcelRequire("eUgss");


var $3IHUl = parcelRequire("3IHUl");

let $fdacd41458676626$var$ssrQueryResultCache = null;
let $fdacd41458676626$var$isSSRDataLinkEnabled = false;
const $fdacd41458676626$var$SSR_NAMESPACE = 'cgraphql';
const $fdacd41458676626$export$40e6c97aebbd6a66 = (request, variables)=>{
    if (window.__SSR_REACT_STREAMING__ && $fdacd41458676626$var$ssrQueryResultCache && request.text) {
        const queryIdentifier = (0, $3IHUl.createIdentifierFromQuery)(request.text);
        const result = $fdacd41458676626$var$ssrQueryResultCache.getMatchingResult(queryIdentifier, variables);
        return result;
    }
    return null;
};
const $fdacd41458676626$export$57ae883cb4ad710b = (request, variables, cacheConfig, promise)=>{
    if (!$fdacd41458676626$var$isSSRDataLinkEnabled || !request.text) return (0, $3e6Uc.Observable).from(promise);
    return (0, $3e6Uc.Observable).create((observer)=>{
        const data = (0, $eUgss.getServerStream)($fdacd41458676626$var$SSR_NAMESPACE);
        promise.then((result)=>{
            if (result.data === null && result.errors !== null) {
                observer.error(result.errors);
                observer.complete();
                return;
            }
            // Use the original query if available in context, otherwise use the request text
            const query = cacheConfig.metadata?.originalQuery ?? request.text;
            if (query && typeof query === 'string') {
                const event = {
                    type: 'result',
                    operation: (0, $3IHUl.createIdentifierFromQuery)(query),
                    variables: variables,
                    result: result
                };
                data.emit(event);
            }
            observer.next(result);
            observer.complete();
        }).catch((error)=>{
            observer.error(error);
        });
    });
};
function $fdacd41458676626$export$fab3eeac887251ef() {
    $fdacd41458676626$var$isSSRDataLinkEnabled = true;
}
function $fdacd41458676626$export$790ca0ff4bf7cfcf() {
    $fdacd41458676626$var$isSSRDataLinkEnabled = false;
}
const $fdacd41458676626$export$8289b734e0005eb9 = (namespace)=>{
    if (window.__SSR_REACT_STREAMING__) $fdacd41458676626$var$ssrQueryResultCache = new (0, $ba079c3e0faaefe3$export$dbda14e90ed6db9b)(namespace);
};



var $bKqeQ = parcelRequire("bKqeQ");


var $04e9M = parcelRequire("04e9M");

// copied from @confluence/graphql/src/links/AGGWebSocketLink/getInternetConnectionState.ts. Once we move to Relay, we can remove the file from that package.
const $982519289dc3d268$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};


// copied from @confluence/graphql/src/links/AGGWebSocketLink/getBackOffDelay.ts. Once we move to Relay, we can remove the file from that package.
// copied from @confluence/graphql/src/links/AGGWebSocketLink/calculateBackOffRange.ts. Once we move to Relay, we can remove the file from that package.
// copied from @confluence/graphql/src/links/AGGWebSocketLink/backOffConfig.ts. Once we move to Relay, we can remove the file from that package.
const $15e87443ac05a25e$var$TEN_MINUTES_IN_MS = 600000;
const $15e87443ac05a25e$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $15e87443ac05a25e$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $15e87443ac05a25e$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $15e87443ac05a25e$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $15e87443ac05a25e$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $15e87443ac05a25e$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};


function $e225a2339357cf25$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $15e87443ac05a25e$export$e5680a2329370bd3)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $15e87443ac05a25e$export$d89658363be37383)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $15e87443ac05a25e$export$1b131e77a0e75a0a)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $15e87443ac05a25e$export$a1d6d3ff41cd93e9);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}


function $44955c092a5a76b5$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $44955c092a5a76b5$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $44955c092a5a76b5$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $44955c092a5a76b5$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $e225a2339357cf25$export$de85ae9dfb4a57bc)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};







var $9A0hR = parcelRequire("9A0hR");

const $0cbc66dca81b262d$export$e9ff5bb5c39478ed = 600000;
class $0cbc66dca81b262d$export$10dced4799546869 {
    subscribe(request, variables, cacheConfig, observer) {
        const errorCollector = (0, $hvWxm.startCaptureGraphQlErrors)();
        // extensions is available on the variables object added by the useSubscriptionValues hook
        const extensions = variables.__extensions || cacheConfig?.metadata?.extensions;
        const subscription = this.client.subscribe({
            query: request.text || '',
            variables: variables,
            operationName: request.name,
            extensions: extensions
        }, {
            next: (result)=>{
                // Transform null data to empty object
                const transformedResult = {
                    ...result,
                    data: result.data === null ? {} : result.data
                };
                // if transformedResult has errors, capture them
                if (transformedResult.errors && transformedResult.errors.length > 0) (0, $hvWxm.captureErrors)(transformedResult.errors, {
                    operationName: request.name,
                    requestId: transformedResult.extensions?.gateway?.request_id
                });
                observer.next(transformedResult);
            },
            complete: ()=>{
                const errors = (0, $hvWxm.stopCaptureGraphQlErrors)(errorCollector);
                if (errors.length > 0) observer.error(new (0, $9A0hR.ApolloErrorInterop)({
                    graphQLErrors: errors.flatMap((e)=>e.errors)
                }));
                else observer.complete();
            },
            error: (err)=>{
                if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                    client.sendOperationalEvent({
                        source: 'confluence-RelayWebSocketSubscriptionHandler',
                        actionSubject: 'webSocket',
                        action: 'closed-socket-error',
                        attributes: {
                            reason: this.closedInfo?.reason,
                            code: this.closedInfo?.code,
                            wasClean: this.closedInfo?.wasClean
                        }
                    });
                });
                if (err instanceof Error) return observer.error(err);
                return observer.error(new Error(`GraphQL WebSocket Error: ${JSON.stringify(err)}`));
            }
        });
        // keep track of the subscription so we can unsubscribe later
        const operationName = request.name || 'unknown';
        this.replayQueries[operationName] = {
            unsubscribe: subscription,
            query: request.text || ''
        };
        return subscription;
    }
    constructor(options){
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-RelayWebSocketSubscriptionHandler',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $982519289dc3d268$export$ddfffe3f5c167fa6)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $44955c092a5a76b5$export$ac8ba6656a385f56)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $44955c092a5a76b5$export$73e02b3a26ecb0d7)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $e225a2339357cf25$export$de85ae9dfb4a57bc)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $44955c092a5a76b5$export$73e02b3a26ecb0d7)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        // unsubscribe so that we can reconnect with new arguments
                        for(const key in this.replayQueries)if (this.replayQueries[key]) {
                            this.replayQueries[key].unsubscribe();
                            delete this.replayQueries[key];
                        }
                        this.client.terminate();
                    }, $0cbc66dca81b262d$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}


// copied from @confluence/graphql/src/links/AGGWebSocketLink/getWebSocketURL.ts. Once we move to Relay, we can remove the file from that package.
function $1a9af86799d1684c$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}


let $1f081d827bd95500$var$wsHandler;
function $1f081d827bd95500$export$aa5574d8bfbafcf5() {
    const WEBSOCKET_URL = (0, $1a9af86799d1684c$export$91893b414ff080f2)();
    if (!$1f081d827bd95500$var$wsHandler) $1f081d827bd95500$var$wsHandler = new (0, $0cbc66dca81b262d$export$10dced4799546869)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $0cbc66dca81b262d$export$e9ff5bb5c39478ed),
        retryAttempts: 5
    });
    return $1f081d827bd95500$var$wsHandler;
}
function $1f081d827bd95500$export$d4026f7781a3f6c6(options) {
    return new (0, $0cbc66dca81b262d$export$10dced4799546869)(options);
}



const $80dafd1908170169$var$fetchFn = (request, variables, cacheConfig)=>{
    const batchFetcher = new (0, $ccacd3f20514e62e$export$2816a23e3c7d0533)((0, $ccacd3f20514e62e$export$837a021df494847));
    const result = (0, $fdacd41458676626$export$40e6c97aebbd6a66)(request, variables);
    if (result) return (0, $3e6Uc.Observable).create((observer)=>{
        observer.next({
            data: result
        });
        observer.complete();
    });
    if ((0, $2399f925b542799d$export$ee52ccb0f5a1cc72)({
        operationName: request.name,
        metadata: cacheConfig.metadata
    })) return (0, $3e6Uc.Observable).create((observer)=>{
        observer.complete();
    });
    const promise = batchFetcher.fetch(request, variables, cacheConfig);
    return (0, $fdacd41458676626$export$57ae883cb4ad710b)(request, variables, cacheConfig, promise) || (0, $3e6Uc.Observable).create((observer)=>{
        promise.then((result)=>{
            observer.next(result);
            observer.complete();
        }).catch((error)=>{
            observer.error(error);
        });
    });
};
const $80dafd1908170169$var$SSR_NAMESPACE = 'cgraphql';
const $80dafd1908170169$var$subscribeFn = (request, variables, cacheConfig)=>{
    const wsHandler = (0, $1f081d827bd95500$export$aa5574d8bfbafcf5)();
    return (0, $3e6Uc.Observable).create((observer)=>{
        const unsubscribe = wsHandler.subscribe(request, variables, cacheConfig, {
            next: (value)=>observer.next(value),
            error: (error)=>observer.error(error),
            complete: ()=>observer.complete()
        });
        // Return cleanup function
        return ()=>{
            unsubscribe();
        };
    });
};
const $80dafd1908170169$export$7de4970ebfd8206d = ()=>{
    (0, $fdacd41458676626$export$8289b734e0005eb9)($80dafd1908170169$var$SSR_NAMESPACE);
    let composedFetch = $80dafd1908170169$var$fetchFn;
    return (0, $3e6Uc.Network).create(composedFetch, $80dafd1908170169$var$subscribeFn);
};
const $80dafd1908170169$export$d57f516a6f483c2 = ()=>{
    return (0, $3e6Uc.Network).create((_request, _variables, _cacheConfig)=>{
        return (0, $3e6Uc.Observable).create((observer)=>{
            observer.complete();
        });
    });
};


const $5284d5d107ac9197$export$21fcfd9d5c6ebbd4 = (0, $80dafd1908170169$export$7de4970ebfd8206d)();
const $5284d5d107ac9197$export$1f63f46913437763 = (0, $80dafd1908170169$export$d57f516a6f483c2)();


const $3d4638e359e5fcc8$var$defaultRelayEnvironmentOptions = {
    disableNetwork: false
};
const $3d4638e359e5fcc8$var$getConfluenceDataID = (fieldValue, typeName)=>{
    if (typeName === 'WebItem') return `${fieldValue.completeKey || fieldValue.id}; ${fieldValue.url}`;
    else if (typeName === 'OnboardingState') return `${fieldValue.key}`;
    else if (typeName === 'WebSection') return `${fieldValue.cacheKey}` || `${String(fieldValue.id)}`;
    else if (typeName === 'DetailsSummaryLines') return `${fieldValue.macroId}_${fieldValue.currentPage}`;
    else if (typeName === 'DetailLine') return `${fieldValue.id}_${fieldValue.rowId}_${fieldValue.macroId}`;
    else if (typeName === 'ConfluenceSystemTemplate') return `${fieldValue.moduleCompleteKey}`;
    // Ideally, we would use  RelayDataID from platform/packages/relay/relay-data-id here.
    // But this is to avoid breaking changes to cache reads via readFragment usages which specify id as a string.
    return (0, $jWs8F.defaultDataIdFromObject)(fieldValue);
};
function $3d4638e359e5fcc8$export$d73fa89307a28aec(relayEnvironmentOptions = $3d4638e359e5fcc8$var$defaultRelayEnvironmentOptions) {
    return (0, $3tMMZ.getDefaultRelayEnvironmentConfig)({
        getDataID: $3d4638e359e5fcc8$var$getConfluenceDataID,
        network: relayEnvironmentOptions.disableNetwork ? (0, $5284d5d107ac9197$export$1f63f46913437763) : (0, $5284d5d107ac9197$export$21fcfd9d5c6ebbd4),
        recordSource: new (0, $3e6Uc.RecordSource)(window.__RELAY_STORE__)
    });
}
/**
 * Gets the relay environment for Confluence. This function is exported to allow the relay environment to be used in tests.
 *
 * @returns The relay environment for Confluence.
 */ let $3d4638e359e5fcc8$var$relayEnvironment = null;
function $3d4638e359e5fcc8$export$ffa93f1e5be01566(relayEnvironmentOptions = $3d4638e359e5fcc8$var$defaultRelayEnvironmentOptions) {
    if (window['GLOBAL_RELAY_ENV']) return window['GLOBAL_RELAY_ENV'];
    if (!$3d4638e359e5fcc8$var$relayEnvironment) $3d4638e359e5fcc8$var$relayEnvironment = new (0, $3e6Uc.Environment)($3d4638e359e5fcc8$export$d73fa89307a28aec(relayEnvironmentOptions));
    window['GLOBAL_RELAY_ENV'] = $3d4638e359e5fcc8$var$relayEnvironment;
    return $3d4638e359e5fcc8$var$relayEnvironment;
}
function $3d4638e359e5fcc8$export$40050d55e59821af() {
    $3d4638e359e5fcc8$var$relayEnvironment = null;
    window['GLOBAL_RELAY_ENV'] = undefined;
}


const $dc433357f1d5f233$export$31463466af654559 = ({ client: client, relayEnvironment: relayEnvironment, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $irOoi.RelayEnvironmentProvider), {
        environment: relayEnvironment || (0, $3d4638e359e5fcc8$export$ffa93f1e5be01566)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3sW76.ApolloProvider), {
        client: client
    }, children));
};
module.exports["GraphqlProvider"] = $dc433357f1d5f233$export$31463466af654559;

});

parcelRegister("3tMMZ", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");

var $d18e9481e599dba1$exports = {};
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $d18e9481e599dba1$var$_interopRequireDefault = $eGvGZ.default;

var $d18e9481e599dba1$var$_createForOfIteratorHelper2 = $d18e9481e599dba1$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $d18e9481e599dba1$var$_defineProperty2 = $d18e9481e599dba1$var$_interopRequireDefault((parcelRequire("l2SD1")));

var $gf5pM = parcelRequire("gf5pM");

var $d18e9481e599dba1$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $gf5pM.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $d18e9481e599dba1$var$assertInternalActorIdentifier = $gf5pM.assertInternalActorIdentifier;
parcelRequire("kiICD");


var $2qNEJ = parcelRequire("2qNEJ");


var $k4tKO = parcelRequire("k4tKO");


var $e9MkZ = parcelRequire("e9MkZ");


var $jO6uW = parcelRequire("jO6uW");


var $v7WaB = parcelRequire("v7WaB");


var $3oKZ4 = parcelRequire("3oKZ4");


var $cJt0g = parcelRequire("cJt0g");


var $bxVYb = parcelRequire("bxVYb");


var $jZOVE = parcelRequire("jZOVE");




var $d18e9481e599dba1$var$ROOT_ID = $jZOVE.ROOT_ID, $d18e9481e599dba1$var$ROOT_TYPE = $jZOVE.ROOT_TYPE;
var $8922c0e1ab2249da$exports = {};
'use strict';



var $8922c0e1ab2249da$var$_interopRequireDefault = $eGvGZ.default;

var $8922c0e1ab2249da$var$_createForOfIteratorHelper2 = $8922c0e1ab2249da$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $kU32t = parcelRequire("kU32t");


var $ceyF6 = parcelRequire("ceyF6");

var $8922c0e1ab2249da$var$RELAY_LIVE_RESOLVER = $ceyF6.RELAY_LIVE_RESOLVER;

var $ek4t1 = parcelRequire("ek4t1");


var $fu0yr = parcelRequire("fu0yr");


var $fub1S = parcelRequire("fub1S");

var $8922c0e1ab2249da$var$generateClientID = $fub1S.generateClientID, $8922c0e1ab2249da$var$generateClientObjectClientID = $fub1S.generateClientObjectClientID;




var $75e3H = parcelRequire("75e3H");

var $8922c0e1ab2249da$var$createNormalizationSelector = $75e3H.createNormalizationSelector;

var $bsBg6 = parcelRequire("bsBg6");


var $5uj6g = parcelRequire("5uj6g");

var $8922c0e1ab2249da$var$normalize = $5uj6g.normalize;



var $8922c0e1ab2249da$var$RELAY_RESOLVER_ERROR_KEY = $jZOVE.RELAY_RESOLVER_ERROR_KEY, $8922c0e1ab2249da$var$RELAY_RESOLVER_INVALIDATION_KEY = $jZOVE.RELAY_RESOLVER_INVALIDATION_KEY, $8922c0e1ab2249da$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $jZOVE.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $8922c0e1ab2249da$var$RELAY_RESOLVER_SNAPSHOT_KEY = $jZOVE.RELAY_RESOLVER_SNAPSHOT_KEY, $8922c0e1ab2249da$var$RELAY_RESOLVER_VALUE_KEY = $jZOVE.RELAY_RESOLVER_VALUE_KEY, $8922c0e1ab2249da$var$getStorageKey = $jZOVE.getStorageKey;

var $4Wu1d = parcelRequire("4Wu1d");

var $2669e3739f6bfefd$exports = {};
'use strict';
function $2669e3739f6bfefd$var$isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
$2669e3739f6bfefd$exports = $2669e3739f6bfefd$var$isLiveStateValue;



var $fusLc = parcelRequire("fusLc");

var $8922c0e1ab2249da$var$isSuspenseSentinel = $fusLc.isSuspenseSentinel;

var $q03Nf = parcelRequire("q03Nf");

parcelRequire("eEWwZ");

var $8922c0e1ab2249da$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var $8922c0e1ab2249da$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var $8922c0e1ab2249da$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var $8922c0e1ab2249da$var$RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var $8922c0e1ab2249da$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
function $8922c0e1ab2249da$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $8922c0e1ab2249da$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $8922c0e1ab2249da$var$expectRecord(recordSource, recordID);
        var storageKey = $8922c0e1ab2249da$var$getStorageKey(field, variables);
        var linkedID = $jO6uW.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $8922c0e1ab2249da$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $8922c0e1ab2249da$var$generateClientID(recordID, storageKey);
            linkedRecord = $jO6uW.create(linkedID, $8922c0e1ab2249da$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $jO6uW.setValue(linkedRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $jO6uW.setValue(linkedRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $8922c0e1ab2249da$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $q03Nf(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $8922c0e1ab2249da$var$expectRecord(recordSource, recordID);
            var nextRecord = $jO6uW.clone(currentRecord);
            $jO6uW.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $8922c0e1ab2249da$var$getStorageKey(field.fragment, variables);
                var resolverID = $8922c0e1ab2249da$var$generateClientID(recordID, fragmentStorageKey);
                $8922c0e1ab2249da$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $8922c0e1ab2249da$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $8922c0e1ab2249da$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $8922c0e1ab2249da$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $8922c0e1ab2249da$var$RELAY_LIVE_RESOLVER && $jO6uW.getValue(linkedRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $8922c0e1ab2249da$var$generateClientID(recordID, storageKey);
            linkedRecord = $jO6uW.clone(linkedRecord);
            var _liveState = $jO6uW.getValue(linkedRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$2669e3739f6bfefd$exports(_liveState)) $q03Nf(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $jO6uW.setValue(linkedRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $jO6uW.getValue(linkedRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $jO6uW.getValue(linkedRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($8922c0e1ab2249da$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $8922c0e1ab2249da$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $q03Nf(false);
        var liveState = $jO6uW.getValue(liveStateRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $jO6uW.setValue(linkedRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $jO6uW.setValue(linkedRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $jO6uW.setValue(linkedRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$jO6uW.hasValue(currentRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $jO6uW.clone(currentRecord);
            $jO6uW.setValue(nextRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $bsBg6.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $bsBg6.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $q03Nf(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $jO6uW.setValue(resolverRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$8922c0e1ab2249da$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $4Wu1d(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $q03Nf(false);
                resolverValue = [];
                var nextSource = $bsBg6.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && $q03Nf(false);
                    var typename = $8922c0e1ab2249da$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $8922c0e1ab2249da$var$generateClientObjectClientID(typename, $jO6uW.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $8922c0e1ab2249da$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $8922c0e1ab2249da$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $8922c0e1ab2249da$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && $q03Nf(false);
                var _typename = $8922c0e1ab2249da$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $8922c0e1ab2249da$var$generateClientObjectClientID(_typename, $jO6uW.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $8922c0e1ab2249da$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $8922c0e1ab2249da$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $jO6uW.setValue(resolverRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $fu0yr(resolverValue);
            $jO6uW.setValue(resolverRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $fu0yr(value);
            $jO6uW.setValue(resolverRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $jO6uW.getValue(resolverRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $8922c0e1ab2249da$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $8922c0e1ab2249da$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $8922c0e1ab2249da$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$jO6uW.getValue(record, $8922c0e1ab2249da$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $jO6uW.getValue(record, $8922c0e1ab2249da$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $kU32t(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($ek4t1.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $jO6uW.clone(record);
            $jO6uW.setValue(nextRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($jO6uW.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $bsBg6.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = $jO6uW.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $8922c0e1ab2249da$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $8922c0e1ab2249da$var$normalize(source, selector, value, normalizationOptions).source;
            case 'WeakModel':
                var _record = $jO6uW.create(outputTypeDataID, typename);
                $jO6uW.setValue(_record, $8922c0e1ab2249da$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $q03Nf(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $8922c0e1ab2249da$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $jO6uW.create(key, typeName);
            $jO6uW.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $8922c0e1ab2249da$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $8922c0e1ab2249da$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $8922c0e1ab2249da$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $8922c0e1ab2249da$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $8922c0e1ab2249da$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $8922c0e1ab2249da$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $8922c0e1ab2249da$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $8922c0e1ab2249da$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $jO6uW.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $8922c0e1ab2249da$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $8922c0e1ab2249da$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $jO6uW.getFields(record).forEach(function(field) {
        if ($jO6uW.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $jO6uW.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($jO6uW.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $jO6uW.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $8922c0e1ab2249da$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $jO6uW.clone(record);
    $jO6uW.setValue(nextRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $8922c0e1ab2249da$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $8922c0e1ab2249da$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $8922c0e1ab2249da$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $8922c0e1ab2249da$var$isResolverRecord(_record2)) $8922c0e1ab2249da$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $8922c0e1ab2249da$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, $8922c0e1ab2249da$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && $8922c0e1ab2249da$var$isResolverRecord(record)) $8922c0e1ab2249da$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function $8922c0e1ab2249da$var$isResolverRecord(record) {
    return $jO6uW.getType(record) === $8922c0e1ab2249da$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $8922c0e1ab2249da$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $jO6uW.getValue(linkedRecord, $8922c0e1ab2249da$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $8922c0e1ab2249da$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $q03Nf(false);
    return record;
}
function $8922c0e1ab2249da$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $8922c0e1ab2249da$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $q03Nf(false);
    return typename;
}
$8922c0e1ab2249da$exports = {
    LiveResolverCache: $8922c0e1ab2249da$var$LiveResolverCache,
    getUpdatedDataIDs: $8922c0e1ab2249da$var$getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $8922c0e1ab2249da$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};


var $d18e9481e599dba1$var$LiveResolverCache = $8922c0e1ab2249da$exports.LiveResolverCache, $d18e9481e599dba1$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $8922c0e1ab2249da$exports.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $d18e9481e599dba1$var$getUpdatedDataIDs = $8922c0e1ab2249da$exports.getUpdatedDataIDs;



var $d18e9481e599dba1$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $d18e9481e599dba1$var$LiveResolverStore = /*#__PURE__*/ function() {
    function LiveResolverStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$treatMissing, _options$shouldProces;
        (0, $d18e9481e599dba1$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $d18e9481e599dba1$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $2qNEJ;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $e9MkZ;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $d18e9481e599dba1$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._storeSubscriptions = new $bxVYb(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        $d18e9481e599dba1$var$initializeRecordSource(this._recordSource);
    }
    var _proto = LiveResolverStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $d18e9481e599dba1$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $d18e9481e599dba1$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $k4tKO.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $d18e9481e599dba1$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return $d18e9481e599dba1$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = $3oKZ4.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $d18e9481e599dba1$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'LiveResolverStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $jO6uW.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        var invalidationState = {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
        return invalidationState;
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $d18e9481e599dba1$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $q03Nf(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $v7WaB.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $q03Nf(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = $v7WaB.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        top: while(true){
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $d18e9481e599dba1$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $cJt0g.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) continue top;
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var log = this.__log;
            if (log != null) log({
                name: 'store.gc',
                references: references
            });
            if (references.size === 0) this._recordSource.clear();
            else {
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) {
                        var record = this._recordSource.get(dataID);
                        if (record != null) {
                            var maybeResolverSubscription = $jO6uW.getValue(record, $d18e9481e599dba1$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                            if (maybeResolverSubscription != null) maybeResolverSubscription();
                        }
                        this._recordSource.remove(dataID);
                    }
                }
            }
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $d18e9481e599dba1$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return LiveResolverStore;
}();
function $d18e9481e599dba1$var$initializeRecordSource(target) {
    if (!target.has($d18e9481e599dba1$var$ROOT_ID)) {
        var rootRecord = $jO6uW.create($d18e9481e599dba1$var$ROOT_ID, $d18e9481e599dba1$var$ROOT_TYPE);
        target.set($d18e9481e599dba1$var$ROOT_ID, rootRecord);
    }
}
function $d18e9481e599dba1$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $jO6uW.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $jO6uW.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $jO6uW.setValue(nextRecord, $jZOVE.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $jO6uW.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $d18e9481e599dba1$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
$d18e9481e599dba1$exports = $d18e9481e599dba1$var$LiveResolverStore;



var $f2OFx = parcelRequire("f2OFx");

// src/jira/filter/types.ts
var $6cf8d402c40d64a7$export$e6199848f52f1119 = "jira", $6cf8d402c40d64a7$export$3c64de4ae038e3ae = "filter";



var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/jira/filter/manifest.ts
var $f8c9a83b34bd5209$var$jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6cf8d402c40d64a7$export$e6199848f52f1119),
    resourceType: (0, $6cf8d402c40d64a7$export$3c64de4ae038e3ae),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/filter/index.ts
var $f8c9a83b34bd5209$export$3cfb6cc809e835bd = class _JiraFilterAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get filterId() {
        return this._filterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f8c9a83b34bd5209$var$jiraFilterAriStaticOpts.qualifier,
            platformQualifier: $f8c9a83b34bd5209$var$jiraFilterAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f8c9a83b34bd5209$var$jiraFilterAriStaticOpts.resourceOwner,
            resourceType: $f8c9a83b34bd5209$var$jiraFilterAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.filterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                filterId: opts.filterId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f8c9a83b34bd5209$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f8c9a83b34bd5209$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            filterId: this.filterId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
    }
};





const $a69540a1adc2255f$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const $a69540a1adc2255f$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $a69540a1adc2255f$export$77232ec02db7a24a = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id: id } = argValues;
            const filterId = (0, $f8c9a83b34bd5209$export$3cfb6cc809e835bd).parse(id).filterId;
            if ($a69540a1adc2255f$var$isCustomFilter(filterId)) return (0, $f2OFx.default)({
                id: id
            }, 'JiraCustomFilter');
            if ($a69540a1adc2255f$var$isSystemFilter(filterId)) return (0, $f2OFx.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const $a69540a1adc2255f$var$MissingFieldHandlers = [
    $a69540a1adc2255f$export$77232ec02db7a24a
];
var $a69540a1adc2255f$export$2e2bcd8739ae039 = $a69540a1adc2255f$var$MissingFieldHandlers;



var $iTyoD = parcelRequire("iTyoD");


var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");

var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$2912bf4fa2770fd6$export$2e2bcd8739ae039 = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // react 16.x
        if (// `unstable_batchedUpdates` is defined in all currently supported versions
        // but could be removed in the future.
        // This check is defensive and not currently necessary.
        typeof (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unstable_batchedUpdates === 'function' && // The version export was only introduced in `react-dom@16.13.0`
        // but we need to support `react-dom@^16.8.0`
        // so we need to handle when the version is `undefined`
        (typeof (0, $jTxSS.version) === 'undefined' || (0, $jTxSS.version).startsWith('16'))) (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unstable_batchedUpdates(()=>{
            fn();
        });
        else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).startTransition === 'function') // @ts-ignore -error React.startTransition does not exist in react-16
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).startTransition(()=>{
            fn();
        });
        else fn();
        return '';
    }
};


const $887e63c8434f65c2$var$createStore = (source, options)=>{
    (0, $3e6Uc.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($d18e9481e599dba1$exports)))(source, options);
};
function $887e63c8434f65c2$export$6c790f07f4ef6a59({ log: log, requiredFieldLogger: requiredFieldLogger, network: network, networkOptions: networkOptions, getDataID: getDataID, recordSource: recordSource }) {
    return {
        configName: 'Atlassian Graphql Gateway',
        network: network || $887e63c8434f65c2$var$getEnvironmentNetwork(networkOptions),
        store: $887e63c8434f65c2$var$createStore(recordSource || new (0, $3e6Uc.RecordSource)(), {
            log: log ?? undefined,
            getDataID: getDataID ?? (0, $f2OFx.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: getDataID ?? (0, $f2OFx.default),
        scheduler: (0, $2912bf4fa2770fd6$export$2e2bcd8739ae039),
        missingFieldHandlers: (0, $a69540a1adc2255f$export$2e2bcd8739ae039)
    };
}
function $887e63c8434f65c2$export$e6902a9ee4e7639e({ log: log, requiredFieldLogger: requiredFieldLogger, networkOptions: networkOptions, getDataID: getDataID, recordSource: recordSource }) {
    return {
        configName: 'Atlassian Shared Graphql Gateway',
        network: $887e63c8434f65c2$var$getEnvironmentNetwork(networkOptions),
        store: $887e63c8434f65c2$var$createStore(recordSource || new (0, $3e6Uc.RecordSource)(), {
            log: log ?? undefined,
            getDataID: getDataID ?? (0, $f2OFx.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: getDataID ?? (0, $f2OFx.default),
        scheduler: (0, $2912bf4fa2770fd6$export$2e2bcd8739ae039),
        missingFieldHandlers: (0, $a69540a1adc2255f$export$2e2bcd8739ae039)
    };
}
const $887e63c8434f65c2$var$getEnvironmentNetwork = (environmentOptions)=>{
    if (environmentOptions) return (0, $iTyoD.createNetwork)(environmentOptions);
    return 0, $iTyoD.network;
};
module.exports["getDefaultRelayEnvironmentConfig"] = $887e63c8434f65c2$export$6c790f07f4ef6a59;

});

parcelRegister("f2OFx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1b075e40986c7a5$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

const $89103c584b545818$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/javascript, */*'
    }
};
const $89103c584b545818$var$isProduction = ()=>true;
const $89103c584b545818$var$MAX_REQUESTS_PER_INTERVAL = 5;
const $89103c584b545818$var$INTERVAL_MS = 1000;
let $89103c584b545818$var$requestQueue = [];
let $89103c584b545818$var$isProcessingQueue = false;
const $89103c584b545818$var$processQueue = ()=>{
    if ($89103c584b545818$var$isProcessingQueue) return;
    $89103c584b545818$var$isProcessingQueue = true;
    const processNextBatch = ()=>{
        if ($89103c584b545818$var$requestQueue.length === 0) {
            $89103c584b545818$var$isProcessingQueue = false;
            return;
        }
        const batch = $89103c584b545818$var$requestQueue.splice(0, $89103c584b545818$var$MAX_REQUESTS_PER_INTERVAL);
        batch.forEach(({ body: body, endpoint: endpoint })=>{
            fetch(endpoint, {
                ...$89103c584b545818$var$defaultOptions,
                method: 'POST',
                body: body
            });
        });
        setTimeout(processNextBatch, $89103c584b545818$var$INTERVAL_MS);
    };
    processNextBatch();
};
const $89103c584b545818$var$sendToServerBatched = (body, endpoint)=>{
    $89103c584b545818$var$requestQueue.push({
        body: body,
        endpoint: endpoint
    });
    // Start processing the logging queue if not already started
    $89103c584b545818$var$processQueue();
};
const $89103c584b545818$var$sendToConsole = (body, endpoint, level, message, eventType, event)=>{
    // eslint-disable-next-line no-console
    console[level]('%c%s %c(POST %s)\n%cMessage\n%c%s\n\n%cEvent body\n%c%s\n\n%cException object and Stack trace (expand to jump to source)\n', 'font-size: 14px; font-weight: bold;', level.toUpperCase(), 'font-size: 10px; font-family: monospace;', endpoint, 'font-family: sans-serif; font-weight: bold; font-size: 12px', 'font-family: sans-serif; font-weight: initial;', message, 'font-family: sans-serif; font-weight: bold;', 'font-family: monospace; font-weight: initial;', body, 'font-family: sans-serif; font-size: 12px; font-weight: bold;', event);
    const currentWindow = window;
    if (!$89103c584b545818$var$isProduction() && currentWindow.Cypress) {
        if (!currentWindow.cypressSafeErrorsLog) currentWindow.cypressSafeErrorsLog = [];
        currentWindow.cypressSafeErrorsLog.push({
            body: body,
            endpoint: endpoint,
            level: level,
            message: message
        });
    }
    if (eventType !== 'object') {
        const errorMessage = `Invalid log API usage: expected event of type 'object', but was ${eventType}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    if (typeof body !== 'string') {
        const errorMessage = `Invalid log API usage: expected event of type 'string', but was ${eventType}; message will be replaced by: ${String(message)}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    return Promise.resolve();
};
const $89103c584b545818$var$transformData = (location, message, event)=>{
    return {
        sentFrom: location,
        message: String(message),
        event: event,
        buildKey: window?.BUILD_KEY,
        logTime: new Date().toISOString()
    };
};
const $89103c584b545818$var$sendData = (level, location, message, event = {})=>{
    const data = $89103c584b545818$var$transformData(location, message, event);
    const body = JSON.stringify(data);
    const endpoint = `/rest/internal/2/log/safe/${level}`;
    if ($89103c584b545818$var$isProduction()) return $89103c584b545818$var$sendToServerBatched(body, endpoint);
    return $89103c584b545818$var$sendToConsole(body, endpoint, level, message, typeof event, event);
};
const $89103c584b545818$export$b8c037155fd57aaf = (location, message, event)=>{
    $89103c584b545818$var$sendData('warn', location, message, event);
};


const $c1b075e40986c7a5$var$idTypeMap = new Map();
function $c1b075e40986c7a5$export$2e2bcd8739ae039(fieldValue, typeName) {
    const { id: id } = fieldValue;
    if (id == null) return undefined;
    if ((0, $dh538.fg)('platform_log_relay_duplicate_identifiers')) {
        const idString = String(id);
        if ($c1b075e40986c7a5$var$idTypeMap.has(idString)) {
            const entry = $c1b075e40986c7a5$var$idTypeMap.get(idString);
            if (entry) {
                const { typeName: existingTypeName, hasLoggedConflict: hasLoggedConflict } = entry;
                if (existingTypeName !== typeName && !hasLoggedConflict) {
                    (0, $89103c584b545818$export$b8c037155fd57aaf)('relaydataid.generator', `RelayDataID: conflicting type names for the same ID: ${idString} with type names: ${existingTypeName} and ${typeName}.`, {
                        id: idString,
                        types: `${existingTypeName}, ${typeName}`
                    });
                    entry.hasLoggedConflict = true;
                }
            }
        } else $c1b075e40986c7a5$var$idTypeMap.set(idString, {
            typeName: typeName,
            hasLoggedConflict: false
        });
    }
    return `${String(id)}:::::${typeName}`;
}

});

parcelRegister("iTyoD", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");


var $2gQQV = parcelRequire("2gQQV");


var $bDPoq = parcelRequire("bDPoq");


var $59hua = parcelRequire("59hua");





var $lrJXD = parcelRequire("lrJXD");




const $036ca9aa83e0f390$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $036ca9aa83e0f390$export$bf6cd96e19b2987f = 100;
const $036ca9aa83e0f390$export$1ad8434180c5936c = 300000; // 5m


const $3f9756dc2e75e45b$export$48d7c418edadb60c = ()=>globalThis.__SERVER__ ?? false;
const $3f9756dc2e75e45b$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;


let $4e4d80ce73ad627c$var$client;
const $4e4d80ce73ad627c$export$6bb76d6eba7e258c = ()=>{
    if ((0, $3f9756dc2e75e45b$export$48d7c418edadb60c)()) return null;
    if (!$4e4d80ce73ad627c$var$client) $4e4d80ce73ad627c$var$client = (0, $lrJXD.createClient)({
        url: (0, $3f9756dc2e75e45b$export$29a72e89601dfc59)(),
        lazy: true,
        keepAlive: (0, $036ca9aa83e0f390$export$8b012b965402e06a),
        retryAttempts: (0, $036ca9aa83e0f390$export$bf6cd96e19b2987f),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $bDPoq.RelayExperimentalApis).join(',')
        }
    });
    return $4e4d80ce73ad627c$var$client;
};
const $4e4d80ce73ad627c$export$2f0afd443356d36f = ()=>{
    $4e4d80ce73ad627c$var$client = null;
};

const $b1307ce3a1c15d36$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (typeof error === 'object' && 'type' in error && error.type === 'error') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const errorEvent = error;
        errorInfo = new Error(`ErrorEvent: "${errorEvent.error}"`);
    } else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};


const $c52e2194a2c31d31$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $3e6Uc.Observable).create((sink)=>{
        const client = (0, $4e4d80ce73ad627c$export$6bb76d6eba7e258c)();
        if (!client) return sink.error(new Error('Unable to create subscription client'));
        const payload = {
            query: '',
            operationName: operationName,
            variables: variables,
            extensions: {
                pq: id
            }
        };
        let requestId;
        return client.subscribe(payload, {
            ...sink,
            next: (value)=>{
                // @ts-expect-error agg prop is missing on generic "extensions" type
                const aggRequestId = value?.extensions?.gateway?.request_id;
                requestId = aggRequestId ?? requestId;
                // @ts-expect-error incompatible types between two libraries
                sink.next(value);
            },
            error: (sinkError)=>{
                const errorInfo = (0, $b1307ce3a1c15d36$export$ece4736473c28965)(sinkError);
                sink.error(errorInfo);
            }
        });
    });


const $185542a16deb61ee$export$10f0d162cb6dae7c = async (request, variables, cacheConfig)=>{
    const endpoint = (0, $2gQQV.getAggEndpoint)(request, cacheConfig);
    const body = (0, $2gQQV.getRequestBody)(request, variables);
    return fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'content-type': 'application/json',
            'X-ExperimentalApi': (0, $bDPoq.RelayExperimentalApis).join(',')
        },
        body: body
    }).then((response)=>{
        return response.json();
    });
};
const $185542a16deb61ee$export$21fcfd9d5c6ebbd4 = (0, $3e6Uc.Network).create($185542a16deb61ee$export$10f0d162cb6dae7c);
function $185542a16deb61ee$export$2c3efcea68fbf7c6(networkDependencies) {
    return (0, $3e6Uc.Network).create((request, variables, cacheConfig)=>(0, $59hua.fetch)(request, variables, cacheConfig, networkDependencies), (0, $c52e2194a2c31d31$export$ec068583843480e7));
}
module.exports["fetchFn"] = $185542a16deb61ee$export$10f0d162cb6dae7c;
module.exports["network"] = $185542a16deb61ee$export$21fcfd9d5c6ebbd4;
module.exports["createNetwork"] = $185542a16deb61ee$export$2c3efcea68fbf7c6;

});

parcelRegister("59hua", function(module, exports) {

var $33JSI = parcelRequire("33JSI");


var $3e6Uc = parcelRequire("3e6Uc");


var $dh538 = parcelRequire("dh538");

const $b8b31e9388977391$var$OperationExtensionsMap = {};
const $b8b31e9388977391$export$8656ba3981c6f6c1 = (operationName)=>{
    $b8b31e9388977391$var$OperationExtensionsMap[operationName] = $b8b31e9388977391$var$OperationExtensionsMap[operationName] || [];
};
const $b8b31e9388977391$export$f16fa6040161f056 = (operationName)=>{
    $b8b31e9388977391$var$OperationExtensionsMap[operationName] = undefined;
};
const $b8b31e9388977391$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $b8b31e9388977391$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $b8b31e9388977391$export$7c6ea4184129ef74 = (operationName)=>$b8b31e9388977391$var$OperationExtensionsMap[operationName] || [];



var $2gQQV = parcelRequire("2gQQV");

/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $aec1d0280b51c3e1$export$607b80f5bc6e396d = new Map();
const $aec1d0280b51c3e1$export$cdadce6ed6361a2c = new Map();


const $d5ce6d160f67e727$var$OperationTraceIdMap = {};
const $d5ce6d160f67e727$export$a2bcb2fac360646c = (operationName)=>{
    $d5ce6d160f67e727$var$OperationTraceIdMap[operationName] = $d5ce6d160f67e727$var$OperationTraceIdMap[operationName] || [];
};
const $d5ce6d160f67e727$export$559128bdc4352001 = (operationName)=>{
    $d5ce6d160f67e727$var$OperationTraceIdMap[operationName] = undefined;
};
const $d5ce6d160f67e727$export$fcaa732775f12226 = (operationName, traceId)=>{
    if (traceId !== undefined) {
        const traceIdsForOperation = $d5ce6d160f67e727$var$OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
const $d5ce6d160f67e727$export$5113e470f5c95670 = (operationName)=>$d5ce6d160f67e727$var$OperationTraceIdMap[operationName] || [];


class $dae17d5049a9d798$export$3f5ba18eb97af725 {
    /**
   * Ingest a payload from the server.
   * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
   * @param payload - The payload to ingest.
   */ ingest(payload) {
        const handler = this.handlers.get(payload.id);
        if (handler) this.exec(handler, payload);
        else {
            const queue = this.queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.queuedPayloads.set(payload.id, queue);
        }
    }
    /**
   * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when the event is ingested.
   */ register(id, callback) {
        this.handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.exec(callback, payload));
            this.queuedPayloads.delete(id);
        }
    }
    /**
   * Unregister a callback for a given event.
   * @param id
   */ unregister(id) {
        this.handlers.delete(id);
        this.queuedPayloads.delete(id);
    }
    /**
   * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when abort detected.
   */ onAbort(id, callback) {
        if (this.abortReason) this.exec(callback, {
            args: [
                this.abortReason
            ]
        });
        else this.abortHandlers.set(id, callback);
    }
    /**
   * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
   * @private
   * @param props
   */ _abort(props) {
        this.abortReason = props;
        this.abortHandlers.forEach((handler)=>{
            this.exec(handler, {
                args: [
                    props
                ]
            });
        });
        // We can delete these now that we've handled the case and remainder will be dealt with immediately.
        this.abortHandlers = new Map();
    }
    /**
   * Execute a callback with the given payload.
   * @param callback - The callback to execute.
   * @param payload - The payload to execute the callback with.
   */ exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            // @ts-expect-error
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
    constructor(){
        this.handlers = void 0;
        this.queuedPayloads = void 0;
        this.abortReason = void 0;
        this.abortHandlers = void 0;
        this.handlers = new Map();
        this.abortHandlers = new Map();
        this.queuedPayloads = new Map();
    }
}


const $e5d9c5404c4087ad$export$eb5d9c90d65c7fea = 'ClientDispatcher';
let $e5d9c5404c4087ad$var$dispatcher;
const $e5d9c5404c4087ad$export$5bb012cf9b3a5452 = ()=>{
    if (!$e5d9c5404c4087ad$var$dispatcher) {
        $e5d9c5404c4087ad$var$dispatcher = new (0, $dae17d5049a9d798$export$3f5ba18eb97af725)();
        // Handle the server hangup scenarios
        $e5d9c5404c4087ad$var$dispatcher.register($e5d9c5404c4087ad$export$eb5d9c90d65c7fea, $e5d9c5404c4087ad$var$dispatcher._abort.bind($e5d9c5404c4087ad$var$dispatcher));
    }
    return $e5d9c5404c4087ad$var$dispatcher;
};


const $4852ba516184255b$var$events = [];
const $4852ba516184255b$export$bd50bc4cd3c601ee = (event)=>{
    $4852ba516184255b$var$events.push(event);
};
const $4852ba516184255b$export$3c7145db84d4587c = ()=>{
    return $4852ba516184255b$var$events.splice(0, $4852ba516184255b$var$events.length);
};


/**
 * @fileOverview Implements a fetch function that can handle multipart/mixed responses.
 * The multipart response is expected to follow the GraphQL multipart request spec.
 *
 * See https://github.com/graphql/graphql-over-http/blob/main/rfcs/IncrementalDelivery.md#content-type-multipartmixed
 * See https://github.com/graphql/graphql-over-http/blob/main/spec/GraphQLOverHTTP.md#multipart-request-format
 */ 
var $lgmus = parcelRequire("lgmus");




const $ee37f6fc0d924aec$var$NO_CONTENT = 204;
function $ee37f6fc0d924aec$var$getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
function $ee37f6fc0d924aec$export$701544522b0c6c99(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [part1, part2] = part.split(/\r?\n\r?\n/);
            // when response content has boundary string, part1 is the actual response
            // when response content does not have boundary string, part2 is the actual response
            const body = part2 ?? part1;
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch (error) {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + parts[parts.length - 1];
}
async function $ee37f6fc0d924aec$export$efb69f1fe7577739(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = $ee37f6fc0d924aec$export$701544522b0c6c99(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) $ee37f6fc0d924aec$export$701544522b0c6c99(incompleteChunk, boundaryString, observer);
    observer.complete();
}
function $ee37f6fc0d924aec$var$handleMultipartResponse(response, observer) {
    const contentType = response.headers.get('content-type');
    const boundary = $ee37f6fc0d924aec$var$getBoundary(contentType || '');
    if (!boundary) {
        observer.error(new Error('Invalid multipart boundary'));
        return;
    }
    const decoder = new TextDecoder('utf-8');
    async function* streamReader() {
        // @ts-expect-error a Response object in Node is streamable
        for await (const chunk of response.body){
            const newText = decoder.decode(chunk, {
                stream: true
            });
            yield newText;
        }
    }
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        $ee37f6fc0d924aec$export$efb69f1fe7577739(streamReader(), boundary, observer).catch((error)=>observer.error(error));
    } catch (e) {
        const error = new Error('Failed to read from response body');
        // @ts-ignore: cause property may not be available in all environments
        error.cause = e;
        observer.error(error);
    }
}
function $ee37f6fc0d924aec$var$handleJsonResponse(response, observer) {
    response.json().then((data)=>observer.next(data)).catch((error)=>observer.error(error)).finally(()=>observer.complete());
}
function $ee37f6fc0d924aec$var$handleTextResponse(response, observer) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((error)=>{
        observer.error(new Error(`Error while parsing text response (Content-Type: ${response?.headers?.get('content-type')}): ${error instanceof Error ? error.message : String(error)}`));
    });
}
function $ee37f6fc0d924aec$export$f76505a7f2969e4e(source) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $3e6Uc.Observable).create((observer)=>{
        result.then((response)=>{
            if (response.status === $ee37f6fc0d924aec$var$NO_CONTENT) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $ee37f6fc0d924aec$var$handleJsonResponse(response, observer);
            else if (contentType.includes('text/plain')) $ee37f6fc0d924aec$var$handleTextResponse(response, observer);
            else if (contentType.includes('multipart/mixed')) $ee37f6fc0d924aec$var$handleMultipartResponse(response, observer);
            else $ee37f6fc0d924aec$var$handleTextResponse(response, observer);
        }).catch((error)=>observer.error(error));
    });
}
const $ee37f6fc0d924aec$var$relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
];
const $ee37f6fc0d924aec$var$MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
const $ee37f6fc0d924aec$var$MAX_HEADERS_SIZE = 20480; // Maximum header size in bytes (20 KB)
// Calculate the size of the headers
function $ee37f6fc0d924aec$export$dd754c3ef60c6999(headers) {
    let totalBytes = 0;
    const textEncoder = new TextEncoder();
    // Iterate over each header entry (name and value)
    for (const [name, value] of Object.entries(headers)){
        const headerSize = textEncoder.encode(`${name}: ${value}\r\n`).length; // Include CRLF
        totalBytes += headerSize;
    }
    return totalBytes;
}
function $ee37f6fc0d924aec$export$5ad31d96a9271d42({ url: url, variables: variables, request: request, headers: headers, isServer: isServer }) {
    if (isServer) return {
        isGetRequest: false,
        reason: 'SSR'
    };
    if (request.operationKind !== 'query') return {
        isGetRequest: false,
        reason: request.operationKind
    };
    const serializedVariables = JSON.stringify(variables);
    const queryLength = url.length + serializedVariables.length;
    const headersSize = $ee37f6fc0d924aec$export$dd754c3ef60c6999(headers || {});
    return queryLength <= $ee37f6fc0d924aec$var$MAX_QUERY_LENGTH && headersSize <= $ee37f6fc0d924aec$var$MAX_HEADERS_SIZE ? {
        isGetRequest: true
    } : {
        isGetRequest: false,
        reason: 'URL length or headers size too large'
    };
}
function $ee37f6fc0d924aec$export$33c9c992c7855d86({ url: url, options: options, variables: variables, request: request, isServer: isServer, cacheConfig: cacheConfig }) {
    const headers = {
        Accept: $ee37f6fc0d924aec$var$relayDeferAcceptableFormats.join(', '),
        ...cacheConfig?.metadata?.headers || {}
    };
    const requestOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(options, {
        headers: headers
    });
    requestOptions.headers['Content-Type'] = 'application/json';
    const { isGetRequest: isGetRequest, reason: reason } = $ee37f6fc0d924aec$export$5ad31d96a9271d42({
        url: url,
        variables: variables,
        request: request,
        headers: requestOptions.headers,
        isServer: isServer
    });
    // Nav4ProjectsContentQuery is forced to go POST route to avoid the stale cache issues when transition between issues in Issue-view
    // that's not a permanent fix, but rather an attampt to unblock the team
    // Context: #jiv-navigation-issue channel
    if (isGetRequest && request.name !== 'Nav4ProjectsContentQuery') {
        requestOptions.method = 'GET';
        const params = new URLSearchParams();
        params.append('variables', JSON.stringify(variables));
        url += `${url.includes('?') ? '&' : '?'}${params.toString()}`;
        delete requestOptions.body; // Not needed for GET
    } else {
        requestOptions.method = 'POST';
        if (reason) requestOptions.headers['X-Request-Fallback-To-Post-Reason'] = reason;
    }
    return ()=>fetch(url, requestOptions);
}


const $a71dc4ac2c5f78d6$export$81189edc9b923717 = 1;
const $a71dc4ac2c5f78d6$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $a71dc4ac2c5f78d6$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $a71dc4ac2c5f78d6$export$81189edc9b923717 ? $a71dc4ac2c5f78d6$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};
const $a71dc4ac2c5f78d6$export$7bfea3c3d460ecd8 = (error)=>{
    if ('statusCode' in error && typeof error.statusCode === 'number') return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};
const $a71dc4ac2c5f78d6$export$9dec0f42cc67f6ab = (request)=>{
    if (request.operationKind === 'query') return $a71dc4ac2c5f78d6$export$81189edc9b923717;
    return 0;
};


const $7d88968840210126$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.trace_id;
    return undefined;
};


const $923cf200d647598a$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $923cf200d647598a$var$moduleID = 'relay-fetch';
const $923cf200d647598a$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig, dependencies)=>{
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = dependencies?.getLoggingAndMetricsHelper?.(loggingMetadata);
    function augmentResponse(response) {
        (0, $d5ce6d160f67e727$export$fcaa732775f12226)(queryName, (0, $7d88968840210126$export$eefb7f54c3b07211)(response));
        (0, $b8b31e9388977391$export$17dc47fdf278de21)(queryName, response.extensions);
    }
    // TODO: This needs to be changed by removing each Product, and only if all keys are empty final output is null
    function enforceNonNullability(response) {
        if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    return (0, $3e6Uc.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$923cf200d647598a$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) sink.next(payload);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // handles getting multipart response
            const getData = ()=>{
                const endpoint = (0, $2gQQV.getAggEndpoint)(request, cacheConfig);
                const body = (0, $2gQQV.getRequestBody)(request, variables);
                const options = {
                    body: body
                };
                const fetchOverNetwork = (0, $ee37f6fc0d924aec$export$33c9c992c7855d86)({
                    url: dependencies?.setEndpoint ? dependencies?.setEndpoint(endpoint) : endpoint,
                    options: dependencies?.setOptions ? dependencies?.setOptions(endpoint, options) : options,
                    variables: variables,
                    request: request,
                    isServer: dependencies?.isServer || false,
                    cacheConfig: cacheConfig
                });
                const earlyScriptPromise = dependencies?.earlyScriptPromise?.(request, variables);
                let fetchFn = fetchOverNetwork;
                let initialSource = fetchFn;
                if (dependencies?.withErrorHandling) {
                    const withErrorHandling = dependencies.withErrorHandling;
                    initialSource = ()=>!dependencies?.isServer && earlyScriptPromise ? withErrorHandling(earlyScriptPromise) : withErrorHandling(fetchFn());
                }
                const responses = (0, $ee37f6fc0d924aec$export$f76505a7f2969e4e)(()=>(0, $a71dc4ac2c5f78d6$export$f859c88bfac2cf2c)(initialSource, {
                        retryFunc: fetchFn,
                        retryPredicate: (0, $a71dc4ac2c5f78d6$export$7bfea3c3d460ecd8),
                        retryAttempts: (0, $a71dc4ac2c5f78d6$export$9dec0f42cc67f6ab)(request),
                        onRetry: loggingAndMetrics?.logErrorRetry
                    }));
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                let responseShouldHang = false;
                let firstResponseUsed = false;
                let resolveFirstResponse;
                const firstResponse = new Promise((resolve)=>{
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: ()=>{
                        if (requestID != null) {
                            if (dependencies?.isServer) {
                                // so that SSR SPA knows it is safe to render
                                const renderAfterThisResponse = $923cf200d647598a$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, $aec1d0280b51c3e1$export$607b80f5bc6e396d).set(requestID, renderAfterThisResponse);
                            } else (0, $aec1d0280b51c3e1$export$607b80f5bc6e396d).set(requestID, firstResponse);
                            (0, $aec1d0280b51c3e1$export$cdadce6ed6361a2c).set(requestID, completedResponse);
                        }
                    },
                    next: (response)=>{
                        if (dependencies?.isServer && $923cf200d647598a$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, $4852ba516184255b$export$bd50bc4cd3c601ee)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const singularResponse = response;
                            augmentResponse(singularResponse);
                            if (!dependencies?.validateResponse?.(request, singularResponse)) {
                                dependencies?.onInvalidResponse?.(request, singularResponse);
                                responseShouldHang = true;
                                return;
                            }
                            if ((0, $dh538.fg)('platform_relay_use_new_non_nullability')) response = $923cf200d647598a$export$b143926e518df3b(singularResponse);
                            else enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if (dependencies?.isServer && requestID != null) dependencies?.queryResponseCache?.appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if (dependencies?.isServer && $923cf200d647598a$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: (error)=>{
                        if (!firstResponseUsed) firstResponseUsed = true;
                        loggingAndMetrics?.logError(error);
                        sink.error(error);
                    },
                    complete: ()=>{
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!dependencies?.isServer && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = dependencies?.queryResponseCache?.get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($33JSI)))(ssrCache)) {
                    dependencies?.queryResponseCache?.delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($923cf200d647598a$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $e5d9c5404c4087ad$export$5bb012cf9b3a5452)().register(sinkID, handleResponse);
                        (0, $e5d9c5404c4087ad$export$5bb012cf9b3a5452)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                dependencies?.handleAbort?.(request, reason);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics?.logError(error);
            sink.error(error);
        }
    });
};
function $923cf200d647598a$export$b143926e518df3b(response) {
    if (response.data) {
        // Enforce non-nullability of the product namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        let sanitisedData = Object.assign({}, response.data);
        const productKeys = Object.keys(response.data);
        for (const product of productKeys)if (sanitisedData[product] === null) delete sanitisedData[product];
        if (Object.keys(sanitisedData).length === 0) // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Dataa
        sanitisedData = null;
        response.data = sanitisedData;
    }
    return response;
}
module.exports["fetch"] = $923cf200d647598a$export$e7aa7bc5c1b3cfb3;

});

parcelRegister("lrJXD", function(module, exports) {
$parcel$export(module.exports, "createClient", () => $f9cfc574ab3845a4$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ /**
 *
 * common
 *
 */ /** @private */ function $ed6b7173c8b91525$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $ed6b7173c8b91525$export$a6cdc56e425d0d0a(val) {
    return $ed6b7173c8b91525$export$573326049e1b1c6b(val) === 'object';
}
function $ed6b7173c8b91525$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $ed6b7173c8b91525$export$92bd080471bc30f1(val) {
    return $ed6b7173c8b91525$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $ed6b7173c8b91525$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $ed6b7173c8b91525$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}


const $cbefd1f1d80a870f$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $cbefd1f1d80a870f$export$ec743af8bb66f3be = 'graphql-ws';
var $cbefd1f1d80a870f$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($cbefd1f1d80a870f$export$777128f41f6616ec || ($cbefd1f1d80a870f$export$777128f41f6616ec = {}));
var $cbefd1f1d80a870f$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($cbefd1f1d80a870f$export$80edbf15fa61a4db || ($cbefd1f1d80a870f$export$80edbf15fa61a4db = {}));
function $cbefd1f1d80a870f$export$c17861b159b1b673(val) {
    if (!(0, $ed6b7173c8b91525$export$a6cdc56e425d0d0a)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $ed6b7173c8b91525$export$573326049e1b1c6b)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $ed6b7173c8b91525$export$573326049e1b1c6b)(val.type)}`);
    switch(val.type){
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.ConnectionInit:
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.ConnectionAck:
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Ping:
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $ed6b7173c8b91525$export$a6cdc56e425d0d0a)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $ed6b7173c8b91525$export$573326049e1b1c6b)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $ed6b7173c8b91525$export$a6cdc56e425d0d0a)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $ed6b7173c8b91525$export$573326049e1b1c6b)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $ed6b7173c8b91525$export$573326049e1b1c6b)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $ed6b7173c8b91525$export$a6cdc56e425d0d0a)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $ed6b7173c8b91525$export$573326049e1b1c6b)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $ed6b7173c8b91525$export$573326049e1b1c6b)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $ed6b7173c8b91525$export$573326049e1b1c6b)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $ed6b7173c8b91525$export$a6cdc56e425d0d0a)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $ed6b7173c8b91525$export$573326049e1b1c6b)(val.payload.extensions)}`);
            break;
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $ed6b7173c8b91525$export$573326049e1b1c6b)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $ed6b7173c8b91525$export$a6cdc56e425d0d0a)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $ed6b7173c8b91525$export$573326049e1b1c6b)(val.payload)}`);
            break;
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $ed6b7173c8b91525$export$573326049e1b1c6b)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $ed6b7173c8b91525$export$e6262fbc2e92290)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $ed6b7173c8b91525$export$573326049e1b1c6b)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $cbefd1f1d80a870f$export$9e0e49e75fa7d548(val) {
    try {
        $cbefd1f1d80a870f$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $cbefd1f1d80a870f$export$f2f615077a189f21(data, reviver) {
    return $cbefd1f1d80a870f$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $cbefd1f1d80a870f$export$77896e5b47bfd50b(msg, replacer) {
    $cbefd1f1d80a870f$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}



var $f9cfc574ab3845a4$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $f9cfc574ab3845a4$var$__await ? (this.v = v, this) : new $f9cfc574ab3845a4$var$__await(v);
};
var $f9cfc574ab3845a4$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f9cfc574ab3845a4$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $f9cfc574ab3845a4$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $f9cfc574ab3845a4$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$f9cfc574ab3845a4$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting', retrying);
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $cbefd1f1d80a870f$export$5c0a4edfedc7c457));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $cbefd1f1d80a870f$export$77896e5b47bfd50b)({
                                    type: (0, $cbefd1f1d80a870f$export$80edbf15fa61a4db).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if (errOrEvent instanceof $f9cfc574ab3845a4$export$f5b1bfead8e118a7) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $cbefd1f1d80a870f$export$77896e5b47bfd50b)(payload ? {
                            type: (0, $cbefd1f1d80a870f$export$80edbf15fa61a4db).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $cbefd1f1d80a870f$export$80edbf15fa61a4db).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $cbefd1f1d80a870f$export$777128f41f6616ec).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $cbefd1f1d80a870f$export$777128f41f6616ec).InternalClientError, (0, $ed6b7173c8b91525$export$2937fa0c8dddae54)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $cbefd1f1d80a870f$export$f2f615077a189f21)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $cbefd1f1d80a870f$export$77896e5b47bfd50b)(message.payload ? {
                                    type: (0, $cbefd1f1d80a870f$export$80edbf15fa61a4db).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $cbefd1f1d80a870f$export$80edbf15fa61a4db).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $cbefd1f1d80a870f$export$80edbf15fa61a4db).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload, retrying); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $cbefd1f1d80a870f$export$777128f41f6616ec).BadResponse, (0, $ed6b7173c8b91525$export$2937fa0c8dddae54)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($f9cfc574ab3845a4$var$isLikeCloseEvent(errOrCloseEvent) && ($f9cfc574ab3845a4$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $cbefd1f1d80a870f$export$777128f41f6616ec).InternalServerError,
            (0, $cbefd1f1d80a870f$export$777128f41f6616ec).InternalClientError,
            (0, $cbefd1f1d80a870f$export$777128f41f6616ec).BadRequest,
            (0, $cbefd1f1d80a870f$export$777128f41f6616ec).BadResponse,
            (0, $cbefd1f1d80a870f$export$777128f41f6616ec).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $cbefd1f1d80a870f$export$777128f41f6616ec).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $cbefd1f1d80a870f$export$777128f41f6616ec).SubscriberAlreadyExists,
            (0, $cbefd1f1d80a870f$export$777128f41f6616ec).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($f9cfc574ab3845a4$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    function subscribe(payload, sink) {
        const id = generateID(payload);
        let done = false, errored = false, releaser = ()=>{
            // for handling completions before connect
            locks--;
            done = true;
        };
        (async ()=>{
            locks++;
            for(;;)try {
                const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                // if done while waiting for connect, release the connection lock right away
                if (done) return release();
                const unlisten = emitter.onMessage(id, (message)=>{
                    switch(message.type){
                        case (0, $cbefd1f1d80a870f$export$80edbf15fa61a4db).Next:
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                            sink.next(message.payload);
                            return;
                        case (0, $cbefd1f1d80a870f$export$80edbf15fa61a4db).Error:
                            errored = true, done = true;
                            sink.error(message.payload);
                            releaser();
                            return;
                        case (0, $cbefd1f1d80a870f$export$80edbf15fa61a4db).Complete:
                            done = true;
                            releaser(); // release completes the sink
                            return;
                    }
                });
                socket.send((0, $cbefd1f1d80a870f$export$77896e5b47bfd50b)({
                    id: id,
                    type: (0, $cbefd1f1d80a870f$export$80edbf15fa61a4db).Subscribe,
                    payload: payload
                }, replacer));
                releaser = ()=>{
                    if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                    socket.send((0, $cbefd1f1d80a870f$export$77896e5b47bfd50b)({
                        id: id,
                        type: (0, $cbefd1f1d80a870f$export$80edbf15fa61a4db).Complete
                    }, replacer));
                    locks--;
                    done = true;
                    release();
                };
                // either the releaser will be called, connection completed and
                // the promise resolved or the socket closed and the promise rejected.
                // whatever happens though, we want to stop listening for messages
                await waitForReleaseOrThrowOnClose.finally(unlisten);
                return; // completed, shouldnt try again
            } catch (errOrCloseEvent) {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            }
        })().then(()=>{
            // delivering either an error or a complete terminates the sequence
            if (!errored) sink.complete();
        }) // resolves on release or normal closure
        .catch((err)=>{
            sink.error(err);
        }); // rejects on close events and errors
        return ()=>{
            // dispose only of active subscriptions
            if (!done) releaser();
        };
    }
    return {
        on: emitter.on,
        subscribe: subscribe,
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = subscribe(request, {
                next (val) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $f9cfc574ab3845a4$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $f9cfc574ab3845a4$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $f9cfc574ab3845a4$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $f9cfc574ab3845a4$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', new $f9cfc574ab3845a4$export$f5b1bfead8e118a7());
        }
    };
}
class $f9cfc574ab3845a4$export$f5b1bfead8e118a7 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'TerminatedCloseEvent';
        this.message = '4499: Terminated';
        this.code = 4499;
        this.reason = 'Terminated';
        this.wasClean = false;
    }
}
function $f9cfc574ab3845a4$var$isLikeCloseEvent(val) {
    return (0, $ed6b7173c8b91525$export$a6cdc56e425d0d0a)(val) && 'code' in val && 'reason' in val;
}
function $f9cfc574ab3845a4$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $f9cfc574ab3845a4$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});

parcelRegister("hvWxm", function(module, exports) {

var $dQl1W = parcelRequire("dQl1W");

const $5b0473a1d03d57c0$var$errorCollector = new Map();
const $5b0473a1d03d57c0$export$da396ad2a542b095 = 120000; // 2min
const $5b0473a1d03d57c0$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $5b0473a1d03d57c0$var$errorCollector.delete(key);
    }, $5b0473a1d03d57c0$export$da396ad2a542b095);
};
const $5b0473a1d03d57c0$export$c211170518c6d0f6 = (key = (0, $dQl1W.v4)())=>{
    $5b0473a1d03d57c0$var$errorCollector.set(key, []);
    $5b0473a1d03d57c0$var$scheduleCleanup(key);
    return key;
};
const $5b0473a1d03d57c0$export$e0491a0d974dadfa = (key)=>{
    const errors = $5b0473a1d03d57c0$var$errorCollector.get(key);
    $5b0473a1d03d57c0$var$errorCollector.delete(key);
    return errors || [];
};
const $5b0473a1d03d57c0$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $5b0473a1d03d57c0$var$errorCollector.forEach((value, key)=>{
        $5b0473a1d03d57c0$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $5b0473a1d03d57c0$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};
module.exports["startCaptureGraphQlErrors"] = $5b0473a1d03d57c0$export$c211170518c6d0f6;
module.exports["stopCaptureGraphQlErrors"] = $5b0473a1d03d57c0$export$e0491a0d974dadfa;
module.exports["captureErrors"] = $5b0473a1d03d57c0$export$7a973c0ff390eb47;
module.exports["isUnauthenticated"] = $5b0473a1d03d57c0$export$1724ecfee73c4768;

});

parcelRegister("fcZiu", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $e1580fd00faa35ab$export$944ecde68d3596be = {
    IS_NEW_USER: 'Query.isNewUser',
    IS_SITE_ADMIN: 'Query.isSiteAdmin',
    IS_ESTABLISHED_USER: 'ExperimentalUserPersonalization.isEstablishedUser',
    ORIGIN_PRODUCT: 'onboarding-origin-state:attributes'
};
const $e1580fd00faa35ab$export$9e2bcbcd8ed473bc = ()=>{
    if (!(0, $17wUi.confluenceLocalStorageInstance)) return {};
    try {
        return JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).QUERY_OVERRIDES)) || {};
    } catch  {
        return {};
    }
};
/**
 * Applies query overrides to response data recursively
 * @param response - The response object to modify
 * @param overrides - The overrides to apply
 */ const $e1580fd00faa35ab$var$applyQueryOverrides = (response, overrides)=>{
    if (!response.data || typeof response.data !== 'object') return;
    function deepApplyQueryOverrides(data, typename) {
        if (data == null || typeof data !== 'object') return data;
        if (!typename) {
            typename = data.__typename;
            if (!typename) return data;
        }
        data = shallowApplyQueryOverrides(data, typename);
        Object.entries(data).forEach(([key, value])=>data[key] = deepApplyQueryOverrides(value));
        return data;
    }
    const overrideEntries = Object.entries(overrides);
    function shallowApplyQueryOverrides(data, typename) {
        const typenamePrefix = `${typename}.`;
        overrideEntries.forEach(([overrideKey, overrideValue])=>{
            if (!overrideKey.startsWith(typenamePrefix)) return;
            const field = overrideKey.substring(typenamePrefix.length);
            if (!(field in data)) return;
            // Match the type of the override to the type of the field:
            switch(typeof data[field]){
                case 'boolean':
                    overrideValue = overrideValue === 'true';
                    break;
                case 'number':
                    overrideValue = Number(overrideValue);
                    break;
            }
            data[field] = overrideValue;
        });
        return data;
    }
    deepApplyQueryOverrides(response.data, 'Query');
};
/**
 * Applies established user override to response data
 * @param data - The response data object to modify
 * @param overrides - The overrides to apply
 */ const $e1580fd00faa35ab$var$applyEstablishedUserOverride = (data, overrides)=>{
    if (!data?.experimentalUserPersonalization) return;
    let isEstablishedUserTraitName = 'confluence_is_established_user';
    const { hostname: hostname } = window.location;
    if (hostname.endsWith('.jira-dev.com')) isEstablishedUserTraitName = 'confluence_is_established_user_stg';
    if (data.experimentalUserPersonalization.__typename === 'ExperimentalUserPersonalization' && $e1580fd00faa35ab$export$944ecde68d3596be.IS_ESTABLISHED_USER in overrides) {
        if (data.experimentalUserPersonalization.attributes) {
            const filteredAttributes = data.experimentalUserPersonalization.attributes.filter((i)=>i.name !== isEstablishedUserTraitName);
            data.experimentalUserPersonalization.attributes = [
                ...filteredAttributes,
                {
                    name: isEstablishedUserTraitName,
                    value: (overrides[$e1580fd00faa35ab$export$944ecde68d3596be.IS_ESTABLISHED_USER] === 'true').toString(),
                    __typename: 'ExperimentalUserPersonalizationAttributes'
                }
            ];
        }
    }
};
/**
 * Applies onboarding state override to response data
 * @param data - The response data object to modify
 * @param overrides - The overrides to apply
 */ const $e1580fd00faa35ab$var$applyOnboardingStateOverride = (data, overrides)=>{
    if (!data.onboardingState) return;
    data.onboardingState = data.onboardingState.map((state)=>{
        const { __typename: __typename, key: key } = state;
        if (__typename === 'OnboardingState' && key in overrides) return {
            ...state,
            value: overrides[key].toString()
        };
        return state;
    });
};
/**
 * Checks if the operation is a query operation
 * @param apolloOperation - Apollo's Operation format
 * @param relayRequest - Relay's RequestParameters format
 * @returns true if the operation is a query
 */ const $e1580fd00faa35ab$var$isQueryOperation = ({ apolloOperation: apolloOperation, relayRequest: relayRequest })=>{
    // Handle Relay format (has operationKind directly)
    if (relayRequest?.operationKind) return relayRequest.operationKind === 'query';
    // Handle Apollo format (has query.definitions)
    if (apolloOperation?.query?.definitions) return apolloOperation.query.definitions.some((definition)=>'operation' in definition && definition.operation === 'query');
    return false;
};
const $e1580fd00faa35ab$export$3c6671486e8a3c05 = ({ overrides: overrides, response: response, apolloOperation: apolloOperation, relayRequest: relayRequest })=>{
    if (Object.keys(overrides).length === 0) return response;
    if ($e1580fd00faa35ab$var$isQueryOperation({
        apolloOperation: apolloOperation,
        relayRequest: relayRequest
    })) $e1580fd00faa35ab$var$applyQueryOverrides(response, overrides);
    if (response?.data != null && typeof response.data === 'object') {
        $e1580fd00faa35ab$var$applyEstablishedUserOverride(response.data, overrides);
        $e1580fd00faa35ab$var$applyOnboardingStateOverride(response.data, overrides);
    }
    return response;
};
module.exports["QUERY_OVERRIDE_KEYS"] = $e1580fd00faa35ab$export$944ecde68d3596be;
module.exports["loadOverridesFromStorage"] = $e1580fd00faa35ab$export$9e2bcbcd8ed473bc;
module.exports["applyQueryOverridesToResponse"] = $e1580fd00faa35ab$export$3c6671486e8a3c05;

});

parcelRegister("kZDrw", function(module, exports) {
$parcel$export(module.exports, "NavdexListener", () => (parcelRequire("7Gyt2")).NavdexListener);

var $7Gyt2 = parcelRequire("7Gyt2");


});

parcelRegister("jVK0t", function(module, exports) {
$parcel$export(module.exports, "I18nProvider", () => (parcelRequire("h4kcT")).I18nProvider);

var $h4kcT = parcelRequire("h4kcT");


});

parcelRegister("fcF01", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $bQm3c = parcelRequire("bQm3c");


var $1ytiN = parcelRequire("1ytiN");


var $euL71 = parcelRequire("euL71");


var $e5k34 = parcelRequire("e5k34");

const $f28efedc8639895a$export$82a72ebc0ad4b09b = /*#__PURE__*/ (0, $42omo.createContext)({
    shouldShowUpFlow: false,
    isSiteAdmin: false,
    cloudId: '',
    currentEdition: undefined,
    showUpFlow: ()=>{},
    hideUpFlow: ()=>{}
});
const $f28efedc8639895a$var$UPFLOW_PROVIDER_INITIAL_DATA = {
    shouldShowUpFlow: false,
    touchpointId: '',
    targetEdition: (0, $euL71.ConfluenceEdition).STANDARD,
    flow: '',
    epMessageId: ''
};
const $f28efedc8639895a$export$60acad7768008761 = ({ children: children })=>{
    const [upFlowProviderData, setUpFlowProviderData] = (0, $42omo.useState)($f28efedc8639895a$var$UPFLOW_PROVIDER_INITIAL_DATA);
    const upFlowProviderDataRef = (0, $42omo.useRef)(upFlowProviderData);
    upFlowProviderDataRef.current = upFlowProviderData;
    const { shouldShowUpFlow: shouldShowUpFlow, targetEdition: targetEdition, flow: flow, touchpointId: touchpointId, epMessageId: epMessageId } = upFlowProviderData;
    const { isSiteAdmin: isSiteAdmin, tenantId: tenantId } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { edition: currentEdition, userId: userId } = (0, $bQm3c.useSessionData)();
    const showUpFlow = (0, $42omo.useCallback)((data)=>{
        experienceTracker.start({
            name: (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE),
            attributes: {
                currentEdition: currentEdition || undefined,
                targetEdition: data.targetEdition,
                experience: (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE),
                experienceId: data.touchpointId
            }
        });
        setUpFlowProviderData({
            ...data,
            shouldShowUpFlow: true
        });
    }, [
        setUpFlowProviderData,
        currentEdition,
        experienceTracker
    ]);
    const hideUpFlow = (0, $42omo.useCallback)(()=>{
        // UpFlow calls the experience fail/abort, so we should not do it here.
        setUpFlowProviderData({
            ...upFlowProviderDataRef.current,
            shouldShowUpFlow: false,
            touchpointId: '',
            flow: '',
            epMessageId: ''
        });
    }, [
        upFlowProviderDataRef,
        setUpFlowProviderData
    ]);
    const onUpFlowOpen = ()=>{
    // no-op
    };
    const failExperienceOnError = (0, $42omo.useCallback)((error)=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    const context = (0, $42omo.useMemo)(()=>({
            shouldShowUpFlow: shouldShowUpFlow,
            isSiteAdmin: isSiteAdmin,
            cloudId: tenantId,
            currentEdition: currentEdition || undefined,
            showUpFlow: showUpFlow,
            hideUpFlow: hideUpFlow
        }), [
        shouldShowUpFlow,
        isSiteAdmin,
        tenantId,
        currentEdition,
        showUpFlow,
        hideUpFlow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f28efedc8639895a$export$82a72ebc0ad4b09b.Provider, {
        value: context
    }, children, shouldShowUpFlow && targetEdition && flow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT,
        onError: failExperienceOnError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
        canChangeEdition: isSiteAdmin,
        cloudId: tenantId,
        currentEdition: currentEdition || undefined,
        atlassianAccountId: userId || undefined,
        flow: flow,
        product: "confluence",
        targetEdition: targetEdition,
        touchpointId: touchpointId,
        onClose: hideUpFlow,
        onOpen: onUpFlowOpen,
        epMessageId: epMessageId,
        isExperienceTrackerEnabled: true
    })) : null);
};
const { Consumer: $f28efedc8639895a$export$b3bffd4bb7da6b8f } = $f28efedc8639895a$export$82a72ebc0ad4b09b;
module.exports["UpFlowContext"] = $f28efedc8639895a$export$82a72ebc0ad4b09b;
module.exports["UpFlowProvider"] = $f28efedc8639895a$export$60acad7768008761;

});

parcelRegister("hSqtY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eCryJ = parcelRequire("eCryJ");

const $300d7a5b554da2b2$var$NullErrorComponent = ()=>null;
const $300d7a5b554da2b2$export$a457282dd80ca698 = ({ attribution: attribution, children: children, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: attribution,
        renderOnError: $300d7a5b554da2b2$var$NullErrorComponent,
        onError: onError
    }, children);
module.exports["TransparentErrorBoundary"] = $300d7a5b554da2b2$export$a457282dd80ca698;

});

parcelRegister("1ytiN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $1uFM6 = parcelRequire("1uFM6");


var $gFHOP = parcelRequire("gFHOP");

const $a659e2987d622809$export$2fba198b5b2e37fa = {
    tenantId: '',
    isNewUser: false,
    userCanCreateContent: false,
    isAnonymous: false,
    siteLogoUrl: '',
    siteTitle: '',
    showSiteTitle: false,
    homepageUri: '',
    homepageTitle: '',
    companyHubName: '',
    frontCoverState: '',
    experimentFeatures: '',
    abTestCohorts: '',
    isSiteAdmin: false,
    loading: true
};
const $a659e2987d622809$export$c0090315433886dc = /*#__PURE__*/ (0, $42omo.createContext)($a659e2987d622809$export$2fba198b5b2e37fa);
const $a659e2987d622809$export$10a1885560a2fd1d = /*#__PURE__*/ (0, $42omo.memo)(({ children: children })=>{
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $gFHOP.SiteInformationQuery));
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: 'backbone'
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    // The context will fallback to default if any error happens
    const context = (0, $42omo.useMemo)(()=>({
            ...data ? $a659e2987d622809$export$3ceb62baab058c6b(data) : $a659e2987d622809$export$2fba198b5b2e37fa,
            loading: loading,
            error: error
        }), [
        loading,
        error,
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a659e2987d622809$export$c0090315433886dc.Provider, {
        value: context
    }, children);
});
const $a659e2987d622809$export$3ceb62baab058c6b = (data)=>{
    const { isSiteAdmin: isSiteAdmin, abTestCohorts: abTestCohorts, experimentFeatures: experimentFeatures, userCanCreateContent: userCanCreateContent, isNewUser: isNewUser } = data;
    const { uri: homepageUri, title: homepageTitle } = data?.siteSettings?.homepage || {};
    const { isAnonymous: isAnonymous } = data?.currentConfluenceUser || {};
    const { logoUrl: siteLogoUrl } = data?.siteDescription || {};
    const { siteTitle: siteTitle } = data?.siteSettings || {};
    const { showApplicationTitle: showSiteTitle, companyHubName: companyHubName } = data?.siteSettings || {};
    const { frontCoverState: frontCoverState } = data?.siteSettings?.frontCover || {};
    const tenantId = data?.tenant?.cloudId;
    const contextData = {
        tenantId: tenantId,
        isNewUser: isNewUser,
        userCanCreateContent: userCanCreateContent,
        isAnonymous: isAnonymous,
        siteLogoUrl: siteLogoUrl,
        siteTitle: siteTitle,
        showSiteTitle: showSiteTitle,
        homepageUri: homepageUri,
        frontCoverState: frontCoverState,
        companyHubName: companyHubName,
        homepageTitle: homepageTitle,
        experimentFeatures: experimentFeatures,
        abTestCohorts: abTestCohorts,
        isSiteAdmin: isSiteAdmin,
        loading: false
    };
    // replace null values from query data with default values
    for (const [key, value] of Object.entries(contextData))if (value === null || value === undefined) contextData[key] = $a659e2987d622809$export$2fba198b5b2e37fa[key];
    return contextData;
};
module.exports["SPAViewContext"] = $a659e2987d622809$export$c0090315433886dc;
module.exports["SPAViewContextProvider"] = $a659e2987d622809$export$10a1885560a2fd1d;

});

parcelRegister("e5k34", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $39559a87bbe2d5db$export$fad9b967c5750450 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "WKfML",
    name: "UpFlowCommerceRouterLoadable",
    loader: async ()=>(await (parcelRequire("3lHG5"))).UpFlowCommerceRouter
});
module.exports["UpFlowCommerceRouterLoadable"] = $39559a87bbe2d5db$export$fad9b967c5750450;

});

parcelRegister("3lHG5", function(module, exports) {

let $270536beeb5c4575$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $270536beeb5c4575$var$load("7WaUI"),
    $270536beeb5c4575$var$load("hhss7"),
    $270536beeb5c4575$var$load("gV84f")
]).then(()=>parcelRequire('7SmYm'));

});

parcelRegister("gqqjz", function(module, exports) {

var $T1bCI = parcelRequire("T1bCI");

class $d20d6e16f6c11b99$export$4ce3626a8d59c88d extends (0, $T1bCI.Container) {
    constructor(_flags){
        super();
        this.previousShowFlag = void 0;
        this.showMultipleFlags = (flags)=>this.setState(({ nextFlagId: nextFlagId })=>{
                const newFlags = flags.map((flag)=>({
                        ...flag,
                        id: nextFlagId++
                    }));
                return {
                    flags: newFlags,
                    nextFlagId: nextFlagId
                };
            });
        this.showFlag = (flag)=>{
            const updateFlagState = ()=>{
                let newFlag;
                const setStateCallback = ()=>{
                    return this.setState(({ flags: flags, nextFlagId: nextFlagId })=>{
                        const equalsFlag = (testFlag)=>testFlag.id === flag.id;
                        if (flags.some(equalsFlag)) {
                            const newFlags = flags.map((testFlag)=>equalsFlag(testFlag) ? flag : testFlag);
                            return {
                                flags: newFlags,
                                nextFlagId: nextFlagId
                            };
                        }
                        newFlag = {
                            ...flag,
                            id: flag.id || nextFlagId
                        };
                        return {
                            flags: [
                                newFlag,
                                ...flags
                            ],
                            nextFlagId: nextFlagId + 1
                        };
                    });
                };
                return new Promise((resolve)=>{
                    setStateCallback();
                    resolve(newFlag);
                }).then(()=>newFlag);
            };
            const delay = ()=>new Promise((resolve)=>{
                    // Timeout protects against visual bug caused by
                    // race condition from concurrent executions of this function.
                    setTimeout(resolve, 500);
                });
            if (this.previousShowFlag) {
                const result = this.previousShowFlag.then(updateFlagState);
                this.previousShowFlag = delay();
                return result;
            } else {
                this.previousShowFlag = delay();
                return updateFlagState();
            }
        };
        this.updateFlag = (id, patch)=>this.setState((state)=>{
                // Ensure we create new instance of both updated flag and of an entire flags array,
                // and retain the order of the flags in the array.
                // Avoid direct mutation of flag and array as it may cause bugs when rendering flags.
                const flags = [
                    ...state.flags
                ];
                for(let index = 0; index < flags.length; index++){
                    const flag = flags[index];
                    if (flag.id === id) flags[index] = {
                        ...flag,
                        ...patch
                    };
                }
                return {
                    flags: flags
                };
            });
        this.hideFlag = (id)=>this.setState((state)=>({
                    flags: state.flags.filter((flag)=>flag.id !== id)
                }));
        /**
     * Hides all active flags but the ones which have explicitly been marked with
     * `close: "never"` - these have been marked explicitly, because an
     * undesireable interaction with existing `hideAllFlags()` calls was observed.
     */ this.hideAllFlags = ()=>this.setState((state)=>({
                    flags: state.flags.filter((flag)=>flag.close === 'never')
                }));
        // Allows for setting whether the flags should be visually hidden or shown in the UI
        this.setFlagsVisibility = (areFlagsVisible)=>this.setState({
                areFlagsVisible: areFlagsVisible
            });
        this.showFlagOfType = (type)=>({ id: id, title: title, description: description, actions: actions, onClose: onClose, isAutoDismiss: isAutoDismiss, customIcon: customIcon, appearance: appearance, delayAnnouncement: delayAnnouncement })=>this.showFlag({
                    id: id,
                    type: type,
                    title: title,
                    description: description,
                    actions: actions,
                    onClose: onClose,
                    close: isAutoDismiss ? 'auto' : undefined,
                    customIcon: customIcon,
                    appearance: appearance,
                    delayAnnouncement: delayAnnouncement
                });
        this.showSuccessFlag = this.showFlagOfType('success');
        this.showSuccessCircleFlag = this.showFlagOfType('success-circle');
        this.showInfoFlag = this.showFlagOfType('info');
        this.showCustomFlag = this.showFlagOfType('custom');
        this.showWarningFlag = this.showFlagOfType('warning');
        this.showErrorFlag = this.showFlagOfType('error');
        this.previousShowFlag = null;
        this.state = {
            flags: _flags || [],
            nextFlagId: _flags ? _flags.length : 0,
            areFlagsVisible: true
        };
    }
}
module.exports["FlagsStateContainer"] = $d20d6e16f6c11b99$export$4ce3626a8d59c88d;

});

parcelRegister("jOtRZ", function(module, exports) {
var $f2665f9f833e3f35$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});



var $bQm3c = parcelRequire("bQm3c");

const $b1c92c0a0cfda130$export$3dc2b705cb95c13f = (environment)=>{
    let analyticsEnvironment;
    switch(environment){
        case 'PRODUCTION':
        case 'prod':
            analyticsEnvironment = (0, $f2665f9f833e3f35$export$56ac8ebc9870b1b9).PROD;
            break;
        case 'STAGING':
        case 'staging':
            analyticsEnvironment = (0, $f2665f9f833e3f35$export$56ac8ebc9870b1b9).STAGING;
            break;
        default:
            analyticsEnvironment = (0, $f2665f9f833e3f35$export$56ac8ebc9870b1b9).DEV;
    }
    return analyticsEnvironment;
};
const $b1c92c0a0cfda130$export$6f29e1e316768b98 = (rawEnvironment)=>{
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    return $b1c92c0a0cfda130$export$3dc2b705cb95c13f(rawEnvironment ?? environment);
};
module.exports["determineAnalyticsEnvironment"] = $b1c92c0a0cfda130$export$3dc2b705cb95c13f;
module.exports["useAnalyticsEnvironment"] = $b1c92c0a0cfda130$export$6f29e1e316768b98;

});

parcelRegister("ll2sR", function(module, exports) {
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths -- Preventing pre-commit error from being thrown when importing NO_CONTENT from controllers folder*/ 
var $aCriw = parcelRequire("aCriw");


var $6empl = parcelRequire("6empl");


var $fw9LG = parcelRequire("fw9LG");


var $9gzc5 = parcelRequire("9gzc5");


var $B8oFf = parcelRequire("B8oFf");


var $9Oif4 = parcelRequire("9Oif4");

const $d6ce555f4a185bef$export$63ce1a41d951945d = 300000; // 5m timeout for duplicate request attempts
class $d6ce555f4a185bef$export$da23bd36e2d631b extends (0, $9Oif4.ChoreographerPlugin) {
    /**
   * Informs the Logger utility class to *NOT* log the provided event if it contains a blockedByProductId
   * attribute of the Engagekit product. EP is _super_ noisy when it comes to logging, and we get no value
   * out of the events it logs for its own message starts that are blocked, by any messages. The reason is
   * that EP tries to start all of its messages all of the time, and lets the gateway determine whether to
   * actually display the message. Roughly 99.9% of messages fail to start for reasons of prior exposure,
   * the user being in the holdout group, or any number of other reasons, so we're logging roughly 1000x what
   * we get any value out of. This filter will now prevent all of those extra, more useless logs, from being
   * actually fired off, and will keep just the log entries from which we can derive some actual value.
   *
   * @param event OperationalEventPayload
   * @returns boolean
   */ shouldLogEvent(event) {
        return event.actionSubject !== (0, $fw9LG.MessageAction).START || event.action !== (0, $fw9LG.MessageDeliveryStatus).BLOCKED;
    }
    isValidDuplicateStartRequest(messageId) {
        const currentMessage = (0, $6empl.Choreographer).getInstance().getCurrentMessage() ?? (0, $6empl.Choreographer).getInstance().getCurrentPendingMessage();
        return Boolean(currentMessage && currentMessage.productId === this.state.productId && currentMessage.messageId === messageId && Date.now() - currentMessage.timestamp < $d6ce555f4a185bef$export$63ce1a41d951945d);
    }
    async startMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $9gzc5.DebugLogger)(this.state.productId, messageId);
        const actionSubject = (0, $fw9LG.MessageAction).START;
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::startMessageWithPlugin`
        });
        /**
     * The Choreographer sets a 5m TTL for any message that opens, before forcefully closing it.
     * EP also allows a messageId to re-request its start if it hasn't yet been dismissed (this is a
     * feature of HISI. For this reason, we can mimic that functionality here (otherwise, Choreographer
     * will block the subsequest start request attempt altogether), by checking the Choreographer's
     * currentMessage against our productId/messageId combo here. If this *is* the currentMessage being
     * displayed, it means it hasn't been dismissed, and we let the request dispatch for EP to make the call.
     */ const isValidDuplicateStartRequest = this.isValidDuplicateStartRequest(messageId);
        if (isValidDuplicateStartRequest) {
            const logger = new (0, $B8oFf.Logger)(actionSubject, messageId, {
                ...this.state.metaMetricsData,
                ...additionalData
            }, this.analyticsClient);
            const didStart = Boolean(await callback());
            if (didStart) {
                logger.started();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        plugin: this.constructor.name,
                        disposition: (0, $fw9LG.MessageDeliveryStatus).STARTED,
                        timestamp: performance.now()
                    }
                });
            }
            return didStart;
        }
        // Do a just-in-time message start subscription with our callback to stargate
        this.onStart(messageId, callback);
        /**
     * Dispatch the request to start the message, and return the response, which will
     * either be 'started' if successful, and anything else if unsuccessful. Convert
     * that value with a boolean check, because the consumer only cares about true/false.
     */ const result = await this.startMessage(messageId, additionalData);
        return result === (0, $fw9LG.MessageDeliveryStatus).STARTED;
    }
    async stopMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $9gzc5.DebugLogger)(this.state.productId, messageId);
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::stopMessageWithPlugin`
        });
        // Do a just-in-time message stop subscription with our callback to stargate
        this.onStop(messageId, callback);
        /**
     * Dispatch the request to stop the message, and return the response, which will
     * either be 'stopped' if successful, and anything else if unsuccessful. Convert
     * that value with a boolean check, because the consumer only cares about true/false.
     */ const result = await this.stopMessage(messageId, additionalData);
        return result === (0, $fw9LG.MessageDeliveryStatus).STOPPED;
    }
    constructor(env, metaMetricsData = {}){
        super((0, $fw9LG.ProductIds).ENGAGEKIT, env, metaMetricsData);
    }
}


const $7a9fd76f016b15ed$export$3288b14b6745c572 = 204;
const $7a9fd76f016b15ed$export$c09e7ea0fc79f34f = 409;
const $7a9fd76f016b15ed$export$974c37534b0191b1 = 503;



var $aqVTl = parcelRequire("aqVTl");

const $a9459a94d201e75b$export$f4d1b02d312560f5 = '2';
const $a9459a94d201e75b$var$inProductMessagesUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($aCriw))).parse('/engage-targeting/api/v2/user/{cloudId}/in-product-messages{?product,schema,locale}');
async function $a9459a94d201e75b$export$8c20ab16ac9cf14f(cloudId, stargateUrl, product, locale) {
    return (0, $aqVTl.stargateFetch)(`${stargateUrl}${$a9459a94d201e75b$var$inProductMessagesUrlTemplate.expand({
        cloudId: cloudId,
        product: product,
        schema: $a9459a94d201e75b$export$f4d1b02d312560f5,
        locale: locale
    })}`).then((0, $aqVTl.errorIfNotOk)).then((r)=>r.json().then((messages)=>({
                messages: messages,
                interval: Number.parseFloat(r.headers.get('POLL-INTERVAL') || '0')
            })));
}
function $a9459a94d201e75b$var$handleStartStopMessageResponse(response) {
    return response.status === (0, $7a9fd76f016b15ed$export$3288b14b6745c572);
}
const $a9459a94d201e75b$var$startMessageUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($aCriw))).parse('/engage-targeting/api/v2/user/messages/{messageId}/start');
const $a9459a94d201e75b$var$startMessageWithVariationIdUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($aCriw))).parse('/engage-targeting/api/v2/user/messages/{messageId}/start/{variationId}');
const $a9459a94d201e75b$var$stopMessageUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($aCriw))).parse('/engage-targeting/api/v2/user/messages/{messageId}/stop');
var $a9459a94d201e75b$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
// Initialize the choreographer plugin on module load
// const choreographerPlugin = new EngagekitChoreographerPlugin();
let $a9459a94d201e75b$var$choreographerPlugin;
async function $a9459a94d201e75b$export$7a77c9a7b182680b(startMessageConfig, options) {
    if (options?.enableChoreographer) return $a9459a94d201e75b$var$startMessageWithChoreographer(startMessageConfig, options);
    return $a9459a94d201e75b$var$startMessageWithCoordination(startMessageConfig);
}
async function $a9459a94d201e75b$export$159ff839f1f095d2(stopMessageConfig, options) {
    if (options?.enableChoreographer) return $a9459a94d201e75b$var$stopMessageWithChoreographer(stopMessageConfig, options);
    return $a9459a94d201e75b$var$stopMessageWithCoordination(stopMessageConfig);
}
async function $a9459a94d201e75b$var$startMessageWithChoreographer(startMessageConfig, options) {
    if (!$a9459a94d201e75b$var$choreographerPlugin) $a9459a94d201e75b$var$choreographerPlugin = new (0, $d6ce555f4a185bef$export$da23bd36e2d631b)(options.envType ?? "local");
    return $a9459a94d201e75b$var$choreographerPlugin.startMessageWithPlugin(startMessageConfig.messageId, ()=>$a9459a94d201e75b$var$startMessageWithCoordination(startMessageConfig, true), options.additionalData);
}
async function $a9459a94d201e75b$var$stopMessageWithChoreographer(stopMessageConfig, options) {
    if (!$a9459a94d201e75b$var$choreographerPlugin) $a9459a94d201e75b$var$choreographerPlugin = new (0, $d6ce555f4a185bef$export$da23bd36e2d631b)(options.envType ?? "local");
    return $a9459a94d201e75b$var$choreographerPlugin.stopMessageWithPlugin(stopMessageConfig.messageId, ()=>$a9459a94d201e75b$var$stopMessageWithCoordination(stopMessageConfig, true), options.additionalData);
}
async function $a9459a94d201e75b$var$startMessageWithCoordination(startMessageConfig, choreographerEnabled = false) {
    const requestBody = {
        cloudId: startMessageConfig.cloudId,
        orgId: startMessageConfig.orgId,
        workspaceId: startMessageConfig.workspaceId,
        choreographerEnabled: choreographerEnabled
    };
    return (0, $aqVTl.stargateFetch)(startMessageConfig.variationId ? `${startMessageConfig.stargateUrl}${$a9459a94d201e75b$var$startMessageWithVariationIdUrlTemplate.expand({
        messageId: startMessageConfig.messageId,
        variationId: startMessageConfig.variationId
    })}` : `${startMessageConfig.stargateUrl}${$a9459a94d201e75b$var$startMessageUrlTemplate.expand({
        messageId: startMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $aqVTl.pullResponseTextIfNotOk)).then($a9459a94d201e75b$var$handleStartStopMessageResponse);
}
async function $a9459a94d201e75b$var$stopMessageWithCoordination(stopMessageConfig, choreographerEnabled = false) {
    const requestBody = {
        cloudId: stopMessageConfig.cloudId,
        orgId: stopMessageConfig.orgId,
        workspaceId: stopMessageConfig.workspaceId,
        choreographerEnabled: choreographerEnabled
    };
    return (0, $aqVTl.stargateFetch)(`${stopMessageConfig.stargateUrl}${$a9459a94d201e75b$var$stopMessageUrlTemplate.expand({
        messageId: stopMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $aqVTl.pullResponseTextIfNotOk)).then($a9459a94d201e75b$var$handleStartStopMessageResponse);
}
const $a9459a94d201e75b$var$userResponseUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($aCriw))).parse('/engage-targeting/api/v2/user/{cloudId}/messages/{messageId}/response');
async function $a9459a94d201e75b$export$e1fd1449cf83c1f5(cloudId, stargateUrl, messageId, payload) {
    return (0, $aqVTl.stargateFetch)(`${stargateUrl}${$a9459a94d201e75b$var$userResponseUrlTemplate.expand({
        cloudId: cloudId,
        messageId: messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $aqVTl.pullResponseTextIfNotOk)).then(()=>Promise.resolve());
}
const $a9459a94d201e75b$var$markSeenAndFatigueUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($aCriw))).parse('/engage-targeting/api/v2/user/messages/{messageId}/seen');
async function $a9459a94d201e75b$export$3683393f780c6905(seenMessageConfig) {
    const requestBody = {
        cloudId: seenMessageConfig.cloudId,
        orgId: seenMessageConfig.orgId,
        workspaceId: seenMessageConfig.workspaceId
    };
    return (0, $aqVTl.stargateFetch)(`${seenMessageConfig.stargateUrl}${$a9459a94d201e75b$var$markSeenAndFatigueUrlTemplate.expand({
        messageId: seenMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $aqVTl.pullResponseTextIfNotOk)).then(()=>Promise.resolve());
}
module.exports["getMessages"] = $a9459a94d201e75b$export$8c20ab16ac9cf14f;
module.exports["startMessage"] = $a9459a94d201e75b$export$7a77c9a7b182680b;
module.exports["stopMessage"] = $a9459a94d201e75b$export$159ff839f1f095d2;
module.exports["sendUserResponse"] = $a9459a94d201e75b$export$e1fd1449cf83c1f5;
module.exports["markAsSeenAndFatigued"] = $a9459a94d201e75b$export$3683393f780c6905;

});

parcelRegister("aCriw", function(module, exports) {
(function(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    /**
   * @constructor
   */ function UrlTemplate() {}
    /**
   * @private
   * @param {string} str
   * @return {string}
   */ UrlTemplate.prototype.encodeReserved = function(str) {
        return str.split(/(%[0-9A-Fa-f]{2})/g).map(function(part) {
            if (!/%[0-9A-Fa-f]/.test(part)) part = encodeURI(part).replace(/%5B/g, '[').replace(/%5D/g, ']');
            return part;
        }).join('');
    };
    /**
   * @private
   * @param {string} str
   * @return {string}
   */ UrlTemplate.prototype.encodeUnreserved = function(str) {
        return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
            return '%' + c.charCodeAt(0).toString(16).toUpperCase();
        });
    };
    /**
   * @private
   * @param {string} operator
   * @param {string} value
   * @param {string} key
   * @return {string}
   */ UrlTemplate.prototype.encodeValue = function(operator, value, key) {
        value = operator === '+' || operator === '#' ? this.encodeReserved(value) : this.encodeUnreserved(value);
        if (key) return this.encodeUnreserved(key) + '=' + value;
        else return value;
    };
    /**
   * @private
   * @param {*} value
   * @return {boolean}
   */ UrlTemplate.prototype.isDefined = function(value) {
        return value !== undefined && value !== null;
    };
    /**
   * @private
   * @param {string}
   * @return {boolean}
   */ UrlTemplate.prototype.isKeyOperator = function(operator) {
        return operator === ';' || operator === '&' || operator === '?';
    };
    /**
   * @private
   * @param {Object} context
   * @param {string} operator
   * @param {string} key
   * @param {string} modifier
   */ UrlTemplate.prototype.getValues = function(context, operator, key, modifier) {
        var value = context[key], result = [];
        if (this.isDefined(value) && value !== '') {
            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
                value = value.toString();
                if (modifier && modifier !== '*') value = value.substring(0, parseInt(modifier, 10));
                result.push(this.encodeValue(operator, value, this.isKeyOperator(operator) ? key : null));
            } else if (modifier === '*') {
                if (Array.isArray(value)) value.filter(this.isDefined).forEach(function(value) {
                    result.push(this.encodeValue(operator, value, this.isKeyOperator(operator) ? key : null));
                }, this);
                else Object.keys(value).forEach(function(k) {
                    if (this.isDefined(value[k])) result.push(this.encodeValue(operator, value[k], k));
                }, this);
            } else {
                var tmp = [];
                if (Array.isArray(value)) value.filter(this.isDefined).forEach(function(value) {
                    tmp.push(this.encodeValue(operator, value));
                }, this);
                else Object.keys(value).forEach(function(k) {
                    if (this.isDefined(value[k])) {
                        tmp.push(this.encodeUnreserved(k));
                        tmp.push(this.encodeValue(operator, value[k].toString()));
                    }
                }, this);
                if (this.isKeyOperator(operator)) result.push(this.encodeUnreserved(key) + '=' + tmp.join(','));
                else if (tmp.length !== 0) result.push(tmp.join(','));
            }
        } else {
            if (operator === ';') {
                if (this.isDefined(value)) result.push(this.encodeUnreserved(key));
            } else if (value === '' && (operator === '&' || operator === '?')) result.push(this.encodeUnreserved(key) + '=');
            else if (value === '') result.push('');
        }
        return result;
    };
    /**
   * @param {string} template
   * @return {function(Object):string}
   */ UrlTemplate.prototype.parse = function(template) {
        var that = this;
        var operators = [
            '+',
            '#',
            '.',
            '/',
            ';',
            '?',
            '&'
        ];
        return {
            expand: function(context) {
                return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function(_, expression, literal) {
                    if (expression) {
                        var operator = null, values = [];
                        if (operators.indexOf(expression.charAt(0)) !== -1) {
                            operator = expression.charAt(0);
                            expression = expression.substr(1);
                        }
                        expression.split(/,/g).forEach(function(variable) {
                            var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
                            values.push.apply(values, that.getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        });
                        if (operator && operator !== '+') {
                            var separator = ',';
                            if (operator === '?') separator = '&';
                            else if (operator !== '#') separator = operator;
                            return (values.length !== 0 ? operator : '') + values.join(separator);
                        } else return values.join(',');
                    } else return that.encodeReserved(literal);
                });
            }
        };
    };
    return new UrlTemplate();
});

});

parcelRegister("aqVTl", function(module, exports) {
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */ var $acb686442d02a48b$export$2e2bcd8739ae039 = [
    // Bitbucket Pipelines domains (is an iframe and require CORS)
    'bitbucket-pipelines.dev.public.atl-paas.net',
    'bitbucket-pipelines.staging.public.atl-paas.net',
    'bitbucket-pipelines.prod.public.atl-paas.net'
];


const $ed42c4b7ef51ed97$export$1f86472c1374185a = 3;
const $ed42c4b7ef51ed97$export$a2d611d5c7be4bb1 = 0.1;
const $ed42c4b7ef51ed97$export$957d605a51548b59 = 2;
const $ed42c4b7ef51ed97$export$80aa83cae6a6c290 = 1000;
async function $ed42c4b7ef51ed97$export$4adbd37839ed7718(response) {
    if (!response.ok) // We use the response body for two reasons:
    // 1. To ensure that we consume the response body, so that it gets reported on in Chrome DevTools
    // 2. It could have some useful information relevant to the error
    throw Error(`${response.status}: ${await response.text()}`);
    return response;
}
async function $ed42c4b7ef51ed97$export$2ba4cde277adb6b1(response) {
    if (!response.ok) await response.text();
    return response;
}
function $ed42c4b7ef51ed97$export$317bcea84a3bea48(input, reqOptions) {
    return $ed42c4b7ef51ed97$var$fetchWithRetry({
        input: input,
        reqOptions: reqOptions,
        numRetries: 0,
        maxRetries: $ed42c4b7ef51ed97$export$1f86472c1374185a,
        waitTimeMs: $ed42c4b7ef51ed97$export$80aa83cae6a6c290,
        backoffFn: $ed42c4b7ef51ed97$export$924aee1254634401
    });
}
function $ed42c4b7ef51ed97$var$fetchWithRetry({ input: input, reqOptions: reqOptions, numRetries: numRetries = 0, maxRetries: maxRetries = 0, waitTimeMs: waitTimeMs = 0, backoffFn: backoffFn = $ed42c4b7ef51ed97$export$924aee1254634401 }) {
    if (numRetries > maxRetries) throw new Error(`Failed to fetch ${input}: Max retries exceeded`);
    const options = {
        ...reqOptions,
        credentials: (0, $acb686442d02a48b$export$2e2bcd8739ae039).includes(location.host) ? 'include' : 'same-origin'
    };
    const retryAttempt = ()=>new Promise((resolve)=>{
            setTimeout(()=>{
                resolve($ed42c4b7ef51ed97$var$fetchWithRetry({
                    input: input,
                    reqOptions: reqOptions,
                    numRetries: numRetries + 1,
                    maxRetries: maxRetries,
                    waitTimeMs: backoffFn(waitTimeMs),
                    backoffFn: backoffFn
                }));
            }, waitTimeMs);
        });
    return fetch(input, options).then((response)=>{
        if (response.status >= 500 && response.status <= 599) return retryAttempt();
        return response;
    }).catch(()=>{
        return retryAttempt();
    });
}
function $ed42c4b7ef51ed97$export$924aee1254634401(waitTimeMs) {
    const nextWaitTime = waitTimeMs * $ed42c4b7ef51ed97$export$957d605a51548b59;
    const jitter = nextWaitTime * $ed42c4b7ef51ed97$export$a2d611d5c7be4bb1 * Math.random();
    return nextWaitTime + jitter;
}
module.exports["errorIfNotOk"] = $ed42c4b7ef51ed97$export$4adbd37839ed7718;
module.exports["pullResponseTextIfNotOk"] = $ed42c4b7ef51ed97$export$2ba4cde277adb6b1;
module.exports["stargateFetch"] = $ed42c4b7ef51ed97$export$317bcea84a3bea48;

});

parcelRegister("4nGsu", function(module, exports) {

var $lzcvT = parcelRequire("lzcvT");

function $fd5afa82043d8fde$export$a77934ac158768dd() {
    return !(0, $lzcvT.isFedRamp)();
}
module.exports["isMessagingEnabled"] = $fd5afa82043d8fde$export$a77934ac158768dd;

});

parcelRegister("ij4CE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $7hXu9 = parcelRequire("7hXu9");


var $86okN = parcelRequire("86okN");

function $7fd39030140cad16$var$useWriteFragmentInteropRelay(args) {
    const { fragmentSpec: fragmentSpec } = args;
    const env = (0, $irOoi.useRelayEnvironment)();
    return (0, $42omo.useCallback)(({ data: data, fragmentId: fragmentId })=>{
        // @ts-expect-error TODO: should be removed once we only accept `GraphQLTaggedNode`
        $7fd39030140cad16$var$writeFragmentShim(env, fragmentSpec, fragmentId, data);
    }, [
        env,
        fragmentSpec
    ]);
}
function $7fd39030140cad16$var$useWriteFragmentInteropApollo(args) {
    const { fragmentSpec: fragmentSpec } = args;
    const client = (0, $7hXu9.useApolloClient)();
    return (0, $42omo.useCallback)(({ data: data, fragmentId: fragmentId })=>{
        client.writeFragment({
            id: fragmentId,
            fragment: (0, $86okN.toDocumentNode)(fragmentSpec),
            data: data
        });
    }, [
        client,
        fragmentSpec
    ]);
}
function $7fd39030140cad16$export$b3a20d310cac24ba(args) {
    return $7fd39030140cad16$var$useWriteFragmentInteropApollo(args);
}
function $7fd39030140cad16$var$apolloFragmentIdToRelayFragmentId(apolloFragmentId) {
    return apolloFragmentId.replace(/^\$ROOT_QUERY\./, 'client:root:');
}
/**
 * Shim function that mimics Apollo's `writeFragment` using Relay
 */ function $7fd39030140cad16$var$writeFragmentShim(environment, fragment, fragmentId, data) {
    if (!data) return;
    const relayFragmentId = $7fd39030140cad16$var$apolloFragmentIdToRelayFragmentId(fragmentId);
    // Use commitUpdate to write to the store
    environment.commitUpdate((storeProxy)=>{
        const record = storeProxy.get(relayFragmentId);
        if (!record) return;
        // Define a function to write the fields specified in the fragment
        const writeFields = (recordId, fields, writeData)=>{
            const targetRecord = storeProxy.get(recordId);
            if (!targetRecord || !writeData) return;
            for (const field of fields){
                if (field.kind === 'LinkedField') {
                    // For linked fields, we need to handle nested data
                    const linkedData = writeData[field.name];
                    if (linkedData) {
                        const linkedRecord = targetRecord.getLinkedRecord(field.name);
                        if (linkedRecord) writeFields(linkedRecord.getDataID(), field.selections, linkedData);
                    }
                } else if (field.kind === 'ScalarField') {
                    if (writeData[field.name] !== undefined) targetRecord.setValue(writeData[field.name], field.name);
                } else throw new Error('Unsupported field');
            }
        };
        const writerFragment = fragment;
        const topLevelFields = writerFragment?.selections;
        if (topLevelFields) writeFields(relayFragmentId, topLevelFields ?? [], data);
    });
}
module.exports["useWriteFragmentInterop"] = $7fd39030140cad16$export$b3a20d310cac24ba;

});

parcelRegister("d5ap9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $7hXu9 = parcelRequire("7hXu9");


var $kDuN4 = parcelRequire("kDuN4");


var $04e9M = parcelRequire("04e9M");


var $6mKj3 = parcelRequire("6mKj3");


var $fFmJj = parcelRequire("fFmJj");


var $jiJCD = parcelRequire("jiJCD");





var $iV5Ic = parcelRequire("iV5Ic");


var $1iSzD = parcelRequire("1iSzD");


var $iSamx = parcelRequire("iSamx");

const $1630c56c1c8a2ea8$export$a49142cbc66558d = (payload, embeddedConfluenceSource)=>{
    const data = payload.data || payload; //this is needed because some events have their attributes property wrapped within data: { ... } , and some don't.
    data.attributes = {
        ...data.attributes,
        embeddedConfluenceSource: embeddedConfluenceSource
    };
    return payload;
};


const $0afc595234550cbb$export$b196590577ebe6b8 = ({ channel: channel, children: children })=>{
    let { embeddedConfluenceSource: embeddedConfluenceSource } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    if (!embeddedConfluenceSource && (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)()) embeddedConfluenceSource = (0, $jiJCD.parse)(location.search, true).query.embeddedConfluenceSource?.toString();
    if (embeddedConfluenceSource) {
        const embeddedConfluenceSourceEventUpdater = (payload)=>(0, $1630c56c1c8a2ea8$export$a49142cbc66558d)(payload, embeddedConfluenceSource);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iSamx.AddAttributesWrapper), {
            eventUpdater: embeddedConfluenceSourceEventUpdater,
            channel: channel || '*'
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};


const $4d278d9889e67ce9$var$eventTypes = [
    'sendOperationalEvent',
    'sendPageEvent',
    'sendTrackEvent',
    'sendUIEvent',
    'sendScreenEvent'
];
// Checks if content attributes should be added to this analytics events
// If so, also retrieves the contentId used to fetch those attributes
// out of the GraphQL cache.
// Currently, the only attributes added are `type` and `subType`
//
// Returns [shouldAddContentAttributes: boolean, contentId: string];
const $4d278d9889e67ce9$var$getContentAttributesInfo = (event)=>{
    if (event?.payload?.type === 'sendOperationalEvent') // Exclude operational events
    return [
        false,
        ''
    ];
    else if (event?.payload?.data?.attributes?.contentId) // Use the contentId attribute if it exists
    return [
        true,
        event?.payload?.data?.attributes?.contentId
    ];
    else if (event?.payload?.data?.objectType === 'page') // Otherwise, use the objectId if the object is a page
    return [
        true,
        event?.payload?.data?.objectId
    ];
    else // Otherwise, exclude this event because we don't have a contentId for it
    return [
        false,
        ''
    ];
};
const $4d278d9889e67ce9$export$1e92460c034514a4 = ({ children: children })=>{
    const apolloClient = (0, $7hXu9.useApolloClient)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $eSUdr.default)`fragment AnalyticsContentSubType on Content{subType}`
    });
    const convertToAnalyticsAttribute = (value)=>{
        if (value === null) // A subType of `null` is used for non-live pages
        return false;
        else if (value === 'live') return true;
        else // Otherwise, subType was not found or the page had a subType other than 'live'.
        return undefined;
    };
    const sendAnalyticEvents = (0, $42omo.useCallback)((event)=>{
        if (!event || !event.payload) throw new Error('Analytics Web Client Payload is required');
        else if (!$4d278d9889e67ce9$var$eventTypes.includes(event.payload.type)) throw new Error(`Recieved Unknown Type for Analytics Web Client: ${event.payload.type}`);
        let contentAttributes = {};
        const [shouldAddContentAttributes, contentId] = $4d278d9889e67ce9$var$getContentAttributesInfo(event);
        if (apolloClient && shouldAddContentAttributes) {
            let data;
            if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) try {
                data = readFragmentInterop({
                    id: `Content:${contentId}`
                });
            } catch (error) {}
            else try {
                // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
                data = apolloClient.readQuery({
                    query: (0, $eSUdr.default)`query analyticsListenerextractContentAttributesAutoAttributesSubTypeQuery($contentId:ID!){singleContent(id:$contentId){subType}}`,
                    variables: {
                        contentId: contentId
                    }
                });
            } catch  {}
            contentAttributes = {
                isLivePage: convertToAnalyticsAttribute(data?.subType || data?.singleContent?.subType)
            };
        }
        (0, $04e9M.getAnalyticsWebClient)().then((analyticWebClientResponse)=>{
            const newData = {
                ...event.payload.data,
                attributes: {
                    ...contentAttributes,
                    ...event.payload.data?.attributes
                }
            };
            analyticWebClientResponse[event.payload.type](newData);
        });
    }, [
        apolloClient,
        readFragmentInterop
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: sendAnalyticEvents
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0afc595234550cbb$export$b196590577ebe6b8), null, children));
};
module.exports["ConfluenceAnalyticsListener"] = $4d278d9889e67ce9$export$1e92460c034514a4;

});

parcelRegister("fFmJj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $7hXu9 = parcelRequire("7hXu9");


var $86okN = parcelRequire("86okN");

function $f1600d1095d0e467$var$useReadFragmentInteropRelay(params) {
    const { fragmentSpec: fragmentSpec, id: defaultId } = params;
    const env = (0, $irOoi.useRelayEnvironment)();
    return (0, $42omo.useCallback)((callbackParams)=>{
        const id = callbackParams?.id ?? defaultId;
        if (!id) return null;
        // @ts-expect-error TODO: should be removed once we only accept `GraphQLTaggedNode`
        return $f1600d1095d0e467$var$readFragmentShim(env, fragmentSpec, id);
    }, [
        env,
        fragmentSpec,
        defaultId
    ]);
}
function $f1600d1095d0e467$var$useReadFragmentInteropApollo(params) {
    const { fragmentSpec: fragment, id: defaultId } = params;
    const client = (0, $7hXu9.useApolloClient)();
    return (0, $42omo.useCallback)((callbackParams)=>{
        const id = callbackParams?.id ?? defaultId;
        if (!id) return null;
        const data = client.readFragment({
            id: id,
            fragment: (0, $86okN.toDocumentNode)(fragment)
        });
        return data;
    }, [
        client,
        fragment,
        defaultId
    ]);
}
function $f1600d1095d0e467$export$e7f64d3242b58da3(params) {
    return $f1600d1095d0e467$var$useReadFragmentInteropApollo(params);
}
function $f1600d1095d0e467$var$apolloFragmentIdToRelayFragmentId(apolloFragmentId) {
    return apolloFragmentId.replace(/^\$ROOT_QUERY\./, 'client:root:');
}
/**
 * Shim function that mimics Apollo's `readFragment` using Relay
 */ function $f1600d1095d0e467$var$readFragmentShim(environment, fragment, fragmentId) {
    // Get the store from the environment
    const store = environment.getStore();
    // Get the source from the store
    const source = store.getSource();
    // Get the record using the fragmentId
    const rootRecord = source.get($f1600d1095d0e467$var$apolloFragmentIdToRelayFragmentId(fragmentId));
    if (!rootRecord) return null;
    // Define a function to read the fields specified in the fragment
    const readFields = (recordId, fields)=>{
        const record = source.get(recordId);
        if (!record) return null;
        const data = {};
        for (const field of fields){
            if (field.kind === 'LinkedField') {
                // For linked fields, we need to get the reference and recursively read
                const linkedRecordRef = record[field.name];
                if (linkedRecordRef && typeof linkedRecordRef === 'object' && '__ref' in linkedRecordRef) {
                    const linkedRecordId = linkedRecordRef.__ref;
                    data[field.name] = readFields(linkedRecordId, field.selections);
                } else data[field.name] = null;
            } else if (field.kind === 'ScalarField') data[field.name] = record[field.name];
            else throw new Error('Unsupported field');
        }
        return data;
    };
    const readerFragment = fragment;
    const topLevelFields = readerFragment?.selections;
    return readFields($f1600d1095d0e467$var$apolloFragmentIdToRelayFragmentId(fragmentId), topLevelFields ?? []);
}
module.exports["useReadFragmentInterop"] = $f1600d1095d0e467$export$e7f64d3242b58da3;

});

parcelRegister("iV5Ic", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gzdsP = parcelRequire("gzdsP");

function $3365988b1c4c1737$export$df02d2df0bc6f323() {
    const unsubscribeRef = (0, $42omo.useRef)();
    const [embeddedConfluenceReactProps, setEmbeddedConfluenceReactProps] = (0, $42omo.useState)(null);
    if (!unsubscribeRef.current) {
        const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
        if (observableObject) {
            const updateProps = ()=>{
                setEmbeddedConfluenceReactProps(observableObject.object);
            };
            unsubscribeRef.current = observableObject.subscribe(updateProps);
            updateProps();
        }
    }
    (0, $42omo.useEffect)(()=>unsubscribeRef.current, []);
    return embeddedConfluenceReactProps;
}
module.exports["useReactProps_DO_NOT_USE"] = $3365988b1c4c1737$export$df02d2df0bc6f323;

});

parcelRegister("gzdsP", function(module, exports) {

var $3XKuW = parcelRequire("3XKuW");

const $5a1450dca323cc16$export$375e0252045b3278 = ()=>window.frameElement?.[0, $3XKuW.EP_REACT_PROPS_OBSERVABLE_OBJECT] || // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
    window[0, $3XKuW.EP_REACT_PROPS_OBSERVABLE_OBJECT];
module.exports["getIframeObservable_DO_NOT_USE"] = $5a1450dca323cc16$export$375e0252045b3278;

});

parcelRegister("iSamx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");

const $5e8dbc9ca8500f23$export$709fad0211a80c64 = ({ eventUpdater: eventUpdater, channel: channel, children: children })=>{
    const onEvent = (event)=>{
        event.update(eventUpdater);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: onEvent,
        channel: channel
    }, children);
};
module.exports["AddAttributesWrapper"] = $5e8dbc9ca8500f23$export$709fad0211a80c64;

});

parcelRegister("cryCi", function(module, exports) {
$parcel$export(module.exports, "Consumer", () => $441587f534f59cf5$export$b3bffd4bb7da6b8f);

var $42omo = parcelRequire("42omo");





var $6auOX = parcelRequire("6auOX");

var $fw9LG = parcelRequire("fw9LG");


var $bQm3c = parcelRequire("bQm3c");


var $7W8i8 = parcelRequire("7W8i8");

const $af74349712b9bfd2$export$c47913ca32a5c6f7 = (name)=>{
    if (typeof globalThis.document !== 'undefined') {
        const node = document.querySelector(`meta[name="${name}"]`);
        const metaValue = node?.getAttribute('content');
        return metaValue ?? null;
    }
    return null;
};



var $jOtRZ = parcelRequire("jOtRZ");

let $9ce9b7b31c3598e6$var$choreographerServices;
const $9ce9b7b31c3598e6$var$ajsEnvironment = (0, $af74349712b9bfd2$export$c47913ca32a5c6f7)('ajs-environment');
const $9ce9b7b31c3598e6$var$logger = (0, $7W8i8.getLogger)('choreographer-services');
if (globalThis.window, $9ce9b7b31c3598e6$var$ajsEnvironment) {
    const environment = (0, $jOtRZ.determineAnalyticsEnvironment)($9ce9b7b31c3598e6$var$ajsEnvironment);
    $9ce9b7b31c3598e6$var$choreographerServices = (0, $6auOX.choreographerFactory)((0, $fw9LG.ProductIds).CONFLUENCE, environment);
}
const $9ce9b7b31c3598e6$export$fd6146171fa6f88f = ()=>{
    const analyticsEnv = (0, $jOtRZ.useAnalyticsEnvironment)();
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const choreographerServiceInstance = (0, $42omo.useMemo)(()=>{
        if (!$9ce9b7b31c3598e6$var$choreographerServices && analyticsEnv) $9ce9b7b31c3598e6$var$choreographerServices = (0, $6auOX.choreographerFactory)((0, $fw9LG.ProductIds).CONFLUENCE, analyticsEnv);
        // Return module level choreographer services
        return $9ce9b7b31c3598e6$var$choreographerServices;
    }, [
        analyticsEnv
    ]);
    const { plugin: plugin } = choreographerServiceInstance ?? {};
    (0, $42omo.useEffect)(()=>{
        if (plugin) $9ce9b7b31c3598e6$var$setupChoreographerAnalyticsClient(plugin, cloudId, userId);
        /**
		 * Cleanup function in case we unmount this component to remount another one.
		 */ return ()=>{
            if (plugin) plugin.destroy();
        };
    }, [
        plugin,
        cloudId,
        userId
    ]);
    return choreographerServiceInstance;
};
function $9ce9b7b31c3598e6$var$setupChoreographerAnalyticsClient(choreographerPlugin, tenantId, atlassianAccountId) {
    const analyticsClient = choreographerPlugin?.getAnalyticsClient();
    try {
        if (analyticsClient) {
            if (tenantId) analyticsClient?.setTenantInfo('cloudId', tenantId);
            if (atlassianAccountId) analyticsClient?.setUserInfo('atlassianAccount', atlassianAccountId);
        }
    } catch (error) {
        $9ce9b7b31c3598e6$var$logger.error`Error setting up choreographer analytics client - ${error}`;
    }
}


const $441587f534f59cf5$export$841858b892ce1f4c = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const { Consumer: $441587f534f59cf5$export$b3bffd4bb7da6b8f, Provider: $441587f534f59cf5$var$Provider } = $441587f534f59cf5$export$841858b892ce1f4c;
const $441587f534f59cf5$export$2a2b82ec45ab1f55 = ({ children: children })=>{
    const choreographerFactoryAssets = (0, $9ce9b7b31c3598e6$export$fd6146171fa6f88f)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($441587f534f59cf5$var$Provider, {
        value: choreographerFactoryAssets
    }, children);
};
module.exports["Context"] = $441587f534f59cf5$export$841858b892ce1f4c;
module.exports["Provider"] = $441587f534f59cf5$export$2a2b82ec45ab1f55;

});

parcelRegister("97W74", function(module, exports) {
$parcel$export(module.exports, "EngagementProvider", () => (parcelRequire("iSprN")).EngagementProvider);

var $iSprN = parcelRequire("iSprN");


});

parcelRegister("20sPA", function(module, exports) {
var $152ad38b374e0a8b$exports = {};

var $ehlgT = parcelRequire("ehlgT");

/** Error message constants. */ var $152ad38b374e0a8b$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $152ad38b374e0a8b$var$before(n, func) {
    var result;
    if (typeof func != 'function') throw new TypeError($152ad38b374e0a8b$var$FUNC_ERROR_TEXT);
    n = $ehlgT(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
$152ad38b374e0a8b$exports = $152ad38b374e0a8b$var$before;


/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $1761f21dbbce9ee1$var$once(func) {
    return $152ad38b374e0a8b$exports(2, func);
}
module.exports = $1761f21dbbce9ee1$var$once;

});

parcelRegister("eXODy", function(module, exports) {

const $f98b0c3bb9dfd9f4$export$fd639506b0932339 = async ()=>{
    return (await (parcelRequire("2Expo"))).nativeEditorComponentsPreloader();
};

const $f98b0c3bb9dfd9f4$export$bfdd6c06749e6ec3 = async ()=>{
    return (await (parcelRequire("kIIxl"))).tinyEditorComponentsPreloader();
};

const $f98b0c3bb9dfd9f4$export$6545754a45dc5973 = async ()=>{
    return (await (parcelRequire("43fZr"))).getEditorPreloader;
};
module.exports["nativeEditorComponentsPreloader"] = $f98b0c3bb9dfd9f4$export$fd639506b0932339;
module.exports["tinyEditorComponentsPreloader"] = $f98b0c3bb9dfd9f4$export$bfdd6c06749e6ec3;
module.exports["getEditorPreloader"] = $f98b0c3bb9dfd9f4$export$6545754a45dc5973;

});

parcelRegister("2Expo", function(module, exports) {

let $1ee93b712c0f75a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1ee93b712c0f75a7$var$load("6MNAi"),
    $1ee93b712c0f75a7$var$load("425pi"),
    $1ee93b712c0f75a7$var$load("bKvoJ")
]).then(()=>parcelRequire('aFK6m'));

});

parcelRegister("kIIxl", function(module, exports) {

let $f15a76c453e52c74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f15a76c453e52c74$var$load("kNZr8").then(()=>parcelRequire('847Yj'));

});

parcelRegister("43fZr", function(module, exports) {

let $2f33d884250e2d17$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f33d884250e2d17$var$load("aDgIB").then(()=>parcelRequire('3K1px'));

});

parcelRegister("7QM6o", function(module, exports) {

var $6uUjl = parcelRequire("6uUjl");

const $664c239122afca31$export$86d46ef78621f34c = (spaceKey)=>{
    const { spaceId: spaceId } = (0, $6uUjl.useSpaceIdentifiers)(spaceKey);
    return spaceId;
};
module.exports["useSpaceId"] = $664c239122afca31$export$86d46ef78621f34c;

});

parcelRegister("6uUjl", function(module, exports) {

var $xQxzY = parcelRequire("xQxzY");


var $ep3mz = parcelRequire("ep3mz");


var $jtuBN = parcelRequire("jtuBN");


var $9wGTI = parcelRequire("9wGTI");


var $eSUdr = parcelRequire("eSUdr");

const $a35e2eb493cc5775$export$c47f6453dc84ce2f = (0, $eSUdr.default)`query SpaceIdentifiersQuery($spaceKey:String){space(key:$spaceKey){id key}}`;


const $b3fa348c6c38e0de$export$a63a3cfa26b2bab3 = (spaceKey)=>{
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    // The given space key may be an alias, not the actual key.
    spaceKey = spaceKey ?? pageContextSpaceKey;
    if ((0, $9wGTI.fg)('stop_watching_space_level_query')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: data } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
        (0, $a35e2eb493cc5775$export$c47f6453dc84ce2f), {
            variables: {
                spaceKey: spaceKey
            },
            skip: !spaceKey
        });
        return {
            spaceId: data?.space?.id || undefined,
            // The returned space key is the actual key, not an alias.
            spaceKey: data?.space?.key || undefined
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: data } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $a35e2eb493cc5775$export$c47f6453dc84ce2f), {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey
    });
    return {
        spaceId: data?.space?.id || undefined,
        // The returned space key is the actual key, not an alias.
        spaceKey: data?.space?.key || undefined
    };
};
module.exports["useSpaceIdentifiers"] = $b3fa348c6c38e0de$export$a63a3cfa26b2bab3;

});

parcelRegister("gTyTP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $1ytiN = parcelRequire("1ytiN");

// TAP trait name and values
const $994775cb6427bea0$var$LIVE_PAGES_BETA_TRAIT_NAME = 'confluence_live_pages_beta';
const $994775cb6427bea0$var$LIVE_PAGES_BETA_DEFAULT_ON_VALUE = 'beta-default-on';
const $994775cb6427bea0$var$LIVE_PAGES_BETA_DEFAULT_OFF_VALUE = 'beta-default-off';
const $994775cb6427bea0$export$1e0344ddce81a796 = 'confluence_modernize';
const $994775cb6427bea0$var$LIVE_DOC_GA_EXP_TEST_GROUP_VALUE = 'exp-test';
const $994775cb6427bea0$export$4651811ac3a91813 = 'exp-control';
var $994775cb6427bea0$export$32d761c7795593f9 = /*#__PURE__*/ function(LivePageReleasePhase) {
    LivePageReleasePhase["NOT_ENABLED"] = "not_enabled";
    LivePageReleasePhase["OPEN_BETA_DEFAULT_ON"] = "open_beta_default_on";
    LivePageReleasePhase["OPEN_BETA_DEFAULT_OFF"] = "open_beta_default_off";
    LivePageReleasePhase["MODERNIZATION_GA_EXP_TEST"] = "modernization_ga_exp_test";
    LivePageReleasePhase["MODERNIZATION_GA_EXP_CONTROL"] = "modernization_ga_exp_control";
    return LivePageReleasePhase;
}({});
const $994775cb6427bea0$var$RELEASE_PHASES_WITH_FEATURE_ENABLED = [
    "open_beta_default_on",
    "open_beta_default_off",
    "modernization_ga_exp_test"
];
const $994775cb6427bea0$var$useLivePageReleasePhase = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { experimentFeatures: experimentFeatures, loading: isSPAViewContextLoading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    (0, $42omo.useEffect)(()=>{
        if (isSPAViewContextLoading) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'traitValueLoading',
                actionSubject: 'useLivePageReleasePhase',
                source: 'useLivePageReleasePhase'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isSPAViewContextLoading
    ]);
    let openBetaTraitValue;
    let modernizationGaTraitValue;
    try {
        const parsedExperimentFeatures = JSON.parse(experimentFeatures);
        if (typeof parsedExperimentFeatures === 'object') ({ [$994775cb6427bea0$var$LIVE_PAGES_BETA_TRAIT_NAME]: openBetaTraitValue, [$994775cb6427bea0$export$1e0344ddce81a796]: modernizationGaTraitValue } = parsedExperimentFeatures);
    } catch (e) {
        openBetaTraitValue = null;
        modernizationGaTraitValue = null;
    }
    // Modernization GA release phase
    /**
	 * Tenants are enrolled once they land in confluence.
	 *
	 * Tenants already in open beta or release tracks will not be part of the GA experiment.
	 * All other tenants will be split 50/50 between the test and control groups.
	 *
	 * Only the test group will have the modernization ga experience.
	 */ if (modernizationGaTraitValue === $994775cb6427bea0$var$LIVE_DOC_GA_EXP_TEST_GROUP_VALUE) return "modernization_ga_exp_test";
    else if (modernizationGaTraitValue === $994775cb6427bea0$export$4651811ac3a91813) return "modernization_ga_exp_control";
    // Open Beta release phase
    /**
	 * Open Beta is now closed and users are no longer able to opt in. Open Beta is determine by the TAP trait value.
	 * Any tenant that has opted in at any point will be part of the GA experience. However, they will not be part of the GA experiment.
	 *
	 * https://hello.atlassian.net/wiki/spaces/PCG/pages/4415395121/Live+Pages+Open+Beta+Feature+Gate+Approach
	 */ if (openBetaTraitValue === $994775cb6427bea0$var$LIVE_PAGES_BETA_DEFAULT_ON_VALUE || (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') // we can assume that the tenant has opted in if the gate is true, opt out is not possible at the moment.
    ) return "open_beta_default_on";
    else if (openBetaTraitValue === $994775cb6427bea0$var$LIVE_PAGES_BETA_DEFAULT_OFF_VALUE) return "open_beta_default_off";
    // Default
    return "not_enabled";
};
const $994775cb6427bea0$export$d9b2df506ebad5d5 = ()=>{
    const phase = $994775cb6427bea0$var$useLivePageReleasePhase();
    return {
        isLivePagesFeatureEnabled: $994775cb6427bea0$var$RELEASE_PHASES_WITH_FEATURE_ENABLED.includes(phase),
        livePageReleasePhase: phase
    };
};
module.exports["LIVE_DOC_GA_EXP_TRAIT_NAME"] = $994775cb6427bea0$export$1e0344ddce81a796;
module.exports["LIVE_DOC_GA_EXP_CONTROL_GROUP_VALUE"] = $994775cb6427bea0$export$4651811ac3a91813;
module.exports["useIsLivePagesFeatureEnabled"] = $994775cb6427bea0$export$d9b2df506ebad5d5;

});

parcelRegister("4PPzL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fGzMp = parcelRequire("fGzMp");


var $lbti1 = parcelRequire("lbti1");


var $jmjWc = parcelRequire("jmjWc");


var $eCryJ = parcelRequire("eCryJ");


const $334e323c22f82a8a$export$65db35c377fab04b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8l8Kg",
    name: "ErrorComponent",
    loader: async ()=>(await (parcelRequire("93Gtj"))).ErrorComponent
});
const $334e323c22f82a8a$export$e926676385687eaf = ({ attribution: attribution, attributes: attributes, children: children, modal: modal })=>{
    const renderOnError = (0, $42omo.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($334e323c22f82a8a$export$65db35c377fab04b, {
            ...props,
            modal: modal
        }), [
        modal
    ]);
    const failExperiencesOnError = (0, $42omo.useCallback)((error)=>{
        if (error.name === 'ChunkLoadError') (0, $fGzMp.getExperienceTracker)().abort({
            reason: 'ChunkLoadErrorAbort'
        });
        // the error UI rendered by this component is scary enough for the user
        // to consider all experiences as failures (we prompt the user to contact support and stuff).
        // Session expiration check that you see here isn't excessive, as it is only
        // supposed to be temporary (while we are in the process of transitioning to better error
        // handling via ErrorDisplay components and the like).
        // Once that migration is complete, this failure will be __unconditional__.
        if (!(0, $lbti1.containsSessionExpiredError)(error)) (0, $fGzMp.getExperienceTracker)().fail({
            error: error,
            attributes: {
                ...attributes,
                errorAttribution: attribution
            }
        });
    }, [
        attributes,
        attribution
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: attribution,
        renderOnError: renderOnError,
        onError: failExperiencesOnError
    }, children);
};
module.exports["ErrorComponent"] = $334e323c22f82a8a$export$65db35c377fab04b;
module.exports["ErrorBoundary"] = $334e323c22f82a8a$export$e926676385687eaf;

});

parcelRegister("93Gtj", function(module, exports) {

let $698556e67d11bf9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $698556e67d11bf9b$var$load("6MNAi"),
    $698556e67d11bf9b$var$load("425pi"),
    $698556e67d11bf9b$var$load("6wr18"),
    $698556e67d11bf9b$var$load("Wowvf"),
    $698556e67d11bf9b$var$load("37ldp"),
    $698556e67d11bf9b$var$load("ffEVr"),
    $698556e67d11bf9b$var$load("hhss7"),
    $698556e67d11bf9b$var$load("i5EJc")
]).then(()=>parcelRequire('fBcAl'));

});

parcelRegister("hl1Kw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $FOT9i = parcelRequire("FOT9i");

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");

const $cbda5d49866ab516$var$parseAnalyticsFromQueryParams = (additionalAnalyticsToParse)=>{
    const formattedEvents = {};
    if (typeof additionalAnalyticsToParse !== 'string') return formattedEvents;
    const events = additionalAnalyticsToParse?.split('____');
    events.forEach((event)=>{
        const formattedEvent = event?.split('---', 2);
        const hasProperlyFormattedEvent = formattedEvent.length === 2;
        if (hasProperlyFormattedEvent) formattedEvents[formattedEvent[0]] = formattedEvent[1];
    });
    return formattedEvents;
};
const $cbda5d49866ab516$var$actions = {
    setSearchSessionId: (searchSessionId)=>({ setState: setState })=>{
            setState({
                searchSessionId: searchSessionId
            });
        },
    setAdditionalAnalytics: (additionalAnalyticsToParse)=>({ setState: setState })=>{
            const parsedAnalytics = $cbda5d49866ab516$var$parseAnalyticsFromQueryParams(additionalAnalyticsToParse);
            setState({
                additionalAnalytics: parsedAnalytics
            });
        }
};
const $cbda5d49866ab516$var$SearchSessionStore = (0, $1P1Tu.createStore)({
    initialState: {
        searchSessionId: undefined,
        additionalAnalytics: {}
    },
    actions: $cbda5d49866ab516$var$actions,
    name: 'SearchSessionStore'
});
const $cbda5d49866ab516$export$e1171f5486fb75fe = (0, $FOT9i.createContainer)($cbda5d49866ab516$var$SearchSessionStore, {
    onInit: ()=>({ setState: setState }, { searchSessionId: searchSessionId, additionalAnalyticsToParse: additionalAnalyticsToParse })=>{
            const parsedAnalytics = $cbda5d49866ab516$var$parseAnalyticsFromQueryParams(additionalAnalyticsToParse);
            setState({
                searchSessionId: searchSessionId,
                additionalAnalytics: parsedAnalytics
            });
        },
    onUpdate: ()=>({ setState: setState }, { searchSessionId: searchSessionId, additionalAnalyticsToParse: additionalAnalyticsToParse })=>{
            const parsedAnalytics = $cbda5d49866ab516$var$parseAnalyticsFromQueryParams(additionalAnalyticsToParse);
            setState({
                searchSessionId: searchSessionId,
                additionalAnalytics: parsedAnalytics
            });
        }
});
const $cbda5d49866ab516$export$e1e7a4797df1a656 = (0, $9zUhf.createHook)($cbda5d49866ab516$var$SearchSessionStore, {
    selector: (state)=>({
            searchSessionId: state.searchSessionId,
            additionalAnalytics: state.additionalAnalytics
        })
});
const $cbda5d49866ab516$export$eaddae88f92f0971 = (0, $j1v0l.createSubscriber)($cbda5d49866ab516$var$SearchSessionStore);
function $cbda5d49866ab516$export$fab1485137890991(WrappedComponent) {
    const SearchSessionComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cbda5d49866ab516$export$eaddae88f92f0971, null, (searchSessionState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                ...props,
                searchSessionState: searchSessionState
            }));
    SearchSessionComponent.displayName = `withSearchSession(${WrappedComponent.displayName || WrappedComponent.name})`;
    return SearchSessionComponent;
}
module.exports["SearchSessionStateContainer"] = $cbda5d49866ab516$export$e1171f5486fb75fe;
module.exports["useSearchSessionId"] = $cbda5d49866ab516$export$e1e7a4797df1a656;
module.exports["withSearchSession"] = $cbda5d49866ab516$export$fab1485137890991;

});

parcelRegister("jLw6A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $1uFM6 = parcelRequire("1uFM6");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $3joiD = parcelRequire("3joiD");


var $hL5Va = parcelRequire("hL5Va");


var $ckmNl = parcelRequire("ckmNl");


var $gYXuI = parcelRequire("gYXuI");

const $6893a43d748c1b7d$var$defaultContext = {
    loading: false,
    refetch: ()=>{}
};
const $6893a43d748c1b7d$export$e29354c764b84d73 = /*#__PURE__*/ (0, $42omo.createContext)($6893a43d748c1b7d$var$defaultContext);
const $6893a43d748c1b7d$export$6ad0c1d41c4e3f99 = $6893a43d748c1b7d$export$e29354c764b84d73.Consumer;
function $6893a43d748c1b7d$export$90d20bb1366d586(props) {
    const contentId = (0, $ckmNl.useContentId)(props.contentId);
    const { edition: edition } = (0, $bQm3c.useSessionData)() || {};
    const includeAncestors = (0, $euL71.ConfluenceEdition).FREE === edition;
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $xQxzY.useQuery)(...(0, $3joiD.getQueryParamsAndSetFetchPolicyForNetworkOnlyQuery)({
        query: (0, $hL5Va.PageRestrictionsQuery),
        variables: {
            contentId: contentId?.toString(),
            status: (0, $gYXuI.ALLOWED_CONTENT_STATUSES),
            includeAncestors: includeAncestors
        },
        skip: !contentId || typeof contentId === 'symbol'
    }));
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: 'backbone'
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const contextValue = (0, $42omo.useMemo)(()=>contentId ? {
            loading: loading,
            error: error,
            restrictions: $6893a43d748c1b7d$var$transformData(data),
            refetch: refetch
        } : $6893a43d748c1b7d$var$defaultContext, [
        loading,
        error,
        data,
        refetch,
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6893a43d748c1b7d$export$e29354c764b84d73.Provider, {
        value: contextValue
    }, props.children);
}
const $6893a43d748c1b7d$var$transformData = (data)=>{
    const content = data?.singleContent;
    if (content) return {
        hasRestrictions: content.hasRestrictions,
        hasViewRestrictions: content.hasViewRestrictions,
        hasInheritedRestrictions: content.hasInheritedRestrictions,
        ancestors: content.ancestors?.map((a)=>({
                id: a?.id || null,
                title: a?.title || null,
                hasRestrictions: Boolean(a?.hasRestrictions),
                links: {
                    webui: a?.links?.webui || null
                }
            })) || []
    };
};
const $6893a43d748c1b7d$export$636524bec905cfd7 = ()=>(0, $42omo.useContext)($6893a43d748c1b7d$export$e29354c764b84d73);
module.exports["PageRestrictionsContextConsumer"] = $6893a43d748c1b7d$export$6ad0c1d41c4e3f99;
module.exports["PageRestrictionsContextProvider"] = $6893a43d748c1b7d$export$90d20bb1366d586;
module.exports["usePageRestrictionsContext"] = $6893a43d748c1b7d$export$636524bec905cfd7;

});

parcelRegister("ckmNl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

function $f8d167b20155dada$export$61f30ffd7f56d537(contentId) {
    // As we have a bunch of places where IsUpsellQueryComponent is used, we need
    // to cover all possible cases how we're getting contentId:
    const [pageStateContentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    // 1) Legacy create page link - *directly passed as a prop*
    //    /wiki/spaces/~533571401/pages/create?fromPageId=55410689
    if (contentId) return contentId;
    // 2) New editor - *get contentID from RoutesContext*
    //    /wiki/spaces/{SPACE}/pages/{CONTENTID}
    //    /wiki/spaces/~351876773/pages/edit-v2/{CONTENTID}?draftShareId=7539fbb2-5f68-4982-8571-36bb8ef89c06
    if (pageStateContentId) return pageStateContentId;
    // 3) Old Editor creating new page - *get contentId as draftId from query*
    //    /wiki/spaces/~351876773/pages/create?draftId={DRAFTID}&draftShareId=ab6a566d-2ecd-4c32-a5ff-f8c13a36f713&
    return (0, $c3Qwv.getSingleParam)(getQueryParams(), 'draftId');
}
module.exports["useContentId"] = $f8d167b20155dada$export$61f30ffd7f56d537;

});

parcelRegister("gz8ZY", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $9hcBu = parcelRequire("9hcBu");


var $deyhs = parcelRequire("deyhs");


var $dKIZZ = parcelRequire("dKIZZ");

const $90a9f787a509158d$export$22793b194a2253b9 = ()=>{
    const currentGAPhase = (0, $deyhs.getNav4GAPhase)();
    const { nav4AdminOptedIn: nav4AdminOptedIn } = (0, $dKIZZ.useGetNav4OptIn)();
    const { nav4OptOut: nav4OptOut } = (0, $9hcBu.useNav4OptOut)();
    if (currentGAPhase === 2) return true;
    if (nav4OptOut) return false;
    return (0, $9wGTI.fg)('confluence_nav_4') || (0, $6mKj3.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false) || // nav4OptOut === false means the user has explicitly opted in for themselves
    currentGAPhase === 1 && (nav4AdminOptedIn || nav4OptOut === false);
};
module.exports["useIsNav4Enabled"] = $90a9f787a509158d$export$22793b194a2253b9;

});

parcelRegister("dKIZZ", function(module, exports) {

var $xQxzY = parcelRequire("xQxzY");


var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $iuIEr = parcelRequire("iuIEr");

const $5926d1d206c7b1bd$export$a638e53225283f3c = ()=>{
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { loading: loading, data: data } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useGetNav4OptInQuery{siteSettings{isNav4OptedIn}}`, {
        skip: !(0, $9wGTI.fg)('confluence_nav4_ga_phase_1')
    });
    const updateNav4AdminOptIn = (0, $42omo.useCallback)(async (isNav4OptedIn)=>{
        (0, $iuIEr.updateNav4AdminOptInCache)(isNav4OptedIn);
    }, []);
    const optInCache = $5926d1d206c7b1bd$var$parseCacheValue((0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).NAV4_ADMIN_OPT_IN_CACHE));
    const optInServer = Boolean(data?.siteSettings?.isNav4OptedIn);
    const nav4AdminOptedIn = (0, $9wGTI.fg)('confluence_nav4_ga_phase_1') && (loading ? optInCache : optInServer);
    (0, $42omo.useEffect)(()=>{
        if (!loading && optInServer !== optInCache) (0, $iuIEr.updateNav4AdminOptInCache)(optInServer);
    }, [
        loading,
        optInCache,
        optInServer
    ]);
    return {
        nav4AdminOptedIn: nav4AdminOptedIn,
        updateNav4AdminOptIn: updateNav4AdminOptIn
    };
};
const $5926d1d206c7b1bd$var$parseCacheValue = (cacheValue)=>{
    if (cacheValue === 'true') return true;
    else if (cacheValue === 'false') return false;
    else return undefined;
};
module.exports["useGetNav4OptIn"] = $5926d1d206c7b1bd$export$a638e53225283f3c;

});

parcelRegister("56QzY", function(module, exports) {
$parcel$export(module.exports, "START", () => (parcelRequire("iu6oZ")).START);
$parcel$export(module.exports, "START_TOUCH", () => (parcelRequire("iu6oZ")).START_TOUCH);
$parcel$export(module.exports, "TOUCH", () => (parcelRequire("iu6oZ")).TOUCH);
$parcel$export(module.exports, "END", () => (parcelRequire("iu6oZ")).END);

var $iu6oZ = parcelRequire("iu6oZ");


});

parcelRegister("308Wd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1KmJq = parcelRequire("1KmJq");


var $irOoi = parcelRequire("irOoi");


var $iF5wn = parcelRequire("iF5wn");


var $86okN = parcelRequire("86okN");

function $6b016d0e76ed02f9$export$425021b579825957(...args) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $1KmJq.useMutation)(...[
        (0, $86okN.toDocumentNode)(args[0]),
        args[1]
    ]);
}
function $6b016d0e76ed02f9$var$useMutationInteropRelay(...[mutation, options]) {
    // TODO: shim accepted but unsupported parameters
    if (options?.optimisticResponse) throw new Error('[Relay migration] optimisticResponse not supported yet');
    const environment = (0, $irOoi.useRelayEnvironment)();
    // Extract variables and memoize them to prevent unnecessary re-renders
    const variables = (0, $iF5wn.useMemoObj)(options?.variables);
    // State to manage the mutation result
    const [data, setData] = (0, $42omo.useState)(undefined);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const onCompletedRef = (0, $42omo.useRef)(options?.onCompleted);
    onCompletedRef.current = options?.onCompleted;
    // Create the mutation function
    const mutate = (0, $42omo.useCallback)((mutationOptions)=>{
        const { optimisticResponse: optimisticResponse } = mutationOptions || {};
        setLoading(true);
        setError(undefined);
        // TODO: shim accepted but unsupported parameters
        if (optimisticResponse) throw new Error('[Relay migration] optimisticResponse not supported yet');
        const operationVariables = mutationOptions?.variables || variables || {};
        return new Promise((resolve, reject)=>{
            (0, $irOoi.commitMutation)(environment, {
                mutation: mutation,
                variables: operationVariables,
                onCompleted: (response, errors)=>{
                    if (errors && errors.length > 0) {
                        const error = new Error(errors[0].message);
                        setError(error);
                        reject(error);
                    } else {
                        setData(response);
                        // Call the user-provided onCompleted callback only on success (to match Apollo behavior)
                        onCompletedRef.current?.(response);
                        resolve({
                            data: response
                        });
                    }
                    setLoading(false);
                },
                onError: (error)=>{
                    setLoading(false);
                    setError(error);
                    reject(error);
                }
            });
        });
    }, [
        environment,
        mutation,
        variables
    ]);
    return [
        mutate,
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
}
module.exports["useMutationInterop"] = $6b016d0e76ed02f9$export$425021b579825957;

});

parcelRegister("iF5wn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");

function $f02c0f1bdff2fe78$var$objToKey(obj) {
    if (typeof obj !== 'object') return obj;
    const sortedObj = Object.keys(obj).sort() // we don't really care about sorting via localeCompare - the goal is to have this sorted the same way, irrespective of the actual comparator
    .reduce((result, key)=>{
        result[key] = $f02c0f1bdff2fe78$var$objToKey(obj[key]);
        return result;
    }, {});
    return JSON.stringify(sortedObj);
}
function $f02c0f1bdff2fe78$export$a84dd6e502828fcd(obj) {
    return $f02c0f1bdff2fe78$var$useMemoObjApollo(obj ?? {});
}
function $f02c0f1bdff2fe78$var$useMemoObjRelay(obj) {
    const [mirroredObj, setMirroredObj] = (0, $42omo.useState)(obj);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(obj, mirroredObj)) return mirroredObj;
    else {
        // Generally, triggering side effects during the render phase is discouraged
        // This mimics Relay approach -- https://github.com/facebook/relay/blob/badd53/packages/react-relay/relay-hooks/useMemoVariables.js
        setMirroredObj(obj);
        return obj;
    }
}
function $f02c0f1bdff2fe78$var$useMemoObjApollo(obj) {
    return (0, $42omo.useMemo)(()=>obj, // eslint-disable-next-line react-hooks/exhaustive-deps -- this is mimicking Apollo's memoization approach; see https://github.com/trojanowski/react-apollo-hooks/blob/682be73/src/useQuery.ts#L119
    [
        obj && $f02c0f1bdff2fe78$var$objToKey(obj)
    ]);
}
module.exports["useMemoObj"] = $f02c0f1bdff2fe78$export$a84dd6e502828fcd;

});

parcelRegister("6VfGD", function(module, exports) {
$parcel$export(module.exports, "ROVO_CHAT_CLIENT_ID", () => (parcelRequire("hHa70")).ROVO_CHAT_CLIENT_ID);
$parcel$export(module.exports, "ROVO_EXTENSION_CLIENT_ID", () => (parcelRequire("4wBlk")).ROVO_EXTENSION_CLIENT_ID);
$parcel$export(module.exports, "ROVO_EXPERIENCE_TRACKING_SENDER_CLIENT_ID", () => (parcelRequire("aesXQ")).ROVO_EXPERIENCE_TRACKING_SENDER_CLIENT_ID);
$parcel$export(module.exports, "HELP_CENTER_FORM_REQUEST_CLIENT_ID", () => (parcelRequire("cBspM")).HELP_CENTER_FORM_REQUEST_CLIENT_ID);
$parcel$export(module.exports, "getConfluenceEditorClientId", () => (parcelRequire("eL1ct")).getConfluenceEditorClientId);
$parcel$export(module.exports, "CONFLUENCE_SPACE_CLIENT_ID", () => (parcelRequire("hAjeC")).CONFLUENCE_SPACE_CLIENT_ID);
$parcel$export(module.exports, "CONFLUENCE_WHITEBOARD_CLIENT_ID", () => (parcelRequire("6nGJw")).CONFLUENCE_WHITEBOARD_CLIENT_ID);
$parcel$export(module.exports, "getConfluenceWhiteboardClientId", () => (parcelRequire("6nGJw")).getConfluenceWhiteboardClientId);
$parcel$export(module.exports, "getConfluenceDatabaseClientId", () => (parcelRequire("fgOJ7")).getConfluenceDatabaseClientId);
$parcel$export(module.exports, "isRovoBroadcastConfirmedActions", () => (parcelRequire("dOEWJ")).isRovoBroadcastConfirmedActions);
$parcel$export(module.exports, "ROVO_INLINE_INPUT_BOX_CLIENT_ID", () => (parcelRequire("4a3y9")).ROVO_INLINE_INPUT_BOX_CLIENT_ID);
$parcel$export(module.exports, "SMART_CREATE_MODAL_CLIENT_ID", () => (parcelRequire("dGRQv")).SMART_CREATE_MODAL_CLIENT_ID);
$parcel$export(module.exports, "JIRA_SMART_CREATE_TABLE_CLIENT_ID", () => (parcelRequire("eX3ET")).JIRA_SMART_CREATE_TABLE_CLIENT_ID);
$parcel$export(module.exports, "ConfluencePageCreateCommand", () => (parcelRequire("4PV5A")).ConfluencePageCreateCommand);
$parcel$export(module.exports, "ConfluenceUpdatePageCommand", () => (parcelRequire("a1lfc")).ConfluenceUpdatePageCommand);
$parcel$export(module.exports, "ConfluenceWhiteboardCreateCommand", () => (parcelRequire("2VpjI")).ConfluenceWhiteboardCreateCommand);
$parcel$export(module.exports, "ConfluenceWhiteboardUpdateCommand", () => (parcelRequire("wLBYY")).ConfluenceWhiteboardUpdateCommand);
$parcel$export(module.exports, "ConfluenceDeepResearchPageCreateCommand", () => (parcelRequire("6PlIk")).ConfluenceDeepResearchPageCreateCommand);
$parcel$export(module.exports, "ConfluenceWhiteboardBrainstormingCommand", () => (parcelRequire("aAJDc")).ConfluenceWhiteboardBrainstormingCommand);
$parcel$export(module.exports, "ConfluenceWhiteboardDiagrammingCommand", () => (parcelRequire("4t4G2")).ConfluenceWhiteboardDiagrammingCommand);
$parcel$export(module.exports, "ConfluenceSpaceCreateCommand", () => (parcelRequire("b9pZB")).ConfluenceSpaceCreateCommand);
$parcel$export(module.exports, "ConfluenceSpaceUpdateCommand", () => (parcelRequire("P9F4k")).ConfluenceSpaceUpdateCommand);
$parcel$export(module.exports, "ReadContentCommand", () => (parcelRequire("2R0Tl")).ReadContentCommand);
$parcel$export(module.exports, "ReadSpaceCommand", () => (parcelRequire("5ghuE")).ReadSpaceCommand);
$parcel$export(module.exports, "PrepareContentForFinalizationCommand", () => (parcelRequire("kA0AR")).PrepareContentForFinalizationCommand);
$parcel$export(module.exports, "InlineInputBoxSendMessageCommand", () => (parcelRequire("aUQK5")).InlineInputBoxSendMessageCommand);
$parcel$export(module.exports, "ConfluenceDatabaseCreateCommand", () => (parcelRequire("ffsQI")).ConfluenceDatabaseCreateCommand);
$parcel$export(module.exports, "ConfluenceDatabaseUpdateCommand", () => (parcelRequire("5sQwW")).ConfluenceDatabaseUpdateCommand);
$parcel$export(module.exports, "InlineInputBoxAbortMessageCommand", () => (parcelRequire("cDDqH")).InlineInputBoxAbortMessageCommand);
$parcel$export(module.exports, "InlineInputBoxFinalResponseMessageCommand", () => (parcelRequire("lfmg5")).InlineInputBoxFinalResponseMessageCommand);
$parcel$export(module.exports, "InlineInputBoxTraceMessageCommand", () => (parcelRequire("22Wz8")).InlineInputBoxTraceMessageCommand);
$parcel$export(module.exports, "InlineInputBoxErrorMessageCommand", () => (parcelRequire("bnT2y")).InlineInputBoxErrorMessageCommand);
$parcel$export(module.exports, "ContentReadyCommand", () => (parcelRequire("eY3DB")).ContentReadyCommand);
$parcel$export(module.exports, "ContentDestroyCommand", () => (parcelRequire("eY3DB")).ContentDestroyCommand);
$parcel$export(module.exports, "ConfluencePageInitCommand", () => (parcelRequire("7UZdX")).ConfluencePageInitCommand);
$parcel$export(module.exports, "ConfluenceWhiteboardInitCommand", () => (parcelRequire("c9IhA")).ConfluenceWhiteboardInitCommand);
$parcel$export(module.exports, "RovoStreamCompletedCommand", () => (parcelRequire("gdg5T")).RovoStreamCompletedCommand);
$parcel$export(module.exports, "RovoStreamErroredCommand", () => (parcelRequire("gdg5T")).RovoStreamErroredCommand);
$parcel$export(module.exports, "RovoStreamAbortedCommand", () => (parcelRequire("gdg5T")).RovoStreamAbortedCommand);
$parcel$export(module.exports, "SmartCreationModalActivatedCommand", () => (parcelRequire("65sE6")).SmartCreationModalActivatedCommand);
$parcel$export(module.exports, "SmartCreationModalDeactivatedCommand", () => (parcelRequire("65sE6")).SmartCreationModalDeactivatedCommand);
$parcel$export(module.exports, "RovoBroadcastConfirmedActionsCommand", () => (parcelRequire("ipJWw")).RovoBroadcastConfirmedActionsCommand);
$parcel$export(module.exports, "ConfluenceSubmitPromptOnPageCreateCommand", () => (parcelRequire("eXBlY")).ConfluenceSubmitPromptOnPageCreateCommand);
$parcel$export(module.exports, "AifcExperienceTrackingCommand", () => (parcelRequire("eeVx7")).AifcExperienceTrackingCommand);
$parcel$export(module.exports, "NotifySuccessCommand", () => (parcelRequire("7lMwT")).NotifySuccessCommand);
$parcel$export(module.exports, "BrowserContextCommand", () => (parcelRequire("5MhyR")).BrowserContextCommand);
$parcel$export(module.exports, "JiraCreateItemsCommand", () => (parcelRequire("lqQ3F")).JiraCreateItemsCommand);

var $hHa70 = parcelRequire("hHa70");


var $4wBlk = parcelRequire("4wBlk");


var $aesXQ = parcelRequire("aesXQ");


var $cBspM = parcelRequire("cBspM");


var $eL1ct = parcelRequire("eL1ct");


var $hAjeC = parcelRequire("hAjeC");


var $6nGJw = parcelRequire("6nGJw");


var $fgOJ7 = parcelRequire("fgOJ7");


var $dOEWJ = parcelRequire("dOEWJ");


var $4a3y9 = parcelRequire("4a3y9");


var $dGRQv = parcelRequire("dGRQv");


var $eX3ET = parcelRequire("eX3ET");


var $4PV5A = parcelRequire("4PV5A");


var $a1lfc = parcelRequire("a1lfc");


var $2VpjI = parcelRequire("2VpjI");


var $wLBYY = parcelRequire("wLBYY");


var $6PlIk = parcelRequire("6PlIk");


var $aAJDc = parcelRequire("aAJDc");


var $4t4G2 = parcelRequire("4t4G2");


var $b9pZB = parcelRequire("b9pZB");


var $P9F4k = parcelRequire("P9F4k");


var $2R0Tl = parcelRequire("2R0Tl");


var $5ghuE = parcelRequire("5ghuE");


var $kA0AR = parcelRequire("kA0AR");


var $aUQK5 = parcelRequire("aUQK5");


var $ffsQI = parcelRequire("ffsQI");


var $5sQwW = parcelRequire("5sQwW");


var $cDDqH = parcelRequire("cDDqH");


var $lfmg5 = parcelRequire("lfmg5");


var $22Wz8 = parcelRequire("22Wz8");


var $bnT2y = parcelRequire("bnT2y");


var $eY3DB = parcelRequire("eY3DB");


var $7UZdX = parcelRequire("7UZdX");


var $c9IhA = parcelRequire("c9IhA");


var $gdg5T = parcelRequire("gdg5T");


var $65sE6 = parcelRequire("65sE6");


var $ipJWw = parcelRequire("ipJWw");


var $eXBlY = parcelRequire("eXBlY");


var $eeVx7 = parcelRequire("eeVx7");


var $7lMwT = parcelRequire("7lMwT");


var $5MhyR = parcelRequire("5MhyR");


var $lqQ3F = parcelRequire("lqQ3F");


});

parcelRegister("fD5Hh", function(module, exports) {
$parcel$export(module.exports, "getBrowserBridgeAPI", () => (parcelRequire("15h8H")).getBrowserBridgeAPI);
$parcel$export(module.exports, "client", () => (parcelRequire("b9NdB")).client);
$parcel$export(module.exports, "createCommand", () => (parcelRequire("3OwWt")).createCommand);
$parcel$export(module.exports, "createBroadcastableCommand", () => (parcelRequire("3OwWt")).createBroadcastableCommand);

var $axhi9 = parcelRequire("axhi9");


var $15h8H = parcelRequire("15h8H");


var $b9NdB = parcelRequire("b9NdB");


var $4Xix7 = parcelRequire("4Xix7");


var $3OwWt = parcelRequire("3OwWt");


var $icEIf = parcelRequire("icEIf");


});

parcelRegister("15h8H", function(module, exports) {

var $icEIf = parcelRequire("icEIf");

/**
 * Utility which computes whether a target window and {@link window.top} conform to the same origin policy.
 *
 * @description If they do, then they share JavaScript execution contexts.
 * @description If they do not, they are the traditional cross-origin `iframe` and host.
 *
 * @param window
 * @returns true if same origin, false if not - if true, then {@link window.top} must be defined.
 */ const $0ff74ebbe03c4790$export$655d79b04044cb4a = (window)=>{
    try {
        return Boolean(window.origin && window.origin === window.top?.origin);
    } catch  {
        return false;
    }
};
const $0ff74ebbe03c4790$export$9be37efcc8d5d23a = (window)=>{
    try {
        return Boolean(window.top && window === window.top);
    } catch  {
        return false;
    }
};
/**
 * Maximum depth to traverse when finding topmost same-origin window.
 * Prevents infinite loops in edge cases while supporting deep nesting.
 */ const $0ff74ebbe03c4790$var$MAX_PARENT_TRAVERSAL_DEPTH = 16;
const $0ff74ebbe03c4790$export$8d6146aae4595d39 = (window)=>{
    let current = window;
    let depth = 0;
    while(depth < $0ff74ebbe03c4790$var$MAX_PARENT_TRAVERSAL_DEPTH)try {
        // If we're at the top, return current
        if (current.parent === current) return current;
        // Try to access parent.origin (will throw SecurityError if cross-origin)
        const parentOrigin = current.parent.origin;
        // Check if parent is same origin
        if (current.origin !== parentOrigin) return current;
        // Parent is same-origin, keep going up
        current = current.parent;
        depth++;
    } catch  {
        // Parent is cross-origin (accessing parent.origin threw)
        return current;
    }
    // Safety: return current window if max depth reached
    return current;
};


const $92b25c9163fab6f7$export$aca538b4585bd0c8 = (bridgeAPI)=>{
    try {
        const topmostSameOriginWindow = (0, $0ff74ebbe03c4790$export$8d6146aae4595d39)(window);
        // do not override if already existing on topmost same-origin window
        if (topmostSameOriginWindow.__rovoContentBridgeAPI__) return;
        topmostSameOriginWindow.__rovoContentBridgeAPI__ = bridgeAPI;
        topmostSameOriginWindow.__rovoBridgeDebuggerStart__ = $92b25c9163fab6f7$var$startDebugger;
    } catch  {
        // bail out if any errors take place (browser quirks on accessing window.top from a cross-origin frame)
        return;
    }
};
const $92b25c9163fab6f7$export$7f2206c1a009e207 = ()=>{
    try {
        const topmostSameOriginWindow = (0, $0ff74ebbe03c4790$export$8d6146aae4595d39)(window);
        return topmostSameOriginWindow.__rovoContentBridgeAPI__ ?? null;
    } catch  {
        return null;
    }
};
const $92b25c9163fab6f7$export$d61f9ff9c1abb253 = ()=>{
    try {
        const topmostSameOriginWindow = (0, $0ff74ebbe03c4790$export$8d6146aae4595d39)(window);
        topmostSameOriginWindow.__rovoContentBridgeAPI__ = undefined;
        // Also clear debug API to prevent memory leaks
        topmostSameOriginWindow.__rovoBridgeDebuggerStart__ = undefined;
    } catch  {
        return;
    }
};

async function $92b25c9163fab6f7$var$startDebugger() {
    try {
        await (parcelRequire("9REl0"));
    } catch (err) {
        console.error('failed to initialise rovo-debug API', err);
    }
}



var $erA1m = parcelRequire("erA1m");


var $2aEKk = parcelRequire("2aEKk");



var $jw6BH = parcelRequire("jw6BH");


const $0825f874617d9b67$export$3888b6e26a971bed = (receiverId)=>{
    const frame = document.querySelector(`[data-rovo-receiver-id="${receiverId}"]`);
    if (!frame || !frame.contentWindow) return undefined;
    return frame.contentWindow;
};
const $0825f874617d9b67$export$b2c3e80b3e42c109 = ()=>{
    if (window.top && !(0, $0ff74ebbe03c4790$export$9be37efcc8d5d23a)(window)) return window.top;
    return undefined;
};
const $0825f874617d9b67$export$6052a3134234724b = (receiverId)=>{
    // Try to find a child iframe first (works at any level)
    const browserTarget = $0825f874617d9b67$export$3888b6e26a971bed(receiverId);
    if (browserTarget) return browserTarget;
    // If not a child, assume parent communication via window.top
    return $0825f874617d9b67$export$b2c3e80b3e42c109();
};


class $0f5022db46319c65$export$7f6b50c45cbf4d90 {
    /**
   * Check to see if this message can be sent to its intended cross-origin target currently.
   *
   * @description Determined by availability of the target window in the DOM.
   * @description If this method does not yield true, the message will be buffered & tried again later.
   *
   * @param message intended RPC message for the receiver
   * @returns true if the transport target is queryable via DOM, otherwise false
   */ canSend(message) {
        // trying to communicate with desktop process
        if ((0, $jw6BH.isWebviewContext)()) return true;
        // passthrough for same-origin communication
        if ((0, $0ff74ebbe03c4790$export$655d79b04044cb4a)(window)) return true;
        // otherwise find the cross-origin target & communicate with it
        const target = this.findTarget(message.params.receiverId);
        return Boolean(target);
    }
    /**
   * Sends a cross-origin message using {@link window.postMessage}.
   * @param message intended RPC message for the receiver
   * @returns void
   */ send(message) {
        // in a webview context and trying to communicate with main process
        if ((0, $jw6BH.isWebviewContext)()) {
            (0, $jw6BH.sendToMainProcess)(message, this.source);
            return;
        }
        const target = this.findTarget(message.params.receiverId);
        if (!target) {
            (0, $erA1m.emitter)().emit({
                type: 'transport-error',
                transportType: this.source,
                direction: 'outbound',
                messageId: message.id,
                error: {
                    message: `Transport target not found for receiver: ${message.params.receiverId}`,
                    code: 'TARGET_NOT_FOUND'
                }
            });
            return;
        }
        const envelope = {
            version: 1,
            source: this.source,
            message: message
        };
        (0, $erA1m.emitter)().emit({
            type: 'transport-message-sent',
            transportType: this.source,
            direction: 'outbound',
            messageId: message.id,
            message: {
                ...envelope
            }
        });
        target.postMessage(envelope, '*');
        return;
    }
    /**
   * Handles incoming events from other bridge API clients.
   * @param handler responds to a given RPC message from a remote client.
   */ onMessage(handler) {
        // do not allow overriding of handlers.
        if (this.handler) return;
        // stable reference so we can destroy it later
        this.handler = (envelope)=>this.handleEnvelope(envelope, handler);
        // listen for messsages from webview context
        if ((0, $jw6BH.isWebviewContext)()) {
            const webviewAPI = (0, $jw6BH.getWebviewAPI)();
            if (!webviewAPI) return;
            this.cleanup = webviewAPI.onMessageFromMain((envelope)=>this.handler?.(envelope));
        } else {
            // Find topmost same-origin window to listen on
            const targetWindow = (0, $0ff74ebbe03c4790$export$8d6146aae4595d39)(window);
            // web-compatible handler
            const handler = (event)=>this.handler?.(event.data);
            targetWindow.addEventListener('message', handler);
            this.cleanup = ()=>targetWindow.removeEventListener('message', handler);
        }
    }
    /**
   * Tears down a specific client by removing its target reference.
   * @description This is important to release iframe / window references fully.
   */ teardown(clientId) {
        this.targets.delete(clientId);
    }
    /**
   * Clears all relevant state.
   */ destroy() {
        // clean up handler
        if (this.cleanup) {
            this.cleanup();
            this.cleanup = undefined;
        }
        // clean up handler reference
        if (this.handler) this.handler = undefined;
        // clear all target references
        this.targets.clear();
        // emit transport destroyed event
        (0, $erA1m.emitter)().emit({
            type: 'transport-destroyed',
            transportType: this.source
        });
    }
    /**
   * Find a target for the given receiver in one of three ways:
   * - Using the existing mapping of known targets ({@link #targets})
   * - Using a DOM query for a cross-origin `iframe`, based on a specific DOM selector contract
   * - Using {@link window.top} if communicating cross-origin from inside of a frame
   *
   * @description If a target is find with one of the latter strategies, it is added to {@link #targets} for subsequent reads.
   *
   * @param receiverId intended target of the current message
   * @returns target if found, otherwise undefined
   */ findTarget(receiverId) {
        // if existing, return
        const target = this.targets.get(receiverId);
        if (target) return target;
        // Find target using resolution strategies
        const browserTarget = (0, $0825f874617d9b67$export$6052a3134234724b)(receiverId);
        if (browserTarget) {
            this.targets.set(receiverId, browserTarget);
            return browserTarget;
        }
        console.warn(`transport target not found for message with intended recipient: ${receiverId}`);
        return undefined;
    }
    /**
   * Handles a transport envelope received from a remote source.
   * @param envelope the transport envelope containing the RPC message
   * @param handler the handler to invoke for the RPC message contained in the envelope
   * @returns void
   */ handleEnvelope(envelope, handler) {
        // always validate first - if invalid, ignore
        if (!(0, $2aEKk.isTransportEnvelope)(envelope)) return;
        // ensure message is not from the current window to itself
        if (envelope.source === this.source) return;
        (0, $erA1m.emitter)().emit({
            type: 'transport-message-received',
            transportType: this.source,
            direction: 'inbound',
            messageId: envelope.message.id,
            transportData: {
                source: envelope.source,
                version: envelope.version,
                message: envelope.message
            }
        });
        handler(envelope.message);
    }
    constructor(source){
        this.source = source;
        /**
     * A mapping of receiver IDs to known targets.
     *
     * Communication will ultimately take place with this target, via the {@link HTMLIFrameElement.contentWindow} property.
     */ this.targets = new Map();
        /**
     * Handles incoming messages received via {@link window.postMessage}.
     */ this.handler = undefined;
        /**
     * Cleanup handler registered for incoming messages
     */ this.cleanup = undefined;
        (0, $erA1m.emitter)().emit({
            type: 'transport-ready',
            transportType: this.source
        });
    }
}


/**
 * A singleton instance to the Rovo bridge API, for bidirectional communication between Rovo Chat and fully immersive content
 * representations. Available in the scope of a single JavaScript context.
 *
 * @description For browser use cases, use {@link getBrowserBridgeAPI}.
 *
 * @description Note: A content frame in this context can refer to either (1) preview of content in a 'staging' view (
 * see @atlassian/smart-creation), or (2) the content actually rendered in an application (e.g. a Confluence page).
 *
 * @description Note: Here, a single JavaScript context can mean any of the following scenarios:
 * - a web application and React component mounted inside of it (e.g. Confluence + Confluence Pages)
 * - a web application and same-origin `<iframe>` mounted inside of it (e.g. Confluence + Confluence Whiteboards / Databases)
 *
 * The following cases represent distinct JavaScript contexts:
 * - a web application and a cross-origin `<iframe>` mounted inside of it (e.g. a third-party Smart Link embed)
 * - the main thread and a worker thread in a web application
 * - the main thread and renderer thread in a desktop application
 *
 * In the case that you have a distinct JavaScript context, ensure you use a transport protocol optimised for your use case.
 * @see {@link getBrowserBridgeAPI} for usage in a browser context.
 */ let $9a9cb5e6f1e958cb$var$bridgeApiInstance = null;
const $9a9cb5e6f1e958cb$export$948c8d79381235ac = ()=>{
    // 1) read singleton instance
    if ($9a9cb5e6f1e958cb$var$bridgeApiInstance) return $9a9cb5e6f1e958cb$var$bridgeApiInstance;
    // 2) read singleton instance from window.top
    const api = (0, $92b25c9163fab6f7$export$7f2206c1a009e207)();
    if (api) return api;
    // 3) create and yield
    $9a9cb5e6f1e958cb$var$bridgeApiInstance = new (0, $icEIf.RovoContentBridgeAPI)(window.origin, new (0, $0f5022db46319c65$export$7f6b50c45cbf4d90)(window.origin));
    (0, $92b25c9163fab6f7$export$aca538b4585bd0c8)($9a9cb5e6f1e958cb$var$bridgeApiInstance);
    return $9a9cb5e6f1e958cb$var$bridgeApiInstance;
};
const $9a9cb5e6f1e958cb$export$ba1db4e691f11d50 = ()=>{
    // Ensure bridge instance is fully destroyed first to clean up all internal state
    if ($9a9cb5e6f1e958cb$var$bridgeApiInstance) $9a9cb5e6f1e958cb$var$bridgeApiInstance.destroy();
    $9a9cb5e6f1e958cb$var$bridgeApiInstance = null;
    (0, $92b25c9163fab6f7$export$d61f9ff9c1abb253)();
};
module.exports["getBrowserBridgeAPI"] = $9a9cb5e6f1e958cb$export$948c8d79381235ac;

});

parcelRegister("icEIf", function(module, exports) {

var $dQl1W = parcelRequire("dQl1W");

class $2c20c32e03f99301$export$c7eb95d2cb93befa {
    /**
   * Yields the current state of a client.
   * @param clientId
   * @returns current state
   */ get(clientId) {
        return this.registry.get(clientId);
    }
    /**
   * Yields whether a given client is known or not to the registry.
   * @param clientId unique identifier for the client
   */ has(clientId) {
        return this.registry.has(clientId);
    }
    /**
   * Adds an entry for a new, pending client. It will be marked as `ready` once a successful handshake transpires.
   *
   * @description Will early exit with a warning if the client being marked as `pending` is already `ready`. This
   * is an anomalous state transition which we do not expect.
   *
   * @param clientId unique identifier for the client
   * @returns void
   */ addPendingClient(clientId) {
        const client = this.get(clientId);
        if (client && client.state === 'ready') {
            console.warn('tried to mark', clientId, 'as `pending` when already in `ready` state');
            return;
        }
        this.registry.set(clientId, {
            id: clientId,
            state: 'pending'
        });
    }
    /**
   * Adds an entry for a local client. It will be immediately ready for direct communication in the same JS context.
   *
   * @description Will early exit with a warning if the client being marked as `local` if already `remote`. This
   * is an anomalous state transition which we do not expect.
   *
   * @param clientId unique identifier for the client
   * @returns void
   */ addLocalClient(clientId) {
        if (this.isRemoteClient(clientId)) {
            console.warn('tried to mark', clientId, 'as `local` when already tracked as `remote`');
            return;
        }
        const wasAlreadyPresent = this.has(clientId);
        this.registry.set(clientId, {
            id: clientId,
            type: 'local',
            state: 'ready'
        });
        // only emit the event if this is a new client
        if (!wasAlreadyPresent) this.emitClientAdded(clientId);
    }
    /**
   * Adds an entry for a remote client. It will be ready for asynchronous communication once a handshake transpires.
   *
   * @description Will early exit with a warning if the client being marked as `remote` if already `local`. This
   * is an anomalous state transition which we do not expect.
   *
   * @param clientId unique identifier for the client
   * @returns void
   */ addRemoteClient(clientId) {
        if (this.isLocalClient(clientId)) {
            console.warn('tried to mark', clientId, 'as `remote` when already tracked as `local`');
            return;
        }
        const wasAlreadyPresent = this.has(clientId);
        this.registry.set(clientId, {
            id: clientId,
            type: 'remote',
            state: 'ready'
        });
        // only emit the event if this is a new client
        if (!wasAlreadyPresent) this.emitClientAdded(clientId);
    }
    isPendingClient(clientId) {
        const client = this.get(clientId);
        return client?.state === 'pending';
    }
    isLocalClient(clientId) {
        const client = this.get(clientId);
        return client?.state === 'ready' && client.type === 'local';
    }
    isRemoteClient(clientId) {
        const client = this.get(clientId);
        return client?.state === 'ready' && client.type === 'remote';
    }
    get size() {
        return this.registry.size;
    }
    /**
   * Removes a client from the registry.
   *
   * @param clientId unique identifier for the client to remove
   * @returns true if the client was removed, false if it wasn't found
   */ removeClient(clientId) {
        return this.registry.delete(clientId);
    }
    /**
   * Gets all client IDs currently in the registry.
   *
   * @returns array of all client IDs
   */ getAllClientIds() {
        return Array.from(this.registry.keys());
    }
    /**
   * Register a handler to be called when a client is added to the registry.
   *
   * @param handler Function to call when a client is added
   */ onClientAdded(handler) {
        this.onClientAddedHandlers.add(handler);
    }
    /**
   * Emit client added event to all registered handlers.
   *
   * @param clientId The client ID that was added
   */ emitClientAdded(clientId) {
        for (const handler of this.onClientAddedHandlers)try {
            handler(clientId);
        } catch (error) {
            console.error('Error in client added handler:', error);
        }
    }
    /**
   * Clean up all event handlers.
   */ destroy() {
        this.onClientAddedHandlers.clear();
        this.registry.clear();
    }
    constructor(){
        /**
     * A registry of all clients known to the current bridge API instance.
     *
     * @description NOTE: Clients undergo state transitions from pending -> ready until the current bridge
     * API instance is able to communicate with them.
     */ this.registry = new Map();
        /**
     * Event handlers for when clients are added to the registry.
     */ this.onClientAddedHandlers = new Set();
    }
}



var $b9NdB = parcelRequire("b9NdB");

function $01b53efa943b3738$export$761a9dd8b8d30326(command) {
    return typeof command === 'function' && command.__broadcastable === true;
}


class $6f9540b301e93716$export$aa5e57f9f8c1afec {
    /**
   * Get the result of the command invocation.
   *
   * @description Returns a promise that resolves to the command result, or undefined if cancelled.
   *
   * @returns Promise that resolves to the command result, or undefined if cancelled
   */ result() {
        return this.resultPromise;
    }
    /**
   * Cancel this specific command invocation.
   *
   * @description Attempts to cancel the command if it's still buffered or in-flight.
   * If the command has already completed, this will have no effect.
   *
   * @returns true if the command was found and cancelled, false if it was already completed/cancelled
   */ cancel() {
        return this.cancelCallback(this.invocationId);
    }
    /**
   * Cancel all commands in a specific group.
   *
   * @description Cancels all buffered commands that share the same groupId.
   * This is useful for cancelling related commands that were sent as part of the same operation.
   *
   * @param groupId The group identifier of commands to cancel
   * @returns number of commands that were cancelled
   */ cancelGroup(groupId) {
        return this.cancelGroupCallback(groupId);
    }
    constructor(invocationId, resultPromise, cancelCallback, cancelGroupCallback){
        this.invocationId = invocationId;
        this.resultPromise = resultPromise;
        this.cancelCallback = cancelCallback;
        this.cancelGroupCallback = cancelGroupCallback;
    }
}



var $3OwWt = parcelRequire("3OwWt");

const $aed738dc6dab29ec$export$ae5619804e22bb3b = (0, $3OwWt.createCommand)('discovery-command');
const $aed738dc6dab29ec$export$bf4ce67fda5f9b9f = (0, $3OwWt.createCommand)('reachable-command');
const $aed738dc6dab29ec$export$6884e468caa75174 = (0, $3OwWt.createCommand)('teardown-command');



var $ihlvl = parcelRequire("ihlvl");


var $erA1m = parcelRequire("erA1m");




// Max time in millis an enqueued invocation message is allowed to live on the queue.
// NOTE: we choose a number which represents a reasonable portion of a user's session.
// I.e., if a user is SPA navigating a web / desktop app, we expect them to stick around
// for more than a typical web page. The longer they stay, the more the probability of objects
// starting to hang around in memory. But also: we don't want to clean up too soon in case we
// have a flakey receiver / want to peform a full event replay / rehydration. Hence the number
// chosen below. For future readers consider AI networking streams & events (long-running).
const $5033d568d101a89b$export$ac4b6c122e5e5626 = 90000;
const $5033d568d101a89b$export$5176aa4eceb2405e = 100;
const $5033d568d101a89b$export$1552419560d53c41 = 1000;
const $5033d568d101a89b$export$2805cdefd9b18065 = 10000;


class $b7587bde0417d78a$export$b0fcb10052c4c5ff {
    /**
   * Buffers an invocation into a queue tied to the intended {@link receiverId}.
   *
   * @description Once the receiver is reachable, this message will be flushed alongside any other messages
   * which were previously enqueued against the provided {@link receiverId}.
   *
   * @param invocationId
   * @param senderId
   * @param receiverId
   * @param command
   * @param params
   */ enqueue(invocationId, senderId, receiverId, command, params) {
        const queue = this.queue.get(receiverId) ?? [];
        const now = performance.now();
        const groupId = params.groupId;
        // check the receiver is not overwhelmed with too many pending messages; if it is, drop the oldest message
        if (queue.length >= (0, $5033d568d101a89b$export$1552419560d53c41)) {
            console.warn(`Message queue for receiver ${receiverId} is full, dropping oldest message`);
            const expired = queue.shift();
            if (expired) this.onInvocationDropped?.(expired);
        }
        // check if the overall queue isn't overwhelmed; if it is, drop the oldest message from each receiver
        if (this.messageCount >= (0, $5033d568d101a89b$export$2805cdefd9b18065)) {
            console.warn('Total message queue is full, dropping oldest messages');
            this.checkAndDropOldestMessage();
        }
        // If this command has a groupId, reset the timer for all commands with the same groupId
        if (groupId) this.resetGroupTimers(groupId, now);
        queue.push({
            invocationId: invocationId,
            senderId: senderId,
            receiverId: receiverId,
            command: command,
            params: params,
            enqueuedAt: now
        });
        this.queue.set(receiverId, queue);
        (0, $erA1m.emitter)().emit({
            type: 'message-queued',
            messageCount: this.messageCount,
            messageId: invocationId,
            clientId: receiverId,
            reason: 'receiver-not-ready'
        });
        // now that we have >1 message (at least), start a tick which executes every N millis
        // and drop any messages which go beyond the lifetime limit
        this.startTick();
    }
    /**
   * Flush all messages associated with a speciifc receiver.
   *
   * @description Typically called once the receiver is marked as ready.
   *
   * @param receiverId unique identifier for the receiver
   */ flush(receiverId) {
        const messages = this.queue.get(receiverId);
        // no messages found
        if (!messages) return;
        // we know we have a reference in the message list now - remove it
        this.deleteClientFromQueue(receiverId);
        // empty message list
        if (messages.length === 0) return;
        // emit queue flush event
        (0, $erA1m.emitter)().emit({
            type: 'queue-flushed',
            clientId: receiverId,
            messageCount: messages.length,
            reason: 'client-ready'
        });
        // return no-empty message list
        return messages;
    }
    /**
   * Returns the total number of messages across all receivers.
   * @returns count of messages across all buffered receivers
   */ get messageCount() {
        return Array.from(this.queue.values()).reduce((sum, q)=>sum + q.length, 0);
    }
    /**
   * Registers a callback to be called on every tick with unique senderId/receiverId pairs
   * for clients that are still waiting to connect.
   *
   * @param callback Function to call with pending connection pairs
   */ onTick(callback) {
        this.onTickCallback = callback;
    }
    /**
   * Registers a callback to be called when a message is dropped due to expiration or queue overflow.
   *
   * @param callback Callback to invoke with the dropped message
   */ onInvocationDroppped(callback) {
        this.onInvocationDropped = callback;
    }
    /**
   * Drops all buffered messages for a specific client (both as sender and receiver).
   *
   * @param clientId unique identifier for the client whose messages should be dropped
   * @returns number of messages that were dropped
   */ clear(clientId) {
        let droppedCount = 0;
        const toDelete = new Set();
        // remove all messages where this client is the receiver
        if (this.queue.has(clientId)) {
            const messages = this.queue.get(clientId) ?? [];
            if (messages.length > 0) (0, $erA1m.emitter)().emit({
                type: 'queue-cleared',
                clientId: clientId,
                messageCount: this.messageCount - messages.length,
                reason: 'client-teardown'
            });
            // notify before dropping messages
            if (this.onInvocationDropped) for (const message of messages)this.onInvocationDropped(message);
            droppedCount += messages.length;
            // delete immediately - we do not want to process this queue below
            this.queue.delete(clientId);
        }
        // remove all messages where this client is the sender
        for (const [receiverId, messages] of this.queue){
            const messagesLength = messages.length;
            const messagesToKeep = messages.filter((message)=>{
                if (message.senderId === clientId) {
                    // notify before dropping message
                    if (this.onInvocationDropped) this.onInvocationDropped(message);
                    return false;
                }
                return true;
            });
            const removedCount = messagesLength - messagesToKeep.length;
            if (removedCount > 0) {
                droppedCount += removedCount;
                if (messagesToKeep.length === 0) toDelete.add(receiverId);
                else this.queue.set(receiverId, messagesToKeep);
            }
        }
        // clean up empty queues and stop tick
        this.deleteClientsFromQueue(toDelete);
        return droppedCount;
    }
    /**
   * Drops a specific buffered message by its invocation ID.
   *
   * @param invocationId The unique identifier of the message to drop
   * @returns true if the message was found and dropped, false otherwise
   */ cancel(invocationId) {
        for (const [receiverId, messages] of this.queue){
            const messageIndex = messages.findIndex((msg)=>msg.invocationId === invocationId);
            if (messageIndex !== -1) {
                const droppedMessage = messages[messageIndex];
                // notify before dropping message
                if (this.onInvocationDropped) this.onInvocationDropped(droppedMessage);
                // remove the message
                messages.splice(messageIndex, 1);
                // if no more messages for this receiver, clean up
                if (messages.length === 0) this.deleteClientFromQueue(receiverId);
                return true;
            }
        }
        return false;
    }
    /**
   * Cancels all buffered messages that match a specific group ID.
   *
   * @param groupId The group identifier of messages to cancel
   * @returns number of messages that were cancelled
   */ cancelGroup(groupId) {
        let droppedCount = 0;
        const toDelete = new Set();
        for (const [receiverId, messages] of this.queue){
            const messagesToKeep = messages.filter((message)=>{
                if (message.params.groupId === groupId) {
                    // notify before dropping message
                    if (this.onInvocationDropped) this.onInvocationDropped(message);
                    droppedCount++;
                    return false;
                }
                return true;
            });
            if (messagesToKeep.length === 0) toDelete.add(receiverId);
            else if (messagesToKeep.length !== messages.length) this.queue.set(receiverId, messagesToKeep);
        }
        // clean up empty queues
        this.deleteClientsFromQueue(toDelete);
        return droppedCount;
    }
    /**
   * Clear all state relevant to the queue.
   */ destroy() {
        this.queue.clear();
        if (this.tick) {
            clearInterval(this.tick);
            this.tick = undefined;
        }
        // clear callback references
        this.onTickCallback = undefined;
        this.onInvocationDropped = undefined;
    }
    /**
   * Checks the lifetime of all messages in the queue and drops them if they have exceeded their
   * maximum allowed lifetime of {@link MESSAGE_LIFETIME_IN_MILLIS}.
   */ checkLifetimeAndDrop() {
        const now = performance.now();
        const toDelete = new Set();
        // cull all messages for each receiver which have expired
        for (const [receiverId, messages] of this.queue){
            let needle = 0;
            // find the first message that has not expired (since messages are chronologically ordered)
            for(let idx = 0; idx < messages.length; idx++){
                const waitTime = now - messages[idx].enqueuedAt;
                if (waitTime <= (0, $5033d568d101a89b$export$ac4b6c122e5e5626)) {
                    needle = idx;
                    break;
                } else needle = messages.length;
            }
            // remove all expired messages in one sweep
            if (needle > 0) {
                // notify before dropping messages
                if (this.onInvocationDropped) for(let idx = 0; idx < needle; idx++)this.onInvocationDropped(messages[idx]);
                // remove expired messages
                messages.splice(0, needle);
            }
            // if we no longer have any messages, we should clear this entry entirely
            if (messages.length === 0) toDelete.add(receiverId);
        }
        // clean up all empty entries
        this.deleteClientsFromQueue(toDelete);
    }
    /**
   * Drops the oldest messages across all receivers when the total queue size is exceeded.
   */ checkAndDropOldestMessage() {
        let oldest = Infinity;
        let receiver = null;
        for (const [receiverId, messages] of this.queue)if (messages.length > 0 && messages[0].enqueuedAt < oldest) {
            oldest = messages[0].enqueuedAt;
            receiver = receiverId;
        }
        // drop the oldest message
        if (receiver) {
            const queue = this.queue.get(receiver) ?? [];
            queue.shift();
            // if no more messages - clean up
            if (queue.length === 0) this.deleteClientFromQueue(receiver);
        }
    }
    /**
   * Resets the enqueuedAt time for all messages with the specified groupId across all receivers.
   * This ensures that when a new message with a groupId is enqueued, all messages in the same
   * group get their timer reset, allowing the entire group to stay alive for MESSAGE_LIFETIME_IN_MILLIS
   * after the last message in the group.
   *
   * @param groupId The group identifier to reset timers for
   * @param newTime The new enqueuedAt time to set for all messages in the group
   */ resetGroupTimers(groupId, newTime) {
        for (const messages of this.queue.values()){
            for (const message of messages)if (message.params.groupId === groupId) message.enqueuedAt = newTime;
        }
    }
    /**
   * Extracts unique senderId/receiverId pairs from all buffered messages.
   * @returns Array of unique sender/receiver pairs that are still waiting to connect
   */ getUniquePendingConnections() {
        const uniquePairs = new Map();
        for (const messages of this.queue.values())for (const message of messages){
            const key = `${message.senderId}:${message.receiverId}`;
            if (!uniquePairs.has(key)) uniquePairs.set(key, {
                senderId: message.senderId,
                receiverId: message.receiverId
            });
        }
        return Array.from(uniquePairs.values());
    }
    /**
   * Safely deletes a single client from the queue and handles cleanup.
   *
   * @param clientId The client to remove from the queue
   * @private
   */ deleteClientFromQueue(clientId) {
        this.queue.delete(clientId);
        this.stopTick();
    }
    /**
   * Safely deletes multiple clients from the queue and handles cleanup.
   *
   * @param clientIds Set of client IDs to remove from the queue
   * @private
   */ deleteClientsFromQueue(clientIds) {
        for (const clientId of clientIds)this.queue.delete(clientId);
        this.stopTick();
    }
    constructor(){
        /**
     * A queue of messages keyed against a recipient client ID.
     *
     * @description Once the receiver is ready, we will flush all messages to them, IF they have not expired.
     */ this.queue = new Map();
        /**
     * A lazy tick which is executed only if there are buffered messages, and cleans up a message after
     * {@link MESSAGE_LIFETIME_IN_MILLIS} have elapsed since the message was enqueued.
     *
     * @description NOTE: It is important to ensure there is only one interval which can run at any given time.
     * Too many timers can clog up the event loop and slow execution:
     */ this.tick = undefined;
        /**
     * Optional callback that gets called on every tick with unique senderId/receiverId pairs
     * for clients that are still waiting to connect.
     */ this.onTickCallback = void 0;
        /**
     * Optional callback that gets called when a message is dropped due to expiration or queue overflow.
     * @description Use this to perform any clean up activities relative to a buffered command.
     */ this.onInvocationDropped = void 0;
        /**
     * Starts an interval which does a full sweep every {@link MESSAGE_TICK_TIME_IN_MILLIS} to drop messages
     * which have gone beyond their lifetime.
     *
     * @description NOTE: The use of {@link setInterval} is deliberate here, as browsers will try their best
     * to continue executing {@link setInterval} callbacks even if a tab is unfocused. If the tab enters the
     * 'frozen' state in Chromium browsers, then execution is completely paused as per:
     * @see {@link https://developer.chrome.com/docs/web-platform/page-lifecycle-api}
     */ this.startTick = ()=>{
            if (this.tick) return;
            this.tick = setInterval(()=>{
                this.checkLifetimeAndDrop();
                // Call the onTick callback if registered and there are buffered messages
                if (this.onTickCallback && this.queue.size > 0) {
                    const pendingConnections = this.getUniquePendingConnections();
                    this.onTickCallback(pendingConnections);
                }
            }, (0, $5033d568d101a89b$export$5176aa4eceb2405e));
        };
        /**
     * Stops the tick if there are no more messages to process.
     */ this.stopTick = ()=>{
            if (this.queue.size > 0) return;
            clearInterval(this.tick);
            this.tick = undefined;
        };
    }
}



var $eF8UL = parcelRequire("eF8UL");


var $7MUeQ = parcelRequire("7MUeQ");







class $669501f7dd7d606f$export$d51c578aa8736606 {
    /**
   * Register a handler for a specific command type for a specific client.
   *
   * @description When a command of type {@link CommandClass} is received, the handler will be invoked in a 1-1 manner.
   * This is to ensure the result of the command invocation can be cleanly passed to the callee.
   *
   * @param clientId The client identifier that this handler is registered for
   * @param CommandClass The command class to register a handler for
   * @param handler The handler function to invoke when the command is received
   * @returns void
   */ register(clientId, CommandClass, handler) {
        const handlerKey = this.createHandlerKey(clientId, CommandClass.identifier);
        this.handlers.set(handlerKey, handler);
    }
    /**
   * Unregisters a handler for a specific command type for a specific client.
   */ unregister(clientId, CommandClass) {
        const handlerKey = this.createHandlerKey(clientId, CommandClass.identifier);
        this.handlers.delete(handlerKey);
    }
    /**
   * Unregisters all handlers for a specific client.
   *
   * @param clientId The client identifier to remove all handlers for
   * @returns number of handlers removed
   */ unregisterAll(clientId) {
        const keysToDelete = [];
        const prefix = `${clientId}:`;
        // find all relevant keys
        for (const key of this.handlers.keys())if (key.startsWith(prefix)) keysToDelete.push(key);
        // drop them
        for (const key of keysToDelete)this.handlers.delete(key);
        return keysToDelete.length;
    }
    /**
   * Invokes the appropriate handler for a given {@link RPCRequest}, and yields the result via
   * {@link transport} to the appropriate JavaScript context. If the handler throws, propagates an
   * {@link RPCResponse} with an error body. Vice versa for a successful handler response.
   *
   * @param request incoming RPC request (delegated method call, as a command)
   */ async handleRequest(request) {
        const params = request.params;
        const handlerKey = this.createHandlerKey(params.receiverId, request.method);
        const handler = this.handlers.get(handlerKey);
        (0, $erA1m.emitter)().emit({
            type: 'command-received',
            commandId: request.id,
            commandType: request.method,
            senderId: params.senderId,
            receiverId: params.receiverId,
            properties: {
                ...params
            },
            groupId: params.groupId
        });
        if (!handler) {
            const err = `handler not found for ${request.method} with clientId ${params.receiverId}`;
            console.warn(err);
            // emit command failed event
            (0, $erA1m.emitter)().emit({
                type: 'command-failed',
                commandId: request.id,
                commandType: request.method,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                    message: err,
                    code: 'METHOD_NOT_FOUND'
                },
                groupId: params.groupId
            });
            // communicate to sender that handler failed
            this.transport.send((0, $eF8UL.rpcError)(request.id, params.receiverId, params.senderId, (0, $7MUeQ.JSONRPCErrorCode).MethodNotFound, new Error(err)));
            return;
        }
        const startTime = performance.now();
        try {
            const result = await handler(request.params);
            const duration = performance.now() - startTime;
            // emit command completed event
            (0, $erA1m.emitter)().emit({
                type: 'command-completed',
                commandId: request.id,
                commandType: request.method,
                senderId: params.senderId,
                receiverId: params.receiverId,
                result: result,
                duration: duration,
                groupId: params.groupId
            });
            this.transport.send((0, $eF8UL.rpcSuccess)(request.id, params.receiverId, params.senderId, result));
        } catch (error) {
            const err = error instanceof Error ? error : new Error(String(error));
            const duration = performance.now() - startTime;
            // emit command failed event
            (0, $erA1m.emitter)().emit({
                type: 'command-failed',
                commandId: request.id,
                commandType: request.method,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                    message: err.message,
                    code: 'HANDLER_ERROR',
                    stack: err.stack
                },
                duration: duration,
                groupId: params.groupId
            });
            this.transport.send((0, $eF8UL.rpcError)(request.id, params.receiverId, params.senderId, (0, $7MUeQ.JSONRPCErrorCode).InternalError, err));
            console.error(err);
        }
    }
    /**
   * Directly invoke a handler of a specific command for a specific client.
   */ async invoke(command, params) {
        const handlerKey = this.createHandlerKey(params.receiverId, command.identifier);
        const handler = this.handlers.get(handlerKey);
        (0, $erA1m.emitter)().emit({
            type: 'command-received',
            commandId: params._invocationId ?? 'local-invocation',
            commandType: command.identifier,
            senderId: params.senderId,
            receiverId: params.receiverId,
            properties: params,
            groupId: params.groupId
        });
        if (!handler) {
            const err = `handler not found for command ${command.identifier} with clientId ${params.receiverId}`;
            console.error(err);
            // emit command failed event
            (0, $erA1m.emitter)().emit({
                type: 'command-failed',
                commandId: params._invocationId ?? 'local-invocation',
                commandType: command.identifier,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                    message: err,
                    code: 'METHOD_NOT_FOUND'
                },
                groupId: params.groupId
            });
            return undefined;
        }
        const startTime = performance.now();
        try {
            const result = handler?.(params);
            const duration = performance.now() - startTime;
            // emit command completed event
            (0, $erA1m.emitter)().emit({
                type: 'command-completed',
                commandId: params._invocationId || 'local-invocation',
                commandType: command.identifier,
                senderId: params.senderId,
                receiverId: params.receiverId,
                result: result,
                duration: duration,
                groupId: params.groupId
            });
            return result;
        } catch (error) {
            const err = error instanceof Error ? error : new Error(String(error));
            const duration = performance.now() - startTime;
            // emit command failed event
            (0, $erA1m.emitter)().emit({
                type: 'command-failed',
                commandId: params._invocationId || 'local-invocation',
                commandType: command.identifier,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                    message: err.message,
                    code: 'HANDLER_ERROR',
                    stack: err.stack
                },
                duration: duration,
                groupId: params.groupId
            });
            throw err;
        }
    }
    /**
   * Clear all relevant state for handling of responses.
   */ destroy() {
        this.handlers.clear();
    }
    /**
   * Creates a unique key for the handler mapping using clientId and command name.
   */ createHandlerKey(clientId, commandName) {
        return `${clientId}:${commandName}`;
    }
    constructor(transport){
        this.transport = transport;
        /**
     * A mapping from clientId:commandName -> handlers for those commands.
     *
     * @description We enforce only 1 handler per clientId+command pair, so that callees can listen for responses to a command.
     * This allows multiple clients to register handlers for the same command type.
     */ this.handlers = new Map();
    }
}


class $25c88f7ec17059a7$export$f456c9835cc63582 {
    /**
   * Creates a deferred promise handler for a given command invocation.
   * @param id unique ID for the command invocation
   * @param senderId the callee
   * @param receiverId the receiver which implements a handler for the command
   * @returns a deferrable which is resolved upon a response being yielded by the receiver
   */ getOrCreate(id, senderId, receiverId) {
        // if we already have a deferred promise waiting for this specific invocation, we do not need another one.
        const existing = this.get(id);
        if (existing) return existing.promise;
        let deferredResolve;
        let deferredReject;
        const promise = new Promise((resolve, reject)=>{
            deferredResolve = resolve;
            deferredReject = reject;
        });
        const result = {
            senderId: senderId,
            receiverId: receiverId,
            promise: promise,
            // @ts-expect-error - established in above callback
            resolve: deferredResolve,
            // @ts-expect-error - established in above callback
            reject: deferredReject
        };
        this.responses.set(id, result);
        return promise;
    }
    /**
   * Yields the current deferrable state for a command invocation.
   * @param id unique ID for the command invocation.
   * @returns deferrable state for a command invocation.
   */ get(id) {
        return this.responses.get(id);
    }
    /**
   * Resolves a promise reference based upon the ID of an RPC response.
   *
   * @description If the RPC response is successful, will resolve the promise with the expected return shape.
   * @description If the RPC response is unsuccessful, will reject the promise with an error.
   *
   * @param _response response yielded by the receiver of the original message.
   */ resolveWithResponse(response) {
        const id = response.id;
        const deferred = this.responses.get(id);
        // no one waiting - exit
        if (!deferred) return;
        // drop the deferrable from storage now
        this.responses.delete(id);
        // yield correct outcome
        if (response.error) deferred.reject(new Error(response.error.message));
        else deferred.resolve(response.result);
    }
    /**
   * Cancels a specific promise by resolving it to undefined to avoid unhandled rejections
   * in fire-and-forget scenarios.
   *
   * @description In JavaScript if you do the following:
   * ```typescript
   * const promise = () => new Promise((_, reject) => reject(new Error('oh boy')));
   * promise();
   * ```
   * Even though you are not explicitly calling `await` on the result of the promise, it will
   * reject and result in an unhandled rejection. Specifically when working with commands, we
   * often want to send them in a fire-and-forget manner. When a 'cancellation' takes place,
   * we therefore DO NOT want an unhandled rejection to result. Hence, we treat all command
   * results similar to distributed system communications - as always nullable.
   *
   * Cancellation events to consider: component unmounts, route transitions.
   *
   * For more, see:
   * - {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event}
   * - {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Using_promises#promise_rejection_events}
   * - {@link https://typescript-eslint.io/rules/no-floating-promises/}
   *
   * @param id unique ID for the command invocation to cancel
   */ cancel(id) {
        const deferred = this.responses.get(id);
        if (!deferred) return;
        // clear out in-memory reference
        this.responses.delete(id);
        // resolve to undefined to avoid unhandled promise rejections
        deferred.resolve(undefined);
    }
    /**
   * Clears response handlers for a specific client to prevent memory leaks during client teardown.
   *
   * @param clientId The client ID to clear responses for (as sender or receiver)
   */ teardown(clientId) {
        const toDelete = [];
        for (const [id, deferred] of this.responses)if (deferred.senderId === clientId || deferred.receiverId === clientId) {
            // Resolve to undefined to avoid unhandled promise rejections
            deferred.resolve(undefined);
            toDelete.push(id);
        }
        for (const id of toDelete)this.responses.delete(id);
    }
    /**
   * Destroy all relevant state.
   */ clear() {
        // Resolve all pending promises to avoid unhandled rejections
        for (const deferred of this.responses.values())deferred.resolve(undefined);
        this.responses.clear();
    }
    constructor(){
        /**
     * A mapping from unique command invocations to deferred promises waiting
     * for their result. Used for match-making the result of a delegated RPC call
     * back to its callee. TODO - hook up to methods in CNS-18261.
     */ this.responses = new Map();
    }
}


class $b3b4cb2fbe9d1237$export$d90806e6eab0cb0a {
    /**
   * Unique ID for this specific bridge API instance.
   *
   * @description Should be the 1 instance in a given JS context.
   */ get id() {
        return this.identifier;
    }
    /**
   * Indicates a specific client is ready to start sending and accepting messages.
   *
   * @param clientId unique identifier for the client.
   */ ready(clientId) {
        this.registry.addLocalClient(clientId);
        // client-specific handlers - sent by a remote client -> this bridge API instance,
        // targeting the client which we are setting up in this method
        this.createDiscoveryHandler(clientId);
        this.createReachableHandler(clientId);
        this.createTeardownHandler(clientId);
        // emit client registration event
        (0, $erA1m.emitter)().emit({
            type: 'client-registered',
            clientId: clientId
        });
    }
    /**
   * Send a command with strongly-typed parameters to a recipient.
   *
   * @description It is possible to wait for the response of a command via the following:
   * ```typescript
   * const command = send(MyCommand, {});
   * await command.result(); // promise with result of the command
   * // optionally, to cancel:
   * command.cancel();
   * ```
   * Command invocations should be treated similarly in concept to network requests to an upstream system.
   * The upstream system can time out, disappear, crash, etc. Hence, all command results yield an optional
   * result, with resiliency baked in for connectivity with a client see {@link BufferedInvocationQueue}.
   *
   * Deferrables are used to expose a stable promise API for the result of a command. I.e., if the receiver
   * of a command is not seen as 'ready' yet, commands will be buffered until a time limit. Once that time
   * limit is expended, the message will be dropped, and its associated deferrable cancelled.
   *
   * @returns {CommandInvocation} api for handling the response of the command.
   */ send(command, params) {
        // assign a unique ID to this command invocation
        if (!params._invocationId) params._invocationId = (0, $dQl1W.v4)();
        // unique, stable ID for this command
        const id = (0, $eF8UL.createInvocationId)(command, params);
        const message = (0, $eF8UL.rpcCommand)(id, command, params);
        const senderId = params.senderId;
        const receiverId = params.receiverId;
        // emit command creation event
        (0, $erA1m.emitter)().emit({
            type: 'command-created',
            commandId: id,
            commandType: command.identifier,
            senderId: senderId,
            receiverId: receiverId,
            properties: {
                ...params
            },
            groupId: params.groupId
        });
        let promise;
        // not ready to send to a known, communicable client yet - buffer & defer (if allowed)
        if (!this.registry.has(receiverId) || !this.transport.canSend(message) || this.registry.isPendingClient(receiverId)) {
            // default to buffering the sending of all commands
            const buffer = params.buffer ?? true;
            if (buffer) {
                this.queue.enqueue(id, senderId, receiverId, command, params);
                promise = this.rpc.response.getOrCreate(id, senderId, receiverId);
            } else // opted out of buffering - resolve immediately to undefined
            promise = Promise.resolve(undefined);
        } else if (this.registry.isLocalClient(receiverId)) {
            // emit command sent event for local invocation
            (0, $erA1m.emitter)().emit({
                type: 'command-sent',
                commandId: id,
                commandType: command.identifier,
                senderId: senderId,
                receiverId: receiverId,
                properties: params,
                groupId: params.groupId
            });
            const result = this.rpc.request.invoke(command, params);
            const existing = this.rpc.response.get(id);
            // if a local client was not ready yet and we tried to communicate with it,
            // we do not want to instantiate a new promise. Hence, we need to latch onto
            // the same deferrable as before, and yield it with the result of invoking the
            // handler provided by the local client which is ready & we are communicating to
            if (existing) {
                existing.resolve(result);
                promise = existing.promise;
            } else promise = result;
        } else {
            // emit command sent event
            (0, $erA1m.emitter)().emit({
                type: 'command-sent',
                commandId: id,
                commandType: command.identifier,
                senderId: senderId,
                receiverId: receiverId,
                properties: params,
                groupId: params.groupId
            });
            this.transport.send(message);
            promise = this.rpc.response.getOrCreate(id, senderId, receiverId);
        }
        return new (0, $6f9540b301e93716$export$aa5e57f9f8c1afec)(id, promise, (invocationId)=>this.cancel(invocationId), (groupId)=>this.cancelGroup(groupId));
    }
    /**
   * Broadcasts a command to all registered clients except those that are pending or filtered out.
   *
   * @typeParam C - The type of command properties, which must include a `receiverId` of type `ClientId`.
   * @param command - The constructor for the broadcastable command to be sent.
   * @param params - The parameters for the command, excluding the `receiverId` which will be set for each recipient.
   * @param options - Optional broadcast options, including a filter function to select specific clients.
   *
   * @remarks
   * - Only commands that pass `isBroadcastableCommand` are sent.
   * - The method retrieves all client IDs from the registry, filters out pending clients, and applies any additional filter provided in `options`.
   * - For each eligible client, the command is sent with the appropriate `receiverId`.
   * - Errors during broadcasting are caught and logged to the console.
   */ broadcast(command, params, options) {
        try {
            if (!(0, $01b53efa943b3738$export$761a9dd8b8d30326)(command)) return;
            const receiverIds = this.registry.getAllClientIds()?.filter((clientId)=>!this.registry.isPendingClient(clientId) && String(params.senderId) !== clientId)?.filter((clientId)=>options?.filter ? options.filter(clientId) : true) ?? [];
            for (const receiverId of receiverIds)this.send(command, {
                ...params,
                receiverId: receiverId
            });
            if (receiverIds.length) (0, $erA1m.emitter)().emit({
                type: 'command-broadcast',
                senderId: params.senderId,
                receiverIds: receiverIds,
                commandType: command.identifier
            });
        } catch (err) {
            console.error('broadcast failed', err);
        }
    }
    /**
   * Register a handler for a specific command type for a specific client.
   */ on(clientId, Command, handler) {
        this.rpc.request.register(clientId, Command, handler);
        (0, $erA1m.emitter)().emit({
            type: 'handler-registered',
            clientId: clientId,
            commandType: Command.identifier
        });
    }
    /**
   * Unregister a handler for a specific command type for a specific client.
   */ off(clientId, Command) {
        this.rpc.request.unregister(clientId, Command);
        (0, $erA1m.emitter)().emit({
            type: 'handler-unregistered',
            clientId: clientId,
            commandType: Command.identifier
        });
    }
    /**
   * Tears down a specific client, removing it from the registry and notifying all remote clients.
   *
   * @description This method performs the following actions:
   * 1. Removes the client from the local registry
   * 2. Sends teardown commands to all known remote clients
   * 3. Drops all buffered messages for the client
   * 4. Unregisters all command handlers for the client
   * 5. Clears any pending response handlers for the client
   * 6. Removes transport target references for the client
   *
   * @param clientId unique identifier for the client to tear down
   */ teardown(clientId) {
        // 1. remove the client from the registry
        const wasRemoved = this.registry.removeClient(clientId);
        if (!wasRemoved) return;
        // 2. notify all remote clients about the teardown
        const allClientIds = this.registry.getAllClientIds();
        for (const otherClientId of allClientIds)// irrespective of state, we should communicate we are tearing down
        // this handles any potential race conditions with in-flight messages
        // across JS contexts (e.g., actively shaking hands with a pending client)
        if (this.registry.isPendingClient(otherClientId) || this.registry.isRemoteClient(otherClientId)) this.sendCommand((0, $aed738dc6dab29ec$export$6884e468caa75174), {
            senderId: clientId,
            receiverId: otherClientId
        });
        // 3. drop all buffered messages for this client
        this.queue.clear(clientId);
        // 4. unregister all command handlers for this client
        this.rpc.request.unregisterAll(clientId);
        // 5. clear any pending response handlers for this client
        this.rpc.response.teardown(clientId);
        // 6. remove transport target references (Window/WebContents) for this client
        this.transport.teardown(clientId);
        // 7. emit client teardown event
        (0, $erA1m.emitter)().emit({
            type: 'client-teardown',
            clientId: clientId
        });
    }
    /**
   * Clear all state prior to the application being destroyed.
   *
   * @description NOTE: Ensure all containing state is destroyed to avoid memory leaks during
   * SPA transitions away from application contexts which use the bridge API.
   */ destroy() {
        this.queue.destroy();
        this.rpc.request.destroy();
        this.rpc.response.clear();
        this.registry.destroy();
        this.transport.destroy();
        // stop emitting any events & drop memory
        (0, $erA1m.emitter)().emit({
            type: 'bridge-destroyed'
        });
        // clean up all event emitter state
        (0, $erA1m.destroyGlobalEventEmitter)();
        (0, $ihlvl.destroyGlobalDebugConsumer)();
    }
    /**
   * Registers a message listener for RPC events received over {@link transport}.
   * @param data RPC message received by this JS context
   */ async onMessage(data) {
        try {
            if ((0, $eF8UL.isRPCRequest)(data)) return await this.rpc.request.handleRequest(data);
            if ((0, $eF8UL.isRPCResponse)(data)) return this.rpc.response.resolveWithResponse(data);
        } catch (err) {
            console.error('failed to handle message:', err);
        }
    }
    /**
   * Sets up a reachable handler for a specific client ID
   * @summary the {@link senderId} is the remote client who sent this command, expressing they are now reachable.
   * @param senderId
   */ createReachableHandler(senderId) {
        this.on(senderId, (0, $aed738dc6dab29ec$export$bf4ce67fda5f9b9f), (params)=>{
            this.registry.addRemoteClient(params.senderId);
            (0, $erA1m.emitter)().emit({
                type: 'client-discovered',
                clientId: params.senderId,
                metadata: {
                    discoveryMethod: 'reachable-command',
                    localClientId: senderId
                }
            });
        });
    }
    /**
   * Sets up a discoverable handler for a specific client ID
   * @summary the {@link senderId} is the remote client who sent this command, expressing they are looking for {@link senderId}.
   * @param senderId
   */ createDiscoveryHandler(senderId) {
        this.on(senderId, (0, $aed738dc6dab29ec$export$ae5619804e22bb3b), (params)=>{
            this.sendCommand((0, $aed738dc6dab29ec$export$bf4ce67fda5f9b9f), {
                senderId: params.receiverId,
                receiverId: params.senderId
            });
            this.registry.addRemoteClient(params.senderId);
            (0, $erA1m.emitter)().emit({
                type: 'client-discovered',
                clientId: params.senderId,
                metadata: {
                    discoveryMethod: 'discovery-command',
                    localClientId: senderId
                }
            });
        });
    }
    /**
   * Sets up a teardown handler for a specific client ID
   * @summary the {@link senderId} is the remote client who sent this command, expressing they are shutting down.
   * @param receiverId the local client that should handle teardown notifications
   */ createTeardownHandler(receiverId) {
        this.on(receiverId, (0, $aed738dc6dab29ec$export$6884e468caa75174), (params)=>{
            // remove the client that is tearing down from our registry
            this.registry.removeClient(params.senderId);
            // drop all buffered messages for the client that is tearing down
            this.queue.clear(params.senderId);
        });
    }
    /**
   * Immediately send a command over the configured {@link transport}.
   *
   * @description Used for handshake between clients, to simplify logic.
   * @description Re-used to send all commands in the bridge API.
   *
   * @param command command to send
   * @param params command properties to provide
   */ sendCommand(command, params) {
        const id = (0, $eF8UL.createInvocationId)(command, params);
        const message = (0, $eF8UL.rpcCommand)(id, command, params);
        this.transport.send(message);
    }
    /**
   * Drain commands for a given client ID from the queue.
   * @param clientId unique identifier for the client
   */ drainCommands(clientId) {
        const messages = this.queue.flush(clientId);
        if (!messages) return;
        for (const message of messages)this.send(message.command, message.params);
    }
    /**
   * Cancel all commands in a specific group.
   *
   * @param groupId The group identifier of commands to cancel
   * @returns number of commands that were cancelled
   */ cancelGroup(groupId) {
        // remove the buffered commands with this group ID from the queue, if they exist; will also clean up
        // the RPC response handler deferrable for each command
        return this.queue.cancelGroup(groupId);
    }
    /**
   * Cancel a specific command invocation by its ID.
   *
   * @param invocationId The unique identifier of the command invocation to cancel
   * @returns true if the command was found and cancelled, false otherwise
   */ cancel(invocationId) {
        // remove the buffered command from the queue, if it exists on it; this will also clean up
        // the RPC response handler deferrable for this command
        return this.queue.cancel(invocationId);
    }
    constructor(instanceId, transport){
        this.transport = void 0;
        this.identifier = void 0;
        this.registry = new (0, $2c20c32e03f99301$export$c7eb95d2cb93befa)();
        this.queue = new (0, $b7587bde0417d78a$export$b0fcb10052c4c5ff)();
        this.rpc = void 0;
        this.transport = transport;
        this.identifier = (0, $b9NdB.client)(instanceId ? instanceId : `bridge-api-${(0, $dQl1W.v4)()}`);
        this.rpc = {
            request: new (0, $669501f7dd7d606f$export$d51c578aa8736606)(this.transport),
            response: new (0, $25c88f7ec17059a7$export$f456c9835cc63582)()
        };
        // setup emitter for all events
        (0, $erA1m.emitter)().setBridgeId(this.identifier);
        // start listening for any incoming messages
        this.transport.onMessage(this.onMessage.bind(this));
        // setup tick handler for sending discovery commands to pending clients
        this.queue.onTick((pendingConnections)=>{
            for (const { senderId: senderId, receiverId: receiverId } of pendingConnections)this.sendCommand((0, $aed738dc6dab29ec$export$ae5619804e22bb3b), {
                senderId: senderId,
                receiverId: receiverId
            });
        });
        // setup dropped message handler to cancel orphaned promises
        this.queue.onInvocationDroppped((m)=>{
            this.rpc.response.cancel(m.invocationId);
            (0, $erA1m.emitter)().emit({
                type: 'message-dropped',
                messageCount: this.queue.messageCount,
                messageId: m.invocationId,
                message: {
                    ...m.params
                },
                clientId: m.senderId,
                reason: 'queue-overflow'
            });
        });
        // setup client added handler to drain commands when clients are ready
        this.registry.onClientAdded((clientId)=>{
            this.drainCommands(clientId);
        });
        // observe readiness of bridge API
        (0, $erA1m.emitter)().emit({
            type: 'bridge-ready'
        });
    }
}
module.exports["RovoContentBridgeAPI"] = $b3b4cb2fbe9d1237$export$d90806e6eab0cb0a;

});

parcelRegister("b9NdB", function(module, exports) {
/**
 * A unique ID for referring to a client of the bridge API.
 *
 * @description Can either be a producer or receiver of events.
 */ const $b2767ae7757ac8f5$export$388e0302ca0d9a41 = (s)=>s;
module.exports["client"] = $b2767ae7757ac8f5$export$388e0302ca0d9a41;

});

parcelRegister("3OwWt", function(module, exports) {

var $4Xix7 = parcelRequire("4Xix7");

function $9ebcf773ee2d83ff$export$8d4021544bdece00(commandName) {
    var _NamedCommand;
    return _NamedCommand = class NamedCommand extends (0, $4Xix7.Command) {
    }, _NamedCommand.identifier = commandName, _NamedCommand;
}
function $9ebcf773ee2d83ff$export$87c8f2eea65200a8(commandName) {
    var _NamedBroadcastCommand;
    // We create a class and then assert the broadcastable marker.
    return _NamedBroadcastCommand = class NamedBroadcastCommand extends (0, $4Xix7.Command) {
    }, _NamedBroadcastCommand.identifier = commandName, _NamedBroadcastCommand.__broadcastable = true, _NamedBroadcastCommand;
}
module.exports["createCommand"] = $9ebcf773ee2d83ff$export$8d4021544bdece00;
module.exports["createBroadcastableCommand"] = $9ebcf773ee2d83ff$export$87c8f2eea65200a8;

});

parcelRegister("4Xix7", function(module, exports) {
class $4ed756eec4058724$export$cc7e12c76513e857 {
    constructor(properties, result){
        this.properties = properties;
        this.result = result;
    }
}
/**
 * Type helper for a command constructor.
 */ /**
 * A unique, human readable identifier for the command. Differs from {@link Command.name}, which is the JavaScript
 * -defined name given to a function symbol DO NOT use {@link Command.name} for any in-production purposes. It can
 * (1) be collapsed into clashing, minified names in the same bundle, or (2) differ across bundles due to differences
 * in decisions made by JavaScript bundlers in how they minify the name of a symbol.
 */ $4ed756eec4058724$export$cc7e12c76513e857.identifier = void 0;
module.exports["Command"] = $4ed756eec4058724$export$cc7e12c76513e857;

});

parcelRegister("ihlvl", function(module, exports) {

var $erA1m = parcelRequire("erA1m");

/**
 * Default debug configuration.
 */ const $61642d5075abcdde$var$DEFAULT_CONFIG = {
    enabled: false,
    maxHistory: 1000
};
class $61642d5075abcdde$export$6144c928b2a81851 {
    /**
   * Start consuming and logging bridge API events.
   */ enable() {
        if (this.subscription) return; // Already enabled
        this.config.enabled = true;
        this.subscription = (0, $erA1m.emitter)().onAny((event)=>{
            if (this.config.enabled && this.shouldLogEvent(event)) {
                this.logEvent(event);
                this.addToHistory(event);
            }
        });
        console.log("%c\uD83C\uDF09 Rovo Bridge API Debug Mode Enabled", 'color: #4ECDC4; font-weight: bold; font-size: 14px;');
    }
    /**
   * Stop consuming bridge API events.
   */ disable() {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }
        this.config.enabled = false;
        console.log("%c\uD83C\uDF09 Rovo Bridge API Debug Mode Disabled", 'color: #FF6B6B; font-weight: bold; font-size: 14px;');
    }
    /**
   * Update debug configuration.
   */ configure(newConfig) {
        this.config = {
            ...this.config,
            ...newConfig
        };
        console.log("%c\uD83D\uDD27 Debug configuration updated", 'color: #96CEB4; font-weight: bold;', this.config);
    }
    /**
   * Get current configuration.
   */ getConfig() {
        return {
            ...this.config
        };
    }
    /**
   * Get event history.
   */ getHistory() {
        return [
            ...this.eventHistory
        ];
    }
    /**
   * Clear event history.
   */ clearHistory() {
        this.eventHistory = [];
        console.log("%c\uD83E\uDDF9 Event history cleared", 'color: #FFEAA7; font-weight: bold;');
    }
    /**
   * Get debug statistics.
   */ getStats() {
        const eventCounts = this.eventHistory.reduce((counts, event)=>{
            counts[event.type] = (counts[event.type] || 0) + 1;
            return counts;
        }, {});
        return {
            enabled: this.config.enabled,
            totalEvents: this.eventHistory.length,
            eventCounts: eventCounts,
            uniqueClients: new Set(this.eventHistory.filter((e)=>'clientId' in e).map((e)=>e.clientId)).size,
            uniqueCommands: new Set(this.eventHistory.filter((e)=>'commandType' in e).map((e)=>e.commandType)).size
        };
    }
    /**
   * Export event history as JSON.
   */ exportHistory() {
        return JSON.stringify({
            exportedAt: new Date().toISOString(),
            config: this.config,
            events: this.eventHistory,
            stats: this.getStats()
        }, null, 2);
    }
    /**
   * Log an event to the console with simple formatting.
   */ logEvent(event) {
        const icon = this.eventIcons[event.type] || "\uD83D\uDCCB";
        const timestamp = this.formatTimestamp(event.timestamp);
        const bridgeId = event.bridgeId;
        // Create collapsible group with basic info
        const groupTitle = `${icon} ${timestamp} ${event.type} [${bridgeId}]`;
        console.groupCollapsed(`%c${groupTitle}`, this.getEventTypeStyle(event.type));
        // Add key details in a simple format
        this.logKeyDetails(event);
        // Log raw event data
        console.log('%cRaw Event:', 'color: #888; font-style: italic;', event);
        console.groupEnd();
    }
    /**
   * Log key event details in a simple format.
   */ logKeyDetails(event) {
        // Client ID (if present)
        if ('clientId' in event) console.log(`%c\u{1F464} Client: %c${event.clientId}`, 'font-weight: bold;', this.getClientStyle(event.clientId));
        // Command details (if present)
        if ('commandType' in event) {
            const cmdEvent = event;
            console.log(`%c\u{26A1} Command: %c${cmdEvent.commandType}`, 'font-weight: bold;', this.getCommandStyle(cmdEvent.commandType));
            if (cmdEvent.senderId && cmdEvent.receiverId) console.log(`%c\u{1F4E4} %c${cmdEvent.senderId} %c\u{2192} %c\u{1F4E5} %c${cmdEvent.receiverId}`, 'font-weight: bold;', this.getClientStyle(cmdEvent.senderId), 'color: #888;', 'font-weight: bold;', this.getClientStyle(cmdEvent.receiverId));
            if (cmdEvent.duration !== undefined) console.log(`%c\u{23F1}\u{FE0F} Duration: %c${this.formatDuration(cmdEvent.duration)}`, 'font-weight: bold;', this.getDurationStyle(cmdEvent.duration));
        }
        // Error (if present)
        if ('error' in event && event.error) console.log("%c\u274C Error:", 'color: #FF6B6B; font-weight: bold;', event.error);
        // Queue size (if present)
        if ('queueSize' in event) console.log(`%c\u{1F4CB} Queue Size: %c${event.queueSize}`, 'font-weight: bold;', this.getQueueSizeStyle(event.queueSize));
    }
    /**
   * Check if an event should be logged (with debouncing for transport errors).
   */ shouldLogEvent(event) {
        // Apply event filter if configured
        if (this.config.eventFilter && this.config.eventFilter.length > 0) {
            const matchesFilter = this.config.eventFilter.some((filter)=>{
                // Support category filters
                if (filter === 'commands') return event.type.startsWith('command-');
                if (filter === 'clients') return event.type.startsWith('client-');
                if (filter === 'transport') return event.type.startsWith('transport-');
                if (filter === 'queue') return event.type.includes('queue') || event.type.includes('message-');
                if (filter === 'handlers') return event.type.startsWith('handler-');
                if (filter === 'bridge') return event.type.startsWith('bridge-');
                if (filter === 'errors') return event.type.includes('error') || event.type.includes('failed') || event.type.includes('dropped');
                // Support exact event type matching
                return event.type === filter;
            });
            if (!matchesFilter) return false;
        }
        // Debounce transport errors to prevent spam during tick loops
        if (event.type === 'transport-error') {
            const transportEvent = event;
            const errorKey = `${event.type}-${transportEvent.messageId || 'unknown'}-${transportEvent.error?.message || 'unknown'}`;
            const lastLogged = this.recentErrors.get(errorKey) || 0;
            const now = Date.now();
            if (now - lastLogged < this.ERROR_DEBOUNCE_MS) return false; // Skip this duplicate error
            this.recentErrors.set(errorKey, now);
        }
        return true;
    }
    /**
   * Add event to history with size management.
   */ addToHistory(event) {
        this.eventHistory.push(event);
        // Trim history if it exceeds max size
        if (this.eventHistory.length > this.config.maxHistory) this.eventHistory.shift();
    }
    /**
   * Get color for a client ID.
   */ getClientColor(clientId) {
        if (!this.clientColors.has(clientId)) {
            const colorIndex = this.clientColors.size % this.colors.length;
            this.clientColors.set(clientId, this.colors[colorIndex]);
        }
        return this.clientColors.get(clientId);
    }
    /**
   * Get color for a command type.
   */ getCommandColor(commandType) {
        if (!this.commandColors.has(commandType)) {
            const colorIndex = this.commandColors.size % this.colors.length;
            this.commandColors.set(commandType, this.colors[colorIndex]);
        }
        return this.commandColors.get(commandType);
    }
    /**
   * Get CSS style for event type.
   */ getEventTypeStyle(eventType) {
        const baseStyle = 'font-weight: bold; font-size: 12px;';
        if (eventType.includes('error') || eventType.includes('failed')) return `${baseStyle} color: #FF6B6B;`;
        if (eventType.includes('completed') || eventType.includes('ready')) return `${baseStyle} color: #4ECDC4;`;
        if (eventType.includes('created') || eventType.includes('sent')) return `${baseStyle} color: #45B7D1;`;
        return `${baseStyle} color: #666;`;
    }
    /**
   * Get CSS style for client ID.
   */ getClientStyle(clientId) {
        return `color: ${this.getClientColor(clientId)}; font-weight: bold;`;
    }
    /**
   * Get CSS style for command type.
   */ getCommandStyle(commandType) {
        return `color: ${this.getCommandColor(commandType)}; font-weight: bold;`;
    }
    /**
   * Get CSS style for duration based on performance.
   */ getDurationStyle(duration) {
        if (duration < 10) return 'color: #4ECDC4; font-weight: bold;';
         // Fast
        if (duration < 100) return 'color: #FFEAA7; font-weight: bold;';
         // Medium
        return 'color: #FF6B6B; font-weight: bold;'; // Slow
    }
    /**
   * Get CSS style for queue size.
   */ getQueueSizeStyle(size) {
        if (size === 0) return 'color: #4ECDC4; font-weight: bold;';
        if (size < 5) return 'color: #FFEAA7; font-weight: bold;';
        return 'color: #FF6B6B; font-weight: bold;';
    }
    /**
   * Format timestamp for display.
   */ formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        return date.toLocaleTimeString('en-US', {
            hour12: false
        });
    }
    /**
   * Format duration in milliseconds.
   */ formatDuration(ms) {
        if (ms < 1) return `${(ms * 1000).toFixed(0)}\u{3BC}s`;
        if (ms < 1000) return `${ms.toFixed(1)}ms`;
        return `${(ms / 1000).toFixed(2)}s`;
    }
    constructor(){
        this.config = {
            ...$61642d5075abcdde$var$DEFAULT_CONFIG
        };
        this.subscription = null;
        this.eventHistory = [];
        this.clientColors = new Map();
        this.commandColors = new Map();
        this.recentErrors = new Map();
        this.ERROR_DEBOUNCE_MS = 5000;
        // 5 seconds
        /**
     * Color palette for consistent coloring.
     */ this.colors = [
            '#FF6B6B',
            '#4ECDC4',
            '#45B7D1',
            '#96CEB4',
            '#FFEAA7',
            '#DDA0DD',
            '#98D8C8',
            '#F7DC6F',
            '#BB8FCE',
            '#85C1E9'
        ];
        /**
     * Event type icons for visual distinction.
     */ this.eventIcons = {
            // Bridge events
            'bridge-ready': "\uD83C\uDF09",
            'bridge-destroyed': "\uD83D\uDCA5",
            // Client events
            'client-registered': "\uD83D\uDCDD",
            'client-ready': "\u2705",
            'client-discovered': "\uD83D\uDD0D",
            'client-teardown': "\uD83D\uDD04",
            // Command events
            'command-created': "\u26A1",
            'command-sent': "\uD83D\uDCE4",
            'command-received': "\uD83D\uDCE5",
            'command-completed': "\u2705",
            'command-failed': "\u274C",
            // Queue events
            'message-queued': "\uD83D\uDCCB",
            'queue-flushed': "\uD83D\uDE80",
            'queue-cleared': "\uD83E\uDDF9",
            'message-dropped': "\uD83D\uDDD1\uFE0F",
            // Transport events
            'transport-ready': "\uD83D\uDE9B",
            'transport-message-sent': "\uD83D\uDCE1",
            'transport-message-received': "\uD83D\uDCFB",
            'transport-error': "\u26A0\uFE0F",
            'transport-destroyed': "\uD83D\uDC80",
            // Handler events
            'handler-registered': "\uD83D\uDD27",
            'handler-unregistered': "\uD83D\uDD13",
            // Broadcast events
            'command-broadcast': "\uD83D\uDCE2"
        };
    }
}
/**
 * Global debug consumer instance.
 */ let $61642d5075abcdde$var$globalDebugConsumer = null;
function $61642d5075abcdde$export$f646f8b6276e8a5d() {
    if (!$61642d5075abcdde$var$globalDebugConsumer) $61642d5075abcdde$var$globalDebugConsumer = new $61642d5075abcdde$export$6144c928b2a81851();
    return $61642d5075abcdde$var$globalDebugConsumer;
}
function $61642d5075abcdde$export$7e0c663a378d377a() {
    if ($61642d5075abcdde$var$globalDebugConsumer) {
        $61642d5075abcdde$var$globalDebugConsumer.disable();
        $61642d5075abcdde$var$globalDebugConsumer = null;
    }
}
module.exports["BridgeDebugConsumer"] = $61642d5075abcdde$export$6144c928b2a81851;
module.exports["getDebugConsumer"] = $61642d5075abcdde$export$f646f8b6276e8a5d;
module.exports["destroyGlobalDebugConsumer"] = $61642d5075abcdde$export$7e0c663a378d377a;

});

parcelRegister("erA1m", function(module, exports) {
class $66f4868596a1fc2d$export$543ba59d3cb254aa {
    /**
   * Set the bridge ID for this emitter instance.
   * Should be called once when the bridge API is initialized.
   *
   * @param bridgeId The unique identifier for the bridge API instance
   */ setBridgeId(bridgeId) {
        this.bridgeId = bridgeId;
    }
    /**
   * Emit an event to all registered handlers.
   * Automatically adds timestamp and bridge ID to the event.
   *
   * @param event The event to emit (without timestamp and bridgeId)
   */ emit(event) {
        // Early return if emitter is disabled
        if (!this.config.enabled) return;
        // Automatically add timestamp and bridge ID
        const fullEvent = {
            ...event,
            timestamp: Date.now(),
            bridgeId: this.bridgeId ?? 'unknown-bridge'
        };
        // Emit to type-specific handlers
        const typeHandlers = this.handlers.get(fullEvent.type);
        if (typeHandlers) for (const handler of typeHandlers)this.safeInvoke(handler, fullEvent);
        // Emit to global handlers
        for (const handler of this.globalHandlers)this.safeInvoke(handler, fullEvent);
    }
    /**
   * Listen for events of a specific type.
   *
   * @param eventType The type of event to listen for
   * @param handler The handler function to call when the event occurs
   * @returns A subscription handle
   */ on(eventType, handler) {
        if (!this.handlers.has(eventType)) this.handlers.set(eventType, new Set());
        const handlers = this.handlers.get(eventType);
        handlers.add(handler);
        return this.createSubscription(()=>{
            handlers.delete(handler);
            if (handlers.size === 0) this.handlers.delete(eventType);
        });
    }
    /**
   * Listen for all events regardless of type.
   *
   * @param handler The handler function to call for any event
   * @returns A subscription handle
   */ onAny(handler) {
        this.globalHandlers.add(handler);
        return this.createSubscription(()=>{
            this.globalHandlers.delete(handler);
        });
    }
    /**
   * Remove a specific handler for an event type.
   *
   * @param eventType The event type to remove the handler from
   * @param handler The handler to remove
   */ off(eventType, handler) {
        const handlers = this.handlers.get(eventType);
        if (handlers) {
            handlers.delete(handler);
            if (handlers.size === 0) this.handlers.delete(eventType);
        }
    }
    /**
   * Remove all handlers for a specific event type.
   *
   * @param eventType The event type to clear handlers for
   */ removeAllListeners(eventType) {
        if (eventType) this.handlers.delete(eventType);
        else {
            this.handlers.clear();
            this.globalHandlers.clear();
        }
    }
    /**
   * Update emitter configuration.
   *
   * @param config New configuration options
   */ configure(config) {
        this.config = {
            ...this.config,
            ...config
        };
    }
    /**
   * Enable or disable the emitter.
   *
   * @param enabled Whether to enable event emission
   */ setEnabled(enabled) {
        this.config.enabled = enabled;
    }
    /**
   * Check if the emitter is currently enabled.
   */ isEnabled() {
        return this.config.enabled;
    }
    /**
   * Destroy the emitter and clean up all resources.
   */ destroy() {
        this.handlers.clear();
        this.globalHandlers.clear();
        this.config.enabled = false;
    }
    /**
   * Safely invoke a handler, catching any errors.
   */ safeInvoke(handler, event) {
        try {
            handler(event);
        } catch  {
        // we do not want to produce error logs for the observer
        // if you need to add logs, go for it - just remove them afterwards!
        }
    }
    /**
   * Create a subscription handle.
   */ createSubscription(unsubscribeFn) {
        let active = true;
        return {
            unsubscribe: ()=>{
                if (active) {
                    unsubscribeFn();
                    active = false;
                }
            },
            isActive: ()=>active
        };
    }
    constructor(config = {}){
        this.handlers = new Map();
        this.globalHandlers = new Set();
        this.config = void 0;
        this.bridgeId = null;
        this.config = {
            enabled: true,
            ...config
        };
    }
}
/**
 * Default global event emitter instance.
 *
 * This can be used as a singleton across the bridge API, or individual
 * bridge instances can create their own emitters.
 */ let $66f4868596a1fc2d$var$globalEmitter = null;
function $66f4868596a1fc2d$export$bad24218ebd77223() {
    if (!$66f4868596a1fc2d$var$globalEmitter) $66f4868596a1fc2d$var$globalEmitter = new $66f4868596a1fc2d$export$543ba59d3cb254aa();
    return $66f4868596a1fc2d$var$globalEmitter;
}
function $66f4868596a1fc2d$export$9e5e7c9e5a788cf7() {
    if ($66f4868596a1fc2d$var$globalEmitter) {
        $66f4868596a1fc2d$var$globalEmitter.destroy();
        $66f4868596a1fc2d$var$globalEmitter = null;
    }
}
module.exports["emitter"] = $66f4868596a1fc2d$export$bad24218ebd77223;
module.exports["destroyGlobalEventEmitter"] = $66f4868596a1fc2d$export$9e5e7c9e5a788cf7;

});

parcelRegister("jhQry", function(module, exports) {
"use strict";
var $e0a84905798d9d3e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e0a84905798d9d3e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSONRPCClient = void 0;

var $g8b8P = parcelRequire("g8b8P");


var $f4ag9 = parcelRequire("f4ag9");

var $e0a84905798d9d3e$var$JSONRPCClient = /** @class */ function() {
    function JSONRPCClient(_send, createID) {
        this._send = _send;
        this.createID = createID;
        this.idToResolveMap = new Map();
        this.id = 0;
    }
    JSONRPCClient.prototype._createID = function() {
        if (this.createID) return this.createID();
        else return ++this.id;
    };
    JSONRPCClient.prototype.timeout = function(delay, overrideCreateJSONRPCErrorResponse) {
        var _this = this;
        if (overrideCreateJSONRPCErrorResponse === void 0) overrideCreateJSONRPCErrorResponse = function(id) {
            return (0, $g8b8P.createJSONRPCErrorResponse)(id, $f4ag9.DefaultErrorCode, "Request timeout");
        };
        var timeoutRequest = function(ids, request) {
            var timeoutID = setTimeout(function() {
                ids.forEach(function(id) {
                    var resolve = _this.idToResolveMap.get(id);
                    if (resolve) {
                        _this.idToResolveMap.delete(id);
                        resolve(overrideCreateJSONRPCErrorResponse(id));
                    }
                });
            }, delay);
            return request().then(function(result) {
                clearTimeout(timeoutID);
                return result;
            }, function(error) {
                clearTimeout(timeoutID);
                return Promise.reject(error);
            });
        };
        var requestAdvanced = function(request, clientParams) {
            var ids = (!Array.isArray(request) ? [
                request
            ] : request).map(function(request) {
                return request.id;
            }).filter($e0a84905798d9d3e$var$isDefinedAndNonNull);
            return timeoutRequest(ids, function() {
                return _this.requestAdvanced(request, clientParams);
            });
        };
        return {
            request: function(method, params, clientParams) {
                var id = _this._createID();
                return timeoutRequest([
                    id
                ], function() {
                    return _this.requestWithID(method, params, clientParams, id);
                });
            },
            requestAdvanced: function(request, clientParams) {
                return requestAdvanced(request, clientParams);
            }
        };
    };
    JSONRPCClient.prototype.request = function(method, params, clientParams) {
        return this.requestWithID(method, params, clientParams, this._createID());
    };
    JSONRPCClient.prototype.requestWithID = function(method, params, clientParams, id) {
        return $e0a84905798d9d3e$var$__awaiter(this, void 0, void 0, function() {
            var request, response;
            return $e0a84905798d9d3e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        request = (0, $g8b8P.createJSONRPCRequest)(id, method, params);
                        return [
                            4 /*yield*/ ,
                            this.requestAdvanced(request, clientParams)
                        ];
                    case 1:
                        response = _a.sent();
                        if (response.result !== undefined && !response.error) return [
                            2 /*return*/ ,
                            response.result
                        ];
                        else if (response.result === undefined && response.error) return [
                            2 /*return*/ ,
                            Promise.reject(new $g8b8P.JSONRPCErrorException(response.error.message, response.error.code, response.error.data))
                        ];
                        else return [
                            2 /*return*/ ,
                            Promise.reject(new Error("An unexpected error occurred"))
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    JSONRPCClient.prototype.requestAdvanced = function(requests, clientParams) {
        var _this = this;
        var areRequestsOriginallyArray = Array.isArray(requests);
        if (!Array.isArray(requests)) requests = [
            requests
        ];
        var requestsWithID = requests.filter(function(request) {
            return $e0a84905798d9d3e$var$isDefinedAndNonNull(request.id);
        });
        var promises = requestsWithID.map(function(request) {
            return new Promise(function(resolve) {
                return _this.idToResolveMap.set(request.id, resolve);
            });
        });
        var promise = Promise.all(promises).then(function(responses) {
            if (areRequestsOriginallyArray || !responses.length) return responses;
            else return responses[0];
        });
        return this.send(areRequestsOriginallyArray ? requests : requests[0], clientParams).then(function() {
            return promise;
        }, function(error) {
            requestsWithID.forEach(function(request) {
                _this.receive((0, $g8b8P.createJSONRPCErrorResponse)(request.id, $f4ag9.DefaultErrorCode, error && error.message || "Failed to send a request"));
            });
            return promise;
        });
    };
    JSONRPCClient.prototype.notify = function(method, params, clientParams) {
        var request = (0, $g8b8P.createJSONRPCNotification)(method, params);
        this.send(request, clientParams).then(undefined, function() {
            return undefined;
        });
    };
    JSONRPCClient.prototype.send = function(payload, clientParams) {
        return $e0a84905798d9d3e$var$__awaiter(this, void 0, void 0, function() {
            return $e0a84905798d9d3e$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._send(payload, clientParams)
                ];
            });
        });
    };
    JSONRPCClient.prototype.rejectAllPendingRequests = function(message) {
        this.idToResolveMap.forEach(function(resolve, id) {
            return resolve((0, $g8b8P.createJSONRPCErrorResponse)(id, $f4ag9.DefaultErrorCode, message));
        });
        this.idToResolveMap.clear();
    };
    JSONRPCClient.prototype.receive = function(responses) {
        var _this = this;
        if (!Array.isArray(responses)) responses = [
            responses
        ];
        responses.forEach(function(response) {
            var resolve = _this.idToResolveMap.get(response.id);
            if (resolve) {
                _this.idToResolveMap.delete(response.id);
                resolve(response);
            }
        });
    };
    return JSONRPCClient;
}();
module.exports.JSONRPCClient = $e0a84905798d9d3e$var$JSONRPCClient;
var $e0a84905798d9d3e$var$isDefinedAndNonNull = function(value) {
    return value !== undefined && value !== null;
};

});

parcelRegister("g8b8P", function(module, exports) {
"use strict";
var $bbe60929532a5baa$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createJSONRPCNotification = module.exports.createJSONRPCRequest = module.exports.createJSONRPCSuccessResponse = module.exports.createJSONRPCErrorResponse = module.exports.JSONRPCErrorCode = module.exports.JSONRPCErrorException = module.exports.isJSONRPCResponses = module.exports.isJSONRPCResponse = module.exports.isJSONRPCRequests = module.exports.isJSONRPCRequest = module.exports.isJSONRPCID = module.exports.JSONRPC = void 0;
module.exports.JSONRPC = "2.0";
var $bbe60929532a5baa$var$isJSONRPCID = function(id) {
    return typeof id === "string" || typeof id === "number" || id === null;
};
module.exports.isJSONRPCID = $bbe60929532a5baa$var$isJSONRPCID;
var $bbe60929532a5baa$var$isJSONRPCRequest = function(payload) {
    return payload.jsonrpc === module.exports.JSONRPC && payload.method !== undefined && payload.result === undefined && payload.error === undefined;
};
module.exports.isJSONRPCRequest = $bbe60929532a5baa$var$isJSONRPCRequest;
var $bbe60929532a5baa$var$isJSONRPCRequests = function(payload) {
    return Array.isArray(payload) && payload.every(module.exports.isJSONRPCRequest);
};
module.exports.isJSONRPCRequests = $bbe60929532a5baa$var$isJSONRPCRequests;
var $bbe60929532a5baa$var$isJSONRPCResponse = function(payload) {
    return payload.jsonrpc === module.exports.JSONRPC && payload.id !== undefined && (payload.result !== undefined || payload.error !== undefined);
};
module.exports.isJSONRPCResponse = $bbe60929532a5baa$var$isJSONRPCResponse;
var $bbe60929532a5baa$var$isJSONRPCResponses = function(payload) {
    return Array.isArray(payload) && payload.every(module.exports.isJSONRPCResponse);
};
module.exports.isJSONRPCResponses = $bbe60929532a5baa$var$isJSONRPCResponses;
var $bbe60929532a5baa$var$createJSONRPCError = function(code, message, data) {
    var error = {
        code: code,
        message: message
    };
    if (data != null) error.data = data;
    return error;
};
var $bbe60929532a5baa$var$JSONRPCErrorException = /** @class */ function(_super) {
    $bbe60929532a5baa$var$__extends(JSONRPCErrorException, _super);
    function JSONRPCErrorException(message, code, data) {
        var _this = _super.call(this, message) || this;
        // Manually set the prototype to fix TypeScript issue:
        // https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, JSONRPCErrorException.prototype);
        _this.code = code;
        _this.data = data;
        return _this;
    }
    JSONRPCErrorException.prototype.toObject = function() {
        return $bbe60929532a5baa$var$createJSONRPCError(this.code, this.message, this.data);
    };
    return JSONRPCErrorException;
}(Error);
module.exports.JSONRPCErrorException = $bbe60929532a5baa$var$JSONRPCErrorException;
var $bbe60929532a5baa$var$JSONRPCErrorCode;
(function(JSONRPCErrorCode) {
    JSONRPCErrorCode[JSONRPCErrorCode["ParseError"] = -32700] = "ParseError";
    JSONRPCErrorCode[JSONRPCErrorCode["InvalidRequest"] = -32600] = "InvalidRequest";
    JSONRPCErrorCode[JSONRPCErrorCode["MethodNotFound"] = -32601] = "MethodNotFound";
    JSONRPCErrorCode[JSONRPCErrorCode["InvalidParams"] = -32602] = "InvalidParams";
    JSONRPCErrorCode[JSONRPCErrorCode["InternalError"] = -32603] = "InternalError";
})($bbe60929532a5baa$var$JSONRPCErrorCode = module.exports.JSONRPCErrorCode || (module.exports.JSONRPCErrorCode = {}));
var $bbe60929532a5baa$var$createJSONRPCErrorResponse = function(id, code, message, data) {
    return {
        jsonrpc: module.exports.JSONRPC,
        id: id,
        error: $bbe60929532a5baa$var$createJSONRPCError(code, message, data)
    };
};
module.exports.createJSONRPCErrorResponse = $bbe60929532a5baa$var$createJSONRPCErrorResponse;
var $bbe60929532a5baa$var$createJSONRPCSuccessResponse = function(id, result) {
    return {
        jsonrpc: module.exports.JSONRPC,
        id: id,
        result: result !== null && result !== void 0 ? result : null
    };
};
module.exports.createJSONRPCSuccessResponse = $bbe60929532a5baa$var$createJSONRPCSuccessResponse;
var $bbe60929532a5baa$var$createJSONRPCRequest = function(id, method, params) {
    return {
        jsonrpc: module.exports.JSONRPC,
        id: id,
        method: method,
        params: params
    };
};
module.exports.createJSONRPCRequest = $bbe60929532a5baa$var$createJSONRPCRequest;
var $bbe60929532a5baa$var$createJSONRPCNotification = function(method, params) {
    return {
        jsonrpc: module.exports.JSONRPC,
        method: method,
        params: params
    };
};
module.exports.createJSONRPCNotification = $bbe60929532a5baa$var$createJSONRPCNotification;

});

parcelRegister("kIKHr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("j1BaM", function(module, exports) {
"use strict";
var $dd9af20d955ffc3a$var$__assign = module.exports && module.exports.__assign || function() {
    $dd9af20d955ffc3a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dd9af20d955ffc3a$var$__assign.apply(this, arguments);
};
var $dd9af20d955ffc3a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $dd9af20d955ffc3a$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $dd9af20d955ffc3a$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSONRPCServer = void 0;

var $g8b8P = parcelRequire("g8b8P");


var $f4ag9 = parcelRequire("f4ag9");

var $dd9af20d955ffc3a$var$createParseErrorResponse = function() {
    return (0, $g8b8P.createJSONRPCErrorResponse)(null, $g8b8P.JSONRPCErrorCode.ParseError, "Parse error");
};
var $dd9af20d955ffc3a$var$createInvalidRequestResponse = function(request) {
    return (0, $g8b8P.createJSONRPCErrorResponse)((0, $g8b8P.isJSONRPCID)(request.id) ? request.id : null, $g8b8P.JSONRPCErrorCode.InvalidRequest, "Invalid Request");
};
var $dd9af20d955ffc3a$var$createMethodNotFoundResponse = function(id) {
    return (0, $g8b8P.createJSONRPCErrorResponse)(id, $g8b8P.JSONRPCErrorCode.MethodNotFound, "Method not found");
};
var $dd9af20d955ffc3a$var$JSONRPCServer = /** @class */ function() {
    function JSONRPCServer(options) {
        if (options === void 0) options = {};
        var _a;
        this.mapErrorToJSONRPCErrorResponse = $dd9af20d955ffc3a$var$defaultMapErrorToJSONRPCErrorResponse;
        this.nameToMethodDictionary = {};
        this.middleware = null;
        this.errorListener = (_a = options.errorListener) !== null && _a !== void 0 ? _a : console.warn;
    }
    JSONRPCServer.prototype.hasMethod = function(name) {
        return !!this.nameToMethodDictionary[name];
    };
    JSONRPCServer.prototype.addMethod = function(name, method) {
        this.addMethodAdvanced(name, this.toJSONRPCMethod(method));
    };
    JSONRPCServer.prototype.removeMethod = function(name) {
        delete this.nameToMethodDictionary[name];
    };
    JSONRPCServer.prototype.toJSONRPCMethod = function(method) {
        return function(request, serverParams) {
            var response = method(request.params, serverParams);
            return Promise.resolve(response).then(function(result) {
                return $dd9af20d955ffc3a$var$mapResultToJSONRPCResponse(request.id, result);
            });
        };
    };
    JSONRPCServer.prototype.addMethodAdvanced = function(name, method) {
        var _a;
        this.nameToMethodDictionary = $dd9af20d955ffc3a$var$__assign($dd9af20d955ffc3a$var$__assign({}, this.nameToMethodDictionary), (_a = {}, _a[name] = method, _a));
    };
    JSONRPCServer.prototype.receiveJSON = function(json, serverParams) {
        var request = this.tryParseRequestJSON(json);
        if (request) return this.receive(request, serverParams);
        else return Promise.resolve($dd9af20d955ffc3a$var$createParseErrorResponse());
    };
    JSONRPCServer.prototype.tryParseRequestJSON = function(json) {
        try {
            return JSON.parse(json);
        } catch (_a) {
            return null;
        }
    };
    JSONRPCServer.prototype.receive = function(request, serverParams) {
        if (Array.isArray(request)) return this.receiveMultiple(request, serverParams);
        else return this.receiveSingle(request, serverParams);
    };
    JSONRPCServer.prototype.receiveMultiple = function(requests, serverParams) {
        return $dd9af20d955ffc3a$var$__awaiter(this, void 0, void 0, function() {
            var responses;
            var _this = this;
            return $dd9af20d955ffc3a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all(requests.map(function(request) {
                                return _this.receiveSingle(request, serverParams);
                            }))
                        ];
                    case 1:
                        responses = _a.sent().filter($dd9af20d955ffc3a$var$isNonNull);
                        if (responses.length === 1) return [
                            2 /*return*/ ,
                            responses[0]
                        ];
                        else if (responses.length) return [
                            2 /*return*/ ,
                            responses
                        ];
                        else return [
                            2 /*return*/ ,
                            null
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    JSONRPCServer.prototype.receiveSingle = function(request, serverParams) {
        return $dd9af20d955ffc3a$var$__awaiter(this, void 0, void 0, function() {
            var method, response;
            return $dd9af20d955ffc3a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        method = this.nameToMethodDictionary[request.method];
                        if (!!(0, $g8b8P.isJSONRPCRequest)(request)) return [
                            3 /*break*/ ,
                            1
                        ];
                        return [
                            2 /*return*/ ,
                            $dd9af20d955ffc3a$var$createInvalidRequestResponse(request)
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.callMethod(method, request, serverParams)
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            $dd9af20d955ffc3a$var$mapResponse(request, response)
                        ];
                }
            });
        });
    };
    JSONRPCServer.prototype.applyMiddleware = function() {
        var middlewares = [];
        for(var _i = 0; _i < arguments.length; _i++)middlewares[_i] = arguments[_i];
        if (this.middleware) this.middleware = this.combineMiddlewares($dd9af20d955ffc3a$var$__spreadArray([
            this.middleware
        ], middlewares, true));
        else this.middleware = this.combineMiddlewares(middlewares);
    };
    JSONRPCServer.prototype.combineMiddlewares = function(middlewares) {
        if (!middlewares.length) return null;
        else return middlewares.reduce(this.middlewareReducer);
    };
    JSONRPCServer.prototype.middlewareReducer = function(prevMiddleware, nextMiddleware) {
        return function(next, request, serverParams) {
            return prevMiddleware(function(request, serverParams) {
                return nextMiddleware(next, request, serverParams);
            }, request, serverParams);
        };
    };
    JSONRPCServer.prototype.callMethod = function(method, request, serverParams) {
        var _this = this;
        var callMethod = function(request, serverParams) {
            if (method) return method(request, serverParams);
            else if (request.id !== undefined) return Promise.resolve($dd9af20d955ffc3a$var$createMethodNotFoundResponse(request.id));
            else return Promise.resolve(null);
        };
        var onError = function(error) {
            _this.errorListener("An unexpected error occurred while executing \"".concat(request.method, "\" JSON-RPC method:"), error);
            return Promise.resolve(_this.mapErrorToJSONRPCErrorResponseIfNecessary(request.id, error));
        };
        try {
            return (this.middleware || $dd9af20d955ffc3a$var$noopMiddleware)(callMethod, request, serverParams).then(undefined, onError);
        } catch (error) {
            return onError(error);
        }
    };
    JSONRPCServer.prototype.mapErrorToJSONRPCErrorResponseIfNecessary = function(id, error) {
        if (id !== undefined) return this.mapErrorToJSONRPCErrorResponse(id, error);
        else return null;
    };
    return JSONRPCServer;
}();
module.exports.JSONRPCServer = $dd9af20d955ffc3a$var$JSONRPCServer;
var $dd9af20d955ffc3a$var$isNonNull = function(value) {
    return value !== null;
};
var $dd9af20d955ffc3a$var$noopMiddleware = function(next, request, serverParams) {
    return next(request, serverParams);
};
var $dd9af20d955ffc3a$var$mapResultToJSONRPCResponse = function(id, result) {
    if (id !== undefined) return (0, $g8b8P.createJSONRPCSuccessResponse)(id, result);
    else return null;
};
var $dd9af20d955ffc3a$var$defaultMapErrorToJSONRPCErrorResponse = function(id, error) {
    var _a;
    var message = (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : "An unexpected error occurred";
    var code = $f4ag9.DefaultErrorCode;
    var data;
    if (error instanceof $g8b8P.JSONRPCErrorException) {
        code = error.code;
        data = error.data;
    }
    return (0, $g8b8P.createJSONRPCErrorResponse)(id, code, message, data);
};
var $dd9af20d955ffc3a$var$mapResponse = function(request, response) {
    if (response) return response;
    else if (request.id !== undefined) return (0, $g8b8P.createJSONRPCErrorResponse)(request.id, $g8b8P.JSONRPCErrorCode.InternalError, "Internal error");
    else return null;
};

});

parcelRegister("7mczC", function(module, exports) {
"use strict";
var $55b4574ea3cdfc19$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $55b4574ea3cdfc19$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSONRPCServerAndClient = void 0;

var $g8b8P = parcelRequire("g8b8P");

var $55b4574ea3cdfc19$var$JSONRPCServerAndClient = /** @class */ function() {
    function JSONRPCServerAndClient(server, client, options) {
        if (options === void 0) options = {};
        var _a;
        this.server = server;
        this.client = client;
        this.errorListener = (_a = options.errorListener) !== null && _a !== void 0 ? _a : console.warn;
    }
    JSONRPCServerAndClient.prototype.applyServerMiddleware = function() {
        var _a;
        var middlewares = [];
        for(var _i = 0; _i < arguments.length; _i++)middlewares[_i] = arguments[_i];
        (_a = this.server).applyMiddleware.apply(_a, middlewares);
    };
    JSONRPCServerAndClient.prototype.hasMethod = function(name) {
        return this.server.hasMethod(name);
    };
    JSONRPCServerAndClient.prototype.addMethod = function(name, method) {
        this.server.addMethod(name, method);
    };
    JSONRPCServerAndClient.prototype.addMethodAdvanced = function(name, method) {
        this.server.addMethodAdvanced(name, method);
    };
    JSONRPCServerAndClient.prototype.removeMethod = function(name) {
        this.server.removeMethod(name);
    };
    JSONRPCServerAndClient.prototype.timeout = function(delay) {
        return this.client.timeout(delay);
    };
    JSONRPCServerAndClient.prototype.request = function(method, params, clientParams) {
        return this.client.request(method, params, clientParams);
    };
    JSONRPCServerAndClient.prototype.requestAdvanced = function(jsonRPCRequest, clientParams) {
        return this.client.requestAdvanced(jsonRPCRequest, clientParams);
    };
    JSONRPCServerAndClient.prototype.notify = function(method, params, clientParams) {
        this.client.notify(method, params, clientParams);
    };
    JSONRPCServerAndClient.prototype.rejectAllPendingRequests = function(message) {
        this.client.rejectAllPendingRequests(message);
    };
    JSONRPCServerAndClient.prototype.receiveAndSend = function(payload, serverParams, clientParams) {
        return $55b4574ea3cdfc19$var$__awaiter(this, void 0, void 0, function() {
            var response, message;
            return $55b4574ea3cdfc19$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!((0, $g8b8P.isJSONRPCResponse)(payload) || (0, $g8b8P.isJSONRPCResponses)(payload))) return [
                            3 /*break*/ ,
                            1
                        ];
                        this.client.receive(payload);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 1:
                        if (!((0, $g8b8P.isJSONRPCRequest)(payload) || (0, $g8b8P.isJSONRPCRequests)(payload))) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.server.receive(payload, serverParams)
                        ];
                    case 2:
                        response = _a.sent();
                        if (response) return [
                            2 /*return*/ ,
                            this.client.send(response, clientParams)
                        ];
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        message = "Received an invalid JSON-RPC message";
                        this.errorListener(message, payload);
                        return [
                            2 /*return*/ ,
                            Promise.reject(new Error(message))
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return JSONRPCServerAndClient;
}();
module.exports.JSONRPCServerAndClient = $55b4574ea3cdfc19$var$JSONRPCServerAndClient;

});

parcelRegister("9REl0", function(module, exports) {

let $72e85a85bb11b060$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $72e85a85bb11b060$var$load("6nq95").then(()=>parcelRequire('g3LKx'));

});

parcelRegister("2aEKk", function(module, exports) {

var $eF8UL = parcelRequire("eF8UL");

const $22b5caa63ff568ea$export$d22e131e673e4be0 = (envelope)=>{
    return Boolean(envelope && typeof envelope.version === 'number' && typeof envelope.source === 'string' && envelope.message && typeof envelope.message === 'object' && ((0, $eF8UL.isRPCRequest)(envelope.message) || (0, $eF8UL.isRPCResponse)(envelope.message)));
};
module.exports["isTransportEnvelope"] = $22b5caa63ff568ea$export$d22e131e673e4be0;

});

parcelRegister("jw6BH", function(module, exports) {

var $erA1m = parcelRequire("erA1m");

const $d49088a70ece8146$export$a06801d4af98f3a3 = ()=>{
    try {
        return Boolean(typeof window !== 'undefined' && window.webviewAPI && typeof window.webviewAPI.isElectron === 'function' && window.webviewAPI.isElectron());
    } catch  {
        return false;
    }
};
const $d49088a70ece8146$export$60ac5c5fdfd88da = ()=>{
    try {
        if ($d49088a70ece8146$export$a06801d4af98f3a3()) return window.webviewAPI;
        return undefined;
    } catch  {
        return undefined;
    }
};
const $d49088a70ece8146$export$7f13f4efe0e0c1f3 = (message, transportSource)=>{
    const electronAPI = $d49088a70ece8146$export$60ac5c5fdfd88da();
    if (!electronAPI) {
        (0, $erA1m.emitter)().emit({
            type: 'transport-error',
            transportType: transportSource,
            direction: 'outbound',
            messageId: message.id,
            error: {
                message: 'Webview API not available',
                code: 'WEBVIEW_API_UNAVAILABLE'
            }
        });
        return;
    }
    const envelope = {
        version: 1,
        source: transportSource,
        message: message
    };
    (0, $erA1m.emitter)().emit({
        type: 'transport-message-sent',
        transportType: transportSource,
        direction: 'outbound',
        messageId: message.id,
        message: {
            ...envelope
        }
    });
    // use the exposed to send to main
    electronAPI.postMessageToMain(envelope);
};
const $d49088a70ece8146$export$206d5b20b7c5c9d6 = 'rovo-bridge-message-channel';
const $d49088a70ece8146$export$c2e3eb4b2d131505 = 'desktop-main';
module.exports["isWebviewContext"] = $d49088a70ece8146$export$a06801d4af98f3a3;
module.exports["getWebviewAPI"] = $d49088a70ece8146$export$60ac5c5fdfd88da;
module.exports["sendToMainProcess"] = $d49088a70ece8146$export$7f13f4efe0e0c1f3;
module.exports["IPC_CHANNEL"] = $d49088a70ece8146$export$206d5b20b7c5c9d6;
module.exports["DESKTOP_INSTANCE_ID"] = $d49088a70ece8146$export$c2e3eb4b2d131505;

});

parcelRegister("67Foi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1DWH0 = parcelRequire("1DWH0");

const $66735002228b2e7e$export$b901544a79a3bbad = (0, $1DWH0.default)()(class ScreenEvent extends (0, $42omo.Component) {
    componentDidMount() {
        this.sendScreenEvent();
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.name !== this.props.name || nextProps.id !== this.props.id;
    }
    componentDidUpdate() {
        this.sendScreenEvent();
    }
    sendScreenEvent() {
        const { createAnalyticsEvent: createAnalyticsEvent, name: name, attributes: attributes } = this.props;
        const analyticsEvent = createAnalyticsEvent?.({
            type: 'sendScreenEvent',
            data: {
                name: name,
                attributes: attributes
            }
        });
        analyticsEvent?.fire();
    }
    render() {
        return null;
    }
});
module.exports["ScreenEvent"] = $66735002228b2e7e$export$b901544a79a3bbad;

});

parcelRegister("cpjd2", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $8SfNq = parcelRequire("8SfNq");

let $f663dee70ebb5ad8$var$wrm = null;
function $f663dee70ebb5ad8$export$6031f4216c50c6b() {
    if ($f663dee70ebb5ad8$var$wrm) return $f663dee70ebb5ad8$var$wrm;
    $f663dee70ebb5ad8$var$wrm = new Promise((resolve)=>{
        const wrmInterval = window.setInterval(()=>{
            if (window.WRM && typeof window.WRM.require === 'function') {
                window.clearInterval(wrmInterval);
                resolve(window.WRM);
            }
        }, 50);
    });
    return $f663dee70ebb5ad8$var$wrm;
}


const $7aedb2e6c8290322$var$logger = (0, $7W8i8.getLogger)('wrm');
let $7aedb2e6c8290322$var$wrmEnabled = true;
function $7aedb2e6c8290322$export$889e833efbc89be2(enabled) {
    $7aedb2e6c8290322$var$wrmEnabled = enabled;
}
function $7aedb2e6c8290322$export$f89844936aed7607(wrm, callback, unavailableCallback) {
    if (!callback || !unavailableCallback || !$7aedb2e6c8290322$var$wrmEnabled) {
        // Timeout to avoid trigger infinite render loop in React Hooks
        if (unavailableCallback) setTimeout(unavailableCallback);
        return;
    }
    Promise.all([
        (0, $8SfNq.requireSuperBatch)(),
        (0, $f663dee70ebb5ad8$export$6031f4216c50c6b)()
    ]).then(([_superBatch, wrmFns])=>wrmFns?.require?.(Array.isArray(wrm) ? wrm : [
            wrm
        ], callback));
}
function $7aedb2e6c8290322$export$20f64252ab26976b(wrm, callback, unavailableCallback) {
    if (!callback || !unavailableCallback || !$7aedb2e6c8290322$var$wrmEnabled) {
        // Timeout to avoid trigger infinite render loop in React Hooks
        if (unavailableCallback) setTimeout(unavailableCallback);
        return;
    }
    Promise.all([
        (0, $8SfNq.requireSuperBatch)(),
        (0, $f663dee70ebb5ad8$export$6031f4216c50c6b)()
    ]).then(([_superBatch, wrmFns])=>wrmFns?.realForceRequire?.(Array.isArray(wrm) ? wrm : [
            wrm
        ], callback));
}
module.exports["requireLegacyWRM"] = $7aedb2e6c8290322$export$f89844936aed7607;
module.exports["realForceRequireLegacyWRM"] = $7aedb2e6c8290322$export$20f64252ab26976b;

});

parcelRegister("8SfNq", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $6X8o4 = parcelRequire("6X8o4");


var $hBkCm = parcelRequire("hBkCm");


var $hp2SH = parcelRequire("hp2SH");




function $85f34d5a545e075f$export$9a852ffab1f95733(tags) {
    return (0, $6X8o4.liftPromiseState)(Promise.all(tags.map((script)=>{
        return new Promise((resolve)=>{
            script.onload = ()=>{
                resolve();
                script.setAttribute('data-loaded', 'true');
            };
        });
    })).then(()=>{}));
}


function $e1d7e468b9f7b2b3$var$updateMetaTag(param, value) {
    let el = window.document.querySelector(`[name="ajs-${param}"]`);
    if (typeof value === 'undefined') {
        if (el) window.document.head.removeChild(el);
        return;
    }
    if (!el) {
        el = window.document.createElement('meta');
        el.name = `ajs-${param}`;
        window.document.head.appendChild(el);
    }
    el.content = value;
}
function $e1d7e468b9f7b2b3$export$5ca65deaeaf7b896() {
    // Only proxy window.AJS.Meta if it's already defined.
    if (window.AJS !== undefined && window.AJS.Meta !== undefined && window.AJS.Meta.set !== undefined) {
        const origMeta = window.AJS.Meta;
        const origSet = window.AJS.Meta.set;
        function proxiedSet(...args) {
            const param = args[0];
            const value = args[1];
            $e1d7e468b9f7b2b3$var$updateMetaTag(param, value);
            return origSet.apply(origMeta, args);
        }
        window.AJS.Meta.set = proxiedSet;
    }
}



var $bUqLQ = parcelRequire("bUqLQ");

const $a0327ccdf3d1c822$export$41a89f309d284b76 = (0, $2XqLN.default)(async (client)=>{
    return client.query({
        query: (0, $bUqLQ.FrontendResourceRenderQuery),
        variables: {},
        context: {
            allowOnExternalPage: true
        }
    }).then((response)=>(response?.data?.internalFrontendResource?.resourceList || []).map((resource)=>{
            resource.attributes = resource.attributes || {};
            if (Array.isArray(resource.attributes)) resource.attributes = resource.attributes.reduce((obj, { key: key, value: value })=>{
                obj[key] = value;
                return obj;
            }, {});
            return resource;
        }) || [], (reason)=>{
        if (reason instanceof (0, $hBkCm.BadStatusError)) return [];
        throw reason;
    });
});
function $a0327ccdf3d1c822$var$createElement(type, attributes) {
    const element = document.createElement(type);
    Object.keys(attributes).forEach((attributeKey)=>element.setAttribute(attributeKey, attributes[attributeKey]));
    return element;
}
function $a0327ccdf3d1c822$var$createStyleElement(attributes) {
    return $a0327ccdf3d1c822$var$createElement('link', {
        rel: 'stylesheet',
        ...attributes
    });
}
function $a0327ccdf3d1c822$var$createSyncScriptElement(attributes) {
    attributes.crossorigin = 'anonymous';
    const element = $a0327ccdf3d1c822$var$createElement('script', attributes);
    element.async = false;
    return element;
}
function $a0327ccdf3d1c822$export$ddbd232684cf7af3(resourceList) {
    return resourceList.reduce((resources, { type: type, attributes: attributes, url: url })=>{
        if (!resources[type]) resources[type] = [];
        resources[type].push({
            attributes: attributes,
            url: url
        });
        return resources;
    }, {
        js: [],
        css: []
    });
}
function $a0327ccdf3d1c822$export$9bf2691bda54425c(url) {
    return url.replace(/externals=[^&]+&/, 'externals=__local-default__&');
}
async function $a0327ccdf3d1c822$var$fetchAndInsertJsAndCssTagsToHead() {
    const resources = await $a0327ccdf3d1c822$export$41a89f309d284b76((0, $hp2SH.getApolloClient)());
    const resourceByType = $a0327ccdf3d1c822$export$ddbd232684cf7af3(resources);
    const fragment = window.document.createDocumentFragment();
    const tagsAdded = [];
    resourceByType.js.forEach(({ url: url, attributes: attributes })=>{
        // Jquery is always statically loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
        if (attributes['data-wrm-key'] === 'com.atlassian.plugins.jquery:jquery') return;
        if (!window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) {
            // use https when running locally as some links with the
            // non-secure http protocol throws 403 locally instead of redirecting to https
            const src = $a0327ccdf3d1c822$export$9bf2691bda54425c(url);
            const tag = $a0327ccdf3d1c822$var$createSyncScriptElement({
                src: // Note: url on BE pipeline is relative
                src,
                ...attributes
            });
            tagsAdded.push(tag);
            fragment.appendChild(tag);
        }
    });
    resourceByType.css.forEach(({ url: url, attributes: attributes })=>{
        if (!window.document.querySelector(`link[data-wrm-key='${attributes['data-wrm-key']}']`)) {
            // use https when running locally as some links with the
            // non-secure http protocol throws 403 locally instead of redirecting to https
            const src = $a0327ccdf3d1c822$export$9bf2691bda54425c(url);
            const tag = $a0327ccdf3d1c822$var$createStyleElement({
                // Note: url on BE pipeline is relative
                href: src,
                ...attributes
            });
            tagsAdded.push(tag);
            fragment.appendChild(tag);
        }
    });
    if (tagsAdded.length) {
        window.document.head.appendChild(fragment);
        return (0, $85f34d5a545e075f$export$9a852ffab1f95733)(tagsAdded);
    }
    return Promise.resolve();
}
const $a0327ccdf3d1c822$export$89d51a91254af4d7 = (0, $2XqLN.default)(()=>{
    // NOTE: superbatch may be requested at the server side already, in which case
    // we don't need to refetch the superbatch resources again and can assume that
    // they are (or are being) loaded.
    const superbatchPromise = window.__SUPERBATCH_REQUESTED__ ? Promise.resolve() : $a0327ccdf3d1c822$var$fetchAndInsertJsAndCssTagsToHead();
    return (0, $6X8o4.liftPromiseState)(superbatchPromise.then(()=>(0, $e1d7e468b9f7b2b3$export$5ca65deaeaf7b896)()));
});
module.exports["requireSuperBatch"] = $a0327ccdf3d1c822$export$89d51a91254af4d7;

});

parcelRegister("8hUXc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3p0JS = parcelRequire("3p0JS");

const $73d59a54035866e7$export$8a4955b67fcd46ec = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext((0, $3p0JS.getDefaultContextState)());
$73d59a54035866e7$export$8a4955b67fcd46ec.displayName = 'CreateDialogContext';
module.exports["CreateDialogContext"] = $73d59a54035866e7$export$8a4955b67fcd46ec;

});

parcelRegister("39rFu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jfrcs = parcelRequire("jfrcs");


var $iFjdQ = parcelRequire("iFjdQ");


var $1NBp8 = parcelRequire("1NBp8");

const $89a61f4bf509d0f4$var$getRouteType = ({ isBlogpost: isBlogpost, isFabricSupported: isFabricSupported, isEmbeddedContent: isEmbeddedContent })=>{
    // Currently a temporary check for blogs is added here until Embedded Pages supports blogs.
    if (isEmbeddedContent && !isBlogpost) return 0, $1NBp8.EDIT_PAGE_EMBED;
    if (isFabricSupported) return isBlogpost ? (0, $1NBp8.EDIT_BLOG_V2) : (0, $1NBp8.EDIT_PAGE_V2);
    else return isBlogpost ? (0, $1NBp8.EDIT_BLOG) : (0, $1NBp8.EDIT_PAGE);
};
const $89a61f4bf509d0f4$export$e822f0a47cab2f33 = (routeDetails, transitionId, contentId)=>{
    const routeType = $89a61f4bf509d0f4$var$getRouteType(routeDetails);
    // Need to clear measures every time we start measuring. Otherwise initial measurements
    // will keep being used for all entry points.
    (0, $iFjdQ.ExperienceActionMeasures).clearMeasures();
    if (routeType.name) // transitionId cant be 0 since 0 is only for initial page load.
    (0, $jfrcs.startBrowserMetricsPageLoad)(routeType.name, routeType.ufoName, (transitionId || 0) + 1, contentId);
};


const $9d2611e8b6350474$export$ed7a4d2a58750e5a = {
    contentId: '',
    spaceKey: undefined,
    redirectUrl: null,
    contentType: null,
    isFabricSupported: true,
    isEmbeddedContent: false,
    referredFromLivePage: undefined
};
const $9d2611e8b6350474$export$dab6678a6d0a2033 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    ...$9d2611e8b6350474$export$ed7a4d2a58750e5a
});
const $9d2611e8b6350474$export$8f14bd77387a9a80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    loadEditor: ()=>{},
    nativeEditorComponentsPreloader: ()=>Promise.resolve(),
    livePageComponentsPreloader: ()=>Promise.resolve()
});
function $9d2611e8b6350474$export$dc5be4ae949c7899({ nativeEditorComponentsPreloader: nativeEditorComponentsPreloader, livePageComponentsPreloader: livePageComponentsPreloader, children: children }) {
    const [editLoadingValues, setEditLoadingValues] = (0, $42omo.useState)($9d2611e8b6350474$export$ed7a4d2a58750e5a);
    const nativeEditorPreloaderRef = (0, $42omo.useRef)(()=>Promise.resolve());
    nativeEditorPreloaderRef.current = nativeEditorComponentsPreloader;
    const stableNativeEditorComponentsPreloader = (0, $42omo.useCallback)(()=>nativeEditorPreloaderRef.current?.(), []);
    const livePagePreloaderRef = (0, $42omo.useRef)(()=>Promise.resolve());
    livePagePreloaderRef.current = livePageComponentsPreloader ?? (()=>Promise.resolve());
    const stableLivePageComponentsPreloader = (0, $42omo.useCallback)(()=>livePagePreloaderRef.current?.(), []);
    const actionsContextValue = (0, $42omo.useMemo)(()=>({
            loadEditor: (newValues)=>{
                if (newValues.contentId) // There's a special case for loadEditor call with default values and empty contentId.
                // It cleans up loading state before navigating to editor, and IS NOT indicating the
                // start of editor loading. So we should not start editor loading measurement in this
                // case, as it is already started.
                (0, $89a61f4bf509d0f4$export$e822f0a47cab2f33)({
                    isBlogpost: newValues.contentType === 'blogpost',
                    isFabricSupported: Boolean(newValues.isFabricSupported),
                    isEmbeddedContent: Boolean(newValues.isEmbeddedContent)
                }, // NOTE: passing transitionId for editor loading measurement doesn't warrant
                // the complexity of managing it in this context. It's barely used for performance
                // measurements but, being tied to Route context may force a lot of unnecessary
                // re-renders. If this is needed in future, we can revisit this decision.
                null, newValues.contentId);
                return setEditLoadingValues((oldState)=>({
                        ...oldState,
                        ...newValues
                    }));
            },
            nativeEditorComponentsPreloader: stableNativeEditorComponentsPreloader,
            livePageComponentsPreloader: stableLivePageComponentsPreloader
        }), [
        setEditLoadingValues,
        stableNativeEditorComponentsPreloader,
        stableLivePageComponentsPreloader
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>({
            ...editLoadingValues
        }), [
        editLoadingValues
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9d2611e8b6350474$export$dab6678a6d0a2033.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9d2611e8b6350474$export$8f14bd77387a9a80.Provider, {
        value: actionsContextValue
    }, children));
}
const $9d2611e8b6350474$export$9db478d7cbc3a0ec = ()=>{
    return (0, $42omo.useContext)($9d2611e8b6350474$export$dab6678a6d0a2033);
};
const $9d2611e8b6350474$export$61b834689819c7d3 = ()=>{
    return (0, $42omo.useContext)($9d2611e8b6350474$export$8f14bd77387a9a80);
};
module.exports["defaultEditLoadingValues"] = $9d2611e8b6350474$export$ed7a4d2a58750e5a;
module.exports["EditPageLoadingContextProvider"] = $9d2611e8b6350474$export$dc5be4ae949c7899;
module.exports["useEditPageLoadingValues"] = $9d2611e8b6350474$export$9db478d7cbc3a0ec;
module.exports["useEditPageLoadingActions"] = $9d2611e8b6350474$export$61b834689819c7d3;

});

parcelRegister("jfrcs", function(module, exports) {

var $2v1PW = parcelRequire("2v1PW");


var $054Kg = parcelRequire("054Kg");


var $6eGYE = parcelRequire("6eGYE");


var $3kTfj = parcelRequire("3kTfj");


var $6mKj3 = parcelRequire("6mKj3");


var $9eE57 = parcelRequire("9eE57");

parcelRequire("7sK8i");
var $dgXJ7 = parcelRequire("dgXJ7");


var $hZpML = parcelRequire("hZpML");


var $6VdZc = parcelRequire("6VdZc");


var $gpK3n = parcelRequire("gpK3n");


var $feexy = parcelRequire("feexy");


var $4u5NT = parcelRequire("4u5NT");

function $606dbc3d0ca2130d$export$812904046c66e1a3(marks) {
    const interactionId = (0, $feexy.getInteractionId)().current;
    if (!interactionId) return;
    const interactionType = (0, $4u5NT.getCurrentInteractionType)(interactionId);
    if (interactionType === 'press') return;
    const bm3Timings = {};
    Object.keys(marks).forEach((mark)=>{
        if (mark.startsWith('segment-start')) {
            const segmentName = mark.split(':')[1];
            const key = `wf/react/${segmentName}`;
            const endMark = `segment-end:${segmentName}`;
            const startTime = marks[mark];
            const endTime = marks[endMark];
            if (typeof startTime === 'number' && typeof endTime === 'number') bm3Timings[key] = {
                startTime: startTime,
                endTime: endTime
            };
        }
        if (mark.startsWith('wf') && mark.endsWith('.start')) {
            const key = mark.split('.start')[0];
            const startTime = marks[mark];
            const endMark = `${key}.end`;
            const endTime = marks[endMark];
            if (typeof startTime === 'number' && typeof endTime === 'number') bm3Timings[key] = {
                startTime: startTime,
                endTime: endTime
            };
        }
    });
    (0, $4u5NT.addCustomTiming)(interactionId, [], bm3Timings);
}


const $a2ef04dcd02665b5$export$4b2f5043c46174c = (routeName = '', ufoName = routeName, transitionId, contentId = '')=>{
    // Begin the loading timer _immediately_ using BM libraries generic meta startPageLoad metric.
    // Routes should later call stopPageLoad on the actual PageLoadMetric that is specifically defined for
    // the route in order to claim this page load.
    (0, $3kTfj.browserMetrics).startPageLoad({
        isInitial: transitionId === 0
    });
    if (transitionId === 0) {
        (0, $054Kg.default)(ufoName.toLocaleLowerCase());
        if ((0, $6mKj3.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) {
            (0, $2v1PW.insm).start(ufoName.toLocaleLowerCase(), {
                initial: true,
                contentId: contentId
            });
            (0, $2v1PW.insm).startHeavyTask('PageLoad');
        }
    } else {
        (0, $6eGYE.default)(ufoName.toLocaleLowerCase());
        if ((0, $6mKj3.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) {
            (0, $2v1PW.insm).start(ufoName.toLocaleLowerCase(), {
                initial: false,
                contentId: contentId
            });
            (0, $2v1PW.insm).startHeavyTask('PageLoad');
        }
    }
    performance.mark('browser-metric.start');
    const pageLoadMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    (0, $6VdZc.browserMetricsState).transitionId = transitionId;
    (0, $6VdZc.browserMetricsState).pageLoadStartTimestamp = pageLoadMetric.getData().start ?? performance.now();
    (0, $6VdZc.browserMetricsState).previousRoute = (0, $6VdZc.browserMetricsState).routeName;
    (0, $6VdZc.browserMetricsState).routeName = routeName;
    (0, $3kTfj.browserMetrics).setRoute(routeName);
    (0, $6VdZc.browserMetricsState).previousContentId = (0, $6VdZc.browserMetricsState).contentId;
    (0, $6VdZc.browserMetricsState).contentId = contentId;
    // will pause low priority events to avoid impacting page load performance
    // once the pageLoadEnd is triggered the resumeLowPriorityEvents will be called
    (0, $dgXJ7.pauseLowPriorityEvents)(routeName);
    if (pageLoadMetric.isInitialLoad() && window?.__SSR_RENDERED__) // Mark the legacy FMP point if server-side rendered
    pageLoadMetric.mark('fy21-legacy-fmp', (0, $9eE57.getMark)('CFP-63.ssr-ttr'));
    pageLoadMetric.onStop(()=>{
        if (pageLoadMetric.isInitialLoad()) {
            const t = window.performance?.getEntriesByType?.('navigation')?.[0];
            if (t) {
                // Redirection time
                if (t.redirectStart >= 0 && t.redirectEnd >= t.redirectStart) {
                    (0, $hZpML.WaterfallMeasures).markMeasureStart((0, $hZpML.WATERFALL_INITIAL_MEASURES).REDIRECTION, t.redirectStart);
                    (0, $hZpML.WaterfallMeasures).markMeasureEnd((0, $hZpML.WATERFALL_INITIAL_MEASURES).REDIRECTION, t.redirectEnd);
                }
                // DNS resolution
                if (t.domainLookupStart >= 0 && t.domainLookupEnd >= t.domainLookupStart) {
                    (0, $hZpML.WaterfallMeasures).markMeasureStart((0, $hZpML.WATERFALL_INITIAL_MEASURES).DNS, t.domainLookupStart);
                    (0, $hZpML.WaterfallMeasures).markMeasureEnd((0, $hZpML.WATERFALL_INITIAL_MEASURES).DNS, t.domainLookupEnd);
                }
                // TCP connection
                if (t.connectStart >= 0 && t.connectEnd >= t.connectStart) {
                    (0, $hZpML.WaterfallMeasures).markMeasureStart((0, $hZpML.WATERFALL_INITIAL_MEASURES).TCP, t.connectStart);
                    (0, $hZpML.WaterfallMeasures).markMeasureEnd((0, $hZpML.WATERFALL_INITIAL_MEASURES).TCP, t.connectEnd);
                }
                // TLS handshake
                if (t.secureConnectionStart >= 0 && t.connectEnd >= 0) {
                    (0, $hZpML.WaterfallMeasures).markMeasureStart((0, $hZpML.WATERFALL_INITIAL_MEASURES).TLS, t.secureConnectionStart);
                    (0, $hZpML.WaterfallMeasures).markMeasureEnd((0, $hZpML.WATERFALL_INITIAL_MEASURES).TLS, t.connectEnd);
                }
                // Response
                if (t.requestStart >= 0 && t.responseStart >= t.requestStart) {
                    (0, $hZpML.WaterfallMeasures).markMeasureStart((0, $hZpML.WATERFALL_INITIAL_MEASURES).RESPONSE, t.requestStart);
                    (0, $hZpML.WaterfallMeasures).markMeasureEnd((0, $hZpML.WATERFALL_INITIAL_MEASURES).RESPONSE, t.responseStart);
                }
                // TTFB
                if (t.startTime >= 0 && t.responseStart >= 0) {
                    (0, $hZpML.WaterfallMeasures).markMeasureStart((0, $hZpML.WATERFALL_INITIAL_MEASURES).TTFB, t.startTime);
                    (0, $hZpML.WaterfallMeasures).markMeasureEnd((0, $hZpML.WATERFALL_INITIAL_MEASURES).TTFB, t.responseStart);
                }
                // SSR complete
                if (t.requestStart >= 0 && t.responseEnd >= t.requestStart) {
                    (0, $hZpML.WaterfallMeasures).markMeasureStart((0, $hZpML.WATERFALL_INITIAL_MEASURES).FULL_HTML, t.requestStart);
                    (0, $hZpML.WaterfallMeasures).markMeasureEnd((0, $hZpML.WATERFALL_INITIAL_MEASURES).FULL_HTML, t.responseEnd);
                }
                // Server-timing
                if (t.serverTiming && t.serverTiming.length > 0) for (const serverTiming of t.serverTiming){
                    const metricName = `${(0, $hZpML.WATERFALL_INITIAL_MEASURES).SERVER_TIMING}/${serverTiming.name}`;
                    const startTime = t.requestStart > 0 ? t.requestStart : 0;
                    if ((0, $hZpML.SERVER_TIMING_MEASURES).includes(serverTiming.name)) {
                        // use requestStart as the start time, it's not the actual start time, but it's helpful
                        // to align the server timing with the request start time for visualisation.
                        (0, $hZpML.WaterfallMeasures).markMeasureStart(metricName, startTime);
                        (0, $hZpML.WaterfallMeasures).markMeasureEnd(metricName, startTime + serverTiming.duration);
                    }
                }
            }
        }
        // Copy all /wf markers to the page load metric
        // - window.performance.mark('wf/something.start/.end')
        // - WaterfallMetrics.run()
        // - WaterfallMetrics.markMeasureStart/markMeasureEnd()
        const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
        (0, $gpK3n.getPerformanceEntries)('wf/').forEach(({ name: name, startTime: startTime })=>{
            currentMetric.mark(name, startTime);
        });
        // NOTE: currentMetric is stopping _too early_ and some segment-end marks are added _after_ the metric is already stopped
        // To see this, console.log the following and compare the outputs:
        // console.log({ ...currentMetric.getData().marks }); // the marks available at the time of the object spread
        // console.log(currentMetric.getData().marks); // the marks available when browser can log to the console
        // what is logged at the bottom console.log is the contents of the memory reference of (currentMetric.getData().marks, which seems to be getting modified at a later point in time.
        (0, $606dbc3d0ca2130d$export$812904046c66e1a3)(currentMetric.getData().marks);
    }, ()=>{});
};
module.exports["startBrowserMetricsPageLoad"] = $a2ef04dcd02665b5$export$4b2f5043c46174c;

});

parcelRegister("7sK8i", function(module, exports) {
$parcel$export(module.exports, "pauseLowPriorityEvents", () => (parcelRequire("dgXJ7")).pauseLowPriorityEvents);
$parcel$export(module.exports, "resumeLowPriorityEvents", () => (parcelRequire("dgXJ7")).resumeLowPriorityEvents);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $dgXJ7 = parcelRequire("dgXJ7");


});

parcelRegister("iFjdQ", function(module, exports) {

var $kGrzq = parcelRequire("kGrzq");

const $35e12b3261878eea$export$85aba550a2da4b89 = new (0, $kGrzq.BaseMeasures)();
module.exports["ExperienceActionMeasures"] = $35e12b3261878eea$export$85aba550a2da4b89;

});

parcelRegister("bmTgR", function(module, exports) {

var $04e9M = parcelRequire("04e9M");

parcelRequire("fD5Hh");
var $b9NdB = parcelRequire("b9NdB");
var $15h8H = parcelRequire("15h8H");

parcelRequire("6VfGD");
var $6nGJw = parcelRequire("6nGJw");
var $4PV5A = parcelRequire("4PV5A");
var $a1lfc = parcelRequire("a1lfc");
var $2VpjI = parcelRequire("2VpjI");
var $wLBYY = parcelRequire("wLBYY");
var $eL1ct = parcelRequire("eL1ct");

// Define the desktop bridge client ID
const $7e1979726f59660a$var$DESKTOP_BRIDGE_CLIENT_ID = (0, $b9NdB.client)('desktop-bridge');
const $7e1979726f59660a$export$1e4fed98bcaa1d82 = ()=>{
    return !!$parcel$global?.window?.desktopNativeBridge;
};
const $7e1979726f59660a$export$b21bea20d2d8ffb1 = ()=>{
    if (!$7e1979726f59660a$export$1e4fed98bcaa1d82()) return ()=>{};
    const listenersCleanup = [];
    listenersCleanup.push($parcel$global.window.desktopNativeBridge.onAnalyticsEvent((eventData)=>{
        (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
            if (eventData.type === 'sendTrackEvent' && eventData.data) client.sendTrackEvent(eventData.data);
        }).catch(()=>{});
    }));
    // Rovo Bridge API IPC listener
    if ($parcel$global.window.desktopNativeBridge.onRovoBridgeEvent) listenersCleanup.push($parcel$global.window.desktopNativeBridge.onRovoBridgeEvent((eventData)=>{
        const bridgeAPI = (0, $15h8H.getBrowserBridgeAPI)();
        if (eventData.type === 'ready') bridgeAPI.ready($7e1979726f59660a$var$DESKTOP_BRIDGE_CLIENT_ID);
        else if (eventData.type === 'send' && eventData) {
            if (eventData.data.params) {
                const message = eventData.data.params;
                try {
                    if (message.key === 'aifc-confluence-page-create') {
                        const commandParams = {
                            ...message,
                            senderId: $7e1979726f59660a$var$DESKTOP_BRIDGE_CLIENT_ID,
                            receiverId: (0, $eL1ct.getConfluenceEditorClientId)(message.data.contentId)
                        };
                        bridgeAPI.send((0, $4PV5A.ConfluencePageCreateCommand), commandParams);
                    } else if (message.key === 'aifc-confluence-page-update' || message.key === 'aifc-adf-update') {
                        const commandParams = {
                            ...message,
                            senderId: $7e1979726f59660a$var$DESKTOP_BRIDGE_CLIENT_ID,
                            receiverId: (0, $eL1ct.getConfluenceEditorClientId)(message.data.contentId)
                        };
                        bridgeAPI.send((0, $a1lfc.ConfluenceUpdatePageCommand), commandParams);
                    } else if (message.key === 'aifc-confluence-whiteboard-create') {
                        const commandParams = {
                            ...message,
                            senderId: $7e1979726f59660a$var$DESKTOP_BRIDGE_CLIENT_ID,
                            receiverId: (0, $6nGJw.CONFLUENCE_WHITEBOARD_CLIENT_ID)
                        };
                        bridgeAPI.send((0, $2VpjI.ConfluenceWhiteboardCreateCommand), commandParams);
                    } else if (message.key === 'aifc-confluence-whiteboard-update') {
                        const commandParams = {
                            ...message,
                            senderId: $7e1979726f59660a$var$DESKTOP_BRIDGE_CLIENT_ID,
                            receiverId: (0, $6nGJw.CONFLUENCE_WHITEBOARD_CLIENT_ID)
                        };
                        bridgeAPI.send((0, $wLBYY.ConfluenceWhiteboardUpdateCommand), commandParams);
                    }
                } catch (error) {}
            } else // Fallback to original behavior for non-streaming messages
            bridgeAPI.send(eventData.data.command, eventData.data.params);
        } else if (eventData.type === 'on' && eventData.data) bridgeAPI.on(eventData.data.clientId, eventData.data.command, eventData.data.handler);
        else if (eventData.type === 'off' && eventData.data) bridgeAPI.off(eventData.data.clientId, eventData.data.command);
        else if (eventData.type === 'teardown' && eventData.data) bridgeAPI.teardown(eventData.data.clientId);
    }));
    return ()=>{
        listenersCleanup.forEach((cleanUpFn)=>cleanUpFn());
    };
};
module.exports["isDesktop"] = $7e1979726f59660a$export$1e4fed98bcaa1d82;
module.exports["establishIPCListeners"] = $7e1979726f59660a$export$b21bea20d2d8ffb1;

});

parcelRegister("c0urc", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $5cd029b88ef194e8$export$b2e4b0d02265baf4 = /*#__PURE__*/ function(ReloadType) {
    ReloadType["content"] = "content";
    ReloadType["comment"] = "comment";
    return ReloadType;
}({});
var $5cd029b88ef194e8$export$ec7bbfd8959ab0ea = /*#__PURE__*/ function(ReloadPriority) {
    ReloadPriority[ReloadPriority["immediate"] = 0] = "immediate";
    ReloadPriority[ReloadPriority["normal"] = 1] = "normal";
    ReloadPriority[ReloadPriority["background"] = 2] = "background";
    return ReloadPriority;
}({});
const $5cd029b88ef194e8$var$reloadAll = async (reloaders, contentId, contentIdRef, options)=>{
    // Arrange reloader by priority to ensure that lower priority reloaders are
    // called strictly after higher-priority ones
    const reloadersByPriority = Object.keys(reloaders).reduce((res, key)=>{
        const reloader = reloaders[key];
        const priority = Number(reloader.priority || 0);
        if (res[priority]) res[priority].push(reloader);
        else res[priority] = [
            reloader
        ];
        return res;
    }, []);
    // Call reloaders according to their priorities
    for (const reloaders of reloadersByPriority){
        // It is possible that by the time the execution flow reached this point,
        // user may have already transitioned to another `contentId`,
        // and in such case some reloaders may contain closures to stale/unmounted components.
        // Comparing `contentIdRef` (which contains up-to-date value)
        // with `contentId` (which is dated the same as `reloaders`) allows to detect such cases.
        const isOriginalContentId = contentIdRef.current === contentId;
        if (reloaders && isOriginalContentId) {
            const reloaderPromises = reloaders.map((reloader)=>reloader.reload(options));
            await Promise.all(reloaderPromises);
        }
    }
};
const $5cd029b88ef194e8$export$813f95dc8c45078c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    registerReloader: ()=>{},
    unregisterReloader: ()=>{},
    reloaders: {
        ["content"]: async ()=>{},
        ["comment"]: async ()=>{}
    }
});
const $5cd029b88ef194e8$export$b159bb10e675c5ff = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, children: children })=>{
    const contentIdRef = (0, $42omo.useRef)(contentId);
    const isUnmountedRef = (0, $42omo.useRef)(false);
    const [contentReloader, setContentReloader] = (0, $42omo.useState)({});
    const [commentReloader, setCommentReloader] = (0, $42omo.useState)({});
    (0, $42omo.useLayoutEffect)(()=>{
        // Due to having empty dependency array the `cleanup` function will be called
        // when component unmounts.
        return ()=>{
            isUnmountedRef.current = true;
        };
    }, []);
    (0, $42omo.useLayoutEffect)(()=>{
        contentIdRef.current = contentId;
        // When contentId changes all reloaders have to be cleaned up, so new page
        // can register their own reloaders.
        // NOTE that reloaders are cleaned up not in the effect but in a `cleanup`
        // function that effect returns.
        return ()=>{
            if (!isUnmountedRef.current) {
                setContentReloader({});
                setCommentReloader({});
            }
        };
    }, [
        contentId
    ]);
    /**
		 * Handles common logic for registering and unregistering reloaders.
		 *
		 * @param {QuickReloaderType} reloader - The reloader object containing
		 * information about the reloader function to be registered or unregistered,
		 * including its name, types, and reloading logic.
		 * @param {(setReloader: (prevState: (prevState: ReloaderStateType) => ReloaderStateType) => void) => void} callback - A callback function that takes
		 * the setReloader function as an argument and performs the necessary logic for
		 * registering or unregistering the given reloader within the context provider.
		 * The setReloader function is used to update the state of either contentReloader
		 * or commentReloader, depending on the reloader's type.
		 */ const handleReloader = (reloader, callback)=>{
        reloader.types.forEach((type)=>{
            const setReloader = type === "comment" ? setCommentReloader : setContentReloader;
            callback(setReloader);
        });
    };
    // Allows to register multiple reload functions for specific type of data to reload.
    // For example, to reload content you need to refetch Content and ViewPageSwitcher
    // queries and possibly run some other functions, if needed.
    const registerReloader = (0, $42omo.useCallback)((reloader)=>{
        handleReloader(reloader, (setReloader)=>{
            setReloader((reloaders)=>({
                    ...reloaders,
                    [reloader.name]: reloader
                }));
        });
    }, []);
    const unregisterReloader = (0, $42omo.useCallback)((reloader)=>{
        handleReloader(reloader, (setReloader)=>{
            setReloader((reloaders)=>{
                const { [reloader.name]: _removedReloader, ...newReloaders } = reloaders;
                return newReloaders;
            });
        });
    }, []);
    // Create the context for all the reloaders
    const context = (0, $42omo.useMemo)(()=>({
            contentId: contentId,
            registerReloader: registerReloader,
            unregisterReloader: unregisterReloader,
            reloaders: {
                ["content"]: (options)=>$5cd029b88ef194e8$var$reloadAll(contentReloader, contentId, contentIdRef, options),
                ["comment"]: (options)=>$5cd029b88ef194e8$var$reloadAll(commentReloader, contentId, contentIdRef, options)
            }
        }), [
        contentId,
        registerReloader,
        unregisterReloader,
        contentReloader,
        commentReloader
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cd029b88ef194e8$export$813f95dc8c45078c.Provider, {
        value: context
    }, children);
});
module.exports["ReloadType"] = $5cd029b88ef194e8$export$b2e4b0d02265baf4;
module.exports["ReloadPriority"] = $5cd029b88ef194e8$export$ec7bbfd8959ab0ea;
module.exports["QuickReloadContext"] = $5cd029b88ef194e8$export$813f95dc8c45078c;
module.exports["QuickReloadContextProvider"] = $5cd029b88ef194e8$export$b159bb10e675c5ff;

});

parcelRegister("7J5Uc", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");


var $bRwDd = parcelRequire("bRwDd");


var $5yVAS = parcelRequire("5yVAS");


var $iZdrT = parcelRequire("iZdrT");


var $58u2L = parcelRequire("58u2L");


var $hxeND = parcelRequire("hxeND");


var $04e9M = parcelRequire("04e9M");


var $1NBp8 = parcelRequire("1NBp8");


var $l7ck4 = parcelRequire("l7ck4");


var $fzfTC = parcelRequire("fzfTC");

const $84c4a68da1697f73$var$initialState = {
    isInitialized: false,
    theme: (0, $58u2L.getDefaultTheme)()
};
const $84c4a68da1697f73$export$bf1195c0a25965df = {
    applyTheme: (theme)=>async ()=>{
            await (0, $iZdrT.applyTheme)(theme);
            const client = await (0, $04e9M.getAnalyticsWebClient)();
            client.appendUIViewedAttributes({
                theme: theme,
                // OStheme may become stale until the session is restarted since the user can
                //      change their system/browser settings at any time without manually changing their theme in the app.
                OStheme: (0, $5yVAS.getSystemPreferredColorScheme)()
            });
        },
    initializeTheme: (initialTheme)=>async ({ setState: setState, dispatch: dispatch })=>{
            if (!initialTheme) {
                // Get local theme first to help render theme faster than waiting to fetch latest preference from remote
                const persistedLocalTheme = (0, $fzfTC.ThemeAPI).getSavedThemeLocal();
                if (persistedLocalTheme) dispatch($84c4a68da1697f73$export$bf1195c0a25965df.applyTheme((0, $hxeND.buildThemeFromState)(persistedLocalTheme)));
            }
            (0, $bRwDd.addIframeThemingSupport)();
            const theme = initialTheme || await (0, $fzfTC.ThemeAPI).getSavedTheme();
            // Check if it's the PDF export route and force light mode if it is
            const isPdfExport = (0, $1NBp8.PDF_EXPORT_PAGE).match(window.location.pathname);
            if (isPdfExport) theme.colorMode = 'light';
            const effectiveTheme = (0, $hxeND.buildThemeFromState)(theme);
            setState({
                isInitialized: true,
                theme: effectiveTheme
            });
            await dispatch($84c4a68da1697f73$export$bf1195c0a25965df.applyTheme(effectiveTheme));
        },
    setColorModePreference: (themeColorMode)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const theme = {
                ...getState().theme,
                colorMode: themeColorMode
            };
            try {
                setState({
                    ...getState(),
                    theme: theme
                });
                await Promise.all([
                    dispatch($84c4a68da1697f73$export$bf1195c0a25965df.applyTheme(theme)),
                    (0, $fzfTC.ThemeAPI).saveTheme(theme)
                ]);
            } catch (e) {
                const attributes = {
                    message: e.message,
                    stack: e.stack
                };
                await (0, $l7ck4.reportThemingError)((0, $l7ck4.ErrorSubjects).useThemingState, (0, $l7ck4.ErrorSubjectIds).setColorMode, attributes);
            }
        },
    restoreThemePreference: ()=>async ({ dispatch: dispatch, getState: getState })=>{
            const { theme: theme } = getState();
            await dispatch($84c4a68da1697f73$export$bf1195c0a25965df.applyTheme(theme));
        }
};
const $84c4a68da1697f73$var$Store = (0, $1P1Tu.createStore)({
    initialState: $84c4a68da1697f73$var$initialState,
    actions: $84c4a68da1697f73$export$bf1195c0a25965df,
    name: 'themingState'
});
const $84c4a68da1697f73$export$338c28a47b6eab8 = (0, $FOT9i.createContainer)($84c4a68da1697f73$var$Store, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialTheme: initialTheme })=>{
            dispatch($84c4a68da1697f73$export$bf1195c0a25965df.initializeTheme(initialTheme));
        }
});
const $84c4a68da1697f73$export$effd3de03784e6fe = (0, $9zUhf.createHook)($84c4a68da1697f73$var$Store);
const $84c4a68da1697f73$export$f33beb6f493a54ff = (0, $9zUhf.createActionsHook)($84c4a68da1697f73$var$Store);
module.exports["useThemingState"] = $84c4a68da1697f73$export$effd3de03784e6fe;
module.exports["useThemingActions"] = $84c4a68da1697f73$export$f33beb6f493a54ff;

});

parcelRegister("bRwDd", function(module, exports) {

var $8z9j5 = parcelRequire("8z9j5");

var $hY0xh = parcelRequire("hY0xh");

var $geGFh = parcelRequire("geGFh");

var $60yhz = parcelRequire("60yhz");

const $d731e5061d622ebc$var$buildStyleElements = async (activeTheme)=>{
    return (await (0, $geGFh.default)(activeTheme)).map((theme)=>{
        const styleElement = document.createElement('style');
        styleElement.innerHTML = theme.css;
        Object.entries(theme.attrs).forEach(([key, value])=>styleElement.setAttribute(key, value));
        return styleElement;
    });
};
// Can be invoked from iframes that have access to the parent window and allows for theme information to be passed into the iframe
const $d731e5061d622ebc$var$initializeIframeTheming = async (onThemeUpdated)=>{
    const activeTheme = (0, $8z9j5.default)();
    const observer = new (0, $60yhz.default)(async (newTheme)=>{
        onThemeUpdated({
            themeHtmlAttrs: (0, $hY0xh.default)(newTheme),
            styleElements: await $d731e5061d622ebc$var$buildStyleElements(newTheme)
        });
    });
    observer.observe();
    const onIframeClose = ()=>observer.disconnect();
    return {
        themeHtmlAttrs: (0, $hY0xh.default)(activeTheme),
        styleElements: await $d731e5061d622ebc$var$buildStyleElements(activeTheme),
        onIframeClose: onIframeClose
    };
};
const $d731e5061d622ebc$export$377bd665ab309e4c = (onThemeUpdated)=>{
    if (window.parent.initializeIframeTheming) window.parent.initializeIframeTheming(onThemeUpdated).then((iframeThemeInitInfo)=>{
        onThemeUpdated(iframeThemeInitInfo);
        // Remove listener to prevent memory leaks
        window.addEventListener('beforeunload', iframeThemeInitInfo.onIframeClose);
    });
};
const $d731e5061d622ebc$export$99897b9fec3a0556 = (iframeThemeInfo, doc)=>{
    // Add HTMl attributes which trigger styles to take effect
    Object.entries(iframeThemeInfo.themeHtmlAttrs).forEach(([key, value])=>doc.documentElement.setAttribute(key, value));
    // Add theming stylesheet(s) into page
    iframeThemeInfo.styleElements.forEach((styleElement)=>{
        const existingStyleElement = doc.head.querySelector(`style[data-theme="${styleElement.getAttribute('data-theme')}"]`);
        if (!existingStyleElement) // Prevent re-inserting the same style element into the DOM repeatedly
        doc.head.appendChild(styleElement);
    });
};
const $d731e5061d622ebc$export$aba0049abf5d5b9a = ()=>{
    window.initializeIframeTheming = $d731e5061d622ebc$var$initializeIframeTheming;
};
module.exports["setupThemeInsideIframe"] = $d731e5061d622ebc$export$377bd665ab309e4c;
module.exports["applyThemeInsideIframe"] = $d731e5061d622ebc$export$99897b9fec3a0556;
module.exports["addIframeThemingSupport"] = $d731e5061d622ebc$export$aba0049abf5d5b9a;

});

parcelRegister("5yVAS", function(module, exports) {
const $e3e99e727739913b$var$darkModeMediaQuery = '(prefers-color-scheme: dark)';
const $e3e99e727739913b$export$fd83dd01b496ad39 = ()=>{
    const isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
    const darkModeMql = isMatchMediaAvailable && window.matchMedia($e3e99e727739913b$var$darkModeMediaQuery);
    return darkModeMql && darkModeMql.matches ? 'dark' : 'light';
};
module.exports["getSystemPreferredColorScheme"] = $e3e99e727739913b$export$fd83dd01b496ad39;

});

parcelRegister("iZdrT", function(module, exports) {

var $bRSdj = parcelRequire("bRSdj");

const $9f527f233178b863$export$49e16ec648d05eb2 = async (theme)=>{
    await (0, $bRSdj.default)(theme);
};
module.exports["applyTheme"] = $9f527f233178b863$export$49e16ec648d05eb2;

});

parcelRegister("fzfTC", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $lesra = parcelRequire("lesra");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");




class $1004ef7739cc518e$export$5294efe0574a1e18 {
    static getThemeLocal() {
        const persistedLocalTheme = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_USER_THEME_PREFERENCE);
        return (0, $lesra.getEffectiveThemeState)(persistedLocalTheme || (0, $lesra.API_DEFAULT_THEME_STATE));
    }
    static saveThemeLocal(theme) {
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_USER_THEME_PREFERENCE, (0, $lesra.getEffectiveThemeStateSerialized)(theme));
    }
    // TODO - FF cleanup - This is only used when the RemoveOriginal FF is NOT enabled.
    // When the FF is enabled, there are no states where there isn't a theme.
    static removeThemeLocal() {
        // setItem is required for server-side local storage as removeItem does not remove server-side values
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_USER_THEME_PREFERENCE, (0, $lesra.API_ORIGINAL_THEME_STATE));
    }
}



var $9wGTI = parcelRequire("9wGTI");


var $hp2SH = parcelRequire("hp2SH");





var $l7ck4 = parcelRequire("l7ck4");


var $eSUdr = parcelRequire("eSUdr");

const $225ceb107f3374df$export$5c26aa61dfa6c7dd = (0, $eSUdr.default)`query ThemePreferenceSelectorQuery{userPreferences{theme}}`;





const $d8b91dac6faab6a9$export$8413d46ad6cb8150 = (0, $eSUdr.default)`mutation ThemePreferenceMutation($theme:String!){updateUserPreferences(userPreferences:{theme:$theme}){theme}}`;



var $j6S25 = parcelRequire("j6S25");
















const $dfa067f559dce27b$export$be88e028417350ed = (0, $eSUdr.default)`query WorkspaceThemePreferenceQuery($workspaceAri:ID!$accountId:ID!){settings_userPreferencesResolved(workspaceAri:$workspaceAri accountId:$accountId){theme}}`;





const $29d58b67aa9fb4c3$export$9574b761b09ab2b8 = (0, $eSUdr.default)`mutation WorkspaceThemePreferenceMutation($workspaceAri:ID!$accountId:ID!$theme:String!){settings_updateUserPreferencesWorkspace(workspaceAri:$workspaceAri accountId:$accountId theme:$theme){theme}}`;


const $4d88fe4ed5dfbc43$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
class $4d88fe4ed5dfbc43$export$e0263efb08e4c06b {
    static async getThemeRemote() {
        const sessionData = await (0, $ge2sX.getSessionData)();
        const { cloudId: cloudId, activationId: activationId, userId: userId } = sessionData;
        if (!userId) return (0, $lesra.getEffectiveThemeState)((0, $lesra.API_DEFAULT_THEME_STATE));
        const workspaceAri = $4d88fe4ed5dfbc43$var$getWorkspaceARI({
            cloudId: cloudId,
            activationId: activationId
        });
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: data, errors: errors } = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $dfa067f559dce27b$export$be88e028417350ed),
            variables: {
                workspaceAri: workspaceAri,
                accountId: userId
            }
        });
        if (errors) throw errors;
        const themeString = data?.settings_userPreferencesResolved?.theme;
        return (0, $lesra.getEffectiveThemeState)(themeString || (0, $lesra.API_DEFAULT_THEME_STATE));
    }
    static async saveThemeRemote(theme) {
        try {
            const sessionData = await (0, $ge2sX.getSessionData)();
            const { cloudId: cloudId, activationId: activationId, userId: userId } = sessionData;
            if (!userId) return;
            const workspaceAri = $4d88fe4ed5dfbc43$var$getWorkspaceARI({
                cloudId: cloudId,
                activationId: activationId
            });
            // Serialize the theme state to a string using Atlaskit's serializer
            const themeSerialized = (0, $j6S25.themeObjectToString)(theme);
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            await (0, $hp2SH.getApolloClient)().mutate({
                mutation: (0, $29d58b67aa9fb4c3$export$9574b761b09ab2b8),
                variables: {
                    workspaceAri: workspaceAri,
                    accountId: userId,
                    theme: themeSerialized
                }
            });
        } catch (e) {
            const attributes = {
                message: e.message,
                stack: e.stack,
                theme: theme
            };
            await (0, $l7ck4.reportThemingError)((0, $l7ck4.ErrorSubjects).remoteThemeStorage, (0, $l7ck4.ErrorSubjectIds).saveThemeRemote, attributes);
        }
    }
}


class $d72d6a2d6dd6a6ab$export$d1c9d31e873127d9 {
    static async getThemeRemote() {
        if ((0, $9wGTI.fg)('shared-user-preferences')) return (0, $4d88fe4ed5dfbc43$export$e0263efb08e4c06b).getThemeRemote();
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: data, errors: errors } = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $225ceb107f3374df$export$5c26aa61dfa6c7dd)
        });
        if (errors) throw errors;
        return (0, $lesra.getEffectiveThemeState)(data.userPreferences.theme);
    }
    static async saveThemeRemote(theme) {
        if ((0, $9wGTI.fg)('shared-user-preferences')) {
            // Convert "default" string to actual theme state before passing to shared implementation
            const themeState = theme === (0, $lesra.API_DEFAULT_THEME_STATE) ? (0, $lesra.getEffectiveThemeState)((0, $lesra.API_DEFAULT_THEME_STATE)) : theme;
            return (0, $4d88fe4ed5dfbc43$export$e0263efb08e4c06b).saveThemeRemote(themeState);
        }
        try {
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            const { errors: errors } = await (0, $hp2SH.getApolloClient)().mutate({
                mutation: (0, $d8b91dac6faab6a9$export$8413d46ad6cb8150),
                variables: {
                    theme: (0, $lesra.getEffectiveThemeStateSerialized)(theme)
                }
            });
            if (errors) {
                const attributes = {
                    errors: errors.map((error)=>({
                            message: error.message,
                            stack: error.stack
                        })),
                    theme: theme
                };
                await (0, $l7ck4.reportThemingError)((0, $l7ck4.ErrorSubjects).remoteThemeStorage, (0, $l7ck4.ErrorSubjectIds).apolloMutationErrors, attributes);
            }
        } catch (e) {
            const attributes = {
                message: e.message,
                stack: e.stack,
                theme: theme
            };
            await (0, $l7ck4.reportThemingError)((0, $l7ck4.ErrorSubjects).remoteThemeStorage, (0, $l7ck4.ErrorSubjectIds).saveThemeRemote, attributes);
        }
    }
}





class $5d98d2226bcd7645$export$4afb38fcac7fd7a6 {
    static async saveTheme(theme) {
        theme.typography = 'typography';
        (0, $1004ef7739cc518e$export$5294efe0574a1e18).saveThemeLocal(theme);
        const { isLoggedIn: isLoggedIn } = await (0, $ge2sX.getSessionData)();
        if (isLoggedIn) await (0, $d72d6a2d6dd6a6ab$export$d1c9d31e873127d9).saveThemeRemote(theme);
    }
    static async getSavedTheme() {
        const persistedLocalTheme = $5d98d2226bcd7645$export$4afb38fcac7fd7a6.getSavedThemeLocal();
        const { isLoggedIn: isLoggedIn } = await (0, $ge2sX.getSessionData)();
        let persistedRemoteTheme = undefined;
        if (isLoggedIn) try {
            persistedRemoteTheme = await (0, $d72d6a2d6dd6a6ab$export$d1c9d31e873127d9).getThemeRemote();
            // Theme from the DB should indicate last preference regardless of browser
            if (!$5d98d2226bcd7645$export$4afb38fcac7fd7a6.localAndRemoteAreEqual(persistedLocalTheme, persistedRemoteTheme)) (0, $1004ef7739cc518e$export$5294efe0574a1e18).saveThemeLocal(persistedRemoteTheme);
        } catch (e) {
            // Fall through to local
            const attributes = {
                message: e.message,
                stack: e.stack,
                persistedRemoteTheme: persistedRemoteTheme,
                persistedLocalTheme: persistedLocalTheme
            };
            await (0, $l7ck4.reportThemingError)((0, $l7ck4.ErrorSubjects).themeAPI, (0, $l7ck4.ErrorSubjectIds).getSavedTheme, attributes);
        }
        const effectiveTheme = persistedRemoteTheme || persistedLocalTheme;
        effectiveTheme.typography = 'typography';
        return effectiveTheme;
    }
    static getSavedThemeLocal() {
        return (0, $1004ef7739cc518e$export$5294efe0574a1e18).getThemeLocal();
    }
    static localAndRemoteAreEqual(local, remote) {
        return (0, $lesra.getEffectiveThemeStateSerialized)(remote) === (0, $lesra.getEffectiveThemeStateSerialized)(local);
    }
}
module.exports["ThemeAPI"] = $5d98d2226bcd7645$export$4afb38fcac7fd7a6;

});

parcelRegister("iyEDi", function(module, exports) {
const $d82aebd029e71988$export$7143d27196c8ece = (state)=>// TODO: https://product-fabric.atlassian.net/browse/BM-429
    // Note: It is not safe to checking the state.router anymore because it is always not null
    // This is a temporary fix to avoid fixing every usage of this function
    !state.isServerRenderedPage && Boolean(state.router);
const $d82aebd029e71988$export$e7fd20fad3cf4b5f = (state)=>!state.isServerRenderedPage && state.router ? state.router.location : {};
const $d82aebd029e71988$export$e2de15bbd9edf9c6 = (state)=>{
    const stateLocation = $d82aebd029e71988$export$e7fd20fad3cf4b5f(state);
    return stateLocation && stateLocation.query ? stateLocation.query : {};
};
const $d82aebd029e71988$export$b9a4691d132f3891 = (state)=>!state.isServerRenderedPage && state.router ? state.router.params || {} : {};
module.exports["routerStateExists"] = $d82aebd029e71988$export$7143d27196c8ece;
module.exports["getLocation"] = $d82aebd029e71988$export$e7fd20fad3cf4b5f;
module.exports["getRouteParams"] = $d82aebd029e71988$export$b9a4691d132f3891;

});

parcelRegister("cZnAz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ead0462393f9d6e0$export$ef343af51345d8b6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "QThCK",
    name: "EditPageLoadingListener",
    loader: async ()=>(await (parcelRequire("3v6jL"))).EditPageLoadingListener
});
module.exports["EditPageLoadingListener"] = $ead0462393f9d6e0$export$ef343af51345d8b6;

});

parcelRegister("3v6jL", function(module, exports) {

let $28c92ae6bf4f8125$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $28c92ae6bf4f8125$var$load("5465r"),
    $28c92ae6bf4f8125$var$load("fkY2m"),
    $28c92ae6bf4f8125$var$load("6MNAi"),
    $28c92ae6bf4f8125$var$load("425pi"),
    $28c92ae6bf4f8125$var$load("cLdBj"),
    $28c92ae6bf4f8125$var$load("43yCy"),
    $28c92ae6bf4f8125$var$load("2lFgQ"),
    $28c92ae6bf4f8125$var$load("4m5MY")
]).then(()=>parcelRequire('j89ZI'));

});

parcelRegister("ggM8l", function(module, exports) {

var $b4Wym = parcelRequire("b4Wym");


var $19fl2 = parcelRequire("19fl2");

const $bd837a4cdefa63be$export$e17af168639dd312 = (state)=>state.discoveredFeatures;
const $bd837a4cdefa63be$export$ef98cff420b6492b = (0, $b4Wym.createSelector)($bd837a4cdefa63be$export$e17af168639dd312, (discoveredPluginFeatures)=>discoveredPluginFeatures.get('hasLoaded'));
const $bd837a4cdefa63be$var$getInputParameter = (state, param)=>param;
const $bd837a4cdefa63be$export$f006967cf667fd76 = (0, $b4Wym.createSelector)($bd837a4cdefa63be$export$e17af168639dd312, $bd837a4cdefa63be$export$ef98cff420b6492b, $bd837a4cdefa63be$var$getInputParameter, (discoveredPluginFeatures, discoveredFeaturesLoaded, { pluginKey: pluginKey = '', featureKey: featureKey = '' } = {})=>!discoveredFeaturesLoaded || (0, $19fl2.hasFeatureBeenDiscovered)(discoveredPluginFeatures.get('list'), {
        pluginKey: pluginKey,
        featureKey: featureKey
    }));
module.exports["haveDiscoveredFeaturesBeenLoaded"] = $bd837a4cdefa63be$export$ef98cff420b6492b;
module.exports["hasFeatureBeenDiscoveredSelector"] = $bd837a4cdefa63be$export$f006967cf667fd76;

});

parcelRegister("ieAat", function(module, exports) {

var $b4Wym = parcelRequire("b4Wym");


var $ggM8l = parcelRequire("ggM8l");

var $gnnzK = parcelRequire("gnnzK");


var $iyEDi = parcelRequire("iyEDi");

const $d46596fddfe2fa00$var$A_SECOND_AGO = new Date(Date.now() - 1000);
const $d46596fddfe2fa00$var$A_YEAR_FROM_NOW = new Date(Date.now() + 3.154e10);
const $d46596fddfe2fa00$var$getSpotlightId = (props)=>props.spotlightId;
const $d46596fddfe2fa00$var$getStartDate = (props)=>props.startDate || $d46596fddfe2fa00$var$A_SECOND_AGO;
const $d46596fddfe2fa00$var$getEndDate = (props)=>props.endDate || $d46596fddfe2fa00$var$A_YEAR_FROM_NOW;
const $d46596fddfe2fa00$var$getDarkFeatureEnabled = (props)=>props.darkFeatureEnabled;
const $d46596fddfe2fa00$var$getDarkFeatureDisabled = (props)=>props.darkFeatureDisabled;
const $d46596fddfe2fa00$var$getIndex = (state)=>state.get('index');
const $d46596fddfe2fa00$var$getLoaded = (state)=>state.get('loaded');
const $d46596fddfe2fa00$var$getFlow = (state)=>state.get('flow');
const $d46596fddfe2fa00$var$getSpotlights = (state)=>state.get('spotlights');
const $d46596fddfe2fa00$export$808b4cfe1b1fa184 = (0, $b4Wym.createSelector)([
    $d46596fddfe2fa00$var$getSpotlights,
    (state, props)=>$d46596fddfe2fa00$var$getSpotlightId(props)
], (spotlights, spotlightId)=>{
    for(let flowIndex = 0; flowIndex < spotlights.size; flowIndex++)for(let spotlightIndex = 0; spotlightIndex < spotlights.get(flowIndex).size; spotlightIndex++){
        if (spotlights.getIn([
            flowIndex,
            spotlightIndex,
            'id'
        ]) === spotlightId) return spotlights.getIn([
            flowIndex,
            spotlightIndex,
            'requested'
        ]);
    }
    return false;
});
const $d46596fddfe2fa00$export$ba6c4d8b172bbf9e = (spotlightId)=>`${spotlightId}.viewed`;
const $d46596fddfe2fa00$export$18d4026d1ea86bb1 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $d46596fddfe2fa00$var$getCurrentFlow = (0, $b4Wym.createSelector)([
    $d46596fddfe2fa00$var$getSpotlights,
    $d46596fddfe2fa00$var$getFlow
], (spotlights, flow)=>spotlights.get(flow));
const $d46596fddfe2fa00$var$getCurrentSpotlight = (0, $b4Wym.createSelector)([
    $d46596fddfe2fa00$var$getCurrentFlow,
    $d46596fddfe2fa00$var$getIndex
], (currentFlow, index)=>currentFlow.get(index));
const $d46596fddfe2fa00$export$c1d7738d965e3481 = (0, $b4Wym.createSelector)([
    $d46596fddfe2fa00$var$getCurrentSpotlight
], (spotlight)=>spotlight ? spotlight.get('attributes').toJSON() : {});
const $d46596fddfe2fa00$export$b5666a506d13f000 = (0, $b4Wym.createSelector)([
    $d46596fddfe2fa00$var$getCurrentFlow
], (currentFlow)=>currentFlow ? currentFlow.map((spotlight)=>spotlight.get('id')).toArray() : []);
const $d46596fddfe2fa00$export$443049729e323335 = (0, $b4Wym.createSelector)([
    $d46596fddfe2fa00$var$getLoaded
], (loaded)=>loaded);
const $d46596fddfe2fa00$export$d1564a5cdee8c52f = (0, $b4Wym.createSelector)([
    $d46596fddfe2fa00$var$getCurrentSpotlight
], (currentSpotlight)=>currentSpotlight ? currentSpotlight.get('id') : null);
const $d46596fddfe2fa00$var$isChangeboardingWithinDateRange = (0, $b4Wym.createSelector)([
    $d46596fddfe2fa00$var$getStartDate,
    $d46596fddfe2fa00$var$getEndDate
], (startDate, endDate)=>{
    const now = Date.now();
    return startDate.getTime() <= now && endDate.getTime() >= now;
});
const $d46596fddfe2fa00$var$hasBeenDiscovered = (state, ownProps)=>{
    const featureKey = $d46596fddfe2fa00$export$ba6c4d8b172bbf9e($d46596fddfe2fa00$var$getSpotlightId(ownProps));
    return (0, $ggM8l.hasFeatureBeenDiscoveredSelector)(state, {
        pluginKey: $d46596fddfe2fa00$export$18d4026d1ea86bb1,
        featureKey: featureKey
    });
};
const $d46596fddfe2fa00$var$getDarkFeatureFulfillment = (0, $b4Wym.createSelector)([
    (state, ownProps)=>{
        const darkFeature = $d46596fddfe2fa00$var$getDarkFeatureEnabled(ownProps);
        return !darkFeature || (0, $gnnzK.isDarkFeatureEnabledSelector)(state, darkFeature);
    },
    (state, ownProps)=>{
        const darkFeature = $d46596fddfe2fa00$var$getDarkFeatureDisabled(ownProps);
        return !darkFeature || !(0, $gnnzK.isDarkFeatureEnabledSelector)(state, darkFeature);
    }
], (enabledOk, disabledOk)=>enabledOk && disabledOk);
const $d46596fddfe2fa00$export$59bfe9c3b3be6bc = (state)=>{
    const { query: query = {}, hash: hash = '' } = (0, $iyEDi.getLocation)(state);
    return hash !== '' || query.preview;
};
const $d46596fddfe2fa00$export$32decc16a9d1b7c4 = (0, $b4Wym.createSelector)([
    (0, $ggM8l.haveDiscoveredFeaturesBeenLoaded),
    $d46596fddfe2fa00$var$hasBeenDiscovered,
    $d46596fddfe2fa00$var$getDarkFeatureFulfillment,
    (state, ownProps)=>$d46596fddfe2fa00$var$isChangeboardingWithinDateRange(ownProps)
], (discoveredFeaturesLoaded, discovered, darkFeaturesFulfilled, withinRange)=>discoveredFeaturesLoaded && !discovered && darkFeaturesFulfilled && withinRange);
const $d46596fddfe2fa00$export$80e7cb43dd9cc8a6 = (0, $b4Wym.createSelector)([
    $d46596fddfe2fa00$export$443049729e323335,
    $d46596fddfe2fa00$var$getIndex
], (total, index)=>{
    const prev = index > 0;
    const next = index + 1 < total;
    const done = !next;
    return {
        prev: prev,
        next: next,
        done: done
    };
});
module.exports["hasSpotlightBeenInvoked"] = $d46596fddfe2fa00$export$808b4cfe1b1fa184;
module.exports["getSpotlightStorageKey"] = $d46596fddfe2fa00$export$ba6c4d8b172bbf9e;
module.exports["pluginKey"] = $d46596fddfe2fa00$export$18d4026d1ea86bb1;
module.exports["getCurrentSpotlightAttributes"] = $d46596fddfe2fa00$export$c1d7738d965e3481;
module.exports["getChangeboardingSpotlightIds"] = $d46596fddfe2fa00$export$b5666a506d13f000;
module.exports["getTotalChangeboardingSpotlights"] = $d46596fddfe2fa00$export$443049729e323335;
module.exports["getCurrentSpotlightId"] = $d46596fddfe2fa00$export$d1564a5cdee8c52f;
module.exports["isChangeboardingUrlBlacklisted"] = $d46596fddfe2fa00$export$59bfe9c3b3be6bc;
module.exports["shouldChangeboardingInstanceRender"] = $d46596fddfe2fa00$export$32decc16a9d1b7c4;
module.exports["getChangeboardingActions"] = $d46596fddfe2fa00$export$80e7cb43dd9cc8a6;

});

parcelRegister("gnnzK", function(module, exports) {

var $b4Wym = parcelRequire("b4Wym");

const $bec114f6471429fc$export$7eb3da172b73083d = (0, $b4Wym.createSelector)((state)=>state.meta, (meta)=>{
    if (!meta) return true;
    return !meta.get('atlassian-account-id');
});
const $bec114f6471429fc$export$a15e774d3d888bb9 = (state)=>state.meta ? state.meta.get('enabled-dark-features', '').split(',') : [];
const $bec114f6471429fc$var$getInputDarkFeature = (state, input)=>input;
const $bec114f6471429fc$export$8c6804d930fb4852 = (0, $b4Wym.createSelector)($bec114f6471429fc$export$a15e774d3d888bb9, $bec114f6471429fc$var$getInputDarkFeature, (enabledDarkFeatures, input)=>enabledDarkFeatures.indexOf(input) > -1 && enabledDarkFeatures.indexOf(`${input}.disable`) === -1);
const $bec114f6471429fc$export$ce5ed99486d97400 = (0, $b4Wym.createSelector)((type)=>type, (type, state)=>state.meta.get('content-type', ''), (type, contentType)=>contentType.toLowerCase() === type.toLowerCase());
module.exports["isDarkFeatureEnabledSelector"] = $bec114f6471429fc$export$8c6804d930fb4852;
module.exports["isContentTypeOf"] = $bec114f6471429fc$export$ce5ed99486d97400;

});

parcelRegister("6pc4Q", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4a9e722311a1cdaa$export$eb3796e87f924aea = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zSTJW",
    name: "ChangeboardingTargetLazyLoader",
    loader: ()=>(parcelRequire("sV1nr"))
});

const $4a9e722311a1cdaa$export$cc62753e1f95cf16 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K3fca",
    name: "ChangeboardingSpotlightLazyLoader",
    loader: ()=>(parcelRequire("31fBI"))
});
module.exports["ChangeboardingTargetLazyLoader"] = $4a9e722311a1cdaa$export$eb3796e87f924aea;
module.exports["ChangeboardingSpotlightLazyLoader"] = $4a9e722311a1cdaa$export$cc62753e1f95cf16;

});

parcelRegister("sV1nr", function(module, exports) {

let $056ed8dd3966d619$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $056ed8dd3966d619$var$load("2GwKS").then(()=>parcelRequire('cTtbu'));

});

parcelRegister("31fBI", function(module, exports) {

let $232d926553e57498$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $232d926553e57498$var$load("jZbup").then(()=>parcelRequire('7STDS'));

});

parcelRegister("iV00x", function(module, exports) {
parcelRequire("kFqI2");
var $2GFTt = parcelRequire("2GFTt");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $6cnUO = parcelRequire("6cnUO");


var $6pc4Q = parcelRequire("6pc4Q");

class $42708fe7d7bfff0c$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    render() {
        const { spotlightId: spotlightId, children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), null, children, !spotlightId ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6pc4Q.ChangeboardingSpotlightLazyLoader), null));
    }
}
$42708fe7d7bfff0c$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).any,
    spotlightId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};



var $ieAat = parcelRequire("ieAat");

const $dc5d8e69dccd2e1f$var$mapStateToProps = (state)=>({
        spotlightId: (0, $ieAat.getCurrentSpotlightId)(state.views.changeboarding)
    });
const $dc5d8e69dccd2e1f$var$ChangeboardingManager = (0, $2GFTt.default)($dc5d8e69dccd2e1f$var$mapStateToProps)((0, $42708fe7d7bfff0c$export$2e2bcd8739ae039));
var $dc5d8e69dccd2e1f$export$2e2bcd8739ae039 = $dc5d8e69dccd2e1f$var$ChangeboardingManager;
module.exports["default"] = $dc5d8e69dccd2e1f$export$2e2bcd8739ae039;

});

parcelRegister("iJELi", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a8580388344cd16b$export$9123996dc48566a9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ugvPP",
    name: "ConnectSupport",
    loader: async ()=>(await (parcelRequire("bJ3XV"))).ConnectSupport
});
module.exports["ConnectSupport"] = $a8580388344cd16b$export$9123996dc48566a9;

});

parcelRegister("bJ3XV", function(module, exports) {

let $8896f921c5731422$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8896f921c5731422$var$load("42QUw"),
    $8896f921c5731422$var$load("58kAD"),
    $8896f921c5731422$var$load("b7Mng"),
    $8896f921c5731422$var$load("cmxKv"),
    $8896f921c5731422$var$load("8m15Y")
]).then(()=>parcelRequire('jsyvA'));

});

parcelRegister("aeSHO", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c711bf2587a9e4e9$export$5dc791f41eb205df = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "XiI1B",
    loader: async ()=>(await (parcelRequire("iiHCU"))).CopySpacePermissionsForLegacyNewSpace,
    name: 'CopySpacePermissionsForLegacyNewSpace'
});
module.exports["CopySpacePermissionsForLegacyNewSpace"] = $c711bf2587a9e4e9$export$5dc791f41eb205df;

});

parcelRegister("iiHCU", function(module, exports) {

let $d52bbfc7b0a4323a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d52bbfc7b0a4323a$var$load("6wr18"),
    $d52bbfc7b0a4323a$var$load("QcHuP"),
    $d52bbfc7b0a4323a$var$load("6XCf4"),
    $d52bbfc7b0a4323a$var$load("5pvpJ"),
    $d52bbfc7b0a4323a$var$load("7EorR"),
    $d52bbfc7b0a4323a$var$load("5fSdR"),
    $d52bbfc7b0a4323a$var$load("1qlDN"),
    $d52bbfc7b0a4323a$var$load("1yVM6"),
    $d52bbfc7b0a4323a$var$load("ffEVr"),
    $d52bbfc7b0a4323a$var$load("hhss7"),
    $d52bbfc7b0a4323a$var$load("fx531")
]).then(()=>parcelRequire('dGO9h'));

});

parcelRegister("joCMa", function(module, exports) {
/* eslint-disable no-restricted-properties */ function $b004eff2eb0be064$export$cef9eeb277f61645() {
    return new Promise((resolve)=>{
        const tryToResolve = (retry)=>{
            if (retry <= 0) return;
            if (window?.legacyMessageQueue?.push) resolve(window.legacyMessageQueue);
            else setTimeout(()=>tryToResolve(retry - 1), 100);
        };
        tryToResolve(50);
    });
}
module.exports["getLegacyMessageQueue"] = $b004eff2eb0be064$export$cef9eeb277f61645;

});

parcelRegister("25MM7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");





var $gmMgo = parcelRequire("gmMgo");


var $aD1SW = parcelRequire("aD1SW");

var $eCEXz = parcelRequire("eCEXz");

var $6uGcC = parcelRequire("6uGcC");


var $cryCi = parcelRequire("cryCi");





var $cvXh8 = parcelRequire("cvXh8");


var $7yDmn = parcelRequire("7yDmn");


var $eXmBZ = parcelRequire("eXmBZ");


var $3sFtD = parcelRequire("3sFtD");


var $ebrpi = parcelRequire("ebrpi");

function $b1c1b600180069b4$var$colorizeIcon(Icon, color, isBold, type) {
    return isBold ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        testId: `flag-${type}`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: color,
        spacing: "spacious",
        testId: `flag-${type}`
    });
}
const $b1c1b600180069b4$export$4fd8d63cb0915eb0 = ({ type: type, isBold: isBold, customIcon: customIcon })=>{
    switch(type){
        case 'success-circle':
            return $b1c1b600180069b4$var$colorizeIcon((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), "var(--ds-icon-success, #22A06B)", isBold, type);
        case 'success':
            return $b1c1b600180069b4$var$colorizeIcon((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), "var(--ds-icon-success, #22A06B)", isBold, type);
        case 'error':
            return $b1c1b600180069b4$var$colorizeIcon((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), "var(--ds-icon-danger, #C9372C)", isBold, type);
        case 'warning':
            return $b1c1b600180069b4$var$colorizeIcon((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), "var(--ds-icon-warning, #E56910)", isBold, type);
        case 'custom':
            return customIcon ?? $b1c1b600180069b4$var$colorizeIcon((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), "var(--ds-icon-information, #1D7AFC)", isBold, 'info');
        case 'info':
        default:
            return $b1c1b600180069b4$var$colorizeIcon((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), "var(--ds-icon-information, #1D7AFC)", isBold, 'info');
    }
};


const $cbc57a64ac2cf4e8$export$355f6c9384246c75 = (0, $gmMgo.default)(class FlagsComponent extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { showFlag: showFlag, applyAJSFlagOverride: applyAJSFlagOverride } = this.props;
        if (showFlag) applyAJSFlagOverride?.(showFlag);
    }
    componentWillUnmount() {
        this.props.removeAJSFlagOverride?.();
    }
    translateActions(actions) {
        const { intl: intl } = this.props;
        return actions.map((action)=>{
            if ('contentKey' in action) {
                const i18nMessage = {
                    id: action.contentKey
                };
                return {
                    ...action,
                    content: intl.formatMessage(i18nMessage)
                };
            }
            return action;
        });
    }
    toFlagProps({ id: id, title: title = '', description: description = '', actions: actions = [], type: type, appearance: appearance, customIcon: customIcon, messageId: messageId, messageType: messageType, onMessageDisposition: onMessageDisposition, delayAnnouncement: delayAnnouncement }) {
        return {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1c1b600180069b4$export$4fd8d63cb0915eb0), {
                type: type,
                isBold: Boolean(appearance),
                customIcon: customIcon
            }),
            appearance: appearance,
            id: id,
            title: title,
            description: description,
            messageId: messageId,
            messageType: messageType,
            onMessageDisposition: onMessageDisposition,
            actions: this.translateActions(actions),
            ...delayAnnouncement && {
                delayAnnouncement: delayAnnouncement
            }
        };
    }
    render() {
        const { flags: flags, areFlagsVisible: areFlagsVisible } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cryCi.Consumer), null, (choreographerAssets)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), {
                onDismissed: this.onDismissed
            }, flags.map((flagDescriptor)=>{
                const FlagComponentType = flagDescriptor.customComponent || (flagDescriptor.close === 'auto' ? choreographerAssets?.AutoDismissFlag ?? (0, $aD1SW.default) : choreographerAssets?.Flag ?? (0, $eCEXz.default));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    "data-test-id": "flag-visibility-wrapper",
                    key: flagDescriptor.id,
                    style: {
                        visibility: areFlagsVisible ? 'visible' : 'hidden'
                    },
                    "aria-hidden": !areFlagsVisible
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FlagComponentType, this.toFlagProps(flagDescriptor)));
            })));
    }
    constructor(...args){
        super(...args);
        this.onDismissed = (flagId)=>{
            const { flags: flags, hideFlag: hideFlag } = this.props;
            flags.forEach((flag)=>{
                if (flag.id === flagId && typeof flag.onClose === 'function') flag.onClose();
            });
            hideFlag?.(flagId);
        };
    }
});


const $c26bad631d03df7b$export$434ba092ed0eee4e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbc57a64ac2cf4e8$export$355f6c9384246c75), {
            flags: flags.state.flags,
            areFlagsVisible: flags.state.areFlagsVisible,
            showFlag: flags.showFlag,
            hideFlag: flags.hideFlag,
            ...props
        }));
module.exports["Flags"] = $c26bad631d03df7b$export$434ba092ed0eee4e;

});

parcelRegister("NAPtM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $joCMa = parcelRequire("joCMa");


var $8hUXc = parcelRequire("8hUXc");


var $3p0JS = parcelRequire("3p0JS");

class $1f88a3fce0610a72$export$1fdbf19afa2e1224 extends (0, $42omo.Component) {
    componentDidMount() {
        (0, $joCMa.getLegacyMessageQueue)().then((legacyMessageQueue)=>{
            legacyMessageQueue.push({
                type: 'ATLASSIAN_CONFLUENCE_VARIABLEINPUT_REGISTER_CALLBACK',
                payload: this.openTemplateVariables
            });
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hUXc.CreateDialogContext).Provider, {
            value: this.getProviderValue(this.state)
        }, this.props.children);
    }
    constructor(props){
        super(props);
        this.openTemplateVariables = ({ templateId: templateId, parentPageId: parentPageId, spaceKey: spaceKey, title: title, contentId: contentId, onContentUpdated: onContentUpdated, onError: onError, beforeUpdateRequest: beforeUpdateRequest, forceTemplatePanelOpen: forceTemplatePanelOpen, openContentInNewTab: openContentInNewTab })=>{
            this.setState({
                templateId: templateId,
                parentPageId: parentPageId,
                spaceKey: spaceKey,
                title: title,
                contentId: contentId,
                onContentUpdated: onContentUpdated,
                onError: onError,
                showTemplateVariableInputDrawer: true,
                beforeUpdateRequest: beforeUpdateRequest,
                forceTemplatePanelOpen: forceTemplatePanelOpen,
                openContentInNewTab: openContentInNewTab
            });
        };
        this.openBlueprintWizard = ({ blueprint: blueprint, parentPageId: parentPageId, spaceKey: spaceKey, templateOriginSpaceKey: templateOriginSpaceKey, title: title, contentId: contentId, onContentUpdated: onContentUpdated, onError: onError, beforeUpdateRequest: beforeUpdateRequest })=>{
            this.setState({
                contentId: contentId,
                blueprint: blueprint,
                parentPageId: parentPageId,
                spaceKey: spaceKey,
                templateOriginSpaceKey: templateOriginSpaceKey,
                onContentUpdated: onContentUpdated,
                onError: onError,
                showBlueprintVariableWizard: true,
                title: title || '',
                beforeUpdateRequest: beforeUpdateRequest
            });
        };
        this.onClose = ()=>{
            this.setState((0, $3p0JS.getDefaultChangeableValues));
        };
        this.getProviderValue = (0, $2XqLN.default)((state)=>({
                ...state,
                openTemplateVariables: this.openTemplateVariables,
                openBlueprintWizard: this.openBlueprintWizard,
                onClose: this.onClose
            }));
        this.state = (0, $3p0JS.getDefaultChangeableValues);
    }
}
module.exports["CreateDialogContextProvider"] = $1f88a3fce0610a72$export$1fdbf19afa2e1224;

});

parcelRegister("iJiK8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a453873b7831bd9f$export$6aea35d848d72744 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "ccV4q",
    name: "Dialogs",
    loader: async ()=>(await (parcelRequire("amvCA"))).Dialogs
});
module.exports["Dialogs"] = $a453873b7831bd9f$export$6aea35d848d72744;

});

parcelRegister("amvCA", function(module, exports) {

let $78b47cd07f62be5c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $78b47cd07f62be5c$var$load("hhss7"),
    $78b47cd07f62be5c$var$load("iiMWZ")
]).then(()=>parcelRequire('8Ugl4'));

});

parcelRegister("itS9i", function(module, exports) {
$parcel$export(module.exports, "debuggerEnabled", () => $87d19dc7160c9951$export$d29204ec4461f93d);
/**
 * Analytics Debugger
 *
 * A micro debugger for the load testing team designed to safely cache View Page's
 * page segment load metrics on the window.
 */ /**
 * Indicates whether debugging analytics-web-client is enabled
 */ let $87d19dc7160c9951$export$d29204ec4461f93d = false;
const $87d19dc7160c9951$export$fa5a3071e40f49f0 = ()=>{
    $87d19dc7160c9951$export$d29204ec4461f93d = true;
};
/**
 * Check the window for the test interface added by the load testing team
 */ const $87d19dc7160c9951$var$getTestInterface = ()=>{
    return !!window.testAnalytics;
};
const $87d19dc7160c9951$export$aca950d042781720 = (segments)=>{
    if ($87d19dc7160c9951$var$getTestInterface()) window.testAnalytics.expectedPageSegments = segments;
};
const $87d19dc7160c9951$export$3bcd87824542df8d = ()=>{
    if ($87d19dc7160c9951$var$getTestInterface()) window.testAnalytics.clear();
};
const $87d19dc7160c9951$export$f80940ef284a6232 = ()=>{
    $87d19dc7160c9951$export$d29204ec4461f93d = false;
};
module.exports["enableAnalyticsDebugger"] = $87d19dc7160c9951$export$fa5a3071e40f49f0;
module.exports["cacheExpectedViewPageSegments"] = $87d19dc7160c9951$export$aca950d042781720;
module.exports["clearAnalyticsDebugger"] = $87d19dc7160c9951$export$3bcd87824542df8d;

});

parcelRegister("cBuRD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $3jwuS = parcelRequire("3jwuS");


var $7zgzO = parcelRequire("7zgzO");


var $7W8i8 = parcelRequire("7W8i8");

const $dbb766fb537d30bb$var$logger = (0, $7W8i8.getLogger)('notifications');
const $dbb766fb537d30bb$export$eac8f819fa93e7ef = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Check for the notification landed query params "atl_p" when loading
    (0, $42omo.useEffect)(()=>{
        const queryParams = getQueryParams();
        const base64NotificationParams = queryParams.atl_p;
        const aiInstrumentationParams = queryParams.atl_aip;
        if ((0, $9wGTI.fg)('cc-notifications-fire-ai-analytics-from-email')) {
            if (aiInstrumentationParams) try {
                const paramsJSONStr = window.atob(aiInstrumentationParams);
                const params = JSON.parse(paramsJSONStr);
                if (params && !params.id) throw new Error('single instrumentation ID field is required to send event');
                else if (params && !params.fn) throw new Error('AI feature name field is required to send event');
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'viewed',
                        actionSubject: 'aiResult',
                        actionSubjectId: 'client',
                        attributes: {
                            singleInstrumentationID: params.id,
                            aiFeatureName: params.fn,
                            proactiveGeneratedAI: 1,
                            userGeneratedAI: 0,
                            isAIFeature: 1,
                            doesNotMeetMAUCriteria: false
                        },
                        source: params.source || 'email'
                    }
                }).fire();
            } catch (e) {
                $dbb766fb537d30bb$var$logger.error`An error occurred attempting to send the AI instrumentation ID: ${e}`;
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'failed',
                        actionSubject: 'aiResultViewedFromEmail',
                        attributes: {
                            error: e?.message || String(e),
                            queryParams: aiInstrumentationParams
                        },
                        source: 'email'
                    }
                }).fire();
            }
        }
        // If we have the query param for the event, send it and clear them
        if (base64NotificationParams) // Its a Base64 encoded JSON string which we need to unpack
        try {
            const paramsJSONStr = window.atob(base64NotificationParams);
            const params = JSON.parse(paramsJSONStr);
            // Ensure we have a "source" field in the param
            if (params && !params.source) throw new Error('source field is required to send event');
            const attributes = Object.assign({
                isLivePage: isLivePage
            }, params);
            delete attributes['source'];
            // COMMENTS-372 Persisting originId for cc-notifications to use
            // @ts-ignore
            window.atlp = {
                originId: params.i
            };
            // Send event
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'landed',
                    actionSubject: 'notification',
                    source: params.source,
                    attributes: attributes
                }
            }).fire();
        } catch (e) {
            $dbb766fb537d30bb$var$logger.error`An error occurred attempting to decode the notifications query params: ${e}`;
            if ((0, $6mKj3.expValEquals)('cc-notifications-track-notif-landed-failures', 'cohort', 'test')) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'notificationLanded',
                    attributes: {
                        error: e?.message || String(e),
                        queryParams: queryParams
                    },
                    source: 'email'
                }
            }).fire();
        }
        // Unset the query params if either atl_p or atl_aip exists
        if (base64NotificationParams || aiInstrumentationParams) setQueryParams({
            ...queryParams,
            atl_aip: undefined,
            atl_p: undefined
        });
    }, [
        getQueryParams,
        createAnalyticsEvent,
        setQueryParams,
        isLivePage
    ]);
    return null;
};
module.exports["NotificationLandedEvent"] = $dbb766fb537d30bb$export$eac8f819fa93e7ef;

});

parcelRegister("3WLLD", function(module, exports) {
const $d6d9f7d104571c4f$export$334a37b7f6b419fe = {
    colorMode: 'auto'
};
module.exports["mobileAppTheme"] = $d6d9f7d104571c4f$export$334a37b7f6b419fe;

});

parcelRegister("iJ8K8", function(module, exports) {

var $42omo = parcelRequire("42omo");

parcelRequire("j1Ss3");
var $xQxzY = parcelRequire("xQxzY");


var $4xcIM = parcelRequire("4xcIM");


var $2XqLN = parcelRequire("2XqLN");


var $a4TK8 = parcelRequire("a4TK8");


var $c0urc = parcelRequire("c0urc");


var $ep3mz = parcelRequire("ep3mz");


var $jLw6A = parcelRequire("jLw6A");


var $67Foi = parcelRequire("67Foi");


var $jmjWc = parcelRequire("jmjWc");


const $7b6fe42174969fad$export$e67af8512f9fa98a = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "rmoas",
    name: "PremiumAdminEvent",
    loader: async ()=>(await (parcelRequire("2PPDH"))).PremiumAdminEvent
});






const $1f29a03528b9a31f$export$e1028d6b86a91d21 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "LZD7m",
    name: "PremiumOnboarding",
    loader: async ()=>(await (parcelRequire("1LXbn"))).PremiumOnboarding
});






const $d44920250c4aaff7$export$6c880503785d1ff0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "-vbtB",
    name: "CreateContentLegacyQueryParamRedirect",
    loader: async ()=>(await (parcelRequire("5UfRt"))).CreateContentLegacyQueryParamRedirect
});






const $1bb3d0bdc2835241$export$b04f2418ece85f67 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "J1znW",
    name: "CreateContentDataPreloader",
    loader: async ()=>(await (parcelRequire("9vq8F"))).CreateContentDataPreloader
});



var $1NBp8 = parcelRequire("1NBp8");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $cZnAz = parcelRequire("cZnAz");





var $dPJCf = parcelRequire("dPJCf");

const $8563a48fc5b2cd04$var$useSearchIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('search_id');
const $8563a48fc5b2cd04$var$useAdditionalAnalyticsQueryParam = (0, $dPJCf.createSingleQueryParamHook)('additional_analytics');
const $8563a48fc5b2cd04$export$84140e809b1e895a = ({ spaceKey: spaceKey, contentId: contentId })=>{
    const searchSessionCache = (0, $42omo.useRef)(null);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const search_id = $8563a48fc5b2cd04$var$useSearchIdQueryParam() || null;
    const additional_analytics = $8563a48fc5b2cd04$var$useAdditionalAnalyticsQueryParam() || null;
    const isCacheStale = searchSessionCache.current == null || searchSessionCache.current.spaceKey != spaceKey || searchSessionCache.current.contentId != contentId || searchSessionCache.current.additionalAnalyticsToParse != additional_analytics && additional_analytics != null || searchSessionCache.current.searchSessionId != search_id && search_id != null;
    // Cache the searchSessionId/additionalAnalytics because it will be stripped from the query string
    (0, $42omo.useEffect)(()=>{
        if (isCacheStale) searchSessionCache.current = {
            spaceKey: spaceKey,
            contentId: contentId,
            searchSessionId: search_id,
            additionalAnalyticsToParse: additional_analytics
        };
    }, [
        isCacheStale,
        spaceKey,
        contentId,
        search_id,
        additional_analytics
    ]);
    // Strip query param
    (0, $42omo.useEffect)(()=>{
        if (search_id) setQueryParams({
            search_id: null
        }, true);
        if (additional_analytics) setQueryParams({
            additional_analytics: null
        }, true);
    });
    let searchSessionId = search_id;
    let additionalAnalyticsToParse = additional_analytics;
    if (!search_id && !isCacheStale && searchSessionCache.current != null) searchSessionId = searchSessionCache.current.searchSessionId;
    if (!additional_analytics && !isCacheStale && searchSessionCache.current != null) additionalAnalyticsToParse = searchSessionCache.current.additionalAnalyticsToParse;
    return {
        searchSessionId: searchSessionId,
        additionalAnalyticsToParse: additionalAnalyticsToParse
    };
};



var $hl1Kw = parcelRequire("hl1Kw");


var $9wGTI = parcelRequire("9wGTI");


var $5jrGM = parcelRequire("5jrGM");

/**
 * @graphql cc
 */ 



var $eSUdr = parcelRequire("eSUdr");


var $1KmJq = parcelRequire("1KmJq");


var $bQm3c = parcelRequire("bQm3c");


var $gTyTP = parcelRequire("gTyTP");


var $1ytiN = parcelRequire("1ytiN");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");




const $3f19135f9449fadc$var$InitModernizationGaMutation = (0, $eSUdr.default)`mutation InitModernizationGaMutation($cloudId:ID!){confluence_experimentInitModernize(cloudId:$cloudId){success}}`;
const $3f19135f9449fadc$export$92d36ae965196589 = ()=>{
    const [isInitialized, setIsInitialized] = (0, $42omo.useState)(false);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [initModernizationGaMutation] = (0, $1KmJq.useMutation)($3f19135f9449fadc$var$InitModernizationGaMutation, {
        variables: {
            cloudId: cloudId
        }
    });
    // Two keys so that those who were initialized during the control group of the 50/50 experiment
    // are not blocked from initializing modernization ga post experiment should they now be eligible
    const hasInitializedModernizationGa = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $9wGTI.fg)('modernize_ga_exp_post_rollout') ? (0, $1UApO.keys).LIVE_DOCS_HAS_INIT_MODERNIZE_POST_EXP : (0, $1UApO.keys).LIVE_DOCS_HAS_INIT_MODERNIZE);
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { experimentFeatures: experimentFeatures, loading: isSPAViewContextLoading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    (0, $42omo.useEffect)(()=>{
        if (isInitialized || hasInitializedModernizationGa || isLivePagesFeatureEnabled || isSPAViewContextLoading || !experimentFeatures) return;
        try {
            const modernizationGaTraitValue = JSON.parse(experimentFeatures)?.[0, $gTyTP.LIVE_DOC_GA_EXP_TRAIT_NAME];
            if (// modernization trait is not set
            modernizationGaTraitValue === 'null' || !modernizationGaTraitValue || // modernization trait is set to control and the post exp rollout fg is on
            // this allows tenants who were in the control group during the experiment to now have access to modernization features post 50/50 experiment
            modernizationGaTraitValue === (0, $gTyTP.LIVE_DOC_GA_EXP_CONTROL_GROUP_VALUE) && (0, $9wGTI.fg)('modernize_ga_exp_post_rollout')) {
                setIsInitialized(true);
                initModernizationGaMutation().then(({ data: data })=>{
                    data?.confluence_experimentInitModernize?.success && (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $9wGTI.fg)('modernize_ga_exp_post_rollout') ? (0, $1UApO.keys).LIVE_DOCS_HAS_INIT_MODERNIZE_POST_EXP : (0, $1UApO.keys).LIVE_DOCS_HAS_INIT_MODERNIZE, 'true');
                });
            }
        } catch (e) {
        // do nothing
        }
    }, [
        isInitialized,
        hasInitializedModernizationGa,
        isLivePagesFeatureEnabled,
        isSPAViewContextLoading,
        experimentFeatures,
        initModernizationGaMutation
    ]);
    return null;
};


/**
 * @graphql cc
 */ 






var $308Wd = parcelRequire("308Wd");
















const $5ba4cb2d64af54e3$export$d9173af15699f4df = 'confluence_aifc';
const $5ba4cb2d64af54e3$export$1d52a4c2f001b02d = ()=>{
    const [isInitialized, setIsInitialized] = (0, $42omo.useState)(false);
    const { cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    const [initAiFirstCreationExpMutation] = (0, $308Wd.useMutationInterop)(// @ts-expect-error -- http://go/cfe-use-relay-artifacts
    (0, $eSUdr.default)`mutation InitAiFirstCreationExpMutation($cloudId:ID!){confluence_experimentInitAiFirstCreation(cloudId:$cloudId){success}}`, {
        variables: {
            cloudId: cloudId
        }
    });
    const { experimentFeatures: experimentFeatures, loading: isSPAViewContextLoading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const hasInitializedAiFirstCreationExp = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).HAS_INIT_AIFC_EXP);
    (0, $42omo.useEffect)(()=>{
        if (isInitialized || hasInitializedAiFirstCreationExp || isSPAViewContextLoading || !experimentFeatures || !isAdminHubAIEnabled || !isRovoEnabled || !(0, $9wGTI.fg)('cc_aifc_exp_gate')) return;
        try {
            const aifcExpTraitValue = JSON.parse(experimentFeatures)?.[$5ba4cb2d64af54e3$export$d9173af15699f4df];
            if (// aifc experiment trait is not set
            aifcExpTraitValue === 'null' || !aifcExpTraitValue) {
                setIsInitialized(true);
                initAiFirstCreationExpMutation().then(({ data: data })=>{
                    if (data?.confluence_experimentInitAiFirstCreation?.success) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).HAS_INIT_AIFC_EXP, 'true');
                });
            }
        } catch (e) {
        // do nothing
        }
    }, [
        isInitialized,
        isAdminHubAIEnabled,
        isSPAViewContextLoading,
        experimentFeatures,
        initAiFirstCreationExpMutation,
        hasInitializedAiFirstCreationExp,
        isRovoEnabled
    ]);
    return null;
};


const $da2336279c92527f$export$65b723bb995d4fb6 = Symbol('overview');
const $da2336279c92527f$var$newRefIfChanged = (0, $2XqLN.default)((obj)=>({
        ...obj
    }), (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
function $da2336279c92527f$export$a98515d67472a41f({ screenEvent: screenEvent, pageState: pageState = {}, showPremiumOnboarding: showPremiumOnboarding = true, children: children }) {
    const pageStateValues = {
        // setState does a shallow merge this will cause transition to read stale data
        ...(0, $ep3mz.initialPageState),
        // Making a new copy is important here because isEqual will bail if it is a same reference.
        // If we update pageState directly here it will be the same reference when fetchSpaceHomePage comes back.
        // newRefIfChanged won't pick the change up to create a new copy of page state thus not triggering the re-render of children.
        ...pageState
    };
    const missingContentId = !pageStateValues.contentId || pageStateValues.contentId === $da2336279c92527f$export$65b723bb995d4fb6;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const skipQuery = !(pageStateValues.spaceKey && missingContentId);
    const { data: screenQueryData, loading: screenQueryLoading } = (0, $xQxzY.useQuery)((0, $5jrGM.ScreenQuery), {
        variables: {
            spaceKey: pageStateValues.spaceKey
        },
        skip: skipQuery
    });
    if (missingContentId) {
        if (screenQueryData && !screenQueryLoading) {
            pageStateValues.contentId = screenQueryData?.space?.homepage?.id;
            pageStateValues.contentIdLoading = false;
        } else {
            pageStateValues.contentId = undefined;
            pageStateValues.contentIdLoading = true;
        }
    }
    const isCreateContentRoute = pageStateValues.routeName === (0, $1NBp8.CREATE_CONTENT).name;
    if (// If query was skipped means we can never resolve the content id. Most likely there is no space key
    skipQuery || // create flow does not require contentId so set this value to false
    // to prevent issue of blank white screen when redirected to viewing a content on its route
    isCreateContentRoute) pageStateValues.contentIdLoading = false;
    const { searchSessionId: searchSessionId, additionalAnalyticsToParse: additionalAnalyticsToParse } = (0, $8563a48fc5b2cd04$export$84140e809b1e895a)({
        spaceKey: pageStateValues.spaceKey,
        contentId: pageStateValues.contentId
    });
    //this captures if any page is inside a space when viewed, for the purpose of tracking space usage
    if (screenEvent && pageStateValues.spaceKey) {
        let { attributes: attributes } = screenEvent;
        if (attributes == null || typeof attributes !== 'object') screenEvent.attributes = attributes = {};
        // Allow the `Screen` consumer the final say. For example, Company Hub
        // hides its space from the user, doesn't refer to its page as such, is
        // rather presented to the user as "a new surface", and thus doesn't
        // constitute space usage from the perspective of the user.
        if (attributes.screenIsInSpace == null) attributes.screenIsInSpace = true;
    }
    // Skip create content-related components on EXTERNAL_SHARE and ONBOARDING routes (the latter behind a feature flag)
    // to avoid premature requests and caching issues during onboarding.
    const shouldSkipCreateContentExtras = pageStateValues.routeName === (0, $1NBp8.EXTERNAL_SHARE).name || pageStateValues.routeName === (0, $1NBp8.ONBOARDING).name;
    const extra = [
        ...(0, $9wGTI.fg)('modernize_ga_exp_gate') ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3f19135f9449fadc$export$92d36ae965196589), {
                key: "InitModernizationGa"
            })
        ] : [],
        ...(0, $9wGTI.fg)('cc_aifc_exp_gate') ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ba4cb2d64af54e3$export$1d52a4c2f001b02d), {
                key: "InitAiFirstCreationExp"
            })
        ] : [],
        screenEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
            name: screenEvent.name,
            id: screenEvent.id || 'none',
            attributes: screenEvent.attributes,
            key: "screen"
        }),
        ...shouldSkipCreateContentExtras ? [] : [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                key: "missionControlBoundary",
                attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7b6fe42174969fad$export$e67af8512f9fa98a), {
                key: "premiumAdmin"
            }), showPremiumOnboarding && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1f29a03528b9a31f$export$e1028d6b86a91d21), {
                key: "premiumOnboarding"
            })),
            // CreateContentLegacyQueryParamRedirect & CreateContentDataPreloader are using PageState, it needs to be placed here.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d44920250c4aaff7$export$6c880503785d1ff0), {
                key: "CreateContentLegacyQueryParamRedirect"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1bb3d0bdc2835241$export$b04f2418ece85f67), {
                key: "CreateContentDataPreloader"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cZnAz.EditPageLoadingListener), {
                key: "editPageLoadingListener"
            })
        ]
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ep3mz.PageStateContainer), $da2336279c92527f$var$newRefIfChanged(pageStateValues), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hl1Kw.SearchSessionStateContainer), {
        searchSessionId: searchSessionId,
        additionalAnalyticsToParse: additionalAnalyticsToParse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c0urc.QuickReloadContextProvider), {
        contentId: pageStateValues.contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jLw6A.PageRestrictionsContextProvider), {
        contentId: pageStateValues.contentId
    }, extra.concat(children)))));
}
$da2336279c92527f$export$a98515d67472a41f.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).any.isRequired,
    /**
	 * If provided, will send a "screen" analytics event.
	 */ screenEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        attributes: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
        objectType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        objectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
    }).isRequired,
    /**
	 * If provided, will be used as PageState.
	 */ pageState: (0, $ep3mz.pageStateShape),
    /**
	 * If false, the Premium onboarding flow is not rendered
	 * For now, this will be false on the editor routes to not intrude
	 * in the user's editing experience.
	 */ showPremiumOnboarding: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
module.exports["SPACE_OVERVIEW"] = $da2336279c92527f$export$65b723bb995d4fb6;
module.exports["Screen"] = $da2336279c92527f$export$a98515d67472a41f;

});

parcelRegister("2PPDH", function(module, exports) {

let $210866abaf8160f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $210866abaf8160f4$var$load("8mbeF").then(()=>parcelRequire('8fA1P'));

});

parcelRegister("1LXbn", function(module, exports) {

let $14a8169fd7e4ade1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $14a8169fd7e4ade1$var$load("6wr18"),
    $14a8169fd7e4ade1$var$load("2OWSd"),
    $14a8169fd7e4ade1$var$load("j4CTh"),
    $14a8169fd7e4ade1$var$load("8UKe0"),
    $14a8169fd7e4ade1$var$load("Wowvf"),
    $14a8169fd7e4ade1$var$load("5CaYW"),
    $14a8169fd7e4ade1$var$load("ffEVr"),
    $14a8169fd7e4ade1$var$load("hhss7"),
    $14a8169fd7e4ade1$var$load("5o49p")
]).then(()=>parcelRequire('2iFkw'));

});

parcelRegister("5UfRt", function(module, exports) {

let $44ce7c7293c086a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44ce7c7293c086a5$var$load("73mUw").then(()=>parcelRequire('g1Gaf'));

});

parcelRegister("9vq8F", function(module, exports) {

let $6ebb48e728212a85$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6ebb48e728212a85$var$load("aDV08").then(()=>parcelRequire('ef32u'));

});

parcelRegister("4l6Wo", function(module, exports) {
//Product View IDs
const $98ff507ce6a2362a$export$823dfce5c2bceecb = 'product/home';
const $98ff507ce6a2362a$export$6ff1c5d96830f745 = 'product/addons';
const $98ff507ce6a2362a$export$b8c5fd47fee73aae = 'container/home';
const $98ff507ce6a2362a$export$4b542de2568592b5 = 'container/home/loading';
const $98ff507ce6a2362a$export$1237a23d18648140 = 'container/blog';
const $98ff507ce6a2362a$export$245a96a4a566e845 = 'container/pdf-export';
const $98ff507ce6a2362a$export$c3f826fbea17177 = 'container/admin/home';
const $98ff507ce6a2362a$export$e1cac4d5c92cf74b = 'container/admin/company-hub';
const $98ff507ce6a2362a$export$a9aa544aabcc3ca1 = 'admin/home';
module.exports["PRODUCT_HOME_ID"] = $98ff507ce6a2362a$export$823dfce5c2bceecb;
module.exports["PRODUCT_ADDONS_ID"] = $98ff507ce6a2362a$export$6ff1c5d96830f745;
module.exports["CONTAINER_HOME_ID"] = $98ff507ce6a2362a$export$b8c5fd47fee73aae;
module.exports["CONTAINER_HOME_LOADING_ID"] = $98ff507ce6a2362a$export$4b542de2568592b5;
module.exports["CONTAINER_BLOG_ID"] = $98ff507ce6a2362a$export$1237a23d18648140;
module.exports["CONTAINER_ADMIN_HOME_ID"] = $98ff507ce6a2362a$export$c3f826fbea17177;
module.exports["COMPANY_HUB_SETTINGS_ID"] = $98ff507ce6a2362a$export$e1cac4d5c92cf74b;
module.exports["ADMIN_HOME_ID"] = $98ff507ce6a2362a$export$a9aa544aabcc3ca1;

});

parcelRegister("feuG2", function(module, exports) {
$parcel$export(module.exports, "SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE", () => (parcelRequire("5PeCy")).SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


var $5PeCy = parcelRequire("5PeCy");


const $b00cf28e8f13375f$export$9e3c60dd96fa2f8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "uLHEX",
    loader: async ()=>(await (parcelRequire("94oFa"))).SpaceSettingsNavigationPortal,
    name: 'SpaceSettingsNavigationPortal'
});

const $b00cf28e8f13375f$export$ce72f5360cf6ed0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Qp6ij",
    loader: async ()=>(await (parcelRequire("3LzHP"))).SpaceSettingsSidebarLinks,
    name: 'SpaceSettingsSidebarLinks'
});

const $b00cf28e8f13375f$export$80a4abaa5ce40322 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3t1oo",
    loader: async ()=>(await (parcelRequire("aVNzX"))).ForgeApp,
    name: 'SpaceSettingsV2ForgeApp'
});

const $b00cf28e8f13375f$export$427e207118ab314a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qLkPh",
    loader: async ()=>(await (parcelRequire("d58BO"))).LandingPage,
    name: 'SpaceSettingsV2LandingPage'
});

const $b00cf28e8f13375f$export$3edf328f9b8c29f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "FToEO",
    loader: async ()=>(await (parcelRequire("exRYE"))).ContentStateSettings,
    name: 'ContentStateSettings'
});

const $b00cf28e8f13375f$export$3777b033eca1f6e0 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "cpLCK",
    loader: async ()=>(await (parcelRequire("cWpd3"))).ArchiveSpace,
    name: 'ArchiveSpace'
});

const $b00cf28e8f13375f$export$1d7dd072dca164eb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "YzrOE",
    loader: async ()=>(await (parcelRequire("3plqm"))).EditorConversion,
    name: 'EditorConversion'
});

const $b00cf28e8f13375f$export$e9572bc84661916 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qWPYU",
    loader: async ()=>(await (parcelRequire("dZdxQ"))).DataClassificationSpaceSettings,
    name: 'DataClassificationSpaceSettings'
});

const $b00cf28e8f13375f$export$7054514dd2a9ab86 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "A9nRA",
    loader: async ()=>(await (parcelRequire("8nlm7"))).WatermarkConfigurationSpaceSettings,
    name: 'WatermarkConfigurationSpaceSettings'
});

const $b00cf28e8f13375f$export$4b21898ae61239bd = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "vt_3W",
    loader: async ()=>(await (parcelRequire("iCboS"))).ExportSpaceUnavailable,
    name: 'ExportSpaceUnavailable'
});

const $b00cf28e8f13375f$export$93b842abd8ad75f9 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "biBYY",
    loader: async ()=>(await (parcelRequire("d9EcZ"))).ExportSpace,
    name: 'ExportSpace'
});

const $b00cf28e8f13375f$export$9483751c8069a09c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "NurUC",
    loader: async ()=>(await (parcelRequire("2D22O"))).LegacyContent,
    name: 'LegacyContent'
});

const $b00cf28e8f13375f$export$bc89e6c0f5af9aeb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "nGPFr",
    loader: async ()=>(await (parcelRequire("ilz0m"))).EditFeatures,
    name: 'EditFeatures'
});

const $b00cf28e8f13375f$export$def53ea7cb291102 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zu9Zj",
    loader: async ()=>(await (parcelRequire("ikXnm"))).PdfExportPage,
    name: 'PdfExportPage'
});

const $b00cf28e8f13375f$export$344292e50180f695 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LtojB",
    loader: async ()=>(await (parcelRequire("ikXnm"))).PdfExportPage,
    name: 'PdfExportPage'
});

const $b00cf28e8f13375f$export$a39c3ddfb0f23a36 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "JXbLC",
    loader: async ()=>(await (parcelRequire("9UIXv"))).NcsPdfStylingPage,
    name: 'NcsPdfStylingPage'
});

const $b00cf28e8f13375f$export$21d23c9293c0e1b6 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "TXVcD",
    loader: async ()=>(await (parcelRequire("gHVc8"))).PageLayoutPage,
    name: 'PageLayoutPage'
});

const $b00cf28e8f13375f$export$39b0a52384de05d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "uXV6v",
    loader: async ()=>(await (parcelRequire("eD30T"))).ThemesPage,
    name: 'ThemesPage'
});

const $b00cf28e8f13375f$export$dfb17b75c81c879e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4VN1e",
    loader: async ()=>(await (parcelRequire("aVoWQ"))).TemplatesAndBlueprintsPage,
    name: 'TemplatesPage'
});

const $b00cf28e8f13375f$export$8ac2027648d0e996 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JHS8c",
    loader: async ()=>(await (parcelRequire("8xIes"))).SpaceSettingsSideNavigation,
    name: 'SpaceSettingsSideNavigation'
});

const $b00cf28e8f13375f$export$3d886d71e69bfaa7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6JNth",
    loader: async ()=>(await (parcelRequire("7ApYl"))).SpaceDetailsPage,
    name: 'SpaceDetailsPage'
});
module.exports["SpaceSettingsNavigationV2Portal"] = $b00cf28e8f13375f$export$9e3c60dd96fa2f8;
module.exports["SpaceSettingsSidebarLinks"] = $b00cf28e8f13375f$export$ce72f5360cf6ed0;
module.exports["SpaceSettingsV2ForgeApp"] = $b00cf28e8f13375f$export$80a4abaa5ce40322;
module.exports["SpaceSettingsV2LandingPage"] = $b00cf28e8f13375f$export$427e207118ab314a;
module.exports["ContentStateSettings"] = $b00cf28e8f13375f$export$3edf328f9b8c29f;
module.exports["ArchiveSpace"] = $b00cf28e8f13375f$export$3777b033eca1f6e0;
module.exports["EditorConversion"] = $b00cf28e8f13375f$export$1d7dd072dca164eb;
module.exports["DataClassificationSpaceSettings"] = $b00cf28e8f13375f$export$e9572bc84661916;
module.exports["WatermarkConfigurationSpaceSettings"] = $b00cf28e8f13375f$export$7054514dd2a9ab86;
module.exports["ExportSpaceUnavailable"] = $b00cf28e8f13375f$export$4b21898ae61239bd;
module.exports["ExportSpace"] = $b00cf28e8f13375f$export$93b842abd8ad75f9;
module.exports["LegacyContent"] = $b00cf28e8f13375f$export$9483751c8069a09c;
module.exports["EditFeatures"] = $b00cf28e8f13375f$export$bc89e6c0f5af9aeb;
module.exports["LazyPdfExportPage"] = $b00cf28e8f13375f$export$def53ea7cb291102;
module.exports["NcsPdfStylingPage"] = $b00cf28e8f13375f$export$a39c3ddfb0f23a36;
module.exports["LazyPageLayoutPage"] = $b00cf28e8f13375f$export$21d23c9293c0e1b6;
module.exports["LazyThemesPage"] = $b00cf28e8f13375f$export$39b0a52384de05d;
module.exports["LazyTemplatesPage"] = $b00cf28e8f13375f$export$dfb17b75c81c879e;
module.exports["SpaceSettingsSideNavigation"] = $b00cf28e8f13375f$export$8ac2027648d0e996;
module.exports["LazySpaceDetailsPage"] = $b00cf28e8f13375f$export$3d886d71e69bfaa7;

});

parcelRegister("94oFa", function(module, exports) {

let $69a79e5722c8c87d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $69a79e5722c8c87d$var$load("gSl1o"),
    $69a79e5722c8c87d$var$load("4CfTY"),
    $69a79e5722c8c87d$var$load("gctwz"),
    $69a79e5722c8c87d$var$load("4drdS"),
    $69a79e5722c8c87d$var$load("Wowvf"),
    $69a79e5722c8c87d$var$load("5fSdR"),
    $69a79e5722c8c87d$var$load("7EorR"),
    $69a79e5722c8c87d$var$load("awqCy"),
    $69a79e5722c8c87d$var$load("6wr18"),
    $69a79e5722c8c87d$var$load("cyGuT"),
    $69a79e5722c8c87d$var$load("fZt2F"),
    $69a79e5722c8c87d$var$load("ffEVr"),
    $69a79e5722c8c87d$var$load("hhss7"),
    $69a79e5722c8c87d$var$load("kemVp")
]).then(()=>parcelRequire('fE3rm'));

});

parcelRegister("3LzHP", function(module, exports) {

let $2be175591f1fdf8e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2be175591f1fdf8e$var$load("6wr18"),
    $2be175591f1fdf8e$var$load("ffEVr"),
    $2be175591f1fdf8e$var$load("7EorR"),
    $2be175591f1fdf8e$var$load("3VpdY")
]).then(()=>parcelRequire('iqUA6'));

});

parcelRegister("aVNzX", function(module, exports) {

let $7f55af9b24e59169$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f55af9b24e59169$var$load("gSl1o"),
    $7f55af9b24e59169$var$load("4CfTY"),
    $7f55af9b24e59169$var$load("gctwz"),
    $7f55af9b24e59169$var$load("4drdS"),
    $7f55af9b24e59169$var$load("Wowvf"),
    $7f55af9b24e59169$var$load("5fSdR"),
    $7f55af9b24e59169$var$load("7EorR"),
    $7f55af9b24e59169$var$load("awqCy"),
    $7f55af9b24e59169$var$load("6wr18"),
    $7f55af9b24e59169$var$load("cyGuT"),
    $7f55af9b24e59169$var$load("fZt2F"),
    $7f55af9b24e59169$var$load("ffEVr"),
    $7f55af9b24e59169$var$load("hhss7"),
    $7f55af9b24e59169$var$load("hikiA")
]).then(()=>parcelRequire('62VWj'));

});

parcelRegister("d58BO", function(module, exports) {

let $98626b8a03f33e19$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $98626b8a03f33e19$var$load("gSl1o"),
    $98626b8a03f33e19$var$load("4CfTY"),
    $98626b8a03f33e19$var$load("hHrTM"),
    $98626b8a03f33e19$var$load("gctwz"),
    $98626b8a03f33e19$var$load("4drdS"),
    $98626b8a03f33e19$var$load("7EorR"),
    $98626b8a03f33e19$var$load("5fSdR"),
    $98626b8a03f33e19$var$load("Wowvf"),
    $98626b8a03f33e19$var$load("6wr18"),
    $98626b8a03f33e19$var$load("cyGuT"),
    $98626b8a03f33e19$var$load("fZt2F"),
    $98626b8a03f33e19$var$load("ffEVr"),
    $98626b8a03f33e19$var$load("hhss7"),
    $98626b8a03f33e19$var$load("aOJkF")
]).then(()=>parcelRequire('fOc3P'));

});

parcelRegister("exRYE", function(module, exports) {

let $a96e04889efaeb6f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a96e04889efaeb6f$var$load("gSl1o"),
    $a96e04889efaeb6f$var$load("4CfTY"),
    $a96e04889efaeb6f$var$load("gctwz"),
    $a96e04889efaeb6f$var$load("4drdS"),
    $a96e04889efaeb6f$var$load("Wowvf"),
    $a96e04889efaeb6f$var$load("5fSdR"),
    $a96e04889efaeb6f$var$load("7EorR"),
    $a96e04889efaeb6f$var$load("awqCy"),
    $a96e04889efaeb6f$var$load("6wr18"),
    $a96e04889efaeb6f$var$load("cyGuT"),
    $a96e04889efaeb6f$var$load("fZt2F"),
    $a96e04889efaeb6f$var$load("ffEVr"),
    $a96e04889efaeb6f$var$load("hhss7"),
    $a96e04889efaeb6f$var$load("hWed1")
]).then(()=>parcelRequire('7bHkN'));

});

parcelRegister("cWpd3", function(module, exports) {

let $96be74e5c976f0c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $96be74e5c976f0c6$var$load("kHOMt"),
    $96be74e5c976f0c6$var$load("gSl1o"),
    $96be74e5c976f0c6$var$load("4CfTY"),
    $96be74e5c976f0c6$var$load("gctwz"),
    $96be74e5c976f0c6$var$load("4drdS"),
    $96be74e5c976f0c6$var$load("Wowvf"),
    $96be74e5c976f0c6$var$load("5fSdR"),
    $96be74e5c976f0c6$var$load("7EorR"),
    $96be74e5c976f0c6$var$load("awqCy"),
    $96be74e5c976f0c6$var$load("6wr18"),
    $96be74e5c976f0c6$var$load("cyGuT"),
    $96be74e5c976f0c6$var$load("fZt2F"),
    $96be74e5c976f0c6$var$load("ffEVr"),
    $96be74e5c976f0c6$var$load("hhss7"),
    $96be74e5c976f0c6$var$load("3oo5Z")
]).then(()=>parcelRequire('58FKJ'));

});

parcelRegister("3plqm", function(module, exports) {

let $27b4534bc4eaeaab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $27b4534bc4eaeaab$var$load("kHOMt"),
    $27b4534bc4eaeaab$var$load("gSl1o"),
    $27b4534bc4eaeaab$var$load("4CfTY"),
    $27b4534bc4eaeaab$var$load("gctwz"),
    $27b4534bc4eaeaab$var$load("4drdS"),
    $27b4534bc4eaeaab$var$load("Wowvf"),
    $27b4534bc4eaeaab$var$load("5fSdR"),
    $27b4534bc4eaeaab$var$load("7EorR"),
    $27b4534bc4eaeaab$var$load("awqCy"),
    $27b4534bc4eaeaab$var$load("6wr18"),
    $27b4534bc4eaeaab$var$load("cyGuT"),
    $27b4534bc4eaeaab$var$load("fZt2F"),
    $27b4534bc4eaeaab$var$load("ffEVr"),
    $27b4534bc4eaeaab$var$load("hhss7"),
    $27b4534bc4eaeaab$var$load("3oo5Z")
]).then(()=>parcelRequire('jE6bv'));

});

parcelRegister("dZdxQ", function(module, exports) {

let $a2eb7a9c45df03d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a2eb7a9c45df03d1$var$load("gSl1o"),
    $a2eb7a9c45df03d1$var$load("4CfTY"),
    $a2eb7a9c45df03d1$var$load("gctwz"),
    $a2eb7a9c45df03d1$var$load("4drdS"),
    $a2eb7a9c45df03d1$var$load("Wowvf"),
    $a2eb7a9c45df03d1$var$load("5fSdR"),
    $a2eb7a9c45df03d1$var$load("7EorR"),
    $a2eb7a9c45df03d1$var$load("awqCy"),
    $a2eb7a9c45df03d1$var$load("6wr18"),
    $a2eb7a9c45df03d1$var$load("cyGuT"),
    $a2eb7a9c45df03d1$var$load("fZt2F"),
    $a2eb7a9c45df03d1$var$load("ffEVr"),
    $a2eb7a9c45df03d1$var$load("hhss7"),
    $a2eb7a9c45df03d1$var$load("1RXGd")
]).then(()=>parcelRequire('4XP30'));

});

parcelRegister("8nlm7", function(module, exports) {

let $6191098580dedd73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6191098580dedd73$var$load("gSl1o"),
    $6191098580dedd73$var$load("4CfTY"),
    $6191098580dedd73$var$load("8JZKd"),
    $6191098580dedd73$var$load("0apDi"),
    $6191098580dedd73$var$load("gctwz"),
    $6191098580dedd73$var$load("4drdS"),
    $6191098580dedd73$var$load("Wowvf"),
    $6191098580dedd73$var$load("5fSdR"),
    $6191098580dedd73$var$load("7EorR"),
    $6191098580dedd73$var$load("awqCy"),
    $6191098580dedd73$var$load("6wr18"),
    $6191098580dedd73$var$load("cyGuT"),
    $6191098580dedd73$var$load("fZt2F"),
    $6191098580dedd73$var$load("ffEVr"),
    $6191098580dedd73$var$load("hhss7"),
    $6191098580dedd73$var$load("3N88z")
]).then(()=>parcelRequire('dHPdF'));

});

parcelRegister("iCboS", function(module, exports) {

let $d8d49e7405207b73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d8d49e7405207b73$var$load("gSl1o"),
    $d8d49e7405207b73$var$load("4CfTY"),
    $d8d49e7405207b73$var$load("gctwz"),
    $d8d49e7405207b73$var$load("4drdS"),
    $d8d49e7405207b73$var$load("Wowvf"),
    $d8d49e7405207b73$var$load("5fSdR"),
    $d8d49e7405207b73$var$load("7EorR"),
    $d8d49e7405207b73$var$load("awqCy"),
    $d8d49e7405207b73$var$load("6wr18"),
    $d8d49e7405207b73$var$load("cyGuT"),
    $d8d49e7405207b73$var$load("fZt2F"),
    $d8d49e7405207b73$var$load("ffEVr"),
    $d8d49e7405207b73$var$load("hhss7"),
    $d8d49e7405207b73$var$load("8dtLd")
]).then(()=>parcelRequire('29NvJ'));

});

parcelRegister("d9EcZ", function(module, exports) {

let $993b4e2eb6ceb8c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $993b4e2eb6ceb8c5$var$load("asMrh"),
    $993b4e2eb6ceb8c5$var$load("foT6i"),
    $993b4e2eb6ceb8c5$var$load("gSl1o"),
    $993b4e2eb6ceb8c5$var$load("4CfTY"),
    $993b4e2eb6ceb8c5$var$load("aFS1j"),
    $993b4e2eb6ceb8c5$var$load("gctwz"),
    $993b4e2eb6ceb8c5$var$load("4drdS"),
    $993b4e2eb6ceb8c5$var$load("kiGNy"),
    $993b4e2eb6ceb8c5$var$load("Wowvf"),
    $993b4e2eb6ceb8c5$var$load("5fSdR"),
    $993b4e2eb6ceb8c5$var$load("7EorR"),
    $993b4e2eb6ceb8c5$var$load("awqCy"),
    $993b4e2eb6ceb8c5$var$load("6wr18"),
    $993b4e2eb6ceb8c5$var$load("cyGuT"),
    $993b4e2eb6ceb8c5$var$load("fZt2F"),
    $993b4e2eb6ceb8c5$var$load("ffEVr"),
    $993b4e2eb6ceb8c5$var$load("hhss7"),
    $993b4e2eb6ceb8c5$var$load("5l56g")
]).then(()=>parcelRequire('13289'));

});

parcelRegister("2D22O", function(module, exports) {

let $1ea0cf4219a2dc3b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1ea0cf4219a2dc3b$var$load("asMrh"),
    $1ea0cf4219a2dc3b$var$load("foT6i"),
    $1ea0cf4219a2dc3b$var$load("gSl1o"),
    $1ea0cf4219a2dc3b$var$load("4CfTY"),
    $1ea0cf4219a2dc3b$var$load("aFS1j"),
    $1ea0cf4219a2dc3b$var$load("gctwz"),
    $1ea0cf4219a2dc3b$var$load("4drdS"),
    $1ea0cf4219a2dc3b$var$load("kiGNy"),
    $1ea0cf4219a2dc3b$var$load("Wowvf"),
    $1ea0cf4219a2dc3b$var$load("5fSdR"),
    $1ea0cf4219a2dc3b$var$load("7EorR"),
    $1ea0cf4219a2dc3b$var$load("awqCy"),
    $1ea0cf4219a2dc3b$var$load("6wr18"),
    $1ea0cf4219a2dc3b$var$load("cyGuT"),
    $1ea0cf4219a2dc3b$var$load("fZt2F"),
    $1ea0cf4219a2dc3b$var$load("ffEVr"),
    $1ea0cf4219a2dc3b$var$load("hhss7"),
    $1ea0cf4219a2dc3b$var$load("5l56g")
]).then(()=>parcelRequire('b3HuK'));

});

parcelRegister("ilz0m", function(module, exports) {

let $d5b5575eda7eb30b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d5b5575eda7eb30b$var$load("gSl1o"),
    $d5b5575eda7eb30b$var$load("4CfTY"),
    $d5b5575eda7eb30b$var$load("gctwz"),
    $d5b5575eda7eb30b$var$load("4drdS"),
    $d5b5575eda7eb30b$var$load("Wowvf"),
    $d5b5575eda7eb30b$var$load("5fSdR"),
    $d5b5575eda7eb30b$var$load("7EorR"),
    $d5b5575eda7eb30b$var$load("awqCy"),
    $d5b5575eda7eb30b$var$load("6wr18"),
    $d5b5575eda7eb30b$var$load("cyGuT"),
    $d5b5575eda7eb30b$var$load("fZt2F"),
    $d5b5575eda7eb30b$var$load("ffEVr"),
    $d5b5575eda7eb30b$var$load("hhss7"),
    $d5b5575eda7eb30b$var$load("4R2Ie")
]).then(()=>parcelRequire('cUMZA'));

});

parcelRegister("ikXnm", function(module, exports) {

let $d598270b102d0ba0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d598270b102d0ba0$var$load("6MNAi"),
    $d598270b102d0ba0$var$load("425pi"),
    $d598270b102d0ba0$var$load("6wr18"),
    $d598270b102d0ba0$var$load("2F69B"),
    $d598270b102d0ba0$var$load("Wowvf"),
    $d598270b102d0ba0$var$load("37ldp"),
    $d598270b102d0ba0$var$load("ffEVr"),
    $d598270b102d0ba0$var$load("kHOMt"),
    $d598270b102d0ba0$var$load("hhss7"),
    $d598270b102d0ba0$var$load("eCKto")
]).then(()=>parcelRequire('lt04m'));

});

parcelRegister("9UIXv", function(module, exports) {

let $737c37e0a2e1c439$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $737c37e0a2e1c439$var$load("6wr18"),
    $737c37e0a2e1c439$var$load("2F69B"),
    $737c37e0a2e1c439$var$load("ffEVr"),
    $737c37e0a2e1c439$var$load("kHOMt"),
    $737c37e0a2e1c439$var$load("hhss7"),
    $737c37e0a2e1c439$var$load("jCgHD")
]).then(()=>parcelRequire('ig7oA'));

});

parcelRegister("gHVc8", function(module, exports) {

let $c29d072de3bd1b71$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c29d072de3bd1b71$var$load("6wr18"),
    $c29d072de3bd1b71$var$load("2F69B"),
    $c29d072de3bd1b71$var$load("ffEVr"),
    $c29d072de3bd1b71$var$load("kHOMt"),
    $c29d072de3bd1b71$var$load("hhss7"),
    $c29d072de3bd1b71$var$load("jCgHD")
]).then(()=>parcelRequire('lhpIB'));

});

parcelRegister("eD30T", function(module, exports) {

let $aa670ba02c07c932$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aa670ba02c07c932$var$load("2F69B"),
    $aa670ba02c07c932$var$load("hhss7"),
    $aa670ba02c07c932$var$load("gr3fi")
]).then(()=>parcelRequire('h595R'));

});

parcelRegister("aVoWQ", function(module, exports) {

let $7f429473762ab3b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f429473762ab3b5$var$load("49GA1"),
    $7f429473762ab3b5$var$load("32K9i"),
    $7f429473762ab3b5$var$load("awqCy"),
    $7f429473762ab3b5$var$load("5465r"),
    $7f429473762ab3b5$var$load("fkY2m"),
    $7f429473762ab3b5$var$load("6wr18"),
    $7f429473762ab3b5$var$load("2F69B"),
    $7f429473762ab3b5$var$load("65Hz8"),
    $7f429473762ab3b5$var$load("h4Nf7"),
    $7f429473762ab3b5$var$load("6p14c"),
    $7f429473762ab3b5$var$load("ie88R"),
    $7f429473762ab3b5$var$load("Wowvf"),
    $7f429473762ab3b5$var$load("7EorR"),
    $7f429473762ab3b5$var$load("ffEVr"),
    $7f429473762ab3b5$var$load("hhss7"),
    $7f429473762ab3b5$var$load("75ddA")
]).then(()=>parcelRequire('6xruv'));

});

parcelRegister("8xIes", function(module, exports) {

let $6383b768c13c8a8c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6383b768c13c8a8c$var$load("gSl1o"),
    $6383b768c13c8a8c$var$load("awqCy"),
    $6383b768c13c8a8c$var$load("6wr18"),
    $6383b768c13c8a8c$var$load("bXcCM"),
    $6383b768c13c8a8c$var$load("hHrTM"),
    $6383b768c13c8a8c$var$load("lRtGG"),
    $6383b768c13c8a8c$var$load("8UKe0"),
    $6383b768c13c8a8c$var$load("7EorR"),
    $6383b768c13c8a8c$var$load("ffEVr"),
    $6383b768c13c8a8c$var$load("Wowvf"),
    $6383b768c13c8a8c$var$load("hUIij"),
    $6383b768c13c8a8c$var$load("6Up0b"),
    $6383b768c13c8a8c$var$load("hhss7"),
    $6383b768c13c8a8c$var$load("hXJOj")
]).then(()=>parcelRequire('f53HT'));

});

parcelRegister("7ApYl", function(module, exports) {

let $58600ac1610f644d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $58600ac1610f644d$var$load("5465r"),
    $58600ac1610f644d$var$load("fkY2m"),
    $58600ac1610f644d$var$load("1wMt1"),
    $58600ac1610f644d$var$load("gSl1o"),
    $58600ac1610f644d$var$load("4CfTY"),
    $58600ac1610f644d$var$load("2F69B"),
    $58600ac1610f644d$var$load("gctwz"),
    $58600ac1610f644d$var$load("65Hz8"),
    $58600ac1610f644d$var$load("4drdS"),
    $58600ac1610f644d$var$load("h4Nf7"),
    $58600ac1610f644d$var$load("6p14c"),
    $58600ac1610f644d$var$load("ie88R"),
    $58600ac1610f644d$var$load("iXzmH"),
    $58600ac1610f644d$var$load("65c4i"),
    $58600ac1610f644d$var$load("5fSdR"),
    $58600ac1610f644d$var$load("dTsOE"),
    $58600ac1610f644d$var$load("7EorR"),
    $58600ac1610f644d$var$load("awqCy"),
    $58600ac1610f644d$var$load("6wr18"),
    $58600ac1610f644d$var$load("cyGuT"),
    $58600ac1610f644d$var$load("fZt2F"),
    $58600ac1610f644d$var$load("Wowvf"),
    $58600ac1610f644d$var$load("ffEVr"),
    $58600ac1610f644d$var$load("let0D"),
    $58600ac1610f644d$var$load("hhss7"),
    $58600ac1610f644d$var$load("aGPD2")
]).then(()=>parcelRequire('Nfj1T'));

});

parcelRegister("5PeCy", function(module, exports) {
const $3f1a68f508d23df8$export$9e09723d1b627d8f = 'spaceSettingsDetails';
const $3f1a68f508d23df8$export$e8958a6508ec5b71 = 'N/A';
module.exports["SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE"] = $3f1a68f508d23df8$export$9e09723d1b627d8f;
module.exports["NOT_APPLICABLE"] = $3f1a68f508d23df8$export$e8958a6508ec5b71;

});

parcelRegister("arkw6", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $799c5730c040f94e$export$8a15724b9c449449 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "24dkw",
    name: "LazyCreateDialogQueryRenderer",
    loader: async ()=>(await (parcelRequire("hRUHW"))).CreateDialogQueryRenderer
});
module.exports["LazyCreateDialogQueryRenderer"] = $799c5730c040f94e$export$8a15724b9c449449;

});

parcelRegister("hRUHW", function(module, exports) {

let $d0235fe2ee686ff6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d0235fe2ee686ff6$var$load("7kiNM"),
    $d0235fe2ee686ff6$var$load("5MjBi"),
    $d0235fe2ee686ff6$var$load("6wr18"),
    $d0235fe2ee686ff6$var$load("ffEVr"),
    $d0235fe2ee686ff6$var$load("Wowvf"),
    $d0235fe2ee686ff6$var$load("kHOMt"),
    $d0235fe2ee686ff6$var$load("let0D"),
    $d0235fe2ee686ff6$var$load("hhss7"),
    $d0235fe2ee686ff6$var$load("8sv0D")
]).then(()=>parcelRequire('awg6S'));

});

parcelRegister("4QflW", function(module, exports) {
parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


const $3867ed838141f5c5$export$cb6c2610bed03a36 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Hii47",
    name: "LegacyCreateDialogCssOverridesLoader",
    loader: ()=>(parcelRequire("6cwxk"))
});

const $3867ed838141f5c5$var$LegacyCssOverridesLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3Za_w",
    name: "LegacyCssOverridesLoader",
    loader: ()=>(parcelRequire("1Zbb9"))
});
var $3867ed838141f5c5$export$2e2bcd8739ae039 = $3867ed838141f5c5$var$LegacyCssOverridesLoader;
module.exports["LegacyCreateDialogCssOverridesLoader"] = $3867ed838141f5c5$export$cb6c2610bed03a36;
module.exports["default"] = $3867ed838141f5c5$export$2e2bcd8739ae039;

});

parcelRegister("6cwxk", function(module, exports) {

let $483d1a26ae52478e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $483d1a26ae52478e$var$load("5zc8S").then(()=>parcelRequire('77xGo'));

});

parcelRegister("1Zbb9", function(module, exports) {

let $172428d361f6d1f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $172428d361f6d1f1$var$load("kS1Zx").then(()=>parcelRequire('dvfbF'));

});

parcelRegister("3j0Cc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $26839f94c757541d$export$581cdb67a7c2d168 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "6iAdD",
    name: "LazyCreateDialogBlueprintWizardRenderer",
    loader: async ()=>(await (parcelRequire("guKKr"))).CreateDialogBlueprintWizardRenderer
});
module.exports["LazyCreateDialogBlueprintWizardRenderer"] = $26839f94c757541d$export$581cdb67a7c2d168;

});

parcelRegister("guKKr", function(module, exports) {

let $c023b5dc38d3e93e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c023b5dc38d3e93e$var$load("c37CC").then(()=>parcelRequire('cVptH'));

});

parcelRegister("jwv1p", function(module, exports) {

const $e36911ba101658f6$export$148862cf4cade69d = async ()=>{
    return (await (parcelRequire("ehSnc"))).preloadLivePagesComponents();
};

const $e36911ba101658f6$export$ae265da577871bc0 = async (...args)=>{
    return (await (parcelRequire("fg7BC"))).preloadViewPage(...args);
};

const $e36911ba101658f6$export$2fae7b45037154b8 = async ()=>{
    (await (parcelRequire("jhORN"))).preloadSpaceOverview();
};

const $e36911ba101658f6$export$46a5a1ea97a164bd = async ()=>{
    (await (parcelRequire("gS3nK"))).preloadSearch();
};

const $e36911ba101658f6$export$ae91664215c56ac5 = async (...args)=>{
    (await (parcelRequire("jgNuY"))).preloadHome(...args);
};

const $e36911ba101658f6$export$e3acde4c7c871ca8 = async ()=>{
    (await Promise.resolve((parcelRequire("eXODy")))).nativeEditorComponentsPreloader();
};

const $e36911ba101658f6$export$b132280a7554aa6b = async ()=>{
    (await (parcelRequire("eOt3C"))).preloadCreateContentRoute();
};

const $e36911ba101658f6$export$203980c0fec24ba7 = async ()=>{
    (await (parcelRequire("5slIf"))).preloadWhiteboardPage();
};
module.exports["preloadLivePagesComponents"] = $e36911ba101658f6$export$148862cf4cade69d;
module.exports["preloadViewPageComponents"] = $e36911ba101658f6$export$ae265da577871bc0;
module.exports["preloadSpaceOverview"] = $e36911ba101658f6$export$2fae7b45037154b8;
module.exports["preloadSearch"] = $e36911ba101658f6$export$46a5a1ea97a164bd;
module.exports["preloadHome"] = $e36911ba101658f6$export$ae91664215c56ac5;
module.exports["preloadNativeEditorComponentsPreloader"] = $e36911ba101658f6$export$e3acde4c7c871ca8;
module.exports["preloadCreateContent"] = $e36911ba101658f6$export$b132280a7554aa6b;
module.exports["preloadWhiteboardPage"] = $e36911ba101658f6$export$203980c0fec24ba7;

});

parcelRegister("ehSnc", function(module, exports) {

let $a66cd4940eec9f5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a66cd4940eec9f5e$var$load("hTcok").then(()=>parcelRequire('3u3VR'));

});

parcelRegister("fg7BC", function(module, exports) {

let $b1be3ffffffe2bb2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b1be3ffffffe2bb2$var$load("dRao7"),
    $b1be3ffffffe2bb2$var$load("jvuhr"),
    $b1be3ffffffe2bb2$var$load("7kiNM"),
    $b1be3ffffffe2bb2$var$load("5MjBi"),
    $b1be3ffffffe2bb2$var$load("6wr18"),
    $b1be3ffffffe2bb2$var$load("aEyFn"),
    $b1be3ffffffe2bb2$var$load("jdHbV"),
    $b1be3ffffffe2bb2$var$load("2F69B"),
    $b1be3ffffffe2bb2$var$load("3qsjq"),
    $b1be3ffffffe2bb2$var$load("hhss7"),
    $b1be3ffffffe2bb2$var$load("ffEVr"),
    $b1be3ffffffe2bb2$var$load("5465r"),
    $b1be3ffffffe2bb2$var$load("fkY2m"),
    $b1be3ffffffe2bb2$var$load("30YPk"),
    $b1be3ffffffe2bb2$var$load("7qbsX")
]).then(()=>parcelRequire('jpdb8'));

});

parcelRegister("jhORN", function(module, exports) {

let $e0a70fe6cc186c86$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e0a70fe6cc186c86$var$load("6wr18"),
    $e0a70fe6cc186c86$var$load("aEyFn"),
    $e0a70fe6cc186c86$var$load("hhss7"),
    $e0a70fe6cc186c86$var$load("ffEVr"),
    $e0a70fe6cc186c86$var$load("5465r"),
    $e0a70fe6cc186c86$var$load("fkY2m"),
    $e0a70fe6cc186c86$var$load("30YPk"),
    $e0a70fe6cc186c86$var$load("c9p5N")
]).then(()=>parcelRequire('eyGwZ'));

});

parcelRegister("gS3nK", function(module, exports) {

let $c4845015d80c7b32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c4845015d80c7b32$var$load("3tzD8").then(()=>parcelRequire('7Q5hy'));

});

parcelRegister("jgNuY", function(module, exports) {

let $e075e84f5855cfdd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e075e84f5855cfdd$var$load("6MNAi"),
    $e075e84f5855cfdd$var$load("425pi"),
    $e075e84f5855cfdd$var$load("6wr18"),
    $e075e84f5855cfdd$var$load("37ldp"),
    $e075e84f5855cfdd$var$load("ffEVr"),
    $e075e84f5855cfdd$var$load("hhss7"),
    $e075e84f5855cfdd$var$load("aDFb6")
]).then(()=>parcelRequire('2zBDm'));

});

parcelRegister("eOt3C", function(module, exports) {

let $ac8c4664102bdf61$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac8c4664102bdf61$var$load("hGSL3").then(()=>parcelRequire('jOGWx'));

});

parcelRegister("5slIf", function(module, exports) {

let $3f9068f35b478720$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3f9068f35b478720$var$load("d3Mqz").then(()=>parcelRequire('ezyVI'));

});

parcelRegister("eIKcA", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("aiAUl")).default);

var $aiAUl = parcelRequire("aiAUl");


});

parcelRegister("7LuKf", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $1iSzD = parcelRequire("1iSzD");


var $68uaC = parcelRequire("68uaC");


var $l3KBO = parcelRequire("l3KBO");

var $398ES = parcelRequire("398ES");


var $e43zd = parcelRequire("e43zd");


var $b2nDI = parcelRequire("b2nDI");

function $d5602fcf9b009334$export$948cfabebbf3f293() {
    (0, $e43zd.enableNetworkRetryLink)();
    (0, $b2nDI.enableStatusCodeRetryLink)();
}



var $eSuZj = parcelRequire("eSuZj");


var $27y2X = parcelRequire("27y2X");


var $5ZqQS = parcelRequire("5ZqQS");


var $04e9M = parcelRequire("04e9M");


var $6vg9V = parcelRequire("6vg9V");


var $5MeCb = parcelRequire("5MeCb");

const $c417ee49d66f0195$export$87ce35ca55792fef = ()=>{
    const realSetItem = window.localStorage.setItem;
    function newSetItem(...args) {
        try {
            return realSetItem.apply(this, args);
        } catch (e) {
            if ((0, $5MeCb.isQuotaExceededError)(e)) window.dispatchEvent(new CustomEvent('local-storage.quota.exceeded'));
            throw e;
        }
    }
    window.localStorage.setItem = newSetItem;
};



var $itS9i = parcelRequire("itS9i");


var $bmTgR = parcelRequire("bmTgR");


var $4VJDS = parcelRequire("4VJDS");





var $6g1oe = parcelRequire("6g1oe");




const $502c94f8f5d6e348$var$CLASSIC_BRANCH = 'useFrontendBranch';
const $502c94f8f5d6e348$var$BUILD_VERSION = 'useFrontendBuildVersion';
const $502c94f8f5d6e348$var$REGEX = /[^A-Za-z0-9\-]/g;
async function $502c94f8f5d6e348$var$setCookie(key, value) {
    const original = (0, $68uaC.Cookies).get(key);
    if (value === 'off' || key === $502c94f8f5d6e348$var$BUILD_VERSION && !value) (0, $68uaC.Cookies).remove(key);
    else if (value) await (0, $68uaC.Cookies).set(key, decodeURIComponent(value).replace($502c94f8f5d6e348$var$REGEX, '-'));
    return (0, $68uaC.Cookies).get(key) !== original;
}
async function $502c94f8f5d6e348$export$b4feebdfd4dc5ca8() {
    const urlComponents = (0, $jiJCD.parse)((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).location.href, true);
    let branchName = null;
    let buildVersion = null;
    if (urlComponents.query && (urlComponents.query.useFrontendBranch || urlComponents.query.useFrontendBuildVersion)) {
        branchName = urlComponents.query.useFrontendBranch;
        buildVersion = urlComponents.query.useFrontendBuildVersion;
        const branchVersionChanged = await $502c94f8f5d6e348$var$setCookie($502c94f8f5d6e348$var$CLASSIC_BRANCH, branchName);
        const buildVersionChanged = await $502c94f8f5d6e348$var$setCookie($502c94f8f5d6e348$var$BUILD_VERSION, buildVersion);
        if (branchVersionChanged || buildVersionChanged) (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).location.assign((0, $jiJCD.format)({
            pathname: urlComponents.pathname,
            query: urlComponents.query,
            hash: urlComponents.hash
        }));
    }
}











const $39e2ce9abd3d5cf3$var$BM_UNIQUE_IDENTIFIER = 'bmUniqueIdentifier';
function $39e2ce9abd3d5cf3$export$79147544b544e349() {
    const urlComponents = (0, $jiJCD.parse)((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).location.href, true);
    const identifier = urlComponents.query?.bmUniqueIdentifier;
    if (identifier === 'off') (0, $68uaC.Cookies).remove($39e2ce9abd3d5cf3$var$BM_UNIQUE_IDENTIFIER);
    else if (identifier) (0, $68uaC.Cookies).set($39e2ce9abd3d5cf3$var$BM_UNIQUE_IDENTIFIER, identifier);
}





function $5a74c583a9da3f53$export$66b82bc0ee0db41d(sessionData) {
    const { featureFlags: featureFlags, cloudId: cloudId, environment: environment, shard: shard, activationId: activationId, edition: edition } = sessionData;
    (0, $c417ee49d66f0195$export$87ce35ca55792fef)();
    (0, $502c94f8f5d6e348$export$b4feebdfd4dc5ca8)();
    if (featureFlags['confluence.frontend.bm.unique-identifier']) (0, $39e2ce9abd3d5cf3$export$79147544b544e349)();
    (0, $d5602fcf9b009334$export$948cfabebbf3f293)();
    (0, $5ZqQS.enableSendErrorsToTelemetryService)();
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const product = isEmbeddedConfluence ? 'embeddedConfluence' : 'confluence';
    //Grabbing parentProduct and setting it to subproduct
    const subproduct = isEmbeddedConfluence ? (0, $jiJCD.parse)(location.search, true).query.parentProduct : undefined;
    // Monitoring context initialization
    (0, $5ZqQS.getMonitoringClient)().updateContext({
        tenantId: cloudId,
        shard: shard,
        product: product,
        edition: edition
    });
    // initialize metal client
    (0, $6vg9V.initMetalClient)({
        environment: environment || 'DEVELOPMENT',
        synthetic: (0, $4VJDS.default).getBoolean('confluence_frontend_pollinator_synthetic_tenants', false)
    });
    // Before initializing the Analytics Web Client (AWC), set the
    // `atlassian_analytics_debug` cookie to indicate that CC Scale bot users (load testing)
    // can use `window.testAnalytics` object to detect whether a page is loaded
    // (AWC saves all the events that are fired under `window.testAnalytics`)
    const analyticsDebuggingEnabled = (0, $4VJDS.default).getBoolean('confluence_frontend_analytics_load_testing', false);
    const shouldFilterEvents = Boolean((0, $4VJDS.default).isKillSwitchOn('confluence_frontend_filter_events_config') ?? false);
    if (analyticsDebuggingEnabled) (0, $68uaC.Cookies).set('atlassian_analytics_debug', true);
    // Disable AWC synthetic tag via global override when feature gate is enabled
    const disableAWCSyntheticTag = (0, $4VJDS.default).getBoolean('confluence_frontend_awc_disable_synthetic_tag', false);
    if (disableAWCSyntheticTag) // Explicitly disable automatic 'synthetic' tag on AWC events
    // See platform/packages/atlassian-analytics-pipeline/analytics-web-client/README.md
    // and TestSupport.SYNTHETIC_FLAG_OVERRIDE_PROPERTY
    window.__awc_synthetic_flag_override__ = false;
    // GASv3 analytics client
    // ActivationId: sessionData.activationId needs to be added after https://experimentation-platform.atlassian.net/browse/MEP-2924
    (0, $04e9M.initializeAnalyticsClient)({
        cloudId: cloudId,
        activationId: activationId,
        userId: sessionData.userIdForAnalytics,
        locale: sessionData.locale,
        environment: (0, $4VJDS.default).getBoolean('confluence_frontend_pollinator_synthetic_tenants', false) ? 'DEVELOPMENT' : environment,
        product: product,
        subproduct: subproduct,
        eventFilterOptions: {
            shouldFilterEvents: shouldFilterEvents,
            eventMatchers: (0, $27y2X.defaultEventMatchers)
        },
        callback: analyticsDebuggingEnabled ? (0, $itS9i.enableAnalyticsDebugger) : undefined
    });
    // Please put stuff that can be delayed here
    (0, $l3KBO.getTaskManager)().push({
        id: 'BackgroundInitialization',
        priority: (0, $398ES.LoadingPriority).BACKGROUND,
        task: ()=>{
            // Global function available for support engineer to get all environmental data for troubleshooting.
            window.__CONFLUENCE_SUPPORT = ()=>{
                const supportData = {
                    version: (0, $eSuZj.getBuildInfo)().FRONTEND_VERSION,
                    tinymce: window.tinymce ? `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}` : undefined,
                    activeEditor: window.tinymce && window.tinymce.activeEditor ? true : undefined
                };
                return JSON.stringify(supportData);
            };
            // Register service worker
            (parcelRequire("fBw7f")).then(({ unregister: unregisterServiceWorker })=>{
                unregisterServiceWorker();
            });
            // Message queue for sending GASv3 event from legacy pages
            (parcelRequire("50xZB")).then(({ initializeLegacyMessageQueue: initializeLegacyMessageQueue })=>{
                initializeLegacyMessageQueue();
            });
            // https://developer.mozilla.org/en-US/docs/Glossary/Domain_sharding
            // We roughly has 8% of users still on http/1.1 https://redash.data.internal.atlassian.com/queries/126773/source#242723
            // Http/1.1 is 2x slower than http/2 https://redash.data.internal.atlassian.com/queries/126772/source#242719
            (parcelRequire("lFbdE")).then(({ initializeFlag: initializeFlag })=>initializeFlag());
            // Establish IPC listeners for Confluence Desktop App
            const shouldInitializeDesktop = (0, $4VJDS.default).getBoolean('confluence_should_initialize_desktop', false);
            if (shouldInitializeDesktop) (0, $bmTgR.establishIPCListeners)();
        }
    });
}
module.exports["initialization"] = $5a74c583a9da3f53$export$66b82bc0ee0db41d;

});

parcelRegister("fBw7f", function(module, exports) {

let $b5c33941132f3568$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b5c33941132f3568$var$load("erEMS").then(()=>parcelRequire('lQAde'));

});

parcelRegister("50xZB", function(module, exports) {

let $3a57520926570fbb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3a57520926570fbb$var$load("eOPjI").then(()=>parcelRequire('93DJf'));

});

parcelRegister("lFbdE", function(module, exports) {

let $fc56212f2ce1f01a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fc56212f2ce1f01a$var$load("gHIIj").then(()=>parcelRequire('gzkU4'));

});

parcelRegister("7RVQB", function(module, exports) {
/* eslint-disable import/dynamic-import-chunkname */ /**
 * The webpackChunkName "translations.foo" is important. Do not change without updating following files:
 * - packages/confluence-frontend-server/webpack.config.js
 * - packages/confluence-frontend-server/templates/generator.js
 */ 























function $5baa5af3b62b17d6$var$fetchLanguage(locale) {
    /**
     * en-ZZ is a special locale used for locate translation strings. Real user won't see it.
     * Split the condition statements so webpack can remove the whole thing when compiling for SSR
     * SSR doesn't have splits this file will make the ssr-app significantly bigger
     */ if (locale === 'en-ZZ') return ()=>(parcelRequire("kY2qb"));
    const languageHash = {
        'fr-FR': ()=>(parcelRequire("9ug0f")),
        'de-DE': ()=>(parcelRequire("dzF3o")),
        'ja-JP': ()=>(parcelRequire("gHxq1")),
        'es-ES': ()=>(parcelRequire("dKLEo")),
        'ko-KR': ()=>(parcelRequire("gbAYV")),
        'pt-BR': ()=>(parcelRequire("7PYJM")),
        'ru-RU': ()=>(parcelRequire("cEFjn")),
        'en-GB': ()=>(parcelRequire("9Q3YH")),
        'da-DK': ()=>(parcelRequire("cyYMW")),
        'et-EE': ()=>(parcelRequire("dk2E7")),
        'fi-FI': ()=>(parcelRequire("47VDS")),
        'hu-HU': ()=>(parcelRequire("bad4e")),
        'is-IS': ()=>(parcelRequire("9mX5T")),
        'it-IT': ()=>(parcelRequire("9MAA5")),
        'nl-NL': ()=>(parcelRequire("g3cjJ")),
        'no-NO': ()=>(parcelRequire("cd8R2")),
        'pl-PL': ()=>(parcelRequire("dVfFh")),
        'ro-RO': ()=>(parcelRequire("3R1mH")),
        'sk-SK': ()=>(parcelRequire("6uGdm")),
        'cs-CZ': ()=>(parcelRequire("8fc7Q")),
        'sv-SE': ()=>(parcelRequire("5D1pj")),
        'zh-CN': ()=>(parcelRequire("5VTmi")),
        'zh-TW': ()=>(parcelRequire("gWhk4"))
    };
    return locale in languageHash ? languageHash[locale] : undefined;
}

function $5baa5af3b62b17d6$export$e275acea19f48fe8(locale) {
    const promises = [
        (parcelRequire("5vcUM"))
    ];
    const languageChunk = $5baa5af3b62b17d6$var$fetchLanguage(locale);
    if (languageChunk) promises.push(languageChunk());
    return promises;
}
module.exports["lazyLanguage"] = $5baa5af3b62b17d6$export$e275acea19f48fe8;

});

parcelRegister("kY2qb", function(module, exports) {

let $f43b4a10d5e16df5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f43b4a10d5e16df5$var$load("j0PWv"),
    $f43b4a10d5e16df5$var$load("ksTQ6"),
    $f43b4a10d5e16df5$var$load("eBoC7"),
    $f43b4a10d5e16df5$var$load("j5F5K"),
    $f43b4a10d5e16df5$var$load("cukQS"),
    $f43b4a10d5e16df5$var$load("5FaEJ")
]).then(()=>parcelRequire('7TlDk'));

});

parcelRegister("9ug0f", function(module, exports) {

let $6e8354438a94fe0c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6e8354438a94fe0c$var$load("17m16"),
    $6e8354438a94fe0c$var$load("kAg8V"),
    $6e8354438a94fe0c$var$load("cMubu"),
    $6e8354438a94fe0c$var$load("9Cdzw"),
    $6e8354438a94fe0c$var$load("cHWSM"),
    $6e8354438a94fe0c$var$load("35Ssm")
]).then(()=>parcelRequire('gpNr5'));

});

parcelRegister("dzF3o", function(module, exports) {

let $9e1e63a447c7fb6a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9e1e63a447c7fb6a$var$load("6dERU"),
    $9e1e63a447c7fb6a$var$load("7gF8f"),
    $9e1e63a447c7fb6a$var$load("gd4qs"),
    $9e1e63a447c7fb6a$var$load("YEGhv"),
    $9e1e63a447c7fb6a$var$load("dBb6q"),
    $9e1e63a447c7fb6a$var$load("eJgH8")
]).then(()=>parcelRequire('5pIQr'));

});

parcelRegister("gHxq1", function(module, exports) {

let $c28a95c657396501$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c28a95c657396501$var$load("38sfA"),
    $c28a95c657396501$var$load("awkVi"),
    $c28a95c657396501$var$load("h4OCL"),
    $c28a95c657396501$var$load("6yRq3"),
    $c28a95c657396501$var$load("ktSfi"),
    $c28a95c657396501$var$load("9GZ76")
]).then(()=>parcelRequire('HRYij'));

});

parcelRegister("dKLEo", function(module, exports) {

let $a03488a030c56fc1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a03488a030c56fc1$var$load("dlmud"),
    $a03488a030c56fc1$var$load("5CGnz"),
    $a03488a030c56fc1$var$load("bNv64"),
    $a03488a030c56fc1$var$load("dXu4x"),
    $a03488a030c56fc1$var$load("3CucM"),
    $a03488a030c56fc1$var$load("9yemY")
]).then(()=>parcelRequire('guCYa'));

});

parcelRegister("gbAYV", function(module, exports) {

let $bc8a5c37d2d0f4a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bc8a5c37d2d0f4a7$var$load("bjmre"),
    $bc8a5c37d2d0f4a7$var$load("11DLa"),
    $bc8a5c37d2d0f4a7$var$load("bcQs2"),
    $bc8a5c37d2d0f4a7$var$load("cft22"),
    $bc8a5c37d2d0f4a7$var$load("iouLY"),
    $bc8a5c37d2d0f4a7$var$load("4sOIV")
]).then(()=>parcelRequire('02XAY'));

});

parcelRegister("7PYJM", function(module, exports) {

let $5b4c68ffbed440e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5b4c68ffbed440e9$var$load("3fuR9"),
    $5b4c68ffbed440e9$var$load("2bqSD"),
    $5b4c68ffbed440e9$var$load("gZU54"),
    $5b4c68ffbed440e9$var$load("e8jpx"),
    $5b4c68ffbed440e9$var$load("bGhLc"),
    $5b4c68ffbed440e9$var$load("iRKhU")
]).then(()=>parcelRequire('dGgwV'));

});

parcelRegister("cEFjn", function(module, exports) {

let $93694416ebe3fd84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $93694416ebe3fd84$var$load("fMrUo"),
    $93694416ebe3fd84$var$load("bJykp"),
    $93694416ebe3fd84$var$load("4Wdqb"),
    $93694416ebe3fd84$var$load("fjbzp"),
    $93694416ebe3fd84$var$load("9v6ER"),
    $93694416ebe3fd84$var$load("aEAsN")
]).then(()=>parcelRequire('9wCA2'));

});

parcelRegister("9Q3YH", function(module, exports) {

let $729c0e55300e820e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $729c0e55300e820e$var$load("kTurq"),
    $729c0e55300e820e$var$load("djb49"),
    $729c0e55300e820e$var$load("fviv5"),
    $729c0e55300e820e$var$load("d8WL7"),
    $729c0e55300e820e$var$load("2RQvP"),
    $729c0e55300e820e$var$load("7Lkvk")
]).then(()=>parcelRequire('50Ww1'));

});

parcelRegister("cyYMW", function(module, exports) {

let $9257d053ed533916$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9257d053ed533916$var$load("deyvi"),
    $9257d053ed533916$var$load("cdeuH"),
    $9257d053ed533916$var$load("4UPfH"),
    $9257d053ed533916$var$load("aNg21"),
    $9257d053ed533916$var$load("1Mp9N"),
    $9257d053ed533916$var$load("2Fu3d")
]).then(()=>parcelRequire('9BoM3'));

});

parcelRegister("dk2E7", function(module, exports) {

let $9b2f321465553a34$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9b2f321465553a34$var$load("7snhF"),
    $9b2f321465553a34$var$load("X0Jic"),
    $9b2f321465553a34$var$load("bAoKR"),
    $9b2f321465553a34$var$load("34YSq"),
    $9b2f321465553a34$var$load("5IaSN")
]).then(()=>parcelRequire('ffimM'));

});

parcelRegister("47VDS", function(module, exports) {

let $301487689d90cc9e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $301487689d90cc9e$var$load("cbkj0"),
    $301487689d90cc9e$var$load("9Oxgj"),
    $301487689d90cc9e$var$load("4Afgd"),
    $301487689d90cc9e$var$load("18TX5"),
    $301487689d90cc9e$var$load("lp8Wm"),
    $301487689d90cc9e$var$load("l2LZP")
]).then(()=>parcelRequire('ljE1W'));

});

parcelRegister("bad4e", function(module, exports) {

let $820ac3c034188027$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $820ac3c034188027$var$load("b4NO6"),
    $820ac3c034188027$var$load("fM2oh"),
    $820ac3c034188027$var$load("3fLE9"),
    $820ac3c034188027$var$load("guNAg"),
    $820ac3c034188027$var$load("b37xN"),
    $820ac3c034188027$var$load("ik6u5")
]).then(()=>parcelRequire('kiiUw'));

});

parcelRegister("9mX5T", function(module, exports) {

let $6d2401fdd45a9274$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d2401fdd45a9274$var$load("fModo").then(()=>parcelRequire('1HB7W'));

});

parcelRegister("9MAA5", function(module, exports) {

let $71f4f9022e799838$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $71f4f9022e799838$var$load("1K1Fj"),
    $71f4f9022e799838$var$load("xnqy2"),
    $71f4f9022e799838$var$load("8hOn0"),
    $71f4f9022e799838$var$load("cM3gY"),
    $71f4f9022e799838$var$load("7PjNK"),
    $71f4f9022e799838$var$load("Vt6S9")
]).then(()=>parcelRequire('l8Ete'));

});

parcelRegister("g3cjJ", function(module, exports) {

let $baf67b191248e159$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $baf67b191248e159$var$load("7v6wU"),
    $baf67b191248e159$var$load("a8heY"),
    $baf67b191248e159$var$load("b544F"),
    $baf67b191248e159$var$load("9PPH7"),
    $baf67b191248e159$var$load("dzIm8"),
    $baf67b191248e159$var$load("hrf1M")
]).then(()=>parcelRequire('jpE1z'));

});

parcelRegister("cd8R2", function(module, exports) {

let $8e3d913c77f6c5bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8e3d913c77f6c5bb$var$load("asvK9"),
    $8e3d913c77f6c5bb$var$load("barSq"),
    $8e3d913c77f6c5bb$var$load("aBa7j"),
    $8e3d913c77f6c5bb$var$load("gctEz"),
    $8e3d913c77f6c5bb$var$load("hPZE5"),
    $8e3d913c77f6c5bb$var$load("QTjdE")
]).then(()=>parcelRequire('dtscy'));

});

parcelRegister("dVfFh", function(module, exports) {

let $a22cbfed16e308a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a22cbfed16e308a0$var$load("aEpRh"),
    $a22cbfed16e308a0$var$load("6hlNE"),
    $a22cbfed16e308a0$var$load("K6fhx"),
    $a22cbfed16e308a0$var$load("1y1eN"),
    $a22cbfed16e308a0$var$load("jqwnR"),
    $a22cbfed16e308a0$var$load("lsloj")
]).then(()=>parcelRequire('89BCe'));

});

parcelRegister("3R1mH", function(module, exports) {

let $2ce7616677e70228$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2ce7616677e70228$var$load("bSjyK"),
    $2ce7616677e70228$var$load("j6IGj"),
    $2ce7616677e70228$var$load("hlJc4"),
    $2ce7616677e70228$var$load("6tWAg"),
    $2ce7616677e70228$var$load("aOdaf")
]).then(()=>parcelRequire('e5v6R'));

});

parcelRegister("6uGdm", function(module, exports) {

let $4ba64a588ded1731$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ba64a588ded1731$var$load("5WkxF").then(()=>parcelRequire('dRB6U'));

});

parcelRegister("8fc7Q", function(module, exports) {

let $6009214d241845fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6009214d241845fe$var$load("1jsQH"),
    $6009214d241845fe$var$load("bv8GZ"),
    $6009214d241845fe$var$load("i5eMd"),
    $6009214d241845fe$var$load("i9sd0"),
    $6009214d241845fe$var$load("gyXEE"),
    $6009214d241845fe$var$load("hoPZ9")
]).then(()=>parcelRequire('4uCzr'));

});

parcelRegister("5D1pj", function(module, exports) {

let $4191afbbcfdd4a7f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4191afbbcfdd4a7f$var$load("9eNkX"),
    $4191afbbcfdd4a7f$var$load("dh2Er"),
    $4191afbbcfdd4a7f$var$load("k10Cs"),
    $4191afbbcfdd4a7f$var$load("1pFHs"),
    $4191afbbcfdd4a7f$var$load("8Mz40"),
    $4191afbbcfdd4a7f$var$load("l6YHr")
]).then(()=>parcelRequire('ttXag'));

});

parcelRegister("5VTmi", function(module, exports) {

let $451d37b325e638de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $451d37b325e638de$var$load("gDiIK"),
    $451d37b325e638de$var$load("eLlpV"),
    $451d37b325e638de$var$load("f1B4n"),
    $451d37b325e638de$var$load("7sItg"),
    $451d37b325e638de$var$load("1Tuyb"),
    $451d37b325e638de$var$load("7iCpI")
]).then(()=>parcelRequire('d3zyo'));

});

parcelRegister("gWhk4", function(module, exports) {

let $c54f8007ce39332e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c54f8007ce39332e$var$load("j9OUx"),
    $c54f8007ce39332e$var$load("bV8sS"),
    $c54f8007ce39332e$var$load("l079e"),
    $c54f8007ce39332e$var$load("kKXTS"),
    $c54f8007ce39332e$var$load("hF4v3"),
    $c54f8007ce39332e$var$load("afU9w")
]).then(()=>parcelRequire('9FNbj'));

});

parcelRegister("5vcUM", function(module, exports) {

let $4019dda20a8d29d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4019dda20a8d29d3$var$load("2YffH").then(()=>parcelRequire('1zv2N'));

});

parcelRegister("jZwD7", function(module, exports) {
var $e8dd0673f1b11f27$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
module.exports["default"] = $e8dd0673f1b11f27$export$2e2bcd8739ae039;

});

parcelRegister("aOdGZ", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $7de931e75fd7be56$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($7de931e75fd7be56$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $7de931e75fd7be56$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $7de931e75fd7be56$var$getRandomValues($7de931e75fd7be56$var$rnds8);
        return $7de931e75fd7be56$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $7de931e75fd7be56$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $7de931e75fd7be56$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $7de931e75fd7be56$var$rnds;
    };
}

});

parcelRegister("hEUUD", function(module, exports) {
/// <reference types="node" />
const $1f4159c5567c1673$export$a59f8d67326bd1cb = "0.0.0-use.local";
module.exports["CLIENT_VERSION"] = $1f4159c5567c1673$export$a59f8d67326bd1cb;

});

parcelRegister("g84RO", function(module, exports) {
"use strict";
var $bbe12b2767d5554b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bbe12b2767d5554b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bbe12b2767d5554b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $dnmqd = parcelRequire("dnmqd");

module.exports.StatsigClient = $dnmqd.default;

$bbe12b2767d5554b$var$__exportStar((parcelRequire("4XvZj")), module.exports);
const $bbe12b2767d5554b$var$__STATSIG__ = Object.assign((0, (parcelRequire("4XvZj"))._getStatsigGlobal)(), {
    StatsigClient: $dnmqd.default
});
module.exports.default = $bbe12b2767d5554b$var$__STATSIG__;

});

parcelRegister("kWb5j", function(module, exports) {

var $dYDWA = parcelRequire("dYDWA");

class $83240849c9194eb7$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        const config = new $83240849c9194eb7$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $dYDWA.migrateEvaluationDetails)(experiment.details), (0, $dYDWA.migrateSecondaryExposures)(experiment.__evaluation?.secondary_exposures ?? []), experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    get(key, defaultValue, typeGuard) {
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            this._onDefaultValueFallback?.(this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        this._onDefaultValueFallback?.(this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = void 0;
        this._name = void 0;
        this._ruleID = void 0;
        /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ this._secondaryExposures = void 0;
        this._allocatedExperimentName = void 0;
        this._evaluationDetails = void 0;
        this._onDefaultValueFallback = void 0;
        this.experiment = void 0;
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
}
module.exports["DynamicConfig"] = $83240849c9194eb7$export$6dc24881a3d96325;

});

parcelRegister("dYDWA", function(module, exports) {

var $lzcvT = parcelRequire("lzcvT");


var $3Fnbb = parcelRequire("3Fnbb");


var $7OROP = parcelRequire("7OROP");

const $1e37ba36f51c6658$export$d119b37e5f788b43 = (options)=>({
        /**
	 * If more federal PerimeterTypes are added in the future, this should be updated so
	 * that isFedRamp() === true always returns the strictest perimeter.
	 */ perimeter: (0, $lzcvT.isFedRamp)() ? (0, $7OROP.PerimeterType).FEDRAMP_MODERATE : (0, $7OROP.PerimeterType).COMMERCIAL,
        ...options
    });
const $1e37ba36f51c6658$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};
const $1e37ba36f51c6658$export$3dad1db244472f32 = (identifiers, customAttributes)=>{
    const user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
const $1e37ba36f51c6658$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};
const $1e37ba36f51c6658$var$evaluationReasonMappings = Object.entries((0, $3Fnbb.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $1e37ba36f51c6658$export$18ad168d3dbac899 = (details)=>{
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: $1e37ba36f51c6658$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))?.[1] ?? (0, $3Fnbb.EvaluationReason).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};
const $1e37ba36f51c6658$export$55fd683752d01e67 = (secondaryExposures)=>{
    return secondaryExposures.map((exposure)=>{
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};
module.exports["getOptionsWithDefaults"] = $1e37ba36f51c6658$export$d119b37e5f788b43;
module.exports["shallowEquals"] = $1e37ba36f51c6658$export$fa1c2bbf4100b8bc;
module.exports["toStatsigUser"] = $1e37ba36f51c6658$export$3dad1db244472f32;
module.exports["migrateInitializationOptions"] = $1e37ba36f51c6658$export$202946b690d26d22;
module.exports["migrateEvaluationDetails"] = $1e37ba36f51c6658$export$18ad168d3dbac899;
module.exports["migrateSecondaryExposures"] = $1e37ba36f51c6658$export$55fd683752d01e67;

});

parcelRegister("3Fnbb", function(module, exports) {
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $bf64b280dc5c1dad$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({});
module.exports["EvaluationReason"] = $bf64b280dc5c1dad$export$c62558b199e46828;

});

parcelRegister("1CKxc", function(module, exports) {
"use strict";
var $12ed6fda503ec405$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $12ed6fda503ec405$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $12ed6fda503ec405$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("g7kXt")).Diagnostics;
    }
});

var $2y1fg = parcelRequire("2y1fg");

Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $2y1fg.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("gEGY8")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("4DTY3")).Storage;
    }
});

$12ed6fda503ec405$var$__exportStar((parcelRequire("jThPW")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("bCidb")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("2TU3n")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("yyBtO")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("g7kXt")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("fZ2rG")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("gTaww")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("8tHvG")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("aVYNV")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("hfOjO")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("9oX2t")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("gEGY8")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("fwPWd")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("9SMpY")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("g2HdN")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("lhJ27")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("mHIrT")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("c03HY")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("csFe1")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("humPl")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("hNnlB")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("efYQm")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("dlQeO")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("4GR4m")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("7ndJy")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("e68I2")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("kqAyV")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("l7BAr")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("j4WXX")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("3WRYT")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("8qVRj")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("dYbRq")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("4DTY3")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("fpY7K")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("l5YTH")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("cRnPo")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("jWTBq")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("kOIO0")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("knKVb")), module.exports);

$12ed6fda503ec405$var$__exportStar((parcelRequire("bXP0P")), module.exports);
Object.assign((0, (parcelRequire("jThPW"))._getStatsigGlobal)(), {
    Log: (parcelRequire("gEGY8")).Log,
    SDK_VERSION: (parcelRequire("kqAyV")).SDK_VERSION
});

});

parcelRegister("DCfK4", function(module, exports) {
"use strict";
var $077150dcf50b3e42$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $8PnCm = parcelRequire("8PnCm");


var $ecDPx = parcelRequire("ecDPx");


var $druB2 = parcelRequire("druB2");


var $dc8O0 = parcelRequire("dc8O0");


var $7IzEC = parcelRequire("7IzEC");


var $99fLW = parcelRequire("99fLW");


var $62rFB = parcelRequire("62rFB");


var $dR8ux = parcelRequire("dR8ux");


var $d9YAx = parcelRequire("d9YAx");


var $7bskI = parcelRequire("7bskI");

const $077150dcf50b3e42$var$DEFAULT_QUEUE_SIZE = 100;
const $077150dcf50b3e42$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $077150dcf50b3e42$var$MAX_DEDUPER_KEYS = 1000;
const $077150dcf50b3e42$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $077150dcf50b3e42$var$MAX_FAILED_LOGS = 500;
const $077150dcf50b3e42$var$QUICK_FLUSH_WINDOW_MS = 200;
const $077150dcf50b3e42$var$EVENT_LOGGER_MAP = {};
const $077150dcf50b3e42$var$RetryFailedLogsTrigger = {
    Startup: 'startup',
    GainedFocus: 'gained_focus'
};
class $077150dcf50b3e42$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $077150dcf50b3e42$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $077150dcf50b3e42$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($077150dcf50b3e42$var$RetryFailedLogsTrigger.GainedFocus);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $077150dcf50b3e42$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $7IzEC._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $077150dcf50b3e42$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $7bskI._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $077150dcf50b3e42$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $077150dcf50b3e42$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($077150dcf50b3e42$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $077150dcf50b3e42$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $077150dcf50b3e42$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $077150dcf50b3e42$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $077150dcf50b3e42$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$077150dcf50b3e42$var$EventLogger._safeFlushAndForget(this._sdkKey), $077150dcf50b3e42$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $7IzEC._isServerEnv)()) return false;
        if (!(0, $99fLW._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $8PnCm._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $077150dcf50b3e42$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $077150dcf50b3e42$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $077150dcf50b3e42$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $7bskI._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $druB2.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $druB2.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $077150dcf50b3e42$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$dc8O0.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $077150dcf50b3e42$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $dR8ux._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $druB2.Log.warn('Unable to save failed logs to storage');
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$077150dcf50b3e42$var$__awaiter(this, void 0, void 0, function*() {
                if (!$dR8ux.Storage.isReady()) yield $dR8ux.Storage.isReadyResolver();
                const events = (0, $dR8ux._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $077150dcf50b3e42$var$RetryFailedLogsTrigger.Startup) $dR8ux.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $077150dcf50b3e42$var$RetryFailedLogsTrigger.GainedFocus) $dR8ux.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $druB2.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $ecDPx._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $druB2.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $7IzEC._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $077150dcf50b3e42$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $077150dcf50b3e42$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $077150dcf50b3e42$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $62rFB.LoggingEnabledOption.disabled : $62rFB.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $druB2.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $077150dcf50b3e42$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $d9YAx.UrlConfiguration($dc8O0.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
}
module.exports.EventLogger = $077150dcf50b3e42$var$EventLogger;

});

parcelRegister("2MfSb", function(module, exports) {
"use strict";
var $205c6083aa403dbe$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $g9T2X = parcelRequire("g9T2X");


var $ecDPx = parcelRequire("ecDPx");


var $druB2 = parcelRequire("druB2");


var $dR8ux = parcelRequire("dR8ux");

const $205c6083aa403dbe$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $205c6083aa403dbe$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $205c6083aa403dbe$var$NetworkFallbackResolver {
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $205c6083aa403dbe$var$DEFAULT_TTL_MS;
        $205c6083aa403dbe$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $205c6083aa403dbe$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $205c6083aa403dbe$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $205c6083aa403dbe$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$205c6083aa403dbe$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $205c6083aa403dbe$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $205c6083aa403dbe$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $205c6083aa403dbe$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $205c6083aa403dbe$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $g9T2X._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $205c6083aa403dbe$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
}
module.exports.NetworkFallbackResolver = $205c6083aa403dbe$var$NetworkFallbackResolver;
function $205c6083aa403dbe$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $205c6083aa403dbe$var$_isDomainFailure;
function $205c6083aa403dbe$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $ecDPx._DJB2)(sdkKey)}`;
}
function $205c6083aa403dbe$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $205c6083aa403dbe$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $dR8ux.Storage.removeItem(hashKey);
        return;
    }
    $dR8ux.Storage.setItem(hashKey, JSON.stringify(info));
}
function $205c6083aa403dbe$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $205c6083aa403dbe$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $dR8ux.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $druB2.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $205c6083aa403dbe$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});

parcelRegister("5QGKZ", function(module, exports) {
"use strict";
var $4422f9b44f214771$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $8SG8i = parcelRequire("8SG8i");


var $hfOjO = parcelRequire("hfOjO");


var $gEGY8 = parcelRequire("gEGY8");


var $4DTY3 = parcelRequire("4DTY3");

const $4422f9b44f214771$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $4422f9b44f214771$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $4422f9b44f214771$var$NetworkFallbackResolver {
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $4422f9b44f214771$var$DEFAULT_TTL_MS;
        $4422f9b44f214771$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $4422f9b44f214771$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $4422f9b44f214771$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $4422f9b44f214771$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$4422f9b44f214771$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $4422f9b44f214771$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $4422f9b44f214771$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $4422f9b44f214771$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $4422f9b44f214771$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $8SG8i._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $4422f9b44f214771$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
}
module.exports.NetworkFallbackResolver = $4422f9b44f214771$var$NetworkFallbackResolver;
function $4422f9b44f214771$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $4422f9b44f214771$var$_isDomainFailure;
function $4422f9b44f214771$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $hfOjO._DJB2)(sdkKey)}`;
}
function $4422f9b44f214771$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $4422f9b44f214771$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $4DTY3.Storage.removeItem(hashKey);
        return;
    }
    $4DTY3.Storage.setItem(hashKey, JSON.stringify(info));
}
function $4422f9b44f214771$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $4422f9b44f214771$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $4DTY3.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $gEGY8.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $4422f9b44f214771$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});

parcelRegister("2y1fg", function(module, exports) {
"use strict";
var $1dafb9039f2493e6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $bCidb = parcelRequire("bCidb");


var $hfOjO = parcelRequire("hfOjO");


var $gEGY8 = parcelRequire("gEGY8");


var $9SMpY = parcelRequire("9SMpY");


var $c03HY = parcelRequire("c03HY");


var $e68I2 = parcelRequire("e68I2");


var $l7BAr = parcelRequire("l7BAr");


var $4DTY3 = parcelRequire("4DTY3");


var $cRnPo = parcelRequire("cRnPo");


var $kOIO0 = parcelRequire("kOIO0");

const $1dafb9039f2493e6$var$DEFAULT_QUEUE_SIZE = 100;
const $1dafb9039f2493e6$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $1dafb9039f2493e6$var$MAX_DEDUPER_KEYS = 1000;
const $1dafb9039f2493e6$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $1dafb9039f2493e6$var$MAX_FAILED_LOGS = 500;
const $1dafb9039f2493e6$var$QUICK_FLUSH_WINDOW_MS = 200;
const $1dafb9039f2493e6$var$EVENT_LOGGER_MAP = {};
const $1dafb9039f2493e6$var$RetryFailedLogsTrigger = {
    Startup: 'startup',
    GainedFocus: 'gained_focus'
};
class $1dafb9039f2493e6$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $1dafb9039f2493e6$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $1dafb9039f2493e6$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($1dafb9039f2493e6$var$RetryFailedLogsTrigger.GainedFocus);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $1dafb9039f2493e6$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $c03HY._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $1dafb9039f2493e6$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $kOIO0._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $1dafb9039f2493e6$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $1dafb9039f2493e6$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($1dafb9039f2493e6$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $1dafb9039f2493e6$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $1dafb9039f2493e6$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $1dafb9039f2493e6$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $1dafb9039f2493e6$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$1dafb9039f2493e6$var$EventLogger._safeFlushAndForget(this._sdkKey), $1dafb9039f2493e6$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $c03HY._isServerEnv)()) return false;
        if (!(0, $e68I2._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $bCidb._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $1dafb9039f2493e6$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $1dafb9039f2493e6$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $1dafb9039f2493e6$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $kOIO0._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $gEGY8.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $gEGY8.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $1dafb9039f2493e6$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$9SMpY.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $1dafb9039f2493e6$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $4DTY3._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $gEGY8.Log.warn('Unable to save failed logs to storage');
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$1dafb9039f2493e6$var$__awaiter(this, void 0, void 0, function*() {
                if (!$4DTY3.Storage.isReady()) yield $4DTY3.Storage.isReadyResolver();
                const events = (0, $4DTY3._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $1dafb9039f2493e6$var$RetryFailedLogsTrigger.Startup) $4DTY3.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $1dafb9039f2493e6$var$RetryFailedLogsTrigger.GainedFocus) $4DTY3.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $gEGY8.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $hfOjO._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $gEGY8.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $c03HY._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $1dafb9039f2493e6$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $1dafb9039f2493e6$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $1dafb9039f2493e6$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $l7BAr.LoggingEnabledOption.disabled : $l7BAr.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $gEGY8.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $1dafb9039f2493e6$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $cRnPo.UrlConfiguration($9SMpY.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
}
module.exports.EventLogger = $1dafb9039f2493e6$var$EventLogger;

});

parcelRegister("bLmKG", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("7WErB", function(module, exports) {
'use strict';

var $kXkoT = parcelRequire("kXkoT");

module.exports = Function.prototype.bind || $kXkoT;

});

parcelRegister("guZe9", function(module, exports) {

var $19Cca = parcelRequire("19Cca");


var $7RTAm = parcelRequire("7RTAm");


var $hXuPC = parcelRequire("hXuPC");


var $2uzbP = parcelRequire("2uzbP");


var $b3YTN = parcelRequire("b3YTN");


var $kyRHQ = parcelRequire("kyRHQ");

function $c02ef11d754f4d90$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $c02ef11d754f4d90$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $c02ef11d754f4d90$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $c02ef11d754f4d90$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $c02ef11d754f4d90$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $c02ef11d754f4d90$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $c02ef11d754f4d90$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $c02ef11d754f4d90$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $c02ef11d754f4d90$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $c02ef11d754f4d90$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $c02ef11d754f4d90$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $c02ef11d754f4d90$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($c02ef11d754f4d90$var$isIntValue(value) || $c02ef11d754f4d90$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($c02ef11d754f4d90$var$isBooleanValue(value) || $c02ef11d754f4d90$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($c02ef11d754f4d90$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $c02ef11d754f4d90$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($c02ef11d754f4d90$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($c02ef11d754f4d90$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $c02ef11d754f4d90$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($c02ef11d754f4d90$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($c02ef11d754f4d90$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $7RTAm.InvariantError)(17);
}
function $c02ef11d754f4d90$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $c02ef11d754f4d90$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $c02ef11d754f4d90$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $c02ef11d754f4d90$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $c02ef11d754f4d90$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $c02ef11d754f4d90$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($c02ef11d754f4d90$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $c02ef11d754f4d90$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $c02ef11d754f4d90$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $c02ef11d754f4d90$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $c02ef11d754f4d90$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $c02ef11d754f4d90$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $c02ef11d754f4d90$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $c02ef11d754f4d90$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $hXuPC.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $c02ef11d754f4d90$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $c02ef11d754f4d90$var$defaultValueFromVariable(node) {
    throw new (0, $7RTAm.InvariantError)(18);
}
function $c02ef11d754f4d90$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $c02ef11d754f4d90$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $c02ef11d754f4d90$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $c02ef11d754f4d90$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $c02ef11d754f4d90$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $c02ef11d754f4d90$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $c02ef11d754f4d90$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $c02ef11d754f4d90$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $7RTAm.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $c02ef11d754f4d90$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $19Cca.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $c02ef11d754f4d90$export$2dafb573e282fe8d(names, doc) {
    return $c02ef11d754f4d90$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $c02ef11d754f4d90$export$8d1e9e5bbfa5d09a(document) {
    return document && $c02ef11d754f4d90$export$2dafb573e282fe8d([
        'client'
    ], document) && $c02ef11d754f4d90$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $c02ef11d754f4d90$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $c02ef11d754f4d90$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($c02ef11d754f4d90$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $7RTAm.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $7RTAm.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $7RTAm.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $c02ef11d754f4d90$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $7RTAm.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $7RTAm.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, document), {
        definitions: (0, $hXuPC.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $c02ef11d754f4d90$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $c02ef11d754f4d90$export$a92e7a440b22bdf0(doc) {
    $c02ef11d754f4d90$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $7RTAm.invariant)(mutationDef, 1);
    return mutationDef;
}
function $c02ef11d754f4d90$export$a7d0d8111d2386df(doc) {
    (0, $7RTAm.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $7RTAm.InvariantError)(3);
        return definition;
    });
    (0, $7RTAm.invariant)(operations.length <= 1, 4);
    return doc;
}
function $c02ef11d754f4d90$export$7a5b1fa979d2c158(doc) {
    $c02ef11d754f4d90$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $c02ef11d754f4d90$export$78a8e95d8d43ad7f(document) {
    var def = $c02ef11d754f4d90$export$7a5b1fa979d2c158(document);
    (0, $7RTAm.invariant)(def, 5);
    return def;
}
function $c02ef11d754f4d90$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $c02ef11d754f4d90$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $c02ef11d754f4d90$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $c02ef11d754f4d90$export$7a5b1fa979d2c158(doc);
    (0, $7RTAm.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $c02ef11d754f4d90$export$772111caef41b3f5(doc) {
    (0, $7RTAm.invariant)(doc.kind === 'Document', 7);
    (0, $7RTAm.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $7RTAm.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $c02ef11d754f4d90$export$f431198736b7f96d(queryDoc) {
    $c02ef11d754f4d90$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $7RTAm.InvariantError)(10);
}
function $c02ef11d754f4d90$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $c02ef11d754f4d90$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $c02ef11d754f4d90$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $c02ef11d754f4d90$export$e6e34fd1f2686227.apply(void 0, (0, $hXuPC.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $c02ef11d754f4d90$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $c02ef11d754f4d90$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $c02ef11d754f4d90$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $c02ef11d754f4d90$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $c02ef11d754f4d90$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $c02ef11d754f4d90$var$nullIfDocIsEmpty(doc) {
    return $c02ef11d754f4d90$var$isEmpty($c02ef11d754f4d90$export$7a5b1fa979d2c158(doc) || $c02ef11d754f4d90$export$772111caef41b3f5(doc), $c02ef11d754f4d90$export$193789b4c8246dd4($c02ef11d754f4d90$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $c02ef11d754f4d90$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $c02ef11d754f4d90$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $c02ef11d754f4d90$var$nullIfDocIsEmpty((0, $19Cca.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($c02ef11d754f4d90$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $c02ef11d754f4d90$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($c02ef11d754f4d90$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $c02ef11d754f4d90$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $c02ef11d754f4d90$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $c02ef11d754f4d90$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $c02ef11d754f4d90$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $c02ef11d754f4d90$export$43b332f87950a467(doc) {
    return (0, $19Cca.visit)($c02ef11d754f4d90$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $c02ef11d754f4d90$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($c02ef11d754f4d90$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, node), {
                    selections: (0, $hXuPC.__spreadArrays)(selections, [
                        $c02ef11d754f4d90$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $c02ef11d754f4d90$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $c02ef11d754f4d90$export$74985f3324559867(doc) {
    return $c02ef11d754f4d90$export$e5ae0530da5fe96c([
        $c02ef11d754f4d90$var$connectionRemoveConfig
    ], $c02ef11d754f4d90$export$a7d0d8111d2386df(doc));
}
function $c02ef11d754f4d90$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $c02ef11d754f4d90$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $c02ef11d754f4d90$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$c02ef11d754f4d90$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($c02ef11d754f4d90$var$getDirectiveMatcher(directives)) || nestedCheck && $c02ef11d754f4d90$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $c02ef11d754f4d90$export$deed3420cb5d2e1d(directives, doc) {
    $c02ef11d754f4d90$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $c02ef11d754f4d90$var$nullIfDocIsEmpty((0, $19Cca.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $c02ef11d754f4d90$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($c02ef11d754f4d90$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $c02ef11d754f4d90$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $c02ef11d754f4d90$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $c02ef11d754f4d90$var$getArgumentMatcher(config);
    return $c02ef11d754f4d90$var$nullIfDocIsEmpty((0, $19Cca.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $c02ef11d754f4d90$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $c02ef11d754f4d90$var$nullIfDocIsEmpty((0, $19Cca.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $c02ef11d754f4d90$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($c02ef11d754f4d90$export$fb56ad75dd311c12(selection) || $c02ef11d754f4d90$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $c02ef11d754f4d90$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $c02ef11d754f4d90$export$57c368c23873f32b(document) {
    var definition = $c02ef11d754f4d90$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $19Cca.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $c02ef11d754f4d90$export$8eae69e876ee321e(document) {
    $c02ef11d754f4d90$export$a7d0d8111d2386df(document);
    var modifiedDoc = $c02ef11d754f4d90$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $19Cca.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $c02ef11d754f4d90$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $c02ef11d754f4d90$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $c02ef11d754f4d90$var$toString = Object.prototype.toString;
function $c02ef11d754f4d90$export$629a2bd3f5a49ecc(value) {
    return $c02ef11d754f4d90$var$cloneDeepHelper(value, new Map());
}
function $c02ef11d754f4d90$var$cloneDeepHelper(val, seen) {
    switch($c02ef11d754f4d90$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $c02ef11d754f4d90$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $c02ef11d754f4d90$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $c02ef11d754f4d90$export$4bd44a2aa29d3d6e() {
    if (typeof $kyRHQ !== 'undefined' && "production") return "production";
    return 'development';
}
function $c02ef11d754f4d90$export$f0cb0fda19c18b37(env) {
    return $c02ef11d754f4d90$export$4bd44a2aa29d3d6e() === env;
}
function $c02ef11d754f4d90$export$f15d00aa73aafac4() {
    return $c02ef11d754f4d90$export$f0cb0fda19c18b37('production') === true;
}
function $c02ef11d754f4d90$export$df77466336fe5355() {
    return $c02ef11d754f4d90$export$f0cb0fda19c18b37('development') === true;
}
function $c02ef11d754f4d90$export$410cbc2864fa25b5() {
    return $c02ef11d754f4d90$export$f0cb0fda19c18b37('test') === true;
}
function $c02ef11d754f4d90$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $c02ef11d754f4d90$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $c02ef11d754f4d90$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $c02ef11d754f4d90$var$deepFreeze(o[prop]);
    });
    return o;
}
function $c02ef11d754f4d90$export$7f9c177735b71f18(obj) {
    if ($c02ef11d754f4d90$export$df77466336fe5355() || $c02ef11d754f4d90$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $c02ef11d754f4d90$var$deepFreeze(obj);
    }
    return obj;
}
var $c02ef11d754f4d90$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $c02ef11d754f4d90$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $c02ef11d754f4d90$export$160070228be94b08(sources);
}
function $c02ef11d754f4d90$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $c02ef11d754f4d90$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $c02ef11d754f4d90$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $c02ef11d754f4d90$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $c02ef11d754f4d90$var$mergeHelper(target, source, pastCopies) {
    if ($c02ef11d754f4d90$var$isObject(source) && $c02ef11d754f4d90$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $c02ef11d754f4d90$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($c02ef11d754f4d90$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $c02ef11d754f4d90$var$mergeHelper($c02ef11d754f4d90$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $c02ef11d754f4d90$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $hXuPC.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $c02ef11d754f4d90$var$haveWarned = Object.create({});
function $c02ef11d754f4d90$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$c02ef11d754f4d90$export$f15d00aa73aafac4() && !$c02ef11d754f4d90$var$haveWarned[msg]) {
        if (!$c02ef11d754f4d90$export$410cbc2864fa25b5()) $c02ef11d754f4d90$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $c02ef11d754f4d90$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}
module.exports["storeKeyNameFromField"] = $c02ef11d754f4d90$export$54be8689c65f3b56;
module.exports["getStoreKeyName"] = $c02ef11d754f4d90$export$3cdb6c178b88cabe;
module.exports["argumentsObjectFromField"] = $c02ef11d754f4d90$export$3f5a60fb6a781b4f;
module.exports["resultKeyNameFromField"] = $c02ef11d754f4d90$export$7d1ad22471852218;
module.exports["isField"] = $c02ef11d754f4d90$export$fb56ad75dd311c12;
module.exports["isInlineFragment"] = $c02ef11d754f4d90$export$22a1cdafaf27bcff;
module.exports["isIdValue"] = $c02ef11d754f4d90$export$e33b89a9aa87695;
module.exports["toIdValue"] = $c02ef11d754f4d90$export$b124f125e34d720a;
module.exports["isJsonValue"] = $c02ef11d754f4d90$export$226c1c6d1a5b660a;
module.exports["getDirectiveInfoFromField"] = $c02ef11d754f4d90$export$2a7f471142984a91;
module.exports["shouldInclude"] = $c02ef11d754f4d90$export$3dc388a5f013b4a5;
module.exports["hasDirectives"] = $c02ef11d754f4d90$export$2dafb573e282fe8d;
module.exports["hasClientExports"] = $c02ef11d754f4d90$export$8d1e9e5bbfa5d09a;
module.exports["getFragmentQueryDocument"] = $c02ef11d754f4d90$export$abbf37c7cf644e41;
module.exports["assign"] = $c02ef11d754f4d90$export$e6e34fd1f2686227;
module.exports["getOperationDefinition"] = $c02ef11d754f4d90$export$7a5b1fa979d2c158;
module.exports["getOperationName"] = $c02ef11d754f4d90$export$41bca9dc6871dd4e;
module.exports["getFragmentDefinitions"] = $c02ef11d754f4d90$export$5320a7ba9466a3df;
module.exports["getQueryDefinition"] = $c02ef11d754f4d90$export$d96b2213c1b9d3a9;
module.exports["getMainDefinition"] = $c02ef11d754f4d90$export$f431198736b7f96d;
module.exports["createFragmentMap"] = $c02ef11d754f4d90$export$193789b4c8246dd4;
module.exports["getDefaultValues"] = $c02ef11d754f4d90$export$84c19026e616569e;
module.exports["addTypenameToDocument"] = $c02ef11d754f4d90$export$43b332f87950a467;
module.exports["removeConnectionDirectiveFromDocument"] = $c02ef11d754f4d90$export$74985f3324559867;
module.exports["buildQueryFromSelectionSet"] = $c02ef11d754f4d90$export$57c368c23873f32b;
module.exports["removeClientSetsFromDocument"] = $c02ef11d754f4d90$export$8eae69e876ee321e;
module.exports["canUseWeakMap"] = $c02ef11d754f4d90$export$772fbc04a0ad4ce9;
module.exports["cloneDeep"] = $c02ef11d754f4d90$export$629a2bd3f5a49ecc;
module.exports["isProduction"] = $c02ef11d754f4d90$export$f15d00aa73aafac4;
module.exports["isTest"] = $c02ef11d754f4d90$export$410cbc2864fa25b5;
module.exports["tryFunctionOrLogError"] = $c02ef11d754f4d90$export$50a91acae4904909;
module.exports["graphQLResultHasError"] = $c02ef11d754f4d90$export$b4df399e879e53ab;
module.exports["mergeDeep"] = $c02ef11d754f4d90$export$dd702b3c8240390c;
module.exports["mergeDeepArray"] = $c02ef11d754f4d90$export$160070228be94b08;

});

parcelRegister("b3YTN", function(module, exports) {
var $80df36cbaad55fbc$var$_a = Object.prototype, $80df36cbaad55fbc$var$toString = $80df36cbaad55fbc$var$_a.toString, $80df36cbaad55fbc$var$hasOwnProperty = $80df36cbaad55fbc$var$_a.hasOwnProperty;
var $80df36cbaad55fbc$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $80df36cbaad55fbc$export$411ce8e5a71e3069(a, b) {
    try {
        return $80df36cbaad55fbc$var$check(a, b);
    } finally{
        $80df36cbaad55fbc$var$previousComparisons.clear();
    }
}
function $80df36cbaad55fbc$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $80df36cbaad55fbc$var$toString.call(a);
    var bTag = $80df36cbaad55fbc$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($80df36cbaad55fbc$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$80df36cbaad55fbc$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$80df36cbaad55fbc$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($80df36cbaad55fbc$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$80df36cbaad55fbc$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $80df36cbaad55fbc$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $80df36cbaad55fbc$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $80df36cbaad55fbc$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $80df36cbaad55fbc$export$2e2bcd8739ae039 = $80df36cbaad55fbc$export$411ce8e5a71e3069;
module.exports["equal"] = $80df36cbaad55fbc$export$411ce8e5a71e3069;

});

parcelRegister("9Z0h9", function(module, exports) {
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $744a064d896477f8$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $744a064d896477f8$export$2e2bcd8739ae039 = $744a064d896477f8$var$nodejsCustomInspectSymbol;
module.exports["default"] = $744a064d896477f8$export$2e2bcd8739ae039;

});

parcelRegister("jLTuK", function(module, exports) {
var $a8e82721b57c13a7$exports = {};

$a8e82721b57c13a7$exports = (parcelRequire("lqRg6")).Observable;


var $e64d743f3b3b51d1$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($a8e82721b57c13a7$exports)));
var $e64d743f3b3b51d1$export$2e2bcd8739ae039 = $e64d743f3b3b51d1$export$77cea355fa80b5f4;
module.exports["default"] = $e64d743f3b3b51d1$export$2e2bcd8739ae039;

});

parcelRegister("7RTAm", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $5ba899c03cc7302d$export$f5708dca728d7177);

var $hXuPC = parcelRequire("hXuPC");


var $kyRHQ = parcelRequire("kyRHQ");

var $5ba899c03cc7302d$var$genericMessage = "Invariant Violation";
var $5ba899c03cc7302d$var$_a = Object.setPrototypeOf, $5ba899c03cc7302d$var$setPrototypeOf = $5ba899c03cc7302d$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $5ba899c03cc7302d$var$_a;
var $5ba899c03cc7302d$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $5ba899c03cc7302d$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $5ba899c03cc7302d$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $5ba899c03cc7302d$var$genericMessage;
        $5ba899c03cc7302d$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $5ba899c03cc7302d$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $5ba899c03cc7302d$export$cea12affaee22fe8(message);
}
function $5ba899c03cc7302d$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $5ba899c03cc7302d$var$wrapConsoleMethod("warn");
    invariant.error = $5ba899c03cc7302d$var$wrapConsoleMethod("error");
})($5ba899c03cc7302d$export$f5708dca728d7177 || ($5ba899c03cc7302d$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $5ba899c03cc7302d$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $kyRHQ === "object") $5ba899c03cc7302d$export$e54fe5b0f43758f7 = $kyRHQ;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($5ba899c03cc7302d$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $5ba899c03cc7302d$var$invariant$1 = $5ba899c03cc7302d$export$f5708dca728d7177;
var $5ba899c03cc7302d$export$2e2bcd8739ae039 = $5ba899c03cc7302d$var$invariant$1;
module.exports["InvariantError"] = $5ba899c03cc7302d$export$cea12affaee22fe8;

});

parcelRegister("a2LhX", function(module, exports) {
const $59d0fa0e69f3d586$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $59d0fa0e69f3d586$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $59d0fa0e69f3d586$export$2e2bcd8739ae039.prototype);
        this.name = $59d0fa0e69f3d586$export$a409c8de90e11e14;
    }
}
module.exports["CallbackProcessingErrorName"] = $59d0fa0e69f3d586$export$a409c8de90e11e14;
module.exports["default"] = $59d0fa0e69f3d586$export$2e2bcd8739ae039;

});

parcelRegister("abcF7", function(module, exports) {
const $b045c83a22757ad7$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $b045c83a22757ad7$export$8cad224051643259 = 'analytics-web-client';
const $b045c83a22757ad7$export$3d8420be07b276ab = 'analytics-resilience';
const $b045c83a22757ad7$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $b045c83a22757ad7$export$89d9c1ff8ac91862 = 'timeAdded';
const $b045c83a22757ad7$export$a37d385bcd713809 = 'retryAttempts';
const $b045c83a22757ad7$export$6d8635fed0e4b14d = 15000;
var $b045c83a22757ad7$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $b045c83a22757ad7$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});
module.exports["NAMESPACE_AND_TIME_ADDED_INDEX"] = $b045c83a22757ad7$export$d21fbb25eb37b5bf;
module.exports["RESILIENCE_DB_NAME"] = $b045c83a22757ad7$export$8cad224051643259;
module.exports["RESILIENCE_STORE_NAME"] = $b045c83a22757ad7$export$3d8420be07b276ab;
module.exports["TIME_TO_PROCESS_AFTER_INDEX"] = $b045c83a22757ad7$export$a512a65455fce2a6;
module.exports["TIME_ADDED_INDEX"] = $b045c83a22757ad7$export$89d9c1ff8ac91862;
module.exports["RETRY_INDEX"] = $b045c83a22757ad7$export$a37d385bcd713809;
module.exports["INDEXEDDB_TIMEOUT"] = $b045c83a22757ad7$export$6d8635fed0e4b14d;
module.exports["StoreType"] = $b045c83a22757ad7$export$39337ab5872e9457;
module.exports["GuardPolicy"] = $b045c83a22757ad7$export$7710d69e6f450f20;

});

parcelRegister("iGeiI", function(module, exports) {

var $byR6T = parcelRequire("byR6T");


var $iyPdu = parcelRequire("iyPdu");

class $07d61d66ac1034e7$export$2e2bcd8739ae039 extends (0, $iyPdu.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $byR6T.default);
        } catch (err) {
            storageToUse = (0, $byR6T.default);
        }
        super(storageToUse, options);
    }
}
module.exports["default"] = $07d61d66ac1034e7$export$2e2bcd8739ae039;

});

parcelRegister("ewjj9", function(module, exports) {
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $99ce6124d9125272$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $99ce6124d9125272$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $99ce6124d9125272$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $99ce6124d9125272$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $99ce6124d9125272$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $99ce6124d9125272$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$99ce6124d9125272$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $99ce6124d9125272$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);
module.exports["mapKeys"] = $99ce6124d9125272$export$781522908e4e76a1;
module.exports["pick"] = $99ce6124d9125272$export$357523c63a2253b9;
module.exports["omitBy"] = $99ce6124d9125272$export$d7a617dda645b4e3;
module.exports["pickBy"] = $99ce6124d9125272$export$b460b275d6c6aa0;
module.exports["omit"] = $99ce6124d9125272$export$30a06c8d3562193f;
module.exports["equals"] = $99ce6124d9125272$export$e9bab7fafb253603;
module.exports["partition"] = $99ce6124d9125272$export$b29f828819edca8d;

});

parcelRegister("bKFjF", function(module, exports) {
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $9679a611363f717e$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $9679a611363f717e$var$isObjectObject(o) {
    return $9679a611363f717e$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $9679a611363f717e$export$53b83ca8eaab0383(o) {
    if ($9679a611363f717e$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($9679a611363f717e$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}
module.exports["isPlainObject"] = $9679a611363f717e$export$53b83ca8eaab0383;

});

parcelRegister("ERH8u", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $07ad6332cd0e62d6$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $07ad6332cd0e62d6$var$eq;

});

parcelRegister("aSUgi", function(module, exports) {

var $4Q9Y3 = parcelRequire("4Q9Y3");


var $7klPX = parcelRequire("7klPX");


var $2v38A = parcelRequire("2v38A");


var $1h87E = parcelRequire("1h87E");


var $9pbIA = parcelRequire("9pbIA");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7eca96f06445c907$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$7eca96f06445c907$var$MapCache.prototype.clear = $4Q9Y3;
$7eca96f06445c907$var$MapCache.prototype['delete'] = $7klPX;
$7eca96f06445c907$var$MapCache.prototype.get = $2v38A;
$7eca96f06445c907$var$MapCache.prototype.has = $1h87E;
$7eca96f06445c907$var$MapCache.prototype.set = $9pbIA;
module.exports = $7eca96f06445c907$var$MapCache;

});

parcelRegister("2ivnr", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $1ac59a0a3f1572ec$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $1ac59a0a3f1572ec$var$freeGlobal;

});

parcelRegister("4CWcc", function(module, exports) {
/** Used as references for various `Number` constants. */ var $35e7da8130935297$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $35e7da8130935297$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $35e7da8130935297$var$MAX_SAFE_INTEGER;
}
module.exports = $35e7da8130935297$var$isLength;

});

parcelRegister("k1Lsb", function(module, exports) {

var $6Uwva = parcelRequire("6Uwva");


var $7DiKo = parcelRequire("7DiKo");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e948b5e8bd08a2b0$var$getNative(object, key) {
    var value = $7DiKo(object, key);
    return $6Uwva(value) ? value : undefined;
}
module.exports = $e948b5e8bd08a2b0$var$getNative;

});

parcelRegister("iiQrz", function(module, exports) {

var $k1Lsb = parcelRequire("k1Lsb");


var $c2Pwh = parcelRequire("c2Pwh");

/* Built-in method references that are verified to be native. */ var $d53296a809ec74ca$var$Map = $k1Lsb($c2Pwh, 'Map');
module.exports = $d53296a809ec74ca$var$Map;

});

parcelRegister("gnC5r", function(module, exports) {
/** Used for built-in method references. */ var $becc568a34afe63a$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $becc568a34afe63a$var$funcToString = $becc568a34afe63a$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $becc568a34afe63a$var$toSource(func) {
    if (func != null) {
        try {
            return $becc568a34afe63a$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $becc568a34afe63a$var$toSource;

});

parcelRegister("ECRpY", function(module, exports) {

var $iGqJ7 = parcelRequire("iGqJ7");

const $f3838902fc4e0ba4$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
const $f3838902fc4e0ba4$export$8ed1df9dbe2e9a7d = (obj)=>{
    return obj ? Object.keys(obj).length === 0 : true;
};
const $f3838902fc4e0ba4$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
    attributes.forEach((attribute)=>{
        if (!(attribute in obj)) {
            const title = identifier ? `${identifier}: ` : '';
            throw new Error(`${title}Missing ${attribute}`);
        }
    });
};
const $f3838902fc4e0ba4$export$891630e169ca14a4 = (customAttributes)=>{
    const reservedAttributes = [
        'flagKey',
        'ruleId',
        'reason',
        'value',
        'errorKind'
    ];
    const keys = customAttributes ? Object.keys(customAttributes) : [];
    if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
};
const $f3838902fc4e0ba4$var$validateFlag = (flagKey, flag)=>{
    if ($f3838902fc4e0ba4$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
};
const $f3838902fc4e0ba4$export$410eec87ab950965 = (flags)=>{
    Object.keys(flags).forEach((key)=>$f3838902fc4e0ba4$var$validateFlag(key, flags[key]));
};


const $f2d1168707e5ae70$export$933245d8afcc8872 = {
    kind: 'ERROR',
    errorKind: 'FLAG_NOT_FOUND'
};
class $f2d1168707e5ae70$export$2e2bcd8739ae039 {
    evaluate(defaultValue) {
        return defaultValue;
    }
    getBooleanValue(options) {
        return this.evaluate(options.default);
    }
    getVariantValue(options) {
        return this.evaluate(options.default);
    }
    getJSONValue() {
        return this.evaluate({});
    }
    getRawValue(options) {
        return this.evaluate(options.default);
    }
    getFlagEvaluation(options) {
        const value = this.evaluate(options.default);
        return {
            value: value,
            explanation: $f2d1168707e5ae70$export$933245d8afcc8872
        };
    }
    constructor(){
        // Unused but required for type
        this.evaluationCount = -1;
    }
}





class $f5c427f90aa2c3ea$export$2e2bcd8739ae039 {
    getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let exposureTriggerReason = (0, $iGqJ7.ExposureTriggerReason).OptIn;
        if (shouldTrackExposureEvent === undefined) {
            shouldTrackExposureEvent = true;
            exposureTriggerReason = (0, $iGqJ7.ExposureTriggerReason).Default;
        }
        // It is very common for products to call this method many times for the same flag key,
        // as flag evaluations are often done inside action callbacks and/or inside components with many instances.
        // We can cache the result of the first evaluation to avoid doing the same validation checks on every call.
        if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
            oneOf: oneOf,
            ignoreTypes: ignoreTypes
        });
        let value = this.evaluationResult.value;
        if (this.evaluationResult.didFallbackToDefaultValue) // Use the default that was passed in, just in case it's different to what it was in the initial evaluation
        value = defaultValue;
        else if (shouldTrackExposureEvent) // For backwards compability, only fire the opt-in exposure event in valid evaluations.
        this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
        this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
        this.evaluationCount++;
        return {
            value: value,
            explanation: this.evaluationResult.explanation
        };
    }
    computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let result = {
            value: this.flag.value,
            explanation: this.flag.explanation,
            didFallbackToDefaultValue: false
        };
        if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'WRONG_TYPE'
            };
        } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'VALIDATION_ERROR'
            };
        }
        return result;
    }
    getBooleanValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: undefined,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getVariantValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: options.oneOf,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getJSONValue() {
        return this.getCachedResultOrCompute({}, {
            shouldTrackExposureEvent: false,
            ignoreTypes: this.ignoreTypes
        }).value;
    }
    getRawValue(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            oneOf: undefined,
            ignoreTypes: true
        }).value;
    }
    getFlagEvaluation(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            ignoreTypes: this.ignoreTypes || false
        });
    }
    constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
        this.evaluationCount = void 0;
        this.flagKey = void 0;
        this.flag = void 0;
        this.trackExposure = void 0;
        this.sendAutomaticExposure = void 0;
        this.ignoreTypes = void 0;
        // Makes the casting easier later on. The APIs should not leak any.
        // Should only be used in private functions.
        this.evaluationResult = void 0;
        this.flagKey = flagKey;
        this.flag = flag;
        this.evaluationCount = 0;
        this.trackExposure = trackExposure;
        this.sendAutomaticExposure = sendAutomaticExposure;
        this.ignoreTypes = ignoreTypes;
    }
}


class $beddd9d801215c13$export$2e2bcd8739ae039 {
    setFlags(flags) {
        if (!(0, $f3838902fc4e0ba4$export$a6cdc56e425d0d0a)(flags)) return;
        Object.entries(flags).forEach(([flagKey, flag])=>{
            this.flags.set(flagKey, flag);
        });
        // Clear any cached data for flags that have been passed in again,
        // in case they have different values or explanations
        for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
    }
    setAnalyticsHandler(analyticsHandler) {
        this.analyticsHandler = analyticsHandler;
    }
    setIsAutomaticExposuresEnabled(isEnabled) {
        this.isAutomaticExposuresEnabled = isEnabled;
    }
    /**
   * This method returns the wrapper object for the given flag key.
   * If the flag does not exist, this will return a stubbed flag following the null-object pattern,
   * so it is always guaranteed to return an object.
   */ getFlagWrapper(flagKey) {
        let wrapper = this.flagWrapperCache.get(flagKey);
        if (wrapper !== undefined) return wrapper;
        const flag = this.flags.get(flagKey);
        if (flag) wrapper = new (0, $f5c427f90aa2c3ea$export$2e2bcd8739ae039)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
        else wrapper = new (0, $f2d1168707e5ae70$export$2e2bcd8739ae039)();
        this.flagWrapperCache.set(flagKey, wrapper);
        return wrapper;
    }
    clear() {
        this.flags.clear();
        this.flagWrapperCache.clear();
        this.trackedFlags.clear();
    }
    getBooleanValue(flagKey, options) {
        (0, $f3838902fc4e0ba4$export$c7d37910dd25ecbf)(options, [
            'default'
        ], 'getBooleanValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getBooleanValue(options);
    }
    getVariantValue(flagKey, options) {
        (0, $f3838902fc4e0ba4$export$c7d37910dd25ecbf)(options, [
            'default',
            'oneOf'
        ], 'getVariantValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getVariantValue(options);
    }
    getJSONValue(flagKey) {
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getJSONValue();
    }
    getRawValue(flagKey, options) {
        (0, $f3838902fc4e0ba4$export$c7d37910dd25ecbf)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getRawValue(options);
    }
    getFlagEvaluation(flagKey, options) {
        (0, $f3838902fc4e0ba4$export$c7d37910dd25ecbf)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getFlagEvaluation(options);
    }
    /**
   * This method combines both the trackExposure and sendAutomaticExposure flows into
   * one endpoint. Depending on the passed in trigger reason a manual or automatic exposure
   * is sent.
   **/ trackFeatureFlag(flagKey, options = {}) {
        const triggerReason = options?.triggerReason ? options.triggerReason : (0, $iGqJ7.ExposureTriggerReason).Manual;
        const isValueSet = this.flags.has(flagKey) || 'value' in options;
        if (!isValueSet) {
            // eslint-disable-next-line no-console
            console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
            return;
        }
        // if no values for flagValue and explanation supplied then retrieve them from the flags map
        const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
        const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
        if (triggerReason === (0, $iGqJ7.ExposureTriggerReason).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
        else // default to fire a manual track exposure
        this._trackExposure(flagKey, {
            value: flagValue,
            explanation: flagExplanation
        }, triggerReason);
    }
    trackExposure(flagKey, flag, exposureData = {}) {
        return this._trackExposure(flagKey, flag, (0, $iGqJ7.ExposureTriggerReason).Manual, exposureData);
    }
    _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
        if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
        (0, $f3838902fc4e0ba4$export$891630e169ca14a4)(exposureData);
        const flagAttributes = {
            flagKey: flagKey,
            reason: flag.explanation.kind,
            ruleId: flag.explanation.ruleId,
            value: flag.value
        };
        this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
    }
    shouldSendEvent(flagKey, customAttributes) {
        return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $f3838902fc4e0ba4$export$8ed1df9dbe2e9a7d)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
    }
    sendAutomaticExposure(flagKey, value, flagExplanation) {
        if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
        const flagAttributes = {
            flagKey: flagKey,
            value: value,
            reason: flagExplanation.kind || 'SIMPLE_EVAL',
            // In theory this shouldnt be necessary
            ruleId: flagExplanation.ruleId,
            errorKind: flagExplanation.errorKind
        };
        this.sendExposureEvent(flagAttributes, (0, $iGqJ7.ExposureTriggerReason).AutoExposure);
    }
    sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
        if (!this.trackedFlags.has(attributes.flagKey)) {
            const exposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: attributes,
                tags: [
                    'measurement',
                    exposureTriggerReason
                ],
                highPriority: false,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(exposureEvent);
            this.trackedFlags.add(attributes.flagKey);
        }
        // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
        // events. In order not to break existing users of this feature immediately, we're sending an
        // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
        // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
        if (!(0, $f3838902fc4e0ba4$export$8ed1df9dbe2e9a7d)(customAttributes)) {
            const customeAttributesExposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: Object.assign({}, attributes, customAttributes),
                tags: [
                    'measurement',
                    (0, $iGqJ7.ExposureTriggerReason).hasCustomAttributes,
                    exposureTriggerReason
                ],
                highPriority: true,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
            this.customAttributesExposuresCache.add(attributes.flagKey);
        }
    }
    getFlagStats() {
        const flagStats = {};
        for (const [flagKey, wrapper] of this.flagWrapperCache){
            const { evaluationCount: evaluationCount } = wrapper;
            flagStats[flagKey] = {
                evaluationCount: evaluationCount
            };
        }
        return flagStats;
    }
    constructor(options){
        this.flags = void 0;
        this.flagWrapperCache = void 0;
        this.analyticsHandler = void 0;
        this.isAutomaticExposuresEnabled = void 0;
        this.trackedFlags = void 0;
        this.customAttributesExposuresCache = void 0;
        this.ignoreTypes = void 0;
        (0, $f3838902fc4e0ba4$export$c7d37910dd25ecbf)(options, [
            'analyticsHandler'
        ], 'Feature Flag Client');
        const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, ignoreTypes: ignoreTypes } = options;
        this.flags = new Map();
        this.flagWrapperCache = new Map();
        this.customAttributesExposuresCache = new Set();
        this.trackedFlags = new Set();
        this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
        this.ignoreTypes = ignoreTypes || false;
        this.setFlags(flags || {});
        this.setAnalyticsHandler(analyticsHandler);
    }
}
module.exports["default"] = $beddd9d801215c13$export$2e2bcd8739ae039;

});

parcelRegister("iGqJ7", function(module, exports) {
var $c0cc6a0eb5682405$export$2c20ffeba7dbc068 = /*#__PURE__*/ function(ExposureTriggerReason) {
    ExposureTriggerReason["OptIn"] = "optInExposure";
    ExposureTriggerReason["Manual"] = "manualExposure";
    ExposureTriggerReason["Default"] = "defaultExposure";
    ExposureTriggerReason["AutoExposure"] = "autoExposure";
    ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
    return ExposureTriggerReason;
}({});
module.exports["ExposureTriggerReason"] = $c0cc6a0eb5682405$export$2c20ffeba7dbc068;

});

parcelRegister("hohxW", function(module, exports) {
var $63afadb48eb6c49e$export$259e3a861f28589b = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});
module.exports["WebStorageType"] = $63afadb48eb6c49e$export$259e3a861f28589b;

});

parcelRegister("iL7bG", function(module, exports) {

var $ccRXO = parcelRequire("ccRXO");

const $4c43fb9fb9da63bb$export$194c34963e6f0bc6 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';
const $4c43fb9fb9da63bb$export$b44048c6704cb5cb = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_COOKIE.json';
const $4c43fb9fb9da63bb$export$c55beaf8e17d7be2 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_LOCAL_STORAGE.json';
const $4c43fb9fb9da63bb$export$e1db91db5e7e324f = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_SESSION_STORAGE.json';
const $4c43fb9fb9da63bb$export$abf8d23e319d4d71 = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_COOKIE.json';
const $4c43fb9fb9da63bb$export$de367b95fcc6730f = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_LOCAL_STORAGE.json';
const $4c43fb9fb9da63bb$export$d5e6ad74bf291eaf = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_SESSION_STORAGE.json';
const $4c43fb9fb9da63bb$export$218c59d0d43946aa = {
    [(0, $ccRXO.CategoryStorageType).Cookies]: $4c43fb9fb9da63bb$export$b44048c6704cb5cb,
    [(0, $ccRXO.CategoryStorageType).LocalStorage]: $4c43fb9fb9da63bb$export$c55beaf8e17d7be2,
    [(0, $ccRXO.CategoryStorageType).SessionStorage]: $4c43fb9fb9da63bb$export$e1db91db5e7e324f
};
const $4c43fb9fb9da63bb$export$df45fb0af5b720ce = {
    commercial: $4c43fb9fb9da63bb$export$218c59d0d43946aa,
    'fedramp-moderate': {
        [(0, $ccRXO.CategoryStorageType).Cookies]: $4c43fb9fb9da63bb$export$abf8d23e319d4d71,
        [(0, $ccRXO.CategoryStorageType).LocalStorage]: $4c43fb9fb9da63bb$export$de367b95fcc6730f,
        [(0, $ccRXO.CategoryStorageType).SessionStorage]: $4c43fb9fb9da63bb$export$d5e6ad74bf291eaf
    }
};
module.exports["LEGACY_COOKIE_CACHE_URL_PROD"] = $4c43fb9fb9da63bb$export$194c34963e6f0bc6;
module.exports["COOKIE_CACHE_URL_COMMERCIAL_PROD"] = $4c43fb9fb9da63bb$export$b44048c6704cb5cb;
module.exports["LOCAL_STORAGE_CACHE_URL_COMMERCIAL_PROD"] = $4c43fb9fb9da63bb$export$c55beaf8e17d7be2;
module.exports["SESSION_STORAGE_CACHE_URL_COMMERCIAL_PROD"] = $4c43fb9fb9da63bb$export$e1db91db5e7e324f;
module.exports["COMMERCIAL_CATEGORY_CACHE_URL_LOOKUP"] = $4c43fb9fb9da63bb$export$218c59d0d43946aa;
module.exports["CATEGORY_CACHE_URL_PERIMETER_LOOKUP"] = $4c43fb9fb9da63bb$export$df45fb0af5b720ce;

});

parcelRegister("9P7Na", function(module, exports) {
const $2ba5b22c48713c1b$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $2ba5b22c48713c1b$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};
module.exports["getBitValueFromBool"] = $2ba5b22c48713c1b$export$929f1500428a1fc8;
module.exports["getBoolFromBitValue"] = $2ba5b22c48713c1b$export$27647458f3cf29d2;

});

parcelRegister("573Av", function(module, exports) {

var $1UApO = parcelRequire("1UApO");


var $fPYum = parcelRequire("fPYum");

const $024a6c1f3e085dca$var$serverCacheKeyRegex = /[^A-Za-z0-9\-._\/]/g;
const $024a6c1f3e085dca$export$7c5eda5500a5f08d = (userId)=>{
    const keys = [];
    let prefix = `${(0, $fPYum.LOCAL_STORAGE_MANAGER)}/${(0, $fPYum.STORAGE_MANAGER_PREFIX)}.${userId}.${(0, $fPYum.STORAGE_MANAGER_ID)}`;
    prefix = prefix.replace($024a6c1f3e085dca$var$serverCacheKeyRegex, '_');
    Object.keys((0, $1UApO.PERSISTED_KEYS_ON_SERVER)).forEach((key)=>keys.push(`${prefix}.${(0, $1UApO.PERSISTED_KEYS_ON_SERVER)[key]}`));
    return keys;
};
const $024a6c1f3e085dca$export$902ba6ec74c93f9d = (key, cacheKey)=>{
    if (Object.values((0, $1UApO.PERSISTED_KEYS_ON_SERVER)).indexOf(key) > -1) cacheKey = cacheKey.replace($024a6c1f3e085dca$var$serverCacheKeyRegex, '_');
    return cacheKey;
};
module.exports["getKeysForLocalStorageQuery"] = $024a6c1f3e085dca$export$7c5eda5500a5f08d;
module.exports["getStorageKey"] = $024a6c1f3e085dca$export$902ba6ec74c93f9d;

});

parcelRegister("2BcbG", function(module, exports) {
class $301057c16b344423$var$VisibilityChangeObserver {
    start() {
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $301057c16b344423$export$13e680397ec8f3eb = new $301057c16b344423$var$VisibilityChangeObserver();
module.exports["visibilityChangeObserver"] = $301057c16b344423$export$13e680397ec8f3eb;

});

parcelRegister("jGRlW", function(module, exports) {
const $cb88293f5f41b972$export$1d17377365286b00 = [
    'ssr'
];
const $cb88293f5f41b972$export$df21d285cfcda81e = 7500;
module.exports["restrictedTimingKeys"] = $cb88293f5f41b972$export$1d17377365286b00;
module.exports["clsWaitTimeMs"] = $cb88293f5f41b972$export$df21d285cfcda81e;

});

parcelRegister("c1uRl", function(module, exports) {


class $f0923312a6e4cc5b$var$WebVitalsObserver {
    start() {
        this.ttciDetermined = this.registerTTCI();
        this.webVitalsDetermined = this.registerWebVitals();
    }
    async registerWebVitals() {
        try {
            const { getCLS: getCLS, getFCP: getFCP, getFID: getFID, getLCP: getLCP, getTTFB: getTTFB } = await (parcelRequire("e2x0y"));
            await Promise.all([
                getTTFB,
                getFID,
                getFCP,
                getLCP,
                getCLS
            ].map((fx)=>new Promise((resolve)=>{
                    fx(({ name: name, value: value })=>{
                        // round FCP, FID, LCP, TTFB to nearest integer.
                        // CLS is rounded to two decimal places.
                        const metricName = name.toLowerCase();
                        const metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                        this.data[`metric:${metricName}`] = metricValue;
                        resolve();
                    });
                })));
        } catch (e) {}
    }
    async registerTTCI() {
        try {
            const ttiPolyfill = await (parcelRequire("ia8Qs"));
            await ttiPolyfill.getFirstConsistentlyInteractive().then((value)=>{
                // according to the docs:
                // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                // the promise resolves to null.
                this.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                return true;
            });
        } catch (e) {}
    }
    constructor(){
        this.ttciDetermined = void 0;
        this.webVitalsDetermined = void 0;
        this.data = {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        };
    }
}
const $f0923312a6e4cc5b$export$253d38dccbb37615 = new $f0923312a6e4cc5b$var$WebVitalsObserver();
module.exports["webVitalsObserver"] = $f0923312a6e4cc5b$export$253d38dccbb37615;

});

parcelRegister("1SHEm", function(module, exports) {
$parcel$export(module.exports, "default", () => $15ecb19459f46465$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");


var $3QScg = parcelRequire("3QScg");

function $15ecb19459f46465$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $3QScg.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $3QScg.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});

parcelRegister("egtNM", function(module, exports) {

var $c2Pwh = parcelRequire("c2Pwh");

/** Built-in value references. */ var $a629ad57448e4c77$var$Uint8Array = $c2Pwh.Uint8Array;
module.exports = $a629ad57448e4c77$var$Uint8Array;

});

parcelRegister("bmalB", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $8449c697365229fc$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $8449c697365229fc$var$overArg;

});

parcelRegister("iRjkT", function(module, exports) {

var $bmalB = parcelRequire("bmalB");

/** Built-in value references. */ var $dbac2cee2c2863d1$var$getPrototype = $bmalB(Object.getPrototypeOf, Object);
module.exports = $dbac2cee2c2863d1$var$getPrototype;

});

parcelRegister("dP6hW", function(module, exports) {

var $jr8iR = parcelRequire("jr8iR");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");


var $cSA01 = parcelRequire("cSA01");


var $1UktQ = parcelRequire("1UktQ");


var $gQUlr = parcelRequire("gQUlr");

/** Used for built-in method references. */ var $a104ea8984df0617$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a104ea8984df0617$var$hasOwnProperty = $a104ea8984df0617$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $a104ea8984df0617$var$arrayLikeKeys(value, inherited) {
    var isArr = $fZxmY(value), isArg = !isArr && $dI6Ko(value), isBuff = !isArr && !isArg && $cSA01(value), isType = !isArr && !isArg && !isBuff && $gQUlr(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $jr8iR(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $a104ea8984df0617$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $1UktQ(key, length)))) result.push(key);
    return result;
}
module.exports = $a104ea8984df0617$var$arrayLikeKeys;

});

parcelRegister("bv8vS", function(module, exports) {

var $k1Lsb = parcelRequire("k1Lsb");

var $85f9318166d65bf4$var$defineProperty = function() {
    try {
        var func = $k1Lsb(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $85f9318166d65bf4$var$defineProperty;

});

parcelRegister("45dI4", function(module, exports) {

var $lc9ud = parcelRequire("lc9ud");

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $2f92438b9755c1d7$var$isStrictComparable(value) {
    return value === value && !$lc9ud(value);
}
module.exports = $2f92438b9755c1d7$var$isStrictComparable;

});

parcelRegister("1XoFm", function(module, exports) {

var $fZxmY = parcelRequire("fZxmY");


var $hDVEF = parcelRequire("hDVEF");

/** Used to match property names within property paths. */ var $16ce6f4ed85de19e$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $16ce6f4ed85de19e$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $16ce6f4ed85de19e$var$isKey(value, object) {
    if ($fZxmY(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $hDVEF(value)) return true;
    return $16ce6f4ed85de19e$var$reIsPlainProp.test(value) || !$16ce6f4ed85de19e$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $16ce6f4ed85de19e$var$isKey;

});

parcelRegister("l5f4C", function(module, exports) {
const $f595c1e8cedcb25c$var$supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $f595c1e8cedcb25c$export$2e2bcd8739ae039 = $f595c1e8cedcb25c$var$supports;
module.exports["default"] = $f595c1e8cedcb25c$export$2e2bcd8739ae039;

});

parcelRegister("2ObRk", function(module, exports) {
$parcel$export(module.exports, "default", () => $20b973414a5b864e$export$2e2bcd8739ae039);
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $20b973414a5b864e$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $20b973414a5b864e$var$CACHE = new WeakMap();
function $20b973414a5b864e$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = '' + objA;
        const strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        let keysA;
        if ($20b973414a5b864e$var$CACHE.has(objA)) keysA = $20b973414a5b864e$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $20b973414a5b864e$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($20b973414a5b864e$var$CACHE.has(objB)) keysB = $20b973414a5b864e$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $20b973414a5b864e$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$20b973414a5b864e$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}

});

parcelRegister("e3NzX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4HDYO = parcelRequire("4HDYO");

const $a3c7cdde0298239d$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    globalRegistry: (0, $4HDYO.defaultRegistry),
    retrieveStore: (Store)=>(0, $4HDYO.defaultRegistry).getStore(Store)
}, ()=>0);
module.exports["Context"] = $a3c7cdde0298239d$export$841858b892ce1f4c;

});

parcelRegister("davT6", function(module, exports) {

var $fyrKY = parcelRequire("fyrKY");

const $9964f1c83f6de0cf$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $9964f1c83f6de0cf$var$warnings = new WeakMap();
const $9964f1c83f6de0cf$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $fyrKY.default).devtools ? $9964f1c83f6de0cf$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$9964f1c83f6de0cf$var$warnings.has(actionFn)) $9964f1c83f6de0cf$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $9964f1c83f6de0cf$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $9964f1c83f6de0cf$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};
module.exports["bindActions"] = $9964f1c83f6de0cf$export$5ee1d46cd0883a22;

});

parcelRegister("3m5TZ", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $ef9a57e67d61acdc$export$491825b5144ba722 = /*#__PURE__*/ function(ClientNetworkStatus) {
    ClientNetworkStatus["IP_BLOCKED"] = "IP_BLOCKED";
    ClientNetworkStatus["OFFLINE"] = "OFFLINE";
    ClientNetworkStatus["ONLINE"] = "ONLINE";
    ClientNetworkStatus["RATE_LIMITED"] = "RATE_LIMITED";
    ClientNetworkStatus["SESSION_EXPIRED"] = "SESSION_EXPIRED";
    return ClientNetworkStatus;
}({});
module.exports["ClientNetworkStatus"] = $ef9a57e67d61acdc$export$491825b5144ba722;

});

parcelRegister("9S3jU", function(module, exports) {
"use strict";
var $72fbbb81467b49e4$var$__assign = module.exports && module.exports.__assign || function() {
    $72fbbb81467b49e4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $72fbbb81467b49e4$var$__assign.apply(this, arguments);
};
var $72fbbb81467b49e4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $72fbbb81467b49e4$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $72fbbb81467b49e4$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SubscriptionClient = void 0;
var $72fbbb81467b49e4$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : {};
var $72fbbb81467b49e4$var$NativeWebSocket = $72fbbb81467b49e4$var$_global.WebSocket || $72fbbb81467b49e4$var$_global.MozWebSocket;
var $61f2bd42b8be292e$exports = {};
/**
 * Expose `Backoff`.
 */ $61f2bd42b8be292e$exports = $61f2bd42b8be292e$var$Backoff;
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $61f2bd42b8be292e$var$Backoff(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $61f2bd42b8be292e$var$Backoff.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $61f2bd42b8be292e$var$Backoff.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $61f2bd42b8be292e$var$Backoff.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $61f2bd42b8be292e$var$Backoff.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $61f2bd42b8be292e$var$Backoff.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



var $5OAab = parcelRequire("5OAab");


var $3NFzB = parcelRequire("3NFzB");


var $6rnVN = parcelRequire("6rnVN");


var $lB1H3 = parcelRequire("lB1H3");


var $q7IQV = parcelRequire("q7IQV");

function $6cbc563dafc125b6$export$1f718485f6b6643f(documentAST, operationName) {
    var operation = null;
    for(var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++){
        var definition = _documentAST$definiti2[_i2];
        if (definition.kind === (0, $q7IQV.Kind).OPERATION_DEFINITION) {
            var _definition$name;
            if (operationName == null) {
                // If no operation name was provided, only return an Operation if there
                // is one defined in the document. Upon encountering the second, return
                // null.
                if (operation) return null;
                operation = definition;
            } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) return definition;
        }
    }
    return operation;
}



var $1hmzn = parcelRequire("1hmzn");


var $kU3jZ = parcelRequire("kU3jZ");


var $fRFuT = parcelRequire("fRFuT");


var $fDXwS = parcelRequire("fDXwS");

var $72fbbb81467b49e4$var$SubscriptionClient = function() {
    function SubscriptionClient(url, options, webSocketImpl, webSocketProtocols) {
        var _a = options || {}, _b = _a.connectionCallback, connectionCallback = _b === void 0 ? undefined : _b, _c = _a.connectionParams, connectionParams = _c === void 0 ? {} : _c, _d = _a.minTimeout, minTimeout = _d === void 0 ? $fRFuT.MIN_WS_TIMEOUT : _d, _e = _a.timeout, timeout = _e === void 0 ? $fRFuT.WS_TIMEOUT : _e, _f = _a.reconnect, reconnect = _f === void 0 ? false : _f, _g = _a.reconnectionAttempts, reconnectionAttempts = _g === void 0 ? Infinity : _g, _h = _a.lazy, lazy = _h === void 0 ? false : _h, _j = _a.inactivityTimeout, inactivityTimeout = _j === void 0 ? 0 : _j, _k = _a.wsOptionArguments, wsOptionArguments = _k === void 0 ? [] : _k;
        this.wsImpl = webSocketImpl || $72fbbb81467b49e4$var$NativeWebSocket;
        if (!this.wsImpl) throw new Error('Unable to find native implementation, or alternative implementation for WebSocket!');
        this.wsProtocols = webSocketProtocols || $kU3jZ.GRAPHQL_WS;
        this.connectionCallback = connectionCallback;
        this.url = url;
        this.operations = {};
        this.nextOperationId = 0;
        this.minWsTimeout = minTimeout;
        this.wsTimeout = timeout;
        this.unsentMessagesQueue = [];
        this.reconnect = reconnect;
        this.reconnecting = false;
        this.reconnectionAttempts = reconnectionAttempts;
        this.lazy = !!lazy;
        this.inactivityTimeout = inactivityTimeout;
        this.closedByUser = false;
        this.backoff = new $61f2bd42b8be292e$exports({
            jitter: 0.5
        });
        this.eventEmitter = new $5OAab.EventEmitter();
        this.middlewares = [];
        this.client = null;
        this.maxConnectTimeGenerator = this.createMaxConnectTimeGenerator();
        this.connectionParams = this.getConnectionParams(connectionParams);
        this.wsOptionArguments = wsOptionArguments;
        if (!this.lazy) this.connect();
    }
    Object.defineProperty(SubscriptionClient.prototype, "status", {
        get: function() {
            if (this.client === null) return this.wsImpl.CLOSED;
            return this.client.readyState;
        },
        enumerable: false,
        configurable: true
    });
    SubscriptionClient.prototype.close = function(isForced, closedByUser) {
        if (isForced === void 0) isForced = true;
        if (closedByUser === void 0) closedByUser = true;
        this.clearInactivityTimeout();
        if (this.client !== null) {
            this.closedByUser = closedByUser;
            if (isForced) {
                this.clearCheckConnectionInterval();
                this.clearMaxConnectTimeout();
                this.clearTryReconnectTimeout();
                this.unsubscribeAll();
                this.sendMessage(undefined, $fDXwS.default.GQL_CONNECTION_TERMINATE, null);
            }
            this.client.close();
            this.client.onopen = null;
            this.client.onclose = null;
            this.client.onerror = null;
            this.client.onmessage = null;
            this.client = null;
            this.eventEmitter.emit('disconnected');
            if (!isForced) this.tryReconnect();
        }
    };
    SubscriptionClient.prototype.request = function(request) {
        var _a;
        var getObserver = this.getObserver.bind(this);
        var executeOperation = this.executeOperation.bind(this);
        var unsubscribe = this.unsubscribe.bind(this);
        var opId;
        this.clearInactivityTimeout();
        return _a = {}, _a[$1hmzn.default] = function() {
            return this;
        }, _a.subscribe = function(observerOrNext, onError, onComplete) {
            var observer = getObserver(observerOrNext, onError, onComplete);
            opId = executeOperation(request, function(error, result) {
                if (error === null && result === null) {
                    if (observer.complete) observer.complete();
                } else if (error) {
                    if (observer.error) observer.error(error[0]);
                } else if (observer.next) observer.next(result);
            });
            return {
                unsubscribe: function() {
                    if (opId) {
                        unsubscribe(opId);
                        opId = null;
                    }
                }
            };
        }, _a;
    };
    SubscriptionClient.prototype.on = function(eventName, callback, context) {
        var handler = this.eventEmitter.on(eventName, callback, context);
        return function() {
            handler.off(eventName, callback, context);
        };
    };
    SubscriptionClient.prototype.onConnected = function(callback, context) {
        return this.on('connected', callback, context);
    };
    SubscriptionClient.prototype.onConnecting = function(callback, context) {
        return this.on('connecting', callback, context);
    };
    SubscriptionClient.prototype.onDisconnected = function(callback, context) {
        return this.on('disconnected', callback, context);
    };
    SubscriptionClient.prototype.onReconnected = function(callback, context) {
        return this.on('reconnected', callback, context);
    };
    SubscriptionClient.prototype.onReconnecting = function(callback, context) {
        return this.on('reconnecting', callback, context);
    };
    SubscriptionClient.prototype.onError = function(callback, context) {
        return this.on('error', callback, context);
    };
    SubscriptionClient.prototype.unsubscribeAll = function() {
        var _this = this;
        Object.keys(this.operations).forEach(function(subId) {
            _this.unsubscribe(subId);
        });
    };
    SubscriptionClient.prototype.applyMiddlewares = function(options) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var queue = function(funcs, scope) {
                var next = function(error) {
                    if (error) reject(error);
                    else if (funcs.length > 0) {
                        var f = funcs.shift();
                        if (f) f.applyMiddleware.apply(scope, [
                            options,
                            next
                        ]);
                    } else resolve(options);
                };
                next();
            };
            queue($72fbbb81467b49e4$var$__spreadArrays(_this.middlewares), _this);
        });
    };
    SubscriptionClient.prototype.use = function(middlewares) {
        var _this = this;
        middlewares.map(function(middleware) {
            if (typeof middleware.applyMiddleware === 'function') _this.middlewares.push(middleware);
            else throw new Error('Middleware must implement the applyMiddleware function.');
        });
        return this;
    };
    SubscriptionClient.prototype.getConnectionParams = function(connectionParams) {
        return function() {
            return new Promise(function(resolve, reject) {
                if (typeof connectionParams === 'function') try {
                    return resolve(connectionParams.call(null));
                } catch (error) {
                    return reject(error);
                }
                resolve(connectionParams);
            });
        };
    };
    SubscriptionClient.prototype.executeOperation = function(options, handler) {
        var _this = this;
        if (this.client === null) this.connect();
        var opId = this.generateOperationId();
        this.operations[opId] = {
            options: options,
            handler: handler
        };
        this.applyMiddlewares(options).then(function(processedOptions) {
            _this.checkOperationOptions(processedOptions, handler);
            if (_this.operations[opId]) {
                _this.operations[opId] = {
                    options: processedOptions,
                    handler: handler
                };
                _this.sendMessage(opId, $fDXwS.default.GQL_START, processedOptions);
            }
        }).catch(function(error) {
            _this.unsubscribe(opId);
            handler(_this.formatErrors(error));
        });
        return opId;
    };
    SubscriptionClient.prototype.getObserver = function(observerOrNext, error, complete) {
        if (typeof observerOrNext === 'function') return {
            next: function(v) {
                return observerOrNext(v);
            },
            error: function(e) {
                return error && error(e);
            },
            complete: function() {
                return complete && complete();
            }
        };
        return observerOrNext;
    };
    SubscriptionClient.prototype.createMaxConnectTimeGenerator = function() {
        var minValue = this.minWsTimeout;
        var maxValue = this.wsTimeout;
        return new $61f2bd42b8be292e$exports({
            min: minValue,
            max: maxValue,
            factor: 1.2
        });
    };
    SubscriptionClient.prototype.clearCheckConnectionInterval = function() {
        if (this.checkConnectionIntervalId) {
            clearInterval(this.checkConnectionIntervalId);
            this.checkConnectionIntervalId = null;
        }
    };
    SubscriptionClient.prototype.clearMaxConnectTimeout = function() {
        if (this.maxConnectTimeoutId) {
            clearTimeout(this.maxConnectTimeoutId);
            this.maxConnectTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.clearTryReconnectTimeout = function() {
        if (this.tryReconnectTimeoutId) {
            clearTimeout(this.tryReconnectTimeoutId);
            this.tryReconnectTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.clearInactivityTimeout = function() {
        if (this.inactivityTimeoutId) {
            clearTimeout(this.inactivityTimeoutId);
            this.inactivityTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.setInactivityTimeout = function() {
        var _this = this;
        if (this.inactivityTimeout > 0 && Object.keys(this.operations).length === 0) this.inactivityTimeoutId = setTimeout(function() {
            if (Object.keys(_this.operations).length === 0) _this.close();
        }, this.inactivityTimeout);
    };
    SubscriptionClient.prototype.checkOperationOptions = function(options, handler) {
        var query = options.query, variables = options.variables, operationName = options.operationName;
        if (!query) throw new Error('Must provide a query.');
        if (!handler) throw new Error('Must provide an handler.');
        if (!$3NFzB.default(query) && !$6cbc563dafc125b6$export$1f718485f6b6643f(query, operationName) || operationName && !$3NFzB.default(operationName) || variables && !$6rnVN.default(variables)) throw new Error("Incorrect option types. query must be a string or a document,`operationName` must be a string, and `variables` must be an object.");
    };
    SubscriptionClient.prototype.buildMessage = function(id, type, payload) {
        var payloadToReturn = payload && payload.query ? $72fbbb81467b49e4$var$__assign($72fbbb81467b49e4$var$__assign({}, payload), {
            query: typeof payload.query === 'string' ? payload.query : $lB1H3.print(payload.query)
        }) : payload;
        return {
            id: id,
            type: type,
            payload: payloadToReturn
        };
    };
    SubscriptionClient.prototype.formatErrors = function(errors) {
        if (Array.isArray(errors)) return errors;
        if (errors && errors.errors) return this.formatErrors(errors.errors);
        if (errors && errors.message) return [
            errors
        ];
        return [
            {
                name: 'FormatedError',
                message: 'Unknown error',
                originalError: errors
            }
        ];
    };
    SubscriptionClient.prototype.sendMessage = function(id, type, payload) {
        this.sendMessageRaw(this.buildMessage(id, type, payload));
    };
    SubscriptionClient.prototype.sendMessageRaw = function(message) {
        switch(this.status){
            case this.wsImpl.OPEN:
                var serializedMessage = JSON.stringify(message);
                try {
                    JSON.parse(serializedMessage);
                } catch (e) {
                    this.eventEmitter.emit('error', new Error("Message must be JSON-serializable. Got: " + message));
                }
                this.client.send(serializedMessage);
                break;
            case this.wsImpl.CONNECTING:
                this.unsentMessagesQueue.push(message);
                break;
            default:
                if (!this.reconnecting) this.eventEmitter.emit('error', new Error("A message was not sent because socket is not connected, is closing or is already closed. Message was: " + JSON.stringify(message)));
        }
    };
    SubscriptionClient.prototype.generateOperationId = function() {
        return String(++this.nextOperationId);
    };
    SubscriptionClient.prototype.tryReconnect = function() {
        var _this = this;
        if (!this.reconnect || this.backoff.attempts >= this.reconnectionAttempts) return;
        if (!this.reconnecting) {
            Object.keys(this.operations).forEach(function(key) {
                _this.unsentMessagesQueue.push(_this.buildMessage(key, $fDXwS.default.GQL_START, _this.operations[key].options));
            });
            this.reconnecting = true;
        }
        this.clearTryReconnectTimeout();
        var delay = this.backoff.duration();
        this.tryReconnectTimeoutId = setTimeout(function() {
            _this.connect();
        }, delay);
    };
    SubscriptionClient.prototype.flushUnsentMessagesQueue = function() {
        var _this = this;
        this.unsentMessagesQueue.forEach(function(message) {
            _this.sendMessageRaw(message);
        });
        this.unsentMessagesQueue = [];
    };
    SubscriptionClient.prototype.checkConnection = function() {
        if (this.wasKeepAliveReceived) {
            this.wasKeepAliveReceived = false;
            return;
        }
        if (!this.reconnecting) this.close(false, true);
    };
    SubscriptionClient.prototype.checkMaxConnectTimeout = function() {
        var _this = this;
        this.clearMaxConnectTimeout();
        this.maxConnectTimeoutId = setTimeout(function() {
            if (_this.status !== _this.wsImpl.OPEN) {
                _this.reconnecting = true;
                _this.close(false, true);
            }
        }, this.maxConnectTimeGenerator.duration());
    };
    SubscriptionClient.prototype.connect = function() {
        var _a;
        var _this = this;
        this.client = new ((_a = this.wsImpl).bind.apply(_a, $72fbbb81467b49e4$var$__spreadArrays([
            void 0,
            this.url,
            this.wsProtocols
        ], this.wsOptionArguments)))();
        this.checkMaxConnectTimeout();
        this.client.onopen = function() {
            return $72fbbb81467b49e4$var$__awaiter(_this, void 0, void 0, function() {
                var connectionParams, error_1;
                return $72fbbb81467b49e4$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(this.status === this.wsImpl.OPEN)) return [
                                3,
                                4
                            ];
                            this.clearMaxConnectTimeout();
                            this.closedByUser = false;
                            this.eventEmitter.emit(this.reconnecting ? 'reconnecting' : 'connecting');
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                this.connectionParams()
                            ];
                        case 2:
                            connectionParams = _a.sent();
                            this.sendMessage(undefined, $fDXwS.default.GQL_CONNECTION_INIT, connectionParams);
                            this.flushUnsentMessagesQueue();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error_1 = _a.sent();
                            this.sendMessage(undefined, $fDXwS.default.GQL_CONNECTION_ERROR, error_1);
                            this.flushUnsentMessagesQueue();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
        };
        this.client.onclose = function() {
            if (!_this.closedByUser) _this.close(false, false);
        };
        this.client.onerror = function(err) {
            _this.eventEmitter.emit('error', err);
        };
        this.client.onmessage = function(_a) {
            var data = _a.data;
            _this.processReceivedData(data);
        };
    };
    SubscriptionClient.prototype.processReceivedData = function(receivedData) {
        var parsedMessage;
        var opId;
        try {
            parsedMessage = JSON.parse(receivedData);
            opId = parsedMessage.id;
        } catch (e) {
            throw new Error("Message must be JSON-parseable. Got: " + receivedData);
        }
        if ([
            $fDXwS.default.GQL_DATA,
            $fDXwS.default.GQL_COMPLETE,
            $fDXwS.default.GQL_ERROR
        ].indexOf(parsedMessage.type) !== -1 && !this.operations[opId]) {
            this.unsubscribe(opId);
            return;
        }
        switch(parsedMessage.type){
            case $fDXwS.default.GQL_CONNECTION_ERROR:
                if (this.connectionCallback) this.connectionCallback(parsedMessage.payload);
                break;
            case $fDXwS.default.GQL_CONNECTION_ACK:
                this.eventEmitter.emit(this.reconnecting ? 'reconnected' : 'connected', parsedMessage.payload);
                this.reconnecting = false;
                this.backoff.reset();
                this.maxConnectTimeGenerator.reset();
                if (this.connectionCallback) this.connectionCallback();
                break;
            case $fDXwS.default.GQL_COMPLETE:
                var handler = this.operations[opId].handler;
                delete this.operations[opId];
                handler.call(this, null, null);
                break;
            case $fDXwS.default.GQL_ERROR:
                this.operations[opId].handler(this.formatErrors(parsedMessage.payload), null);
                delete this.operations[opId];
                break;
            case $fDXwS.default.GQL_DATA:
                var parsedPayload = !parsedMessage.payload.errors ? parsedMessage.payload : $72fbbb81467b49e4$var$__assign($72fbbb81467b49e4$var$__assign({}, parsedMessage.payload), {
                    errors: this.formatErrors(parsedMessage.payload.errors)
                });
                this.operations[opId].handler(null, parsedPayload);
                break;
            case $fDXwS.default.GQL_CONNECTION_KEEP_ALIVE:
                var firstKA = typeof this.wasKeepAliveReceived === 'undefined';
                this.wasKeepAliveReceived = true;
                if (firstKA) this.checkConnection();
                if (this.checkConnectionIntervalId) {
                    clearInterval(this.checkConnectionIntervalId);
                    this.checkConnection();
                }
                this.checkConnectionIntervalId = setInterval(this.checkConnection.bind(this), this.wsTimeout);
                break;
            default:
                throw new Error('Invalid message type!');
        }
    };
    SubscriptionClient.prototype.unsubscribe = function(opId) {
        if (this.operations[opId]) {
            delete this.operations[opId];
            this.setInactivityTimeout();
            this.sendMessage(opId, $fDXwS.default.GQL_STOP, undefined);
        }
    };
    return SubscriptionClient;
}();
module.exports.SubscriptionClient = $72fbbb81467b49e4$var$SubscriptionClient;

});

parcelRegister("iMbr2", function(module, exports) {

var $6ZgEd = parcelRequire("6ZgEd");


var $2i8PW = parcelRequire("2i8PW");

var $c5a0x = parcelRequire("c5a0x");


var $6RSiP = parcelRequire("6RSiP");





var $ccRXO = parcelRequire("ccRXO");

const $0958c9ba5ffa5207$export$b7364c41ddbfdb0a = (originalSetter)=>(originalCookieValue)=>{
        const cookieSetByPackage = originalCookieValue.includes('atl-set-cookie');
        if (cookieSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetter.apply(document, [
                originalCookieValue
            ]);
        } catch (e) {
            (0, $6ZgEd.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `document.cookie setter failed to set cookie set by package. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false
                }
            });
        }
        try {
            // Raw cookies and query params can contain sensitive PII/UGC we can't store, so we want to
            // strip that out before we log it out to our analytics client.
            const sanitizedCookieKey = originalCookieValue.slice(0, originalCookieValue.indexOf('=')) || '';
            (0, $c5a0x.sendPackageOperationalEvent)({
                action: 'usedDocumentCookie',
                attributes: {
                    cookieKey: sanitizedCookieKey,
                    outsidePackage: !cookieSetByPackage
                }
            });
            try {
                const productName = (0, $2i8PW.getBscGlobalState)().product;
                // Attempt to set a known cookie that was set from outside the package
                (0, $6RSiP.isProcessingAllowedByPreferences)({
                    itemKey: sanitizedCookieKey,
                    allowedCallback: ()=>{
                        return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory })=>{
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $2i8PW.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                        else return;
                    },
                    storageType: (0, $ccRXO.CategoryStorageType).Cookies,
                    productName: productName
                });
            } catch (e) {
                (0, $6ZgEd.Logger).errorWithOperationalEvent({
                    action: 'usedDocumentCookieError',
                    message: `Failed to set cookie. ${e.message || ''}`,
                    attributes: {
                        cookieKey: sanitizedCookieKey
                    }
                });
            }
        } catch (e) {
            (0, $6ZgEd.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `Failed to send document.cookie setter event. ${e.message || ''}`
            });
        }
    };


const $deca648bfb5be9c0$export$45a5573b04db016c = async ()=>{
    const documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
    const originalSetter = documentCookieProperty?.set;
    const originalGetter = documentCookieProperty?.get;
    if (!originalSetter || !originalGetter) {
        (0, $6ZgEd.Logger).warn('No document.cookie capabilities found');
        return;
    }
    // Override document.cookie setter
    Object.defineProperty(document, 'cookie', {
        get: originalGetter,
        set: (0, $0958c9ba5ffa5207$export$b7364c41ddbfdb0a)(originalSetter),
        configurable: true
    });
};
module.exports["createDocumentCookiePassthrough"] = $deca648bfb5be9c0$export$45a5573b04db016c;

});

parcelRegister("gNXDk", function(module, exports) {

var $6ZgEd = parcelRequire("6ZgEd");


var $8oAcs = parcelRequire("8oAcs");


var $c4TO3 = parcelRequire("c4TO3");
var $hohxW = parcelRequire("hohxW");


var $2i8PW = parcelRequire("2i8PW");

var $c5a0x = parcelRequire("c5a0x");


var $6RSiP = parcelRequire("6RSiP");




parcelRequire("c4TO3");



var $ccRXO = parcelRequire("ccRXO");

const $04cbb2a37e439c7b$export$b4469df6294ea6aa = (bscStorage, originalSetItem, storageType)=>(originalItemKey, originalItemValue)=>{
        const storageContext = bscStorage.storage;
        let itemSetByPackage = false;
        bscStorage.checkIfSetByPackage({
            itemKey: originalItemKey,
            isSetCallback: ()=>{
                itemSetByPackage = true;
            },
            isNotSetCallback: ()=>{
                // Note: This is async and could fail, but if the call errors out in IDB,
                // it will forcibly resolve to false here, so we're not catching the error again here ✅
                itemSetByPackage = false;
            }
        });
        if (itemSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetItem.apply(storageContext, [
                originalItemKey,
                originalItemValue
            ]);
        } catch (e) {
            (0, $6ZgEd.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `${storageType} failed to setItem. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false,
                    storageType: storageType
                }
            });
        }
        try {
            (0, $c5a0x.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: {
                    itemKey: originalItemKey,
                    outsidePackage: !itemSetByPackage,
                    storageType: storageType
                }
            });
            try {
                const productName = (0, $2i8PW.getBscGlobalState)().product;
                // Attempt to set a known item key that was set from outside the package
                (0, $6RSiP.isProcessingAllowedByPreferences)({
                    itemKey: originalItemKey,
                    allowedCallback: ()=>{
                        originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory })=>{
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $2i8PW.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                        else return;
                    },
                    storageType: storageType === (0, $hohxW.WebStorageType).LocalStorage ? (0, $ccRXO.CategoryStorageType).LocalStorage : (0, $ccRXO.CategoryStorageType).SessionStorage,
                    productName: productName
                });
            } catch (e) {
                (0, $6ZgEd.Logger).errorWithOperationalEvent({
                    action: 'usedAtlBrowserStorageSetItemError',
                    message: `Failed to set item. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType
                    }
                });
            }
        } catch (e) {
            (0, $6ZgEd.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `Failed to send ${storageType} setter event. ${e.message || ''}`
            });
        }
    };


const $746a09bdebd6d04b$export$619fe705922e5d61 = async (storageType)=>{
    const bscStorage = (0, $c4TO3.findStorageTarget)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $6ZgEd.Logger).warn(`No ${storageType} capabilities found`);
        return;
    }
    if (!(0, $8oAcs.BSCIndexedDB).isAvailable) {
        (0, $6ZgEd.Logger).warn('IndexedDB is not available');
        return;
    }
    if (!(0, $8oAcs.BSCIndexedDB).isBooted) // If we've yet to invoke booting of the IDB service, ensure we do it here.
    await (0, $8oAcs.BSCIndexedDB).boot();
    const originalSetItem = bscStorage.storage.setItem;
    // As we cannot use Object.defineProperty(window[storageType], 'setItem', ...implementation)
    // we have to override the entire utility with our own edition of the webStorage class
    const overriddenStorageClass = {
        clear: bscStorage.clear.bind(bscStorage),
        key: bscStorage.key.bind(bscStorage),
        length: bscStorage.length.bind(bscStorage),
        removeItem: bscStorage.removeItem.bind(bscStorage),
        getItem: bscStorage.getItem.bind(bscStorage),
        setItem: (0, $04cbb2a37e439c7b$export$b4469df6294ea6aa)(bscStorage, originalSetItem, storageType)
    };
    const caseSensitiveStorageType = storageType === (0, $hohxW.WebStorageType).LocalStorage ? 'localStorage' : 'sessionStorage';
    Object.defineProperty(window, caseSensitiveStorageType, {
        value: overriddenStorageClass,
        writable: true,
        configurable: true
    });
};
module.exports["createWebStoragePassthrough"] = $746a09bdebd6d04b$export$619fe705922e5d61;

});

parcelRegister("6RSiP", function(module, exports) {
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths

var $7MEbC = parcelRequire("7MEbC");


var $ccRXO = parcelRequire("ccRXO");


var $2i8PW = parcelRequire("2i8PW");

const $1a7ba0e7c7adf589$export$2c141b1c00f3e482 = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $1a7ba0e7c7adf589$export$c4a1dd71bbd8954c = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const $1a7ba0e7c7adf589$export$69d5b68d01f4a366 = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName?.toLowerCase();
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    let productKeys = {
        ...storageControlsData['keys']['all'],
        ...downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {}
    };
    const productStartsWithPatterns = {
        ...patterns.startsWith['all'],
        ...downcasedProduct ? patterns.startsWith[downcasedProduct] : {}
    };
    const productEndsWithPatterns = {
        ...patterns.endsWith['all'],
        ...downcasedProduct ? patterns.endsWith[downcasedProduct] : {}
    };
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else {
        // Find pattern match or null
        itemCategoryNumber = $1a7ba0e7c7adf589$export$2c141b1c00f3e482(itemKey, productStartsWithPatterns);
        if (itemCategoryNumber === null) itemCategoryNumber = $1a7ba0e7c7adf589$export$c4a1dd71bbd8954c(itemKey, productEndsWithPatterns);
    }
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $ccRXO.PreferenceCategory).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $ccRXO.PreferenceCategory).Functional,
        [categories.ANALYTICS]: (0, $ccRXO.PreferenceCategory).Analytics,
        [categories.MARKETING]: (0, $ccRXO.PreferenceCategory).Marketing,
        [categories.UNKNOWN]: (0, $ccRXO.PreferenceCategory).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] : null;
};
const $1a7ba0e7c7adf589$export$ec8ce5237293e4a4 = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, $2i8PW.getBscGlobalState)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return $1a7ba0e7c7adf589$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
};
const $1a7ba0e7c7adf589$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, storageType: storageType, productName: productName })=>{
    let shouldProcessItem;
    const itemCategory = await $1a7ba0e7c7adf589$export$ec8ce5237293e4a4(itemKey, storageType, productName);
    if (itemCategory === (0, $ccRXO.PreferenceCategory).StrictlyNecessary) shouldProcessItem = true;
    else {
        const preferences = await (0, $7MEbC.getPreferences)();
        let hasPreferencesForCategory = false;
        if (!!preferences) {
            if (!!itemCategory) hasPreferencesForCategory = preferences[itemCategory];
        }
        shouldProcessItem = hasPreferencesForCategory;
    }
    if (shouldProcessItem) allowedCallback?.();
    else blockedCallback?.({
        itemHasCategory: itemCategory != null
    });
    return shouldProcessItem;
};
module.exports["isProcessingAllowedByPreferences"] = $1a7ba0e7c7adf589$export$e7a3dca206fec6e2;

});

parcelRegister("3sW76", function(module, exports) {
$parcel$export(module.exports, "DocumentType", () => $286110c7b5212a78$export$d1d99cf900472499);

var $42omo = parcelRequire("42omo");


var $7RTAm = parcelRequire("7RTAm");

var $286110c7b5212a78$var$apolloContext;
function $286110c7b5212a78$export$a47505d961ee3a1() {
    if (!$286110c7b5212a78$var$apolloContext) $286110c7b5212a78$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
    return $286110c7b5212a78$var$apolloContext;
}
function $286110c7b5212a78$export$c2ee824bcc89ca6a() {
    $286110c7b5212a78$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
}
var $286110c7b5212a78$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $286110c7b5212a78$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $7RTAm.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $286110c7b5212a78$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $286110c7b5212a78$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $7RTAm.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $286110c7b5212a78$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($286110c7b5212a78$export$d1d99cf900472499 || ($286110c7b5212a78$export$d1d99cf900472499 = {}));
var $286110c7b5212a78$var$cache = new Map();
function $286110c7b5212a78$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $286110c7b5212a78$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $286110c7b5212a78$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $286110c7b5212a78$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $286110c7b5212a78$export$8f49e4af10703ce3(document) {
    var cached = $286110c7b5212a78$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $7RTAm.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $7RTAm.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $7RTAm.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $286110c7b5212a78$export$d1d99cf900472499.Query : $286110c7b5212a78$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $286110c7b5212a78$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $7RTAm.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $286110c7b5212a78$var$cache.set(document, payload);
    return payload;
}
module.exports["getApolloContext"] = $286110c7b5212a78$export$a47505d961ee3a1;
module.exports["ApolloProvider"] = $286110c7b5212a78$export$c16b04c8a9956446;
module.exports["ApolloConsumer"] = $286110c7b5212a78$export$ed5ceab8c2bb5ce4;
module.exports["operationName"] = $286110c7b5212a78$export$5db520940cf00715;
module.exports["parser"] = $286110c7b5212a78$export$8f49e4af10703ce3;

});

parcelRegister("dr1zO", function(module, exports) {
const $874015b23cbd80ee$var$streams = new Map();
function $874015b23cbd80ee$export$9545e1e15c32e6d6() {
    $874015b23cbd80ee$var$streams.clear();
}
class $874015b23cbd80ee$var$EventStream {
    /**
   * Add a listener to the stream
   * @param fn - The listener function
   */ addListener(fn) {
        for (const value of window.__s[this.stream])fn(value);
        this.listeners.add(fn);
    }
    /**
   * Remove a listener from the stream
   * @param fn - The listener function
   */ removeListener(fn) {
        this.listeners.delete(fn);
    }
    constructor(stream){
        var _window, _window1, _window___sL, _stream, _window___s, _stream1;
        this.stream = void 0;
        this.listeners = new Set();
        this.onEvent = (data)=>{
            this.listeners.forEach((fn)=>fn(data));
        };
        (_window = window).__s ?? (_window.__s = {});
        (_window1 = window).__sL ?? (_window1.__sL = {});
        (_window___sL = window.__sL)[_stream = stream] ?? (_window___sL[_stream] = new Set());
        window.__sL[stream].add(this.onEvent);
        (_window___s = window.__s)[_stream1 = stream] ?? (_window___s[_stream1] = []);
        this.stream = stream;
    }
}
function $874015b23cbd80ee$export$e2d3408bc322188a(key) {
    let stream = $874015b23cbd80ee$var$streams.get(key);
    if (!stream) {
        stream = new $874015b23cbd80ee$var$EventStream(key);
        $874015b23cbd80ee$var$streams.set(key, stream);
    }
    return stream;
}
module.exports["getClientStream"] = $874015b23cbd80ee$export$e2d3408bc322188a;

});

parcelRegister("2l40N", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $1b40a79630ee60d4$var$stubArray() {
    return [];
}
module.exports = $1b40a79630ee60d4$var$stubArray;

});

parcelRegister("dJQeL", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $fZxmY = parcelRequire("fZxmY");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $a007ff84b46efdf4$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $fZxmY(object) ? result : $hwwIB(result, symbolsFunc(object));
}
module.exports = $a007ff84b46efdf4$var$baseGetAllKeys;

});

parcelRegister("jxz2A", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $5v4fk = parcelRequire("5v4fk");
var $jLTuK = parcelRequire("jLTuK");


var $hqQq0 = parcelRequire("hqQq0");

var $e39c47bdc0043399$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, requestOptions = (0, $hXuPC.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries"
    ]);
    (0, $hqQq0.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $5v4fk.ApolloLink)(function(operation) {
        var chosenURI = (0, $hqQq0.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $hXuPC.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $hqQq0.selectHttpOptionsAndBody)(operation, (0, $hqQq0.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $hqQq0.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $e39c47bdc0043399$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $5v4fk.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $hqQq0.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $5v4fk.fromError)(parseError);
        }
        return new (0, $jLTuK.default)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $hqQq0.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError') return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $e39c47bdc0043399$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $hqQq0.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $hqQq0.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $e39c47bdc0043399$export$f4bbf1aec241cc1 = function(_super) {
    (0, $hXuPC.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $e39c47bdc0043399$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $5v4fk.ApolloLink));
module.exports["HttpLink"] = $e39c47bdc0043399$export$f4bbf1aec241cc1;

});

parcelRegister("gTOUc", function(module, exports) {

var $5v4fk = parcelRequire("5v4fk");


var $4u5NT = parcelRequire("4u5NT");

const $28d9509e838f50ce$export$fb326ed954631f3f = new (0, $5v4fk.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $4u5NT.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});
module.exports["UFOLoggerLink"] = $28d9509e838f50ce$export$fb326ed954631f3f;

});

parcelRegister("9jPdT", function(module, exports) {

var $c9tKb = parcelRequire("c9tKb");


var $fJlJm = parcelRequire("fJlJm");


var $9kGfD = parcelRequire("9kGfD");

var $flE5X = parcelRequire("flE5X");


var $7Sm4c = parcelRequire("7Sm4c");

const $f891c7498335b8fa$export$b330696930e048ff = ()=>(0, $c9tKb.onError)(({ operation: operation, graphQLErrors: graphQLErrors, networkError: networkError })=>{
        let response = operation.getContext()?.response;
        if (!response) // Experimental queries don't have 'response' populated in context, so try
        // to get the Response object from graphQLErrors:
        response = graphQLErrors?.map((e)=>$f891c7498335b8fa$var$getResponseFromError(e.originalError)).find((e)=>e != null);
        const traceId = (0, $9kGfD.getTraceIdFromResponse)(response);
        if (graphQLErrors?.length) graphQLErrors.forEach((e)=>{
            (0, $fJlJm.setGraphqlErrorAttributes)(e, {
                graphqlPath: e.path?.join('.'),
                operationName: operation.operationName,
                statusCode: response?.status,
                traceId: traceId
            });
            (0, $7Sm4c.processError)(e);
        });
        if (networkError) {
            (0, $fJlJm.setGraphqlErrorAttributes)(networkError, {
                operationName: operation.operationName,
                statusCode: $f891c7498335b8fa$var$getResponseFromError(networkError)?.status,
                traceId: traceId,
                ...networkError instanceof (0, $flE5X.NoNetworkError) && networkError.wasBubbledUp === true ? {
                    wasBubbledUp: true
                } // Extra analytics attribute to mark errors caused by platform_editor_bubble_cfe_gql_network_errors. This can probably be removed during fg cleanup.
                 : {}
            });
            (0, $7Sm4c.processError)(networkError);
        }
    });
function $f891c7498335b8fa$var$getResponseFromError(error) {
    if (typeof error === 'object' && error && 'response' in error) {
        const { response: response } = error;
        if (typeof response === 'object' && response && 'status' in response) return response;
    }
    return undefined;
}
module.exports["createOnErrorLink"] = $f891c7498335b8fa$export$b330696930e048ff;

});

parcelRegister("iMHGI", function(module, exports) {

var $lMdlY = parcelRequire("lMdlY");



var $9wGTI = parcelRequire("9wGTI");


var $14DR2 = parcelRequire("14DR2");

var $f7B1p = parcelRequire("f7B1p");

var $lqJ5I = parcelRequire("lqJ5I");


var $hZpML = parcelRequire("hZpML");



var $60cDW = parcelRequire("60cDW");


var $eecps = parcelRequire("eecps");

const $2386d66c0d937812$var$experienceAwareFetch = (0, $eecps.createExperienceAwareFetch)();
const $2386d66c0d937812$export$b976e16d553aa486 = '/gateway/api/graphql/slow';
const $2386d66c0d937812$export$ea28bdf504d67aa4 = (isForAggOnly)=>{
    return (uri, options)=>{
        const payload = [].concat(typeof options.body === 'string' ? JSON.parse(options.body) : []); // concat normalizes into an array
        const operationNames = payload.map(({ operationName: operationName, variables: variables })=>{
            // There are various webitem location we want to distinguish them
            if (operationName === 'WebItemLocationQuery' || operationName === 'WebPanelLocationQuery') return `${operationName}:${variables?.location || (variables?.locations || []).join(',') || ''}`;
            return operationName;
        });
        if (!isForAggOnly) {
            if ((0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint')) uri = $2386d66c0d937812$export$b976e16d553aa486;
            else // On client side the uri is /cgraphql
            // However when running on the server side we want to dynamic change the URI
            // So we can route the request to the graphql deployment that closer to the data.
            // AGG host is redirected by Tesseract so we don't need to change the URI
            uri = window.GLOBAL_APOLLO_CLIENT_URI || uri;
        }
        // Track individual operations for frontend
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (typeof window !== 'undefined') (0, $lqJ5I.networkTracker).trackGraphQLOperations(operationNames);
        // pass as headers for rate-limiting compatibility
        const operationNamesList = operationNames.join(',');
        if (!options.headers) options.headers = {};
        // AGG batch queries require /batch to be added to the uri and an additional header
        if ((0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint')) {
            (0, $14DR2.appendHeader)(options.headers, 'X-ExperimentalApi', 'confluence-agg-beta');
            if (payload.length === 1) options.body = JSON.stringify(payload[0]);
            else if (payload.length > 1) {
                (0, $14DR2.appendHeader)(options.headers, 'X-ExperimentalApi', 'BatchOperations');
                uri = `${uri}/batch`;
            }
        }
        (0, $14DR2.appendHeader)(options.headers, 'X-APOLLO-OPERATION-NAME', operationNamesList);
        const shouldApplyAggHeaders = (0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint') || isForAggOnly;
        if (shouldApplyAggHeaders || false) {
            // These headers are explicitly forwarded to cc-graphql in cc-frontend-ssr, but we need to apply them here for Bifrost requests to cc-graphql.
            // We forward the same headers for AGG and cc-graphql requests
            const { aggHeaders: aggHeaders } = (0, $60cDW.getSSRRenderInputs)();
            if (aggHeaders) Object.entries(aggHeaders).forEach(([header, val])=>{
                if (val) (0, $14DR2.appendHeader)(options.headers, header, val);
            });
        }
        // Note: this may overrwrite a header value from above in SSR context, but this ensures
        // it's still applied in SPA context
        if (shouldApplyAggHeaders && window['GLOBAL_AGG_REGION_STEERING_HINT']) (0, $14DR2.appendHeader)(options.headers, 'Atl-Edge-Region-Hint', window['GLOBAL_AGG_REGION_STEERING_HINT']);
        // TODO: as part of AGG MIGRATION cleanup, the references to `mutationErrorExtensionsAggCompat` function can be removed and the code should be compatible with AGG type definitions
        (0, $14DR2.appendHeader)(options.headers, 'ATL-AGG-Confluence-MutationError-Compat', 'false');
        options.referrerPolicy = options.referrerPolicy || 'same-origin';
        {
            // add experience tracing headers
            const tracingHeaders = (0, $lMdlY.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
            options.headers = Object.assign(options.headers, tracingHeaders);
        }
        // At this point the query has lost the structure and formatted back to string
        // However it is different in experimental queries. The AST is always accessible
        // Refer to next/packages/graphql/src/links/ExperimentalLink/schemaLink.ts
        const executeFetch = ()=>{
            return ((0, $eecps.isExperienceAwareFetchAlwaysEnabled)() || payload.some((item)=>item.query.includes('@SLA')) ? $2386d66c0d937812$var$experienceAwareFetch : (0, $f7B1p.cfetch))(`${uri}?q=${operationNamesList}`, options);
        };
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const markingPrefix = 'wf/client-graphql/';
        const markingNames = operationNames.map((name)=>{
            // Note: whole batch goes to cc-graphql, if one query is excluded w/in a batch
            name = shouldApplyAggHeaders ? `agg_${name}` : name;
            return `${markingPrefix}${name?.replace(/[^\-\.\w]/g, '_')}`;
        });
        // Ignore batch queries because they are not deterministic. Don't make sense to show on performance waterfall.
        return operationNames.length > 1 ? executeFetch() : (0, $hZpML.WaterfallMeasures).run(markingNames, executeFetch);
    };
};
module.exports["AGG_SLOW_URI"] = $2386d66c0d937812$export$b976e16d553aa486;
module.exports["createWrappedFetch"] = $2386d66c0d937812$export$ea28bdf504d67aa4;

});

parcelRegister("11MAl", function(module, exports) {

var $5v4fk = parcelRequire("5v4fk");
var $jLTuK = parcelRequire("jLTuK");


var $eSUdr = parcelRequire("eSUdr");


var $lB1H3 = parcelRequire("lB1H3");


var $a4TK8 = parcelRequire("a4TK8");

parcelRequire("1z9oK");
var $dr1zO = parcelRequire("dr1zO");


var $3IHUl = parcelRequire("3IHUl");

function $4661dfb4474ace55$var$hasRootLevelOrValidationErrors(eventResult) {
    if (!Array.isArray(eventResult.errors)) return false;
    return eventResult.errors.some((error)=>error.path && error.path.length === 1 || error?.extensions?.classification === 'ValidationError');
}
class $4661dfb4474ace55$var$QueryResultCache {
    getMatchingResult(query, variables) {
        const results = this.queryResults.get(query);
        if (!results) return null;
        const matchingQueryResult = results.findIndex((result)=>(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(result.variables, variables));
        if (matchingQueryResult === -1) return null;
        const matchingData = results[matchingQueryResult].result;
        results.splice(matchingQueryResult, 1);
        this.queryResults.set(query, results);
        return matchingData;
    }
    addResult(query, result, variables) {
        const results = this.queryResults.get(query) || [];
        results.push({
            result: result,
            variables: variables
        });
        this.queryResults.set(query, results);
    }
    constructor(namespace, cache){
        this.cache = cache;
        this.queryResults = void 0;
        this.queryResults = new Map();
        const data = (0, $dr1zO.getClientStream)(namespace);
        data.addListener((event)=>{
            if (event.type === 'result') try {
                if (!$4661dfb4474ace55$var$hasRootLevelOrValidationErrors(event.result)) {
                    this.cache.writeQuery({
                        query: (0, $eSUdr.gql)(event.operation),
                        variables: event.variables,
                        data: event.result.data
                    });
                    this.addResult(event.operation, event.result.data, event.variables);
                }
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('Failed to write query', e);
            }
        });
    }
}
const $4661dfb4474ace55$export$498642ee116fe4df = (namespace, cache)=>{
    let queryResultCache = null;
    if (window.__SSR_REACT_STREAMING__) queryResultCache = new $4661dfb4474ace55$var$QueryResultCache(namespace, cache);
    return new (0, $5v4fk.ApolloLink)((operation, forward)=>{
        if (!window.__SSR_REACT_STREAMING__ || !queryResultCache) return forward(operation);
        const query = (0, $lB1H3.print)(operation.query);
        const result = queryResultCache.getMatchingResult((0, $3IHUl.createIdentifierFromQuery)(query), operation.variables);
        if (result) return (0, $jLTuK.default).of({
            data: result
        });
        return forward(operation);
    });
};
module.exports["SSRClientLink"] = $4661dfb4474ace55$export$498642ee116fe4df;

});

parcelRegister("eUgss", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8vxJi = parcelRequire("8vxJi");

const $42ff849c6357ec03$var$pending = [];
function $42ff849c6357ec03$var$queueRenderCallback(callback) {
    $42ff849c6357ec03$var$pending.push(callback);
}
let $42ff849c6357ec03$var$inject = $42ff849c6357ec03$var$queueRenderCallback;
/**
 * Bootstrap script that is rendered inline before any data streams are emitted
 *
 * This initializes the following:
 * * __s - A map of stream names to a list of emitted values
 * * __sL - A map of stream names to a set of listeners
 * * __sR - A function that initializes a stream if it doesn't exist
 * * __sE - A function that emits a value to a stream
 * * __sC - A function that inserts an emotion style tag into the head. Self-deleting to avoid hydration mismatches.
 */ /* istanbul ignore next */ const $42ff849c6357ec03$var$streamBootstrapFn = (window)=>{
    if (!window.__s) window.__s = {};
    if (!window.__sL) window.__sL = {};
    window.__sR = (s)=>{
        if (!window.__s[s]) window.__s[s] = [];
        if (!window.__sL[s]) window.__sL[s] = new Set();
    };
    window.__sE = (s, v)=>{
        try {
            if (!window.__s[s]) window.__s[s] = [];
            window.__s[s].push(v);
            if (window.__sL[s]) window.__sL[s].forEach((fn)=>fn(v));
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('[__sE] error', e);
        }
    };
};
function $42ff849c6357ec03$export$2c8856ae107b7110() {
    return $42ff849c6357ec03$var$inject;
}
function $42ff849c6357ec03$export$b28f0b0600a86f70(callback) {
    $42ff849c6357ec03$var$inject = callback;
    if ($42ff849c6357ec03$var$pending.length > 0) {
        $42ff849c6357ec03$var$pending.forEach($42ff849c6357ec03$var$inject);
        $42ff849c6357ec03$var$pending.length = 0;
    }
}
function $42ff849c6357ec03$export$ccf708e2e2d09700() {
    $42ff849c6357ec03$var$inject = $42ff849c6357ec03$var$queueRenderCallback;
}
const $42ff849c6357ec03$var$streams = new Map();
function $42ff849c6357ec03$export$c8e414912e6da9df() {
    $42ff849c6357ec03$var$streams.clear();
}
class $42ff849c6357ec03$var$EventStream {
    emit(value) {
        $42ff849c6357ec03$var$inject(()=>{
            let script = '';
            if (!this.initialized) {
                script = `__sR("${this.stream}");`;
                this.initialized = true;
            }
            script += `__sE("${this.stream}", ${(0, $8vxJi.stringifyForSSR)(value)});`;
            return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement('script', {
                dangerouslySetInnerHTML: {
                    __html: script
                }
            });
        });
    }
    constructor(stream){
        this.initialized = false;
        this.stream = void 0;
        this.stream = stream;
    }
}
function $42ff849c6357ec03$export$9b8a06415a43901d(key) {
    if ($42ff849c6357ec03$var$streams.size === 0) $42ff849c6357ec03$var$inject(()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement('script', {
            dangerouslySetInnerHTML: {
                __html: `(${$42ff849c6357ec03$var$streamBootstrapFn.toString()})(window)`
            }
        });
    });
    let stream = $42ff849c6357ec03$var$streams.get(key);
    if (!stream) {
        stream = new $42ff849c6357ec03$var$EventStream(key);
        $42ff849c6357ec03$var$streams.set(key, stream);
    }
    return stream;
}
module.exports["getStreamInject"] = $42ff849c6357ec03$export$2c8856ae107b7110;
module.exports["getServerStream"] = $42ff849c6357ec03$export$9b8a06415a43901d;

});

parcelRegister("l3KBO", function(module, exports) {

var $jSnXV = parcelRequire("jSnXV");


var $7W8i8 = parcelRequire("7W8i8");


var $f5DmR = parcelRequire("f5DmR");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $jrqSm = parcelRequire("jrqSm");


var $398ES = parcelRequire("398ES");

const $c072487ed52e1be0$var$logger = (0, $7W8i8.getLogger)('TaskManager');
const $c072487ed52e1be0$var$TASK_TIME_QUANTUM = 35; // ms
const $c072487ed52e1be0$var$TASK_DELAY = 5; // ms
const $c072487ed52e1be0$var$isInputPending = ()=>{
    // This API is only available in Chrome 87 and higher, as of Oct 2021
    return navigator?.scheduling?.isInputPending() || false;
};
class $c072487ed52e1be0$export$9d8267e945b03765 {
    push({ id: id, priority: priority, task: task, _delayHydration: _delayHydration = false }) {
        if (this.disabled) priority = (0, $398ES.LoadingPriority).PAINT;
        if (_delayHydration && !this.serverMarkupHydratedCountMap.has(id)) this.serverMarkupHydratedCountMap.set(id, 0);
        if (_delayHydration && //totalTasksHydratedAtOnce acts as a switch to turn on/off hydration delay
        window.__SSR_RENDERED__ && this.totalTasksHydratedAtOncePerTaskId > 0 && this.serverMarkupHydratedCountMap.has(id)) {
            if (this.serverMarkupHydratedCountMap.get(id) >= this.totalTasksHydratedAtOncePerTaskId) return new Promise((resolve, reject)=>{
                const timer = setTimeout(()=>{
                    this.push({
                        id: id,
                        priority: priority,
                        task: task,
                        _delayHydration: _delayHydration
                    }).then(resolve, reject).finally(()=>clearTimeout(timer));
                }, 1);
            });
        }
        const futureTask = (0, $jrqSm.createFutureTask)(`${id}:${priority}`, task, this.maxQueueTimeMs);
        const QueueItem = {
            id: id,
            futureTask: futureTask,
            priority: priority,
            _delayHydration: _delayHydration
        };
        this.queue.add(QueueItem, QueueItem.priority);
        if (_delayHydration && //totalTasksHydratedAtOnce acts as a switch to turn on/off hydration delay
        window.__SSR_RENDERED__ && this.totalTasksHydratedAtOncePerTaskId > 0 && this.serverMarkupHydratedCountMap.has(id)) this.serverMarkupHydratedCountMap.set(id, this.serverMarkupHydratedCountMap.get(id) + 1);
        if (priority === (0, $398ES.LoadingPriority).PAINT) QueueItem.futureTask.run();
        this.runTasks();
        return futureTask.result;
    }
    reset() {
        this.allowedPriority = (0, $398ES.LoadingPriority).PAINT;
    }
    constructor(options = {}){
        this.maxQueueTimeMs = void 0;
        this.debounceTimeMs = void 0;
        this.disabled = void 0;
        this.allowedPriority = void 0;
        this.totalTasksHydratedAtOncePerTaskId = void 0;
        this.serverMarkupHydratedCountMap = void 0;
        // This is a priority queue. Lower priority numbers are ordered first.
        this.queue = new (0, $f5DmR.BucketQueue)((0, $398ES.LoadingPriority).MAX_PRIORITY);
        this.running = new Set();
        /**
     * Run any tasks that are the same priority as the head of the queue.
     *
     * This is debounced to allow for higher-priority tasks that are queued
     * (slightly) later to be run first.
     */ this.runTasks = void 0;
        let DEBUG_STEP_OVER = false;
        try {
            // handle The "operation is insecure" when cookie is disabled
            DEBUG_STEP_OVER = typeof window !== 'undefined' && Boolean((0, $17wUi.confluenceSessionStorageInstance)?.getItem((0, $1UApO.keys).CONFLUENCE_LOADABLE_STEP_OVER_ENABLED));
        } catch (e) {}
        this.maxQueueTimeMs = options.maxQueueTimeMs || (DEBUG_STEP_OVER ? 0 : 10000);
        this.debounceTimeMs = options.debounceTimeMs || 0;
        this.disabled = options.disabled || false;
        this.allowedPriority = DEBUG_STEP_OVER ? (0, $398ES.LoadingPriority).PAINT : (0, $398ES.LoadingPriority).MAX_PRIORITY;
        this.totalTasksHydratedAtOncePerTaskId = options.totalHydratedAtOnce || 0;
        this.serverMarkupHydratedCountMap = new Map();
        this.runTasks = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            const deadline = performance.now() + $c072487ed52e1be0$var$TASK_TIME_QUANTUM;
            // Get all the heap items unless that is no more item with the same priority
            let lastPriority = Infinity;
            const batch = [];
            while(!this.running.size && this.queue.size && this.queue.peek().priority <= Math.min(this.allowedPriority, lastPriority)){
                // If runTask takes more than TIME_QUANTUM ms and there's a pending input
                // break the task execution to allow time for an input handler
                if ($c072487ed52e1be0$var$isInputPending() && performance.now() >= deadline) {
                    setTimeout(()=>this.runTasks(), $c072487ed52e1be0$var$TASK_DELAY);
                    return;
                }
                const item = this.queue.poll();
                lastPriority = item.priority;
                // Run task
                item.futureTask.run();
                batch.push(item);
                // On task finish
                // eslint-disable-next-line  @typescript-eslint/no-floating-promises
                item.futureTask.result.finally(()=>{
                    this.running.delete(item);
                    if (item._delayHydration && //totalTasksHydratedAtOnce acts as a switch to turn on/off hydration delay
                    window.__SSR_RENDERED__ && this.totalTasksHydratedAtOncePerTaskId > 0 && this.serverMarkupHydratedCountMap.has(item.id)) this.serverMarkupHydratedCountMap.set(item.id, this.serverMarkupHydratedCountMap.get(item.id) - 1);
                    this.runTasks();
                });
            }
            batch.forEach((t)=>this.running.add(t));
            batch.length = 0;
        }, this.debounceTimeMs);
        if (DEBUG_STEP_OVER) document.addEventListener('loadable-devtool-next-phase', ()=>{
            this.allowedPriority = Math.min(this.allowedPriority + 1, (0, $398ES.LoadingPriority).MAX_PRIORITY);
            $c072487ed52e1be0$var$logger.debug`Allowed priority: ${this.allowedPriority}. Remaining tasks: ${this.queue.size}`;
            this.runTasks();
        });
    }
}
let $c072487ed52e1be0$var$taskManager;
const $c072487ed52e1be0$export$68bd643cc48865fe = (options)=>{
    if (!$c072487ed52e1be0$var$taskManager) $c072487ed52e1be0$var$taskManager = new $c072487ed52e1be0$export$9d8267e945b03765({
        disabled: false,
        ...options
    });
    return $c072487ed52e1be0$var$taskManager;
};
module.exports["getTaskManager"] = $c072487ed52e1be0$export$68bd643cc48865fe;

});

parcelRegister("b6HON", function(module, exports) {
/**
 * Returns a promise that can be resolved by calling the resolve function.
 * The promise will be resolved automatically after timeout
 */ function $f1ff60606a74851f$export$260e5c0943f31606(timeout, timeoutCallback) {
    let resolve;
    let timerId;
    const promise = new Promise((_resolve)=>{
        timerId = setTimeout(()=>{
            _resolve();
            if (timeoutCallback) timeoutCallback();
        }, timeout);
        resolve = _resolve;
    });
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    promise.finally(()=>{
        clearTimeout(timerId);
    });
    return {
        promise: promise,
        resolve: // @ts-ignore
        resolve
    };
}
module.exports["defer"] = $f1ff60606a74851f$export$260e5c0943f31606;

});

parcelRegister("dVUnn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5ZqQS = parcelRequire("5ZqQS");


var $fJlJm = parcelRequire("fJlJm");

function $40f7bd57b03838e5$export$d6a2d630e424851d(type, rest, name) {
    // https://github.com/facebook/react/blob/8f8b336734d7c807f5aa11b0f31540e63302d789/packages/react-reconciler/src/ReactFiber.js#L557
    const validType = // Functional or class component
    typeof type === 'function' || // built-in HTML elements
    typeof type === 'string' || // react special types like fragments
    typeof type === 'symbol' || // other special types like context and memo
    typeof type === 'object' && type !== null && type.$$typeof;
    if (!validType) {
        let serialized = typeof type;
        try {
            if (serialized === 'object') serialized = JSON.stringify(type);
        } catch (e) {
            serialized = `Error serializing ${typeof type}: ${e.message}`;
        }
        const error = new Error(`Invalid loadable createElement type: ${serialized}`);
        (0, $fJlJm.setLoadableErrorAttributes)(error, {
            name: name
        });
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: 'backbone-loadable'
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(type, rest);
}
module.exports["createElementWithCheckForInvalidType"] = $40f7bd57b03838e5$export$d6a2d630e424851d;

});

parcelRegister("lojHn", function(module, exports) {
/* outline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $dcc520ac648b1b27$var$baseOutlineStyles = null;
const $dcc520ac648b1b27$var$colorMap = {
    red: "_12ji5scu _1qu2gq9o _12y3yh40 _1hfk5scu",
    yellow: "_12jiwxnz _1qu2gq9o _12y3yh40 _1hfkwxnz",
    blue: "_12ji13q2 _1qu2gq9o _12y3yh40 _1hfk13q2",
    green: "_12jibf54 _1qu2gq9o _12y3yh40 _1hfkbf54"
};
const $dcc520ac648b1b27$export$59c76a2fc842a0f1 = (color, element)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswh2mm _aetrb3bt _18postnw _15l2idpf _19doidpf _32rxidpf _1x88idpf _1peqsxj9",
            $dcc520ac648b1b27$var$colorMap[color]
        ])
    }, element);
module.exports["withOutline"] = $dcc520ac648b1b27$export$59c76a2fc842a0f1;

});

parcelRegister("jjudR", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $e0f73c3ac42b2c93$var$syncFallback = function syncFallback(create) {
    return create();
};
var $e0f73c3ac42b2c93$var$useInsertionEffect = false;
var $e0f73c3ac42b2c93$export$db21c7ffa21794e7 = $e0f73c3ac42b2c93$var$useInsertionEffect || $e0f73c3ac42b2c93$var$syncFallback;
var $e0f73c3ac42b2c93$export$811a713a7276cb9d = $e0f73c3ac42b2c93$var$useInsertionEffect || $42omo.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $e0f73c3ac42b2c93$export$db21c7ffa21794e7;
module.exports["useInsertionEffectWithLayoutFallback"] = $e0f73c3ac42b2c93$export$811a713a7276cb9d;

});

parcelRegister("lk6Q6", function(module, exports) {

var $56GFp = parcelRequire("56GFp");

// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f860c55ffb8525f6$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($56GFp)))(targetComponent, sourceComponent);
};
module.exports["default"] = $f860c55ffb8525f6$export$2e2bcd8739ae039;

});

parcelRegister("6iiHx", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");

var $4952ee32a5b0e4c3$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($4952ee32a5b0e4c3$var$DisplayName || ($4952ee32a5b0e4c3$var$DisplayName = {}));
var $4952ee32a5b0e4c3$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($4952ee32a5b0e4c3$var$DisplayNameParts || ($4952ee32a5b0e4c3$var$DisplayNameParts = {}));
var $4952ee32a5b0e4c3$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $8C5kA.default)();
    var value = props.value, children = props.children, formatProps = (0, $hXuPC.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$4952ee32a5b0e4c3$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $4952ee32a5b0e4c3$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $8C5kA.default)();
    var value = props.value, children = props.children, formatProps = (0, $hXuPC.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$4952ee32a5b0e4c3$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $4952ee32a5b0e4c3$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $8C5kA.default)();
        var value = props.value, children = props.children, formatProps = (0, $hXuPC.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $4952ee32a5b0e4c3$var$DisplayNameParts[name];
    return ComponentParts;
}
function $4952ee32a5b0e4c3$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $8C5kA.default)();
        var value = props.value, children = props.children, formatProps = (0, $hXuPC.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $42omo.Fragment;
        return $42omo.createElement(Text, null, formattedValue);
    };
    Component.displayName = $4952ee32a5b0e4c3$var$DisplayName[name];
    return Component;
}
module.exports["FormattedNumberParts"] = $4952ee32a5b0e4c3$export$54d4989ed3eea1ea;
module.exports["FormattedListParts"] = $4952ee32a5b0e4c3$export$5ac259c7da6d2188;
module.exports["createFormattedDateTimePartsComponent"] = $4952ee32a5b0e4c3$export$7448277f6036d2ab;
module.exports["createFormattedComponent"] = $4952ee32a5b0e4c3$export$b37e14176d001dec;

});

parcelRegister("bCOYK", function(module, exports) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");

var $876ac9a7275ec82b$var$FormattedPlural = function(props) {
    var _a = (0, $8C5kA.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return $42omo.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$876ac9a7275ec82b$var$FormattedPlural.defaultProps = {
    type: 'cardinal'
};
$876ac9a7275ec82b$var$FormattedPlural.displayName = 'FormattedPlural';
var $876ac9a7275ec82b$export$2e2bcd8739ae039 = $876ac9a7275ec82b$var$FormattedPlural;
module.exports["default"] = $876ac9a7275ec82b$export$2e2bcd8739ae039;

});

parcelRegister("g0khF", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");

var $ba6c616458718860$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $8C5kA.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $hXuPC.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || $42omo.Fragment;
    return $42omo.createElement(Text, null, formattedValue);
};
$ba6c616458718860$var$FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
var $ba6c616458718860$export$2e2bcd8739ae039 = $ba6c616458718860$var$FormattedDateTimeRange;
module.exports["default"] = $ba6c616458718860$export$2e2bcd8739ae039;

});

parcelRegister("6ttb4", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $4b6c158d4375af5b$export$557d6acb76e8a244);

var $hXuPC = parcelRequire("hXuPC");

var $4b6c158d4375af5b$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($4b6c158d4375af5b$export$557d6acb76e8a244 || ($4b6c158d4375af5b$export$557d6acb76e8a244 = {}));
var $4b6c158d4375af5b$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $4b6c158d4375af5b$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $4b6c158d4375af5b$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($4b6c158d4375af5b$export$c016d36112f6ddf8);
var $4b6c158d4375af5b$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $4b6c158d4375af5b$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($4b6c158d4375af5b$export$c016d36112f6ddf8);
var $4b6c158d4375af5b$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $4b6c158d4375af5b$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($4b6c158d4375af5b$export$c016d36112f6ddf8);
var $4b6c158d4375af5b$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, $4b6c158d4375af5b$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}($4b6c158d4375af5b$export$c016d36112f6ddf8);
var $4b6c158d4375af5b$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}($4b6c158d4375af5b$export$e3b7eee1dbc44895);
var $4b6c158d4375af5b$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $4b6c158d4375af5b$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? 'default message' : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($4b6c158d4375af5b$export$c016d36112f6ddf8);
module.exports["IntlError"] = $4b6c158d4375af5b$export$c016d36112f6ddf8;
module.exports["UnsupportedFormatterError"] = $4b6c158d4375af5b$export$549f97e137a05c90;
module.exports["InvalidConfigError"] = $4b6c158d4375af5b$export$3ca04dd7fb305893;
module.exports["MissingDataError"] = $4b6c158d4375af5b$export$c1eaf877d81384b6;
module.exports["IntlFormatError"] = $4b6c158d4375af5b$export$e3b7eee1dbc44895;
module.exports["MessageFormatError"] = $4b6c158d4375af5b$export$74a601a3d3f31621;
module.exports["MissingTranslationError"] = $4b6c158d4375af5b$export$2ddcb436d0aa3688;

});

parcelRegister("lIKdq", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $42omo = parcelRequire("42omo");


var $eZGdB = parcelRequire("eZGdB");


var $fI8ba = parcelRequire("fI8ba");

function $fd018e7854e00d1a$export$45c4bbf6e55bba1f(intl) {
    (0, $eZGdB.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $fd018e7854e00d1a$export$b52f8d6fc0d47415 = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, (0, $fI8ba.DEFAULT_INTL_CONFIG)), {
    textComponent: $42omo.Fragment
});
function $fd018e7854e00d1a$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($42omo.Children.toArray(parts));
    };
}
function $fd018e7854e00d1a$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
module.exports["invariantIntlContext"] = $fd018e7854e00d1a$export$45c4bbf6e55bba1f;
module.exports["DEFAULT_INTL_CONFIG"] = $fd018e7854e00d1a$export$b52f8d6fc0d47415;
module.exports["assignUniqueKeysToParts"] = $fd018e7854e00d1a$export$cfec03d26465fa63;
module.exports["shallowEqual"] = $fd018e7854e00d1a$export$d36bdfa510afb180;

});

parcelRegister("jvvYq", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $e339b6e12d975bbd$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $e339b6e12d975bbd$export$906452485466fa53);
var $e339b6e12d975bbd$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($e339b6e12d975bbd$export$b87f371cbc396fcf || ($e339b6e12d975bbd$export$b87f371cbc396fcf = {}));
var $e339b6e12d975bbd$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($e339b6e12d975bbd$export$906452485466fa53 || ($e339b6e12d975bbd$export$906452485466fa53 = {}));
function $e339b6e12d975bbd$export$cfa10c5697238752(el) {
    return el.type === $e339b6e12d975bbd$export$b87f371cbc396fcf.literal;
}
function $e339b6e12d975bbd$export$4f55724281bdfaf9(el) {
    return el.type === $e339b6e12d975bbd$export$b87f371cbc396fcf.argument;
}
function $e339b6e12d975bbd$export$e11187b219e191e1(el) {
    return el.type === $e339b6e12d975bbd$export$b87f371cbc396fcf.number;
}
function $e339b6e12d975bbd$export$32d811605da75f40(el) {
    return el.type === $e339b6e12d975bbd$export$b87f371cbc396fcf.date;
}
function $e339b6e12d975bbd$export$34ec46f596b1702f(el) {
    return el.type === $e339b6e12d975bbd$export$b87f371cbc396fcf.time;
}
function $e339b6e12d975bbd$export$dcfe1c11d168b5a1(el) {
    return el.type === $e339b6e12d975bbd$export$b87f371cbc396fcf.select;
}
function $e339b6e12d975bbd$export$6c796d116f0a4fbc(el) {
    return el.type === $e339b6e12d975bbd$export$b87f371cbc396fcf.plural;
}
function $e339b6e12d975bbd$export$c0ece297bdd0c082(el) {
    return el.type === $e339b6e12d975bbd$export$b87f371cbc396fcf.pound;
}
function $e339b6e12d975bbd$export$5c83de34745812b(el) {
    return el.type === $e339b6e12d975bbd$export$b87f371cbc396fcf.tag;
}
function $e339b6e12d975bbd$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $e339b6e12d975bbd$export$906452485466fa53.number);
}
function $e339b6e12d975bbd$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $e339b6e12d975bbd$export$906452485466fa53.dateTime);
}
function $e339b6e12d975bbd$export$f0ac572c1121c662(value) {
    return {
        type: $e339b6e12d975bbd$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $e339b6e12d975bbd$export$425e864b0ba114f1(value, style) {
    return {
        type: $e339b6e12d975bbd$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}
module.exports["isLiteralElement"] = $e339b6e12d975bbd$export$cfa10c5697238752;
module.exports["isArgumentElement"] = $e339b6e12d975bbd$export$4f55724281bdfaf9;
module.exports["isNumberElement"] = $e339b6e12d975bbd$export$e11187b219e191e1;
module.exports["isDateElement"] = $e339b6e12d975bbd$export$32d811605da75f40;
module.exports["isTimeElement"] = $e339b6e12d975bbd$export$34ec46f596b1702f;
module.exports["isSelectElement"] = $e339b6e12d975bbd$export$dcfe1c11d168b5a1;
module.exports["isPluralElement"] = $e339b6e12d975bbd$export$6c796d116f0a4fbc;
module.exports["isPoundElement"] = $e339b6e12d975bbd$export$c0ece297bdd0c082;
module.exports["isTagElement"] = $e339b6e12d975bbd$export$5c83de34745812b;
module.exports["isNumberSkeleton"] = $e339b6e12d975bbd$export$3f9a19cd4152eda3;
module.exports["isDateTimeSkeleton"] = $e339b6e12d975bbd$export$7680c41f1a55f4cf;

});

parcelRegister("4Duar", function(module, exports) {
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $3602348e26a0b2ca$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $3602348e26a0b2ca$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($3602348e26a0b2ca$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}
module.exports["parseDateTimeSkeleton"] = $3602348e26a0b2ca$export$f7b99fb377fe69fa;

});

parcelRegister("alwPZ", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

// @generated from regex-gen.ts
var $33049cb248340bf7$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $78855669f807d5a2$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $33049cb248340bf7$export$2b8db14d8bcaece7)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $78855669f807d5a2$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $78855669f807d5a2$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $78855669f807d5a2$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $78855669f807d5a2$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $78855669f807d5a2$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $78855669f807d5a2$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($78855669f807d5a2$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $78855669f807d5a2$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $78855669f807d5a2$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$78855669f807d5a2$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $78855669f807d5a2$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $78855669f807d5a2$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $78855669f807d5a2$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $78855669f807d5a2$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, all), $78855669f807d5a2$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, all), $78855669f807d5a2$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($78855669f807d5a2$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($78855669f807d5a2$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($78855669f807d5a2$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($78855669f807d5a2$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, result), $78855669f807d5a2$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($78855669f807d5a2$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, result), $78855669f807d5a2$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $78855669f807d5a2$var$parseSign(token.stem);
        if (signOpts) result = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $78855669f807d5a2$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}
module.exports["parseNumberSkeletonFromString"] = $78855669f807d5a2$export$71cee2f16fba2480;
module.exports["parseNumberSkeleton"] = $78855669f807d5a2$export$47c6f8480bda3e11;

});

parcelRegister("lRVkV", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $febb060fd7956e0d$export$d4e71bc0b80dc0fb);

var $hXuPC = parcelRequire("hXuPC");

var $febb060fd7956e0d$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($febb060fd7956e0d$export$d4e71bc0b80dc0fb || ($febb060fd7956e0d$export$d4e71bc0b80dc0fb = {}));
var $febb060fd7956e0d$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $febb060fd7956e0d$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $febb060fd7956e0d$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($febb060fd7956e0d$export$7369836851cc1329);
var $febb060fd7956e0d$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $febb060fd7956e0d$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($febb060fd7956e0d$export$7369836851cc1329);
var $febb060fd7956e0d$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $febb060fd7956e0d$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($febb060fd7956e0d$export$7369836851cc1329);
module.exports["FormatError"] = $febb060fd7956e0d$export$7369836851cc1329;
module.exports["InvalidValueError"] = $febb060fd7956e0d$export$565c3afc07dfa382;
module.exports["InvalidValueTypeError"] = $febb060fd7956e0d$export$cbc0db47c750f7c9;
module.exports["MissingValueError"] = $febb060fd7956e0d$export$8bfc137e4d23fdf0;

});

parcelRegister("29bcO", function(module, exports) {
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $hXuPC = parcelRequire("hXuPC");


var $1oTFG = parcelRequire("1oTFG");


var $8lH4q = parcelRequire("8lH4q");


var $eUSop = parcelRequire("eUSop");

// -- MessageFormat --------------------------------------------------------
function $19051d408d9c9b13$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $19051d408d9c9b13$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $19051d408d9c9b13$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $hXuPC.__assign)({}, defaultConfig));
}
function $19051d408d9c9b13$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $19051d408d9c9b13$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $8lH4q.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $hXuPC.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $19051d408d9c9b13$var$createFastMemoizeCache(cache.number),
            strategy: (0, $8lH4q.strategies).variadic
        }),
        getDateTimeFormat: (0, $8lH4q.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $hXuPC.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $19051d408d9c9b13$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $8lH4q.strategies).variadic
        }),
        getPluralRules: (0, $8lH4q.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $hXuPC.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $19051d408d9c9b13$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $8lH4q.strategies).variadic
        })
    };
}
var $19051d408d9c9b13$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $eUSop.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $eUSop.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: _this.resolvedLocale.toString()
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $19051d408d9c9b13$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $19051d408d9c9b13$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $1oTFG.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();
module.exports["IntlMessageFormat"] = $19051d408d9c9b13$export$d342343268debc40;

});

parcelRegister("d2KKO", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $97efbaa45122aeca$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $97efbaa45122aeca$export$906452485466fa53);
var $97efbaa45122aeca$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($97efbaa45122aeca$export$b87f371cbc396fcf || ($97efbaa45122aeca$export$b87f371cbc396fcf = {}));
var $97efbaa45122aeca$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($97efbaa45122aeca$export$906452485466fa53 || ($97efbaa45122aeca$export$906452485466fa53 = {}));
function $97efbaa45122aeca$export$cfa10c5697238752(el) {
    return el.type === $97efbaa45122aeca$export$b87f371cbc396fcf.literal;
}
function $97efbaa45122aeca$export$4f55724281bdfaf9(el) {
    return el.type === $97efbaa45122aeca$export$b87f371cbc396fcf.argument;
}
function $97efbaa45122aeca$export$e11187b219e191e1(el) {
    return el.type === $97efbaa45122aeca$export$b87f371cbc396fcf.number;
}
function $97efbaa45122aeca$export$32d811605da75f40(el) {
    return el.type === $97efbaa45122aeca$export$b87f371cbc396fcf.date;
}
function $97efbaa45122aeca$export$34ec46f596b1702f(el) {
    return el.type === $97efbaa45122aeca$export$b87f371cbc396fcf.time;
}
function $97efbaa45122aeca$export$dcfe1c11d168b5a1(el) {
    return el.type === $97efbaa45122aeca$export$b87f371cbc396fcf.select;
}
function $97efbaa45122aeca$export$6c796d116f0a4fbc(el) {
    return el.type === $97efbaa45122aeca$export$b87f371cbc396fcf.plural;
}
function $97efbaa45122aeca$export$c0ece297bdd0c082(el) {
    return el.type === $97efbaa45122aeca$export$b87f371cbc396fcf.pound;
}
function $97efbaa45122aeca$export$5c83de34745812b(el) {
    return el.type === $97efbaa45122aeca$export$b87f371cbc396fcf.tag;
}
function $97efbaa45122aeca$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $97efbaa45122aeca$export$906452485466fa53.number);
}
function $97efbaa45122aeca$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $97efbaa45122aeca$export$906452485466fa53.dateTime);
}
function $97efbaa45122aeca$export$f0ac572c1121c662(value) {
    return {
        type: $97efbaa45122aeca$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $97efbaa45122aeca$export$425e864b0ba114f1(value, style) {
    return {
        type: $97efbaa45122aeca$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}
module.exports["isNumberElement"] = $97efbaa45122aeca$export$e11187b219e191e1;
module.exports["isDateElement"] = $97efbaa45122aeca$export$32d811605da75f40;
module.exports["isTimeElement"] = $97efbaa45122aeca$export$34ec46f596b1702f;
module.exports["isSelectElement"] = $97efbaa45122aeca$export$dcfe1c11d168b5a1;
module.exports["isPluralElement"] = $97efbaa45122aeca$export$6c796d116f0a4fbc;
module.exports["isTagElement"] = $97efbaa45122aeca$export$5c83de34745812b;
module.exports["isNumberSkeleton"] = $97efbaa45122aeca$export$3f9a19cd4152eda3;
module.exports["isDateTimeSkeleton"] = $97efbaa45122aeca$export$7680c41f1a55f4cf;

});

parcelRegister("eqdqo", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("4Duar")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("alwPZ")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("alwPZ")).parseNumberSkeletonFromString);
parcelRequire("4Duar");

parcelRequire("alwPZ");


});

parcelRegister("eUSop", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $adc07ced9d801a78$export$49694c2877b44c57);
parcelRequire("1oTFG");
var $jvvYq = parcelRequire("jvvYq");


var $lRVkV = parcelRequire("lRVkV");

var $adc07ced9d801a78$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($adc07ced9d801a78$export$49694c2877b44c57 || ($adc07ced9d801a78$export$49694c2877b44c57 = {}));
function $adc07ced9d801a78$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $adc07ced9d801a78$export$49694c2877b44c57.literal || part.type !== $adc07ced9d801a78$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $adc07ced9d801a78$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $adc07ced9d801a78$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $jvvYq.isLiteralElement)(els[0])) return [
        {
            type: $adc07ced9d801a78$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $jvvYq.isLiteralElement)(el)) {
            result.push({
                type: $adc07ced9d801a78$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $jvvYq.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $adc07ced9d801a78$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $lRVkV.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $jvvYq.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $adc07ced9d801a78$export$49694c2877b44c57.literal : $adc07ced9d801a78$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $jvvYq.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $jvvYq.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $adc07ced9d801a78$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jvvYq.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $jvvYq.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $adc07ced9d801a78$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jvvYq.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $jvvYq.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $adc07ced9d801a78$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jvvYq.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$adc07ced9d801a78$export$df0c12a2d414a163(formatFn)) throw new (0, $lRVkV.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $adc07ced9d801a78$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $adc07ced9d801a78$export$49694c2877b44c57.literal : $adc07ced9d801a78$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $jvvYq.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $lRVkV.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $adc07ced9d801a78$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $jvvYq.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $lRVkV.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $lRVkV.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $lRVkV.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $adc07ced9d801a78$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $adc07ced9d801a78$var$mergeLiteral(result);
}
module.exports["isFormatXMLElementFn"] = $adc07ced9d801a78$export$df0c12a2d414a163;
module.exports["formatToParts"] = $adc07ced9d801a78$export$275d4a3bb5f66fda;

});

parcelRegister("eZGdB", function(module, exports) {
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $02d12745c3c5445e$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $02d12745c3c5445e$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $02d12745c3c5445e$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $02d12745c3c5445e$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $02d12745c3c5445e$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $02d12745c3c5445e$export$3fae2929ed23c202(map, pl, field) {
    return $02d12745c3c5445e$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $02d12745c3c5445e$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $02d12745c3c5445e$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $02d12745c3c5445e$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $02d12745c3c5445e$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $02d12745c3c5445e$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
module.exports["invariant"] = $02d12745c3c5445e$export$f5708dca728d7177;

});

parcelRegister("eI8vp", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $iA9co = parcelRequire("iA9co");

var $ab5bc5cb186d1202$var$Buffer = $iA9co.Buffer;
// alternative to using Object.keys for old browsers
function $ab5bc5cb186d1202$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($ab5bc5cb186d1202$var$Buffer.from && $ab5bc5cb186d1202$var$Buffer.alloc && $ab5bc5cb186d1202$var$Buffer.allocUnsafe && $ab5bc5cb186d1202$var$Buffer.allocUnsafeSlow) module.exports = $iA9co;
else {
    // Copy properties from require('buffer')
    $ab5bc5cb186d1202$var$copyProps($iA9co, module.exports);
    module.exports.Buffer = $ab5bc5cb186d1202$var$SafeBuffer;
}
function $ab5bc5cb186d1202$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $ab5bc5cb186d1202$var$Buffer(arg, encodingOrOffset, length);
}
$ab5bc5cb186d1202$var$SafeBuffer.prototype = Object.create($ab5bc5cb186d1202$var$Buffer.prototype);
// Copy static methods from Buffer
$ab5bc5cb186d1202$var$copyProps($ab5bc5cb186d1202$var$Buffer, $ab5bc5cb186d1202$var$SafeBuffer);
$ab5bc5cb186d1202$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $ab5bc5cb186d1202$var$Buffer(arg, encodingOrOffset, length);
};
$ab5bc5cb186d1202$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $ab5bc5cb186d1202$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$ab5bc5cb186d1202$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $ab5bc5cb186d1202$var$Buffer(size);
};
$ab5bc5cb186d1202$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $iA9co.SlowBuffer(size);
};

});

parcelRegister("gBIbs", function(module, exports) {
'use strict';
var $c1725fffef8cbeda$var$elliptic = module.exports;

$c1725fffef8cbeda$var$elliptic.version = (parcelRequire("5kU12")).version;

$c1725fffef8cbeda$var$elliptic.utils = (parcelRequire("ljKeU"));

$c1725fffef8cbeda$var$elliptic.rand = (parcelRequire("7VcJI"));

$c1725fffef8cbeda$var$elliptic.curve = (parcelRequire("fFhvD"));

$c1725fffef8cbeda$var$elliptic.curves = (parcelRequire("6DqYG"));

// Protocols
$c1725fffef8cbeda$var$elliptic.ec = (parcelRequire("kiFNt"));

$c1725fffef8cbeda$var$elliptic.eddsa = (parcelRequire("7XMT8"));

});

parcelRegister("k3MQ7", function(module, exports) {
var $e9a9f8f831b5ce65$var$asn1 = module.exports;

$e9a9f8f831b5ce65$var$asn1.bignum = (parcelRequire("hpluo"));

$e9a9f8f831b5ce65$var$asn1.define = (parcelRequire("4PflA")).define;

$e9a9f8f831b5ce65$var$asn1.base = (parcelRequire("aTE7O"));

$e9a9f8f831b5ce65$var$asn1.constants = (parcelRequire("cqiEw"));

$e9a9f8f831b5ce65$var$asn1.decoders = (parcelRequire("a30dO"));

$e9a9f8f831b5ce65$var$asn1.encoders = (parcelRequire("8tslJ"));

});

parcelRegister("2QUb5", function(module, exports) {
$parcel$export(module.exports, "publicEncrypt", () => $213c03d9967ac195$export$512823e338ddb1b7, (v) => $213c03d9967ac195$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $213c03d9967ac195$export$7efb24e2fddf99b9, (v) => $213c03d9967ac195$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $213c03d9967ac195$export$9d0e0c0c4a8d30f3, (v) => $213c03d9967ac195$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $213c03d9967ac195$export$b9d55ff329113abd, (v) => $213c03d9967ac195$export$b9d55ff329113abd = v);
var $213c03d9967ac195$export$512823e338ddb1b7;
var $213c03d9967ac195$export$7efb24e2fddf99b9;
var $213c03d9967ac195$export$9d0e0c0c4a8d30f3;
var $213c03d9967ac195$export$b9d55ff329113abd;

$213c03d9967ac195$export$512823e338ddb1b7 = (parcelRequire("ksS2r"));

$213c03d9967ac195$export$7efb24e2fddf99b9 = (parcelRequire("7zmOG"));
$213c03d9967ac195$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $213c03d9967ac195$export$512823e338ddb1b7(key, buf, true);
};
$213c03d9967ac195$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $213c03d9967ac195$export$7efb24e2fddf99b9(key, buf, true);
};

});

parcelRegister("DPs2c", function(module, exports) {
'use strict';

var $dMzRp = parcelRequire("dMzRp");


var $8LjNz = parcelRequire("8LjNz");


var $eI8vp = parcelRequire("eI8vp");

var $077b8dc36526faa9$require$Buffer = $eI8vp.Buffer;
var $077b8dc36526faa9$var$ARRAY16 = new Array(16);
function $077b8dc36526faa9$var$MD5() {
    $8LjNz.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dMzRp($077b8dc36526faa9$var$MD5, $8LjNz);
$077b8dc36526faa9$var$MD5.prototype._update = function() {
    var M = $077b8dc36526faa9$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $077b8dc36526faa9$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $077b8dc36526faa9$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $077b8dc36526faa9$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $077b8dc36526faa9$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $077b8dc36526faa9$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $077b8dc36526faa9$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $077b8dc36526faa9$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $077b8dc36526faa9$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $077b8dc36526faa9$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $077b8dc36526faa9$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $077b8dc36526faa9$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $077b8dc36526faa9$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $077b8dc36526faa9$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $077b8dc36526faa9$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $077b8dc36526faa9$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $077b8dc36526faa9$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $077b8dc36526faa9$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $077b8dc36526faa9$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $077b8dc36526faa9$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $077b8dc36526faa9$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $077b8dc36526faa9$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $077b8dc36526faa9$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $077b8dc36526faa9$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $077b8dc36526faa9$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $077b8dc36526faa9$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $077b8dc36526faa9$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $077b8dc36526faa9$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $077b8dc36526faa9$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $077b8dc36526faa9$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $077b8dc36526faa9$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $077b8dc36526faa9$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $077b8dc36526faa9$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $077b8dc36526faa9$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $077b8dc36526faa9$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $077b8dc36526faa9$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $077b8dc36526faa9$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $077b8dc36526faa9$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $077b8dc36526faa9$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $077b8dc36526faa9$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $077b8dc36526faa9$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $077b8dc36526faa9$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $077b8dc36526faa9$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $077b8dc36526faa9$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $077b8dc36526faa9$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $077b8dc36526faa9$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $077b8dc36526faa9$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $077b8dc36526faa9$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $077b8dc36526faa9$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $077b8dc36526faa9$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $077b8dc36526faa9$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $077b8dc36526faa9$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $077b8dc36526faa9$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $077b8dc36526faa9$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $077b8dc36526faa9$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $077b8dc36526faa9$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $077b8dc36526faa9$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $077b8dc36526faa9$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $077b8dc36526faa9$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $077b8dc36526faa9$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $077b8dc36526faa9$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $077b8dc36526faa9$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $077b8dc36526faa9$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $077b8dc36526faa9$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $077b8dc36526faa9$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$077b8dc36526faa9$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $077b8dc36526faa9$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $077b8dc36526faa9$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $077b8dc36526faa9$var$fnF(a, b, c, d, m, k, s) {
    return $077b8dc36526faa9$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $077b8dc36526faa9$var$fnG(a, b, c, d, m, k, s) {
    return $077b8dc36526faa9$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $077b8dc36526faa9$var$fnH(a, b, c, d, m, k, s) {
    return $077b8dc36526faa9$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $077b8dc36526faa9$var$fnI(a, b, c, d, m, k, s) {
    return $077b8dc36526faa9$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $077b8dc36526faa9$var$MD5;

});

parcelRegister("8LjNz", function(module, exports) {
'use strict';

var $eI8vp = parcelRequire("eI8vp");

var $661212188196e049$require$Buffer = $eI8vp.Buffer;

var $kQLUz = parcelRequire("kQLUz");

var $661212188196e049$require$Transform = $kQLUz.Transform;

var $dMzRp = parcelRequire("dMzRp");

function $661212188196e049$var$HashBase(blockSize) {
    $661212188196e049$require$Transform.call(this);
    this._block = $661212188196e049$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dMzRp($661212188196e049$var$HashBase, $661212188196e049$require$Transform);
$661212188196e049$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$661212188196e049$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
var $661212188196e049$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $661212188196e049$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($661212188196e049$require$Buffer.prototype instanceof Uint8Array || $661212188196e049$require$Buffer.TYPED_ARRAY_SUPPORT);
function $661212188196e049$var$toBuffer(data, encoding) {
    // No need to do anything for exact instance
    // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
    if (data instanceof $661212188196e049$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $661212188196e049$require$Buffer.from(data, encoding);
    /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */ if ($661212188196e049$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        if (data.byteLength === 0) return $661212188196e049$require$Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        ;
        var res = $661212188196e049$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        // Recheck result size, as offset/length doesn't work on Node.js <5.10
        // We just go to Uint8Array case if this fails
        if (res.byteLength === data.byteLength) return res;
    }
    /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */ if ($661212188196e049$var$useUint8Array && data instanceof Uint8Array) return $661212188196e049$require$Buffer.from(data);
    /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */ if ($661212188196e049$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $661212188196e049$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$661212188196e049$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    data = $661212188196e049$var$toBuffer(data, encoding) // asserts correct input type
    ;
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$661212188196e049$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$661212188196e049$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$661212188196e049$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $661212188196e049$var$HashBase;

});

parcelRegister("3xrS3", function(module, exports) {
'use strict';

var $eI8vp = parcelRequire("eI8vp");

var $293a12b68b085d56$require$Buffer = $eI8vp.Buffer;

var $kQLUz = parcelRequire("kQLUz");

var $293a12b68b085d56$require$Transform = $kQLUz.Transform;

var $4jSqR = parcelRequire("4jSqR");

var $293a12b68b085d56$require$StringDecoder = $4jSqR.StringDecoder;

var $dMzRp = parcelRequire("dMzRp");

function $293a12b68b085d56$var$CipherBase(hashMode) {
    $293a12b68b085d56$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dMzRp($293a12b68b085d56$var$CipherBase, $293a12b68b085d56$require$Transform);
var $293a12b68b085d56$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $293a12b68b085d56$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($293a12b68b085d56$require$Buffer.prototype instanceof Uint8Array || $293a12b68b085d56$require$Buffer.TYPED_ARRAY_SUPPORT);
function $293a12b68b085d56$var$toBuffer(data, encoding) {
    /*
	 * No need to do anything for exact instance
	 * This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
	 */ if (data instanceof $293a12b68b085d56$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $293a12b68b085d56$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($293a12b68b085d56$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $293a12b68b085d56$require$Buffer.alloc(0);
        var res = $293a12b68b085d56$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        /*
		 * Recheck result size, as offset/length doesn't work on Node.js <5.10
		 * We just go to Uint8Array case if this fails
		 */ if (res.byteLength === data.byteLength) return res;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($293a12b68b085d56$var$useUint8Array && data instanceof Uint8Array) return $293a12b68b085d56$require$Buffer.from(data);
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if ($293a12b68b085d56$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $293a12b68b085d56$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$293a12b68b085d56$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $293a12b68b085d56$var$toBuffer(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$293a12b68b085d56$var$CipherBase.prototype.setAutoPadding = function() {};
$293a12b68b085d56$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$293a12b68b085d56$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$293a12b68b085d56$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$293a12b68b085d56$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$293a12b68b085d56$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$293a12b68b085d56$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $293a12b68b085d56$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$293a12b68b085d56$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $293a12b68b085d56$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $293a12b68b085d56$var$CipherBase;

});

parcelRegister("lD5Li", function(module, exports) {

module.exports = (parcelRequire("5rDjV")).EventEmitter;

});

parcelRegister("8omKJ", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");

'use strict';
// undocumented cb() API, needed for core, not for public API
function $61c236d5c461835e$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $kyRHQ.nextTick($61c236d5c461835e$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $kyRHQ.nextTick($61c236d5c461835e$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $kyRHQ.nextTick($61c236d5c461835e$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $kyRHQ.nextTick($61c236d5c461835e$var$emitErrorAndCloseNT, _this, err);
            } else $kyRHQ.nextTick($61c236d5c461835e$var$emitCloseNT, _this);
        } else if (cb) {
            $kyRHQ.nextTick($61c236d5c461835e$var$emitCloseNT, _this);
            cb(err);
        } else $kyRHQ.nextTick($61c236d5c461835e$var$emitCloseNT, _this);
    });
    return this;
}
function $61c236d5c461835e$var$emitErrorAndCloseNT(self, err) {
    $61c236d5c461835e$var$emitErrorNT(self, err);
    $61c236d5c461835e$var$emitCloseNT(self);
}
function $61c236d5c461835e$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $61c236d5c461835e$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $61c236d5c461835e$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $61c236d5c461835e$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $61c236d5c461835e$var$destroy,
    undestroy: $61c236d5c461835e$var$undestroy,
    errorOrDestroy: $61c236d5c461835e$var$errorOrDestroy
};

});

parcelRegister("dh1Ip", function(module, exports) {
'use strict';

var $9a9e3188e84c1561$var$ERR_INVALID_OPT_VALUE = (parcelRequire("7x5Xe")).codes.ERR_INVALID_OPT_VALUE;
function $9a9e3188e84c1561$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $9a9e3188e84c1561$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $9a9e3188e84c1561$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $9a9e3188e84c1561$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $9a9e3188e84c1561$var$getHighWaterMark
};

});

parcelRegister("2fUgV", function(module, exports) {

var $eI8vp = parcelRequire("eI8vp");

var $1a48a1ebe2f1940c$require$Buffer = $eI8vp.Buffer;
// prototype class for hash functions
function $1a48a1ebe2f1940c$var$Hash(blockSize, finalSize) {
    this._block = $1a48a1ebe2f1940c$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$1a48a1ebe2f1940c$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === 'string') {
        enc = enc || 'utf8';
        data = $1a48a1ebe2f1940c$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$1a48a1ebe2f1940c$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$1a48a1ebe2f1940c$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $1a48a1ebe2f1940c$var$Hash;

});

parcelRegister("iG9PD", function(module, exports) {
'use strict';

var $iA9co = parcelRequire("iA9co");

var $d993c6a4e180fd3e$require$Buffer = $iA9co.Buffer;

var $dMzRp = parcelRequire("dMzRp");


var $8LjNz = parcelRequire("8LjNz");

var $d993c6a4e180fd3e$var$ARRAY16 = new Array(16);
var $d993c6a4e180fd3e$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $d993c6a4e180fd3e$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $d993c6a4e180fd3e$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $d993c6a4e180fd3e$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $d993c6a4e180fd3e$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $d993c6a4e180fd3e$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $d993c6a4e180fd3e$var$RIPEMD160() {
    $8LjNz.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dMzRp($d993c6a4e180fd3e$var$RIPEMD160, $8LjNz);
$d993c6a4e180fd3e$var$RIPEMD160.prototype._update = function() {
    var words = $d993c6a4e180fd3e$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $d993c6a4e180fd3e$var$fn1(al, bl, cl, dl, el, words[$d993c6a4e180fd3e$var$zl[i]], $d993c6a4e180fd3e$var$hl[0], $d993c6a4e180fd3e$var$sl[i]);
            tr = $d993c6a4e180fd3e$var$fn5(ar, br, cr, dr, er, words[$d993c6a4e180fd3e$var$zr[i]], $d993c6a4e180fd3e$var$hr[0], $d993c6a4e180fd3e$var$sr[i]);
        } else if (i < 32) {
            tl = $d993c6a4e180fd3e$var$fn2(al, bl, cl, dl, el, words[$d993c6a4e180fd3e$var$zl[i]], $d993c6a4e180fd3e$var$hl[1], $d993c6a4e180fd3e$var$sl[i]);
            tr = $d993c6a4e180fd3e$var$fn4(ar, br, cr, dr, er, words[$d993c6a4e180fd3e$var$zr[i]], $d993c6a4e180fd3e$var$hr[1], $d993c6a4e180fd3e$var$sr[i]);
        } else if (i < 48) {
            tl = $d993c6a4e180fd3e$var$fn3(al, bl, cl, dl, el, words[$d993c6a4e180fd3e$var$zl[i]], $d993c6a4e180fd3e$var$hl[2], $d993c6a4e180fd3e$var$sl[i]);
            tr = $d993c6a4e180fd3e$var$fn3(ar, br, cr, dr, er, words[$d993c6a4e180fd3e$var$zr[i]], $d993c6a4e180fd3e$var$hr[2], $d993c6a4e180fd3e$var$sr[i]);
        } else if (i < 64) {
            tl = $d993c6a4e180fd3e$var$fn4(al, bl, cl, dl, el, words[$d993c6a4e180fd3e$var$zl[i]], $d993c6a4e180fd3e$var$hl[3], $d993c6a4e180fd3e$var$sl[i]);
            tr = $d993c6a4e180fd3e$var$fn2(ar, br, cr, dr, er, words[$d993c6a4e180fd3e$var$zr[i]], $d993c6a4e180fd3e$var$hr[3], $d993c6a4e180fd3e$var$sr[i]);
        } else {
            tl = $d993c6a4e180fd3e$var$fn5(al, bl, cl, dl, el, words[$d993c6a4e180fd3e$var$zl[i]], $d993c6a4e180fd3e$var$hl[4], $d993c6a4e180fd3e$var$sl[i]);
            tr = $d993c6a4e180fd3e$var$fn1(ar, br, cr, dr, er, words[$d993c6a4e180fd3e$var$zr[i]], $d993c6a4e180fd3e$var$hr[4], $d993c6a4e180fd3e$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $d993c6a4e180fd3e$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $d993c6a4e180fd3e$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$d993c6a4e180fd3e$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $d993c6a4e180fd3e$require$Buffer.alloc ? $d993c6a4e180fd3e$require$Buffer.alloc(20) : new $d993c6a4e180fd3e$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $d993c6a4e180fd3e$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $d993c6a4e180fd3e$var$fn1(a, b, c, d, e, m, k, s) {
    return $d993c6a4e180fd3e$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $d993c6a4e180fd3e$var$fn2(a, b, c, d, e, m, k, s) {
    return $d993c6a4e180fd3e$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $d993c6a4e180fd3e$var$fn3(a, b, c, d, e, m, k, s) {
    return $d993c6a4e180fd3e$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $d993c6a4e180fd3e$var$fn4(a, b, c, d, e, m, k, s) {
    return $d993c6a4e180fd3e$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $d993c6a4e180fd3e$var$fn5(a, b, c, d, e, m, k, s) {
    return $d993c6a4e180fd3e$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $d993c6a4e180fd3e$var$RIPEMD160;

});

parcelRegister("hyb5G", function(module, exports) {
var $cc6e36ffa2ef9ca4$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $cc6e36ffa2ef9ca4$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

$cc6e36ffa2ef9ca4$var$exports.sha = (parcelRequire("ceK8O"));

$cc6e36ffa2ef9ca4$var$exports.sha1 = (parcelRequire("1MHz3"));

$cc6e36ffa2ef9ca4$var$exports.sha224 = (parcelRequire("1p5m5"));

$cc6e36ffa2ef9ca4$var$exports.sha256 = (parcelRequire("4fDtH"));

$cc6e36ffa2ef9ca4$var$exports.sha384 = (parcelRequire("662NC"));

$cc6e36ffa2ef9ca4$var$exports.sha512 = (parcelRequire("7rB3k"));

});

parcelRegister("kQLUz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $f2ddd435842f4fe2$var$Stream;

var $5rDjV = parcelRequire("5rDjV");

var $f2ddd435842f4fe2$require$EE = $5rDjV.EventEmitter;

var $dMzRp = parcelRequire("dMzRp");

$dMzRp($f2ddd435842f4fe2$var$Stream, $f2ddd435842f4fe2$require$EE);

$f2ddd435842f4fe2$var$Stream.Readable = (parcelRequire("cjCi4"));

$f2ddd435842f4fe2$var$Stream.Writable = (parcelRequire("8cM2j"));

$f2ddd435842f4fe2$var$Stream.Duplex = (parcelRequire("1UQ2d"));

$f2ddd435842f4fe2$var$Stream.Transform = (parcelRequire("9kubK"));

$f2ddd435842f4fe2$var$Stream.PassThrough = (parcelRequire("kSdiX"));

$f2ddd435842f4fe2$var$Stream.finished = (parcelRequire("ehL28"));

$f2ddd435842f4fe2$var$Stream.pipeline = (parcelRequire("3DNUy"));
// Backwards-compat with node 0.4.x
$f2ddd435842f4fe2$var$Stream.Stream = $f2ddd435842f4fe2$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $f2ddd435842f4fe2$var$Stream() {
    $f2ddd435842f4fe2$require$EE.call(this);
}
$f2ddd435842f4fe2$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($f2ddd435842f4fe2$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});

parcelRegister("8THs5", function(module, exports) {
'use strict';
var $67a52a7814781665$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $67a52a7814781665$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("jmQ5f", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");

'use strict';
var $e1987919fff67bb0$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $e1987919fff67bb0$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $e1987919fff67bb0$var$pVersionMajor = parseInt($kyRHQ.version.split('.')[0].slice(1), 10);
    $e1987919fff67bb0$var$defaultEncoding = $e1987919fff67bb0$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $e1987919fff67bb0$var$defaultEncoding = 'utf-8';
module.exports = $e1987919fff67bb0$var$defaultEncoding;

});

parcelRegister("9Jtnp", function(module, exports) {
'use strict';

var $eI8vp = parcelRequire("eI8vp");

var $715f1a9b796effa2$require$Buffer = $eI8vp.Buffer;

var $acUKe = parcelRequire("acUKe");

var $715f1a9b796effa2$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $715f1a9b796effa2$var$useArrayBuffer = $715f1a9b796effa2$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $715f1a9b796effa2$var$isView = $715f1a9b796effa2$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $715f1a9b796effa2$require$Buffer.isBuffer(thing) || $715f1a9b796effa2$var$useUint8Array && thing instanceof Uint8Array || $715f1a9b796effa2$var$isView && $715f1a9b796effa2$var$isView(thing)) return $acUKe(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});

parcelRegister("bVf2p", function(module, exports) {
'use strict';

var $7WErB = parcelRequire("7WErB");


var $bLmKG = parcelRequire("bLmKG");


var $kGRY2 = parcelRequire("kGRY2");


var $2kBNA = parcelRequire("2kBNA");

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $bLmKG('a function is required');
    return $2kBNA($7WErB, $kGRY2, args);
};

});

parcelRegister("aFqsr", function(module, exports) {
'use strict';

var $1TfOD = parcelRequire("1TfOD");

var $7c4241b0d65bd6db$require$$gOPD = $1TfOD;
if ($7c4241b0d65bd6db$require$$gOPD) try {
    $7c4241b0d65bd6db$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $7c4241b0d65bd6db$require$$gOPD = null;
}
module.exports = $7c4241b0d65bd6db$require$$gOPD;

});

parcelRegister("4fQJo", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("2kBNA", function(module, exports) {
'use strict';

var $7WErB = parcelRequire("7WErB");


var $4fQJo = parcelRequire("4fQJo");


var $kGRY2 = parcelRequire("kGRY2");


var $jX77m = parcelRequire("jX77m");

/** @type {import('./actualApply')} */ module.exports = $jX77m || $7WErB.call($kGRY2, $4fQJo);

});

parcelRegister("cy5uq", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $922ceb2c0725316c$var$$defineProperty = Object.defineProperty || false;
if ($922ceb2c0725316c$var$$defineProperty) try {
    $922ceb2c0725316c$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $922ceb2c0725316c$var$$defineProperty = false;
}
module.exports = $922ceb2c0725316c$var$$defineProperty;

});

parcelRegister("f0OSc", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("gLTb0", function(module, exports) {
module.exports = $c35bd6074923167f$var$assert;
function $c35bd6074923167f$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$c35bd6074923167f$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});

parcelRegister("479P8", function(module, exports) {

var $iA9co = parcelRequire("iA9co");

var $2fef6faa931f72cf$require$Buffer = $iA9co.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $2fef6faa931f72cf$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});

parcelRegister("1VL9i", function(module, exports) {
function $167fb017e3bab95f$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $167fb017e3bab95f$var$incr32;

});

parcelRegister("6Y114", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $iA9co = parcelRequire("iA9co");

var $51292281d770f2ab$var$Buffer = $iA9co.Buffer;
// alternative to using Object.keys for old browsers
function $51292281d770f2ab$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($51292281d770f2ab$var$Buffer.from && $51292281d770f2ab$var$Buffer.alloc && $51292281d770f2ab$var$Buffer.allocUnsafe && $51292281d770f2ab$var$Buffer.allocUnsafeSlow) module.exports = $iA9co;
else {
    // Copy properties from require('buffer')
    $51292281d770f2ab$var$copyProps($iA9co, module.exports);
    module.exports.Buffer = $51292281d770f2ab$var$SafeBuffer;
}
function $51292281d770f2ab$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $51292281d770f2ab$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$51292281d770f2ab$var$copyProps($51292281d770f2ab$var$Buffer, $51292281d770f2ab$var$SafeBuffer);
$51292281d770f2ab$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $51292281d770f2ab$var$Buffer(arg, encodingOrOffset, length);
};
$51292281d770f2ab$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $51292281d770f2ab$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$51292281d770f2ab$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $51292281d770f2ab$var$Buffer(size);
};
$51292281d770f2ab$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $iA9co.SlowBuffer(size);
};

});

parcelRegister("gLkWG", function(module, exports) {
'use strict';
function $c341487b78d69183$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $6Y114 = parcelRequire("6Y114");

var $c341487b78d69183$require$Buffer = $6Y114.Buffer;

var $h1hUh = parcelRequire("h1hUh");

function $c341487b78d69183$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $c341487b78d69183$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $c341487b78d69183$require$Buffer.alloc(0);
        var ret = $c341487b78d69183$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $c341487b78d69183$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($h1hUh && $h1hUh.inspect && $h1hUh.inspect.custom) module.exports.prototype[$h1hUh.inspect.custom] = function() {
    var obj = $h1hUh.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("eigVC", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");

'use strict';
if (typeof $kyRHQ === 'undefined' || !$kyRHQ.version || $kyRHQ.version.indexOf('v0.') === 0 || $kyRHQ.version.indexOf('v1.') === 0 && $kyRHQ.version.indexOf('v1.8.') !== 0) module.exports = {
    nextTick: $a67fe0bda9cdb628$var$nextTick
};
else module.exports = $kyRHQ;
function $a67fe0bda9cdb628$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $kyRHQ.nextTick(fn);
        case 2:
            return $kyRHQ.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $kyRHQ.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $kyRHQ.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $kyRHQ.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("jHaCq", function(module, exports) {

module.exports = (parcelRequire("5rDjV")).EventEmitter;

});

parcelRegister("epYxt", function(module, exports) {
'use strict';

var $eigVC = parcelRequire("eigVC");

/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $a7f25c3a30c1caf6$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $eigVC.nextTick($a7f25c3a30c1caf6$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $eigVC.nextTick($a7f25c3a30c1caf6$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $eigVC.nextTick($a7f25c3a30c1caf6$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $eigVC.nextTick($a7f25c3a30c1caf6$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $a7f25c3a30c1caf6$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $a7f25c3a30c1caf6$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $a7f25c3a30c1caf6$var$destroy,
    undestroy: $a7f25c3a30c1caf6$var$undestroy
};

});

parcelRegister("eSDVW", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $iA9co = parcelRequire("iA9co");

var $ad5515d39a349a49$var$Buffer = $iA9co.Buffer;
// alternative to using Object.keys for old browsers
function $ad5515d39a349a49$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($ad5515d39a349a49$var$Buffer.from && $ad5515d39a349a49$var$Buffer.alloc && $ad5515d39a349a49$var$Buffer.allocUnsafe && $ad5515d39a349a49$var$Buffer.allocUnsafeSlow) module.exports = $iA9co;
else {
    // Copy properties from require('buffer')
    $ad5515d39a349a49$var$copyProps($iA9co, module.exports);
    module.exports.Buffer = $ad5515d39a349a49$var$SafeBuffer;
}
function $ad5515d39a349a49$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $ad5515d39a349a49$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$ad5515d39a349a49$var$copyProps($ad5515d39a349a49$var$Buffer, $ad5515d39a349a49$var$SafeBuffer);
$ad5515d39a349a49$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $ad5515d39a349a49$var$Buffer(arg, encodingOrOffset, length);
};
$ad5515d39a349a49$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $ad5515d39a349a49$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$ad5515d39a349a49$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $ad5515d39a349a49$var$Buffer(size);
};
$ad5515d39a349a49$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $iA9co.SlowBuffer(size);
};

});

parcelRegister("hjBPv", function(module, exports) {
'use strict';
var $c9b18e35be949447$var$utils = module.exports;
function $c9b18e35be949447$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$c9b18e35be949447$var$utils.toArray = $c9b18e35be949447$var$toArray;
function $c9b18e35be949447$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$c9b18e35be949447$var$utils.zero2 = $c9b18e35be949447$var$zero2;
function $c9b18e35be949447$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $c9b18e35be949447$var$zero2(msg[i].toString(16));
    return res;
}
$c9b18e35be949447$var$utils.toHex = $c9b18e35be949447$var$toHex;
$c9b18e35be949447$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $c9b18e35be949447$var$toHex(arr);
    else return arr;
};

});

parcelRegister("52esc", function(module, exports) {
var $3aa859dd9b6fd2d4$var$hash = module.exports;

$3aa859dd9b6fd2d4$var$hash.utils = (parcelRequire("29p5P"));

$3aa859dd9b6fd2d4$var$hash.common = (parcelRequire("cxiAS"));

$3aa859dd9b6fd2d4$var$hash.sha = (parcelRequire("8lXl4"));

$3aa859dd9b6fd2d4$var$hash.ripemd = (parcelRequire("keqck"));

$3aa859dd9b6fd2d4$var$hash.hmac = (parcelRequire("7SPJd"));
// Proxy hash functions to the main object
$3aa859dd9b6fd2d4$var$hash.sha1 = $3aa859dd9b6fd2d4$var$hash.sha.sha1;
$3aa859dd9b6fd2d4$var$hash.sha256 = $3aa859dd9b6fd2d4$var$hash.sha.sha256;
$3aa859dd9b6fd2d4$var$hash.sha224 = $3aa859dd9b6fd2d4$var$hash.sha.sha224;
$3aa859dd9b6fd2d4$var$hash.sha384 = $3aa859dd9b6fd2d4$var$hash.sha.sha384;
$3aa859dd9b6fd2d4$var$hash.sha512 = $3aa859dd9b6fd2d4$var$hash.sha.sha512;
$3aa859dd9b6fd2d4$var$hash.ripemd160 = $3aa859dd9b6fd2d4$var$hash.ripemd.ripemd160;

});

parcelRegister("48OKc", function(module, exports) {
$parcel$export(module.exports, "ft_1", () => $303f4580b971bb66$export$5a92649d7ddb9f63, (v) => $303f4580b971bb66$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $303f4580b971bb66$export$c6d0d020c3a6269, (v) => $303f4580b971bb66$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $303f4580b971bb66$export$eb90c27fca05f956, (v) => $303f4580b971bb66$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $303f4580b971bb66$export$14a4a98e063b1999, (v) => $303f4580b971bb66$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $303f4580b971bb66$export$d20cecfa1564c686, (v) => $303f4580b971bb66$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $303f4580b971bb66$export$44fd472a12fc6db, (v) => $303f4580b971bb66$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $303f4580b971bb66$export$1ed238bb6ea1dd47, (v) => $303f4580b971bb66$export$1ed238bb6ea1dd47 = v);
var $303f4580b971bb66$export$5a92649d7ddb9f63;
var $303f4580b971bb66$export$c6d0d020c3a6269;
var $303f4580b971bb66$export$eb90c27fca05f956;
var $303f4580b971bb66$export$cc992891a14496a1;
var $303f4580b971bb66$export$14a4a98e063b1999;
var $303f4580b971bb66$export$d20cecfa1564c686;
var $303f4580b971bb66$export$44fd472a12fc6db;
var $303f4580b971bb66$export$1ed238bb6ea1dd47;
'use strict';

var $29p5P = parcelRequire("29p5P");

var $303f4580b971bb66$var$rotr32 = $29p5P.rotr32;
function $303f4580b971bb66$var$ft_1(s, x, y, z) {
    if (s === 0) return $303f4580b971bb66$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $303f4580b971bb66$var$p32(x, y, z);
    if (s === 2) return $303f4580b971bb66$var$maj32(x, y, z);
}
$303f4580b971bb66$export$5a92649d7ddb9f63 = $303f4580b971bb66$var$ft_1;
function $303f4580b971bb66$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$303f4580b971bb66$export$c6d0d020c3a6269 = $303f4580b971bb66$var$ch32;
function $303f4580b971bb66$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$303f4580b971bb66$export$eb90c27fca05f956 = $303f4580b971bb66$var$maj32;
function $303f4580b971bb66$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$303f4580b971bb66$export$cc992891a14496a1 = $303f4580b971bb66$var$p32;
function $303f4580b971bb66$var$s0_256(x) {
    return $303f4580b971bb66$var$rotr32(x, 2) ^ $303f4580b971bb66$var$rotr32(x, 13) ^ $303f4580b971bb66$var$rotr32(x, 22);
}
$303f4580b971bb66$export$14a4a98e063b1999 = $303f4580b971bb66$var$s0_256;
function $303f4580b971bb66$var$s1_256(x) {
    return $303f4580b971bb66$var$rotr32(x, 6) ^ $303f4580b971bb66$var$rotr32(x, 11) ^ $303f4580b971bb66$var$rotr32(x, 25);
}
$303f4580b971bb66$export$d20cecfa1564c686 = $303f4580b971bb66$var$s1_256;
function $303f4580b971bb66$var$g0_256(x) {
    return $303f4580b971bb66$var$rotr32(x, 7) ^ $303f4580b971bb66$var$rotr32(x, 18) ^ x >>> 3;
}
$303f4580b971bb66$export$44fd472a12fc6db = $303f4580b971bb66$var$g0_256;
function $303f4580b971bb66$var$g1_256(x) {
    return $303f4580b971bb66$var$rotr32(x, 17) ^ $303f4580b971bb66$var$rotr32(x, 19) ^ x >>> 10;
}
$303f4580b971bb66$export$1ed238bb6ea1dd47 = $303f4580b971bb66$var$g1_256;

});

parcelRegister("jpRkG", function(module, exports) {
'use strict';

var $5jY1L = parcelRequire("5jY1L");


var $4gySg = parcelRequire("4gySg");


var $coEl1 = parcelRequire("coEl1");


var $j9ccG = parcelRequire("j9ccG");


var $h8Kts = parcelRequire("h8Kts");


var $eI8vp = parcelRequire("eI8vp");

var $e229b8da9a47a160$require$Buffer = $eI8vp.Buffer;
function $e229b8da9a47a160$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $4gySg[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $h8Kts.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $j9ccG.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $e229b8da9a47a160$require$Buffer.concat(out);
}
function $e229b8da9a47a160$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$e229b8da9a47a160$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $e229b8da9a47a160$require$Buffer.from(buffer);
    var stripped = $coEl1(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $5jY1L.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $5jY1L.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $5jY1L.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $5jY1L.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $5jY1L.EncryptedPrivateKey.decode(data, 'der');
            data = $e229b8da9a47a160$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $5jY1L.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $5jY1L.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $5jY1L.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $5jY1L.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $5jY1L.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $5jY1L.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $5jY1L.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $5jY1L.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$e229b8da9a47a160$var$parseKeys.signature = $5jY1L.signature;
module.exports = $e229b8da9a47a160$var$parseKeys;

});

parcelRegister("1fiU8", function(module, exports) {
'use strict';

var $cGJih = parcelRequire("cGJih");


var $97jsf = parcelRequire("97jsf");


var $eI8vp = parcelRequire("eI8vp");

var $0e85db2c1ccb8d1c$require$Buffer = $eI8vp.Buffer;
function $0e85db2c1ccb8d1c$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $cGJih($97jsf(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $0e85db2c1ccb8d1c$var$blind(priv) {
    var r = $0e85db2c1ccb8d1c$var$getr(priv);
    var blinder = r.toRed($cGJih.mont(priv.modulus)).redPow(new $cGJih(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $0e85db2c1ccb8d1c$var$crt(msg, priv) {
    var blinds = $0e85db2c1ccb8d1c$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $cGJih(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($cGJih.mont(priv.prime1));
    var c2 = blinded.toRed($cGJih.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($0e85db2c1ccb8d1c$require$Buffer, 'be', len);
}
$0e85db2c1ccb8d1c$var$crt.getr = $0e85db2c1ccb8d1c$var$getr;
module.exports = $0e85db2c1ccb8d1c$var$crt;

});

parcelRegister("egef1", function(module, exports) {

var $abSTA = parcelRequire("abSTA");


var $eI8vp = parcelRequire("eI8vp");

var $a61d9b558e57d669$require$Buffer = $eI8vp.Buffer;
module.exports = function(seed, len) {
    var t = $a61d9b558e57d669$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $a61d9b558e57d669$var$i2ops(i++);
        t = $a61d9b558e57d669$require$Buffer.concat([
            t,
            $abSTA('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $a61d9b558e57d669$var$i2ops(c) {
    var out = $a61d9b558e57d669$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("k5wZL", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("kFyyv", function(module, exports) {

var $hpluo = parcelRequire("hpluo");


var $eI8vp = parcelRequire("eI8vp");

var $f0c271044abdf245$require$Buffer = $eI8vp.Buffer;
function $f0c271044abdf245$var$withPublic(paddedMsg, key) {
    return $f0c271044abdf245$require$Buffer.from(paddedMsg.toRed($hpluo.mont(key.modulus)).redPow(new $hpluo(key.publicExponent)).fromRed().toArray());
}
module.exports = $f0c271044abdf245$var$withPublic;

});

parcelRegister("kH7bh", function(module, exports) {
$parcel$export(module.exports, "default", () => $91b77edaac521dc8$export$2e2bcd8739ae039);
function $91b77edaac521dc8$export$2e2bcd8739ae039(gqlQueryNode) {
    const operationDef = gqlQueryNode?.definitions?.find((d)=>d.kind === 'OperationDefinition' && d.name);
    const operationName = (operationDef?.kind === 'OperationDefinition' ? operationDef?.name?.value : undefined) ?? 'unnamed';
    return operationName;
}

});

parcelRegister("fFVny", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2xIMp = parcelRequire("2xIMp");

const $0c159d1a51729e4b$export$d1f587f82ad51c4 = ()=>{
    return (0, $42omo.useContext)((0, $2xIMp.default));
};
module.exports["useAnalyticsContext"] = $0c159d1a51729e4b$export$d1f587f82ad51c4;

});

parcelRegister("bojLi", function(module, exports) {

var $3sW76 = parcelRequire("3sW76");


var $hXuPC = parcelRequire("hXuPC");


var $42omo = parcelRequire("42omo");


var $56GFp = parcelRequire("56GFp");






var $1KmJq = parcelRequire("1KmJq");

var $xQxzY = parcelRequire("xQxzY");

var $7hXu9 = parcelRequire("7hXu9");


var $4xcIM = parcelRequire("4xcIM");

function $aa9606c392a1a482$export$62297b13309008b2(props) {
    var children = props.children, query = props.query, options = (0, $hXuPC.__rest)(props, [
        "children",
        "query"
    ]);
    var result = (0, $xQxzY.useQuery)(query, options);
    return children && result ? children(result) : null;
}
(function(Query) {
    Query.propTypes = {
        client: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
        fetchPolicy: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        notifyOnNetworkStatusChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
        onCompleted: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
        pollInterval: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number,
        query: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
        variables: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
        ssr: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
        partialRefetch: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
        returnPartialData: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
    };
})($aa9606c392a1a482$export$62297b13309008b2 || ($aa9606c392a1a482$export$62297b13309008b2 = {}));
function $aa9606c392a1a482$export$17b8b19c814bcf56(props) {
    var _a = (0, $1KmJq.useMutation)(props.mutation, props), runMutation = _a[0], result = _a[1];
    return props.children ? props.children(runMutation, result) : null;
}
(function(Mutation) {
    Mutation.propTypes = {
        mutation: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
        variables: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
        optimisticResponse: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
        ]),
        refetchQueries: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
        ]),
        awaitRefetchQueries: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
        update: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
        onCompleted: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
        fetchPolicy: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
    };
})($aa9606c392a1a482$export$17b8b19c814bcf56 || ($aa9606c392a1a482$export$17b8b19c814bcf56 = {}));
function $aa9606c392a1a482$export$f55210826850c514(props) {
    var result = (0, $7hXu9.useSubscription)(props.subscription, props);
    return props.children && result ? props.children(result) : null;
}
(function(Subscription) {
    Subscription.propTypes = {
        subscription: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
        variables: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
        onSubscriptionData: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
        onSubscriptionComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
        shouldResubscribe: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
        ])
    };
})($aa9606c392a1a482$export$f55210826850c514 || ($aa9606c392a1a482$export$f55210826850c514 = {}));



var $7RTAm = parcelRequire("7RTAm");

var $84b143e166c9dd23$var$defaultMapPropsToOptions = function() {
    return {};
};
var $84b143e166c9dd23$var$defaultMapPropsToSkip = function() {
    return false;
};
function $84b143e166c9dd23$var$getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
function $84b143e166c9dd23$var$calculateVariablesFromProps(operation, props) {
    var variables = {};
    for(var _i = 0, _a = operation.variables; _i < _a.length; _i++){
        var _b = _a[_i], variable = _b.variable, type = _b.type;
        if (!variable.name || !variable.name.value) continue;
        var variableName = variable.name.value;
        var variableProp = props[variableName];
        if (typeof variableProp !== 'undefined') {
            variables[variableName] = variableProp;
            continue;
        }
        if (type.kind !== 'NonNullType') variables[variableName] = undefined;
    }
    return variables;
}
var $84b143e166c9dd23$var$GraphQLBase = function(_super) {
    (0, $hXuPC.__extends)(GraphQLBase, _super);
    function GraphQLBase(props) {
        var _this = _super.call(this, props) || this;
        _this.withRef = false;
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
        return _this;
    }
    GraphQLBase.prototype.getWrappedInstance = function() {
        (0, $7RTAm.invariant)(this.withRef, 2);
        return this.wrappedInstance;
    };
    GraphQLBase.prototype.setWrappedInstance = function(ref) {
        this.wrappedInstance = ref;
    };
    return GraphQLBase;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
function $84b143e166c9dd23$export$e0f4c6d2a1e99ce0(document, operationOptions) {
    if (operationOptions === void 0) operationOptions = {};
    var operation = (0, $3sW76.parser)(document);
    var _a = operationOptions.options, options = _a === void 0 ? $84b143e166c9dd23$var$defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? $84b143e166c9dd23$var$defaultMapPropsToSkip : _b, _c = operationOptions.alias, alias = _c === void 0 ? 'Apollo' : _c;
    var mapPropsToOptions = options;
    if (typeof mapPropsToOptions !== 'function') mapPropsToOptions = function() {
        return options;
    };
    var mapPropsToSkip = skip;
    if (typeof mapPropsToSkip !== 'function') mapPropsToSkip = function() {
        return skip;
    };
    var lastResultProps;
    return function(WrappedComponent) {
        var graphQLDisplayName = alias + "(" + $84b143e166c9dd23$var$getDisplayName(WrappedComponent) + ")";
        var GraphQL = function(_super) {
            (0, $hXuPC.__extends)(GraphQL, _super);
            function GraphQL() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            GraphQL.prototype.render = function() {
                var _this = this;
                var props = this.props;
                var shouldSkip = mapPropsToSkip(props);
                var opts = shouldSkip ? Object.create(null) : (0, $hXuPC.__assign)({}, mapPropsToOptions(props));
                if (!shouldSkip && !opts.variables && operation.variables.length > 0) opts.variables = $84b143e166c9dd23$var$calculateVariablesFromProps(operation, props);
                return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aa9606c392a1a482$export$62297b13309008b2), (0, $hXuPC.__assign)({}, opts, {
                    displayName: graphQLDisplayName,
                    skip: shouldSkip,
                    query: document
                }), function(_a) {
                    var _b, _c;
                    var _ = _a.client, data = _a.data, r = (0, $hXuPC.__rest)(_a, [
                        "client",
                        "data"
                    ]);
                    if (operationOptions.withRef) {
                        _this.withRef = true;
                        props = Object.assign({}, props, {
                            ref: _this.setWrappedInstance
                        });
                    }
                    if (shouldSkip) return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, (0, $hXuPC.__assign)({}, props, {}));
                    var result = Object.assign(r, data || {});
                    var name = operationOptions.name || 'data';
                    var childProps = (_b = {}, _b[name] = result, _b);
                    if (operationOptions.props) {
                        var newResult = (_c = {}, _c[name] = result, _c.ownProps = props, _c);
                        lastResultProps = operationOptions.props(newResult, lastResultProps);
                        childProps = lastResultProps;
                    }
                    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, (0, $hXuPC.__assign)({}, props, childProps));
                });
            };
            GraphQL.displayName = graphQLDisplayName;
            GraphQL.WrappedComponent = WrappedComponent;
            return GraphQL;
        }($84b143e166c9dd23$var$GraphQLBase);
        return (0, (/*@__PURE__*/$parcel$interopDefault($56GFp)))(GraphQL, WrappedComponent, {});
    };
}
function $84b143e166c9dd23$export$4cfe52eb1eaa1106(document, operationOptions) {
    if (operationOptions === void 0) operationOptions = {};
    var operation = (0, $3sW76.parser)(document);
    var _a = operationOptions.options, options = _a === void 0 ? $84b143e166c9dd23$var$defaultMapPropsToOptions : _a, _b = operationOptions.alias, alias = _b === void 0 ? 'Apollo' : _b;
    var mapPropsToOptions = options;
    if (typeof mapPropsToOptions !== 'function') mapPropsToOptions = function() {
        return options;
    };
    return function(WrappedComponent) {
        var graphQLDisplayName = alias + "(" + $84b143e166c9dd23$var$getDisplayName(WrappedComponent) + ")";
        var GraphQL = function(_super) {
            (0, $hXuPC.__extends)(GraphQL, _super);
            function GraphQL() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            GraphQL.prototype.render = function() {
                var props = this.props;
                var opts = mapPropsToOptions(props);
                if (operationOptions.withRef) {
                    this.withRef = true;
                    props = Object.assign({}, props, {
                        ref: this.setWrappedInstance
                    });
                }
                if (!opts.variables && operation.variables.length > 0) opts.variables = $84b143e166c9dd23$var$calculateVariablesFromProps(operation, props);
                return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aa9606c392a1a482$export$17b8b19c814bcf56), (0, $hXuPC.__assign)({
                    ignoreResults: true
                }, opts, {
                    mutation: document
                }), function(mutate, _a) {
                    var _b, _c;
                    var data = _a.data, r = (0, $hXuPC.__rest)(_a, [
                        "data"
                    ]);
                    var result = Object.assign(r, data || {});
                    var name = operationOptions.name || 'mutate';
                    var resultName = operationOptions.name ? name + "Result" : 'result';
                    var childProps = (_b = {}, _b[name] = mutate, _b[resultName] = result, _b);
                    if (operationOptions.props) {
                        var newResult = (_c = {}, _c[name] = mutate, _c[resultName] = result, _c.ownProps = props, _c);
                        childProps = operationOptions.props(newResult);
                    }
                    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, (0, $hXuPC.__assign)({}, props, childProps));
                });
            };
            GraphQL.displayName = graphQLDisplayName;
            GraphQL.WrappedComponent = WrappedComponent;
            return GraphQL;
        }($84b143e166c9dd23$var$GraphQLBase);
        return (0, (/*@__PURE__*/$parcel$interopDefault($56GFp)))(GraphQL, WrappedComponent, {});
    };
}
function $84b143e166c9dd23$export$847d9e19bf74eca4(document, operationOptions) {
    if (operationOptions === void 0) operationOptions = {};
    var operation = (0, $3sW76.parser)(document);
    var _a = operationOptions.options, options = _a === void 0 ? $84b143e166c9dd23$var$defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? $84b143e166c9dd23$var$defaultMapPropsToSkip : _b, _c = operationOptions.alias, alias = _c === void 0 ? 'Apollo' : _c, shouldResubscribe = operationOptions.shouldResubscribe;
    var mapPropsToOptions = options;
    if (typeof mapPropsToOptions !== 'function') mapPropsToOptions = function() {
        return options;
    };
    var mapPropsToSkip = skip;
    if (typeof mapPropsToSkip !== 'function') mapPropsToSkip = function() {
        return skip;
    };
    var lastResultProps;
    return function(WrappedComponent) {
        var graphQLDisplayName = alias + "(" + $84b143e166c9dd23$var$getDisplayName(WrappedComponent) + ")";
        var GraphQL = function(_super) {
            (0, $hXuPC.__extends)(GraphQL, _super);
            function GraphQL(props) {
                var _this = _super.call(this, props) || this;
                _this.state = {
                    resubscribe: false
                };
                return _this;
            }
            GraphQL.prototype.componentDidUpate = function(prevProps) {
                if (shouldResubscribe) this.setState({
                    resubscribe: shouldResubscribe(prevProps, this.props)
                });
            };
            GraphQL.prototype.render = function() {
                var _this = this;
                var props = this.props;
                var shouldSkip = mapPropsToSkip(props);
                var opts = shouldSkip ? Object.create(null) : mapPropsToOptions(props);
                if (!shouldSkip && !opts.variables && operation.variables.length > 0) opts.variables = $84b143e166c9dd23$var$calculateVariablesFromProps(operation, props);
                return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aa9606c392a1a482$export$f55210826850c514), (0, $hXuPC.__assign)({}, opts, {
                    displayName: graphQLDisplayName,
                    skip: shouldSkip,
                    subscription: document,
                    shouldResubscribe: this.state.resubscribe
                }), function(_a) {
                    var _b, _c;
                    var data = _a.data, r = (0, $hXuPC.__rest)(_a, [
                        "data"
                    ]);
                    if (operationOptions.withRef) {
                        _this.withRef = true;
                        props = Object.assign({}, props, {
                            ref: _this.setWrappedInstance
                        });
                    }
                    if (shouldSkip) return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, (0, $hXuPC.__assign)({}, props, {}));
                    var result = Object.assign(r, data || {});
                    var name = operationOptions.name || 'data';
                    var childProps = (_b = {}, _b[name] = result, _b);
                    if (operationOptions.props) {
                        var newResult = (_c = {}, _c[name] = result, _c.ownProps = props, _c);
                        lastResultProps = operationOptions.props(newResult, lastResultProps);
                        childProps = lastResultProps;
                    }
                    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, (0, $hXuPC.__assign)({}, props, childProps));
                });
            };
            GraphQL.displayName = graphQLDisplayName;
            GraphQL.WrappedComponent = WrappedComponent;
            return GraphQL;
        }($84b143e166c9dd23$var$GraphQLBase);
        return (0, (/*@__PURE__*/$parcel$interopDefault($56GFp)))(GraphQL, WrappedComponent, {});
    };
}
function $84b143e166c9dd23$export$1eb4e7c0ed67b035(document, operationOptions) {
    if (operationOptions === void 0) operationOptions = {};
    switch((0, $3sW76.parser)(document).type){
        case (0, $3sW76.DocumentType).Mutation:
            return $84b143e166c9dd23$export$4cfe52eb1eaa1106(document, operationOptions);
        case (0, $3sW76.DocumentType).Subscription:
            return $84b143e166c9dd23$export$847d9e19bf74eca4(document, operationOptions);
        case (0, $3sW76.DocumentType).Query:
        default:
            return $84b143e166c9dd23$export$e0f4c6d2a1e99ce0(document, operationOptions);
    }
}
function $84b143e166c9dd23$var$getDisplayName$1(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
function $84b143e166c9dd23$export$e9da82a5f45de44a(WrappedComponent, operationOptions) {
    if (operationOptions === void 0) operationOptions = {};
    var withDisplayName = "withApollo(" + $84b143e166c9dd23$var$getDisplayName$1(WrappedComponent) + ")";
    var WithApollo = function(_super) {
        (0, $hXuPC.__extends)(WithApollo, _super);
        function WithApollo(props) {
            var _this = _super.call(this, props) || this;
            _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
            return _this;
        }
        WithApollo.prototype.getWrappedInstance = function() {
            (0, $7RTAm.invariant)(operationOptions.withRef, 1);
            return this.wrappedInstance;
        };
        WithApollo.prototype.setWrappedInstance = function(ref) {
            this.wrappedInstance = ref;
        };
        WithApollo.prototype.render = function() {
            var _this = this;
            return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3sW76.ApolloConsumer), null, function(client) {
                var props = Object.assign({}, _this.props, {
                    client: client,
                    ref: operationOptions.withRef ? _this.setWrappedInstance : undefined
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, (0, $hXuPC.__assign)({}, props));
            });
        };
        WithApollo.displayName = withDisplayName;
        WithApollo.WrappedComponent = WrappedComponent;
        return WithApollo;
    }((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($56GFp)))(WithApollo, WrappedComponent, {});
}
module.exports["withApollo"] = $84b143e166c9dd23$export$e9da82a5f45de44a;

});

parcelRegister("dseO2", function(module, exports) {

var $5PD23 = parcelRequire("5PD23");


var $dWWac = parcelRequire("dWWac");


var $abBQX = parcelRequire("abBQX");


var $kXrr0 = parcelRequire("kXrr0");

function $5de5987c03fb6460$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $3408e91843c089f1$export$2e2bcd8739ae039(node) {
    if (node === (0, $abBQX.default)(node) || !(0, $kXrr0.isHTMLElement)(node)) return (0, $dWWac.default)(node);
    else return (0, $5de5987c03fb6460$export$2e2bcd8739ae039)(node);
}



var $2X8fC = parcelRequire("2X8fC");





var $bd6jv = parcelRequire("bd6jv");


var $cBZBQ = parcelRequire("cBZBQ");


var $l3Xsd = parcelRequire("l3Xsd");


var $fEu2C = parcelRequire("fEu2C");

function $e873958c031dbf9d$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $fEu2C.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $fEu2C.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $e873958c031dbf9d$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $kXrr0.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $kXrr0.isHTMLElement)(offsetParent) && $e873958c031dbf9d$var$isElementScaled(offsetParent);
    var documentElement = (0, $cBZBQ.default)(offsetParent);
    var rect = (0, $5PD23.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $2X8fC.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $l3Xsd.default)(documentElement)) scroll = (0, $3408e91843c089f1$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $kXrr0.isHTMLElement)(offsetParent)) {
            offsets = (0, $5PD23.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $bd6jv.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



var $j7Ucr = parcelRequire("j7Ucr");


var $j6Wo8 = parcelRequire("j6Wo8");


var $d90wo = parcelRequire("d90wo");


var $eX4ca = parcelRequire("eX4ca");

function $4ab70eb674db698b$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $4ab70eb674db698b$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $4ab70eb674db698b$var$order(modifiers); // order based on phase
    return (0, $eX4ca.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $945841fbfe6acc63$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $87d604c23968d4e2$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}






var $9cb960132038225e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $9cb960132038225e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $9cb960132038225e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9cb960132038225e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $9cb960132038225e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $kXrr0.isElement)(reference) ? (0, $j6Wo8.default)(reference) : reference.contextElement ? (0, $j6Wo8.default)(reference.contextElement) : [],
                    popper: (0, $j6Wo8.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $4ab70eb674db698b$export$2e2bcd8739ae039)((0, $87d604c23968d4e2$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$9cb960132038225e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $e873958c031dbf9d$export$2e2bcd8739ae039)(reference, (0, $d90wo.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $j7Ucr.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $945841fbfe6acc63$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$9cb960132038225e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $9cb960132038225e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $9cb960132038225e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules
module.exports["popperGenerator"] = $9cb960132038225e$export$ed5e13716264f202;

});

parcelRegister("eX4ca", function(module, exports) {
var $ae29d47a0d039bf0$export$1e95b668f3b82d = 'top';
var $ae29d47a0d039bf0$export$40e543e69a8b3fbb = 'bottom';
var $ae29d47a0d039bf0$export$79ffe56a765070d2 = 'right';
var $ae29d47a0d039bf0$export$eabcd2c8791e7bf4 = 'left';
var $ae29d47a0d039bf0$export$dfb5619354ba860 = 'auto';
var $ae29d47a0d039bf0$export$aec2ce47c367b8c3 = [
    $ae29d47a0d039bf0$export$1e95b668f3b82d,
    $ae29d47a0d039bf0$export$40e543e69a8b3fbb,
    $ae29d47a0d039bf0$export$79ffe56a765070d2,
    $ae29d47a0d039bf0$export$eabcd2c8791e7bf4
];
var $ae29d47a0d039bf0$export$b3571188c770cc5a = 'start';
var $ae29d47a0d039bf0$export$bd5df0f255a350f8 = 'end';
var $ae29d47a0d039bf0$export$390fd549c5303b4d = 'clippingParents';
var $ae29d47a0d039bf0$export$d7b7311ec04a3e8f = 'viewport';
var $ae29d47a0d039bf0$export$ae5ab1c730825774 = 'popper';
var $ae29d47a0d039bf0$export$ca50aac9f3ba507f = 'reference';
var $ae29d47a0d039bf0$export$368f9a87e87fa4e1 = /*#__PURE__*/ $ae29d47a0d039bf0$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $ae29d47a0d039bf0$export$b3571188c770cc5a,
        placement + "-" + $ae29d47a0d039bf0$export$bd5df0f255a350f8
    ]);
}, []);
var $ae29d47a0d039bf0$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($ae29d47a0d039bf0$export$aec2ce47c367b8c3, [
    $ae29d47a0d039bf0$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $ae29d47a0d039bf0$export$b3571188c770cc5a,
        placement + "-" + $ae29d47a0d039bf0$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $ae29d47a0d039bf0$export$421679a7c3d56e = 'beforeRead';
var $ae29d47a0d039bf0$export$aafa59e2e03f2942 = 'read';
var $ae29d47a0d039bf0$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $ae29d47a0d039bf0$export$c65e99957a05207c = 'beforeMain';
var $ae29d47a0d039bf0$export$f22da7240b7add18 = 'main';
var $ae29d47a0d039bf0$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $ae29d47a0d039bf0$export$8d4d2d70e7d46032 = 'beforeWrite';
var $ae29d47a0d039bf0$export$68d8715fc104d294 = 'write';
var $ae29d47a0d039bf0$export$70a6e5159acce2e6 = 'afterWrite';
var $ae29d47a0d039bf0$export$d087d3878fdf71d5 = [
    $ae29d47a0d039bf0$export$421679a7c3d56e,
    $ae29d47a0d039bf0$export$aafa59e2e03f2942,
    $ae29d47a0d039bf0$export$6964f6c886723980,
    $ae29d47a0d039bf0$export$c65e99957a05207c,
    $ae29d47a0d039bf0$export$f22da7240b7add18,
    $ae29d47a0d039bf0$export$bab79516f2d662fe,
    $ae29d47a0d039bf0$export$8d4d2d70e7d46032,
    $ae29d47a0d039bf0$export$68d8715fc104d294,
    $ae29d47a0d039bf0$export$70a6e5159acce2e6
];
module.exports["top"] = $ae29d47a0d039bf0$export$1e95b668f3b82d;
module.exports["bottom"] = $ae29d47a0d039bf0$export$40e543e69a8b3fbb;
module.exports["right"] = $ae29d47a0d039bf0$export$79ffe56a765070d2;
module.exports["left"] = $ae29d47a0d039bf0$export$eabcd2c8791e7bf4;
module.exports["auto"] = $ae29d47a0d039bf0$export$dfb5619354ba860;
module.exports["basePlacements"] = $ae29d47a0d039bf0$export$aec2ce47c367b8c3;
module.exports["start"] = $ae29d47a0d039bf0$export$b3571188c770cc5a;
module.exports["end"] = $ae29d47a0d039bf0$export$bd5df0f255a350f8;
module.exports["clippingParents"] = $ae29d47a0d039bf0$export$390fd549c5303b4d;
module.exports["viewport"] = $ae29d47a0d039bf0$export$d7b7311ec04a3e8f;
module.exports["popper"] = $ae29d47a0d039bf0$export$ae5ab1c730825774;
module.exports["reference"] = $ae29d47a0d039bf0$export$ca50aac9f3ba507f;
module.exports["variationPlacements"] = $ae29d47a0d039bf0$export$368f9a87e87fa4e1;
module.exports["placements"] = $ae29d47a0d039bf0$export$803cd8101b6c182b;
module.exports["modifierPhases"] = $ae29d47a0d039bf0$export$d087d3878fdf71d5;

});

parcelRegister("jietZ", function(module, exports) {
/*
IE11 support
 */ var $e0baeeb718ac4ab3$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $e0baeeb718ac4ab3$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $e0baeeb718ac4ab3$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};
module.exports["toArray"] = $e0baeeb718ac4ab3$export$45b10814cc054894;
module.exports["asArray"] = $e0baeeb718ac4ab3$export$75093a47a9fa838d;
module.exports["getFirst"] = $e0baeeb718ac4ab3$export$bcd7afcd904dce14;

});

parcelRegister("cdwZR", function(module, exports) {

var $8m5WU = parcelRequire("8m5WU");

var $8e504b640b9a6d1a$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $8e504b640b9a6d1a$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $8e504b640b9a6d1a$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $8e504b640b9a6d1a$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $8e504b640b9a6d1a$var$isVisibleUncached = function(node, checkParent) {
    return !node || $8e504b640b9a6d1a$var$isTopNode(node) || !$8e504b640b9a6d1a$var$isElementHidden(node) && !$8e504b640b9a6d1a$var$isInert(node) && checkParent($8e504b640b9a6d1a$var$getParentNode(node));
};
var $8e504b640b9a6d1a$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $8e504b640b9a6d1a$var$isVisibleUncached(node, $8e504b640b9a6d1a$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $8e504b640b9a6d1a$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$8e504b640b9a6d1a$var$isTopNode(node) ? $8e504b640b9a6d1a$export$b8550e27de209d85(node) ? checkParent($8e504b640b9a6d1a$var$getParentNode(node)) : false : true;
};
var $8e504b640b9a6d1a$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $8e504b640b9a6d1a$var$isAutoFocusAllowedUncached(node, $8e504b640b9a6d1a$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $8e504b640b9a6d1a$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $8e504b640b9a6d1a$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $8e504b640b9a6d1a$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $8e504b640b9a6d1a$export$9d74f6fbc6f469d0 = function(node) {
    return $8e504b640b9a6d1a$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $8e504b640b9a6d1a$export$8197b0ea56b3b055 = function(node) {
    return !(($8e504b640b9a6d1a$export$88a6ceeed5737ba3(node) || $8e504b640b9a6d1a$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $8e504b640b9a6d1a$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $8m5WU.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $8e504b640b9a6d1a$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $8e504b640b9a6d1a$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $8e504b640b9a6d1a$export$602e5a0d338d7750 = function(node) {
    return !$8e504b640b9a6d1a$export$d94b8b58ec2f30eb(node);
};
var $8e504b640b9a6d1a$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};
module.exports["isVisibleCached"] = $8e504b640b9a6d1a$export$3c9dc299685ad160;
module.exports["isAutoFocusAllowedCached"] = $8e504b640b9a6d1a$export$bcaa50628f6a736e;
module.exports["getDataset"] = $8e504b640b9a6d1a$export$698b339b0c8edae3;
module.exports["isRadioElement"] = $8e504b640b9a6d1a$export$9d74f6fbc6f469d0;
module.exports["notHiddenInput"] = $8e504b640b9a6d1a$export$8197b0ea56b3b055;
module.exports["isGuard"] = $8e504b640b9a6d1a$export$d94b8b58ec2f30eb;
module.exports["isNotAGuard"] = $8e504b640b9a6d1a$export$602e5a0d338d7750;
module.exports["isDefined"] = $8e504b640b9a6d1a$export$4e62c701997796c1;

});

parcelRegister("8k0Cv", function(module, exports) {

var $jietZ = parcelRequire("jietZ");

var $60f0ac23e9deb58f$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $60f0ac23e9deb58f$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $60f0ac23e9deb58f$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $jietZ.toArray)(nodes).map(function(node, index) {
        var tabIndex = $60f0ac23e9deb58f$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($60f0ac23e9deb58f$export$350ee6c095d98996);
};
module.exports["orderByTabIndex"] = $60f0ac23e9deb58f$export$cb40ee071f0d5226;

});

parcelRegister("71ClY", function(module, exports) {

var $8m5WU = parcelRequire("8m5WU");


var $jietZ = parcelRequire("jietZ");


var $i6029 = parcelRequire("i6029");

var $51d66093a1d9dc0d$var$queryTabbables = (0, $i6029.tabbables).join(',');
var $51d66093a1d9dc0d$var$queryGuardTabbables = "".concat($51d66093a1d9dc0d$var$queryTabbables, ", [data-focus-guard]");
var $51d66093a1d9dc0d$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $jietZ.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $51d66093a1d9dc0d$var$queryGuardTabbables : $51d66093a1d9dc0d$var$queryTabbables) ? [
            child
        ] : [], $51d66093a1d9dc0d$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $51d66093a1d9dc0d$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $51d66093a1d9dc0d$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $51d66093a1d9dc0d$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $51d66093a1d9dc0d$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $51d66093a1d9dc0d$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $jietZ.toArray)(parent.parentNode.querySelectorAll($51d66093a1d9dc0d$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $51d66093a1d9dc0d$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $8m5WU.FOCUS_AUTO), "]"));
    return (0, $jietZ.toArray)(parentFocus).map(function(node) {
        return $51d66093a1d9dc0d$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};
module.exports["getFocusables"] = $51d66093a1d9dc0d$export$f6768025e418420e;
module.exports["getParentAutofocusables"] = $51d66093a1d9dc0d$export$853fa94d922e78b9;

});

parcelRegister("9mFgj", function(module, exports) {

var $8m5WU = parcelRequire("8m5WU");


var $jietZ = parcelRequire("jietZ");

/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $6d162cea6cb86cc8$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $6d162cea6cb86cc8$var$getTopParent = function(node) {
    return node.parentNode ? $6d162cea6cb86cc8$var$getTopParent(node.parentNode) : node;
};
var $6d162cea6cb86cc8$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $jietZ.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $8m5WU.FOCUS_GROUP));
        acc.push.apply(acc, group ? $6d162cea6cb86cc8$var$filterNested((0, $jietZ.toArray)($6d162cea6cb86cc8$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $8m5WU.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $8m5WU.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};
module.exports["getAllAffectedNodes"] = $6d162cea6cb86cc8$export$7e87c4720b9b279b;

});

parcelRegister("8AJ6G", function(module, exports) {
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $gDscz = parcelRequire("gDscz");

var $6414acc8ce42cdfc$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $6414acc8ce42cdfc$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $gDscz.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $6414acc8ce42cdfc$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};
module.exports["getActiveElement"] = $6414acc8ce42cdfc$export$cd4e5573fbe2b576;

});

parcelRegister("bIaib", function(module, exports) {

var $9OOUs = parcelRequire("9OOUs");


var $jietZ = parcelRequire("jietZ");

var $886bc9983e62499a$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $886bc9983e62499a$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $886bc9983e62499a$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $886bc9983e62499a$var$getParents(nodeA);
    var parentsB = $886bc9983e62499a$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $886bc9983e62499a$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $jietZ.asArray)(baseActiveElement);
    var leftEntries = (0, $jietZ.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $886bc9983e62499a$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $886bc9983e62499a$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $9OOUs.contains)(common, topCommon)) topCommon = common;
                else topCommon = $886bc9983e62499a$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $886bc9983e62499a$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $9OOUs.parentAutofocusables)(node, visibilityCache));
    }, []);
};
module.exports["getTopCommonParent"] = $886bc9983e62499a$export$a9a7252b5f2e280e;
module.exports["allParentAutofocusables"] = $886bc9983e62499a$export$8f99714c70a37db1;

});

parcelRegister("kcGU6", function(module, exports) {

var $2s4CC = parcelRequire("2s4CC");


var $5Yw9H = parcelRequire("5Yw9H");

var $eb56357036b3b292$var$guardCount = 0;
var $eb56357036b3b292$var$lockDisabled = false;
var $eb56357036b3b292$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $5Yw9H.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($eb56357036b3b292$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($eb56357036b3b292$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $eb56357036b3b292$var$lockDisabled = true;
            setTimeout(function() {
                $eb56357036b3b292$var$lockDisabled = false;
            }, 1);
            return;
        }
        $eb56357036b3b292$var$guardCount++;
        (0, $2s4CC.focusOn)(focusable.node, options.focusOptions);
        $eb56357036b3b292$var$guardCount--;
    }
};
module.exports["moveFocusInside"] = $eb56357036b3b292$export$cd599851e879a025;

});

parcelRegister("cT1Md", function(module, exports) {

var $lzPoe = parcelRequire("lzPoe");

const $46f3b05eb9c58251$export$80450e0a84a5ede9 = 'fabricElementsCtx';
const $46f3b05eb9c58251$export$3fe25500478a635c = (0, $lzPoe.default)($46f3b05eb9c58251$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');
module.exports["ELEMENTS_CONTEXT"] = $46f3b05eb9c58251$export$80450e0a84a5ede9;
module.exports["FabricElementsAnalyticsContext"] = $46f3b05eb9c58251$export$3fe25500478a635c;

});

parcelRegister("1oYFx", function(module, exports) {

var $lzPoe = parcelRequire("lzPoe");

const $ff8209db9a792c53$export$1fd3aad76a7c6788 = 'navigationCtx';
const $ff8209db9a792c53$export$d0a82da1a0b94929 = (0, $lzPoe.default)($ff8209db9a792c53$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');
module.exports["NAVIGATION_CONTEXT"] = $ff8209db9a792c53$export$1fd3aad76a7c6788;
module.exports["NavigationAnalyticsContext"] = $ff8209db9a792c53$export$d0a82da1a0b94929;

});

parcelRegister("gqplE", function(module, exports) {

var $lzPoe = parcelRequire("lzPoe");

const $9edf731f97a24332$export$b326383bee6cb993 = 'peopleTeamsCtx';
const $9edf731f97a24332$export$4119ddb38ccbfb87 = (0, $lzPoe.default)($9edf731f97a24332$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');
module.exports["PEOPLE_TEAMS_CONTEXT"] = $9edf731f97a24332$export$b326383bee6cb993;
module.exports["PeopleTeamsAnalyticsContext"] = $9edf731f97a24332$export$4119ddb38ccbfb87;

});

parcelRegister("ePh4F", function(module, exports) {

var $lzPoe = parcelRequire("lzPoe");

const $9d8ba06d8384c89b$export$da1befb791e93c7e = 'NotificationsCtx';
const $9d8ba06d8384c89b$export$6f8e7ff1e3feafd7 = (0, $lzPoe.default)($9d8ba06d8384c89b$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');
module.exports["NOTIFICATIONS_CONTEXT"] = $9d8ba06d8384c89b$export$da1befb791e93c7e;
module.exports["NotificationsAnalyticsContext"] = $9d8ba06d8384c89b$export$6f8e7ff1e3feafd7;

});

parcelRegister("8hvil", function(module, exports) {

var $lzPoe = parcelRequire("lzPoe");

const $060232cf4e4d539d$export$fc7a65795610cb71 = 'RecentWorkCtx';
const $060232cf4e4d539d$export$745926731087ebe2 = (0, $lzPoe.default)($060232cf4e4d539d$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');
module.exports["RECENT_WORK_CONTEXT"] = $060232cf4e4d539d$export$fc7a65795610cb71;
module.exports["RecentWorkAnalyticsContext"] = $060232cf4e4d539d$export$745926731087ebe2;

});

parcelRegister("dWoPW", function(module, exports) {

var $lzPoe = parcelRequire("lzPoe");

const $46a73b440d6113f3$export$4906017439f33fc0 = 'atlasCtx';
const $46a73b440d6113f3$export$43ebbe41370d4543 = (0, $lzPoe.default)($46a73b440d6113f3$export$4906017439f33fc0, 'AtlasAnalyticsContext');
module.exports["ATLAS_CONTEXT"] = $46a73b440d6113f3$export$4906017439f33fc0;

});

parcelRegister("2mJpK", function(module, exports) {

var $lzPoe = parcelRequire("lzPoe");

const $beb36ec22a042708$export$aa18ab4fff926c9e = 'townsquareHomeCtx';
const $beb36ec22a042708$export$d283110f5d85c8f2 = (0, $lzPoe.default)($beb36ec22a042708$export$aa18ab4fff926c9e, 'TownsquareHomeAnalyticsContext');
module.exports["TOWNSQUARE_HOME_CONTEXT"] = $beb36ec22a042708$export$aa18ab4fff926c9e;

});

parcelRegister("kwKGS", function(module, exports) {

var $lzPoe = parcelRequire("lzPoe");

const $65864e4d26a7c98c$export$3240443bf2b83834 = 'linkingPlatformCtx';
const $65864e4d26a7c98c$export$6d568da622ce0a08 = (0, $lzPoe.default)($65864e4d26a7c98c$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');
module.exports["LINKING_PLATFORM_CONTEXT"] = $65864e4d26a7c98c$export$3240443bf2b83834;

});

parcelRegister("26stD", function(module, exports) {

var $lzPoe = parcelRequire("lzPoe");

const $1c7021ddb425333f$export$ef0c05448f0f8f9 = 'postOfficeCtx';
const $1c7021ddb425333f$export$dcd232f3be312f94 = (0, $lzPoe.default)($1c7021ddb425333f$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');
module.exports["POST_OFFICE_CONTEXT"] = $1c7021ddb425333f$export$ef0c05448f0f8f9;
module.exports["PostOfficeAnalyticsContext"] = $1c7021ddb425333f$export$dcd232f3be312f94;

});

parcelRegister("2jQZn", function(module, exports) {

var $lzPoe = parcelRequire("lzPoe");

const $c5296d06c7e65da9$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
const $c5296d06c7e65da9$export$de3826c30468da26 = (0, $lzPoe.default)($c5296d06c7e65da9$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');
module.exports["AI_MATE_CONTEXT"] = $c5296d06c7e65da9$export$5c3a6fd8b96e8b66;
module.exports["AIMateAnalyticsContext"] = $c5296d06c7e65da9$export$de3826c30468da26;

});

parcelRegister("aVIsj", function(module, exports) {

var $lzPoe = parcelRequire("lzPoe");

const $7f234d72bc6ab634$export$c2a811a4e42f4af5 = 'avpCtx';
const $7f234d72bc6ab634$export$da383e8879a25b03 = (0, $lzPoe.default)($7f234d72bc6ab634$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');
module.exports["AVP_CONTEXT"] = $7f234d72bc6ab634$export$c2a811a4e42f4af5;

});

parcelRegister("hcByP", function(module, exports) {

var $lzPoe = parcelRequire("lzPoe");

const $13998c7aae48d2e2$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
const $13998c7aae48d2e2$export$84980182680018f = (0, $lzPoe.default)($13998c7aae48d2e2$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');
module.exports["GROWTH_CONTEXT"] = $13998c7aae48d2e2$export$82023f2f4bfb06c1;

});

parcelRegister("aldCG", function(module, exports) {

var $lzPoe = parcelRequire("lzPoe");

const $3815a7aaae441aa1$export$6d3c48fd1b3e4f3b = 'omniChannelCtx';
const $3815a7aaae441aa1$export$e4e6df99270bbbb1 = (0, $lzPoe.default)($3815a7aaae441aa1$export$6d3c48fd1b3e4f3b, 'OmniChannelAnalyticsContext');
module.exports["OMNI_CHANNEL_CONTEXT"] = $3815a7aaae441aa1$export$6d3c48fd1b3e4f3b;

});

parcelRegister("lJwkv", function(module, exports) {

var $lzPoe = parcelRequire("lzPoe");

const $ab4b80437ced0ec4$export$fae437eb1dd9520c = 'rovoExtensionCtx';
const $ab4b80437ced0ec4$export$7fcecc25ee38fbef = (0, $lzPoe.default)($ab4b80437ced0ec4$export$fae437eb1dd9520c, 'RovoExtensionAnalyticsContext');
module.exports["ROVO_EXTENSION_CONTEXT"] = $ab4b80437ced0ec4$export$fae437eb1dd9520c;

});

parcelRegister("dhTbP", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $9ac7ac6e8527b1c8$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $9ac7ac6e8527b1c8$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $9ac7ac6e8527b1c8$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $9ac7ac6e8527b1c8$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $9ac7ac6e8527b1c8$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $9ac7ac6e8527b1c8$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $42omo.useLayoutEffect : $42omo.useEffect;
module.exports["unwrapArray"] = $9ac7ac6e8527b1c8$export$f52c55943429c8b6;
module.exports["safeInvoke"] = $9ac7ac6e8527b1c8$export$3dfa7c28635fe028;
module.exports["setRef"] = $9ac7ac6e8527b1c8$export$4bb192c7cacf928f;
module.exports["fromEntries"] = $9ac7ac6e8527b1c8$export$5150077fc2e7c662;
module.exports["useIsomorphicLayoutEffect"] = $9ac7ac6e8527b1c8$export$700979bc83e7db82;

});

parcelRegister("2mqmH", function(module, exports) {
/* popup.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $iug2J = parcelRequire("iug2J");


var $if5rb = parcelRequire("if5rb");


var $dh538 = parcelRequire("dh538");


var $2xusd = parcelRequire("2xusd");

var $cs0ez = parcelRequire("cs0ez");


var $caX7N = parcelRequire("caX7N");


var $gdv5Z = parcelRequire("gdv5Z");


var $2cdko = parcelRequire("2cdko");


var $fiAWX = parcelRequire("fiAWX");


var $9Ghf3 = parcelRequire("9Ghf3");


var $advfQ = parcelRequire("advfQ");

const $6072e21ac854e34a$var$defaultLayer = 400;
const $6072e21ac854e34a$var$wrapperStyles = {
    root: "_kqswh2mm"
};
const $6072e21ac854e34a$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $42omo.memo)(({ xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, zIndex: zIndex = $6072e21ac854e34a$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport })=>{
    const [triggerRef, setTriggerRef] = (0, $42omo.useState)(null);
    const getMergedTriggerRef = (0, $9Ghf3.useGetMemoizedMergedTriggerRef)();
    const getMergedTriggerRefNew = (0, $advfQ.useGetMemoizedMergedTriggerRefNew)();
    const generatedId = (0, $c0qxy.useId)();
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $fiAWX.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const id = providedId || generatedId;
    const handleOpenLayerObserverCloseSignal = (0, $42omo.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $if5rb.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    const renderPopperWrapper = /*#__PURE__*/ (0, $l998X.jsx)((0, $iug2J.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2cdko.default), {
            xcss: xcss,
            appearance: appearance,
            content: content,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: PopupContainer,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
            shouldFitContainer: shouldFitContainer,
            shouldDisableFocusLock: shouldDisableFocusLock,
            shouldReturnFocus: shouldReturnFocus,
            triggerRef: triggerRef,
            strategy: shouldFitContainer ? 'absolute' : strategy,
            role: role,
            label: label,
            titleId: titleId,
            modifiers: modifiers,
            shouldFitViewport: shouldFitViewport
        })
    });
    const popupContent = /*#__PURE__*/ (0, $l998X.jsxs)((0, $2xusd.Manager), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cs0ez.Reference), {
                children: ({ ref: ref })=>{
                    return trigger({
                        ref: !(0, $dh538.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
                        'aria-controls': isOpen ? id : undefined,
                        'aria-expanded': isOpen,
                        'aria-haspopup': role === 'dialog' && (0, $dh538.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
                    });
                }
            }),
            isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
                zIndex: zIndex,
                children: renderPopperWrapper
            }))
        ]
    });
    if (shouldFitContainer) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $6072e21ac854e34a$var$wrapperStyles.root,
        children: popupContent
    });
    return popupContent;
});
module.exports["Popup"] = $6072e21ac854e34a$export$129a32eedafa97c5;

});

parcelRegister("7T0iB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5bdde6d264fda0a0$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $5bdde6d264fda0a0$var$_react2 = $5bdde6d264fda0a0$var$_interopRequireDefault($42omo);

var $5dBQh = parcelRequire("5dBQh");


var $fsOG6 = parcelRequire("fsOG6");


var $eSYTn = parcelRequire("eSYTn");

var $5bdde6d264fda0a0$var$_withLockSheet2 = $5bdde6d264fda0a0$var$_interopRequireDefault($eSYTn);

var $gLQo9 = parcelRequire("gLQo9");

var $5bdde6d264fda0a0$var$_withTouchListeners2 = $5bdde6d264fda0a0$var$_interopRequireDefault($gLQo9);

var $iiSau = parcelRequire("iiSau");

function $5bdde6d264fda0a0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5bdde6d264fda0a0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5bdde6d264fda0a0$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5bdde6d264fda0a0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5bdde6d264fda0a0$var$ScrollLock = function(_PureComponent) {
    $5bdde6d264fda0a0$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $5bdde6d264fda0a0$var$_classCallCheck(this, ScrollLock);
        return $5bdde6d264fda0a0$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $5bdde6d264fda0a0$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$5dBQh.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $5bdde6d264fda0a0$var$_react2.default.createElement($fsOG6.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($42omo.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $5bdde6d264fda0a0$var$compose = (0, $iiSau.pipe)($5bdde6d264fda0a0$var$_withTouchListeners2.default, $5bdde6d264fda0a0$var$_withLockSheet2.default);
var $5bdde6d264fda0a0$var$SheetLock = $5bdde6d264fda0a0$var$compose($5bdde6d264fda0a0$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $5bdde6d264fda0a0$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $5bdde6d264fda0a0$var$_react2.default.createElement($5bdde6d264fda0a0$var$SheetLock, props) : props.children;
};
$5bdde6d264fda0a0$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $5bdde6d264fda0a0$var$LockToggle;

});

parcelRegister("fsOG6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $b420c82cd553c073$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $b420c82cd553c073$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");


var $5dBQh = parcelRequire("5dBQh");


var $iiSau = parcelRequire("iiSau");

function $b420c82cd553c073$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $b420c82cd553c073$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b420c82cd553c073$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b420c82cd553c073$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $b420c82cd553c073$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $b420c82cd553c073$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $b420c82cd553c073$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $b420c82cd553c073$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $b420c82cd553c073$var$_possibleConstructorReturn(_this, _ret);
    }
    $b420c82cd553c073$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$5dBQh.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $iiSau.preventInertiaScroll, $iiSau.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $iiSau.allowTouchMove, $iiSau.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$5dBQh.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $iiSau.preventInertiaScroll, $iiSau.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $iiSau.allowTouchMove, $iiSau.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $b420c82cd553c073$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $42omo.cloneElement)(children, $b420c82cd553c073$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($42omo.PureComponent);

});

parcelRegister("k1UQN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e950000043324005$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");

function $e950000043324005$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e950000043324005$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e950000043324005$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e950000043324005$var$NodeResolver = function(_Component) {
    $e950000043324005$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $e950000043324005$var$_classCallCheck(this, NodeResolver);
        return $e950000043324005$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $e950000043324005$var$_createClass(NodeResolver, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.innerRef((0, $jTxSS.findDOMNode)(this));
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: 'render',
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($42omo.Component);
module.exports.default = $e950000043324005$var$NodeResolver;

});

parcelRegister("2tfwO", function(module, exports) {
/* dialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gdv5Z = parcelRequire("gdv5Z");

const $3d8bed936bc122c0$var$imageStyles = null;
const $3d8bed936bc122c0$var$actionItemContainerStyles = {
    root: "_1e0c1txw _2lx21sbv _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr"
};
const $3d8bed936bc122c0$var$actionItemStyles = {
    root: "_6rthze3t _1pfhze3t _12l21b66 _ahbq1b66"
}; /**
    * __Dialog image__
    *
    * An optional header image in spotlight dialogs.
    *
    * @internal
    */ 
const $3d8bed936bc122c0$export$855e1a47874d6b81 = ({ alt: alt, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)("img", {
        alt: alt,
        ...props,
        className: (0, $gMc0m.default)([
            "_p12f1osq _4t3i1wug"
        ])
    }); /**
                                                                                                                  * __Dialog action item container__
                                                                                                                  *
                                                                                                                  * Flex wrapper around dialog action items.
                                                                                                                  *
                                                                                                                  * @internal
                                                                                                                  */ 
const $3d8bed936bc122c0$export$ed9b6b50bbed5f27 = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $3d8bed936bc122c0$var$actionItemContainerStyles.root,
        children: children
    }); /**
                                                                    * __Dialog action item__
                                                                    *
                                                                    * Action items shown inside of the dialog.
                                                                    *
                                                                    * @internal
                                                                    */ 
const $3d8bed936bc122c0$export$6ae54e00f59e1f33 = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $3d8bed936bc122c0$var$actionItemStyles.root,
        children: children
    });
module.exports["DialogImage"] = $3d8bed936bc122c0$export$855e1a47874d6b81;
module.exports["DialogActionItemContainer"] = $3d8bed936bc122c0$export$ed9b6b50bbed5f27;
module.exports["DialogActionItem"] = $3d8bed936bc122c0$export$6ae54e00f59e1f33;

});

parcelRegister("i4gTI", function(module, exports) {

var $88g2N = parcelRequire("88g2N");

function $cc37bf7dc6df308f$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $88g2N.honeyPotDataAttribute));
}
module.exports["isHoneyPotElement"] = $cc37bf7dc6df308f$export$821bdcd739a2706b;

});

parcelRegister("7J9Bb", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $iKd0N = parcelRequire("iKd0N");


var $ic3Jg = parcelRequire("ic3Jg");


var $1iOCV = parcelRequire("1iOCV");


var $e880Z = parcelRequire("e880Z");


var $2NDLX = parcelRequire("2NDLX");


var $beiUR = parcelRequire("beiUR");

function $7e1eb1dda9dbff10$export$d1c6f249e893cdf4({ dragEnter: dragEnter }) {
    const { type: type, relatedTarget: relatedTarget } = dragEnter;
    if (type !== 'dragenter') return false;
    if ((0, $e880Z.isSafari)()) return (0, $2NDLX.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is an element inside the child `iframe`
	 * (foreign element)
	 */ if ((0, $1iOCV.isFirefox)()) return (0, $beiUR.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is `null` *(standard check)*
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}



var $cmcCB = parcelRequire("cmcCB");


var $k5wZ1 = parcelRequire("k5wZ1");


var $839Yz = parcelRequire("839Yz");

function $6614ade0e20d66dc$export$a8e56a860d7957c7({ type: type, value: value }) {
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $839Yz.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $k5wZ1.textMediaType) && value === (0, $ic3Jg.androidFallbackText)) return false;
    return true;
}
function $6614ade0e20d66dc$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter((type)=>$6614ade0e20d66dc$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        }));
}
function $6614ade0e20d66dc$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || $6614ade0e20d66dc$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        }));
}
let $6614ade0e20d66dc$var$didDragStartLocally = false;
const $6614ade0e20d66dc$var$adapter = (0, $iKd0N.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $fFa3V.bind)(window, {
            type: 'dragenter',
            listener (event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($6614ade0e20d66dc$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $7e1eb1dda9dbff10$export$d1c6f249e893cdf4)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                const types = $6614ade0e20d66dc$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                const locked = {
                    types: types,
                    items: [],
                    getStringData: ()=>null
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload (event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            const items = $6614ade0e20d66dc$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData (mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    const value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$6614ade0e20d66dc$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $6614ade0e20d66dc$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $6614ade0e20d66dc$var$adapter.dropTarget(args);
}
function $6614ade0e20d66dc$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $6614ade0e20d66dc$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $6614ade0e20d66dc$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    const idle = {
        type: 'idle'
    };
    let state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $6614ade0e20d66dc$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $fFa3V.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            },
            ...(0, $cmcCB.getBindingsForBrokenDrags)({
                onDragEnd: clear
            })
        ], // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $fFa3V.bind)(window, {
        type: 'dragstart',
        listener () {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $6614ade0e20d66dc$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();
module.exports["dropTargetForExternal"] = $6614ade0e20d66dc$export$9edc779df9a85289;
module.exports["monitorForExternal"] = $6614ade0e20d66dc$export$bb1740f3194979c1;

});

parcelRegister("894UW", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $75LZI = parcelRequire("75LZI");


var $iKd0N = parcelRequire("iKd0N");


var $bSwyQ = parcelRequire("bSwyQ");


var $e880Z = parcelRequire("e880Z");

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $4ec37091dee56003$export$338a9f6c7a1f02b0 = 'text/html';



var $k5wZ1 = parcelRequire("k5wZ1");


var $839Yz = parcelRequire("839Yz");

function $3c235b63087ea285$var$findTextNode(event) {
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $e880Z.isSafari)()) return null;
    /**
	 * According to the spec, `event.target` should be the `Text` node that
	 * the drag started from when dragging a text selection.
	 *
	 * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
	 *
	 * However, in Safari the closest `HTMLElement` is returned.
	 * So we need to figure out if text is dragging ourselves.
	 *
	 * → https://bugs.webkit.org/show_bug.cgi?id=268959
	 */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!event.dataTransfer?.getData((0, $k5wZ1.textMediaType))) return null;
    /**
	 * Grab the first Text node and use that.
	 * Only doing a single level search as that is all we need for this bug.
	 */ const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
    return text ?? null;
}
const $3c235b63087ea285$var$honeyPotFix = (0, $75LZI.makeHoneyPotFix)();
const $3c235b63087ea285$var$adapter = (0, $iKd0N.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $bSwyQ.combine)($3c235b63087ea285$var$honeyPotFix.bindEvents(), (0, $fFa3V.bind)(window, {
            type: 'dragstart',
            listener (event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $839Yz.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $k5wZ1.textMediaType))) return;
                const target = $3c235b63087ea285$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                const payload = {
                    target: // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target,
                    plain: event.dataTransfer.getData((0, $k5wZ1.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $4ec37091dee56003$export$338a9f6c7a1f02b0))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $3c235b63087ea285$var$honeyPotFix.getOnPostDispatch()
});
function $3c235b63087ea285$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $3c235b63087ea285$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $3c235b63087ea285$var$adapter.registerUsage();
})();
function $3c235b63087ea285$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $3c235b63087ea285$var$adapter.monitor(args);
}
module.exports["monitorForTextSelection"] = $3c235b63087ea285$export$2e178e3647f5e6e9;

});

parcelRegister("7l88B", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $k7eoe = parcelRequire("k7eoe");








var $kDuN4 = parcelRequire("kDuN4");




const $08ebe6d2f096a5ea$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $08ebe6d2f096a5ea$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const { eventType: eventType, ...gasEvent } = event;
            const withClient = (cb)=>{
                if ($08ebe6d2f096a5ea$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };



var $7TH2w = parcelRequire("7TH2w");

parcelRequire("ffCOo");
var $7i8J9 = parcelRequire("7i8J9");
var $cT1Md = parcelRequire("cT1Md");


var $lgmus = parcelRequire("lgmus");















const $c1861bb6696554c9$export$a1d9dc589a29b3aa = 'editor';
const $c1861bb6696554c9$export$8aa0d788f94a809 = 'fabricEditor';
class $c1861bb6696554c9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $kDuN4.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $k7eoe.FabricChannel).editor,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args);
        this.handleEventWrapper = (event)=>{
            (0, $0324ab2e636f2852$export$d6e5ca10785815df)(event, [
                $c1861bb6696554c9$export$a1d9dc589a29b3aa,
                $c1861bb6696554c9$export$8aa0d788f94a809
            ], this.props.logger, this.props.client);
        };
    }
}


const $e066e6e8fe62f4ce$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(result, item), {});
const $e066e6e8fe62f4ce$var$fieldExtractor = (contextKey)=>$e066e6e8fe62f4ce$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey
    ]);
const $e066e6e8fe62f4ce$var$getContextKey = (tag)=>{
    switch(tag){
        case 0, $399527ab09064620$export$ed71ae78997933a:
            return 0, $cT1Md.ELEMENTS_CONTEXT;
        case 0, $c1861bb6696554c9$export$a1d9dc589a29b3aa:
            return 0, $7i8J9.EDITOR_CONTEXT;
        default:
            return '';
    }
};
const $e066e6e8fe62f4ce$var$updatePayloadWithContext = (primaryTag, event)=>{
    if (event.context.length === 0) return {
        source: (0, $7TH2w.DEFAULT_SOURCE),
        ...event.payload
    };
    const contextKey = $e066e6e8fe62f4ce$var$getContextKey(primaryTag) || 'attributes';
    const { [contextKey]: attributes, ...fields } = $e066e6e8fe62f4ce$var$fieldExtractor(contextKey)(event.context);
    if (attributes) event.payload.attributes = (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(attributes, event.payload.attributes || {});
    return {
        source: (0, $7TH2w.DEFAULT_SOURCE),
        ...fields,
        ...event.payload
    };
};
const $e066e6e8fe62f4ce$var$addTags = (tags, originalTags = [])=>{
    const mergedTags = new Set([
        ...originalTags,
        ...tags
    ]);
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function $e066e6e8fe62f4ce$var$getPrimaryTag(tags) {
    if (typeof tags === 'string') return tags;
    if (!tags.length) throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    return tags[0];
}
const $e066e6e8fe62f4ce$export$c37d638b7f2ca192 = (event, tags)=>{
    const primaryTag = $e066e6e8fe62f4ce$var$getPrimaryTag(tags);
    const tagsArray = typeof tags === 'string' ? [
        tags
    ] : tags;
    return {
        ...$e066e6e8fe62f4ce$var$updatePayloadWithContext(primaryTag, event),
        tags: $e066e6e8fe62f4ce$var$addTags(tagsArray, event.payload.tags)
    };
};


const $0324ab2e636f2852$export$d6e5ca10785815df = (event, // If passing through multiple tags, the primary tag should be first in the array.
// The primary tag is used for matching context.
tags, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $e066e6e8fe62f4ce$export$c37d638b7f2ca192)(event, tags);
    (0, $08ebe6d2f096a5ea$export$7329bcdc3edcd90e)(logger, client)(payload);
};


const $399527ab09064620$export$ed71ae78997933a = 'fabricElements';
class $399527ab09064620$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $kDuN4.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $k7eoe.FabricChannel).elements,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args);
        this.handleEventWrapper = (event)=>{
            (0, $0324ab2e636f2852$export$d6e5ca10785815df)(event, $399527ab09064620$export$ed71ae78997933a, this.props.logger, this.props.client);
        };
    }
}





parcelRequire("42omo");




/**
 * Inspired by analytics-web-react
 */ 
var $apAFY = parcelRequire("apAFY");







/**
 * Largely taken from analytics-web-react
 */ 


const $de25c6b1a3aac308$export$9b947b4502cd2705 = (propertyName, event)=>event.context.map((contextItem)=>contextItem[propertyName]).filter(Boolean);
const $de25c6b1a3aac308$export$6f40cdf6d42c018d = (event)=>{
    const overrides = $de25c6b1a3aac308$export$9b947b4502cd2705('actionSubjectOverride', event);
    const closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    const actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};
const $de25c6b1a3aac308$export$5f9bc633b116660f = (event)=>$de25c6b1a3aac308$export$9b947b4502cd2705('source', event);
const $de25c6b1a3aac308$export$4e811121b221213b = (event)=>$de25c6b1a3aac308$export$9b947b4502cd2705('component', event);
const $de25c6b1a3aac308$export$67c3590839ebecdd = (event)=>$de25c6b1a3aac308$export$9b947b4502cd2705('attributes', event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(result, extraAttributes), {});
const $de25c6b1a3aac308$export$cd17d76da7967240 = (event)=>event.context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $de25c6b1a3aac308$export$18cd124b5098d330 = (event)=>$de25c6b1a3aac308$export$9b947b4502cd2705('packageVersion', event);
function $de25c6b1a3aac308$export$4e0b83da1896ebc7(event) {
    const packages = $de25c6b1a3aac308$export$cd17d76da7967240(event) || [];
    return packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName).join(',') || undefined;
}


const $1024103f531856dc$var$ATLASKIT_TAG = 'atlaskit';
const $1024103f531856dc$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $1024103f531856dc$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $de25c6b1a3aac308$export$5f9bc633b116660f)(event);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $de25c6b1a3aac308$export$67c3590839ebecdd)(event);
    const components = (0, $de25c6b1a3aac308$export$4e811121b221213b)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))((0, $de25c6b1a3aac308$export$cd17d76da7967240)(event)) || {};
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubjectId: actionSubjectId, attributes: payloadAttributes, containerId: containerId } = event.payload;
    const attributes = {
        listenerVersion: $1024103f531856dc$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: (0, $de25c6b1a3aac308$export$4e0b83da1896ebc7)(event) || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(extraAttributes, payloadAttributes)
    };
    // Ensure atlaskit tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($1024103f531856dc$var$ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, $7TH2w.UI_EVENT_TYPE)) return {
            eventType: eventType,
            source: source,
            actionSubject: (0, $de25c6b1a3aac308$export$6f40cdf6d42c018d)(event),
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            containerId: containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, $7TH2w.TRACK_EVENT_TYPE) || eventType === (0, $7TH2w.OPERATIONAL_EVENT_TYPE) || eventType === (0, $7TH2w.SCREEN_EVENT_TYPE)) logger.error('Track, screen and operational events are currently not supported for atlaskit events');
        else logger.error('Invalid event type', eventType);
    }
    return null;
};












class $4e095df3c01dc7b7$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $kDuN4.default), {
            onEvent: this.listenerHandler,
            channel: this.props.channel,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args);
        this.listenerHandler = (event)=>{
            const { client: client, logger: logger, channel: channel, processEvent: processEvent } = this.props;
            if (!event.payload) return;
            logger.debug(`Received ${channel} event`, event);
            const payload = processEvent(event, logger);
            logger.debug(`Processed ${channel} event`, payload);
            if (payload) (0, $08ebe6d2f096a5ea$export$7329bcdc3edcd90e)(logger, client)(payload);
        };
    }
}


function $9808379ecad6fe49$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4e095df3c01dc7b7$export$2e2bcd8739ae039), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).atlaskit,
        processEvent: (0, $1024103f531856dc$export$2e2bcd8739ae039)
    });
}



var $cCg1W = parcelRequire("cCg1W");




parcelRequire("42omo");




/**
 * Inspired by analytics-web-react
 */ 








parcelRequire("ffCOo");
var $1oYFx = parcelRequire("1oYFx");

/**
 * Largely taken from analytics-web-react
 */ 


const $99c5302a58ee3827$var$extractFromEventContext = (propertyNames, event, namespacedContextOnly = true, contextName)=>event.context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContext = contextItem[contextName];
            const navContextProp = navContext ? navContext[propertyName] : null;
            const value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);
const $99c5302a58ee3827$export$5f9bc633b116660f = (event, contextName)=>$99c5302a58ee3827$var$extractFromEventContext([
        'source'
    ], event, false, contextName);
const $99c5302a58ee3827$export$4e811121b221213b = (event, contextName)=>$99c5302a58ee3827$var$extractFromEventContext([
        'component',
        'componentName'
    ], event, false, contextName);
const $99c5302a58ee3827$export$67c3590839ebecdd = (event, contextName)=>$99c5302a58ee3827$var$extractFromEventContext([
        'attributes'
    ], event, true, contextName).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(result, extraAttributes), {});
const $99c5302a58ee3827$export$cd17d76da7967240 = (event, contextName)=>event.context.map((contextItem)=>{
        const navContext = contextItem[contextName];
        const item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter((p)=>p.packageName);
const $99c5302a58ee3827$export$18cd124b5098d330 = (event, contextName)=>$99c5302a58ee3827$var$extractFromEventContext([
        'packageVersion'
    ], event, true, contextName);


const $b6f08321b231e7ec$var$NAVIGATION_TAG = 'navigation';
const $b6f08321b231e7ec$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $b6f08321b231e7ec$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $99c5302a58ee3827$export$5f9bc633b116660f)(event, (0, $1oYFx.NAVIGATION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $99c5302a58ee3827$export$67c3590839ebecdd)(event, (0, $1oYFx.NAVIGATION_CONTEXT));
    const components = (0, $99c5302a58ee3827$export$4e811121b221213b)(event, (0, $1oYFx.NAVIGATION_CONTEXT));
    const packages = (0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $1oYFx.NAVIGATION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))((0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $1oYFx.NAVIGATION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $b6f08321b231e7ec$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($b6f08321b231e7ec$var$NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};



function $f6e39daa81a4df2a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4e095df3c01dc7b7$export$2e2bcd8739ae039), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).navigation,
        processEvent: (0, $b6f08321b231e7ec$export$2e2bcd8739ae039)
    });
}






parcelRequire("42omo");







parcelRequire("ffCOo");
var $gSKON = parcelRequire("gSKON");








const $f63901d19e7bdc18$var$listenerVersion = "0.0.0-use.local";
function $f63901d19e7bdc18$var$getMediaContexts(event) {
    return (0, $de25c6b1a3aac308$export$9b947b4502cd2705)((0, $gSKON.MEDIA_CONTEXT), event);
}
function $f63901d19e7bdc18$var$getMediaRegion() {
    try {
        return window && window.sessionStorage && window.sessionStorage.getItem('media-api-region');
    } catch (e) {
        return;
    }
}
function $f63901d19e7bdc18$export$22af68e3614bf024(event) {
    const sources = (0, $de25c6b1a3aac308$export$5f9bc633b116660f)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))((0, $de25c6b1a3aac308$export$cd17d76da7967240)(event)) || {};
    const extraAttributes = (0, $de25c6b1a3aac308$export$67c3590839ebecdd)(event);
    const mediaContexts = $f63901d19e7bdc18$var$getMediaContexts(event) || [];
    const mediaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))({}, ...mediaContexts);
    const tags = new Set(event.payload.tags || []);
    tags.add('media');
    const components = (0, $de25c6b1a3aac308$export$4e811121b221213b)(event);
    const mediaRegion = $f63901d19e7bdc18$var$getMediaRegion();
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(sources) || (0, $7TH2w.DEFAULT_SOURCE),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))({}, extraAttributes, mediaAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $de25c6b1a3aac308$export$4e0b83da1896ebc7)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $f63901d19e7bdc18$var$listenerVersion,
            ...mediaRegion ? {
                mediaRegion: mediaRegion
            } : undefined
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}



function $6e34a9c02452623d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4e095df3c01dc7b7$export$2e2bcd8739ae039), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).media,
        processEvent: (0, $f63901d19e7bdc18$export$22af68e3614bf024)
    });
}





parcelRequire("42omo");




/**
 * Inspired by analytics-web-react
 */ 








parcelRequire("ffCOo");
var $gqplE = parcelRequire("gqplE");


const $8cadc3c25c9846ec$var$PEOPLE_TEAMS_TAG = 'peopleTeams';
const $8cadc3c25c9846ec$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $8cadc3c25c9846ec$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $99c5302a58ee3827$export$5f9bc633b116660f)(event, (0, $gqplE.PEOPLE_TEAMS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $99c5302a58ee3827$export$67c3590839ebecdd)(event, (0, $gqplE.PEOPLE_TEAMS_CONTEXT));
    const components = (0, $99c5302a58ee3827$export$4e811121b221213b)(event, (0, $gqplE.PEOPLE_TEAMS_CONTEXT));
    const packages = (0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $gqplE.PEOPLE_TEAMS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))((0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $gqplE.PEOPLE_TEAMS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $8cadc3c25c9846ec$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($8cadc3c25c9846ec$var$PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};



function $96136f03b059d91c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4e095df3c01dc7b7$export$2e2bcd8739ae039), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).peopleTeams,
        processEvent: (0, $8cadc3c25c9846ec$export$2e2bcd8739ae039)
    });
}





parcelRequire("42omo");




/**
 * Inspired by analytics-web-react
 */ 









parcelRequire("ffCOo");
var $ePh4F = parcelRequire("ePh4F");




const $544439629a9bf3fd$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $544439629a9bf3fd$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $99c5302a58ee3827$export$5f9bc633b116660f)(event, (0, $ePh4F.NOTIFICATIONS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $99c5302a58ee3827$export$67c3590839ebecdd)(event, (0, $ePh4F.NOTIFICATIONS_CONTEXT));
    const components = (0, $99c5302a58ee3827$export$4e811121b221213b)(event, (0, $ePh4F.NOTIFICATIONS_CONTEXT));
    const packages = (0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $ePh4F.NOTIFICATIONS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))((0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $ePh4F.NOTIFICATIONS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $544439629a9bf3fd$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $k7eoe.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};



function $07dbb2b9190d7b14$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4e095df3c01dc7b7$export$2e2bcd8739ae039), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).notifications,
        processEvent: (0, $544439629a9bf3fd$export$2e2bcd8739ae039)
    });
}





parcelRequire("42omo");




/**
 * Inspired by analytics-web-react
 */ 









parcelRequire("ffCOo");
var $8hvil = parcelRequire("8hvil");




const $ce2161de111877bc$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $ce2161de111877bc$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $99c5302a58ee3827$export$5f9bc633b116660f)(event, (0, $8hvil.RECENT_WORK_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $99c5302a58ee3827$export$67c3590839ebecdd)(event, (0, $8hvil.RECENT_WORK_CONTEXT));
    const components = (0, $99c5302a58ee3827$export$4e811121b221213b)(event, (0, $8hvil.RECENT_WORK_CONTEXT));
    const packages = (0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $8hvil.RECENT_WORK_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))((0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $8hvil.RECENT_WORK_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $ce2161de111877bc$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $k7eoe.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};



function $20cd78c23fb9f419$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4e095df3c01dc7b7$export$2e2bcd8739ae039), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).recentWork,
        processEvent: (0, $ce2161de111877bc$export$2e2bcd8739ae039)
    });
}





parcelRequire("42omo");




/**
 * Inspired by analytics-web-react
 */ 









parcelRequire("ffCOo");
var $dWoPW = parcelRequire("dWoPW");

const $2d899a2b8fb68cab$var$ATLAS_TAG = 'atlas';
const $2d899a2b8fb68cab$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $2d899a2b8fb68cab$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $99c5302a58ee3827$export$5f9bc633b116660f)(event, (0, $dWoPW.ATLAS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $99c5302a58ee3827$export$67c3590839ebecdd)(event, (0, $dWoPW.ATLAS_CONTEXT));
    const components = (0, $99c5302a58ee3827$export$4e811121b221213b)(event, (0, $dWoPW.ATLAS_CONTEXT));
    const packages = (0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $dWoPW.ATLAS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))((0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $dWoPW.ATLAS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $2d899a2b8fb68cab$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($2d899a2b8fb68cab$var$ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};



function $0213153459c4e853$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4e095df3c01dc7b7$export$2e2bcd8739ae039), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).atlas,
        processEvent: (0, $2d899a2b8fb68cab$export$2e2bcd8739ae039)
    });
}





parcelRequire("42omo");




/**
 * Inspired by analytics-web-react
 */ 





parcelRequire("ffCOo");




const $133994367adca510$var$CROSS_FLOW_TAG = 'crossFlow';
var $133994367adca510$export$2e2bcd8739ae039 = (event, logger)=>{
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, name: name } = event.payload;
    let sources = (0, $de25c6b1a3aac308$export$5f9bc633b116660f)(event);
    const lastSourceFromContext = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(sources);
    const source = event.payload.source ?? lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    const attributes = {
        // To get extra attributes from AnalyticsContext from other products/platforms, e.g. Jira-frontend
        ...(0, $de25c6b1a3aac308$export$67c3590839ebecdd)(event),
        // To inherit the extra attributes from the navigation (Atlassian Switcher) context into the crossFlow events,
        // because the events current crossFlow touchpionts already inherit these attributes in the payload.
        ...(0, $99c5302a58ee3827$export$67c3590839ebecdd)(event, (0, $1oYFx.NAVIGATION_CONTEXT)),
        ...event.payload.attributes,
        namespaces: sources.join('.')
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($133994367adca510$var$CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};



function $63906427acfeed89$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4e095df3c01dc7b7$export$2e2bcd8739ae039), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).crossFlow,
        processEvent: (0, $133994367adca510$export$2e2bcd8739ae039)
    });
}





parcelRequire("42omo");










parcelRequire("ffCOo");
var $kwKGS = parcelRequire("kwKGS");





const $5f46c414ec40580e$var$listenerVersion = "0.0.0-use.local";
var $5f46c414ec40580e$export$2e2bcd8739ae039 = (event)=>{
    const sources = (0, $99c5302a58ee3827$export$5f9bc633b116660f)(event, (0, $kwKGS.LINKING_PLATFORM_CONTEXT));
    const packages = (0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $kwKGS.LINKING_PLATFORM_CONTEXT));
    const components = (0, $99c5302a58ee3827$export$4e811121b221213b)(event, (0, $kwKGS.LINKING_PLATFORM_CONTEXT));
    const extraAttributes = (0, $99c5302a58ee3827$export$67c3590839ebecdd)(event, (0, $kwKGS.LINKING_PLATFORM_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(packages) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $k7eoe.FabricChannel).linkingPlatform);
    const payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            listenerVersion: $5f46c414ec40580e$var$listenerVersion,
            sourceHierarchy: sources.join('.') || undefined,
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: packageHierarchy.join(',') || undefined,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(extraAttributes, event.payload.attributes)
        },
        tags: Array.from(tags),
        source: (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(sources) || (0, $7TH2w.DEFAULT_SOURCE),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};






function $2bce08cf99fe0dac$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4e095df3c01dc7b7$export$2e2bcd8739ae039), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).linkingPlatform,
        processEvent: (0, $5f46c414ec40580e$export$2e2bcd8739ae039)
    });
}





parcelRequire("42omo");




/**
 * Inspired by analytics-web-react
 */ 








parcelRequire("ffCOo");
var $26stD = parcelRequire("26stD");





const $e9762b64767a874c$var$POST_OFFICE_TAG = (0, $k7eoe.FabricChannel).postOffice;
const $e9762b64767a874c$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $e9762b64767a874c$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $99c5302a58ee3827$export$5f9bc633b116660f)(event, (0, $26stD.POST_OFFICE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $99c5302a58ee3827$export$67c3590839ebecdd)(event, (0, $26stD.POST_OFFICE_CONTEXT));
    const components = (0, $99c5302a58ee3827$export$4e811121b221213b)(event, (0, $26stD.POST_OFFICE_CONTEXT));
    const packages = (0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $26stD.POST_OFFICE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))((0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $26stD.POST_OFFICE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $e9762b64767a874c$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($e9762b64767a874c$var$POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};



function $d14160c3893b0733$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4e095df3c01dc7b7$export$2e2bcd8739ae039), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).postOffice,
        processEvent: (0, $e9762b64767a874c$export$2e2bcd8739ae039)
    });
}





parcelRequire("42omo");




/**
 * Inspired by analytics-web-react
 */ 








parcelRequire("ffCOo");
var $2jQZn = parcelRequire("2jQZn");


const $7d1e264d0be06509$var$AI_MATE_TAG = 'aiMate';
const $7d1e264d0be06509$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $7d1e264d0be06509$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $99c5302a58ee3827$export$5f9bc633b116660f)(event, (0, $2jQZn.AI_MATE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $99c5302a58ee3827$export$67c3590839ebecdd)(event, (0, $2jQZn.AI_MATE_CONTEXT));
    const components = (0, $99c5302a58ee3827$export$4e811121b221213b)(event, (0, $2jQZn.AI_MATE_CONTEXT));
    const packages = (0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $2jQZn.AI_MATE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))((0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $2jQZn.AI_MATE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $7d1e264d0be06509$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($7d1e264d0be06509$var$AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};



function $99eee8d37ca1b185$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4e095df3c01dc7b7$export$2e2bcd8739ae039), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).aiMate,
        processEvent: (0, $7d1e264d0be06509$export$2e2bcd8739ae039)
    });
}





parcelRequire("42omo");




/**
 * Inspired by analytics-web-react
 */ 








parcelRequire("ffCOo");
var $aVIsj = parcelRequire("aVIsj");


const $52f6da4fdcbb05f5$var$AVP_TAG = 'avp';
const $52f6da4fdcbb05f5$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $52f6da4fdcbb05f5$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $99c5302a58ee3827$export$5f9bc633b116660f)(event, (0, $aVIsj.AVP_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $99c5302a58ee3827$export$67c3590839ebecdd)(event, (0, $aVIsj.AVP_CONTEXT));
    const components = (0, $99c5302a58ee3827$export$4e811121b221213b)(event, (0, $aVIsj.AVP_CONTEXT));
    const packages = (0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $aVIsj.AVP_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))((0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $aVIsj.AVP_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $52f6da4fdcbb05f5$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(extraAttributes, payloadAttributes),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))({}, ...event.context)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($52f6da4fdcbb05f5$var$AVP_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};



function $b3b70804c56098a4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4e095df3c01dc7b7$export$2e2bcd8739ae039), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).avp,
        processEvent: (0, $52f6da4fdcbb05f5$export$2e2bcd8739ae039)
    });
}





parcelRequire("42omo");




/**
 * Inspired by analytics-web-react
 */ 








parcelRequire("ffCOo");
var $hcByP = parcelRequire("hcByP");


const $b335e7076eadb138$var$GROWTH_TAG = 'growth';
const $b335e7076eadb138$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $b335e7076eadb138$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $99c5302a58ee3827$export$5f9bc633b116660f)(event, (0, $hcByP.GROWTH_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $99c5302a58ee3827$export$67c3590839ebecdd)(event, (0, $hcByP.GROWTH_CONTEXT));
    const components = (0, $99c5302a58ee3827$export$4e811121b221213b)(event, (0, $hcByP.GROWTH_CONTEXT));
    const packages = (0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $hcByP.GROWTH_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))((0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $hcByP.GROWTH_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $b335e7076eadb138$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($b335e7076eadb138$var$GROWTH_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};



function $b0ce442b4c3e5345$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4e095df3c01dc7b7$export$2e2bcd8739ae039), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).growth,
        processEvent: (0, $b335e7076eadb138$export$2e2bcd8739ae039)
    });
}





parcelRequire("42omo");







parcelRequire("ffCOo");
var $aldCG = parcelRequire("aldCG");











const $f3f1525c6c8cd465$var$listenerVersion = "0.0.0-use.local";
var $f3f1525c6c8cd465$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $99c5302a58ee3827$export$5f9bc633b116660f)(event, (0, $aldCG.OMNI_CHANNEL_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $99c5302a58ee3827$export$67c3590839ebecdd)(event, (0, $aldCG.OMNI_CHANNEL_CONTEXT));
    const components = (0, $99c5302a58ee3827$export$4e811121b221213b)(event, (0, $aldCG.OMNI_CHANNEL_CONTEXT));
    const packages = (0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $aldCG.OMNI_CHANNEL_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))((0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $aldCG.OMNI_CHANNEL_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $f3f1525c6c8cd465$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $k7eoe.FabricChannel).omniChannel);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};



const $d6a5585a1f18154a$var$OmniChannelAnalyticsListener = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4e095df3c01dc7b7$export$2e2bcd8739ae039), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).omniChannel,
        processEvent: (0, $f3f1525c6c8cd465$export$2e2bcd8739ae039)
    });
};
var $d6a5585a1f18154a$export$2e2bcd8739ae039 = $d6a5585a1f18154a$var$OmniChannelAnalyticsListener;





parcelRequire("42omo");














parcelRequire("ffCOo");
var $2mJpK = parcelRequire("2mJpK");

const $f7b8cc7da8a24d30$var$TOWNSQUARE_TAG = 'townsquare';
const $f7b8cc7da8a24d30$var$TOWNSQUARE_HOME_TAG = 'townsquareHome';
const $f7b8cc7da8a24d30$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $f7b8cc7da8a24d30$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $99c5302a58ee3827$export$5f9bc633b116660f)(event, (0, $2mJpK.TOWNSQUARE_HOME_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $99c5302a58ee3827$export$67c3590839ebecdd)(event, (0, $2mJpK.TOWNSQUARE_HOME_CONTEXT));
    const components = (0, $99c5302a58ee3827$export$4e811121b221213b)(event, (0, $2mJpK.TOWNSQUARE_HOME_CONTEXT));
    const packages = (0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $2mJpK.TOWNSQUARE_HOME_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))((0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $2mJpK.TOWNSQUARE_HOME_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $f7b8cc7da8a24d30$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "townsquare" is our platform analytic for data portal
    tags.add($f7b8cc7da8a24d30$var$TOWNSQUARE_TAG);
    // "townsquareHome" allows us to differentiate our events from townsquare events.
    tags.add($f7b8cc7da8a24d30$var$TOWNSQUARE_HOME_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};



function $218ae702f00d57e0$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4e095df3c01dc7b7$export$2e2bcd8739ae039), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).townsquareHome,
        processEvent: (0, $f7b8cc7da8a24d30$export$2e2bcd8739ae039)
    });
}





parcelRequire("42omo");














parcelRequire("ffCOo");
var $lJwkv = parcelRequire("lJwkv");

const $58d8a06bdb5a00fe$var$ROVO_EXTENSION_TAG = 'rovoExtension';
const $58d8a06bdb5a00fe$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $58d8a06bdb5a00fe$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $99c5302a58ee3827$export$5f9bc633b116660f)(event, (0, $lJwkv.ROVO_EXTENSION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = (0, $99c5302a58ee3827$export$67c3590839ebecdd)(event, (0, $lJwkv.ROVO_EXTENSION_CONTEXT));
    const components = (0, $99c5302a58ee3827$export$4e811121b221213b)(event, (0, $lJwkv.ROVO_EXTENSION_CONTEXT));
    const packages = (0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $lJwkv.ROVO_EXTENSION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))((0, $99c5302a58ee3827$export$cd17d76da7967240)(event, (0, $lJwkv.ROVO_EXTENSION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $58d8a06bdb5a00fe$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "rovoExtension" allows us to differentiate our events from rovo events.
    tags.add($58d8a06bdb5a00fe$var$ROVO_EXTENSION_TAG);
    if (event.payload) switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};



function $7c4a9239ed66315f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4e095df3c01dc7b7$export$2e2bcd8739ae039), {
        ...props,
        channel: (0, $k7eoe.FabricChannel).rovoExtension,
        processEvent: (0, $58d8a06bdb5a00fe$export$2e2bcd8739ae039)
    });
}


const $104739198ff898b6$var$listenerMap = {
    [(0, $k7eoe.FabricChannel).elements]: (0, $399527ab09064620$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).editor]: (0, $c1861bb6696554c9$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).atlaskit]: (0, $9808379ecad6fe49$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).navigation]: (0, $f6e39daa81a4df2a$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).media]: (0, $6e34a9c02452623d$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).peopleTeams]: (0, $96136f03b059d91c$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).notifications]: (0, $07dbb2b9190d7b14$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).recentWork]: (0, $20cd78c23fb9f419$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).atlas]: (0, $0213153459c4e853$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).crossFlow]: (0, $63906427acfeed89$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).linkingPlatform]: (0, $2bce08cf99fe0dac$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).postOffice]: (0, $d14160c3893b0733$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).aiMate]: (0, $99eee8d37ca1b185$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).avp]: (0, $b3b70804c56098a4$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).growth]: (0, $b0ce442b4c3e5345$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).omniChannel]: (0, $d6a5585a1f18154a$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).townsquareHome]: (0, $218ae702f00d57e0$export$2e2bcd8739ae039),
    [(0, $k7eoe.FabricChannel).rovoExtension]: (0, $7c4a9239ed66315f$export$2e2bcd8739ae039)
};
class $104739198ff898b6$var$FabricAnalyticsListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { client: client, children: children, logLevel: logLevel, excludedChannels: excludedChannels } = this.props;
        if (typeof logLevel === 'number') this.logger.setLogLevel(logLevel);
        const listeners = Object.keys($104739198ff898b6$var$listenerMap).filter((channel)=>!excludedChannels || excludedChannels.indexOf(channel) < 0).map((channel)=>$104739198ff898b6$var$listenerMap[channel]).reduce((prev, Listener)=>/*#__PURE__*/ (0, $l998X.jsx)(Listener, {
                client: client,
                logger: this.logger,
                children: prev
            }), children);
        return listeners;
    }
    constructor(props){
        super(props);
        this.logger = void 0;
        this.logger = new (0, $cCg1W.default)({
            logLevel: props.logLevel
        });
    }
}
var $104739198ff898b6$export$2e2bcd8739ae039 = $104739198ff898b6$var$FabricAnalyticsListeners;
module.exports["default"] = $104739198ff898b6$export$2e2bcd8739ae039;

});

parcelRegister("cCg1W", function(module, exports) {
/* eslint-disable no-console */ const $72dce2384e397b71$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $72dce2384e397b71$export$2e2bcd8739ae039 {
    setLogLevel(logLevel) {
        if (logLevel >= $72dce2384e397b71$export$ffe0c436e29512cf.DEBUG && logLevel <= $72dce2384e397b71$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $72dce2384e397b71$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) console[type](...args);
    }
    debug(...args) {
        this.logMessage($72dce2384e397b71$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($72dce2384e397b71$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($72dce2384e397b71$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($72dce2384e397b71$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $72dce2384e397b71$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
}
module.exports["default"] = $72dce2384e397b71$export$2e2bcd8739ae039;

});

parcelRegister("1oKVt", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $iT2q7 = parcelRequire("iT2q7");

const $1fa91599cfa7c506$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $dh538.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $iT2q7.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $dh538.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, $iT2q7.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};
const $1fa91599cfa7c506$export$5d76d7014f4a5d08 = (_themeState)=>{
    const themeOverridePreferences = [];
    return [
        ...new Set(themeOverridePreferences)
    ];
};
module.exports["getThemePreferences"] = $1fa91599cfa7c506$export$dd6aeb7c823fc03d;
module.exports["getThemeOverridePreferences"] = $1fa91599cfa7c506$export$5d76d7014f4a5d08;

});

parcelRegister("k5Cbm", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea01e4743d226ebd$export$2e2bcd8739ae039);

var $fCbsm = parcelRequire("fCbsm");


var $1hmzn = parcelRequire("1hmzn");

var $ea01e4743d226ebd$export$1385d81a6c6bbcd4 = {
    INIT: '@@redux/INIT'
};
function $ea01e4743d226ebd$export$2e2bcd8739ae039(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error('Expected the enhancer to be a function.');
        return enhancer($ea01e4743d226ebd$export$2e2bcd8739ae039)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error('Expected the reducer to be a function.');
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error('Expected listener to be a function.');
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!(0, $fCbsm.default)(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === 'undefined') throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error('Reducers may not dispatch actions.');
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error('Expected the nextReducer to be a function.');
        currentReducer = nextReducer;
        dispatch({
            type: $ea01e4743d226ebd$export$1385d81a6c6bbcd4.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object') throw new TypeError('Expected the observer to be an object.');
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[0, $1hmzn.default] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $ea01e4743d226ebd$export$1385d81a6c6bbcd4.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[0, $1hmzn.default] = observable, _ref2;
}
module.exports["ActionTypes"] = $ea01e4743d226ebd$export$1385d81a6c6bbcd4;

});

parcelRegister("dr3FA", function(module, exports) {

var $k5Cbm = parcelRequire("k5Cbm");


var $fCbsm = parcelRequire("fCbsm");

parcelRequire("eOnB8");

function $9c80a4b15dc2578f$var$getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
    return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}
function $9c80a4b15dc2578f$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === (0, $k5Cbm.ActionTypes).INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!(0, $fCbsm.default)(inputState)) return 'The ' + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (unexpectedKeys.length > 0) return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $9c80a4b15dc2578f$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: (0, $k5Cbm.ActionTypes).INIT
        });
        if (typeof initialState === 'undefined') throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
        var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
        if (typeof reducer(undefined, {
            type: type
        }) === 'undefined') throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + (0, $k5Cbm.ActionTypes).INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    });
}
function $9c80a4b15dc2578f$export$2e2bcd8739ae039(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache = void 0;
    var shapeAssertionError = void 0;
    try {
        $9c80a4b15dc2578f$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var errorMessage = $9c80a4b15dc2578f$var$getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}

});

parcelRegister("kVUld", function(module, exports) {
function $f3d4d5b73cf37aee$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(undefined, arguments));
    };
}
function $f3d4d5b73cf37aee$export$2e2bcd8739ae039(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $f3d4d5b73cf37aee$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var keys = Object.keys(actionCreators);
    var boundActionCreators = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $f3d4d5b73cf37aee$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}

});

parcelRegister("7r3UO", function(module, exports) {

var $lRjVN = parcelRequire("lRjVN");

var $569e178a1ea98196$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $569e178a1ea98196$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch(action) {
                    return _dispatch(action);
                }
            };
            chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = (0, $lRjVN.default).apply(undefined, chain)(store.dispatch);
            return $569e178a1ea98196$var$_extends({}, store, {
                dispatch: _dispatch
            });
        };
    };
}

});

parcelRegister("lRjVN", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe9e022296534d83$export$2e2bcd8739ae039);
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $fe9e022296534d83$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(undefined, arguments));
        };
    });
}

});

parcelRegister("eEWwZ", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $5Gw6m = parcelRequire("5Gw6m");

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function $aac23429d737d2a5$var$printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var $aac23429d737d2a5$var$warning = $5Gw6m;
module.exports = $aac23429d737d2a5$var$warning;

});

parcelRegister("8w3GE", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var $63342c0e05139c45$var$aStackPool = [];
var $63342c0e05139c45$var$bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function $63342c0e05139c45$var$areEqual(a, b) {
    var aStack = $63342c0e05139c45$var$aStackPool.length ? $63342c0e05139c45$var$aStackPool.pop() : [];
    var bStack = $63342c0e05139c45$var$bStackPool.length ? $63342c0e05139c45$var$bStackPool.pop() : [];
    var result = $63342c0e05139c45$var$eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    $63342c0e05139c45$var$aStackPool.push(aStack);
    $63342c0e05139c45$var$bStackPool.push(bStack);
    return result;
}
function $63342c0e05139c45$var$eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != 'object' || typeof b != 'object') return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === '[object Array]') {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!$63342c0e05139c45$var$eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!$63342c0e05139c45$var$eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = $63342c0e05139c45$var$areEqual;

});

parcelRegister("9CxbP", function(module, exports) {

var $lW3f8 = parcelRequire("lW3f8");

function $701168728f8a4b50$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $lW3f8(r);
}
module.exports = $701168728f8a4b50$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dQXcU", function(module, exports) {
function $a15e0f0822d0c598$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $a15e0f0822d0c598$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dLmhD", function(module, exports) {

var $lW3f8 = parcelRequire("lW3f8");

function $a050f327ed01f694$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $lW3f8(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $lW3f8(r, a) : void 0;
    }
}
module.exports = $a050f327ed01f694$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6OV2B", function(module, exports) {
function $4f73a8be71103f91$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $4f73a8be71103f91$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8numO", function(module, exports) {

var $crVe8 = parcelRequire("crVe8");

var $619806f3d041136c$var$_typeof = $crVe8.default;
function $619806f3d041136c$var$toPrimitive(t, r) {
    if ("object" != $619806f3d041136c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $619806f3d041136c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $619806f3d041136c$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lr3oT", function(module, exports) {
function $f9aec1da2cf34670$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $f9aec1da2cf34670$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ga7FX", function(module, exports) {

var $6oivZ = parcelRequire("6oivZ");


var $gHZmH = parcelRequire("gHZmH");

function $bc4388c2e8f7c916$var$_construct(t, e, r) {
    if ($6oivZ()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $gHZmH(p, r.prototype), p;
}
module.exports = $bc4388c2e8f7c916$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kiICD", function(module, exports) {
'use strict';
function $ec781a1c2573b09e$var$deepFreeze(object) {
    if (!$ec781a1c2573b09e$var$shouldBeFrozen(object)) return object;
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === 'object' && !Object.isFrozen(property)) $ec781a1c2573b09e$var$deepFreeze(property);
    });
    return object;
}
function $ec781a1c2573b09e$var$shouldBeFrozen(value) {
    return value != null && (Array.isArray(value) || typeof value === 'object' && value.constructor === Object);
}
module.exports = $ec781a1c2573b09e$var$deepFreeze;

});

parcelRegister("fub1S", function(module, exports) {
'use strict';

var $ek4t1 = parcelRequire("ek4t1");


var $571eK = parcelRequire("571eK");

var $b4623687aa59866d$var$intern = $571eK.intern;
var $b4623687aa59866d$var$PREFIX = 'client:';
function $b4623687aa59866d$var$generateClientID(id, storageKey, index) {
    var internedId = $ek4t1.STRING_INTERN_LEVEL <= 0 ? id : $b4623687aa59866d$var$intern(id, $ek4t1.MAX_DATA_ID_LENGTH);
    var key = internedId + ':' + storageKey;
    if (index != null) key += ':' + index;
    if (key.indexOf($b4623687aa59866d$var$PREFIX) !== 0) key = $b4623687aa59866d$var$PREFIX + key;
    return key;
}
function $b4623687aa59866d$var$isClientID(id) {
    return id.indexOf($b4623687aa59866d$var$PREFIX) === 0;
}
var $b4623687aa59866d$var$localID = 0;
function $b4623687aa59866d$var$generateUniqueClientID() {
    return "".concat($b4623687aa59866d$var$PREFIX, "local:").concat($b4623687aa59866d$var$localID++);
}
function $b4623687aa59866d$var$generateClientObjectClientID(typename, localId, index) {
    var key = "".concat($b4623687aa59866d$var$PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ':' + index;
    return key;
}
module.exports = {
    generateClientID: $b4623687aa59866d$var$generateClientID,
    generateClientObjectClientID: $b4623687aa59866d$var$generateClientObjectClientID,
    generateUniqueClientID: $b4623687aa59866d$var$generateUniqueClientID,
    isClientID: $b4623687aa59866d$var$isClientID
};

});

parcelRegister("fusLc", function(module, exports) {
'use strict';
var $b46ff7924e7b5051$var$LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function $b46ff7924e7b5051$var$suspenseSentinel() {
    return $b46ff7924e7b5051$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function $b46ff7924e7b5051$var$isSuspenseSentinel(value) {
    return value === $b46ff7924e7b5051$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: $b46ff7924e7b5051$var$isSuspenseSentinel,
    suspenseSentinel: $b46ff7924e7b5051$var$suspenseSentinel
};

});

parcelRegister("jZOVE", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $e8eb383e1e759cf3$var$_interopRequireDefault = $eGvGZ.default;

var $e8eb383e1e759cf3$var$_toConsumableArray2 = $e8eb383e1e759cf3$var$_interopRequireDefault((parcelRequire("aUSZ9")));

var $6TFlP = parcelRequire("6TFlP");


var $ceyF6 = parcelRequire("ceyF6");


var $hQyFA = parcelRequire("hQyFA");


var $q03Nf = parcelRequire("q03Nf");

var $e8eb383e1e759cf3$var$VARIABLE = $ceyF6.VARIABLE, $e8eb383e1e759cf3$var$LITERAL = $ceyF6.LITERAL, $e8eb383e1e759cf3$var$OBJECT_VALUE = $ceyF6.OBJECT_VALUE, $e8eb383e1e759cf3$var$LIST_VALUE = $ceyF6.LIST_VALUE;
var $e8eb383e1e759cf3$var$ERRORS_KEY = '__errors';
var $e8eb383e1e759cf3$var$MODULE_COMPONENT_KEY_PREFIX = '__module_component_';
var $e8eb383e1e759cf3$var$MODULE_OPERATION_KEY_PREFIX = '__module_operation_';
function $e8eb383e1e759cf3$var$getArgumentValue(arg, variables) {
    if (arg.kind === $e8eb383e1e759cf3$var$VARIABLE) return $e8eb383e1e759cf3$var$getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === $e8eb383e1e759cf3$var$LITERAL) return arg.value;
    else if (arg.kind === $e8eb383e1e759cf3$var$OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = $e8eb383e1e759cf3$var$getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === $e8eb383e1e759cf3$var$LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push($e8eb383e1e759cf3$var$getArgumentValue(item, variables));
        });
        return _value;
    }
}
function $e8eb383e1e759cf3$var$getArgumentValues(args, variables, isWithinUnmatchedTypeRefinement) {
    var values = {};
    if (isWithinUnmatchedTypeRefinement) values[$e8eb383e1e759cf3$var$RelayStoreUtils.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = true;
    if (args) args.forEach(function(arg) {
        values[arg.name] = $e8eb383e1e759cf3$var$getArgumentValue(arg, variables);
    });
    return values;
}
function $e8eb383e1e759cf3$var$getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = $6TFlP(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, $e8eb383e1e759cf3$var$_toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return $e8eb383e1e759cf3$var$formatStorageKey(handleName, $e8eb383e1e759cf3$var$getArgumentValues(filterArgs, variables));
}
function $e8eb383e1e759cf3$var$getStorageKey(field, variables) {
    if (field.storageKey) return field.storageKey;
    var args = $e8eb383e1e759cf3$var$getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? $e8eb383e1e759cf3$var$formatStorageKey(name, $e8eb383e1e759cf3$var$getArgumentValues(args, variables)) : name;
}
function $e8eb383e1e759cf3$var$getArguments(field) {
    if (field.kind === 'RelayResolver' || field.kind === 'RelayLiveResolver') {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === 'undefined' ? undefined : field.args;
    return args;
}
function $e8eb383e1e759cf3$var$getStableStorageKey(name, args) {
    return $e8eb383e1e759cf3$var$formatStorageKey(name, $hQyFA(args));
}
function $e8eb383e1e759cf3$var$formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ':' + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'undefined'));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(','), ")");
}
function $e8eb383e1e759cf3$var$getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && $q03Nf(false);
    return $hQyFA(variables[name]);
}
function $e8eb383e1e759cf3$var$getModuleComponentKey(documentName) {
    return "".concat($e8eb383e1e759cf3$var$MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function $e8eb383e1e759cf3$var$getModuleOperationKey(documentName) {
    return "".concat($e8eb383e1e759cf3$var$MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
var $e8eb383e1e759cf3$var$RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: '__actorIdentifier',
    CLIENT_EDGE_TRAVERSAL_PATH: '__clientEdgeTraversalPath',
    FRAGMENTS_KEY: '__fragments',
    FRAGMENT_OWNER_KEY: '__fragmentOwner',
    FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: '$isWithinUnmatchedTypeRefinement',
    FRAGMENT_PROP_NAME_KEY: '__fragmentPropName',
    MODULE_COMPONENT_KEY: '__module_component',
    ERRORS_KEY: $e8eb383e1e759cf3$var$ERRORS_KEY,
    ID_KEY: '__id',
    REF_KEY: '__ref',
    REFS_KEY: '__refs',
    ROOT_ID: 'client:root',
    ROOT_TYPE: '__Root',
    TYPENAME_KEY: '__typename',
    INVALIDATED_AT_KEY: '__invalidated_at',
    RELAY_RESOLVER_VALUE_KEY: '__resolverValue',
    RELAY_RESOLVER_INVALIDATION_KEY: '__resolverValueMayBeInvalid',
    RELAY_RESOLVER_SNAPSHOT_KEY: '__resolverSnapshot',
    RELAY_RESOLVER_ERROR_KEY: '__resolverError',
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: '__resolverOutputTypeRecordIDs',
    formatStorageKey: $e8eb383e1e759cf3$var$formatStorageKey,
    getArgumentValue: $e8eb383e1e759cf3$var$getArgumentValue,
    getArgumentValues: $e8eb383e1e759cf3$var$getArgumentValues,
    getHandleStorageKey: $e8eb383e1e759cf3$var$getHandleStorageKey,
    getStorageKey: $e8eb383e1e759cf3$var$getStorageKey,
    getStableStorageKey: $e8eb383e1e759cf3$var$getStableStorageKey,
    getModuleComponentKey: $e8eb383e1e759cf3$var$getModuleComponentKey,
    getModuleOperationKey: $e8eb383e1e759cf3$var$getModuleOperationKey
};
module.exports = $e8eb383e1e759cf3$var$RelayStoreUtils;

});

parcelRegister("eFVpV", function(module, exports) {
'use strict';
var $aaf16ee2fa454af3$var$RelayRecordState = {
    EXISTENT: 'EXISTENT',
    NONEXISTENT: 'NONEXISTENT',
    UNKNOWN: 'UNKNOWN'
};
module.exports = $aaf16ee2fa454af3$var$RelayRecordState;

});

parcelRegister("gf5pM", function(module, exports) {
'use strict';

var $q03Nf = parcelRequire("q03Nf");

var $bd323f4f49554f7f$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = 'INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE';
function $bd323f4f49554f7f$var$assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === $bd323f4f49554f7f$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && $q03Nf(false);
}
module.exports = {
    assertInternalActorIdentifier: $bd323f4f49554f7f$var$assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error('Not Implemented');
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: $bd323f4f49554f7f$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

});

parcelRegister("ceyF6", function(module, exports) {
'use strict';
var $8e81adffbcb67122$var$RelayConcreteNode = {
    ACTOR_CHANGE: 'ActorChange',
    CATCH_FIELD: 'CatchField',
    CONDITION: 'Condition',
    CLIENT_COMPONENT: 'ClientComponent',
    CLIENT_EDGE_TO_SERVER_OBJECT: 'ClientEdgeToServerObject',
    CLIENT_EDGE_TO_CLIENT_OBJECT: 'ClientEdgeToClientObject',
    CLIENT_EXTENSION: 'ClientExtension',
    DEFER: 'Defer',
    CONNECTION: 'Connection',
    FRAGMENT: 'Fragment',
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_DATA_FRAGMENT_SPREAD: 'InlineDataFragmentSpread',
    INLINE_DATA_FRAGMENT: 'InlineDataFragment',
    INLINE_FRAGMENT: 'InlineFragment',
    LINKED_FIELD: 'LinkedField',
    LINKED_HANDLE: 'LinkedHandle',
    LITERAL: 'Literal',
    LIST_VALUE: 'ListValue',
    LOCAL_ARGUMENT: 'LocalArgument',
    MODULE_IMPORT: 'ModuleImport',
    ALIASED_FRAGMENT_SPREAD: 'AliasedFragmentSpread',
    ALIASED_INLINE_FRAGMENT_SPREAD: 'AliasedInlineFragmentSpread',
    RELAY_RESOLVER: 'RelayResolver',
    RELAY_LIVE_RESOLVER: 'RelayLiveResolver',
    REQUIRED_FIELD: 'RequiredField',
    OBJECT_VALUE: 'ObjectValue',
    OPERATION: 'Operation',
    REQUEST: 'Request',
    ROOT_ARGUMENT: 'RootArgument',
    SCALAR_FIELD: 'ScalarField',
    SCALAR_HANDLE: 'ScalarHandle',
    SPLIT_OPERATION: 'SplitOperation',
    STREAM: 'Stream',
    TYPE_DISCRIMINATOR: 'TypeDiscriminator',
    UPDATABLE_QUERY: 'UpdatableQuery',
    VARIABLE: 'Variable'
};
module.exports = $8e81adffbcb67122$var$RelayConcreteNode;

});

parcelRegister("dMDnw", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $a08e4dcc0bbaacda$var$_interopRequireDefault = $eGvGZ.default;

var $a08e4dcc0bbaacda$var$_objectSpread2 = $a08e4dcc0bbaacda$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $jZOVE = parcelRequire("jZOVE");

var $a08e4dcc0bbaacda$var$getArgumentValues = $jZOVE.getArgumentValues;

var $q03Nf = parcelRequire("q03Nf");

function $a08e4dcc0bbaacda$var$getFragmentVariables(fragment, rootVariables, argumentVariables) {
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, $a08e4dcc0bbaacda$var$_objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case 'LocalArgument':
                variables[definition.name] = definition.defaultValue;
                break;
            case 'RootArgument':
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                $q03Nf(false);
        }
    });
    return variables || argumentVariables;
}
function $a08e4dcc0bbaacda$var$getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function $a08e4dcc0bbaacda$var$getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, $a08e4dcc0bbaacda$var$_objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? $a08e4dcc0bbaacda$var$getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: $a08e4dcc0bbaacda$var$getLocalVariables,
    getFragmentVariables: $a08e4dcc0bbaacda$var$getFragmentVariables,
    getOperationVariables: $a08e4dcc0bbaacda$var$getOperationVariables
};

});

parcelRegister("lBYAg", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $fbbc0c64b39ab40a$var$_interopRequireDefault = $eGvGZ.default;

var $fbbc0c64b39ab40a$var$_objectSpread2 = $fbbc0c64b39ab40a$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $fbbc0c64b39ab40a$var$_objectWithoutPropertiesLoose2 = $fbbc0c64b39ab40a$var$_interopRequireDefault((parcelRequire("6Ahnn")));

var $fbbc0c64b39ab40a$var$_createForOfIteratorHelper2 = $fbbc0c64b39ab40a$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $fbbc0c64b39ab40a$var$_inheritsLoose2 = $fbbc0c64b39ab40a$var$_interopRequireDefault((parcelRequire("lNM3R")));

var $fbbc0c64b39ab40a$var$_wrapNativeSuper2 = $fbbc0c64b39ab40a$var$_interopRequireDefault((parcelRequire("7w1RD")));

var $fbbc0c64b39ab40a$var$_toConsumableArray2 = $fbbc0c64b39ab40a$var$_interopRequireDefault((parcelRequire("aUSZ9")));
var $fbbc0c64b39ab40a$var$_excluded = [
    "path",
    "locations"
];

var $ek4t1 = parcelRequire("ek4t1");

var $fbbc0c64b39ab40a$var$SELF = Symbol('$SELF');
var $fbbc0c64b39ab40a$var$RelayFieldError = /*#__PURE__*/ function(_Error) {
    (0, $fbbc0c64b39ab40a$var$_inheritsLoose2["default"])(RelayFieldError, _Error);
    function RelayFieldError(message) {
        var _this;
        var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        _this = _Error.call(this, message) || this;
        _this.name = 'RelayFieldError';
        _this.message = message;
        _this.errors = errors;
        return _this;
    }
    return RelayFieldError;
}(/*#__PURE__*/ (0, $fbbc0c64b39ab40a$var$_wrapNativeSuper2["default"])(Error));
function $fbbc0c64b39ab40a$var$buildErrorTrie(errors) {
    if (errors == null) return null;
    if (!$ek4t1.ENABLE_FIELD_ERROR_HANDLING) return null;
    var trie = new Map();
    var _iterator = (0, $fbbc0c64b39ab40a$var$_createForOfIteratorHelper2["default"])(errors), _step;
    try {
        ERRORS: for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, path = _step$value.path, _ = _step$value.locations, error = (0, $fbbc0c64b39ab40a$var$_objectWithoutPropertiesLoose2["default"])(_step$value, $fbbc0c64b39ab40a$var$_excluded);
            if (path == null) continue;
            var length = path.length;
            if (length === 0) continue;
            var lastIndex = length - 1;
            var currentTrie = trie;
            for(var index = 0; index < lastIndex; index++){
                var key = path[index];
                var existingValue = currentTrie.get(key);
                if (existingValue instanceof Map) {
                    currentTrie = existingValue;
                    continue;
                }
                var newValue = new Map();
                if (Array.isArray(existingValue)) newValue.set($fbbc0c64b39ab40a$var$SELF, existingValue);
                currentTrie.set(key, newValue);
                currentTrie = newValue;
            }
            var lastKey = path[lastIndex];
            var container = currentTrie.get(lastKey);
            if (container instanceof Map) {
                currentTrie = container;
                container = currentTrie.get(lastKey);
                lastKey = $fbbc0c64b39ab40a$var$SELF;
            }
            if (Array.isArray(container)) container.push(error);
            else currentTrie.set(lastKey, [
                error
            ]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return trie;
}
function $fbbc0c64b39ab40a$var$getErrorsByKey(trie, key) {
    var value = trie.get(key);
    if (value == null) return null;
    if (Array.isArray(value)) return value;
    var errors = [];
    $fbbc0c64b39ab40a$var$recursivelyCopyErrorsIntoArray(value, errors);
    return errors;
}
function $fbbc0c64b39ab40a$var$recursivelyCopyErrorsIntoArray(trieOrSet, errors) {
    var _iterator2 = (0, $fbbc0c64b39ab40a$var$_createForOfIteratorHelper2["default"])(trieOrSet), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = _step2.value, childKey = _step2$value[0], value = _step2$value[1];
            var oldLength = errors.length;
            if (Array.isArray(value)) errors.push.apply(errors, (0, $fbbc0c64b39ab40a$var$_toConsumableArray2["default"])(value));
            else $fbbc0c64b39ab40a$var$recursivelyCopyErrorsIntoArray(value, errors);
            if (childKey === $fbbc0c64b39ab40a$var$SELF) continue;
            var newLength = errors.length;
            for(var index = oldLength; index < newLength; index++){
                var error = errors[index];
                if (error.path == null) errors[index] = (0, $fbbc0c64b39ab40a$var$_objectSpread2["default"])((0, $fbbc0c64b39ab40a$var$_objectSpread2["default"])({}, error), {}, {
                    path: [
                        childKey
                    ]
                });
                else error.path.unshift(childKey);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $fbbc0c64b39ab40a$var$getNestedErrorTrieByKey(trie, key) {
    var value = trie.get(key);
    if (value instanceof Map) return value;
    return null;
}
module.exports = {
    SELF: $fbbc0c64b39ab40a$var$SELF,
    buildErrorTrie: $fbbc0c64b39ab40a$var$buildErrorTrie,
    getNestedErrorTrieByKey: $fbbc0c64b39ab40a$var$getNestedErrorTrieByKey,
    getErrorsByKey: $fbbc0c64b39ab40a$var$getErrorsByKey,
    RelayFieldError: $fbbc0c64b39ab40a$var$RelayFieldError
};

});

parcelRegister("75e3H", function(module, exports) {
'use strict';

var $dMDnw = parcelRequire("dMDnw");

var $5283e7cb05cadf23$var$getFragmentVariables = $dMDnw.getFragmentVariables;

var $jZOVE = parcelRequire("jZOVE");

var $5283e7cb05cadf23$var$CLIENT_EDGE_TRAVERSAL_PATH = $jZOVE.CLIENT_EDGE_TRAVERSAL_PATH, $5283e7cb05cadf23$var$FRAGMENT_OWNER_KEY = $jZOVE.FRAGMENT_OWNER_KEY, $5283e7cb05cadf23$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $jZOVE.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, $5283e7cb05cadf23$var$FRAGMENTS_KEY = $jZOVE.FRAGMENTS_KEY, $5283e7cb05cadf23$var$ID_KEY = $jZOVE.ID_KEY;

var $8w3GE = parcelRequire("8w3GE");


var $q03Nf = parcelRequire("q03Nf");

parcelRequire("eEWwZ");

function $5283e7cb05cadf23$var$getSingularSelector(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $q03Nf(false);
    var dataID = item[$5283e7cb05cadf23$var$ID_KEY];
    var fragments = item[$5283e7cb05cadf23$var$FRAGMENTS_KEY];
    var mixedOwner = item[$5283e7cb05cadf23$var$FRAGMENT_OWNER_KEY];
    var mixedClientEdgeTraversalPath = item[$5283e7cb05cadf23$var$CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === 'string' && typeof fragments === 'object' && fragments !== null && typeof fragments[fragment.name] === 'object' && fragments[fragment.name] !== null && typeof mixedOwner === 'object' && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = $5283e7cb05cadf23$var$getFragmentVariables(fragment, owner.variables, argumentVariables);
        var isWithinUnmatchedTypeRefinement = argumentVariables[$5283e7cb05cadf23$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
        return $5283e7cb05cadf23$var$createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
function $5283e7cb05cadf23$var$getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? $5283e7cb05cadf23$var$getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: 'PluralReaderSelector',
        selectors: selectors
    };
}
function $5283e7cb05cadf23$var$getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $q03Nf(false);
        return $5283e7cb05cadf23$var$getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && $q03Nf(false);
        return $5283e7cb05cadf23$var$getSingularSelector(fragment, item);
    }
}
function $5283e7cb05cadf23$var$getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = $5283e7cb05cadf23$var$getSelector(fragment, item);
    }
    return selectors;
}
function $5283e7cb05cadf23$var$getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = $5283e7cb05cadf23$var$getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function $5283e7cb05cadf23$var$getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $q03Nf(false);
        return $5283e7cb05cadf23$var$getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && $q03Nf(false);
        return $5283e7cb05cadf23$var$getDataID(fragment, item);
    }
}
function $5283e7cb05cadf23$var$getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? $5283e7cb05cadf23$var$getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
function $5283e7cb05cadf23$var$getDataID(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $q03Nf(false);
    var dataID = item[$5283e7cb05cadf23$var$ID_KEY];
    if (typeof dataID === 'string') return dataID;
    return null;
}
function $5283e7cb05cadf23$var$getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = $5283e7cb05cadf23$var$getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function $5283e7cb05cadf23$var$getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && $q03Nf(false);
        return $5283e7cb05cadf23$var$getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && $q03Nf(false);
        return $5283e7cb05cadf23$var$getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function $5283e7cb05cadf23$var$getVariablesFromSingularFragment(fragment, item) {
    var selector = $5283e7cb05cadf23$var$getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function $5283e7cb05cadf23$var$getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = $5283e7cb05cadf23$var$getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function $5283e7cb05cadf23$var$areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && $8w3GE(thisSelector.variables, thatSelector.variables) && $5283e7cb05cadf23$var$areEqualOwners(thisSelector.owner, thatSelector.owner) && thisSelector.isWithinUnmatchedTypeRefinement === thatSelector.isWithinUnmatchedTypeRefinement && $5283e7cb05cadf23$var$areEqualClientEdgeTraversalPaths(thisSelector.clientEdgeTraversalPath, thatSelector.clientEdgeTraversalPath);
}
function $5283e7cb05cadf23$var$areEqualOwners(thisOwner, thatOwner) {
    if (thisOwner === thatOwner) return true;
    else return thisOwner.identifier === thatOwner.identifier && $8w3GE(thisOwner.cacheConfig, thatOwner.cacheConfig);
}
function $5283e7cb05cadf23$var$areEqualClientEdgeTraversalPaths(thisPath, thatPath) {
    if (thisPath === thatPath) return true;
    if (thisPath == null || thatPath == null || thisPath.length !== thatPath.length) return false;
    var idx = thisPath.length;
    while(idx--){
        var a = thisPath[idx];
        var b = thatPath[idx];
        if (a === b) continue;
        if (a == null || b == null || a.clientEdgeDestinationID !== b.clientEdgeDestinationID || a.readerClientEdge !== b.readerClientEdge) return false;
    }
    return true;
}
function $5283e7cb05cadf23$var$areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === 'SingularReaderSelector' && b.kind === 'SingularReaderSelector') return $5283e7cb05cadf23$var$areEqualSingularSelectors(a, b);
    else if (a.kind === 'PluralReaderSelector' && b.kind === 'PluralReaderSelector') return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return $5283e7cb05cadf23$var$areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function $5283e7cb05cadf23$var$createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: 'SingularReaderSelector',
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function $5283e7cb05cadf23$var$createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: $5283e7cb05cadf23$var$areEqualSelectors,
    createReaderSelector: $5283e7cb05cadf23$var$createReaderSelector,
    createNormalizationSelector: $5283e7cb05cadf23$var$createNormalizationSelector,
    getDataIDsFromFragment: $5283e7cb05cadf23$var$getDataIDsFromFragment,
    getDataIDsFromObject: $5283e7cb05cadf23$var$getDataIDsFromObject,
    getSingularSelector: $5283e7cb05cadf23$var$getSingularSelector,
    getPluralSelector: $5283e7cb05cadf23$var$getPluralSelector,
    getSelector: $5283e7cb05cadf23$var$getSelector,
    getSelectorsFromObject: $5283e7cb05cadf23$var$getSelectorsFromObject,
    getVariablesFromSingularFragment: $5283e7cb05cadf23$var$getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: $5283e7cb05cadf23$var$getVariablesFromPluralFragment,
    getVariablesFromFragment: $5283e7cb05cadf23$var$getVariablesFromFragment,
    getVariablesFromObject: $5283e7cb05cadf23$var$getVariablesFromObject
};

});

parcelRegister("a1r1h", function(module, exports) {
'use strict';
var $74bef4eb80a01680$var$PREFIX = 'client:__type:';
var $74bef4eb80a01680$var$TYPE_SCHEMA_TYPE = '__TypeSchema';
function $74bef4eb80a01680$var$generateTypeID(typeName) {
    return $74bef4eb80a01680$var$PREFIX + typeName;
}
function $74bef4eb80a01680$var$isTypeID(id) {
    return id.indexOf($74bef4eb80a01680$var$PREFIX) === 0;
}
module.exports = {
    generateTypeID: $74bef4eb80a01680$var$generateTypeID,
    isTypeID: $74bef4eb80a01680$var$isTypeID,
    TYPE_SCHEMA_TYPE: $74bef4eb80a01680$var$TYPE_SCHEMA_TYPE
};

});

parcelRegister("f8mcb", function(module, exports) {
'use strict';

var $42omo = parcelRequire("42omo");


var $3e6Uc = parcelRequire("3e6Uc");

var $b048d1f19b6994fd$var$createRelayContext = $3e6Uc.__internal.createRelayContext;
module.exports = $b048d1f19b6994fd$var$createRelayContext($42omo);

});

parcelRegister("fFePu", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $b676302b11e8f8cb$var$_interopRequireDefault = $eGvGZ.default;

var $b676302b11e8f8cb$var$_objectSpread2 = $b676302b11e8f8cb$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $b676302b11e8f8cb$var$_createForOfIteratorHelper2 = $b676302b11e8f8cb$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $b676302b11e8f8cb$var$_toConsumableArray2 = $b676302b11e8f8cb$var$_interopRequireDefault((parcelRequire("aUSZ9")));

var $lpjQw = parcelRequire("lpjQw");

var $b676302b11e8f8cb$var$getQueryResourceForEnvironment = $lpjQw.getQueryResourceForEnvironment;

var $amoBB = parcelRequire("amoBB");


var $q03Nf = parcelRequire("q03Nf");


var $42omo = parcelRequire("42omo");

var $b676302b11e8f8cb$var$useDebugValue = $42omo.useDebugValue, $b676302b11e8f8cb$var$useEffect = $42omo.useEffect, $b676302b11e8f8cb$var$useMemo = $42omo.useMemo, $b676302b11e8f8cb$var$useRef = $42omo.useRef, $b676302b11e8f8cb$var$useState = $42omo.useState;

var $3e6Uc = parcelRequire("3e6Uc");

var $b676302b11e8f8cb$var$_require3$__internal = $3e6Uc.__internal, $b676302b11e8f8cb$var$fetchQueryInternal = $b676302b11e8f8cb$var$_require3$__internal.fetchQuery, $b676302b11e8f8cb$var$getPromiseForActiveRequest = $b676302b11e8f8cb$var$_require3$__internal.getPromiseForActiveRequest, $b676302b11e8f8cb$var$RelayFeatureFlags = $3e6Uc.RelayFeatureFlags, $b676302b11e8f8cb$var$areEqualSelectors = $3e6Uc.areEqualSelectors, $b676302b11e8f8cb$var$createOperationDescriptor = $3e6Uc.createOperationDescriptor, $b676302b11e8f8cb$var$getPendingOperationsForFragment = $3e6Uc.getPendingOperationsForFragment, $b676302b11e8f8cb$var$getSelector = $3e6Uc.getSelector, $b676302b11e8f8cb$var$getVariablesFromFragment = $3e6Uc.getVariablesFromFragment, $b676302b11e8f8cb$var$handlePotentialSnapshotErrors = $3e6Uc.handlePotentialSnapshotErrors, $b676302b11e8f8cb$var$recycleNodesInto = $3e6Uc.recycleNodesInto;
parcelRequire("eEWwZ");

function $b676302b11e8f8cb$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $b676302b11e8f8cb$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $b676302b11e8f8cb$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $b676302b11e8f8cb$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $b676302b11e8f8cb$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $b676302b11e8f8cb$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $b676302b11e8f8cb$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $b676302b11e8f8cb$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') {
        var _state$snapshot$selec, _state$snapshot$selec2;
        $b676302b11e8f8cb$var$handlePotentialSnapshotErrors(environment, state.snapshot.missingRequiredFields, state.snapshot.relayResolverErrors, state.snapshot.errorResponseFields, (_state$snapshot$selec = (_state$snapshot$selec2 = state.snapshot.selector.node.metadata) === null || _state$snapshot$selec2 === void 0 ? void 0 : _state$snapshot$selec2.throwOnFieldError) !== null && _state$snapshot$selec !== void 0 ? _state$snapshot$selec : false);
    } else if (state.kind === 'plural') {
        var _iterator5 = (0, $b676302b11e8f8cb$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _snapshot$selector$no, _snapshot$selector$no2;
                var snapshot = _step5.value;
                $b676302b11e8f8cb$var$handlePotentialSnapshotErrors(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_snapshot$selector$no = (_snapshot$selector$no2 = snapshot.selector.node.metadata) === null || _snapshot$selector$no2 === void 0 ? void 0 : _snapshot$selector$no2.throwOnFieldError) !== null && _snapshot$selector$no !== void 0 ? _snapshot$selector$no : false);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $b676302b11e8f8cb$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $b676302b11e8f8cb$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            missingRequiredFields: currentSnapshot.missingRequiredFields,
            relayResolverErrors: currentSnapshot.relayResolverErrors,
            errorResponseFields: currentSnapshot.errorResponseFields
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $b676302b11e8f8cb$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                missingRequiredFields: _currentSnapshot.missingRequiredFields,
                relayResolverErrors: _currentSnapshot.relayResolverErrors,
                errorResponseFields: _currentSnapshot.errorResponseFields
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $q03Nf(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch
            }
        ];
    }
}
function $b676302b11e8f8cb$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $b676302b11e8f8cb$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $b676302b11e8f8cb$var$_objectSpread2["default"])((0, $b676302b11e8f8cb$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $b676302b11e8f8cb$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $b676302b11e8f8cb$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $b676302b11e8f8cb$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        $b676302b11e8f8cb$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function $b676302b11e8f8cb$var$subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector) {
                    var updates = $b676302b11e8f8cb$var$handleMissedUpdates(environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], nextState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        hasPendingStateChanges.current = dataChanged;
                        return dataChanged ? nextState : prevState;
                    } else return prevState;
                }
                hasPendingStateChanges.current = true;
                return {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch()
                };
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
                        var updates = $b676302b11e8f8cb$var$handleMissedUpdates(environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], nextState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                            return dataChanged ? nextState : prevState;
                        } else return prevState;
                    }
                    var updated = (0, $b676302b11e8f8cb$var$_toConsumableArray2["default"])(prevState.snapshots);
                    updated[index] = latestSnapshot;
                    hasPendingStateChanges.current = true;
                    return {
                        kind: 'plural',
                        snapshots: updated,
                        epoch: environment.getStore().getEpoch()
                    };
                });
            });
        });
        return function() {
            var _iterator6 = (0, $b676302b11e8f8cb$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $b676302b11e8f8cb$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch()
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $b676302b11e8f8cb$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $b676302b11e8f8cb$var$useMemo(function() {
        return $b676302b11e8f8cb$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $q03Nf(false);
    else !!Array.isArray(fragmentRef) && $q03Nf(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $q03Nf(false);
    var environment = $amoBB();
    var _useState = $b676302b11e8f8cb$var$useState(function() {
        return $b676302b11e8f8cb$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = $b676302b11e8f8cb$var$useState(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = $b676302b11e8f8cb$var$useState(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = $b676302b11e8f8cb$var$useState(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!$b676302b11e8f8cb$var$areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
        setPreviousFragmentSelector(fragmentSelector);
        setPreviousEnvironment(environment);
        var newState = $b676302b11e8f8cb$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        setSubscribedState(newState);
        state = newState;
        subscribedState = newState;
    }
    var committedFragmentSelectorRef = $b676302b11e8f8cb$var$useRef(false);
    $b676302b11e8f8cb$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var _useMemo = $b676302b11e8f8cb$var$useMemo(function() {
            var missingClientEdges = $b676302b11e8f8cb$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $b676302b11e8f8cb$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $b676302b11e8f8cb$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        $b676302b11e8f8cb$var$useEffect(function() {
            var QueryResource = $b676302b11e8f8cb$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $b676302b11e8f8cb$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    var _iterator9 = (0, $b676302b11e8f8cb$var$_createForOfIteratorHelper2["default"])(disposables), _step9;
                    try {
                        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
                            var disposable = _step9.value;
                            disposable.dispose();
                        }
                    } catch (err) {
                        _iterator9.e(err);
                    } finally{
                        _iterator9.f();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($b676302b11e8f8cb$var$isMissingData(state)) {
        var suspendingLiveResolvers = $b676302b11e8f8cb$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(_ref) {
            var liveStateID = _ref.liveStateID;
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if ($b676302b11e8f8cb$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$b676302b11e8f8cb$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $q03Nf(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $b676302b11e8f8cb$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $b676302b11e8f8cb$var$handlePotentialSnapshotErrorsForState(environment, state);
    var hasPendingStateChanges = $b676302b11e8f8cb$var$useRef(false);
    $b676302b11e8f8cb$var$useEffect(function() {
        var currentState = subscribedState;
        var updates = $b676302b11e8f8cb$var$handleMissedUpdates(environment, subscribedState);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) setState(updatedState);
            currentState = updatedState;
        }
        return $b676302b11e8f8cb$var$subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [
        environment,
        subscribedState
    ]);
    if (hasPendingStateChanges.current) {
        var updates = $b676302b11e8f8cb$var$handleMissedUpdates(environment, state);
        if (updates != null) {
            var hasStateUpdates = updates[0], updatedState = updates[1];
            if (hasStateUpdates) {
                setState(updatedState);
                state = updatedState;
            }
        }
        hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $b676302b11e8f8cb$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $q03Nf(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $q03Nf(false);
        data = state.snapshot.data;
    }
    if ($b676302b11e8f8cb$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $b676302b11e8f8cb$var$useFragmentInternal;

});

parcelRegister("CsC3I", function(module, exports) {
'use strict';

var $42omo = parcelRequire("42omo");

var $0739bea43041660c$var$useMemo = $42omo.useMemo;
function $0739bea43041660c$var$useUnsafeRef_DEPRECATED(init) {
    return $0739bea43041660c$var$useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = $0739bea43041660c$var$useUnsafeRef_DEPRECATED;

});

parcelRegister("4QlpF", function(module, exports) {
'use strict';

var $42omo = parcelRequire("42omo");

var $386ca0f238dcef45$var$useEffect = $42omo.useEffect, $386ca0f238dcef45$var$useRef = $42omo.useRef;
function $386ca0f238dcef45$var$useIsMountedRef() {
    var isMountedRef = $386ca0f238dcef45$var$useRef(true);
    $386ca0f238dcef45$var$useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = $386ca0f238dcef45$var$useIsMountedRef;

});

parcelRegister("gGM3K", function(module, exports) {
'use strict';

var $CsC3I = parcelRequire("CsC3I");


var $42omo = parcelRequire("42omo");

var $c265d92da86ceaab$var$useCallback = $42omo.useCallback, $c265d92da86ceaab$var$useEffect = $42omo.useEffect;
function $c265d92da86ceaab$var$useFetchTrackingRef() {
    var subscriptionRef = $CsC3I(null);
    var isFetchingRef = $CsC3I(false);
    var disposeFetch = $c265d92da86ceaab$var$useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = $c265d92da86ceaab$var$useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = $c265d92da86ceaab$var$useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    $c265d92da86ceaab$var$useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = $c265d92da86ceaab$var$useFetchTrackingRef;

});

parcelRegister("lpjQw", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $f95b53c7380a2af5$var$_interopRequireDefault = $eGvGZ.default;

var $f95b53c7380a2af5$var$_objectSpread2 = $f95b53c7380a2af5$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $f95b53c7380a2af5$var$_defineProperty2 = $f95b53c7380a2af5$var$_interopRequireDefault((parcelRequire("l2SD1")));

var $kfQ2W = parcelRequire("kfQ2W");


var $aB7rE = parcelRequire("aB7rE");


var $q03Nf = parcelRequire("q03Nf");


var $3e6Uc = parcelRequire("3e6Uc");

var $f95b53c7380a2af5$var$isPromise = $3e6Uc.isPromise;
parcelRequire("eEWwZ");

var $f95b53c7380a2af5$var$CACHE_CAPACITY = 1000;
var $f95b53c7380a2af5$var$DEFAULT_FETCH_POLICY = 'store-or-network';
var $f95b53c7380a2af5$var$DEFAULT_LIVE_FETCH_POLICY = 'store-and-network';
var $f95b53c7380a2af5$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
function $f95b53c7380a2af5$var$operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function $f95b53c7380a2af5$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $f95b53c7380a2af5$var$operationIsLiveQuery(operation) ? $f95b53c7380a2af5$var$DEFAULT_LIVE_FETCH_POLICY : $f95b53c7380a2af5$var$DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function $f95b53c7380a2af5$var$getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $f95b53c7380a2af5$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var $f95b53c7380a2af5$var$nextID = 200000;
function $f95b53c7380a2af5$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = $f95b53c7380a2af5$var$operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new $aB7rE(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: $f95b53c7380a2af5$var$nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var $f95b53c7380a2af5$var$QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, $f95b53c7380a2af5$var$_defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = $kfQ2W.create($f95b53c7380a2af5$var$CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = $f95b53c7380a2af5$var$getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $f95b53c7380a2af5$var$operationIsLiveQuery(operation) ? $f95b53c7380a2af5$var$DEFAULT_LIVE_FETCH_POLICY : $f95b53c7380a2af5$var$DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, $f95b53c7380a2af5$var$_objectSpread2["default"])((0, $f95b53c7380a2af5$var$_objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if ($f95b53c7380a2af5$var$isPromise(cachedValue)) {
            environment.__log({
                name: 'suspense.query',
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if (cachedValue instanceof Error) throw cachedValue;
        return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: 'queryresource.retain',
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = $f95b53c7380a2af5$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = $f95b53c7380a2af5$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === 'available';
        var canPartialRender = hasFullQuery || renderPolicy === 'partial' && queryStatus !== 'stale';
        var shouldFetch;
        var shouldAllowRender;
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case 'store-only':
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case 'store-or-network':
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case 'store-and-network':
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case 'network-only':
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        if (shouldAllowRender) {
            var queryResult = $f95b53c7380a2af5$var$getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = $f95b53c7380a2af5$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = $f95b53c7380a2af5$var$getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, $f95b53c7380a2af5$var$_objectSpread2["default"])((0, $f95b53c7380a2af5$var$_objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                if ($f95b53c7380a2af5$var$operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                networkPromise.displayName = 'Relay(' + operation.fragment.node.name + ')';
                _cacheEntry2 = $f95b53c7380a2af5$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && $q03Nf(false);
        environment.__log({
            name: 'queryresource.fetch',
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function $f95b53c7380a2af5$var$createQueryResource(environment) {
    return new $f95b53c7380a2af5$var$QueryResourceImpl(environment);
}
var $f95b53c7380a2af5$var$dataResources = $f95b53c7380a2af5$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $f95b53c7380a2af5$var$getQueryResourceForEnvironment(environment) {
    var cached = $f95b53c7380a2af5$var$dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = $f95b53c7380a2af5$var$createQueryResource(environment);
    $f95b53c7380a2af5$var$dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: $f95b53c7380a2af5$var$createQueryResource,
    getQueryResourceForEnvironment: $f95b53c7380a2af5$var$getQueryResourceForEnvironment,
    getQueryCacheIdentifier: $f95b53c7380a2af5$var$getQueryCacheIdentifier
};

});

parcelRegister("4MqaE", function(module, exports) {
'use strict';
parcelRequire("CsC3I");

parcelRequire("eEWwZ");

function $37aff21b4d1318de$var$useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = $37aff21b4d1318de$var$useStaticFragmentNodeWarning;

});

parcelRegister("e3rvE", function(module, exports) {
'use strict';

var $c2Tw9 = parcelRequire("c2Tw9");


var $lpjQw = parcelRequire("lpjQw");

var $a3b6af56d3824486$var$getQueryCacheIdentifier = $lpjQw.getQueryCacheIdentifier, $a3b6af56d3824486$var$getQueryResourceForEnvironment = $lpjQw.getQueryResourceForEnvironment;

var $gGM3K = parcelRequire("gGM3K");


var $fFePu = parcelRequire("fFePu");


var $amoBB = parcelRequire("amoBB");


var $42omo = parcelRequire("42omo");

var $a3b6af56d3824486$var$useContext = $42omo.useContext, $a3b6af56d3824486$var$useEffect = $42omo.useEffect, $a3b6af56d3824486$var$useState = $42omo.useState, $a3b6af56d3824486$var$useRef = $42omo.useRef;
function $a3b6af56d3824486$var$useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = $amoBB();
    var profilerContext = $a3b6af56d3824486$var$useContext($c2Tw9);
    var QueryResource = $a3b6af56d3824486$var$getQueryResourceForEnvironment(environment);
    var _useState = $a3b6af56d3824486$var$useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = $gGM3K(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : '');
    var cacheIdentifier = $a3b6af56d3824486$var$getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
            start: startFetch,
            complete: completeFetch,
            error: completeFetch
        }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = $a3b6af56d3824486$var$useRef(false);
    $a3b6af56d3824486$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $a3b6af56d3824486$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    }, [
        environment,
        cacheIdentifier
    ]);
    $a3b6af56d3824486$var$useEffect(function() {
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var data = $fFePu(fragmentNode, fragmentRef, componentDisplayName);
    return data;
}
module.exports = $a3b6af56d3824486$var$useLazyLoadQueryNode;

});

parcelRegister("76FYg", function(module, exports) {
'use strict';

var $7UGaB = parcelRequire("7UGaB");


var $42omo = parcelRequire("42omo");


var $3e6Uc = parcelRequire("3e6Uc");

var $52c9a6873e38588c$var$createOperationDescriptor = $3e6Uc.createOperationDescriptor, $52c9a6873e38588c$var$getRequest = $3e6Uc.getRequest;
var $52c9a6873e38588c$var$useMemo = $42omo.useMemo;
function $52c9a6873e38588c$var$useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = $7UGaB(variables);
    var memoCacheConfig = $7UGaB(cacheConfig || {});
    return $52c9a6873e38588c$var$useMemo(function() {
        return $52c9a6873e38588c$var$createOperationDescriptor($52c9a6873e38588c$var$getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = $52c9a6873e38588c$var$useMemoOperationDescriptor;

});

parcelRegister("8g1lf", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $6030dbcaf8c7f5f7$var$_interopRequireDefault = $eGvGZ.default;

var $6030dbcaf8c7f5f7$var$_objectSpread2 = $6030dbcaf8c7f5f7$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $c2Tw9 = parcelRequire("c2Tw9");


var $lpjQw = parcelRequire("lpjQw");

var $6030dbcaf8c7f5f7$var$getQueryResourceForEnvironment = $lpjQw.getQueryResourceForEnvironment;

var $eBXBf = parcelRequire("eBXBf");


var $fFePu = parcelRequire("fFePu");


var $4QlpF = parcelRequire("4QlpF");


var $2g3bG = parcelRequire("2g3bG");


var $amoBB = parcelRequire("amoBB");


var $q03Nf = parcelRequire("q03Nf");


var $42omo = parcelRequire("42omo");

var $6030dbcaf8c7f5f7$var$useCallback = $42omo.useCallback, $6030dbcaf8c7f5f7$var$useContext = $42omo.useContext, $6030dbcaf8c7f5f7$var$useReducer = $42omo.useReducer;

var $3e6Uc = parcelRequire("3e6Uc");

var $6030dbcaf8c7f5f7$var$fetchQuery = $3e6Uc.__internal.fetchQuery, $6030dbcaf8c7f5f7$var$createOperationDescriptor = $3e6Uc.createOperationDescriptor, $6030dbcaf8c7f5f7$var$getFragmentIdentifier = $3e6Uc.getFragmentIdentifier, $6030dbcaf8c7f5f7$var$getRefetchMetadata = $3e6Uc.getRefetchMetadata, $6030dbcaf8c7f5f7$var$getSelector = $3e6Uc.getSelector, $6030dbcaf8c7f5f7$var$getValueAtPath = $3e6Uc.getValueAtPath;
parcelRequire("eEWwZ");

function $6030dbcaf8c7f5f7$var$reducer(state, action) {
    switch(action.type){
        case 'refetch':
            var _action$refetchEnviro;
            return (0, $6030dbcaf8c7f5f7$var$_objectSpread2["default"])((0, $6030dbcaf8c7f5f7$var$_objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case 'reset':
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error('useRefetchableFragmentNode: Unexpected action type');
    }
}
function $6030dbcaf8c7f5f7$var$useRefetchableFragmentNode(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = $amoBB();
    var _getRefetchMetadata = $6030dbcaf8c7f5f7$var$getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = $6030dbcaf8c7f5f7$var$getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = $6030dbcaf8c7f5f7$var$useReducer($6030dbcaf8c7f5f7$var$reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = $6030dbcaf8c7f5f7$var$getQueryResourceForEnvironment(environment);
    var profilerContext = $6030dbcaf8c7f5f7$var$useContext($c2Tw9);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = $2g3bG(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            type: 'reset',
            environment: environment,
            fragmentIdentifier: fragmentIdentifier
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        var fetchObservable = queryRef.source != null ? queryRef.source : $6030dbcaf8c7f5f7$var$fetchQuery(environment, refetchQuery);
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                error: handleQueryCompleted,
                complete: function complete() {
                    handleQueryCompleted();
                }
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = $eBXBf(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && $q03Nf(false);
        var refetchedFragmentRef = $6030dbcaf8c7f5f7$var$getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    var fragmentData = $fFePu(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = $6030dbcaf8c7f5f7$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch
    };
}
function $6030dbcaf8c7f5f7$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = $4QlpF();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    return $6030dbcaf8c7f5f7$var$useCallback(function(providedRefetchVariables, options) {
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = $6030dbcaf8c7f5f7$var$getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === 'PluralReaderSelector') {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        var refetchVariables = (0, $6030dbcaf8c7f5f7$var$_objectSpread2["default"])((0, $6030dbcaf8c7f5f7$var$_objectSpread2["default"])((0, $6030dbcaf8c7f5f7$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
            typeof identifierValue;
            refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var refetchQuery = $6030dbcaf8c7f5f7$var$createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        loadQuery(refetchQuery.request.variables, {
            fetchPolicy: fetchPolicy,
            __environment: refetchEnvironment,
            __nameForWarning: 'refetch'
        });
        dispatch({
            type: 'refetch',
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy
        });
        return {
            dispose: disposeQuery
        };
    }, [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var $6030dbcaf8c7f5f7$var$debugFunctions;
module.exports = $6030dbcaf8c7f5f7$var$useRefetchableFragmentNode;

});

parcelRegister("3QIlf", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dee474472bdb4825$export$6ae4df695e19c5 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(()=>false);
$dee474472bdb4825$export$6ae4df695e19c5.displayName = 'KnownErrorBoundaryContext';
module.exports["KnownErrorBoundaryContext"] = $dee474472bdb4825$export$6ae4df695e19c5;

});

parcelRegister("d4U2f", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $c3Qwv = parcelRequire("c3Qwv");

/* eslint-disable import/dynamic-import-chunkname */ 

















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































const $53ca2ee1a59d82f1$export$8c20ab16ac9cf14f = (locale)=>{
    // en-ZZ is a special locale used for locate translation strings. Real user won't see it.
    // Split the condition statements so webpack can remove the whole thing when compiling for SSR
    // SSR doesn't have splits this file will make the ssr-app significantly bigger
    if (locale === 'en-ZZ') return [
        (parcelRequire("lKRGI")),
        (parcelRequire("jJa9X")),
        (parcelRequire("byL3E")),
        (parcelRequire("jBneR")),
        (parcelRequire("i9aRg")),
        (parcelRequire("25lVW")),
        (parcelRequire("ksGWf")),
        (parcelRequire("aR9ep")),
        (parcelRequire("gSJcL")),
        (parcelRequire("1ncQy")),
        (parcelRequire("9ncev")),
        (parcelRequire("kafcO")),
        (parcelRequire("dShyO")),
        (parcelRequire("7GlmA")),
        (parcelRequire("9d2Gs")),
        (parcelRequire("1j4bG")),
        (parcelRequire("9Ja0P")),
        (parcelRequire("kRsvf")),
        (parcelRequire("2kKla")),
        (parcelRequire("6Hi6c")),
        (parcelRequire("6ZgSe")),
        (parcelRequire("7zwKU")),
        (parcelRequire("dBhWl")),
        (parcelRequire("25Pzt")),
        (parcelRequire("5vkLT")),
        (parcelRequire("4P1nf")),
        (parcelRequire("vW363")),
        (parcelRequire("4nN3W")),
        (parcelRequire("3jDyq")),
        (parcelRequire("kDXpa")),
        (parcelRequire("heetv")),
        (parcelRequire("4SDkZ")),
        (parcelRequire("6lfP8")),
        (parcelRequire("bhBKd")),
        (parcelRequire("4iAbq")),
        (parcelRequire("5SxZH")),
        (parcelRequire("85COw")),
        (parcelRequire("d9OHC")),
        (parcelRequire("d02bW")),
        (parcelRequire("8HW2u")),
        (parcelRequire("7Oob2")),
        (parcelRequire("b7k1w")),
        (parcelRequire("8LKOI")),
        (parcelRequire("43Xkp")),
        (parcelRequire("lVEhc")),
        (parcelRequire("aGgqX")),
        (parcelRequire("fouQR")),
        (parcelRequire("aZrhv")),
        (parcelRequire("1wpD8"))
    ];
    switch(locale){
        case 'fr-FR':
            return [
                (parcelRequire("bQCsy")),
                (parcelRequire("cIdVA")),
                (parcelRequire("1EwpP")),
                (parcelRequire("5AXwb")),
                (parcelRequire("64ipj")),
                (parcelRequire("gQp1P")),
                (parcelRequire("caRTX")),
                (parcelRequire("6OyGQ")),
                (parcelRequire("8fs7c")),
                (parcelRequire("cvRbd")),
                (parcelRequire("9dBYl")),
                (parcelRequire("3srrQ")),
                (parcelRequire("fRxL7")),
                (parcelRequire("6cJme")),
                (parcelRequire("70MHg")),
                (parcelRequire("6zV8W")),
                (parcelRequire("5N98w")),
                (parcelRequire("b6gTp")),
                (parcelRequire("1x1Bp")),
                (parcelRequire("6Q0A2")),
                (parcelRequire("4dt5q")),
                (parcelRequire("8rUdF")),
                (parcelRequire("Bnums")),
                (parcelRequire("8xnwm")),
                (parcelRequire("hu7fb")),
                (parcelRequire("2j2vD")),
                (parcelRequire("c600P")),
                (parcelRequire("jSOD3")),
                (parcelRequire("88Z56")),
                (parcelRequire("93WMc")),
                (parcelRequire("59TZ0")),
                (parcelRequire("j6WqW")),
                (parcelRequire("103gp")),
                (parcelRequire("dBUQx")),
                (parcelRequire("awVjk")),
                (parcelRequire("9Fn1Y")),
                (parcelRequire("d63Ye")),
                (parcelRequire("8wNYI")),
                (parcelRequire("j7h7l")),
                (parcelRequire("bAC7W")),
                (parcelRequire("Mk6iP")),
                (parcelRequire("lhr39")),
                (parcelRequire("aDBvo")),
                (parcelRequire("8CLA3")),
                (parcelRequire("aMKDm")),
                (parcelRequire("11b9v")),
                (parcelRequire("6Lzfk")),
                (parcelRequire("4uy4d")),
                (parcelRequire("5kWzc")),
                (parcelRequire("fwmTr"))
            ];
        case 'de-DE':
            return [
                (parcelRequire("ant2c")),
                (parcelRequire("fc4je")),
                (parcelRequire("aq1Eq")),
                (parcelRequire("dUpVF")),
                (parcelRequire("lFZTV")),
                (parcelRequire("b91Om")),
                (parcelRequire("kRP4O")),
                (parcelRequire("fFuqn")),
                (parcelRequire("c6G5D")),
                (parcelRequire("4p46Z")),
                (parcelRequire("jqDvG")),
                (parcelRequire("5kyZB")),
                (parcelRequire("kfOaY")),
                (parcelRequire("9fnZO")),
                (parcelRequire("dCntC")),
                (parcelRequire("5OcxY")),
                (parcelRequire("cIGUw")),
                (parcelRequire("9pxxR")),
                (parcelRequire("22KPu")),
                (parcelRequire("hM6ew")),
                (parcelRequire("eLqUQ")),
                (parcelRequire("6XJHZ")),
                (parcelRequire("c7V0X")),
                (parcelRequire("5VPPI")),
                (parcelRequire("jGyoB")),
                (parcelRequire("12EHY")),
                (parcelRequire("9Bk5u")),
                (parcelRequire("gq8Xj")),
                (parcelRequire("RYO6Q")),
                (parcelRequire("1aYnM")),
                (parcelRequire("7s4Gp")),
                (parcelRequire("4Qjsa")),
                (parcelRequire("8xC7R")),
                (parcelRequire("gUE67")),
                (parcelRequire("6im8C")),
                (parcelRequire("kQzCW")),
                (parcelRequire("5RcRV")),
                (parcelRequire("aavdM")),
                (parcelRequire("5XnXI")),
                (parcelRequire("fSlKh")),
                (parcelRequire("2fhU5")),
                (parcelRequire("9q1e5")),
                (parcelRequire("24c8C")),
                (parcelRequire("hRU4W")),
                (parcelRequire("6QI6Z")),
                (parcelRequire("1gxq9")),
                (parcelRequire("eKFPk")),
                (parcelRequire("gthL6")),
                (parcelRequire("6tnhg")),
                (parcelRequire("h5I7u"))
            ];
        case 'ja-JP':
            return [
                (parcelRequire("5COaO")),
                (parcelRequire("hvX00")),
                (parcelRequire("kqu9A")),
                (parcelRequire("fkwqh")),
                (parcelRequire("6JizP")),
                (parcelRequire("fVT8P")),
                (parcelRequire("fpPp8")),
                (parcelRequire("kYDpE")),
                (parcelRequire("knkpn")),
                (parcelRequire("gLkBH")),
                (parcelRequire("gCqQJ")),
                (parcelRequire("1RReW")),
                (parcelRequire("b9WlS")),
                (parcelRequire("i5adi")),
                (parcelRequire("llCCX")),
                (parcelRequire("dnSJ9")),
                (parcelRequire("8Mgtj")),
                (parcelRequire("2pTEE")),
                (parcelRequire("jpv7D")),
                (parcelRequire("h9yAS")),
                (parcelRequire("2rhuV")),
                (parcelRequire("lAtht")),
                (parcelRequire("iDOtR")),
                (parcelRequire("ftF7U")),
                (parcelRequire("ddghb")),
                (parcelRequire("dVqdf")),
                (parcelRequire("6rLAU")),
                (parcelRequire("6HgQ9")),
                (parcelRequire("eEYqK")),
                (parcelRequire("2YQCO")),
                (parcelRequire("8wO31")),
                (parcelRequire("bDOTt")),
                (parcelRequire("04IYy")),
                (parcelRequire("hXuM9")),
                (parcelRequire("4sZ5E")),
                (parcelRequire("dGePy")),
                (parcelRequire("d5n8x")),
                (parcelRequire("ixiPm")),
                (parcelRequire("isYwl")),
                (parcelRequire("54x7S")),
                (parcelRequire("3MBDQ")),
                (parcelRequire("1xHL2")),
                (parcelRequire("2Dl1E")),
                (parcelRequire("6Vhav")),
                (parcelRequire("f4foO")),
                (parcelRequire("cbfay")),
                (parcelRequire("fwORh")),
                (parcelRequire("e1vQv")),
                (parcelRequire("l9hgx")),
                (parcelRequire("dJEql"))
            ];
        case 'es-ES':
            return [
                (parcelRequire("dn93j")),
                (parcelRequire("9weE3")),
                (parcelRequire("4ItCw")),
                (parcelRequire("eRefA")),
                (parcelRequire("hhFaw")),
                (parcelRequire("c8wt5")),
                (parcelRequire("ksp6c")),
                (parcelRequire("eknul")),
                (parcelRequire("d2WOP")),
                (parcelRequire("4EtrO")),
                (parcelRequire("lapQH")),
                (parcelRequire("iew7M")),
                (parcelRequire("3NEgH")),
                (parcelRequire("ksebp")),
                (parcelRequire("lF2vA")),
                (parcelRequire("iJ9Jb")),
                (parcelRequire("5kZ9D")),
                (parcelRequire("lXdTE")),
                (parcelRequire("b5Ihu")),
                (parcelRequire("80lc4")),
                (parcelRequire("5VQ9X")),
                (parcelRequire("kqX74")),
                (parcelRequire("3QlSH")),
                (parcelRequire("kPOaW")),
                (parcelRequire("4Xxhw")),
                (parcelRequire("8WSpN")),
                (parcelRequire("i8KLr")),
                (parcelRequire("2oMfn")),
                (parcelRequire("1zI6L")),
                (parcelRequire("758zj")),
                (parcelRequire("1ryZM")),
                (parcelRequire("emb1U")),
                (parcelRequire("1KR1V")),
                (parcelRequire("jLp8w")),
                (parcelRequire("9YYuu")),
                (parcelRequire("6Wi7n")),
                (parcelRequire("3Dfxg")),
                (parcelRequire("iiP4O")),
                (parcelRequire("9NBbq")),
                (parcelRequire("64jNc")),
                (parcelRequire("t5OKm")),
                (parcelRequire("kNrlR")),
                (parcelRequire("cCQYk")),
                (parcelRequire("bdNA6")),
                (parcelRequire("gCd0U")),
                (parcelRequire("dWGPI")),
                (parcelRequire("gPm8e")),
                (parcelRequire("1k62a"))
            ];
        case 'ko-KR':
            return [
                (parcelRequire("k21Jj")),
                (parcelRequire("01PkK")),
                (parcelRequire("cqYa4")),
                (parcelRequire("dP1Ki")),
                (parcelRequire("hscz1")),
                (parcelRequire("4QSiG")),
                (parcelRequire("9sB5X")),
                (parcelRequire("2fyIl")),
                (parcelRequire("178Ja")),
                (parcelRequire("lIQA8")),
                (parcelRequire("52OQT")),
                (parcelRequire("hOfip")),
                (parcelRequire("R9hyw")),
                (parcelRequire("fSiBm")),
                (parcelRequire("cAlfu")),
                (parcelRequire("iNn3k")),
                (parcelRequire("euUEL")),
                (parcelRequire("3Mi1u")),
                (parcelRequire("6tl5d")),
                (parcelRequire("bDyHb")),
                (parcelRequire("kMRbA")),
                (parcelRequire("kjbMO")),
                (parcelRequire("gUzRE")),
                (parcelRequire("685kr")),
                (parcelRequire("gfGbG")),
                (parcelRequire("3TGTI")),
                (parcelRequire("kqqmc")),
                (parcelRequire("i8ppi")),
                (parcelRequire("9DzvR")),
                (parcelRequire("hF2LE")),
                (parcelRequire("hvV6G")),
                (parcelRequire("fPtyC")),
                (parcelRequire("8qjyp")),
                (parcelRequire("lR6hc")),
                (parcelRequire("dNTKH")),
                (parcelRequire("bAwwv")),
                (parcelRequire("1jtdV")),
                (parcelRequire("3fpTR")),
                (parcelRequire("8qqCf")),
                (parcelRequire("2nSdZ")),
                (parcelRequire("feERk")),
                (parcelRequire("fkIJN")),
                (parcelRequire("4mS0j")),
                (parcelRequire("2r0ky")),
                (parcelRequire("3cUfk")),
                (parcelRequire("8VNhj")),
                (parcelRequire("d9uo9")),
                (parcelRequire("iT4kI")),
                (parcelRequire("ev9yT")),
                (parcelRequire("863q1"))
            ];
        case 'pt-BR':
            return [
                (parcelRequire("7KEdW")),
                (parcelRequire("kdBqJ")),
                (parcelRequire("dluhI")),
                (parcelRequire("3wULy")),
                (parcelRequire("hAOSE")),
                (parcelRequire("aZqBU")),
                (parcelRequire("6hemr")),
                (parcelRequire("6PDRB")),
                (parcelRequire("6Lo6W")),
                (parcelRequire("7ZOwR")),
                (parcelRequire("bcOcq")),
                (parcelRequire("h3DUz")),
                (parcelRequire("kkjUK")),
                (parcelRequire("e608R")),
                (parcelRequire("3pC5u")),
                (parcelRequire("5nm3d")),
                (parcelRequire("1ArxI")),
                (parcelRequire("6i3Ao")),
                (parcelRequire("dPoZx")),
                (parcelRequire("faiza")),
                (parcelRequire("hr5n6")),
                (parcelRequire("ahPAX")),
                (parcelRequire("gf2kN")),
                (parcelRequire("9zIhO")),
                (parcelRequire("72xvc")),
                (parcelRequire("3ihb5")),
                (parcelRequire("fMN6V")),
                (parcelRequire("8Z6nZ")),
                (parcelRequire("8WwfW")),
                (parcelRequire("25J5q")),
                (parcelRequire("7Hj6K")),
                (parcelRequire("hfFBb")),
                (parcelRequire("iV0Xw")),
                (parcelRequire("lj5Na")),
                (parcelRequire("021th")),
                (parcelRequire("fUipc")),
                (parcelRequire("79ylg")),
                (parcelRequire("1hD9Q")),
                (parcelRequire("f2u0Z")),
                (parcelRequire("fSQd6")),
                (parcelRequire("a6jSu")),
                (parcelRequire("1gD8I")),
                (parcelRequire("hCfMc")),
                (parcelRequire("fzZOG")),
                (parcelRequire("lhsZr")),
                (parcelRequire("fVdQR")),
                (parcelRequire("7Da0Y")),
                (parcelRequire("4A7fy")),
                (parcelRequire("hSp9J")),
                (parcelRequire("5lRLj"))
            ];
        case 'pt-PT':
            return [
                (parcelRequire("8BeV9")),
                (parcelRequire("crWmJ")),
                (parcelRequire("bHrFd")),
                (parcelRequire("7lF6v")),
                (parcelRequire("eD8co")),
                (parcelRequire("3GzA6")),
                (parcelRequire("e9hzu")),
                (parcelRequire("3uDBq")),
                (parcelRequire("fiBVu")),
                (parcelRequire("4PYdP"))
            ];
        case 'ru-RU':
            return [
                (parcelRequire("8Dvkp")),
                (parcelRequire("kTz1D")),
                (parcelRequire("fjKDV")),
                (parcelRequire("cjj2j")),
                (parcelRequire("cNuSQ")),
                (parcelRequire("d39o7")),
                (parcelRequire("94T2T")),
                (parcelRequire("9Ebk4")),
                (parcelRequire("jgAV4")),
                (parcelRequire("3qLfN")),
                (parcelRequire("ci5Cc")),
                (parcelRequire("higsq")),
                (parcelRequire("dACbQ")),
                (parcelRequire("9fDpX")),
                (parcelRequire("5YBIO")),
                (parcelRequire("2e8HC")),
                (parcelRequire("kaWKs")),
                (parcelRequire("3W3jF")),
                (parcelRequire("ge4kn")),
                (parcelRequire("dALWD")),
                (parcelRequire("fZwia")),
                (parcelRequire("eFhvS")),
                (parcelRequire("2nXZ8")),
                (parcelRequire("jmZFT")),
                (parcelRequire("6Y3b8")),
                (parcelRequire("a1uRE")),
                (parcelRequire("HG6tA")),
                (parcelRequire("bt2el")),
                (parcelRequire("3ZSwL")),
                (parcelRequire("hHPqE")),
                (parcelRequire("gIBZU")),
                (parcelRequire("9o60R")),
                (parcelRequire("eAQcA")),
                (parcelRequire("bqdqd")),
                (parcelRequire("jCl1E")),
                (parcelRequire("bUlYI")),
                (parcelRequire("7YG1Z")),
                (parcelRequire("dQTJB")),
                (parcelRequire("kI5sJ")),
                (parcelRequire("d3mtm")),
                (parcelRequire("eK9gf")),
                (parcelRequire("91wjI")),
                (parcelRequire("cSIGQ")),
                (parcelRequire("s6lRK")),
                (parcelRequire("8fOrs")),
                (parcelRequire("5zdpU")),
                (parcelRequire("kj3LF")),
                (parcelRequire("lJcGW")),
                (parcelRequire("lbVXE")),
                (parcelRequire("8XQ8w"))
            ];
        case 'da-DK':
            return [
                (parcelRequire("d9Ik0")),
                (parcelRequire("byDVw")),
                (parcelRequire("8L1el")),
                (parcelRequire("aHczM")),
                (parcelRequire("1xR7J")),
                (parcelRequire("fsZT8")),
                (parcelRequire("hWH5l")),
                (parcelRequire("f7BwS")),
                (parcelRequire("3iZBc")),
                (parcelRequire("g3jku")),
                (parcelRequire("c4axN")),
                (parcelRequire("1DN08")),
                (parcelRequire("5r4T2")),
                (parcelRequire("frJRn")),
                (parcelRequire("6RhHb")),
                (parcelRequire("79T8R")),
                (parcelRequire("doQkv")),
                (parcelRequire("bsi3C")),
                (parcelRequire("85hJ3")),
                (parcelRequire("aC4DH")),
                (parcelRequire("hC4Lh")),
                (parcelRequire("iqmqJ")),
                (parcelRequire("LC2CN")),
                (parcelRequire("a1Dfy")),
                (parcelRequire("kGzms")),
                (parcelRequire("iBqVt")),
                (parcelRequire("7BZ9C")),
                (parcelRequire("bzecu")),
                (parcelRequire("dNZ7N")),
                (parcelRequire("a5CS2")),
                (parcelRequire("kqoD7")),
                (parcelRequire("eCZos")),
                (parcelRequire("di64X")),
                (parcelRequire("72kZ1")),
                (parcelRequire("gyczk")),
                (parcelRequire("99SMa")),
                (parcelRequire("4vXmH")),
                (parcelRequire("6H2n8")),
                (parcelRequire("kTT3m")),
                (parcelRequire("fbtaD")),
                (parcelRequire("fCU8B")),
                (parcelRequire("bIFjS")),
                (parcelRequire("474bn")),
                (parcelRequire("kOD1A")),
                (parcelRequire("hBv8R")),
                (parcelRequire("9AVwI")),
                (parcelRequire("ergUs")),
                (parcelRequire("cZ1Kt")),
                (parcelRequire("b32TI")),
                (parcelRequire("3dkeg"))
            ];
        case 'et-EE':
            return [
                (parcelRequire("3TmS7")),
                (parcelRequire("iO4nx")),
                (parcelRequire("44JeZ")),
                (parcelRequire("7czRk")),
                (parcelRequire("6K20d")),
                (parcelRequire("g9h5M")),
                (parcelRequire("dexYO")),
                (parcelRequire("bByvU")),
                (parcelRequire("8LRp6")),
                (parcelRequire("5JS0e")),
                (parcelRequire("ja1eS"))
            ];
        case 'fi-FI':
            return [
                (parcelRequire("hOjAI")),
                (parcelRequire("kAg4J")),
                (parcelRequire("aJrZf")),
                (parcelRequire("bOPON")),
                (parcelRequire("6yeY4")),
                (parcelRequire("75D4e")),
                (parcelRequire("hJaAz")),
                (parcelRequire("8YOOq")),
                (parcelRequire("eYYJB")),
                (parcelRequire("1i9hU")),
                (parcelRequire("6sWdk")),
                (parcelRequire("irj7Y")),
                (parcelRequire("aIRz0")),
                (parcelRequire("aqhcc")),
                (parcelRequire("8aZma")),
                (parcelRequire("giCMm")),
                (parcelRequire("7cXmg")),
                (parcelRequire("anTn4")),
                (parcelRequire("46lt6")),
                (parcelRequire("iMasR")),
                (parcelRequire("9Euzu")),
                (parcelRequire("hs7Tn")),
                (parcelRequire("34hMn")),
                (parcelRequire("4zoGR")),
                (parcelRequire("W955n")),
                (parcelRequire("adyGO")),
                (parcelRequire("8aSXD")),
                (parcelRequire("4CCNY")),
                (parcelRequire("gMXBx")),
                (parcelRequire("iPlMM")),
                (parcelRequire("3hSLZ")),
                (parcelRequire("4N5hB")),
                (parcelRequire("6RqBf")),
                (parcelRequire("1mcMr")),
                (parcelRequire("3tUrN")),
                (parcelRequire("3WvZO")),
                (parcelRequire("eNqGF")),
                (parcelRequire("giq8v")),
                (parcelRequire("5qNyO")),
                (parcelRequire("7y9ZQ")),
                (parcelRequire("lbsop")),
                (parcelRequire("1mUUj")),
                (parcelRequire("6OSOg")),
                (parcelRequire("8LsJU")),
                (parcelRequire("d3d3B")),
                (parcelRequire("6jDDp")),
                (parcelRequire("7rsL3")),
                (parcelRequire("8J2b3")),
                (parcelRequire("k8YM1")),
                (parcelRequire("04pAv"))
            ];
        case 'hu-HU':
            return [
                (parcelRequire("h4UaP")),
                (parcelRequire("3vp2D")),
                (parcelRequire("3kTSZ")),
                (parcelRequire("3pojl")),
                (parcelRequire("12Fd8")),
                (parcelRequire("8Qd1R")),
                (parcelRequire("g4xdF")),
                (parcelRequire("dGum9")),
                (parcelRequire("3mnOL")),
                (parcelRequire("3pTic")),
                (parcelRequire("gVlep")),
                (parcelRequire("4Wv3d")),
                (parcelRequire("lre2p")),
                (parcelRequire("fbTYr")),
                (parcelRequire("ehB6l")),
                (parcelRequire("fgWDV")),
                (parcelRequire("lNCBE")),
                (parcelRequire("cBy0t")),
                (parcelRequire("gavcE")),
                (parcelRequire("72TUS")),
                (parcelRequire("lX7ZB")),
                (parcelRequire("44MZj")),
                (parcelRequire("kiL6P")),
                (parcelRequire("57Xmt")),
                (parcelRequire("kOAsS")),
                (parcelRequire("22175")),
                (parcelRequire("5VTGq")),
                (parcelRequire("kblFP")),
                (parcelRequire("1pViZ")),
                (parcelRequire("6kIEp")),
                (parcelRequire("fQ8ub")),
                (parcelRequire("2sNKf")),
                (parcelRequire("fBE45")),
                (parcelRequire("cigct")),
                (parcelRequire("azU1D")),
                (parcelRequire("042s4")),
                (parcelRequire("7SOfW")),
                (parcelRequire("ahVuR")),
                (parcelRequire("5on6f")),
                (parcelRequire("kZd4d")),
                (parcelRequire("29xop")),
                (parcelRequire("8m0jZ")),
                (parcelRequire("lyu5f")),
                (parcelRequire("furZw")),
                (parcelRequire("6HUYI")),
                (parcelRequire("eFDCy")),
                (parcelRequire("k3Mc5")),
                (parcelRequire("5WCJp")),
                (parcelRequire("lbRE3")),
                (parcelRequire("ilYgv"))
            ];
        case 'is-IS':
            return [
                (parcelRequire("8XMSq")),
                (parcelRequire("dJ6Pi")),
                (parcelRequire("lUn5i")),
                (parcelRequire("8e7x9")),
                (parcelRequire("6WBDv")),
                (parcelRequire("lxOk8")),
                (parcelRequire("UR9zx"))
            ];
        case 'it-IT':
            return [
                (parcelRequire("ahHe3")),
                (parcelRequire("6lwg0")),
                (parcelRequire("9SUaK")),
                (parcelRequire("efE2E")),
                (parcelRequire("4E3Th")),
                (parcelRequire("4Qs4Q")),
                (parcelRequire("2yqT6")),
                (parcelRequire("7VYYf")),
                (parcelRequire("5D3sR")),
                (parcelRequire("2efCB")),
                (parcelRequire("i6Zgr")),
                (parcelRequire("lFsTu")),
                (parcelRequire("N953D")),
                (parcelRequire("2u2kR")),
                (parcelRequire("8MTu9")),
                (parcelRequire("kRiRv")),
                (parcelRequire("aooVH")),
                (parcelRequire("ibFQv")),
                (parcelRequire("bVrxR")),
                (parcelRequire("7ah00")),
                (parcelRequire("228Zl")),
                (parcelRequire("4au4n")),
                (parcelRequire("iR6Xu")),
                (parcelRequire("fkzqw")),
                (parcelRequire("bSpOm")),
                (parcelRequire("hwNwq")),
                (parcelRequire("3Vy0v")),
                (parcelRequire("a0Qfs")),
                (parcelRequire("gFkVa")),
                (parcelRequire("948bX")),
                (parcelRequire("j4BCj")),
                (parcelRequire("gleDJ")),
                (parcelRequire("1GLjy")),
                (parcelRequire("7Sx4H")),
                (parcelRequire("ekfAU")),
                (parcelRequire("hog0H")),
                (parcelRequire("3RT2u")),
                (parcelRequire("2WFcU")),
                (parcelRequire("ll7nG")),
                (parcelRequire("OleXG")),
                (parcelRequire("aQEiB")),
                (parcelRequire("hGlAj")),
                (parcelRequire("7g65d")),
                (parcelRequire("amRwH")),
                (parcelRequire("3Ab0c")),
                (parcelRequire("1JMes")),
                (parcelRequire("amuYS")),
                (parcelRequire("9chGX")),
                (parcelRequire("g5ykP")),
                (parcelRequire("alUyM"))
            ];
        case 'nl-NL':
            return [
                (parcelRequire("dMN5u")),
                (parcelRequire("9Sy6S")),
                (parcelRequire("2sR2M")),
                (parcelRequire("lOHWU")),
                (parcelRequire("jf7Wf")),
                (parcelRequire("cJ0AU")),
                (parcelRequire("fjeb2")),
                (parcelRequire("jZyhc")),
                (parcelRequire("bL83i")),
                (parcelRequire("4Sfek")),
                (parcelRequire("fQBV7")),
                (parcelRequire("aHOHt")),
                (parcelRequire("lkDzP")),
                (parcelRequire("acAF0")),
                (parcelRequire("3WzYO")),
                (parcelRequire("2ZzQp")),
                (parcelRequire("1WKn0")),
                (parcelRequire("gXZbC")),
                (parcelRequire("dT0l0")),
                (parcelRequire("dncYR")),
                (parcelRequire("8SY41")),
                (parcelRequire("13Wx0")),
                (parcelRequire("5qYkf")),
                (parcelRequire("eMQbd")),
                (parcelRequire("jDjEq")),
                (parcelRequire("jvWch")),
                (parcelRequire("im8t4")),
                (parcelRequire("lP9lz")),
                (parcelRequire("eJom7")),
                (parcelRequire("dVscl")),
                (parcelRequire("gJdES")),
                (parcelRequire("gIU5D")),
                (parcelRequire("gUMoH")),
                (parcelRequire("1xJ6S")),
                (parcelRequire("iA00J")),
                (parcelRequire("hjIWO")),
                (parcelRequire("2mKTO")),
                (parcelRequire("64Exp")),
                (parcelRequire("2whfU")),
                (parcelRequire("2oUhU")),
                (parcelRequire("n6J1z")),
                (parcelRequire("iYl0v")),
                (parcelRequire("ajmHX")),
                (parcelRequire("gcFuD")),
                (parcelRequire("fBUMu")),
                (parcelRequire("8p4qh")),
                (parcelRequire("jkRu0")),
                (parcelRequire("litwj")),
                (parcelRequire("cdWqu")),
                (parcelRequire("cDKFi"))
            ];
        case 'no-NO':
            /**
      * Fun fact: Norwegian has two written dialects! The W3C recommends using the Bokmål dialect,
      * which is why we use 'nb' as the language code for this locale rather than 'no'.
      * More info:
      * @see https://hello.atlassian.net/wiki/spaces/~139129757/pages/1604629732/User+preferences+for+language+and+locale
      * @see https://internal.stptrans.com/bokmal-and-nynorsk/
      */ return [
                (parcelRequire("h7jes")),
                (parcelRequire("aFVpw")),
                (parcelRequire("pcTb4")),
                (parcelRequire("hwCQi")),
                (parcelRequire("fprwv")),
                (parcelRequire("euPQu")),
                (parcelRequire("b1mVA")),
                (parcelRequire("bg7zY")),
                (parcelRequire("469Km")),
                (parcelRequire("6MZlt")),
                (parcelRequire("40MMk")),
                (parcelRequire("1V9j9")),
                (parcelRequire("aXTPJ")),
                (parcelRequire("88wo1")),
                (parcelRequire("4vIkx")),
                (parcelRequire("32iGc")),
                (parcelRequire("3Y0WQ")),
                (parcelRequire("98RbQ")),
                (parcelRequire("fFZZA")),
                (parcelRequire("xH2GM")),
                (parcelRequire("iBKof")),
                (parcelRequire("jB9y9")),
                (parcelRequire("iZu39")),
                (parcelRequire("gFLJ1")),
                (parcelRequire("1MZwk")),
                (parcelRequire("g5owg")),
                (parcelRequire("jAgyb")),
                (parcelRequire("2fO8a")),
                (parcelRequire("4MUUK")),
                (parcelRequire("kS9Ey")),
                (parcelRequire("bWVFp")),
                (parcelRequire("hejHg")),
                (parcelRequire("5K6uD")),
                (parcelRequire("18fJW")),
                (parcelRequire("9T6gR")),
                (parcelRequire("a5W4o")),
                (parcelRequire("3UlWm")),
                (parcelRequire("gSP59")),
                (parcelRequire("jx6sy")),
                (parcelRequire("ee9aR")),
                (parcelRequire("45KR4")),
                (parcelRequire("lhlg8")),
                (parcelRequire("7SSt6")),
                (parcelRequire("bP4ZN")),
                (parcelRequire("dpA9w")),
                (parcelRequire("eGaQ6")),
                (parcelRequire("dufY6")),
                (parcelRequire("8DgxY")),
                (parcelRequire("eWf9o")),
                (parcelRequire("NF1yG"))
            ];
        case 'pl-PL':
            return [
                (parcelRequire("gVudA")),
                (parcelRequire("cvgc1")),
                (parcelRequire("eoZ7g")),
                (parcelRequire("1zBiF")),
                (parcelRequire("9fkYT")),
                (parcelRequire("8jWMf")),
                (parcelRequire("29zH2")),
                (parcelRequire("73k0F")),
                (parcelRequire("4X4g9")),
                (parcelRequire("jwi97")),
                (parcelRequire("7PxsC")),
                (parcelRequire("9yoPQ")),
                (parcelRequire("lkZoc")),
                (parcelRequire("3G17e")),
                (parcelRequire("3pPwF")),
                (parcelRequire("lvXhC")),
                (parcelRequire("edVEs")),
                (parcelRequire("7OuiO")),
                (parcelRequire("alhJp")),
                (parcelRequire("cFUs5")),
                (parcelRequire("acCtp")),
                (parcelRequire("kbyT1")),
                (parcelRequire("6YnnP")),
                (parcelRequire("licQg")),
                (parcelRequire("aSDlt")),
                (parcelRequire("6la3D")),
                (parcelRequire("kCQLZ")),
                (parcelRequire("i3EHa")),
                (parcelRequire("jAjQ2")),
                (parcelRequire("eVRAq")),
                (parcelRequire("isq2S")),
                (parcelRequire("gOoQN")),
                (parcelRequire("5FIM9")),
                (parcelRequire("hLynJ")),
                (parcelRequire("68y2U")),
                (parcelRequire("dfrAP")),
                (parcelRequire("f0q8G")),
                (parcelRequire("7IZCm")),
                (parcelRequire("5oFEH")),
                (parcelRequire("3OUob")),
                (parcelRequire("8ihmZ")),
                (parcelRequire("eKt5X")),
                (parcelRequire("dMfhL")),
                (parcelRequire("b507v")),
                (parcelRequire("4bGBS")),
                (parcelRequire("1Avk6")),
                (parcelRequire("jxXUD")),
                (parcelRequire("NVO1b")),
                (parcelRequire("hZZzn")),
                (parcelRequire("6pemw"))
            ];
        case 'ro-RO':
            return [
                (parcelRequire("g1mTU")),
                (parcelRequire("2iMjb")),
                (parcelRequire("40naj")),
                (parcelRequire("Ev419")),
                (parcelRequire("kdSeN")),
                (parcelRequire("88EVY")),
                (parcelRequire("gnWy6")),
                (parcelRequire("7KYU2"))
            ];
        case 'sk-SK':
            return [
                (parcelRequire("kou5y")),
                (parcelRequire("3RRnu")),
                (parcelRequire("hzmCK")),
                (parcelRequire("1yd01")),
                (parcelRequire("dVKWy")),
                (parcelRequire("9l2PM")),
                (parcelRequire("cTdgN")),
                (parcelRequire("dcTqb")),
                (parcelRequire("16noY")),
                (parcelRequire("eEY1A")),
                (parcelRequire("9fnFP"))
            ];
        case 'cs-CZ':
            return [
                (parcelRequire("5IJ7c")),
                (parcelRequire("haekz")),
                (parcelRequire("2VLdk")),
                (parcelRequire("l5U9N")),
                (parcelRequire("fJeFi")),
                (parcelRequire("hA8pw")),
                (parcelRequire("dtwe8")),
                (parcelRequire("7hJ4k")),
                (parcelRequire("gYY23")),
                (parcelRequire("i6DYd")),
                (parcelRequire("fssKD")),
                (parcelRequire("epNJv")),
                (parcelRequire("jDTSe")),
                (parcelRequire("bUjED")),
                (parcelRequire("1D6mn")),
                (parcelRequire("lsKzd")),
                (parcelRequire("e6Mh1")),
                (parcelRequire("4igGY")),
                (parcelRequire("kKlml")),
                (parcelRequire("55ZbW")),
                (parcelRequire("8QRlX")),
                (parcelRequire("4UYKE")),
                (parcelRequire("dmuIJ")),
                (parcelRequire("dp0SK")),
                (parcelRequire("fE1BU")),
                (parcelRequire("djF45")),
                (parcelRequire("bYDKL")),
                (parcelRequire("djluV")),
                (parcelRequire("hYcrq")),
                (parcelRequire("lfBS4")),
                (parcelRequire("cm23V")),
                (parcelRequire("2YiJd")),
                (parcelRequire("05g36")),
                (parcelRequire("2nCDy")),
                (parcelRequire("7RCJa")),
                (parcelRequire("50uHu")),
                (parcelRequire("eIlsK")),
                (parcelRequire("eHyl3")),
                (parcelRequire("eMs9r")),
                (parcelRequire("htEbN")),
                (parcelRequire("fXsDX")),
                (parcelRequire("gssRx")),
                (parcelRequire("9J20P")),
                (parcelRequire("hxniA")),
                (parcelRequire("8SxNE")),
                (parcelRequire("cGFVw")),
                (parcelRequire("4xjsK")),
                (parcelRequire("bxtFe")),
                (parcelRequire("8BwAK")),
                (parcelRequire("gT2Dr"))
            ];
        case 'sv-SE':
            return [
                (parcelRequire("gygIs")),
                (parcelRequire("2cAsa")),
                (parcelRequire("idofV")),
                (parcelRequire("59soY")),
                (parcelRequire("gWnqr")),
                (parcelRequire("2zWSc")),
                (parcelRequire("d3zGC")),
                (parcelRequire("1qMg4")),
                (parcelRequire("gtUoU")),
                (parcelRequire("0517g")),
                (parcelRequire("lwbVR")),
                (parcelRequire("bfPXA")),
                (parcelRequire("85Xbu")),
                (parcelRequire("9fYMB")),
                (parcelRequire("2WCM6")),
                (parcelRequire("4Kylo")),
                (parcelRequire("ei5Av")),
                (parcelRequire("dxCfe")),
                (parcelRequire("1aoGA")),
                (parcelRequire("dJCBo")),
                (parcelRequire("lJZW0")),
                (parcelRequire("5QFye")),
                (parcelRequire("4zmXl")),
                (parcelRequire("5e72D")),
                (parcelRequire("kkfHx")),
                (parcelRequire("bDv1U")),
                (parcelRequire("01sCo")),
                (parcelRequire("1qZ55")),
                (parcelRequire("heq0d")),
                (parcelRequire("6mL38")),
                (parcelRequire("4ZMhF")),
                (parcelRequire("i9tIA")),
                (parcelRequire("iymfG")),
                (parcelRequire("5CV3W")),
                (parcelRequire("iSk4v")),
                (parcelRequire("g2iSE")),
                (parcelRequire("5sdAA")),
                (parcelRequire("9Oobr")),
                (parcelRequire("aH2Wx")),
                (parcelRequire("3S2W0")),
                (parcelRequire("7KXL4")),
                (parcelRequire("7oiGZ")),
                (parcelRequire("cek4L")),
                (parcelRequire("dkc7j")),
                (parcelRequire("likbX")),
                (parcelRequire("aIVPF")),
                (parcelRequire("d3V3a")),
                (parcelRequire("lSVUW")),
                (parcelRequire("jx5hF")),
                (parcelRequire("bVmps"))
            ];
        case 'zh-CN':
            return [
                (parcelRequire("kCgDJ")),
                (parcelRequire("4qfEE")),
                (parcelRequire("2hO4g")),
                (parcelRequire("8i4WU")),
                (parcelRequire("fPuGj")),
                (parcelRequire("cv67e")),
                (parcelRequire("Ntwva")),
                (parcelRequire("eCrXN")),
                (parcelRequire("d7mnE")),
                (parcelRequire("gaZlZ")),
                (parcelRequire("frhpg")),
                (parcelRequire("9SR7e")),
                (parcelRequire("fg8fT")),
                (parcelRequire("8rIKC")),
                (parcelRequire("bbIQ2")),
                (parcelRequire("i4Utk")),
                (parcelRequire("irZzC")),
                (parcelRequire("2WuKG")),
                (parcelRequire("blkN1")),
                (parcelRequire("wsFXm")),
                (parcelRequire("cjzkx")),
                (parcelRequire("8AnHw")),
                (parcelRequire("gwyWM")),
                (parcelRequire("jpubq")),
                (parcelRequire("f0Mty")),
                (parcelRequire("4q5qH")),
                (parcelRequire("gE1YK")),
                (parcelRequire("a3MCo")),
                (parcelRequire("1DGKK")),
                (parcelRequire("l8zxR")),
                (parcelRequire("kGQe4")),
                (parcelRequire("iEHWY")),
                (parcelRequire("kCIZm")),
                (parcelRequire("1Pemw")),
                (parcelRequire("2cQTL")),
                (parcelRequire("5Bquy")),
                (parcelRequire("hmVpw")),
                (parcelRequire("jMgDu")),
                (parcelRequire("78OkM")),
                (parcelRequire("3jJh8")),
                (parcelRequire("dKzkX")),
                (parcelRequire("3RiGn")),
                (parcelRequire("2XIfy")),
                (parcelRequire("kXTyV")),
                (parcelRequire("8zP6u")),
                (parcelRequire("gYPsP")),
                (parcelRequire("621Nl")),
                (parcelRequire("6oWhF")),
                (parcelRequire("8KoP3")),
                (parcelRequire("hVxyg"))
            ];
        case 'zh-TW':
            return [
                (parcelRequire("2IuuZ")),
                (parcelRequire("4Qogz")),
                (parcelRequire("6fq6p")),
                (parcelRequire("4IUb2")),
                (parcelRequire("9CnN2")),
                (parcelRequire("bO3GU")),
                (parcelRequire("3sKHD")),
                (parcelRequire("8BAgg")),
                (parcelRequire("bvN9u")),
                (parcelRequire("cDueA")),
                (parcelRequire("ar2qP")),
                (parcelRequire("bE3dj")),
                (parcelRequire("5SMsY")),
                (parcelRequire("jYMGc")),
                (parcelRequire("6yjSe")),
                (parcelRequire("3C2dA")),
                (parcelRequire("glqkY")),
                (parcelRequire("f4vRL")),
                (parcelRequire("4Nozy")),
                (parcelRequire("1BuHK")),
                (parcelRequire("hgiFl")),
                (parcelRequire("4oWJF")),
                (parcelRequire("8uSaY")),
                (parcelRequire("3Ajke")),
                (parcelRequire("ky9In")),
                (parcelRequire("hGspX")),
                (parcelRequire("fOV3L")),
                (parcelRequire("gJnJ1")),
                (parcelRequire("aOmjA")),
                (parcelRequire("aquFR")),
                (parcelRequire("11QG0")),
                (parcelRequire("fzZK6")),
                (parcelRequire("aQrK1")),
                (parcelRequire("dT7X0")),
                (parcelRequire("k1y06")),
                (parcelRequire("3ZXdN")),
                (parcelRequire("adYmX")),
                (parcelRequire("5ORh0")),
                (parcelRequire("gRdNA")),
                (parcelRequire("dYj34")),
                (parcelRequire("aaBhI")),
                (parcelRequire("fBwpI")),
                (parcelRequire("lrUUy")),
                (parcelRequire("9ysds")),
                (parcelRequire("6cdAA")),
                (parcelRequire("70nmK")),
                (parcelRequire("jM3pb")),
                (parcelRequire("0dv56")),
                (parcelRequire("6YNhw")),
                (parcelRequire("aRmNy"))
            ];
        case 'tr-TR':
            return [
                (parcelRequire("ipS8E")),
                (parcelRequire("6Cc41")),
                (parcelRequire("kSjT1")),
                (parcelRequire("6jSEb")),
                (parcelRequire("2zfpe")),
                (parcelRequire("36j9T")),
                (parcelRequire("ckPPk")),
                (parcelRequire("17U1Q")),
                (parcelRequire("j3dnL")),
                (parcelRequire("8lyjk")),
                (parcelRequire("dIHgW")),
                (parcelRequire("cicjm")),
                (parcelRequire("b4HSq")),
                (parcelRequire("58W22")),
                (parcelRequire("6r3yr")),
                (parcelRequire("03uca")),
                (parcelRequire("3mqHt")),
                (parcelRequire("2iat6")),
                (parcelRequire("9CJod")),
                (parcelRequire("aUYkR")),
                (parcelRequire("9LWsl")),
                (parcelRequire("2HJJD")),
                (parcelRequire("bzHCQ")),
                (parcelRequire("cGT0B")),
                (parcelRequire("kwPXa")),
                (parcelRequire("9Tj1I")),
                (parcelRequire("647dl")),
                (parcelRequire("bmtNL")),
                (parcelRequire("cON8f")),
                (parcelRequire("loYIc")),
                (parcelRequire("22QUF")),
                (parcelRequire("g7B8P")),
                (parcelRequire("c6mWx")),
                (parcelRequire("5XBUQ")),
                (parcelRequire("7tBlJ")),
                (parcelRequire("jIX5A")),
                (parcelRequire("ayk8s")),
                (parcelRequire("lst71")),
                (parcelRequire("jjWma")),
                (parcelRequire("ixOWR")),
                (parcelRequire("adF3X")),
                (parcelRequire("fkaJs")),
                (parcelRequire("bjCJ2")),
                (parcelRequire("cYqNL")),
                (parcelRequire("5EmqU")),
                (parcelRequire("bakss")),
                (parcelRequire("fr3Bx")),
                (parcelRequire("f4UP8"))
            ];
        case 'en-GB':
            return [
                (parcelRequire("1lk68")),
                (parcelRequire("5wUxs")),
                (parcelRequire("c9V23")),
                (parcelRequire("92AbJ")),
                (parcelRequire("eR1v2")),
                (parcelRequire("7u0db")),
                (parcelRequire("7Fn13")),
                (parcelRequire("ha0by")),
                (parcelRequire("kqJvS")),
                (parcelRequire("aXGoh")),
                (parcelRequire("lwrmz")),
                (parcelRequire("fu6d4")),
                (parcelRequire("i6TKI")),
                (parcelRequire("l1p3M")),
                (parcelRequire("i9Bna")),
                (parcelRequire("1BmbT")),
                (parcelRequire("euYEG")),
                (parcelRequire("7SiaK")),
                (parcelRequire("a8eEr")),
                (parcelRequire("4Eyqr")),
                (parcelRequire("9noVS")),
                (parcelRequire("3Nw8M")),
                (parcelRequire("3gcR9")),
                (parcelRequire("10VOJ")),
                (parcelRequire("2bGAH")),
                (parcelRequire("1d6GX")),
                (parcelRequire("4XFOq")),
                (parcelRequire("eQYGM")),
                (parcelRequire("HnRWw")),
                (parcelRequire("8zUbk")),
                (parcelRequire("dq42d")),
                (parcelRequire("5Iyy7")),
                (parcelRequire("ca331")),
                (parcelRequire("crPcP")),
                (parcelRequire("5ZZn2")),
                (parcelRequire("gxG4k")),
                (parcelRequire("5aA4m")),
                (parcelRequire("34nYu")),
                (parcelRequire("a9iSw")),
                (parcelRequire("3m7mh")),
                (parcelRequire("7o23c")),
                (parcelRequire("8uvTB")),
                (parcelRequire("9lBgB")),
                (parcelRequire("ashCg")),
                (parcelRequire("fdn1c")),
                (parcelRequire("9Nrds")),
                (parcelRequire("5ykbE")),
                (parcelRequire("cRwiz"))
            ];
        default:
            // Use default string defined in the source code.
            return [
                (parcelRequire("9xhsN")),
                (parcelRequire("01seq")),
                (parcelRequire("jTiFB")),
                (parcelRequire("1Ykrb")),
                (parcelRequire("9F414")),
                (parcelRequire("jclLy")),
                (parcelRequire("ilJbA")),
                (parcelRequire("aRrRe")),
                (parcelRequire("3k2KC")),
                (parcelRequire("lf7GA")),
                (parcelRequire("jMq97")),
                (parcelRequire("8m6PI")),
                (parcelRequire("ef8wK")),
                (parcelRequire("io22p")),
                (parcelRequire("1e3By")),
                (parcelRequire("5twea")),
                (parcelRequire("jenK5")),
                (parcelRequire("908Pr")),
                (parcelRequire("2rukH")),
                (parcelRequire("996CT")),
                (parcelRequire("eqC8j")),
                (parcelRequire("iGLM7")),
                (parcelRequire("3SnQ2")),
                (parcelRequire("8tnJG")),
                (parcelRequire("6jcuv")),
                (parcelRequire("kRtaI")),
                (parcelRequire("32DbA")),
                (parcelRequire("i8SNb")),
                (parcelRequire("fgBr2")),
                (parcelRequire("7nTwf")),
                (parcelRequire("9EXEt")),
                (parcelRequire("8b4oS")),
                (parcelRequire("keFAg")),
                (parcelRequire("9gxeP")),
                (parcelRequire("czRCp")),
                (parcelRequire("8cXyi")),
                (parcelRequire("7ogQg")),
                (parcelRequire("ciDVS")),
                (parcelRequire("knOJh")),
                (parcelRequire("acYBW")),
                (parcelRequire("5ZePp")),
                (parcelRequire("1Puba")),
                (parcelRequire("fb5VQ")),
                (parcelRequire("lzD0e")),
                (parcelRequire("nJZRb")),
                (parcelRequire("22D0q")),
                (parcelRequire("gc6fa")),
                (parcelRequire("frVR3"))
            ];
    }
};


function $c257e233451d85a0$var$getDefault(obj) {
    return obj.default && typeof obj.default !== 'string' ? obj.default : obj;
}
const $c257e233451d85a0$export$1af4c7e47ad72f44 = 'en-US';
const $c257e233451d85a0$var$translationCache = {};
function $c257e233451d85a0$var$isTranslationCacheSet(cache) {
    return Boolean(cache.locale && cache.messages);
}
function $c257e233451d85a0$export$202e99f82f7f0395() {
    if (!$c257e233451d85a0$var$isTranslationCacheSet($c257e233451d85a0$var$translationCache)) throw new Error('loadTranslation needs to be called before getTranslation');
    return $c257e233451d85a0$var$translationCache;
}
function $c257e233451d85a0$export$85e084dbe857046b(loader = ()=>[], forcedLocale) {
    let localeFromQueryParam;
    try {
        const localeParam = (0, $c3Qwv.getSingleParam)((0, $jiJCD.parse)(location.search, true).query, 'locale');
        Intl.getCanonicalLocales(localeParam); // Throws if the locale is not valid
        localeFromQueryParam = localeParam;
    } catch (error) {
    // Silently handle URI malformed error or invalid locale
    }
    let locale = forcedLocale ?? localeFromQueryParam ?? window?.__SSR_LOCALE__ ?? window?.__INITIAL_STATE__?.i18n?.locale ?? $c257e233451d85a0$export$1af4c7e47ad72f44;
    if (locale.includes('_')) // Note: the locale from session data is not standard aa-AA format. It is aa_AA
    locale = locale.replace('_', '-');
    return Promise.all([
        ...(0, $53ca2ee1a59d82f1$export$8c20ab16ac9cf14f)(locale),
        ...loader(locale)
    ]).then(([...translations])=>{
        // Cache the result in module level.
        $c257e233451d85a0$var$translationCache.locale = locale;
        $c257e233451d85a0$var$translationCache.messages = translations.reduce((allTranslations, translation)=>{
            // import() with json behaves different in test and runtime.
            translation = $c257e233451d85a0$var$getDefault(translation);
            // We've now merged the translations a bit more careful, rather
            // than just blindly use a spread operator because a problem occurred
            // while blindly merging and sending the values to the legacy editor.
            // @see https://ops.internal.atlassian.com/jira/browse/HOT-84998
            for(const key in translation)if (typeof translation[key] === 'string') allTranslations[key] = translation[key];
            return allTranslations;
        }, {});
    });
}
module.exports["DEFAULT_LOCALE"] = $c257e233451d85a0$export$1af4c7e47ad72f44;
module.exports["getTranslation"] = $c257e233451d85a0$export$202e99f82f7f0395;
module.exports["loadTranslation"] = $c257e233451d85a0$export$85e084dbe857046b;

});

parcelRegister("itW76", function(module, exports) {
class $efda06174e4570b7$export$286baf652d0b1206 extends Error {
    get status() {
        return this._status;
    }
    get body() {
        return this._body;
    }
    constructor(message, status, body){
        super(message);
        this._status = void 0;
        this._body = void 0;
        this._status = status;
        this._body = body;
    }
}
module.exports["ResponseError"] = $efda06174e4570b7$export$286baf652d0b1206;

});

parcelRegister("cO8uZ", function(module, exports) {

var $9JIG7 = parcelRequire("9JIG7");

class $acc48749799652be$export$f9c837a54db411d extends Error {
    constructor(message, cause){
        super(message), this.cause = cause;
    }
}
function $acc48749799652be$var$safeParse(json) {
    try {
        return {
            data: (0, $9JIG7.AnyConfigSchema).parse(JSON.parse(json)),
            success: true
        };
    } catch (error) {
        if (error instanceof Error) return {
            success: false,
            error: error
        };
        return {
            success: false,
            error: new $acc48749799652be$export$f9c837a54db411d('An unknown error occurred during parsing', error)
        };
    }
}
class $acc48749799652be$export$2be5653e4dada0a3 {
    static fromValues(values, options) {
        const result = $acc48749799652be$var$safeParse(values);
        if (!result.success) {
            const parseError = new $acc48749799652be$export$f9c837a54db411d('Failed to deserialize config', result.error);
            if (options?.throw) throw parseError;
            // eslint-disable-next-line no-console
            console.error(parseError);
            return $acc48749799652be$export$2be5653e4dada0a3.empty();
        }
        return this.fromData(result.data);
    }
    static fromData(data) {
        return new $acc48749799652be$export$2be5653e4dada0a3(Array.isArray(data) ? (0, $9JIG7.minimalToMap)(data) : (0, $9JIG7.standardToMap)(data));
    }
    static empty() {
        return new $acc48749799652be$export$2be5653e4dada0a3(new Map());
    }
    toJson(format) {
        switch(format){
            case 'standard':
                return JSON.stringify((0, $9JIG7.mapToStandard)(this.config));
            case 'minimal':
                return JSON.stringify((0, $9JIG7.mapToMinimal)(this.config));
        }
    }
    getBoolean(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $9JIG7.ConfigError).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'boolean') return {
            error: (0, $9JIG7.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getString(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $9JIG7.ConfigError).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'string') return {
            error: (0, $9JIG7.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getNumber(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $9JIG7.ConfigError).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'number') return {
            error: (0, $9JIG7.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getStringList(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $9JIG7.ConfigError).NotFound
        };
        const { value: value } = config;
        if (!Array.isArray(value) || !value.every((x)=>typeof x === 'string')) return {
            error: (0, $9JIG7.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getNumberList(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $9JIG7.ConfigError).NotFound
        };
        const { value: value } = config;
        if (!Array.isArray(value) || !value.every((x)=>typeof x === 'number')) return {
            error: (0, $9JIG7.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    constructor(config){
        this.config = config;
    }
}
module.exports["ConfigCollection"] = $acc48749799652be$export$2be5653e4dada0a3;

});

parcelRegister("kwHsV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ef1883270bcd5f57$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $ef1883270bcd5f57$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ef1883270bcd5f57$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $jkp6O = parcelRequire("jkp6O");

var $ef1883270bcd5f57$var$ImmutableUtils = $ef1883270bcd5f57$var$_interopRequireWildcard($jkp6O);
function $ef1883270bcd5f57$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $ef1883270bcd5f57$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ef1883270bcd5f57$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $ef1883270bcd5f57$var$getDefaultGetId = function getDefaultGetId(idAttribute) {
    return function(input) {
        return $ef1883270bcd5f57$var$ImmutableUtils.isImmutable(input) ? input.get(idAttribute) : input[idAttribute];
    };
};
var $ef1883270bcd5f57$var$EntitySchema = function() {
    function EntitySchema(key) {
        var definition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $ef1883270bcd5f57$var$_classCallCheck(this, EntitySchema);
        if (!key || typeof key !== 'string') throw new Error('Expected a string key for Entity, but found ' + key + '.');
        var _options$idAttribute = options.idAttribute, idAttribute = _options$idAttribute === undefined ? 'id' : _options$idAttribute, _options$mergeStrateg = options.mergeStrategy, mergeStrategy = _options$mergeStrateg === undefined ? function(entityA, entityB) {
            return $ef1883270bcd5f57$var$_extends({}, entityA, entityB);
        } : _options$mergeStrateg, _options$processStrat = options.processStrategy, processStrategy = _options$processStrat === undefined ? function(input) {
            return $ef1883270bcd5f57$var$_extends({}, input);
        } : _options$processStrat;
        this._key = key;
        this._getId = typeof idAttribute === 'function' ? idAttribute : $ef1883270bcd5f57$var$getDefaultGetId(idAttribute);
        this._idAttribute = idAttribute;
        this._mergeStrategy = mergeStrategy;
        this._processStrategy = processStrategy;
        this.define(definition);
    }
    $ef1883270bcd5f57$var$_createClass(EntitySchema, [
        {
            key: 'define',
            value: function define(definition) {
                this.schema = Object.keys(definition).reduce(function(entitySchema, key) {
                    var schema = definition[key];
                    return $ef1883270bcd5f57$var$_extends({}, entitySchema, $ef1883270bcd5f57$var$_defineProperty({}, key, schema));
                }, this.schema || {});
            }
        },
        {
            key: 'getId',
            value: function getId(input, parent, key) {
                return this._getId(input, parent, key);
            }
        },
        {
            key: 'merge',
            value: function merge(entityA, entityB) {
                return this._mergeStrategy(entityA, entityB);
            }
        },
        {
            key: 'normalize',
            value: function normalize(input, parent, key, visit, addEntity) {
                var _this = this;
                var processedEntity = this._processStrategy(input, parent, key);
                Object.keys(this.schema).forEach(function(key) {
                    if (processedEntity.hasOwnProperty(key) && $ef1883270bcd5f57$var$_typeof(processedEntity[key]) === 'object') {
                        var schema = _this.schema[key];
                        processedEntity[key] = visit(processedEntity[key], processedEntity, key, schema, addEntity);
                    }
                });
                addEntity(this, processedEntity, input, parent, key);
                return this.getId(input, parent, key);
            }
        },
        {
            key: 'denormalize',
            value: function denormalize(entity, unvisit) {
                var _this2 = this;
                if ($ef1883270bcd5f57$var$ImmutableUtils.isImmutable(entity)) return $ef1883270bcd5f57$var$ImmutableUtils.denormalizeImmutable(this.schema, entity, unvisit);
                Object.keys(this.schema).forEach(function(key) {
                    if (entity.hasOwnProperty(key)) {
                        var schema = _this2.schema[key];
                        entity[key] = unvisit(entity[key], schema);
                    }
                });
                return entity;
            }
        },
        {
            key: 'key',
            get: function get() {
                return this._key;
            }
        },
        {
            key: 'idAttribute',
            get: function get() {
                return this._idAttribute;
            }
        }
    ]);
    return EntitySchema;
}();
module.exports.default = $ef1883270bcd5f57$var$EntitySchema;

});

parcelRegister("7SvvE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5bc604b0b03fe3ee$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eLLiA = parcelRequire("eLLiA");

var $5bc604b0b03fe3ee$var$_Polymorphic2 = $5bc604b0b03fe3ee$var$_interopRequireDefault($eLLiA);
function $5bc604b0b03fe3ee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5bc604b0b03fe3ee$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5bc604b0b03fe3ee$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5bc604b0b03fe3ee$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5bc604b0b03fe3ee$var$UnionSchema = function(_PolymorphicSchema) {
    $5bc604b0b03fe3ee$var$_inherits(UnionSchema, _PolymorphicSchema);
    function UnionSchema(definition, schemaAttribute) {
        $5bc604b0b03fe3ee$var$_classCallCheck(this, UnionSchema);
        if (!schemaAttribute) throw new Error('Expected option "schemaAttribute" not found on UnionSchema.');
        return $5bc604b0b03fe3ee$var$_possibleConstructorReturn(this, (UnionSchema.__proto__ || Object.getPrototypeOf(UnionSchema)).call(this, definition, schemaAttribute));
    }
    $5bc604b0b03fe3ee$var$_createClass(UnionSchema, [
        {
            key: 'normalize',
            value: function normalize(input, parent, key, visit, addEntity) {
                return this.normalizeValue(input, parent, key, visit, addEntity);
            }
        },
        {
            key: 'denormalize',
            value: function denormalize(input, unvisit) {
                return this.denormalizeValue(input, unvisit);
            }
        }
    ]);
    return UnionSchema;
}($5bc604b0b03fe3ee$var$_Polymorphic2.default);
module.exports.default = $5bc604b0b03fe3ee$var$UnionSchema;

});

parcelRegister("cVJRr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $969e61f52917b1b1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $969e61f52917b1b1$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eLLiA = parcelRequire("eLLiA");

var $969e61f52917b1b1$var$_Polymorphic2 = $969e61f52917b1b1$var$_interopRequireDefault($eLLiA);
function $969e61f52917b1b1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $969e61f52917b1b1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $969e61f52917b1b1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $969e61f52917b1b1$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $969e61f52917b1b1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $969e61f52917b1b1$var$ValuesSchema = function(_PolymorphicSchema) {
    $969e61f52917b1b1$var$_inherits(ValuesSchema, _PolymorphicSchema);
    function ValuesSchema() {
        $969e61f52917b1b1$var$_classCallCheck(this, ValuesSchema);
        return $969e61f52917b1b1$var$_possibleConstructorReturn(this, (ValuesSchema.__proto__ || Object.getPrototypeOf(ValuesSchema)).apply(this, arguments));
    }
    $969e61f52917b1b1$var$_createClass(ValuesSchema, [
        {
            key: 'normalize',
            value: function normalize(input, parent, key, visit, addEntity) {
                var _this2 = this;
                return Object.keys(input).reduce(function(output, key, index) {
                    var value = input[key];
                    return value !== undefined && value !== null ? $969e61f52917b1b1$var$_extends({}, output, $969e61f52917b1b1$var$_defineProperty({}, key, _this2.normalizeValue(value, input, key, visit, addEntity))) : output;
                }, {});
            }
        },
        {
            key: 'denormalize',
            value: function denormalize(input, unvisit) {
                var _this3 = this;
                return Object.keys(input).reduce(function(output, key) {
                    var entityOrId = input[key];
                    return $969e61f52917b1b1$var$_extends({}, output, $969e61f52917b1b1$var$_defineProperty({}, key, _this3.denormalizeValue(entityOrId, unvisit)));
                }, {});
            }
        }
    ]);
    return ValuesSchema;
}($969e61f52917b1b1$var$_Polymorphic2.default);
module.exports.default = $969e61f52917b1b1$var$ValuesSchema;

});

parcelRegister("6GEE8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.denormalize = module.exports.normalize = undefined;
var $4de631d96f2c5310$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eLLiA = parcelRequire("eLLiA");

var $4de631d96f2c5310$var$_Polymorphic2 = $4de631d96f2c5310$var$_interopRequireDefault($eLLiA);
function $4de631d96f2c5310$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4de631d96f2c5310$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4de631d96f2c5310$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $4de631d96f2c5310$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $4de631d96f2c5310$var$validateSchema = function validateSchema(definition) {
    var isArray = Array.isArray(definition);
    if (isArray && definition.length > 1) throw new Error('Expected schema definition to be a single schema, but found ' + definition.length + '.');
    return definition[0];
};
var $4de631d96f2c5310$var$getValues = function getValues(input) {
    return Array.isArray(input) ? input : Object.keys(input).map(function(key) {
        return input[key];
    });
};
var $4de631d96f2c5310$var$normalize = module.exports.normalize = function normalize(schema, input, parent, key, visit, addEntity) {
    schema = $4de631d96f2c5310$var$validateSchema(schema);
    var values = $4de631d96f2c5310$var$getValues(input);
    // Special case: Arrays pass *their* parent on to their children, since there
    // is not any special information that can be gathered from themselves directly
    return values.map(function(value, index) {
        return visit(value, parent, key, schema, addEntity);
    });
};
var $4de631d96f2c5310$var$denormalize = module.exports.denormalize = function denormalize(schema, input, unvisit) {
    schema = $4de631d96f2c5310$var$validateSchema(schema);
    return input && input.map ? input.map(function(entityOrId) {
        return unvisit(entityOrId, schema);
    }) : input;
};
var $4de631d96f2c5310$var$ArraySchema = function(_PolymorphicSchema) {
    $4de631d96f2c5310$var$_inherits(ArraySchema, _PolymorphicSchema);
    function ArraySchema() {
        $4de631d96f2c5310$var$_classCallCheck(this, ArraySchema);
        return $4de631d96f2c5310$var$_possibleConstructorReturn(this, (ArraySchema.__proto__ || Object.getPrototypeOf(ArraySchema)).apply(this, arguments));
    }
    $4de631d96f2c5310$var$_createClass(ArraySchema, [
        {
            key: 'normalize',
            value: function normalize(input, parent, key, visit, addEntity) {
                var _this2 = this;
                var values = $4de631d96f2c5310$var$getValues(input);
                return values.map(function(value, index) {
                    return _this2.normalizeValue(value, parent, key, visit, addEntity);
                }).filter(function(value) {
                    return value !== undefined && value !== null;
                });
            }
        },
        {
            key: 'denormalize',
            value: function denormalize(input, unvisit) {
                var _this3 = this;
                return input && input.map ? input.map(function(value) {
                    return _this3.denormalizeValue(value, unvisit);
                }) : input;
            }
        }
    ]);
    return ArraySchema;
}($4de631d96f2c5310$var$_Polymorphic2.default);
module.exports.default = $4de631d96f2c5310$var$ArraySchema;

});

parcelRegister("7jEGY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.denormalize = module.exports.normalize = undefined;
var $5539df5edbb75ace$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $5539df5edbb75ace$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jkp6O = parcelRequire("jkp6O");

var $5539df5edbb75ace$var$ImmutableUtils = $5539df5edbb75ace$var$_interopRequireWildcard($jkp6O);
function $5539df5edbb75ace$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $5539df5edbb75ace$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5539df5edbb75ace$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $5539df5edbb75ace$var$_normalize = function _normalize(schema, input, parent, key, visit, addEntity) {
    var object = $5539df5edbb75ace$var$_extends({}, input);
    Object.keys(schema).forEach(function(key) {
        var localSchema = schema[key];
        var value = visit(input[key], input, key, localSchema, addEntity);
        if (value === undefined || value === null) delete object[key];
        else object[key] = value;
    });
    return object;
};
module.exports.normalize = $5539df5edbb75ace$var$_normalize;
var $5539df5edbb75ace$var$_denormalize = function _denormalize(schema, input, unvisit) {
    if ($5539df5edbb75ace$var$ImmutableUtils.isImmutable(input)) return $5539df5edbb75ace$var$ImmutableUtils.denormalizeImmutable(schema, input, unvisit);
    var object = $5539df5edbb75ace$var$_extends({}, input);
    Object.keys(schema).forEach(function(key) {
        if (object[key]) object[key] = unvisit(object[key], schema[key]);
    });
    return object;
};
module.exports.denormalize = $5539df5edbb75ace$var$_denormalize;
var $5539df5edbb75ace$var$ObjectSchema = function() {
    function ObjectSchema(definition) {
        $5539df5edbb75ace$var$_classCallCheck(this, ObjectSchema);
        this.define(definition);
    }
    $5539df5edbb75ace$var$_createClass(ObjectSchema, [
        {
            key: 'define',
            value: function define(definition) {
                this.schema = Object.keys(definition).reduce(function(entitySchema, key) {
                    var schema = definition[key];
                    return $5539df5edbb75ace$var$_extends({}, entitySchema, $5539df5edbb75ace$var$_defineProperty({}, key, schema));
                }, this.schema || {});
            }
        },
        {
            key: 'normalize',
            value: function normalize() {
                for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return $5539df5edbb75ace$var$_normalize.apply(undefined, [
                    this.schema
                ].concat(args));
            }
        },
        {
            key: 'denormalize',
            value: function denormalize() {
                for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return $5539df5edbb75ace$var$_denormalize.apply(undefined, [
                    this.schema
                ].concat(args));
            }
        }
    ]);
    return ObjectSchema;
}();
module.exports.default = $5539df5edbb75ace$var$ObjectSchema;

});

parcelRegister("jkp6O", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isImmutable = $e1235cad91632715$var$isImmutable;
module.exports.denormalizeImmutable = $e1235cad91632715$var$denormalizeImmutable;
/**
 * Helpers to enable Immutable compatibility *without* bringing in
 * the 'immutable' package as a dependency.
 */ /**
 * Check if an object is immutable by checking if it has a key specific
 * to the immutable library.
 *
 * @param  {any} object
 * @return {bool}
 */ function $e1235cad91632715$var$isImmutable(object) {
    return !!(object && typeof object.hasOwnProperty === 'function' && (object.hasOwnProperty('__ownerID') || // Immutable.Map
    object._map && object._map.hasOwnProperty('__ownerID') // Immutable.Record
    ));
}
/**
 * Denormalize an immutable entity.
 *
 * @param  {Schema} schema
 * @param  {Immutable.Map|Immutable.Record} input
 * @param  {function} unvisit
 * @param  {function} getDenormalizedEntity
 * @return {Immutable.Map|Immutable.Record}
 */ function $e1235cad91632715$var$denormalizeImmutable(schema, input, unvisit) {
    return Object.keys(schema).reduce(function(object, key) {
        // Immutable maps cast keys to strings on write so we need to ensure
        // we're accessing them using string keys.
        var stringKey = '' + key;
        if (object.has(stringKey)) return object.set(stringKey, unvisit(object.get(stringKey), schema[stringKey]));
        else return object;
    }, input);
}

});

parcelRegister("6bFuJ", function(module, exports) {
$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("jTxSS")).unstable_batchedUpdates);

var $jTxSS = parcelRequire("jTxSS");


});

parcelRegister("kDIqF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $35L13 = parcelRequire("35L13");


var $ldVC5 = parcelRequire("ldVC5");


var $lNqan = parcelRequire("lNqan");

let $f069e9dc3efaaedd$var$useSyncExternalStoreWithSelector = (0, $lNqan.notInitialized);
const $f069e9dc3efaaedd$export$e2e6e3f3f3b782e3 = (fn)=>{
    $f069e9dc3efaaedd$var$useSyncExternalStoreWithSelector = fn;
};
const $f069e9dc3efaaedd$var$refEquality = (a, b)=>a === b;
function $f069e9dc3efaaedd$export$2b53f90d2bd1cbfb(context = (0, $ldVC5.ReactReduxContext)) {
    const useReduxContext = context === (0, $ldVC5.ReactReduxContext) ? (0, $35L13.useReduxContext) : (0, $35L13.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $f069e9dc3efaaedd$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $42omo.useRef)(true);
        const wrappedSelector = (0, $42omo.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $f069e9dc3efaaedd$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $42omo.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $f069e9dc3efaaedd$export$2105062e25df4afe = /*#__PURE__*/ $f069e9dc3efaaedd$export$2b53f90d2bd1cbfb();
module.exports["initializeUseSelector"] = $f069e9dc3efaaedd$export$e2e6e3f3f3b782e3;
module.exports["useSelector"] = $f069e9dc3efaaedd$export$2105062e25df4afe;

});

parcelRegister("2GFTt", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $56GFp = parcelRequire("56GFp");


var $42omo = parcelRequire("42omo");


var $hwKTG = parcelRequire("hwKTG");




/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $4e6356c58321ced9$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $590e732ace0409be$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $4e6356c58321ced9$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $590e732ace0409be$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $590e732ace0409be$var$verify(mapStateToProps, 'mapStateToProps');
    $590e732ace0409be$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $590e732ace0409be$var$verify(mergeProps, 'mergeProps');
}


const $c190ecbf2b86374e$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $c190ecbf2b86374e$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $c190ecbf2b86374e$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $bDniu.default)(_ref, $c190ecbf2b86374e$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $c190ecbf2b86374e$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $8c103526328a6661$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $aa6f5b1dc9284830$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $e03d0ebac4fe0d10$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $aa6f5b1dc9284830$export$2e2bcd8739ae039)(value)) (0, $4e6356c58321ced9$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $56fcac51f621cf1f$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $56fcac51f621cf1f$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $56fcac51f621cf1f$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $56fcac51f621cf1f$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $56fcac51f621cf1f$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $401b601c07fa34c5$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $93ca1dda084ad48f$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $56fcac51f621cf1f$export$710f7c60f68acd3e)((dispatch)=>(0, $8c103526328a6661$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $56fcac51f621cf1f$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $56fcac51f621cf1f$export$8d46c7f53c8c602f)(mapDispatchToProps, 'mapDispatchToProps') : (0, $401b601c07fa34c5$export$19ef7b929f7e2559)(mapDispatchToProps, 'mapDispatchToProps');
}




function $88a3edc139a9a22c$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $56fcac51f621cf1f$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $56fcac51f621cf1f$export$8d46c7f53c8c602f)(mapStateToProps, 'mapStateToProps') : (0, $401b601c07fa34c5$export$19ef7b929f7e2559)(mapStateToProps, 'mapStateToProps');
}







function $a60aee4d3b87413b$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $7Q5yr.default)({}, ownProps, stateProps, dispatchProps);
}
function $a60aee4d3b87413b$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $a60aee4d3b87413b$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$a60aee4d3b87413b$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $a60aee4d3b87413b$export$5b105939c84b5234(mergeProps) : (0, $401b601c07fa34c5$export$19ef7b929f7e2559)(mergeProps, 'mergeProps');
}



var $jgNAy = parcelRequire("jgNAy");


var $fUAun = parcelRequire("fUAun");


var $1QPqt = parcelRequire("1QPqt");



var $ldVC5 = parcelRequire("ldVC5");


var $lNqan = parcelRequire("lNqan");

const $1f500041dd10c16e$var$_excluded = [
    "reactReduxForwardedRef"
];
let $1f500041dd10c16e$var$useSyncExternalStore = (0, $lNqan.notInitialized);
const $1f500041dd10c16e$export$36d45daa6a4925b8 = (fn)=>{
    $1f500041dd10c16e$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $1f500041dd10c16e$var$EMPTY_ARRAY = [
    null,
    0
];
const $1f500041dd10c16e$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $1f500041dd10c16e$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $1f500041dd10c16e$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $fUAun.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $1f500041dd10c16e$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $1f500041dd10c16e$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $1f500041dd10c16e$var$initStateUpdates = ()=>$1f500041dd10c16e$var$EMPTY_ARRAY;
function $1f500041dd10c16e$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $1f500041dd10c16e$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $1f500041dd10c16e$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $1f500041dd10c16e$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $1QPqt.default), areStatePropsEqual: areStatePropsEqual = (0, $1QPqt.default), areMergedPropsEqual: areMergedPropsEqual = (0, $1QPqt.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $ldVC5.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $88a3edc139a9a22c$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $93ca1dda084ad48f$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $a60aee4d3b87413b$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $42omo.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $bDniu.default)(props, $1f500041dd10c16e$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $42omo.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $hwKTG.isContextConsumer)(/*#__PURE__*/ $42omo.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $42omo.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $42omo.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $c190ecbf2b86374e$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $42omo.useMemo(()=>{
                if (!shouldHandleStateChanges) return $1f500041dd10c16e$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $jgNAy.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $42omo.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $7Q5yr.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $42omo.useRef();
            const lastWrapperProps = $42omo.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $42omo.useRef();
            const renderIsScheduled = $42omo.useRef(false);
            const isProcessingDispatch = $42omo.useRef(false);
            const isMounted = $42omo.useRef(false);
            const latestSubscriptionCallbackError = $42omo.useRef();
            (0, $fUAun.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $42omo.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $42omo.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $1f500041dd10c16e$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $1f500041dd10c16e$var$useIsomorphicLayoutEffectWithArgs($1f500041dd10c16e$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $1f500041dd10c16e$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $fUAun.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $42omo.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $42omo.createElement(WrappedComponent, (0, $7Q5yr.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $42omo.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $42omo.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $42omo.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $42omo.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $42omo.createElement(Connect, (0, $7Q5yr.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($56GFp)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($56GFp)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $1f500041dd10c16e$export$2e2bcd8739ae039 = $1f500041dd10c16e$var$connect;
module.exports["initializeConnect"] = $1f500041dd10c16e$export$36d45daa6a4925b8;
module.exports["default"] = $1f500041dd10c16e$export$2e2bcd8739ae039;

});

parcelRegister("eIqD0", function(module, exports) {
$parcel$export(module.exports, "Provider", () => (parcelRequire("gG0AJ")).default);
$parcel$export(module.exports, "ReactReduxContext", () => (parcelRequire("ldVC5")).ReactReduxContext);
$parcel$export(module.exports, "connect", () => (parcelRequire("2GFTt")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("8eIct")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("kDIqF")).useSelector);

var $gG0AJ = parcelRequire("gG0AJ");


var $2GFTt = parcelRequire("2GFTt");


var $ldVC5 = parcelRequire("ldVC5");


var $8eIct = parcelRequire("8eIct");


var $kDIqF = parcelRequire("kDIqF");


var $2zEgD = parcelRequire("2zEgD");


var $1QPqt = parcelRequire("1QPqt");




});

parcelRegister("EGdrQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $07a47bbdb815b6f8$export$2e2bcd8739ae039);

var $6g1oe = parcelRequire("6g1oe");


var $aTWRz = parcelRequire("aTWRz");

function $07a47bbdb815b6f8$export$2e2bcd8739ae039() {
    const API_HOST = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).location ? `${(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).location.protocol}//${(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).location.host}` : ``;
    return {
        endpoint: API_HOST,
        contextPath: (0, $aTWRz.CONTEXT_PATH),
        extraHeaders: {
            // required for auth/referrer in rest calls
            'X-Requested-With': 'XMLHttpRequest'
        }
    };
}

});

parcelRegister("7MCqB", function(module, exports) {

var $jSnXV = parcelRequire("jSnXV");


var $b4Wym = parcelRequire("b4Wym");


var $64Cib = parcelRequire("64Cib");

/***
 * BEWARE: THIS INSTANCE OF THE REST API INCLUDES ALL ENDPOINTS (IT ENDS UP ADDING ABOUT 300kb WHEREVER IT IS USED).
 * YOU MAY WANT TO CONSIDER IMPORTING THE SPECIFIC ENDPOINT AND CONFIGURING IT WITH THE DEFAULT CONFIGURATION:
 *
 *   import { webResources } from '@confluence-classic/confluence-rest-api';
 *   import configuration from './rest-api-configuration';
 *   webResources.configure(configuration());
 *
 */ /**
 * Official Atlassian javascript library for Confluence REST API calls.
 * @module confluence-rest-api
 */ 
var $4ZFIE = parcelRequire("4ZFIE");


var $1OVaR = parcelRequire("1OVaR");


var $chDZy = parcelRequire("chDZy");


var $2cpJ0 = parcelRequire("2cpJ0");



var $3xce3 = parcelRequire("3xce3");


var $gCs5d = parcelRequire("gCs5d");




const $be71c66c5fa57adb$export$e7aa7bc5c1b3cfb3 = (0, $4ZFIE.default).fetch;
function $be71c66c5fa57adb$export$8d21e34596265fa2(configuration) {
    (0, $4ZFIE.default).configure(configuration);
}
function $be71c66c5fa57adb$export$a2c54b301f7da496() {
    return (0, $4ZFIE.default).getAtlToken();
}



var $EGdrQ = parcelRequire("EGdrQ");

(0, $be71c66c5fa57adb$export$8d21e34596265fa2)((0, $EGdrQ.default)());
function $b0caef45af5fc05b$export$2e2bcd8739ae039(newConfiguration = {}) {
    (0, $be71c66c5fa57adb$export$8d21e34596265fa2)({
        ...(0, $EGdrQ.default)(),
        ...newConfiguration
    });
}


const $5aaad316cd20dd80$export$e60872e78c337210 = (state)=>state.views.dashboard.get('tenantId', null);
const $5aaad316cd20dd80$var$getAtlToken = (state)=>state.meta.get('atl-token', null);
const $5aaad316cd20dd80$var$getFields = (0, $b4Wym.createSelector)($5aaad316cd20dd80$export$e60872e78c337210, $5aaad316cd20dd80$var$getAtlToken, (tenantId, atlToken)=>(0, $64Cib.Map)({
        tenantId: tenantId,
        atlToken: atlToken
    }));
function $5aaad316cd20dd80$var$hasChanged(previousState, state) {
    return previousState !== state;
}
let $5aaad316cd20dd80$var$cache = (0, $64Cib.Map)({});
function $5aaad316cd20dd80$var$configureRestApiClient(store) {
    const newState = $5aaad316cd20dd80$var$getFields(store.getState());
    if ($5aaad316cd20dd80$var$hasChanged($5aaad316cd20dd80$var$cache, newState)) {
        $5aaad316cd20dd80$var$cache = newState;
        (0, $b0caef45af5fc05b$export$2e2bcd8739ae039)(newState.toJS());
    }
}
const $5aaad316cd20dd80$export$e405c2b0f74207f = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))($5aaad316cd20dd80$var$configureRestApiClient, 500);
module.exports["debouncedConfigureRestApiClient"] = $5aaad316cd20dd80$export$e405c2b0f74207f;

});

parcelRegister("chDZy", function(module, exports) {
/**
 * Helper methods for fetching content.
 * @module confluence-rest-api/content
 */ parcelRequire("1wgMJ");
var $6cikW = parcelRequire("6cikW");


var $glTst = parcelRequire("glTst");


var $kzVdH = parcelRequire("kzVdH");


var $fHHNy = parcelRequire("fHHNy");

const $4f571486c73ec3f3$export$7328289ba9a44022 = (content, labels)=>{
    if (labels) {
        const kind = $4f571486c73ec3f3$export$25a56c84cce0b050(labels);
        if (kind) return kind;
    }
    // TODO: that will need to be i18n
    const typesToKind = {
        page: 'Page',
        blog: 'Blogpost',
        question: 'Question'
    };
    return typesToKind[content.type];
};
const $4f571486c73ec3f3$export$25a56c84cce0b050 = (labels)=>{
    if (!labels.length) return null;
    // TODO: that will need to be i18n
    const labelToKind = {
        'meeting-notes': 'Meeting notes',
        'product-requirements': 'Product requirement',
        decisions: 'Decision',
        'file-list': 'File list',
        retrospective: 'Retrospective',
        'kb-how-to-article': 'How to article',
        'task-report': 'Task report',
        jirareport: 'Jira report',
        'shared-links': 'Shared link',
        'kb-troubleshooting-article': 'Troubleshooting article',
        'gliffy-blueprint': 'Gliffy diagram'
    };
    const acceptedLabels = Object.keys(labelToKind);
    const found = labels.filter((label)=>acceptedLabels.indexOf(label.name) > -1);
    return found.length ? labelToKind[found[0].name] : null;
};
const $4f571486c73ec3f3$export$d2296f7618a3dcd = (item, defaultResult)=>{
    if (typeof item === 'object' && item && typeof item.metadata === 'object' && item.metadata && typeof item.metadata.labels === 'object' && item.metadata.labels && typeof item.metadata.labels.results !== 'undefined') return item.metadata.labels.results;
    return defaultResult;
};
function $4f571486c73ec3f3$export$ba6cee8d0d45e052(response) {
    return {
        ...response,
        version: {
            ...response.version,
            id: response.id,
            by: {
                ...response.version.by
            }
        },
        contributors: response.history && response.history.contributors && response.history.contributors.publishers && response.history.contributors.publishers.users && response.history.contributors.publishers.users.map((0, $fHHNy.userTransformer)),
        labels: $4f571486c73ec3f3$export$d2296f7618a3dcd(response, [])
    };
}



var $4ZFIE = parcelRequire("4ZFIE");

const $8f16181e8882e6f9$var$JSONPostHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
function $8f16181e8882e6f9$export$3d345574ab01eed1(options, callback) {
    const params = {
        contentId: options.contentId
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.EDIT_PAGE_METADATA), params);
    (0, $4ZFIE.default).get(url, {
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        responseTransformer: (0, $kzVdH.contentWithBodyResponseTransformer),
        routeName: 'EDIT_PAGE_METADATA'
    });
}
function $8f16181e8882e6f9$export$a6789ac37d2f0d42(options, callback) {
    const params = {
        contentId: options.contentId,
        timestamp: Date.now(),
        draftShareId: options.draftShareId
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.EDITOR_PAGE), params);
    (0, $4ZFIE.default).get(url, {
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        responseTransformer: (0, $kzVdH.editorContentWithBodyResponseTransformer),
        routeName: 'EDITOR_PAGE'
    });
}
function $8f16181e8882e6f9$export$a288c2036303f9da(options, callback) {
    const schedulePublishTime = options.content.schedulePublishDate;
    const params = {
        contentId: options.content.id,
        schedulePublishTime: schedulePublishTime
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.CONTENT_PUBLISH), params);
    (0, $4ZFIE.default).put(url, {
        body: options.content,
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        headers: $8f16181e8882e6f9$var$JSONPostHeaders,
        responseTransformer: schedulePublishTime ? (0, $kzVdH.schedulePublishContentTransformer) : (0, $kzVdH.publishContentTransformer),
        routeName: 'CONTENT_PUBLISH'
    });
}
function $8f16181e8882e6f9$export$d6662bc368e1c48b(options, callback) {
    const params = {
        contentId: options.content.id
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.DRAFT_SYNC), params);
    (0, $4ZFIE.default).put(url, {
        body: options.content,
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        headers: $8f16181e8882e6f9$var$JSONPostHeaders,
        responseTransformer: (0, $kzVdH.publishContentTransformer),
        routeName: 'DRAFT_SYNC'
    });
}
function $8f16181e8882e6f9$export$db7e0944681d3c58(options, callback) {
    const schedulePublishTime = options.content.schedulePublishDate;
    const params = {
        contentId: options.content.id,
        schedulePublishTime: schedulePublishTime
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.CONTENT_FROM_TEMPLATE_PUBLISH), params);
    (0, $4ZFIE.default).put(url, {
        body: options.content,
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        headers: $8f16181e8882e6f9$var$JSONPostHeaders,
        responseTransformer: schedulePublishTime ? (0, $kzVdH.schedulePublishContentTransformer) : (0, $kzVdH.publishContentTransformer),
        routeName: 'CONTENT_FROM_TEMPLATE_PUBLISH'
    });
}
function $8f16181e8882e6f9$export$eea1b38e4aaafc7d(options, callback) {
    const body = {
        type: options.contentType || 'page',
        status: 'draft',
        //title: "",    // This is possible for draft but not for published page.
        space: {
            key: options.spaceKey
        }
    };
    if (options.fromPageId) body.ancestors = [
        {
            id: options.fromPageId
        }
    ];
    if (options.title) body.title = options.title;
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.CONTENT_CREATE));
    (0, $4ZFIE.default).post(url, {
        body: body,
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        headers: $8f16181e8882e6f9$var$JSONPostHeaders,
        responseTransformer: (0, $4f571486c73ec3f3$export$ba6cee8d0d45e052),
        routeName: 'CONTENT_CREATE'
    });
}
function $8f16181e8882e6f9$export$62e554e9e3f861e(options, callback) {
    const params = {
        contentId: options.contentId
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.DRAFT_METADATA), params);
    (0, $4ZFIE.default).get(url, {
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        responseTransformer: (0, $kzVdH.contentWithBodyResponseTransformer),
        routeName: 'DRAFT_METADATA'
    });
}
function $8f16181e8882e6f9$export$ce9e47b8e2fdc29c(options, callback) {
    const params = {
        contentId: options.contentId
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.CANCEL_SCHEDULED_PUBLISH), params);
    (0, $4ZFIE.default).delete(url, {
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        routeName: 'CANCEL_SCHEDULED_PUBLISH'
    });
}
module.exports["editPageMetadata"] = $8f16181e8882e6f9$export$3d345574ab01eed1;
module.exports["editorPage"] = $8f16181e8882e6f9$export$a6789ac37d2f0d42;
module.exports["publishEditorPage"] = $8f16181e8882e6f9$export$a288c2036303f9da;
module.exports["syncEditorDraft"] = $8f16181e8882e6f9$export$d6662bc368e1c48b;
module.exports["publishEditorPageFromTemplate"] = $8f16181e8882e6f9$export$db7e0944681d3c58;
module.exports["createPage"] = $8f16181e8882e6f9$export$eea1b38e4aaafc7d;
module.exports["draftMetadata"] = $8f16181e8882e6f9$export$62e554e9e3f861e;
module.exports["cancelScheduledPublish"] = $8f16181e8882e6f9$export$ce9e47b8e2fdc29c;

});

parcelRegister("3xce3", function(module, exports) {
parcelRequire("1wgMJ");
var $6cikW = parcelRequire("6cikW");


var $4ZFIE = parcelRequire("4ZFIE");

// This is intentionally outside endpoints.js to prevent any transformers leaking here.
const $292defebfb376489$var$EDITOR_PLUGIN_CODE_LANGUAGES = '/plugins/newcode/getlanguages.action';
const $292defebfb376489$var$EDITOR_PLUGIN_WIKI_CONFLUENCE_CONVERTER = '/rest/tinymce/1/wikixhtmlconverter';
const $292defebfb376489$var$EDITOR_PLUGIN_WIKI_MARKDOWN_CONVERTER = '/rest/tinymce/1/markdownxhtmlconverter';
function $292defebfb376489$export$36fc1cabd39f481b(callback) {
    const url = (0, $4ZFIE.default).getFullPath($292defebfb376489$var$EDITOR_PLUGIN_CODE_LANGUAGES);
    (0, $4ZFIE.default).get(url, {
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        routeName: 'EDITOR_PLUGIN_CODE_LANGUAGES'
    });
}
function $292defebfb376489$export$3b78f501cfcecded(body, callback) {
    const url = (0, $4ZFIE.default).getFullPath($292defebfb376489$var$EDITOR_PLUGIN_WIKI_CONFLUENCE_CONVERTER);
    (0, $4ZFIE.default).postLegacyResource(url, {
        body: body,
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        headers: {
            Accept: 'text/plain, */*',
            'Content-Type': 'application/json; charset=utf-8'
        },
        routeName: 'EDITOR_PLUGIN_WIKI_CONFLUENCE_CONVERTER'
    });
}
function $292defebfb376489$export$b0105dc9e36efff1(body, callback) {
    const url = (0, $4ZFIE.default).getFullPath($292defebfb376489$var$EDITOR_PLUGIN_WIKI_MARKDOWN_CONVERTER);
    (0, $4ZFIE.default).postLegacyResource(url, {
        body: body,
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        headers: {
            Accept: 'text/plain, */*',
            'Content-Type': 'application/json; charset=utf-8'
        },
        routeName: 'EDITOR_PLUGIN_WIKI_MARKDOWN_CONVERTER'
    });
}
module.exports["getPluginCodeLanguages"] = $292defebfb376489$export$36fc1cabd39f481b;
module.exports["getWikiConfluenceToXhtml"] = $292defebfb376489$export$3b78f501cfcecded;
module.exports["getWikiMarkdownToXhtml"] = $292defebfb376489$export$b0105dc9e36efff1;

});

parcelRegister("2cpJ0", function(module, exports) {
/**
 * Helper methods for feature discovery plugin.
 * @module confluence-rest-api/feature-discovery
 */ parcelRequire("1wgMJ");
var $6cikW = parcelRequire("6cikW");


var $glTst = parcelRequire("glTst");


var $4ZFIE = parcelRequire("4ZFIE");

function $19a0a834f2942e87$export$29913089bc850e3(options, callback) {
    const params = {
        pluginKey: options.pluginKey,
        featureKey: options.featureKey
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.FEATURE_DISCOVERY), params);
    (0, $4ZFIE.default).postLegacyResource(url, {
        body: {
            atl_token: (0, $4ZFIE.default).getAtlToken()
        },
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        callback: callback,
        routeName: 'FEATURE_DISCOVERY'
    });
}
module.exports["markDiscovered"] = $19a0a834f2942e87$export$29913089bc850e3;

});

parcelRegister("1OVaR", function(module, exports) {
parcelRequire("1wgMJ");
var $6cikW = parcelRequire("6cikW");


var $glTst = parcelRequire("glTst");


var $kzVdH = parcelRequire("kzVdH");


var $4ZFIE = parcelRequire("4ZFIE");

/**
 * Add a relationship between a space and current user.
 *
 * @param {Object} options
 * @param {String} options.relation - The relation between 2 entities
 * @param {String} options.key - The id of the entity
 * @param {String} options.action - The action to the entity
 * @param callback - The callback that handles the response.
 */ const $1536cf93d43d6602$var$relations = (options, callback)=>{
    const params = {
        sourceType: 'user',
        sourceKey: 'current',
        relationName: options.relation,
        targetType: 'Space',
        targetKey: options.key
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.RELATION_ENTITIES), params);
    if (options.action === 'add') (0, $4ZFIE.default).put(url, {
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        routeName: 'RELATION_ENTITIES'
    });
    else if (options.action === 'delete') (0, $4ZFIE.default).delete(url, {
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        routeName: 'RELATION_ENTITIES'
    });
};
function $1536cf93d43d6602$export$a941ed4b947d12f8(options, callback) {
    const defaultSpaceExpansions = 'icon,metadata.labels,operations,lookAndFeel,settings,theme';
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.SPACE), {
        spaceKey: options.spaceKey,
        expand: options.expand ? options.expand : defaultSpaceExpansions
    });
    (0, $4ZFIE.default).get(url, {
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        responseTransformer: (0, $kzVdH.spaceResponseTransformer),
        routeName: 'SPACE'
    });
}
module.exports["space"] = $1536cf93d43d6602$export$a941ed4b947d12f8;

});

parcelRegister("gCs5d", function(module, exports) {
parcelRequire("1wgMJ");
var $6cikW = parcelRequire("6cikW");


var $glTst = parcelRequire("glTst");


var $4ZFIE = parcelRequire("4ZFIE");

function $c195faa763349116$export$392f5cb0a0c7397a(options, callback) {
    const params = {
        contentId: options.contentId,
        propertyKey: options.propertyKey
    };
    const body = {
        value: options.propertyValue,
        version: {
            number: options.versionNumber,
            minorEdit: true
        }
    };
    const url = (0, $4ZFIE.default).getFullPath((0, $glTst.EDIT_PAGE_PROPERTIES), params);
    (0, $4ZFIE.default).put(url, {
        body: body,
        callback: callback,
        httpCodeHandlers: {
            401: ()=>(0, $6cikW.redirectToLoginPage)()
        },
        headers: {
            'Content-Type': 'application/json'
        },
        routeName: 'EDIT_PAGE_PROPERTIES'
    });
}
module.exports["updateContentProperty"] = $c195faa763349116$export$392f5cb0a0c7397a;

});

parcelRegister("6cikW", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");


var $jlIaF = parcelRequire("jlIaF");

function $4832165b3cb00945$export$53fdc13b0725dc2f() {
    (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).location = `${0, $jlIaF.CONTEXT_PATH}/login.action?os_destination=${(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).location.pathname.replace((0, $jlIaF.CONTEXT_PATH), '')}`;
}
module.exports["redirectToLoginPage"] = $4832165b3cb00945$export$53fdc13b0725dc2f;

});

parcelRegister("bqHkV", function(module, exports) {
'use strict';
module.exports.__esModule = true;

var $42omo = parcelRequire("42omo");

var $8523bd2615856c35$var$_react2 = $8523bd2615856c35$var$_interopRequireDefault($42omo);

var $4xcIM = parcelRequire("4xcIM");

var $8523bd2615856c35$var$_propTypes2 = $8523bd2615856c35$var$_interopRequireDefault($4xcIM);
function $8523bd2615856c35$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8523bd2615856c35$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8523bd2615856c35$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8523bd2615856c35$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8523bd2615856c35$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value);
            });
        }
    };
}
function $8523bd2615856c35$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
var $8523bd2615856c35$var$uniqueId = 0;
function $8523bd2615856c35$var$createReactContext(defaultValue) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = '__create-react-context-' + $8523bd2615856c35$var$uniqueId++ + '__';
    var Provider = function(_Component) {
        $8523bd2615856c35$var$_inherits(Provider, _Component);
        function Provider() {
            var _temp, _this, _ret;
            $8523bd2615856c35$var$_classCallCheck(this, Provider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $8523bd2615856c35$var$_possibleConstructorReturn(this, _Component.call.apply(_Component, [
                this
            ].concat(args))), _this), _this.emitter = $8523bd2615856c35$var$createEventEmitter(_this.props.value), _temp), $8523bd2615856c35$var$_possibleConstructorReturn(_this, _ret);
        }
        Provider.prototype.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) this.emitter.set(nextProps.value);
        };
        Provider.prototype.render = function render() {
            return this.props.children;
        };
        return Provider;
    }($42omo.Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = $8523bd2615856c35$var$_propTypes2.default.object.isRequired, _Provider$childContex);
    var Consumer = function(_Component2) {
        $8523bd2615856c35$var$_inherits(Consumer, _Component2);
        function Consumer() {
            var _temp2, _this2, _ret2;
            $8523bd2615856c35$var$_classCallCheck(this, Consumer);
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _ret2 = (_temp2 = (_this2 = $8523bd2615856c35$var$_possibleConstructorReturn(this, _Component2.call.apply(_Component2, [
                this
            ].concat(args))), _this2), _this2.state = {
                value: _this2.getValue()
            }, _this2.onUpdate = function() {
                _this2.setState({
                    value: _this2.getValue()
                });
            }, _temp2), $8523bd2615856c35$var$_possibleConstructorReturn(_this2, _ret2);
        }
        Consumer.prototype.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
        };
        Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        Consumer.prototype.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        Consumer.prototype.render = function render() {
            return $8523bd2615856c35$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }($42omo.Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = $8523bd2615856c35$var$_propTypes2.default.object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
module.exports.default = $8523bd2615856c35$var$createReactContext;
module.exports = module.exports['default'];

});

parcelRegister("3IHUl", function(module, exports) {
function $2227e9b979f2e945$export$3dbeb6d12a4c4b00(query) {
    // Early return for empty input
    const trimmed = query.trim();
    if (!trimmed) return '';
    return trimmed// Remove comments first, then normalize whitespace
    .replace(/#[^\r\n]*/g, '').replace(/\s+/g, ' ')// Remove operation names
    .replace(/\b(query|mutation|subscription)\s+[A-Za-z_][A-Za-z0-9_]*\s*([({])/g, '$1$2')// Clean up spacing around punctuation and keywords
    .replace(/\s*([{}():,])\s*|\b(query|mutation|subscription)\s+([({])/g, (_, punct, op, bracket)=>punct || op + bracket)// Handle fragment spacing
    .replace(/\bfragment\s+([A-Za-z_][A-Za-z0-9_]*)\s+on\s+/g, 'fragment $1 on ').trim();
}
module.exports["createIdentifierFromQuery"] = $2227e9b979f2e945$export$3dbeb6d12a4c4b00;

});

parcelRegister("2qNEJ", function(module, exports) {
'use strict';
var $1c54871bf38e90e7$var$resolvedPromise = Promise.resolve();
function $1c54871bf38e90e7$var$resolveImmediate(callback) {
    $1c54871bf38e90e7$var$resolvedPromise.then(callback)["catch"]($1c54871bf38e90e7$var$throwNext);
}
function $1c54871bf38e90e7$var$throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = $1c54871bf38e90e7$var$resolveImmediate;

});

parcelRegister("k4tKO", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $e9cb42e87ddcc173$var$_interopRequireDefault = $eGvGZ.default;

var $e9cb42e87ddcc173$var$_createForOfIteratorHelper2 = $e9cb42e87ddcc173$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $1YPEa = parcelRequire("1YPEa");


var $kin3U = parcelRequire("kin3U");


var $cCwaC = parcelRequire("cCwaC");


var $ceyF6 = parcelRequire("ceyF6");


var $fub1S = parcelRequire("fub1S");

var $e9cb42e87ddcc173$var$isClientID = $fub1S.isClientID;

var $k2eXq = parcelRequire("k2eXq");


var $buZz3 = parcelRequire("buZz3");


var $dMDnw = parcelRequire("dMDnw");

var $e9cb42e87ddcc173$var$getLocalVariables = $dMDnw.getLocalVariables;

var $jO6uW = parcelRequire("jO6uW");


var $eFVpV = parcelRequire("eFVpV");

var $e9cb42e87ddcc173$var$EXISTENT = $eFVpV.EXISTENT, $e9cb42e87ddcc173$var$UNKNOWN = $eFVpV.UNKNOWN;

var $jZOVE = parcelRequire("jZOVE");


var $a1r1h = parcelRequire("a1r1h");

var $e9cb42e87ddcc173$var$TYPE_SCHEMA_TYPE = $a1r1h.TYPE_SCHEMA_TYPE, $e9cb42e87ddcc173$var$generateTypeID = $a1r1h.generateTypeID;

var $q03Nf = parcelRequire("q03Nf");

var $e9cb42e87ddcc173$var$ACTOR_CHANGE = $ceyF6.ACTOR_CHANGE, $e9cb42e87ddcc173$var$CONDITION = $ceyF6.CONDITION, $e9cb42e87ddcc173$var$CLIENT_COMPONENT = $ceyF6.CLIENT_COMPONENT, $e9cb42e87ddcc173$var$CLIENT_EXTENSION = $ceyF6.CLIENT_EXTENSION, $e9cb42e87ddcc173$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $ceyF6.CLIENT_EDGE_TO_CLIENT_OBJECT, $e9cb42e87ddcc173$var$DEFER = $ceyF6.DEFER, $e9cb42e87ddcc173$var$FRAGMENT_SPREAD = $ceyF6.FRAGMENT_SPREAD, $e9cb42e87ddcc173$var$INLINE_FRAGMENT = $ceyF6.INLINE_FRAGMENT, $e9cb42e87ddcc173$var$LINKED_FIELD = $ceyF6.LINKED_FIELD, $e9cb42e87ddcc173$var$LINKED_HANDLE = $ceyF6.LINKED_HANDLE, $e9cb42e87ddcc173$var$MODULE_IMPORT = $ceyF6.MODULE_IMPORT, $e9cb42e87ddcc173$var$RELAY_RESOLVER = $ceyF6.RELAY_RESOLVER, $e9cb42e87ddcc173$var$RELAY_LIVE_RESOLVER = $ceyF6.RELAY_LIVE_RESOLVER, $e9cb42e87ddcc173$var$SCALAR_FIELD = $ceyF6.SCALAR_FIELD, $e9cb42e87ddcc173$var$SCALAR_HANDLE = $ceyF6.SCALAR_HANDLE, $e9cb42e87ddcc173$var$STREAM = $ceyF6.STREAM, $e9cb42e87ddcc173$var$TYPE_DISCRIMINATOR = $ceyF6.TYPE_DISCRIMINATOR;
var $e9cb42e87ddcc173$var$getModuleOperationKey = $jZOVE.getModuleOperationKey, $e9cb42e87ddcc173$var$getStorageKey = $jZOVE.getStorageKey, $e9cb42e87ddcc173$var$getArgumentValues = $jZOVE.getArgumentValues;
function $e9cb42e87ddcc173$var$check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new $e9cb42e87ddcc173$var$DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents);
    return checker.check(node, dataID);
}
var $e9cb42e87ddcc173$var$DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new $1YPEa(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new $kin3U(mutator, this._getDataID, undefined, this._handlers);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: 'missing',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: 'available',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $q03Nf(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === 'id' && field.alias == null && $e9cb42e87ddcc173$var$isClientID(dataID)) return undefined;
        var args = field.args != undefined ? $e9cb42e87ddcc173$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, $e9cb42e87ddcc173$var$_createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === 'scalar') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? $e9cb42e87ddcc173$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, $e9cb42e87ddcc173$var$_createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === 'linked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === $e9cb42e87ddcc173$var$EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? $e9cb42e87ddcc173$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, $e9cb42e87ddcc173$var$_createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === 'pluralLinked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === $e9cb42e87ddcc173$var$EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === $e9cb42e87ddcc173$var$UNKNOWN) this._handleMissing();
        if (status === $e9cb42e87ddcc173$var$EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = $jO6uW.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case $e9cb42e87ddcc173$var$SCALAR_FIELD:
                    _this2._checkScalar(selection, dataID);
                    break;
                case $e9cb42e87ddcc173$var$LINKED_FIELD:
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case $e9cb42e87ddcc173$var$ACTOR_CHANGE:
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case $e9cb42e87ddcc173$var$CONDITION:
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case $e9cb42e87ddcc173$var$INLINE_FRAGMENT:
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && $q03Nf(false);
                        var _typeID = $e9cb42e87ddcc173$var$generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) _this2._handleMissing();
                    }
                    break;
                case $e9cb42e87ddcc173$var$LINKED_HANDLE:
                    var handleField = $k2eXq(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case $e9cb42e87ddcc173$var$SCALAR_HANDLE:
                    var _handleField = $buZz3(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case $e9cb42e87ddcc173$var$MODULE_IMPORT:
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case $e9cb42e87ddcc173$var$DEFER:
                case $e9cb42e87ddcc173$var$STREAM:
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case $e9cb42e87ddcc173$var$FRAGMENT_SPREAD:
                    var prevVariables = _this2._variables;
                    _this2._variables = $e9cb42e87ddcc173$var$getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case $e9cb42e87ddcc173$var$CLIENT_EXTENSION:
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case $e9cb42e87ddcc173$var$TYPE_DISCRIMINATOR:
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && $q03Nf(false);
                    var typeID = $e9cb42e87ddcc173$var$generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) _this2._handleMissing();
                    break;
                case $e9cb42e87ddcc173$var$CLIENT_COMPONENT:
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case $e9cb42e87ddcc173$var$RELAY_RESOLVER:
                    _this2._checkResolver(selection, dataID);
                    break;
                case $e9cb42e87ddcc173$var$RELAY_LIVE_RESOLVER:
                    _this2._checkResolver(selection, dataID);
                    break;
                case $e9cb42e87ddcc173$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    $q03Nf(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $q03Nf(false);
        var operationKey = $e9cb42e87ddcc173$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $cCwaC(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $e9cb42e87ddcc173$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = $e9cb42e87ddcc173$var$getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = $e9cb42e87ddcc173$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = $e9cb42e87ddcc173$var$getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = $e9cb42e87ddcc173$var$getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? $jO6uW.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator4 = (0, $e9cb42e87ddcc173$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var concreteType = _step4.value;
                    var typeID = $e9cb42e87ddcc173$var$generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, $e9cb42e87ddcc173$var$TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: $e9cb42e87ddcc173$var$check
};

});

parcelRegister("e9MkZ", function(module, exports) {
'use strict';

var $1uPIp = parcelRequire("1uPIp");

var $a4e766cc98cd69bf$var$VIEWER_ID = $1uPIp.VIEWER_ID, $a4e766cc98cd69bf$var$VIEWER_TYPE = $1uPIp.VIEWER_TYPE;
function $a4e766cc98cd69bf$var$defaultGetDataID(fieldValue, typeName) {
    if (typeName === $a4e766cc98cd69bf$var$VIEWER_TYPE) return fieldValue.id == null ? $a4e766cc98cd69bf$var$VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = $a4e766cc98cd69bf$var$defaultGetDataID;

});

parcelRegister("v7WaB", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $05d90d886800acbb$var$_interopRequireDefault = $eGvGZ.default;

var $05d90d886800acbb$var$_objectSpread2 = $05d90d886800acbb$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $jO6uW = parcelRequire("jO6uW");


var $bsBg6 = parcelRequire("bsBg6");


var $q03Nf = parcelRequire("q03Nf");

var $05d90d886800acbb$var$UNPUBLISH_RECORD_SENTINEL = $jO6uW.fromObject(Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
}));
var $05d90d886800acbb$var$RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = $bsBg6.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== $05d90d886800acbb$var$UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === $05d90d886800acbb$var$UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return 'UNKNOWN';
        else if (record === null) return 'NONEXISTENT';
        else return 'EXISTENT';
    };
    _proto.clear = function clear() {
        this._base = $bsBg6.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, $05d90d886800acbb$var$UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, $05d90d886800acbb$var$_objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = $jO6uW.toJSON(record);
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function $05d90d886800acbb$var$create(base) {
    return new $05d90d886800acbb$var$RelayOptimisticRecordSource(base);
}
function $05d90d886800acbb$var$getOptimisticRecordIDs(source) {
    !(source instanceof $05d90d886800acbb$var$RelayOptimisticRecordSource) && $q03Nf(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: $05d90d886800acbb$var$create,
    getOptimisticRecordIDs: $05d90d886800acbb$var$getOptimisticRecordIDs
};

});

parcelRegister("3oKZ4", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $27980f049eebb45c$var$_interopRequireDefault = $eGvGZ.default;

var $27980f049eebb45c$var$_defineProperty2 = $27980f049eebb45c$var$_interopRequireDefault((parcelRequire("l2SD1")));

var $27980f049eebb45c$var$_createForOfIteratorHelper2 = $27980f049eebb45c$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $27980f049eebb45c$var$_toConsumableArray2 = $27980f049eebb45c$var$_interopRequireDefault((parcelRequire("aUSZ9")));

var $ceyF6 = parcelRequire("ceyF6");

var $27980f049eebb45c$var$ACTOR_CHANGE = $ceyF6.ACTOR_CHANGE, $27980f049eebb45c$var$ALIASED_FRAGMENT_SPREAD = $ceyF6.ALIASED_FRAGMENT_SPREAD, $27980f049eebb45c$var$ALIASED_INLINE_FRAGMENT_SPREAD = $ceyF6.ALIASED_INLINE_FRAGMENT_SPREAD, $27980f049eebb45c$var$CATCH_FIELD = $ceyF6.CATCH_FIELD, $27980f049eebb45c$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $ceyF6.CLIENT_EDGE_TO_CLIENT_OBJECT, $27980f049eebb45c$var$CLIENT_EDGE_TO_SERVER_OBJECT = $ceyF6.CLIENT_EDGE_TO_SERVER_OBJECT, $27980f049eebb45c$var$CLIENT_EXTENSION = $ceyF6.CLIENT_EXTENSION, $27980f049eebb45c$var$CONDITION = $ceyF6.CONDITION, $27980f049eebb45c$var$DEFER = $ceyF6.DEFER, $27980f049eebb45c$var$FRAGMENT_SPREAD = $ceyF6.FRAGMENT_SPREAD, $27980f049eebb45c$var$INLINE_DATA_FRAGMENT_SPREAD = $ceyF6.INLINE_DATA_FRAGMENT_SPREAD, $27980f049eebb45c$var$INLINE_FRAGMENT = $ceyF6.INLINE_FRAGMENT, $27980f049eebb45c$var$LINKED_FIELD = $ceyF6.LINKED_FIELD, $27980f049eebb45c$var$MODULE_IMPORT = $ceyF6.MODULE_IMPORT, $27980f049eebb45c$var$RELAY_LIVE_RESOLVER = $ceyF6.RELAY_LIVE_RESOLVER, $27980f049eebb45c$var$RELAY_RESOLVER = $ceyF6.RELAY_RESOLVER, $27980f049eebb45c$var$REQUIRED_FIELD = $ceyF6.REQUIRED_FIELD, $27980f049eebb45c$var$SCALAR_FIELD = $ceyF6.SCALAR_FIELD, $27980f049eebb45c$var$STREAM = $ceyF6.STREAM;

var $ek4t1 = parcelRequire("ek4t1");


var $fusLc = parcelRequire("fusLc");

var $27980f049eebb45c$var$isSuspenseSentinel = $fusLc.isSuspenseSentinel;

var $dMDnw = parcelRequire("dMDnw");


var $jO6uW = parcelRequire("jO6uW");


var $jZOVE = parcelRequire("jZOVE");

var $27980f049eebb45c$var$CLIENT_EDGE_TRAVERSAL_PATH = $jZOVE.CLIENT_EDGE_TRAVERSAL_PATH, $27980f049eebb45c$var$FRAGMENT_OWNER_KEY = $jZOVE.FRAGMENT_OWNER_KEY, $27980f049eebb45c$var$FRAGMENT_PROP_NAME_KEY = $jZOVE.FRAGMENT_PROP_NAME_KEY, $27980f049eebb45c$var$FRAGMENTS_KEY = $jZOVE.FRAGMENTS_KEY, $27980f049eebb45c$var$ID_KEY = $jZOVE.ID_KEY, $27980f049eebb45c$var$MODULE_COMPONENT_KEY = $jZOVE.MODULE_COMPONENT_KEY, $27980f049eebb45c$var$ROOT_ID = $jZOVE.ROOT_ID, $27980f049eebb45c$var$getArgumentValues = $jZOVE.getArgumentValues, $27980f049eebb45c$var$getModuleComponentKey = $jZOVE.getModuleComponentKey, $27980f049eebb45c$var$getStorageKey = $jZOVE.getStorageKey;

var $fYxua = parcelRequire("fYxua");

var $27980f049eebb45c$var$NoopResolverCache = $fYxua.NoopResolverCache;

var $lQmu3 = parcelRequire("lQmu3");

var $27980f049eebb45c$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL = $lQmu3.RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL, $27980f049eebb45c$var$withResolverContext = $lQmu3.withResolverContext;

var $a1r1h = parcelRequire("a1r1h");

var $27980f049eebb45c$var$generateTypeID = $a1r1h.generateTypeID;

var $q03Nf = parcelRequire("q03Nf");

function $27980f049eebb45c$var$read(recordSource, selector, resolverCache) {
    var reader = new $27980f049eebb45c$var$RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new $27980f049eebb45c$var$NoopResolverCache());
    return reader.read();
}
var $27980f049eebb45c$var$RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache) {
        var _selector$clientEdgeT;
        this._clientEdgeTraversalPath = (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, $27980f049eebb45c$var$_toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._missingRequiredFields = null;
        this._errorResponseFields = null;
        this._owner = selector.owner;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._resolverErrors = [];
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            var recordType = $jO6uW.getType(record);
            if (recordType !== node.type && dataID !== $27980f049eebb45c$var$ROOT_ID) isDataExpectedToBePresent = false;
        }
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) isDataExpectedToBePresent = false;
            else if (implementsInterface == null) this._isMissingData = true;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            missingRequiredFields: this._missingRequiredFields,
            relayResolverErrors: this._resolverErrors,
            errorResponseFields: this._errorResponseFields
        };
    };
    _proto._maybeAddErrorResponseFields = function _maybeAddErrorResponseFields(record, storageKey) {
        if (!$ek4t1.ENABLE_FIELD_ERROR_HANDLING) return;
        var errors = $jO6uW.getErrors(record, storageKey);
        if (errors == null) return;
        var owner = this._fragmentName;
        if (this._errorResponseFields == null) this._errorResponseFields = [];
        var _iterator = (0, $27980f049eebb45c$var$_createForOfIteratorHelper2["default"])(errors), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _error$path;
                var error = _step.value;
                this._errorResponseFields.push({
                    owner: owner,
                    path: ((_error$path = error.path) !== null && _error$path !== void 0 ? _error$path : []).join('.'),
                    error: error
                });
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    _proto._markDataAsMissing = function _markDataAsMissing() {
        this._isMissingData = true;
        if (this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing();
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $q03Nf(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(fieldPath, action) {
        var _this$_missingRequire;
        if (((_this$_missingRequire = this._missingRequiredFields) === null || _this$_missingRequire === void 0 ? void 0 : _this$_missingRequire.action) === 'THROW') return;
        var owner = this._fragmentName;
        switch(action){
            case 'THROW':
                this._missingRequiredFields = {
                    action: action,
                    field: {
                        path: fieldPath,
                        owner: owner
                    }
                };
                return;
            case 'LOG':
                if (this._missingRequiredFields == null) this._missingRequiredFields = {
                    action: action,
                    fields: [
                        {
                            path: fieldPath,
                            owner: owner
                        }
                    ]
                };
                else this._missingRequiredFields = {
                    action: action,
                    fields: [].concat((0, $27980f049eebb45c$var$_toConsumableArray2["default"])(this._missingRequiredFields.fields), [
                        {
                            path: fieldPath,
                            owner: owner
                        }
                    ])
                };
                return;
            default:
                action;
        }
    };
    _proto._handleCatchFieldValue = function _handleCatchFieldValue(selection, record, data, value) {
        var _selection$field$back, _selection$field, _field$alias, _this$_missingRequire2;
        var to = selection.to;
        var field = (_selection$field$back = (_selection$field = selection.field) === null || _selection$field === void 0 ? void 0 : _selection$field.backingField) !== null && _selection$field$back !== void 0 ? _selection$field$back : selection.field;
        var fieldName = (_field$alias = field === null || field === void 0 ? void 0 : field.alias) !== null && _field$alias !== void 0 ? _field$alias : field === null || field === void 0 ? void 0 : field.name;
        !(fieldName != null) && $q03Nf(false);
        if (this._errorResponseFields != null) for(var i = 0; i < this._errorResponseFields.length; i++)this._errorResponseFields[i].to = to;
        if (((_this$_missingRequire2 = this._missingRequiredFields) === null || _this$_missingRequire2 === void 0 ? void 0 : _this$_missingRequire2.action) === 'THROW') {
            var _this$_missingRequire3;
            if (((_this$_missingRequire3 = this._missingRequiredFields) === null || _this$_missingRequire3 === void 0 ? void 0 : _this$_missingRequire3.field) == null) return;
            if (this._errorResponseFields == null) this._errorResponseFields = [];
            var _this$_missingRequire4 = this._missingRequiredFields.field, owner = _this$_missingRequire4.owner, path = _this$_missingRequire4.path;
            this._errorResponseFields.push({
                owner: owner,
                path: path,
                error: {
                    message: "Relay: Missing @required value at path '".concat(path, "' in '").concat(owner, "'.")
                },
                to: to
            });
            this._missingRequiredFields = null;
            return;
        }
        if (this._errorResponseFields != null) {
            var errors = this._errorResponseFields.map(function(error) {
                return error.error;
            });
            data[fieldName] = {
                ok: false,
                errors: errors
            };
            return;
        }
        data[fieldName] = {
            ok: true,
            value: value
        };
    };
    _proto._handleRequiredFieldValue = function _handleRequiredFieldValue(selection, value) {
        if (value == null) {
            var action = selection.action;
            if (action !== 'NONE') this._maybeReportUnexpectedNull(selection.path, action);
            return false;
        }
        return true;
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case $27980f049eebb45c$var$REQUIRED_FIELD:
                    var requiredFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (!this._handleRequiredFieldValue(selection, requiredFieldValue)) return false;
                    break;
                case $27980f049eebb45c$var$CATCH_FIELD:
                    var catchFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if ($ek4t1.ENABLE_FIELD_ERROR_HANDLING_CATCH_DIRECTIVE) {
                        if (selection.to != 'NULL') this._handleCatchFieldValue(selection, record, data, catchFieldValue);
                    }
                    break;
                case $27980f049eebb45c$var$SCALAR_FIELD:
                    this._readScalar(selection, record, data);
                    break;
                case $27980f049eebb45c$var$LINKED_FIELD:
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case $27980f049eebb45c$var$CONDITION:
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case $27980f049eebb45c$var$INLINE_FRAGMENT:
                    if (this._readInlineFragment(selection, record, data) === false) return false;
                    break;
                case $27980f049eebb45c$var$RELAY_LIVE_RESOLVER:
                case $27980f049eebb45c$var$RELAY_RESOLVER:
                    if (!$ek4t1.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                    this._readResolverField(selection, record, data);
                    break;
                case $27980f049eebb45c$var$FRAGMENT_SPREAD:
                    this._createFragmentPointer(selection, record, data);
                    break;
                case $27980f049eebb45c$var$ALIASED_FRAGMENT_SPREAD:
                    data[selection.name] = this._createAliasedFragmentSpread(selection, record);
                    break;
                case $27980f049eebb45c$var$ALIASED_INLINE_FRAGMENT_SPREAD:
                    var fieldValue = this._readInlineFragment(selection.fragment, record, {});
                    if (fieldValue === false) fieldValue = null;
                    data[selection.name] = fieldValue;
                    break;
                case $27980f049eebb45c$var$MODULE_IMPORT:
                    this._readModuleImport(selection, record, data);
                    break;
                case $27980f049eebb45c$var$INLINE_DATA_FRAGMENT_SPREAD:
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case $27980f049eebb45c$var$DEFER:
                case $27980f049eebb45c$var$CLIENT_EXTENSION:
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData = this._traverseSelections(selection.selections, record, data);
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData) return false;
                    break;
                case $27980f049eebb45c$var$STREAM:
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData2) return false;
                    break;
                case $27980f049eebb45c$var$ACTOR_CHANGE:
                    this._readActorChange(selection, record, data);
                    break;
                case $27980f049eebb45c$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                case $27980f049eebb45c$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                    this._readClientEdge(selection, record, data);
                    break;
                default:
                    selection;
                    $q03Nf(false);
            }
        }
        return true;
    };
    _proto._readClientSideDirectiveField = function _readClientSideDirectiveField(selection, record, data) {
        switch(selection.field.kind){
            case $27980f049eebb45c$var$SCALAR_FIELD:
                return this._readScalar(selection.field, record, data);
            case $27980f049eebb45c$var$LINKED_FIELD:
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case $27980f049eebb45c$var$RELAY_RESOLVER:
                if (!$ek4t1.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readResolverField(selection.field, record, data);
            case $27980f049eebb45c$var$RELAY_LIVE_RESOLVER:
                if (!$ek4t1.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readResolverField(selection.field, record, data);
            case $27980f049eebb45c$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
            case $27980f049eebb45c$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                if (!$ek4t1.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readClientEdge(selection.field, record, data);
            default:
                selection.field.kind;
                $q03Nf(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _field$alias2;
        var parentRecordID = $jO6uW.getDataID(record);
        var result = this._readResolverFieldImpl(field, parentRecordID);
        var fieldName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        data[fieldName] = result;
        return result;
    };
    _proto._readResolverFieldImpl = function _readResolverFieldImpl(field, parentRecordID) {
        var _this = this;
        var fragment = field.fragment;
        var snapshot;
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData
            };
            snapshot = $27980f049eebb45c$var$read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData
            };
        };
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, $27980f049eebb45c$var$_defineProperty2["default"])({}, fragment.name, fragment.args ? $27980f049eebb45c$var$getArgumentValues(fragment.args, _this._variables) : {})
                };
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return $27980f049eebb45c$var$withResolverContext(resolverContext, function() {
                    var _getResolverValue = $27980f049eebb45c$var$getResolverValue(field, _this._variables, key), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = $27980f049eebb45c$var$getResolverValue(field, _this._variables, null), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        this._propogateResolverMetadata(field.path, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs);
        return result;
    };
    _proto._propogateResolverMetadata = function _propogateResolverMetadata(fieldPath, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs) {
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingRequiredFields != null) this._addMissingRequiredFields(cachedSnapshot.missingRequiredFields);
            if (cachedSnapshot.missingClientEdges != null) {
                var _iterator2 = (0, $27980f049eebb45c$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingClientEdges), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var missing = _step2.value;
                        this._missingClientEdges.push(missing);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                var _iterator3 = (0, $27980f049eebb45c$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingLiveResolverFields), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var missingResolverField = _step3.value;
                        this._missingLiveResolverFields.push(missingResolverField);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            }
            var _iterator4 = (0, $27980f049eebb45c$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.relayResolverErrors), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var error = _step4.value;
                    this._resolverErrors.push(error);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        if (resolverError) this._resolverErrors.push({
            field: {
                path: fieldPath,
                owner: this._fragmentName
            },
            error: resolverError
        });
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push({
                path: "".concat(this._fragmentName, ".").concat(fieldPath),
                liveStateID: suspenseID
            });
        }
        if (updatedDataIDs != null) {
            var _iterator5 = (0, $27980f049eebb45c$var$_createForOfIteratorHelper2["default"])(updatedDataIDs), _step5;
            try {
                for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                    var recordID = _step5.value;
                    this._updatedDataIDs.add(recordID);
                }
            } catch (err) {
                _iterator5.e(err);
            } finally{
                _iterator5.f();
            }
        }
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _this2 = this;
        var _backingField$alias;
        var backingField = field.backingField;
        !(backingField.kind !== 'ClientExtension') && $q03Nf(false);
        var fieldName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        var clientEdgeResolverResponse = backingFieldData[fieldName];
        if (clientEdgeResolverResponse == null || $27980f049eebb45c$var$isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[fieldName] = clientEdgeResolverResponse;
            return clientEdgeResolverResponse;
        }
        if (field.linkedField.plural) {
            !Array.isArray(clientEdgeResolverResponse) && $q03Nf(false);
            var storeIDs;
            !(field.kind === $27980f049eebb45c$var$CLIENT_EDGE_TO_CLIENT_OBJECT) && $q03Nf(false);
            if (field.backingField.normalizationInfo == null) storeIDs = clientEdgeResolverResponse.map(function(itemResponse) {
                var _field$concreteType;
                var concreteType = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : itemResponse.__typename;
                !(typeof concreteType === 'string') && $q03Nf(false);
                var localId = $27980f049eebb45c$var$extractIdFromResponse(itemResponse);
                var id = _this2._resolverCache.ensureClientRecord(localId, concreteType);
                var modelResolvers = field.modelResolvers;
                if (modelResolvers != null) {
                    var modelResolver = modelResolvers[concreteType];
                    !(modelResolver !== undefined) && $q03Nf(false);
                    var model = _this2._readResolverFieldImpl(modelResolver, id);
                    return model != null ? id : null;
                }
                return id;
            });
            else storeIDs = clientEdgeResolverResponse.map($27980f049eebb45c$var$extractIdFromResponse);
            this._clientEdgeTraversalPath.push(null);
            var edgeValues = this._readLinkedIds(field.linkedField, storeIDs, record, data);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValues;
            return edgeValues;
        } else {
            var _field$concreteType2;
            var id = $27980f049eebb45c$var$extractIdFromResponse(clientEdgeResolverResponse);
            var storeID;
            var concreteType = (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : clientEdgeResolverResponse.__typename;
            var traversalPathSegment;
            if (field.kind === $27980f049eebb45c$var$CLIENT_EDGE_TO_CLIENT_OBJECT) {
                if (field.backingField.normalizationInfo == null) {
                    !(typeof concreteType === 'string') && $q03Nf(false);
                    storeID = this._resolverCache.ensureClientRecord(id, concreteType);
                    traversalPathSegment = null;
                } else {
                    storeID = id;
                    traversalPathSegment = null;
                }
            } else {
                storeID = id;
                traversalPathSegment = {
                    readerClientEdge: field,
                    clientEdgeDestinationID: id
                };
            }
            var modelResolvers = field.modelResolvers;
            if (modelResolvers != null) {
                !(typeof concreteType === 'string') && $q03Nf(false);
                var modelResolver = modelResolvers[concreteType];
                !(modelResolver !== undefined) && $q03Nf(false);
                var model = this._readResolverFieldImpl(modelResolver, storeID);
                if (model == null) {
                    data[fieldName] = null;
                    return null;
                }
            }
            this._clientEdgeTraversalPath.push(traversalPathSegment);
            var prevData = data[fieldName];
            !(prevData == null || typeof prevData === 'object') && $q03Nf(false);
            var edgeValue = this._traverse(field.linkedField, storeID, prevData);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValue;
            return edgeValue;
        }
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var fieldName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = $27980f049eebb45c$var$getStorageKey(field, this._variables);
        var value = $jO6uW.getValue(record, storageKey);
        if (value === null) this._maybeAddErrorResponseFields(record, storageKey);
        else if (value === undefined) this._markDataAsMissing();
        data[fieldName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var fieldName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = $27980f049eebb45c$var$getStorageKey(field, this._variables);
        var linkedID = $jO6uW.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[fieldName] = linkedID;
            if (linkedID === null) this._maybeAddErrorResponseFields(record, storageKey);
            else if (linkedID === undefined) this._markDataAsMissing();
            return linkedID;
        }
        var prevData = data[fieldName];
        !(prevData == null || typeof prevData === 'object') && $q03Nf(false);
        var value = this._traverse(field, linkedID, prevData);
        data[fieldName] = value;
        return value;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var fieldName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = $27980f049eebb45c$var$getStorageKey(field, this._variables);
        var externalRef = $jO6uW.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[fieldName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing();
            else if (externalRef === null) this._maybeAddErrorResponseFields(record, storageKey);
            return data[fieldName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, $jO6uW.fromObject({
            __id: dataID
        }), fragmentRef);
        data[fieldName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[fieldName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = $27980f049eebb45c$var$getStorageKey(field, this._variables);
        var linkedIDs = $jO6uW.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs === null) this._maybeAddErrorResponseFields(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this3 = this;
        var _field$alias6;
        var fieldName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[fieldName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing();
            return linkedIDs;
        }
        var prevData = data[fieldName];
        !(prevData == null || Array.isArray(prevData)) && $q03Nf(false);
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this3._markDataAsMissing();
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === 'object') && $q03Nf(false);
            linkedArray[nextIndex] = _this3._traverse(field, linkedID, prevItem);
        });
        data[fieldName] = linkedArray;
        return linkedArray;
    };
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        var componentKey = $27980f049eebb45c$var$getModuleComponentKey(moduleImport.documentName);
        var component = $jO6uW.getValue(record, componentKey);
        if (component == null) {
            if (component === undefined) this._markDataAsMissing();
            return;
        }
        this._createFragmentPointer({
            kind: 'FragmentSpread',
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[$27980f049eebb45c$var$FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[$27980f049eebb45c$var$MODULE_COMPONENT_KEY] = component;
    };
    _proto._createAliasedFragmentSpread = function _createAliasedFragmentSpread(namedFragmentSpread, record) {
        var abstractKey = namedFragmentSpread.abstractKey;
        if (abstractKey == null) {
            var typeName = $jO6uW.getType(record);
            if (typeName == null || typeName !== namedFragmentSpread.type) return null;
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) return null;
            else if (implementsInterface == null) {
                this._markDataAsMissing();
                return undefined;
            }
        }
        var fieldData = {};
        this._createFragmentPointer(namedFragmentSpread.fragment, record, fieldData);
        return $jO6uW.fromObject(fieldData);
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data) {
        if (inlineFragment.type == null) {
            var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
            if (hasExpectedData === false) return false;
            return data;
        }
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            var typeName = $jO6uW.getType(record);
            if (typeName == null || typeName !== inlineFragment.type) return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            this._traverseSelections(inlineFragment.selections, record, data);
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                this._isMissingData = parentIsMissingData;
                return undefined;
            } else if (implementsInterface == null) {
                this._markDataAsMissing();
                return null;
            }
        }
        return data;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[$27980f049eebb45c$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$27980f049eebb45c$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $q03Nf(false);
        if (data[$27980f049eebb45c$var$ID_KEY] == null) data[$27980f049eebb45c$var$ID_KEY] = $jO6uW.getDataID(record);
        fragmentPointers[fragmentSpread.name] = $27980f049eebb45c$var$getArgumentValues(fragmentSpread.args, this._variables, this._isWithinUnmatchedTypeRefinement);
        data[$27980f049eebb45c$var$FRAGMENT_OWNER_KEY] = this._owner;
        if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[$27980f049eebb45c$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $27980f049eebb45c$var$_toConsumableArray2["default"])(this._clientEdgeTraversalPath);
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[$27980f049eebb45c$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$27980f049eebb45c$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $q03Nf(false);
        if (data[$27980f049eebb45c$var$ID_KEY] == null) data[$27980f049eebb45c$var$ID_KEY] = $jO6uW.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        var argumentVariables = fragmentSpreadOrFragment.args ? $27980f049eebb45c$var$getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = $dMDnw.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._addMissingRequiredFields = function _addMissingRequiredFields(additional) {
        if (this._missingRequiredFields == null) {
            this._missingRequiredFields = additional;
            return;
        }
        if (this._missingRequiredFields.action === 'THROW') return;
        if (additional.action === 'THROW') {
            this._missingRequiredFields = additional;
            return;
        }
        this._missingRequiredFields = {
            action: 'LOG',
            fields: [].concat((0, $27980f049eebb45c$var$_toConsumableArray2["default"])(this._missingRequiredFields.fields), (0, $27980f049eebb45c$var$_toConsumableArray2["default"])(additional.fields))
        };
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = $jO6uW.getType(record);
        var typeRecord = this._recordSource.get($27980f049eebb45c$var$generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? $jO6uW.getValue(typeRecord, abstractKey) : null;
        return implementsInterface;
    };
    return RelayReader;
}();
function $27980f049eebb45c$var$getResolverValue(field, variables, fragmentKey) {
    var resolverFunction = typeof field.resolverModule === 'function' ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? $27980f049eebb45c$var$getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        if (e === $27980f049eebb45c$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL) resolverResult = undefined;
        else resolverError = e;
    }
    return [
        resolverResult,
        resolverError
    ];
}
function $27980f049eebb45c$var$extractIdFromResponse(individualResponse) {
    if (typeof individualResponse === 'string') return individualResponse;
    else if (typeof individualResponse === 'object' && individualResponse != null && typeof individualResponse.id === 'string') return individualResponse.id;
    $q03Nf(false);
}
module.exports = {
    read: $27980f049eebb45c$var$read
};

});

parcelRegister("cJt0g", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $94502f6e2848b2cf$var$_interopRequireDefault = $eGvGZ.default;

var $94502f6e2848b2cf$var$_createForOfIteratorHelper2 = $94502f6e2848b2cf$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $cCwaC = parcelRequire("cCwaC");


var $ceyF6 = parcelRequire("ceyF6");


var $k2eXq = parcelRequire("k2eXq");


var $4Wu1d = parcelRequire("4Wu1d");


var $dMDnw = parcelRequire("dMDnw");

var $94502f6e2848b2cf$var$getLocalVariables = $dMDnw.getLocalVariables;

var $jO6uW = parcelRequire("jO6uW");


var $jZOVE = parcelRequire("jZOVE");


var $a1r1h = parcelRequire("a1r1h");

var $94502f6e2848b2cf$var$generateTypeID = $a1r1h.generateTypeID;

var $q03Nf = parcelRequire("q03Nf");

var $94502f6e2848b2cf$var$ACTOR_CHANGE = $ceyF6.ACTOR_CHANGE, $94502f6e2848b2cf$var$CONDITION = $ceyF6.CONDITION, $94502f6e2848b2cf$var$CLIENT_COMPONENT = $ceyF6.CLIENT_COMPONENT, $94502f6e2848b2cf$var$CLIENT_EXTENSION = $ceyF6.CLIENT_EXTENSION, $94502f6e2848b2cf$var$DEFER = $ceyF6.DEFER, $94502f6e2848b2cf$var$FRAGMENT_SPREAD = $ceyF6.FRAGMENT_SPREAD, $94502f6e2848b2cf$var$INLINE_FRAGMENT = $ceyF6.INLINE_FRAGMENT, $94502f6e2848b2cf$var$LINKED_FIELD = $ceyF6.LINKED_FIELD, $94502f6e2848b2cf$var$MODULE_IMPORT = $ceyF6.MODULE_IMPORT, $94502f6e2848b2cf$var$LINKED_HANDLE = $ceyF6.LINKED_HANDLE, $94502f6e2848b2cf$var$SCALAR_FIELD = $ceyF6.SCALAR_FIELD, $94502f6e2848b2cf$var$SCALAR_HANDLE = $ceyF6.SCALAR_HANDLE, $94502f6e2848b2cf$var$STREAM = $ceyF6.STREAM, $94502f6e2848b2cf$var$TYPE_DISCRIMINATOR = $ceyF6.TYPE_DISCRIMINATOR, $94502f6e2848b2cf$var$RELAY_RESOLVER = $ceyF6.RELAY_RESOLVER, $94502f6e2848b2cf$var$RELAY_LIVE_RESOLVER = $ceyF6.RELAY_LIVE_RESOLVER, $94502f6e2848b2cf$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $ceyF6.CLIENT_EDGE_TO_CLIENT_OBJECT;
var $94502f6e2848b2cf$var$getStorageKey = $jZOVE.getStorageKey, $94502f6e2848b2cf$var$getModuleOperationKey = $jZOVE.getModuleOperationKey;
function $94502f6e2848b2cf$var$mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new $94502f6e2848b2cf$var$RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents);
    marker.mark(node, dataID);
}
var $94502f6e2848b2cf$var$RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === 'Operation' || node.kind === 'SplitOperation') this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $q03Nf(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case $94502f6e2848b2cf$var$ACTOR_CHANGE:
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case $94502f6e2848b2cf$var$LINKED_FIELD:
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case $94502f6e2848b2cf$var$CONDITION:
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case $94502f6e2848b2cf$var$INLINE_FRAGMENT:
                    if (selection.abstractKey == null) {
                        var typeName = $jO6uW.getType(record);
                        if (typeName != null && typeName === selection.type || typeName === $jZOVE.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = $jO6uW.getType(record);
                        var typeID = $94502f6e2848b2cf$var$generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case $94502f6e2848b2cf$var$FRAGMENT_SPREAD:
                    var prevVariables = _this._variables;
                    _this._variables = $94502f6e2848b2cf$var$getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case $94502f6e2848b2cf$var$LINKED_HANDLE:
                    var handleField = $k2eXq(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case $94502f6e2848b2cf$var$DEFER:
                case $94502f6e2848b2cf$var$STREAM:
                    _this._traverseSelections(selection.selections, record);
                    break;
                case $94502f6e2848b2cf$var$SCALAR_FIELD:
                case $94502f6e2848b2cf$var$SCALAR_HANDLE:
                    break;
                case $94502f6e2848b2cf$var$TYPE_DISCRIMINATOR:
                    var _typeName2 = $jO6uW.getType(record);
                    var _typeID = $94502f6e2848b2cf$var$generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case $94502f6e2848b2cf$var$MODULE_IMPORT:
                    _this._traverseModuleImport(selection, record);
                    break;
                case $94502f6e2848b2cf$var$CLIENT_EXTENSION:
                    _this._traverseSelections(selection.selections, record);
                    break;
                case $94502f6e2848b2cf$var$CLIENT_COMPONENT:
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case $94502f6e2848b2cf$var$RELAY_RESOLVER:
                    _this._traverseResolverField(selection, record);
                    break;
                case $94502f6e2848b2cf$var$RELAY_LIVE_RESOLVER:
                    _this._traverseResolverField(selection, record);
                    break;
                case $94502f6e2848b2cf$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    $q03Nf(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            var outputTypeRecordIDs = $4Wu1d(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, $94502f6e2848b2cf$var$_createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) return;
            if (linkedField.plural) {
                var dataIDs = $jO6uW.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, $94502f6e2848b2cf$var$_createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = $jO6uW.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        var storageKey = $94502f6e2848b2cf$var$getStorageKey(field, this._variables);
        var dataID = $jO6uW.getLinkedRecordID(record, storageKey);
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $q03Nf(false);
        var operationKey = $94502f6e2848b2cf$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = $jO6uW.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $cCwaC(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $94502f6e2848b2cf$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = $94502f6e2848b2cf$var$getStorageKey(field, this._variables);
        var linkedID = $jO6uW.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = $94502f6e2848b2cf$var$getStorageKey(field, this._variables);
        var linkedIDs = $jO6uW.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: $94502f6e2848b2cf$var$mark
};

});

parcelRegister("bxVYb", function(module, exports) {
'use strict';
parcelRequire("kiICD");


var $kU32t = parcelRequire("kU32t");


var $ek4t1 = parcelRequire("ek4t1");


var $j7VPM = parcelRequire("j7VPM");


var $6fWGE = parcelRequire("6fWGE");


var $3oKZ4 = parcelRequire("3oKZ4");

var $867fbe5cd2934921$var$RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = $3oKZ4.read(source, snapshot.selector, _this2._resolverCache);
            var nextData = $kU32t(snapshot.data, backup.data);
            backup.data = nextData;
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    missingRequiredFields: backup.missingRequiredFields,
                    relayResolverErrors: backup.relayResolverErrors,
                    errorResponseFields: backup.errorResponseFields
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && $j7VPM(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? $3oKZ4.read(source, snapshot.selector, this._resolverCache) : backup;
        var nextData = $kU32t(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            missingRequiredFields: nextSnapshot.missingRequiredFields,
            relayResolverErrors: nextSnapshot.relayResolverErrors,
            errorResponseFields: nextSnapshot.errorResponseFields
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && $ek4t1.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: 'store.notify.subscription',
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
        if ($ek4t1.ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION && (stale || $6fWGE(snapshot.seenRecords, updatedRecordIDs))) return snapshot.selector.owner;
    };
    return RelayStoreSubscriptions;
}();
module.exports = $867fbe5cd2934921$var$RelayStoreSubscriptions;

});

parcelRegister("kU32t", function(module, exports) {
'use strict';
function $f37b650c588ba627$var$recycleNodesInto(prevData, nextData) {
    return $f37b650c588ba627$var$recycleNodesIntoImpl(prevData, nextData, true);
}
function $f37b650c588ba627$var$recycleNodesIntoImpl(prevData, nextData, canMutate) {
    if (prevData === nextData || typeof prevData !== 'object' || !prevData || prevData.constructor !== Object && !Array.isArray(prevData) || typeof nextData !== 'object' || !nextData || nextData.constructor !== Object && !Array.isArray(nextData)) return nextData;
    var canRecycle = false;
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) {
        var canMutateNext = canMutate && !Object.isFrozen(nextArray);
        canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
            var prevValue = prevArray[ii];
            var nextValue = $f37b650c588ba627$var$recycleNodesIntoImpl(prevValue, nextItem, canMutateNext);
            if (nextValue !== nextArray[ii] && canMutateNext) nextArray[ii] = nextValue;
            return wasEqual && nextValue === prevArray[ii];
        }, true) && prevArray.length === nextArray.length;
    } else if (!prevArray && !nextArray) {
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        var _canMutateNext = canMutate && !Object.isFrozen(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = $f37b650c588ba627$var$recycleNodesIntoImpl(prevValue, nextObject[key], _canMutateNext);
            if (nextValue !== nextObject[key] && _canMutateNext) nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = $f37b650c588ba627$var$recycleNodesInto;

});

parcelRegister("fu0yr", function(module, exports) {
'use strict';
module.exports = function shallowFreeze(value) {
    if (typeof value === 'object' && value != null && (Array.isArray(value) || value.constructor === Object)) Object.freeze(value);
};

});

parcelRegister("4Wu1d", function(module, exports) {
'use strict';

var $jO6uW = parcelRequire("jO6uW");


var $jZOVE = parcelRequire("jZOVE");

var $3993dd422e78969e$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $jZOVE.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;

var $q03Nf = parcelRequire("q03Nf");

function $3993dd422e78969e$var$getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = $jO6uW.getValue(record, $3993dd422e78969e$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && $q03Nf(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = $3993dd422e78969e$var$getOutputTypeRecordIDs;

});

parcelRegister("2gQQV", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");

const $00d790897fd8fcbc$var$branchSlug = typeof $kyRHQ !== 'undefined' && $kyRHQ.env ? undefined : undefined;
const $00d790897fd8fcbc$export$8f8c52ac77845a86 = `/gateway/api/graphql${$00d790897fd8fcbc$var$branchSlug ? `/${$00d790897fd8fcbc$var$branchSlug}/graphql` : ''}`;
const $00d790897fd8fcbc$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    let endpoint = $00d790897fd8fcbc$export$8f8c52ac77845a86;
    if (cacheConfig.metadata?.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    return `${endpoint}?operation=${request.name}`;
};
const $00d790897fd8fcbc$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};
module.exports["getAggEndpoint"] = $00d790897fd8fcbc$export$fd126d8de571b77d;
module.exports["getRequestBody"] = $00d790897fd8fcbc$export$55bce18df99af758;

});

parcelRegister("bDPoq", function(module, exports) {
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
const $ab3c8df02f85ed39$export$ebe3a775ce3053a5 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];
module.exports["RelayExperimentalApis"] = $ab3c8df02f85ed39$export$ebe3a775ce3053a5;

});

parcelRegister("33JSI", function(module, exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $23a53e0237b082ca$var$isNil(value) {
    return value == null;
}
module.exports = $23a53e0237b082ca$var$isNil;

});

parcelRegister("7Gyt2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kyKWe = parcelRequire("kyKWe");


var $kDuN4 = parcelRequire("kDuN4");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");








var $iu6oZ = parcelRequire("iu6oZ");

const $3610af1ecb1deabe$var$atlaskitRegistry = {
    [(0, $iu6oZ.START_TOUCH)]: [
        {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'productLogo'
        },
        {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'recentIcon'
        },
        {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'quickSearch'
        },
        {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'notifications'
        },
        {
            action: 'clicked',
            actionSubject: 'smartLink'
        },
        {
            action: 'dismissed',
            actionSubject: 'drawer'
        },
        {
            action: 'selected',
            actionSubject: 'navigationItem',
            actionSubjectId: 'searchResult'
        },
        {
            action: 'selected',
            actionSubject: 'navigationItem',
            actionSubjectId: 'advanced_search_confluence'
        }
    ]
};
const $3610af1ecb1deabe$export$203e3ae7319f8133 = ({ children: children })=>{
    const onEvent = (event)=>{
        for(const type in $3610af1ecb1deabe$var$atlaskitRegistry)if ($3610af1ecb1deabe$var$atlaskitRegistry[type].some((entry)=>Object.keys(entry).every((key)=>entry[key] === event.payload[key]))) event.update((payload)=>({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    navdexPointType: type
                }
            }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: onEvent,
        channel: "*"
    }, children);
};





const $b052390ea3c4f36a$var$SESSION_EXPIRE_MILLIS = 600000;
const $b052390ea3c4f36a$var$loadSession = ()=>{
    const sessionString = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).NAVDEX_STORAGE_KEY);
    if (!sessionString) return null;
    const session = JSON.parse(sessionString);
    session.updated = new Date(session.updated);
    return session;
};
const $b052390ea3c4f36a$export$13953a62d51faabe = ({ children: children })=>{
    const session = (0, $42omo.useRef)($b052390ea3c4f36a$var$loadSession());
    const setSession = (newSession)=>{
        session.current = newSession;
        if (!session.current) (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).NAVDEX_STORAGE_KEY);
        else if (session.current.updateStorage) try {
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).NAVDEX_STORAGE_KEY, JSON.stringify(session.current));
        } catch (e) {
            (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).NAVDEX_STORAGE_KEY);
        }
    };
    (0, $42omo.useEffect)(()=>{
        const storageListener = (event)=>{
            if (event.key === (0, $1UApO.keys).NAVDEX_STORAGE_KEY) {
                const newSession = $b052390ea3c4f36a$var$loadSession();
                if (newSession) touchSession(newSession.id, false);
                else setSession(null);
            }
        };
        window.addEventListener('storage', storageListener);
        return ()=>{
            window.removeEventListener('storage', storageListener);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const updateEvent = (event, navigationSessionId, pointTypeOverride)=>{
        if (event.payload.data) event.update((payload)=>({
                ...payload,
                data: {
                    ...payload.data,
                    attributes: {
                        ...payload.data.attributes,
                        navigationSessionId: navigationSessionId,
                        navdexPointType: pointTypeOverride || payload.data.attributes.navdexPointType
                    }
                }
            }));
        else // Atlaskit events lack the data object
        event.update((payload)=>({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    navigationSessionId: navigationSessionId,
                    navdexPointType: pointTypeOverride || payload.attributes.navdexPointType
                }
            }));
    };
    const touchSession = (sessionId, updateStorage = true)=>{
        setSession({
            id: sessionId,
            updated: new Date(),
            updateStorage: updateStorage
        });
    };
    const handleTouchPoint = (event)=>{
        const type = event?.payload?.data?.attributes?.navdexPointType || // Atlaskit events lack the data object
        event?.payload?.attributes?.navdexPointType;
        let sessionId = session.current && session.current.id;
        if (session.current && Date.now() - session.current.updated.getTime() > $b052390ea3c4f36a$var$SESSION_EXPIRE_MILLIS) {
            setSession(null);
            sessionId = null;
        }
        switch(type){
            case 0, $iu6oZ.START:
                const newSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
                updateEvent(event, newSessionId);
                touchSession(newSessionId);
                break;
            case 0, $iu6oZ.START_TOUCH:
                const actualPointType = sessionId ? (0, $iu6oZ.TOUCH) : (0, $iu6oZ.START);
                sessionId = sessionId || (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
                updateEvent(event, sessionId, actualPointType);
                touchSession(sessionId);
                break;
            case 0, $iu6oZ.TOUCH:
                if (sessionId) {
                    updateEvent(event, sessionId);
                    touchSession(sessionId);
                }
                break;
            case 0, $iu6oZ.END:
                if (sessionId) {
                    updateEvent(event, sessionId);
                    setSession(null);
                }
                break;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: handleTouchPoint,
        channel: "*"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3610af1ecb1deabe$export$203e3ae7319f8133), null, children));
};
module.exports["NavdexListener"] = $b052390ea3c4f36a$export$13953a62d51faabe;

});

parcelRegister("h4kcT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $d4U2f = parcelRequire("d4U2f");

const $a338fab92c921401$export$a54013f0d02a8f82 = ({ children: children })=>{
    const [forcedLocale, setForcedLocale] = (0, $42omo.useState)(undefined);
    const { locale: unforcedLoadle, messages: messages } = (0, $d4U2f.getTranslation)();
    const locale = forcedLocale || unforcedLoadle;
    (0, $42omo.useEffect)(()=>{
        document.documentElement.lang = locale;
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
        key: `intl-provider-${locale}-v5`,
        "data-test-language": locale,
        locale: locale,
        defaultLocale: (0, $d4U2f.DEFAULT_LOCALE),
        messages: messages,
        textComponent: "span",
        onError: (err)=>{}
    }, children);
};
module.exports["I18nProvider"] = $a338fab92c921401$export$a54013f0d02a8f82;

});

parcelRegister("6empl", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $fw9LG = parcelRequire("fw9LG");


var $9gzc5 = parcelRequire("9gzc5");


var $B8oFf = parcelRequire("B8oFf");


var $6sxJX = parcelRequire("6sxJX");


var $fJEl2 = parcelRequire("fJEl2");

// This timeout is used for any long-running messages that are either stuck for some reason, or that the user has yet to clear, to ensure that messaging doesn't stay blocked indefinitely
const $b27cd53e8327a957$var$CHOREOGRAPHER_MESSAGE_TTL = 300000; // 5 minute TTL for messages
// Lazily instantiate this the first time it's requested
let $b27cd53e8327a957$var$singleton;
class $b27cd53e8327a957$export$236158f15971c92e {
    /**
   * Static method to create and/or return a singleton of the choreographer API.
   *
   * @returns Shared instance of choreographer API.
   */ static getInstance() {
        if (!$b27cd53e8327a957$var$singleton) $b27cd53e8327a957$var$singleton = new this();
        return $b27cd53e8327a957$var$singleton;
    }
    stopCurrentMessage() {
        if (this.state.currentMessage) this.stopMessageInternal(this.state.currentMessage.productId, this.state.currentMessage.messageId, this.state.currentMessage.analyticsClient, this.state.currentMessage.metricsData, this.state.currentMessage.plugin, true).then(()=>{
            // Manually clear the message TTL and reenable plugins here just in case the unregistered plugin's message denied the
            // stop request. We may still get a collision on-screen, but we're considering the message forcibly stopped at this
            // point, so need to allow new requests.
            this.clearMessageTtl();
            this.enablePlugins();
        });
    }
    /**
   * Enables the message queue, and logs which message everybody else is queueing up behind.
   *
   * @param productId Unique identifier for the product making the current startMessage request blocking others.
   * @param messageId Unique identifier for the messageId blocking others.
   */ queueMessages(productId, messageId) {
        this.state.shouldQueueMessages = true;
        this.state.queueingBehindMessage = {
            productId: productId,
            messageId: messageId,
            timestamp: Date.now()
        };
    }
    /**
   * Pushes all data associated with a startMessage request onto an internal queue, to potentially be processed at a later time.
   * If a pending message request opts out (or otherwise fails to start), this data will be used to reinitiate the startMessage
   * request for this message request instance. Returns a Promise that the caller can await as normal, and which will eventually
   * either be resolved as 'blocked' if any prior pending message is started, or will be resolved with its eventual outcome when
   * its startMessage request is processed.
   *
   * @param productId Unique identifier for the product making the current startMessage request being queued.
   * @param messageId Unique identifier for the messageId being queued.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ queueMessage(productId, messageId, analyticsClient, metricsData, plugin) {
        return new Promise((resolve)=>{
            this.state.messageQueue.push({
                productId: productId,
                messageId: messageId,
                analyticsClient: analyticsClient,
                metricsData: metricsData,
                plugin: plugin,
                resolve: resolve
            });
        });
    }
    /**
   * Responsible for pulling a previously queued message request that was received while a message request was already in flight.
   * Shift the first message off the top of the queue, and use the stored resolve function to kickstart another pass through the
   * startMessage function, ultimately resolving with the final disposition of the request. Set the internal state for shouldQueueMessages
   * to false if we're restarting a startMessage request, so that this doesn't get immediately thrown back into the queue. If it
   * makes it through to its start callback being fired, that code will turn the shouldQueueMessages state back on.
   */ processQueuedMessage() {
        const queuedMessage = this.state.messageQueue.shift();
        // Disable the shouldQueueMessages state here. If we have a queued message, it will turn the shouldQueueMessages state back on when it
        // hits the call to its message's startCallback function. Otherwise, the queue is now empty, and we let things process normally.
        this.state.shouldQueueMessages = false;
        // Also null out the queueingBehindMessage value, which will be recreated if/when another message opens the queue below.
        this.state.queueingBehindMessage = null;
        if (queuedMessage) queuedMessage.resolve(this.startMessage(queuedMessage.productId, queuedMessage.messageId, queuedMessage.analyticsClient, queuedMessage.metricsData, queuedMessage.plugin));
    }
    /**
   * Responsible for flushing out any queued messages and resolving their Promises as "blocked". We don't officially consider a
   * message as "blocked" until one of the prior calls has signaled a valid "started" state. This way, any async callbacks that
   * are in flight can allow additional messages to queue up, and if they eventually opt out, we can move on to the next message
   * in the queue and see if it will signal success. Only when we get a successful start to we consider all queued up messages to
   * be "blocked". Run a loop to shift each of them off of the array and resolve them as blocked, until the array is empty.
   *
   * @param [plugin] An optional plugin instance
   */ destroyMessageQueue(plugin) {
        this.state.shouldQueueMessages = false;
        this.state.queueingBehindMessage = null;
        while(this.state.messageQueue.length > 0){
            const { analyticsClient: analyticsClient, messageId: messageId, metricsData: metricsData, productId: productId, resolve: resolve } = this.state.messageQueue.shift();
            const attributes = {
                ...metricsData,
                productId: productId,
                messageId: messageId
            };
            const actionSubject = (0, $fw9LG.MessageAction).START;
            const logger = new (0, $B8oFf.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
            const debugLogger = new (0, $9gzc5.DebugLogger)(productId, messageId);
            logger.blocked({
                blockedByProductId: this.state.currentMessage?.productId,
                blockedByMessageId: this.state.currentMessage?.messageId
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $fw9LG.MessageDeliveryStatus).BLOCKED,
                    blockedByProductId: this.state.currentMessage?.productId,
                    blockedByMessageId: this.state.currentMessage?.messageId
                }
            });
            resolve((0, $fw9LG.MessageDeliveryStatus).BLOCKED);
        }
    }
    /**
   * Sets a timeout to auto-expire any messaging that stays open for too long, to prevent messaging from being blocked indefinitely.
   *
   * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
   * @param messageId Unique identifier for the messageId that triggered this message timeout.
   * @param AnalyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @param [messageTtl] Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use default TTL (5 minutes).
   */ setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin, messageTtl) {
        this.state.currentMessage = {
            productId: productId,
            messageId: messageId,
            analyticsClient: analyticsClient,
            metricsData: metricsData,
            plugin: plugin,
            timestamp: Date.now()
        };
        const isCustomTtlEnabled = (0, $dh538.fg)('post-office_choreographer_custom_message_ttl');
        // If feature flag is off, always use default TTL
        if (!isCustomTtlEnabled) {
            this.state.messageTtl = setTimeout(()=>{
                if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
            }, $b27cd53e8327a957$var$CHOREOGRAPHER_MESSAGE_TTL);
            return;
        }
        // If TTL is 0, disable TTL for this message
        if (messageTtl === 0) return;
        // Use provided TTL or default to CHOREOGRAPHER_MESSAGE_TTL
        this.state.messageTtl = setTimeout(()=>{
            if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
        }, messageTtl ?? $b27cd53e8327a957$var$CHOREOGRAPHER_MESSAGE_TTL);
    }
    /**
   * Checks to see if the requesting productId/messageId pair matches the data for the currently-displayed message.
   *
   * @param productId Unique identifier for the product being checked for a current message match.
   * @param messageId Unique identifier for the messageId being checked for a current message match.
   */ isCurrentMessage(productId, messageId) {
        return Boolean(this.state.currentMessage && this.state.currentMessage.productId === productId && this.state.currentMessage.messageId === messageId);
    }
    /**
   * Returns the currentMessage object.
   */ getCurrentMessage() {
        return this.state.currentMessage;
    }
    /**
   * Returns the queueingBehindMessage object.
   */ getCurrentPendingMessage() {
        return this.state.queueingBehindMessage;
    }
    /**
   * Clears the timeout that was established for the currently-displayed message.
   */ clearMessageTtl() {
        this.state.currentMessage = null;
        if (this.state.messageTtl) clearTimeout(this.state.messageTtl);
    }
    /**
   * Disables all plugins that are currently registered with the choreographer when loaded in an iframe. For apps that
   * are shown within iframes (e.g. smart link embeds) we typically do not want to show in-product messages as they
   * may conflict with messages shown in parent frames.
   *
   * If called outside an iframe then this function is a noop.
   *
   * @returns A cleanup function to re-enable plugins, or `undefined` if the function was called outside an iframe.
   */ disableChoreographerForIframe() {
        // Exit if we're not in an iframe
        if (!(0, $fJEl2.isIframe)()) return;
        this.disablePlugins();
        // Cleanup function to re-enable plugins
        return ()=>this.enablePlugins();
    }
    /**
   * Disables all plugins that are currently registered with the choreographer, called when a startMessage call is being dispatched.
   *
   * @param [exceptFor] An optional plugin instance.
   */ disablePlugins(exceptFor) {
        this.state.isDisabled = true;
        [
            ...this.state.plugins.values()
        ].forEach((p)=>{
            if (p !== exceptFor) p.disable();
        });
    }
    /**
   * Enables all plugins that are currently registered with the choreographer, called when a matching stopMessage call is successful.
   */ enablePlugins() {
        [
            ...this.state.plugins.values()
        ].forEach((p)=>p.enable());
        this.state.isDisabled = false;
    }
    /**
   * A callback used to remove a plugin from the list of subscribers for the choreographer service.
   *
   * @param productId A unique string representing the plugin to be unregistered from the choreographer API.
   */ unregisterPlugin(productId) {
        // If we're unregistering this productId's plugin, and the currentMessage is from this productId, we need to stop it to clear the choreographer
        if (this.state.currentMessage?.productId === productId) this.stopCurrentMessage();
        this.state.messages.delete(productId);
        this.state.plugins.delete(productId);
        this.state.seenTransactionalMessages.delete(productId);
    }
    /**
   * Determines whether any message is currently being displayed, by checking its own status and optionally, asking each registered plugin for its individual status.
   *
   * @returns A value reflecting whether a message is currently being displayed on screen.
   */ isDisplayingMessage() {
        return Boolean(this.state.currentMessage || [
            ...this.state.plugins.values()
        ].reduce((isDisplayingMessage, p)=>{
            return isDisplayingMessage || p.isDisplayingMessage();
        }, false));
    }
    /**
   * This function is intended for test cleanup purposes only, *not* to be called by external callers.
   *
   * @ignore
   * @param productId Unique identifier for the product whose messages are being requested
   * @returns A Map of IMessage objects, keyed by unique messageId strings.
   */ getMessages(productId) {
        return this.state.messages.get(productId) ?? new Map();
    }
    /**
   * Requests to start a message via the choreographer service, ensuring only a single message instance at a time on the screen.
   * A successful request will block any other message attempts until such time as the matching stopMessage request is received,
   * or a message TTL timeout has expired.
   *
   * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
   * @param messageId Unique identifier for the messageId that triggered this message timeout.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @param [messageTtl] Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use default TTL (5 minutes).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ async startMessage(productId, messageId, analyticsClient, metricsData = {}, plugin, messageTtl) {
        const debugLogger = new (0, $9gzc5.DebugLogger)(productId, messageId);
        const actionSubject = (0, $fw9LG.MessageAction).START;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $B8oFf.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            if (!this.hasMessageRecord(productId, messageId)) {
                // Bail early here, before even checking if we're in a queueing situation, or blocked, or anything else
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $fw9LG.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $fw9LG.MessageDeliveryStatus).UNREGISTERED;
            }
            // If we're currently queueing messages, push this one onto the queue and return the new Promise
            if (this.state.shouldQueueMessages) {
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: `queued behind ${this.state.queueingBehindMessage?.productId} ${this.state.queueingBehindMessage?.messageId}`
                    }
                });
                return this.queueMessage(productId, messageId, analyticsClient, metricsData, plugin);
            }
            if (this.state.isDisabled || this.isDisplayingMessage()) {
                logger.blocked({
                    blockedByProductId: this.state.currentMessage?.productId,
                    blockedByMessageId: this.state.currentMessage?.messageId
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $fw9LG.MessageDeliveryStatus).BLOCKED,
                        blockedByProductId: this.state.currentMessage?.productId,
                        blockedByMessageId: this.state.currentMessage?.messageId
                    }
                });
                return (0, $fw9LG.MessageDeliveryStatus).BLOCKED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            this.queueMessages(productId, messageId);
            const didStart = await message.start?.() ?? true;
            if (didStart) {
                // Fire the onStart callback, if provided, to handle any post-start concerns for the consumer
                message.onStart?.();
                logger.started();
                this.disablePlugins(plugin);
                this.setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin, messageTtl);
                // Successfully started the message, flush the queue and mark any pending requests as "blocked"
                this.destroyMessageQueue(plugin);
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $fw9LG.MessageDeliveryStatus).STARTED
                    }
                });
                return (0, $fw9LG.MessageDeliveryStatus).STARTED;
            }
            // Check to see if we have any pending requests in the message queue and attempt to start the next one in line
            this.processQueuedMessage();
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $fw9LG.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $fw9LG.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $fw9LG.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $fw9LG.MessageDeliveryStatus).ERROR;
        }
    }
    /**
   * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
   * This version of the stopMessage function is private, and only intended to be called internally, so that it can make use of the forceStop parameter without exposing that to external callers.
   *
   * @param productId Unique identifier for the product making the current stopMessage request.
   * @param messageId Unique identifier for the messageId to be stopped.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @param [forceStop] A boolean to denote whether to forcefully clear the Choreographer's blocked state (used for TTL expiration and unregistering a plugin).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessageInternal(productId, messageId, analyticsClient, metricsData = {}, plugin, forceStop = false) {
        const debugLogger = new (0, $9gzc5.DebugLogger)(productId, messageId);
        const actionSubject = (0, $fw9LG.MessageAction).STOP;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $B8oFf.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            if (!this.hasMessageRecord(productId, messageId)) {
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $fw9LG.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $fw9LG.MessageDeliveryStatus).UNREGISTERED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            // Enable the message queue *if* the current stopMessage request matches the currentMessage data.
            // Any incoming startMessage requests will be queued while this stopMessage request is in-flight,
            // so that they can be immediately honored if this request comes back successfully.
            if (this.isCurrentMessage(productId, messageId)) this.queueMessages(productId, messageId);
            const didStop = await message.stop?.() ?? true;
            // If we're hitting this from stopCurrentMessage, it means either a TTL has expired, or we're
            // unregistering a plugin. We forceStop the choreographer blocked state here, even if the stop
            // callback returned false.We don't want to block the UI indefinitely, we'll just have to risk
            // 1 additional message collision if the current message's stop callback refuses to clear.
            if (didStop || forceStop) {
                if (this.isCurrentMessage(productId, messageId)) {
                    // Fire the onStop callback, if provided, to handle any post-stop concerns for the consumer
                    message.onStop?.();
                    // Only log this even if we're stopping the current message, so we have a 1:1 mapping of starts to stops.
                    // If this is a forced stop, log that in the attributes, so we can track those events specifically.
                    // Also log the value of didStop, so we know if this was a rejected stop attempt that *had* to be force stopped.
                    logger.stopped(forceStop ? {
                        forceStop: forceStop,
                        didStop: didStop
                    } : undefined);
                    // Only clear the message TTL and reenable plugins if we're stopping the *current* message
                    this.clearMessageTtl();
                    this.enablePlugins();
                }
                // Check to see if we have any pending requests in the message queue and attempt to start them
                this.processQueuedMessage();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $fw9LG.MessageDeliveryStatus).STOPPED
                    }
                });
                return (0, $fw9LG.MessageDeliveryStatus).STOPPED;
            }
            // Stopping the message failed, so the UI is still intentionally blocked, flush the queue and mark any pending requests as "blocked"
            this.destroyMessageQueue(plugin);
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $fw9LG.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $fw9LG.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $fw9LG.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $fw9LG.MessageDeliveryStatus).ERROR;
        }
    }
    /**
   * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
   *
   * @param productId Unique identifier for the product making the current stopMessage request.
   * @param messageId Unique identifier for the messageId to be stopped.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
        return this.stopMessageInternal(productId, messageId, analyticsClient, metricsData, plugin);
    }
    /**
   * Registers a plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
   *
   * @param productId Unique identifier to register as the product owner of this plugin.
   * @param plugin A plugin instance to be registered with the choreographer instance.
   * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
   */ registerPlugin(productId, plugin) {
        if (this.state.plugins.has(productId)) throw new Error(`Choreographer plugin already registered for ${productId}!`);
        this.state.plugins = this.state.plugins.set(productId, plugin);
        this.state.seenTransactionalMessages.set(productId, new Set());
        if (this.state.isDisabled) plugin.disable();
        return ()=>{
            this.unregisterPlugin(productId);
        };
    }
    /**
   * Validates that a message record is present and ready to be retrieved and/or manipulated.
   * Creates the message instance if it doesn't yet exist, initializing both start and stop callbacks to noop functions.
   *
   * @param productId Unique identifier to retrieve map of IMessage objects.
   * @param messageId Unique identifier for the messageId to be retrieved.
   * @returns IMessage object for the requested productId/messageId combination.
   */ ensureMessageRecord(productId, messageId) {
        let productMessages = this.state.messages.get(productId);
        if (!productMessages) {
            productMessages = new Map();
            this.state.messages.set(productId, productMessages);
        }
        let message = productMessages.get(messageId);
        if (!message) {
            message = {};
            productMessages.set(messageId, message);
        }
        return message;
    }
    /**
   * Checks for the existance of a message record for a given productId/messageId combination.
   *
   * @param productId Unique identifier to check for a map of IMessage objects.
   * @param messageId Unique identifier to check for within the map of productId IMessage objects.
   * @returns Boolean indicating whether or not an IMessage record exists for the requested productId/messageId combination.
   */ hasMessageRecord(productId, messageId) {
        return Boolean(this.state.messages.get(productId)?.has?.(messageId));
    }
    /**
   * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param options An object containing optional start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ on(productId, messageId, options = {}, finalizers = {}) {
        const message = {
            ...this.ensureMessageRecord(productId, messageId),
            ...options,
            ...finalizers
        };
        this.state.messages.get(productId).set(messageId, message);
    }
    /**
   * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param startCallback A callback to be invoked upon successful requests to startMessage.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ onStart(productId, messageId, startCallback, finalizers) {
        this.on(productId, messageId, {
            start: startCallback
        }, finalizers);
    }
    /**
   * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ onStop(productId, messageId, stopCallback, finalizers = {}) {
        this.on(productId, messageId, {
            stop: stopCallback
        }, finalizers);
    }
    /**
   * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for unsubscribing this message.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for unsubscribing this message.
   */ off(productId, messageId) {
        this.state.messages.get(productId)?.delete?.(messageId);
    }
    /**
   * This should only be used for test cleanup purposes.
   * Clears the seen transactional messages cache for a given productId.
   *
   * @param productId Unique identifier to clear the seen transactional messages cache for.
   */ clearSeenTransactionalMessages(productId) {
        this.state.seenTransactionalMessages.get(productId)?.clear();
    }
    constructor(){
        this.state = void 0;
        this.shouldBeChoreographed = (productId, analyticsClient, metricsData = {}, props, coordinationOptions, toggleableProp)=>{
            /*
       * TODO: Remove this once we have enough transactional message data!!! This is a hacky TEMPORARY solution to get a sense
       * of how many transactional messages we are showing to users.
       *
       * We have to track which messages have been seen because shouldBeChoreographed is called on every rerender of
       * Choreographer-integrated components. So, if we log every call, we'll get an inaccurate number of transactional
       * messages that are actually being shown to users.
       *
       * Thus, we track which messages have been seen and only log the first time we see a transactional message.
       */ // Check if we should log the shouldBeChoreographed call
            const isTransactional = props?.messageType === (0, $fw9LG.MessageTypesEnum).TRANSACTIONAL;
            const isTransactionalLoggingEnabled = (0, $dh538.fg)('post-office_choreographer_log_transactional_msg');
            const seen = props?.messageId && this.state.seenTransactionalMessages.get(productId)?.has(props.messageId);
            // If the component is toggleable, we only want to log the message if it is actually rendered
            const isRendered = !toggleableProp || toggleableProp && props?.[toggleableProp];
            if (isTransactional && props?.messageId && isTransactionalLoggingEnabled && isRendered && !seen) {
                // Mark the messageId as seen to prevent duplicate logging on rerenders
                if (!this.state.seenTransactionalMessages.has(productId)) this.state.seenTransactionalMessages.set(productId, new Set());
                this.state.seenTransactionalMessages.get(productId)?.add(props.messageId);
                const logger = new (0, $B8oFf.Logger)('messageStart', props.messageId, {
                    ...metricsData,
                    messageId: props.messageId,
                    currentMessageId: this.getCurrentMessage()?.messageId,
                    messageType: props.messageType
                }, analyticsClient);
                logger.requested();
            }
            // Call the original function that actually determines if a message should be choreographed
            return (0, $6sxJX.shouldBeChoreographed)(props, coordinationOptions);
        };
        this.state = {
            currentMessage: null,
            isDisabled: false,
            messages: new Map(),
            messageQueue: [],
            messageTtl: null,
            plugins: new Map(),
            queueingBehindMessage: null,
            shouldQueueMessages: false,
            seenTransactionalMessages: new Map()
        };
    }
}
module.exports["Choreographer"] = $b27cd53e8327a957$export$236158f15971c92e;

});

parcelRegister("9gzc5", function(module, exports) {
function $c9e657d0e8c68e56$var$getCurrentLoggingLevel() {
    return window.choreographerLoggingLevel;
}
function $c9e657d0e8c68e56$var$logMessageIfValidLoggingLevel(loggingLevel, data) {
    if ($c9e657d0e8c68e56$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.table(data);
}
function $c9e657d0e8c68e56$var$traceMessageIfValidLoggingLevel(loggingLevel, productId, messageId, message) {
    if ($c9e657d0e8c68e56$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.log(`CHOREOGRAPHER - ${productId} - ${messageId} - ${message}`);
}
class $c9e657d0e8c68e56$export$21e6cc849c1dc1ab {
    constructor(productId, messageId){
        this.state = void 0;
        /**
     * A function that takes an object of properties for each logging level
     * name, e.g. log.info and log.verbose, which are functions that take an
     * object of any key/value pairs, which will be merged with the productId
     * and the messageId values passed to the constructor, and output via
     * console.table.
     *
     * Example: debugLogger.log({
     *   info: { foo: true },
     *   verbose: {
     *     foo: true,
     *     bar: 123,
     *     baz 'abc',
     *     timestamp: performance.now()
     *   },
     * });
     *
     * @param messages Record<LoggingLevels, Record<string, unknown>> An object
     * keyed by the desired log-level, with each value being an object of any
     * key/value pairs to be output to console.table.
     */ this.log = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $c9e657d0e8c68e56$var$logMessageIfValidLoggingLevel(loggingLevel, {
                    productId: this.state.productId,
                    messageId: this.state.messageId,
                    ...messages[loggingLevel] ?? {},
                    ...loggingLevel === 'verbose' ? {
                        timestamp: performance.now()
                    } : {}
                });
            });
        };
        /**
     * A function that takes an object of properties for each logging level
     * name, e.g. trace.info and trace.verbose, which are functions that take
     * a string to be used as the label for a stack trace via console.trace.
     *
     * Example: debugLogger.trace({
     *   info: 'This is a stack trace',
     *   verbose: `This is a stack trace with a much more verbose message which
     * contains data about the ${productId} and ${messageId} within my function,
     * invoked at ${performance.now()}ms`,
     * });
     *
     * @param messages Record<LoggingLevels, string> An object keyed by the
     * desired log-level, with each value being a string to be output as the
     * label to console.trace.
     */ this.trace = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $c9e657d0e8c68e56$var$traceMessageIfValidLoggingLevel(loggingLevel, this.state.productId, this.state.messageId, `${messages[loggingLevel]}${loggingLevel === 'verbose' ? ` (${performance.now()})` : ''}`);
            });
        };
        this.state = {
            productId: productId,
            messageId: messageId
        };
    }
}
module.exports["DebugLogger"] = $c9e657d0e8c68e56$export$21e6cc849c1dc1ab;

});

parcelRegister("B8oFf", function(module, exports) {

var $fw9LG = parcelRequire("fw9LG");

class $de1f89189bfc70dc$export$efa9a398d6368992 {
    /**
   * Send operational event to the Analytics web client for logging/metrics.
   *
   * @param action A (MessageDeliveryStatuses) string denoting the ultimate disposition of this message start or stop request.
   */ sendOperationalEvent(action, additionalAttributes) {
        const { analyticsClient: analyticsClient, actionSubject: actionSubject, actionSubjectId: actionSubjectId, metricsData: attributes, plugin: plugin } = this.state;
        const event = {
            source: 'choreographer',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...attributes ?? {},
                ...additionalAttributes ?? {}
            },
            tags: [
                'postOffice'
            ]
        };
        if (plugin?.shouldLogEvent?.(event) ?? true) analyticsClient.sendOperationalEvent(event);
    }
    blocked(additionalAttributes) {
        this.sendOperationalEvent((0, $fw9LG.MessageDeliveryStatus).BLOCKED, additionalAttributes);
    }
    error(additionalAttributes) {
        this.sendOperationalEvent((0, $fw9LG.MessageDeliveryStatus).ERROR, additionalAttributes);
    }
    unregistered(additionalAttributes) {
        this.sendOperationalEvent((0, $fw9LG.MessageDeliveryStatus).UNREGISTERED, additionalAttributes);
    }
    started(additionalAttributes) {
        this.sendOperationalEvent((0, $fw9LG.MessageDeliveryStatus).STARTED, additionalAttributes);
    }
    stopped(additionalAttributes) {
        this.sendOperationalEvent((0, $fw9LG.MessageDeliveryStatus).STOPPED, additionalAttributes);
    }
    requested(additionalAttributes) {
        this.sendOperationalEvent((0, $fw9LG.MessageDeliveryStatus).REQUESTED, additionalAttributes);
    }
    /**
   * Utility class to simplify and allow for wider use of sending operational event to the Analytics web client for logging/metrics.
   *
   * @param actionSubject A (MessageActions) string denoting either the start or stop phase of a message.
   * @param actionSubjectId Unique messageId to be logged with this even.
   * @param metricsData Additional data from plugin to be sent with event for metrics logging.
   * @param analyticsClient An instance of AnalyticsWebClient, unique to each caller
   * @param [plugin] An optional plugin instance.
   */ constructor(actionSubject, actionSubjectId, metricsData, analyticsClient, plugin){
        this.state = void 0;
        this.state = {
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            metricsData: metricsData,
            analyticsClient: analyticsClient,
            plugin: plugin
        };
    }
}
module.exports["Logger"] = $de1f89189bfc70dc$export$efa9a398d6368992;

});

parcelRegister("9Oif4", function(module, exports) {

var $a9sR2 = parcelRequire("a9sR2");

var $5DUgU = parcelRequire("5DUgU");


var $6empl = parcelRequire("6empl");

class $39a7bbb2f38c34c0$export$71324a662782c710 {
    /**
   * Public method to clean up this plugin instance, which will handle unregistering it from the choreographer API.
   */ destroy() {
        this.state.unregisterPlugin();
    }
    /**
   * Determines whether this plugin is currently displaying a message on the screen. By default, is a simple boolean
   * toggle that gets flipped back and forth, but it could also be a function that checks the DOM for a given message
   * container to be present, or checks with some external API to tell it whether a message is being displayed, or
   * anything else. The logic is up to the consumer to implement, if something custom is desired.
   *
   * @returns A boolean that represents whether this plugin is currently displaying a message on the screen.
   */ isDisplayingMessage() {
        return this.state.isDisplayingMessage;
    }
    /**
   * Sets the internal isDisplayingMessage state to true, to denote that this plugin is currently blocking the UI.
   */ blockDisplayState() {
        this.state.isDisplayingMessage = true;
    }
    /**
   * Sets the internal isDisplayingMessage state to false, to denote that this plugin is no longer blocking the UI.
   */ clearDisplayState() {
        this.state.isDisplayingMessage = false;
    }
    /**
   * Disables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
   * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
   * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
   */ disable() {
        this.state.isDisabled = true;
    }
    /**
   * Enables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
   * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
   * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
   */ enable() {
        this.state.isDisabled = false;
    }
    /**
   * Returns the Analytics Web Client instance for this plugin.
   *
   * @returns AnalyticsWebClient instance
   */ getAnalyticsClient() {
        return this.analyticsClient;
    }
    /**
   * Makes a request to start a message through the choreographer API. Will immediately return false if this plugin
   * is currently in a disabled state, and will otherwise return the ultimate result of the startMessage request.
   *
   * @param messageId The messageId for the message to be started through the choreographer API.
   * @param additionalData An object containing additional metadata to be sent along with the message start request
   * @param messageTtl Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use global default (5 minutes).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ async startMessage(messageId, additionalData = {}, messageTtl) {
        return (0, $6empl.Choreographer).getInstance().startMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        }, this, messageTtl);
    }
    /**
   * Makes a request to stop a message through the choreographer API. Will return the ultimate result of the stopMessage request.
   *
   * @param messageId The messageId for the message to be stopped through the choreographer API.
   * @param additionalData An object containing additional metadata to be sent along with the message stop request
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessage(messageId, additionalData = {}) {
        return (0, $6empl.Choreographer).getInstance().stopMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        });
    }
    /**
   * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param options An object containing start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
   */ on(messageId, options = {}) {
        return (0, $6empl.Choreographer).getInstance().on(this.state.productId, messageId, options, this.finalizers);
    }
    /**
   * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param startCallback A callback to be invoked upon successful requests to startMessage.
   */ onStart(messageId, startCallback) {
        return (0, $6empl.Choreographer).getInstance().onStart(this.state.productId, messageId, startCallback, this.finalizers);
    }
    /**
   * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
   */ onStop(messageId, stopCallback) {
        return (0, $6empl.Choreographer).getInstance().onStop(this.state.productId, messageId, stopCallback, this.finalizers);
    }
    /**
   * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for unsubscribing this message subscription.
   */ off(messageId) {
        return (0, $6empl.Choreographer).getInstance().off(this.state.productId, messageId);
    }
    shouldBeChoreographed(props, coordinationOptions, toggleableProp // TODO: Remove this once we no longer need transactional logs
    ) {
        return (0, $6empl.Choreographer).getInstance().shouldBeChoreographed(this.state.productId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            productId: this.state.productId
        }, props, coordinationOptions, toggleableProp);
    }
    /**
   * Registers this plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
   *
   * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
   * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
   */ registerPlugin(productId) {
        return (0, $6empl.Choreographer).getInstance().registerPlugin(productId, this);
    }
    /**
   * Creates a new instance of the Analytics Web Client for a plugin to use for sending analytics events.
   *
   * @param env environment type used to create the analytics client
   * @returns AnalyticsWebClient instance
   */ createAnalyticsClient(env) {
        const analyticsClient = new (0, $a9sR2.default)({
            env: env,
            product: 'postOffice',
            origin: (0, $5DUgU.originType).WEB
        });
        return analyticsClient;
    }
    /**
   * Instantiates a plugin to be used with the main choreographer API. Requires a productId string
   * to be used for segmenting registered messageIds in other parts of the API, which ensures uniqueness
   * between individual products for tracking purposes.
   *
   * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
   * @param env The environment type for the product, to be used for analytics events.
   * @param metaMetricsData An object containing additional metadata to be sent along with every message request.
   * @returns A new instance of this plugin to use for integrating a 1P or 3P product with the choreographer API.
   */ constructor(productId, env, metaMetricsData = {}){
        this.state = void 0;
        this.analyticsClient = void 0;
        this.finalizers = void 0;
        this.state = {
            isDisabled: false,
            isDisplayingMessage: false,
            metaMetricsData: metaMetricsData,
            productId: productId,
            unregisterPlugin: ()=>{}
        };
        this.analyticsClient = this.createAnalyticsClient(env);
        /**
     * These finalizers are callbacks to be invoked after a valid start or stop request in the Choreographer core.
     * Declaring them in the constructor because it's the same onStart/onStop pair that will be passed ot all of the
     * .on, .onStart, and .onStop function registrations.
     *
     * This behavior used to be managed by a decorator function that would auto-set the isDisplayingMessage value
     * whenever its start or stop callbacks were invoked. However, those start and stop callbacks are optional from
     * this layer, so if a consumer did *not* register a stop callback, the display state would never be cleared here
     * in the plugin, and would continue blocking messages.
     *
     * We're now passing these onStart and onStop callbacks as part of the message registration, so that any time a
     * message is started or stopped at the core layer, we can fire these callbacks to update the plugin's local state,
     * whether or not an actual start or stop callback was registered by the consumer.
     */ this.finalizers = {
            onStart: ()=>this.blockDisplayState(),
            onStop: ()=>this.clearDisplayState()
        };
        this.state.unregisterPlugin = this.registerPlugin(productId);
    }
}
module.exports["ChoreographerPlugin"] = $39a7bbb2f38c34c0$export$71324a662782c710;

});

parcelRegister("iSprN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $bQm3c = parcelRequire("bQm3c");











var $1DWH0 = parcelRequire("1DWH0");




function $8b0df458834f5425$export$2e2bcd8739ae039(Component) {
    const PreventNestedInstancesContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(false);
    return function PreventNestedInstances(props) {
        return(// TODO: Replace usage of PreventNestedInstancesContext.Consumer with useContext(PreventNestedInstancesContext)
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PreventNestedInstancesContext.Consumer, null, (shouldPreventInstantiation)=>shouldPreventInstantiation ? props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PreventNestedInstancesContext.Provider, {
                value: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props))));
    };
}



var $a4TK8 = parcelRequire("a4TK8");

parcelRequire("99uSl");
var $k5Cbm = parcelRequire("k5Cbm");

function $51038d8f9e47263d$export$eac027797b968991(isCancelled = false) {
    return {
        isCancelled: isCancelled
    };
}



var $4nGsu = parcelRequire("4nGsu");

const $349caf1aae10645a$export$d05fe3e897340c89 = 'SET_MESSAGE_MAPPING';
const $349caf1aae10645a$export$eacd3ec165715d8 = 'SET_INITIALIZING';
const $349caf1aae10645a$export$874c5149d7f0e3b8 = 'RESET_STORE';
const $349caf1aae10645a$export$cb5041d68cb18859 = 'CLEAR_CURRENT';
const $349caf1aae10645a$export$a9319af002a4c677 = 'SET_CURRENT';
const $349caf1aae10645a$export$a20a1205b2a2b7e4 = ()=>({
        type: $349caf1aae10645a$export$874c5149d7f0e3b8
    });
const $349caf1aae10645a$export$2a47f398eeff8b01 = (config)=>({
        type: $349caf1aae10645a$export$eacd3ec165715d8,
        config: config
    });
const $349caf1aae10645a$export$375dd0a76fecd4c7 = (messageMapping)=>({
        type: $349caf1aae10645a$export$d05fe3e897340c89,
        messageMapping: messageMapping
    });
function $349caf1aae10645a$export$5f80f094fd31fffd(eventMapping) {
    return {
        type: $349caf1aae10645a$export$a9319af002a4c677,
        eventMapping: eventMapping
    };
}
function $349caf1aae10645a$export$96105f873ade39d7() {
    return {
        type: $349caf1aae10645a$export$cb5041d68cb18859
    };
}



var $ll2sR = parcelRequire("ll2sR");



const $236a1e5ddbdeb765$export$a9d4ce3abb5d2365 = (messages)=>{
    const mapping = new Map();
    messages.forEach((message)=>{
        const components = message.components;
        components.forEach((component, index)=>{
            component.triggers.forEach((trigger)=>{
                mapping.set(trigger, {
                    message: message,
                    component: {
                        componentId: index,
                        isLast: index === components.length - 1,
                        ...component
                    }
                });
            });
        });
    });
    return mapping;
};
async function $236a1e5ddbdeb765$export$d2e92820f98a2592(engagementStore, config, cancellationToken) {
    if (cancellationToken.isCancelled) return;
    const state = (0, $25d7841ba52366e9$export$6f57813fe9f31bf9).getState();
    const { cloudId: cloudId, stargateUrl: stargateUrl, product: product, locale: locale } = config;
    let messages, interval;
    try {
        const results = await (0, $ll2sR.getMessages)(cloudId, stargateUrl, product, locale);
        if (cancellationToken.isCancelled) return;
        messages = results.messages;
        interval = results.interval;
    } catch (e) {
        // TODO: Configure metal to monitor errors here
        // Give up, don't try fetching again
        return;
    }
    // Don't overwrite the messageMapping if there's an active message
    if (state.current === null) {
        const messageMapping = $236a1e5ddbdeb765$export$a9d4ce3abb5d2365(messages);
        engagementStore.dispatch((0, $349caf1aae10645a$export$375dd0a76fecd4c7)(messageMapping));
    }
    if (interval !== 0) setTimeout(()=>{
        $236a1e5ddbdeb765$export$d2e92820f98a2592(engagementStore, config, cancellationToken);
    }, interval * 1000);
// TODO: Configure metal to monitor success response here
}


const $25d7841ba52366e9$export$36d128238e6b60f5 = {
    messageMapping: new Map(),
    current: null,
    initialized: false,
    initializing: false,
    config: {
        cloudId: '',
        aaid: '',
        locale: '',
        product: '',
        stargateUrl: '',
        orgId: '',
        workspaceId: ''
    }
};
let $25d7841ba52366e9$var$processMessagesCancellationToken = (0, $51038d8f9e47263d$export$eac027797b968991)();
function $25d7841ba52366e9$export$7a10f46f72407bc5(messageMapping, component) {
    const newMapping = new Map();
    messageMapping.forEach((value, key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(value.component, component)) newMapping.set(key, value);
    });
    return newMapping;
}
const $25d7841ba52366e9$export$6f57813fe9f31bf9 = (0, $k5Cbm.default)((state = $25d7841ba52366e9$export$36d128238e6b60f5, action)=>{
    switch(action.type){
        case 0, $349caf1aae10645a$export$d05fe3e897340c89:
            return {
                ...state,
                initialized: true,
                initializing: false,
                messageMapping: action.messageMapping
            };
        case 0, $349caf1aae10645a$export$eacd3ec165715d8:
            return {
                ...state,
                config: action.config,
                initializing: true
            };
        case 0, $349caf1aae10645a$export$a9319af002a4c677:
            {
                const { eventMapping: eventMapping } = action;
                const { message: message, component: component } = eventMapping;
                const messageMapping = $25d7841ba52366e9$export$7a10f46f72407bc5(state.messageMapping, component);
                return {
                    ...state,
                    current: {
                        messageId: message.messageId,
                        variationId: message.variationId,
                        ...component
                    },
                    messageMapping: messageMapping
                };
            }
        case 0, $349caf1aae10645a$export$cb5041d68cb18859:
            return {
                ...state,
                current: null
            };
        case 0, $349caf1aae10645a$export$874c5149d7f0e3b8:
            return $25d7841ba52366e9$export$36d128238e6b60f5;
        default:
            return state;
    }
});
var $25d7841ba52366e9$export$2e2bcd8739ae039 = (config)=>{
    const state = $25d7841ba52366e9$export$6f57813fe9f31bf9.getState();
    if (state.initializing || state.initialized) {
        if (state.config.cloudId === config.cloudId) return $25d7841ba52366e9$export$6f57813fe9f31bf9;
        // CloudId has changed, cancel any in process processMessages request
        $25d7841ba52366e9$var$processMessagesCancellationToken.isCancelled = true;
        $25d7841ba52366e9$var$processMessagesCancellationToken = (0, $51038d8f9e47263d$export$eac027797b968991)();
        $25d7841ba52366e9$export$6f57813fe9f31bf9.dispatch((0, $349caf1aae10645a$export$a20a1205b2a2b7e4)());
    }
    const newConfig = {
        ...config
    };
    newConfig.locale = newConfig.locale.replace('_', '-');
    $25d7841ba52366e9$export$6f57813fe9f31bf9.dispatch((0, $349caf1aae10645a$export$2a47f398eeff8b01)(newConfig));
    if ((0, $4nGsu.isMessagingEnabled)()) (0, $236a1e5ddbdeb765$export$d2e92820f98a2592)($25d7841ba52366e9$export$6f57813fe9f31bf9, newConfig, $25d7841ba52366e9$var$processMessagesCancellationToken);
    return $25d7841ba52366e9$export$6f57813fe9f31bf9;
};


/* eslint-disable max-lines */ 



var $hs90m = parcelRequire("hs90m");


var $20sPA = parcelRequire("20sPA");





var $6g1oe = parcelRequire("6g1oe");


var $feHMU = parcelRequire("feHMU");

var $kDuN4 = parcelRequire("kDuN4");


var $fw9LG = parcelRequire("fw9LG");

var $6sxJX = parcelRequire("6sxJX");




function $59b1b265b9049137$export$22a3b1671f38a193(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendScreenEvent(payload);
    });
}
function $59b1b265b9049137$export$1aecf263098db667(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendUIEvent(payload);
    });
}
function $59b1b265b9049137$export$e5f89b51c6d4e36b(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendOperationalEvent(payload);
    });
}


const $812a060980ce0ea1$var$browserMatchers = [
    {
        name: 'IE',
        pattern: /Trident\/.*; rv:([^;)]+)/
    },
    {
        name: 'Chrome',
        pattern: /Chrome\/([^ )]+)/
    },
    {
        name: 'Firefox',
        pattern: /Firefox\/([^ )]+)/
    }
];
const $812a060980ce0ea1$export$cda2203640e08931 = {
    name: 'unknown',
    version: 'unknown'
};
function $812a060980ce0ea1$export$6c724a6ffa2dc3e1(userAgent) {
    if (!window.navigator) return $812a060980ce0ea1$export$cda2203640e08931;
    if (!userAgent) userAgent = window.navigator.userAgent;
    for (const matcher of $812a060980ce0ea1$var$browserMatchers){
        const versionMatch = userAgent.match(matcher.pattern);
        if (versionMatch) return {
            name: matcher.name,
            version: versionMatch[1]
        };
    }
    return $812a060980ce0ea1$export$cda2203640e08931;
}


const $3d2a366249ac5f1c$var$createCustomEvent = ({ eventName: eventName, canBubble: canBubble, cancellable: cancellable, detail: detail })=>{
    const customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(eventName, canBubble, cancellable, detail);
    return customEvent;
};
var $3d2a366249ac5f1c$export$2e2bcd8739ae039 = $3d2a366249ac5f1c$var$createCustomEvent;






class $b1929a7ab4bc735e$export$2e2bcd8739ae039 {
    enqueue(item) {
        if (this.queue.length === this.maxSize) return false;
        this.queue.push(item);
        return true;
    }
    flush(callback) {
        this.queue.forEach(callback);
        this.queue = [];
    }
    getSize() {
        return this.queue.length;
    }
    constructor(maxSize){
        this.queue = void 0;
        this.maxSize = void 0;
        this.queue = [];
        this.maxSize = maxSize;
    }
}


const $9c8bc4bcbfdac5c7$var$MAX_EVENT_QUEUE_SIZE = 100;
const $9c8bc4bcbfdac5c7$var$EK_LOADED_EVENT = 'engagement.inproduct.loaded';
const $9c8bc4bcbfdac5c7$export$5306bd00631dbf8c = 'ep.analyticEvent';
function $9c8bc4bcbfdac5c7$var$collapseEventToPayload(event) {
    const payload = {
        ...event.payload,
        context: {}
    };
    Object.assign(payload.context, ...event.context);
    return payload;
}
function $9c8bc4bcbfdac5c7$var$findMatchingTrigger(messageMapping, payload) {
    return Array.from(messageMapping.keys()).find((trigger)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($hs90m)))(payload, trigger);
    });
}
function $9c8bc4bcbfdac5c7$var$fireExposureEvent(attributes, clientOrPromise) {
    const analyticsEvent = new (0, $feHMU.default)({
        payload: {
            action: 'exposed',
            actionSubject: 'feature',
            actionSubjectId: attributes.flagKey,
            source: 'engagement-platform',
            attributes: attributes
        }
    });
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendTrackEvent(analyticsEvent.payload);
    });
}
function $9c8bc4bcbfdac5c7$var$getExposureAttributes(messageId, cohort, additionalProps) {
    return {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        flagKey: `engagement.inproduct.${messageId}`,
        value: cohort,
        ...additionalProps
    };
}
function $9c8bc4bcbfdac5c7$var$getBaseAttributes(messageId, variationId, componentId, locale) {
    return {
        messageId: messageId,
        variationId: variationId,
        componentIndex: componentId,
        locale: locale
    };
}
async function $9c8bc4bcbfdac5c7$export$473a2bbbfd90c87b(eventMapping, config, store, clientOrPromise, coordinationOptions, componentConfig) {
    const { locale: locale } = config;
    const { message: message, component: component } = eventMapping;
    if (message.holdout) {
        await (0, $ll2sR.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        await (0, $ll2sR.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        $9c8bc4bcbfdac5c7$var$fireExposureEvent($9c8bc4bcbfdac5c7$var$getExposureAttributes(message.messageId, 'holdout', {
            locale: locale
        }), clientOrPromise);
        return;
    }
    if (component.componentId === 0) {
        const success = await (0, $ll2sR.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions?.enableChoreographer && componentConfig?.onMessageDisposition) componentConfig.onMessageDisposition(success ? (0, $fw9LG.MessageDeliveryStatus).STARTED : (0, $fw9LG.MessageDeliveryStatus).BLOCKED);
        if (success) {
            $9c8bc4bcbfdac5c7$var$fireExposureEvent($9c8bc4bcbfdac5c7$var$getExposureAttributes(message.messageId, message.variationId, {
                locale: locale
            }), clientOrPromise);
            store.dispatch((0, $349caf1aae10645a$export$5f80f094fd31fffd)(eventMapping));
        }
    } else {
        $9c8bc4bcbfdac5c7$var$fireExposureEvent($9c8bc4bcbfdac5c7$var$getExposureAttributes(message.messageId, message.variationId, {
            locale: locale
        }), clientOrPromise);
        store.dispatch((0, $349caf1aae10645a$export$5f80f094fd31fffd)(eventMapping));
    }
}
class $9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c extends (0, $42omo.Component) {
    getConfig() {
        const { config: config } = this.getState();
        return config;
    }
    getChildContext() {
        return {
            subscribeEngagementState: this.subscribeEngagementState,
            setComponentConfig: this.setComponentConfig
        };
    }
    getState() {
        return this.props.store.getState();
    }
    getActiveMessage() {
        return this.getState().current;
    }
    async completeMessage(messageId, componentConfig) {
        const config = this.getConfig();
        const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
        const disposition = await (0, $ll2sR.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions.enableChoreographer && componentConfig?.onMessageDisposition) componentConfig.onMessageDisposition(disposition ? (0, $fw9LG.MessageDeliveryStatus).STOPPED : (0, $fw9LG.MessageDeliveryStatus).CANCELED);
    }
    handleClickEvent(messageId, variationId, componentId) {
        const activeMessage = this.getActiveMessage();
        // It is important to check that the event we're handling matches the
        // current active message because it is possible for an event to come
        // through for a past message. We don't want to mess up the current
        // message by calling clearCurrent just because the old message is done.
        if (!activeMessage || activeMessage.messageId !== messageId || activeMessage.variationId !== variationId || activeMessage.componentId !== componentId) return;
        let componentConfig;
        if (activeMessage.componentType) {
            const componentConfigId = this.getConfigId(activeMessage.componentType, activeMessage.target);
            componentConfig = $9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
        }
        if (activeMessage.isLast) this.completeMessage(messageId, componentConfig);
        this.props.store.dispatch((0, $349caf1aae10645a$export$96105f873ade39d7)());
    }
    componentWillUnmount() {
        this.unsubscribeFromStore && this.unsubscribeFromStore();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
            channel: "*",
            onEvent: this.onEvent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
            channel: "engagement",
            onEvent: this.onEngagementEvent
        }, this.props.children));
    }
    constructor(props){
        super(props);
        this.analyticsEventQueue = void 0;
        this.unsubscribeFromStore = void 0;
        this.fireQueueOverflowEvent = void 0;
        this.sendUIEventWithClient = void 0;
        this.sendScreenEventWithClient = void 0;
        this.sendOperationalEventWithClient = void 0;
        this.onStoreChange = (state)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const config = this.getConfig();
            const { locale: locale } = config;
            if (state.initialized) {
                if (!$9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider) {
                    this.sendOperationalEventWithClient({
                        action: 'loaded',
                        actionSubject: 'messages',
                        actionSubjectId: undefined,
                        source: 'engagekit',
                        attributes: {
                            locale: locale
                        }
                    });
                    const browserInfo = (0, $812a060980ce0ea1$export$6c724a6ffa2dc3e1)();
                    this.onEvent(createAnalyticsEvent({
                        event: $9c8bc4bcbfdac5c7$var$EK_LOADED_EVENT,
                        properties: {
                            browser: browserInfo.name,
                            browserVersion: browserInfo.version
                        }
                    }));
                    $9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider = true;
                }
                this.analyticsEventQueue.flush(this.onEvent);
                if (this.unsubscribeFromStore) this.unsubscribeFromStore();
            }
        };
        this.onEvent = (event)=>{
            const state = this.getState();
            if (!state.initialized) {
                const success = this.analyticsEventQueue.enqueue(event);
                if (!success) this.fireQueueOverflowEvent();
                return;
            }
            const { eventTarget: eventTarget, store: store, analyticsClientInstance: analyticsClientInstance } = this.props;
            const config = this.getConfig();
            const { current: current, messageMapping: messageMapping } = state;
            const payload = $9c8bc4bcbfdac5c7$var$collapseEventToPayload(event);
            eventTarget.dispatchEvent((0, $3d2a366249ac5f1c$export$2e2bcd8739ae039)({
                eventName: $9c8bc4bcbfdac5c7$export$5306bd00631dbf8c,
                canBubble: false,
                cancellable: false,
                detail: payload
            }));
            if (!(0, $4nGsu.isMessagingEnabled)()) return;
            // existing message found
            if (current) return;
            const trigger = $9c8bc4bcbfdac5c7$var$findMatchingTrigger(messageMapping, payload);
            // No messages found for trigger
            if (!trigger) return;
            const eventMapping = messageMapping.get(trigger);
            let componentConfig;
            if (eventMapping.component?.componentType) {
                const componentConfigId = this.getConfigId(eventMapping.component.componentType, eventMapping.component.target);
                componentConfig = $9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
            }
            const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
            $9c8bc4bcbfdac5c7$export$473a2bbbfd90c87b(eventMapping, config, store, analyticsClientInstance, coordinationOptions, componentConfig);
        };
        this.onEngagementEvent = (event)=>{
            const { action: action, clickType: clickType, ekMessageId: ekMessageId, ekVariationId: ekVariationId, ekComponentId: ekComponentId, ekComponentType: ekComponentType, ekIsLast: ekIsLast } = event.payload;
            const config = this.getConfig();
            const { locale: locale } = config;
            const attributes = $9c8bc4bcbfdac5c7$var$getBaseAttributes(ekMessageId, ekVariationId, ekComponentId, locale);
            if (action === 'click') {
                this.handleClickEvent(ekMessageId, ekVariationId, ekComponentId);
                attributes.buttonType = clickType;
                this.sendUIEventWithClient({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: `${clickType}Button`,
                    source: `engagement_${ekComponentType}`,
                    attributes: attributes
                });
            } else {
                if (action === 'shown') {
                    attributes.componentType = ekComponentType;
                    this.sendScreenEventWithClient({
                        name: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
                if (action === 'hidden') {
                    attributes.isLast = ekIsLast;
                    this.sendUIEventWithClient({
                        action: 'hid',
                        actionSubject: 'component',
                        actionSubjectId: undefined,
                        source: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
            }
            this.onEvent(event);
        };
        this.subscribeEngagementState = (callback)=>{
            const { store: store } = this.props;
            callback(store.getState());
            return store.subscribe(()=>{
                callback(store.getState());
            });
        };
        this.getComponentCoordinationOptions = (componentConfig)=>{
            // Default enableChoreographer to the EngagementProvider's coordinationOptions
            const enableChoreographer = Boolean(this.props.coordinationOptions?.enableChoreographer);
            return {
                ...this.props.coordinationOptions,
                enableChoreographer: componentConfig?.messageType ? // Use the component's individual choreographer configuration, if defined,
                // regardless of the EngagementProvider's coordinationOptions
                (0, $6sxJX.shouldBeChoreographed)(componentConfig, {
                    enableChoreographer: true
                }) : enableChoreographer
            };
        };
        this.getConfigId = (componentType, engagementId)=>{
            return engagementId ? `${componentType}-${engagementId}` : componentType;
        };
        this.setComponentConfig = (componentType, config, engagementId)=>{
            const configId = this.getConfigId(componentType, engagementId);
            $9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.componentConfig.set(configId, config);
            return ()=>this.removeComponentConfig(configId);
        };
        this.removeComponentConfig = (configId)=>{
            if ($9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.componentConfig.has(configId)) $9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.componentConfig.delete(configId);
        };
        const { analyticsClientInstance: _analyticsClientInstance } = this.props;
        this.sendUIEventWithClient = (0, $59b1b265b9049137$export$1aecf263098db667).bind(null, _analyticsClientInstance);
        this.sendScreenEventWithClient = (0, $59b1b265b9049137$export$22a3b1671f38a193).bind(null, _analyticsClientInstance);
        this.sendOperationalEventWithClient = (0, $59b1b265b9049137$export$e5f89b51c6d4e36b).bind(null, _analyticsClientInstance);
        this.analyticsEventQueue = new (0, $b1929a7ab4bc735e$export$2e2bcd8739ae039)($9c8bc4bcbfdac5c7$var$MAX_EVENT_QUEUE_SIZE);
        this.unsubscribeFromStore = this.subscribeEngagementState(this.onStoreChange);
        this.fireQueueOverflowEvent = (0, (/*@__PURE__*/$parcel$interopDefault($20sPA)))(// TODO: create metric for this with Metal
        ()=>{});
    }
}
$9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.componentConfig = new Map();
$9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.childContextTypes = {
    subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
$9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.defaultProps = {
    eventTarget: (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))
};
/*
 * We use this flag for ensuring that we only fire the engagement.inproduct.loaded event once. This is an interim solution
 * until we can more holistically rethink our code architecture to eliminate duplicate behaviour across EngagementProviders.
 */ $9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider = false;


const $58bc48178420584b$var$EngagementProviderWithEvents = (0, $1DWH0.default)()((0, $9c8bc4bcbfdac5c7$export$83b8ae7ce7b4d59c));
const $58bc48178420584b$var$EngagementProviderWithDefaultStore = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($58bc48178420584b$var$EngagementProviderWithEvents, {
        ...props,
        store: (0, $25d7841ba52366e9$export$2e2bcd8739ae039)(props.config)
    });
};
var $58bc48178420584b$export$2e2bcd8739ae039 = (0, $8b0df458834f5425$export$2e2bcd8739ae039)($58bc48178420584b$var$EngagementProviderWithDefaultStore);






var $04e9M = parcelRequire("04e9M");


var $jOtRZ = parcelRequire("jOtRZ");





var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

function $dd0f530acbd7ff69$export$cd24ff735be1c995(props) {
    const { cloudId: cloudId, locale: locale, userId: userId, activationId: activationId, environment: environment } = (0, $bQm3c.useSessionData)();
    const workspaceId = (0, $04e9M.getWorkspaceId)(cloudId, activationId);
    if ((0, $17wUi.confluenceSessionStorageInstance).getItem((0, $1UApO.keys).DISABLE_ENGAGEMENT_FOR_TESTS) === 'true') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    const config = {
        cloudId: cloudId,
        aaid: userId,
        locale: locale,
        product: 'confluence',
        stargateUrl: '/gateway/api',
        workspaceId: workspaceId,
        isFedRAMPEnvironment: false
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const envType = (0, $jOtRZ.useAnalyticsEnvironment)(environment);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const coordinationOptions = (0, $42omo.useMemo)(()=>({
            enableChoreographer: true,
            envType: envType,
            additionalData: {
                sourceProductId: (0, $fw9LG.ProductIds).CONFLUENCE
            }
        }), [
        envType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $58bc48178420584b$export$2e2bcd8739ae039), {
        ...props,
        // eslint-disable-next-line react/no-children-prop
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children),
        config: config,
        analyticsClientInstance: (0, $04e9M.getAnalyticsWebClient)(),
        coordinationOptions: coordinationOptions
    });
}
$dd0f530acbd7ff69$export$cd24ff735be1c995.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).element,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};


function $b27b10f99376c25d$var$EngagementProviderComponentWrapper({ children: children }) {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const renderOnError = (0, $42omo.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    if (!isLicensed) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).INHERIT,
        renderOnError: renderOnError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dd0f530acbd7ff69$export$cd24ff735be1c995), null, children));
}
$b27b10f99376c25d$var$EngagementProviderComponentWrapper.propTypes = {
    children: (0, $4xcIM.element)
};
const $b27b10f99376c25d$export$83b8ae7ce7b4d59c = $b27b10f99376c25d$var$EngagementProviderComponentWrapper;
module.exports["EngagementProvider"] = $b27b10f99376c25d$export$83b8ae7ce7b4d59c;

});

parcelRegister("9hcBu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1KmJq = parcelRequire("1KmJq");


var $eSUdr = parcelRequire("eSUdr");


var $inPa6 = parcelRequire("inPa6");


var $jtuBN = parcelRequire("jtuBN");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $9wGTI = parcelRequire("9wGTI");


var $dPJCf = parcelRequire("dPJCf");


var $7Sm4c = parcelRequire("7Sm4c");


var $dd2fS = parcelRequire("dd2fS");

const $4aa660b1c29a3af1$var$OPT_OUT_CACHE_EXPIRATION_SECONDS = 31536000; // 1 year
const $4aa660b1c29a3af1$export$77dd43be45cef9eb = ({ onCompleted: onCompleted, onError: onError } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // useNav4OptOutMutation does not seem to return a response, success state is tracked with a hook instead
    const [isAdminUpdateSuccessful, setAdminUpdateSuccessful] = (0, $42omo.useState)(null);
    const { shouldSkipOptOutQuery: shouldSkipOptOutQuery } = (0, $dd2fS.useShouldSkipOptOutQuery)();
    const { loading: loading, data: data, error: queryError } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $eSUdr.default)`query useNav4OptOutQuery{userPreferences{nav4OptOut}}`, {
        skip: shouldSkipOptOutQuery
    });
    // Expected error - query will fail for anonymous and unlicensed users
    if (queryError?.message.includes('Cannot find authenticated user.')) (0, $7Sm4c.markErrorAsHandled)(queryError);
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [updateNav4OptOutServer] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation useNav4OptOutMutation($nav4OptOut:Boolean!){updateUserPreferences(userPreferences:{nav4OptOut:$nav4OptOut}){nav4OptOut}}`);
    const neverOptedOut = !loading && data?.userPreferences?.nav4OptOut === null;
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const updateNav4OptOut = (0, $42omo.useCallback)(async (newNav4OptOut)=>{
        updateNav4OptOutServer({
            variables: {
                nav4OptOut: newNav4OptOut
            }
        }).then(()=>{
            $4aa660b1c29a3af1$var$updateNav4OptOutCache(newNav4OptOut);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'changed',
                    actionSubject: 'navigationVersion',
                    source: 'nav4OptOut',
                    attributes: {
                        originalNavVersion: newNav4OptOut ? '4' : '3',
                        newNavVersion: newNav4OptOut ? '3' : '4'
                    }
                }
            }).fire();
            if (newNav4OptOut && neverOptedOut && !(0, $9wGTI.fg)('confluence_nav4_ga_phase_1')) // If this is the first time opting out, reload with query param to trigger Nav4OptOutSpotlight
            setQueryParams({
                navOptOut: 'true'
            });
            setAdminUpdateSuccessful(true);
            onCompleted?.();
        }).catch((error)=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'changeFailed',
                    actionSubject: 'navigationVersion',
                    source: 'nav4OptOut',
                    attributes: {
                        error: error
                    }
                }
            }).fire();
            setAdminUpdateSuccessful(false);
            onError?.(error);
        });
    }, [
        updateNav4OptOutServer,
        createAnalyticsEvent,
        neverOptedOut,
        setQueryParams,
        onCompleted,
        onError
    ]);
    const optOutCache = $4aa660b1c29a3af1$var$parseCacheValue((0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).NAV4_OPT_OUT_CACHE));
    const optOutServer = data?.userPreferences?.nav4OptOut;
    const nav4OptOut = ((0, $9wGTI.fg)('confluence_nav_4') || (0, $9wGTI.fg)('confluence_nav4_ga_phase_1')) && (loading ? optOutCache : optOutServer);
    (0, $42omo.useEffect)(()=>{
        if (!loading && optOutServer !== optOutCache) $4aa660b1c29a3af1$var$updateNav4OptOutCache(optOutServer);
    }, [
        loading,
        optOutCache,
        optOutServer
    ]);
    return {
        nav4OptOut: nav4OptOut,
        updateNav4OptOut: updateNav4OptOut,
        isAdminUpdateSuccessful: isAdminUpdateSuccessful
    };
};
const $4aa660b1c29a3af1$var$parseCacheValue = (cacheValue)=>{
    if (cacheValue === 'true') return true;
    else if (cacheValue === 'false') return false;
    else return undefined;
};
const $4aa660b1c29a3af1$export$913ff9805687cd8 = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).NAV4_OPT_OUT_CACHE) === 'true';
};
const $4aa660b1c29a3af1$export$aca664b5b089bc42 = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).NAV4_OPT_OUT_CACHE) === 'false';
};
const $4aa660b1c29a3af1$var$updateNav4OptOutCache = (nav4OptOut)=>{
    if (nav4OptOut) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).NAV4_OPT_OUT_CACHE, true, $4aa660b1c29a3af1$var$OPT_OUT_CACHE_EXPIRATION_SECONDS);
    else if (nav4OptOut === false) // if explicitly set to false, we need to save to check in phase_1 since false means "opt-in"
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).NAV4_OPT_OUT_CACHE, false, $4aa660b1c29a3af1$var$OPT_OUT_CACHE_EXPIRATION_SECONDS);
    else // the value is null and has never been set
    (0, $17wUi.confluenceLocalStorageInstance)?.removeItem((0, $1UApO.keys).NAV4_OPT_OUT_CACHE);
};
module.exports["useNav4OptOut"] = $4aa660b1c29a3af1$export$77dd43be45cef9eb;
module.exports["getNav4OptOutCache"] = $4aa660b1c29a3af1$export$913ff9805687cd8;
module.exports["getNav4GAOptInCache"] = $4aa660b1c29a3af1$export$aca664b5b089bc42;

});

parcelRegister("iuIEr", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $b498080c9041fb4f$var$OPT_OUT_CACHE_EXPIRATION_SECONDS = 31536000; // 1 year
const $b498080c9041fb4f$export$2157f431c298ed22 = (nav4AdminOptIn)=>{
    if (nav4AdminOptIn) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).NAV4_ADMIN_OPT_IN_CACHE, true, $b498080c9041fb4f$var$OPT_OUT_CACHE_EXPIRATION_SECONDS);
    else // the value is null and has never been set
    (0, $17wUi.confluenceLocalStorageInstance)?.removeItem((0, $1UApO.keys).NAV4_ADMIN_OPT_IN_CACHE);
};
const $b498080c9041fb4f$export$4b020a7ac475108f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).NAV4_ADMIN_OPT_IN_CACHE) === 'true';
};
module.exports["updateNav4AdminOptInCache"] = $b498080c9041fb4f$export$2157f431c298ed22;
module.exports["getNav4AdminOptInCache"] = $b498080c9041fb4f$export$4b020a7ac475108f;

});

parcelRegister("iu6oZ", function(module, exports) {
const $f3b5cc99c5d99322$export$21c466265830bc3a = 'navigationSessionStart';
const $f3b5cc99c5d99322$export$2a8e400e9c788e93 = 'navigationSessionStartTouch';
const $f3b5cc99c5d99322$export$d46bd3ead7cc759b = 'navigationSessionTouch';
const $f3b5cc99c5d99322$export$32239d68d9c6cb49 = 'navigationSessionEnd';
module.exports["START"] = $f3b5cc99c5d99322$export$21c466265830bc3a;
module.exports["START_TOUCH"] = $f3b5cc99c5d99322$export$2a8e400e9c788e93;
module.exports["TOUCH"] = $f3b5cc99c5d99322$export$d46bd3ead7cc759b;
module.exports["END"] = $f3b5cc99c5d99322$export$32239d68d9c6cb49;

});

parcelRegister("hHa70", function(module, exports) {
parcelRequire("fD5Hh");
var $b9NdB = parcelRequire("b9NdB");

const $b551d0022134cd9e$export$849380b7ef7c6423 = (0, $b9NdB.client)('rovo-chat');
module.exports["ROVO_CHAT_CLIENT_ID"] = $b551d0022134cd9e$export$849380b7ef7c6423;

});

parcelRegister("4wBlk", function(module, exports) {
parcelRequire("fD5Hh");
var $b9NdB = parcelRequire("b9NdB");

const $2a2e2d7e05ed1811$export$2ad5837eb82f758b = (0, $b9NdB.client)('rovo-extension');
module.exports["ROVO_EXTENSION_CLIENT_ID"] = $2a2e2d7e05ed1811$export$2ad5837eb82f758b;

});

parcelRegister("aesXQ", function(module, exports) {
parcelRequire("fD5Hh");
var $b9NdB = parcelRequire("b9NdB");

const $3254b669ef7d795b$export$24580e289ee2ffdc = (0, $b9NdB.client)('rovo-experience-tracking-sender');
module.exports["ROVO_EXPERIENCE_TRACKING_SENDER_CLIENT_ID"] = $3254b669ef7d795b$export$24580e289ee2ffdc;

});

parcelRegister("cBspM", function(module, exports) {
parcelRequire("fD5Hh");
var $b9NdB = parcelRequire("b9NdB");

const $0e339f6d95a8bd7f$export$6c08ef6d43996fe4 = (0, $b9NdB.client)('help-center-form-content-renderer');
module.exports["HELP_CENTER_FORM_REQUEST_CLIENT_ID"] = $0e339f6d95a8bd7f$export$6c08ef6d43996fe4;

});

parcelRegister("eL1ct", function(module, exports) {
parcelRequire("fD5Hh");
var $b9NdB = parcelRequire("b9NdB");

const $962b68997878101c$var$CONFLUENCE_EDITOR_CLIENT_ID_PREFIX = 'confluence-editor';
const $962b68997878101c$export$3c63b57f6a593217 = (contentId)=>(0, $b9NdB.client)(`${$962b68997878101c$var$CONFLUENCE_EDITOR_CLIENT_ID_PREFIX}-${contentId}`);
module.exports["getConfluenceEditorClientId"] = $962b68997878101c$export$3c63b57f6a593217;

});

parcelRegister("hAjeC", function(module, exports) {
parcelRequire("fD5Hh");
var $b9NdB = parcelRequire("b9NdB");

const $9e0dccefe27ad79f$export$8250ca57d8d07487 = (0, $b9NdB.client)('confluence-space');
module.exports["CONFLUENCE_SPACE_CLIENT_ID"] = $9e0dccefe27ad79f$export$8250ca57d8d07487;

});

parcelRegister("6nGJw", function(module, exports) {
parcelRequire("fD5Hh");
var $b9NdB = parcelRequire("b9NdB");

const $22fe4731fba71197$export$346313916c39ec03 = (0, $b9NdB.client)('confluence-whiteboard');
const $22fe4731fba71197$var$CONFLUENCE_WHITEBOARD_CLIENT_ID_PREFIX = 'confluence-whiteboard';
const $22fe4731fba71197$export$7a4eab435d4dde86 = (contentId)=>(0, $b9NdB.client)(`${$22fe4731fba71197$var$CONFLUENCE_WHITEBOARD_CLIENT_ID_PREFIX}-${contentId}`);
module.exports["CONFLUENCE_WHITEBOARD_CLIENT_ID"] = $22fe4731fba71197$export$346313916c39ec03;
module.exports["getConfluenceWhiteboardClientId"] = $22fe4731fba71197$export$7a4eab435d4dde86;

});

parcelRegister("fgOJ7", function(module, exports) {
parcelRequire("fD5Hh");
var $b9NdB = parcelRequire("b9NdB");

const $6c9c1841a7cfaabb$var$CONFLUENCE_DATABASE_CLIENT_ID_PREFIX = 'confluence-database';
const $6c9c1841a7cfaabb$export$944a2201a89e310b = (contentId)=>(0, $b9NdB.client)(`${$6c9c1841a7cfaabb$var$CONFLUENCE_DATABASE_CLIENT_ID_PREFIX}-${contentId}`);
module.exports["getConfluenceDatabaseClientId"] = $6c9c1841a7cfaabb$export$944a2201a89e310b;

});

parcelRegister("dOEWJ", function(module, exports) {
parcelRequire("fD5Hh");
var $b9NdB = parcelRequire("b9NdB");

const $bbd8c2fb7adc83ad$var$CLIENT_ID_PREFIX = 'rovo-broadcast-confirmed-actions';
const $bbd8c2fb7adc83ad$export$ccb03740c4f32a07 = (id)=>(0, $b9NdB.client)(`${$bbd8c2fb7adc83ad$var$CLIENT_ID_PREFIX}-${id}`);
function $bbd8c2fb7adc83ad$export$258ec240aae2a0bc(clientId) {
    return clientId.startsWith($bbd8c2fb7adc83ad$var$CLIENT_ID_PREFIX);
}
module.exports["isRovoBroadcastConfirmedActions"] = $bbd8c2fb7adc83ad$export$258ec240aae2a0bc;

});

parcelRegister("4a3y9", function(module, exports) {
parcelRequire("fD5Hh");
var $b9NdB = parcelRequire("b9NdB");

const $315f310df919db86$export$a748a8497702f47e = (0, $b9NdB.client)('rovo-inline-input-box');
module.exports["ROVO_INLINE_INPUT_BOX_CLIENT_ID"] = $315f310df919db86$export$a748a8497702f47e;

});

parcelRegister("dGRQv", function(module, exports) {
parcelRequire("fD5Hh");
var $b9NdB = parcelRequire("b9NdB");

const $d08df545166b7b09$export$7f629c3471231b6a = (0, $b9NdB.client)('smart-create-modal');
module.exports["SMART_CREATE_MODAL_CLIENT_ID"] = $d08df545166b7b09$export$7f629c3471231b6a;

});

parcelRegister("eX3ET", function(module, exports) {
parcelRequire("fD5Hh");
var $b9NdB = parcelRequire("b9NdB");

const $8a91310f7ad0612b$export$af80dd36c922905e = (0, $b9NdB.client)('jira-smart-create-modal');
const $8a91310f7ad0612b$export$37d6bd20610dc5a7 = (0, $b9NdB.client)('jira-smart-create-table');
module.exports["JIRA_SMART_CREATE_TABLE_CLIENT_ID"] = $8a91310f7ad0612b$export$37d6bd20610dc5a7;

});

parcelRegister("4PV5A", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $9f18a5eeb2d9b42c$export$a1450e73444b242a = (0, $3OwWt.createCommand)('confluence-page-create-command');
module.exports["ConfluencePageCreateCommand"] = $9f18a5eeb2d9b42c$export$a1450e73444b242a;

});

parcelRegister("a1lfc", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $7b3a6caa6fd24184$export$85b139527d06ee36 = (0, $3OwWt.createCommand)('confluence-page-update-command');
module.exports["ConfluenceUpdatePageCommand"] = $7b3a6caa6fd24184$export$85b139527d06ee36;

});

parcelRegister("2VpjI", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $7f5a08b53d2a63d3$export$52973270c31d5176 = (0, $3OwWt.createCommand)('confluence-whiteboard-create-command');
module.exports["ConfluenceWhiteboardCreateCommand"] = $7f5a08b53d2a63d3$export$52973270c31d5176;

});

parcelRegister("wLBYY", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $74169d832f76f7a0$export$764ff6b3b85c6964 = (0, $3OwWt.createCommand)('confluence-whiteboard-update-command');
module.exports["ConfluenceWhiteboardUpdateCommand"] = $74169d832f76f7a0$export$764ff6b3b85c6964;

});

parcelRegister("6PlIk", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $8cb6f5f56bc6e0de$export$32e09b0581875caf = (0, $3OwWt.createCommand)('confluence-deep-research-page-create-command');
module.exports["ConfluenceDeepResearchPageCreateCommand"] = $8cb6f5f56bc6e0de$export$32e09b0581875caf;

});

parcelRegister("aAJDc", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $3c187a96cc813617$export$a18369a0814f335e = (0, $3OwWt.createCommand)('confluence-whiteboard-brainstorming-command');
module.exports["ConfluenceWhiteboardBrainstormingCommand"] = $3c187a96cc813617$export$a18369a0814f335e;

});

parcelRegister("4t4G2", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $09a0b587529d5ae6$export$bb8af363a8f0dd89 = (0, $3OwWt.createCommand)('confluence-whiteboard-diagramming-command');
module.exports["ConfluenceWhiteboardDiagrammingCommand"] = $09a0b587529d5ae6$export$bb8af363a8f0dd89;

});

parcelRegister("b9pZB", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $958c96bd89be97a7$export$26f00d2a2ba7c10 = (0, $3OwWt.createCommand)('confluence-space-create-command');
module.exports["ConfluenceSpaceCreateCommand"] = $958c96bd89be97a7$export$26f00d2a2ba7c10;

});

parcelRegister("P9F4k", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $0a2e01c6f981cd88$export$8b6f33398c82b066 = (0, $3OwWt.createCommand)('confluence-space-update-command');
module.exports["ConfluenceSpaceUpdateCommand"] = $0a2e01c6f981cd88$export$8b6f33398c82b066;

});

parcelRegister("2R0Tl", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $60075a5b65fdd277$export$beca1c3ad59b6a98 = (0, $3OwWt.createCommand)('read-content-command');
module.exports["ReadContentCommand"] = $60075a5b65fdd277$export$beca1c3ad59b6a98;

});

parcelRegister("5ghuE", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $cb4a4321d2881a3a$export$1a9a98d2f924b164 = (0, $3OwWt.createCommand)('read-space-command');
module.exports["ReadSpaceCommand"] = $cb4a4321d2881a3a$export$1a9a98d2f924b164;

});

parcelRegister("kA0AR", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $ad79ac8481634363$export$8e74123a470f256e = (0, $3OwWt.createCommand)('prepare-content-for-finalization-command');
module.exports["PrepareContentForFinalizationCommand"] = $ad79ac8481634363$export$8e74123a470f256e;

});

parcelRegister("aUQK5", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $13c06823585b998a$export$22669456467d325 = (0, $3OwWt.createCommand)('inline-input-box-send-message-command');
module.exports["InlineInputBoxSendMessageCommand"] = $13c06823585b998a$export$22669456467d325;

});

parcelRegister("ffsQI", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $01c19cb910a2c3d4$export$40b320247a441c03 = (0, $3OwWt.createCommand)('confluence-database-create-command');
module.exports["ConfluenceDatabaseCreateCommand"] = $01c19cb910a2c3d4$export$40b320247a441c03;

});

parcelRegister("5sQwW", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $1b2b6c5386d10c86$export$780203dcd64e7bb4 = (0, $3OwWt.createCommand)('confluence-database-update-command');
module.exports["ConfluenceDatabaseUpdateCommand"] = $1b2b6c5386d10c86$export$780203dcd64e7bb4;

});

parcelRegister("cDDqH", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $88a286e148123a2e$export$fee55b20c7c13012 = (0, $3OwWt.createCommand)('inline-input-box-abort-message-command');
module.exports["InlineInputBoxAbortMessageCommand"] = $88a286e148123a2e$export$fee55b20c7c13012;

});

parcelRegister("lfmg5", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $ab0c69c204c01c9b$export$37a1103a81c8530f = (0, $3OwWt.createCommand)('inline-input-box-final-response-message-command');
module.exports["InlineInputBoxFinalResponseMessageCommand"] = $ab0c69c204c01c9b$export$37a1103a81c8530f;

});

parcelRegister("22Wz8", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $3bc5975fe96523d5$export$f9cc8d0bf779429c = (0, $3OwWt.createCommand)('inline-input-box-trace-message-command');
module.exports["InlineInputBoxTraceMessageCommand"] = $3bc5975fe96523d5$export$f9cc8d0bf779429c;

});

parcelRegister("bnT2y", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $99c8f98b2826ce5e$export$2a588dc272902413 = (0, $3OwWt.createCommand)('inline-input-box-error-message-command');
module.exports["InlineInputBoxErrorMessageCommand"] = $99c8f98b2826ce5e$export$2a588dc272902413;

});

parcelRegister("eY3DB", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $dad97e1a0d65333a$export$6e0ff3dd50e6cb87 = (0, $3OwWt.createCommand)('content-ready');
const $dad97e1a0d65333a$export$681981d15386a49c = (0, $3OwWt.createCommand)('content-destroy');
module.exports["ContentReadyCommand"] = $dad97e1a0d65333a$export$6e0ff3dd50e6cb87;
module.exports["ContentDestroyCommand"] = $dad97e1a0d65333a$export$681981d15386a49c;

});

parcelRegister("7UZdX", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $f7be2127a7be2a6b$export$6c37c31e66208e9b = (0, $3OwWt.createCommand)('confluence-page-init-command');
module.exports["ConfluencePageInitCommand"] = $f7be2127a7be2a6b$export$6c37c31e66208e9b;

});

parcelRegister("c9IhA", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $e81d6c2a8e59ecb3$export$2429e7ad86b06549 = (0, $3OwWt.createCommand)('confluence-whiteboard-init-command');
module.exports["ConfluenceWhiteboardInitCommand"] = $e81d6c2a8e59ecb3$export$2429e7ad86b06549;

});

parcelRegister("gdg5T", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $4bb3c4ffe5f83dd5$export$374c4548d2bf645a = (0, $3OwWt.createCommand)('rovo-stream-completed-command');
const $4bb3c4ffe5f83dd5$export$62fddcb893a4619 = (0, $3OwWt.createCommand)('rovo-stream-errored-command');
const $4bb3c4ffe5f83dd5$export$1cac522d42a0059a = (0, $3OwWt.createCommand)('rovo-stream-aborted-command');
module.exports["RovoStreamCompletedCommand"] = $4bb3c4ffe5f83dd5$export$374c4548d2bf645a;
module.exports["RovoStreamErroredCommand"] = $4bb3c4ffe5f83dd5$export$62fddcb893a4619;
module.exports["RovoStreamAbortedCommand"] = $4bb3c4ffe5f83dd5$export$1cac522d42a0059a;

});

parcelRegister("65sE6", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $ffa3687b823c450f$export$194038c1ca9cb268 = (0, $3OwWt.createCommand)('smart-creation-modal-activated');
const $ffa3687b823c450f$export$d6e8fa673d0893fd = (0, $3OwWt.createCommand)('smart-creation-modal-deactivated');
module.exports["SmartCreationModalActivatedCommand"] = $ffa3687b823c450f$export$194038c1ca9cb268;
module.exports["SmartCreationModalDeactivatedCommand"] = $ffa3687b823c450f$export$d6e8fa673d0893fd;

});

parcelRegister("ipJWw", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $a173645799746345$export$d430618eecf50cc4 = (0, $3OwWt.createBroadcastableCommand)('rovo-broadcast-confirmed-actions-command');
module.exports["RovoBroadcastConfirmedActionsCommand"] = $a173645799746345$export$d430618eecf50cc4;

});

parcelRegister("eXBlY", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $d0e721bee74af815$export$28bc11601bb4ecdf = (0, $3OwWt.createCommand)('confluence-prompt-submit-on-page-create-command');
module.exports["ConfluenceSubmitPromptOnPageCreateCommand"] = $d0e721bee74af815$export$28bc11601bb4ecdf;

});

parcelRegister("eeVx7", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $eca2f3a0c732336b$export$4a3833ddccd6672b = (0, $3OwWt.createCommand)('aifc-experience-tracking-command');
module.exports["AifcExperienceTrackingCommand"] = $eca2f3a0c732336b$export$4a3833ddccd6672b;

});

parcelRegister("7lMwT", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $65d5349aaf408f61$export$fa7e3d4efc038293 = (0, $3OwWt.createCommand)('notify-success-command');
module.exports["NotifySuccessCommand"] = $65d5349aaf408f61$export$fa7e3d4efc038293;

});

parcelRegister("5MhyR", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $c0c4d8bd171d446c$export$4d655e1102c096fc = (0, $3OwWt.createCommand)('browser-context-command');
module.exports["BrowserContextCommand"] = $c0c4d8bd171d446c$export$4d655e1102c096fc;

});

parcelRegister("lqQ3F", function(module, exports) {
parcelRequire("fD5Hh");
var $3OwWt = parcelRequire("3OwWt");

const $718efdd2a105fb4a$export$d1a4611f463cae77 = (0, $3OwWt.createCommand)('jira-create-items-command');
module.exports["JiraCreateItemsCommand"] = $718efdd2a105fb4a$export$d1a4611f463cae77;

});

parcelRegister("axhi9", function(module, exports) {

var $15h8H = parcelRequire("15h8H");

const $e59dac36041cf1d2$export$57477d04dca7c540 = (id, setupHandlers, api = (0, $15h8H.getBrowserBridgeAPI)())=>{
    // setup command handlers before indicating this client is ready
    setupHandlers?.((command, handler)=>api.on(id, command, handler));
    // indicate as ready
    api.ready(id);
    // start using the API
    return api;
};

});

parcelRegister("7MUeQ", function(module, exports) {
"use strict";
var $5ab8a3e02b325ee4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5ab8a3e02b325ee4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5ab8a3e02b325ee4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5ab8a3e02b325ee4$var$__exportStar((parcelRequire("jhQry")), module.exports);

$5ab8a3e02b325ee4$var$__exportStar((parcelRequire("kIKHr")), module.exports);

$5ab8a3e02b325ee4$var$__exportStar((parcelRequire("g8b8P")), module.exports);

$5ab8a3e02b325ee4$var$__exportStar((parcelRequire("j1BaM")), module.exports);

$5ab8a3e02b325ee4$var$__exportStar((parcelRequire("7mczC")), module.exports);

});

parcelRegister("f4ag9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultErrorCode = void 0;
module.exports.DefaultErrorCode = 0;

});

parcelRegister("eF8UL", function(module, exports) {

var $7MUeQ = parcelRequire("7MUeQ");

function $aa3d9f4f35c3fdc3$export$4f25fe9107a7301c(commandClass, commandProperties) {
    const parts = [
        'rovo-bridge-api',
        commandProperties.senderId,
        commandProperties.receiverId,
        commandClass.identifier,
        commandProperties._invocationId ?? 'unspecified-id'
    ];
    return parts.join(':');
}
function $aa3d9f4f35c3fdc3$export$e414fa4333835a96(id, commandClass, commandProperties) {
    return (0, $7MUeQ.createJSONRPCRequest)(id, commandClass.identifier, commandProperties);
}
function $aa3d9f4f35c3fdc3$export$8dddc5c53da4c063(id, senderId, receiverId, result) {
    const response = (0, $7MUeQ.createJSONRPCSuccessResponse)(id, result);
    return {
        ...response,
        params: {
            senderId: senderId,
            receiverId: receiverId
        }
    };
}
function $aa3d9f4f35c3fdc3$export$97e0f665ead0e435(id, senderId, receiverId, code = (0, $7MUeQ.JSONRPCErrorCode).InternalError, error) {
    const response = (0, $7MUeQ.createJSONRPCErrorResponse)(id, code, error.message, error.stack);
    return {
        ...response,
        params: {
            senderId: senderId,
            receiverId: receiverId
        }
    };
}
function $aa3d9f4f35c3fdc3$export$94e3360fcddccc76(request) {
    return Boolean((0, $7MUeQ.isJSONRPCRequest)(request) && request.id && typeof request.id === 'string');
}
function $aa3d9f4f35c3fdc3$export$c2a53faed5b3a8da(response) {
    return Boolean((0, $7MUeQ.isJSONRPCResponse)(response) && response.id && typeof response.id === 'string');
}
module.exports["createInvocationId"] = $aa3d9f4f35c3fdc3$export$4f25fe9107a7301c;
module.exports["rpcCommand"] = $aa3d9f4f35c3fdc3$export$e414fa4333835a96;
module.exports["rpcSuccess"] = $aa3d9f4f35c3fdc3$export$8dddc5c53da4c063;
module.exports["rpcError"] = $aa3d9f4f35c3fdc3$export$97e0f665ead0e435;
module.exports["isRPCRequest"] = $aa3d9f4f35c3fdc3$export$94e3360fcddccc76;
module.exports["isRPCResponse"] = $aa3d9f4f35c3fdc3$export$c2a53faed5b3a8da;

});

parcelRegister("dgXJ7", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");

const $9db38887cf5a61fb$var$STOP_DELAY_TIMEOUT = 11000;
let $9db38887cf5a61fb$var$lastDelayActionPromise = (0, $04e9M.getAnalyticsWebClient)();
let $9db38887cf5a61fb$var$isAutomaticExposuresEnabled = false;
const $9db38887cf5a61fb$export$79d5d0605aceeccc = async (routeName)=>{
    if (routeName !== 'VIEW_PAGE') return $9db38887cf5a61fb$var$lastDelayActionPromise;
    const { featureFlagClient: featureFlagClient } = await (0, $ge2sX.getSessionData)();
    // By using chained promises we can ensure that the order of pause and resume calls are kept
    $9db38887cf5a61fb$var$lastDelayActionPromise = $9db38887cf5a61fb$var$lastDelayActionPromise.then((analyticsClient)=>{
        // If pauseLowPriorityEvents is called when it's already active, then we are just extending
        // the delay period, so we don't want to reset any metadata we have captured about the original start.
        if (!$9db38887cf5a61fb$var$isAutomaticExposuresEnabled) {
            featureFlagClient.setIsAutomaticExposuresEnabled(true);
            $9db38887cf5a61fb$var$isAutomaticExposuresEnabled = true;
        }
        analyticsClient.startLowPriorityEventDelay($9db38887cf5a61fb$var$STOP_DELAY_TIMEOUT, $9db38887cf5a61fb$var$stopLowPriorityEventDelayCallback);
        return analyticsClient;
    });
    // return only for test usage
    return $9db38887cf5a61fb$var$lastDelayActionPromise;
};
const $9db38887cf5a61fb$export$f627161e107278c0 = ()=>{
    $9db38887cf5a61fb$var$lastDelayActionPromise = $9db38887cf5a61fb$var$lastDelayActionPromise.then((analyticsClient)=>{
        analyticsClient.stopLowPriorityEventDelay();
        return analyticsClient;
    });
    // return only for test usage
    return $9db38887cf5a61fb$var$lastDelayActionPromise;
};
// this callback will always be called from the analytics web client
const $9db38887cf5a61fb$var$stopLowPriorityEventDelayCallback = async ()=>{
    const { featureFlagClient: featureFlagClient } = await (0, $ge2sX.getSessionData)();
    featureFlagClient.setIsAutomaticExposuresEnabled(false);
    $9db38887cf5a61fb$var$isAutomaticExposuresEnabled = true;
};
module.exports["pauseLowPriorityEvents"] = $9db38887cf5a61fb$export$79d5d0605aceeccc;
module.exports["resumeLowPriorityEvents"] = $9db38887cf5a61fb$export$f627161e107278c0;

});

parcelRegister("hxeND", function(module, exports) {

var $58u2L = parcelRequire("58u2L");

const $eedd4917ca826380$export$e099b20409de544b = (themeState)=>{
    return {
        ...(0, $58u2L.getDefaultTheme)(),
        ...themeState,
        typography: 'typography'
    };
};
module.exports["buildThemeFromState"] = $eedd4917ca826380$export$e099b20409de544b;

});

parcelRegister("l7ck4", function(module, exports) {

var $04e9M = parcelRequire("04e9M");

const $c02479209652268b$export$d3fdcaafc90b083a = {
    themeAPI: 'themeAPI',
    remoteThemeStorage: 'remoteThemeStorage',
    useThemingState: 'useThemingState'
};
const $c02479209652268b$export$72a05cdc0e0fc7eb = {
    getSavedTheme: 'getSavedTheme',
    apolloMutationErrors: 'apolloMutationErrors',
    saveThemeRemote: 'saveThemeRemote',
    setColorMode: 'setColorMode'
};
const $c02479209652268b$export$57a9bc2929c9a2b1 = async (subject, subjectId, attributes)=>{
    const client = await (0, $04e9M.getAnalyticsWebClient)();
    client.sendUIEvent({
        source: 'theming',
        action: 'error',
        actionSubject: subject,
        actionSubjectId: subjectId,
        attributes: attributes
    });
};
module.exports["ErrorSubjects"] = $c02479209652268b$export$d3fdcaafc90b083a;
module.exports["ErrorSubjectIds"] = $c02479209652268b$export$72a05cdc0e0fc7eb;
module.exports["reportThemingError"] = $c02479209652268b$export$57a9bc2929c9a2b1;

});

parcelRegister("3p0JS", function(module, exports) {
const $53e04b1c25cc05a9$export$d04ae6f61d7c3eb1 = {
    contentId: '',
    spaceKey: '',
    parentPageId: '',
    templateId: '',
    title: '',
    blueprint: {
        contentBlueprintId: '',
        itemModuleCompleteKey: ''
    },
    showTemplateVariableInputDrawer: false,
    showBlueprintVariableWizard: false,
    onContentUpdated: ()=>{},
    onError: ()=>{}
};
const $53e04b1c25cc05a9$export$a2e7ab36beb33d74 = ()=>{
    return {
        ...$53e04b1c25cc05a9$export$d04ae6f61d7c3eb1,
        onClose: ()=>{},
        openTemplateVariables: ({})=>{},
        openBlueprintWizard: ({})=>{}
    };
};
module.exports["getDefaultChangeableValues"] = $53e04b1c25cc05a9$export$d04ae6f61d7c3eb1;
module.exports["getDefaultContextState"] = $53e04b1c25cc05a9$export$a2e7ab36beb33d74;

});

parcelRegister("aiAUl", function(module, exports) {
$parcel$export(module.exports, "default", () => $77f836f57929774c$export$2e2bcd8739ae039);
parcelRequire("42omo");

parcelRequire("kFqI2");
var $2GFTt = parcelRequire("2GFTt");


var $5cBWV = parcelRequire("5cBWV");

const $493d0f2fa1aa4d5c$export$6d4e820aaceb5999 = (0, $5cBWV.commonActionCreator)('CLOSE_ACTIVE_MODAL');
const $493d0f2fa1aa4d5c$export$7c7b664744e0bbd3 = (0, $5cBWV.commonActionCreator)('SET_ACTIVE_MODAL');



var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");

class $eb39382018b931f4$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    render() {
        const { modalComponent: Modal, modalProps: modalProps, closeActiveModal: closeActiveModal } = this.props;
        if (Modal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
            ...modalProps,
            closeModal: closeActiveModal
        });
        return null;
    }
}
$eb39382018b931f4$export$2e2bcd8739ae039.defaultProps = {
    modalProps: {}
};
$eb39382018b931f4$export$2e2bcd8739ae039.propTypes = {
    closeActiveModal: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    modalComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    modalProps: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
};


const $77f836f57929774c$var$mapStateToProps = ({ modal: { modalComponent: modalComponent, modalProps: modalProps } })=>({
        modalComponent: modalComponent,
        modalProps: modalProps
    });
var $77f836f57929774c$export$2e2bcd8739ae039 = (0, $2GFTt.default)($77f836f57929774c$var$mapStateToProps, {
    closeActiveModal: $493d0f2fa1aa4d5c$export$6d4e820aaceb5999
})((0, $eb39382018b931f4$export$2e2bcd8739ae039));

});

parcelRegister("e43zd", function(module, exports) {

var $4GzBp = parcelRequire("4GzBp");


var $flE5X = parcelRequire("flE5X");

// In some circumstances, unmounting a <Query> won't cancel the underlying query,
// causing a retry-loop to continue long after the corresponding UI has
// disappeared (link-to-this-page-dialog was doing this for me -mdean2).
// Seems to need fetchPolicy="cache-first" (the default) and a not-single query
// to show the effect. While that's still an issue, be conservative with the
// max retries.
const $358c0fe063680ddb$var$NETWORK_ERROR_MAX_RETRIES = 2;
const $358c0fe063680ddb$var$NETWORK_ERROR_INITIAL_RETRY_DELAY_MS = 500;
const $358c0fe063680ddb$var$NETWORK_ERROR_MAX_RETRY_DELAY_MS = 5000;
// Query retries are disabled by default: reconsider after fetching feature flags
let $358c0fe063680ddb$var$retryEnabled = false;

const $358c0fe063680ddb$var$sendTrackEvent = (error, operation)=>{
    Promise.resolve((parcelRequire("04e9M"))).then(({ getAnalyticsWebClient: getAnalyticsWebClient })=>{
        getAnalyticsWebClient().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'graphql',
                action: 'errored',
                attributes: {
                    eventName: 'network.error.retry',
                    queryName: operation.operationName,
                    priorRetries: operation.getContext().networkRetries || 0,
                    message: error.message
                }
            });
        });
    });
};
const $358c0fe063680ddb$export$bc8f9e5839290435 = new (0, $4GzBp.RetryLink)({
    delay: {
        initial: $358c0fe063680ddb$var$NETWORK_ERROR_INITIAL_RETRY_DELAY_MS,
        max: $358c0fe063680ddb$var$NETWORK_ERROR_MAX_RETRY_DELAY_MS,
        jitter: true
    },
    attempts: {
        max: $358c0fe063680ddb$var$NETWORK_ERROR_MAX_RETRIES,
        retryIf: (error, operation)=>{
            // Never retry if feature-flag not enabled
            if (!$358c0fe063680ddb$var$retryEnabled) return false;
            // Don't retry mutations, regardless of all other concerns
            if (operation.query.definitions.some((definition)=>'operation' in definition && definition.operation === 'mutation')) return false;
            // Do retry when connection failed at the network layer
            if (error instanceof (0, $flE5X.NoNetworkError)) {
                $358c0fe063680ddb$var$sendTrackEvent(error, operation);
                operation.setContext((context)=>({
                        networkRetries: (context.networkRetries || 0) + 1
                    }));
                return true;
            }
            // All other errors, leave it to a higher link in the chain to retry if it wants to
            return false;
        }
    }
});
function $358c0fe063680ddb$export$164e9e9b901ab24f() {
    $358c0fe063680ddb$var$retryEnabled = true;
}
module.exports["networkErrorRetryLink"] = $358c0fe063680ddb$export$bc8f9e5839290435;
module.exports["enableNetworkRetryLink"] = $358c0fe063680ddb$export$164e9e9b901ab24f;

});

parcelRegister("b2nDI", function(module, exports) {

var $4GzBp = parcelRequire("4GzBp");


var $hBkCm = parcelRequire("hBkCm");

// In some circumstances, unmounting a <Query> won't cancel the underlying query,
// causing a retry-loop to continue long after the corresponding UI has
// disappeared (link-to-this-page-dialog was doing this for me -mdean2).
// Seems to need fetchPolicy="cache-first" (the default) and a not-single query
// to show the effect. While that's still an issue, be conservative with the
// max retries.
const $1fda01e907a51fcb$var$BAD_STATUS_CODE_MAX_RETRIES = 2;
const $1fda01e907a51fcb$var$BAD_STATUS_CODE_INITIAL_RETRY_DELAY_MS = 500;
const $1fda01e907a51fcb$var$BAD_STATUS_CODE_MAX_RETRY_DELAY_MS = 5000;
// Query retries are disabled by default: reconsider after fetching feature flags
let $1fda01e907a51fcb$var$retryEnabled = false;

// @ts-ignore
// eslint-disable-next-line no-unused-vars
const $1fda01e907a51fcb$var$sendTrackEvent = (error, operation)=>{
    Promise.resolve((parcelRequire("04e9M"))).then(({ getAnalyticsWebClient: getAnalyticsWebClient })=>{
        getAnalyticsWebClient().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'graphql',
                action: 'errored',
                attributes: {
                    eventName: 'status.code.retry',
                    queryName: operation.operationName,
                    priorRetries: operation.getContext().statusRetries || 0,
                    status: error.response.status,
                    statusText: error.response.statusText
                }
            });
        });
    });
};
const $1fda01e907a51fcb$export$e30c063a9dc76f6b = new (0, $4GzBp.RetryLink)({
    delay: {
        initial: $1fda01e907a51fcb$var$BAD_STATUS_CODE_INITIAL_RETRY_DELAY_MS,
        max: $1fda01e907a51fcb$var$BAD_STATUS_CODE_MAX_RETRY_DELAY_MS,
        jitter: true
    },
    attempts: {
        max: $1fda01e907a51fcb$var$BAD_STATUS_CODE_MAX_RETRIES,
        retryIf: (error, operation)=>{
            // Never retry if feature-flag not enabled
            if (!$1fda01e907a51fcb$var$retryEnabled) return false;
            // If we didn't receive a 2xx status code, then...
            if (error instanceof (0, $hBkCm.BadStatusError)) {
                // Don't retry mutations, regardless of all other concerns
                if (operation.query.definitions.some((definition)=>'operation' in definition && definition.operation === 'mutation')) return false;
            // When we've decided policy on which 5xx errors merit a retry, implement here.
            //
            // If you wanted, for instance, to retry based on your machine's WiFi being
            // down (where the dev proxy will be responding with 504 codes), uncomment this:
            /*
            if (error.response.status === 504) {
              console.log("Do not commit");
              sendTrackEvent(error, operation);
              operation.setContext(context => ({
                statusRetries: (context.statusRetries || 0) + 1
              }));
              return true;
            }
            */ }
            // All other errors, leave it to a higher link in the chain to retry if it wants to
            return false;
        }
    }
});
function $1fda01e907a51fcb$export$4496b6bcbac21996() {
    $1fda01e907a51fcb$var$retryEnabled = true;
}
module.exports["statusCodeRetryLink"] = $1fda01e907a51fcb$export$e30c063a9dc76f6b;
module.exports["enableStatusCodeRetryLink"] = $1fda01e907a51fcb$export$4496b6bcbac21996;

});

parcelRegister("5MeCb", function(module, exports) {
/* eslint-disable check-set-storage-usage/no-unimported-storage-set */ 
var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $5ZqQS = parcelRequire("5ZqQS");


var $cRYpA = parcelRequire("cRYpA");


var $1UApO = parcelRequire("1UApO");


var $573Av = parcelRequire("573Av");

const $46257fa69570a280$var$logger = (0, $7W8i8.getLogger)('storage-manager');
const $46257fa69570a280$var$localStorageMigrationEntriesKey = 'localstorage-migration-entries';
function $46257fa69570a280$export$4fc2001188ec893d(error) {
    if (error && 'code' in error) switch(error.code){
        case 22:
            return true;
        case 1014:
            // Firefox
            if (error.name === 'NS_ERROR_DOM_QUOTA_REACHED') return true;
            break;
        default:
            return false;
    }
    return false;
}
function $46257fa69570a280$export$b4ff986ecbd5f7f2(value) {
    if (!value) return value;
    try {
        return JSON.parse(value);
    } catch (_) {
        return value;
    }
}
class $46257fa69570a280$export$93525d6e221593cb {
    /**
   * PRIVATE Does not trigger Init
   * creates a prefix for a value
   */ _getPrefix(seconds) {
        const milliseconds = (seconds || 0) * 1000;
        if (!milliseconds) return '';
        return Date.now() + milliseconds + this._delimiter;
    }
    constructor(storageManager, prefix, id, storagePrefix, { userId: userId, isLicensed: isLicensed }){
        this._storageManager = void 0;
        this._delimiter = '#';
        this._namespace = void 0;
        this._userId = void 0;
        this._isLicensedUser = void 0;
        this._hasQuotaErrorBeenSubmitted = false;
        this._persistSetValue = (originalKey, value, persistKey)=>{
            // there is a cyclic dependency with @confluence/graphql
            // communicate local/session storage update to cc-bandana
            if (Object.values((0, $1UApO.PERSISTED_KEYS_ON_SERVER)).indexOf(originalKey) > -1 && !sessionStorage.getItem('confluence.disable-persisted-storage-for-tests') && window['GLOBAL_APOLLO_CLIENT'] && this._userId && this._isLicensedUser) {
                const mutationVariables = {
                    storageinput: {
                        stringValues: [
                            {
                                key: persistKey,
                                value: value
                            }
                        ]
                    },
                    stringKeys: [
                        persistKey
                    ]
                };
                window['GLOBAL_APOLLO_CLIENT'].mutate({
                    mutation: (0, $cRYpA.UpdateLocalStorageMutation),
                    variables: mutationVariables
                }).catch((e)=>{
                    this._submitError(e, `Error updating user preferences with key ${originalKey} and value ${value}: ${e}`);
                });
            }
        };
        /**
     * Gets the item stored in local storage for the given key. null is returned if it doesn't exist.
     * Note that this method will always return a string representation of what is stored.
     */ this.getItem = (key)=>{
            if (!this._storageManager) {
                $46257fa69570a280$var$logger.warn`Local/session storage not supported on browser`;
                return null;
            }
            try {
                const cacheKey = (0, $573Av.getStorageKey)(key, `${this._namespace}.${key}`);
                let item;
                if ((0, $9wGTI.fg)('confluence_browser_storage_controls')) item = this._storageManager.getItem(key);
                else {
                    item = this._storageManager.getItem(cacheKey);
                    /**
           * Currently some keys from independent usages of native local/session storage
          	 were adding keys without namespace. This helps cleanup those keys and return the
          	values for those keys if they exist
          * Once we stop seeing increments in counter in metrics for localStorageMigrationEntriesKey
          		we can remove this logic*/ if (!item) {
                        item = this._storageManager.getItem(key);
                        if (item) {
                            this._incrementLocalStorageMigrationEntries();
                            this.setItem(key, item);
                            this._storageManager.removeItem(`${key}`);
                        }
                    }
                }
                if (item) {
                    item = $46257fa69570a280$export$b4ff986ecbd5f7f2(item);
                    let match;
                    const prefixMatch = /(\d+)#/;
                    if (typeof item === 'string' && (match = prefixMatch.exec(item))) {
                        const itemWithStrippedExpirationPrefix = item.replace(match[0], '');
                        const expirationTimestamp = parseInt(match[1], 10);
                        const isExpired = !isNaN(expirationTimestamp) && Date.now() > expirationTimestamp;
                        if (isExpired) {
                            this.removeItem(key);
                            return null;
                        }
                        return itemWithStrippedExpirationPrefix;
                    }
                    return item;
                }
                return null;
            } catch (e) {
                this._submitError(e, `Error getting value from storage manager for key:${key} : ${e}`);
                return null;
            }
        };
        this.getAndRemoveItem = (key)=>{
            if (!this._storageManager) {
                $46257fa69570a280$var$logger.warn`Local/session storage not supported on browser`;
                return null;
            }
            try {
                const item = this.getItem(key);
                if (item) {
                    this.removeItem(key);
                    return item;
                }
                return null;
            } catch (e) {
                this._submitError(e, `Error getting and removing value from storage manager for key:${key} : ${e}`);
                return null;
            }
        };
        /**
     * Get all the items in local storage that are bound to the given context.
     */ this.getAllItems = ()=>{
            const items = {};
            if (!this._storageManager) {
                $46257fa69570a280$var$logger.warn`Local/session storage not supported on browser`;
                return items;
            }
            const length = this._storageManager.length;
            // Currently getAllItems is unsupported if _storageManager is AtlBrowserStorage,
            // which retrieves length differently
            if (typeof length !== 'number') return items;
            try {
                for(let i = 0; i < length; i++){
                    const itemKey = this._storageManager.key(i);
                    if (itemKey && itemKey.includes(`${this._namespace}.`)) {
                        const keyWithoutNamespace = itemKey.split(`${this._namespace}.`)[1];
                        const rawItemValue = this._storageManager.getItem(itemKey);
                        items[keyWithoutNamespace] = $46257fa69570a280$export$b4ff986ecbd5f7f2(rawItemValue);
                    }
                }
                return items;
            } catch (e) {
                this._submitError(e, `Error getting all items from storage manager : ${e}`);
                return items;
            }
        };
        /**
     * Returns a boolean to let you know if we contain a key that matches, and has not expired.
     */ this.doesContain = (key)=>{
            if (!this._storageManager) {
                $46257fa69570a280$var$logger.warn`Local/session storage not supported on browser`;
                return false;
            }
            try {
                const value = this.getItem(key);
                return typeof value === 'boolean' ? !value : !!value;
            } catch (e) {
                this._submitError(e, `Error getting value from storage manager for key ${key}: ${e}`);
                return false;
            }
        };
        /**
     * Gets the item stored in local storage for the given key and returns the boolean value of it.
     * It correctly convert the "true" and "false" strings to return true/false booleans.
     */ this.getItemAsBoolean = (key)=>{
            if (!this._storageManager) {
                $46257fa69570a280$var$logger.warn`Local/session storage not supported on browser`;
                return false;
            }
            try {
                const value = this.getItem(key);
                if (value && typeof value === 'string' && value.indexOf('false') >= 0) return false;
                if (value && typeof value === 'string' && value.indexOf('true') >= 0) return true;
                return !!value;
            } catch (e) {
                this._submitError(e, `Error getting value as boolean from storage manager for key ${key}: ${e}`);
                return false;
            }
        };
        /**
     * synchronously sets a value
     * @param expire expiration time in seconds
     * @returns {string}
     */ this.setItem = (key, value, expire)=>{
            if (!this._storageManager) {
                $46257fa69570a280$var$logger.warn`Local/session storage not supported on browser`;
                return null;
            }
            try {
                const cacheKey = (0, $573Av.getStorageKey)(key, `${this._namespace}.${key}`);
                // If it's not an object then append prefix.
                if (typeof value !== 'object') value = `${this._getPrefix(expire)}${value}`;
                value = JSON.stringify(value);
                // Use original key to call AtlBrowserStorage setItem, because only the original key is registered
                if ((0, $9wGTI.fg)('confluence_browser_storage_controls')) {
                    const processSetItem = this._storageManager.setItem(key, value);
                    processSetItem?.then(()=>{
                        // Currently AtlBrowserStorage setItem does not return SUCCESS or BLOCKED,
                        // so we check the successful status by calling getItem
                        // only persist the value if the setItem was successful
                        const isSuccessful = this._storageManager && this._storageManager.getItem(key);
                        if (isSuccessful) this._persistSetValue(key, value, cacheKey);
                    });
                } else {
                    this._storageManager.setItem(cacheKey, value);
                    this._persistSetValue(key, value, cacheKey);
                }
                return JSON.parse(value);
            } catch (e) {
                if ($46257fa69570a280$export$4fc2001188ec893d(e)) {
                    // for "quota exceeded" errors we're re-massaging the error message to exclude `this._namespace`
                    // DOMException properties are read-only, so we can't just modify them inline, see https://developer.mozilla.org/en-US/docs/Web/API/DOMException
                    if (!this._hasQuotaErrorBeenSubmitted) {
                        // we'll only submit "quota exceeded" error to the monitoring systems once per user session -- there isn't really a need to submit all such errors.
                        this._submitError(new Error(`Quota exceeded on key "${key}"`));
                        this._hasQuotaErrorBeenSubmitted = true;
                    }
                    $46257fa69570a280$var$logger.error`Storage quota exceeded when for key ${key} and value ${value}; original error: ${e}`;
                } else this._submitError(e, `Error setting value from storage manager with key ${key} and value ${value}: ${e}`);
                return null;
            }
        };
        /**
     * Removes a Key from the Store
     */ this.removeItem = (key)=>{
            if (!this._storageManager) {
                $46257fa69570a280$var$logger.warn`Local/session storage not supported on browser`;
                return;
            }
            try {
                const cacheKey = (0, $573Av.getStorageKey)(key, `${this._namespace}.${key}`);
                if ((0, $9wGTI.fg)('confluence_browser_storage_controls')) this._storageManager.removeItem(`${key}`);
                else this._storageManager.removeItem(`${cacheKey}`);
                return;
            } catch (e) {
                this._submitError(e, `Error removing value from storage manager for key ${key}: ${e}`);
                return;
            }
        };
        this.initializeFromServer = (results)=>{
            if (!Array.isArray(results)) return;
            if (sessionStorage.getItem('confluence.disable-persisted-storage-for-tests')) return;
            try {
                if ((0, $9wGTI.fg)('confluence_browser_storage_controls')) results.forEach((val)=>{
                    const originalKey = val?.key?.replace(`${this._namespace}.`, '');
                    if (this._storageManager && originalKey) this._storageManager.setItem(originalKey, val.value);
                });
                else results.forEach((val)=>this._storageManager && this._storageManager.setItem(val.key, val.value));
            } catch (e) {
                if ($46257fa69570a280$export$4fc2001188ec893d(e)) this._submitError(new Error('Quota exceeded on intializing persisted values from server'));
                else this._submitError(e, `Error setting value from storage manager while initializing persisted values from server: ${e}`);
            }
        };
        this._submitError = (e, message)=>{
            if (message) $46257fa69570a280$var$logger.error`${message}`;
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: 'unknown'
            });
        };
        this._incrementLocalStorageMigrationEntries = ()=>{
            (0, $5ZqQS.getMonitoringClient)().incrementCounter($46257fa69570a280$var$localStorageMigrationEntriesKey);
        };
        this._storageManager = storageManager;
        this._namespace = userId ? `${storagePrefix}/${prefix}.${userId}.${id}` : `${storagePrefix}/null`;
        this._userId = userId;
        this._isLicensedUser = isLicensed ?? false;
    }
}
module.exports["isQuotaExceededError"] = $46257fa69570a280$export$4fc2001188ec893d;
module.exports["StorageManager"] = $46257fa69570a280$export$93525d6e221593cb;

});

parcelRegister("dnmqd", function(module, exports) {
"use strict";
var $9bced0d84d3065db$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4XvZj = parcelRequire("4XvZj");


var $gwDx5 = parcelRequire("gwDx5");


var $8SuEO = parcelRequire("8SuEO");


var $coFhs = parcelRequire("coFhs");


var $2HQ4d = parcelRequire("2HQ4d");

class $9bced0d84d3065db$var$StatsigClient extends $4XvZj.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $4XvZj._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $9bced0d84d3065db$var$StatsigClient) return instance;
        $4XvZj.Log.warn((0, $4XvZj._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $9bced0d84d3065db$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $4XvZj.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $9bced0d84d3065db$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $4XvZj.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $4XvZj.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $9bced0d84d3065db$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $9bced0d84d3065db$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $4XvZj.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $4XvZj.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $4XvZj.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $4XvZj.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($4XvZj.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $4XvZj.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $4XvZj.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $4XvZj.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $4XvZj.StatsigSession.get(this._sdkKey),
            stableID: $4XvZj.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $9bced0d84d3065db$var$__awaiter(this, void 0, void 0, function*() {
            if (!$4XvZj.Storage.isReady()) yield $4XvZj.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $4XvZj.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $4XvZj.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $4XvZj._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $4XvZj.StableID.setOverride(stableIdOverride, this._sdkKey);
        user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $4XvZj._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $4XvZj._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $4XvZj._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $4XvZj._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $4XvZj._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $4XvZj._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $4XvZj._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $4XvZj._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $4XvZj._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $4XvZj._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $coFhs._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $coFhs._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $4XvZj.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $8SuEO.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $2HQ4d.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($4XvZj.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($4XvZj.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($4XvZj.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($4XvZj.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($4XvZj.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($4XvZj.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $gwDx5.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $4XvZj.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
}
module.exports.default = $9bced0d84d3065db$var$StatsigClient;

});

parcelRegister("g9T2X", function(module, exports) {
"use strict";
var $bc382fc028344874$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $bc382fc028344874$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $bc382fc028344874$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $bc382fc028344874$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $bc382fc028344874$var$MAX_START_LOOKUP = 200;
function $bc382fc028344874$var$_fetchTxtRecords(networkFunc) {
    return $bc382fc028344874$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($bc382fc028344874$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $bc382fc028344874$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $bc382fc028344874$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $bc382fc028344874$var$_fetchTxtRecords;
function $bc382fc028344874$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $bc382fc028344874$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $bc382fc028344874$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});

parcelRegister("8SG8i", function(module, exports) {
"use strict";
var $67740c90bea29b3b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $67740c90bea29b3b$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $67740c90bea29b3b$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $67740c90bea29b3b$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $67740c90bea29b3b$var$MAX_START_LOOKUP = 200;
function $67740c90bea29b3b$var$_fetchTxtRecords(networkFunc) {
    return $67740c90bea29b3b$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($67740c90bea29b3b$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $67740c90bea29b3b$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $67740c90bea29b3b$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $67740c90bea29b3b$var$_fetchTxtRecords;
function $67740c90bea29b3b$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $67740c90bea29b3b$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $67740c90bea29b3b$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});

parcelRegister("kXkoT", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $f419247328554d2e$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $f419247328554d2e$var$toStr = Object.prototype.toString;
var $f419247328554d2e$var$max = Math.max;
var $f419247328554d2e$var$funcType = '[object Function]';
var $f419247328554d2e$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $f419247328554d2e$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $f419247328554d2e$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $f419247328554d2e$var$toStr.apply(target) !== $f419247328554d2e$var$funcType) throw new TypeError($f419247328554d2e$var$ERROR_MESSAGE + target);
    var args = $f419247328554d2e$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $f419247328554d2e$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $f419247328554d2e$var$concatty(args, arguments));
    };
    var boundLength = $f419247328554d2e$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $f419247328554d2e$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});

parcelRegister("byR6T", function(module, exports) {
class $5627e8b09073d0e5$export$90e3e001bcac59c7 {
    constructor(){
        this.data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this.data[key] = value;
            this.length = Object.keys(this.data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this.data) return this.data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this.data) delete this.data[key];
            this.length = Object.keys(this.data).length;
            return null;
        };
        this.clear = ()=>{
            this.data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this.data)[index];
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $5627e8b09073d0e5$var$inmemorystorage = new $5627e8b09073d0e5$export$90e3e001bcac59c7();
var $5627e8b09073d0e5$export$2e2bcd8739ae039 = $5627e8b09073d0e5$var$inmemorystorage;
module.exports["default"] = $5627e8b09073d0e5$export$2e2bcd8739ae039;

});

parcelRegister("iyPdu", function(module, exports) {
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $byR6T = parcelRequire("byR6T");

const $f20ffb7ead9569c1$export$41c06fdd37b7e9a5 = 'awc';
const $f20ffb7ead9569c1$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
var $f20ffb7ead9569c1$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});
function $f20ffb7ead9569c1$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $f20ffb7ead9569c1$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $f20ffb7ead9569c1$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.prefix = void 0;
        this.store = void 0;
        this.options = void 0;
        this.getStore = ()=>this.store;
        this.getItem = (key)=>this.store.getItem(this.createKey(key));
        this.removeItem = (key)=>this.store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this.store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($f20ffb7ead9569c1$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this.store.setItem(this.createKey(key), value);
                }
            }
        };
        this.swapToInMemory = ()=>{
            if (this.store === (0, $byR6T.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this.store || {});
            let inMemoryStorage;
            if ($f20ffb7ead9569c1$export$48c17662a6902497(window[$f20ffb7ead9569c1$export$770aa8bc07b3de03])) inMemoryStorage = window[$f20ffb7ead9569c1$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $byR6T.default);
                if (!window[$f20ffb7ead9569c1$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$f20ffb7ead9569c1$export$770aa8bc07b3de03] = (0, $byR6T.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this.store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this.store = inMemoryStorage;
        };
        this.clear = ()=>this.store.clear();
        this.key = (index)=>this.store.key(index);
        this.getPrefix = ()=>this.prefix;
        this.createKey = (key)=>{
            if (this.prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($f20ffb7ead9569c1$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== "prod") prefixes.push(options.envPrefix);
        this.prefix = prefixes.join('-');
        if ($f20ffb7ead9569c1$export$48c17662a6902497(storageToUse)) this.store = storageToUse;
        else this.swapToInMemory();
    }
}
module.exports["default"] = $f20ffb7ead9569c1$export$2e2bcd8739ae039;

});

parcelRegister("4Q9Y3", function(module, exports) {

var $lRdu3 = parcelRequire("lRdu3");


var $2JXSR = parcelRequire("2JXSR");


var $iiQrz = parcelRequire("iiQrz");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $3863c01c9bccfad6$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $lRdu3,
        'map': new ($iiQrz || $2JXSR),
        'string': new $lRdu3
    };
}
module.exports = $3863c01c9bccfad6$var$mapCacheClear;

});

parcelRegister("7klPX", function(module, exports) {

var $9w7HK = parcelRequire("9w7HK");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $555b570fd6f51c1c$var$mapCacheDelete(key) {
    var result = $9w7HK(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $555b570fd6f51c1c$var$mapCacheDelete;

});

parcelRegister("2v38A", function(module, exports) {

var $9w7HK = parcelRequire("9w7HK");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1d20e90e2c6dbb07$var$mapCacheGet(key) {
    return $9w7HK(this, key).get(key);
}
module.exports = $1d20e90e2c6dbb07$var$mapCacheGet;

});

parcelRegister("1h87E", function(module, exports) {

var $9w7HK = parcelRequire("9w7HK");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0eddadec9272312b$var$mapCacheHas(key) {
    return $9w7HK(this, key).has(key);
}
module.exports = $0eddadec9272312b$var$mapCacheHas;

});

parcelRegister("9pbIA", function(module, exports) {

var $9w7HK = parcelRequire("9w7HK");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $6d8f89d8a88f7443$var$mapCacheSet(key, value) {
    var data = $9w7HK(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $6d8f89d8a88f7443$var$mapCacheSet;

});

parcelRegister("6Uwva", function(module, exports) {

var $bsrY7 = parcelRequire("bsrY7");


var $1f2d6 = parcelRequire("1f2d6");


var $lc9ud = parcelRequire("lc9ud");


var $gnC5r = parcelRequire("gnC5r");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $50812f2db807ab96$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $50812f2db807ab96$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $50812f2db807ab96$var$funcProto = Function.prototype, $50812f2db807ab96$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $50812f2db807ab96$var$funcToString = $50812f2db807ab96$var$funcProto.toString;
/** Used to check objects for own properties. */ var $50812f2db807ab96$var$hasOwnProperty = $50812f2db807ab96$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $50812f2db807ab96$var$reIsNative = RegExp('^' + $50812f2db807ab96$var$funcToString.call($50812f2db807ab96$var$hasOwnProperty).replace($50812f2db807ab96$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $50812f2db807ab96$var$baseIsNative(value) {
    if (!$lc9ud(value) || $1f2d6(value)) return false;
    var pattern = $bsrY7(value) ? $50812f2db807ab96$var$reIsNative : $50812f2db807ab96$var$reIsHostCtor;
    return pattern.test($gnC5r(value));
}
module.exports = $50812f2db807ab96$var$baseIsNative;

});

parcelRegister("7DiKo", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $58eab7bf7a3b222e$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $58eab7bf7a3b222e$var$getValue;

});

parcelRegister("fPYum", function(module, exports) {
const $c1e570c94f11101f$export$94c92810ef76851 = 'atlassian';
const $c1e570c94f11101f$export$cae0fbb99c422e2 = 'frontend';
const $c1e570c94f11101f$export$1b311d1dfe8a9349 = 'localStorage';
const $c1e570c94f11101f$export$16f5e866917d6fd1 = 'sessionStorage';
module.exports["STORAGE_MANAGER_PREFIX"] = $c1e570c94f11101f$export$94c92810ef76851;
module.exports["STORAGE_MANAGER_ID"] = $c1e570c94f11101f$export$cae0fbb99c422e2;
module.exports["LOCAL_STORAGE_MANAGER"] = $c1e570c94f11101f$export$1b311d1dfe8a9349;
module.exports["SESSION_STORAGE_MANAGER"] = $c1e570c94f11101f$export$16f5e866917d6fd1;

});

parcelRegister("3NFzB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $2c463249f8514993$var$isString(value) {
    return typeof value === 'string';
}
module.exports.default = $2c463249f8514993$var$isString;

});

parcelRegister("6rnVN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $4b07d3ea0fa90230$var$isObject(value) {
    return value !== null && typeof value === 'object';
}
module.exports.default = $4b07d3ea0fa90230$var$isObject;

});

parcelRegister("kU3jZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GRAPHQL_SUBSCRIPTIONS = module.exports.GRAPHQL_WS = void 0;
var $f37b9d292e9148ef$var$GRAPHQL_WS = 'graphql-ws';
module.exports.GRAPHQL_WS = $f37b9d292e9148ef$var$GRAPHQL_WS;
var $f37b9d292e9148ef$var$GRAPHQL_SUBSCRIPTIONS = 'graphql-subscriptions';
module.exports.GRAPHQL_SUBSCRIPTIONS = $f37b9d292e9148ef$var$GRAPHQL_SUBSCRIPTIONS;

});

parcelRegister("fRFuT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WS_TIMEOUT = module.exports.MIN_WS_TIMEOUT = void 0;
var $b8cbfebbd8ce9c65$var$MIN_WS_TIMEOUT = 1000;
module.exports.MIN_WS_TIMEOUT = $b8cbfebbd8ce9c65$var$MIN_WS_TIMEOUT;
var $b8cbfebbd8ce9c65$var$WS_TIMEOUT = 30000;
module.exports.WS_TIMEOUT = $b8cbfebbd8ce9c65$var$WS_TIMEOUT;

});

parcelRegister("fDXwS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b638acd41673513b$var$MessageTypes = function() {
    function MessageTypes() {
        throw new Error('Static Class');
    }
    MessageTypes.GQL_CONNECTION_INIT = 'connection_init';
    MessageTypes.GQL_CONNECTION_ACK = 'connection_ack';
    MessageTypes.GQL_CONNECTION_ERROR = 'connection_error';
    MessageTypes.GQL_CONNECTION_KEEP_ALIVE = 'ka';
    MessageTypes.GQL_CONNECTION_TERMINATE = 'connection_terminate';
    MessageTypes.GQL_START = 'start';
    MessageTypes.GQL_DATA = 'data';
    MessageTypes.GQL_ERROR = 'error';
    MessageTypes.GQL_COMPLETE = 'complete';
    MessageTypes.GQL_STOP = 'stop';
    MessageTypes.SUBSCRIPTION_START = 'subscription_start';
    MessageTypes.SUBSCRIPTION_DATA = 'subscription_data';
    MessageTypes.SUBSCRIPTION_SUCCESS = 'subscription_success';
    MessageTypes.SUBSCRIPTION_FAIL = 'subscription_fail';
    MessageTypes.SUBSCRIPTION_END = 'subscription_end';
    MessageTypes.INIT = 'init';
    MessageTypes.INIT_SUCCESS = 'init_success';
    MessageTypes.INIT_FAIL = 'init_fail';
    MessageTypes.KEEP_ALIVE = 'keepalive';
    return MessageTypes;
}();
module.exports.default = $b638acd41673513b$var$MessageTypes;

});

parcelRegister("8oAcs", function(module, exports) {

var $kfwMJ = parcelRequire("kfwMJ");


var $6ZgEd = parcelRequire("6ZgEd");

class $cb97cb9e1f37d0e0$export$fde2a4e0e57f47e {
    async boot() {
        if (!this.isAvailable) {
            (0, $6ZgEd.Logger).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, $6ZgEd.Logger).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, $kfwMJ.isSSR)() && !!window.indexedDB;
    }
    async openDB() {
        return new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 2);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
    }
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) throw new Error('Database is not opened');
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, $6ZgEd.Logger).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) throw new Error('Database is not opened');
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                const newAtlRecord = {
                    atlSetItem: 'SET-BY-PACKAGE',
                    id: recordKey
                };
                let request = objectStore.put(newAtlRecord);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, $6ZgEd.Logger).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
    constructor(dbName, storeName){
        this.dbName = void 0;
        this.storeName = void 0;
        this.bootUpPromiseCache = void 0;
        this.db = null;
        this.isBooted = false;
        this.isAvailable = false;
        this.onConnectionErrorHandler = (reject)=>(event)=>{
                (0, $6ZgEd.Logger).warn('Error opening database.');
                reject(event);
            };
        this.onConnectionSuccessHandler = (connection, resolve)=>()=>{
                this.db = connection.result;
                resolve();
            };
        this.onConnectionUpgradeNeededHandler = (request)=>()=>{
                this.db = request.result;
                this.db.createObjectStore(this.storeName, {
                    keyPath: 'id'
                });
            };
        this.onGetRecordErrorHandler = (reject)=>()=>{
                const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $6ZgEd.Logger).warn(getErrorMessage);
                reject(getErrorMessage);
            };
        this.onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
                resolve(getRequest.result);
            };
        this.onSetRecordErrorHandler = (reject)=>()=>{
                const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $6ZgEd.Logger).warn(errorMessage);
                reject(errorMessage);
            };
        this.onSetRecordSuccessHandler = (resolve)=>()=>{
                resolve();
            };
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
}
const $cb97cb9e1f37d0e0$export$36328b3bcbe4623a = new $cb97cb9e1f37d0e0$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');
module.exports["BSCIndexedDB"] = $cb97cb9e1f37d0e0$export$36328b3bcbe4623a;

});

parcelRegister("hqQq0", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $lB1H3 = parcelRequire("lB1H3");


var $7RTAm = parcelRequire("7RTAm");

var $cb0d869c7b74fab1$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $cb0d869c7b74fab1$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $cb0d869c7b74fab1$var$defaultOptions = {
    method: 'POST'
};
var $cb0d869c7b74fab1$export$dd86f00dc866e75d = {
    http: $cb0d869c7b74fab1$var$defaultHttpOptions,
    headers: $cb0d869c7b74fab1$var$defaultHeaders,
    options: $cb0d869c7b74fab1$var$defaultOptions
};
var $cb0d869c7b74fab1$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $cb0d869c7b74fab1$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $cb0d869c7b74fab1$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $cb0d869c7b74fab1$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $cb0d869c7b74fab1$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $7RTAm.InvariantError)(1);
    }
};
var $cb0d869c7b74fab1$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $cb0d869c7b74fab1$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $hXuPC.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $hXuPC.__assign)({}, options, config.options, {
            headers: (0, $hXuPC.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $hXuPC.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $lB1H3.print)(query);
    return {
        options: options,
        body: body
    };
};
var $cb0d869c7b74fab1$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $7RTAm.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $cb0d869c7b74fab1$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};
module.exports["fallbackHttpConfig"] = $cb0d869c7b74fab1$export$dd86f00dc866e75d;
module.exports["parseAndCheckHttpResponse"] = $cb0d869c7b74fab1$export$d4051215bea0639f;
module.exports["checkFetcher"] = $cb0d869c7b74fab1$export$8423f0cd3773115e;
module.exports["createSignalIfSupported"] = $cb0d869c7b74fab1$export$f5853cd1fc39aea6;
module.exports["selectHttpOptionsAndBody"] = $cb0d869c7b74fab1$export$a00ebfd5f1eebfb1;
module.exports["serializeFetchParameter"] = $cb0d869c7b74fab1$export$5f8e80ac52052e28;
module.exports["selectURI"] = $cb0d869c7b74fab1$export$63ccc2571850f81a;

});

parcelRegister("c9tKb", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $5v4fk = parcelRequire("5v4fk");
var $jLTuK = parcelRequire("jLTuK");

function $8d8d65d13ca16c26$export$2288787135a8f66e(errorHandler) {
    return new (0, $5v4fk.ApolloLink)(function(operation, forward) {
        return new (0, $jLTuK.default)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $8d8d65d13ca16c26$export$d2c8415987899609 = function(_super) {
    (0, $hXuPC.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $8d8d65d13ca16c26$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $5v4fk.ApolloLink));
module.exports["onError"] = $8d8d65d13ca16c26$export$2288787135a8f66e;

});

parcelRegister("f5DmR", function(module, exports) {
/**
 * Bucket Queue
 *
 * A priority queue supporting N number of buckets
 * that represent the order in which items will be
 * dequeued. The lower the bucket-index, the higher
 * priority its items
 */ class $5b5fdfb1337bae5e$export$6cea0ddf8367090d {
    /**
   * Add
   *
   * Adds an item to the queue into the bucket specified. The
   * lower the number, the sooner your item will be dequeued
   */ add(t, bucket) {
        if (bucket >= this.buckets.length || bucket < 0) throw new Error('Range error: The bucket specified does not exist');
        this.buckets[bucket].push(t);
        this.size++;
    }
    /**
   * Peek
   *
   * Returns the highest priority item in the queue
   */ peek() {
        for (const bucket of this.buckets){
            if (bucket.length) return bucket[0];
        }
        return null;
    }
    /**
   * Poll
   *
   * Returns the highest priority item in the queue by
   * dequeuing it
   */ poll() {
        for (const bucket of this.buckets)if (bucket.length) {
            this.size--;
            return bucket.shift();
        }
        return null;
    }
    constructor(max){
        this.buckets = void 0;
        this.size = void 0;
        this.size = 0;
        this.buckets = Array(max + 1).fill(null).map(()=>[]);
    }
}
module.exports["BucketQueue"] = $5b5fdfb1337bae5e$export$6cea0ddf8367090d;

});

parcelRegister("jrqSm", function(module, exports) {
const $6b5ba91e016c9f96$export$f95417658c1a3941 = (_id, task, timeout)=>{
    let resolve;
    let reject;
    let started = false;
    let timer;
    const run = ()=>{
        if (started) return;
        if (timer && typeof clearTimeout !== 'undefined') clearTimeout(timer);
        started = true;
        try {
            const result = task();
            if (result instanceof Promise) result.then(resolve, reject);
            else resolve(result);
        } catch (e) {
            // result can be a Promise or a value
            // The try catch cannot catch async errors
            // It is used to catch sync throws
            reject(e);
        }
    };
    if (timeout && typeof setTimeout !== 'undefined') timer = setTimeout(run, timeout);
    return {
        get started () {
            return started;
        },
        result: new Promise((_resolve, _reject)=>{
            resolve = _resolve;
            reject = _reject;
        }),
        run: run
    };
};
module.exports["createFutureTask"] = $6b5ba91e016c9f96$export$f95417658c1a3941;

});

parcelRegister("1oTFG", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("jvvYq")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("jvvYq")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("jvvYq")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("jvvYq")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("jvvYq")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("jvvYq")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("jvvYq")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("jvvYq")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("jvvYq")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("jvvYq")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("jvvYq")).isTimeElement);
$parcel$export(module.exports, "parse", () => $1053377a189b24ff$export$98e6a39c04603d36);

var $hXuPC = parcelRequire("hXuPC");


var $feUp7 = parcelRequire("feUp7");


var $5z7oK = parcelRequire("5z7oK");


var $jvvYq = parcelRequire("jvvYq");

function $1053377a189b24ff$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $jvvYq.isSelectElement)(el) || (0, $jvvYq.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $1053377a189b24ff$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $jvvYq.isNumberElement)(el) && (0, $jvvYq.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $jvvYq.isDateElement)(el) || (0, $jvvYq.isTimeElement)(el)) && (0, $jvvYq.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $jvvYq.isTagElement)(el)) $1053377a189b24ff$var$pruneLocation(el.children);
    });
}
function $1053377a189b24ff$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $hXuPC.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $5z7oK.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $feUp7.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $1053377a189b24ff$var$pruneLocation(result.val);
    return result.val;
}

});

parcelRegister("8lH4q", function(module, exports) {
$parcel$export(module.exports, "default", () => $6141b1c42c9df1db$export$2e2bcd8739ae039);
//
// Main
//
function $6141b1c42c9df1db$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $6141b1c42c9df1db$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $6141b1c42c9df1db$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $6141b1c42c9df1db$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $6141b1c42c9df1db$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $6141b1c42c9df1db$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $6141b1c42c9df1db$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $6141b1c42c9df1db$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $6141b1c42c9df1db$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $6141b1c42c9df1db$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $6141b1c42c9df1db$var$monadic : $6141b1c42c9df1db$var$variadic;
    return $6141b1c42c9df1db$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $6141b1c42c9df1db$var$strategyVariadic(fn, options) {
    return $6141b1c42c9df1db$var$assemble(fn, this, $6141b1c42c9df1db$var$variadic, options.cache.create(), options.serializer);
}
function $6141b1c42c9df1db$var$strategyMonadic(fn, options) {
    return $6141b1c42c9df1db$var$assemble(fn, this, $6141b1c42c9df1db$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $6141b1c42c9df1db$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $6141b1c42c9df1db$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$6141b1c42c9df1db$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$6141b1c42c9df1db$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $6141b1c42c9df1db$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $6141b1c42c9df1db$var$ObjectWithoutPrototypeCache();
    }
};
var $6141b1c42c9df1db$export$c5491a8691a23b9e = {
    variadic: $6141b1c42c9df1db$var$strategyVariadic,
    monadic: $6141b1c42c9df1db$var$strategyMonadic
};
module.exports["strategies"] = $6141b1c42c9df1db$export$c5491a8691a23b9e;

});

parcelRegister("acUKe", function(module, exports) {
'use strict';

var $eI8vp = parcelRequire("eI8vp");

var $76e70ab43d28d875$require$Buffer = $eI8vp.Buffer;

var $howAI = parcelRequire("howAI");


var $9zwU2 = parcelRequire("9zwU2");

var $76e70ab43d28d875$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $9zwU2(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $76e70ab43d28d875$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $76e70ab43d28d875$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $76e70ab43d28d875$var$useFromArrayBuffer = $76e70ab43d28d875$var$useArrayBuffer && ($76e70ab43d28d875$require$Buffer.prototype instanceof Uint8Array || $76e70ab43d28d875$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    /*
	 * No need to do anything for exact instance
	 * This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
	 */ if (data instanceof $76e70ab43d28d875$require$Buffer) return data;
    if (typeof data === 'string') return $76e70ab43d28d875$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($76e70ab43d28d875$var$useArrayBuffer && $76e70ab43d28d875$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $76e70ab43d28d875$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($76e70ab43d28d875$var$useFromArrayBuffer) {
            var res = $76e70ab43d28d875$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $76e70ab43d28d875$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($76e70ab43d28d875$var$useUint8Array && data instanceof Uint8Array) return $76e70ab43d28d875$require$Buffer.from(data);
    var isArr = $howAI(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $76e70ab43d28d875$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $76e70ab43d28d875$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});

parcelRegister("kGRY2", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("1TfOD", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});

parcelRegister("jX77m", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});

parcelRegister("5jY1L", function(module, exports) {
$parcel$export(module.exports, "certificate", () => $3dfd4a4bead0b9d3$export$c98397a6eb8d0678, (v) => $3dfd4a4bead0b9d3$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $3dfd4a4bead0b9d3$export$f4aab6816f64fa6b, (v) => $3dfd4a4bead0b9d3$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $3dfd4a4bead0b9d3$export$4471f5c65d097c11, (v) => $3dfd4a4bead0b9d3$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $3dfd4a4bead0b9d3$export$ca8b6604d6ce14de, (v) => $3dfd4a4bead0b9d3$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $3dfd4a4bead0b9d3$export$8f54525b330fd87b, (v) => $3dfd4a4bead0b9d3$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $3dfd4a4bead0b9d3$export$23cd2842b44ca3e7, (v) => $3dfd4a4bead0b9d3$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $3dfd4a4bead0b9d3$export$245c9aaa9f5ce4ce, (v) => $3dfd4a4bead0b9d3$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $3dfd4a4bead0b9d3$export$8ad762e3e6399afe, (v) => $3dfd4a4bead0b9d3$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $3dfd4a4bead0b9d3$export$32ef6f92e22c6ab0, (v) => $3dfd4a4bead0b9d3$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $3dfd4a4bead0b9d3$export$c9cd164b539ebb63, (v) => $3dfd4a4bead0b9d3$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $3dfd4a4bead0b9d3$export$c98397a6eb8d0678;
var $3dfd4a4bead0b9d3$export$f4aab6816f64fa6b;
var $3dfd4a4bead0b9d3$export$4471f5c65d097c11;
var $3dfd4a4bead0b9d3$export$ca8b6604d6ce14de;
var $3dfd4a4bead0b9d3$export$8f54525b330fd87b;
var $3dfd4a4bead0b9d3$export$23cd2842b44ca3e7;
var $3dfd4a4bead0b9d3$export$245c9aaa9f5ce4ce;
var $3dfd4a4bead0b9d3$export$8ad762e3e6399afe;
var $3dfd4a4bead0b9d3$export$32ef6f92e22c6ab0;
var $3dfd4a4bead0b9d3$export$c9cd164b539ebb63;
'use strict';

var $k3MQ7 = parcelRequire("k3MQ7");


$3dfd4a4bead0b9d3$export$c98397a6eb8d0678 = (parcelRequire("5St6j"));
var $3dfd4a4bead0b9d3$var$RSAPrivateKey = $k3MQ7.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$3dfd4a4bead0b9d3$export$f4aab6816f64fa6b = $3dfd4a4bead0b9d3$var$RSAPrivateKey;
var $3dfd4a4bead0b9d3$var$RSAPublicKey = $k3MQ7.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$3dfd4a4bead0b9d3$export$4471f5c65d097c11 = $3dfd4a4bead0b9d3$var$RSAPublicKey;
var $3dfd4a4bead0b9d3$var$AlgorithmIdentifier = $k3MQ7.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $3dfd4a4bead0b9d3$var$PublicKey = $k3MQ7.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($3dfd4a4bead0b9d3$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$3dfd4a4bead0b9d3$export$ca8b6604d6ce14de = $3dfd4a4bead0b9d3$var$PublicKey;
var $3dfd4a4bead0b9d3$var$PrivateKeyInfo = $k3MQ7.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($3dfd4a4bead0b9d3$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$3dfd4a4bead0b9d3$export$8f54525b330fd87b = $3dfd4a4bead0b9d3$var$PrivateKeyInfo;
var $3dfd4a4bead0b9d3$var$EncryptedPrivateKeyInfo = $k3MQ7.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$3dfd4a4bead0b9d3$export$23cd2842b44ca3e7 = $3dfd4a4bead0b9d3$var$EncryptedPrivateKeyInfo;
var $3dfd4a4bead0b9d3$var$DSAPrivateKey = $k3MQ7.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$3dfd4a4bead0b9d3$export$245c9aaa9f5ce4ce = $3dfd4a4bead0b9d3$var$DSAPrivateKey;
$3dfd4a4bead0b9d3$export$8ad762e3e6399afe = $k3MQ7.define('DSAparam', function() {
    this['int']();
});
var $3dfd4a4bead0b9d3$var$ECParameters = $k3MQ7.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $3dfd4a4bead0b9d3$var$ECPrivateKey = $k3MQ7.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($3dfd4a4bead0b9d3$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$3dfd4a4bead0b9d3$export$32ef6f92e22c6ab0 = $3dfd4a4bead0b9d3$var$ECPrivateKey;
$3dfd4a4bead0b9d3$export$c9cd164b539ebb63 = $k3MQ7.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});

parcelRegister("4gySg", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("coEl1", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $90670439db961371$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $90670439db961371$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $90670439db961371$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $kexZs = parcelRequire("kexZs");


var $j9ccG = parcelRequire("j9ccG");


var $eI8vp = parcelRequire("eI8vp");

var $90670439db961371$require$Buffer = $eI8vp.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($90670439db961371$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($90670439db961371$var$fullRegex);
        decrypted = $90670439db961371$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $90670439db961371$require$Buffer.from(match[2], 'hex');
        var cipherText = $90670439db961371$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $kexZs(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $j9ccG.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $90670439db961371$require$Buffer.concat(out);
    }
    var tag = key.match($90670439db961371$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});

parcelRegister("j9ccG", function(module, exports) {
$parcel$export(module.exports, "createCipheriv", () => $df0852f8f69618e0$export$2f64596b8cbf08b4, (v) => $df0852f8f69618e0$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $df0852f8f69618e0$export$36b6d6ef312eab39, (v) => $df0852f8f69618e0$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $df0852f8f69618e0$export$58a258485f1e49f6, (v) => $df0852f8f69618e0$export$58a258485f1e49f6 = v);
var $df0852f8f69618e0$export$bdd223f16383713e;
var $df0852f8f69618e0$export$26e5786e8ac8e530;
var $df0852f8f69618e0$export$2f64596b8cbf08b4;
var $df0852f8f69618e0$export$20533d26f07f1ee0;
var $df0852f8f69618e0$export$12ada9414fbc594c;
var $df0852f8f69618e0$export$2ce6d8d0e8b04e1a;
var $df0852f8f69618e0$export$36b6d6ef312eab39;
var $df0852f8f69618e0$export$f5e7e39d57cd9700;
var $df0852f8f69618e0$export$dedd8dc3dc62b370;
var $df0852f8f69618e0$export$58a258485f1e49f6;

var $a8UB9 = parcelRequire("a8UB9");


var $f8jd9 = parcelRequire("f8jd9");


var $fcAZM = parcelRequire("fcAZM");

function $df0852f8f69618e0$var$getCiphers() {
    return Object.keys($fcAZM);
}
$df0852f8f69618e0$export$bdd223f16383713e = $df0852f8f69618e0$export$26e5786e8ac8e530 = $a8UB9.createCipher;
$df0852f8f69618e0$export$2f64596b8cbf08b4 = $df0852f8f69618e0$export$20533d26f07f1ee0 = $a8UB9.createCipheriv;
$df0852f8f69618e0$export$12ada9414fbc594c = $df0852f8f69618e0$export$2ce6d8d0e8b04e1a = $f8jd9.createDecipher;
$df0852f8f69618e0$export$36b6d6ef312eab39 = $df0852f8f69618e0$export$f5e7e39d57cd9700 = $f8jd9.createDecipheriv;
$df0852f8f69618e0$export$dedd8dc3dc62b370 = $df0852f8f69618e0$export$58a258485f1e49f6 = $df0852f8f69618e0$var$getCiphers;

});

parcelRegister("h8Kts", function(module, exports) {
$parcel$export(module.exports, "pbkdf2", () => $c7a73bd5dc43e502$export$448fa22aedc9dbca, (v) => $c7a73bd5dc43e502$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $c7a73bd5dc43e502$export$b80c7ba289c8fa56, (v) => $c7a73bd5dc43e502$export$b80c7ba289c8fa56 = v);
var $c7a73bd5dc43e502$export$448fa22aedc9dbca;
var $c7a73bd5dc43e502$export$b80c7ba289c8fa56;
'use strict';

$c7a73bd5dc43e502$export$448fa22aedc9dbca = (parcelRequire("7rIrX"));

$c7a73bd5dc43e502$export$b80c7ba289c8fa56 = (parcelRequire("kZS47"));

});

parcelRegister("5PD23", function(module, exports) {
$parcel$export(module.exports, "default", () => $43effe20581f4aee$export$2e2bcd8739ae039);

var $kXrr0 = parcelRequire("kXrr0");


var $fEu2C = parcelRequire("fEu2C");


var $abBQX = parcelRequire("abBQX");


var $6hOPx = parcelRequire("6hOPx");

function $43effe20581f4aee$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $kXrr0.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $fEu2C.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $fEu2C.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $kXrr0.isElement)(element) ? (0, $abBQX.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $6hOPx.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});

parcelRegister("dWWac", function(module, exports) {
$parcel$export(module.exports, "default", () => $a27dcf3809b828e4$export$2e2bcd8739ae039);

var $abBQX = parcelRequire("abBQX");

function $a27dcf3809b828e4$export$2e2bcd8739ae039(node) {
    var win = (0, $abBQX.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("abBQX", function(module, exports) {
$parcel$export(module.exports, "default", () => $76a84b4f5da7e32e$export$2e2bcd8739ae039);
function $76a84b4f5da7e32e$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});

parcelRegister("kXrr0", function(module, exports) {

var $abBQX = parcelRequire("abBQX");

function $f41e99447dad2e73$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $abBQX.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f41e99447dad2e73$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $abBQX.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f41e99447dad2e73$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $abBQX.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}
module.exports["isElement"] = $f41e99447dad2e73$export$45a5e7f76e0caa8d;
module.exports["isHTMLElement"] = $f41e99447dad2e73$export$1b3bfaa9684536aa;
module.exports["isShadowRoot"] = $f41e99447dad2e73$export$af51f0f06c0f328a;

});

parcelRegister("2X8fC", function(module, exports) {
$parcel$export(module.exports, "default", () => $22677deb97825cd8$export$2e2bcd8739ae039);
function $22677deb97825cd8$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("bd6jv", function(module, exports) {
$parcel$export(module.exports, "default", () => $8295ce595e4ff111$export$2e2bcd8739ae039);

var $5PD23 = parcelRequire("5PD23");


var $cBZBQ = parcelRequire("cBZBQ");


var $dWWac = parcelRequire("dWWac");

function $8295ce595e4ff111$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $5PD23.default)((0, $cBZBQ.default)(element)).left + (0, $dWWac.default)(element).scrollLeft;
}

});

parcelRegister("cBZBQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $92e8bb0f72532b19$export$2e2bcd8739ae039);

var $kXrr0 = parcelRequire("kXrr0");

function $92e8bb0f72532b19$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $kXrr0.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});

parcelRegister("l3Xsd", function(module, exports) {
$parcel$export(module.exports, "default", () => $f557ff1fc73b8bd5$export$2e2bcd8739ae039);

var $1idVR = parcelRequire("1idVR");

function $f557ff1fc73b8bd5$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $1idVR.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});

parcelRegister("fEu2C", function(module, exports) {
var $b651e501010aedf6$export$8960430cfd85939f = Math.max;
var $b651e501010aedf6$export$96ec731ed4dcb222 = Math.min;
var $b651e501010aedf6$export$2077e0241d6afd3c = Math.round;
module.exports["max"] = $b651e501010aedf6$export$8960430cfd85939f;
module.exports["min"] = $b651e501010aedf6$export$96ec731ed4dcb222;
module.exports["round"] = $b651e501010aedf6$export$2077e0241d6afd3c;

});

parcelRegister("j7Ucr", function(module, exports) {
$parcel$export(module.exports, "default", () => $deca43df0b365ccf$export$2e2bcd8739ae039);

var $5PD23 = parcelRequire("5PD23");

function $deca43df0b365ccf$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $5PD23.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("j6Wo8", function(module, exports) {
$parcel$export(module.exports, "default", () => $de9bde8893397c81$export$2e2bcd8739ae039);

var $9Vrvx = parcelRequire("9Vrvx");


var $62QMc = parcelRequire("62QMc");


var $abBQX = parcelRequire("abBQX");


var $l3Xsd = parcelRequire("l3Xsd");

function $de9bde8893397c81$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $9Vrvx.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $abBQX.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $l3Xsd.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($de9bde8893397c81$export$2e2bcd8739ae039((0, $62QMc.default)(target)));
}

});

parcelRegister("d90wo", function(module, exports) {
$parcel$export(module.exports, "default", () => $991c853104a03705$export$2e2bcd8739ae039);

var $abBQX = parcelRequire("abBQX");


var $2X8fC = parcelRequire("2X8fC");


var $1idVR = parcelRequire("1idVR");


var $kXrr0 = parcelRequire("kXrr0");


var $hHrtd = parcelRequire("hHrtd");


var $62QMc = parcelRequire("62QMc");


var $4gVDY = parcelRequire("4gVDY");

function $991c853104a03705$var$getTrueOffsetParent(element) {
    if (!(0, $kXrr0.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $1idVR.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $991c853104a03705$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $4gVDY.default)());
    var isIE = /Trident/i.test((0, $4gVDY.default)());
    if (isIE && (0, $kXrr0.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $1idVR.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $62QMc.default)(element);
    if ((0, $kXrr0.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $kXrr0.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $2X8fC.default)(currentNode)) < 0){
        var css = (0, $1idVR.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $991c853104a03705$export$2e2bcd8739ae039(element) {
    var window = (0, $abBQX.default)(element);
    var offsetParent = $991c853104a03705$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $hHrtd.default)(offsetParent) && (0, $1idVR.default)(offsetParent).position === 'static')offsetParent = $991c853104a03705$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $2X8fC.default)(offsetParent) === 'html' || (0, $2X8fC.default)(offsetParent) === 'body' && (0, $1idVR.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $991c853104a03705$var$getContainingBlock(element) || window;
}

});

parcelRegister("1ldyQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fa2458a51c3454b$export$2e2bcd8739ae039);

var $lkswr = parcelRequire("lkswr");


var $cBZBQ = parcelRequire("cBZBQ");


var $5PD23 = parcelRequire("5PD23");


var $gjl0U = parcelRequire("gjl0U");


var $itoGF = parcelRequire("itoGF");


var $eX4ca = parcelRequire("eX4ca");


var $kXrr0 = parcelRequire("kXrr0");


var $jD11d = parcelRequire("jD11d");


var $ge7rQ = parcelRequire("ge7rQ");

function $0fa2458a51c3454b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $eX4ca.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $eX4ca.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $eX4ca.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $jD11d.default)(typeof padding !== 'number' ? padding : (0, $ge7rQ.default)(padding, (0, $eX4ca.basePlacements)));
    var altContext = elementContext === (0, $eX4ca.popper) ? (0, $eX4ca.reference) : (0, $eX4ca.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $lkswr.default)((0, $kXrr0.isElement)(element) ? element : element.contextElement || (0, $cBZBQ.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $5PD23.default)(state.elements.reference);
    var popperOffsets = (0, $gjl0U.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $itoGF.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $eX4ca.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $eX4ca.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $eX4ca.right),
                (0, $eX4ca.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $eX4ca.top),
                (0, $eX4ca.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});

parcelRegister("i6029", function(module, exports) {
/**
 * list of the object to be considered as focusable
 */ var $d2c8d034aed355b3$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];
module.exports["tabbables"] = $d2c8d034aed355b3$export$8555f4622e95784;

});

parcelRegister("gDscz", function(module, exports) {
var $c1c62a1e24ba8b89$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};
module.exports["safeProbe"] = $c1c62a1e24ba8b89$export$78d20aae35adef88;

});

parcelRegister("2s4CC", function(module, exports) {
var $1c91c81d097c7564$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};
module.exports["focusOn"] = $1c91c81d097c7564$export$c12b3da842c43a8;

});

parcelRegister("5Yw9H", function(module, exports) {

var $k1o7W = parcelRequire("k1o7W");


var $9OOUs = parcelRequire("9OOUs");


var $9mFgj = parcelRequire("9mFgj");


var $jietZ = parcelRequire("jietZ");


var $gusZk = parcelRequire("gusZk");


var $8AJ6G = parcelRequire("8AJ6G");


var $cdwZR = parcelRequire("cdwZR");


var $bIaib = parcelRequire("bIaib");

var $459b7fc1f83abffd$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $cdwZR.isDefined));
};
var $459b7fc1f83abffd$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $8AJ6G.getActiveElement)((0, $jietZ.asArray)(topNode).length > 0 ? document : (0, $jietZ.getFirst)(topNode).ownerDocument);
    var entries = (0, $9mFgj.getAllAffectedNodes)(topNode).filter((0, $cdwZR.isNotAGuard));
    var commonParent = (0, $bIaib.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $9OOUs.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $cdwZR.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $9OOUs.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $459b7fc1f83abffd$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $k1o7W.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $k1o7W.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $gusZk.pickAutofocus)(anyFocusable, innerTabbable, (0, $bIaib.allParentAutofocusables)(entries, visibilityCache)) || (0, $gusZk.pickAutofocus)(anyFocusable, innerFocusables, (0, $bIaib.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};
module.exports["focusSolver"] = $459b7fc1f83abffd$export$305758c744b57f6f;

});

parcelRegister("lzPoe", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");

const $e445bef6beedf905$var$createNamespaceContext = (namespace, displayName = 'NamespacedContext')=>{
    const Component = (props)=>{
        const newData = {
            [namespace]: props.data
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
            data: newData,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(props.children)
        });
    };
    Component.displayName = displayName;
    return Component;
};
var $e445bef6beedf905$export$2e2bcd8739ae039 = $e445bef6beedf905$var$createNamespaceContext;
module.exports["default"] = $e445bef6beedf905$export$2e2bcd8739ae039;

});

parcelRegister("eSYTn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ad6557c6194764fa$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $ad6557c6194764fa$var$withLockSheet;

var $42omo = parcelRequire("42omo");

var $ad6557c6194764fa$var$_react2 = $ad6557c6194764fa$var$_interopRequireDefault($42omo);

var $iiSau = parcelRequire("iiSau");

function $ad6557c6194764fa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ad6557c6194764fa$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ad6557c6194764fa$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ad6557c6194764fa$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $ad6557c6194764fa$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $ad6557c6194764fa$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $ad6557c6194764fa$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $ad6557c6194764fa$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $iiSau.makeStyleTag)();
                if (!sheet) return;
                (0, $iiSau.injectStyles)(sheet, styles);
                (0, $iiSau.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $iiSau.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $iiSau.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $ad6557c6194764fa$var$_possibleConstructorReturn(_this, _ret);
        }
        $ad6557c6194764fa$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet || !this.sheet.parentNode || typeof this.sheet.parentNode.removeChild !== 'function') return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $ad6557c6194764fa$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($42omo.PureComponent);
}

});

parcelRegister("gLQo9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c359ac616ace47b8$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $c359ac616ace47b8$var$withTouchListeners;

var $42omo = parcelRequire("42omo");

var $c359ac616ace47b8$var$_react2 = $c359ac616ace47b8$var$_interopRequireDefault($42omo);

var $5dBQh = parcelRequire("5dBQh");


var $iiSau = parcelRequire("iiSau");

function $c359ac616ace47b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c359ac616ace47b8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c359ac616ace47b8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c359ac616ace47b8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $c359ac616ace47b8$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $c359ac616ace47b8$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $c359ac616ace47b8$var$_classCallCheck(this, TouchProvider);
            return $c359ac616ace47b8$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $c359ac616ace47b8$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$5dBQh.canUseDOM || !(0, $iiSau.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $iiSau.preventTouchMove, $iiSau.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$5dBQh.canUseDOM || !(0, $iiSau.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $iiSau.preventTouchMove, $iiSau.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $c359ac616ace47b8$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($42omo.PureComponent);
}

});

parcelRegister("iiSau", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $d533ed1736c642ec$var$preventTouchMove;
module.exports.allowTouchMove = $d533ed1736c642ec$var$allowTouchMove;
module.exports.preventInertiaScroll = $d533ed1736c642ec$var$preventInertiaScroll;
module.exports.isTouchDevice = $d533ed1736c642ec$var$isTouchDevice;
module.exports.camelToKebab = $d533ed1736c642ec$var$camelToKebab;
module.exports.parse = $d533ed1736c642ec$var$parse;
module.exports.getPadding = $d533ed1736c642ec$var$getPadding;
module.exports.getWindowHeight = $d533ed1736c642ec$var$getWindowHeight;
module.exports.getDocumentHeight = $d533ed1736c642ec$var$getDocumentHeight;
module.exports.makeStyleTag = $d533ed1736c642ec$var$makeStyleTag;
module.exports.injectStyles = $d533ed1736c642ec$var$injectStyles;
module.exports.insertStyleTag = $d533ed1736c642ec$var$insertStyleTag;

var $5dBQh = parcelRequire("5dBQh");

var $d533ed1736c642ec$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $d533ed1736c642ec$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $d533ed1736c642ec$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $d533ed1736c642ec$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $d533ed1736c642ec$var$isTouchDevice() {
    if (!$5dBQh.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $d533ed1736c642ec$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $d533ed1736c642ec$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $d533ed1736c642ec$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $d533ed1736c642ec$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($d533ed1736c642ec$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $d533ed1736c642ec$var$getPadding() {
    if (!$5dBQh.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $d533ed1736c642ec$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($5dBQh.canUseDOM) return window.innerHeight * multiplier;
}
function $d533ed1736c642ec$var$getDocumentHeight() {
    if ($5dBQh.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $d533ed1736c642ec$var$makeStyleTag() {
    if (!$5dBQh.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $d533ed1736c642ec$var$injectStyles(tag, css) {
    if (!$5dBQh.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $d533ed1736c642ec$var$insertStyleTag(tag) {
    if (!$5dBQh.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});

parcelRegister("88g2N", function(module, exports) {
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $6a5f6bb656991b60$export$6eafea55f7947469 = 'data-pdnd-honey-pot';
module.exports["honeyPotDataAttribute"] = $6a5f6bb656991b60$export$6eafea55f7947469;

});

parcelRegister("iKd0N", function(module, exports) {

var $gnzSa = parcelRequire("gnzSa");


var $NVvMh = parcelRequire("NVvMh");


var $3YPrz = parcelRequire("3YPrz");


var $cuaz9 = parcelRequire("cuaz9");

function $6879436595dbe2c5$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $cuaz9.makeMonitor)();
    const dropTargetAPI = (0, $3YPrz.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource?.(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch?.(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $gnzSa.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $gnzSa.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $NVvMh.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}
module.exports["makeAdapter"] = $6879436595dbe2c5$export$2aa3a33160990d96;

});

parcelRegister("1iOCV", function(module, exports) {

var $aYpzB = parcelRequire("aYpzB");

const $6601d783db69824e$export$b7d78993b74f766d = (0, $aYpzB.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});
module.exports["isFirefox"] = $6601d783db69824e$export$b7d78993b74f766d;

});

parcelRegister("2NDLX", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $e880Z = parcelRequire("e880Z");

/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
const $9d9b82cee26a251c$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $9d9b82cee26a251c$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $e880Z.isSafari)()) return false;
    return dragEnter.hasOwnProperty($9d9b82cee26a251c$var$symbols.isEnteringWindow);
}
function $9d9b82cee26a251c$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $e880Z.isSafari)()) return false;
    return dragLeave.hasOwnProperty($9d9b82cee26a251c$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $e880Z.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $fFa3V.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[$9d9b82cee26a251c$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[$9d9b82cee26a251c$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();
module.exports["isEnteringWindowInSafari"] = $9d9b82cee26a251c$export$de68634bd94ed596;
module.exports["isLeavingWindowInSafari"] = $9d9b82cee26a251c$export$f21837c338005454;

});

parcelRegister("beiUR", function(module, exports) {
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $ffeb788f65f8276d$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $ffeb788f65f8276d$export$e46810fef53b5b0e(eventTarget) {
    return $ffeb788f65f8276d$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}
module.exports["isFromAnotherWindow"] = $ffeb788f65f8276d$export$e46810fef53b5b0e;

});

parcelRegister("k5wZ1", function(module, exports) {
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $dabd2dc172f154c6$export$fd3d00026297c0ad = 'text/plain';
module.exports["textMediaType"] = $dabd2dc172f154c6$export$fd3d00026297c0ad;

});

parcelRegister("839Yz", function(module, exports) {
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $c77f43d403723972$export$c9c4cc54e73b125d = 'application/vnd.pdnd';
module.exports["elementAdapterNativeDataKey"] = $c77f43d403723972$export$c9c4cc54e73b125d;

});

parcelRegister("75LZI", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $f7qXf = parcelRequire("f7qXf");


var $88g2N = parcelRequire("88g2N");

const $c27b859847955e76$var$honeyPotSize = 2;
const $c27b859847955e76$var$halfHoneyPotSize = $c27b859847955e76$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $c27b859847955e76$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $c27b859847955e76$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $c27b859847955e76$var$halfHoneyPotSize,
        y: point.y - $c27b859847955e76$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $c27b859847955e76$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $c27b859847955e76$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $c27b859847955e76$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $c27b859847955e76$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $c27b859847955e76$var$getHoneyPotRectFor({ client: client }) {
    const point = $c27b859847955e76$var$preventGoingForwardsOffScreen($c27b859847955e76$var$preventGoingBackwardsOffScreen($c27b859847955e76$var$pullBackByHalfHoneyPotSize($c27b859847955e76$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $c27b859847955e76$var$honeyPotSize,
        height: $c27b859847955e76$var$honeyPotSize
    });
}
function $c27b859847955e76$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $c27b859847955e76$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $c27b859847955e76$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $88g2N.honeyPotDataAttribute), 'true');
    // can shift during the drag thanks to Firefox
    let clientRect = $c27b859847955e76$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        ...$c27b859847955e76$var$getRectStyles({
            clientRect: clientRect
        }),
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $f7qXf.maxZIndex)
    });
    document.body.appendChild(element);
    /**
	 *  🦊 In firefox we can get `"pointermove"` events after the drag
	 * has started, which is a spec violation.
	 * The final `"pointermove"` will reveal where the "depressed" position
	 * is for our honey pot fix.
	 */ const unbindPointerMove = (0, $fFa3V.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $c27b859847955e76$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $c27b859847955e76$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($c27b859847955e76$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $fFa3V.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $c27b859847955e76$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $fFa3V.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $c27b859847955e76$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                const { input: input } = payload.location.current;
                finish?.({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}
module.exports["makeHoneyPotFix"] = $c27b859847955e76$export$8ecad27c959e89e0;

});

parcelRegister("iT2q7", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a8ff3bc097141ca$export$2e2bcd8739ae039);

var $fwSE5 = parcelRequire("fwSE5");

function $5a8ff3bc097141ca$export$2e2bcd8739ae039(themeId) {
    return Object.entries((0, $fwSE5.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })?.[1].id;
}

});

parcelRegister("fCbsm", function(module, exports) {

var $gfc5m = parcelRequire("gfc5m");


var $81QbB = parcelRequire("81QbB");


var $fy8Dq = parcelRequire("fy8Dq");

/** `Object#toString` result references. */ var $b5e34a9e8c2bf889$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $b5e34a9e8c2bf889$var$funcProto = Function.prototype, $b5e34a9e8c2bf889$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $b5e34a9e8c2bf889$var$funcToString = $b5e34a9e8c2bf889$var$funcProto.toString;
/** Used to check objects for own properties. */ var $b5e34a9e8c2bf889$var$hasOwnProperty = $b5e34a9e8c2bf889$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $b5e34a9e8c2bf889$var$objectCtorString = $b5e34a9e8c2bf889$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $b5e34a9e8c2bf889$var$isPlainObject(value) {
    if (!(0, $fy8Dq.default)(value) || (0, $gfc5m.default)(value) != $b5e34a9e8c2bf889$var$objectTag) return false;
    var proto = (0, $81QbB.default)(value);
    if (proto === null) return true;
    var Ctor = $b5e34a9e8c2bf889$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $b5e34a9e8c2bf889$var$funcToString.call(Ctor) == $b5e34a9e8c2bf889$var$objectCtorString;
}
var $b5e34a9e8c2bf889$export$2e2bcd8739ae039 = $b5e34a9e8c2bf889$var$isPlainObject;
module.exports["default"] = $b5e34a9e8c2bf889$export$2e2bcd8739ae039;

});

parcelRegister("eOnB8", function(module, exports) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ac880a446d7b6d4a$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});

parcelRegister("5Gw6m", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $4239c6b865c51450$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $4239c6b865c51450$var$emptyFunction = function emptyFunction() {};
$4239c6b865c51450$var$emptyFunction.thatReturns = $4239c6b865c51450$var$makeEmptyFunction;
$4239c6b865c51450$var$emptyFunction.thatReturnsFalse = $4239c6b865c51450$var$makeEmptyFunction(false);
$4239c6b865c51450$var$emptyFunction.thatReturnsTrue = $4239c6b865c51450$var$makeEmptyFunction(true);
$4239c6b865c51450$var$emptyFunction.thatReturnsNull = $4239c6b865c51450$var$makeEmptyFunction(null);
$4239c6b865c51450$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$4239c6b865c51450$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $4239c6b865c51450$var$emptyFunction;

});

parcelRegister("lW3f8", function(module, exports) {
function $ff8187ca06ce6778$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $ff8187ca06ce6778$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6oivZ", function(module, exports) {
function $4a7358a59ccaf7be$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $4a7358a59ccaf7be$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $4a7358a59ccaf7be$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("571eK", function(module, exports) {
'use strict';
var $3b8e90d446ef6ba3$var$internTable = new Map();
var $3b8e90d446ef6ba3$var$nextIndex = 1;
var $3b8e90d446ef6ba3$var$digits = $3b8e90d446ef6ba3$var$initDigitTable();
var $3b8e90d446ef6ba3$var$INTERN_PREFIX = '\t';
var $3b8e90d446ef6ba3$var$ESCAPE_PREFIX = '\v';
function $3b8e90d446ef6ba3$var$initDigitTable() {
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
function $3b8e90d446ef6ba3$var$escape(str) {
    if (str[0] === $3b8e90d446ef6ba3$var$INTERN_PREFIX && $3b8e90d446ef6ba3$var$digits.has(str[1]) || str[0] === $3b8e90d446ef6ba3$var$ESCAPE_PREFIX) return $3b8e90d446ef6ba3$var$ESCAPE_PREFIX + str;
    return str;
}
function $3b8e90d446ef6ba3$var$intern(str, limit) {
    if (limit == null || str.length < limit) return $3b8e90d446ef6ba3$var$escape(str);
    var internedString = $3b8e90d446ef6ba3$var$internTable.get(str);
    if (internedString != null) return internedString;
    internedString = $3b8e90d446ef6ba3$var$INTERN_PREFIX + $3b8e90d446ef6ba3$var$nextIndex++;
    $3b8e90d446ef6ba3$var$internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: $3b8e90d446ef6ba3$var$intern
};

});

parcelRegister("6TFlP", function(module, exports) {
'use strict';

var $f7irG = parcelRequire("f7irG");

var $5057f49e29ad7013$var$DEFAULT_HANDLE_KEY = $f7irG.DEFAULT_HANDLE_KEY;

var $q03Nf = parcelRequire("q03Nf");

function $5057f49e29ad7013$var$getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== $5057f49e29ad7013$var$DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && $q03Nf(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = $5057f49e29ad7013$var$getRelayHandleKey;

});

parcelRegister("hQyFA", function(module, exports) {
'use strict';
function $cfe22fa9c6a21a71$var$stableCopy(value) {
    if (!value || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.map($cfe22fa9c6a21a71$var$stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = $cfe22fa9c6a21a71$var$stableCopy(value[keys[i]]);
    return stable;
}
module.exports = $cfe22fa9c6a21a71$var$stableCopy;

});

parcelRegister("kfQ2W", function(module, exports) {
'use strict';

var $q03Nf = parcelRequire("q03Nf");

var $ebed94b9a031fb18$var$LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && $q03Nf(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function $ebed94b9a031fb18$var$create(capacity) {
    return new $ebed94b9a031fb18$var$LRUCache(capacity);
}
module.exports = {
    create: $ebed94b9a031fb18$var$create
};

});

parcelRegister("aB7rE", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $7b73227b6097a14f$var$_interopRequireDefault = $eGvGZ.default;

var $7b73227b6097a14f$var$_defineProperty2 = $7b73227b6097a14f$var$_interopRequireDefault((parcelRequire("l2SD1")));
parcelRequire("eEWwZ");

var $7b73227b6097a14f$var$TEMPORARY_RETAIN_DURATION_MS = 300000;
var $7b73227b6097a14f$var$SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, $7b73227b6097a14f$var$_defineProperty2["default"])(this, "_retainCount", 0);
        (0, $7b73227b6097a14f$var$_defineProperty2["default"])(this, "_retainDisposable", null);
        (0, $7b73227b6097a14f$var$_defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        if (_this._retainDisposable != null) {
                            _this._retainDisposable.dispose();
                            _this._retainDisposable = null;
                        }
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, $7b73227b6097a14f$var$TEMPORARY_RETAIN_DURATION_MS);
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = $7b73227b6097a14f$var$SuspenseResource;

});

parcelRegister("7UGaB", function(module, exports) {
'use strict';

var $8w3GE = parcelRequire("8w3GE");


var $42omo = parcelRequire("42omo");

var $5c2e797144767886$var$useState = $42omo.useState;
function $5c2e797144767886$var$useMemoVariables(variables) {
    var _useState = $5c2e797144767886$var$useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if ($8w3GE(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = $5c2e797144767886$var$useMemoVariables;

});

parcelRegister("eBXBf", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $aa32c0adaf65d642$var$_interopRequireDefault = $eGvGZ.default;

var $aa32c0adaf65d642$var$_objectSpread2 = $aa32c0adaf65d642$var$_interopRequireDefault((parcelRequire("6g2zv")));

var $aa32c0adaf65d642$var$_createForOfIteratorHelper2 = $aa32c0adaf65d642$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $lpjQw = parcelRequire("lpjQw");

var $aa32c0adaf65d642$var$getQueryResourceForEnvironment = $lpjQw.getQueryResourceForEnvironment;

var $q03Nf = parcelRequire("q03Nf");


var $3e6Uc = parcelRequire("3e6Uc");

var $aa32c0adaf65d642$var$fetchQueryInternal = $3e6Uc.__internal.fetchQuery, $aa32c0adaf65d642$var$RelayFeatureFlags = $3e6Uc.RelayFeatureFlags, $aa32c0adaf65d642$var$createOperationDescriptor = $3e6Uc.createOperationDescriptor, $aa32c0adaf65d642$var$getPendingOperationsForFragment = $3e6Uc.getPendingOperationsForFragment, $aa32c0adaf65d642$var$getSelector = $3e6Uc.getSelector, $aa32c0adaf65d642$var$getVariablesFromFragment = $3e6Uc.getVariablesFromFragment, $aa32c0adaf65d642$var$handlePotentialSnapshotErrors = $3e6Uc.handlePotentialSnapshotErrors;
parcelRequire("eEWwZ");

function $aa32c0adaf65d642$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $aa32c0adaf65d642$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $aa32c0adaf65d642$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $aa32c0adaf65d642$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $aa32c0adaf65d642$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') {
        var _state$snapshot$selec, _state$snapshot$selec2;
        $aa32c0adaf65d642$var$handlePotentialSnapshotErrors(environment, state.snapshot.missingRequiredFields, state.snapshot.relayResolverErrors, state.snapshot.errorResponseFields, (_state$snapshot$selec = (_state$snapshot$selec2 = state.snapshot.selector.node.metadata) === null || _state$snapshot$selec2 === void 0 ? void 0 : _state$snapshot$selec2.throwOnFieldError) !== null && _state$snapshot$selec !== void 0 ? _state$snapshot$selec : false);
    } else if (state.kind === 'plural') {
        var _iterator3 = (0, $aa32c0adaf65d642$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var _snapshot$selector$no, _snapshot$selector$no2;
                var snapshot = _step3.value;
                $aa32c0adaf65d642$var$handlePotentialSnapshotErrors(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_snapshot$selector$no = (_snapshot$selector$no2 = snapshot.selector.node.metadata) === null || _snapshot$selector$no2 === void 0 ? void 0 : _snapshot$selector$no2.throwOnFieldError) !== null && _snapshot$selector$no !== void 0 ? _snapshot$selector$no : false);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    }
}
function $aa32c0adaf65d642$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $aa32c0adaf65d642$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $aa32c0adaf65d642$var$_objectSpread2["default"])((0, $aa32c0adaf65d642$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $aa32c0adaf65d642$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $aa32c0adaf65d642$var$getQueryResourceForEnvironment(environment);
    return QueryResource.prepare(queryOperationDescriptor, $aa32c0adaf65d642$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
}
function $aa32c0adaf65d642$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') {
        if (fragmentSelector.selectors.length === 0) return {
            kind: 'bailout'
        };
        else return {
            kind: 'plural',
            snapshots: fragmentSelector.selectors.map(function(s) {
                return environment.lookup(s);
            }),
            epoch: environment.getStore().getEpoch()
        };
    } else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $aa32c0adaf65d642$var$readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $aa32c0adaf65d642$var$getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $q03Nf(false);
    else !!Array.isArray(fragmentRef) && $q03Nf(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $q03Nf(false);
    var state = $aa32c0adaf65d642$var$getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var missingClientEdges = $aa32c0adaf65d642$var$getMissingClientEdges(state);
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
            clientEdgeQueries = [];
            var _iterator4 = (0, $aa32c0adaf65d642$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var edge = _step4.value;
                    clientEdgeQueries.push($aa32c0adaf65d642$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    }
    if ($aa32c0adaf65d642$var$isMissingData(state)) {
        !(fragmentSelector != null) && $q03Nf(false);
        var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = $aa32c0adaf65d642$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) throw pendingOperationsResult.promise;
        $aa32c0adaf65d642$var$handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === 'bailout') data = isPlural ? [] : null;
    else if (state.kind === 'singular') data = state.snapshot.data;
    else data = state.snapshots.map(function(s) {
        return s.data;
    });
    if ($aa32c0adaf65d642$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return {
        data: data,
        clientEdgeQueries: clientEdgeQueries
    };
}
module.exports = $aa32c0adaf65d642$var$readFragmentInternal;

});

parcelRegister("9JIG7", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

var $395103940609b8b3$export$c5fb415882705cf4 = /*#__PURE__*/ function(ConfigError) {
    ConfigError["NotFound"] = "not_found";
    ConfigError["InvalidState"] = "state_invalid";
    ConfigError["IncorrectType"] = "incorrect_type";
    return ConfigError;
}({});
const $395103940609b8b3$export$e94ee64b2671e155 = (0, $gLLcz.z).record((0, $gLLcz.z).string(), (0, $gLLcz.z).object({
    value: (0, $gLLcz.z).union([
        (0, $gLLcz.z).boolean(),
        (0, $gLLcz.z).string(),
        (0, $gLLcz.z).number(),
        (0, $gLLcz.z).string().array(),
        (0, $gLLcz.z).number().array()
    ])
}));
const $395103940609b8b3$export$e38f7b10db0e126a = (0, $gLLcz.z).tuple([
    // list of boolean configs which are on
    (0, $gLLcz.z).string().array(),
    // list of string config tuples
    (0, $gLLcz.z).array((0, $gLLcz.z).string()).refine((arr)=>arr.length % 2 === 0),
    // list of number config tuples
    (0, $gLLcz.z).array((0, $gLLcz.z).union([
        (0, $gLLcz.z).string(),
        (0, $gLLcz.z).number()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            if (typeof arr[i] !== 'string') return false;
            if (typeof arr[i + 1] !== 'number') return false;
        }
        return true;
    }),
    // list of string list config tuples
    (0, $gLLcz.z).array((0, $gLLcz.z).union([
        (0, $gLLcz.z).string(),
        (0, $gLLcz.z).string().array()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every((x)=>typeof x === 'string')) return false;
        }
        return true;
    }),
    // list of number list config tuples
    (0, $gLLcz.z).array((0, $gLLcz.z).union([
        (0, $gLLcz.z).string(),
        (0, $gLLcz.z).number().array()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every((x)=>typeof x === 'number')) return false;
        }
        return true;
    })
]);
const $395103940609b8b3$export$960d45de79bd7d81 = (0, $gLLcz.z).union([
    $395103940609b8b3$export$e94ee64b2671e155,
    $395103940609b8b3$export$e38f7b10db0e126a
]);
const $395103940609b8b3$export$ac2e9c88ba5d7cbb = (0, $gLLcz.z).map((0, $gLLcz.z).string(), (0, $gLLcz.z).object({
    value: (0, $gLLcz.z).union([
        (0, $gLLcz.z).boolean(),
        (0, $gLLcz.z).string(),
        (0, $gLLcz.z).number(),
        (0, $gLLcz.z).string().array(),
        (0, $gLLcz.z).number().array()
    ])
}));
function $395103940609b8b3$var$pairs(arr, fn) {
    for(let i = 0; i < arr.length; i += 2){
        const key = arr[i];
        const val = arr[i + 1];
        if (typeof key !== 'string') throw new Error(`Expected a string while iterating pairs, got: ${arr[i]}`);
        fn(key, val);
    }
}
function $395103940609b8b3$export$c29ba52779f58587(minimal) {
    const map = new Map();
    minimal[0].forEach((boolean)=>map.set(boolean, {
            value: true
        }));
    $395103940609b8b3$var$pairs(minimal[1], (a, b)=>map.set(a, {
            value: b
        }));
    $395103940609b8b3$var$pairs(minimal[2], (a, b)=>map.set(a, {
            value: b
        }));
    $395103940609b8b3$var$pairs(minimal[3], (a, b)=>map.set(a, {
            value: b
        }));
    $395103940609b8b3$var$pairs(minimal[4], (a, b)=>map.set(a, {
            value: b
        }));
    return map;
}
function $395103940609b8b3$export$be5b69ecb011d7cc(standard) {
    const map = new Map();
    Object.entries(standard).forEach(([key, value])=>map.set(key, value));
    return map;
}
function $395103940609b8b3$export$460f06addafd9f86(map) {
    const minimal = [
        [],
        [],
        [],
        [],
        []
    ];
    for (const [key, { value: value }] of map.entries())switch(typeof value){
        case 'boolean':
            if (value) minimal[0].push(key);
            break;
        case 'string':
            minimal[1].push(key, value);
            break;
        case 'number':
            minimal[2].push(key, value);
            break;
        default:
            if (!Array.isArray(value)) throw new Error(`Unexpected configuration value: ${value}`);
            const allStrings = value.every((x)=>typeof x === 'string');
            if (allStrings) {
                minimal[3].push(key, value);
                break;
            }
            const allNumbers = value.every((x)=>typeof x === 'number');
            if (allNumbers) {
                minimal[4].push(key, value);
                break;
            }
            throw new Error(`Unexpected configuration value: ${value}`);
    }
    return minimal;
}
function $395103940609b8b3$export$9d0101ad8235e092(map) {
    return Object.fromEntries(map.entries());
}
module.exports["ConfigError"] = $395103940609b8b3$export$c5fb415882705cf4;
module.exports["AnyConfigSchema"] = $395103940609b8b3$export$960d45de79bd7d81;
module.exports["minimalToMap"] = $395103940609b8b3$export$c29ba52779f58587;
module.exports["standardToMap"] = $395103940609b8b3$export$be5b69ecb011d7cc;
module.exports["mapToMinimal"] = $395103940609b8b3$export$460f06addafd9f86;
module.exports["mapToStandard"] = $395103940609b8b3$export$9d0101ad8235e092;

});

parcelRegister("eLLiA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ac0a250ca9be848a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $jkp6O = parcelRequire("jkp6O");

function $ac0a250ca9be848a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $ac0a250ca9be848a$var$PolymorphicSchema = function() {
    function PolymorphicSchema(definition, schemaAttribute) {
        $ac0a250ca9be848a$var$_classCallCheck(this, PolymorphicSchema);
        if (schemaAttribute) this._schemaAttribute = typeof schemaAttribute === 'string' ? function(input) {
            return input[schemaAttribute];
        } : schemaAttribute;
        this.define(definition);
    }
    $ac0a250ca9be848a$var$_createClass(PolymorphicSchema, [
        {
            key: 'define',
            value: function define(definition) {
                this.schema = definition;
            }
        },
        {
            key: 'getSchemaAttribute',
            value: function getSchemaAttribute(input, parent, key) {
                return !this.isSingleSchema && this._schemaAttribute(input, parent, key);
            }
        },
        {
            key: 'inferSchema',
            value: function inferSchema(input, parent, key) {
                if (this.isSingleSchema) return this.schema;
                var attr = this.getSchemaAttribute(input, parent, key);
                return this.schema[attr];
            }
        },
        {
            key: 'normalizeValue',
            value: function normalizeValue(value, parent, key, visit, addEntity) {
                var schema = this.inferSchema(value, parent, key);
                if (!schema) return value;
                var normalizedValue = visit(value, parent, key, schema, addEntity);
                return this.isSingleSchema || normalizedValue === undefined || normalizedValue === null ? normalizedValue : {
                    id: normalizedValue,
                    schema: this.getSchemaAttribute(value, parent, key)
                };
            }
        },
        {
            key: 'denormalizeValue',
            value: function denormalizeValue(value, unvisit) {
                var schemaKey = (0, $jkp6O.isImmutable)(value) ? value.get('schema') : value.schema;
                if (!this.isSingleSchema && !schemaKey) return value;
                var id = (0, $jkp6O.isImmutable)(value) ? value.get('id') : value.id;
                var schema = this.isSingleSchema ? this.schema : this.schema[schemaKey];
                return unvisit(id || value, schema);
            }
        },
        {
            key: 'isSingleSchema',
            get: function get() {
                return !this._schemaAttribute;
            }
        }
    ]);
    return PolymorphicSchema;
}();
module.exports.default = $ac0a250ca9be848a$var$PolymorphicSchema;

});

parcelRegister("ldVC5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f73780b0b218f0e2$var$ContextKey = Symbol.for(`react-redux-context`);
const $f73780b0b218f0e2$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $f73780b0b218f0e2$var$getContext() {
    var _gT$ContextKey;
    if (!$42omo.createContext) return {};
    const contextMap = (_gT$ContextKey = $f73780b0b218f0e2$var$gT[$f73780b0b218f0e2$var$ContextKey]) != null ? _gT$ContextKey : $f73780b0b218f0e2$var$gT[$f73780b0b218f0e2$var$ContextKey] = new Map();
    let realContext = contextMap.get($42omo.createContext);
    if (!realContext) {
        realContext = $42omo.createContext(null);
        contextMap.set($42omo.createContext, realContext);
    }
    return realContext;
}
const $f73780b0b218f0e2$export$cc80c08dc91f1c00 = /*#__PURE__*/ $f73780b0b218f0e2$var$getContext();
var $f73780b0b218f0e2$export$2e2bcd8739ae039 = $f73780b0b218f0e2$export$cc80c08dc91f1c00;
module.exports["ReactReduxContext"] = $f73780b0b218f0e2$export$cc80c08dc91f1c00;

});

parcelRegister("dMy3z", function(module, exports) {
// Default to a dummy "batch" implementation that just runs the callback
function $a08a2d023a56acb3$var$defaultNoopBatch(callback) {
    callback();
}
let $a08a2d023a56acb3$var$batch = $a08a2d023a56acb3$var$defaultNoopBatch; // Allow injecting another batching function later
const $a08a2d023a56acb3$export$4b9874722d0da7bc = (newBatch)=>$a08a2d023a56acb3$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $a08a2d023a56acb3$export$fc47d4c0ba3bd2c6 = ()=>$a08a2d023a56acb3$var$batch;
module.exports["setBatch"] = $a08a2d023a56acb3$export$4b9874722d0da7bc;
module.exports["getBatch"] = $a08a2d023a56acb3$export$fc47d4c0ba3bd2c6;

});

parcelRegister("1QPqt", function(module, exports) {
$parcel$export(module.exports, "default", () => $159289eaf4cf88c4$export$2e2bcd8739ae039);
function $159289eaf4cf88c4$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $159289eaf4cf88c4$export$2e2bcd8739ae039(objA, objB) {
    if ($159289eaf4cf88c4$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$159289eaf4cf88c4$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("lNqan", function(module, exports) {
const $fde278b08a26bdac$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};
module.exports["notInitialized"] = $fde278b08a26bdac$export$20656a4825650bd0;

});

parcelRegister("gG0AJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ldVC5 = parcelRequire("ldVC5");


var $jgNAy = parcelRequire("jgNAy");


var $fUAun = parcelRequire("fUAun");

function $c241070daabefca1$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $42omo.useMemo(()=>{
        const subscription = (0, $jgNAy.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $42omo.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $fUAun.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $ldVC5.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $42omo.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $c241070daabefca1$export$2e2bcd8739ae039 = $c241070daabefca1$var$Provider;
module.exports["default"] = $c241070daabefca1$export$2e2bcd8739ae039;

});

parcelRegister("8eIct", function(module, exports) {

var $ldVC5 = parcelRequire("ldVC5");


var $2zEgD = parcelRequire("2zEgD");

function $5ff1eac536fe3c1c$export$bc9b55530897c558(context = (0, $ldVC5.ReactReduxContext)) {
    const useStore = context === (0, $ldVC5.ReactReduxContext) ? (0, $2zEgD.useStore) : (0, $2zEgD.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $5ff1eac536fe3c1c$export$8ad76b76a4c905f8 = /*#__PURE__*/ $5ff1eac536fe3c1c$export$bc9b55530897c558();
module.exports["useDispatch"] = $5ff1eac536fe3c1c$export$8ad76b76a4c905f8;

});

parcelRegister("2zEgD", function(module, exports) {

var $ldVC5 = parcelRequire("ldVC5");


var $35L13 = parcelRequire("35L13");

function $1dfe15eb01a98ead$export$671dba69185d0304(context = (0, $ldVC5.ReactReduxContext)) {
    const useReduxContext = context === (0, $ldVC5.ReactReduxContext) ? (0, $35L13.useReduxContext) : (0, $35L13.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $1dfe15eb01a98ead$export$6ccbb43953eebf8 = /*#__PURE__*/ $1dfe15eb01a98ead$export$671dba69185d0304();
module.exports["createStoreHook"] = $1dfe15eb01a98ead$export$671dba69185d0304;
module.exports["useStore"] = $1dfe15eb01a98ead$export$6ccbb43953eebf8;

});

parcelRegister("kzVdH", function(module, exports) {

var $fHHNy = parcelRequire("fHHNy");

const $efb3763ab8e07bb8$var$_toStringPreserveNull = (value)=>{
    if (typeof value === 'undefined' || value === null) return value;
    return String(value);
};
const $efb3763ab8e07bb8$var$_contentPropertiesResponseTransformer = (properties)=>{
    const contentProperties = {};
    if (!properties) return contentProperties;
    if (properties instanceof Array) // GraphQL
    for (const property of properties)contentProperties[property.key] = {
        key: property.key,
        value: JSON.parse(property.value)
    };
    else // REST
    Object.keys(properties).filter((key)=>!key.startsWith('_')).forEach((key)=>{
        const value = properties[key].value;
        contentProperties[key] = {
            key: key,
            value: value
        };
    });
    return contentProperties;
};
/**
 * @typedef {Object} NormalizedAllUpdatesResponse
 * @property {Object} response - The original REST API response. This will be removed as development progresses.
 * @property {Array<Object>} changeSets - The normalized content entities from the response object.
 */ /**
 * @typedef {Object} SpaceEntity
 * @property {string} key - The unique key for a space.
 * @property {string} title - The display title of a space.
 */ /**
 * Transforms common properties from a REST Space object response.
 * @param spaceResult The REST space object
 * @returns {{id: Number, key: String, name: String, type: String, description: null, iconPath: String, homepageId: String}}
 * @private
 */ const $efb3763ab8e07bb8$var$_transformSpaceEntity = (spaceResult)=>{
    const homepageId = spaceResult._expandable && spaceResult._expandable.homepage ? spaceResult._expandable.homepage.substring(18) : spaceResult.homepage && spaceResult.homepage.id;
    const space = {
        id: spaceResult.id ? `${spaceResult.id}` : spaceResult.id,
        key: spaceResult.key,
        alias: spaceResult.alias,
        name: spaceResult.name,
        type: spaceResult.type
    };
    if (homepageId) space.homepageId = `${homepageId}`;
    if (spaceResult.icon && spaceResult.icon.path) space.iconPath = spaceResult.icon.path;
    if (spaceResult.isFavourite) space.isFavourite = spaceResult.isFavourite;
    if (spaceResult.isWatched) space.isWatched = spaceResult.isWatched;
    if (spaceResult.operations) {
        space.operations = spaceResult.operations;
        space.currentUserPermissions = spaceResult.operations.filter((op)=>op.targetType === 'space').map((op)=>op.operation);
    }
    if (spaceResult.lookAndFeel) space.lookAndFeel = spaceResult.lookAndFeel;
    if (spaceResult.settings) space.settings = spaceResult.settings;
    if (spaceResult.theme) space.theme = $efb3763ab8e07bb8$export$90060682b63d0d22(spaceResult.theme);
    return space;
};
const $efb3763ab8e07bb8$export$9d4d8ac8f8e79877 = (response)=>{
    const results = [];
    (response.results || response.nodes).map((space)=>{
        const labels = space.metadata && space.metadata.labels && (space.metadata.labels.results || space.metadata.labels.nodes);
        results.push($efb3763ab8e07bb8$var$_transformSpaceEntity({
            ...space,
            isFavourite: labels && labels.some((label)=>label.prefix === 'my' && (label.name === 'favourite' || label.name === 'favorite'))
        }));
    });
    return {
        results: results
    };
};
const $efb3763ab8e07bb8$var$spaceThemeKeyModuleKeyRegex = /^ac:(.*)__(.*)-remote-theme$/;
const $efb3763ab8e07bb8$export$90060682b63d0d22 = (response)=>{
    const regexResult = $efb3763ab8e07bb8$var$spaceThemeKeyModuleKeyRegex.exec(response.themeKey);
    return regexResult ? {
        addonKey: regexResult[1],
        moduleKey: regexResult[2]
    } : {
        addonKey: null,
        moduleKey: null
    };
};
/**
 * Return 'null' in place of 'undefined'
 */ const $efb3763ab8e07bb8$var$orNull = (value)=>typeof value === 'undefined' ? null : value;
const $efb3763ab8e07bb8$export$51f5684b148b495e = (response)=>{
    if (!response) return {};
    const { metadata: metadata = {} } = response;
    const id = response ? $efb3763ab8e07bb8$var$_toStringPreserveNull(response.id) : null;
    const properties = response.properties && response.properties.nodes || metadata.properties;
    const data = {
        id: id,
        properties: $efb3763ab8e07bb8$var$_contentPropertiesResponseTransformer(properties),
        title: response.title,
        type: response.type,
        operations: response.operations,
        currentUserPermissions: response.operations ? response.operations.map((op)=>op.operation) : null
    };
    if (response.version) data.version = $efb3763ab8e07bb8$var$contentVersionResponseTransformer(response).version;
    return data;
};
/**
 * Standardize the response for getting the space home content.
 * @param response - The REST response
 * @returns {*} a normalized content response for the space home.
 */ const $efb3763ab8e07bb8$var$contentBodyResponseTransformer = (response)=>{
    if (!response) return {};
    const { body: body } = response;
    const id = response ? $efb3763ab8e07bb8$var$_toStringPreserveNull(response.id) : null;
    return {
        body: {
            id: id,
            html: body && body.view && body.view.value,
            cssTags: body && body.view && body.view.webresource.tags.css,
            jsUris: body && body.view && body.view.webresource.uris.js
        }
    };
};
/**
 * Standardize the response for getting versions.
 * @param response - The REST response
 * @param id - The content id
 * @returns {*} a normalized content response for the version
 */ const $efb3763ab8e07bb8$var$contentVersionResponseTransformer = (response, id)=>{
    if (!response) return {};
    id = $efb3763ab8e07bb8$var$_toStringPreserveNull(id || response.id);
    return {
        version: {
            id: `${id}`,
            by: response.version && response.version.by && (0, $fHHNy.userTransformer)(response.version.by),
            when: response.version && response.version.when,
            friendlyWhen: response.version && response.version.friendlyWhen,
            number: response.version && response.version.number,
            syncRev: response.version && response.version.syncRev,
            confRev: response.version && response.version.confRev
        }
    };
};
/**
 * Standardize the response for getting createdBy field.
 * @param response - The REST response
 * @param id - The content id
 * @returns {*} a normalized content response for the createdBy field
 */ const $efb3763ab8e07bb8$var$contentCreatedResponseTransformer = (content)=>{
    const created = {
        createdDate: undefined,
        createdBy: undefined
    };
    if (!content || !content.history) return created;
    const { createdDate: createdDate, createdBy: createdBy } = content.history;
    if (createdDate) created.createdDate = createdDate;
    if (createdBy) {
        const user = (0, $fHHNy.userTransformer)(createdBy);
        if (typeof user.isAnonymous !== 'undefined') created.createdBy = user;
    }
    return created;
};
const $efb3763ab8e07bb8$export$b8b68047d69aeebb = (response)=>{
    if (!response) return {};
    // when using cql search through graphql, there is one extra level of nesting
    const content = response.content || response;
    return {
        ...$efb3763ab8e07bb8$export$51f5684b148b495e(content),
        ...$efb3763ab8e07bb8$var$contentBodyResponseTransformer(content),
        ancestors: content.ancestors,
        ...$efb3763ab8e07bb8$var$contentCreatedResponseTransformer(content),
        ...$efb3763ab8e07bb8$var$contentVersionResponseTransformer(content),
        space: content.space
    };
};
const $efb3763ab8e07bb8$export$f4598dcdfe03c0cd = (response)=>{
    const results = response && (response.results || response.nodes);
    if (!results || !results.length) return null;
    return $efb3763ab8e07bb8$export$b8b68047d69aeebb(results[0]);
};
const $efb3763ab8e07bb8$export$5b7f66cbeaa0c63f = (response, url)=>{
    if (!response) return {};
    // Do not use the id from the response - there could be a rounding error if the id is too large.
    const id = $efb3763ab8e07bb8$var$_toStringPreserveNull(url.substring(url.lastIndexOf('/') + 1).split('.')[0]);
    return {
        _originalResponse: response,
        id: id,
        title: response.title,
        version: {
            id: `${id}`,
            number: parseInt(response.pageVersion, 10)
        },
        spaceKey: response.spaceKey
    };
};
const $efb3763ab8e07bb8$export$8e8f969893c7131f = (response, url)=>{
    if (!response) return {};
    return {
        id: response.id,
        createdDate: response.history && response.history.createdDate,
        createdBy: response.history && response.history.createdBy && (0, $fHHNy.userTransformer)(response.history.createdBy),
        ...$efb3763ab8e07bb8$var$contentVersionResponseTransformer(response),
        type: response.type,
        title: response.title
    };
};
const $efb3763ab8e07bb8$export$308ad3c647525282 = (response, url)=>{
    if (!response) return {};
    return {
        id: response.id,
        createdDate: response.history && response.history.createdDate,
        createdBy: response.history && response.history.createdBy && (0, $fHHNy.userTransformer)(response.history.createdBy),
        type: response.type,
        title: response.title
    };
};
const $efb3763ab8e07bb8$export$22c94088267c8e81 = (response)=>{
    const results = response && (response.results || response.nodes);
    if (!results || !results.length) return null;
    return $efb3763ab8e07bb8$export$b89596f1f8559835(results[0]);
};
const $efb3763ab8e07bb8$var$EMPTY_ADF_DOCUMENT = {
    value: {
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ],
        type: 'doc',
        version: 1
    }
};
function $efb3763ab8e07bb8$var$_parseAtlasDocFormat(atlas_doc_format) {
    //TODO: CFE-610 Remove this empty ADF document
    if (!atlas_doc_format.value || atlas_doc_format.value.length === 0) return $efb3763ab8e07bb8$var$EMPTY_ADF_DOCUMENT;
    try {
        return {
            value: JSON.parse(atlas_doc_format.value)
        };
    } catch (e) {
        return {
            // use the value to show in ADF Parsing Error dialog
            value: atlas_doc_format.value,
            isADFContentInvalid: true
        };
    }
}
const $efb3763ab8e07bb8$export$b89596f1f8559835 = (response, url)=>{
    if (!response) return {};
    let id;
    if (response.id) id = response.id;
    else if (url) id = $efb3763ab8e07bb8$var$_toStringPreserveNull(url.substring(url.lastIndexOf('/') + 1).split('.')[0]);
    const parsedEditorContent = {};
    parsedEditorContent.atlas_doc_format = $efb3763ab8e07bb8$var$_parseAtlasDocFormat(response.body.atlas_doc_format);
    const data = {
        id: id,
        title: response.title,
        editorContent: {
            ...response.body,
            ...parsedEditorContent
        },
        type: response.type,
        isUnpublishedDraft: !response.history.createdBy,
        ancestors: response.ancestors,
        space: response.space,
        links: response.links,
        currentUserPermissions: response.operations && response.operations.map((op)=>op.operation),
        ...$efb3763ab8e07bb8$var$contentCreatedResponseTransformer(response),
        ...$efb3763ab8e07bb8$var$contentVersionResponseTransformer(response),
        appearancePublished: response.appearancePublished.nodes,
        appearanceDraft: response.appearanceDraft.nodes,
        labels: response.metadata.labels,
        schedulePublishDate: response.schedulePublishDate
    };
    return data;
};
const $efb3763ab8e07bb8$export$f7a7df7bf8236bf1 = (response, url)=>{
    if (!response) return {};
    const id = $efb3763ab8e07bb8$var$_toStringPreserveNull(url.substring(url.lastIndexOf('/') + 1).split('.')[0]);
    return {
        id: id,
        renderedPreviewContent: response
    };
};
const $efb3763ab8e07bb8$export$b74925f6c30cdf19 = (response, url)=>{
    if (url) {
        const spaceKey = url.substr(url.lastIndexOf('/') + 1);
        return {
            entities: {
                spaces: {
                    [spaceKey]: {
                        isFavourite: true
                    }
                }
            }
        };
    } else return {
        entities: {
            spaces: {}
        }
    };
};
const $efb3763ab8e07bb8$export$304e680a6aa46d45 = (response, url)=>{
    if (url) {
        const spaceKey = url.substr(url.lastIndexOf('/') + 1);
        return {
            entities: {
                spaces: {
                    [spaceKey]: {
                        isFavourite: false
                    }
                }
            }
        };
    } else return {
        entities: {
            spaces: {}
        }
    };
};
const $efb3763ab8e07bb8$export$b1e23bed8ebe8d4c = (response)=>{
    return response.results.map(({ source: { displayName: displayName, accountId: accountId, profilePicture: { path: avatarUrl } = {} }, relationData: { createdDate: createdDate, friendlyCreatedDate: friendlyCreatedDate } })=>{
        return {
            avatarUrl: avatarUrl,
            displayName: displayName,
            accountId: accountId,
            createdDate: createdDate,
            friendlyCreatedDate: friendlyCreatedDate
        };
    });
};
module.exports["spaceResponseTransformer"] = $efb3763ab8e07bb8$export$9d4d8ac8f8e79877;
module.exports["contentWithBodyResponseTransformer"] = $efb3763ab8e07bb8$export$b8b68047d69aeebb;
module.exports["editorContentWithBodyResponseTransformer"] = $efb3763ab8e07bb8$export$5b7f66cbeaa0c63f;
module.exports["publishContentTransformer"] = $efb3763ab8e07bb8$export$8e8f969893c7131f;
module.exports["schedulePublishContentTransformer"] = $efb3763ab8e07bb8$export$308ad3c647525282;

});

parcelRegister("fHHNy", function(module, exports) {
const $b6ecd8937a6050a6$export$6938163b060d2a80 = ({ type: type, accountId: accountId, displayName: displayName, profilePicture: { path: avatarUrl } = {}, permissionType: permissionType } = {})=>{
    if (!avatarUrl) return {};
    if (type === 'anonymous') return {
        isAnonymous: true,
        avatarUrl: avatarUrl
    };
    return {
        isAnonymous: false,
        displayName: displayName,
        avatarUrl: avatarUrl,
        accountId: accountId,
        permissionType: permissionType
    };
};
module.exports["userTransformer"] = $b6ecd8937a6050a6$export$6938163b060d2a80;

});

parcelRegister("4ZFIE", function(module, exports) {
/* eslint-disable check-credentials-option/has-credentials-option */ 
var $jiJCD = parcelRequire("jiJCD");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");

var $50bhB = parcelRequire("50bhB");

var $flE5X = parcelRequire("flE5X");


var $3A6oh = parcelRequire("3A6oh");

/**
 * Substitute tokens with values
 *
 * @param {String} url - the url with ':token' or ':token?' tokens to be replaced.
 * @param {Object} parameters - the substitutions.
 */ const $3a2d38778062baf1$var$replaceTokens = (url, parameters)=>{
    return url.replace(/:([a-zA-Z]+)\?*/g, function(match, token) {
        let param = parameters[token];
        // blueprint urls need a ? following the contentId
        if (match === ':contentId?') param = param + '?';
        // Do not encode token like :query => key=value or :contentId? => 123188823?
        return typeof param === 'string' && param.indexOf('=') === -1 && match !== ':contentId?' ? encodeURIComponent(decodeURIComponent(param)) : param;
    });
};
function $3a2d38778062baf1$var$waitFor({ condition: condition, maxTries: maxTries = 10, interval: interval = 250, callback: callback }) {
    if (typeof condition !== 'function') throw new Error('waitFor requires a condition wrapped in a function as first argument');
    if (typeof callback !== 'function') throw new Error('waitFor requires a function as callback');
    // if condition passes, return immediately
    if (condition()) return callback();
    let currentTry = 0;
    const waitForTimeout = ()=>setTimeout(()=>{
            if (condition()) return callback();
            // count number of tries
            currentTry = currentTry + 1;
            // escape if it's over the maximum
            if (maxTries && maxTries > 0 && currentTry >= maxTries) return;
            // check again
            waitForTimeout();
        }, interval);
    // start waiting
    waitForTimeout();
}
function $3a2d38778062baf1$var$requestErrorHandler(callback, httpCodeHandlers = {}, method = '', urlPath = '', routeName = '') {
    return (error)=>{
        if (error instanceof (0, $hBkCm.BadStatusError)) {
            // XXX Translate BadStatusError to ConfluenceRestApiError because that's what
            // customHandler and callback (may) rely on (since they predate the
            // introduction of BadStatusError).
            const { response: response } = error;
            return response.text().then((text)=>$3a2d38778062baf1$var$requestErrorHandler(callback, httpCodeHandlers, method, urlPath, routeName)(new (0, $50bhB.ConfluenceRestApiError)({
                    message: text,
                    'status-code': response.status,
                    method: method,
                    url: urlPath
                }, {
                    route: routeName,
                    traceId: error.traceId
                })));
        }
        if (error instanceof (0, $50bhB.ConfluenceRestApiError)) {
            const customHandler = httpCodeHandlers[error.statusCode];
            if (customHandler) customHandler(error);
            return callback(error);
        }
        // XXX TypeError was given to callback before the introduction of
        // NoNetworkError. Based on searching for TypeError in the source code base,
        // it appears that the TypeError was used as a signal of an offline network.
        // That's understandable given that fetch throws a TypeError when the
        // network is offline. However, requestErrorHandler runs in a catch of a
        // chain of Promises each of which may throw TypeError for reasons other
        // than the network being offline. So preserve the legacy behavior for
        // compatibility reasons.
        //
        // However, we now wrap fetch and throw NoNetworkError so take that new type
        // into account as well.
        if (error instanceof TypeError || error instanceof (0, $flE5X.NoNetworkError)) return callback(error);
        throw error;
    };
}
const $3a2d38778062baf1$export$8ae1430f8babe4d9 = $3a2d38778062baf1$var$requestErrorHandler;
function $3a2d38778062baf1$var$invokeResource(url, { body: body, callback: callback, headers: headers, method: method, extraConfig: extraConfig = {}, responseTransformer: responseTransformer, httpCodeHandlers: httpCodeHandlers, routeName: routeName }, config) {
    let bodyParam = body;
    const contentType = headers['Content-Type'];
    // remove Content-Type if 'null', which is required for multipart/form-data
    // so that the browser populates the mime boundary string correctly
    if (!contentType) delete headers['Content-Type'];
    if (contentType && contentType.indexOf('application/x-www-form-urlencoded') !== -1) bodyParam = new URLSearchParams(body).toString();
    else if (contentType === 'application/json') bodyParam = JSON.stringify(body);
    const urlPath = (0, $jiJCD.parse)(url).path;
    const passThrough = ()=>(0, $f7B1p.cfetch)(url, {
            headers: headers,
            method: method,
            body: bodyParam
        });
    return (0, $3A6oh.preloadedRestLink)(urlPath, {
        method: method,
        headers: headers,
        body: body
    }, passThrough).then(function(response) {
        if (extraConfig.ignoreResponseJson) return null;
        if (response.status !== 204) return response.json();
        else return response;
    }).then(function(responseJson) {
        if (responseJson && responseJson['status-code']) throw new (0, $50bhB.ConfluenceRestApiError)(responseJson, {
            route: routeName
        });
        return callback(null, responseTransformer ? responseTransformer(responseJson, url, config.contextPath, body) : responseJson);
    }).catch($3a2d38778062baf1$var$requestErrorHandler(callback, httpCodeHandlers, method, urlPath, routeName));
}
function $3a2d38778062baf1$export$34cd9bd409b5730c() {
    let config = {
        endpoint: null,
        contextPath: null,
        extraHeaders: {},
        atlToken: null,
        tenantId: null
    };
    return {
        configure (configuration = {}) {
            config = {
                ...config,
                ...configuration
            };
        },
        getConfig () {
            return config;
        },
        getAtlToken () {
            if (!config.atlToken) throw new Error('Tried to use atlToken before it was available');
            return config.atlToken;
        },
        /**
		 * Wait for tenant id and resolves the promise
		 * @returns {Promise}
		 */ withTenantId () {
            return new Promise((resolve, reject)=>{
                $3a2d38778062baf1$var$waitFor({
                    condition: ()=>config.tenantId !== null,
                    callback: ()=>resolve(config.tenantId)
                });
            });
        },
        /**
		 * Returns the full PATH for a given path.
		 * @param {string} path
		 * @param {Object} [params]
		 */ getFullPath (path, params) {
            const absoluteUrl = config.endpoint ? `${config.endpoint}${config.contextPath}${path}` : `${config.contextPath}${path}`;
            return params ? $3a2d38778062baf1$var$replaceTokens(absoluteUrl, params) : absoluteUrl;
        },
        getExternalServicePath (path, params) {
            if (typeof path !== 'function') throw new Error('getExternalServicePath expects path to be a function so it can be lazy evaluated');
            const lazyPath = path();
            return $3a2d38778062baf1$var$replaceTokens(lazyPath, params);
        },
        get (url, { callback: callback, headers: headers, responseTransformer: responseTransformer, httpCodeHandlers: httpCodeHandlers, extraConfig: extraConfig = {}, routeName: routeName }) {
            const actualHeaders = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...config.extraHeaders,
                ...headers
            };
            return $3a2d38778062baf1$var$invokeResource(url, {
                callback: callback,
                headers: actualHeaders,
                method: 'GET',
                responseTransformer: responseTransformer,
                httpCodeHandlers: httpCodeHandlers,
                extraConfig: extraConfig,
                routeName: routeName
            }, config);
        },
        post (url, { body: body, callback: callback, headers: headers, extraConfig: extraConfig, responseTransformer: responseTransformer, httpCodeHandlers: httpCodeHandlers, routeName: routeName }) {
            const actualHeaders = {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...config.extraHeaders,
                ...headers
            };
            return $3a2d38778062baf1$var$invokeResource(url, {
                body: body,
                callback: callback,
                headers: actualHeaders,
                method: 'POST',
                extraConfig: extraConfig,
                responseTransformer: responseTransformer,
                httpCodeHandlers: httpCodeHandlers,
                routeName: routeName
            }, config);
        },
        put (url, { body: body, callback: callback, headers: headers, extraConfig: extraConfig, responseTransformer: responseTransformer, httpCodeHandlers: httpCodeHandlers, routeName: routeName }) {
            const actualHeaders = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...config.extraHeaders,
                ...headers
            };
            return $3a2d38778062baf1$var$invokeResource(url, {
                body: body,
                callback: callback,
                headers: actualHeaders,
                method: 'PUT',
                extraConfig: extraConfig,
                responseTransformer: responseTransformer,
                httpCodeHandlers: httpCodeHandlers,
                routeName: routeName
            }, config);
        },
        delete (url, { callback: callback, headers: headers, extraConfig: extraConfig, responseTransformer: responseTransformer, httpCodeHandlers: httpCodeHandlers, routeName: routeName }) {
            const actualHeaders = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...config.extraHeaders,
                ...headers
            };
            return $3a2d38778062baf1$var$invokeResource(url, {
                callback: callback,
                headers: actualHeaders,
                method: 'DELETE',
                extraConfig: extraConfig,
                responseTransformer: responseTransformer,
                httpCodeHandlers: httpCodeHandlers,
                routeName: routeName
            }, config);
        },
        postLegacyResource (url, { body: body, callback: callback, headers: headers, method: method, responseTransformer: responseTransformer, httpCodeHandlers: httpCodeHandlers, routeName: routeName }) {
            return (0, $f7B1p.cfetch)(url, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    ...config.extraHeaders,
                    ...headers
                },
                method: 'POST',
                body: typeof body === 'string' ? body : new URLSearchParams(body).toString()
            }).then(/* onFulfilled */ (response)=>{
                const contentType = response.headers.get('content-type');
                return !contentType || contentType.indexOf('text/html') !== -1 || contentType.indexOf('text/plain') !== -1 ? response.text() : response.json();
            }, /* onRejected */ (reason)=>{
                if (reason instanceof (0, $hBkCm.BadStatusError)) return new Error('Request failed with ' + reason.response.status);
                throw reason;
            }).then((result)=>{
                if (result instanceof Error) return callback(result);
                else return callback(null, responseTransformer ? responseTransformer(result, url, config.contextPath, body) : result);
            }).catch($3a2d38778062baf1$var$requestErrorHandler(callback, httpCodeHandlers, method, url, routeName));
        },
        /**
		 * Clean wrapper around Native fetch - it returns the fetch promise so it
		 * can be used when we need to delegate workflow rules to the action creator
		 * instead of relying on the middleware.
		 *
		 * @param url
		 * @param options
		 * @returns Promise
		 */ fetch (url, options) {
            // eslint-disable-next-line no-restricted-syntax
            return fetch(url, options);
        }
    };
}
/** Global request helper with shared configuration to avoid breaking API changes.
 *
 * @deprecated
 * @type Object
 */ const $3a2d38778062baf1$var$globalRequestHelper = $3a2d38778062baf1$export$34cd9bd409b5730c();
$3a2d38778062baf1$var$globalRequestHelper.configure();
var $3a2d38778062baf1$export$2e2bcd8739ae039 = $3a2d38778062baf1$var$globalRequestHelper;
module.exports["default"] = $3a2d38778062baf1$export$2e2bcd8739ae039;

});

parcelRegister("glTst", function(module, exports) {
// NOTE: These constants are alphabetised by value to help avoid duplication.
const $be79a06186edd30a$export$999beecd9976dfe6 = '/labels/autocompletelabel.action?maxResults=3&query=:query&contentId=:contentId';
const $be79a06186edd30a$export$d7b094653547f492 = '/rest/api/content';
const $be79a06186edd30a$export$60da72490d291c94 = '/rest/api/content/:contentId/?status=:status';
const $be79a06186edd30a$export$7289b07637c5429e = '/rest/api/content/:contentId/?expand=ancestors,version';
const $be79a06186edd30a$export$df073c2379a2dd3f = '/rest/api/content/:contentId/?status=draft&expand=ancestors,space';
const $be79a06186edd30a$export$49f3ec801d107ef1 = '/rest/api/content/:contentId/?status=draft&action=sync';
const $be79a06186edd30a$export$9903792537254d5 = '/rest/api/content/:contentId/?status=draft&action=publish';
const $be79a06186edd30a$export$4623bae024a48b71 = '/rest/api/content/blueprint/instance/:contentId?status=draft';
const $be79a06186edd30a$export$533c0de32020cfb7 = '/rest/api/content/:contentId/property/:propertyKey';
const $be79a06186edd30a$export$27b7b95a5fde2b31 = '/rest/api/space?spaceKey=:spaceKey&expand=:expand';
const $be79a06186edd30a$export$71a35391239a6305 = '/rest/experimental/relation/:sourceType/:sourceKey/:relationName/to:targetType/:targetKey';
const $be79a06186edd30a$export$4ce7537a3461d0d3 = '/rest/feature-discovery/1.0/discovered/:pluginKey/:featureKey';
const $be79a06186edd30a$export$eabb116af1a87c7 = '/rest/tinymce/1/content/:contentId.json?draftShareId=:draftShareId&_=:timestamp';
const $be79a06186edd30a$export$81b54e219a26d7f3 = '/pages/rendercontent.action';
const $be79a06186edd30a$export$178c227390220f0e = '/rest/synchrony/1.0/content/:contentId/changes/unpublished';
const $be79a06186edd30a$export$8457ce6f530e7dc4 = '/rest/api/content/:contentId/schedule/publish';
module.exports["CONTENT_CREATE"] = $be79a06186edd30a$export$d7b094653547f492;
module.exports["EDIT_PAGE_METADATA"] = $be79a06186edd30a$export$7289b07637c5429e;
module.exports["DRAFT_METADATA"] = $be79a06186edd30a$export$df073c2379a2dd3f;
module.exports["DRAFT_SYNC"] = $be79a06186edd30a$export$49f3ec801d107ef1;
module.exports["CONTENT_PUBLISH"] = $be79a06186edd30a$export$9903792537254d5;
module.exports["CONTENT_FROM_TEMPLATE_PUBLISH"] = $be79a06186edd30a$export$4623bae024a48b71;
module.exports["EDIT_PAGE_PROPERTIES"] = $be79a06186edd30a$export$533c0de32020cfb7;
module.exports["SPACE"] = $be79a06186edd30a$export$27b7b95a5fde2b31;
module.exports["RELATION_ENTITIES"] = $be79a06186edd30a$export$71a35391239a6305;
module.exports["FEATURE_DISCOVERY"] = $be79a06186edd30a$export$4ce7537a3461d0d3;
module.exports["EDITOR_PAGE"] = $be79a06186edd30a$export$eabb116af1a87c7;
module.exports["CANCEL_SCHEDULED_PUBLISH"] = $be79a06186edd30a$export$8457ce6f530e7dc4;

});

parcelRegister("1YPEa", function(module, exports) {
'use strict';

var $jO6uW = parcelRequire("jO6uW");


var $eFVpV = parcelRequire("eFVpV");

var $17137506d247dcb1$var$EXISTENT = $eFVpV.EXISTENT;

var $q03Nf = parcelRequire("q03Nf");

var $17137506d247dcb1$var$RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = $jO6uW.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = $jO6uW.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = $jO6uW.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && $q03Nf(false);
            sinkRecord = $jO6uW.create(dataID, $jO6uW.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && $q03Nf(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) $jO6uW.copyFields(baseSource, sink);
        if (sinkSource) $jO6uW.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        $jO6uW.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== $17137506d247dcb1$var$EXISTENT && this._sink.getStatus(dataID) !== $17137506d247dcb1$var$EXISTENT) && $q03Nf(false);
        var record = $jO6uW.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return $jO6uW.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $jO6uW.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        $jO6uW.setValue(sinkRecord, storageKey, value);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = $jO6uW.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        $jO6uW.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = $jO6uW.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        $jO6uW.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = $17137506d247dcb1$var$RelayRecordSourceMutator;

});

parcelRegister("kin3U", function(module, exports) {
'use strict';

var $jO6uW = parcelRequire("jO6uW");


var $eFVpV = parcelRequire("eFVpV");

var $ec6760c12c70297e$var$EXISTENT = $eFVpV.EXISTENT, $ec6760c12c70297e$var$NONEXISTENT = $eFVpV.NONEXISTENT;

var $jZOVE = parcelRequire("jZOVE");

var $ec6760c12c70297e$var$ROOT_ID = $jZOVE.ROOT_ID, $ec6760c12c70297e$var$ROOT_TYPE = $jZOVE.ROOT_TYPE;

var $6lAfP = parcelRequire("6lAfP");

var $ec6760c12c70297e$var$_readUpdatableFragment = $6lAfP.readUpdatableFragment;

var $e48nX = parcelRequire("e48nX");

var $ec6760c12c70297e$var$_readUpdatableQuery = $e48nX.readUpdatableQuery;

var $2Geq3 = parcelRequire("2Geq3");


var $q03Nf = parcelRequire("q03Nf");

var $ec6760c12c70297e$var$RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === $ec6760c12c70297e$var$EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== $ec6760c12c70297e$var$EXISTENT) _this.create(dataID, $jO6uW.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === $ec6760c12c70297e$var$NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $q03Nf(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        !record && $q03Nf(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== $ec6760c12c70297e$var$ROOT_ID) && $q03Nf(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === $ec6760c12c70297e$var$EXISTENT) this._proxies[dataID] = new $2Geq3(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === $ec6760c12c70297e$var$NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get($ec6760c12c70297e$var$ROOT_ID);
        if (!root) root = this.create($ec6760c12c70297e$var$ROOT_ID, $ec6760c12c70297e$var$ROOT_TYPE);
        !(root && root.getType() === $ec6760c12c70297e$var$ROOT_TYPE) && $q03Nf(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $ec6760c12c70297e$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $ec6760c12c70297e$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = $ec6760c12c70297e$var$RelayRecordSourceProxy;

});

parcelRegister("cCwaC", function(module, exports) {
'use strict';

var $ceyF6 = parcelRequire("ceyF6");

var $9301fcfe2bd46ea1$var$REQUEST = $ceyF6.REQUEST, $9301fcfe2bd46ea1$var$SPLIT_OPERATION = $ceyF6.SPLIT_OPERATION;
function $9301fcfe2bd46ea1$var$getOperation(node) {
    switch(node.kind){
        case $9301fcfe2bd46ea1$var$REQUEST:
            return node.operation;
        case $9301fcfe2bd46ea1$var$SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = $9301fcfe2bd46ea1$var$getOperation;

});

parcelRegister("k2eXq", function(module, exports) {
'use strict';

var $ceyF6 = parcelRequire("ceyF6");

var $e95f98c6a809a5d0$var$LINKED_FIELD = $ceyF6.LINKED_FIELD;

var $jZOVE = parcelRequire("jZOVE");

var $e95f98c6a809a5d0$var$getHandleStorageKey = $jZOVE.getHandleStorageKey;

var $8w3GE = parcelRequire("8w3GE");


var $q03Nf = parcelRequire("q03Nf");

function $e95f98c6a809a5d0$var$cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $e95f98c6a809a5d0$var$LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && $8w3GE(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $e95f98c6a809a5d0$var$LINKED_FIELD) && $q03Nf(false);
    var handleKey = $e95f98c6a809a5d0$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'LinkedField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = $e95f98c6a809a5d0$var$cloneRelayHandleSourceField;

});

parcelRegister("buZz3", function(module, exports) {
'use strict';

var $ceyF6 = parcelRequire("ceyF6");

var $85f2406e99321576$var$SCALAR_FIELD = $ceyF6.SCALAR_FIELD;

var $jZOVE = parcelRequire("jZOVE");

var $85f2406e99321576$var$getHandleStorageKey = $jZOVE.getHandleStorageKey;

var $8w3GE = parcelRequire("8w3GE");


var $q03Nf = parcelRequire("q03Nf");

function $85f2406e99321576$var$cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $85f2406e99321576$var$SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && $8w3GE(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $85f2406e99321576$var$SCALAR_FIELD) && $q03Nf(false);
    var handleKey = $85f2406e99321576$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'ScalarField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = $85f2406e99321576$var$cloneRelayScalarHandleSourceField;

});

parcelRegister("1uPIp", function(module, exports) {
'use strict';

var $fub1S = parcelRequire("fub1S");

var $1170b55feef62b2f$var$generateClientID = $fub1S.generateClientID;

var $jZOVE = parcelRequire("jZOVE");

var $1170b55feef62b2f$var$ROOT_ID = $jZOVE.ROOT_ID;
var $1170b55feef62b2f$var$VIEWER_ID = $1170b55feef62b2f$var$generateClientID($1170b55feef62b2f$var$ROOT_ID, 'viewer');
var $1170b55feef62b2f$var$VIEWER_TYPE = 'Viewer';
module.exports = {
    VIEWER_ID: $1170b55feef62b2f$var$VIEWER_ID,
    VIEWER_TYPE: $1170b55feef62b2f$var$VIEWER_TYPE
};

});

parcelRegister("fYxua", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $ba166f25139cb335$var$_interopRequireDefault = $eGvGZ.default;

var $ba166f25139cb335$var$_createForOfIteratorHelper2 = $ba166f25139cb335$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $kU32t = parcelRequire("kU32t");


var $ceyF6 = parcelRequire("ceyF6");

var $ba166f25139cb335$var$RELAY_LIVE_RESOLVER = $ceyF6.RELAY_LIVE_RESOLVER;

var $ek4t1 = parcelRequire("ek4t1");


var $fu0yr = parcelRequire("fu0yr");


var $fub1S = parcelRequire("fub1S");

var $ba166f25139cb335$var$generateClientID = $fub1S.generateClientID;

var $jO6uW = parcelRequire("jO6uW");


var $jZOVE = parcelRequire("jZOVE");

var $ba166f25139cb335$var$RELAY_RESOLVER_ERROR_KEY = $jZOVE.RELAY_RESOLVER_ERROR_KEY, $ba166f25139cb335$var$RELAY_RESOLVER_INVALIDATION_KEY = $jZOVE.RELAY_RESOLVER_INVALIDATION_KEY, $ba166f25139cb335$var$RELAY_RESOLVER_SNAPSHOT_KEY = $jZOVE.RELAY_RESOLVER_SNAPSHOT_KEY, $ba166f25139cb335$var$RELAY_RESOLVER_VALUE_KEY = $jZOVE.RELAY_RESOLVER_VALUE_KEY, $ba166f25139cb335$var$getStorageKey = $jZOVE.getStorageKey;

var $q03Nf = parcelRequire("q03Nf");

parcelRequire("eEWwZ");

var $ba166f25139cb335$var$emptySet = new Set();
var $ba166f25139cb335$var$NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== $ba166f25139cb335$var$RELAY_LIVE_RESOLVER) && $q03Nf(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        $q03Nf(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
function $ba166f25139cb335$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $ba166f25139cb335$var$RecordResolverCache = /*#__PURE__*/ function() {
    function RecordResolverCache(getRecordSource) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
    }
    var _proto2 = RecordResolverCache.prototype;
    _proto2.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = recordSource.get(recordID);
        !(record != null) && $q03Nf(false);
        var storageKey = $ba166f25139cb335$var$getStorageKey(field, variables);
        var linkedID = $jO6uW.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $ba166f25139cb335$var$generateClientID(recordID, storageKey);
            linkedRecord = $jO6uW.create(linkedID, '__RELAY_RESOLVER__');
            var evaluationResult = evaluate();
            $fu0yr(evaluationResult.resolverResult);
            $jO6uW.setValue(linkedRecord, $ba166f25139cb335$var$RELAY_RESOLVER_VALUE_KEY, evaluationResult.resolverResult);
            $jO6uW.setValue(linkedRecord, $ba166f25139cb335$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $jO6uW.setValue(linkedRecord, $ba166f25139cb335$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = recordSource.get(recordID);
            !(currentRecord != null) && $q03Nf(false);
            var nextRecord = $jO6uW.clone(currentRecord);
            $jO6uW.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna;
                var fragmentStorageKey = $ba166f25139cb335$var$getStorageKey(field.fragment, variables);
                var resolverID = $ba166f25139cb335$var$generateClientID(recordID, fragmentStorageKey);
                $ba166f25139cb335$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $ba166f25139cb335$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna = evaluationResult.snapshot) === null || _evaluationResult$sna === void 0 ? void 0 : _evaluationResult$sna.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $ba166f25139cb335$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $ba166f25139cb335$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        }
        var answer = $jO6uW.getValue(linkedRecord, $ba166f25139cb335$var$RELAY_RESOLVER_VALUE_KEY);
        var snapshot = $jO6uW.getValue(linkedRecord, $ba166f25139cb335$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $jO6uW.getValue(linkedRecord, $ba166f25139cb335$var$RELAY_RESOLVER_ERROR_KEY);
        return [
            answer,
            linkedID,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto2.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var _iterator2 = (0, $ba166f25139cb335$var$_createForOfIteratorHelper2["default"])((_this$_recordIDToReso = this._recordIDToResolverIDs.get(recordID)) !== null && _this$_recordIDToReso !== void 0 ? _this$_recordIDToReso : $ba166f25139cb335$var$emptySet), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _this$_recordIDToReso;
                    var fragment = _step2.value;
                    if (!visited.has(fragment)) {
                        var _iterator3 = (0, $ba166f25139cb335$var$_createForOfIteratorHelper2["default"])((_this$_resolverIDToRe = this._resolverIDToRecordIDs.get(fragment)) !== null && _this$_resolverIDToRe !== void 0 ? _this$_resolverIDToRe : $ba166f25139cb335$var$emptySet), _step3;
                        try {
                            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                var _this$_resolverIDToRe;
                                var anotherRecordID = _step3.value;
                                this._markInvalidatedResolverRecord(anotherRecordID, recordSource, updatedDataIDs);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator3.e(err);
                        } finally{
                            _iterator3.f();
                        }
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
    };
    _proto2._markInvalidatedResolverRecord = function _markInvalidatedResolverRecord(dataID, recordSource, updatedDataIDs) {
        var record = recordSource.get(dataID);
        if (!record) return;
        var nextRecord = $jO6uW.clone(record);
        $jO6uW.setValue(nextRecord, $ba166f25139cb335$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
        recordSource.set(dataID, nextRecord);
    };
    _proto2._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$jO6uW.getValue(record, $ba166f25139cb335$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $jO6uW.getValue(record, $ba166f25139cb335$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $kU32t(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($ek4t1.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $jO6uW.clone(record);
            $jO6uW.setValue(nextRecord, $ba166f25139cb335$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($jO6uW.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto2.ensureClientRecord = function ensureClientRecord(id, typename) {
        $q03Nf(false);
    };
    _proto2.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        $q03Nf(false);
    };
    return RecordResolverCache;
}();
module.exports = {
    NoopResolverCache: $ba166f25139cb335$var$NoopResolverCache,
    RecordResolverCache: $ba166f25139cb335$var$RecordResolverCache
};

});

parcelRegister("lQmu3", function(module, exports) {
'use strict';

var $befAO = parcelRequire("befAO");

var $fe6fe5160f802599$var$getFragment = $befAO.getFragment;

var $75e3H = parcelRequire("75e3H");

var $fe6fe5160f802599$var$getSelector = $75e3H.getSelector;

var $q03Nf = parcelRequire("q03Nf");

var $fe6fe5160f802599$var$contextStack = [];
function $fe6fe5160f802599$var$withResolverContext(context, cb) {
    $fe6fe5160f802599$var$contextStack.push(context);
    try {
        return cb();
    } finally{
        $fe6fe5160f802599$var$contextStack.pop();
    }
}
function $fe6fe5160f802599$var$readFragment(fragmentInput, fragmentKey) {
    if (!$fe6fe5160f802599$var$contextStack.length) throw new Error('readFragment should be called only from within a Relay Resolver function.');
    var context = $fe6fe5160f802599$var$contextStack[$fe6fe5160f802599$var$contextStack.length - 1];
    var fragmentNode = $fe6fe5160f802599$var$getFragment(fragmentInput);
    var fragmentSelector = $fe6fe5160f802599$var$getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && $q03Nf(false);
    !(fragmentSelector.kind === 'SingularReaderSelector') && $q03Nf(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData;
    if (isMissingData) throw $fe6fe5160f802599$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL;
    return data;
}
var $fe6fe5160f802599$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL = {};
module.exports = {
    readFragment: $fe6fe5160f802599$var$readFragment,
    withResolverContext: $fe6fe5160f802599$var$withResolverContext,
    RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL: $fe6fe5160f802599$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL
};

});

parcelRegister("j7VPM", function(module, exports) {
'use strict';
var $decb8868a2530770$var$ITERATOR_KEY = Symbol.iterator;
function $decb8868a2530770$var$hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$decb8868a2530770$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $decb8868a2530770$var$hasOverlappingIDs;

});

parcelRegister("6fWGE", function(module, exports) {
'use strict';

var $jZOVE = parcelRequire("jZOVE");

var $48e1aacc1d26566b$var$ROOT_ID = $jZOVE.ROOT_ID;

var $1uPIp = parcelRequire("1uPIp");

var $48e1aacc1d26566b$var$VIEWER_ID = $1uPIp.VIEWER_ID;
var $48e1aacc1d26566b$var$ITERATOR_KEY = Symbol.iterator;
function $48e1aacc1d26566b$var$hasSignificantOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$48e1aacc1d26566b$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key) && key !== $48e1aacc1d26566b$var$ROOT_ID && key !== $48e1aacc1d26566b$var$VIEWER_ID) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $48e1aacc1d26566b$var$hasSignificantOverlappingIDs;

});

parcelRegister("6sxJX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fw9LG = parcelRequire("fw9LG");

const $bdcfd05ec26a65b1$export$a8ba9111c7eec9ac = (props, coordinationOptions)=>{
    return Boolean(coordinationOptions?.enableChoreographer) && props?.messageType !== undefined && (0, $fw9LG.IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
};
const $bdcfd05ec26a65b1$export$51d40de083bcc6e7 = (Component)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedRender: withChoreographedRender, ...props }) {
        const ChoreographedComponent = (0, $42omo.useMemo)(()=>withChoreographedRender(Component), [
            withChoreographedRender
        ]);
        if (shouldBeChoreographedProp(props)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ChoreographedComponent, rest);
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, rest);
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};
const $bdcfd05ec26a65b1$export$7c574bc7a8b74124 = (Component, toggleableProp)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedToggle: withChoreographedToggle, ...props }) {
        const ChoreographedComponent = (0, $42omo.useMemo)(()=>withChoreographedToggle(Component, toggleableProp), [
            withChoreographedToggle
        ]);
        if (shouldBeChoreographedProp(props, toggleableProp)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ChoreographedComponent, rest);
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, rest);
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};
module.exports["shouldBeChoreographed"] = $bdcfd05ec26a65b1$export$a8ba9111c7eec9ac;
module.exports["wrapComponentForChoreographer"] = $bdcfd05ec26a65b1$export$51d40de083bcc6e7;
module.exports["wrapToggleableComponentForChoreographer"] = $bdcfd05ec26a65b1$export$7c574bc7a8b74124;

});

parcelRegister("fJEl2", function(module, exports) {
/**
 * Returns `true` if window is currently nested within an iframe.
 */ function $f1ec1dd6a07d3253$export$e6c5ffa684aac4d7() {
    return window.self !== window.top;
}
module.exports["isIframe"] = $f1ec1dd6a07d3253$export$e6c5ffa684aac4d7;

});

parcelRegister("feHMU", function(module, exports) {
const $62c50a6d094c49db$export$ad4be5c2ec28cecf = (obj)=>obj instanceof $62c50a6d094c49db$export$2e2bcd8739ae039 || !!obj?._isAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'AnalyticsEvent';
class $62c50a6d094c49db$export$2e2bcd8739ae039 {
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
    constructor(props){
        this.payload = void 0;
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $62c50a6d094c49db$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
}
module.exports["default"] = $62c50a6d094c49db$export$2e2bcd8739ae039;

});

parcelRegister("dd2fS", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $163bef83c88d2a98$export$cad4fa6c249bffe = ()=>{
    if ((0, $9wGTI.fg)('confluence_nav4_ga_phase_2')) //if phase 2 is enabled ignore all opt out
    return true;
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('confluence_nav_4')) //fire the query if nav4 is enabled
    return false;
    if ((0, $9wGTI.fg)('confluence_nav4_ga_phase_1')) //if nav4 is disabled, but phase 1 is enabled, check the opt status
    return false; //should still skip if admin opt in is enabled
    return true;
};
const $163bef83c88d2a98$var$hasAccess = (accessStatus)=>![
        (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS,
        null
    ].includes(accessStatus);
const $163bef83c88d2a98$export$d7e12273c5b6a967 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    // Should skip for anonymous and unlicensed users as userPreferences will return error in those cases
    return {
        shouldSkipOptOutQuery: !$163bef83c88d2a98$var$hasAccess(accessStatus) || $163bef83c88d2a98$export$cad4fa6c249bffe()
    };
};
module.exports["useShouldSkipOptOutQuery"] = $163bef83c88d2a98$export$d7e12273c5b6a967;

});

parcelRegister("4GzBp", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $5v4fk = parcelRequire("5v4fk");
var $jLTuK = parcelRequire("jLTuK");

function $3696b38e63268258$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $3696b38e63268258$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $3696b38e63268258$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $hXuPC.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $hXuPC.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $3696b38e63268258$export$943d544ad120494a = function(_super) {
    (0, $hXuPC.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $3696b38e63268258$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $3696b38e63268258$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $3696b38e63268258$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $jLTuK.default)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $5v4fk.ApolloLink));
module.exports["RetryLink"] = $3696b38e63268258$export$943d544ad120494a;

});

parcelRegister("cRYpA", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $59e51e74b68fd68c$export$359ef83116415c8a = (0, $eSUdr.default)`mutation UpdateLocalStorageMutation($storageinput:LocalStorageInput!$stringKeys:[String]!){updateLocalStorage(localStorage:$storageinput){stringValues(keys:$stringKeys){key value}}}`;
module.exports["UpdateLocalStorageMutation"] = $59e51e74b68fd68c$export$359ef83116415c8a;

});

parcelRegister("gwDx5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4XvZj = parcelRequire("4XvZj");

class $c07e4cdd13d42343$var$EvaluationStore {
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $4XvZj._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a;
        if (!result) return false;
        const values = (0, $4XvZj._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $4XvZj.SDKFlags.setFlags(this._sdkKey, (_a = values.sdk_flags) !== null && _a !== void 0 ? _a : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getConfigList() {
        var _a;
        if (!((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs)) return [];
        return Object.values(this._values.dynamic_configs).map((config)=>config.name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.exposures;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $4XvZj._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $4XvZj.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $4XvZj._getFullUserHash)(userForComparison) !== (0, $4XvZj._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
}
module.exports.default = $c07e4cdd13d42343$var$EvaluationStore;

});

parcelRegister("8SuEO", function(module, exports) {
"use strict";
var $676b25c2198ad891$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4XvZj = parcelRequire("4XvZj");


var $9F3aL = parcelRequire("9F3aL");

class $676b25c2198ad891$var$StatsigNetwork extends $4XvZj.NetworkCore {
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $676b25c2198ad891$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $4XvZj._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $676b25c2198ad891$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $9F3aL._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $4XvZj.UrlConfiguration($4XvZj.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
}
module.exports.default = $676b25c2198ad891$var$StatsigNetwork;

});

parcelRegister("coFhs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $4XvZj = parcelRequire("4XvZj");

const $9067bf69d0d55a2d$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $9067bf69d0d55a2d$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $9067bf69d0d55a2d$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $4XvZj._isTypeMatch)(value, fallback);
}
function $9067bf69d0d55a2d$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $9067bf69d0d55a2d$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $9067bf69d0d55a2d$var$_shouldLogExposure(options) ? undefined : $9067bf69d0d55a2d$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $9067bf69d0d55a2d$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $9067bf69d0d55a2d$var$_shouldLogExposure(options) ? undefined : $9067bf69d0d55a2d$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($9067bf69d0d55a2d$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $9067bf69d0d55a2d$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $9067bf69d0d55a2d$var$_shouldLogExposure(options) ? undefined : $9067bf69d0d55a2d$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($9067bf69d0d55a2d$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $9067bf69d0d55a2d$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $9067bf69d0d55a2d$var$_shouldLogExposure(options) ? undefined : $9067bf69d0d55a2d$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($9067bf69d0d55a2d$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $9067bf69d0d55a2d$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $4XvZj._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $9067bf69d0d55a2d$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $9067bf69d0d55a2d$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $9067bf69d0d55a2d$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $9067bf69d0d55a2d$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $9067bf69d0d55a2d$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $9067bf69d0d55a2d$var$_makeParamStoreGetter;

});

parcelRegister("2HQ4d", function(module, exports) {
"use strict";
var $1f87fc5178b9b8aa$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $4XvZj = parcelRequire("4XvZj");


var $8SuEO = parcelRequire("8SuEO");

class $1f87fc5178b9b8aa$var$StatsigEvaluationsDataAdapter extends $4XvZj.DataAdapterCore {
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $8SuEO.default) this._network = network;
        else this._network = new $8SuEO.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $4XvZj._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $4XvZj._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $4XvZj.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $1f87fc5178b9b8aa$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $4XvZj._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$4XvZj.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $4XvZj._getFullUserHash)(user);
    }
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
}
module.exports.StatsigEvaluationsDataAdapter = $1f87fc5178b9b8aa$var$StatsigEvaluationsDataAdapter;

});

parcelRegister("lRdu3", function(module, exports) {

var $cFL8p = parcelRequire("cFL8p");


var $bUdvl = parcelRequire("bUdvl");


var $frFLQ = parcelRequire("frFLQ");


var $1DJfC = parcelRequire("1DJfC");


var $gB1dC = parcelRequire("gB1dC");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fe9901cd241e3d51$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$fe9901cd241e3d51$var$Hash.prototype.clear = $cFL8p;
$fe9901cd241e3d51$var$Hash.prototype['delete'] = $bUdvl;
$fe9901cd241e3d51$var$Hash.prototype.get = $frFLQ;
$fe9901cd241e3d51$var$Hash.prototype.has = $1DJfC;
$fe9901cd241e3d51$var$Hash.prototype.set = $gB1dC;
module.exports = $fe9901cd241e3d51$var$Hash;

});

parcelRegister("2JXSR", function(module, exports) {

var $bnEma = parcelRequire("bnEma");


var $iVowk = parcelRequire("iVowk");


var $2PnXJ = parcelRequire("2PnXJ");


var $d3Lhu = parcelRequire("d3Lhu");


var $bnKrz = parcelRequire("bnKrz");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1fee3c6ad455bde0$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$1fee3c6ad455bde0$var$ListCache.prototype.clear = $bnEma;
$1fee3c6ad455bde0$var$ListCache.prototype['delete'] = $iVowk;
$1fee3c6ad455bde0$var$ListCache.prototype.get = $2PnXJ;
$1fee3c6ad455bde0$var$ListCache.prototype.has = $d3Lhu;
$1fee3c6ad455bde0$var$ListCache.prototype.set = $bnKrz;
module.exports = $1fee3c6ad455bde0$var$ListCache;

});

parcelRegister("9w7HK", function(module, exports) {

var $3Qi0V = parcelRequire("3Qi0V");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $6edd14335b1f5736$var$getMapData(map, key) {
    var data = map.__data__;
    return $3Qi0V(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $6edd14335b1f5736$var$getMapData;

});

parcelRegister("1f2d6", function(module, exports) {

var $jCOpB = parcelRequire("jCOpB");

/** Used to detect methods masquerading as native. */ var $0e78e813c480d3e5$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($jCOpB && $jCOpB.keys && $jCOpB.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $0e78e813c480d3e5$var$isMasked(func) {
    return !!$0e78e813c480d3e5$var$maskSrcKey && $0e78e813c480d3e5$var$maskSrcKey in func;
}
module.exports = $0e78e813c480d3e5$var$isMasked;

});

parcelRegister("feUp7", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $b183ea7d7496ba0f$export$896afd8541959ee5);
var $b183ea7d7496ba0f$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($b183ea7d7496ba0f$export$896afd8541959ee5 || ($b183ea7d7496ba0f$export$896afd8541959ee5 = {}));

});

parcelRegister("5z7oK", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $feUp7 = parcelRequire("feUp7");


var $jvvYq = parcelRequire("jvvYq");


var $cSfeu = parcelRequire("cSfeu");

parcelRequire("eqdqo");
var $4Duar = parcelRequire("4Duar");
var $alwPZ = parcelRequire("alwPZ");


var $isEVw = parcelRequire("isEVw");

var $40d5f5c054d39ca1$var$_a;
var $40d5f5c054d39ca1$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $cSfeu.SPACE_SEPARATOR_REGEX).source, "*"));
var $40d5f5c054d39ca1$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $cSfeu.SPACE_SEPARATOR_REGEX).source, "*$"));
function $40d5f5c054d39ca1$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $40d5f5c054d39ca1$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $40d5f5c054d39ca1$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $40d5f5c054d39ca1$var$hasNativeFromEntries = !!Object.fromEntries;
var $40d5f5c054d39ca1$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $40d5f5c054d39ca1$var$hasTrimStart = !!String.prototype.trimStart;
var $40d5f5c054d39ca1$var$hasTrimEnd = !!String.prototype.trimEnd;
var $40d5f5c054d39ca1$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $40d5f5c054d39ca1$var$isSafeInteger = $40d5f5c054d39ca1$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $40d5f5c054d39ca1$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $40d5f5c054d39ca1$var$re = $40d5f5c054d39ca1$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $40d5f5c054d39ca1$var$REGEX_SUPPORTS_U_AND_Y = (($40d5f5c054d39ca1$var$_a = $40d5f5c054d39ca1$var$re.exec('a')) === null || $40d5f5c054d39ca1$var$_a === void 0 ? void 0 : $40d5f5c054d39ca1$var$_a[0]) === 'a';
} catch (_) {
    $40d5f5c054d39ca1$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $40d5f5c054d39ca1$var$startsWith = $40d5f5c054d39ca1$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $40d5f5c054d39ca1$var$fromCodePoint = $40d5f5c054d39ca1$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $40d5f5c054d39ca1$var$fromEntries = // native
$40d5f5c054d39ca1$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $40d5f5c054d39ca1$var$codePointAt = $40d5f5c054d39ca1$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $40d5f5c054d39ca1$var$trimStart = $40d5f5c054d39ca1$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($40d5f5c054d39ca1$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $40d5f5c054d39ca1$var$trimEnd = $40d5f5c054d39ca1$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($40d5f5c054d39ca1$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $40d5f5c054d39ca1$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $40d5f5c054d39ca1$var$matchIdentifierAtIndex;
if ($40d5f5c054d39ca1$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $40d5f5c054d39ca1$var$IDENTIFIER_PREFIX_RE_1 = $40d5f5c054d39ca1$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $40d5f5c054d39ca1$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $40d5f5c054d39ca1$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $40d5f5c054d39ca1$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$40d5f5c054d39ca1$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $40d5f5c054d39ca1$var$codePointAt(s, index);
        if (c === undefined || $40d5f5c054d39ca1$var$_isWhiteSpace(c) || $40d5f5c054d39ca1$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $40d5f5c054d39ca1$var$fromCodePoint.apply(void 0, match);
};
var $40d5f5c054d39ca1$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $jvvYq.TYPE).pound,
                    location: $40d5f5c054d39ca1$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $feUp7.ErrorKind).UNMATCHED_CLOSING_TAG, $40d5f5c054d39ca1$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $40d5f5c054d39ca1$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $jvvYq.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $40d5f5c054d39ca1$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$40d5f5c054d39ca1$var$_isAlpha(this.char())) return this.error((0, $feUp7.ErrorKind).INVALID_TAG, $40d5f5c054d39ca1$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $feUp7.ErrorKind).UNMATCHED_CLOSING_TAG, $40d5f5c054d39ca1$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $feUp7.ErrorKind).INVALID_TAG, $40d5f5c054d39ca1$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $jvvYq.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $40d5f5c054d39ca1$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $feUp7.ErrorKind).UNCLOSED_TAG, $40d5f5c054d39ca1$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $feUp7.ErrorKind).INVALID_TAG, $40d5f5c054d39ca1$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $40d5f5c054d39ca1$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $40d5f5c054d39ca1$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $jvvYq.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$40d5f5c054d39ca1$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $40d5f5c054d39ca1$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $40d5f5c054d39ca1$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $feUp7.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $40d5f5c054d39ca1$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $feUp7.ErrorKind).EMPTY_ARGUMENT, $40d5f5c054d39ca1$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $feUp7.ErrorKind).MALFORMED_ARGUMENT, $40d5f5c054d39ca1$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $feUp7.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $40d5f5c054d39ca1$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $jvvYq.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $40d5f5c054d39ca1$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $feUp7.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $40d5f5c054d39ca1$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $feUp7.ErrorKind).MALFORMED_ARGUMENT, $40d5f5c054d39ca1$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $40d5f5c054d39ca1$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $40d5f5c054d39ca1$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $feUp7.ErrorKind).EXPECT_ARGUMENT_TYPE, $40d5f5c054d39ca1$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $40d5f5c054d39ca1$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $feUp7.ErrorKind).EXPECT_ARGUMENT_STYLE, $40d5f5c054d39ca1$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $40d5f5c054d39ca1$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $40d5f5c054d39ca1$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $40d5f5c054d39ca1$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $40d5f5c054d39ca1$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $jvvYq.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $feUp7.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $isEVw.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $jvvYq.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $4Duar.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $jvvYq.TYPE).date : (0, $jvvYq.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $jvvYq.TYPE).number : argType === 'date' ? (0, $jvvYq.TYPE).date : (0, $jvvYq.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $feUp7.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $40d5f5c054d39ca1$var$createLocation(typeEndPosition_1, (0, $hXuPC.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $feUp7.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $40d5f5c054d39ca1$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $feUp7.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $feUp7.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $40d5f5c054d39ca1$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $jvvYq.TYPE).select,
                        value: value,
                        options: $40d5f5c054d39ca1$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $jvvYq.TYPE).plural,
                        value: value,
                        options: $40d5f5c054d39ca1$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $feUp7.ErrorKind).INVALID_ARGUMENT_TYPE, $40d5f5c054d39ca1$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $feUp7.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $40d5f5c054d39ca1$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $feUp7.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $40d5f5c054d39ca1$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $alwPZ.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $feUp7.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $jvvYq.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $alwPZ.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $feUp7.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $feUp7.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $40d5f5c054d39ca1$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $feUp7.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $feUp7.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $feUp7.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $feUp7.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $40d5f5c054d39ca1$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $40d5f5c054d39ca1$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $feUp7.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $feUp7.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $40d5f5c054d39ca1$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $feUp7.ErrorKind).MISSING_OTHER_CLAUSE, $40d5f5c054d39ca1$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $40d5f5c054d39ca1$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$40d5f5c054d39ca1$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $40d5f5c054d39ca1$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($40d5f5c054d39ca1$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $40d5f5c054d39ca1$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $40d5f5c054d39ca1$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $40d5f5c054d39ca1$var$_isAlphaOrSlash(codepoint) {
    return $40d5f5c054d39ca1$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $40d5f5c054d39ca1$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $40d5f5c054d39ca1$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $40d5f5c054d39ca1$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}
module.exports["Parser"] = $40d5f5c054d39ca1$export$7acfa6ed01010e37;

});

parcelRegister("9zwU2", function(module, exports) {
'use strict';

var $bLmKG = parcelRequire("bLmKG");


var $aahHV = parcelRequire("aahHV");

/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $6f80e7be09ddfbc4$var$$typedArrayBuffer = $aahHV('TypedArray.prototype.buffer', true);

var $7vkYj = parcelRequire("7vkYj");

/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $6f80e7be09ddfbc4$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$7vkYj(x)) throw new $bLmKG('Not a Typed Array');
    return x.buffer;
};

});

parcelRegister("kexZs", function(module, exports) {

var $eI8vp = parcelRequire("eI8vp");

var $ebaf7b3748aa3a4d$require$Buffer = $eI8vp.Buffer;

var $DPs2c = parcelRequire("DPs2c");

/* eslint-disable camelcase */ function $ebaf7b3748aa3a4d$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$ebaf7b3748aa3a4d$require$Buffer.isBuffer(password)) password = $ebaf7b3748aa3a4d$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$ebaf7b3748aa3a4d$require$Buffer.isBuffer(salt)) salt = $ebaf7b3748aa3a4d$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $ebaf7b3748aa3a4d$require$Buffer.alloc(keyLen);
    var iv = $ebaf7b3748aa3a4d$require$Buffer.alloc(ivLen || 0);
    var tmp = $ebaf7b3748aa3a4d$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $DPs2c();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $ebaf7b3748aa3a4d$var$EVP_BytesToKey;

});

parcelRegister("a8UB9", function(module, exports) {
$parcel$export(module.exports, "createCipheriv", () => $76268df937855c7e$export$2f64596b8cbf08b4, (v) => $76268df937855c7e$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $76268df937855c7e$export$bdd223f16383713e, (v) => $76268df937855c7e$export$bdd223f16383713e = v);
var $76268df937855c7e$export$2f64596b8cbf08b4;
var $76268df937855c7e$export$bdd223f16383713e;

var $e6oz7 = parcelRequire("e6oz7");


var $j1r2v = parcelRequire("j1r2v");


var $eI8vp = parcelRequire("eI8vp");

var $76268df937855c7e$require$Buffer = $eI8vp.Buffer;

var $1TyDJ = parcelRequire("1TyDJ");


var $3xrS3 = parcelRequire("3xrS3");


var $b4qBY = parcelRequire("b4qBY");


var $kexZs = parcelRequire("kexZs");


var $dMzRp = parcelRequire("dMzRp");

function $76268df937855c7e$var$Cipher(mode, key, iv) {
    $3xrS3.call(this);
    this._cache = new $76268df937855c7e$var$Splitter();
    this._cipher = new $b4qBY.AES(key);
    this._prev = $76268df937855c7e$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dMzRp($76268df937855c7e$var$Cipher, $3xrS3);
$76268df937855c7e$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $76268df937855c7e$require$Buffer.concat(out);
};
var $76268df937855c7e$var$PADDING = $76268df937855c7e$require$Buffer.alloc(16, 0x10);
$76268df937855c7e$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($76268df937855c7e$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$76268df937855c7e$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $76268df937855c7e$var$Splitter() {
    this.cache = $76268df937855c7e$require$Buffer.allocUnsafe(0);
}
$76268df937855c7e$var$Splitter.prototype.add = function(data) {
    this.cache = $76268df937855c7e$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$76268df937855c7e$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$76268df937855c7e$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $76268df937855c7e$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $76268df937855c7e$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $76268df937855c7e$var$createCipheriv(suite, password, iv) {
    var config = $e6oz7[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $76268df937855c7e$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $76268df937855c7e$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $1TyDJ(config.module, password, iv);
    else if (config.type === 'auth') return new $j1r2v(config.module, password, iv);
    return new $76268df937855c7e$var$Cipher(config.module, password, iv);
}
function $76268df937855c7e$var$createCipher(suite, password) {
    var config = $e6oz7[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $kexZs(password, false, config.key, config.iv);
    return $76268df937855c7e$var$createCipheriv(suite, keys.key, keys.iv);
}
$76268df937855c7e$export$2f64596b8cbf08b4 = $76268df937855c7e$var$createCipheriv;
$76268df937855c7e$export$bdd223f16383713e = $76268df937855c7e$var$createCipher;

});

parcelRegister("f8jd9", function(module, exports) {
$parcel$export(module.exports, "createDecipher", () => $b046814917e3de66$export$12ada9414fbc594c, (v) => $b046814917e3de66$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $b046814917e3de66$export$36b6d6ef312eab39, (v) => $b046814917e3de66$export$36b6d6ef312eab39 = v);
var $b046814917e3de66$export$12ada9414fbc594c;
var $b046814917e3de66$export$36b6d6ef312eab39;

var $j1r2v = parcelRequire("j1r2v");


var $eI8vp = parcelRequire("eI8vp");

var $b046814917e3de66$require$Buffer = $eI8vp.Buffer;

var $e6oz7 = parcelRequire("e6oz7");


var $1TyDJ = parcelRequire("1TyDJ");


var $3xrS3 = parcelRequire("3xrS3");


var $b4qBY = parcelRequire("b4qBY");


var $kexZs = parcelRequire("kexZs");


var $dMzRp = parcelRequire("dMzRp");

function $b046814917e3de66$var$Decipher(mode, key, iv) {
    $3xrS3.call(this);
    this._cache = new $b046814917e3de66$var$Splitter();
    this._last = void 0;
    this._cipher = new $b4qBY.AES(key);
    this._prev = $b046814917e3de66$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dMzRp($b046814917e3de66$var$Decipher, $3xrS3);
$b046814917e3de66$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $b046814917e3de66$require$Buffer.concat(out);
};
$b046814917e3de66$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $b046814917e3de66$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$b046814917e3de66$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $b046814917e3de66$var$Splitter() {
    this.cache = $b046814917e3de66$require$Buffer.allocUnsafe(0);
}
$b046814917e3de66$var$Splitter.prototype.add = function(data) {
    this.cache = $b046814917e3de66$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$b046814917e3de66$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$b046814917e3de66$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $b046814917e3de66$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $b046814917e3de66$var$createDecipheriv(suite, password, iv) {
    var config = $e6oz7[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $b046814917e3de66$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $b046814917e3de66$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $1TyDJ(config.module, password, iv, true);
    else if (config.type === 'auth') return new $j1r2v(config.module, password, iv, true);
    return new $b046814917e3de66$var$Decipher(config.module, password, iv);
}
function $b046814917e3de66$var$createDecipher(suite, password) {
    var config = $e6oz7[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $kexZs(password, false, config.key, config.iv);
    return $b046814917e3de66$var$createDecipheriv(suite, keys.key, keys.iv);
}
$b046814917e3de66$export$12ada9414fbc594c = $b046814917e3de66$var$createDecipher;
$b046814917e3de66$export$36b6d6ef312eab39 = $b046814917e3de66$var$createDecipheriv;

});

parcelRegister("fcAZM", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});

parcelRegister("6hOPx", function(module, exports) {
$parcel$export(module.exports, "default", () => $493bc27139063f90$export$2e2bcd8739ae039);

var $4gVDY = parcelRequire("4gVDY");

function $493bc27139063f90$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $4gVDY.default)());
}

});

parcelRegister("1idVR", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f12478d1dfd871a$export$2e2bcd8739ae039);

var $abBQX = parcelRequire("abBQX");

function $0f12478d1dfd871a$export$2e2bcd8739ae039(element) {
    return (0, $abBQX.default)(element).getComputedStyle(element);
}

});

parcelRegister("9Vrvx", function(module, exports) {
$parcel$export(module.exports, "default", () => $739ec65c1d807073$export$2e2bcd8739ae039);

var $62QMc = parcelRequire("62QMc");


var $l3Xsd = parcelRequire("l3Xsd");


var $2X8fC = parcelRequire("2X8fC");


var $kXrr0 = parcelRequire("kXrr0");

function $739ec65c1d807073$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $2X8fC.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $kXrr0.isHTMLElement)(node) && (0, $l3Xsd.default)(node)) return node;
    return $739ec65c1d807073$export$2e2bcd8739ae039((0, $62QMc.default)(node));
}

});

parcelRegister("62QMc", function(module, exports) {
$parcel$export(module.exports, "default", () => $466bde478445501b$export$2e2bcd8739ae039);

var $2X8fC = parcelRequire("2X8fC");


var $cBZBQ = parcelRequire("cBZBQ");


var $kXrr0 = parcelRequire("kXrr0");

function $466bde478445501b$export$2e2bcd8739ae039(element) {
    if ((0, $2X8fC.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $kXrr0.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $cBZBQ.default)(element) // fallback
    );
}

});

parcelRegister("hHrtd", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce2bc2d7880d346e$export$2e2bcd8739ae039);

var $2X8fC = parcelRequire("2X8fC");

function $ce2bc2d7880d346e$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $2X8fC.default)(element)) >= 0;
}

});

parcelRegister("4gVDY", function(module, exports) {
$parcel$export(module.exports, "default", () => $31c55eeab7f266cb$export$2e2bcd8739ae039);
function $31c55eeab7f266cb$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});

parcelRegister("lkswr", function(module, exports) {
$parcel$export(module.exports, "default", () => $f871972e14b10beb$export$2e2bcd8739ae039);

var $eX4ca = parcelRequire("eX4ca");


var $ebcOQ = parcelRequire("ebcOQ");


var $dSq7f = parcelRequire("dSq7f");


var $j6Wo8 = parcelRequire("j6Wo8");


var $d90wo = parcelRequire("d90wo");


var $cBZBQ = parcelRequire("cBZBQ");


var $1idVR = parcelRequire("1idVR");


var $kXrr0 = parcelRequire("kXrr0");


var $5PD23 = parcelRequire("5PD23");


var $62QMc = parcelRequire("62QMc");


var $7bTYu = parcelRequire("7bTYu");


var $2X8fC = parcelRequire("2X8fC");


var $itoGF = parcelRequire("itoGF");


var $fEu2C = parcelRequire("fEu2C");

function $f871972e14b10beb$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $5PD23.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $f871972e14b10beb$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $eX4ca.viewport) ? (0, $itoGF.default)((0, $ebcOQ.default)(element, strategy)) : (0, $kXrr0.isElement)(clippingParent) ? $f871972e14b10beb$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $itoGF.default)((0, $dSq7f.default)((0, $cBZBQ.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $f871972e14b10beb$var$getClippingParents(element) {
    var clippingParents = (0, $j6Wo8.default)((0, $62QMc.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $1idVR.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $kXrr0.isHTMLElement)(element) ? (0, $d90wo.default)(element) : element;
    if (!(0, $kXrr0.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $kXrr0.isElement)(clippingParent) && (0, $7bTYu.default)(clippingParent, clipperElement) && (0, $2X8fC.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $f871972e14b10beb$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $f871972e14b10beb$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $f871972e14b10beb$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $fEu2C.max)(rect.top, accRect.top);
        accRect.right = (0, $fEu2C.min)(rect.right, accRect.right);
        accRect.bottom = (0, $fEu2C.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $fEu2C.max)(rect.left, accRect.left);
        return accRect;
    }, $f871972e14b10beb$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});

parcelRegister("gjl0U", function(module, exports) {
$parcel$export(module.exports, "default", () => $bdfeb88c577e710e$export$2e2bcd8739ae039);

var $gLRTP = parcelRequire("gLRTP");


var $fd6rO = parcelRequire("fd6rO");


var $7ONHI = parcelRequire("7ONHI");


var $eX4ca = parcelRequire("eX4ca");

function $bdfeb88c577e710e$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $gLRTP.default)(placement) : null;
    var variation = placement ? (0, $fd6rO.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $eX4ca.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $eX4ca.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $eX4ca.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $eX4ca.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $7ONHI.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $eX4ca.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $eX4ca.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});

parcelRegister("itoGF", function(module, exports) {
$parcel$export(module.exports, "default", () => $d72e15c814e9f0b4$export$2e2bcd8739ae039);
function $d72e15c814e9f0b4$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});

parcelRegister("jD11d", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4a2731e2f7c1e1e$export$2e2bcd8739ae039);

var $lFhaR = parcelRequire("lFhaR");

function $e4a2731e2f7c1e1e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $lFhaR.default)(), paddingObject);
}

});

parcelRegister("ge7rQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd03bb2f2c59201a$export$2e2bcd8739ae039);
function $bd03bb2f2c59201a$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});

parcelRegister("k1o7W", function(module, exports) {

var $lpdFp = parcelRequire("lpdFp");


var $1GFh6 = parcelRequire("1GFh6");


var $cdwZR = parcelRequire("cdwZR");

var $e9369dca49a20205$export$85710b12cf912438 = 'NEW_FOCUS';
var $e9369dca49a20205$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $cdwZR.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $e9369dca49a20205$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $e9369dca49a20205$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $lpdFp.correctNodes)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $1GFh6.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $1GFh6.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};
module.exports["NEW_FOCUS"] = $e9369dca49a20205$export$85710b12cf912438;
module.exports["newFocus"] = $e9369dca49a20205$export$65842178e9bb4205;

});

parcelRegister("gusZk", function(module, exports) {

var $9OOUs = parcelRequire("9OOUs");


var $1GFh6 = parcelRequire("1GFh6");


var $cdwZR = parcelRequire("cdwZR");

var $c015ef25631d77cf$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $cdwZR.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $c015ef25631d77cf$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $9OOUs.filterAutoFocusable)(nodes.filter($c015ef25631d77cf$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $1GFh6.pickFirstFocus)(autoFocusable);
    return (0, $1GFh6.pickFirstFocus)((0, $9OOUs.filterAutoFocusable)(orderedNodes));
};
module.exports["pickAutofocus"] = $c015ef25631d77cf$export$cfb742983e257555;

});

parcelRegister("gnzSa", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $66utD = parcelRequire("66utD");


var $i4gTI = parcelRequire("i4gTI");


var $jzO5W = parcelRequire("jzO5W");


var $cmcCB = parcelRequire("cmcCB");


var $btsNM = parcelRequire("btsNM");


var $iMQqx = parcelRequire("iMQqx");

const $2d31ea8c6d57dfbd$var$globalState = {
    isActive: false
};
function $2d31ea8c6d57dfbd$var$canStart() {
    return !$2d31ea8c6d57dfbd$var$globalState.isActive;
}
function $2d31ea8c6d57dfbd$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $2d31ea8c6d57dfbd$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $2d31ea8c6d57dfbd$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$2d31ea8c6d57dfbd$var$canStart()) return;
    const initial = $2d31ea8c6d57dfbd$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $2d31ea8c6d57dfbd$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $2d31ea8c6d57dfbd$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $iMQqx.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $2d31ea8c6d57dfbd$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $btsNM.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $i4gTI.isHoneyPotElement)(event.target) ? (0, $66utD.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $2d31ea8c6d57dfbd$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $2d31ea8c6d57dfbd$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $fFa3V.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $jzO5W.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
					 * At this point we don't know if a drag is being cancelled,
					 * or if a drag is leaving the `window`.
					 *
					 * Both have:
					 *   1. "dragleave" (with `relatedTarget: null`)
					 *   2. "dragend" (a "dragend" can occur when outside the `window`)
					 *
					 * **Clearing drop targets**
					 *
					 * For either case we are clearing the the drop targets
					 *
					 * - cancelling: we clear drop targets in `"dragend"` anyway
					 * - leaving the `window`: we clear the drop targets (to clear stickiness)
					 *
					 * **Leaving the window and finishing the drag**
					 *
					 * _internal drags_
					 *
					 * - The drag continues when the user is outside the `window`
					 *   and can resume if the user drags back over the `window`,
					 *   or end when the user drops in an external `window`.
					 * - We will get a `"dragend"`, or we can listen for other
					 *   events to determine the drag is finished when the user re-enters the `window`).
					 *
					 * _external drags_
					 *
					 * - We conclude the drag operation.
					 * - We have no idea if the user will drag back over the `window`,
					 *   or if the drag ends elsewhere.
					 * - We will create a new drag if the user re-enters the `window`.
					 *
					 * **Not updating `input`**
					 *
					 * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
					 * Workaround: intentionally not updating `input` in "dragleave"
					 * rather than the users current input values
					 * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
					 * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
					 **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $btsNM.getInput)(event)
                };
                /** If there are no drop targets, then we will get
					 * a "drop" event if:
					 * - `preventUnhandled()` is being used
					 * - there is an unmanaged drop target (eg another library)
					 * In these cases, it's up to the consumer
					 * to handle the drop if it's not over one of our drop targets
					 * - `preventUnhandled()` will cancel the "drop"
					 * - unmanaged drop targets can handle the "drop" how they want to
					 * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $2d31ea8c6d57dfbd$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $btsNM.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $cmcCB.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $2d31ea8c6d57dfbd$var$getNativeSetDragImage(event)
    });
}
function $2d31ea8c6d57dfbd$var$setDropEffectOnEvent({ event: event, current: current }) {
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = current[0]?.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $2d31ea8c6d57dfbd$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $btsNM.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $2d31ea8c6d57dfbd$export$3efdceeb8ca25c51 = {
    canStart: $2d31ea8c6d57dfbd$var$canStart,
    start: $2d31ea8c6d57dfbd$var$start
};
module.exports["lifecycle"] = $2d31ea8c6d57dfbd$export$3efdceeb8ca25c51;

});

parcelRegister("NVvMh", function(module, exports) {
const $84e48945a397d5d8$var$ledger = new Map();
function $84e48945a397d5d8$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $84e48945a397d5d8$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $84e48945a397d5d8$var$ledger.set(typeKey, initial);
    return initial;
}
function $84e48945a397d5d8$export$6503ec6e8aabbaf(args) {
    const entry = $84e48945a397d5d8$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $84e48945a397d5d8$var$ledger.delete(args.typeKey);
    };
}
module.exports["register"] = $84e48945a397d5d8$export$6503ec6e8aabbaf;

});

parcelRegister("3YPrz", function(module, exports) {

var $bSwyQ = parcelRequire("bSwyQ");


var $aYpzB = parcelRequire("aYpzB");


var $gz7GF = parcelRequire("gz7GF");

function $087df2c0a749e1c4$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $087df2c0a749e1c4$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        const cleanup = (0, $bSwyQ.combine)((0, $gz7GF.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $aYpzB.once)(cleanup);
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = args.getData?.(feedback) ?? {};
        const dropEffect = args.getDropEffect?.(feedback) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry?.[eventName]?.(// I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry?.onDropTargetChange?.(args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) entry?.onDragLeave?.(args);
            }
            for (const record of payload.location.current.dropTargets){
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry?.onDropTargetChange?.(args);
                entry?.onDragEnter?.(args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $087df2c0a749e1c4$var$copyReverse(current);
        const actualCaptureOrdered = $087df2c0a749e1c4$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if (parent?.element !== lastParent?.element) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!argsForLast.getIsSticky?.(feedback)) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $087df2c0a749e1c4$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}
module.exports["makeDropTarget"] = $087df2c0a749e1c4$export$47d10e7bd9c81890;

});

parcelRegister("cuaz9", function(module, exports) {

var $aYpzB = parcelRequire("aYpzB");

function $38c2157c450658b9$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $aYpzB.once)(cleanup);
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) // @ts-expect-error: I cannot get this type working!
        monitor[eventName]?.(payload);
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}
module.exports["makeMonitor"] = $38c2157c450658b9$export$5dd4ed888d5b12ca;

});

parcelRegister("gfc5m", function(module, exports) {

var $ah22M = parcelRequire("ah22M");


var $avOqW = parcelRequire("avOqW");


var $8ESDP = parcelRequire("8ESDP");

/** `Object#toString` result references. */ var $bd376c00da24fc2b$var$nullTag = '[object Null]', $bd376c00da24fc2b$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $bd376c00da24fc2b$var$symToStringTag = (0, $ah22M.default) ? (0, $ah22M.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $bd376c00da24fc2b$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $bd376c00da24fc2b$var$undefinedTag : $bd376c00da24fc2b$var$nullTag;
    return $bd376c00da24fc2b$var$symToStringTag && $bd376c00da24fc2b$var$symToStringTag in Object(value) ? (0, $avOqW.default)(value) : (0, $8ESDP.default)(value);
}
var $bd376c00da24fc2b$export$2e2bcd8739ae039 = $bd376c00da24fc2b$var$baseGetTag;
module.exports["default"] = $bd376c00da24fc2b$export$2e2bcd8739ae039;

});

parcelRegister("81QbB", function(module, exports) {

var $1GNVc = parcelRequire("1GNVc");

/** Built-in value references. */ var $5d86e5c8c58d1050$var$getPrototype = (0, $1GNVc.default)(Object.getPrototypeOf, Object);
var $5d86e5c8c58d1050$export$2e2bcd8739ae039 = $5d86e5c8c58d1050$var$getPrototype;
module.exports["default"] = $5d86e5c8c58d1050$export$2e2bcd8739ae039;

});

parcelRegister("fy8Dq", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $b520baae6ce76437$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $b520baae6ce76437$export$2e2bcd8739ae039 = $b520baae6ce76437$var$isObjectLike;
module.exports["default"] = $b520baae6ce76437$export$2e2bcd8739ae039;

});

parcelRegister("f7irG", function(module, exports) {
'use strict';
module.exports = {
    DEFAULT_HANDLE_KEY: ''
};

});

parcelRegister("jgNAy", function(module, exports) {

var $dMy3z = parcelRequire("dMy3z");

// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $e075fa3116464eff$var$createListenerCollection() {
    const batch = (0, $dMy3z.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $e075fa3116464eff$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $e075fa3116464eff$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $e075fa3116464eff$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $e075fa3116464eff$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $e075fa3116464eff$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
module.exports["createSubscription"] = $e075fa3116464eff$export$d567d2b9af322f8f;

});

parcelRegister("fUAun", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b95863eabeb18893$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $b95863eabeb18893$export$700979bc83e7db82 = $b95863eabeb18893$export$71594e8a50f746f4 ? $42omo.useLayoutEffect : $42omo.useEffect;
module.exports["useIsomorphicLayoutEffect"] = $b95863eabeb18893$export$700979bc83e7db82;

});

parcelRegister("35L13", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ldVC5 = parcelRequire("ldVC5");

function $24064f23fa4a6ef3$export$d4d6226d5fc61558(context = (0, $ldVC5.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $42omo.useContext)(context);
        return contextValue;
    };
}
const $24064f23fa4a6ef3$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $24064f23fa4a6ef3$export$d4d6226d5fc61558();
module.exports["createReduxContextHook"] = $24064f23fa4a6ef3$export$d4d6226d5fc61558;
module.exports["useReduxContext"] = $24064f23fa4a6ef3$export$c1275ca9a6fd3ec5;

});

parcelRegister("3A6oh", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $8HmnL = parcelRequire("8HmnL");

const $be70be676a6626b5$export$7c8f96a75ff5904 = async (url, { method: method, headers: headers, claimKey: claimKey }, passThrough)=>{
    if (!method || method.toUpperCase() !== 'GET') return passThrough();
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $8HmnL.getPreloadResult)().claim(claimKey ? {
            name: claimKey
        } : {
            name: url,
            variables: {
                method: method,
                ...headers
            }
        }, (result)=>{
            return result;
        }).then((data)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            if (!data) return passThrough();
            return data;
        });
    })();
};
module.exports["preloadedRestLink"] = $be70be676a6626b5$export$7c8f96a75ff5904;

});

parcelRegister("6lAfP", function(module, exports) {
'use strict';

var $befAO = parcelRequire("befAO");

var $49f0d393aea8c4da$var$getFragment = $befAO.getFragment;

var $75e3H = parcelRequire("75e3H");

var $49f0d393aea8c4da$var$getVariablesFromFragment = $75e3H.getVariablesFromFragment;

var $jZOVE = parcelRequire("jZOVE");

var $49f0d393aea8c4da$var$ID_KEY = $jZOVE.ID_KEY;

var $cquBl = parcelRequire("cquBl");

var $49f0d393aea8c4da$var$createUpdatableProxy = $cquBl.createUpdatableProxy;

var $q03Nf = parcelRequire("q03Nf");

function $49f0d393aea8c4da$var$readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = $49f0d393aea8c4da$var$getFragment(fragment);
    var fragmentVariables = $49f0d393aea8c4da$var$getVariablesFromFragment(updatableFragment, fragmentReference);
    var id = fragmentReference[$49f0d393aea8c4da$var$ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && $q03Nf(false);
    return {
        updatableData: $49f0d393aea8c4da$var$createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: $49f0d393aea8c4da$var$readUpdatableFragment
};

});

parcelRegister("e48nX", function(module, exports) {
'use strict';

var $befAO = parcelRequire("befAO");

var $a3d7f1946d510cc9$var$getUpdatableQuery = $befAO.getUpdatableQuery;

var $cquBl = parcelRequire("cquBl");

var $a3d7f1946d510cc9$var$createUpdatableProxy = $cquBl.createUpdatableProxy;
function $a3d7f1946d510cc9$var$readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = $a3d7f1946d510cc9$var$getUpdatableQuery(query);
    return {
        updatableData: $a3d7f1946d510cc9$var$createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: $a3d7f1946d510cc9$var$readUpdatableQuery
};

});

parcelRegister("2Geq3", function(module, exports) {
'use strict';

var $fub1S = parcelRequire("fub1S");

var $1f3ab05ef620f45c$var$generateClientID = $fub1S.generateClientID;

var $jZOVE = parcelRequire("jZOVE");

var $1f3ab05ef620f45c$var$getStableStorageKey = $jZOVE.getStableStorageKey;

var $q03Nf = parcelRequire("q03Nf");

var $1f3ab05ef620f45c$var$RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && $q03Nf(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = $1f3ab05ef620f45c$var$getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args) {
        !$1f3ab05ef620f45c$var$isValidLeafValue(value) && $q03Nf(false);
        return this.setValue__UNSAFE(value, name, args);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args) {
        var storageKey = $1f3ab05ef620f45c$var$getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = $1f3ab05ef620f45c$var$getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && $q03Nf(false);
        var storageKey = $1f3ab05ef620f45c$var$getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = $1f3ab05ef620f45c$var$getStableStorageKey(name, args);
            var clientID = $1f3ab05ef620f45c$var$generateClientID(this.getDataID(), storageKey);
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = $1f3ab05ef620f45c$var$getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && $q03Nf(false);
        var storageKey = $1f3ab05ef620f45c$var$getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function $1f3ab05ef620f45c$var$isValidLeafValue(value) {
    return value == null || typeof value !== 'object' || Array.isArray(value) && value.every($1f3ab05ef620f45c$var$isValidLeafValue);
}
module.exports = $1f3ab05ef620f45c$var$RelayRecordProxy;

});

parcelRegister("befAO", function(module, exports) {
'use strict';

var $ceyF6 = parcelRequire("ceyF6");


var $q03Nf = parcelRequire("q03Nf");

parcelRequire("eEWwZ");

function $82cd18ea52d4c4dc$var$graphql(strings) {
    $q03Nf(false);
}
function $82cd18ea52d4c4dc$var$getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === 'function') node = node();
    else if (node["default"]) node = node["default"];
    return node;
}
function $82cd18ea52d4c4dc$var$isFragment(node) {
    var fragment = $82cd18ea52d4c4dc$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $ceyF6.FRAGMENT;
}
function $82cd18ea52d4c4dc$var$isRequest(node) {
    var request = $82cd18ea52d4c4dc$var$getNode(node);
    return typeof request === 'object' && request !== null && request.kind === $ceyF6.REQUEST;
}
function $82cd18ea52d4c4dc$var$isUpdatableQuery(node) {
    var updatableQuery = $82cd18ea52d4c4dc$var$getNode(node);
    return typeof updatableQuery === 'object' && updatableQuery !== null && updatableQuery.kind === $ceyF6.UPDATABLE_QUERY;
}
function $82cd18ea52d4c4dc$var$isInlineDataFragment(node) {
    var fragment = $82cd18ea52d4c4dc$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $ceyF6.INLINE_DATA_FRAGMENT;
}
function $82cd18ea52d4c4dc$var$getFragment(taggedNode) {
    var fragment = $82cd18ea52d4c4dc$var$getNode(taggedNode);
    !$82cd18ea52d4c4dc$var$isFragment(fragment) && $q03Nf(false);
    return fragment;
}
function $82cd18ea52d4c4dc$var$getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = $82cd18ea52d4c4dc$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== 'object' || connection === null || typeof connection !== 'object') return null;
    return fragment;
}
function $82cd18ea52d4c4dc$var$getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = $82cd18ea52d4c4dc$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== 'object') return null;
    return fragment;
}
function $82cd18ea52d4c4dc$var$getRequest(taggedNode) {
    var request = $82cd18ea52d4c4dc$var$getNode(taggedNode);
    !$82cd18ea52d4c4dc$var$isRequest(request) && $q03Nf(false);
    return request;
}
function $82cd18ea52d4c4dc$var$getUpdatableQuery(taggedNode) {
    var updatableQuery = $82cd18ea52d4c4dc$var$getNode(taggedNode);
    !$82cd18ea52d4c4dc$var$isUpdatableQuery(updatableQuery) && $q03Nf(false);
    return updatableQuery;
}
function $82cd18ea52d4c4dc$var$getInlineDataFragment(taggedNode) {
    var fragment = $82cd18ea52d4c4dc$var$getNode(taggedNode);
    !$82cd18ea52d4c4dc$var$isInlineDataFragment(fragment) && $q03Nf(false);
    return fragment;
}
module.exports = {
    getFragment: $82cd18ea52d4c4dc$var$getFragment,
    getNode: $82cd18ea52d4c4dc$var$getNode,
    getPaginationFragment: $82cd18ea52d4c4dc$var$getPaginationFragment,
    getRefetchableFragment: $82cd18ea52d4c4dc$var$getRefetchableFragment,
    getRequest: $82cd18ea52d4c4dc$var$getRequest,
    getUpdatableQuery: $82cd18ea52d4c4dc$var$getUpdatableQuery,
    getInlineDataFragment: $82cd18ea52d4c4dc$var$getInlineDataFragment,
    graphql: $82cd18ea52d4c4dc$var$graphql,
    isFragment: $82cd18ea52d4c4dc$var$isFragment,
    isRequest: $82cd18ea52d4c4dc$var$isRequest,
    isUpdatableQuery: $82cd18ea52d4c4dc$var$isUpdatableQuery,
    isInlineDataFragment: $82cd18ea52d4c4dc$var$isInlineDataFragment
};

});

parcelRegister("9F3aL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $4XvZj = parcelRequire("4XvZj");

const $708a6767ff795a89$var$MAX_DELTAS_SORT_DEPTH = 2;
function $708a6767ff795a89$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $4XvZj._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $708a6767ff795a89$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $708a6767ff795a89$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $4XvZj._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $708a6767ff795a89$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $708a6767ff795a89$var$_resolveDeltasResponse;
function $708a6767ff795a89$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $708a6767ff795a89$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $708a6767ff795a89$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $708a6767ff795a89$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $708a6767ff795a89$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $708a6767ff795a89$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});

parcelRegister("cFL8p", function(module, exports) {

var $atlLe = parcelRequire("atlLe");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $939de05a02189419$var$hashClear() {
    this.__data__ = $atlLe ? $atlLe(null) : {};
    this.size = 0;
}
module.exports = $939de05a02189419$var$hashClear;

});

parcelRegister("bUdvl", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8aaf665f5d376558$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $8aaf665f5d376558$var$hashDelete;

});

parcelRegister("frFLQ", function(module, exports) {

var $atlLe = parcelRequire("atlLe");

/** Used to stand-in for `undefined` hash values. */ var $b3e9c766d6e03c03$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $b3e9c766d6e03c03$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b3e9c766d6e03c03$var$hasOwnProperty = $b3e9c766d6e03c03$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b3e9c766d6e03c03$var$hashGet(key) {
    var data = this.__data__;
    if ($atlLe) {
        var result = data[key];
        return result === $b3e9c766d6e03c03$var$HASH_UNDEFINED ? undefined : result;
    }
    return $b3e9c766d6e03c03$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $b3e9c766d6e03c03$var$hashGet;

});

parcelRegister("1DJfC", function(module, exports) {

var $atlLe = parcelRequire("atlLe");

/** Used for built-in method references. */ var $131c88d9e2c69f28$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $131c88d9e2c69f28$var$hasOwnProperty = $131c88d9e2c69f28$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $131c88d9e2c69f28$var$hashHas(key) {
    var data = this.__data__;
    return $atlLe ? data[key] !== undefined : $131c88d9e2c69f28$var$hasOwnProperty.call(data, key);
}
module.exports = $131c88d9e2c69f28$var$hashHas;

});

parcelRegister("gB1dC", function(module, exports) {

var $atlLe = parcelRequire("atlLe");

/** Used to stand-in for `undefined` hash values. */ var $c1510c0e83cab750$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $c1510c0e83cab750$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $atlLe && value === undefined ? $c1510c0e83cab750$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $c1510c0e83cab750$var$hashSet;

});

parcelRegister("bnEma", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $849125a86c80cd9c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $849125a86c80cd9c$var$listCacheClear;

});

parcelRegister("iVowk", function(module, exports) {

var $977e2 = parcelRequire("977e2");

/** Used for built-in method references. */ var $dc70921f9b744379$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $dc70921f9b744379$var$splice = $dc70921f9b744379$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $dc70921f9b744379$var$listCacheDelete(key) {
    var data = this.__data__, index = $977e2(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $dc70921f9b744379$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $dc70921f9b744379$var$listCacheDelete;

});

parcelRegister("2PnXJ", function(module, exports) {

var $977e2 = parcelRequire("977e2");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $20f2ee9a26274204$var$listCacheGet(key) {
    var data = this.__data__, index = $977e2(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $20f2ee9a26274204$var$listCacheGet;

});

parcelRegister("d3Lhu", function(module, exports) {

var $977e2 = parcelRequire("977e2");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $98203b35c372b5cd$var$listCacheHas(key) {
    return $977e2(this.__data__, key) > -1;
}
module.exports = $98203b35c372b5cd$var$listCacheHas;

});

parcelRegister("bnKrz", function(module, exports) {

var $977e2 = parcelRequire("977e2");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $8495de718d4d14e6$var$listCacheSet(key, value) {
    var data = this.__data__, index = $977e2(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $8495de718d4d14e6$var$listCacheSet;

});

parcelRegister("3Qi0V", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $2cc4339d23dd72fd$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $2cc4339d23dd72fd$var$isKeyable;

});

parcelRegister("jCOpB", function(module, exports) {

var $c2Pwh = parcelRequire("c2Pwh");

/** Used to detect overreaching core-js shims. */ var $e498abac2dc082b7$var$coreJsData = $c2Pwh["__core-js_shared__"];
module.exports = $e498abac2dc082b7$var$coreJsData;

});

parcelRegister("cSfeu", function(module, exports) {
// @generated from regex-gen.ts
var $95f6581222d3eded$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $95f6581222d3eded$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;
module.exports["SPACE_SEPARATOR_REGEX"] = $95f6581222d3eded$export$523451f94304dd6c;

});

parcelRegister("isEVw", function(module, exports) {

var $k0Vfo = parcelRequire("k0Vfo");

function $d70a96b8c727f52c$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $d70a96b8c727f52c$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $d70a96b8c727f52c$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $k0Vfo.timeData)[regionTag || ''] || (0, $k0Vfo.timeData)[languageTag || ''] || (0, $k0Vfo.timeData)["".concat(languageTag, "-001")] || (0, $k0Vfo.timeData)['001'];
    return hourCycles[0];
}
module.exports["getBestPattern"] = $d70a96b8c727f52c$export$29c5368be8904d27;

});

parcelRegister("e6oz7", function(module, exports) {








var $a444ae641951b794$var$modeModules = {
    ECB: (parcelRequire("4YL5h")),
    CBC: (parcelRequire("l92H7")),
    CFB: (parcelRequire("iTSsV")),
    CFB8: (parcelRequire("sGGPC")),
    CFB1: (parcelRequire("eqJyk")),
    OFB: (parcelRequire("dITno")),
    CTR: (parcelRequire("8ERF1")),
    GCM: (parcelRequire("8ERF1"))
};

var $fcAZM = parcelRequire("fcAZM");

for(var $a444ae641951b794$var$key in $fcAZM)$fcAZM[$a444ae641951b794$var$key].module = $a444ae641951b794$var$modeModules[$fcAZM[$a444ae641951b794$var$key].mode];
module.exports = $fcAZM;

});

parcelRegister("j1r2v", function(module, exports) {

var $b4qBY = parcelRequire("b4qBY");


var $eI8vp = parcelRequire("eI8vp");

var $dd9315c29549edde$require$Buffer = $eI8vp.Buffer;

var $3xrS3 = parcelRequire("3xrS3");


var $dMzRp = parcelRequire("dMzRp");


var $7z9nz = parcelRequire("7z9nz");


var $479P8 = parcelRequire("479P8");


var $1VL9i = parcelRequire("1VL9i");

function $dd9315c29549edde$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $dd9315c29549edde$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $dd9315c29549edde$require$Buffer.concat([
            iv,
            $dd9315c29549edde$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $dd9315c29549edde$require$Buffer.concat([
            iv,
            $dd9315c29549edde$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $7z9nz(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($dd9315c29549edde$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($dd9315c29549edde$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $dd9315c29549edde$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $dd9315c29549edde$require$Buffer.from(self._finID);
    $1VL9i(out);
    return out;
}
function $dd9315c29549edde$var$StreamCipher(mode, key, iv, decrypt) {
    $3xrS3.call(this);
    var h = $dd9315c29549edde$require$Buffer.alloc(4, 0);
    this._cipher = new $b4qBY.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $7z9nz(ck);
    iv = $dd9315c29549edde$var$calcIv(this, iv, ck);
    this._prev = $dd9315c29549edde$require$Buffer.from(iv);
    this._cache = $dd9315c29549edde$require$Buffer.allocUnsafe(0);
    this._secCache = $dd9315c29549edde$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dMzRp($dd9315c29549edde$var$StreamCipher, $3xrS3);
$dd9315c29549edde$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $dd9315c29549edde$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$dd9315c29549edde$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $479P8(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $dd9315c29549edde$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$dd9315c29549edde$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$dd9315c29549edde$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$dd9315c29549edde$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$dd9315c29549edde$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $dd9315c29549edde$var$StreamCipher;

});

parcelRegister("1TyDJ", function(module, exports) {

var $b4qBY = parcelRequire("b4qBY");


var $eI8vp = parcelRequire("eI8vp");

var $1615cc42cdde093e$require$Buffer = $eI8vp.Buffer;

var $3xrS3 = parcelRequire("3xrS3");


var $dMzRp = parcelRequire("dMzRp");

function $1615cc42cdde093e$var$StreamCipher(mode, key, iv, decrypt) {
    $3xrS3.call(this);
    this._cipher = new $b4qBY.AES(key);
    this._prev = $1615cc42cdde093e$require$Buffer.from(iv);
    this._cache = $1615cc42cdde093e$require$Buffer.allocUnsafe(0);
    this._secCache = $1615cc42cdde093e$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dMzRp($1615cc42cdde093e$var$StreamCipher, $3xrS3);
$1615cc42cdde093e$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$1615cc42cdde093e$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $1615cc42cdde093e$var$StreamCipher;

});

parcelRegister("b4qBY", function(module, exports) {
$parcel$export(module.exports, "AES", () => $80f4b5e9dce8dcb6$export$b80fbe1c3a2b92b5, (v) => $80f4b5e9dce8dcb6$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $80f4b5e9dce8dcb6$export$b80fbe1c3a2b92b5;

var $eI8vp = parcelRequire("eI8vp");

var $80f4b5e9dce8dcb6$require$Buffer = $eI8vp.Buffer;
function $80f4b5e9dce8dcb6$var$asUInt32Array(buf) {
    if (!$80f4b5e9dce8dcb6$require$Buffer.isBuffer(buf)) buf = $80f4b5e9dce8dcb6$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $80f4b5e9dce8dcb6$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $80f4b5e9dce8dcb6$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $80f4b5e9dce8dcb6$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $80f4b5e9dce8dcb6$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $80f4b5e9dce8dcb6$var$AES(key) {
    this._key = $80f4b5e9dce8dcb6$var$asUInt32Array(key);
    this._reset();
}
$80f4b5e9dce8dcb6$var$AES.blockSize = 16;
$80f4b5e9dce8dcb6$var$AES.keySize = 32;
$80f4b5e9dce8dcb6$var$AES.prototype.blockSize = $80f4b5e9dce8dcb6$var$AES.blockSize;
$80f4b5e9dce8dcb6$var$AES.prototype.keySize = $80f4b5e9dce8dcb6$var$AES.keySize;
$80f4b5e9dce8dcb6$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $80f4b5e9dce8dcb6$var$G.SBOX[t >>> 24] << 24 | $80f4b5e9dce8dcb6$var$G.SBOX[t >>> 16 & 0xff] << 16 | $80f4b5e9dce8dcb6$var$G.SBOX[t >>> 8 & 0xff] << 8 | $80f4b5e9dce8dcb6$var$G.SBOX[t & 0xff];
            t ^= $80f4b5e9dce8dcb6$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $80f4b5e9dce8dcb6$var$G.SBOX[t >>> 24] << 24 | $80f4b5e9dce8dcb6$var$G.SBOX[t >>> 16 & 0xff] << 16 | $80f4b5e9dce8dcb6$var$G.SBOX[t >>> 8 & 0xff] << 8 | $80f4b5e9dce8dcb6$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $80f4b5e9dce8dcb6$var$G.INV_SUB_MIX[0][$80f4b5e9dce8dcb6$var$G.SBOX[tt >>> 24]] ^ $80f4b5e9dce8dcb6$var$G.INV_SUB_MIX[1][$80f4b5e9dce8dcb6$var$G.SBOX[tt >>> 16 & 0xff]] ^ $80f4b5e9dce8dcb6$var$G.INV_SUB_MIX[2][$80f4b5e9dce8dcb6$var$G.SBOX[tt >>> 8 & 0xff]] ^ $80f4b5e9dce8dcb6$var$G.INV_SUB_MIX[3][$80f4b5e9dce8dcb6$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$80f4b5e9dce8dcb6$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $80f4b5e9dce8dcb6$var$asUInt32Array(M);
    return $80f4b5e9dce8dcb6$var$cryptBlock(M, this._keySchedule, $80f4b5e9dce8dcb6$var$G.SUB_MIX, $80f4b5e9dce8dcb6$var$G.SBOX, this._nRounds);
};
$80f4b5e9dce8dcb6$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $80f4b5e9dce8dcb6$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$80f4b5e9dce8dcb6$var$AES.prototype.decryptBlock = function(M) {
    M = $80f4b5e9dce8dcb6$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $80f4b5e9dce8dcb6$var$cryptBlock(M, this._invKeySchedule, $80f4b5e9dce8dcb6$var$G.INV_SUB_MIX, $80f4b5e9dce8dcb6$var$G.INV_SBOX, this._nRounds);
    var buf = $80f4b5e9dce8dcb6$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$80f4b5e9dce8dcb6$var$AES.prototype.scrub = function() {
    $80f4b5e9dce8dcb6$var$scrubVec(this._keySchedule);
    $80f4b5e9dce8dcb6$var$scrubVec(this._invKeySchedule);
    $80f4b5e9dce8dcb6$var$scrubVec(this._key);
};
$80f4b5e9dce8dcb6$export$b80fbe1c3a2b92b5 = $80f4b5e9dce8dcb6$var$AES;

});

parcelRegister("ebcOQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a52c09587ecd0385$export$2e2bcd8739ae039);

var $abBQX = parcelRequire("abBQX");


var $cBZBQ = parcelRequire("cBZBQ");


var $bd6jv = parcelRequire("bd6jv");


var $6hOPx = parcelRequire("6hOPx");

function $a52c09587ecd0385$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $abBQX.default)(element);
    var html = (0, $cBZBQ.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $6hOPx.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $bd6jv.default)(element),
        y: y
    };
}

});

parcelRegister("dSq7f", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1a493938a0734ee$export$2e2bcd8739ae039);

var $cBZBQ = parcelRequire("cBZBQ");


var $1idVR = parcelRequire("1idVR");


var $bd6jv = parcelRequire("bd6jv");


var $dWWac = parcelRequire("dWWac");


var $fEu2C = parcelRequire("fEu2C");

function $a1a493938a0734ee$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $cBZBQ.default)(element);
    var winScroll = (0, $dWWac.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $fEu2C.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $fEu2C.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $bd6jv.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $1idVR.default)(body || html).direction === 'rtl') x += (0, $fEu2C.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("7bTYu", function(module, exports) {
$parcel$export(module.exports, "default", () => $53c4fae1d5689437$export$2e2bcd8739ae039);

var $kXrr0 = parcelRequire("kXrr0");

function $53c4fae1d5689437$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $kXrr0.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("gLRTP", function(module, exports) {
$parcel$export(module.exports, "default", () => $c35ad86b9c36ff63$export$2e2bcd8739ae039);

function $c35ad86b9c36ff63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("fd6rO", function(module, exports) {
$parcel$export(module.exports, "default", () => $b12d1243245849ec$export$2e2bcd8739ae039);
function $b12d1243245849ec$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("7ONHI", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b13c21a38289f89$export$2e2bcd8739ae039);
function $5b13c21a38289f89$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});

parcelRegister("lFhaR", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc5abfc1510987ae$export$2e2bcd8739ae039);
function $fc5abfc1510987ae$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});

parcelRegister("lpdFp", function(module, exports) {

var $cdwZR = parcelRequire("cdwZR");

var $f95688bc16dd4c46$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $cdwZR.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $f95688bc16dd4c46$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $cdwZR.isRadioElement)(node) && node.name) return $f95688bc16dd4c46$var$findSelectedRadio(node, nodes);
    return node;
};
var $f95688bc16dd4c46$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($f95688bc16dd4c46$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};
module.exports["correctNode"] = $f95688bc16dd4c46$export$5261662167ad7ced;
module.exports["correctNodes"] = $f95688bc16dd4c46$export$4a5a72a7124e45f9;

});

parcelRegister("1GFh6", function(module, exports) {

var $lpdFp = parcelRequire("lpdFp");

var $13a9bafd61802223$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $lpdFp.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $13a9bafd61802223$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $lpdFp.correctNode)(node, nodes));
};
module.exports["pickFirstFocus"] = $13a9bafd61802223$export$f4e86cfa0679b9cc;
module.exports["pickFocusable"] = $13a9bafd61802223$export$e06728ee87c96122;

});

parcelRegister("jzO5W", function(module, exports) {

var $1iOCV = parcelRequire("1iOCV");


var $e880Z = parcelRequire("e880Z");


var $2NDLX = parcelRequire("2NDLX");


var $beiUR = parcelRequire("beiUR");

function $7c20fd3bac90876e$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $e880Z.isSafari)()) return (0, $2NDLX.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 * (foreign element)
	 */ if ((0, $1iOCV.isFirefox)()) return (0, $beiUR.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is `null` *(standard check)*
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}
module.exports["isLeavingWindow"] = $7c20fd3bac90876e$export$57d220c74e84a273;

});

parcelRegister("btsNM", function(module, exports) {
function $f6ca35f3a0236545$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}
module.exports["getInput"] = $f6ca35f3a0236545$export$7c112ceec8941e67;

});

parcelRegister("iMQqx", function(module, exports) {

var $2P8Ax = parcelRequire("2P8Ax");

const $efd469c0d961735f$var$scheduleOnDrag = (0, $2P8Ax.default)((fn)=>fn());
const $efd469c0d961735f$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $efd469c0d961735f$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $efd469c0d961735f$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $efd469c0d961735f$var$dragStart.flush();
            $efd469c0d961735f$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $efd469c0d961735f$var$scheduleOnDrag(()=>{
                $efd469c0d961735f$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $efd469c0d961735f$var$dragStart.flush();
            $efd469c0d961735f$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}
module.exports["makeDispatch"] = $efd469c0d961735f$export$9f13ecc44e83d682;

});

parcelRegister("gz7GF", function(module, exports) {
function $f6f79f7ab00b23b4$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}
module.exports["addAttribute"] = $f6f79f7ab00b23b4$export$5dcb5c23b6ba980a;

});

parcelRegister("ah22M", function(module, exports) {

var $ibUOq = parcelRequire("ibUOq");

/** Built-in value references. */ var $77ad13c5ac29bc28$var$Symbol = (0, $ibUOq.default).Symbol;
var $77ad13c5ac29bc28$export$2e2bcd8739ae039 = $77ad13c5ac29bc28$var$Symbol;
module.exports["default"] = $77ad13c5ac29bc28$export$2e2bcd8739ae039;

});

parcelRegister("avOqW", function(module, exports) {

var $ah22M = parcelRequire("ah22M");

/** Used for built-in method references. */ var $7a73ebb3a28c3aeb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7a73ebb3a28c3aeb$var$hasOwnProperty = $7a73ebb3a28c3aeb$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7a73ebb3a28c3aeb$var$nativeObjectToString = $7a73ebb3a28c3aeb$var$objectProto.toString;
/** Built-in value references. */ var $7a73ebb3a28c3aeb$var$symToStringTag = (0, $ah22M.default) ? (0, $ah22M.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $7a73ebb3a28c3aeb$var$getRawTag(value) {
    var isOwn = $7a73ebb3a28c3aeb$var$hasOwnProperty.call(value, $7a73ebb3a28c3aeb$var$symToStringTag), tag = value[$7a73ebb3a28c3aeb$var$symToStringTag];
    try {
        value[$7a73ebb3a28c3aeb$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $7a73ebb3a28c3aeb$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$7a73ebb3a28c3aeb$var$symToStringTag] = tag;
        else delete value[$7a73ebb3a28c3aeb$var$symToStringTag];
    }
    return result;
}
var $7a73ebb3a28c3aeb$export$2e2bcd8739ae039 = $7a73ebb3a28c3aeb$var$getRawTag;
module.exports["default"] = $7a73ebb3a28c3aeb$export$2e2bcd8739ae039;

});

parcelRegister("8ESDP", function(module, exports) {
/** Used for built-in method references. */ var $64dc71cb594e4355$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $64dc71cb594e4355$var$nativeObjectToString = $64dc71cb594e4355$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $64dc71cb594e4355$var$objectToString(value) {
    return $64dc71cb594e4355$var$nativeObjectToString.call(value);
}
var $64dc71cb594e4355$export$2e2bcd8739ae039 = $64dc71cb594e4355$var$objectToString;
module.exports["default"] = $64dc71cb594e4355$export$2e2bcd8739ae039;

});

parcelRegister("1GNVc", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $13b07013b9cc4e48$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $13b07013b9cc4e48$export$2e2bcd8739ae039 = $13b07013b9cc4e48$var$overArg;
module.exports["default"] = $13b07013b9cc4e48$export$2e2bcd8739ae039;

});

parcelRegister("8HmnL", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $6X8o4 = parcelRequire("6X8o4");

class $7460d2a0255ec893$export$8f7a8a727d75d90e {
    serialize(value) {
        if (Array.isArray(value)) return `[${value.map(this.serialize, this).join(',')}]`;
        else if (typeof value === 'object') {
            const serializedObject = Object.entries(value ?? {}).filter((entry)=>entry[1] !== undefined).sort((a, b)=>a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0).map(([key, child])=>`${key}:${this.serialize(child)}`).join(',');
            return `{${serializedObject}}`;
        } else return String(value);
    }
    toHashKey({ name: name, variables: variables }) {
        const serializedVariables = this.serialize(variables ?? {});
        return `${name}:${serializedVariables}`;
    }
    load(key, loader, { refetchIfNotClaimed: refetchIfNotClaimed = true } = {}, saveToStore = true) {
        const hash = this.toHashKey(key);
        // Ignore the request if there is a pending request with the exact same query name and variables.
        if (!this.store[hash] || refetchIfNotClaimed && (0, $6X8o4.isResolved)(this.store[hash])) {
            if (saveToStore) this.store[hash] = (0, $6X8o4.liftPromiseState)(loader());
        }
        return this.store[hash];
    }
    claim(key, dataAccessor) {
        const hash = this.toHashKey(key);
        const result = this.store[hash];
        return result ? (()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            return result.catch(()=>{
                delete this.store[hash];
                return null;
            }).then((result)=>{
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
                // Cypress uses Electron 61 which doesn't support finally
                delete this.store[hash];
                // Custom implementation for accessing preloaded data
                if (dataAccessor) return dataAccessor(result);
                // Ignore the preloaded data if there is no valid data field
                return result && result.data ? result : null;
            });
        })() : Promise.resolve(null);
    }
    constructor(store = {}){
        this.store = void 0;
        this.store = store;
    }
}
let $7460d2a0255ec893$var$preloadResult = null;
function $7460d2a0255ec893$export$2e8e3f1fde57bbfe() {
    if ($7460d2a0255ec893$var$preloadResult === null) {
        // Save data to a global variable so they can be shared between bundles.
        if (!window.QUERY_PRELOADER_RESULTS) window.QUERY_PRELOADER_RESULTS = {};
        $7460d2a0255ec893$var$preloadResult = new $7460d2a0255ec893$export$8f7a8a727d75d90e(window.QUERY_PRELOADER_RESULTS);
    }
    return $7460d2a0255ec893$var$preloadResult;
}
module.exports["getPreloadResult"] = $7460d2a0255ec893$export$2e8e3f1fde57bbfe;

});

parcelRegister("cquBl", function(module, exports) {
'use strict';

var $eGvGZ = parcelRequire("eGvGZ");

var $90bfa68990a7df63$var$_interopRequireDefault = $eGvGZ.default;

var $90bfa68990a7df63$var$_createForOfIteratorHelper2 = $90bfa68990a7df63$var$_interopRequireDefault((parcelRequire("5YwI0")));

var $jZOVE = parcelRequire("jZOVE");

var $90bfa68990a7df63$var$getArgumentValues = $jZOVE.getArgumentValues;

var $ceyF6 = parcelRequire("ceyF6");

var $90bfa68990a7df63$var$ACTOR_CHANGE = $ceyF6.ACTOR_CHANGE, $90bfa68990a7df63$var$ALIASED_FRAGMENT_SPREAD = $ceyF6.ALIASED_FRAGMENT_SPREAD, $90bfa68990a7df63$var$ALIASED_INLINE_FRAGMENT_SPREAD = $ceyF6.ALIASED_INLINE_FRAGMENT_SPREAD, $90bfa68990a7df63$var$CATCH_FIELD = $ceyF6.CATCH_FIELD, $90bfa68990a7df63$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $ceyF6.CLIENT_EDGE_TO_CLIENT_OBJECT, $90bfa68990a7df63$var$CLIENT_EDGE_TO_SERVER_OBJECT = $ceyF6.CLIENT_EDGE_TO_SERVER_OBJECT, $90bfa68990a7df63$var$CLIENT_EXTENSION = $ceyF6.CLIENT_EXTENSION, $90bfa68990a7df63$var$CONDITION = $ceyF6.CONDITION, $90bfa68990a7df63$var$DEFER = $ceyF6.DEFER, $90bfa68990a7df63$var$FRAGMENT_SPREAD = $ceyF6.FRAGMENT_SPREAD, $90bfa68990a7df63$var$INLINE_DATA_FRAGMENT_SPREAD = $ceyF6.INLINE_DATA_FRAGMENT_SPREAD, $90bfa68990a7df63$var$INLINE_FRAGMENT = $ceyF6.INLINE_FRAGMENT, $90bfa68990a7df63$var$LINKED_FIELD = $ceyF6.LINKED_FIELD, $90bfa68990a7df63$var$MODULE_IMPORT = $ceyF6.MODULE_IMPORT, $90bfa68990a7df63$var$RELAY_LIVE_RESOLVER = $ceyF6.RELAY_LIVE_RESOLVER, $90bfa68990a7df63$var$RELAY_RESOLVER = $ceyF6.RELAY_RESOLVER, $90bfa68990a7df63$var$REQUIRED_FIELD = $ceyF6.REQUIRED_FIELD, $90bfa68990a7df63$var$SCALAR_FIELD = $ceyF6.SCALAR_FIELD, $90bfa68990a7df63$var$STREAM = $ceyF6.STREAM;
var $90bfa68990a7df63$var$nonUpdatableKeys = [
    'id',
    '__id',
    '__typename',
    'js'
];
function $90bfa68990a7df63$var$createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    $90bfa68990a7df63$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    return mutableUpdatableProxy;
}
function $90bfa68990a7df63$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, $90bfa68990a7df63$var$_createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case $90bfa68990a7df63$var$LINKED_FIELD:
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: $90bfa68990a7df63$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $90bfa68990a7df63$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: $90bfa68990a7df63$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $90bfa68990a7df63$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case $90bfa68990a7df63$var$SCALAR_FIELD:
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = $90bfa68990a7df63$var$getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = $90bfa68990a7df63$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: $90bfa68990a7df63$var$nonUpdatableKeys.includes(selection.name) ? undefined : function(newValue) {
                            var _selection$args2;
                            var newVariables = $90bfa68990a7df63$var$getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case $90bfa68990a7df63$var$INLINE_FRAGMENT:
                    if (updatableProxyRootRecord.getType() === selection.type) $90bfa68990a7df63$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case $90bfa68990a7df63$var$CLIENT_EXTENSION:
                    $90bfa68990a7df63$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case $90bfa68990a7df63$var$FRAGMENT_SPREAD:
                    break;
                case $90bfa68990a7df63$var$CONDITION:
                case $90bfa68990a7df63$var$ACTOR_CHANGE:
                case $90bfa68990a7df63$var$ALIASED_FRAGMENT_SPREAD:
                case $90bfa68990a7df63$var$INLINE_DATA_FRAGMENT_SPREAD:
                case $90bfa68990a7df63$var$ALIASED_INLINE_FRAGMENT_SPREAD:
                case $90bfa68990a7df63$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                case $90bfa68990a7df63$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                case $90bfa68990a7df63$var$DEFER:
                case $90bfa68990a7df63$var$MODULE_IMPORT:
                case $90bfa68990a7df63$var$RELAY_LIVE_RESOLVER:
                case $90bfa68990a7df63$var$REQUIRED_FIELD:
                case $90bfa68990a7df63$var$CATCH_FIELD:
                case $90bfa68990a7df63$var$STREAM:
                case $90bfa68990a7df63$var$RELAY_RESOLVER:
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
                default:
                    selection.kind;
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $90bfa68990a7df63$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = $90bfa68990a7df63$var$getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error('Do not assign null to plural linked fields; assign an empty array instead.');
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error('When assigning an array of items, none of the items should be null or undefined.');
                var __id = item.__id;
                if (__id == null) throw new Error('The __id field must be present on each item passed to the setter. This indicates a bug in Relay.');
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function $90bfa68990a7df63$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = $90bfa68990a7df63$var$getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error('The __id field must be present on the argument. This indicates a bug in Relay.');
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function $90bfa68990a7df63$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = $90bfa68990a7df63$var$getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = $90bfa68990a7df63$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                $90bfa68990a7df63$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                return updatableProxy;
            } else return linkedRecord;
        });
        else return linkedRecords;
    };
}
function $90bfa68990a7df63$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = $90bfa68990a7df63$var$getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = $90bfa68990a7df63$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            $90bfa68990a7df63$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            return updatableProxy;
        } else return linkedRecord;
    };
}
function $90bfa68990a7df63$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, $90bfa68990a7df63$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === 'linked') {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $90bfa68990a7df63$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, $90bfa68990a7df63$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === 'pluralLinked') {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $90bfa68990a7df63$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, $90bfa68990a7df63$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === 'scalar') {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: $90bfa68990a7df63$var$createUpdatableProxy
};

});

parcelRegister("atlLe", function(module, exports) {

var $k1Lsb = parcelRequire("k1Lsb");

/* Built-in method references that are verified to be native. */ var $79fd7e1460e8a874$var$nativeCreate = $k1Lsb(Object, 'create');
module.exports = $79fd7e1460e8a874$var$nativeCreate;

});

parcelRegister("977e2", function(module, exports) {

var $ERH8u = parcelRequire("ERH8u");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6a2a5f4c09387328$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($ERH8u(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $6a2a5f4c09387328$var$assocIndexOf;

});

parcelRegister("k0Vfo", function(module, exports) {
// @generated from time-data-gen.ts
// prettier-ignore  
var $e92036df5e90d876$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};
module.exports["timeData"] = $e92036df5e90d876$export$a8c9209db4084317;

});

parcelRegister("7z9nz", function(module, exports) {

var $eI8vp = parcelRequire("eI8vp");

var $582313cdf517a674$require$Buffer = $eI8vp.Buffer;
var $582313cdf517a674$var$ZEROES = $582313cdf517a674$require$Buffer.alloc(16, 0);
function $582313cdf517a674$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $582313cdf517a674$var$fromArray(out) {
    var buf = $582313cdf517a674$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $582313cdf517a674$var$GHASH(key) {
    this.h = key;
    this.state = $582313cdf517a674$require$Buffer.alloc(16, 0);
    this.cache = $582313cdf517a674$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$582313cdf517a674$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$582313cdf517a674$var$GHASH.prototype._multiply = function() {
    var Vi = $582313cdf517a674$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $582313cdf517a674$var$fromArray(Zi);
};
$582313cdf517a674$var$GHASH.prototype.update = function(buf) {
    this.cache = $582313cdf517a674$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$582313cdf517a674$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($582313cdf517a674$require$Buffer.concat([
        this.cache,
        $582313cdf517a674$var$ZEROES
    ], 16));
    this.ghash($582313cdf517a674$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $582313cdf517a674$var$GHASH;

});

parcelRegister("ibUOq", function(module, exports) {

var $fG9YV = parcelRequire("fG9YV");

/** Detect free variable `self`. */ var $d3e552d502fae3c3$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $d3e552d502fae3c3$var$root = (0, $fG9YV.default) || $d3e552d502fae3c3$var$freeSelf || Function('return this')();
var $d3e552d502fae3c3$export$2e2bcd8739ae039 = $d3e552d502fae3c3$var$root;
module.exports["default"] = $d3e552d502fae3c3$export$2e2bcd8739ae039;

});

parcelRegister("fG9YV", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $b6a2856403f76d4e$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $b6a2856403f76d4e$export$2e2bcd8739ae039 = $b6a2856403f76d4e$var$freeGlobal;
module.exports["default"] = $b6a2856403f76d4e$export$2e2bcd8739ae039;

});


$parcel$global.rlb("4O7in")
//# sourceMappingURL=dashboard-spa-container-jquery3.d08670cd.js.map
